import { $ as getMapForWordSeparators, $a as ok, $n as CompletionItemInsertTextRule, $t as runWhenGlobalIdle, A as findLast, Aa as cloneAndChange, Ai as CancellationToken, An as isEmojiImprecise, Ar as ScrollType, At as matchesScheme, B as TextModelSearch, Ba as isFunction, Bi as EventBufferer, Bn as prevCharLength, Br as WrappingIndent, Bt as TaskQueue$1, Ci as resolve$1, Cn as getCharContainingOffset, Co as distinct, Cr as NewSymbolNameTriggerKind, Ct as writeUInt16LE, Da as getNLSMessages, Di as KeyChord, Dn as htmlAttributeEncodeValue, Dr as PositionAffinity, Dt as FileAccess, E as LineRangeSet, Ea as getNLSLanguage, Ei as IMMUTABLE_CODE_TO_KEY_CODE, En as getNextCodePoint, Eo as groupAdjacentBy, Er as PartialAcceptTriggerKind, Et as COI, F as OffsetRangeSet, Fa as assertReturnsDefined, Fi as ensureValidWordDefinition, Fn as isLowerAsciiLetter, Fr as SymbolTag, Ft as Delayer, G as GlyphMarginLane, Ga as isUndefined, Gi as createEventDeliveryQueue, Gn as startsWithIgnoreCase, Gr as EncodedTokenizationResult, Gt as createCancelablePromise, H as isValidMatch, Ha as isNumber$1, Hi as MicrotaskEmitter, Hn as rtrim$1, Ho as tieBreakComparators, Ht as TimeoutTimer, I as MovedText, Ia as assertType, Ii as getWordAtText, In as isUpperAsciiLetter, Io as range, Ir as TextDirection$1, It as GlobalIdleValue, J as TextDirection, Ja as validateConstraints, Ji as LinkedList, Jn as Lazy, Jt as isThenable$1, K as InjectedTextCursorStops, Ka as isUndefinedOrNull, Ki as StopWatch, Kn as startsWithUTF8BOM, Kr as FoldingRangeKind, Kt as disposableTimeout, Li as DebounceEmitter, Ln as lastNonWhitespaceIndex, Lo as removeFastWithoutKeepingOrder, Lr as TextEditorCursorBlinkingStyle, Lt as IntervalTimer, M as findMaxIdx, Ma as deepFreeze, Mi as cancelOnDispose, Mn as isFullWidthCharacter, Mo as pushMany, Mr as ShowLightbulbIconMode$1, Mt as AbstractIdleValue, Na as equals$2, Ni as DEFAULT_WORD_REGEXP, Nn as isHighSurrogate, No as pushToEnd, Nr as SignatureHelpTriggerKind, O as findFirstMax, Oa as localize, Oi as KeyCodeUtils, On as isAsciiDigit, Oo as isFalsyOrEmpty, Or as RenderLineNumbersType, Ot as RemoteAuthorities, P as OffsetRange, Pi as USUAL_WORD_SEPARATORS, Pn as isLowSurrogate, Po as pushToStart, Pr as SymbolKind, Pt as DeferredPromise, Q as shouldSynchronizeModel, Qi as MutableDisposable, Qn as CodeActionTriggerType, Qr as LazyTokenizationSupport, Qt as rejectIfNotCanceled, R as SearchParams, Ra as isBoolean, Ri as Emitter$1, Rn as ltrim, Rr as TextEditorCursorStyle$1, Rt as Promises, S as PositionOffsetTransformer, Sa as isWindows, Si as relative, Sn as format, Sr as NewSymbolNameTag, St as readUInt8, T as LineRange, Ta as setTimeout0, Ti as EVENT_KEY_CODE_MAP, Tn as getLeftDeleteOffset, To as forEachAdjacent, Tr as OverviewRulerLane$1, Tt as writeUInt8, U as ApplyEditsResult, Ua as isObject, Ui as PauseableEmitter, Un as singleLetterHash, Ut as _runWhenIdle, V as createFindMatch, Va as isIterable, Vi as EventMultiplexer, Vn as regExpLeadsToEndlessLoop, Vo as tail, Vt as ThrottledDelayer, W as FindMatch, Wa as isString$1, Wi as Relay, Wn as splitLines, X as ValidAnnotatedEditOperation, Xa as assertFn, Xi as DisposableMap, Xn as createMonacoBaseAPI, Y as TextModelResolvedOptions, Ya as assert, Yi as Disposable, Yn as CachedFunction, Z as isITextSnapshot, Za as assertNever, Zi as DisposableStore, Zn as AccessibilitySupport, _a as isMacintosh, _i as basename$1, _n as equals$3, _o as binarySearch2, _r as InlineCompletionHintStyle, _t as doHash, a as WorkerTextModelSyncClient, aa as toDisposable, ai as Token$2, an as commonPrefixLength, ao as illegalArgument, ar as DefaultEndOfLine, b as AbstractText, ba as isSafari$1, bi as normalize$1, bn as escapeRegExpCharacters, bo as coalesceInPlace, br as MinimapSectionHeaderStyle, bt as readUInt16LE, ca as OS, cn as compareIgnoreCase, co as onBugIndicatingError, cr as EditorOption, ct as logOnceWebWorkerWarning, d as StringEdit, da as isChromeOS, di as getCodiconFontCharacters, dn as containsRTL, do as ArrayQueue, dr as GlyphMarginLane$1, dt as NKeyMap, ea as ReferenceCollection, en as timeout, eo as softAssert, er as CompletionItemKind, et as safeIntl, f as StringReplacement, fa as isEdge, fi as Selection$1, fn as containsUnusualLineTerminators, fo as CallbackIterable, fr as HoverVerbosityAction, ft as ResourceMap, g as RangeMapping, ga as isLittleEndian, gi as uriToFsPath, gn as endsWithIgnoreCase, go as binarySearch, gr as InlineCompletionEndOfLifeReasonKind, gt as StringSHA1, h as LineRangeMapping, ha as isLinux, hi as URI, hn as createRegExp, ho as asArray, hr as InlayHintKind, i as EditorWorker, ia as markAsSingleton, ii as SymbolKinds, in as UNUSUAL_LINE_TERMINATORS, io as canceled, ir as CursorChangeReason, it as LcsDiff, j as findLastMax, ja as deepClone, ji as CancellationTokenSource$1, jn as isFalsyOrWhitespace, jo as numberComparator, jr as ScrollbarVisibility, jt as matchesSomeScheme, k as findFirstMin, ka as localize2, ki as isModifierKey, kn as isBasicASCII, ko as isNonEmptyArray, kr as RenderMinimap, kt as Schemas, l as RGBA, la as isAndroid$1, ln as compareSubstring, lo as onUnexpectedError, lr as EndOfLinePreference, lt as BidirectionalMap, m as DetailedLineRangeMapping, ma as isIOS, mi as Position$1, mn as convertSimple2RegExpPattern, mo as arrayInsert, mr as InjectedTextCursorStops$1, mt as SetMap, na as dispose, ni as SelectedSuggestionInfo, nn as GraphemeIterator, no as CancellationError, nr as CompletionTriggerKind, o as ConstantTimePrefixSumComputer, oa as Iterable, oi as TokenizationRegistry, on as commonSuffixLength, oo as illegalState, or as DocumentHighlightKind, ot as WebWorkerClient, pa as isFirefox$1, pi as Range$2, pr as IndentAction$1, pt as ResourceSet, q as OverviewRulerLane, qi as env, r as EditorWorkerHost, ra as isDisposable, ro as NotSupportedError, rr as ContentWidgetPositionPreference, rt as toUint8, s as Color, sa as createSingleCallFunction, si as TokenizationResult, sn as compare, so as isCancellationError, sr as EditorAutoIndentStrategy, ta as combinedDisposable, tn as MicrotaskDelay, to as BugIndicatingError, tr as CompletionItemTag, tt as CharacterClassifier, ua as isChrome$1, ui as Codicon, un as compareSubstringIgnoreCase, uo as onUnexpectedExternalError, ur as EndOfLineSequence, ut as LRUCache, v as TextEdit, va as isMobile, vi as dirname$1, vn as equalsIgnoreCase, vo as booleanComparator, vr as InlineCompletionTriggerKind, vt as hash, w as TextLength, wa as platform, wi as sep, wn as getLeadingWhitespace, wo as equals$1, wr as OverlayWidgetPositionPreference, wt as writeUInt32BE, xa as isWeb, xi as posix, xn as firstNonWhitespaceIndex, xo as compareBy, xr as MouseTargetType, xt as readUInt32BE, ya as isNative, yi as extname$1, yn as escape$2, yo as coalesce, yr as MinimapPosition, yt as VSBuffer, z as Searcher, za as isDefined, zi as Event, zn as nextCharLength, zo as splice$1, zr as TrackedRangeStickiness, zt as RunOnceScheduler } from "./esm-i_H2JYVp.js";
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/config/editorZoom.js
var EditorZoom = new class {
	constructor() {
		this._zoomLevel = 0;
		this._onDidChangeZoomLevel = new Emitter$1();
		this.onDidChangeZoomLevel = this._onDidChangeZoomLevel.event;
	}
	getZoomLevel() {
		return this._zoomLevel;
	}
	setZoomLevel(zoomLevel) {
		zoomLevel = Math.min(Math.max(-5, zoomLevel), 20);
		if (this._zoomLevel === zoomLevel) return;
		this._zoomLevel = zoomLevel;
		this._onDidChangeZoomLevel.fire(this._zoomLevel);
	}
}();
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/config/fontInfo.js
/**
* Determined from empirical observations.
* @internal
*/
var GOLDEN_LINE_HEIGHT_RATIO = isMacintosh ? 1.5 : 1.35;
var BareFontInfo = class BareFontInfo {
	/**
	* @internal
	*/
	static _create(fontFamily, fontWeight, fontSize, fontFeatureSettings, fontVariationSettings, lineHeight, letterSpacing, pixelRatio, ignoreEditorZoom) {
		if (lineHeight === 0) lineHeight = GOLDEN_LINE_HEIGHT_RATIO * fontSize;
		else if (lineHeight < 8) lineHeight = lineHeight * fontSize;
		lineHeight = Math.round(lineHeight);
		if (lineHeight < 8) lineHeight = 8;
		const editorZoomLevelMultiplier = 1 + (ignoreEditorZoom ? 0 : EditorZoom.getZoomLevel() * .1);
		fontSize *= editorZoomLevelMultiplier;
		lineHeight *= editorZoomLevelMultiplier;
		if (fontVariationSettings === "translate") {
			if (fontWeight === "normal" || fontWeight === "bold") fontVariationSettings = FONT_VARIATION_OFF;
			else {
				fontVariationSettings = `'wght' ${parseInt(fontWeight, 10)}`;
				fontWeight = "normal";
			}
		}
		return new BareFontInfo({
			pixelRatio,
			fontFamily,
			fontWeight,
			fontSize,
			fontFeatureSettings,
			fontVariationSettings,
			lineHeight,
			letterSpacing
		});
	}
	/**
	* @internal
	*/
	constructor(opts) {
		this._bareFontInfoBrand = void 0;
		this.pixelRatio = opts.pixelRatio;
		this.fontFamily = String(opts.fontFamily);
		this.fontWeight = String(opts.fontWeight);
		this.fontSize = opts.fontSize;
		this.fontFeatureSettings = opts.fontFeatureSettings;
		this.fontVariationSettings = opts.fontVariationSettings;
		this.lineHeight = opts.lineHeight | 0;
		this.letterSpacing = opts.letterSpacing;
	}
	/**
	* @internal
	*/
	getId() {
		return `${this.pixelRatio}-${this.fontFamily}-${this.fontWeight}-${this.fontSize}-${this.fontFeatureSettings}-${this.fontVariationSettings}-${this.lineHeight}-${this.letterSpacing}`;
	}
	/**
	* @internal
	*/
	getMassagedFontFamily() {
		const fallbackFontFamily = EDITOR_FONT_DEFAULTS.fontFamily;
		const fontFamily = BareFontInfo._wrapInQuotes(this.fontFamily);
		if (this.fontFamily !== fallbackFontFamily) return `${fontFamily}, ${fallbackFontFamily}`;
		return fontFamily;
	}
	static _wrapInQuotes(fontFamily) {
		if (/[,"']/.test(fontFamily)) return fontFamily;
		if (/[+ ]/.test(fontFamily)) return `"${fontFamily}"`;
		return fontFamily;
	}
};
var FontInfo = class extends BareFontInfo {
	/**
	* @internal
	*/
	constructor(opts, isTrusted) {
		super(opts);
		this._editorStylingBrand = void 0;
		this.version = 2;
		this.isTrusted = isTrusted;
		this.isMonospace = opts.isMonospace;
		this.typicalHalfwidthCharacterWidth = opts.typicalHalfwidthCharacterWidth;
		this.typicalFullwidthCharacterWidth = opts.typicalFullwidthCharacterWidth;
		this.canUseHalfwidthRightwardsArrow = opts.canUseHalfwidthRightwardsArrow;
		this.spaceWidth = opts.spaceWidth;
		this.middotWidth = opts.middotWidth;
		this.wsmiddotWidth = opts.wsmiddotWidth;
		this.maxDigitWidth = opts.maxDigitWidth;
	}
	/**
	* @internal
	*/
	equals(other) {
		return this.fontFamily === other.fontFamily && this.fontWeight === other.fontWeight && this.fontSize === other.fontSize && this.fontFeatureSettings === other.fontFeatureSettings && this.fontVariationSettings === other.fontVariationSettings && this.lineHeight === other.lineHeight && this.letterSpacing === other.letterSpacing && this.typicalHalfwidthCharacterWidth === other.typicalHalfwidthCharacterWidth && this.typicalFullwidthCharacterWidth === other.typicalFullwidthCharacterWidth && this.canUseHalfwidthRightwardsArrow === other.canUseHalfwidthRightwardsArrow && this.spaceWidth === other.spaceWidth && this.middotWidth === other.middotWidth && this.wsmiddotWidth === other.wsmiddotWidth && this.maxDigitWidth === other.maxDigitWidth;
	}
};
/**
* @internal
*/
var FONT_VARIATION_OFF = "normal";
/**
* @internal
*/
var FONT_VARIATION_TRANSLATE = "translate";
/**
* @internal
*/
var EDITOR_FONT_DEFAULTS = {
	fontFamily: isMacintosh ? "Menlo, Monaco, 'Courier New', monospace" : isWindows ? "Consolas, 'Courier New', monospace" : "'Droid Sans Mono', monospace",
	fontWeight: "normal",
	fontSize: isMacintosh ? 12 : 14,
	lineHeight: 0,
	letterSpacing: 0
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/core/misc/textModelDefaults.js
var EDITOR_MODEL_DEFAULTS = {
	tabSize: 4,
	indentSize: 4,
	insertSpaces: true,
	detectIndentation: true,
	trimAutoWhitespace: true,
	largeFileOptimizations: true,
	bracketPairColorizationOptions: {
		enabled: true,
		independentColorPoolPerBracketType: false
	}
};
/**
* An event describing that the configuration of the editor has changed.
*/
var ConfigurationChangedEvent = class {
	/**
	* @internal
	*/
	constructor(values) {
		this._values = values;
	}
	hasChanged(id) {
		return this._values[id];
	}
};
/**
* @internal
*/
var ComputeOptionsMemory = class {
	constructor() {
		this.stableMinimapLayoutInput = null;
		this.stableFitMaxMinimapScale = 0;
		this.stableFitRemainingWidth = 0;
	}
};
/**
* @internal
*/
var BaseEditorOption = class {
	constructor(id, name, defaultValue, schema) {
		this.id = id;
		this.name = name;
		this.defaultValue = defaultValue;
		this.schema = schema;
	}
	applyUpdate(value, update) {
		return applyUpdate(value, update);
	}
	compute(env, options, value) {
		return value;
	}
};
var ApplyUpdateResult = class {
	constructor(newValue, didChange) {
		this.newValue = newValue;
		this.didChange = didChange;
	}
};
function applyUpdate(value, update) {
	if (typeof value !== "object" || typeof update !== "object" || !value || !update) return new ApplyUpdateResult(update, value !== update);
	if (Array.isArray(value) || Array.isArray(update)) return new ApplyUpdateResult(update, !(Array.isArray(value) && Array.isArray(update) && equals$1(value, update)));
	let didChange = false;
	for (const key in update) if (update.hasOwnProperty(key)) {
		const result = applyUpdate(value[key], update[key]);
		if (result.didChange) {
			value[key] = result.newValue;
			didChange = true;
		}
	}
	return new ApplyUpdateResult(value, didChange);
}
/**
* @internal
*/
var ComputedEditorOption = class {
	constructor(id, defaultValue) {
		this.schema = void 0;
		this.id = id;
		this.name = "_never_";
		this.defaultValue = defaultValue;
	}
	applyUpdate(value, update) {
		return applyUpdate(value, update);
	}
	validate(input) {
		return this.defaultValue;
	}
};
var SimpleEditorOption = class {
	constructor(id, name, defaultValue, schema) {
		this.id = id;
		this.name = name;
		this.defaultValue = defaultValue;
		this.schema = schema;
	}
	applyUpdate(value, update) {
		return applyUpdate(value, update);
	}
	compute(env, options, value) {
		return value;
	}
};
/**
* @internal
*/
function boolean(value, defaultValue) {
	if (typeof value === "undefined") return defaultValue;
	if (value === "false") return false;
	return Boolean(value);
}
var EditorBooleanOption = class extends SimpleEditorOption {
	constructor(id, name, defaultValue, schema = void 0) {
		if (typeof schema !== "undefined") {
			schema.type = "boolean";
			schema.default = defaultValue;
		}
		super(id, name, defaultValue, schema);
	}
	validate(input) {
		return boolean(input, this.defaultValue);
	}
};
/**
* @internal
*/
function clampedInt(value, defaultValue, minimum, maximum) {
	if (typeof value === "string") value = parseInt(value, 10);
	if (typeof value !== "number" || isNaN(value)) return defaultValue;
	let r = value;
	r = Math.max(minimum, r);
	r = Math.min(maximum, r);
	return r | 0;
}
var EditorIntOption = class EditorIntOption extends SimpleEditorOption {
	static clampedInt(value, defaultValue, minimum, maximum) {
		return clampedInt(value, defaultValue, minimum, maximum);
	}
	constructor(id, name, defaultValue, minimum, maximum, schema = void 0) {
		if (typeof schema !== "undefined") {
			schema.type = "integer";
			schema.default = defaultValue;
			schema.minimum = minimum;
			schema.maximum = maximum;
		}
		super(id, name, defaultValue, schema);
		this.minimum = minimum;
		this.maximum = maximum;
	}
	validate(input) {
		return EditorIntOption.clampedInt(input, this.defaultValue, this.minimum, this.maximum);
	}
};
/**
* @internal
*/
function clampedFloat(value, defaultValue, minimum, maximum) {
	if (typeof value === "undefined") return defaultValue;
	const r = EditorFloatOption.float(value, defaultValue);
	return EditorFloatOption.clamp(r, minimum, maximum);
}
var EditorFloatOption = class EditorFloatOption extends SimpleEditorOption {
	static clamp(n, min, max) {
		if (n < min) return min;
		if (n > max) return max;
		return n;
	}
	static float(value, defaultValue) {
		if (typeof value === "string") value = parseFloat(value);
		if (typeof value !== "number" || isNaN(value)) return defaultValue;
		return value;
	}
	constructor(id, name, defaultValue, validationFn, schema, minimum, maximum) {
		if (typeof schema !== "undefined") {
			schema.type = "number";
			schema.default = defaultValue;
			schema.minimum = minimum;
			schema.maximum = maximum;
		}
		super(id, name, defaultValue, schema);
		this.validationFn = validationFn;
		this.minimum = minimum;
		this.maximum = maximum;
	}
	validate(input) {
		return this.validationFn(EditorFloatOption.float(input, this.defaultValue));
	}
};
var EditorStringOption = class EditorStringOption extends SimpleEditorOption {
	static string(value, defaultValue) {
		if (typeof value !== "string") return defaultValue;
		return value;
	}
	constructor(id, name, defaultValue, schema = void 0) {
		if (typeof schema !== "undefined") {
			schema.type = "string";
			schema.default = defaultValue;
		}
		super(id, name, defaultValue, schema);
	}
	validate(input) {
		return EditorStringOption.string(input, this.defaultValue);
	}
};
/**
* @internal
*/
function stringSet(value, defaultValue, allowedValues, renamedValues) {
	if (typeof value !== "string") return defaultValue;
	if (renamedValues && value in renamedValues) return renamedValues[value];
	if (allowedValues.indexOf(value) === -1) return defaultValue;
	return value;
}
var EditorStringEnumOption = class extends SimpleEditorOption {
	constructor(id, name, defaultValue, allowedValues, schema = void 0) {
		if (typeof schema !== "undefined") {
			schema.type = "string";
			schema.enum = allowedValues.slice(0);
			schema.default = defaultValue;
		}
		super(id, name, defaultValue, schema);
		this._allowedValues = allowedValues;
	}
	validate(input) {
		return stringSet(input, this.defaultValue, this._allowedValues);
	}
};
var EditorEnumOption = class extends BaseEditorOption {
	constructor(id, name, defaultValue, defaultStringValue, allowedValues, convert, schema = void 0) {
		if (typeof schema !== "undefined") {
			schema.type = "string";
			schema.enum = allowedValues;
			schema.default = defaultStringValue;
		}
		super(id, name, defaultValue, schema);
		this._allowedValues = allowedValues;
		this._convert = convert;
	}
	validate(input) {
		if (typeof input !== "string") return this.defaultValue;
		if (this._allowedValues.indexOf(input) === -1) return this.defaultValue;
		return this._convert(input);
	}
};
function _autoIndentFromString(autoIndent) {
	switch (autoIndent) {
		case "none": return 0;
		case "keep": return 1;
		case "brackets": return 2;
		case "advanced": return 3;
		case "full": return 4;
	}
}
var EditorAccessibilitySupport = class extends BaseEditorOption {
	constructor() {
		super(2, "accessibilitySupport", 0, {
			type: "string",
			enum: [
				"auto",
				"on",
				"off"
			],
			enumDescriptions: [
				localize(226, "Use platform APIs to detect when a Screen Reader is attached."),
				localize(227, "Optimize for usage with a Screen Reader."),
				localize(228, "Assume a screen reader is not attached.")
			],
			default: "auto",
			tags: ["accessibility"],
			description: localize(229, "Controls if the UI should run in a mode where it is optimized for screen readers.")
		});
	}
	validate(input) {
		switch (input) {
			case "auto": return 0;
			case "off": return 1;
			case "on": return 2;
		}
		return this.defaultValue;
	}
	compute(env, options, value) {
		if (value === 0) return env.accessibilitySupport;
		return value;
	}
};
var EditorComments = class extends BaseEditorOption {
	constructor() {
		const defaults = {
			insertSpace: true,
			ignoreEmptyLines: true
		};
		super(29, "comments", defaults, {
			"editor.comments.insertSpace": {
				type: "boolean",
				default: defaults.insertSpace,
				description: localize(230, "Controls whether a space character is inserted when commenting.")
			},
			"editor.comments.ignoreEmptyLines": {
				type: "boolean",
				default: defaults.ignoreEmptyLines,
				description: localize(231, "Controls if empty lines should be ignored with toggle, add or remove actions for line comments.")
			}
		});
	}
	validate(_input) {
		if (!_input || typeof _input !== "object") return this.defaultValue;
		const input = _input;
		return {
			insertSpace: boolean(input.insertSpace, this.defaultValue.insertSpace),
			ignoreEmptyLines: boolean(input.ignoreEmptyLines, this.defaultValue.ignoreEmptyLines)
		};
	}
};
/**
* @internal
*/
function cursorBlinkingStyleFromString(cursorBlinkingStyle) {
	switch (cursorBlinkingStyle) {
		case "blink": return 1;
		case "smooth": return 2;
		case "phase": return 3;
		case "expand": return 4;
		case "solid": return 5;
	}
}
/**
* The style in which the editor's cursor should be rendered.
*/
var TextEditorCursorStyle;
(function(TextEditorCursorStyle) {
	/**
	* As a vertical line (sitting between two characters).
	*/
	TextEditorCursorStyle[TextEditorCursorStyle["Line"] = 1] = "Line";
	/**
	* As a block (sitting on top of a character).
	*/
	TextEditorCursorStyle[TextEditorCursorStyle["Block"] = 2] = "Block";
	/**
	* As a horizontal line (sitting under a character).
	*/
	TextEditorCursorStyle[TextEditorCursorStyle["Underline"] = 3] = "Underline";
	/**
	* As a thin vertical line (sitting between two characters).
	*/
	TextEditorCursorStyle[TextEditorCursorStyle["LineThin"] = 4] = "LineThin";
	/**
	* As an outlined block (sitting on top of a character).
	*/
	TextEditorCursorStyle[TextEditorCursorStyle["BlockOutline"] = 5] = "BlockOutline";
	/**
	* As a thin horizontal line (sitting under a character).
	*/
	TextEditorCursorStyle[TextEditorCursorStyle["UnderlineThin"] = 6] = "UnderlineThin";
})(TextEditorCursorStyle || (TextEditorCursorStyle = {}));
/**
* @internal
*/
function cursorStyleFromString(cursorStyle) {
	switch (cursorStyle) {
		case "line": return TextEditorCursorStyle.Line;
		case "block": return TextEditorCursorStyle.Block;
		case "underline": return TextEditorCursorStyle.Underline;
		case "line-thin": return TextEditorCursorStyle.LineThin;
		case "block-outline": return TextEditorCursorStyle.BlockOutline;
		case "underline-thin": return TextEditorCursorStyle.UnderlineThin;
	}
}
var EditorClassName = class extends ComputedEditorOption {
	constructor() {
		super(163, "");
	}
	compute(env, options, _) {
		const classNames = ["monaco-editor"];
		if (options.get(48)) classNames.push(options.get(48));
		if (env.extraEditorClassName) classNames.push(env.extraEditorClassName);
		if (options.get(82) === "default") classNames.push("mouse-default");
		else if (options.get(82) === "copy") classNames.push("mouse-copy");
		if (options.get(127)) classNames.push("showUnused");
		if (options.get(157)) classNames.push("showDeprecated");
		return classNames.join(" ");
	}
};
var EditorEmptySelectionClipboard = class extends EditorBooleanOption {
	constructor() {
		super(45, "emptySelectionClipboard", true, { description: localize(232, "Controls whether copying without a selection copies the current line.") });
	}
	compute(env, options, value) {
		return value && env.emptySelectionClipboard;
	}
};
var EditorFind = class extends BaseEditorOption {
	constructor() {
		const defaults = {
			cursorMoveOnType: true,
			findOnType: true,
			seedSearchStringFromSelection: "always",
			autoFindInSelection: "never",
			globalFindClipboard: false,
			addExtraSpaceOnTop: true,
			loop: true,
			closeOnResult: false,
			history: "workspace",
			replaceHistory: "workspace"
		};
		super(50, "find", defaults, {
			"editor.find.cursorMoveOnType": {
				type: "boolean",
				default: defaults.cursorMoveOnType,
				description: localize(233, "Controls whether the cursor should jump to find matches while typing.")
			},
			"editor.find.seedSearchStringFromSelection": {
				type: "string",
				enum: [
					"never",
					"always",
					"selection"
				],
				default: defaults.seedSearchStringFromSelection,
				enumDescriptions: [
					localize(234, "Never seed search string from the editor selection."),
					localize(235, "Always seed search string from the editor selection, including word at cursor position."),
					localize(236, "Only seed search string from the editor selection.")
				],
				description: localize(237, "Controls whether the search string in the Find Widget is seeded from the editor selection.")
			},
			"editor.find.autoFindInSelection": {
				type: "string",
				enum: [
					"never",
					"always",
					"multiline"
				],
				default: defaults.autoFindInSelection,
				enumDescriptions: [
					localize(238, "Never turn on Find in Selection automatically (default)."),
					localize(239, "Always turn on Find in Selection automatically."),
					localize(240, "Turn on Find in Selection automatically when multiple lines of content are selected.")
				],
				description: localize(241, "Controls the condition for turning on Find in Selection automatically.")
			},
			"editor.find.globalFindClipboard": {
				type: "boolean",
				default: defaults.globalFindClipboard,
				description: localize(242, "Controls whether the Find Widget should read or modify the shared find clipboard on macOS."),
				included: isMacintosh
			},
			"editor.find.addExtraSpaceOnTop": {
				type: "boolean",
				default: defaults.addExtraSpaceOnTop,
				description: localize(243, "Controls whether the Find Widget should add extra lines on top of the editor. When true, you can scroll beyond the first line when the Find Widget is visible.")
			},
			"editor.find.loop": {
				type: "boolean",
				default: defaults.loop,
				description: localize(244, "Controls whether the search automatically restarts from the beginning (or the end) when no further matches can be found.")
			},
			"editor.find.closeOnResult": {
				type: "boolean",
				default: defaults.closeOnResult,
				description: localize(245, "Controls whether the Find Widget closes after an explicit find navigation command lands on a result.")
			},
			"editor.find.history": {
				type: "string",
				enum: ["never", "workspace"],
				default: "workspace",
				enumDescriptions: [localize(246, "Do not store search history from the find widget."), localize(247, "Store search history across the active workspace")],
				description: localize(248, "Controls how the find widget history should be stored")
			},
			"editor.find.replaceHistory": {
				type: "string",
				enum: ["never", "workspace"],
				default: "workspace",
				enumDescriptions: [localize(249, "Do not store history from the replace widget."), localize(250, "Store replace history across the active workspace")],
				description: localize(251, "Controls how the replace widget history should be stored")
			},
			"editor.find.findOnType": {
				type: "boolean",
				default: defaults.findOnType,
				description: localize(252, "Controls whether the Find Widget should search as you type.")
			}
		});
	}
	validate(_input) {
		if (!_input || typeof _input !== "object") return this.defaultValue;
		const input = _input;
		return {
			cursorMoveOnType: boolean(input.cursorMoveOnType, this.defaultValue.cursorMoveOnType),
			findOnType: boolean(input.findOnType, this.defaultValue.findOnType),
			seedSearchStringFromSelection: typeof input.seedSearchStringFromSelection === "boolean" ? input.seedSearchStringFromSelection ? "always" : "never" : stringSet(input.seedSearchStringFromSelection, this.defaultValue.seedSearchStringFromSelection, [
				"never",
				"always",
				"selection"
			]),
			autoFindInSelection: typeof input.autoFindInSelection === "boolean" ? input.autoFindInSelection ? "always" : "never" : stringSet(input.autoFindInSelection, this.defaultValue.autoFindInSelection, [
				"never",
				"always",
				"multiline"
			]),
			globalFindClipboard: boolean(input.globalFindClipboard, this.defaultValue.globalFindClipboard),
			addExtraSpaceOnTop: boolean(input.addExtraSpaceOnTop, this.defaultValue.addExtraSpaceOnTop),
			loop: boolean(input.loop, this.defaultValue.loop),
			closeOnResult: boolean(input.closeOnResult, this.defaultValue.closeOnResult),
			history: stringSet(input.history, this.defaultValue.history, ["never", "workspace"]),
			replaceHistory: stringSet(input.replaceHistory, this.defaultValue.replaceHistory, ["never", "workspace"])
		};
	}
};
/**
* @internal
*/
var EditorFontLigatures = class EditorFontLigatures extends BaseEditorOption {
	static {
		this.OFF = "\"liga\" off, \"calt\" off";
	}
	static {
		this.ON = "\"liga\" on, \"calt\" on";
	}
	constructor() {
		super(60, "fontLigatures", EditorFontLigatures.OFF, {
			anyOf: [{
				type: "boolean",
				description: localize(253, "Enables/Disables font ligatures ('calt' and 'liga' font features). Change this to a string for fine-grained control of the 'font-feature-settings' CSS property.")
			}, {
				type: "string",
				description: localize(254, "Explicit 'font-feature-settings' CSS property. A boolean can be passed instead if one only needs to turn on/off ligatures.")
			}],
			description: localize(255, "Configures font ligatures or font features. Can be either a boolean to enable/disable ligatures or a string for the value of the CSS 'font-feature-settings' property."),
			default: false
		});
	}
	validate(input) {
		if (typeof input === "undefined") return this.defaultValue;
		if (typeof input === "string") {
			if (input === "false" || input.length === 0) return EditorFontLigatures.OFF;
			if (input === "true") return EditorFontLigatures.ON;
			return input;
		}
		if (Boolean(input)) return EditorFontLigatures.ON;
		return EditorFontLigatures.OFF;
	}
};
/**
* @internal
*/
var EditorFontVariations = class EditorFontVariations extends BaseEditorOption {
	static {
		this.OFF = FONT_VARIATION_OFF;
	}
	static {
		this.TRANSLATE = FONT_VARIATION_TRANSLATE;
	}
	constructor() {
		super(63, "fontVariations", EditorFontVariations.OFF, {
			anyOf: [{
				type: "boolean",
				description: localize(256, "Enables/Disables the translation from font-weight to font-variation-settings. Change this to a string for fine-grained control of the 'font-variation-settings' CSS property.")
			}, {
				type: "string",
				description: localize(257, "Explicit 'font-variation-settings' CSS property. A boolean can be passed instead if one only needs to translate font-weight to font-variation-settings.")
			}],
			description: localize(258, "Configures font variations. Can be either a boolean to enable/disable the translation from font-weight to font-variation-settings or a string for the value of the CSS 'font-variation-settings' property."),
			default: false
		});
	}
	validate(input) {
		if (typeof input === "undefined") return this.defaultValue;
		if (typeof input === "string") {
			if (input === "false") return EditorFontVariations.OFF;
			if (input === "true") return EditorFontVariations.TRANSLATE;
			return input;
		}
		if (Boolean(input)) return EditorFontVariations.TRANSLATE;
		return EditorFontVariations.OFF;
	}
	compute(env, options, value) {
		return env.fontInfo.fontVariationSettings;
	}
};
var EditorFontInfo = class extends ComputedEditorOption {
	constructor() {
		super(59, new FontInfo({
			pixelRatio: 0,
			fontFamily: "",
			fontWeight: "",
			fontSize: 0,
			fontFeatureSettings: "",
			fontVariationSettings: "",
			lineHeight: 0,
			letterSpacing: 0,
			isMonospace: false,
			typicalHalfwidthCharacterWidth: 0,
			typicalFullwidthCharacterWidth: 0,
			canUseHalfwidthRightwardsArrow: false,
			spaceWidth: 0,
			middotWidth: 0,
			wsmiddotWidth: 0,
			maxDigitWidth: 0
		}, false));
	}
	compute(env, options, _) {
		return env.fontInfo;
	}
};
var EffectiveCursorStyle = class extends ComputedEditorOption {
	constructor() {
		super(162, TextEditorCursorStyle.Line);
	}
	compute(env, options, _) {
		return env.inputMode === "overtype" ? options.get(92) : options.get(34);
	}
};
var EffectiveEditContextEnabled = class extends ComputedEditorOption {
	constructor() {
		super(171, false);
	}
	compute(env, options) {
		return env.editContextSupported && options.get(44);
	}
};
var EffectiveAllowVariableFonts = class extends ComputedEditorOption {
	constructor() {
		super(173, false);
	}
	compute(env, options) {
		if (env.accessibilitySupport === 2) return options.get(7);
		else return options.get(6);
	}
};
var EffectiveFullwidthCharacterWidth = class extends ComputedEditorOption {
	constructor() {
		super(176, "font");
	}
	compute(env, options) {
		if (options.get(175) === "twoCells" && env.fontInfo.isMonospace) return "twoCells";
		return "font";
	}
};
var EditorFontSize = class extends SimpleEditorOption {
	constructor() {
		super(61, "fontSize", EDITOR_FONT_DEFAULTS.fontSize, {
			type: "number",
			minimum: 6,
			maximum: 100,
			default: EDITOR_FONT_DEFAULTS.fontSize,
			description: localize(259, "Controls the font size in pixels.")
		});
	}
	validate(input) {
		const r = EditorFloatOption.float(input, this.defaultValue);
		if (r === 0) return EDITOR_FONT_DEFAULTS.fontSize;
		return EditorFloatOption.clamp(r, 6, 100);
	}
	compute(env, options, value) {
		return env.fontInfo.fontSize;
	}
};
var EditorFontWeight = class EditorFontWeight extends BaseEditorOption {
	static {
		this.SUGGESTION_VALUES = [
			"normal",
			"bold",
			"100",
			"200",
			"300",
			"400",
			"500",
			"600",
			"700",
			"800",
			"900"
		];
	}
	static {
		this.MINIMUM_VALUE = 1;
	}
	static {
		this.MAXIMUM_VALUE = 1e3;
	}
	constructor() {
		super(62, "fontWeight", EDITOR_FONT_DEFAULTS.fontWeight, {
			anyOf: [
				{
					type: "number",
					minimum: EditorFontWeight.MINIMUM_VALUE,
					maximum: EditorFontWeight.MAXIMUM_VALUE,
					errorMessage: localize(260, "Only \"normal\" and \"bold\" keywords or numbers between 1 and 1000 are allowed.")
				},
				{
					type: "string",
					pattern: "^(normal|bold|1000|[1-9][0-9]{0,2})$"
				},
				{ enum: EditorFontWeight.SUGGESTION_VALUES }
			],
			default: EDITOR_FONT_DEFAULTS.fontWeight,
			description: localize(261, "Controls the font weight. Accepts \"normal\" and \"bold\" keywords or numbers between 1 and 1000.")
		});
	}
	validate(input) {
		if (input === "normal" || input === "bold") return input;
		return String(EditorIntOption.clampedInt(input, EDITOR_FONT_DEFAULTS.fontWeight, EditorFontWeight.MINIMUM_VALUE, EditorFontWeight.MAXIMUM_VALUE));
	}
};
var EditorGoToLocation = class extends BaseEditorOption {
	constructor() {
		const defaults = {
			multiple: "peek",
			multipleDefinitions: "peek",
			multipleTypeDefinitions: "peek",
			multipleDeclarations: "peek",
			multipleImplementations: "peek",
			multipleReferences: "peek",
			multipleTests: "peek",
			alternativeDefinitionCommand: "editor.action.goToReferences",
			alternativeTypeDefinitionCommand: "editor.action.goToReferences",
			alternativeDeclarationCommand: "editor.action.goToReferences",
			alternativeImplementationCommand: "",
			alternativeReferenceCommand: "",
			alternativeTestsCommand: ""
		};
		const jsonSubset = {
			type: "string",
			enum: [
				"peek",
				"gotoAndPeek",
				"goto"
			],
			default: defaults.multiple,
			enumDescriptions: [
				localize(262, "Show Peek view of the results (default)"),
				localize(263, "Go to the primary result and show a Peek view"),
				localize(264, "Go to the primary result and enable Peek-less navigation to others")
			]
		};
		const alternativeCommandOptions = [
			"",
			"editor.action.referenceSearch.trigger",
			"editor.action.goToReferences",
			"editor.action.peekImplementation",
			"editor.action.goToImplementation",
			"editor.action.peekTypeDefinition",
			"editor.action.goToTypeDefinition",
			"editor.action.peekDeclaration",
			"editor.action.revealDeclaration",
			"editor.action.peekDefinition",
			"editor.action.revealDefinitionAside",
			"editor.action.revealDefinition"
		];
		super(67, "gotoLocation", defaults, {
			"editor.gotoLocation.multiple": { deprecationMessage: localize(265, "This setting is deprecated, please use separate settings like 'editor.editor.gotoLocation.multipleDefinitions' or 'editor.editor.gotoLocation.multipleImplementations' instead.") },
			"editor.gotoLocation.multipleDefinitions": {
				description: localize(266, "Controls the behavior the 'Go to Definition'-command when multiple target locations exist."),
				...jsonSubset
			},
			"editor.gotoLocation.multipleTypeDefinitions": {
				description: localize(267, "Controls the behavior the 'Go to Type Definition'-command when multiple target locations exist."),
				...jsonSubset
			},
			"editor.gotoLocation.multipleDeclarations": {
				description: localize(268, "Controls the behavior the 'Go to Declaration'-command when multiple target locations exist."),
				...jsonSubset
			},
			"editor.gotoLocation.multipleImplementations": {
				description: localize(269, "Controls the behavior the 'Go to Implementations'-command when multiple target locations exist."),
				...jsonSubset
			},
			"editor.gotoLocation.multipleReferences": {
				description: localize(270, "Controls the behavior the 'Go to References'-command when multiple target locations exist."),
				...jsonSubset
			},
			"editor.gotoLocation.alternativeDefinitionCommand": {
				type: "string",
				default: defaults.alternativeDefinitionCommand,
				enum: alternativeCommandOptions,
				description: localize(271, "Alternative command id that is being executed when the result of 'Go to Definition' is the current location.")
			},
			"editor.gotoLocation.alternativeTypeDefinitionCommand": {
				type: "string",
				default: defaults.alternativeTypeDefinitionCommand,
				enum: alternativeCommandOptions,
				description: localize(272, "Alternative command id that is being executed when the result of 'Go to Type Definition' is the current location.")
			},
			"editor.gotoLocation.alternativeDeclarationCommand": {
				type: "string",
				default: defaults.alternativeDeclarationCommand,
				enum: alternativeCommandOptions,
				description: localize(273, "Alternative command id that is being executed when the result of 'Go to Declaration' is the current location.")
			},
			"editor.gotoLocation.alternativeImplementationCommand": {
				type: "string",
				default: defaults.alternativeImplementationCommand,
				enum: alternativeCommandOptions,
				description: localize(274, "Alternative command id that is being executed when the result of 'Go to Implementation' is the current location.")
			},
			"editor.gotoLocation.alternativeReferenceCommand": {
				type: "string",
				default: defaults.alternativeReferenceCommand,
				enum: alternativeCommandOptions,
				description: localize(275, "Alternative command id that is being executed when the result of 'Go to Reference' is the current location.")
			}
		});
	}
	validate(_input) {
		if (!_input || typeof _input !== "object") return this.defaultValue;
		const input = _input;
		return {
			multiple: stringSet(input.multiple, this.defaultValue.multiple, [
				"peek",
				"gotoAndPeek",
				"goto"
			]),
			multipleDefinitions: stringSet(input.multipleDefinitions, "peek", [
				"peek",
				"gotoAndPeek",
				"goto"
			]),
			multipleTypeDefinitions: stringSet(input.multipleTypeDefinitions, "peek", [
				"peek",
				"gotoAndPeek",
				"goto"
			]),
			multipleDeclarations: stringSet(input.multipleDeclarations, "peek", [
				"peek",
				"gotoAndPeek",
				"goto"
			]),
			multipleImplementations: stringSet(input.multipleImplementations, "peek", [
				"peek",
				"gotoAndPeek",
				"goto"
			]),
			multipleReferences: stringSet(input.multipleReferences, "peek", [
				"peek",
				"gotoAndPeek",
				"goto"
			]),
			multipleTests: stringSet(input.multipleTests, "peek", [
				"peek",
				"gotoAndPeek",
				"goto"
			]),
			alternativeDefinitionCommand: EditorStringOption.string(input.alternativeDefinitionCommand, this.defaultValue.alternativeDefinitionCommand),
			alternativeTypeDefinitionCommand: EditorStringOption.string(input.alternativeTypeDefinitionCommand, this.defaultValue.alternativeTypeDefinitionCommand),
			alternativeDeclarationCommand: EditorStringOption.string(input.alternativeDeclarationCommand, this.defaultValue.alternativeDeclarationCommand),
			alternativeImplementationCommand: EditorStringOption.string(input.alternativeImplementationCommand, this.defaultValue.alternativeImplementationCommand),
			alternativeReferenceCommand: EditorStringOption.string(input.alternativeReferenceCommand, this.defaultValue.alternativeReferenceCommand),
			alternativeTestsCommand: EditorStringOption.string(input.alternativeTestsCommand, this.defaultValue.alternativeTestsCommand)
		};
	}
};
var EditorHover = class extends BaseEditorOption {
	constructor() {
		const defaults = {
			enabled: "on",
			delay: 300,
			hidingDelay: 300,
			sticky: true,
			above: true,
			showLongLineWarning: true
		};
		super(69, "hover", defaults, {
			"editor.hover.enabled": {
				type: "string",
				enum: [
					"on",
					"off",
					"onKeyboardModifier"
				],
				default: defaults.enabled,
				markdownEnumDescriptions: [
					localize(276, "Hover is enabled."),
					localize(277, "Hover is disabled."),
					localize(278, "Hover is shown when holding `{0}` or `Alt` (the opposite modifier of `#editor.multiCursorModifier#`)", isMacintosh ? `Command` : `Control`)
				],
				description: localize(279, "Controls whether the hover is shown."),
				keywords: [
					"hint",
					"info",
					"tooltip"
				]
			},
			"editor.hover.delay": {
				type: "number",
				default: defaults.delay,
				minimum: 0,
				maximum: 1e4,
				description: localize(280, "Controls the delay in milliseconds after which the hover is shown.")
			},
			"editor.hover.sticky": {
				type: "boolean",
				default: defaults.sticky,
				description: localize(281, "Controls whether the hover should remain visible when mouse is moved over it.")
			},
			"editor.hover.hidingDelay": {
				type: "integer",
				minimum: 0,
				default: defaults.hidingDelay,
				markdownDescription: localize(282, "Controls the delay in milliseconds after which the hover is hidden. Requires `#editor.hover.sticky#` to be enabled.")
			},
			"editor.hover.above": {
				type: "boolean",
				default: defaults.above,
				description: localize(283, "Prefer showing hovers above the line, if there's space.")
			},
			"editor.hover.showLongLineWarning": {
				type: "boolean",
				default: defaults.showLongLineWarning,
				description: localize(284, "Controls whether long line warning hovers are shown, such as when tokenization is skipped or rendering is paused.")
			}
		});
	}
	validate(_input) {
		if (!_input || typeof _input !== "object") return this.defaultValue;
		const input = _input;
		return {
			enabled: stringSet(input.enabled, this.defaultValue.enabled, [
				"on",
				"off",
				"onKeyboardModifier"
			]),
			delay: EditorIntOption.clampedInt(input.delay, this.defaultValue.delay, 0, 1e4),
			sticky: boolean(input.sticky, this.defaultValue.sticky),
			hidingDelay: EditorIntOption.clampedInt(input.hidingDelay, this.defaultValue.hidingDelay, 0, 6e5),
			above: boolean(input.above, this.defaultValue.above),
			showLongLineWarning: boolean(input.showLongLineWarning, this.defaultValue.showLongLineWarning)
		};
	}
};
/**
* @internal
*/
var EditorLayoutInfoComputer = class EditorLayoutInfoComputer extends ComputedEditorOption {
	constructor() {
		super(166, {
			width: 0,
			height: 0,
			glyphMarginLeft: 0,
			glyphMarginWidth: 0,
			glyphMarginDecorationLaneCount: 0,
			lineNumbersLeft: 0,
			lineNumbersWidth: 0,
			decorationsLeft: 0,
			decorationsWidth: 0,
			contentLeft: 0,
			contentWidth: 0,
			minimap: {
				renderMinimap: 0,
				minimapLeft: 0,
				minimapWidth: 0,
				minimapHeightIsEditorHeight: false,
				minimapIsSampling: false,
				minimapScale: 1,
				minimapLineHeight: 1,
				minimapCanvasInnerWidth: 0,
				minimapCanvasInnerHeight: 0,
				minimapCanvasOuterWidth: 0,
				minimapCanvasOuterHeight: 0
			},
			viewportColumn: 0,
			isWordWrapMinified: false,
			isViewportWrapping: false,
			wrappingColumn: -1,
			verticalScrollbarWidth: 0,
			horizontalScrollbarHeight: 0,
			overviewRuler: {
				top: 0,
				width: 0,
				height: 0,
				right: 0
			}
		});
	}
	compute(env, options, _) {
		return EditorLayoutInfoComputer.computeLayout(options, {
			memory: env.memory,
			outerWidth: env.outerWidth,
			outerHeight: env.outerHeight,
			isDominatedByLongLines: env.isDominatedByLongLines,
			lineHeight: env.fontInfo.lineHeight,
			viewLineCount: env.viewLineCount,
			lineNumbersDigitCount: env.lineNumbersDigitCount,
			typicalHalfwidthCharacterWidth: env.fontInfo.typicalHalfwidthCharacterWidth,
			maxDigitWidth: env.fontInfo.maxDigitWidth,
			pixelRatio: env.pixelRatio,
			glyphMarginDecorationLaneCount: env.glyphMarginDecorationLaneCount
		});
	}
	static computeContainedMinimapLineCount(input) {
		const typicalViewportLineCount = input.height / input.lineHeight;
		const extraLinesBeforeFirstLine = Math.floor(input.paddingTop / input.lineHeight);
		let extraLinesBeyondLastLine = Math.floor(input.paddingBottom / input.lineHeight);
		if (input.scrollBeyondLastLine) extraLinesBeyondLastLine = Math.max(extraLinesBeyondLastLine, typicalViewportLineCount - 1);
		const desiredRatio = (extraLinesBeforeFirstLine + input.viewLineCount + extraLinesBeyondLastLine) / (input.pixelRatio * input.height);
		const minimapLineCount = Math.floor(input.viewLineCount / desiredRatio);
		return {
			typicalViewportLineCount,
			extraLinesBeforeFirstLine,
			extraLinesBeyondLastLine,
			desiredRatio,
			minimapLineCount
		};
	}
	static _computeMinimapLayout(input, memory) {
		const outerWidth = input.outerWidth;
		const outerHeight = input.outerHeight;
		const pixelRatio = input.pixelRatio;
		if (!input.minimap.enabled) return {
			renderMinimap: 0,
			minimapLeft: 0,
			minimapWidth: 0,
			minimapHeightIsEditorHeight: false,
			minimapIsSampling: false,
			minimapScale: 1,
			minimapLineHeight: 1,
			minimapCanvasInnerWidth: 0,
			minimapCanvasInnerHeight: Math.floor(pixelRatio * outerHeight),
			minimapCanvasOuterWidth: 0,
			minimapCanvasOuterHeight: outerHeight
		};
		const stableMinimapLayoutInput = memory.stableMinimapLayoutInput;
		const couldUseMemory = stableMinimapLayoutInput && input.outerHeight === stableMinimapLayoutInput.outerHeight && input.lineHeight === stableMinimapLayoutInput.lineHeight && input.typicalHalfwidthCharacterWidth === stableMinimapLayoutInput.typicalHalfwidthCharacterWidth && input.pixelRatio === stableMinimapLayoutInput.pixelRatio && input.scrollBeyondLastLine === stableMinimapLayoutInput.scrollBeyondLastLine && input.paddingTop === stableMinimapLayoutInput.paddingTop && input.paddingBottom === stableMinimapLayoutInput.paddingBottom && input.minimap.enabled === stableMinimapLayoutInput.minimap.enabled && input.minimap.side === stableMinimapLayoutInput.minimap.side && input.minimap.size === stableMinimapLayoutInput.minimap.size && input.minimap.showSlider === stableMinimapLayoutInput.minimap.showSlider && input.minimap.renderCharacters === stableMinimapLayoutInput.minimap.renderCharacters && input.minimap.maxColumn === stableMinimapLayoutInput.minimap.maxColumn && input.minimap.scale === stableMinimapLayoutInput.minimap.scale && input.verticalScrollbarWidth === stableMinimapLayoutInput.verticalScrollbarWidth && input.isViewportWrapping === stableMinimapLayoutInput.isViewportWrapping;
		const lineHeight = input.lineHeight;
		const typicalHalfwidthCharacterWidth = input.typicalHalfwidthCharacterWidth;
		const scrollBeyondLastLine = input.scrollBeyondLastLine;
		const minimapRenderCharacters = input.minimap.renderCharacters;
		let minimapScale = pixelRatio >= 2 ? Math.round(input.minimap.scale * 2) : input.minimap.scale;
		const minimapMaxColumn = input.minimap.maxColumn;
		const minimapSize = input.minimap.size;
		const minimapSide = input.minimap.side;
		const verticalScrollbarWidth = input.verticalScrollbarWidth;
		const viewLineCount = input.viewLineCount;
		const remainingWidth = input.remainingWidth;
		const isViewportWrapping = input.isViewportWrapping;
		const baseCharHeight = minimapRenderCharacters ? 2 : 3;
		let minimapCanvasInnerHeight = Math.floor(pixelRatio * outerHeight);
		const minimapCanvasOuterHeight = minimapCanvasInnerHeight / pixelRatio;
		let minimapHeightIsEditorHeight = false;
		let minimapIsSampling = false;
		let minimapLineHeight = baseCharHeight * minimapScale;
		let minimapCharWidth = minimapScale / pixelRatio;
		let minimapWidthMultiplier = 1;
		if (minimapSize === "fill" || minimapSize === "fit") {
			const { typicalViewportLineCount, extraLinesBeforeFirstLine, extraLinesBeyondLastLine, desiredRatio, minimapLineCount } = EditorLayoutInfoComputer.computeContainedMinimapLineCount({
				viewLineCount,
				scrollBeyondLastLine,
				paddingTop: input.paddingTop,
				paddingBottom: input.paddingBottom,
				height: outerHeight,
				lineHeight,
				pixelRatio
			});
			if (viewLineCount / minimapLineCount > 1) {
				minimapHeightIsEditorHeight = true;
				minimapIsSampling = true;
				minimapScale = 1;
				minimapLineHeight = 1;
				minimapCharWidth = minimapScale / pixelRatio;
			} else {
				let fitBecomesFill = false;
				let maxMinimapScale = minimapScale + 1;
				if (minimapSize === "fit") {
					const effectiveMinimapHeight = Math.ceil((extraLinesBeforeFirstLine + viewLineCount + extraLinesBeyondLastLine) * minimapLineHeight);
					if (isViewportWrapping && couldUseMemory && remainingWidth <= memory.stableFitRemainingWidth) {
						fitBecomesFill = true;
						maxMinimapScale = memory.stableFitMaxMinimapScale;
					} else fitBecomesFill = effectiveMinimapHeight > minimapCanvasInnerHeight;
				}
				if (minimapSize === "fill" || fitBecomesFill) {
					minimapHeightIsEditorHeight = true;
					const configuredMinimapScale = minimapScale;
					minimapLineHeight = Math.min(lineHeight * pixelRatio, Math.max(1, Math.floor(1 / desiredRatio)));
					if (isViewportWrapping && couldUseMemory && remainingWidth <= memory.stableFitRemainingWidth) maxMinimapScale = memory.stableFitMaxMinimapScale;
					minimapScale = Math.min(maxMinimapScale, Math.max(1, Math.floor(minimapLineHeight / baseCharHeight)));
					if (minimapScale > configuredMinimapScale) minimapWidthMultiplier = Math.min(2, minimapScale / configuredMinimapScale);
					minimapCharWidth = minimapScale / pixelRatio / minimapWidthMultiplier;
					minimapCanvasInnerHeight = Math.ceil(Math.max(typicalViewportLineCount, extraLinesBeforeFirstLine + viewLineCount + extraLinesBeyondLastLine) * minimapLineHeight);
					if (isViewportWrapping) {
						memory.stableMinimapLayoutInput = input;
						memory.stableFitRemainingWidth = remainingWidth;
						memory.stableFitMaxMinimapScale = minimapScale;
					} else {
						memory.stableMinimapLayoutInput = null;
						memory.stableFitRemainingWidth = 0;
					}
				}
			}
		}
		const minimapMaxWidth = Math.floor(minimapMaxColumn * minimapCharWidth);
		const minimapWidth = Math.min(minimapMaxWidth, Math.max(0, Math.floor((remainingWidth - verticalScrollbarWidth - 2) * minimapCharWidth / (typicalHalfwidthCharacterWidth + minimapCharWidth))) + 8);
		let minimapCanvasInnerWidth = Math.floor(pixelRatio * minimapWidth);
		const minimapCanvasOuterWidth = minimapCanvasInnerWidth / pixelRatio;
		minimapCanvasInnerWidth = Math.floor(minimapCanvasInnerWidth * minimapWidthMultiplier);
		return {
			renderMinimap: minimapRenderCharacters ? 1 : 2,
			minimapLeft: minimapSide === "left" ? 0 : outerWidth - minimapWidth - verticalScrollbarWidth,
			minimapWidth,
			minimapHeightIsEditorHeight,
			minimapIsSampling,
			minimapScale,
			minimapLineHeight,
			minimapCanvasInnerWidth,
			minimapCanvasInnerHeight,
			minimapCanvasOuterWidth,
			minimapCanvasOuterHeight
		};
	}
	static computeLayout(options, env) {
		const outerWidth = env.outerWidth | 0;
		const outerHeight = env.outerHeight | 0;
		const lineHeight = env.lineHeight | 0;
		const lineNumbersDigitCount = env.lineNumbersDigitCount | 0;
		const typicalHalfwidthCharacterWidth = env.typicalHalfwidthCharacterWidth;
		const maxDigitWidth = env.maxDigitWidth;
		const pixelRatio = env.pixelRatio;
		const viewLineCount = env.viewLineCount;
		const wordWrapOverride2 = options.get(154);
		const wordWrapOverride1 = wordWrapOverride2 === "inherit" ? options.get(153) : wordWrapOverride2;
		const wordWrap = wordWrapOverride1 === "inherit" ? options.get(149) : wordWrapOverride1;
		const wordWrapColumn = options.get(152);
		const wordWrapIndicator = options.get(161);
		const isDominatedByLongLines = env.isDominatedByLongLines;
		const showGlyphMargin = options.get(66);
		const showLineNumbers = options.get(76).renderType !== 0;
		const lineNumbersMinChars = options.get(77);
		const scrollBeyondLastLine = options.get(119);
		const padding = options.get(96);
		const minimap = options.get(81);
		const scrollbar = options.get(117);
		const verticalScrollbarWidth = scrollbar.verticalScrollbarSize;
		const verticalScrollbarHasArrows = scrollbar.verticalHasArrows;
		const scrollbarArrowSize = scrollbar.arrowSize;
		const horizontalScrollbarHeight = scrollbar.horizontalScrollbarSize;
		const folding = options.get(52);
		const showFoldingDecoration = options.get(126) !== "never";
		let lineDecorationsWidth = options.get(74);
		if (folding && showFoldingDecoration) lineDecorationsWidth += 16;
		let lineNumbersWidth = 0;
		if (showLineNumbers) lineNumbersWidth = Math.round(Math.max(lineNumbersDigitCount, lineNumbersMinChars) * maxDigitWidth);
		let glyphMarginWidth = 0;
		if (showGlyphMargin) glyphMarginWidth = lineHeight * env.glyphMarginDecorationLaneCount;
		let glyphMarginLeft = 0;
		let lineNumbersLeft = glyphMarginLeft + glyphMarginWidth;
		let decorationsLeft = lineNumbersLeft + lineNumbersWidth;
		let contentLeft = decorationsLeft + lineDecorationsWidth;
		const remainingWidth = outerWidth - glyphMarginWidth - lineNumbersWidth - lineDecorationsWidth;
		let isWordWrapMinified = false;
		let isViewportWrapping = false;
		let wrappingColumn = -1;
		if (options.get(2) === 2 && wordWrapOverride1 === "inherit" && isDominatedByLongLines) {
			isWordWrapMinified = true;
			isViewportWrapping = true;
		} else if (wordWrap === "on" || wordWrap === "bounded") isViewportWrapping = true;
		else if (wordWrap === "wordWrapColumn") wrappingColumn = wordWrapColumn;
		const minimapLayout = EditorLayoutInfoComputer._computeMinimapLayout({
			outerWidth,
			outerHeight,
			lineHeight,
			typicalHalfwidthCharacterWidth,
			pixelRatio,
			scrollBeyondLastLine,
			paddingTop: padding.top,
			paddingBottom: padding.bottom,
			minimap,
			verticalScrollbarWidth,
			viewLineCount,
			remainingWidth,
			isViewportWrapping
		}, env.memory || new ComputeOptionsMemory());
		if (minimapLayout.renderMinimap !== 0 && minimapLayout.minimapLeft === 0) {
			glyphMarginLeft += minimapLayout.minimapWidth;
			lineNumbersLeft += minimapLayout.minimapWidth;
			decorationsLeft += minimapLayout.minimapWidth;
			contentLeft += minimapLayout.minimapWidth;
		}
		const contentWidth = remainingWidth - minimapLayout.minimapWidth;
		const viewportColumn = Math.max(1, Math.floor((contentWidth - verticalScrollbarWidth - 2) / typicalHalfwidthCharacterWidth));
		const verticalArrowSize = verticalScrollbarHasArrows ? scrollbarArrowSize : 0;
		if (isViewportWrapping) {
			wrappingColumn = Math.max(1, viewportColumn - (wordWrapIndicator ? 1 : 0));
			if (wordWrap === "bounded") wrappingColumn = Math.min(wrappingColumn, wordWrapColumn);
		}
		return {
			width: outerWidth,
			height: outerHeight,
			glyphMarginLeft,
			glyphMarginWidth,
			glyphMarginDecorationLaneCount: env.glyphMarginDecorationLaneCount,
			lineNumbersLeft,
			lineNumbersWidth,
			decorationsLeft,
			decorationsWidth: lineDecorationsWidth,
			contentLeft,
			contentWidth,
			minimap: minimapLayout,
			viewportColumn,
			isWordWrapMinified,
			isViewportWrapping,
			wrappingColumn,
			verticalScrollbarWidth,
			horizontalScrollbarHeight,
			overviewRuler: {
				top: verticalArrowSize,
				width: verticalScrollbarWidth,
				height: outerHeight - 2 * verticalArrowSize,
				right: 0
			}
		};
	}
};
var WrappingStrategy = class extends BaseEditorOption {
	constructor() {
		super(156, "wrappingStrategy", "simple", { "editor.wrappingStrategy": {
			enumDescriptions: [localize(285, "Assumes that all characters are of the same width. This is a fast algorithm that works correctly for monospace fonts and certain scripts (like Latin characters) where glyphs are of equal width."), localize(286, "Delegates wrapping points computation to the browser. This is a slow algorithm, that might cause freezes for large files, but it works correctly in all cases.")],
			type: "string",
			enum: ["simple", "advanced"],
			default: "simple",
			description: localize(287, "Controls the algorithm that computes wrapping points. Note that when in accessibility mode, advanced will be used for the best experience.")
		} });
	}
	validate(input) {
		return stringSet(input, "simple", ["simple", "advanced"]);
	}
	compute(env, options, value) {
		if (options.get(2) === 2) return "advanced";
		return value;
	}
};
var ShowLightbulbIconMode;
(function(ShowLightbulbIconMode) {
	ShowLightbulbIconMode["Off"] = "off";
	ShowLightbulbIconMode["OnCode"] = "onCode";
	ShowLightbulbIconMode["On"] = "on";
})(ShowLightbulbIconMode || (ShowLightbulbIconMode = {}));
var EditorLightbulb = class extends BaseEditorOption {
	constructor() {
		const defaults = { enabled: ShowLightbulbIconMode.OnCode };
		super(73, "lightbulb", defaults, { "editor.lightbulb.enabled": {
			type: "string",
			enum: [
				ShowLightbulbIconMode.Off,
				ShowLightbulbIconMode.OnCode,
				ShowLightbulbIconMode.On
			],
			default: defaults.enabled,
			enumDescriptions: [
				localize(288, "Disable the code action menu."),
				localize(289, "Show the code action menu when the cursor is on lines with code."),
				localize(290, "Show the code action menu when the cursor is on lines with code or on empty lines.")
			],
			description: localize(291, "Enables the Code Action lightbulb in the editor.")
		} });
	}
	validate(_input) {
		if (!_input || typeof _input !== "object") return this.defaultValue;
		return { enabled: stringSet(_input.enabled, this.defaultValue.enabled, [
			ShowLightbulbIconMode.Off,
			ShowLightbulbIconMode.OnCode,
			ShowLightbulbIconMode.On
		]) };
	}
};
var EditorStickyScroll = class extends BaseEditorOption {
	constructor() {
		const defaults = {
			enabled: true,
			maxLineCount: 5,
			defaultModel: "outlineModel",
			scrollWithEditor: true
		};
		super(131, "stickyScroll", defaults, {
			"editor.stickyScroll.enabled": {
				type: "boolean",
				default: defaults.enabled,
				description: localize(292, "Shows the nested current scopes during the scroll at the top of the editor.")
			},
			"editor.stickyScroll.maxLineCount": {
				type: "number",
				default: defaults.maxLineCount,
				minimum: 1,
				maximum: 20,
				description: localize(293, "Defines the maximum number of sticky lines to show.")
			},
			"editor.stickyScroll.defaultModel": {
				type: "string",
				enum: [
					"outlineModel",
					"foldingProviderModel",
					"indentationModel"
				],
				default: defaults.defaultModel,
				description: localize(294, "Defines the model to use for determining which lines to stick. If the outline model does not exist, it will fall back on the folding provider model which falls back on the indentation model. This order is respected in all three cases.")
			},
			"editor.stickyScroll.scrollWithEditor": {
				type: "boolean",
				default: defaults.scrollWithEditor,
				description: localize(295, "Enable scrolling of Sticky Scroll with the editor's horizontal scrollbar.")
			}
		});
	}
	validate(_input) {
		if (!_input || typeof _input !== "object") return this.defaultValue;
		const input = _input;
		return {
			enabled: boolean(input.enabled, this.defaultValue.enabled),
			maxLineCount: EditorIntOption.clampedInt(input.maxLineCount, this.defaultValue.maxLineCount, 1, 20),
			defaultModel: stringSet(input.defaultModel, this.defaultValue.defaultModel, [
				"outlineModel",
				"foldingProviderModel",
				"indentationModel"
			]),
			scrollWithEditor: boolean(input.scrollWithEditor, this.defaultValue.scrollWithEditor)
		};
	}
};
var EditorInlayHints = class extends BaseEditorOption {
	constructor() {
		const defaults = {
			enabled: "on",
			fontSize: 0,
			fontFamily: "",
			padding: false,
			maximumLength: 43
		};
		super(159, "inlayHints", defaults, {
			"editor.inlayHints.enabled": {
				type: "string",
				default: defaults.enabled,
				description: localize(296, "Enables the inlay hints in the editor."),
				enum: [
					"on",
					"onUnlessPressed",
					"offUnlessPressed",
					"off"
				],
				markdownEnumDescriptions: [
					localize(297, "Inlay hints are enabled"),
					localize(298, "Inlay hints are showing by default and hide when holding {0}", isMacintosh ? `Ctrl+Option` : `Ctrl+Alt`),
					localize(299, "Inlay hints are hidden by default and show when holding {0}", isMacintosh ? `Ctrl+Option` : `Ctrl+Alt`),
					localize(300, "Inlay hints are disabled")
				]
			},
			"editor.inlayHints.fontSize": {
				type: "number",
				default: defaults.fontSize,
				markdownDescription: localize(301, "Controls font size of inlay hints in the editor. As default the {0} is used when the configured value is less than {1} or greater than the editor font size.", "`#editor.fontSize#`", "`5`")
			},
			"editor.inlayHints.fontFamily": {
				type: "string",
				default: defaults.fontFamily,
				markdownDescription: localize(302, "Controls font family of inlay hints in the editor. When set to empty, the {0} is used.", "`#editor.fontFamily#`")
			},
			"editor.inlayHints.padding": {
				type: "boolean",
				default: defaults.padding,
				description: localize(303, "Enables the padding around the inlay hints in the editor.")
			},
			"editor.inlayHints.maximumLength": {
				type: "number",
				default: defaults.maximumLength,
				markdownDescription: localize(304, "Maximum overall length of inlay hints, for a single line, before they get truncated by the editor. Set to `0` to never truncate")
			}
		});
	}
	validate(_input) {
		if (!_input || typeof _input !== "object") return this.defaultValue;
		const input = _input;
		if (typeof input.enabled === "boolean") input.enabled = input.enabled ? "on" : "off";
		return {
			enabled: stringSet(input.enabled, this.defaultValue.enabled, [
				"on",
				"off",
				"offUnlessPressed",
				"onUnlessPressed"
			]),
			fontSize: EditorIntOption.clampedInt(input.fontSize, this.defaultValue.fontSize, 0, 100),
			fontFamily: EditorStringOption.string(input.fontFamily, this.defaultValue.fontFamily),
			padding: boolean(input.padding, this.defaultValue.padding),
			maximumLength: EditorIntOption.clampedInt(input.maximumLength, this.defaultValue.maximumLength, 0, Number.MAX_SAFE_INTEGER)
		};
	}
};
var EditorLineDecorationsWidth = class extends BaseEditorOption {
	constructor() {
		super(74, "lineDecorationsWidth", 10);
	}
	validate(input) {
		if (typeof input === "string" && /^\d+(\.\d+)?ch$/.test(input)) return -parseFloat(input.substring(0, input.length - 2));
		else return EditorIntOption.clampedInt(input, this.defaultValue, 0, 1e3);
	}
	compute(env, options, value) {
		if (value < 0) return EditorIntOption.clampedInt(-value * env.fontInfo.typicalHalfwidthCharacterWidth, this.defaultValue, 0, 1e3);
		else return value;
	}
};
var EditorLineHeight = class extends EditorFloatOption {
	constructor() {
		super(75, "lineHeight", EDITOR_FONT_DEFAULTS.lineHeight, (x) => EditorFloatOption.clamp(x, 0, 150), { markdownDescription: localize(305, "Controls the line height. \n - Use 0 to automatically compute the line height from the font size.\n - Values between 0 and 8 will be used as a multiplier with the font size.\n - Values greater than or equal to 8 will be used as effective values.") }, 0, 150);
	}
	compute(env, options, value) {
		return env.fontInfo.lineHeight;
	}
};
var EditorMinimap = class extends BaseEditorOption {
	constructor() {
		const defaults = {
			enabled: true,
			size: "proportional",
			side: "right",
			showSlider: "mouseover",
			autohide: "none",
			renderCharacters: true,
			maxColumn: 120,
			scale: 1,
			showRegionSectionHeaders: true,
			showMarkSectionHeaders: true,
			markSectionHeaderRegex: "\\bMARK:\\s*(?<separator>-?)\\s*(?<label>.*)$",
			sectionHeaderFontSize: 9,
			sectionHeaderLetterSpacing: 1
		};
		super(81, "minimap", defaults, {
			"editor.minimap.enabled": {
				type: "boolean",
				default: defaults.enabled,
				description: localize(306, "Controls whether the minimap is shown.")
			},
			"editor.minimap.autohide": {
				type: "string",
				enum: [
					"none",
					"mouseover",
					"scroll"
				],
				enumDescriptions: [
					localize(307, "The minimap is always shown."),
					localize(308, "The minimap is hidden when mouse is not over the minimap and shown when mouse is over the minimap."),
					localize(309, "The minimap is only shown when the editor is scrolled")
				],
				default: defaults.autohide,
				description: localize(310, "Controls whether the minimap is hidden automatically.")
			},
			"editor.minimap.size": {
				type: "string",
				enum: [
					"proportional",
					"fill",
					"fit"
				],
				enumDescriptions: [
					localize(311, "The minimap has the same size as the editor contents (and might scroll)."),
					localize(312, "The minimap will stretch or shrink as necessary to fill the height of the editor (no scrolling)."),
					localize(313, "The minimap will shrink as necessary to never be larger than the editor (no scrolling).")
				],
				default: defaults.size,
				description: localize(314, "Controls the size of the minimap.")
			},
			"editor.minimap.side": {
				type: "string",
				enum: ["left", "right"],
				default: defaults.side,
				description: localize(315, "Controls the side where to render the minimap.")
			},
			"editor.minimap.showSlider": {
				type: "string",
				enum: ["always", "mouseover"],
				default: defaults.showSlider,
				description: localize(316, "Controls when the minimap slider is shown.")
			},
			"editor.minimap.scale": {
				type: "number",
				default: defaults.scale,
				minimum: 1,
				maximum: 3,
				enum: [
					1,
					2,
					3
				],
				description: localize(317, "Scale of content drawn in the minimap: 1, 2 or 3.")
			},
			"editor.minimap.renderCharacters": {
				type: "boolean",
				default: defaults.renderCharacters,
				description: localize(318, "Render the actual characters on a line as opposed to color blocks.")
			},
			"editor.minimap.maxColumn": {
				type: "number",
				default: defaults.maxColumn,
				description: localize(319, "Limit the width of the minimap to render at most a certain number of columns.")
			},
			"editor.minimap.showRegionSectionHeaders": {
				type: "boolean",
				default: defaults.showRegionSectionHeaders,
				description: localize(320, "Controls whether named regions are shown as section headers in the minimap.")
			},
			"editor.minimap.showMarkSectionHeaders": {
				type: "boolean",
				default: defaults.showMarkSectionHeaders,
				description: localize(321, "Controls whether MARK: comments are shown as section headers in the minimap.")
			},
			"editor.minimap.markSectionHeaderRegex": {
				type: "string",
				default: defaults.markSectionHeaderRegex,
				description: localize(322, "Defines the regular expression used to find section headers in comments. The regex must contain a named match group `label` (written as `(?<label>.+)`) that encapsulates the section header, otherwise it will not work. Optionally you can include another match group named `separator`. Use \\n in the pattern to match multi-line headers.")
			},
			"editor.minimap.sectionHeaderFontSize": {
				type: "number",
				default: defaults.sectionHeaderFontSize,
				description: localize(323, "Controls the font size of section headers in the minimap.")
			},
			"editor.minimap.sectionHeaderLetterSpacing": {
				type: "number",
				default: defaults.sectionHeaderLetterSpacing,
				description: localize(324, "Controls the amount of space (in pixels) between characters of section header. This helps the readability of the header in small font sizes.")
			}
		});
	}
	validate(_input) {
		if (!_input || typeof _input !== "object") return this.defaultValue;
		const input = _input;
		let markSectionHeaderRegex = this.defaultValue.markSectionHeaderRegex;
		const inputRegex = input.markSectionHeaderRegex;
		if (typeof inputRegex === "string") try {
			new RegExp(inputRegex, "d");
			markSectionHeaderRegex = inputRegex;
		} catch {}
		return {
			enabled: boolean(input.enabled, this.defaultValue.enabled),
			autohide: stringSet(input.autohide, this.defaultValue.autohide, [
				"none",
				"mouseover",
				"scroll"
			]),
			size: stringSet(input.size, this.defaultValue.size, [
				"proportional",
				"fill",
				"fit"
			]),
			side: stringSet(input.side, this.defaultValue.side, ["right", "left"]),
			showSlider: stringSet(input.showSlider, this.defaultValue.showSlider, ["always", "mouseover"]),
			renderCharacters: boolean(input.renderCharacters, this.defaultValue.renderCharacters),
			scale: EditorIntOption.clampedInt(input.scale, 1, 1, 3),
			maxColumn: EditorIntOption.clampedInt(input.maxColumn, this.defaultValue.maxColumn, 1, 1e4),
			showRegionSectionHeaders: boolean(input.showRegionSectionHeaders, this.defaultValue.showRegionSectionHeaders),
			showMarkSectionHeaders: boolean(input.showMarkSectionHeaders, this.defaultValue.showMarkSectionHeaders),
			markSectionHeaderRegex,
			sectionHeaderFontSize: EditorFloatOption.clamp(EditorFloatOption.float(input.sectionHeaderFontSize, this.defaultValue.sectionHeaderFontSize), 4, 32),
			sectionHeaderLetterSpacing: EditorFloatOption.clamp(EditorFloatOption.float(input.sectionHeaderLetterSpacing, this.defaultValue.sectionHeaderLetterSpacing), 0, 5)
		};
	}
};
function _multiCursorModifierFromString(multiCursorModifier) {
	if (multiCursorModifier === "ctrlCmd") return isMacintosh ? "metaKey" : "ctrlKey";
	return "altKey";
}
var EditorPadding = class extends BaseEditorOption {
	constructor() {
		super(96, "padding", {
			top: 0,
			bottom: 0
		}, {
			"editor.padding.top": {
				type: "number",
				default: 0,
				minimum: 0,
				maximum: 1e3,
				description: localize(325, "Controls the amount of space between the top edge of the editor and the first line.")
			},
			"editor.padding.bottom": {
				type: "number",
				default: 0,
				minimum: 0,
				maximum: 1e3,
				description: localize(326, "Controls the amount of space between the bottom edge of the editor and the last line.")
			}
		});
	}
	validate(_input) {
		if (!_input || typeof _input !== "object") return this.defaultValue;
		const input = _input;
		return {
			top: EditorIntOption.clampedInt(input.top, 0, 0, 1e3),
			bottom: EditorIntOption.clampedInt(input.bottom, 0, 0, 1e3)
		};
	}
};
var EditorParameterHints = class extends BaseEditorOption {
	constructor() {
		const defaults = {
			enabled: true,
			cycle: true
		};
		super(98, "parameterHints", defaults, {
			"editor.parameterHints.enabled": {
				type: "boolean",
				default: defaults.enabled,
				description: localize(327, "Enables a pop-up that shows parameter documentation and type information as you type.")
			},
			"editor.parameterHints.cycle": {
				type: "boolean",
				default: defaults.cycle,
				description: localize(328, "Controls whether the parameter hints menu cycles or closes when reaching the end of the list.")
			}
		});
	}
	validate(_input) {
		if (!_input || typeof _input !== "object") return this.defaultValue;
		const input = _input;
		return {
			enabled: boolean(input.enabled, this.defaultValue.enabled),
			cycle: boolean(input.cycle, this.defaultValue.cycle)
		};
	}
};
var EditorPixelRatio = class extends ComputedEditorOption {
	constructor() {
		super(164, 1);
	}
	compute(env, options, _) {
		return env.pixelRatio;
	}
};
var PlaceholderOption = class extends BaseEditorOption {
	constructor() {
		super(100, "placeholder", void 0);
	}
	validate(input) {
		if (typeof input === "undefined") return this.defaultValue;
		if (typeof input === "string") return input;
		return this.defaultValue;
	}
};
var EditorQuickSuggestions = class extends BaseEditorOption {
	constructor() {
		const defaults = {
			other: "offWhenInlineCompletions",
			comments: "off",
			strings: "off"
		};
		const types = [{ type: "boolean" }, {
			type: "string",
			enum: [
				"on",
				"inline",
				"off",
				"offWhenInlineCompletions"
			],
			enumDescriptions: [
				localize(329, "Quick suggestions show inside the suggest widget"),
				localize(330, "Quick suggestions show as ghost text"),
				localize(331, "Quick suggestions are disabled"),
				localize(332, "Quick suggestions are disabled when inline completions are showing")
			]
		}];
		super(102, "quickSuggestions", defaults, {
			anyOf: [
				{ type: "boolean" },
				{
					type: "string",
					enum: [
						"on",
						"inline",
						"off",
						"offWhenInlineCompletions"
					],
					enumDescriptions: [
						localize(333, "Quick suggestions are enabled for all token types"),
						localize(334, "Quick suggestions show as ghost text for all token types"),
						localize(335, "Quick suggestions are disabled for all token types"),
						localize(336, "Quick suggestions are disabled for all token types when inline completions are showing")
					]
				},
				{
					type: "object",
					additionalProperties: false,
					properties: {
						strings: {
							anyOf: types,
							default: defaults.strings,
							description: localize(337, "Enable quick suggestions inside strings.")
						},
						comments: {
							anyOf: types,
							default: defaults.comments,
							description: localize(338, "Enable quick suggestions inside comments.")
						},
						other: {
							anyOf: types,
							default: defaults.other,
							description: localize(339, "Enable quick suggestions outside of strings and comments.")
						}
					}
				}
			],
			default: defaults,
			markdownDescription: localize(340, "Controls whether suggestions should automatically show up while typing. This can be controlled for typing in comments, strings, and other code. Quick suggestion can be configured to show as ghost text or with the suggest widget. Also be aware of the {0}-setting which controls if suggestions are triggered by special characters.", "`#editor.suggestOnTriggerCharacters#`"),
			experiment: { mode: "auto" }
		});
		this.defaultValue = defaults;
	}
	validate(input) {
		if (typeof input === "boolean") {
			const value = input ? "on" : "off";
			return {
				comments: value,
				strings: value,
				other: value
			};
		}
		if (typeof input === "string") {
			const validated = stringSet(input, this.defaultValue.other, [
				"on",
				"inline",
				"off",
				"offWhenInlineCompletions"
			]);
			return {
				comments: validated,
				strings: validated,
				other: validated
			};
		}
		if (!input || typeof input !== "object") return this.defaultValue;
		const { other, comments, strings } = input;
		const allowedValues = [
			"on",
			"inline",
			"off",
			"offWhenInlineCompletions"
		];
		let validatedOther;
		let validatedComments;
		let validatedStrings;
		if (typeof other === "boolean") validatedOther = other ? "on" : "off";
		else validatedOther = stringSet(other, this.defaultValue.other, allowedValues);
		if (typeof comments === "boolean") validatedComments = comments ? "on" : "off";
		else validatedComments = stringSet(comments, this.defaultValue.comments, allowedValues);
		if (typeof strings === "boolean") validatedStrings = strings ? "on" : "off";
		else validatedStrings = stringSet(strings, this.defaultValue.strings, allowedValues);
		return {
			other: validatedOther,
			comments: validatedComments,
			strings: validatedStrings
		};
	}
};
var EditorRenderLineNumbersOption = class extends BaseEditorOption {
	constructor() {
		super(76, "lineNumbers", {
			renderType: 1,
			renderFn: null
		}, {
			type: "string",
			enum: [
				"off",
				"on",
				"relative",
				"interval"
			],
			enumDescriptions: [
				localize(341, "Line numbers are not rendered."),
				localize(342, "Line numbers are rendered as absolute number."),
				localize(343, "Line numbers are rendered as distance in lines to cursor position."),
				localize(344, "Line numbers are rendered every 10 lines.")
			],
			default: "on",
			description: localize(345, "Controls the display of line numbers.")
		});
	}
	validate(lineNumbers) {
		let renderType = this.defaultValue.renderType;
		let renderFn = this.defaultValue.renderFn;
		if (typeof lineNumbers !== "undefined") {
			if (typeof lineNumbers === "function") {
				renderType = 4;
				renderFn = lineNumbers;
			} else if (lineNumbers === "interval") renderType = 3;
			else if (lineNumbers === "relative") renderType = 2;
			else if (lineNumbers === "on") renderType = 1;
			else renderType = 0;
		}
		return {
			renderType,
			renderFn
		};
	}
};
/**
* @internal
*/
function filterValidationDecorations(options) {
	const renderValidationDecorations = options.get(112);
	if (renderValidationDecorations === "editable") return options.get(104);
	return renderValidationDecorations === "on" ? false : true;
}
/**
* @internal
*/
function filterFontDecorations(options) {
	return !options.get(173);
}
var EditorRulers = class extends BaseEditorOption {
	constructor() {
		const defaults = [];
		const columnSchema = {
			type: "number",
			description: localize(346, "Number of monospace characters at which this editor ruler will render.")
		};
		super(116, "rulers", defaults, {
			type: "array",
			items: { anyOf: [columnSchema, {
				type: ["object"],
				properties: {
					column: columnSchema,
					color: {
						type: "string",
						description: localize(347, "Color of this editor ruler."),
						format: "color-hex"
					}
				}
			}] },
			default: defaults,
			description: localize(348, "Render vertical rulers after a certain number of monospace characters. Use multiple values for multiple rulers. No rulers are drawn if array is empty.")
		});
	}
	validate(input) {
		if (Array.isArray(input)) {
			const rulers = [];
			for (const _element of input) if (typeof _element === "number") rulers.push({
				column: EditorIntOption.clampedInt(_element, 0, 0, 1e4),
				color: null
			});
			else if (_element && typeof _element === "object") {
				const element = _element;
				rulers.push({
					column: EditorIntOption.clampedInt(element.column, 0, 0, 1e4),
					color: element.color
				});
			}
			rulers.sort((a, b) => a.column - b.column);
			return rulers;
		}
		return this.defaultValue;
	}
};
/**
* Configuration options for readonly message
*/
var ReadonlyMessage = class extends BaseEditorOption {
	constructor() {
		super(105, "readOnlyMessage", void 0);
	}
	validate(_input) {
		if (!_input || typeof _input !== "object") return this.defaultValue;
		return _input;
	}
};
function _scrollbarVisibilityFromString(visibility, defaultValue) {
	if (typeof visibility !== "string") return defaultValue;
	switch (visibility) {
		case "hidden": return 2;
		case "visible": return 3;
		default: return 1;
	}
}
var EditorScrollbar$1 = class extends BaseEditorOption {
	constructor() {
		const defaults = {
			vertical: 1,
			horizontal: 1,
			arrowSize: 11,
			useShadows: true,
			verticalHasArrows: false,
			horizontalHasArrows: false,
			horizontalScrollbarSize: 12,
			horizontalSliderSize: 12,
			verticalScrollbarSize: 14,
			verticalSliderSize: 14,
			handleMouseWheel: true,
			alwaysConsumeMouseWheel: true,
			scrollByPage: false,
			ignoreHorizontalScrollbarInContentHeight: false
		};
		super(117, "scrollbar", defaults, {
			"editor.scrollbar.vertical": {
				type: "string",
				enum: [
					"auto",
					"visible",
					"hidden"
				],
				enumDescriptions: [
					localize(349, "The vertical scrollbar will be visible only when necessary."),
					localize(350, "The vertical scrollbar will always be visible."),
					localize(351, "The vertical scrollbar will always be hidden.")
				],
				default: "auto",
				description: localize(352, "Controls the visibility of the vertical scrollbar.")
			},
			"editor.scrollbar.horizontal": {
				type: "string",
				enum: [
					"auto",
					"visible",
					"hidden"
				],
				enumDescriptions: [
					localize(353, "The horizontal scrollbar will be visible only when necessary."),
					localize(354, "The horizontal scrollbar will always be visible."),
					localize(355, "The horizontal scrollbar will always be hidden.")
				],
				default: "auto",
				description: localize(356, "Controls the visibility of the horizontal scrollbar.")
			},
			"editor.scrollbar.verticalScrollbarSize": {
				type: "number",
				default: defaults.verticalScrollbarSize,
				description: localize(357, "The width of the vertical scrollbar.")
			},
			"editor.scrollbar.horizontalScrollbarSize": {
				type: "number",
				default: defaults.horizontalScrollbarSize,
				description: localize(358, "The height of the horizontal scrollbar.")
			},
			"editor.scrollbar.scrollByPage": {
				type: "boolean",
				default: defaults.scrollByPage,
				description: localize(359, "Controls whether clicks scroll by page or jump to click position.")
			},
			"editor.scrollbar.ignoreHorizontalScrollbarInContentHeight": {
				type: "boolean",
				default: defaults.ignoreHorizontalScrollbarInContentHeight,
				description: localize(360, "When set, the horizontal scrollbar will not increase the size of the editor's content.")
			}
		});
	}
	validate(_input) {
		if (!_input || typeof _input !== "object") return this.defaultValue;
		const input = _input;
		const horizontalScrollbarSize = EditorIntOption.clampedInt(input.horizontalScrollbarSize, this.defaultValue.horizontalScrollbarSize, 0, 1e3);
		const verticalScrollbarSize = EditorIntOption.clampedInt(input.verticalScrollbarSize, this.defaultValue.verticalScrollbarSize, 0, 1e3);
		return {
			arrowSize: EditorIntOption.clampedInt(input.arrowSize, this.defaultValue.arrowSize, 0, 1e3),
			vertical: _scrollbarVisibilityFromString(input.vertical, this.defaultValue.vertical),
			horizontal: _scrollbarVisibilityFromString(input.horizontal, this.defaultValue.horizontal),
			useShadows: boolean(input.useShadows, this.defaultValue.useShadows),
			verticalHasArrows: boolean(input.verticalHasArrows, this.defaultValue.verticalHasArrows),
			horizontalHasArrows: boolean(input.horizontalHasArrows, this.defaultValue.horizontalHasArrows),
			handleMouseWheel: boolean(input.handleMouseWheel, this.defaultValue.handleMouseWheel),
			alwaysConsumeMouseWheel: boolean(input.alwaysConsumeMouseWheel, this.defaultValue.alwaysConsumeMouseWheel),
			horizontalScrollbarSize,
			horizontalSliderSize: EditorIntOption.clampedInt(input.horizontalSliderSize, horizontalScrollbarSize, 0, 1e3),
			verticalScrollbarSize,
			verticalSliderSize: EditorIntOption.clampedInt(input.verticalSliderSize, verticalScrollbarSize, 0, 1e3),
			scrollByPage: boolean(input.scrollByPage, this.defaultValue.scrollByPage),
			ignoreHorizontalScrollbarInContentHeight: boolean(input.ignoreHorizontalScrollbarInContentHeight, this.defaultValue.ignoreHorizontalScrollbarInContentHeight)
		};
	}
};
/**
* @internal
*/
var inUntrustedWorkspace = "inUntrustedWorkspace";
/**
* @internal
*/
var unicodeHighlightConfigKeys = {
	allowedCharacters: "editor.unicodeHighlight.allowedCharacters",
	invisibleCharacters: "editor.unicodeHighlight.invisibleCharacters",
	nonBasicASCII: "editor.unicodeHighlight.nonBasicASCII",
	ambiguousCharacters: "editor.unicodeHighlight.ambiguousCharacters",
	includeComments: "editor.unicodeHighlight.includeComments",
	includeStrings: "editor.unicodeHighlight.includeStrings",
	allowedLocales: "editor.unicodeHighlight.allowedLocales"
};
var UnicodeHighlight = class extends BaseEditorOption {
	constructor() {
		const defaults = {
			nonBasicASCII: inUntrustedWorkspace,
			invisibleCharacters: true,
			ambiguousCharacters: true,
			includeComments: inUntrustedWorkspace,
			includeStrings: true,
			allowedCharacters: {},
			allowedLocales: {
				_os: true,
				_vscode: true
			}
		};
		super(142, "unicodeHighlight", defaults, {
			[unicodeHighlightConfigKeys.nonBasicASCII]: {
				restricted: true,
				type: ["boolean", "string"],
				enum: [
					true,
					false,
					inUntrustedWorkspace
				],
				default: defaults.nonBasicASCII,
				description: localize(361, "Controls whether all non-basic ASCII characters are highlighted. Only characters between U+0020 and U+007E, tab, line-feed and carriage-return are considered basic ASCII.")
			},
			[unicodeHighlightConfigKeys.invisibleCharacters]: {
				restricted: true,
				type: "boolean",
				default: defaults.invisibleCharacters,
				description: localize(362, "Controls whether characters that just reserve space or have no width at all are highlighted.")
			},
			[unicodeHighlightConfigKeys.ambiguousCharacters]: {
				restricted: true,
				type: "boolean",
				default: defaults.ambiguousCharacters,
				description: localize(363, "Controls whether characters are highlighted that can be confused with basic ASCII characters, except those that are common in the current user locale.")
			},
			[unicodeHighlightConfigKeys.includeComments]: {
				restricted: true,
				type: ["boolean", "string"],
				enum: [
					true,
					false,
					inUntrustedWorkspace
				],
				default: defaults.includeComments,
				description: localize(364, "Controls whether characters in comments should also be subject to Unicode highlighting.")
			},
			[unicodeHighlightConfigKeys.includeStrings]: {
				restricted: true,
				type: ["boolean", "string"],
				enum: [
					true,
					false,
					inUntrustedWorkspace
				],
				default: defaults.includeStrings,
				description: localize(365, "Controls whether characters in strings should also be subject to Unicode highlighting.")
			},
			[unicodeHighlightConfigKeys.allowedCharacters]: {
				restricted: true,
				type: "object",
				default: defaults.allowedCharacters,
				description: localize(366, "Defines allowed characters that are not being highlighted."),
				additionalProperties: { type: "boolean" }
			},
			[unicodeHighlightConfigKeys.allowedLocales]: {
				restricted: true,
				type: "object",
				additionalProperties: { type: "boolean" },
				default: defaults.allowedLocales,
				description: localize(367, "Unicode characters that are common in allowed locales are not being highlighted.")
			}
		});
	}
	applyUpdate(value, update) {
		let didChange = false;
		if (update.allowedCharacters && value) {
			if (!equals$2(value.allowedCharacters, update.allowedCharacters)) {
				value = {
					...value,
					allowedCharacters: update.allowedCharacters
				};
				didChange = true;
			}
		}
		if (update.allowedLocales && value) {
			if (!equals$2(value.allowedLocales, update.allowedLocales)) {
				value = {
					...value,
					allowedLocales: update.allowedLocales
				};
				didChange = true;
			}
		}
		const result = super.applyUpdate(value, update);
		if (didChange) return new ApplyUpdateResult(result.newValue, true);
		return result;
	}
	validate(_input) {
		if (!_input || typeof _input !== "object") return this.defaultValue;
		const input = _input;
		return {
			nonBasicASCII: primitiveSet(input.nonBasicASCII, inUntrustedWorkspace, [
				true,
				false,
				inUntrustedWorkspace
			]),
			invisibleCharacters: boolean(input.invisibleCharacters, this.defaultValue.invisibleCharacters),
			ambiguousCharacters: boolean(input.ambiguousCharacters, this.defaultValue.ambiguousCharacters),
			includeComments: primitiveSet(input.includeComments, inUntrustedWorkspace, [
				true,
				false,
				inUntrustedWorkspace
			]),
			includeStrings: primitiveSet(input.includeStrings, inUntrustedWorkspace, [
				true,
				false,
				inUntrustedWorkspace
			]),
			allowedCharacters: this.validateBooleanMap(input.allowedCharacters, this.defaultValue.allowedCharacters),
			allowedLocales: this.validateBooleanMap(input.allowedLocales, this.defaultValue.allowedLocales)
		};
	}
	validateBooleanMap(map, defaultValue) {
		if (typeof map !== "object" || !map) return defaultValue;
		const result = {};
		for (const [key, value] of Object.entries(map)) if (value === true) result[key] = true;
		return result;
	}
};
/**
* Configuration options for inline suggestions
*/
var InlineEditorSuggest = class extends BaseEditorOption {
	constructor() {
		const defaults = {
			enabled: true,
			mode: "subwordSmart",
			showToolbar: "onHover",
			suppressSuggestions: false,
			keepOnBlur: false,
			fontFamily: "default",
			syntaxHighlightingEnabled: true,
			minShowDelay: 0,
			suppressInSnippetMode: true,
			edits: {
				enabled: true,
				showCollapsed: false,
				renderSideBySide: "auto",
				allowCodeShifting: "always",
				showLongDistanceHint: true,
				longDistanceHintContextLineCount: 0
			},
			triggerCommandOnProviderChange: false,
			experimental: {
				suppressInlineSuggestions: "",
				showOnSuggestConflict: "never",
				emptyResponseInformation: true
			}
		};
		super(71, "inlineSuggest", defaults, {
			"editor.inlineSuggest.enabled": {
				type: "boolean",
				default: defaults.enabled,
				description: localize(368, "Controls whether to automatically show inline suggestions in the editor.")
			},
			"editor.inlineSuggest.showToolbar": {
				type: "string",
				default: defaults.showToolbar,
				enum: [
					"always",
					"onHover",
					"never"
				],
				enumDescriptions: [
					localize(369, "Show the inline suggestion toolbar whenever an inline suggestion is shown."),
					localize(370, "Show the inline suggestion toolbar when hovering over an inline suggestion."),
					localize(371, "Never show the inline suggestion toolbar.")
				],
				description: localize(372, "Controls when to show the inline suggestion toolbar.")
			},
			"editor.inlineSuggest.syntaxHighlightingEnabled": {
				type: "boolean",
				default: defaults.syntaxHighlightingEnabled,
				description: localize(373, "Controls whether to show syntax highlighting for inline suggestions in the editor.")
			},
			"editor.inlineSuggest.suppressSuggestions": {
				type: "boolean",
				default: defaults.suppressSuggestions,
				description: localize(374, "Controls how inline suggestions interact with the suggest widget. If enabled, the suggest widget is not shown automatically when inline suggestions are available.")
			},
			"editor.inlineSuggest.suppressInSnippetMode": {
				type: "boolean",
				default: defaults.suppressInSnippetMode,
				description: localize(375, "Controls whether inline suggestions are suppressed when in snippet mode.")
			},
			"editor.inlineSuggest.minShowDelay": {
				type: "number",
				default: 0,
				minimum: 0,
				maximum: 1e4,
				description: localize(376, "Controls the minimal delay in milliseconds after which inline suggestions are shown after typing.")
			},
			"editor.inlineSuggest.experimental.suppressInlineSuggestions": {
				type: "string",
				default: defaults.experimental.suppressInlineSuggestions,
				tags: ["experimental"],
				description: localize(377, "Suppresses inline completions for specified extension IDs -- comma separated."),
				experiment: { mode: "auto" }
			},
			"editor.inlineSuggest.experimental.emptyResponseInformation": {
				type: "boolean",
				default: defaults.experimental.emptyResponseInformation,
				tags: ["experimental"],
				description: localize(378, "Controls whether to send request information from the inline suggestion provider."),
				experiment: { mode: "auto" }
			},
			"editor.inlineSuggest.triggerCommandOnProviderChange": {
				type: "boolean",
				default: defaults.triggerCommandOnProviderChange,
				tags: ["experimental"],
				description: localize(379, "Controls whether to trigger a command when the inline suggestion provider changes."),
				experiment: { mode: "auto" }
			},
			"editor.inlineSuggest.experimental.showOnSuggestConflict": {
				type: "string",
				default: defaults.experimental.showOnSuggestConflict,
				tags: ["experimental"],
				enum: [
					"always",
					"never",
					"whenSuggestListIsIncomplete"
				],
				description: localize(380, "Controls whether to show inline suggestions when there is a suggest conflict."),
				experiment: { mode: "auto" }
			},
			"editor.inlineSuggest.fontFamily": {
				type: "string",
				default: defaults.fontFamily,
				description: localize(381, "Controls the font family of the inline suggestions.")
			},
			"editor.inlineSuggest.edits.allowCodeShifting": {
				type: "string",
				default: defaults.edits.allowCodeShifting,
				description: localize(382, "Controls whether showing a suggestion will shift the code to make space for the suggestion inline."),
				enum: [
					"always",
					"horizontal",
					"never"
				],
				tags: ["nextEditSuggestions"]
			},
			"editor.inlineSuggest.edits.showLongDistanceHint": {
				type: "boolean",
				default: defaults.edits.showLongDistanceHint,
				description: localize(383, "Controls whether long distance inline suggestions are shown."),
				tags: ["nextEditSuggestions", "experimental"]
			},
			"editor.inlineSuggest.edits.longDistanceHintContextLineCount": {
				type: "number",
				default: defaults.edits.longDistanceHintContextLineCount,
				minimum: 0,
				maximum: 10,
				description: localize(384, "Controls how many lines of surrounding context are shown above and below the target line in the long distance inline suggestion preview. Set to 0 to only show the target line."),
				tags: ["nextEditSuggestions", "experimental"],
				experiment: { mode: "auto" }
			},
			"editor.inlineSuggest.edits.renderSideBySide": {
				type: "string",
				default: defaults.edits.renderSideBySide,
				description: localize(385, "Controls whether larger suggestions can be shown side by side."),
				enum: ["auto", "never"],
				enumDescriptions: [localize(386, "Larger suggestions will show side by side if there is enough space, otherwise they will be shown below."), localize(387, "Larger suggestions are never shown side by side and will always be shown below.")],
				tags: ["nextEditSuggestions"]
			},
			"editor.inlineSuggest.edits.showCollapsed": {
				type: "boolean",
				default: defaults.edits.showCollapsed,
				description: localize(388, "Controls whether the suggestion will show as collapsed until jumping to it."),
				tags: ["nextEditSuggestions"]
			}
		});
	}
	validate(_input) {
		if (!_input || typeof _input !== "object") return this.defaultValue;
		const input = _input;
		return {
			enabled: boolean(input.enabled, this.defaultValue.enabled),
			mode: stringSet(input.mode, this.defaultValue.mode, [
				"prefix",
				"subword",
				"subwordSmart"
			]),
			showToolbar: stringSet(input.showToolbar, this.defaultValue.showToolbar, [
				"always",
				"onHover",
				"never"
			]),
			suppressSuggestions: boolean(input.suppressSuggestions, this.defaultValue.suppressSuggestions),
			keepOnBlur: boolean(input.keepOnBlur, this.defaultValue.keepOnBlur),
			fontFamily: EditorStringOption.string(input.fontFamily, this.defaultValue.fontFamily),
			syntaxHighlightingEnabled: boolean(input.syntaxHighlightingEnabled, this.defaultValue.syntaxHighlightingEnabled),
			minShowDelay: EditorIntOption.clampedInt(input.minShowDelay, 0, 0, 1e4),
			suppressInSnippetMode: boolean(input.suppressInSnippetMode, this.defaultValue.suppressInSnippetMode),
			edits: this._validateEdits(input.edits),
			triggerCommandOnProviderChange: boolean(input.triggerCommandOnProviderChange, this.defaultValue.triggerCommandOnProviderChange),
			experimental: this._validateExperimental(input.experimental)
		};
	}
	_validateEdits(_input) {
		if (!_input || typeof _input !== "object") return this.defaultValue.edits;
		const input = _input;
		return {
			enabled: boolean(input.enabled, this.defaultValue.edits.enabled),
			showCollapsed: boolean(input.showCollapsed, this.defaultValue.edits.showCollapsed),
			allowCodeShifting: stringSet(input.allowCodeShifting, this.defaultValue.edits.allowCodeShifting, [
				"always",
				"horizontal",
				"never"
			]),
			showLongDistanceHint: boolean(input.showLongDistanceHint, this.defaultValue.edits.showLongDistanceHint),
			longDistanceHintContextLineCount: EditorIntOption.clampedInt(input.longDistanceHintContextLineCount, this.defaultValue.edits.longDistanceHintContextLineCount, 0, 10),
			renderSideBySide: stringSet(input.renderSideBySide, this.defaultValue.edits.renderSideBySide, ["never", "auto"])
		};
	}
	_validateExperimental(_input) {
		if (!_input || typeof _input !== "object") return this.defaultValue.experimental;
		const input = _input;
		return {
			suppressInlineSuggestions: EditorStringOption.string(input.suppressInlineSuggestions, this.defaultValue.experimental.suppressInlineSuggestions),
			showOnSuggestConflict: stringSet(input.showOnSuggestConflict, this.defaultValue.experimental.showOnSuggestConflict, [
				"always",
				"never",
				"whenSuggestListIsIncomplete"
			]),
			emptyResponseInformation: boolean(input.emptyResponseInformation, this.defaultValue.experimental.emptyResponseInformation)
		};
	}
};
/**
* Configuration options for inline suggestions
*/
var BracketPairColorization = class extends BaseEditorOption {
	constructor() {
		const defaults = {
			enabled: EDITOR_MODEL_DEFAULTS.bracketPairColorizationOptions.enabled,
			independentColorPoolPerBracketType: EDITOR_MODEL_DEFAULTS.bracketPairColorizationOptions.independentColorPoolPerBracketType
		};
		super(21, "bracketPairColorization", defaults, {
			"editor.bracketPairColorization.enabled": {
				type: "boolean",
				default: defaults.enabled,
				markdownDescription: localize(389, "Controls whether bracket pair colorization is enabled or not. Use {0} to override the bracket highlight colors.", "`#workbench.colorCustomizations#`")
			},
			"editor.bracketPairColorization.independentColorPoolPerBracketType": {
				type: "boolean",
				default: defaults.independentColorPoolPerBracketType,
				description: localize(390, "Controls whether each bracket type has its own independent color pool.")
			}
		});
	}
	validate(_input) {
		if (!_input || typeof _input !== "object") return this.defaultValue;
		const input = _input;
		return {
			enabled: boolean(input.enabled, this.defaultValue.enabled),
			independentColorPoolPerBracketType: boolean(input.independentColorPoolPerBracketType, this.defaultValue.independentColorPoolPerBracketType)
		};
	}
};
/**
* Configuration options for inline suggestions
*/
var GuideOptions = class extends BaseEditorOption {
	constructor() {
		const defaults = {
			bracketPairs: false,
			bracketPairsHorizontal: "active",
			highlightActiveBracketPair: true,
			indentation: true,
			highlightActiveIndentation: true
		};
		super(22, "guides", defaults, {
			"editor.guides.bracketPairs": {
				type: ["boolean", "string"],
				enum: [
					true,
					"active",
					false
				],
				enumDescriptions: [
					localize(391, "Enables bracket pair guides."),
					localize(392, "Enables bracket pair guides only for the active bracket pair."),
					localize(393, "Disables bracket pair guides.")
				],
				default: defaults.bracketPairs,
				description: localize(394, "Controls whether bracket pair guides are enabled or not.")
			},
			"editor.guides.bracketPairsHorizontal": {
				type: ["boolean", "string"],
				enum: [
					true,
					"active",
					false
				],
				enumDescriptions: [
					localize(395, "Enables horizontal guides as addition to vertical bracket pair guides."),
					localize(396, "Enables horizontal guides only for the active bracket pair."),
					localize(397, "Disables horizontal bracket pair guides.")
				],
				default: defaults.bracketPairsHorizontal,
				description: localize(398, "Controls whether horizontal bracket pair guides are enabled or not.")
			},
			"editor.guides.highlightActiveBracketPair": {
				type: "boolean",
				default: defaults.highlightActiveBracketPair,
				description: localize(399, "Controls whether the editor should highlight the active bracket pair.")
			},
			"editor.guides.indentation": {
				type: "boolean",
				default: defaults.indentation,
				description: localize(400, "Controls whether the editor should render indent guides.")
			},
			"editor.guides.highlightActiveIndentation": {
				type: ["boolean", "string"],
				enum: [
					true,
					"always",
					false
				],
				enumDescriptions: [
					localize(401, "Highlights the active indent guide."),
					localize(402, "Highlights the active indent guide even if bracket guides are highlighted."),
					localize(403, "Do not highlight the active indent guide.")
				],
				default: defaults.highlightActiveIndentation,
				description: localize(404, "Controls whether the editor should highlight the active indent guide.")
			}
		});
	}
	validate(_input) {
		if (!_input || typeof _input !== "object") return this.defaultValue;
		const input = _input;
		return {
			bracketPairs: primitiveSet(input.bracketPairs, this.defaultValue.bracketPairs, [
				true,
				false,
				"active"
			]),
			bracketPairsHorizontal: primitiveSet(input.bracketPairsHorizontal, this.defaultValue.bracketPairsHorizontal, [
				true,
				false,
				"active"
			]),
			highlightActiveBracketPair: boolean(input.highlightActiveBracketPair, this.defaultValue.highlightActiveBracketPair),
			indentation: boolean(input.indentation, this.defaultValue.indentation),
			highlightActiveIndentation: primitiveSet(input.highlightActiveIndentation, this.defaultValue.highlightActiveIndentation, [
				true,
				false,
				"always"
			])
		};
	}
};
function primitiveSet(value, defaultValue, allowedValues) {
	const idx = allowedValues.indexOf(value);
	if (idx === -1) return defaultValue;
	return allowedValues[idx];
}
var EditorSuggest = class extends BaseEditorOption {
	constructor() {
		const defaults = {
			insertMode: "insert",
			filterGraceful: true,
			snippetsPreventQuickSuggestions: false,
			localityBonus: false,
			shareSuggestSelections: false,
			selectionMode: "always",
			showIcons: true,
			showStatusBar: false,
			preview: false,
			previewMode: "subwordSmart",
			showInlineDetails: true,
			fitWidthToDetails: false,
			showMethods: true,
			showFunctions: true,
			showConstructors: true,
			showDeprecated: true,
			matchOnWordStartOnly: true,
			showFields: true,
			showVariables: true,
			showClasses: true,
			showStructs: true,
			showInterfaces: true,
			showModules: true,
			showProperties: true,
			showEvents: true,
			showOperators: true,
			showUnits: true,
			showValues: true,
			showConstants: true,
			showEnums: true,
			showEnumMembers: true,
			showKeywords: true,
			showWords: true,
			showColors: true,
			showFiles: true,
			showReferences: true,
			showFolders: true,
			showTypeParameters: true,
			showSnippets: true,
			showUsers: true,
			showIssues: true
		};
		super(134, "suggest", defaults, {
			"editor.suggest.insertMode": {
				type: "string",
				enum: ["insert", "replace"],
				enumDescriptions: [localize(405, "Insert suggestion without overwriting text right of the cursor."), localize(406, "Insert suggestion and overwrite text right of the cursor.")],
				default: defaults.insertMode,
				description: localize(407, "Controls whether words are overwritten when accepting completions. Note that this depends on extensions opting into this feature.")
			},
			"editor.suggest.filterGraceful": {
				type: "boolean",
				default: defaults.filterGraceful,
				description: localize(408, "Controls whether filtering and sorting suggestions accounts for small typos.")
			},
			"editor.suggest.localityBonus": {
				type: "boolean",
				default: defaults.localityBonus,
				description: localize(409, "Controls whether sorting favors words that appear close to the cursor.")
			},
			"editor.suggest.shareSuggestSelections": {
				type: "boolean",
				default: defaults.shareSuggestSelections,
				markdownDescription: localize(410, "Controls whether remembered suggestion selections are shared between multiple workspaces and windows (needs `#editor.suggestSelection#`).")
			},
			"editor.suggest.selectionMode": {
				type: "string",
				enum: [
					"always",
					"never",
					"whenTriggerCharacter",
					"whenQuickSuggestion"
				],
				enumDescriptions: [
					localize(411, "Always select a suggestion when automatically triggering IntelliSense."),
					localize(412, "Never select a suggestion when automatically triggering IntelliSense."),
					localize(413, "Select a suggestion only when triggering IntelliSense from a trigger character."),
					localize(414, "Select a suggestion only when triggering IntelliSense as you type.")
				],
				default: defaults.selectionMode,
				markdownDescription: localize(415, "Controls whether a suggestion is selected when the widget shows. Note that this only applies to automatically triggered suggestions ({0} and {1}) and that a suggestion is always selected when explicitly invoked, e.g via `Ctrl+Space`.", "`#editor.quickSuggestions#`", "`#editor.suggestOnTriggerCharacters#`")
			},
			"editor.suggest.snippetsPreventQuickSuggestions": {
				type: "boolean",
				default: defaults.snippetsPreventQuickSuggestions,
				description: localize(416, "Controls whether an active snippet prevents quick suggestions.")
			},
			"editor.suggest.showIcons": {
				type: "boolean",
				default: defaults.showIcons,
				description: localize(417, "Controls whether to show or hide icons in suggestions.")
			},
			"editor.suggest.showStatusBar": {
				type: "boolean",
				default: defaults.showStatusBar,
				description: localize(418, "Controls the visibility of the status bar at the bottom of the suggest widget.")
			},
			"editor.suggest.preview": {
				type: "boolean",
				default: defaults.preview,
				description: localize(419, "Controls whether to preview the suggestion outcome in the editor.")
			},
			"editor.suggest.showInlineDetails": {
				type: "boolean",
				default: defaults.showInlineDetails,
				description: localize(420, "Controls whether suggest details show inline with the label or only in the details widget.")
			},
			"editor.suggest.filteredTypes": {
				type: "object",
				deprecationMessage: localize(421, "This setting is deprecated, please use separate settings like 'editor.suggest.showKeywords' or 'editor.suggest.showSnippets' instead.")
			},
			"editor.suggest.showMethods": {
				type: "boolean",
				default: true,
				markdownDescription: localize(422, "When enabled IntelliSense shows `method`-suggestions.")
			},
			"editor.suggest.showFunctions": {
				type: "boolean",
				default: true,
				markdownDescription: localize(423, "When enabled IntelliSense shows `function`-suggestions.")
			},
			"editor.suggest.showConstructors": {
				type: "boolean",
				default: true,
				markdownDescription: localize(424, "When enabled IntelliSense shows `constructor`-suggestions.")
			},
			"editor.suggest.showDeprecated": {
				type: "boolean",
				default: true,
				markdownDescription: localize(425, "When enabled IntelliSense shows `deprecated`-suggestions.")
			},
			"editor.suggest.matchOnWordStartOnly": {
				type: "boolean",
				default: true,
				markdownDescription: localize(426, "When enabled IntelliSense filtering requires that the first character matches on a word start. For example, `c` on `Console` or `WebContext` but _not_ on `description`. When disabled IntelliSense will show more results but still sorts them by match quality.")
			},
			"editor.suggest.showFields": {
				type: "boolean",
				default: true,
				markdownDescription: localize(427, "When enabled IntelliSense shows `field`-suggestions.")
			},
			"editor.suggest.showVariables": {
				type: "boolean",
				default: true,
				markdownDescription: localize(428, "When enabled IntelliSense shows `variable`-suggestions.")
			},
			"editor.suggest.showClasses": {
				type: "boolean",
				default: true,
				markdownDescription: localize(429, "When enabled IntelliSense shows `class`-suggestions.")
			},
			"editor.suggest.showStructs": {
				type: "boolean",
				default: true,
				markdownDescription: localize(430, "When enabled IntelliSense shows `struct`-suggestions.")
			},
			"editor.suggest.showInterfaces": {
				type: "boolean",
				default: true,
				markdownDescription: localize(431, "When enabled IntelliSense shows `interface`-suggestions.")
			},
			"editor.suggest.showModules": {
				type: "boolean",
				default: true,
				markdownDescription: localize(432, "When enabled IntelliSense shows `module`-suggestions.")
			},
			"editor.suggest.showProperties": {
				type: "boolean",
				default: true,
				markdownDescription: localize(433, "When enabled IntelliSense shows `property`-suggestions.")
			},
			"editor.suggest.showEvents": {
				type: "boolean",
				default: true,
				markdownDescription: localize(434, "When enabled IntelliSense shows `event`-suggestions.")
			},
			"editor.suggest.showOperators": {
				type: "boolean",
				default: true,
				markdownDescription: localize(435, "When enabled IntelliSense shows `operator`-suggestions.")
			},
			"editor.suggest.showUnits": {
				type: "boolean",
				default: true,
				markdownDescription: localize(436, "When enabled IntelliSense shows `unit`-suggestions.")
			},
			"editor.suggest.showValues": {
				type: "boolean",
				default: true,
				markdownDescription: localize(437, "When enabled IntelliSense shows `value`-suggestions.")
			},
			"editor.suggest.showConstants": {
				type: "boolean",
				default: true,
				markdownDescription: localize(438, "When enabled IntelliSense shows `constant`-suggestions.")
			},
			"editor.suggest.showEnums": {
				type: "boolean",
				default: true,
				markdownDescription: localize(439, "When enabled IntelliSense shows `enum`-suggestions.")
			},
			"editor.suggest.showEnumMembers": {
				type: "boolean",
				default: true,
				markdownDescription: localize(440, "When enabled IntelliSense shows `enumMember`-suggestions.")
			},
			"editor.suggest.showKeywords": {
				type: "boolean",
				default: true,
				markdownDescription: localize(441, "When enabled IntelliSense shows `keyword`-suggestions.")
			},
			"editor.suggest.showWords": {
				type: "boolean",
				default: true,
				markdownDescription: localize(442, "When enabled IntelliSense shows `text`-suggestions.")
			},
			"editor.suggest.showColors": {
				type: "boolean",
				default: true,
				markdownDescription: localize(443, "When enabled IntelliSense shows `color`-suggestions.")
			},
			"editor.suggest.showFiles": {
				type: "boolean",
				default: true,
				markdownDescription: localize(444, "When enabled IntelliSense shows `file`-suggestions.")
			},
			"editor.suggest.showReferences": {
				type: "boolean",
				default: true,
				markdownDescription: localize(445, "When enabled IntelliSense shows `reference`-suggestions.")
			},
			"editor.suggest.showCustomcolors": {
				type: "boolean",
				default: true,
				markdownDescription: localize(446, "When enabled IntelliSense shows `customcolor`-suggestions.")
			},
			"editor.suggest.showFolders": {
				type: "boolean",
				default: true,
				markdownDescription: localize(447, "When enabled IntelliSense shows `folder`-suggestions.")
			},
			"editor.suggest.showTypeParameters": {
				type: "boolean",
				default: true,
				markdownDescription: localize(448, "When enabled IntelliSense shows `typeParameter`-suggestions.")
			},
			"editor.suggest.showSnippets": {
				type: "boolean",
				default: true,
				markdownDescription: localize(449, "When enabled IntelliSense shows `snippet`-suggestions.")
			},
			"editor.suggest.showUsers": {
				type: "boolean",
				default: true,
				markdownDescription: localize(450, "When enabled IntelliSense shows `user`-suggestions.")
			},
			"editor.suggest.showIssues": {
				type: "boolean",
				default: true,
				markdownDescription: localize(451, "When enabled IntelliSense shows `issues`-suggestions.")
			}
		});
	}
	validate(_input) {
		if (!_input || typeof _input !== "object") return this.defaultValue;
		const input = _input;
		return {
			insertMode: stringSet(input.insertMode, this.defaultValue.insertMode, ["insert", "replace"]),
			filterGraceful: boolean(input.filterGraceful, this.defaultValue.filterGraceful),
			snippetsPreventQuickSuggestions: boolean(input.snippetsPreventQuickSuggestions, this.defaultValue.filterGraceful),
			localityBonus: boolean(input.localityBonus, this.defaultValue.localityBonus),
			shareSuggestSelections: boolean(input.shareSuggestSelections, this.defaultValue.shareSuggestSelections),
			selectionMode: stringSet(input.selectionMode, this.defaultValue.selectionMode, [
				"always",
				"never",
				"whenQuickSuggestion",
				"whenTriggerCharacter"
			]),
			showIcons: boolean(input.showIcons, this.defaultValue.showIcons),
			showStatusBar: boolean(input.showStatusBar, this.defaultValue.showStatusBar),
			preview: boolean(input.preview, this.defaultValue.preview),
			previewMode: stringSet(input.previewMode, this.defaultValue.previewMode, [
				"prefix",
				"subword",
				"subwordSmart"
			]),
			showInlineDetails: boolean(input.showInlineDetails, this.defaultValue.showInlineDetails),
			fitWidthToDetails: boolean(input.fitWidthToDetails, this.defaultValue.fitWidthToDetails),
			showMethods: boolean(input.showMethods, this.defaultValue.showMethods),
			showFunctions: boolean(input.showFunctions, this.defaultValue.showFunctions),
			showConstructors: boolean(input.showConstructors, this.defaultValue.showConstructors),
			showDeprecated: boolean(input.showDeprecated, this.defaultValue.showDeprecated),
			matchOnWordStartOnly: boolean(input.matchOnWordStartOnly, this.defaultValue.matchOnWordStartOnly),
			showFields: boolean(input.showFields, this.defaultValue.showFields),
			showVariables: boolean(input.showVariables, this.defaultValue.showVariables),
			showClasses: boolean(input.showClasses, this.defaultValue.showClasses),
			showStructs: boolean(input.showStructs, this.defaultValue.showStructs),
			showInterfaces: boolean(input.showInterfaces, this.defaultValue.showInterfaces),
			showModules: boolean(input.showModules, this.defaultValue.showModules),
			showProperties: boolean(input.showProperties, this.defaultValue.showProperties),
			showEvents: boolean(input.showEvents, this.defaultValue.showEvents),
			showOperators: boolean(input.showOperators, this.defaultValue.showOperators),
			showUnits: boolean(input.showUnits, this.defaultValue.showUnits),
			showValues: boolean(input.showValues, this.defaultValue.showValues),
			showConstants: boolean(input.showConstants, this.defaultValue.showConstants),
			showEnums: boolean(input.showEnums, this.defaultValue.showEnums),
			showEnumMembers: boolean(input.showEnumMembers, this.defaultValue.showEnumMembers),
			showKeywords: boolean(input.showKeywords, this.defaultValue.showKeywords),
			showWords: boolean(input.showWords, this.defaultValue.showWords),
			showColors: boolean(input.showColors, this.defaultValue.showColors),
			showFiles: boolean(input.showFiles, this.defaultValue.showFiles),
			showReferences: boolean(input.showReferences, this.defaultValue.showReferences),
			showFolders: boolean(input.showFolders, this.defaultValue.showFolders),
			showTypeParameters: boolean(input.showTypeParameters, this.defaultValue.showTypeParameters),
			showSnippets: boolean(input.showSnippets, this.defaultValue.showSnippets),
			showUsers: boolean(input.showUsers, this.defaultValue.showUsers),
			showIssues: boolean(input.showIssues, this.defaultValue.showIssues)
		};
	}
};
var SmartSelect = class extends BaseEditorOption {
	constructor() {
		super(129, "smartSelect", {
			selectLeadingAndTrailingWhitespace: true,
			selectSubwords: true
		}, {
			"editor.smartSelect.selectLeadingAndTrailingWhitespace": {
				description: localize(452, "Whether leading and trailing whitespace should always be selected."),
				default: true,
				type: "boolean"
			},
			"editor.smartSelect.selectSubwords": {
				description: localize(453, "Whether subwords (like 'foo' in 'fooBar' or 'foo_bar') should be selected."),
				default: true,
				type: "boolean"
			}
		});
	}
	validate(input) {
		if (!input || typeof input !== "object") return this.defaultValue;
		return {
			selectLeadingAndTrailingWhitespace: boolean(input.selectLeadingAndTrailingWhitespace, this.defaultValue.selectLeadingAndTrailingWhitespace),
			selectSubwords: boolean(input.selectSubwords, this.defaultValue.selectSubwords)
		};
	}
};
/**
* Locales used for segmenting lines into words when doing word related navigations or operations.
*
* Specify the BCP 47 language tag of the word you wish to recognize (e.g., ja, zh-CN, zh-Hant-TW, etc.).
*/
var WordSegmenterLocales = class extends BaseEditorOption {
	constructor() {
		const defaults = [];
		super(147, "wordSegmenterLocales", defaults, {
			anyOf: [{ type: "string" }, {
				type: "array",
				items: { type: "string" }
			}],
			description: localize(454, "Locales to be used for word segmentation when doing word related navigations or operations. Specify the BCP 47 language tag of the word you wish to recognize (e.g., ja, zh-CN, zh-Hant-TW, etc.)."),
			type: "array",
			items: { type: "string" },
			default: defaults
		});
	}
	validate(input) {
		if (typeof input === "string") input = [input];
		if (Array.isArray(input)) {
			const validLocales = [];
			for (const locale of input) if (typeof locale === "string") try {
				if (Intl.Segmenter.supportedLocalesOf(locale).length > 0) validLocales.push(locale);
			} catch {}
			return validLocales;
		}
		return this.defaultValue;
	}
};
var WrappingIndentOption = class extends BaseEditorOption {
	constructor() {
		super(155, "wrappingIndent", 1, { "editor.wrappingIndent": {
			type: "string",
			enum: [
				"none",
				"same",
				"indent",
				"deepIndent"
			],
			enumDescriptions: [
				localize(455, "No indentation. Wrapped lines begin at column 1."),
				localize(456, "Wrapped lines get the same indentation as the parent."),
				localize(457, "Wrapped lines get +1 indentation toward the parent."),
				localize(458, "Wrapped lines get +2 indentation toward the parent.")
			],
			description: localize(459, "Controls the indentation of wrapped lines."),
			default: "same"
		} });
	}
	validate(input) {
		switch (input) {
			case "none": return 0;
			case "same": return 1;
			case "indent": return 2;
			case "deepIndent": return 3;
		}
		return 1;
	}
	compute(env, options, value) {
		if (options.get(2) === 2) return 0;
		return value;
	}
};
var EditorWrappingInfoComputer = class extends ComputedEditorOption {
	constructor() {
		super(167, {
			isDominatedByLongLines: false,
			isWordWrapMinified: false,
			isViewportWrapping: false,
			wrappingColumn: -1
		});
	}
	compute(env, options, _) {
		const layoutInfo = options.get(166);
		return {
			isDominatedByLongLines: env.isDominatedByLongLines,
			isWordWrapMinified: layoutInfo.isWordWrapMinified,
			isViewportWrapping: layoutInfo.isViewportWrapping,
			wrappingColumn: layoutInfo.wrappingColumn
		};
	}
};
var EditorDropIntoEditor = class extends BaseEditorOption {
	constructor() {
		const defaults = {
			enabled: true,
			showDropSelector: "afterDrop"
		};
		super(43, "dropIntoEditor", defaults, {
			"editor.dropIntoEditor.enabled": {
				type: "boolean",
				default: defaults.enabled,
				markdownDescription: localize(460, "Controls whether you can drag and drop a file into a text editor by holding down the `Shift` key (instead of opening the file in an editor).")
			},
			"editor.dropIntoEditor.showDropSelector": {
				type: "string",
				markdownDescription: localize(461, "Controls if a widget is shown when dropping files into the editor. This widget lets you control how the file is dropped."),
				enum: ["afterDrop", "never"],
				enumDescriptions: [localize(462, "Show the drop selector widget after a file is dropped into the editor."), localize(463, "Never show the drop selector widget. Instead the default drop provider is always used.")],
				default: "afterDrop"
			}
		});
	}
	validate(_input) {
		if (!_input || typeof _input !== "object") return this.defaultValue;
		const input = _input;
		return {
			enabled: boolean(input.enabled, this.defaultValue.enabled),
			showDropSelector: stringSet(input.showDropSelector, this.defaultValue.showDropSelector, ["afterDrop", "never"])
		};
	}
};
var EditorPasteAs = class extends BaseEditorOption {
	constructor() {
		const defaults = {
			enabled: true,
			showPasteSelector: "afterPaste"
		};
		super(97, "pasteAs", defaults, {
			"editor.pasteAs.enabled": {
				type: "boolean",
				default: defaults.enabled,
				markdownDescription: localize(464, "Controls whether you can paste content in different ways.")
			},
			"editor.pasteAs.showPasteSelector": {
				type: "string",
				markdownDescription: localize(465, "Controls if a widget is shown when pasting content in to the editor. This widget lets you control how the file is pasted."),
				enum: ["afterPaste", "never"],
				enumDescriptions: [localize(466, "Show the paste selector widget after content is pasted into the editor."), localize(467, "Never show the paste selector widget. Instead the default pasting behavior is always used.")],
				default: "afterPaste"
			}
		});
	}
	validate(_input) {
		if (!_input || typeof _input !== "object") return this.defaultValue;
		const input = _input;
		return {
			enabled: boolean(input.enabled, this.defaultValue.enabled),
			showPasteSelector: stringSet(input.showPasteSelector, this.defaultValue.showPasteSelector, ["afterPaste", "never"])
		};
	}
};
/**
* @internal
*/
var editorOptionsRegistry = [];
function register$1(option) {
	editorOptionsRegistry[option.id] = option;
	return option;
}
var EditorOptions = {
	acceptSuggestionOnCommitCharacter: register$1(new EditorBooleanOption(0, "acceptSuggestionOnCommitCharacter", true, { markdownDescription: localize(468, "Controls whether suggestions should be accepted on commit characters. For example, in JavaScript, the semi-colon (`;`) can be a commit character that accepts a suggestion and types that character.") })),
	acceptSuggestionOnEnter: register$1(new EditorStringEnumOption(1, "acceptSuggestionOnEnter", "on", [
		"on",
		"smart",
		"off"
	], {
		markdownEnumDescriptions: [
			"",
			localize(469, "Only accept a suggestion with `Enter` when it makes a textual change."),
			""
		],
		markdownDescription: localize(470, "Controls whether suggestions should be accepted on `Enter`, in addition to `Tab`. Helps to avoid ambiguity between inserting new lines or accepting suggestions.")
	})),
	accessibilitySupport: register$1(new EditorAccessibilitySupport()),
	accessibilityPageSize: register$1(new EditorIntOption(3, "accessibilityPageSize", 500, 1, 1073741824, {
		description: localize(471, "Controls the number of lines in the editor that can be read out by a screen reader at once. When we detect a screen reader we automatically set the default to be 500. Warning: this has a performance implication for numbers larger than the default."),
		tags: ["accessibility"]
	})),
	allowOverflow: register$1(new EditorBooleanOption(4, "allowOverflow", true)),
	allowVariableLineHeights: register$1(new EditorBooleanOption(5, "allowVariableLineHeights", true, { description: localize(472, "Controls whether to allow using variable line heights in the editor.") })),
	allowVariableFonts: register$1(new EditorBooleanOption(6, "allowVariableFonts", true, { description: localize(473, "Controls whether to allow using variable fonts in the editor.") })),
	allowVariableFontsInAccessibilityMode: register$1(new EditorBooleanOption(7, "allowVariableFontsInAccessibilityMode", false, {
		description: localize(474, "Controls whether to allow using variable fonts in the editor in the accessibility mode."),
		tags: ["accessibility"]
	})),
	ariaLabel: register$1(new EditorStringOption(8, "ariaLabel", localize(475, "Editor content"))),
	ariaRequired: register$1(new EditorBooleanOption(9, "ariaRequired", false, void 0)),
	screenReaderAnnounceInlineSuggestion: register$1(new EditorBooleanOption(12, "screenReaderAnnounceInlineSuggestion", true, {
		description: localize(476, "Control whether inline suggestions are announced by a screen reader."),
		tags: ["accessibility"]
	})),
	autoClosingBrackets: register$1(new EditorStringEnumOption(10, "autoClosingBrackets", "languageDefined", [
		"always",
		"languageDefined",
		"beforeWhitespace",
		"never"
	], {
		enumDescriptions: [
			"",
			localize(477, "Use language configurations to determine when to autoclose brackets."),
			localize(478, "Autoclose brackets only when the cursor is to the left of whitespace."),
			""
		],
		description: localize(479, "Controls whether the editor should automatically close brackets after the user adds an opening bracket.")
	})),
	autoClosingComments: register$1(new EditorStringEnumOption(11, "autoClosingComments", "languageDefined", [
		"always",
		"languageDefined",
		"beforeWhitespace",
		"never"
	], {
		enumDescriptions: [
			"",
			localize(480, "Use language configurations to determine when to autoclose comments."),
			localize(481, "Autoclose comments only when the cursor is to the left of whitespace."),
			""
		],
		description: localize(482, "Controls whether the editor should automatically close comments after the user adds an opening comment.")
	})),
	autoClosingDelete: register$1(new EditorStringEnumOption(13, "autoClosingDelete", "auto", [
		"always",
		"auto",
		"never"
	], {
		enumDescriptions: [
			"",
			localize(483, "Remove adjacent closing quotes or brackets only if they were automatically inserted."),
			""
		],
		description: localize(484, "Controls whether the editor should remove adjacent closing quotes or brackets when deleting.")
	})),
	autoClosingOvertype: register$1(new EditorStringEnumOption(14, "autoClosingOvertype", "auto", [
		"always",
		"auto",
		"never"
	], {
		enumDescriptions: [
			"",
			localize(485, "Type over closing quotes or brackets only if they were automatically inserted."),
			""
		],
		description: localize(486, "Controls whether the editor should type over closing quotes or brackets.")
	})),
	autoClosingQuotes: register$1(new EditorStringEnumOption(15, "autoClosingQuotes", "languageDefined", [
		"always",
		"languageDefined",
		"beforeWhitespace",
		"never"
	], {
		enumDescriptions: [
			"",
			localize(487, "Use language configurations to determine when to autoclose quotes."),
			localize(488, "Autoclose quotes only when the cursor is to the left of whitespace."),
			""
		],
		description: localize(489, "Controls whether the editor should automatically close quotes after the user adds an opening quote.")
	})),
	autoIndent: register$1(new EditorEnumOption(16, "autoIndent", 4, "full", [
		"none",
		"keep",
		"brackets",
		"advanced",
		"full"
	], _autoIndentFromString, {
		enumDescriptions: [
			localize(490, "The editor will not insert indentation automatically."),
			localize(491, "The editor will keep the current line's indentation."),
			localize(492, "The editor will keep the current line's indentation and honor language defined brackets."),
			localize(493, "The editor will keep the current line's indentation, honor language defined brackets and invoke special onEnterRules defined by languages."),
			localize(494, "The editor will keep the current line's indentation, honor language defined brackets, invoke special onEnterRules defined by languages, and honor indentationRules defined by languages.")
		],
		description: localize(495, "Controls whether the editor should automatically adjust the indentation when users type, paste, move or indent lines.")
	})),
	autoIndentOnPaste: register$1(new EditorBooleanOption(17, "autoIndentOnPaste", false, { description: localize(496, "Controls whether the editor should automatically auto-indent the pasted content.") })),
	autoIndentOnPasteWithinString: register$1(new EditorBooleanOption(18, "autoIndentOnPasteWithinString", true, { description: localize(497, "Controls whether the editor should automatically auto-indent the pasted content when pasted within a string. This takes effect when autoIndentOnPaste is true.") })),
	automaticLayout: register$1(new EditorBooleanOption(19, "automaticLayout", false)),
	autoSurround: register$1(new EditorStringEnumOption(20, "autoSurround", "languageDefined", [
		"languageDefined",
		"quotes",
		"brackets",
		"never"
	], {
		enumDescriptions: [
			localize(498, "Use language configurations to determine when to automatically surround selections."),
			localize(499, "Surround with quotes but not brackets."),
			localize(500, "Surround with brackets but not quotes."),
			""
		],
		description: localize(501, "Controls whether the editor should automatically surround selections when typing quotes or brackets.")
	})),
	bracketPairColorization: register$1(new BracketPairColorization()),
	bracketPairGuides: register$1(new GuideOptions()),
	stickyTabStops: register$1(new EditorBooleanOption(132, "stickyTabStops", false, { description: localize(502, "Emulate selection behavior of tab characters when using spaces for indentation. Selection will stick to tab stops.") })),
	codeLens: register$1(new EditorBooleanOption(23, "codeLens", true, { description: localize(503, "Controls whether the editor shows CodeLens.") })),
	codeLensFontFamily: register$1(new EditorStringOption(24, "codeLensFontFamily", "", { description: localize(504, "Controls the font family for CodeLens.") })),
	codeLensFontSize: register$1(new EditorIntOption(25, "codeLensFontSize", 0, 0, 100, {
		type: "number",
		default: 0,
		minimum: 0,
		maximum: 100,
		markdownDescription: localize(505, "Controls the font size in pixels for CodeLens. When set to 0, 90% of `#editor.fontSize#` is used.")
	})),
	colorDecorators: register$1(new EditorBooleanOption(26, "colorDecorators", true, { description: localize(506, "Controls whether the editor should render the inline color decorators and color picker.") })),
	colorDecoratorActivatedOn: register$1(new EditorStringEnumOption(169, "colorDecoratorsActivatedOn", "clickAndHover", [
		"clickAndHover",
		"hover",
		"click"
	], {
		enumDescriptions: [
			localize(507, "Make the color picker appear both on click and hover of the color decorator"),
			localize(508, "Make the color picker appear on hover of the color decorator"),
			localize(509, "Make the color picker appear on click of the color decorator")
		],
		description: localize(510, "Controls the condition to make a color picker appear from a color decorator.")
	})),
	colorDecoratorsLimit: register$1(new EditorIntOption(27, "colorDecoratorsLimit", 500, 1, 1e6, { markdownDescription: localize(511, "Controls the max number of color decorators that can be rendered in an editor at once.") })),
	columnSelection: register$1(new EditorBooleanOption(28, "columnSelection", false, { description: localize(512, "Enable that the selection with the mouse and keys is doing column selection.") })),
	comments: register$1(new EditorComments()),
	contextmenu: register$1(new EditorBooleanOption(30, "contextmenu", true)),
	copyWithSyntaxHighlighting: register$1(new EditorBooleanOption(31, "copyWithSyntaxHighlighting", true, { description: localize(513, "Controls whether syntax highlighting should be copied into the clipboard.") })),
	cursorBlinking: register$1(new EditorEnumOption(32, "cursorBlinking", 1, "blink", [
		"blink",
		"smooth",
		"phase",
		"expand",
		"solid"
	], cursorBlinkingStyleFromString, { description: localize(514, "Control the cursor animation style.") })),
	cursorSmoothCaretAnimation: register$1(new EditorStringEnumOption(33, "cursorSmoothCaretAnimation", "off", [
		"off",
		"explicit",
		"on"
	], {
		enumDescriptions: [
			localize(515, "Smooth caret animation is disabled."),
			localize(516, "Smooth caret animation is enabled only when the user moves the cursor with an explicit gesture."),
			localize(517, "Smooth caret animation is always enabled.")
		],
		description: localize(518, "Controls whether the smooth caret animation should be enabled.")
	})),
	cursorStyle: register$1(new EditorEnumOption(34, "cursorStyle", TextEditorCursorStyle.Line, "line", [
		"line",
		"block",
		"underline",
		"line-thin",
		"block-outline",
		"underline-thin"
	], cursorStyleFromString, { description: localize(519, "Controls the cursor style in insert input mode.") })),
	overtypeCursorStyle: register$1(new EditorEnumOption(92, "overtypeCursorStyle", TextEditorCursorStyle.Block, "block", [
		"line",
		"block",
		"underline",
		"line-thin",
		"block-outline",
		"underline-thin"
	], cursorStyleFromString, { description: localize(520, "Controls the cursor style in overtype input mode.") })),
	cursorSurroundingLines: register$1(new EditorIntOption(35, "cursorSurroundingLines", 0, 0, 1073741824, { description: localize(521, "Controls the minimal number of visible leading lines (minimum 0) and trailing lines (minimum 1) surrounding the cursor. Known as 'scrollOff' or 'scrollOffset' in some other editors.") })),
	cursorSurroundingLinesStyle: register$1(new EditorStringEnumOption(36, "cursorSurroundingLinesStyle", "default", ["default", "all"], {
		enumDescriptions: [localize(522, "`cursorSurroundingLines` is enforced only when triggered via the keyboard or API."), localize(523, "`cursorSurroundingLines` is enforced always.")],
		markdownDescription: localize(524, "Controls when `#editor.cursorSurroundingLines#` should be enforced.")
	})),
	cursorWidth: register$1(new EditorIntOption(37, "cursorWidth", 0, 0, 1073741824, { markdownDescription: localize(525, "Controls the width of the cursor when `#editor.cursorStyle#` is set to `line`.") })),
	cursorHeight: register$1(new EditorIntOption(38, "cursorHeight", 0, 0, 1073741824, { markdownDescription: localize(526, "Controls the height of the cursor when `#editor.cursorStyle#` is set to `line`. Cursor's max height depends on line height.") })),
	disableLayerHinting: register$1(new EditorBooleanOption(39, "disableLayerHinting", false)),
	disableMonospaceOptimizations: register$1(new EditorBooleanOption(40, "disableMonospaceOptimizations", false)),
	domReadOnly: register$1(new EditorBooleanOption(41, "domReadOnly", false)),
	doubleClickSelectsBlock: register$1(new EditorBooleanOption(174, "doubleClickSelectsBlock", true, { description: localize(527, "Controls whether double-clicking next to a bracket or quote selects the content inside.") })),
	dragAndDrop: register$1(new EditorBooleanOption(42, "dragAndDrop", true, { description: localize(528, "Controls whether the editor should allow moving selections via drag and drop.") })),
	emptySelectionClipboard: register$1(new EditorEmptySelectionClipboard()),
	dropIntoEditor: register$1(new EditorDropIntoEditor()),
	editContext: register$1(new EditorBooleanOption(44, "editContext", true, {
		description: localize(529, "Sets whether the EditContext API should be used instead of the text area to power input in the editor."),
		included: isChrome$1 || isEdge || isNative
	})),
	renderRichScreenReaderContent: register$1(new EditorBooleanOption(107, "renderRichScreenReaderContent", false, { markdownDescription: localize(530, "Whether to render rich screen reader content when the `#editor.editContext#` setting is enabled.") })),
	stickyScroll: register$1(new EditorStickyScroll()),
	experimentalGpuAcceleration: register$1(new EditorStringEnumOption(46, "experimentalGpuAcceleration", "off", ["off", "on"], {
		tags: ["experimental"],
		enumDescriptions: [localize(531, "Use regular DOM-based rendering."), localize(532, "Use GPU acceleration.")],
		description: localize(533, "Controls whether to use the experimental GPU acceleration to render the editor.")
	})),
	experimentalWhitespaceRendering: register$1(new EditorStringEnumOption(47, "experimentalWhitespaceRendering", "svg", [
		"svg",
		"font",
		"off"
	], {
		enumDescriptions: [
			localize(534, "Use a new rendering method with svgs."),
			localize(535, "Use a new rendering method with font characters."),
			localize(536, "Use the stable rendering method.")
		],
		description: localize(537, "Controls whether whitespace is rendered with a new, experimental method.")
	})),
	extraEditorClassName: register$1(new EditorStringOption(48, "extraEditorClassName", "")),
	fastScrollSensitivity: register$1(new EditorFloatOption(49, "fastScrollSensitivity", 5, (x) => x <= 0 ? 5 : x, { markdownDescription: localize(538, "Scrolling speed multiplier when pressing `Alt`.") })),
	find: register$1(new EditorFind()),
	fixedOverflowWidgets: register$1(new EditorBooleanOption(51, "fixedOverflowWidgets", false)),
	folding: register$1(new EditorBooleanOption(52, "folding", true, { description: localize(539, "Controls whether the editor has code folding enabled.") })),
	foldingStrategy: register$1(new EditorStringEnumOption(53, "foldingStrategy", "auto", ["auto", "indentation"], {
		enumDescriptions: [localize(540, "Use a language-specific folding strategy if available, else the indentation-based one."), localize(541, "Use the indentation-based folding strategy.")],
		description: localize(542, "Controls the strategy for computing folding ranges.")
	})),
	foldingHighlight: register$1(new EditorBooleanOption(54, "foldingHighlight", true, { description: localize(543, "Controls whether the editor should highlight folded ranges.") })),
	foldingImportsByDefault: register$1(new EditorBooleanOption(55, "foldingImportsByDefault", false, { description: localize(544, "Controls whether the editor automatically collapses import ranges.") })),
	foldingMaximumRegions: register$1(new EditorIntOption(56, "foldingMaximumRegions", 5e3, 10, 65e3, { description: localize(545, "The maximum number of foldable regions. Increasing this value may result in the editor becoming less responsive when the current source has a large number of foldable regions.") })),
	unfoldOnClickAfterEndOfLine: register$1(new EditorBooleanOption(57, "unfoldOnClickAfterEndOfLine", false, { description: localize(546, "Controls whether clicking on the empty content after a folded line will unfold the line.") })),
	fontFamily: register$1(new EditorStringOption(58, "fontFamily", EDITOR_FONT_DEFAULTS.fontFamily, { description: localize(547, "Controls the font family.") })),
	fontInfo: register$1(new EditorFontInfo()),
	fontLigatures2: register$1(new EditorFontLigatures()),
	fontSize: register$1(new EditorFontSize()),
	fontWeight: register$1(new EditorFontWeight()),
	fontVariations: register$1(new EditorFontVariations()),
	formatOnPaste: register$1(new EditorBooleanOption(64, "formatOnPaste", false, { description: localize(548, "Controls whether the editor should automatically format the pasted content. A formatter must be available and the formatter should be able to format a range in a document.") })),
	formatOnType: register$1(new EditorBooleanOption(65, "formatOnType", false, { description: localize(549, "Controls whether the editor should automatically format the line after typing.") })),
	fullwidthCharacterWidth: register$1(new EditorStringEnumOption(175, "fullwidthCharacterWidth", "font", ["font", "twoCells"], {
		enumDescriptions: [localize(550, "Render full-width characters using the width defined by the font."), localize(551, "Render full-width characters centered in exactly two character cells. Only applies to monospace fonts. Does not apply to multi codepoint full-width characters or to GPU rendering. This has a performance impact on line rendering.")],
		description: localize(552, "Controls the width used to render full-width characters.")
	})),
	glyphMargin: register$1(new EditorBooleanOption(66, "glyphMargin", true, { description: localize(553, "Controls whether the editor should render the vertical glyph margin. Glyph margin is mostly used for debugging.") })),
	gotoLocation: register$1(new EditorGoToLocation()),
	hideCursorInOverviewRuler: register$1(new EditorBooleanOption(68, "hideCursorInOverviewRuler", false, { description: localize(554, "Controls whether the cursor should be hidden in the overview ruler.") })),
	hover: register$1(new EditorHover()),
	inDiffEditor: register$1(new EditorBooleanOption(70, "inDiffEditor", false)),
	inertialScroll: register$1(new EditorBooleanOption(158, "inertialScroll", false, { description: localize(555, "Make scrolling inertial - mostly useful with touchpad on linux.") })),
	letterSpacing: register$1(new EditorFloatOption(72, "letterSpacing", EDITOR_FONT_DEFAULTS.letterSpacing, (x) => EditorFloatOption.clamp(x, -5, 20), { description: localize(556, "Controls the letter spacing in pixels.") })),
	lightbulb: register$1(new EditorLightbulb()),
	lineDecorationsWidth: register$1(new EditorLineDecorationsWidth()),
	lineHeight: register$1(new EditorLineHeight()),
	lineNumbers: register$1(new EditorRenderLineNumbersOption()),
	lineNumbersMinChars: register$1(new EditorIntOption(77, "lineNumbersMinChars", 5, 1, 300)),
	linkedEditing: register$1(new EditorBooleanOption(78, "linkedEditing", false, { description: localize(557, "Controls whether the editor has linked editing enabled. Depending on the language, related symbols such as HTML tags, are updated while editing.") })),
	links: register$1(new EditorBooleanOption(79, "links", true, { description: localize(558, "Controls whether the editor should detect links and make them clickable.") })),
	matchBrackets: register$1(new EditorStringEnumOption(80, "matchBrackets", "always", [
		"always",
		"near",
		"never"
	], { description: localize(559, "Highlight matching brackets.") })),
	minimap: register$1(new EditorMinimap()),
	mouseStyle: register$1(new EditorStringEnumOption(82, "mouseStyle", "text", [
		"text",
		"default",
		"copy"
	])),
	mouseWheelScrollSensitivity: register$1(new EditorFloatOption(83, "mouseWheelScrollSensitivity", 1, (x) => x === 0 ? 1 : x, { markdownDescription: localize(560, "A multiplier to be used on the `deltaX` and `deltaY` of mouse wheel scroll events.") })),
	mouseWheelZoom: register$1(new EditorBooleanOption(84, "mouseWheelZoom", false, { markdownDescription: isMacintosh ? localize(561, "Zoom the font of the editor when using mouse wheel and holding `Cmd`.") : localize(562, "Zoom the font of the editor when using mouse wheel and holding `Ctrl`.") })),
	multiCursorMergeOverlapping: register$1(new EditorBooleanOption(85, "multiCursorMergeOverlapping", true, { description: localize(563, "Merge multiple cursors when they are overlapping.") })),
	multiCursorModifier: register$1(new EditorEnumOption(86, "multiCursorModifier", "altKey", "alt", ["ctrlCmd", "alt"], _multiCursorModifierFromString, {
		markdownEnumDescriptions: [localize(564, "Maps to `Control` on Windows and Linux and to `Command` on macOS."), localize(565, "Maps to `Alt` on Windows and Linux and to `Option` on macOS.")],
		markdownDescription: localize(566, "The modifier to be used to add multiple cursors with the mouse. The Go to Definition and Open Link mouse gestures will adapt such that they do not conflict with the [multicursor modifier](https://code.visualstudio.com/docs/editor/codebasics#_multicursor-modifier).")
	})),
	mouseMiddleClickAction: register$1(new EditorStringEnumOption(87, "mouseMiddleClickAction", "default", [
		"default",
		"openLink",
		"ctrlLeftClick"
	], { description: localize(567, "Controls what happens when middle mouse button is clicked in the editor.") })),
	multiCursorPaste: register$1(new EditorStringEnumOption(88, "multiCursorPaste", "spread", ["spread", "full"], {
		markdownEnumDescriptions: [localize(568, "Each cursor pastes a single line of the text."), localize(569, "Each cursor pastes the full text.")],
		markdownDescription: localize(570, "Controls pasting when the line count of the pasted text matches the cursor count.")
	})),
	multiCursorLimit: register$1(new EditorIntOption(89, "multiCursorLimit", 1e4, 1, 1e5, { markdownDescription: localize(571, "Controls the max number of cursors that can be in an active editor at once.") })),
	occurrencesHighlight: register$1(new EditorStringEnumOption(90, "occurrencesHighlight", "singleFile", [
		"off",
		"singleFile",
		"multiFile"
	], {
		markdownEnumDescriptions: [
			localize(572, "Does not highlight occurrences."),
			localize(573, "Highlights occurrences only in the current file."),
			localize(574, "Experimental: Highlights occurrences across all valid open files.")
		],
		markdownDescription: localize(575, "Controls whether occurrences should be highlighted across open files.")
	})),
	occurrencesHighlightDelay: register$1(new EditorIntOption(91, "occurrencesHighlightDelay", 0, 0, 2e3, {
		description: localize(576, "Controls the delay in milliseconds after which occurrences are highlighted."),
		tags: ["preview"]
	})),
	overtypeOnPaste: register$1(new EditorBooleanOption(93, "overtypeOnPaste", true, { description: localize(577, "Controls whether pasting should overtype.") })),
	overviewRulerBorder: register$1(new EditorBooleanOption(94, "overviewRulerBorder", true, { description: localize(578, "Controls whether a border should be drawn around the overview ruler.") })),
	overviewRulerLanes: register$1(new EditorIntOption(95, "overviewRulerLanes", 3, 0, 3)),
	padding: register$1(new EditorPadding()),
	pasteAs: register$1(new EditorPasteAs()),
	parameterHints: register$1(new EditorParameterHints()),
	peekWidgetDefaultFocus: register$1(new EditorStringEnumOption(99, "peekWidgetDefaultFocus", "tree", ["tree", "editor"], {
		enumDescriptions: [localize(579, "Focus the tree when opening peek"), localize(580, "Focus the editor when opening peek")],
		description: localize(581, "Controls whether to focus the inline editor or the tree in the peek widget.")
	})),
	placeholder: register$1(new PlaceholderOption()),
	definitionLinkOpensInPeek: register$1(new EditorBooleanOption(101, "definitionLinkOpensInPeek", false, { description: localize(582, "Controls whether the Go to Definition mouse gesture always opens the peek widget.") })),
	quickSuggestions: register$1(new EditorQuickSuggestions()),
	quickSuggestionsDelay: register$1(new EditorIntOption(103, "quickSuggestionsDelay", 10, 0, 1073741824, {
		description: localize(583, "Controls the delay in milliseconds after which quick suggestions will show up."),
		experiment: { mode: "auto" }
	})),
	readOnly: register$1(new EditorBooleanOption(104, "readOnly", false)),
	readOnlyMessage: register$1(new ReadonlyMessage()),
	renameOnType: register$1(new EditorBooleanOption(106, "renameOnType", false, {
		description: localize(584, "Controls whether the editor auto renames on type."),
		markdownDeprecationMessage: localize(585, "Deprecated, use `#editor.linkedEditing#` instead.")
	})),
	renderControlCharacters: register$1(new EditorBooleanOption(108, "renderControlCharacters", true, {
		description: localize(586, "Controls whether the editor should render control characters."),
		restricted: true
	})),
	renderFinalNewline: register$1(new EditorStringEnumOption(109, "renderFinalNewline", isLinux ? "dimmed" : "on", [
		"off",
		"on",
		"dimmed"
	], { description: localize(587, "Render last line number when the file ends with a newline.") })),
	renderLineHighlight: register$1(new EditorStringEnumOption(110, "renderLineHighlight", "line", [
		"none",
		"gutter",
		"line",
		"all"
	], {
		enumDescriptions: [
			"",
			"",
			"",
			localize(588, "Highlights both the gutter and the current line.")
		],
		description: localize(589, "Controls how the editor should render the current line highlight.")
	})),
	renderLineHighlightOnlyWhenFocus: register$1(new EditorBooleanOption(111, "renderLineHighlightOnlyWhenFocus", false, { description: localize(590, "Controls if the editor should render the current line highlight only when the editor is focused.") })),
	renderValidationDecorations: register$1(new EditorStringEnumOption(112, "renderValidationDecorations", "editable", [
		"editable",
		"on",
		"off"
	])),
	renderWhitespace: register$1(new EditorStringEnumOption(113, "renderWhitespace", "selection", [
		"none",
		"boundary",
		"selection",
		"trailing",
		"all"
	], {
		enumDescriptions: [
			"",
			localize(591, "Render whitespace characters except for single spaces between words."),
			localize(592, "Render whitespace characters only on selected text."),
			localize(593, "Render only trailing whitespace characters."),
			""
		],
		description: localize(594, "Controls how the editor should render whitespace characters.")
	})),
	revealHorizontalRightPadding: register$1(new EditorIntOption(114, "revealHorizontalRightPadding", 15, 0, 1e3)),
	roundedSelection: register$1(new EditorBooleanOption(115, "roundedSelection", true, { description: localize(595, "Controls whether selections should have rounded corners.") })),
	rulers: register$1(new EditorRulers()),
	scrollbar: register$1(new EditorScrollbar$1()),
	scrollBeyondLastColumn: register$1(new EditorIntOption(118, "scrollBeyondLastColumn", 4, 0, 1073741824, { description: localize(596, "Controls the number of extra characters beyond which the editor will scroll horizontally.") })),
	scrollBeyondLastLine: register$1(new EditorBooleanOption(119, "scrollBeyondLastLine", true, { description: localize(597, "Controls whether the editor will scroll beyond the last line.") })),
	scrollOnMiddleClick: register$1(new EditorBooleanOption(172, "scrollOnMiddleClick", false, { description: localize(598, "Controls whether the editor will scroll when the middle button is pressed.") })),
	scrollPredominantAxis: register$1(new EditorBooleanOption(120, "scrollPredominantAxis", true, { description: localize(599, "Scroll only along the predominant axis when scrolling both vertically and horizontally at the same time. Prevents horizontal drift when scrolling vertically on a trackpad.") })),
	selectionClipboard: register$1(new EditorBooleanOption(121, "selectionClipboard", true, {
		description: localize(600, "Controls whether the Linux primary clipboard should be supported."),
		included: isLinux
	})),
	selectionHighlight: register$1(new EditorBooleanOption(122, "selectionHighlight", true, { description: localize(601, "Controls whether the editor should highlight matches similar to the selection.") })),
	selectionHighlightMaxLength: register$1(new EditorIntOption(123, "selectionHighlightMaxLength", 200, 0, 1073741824, { description: localize(602, "Controls how many characters can be in the selection before similar matches are not highlighted. Set to zero for unlimited.") })),
	selectionHighlightMultiline: register$1(new EditorBooleanOption(124, "selectionHighlightMultiline", false, { description: localize(603, "Controls whether the editor should highlight selection matches that span multiple lines.") })),
	selectOnLineNumbers: register$1(new EditorBooleanOption(125, "selectOnLineNumbers", true)),
	showFoldingControls: register$1(new EditorStringEnumOption(126, "showFoldingControls", "mouseover", [
		"always",
		"never",
		"mouseover"
	], {
		enumDescriptions: [
			localize(604, "Always show the folding controls."),
			localize(605, "Never show the folding controls and reduce the gutter size."),
			localize(606, "Only show the folding controls when the mouse is over the gutter.")
		],
		description: localize(607, "Controls when the folding controls on the gutter are shown.")
	})),
	showUnused: register$1(new EditorBooleanOption(127, "showUnused", true, { description: localize(608, "Controls fading out of unused code.") })),
	showDeprecated: register$1(new EditorBooleanOption(157, "showDeprecated", true, { description: localize(609, "Controls strikethrough deprecated variables.") })),
	inlayHints: register$1(new EditorInlayHints()),
	snippetSuggestions: register$1(new EditorStringEnumOption(128, "snippetSuggestions", "inline", [
		"top",
		"bottom",
		"inline",
		"none"
	], {
		enumDescriptions: [
			localize(610, "Show snippet suggestions on top of other suggestions."),
			localize(611, "Show snippet suggestions below other suggestions."),
			localize(612, "Show snippets suggestions with other suggestions."),
			localize(613, "Do not show snippet suggestions.")
		],
		description: localize(614, "Controls whether snippets are shown with other suggestions and how they are sorted.")
	})),
	smartSelect: register$1(new SmartSelect()),
	smoothScrolling: register$1(new EditorBooleanOption(130, "smoothScrolling", false, { description: localize(615, "Controls whether the editor will scroll using an animation.") })),
	stopRenderingLineAfter: register$1(new EditorIntOption(133, "stopRenderingLineAfter", 1e4, -1, 1073741824)),
	suggest: register$1(new EditorSuggest()),
	inlineSuggest: register$1(new InlineEditorSuggest()),
	inlineCompletionsAccessibilityVerbose: register$1(new EditorBooleanOption(170, "inlineCompletionsAccessibilityVerbose", false, { description: localize(616, "Controls whether the accessibility hint should be provided to screen reader users when an inline completion is shown.") })),
	suggestFontSize: register$1(new EditorIntOption(135, "suggestFontSize", 0, 0, 1e3, { markdownDescription: localize(617, "Font size for the suggest widget. When set to {0}, the value of {1} is used.", "`0`", "`#editor.fontSize#`") })),
	suggestLineHeight: register$1(new EditorIntOption(136, "suggestLineHeight", 0, 0, 1e3, { markdownDescription: localize(618, "Line height for the suggest widget. When set to {0}, the value of {1} is used. The minimum value is 8.", "`0`", "`#editor.lineHeight#`") })),
	suggestOnTriggerCharacters: register$1(new EditorBooleanOption(137, "suggestOnTriggerCharacters", true, { description: localize(619, "Controls whether suggestions should automatically show up when typing trigger characters.") })),
	suggestSelection: register$1(new EditorStringEnumOption(138, "suggestSelection", "first", [
		"first",
		"recentlyUsed",
		"recentlyUsedByPrefix"
	], {
		markdownEnumDescriptions: [
			localize(620, "Always select the first suggestion."),
			localize(621, "Select recent suggestions unless further typing selects one, e.g. `console.| -> console.log` because `log` has been completed recently."),
			localize(622, "Select suggestions based on previous prefixes that have completed those suggestions, e.g. `co -> console` and `con -> const`.")
		],
		description: localize(623, "Controls how suggestions are pre-selected when showing the suggest list.")
	})),
	tabCompletion: register$1(new EditorStringEnumOption(139, "tabCompletion", "off", [
		"on",
		"off",
		"onlySnippets"
	], {
		enumDescriptions: [
			localize(624, "Tab complete will insert the best matching suggestion when pressing tab."),
			localize(625, "Disable tab completions."),
			localize(626, "Tab complete snippets when their prefix match. Works best when 'quickSuggestions' aren't enabled.")
		],
		description: localize(627, "Enables tab completions.")
	})),
	tabIndex: register$1(new EditorIntOption(140, "tabIndex", 0, -1, 1073741824)),
	trimWhitespaceOnDelete: register$1(new EditorBooleanOption(141, "trimWhitespaceOnDelete", false, { description: localize(628, "Controls whether the editor will also delete the next line's indentation whitespace when deleting a newline.") })),
	unicodeHighlight: register$1(new UnicodeHighlight()),
	unusualLineTerminators: register$1(new EditorStringEnumOption(143, "unusualLineTerminators", "prompt", [
		"auto",
		"off",
		"prompt"
	], {
		enumDescriptions: [
			localize(629, "Unusual line terminators are automatically removed."),
			localize(630, "Unusual line terminators are ignored."),
			localize(631, "Unusual line terminators prompt to be removed.")
		],
		description: localize(632, "Remove unusual line terminators that might cause problems.")
	})),
	useShadowDOM: register$1(new EditorBooleanOption(144, "useShadowDOM", true)),
	useTabStops: register$1(new EditorBooleanOption(145, "useTabStops", true, { description: localize(633, "Spaces and tabs are inserted and deleted in alignment with tab stops.") })),
	wordBreak: register$1(new EditorStringEnumOption(146, "wordBreak", "normal", ["normal", "keepAll"], {
		markdownEnumDescriptions: [localize(634, "Use the default line break rule."), localize(635, "Word breaks should not be used for Chinese/Japanese/Korean (CJK) text. Non-CJK text behavior is the same as for normal.")],
		description: localize(636, "Controls the word break rules used for Chinese/Japanese/Korean (CJK) text.")
	})),
	wordSegmenterLocales: register$1(new WordSegmenterLocales()),
	wordSeparators: register$1(new EditorStringOption(148, "wordSeparators", USUAL_WORD_SEPARATORS, { description: localize(637, "Characters that will be used as word separators when doing word related navigations or operations.") })),
	wordWrap: register$1(new EditorStringEnumOption(149, "wordWrap", "off", [
		"off",
		"on",
		"wordWrapColumn",
		"bounded"
	], {
		markdownEnumDescriptions: [
			localize(638, "Lines will never wrap."),
			localize(639, "Lines will wrap at the viewport width."),
			localize(640, "Lines will wrap at `#editor.wordWrapColumn#`."),
			localize(641, "Lines will wrap at the minimum of viewport and `#editor.wordWrapColumn#`.")
		],
		description: localize(642, "Controls how lines should wrap.")
	})),
	wordWrapIndicator: register$1(new EditorBooleanOption(161, "wordWrapIndicator", false, { markdownDescription: localize(643, "Controls whether an indicator is rendered at the wrapping column of lines that wrap. Only has an effect when `#editor.wordWrap#` is enabled.") })),
	wordWrapBreakAfterCharacters: register$1(new EditorStringOption(150, "wordWrapBreakAfterCharacters", " 	})]?|/&.,;¢°′″‰℃、。｡､￠，．：；？！％・･ゝゞヽヾーァィゥェォッャュョヮヵヶぁぃぅぇぉっゃゅょゎゕゖㇰㇱㇲㇳㇴㇵㇶㇷㇸㇹㇺㇻㇼㇽㇾㇿ々〻ｧｨｩｪｫｬｭｮｯｰ”〉》」』】〕）］｝｣")),
	wordWrapBreakBeforeCharacters: register$1(new EditorStringOption(151, "wordWrapBreakBeforeCharacters", "([{‘“〈《「『【〔（［｛｢£¥＄￡￥+＋")),
	wordWrapColumn: register$1(new EditorIntOption(152, "wordWrapColumn", 80, 1, 1073741824, { markdownDescription: localize(644, "Controls the wrapping column of the editor when `#editor.wordWrap#` is `wordWrapColumn` or `bounded`.") })),
	wordWrapOverride1: register$1(new EditorStringEnumOption(153, "wordWrapOverride1", "inherit", [
		"off",
		"on",
		"inherit"
	])),
	wordWrapOverride2: register$1(new EditorStringEnumOption(154, "wordWrapOverride2", "inherit", [
		"off",
		"on",
		"inherit"
	])),
	wrapOnEscapedLineFeeds: register$1(new EditorBooleanOption(160, "wrapOnEscapedLineFeeds", false, { markdownDescription: localize(645, "Controls whether literal `\\n` shall trigger a wordWrap when `#editor.wordWrap#` is enabled.\n\nFor example:\n```c\nchar* str=\"hello\\nworld\"\n```\nwill be displayed as\n```c\nchar* str=\"hello\\n\n           world\"\n```") })),
	effectiveCursorStyle: register$1(new EffectiveCursorStyle()),
	editorClassName: register$1(new EditorClassName()),
	defaultColorDecorators: register$1(new EditorStringEnumOption(168, "defaultColorDecorators", "auto", [
		"auto",
		"always",
		"never"
	], {
		enumDescriptions: [
			localize(646, "Show default color decorators only when no extension provides colors decorators."),
			localize(647, "Always show default color decorators."),
			localize(648, "Never show default color decorators.")
		],
		description: localize(649, "Controls whether inline color decorations should be shown using the default document color provider.")
	})),
	pixelRatio: register$1(new EditorPixelRatio()),
	tabFocusMode: register$1(new EditorBooleanOption(165, "tabFocusMode", false, { markdownDescription: localize(650, "Controls whether the editor receives tabs or defers them to the workbench for navigation.") })),
	layoutInfo: register$1(new EditorLayoutInfoComputer()),
	wrappingInfo: register$1(new EditorWrappingInfoComputer()),
	wrappingIndent: register$1(new WrappingIndentOption()),
	wrappingStrategy: register$1(new WrappingStrategy()),
	effectiveEditContextEnabled: register$1(new EffectiveEditContextEnabled()),
	effectiveAllowVariableFonts: register$1(new EffectiveAllowVariableFonts()),
	effectiveFullwidthCharacterWidth: register$1(new EffectiveFullwidthCharacterWidth())
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/window.js
function ensureCodeWindow(targetWindow, fallbackWindowId) {
	const codeWindow = targetWindow;
	if (typeof codeWindow.vscodeWindowId !== "number") Object.defineProperty(codeWindow, "vscodeWindowId", { get: () => fallbackWindowId });
}
var mainWindow = window;
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/browser.js
var WindowManager = class WindowManager {
	constructor() {
		this.mapWindowIdToZoomFactor = /* @__PURE__ */ new Map();
	}
	static {
		this.INSTANCE = new WindowManager();
	}
	getZoomFactor(targetWindow) {
		return this.mapWindowIdToZoomFactor.get(this.getWindowId(targetWindow)) ?? 1;
	}
	getWindowId(targetWindow) {
		return targetWindow.vscodeWindowId;
	}
};
function addMatchMediaChangeListener(targetWindow, query, callback) {
	if (typeof query === "string") query = targetWindow.matchMedia(query);
	query.addEventListener("change", callback);
}
/** The zoom scale for an index, e.g. 1, 1.2, 1.4 */
function getZoomFactor(targetWindow) {
	return WindowManager.INSTANCE.getZoomFactor(targetWindow);
}
var userAgent = navigator.userAgent;
var isFirefox = userAgent.indexOf("Firefox") >= 0;
var isWebKit = userAgent.indexOf("AppleWebKit") >= 0;
var isChrome = userAgent.indexOf("Chrome") >= 0;
var isSafari = !isChrome && userAgent.indexOf("Safari") >= 0;
var isWebkitWebView = !isChrome && !isSafari && isWebKit;
userAgent.indexOf("Electron/");
var isAndroid = userAgent.indexOf("Android") >= 0;
var standalone = false;
if (typeof mainWindow.matchMedia === "function") {
	const standaloneMatchMedia = mainWindow.matchMedia("(display-mode: standalone) or (display-mode: window-controls-overlay)");
	const fullScreenMatchMedia = mainWindow.matchMedia("(display-mode: fullscreen)");
	standalone = standaloneMatchMedia.matches;
	addMatchMediaChangeListener(mainWindow, standaloneMatchMedia, ({ matches }) => {
		if (standalone && fullScreenMatchMedia.matches) return;
		standalone = matches;
	});
}
function getMonacoEnvironment() {
	return globalThis.MonacoEnvironment;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/canIUse.js
/**
* Browser feature we can support in current platform, browser and environment.
*/
var BrowserFeatures = {
	clipboard: {
		writeText: isNative || document.queryCommandSupported && document.queryCommandSupported("copy") || !!(navigator && navigator.clipboard && navigator.clipboard.writeText),
		readText: isNative || !!(navigator && navigator.clipboard && navigator.clipboard.readText)
	},
	pointerEvents: mainWindow.PointerEvent && ("ontouchstart" in mainWindow || navigator.maxTouchPoints > 0)
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/keybindings.js
function decodeKeybinding(keybinding, OS) {
	if (typeof keybinding === "number") {
		if (keybinding === 0) return null;
		const firstChord = (keybinding & 65535) >>> 0;
		const secondChord = (keybinding & 4294901760) >>> 16;
		if (secondChord !== 0) return new Keybinding([createSimpleKeybinding(firstChord, OS), createSimpleKeybinding(secondChord, OS)]);
		return new Keybinding([createSimpleKeybinding(firstChord, OS)]);
	} else {
		const chords = [];
		for (let i = 0; i < keybinding.length; i++) chords.push(createSimpleKeybinding(keybinding[i], OS));
		return new Keybinding(chords);
	}
}
function createSimpleKeybinding(keybinding, OS) {
	const ctrlCmd = keybinding & 2048 ? true : false;
	const winCtrl = keybinding & 256 ? true : false;
	return new KeyCodeChord(OS === 2 ? winCtrl : ctrlCmd, keybinding & 1024 ? true : false, keybinding & 512 ? true : false, OS === 2 ? ctrlCmd : winCtrl, keybinding & 255);
}
/**
* Represents a chord which uses the `keyCode` field of keyboard events.
* A chord is a combination of keys pressed simultaneously.
*/
var KeyCodeChord = class {
	constructor(ctrlKey, shiftKey, altKey, metaKey, keyCode) {
		this.ctrlKey = ctrlKey;
		this.shiftKey = shiftKey;
		this.altKey = altKey;
		this.metaKey = metaKey;
		this.keyCode = keyCode;
	}
	isModifierKey() {
		return this.keyCode === 0 || this.keyCode === 5 || this.keyCode === 57 || this.keyCode === 6 || this.keyCode === 4;
	}
	/**
	* Does this keybinding refer to the key code of a modifier and it also has the modifier flag?
	*/
	isDuplicateModifierCase() {
		return this.ctrlKey && this.keyCode === 5 || this.shiftKey && this.keyCode === 4 || this.altKey && this.keyCode === 6 || this.metaKey && this.keyCode === 57;
	}
};
/**
* A keybinding is a sequence of chords.
*/
var Keybinding = class {
	constructor(chords) {
		if (chords.length === 0) throw illegalArgument(`chords`);
		this.chords = chords;
	}
};
var ResolvedChord = class {
	constructor(ctrlKey, shiftKey, altKey, metaKey, keyLabel, keyAriaLabel) {
		this.ctrlKey = ctrlKey;
		this.shiftKey = shiftKey;
		this.altKey = altKey;
		this.metaKey = metaKey;
		this.keyLabel = keyLabel;
		this.keyAriaLabel = keyAriaLabel;
	}
};
/**
* A resolved keybinding. Consists of one or multiple chords.
*/
var ResolvedKeybinding = class {};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/keyboardEvent.js
function extractKeyCode(e) {
	if (e.charCode) {
		const char = String.fromCharCode(e.charCode).toUpperCase();
		return KeyCodeUtils.fromString(char);
	}
	const keyCode = e.keyCode;
	if (keyCode === 3) return 7;
	else if (isFirefox) switch (keyCode) {
		case 59: return 85;
		case 60:
			if (isLinux) return 97;
			break;
		case 61: return 86;
		case 107: return 109;
		case 109: return 111;
		case 173: return 88;
		case 224: if (isMacintosh) return 57;
	}
	else if (isWebKit) {
		if (isMacintosh && keyCode === 93) return 57;
		else if (!isMacintosh && keyCode === 92) return 57;
	}
	return EVENT_KEY_CODE_MAP[keyCode] || 0;
}
var ctrlKeyMod$1 = isMacintosh ? 256 : 2048;
var altKeyMod = 512;
var shiftKeyMod = 1024;
var metaKeyMod = isMacintosh ? 2048 : 256;
var StandardKeyboardEvent = class {
	constructor(source) {
		this._standardKeyboardEventBrand = true;
		const e = source;
		this.browserEvent = e;
		this.target = e.target;
		this.ctrlKey = e.ctrlKey;
		this.shiftKey = e.shiftKey;
		this.altKey = e.altKey;
		this.metaKey = e.metaKey;
		this.altGraphKey = e.getModifierState?.("AltGraph");
		this.code = e.code;
		this.keyCode = e.isComposing ? 114 : extractKeyCode(e);
		this.ctrlKey = this.ctrlKey || this.keyCode === 5;
		this.altKey = this.altKey || this.keyCode === 6;
		this.shiftKey = this.shiftKey || this.keyCode === 4;
		this.metaKey = this.metaKey || this.keyCode === 57;
		this._asKeybinding = this._computeKeybinding();
		this._asKeyCodeChord = this._computeKeyCodeChord();
	}
	preventDefault() {
		if (this.browserEvent && this.browserEvent.preventDefault) this.browserEvent.preventDefault();
	}
	stopPropagation() {
		if (this.browserEvent && this.browserEvent.stopPropagation) this.browserEvent.stopPropagation();
	}
	toKeyCodeChord() {
		return this._asKeyCodeChord;
	}
	equals(other) {
		return this._asKeybinding === other;
	}
	_computeKeybinding() {
		let key = 0;
		if (!isModifierKey(this.keyCode)) key = this.keyCode;
		let result = 0;
		if (this.ctrlKey) result |= ctrlKeyMod$1;
		if (this.altKey) result |= altKeyMod;
		if (this.shiftKey) result |= shiftKeyMod;
		if (this.metaKey) result |= metaKeyMod;
		result |= key;
		return result;
	}
	_computeKeyCodeChord() {
		let key = 0;
		if (!isModifierKey(this.keyCode)) key = this.keyCode;
		return new KeyCodeChord(this.ctrlKey, this.shiftKey, this.altKey, this.metaKey, key);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/iframe.js
var sameOriginWindowChainCache = /* @__PURE__ */ new WeakMap();
function getParentWindowIfSameOrigin(w) {
	if (!w.parent || w.parent === w) return null;
	try {
		const location = w.location;
		const parentLocation = w.parent.location;
		if (location.origin !== "null" && parentLocation.origin !== "null" && location.origin !== parentLocation.origin) return null;
	} catch (e) {
		return null;
	}
	return w.parent;
}
var IframeUtils = class {
	/**
	* Returns a chain of embedded windows with the same origin (which can be accessed programmatically).
	* Having a chain of length 1 might mean that the current execution environment is running outside of an iframe or inside an iframe embedded in a window with a different origin.
	*/
	static getSameOriginWindowChain(targetWindow) {
		let windowChainCache = sameOriginWindowChainCache.get(targetWindow);
		if (!windowChainCache) {
			windowChainCache = [];
			sameOriginWindowChainCache.set(targetWindow, windowChainCache);
			let w = targetWindow;
			let parent;
			do {
				parent = getParentWindowIfSameOrigin(w);
				if (parent) windowChainCache.push({
					window: new WeakRef(w),
					iframeElement: w.frameElement || null
				});
				else windowChainCache.push({
					window: new WeakRef(w),
					iframeElement: null
				});
				w = parent;
			} while (w);
		}
		return windowChainCache.slice(0);
	}
	/**
	* Returns the position of `childWindow` relative to `ancestorWindow`
	*/
	static getPositionOfChildWindowRelativeToAncestorWindow(childWindow, ancestorWindow) {
		if (!ancestorWindow || childWindow === ancestorWindow) return {
			top: 0,
			left: 0
		};
		let top = 0, left = 0;
		const windowChain = this.getSameOriginWindowChain(childWindow);
		for (const windowChainEl of windowChain) {
			const windowInChain = windowChainEl.window.deref();
			top += windowInChain?.scrollY ?? 0;
			left += windowInChain?.scrollX ?? 0;
			if (windowInChain === ancestorWindow) break;
			if (!windowChainEl.iframeElement) break;
			const boundingRect = windowChainEl.iframeElement.getBoundingClientRect();
			top += boundingRect.top;
			left += boundingRect.left;
		}
		return {
			top,
			left
		};
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/mouseEvent.js
var StandardMouseEvent = class {
	constructor(targetWindow, e) {
		this.timestamp = Date.now();
		this.browserEvent = e;
		this.leftButton = e.button === 0;
		this.middleButton = e.button === 1;
		this.rightButton = e.button === 2;
		this.buttons = e.buttons;
		this.defaultPrevented = e.defaultPrevented;
		this.target = e.target;
		this.detail = e.detail || 1;
		if (e.type === "dblclick") this.detail = 2;
		this.ctrlKey = e.ctrlKey;
		this.shiftKey = e.shiftKey;
		this.altKey = e.altKey;
		this.metaKey = e.metaKey;
		this.posx = e.pageX;
		this.posy = e.pageY;
		const iframeOffsets = IframeUtils.getPositionOfChildWindowRelativeToAncestorWindow(targetWindow, e.view);
		this.posx -= iframeOffsets.left;
		this.posy -= iframeOffsets.top;
	}
	preventDefault() {
		this.browserEvent.preventDefault();
	}
	stopPropagation() {
		this.browserEvent.stopPropagation();
	}
};
var StandardWheelEvent = class {
	constructor(e, deltaX = 0, deltaY = 0) {
		this.browserEvent = e || null;
		this.target = e ? e.target || e.targetNode || e.srcElement : null;
		this.deltaY = deltaY;
		this.deltaX = deltaX;
		let shouldFactorDPR = false;
		if (isChrome) {
			const chromeVersionMatch = navigator.userAgent.match(/Chrome\/(\d+)/);
			shouldFactorDPR = (chromeVersionMatch ? parseInt(chromeVersionMatch[1]) : 123) <= 122;
		}
		if (e) {
			const e1 = e;
			const e2 = e;
			const devicePixelRatio = e.view?.devicePixelRatio || 1;
			if (typeof e1.wheelDeltaY !== "undefined") {
				if (shouldFactorDPR) this.deltaY = e1.wheelDeltaY / (120 * devicePixelRatio);
				else this.deltaY = e1.wheelDeltaY / 120;
			} else if (typeof e2.VERTICAL_AXIS !== "undefined" && e2.axis === e2.VERTICAL_AXIS) this.deltaY = -e2.detail / 3;
			else if (e.type === "wheel") {
				const ev = e;
				if (ev.deltaMode === ev.DOM_DELTA_LINE) {
					if (isFirefox && !isMacintosh) this.deltaY = -e.deltaY / 3;
					else this.deltaY = -e.deltaY;
				} else this.deltaY = -e.deltaY / 40;
			}
			if (typeof e1.wheelDeltaX !== "undefined") {
				if (isSafari && isWindows) this.deltaX = -(e1.wheelDeltaX / 120);
				else if (shouldFactorDPR) this.deltaX = e1.wheelDeltaX / (120 * devicePixelRatio);
				else this.deltaX = e1.wheelDeltaX / 120;
			} else if (typeof e2.HORIZONTAL_AXIS !== "undefined" && e2.axis === e2.HORIZONTAL_AXIS) this.deltaX = -e.detail / 3;
			else if (e.type === "wheel") {
				const ev = e;
				if (ev.deltaMode === ev.DOM_DELTA_LINE) {
					if (isFirefox && !isMacintosh) this.deltaX = -e.deltaX / 3;
					else this.deltaX = -e.deltaX;
				} else this.deltaX = -e.deltaX / 40;
			}
			if (this.deltaY === 0 && this.deltaX === 0 && e.wheelDelta) {
				if (shouldFactorDPR) this.deltaY = e.wheelDelta / (120 * devicePixelRatio);
				else this.deltaY = e.wheelDelta / 120;
			}
		}
	}
	preventDefault() {
		this.browserEvent?.preventDefault();
	}
	stopPropagation() {
		this.browserEvent?.stopPropagation();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/numbers.js
function clamp(value, min, max) {
	return Math.min(Math.max(value, min), max);
}
var MovingAverage = class {
	constructor() {
		this._n = 1;
		this._val = 0;
	}
	update(value) {
		this._val = this._val + (value - this._val) / this._n;
		this._n += 1;
		return this._val;
	}
	get value() {
		return this._val;
	}
};
var SlidingWindowAverage = class {
	constructor(size) {
		this._n = 0;
		this._val = 0;
		this._values = [];
		this._index = 0;
		this._sum = 0;
		this._values = new Array(size);
		this._values.fill(0, 0, size);
	}
	update(value) {
		const oldValue = this._values[this._index];
		this._values[this._index] = value;
		this._index = (this._index + 1) % this._values.length;
		this._sum -= oldValue;
		this._sum += value;
		if (this._n < this._values.length) this._n += 1;
		this._val = this._sum / this._n;
		return this._val;
	}
	get value() {
		return this._val;
	}
};
/** Returns whether the point is within the triangle formed by the following 6 x/y point pairs */
function isPointWithinTriangle(x, y, ax, ay, bx, by, cx, cy) {
	const v0x = cx - ax;
	const v0y = cy - ay;
	const v1x = bx - ax;
	const v1y = by - ay;
	const v2x = x - ax;
	const v2y = y - ay;
	const dot00 = v0x * v0x + v0y * v0y;
	const dot01 = v0x * v1x + v0y * v1y;
	const dot02 = v0x * v2x + v0y * v2y;
	const dot11 = v1x * v1x + v1y * v1y;
	const dot12 = v1x * v2x + v1y * v2y;
	const invDenom = 1 / (dot00 * dot11 - dot01 * dot01);
	const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
	const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
	return u >= 0 && v >= 0 && u + v < 1;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/equals.js
/**
* Compares two items for equality using strict equality.
*/
function strictEquals(a, b) {
	return a === b;
}
function strictEqualsC() {
	return (a, b) => a === b;
}
/**
* Checks if the items of two arrays are equal.
* By default, strict equality is used to compare elements, but a custom equality comparer can be provided.
*/
function arrayEquals$1(a, b, itemEquals) {
	return equals$1(a, b, itemEquals ?? strictEquals);
}
/**
* Checks if the items of two arrays are equal.
* By default, strict equality is used to compare elements, but a custom equality comparer can be provided.
*/
function arrayEqualsC(itemEquals) {
	return (a, b) => equals$1(a, b, itemEquals ?? strictEquals);
}
/**
* Drills into arrays (items ordered) and objects (keys unordered) and uses strict equality on everything else.
*/
function structuralEquals(a, b) {
	if (a === b) return true;
	if (Array.isArray(a) && Array.isArray(b)) {
		if (a.length !== b.length) return false;
		for (let i = 0; i < a.length; i++) if (!structuralEquals(a[i], b[i])) return false;
		return true;
	}
	if (a && typeof a === "object" && b && typeof b === "object") {
		if (Object.getPrototypeOf(a) === Object.prototype && Object.getPrototypeOf(b) === Object.prototype) {
			const aObj = a;
			const bObj = b;
			const keysA = Object.keys(aObj);
			const keysB = Object.keys(bObj);
			const keysBSet = new Set(keysB);
			if (keysA.length !== keysB.length) return false;
			for (const key of keysA) {
				if (!keysBSet.has(key)) return false;
				if (!structuralEquals(aObj[key], bObj[key])) return false;
			}
			return true;
		}
	}
	return false;
}
function structuralEqualsC() {
	return (a, b) => structuralEquals(a, b);
}
/**
* Two items are considered equal, if their stringified representations are equal.
*/
function jsonStringifyEquals(a, b) {
	return JSON.stringify(a) === JSON.stringify(b);
}
/**
* Two items are considered equal, if their stringified representations are equal.
*/
function jsonStringifyEqualsC() {
	return (a, b) => JSON.stringify(a) === JSON.stringify(b);
}
/**
* Uses `item.equals(other)` to determine equality.
*/
function thisEqualsC() {
	return (a, b) => a.equals(b);
}
/**
* Checks if two items are both null or undefined, or are equal according to the provided equality comparer.
*/
function equalsIfDefined(v1, v2, equals) {
	if (v1 === void 0 || v1 === null || v2 === void 0 || v2 === null) return v2 === v1;
	return equals(v1, v2);
}
/**
* Returns an equality comparer that checks if two items are both null or undefined, or are equal according to the provided equality comparer.
*/
function equalsIfDefinedC(equals) {
	return (v1, v2) => {
		if (v1 === void 0 || v1 === null || v2 === void 0 || v2 === null) return v2 === v1;
		return equals(v1, v2);
	};
}
/**
* Each function in this file which offers an equality comparison, has an accompanying
* `*C` variant which returns an EqualityComparer function.
*
* The `*C` variant allows for easier composition of equality comparers and improved type-inference.
*/
var equals;
(function(equals) {
	equals.strict = strictEquals;
	equals.strictC = strictEqualsC;
	equals.array = arrayEquals$1;
	equals.arrayC = arrayEqualsC;
	equals.structural = structuralEquals;
	equals.structuralC = structuralEqualsC;
	equals.jsonStringify = jsonStringifyEquals;
	equals.jsonStringifyC = jsonStringifyEqualsC;
	equals.thisC = thisEqualsC;
	equals.ifDefined = equalsIfDefined;
	equals.ifDefinedC = equalsIfDefinedC;
})(equals || (equals = {}));
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/observableInternal/logging/logging.js
var globalObservableLogger;
function addLogger(logger) {
	if (!globalObservableLogger) globalObservableLogger = logger;
	else if (globalObservableLogger instanceof ComposedLogger) globalObservableLogger.loggers.push(logger);
	else globalObservableLogger = new ComposedLogger([globalObservableLogger, logger]);
}
function getLogger() {
	return globalObservableLogger;
}
var ComposedLogger = class {
	constructor(loggers) {
		this.loggers = loggers;
	}
	handleObservableCreated(observable, location) {
		for (const logger of this.loggers) logger.handleObservableCreated(observable, location);
	}
	handleOnListenerCountChanged(observable, newCount) {
		for (const logger of this.loggers) logger.handleOnListenerCountChanged(observable, newCount);
	}
	handleObservableUpdated(observable, info) {
		for (const logger of this.loggers) logger.handleObservableUpdated(observable, info);
	}
	handleAutorunCreated(autorun, location) {
		for (const logger of this.loggers) logger.handleAutorunCreated(autorun, location);
	}
	handleAutorunDisposed(autorun) {
		for (const logger of this.loggers) logger.handleAutorunDisposed(autorun);
	}
	handleAutorunDependencyChanged(autorun, observable, change) {
		for (const logger of this.loggers) logger.handleAutorunDependencyChanged(autorun, observable, change);
	}
	handleAutorunStarted(autorun) {
		for (const logger of this.loggers) logger.handleAutorunStarted(autorun);
	}
	handleAutorunFinished(autorun) {
		for (const logger of this.loggers) logger.handleAutorunFinished(autorun);
	}
	handleDerivedDependencyChanged(derived, observable, change) {
		for (const logger of this.loggers) logger.handleDerivedDependencyChanged(derived, observable, change);
	}
	handleDerivedCleared(observable) {
		for (const logger of this.loggers) logger.handleDerivedCleared(observable);
	}
	handleBeginTransaction(transaction) {
		for (const logger of this.loggers) logger.handleBeginTransaction(transaction);
	}
	handleEndTransaction(transaction) {
		for (const logger of this.loggers) logger.handleEndTransaction(transaction);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/observableInternal/debugLocation.js
var DebugLocation;
(function(DebugLocation) {
	let enabled = false;
	function enable() {
		enabled = true;
	}
	DebugLocation.enable = enable;
	function ofCaller() {
		if (!enabled) return;
		const Err = Error;
		const l = Err.stackTraceLimit;
		Err.stackTraceLimit = 3;
		const stack = (/* @__PURE__ */ new Error()).stack;
		Err.stackTraceLimit = l;
		return DebugLocationImpl.fromStack(stack, 2);
	}
	DebugLocation.ofCaller = ofCaller;
})(DebugLocation || (DebugLocation = {}));
var DebugLocationImpl = class DebugLocationImpl {
	static fromStack(stack, parentIdx) {
		const location = parseLine(stack.split("\n")[parentIdx + 1]);
		if (location) return new DebugLocationImpl(location.fileName, location.line, location.column, location.id);
		else return;
	}
	constructor(fileName, line, column, id) {
		this.fileName = fileName;
		this.line = line;
		this.column = column;
		this.id = id;
	}
};
function parseLine(stackLine) {
	const match = stackLine.match(/\((.*):(\d+):(\d+)\)/);
	if (match) return {
		fileName: match[1],
		line: parseInt(match[2]),
		column: parseInt(match[3]),
		id: stackLine
	};
	const match2 = stackLine.match(/at ([^\(\)]*):(\d+):(\d+)/);
	if (match2) return {
		fileName: match2[1],
		line: parseInt(match2[2]),
		column: parseInt(match2[3]),
		id: stackLine
	};
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/observableInternal/debugName.js
var DebugNameData = class {
	constructor(owner, debugNameSource, referenceFn) {
		this.owner = owner;
		this.debugNameSource = debugNameSource;
		this.referenceFn = referenceFn;
	}
	getDebugName(target) {
		return getDebugName(target, this);
	}
};
var countPerName = /* @__PURE__ */ new Map();
var cachedDebugName = /* @__PURE__ */ new WeakMap();
function getDebugName(target, data) {
	const cached = cachedDebugName.get(target);
	if (cached) return cached;
	const dbgName = computeDebugName(target, data);
	if (dbgName) {
		let count = countPerName.get(dbgName) ?? 0;
		count++;
		countPerName.set(dbgName, count);
		const result = count === 1 ? dbgName : `${dbgName}#${count}`;
		cachedDebugName.set(target, result);
		return result;
	}
}
function computeDebugName(self, data) {
	const cached = cachedDebugName.get(self);
	if (cached) return cached;
	const ownerStr = data.owner ? formatOwner(data.owner) + `.` : "";
	let result;
	const debugNameSource = data.debugNameSource;
	if (debugNameSource !== void 0) {
		if (typeof debugNameSource === "function") {
			result = debugNameSource();
			if (result !== void 0) return ownerStr + result;
		} else return ownerStr + debugNameSource;
	}
	const referenceFn = data.referenceFn;
	if (referenceFn !== void 0) {
		result = getFunctionName(referenceFn);
		if (result !== void 0) return ownerStr + result;
	}
	if (data.owner !== void 0) {
		const key = findKey(data.owner, self);
		if (key !== void 0) return ownerStr + key;
	}
}
function findKey(obj, value) {
	for (const key in obj) if (obj[key] === value) return key;
}
var countPerClassName = /* @__PURE__ */ new Map();
var ownerId = /* @__PURE__ */ new WeakMap();
function formatOwner(owner) {
	const id = ownerId.get(owner);
	if (id) return id;
	const className = getClassName$1(owner) ?? "Object";
	let count = countPerClassName.get(className) ?? 0;
	count++;
	countPerClassName.set(className, count);
	const result = count === 1 ? className : `${className}#${count}`;
	ownerId.set(owner, result);
	return result;
}
function getClassName$1(obj) {
	const ctor = obj.constructor;
	if (ctor) {
		if (ctor.name === "Object") return;
		return ctor.name;
	}
}
function getFunctionName(fn) {
	const fnSrc = fn.toString();
	const match = /\/\*\*\s*@description\s*([^*]*)\*\//.exec(fnSrc);
	return (match ? match[1] : void 0)?.trim();
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/observableInternal/observables/baseObservable.js
var _derived;
/**
* @internal
* This is to allow splitting files.
*/
function _setDerivedOpts(derived) {
	_derived = derived;
}
var _recomputeInitiallyAndOnChange;
function _setRecomputeInitiallyAndOnChange(recomputeInitiallyAndOnChange) {
	_recomputeInitiallyAndOnChange = recomputeInitiallyAndOnChange;
}
var ConvenientObservable = class {
	get TChange() {
		return null;
	}
	reportChanges() {
		this.get();
	}
	/** @sealed */
	read(reader) {
		if (reader) return reader.readObservable(this);
		else return this.get();
	}
	map(fnOrOwner, fnOrUndefined, debugLocation = DebugLocation.ofCaller()) {
		const owner = fnOrUndefined === void 0 ? void 0 : fnOrOwner;
		const fn = fnOrUndefined === void 0 ? fnOrOwner : fnOrUndefined;
		return _derived({
			owner,
			debugName: () => {
				const name = getFunctionName(fn);
				if (name !== void 0) return name;
				const match = /^\s*\(?\s*([a-zA-Z_$][a-zA-Z_$0-9]*)\s*\)?\s*=>\s*\1(?:\??)\.([a-zA-Z_$][a-zA-Z_$0-9]*)\s*$/.exec(fn.toString());
				if (match) return `${this.debugName}.${match[2]}`;
				if (!owner) return `${this.debugName} (mapped)`;
			},
			debugReferenceFn: fn
		}, (reader) => fn(this.read(reader), reader), debugLocation);
	}
	/**
	* @sealed
	* Converts an observable of an observable value into a direct observable of the value.
	*/
	flatten() {
		return _derived({
			owner: void 0,
			debugName: () => `${this.debugName} (flattened)`
		}, (reader) => this.read(reader).read(reader));
	}
	recomputeInitiallyAndOnChange(store, handleValue) {
		store.add(_recomputeInitiallyAndOnChange(this, handleValue));
		return this;
	}
};
var BaseObservable = class extends ConvenientObservable {
	constructor(debugLocation) {
		super();
		this._observers = /* @__PURE__ */ new Set();
		getLogger()?.handleObservableCreated(this, debugLocation);
	}
	addObserver(observer) {
		const len = this._observers.size;
		this._observers.add(observer);
		if (len === 0) this.onFirstObserverAdded();
		if (len !== this._observers.size) getLogger()?.handleOnListenerCountChanged(this, this._observers.size);
	}
	removeObserver(observer) {
		const deleted = this._observers.delete(observer);
		if (deleted && this._observers.size === 0) this.onLastObserverRemoved();
		if (deleted) getLogger()?.handleOnListenerCountChanged(this, this._observers.size);
	}
	onFirstObserverAdded() {}
	onLastObserverRemoved() {}
	debugGetObservers() {
		return this._observers;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/observableInternal/observables/derivedImpl.js
function derivedStateToString(state) {
	switch (state) {
		case 0: return "initial";
		case 1: return "dependenciesMightHaveChanged";
		case 2: return "stale";
		case 3: return "upToDate";
		default: return "<unknown>";
	}
}
var Derived = class extends BaseObservable {
	get debugName() {
		return this._debugNameData.getDebugName(this) ?? "(anonymous)";
	}
	constructor(_debugNameData, _computeFn, _changeTracker, _handleLastObserverRemoved = void 0, _equalityComparator, debugLocation) {
		super(debugLocation);
		this._debugNameData = _debugNameData;
		this._computeFn = _computeFn;
		this._changeTracker = _changeTracker;
		this._handleLastObserverRemoved = _handleLastObserverRemoved;
		this._equalityComparator = _equalityComparator;
		this._state = 0;
		this._value = void 0;
		this._updateCount = 0;
		this._dependencies = /* @__PURE__ */ new Set();
		this._dependenciesToBeRemoved = /* @__PURE__ */ new Set();
		this._changeSummary = void 0;
		this._isUpdating = false;
		this._isComputing = false;
		this._didReportChange = false;
		this._isInBeforeUpdate = false;
		this._isReaderValid = false;
		this._store = void 0;
		this._delayedStore = void 0;
		this._removedObserverToCallEndUpdateOn = null;
		this._changeSummary = this._changeTracker?.createChangeSummary(void 0);
	}
	onLastObserverRemoved() {
		/**
		* We are not tracking changes anymore, thus we have to assume
		* that our cache is invalid.
		*/
		this._state = 0;
		this._value = void 0;
		getLogger()?.handleDerivedCleared(this);
		for (const d of this._dependencies) d.removeObserver(this);
		this._dependencies.clear();
		if (this._store !== void 0) {
			this._store.dispose();
			this._store = void 0;
		}
		if (this._delayedStore !== void 0) {
			this._delayedStore.dispose();
			this._delayedStore = void 0;
		}
		this._handleLastObserverRemoved?.();
	}
	get() {
		if (this._isComputing && false);
		if (this._observers.size === 0) {
			let result;
			try {
				this._isReaderValid = true;
				let changeSummary = void 0;
				if (this._changeTracker) {
					changeSummary = this._changeTracker.createChangeSummary(void 0);
					this._changeTracker.beforeUpdate?.(this, changeSummary);
				}
				result = this._computeFn(this, changeSummary);
			} finally {
				this._isReaderValid = false;
			}
			this.onLastObserverRemoved();
			return result;
		} else {
			do {
				if (this._state === 1) for (const d of this._dependencies) {
					/** might call {@link handleChange} indirectly, which could make us stale */
					d.reportChanges();
					if (this._state === 2) break;
				}
				if (this._state === 1) this._state = 3;
				if (this._state !== 3) this._recompute();
			} while (this._state !== 3);
			return this._value;
		}
	}
	_recompute() {
		let didChange = false;
		this._isComputing = true;
		this._didReportChange = false;
		const emptySet = this._dependenciesToBeRemoved;
		this._dependenciesToBeRemoved = this._dependencies;
		this._dependencies = emptySet;
		try {
			const changeSummary = this._changeSummary;
			this._isReaderValid = true;
			if (this._changeTracker) {
				this._isInBeforeUpdate = true;
				this._changeTracker.beforeUpdate?.(this, changeSummary);
				this._isInBeforeUpdate = false;
				this._changeSummary = this._changeTracker?.createChangeSummary(changeSummary);
			}
			const hadValue = this._state !== 0;
			const oldValue = this._value;
			this._state = 3;
			const delayedStore = this._delayedStore;
			if (delayedStore !== void 0) this._delayedStore = void 0;
			try {
				if (this._store !== void 0) {
					this._store.dispose();
					this._store = void 0;
				}
				/** might call {@link handleChange} indirectly, which could invalidate us */
				this._value = this._computeFn(this, changeSummary);
			} finally {
				this._isReaderValid = false;
				for (const o of this._dependenciesToBeRemoved) o.removeObserver(this);
				this._dependenciesToBeRemoved.clear();
				if (delayedStore !== void 0) delayedStore.dispose();
			}
			didChange = this._didReportChange || hadValue && !this._equalityComparator(oldValue, this._value);
			getLogger()?.handleObservableUpdated(this, {
				oldValue,
				newValue: this._value,
				change: void 0,
				didChange,
				hadValue
			});
		} catch (e) {
			onBugIndicatingError(e);
		}
		this._isComputing = false;
		if (!this._didReportChange && didChange) for (const r of this._observers) r.handleChange(this, void 0);
		else this._didReportChange = false;
	}
	toString() {
		return `LazyDerived<${this.debugName}>`;
	}
	beginUpdate(_observable) {
		if (this._isUpdating) throw new BugIndicatingError("Cyclic deriveds are not supported yet!");
		this._updateCount++;
		this._isUpdating = true;
		try {
			const propagateBeginUpdate = this._updateCount === 1;
			if (this._state === 3) {
				this._state = 1;
				if (!propagateBeginUpdate) for (const r of this._observers) r.handlePossibleChange(this);
			}
			if (propagateBeginUpdate) for (const r of this._observers) r.beginUpdate(this);
		} finally {
			this._isUpdating = false;
		}
	}
	endUpdate(_observable) {
		this._updateCount--;
		if (this._updateCount === 0) {
			const observers = [...this._observers];
			for (const r of observers) r.endUpdate(this);
			if (this._removedObserverToCallEndUpdateOn) {
				const observers = [...this._removedObserverToCallEndUpdateOn];
				this._removedObserverToCallEndUpdateOn = null;
				for (const r of observers) r.endUpdate(this);
			}
		}
		assertFn(() => this._updateCount >= 0);
	}
	handlePossibleChange(observable) {
		if (this._state === 3 && this._dependencies.has(observable) && !this._dependenciesToBeRemoved.has(observable)) {
			this._state = 1;
			for (const r of this._observers) r.handlePossibleChange(this);
		}
	}
	handleChange(observable, change) {
		if (this._dependencies.has(observable) && !this._dependenciesToBeRemoved.has(observable) || this._isInBeforeUpdate) {
			getLogger()?.handleDerivedDependencyChanged(this, observable, change);
			let shouldReact = false;
			try {
				shouldReact = this._changeTracker ? this._changeTracker.handleChange({
					changedObservable: observable,
					change,
					didChange: (o) => o === observable
				}, this._changeSummary) : true;
			} catch (e) {
				onBugIndicatingError(e);
			}
			const wasUpToDate = this._state === 3;
			if (shouldReact && (this._state === 1 || wasUpToDate)) {
				this._state = 2;
				if (wasUpToDate) for (const r of this._observers) r.handlePossibleChange(this);
			}
		}
	}
	_ensureReaderValid() {
		if (!this._isReaderValid) throw new BugIndicatingError("The reader object cannot be used outside its compute function!");
	}
	readObservable(observable) {
		this._ensureReaderValid();
		observable.addObserver(this);
		/** This might call {@link handleChange} indirectly, which could invalidate us */
		const value = observable.get();
		this._dependencies.add(observable);
		this._dependenciesToBeRemoved.delete(observable);
		return value;
	}
	get store() {
		this._ensureReaderValid();
		if (this._store === void 0) this._store = new DisposableStore();
		return this._store;
	}
	get delayedStore() {
		this._ensureReaderValid();
		if (this._delayedStore === void 0) this._delayedStore = new DisposableStore();
		return this._delayedStore;
	}
	addObserver(observer) {
		const shouldCallBeginUpdate = !this._observers.has(observer) && this._updateCount > 0;
		super.addObserver(observer);
		if (shouldCallBeginUpdate) {
			if (!this._removedObserverToCallEndUpdateOn?.delete(observer)) observer.beginUpdate(this);
		}
	}
	removeObserver(observer) {
		if (this._observers.has(observer) && this._updateCount > 0) {
			if (!this._removedObserverToCallEndUpdateOn) this._removedObserverToCallEndUpdateOn = /* @__PURE__ */ new Set();
			this._removedObserverToCallEndUpdateOn.add(observer);
		}
		super.removeObserver(observer);
	}
	debugGetState() {
		return {
			state: this._state,
			stateStr: derivedStateToString(this._state),
			updateCount: this._updateCount,
			isComputing: this._isComputing,
			dependencies: this._dependencies,
			value: this._value
		};
	}
	debugSetValue(newValue) {
		this._value = newValue;
	}
	debugRecompute() {
		this.beginUpdate(this);
		try {
			if (!this._isComputing) this._recompute();
			else this._state = 2;
		} finally {
			this.endUpdate(this);
		}
	}
	setValue(newValue, tx, change) {
		this._value = newValue;
		const observers = this._observers;
		tx.updateObserver(this, this);
		for (const d of observers) d.handleChange(this, change);
	}
};
var DerivedWithSetter = class extends Derived {
	constructor(debugNameData, computeFn, changeTracker, handleLastObserverRemoved = void 0, equalityComparator, set, debugLocation) {
		super(debugNameData, computeFn, changeTracker, handleLastObserverRemoved, equalityComparator, debugLocation);
		this.set = set;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/observableInternal/observables/derived.js
function derived(computeFnOrOwner, computeFn, debugLocation = DebugLocation.ofCaller()) {
	if (computeFn !== void 0) return new Derived(new DebugNameData(computeFnOrOwner, void 0, computeFn), computeFn, void 0, void 0, strictEquals, debugLocation);
	return new Derived(new DebugNameData(void 0, void 0, computeFnOrOwner), computeFnOrOwner, void 0, void 0, strictEquals, debugLocation);
}
function derivedWithSetter(owner, computeFn, setter, debugLocation = DebugLocation.ofCaller()) {
	return new DerivedWithSetter(new DebugNameData(owner, void 0, computeFn), computeFn, void 0, void 0, strictEquals, setter, debugLocation);
}
function derivedOpts(options, computeFn, debugLocation = DebugLocation.ofCaller()) {
	return new Derived(new DebugNameData(options.owner, options.debugName, options.debugReferenceFn), computeFn, void 0, options.onLastObserverRemoved, options.equalsFn ?? strictEquals, debugLocation);
}
_setDerivedOpts(derivedOpts);
/**
* Represents an observable that is derived from other observables.
* The value is only recomputed when absolutely needed.
*
* {@link computeFn} should start with a JS Doc using `@description` to name the derived.
*
* Use `createEmptyChangeSummary` to create a "change summary" that can collect the changes.
* Use `handleChange` to add a reported change to the change summary.
* The compute function is given the last change summary.
* The change summary is discarded after the compute function was called.
*
* @see derived
*/
function derivedHandleChanges(options, computeFn, debugLocation = DebugLocation.ofCaller()) {
	return new Derived(new DebugNameData(options.owner, options.debugName, void 0), computeFn, options.changeTracker, void 0, options.equalityComparer ?? strictEquals, debugLocation);
}
function derivedDisposable(computeFnOrOwner, computeFnOrUndefined, debugLocation = DebugLocation.ofCaller()) {
	let computeFn;
	let owner;
	if (computeFnOrUndefined === void 0) {
		computeFn = computeFnOrOwner;
		owner = void 0;
	} else {
		owner = computeFnOrOwner;
		computeFn = computeFnOrUndefined;
	}
	let store = void 0;
	return new Derived(new DebugNameData(owner, void 0, computeFn), (r) => {
		if (!store) store = new DisposableStore();
		else store.clear();
		const result = computeFn(r);
		if (result) store.add(result);
		return result;
	}, void 0, () => {
		if (store) {
			store.dispose();
			store = void 0;
		}
	}, strictEquals, debugLocation);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/observableInternal/reactions/autorunImpl.js
function autorunStateToString(state) {
	switch (state) {
		case 1: return "dependenciesMightHaveChanged";
		case 2: return "stale";
		case 3: return "upToDate";
		default: return "<unknown>";
	}
}
var AutorunObserver = class {
	get debugName() {
		return this._debugNameData.getDebugName(this) ?? "(anonymous)";
	}
	constructor(_debugNameData, _runFn, _changeTracker, debugLocation) {
		this._debugNameData = _debugNameData;
		this._runFn = _runFn;
		this._changeTracker = _changeTracker;
		this._state = 2;
		this._updateCount = 0;
		this._disposed = false;
		this._dependencies = /* @__PURE__ */ new Set();
		this._dependenciesToBeRemoved = /* @__PURE__ */ new Set();
		this._isRunning = false;
		this._iteration = 0;
		this._store = void 0;
		this._delayedStore = void 0;
		this._changeSummary = this._changeTracker?.createChangeSummary(void 0);
		getLogger()?.handleAutorunCreated(this, debugLocation);
		this._run();
	}
	dispose() {
		if (this._disposed) return;
		this._disposed = true;
		for (const o of this._dependencies) o.removeObserver(this);
		this._dependencies.clear();
		if (this._store !== void 0) this._store.dispose();
		if (this._delayedStore !== void 0) this._delayedStore.dispose();
		getLogger()?.handleAutorunDisposed(this);
	}
	_run() {
		const emptySet = this._dependenciesToBeRemoved;
		this._dependenciesToBeRemoved = this._dependencies;
		this._dependencies = emptySet;
		this._state = 3;
		try {
			if (!this._disposed) {
				getLogger()?.handleAutorunStarted(this);
				const changeSummary = this._changeSummary;
				const delayedStore = this._delayedStore;
				if (delayedStore !== void 0) this._delayedStore = void 0;
				try {
					this._isRunning = true;
					if (this._changeTracker) {
						this._changeTracker.beforeUpdate?.(this, changeSummary);
						this._changeSummary = this._changeTracker.createChangeSummary(changeSummary);
					}
					if (this._store !== void 0) {
						this._store.dispose();
						this._store = void 0;
					}
					this._runFn(this, changeSummary);
				} catch (e) {
					onBugIndicatingError(e);
				} finally {
					this._isRunning = false;
					if (delayedStore !== void 0) delayedStore.dispose();
				}
			}
		} finally {
			if (!this._disposed) getLogger()?.handleAutorunFinished(this);
			for (const o of this._dependenciesToBeRemoved) o.removeObserver(this);
			this._dependenciesToBeRemoved.clear();
		}
	}
	toString() {
		return `Autorun<${this.debugName}>`;
	}
	beginUpdate(_observable) {
		if (this._state === 3) {
			this._checkIterations();
			this._state = 1;
		}
		this._updateCount++;
	}
	endUpdate(_observable) {
		try {
			if (this._updateCount === 1) {
				this._iteration = 1;
				do {
					if (this._checkIterations()) return;
					if (this._state === 1) {
						this._state = 3;
						for (const d of this._dependencies) {
							d.reportChanges();
							if (this._state === 2) break;
						}
					}
					this._iteration++;
					if (this._state !== 3) this._run();
				} while (this._state !== 3);
			}
		} finally {
			this._updateCount--;
		}
		assertFn(() => this._updateCount >= 0);
	}
	handlePossibleChange(observable) {
		if (this._state === 3 && this._isDependency(observable)) {
			this._checkIterations();
			this._state = 1;
		}
	}
	handleChange(observable, change) {
		if (this._isDependency(observable)) {
			getLogger()?.handleAutorunDependencyChanged(this, observable, change);
			try {
				if (this._changeTracker ? this._changeTracker.handleChange({
					changedObservable: observable,
					change,
					didChange: (o) => o === observable
				}, this._changeSummary) : true) {
					this._checkIterations();
					this._state = 2;
				}
			} catch (e) {
				onBugIndicatingError(e);
			}
		}
	}
	_isDependency(observable) {
		return this._dependencies.has(observable) && !this._dependenciesToBeRemoved.has(observable);
	}
	_ensureNoRunning() {
		if (!this._isRunning) throw new BugIndicatingError("The reader object cannot be used outside its compute function!");
	}
	readObservable(observable) {
		this._ensureNoRunning();
		if (this._disposed) return observable.get();
		observable.addObserver(this);
		const value = observable.get();
		this._dependencies.add(observable);
		this._dependenciesToBeRemoved.delete(observable);
		return value;
	}
	get store() {
		this._ensureNoRunning();
		if (this._disposed) throw new BugIndicatingError("Cannot access store after dispose");
		if (this._store === void 0) this._store = new DisposableStore();
		return this._store;
	}
	get delayedStore() {
		this._ensureNoRunning();
		if (this._disposed) throw new BugIndicatingError("Cannot access store after dispose");
		if (this._delayedStore === void 0) this._delayedStore = new DisposableStore();
		return this._delayedStore;
	}
	debugGetState() {
		return {
			isRunning: this._isRunning,
			updateCount: this._updateCount,
			dependencies: this._dependencies,
			state: this._state,
			stateStr: autorunStateToString(this._state)
		};
	}
	debugRerun() {
		if (!this._isRunning) this._run();
		else this._state = 2;
	}
	_checkIterations() {
		if (this._iteration > 100) {
			onBugIndicatingError(new BugIndicatingError(`Autorun '${this.debugName}' is stuck in an infinite update loop.`));
			return true;
		}
		return false;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/observableInternal/reactions/autorun.js
/**
* Runs immediately and whenever a transaction ends and an observed observable changed.
* {@link fn} should start with a JS Doc using `@description` to name the autorun.
*/
function autorun(fn, debugLocation = DebugLocation.ofCaller()) {
	return new AutorunObserver(new DebugNameData(void 0, void 0, fn), fn, void 0, debugLocation);
}
/**
* Runs immediately and whenever a transaction ends and an observed observable changed.
* {@link fn} should start with a JS Doc using `@description` to name the autorun.
*/
function autorunOpts(options, fn, debugLocation = DebugLocation.ofCaller()) {
	return new AutorunObserver(new DebugNameData(options.owner, options.debugName, options.debugReferenceFn ?? fn), fn, void 0, debugLocation);
}
/**
* Runs immediately and whenever a transaction ends and an observed observable changed.
* {@link fn} should start with a JS Doc using `@description` to name the autorun.
*
* Use `changeTracker.createChangeSummary` to create a "change summary" that can collect the changes.
* Use `changeTracker.handleChange` to add a reported change to the change summary.
* The run function is given the last change summary.
* The change summary is discarded after the run function was called.
*
* @see autorun
*/
function autorunHandleChanges(options, fn, debugLocation = DebugLocation.ofCaller()) {
	return new AutorunObserver(new DebugNameData(options.owner, options.debugName, options.debugReferenceFn ?? fn), fn, options.changeTracker, debugLocation);
}
/**
* @see autorunHandleChanges (but with a disposable store that is cleared before the next run or on dispose)
*/
function autorunWithStoreHandleChanges(options, fn) {
	const store = new DisposableStore();
	const disposable = autorunHandleChanges({
		owner: options.owner,
		debugName: options.debugName,
		debugReferenceFn: options.debugReferenceFn ?? fn,
		changeTracker: options.changeTracker
	}, (reader, changeSummary) => {
		store.clear();
		fn(reader, changeSummary, store);
	});
	return toDisposable(() => {
		disposable.dispose();
		store.dispose();
	});
}
/**
* @see autorun (but with a disposable store that is cleared before the next run or on dispose)
*
* @deprecated Use `autorun(reader => { reader.store.add(...) })` instead!
*/
function autorunWithStore(fn) {
	const store = new DisposableStore();
	const disposable = autorunOpts({
		owner: void 0,
		debugName: void 0,
		debugReferenceFn: fn
	}, (reader) => {
		store.clear();
		fn(reader, store);
	});
	return toDisposable(() => {
		disposable.dispose();
		store.dispose();
	});
}
function autorunDelta(observable, handler) {
	let _lastValue;
	return autorunOpts({ debugReferenceFn: handler }, (reader) => {
		const newValue = observable.read(reader);
		const lastValue = _lastValue;
		_lastValue = newValue;
		handler({
			lastValue,
			newValue
		});
	});
}
/**
* An autorun with a `dispose()` method on its `reader` which cancels the autorun.
* It it safe to call `dispose()` synchronously.
* TODO@hediet/copilot: rename to delete autorunSelfDisposable, and rename autorunSelfDisposable2 to autorunSelfDisposable.
*/
function registerAutorunSelfDisposable(store, fn, debugLocation = DebugLocation.ofCaller()) {
	let ar;
	let disposeSync = false;
	ar = autorun((reader) => {
		fn({
			delayedStore: reader.delayedStore,
			store: reader.store,
			readObservable: reader.readObservable.bind(reader),
			dispose: () => {
				if (!ar) disposeSync = true;
				else store.delete(ar);
			}
		});
	}, debugLocation);
	if (disposeSync) ar.dispose();
	else store.add(ar);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/observableInternal/base.js
/**
* This function is used to indicate that the caller recovered from an error that indicates a bug.
*/
function handleBugIndicatingErrorRecovery(message) {
	const err = /* @__PURE__ */ new Error("BugIndicatingErrorRecovery: " + message);
	onUnexpectedError(err);
	console.error("recovered from an error that indicates a bug", err);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/observableInternal/transaction.js
/**
* Starts a transaction in which many observables can be changed at once.
* {@link fn} should start with a JS Doc using `@description` to give the transaction a debug name.
* Reaction run on demand or when the transaction ends.
*/
function transaction(fn, getDebugName) {
	const tx = new TransactionImpl(fn, getDebugName);
	try {
		fn(tx);
	} finally {
		tx.finish();
	}
}
var _globalTransaction = void 0;
function globalTransaction(fn) {
	if (_globalTransaction) fn(_globalTransaction);
	else {
		const tx = new TransactionImpl(fn, void 0);
		_globalTransaction = tx;
		try {
			fn(tx);
		} finally {
			tx.finish();
			_globalTransaction = void 0;
		}
	}
}
/** @deprecated */
async function asyncTransaction(fn, getDebugName) {
	const tx = new TransactionImpl(fn, getDebugName);
	try {
		await fn(tx);
	} finally {
		tx.finish();
	}
}
/**
* Allows to chain transactions.
*/
function subtransaction(tx, fn, getDebugName) {
	if (!tx) transaction(fn, getDebugName);
	else fn(tx);
}
var TransactionImpl = class {
	constructor(_fn, _getDebugName) {
		this._fn = _fn;
		this._getDebugName = _getDebugName;
		this._updatingObservers = [];
		getLogger()?.handleBeginTransaction(this);
	}
	getDebugName() {
		if (this._getDebugName) return this._getDebugName();
		return getFunctionName(this._fn);
	}
	updateObserver(observer, observable) {
		if (!this._updatingObservers) {
			handleBugIndicatingErrorRecovery("Transaction already finished!");
			transaction((tx) => {
				tx.updateObserver(observer, observable);
			});
			return;
		}
		this._updatingObservers.push({
			observer,
			observable
		});
		observer.beginUpdate(observable);
	}
	finish() {
		const updatingObservers = this._updatingObservers;
		if (!updatingObservers) {
			handleBugIndicatingErrorRecovery("transaction.finish() has already been called!");
			return;
		}
		for (let i = 0; i < updatingObservers.length; i++) {
			const { observer, observable } = updatingObservers[i];
			observer.endUpdate(observable);
		}
		this._updatingObservers = null;
		getLogger()?.handleEndTransaction(this);
	}
	debugGetUpdatingObservers() {
		return this._updatingObservers;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/observableInternal/observables/observableValue.js
function observableValue(nameOrOwner, initialValue, debugLocation = DebugLocation.ofCaller()) {
	let debugNameData;
	if (typeof nameOrOwner === "string") debugNameData = new DebugNameData(void 0, nameOrOwner, void 0);
	else debugNameData = new DebugNameData(nameOrOwner, void 0, void 0);
	return new ObservableValue(debugNameData, initialValue, strictEquals, debugLocation);
}
var ObservableValue = class extends BaseObservable {
	get debugName() {
		return this._debugNameData.getDebugName(this) ?? "ObservableValue";
	}
	constructor(_debugNameData, initialValue, _equalityComparator, debugLocation) {
		super(debugLocation);
		this._debugNameData = _debugNameData;
		this._equalityComparator = _equalityComparator;
		this._value = initialValue;
		getLogger()?.handleObservableUpdated(this, {
			hadValue: false,
			newValue: initialValue,
			change: void 0,
			didChange: true,
			oldValue: void 0
		});
	}
	get() {
		return this._value;
	}
	set(value, tx, change) {
		if (change === void 0 && this._equalityComparator(this._value, value)) return;
		let _tx;
		if (!tx) tx = _tx = new TransactionImpl(() => {}, () => `Setting ${this.debugName}`);
		try {
			const oldValue = this._value;
			this._setValue(value);
			getLogger()?.handleObservableUpdated(this, {
				oldValue,
				newValue: value,
				change,
				didChange: true,
				hadValue: true
			});
			for (const observer of this._observers) {
				tx.updateObserver(observer, this);
				observer.handleChange(this, change);
			}
		} finally {
			if (_tx) _tx.finish();
		}
	}
	toString() {
		return `${this.debugName}: ${this._value}`;
	}
	_setValue(newValue) {
		this._value = newValue;
	}
	debugGetState() {
		return { value: this._value };
	}
	debugSetValue(value) {
		this._value = value;
	}
};
/**
* A disposable observable. When disposed, its value is also disposed.
* When a new value is set, the previous value is disposed.
*/
function disposableObservableValue(nameOrOwner, initialValue, debugLocation = DebugLocation.ofCaller()) {
	let debugNameData;
	if (typeof nameOrOwner === "string") debugNameData = new DebugNameData(void 0, nameOrOwner, void 0);
	else debugNameData = new DebugNameData(nameOrOwner, void 0, void 0);
	return new DisposableObservableValue(debugNameData, initialValue, strictEquals, debugLocation);
}
var DisposableObservableValue = class extends ObservableValue {
	_setValue(newValue) {
		if (this._value === newValue) return;
		if (this._value) this._value.dispose();
		this._value = newValue;
	}
	dispose() {
		this._value?.dispose();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/observableInternal/observables/observableFromEvent.js
function observableFromEvent(...args) {
	let owner;
	let event;
	let getValue;
	let debugLocation;
	if (args.length === 2) [event, getValue] = args;
	else [owner, event, getValue, debugLocation] = args;
	return new FromEventObservable(new DebugNameData(owner, void 0, getValue), event, getValue, () => FromEventObservable.globalTransaction, strictEquals, debugLocation ?? DebugLocation.ofCaller());
}
function observableFromEventOpts(options, event, getValue, debugLocation = DebugLocation.ofCaller()) {
	return new FromEventObservable(new DebugNameData(options.owner, options.debugName, options.debugReferenceFn ?? getValue), event, getValue, () => options.getTransaction?.() ?? FromEventObservable.globalTransaction, options.equalsFn ?? strictEquals, debugLocation);
}
var FromEventObservable = class extends BaseObservable {
	constructor(_debugNameData, event, _getValue, _getTransaction, _equalityComparator, debugLocation) {
		super(debugLocation);
		this._debugNameData = _debugNameData;
		this.event = event;
		this._getValue = _getValue;
		this._getTransaction = _getTransaction;
		this._equalityComparator = _equalityComparator;
		this._hasValue = false;
		this.handleEvent = (args) => {
			const newValue = this._getValue(args);
			const oldValue = this._value;
			const hadValue = this._hasValue;
			const didChange = !hadValue || !this._equalityComparator(oldValue, newValue);
			let didRunTransaction = false;
			if (didChange) {
				this._value = newValue;
				this._hasValue = true;
				if (hadValue) {
					didRunTransaction = true;
					subtransaction(this._getTransaction(), (tx) => {
						getLogger()?.handleObservableUpdated(this, {
							oldValue,
							newValue,
							change: void 0,
							didChange,
							hadValue
						});
						for (const o of this._observers) {
							tx.updateObserver(o, this);
							o.handleChange(this, void 0);
						}
					}, () => {
						const name = this.getDebugName();
						return "Event fired" + (name ? `: ${name}` : "");
					});
				}
			}
			if (!didRunTransaction) getLogger()?.handleObservableUpdated(this, {
				oldValue,
				newValue,
				change: void 0,
				didChange,
				hadValue
			});
		};
	}
	getDebugName() {
		return this._debugNameData.getDebugName(this);
	}
	get debugName() {
		const name = this.getDebugName();
		return "From Event" + (name ? `: ${name}` : "");
	}
	onFirstObserverAdded() {
		this._subscription = this.event(this.handleEvent);
	}
	onLastObserverRemoved() {
		this._subscription.dispose();
		this._subscription = void 0;
		this._hasValue = false;
		this._value = void 0;
	}
	get() {
		if (this._subscription) {
			if (!this._hasValue) this.handleEvent(void 0);
			return this._value;
		} else return this._getValue(void 0);
	}
	debugSetValue(value) {
		this._value = value;
	}
	debugGetState() {
		return {
			value: this._value,
			hasValue: this._hasValue
		};
	}
};
(function(observableFromEvent) {
	observableFromEvent.Observer = FromEventObservable;
	function batchEventsGlobally(tx, fn) {
		let didSet = false;
		if (FromEventObservable.globalTransaction === void 0) {
			FromEventObservable.globalTransaction = tx;
			didSet = true;
		}
		try {
			fn();
		} finally {
			if (didSet) FromEventObservable.globalTransaction = void 0;
		}
	}
	observableFromEvent.batchEventsGlobally = batchEventsGlobally;
})(observableFromEvent || (observableFromEvent = {}));
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/observableInternal/observables/observableSignal.js
function observableSignal(debugNameOrOwner, debugLocation = DebugLocation.ofCaller()) {
	if (typeof debugNameOrOwner === "string") return new ObservableSignal(debugNameOrOwner, void 0, debugLocation);
	else return new ObservableSignal(void 0, debugNameOrOwner, debugLocation);
}
var ObservableSignal = class extends BaseObservable {
	get debugName() {
		return new DebugNameData(this._owner, this._debugName, void 0).getDebugName(this) ?? "Observable Signal";
	}
	toString() {
		return this.debugName;
	}
	constructor(_debugName, _owner, debugLocation) {
		super(debugLocation);
		this._debugName = _debugName;
		this._owner = _owner;
	}
	trigger(tx, change) {
		if (!tx) {
			transaction((tx) => {
				this.trigger(tx, change);
			}, () => `Trigger signal ${this.debugName}`);
			return;
		}
		for (const o of this._observers) {
			tx.updateObserver(o, this);
			o.handleChange(this, change);
		}
	}
	get() {}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/observableInternal/utils/utils.js
function observableFromPromise(promise) {
	const observable = observableValue("promiseValue", {});
	promise.then((value) => {
		observable.set({ value }, void 0);
	});
	return observable;
}
/**
* Creates an observable that debounces the input observable.
*/
function debouncedObservable(observable, debounceMs, debugLocation = DebugLocation.ofCaller()) {
	let hasValue = false;
	let lastValue;
	let timeout = void 0;
	return observableFromEvent(void 0, (cb) => {
		const d = autorun((reader) => {
			const value = observable.read(reader);
			if (!hasValue) {
				hasValue = true;
				lastValue = value;
			} else {
				if (timeout) clearTimeout(timeout);
				timeout = setTimeout(() => {
					lastValue = value;
					cb();
				}, debounceMs);
			}
		});
		return { dispose() {
			d.dispose();
			hasValue = false;
			lastValue = void 0;
		} };
	}, () => {
		if (hasValue) return lastValue;
		else return observable.get();
	}, debugLocation);
}
/**
* Creates an observable that debounces the input observable.
*/
function debouncedObservable2(observable, debounceMs, debugLocation = DebugLocation.ofCaller()) {
	const s = observableSignal("handleTimeout");
	let currentValue = void 0;
	let timeout = void 0;
	return derivedOpts({
		owner: void 0,
		onLastObserverRemoved: () => {
			currentValue = void 0;
		}
	}, (reader) => {
		const val = observable.read(reader);
		s.read(reader);
		if (val !== currentValue) {
			const debounceDuration = typeof debounceMs === "number" ? debounceMs : debounceMs(currentValue, val);
			if (debounceDuration === 0) {
				currentValue = val;
				return val;
			}
			if (timeout) clearTimeout(timeout);
			timeout = setTimeout(() => {
				currentValue = val;
				s.trigger(void 0);
			}, debounceDuration);
		}
		return currentValue;
	}, debugLocation);
}
/**
* This converts the given observable into an autorun.
*/
function recomputeInitiallyAndOnChange(observable, handleValue) {
	const o = new KeepAliveObserver(true, handleValue);
	observable.addObserver(o);
	try {
		o.beginUpdate(observable);
	} finally {
		o.endUpdate(observable);
	}
	return toDisposable(() => {
		observable.removeObserver(o);
	});
}
_setRecomputeInitiallyAndOnChange(recomputeInitiallyAndOnChange);
var KeepAliveObserver = class {
	constructor(_forceRecompute, _handleValue) {
		this._forceRecompute = _forceRecompute;
		this._handleValue = _handleValue;
		this._counter = 0;
	}
	beginUpdate(observable) {
		this._counter++;
	}
	endUpdate(observable) {
		if (this._counter === 1 && this._forceRecompute) {
			if (this._handleValue) this._handleValue(observable.get());
			else observable.reportChanges();
		}
		this._counter--;
	}
	handlePossibleChange(observable) {}
	handleChange(observable, change) {}
};
function derivedObservableWithCache(owner, computeFn) {
	let lastValue = void 0;
	return derivedOpts({
		owner,
		debugReferenceFn: computeFn
	}, (reader) => {
		lastValue = computeFn(reader, lastValue);
		return lastValue;
	});
}
/**
* When the items array changes, referential equal items are not mapped again.
*/
function mapObservableArrayCached(owner, items, map, keySelector) {
	let m = new ArrayMap$1(map, keySelector);
	return derivedOpts({
		debugReferenceFn: map,
		owner,
		onLastObserverRemoved: () => {
			m.dispose();
			m = new ArrayMap$1(map);
		}
	}, (reader) => {
		const i = items.read(reader);
		m.setItems(i);
		return m.getItems();
	});
}
var ArrayMap$1 = class {
	constructor(_map, _keySelector) {
		this._map = _map;
		this._keySelector = _keySelector;
		this._cache = /* @__PURE__ */ new Map();
		this._items = [];
	}
	dispose() {
		this._cache.forEach((entry) => entry.store.dispose());
		this._cache.clear();
	}
	setItems(items) {
		const newItems = [];
		const itemsToRemove = new Set(this._cache.keys());
		for (const item of items) {
			const key = this._keySelector ? this._keySelector(item) : item;
			let entry = this._cache.get(key);
			if (!entry) {
				const store = new DisposableStore();
				entry = {
					out: this._map(item, store),
					store
				};
				this._cache.set(key, entry);
			} else itemsToRemove.delete(key);
			newItems.push(entry.out);
		}
		for (const item of itemsToRemove) {
			this._cache.get(item).store.dispose();
			this._cache.delete(item);
		}
		this._items = newItems;
	}
	getItems() {
		return this._items;
	}
};
function isObservable(obj) {
	return !!obj && obj.read !== void 0 && obj.reportChanges !== void 0;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/observableInternal/logging/consoleObservableLogger.js
function formatValue$1(value, availableLen) {
	switch (typeof value) {
		case "number": return "" + value;
		case "string":
			if (value.length + 2 <= availableLen) return `"${value}"`;
			return `"${value.substr(0, availableLen - 7)}"+...`;
		case "boolean": return value ? "true" : "false";
		case "undefined": return "undefined";
		case "object":
			if (value === null) return "null";
			if (Array.isArray(value)) return formatArray(value, availableLen);
			return formatObject(value, availableLen);
		case "symbol": return value.toString();
		case "function": return `[[Function${value.name ? " " + value.name : ""}]]`;
		default: return "" + value;
	}
}
function formatArray(value, availableLen) {
	let result = "[ ";
	let first = true;
	for (const val of value) {
		if (!first) result += ", ";
		if (result.length - 5 > availableLen) {
			result += "...";
			break;
		}
		first = false;
		result += `${formatValue$1(val, availableLen - result.length)}`;
	}
	result += " ]";
	return result;
}
function formatObject(value, availableLen) {
	if (typeof value.toString === "function" && value.toString !== Object.prototype.toString) {
		const val = value.toString();
		if (val.length <= availableLen) return val;
		return val.substring(0, availableLen - 3) + "...";
	}
	const className = getClassName$1(value);
	let result = className ? className + "(" : "{ ";
	let first = true;
	for (const [key, val] of Object.entries(value)) {
		if (!first) result += ", ";
		if (result.length - 5 > availableLen) {
			result += "...";
			break;
		}
		first = false;
		result += `${key}: ${formatValue$1(val, availableLen - result.length)}`;
	}
	result += className ? ")" : " }";
	return result;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/observableInternal/logging/debugger/rpc.js
var SimpleTypedRpcConnection = class SimpleTypedRpcConnection {
	static createClient(channelFactory, getHandler) {
		return new SimpleTypedRpcConnection(channelFactory, getHandler);
	}
	constructor(_channelFactory, _getHandler) {
		this._channelFactory = _channelFactory;
		this._getHandler = _getHandler;
		this._channel = this._channelFactory({
			handleNotification: (notificationData) => {
				const m = notificationData;
				const fn = this._getHandler().notifications[m[0]];
				if (!fn) throw new Error(`Unknown notification "${m[0]}"!`);
				fn(...m[1]);
			},
			handleRequest: (requestData) => {
				const m = requestData;
				try {
					return {
						type: "result",
						value: this._getHandler().requests[m[0]](...m[1])
					};
				} catch (e) {
					return {
						type: "error",
						value: e
					};
				}
			}
		});
		const requests = new Proxy({}, { get: (target, key) => {
			if (key === "then") return;
			return async (...args) => {
				const result = await this._channel.sendRequest([key, args]);
				if (result.type === "error") throw result.value;
				else return result.value;
			};
		} });
		const notifications = new Proxy({}, { get: (target, key) => {
			if (key === "then") return;
			return (...args) => {
				this._channel.sendNotification([key, args]);
			};
		} });
		this.api = {
			notifications,
			requests
		};
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/observableInternal/logging/debugger/debuggerRpc.js
function registerDebugChannel(channelId, createClient) {
	const g = globalThis;
	let queuedNotifications = [];
	let curHost = void 0;
	const { channel, handler } = createChannelFactoryFromDebugChannel({ sendNotification: (data) => {
		if (curHost) curHost.sendNotification(data);
		else queuedNotifications.push(data);
	} });
	let curClient = void 0;
	(g.$$debugValueEditor_debugChannels ?? (g.$$debugValueEditor_debugChannels = {}))[channelId] = (host) => {
		curClient = createClient();
		curHost = host;
		for (const n of queuedNotifications) host.sendNotification(n);
		queuedNotifications = [];
		return handler;
	};
	return SimpleTypedRpcConnection.createClient(channel, () => {
		if (!curClient) throw new Error("Not supported");
		return curClient;
	});
}
function createChannelFactoryFromDebugChannel(host) {
	let h;
	const channel = (handler) => {
		h = handler;
		return {
			sendNotification: (data) => {
				host.sendNotification(data);
			},
			sendRequest: (data) => {
				throw new Error("not supported");
			}
		};
	};
	return {
		channel,
		handler: { handleRequest: (data) => {
			if (data.type === "notification") return h?.handleNotification(data.data);
			else return h?.handleRequest(data.data);
		} }
	};
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/observableInternal/logging/debugger/utils.js
var Throttler = class {
	constructor() {
		this._timeout = void 0;
	}
	throttle(fn, timeoutMs) {
		if (this._timeout === void 0) this._timeout = setTimeout(() => {
			this._timeout = void 0;
			fn();
		}, timeoutMs);
	}
	dispose() {
		if (this._timeout !== void 0) clearTimeout(this._timeout);
	}
};
function deepAssign(target, source) {
	for (const key in source) if (!!target[key] && typeof target[key] === "object" && !!source[key] && typeof source[key] === "object") deepAssign(target[key], source[key]);
	else target[key] = source[key];
}
function deepAssignDeleteNulls(target, source) {
	for (const key in source) if (source[key] === null) delete target[key];
	else if (!!target[key] && typeof target[key] === "object" && !!source[key] && typeof source[key] === "object") deepAssignDeleteNulls(target[key], source[key]);
	else target[key] = source[key];
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/observableInternal/logging/debugger/devToolsLogger.js
var DevToolsLogger = class DevToolsLogger {
	static {
		this._instance = void 0;
	}
	static getInstance() {
		if (DevToolsLogger._instance === void 0) DevToolsLogger._instance = new DevToolsLogger();
		return DevToolsLogger._instance;
	}
	getTransactionState() {
		const affected = [];
		const txs = [...this._activeTransactions];
		if (txs.length === 0) return;
		const observerQueue = txs.flatMap((t) => t.debugGetUpdatingObservers() ?? []).map((o) => o.observer);
		const processedObservers = /* @__PURE__ */ new Set();
		while (observerQueue.length > 0) {
			const observer = observerQueue.shift();
			if (processedObservers.has(observer)) continue;
			processedObservers.add(observer);
			const state = this._getInfo(observer, (d) => {
				if (!processedObservers.has(d)) observerQueue.push(d);
			});
			if (state) affected.push(state);
		}
		return {
			names: txs.map((t) => t.getDebugName() ?? "tx"),
			affected
		};
	}
	_getObservableInfo(observable) {
		const info = this._instanceInfos.get(observable);
		if (!info) {
			onUnexpectedError(new BugIndicatingError("No info found"));
			return;
		}
		return info;
	}
	_getAutorunInfo(autorun) {
		const info = this._instanceInfos.get(autorun);
		if (!info) {
			onUnexpectedError(new BugIndicatingError("No info found"));
			return;
		}
		return info;
	}
	_getInfo(observer, queue) {
		if (observer instanceof Derived) {
			const observersToUpdate = [...observer.debugGetObservers()];
			for (const o of observersToUpdate) queue(o);
			const info = this._getObservableInfo(observer);
			if (!info) return;
			const observerState = observer.debugGetState();
			const base = {
				name: observer.debugName,
				instanceId: info.instanceId,
				updateCount: observerState.updateCount
			};
			const changedDependencies = [...info.changedObservables].map((o) => this._instanceInfos.get(o)?.instanceId).filter(isDefined);
			if (observerState.isComputing) return {
				...base,
				type: "observable/derived",
				state: "updating",
				changedDependencies,
				initialComputation: false
			};
			switch (observerState.state) {
				case 0: return {
					...base,
					type: "observable/derived",
					state: "noValue"
				};
				case 3: return {
					...base,
					type: "observable/derived",
					state: "upToDate"
				};
				case 2: return {
					...base,
					type: "observable/derived",
					state: "stale",
					changedDependencies
				};
				case 1: return {
					...base,
					type: "observable/derived",
					state: "possiblyStale"
				};
			}
		} else if (observer instanceof AutorunObserver) {
			const info = this._getAutorunInfo(observer);
			if (!info) return;
			const base = {
				name: observer.debugName,
				instanceId: info.instanceId,
				updateCount: info.updateCount
			};
			const changedDependencies = [...info.changedObservables].map((o) => this._instanceInfos.get(o).instanceId);
			if (observer.debugGetState().isRunning) return {
				...base,
				type: "autorun",
				state: "updating",
				changedDependencies
			};
			switch (observer.debugGetState().state) {
				case 3: return {
					...base,
					type: "autorun",
					state: "upToDate"
				};
				case 2: return {
					...base,
					type: "autorun",
					state: "stale",
					changedDependencies
				};
				case 1: return {
					...base,
					type: "autorun",
					state: "possiblyStale"
				};
			}
		}
	}
	_formatObservable(obs) {
		const info = this._getObservableInfo(obs);
		if (!info) return;
		return {
			name: obs.debugName,
			instanceId: info.instanceId
		};
	}
	_formatObserver(obs) {
		if (obs instanceof Derived) return {
			name: obs.toString(),
			instanceId: this._getObservableInfo(obs)?.instanceId
		};
		const autorunInfo = this._getAutorunInfo(obs);
		if (autorunInfo) return {
			name: obs.toString(),
			instanceId: autorunInfo.instanceId
		};
	}
	constructor() {
		this._declarationId = 0;
		this._instanceId = 0;
		this._declarations = /* @__PURE__ */ new Map();
		this._instanceInfos = /* @__PURE__ */ new WeakMap();
		this._aliveInstances = /* @__PURE__ */ new Map();
		this._activeTransactions = /* @__PURE__ */ new Set();
		this._channel = registerDebugChannel("observableDevTools", () => {
			return {
				notifications: {
					setDeclarationIdFilter: (declarationIds) => {},
					logObservableValue: (observableId) => {
						console.log("logObservableValue", observableId);
					},
					flushUpdates: () => {
						this._flushUpdates();
					},
					resetUpdates: () => {
						this._pendingChanges = null;
						this._channel.api.notifications.handleChange(this._fullState, true);
					}
				},
				requests: {
					getDeclarations: () => {
						const result = {};
						for (const decl of this._declarations.values()) result[decl.id] = decl;
						return { decls: result };
					},
					getSummarizedInstances: () => {
						return null;
					},
					getObservableValueInfo: (instanceId) => {
						return { observers: [...this._aliveInstances.get(instanceId).debugGetObservers()].map((d) => this._formatObserver(d)).filter(isDefined) };
					},
					getDerivedInfo: (instanceId) => {
						const d = this._aliveInstances.get(instanceId);
						return {
							dependencies: [...d.debugGetState().dependencies].map((d) => this._formatObservable(d)).filter(isDefined),
							observers: [...d.debugGetObservers()].map((d) => this._formatObserver(d)).filter(isDefined)
						};
					},
					getAutorunInfo: (instanceId) => {
						return { dependencies: [...this._aliveInstances.get(instanceId).debugGetState().dependencies].map((d) => this._formatObservable(d)).filter(isDefined) };
					},
					getTransactionState: () => {
						return this.getTransactionState();
					},
					setValue: (instanceId, jsonValue) => {
						const obs = this._aliveInstances.get(instanceId);
						if (obs instanceof Derived) obs.debugSetValue(jsonValue);
						else if (obs instanceof ObservableValue) obs.debugSetValue(jsonValue);
						else if (obs instanceof FromEventObservable) obs.debugSetValue(jsonValue);
						else throw new BugIndicatingError("Observable is not supported");
						const observers = [...obs.debugGetObservers()];
						for (const d of observers) d.beginUpdate(obs);
						for (const d of observers) d.handleChange(obs, void 0);
						for (const d of observers) d.endUpdate(obs);
					},
					getValue: (instanceId) => {
						const obs = this._aliveInstances.get(instanceId);
						if (obs instanceof Derived) return formatValue$1(obs.debugGetState().value, 200);
						else if (obs instanceof ObservableValue) return formatValue$1(obs.debugGetState().value, 200);
					},
					logValue: (instanceId) => {
						const obs = this._aliveInstances.get(instanceId);
						if (obs && "get" in obs) console.log("Logged Value:", obs.get());
						else throw new BugIndicatingError("Observable is not supported");
					},
					rerun: (instanceId) => {
						const obs = this._aliveInstances.get(instanceId);
						if (obs instanceof Derived) obs.debugRecompute();
						else if (obs instanceof AutorunObserver) obs.debugRerun();
						else throw new BugIndicatingError("Observable is not supported");
					}
				}
			};
		});
		this._pendingChanges = null;
		this._changeThrottler = new Throttler();
		this._fullState = {};
		this._flushUpdates = () => {
			if (this._pendingChanges !== null) {
				this._channel.api.notifications.handleChange(this._pendingChanges, false);
				this._pendingChanges = null;
			}
		};
		DebugLocation.enable();
	}
	_handleChange(update) {
		deepAssignDeleteNulls(this._fullState, update);
		if (this._pendingChanges === null) this._pendingChanges = update;
		else deepAssign(this._pendingChanges, update);
		this._changeThrottler.throttle(this._flushUpdates, 10);
	}
	_getDeclarationId(type, location) {
		if (!location) return -1;
		let decInfo = this._declarations.get(location.id);
		if (decInfo === void 0) {
			decInfo = {
				id: this._declarationId++,
				type,
				url: location.fileName,
				line: location.line,
				column: location.column
			};
			this._declarations.set(location.id, decInfo);
			this._handleChange({ decls: { [decInfo.id]: decInfo } });
		}
		return decInfo.id;
	}
	handleObservableCreated(observable, location) {
		const info = {
			declarationId: this._getDeclarationId("observable/value", location),
			instanceId: this._instanceId++,
			listenerCount: 0,
			lastValue: void 0,
			updateCount: 0,
			changedObservables: /* @__PURE__ */ new Set()
		};
		this._instanceInfos.set(observable, info);
	}
	handleOnListenerCountChanged(observable, newCount) {
		const info = this._getObservableInfo(observable);
		if (!info) return;
		if (info.listenerCount === 0 && newCount > 0) {
			const type = observable instanceof Derived ? "observable/derived" : "observable/value";
			this._aliveInstances.set(info.instanceId, observable);
			this._handleChange({ instances: { [info.instanceId]: {
				instanceId: info.instanceId,
				declarationId: info.declarationId,
				formattedValue: info.lastValue,
				type,
				name: observable.debugName
			} } });
		} else if (info.listenerCount > 0 && newCount === 0) {
			this._handleChange({ instances: { [info.instanceId]: null } });
			this._aliveInstances.delete(info.instanceId);
		}
		info.listenerCount = newCount;
	}
	handleObservableUpdated(observable, changeInfo) {
		if (observable instanceof Derived) {
			this._handleDerivedRecomputed(observable, changeInfo);
			return;
		}
		const info = this._getObservableInfo(observable);
		if (info) {
			if (changeInfo.didChange) {
				info.lastValue = formatValue$1(changeInfo.newValue, 30);
				if (info.listenerCount > 0) this._handleChange({ instances: { [info.instanceId]: { formattedValue: info.lastValue } } });
			}
		}
	}
	handleAutorunCreated(autorun, location) {
		const info = {
			declarationId: this._getDeclarationId("autorun", location),
			instanceId: this._instanceId++,
			updateCount: 0,
			changedObservables: /* @__PURE__ */ new Set()
		};
		this._instanceInfos.set(autorun, info);
		this._aliveInstances.set(info.instanceId, autorun);
		if (info) this._handleChange({ instances: { [info.instanceId]: {
			instanceId: info.instanceId,
			declarationId: info.declarationId,
			runCount: 0,
			type: "autorun",
			name: autorun.debugName
		} } });
	}
	handleAutorunDisposed(autorun) {
		const info = this._getAutorunInfo(autorun);
		if (!info) return;
		this._handleChange({ instances: { [info.instanceId]: null } });
		this._instanceInfos.delete(autorun);
		this._aliveInstances.delete(info.instanceId);
	}
	handleAutorunDependencyChanged(autorun, observable, change) {
		const info = this._getAutorunInfo(autorun);
		if (!info) return;
		info.changedObservables.add(observable);
	}
	handleAutorunStarted(autorun) {}
	handleAutorunFinished(autorun) {
		const info = this._getAutorunInfo(autorun);
		if (!info) return;
		info.changedObservables.clear();
		info.updateCount++;
		this._handleChange({ instances: { [info.instanceId]: { runCount: info.updateCount } } });
	}
	handleDerivedDependencyChanged(derived, observable, change) {
		const info = this._getObservableInfo(derived);
		if (info) info.changedObservables.add(observable);
	}
	_handleDerivedRecomputed(observable, changeInfo) {
		const info = this._getObservableInfo(observable);
		if (!info) return;
		const formattedValue = formatValue$1(changeInfo.newValue, 30);
		info.updateCount++;
		info.changedObservables.clear();
		info.lastValue = formattedValue;
		if (info.listenerCount > 0) this._handleChange({ instances: { [info.instanceId]: {
			formattedValue,
			recomputationCount: info.updateCount
		} } });
	}
	handleDerivedCleared(observable) {
		const info = this._getObservableInfo(observable);
		if (!info) return;
		info.lastValue = void 0;
		info.changedObservables.clear();
		if (info.listenerCount > 0) this._handleChange({ instances: { [info.instanceId]: { formattedValue: void 0 } } });
	}
	handleBeginTransaction(transaction) {
		this._activeTransactions.add(transaction);
	}
	handleEndTransaction(transaction) {
		this._activeTransactions.delete(transaction);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/observableInternal/index.js
if (env && env["VSCODE_DEV_DEBUG_OBSERVABLES"]) addLogger(DevToolsLogger.getInstance());
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/dom.js
var { getWindow, getDocument, getWindows, getWindowsCount, getWindowId, getWindowById, onDidRegisterWindow, onWillUnregisterWindow, onDidUnregisterWindow } = (function() {
	const windows = /* @__PURE__ */ new Map();
	ensureCodeWindow(mainWindow, 1);
	const mainWindowRegistration = {
		window: mainWindow,
		disposables: new DisposableStore()
	};
	windows.set(mainWindow.vscodeWindowId, mainWindowRegistration);
	const onDidRegisterWindow = new Emitter$1();
	const onDidUnregisterWindow = new Emitter$1();
	const onWillUnregisterWindow = new Emitter$1();
	function getWindowById(windowId, fallbackToMain) {
		return (typeof windowId === "number" ? windows.get(windowId) : void 0) ?? (fallbackToMain ? mainWindowRegistration : void 0);
	}
	return {
		onDidRegisterWindow: onDidRegisterWindow.event,
		onWillUnregisterWindow: onWillUnregisterWindow.event,
		onDidUnregisterWindow: onDidUnregisterWindow.event,
		registerWindow(window) {
			if (windows.has(window.vscodeWindowId)) return Disposable.None;
			const disposables = new DisposableStore();
			const registeredWindow = {
				window,
				disposables: disposables.add(new DisposableStore())
			};
			windows.set(window.vscodeWindowId, registeredWindow);
			disposables.add(toDisposable(() => {
				windows.delete(window.vscodeWindowId);
				onDidUnregisterWindow.fire(window);
			}));
			disposables.add(addDisposableListener(window, EventType$1.BEFORE_UNLOAD, () => {
				onWillUnregisterWindow.fire(window);
			}));
			onDidRegisterWindow.fire(registeredWindow);
			return disposables;
		},
		getWindows() {
			return windows.values();
		},
		getWindowsCount() {
			return windows.size;
		},
		getWindowId(targetWindow) {
			return targetWindow.vscodeWindowId;
		},
		hasWindow(windowId) {
			return windows.has(windowId);
		},
		getWindowById,
		getWindow(e) {
			const candidateNode = e;
			if (candidateNode?.ownerDocument?.defaultView) return candidateNode.ownerDocument.defaultView.window;
			const candidateEvent = e;
			if (candidateEvent?.view) return candidateEvent.view.window;
			return mainWindow;
		},
		getDocument(e) {
			return getWindow(e).document;
		}
	};
})();
/**
* A registry for functions that check if a component outside the normal DOM tree has focus.
* This is used to extend the concept of "window has focus" to include things like
* Electron WebContentsViews (browser views) that exist outside the workbench DOM.
*/
var externalFocusCheckers = /* @__PURE__ */ new Set();
/**
* Get the window associated with a focused external component.
* This is used to determine which window should receive UI like dialogs
* when an external component (like a browser view) has focus.
*
* @returns The window of the focused external component, or undefined if none
*/
function getExternalFocusWindow() {
	for (const checker of externalFocusCheckers) {
		const info = checker();
		if (info.hasFocus && info.window) return info.window;
	}
}
function clearNode(node) {
	while (node.firstChild) node.firstChild.remove();
}
var DomListener = class {
	constructor(node, type, handler, options) {
		this._node = node;
		this._type = type;
		this._handler = handler;
		this._options = options || false;
		this._node.addEventListener(this._type, this._handler, this._options);
	}
	dispose() {
		if (!this._handler) return;
		this._node.removeEventListener(this._type, this._handler, this._options);
		this._node = null;
		this._handler = null;
	}
};
function addDisposableListener(node, type, handler, useCaptureOrOptions) {
	return new DomListener(node, type, handler, useCaptureOrOptions);
}
function _wrapAsStandardMouseEvent(targetWindow, handler) {
	return function(e) {
		return handler(new StandardMouseEvent(targetWindow, e));
	};
}
function _wrapAsStandardKeyboardEvent(handler) {
	return function(e) {
		return handler(new StandardKeyboardEvent(e));
	};
}
var addStandardDisposableListener = function addStandardDisposableListener(node, type, handler, useCapture) {
	let wrapHandler = handler;
	if (type === "click" || type === "mousedown" || type === "contextmenu") wrapHandler = _wrapAsStandardMouseEvent(getWindow(node), handler);
	else if (type === "keydown" || type === "keypress" || type === "keyup") wrapHandler = _wrapAsStandardKeyboardEvent(handler);
	return addDisposableListener(node, type, wrapHandler, useCapture);
};
var addStandardDisposableGenericMouseDownListener = function addStandardDisposableListener(node, handler, useCapture) {
	return addDisposableGenericMouseDownListener(node, _wrapAsStandardMouseEvent(getWindow(node), handler), useCapture);
};
function addDisposableGenericMouseDownListener(node, handler, useCapture) {
	return addDisposableListener(node, isIOS && BrowserFeatures.pointerEvents ? EventType$1.POINTER_DOWN : EventType$1.MOUSE_DOWN, handler, useCapture);
}
function addDisposableGenericMouseMoveListener(node, handler, useCapture) {
	return addDisposableListener(node, isIOS && BrowserFeatures.pointerEvents ? EventType$1.POINTER_MOVE : EventType$1.MOUSE_MOVE, handler, useCapture);
}
function addDisposableGenericMouseUpListener(node, handler, useCapture) {
	return addDisposableListener(node, isIOS && BrowserFeatures.pointerEvents ? EventType$1.POINTER_UP : EventType$1.MOUSE_UP, handler, useCapture);
}
/**
* Execute the callback the next time the browser is idle, returning an
* {@link IDisposable} that will cancel the callback when disposed. This wraps
* [requestIdleCallback] so it will fallback to [setTimeout] if the environment
* doesn't support it.
*
* @param targetWindow The window for which to run the idle callback
* @param callback The callback to run when idle, this includes an
* [IdleDeadline] that provides the time alloted for the idle callback by the
* browser. Not respecting this deadline will result in a degraded user
* experience.
* @param timeout A timeout at which point to queue no longer wait for an idle
* callback but queue it on the regular event loop (like setTimeout). Typically
* this should not be used.
*
* [IdleDeadline]: https://developer.mozilla.org/en-US/docs/Web/API/IdleDeadline
* [requestIdleCallback]: https://developer.mozilla.org/en-US/docs/Web/API/Window/requestIdleCallback
* [setTimeout]: https://developer.mozilla.org/en-US/docs/Web/API/Window/setTimeout
*/
function runWhenWindowIdle(targetWindow, callback, timeout) {
	return _runWhenIdle(targetWindow, callback, timeout);
}
/**
* An implementation of the "idle-until-urgent"-strategy as introduced
* here: https://philipwalton.com/articles/idle-until-urgent/
*/
var WindowIdleValue = class extends AbstractIdleValue {
	constructor(targetWindow, executor) {
		super(targetWindow, executor);
	}
};
/**
* Schedule a callback to be run at the next animation frame.
* This allows multiple parties to register callbacks that should run at the next animation frame.
* If currently in an animation frame, `runner` will be executed immediately.
* @return token that can be used to cancel the scheduled runner (only if `runner` was not executed immediately).
*/
var runAtThisOrScheduleAtNextAnimationFrame;
/**
* Schedule a callback to be run at the next animation frame.
* This allows multiple parties to register callbacks that should run at the next animation frame.
* If currently in an animation frame, `runner` will be executed at the next animation frame.
* @return token that can be used to cancel the scheduled runner.
*/
var scheduleAtNextAnimationFrame;
var WindowIntervalTimer = class extends IntervalTimer {
	/**
	*
	* @param node The optional node from which the target window is determined
	*/
	constructor(node) {
		super();
		this.defaultTarget = node && getWindow(node);
	}
	cancelAndSet(runner, interval, targetWindow) {
		return super.cancelAndSet(runner, interval, targetWindow ?? this.defaultTarget);
	}
};
var AnimationFrameQueueItem = class {
	constructor(runner, priority = 0) {
		this._runner = runner;
		this.priority = priority;
		this._canceled = false;
	}
	dispose() {
		this._canceled = true;
	}
	execute() {
		if (this._canceled) return;
		try {
			this._runner();
		} catch (e) {
			onUnexpectedError(e);
		}
	}
	static sort(a, b) {
		return b.priority - a.priority;
	}
};
(function() {
	/**
	* The runners scheduled at the next animation frame
	*/
	const NEXT_QUEUE = /* @__PURE__ */ new Map();
	/**
	* The runners scheduled at the current animation frame
	*/
	const CURRENT_QUEUE = /* @__PURE__ */ new Map();
	/**
	* A flag to keep track if the native requestAnimationFrame was already called
	*/
	const animFrameRequested = /* @__PURE__ */ new Map();
	/**
	* A flag to indicate if currently handling a native requestAnimationFrame callback
	*/
	const inAnimationFrameRunner = /* @__PURE__ */ new Map();
	const animationFrameRunner = (targetWindowId) => {
		animFrameRequested.set(targetWindowId, false);
		const currentQueue = NEXT_QUEUE.get(targetWindowId) ?? [];
		CURRENT_QUEUE.set(targetWindowId, currentQueue);
		NEXT_QUEUE.set(targetWindowId, []);
		inAnimationFrameRunner.set(targetWindowId, true);
		while (currentQueue.length > 0) {
			currentQueue.sort(AnimationFrameQueueItem.sort);
			currentQueue.shift().execute();
		}
		inAnimationFrameRunner.set(targetWindowId, false);
	};
	scheduleAtNextAnimationFrame = (targetWindow, runner, priority = 0) => {
		const targetWindowId = getWindowId(targetWindow);
		const item = new AnimationFrameQueueItem(runner, priority);
		let nextQueue = NEXT_QUEUE.get(targetWindowId);
		if (!nextQueue) {
			nextQueue = [];
			NEXT_QUEUE.set(targetWindowId, nextQueue);
		}
		nextQueue.push(item);
		if (!animFrameRequested.get(targetWindowId)) {
			animFrameRequested.set(targetWindowId, true);
			targetWindow.requestAnimationFrame(() => animationFrameRunner(targetWindowId));
		}
		return item;
	};
	runAtThisOrScheduleAtNextAnimationFrame = (targetWindow, runner, priority) => {
		const targetWindowId = getWindowId(targetWindow);
		if (inAnimationFrameRunner.get(targetWindowId)) {
			const item = new AnimationFrameQueueItem(runner, priority);
			let currentQueue = CURRENT_QUEUE.get(targetWindowId);
			if (!currentQueue) {
				currentQueue = [];
				CURRENT_QUEUE.set(targetWindowId, currentQueue);
			}
			currentQueue.push(item);
			return item;
		} else return scheduleAtNextAnimationFrame(targetWindow, runner, priority);
	};
})();
function getComputedStyle(el) {
	return getWindow(el).getComputedStyle(el, null);
}
function getClientArea(element, defaultValue, fallbackElement) {
	const elWindow = getWindow(element);
	const elDocument = elWindow.document;
	if (element !== elDocument.body) return new Dimension(element.clientWidth, element.clientHeight);
	if (isIOS && elWindow?.visualViewport) return new Dimension(elWindow.visualViewport.width, elWindow.visualViewport.height);
	if (elWindow?.innerWidth && elWindow.innerHeight) return new Dimension(elWindow.innerWidth, elWindow.innerHeight);
	if (elDocument.body && elDocument.body.clientWidth && elDocument.body.clientHeight) return new Dimension(elDocument.body.clientWidth, elDocument.body.clientHeight);
	if (elDocument.documentElement && elDocument.documentElement.clientWidth && elDocument.documentElement.clientHeight) return new Dimension(elDocument.documentElement.clientWidth, elDocument.documentElement.clientHeight);
	throw new Error("Unable to figure out browser width and height");
}
var SizeUtils = class SizeUtils {
	static convertToPixels(element, value) {
		return parseFloat(value) || 0;
	}
	static getDimension(element, cssPropertyName) {
		const computedStyle = getComputedStyle(element);
		const value = computedStyle ? computedStyle.getPropertyValue(cssPropertyName) : "0";
		return SizeUtils.convertToPixels(element, value);
	}
	static getBorderLeftWidth(element) {
		return SizeUtils.getDimension(element, "border-left-width");
	}
	static getBorderRightWidth(element) {
		return SizeUtils.getDimension(element, "border-right-width");
	}
	static getBorderTopWidth(element) {
		return SizeUtils.getDimension(element, "border-top-width");
	}
	static getBorderBottomWidth(element) {
		return SizeUtils.getDimension(element, "border-bottom-width");
	}
	static getPaddingLeft(element) {
		return SizeUtils.getDimension(element, "padding-left");
	}
	static getPaddingRight(element) {
		return SizeUtils.getDimension(element, "padding-right");
	}
	static getPaddingTop(element) {
		return SizeUtils.getDimension(element, "padding-top");
	}
	static getPaddingBottom(element) {
		return SizeUtils.getDimension(element, "padding-bottom");
	}
	static getMarginLeft(element) {
		return SizeUtils.getDimension(element, "margin-left");
	}
	static getMarginTop(element) {
		return SizeUtils.getDimension(element, "margin-top");
	}
	static getMarginRight(element) {
		return SizeUtils.getDimension(element, "margin-right");
	}
	static getMarginBottom(element) {
		return SizeUtils.getDimension(element, "margin-bottom");
	}
};
var Dimension = class Dimension {
	static {
		this.None = new Dimension(0, 0);
	}
	constructor(width, height) {
		this.width = width;
		this.height = height;
	}
	with(width = this.width, height = this.height) {
		if (width !== this.width || height !== this.height) return new Dimension(width, height);
		else return this;
	}
	static is(obj) {
		return typeof obj === "object" && typeof obj.height === "number" && typeof obj.width === "number";
	}
	static lift(obj) {
		if (obj instanceof Dimension) return obj;
		else return new Dimension(obj.width, obj.height);
	}
	static equals(a, b) {
		if (a === b) return true;
		if (!a || !b) return false;
		return a.width === b.width && a.height === b.height;
	}
};
function getTopLeftOffset(element) {
	let offsetParent = element.offsetParent;
	let top = element.offsetTop;
	let left = element.offsetLeft;
	while ((element = element.parentNode) !== null && element !== element.ownerDocument.body && element !== element.ownerDocument.documentElement) {
		top -= element.scrollTop;
		const c = isShadowRoot(element) ? null : getComputedStyle(element);
		if (c) left -= c.direction !== "rtl" ? element.scrollLeft : -element.scrollLeft;
		if (element === offsetParent) {
			left += SizeUtils.getBorderLeftWidth(element);
			top += SizeUtils.getBorderTopWidth(element);
			top += element.offsetTop;
			left += element.offsetLeft;
			offsetParent = element.offsetParent;
		}
	}
	return {
		left,
		top
	};
}
function size(element, width, height) {
	if (typeof width === "number") element.style.width = `${width}px`;
	if (typeof height === "number") element.style.height = `${height}px`;
}
/**
* Returns the position of a dom node relative to the entire page.
*/
function getDomNodePagePosition(domNode) {
	const bb = domNode.getBoundingClientRect();
	const window = getWindow(domNode);
	return {
		left: bb.left + window.scrollX,
		top: bb.top + window.scrollY,
		width: bb.width,
		height: bb.height
	};
}
/**
* Returns the effective zoom on a given element before window zoom level is applied
*/
function getDomNodeZoomLevel(domNode) {
	let testElement = domNode;
	let zoom = 1;
	do {
		const elementZoomLevel = getComputedStyle(testElement).zoom;
		if (elementZoomLevel !== null && elementZoomLevel !== void 0 && elementZoomLevel !== "1") zoom *= elementZoomLevel;
		testElement = testElement.parentElement;
	} while (testElement !== null && testElement !== testElement.ownerDocument.documentElement);
	return zoom;
}
function getTotalWidth(element) {
	const margin = SizeUtils.getMarginLeft(element) + SizeUtils.getMarginRight(element);
	return element.offsetWidth + margin;
}
function getContentWidth(element) {
	const border = SizeUtils.getBorderLeftWidth(element) + SizeUtils.getBorderRightWidth(element);
	const padding = SizeUtils.getPaddingLeft(element) + SizeUtils.getPaddingRight(element);
	return element.offsetWidth - border - padding;
}
function getContentHeight(element) {
	const border = SizeUtils.getBorderTopWidth(element) + SizeUtils.getBorderBottomWidth(element);
	const padding = SizeUtils.getPaddingTop(element) + SizeUtils.getPaddingBottom(element);
	return element.offsetHeight - border - padding;
}
function getTotalHeight(element) {
	const margin = SizeUtils.getMarginTop(element) + SizeUtils.getMarginBottom(element);
	return element.offsetHeight + margin;
}
function isAncestor$1(testChild, testAncestor) {
	return Boolean(testAncestor?.contains(testChild));
}
function findParentWithClass(node, clazz, stopAtClazzOrNode) {
	while (node && node.nodeType === node.ELEMENT_NODE) {
		if (typeof clazz === "string" ? node.classList.contains(clazz) : clazz.every((candidate) => node.classList.contains(candidate))) return node;
		if (stopAtClazzOrNode) {
			if (typeof stopAtClazzOrNode === "string") {
				if (node.classList.contains(stopAtClazzOrNode)) return null;
			} else if (node === stopAtClazzOrNode) return null;
		}
		node = node.parentNode;
	}
	return null;
}
function hasParentWithClass(node, clazz, stopAtClazzOrNode) {
	return !!findParentWithClass(node, clazz, stopAtClazzOrNode);
}
function isShadowRoot(node) {
	return node && !!node.host && !!node.mode;
}
function isInShadowDOM(domNode) {
	return !!getShadowRoot(domNode);
}
function getShadowRoot(domNode) {
	while (domNode.parentNode) {
		if (domNode === domNode.ownerDocument?.body) return null;
		domNode = domNode.parentNode;
	}
	return isShadowRoot(domNode) ? domNode : null;
}
/**
* Returns the active element across all child windows
* based on document focus. Falls back to the main
* window if no window has focus.
*/
function getActiveElement() {
	let result = getActiveDocument().activeElement;
	while (result?.shadowRoot) result = result.shadowRoot.activeElement;
	return result;
}
/**
* Returns true if the focused window active element matches
* the provided element. Falls back to the main window if no
* window has focus.
*/
function isActiveElement(element) {
	return getActiveElement() === element;
}
/**
* Returns true if the focused window active element is contained in
* `ancestor`. Falls back to the main window if no window has focus.
*/
function isAncestorOfActiveElement(ancestor) {
	return isAncestor$1(getActiveElement(), ancestor);
}
/**
* Returns the active document across main and child windows.
* Prefers the window with focus (including external components like browser views),
* otherwise falls back to the main windows document.
*/
function getActiveDocument() {
	if (getWindowsCount() <= 1) return mainWindow.document;
	const focusedDoc = Array.from(getWindows()).map(({ window }) => window.document).find((doc) => doc.hasFocus());
	if (focusedDoc) return focusedDoc;
	const externalWindow = getExternalFocusWindow();
	if (externalWindow) return externalWindow.document;
	return mainWindow.document;
}
/**
* Returns the active window across main and child windows.
* Prefers the window with focus, otherwise falls back to
* the main window.
*/
function getActiveWindow() {
	return getActiveDocument().defaultView?.window ?? mainWindow;
}
var sharedMutationObserver = new class {
	constructor() {
		this.mutationObservers = /* @__PURE__ */ new Map();
	}
	observe(target, disposables, options) {
		let mutationObserversPerTarget = this.mutationObservers.get(target);
		if (!mutationObserversPerTarget) {
			mutationObserversPerTarget = /* @__PURE__ */ new Map();
			this.mutationObservers.set(target, mutationObserversPerTarget);
		}
		const optionsHash = hash(options);
		let mutationObserverPerOptions = mutationObserversPerTarget.get(optionsHash);
		if (!mutationObserverPerOptions) {
			const onDidMutate = new Emitter$1();
			const observer = new MutationObserver((mutations) => onDidMutate.fire(mutations));
			observer.observe(target, options);
			const resolvedMutationObserverPerOptions = mutationObserverPerOptions = {
				users: 1,
				observer,
				onDidMutate: onDidMutate.event
			};
			disposables.add(toDisposable(() => {
				resolvedMutationObserverPerOptions.users -= 1;
				if (resolvedMutationObserverPerOptions.users === 0) {
					onDidMutate.dispose();
					observer.disconnect();
					mutationObserversPerTarget?.delete(optionsHash);
					if (mutationObserversPerTarget?.size === 0) this.mutationObservers.delete(target);
				}
			}));
			mutationObserversPerTarget.set(optionsHash, mutationObserverPerOptions);
		} else mutationObserverPerOptions.users += 1;
		return mutationObserverPerOptions.onDidMutate;
	}
}();
function isHTMLElement(e) {
	return e instanceof HTMLElement || e instanceof getWindow(e).HTMLElement;
}
function isHTMLAnchorElement(e) {
	return e instanceof HTMLAnchorElement || e instanceof getWindow(e).HTMLAnchorElement;
}
function isSVGElement(e) {
	return e instanceof SVGElement || e instanceof getWindow(e).SVGElement;
}
function isMouseEvent(e) {
	return e instanceof MouseEvent || e instanceof getWindow(e).MouseEvent;
}
function isKeyboardEvent(e) {
	return e instanceof KeyboardEvent || e instanceof getWindow(e).KeyboardEvent;
}
var EventType$1 = {
	CLICK: "click",
	AUXCLICK: "auxclick",
	DBLCLICK: "dblclick",
	MOUSE_UP: "mouseup",
	MOUSE_DOWN: "mousedown",
	MOUSE_OVER: "mouseover",
	MOUSE_MOVE: "mousemove",
	MOUSE_OUT: "mouseout",
	MOUSE_ENTER: "mouseenter",
	MOUSE_LEAVE: "mouseleave",
	MOUSE_WHEEL: "wheel",
	POINTER_UP: "pointerup",
	POINTER_DOWN: "pointerdown",
	POINTER_MOVE: "pointermove",
	POINTER_LEAVE: "pointerleave",
	CONTEXT_MENU: "contextmenu",
	KEY_DOWN: "keydown",
	KEY_UP: "keyup",
	BEFORE_UNLOAD: "beforeunload",
	RESIZE: "resize",
	SCROLL: "scroll",
	FOCUS: "focus",
	FOCUS_IN: "focusin",
	FOCUS_OUT: "focusout",
	BLUR: "blur",
	INPUT: "input",
	DRAG_START: "dragstart",
	DRAG: "drag",
	DRAG_ENTER: "dragenter",
	DRAG_LEAVE: "dragleave",
	DRAG_OVER: "dragover",
	DROP: "drop",
	DRAG_END: "dragend"
};
function isEventLike(obj) {
	const candidate = obj;
	return !!(candidate && typeof candidate.preventDefault === "function" && typeof candidate.stopPropagation === "function");
}
var EventHelper = { stop: (e, cancelBubble) => {
	e.preventDefault();
	if (cancelBubble) e.stopPropagation();
	return e;
} };
function saveParentsScrollTop(node) {
	const r = [];
	for (let i = 0; node && node.nodeType === node.ELEMENT_NODE; i++) {
		r[i] = node.scrollTop;
		node = node.parentNode;
	}
	return r;
}
function restoreParentsScrollTop(node, state) {
	for (let i = 0; node && node.nodeType === node.ELEMENT_NODE; i++) {
		if (node.scrollTop !== state[i]) node.scrollTop = state[i];
		node = node.parentNode;
	}
}
var FocusTracker$1 = class FocusTracker$1 extends Disposable {
	get onDidFocus() {
		return this._onDidFocus.event;
	}
	get onDidBlur() {
		return this._onDidBlur.event;
	}
	static hasFocusWithin(element) {
		if (isHTMLElement(element)) {
			const shadowRoot = getShadowRoot(element);
			return isAncestor$1(shadowRoot ? shadowRoot.activeElement : element.ownerDocument.activeElement, element);
		} else {
			const window = element;
			return isAncestor$1(window.document.activeElement, window.document);
		}
	}
	constructor(element) {
		super();
		this._onDidFocus = this._register(new Emitter$1());
		this._onDidBlur = this._register(new Emitter$1());
		let hasFocus = FocusTracker$1.hasFocusWithin(element);
		let loosingFocus = false;
		const onFocus = () => {
			loosingFocus = false;
			if (!hasFocus) {
				hasFocus = true;
				this._onDidFocus.fire();
			}
		};
		const onBlur = () => {
			if (hasFocus) {
				loosingFocus = true;
				(isHTMLElement(element) ? getWindow(element) : element).setTimeout(() => {
					if (loosingFocus) {
						loosingFocus = false;
						hasFocus = false;
						this._onDidBlur.fire();
					}
				}, 0);
			}
		};
		this._refreshStateHandler = () => {
			if (FocusTracker$1.hasFocusWithin(element) !== hasFocus) {
				if (hasFocus) onBlur();
				else onFocus();
			}
		};
		this._register(addDisposableListener(element, EventType$1.FOCUS, onFocus, true));
		this._register(addDisposableListener(element, EventType$1.BLUR, onBlur, true));
		if (isHTMLElement(element)) {
			this._register(addDisposableListener(element, EventType$1.FOCUS_IN, () => this._refreshStateHandler()));
			this._register(addDisposableListener(element, EventType$1.FOCUS_OUT, () => this._refreshStateHandler()));
		}
	}
};
/**
* Creates a new `IFocusTracker` instance that tracks focus changes on the given `element` and its descendants.
*
* @param element The `HTMLElement` or `Window` to track focus changes on.
* @returns An `IFocusTracker` instance.
*/
function trackFocus(element) {
	return new FocusTracker$1(element);
}
function after(sibling, child) {
	sibling.after(child);
	return child;
}
function append$2(parent, ...children) {
	parent.append(...children);
	if (children.length === 1 && typeof children[0] !== "string") return children[0];
}
function prepend$2(parent, child) {
	parent.insertBefore(child, parent.firstChild);
	return child;
}
/**
* Removes all children from `parent` and appends `children`
*/
function reset(parent, ...children) {
	parent.textContent = "";
	append$2(parent, ...children);
}
var SELECTOR_REGEX = /([\w\-]+)?(#([\w\-]+))?((\.([\w\-]+))*)/;
var Namespace;
(function(Namespace) {
	Namespace["HTML"] = "http://www.w3.org/1999/xhtml";
	Namespace["SVG"] = "http://www.w3.org/2000/svg";
})(Namespace || (Namespace = {}));
function _$(namespace, description, attrs, ...children) {
	const match = SELECTOR_REGEX.exec(description);
	if (!match) throw new Error("Bad use of emmet");
	const tagName = match[1] || "div";
	let result;
	if (namespace !== Namespace.HTML) result = document.createElementNS(namespace, tagName);
	else result = document.createElement(tagName);
	if (match[3]) result.id = match[3];
	if (match[4]) result.className = match[4].replace(/\./g, " ").trim();
	if (attrs) Object.entries(attrs).forEach(([name, value]) => {
		if (typeof value === "undefined") return;
		if (/^on\w+$/.test(name)) result[name] = value;
		else if (name === "selected") {
			if (value) result.setAttribute(name, "true");
		} else result.setAttribute(name, value);
	});
	result.append(...children);
	return result;
}
function $$10(description, attrs, ...children) {
	return _$(Namespace.HTML, description, attrs, ...children);
}
$$10.SVG = function(description, attrs, ...children) {
	return _$(Namespace.SVG, description, attrs, ...children);
};
function setVisibility(visible, ...elements) {
	if (visible) show(...elements);
	else hide(...elements);
}
function show(...elements) {
	for (const element of elements) {
		element.style.display = "";
		element.removeAttribute("aria-hidden");
	}
}
function hide(...elements) {
	for (const element of elements) {
		element.style.display = "none";
		element.setAttribute("aria-hidden", "true");
	}
}
/**
* Find a value usable for a dom node size such that the likelihood that it would be
* displayed with constant screen pixels size is as high as possible.
*
* e.g. We would desire for the cursors to be 2px (CSS px) wide. Under a devicePixelRatio
* of 1.25, the cursor will be 2.5 screen pixels wide. Depending on how the dom node aligns/"snaps"
* with the screen pixels, it will sometimes be rendered with 2 screen pixels, and sometimes with 3 screen pixels.
*/
function computeScreenAwareSize(window, cssPx) {
	const screenPx = window.devicePixelRatio * cssPx;
	return Math.max(1, Math.floor(screenPx)) / window.devicePixelRatio;
}
/**
* Open safely a new window. This is the best way to do so, but you cannot tell
* if the window was opened or if it was blocked by the browser's popup blocker.
* If you want to tell if the browser blocked the new window, use {@link windowOpenWithSuccess}.
*
* See https://github.com/microsoft/monaco-editor/issues/601
* To protect against malicious code in the linked site, particularly phishing attempts,
* the window.opener should be set to null to prevent the linked site from having access
* to change the location of the current page.
* See https://mathiasbynens.github.io/rel-noopener/
*/
function windowOpenNoOpener(url) {
	mainWindow.open(url, "_blank", "noopener");
}
function animate(targetWindow, fn) {
	const step = () => {
		fn();
		stepDisposable = scheduleAtNextAnimationFrame(targetWindow, step);
	};
	let stepDisposable = scheduleAtNextAnimationFrame(targetWindow, step);
	return toDisposable(() => stepDisposable.dispose());
}
RemoteAuthorities.setPreferredWebSchema(/^https:/.test(mainWindow.location.href) ? "https" : "http");
var ModifierKeyEmitter = class ModifierKeyEmitter extends Emitter$1 {
	constructor() {
		super();
		this._subscriptions = markAsSingleton(new DisposableStore());
		this._keyStatus = {
			altKey: false,
			shiftKey: false,
			ctrlKey: false,
			metaKey: false
		};
		this._subscriptions.add(Event.runAndSubscribe(onDidRegisterWindow, ({ window, disposables }) => this.registerListeners(window, disposables), {
			window: mainWindow,
			disposables: this._subscriptions
		}));
	}
	registerListeners(window, disposables) {
		disposables.add(addDisposableListener(window, "keydown", (e) => {
			if (e.defaultPrevented) return;
			const event = new StandardKeyboardEvent(e);
			if (event.keyCode === 6 && e.repeat) return;
			if (e.altKey && !this._keyStatus.altKey) this._keyStatus.lastKeyPressed = "alt";
			else if (e.ctrlKey && !this._keyStatus.ctrlKey) this._keyStatus.lastKeyPressed = "ctrl";
			else if (e.metaKey && !this._keyStatus.metaKey) this._keyStatus.lastKeyPressed = "meta";
			else if (e.shiftKey && !this._keyStatus.shiftKey) this._keyStatus.lastKeyPressed = "shift";
			else if (event.keyCode !== 6) this._keyStatus.lastKeyPressed = void 0;
			else return;
			this._keyStatus.altKey = e.altKey;
			this._keyStatus.ctrlKey = e.ctrlKey;
			this._keyStatus.metaKey = e.metaKey;
			this._keyStatus.shiftKey = e.shiftKey;
			if (this._keyStatus.lastKeyPressed) {
				this._keyStatus.event = e;
				this.fire(this._keyStatus);
			}
		}, true));
		disposables.add(addDisposableListener(window, "keyup", (e) => {
			if (e.defaultPrevented) return;
			if (!e.altKey && this._keyStatus.altKey) this._keyStatus.lastKeyReleased = "alt";
			else if (!e.ctrlKey && this._keyStatus.ctrlKey) this._keyStatus.lastKeyReleased = "ctrl";
			else if (!e.metaKey && this._keyStatus.metaKey) this._keyStatus.lastKeyReleased = "meta";
			else if (!e.shiftKey && this._keyStatus.shiftKey) this._keyStatus.lastKeyReleased = "shift";
			else this._keyStatus.lastKeyReleased = void 0;
			if (this._keyStatus.lastKeyPressed !== this._keyStatus.lastKeyReleased) this._keyStatus.lastKeyPressed = void 0;
			this._keyStatus.altKey = e.altKey;
			this._keyStatus.ctrlKey = e.ctrlKey;
			this._keyStatus.metaKey = e.metaKey;
			this._keyStatus.shiftKey = e.shiftKey;
			if (this._keyStatus.lastKeyReleased) {
				this._keyStatus.event = e;
				this.fire(this._keyStatus);
			}
		}, true));
		disposables.add(addDisposableListener(window.document.body, "mousedown", () => {
			this._keyStatus.lastKeyPressed = void 0;
		}, true));
		disposables.add(addDisposableListener(window.document.body, "mouseup", () => {
			this._keyStatus.lastKeyPressed = void 0;
		}, true));
		disposables.add(addDisposableListener(window.document.body, "mousemove", (e) => {
			if (e.buttons) this._keyStatus.lastKeyPressed = void 0;
		}, true));
		disposables.add(addDisposableListener(window, "blur", () => {
			this.resetKeyStatus();
		}));
	}
	get keyStatus() {
		return this._keyStatus;
	}
	/**
	* Allows to explicitly reset the key status based on more knowledge (#109062)
	*/
	resetKeyStatus() {
		this.doResetKeyStatus();
		this.fire(this._keyStatus);
	}
	doResetKeyStatus() {
		this._keyStatus = {
			altKey: false,
			shiftKey: false,
			ctrlKey: false,
			metaKey: false
		};
	}
	static getInstance() {
		if (!ModifierKeyEmitter.instance) ModifierKeyEmitter.instance = new ModifierKeyEmitter();
		return ModifierKeyEmitter.instance;
	}
	dispose() {
		super.dispose();
		this._subscriptions.dispose();
	}
};
var DragAndDropObserver = class extends Disposable {
	constructor(element, callbacks) {
		super();
		this.element = element;
		this.callbacks = callbacks;
		this.counter = 0;
		this.dragStartTime = 0;
		this.registerListeners();
	}
	registerListeners() {
		if (this.callbacks.onDragStart) this._register(addDisposableListener(this.element, EventType$1.DRAG_START, (e) => {
			this.callbacks.onDragStart?.(e);
		}));
		if (this.callbacks.onDrag) this._register(addDisposableListener(this.element, EventType$1.DRAG, (e) => {
			this.callbacks.onDrag?.(e);
		}));
		this._register(addDisposableListener(this.element, EventType$1.DRAG_ENTER, (e) => {
			this.counter++;
			this.dragStartTime = e.timeStamp;
			this.callbacks.onDragEnter?.(e);
		}));
		this._register(addDisposableListener(this.element, EventType$1.DRAG_OVER, (e) => {
			e.preventDefault();
			this.callbacks.onDragOver?.(e, e.timeStamp - this.dragStartTime);
		}));
		this._register(addDisposableListener(this.element, EventType$1.DRAG_LEAVE, (e) => {
			this.counter--;
			if (this.counter === 0) {
				this.dragStartTime = 0;
				this.callbacks.onDragLeave?.(e);
			}
		}));
		this._register(addDisposableListener(this.element, EventType$1.DRAG_END, (e) => {
			this.counter = 0;
			this.dragStartTime = 0;
			this.callbacks.onDragEnd?.(e);
		}));
		this._register(addDisposableListener(this.element, EventType$1.DROP, (e) => {
			this.counter = 0;
			this.dragStartTime = 0;
			this.callbacks.onDrop?.(e);
		}));
	}
};
/**
* A wrapper around `ResizeObserver` that is disposable.
*
* Behavior is intentionally identical to using `new ResizeObserver(callback)`
* directly: the user-supplied callback runs synchronously inside the
* browser's resize-observation phase, with the entries the browser delivered.
* The wrapper adds three things on top:
*
* 1. Lifetime management: `dispose()` disconnects the underlying observer.
* 2. Auxiliary-window support: pass `targetWindow` so the observer is
*    constructed in the realm of the element being observed.
* 3. Context for the
*    `ResizeObserver loop completed with undelivered notifications` warning:
*    each instance carries a stable `name`, and just before invoking the user
*    callback we add that name to a bounded, per-window set that is cleared
*    at the next animation frame. The warning is delivered as a stackless
*    `ErrorEvent` on `window` after callbacks run, so error telemetry can
*    include the wrapped observers that recently ran in that window (see
*    {@link getRecentDisposableResizeObserverContextForLoopError}). This is
*    delivery context, not causal attribution: the browser does not expose
*    which observer or skipped target caused the warning.
*
* @param name Stable identifier used in loop-warning context. Prefer one that
* survives minification and refactors (e.g. the consumer class + purpose)
* since callstacks change across releases.
* @param callback Invoked synchronously when the browser delivers resize
* notifications, with the same entries the native `ResizeObserver` would
* have delivered.
* @param targetWindow The window whose `ResizeObserver` constructor should
* be used. Defaults to `mainWindow`. Pass the containing window when
* creating an observer for elements that live in an auxiliary window.
* @param options Optional configuration. `resizeObserverCtor` is a test
* seam that defaults to `targetWindow.ResizeObserver`.
*/
var DisposableResizeObserver = class extends Disposable {
	constructor(name, callback, targetWindow = mainWindow, options) {
		super();
		this.name = name;
		const ctor = options?.resizeObserverCtor ?? targetWindow.ResizeObserver;
		this.observer = new ctor((entries, observer) => {
			recordDisposableResizeObserverInvocation(targetWindow, this.name);
			try {
				callback(entries, observer);
			} catch (e) {
				onUnexpectedError(e);
			}
		});
		this._register(toDisposable(() => this.observer.disconnect()));
	}
	observe(target, options) {
		this.observer.observe(target, options);
		return toDisposable(() => this.observer.unobserve(target));
	}
};
/**
* Keep the context bounded so a large delivery phase cannot create an
* unbounded telemetry value. Names are static component identifiers, and are
* sorted when read so equivalent phases share a stable bucket.
*/
var maxRecentDisposableResizeObservers = 8;
var recentDisposableResizeObserverContexts = /* @__PURE__ */ new WeakMap();
function recordDisposableResizeObserverInvocation(targetWindow, name) {
	let context = recentDisposableResizeObserverContexts.get(targetWindow);
	if (!context) {
		context = {
			names: /* @__PURE__ */ new Set(),
			overflow: false
		};
		recentDisposableResizeObserverContexts.set(targetWindow, context);
		targetWindow.requestAnimationFrame(() => recentDisposableResizeObserverContexts.delete(targetWindow));
	}
	if (context.names.has(name)) return;
	if (context.names.size < maxRecentDisposableResizeObservers) context.names.add(name);
	else {
		context.overflow = true;
		const largestName = Array.from(context.names).sort().at(-1);
		if (name < largestName) {
			context.names.delete(largestName);
			context.names.add(name);
		}
	}
}
var H_REGEX = /(?<tag>[\w\-]+)?(?:#(?<id>[\w\-]+))?(?<class>(?:\.(?:[\w\-]+))*)(?:@(?<name>(?:[\w\_])+))?/;
function h(tag, ...args) {
	let attributes;
	let children;
	if (Array.isArray(args[0])) {
		attributes = {};
		children = args[0];
	} else {
		attributes = args[0] || {};
		children = args[1];
	}
	const match = H_REGEX.exec(tag);
	if (!match || !match.groups) throw new Error("Bad use of h");
	const tagName = match.groups["tag"] || "div";
	const el = document.createElement(tagName);
	if (match.groups["id"]) el.id = match.groups["id"];
	const classNames = [];
	if (match.groups["class"]) {
		for (const className of match.groups["class"].split(".")) if (className !== "") classNames.push(className);
	}
	if (attributes.className !== void 0) {
		for (const className of attributes.className.split(".")) if (className !== "") classNames.push(className);
	}
	if (classNames.length > 0) el.className = classNames.join(" ");
	const result = {};
	if (match.groups["name"]) result[match.groups["name"]] = el;
	if (children) {
		for (const c of children) if (isHTMLElement(c)) el.appendChild(c);
		else if (typeof c === "string") el.append(c);
		else if ("root" in c) {
			Object.assign(result, c);
			el.appendChild(c.root);
		}
	}
	for (const [key, value] of Object.entries(attributes)) if (key === "className") continue;
	else if (key === "style") for (const [cssKey, cssValue] of Object.entries(value)) el.style.setProperty(camelCaseToHyphenCase(cssKey), typeof cssValue === "number" ? cssValue + "px" : "" + cssValue);
	else if (key === "tabIndex") el.tabIndex = value;
	else el.setAttribute(camelCaseToHyphenCase(key), value.toString());
	result["root"] = el;
	return result;
}
function camelCaseToHyphenCase(str) {
	return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function copyAttributes(from, to, filter) {
	for (const { name, value } of from.attributes) to.setAttribute(name, value);
}
function isEditableElement(element) {
	return element.tagName.toLowerCase() === "input" || element.tagName.toLowerCase() === "textarea" || isHTMLElement(element) && !!element.editContext;
}
/**
* Helper for calculating the "safe triangle" occluded by hovers to avoid early dismissal.
* @see https://www.smashingmagazine.com/2023/08/better-context-menus-safe-triangles/ for example
*/
var SafeTriangle = class {
	constructor(originX, originY, target) {
		this.originX = originX;
		this.originY = originY;
		this.points = /* @__PURE__ */ new Int16Array(8);
		const { top, left, right, bottom } = target.getBoundingClientRect();
		const t = this.points;
		let i = 0;
		t[i++] = left;
		t[i++] = top;
		t[i++] = right;
		t[i++] = top;
		t[i++] = left;
		t[i++] = bottom;
		t[i++] = right;
		t[i++] = bottom;
	}
	contains(x, y) {
		const { points, originX, originY } = this;
		for (let i = 0; i < 4; i++) {
			const p1 = 2 * i;
			const p2 = 2 * ((i + 1) % 4);
			if (isPointWithinTriangle(x, y, originX, originY, points[p1], points[p1 + 1], points[p2], points[p2 + 1])) return true;
		}
		return false;
	}
};
var n;
(function(n) {
	function nodeNs(elementNs = void 0) {
		return (tag, attributes, children) => {
			const className = attributes.class;
			delete attributes.class;
			const ref = attributes.ref;
			delete attributes.ref;
			const obsRef = attributes.obsRef;
			delete attributes.obsRef;
			return new ObserverNodeWithElement(tag, ref, obsRef, elementNs, className, attributes, children);
		};
	}
	function node(tag, elementNs = void 0) {
		const f = nodeNs(elementNs);
		return (attributes, children) => {
			return f(tag, attributes, children);
		};
	}
	n.div = node("div");
	n.elem = nodeNs(void 0);
	n.svg = node("svg", "http://www.w3.org/2000/svg");
	n.svgElem = nodeNs("http://www.w3.org/2000/svg");
	function ref() {
		let value = void 0;
		const result = function(val) {
			value = val;
		};
		Object.defineProperty(result, "element", { get() {
			if (!value) throw new BugIndicatingError("Make sure the ref is set before accessing the element. Maybe wrong initialization order?");
			return value;
		} });
		return result;
	}
	n.ref = ref;
})(n || (n = {}));
var ObserverNode = class ObserverNode {
	constructor(tag, ref, obsRef, ns, className, attributes, children) {
		this._deriveds = [];
		this._isHovered = void 0;
		this._didMouseMoveDuringHover = void 0;
		this._element = ns ? document.createElementNS(ns, tag) : document.createElement(tag);
		if (ref) ref(this._element);
		if (obsRef) this._deriveds.push(derived((_reader) => {
			obsRef(this);
			_reader.store.add({ dispose: () => {
				obsRef(null);
			} });
		}));
		if (className) {
			if (hasObservable(className)) this._deriveds.push(derived(this, (reader) => {
				/** @description set.class */
				setClassName(this._element, getClassName(className, reader));
			}));
			else setClassName(this._element, getClassName(className, void 0));
		}
		for (const [key, value] of Object.entries(attributes)) if (key === "style") for (const [cssKey, cssValue] of Object.entries(value)) {
			const key = camelCaseToHyphenCase(cssKey);
			if (isObservable(cssValue)) this._deriveds.push(derivedOpts({
				owner: this,
				debugName: () => `set.style.${key}`
			}, (reader) => {
				this._element.style.setProperty(key, convertCssValue(cssValue.read(reader)));
			}));
			else this._element.style.setProperty(key, convertCssValue(cssValue));
		}
		else if (key === "tabIndex") {
			if (isObservable(value)) this._deriveds.push(derived(this, (reader) => {
				/** @description set.tabIndex */
				this._element.tabIndex = value.read(reader);
			}));
			else this._element.tabIndex = value;
		} else if (key.startsWith("on")) this._element[key] = value;
		else if (isObservable(value)) this._deriveds.push(derivedOpts({
			owner: this,
			debugName: () => `set.${key}`
		}, (reader) => {
			setOrRemoveAttribute(this._element, key, value.read(reader));
		}));
		else setOrRemoveAttribute(this._element, key, value);
		if (children) {
			function getChildren(reader, children) {
				if (isObservable(children)) return getChildren(reader, children.read(reader));
				if (Array.isArray(children)) return children.flatMap((c) => getChildren(reader, c));
				if (children instanceof ObserverNode) {
					if (reader) children.readEffect(reader);
					return [children._element];
				}
				if (children) return [children];
				return [];
			}
			const d = derived(this, (reader) => {
				/** @description set.children */
				this._element.replaceChildren(...getChildren(reader, children));
			});
			this._deriveds.push(d);
			if (!childrenIsObservable(children)) d.get();
		}
	}
	readEffect(reader) {
		for (const d of this._deriveds) d.read(reader);
	}
	keepUpdated(store) {
		derived((reader) => {
			/** update */
			this.readEffect(reader);
		}).recomputeInitiallyAndOnChange(store);
		return this;
	}
	/**
	* Creates a live element that will keep the element updated as long as the returned object is not disposed.
	*/
	toDisposableLiveElement() {
		const store = new DisposableStore();
		this.keepUpdated(store);
		return new LiveElement(this._element, store);
	}
	get isHovered() {
		if (!this._isHovered) {
			const hovered = observableValue("hovered", false);
			this._element.addEventListener("mouseenter", (_e) => hovered.set(true, void 0));
			this._element.addEventListener("mouseleave", (_e) => hovered.set(false, void 0));
			this._isHovered = hovered;
		}
		return this._isHovered;
	}
	get didMouseMoveDuringHover() {
		if (!this._didMouseMoveDuringHover) {
			let _hovering = false;
			const hovered = observableValue("didMouseMoveDuringHover", false);
			this._element.addEventListener("mouseenter", (_e) => {
				_hovering = true;
			});
			this._element.addEventListener("mousemove", (_e) => {
				if (_hovering) hovered.set(true, void 0);
			});
			this._element.addEventListener("mouseleave", (_e) => {
				_hovering = false;
				hovered.set(false, void 0);
			});
			this._didMouseMoveDuringHover = hovered;
		}
		return this._didMouseMoveDuringHover;
	}
};
function setClassName(domNode, className) {
	if (isSVGElement(domNode)) domNode.setAttribute("class", className);
	else domNode.className = className;
}
function resolve(value, reader, cb) {
	if (isObservable(value)) {
		cb(value.read(reader));
		return;
	}
	if (Array.isArray(value)) {
		for (const v of value) resolve(v, reader, cb);
		return;
	}
	cb(value);
}
function getClassName(className, reader) {
	let result = "";
	resolve(className, reader, (val) => {
		if (val) {
			if (result.length === 0) result = val;
			else result += " " + val;
		}
	});
	return result;
}
function hasObservable(value) {
	if (isObservable(value)) return true;
	if (Array.isArray(value)) return value.some((v) => hasObservable(v));
	return false;
}
function convertCssValue(value) {
	if (typeof value === "number") return value + "px";
	return value;
}
function childrenIsObservable(children) {
	if (isObservable(children)) return true;
	if (Array.isArray(children)) return children.some((c) => childrenIsObservable(c));
	return false;
}
var LiveElement = class {
	constructor(element, _disposable) {
		this.element = element;
		this._disposable = _disposable;
	}
	dispose() {
		this._disposable.dispose();
	}
};
var ObserverNodeWithElement = class extends ObserverNode {
	get element() {
		return this._element;
	}
};
function setOrRemoveAttribute(element, key, value) {
	if (value === null || value === void 0) element.removeAttribute(camelCaseToHyphenCase(key));
	else element.setAttribute(camelCaseToHyphenCase(key), String(value));
}
/**
* A custom element that fires callbacks when connected to or disconnected from the DOM.
* Useful for tracking whether a template or component is currently mounted, especially
* with iframes/webviews that are sensitive to movement.
*
* @example
* ```ts
* const observer = document.createElement('connection-observer') as ConnectionObserverElement;
* observer.onDidConnect = () => console.log('mounted');
* observer.onDidDisconnect = () => console.log('unmounted');
* container.appendChild(observer);
* ```
*/
var ConnectionObserverElement = class extends HTMLElement {
	disconnectedCallback() {
		this.onDidDisconnect?.();
	}
	connectedCallback() {
		this.onDidConnect?.();
	}
};
if (!customElements.get("connection-observer")) customElements.define("connection-observer", ConnectionObserverElement);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/pixelRatio.js
/**
* See https://developer.mozilla.org/en-US/docs/Web/API/Window/devicePixelRatio#monitoring_screen_resolution_or_zoom_level_changes
*/
var DevicePixelRatioMonitor = class extends Disposable {
	constructor(targetWindow) {
		super();
		this._onDidChange = this._register(new Emitter$1());
		this.onDidChange = this._onDidChange.event;
		this._listener = () => this._handleChange(targetWindow, true);
		this._mediaQueryList = null;
		this._handleChange(targetWindow, false);
		this._register(toDisposable(() => this._mediaQueryList?.removeEventListener("change", this._listener)));
	}
	_handleChange(targetWindow, fireEvent) {
		this._mediaQueryList?.removeEventListener("change", this._listener);
		this._mediaQueryList = targetWindow.matchMedia(`(resolution: ${targetWindow.devicePixelRatio}dppx)`);
		this._mediaQueryList.addEventListener("change", this._listener);
		if (fireEvent) this._onDidChange.fire();
	}
};
var PixelRatioMonitorImpl = class extends Disposable {
	get value() {
		return this._value;
	}
	constructor(targetWindow) {
		super();
		this._onDidChange = this._register(new Emitter$1());
		this.onDidChange = this._onDidChange.event;
		this._value = this._getPixelRatio(targetWindow);
		const dprMonitor = this._register(new DevicePixelRatioMonitor(targetWindow));
		this._register(dprMonitor.onDidChange(() => {
			this._value = this._getPixelRatio(targetWindow);
			this._onDidChange.fire(this._value);
		}));
	}
	_getPixelRatio(targetWindow) {
		const ctx = document.createElement("canvas").getContext("2d");
		return (targetWindow.devicePixelRatio || 1) / (ctx?.webkitBackingStorePixelRatio || ctx?.mozBackingStorePixelRatio || ctx?.msBackingStorePixelRatio || ctx?.oBackingStorePixelRatio || ctx?.backingStorePixelRatio || 1);
	}
};
var PixelRatioMonitorFacade = class {
	constructor() {
		this.mapWindowIdToPixelRatioMonitor = /* @__PURE__ */ new Map();
	}
	_getOrCreatePixelRatioMonitor(targetWindow) {
		const targetWindowId = getWindowId(targetWindow);
		let pixelRatioMonitor = this.mapWindowIdToPixelRatioMonitor.get(targetWindowId);
		if (!pixelRatioMonitor) {
			pixelRatioMonitor = markAsSingleton(new PixelRatioMonitorImpl(targetWindow));
			this.mapWindowIdToPixelRatioMonitor.set(targetWindowId, pixelRatioMonitor);
			markAsSingleton(Event.once(onDidUnregisterWindow)(({ vscodeWindowId }) => {
				if (vscodeWindowId === targetWindowId) {
					pixelRatioMonitor?.dispose();
					this.mapWindowIdToPixelRatioMonitor.delete(targetWindowId);
				}
			}));
		}
		return pixelRatioMonitor;
	}
	getInstance(targetWindow) {
		return this._getOrCreatePixelRatioMonitor(targetWindow);
	}
};
/**
* Returns the pixel ratio.
*
* This is useful for rendering <canvas> elements at native screen resolution or for being used as
* a cache key when storing font measurements. Fonts might render differently depending on resolution
* and any measurements need to be discarded for example when a window is moved from a monitor to another.
*/
var PixelRatio = new PixelRatioMonitorFacade();
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/fastDomNode.js
var FastDomNode = class {
	constructor(domNode) {
		this.domNode = domNode;
		this._maxWidth = "";
		this._width = "";
		this._height = "";
		this._top = "";
		this._left = "";
		this._bottom = "";
		this._right = "";
		this._paddingLeft = "";
		this._fontFamily = "";
		this._fontWeight = "";
		this._fontSize = "";
		this._fontStyle = "";
		this._fontFeatureSettings = "";
		this._fontVariationSettings = "";
		this._textDecoration = "";
		this._lineHeight = "";
		this._letterSpacing = "";
		this._className = "";
		this._display = "";
		this._position = "";
		this._visibility = "";
		this._color = "";
		this._backgroundColor = "";
		this._layerHint = false;
		this._contain = "none";
		this._boxShadow = "";
	}
	focus() {
		this.domNode.focus();
	}
	setMaxWidth(_maxWidth) {
		const maxWidth = numberAsPixels(_maxWidth);
		if (this._maxWidth === maxWidth) return;
		this._maxWidth = maxWidth;
		this.domNode.style.maxWidth = this._maxWidth;
	}
	setWidth(_width) {
		const width = numberAsPixels(_width);
		if (this._width === width) return;
		this._width = width;
		this.domNode.style.width = this._width;
	}
	setHeight(_height) {
		const height = numberAsPixels(_height);
		if (this._height === height) return;
		this._height = height;
		this.domNode.style.height = this._height;
	}
	setTop(_top) {
		const top = numberAsPixels(_top);
		if (this._top === top) return;
		this._top = top;
		this.domNode.style.top = this._top;
	}
	setLeft(_left) {
		const left = numberAsPixels(_left);
		if (this._left === left) return;
		this._left = left;
		this.domNode.style.left = this._left;
	}
	setBottom(_bottom) {
		const bottom = numberAsPixels(_bottom);
		if (this._bottom === bottom) return;
		this._bottom = bottom;
		this.domNode.style.bottom = this._bottom;
	}
	setRight(_right) {
		const right = numberAsPixels(_right);
		if (this._right === right) return;
		this._right = right;
		this.domNode.style.right = this._right;
	}
	setPaddingLeft(_paddingLeft) {
		const paddingLeft = numberAsPixels(_paddingLeft);
		if (this._paddingLeft === paddingLeft) return;
		this._paddingLeft = paddingLeft;
		this.domNode.style.paddingLeft = this._paddingLeft;
	}
	setFontFamily(fontFamily) {
		if (this._fontFamily === fontFamily) return;
		this._fontFamily = fontFamily;
		this.domNode.style.fontFamily = this._fontFamily;
	}
	setFontWeight(fontWeight) {
		if (this._fontWeight === fontWeight) return;
		this._fontWeight = fontWeight;
		this.domNode.style.fontWeight = this._fontWeight;
	}
	setFontSize(_fontSize) {
		const fontSize = numberAsPixels(_fontSize);
		if (this._fontSize === fontSize) return;
		this._fontSize = fontSize;
		this.domNode.style.fontSize = this._fontSize;
	}
	setFontStyle(fontStyle) {
		if (this._fontStyle === fontStyle) return;
		this._fontStyle = fontStyle;
		this.domNode.style.fontStyle = this._fontStyle;
	}
	setFontFeatureSettings(fontFeatureSettings) {
		if (this._fontFeatureSettings === fontFeatureSettings) return;
		this._fontFeatureSettings = fontFeatureSettings;
		this.domNode.style.fontFeatureSettings = this._fontFeatureSettings;
	}
	setFontVariationSettings(fontVariationSettings) {
		if (this._fontVariationSettings === fontVariationSettings) return;
		this._fontVariationSettings = fontVariationSettings;
		this.domNode.style.fontVariationSettings = this._fontVariationSettings;
	}
	setTextDecoration(textDecoration) {
		if (this._textDecoration === textDecoration) return;
		this._textDecoration = textDecoration;
		this.domNode.style.textDecoration = this._textDecoration;
	}
	setLineHeight(_lineHeight) {
		const lineHeight = numberAsPixels(_lineHeight);
		if (this._lineHeight === lineHeight) return;
		this._lineHeight = lineHeight;
		this.domNode.style.lineHeight = this._lineHeight;
	}
	setLetterSpacing(_letterSpacing) {
		const letterSpacing = numberAsPixels(_letterSpacing);
		if (this._letterSpacing === letterSpacing) return;
		this._letterSpacing = letterSpacing;
		this.domNode.style.letterSpacing = this._letterSpacing;
	}
	setClassName(className) {
		if (this._className === className) return;
		this._className = className;
		this.domNode.className = this._className;
	}
	toggleClassName(className, shouldHaveIt) {
		this.domNode.classList.toggle(className, shouldHaveIt);
		this._className = this.domNode.className;
	}
	setDisplay(display) {
		if (this._display === display) return;
		this._display = display;
		this.domNode.style.display = this._display;
	}
	setPosition(position) {
		if (this._position === position) return;
		this._position = position;
		this.domNode.style.position = this._position;
	}
	setVisibility(visibility) {
		if (this._visibility === visibility) return;
		this._visibility = visibility;
		this.domNode.style.visibility = this._visibility;
	}
	setColor(color) {
		if (this._color === color) return;
		this._color = color;
		this.domNode.style.color = this._color;
	}
	setBackgroundColor(backgroundColor) {
		if (this._backgroundColor === backgroundColor) return;
		this._backgroundColor = backgroundColor;
		this.domNode.style.backgroundColor = this._backgroundColor;
	}
	setLayerHinting(layerHint) {
		if (this._layerHint === layerHint) return;
		this._layerHint = layerHint;
		this.domNode.style.transform = this._layerHint ? "translate3d(0px, 0px, 0px)" : "";
	}
	setBoxShadow(boxShadow) {
		if (this._boxShadow === boxShadow) return;
		this._boxShadow = boxShadow;
		this.domNode.style.boxShadow = boxShadow;
	}
	setContain(contain) {
		if (this._contain === contain) return;
		this._contain = contain;
		this.domNode.style.contain = this._contain;
	}
	setAttribute(name, value) {
		this.domNode.setAttribute(name, value);
	}
	removeAttribute(name) {
		this.domNode.removeAttribute(name);
	}
	appendChild(child) {
		this.domNode.appendChild(child.domNode);
	}
	removeChild(child) {
		this.domNode.removeChild(child.domNode);
	}
};
function numberAsPixels(value) {
	return typeof value === "number" ? `${value}px` : value;
}
function createFastDomNode(domNode) {
	return new FastDomNode(domNode);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/config/domFontInfo.js
function applyFontInfo(domNode, fontInfo) {
	if (domNode instanceof FastDomNode) {
		domNode.setFontFamily(fontInfo.getMassagedFontFamily());
		domNode.setFontWeight(fontInfo.fontWeight);
		domNode.setFontSize(fontInfo.fontSize);
		domNode.setFontFeatureSettings(fontInfo.fontFeatureSettings);
		domNode.setFontVariationSettings(fontInfo.fontVariationSettings);
		domNode.setLineHeight(fontInfo.lineHeight);
		domNode.setLetterSpacing(fontInfo.letterSpacing);
	} else {
		domNode.style.fontFamily = fontInfo.getMassagedFontFamily();
		domNode.style.fontWeight = fontInfo.fontWeight;
		domNode.style.fontSize = fontInfo.fontSize + "px";
		domNode.style.fontFeatureSettings = fontInfo.fontFeatureSettings;
		domNode.style.fontVariationSettings = fontInfo.fontVariationSettings;
		domNode.style.lineHeight = fontInfo.lineHeight + "px";
		domNode.style.letterSpacing = fontInfo.letterSpacing + "px";
	}
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/config/charWidthReader.js
var CharWidthRequest = class {
	constructor(chr, type) {
		this.chr = chr;
		this.type = type;
		this.width = 0;
	}
	fulfill(width) {
		this.width = width;
	}
};
var DomCharWidthReader = class DomCharWidthReader {
	constructor(bareFontInfo, requests) {
		this._bareFontInfo = bareFontInfo;
		this._requests = requests;
		this._container = null;
		this._testElements = null;
	}
	read(targetWindow) {
		this._createDomElements();
		targetWindow.document.body.appendChild(this._container);
		this._readFromDomElements();
		this._container?.remove();
		this._container = null;
		this._testElements = null;
	}
	_createDomElements() {
		const container = document.createElement("div");
		container.style.position = "absolute";
		container.style.top = "-50000px";
		container.style.width = "50000px";
		const regularDomNode = document.createElement("div");
		applyFontInfo(regularDomNode, this._bareFontInfo);
		container.appendChild(regularDomNode);
		const boldDomNode = document.createElement("div");
		applyFontInfo(boldDomNode, this._bareFontInfo);
		boldDomNode.style.fontWeight = "bold";
		container.appendChild(boldDomNode);
		const italicDomNode = document.createElement("div");
		applyFontInfo(italicDomNode, this._bareFontInfo);
		italicDomNode.style.fontStyle = "italic";
		container.appendChild(italicDomNode);
		const testElements = [];
		for (const request of this._requests) {
			let parent;
			if (request.type === 0) parent = regularDomNode;
			if (request.type === 2) parent = boldDomNode;
			if (request.type === 1) parent = italicDomNode;
			parent.appendChild(document.createElement("br"));
			const testElement = document.createElement("span");
			DomCharWidthReader._render(testElement, request);
			parent.appendChild(testElement);
			testElements.push(testElement);
		}
		this._container = container;
		this._testElements = testElements;
	}
	static _render(testElement, request) {
		if (request.chr === " ") {
			let htmlString = "\xA0";
			for (let i = 0; i < 8; i++) htmlString += htmlString;
			testElement.innerText = htmlString;
		} else {
			let testString = request.chr;
			for (let i = 0; i < 8; i++) testString += testString;
			testElement.textContent = testString;
		}
	}
	_readFromDomElements() {
		for (let i = 0, len = this._requests.length; i < len; i++) {
			const request = this._requests[i];
			const testElement = this._testElements[i];
			request.fulfill(testElement.offsetWidth / 256);
		}
	}
};
function readCharWidths(targetWindow, bareFontInfo, requests) {
	new DomCharWidthReader(bareFontInfo, requests).read(targetWindow);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/config/fontMeasurements.js
var FontMeasurementsImpl = class extends Disposable {
	constructor() {
		super(...arguments);
		this._cache = /* @__PURE__ */ new Map();
		this._evictUntrustedReadingsTimeout = -1;
		this._onDidChange = this._register(new Emitter$1());
		this.onDidChange = this._onDidChange.event;
	}
	dispose() {
		if (this._evictUntrustedReadingsTimeout !== -1) {
			clearTimeout(this._evictUntrustedReadingsTimeout);
			this._evictUntrustedReadingsTimeout = -1;
		}
		super.dispose();
	}
	/**
	* Clear all cached font information and trigger a change event.
	*/
	clearAllFontInfos() {
		this._cache.clear();
		this._onDidChange.fire();
	}
	_ensureCache(targetWindow) {
		const windowId = getWindowId(targetWindow);
		let cache = this._cache.get(windowId);
		if (!cache) {
			cache = new FontMeasurementsCache();
			this._cache.set(windowId, cache);
		}
		return cache;
	}
	_writeToCache(targetWindow, item, value, isRestored) {
		this._ensureCache(targetWindow).put(item, value, isRestored);
		if (!value.isTrusted && this._evictUntrustedReadingsTimeout === -1) this._evictUntrustedReadingsTimeout = targetWindow.setTimeout(() => {
			this._evictUntrustedReadingsTimeout = -1;
			this._evictUntrustedReadings(targetWindow);
		}, 5e3);
	}
	_evictUntrustedReadings(targetWindow) {
		const cache = this._ensureCache(targetWindow);
		const values = cache.getValues();
		let somethingRemoved = false;
		for (const item of values) if (!item.isTrusted) {
			somethingRemoved = true;
			cache.remove(item);
		}
		if (somethingRemoved) this._onDidChange.fire();
	}
	/**
	* Read font information.
	*/
	readFontInfo(targetWindow, bareFontInfo) {
		const cache = this._ensureCache(targetWindow);
		if (!cache.has(bareFontInfo)) {
			let readConfig = this._actualReadFontInfo(targetWindow, bareFontInfo);
			if (readConfig.typicalHalfwidthCharacterWidth <= 2 || readConfig.typicalFullwidthCharacterWidth <= 2 || readConfig.spaceWidth <= 2 || readConfig.maxDigitWidth <= 2) readConfig = new FontInfo({
				pixelRatio: PixelRatio.getInstance(targetWindow).value,
				fontFamily: readConfig.fontFamily,
				fontWeight: readConfig.fontWeight,
				fontSize: readConfig.fontSize,
				fontFeatureSettings: readConfig.fontFeatureSettings,
				fontVariationSettings: readConfig.fontVariationSettings,
				lineHeight: readConfig.lineHeight,
				letterSpacing: readConfig.letterSpacing,
				isMonospace: readConfig.isMonospace,
				typicalHalfwidthCharacterWidth: Math.max(readConfig.typicalHalfwidthCharacterWidth, 5),
				typicalFullwidthCharacterWidth: Math.max(readConfig.typicalFullwidthCharacterWidth, 5),
				canUseHalfwidthRightwardsArrow: readConfig.canUseHalfwidthRightwardsArrow,
				spaceWidth: Math.max(readConfig.spaceWidth, 5),
				middotWidth: Math.max(readConfig.middotWidth, 5),
				wsmiddotWidth: Math.max(readConfig.wsmiddotWidth, 5),
				maxDigitWidth: Math.max(readConfig.maxDigitWidth, 5)
			}, false);
			this._writeToCache(targetWindow, bareFontInfo, readConfig, false);
		}
		return cache.get(bareFontInfo);
	}
	_createRequest(chr, type, all, monospace) {
		const result = new CharWidthRequest(chr, type);
		all.push(result);
		monospace?.push(result);
		return result;
	}
	_actualReadFontInfo(targetWindow, bareFontInfo) {
		const all = [];
		const monospace = [];
		const typicalHalfwidthCharacter = this._createRequest("n", 0, all, monospace);
		const typicalFullwidthCharacter = this._createRequest("ｍ", 0, all, null);
		const space = this._createRequest(" ", 0, all, monospace);
		const digit0 = this._createRequest("0", 0, all, monospace);
		const digit1 = this._createRequest("1", 0, all, monospace);
		const digit2 = this._createRequest("2", 0, all, monospace);
		const digit3 = this._createRequest("3", 0, all, monospace);
		const digit4 = this._createRequest("4", 0, all, monospace);
		const digit5 = this._createRequest("5", 0, all, monospace);
		const digit6 = this._createRequest("6", 0, all, monospace);
		const digit7 = this._createRequest("7", 0, all, monospace);
		const digit8 = this._createRequest("8", 0, all, monospace);
		const digit9 = this._createRequest("9", 0, all, monospace);
		const rightwardsArrow = this._createRequest("→", 0, all, monospace);
		const halfwidthRightwardsArrow = this._createRequest("￫", 0, all, null);
		const middot = this._createRequest("·", 0, all, monospace);
		const wsmiddotWidth = this._createRequest(String.fromCharCode(11825), 0, all, null);
		const monospaceTestChars = "|/-_ilm%";
		for (let i = 0, len = 8; i < len; i++) {
			this._createRequest(monospaceTestChars.charAt(i), 0, all, monospace);
			this._createRequest(monospaceTestChars.charAt(i), 1, all, monospace);
			this._createRequest(monospaceTestChars.charAt(i), 2, all, monospace);
		}
		readCharWidths(targetWindow, bareFontInfo, all);
		const maxDigitWidth = Math.max(digit0.width, digit1.width, digit2.width, digit3.width, digit4.width, digit5.width, digit6.width, digit7.width, digit8.width, digit9.width);
		let isMonospace = bareFontInfo.fontFeatureSettings === EditorFontLigatures.OFF;
		const referenceWidth = monospace[0].width;
		for (let i = 1, len = monospace.length; isMonospace && i < len; i++) {
			const diff = referenceWidth - monospace[i].width;
			if (diff < -.001 || diff > .001) {
				isMonospace = false;
				break;
			}
		}
		let canUseHalfwidthRightwardsArrow = true;
		if (isMonospace && halfwidthRightwardsArrow.width !== referenceWidth) canUseHalfwidthRightwardsArrow = false;
		if (halfwidthRightwardsArrow.width > rightwardsArrow.width) canUseHalfwidthRightwardsArrow = false;
		return new FontInfo({
			pixelRatio: PixelRatio.getInstance(targetWindow).value,
			fontFamily: bareFontInfo.fontFamily,
			fontWeight: bareFontInfo.fontWeight,
			fontSize: bareFontInfo.fontSize,
			fontFeatureSettings: bareFontInfo.fontFeatureSettings,
			fontVariationSettings: bareFontInfo.fontVariationSettings,
			lineHeight: bareFontInfo.lineHeight,
			letterSpacing: bareFontInfo.letterSpacing,
			isMonospace,
			typicalHalfwidthCharacterWidth: typicalHalfwidthCharacter.width,
			typicalFullwidthCharacterWidth: typicalFullwidthCharacter.width,
			canUseHalfwidthRightwardsArrow,
			spaceWidth: space.width,
			middotWidth: middot.width,
			wsmiddotWidth: wsmiddotWidth.width,
			maxDigitWidth
		}, true);
	}
};
var FontMeasurementsCache = class {
	constructor() {
		this._wasPopulatedWithRestoredValues = false;
		this._wasPopulatedWithCurrentSessionValues = false;
		this._keys = Object.create(null);
		this._values = Object.create(null);
	}
	has(item) {
		const itemId = item.getId();
		return !!this._values[itemId];
	}
	get(item) {
		const itemId = item.getId();
		return this._values[itemId];
	}
	put(item, value, isRestored) {
		const itemId = item.getId();
		this._keys[itemId] = item;
		this._values[itemId] = value;
		if (isRestored) this._wasPopulatedWithRestoredValues = true;
		else this._wasPopulatedWithCurrentSessionValues = true;
	}
	remove(item) {
		const itemId = item.getId();
		delete this._keys[itemId];
		delete this._values[itemId];
	}
	getValues() {
		return Object.keys(this._keys).map((id) => this._values[id]);
	}
};
var FontMeasurements = new FontMeasurementsImpl();
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/instantiation/common/instantiation.js
var _util;
(function(_util) {
	_util.serviceIds = /* @__PURE__ */ new Map();
	_util.DI_TARGET = "$di$target";
	_util.DI_DEPENDENCIES = "$di$dependencies";
	function getServiceDependencies(ctor) {
		return ctor[_util.DI_DEPENDENCIES] || [];
	}
	_util.getServiceDependencies = getServiceDependencies;
})(_util || (_util = {}));
var IInstantiationService = createDecorator("instantiationService");
function storeServiceDependency(id, target, index) {
	if (target[_util.DI_TARGET] === target) target[_util.DI_DEPENDENCIES].push({
		id,
		index
	});
	else {
		target[_util.DI_DEPENDENCIES] = [{
			id,
			index
		}];
		target[_util.DI_TARGET] = target;
	}
}
/**
* The *only* valid way to create a {{ServiceIdentifier}}.
*/
function createDecorator(serviceId) {
	if (_util.serviceIds.has(serviceId)) return _util.serviceIds.get(serviceId);
	const id = function(target, key, index) {
		if (arguments.length !== 3) throw new Error("@IServiceName-decorator can only be used to decorate a parameter");
		storeServiceDependency(id, target, index);
	};
	id.toString = () => serviceId;
	_util.serviceIds.set(serviceId, id);
	return id;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/services/codeEditorService.js
var ICodeEditorService = createDecorator("codeEditorService");
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/services/model.js
var IModelService = createDecorator("modelService");
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/services/resolverService.js
var ITextModelService = createDecorator("textModelService");
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/actions.js
/**
* A concrete implementation of {@link IAction}.
*
* Note that in most cases you should use the lighter-weight {@linkcode toAction} function instead.
*/
var Action = class extends Disposable {
	get onDidChange() {
		return this._onDidChange.event;
	}
	constructor(id, label = "", cssClass = "", enabled = true, actionCallback) {
		super();
		this._onDidChange = this._register(new Emitter$1());
		this._enabled = true;
		this._id = id;
		this._label = label;
		this._cssClass = cssClass;
		this._enabled = enabled;
		this._actionCallback = actionCallback;
	}
	get id() {
		return this._id;
	}
	get label() {
		return this._label;
	}
	set label(value) {
		this._setLabel(value);
	}
	_setLabel(value) {
		if (this._label !== value) {
			this._label = value;
			this._onDidChange.fire({ label: value });
		}
	}
	get tooltip() {
		return this._tooltip || "";
	}
	set tooltip(value) {
		this._setTooltip(value);
	}
	_setTooltip(value) {
		if (this._tooltip !== value) {
			this._tooltip = value;
			this._onDidChange.fire({ tooltip: value });
		}
	}
	get class() {
		return this._cssClass;
	}
	set class(value) {
		this._setClass(value);
	}
	_setClass(value) {
		if (this._cssClass !== value) {
			this._cssClass = value;
			this._onDidChange.fire({ class: value });
		}
	}
	get enabled() {
		return this._enabled;
	}
	set enabled(value) {
		this._setEnabled(value);
	}
	_setEnabled(value) {
		if (this._enabled !== value) {
			this._enabled = value;
			this._onDidChange.fire({ enabled: value });
		}
	}
	get checked() {
		return this._checked;
	}
	set checked(value) {
		this._setChecked(value);
	}
	_setChecked(value) {
		if (this._checked !== value) {
			this._checked = value;
			this._onDidChange.fire({ checked: value });
		}
	}
	async run(event, data) {
		if (this._actionCallback) await this._actionCallback(event);
	}
};
var ActionRunner = class extends Disposable {
	constructor() {
		super(...arguments);
		this._onWillRun = this._register(new Emitter$1());
		this._onDidRun = this._register(new Emitter$1());
	}
	get onWillRun() {
		return this._onWillRun.event;
	}
	get onDidRun() {
		return this._onDidRun.event;
	}
	async run(action, context) {
		if (!action.enabled) return;
		this._onWillRun.fire({ action });
		let error = void 0;
		try {
			await this.runAction(action, context);
		} catch (e) {
			error = e;
		}
		this._onDidRun.fire({
			action,
			error
		});
	}
	async runAction(action, context) {
		await action.run(context);
	}
};
var Separator = class Separator {
	constructor() {
		this.id = Separator.ID;
		this.label = "";
		this.tooltip = "";
		this.class = "separator";
		this.enabled = false;
		this.checked = void 0;
	}
	/**
	* Joins all non-empty lists of actions with separators.
	*/
	static join(...actionLists) {
		let out = [];
		for (const list of actionLists) if (!list.length);
		else if (out.length) out = [
			...out,
			new Separator(),
			...list
		];
		else out = list;
		return out;
	}
	/**
	* Removes leading, trailing, and consecutive duplicate separators in-place and returns the actions.
	*/
	static clean(actions) {
		while (actions.length > 0 && actions[0].id === Separator.ID) actions.shift();
		while (actions.length > 0 && actions[actions.length - 1].id === Separator.ID) actions.pop();
		for (let i = actions.length - 2; i >= 0; i--) if (actions[i].id === Separator.ID && actions[i + 1].id === Separator.ID) actions.splice(i + 1, 1);
		return actions;
	}
	static {
		this.ID = "vs.actions.separator";
	}
	async run() {}
};
var SubmenuAction = class {
	get actions() {
		return this._actions;
	}
	constructor(id, label, actions, cssClass) {
		this.tooltip = "";
		this.enabled = true;
		this.checked = void 0;
		this.id = id;
		this.label = label;
		this.class = cssClass;
		this._actions = actions;
	}
	async run() {}
};
var EmptySubmenuAction = class EmptySubmenuAction extends Action {
	static {
		this.ID = "vs.actions.empty";
	}
	constructor() {
		super(EmptySubmenuAction.ID, localize(32, "(empty)"), void 0, false);
	}
};
function toAction(props) {
	return {
		id: props.id,
		label: props.label,
		tooltip: props.tooltip ?? props.label,
		class: props.class,
		enabled: props.enabled ?? true,
		checked: props.checked,
		run: async (...args) => props.run(...args)
	};
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/themables.js
var ThemeColor;
(function(ThemeColor) {
	function isThemeColor(obj) {
		return !!obj && typeof obj === "object" && typeof obj.id === "string";
	}
	ThemeColor.isThemeColor = isThemeColor;
})(ThemeColor || (ThemeColor = {}));
var ThemeIcon;
(function(ThemeIcon) {
	ThemeIcon.iconNameSegment = "[A-Za-z0-9]+";
	ThemeIcon.iconNameExpression = "[A-Za-z0-9-]+";
	ThemeIcon.iconModifierExpression = "~[A-Za-z]+";
	ThemeIcon.iconNameCharacter = "[A-Za-z0-9~-]";
	const ThemeIconIdRegex = new RegExp(`^(${ThemeIcon.iconNameExpression})(${ThemeIcon.iconModifierExpression})?$`);
	function asClassNameArray(icon) {
		const match = ThemeIconIdRegex.exec(icon.id);
		if (!match) return asClassNameArray(Codicon.error);
		const [, id, modifier] = match;
		const classNames = ["codicon", "codicon-" + id];
		if (modifier) classNames.push("codicon-modifier-" + modifier.substring(1));
		return classNames;
	}
	ThemeIcon.asClassNameArray = asClassNameArray;
	function asClassName(icon) {
		return asClassNameArray(icon).join(" ");
	}
	ThemeIcon.asClassName = asClassName;
	function asCSSSelector(icon) {
		return "." + asClassNameArray(icon).join(".");
	}
	ThemeIcon.asCSSSelector = asCSSSelector;
	function isThemeIcon(obj) {
		return !!obj && typeof obj === "object" && typeof obj.id === "string" && (typeof obj.color === "undefined" || ThemeColor.isThemeColor(obj.color));
	}
	ThemeIcon.isThemeIcon = isThemeIcon;
	const _regexFromString = new RegExp(`^\\$\\((${ThemeIcon.iconNameExpression}(?:${ThemeIcon.iconModifierExpression})?)\\)$`);
	function fromString(str) {
		const match = _regexFromString.exec(str);
		if (!match) return;
		const [, name] = match;
		return { id: name };
	}
	ThemeIcon.fromString = fromString;
	function fromId(id) {
		return { id };
	}
	ThemeIcon.fromId = fromId;
	function modify(icon, modifier) {
		let id = icon.id;
		const tildeIndex = id.lastIndexOf("~");
		if (tildeIndex !== -1) id = id.substring(0, tildeIndex);
		if (modifier) id = `${id}~${modifier}`;
		return { id };
	}
	ThemeIcon.modify = modify;
	function getModifier(icon) {
		const tildeIndex = icon.id.lastIndexOf("~");
		if (tildeIndex !== -1) return icon.id.substring(tildeIndex + 1);
	}
	ThemeIcon.getModifier = getModifier;
	function isEqual(ti1, ti2) {
		return ti1.id === ti2.id && ti1.color?.id === ti2.color?.id;
	}
	ThemeIcon.isEqual = isEqual;
	/**
	* Returns whether specified icon is defined and has 'file' ID.
	*/
	function isFile(icon) {
		return icon?.id === Codicon.file.id;
	}
	ThemeIcon.isFile = isFile;
	/**
	* Returns whether specified icon is defined and has 'folder' ID.
	*/
	function isFolder(icon) {
		return icon?.id === Codicon.folder.id;
	}
	ThemeIcon.isFolder = isFolder;
})(ThemeIcon || (ThemeIcon = {}));
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/commands/common/commands.js
var ICommandService = createDecorator("commandService");
var CommandsRegistry = new class {
	constructor() {
		this._commands = /* @__PURE__ */ new Map();
		this._onDidRegisterCommand = new Emitter$1();
		this.onDidRegisterCommand = this._onDidRegisterCommand.event;
	}
	registerCommand(idOrCommand, handler) {
		if (!idOrCommand) throw new Error(`invalid command`);
		if (typeof idOrCommand === "string") {
			if (!handler) throw new Error(`invalid command`);
			return this.registerCommand({
				id: idOrCommand,
				handler
			});
		}
		if (idOrCommand.metadata && Array.isArray(idOrCommand.metadata.args)) {
			const constraints = [];
			for (const arg of idOrCommand.metadata.args) constraints.push(arg.constraint);
			const actualHandler = idOrCommand.handler;
			idOrCommand.handler = function(accessor, ...args) {
				validateConstraints(args, constraints);
				return actualHandler(accessor, ...args);
			};
		}
		const { id } = idOrCommand;
		let commands = this._commands.get(id);
		if (!commands) {
			commands = new LinkedList();
			this._commands.set(id, commands);
		}
		const removeFn = commands.unshift(idOrCommand);
		const ret = toDisposable(() => {
			removeFn();
			if (this._commands.get(id)?.isEmpty()) this._commands.delete(id);
		});
		this._onDidRegisterCommand.fire(id);
		return markAsSingleton(ret);
	}
	registerCommandAlias(oldId, newId) {
		return CommandsRegistry.registerCommand(oldId, (accessor, ...args) => accessor.get(ICommandService).executeCommand(newId, ...args));
	}
	getCommand(id) {
		const list = this._commands.get(id);
		if (!list || list.isEmpty()) return;
		return Iterable.first(list);
	}
	getCommands() {
		const result = /* @__PURE__ */ new Map();
		for (const key of this._commands.keys()) {
			const command = this.getCommand(key);
			if (command) result.set(key, command);
		}
		return result;
	}
}();
CommandsRegistry.registerCommand("noop", () => {});
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/contextkey/common/scanner.js
function hintDidYouMean(...meant) {
	switch (meant.length) {
		case 1: return localize(1788, "Did you mean {0}?", meant[0]);
		case 2: return localize(1789, "Did you mean {0} or {1}?", meant[0], meant[1]);
		case 3: return localize(1790, "Did you mean {0}, {1} or {2}?", meant[0], meant[1], meant[2]);
		default: return;
	}
}
var hintDidYouForgetToOpenOrCloseQuote = localize(1791, "Did you forget to open or close the quote?");
var hintDidYouForgetToEscapeSlash = localize(1792, "Did you forget to escape the '/' (slash) character? Put two backslashes before it to escape, e.g., '\\\\/'.");
/**
* A simple scanner for context keys.
*
* Example:
*
* ```ts
* const scanner = new Scanner().reset('resourceFileName =~ /docker/ && !config.docker.enabled');
* const tokens = [...scanner];
* if (scanner.errorTokens.length > 0) {
*     scanner.errorTokens.forEach(err => console.error(`Unexpected token at ${err.offset}: ${err.lexeme}\nHint: ${err.additional}`));
* } else {
*     // process tokens
* }
* ```
*/
var Scanner = class Scanner {
	constructor() {
		this._input = "";
		this._start = 0;
		this._current = 0;
		this._tokens = [];
		this._errors = [];
		this.stringRe = /[a-zA-Z0-9_<>\-\./\\:\*\?\+\[\]\^,#@;"%\$\p{L}-]+/uy;
	}
	static getLexeme(token) {
		switch (token.type) {
			case 0: return "(";
			case 1: return ")";
			case 2: return "!";
			case 3: return token.isTripleEq ? "===" : "==";
			case 4: return token.isTripleEq ? "!==" : "!=";
			case 5: return "<";
			case 6: return "<=";
			case 7: return ">";
			case 8: return ">=";
			case 9: return "=~";
			case 10: return token.lexeme;
			case 11: return "true";
			case 12: return "false";
			case 13: return "in";
			case 14: return "not";
			case 15: return "&&";
			case 16: return "||";
			case 17: return token.lexeme;
			case 18: return token.lexeme;
			case 19: return token.lexeme;
			case 20: return "EOF";
			default: throw illegalState(`unhandled token type: ${JSON.stringify(token)}; have you forgotten to add a case?`);
		}
	}
	static {
		this._regexFlags = new Set([
			"i",
			"g",
			"s",
			"m",
			"y",
			"u"
		].map((ch) => ch.charCodeAt(0)));
	}
	static {
		this._keywords = /* @__PURE__ */ new Map([
			["not", 14],
			["in", 13],
			["false", 12],
			["true", 11]
		]);
	}
	reset(value) {
		this._input = value;
		this._start = 0;
		this._current = 0;
		this._tokens = [];
		this._errors = [];
		return this;
	}
	scan() {
		while (!this._isAtEnd()) {
			this._start = this._current;
			switch (this._advance()) {
				case 40:
					this._addToken(0);
					break;
				case 41:
					this._addToken(1);
					break;
				case 33:
					if (this._match(61)) {
						const isTripleEq = this._match(61);
						this._tokens.push({
							type: 4,
							offset: this._start,
							isTripleEq
						});
					} else this._addToken(2);
					break;
				case 39:
					this._quotedString();
					break;
				case 47:
					this._regex();
					break;
				case 61:
					if (this._match(61)) {
						const isTripleEq = this._match(61);
						this._tokens.push({
							type: 3,
							offset: this._start,
							isTripleEq
						});
					} else if (this._match(126)) this._addToken(9);
					else this._error(hintDidYouMean("==", "=~"));
					break;
				case 60:
					this._addToken(this._match(61) ? 6 : 5);
					break;
				case 62:
					this._addToken(this._match(61) ? 8 : 7);
					break;
				case 38:
					if (this._match(38)) this._addToken(15);
					else this._error(hintDidYouMean("&&"));
					break;
				case 124:
					if (this._match(124)) this._addToken(16);
					else this._error(hintDidYouMean("||"));
					break;
				case 32:
				case 13:
				case 9:
				case 10:
				case 160: break;
				default: this._string();
			}
		}
		this._start = this._current;
		this._addToken(20);
		return Array.from(this._tokens);
	}
	_match(expected) {
		if (this._isAtEnd()) return false;
		if (this._input.charCodeAt(this._current) !== expected) return false;
		this._current++;
		return true;
	}
	_advance() {
		return this._input.charCodeAt(this._current++);
	}
	_peek() {
		return this._isAtEnd() ? 0 : this._input.charCodeAt(this._current);
	}
	_addToken(type) {
		this._tokens.push({
			type,
			offset: this._start
		});
	}
	_error(additional) {
		const offset = this._start;
		const lexeme = this._input.substring(this._start, this._current);
		const errToken = {
			type: 19,
			offset: this._start,
			lexeme
		};
		this._errors.push({
			offset,
			lexeme,
			additionalInfo: additional
		});
		this._tokens.push(errToken);
	}
	_string() {
		this.stringRe.lastIndex = this._start;
		const match = this.stringRe.exec(this._input);
		if (match) {
			this._current = this._start + match[0].length;
			const lexeme = this._input.substring(this._start, this._current);
			const keyword = Scanner._keywords.get(lexeme);
			if (keyword) this._addToken(keyword);
			else this._tokens.push({
				type: 17,
				lexeme,
				offset: this._start
			});
		}
	}
	_quotedString() {
		while (this._peek() !== 39 && !this._isAtEnd()) this._advance();
		if (this._isAtEnd()) {
			this._error(hintDidYouForgetToOpenOrCloseQuote);
			return;
		}
		this._advance();
		this._tokens.push({
			type: 18,
			lexeme: this._input.substring(this._start + 1, this._current - 1),
			offset: this._start + 1
		});
	}
	_regex() {
		let p = this._current;
		let inEscape = false;
		let inCharacterClass = false;
		while (true) {
			if (p >= this._input.length) {
				this._current = p;
				this._error(hintDidYouForgetToEscapeSlash);
				return;
			}
			const ch = this._input.charCodeAt(p);
			if (inEscape) inEscape = false;
			else if (ch === 47 && !inCharacterClass) {
				p++;
				break;
			} else if (ch === 91) inCharacterClass = true;
			else if (ch === 92) inEscape = true;
			else if (ch === 93) inCharacterClass = false;
			p++;
		}
		while (p < this._input.length && Scanner._regexFlags.has(this._input.charCodeAt(p))) p++;
		this._current = p;
		const lexeme = this._input.substring(this._start, this._current);
		this._tokens.push({
			type: 10,
			lexeme,
			offset: this._start
		});
	}
	_isAtEnd() {
		return this._current >= this._input.length;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/contextkey/common/contextkey.js
var CONSTANT_VALUES = /* @__PURE__ */ new Map();
CONSTANT_VALUES.set("false", false);
CONSTANT_VALUES.set("true", true);
CONSTANT_VALUES.set("isMac", isMacintosh);
CONSTANT_VALUES.set("isLinux", isLinux);
CONSTANT_VALUES.set("isWindows", isWindows);
CONSTANT_VALUES.set("isChromeOS", isChromeOS);
CONSTANT_VALUES.set("isWeb", isWeb);
CONSTANT_VALUES.set("isMacNative", isMacintosh && !isWeb);
CONSTANT_VALUES.set("isEdge", isEdge);
CONSTANT_VALUES.set("isFirefox", isFirefox$1);
CONSTANT_VALUES.set("isChrome", isChrome$1);
CONSTANT_VALUES.set("isSafari", isSafari$1);
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var defaultConfig = { regexParsingWithErrorRecovery: true };
var errorEmptyString = localize(1769, "Empty context key expression");
var hintEmptyString = localize(1770, "Did you forget to write an expression? You can also put 'false' or 'true' to always evaluate to false or true, respectively.");
var errorNoInAfterNot = localize(1771, "'in' after 'not'.");
var errorClosingParenthesis = localize(1772, "closing parenthesis ')'");
var errorUnexpectedToken = localize(1773, "Unexpected token");
var hintUnexpectedToken = localize(1774, "Did you forget to put && or || before the token?");
var errorUnexpectedEOF = localize(1775, "Unexpected end of expression");
var hintUnexpectedEOF = localize(1776, "Did you forget to put a context key?");
/**
* A parser for context key expressions.
*
* Example:
* ```ts
* const parser = new Parser();
* const expr = parser.parse('foo == "bar" && baz == true');
*
* if (expr === undefined) {
* 	// there were lexing or parsing errors
* 	// process lexing errors with `parser.lexingErrors`
*  // process parsing errors with `parser.parsingErrors`
* } else {
* 	// expr is a valid expression
* }
* ```
*/
var Parser$1 = class Parser$1 {
	static {
		this._parseError = /* @__PURE__ */ new Error();
	}
	constructor(_config = defaultConfig) {
		this._config = _config;
		this._scanner = new Scanner();
		this._tokens = [];
		this._current = 0;
		this._parsingErrors = [];
		this._flagsGYRe = /g|y/g;
	}
	/**
	* Parse a context key expression.
	*
	* @param input the expression to parse
	* @returns the parsed expression or `undefined` if there's an error - call `lexingErrors` and `parsingErrors` to see the errors
	*/
	parse(input) {
		if (input === "") {
			this._parsingErrors.push({
				message: errorEmptyString,
				offset: 0,
				lexeme: "",
				additionalInfo: hintEmptyString
			});
			return;
		}
		this._tokens = this._scanner.reset(input).scan();
		this._current = 0;
		this._parsingErrors = [];
		try {
			const expr = this._expr();
			if (!this._isAtEnd()) {
				const peek = this._peek();
				const additionalInfo = peek.type === 17 ? hintUnexpectedToken : void 0;
				this._parsingErrors.push({
					message: errorUnexpectedToken,
					offset: peek.offset,
					lexeme: Scanner.getLexeme(peek),
					additionalInfo
				});
				throw Parser$1._parseError;
			}
			return expr;
		} catch (e) {
			if (!(e === Parser$1._parseError)) throw e;
			return;
		}
	}
	_expr() {
		return this._or();
	}
	_or() {
		const expr = [this._and()];
		while (this._matchOne(16)) {
			const right = this._and();
			expr.push(right);
		}
		return expr.length === 1 ? expr[0] : ContextKeyExpr.or(...expr);
	}
	_and() {
		const expr = [this._term()];
		while (this._matchOne(15)) {
			const right = this._term();
			expr.push(right);
		}
		return expr.length === 1 ? expr[0] : ContextKeyExpr.and(...expr);
	}
	_term() {
		if (this._matchOne(2)) {
			const peek = this._peek();
			switch (peek.type) {
				case 11:
					this._advance();
					return ContextKeyFalseExpr.INSTANCE;
				case 12:
					this._advance();
					return ContextKeyTrueExpr.INSTANCE;
				case 0: {
					this._advance();
					const expr = this._expr();
					this._consume(1, errorClosingParenthesis);
					return expr?.negate();
				}
				case 17:
					this._advance();
					return ContextKeyNotExpr.create(peek.lexeme);
				default: throw this._errExpectedButGot(`KEY | true | false | '(' expression ')'`, peek);
			}
		}
		return this._primary();
	}
	_primary() {
		const peek = this._peek();
		switch (peek.type) {
			case 11:
				this._advance();
				return ContextKeyExpr.true();
			case 12:
				this._advance();
				return ContextKeyExpr.false();
			case 0: {
				this._advance();
				const expr = this._expr();
				this._consume(1, errorClosingParenthesis);
				return expr;
			}
			case 17: {
				const key = peek.lexeme;
				this._advance();
				if (this._matchOne(9)) {
					const expr = this._peek();
					if (!this._config.regexParsingWithErrorRecovery) {
						this._advance();
						if (expr.type !== 10) throw this._errExpectedButGot(`REGEX`, expr);
						const regexLexeme = expr.lexeme;
						const closingSlashIndex = regexLexeme.lastIndexOf("/");
						const flags = closingSlashIndex === regexLexeme.length - 1 ? void 0 : this._removeFlagsGY(regexLexeme.substring(closingSlashIndex + 1));
						let regexp;
						try {
							regexp = new RegExp(regexLexeme.substring(1, closingSlashIndex), flags);
						} catch (e) {
							throw this._errExpectedButGot(`REGEX`, expr);
						}
						return ContextKeyRegexExpr.create(key, regexp);
					}
					switch (expr.type) {
						case 10:
						case 19: {
							const lexemeReconstruction = [expr.lexeme];
							this._advance();
							let followingToken = this._peek();
							let parenBalance = 0;
							for (let i = 0; i < expr.lexeme.length; i++) if (expr.lexeme.charCodeAt(i) === 40) parenBalance++;
							else if (expr.lexeme.charCodeAt(i) === 41) parenBalance--;
							while (!this._isAtEnd() && followingToken.type !== 15 && followingToken.type !== 16) {
								switch (followingToken.type) {
									case 0:
										parenBalance++;
										break;
									case 1:
										parenBalance--;
										break;
									case 10:
									case 18: for (let i = 0; i < followingToken.lexeme.length; i++) if (followingToken.lexeme.charCodeAt(i) === 40) parenBalance++;
									else if (expr.lexeme.charCodeAt(i) === 41) parenBalance--;
								}
								if (parenBalance < 0) break;
								lexemeReconstruction.push(Scanner.getLexeme(followingToken));
								this._advance();
								followingToken = this._peek();
							}
							const regexLexeme = lexemeReconstruction.join("");
							const closingSlashIndex = regexLexeme.lastIndexOf("/");
							const flags = closingSlashIndex === regexLexeme.length - 1 ? void 0 : this._removeFlagsGY(regexLexeme.substring(closingSlashIndex + 1));
							let regexp;
							try {
								regexp = new RegExp(regexLexeme.substring(1, closingSlashIndex), flags);
							} catch (e) {
								throw this._errExpectedButGot(`REGEX`, expr);
							}
							return ContextKeyExpr.regex(key, regexp);
						}
						case 18: {
							const serializedValue = expr.lexeme;
							this._advance();
							let regex = null;
							if (!isFalsyOrWhitespace(serializedValue)) {
								const start = serializedValue.indexOf("/");
								const end = serializedValue.lastIndexOf("/");
								if (start !== end && start >= 0) {
									const value = serializedValue.slice(start + 1, end);
									const caseIgnoreFlag = serializedValue[end + 1] === "i" ? "i" : "";
									try {
										regex = new RegExp(value, caseIgnoreFlag);
									} catch (_e) {
										throw this._errExpectedButGot(`REGEX`, expr);
									}
								}
							}
							if (regex === null) throw this._errExpectedButGot("REGEX", expr);
							return ContextKeyRegexExpr.create(key, regex);
						}
						default: throw this._errExpectedButGot("REGEX", this._peek());
					}
				}
				if (this._matchOne(14)) {
					this._consume(13, errorNoInAfterNot);
					const right = this._value();
					return ContextKeyExpr.notIn(key, right);
				}
				switch (this._peek().type) {
					case 3: {
						this._advance();
						const right = this._value();
						if (this._previous().type === 18) return ContextKeyExpr.equals(key, right);
						switch (right) {
							case "true": return ContextKeyExpr.has(key);
							case "false": return ContextKeyExpr.not(key);
							default: return ContextKeyExpr.equals(key, right);
						}
					}
					case 4: {
						this._advance();
						const right = this._value();
						if (this._previous().type === 18) return ContextKeyExpr.notEquals(key, right);
						switch (right) {
							case "true": return ContextKeyExpr.not(key);
							case "false": return ContextKeyExpr.has(key);
							default: return ContextKeyExpr.notEquals(key, right);
						}
					}
					case 5:
						this._advance();
						return ContextKeySmallerExpr.create(key, this._value());
					case 6:
						this._advance();
						return ContextKeySmallerEqualsExpr.create(key, this._value());
					case 7:
						this._advance();
						return ContextKeyGreaterExpr.create(key, this._value());
					case 8:
						this._advance();
						return ContextKeyGreaterEqualsExpr.create(key, this._value());
					case 13:
						this._advance();
						return ContextKeyExpr.in(key, this._value());
					default: return ContextKeyExpr.has(key);
				}
			}
			case 20:
				this._parsingErrors.push({
					message: errorUnexpectedEOF,
					offset: peek.offset,
					lexeme: "",
					additionalInfo: hintUnexpectedEOF
				});
				throw Parser$1._parseError;
			default: throw this._errExpectedButGot(`true | false | KEY \n\t| KEY '=~' REGEX \n\t| KEY ('==' | '!=' | '<' | '<=' | '>' | '>=' | 'in' | 'not' 'in') value`, this._peek());
		}
	}
	_value() {
		const token = this._peek();
		switch (token.type) {
			case 17:
			case 18:
				this._advance();
				return token.lexeme;
			case 11:
				this._advance();
				return "true";
			case 12:
				this._advance();
				return "false";
			case 13:
				this._advance();
				return "in";
			default: return "";
		}
	}
	_removeFlagsGY(flags) {
		return flags.replaceAll(this._flagsGYRe, "");
	}
	_previous() {
		return this._tokens[this._current - 1];
	}
	_matchOne(token) {
		if (this._check(token)) {
			this._advance();
			return true;
		}
		return false;
	}
	_advance() {
		if (!this._isAtEnd()) this._current++;
		return this._previous();
	}
	_consume(type, message) {
		if (this._check(type)) return this._advance();
		throw this._errExpectedButGot(message, this._peek());
	}
	_errExpectedButGot(expected, got, additionalInfo) {
		const message = localize(1777, "Expected: {0}\nReceived: '{1}'.", expected, Scanner.getLexeme(got));
		const offset = got.offset;
		const lexeme = Scanner.getLexeme(got);
		this._parsingErrors.push({
			message,
			offset,
			lexeme,
			additionalInfo
		});
		return Parser$1._parseError;
	}
	_check(type) {
		return this._peek().type === type;
	}
	_peek() {
		return this._tokens[this._current];
	}
	_isAtEnd() {
		return this._peek().type === 20;
	}
};
var ContextKeyExpr = class {
	static false() {
		return ContextKeyFalseExpr.INSTANCE;
	}
	static true() {
		return ContextKeyTrueExpr.INSTANCE;
	}
	static has(key) {
		return ContextKeyDefinedExpr.create(key);
	}
	static equals(key, value) {
		return ContextKeyEqualsExpr.create(key, value);
	}
	static notEquals(key, value) {
		return ContextKeyNotEqualsExpr.create(key, value);
	}
	static regex(key, value) {
		return ContextKeyRegexExpr.create(key, value);
	}
	static in(key, value) {
		return ContextKeyInExpr.create(key, value);
	}
	static notIn(key, value) {
		return ContextKeyNotInExpr.create(key, value);
	}
	static not(key) {
		return ContextKeyNotExpr.create(key);
	}
	static and(...expr) {
		return ContextKeyAndExpr.create(expr, null, true);
	}
	static or(...expr) {
		return ContextKeyOrExpr.create(expr, null, true);
	}
	static {
		this._parser = new Parser$1({ regexParsingWithErrorRecovery: false });
	}
	static deserialize(serialized) {
		if (serialized === void 0 || serialized === null) return;
		return this._parser.parse(serialized);
	}
};
function cmp(a, b) {
	return a.cmp(b);
}
var ContextKeyFalseExpr = class ContextKeyFalseExpr {
	static {
		this.INSTANCE = new ContextKeyFalseExpr();
	}
	constructor() {
		this.type = 0;
	}
	cmp(other) {
		return this.type - other.type;
	}
	equals(other) {
		return other.type === this.type;
	}
	substituteConstants() {
		return this;
	}
	evaluate(context) {
		return false;
	}
	serialize() {
		return "false";
	}
	keys() {
		return [];
	}
	negate() {
		return ContextKeyTrueExpr.INSTANCE;
	}
};
var ContextKeyTrueExpr = class ContextKeyTrueExpr {
	static {
		this.INSTANCE = new ContextKeyTrueExpr();
	}
	constructor() {
		this.type = 1;
	}
	cmp(other) {
		return this.type - other.type;
	}
	equals(other) {
		return other.type === this.type;
	}
	substituteConstants() {
		return this;
	}
	evaluate(context) {
		return true;
	}
	serialize() {
		return "true";
	}
	keys() {
		return [];
	}
	negate() {
		return ContextKeyFalseExpr.INSTANCE;
	}
};
var ContextKeyDefinedExpr = class ContextKeyDefinedExpr {
	static create(key, negated = null) {
		const constantValue = CONSTANT_VALUES.get(key);
		if (typeof constantValue === "boolean") return constantValue ? ContextKeyTrueExpr.INSTANCE : ContextKeyFalseExpr.INSTANCE;
		return new ContextKeyDefinedExpr(key, negated);
	}
	constructor(key, negated) {
		this.key = key;
		this.negated = negated;
		this.type = 2;
	}
	cmp(other) {
		if (other.type !== this.type) return this.type - other.type;
		return cmp1(this.key, other.key);
	}
	equals(other) {
		if (other.type === this.type) return this.key === other.key;
		return false;
	}
	substituteConstants() {
		const constantValue = CONSTANT_VALUES.get(this.key);
		if (typeof constantValue === "boolean") return constantValue ? ContextKeyTrueExpr.INSTANCE : ContextKeyFalseExpr.INSTANCE;
		return this;
	}
	evaluate(context) {
		return !!context.getValue(this.key);
	}
	serialize() {
		return this.key;
	}
	keys() {
		return [this.key];
	}
	negate() {
		if (!this.negated) this.negated = ContextKeyNotExpr.create(this.key, this);
		return this.negated;
	}
};
var ContextKeyEqualsExpr = class ContextKeyEqualsExpr {
	static create(key, value, negated = null) {
		if (typeof value === "boolean") return value ? ContextKeyDefinedExpr.create(key, negated) : ContextKeyNotExpr.create(key, negated);
		const constantValue = CONSTANT_VALUES.get(key);
		if (typeof constantValue === "boolean") return value === (constantValue ? "true" : "false") ? ContextKeyTrueExpr.INSTANCE : ContextKeyFalseExpr.INSTANCE;
		return new ContextKeyEqualsExpr(key, value, negated);
	}
	constructor(key, value, negated) {
		this.key = key;
		this.value = value;
		this.negated = negated;
		this.type = 4;
	}
	cmp(other) {
		if (other.type !== this.type) return this.type - other.type;
		return cmp2(this.key, this.value, other.key, other.value);
	}
	equals(other) {
		if (other.type === this.type) return this.key === other.key && this.value === other.value;
		return false;
	}
	substituteConstants() {
		const constantValue = CONSTANT_VALUES.get(this.key);
		if (typeof constantValue === "boolean") {
			const trueValue = constantValue ? "true" : "false";
			return this.value === trueValue ? ContextKeyTrueExpr.INSTANCE : ContextKeyFalseExpr.INSTANCE;
		}
		return this;
	}
	evaluate(context) {
		return context.getValue(this.key) == this.value;
	}
	serialize() {
		return `${this.key} == '${this.value}'`;
	}
	keys() {
		return [this.key];
	}
	negate() {
		if (!this.negated) this.negated = ContextKeyNotEqualsExpr.create(this.key, this.value, this);
		return this.negated;
	}
};
var ContextKeyInExpr = class ContextKeyInExpr {
	static create(key, valueKey) {
		return new ContextKeyInExpr(key, valueKey);
	}
	constructor(key, valueKey) {
		this.key = key;
		this.valueKey = valueKey;
		this.type = 10;
		this.negated = null;
	}
	cmp(other) {
		if (other.type !== this.type) return this.type - other.type;
		return cmp2(this.key, this.valueKey, other.key, other.valueKey);
	}
	equals(other) {
		if (other.type === this.type) return this.key === other.key && this.valueKey === other.valueKey;
		return false;
	}
	substituteConstants() {
		return this;
	}
	evaluate(context) {
		const source = context.getValue(this.valueKey);
		const item = context.getValue(this.key);
		if (Array.isArray(source)) {
			if (source.includes(item)) return true;
			if (isWindows && typeof item === "string" && item.startsWith("file:///")) {
				const itemLower = item.toLowerCase();
				return source.some((s) => typeof s === "string" && s.toLowerCase() === itemLower);
			}
			return false;
		}
		if (typeof item === "string" && typeof source === "object" && source !== null) {
			if (hasOwnProperty$1.call(source, item)) return true;
			if (isWindows && item.startsWith("file:///")) {
				const itemLower = item.toLowerCase();
				return Object.keys(source).some((key) => key.toLowerCase() === itemLower);
			}
			return false;
		}
		return false;
	}
	serialize() {
		return `${this.key} in '${this.valueKey}'`;
	}
	keys() {
		return [this.key, this.valueKey];
	}
	negate() {
		if (!this.negated) this.negated = ContextKeyNotInExpr.create(this.key, this.valueKey);
		return this.negated;
	}
};
var ContextKeyNotInExpr = class ContextKeyNotInExpr {
	static create(key, valueKey) {
		return new ContextKeyNotInExpr(key, valueKey);
	}
	constructor(key, valueKey) {
		this.key = key;
		this.valueKey = valueKey;
		this.type = 11;
		this._negated = ContextKeyInExpr.create(key, valueKey);
	}
	cmp(other) {
		if (other.type !== this.type) return this.type - other.type;
		return this._negated.cmp(other._negated);
	}
	equals(other) {
		if (other.type === this.type) return this._negated.equals(other._negated);
		return false;
	}
	substituteConstants() {
		return this;
	}
	evaluate(context) {
		return !this._negated.evaluate(context);
	}
	serialize() {
		return `${this.key} not in '${this.valueKey}'`;
	}
	keys() {
		return this._negated.keys();
	}
	negate() {
		return this._negated;
	}
};
var ContextKeyNotEqualsExpr = class ContextKeyNotEqualsExpr {
	static create(key, value, negated = null) {
		if (typeof value === "boolean") {
			if (value) return ContextKeyNotExpr.create(key, negated);
			return ContextKeyDefinedExpr.create(key, negated);
		}
		const constantValue = CONSTANT_VALUES.get(key);
		if (typeof constantValue === "boolean") return value === (constantValue ? "true" : "false") ? ContextKeyFalseExpr.INSTANCE : ContextKeyTrueExpr.INSTANCE;
		return new ContextKeyNotEqualsExpr(key, value, negated);
	}
	constructor(key, value, negated) {
		this.key = key;
		this.value = value;
		this.negated = negated;
		this.type = 5;
	}
	cmp(other) {
		if (other.type !== this.type) return this.type - other.type;
		return cmp2(this.key, this.value, other.key, other.value);
	}
	equals(other) {
		if (other.type === this.type) return this.key === other.key && this.value === other.value;
		return false;
	}
	substituteConstants() {
		const constantValue = CONSTANT_VALUES.get(this.key);
		if (typeof constantValue === "boolean") {
			const falseValue = constantValue ? "true" : "false";
			return this.value === falseValue ? ContextKeyFalseExpr.INSTANCE : ContextKeyTrueExpr.INSTANCE;
		}
		return this;
	}
	evaluate(context) {
		return context.getValue(this.key) != this.value;
	}
	serialize() {
		return `${this.key} != '${this.value}'`;
	}
	keys() {
		return [this.key];
	}
	negate() {
		if (!this.negated) this.negated = ContextKeyEqualsExpr.create(this.key, this.value, this);
		return this.negated;
	}
};
var ContextKeyNotExpr = class ContextKeyNotExpr {
	static create(key, negated = null) {
		const constantValue = CONSTANT_VALUES.get(key);
		if (typeof constantValue === "boolean") return constantValue ? ContextKeyFalseExpr.INSTANCE : ContextKeyTrueExpr.INSTANCE;
		return new ContextKeyNotExpr(key, negated);
	}
	constructor(key, negated) {
		this.key = key;
		this.negated = negated;
		this.type = 3;
	}
	cmp(other) {
		if (other.type !== this.type) return this.type - other.type;
		return cmp1(this.key, other.key);
	}
	equals(other) {
		if (other.type === this.type) return this.key === other.key;
		return false;
	}
	substituteConstants() {
		const constantValue = CONSTANT_VALUES.get(this.key);
		if (typeof constantValue === "boolean") return constantValue ? ContextKeyFalseExpr.INSTANCE : ContextKeyTrueExpr.INSTANCE;
		return this;
	}
	evaluate(context) {
		return !context.getValue(this.key);
	}
	serialize() {
		return `!${this.key}`;
	}
	keys() {
		return [this.key];
	}
	negate() {
		if (!this.negated) this.negated = ContextKeyDefinedExpr.create(this.key, this);
		return this.negated;
	}
};
function withFloatOrStr(value, callback) {
	if (typeof value === "string") {
		const n = parseFloat(value);
		if (!isNaN(n)) value = n;
	}
	if (typeof value === "string" || typeof value === "number") return callback(value);
	return ContextKeyFalseExpr.INSTANCE;
}
var ContextKeyGreaterExpr = class ContextKeyGreaterExpr {
	static create(key, _value, negated = null) {
		return withFloatOrStr(_value, (value) => new ContextKeyGreaterExpr(key, value, negated));
	}
	constructor(key, value, negated) {
		this.key = key;
		this.value = value;
		this.negated = negated;
		this.type = 12;
	}
	cmp(other) {
		if (other.type !== this.type) return this.type - other.type;
		return cmp2(this.key, this.value, other.key, other.value);
	}
	equals(other) {
		if (other.type === this.type) return this.key === other.key && this.value === other.value;
		return false;
	}
	substituteConstants() {
		return this;
	}
	evaluate(context) {
		if (typeof this.value === "string") return false;
		return parseFloat(context.getValue(this.key)) > this.value;
	}
	serialize() {
		return `${this.key} > ${this.value}`;
	}
	keys() {
		return [this.key];
	}
	negate() {
		if (!this.negated) this.negated = ContextKeySmallerEqualsExpr.create(this.key, this.value, this);
		return this.negated;
	}
};
var ContextKeyGreaterEqualsExpr = class ContextKeyGreaterEqualsExpr {
	static create(key, _value, negated = null) {
		return withFloatOrStr(_value, (value) => new ContextKeyGreaterEqualsExpr(key, value, negated));
	}
	constructor(key, value, negated) {
		this.key = key;
		this.value = value;
		this.negated = negated;
		this.type = 13;
	}
	cmp(other) {
		if (other.type !== this.type) return this.type - other.type;
		return cmp2(this.key, this.value, other.key, other.value);
	}
	equals(other) {
		if (other.type === this.type) return this.key === other.key && this.value === other.value;
		return false;
	}
	substituteConstants() {
		return this;
	}
	evaluate(context) {
		if (typeof this.value === "string") return false;
		return parseFloat(context.getValue(this.key)) >= this.value;
	}
	serialize() {
		return `${this.key} >= ${this.value}`;
	}
	keys() {
		return [this.key];
	}
	negate() {
		if (!this.negated) this.negated = ContextKeySmallerExpr.create(this.key, this.value, this);
		return this.negated;
	}
};
var ContextKeySmallerExpr = class ContextKeySmallerExpr {
	static create(key, _value, negated = null) {
		return withFloatOrStr(_value, (value) => new ContextKeySmallerExpr(key, value, negated));
	}
	constructor(key, value, negated) {
		this.key = key;
		this.value = value;
		this.negated = negated;
		this.type = 14;
	}
	cmp(other) {
		if (other.type !== this.type) return this.type - other.type;
		return cmp2(this.key, this.value, other.key, other.value);
	}
	equals(other) {
		if (other.type === this.type) return this.key === other.key && this.value === other.value;
		return false;
	}
	substituteConstants() {
		return this;
	}
	evaluate(context) {
		if (typeof this.value === "string") return false;
		return parseFloat(context.getValue(this.key)) < this.value;
	}
	serialize() {
		return `${this.key} < ${this.value}`;
	}
	keys() {
		return [this.key];
	}
	negate() {
		if (!this.negated) this.negated = ContextKeyGreaterEqualsExpr.create(this.key, this.value, this);
		return this.negated;
	}
};
var ContextKeySmallerEqualsExpr = class ContextKeySmallerEqualsExpr {
	static create(key, _value, negated = null) {
		return withFloatOrStr(_value, (value) => new ContextKeySmallerEqualsExpr(key, value, negated));
	}
	constructor(key, value, negated) {
		this.key = key;
		this.value = value;
		this.negated = negated;
		this.type = 15;
	}
	cmp(other) {
		if (other.type !== this.type) return this.type - other.type;
		return cmp2(this.key, this.value, other.key, other.value);
	}
	equals(other) {
		if (other.type === this.type) return this.key === other.key && this.value === other.value;
		return false;
	}
	substituteConstants() {
		return this;
	}
	evaluate(context) {
		if (typeof this.value === "string") return false;
		return parseFloat(context.getValue(this.key)) <= this.value;
	}
	serialize() {
		return `${this.key} <= ${this.value}`;
	}
	keys() {
		return [this.key];
	}
	negate() {
		if (!this.negated) this.negated = ContextKeyGreaterExpr.create(this.key, this.value, this);
		return this.negated;
	}
};
var ContextKeyRegexExpr = class ContextKeyRegexExpr {
	static create(key, regexp) {
		return new ContextKeyRegexExpr(key, regexp);
	}
	constructor(key, regexp) {
		this.key = key;
		this.regexp = regexp;
		this.type = 7;
		this.negated = null;
	}
	cmp(other) {
		if (other.type !== this.type) return this.type - other.type;
		if (this.key < other.key) return -1;
		if (this.key > other.key) return 1;
		const thisSource = this.regexp ? this.regexp.source : "";
		const otherSource = other.regexp ? other.regexp.source : "";
		if (thisSource < otherSource) return -1;
		if (thisSource > otherSource) return 1;
		return 0;
	}
	equals(other) {
		if (other.type === this.type) {
			const thisSource = this.regexp ? this.regexp.source : "";
			const otherSource = other.regexp ? other.regexp.source : "";
			return this.key === other.key && thisSource === otherSource;
		}
		return false;
	}
	substituteConstants() {
		return this;
	}
	evaluate(context) {
		const value = context.getValue(this.key);
		return this.regexp ? this.regexp.test(value) : false;
	}
	serialize() {
		const value = this.regexp ? `/${this.regexp.source}/${this.regexp.flags}` : "/invalid/";
		return `${this.key} =~ ${value}`;
	}
	keys() {
		return [this.key];
	}
	negate() {
		if (!this.negated) this.negated = ContextKeyNotRegexExpr.create(this);
		return this.negated;
	}
};
var ContextKeyNotRegexExpr = class ContextKeyNotRegexExpr {
	static create(actual) {
		return new ContextKeyNotRegexExpr(actual);
	}
	constructor(_actual) {
		this._actual = _actual;
		this.type = 8;
	}
	cmp(other) {
		if (other.type !== this.type) return this.type - other.type;
		return this._actual.cmp(other._actual);
	}
	equals(other) {
		if (other.type === this.type) return this._actual.equals(other._actual);
		return false;
	}
	substituteConstants() {
		return this;
	}
	evaluate(context) {
		return !this._actual.evaluate(context);
	}
	serialize() {
		return `!(${this._actual.serialize()})`;
	}
	keys() {
		return this._actual.keys();
	}
	negate() {
		return this._actual;
	}
};
/**
* @returns the same instance if nothing changed.
*/
function eliminateConstantsInArray(arr) {
	let newArr = null;
	for (let i = 0, len = arr.length; i < len; i++) {
		const newExpr = arr[i].substituteConstants();
		if (arr[i] !== newExpr) {
			if (newArr === null) {
				newArr = [];
				for (let j = 0; j < i; j++) newArr[j] = arr[j];
			}
		}
		if (newArr !== null) newArr[i] = newExpr;
	}
	if (newArr === null) return arr;
	return newArr;
}
var ContextKeyAndExpr = class ContextKeyAndExpr {
	static create(_expr, negated, extraRedundantCheck) {
		return ContextKeyAndExpr._normalizeArr(_expr, negated, extraRedundantCheck);
	}
	constructor(expr, negated) {
		this.expr = expr;
		this.negated = negated;
		this.type = 6;
	}
	cmp(other) {
		if (other.type !== this.type) return this.type - other.type;
		if (this.expr.length < other.expr.length) return -1;
		if (this.expr.length > other.expr.length) return 1;
		for (let i = 0, len = this.expr.length; i < len; i++) {
			const r = cmp(this.expr[i], other.expr[i]);
			if (r !== 0) return r;
		}
		return 0;
	}
	equals(other) {
		if (other.type === this.type) {
			if (this.expr.length !== other.expr.length) return false;
			for (let i = 0, len = this.expr.length; i < len; i++) if (!this.expr[i].equals(other.expr[i])) return false;
			return true;
		}
		return false;
	}
	substituteConstants() {
		const exprArr = eliminateConstantsInArray(this.expr);
		if (exprArr === this.expr) return this;
		return ContextKeyAndExpr.create(exprArr, this.negated, false);
	}
	evaluate(context) {
		for (let i = 0, len = this.expr.length; i < len; i++) if (!this.expr[i].evaluate(context)) return false;
		return true;
	}
	static _normalizeArr(arr, negated, extraRedundantCheck) {
		const expr = [];
		let hasTrue = false;
		for (const e of arr) {
			if (!e) continue;
			if (e.type === 1) {
				hasTrue = true;
				continue;
			}
			if (e.type === 0) return ContextKeyFalseExpr.INSTANCE;
			if (e.type === 6) {
				expr.push(...e.expr);
				continue;
			}
			expr.push(e);
		}
		if (expr.length === 0 && hasTrue) return ContextKeyTrueExpr.INSTANCE;
		if (expr.length === 0) return;
		if (expr.length === 1) return expr[0];
		expr.sort(cmp);
		for (let i = 1; i < expr.length; i++) if (expr[i - 1].equals(expr[i])) {
			expr.splice(i, 1);
			i--;
		}
		if (expr.length === 1) return expr[0];
		while (expr.length > 1) {
			const lastElement = expr[expr.length - 1];
			if (lastElement.type !== 9) break;
			expr.pop();
			const secondToLastElement = expr.pop();
			const isFinished = expr.length === 0;
			const resultElement = ContextKeyOrExpr.create(lastElement.expr.map((el) => ContextKeyAndExpr.create([el, secondToLastElement], null, extraRedundantCheck)), null, isFinished);
			if (resultElement) {
				expr.push(resultElement);
				expr.sort(cmp);
			}
		}
		if (expr.length === 1) return expr[0];
		if (extraRedundantCheck) {
			for (let i = 0; i < expr.length; i++) for (let j = i + 1; j < expr.length; j++) if (expr[i].negate().equals(expr[j])) return ContextKeyFalseExpr.INSTANCE;
			if (expr.length === 1) return expr[0];
		}
		return new ContextKeyAndExpr(expr, negated);
	}
	serialize() {
		return this.expr.map((e) => e.serialize()).join(" && ");
	}
	keys() {
		const result = [];
		for (const expr of this.expr) result.push(...expr.keys());
		return result;
	}
	negate() {
		if (!this.negated) {
			const result = [];
			for (const expr of this.expr) result.push(expr.negate());
			this.negated = ContextKeyOrExpr.create(result, this, true);
		}
		return this.negated;
	}
};
var ContextKeyOrExpr = class ContextKeyOrExpr {
	static create(_expr, negated, extraRedundantCheck) {
		return ContextKeyOrExpr._normalizeArr(_expr, negated, extraRedundantCheck);
	}
	constructor(expr, negated) {
		this.expr = expr;
		this.negated = negated;
		this.type = 9;
	}
	cmp(other) {
		if (other.type !== this.type) return this.type - other.type;
		if (this.expr.length < other.expr.length) return -1;
		if (this.expr.length > other.expr.length) return 1;
		for (let i = 0, len = this.expr.length; i < len; i++) {
			const r = cmp(this.expr[i], other.expr[i]);
			if (r !== 0) return r;
		}
		return 0;
	}
	equals(other) {
		if (other.type === this.type) {
			if (this.expr.length !== other.expr.length) return false;
			for (let i = 0, len = this.expr.length; i < len; i++) if (!this.expr[i].equals(other.expr[i])) return false;
			return true;
		}
		return false;
	}
	substituteConstants() {
		const exprArr = eliminateConstantsInArray(this.expr);
		if (exprArr === this.expr) return this;
		return ContextKeyOrExpr.create(exprArr, this.negated, false);
	}
	evaluate(context) {
		for (let i = 0, len = this.expr.length; i < len; i++) if (this.expr[i].evaluate(context)) return true;
		return false;
	}
	static _normalizeArr(arr, negated, extraRedundantCheck) {
		let expr = [];
		let hasFalse = false;
		if (arr) {
			for (let i = 0, len = arr.length; i < len; i++) {
				const e = arr[i];
				if (!e) continue;
				if (e.type === 0) {
					hasFalse = true;
					continue;
				}
				if (e.type === 1) return ContextKeyTrueExpr.INSTANCE;
				if (e.type === 9) {
					expr = expr.concat(e.expr);
					continue;
				}
				expr.push(e);
			}
			if (expr.length === 0 && hasFalse) return ContextKeyFalseExpr.INSTANCE;
			expr.sort(cmp);
		}
		if (expr.length === 0) return;
		if (expr.length === 1) return expr[0];
		for (let i = 1; i < expr.length; i++) if (expr[i - 1].equals(expr[i])) {
			expr.splice(i, 1);
			i--;
		}
		if (expr.length === 1) return expr[0];
		if (extraRedundantCheck) {
			for (let i = 0; i < expr.length; i++) for (let j = i + 1; j < expr.length; j++) if (expr[i].negate().equals(expr[j])) return ContextKeyTrueExpr.INSTANCE;
			if (expr.length === 1) return expr[0];
		}
		return new ContextKeyOrExpr(expr, negated);
	}
	serialize() {
		return this.expr.map((e) => e.serialize()).join(" || ");
	}
	keys() {
		const result = [];
		for (const expr of this.expr) result.push(...expr.keys());
		return result;
	}
	negate() {
		if (!this.negated) {
			const result = [];
			for (const expr of this.expr) result.push(expr.negate());
			while (result.length > 1) {
				const LEFT = result.shift();
				const RIGHT = result.shift();
				const all = [];
				for (const left of getTerminals(LEFT)) for (const right of getTerminals(RIGHT)) all.push(ContextKeyAndExpr.create([left, right], null, false));
				result.unshift(ContextKeyOrExpr.create(all, null, false));
			}
			this.negated = ContextKeyOrExpr.create(result, this, true);
		}
		return this.negated;
	}
};
var RawContextKey = class RawContextKey extends ContextKeyDefinedExpr {
	static {
		this._info = [];
	}
	static all() {
		return RawContextKey._info.values();
	}
	constructor(key, defaultValue, metaOrHide) {
		super(key, null);
		this._defaultValue = defaultValue;
		if (typeof metaOrHide === "object") RawContextKey._info.push({
			...metaOrHide,
			key
		});
		else if (metaOrHide !== true) RawContextKey._info.push({
			key,
			description: metaOrHide,
			type: defaultValue !== null && defaultValue !== void 0 ? typeof defaultValue : void 0
		});
	}
	bindTo(target) {
		return target.createKey(this.key, this._defaultValue);
	}
	getValue(target) {
		return target.getContextKeyValue(this.key);
	}
	toNegated() {
		return this.negate();
	}
	isEqualTo(value) {
		return ContextKeyEqualsExpr.create(this.key, value);
	}
};
var IContextKeyService = createDecorator("contextKeyService");
function cmp1(key1, key2) {
	if (key1 < key2) return -1;
	if (key1 > key2) return 1;
	return 0;
}
function cmp2(key1, value1, key2, value2) {
	if (key1 < key2) return -1;
	if (key1 > key2) return 1;
	if (value1 < value2) return -1;
	if (value1 > value2) return 1;
	return 0;
}
/**
* Returns true if it is provable `p` implies `q`.
*/
function implies(p, q) {
	if (p.type === 0 || q.type === 1) return true;
	if (p.type === 9) {
		if (q.type === 9) return allElementsIncluded(p.expr, q.expr);
		return false;
	}
	if (q.type === 9) {
		for (const element of q.expr) if (implies(p, element)) return true;
		return false;
	}
	if (p.type === 6) {
		if (q.type === 6) return allElementsIncluded(q.expr, p.expr);
		for (const element of p.expr) if (implies(element, q)) return true;
		return false;
	}
	return p.equals(q);
}
/**
* Returns true if all elements in `p` are also present in `q`.
* The two arrays are assumed to be sorted
*/
function allElementsIncluded(p, q) {
	let pIndex = 0;
	let qIndex = 0;
	while (pIndex < p.length && qIndex < q.length) {
		const cmp = p[pIndex].cmp(q[qIndex]);
		if (cmp < 0) return false;
		else if (cmp === 0) {
			pIndex++;
			qIndex++;
		} else qIndex++;
	}
	return pIndex === p.length;
}
function getTerminals(node) {
	if (node.type === 9) return node.expr;
	return [node];
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/registry/common/platform.js
var RegistryImpl = class {
	constructor() {
		this.data = /* @__PURE__ */ new Map();
	}
	add(id, data) {
		ok(isString$1(id));
		ok(isObject(data));
		ok(!this.data.has(id), "There is already an extension with this id");
		this.data.set(id, data);
	}
	as(id) {
		return this.data.get(id) || null;
	}
	dispose() {
		this.data.forEach((value) => {
			if (isFunction(value.dispose)) value.dispose();
		});
		this.data.clear();
	}
};
var Registry = new RegistryImpl();
var KeybindingsRegistry = new class KeybindingsRegistryImpl {
	constructor() {
		this._coreKeybindings = new LinkedList();
		this._coreKeybindingRules = new LinkedList();
		this._extensionKeybindings = [];
		this._cachedMergedKeybindings = null;
	}
	static bindToPlatform(kb, os) {
		if (os === 1) {
			if (kb && kb.win) return kb.win;
		} else if (os === 2) {
			if (kb && kb.mac) return kb.mac;
		} else if (kb && kb.linux) return kb.linux;
		return kb;
	}
	/**
	* Take current platform into account and reduce to primary & secondary.
	*/
	static bindToCurrentPlatform(kb) {
		return KeybindingsRegistryImpl.bindToPlatform(kb, OS);
	}
	registerKeybindingRule(rule) {
		const actualKb = KeybindingsRegistryImpl.bindToCurrentPlatform(rule);
		const result = new DisposableStore();
		if (actualKb && actualKb.primary) {
			const kk = decodeKeybinding(actualKb.primary, OS);
			if (kk) result.add(this._registerDefaultKeybinding(kk, rule.id, rule.args, rule.weight, 0, rule.when));
		}
		if (actualKb && Array.isArray(actualKb.secondary)) for (let i = 0, len = actualKb.secondary.length; i < len; i++) {
			const k = actualKb.secondary[i];
			const kk = decodeKeybinding(k, OS);
			if (kk) result.add(this._registerDefaultKeybinding(kk, rule.id, rule.args, rule.weight, -i - 1, rule.when));
		}
		const removeRule = this._coreKeybindingRules.push(rule);
		result.add(toDisposable(() => {
			removeRule();
		}));
		return result;
	}
	registerCommandAndKeybindingRule(desc) {
		return combinedDisposable(this.registerKeybindingRule(desc), CommandsRegistry.registerCommand(desc));
	}
	_registerDefaultKeybinding(keybinding, commandId, commandArgs, weight1, weight2, when) {
		const remove = this._coreKeybindings.push({
			keybinding,
			command: commandId,
			commandArgs,
			when,
			weight1,
			weight2,
			extensionId: null,
			isBuiltinExtension: false
		});
		this._cachedMergedKeybindings = null;
		return toDisposable(() => {
			remove();
			this._cachedMergedKeybindings = null;
		});
	}
	getDefaultKeybindings() {
		if (!this._cachedMergedKeybindings) {
			this._cachedMergedKeybindings = Array.from(this._coreKeybindings).concat(this._extensionKeybindings);
			this._cachedMergedKeybindings.sort(sorter);
		}
		return this._cachedMergedKeybindings.slice(0);
	}
}();
Registry.add({ EditorModes: "platform.keybindingsRegistry" }.EditorModes, KeybindingsRegistry);
function sorter(a, b) {
	if (a.weight1 !== b.weight1) return a.weight1 - b.weight1;
	if (a.command && b.command) {
		if (a.command < b.command) return -1;
		if (a.command > b.command) return 1;
	}
	return a.weight2 - b.weight2;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/actions/common/actions.js
var __decorate$81 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$74 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var MenuItemAction_1;
function isIMenuItem(item) {
	return item.command !== void 0;
}
function isISubmenuItem(item) {
	return item.submenu !== void 0;
}
var MenuId = class MenuId {
	static {
		this._instances = /* @__PURE__ */ new Map();
	}
	static {
		this.CommandPalette = new MenuId("CommandPalette");
	}
	static {
		this.DebugBreakpointsContext = new MenuId("DebugBreakpointsContext");
	}
	static {
		this.DebugCallStackContext = new MenuId("DebugCallStackContext");
	}
	static {
		this.DebugConsoleContext = new MenuId("DebugConsoleContext");
	}
	static {
		this.DebugVariablesContext = new MenuId("DebugVariablesContext");
	}
	static {
		this.NotebookVariablesContext = new MenuId("NotebookVariablesContext");
	}
	static {
		this.DebugHoverContext = new MenuId("DebugHoverContext");
	}
	static {
		this.DebugWatchContext = new MenuId("DebugWatchContext");
	}
	static {
		this.DebugToolBar = new MenuId("DebugToolBar");
	}
	static {
		this.DebugToolBarStop = new MenuId("DebugToolBarStop");
	}
	static {
		this.DebugDisassemblyContext = new MenuId("DebugDisassemblyContext");
	}
	static {
		this.DebugCallStackToolbar = new MenuId("DebugCallStackToolbar");
	}
	static {
		this.DebugCreateConfiguration = new MenuId("DebugCreateConfiguration");
	}
	static {
		this.DebugScopesContext = new MenuId("DebugScopesContext");
	}
	static {
		this.EditorContext = new MenuId("EditorContext");
	}
	static {
		this.SimpleEditorContext = new MenuId("SimpleEditorContext");
	}
	static {
		this.EditorContent = new MenuId("EditorContent");
	}
	static {
		this.EditorLineNumberContext = new MenuId("EditorLineNumberContext");
	}
	static {
		this.EditorContextCopy = new MenuId("EditorContextCopy");
	}
	static {
		this.EditorContextPeek = new MenuId("EditorContextPeek");
	}
	static {
		this.EditorContextShare = new MenuId("EditorContextShare");
	}
	static {
		this.EditorTitle = new MenuId("EditorTitle");
	}
	static {
		this.EditorTitleLayout = new MenuId("EditorTitleLayout");
	}
	static {
		this.ModalEditorTitle = new MenuId("ModalEditorTitle");
	}
	static {
		this.ModalEditorTitleContext = new MenuId("ModalEditorTitleContext");
	}
	static {
		this.ModalEditorEditorTitle = new MenuId("ModalEditorEditorTitle");
	}
	static {
		this.CompactWindowEditorTitle = new MenuId("CompactWindowEditorTitle");
	}
	static {
		this.EditorTitleRun = new MenuId("EditorTitleRun");
	}
	static {
		this.EditorTitleContext = new MenuId("EditorTitleContext");
	}
	static {
		this.EditorTitleContextShare = new MenuId("EditorTitleContextShare");
	}
	static {
		this.EmptyEditorGroup = new MenuId("EmptyEditorGroup");
	}
	static {
		this.EmptyEditorGroupContext = new MenuId("EmptyEditorGroupContext");
	}
	static {
		this.EditorGroupWatermarkToolbar = new MenuId("EditorGroupWatermarkToolbar");
	}
	static {
		this.EditorTabsBarContext = new MenuId("EditorTabsBarContext");
	}
	static {
		this.EditorTabsBarShowTabsSubmenu = new MenuId("EditorTabsBarShowTabsSubmenu");
	}
	static {
		this.EditorTabsBarShowTabsZenModeSubmenu = new MenuId("EditorTabsBarShowTabsZenModeSubmenu");
	}
	static {
		this.EditorActionsPositionSubmenu = new MenuId("EditorActionsPositionSubmenu");
	}
	static {
		this.DiffEditorViewSubmenu = new MenuId("DiffEditorViewSubmenu");
	}
	static {
		this.EditorRenderWhitespaceSubmenu = new MenuId("EditorRenderWhitespaceSubmenu");
	}
	static {
		this.EditorSplitMoveSubmenu = new MenuId("EditorSplitMoveSubmenu");
	}
	static {
		this.ExplorerContext = new MenuId("ExplorerContext");
	}
	static {
		this.ExplorerContextShare = new MenuId("ExplorerContextShare");
	}
	static {
		this.ExtensionContext = new MenuId("ExtensionContext");
	}
	static {
		this.ExtensionEditorContextMenu = new MenuId("ExtensionEditorContextMenu");
	}
	static {
		this.GlobalActivity = new MenuId("GlobalActivity");
	}
	static {
		this.CommandCenter = new MenuId("CommandCenter");
	}
	static {
		this.CommandCenterCenter = new MenuId("CommandCenterCenter");
	}
	static {
		this.LayoutControlMenuSubmenu = new MenuId("LayoutControlMenuSubmenu");
	}
	static {
		this.LayoutControlMenu = new MenuId("LayoutControlMenu");
	}
	static {
		this.MenubarMainMenu = new MenuId("MenubarMainMenu");
	}
	static {
		this.MenubarAppearanceMenu = new MenuId("MenubarAppearanceMenu");
	}
	static {
		this.MenubarDebugMenu = new MenuId("MenubarDebugMenu");
	}
	static {
		this.MenubarEditMenu = new MenuId("MenubarEditMenu");
	}
	static {
		this.MenubarCopy = new MenuId("MenubarCopy");
	}
	static {
		this.MenubarFileMenu = new MenuId("MenubarFileMenu");
	}
	static {
		this.MenubarGoMenu = new MenuId("MenubarGoMenu");
	}
	static {
		this.MenubarHelpMenu = new MenuId("MenubarHelpMenu");
	}
	static {
		this.MenubarLayoutMenu = new MenuId("MenubarLayoutMenu");
	}
	static {
		this.MenubarNewBreakpointMenu = new MenuId("MenubarNewBreakpointMenu");
	}
	static {
		this.PanelAlignmentMenu = new MenuId("PanelAlignmentMenu");
	}
	static {
		this.PanelPositionMenu = new MenuId("PanelPositionMenu");
	}
	static {
		this.ActivityBarPositionMenu = new MenuId("ActivityBarPositionMenu");
	}
	static {
		this.NotificationsCenterPositionMenu = new MenuId("NotificationsCenterPositionMenu");
	}
	static {
		this.MenubarPreferencesMenu = new MenuId("MenubarPreferencesMenu");
	}
	static {
		this.MenubarRecentMenu = new MenuId("MenubarRecentMenu");
	}
	static {
		this.MenubarSelectionMenu = new MenuId("MenubarSelectionMenu");
	}
	static {
		this.MenubarShare = new MenuId("MenubarShare");
	}
	static {
		this.MenubarSwitchEditorMenu = new MenuId("MenubarSwitchEditorMenu");
	}
	static {
		this.MenubarSwitchGroupMenu = new MenuId("MenubarSwitchGroupMenu");
	}
	static {
		this.MenubarTerminalMenu = new MenuId("MenubarTerminalMenu");
	}
	static {
		this.MenubarTerminalSuggestStatusMenu = new MenuId("MenubarTerminalSuggestStatusMenu");
	}
	static {
		this.MenubarViewMenu = new MenuId("MenubarViewMenu");
	}
	static {
		this.MenubarHomeMenu = new MenuId("MenubarHomeMenu");
	}
	static {
		this.OpenEditorsContext = new MenuId("OpenEditorsContext");
	}
	static {
		this.OpenEditorsContextShare = new MenuId("OpenEditorsContextShare");
	}
	static {
		this.ProblemsPanelContext = new MenuId("ProblemsPanelContext");
	}
	static {
		this.SCMInputBox = new MenuId("SCMInputBox");
	}
	static {
		this.SCMChangeContext = new MenuId("SCMChangeContext");
	}
	static {
		this.SCMResourceContext = new MenuId("SCMResourceContext");
	}
	static {
		this.SCMResourceContextShare = new MenuId("SCMResourceContextShare");
	}
	static {
		this.SCMResourceFolderContext = new MenuId("SCMResourceFolderContext");
	}
	static {
		this.SCMResourceGroupContext = new MenuId("SCMResourceGroupContext");
	}
	static {
		this.SCMSourceControl = new MenuId("SCMSourceControl");
	}
	static {
		this.SCMSourceControlInline = new MenuId("SCMSourceControlInline");
	}
	static {
		this.SCMSourceControlTitle = new MenuId("SCMSourceControlTitle");
	}
	static {
		this.SCMHistoryTitle = new MenuId("SCMHistoryTitle");
	}
	static {
		this.SCMHistoryItemContext = new MenuId("SCMHistoryItemContext");
	}
	static {
		this.SCMHistoryItemChangeContext = new MenuId("SCMHistoryItemChangeContext");
	}
	static {
		this.SCMHistoryItemRefContext = new MenuId("SCMHistoryItemRefContext");
	}
	static {
		this.SCMArtifactGroupContext = new MenuId("SCMArtifactGroupContext");
	}
	static {
		this.SCMArtifactContext = new MenuId("SCMArtifactContext");
	}
	static {
		this.SCMQuickDiffDecorations = new MenuId("SCMQuickDiffDecorations");
	}
	static {
		this.SCMTitle = new MenuId("SCMTitle");
	}
	static {
		this.SearchContext = new MenuId("SearchContext");
	}
	static {
		this.SearchActionMenu = new MenuId("SearchActionContext");
	}
	static {
		this.StatusBarWindowIndicatorMenu = new MenuId("StatusBarWindowIndicatorMenu");
	}
	static {
		this.StatusBarRemoteIndicatorMenu = new MenuId("StatusBarRemoteIndicatorMenu");
	}
	static {
		this.StickyScrollContext = new MenuId("StickyScrollContext");
	}
	static {
		this.TestItem = new MenuId("TestItem");
	}
	static {
		this.TestItemGutter = new MenuId("TestItemGutter");
	}
	static {
		this.TestProfilesContext = new MenuId("TestProfilesContext");
	}
	static {
		this.TestMessageContext = new MenuId("TestMessageContext");
	}
	static {
		this.TestMessageContent = new MenuId("TestMessageContent");
	}
	static {
		this.TestPeekElement = new MenuId("TestPeekElement");
	}
	static {
		this.TestPeekTitle = new MenuId("TestPeekTitle");
	}
	static {
		this.TestCallStack = new MenuId("TestCallStack");
	}
	static {
		this.TestCoverageFilterItem = new MenuId("TestCoverageFilterItem");
	}
	static {
		this.TouchBarContext = new MenuId("TouchBarContext");
	}
	static {
		this.TitleBar = new MenuId("TitleBar");
	}
	static {
		this.TitleBarAdjacentCenter = new MenuId("TitleBarAdjacentCenter");
	}
	static {
		this.TitleBarUpdate = new MenuId("TitleBarUpdate");
	}
	static {
		this.TitleBarContext = new MenuId("TitleBarContext");
	}
	static {
		this.TitleBarTitleContext = new MenuId("TitleBarTitleContext");
	}
	static {
		this.TunnelContext = new MenuId("TunnelContext");
	}
	static {
		this.TunnelPrivacy = new MenuId("TunnelPrivacy");
	}
	static {
		this.TunnelProtocol = new MenuId("TunnelProtocol");
	}
	static {
		this.TunnelPortInline = new MenuId("TunnelInline");
	}
	static {
		this.TunnelTitle = new MenuId("TunnelTitle");
	}
	static {
		this.TunnelLocalAddressInline = new MenuId("TunnelLocalAddressInline");
	}
	static {
		this.TunnelOriginInline = new MenuId("TunnelOriginInline");
	}
	static {
		this.ViewItemContext = new MenuId("ViewItemContext");
	}
	static {
		this.ViewContainerTitle = new MenuId("ViewContainerTitle");
	}
	static {
		this.ViewContainerTitleContext = new MenuId("ViewContainerTitleContext");
	}
	static {
		this.ViewTitle = new MenuId("ViewTitle");
	}
	static {
		this.ViewTitleContext = new MenuId("ViewTitleContext");
	}
	static {
		this.CommentEditorActions = new MenuId("CommentEditorActions");
	}
	static {
		this.CommentThreadTitle = new MenuId("CommentThreadTitle");
	}
	static {
		this.CommentThreadActions = new MenuId("CommentThreadActions");
	}
	static {
		this.CommentThreadAdditionalActions = new MenuId("CommentThreadAdditionalActions");
	}
	static {
		this.CommentThreadTitleContext = new MenuId("CommentThreadTitleContext");
	}
	static {
		this.CommentThreadCommentContext = new MenuId("CommentThreadCommentContext");
	}
	static {
		this.CommentTitle = new MenuId("CommentTitle");
	}
	static {
		this.CommentActions = new MenuId("CommentActions");
	}
	static {
		this.CommentsViewThreadActions = new MenuId("CommentsViewThreadActions");
	}
	static {
		this.InteractiveToolbar = new MenuId("InteractiveToolbar");
	}
	static {
		this.InteractiveCellTitle = new MenuId("InteractiveCellTitle");
	}
	static {
		this.InteractiveCellDelete = new MenuId("InteractiveCellDelete");
	}
	static {
		this.InteractiveCellExecute = new MenuId("InteractiveCellExecute");
	}
	static {
		this.InteractiveInputExecute = new MenuId("InteractiveInputExecute");
	}
	static {
		this.InteractiveInputConfig = new MenuId("InteractiveInputConfig");
	}
	static {
		this.ReplInputExecute = new MenuId("ReplInputExecute");
	}
	static {
		this.IssueReporter = new MenuId("IssueReporter");
	}
	static {
		this.NotebookToolbar = new MenuId("NotebookToolbar");
	}
	static {
		this.NotebookToolbarContext = new MenuId("NotebookToolbarContext");
	}
	static {
		this.NotebookStickyScrollContext = new MenuId("NotebookStickyScrollContext");
	}
	static {
		this.NotebookCellTitle = new MenuId("NotebookCellTitle");
	}
	static {
		this.NotebookCellDelete = new MenuId("NotebookCellDelete");
	}
	static {
		this.NotebookCellInsert = new MenuId("NotebookCellInsert");
	}
	static {
		this.NotebookCellBetween = new MenuId("NotebookCellBetween");
	}
	static {
		this.NotebookCellListTop = new MenuId("NotebookCellTop");
	}
	static {
		this.NotebookCellExecute = new MenuId("NotebookCellExecute");
	}
	static {
		this.NotebookCellExecuteGoTo = new MenuId("NotebookCellExecuteGoTo");
	}
	static {
		this.NotebookCellExecutePrimary = new MenuId("NotebookCellExecutePrimary");
	}
	static {
		this.NotebookDiffCellInputTitle = new MenuId("NotebookDiffCellInputTitle");
	}
	static {
		this.NotebookDiffDocumentMetadata = new MenuId("NotebookDiffDocumentMetadata");
	}
	static {
		this.NotebookDiffCellMetadataTitle = new MenuId("NotebookDiffCellMetadataTitle");
	}
	static {
		this.NotebookDiffCellOutputsTitle = new MenuId("NotebookDiffCellOutputsTitle");
	}
	static {
		this.NotebookOutputToolbar = new MenuId("NotebookOutputToolbar");
	}
	static {
		this.NotebookOutlineFilter = new MenuId("NotebookOutlineFilter");
	}
	static {
		this.NotebookOutlineActionMenu = new MenuId("NotebookOutlineActionMenu");
	}
	static {
		this.NotebookEditorLayoutConfigure = new MenuId("NotebookEditorLayoutConfigure");
	}
	static {
		this.NotebookKernelSource = new MenuId("NotebookKernelSource");
	}
	static {
		this.BulkEditTitle = new MenuId("BulkEditTitle");
	}
	static {
		this.BulkEditContext = new MenuId("BulkEditContext");
	}
	static {
		this.TimelineItemContext = new MenuId("TimelineItemContext");
	}
	static {
		this.TimelineTitle = new MenuId("TimelineTitle");
	}
	static {
		this.TimelineTitleContext = new MenuId("TimelineTitleContext");
	}
	static {
		this.TimelineFilterSubMenu = new MenuId("TimelineFilterSubMenu");
	}
	static {
		this.AccountsContext = new MenuId("AccountsContext");
	}
	static {
		this.SidebarTitle = new MenuId("SidebarTitle");
	}
	static {
		this.PanelTitle = new MenuId("PanelTitle");
	}
	static {
		this.AuxiliaryBarTitle = new MenuId("AuxiliaryBarTitle");
	}
	static {
		this.TerminalInstanceContext = new MenuId("TerminalInstanceContext");
	}
	static {
		this.TerminalEditorInstanceContext = new MenuId("TerminalEditorInstanceContext");
	}
	static {
		this.TerminalNewDropdownContext = new MenuId("TerminalNewDropdownContext");
	}
	static {
		this.TerminalTabContext = new MenuId("TerminalTabContext");
	}
	static {
		this.TerminalTabEmptyAreaContext = new MenuId("TerminalTabEmptyAreaContext");
	}
	static {
		this.TerminalStickyScrollContext = new MenuId("TerminalStickyScrollContext");
	}
	static {
		this.WebviewContext = new MenuId("WebviewContext");
	}
	static {
		this.InlineCompletionsActions = new MenuId("InlineCompletionsActions");
	}
	static {
		this.InlineEditsActions = new MenuId("InlineEditsActions");
	}
	static {
		this.NewFile = new MenuId("NewFile");
	}
	static {
		this.MergeInput1Toolbar = new MenuId("MergeToolbar1Toolbar");
	}
	static {
		this.MergeInput2Toolbar = new MenuId("MergeToolbar2Toolbar");
	}
	static {
		this.MergeBaseToolbar = new MenuId("MergeBaseToolbar");
	}
	static {
		this.MergeInputResultToolbar = new MenuId("MergeToolbarResultToolbar");
	}
	static {
		this.InlineSuggestionToolbar = new MenuId("InlineSuggestionToolbar");
	}
	static {
		this.InlineEditToolbar = new MenuId("InlineEditToolbar");
	}
	static {
		this.ChatContext = new MenuId("ChatContext");
	}
	static {
		this.ChatCodeBlock = new MenuId("ChatCodeblock");
	}
	static {
		this.ChatCompareBlock = new MenuId("ChatCompareBlock");
	}
	static {
		this.ChatMessageTitle = new MenuId("ChatMessageTitle");
	}
	static {
		this.ChatWelcomeContext = new MenuId("ChatWelcomeContext");
	}
	static {
		this.ChatMessageFooter = new MenuId("ChatMessageFooter");
	}
	static {
		this.ChatSubagentContent = new MenuId("ChatSubagentContent");
	}
	static {
		this.ChatExecute = new MenuId("ChatExecute");
	}
	static {
		this.ChatExecuteQueue = new MenuId("ChatExecuteQueue");
	}
	static {
		this.ChatInput = new MenuId("ChatInput");
	}
	static {
		this.ChatInputSecondary = new MenuId("ChatInputSecondary");
	}
	static {
		this.ChatInputStatus = new MenuId("ChatInputStatus");
	}
	static {
		this.ChatInputSide = new MenuId("ChatInputSide");
	}
	static {
		this.AutomationsDialogInput = new MenuId("AutomationsDialogInput");
	}
	static {
		this.ChatModePicker = new MenuId("ChatModePicker");
	}
	static {
		this.ChatEditingWidgetToolbar = new MenuId("ChatEditingWidgetToolbar");
	}
	static {
		this.ChatEditingSessionChangesToolbar = new MenuId("ChatEditingSessionChangesToolbar");
	}
	static {
		this.ChatEditingSessionTitleToolbar = new MenuId("ChatEditingSessionTitleToolbar");
	}
	static {
		this.ChatEditingSessionChangesVersionsSubmenu = new MenuId("ChatEditingSessionChangesVersionsSubmenu");
	}
	static {
		this.ChatEditingSessionChangesFileHeaderToolbar = new MenuId("ChatEditingSessionChangesFileHeaderToolbar");
	}
	static {
		this.ChatEditingSessionChangesFileHeaderRightToolbar = new MenuId("ChatEditingSessionChangesFileHeaderRightToolbar");
	}
	static {
		this.ChatEditingEditorContent = new MenuId("ChatEditingEditorContent");
	}
	static {
		this.ChatEditingEditorHunk = new MenuId("ChatEditingEditorHunk");
	}
	static {
		this.ChatEditingDeletedNotebookCell = new MenuId("ChatEditingDeletedNotebookCell");
	}
	static {
		this.ChatInputAttachmentToolbar = new MenuId("ChatInputAttachmentToolbar");
	}
	static {
		this.ChatEditingWidgetModifiedFilesToolbar = new MenuId("ChatEditingWidgetModifiedFilesToolbar");
	}
	static {
		this.ChatInputResourceAttachmentContext = new MenuId("ChatInputResourceAttachmentContext");
	}
	static {
		this.ChatInputSymbolAttachmentContext = new MenuId("ChatInputSymbolAttachmentContext");
	}
	static {
		this.ChatInlineResourceAnchorContext = new MenuId("ChatInlineResourceAnchorContext");
	}
	static {
		this.ChatInlineSymbolAnchorContext = new MenuId("ChatInlineSymbolAnchorContext");
	}
	static {
		this.ChatMessageCheckpoint = new MenuId("ChatMessageCheckpoint");
	}
	static {
		this.ChatMessageRestoreCheckpoint = new MenuId("ChatMessageRestoreCheckpoint");
	}
	static {
		this.ChatNewMenu = new MenuId("ChatNewMenu");
	}
	static {
		this.ChatEditingCodeBlockContext = new MenuId("ChatEditingCodeBlockContext");
	}
	static {
		this.ChatTitleBarMenu = new MenuId("ChatTitleBarMenu");
	}
	static {
		this.ChatAttachmentsContext = new MenuId("ChatAttachmentsContext");
	}
	static {
		this.ChatTipContext = new MenuId("ChatTipContext");
	}
	static {
		this.ChatTipToolbar = new MenuId("ChatTipToolbar");
	}
	static {
		this.ChatToolOutputResourceToolbar = new MenuId("ChatToolOutputResourceToolbar");
	}
	static {
		this.ChatTextEditorMenu = new MenuId("ChatTextEditorMenu");
	}
	static {
		this.ChatToolOutputResourceContext = new MenuId("ChatToolOutputResourceContext");
	}
	static {
		this.ChatMultiDiffContext = new MenuId("ChatMultiDiffContext");
	}
	static {
		this.ChatConfirmationMenu = new MenuId("ChatConfirmationMenu");
	}
	static {
		this.ChatEditorInlineMenu = new MenuId("ChatEditorInlineGutter");
	}
	static {
		this.ChatEditorInlineExecute = new MenuId("ChatEditorInputExecute");
	}
	static {
		this.ChatEditorInlineInputSide = new MenuId("ChatEditorInputSide");
	}
	static {
		this.InlineChatEditorAffordance = new MenuId("InlineChatEditorAffordance");
	}
	static {
		this.AccessibleView = new MenuId("AccessibleView");
	}
	static {
		this.MultiDiffEditorContent = new MenuId("MultiDiffEditorContent");
	}
	static {
		this.MultiDiffEditorFileToolbar = new MenuId("MultiDiffEditorFileToolbar");
	}
	static {
		this.DiffEditorHunkToolbar = new MenuId("DiffEditorHunkToolbar");
	}
	static {
		this.DiffEditorSelectionToolbar = new MenuId("DiffEditorSelectionToolbar");
	}
	static {
		this.BrowserNavigationToolbar = new MenuId("BrowserNavigationToolbar");
	}
	static {
		this.BrowserActionsToolbar = new MenuId("BrowserActionsToolbar");
	}
	static {
		this.BrowserChatActionsMenu = new MenuId("BrowserChatActionsMenu");
	}
	static {
		this.BrowserEmulationToolbar = new MenuId("BrowserEmulationToolbar");
	}
	static {
		this.AgentSessionsViewerFilterSubMenu = new MenuId("AgentSessionsViewerFilterSubMenu");
	}
	static {
		this.AgentSessionsExternalFilterSubMenu = new MenuId("AgentSessionsExternalFilterSubMenu");
	}
	static {
		this.AgentSessionsContext = new MenuId("AgentSessionsContext");
	}
	static {
		this.AgentSessionSectionContext = new MenuId("AgentSessionSectionContext");
	}
	static {
		this.AgentSessionsCreateSubMenu = new MenuId("AgentSessionsCreateSubMenu");
	}
	static {
		this.AgentSessionsToolbar = new MenuId("AgentSessionsToolbar");
	}
	static {
		this.AgentSessionItemToolbar = new MenuId("AgentSessionItemToolbar");
	}
	static {
		this.AgentSessionSectionToolbar = new MenuId("AgentSessionSectionToolbar");
	}
	static {
		this.SessionItemContextMenu = new MenuId("SessionItemContextMenu");
	}
	static {
		this.SessionHeaderContext = new MenuId("SessionsSessionHeaderContext");
	}
	static {
		this.AgentsTitleBarControlMenu = new MenuId("AgentsTitleBarControlMenu");
	}
	static {
		this.AgentsChangesToolbar = new MenuId("AgentsChangesToolbar");
	}
	static {
		this.AgentsChangesPrimaryActionSubMenu = new MenuId("AgentsChangesPrimaryActionSubMenu");
	}
	static {
		this.AgentsChangeInlineToolbar = new MenuId("AgentsChangeInlineToolbar");
	}
	static {
		this.ChatViewSessionTitleNavigationToolbar = new MenuId("ChatViewSessionTitleNavigationToolbar");
	}
	static {
		this.ChatViewSessionTitleToolbar = new MenuId("ChatViewSessionTitleToolbar");
	}
	static {
		this.ChatContextUsageActions = new MenuId("ChatContextUsageActions");
	}
	static {
		this.MarkerHoverStatusBar = new MenuId("MarkerHoverParticipant.StatusBar");
	}
	/**
	* Create a new `MenuId` with the unique identifier. Will throw if a menu
	* with the identifier already exists, use `MenuId.for(ident)` or a unique
	* identifier
	*/
	constructor(identifier) {
		if (MenuId._instances.has(identifier)) throw new TypeError(`MenuId with identifier '${identifier}' already exists. Use MenuId.for(ident) or a unique identifier`);
		MenuId._instances.set(identifier, this);
		this.id = identifier;
	}
};
var IMenuService = createDecorator("menuService");
var MenuRegistryChangeEvent = class MenuRegistryChangeEvent {
	static {
		this._all = /* @__PURE__ */ new Map();
	}
	static for(id) {
		let value = this._all.get(id);
		if (!value) {
			value = new MenuRegistryChangeEvent(id);
			this._all.set(id, value);
		}
		return value;
	}
	static merge(events) {
		const ids = /* @__PURE__ */ new Set();
		for (const item of events) if (item instanceof MenuRegistryChangeEvent) ids.add(item.id);
		return ids;
	}
	constructor(id) {
		this.id = id;
		this.has = (candidate) => candidate === id;
	}
};
var MenuRegistry = new class {
	constructor() {
		this._commands = /* @__PURE__ */ new Map();
		this._menuItems = /* @__PURE__ */ new Map();
		this._onDidChangeMenu = new MicrotaskEmitter({ merge: MenuRegistryChangeEvent.merge });
		this.onDidChangeMenu = this._onDidChangeMenu.event;
	}
	addCommand(command) {
		this._commands.set(command.id, command);
		this._onDidChangeMenu.fire(MenuRegistryChangeEvent.for(MenuId.CommandPalette));
		return markAsSingleton(toDisposable(() => {
			if (this._commands.delete(command.id)) this._onDidChangeMenu.fire(MenuRegistryChangeEvent.for(MenuId.CommandPalette));
		}));
	}
	getCommand(id) {
		return this._commands.get(id);
	}
	getCommands() {
		const map = /* @__PURE__ */ new Map();
		this._commands.forEach((value, key) => map.set(key, value));
		return map;
	}
	appendMenuItem(id, item) {
		let list = this._menuItems.get(id);
		if (!list) {
			list = new LinkedList();
			this._menuItems.set(id, list);
		}
		const rm = list.push(item);
		this._onDidChangeMenu.fire(MenuRegistryChangeEvent.for(id));
		return markAsSingleton(toDisposable(() => {
			rm();
			this._onDidChangeMenu.fire(MenuRegistryChangeEvent.for(id));
		}));
	}
	appendMenuItems(items) {
		const result = new DisposableStore();
		for (const { id, item } of items) result.add(this.appendMenuItem(id, item));
		return result;
	}
	getMenuItems(id) {
		let result;
		if (this._menuItems.has(id)) result = [...this._menuItems.get(id)];
		else result = [];
		if (id === MenuId.CommandPalette) this._appendImplicitItems(result);
		return result;
	}
	_appendImplicitItems(result) {
		const set = /* @__PURE__ */ new Set();
		for (const item of result) if (isIMenuItem(item)) {
			set.add(item.command.id);
			if (item.alt) set.add(item.alt.id);
		}
		this._commands.forEach((command, id) => {
			if (!set.has(id)) result.push({ command });
		});
	}
}();
var SubmenuItemAction = class extends SubmenuAction {
	constructor(item, hideActions, actions) {
		super(`submenuitem.${item.submenu.id}`, typeof item.title === "string" ? item.title : item.title.value, actions, "submenu");
		this.item = item;
		this.hideActions = hideActions;
	}
};
var MenuItemAction = MenuItemAction_1 = class MenuItemAction {
	static label(action, options) {
		return options?.renderShortTitle && action.shortTitle ? typeof action.shortTitle === "string" ? action.shortTitle : action.shortTitle.value : typeof action.title === "string" ? action.title : action.title.value;
	}
	constructor(item, alt, options, hideActions, menuKeybinding, contextKeyService, _commandService) {
		this.hideActions = hideActions;
		this.menuKeybinding = menuKeybinding;
		this._commandService = _commandService;
		this.id = item.id;
		this.label = MenuItemAction_1.label(item, options);
		this.tooltip = (typeof item.tooltip === "string" ? item.tooltip : item.tooltip?.value) ?? "";
		this.enabled = !item.precondition || contextKeyService.contextMatchesRules(item.precondition);
		this.checked = void 0;
		let icon;
		if (item.toggled) {
			const toggled = item.toggled.condition ? item.toggled : { condition: item.toggled };
			this.checked = contextKeyService.contextMatchesRules(toggled.condition);
			if (this.checked && toggled.tooltip) this.tooltip = typeof toggled.tooltip === "string" ? toggled.tooltip : toggled.tooltip.value;
			if (this.checked && ThemeIcon.isThemeIcon(toggled.icon)) icon = toggled.icon;
			if (this.checked && toggled.title) this.label = typeof toggled.title === "string" ? toggled.title : toggled.title.value;
		}
		if (!icon) icon = ThemeIcon.isThemeIcon(item.icon) ? item.icon : void 0;
		this.item = item;
		this.alt = alt ? new MenuItemAction_1(alt, void 0, options, hideActions, void 0, contextKeyService, _commandService) : void 0;
		this._options = options;
		this.class = icon && ThemeIcon.asClassName(icon);
	}
	run(...args) {
		let runArgs = [];
		if (this._options?.args) runArgs = [...runArgs, ...this._options.args];
		else if (this._options?.arg) runArgs = [...runArgs, this._options.arg];
		if (this._options?.shouldForwardArgs) runArgs = [...runArgs, ...args];
		return this._commandService.executeCommand(this.id, ...runArgs);
	}
};
MenuItemAction = MenuItemAction_1 = __decorate$81([__param$74(5, IContextKeyService), __param$74(6, ICommandService)], MenuItemAction);
var Action2 = class {
	constructor(desc) {
		this.desc = desc;
	}
};
function registerAction2(ctor) {
	const disposables = [];
	const action = new ctor();
	const { f1, menu, keybinding, ...command } = action.desc;
	if (CommandsRegistry.getCommand(command.id)) throw new Error(`Cannot register two commands with the same id: ${command.id}`);
	disposables.push(CommandsRegistry.registerCommand({
		id: command.id,
		handler: (accessor, ...args) => action.run(accessor, ...args),
		metadata: command.metadata ?? { description: action.desc.title }
	}));
	if (Array.isArray(menu)) for (const item of menu) disposables.push(MenuRegistry.appendMenuItem(item.id, {
		command: {
			...command,
			precondition: item.precondition === null ? void 0 : command.precondition
		},
		...item
	}));
	else if (menu) disposables.push(MenuRegistry.appendMenuItem(menu.id, {
		command: {
			...command,
			precondition: menu.precondition === null ? void 0 : command.precondition
		},
		...menu
	}));
	if (f1) {
		disposables.push(MenuRegistry.appendMenuItem(MenuId.CommandPalette, {
			command,
			when: command.precondition
		}));
		disposables.push(MenuRegistry.addCommand(command));
	}
	if (Array.isArray(keybinding)) for (const item of keybinding) disposables.push(KeybindingsRegistry.registerKeybindingRule({
		...item,
		id: command.id,
		when: command.precondition ? ContextKeyExpr.and(command.precondition, item.when) : item.when
	}));
	else if (keybinding) disposables.push(KeybindingsRegistry.registerKeybindingRule({
		...keybinding,
		id: command.id,
		when: command.precondition ? ContextKeyExpr.and(command.precondition, keybinding.when) : keybinding.when
	}));
	return { dispose() {
		dispose(disposables);
	} };
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/telemetry/common/telemetry.js
var ITelemetryService = createDecorator("telemetryService");
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/extpath.js
function isPathSeparator(code) {
	return code === 47 || code === 92;
}
/**
* Takes a Windows OS path and changes backward slashes to forward slashes.
* This should only be done for OS paths from Windows (or user provided paths potentially from Windows).
* Using it on a Linux or MaxOS path might change it.
*/
function toSlashes(osPath) {
	return osPath.replace(/[\\/]/g, posix.sep);
}
/**
* Takes a Windows OS path (using backward or forward slashes) and turns it into a posix path:
* - turns backward slashes into forward slashes
* - makes it absolute if it starts with a drive letter
* This should only be done for OS paths from Windows (or user provided paths potentially from Windows).
* Using it on a Linux or MaxOS path might change it.
*/
function toPosixPath(osPath) {
	if (osPath.indexOf("/") === -1) osPath = toSlashes(osPath);
	if (/^[a-zA-Z]:(\/|$)/.test(osPath)) osPath = "/" + osPath;
	return osPath;
}
/**
* Computes the _root_ this path, like `getRoot('c:\files') === c:\`,
* `getRoot('files:///files/path') === files:///`,
* or `getRoot('\\server\shares\path') === \\server\shares\`
*/
function getRoot(path, sep = posix.sep) {
	if (!path) return "";
	const len = path.length;
	const firstLetter = path.charCodeAt(0);
	if (isPathSeparator(firstLetter)) {
		if (isPathSeparator(path.charCodeAt(1))) {
			if (!isPathSeparator(path.charCodeAt(2))) {
				let pos = 3;
				const start = pos;
				for (; pos < len; pos++) if (isPathSeparator(path.charCodeAt(pos))) break;
				if (start !== pos && !isPathSeparator(path.charCodeAt(pos + 1))) {
					pos += 1;
					for (; pos < len; pos++) if (isPathSeparator(path.charCodeAt(pos))) return path.slice(0, pos + 1).replace(/[\\/]/g, sep);
				}
			}
		}
		return sep;
	} else if (isWindowsDriveLetter(firstLetter)) {
		if (path.charCodeAt(1) === 58) {
			if (isPathSeparator(path.charCodeAt(2))) return path.slice(0, 2) + sep;
			else return path.slice(0, 2);
		}
	}
	let pos = path.indexOf("://");
	if (pos !== -1) {
		pos += 3;
		for (; pos < len; pos++) if (isPathSeparator(path.charCodeAt(pos))) return path.slice(0, pos + 1);
	}
	return "";
}
/**
* Check if the path follows this pattern: `\\hostname\sharename`.
*
* @see https://msdn.microsoft.com/en-us/library/gg465305.aspx
* @return A boolean indication if the path is a UNC path, on none-windows
* always false.
*/
function isUNC(path) {
	if (!isWindows) return false;
	if (!path || path.length < 5) return false;
	let code = path.charCodeAt(0);
	if (code !== 92) return false;
	code = path.charCodeAt(1);
	if (code !== 92) return false;
	let pos = 2;
	const start = pos;
	for (; pos < path.length; pos++) {
		code = path.charCodeAt(pos);
		if (code === 92) break;
	}
	if (start === pos) return false;
	code = path.charCodeAt(pos + 1);
	if (isNaN(code) || code === 92) return false;
	return true;
}
/**
* @deprecated please use `IUriIdentityService.extUri.isEqualOrParent` instead. If
* you are in a context without services, consider to pass down the `extUri` from the
* outside, or use `extUriBiasedIgnorePathCase` if you know what you are doing.
*/
function isEqualOrParent(base, parentCandidate, ignoreCase, forcePosixSemantics = false) {
	const separator = forcePosixSemantics ? posix.sep : sep;
	if (base === parentCandidate) return true;
	if (!base || !parentCandidate) return false;
	if (base.indexOf("..") >= 0 || parentCandidate.indexOf("..") >= 0) {
		base = forcePosixSemantics ? posix.normalize(base) : normalize$1(base);
		parentCandidate = forcePosixSemantics ? posix.normalize(parentCandidate) : normalize$1(parentCandidate);
	}
	if (parentCandidate.length > base.length) return false;
	if (ignoreCase) {
		if (!startsWithIgnoreCase(base, parentCandidate)) return false;
		if (parentCandidate.length === base.length) return true;
		let sepOffset = parentCandidate.length;
		if (parentCandidate.charAt(parentCandidate.length - 1) === separator) sepOffset--;
		return base.charAt(sepOffset) === separator;
	}
	if (parentCandidate.charAt(parentCandidate.length - 1) !== separator) parentCandidate += separator;
	return base.indexOf(parentCandidate) === 0;
}
function isWindowsDriveLetter(char0) {
	return char0 >= 65 && char0 <= 90 || char0 >= 97 && char0 <= 122;
}
function hasDriveLetter(path, isWindowsOS = isWindows) {
	if (isWindowsOS) return isWindowsDriveLetter(path.charCodeAt(0)) && path.charCodeAt(1) === 58;
	return false;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/resources.js
function originalFSPath(uri) {
	return uriToFsPath(uri, true);
}
var ExtUri = class {
	constructor(_ignorePathCasing) {
		this._ignorePathCasing = _ignorePathCasing;
	}
	compare(uri1, uri2, ignoreFragment = false) {
		if (uri1 === uri2) return 0;
		return compare(this.getComparisonKey(uri1, ignoreFragment), this.getComparisonKey(uri2, ignoreFragment));
	}
	isEqual(uri1, uri2, ignoreFragment = false) {
		if (uri1 === uri2) return true;
		if (!uri1 || !uri2) return false;
		return this.getComparisonKey(uri1, ignoreFragment) === this.getComparisonKey(uri2, ignoreFragment);
	}
	getComparisonKey(uri, ignoreFragment = false) {
		return uri.with({
			path: this._ignorePathCasing(uri) ? uri.path.toLowerCase() : void 0,
			fragment: ignoreFragment ? null : void 0
		}).toString();
	}
	isEqualOrParent(base, parentCandidate, ignoreFragment = false) {
		if (base.scheme === parentCandidate.scheme) {
			if (base.scheme === Schemas.file) return isEqualOrParent(originalFSPath(base), originalFSPath(parentCandidate), this._ignorePathCasing(base)) && base.query === parentCandidate.query && (ignoreFragment || base.fragment === parentCandidate.fragment);
			if (isEqualAuthority(base.authority, parentCandidate.authority)) return isEqualOrParent(base.path, parentCandidate.path, this._ignorePathCasing(base), true) && base.query === parentCandidate.query && (ignoreFragment || base.fragment === parentCandidate.fragment);
		}
		return false;
	}
	joinPath(resource, ...pathFragment) {
		return URI.joinPath(resource, ...pathFragment);
	}
	basenameOrAuthority(resource) {
		return basename(resource) || resource.authority;
	}
	basename(resource, suffix) {
		return posix.basename(resource.path, suffix);
	}
	extname(resource) {
		return posix.extname(resource.path);
	}
	dirname(resource) {
		if (resource.path.length === 0) return resource;
		let dirname;
		if (resource.scheme === Schemas.file) dirname = URI.file(dirname$1(originalFSPath(resource))).path;
		else {
			dirname = posix.dirname(resource.path);
			if (resource.authority && dirname.length && dirname.charCodeAt(0) !== 47) {
				console.error(`dirname("${resource.toString})) resulted in a relative path`);
				dirname = "/";
			}
		}
		return resource.with({ path: dirname });
	}
	normalizePath(resource) {
		if (!resource.path.length) return resource;
		let normalizedPath;
		if (resource.scheme === Schemas.file) normalizedPath = URI.file(normalize$1(originalFSPath(resource))).path;
		else normalizedPath = posix.normalize(resource.path);
		return resource.with({ path: normalizedPath });
	}
	relativePath(from, to) {
		if (from.scheme !== to.scheme || !isEqualAuthority(from.authority, to.authority)) return;
		if (from.scheme === Schemas.file) {
			const relativePath = relative(originalFSPath(from), originalFSPath(to));
			return isWindows ? toSlashes(relativePath) : relativePath;
		}
		let fromPath = from.path || "/";
		const toPath = to.path || "/";
		if (this._ignorePathCasing(from)) {
			let i = 0;
			for (const len = Math.min(fromPath.length, toPath.length); i < len; i++) if (fromPath.charCodeAt(i) !== toPath.charCodeAt(i)) {
				if (fromPath.charAt(i).toLowerCase() !== toPath.charAt(i).toLowerCase()) break;
			}
			fromPath = toPath.substr(0, i) + fromPath.substr(i);
		}
		return posix.relative(fromPath, toPath);
	}
	resolvePath(base, path) {
		if (base.scheme === Schemas.file) {
			const newURI = URI.file(resolve$1(originalFSPath(base), path));
			return base.with({
				authority: newURI.authority,
				path: newURI.path
			});
		}
		path = toPosixPath(path);
		return base.with({ path: posix.resolve(base.path, path) });
	}
	isAbsolutePath(resource) {
		return !!resource.path && resource.path[0] === "/";
	}
	isEqualAuthority(a1, a2) {
		return a1 === a2 || a1 !== void 0 && a2 !== void 0 && equalsIgnoreCase(a1, a2);
	}
	hasTrailingPathSeparator(resource, sep$1 = sep) {
		if (resource.scheme === Schemas.file) {
			const fsp = originalFSPath(resource);
			return fsp.length > getRoot(fsp).length && fsp[fsp.length - 1] === sep$1;
		} else {
			const p = resource.path;
			return p.length > 1 && p.charCodeAt(p.length - 1) === 47 && !/^[a-zA-Z]:(\/$|\\$)/.test(resource.fsPath);
		}
	}
	removeTrailingPathSeparator(resource, sep$1 = sep) {
		if (hasTrailingPathSeparator(resource, sep$1)) return resource.with({ path: resource.path.substr(0, resource.path.length - 1) });
		return resource;
	}
	addTrailingPathSeparator(resource, sep$1 = sep) {
		let isRootSep = false;
		if (resource.scheme === Schemas.file) {
			const fsp = originalFSPath(resource);
			isRootSep = fsp !== void 0 && fsp.length === getRoot(fsp).length && fsp[fsp.length - 1] === sep$1;
		} else {
			sep$1 = "/";
			const p = resource.path;
			isRootSep = p.length === 1 && p.charCodeAt(p.length - 1) === 47;
		}
		if (!isRootSep && !hasTrailingPathSeparator(resource, sep$1)) return resource.with({ path: resource.path + "/" });
		return resource;
	}
};
/**
* Unbiased utility that takes uris "as they are". This means it can be interchanged with
* uri#toString() usages. The following is true
* ```
* assertEqual(aUri.toString() === bUri.toString(), exturi.isEqual(aUri, bUri))
* ```
*/
var extUri = new ExtUri(() => false);
var isEqual = extUri.isEqual.bind(extUri);
extUri.isEqualOrParent.bind(extUri);
extUri.getComparisonKey.bind(extUri);
var basenameOrAuthority = extUri.basenameOrAuthority.bind(extUri);
var basename = extUri.basename.bind(extUri);
var extname = extUri.extname.bind(extUri);
var dirname = extUri.dirname.bind(extUri);
var joinPath = extUri.joinPath.bind(extUri);
var normalizePath = extUri.normalizePath.bind(extUri);
var relativePath = extUri.relativePath.bind(extUri);
var resolvePath = extUri.resolvePath.bind(extUri);
extUri.isAbsolutePath.bind(extUri);
var isEqualAuthority = extUri.isEqualAuthority.bind(extUri);
var hasTrailingPathSeparator = extUri.hasTrailingPathSeparator.bind(extUri);
extUri.removeTrailingPathSeparator.bind(extUri);
extUri.addTrailingPathSeparator.bind(extUri);
/**
* Data URI related helpers.
*/
var DataUri;
(function(DataUri) {
	DataUri.META_DATA_LABEL = "label";
	DataUri.META_DATA_DESCRIPTION = "description";
	DataUri.META_DATA_SIZE = "size";
	DataUri.META_DATA_MIME = "mime";
	function parseMetaData(dataUri) {
		const metadata = /* @__PURE__ */ new Map();
		dataUri.path.substring(dataUri.path.indexOf(";") + 1, dataUri.path.lastIndexOf(";")).split(";").forEach((property) => {
			const [key, value] = property.split(":");
			if (key && value) metadata.set(key, value);
		});
		const mime = dataUri.path.substring(0, dataUri.path.indexOf(";"));
		if (mime) metadata.set(DataUri.META_DATA_MIME, mime);
		return metadata;
	}
	DataUri.parseMetaData = parseMetaData;
})(DataUri || (DataUri = {}));
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/log/common/log.js
var ILogService = createDecorator("logService");
var ILoggerService = createDecorator("loggerService");
var LogLevel;
(function(LogLevel) {
	LogLevel[LogLevel["Off"] = 0] = "Off";
	LogLevel[LogLevel["Trace"] = 1] = "Trace";
	LogLevel[LogLevel["Debug"] = 2] = "Debug";
	LogLevel[LogLevel["Info"] = 3] = "Info";
	LogLevel[LogLevel["Warning"] = 4] = "Warning";
	LogLevel[LogLevel["Error"] = 5] = "Error";
})(LogLevel || (LogLevel = {}));
var DEFAULT_LOG_LEVEL = LogLevel.Info;
function canLog(loggerLevel, messageLevel) {
	return loggerLevel !== LogLevel.Off && loggerLevel <= messageLevel;
}
function getConsoleMethod(method) {
	switch (method) {
		case "debug": return console.debug;
		case "error": return console.error;
		case "info": return console.info;
		case "log": return console.log;
		case "warn": return console.warn;
	}
}
function logToConsole(method, ...args) {
	try {
		getConsoleMethod(method).apply(console, args);
	} finally {}
}
var AbstractLogger = class extends Disposable {
	constructor() {
		super(...arguments);
		this.level = DEFAULT_LOG_LEVEL;
		this._onDidChangeLogLevel = this._register(new Emitter$1());
	}
	get onDidChangeLogLevel() {
		return this._onDidChangeLogLevel.event;
	}
	setLevel(level) {
		if (this.level !== level) {
			this.level = level;
			this._onDidChangeLogLevel.fire(this.level);
		}
	}
	getLevel() {
		return this.level;
	}
	checkLogLevel(level) {
		return canLog(this.level, level);
	}
	canLog(level) {
		if (this._store.isDisposed) return false;
		return this.checkLogLevel(level);
	}
};
var ConsoleLogger = class extends AbstractLogger {
	constructor(logLevel = DEFAULT_LOG_LEVEL, useColors = true) {
		super();
		this.useColors = useColors;
		this.setLevel(logLevel);
	}
	trace(message, ...args) {
		if (this.canLog(LogLevel.Trace)) {
			if (this.useColors) logToConsole("log", "%cTRACE", "color: #888", message, ...args);
			else logToConsole("log", message, ...args);
		}
	}
	debug(message, ...args) {
		if (this.canLog(LogLevel.Debug)) {
			if (this.useColors) logToConsole("log", "%cDEBUG", "background: #eee; color: #888", message, ...args);
			else logToConsole("log", message, ...args);
		}
	}
	info(message, ...args) {
		if (this.canLog(LogLevel.Info)) {
			if (this.useColors) logToConsole("log", "%c INFO", "color: #33f", message, ...args);
			else logToConsole("log", message, ...args);
		}
	}
	warn(message, ...args) {
		if (this.canLog(LogLevel.Warning)) {
			if (this.useColors) logToConsole("warn", "%c WARN", "color: #993", message, ...args);
			else logToConsole("log", message, ...args);
		}
	}
	error(message, ...args) {
		if (this.canLog(LogLevel.Error)) {
			if (this.useColors) logToConsole("error", "%c  ERR", "color: #f33", message, ...args);
			else logToConsole("error", message, ...args);
		}
	}
};
var MultiplexLogger = class extends AbstractLogger {
	constructor(loggers) {
		super();
		this.loggers = loggers;
		if (loggers.length) this.setLevel(loggers[0].getLevel());
	}
	setLevel(level) {
		for (const logger of this.loggers) logger.setLevel(level);
		super.setLevel(level);
	}
	trace(message, ...args) {
		for (const logger of this.loggers) logger.trace(message, ...args);
	}
	debug(message, ...args) {
		for (const logger of this.loggers) logger.debug(message, ...args);
	}
	info(message, ...args) {
		for (const logger of this.loggers) logger.info(message, ...args);
	}
	warn(message, ...args) {
		for (const logger of this.loggers) logger.warn(message, ...args);
	}
	error(message, ...args) {
		for (const logger of this.loggers) logger.error(message, ...args);
	}
	dispose() {
		for (const logger of this.loggers) logger.dispose();
		super.dispose();
	}
};
var AbstractLoggerService = class extends Disposable {
	constructor(logLevel, logsHome, loggerResources) {
		super();
		this.logLevel = logLevel;
		this.logsHome = logsHome;
		this._loggers = new ResourceMap();
		this._onDidChangeLoggers = this._register(new Emitter$1());
		this._onDidChangeVisibility = this._register(new Emitter$1());
		if (loggerResources) for (const loggerResource of loggerResources) this._loggers.set(loggerResource.resource, {
			logger: void 0,
			info: loggerResource
		});
	}
	getLoggerEntry(resourceOrId) {
		if (isString$1(resourceOrId)) return [...this._loggers.values()].find((logger) => logger.info.id === resourceOrId);
		return this._loggers.get(resourceOrId);
	}
	createLogger(idOrResource, options) {
		const resource = this.toResource(idOrResource);
		const id = isString$1(idOrResource) ? idOrResource : options?.id ?? hash(resource.toString()).toString(16);
		let logger = this._loggers.get(resource)?.logger;
		const logLevel = options?.logLevel === "always" ? LogLevel.Trace : options?.logLevel;
		if (!logger) logger = this.doCreateLogger(resource, logLevel ?? this.getLogLevel(resource) ?? this.logLevel, {
			...options,
			id
		});
		const loggerEntry = {
			logger,
			info: {
				resource,
				id,
				logLevel,
				name: options?.name,
				hidden: options?.hidden,
				group: options?.group,
				extensionId: options?.extensionId,
				when: options?.when
			}
		};
		this.registerLogger(loggerEntry.info);
		this._loggers.set(resource, loggerEntry);
		return logger;
	}
	toResource(idOrResource) {
		return isString$1(idOrResource) ? joinPath(this.logsHome, `${idOrResource.replace(/[\\/:\*\?"<>\|]/g, "")}.log`) : idOrResource;
	}
	setVisibility(resourceOrId, visibility) {
		const logger = this.getLoggerEntry(resourceOrId);
		if (logger && visibility !== !logger.info.hidden) {
			logger.info.hidden = !visibility;
			this._loggers.set(logger.info.resource, logger);
			this._onDidChangeVisibility.fire([logger.info.resource, visibility]);
		}
	}
	getLogLevel(resource) {
		let logLevel;
		if (resource) logLevel = this._loggers.get(resource)?.info.logLevel;
		return logLevel ?? this.logLevel;
	}
	registerLogger(resource) {
		const existing = this._loggers.get(resource.resource);
		if (existing) {
			if (existing.info.hidden !== resource.hidden) this.setVisibility(resource.resource, !resource.hidden);
		} else {
			this._loggers.set(resource.resource, {
				info: resource,
				logger: void 0
			});
			this._onDidChangeLoggers.fire({
				added: [resource],
				removed: []
			});
		}
	}
	dispose() {
		this._loggers.forEach((logger) => logger.logger?.dispose());
		this._loggers.clear();
		super.dispose();
	}
};
var NullLogger = class {
	constructor() {
		this.onDidChangeLogLevel = new Emitter$1().event;
	}
	setLevel(level) {}
	getLevel() {
		return LogLevel.Info;
	}
	trace(message, ...args) {}
	debug(message, ...args) {}
	info(message, ...args) {}
	warn(message, ...args) {}
	error(message, ...args) {}
	dispose() {}
};
var NullLoggerService = class extends AbstractLoggerService {
	constructor() {
		super(LogLevel.Off, URI.parse("log:///log"));
	}
	doCreateLogger(resource, logLevel, options) {
		return new NullLogger();
	}
};
function LogLevelToString(logLevel) {
	switch (logLevel) {
		case LogLevel.Trace: return "trace";
		case LogLevel.Debug: return "debug";
		case LogLevel.Info: return "info";
		case LogLevel.Warning: return "warn";
		case LogLevel.Error: return "error";
		case LogLevel.Off: return "off";
	}
}
new RawContextKey("logLevel", LogLevelToString(LogLevel.Info));
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/triggerInlineEditCommandsRegistry.js
/**
* Registry for commands that can trigger Inline Edits (NES) when invoked.
*/
var TriggerInlineEditCommandsRegistry = class TriggerInlineEditCommandsRegistry {
	static {
		this.REGISTERED_COMMANDS = /* @__PURE__ */ new Set();
	}
	static getRegisteredCommands() {
		return [...TriggerInlineEditCommandsRegistry.REGISTERED_COMMANDS];
	}
	static registerCommand(commandId) {
		TriggerInlineEditCommandsRegistry.REGISTERED_COMMANDS.add(commandId);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/editorExtensions.js
var Command = class {
	constructor(opts) {
		this.id = opts.id;
		this.precondition = opts.precondition;
		this._kbOpts = opts.kbOpts;
		this._menuOpts = opts.menuOpts;
		this.metadata = opts.metadata;
		this.canTriggerInlineEdits = opts.canTriggerInlineEdits;
	}
	register() {
		if (Array.isArray(this._menuOpts)) this._menuOpts.forEach(this._registerMenuItem, this);
		else if (this._menuOpts) this._registerMenuItem(this._menuOpts);
		if (this._kbOpts) {
			const kbOptsArr = Array.isArray(this._kbOpts) ? this._kbOpts : [this._kbOpts];
			for (const kbOpts of kbOptsArr) {
				let kbWhen = kbOpts.kbExpr;
				if (this.precondition) {
					if (kbWhen) kbWhen = ContextKeyExpr.and(kbWhen, this.precondition);
					else kbWhen = this.precondition;
				}
				const desc = {
					id: this.id,
					weight: kbOpts.weight,
					args: kbOpts.args,
					when: kbWhen,
					primary: kbOpts.primary,
					secondary: kbOpts.secondary,
					win: kbOpts.win,
					linux: kbOpts.linux,
					mac: kbOpts.mac
				};
				KeybindingsRegistry.registerKeybindingRule(desc);
			}
		}
		CommandsRegistry.registerCommand({
			id: this.id,
			handler: (accessor, args) => this.runCommand(accessor, args),
			metadata: this.metadata
		});
		if (this.canTriggerInlineEdits) TriggerInlineEditCommandsRegistry.registerCommand(this.id);
	}
	_registerMenuItem(item) {
		MenuRegistry.appendMenuItem(item.menuId, {
			group: item.group,
			command: {
				id: this.id,
				title: item.title,
				icon: item.icon,
				precondition: this.precondition
			},
			when: item.when,
			order: item.order
		});
	}
};
var MultiCommand = class extends Command {
	constructor() {
		super(...arguments);
		this._implementations = [];
	}
	/**
	* A higher priority gets to be looked at first
	*/
	addImplementation(priority, name, implementation, when) {
		this._implementations.push({
			priority,
			name,
			implementation,
			when
		});
		this._implementations.sort((a, b) => b.priority - a.priority);
		return { dispose: () => {
			for (let i = 0; i < this._implementations.length; i++) if (this._implementations[i].implementation === implementation) {
				this._implementations.splice(i, 1);
				return;
			}
		} };
	}
	runCommand(accessor, args) {
		const logService = accessor.get(ILogService);
		const contextKeyService = accessor.get(IContextKeyService);
		logService.trace(`Executing Command '${this.id}' which has ${this._implementations.length} bound.`);
		for (const impl of this._implementations) {
			if (impl.when) {
				const context = contextKeyService.getContext(getActiveElement());
				if (!impl.when.evaluate(context)) continue;
			}
			const result = impl.implementation(accessor, args);
			if (result) {
				logService.trace(`Command '${this.id}' was handled by '${impl.name}'.`);
				if (typeof result === "boolean") return;
				return result;
			}
		}
		logService.trace(`The Command '${this.id}' was not handled by any implementation.`);
	}
};
/**
* A command that delegates to another command's implementation.
*
* This lets different commands be registered but share the same implementation
*/
var ProxyCommand = class extends Command {
	constructor(command, opts) {
		super(opts);
		this.command = command;
	}
	runCommand(accessor, args) {
		return this.command.runCommand(accessor, args);
	}
};
var EditorCommand = class EditorCommand extends Command {
	/**
	* Create a command class that is bound to a certain editor contribution.
	*/
	static bindToContribution(controllerGetter) {
		return class EditorControllerCommandImpl extends EditorCommand {
			constructor(opts) {
				super(opts);
				this._callback = opts.handler;
			}
			runEditorCommand(accessor, editor, args) {
				const controller = controllerGetter(editor);
				if (controller) this._callback(controller, args);
			}
		};
	}
	static runEditorCommand(accessor, args, precondition, runner) {
		const codeEditorService = accessor.get(ICodeEditorService);
		const editor = codeEditorService.getFocusedCodeEditor() || codeEditorService.getActiveCodeEditor();
		if (!editor) return;
		return editor.invokeWithinContext((editorAccessor) => {
			if (!editorAccessor.get(IContextKeyService).contextMatchesRules(precondition ?? void 0)) return;
			return runner(editorAccessor, editor, args);
		});
	}
	runCommand(accessor, args) {
		return EditorCommand.runEditorCommand(accessor, args, this.precondition, (accessor, editor, args) => this.runEditorCommand(accessor, editor, args));
	}
};
var EditorAction = class EditorAction extends EditorCommand {
	static convertOptions(opts) {
		let menuOpts;
		if (Array.isArray(opts.menuOpts)) menuOpts = opts.menuOpts;
		else if (opts.menuOpts) menuOpts = [opts.menuOpts];
		else menuOpts = [];
		function withDefaults(item) {
			if (!item.menuId) item.menuId = MenuId.EditorContext;
			if (!item.title) item.title = typeof opts.label === "string" ? opts.label : opts.label.value;
			item.when = ContextKeyExpr.and(opts.precondition, item.when);
			return item;
		}
		if (Array.isArray(opts.contextMenuOpts)) menuOpts.push(...opts.contextMenuOpts.map(withDefaults));
		else if (opts.contextMenuOpts) menuOpts.push(withDefaults(opts.contextMenuOpts));
		opts.menuOpts = menuOpts;
		return opts;
	}
	constructor(opts) {
		super(EditorAction.convertOptions(opts));
		if (typeof opts.label === "string") {
			this.label = opts.label;
			this.alias = opts.alias ?? opts.label;
		} else {
			this.label = opts.label.value;
			this.alias = opts.alias ?? opts.label.original;
		}
	}
	runEditorCommand(accessor, editor, args) {
		this.reportTelemetry(accessor, editor);
		return this.run(accessor, editor, args || {});
	}
	reportTelemetry(accessor, editor) {
		accessor.get(ITelemetryService).publicLog2("editorActionInvoked", {
			name: this.label,
			id: this.id
		});
	}
};
var MultiEditorAction = class extends EditorAction {
	constructor() {
		super(...arguments);
		this._implementations = [];
	}
	/**
	* A higher priority gets to be looked at first
	*/
	addImplementation(priority, implementation) {
		this._implementations.push([priority, implementation]);
		this._implementations.sort((a, b) => b[0] - a[0]);
		return { dispose: () => {
			for (let i = 0; i < this._implementations.length; i++) if (this._implementations[i][1] === implementation) {
				this._implementations.splice(i, 1);
				return;
			}
		} };
	}
	run(accessor, editor, args) {
		for (const impl of this._implementations) {
			const result = impl[1](accessor, editor, args);
			if (result) {
				if (typeof result === "boolean") return;
				return result;
			}
		}
	}
};
var EditorAction2 = class extends Action2 {
	run(accessor, ...args) {
		const codeEditorService = accessor.get(ICodeEditorService);
		const editor = codeEditorService.getFocusedCodeEditor() || codeEditorService.getActiveCodeEditor();
		if (!editor) return;
		return editor.invokeWithinContext((editorAccessor) => {
			const kbService = editorAccessor.get(IContextKeyService);
			const logService = editorAccessor.get(ILogService);
			if (!kbService.contextMatchesRules(this.desc.precondition ?? void 0)) {
				logService.debug(`[EditorAction2] NOT running command because its precondition is FALSE`, this.desc.id, this.desc.precondition?.serialize());
				return;
			}
			return this.runEditorCommand(editorAccessor, editor, ...args);
		});
	}
};
function registerModelAndPositionCommand(id, handler) {
	CommandsRegistry.registerCommand(id, function(accessor, ...args) {
		const instaService = accessor.get(IInstantiationService);
		const [resource, position] = args;
		assertType(URI.isUri(resource));
		assertType(Position$1.isIPosition(position));
		const model = accessor.get(IModelService).getModel(resource);
		if (model) {
			const editorPosition = Position$1.lift(position);
			return instaService.invokeFunction(handler, model, editorPosition, ...args.slice(2));
		}
		return accessor.get(ITextModelService).createModelReference(resource).then((reference) => {
			return new Promise((resolve, reject) => {
				try {
					resolve(instaService.invokeFunction(handler, reference.object.textEditorModel, Position$1.lift(position), args.slice(2)));
				} catch (err) {
					reject(err);
				}
			}).finally(() => {
				reference.dispose();
			});
		});
	});
}
function registerEditorCommand(editorCommand) {
	EditorContributionRegistry.INSTANCE.registerEditorCommand(editorCommand);
	return editorCommand;
}
function registerEditorAction(ctor) {
	const action = new ctor();
	EditorContributionRegistry.INSTANCE.registerEditorAction(action);
	return action;
}
function registerMultiEditorAction(action) {
	EditorContributionRegistry.INSTANCE.registerEditorAction(action);
	return action;
}
function registerInstantiatedEditorAction(editorAction) {
	EditorContributionRegistry.INSTANCE.registerEditorAction(editorAction);
}
/**
* Registers an editor contribution. Editor contributions have a lifecycle which is bound
* to a specific code editor instance.
*/
function registerEditorContribution(id, ctor, instantiation) {
	EditorContributionRegistry.INSTANCE.registerEditorContribution(id, ctor, instantiation);
}
var EditorExtensionsRegistry;
(function(EditorExtensionsRegistry) {
	function getEditorCommand(commandId) {
		return EditorContributionRegistry.INSTANCE.getEditorCommand(commandId);
	}
	EditorExtensionsRegistry.getEditorCommand = getEditorCommand;
	function getEditorActions() {
		return EditorContributionRegistry.INSTANCE.getEditorActions();
	}
	EditorExtensionsRegistry.getEditorActions = getEditorActions;
	function getEditorContributions() {
		return EditorContributionRegistry.INSTANCE.getEditorContributions();
	}
	EditorExtensionsRegistry.getEditorContributions = getEditorContributions;
	function getSomeEditorContributions(ids) {
		return EditorContributionRegistry.INSTANCE.getEditorContributions().filter((c) => ids.indexOf(c.id) >= 0);
	}
	EditorExtensionsRegistry.getSomeEditorContributions = getSomeEditorContributions;
	function getDiffEditorContributions() {
		return EditorContributionRegistry.INSTANCE.getDiffEditorContributions();
	}
	EditorExtensionsRegistry.getDiffEditorContributions = getDiffEditorContributions;
})(EditorExtensionsRegistry || (EditorExtensionsRegistry = {}));
var Extensions$8 = { EditorCommonContributions: "editor.contributions" };
var EditorContributionRegistry = class EditorContributionRegistry {
	static {
		this.INSTANCE = new EditorContributionRegistry();
	}
	constructor() {
		this.editorContributions = [];
		this.diffEditorContributions = [];
		this.editorActions = [];
		this.editorCommands = Object.create(null);
	}
	registerEditorContribution(id, ctor, instantiation) {
		this.editorContributions.push({
			id,
			ctor,
			instantiation
		});
	}
	getEditorContributions() {
		return this.editorContributions.slice(0);
	}
	getDiffEditorContributions() {
		return this.diffEditorContributions.slice(0);
	}
	registerEditorAction(action) {
		action.register();
		this.editorActions.push(action);
	}
	getEditorActions() {
		return this.editorActions;
	}
	registerEditorCommand(editorCommand) {
		editorCommand.register();
		this.editorCommands[editorCommand.id] = editorCommand;
	}
	getEditorCommand(commandId) {
		return this.editorCommands[commandId] || null;
	}
};
Registry.add(Extensions$8.EditorCommonContributions, EditorContributionRegistry.INSTANCE);
function registerCommand$2(command) {
	command.register();
	return command;
}
var UndoCommand = registerCommand$2(new MultiCommand({
	id: "undo",
	precondition: void 0,
	kbOpts: {
		weight: 0,
		primary: 2104
	},
	menuOpts: [
		{
			menuId: MenuId.MenubarEditMenu,
			group: "1_do",
			title: localize(73, "&&Undo"),
			order: 1
		},
		{
			menuId: MenuId.CommandPalette,
			group: "",
			title: localize(74, "Undo"),
			order: 1
		},
		{
			menuId: MenuId.SimpleEditorContext,
			group: "1_do",
			title: localize(75, "Undo"),
			order: 1
		}
	]
}));
registerCommand$2(new ProxyCommand(UndoCommand, {
	id: "default:undo",
	precondition: void 0
}));
var RedoCommand = registerCommand$2(new MultiCommand({
	id: "redo",
	precondition: void 0,
	kbOpts: {
		weight: 0,
		primary: 2103,
		secondary: [3128],
		mac: { primary: 3128 }
	},
	menuOpts: [
		{
			menuId: MenuId.MenubarEditMenu,
			group: "1_do",
			title: localize(76, "&&Redo"),
			order: 2
		},
		{
			menuId: MenuId.CommandPalette,
			group: "",
			title: localize(77, "Redo"),
			order: 1
		},
		{
			menuId: MenuId.SimpleEditorContext,
			group: "1_do",
			title: localize(78, "Redo"),
			order: 2
		}
	]
}));
registerCommand$2(new ProxyCommand(RedoCommand, {
	id: "default:redo",
	precondition: void 0
}));
var SelectAllCommand = registerCommand$2(new MultiCommand({
	id: "editor.action.selectAll",
	precondition: void 0,
	kbOpts: {
		weight: 0,
		kbExpr: null,
		primary: 2079
	},
	menuOpts: [
		{
			menuId: MenuId.MenubarSelectionMenu,
			group: "1_basic",
			title: localize(79, "&&Select All"),
			order: 1
		},
		{
			menuId: MenuId.CommandPalette,
			group: "",
			title: localize(80, "Select All"),
			order: 1
		},
		{
			menuId: MenuId.SimpleEditorContext,
			group: "9_select",
			title: localize(81, "Select All"),
			order: 1
		}
	]
}));
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/webWorker/browser/webWorkerDescriptor.js
var WebWorkerDescriptor = class {
	constructor(args) {
		this.esmModuleLocation = args.esmModuleLocation;
		this.esmModuleLocationBundler = args.esmModuleLocationBundler;
		this.label = args.label;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/webWorker/browser/webWorkerService.js
var IWebWorkerService = createDecorator("IWebWorkerService");
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/languages/languageConfiguration.js
/**
* Describes what to do with the indentation when pressing Enter.
*/
var IndentAction;
(function(IndentAction) {
	/**
	* Insert new line and copy the previous line's indentation.
	*/
	IndentAction[IndentAction["None"] = 0] = "None";
	/**
	* Insert new line and indent once (relative to the previous line's indentation).
	*/
	IndentAction[IndentAction["Indent"] = 1] = "Indent";
	/**
	* Insert two new lines:
	*  - the first one indented which will hold the cursor
	*  - the second one at the same indentation level
	*/
	IndentAction[IndentAction["IndentOutdent"] = 2] = "IndentOutdent";
	/**
	* Insert new line and outdent once (relative to the previous line's indentation).
	*/
	IndentAction[IndentAction["Outdent"] = 3] = "Outdent";
})(IndentAction || (IndentAction = {}));
/**
* @internal
*/
var StandardAutoClosingPairConditional = class {
	constructor(source) {
		this._neutralCharacter = null;
		this._neutralCharacterSearched = false;
		this.open = source.open;
		this.close = source.close;
		this._inString = true;
		this._inComment = true;
		this._inRegEx = true;
		if (Array.isArray(source.notIn)) for (let i = 0, len = source.notIn.length; i < len; i++) switch (source.notIn[i]) {
			case "string":
				this._inString = false;
				break;
			case "comment":
				this._inComment = false;
				break;
			case "regex": this._inRegEx = false;
		}
	}
	isOK(standardToken) {
		switch (standardToken) {
			case 0: return true;
			case 1: return this._inComment;
			case 2: return this._inString;
			case 3: return this._inRegEx;
		}
	}
	shouldAutoClose(context, column) {
		if (context.getTokenCount() === 0) return true;
		const tokenIndex = context.findTokenIndexAtOffset(column - 2);
		const standardTokenType = context.getStandardTokenType(tokenIndex);
		return this.isOK(standardTokenType);
	}
	_findNeutralCharacterInRange(fromCharCode, toCharCode) {
		for (let charCode = fromCharCode; charCode <= toCharCode; charCode++) {
			const character = String.fromCharCode(charCode);
			if (!this.open.includes(character) && !this.close.includes(character)) return character;
		}
		return null;
	}
	/**
	* Find a character in the range [0-9a-zA-Z] that does not appear in the open or close
	*/
	findNeutralCharacter() {
		if (!this._neutralCharacterSearched) {
			this._neutralCharacterSearched = true;
			if (!this._neutralCharacter) this._neutralCharacter = this._findNeutralCharacterInRange(48, 57);
			if (!this._neutralCharacter) this._neutralCharacter = this._findNeutralCharacterInRange(97, 122);
			if (!this._neutralCharacter) this._neutralCharacter = this._findNeutralCharacterInRange(65, 90);
		}
		return this._neutralCharacter;
	}
};
/**
* @internal
*/
var AutoClosingPairs = class {
	constructor(autoClosingPairs) {
		this.autoClosingPairsOpenByStart = /* @__PURE__ */ new Map();
		this.autoClosingPairsOpenByEnd = /* @__PURE__ */ new Map();
		this.autoClosingPairsCloseByStart = /* @__PURE__ */ new Map();
		this.autoClosingPairsCloseByEnd = /* @__PURE__ */ new Map();
		this.autoClosingPairsCloseSingleChar = /* @__PURE__ */ new Map();
		for (const pair of autoClosingPairs) {
			appendEntry(this.autoClosingPairsOpenByStart, pair.open.charAt(0), pair);
			appendEntry(this.autoClosingPairsOpenByEnd, pair.open.charAt(pair.open.length - 1), pair);
			appendEntry(this.autoClosingPairsCloseByStart, pair.close.charAt(0), pair);
			appendEntry(this.autoClosingPairsCloseByEnd, pair.close.charAt(pair.close.length - 1), pair);
			if (pair.close.length === 1 && pair.open.length === 1) appendEntry(this.autoClosingPairsCloseSingleChar, pair.close, pair);
		}
	}
};
function appendEntry(target, key, value) {
	if (target.has(key)) target.get(key).push(value);
	else target.set(key, [value]);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/languages/supports/characterPair.js
var CharacterPairSupport = class CharacterPairSupport {
	static {
		this.DEFAULT_AUTOCLOSE_BEFORE_LANGUAGE_DEFINED_QUOTES = ";:.,=}])> \n	";
	}
	static {
		this.DEFAULT_AUTOCLOSE_BEFORE_LANGUAGE_DEFINED_BRACKETS = "'\"`;:.,=}])> \n	";
	}
	constructor(config) {
		if (config.autoClosingPairs) this._autoClosingPairs = config.autoClosingPairs.map((el) => new StandardAutoClosingPairConditional(el));
		else if (config.brackets) this._autoClosingPairs = config.brackets.map((b) => new StandardAutoClosingPairConditional({
			open: b[0],
			close: b[1]
		}));
		else this._autoClosingPairs = [];
		if (config.__electricCharacterSupport && config.__electricCharacterSupport.docComment) {
			const docComment = config.__electricCharacterSupport.docComment;
			this._autoClosingPairs.push(new StandardAutoClosingPairConditional({
				open: docComment.open,
				close: docComment.close || ""
			}));
		}
		this._autoCloseBeforeForQuotes = typeof config.autoCloseBefore === "string" ? config.autoCloseBefore : CharacterPairSupport.DEFAULT_AUTOCLOSE_BEFORE_LANGUAGE_DEFINED_QUOTES;
		this._autoCloseBeforeForBrackets = typeof config.autoCloseBefore === "string" ? config.autoCloseBefore : CharacterPairSupport.DEFAULT_AUTOCLOSE_BEFORE_LANGUAGE_DEFINED_BRACKETS;
		this._surroundingPairs = config.surroundingPairs || this._autoClosingPairs;
	}
	getAutoClosingPairs() {
		return this._autoClosingPairs;
	}
	getAutoCloseBeforeSet(forQuotes) {
		return forQuotes ? this._autoCloseBeforeForQuotes : this._autoCloseBeforeForBrackets;
	}
	getSurroundingPairs() {
		return this._surroundingPairs;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/languages/supports.js
function createScopedLineTokens(context, offset) {
	const tokenCount = context.getCount();
	const tokenIndex = context.findTokenIndexAtOffset(offset);
	const desiredLanguageId = context.getLanguageId(tokenIndex);
	let lastTokenIndex = tokenIndex;
	while (lastTokenIndex + 1 < tokenCount && context.getLanguageId(lastTokenIndex + 1) === desiredLanguageId) lastTokenIndex++;
	let firstTokenIndex = tokenIndex;
	while (firstTokenIndex > 0 && context.getLanguageId(firstTokenIndex - 1) === desiredLanguageId) firstTokenIndex--;
	return new ScopedLineTokens(context, desiredLanguageId, firstTokenIndex, lastTokenIndex + 1, context.getStartOffset(firstTokenIndex), context.getEndOffset(lastTokenIndex));
}
var ScopedLineTokens = class {
	constructor(actual, languageId, firstTokenIndex, lastTokenIndex, firstCharOffset, lastCharOffset) {
		this._scopedLineTokensBrand = void 0;
		this._actual = actual;
		this.languageId = languageId;
		this._firstTokenIndex = firstTokenIndex;
		this._lastTokenIndex = lastTokenIndex;
		this.firstCharOffset = firstCharOffset;
		this._lastCharOffset = lastCharOffset;
		this.languageIdCodec = actual.languageIdCodec;
	}
	getLineContent() {
		return this._actual.getLineContent().substring(this.firstCharOffset, this._lastCharOffset);
	}
	getLineLength() {
		return this._lastCharOffset - this.firstCharOffset;
	}
	getActualLineContentBefore(offset) {
		return this._actual.getLineContent().substring(0, this.firstCharOffset + offset);
	}
	getTokenCount() {
		return this._lastTokenIndex - this._firstTokenIndex;
	}
	findTokenIndexAtOffset(offset) {
		return this._actual.findTokenIndexAtOffset(offset + this.firstCharOffset) - this._firstTokenIndex;
	}
	getStandardTokenType(tokenIndex) {
		return this._actual.getStandardTokenType(tokenIndex + this._firstTokenIndex);
	}
	toIViewLineTokens() {
		return this._actual.sliceAndInflate(this.firstCharOffset, this._lastCharOffset, 0);
	}
};
function ignoreBracketsInToken(standardTokenType) {
	return (standardTokenType & 3) !== 0;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/core/stringBuilder.js
var _utf16LE_TextDecoder;
function getUTF16LE_TextDecoder() {
	if (!_utf16LE_TextDecoder) _utf16LE_TextDecoder = new TextDecoder("UTF-16LE");
	return _utf16LE_TextDecoder;
}
var _utf16BE_TextDecoder;
function getUTF16BE_TextDecoder() {
	if (!_utf16BE_TextDecoder) _utf16BE_TextDecoder = new TextDecoder("UTF-16BE");
	return _utf16BE_TextDecoder;
}
var _platformTextDecoder;
function getPlatformTextDecoder() {
	if (!_platformTextDecoder) _platformTextDecoder = isLittleEndian() ? getUTF16LE_TextDecoder() : getUTF16BE_TextDecoder();
	return _platformTextDecoder;
}
function decodeUTF16LE(source, offset, len) {
	const view = new Uint16Array(source.buffer, offset, len);
	if (len > 0 && (view[0] === 65279 || view[0] === 65534)) return compatDecodeUTF16LE(source, offset, len);
	return getUTF16LE_TextDecoder().decode(view);
}
function compatDecodeUTF16LE(source, offset, len) {
	const result = [];
	let resultLen = 0;
	for (let i = 0; i < len; i++) {
		const charCode = readUInt16LE(source, offset);
		offset += 2;
		result[resultLen++] = String.fromCharCode(charCode);
	}
	return result.join("");
}
var StringBuilder = class {
	constructor(capacity) {
		this._capacity = capacity | 0;
		this._buffer = new Uint16Array(this._capacity);
		this._completedStrings = null;
		this._bufferLength = 0;
	}
	reset() {
		this._completedStrings = null;
		this._bufferLength = 0;
	}
	build() {
		if (this._completedStrings !== null) {
			this._flushBuffer();
			return this._completedStrings.join("");
		}
		return this._buildBuffer();
	}
	_buildBuffer() {
		if (this._bufferLength === 0) return "";
		const view = new Uint16Array(this._buffer.buffer, 0, this._bufferLength);
		return getPlatformTextDecoder().decode(view);
	}
	_flushBuffer() {
		const bufferString = this._buildBuffer();
		this._bufferLength = 0;
		if (this._completedStrings === null) this._completedStrings = [bufferString];
		else this._completedStrings[this._completedStrings.length] = bufferString;
	}
	/**
	* Append a char code (<2^16)
	*/
	appendCharCode(charCode) {
		const remainingSpace = this._capacity - this._bufferLength;
		if (remainingSpace <= 1) {
			if (remainingSpace === 0 || isHighSurrogate(charCode)) this._flushBuffer();
		}
		this._buffer[this._bufferLength++] = charCode;
	}
	/**
	* Append an ASCII char code (<2^8)
	*/
	appendASCIICharCode(charCode) {
		if (this._bufferLength === this._capacity) this._flushBuffer();
		this._buffer[this._bufferLength++] = charCode;
	}
	appendString(str) {
		const strLen = str.length;
		if (this._bufferLength + strLen >= this._capacity) {
			this._flushBuffer();
			this._completedStrings[this._completedStrings.length] = str;
			return;
		}
		for (let i = 0; i < strLen; i++) this._buffer[this._bufferLength++] = str.charCodeAt(i);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/languages/supports/richEditBrackets.js
/**
* Represents a grouping of colliding bracket pairs.
*
* Most of the times this contains a single bracket pair,
* but sometimes this contains multiple bracket pairs in cases
* where the same string appears as a closing bracket for multiple
* bracket pairs, or the same string appears an opening bracket for
* multiple bracket pairs.
*
* e.g. of a group containing a single pair:
*   open: ['{'], close: ['}']
*
* e.g. of a group containing multiple pairs:
*   open: ['if', 'for'], close: ['end', 'end']
*/
var RichEditBracket = class RichEditBracket {
	constructor(languageId, index, open, close, forwardRegex, reversedRegex) {
		this._richEditBracketBrand = void 0;
		this.languageId = languageId;
		this.index = index;
		this.open = open;
		this.close = close;
		this.forwardRegex = forwardRegex;
		this.reversedRegex = reversedRegex;
		this._openSet = RichEditBracket._toSet(this.open);
		this._closeSet = RichEditBracket._toSet(this.close);
	}
	/**
	* Check if the provided `text` is an open bracket in this group.
	*/
	isOpen(text) {
		return this._openSet.has(text);
	}
	/**
	* Check if the provided `text` is a close bracket in this group.
	*/
	isClose(text) {
		return this._closeSet.has(text);
	}
	static _toSet(arr) {
		const result = /* @__PURE__ */ new Set();
		for (const element of arr) result.add(element);
		return result;
	}
};
/**
* Groups together brackets that have equal open or close sequences.
*
* For example, if the following brackets are defined:
*   ['IF','END']
*   ['for','end']
*   ['{','}']
*
* Then the grouped brackets would be:
*   { open: ['if', 'for'], close: ['end', 'end'] }
*   { open: ['{'], close: ['}'] }
*
*/
function groupFuzzyBrackets(brackets) {
	const N = brackets.length;
	brackets = brackets.map((b) => [b[0].toLowerCase(), b[1].toLowerCase()]);
	const group = [];
	for (let i = 0; i < N; i++) group[i] = i;
	const areOverlapping = (a, b) => {
		const [aOpen, aClose] = a;
		const [bOpen, bClose] = b;
		return aOpen === bOpen || aOpen === bClose || aClose === bOpen || aClose === bClose;
	};
	const mergeGroups = (g1, g2) => {
		const newG = Math.min(g1, g2);
		const oldG = Math.max(g1, g2);
		for (let i = 0; i < N; i++) if (group[i] === oldG) group[i] = newG;
	};
	for (let i = 0; i < N; i++) {
		const a = brackets[i];
		for (let j = i + 1; j < N; j++) {
			const b = brackets[j];
			if (areOverlapping(a, b)) mergeGroups(group[i], group[j]);
		}
	}
	const result = [];
	for (let g = 0; g < N; g++) {
		const currentOpen = [];
		const currentClose = [];
		for (let i = 0; i < N; i++) if (group[i] === g) {
			const [open, close] = brackets[i];
			currentOpen.push(open);
			currentClose.push(close);
		}
		if (currentOpen.length > 0) result.push({
			open: currentOpen,
			close: currentClose
		});
	}
	return result;
}
var RichEditBrackets = class {
	constructor(languageId, _brackets) {
		this._richEditBracketsBrand = void 0;
		const brackets = groupFuzzyBrackets(_brackets);
		this.brackets = brackets.map((b, index) => {
			return new RichEditBracket(languageId, index, b.open, b.close, getRegexForBracketPair(b.open, b.close, brackets, index), getReversedRegexForBracketPair(b.open, b.close, brackets, index));
		});
		this.forwardRegex = getRegexForBrackets(this.brackets);
		this.reversedRegex = getReversedRegexForBrackets(this.brackets);
		this.textIsBracket = {};
		this.textIsOpenBracket = {};
		this.maxBracketLength = 0;
		for (const bracket of this.brackets) {
			for (const open of bracket.open) {
				this.textIsBracket[open] = bracket;
				this.textIsOpenBracket[open] = true;
				this.maxBracketLength = Math.max(this.maxBracketLength, open.length);
			}
			for (const close of bracket.close) {
				this.textIsBracket[close] = bracket;
				this.textIsOpenBracket[close] = false;
				this.maxBracketLength = Math.max(this.maxBracketLength, close.length);
			}
		}
	}
};
function collectSuperstrings(str, brackets, currentIndex, dest) {
	for (let i = 0, len = brackets.length; i < len; i++) {
		if (i === currentIndex) continue;
		const bracket = brackets[i];
		for (const open of bracket.open) if (open.indexOf(str) >= 0) dest.push(open);
		for (const close of bracket.close) if (close.indexOf(str) >= 0) dest.push(close);
	}
}
function lengthcmp(a, b) {
	return a.length - b.length;
}
function unique(arr) {
	if (arr.length <= 1) return arr;
	const result = [];
	const seen = /* @__PURE__ */ new Set();
	for (const element of arr) {
		if (seen.has(element)) continue;
		result.push(element);
		seen.add(element);
	}
	return result;
}
/**
* Create a regular expression that can be used to search forward in a piece of text
* for a group of bracket pairs. But this regex must be built in a way in which
* it is aware of the other bracket pairs defined for the language.
*
* For example, if a language contains the following bracket pairs:
*   ['begin', 'end']
*   ['if', 'end if']
* The two bracket pairs do not collide because no open or close brackets are equal.
* So the function getRegexForBracketPair is called twice, once with
* the ['begin'], ['end'] group consisting of one bracket pair, and once with
* the ['if'], ['end if'] group consiting of the other bracket pair.
*
* But there could be a situation where an occurrence of 'end if' is mistaken
* for an occurrence of 'end'.
*
* Therefore, for the bracket pair ['begin', 'end'], the regex will also
* target 'end if'. The regex will be something like:
*   /(\bend if\b)|(\bend\b)|(\bif\b)/
*
* The regex also searches for "superstrings" (other brackets that might be mistaken with the current bracket).
*
*/
function getRegexForBracketPair(open, close, brackets, currentIndex) {
	let pieces = [];
	pieces = pieces.concat(open);
	pieces = pieces.concat(close);
	for (let i = 0, len = pieces.length; i < len; i++) collectSuperstrings(pieces[i], brackets, currentIndex, pieces);
	pieces = unique(pieces);
	pieces.sort(lengthcmp);
	pieces.reverse();
	return createBracketOrRegExp(pieces);
}
/**
* Matching a regular expression in JS can only be done "forwards". So JS offers natively only
* methods to find the first match of a regex in a string. But sometimes, it is useful to
* find the last match of a regex in a string. For such a situation, a nice solution is to
* simply reverse the string and then search for a reversed regex.
*
* This function also has the fine details of `getRegexForBracketPair`. For the same example
* given above, the regex produced here would look like:
*   /(\bfi dne\b)|(\bdne\b)|(\bfi\b)/
*/
function getReversedRegexForBracketPair(open, close, brackets, currentIndex) {
	let pieces = [];
	pieces = pieces.concat(open);
	pieces = pieces.concat(close);
	for (let i = 0, len = pieces.length; i < len; i++) collectSuperstrings(pieces[i], brackets, currentIndex, pieces);
	pieces = unique(pieces);
	pieces.sort(lengthcmp);
	pieces.reverse();
	return createBracketOrRegExp(pieces.map(toReversedString));
}
/**
* Creates a regular expression that targets all bracket pairs.
*
* e.g. for the bracket pairs:
*  ['{','}']
*  ['begin,'end']
*  ['for','end']
* the regex would look like:
*  /(\{)|(\})|(\bbegin\b)|(\bend\b)|(\bfor\b)/
*/
function getRegexForBrackets(brackets) {
	let pieces = [];
	for (const bracket of brackets) {
		for (const open of bracket.open) pieces.push(open);
		for (const close of bracket.close) pieces.push(close);
	}
	pieces = unique(pieces);
	return createBracketOrRegExp(pieces);
}
/**
* Matching a regular expression in JS can only be done "forwards". So JS offers natively only
* methods to find the first match of a regex in a string. But sometimes, it is useful to
* find the last match of a regex in a string. For such a situation, a nice solution is to
* simply reverse the string and then search for a reversed regex.
*
* e.g. for the bracket pairs:
*  ['{','}']
*  ['begin,'end']
*  ['for','end']
* the regex would look like:
*  /(\{)|(\})|(\bnigeb\b)|(\bdne\b)|(\brof\b)/
*/
function getReversedRegexForBrackets(brackets) {
	let pieces = [];
	for (const bracket of brackets) {
		for (const open of bracket.open) pieces.push(open);
		for (const close of bracket.close) pieces.push(close);
	}
	pieces = unique(pieces);
	return createBracketOrRegExp(pieces.map(toReversedString));
}
function prepareBracketForRegExp$1(str) {
	const insertWordBoundaries = /^[\w ]+$/.test(str);
	str = escapeRegExpCharacters(str);
	return insertWordBoundaries ? `\\b${str}\\b` : str;
}
function createBracketOrRegExp(pieces, options) {
	const regexStr = `(${pieces.map(prepareBracketForRegExp$1).join(")|(")})`;
	return createRegExp(regexStr, true, options);
}
var toReversedString = (function() {
	function reverse(str) {
		const arr = new Uint16Array(str.length);
		let offset = 0;
		for (let i = str.length - 1; i >= 0; i--) arr[offset++] = str.charCodeAt(i);
		return getPlatformTextDecoder().decode(arr);
	}
	let lastInput = null;
	let lastOutput = null;
	return function toReversedString(str) {
		if (lastInput !== str) {
			lastInput = str;
			lastOutput = reverse(lastInput);
		}
		return lastOutput;
	};
})();
var BracketsUtils = class {
	static _findPrevBracketInText(reversedBracketRegex, lineNumber, reversedText, offset) {
		const m = reversedText.match(reversedBracketRegex);
		if (!m) return null;
		const matchOffset = reversedText.length - (m.index || 0);
		const matchLength = m[0].length;
		const absoluteMatchOffset = offset + matchOffset;
		return new Range$2(lineNumber, absoluteMatchOffset - matchLength + 1, lineNumber, absoluteMatchOffset + 1);
	}
	static findPrevBracketInRange(reversedBracketRegex, lineNumber, lineText, startOffset, endOffset) {
		const reversedSubstr = toReversedString(lineText).substring(lineText.length - endOffset, lineText.length - startOffset);
		return this._findPrevBracketInText(reversedBracketRegex, lineNumber, reversedSubstr, startOffset);
	}
	static findNextBracketInText(bracketRegex, lineNumber, text, offset) {
		const m = text.match(bracketRegex);
		if (!m) return null;
		const matchOffset = m.index || 0;
		const matchLength = m[0].length;
		if (matchLength === 0) return null;
		const absoluteMatchOffset = offset + matchOffset;
		return new Range$2(lineNumber, absoluteMatchOffset + 1, lineNumber, absoluteMatchOffset + 1 + matchLength);
	}
	static findNextBracketInRange(bracketRegex, lineNumber, lineText, startOffset, endOffset) {
		const substr = lineText.substring(startOffset, endOffset);
		return this.findNextBracketInText(bracketRegex, lineNumber, substr, startOffset);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/languages/supports/electricCharacter.js
var BracketElectricCharacterSupport = class {
	constructor(richEditBrackets) {
		this._richEditBrackets = richEditBrackets;
	}
	getElectricCharacters() {
		const result = [];
		if (this._richEditBrackets) for (const bracket of this._richEditBrackets.brackets) for (const close of bracket.close) {
			const lastChar = close.charAt(close.length - 1);
			result.push(lastChar);
		}
		return distinct(result);
	}
	onElectricCharacter(character, context, column) {
		if (!this._richEditBrackets || this._richEditBrackets.brackets.length === 0) return null;
		const tokenIndex = context.findTokenIndexAtOffset(column - 1);
		if (ignoreBracketsInToken(context.getStandardTokenType(tokenIndex))) return null;
		const reversedBracketRegex = this._richEditBrackets.reversedRegex;
		const text = context.getLineContent().substring(0, column - 1) + character;
		const r = BracketsUtils.findPrevBracketInRange(reversedBracketRegex, 1, text, 0, text.length);
		if (!r) return null;
		const bracketText = text.substring(r.startColumn - 1, r.endColumn - 1).toLowerCase();
		if (this._richEditBrackets.textIsOpenBracket[bracketText]) return null;
		const textBeforeBracket = context.getActualLineContentBefore(r.startColumn - 1);
		if (!/^\s*$/.test(textBeforeBracket)) return null;
		return { matchOpenBracket: bracketText };
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/languages/supports/indentRules.js
function resetGlobalRegex(reg) {
	if (reg.global) reg.lastIndex = 0;
	return true;
}
var IndentRulesSupport = class {
	constructor(indentationRules) {
		this._indentationRules = indentationRules;
	}
	shouldIncrease(text) {
		if (this._indentationRules) {
			if (this._indentationRules.increaseIndentPattern && resetGlobalRegex(this._indentationRules.increaseIndentPattern) && this._indentationRules.increaseIndentPattern.test(text)) return true;
		}
		return false;
	}
	shouldDecrease(text) {
		if (this._indentationRules && this._indentationRules.decreaseIndentPattern && resetGlobalRegex(this._indentationRules.decreaseIndentPattern) && this._indentationRules.decreaseIndentPattern.test(text)) return true;
		return false;
	}
	shouldIndentNextLine(text) {
		if (this._indentationRules && this._indentationRules.indentNextLinePattern && resetGlobalRegex(this._indentationRules.indentNextLinePattern) && this._indentationRules.indentNextLinePattern.test(text)) return true;
		return false;
	}
	shouldIgnore(text) {
		if (this._indentationRules && this._indentationRules.unIndentedLinePattern && resetGlobalRegex(this._indentationRules.unIndentedLinePattern) && this._indentationRules.unIndentedLinePattern.test(text)) return true;
		return false;
	}
	getIndentMetadata(text) {
		let ret = 0;
		if (this.shouldIncrease(text)) ret += 1;
		if (this.shouldDecrease(text)) ret += 2;
		if (this.shouldIndentNextLine(text)) ret += 4;
		if (this.shouldIgnore(text)) ret += 8;
		return ret;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/languages/supports/onEnter.js
var OnEnterSupport = class OnEnterSupport {
	constructor(opts) {
		opts = opts || {};
		opts.brackets = opts.brackets || [
			["(", ")"],
			["{", "}"],
			["[", "]"]
		];
		this._brackets = [];
		opts.brackets.forEach((bracket) => {
			const openRegExp = OnEnterSupport._createOpenBracketRegExp(bracket[0]);
			const closeRegExp = OnEnterSupport._createCloseBracketRegExp(bracket[1]);
			if (openRegExp && closeRegExp) this._brackets.push({
				open: bracket[0],
				openRegExp,
				close: bracket[1],
				closeRegExp
			});
		});
		this._regExpRules = opts.onEnterRules || [];
	}
	onEnter(autoIndent, previousLineText, beforeEnterText, afterEnterText) {
		if (autoIndent >= 3) for (let i = 0, len = this._regExpRules.length; i < len; i++) {
			const rule = this._regExpRules[i];
			if ([
				{
					reg: rule.beforeText,
					text: beforeEnterText
				},
				{
					reg: rule.afterText,
					text: afterEnterText
				},
				{
					reg: rule.previousLineText,
					text: previousLineText
				}
			].every((obj) => {
				if (!obj.reg) return true;
				obj.reg.lastIndex = 0;
				return obj.reg.test(obj.text);
			})) return rule.action;
		}
		if (autoIndent >= 2) {
			if (beforeEnterText.length > 0 && afterEnterText.length > 0) for (let i = 0, len = this._brackets.length; i < len; i++) {
				const bracket = this._brackets[i];
				if (bracket.openRegExp.test(beforeEnterText) && bracket.closeRegExp.test(afterEnterText)) return { indentAction: IndentAction.IndentOutdent };
			}
		}
		if (autoIndent >= 2) {
			if (beforeEnterText.length > 0) {
				for (let i = 0, len = this._brackets.length; i < len; i++) if (this._brackets[i].openRegExp.test(beforeEnterText)) return { indentAction: IndentAction.Indent };
			}
		}
		return null;
	}
	static _createOpenBracketRegExp(bracket) {
		let str = escapeRegExpCharacters(bracket);
		if (!/\B/.test(str.charAt(0))) str = "\\b" + str;
		str += "\\s*$";
		return OnEnterSupport._safeRegExp(str);
	}
	static _createCloseBracketRegExp(bracket) {
		let str = escapeRegExpCharacters(bracket);
		if (!/\B/.test(str.charAt(str.length - 1))) str = str + "\\b";
		str = "^\\s*" + str;
		return OnEnterSupport._safeRegExp(str);
	}
	static _safeRegExp(def) {
		try {
			return new RegExp(def);
		} catch (err) {
			onUnexpectedError(err);
			return null;
		}
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/configuration/common/configuration.js
var IConfigurationService = createDecorator("configurationService");
function toValuesTree(properties, conflictReporter) {
	const root = Object.create(null);
	for (const key in properties) addToValueTree(root, key, properties[key], conflictReporter);
	return root;
}
function addToValueTree(settingsTreeRoot, key, value, conflictReporter) {
	const segments = key.split(".");
	const last = segments.pop();
	let curr = settingsTreeRoot;
	for (let i = 0; i < segments.length; i++) {
		const s = segments[i];
		let obj = curr[s];
		switch (typeof obj) {
			case "undefined":
				obj = curr[s] = Object.create(null);
				break;
			case "object":
				if (obj === null) {
					conflictReporter(`Ignoring ${key} as ${segments.slice(0, i + 1).join(".")} is null`);
					return;
				}
				break;
			default:
				conflictReporter(`Ignoring ${key} as ${segments.slice(0, i + 1).join(".")} is ${JSON.stringify(obj)}`);
				return;
		}
		curr = obj;
	}
	if (typeof curr === "object" && curr !== null) try {
		curr[last] = value;
	} catch (e) {
		conflictReporter(`Ignoring ${key} as ${segments.join(".")} is ${JSON.stringify(curr)}`);
	}
	else conflictReporter(`Ignoring ${key} as ${segments.join(".")} is ${JSON.stringify(curr)}`);
}
function removeFromValueTree(valueTree, key) {
	doRemoveFromValueTree(valueTree, key.split("."));
}
function doRemoveFromValueTree(valueTree, segments) {
	if (!valueTree) return;
	const valueTreeRecord = valueTree;
	const first = segments.shift();
	if (segments.length === 0) {
		delete valueTreeRecord[first];
		return;
	}
	if (Object.keys(valueTreeRecord).indexOf(first) !== -1) {
		const value = valueTreeRecord[first];
		if (typeof value === "object" && value !== null && !Array.isArray(value)) {
			doRemoveFromValueTree(value, segments);
			if (Object.keys(value).length === 0) delete valueTreeRecord[first];
		}
	}
}
function getConfigurationValue(config, settingPath, defaultValue) {
	function accessSetting(config, path) {
		let current = config;
		for (const component of path) {
			if (typeof current !== "object" || current === null) return;
			current = current[component];
		}
		return current;
	}
	const result = accessSetting(config, settingPath.split("."));
	return typeof result === "undefined" ? defaultValue : result;
}
function getLanguageTagSettingPlainKey(settingKey) {
	return settingKey.replace(/^\[/, "").replace(/]$/g, "").replace(/\]\[/g, ", ");
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/languages/language.js
var ILanguageService = createDecorator("languageService");
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/instantiation/common/descriptors.js
var SyncDescriptor = class {
	constructor(ctor, staticArguments = [], supportsDelayedInstantiation = false) {
		this.ctor = ctor;
		this.staticArguments = staticArguments;
		this.supportsDelayedInstantiation = supportsDelayedInstantiation;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/instantiation/common/extensions.js
var _registry = [];
function registerSingleton(id, ctorOrDescriptor, supportsDelayedInstantiation) {
	if (!(ctorOrDescriptor instanceof SyncDescriptor)) ctorOrDescriptor = new SyncDescriptor(ctorOrDescriptor, [], Boolean(supportsDelayedInstantiation));
	_registry.push([id, ctorOrDescriptor]);
}
function getSingletonServiceDescriptors() {
	return _registry;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/mime.js
var Mimes = Object.freeze({
	text: "text/plain",
	binary: "application/octet-stream",
	unknown: "application/unknown",
	markdown: "text/markdown",
	latex: "text/latex",
	uriList: "text/uri-list",
	html: "text/html"
});
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/jsonschemas/common/jsonContributionRegistry.js
var Extensions$7 = { JSONContribution: "base.contributions.json" };
function normalizeId(id) {
	if (id.length > 0 && id.charAt(id.length - 1) === "#") return id.substring(0, id.length - 1);
	return id;
}
var JSONContributionRegistry = class extends Disposable {
	constructor() {
		super(...arguments);
		this.schemasById = {};
		this._onDidChangeSchema = this._register(new Emitter$1());
	}
	registerSchema(uri, unresolvedSchemaContent, store) {
		const normalizedUri = normalizeId(uri);
		this.schemasById[normalizedUri] = unresolvedSchemaContent;
		this._onDidChangeSchema.fire(uri);
		if (store) store.add(toDisposable(() => {
			delete this.schemasById[normalizedUri];
			this._onDidChangeSchema.fire(uri);
		}));
	}
	notifySchemaChanged(uri) {
		this._onDidChangeSchema.fire(uri);
	}
};
var jsonContributionRegistry = new JSONContributionRegistry();
Registry.add(Extensions$7.JSONContribution, jsonContributionRegistry);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/product/common/product.js
function getDependencyVersion(packageConfiguration, packageName) {
	return packageConfiguration.dependencies?.[packageName]?.replace(/^[~^]/, "");
}
/**
* @deprecated It is preferred that you use `IProductService` if you can. This
* allows web embedders to override our defaults. But for things like `product.quality`,
* the use is fine because that property is not overridable.
*/
var product;
var vscodeGlobal = globalThis.vscode;
if (typeof vscodeGlobal !== "undefined" && typeof vscodeGlobal.context !== "undefined") {
	const configuration = vscodeGlobal.context.configuration();
	if (configuration) product = configuration.product;
	else throw new Error("Sandbox: unable to resolve product configuration from preload script.");
} else if (globalThis._VSCODE_PRODUCT_JSON && globalThis._VSCODE_PACKAGE_JSON) {
	product = globalThis._VSCODE_PRODUCT_JSON;
	const packageConfiguration = globalThis._VSCODE_PACKAGE_JSON;
	if (env["VSCODE_DEV"]) Object.assign(product, {
		nameShort: `${product.nameShort} Dev`,
		nameLong: `${product.nameLong} Dev`,
		dataFolderName: `${product.dataFolderName}-dev`,
		serverDataFolderName: product.serverDataFolderName ? `${product.serverDataFolderName}-dev` : void 0
	});
	if (!product.version) Object.assign(product, { version: packageConfiguration.version });
	if (!product.copilotVersions) {
		const sdk = getDependencyVersion(packageConfiguration, "@github/copilot-sdk");
		if (packageConfiguration.copilotRuntimeVersion && sdk) Object.assign(product, { copilotVersions: {
			runtime: packageConfiguration.copilotRuntimeVersion,
			sdk
		} });
	}
} else {
	product = {};
	if (Object.keys(product).length === 0) Object.assign(product, {
		version: "1.104.0-dev",
		nameShort: "Code - OSS Dev",
		nameLong: "Code - OSS Dev",
		applicationName: "code-oss",
		dataFolderName: ".vscode-oss",
		urlProtocol: "code-oss",
		reportIssueUrl: "https://github.com/microsoft/vscode/issues/new",
		licenseName: "MIT",
		licenseUrl: "https://github.com/microsoft/vscode/blob/main/LICENSE.txt",
		serverLicenseUrl: "https://github.com/microsoft/vscode/blob/main/LICENSE.txt",
		defaultChatAgent: {
			extensionId: "GitHub.copilot",
			chatExtensionId: "GitHub.copilot-chat",
			provider: {
				default: {
					id: "github",
					name: "GitHub"
				},
				enterprise: {
					id: "github-enterprise",
					name: "GitHub Enterprise"
				}
			},
			providerScopes: []
		}
	});
}
var product$1 = product;
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/configuration/common/configurationRegistry.js
var Extensions$6 = { Configuration: "base.contributions.configuration" };
var resourceLanguageSettingsSchemaId = "vscode://schemas/settings/resourceLanguage";
var contributionRegistry = Registry.as(Extensions$7.JSONContribution);
var ConfigurationRegistry = class extends Disposable {
	constructor() {
		super();
		this.registeredConfigurationDefaults = [];
		/**
		* Agent-host-mirrored setting keys per node that were hidden with
		* `included: false`. Registration deletes those keys from the node's
		* `properties`, so deregistration has no other way to find them.
		*/
		this.excludedAgentHostSyncKeys = /* @__PURE__ */ new Map();
		this.overrideIdentifiers = /* @__PURE__ */ new Set();
		this._onDidSchemaChange = this._register(new Emitter$1());
		this._onDidUpdateConfiguration = this._register(new Emitter$1());
		this.configurationDefaultsOverrides = /* @__PURE__ */ new Map();
		this.defaultLanguageConfigurationOverridesNode = {
			id: "defaultOverrides",
			title: localize(1756, "Default Language Configuration Overrides"),
			properties: {}
		};
		this.configurationContributors = [this.defaultLanguageConfigurationOverridesNode];
		this.resourceLanguageSettingsSchema = {
			properties: {},
			patternProperties: {},
			additionalProperties: true,
			allowTrailingCommas: true,
			allowComments: true
		};
		this.configurationProperties = {};
		this.policyConfigurations = /* @__PURE__ */ new Map();
		this.policyReferenceConfigurations = /* @__PURE__ */ new Map();
		this.agentHostSyncConfigurations = /* @__PURE__ */ new Map();
		this.excludedConfigurationProperties = {};
		contributionRegistry.registerSchema(resourceLanguageSettingsSchemaId, this.resourceLanguageSettingsSchema);
		this.registerOverridePropertyPatternKey();
	}
	registerConfiguration(configuration, validate = true) {
		this.registerConfigurations([configuration], validate);
		return configuration;
	}
	registerConfigurations(configurations, validate = true) {
		const properties = /* @__PURE__ */ new Set();
		this.doRegisterConfigurations(configurations, validate, properties);
		contributionRegistry.registerSchema(resourceLanguageSettingsSchemaId, this.resourceLanguageSettingsSchema);
		this._onDidSchemaChange.fire();
		this._onDidUpdateConfiguration.fire({ properties });
	}
	registerDefaultConfigurations(configurationDefaults) {
		const properties = /* @__PURE__ */ new Set();
		this.doRegisterDefaultConfigurations(configurationDefaults, properties);
		this._onDidSchemaChange.fire();
		this._onDidUpdateConfiguration.fire({
			properties,
			defaultsOverrides: true
		});
	}
	doRegisterDefaultConfigurations(configurationDefaults, bucket) {
		this.registeredConfigurationDefaults.push(...configurationDefaults);
		const overrideIdentifiers = [];
		for (const { overrides, source } of configurationDefaults) for (const key in overrides) {
			bucket.add(key);
			const configurationDefaultOverridesForKey = this.configurationDefaultsOverrides.get(key) ?? this.configurationDefaultsOverrides.set(key, { configurationDefaultOverrides: [] }).get(key);
			const value = overrides[key];
			configurationDefaultOverridesForKey.configurationDefaultOverrides.push({
				value,
				source
			});
			if (OVERRIDE_PROPERTY_REGEX.test(key)) {
				const newDefaultOverride = this.mergeDefaultConfigurationsForOverrideIdentifier(key, value, source, configurationDefaultOverridesForKey.configurationDefaultOverrideValue);
				if (!newDefaultOverride) continue;
				configurationDefaultOverridesForKey.configurationDefaultOverrideValue = newDefaultOverride;
				this.updateDefaultOverrideProperty(key, newDefaultOverride, source);
				overrideIdentifiers.push(...overrideIdentifiersFromKey(key));
			} else {
				const newDefaultOverride = this.mergeDefaultConfigurationsForConfigurationProperty(key, value, source, configurationDefaultOverridesForKey.configurationDefaultOverrideValue);
				if (!newDefaultOverride) continue;
				configurationDefaultOverridesForKey.configurationDefaultOverrideValue = newDefaultOverride;
				const property = this.configurationProperties[key];
				if (property) {
					this.updatePropertyDefaultValue(key, property);
					this.updateSchema(key, property);
				}
			}
		}
		this.doRegisterOverrideIdentifiers(overrideIdentifiers);
	}
	updateDefaultOverrideProperty(key, newDefaultOverride, source) {
		const property = {
			section: {
				id: this.defaultLanguageConfigurationOverridesNode.id,
				title: this.defaultLanguageConfigurationOverridesNode.title,
				order: this.defaultLanguageConfigurationOverridesNode.order,
				extensionInfo: this.defaultLanguageConfigurationOverridesNode.extensionInfo
			},
			type: "object",
			default: newDefaultOverride.value,
			description: localize(1757, "Configure settings to be overridden for {0}.", getLanguageTagSettingPlainKey(key)),
			$ref: resourceLanguageSettingsSchemaId,
			defaultDefaultValue: newDefaultOverride.value,
			source,
			defaultValueSource: source
		};
		this.configurationProperties[key] = property;
		this.defaultLanguageConfigurationOverridesNode.properties[key] = property;
	}
	mergeDefaultConfigurationsForOverrideIdentifier(overrideIdentifier, configurationValueObject, valueSource, existingDefaultOverride) {
		const defaultValue = existingDefaultOverride?.value || {};
		const source = existingDefaultOverride?.source ?? /* @__PURE__ */ new Map();
		if (!(source instanceof Map)) {
			console.error("objectConfigurationSources is not a Map");
			return;
		}
		for (const propertyKey of Object.keys(configurationValueObject)) {
			const propertyDefaultValue = configurationValueObject[propertyKey];
			if (isObject(propertyDefaultValue) && (isUndefined(defaultValue[propertyKey]) || isObject(defaultValue[propertyKey]))) {
				defaultValue[propertyKey] = {
					...defaultValue[propertyKey] ?? {},
					...propertyDefaultValue
				};
				if (valueSource) for (const objectKey in propertyDefaultValue) source.set(`${propertyKey}.${objectKey}`, valueSource);
			} else {
				defaultValue[propertyKey] = propertyDefaultValue;
				if (valueSource) source.set(propertyKey, valueSource);
				else source.delete(propertyKey);
			}
		}
		return {
			value: defaultValue,
			source
		};
	}
	mergeDefaultConfigurationsForConfigurationProperty(propertyKey, value, valuesSource, existingDefaultOverride) {
		const property = this.configurationProperties[propertyKey];
		const existingDefaultValue = existingDefaultOverride?.value ?? property?.defaultDefaultValue;
		let source = valuesSource;
		if (isObject(value) && (property !== void 0 && property.type === "object" || property === void 0 && (isUndefined(existingDefaultValue) || isObject(existingDefaultValue)))) {
			source = existingDefaultOverride?.source ?? /* @__PURE__ */ new Map();
			if (!(source instanceof Map)) {
				console.error("defaultValueSource is not a Map");
				return;
			}
			for (const objectKey in value) if (valuesSource) source.set(`${propertyKey}.${objectKey}`, valuesSource);
			value = {
				...isObject(existingDefaultValue) ? existingDefaultValue : {},
				...value
			};
		}
		return {
			value,
			source
		};
	}
	registerOverrideIdentifiers(overrideIdentifiers) {
		this.doRegisterOverrideIdentifiers(overrideIdentifiers);
		this._onDidSchemaChange.fire();
	}
	doRegisterOverrideIdentifiers(overrideIdentifiers) {
		for (const overrideIdentifier of overrideIdentifiers) this.overrideIdentifiers.add(overrideIdentifier);
		this.updateOverridePropertyPatternKey();
	}
	doRegisterConfigurations(configurations, validate, bucket) {
		configurations.forEach((configuration) => {
			this.validateAndRegisterProperties(configuration, validate, configuration.extensionInfo, configuration.restrictedProperties, void 0, bucket);
			this.configurationContributors.push(configuration);
			this.registerJSONConfiguration(configuration);
		});
	}
	validateAndRegisterProperties(configuration, validate = true, extensionInfo, restrictedProperties, scope = 4, bucket) {
		scope = isUndefinedOrNull(configuration.scope) ? scope : configuration.scope;
		const properties = configuration.properties;
		if (properties) for (const key in properties) {
			const property = properties[key];
			property.section = {
				id: configuration.id,
				title: configuration.title,
				order: configuration.order,
				extensionInfo: configuration.extensionInfo
			};
			if (validate && validateProperty(key, property, extensionInfo?.id)) {
				delete properties[key];
				continue;
			}
			property.source = extensionInfo;
			property.defaultDefaultValue = properties[key].default;
			this.updatePropertyDefaultValue(key, property);
			if (OVERRIDE_PROPERTY_REGEX.test(key)) property.scope = void 0;
			else {
				property.scope = isUndefinedOrNull(property.scope) ? scope : property.scope;
				property.restricted = isUndefinedOrNull(property.restricted) ? !!restrictedProperties?.includes(key) : property.restricted;
			}
			if (property.experiment) {
				if (!property.tags?.some((tag) => tag.toLowerCase() === "onexp")) {
					property.tags = property.tags ?? [];
					property.tags.push("onExP");
				}
			} else if (property.tags?.some((tag) => tag.toLowerCase() === "onexp")) {
				console.error(`Invalid tag 'onExP' found for property '${key}'. Please use 'experiment' property instead.`);
				property.experiment = { mode: "startup" };
			}
			const excluded = properties[key].hasOwnProperty("included") && !properties[key].included;
			const policyName = properties[key].policy?.name;
			const policyReferenceName = properties[key].policyReference?.name;
			const agentHostSync = properties[key].agentHost;
			if (agentHostSync) this.agentHostSyncConfigurations.set(key, agentHostSync);
			if (excluded) {
				this.excludedConfigurationProperties[key] = properties[key];
				if (policyName) {
					this.policyConfigurations.set(policyName, key);
					bucket.add(key);
				}
				if (policyReferenceName) {
					this.addPolicyReferenceConfiguration(policyReferenceName, key);
					bucket.add(key);
				}
				if (agentHostSync) {
					bucket.add(key);
					let excludedSyncKeys = this.excludedAgentHostSyncKeys.get(configuration);
					if (!excludedSyncKeys) {
						excludedSyncKeys = /* @__PURE__ */ new Set();
						this.excludedAgentHostSyncKeys.set(configuration, excludedSyncKeys);
					}
					excludedSyncKeys.add(key);
				}
				delete properties[key];
			} else {
				bucket.add(key);
				if (policyName) this.policyConfigurations.set(policyName, key);
				if (policyReferenceName) this.addPolicyReferenceConfiguration(policyReferenceName, key);
				this.configurationProperties[key] = properties[key];
				if (!properties[key].deprecationMessage && properties[key].markdownDeprecationMessage) properties[key].deprecationMessage = properties[key].markdownDeprecationMessage;
			}
		}
		const subNodes = configuration.allOf;
		if (subNodes) for (const node of subNodes) this.validateAndRegisterProperties(node, validate, extensionInfo, restrictedProperties, scope, bucket);
	}
	addPolicyReferenceConfiguration(policyName, key) {
		let keys = this.policyReferenceConfigurations.get(policyName);
		if (!keys) {
			keys = /* @__PURE__ */ new Set();
			this.policyReferenceConfigurations.set(policyName, keys);
		}
		keys.add(key);
	}
	getConfigurationProperties() {
		return this.configurationProperties;
	}
	getPolicyConfigurations() {
		return this.policyConfigurations;
	}
	getAgentHostSyncConfigurations() {
		return this.agentHostSyncConfigurations;
	}
	getExcludedConfigurationProperties() {
		return this.excludedConfigurationProperties;
	}
	registerJSONConfiguration(configuration) {
		const register = (configuration) => {
			const properties = configuration.properties;
			if (properties) for (const key in properties) this.updateSchema(key, properties[key]);
			configuration.allOf?.forEach(register);
		};
		register(configuration);
	}
	updateSchema(key, property) {
		switch (property.scope) {
			case 1: break;
			case 2: break;
			case 3: break;
			case 7: break;
			case 4: break;
			case 5: break;
			case 6: this.resourceLanguageSettingsSchema.properties[key] = property;
		}
	}
	updateOverridePropertyPatternKey() {
		for (const overrideIdentifier of this.overrideIdentifiers.values()) {
			const overrideIdentifierProperty = `[${overrideIdentifier}]`;
			const resourceLanguagePropertiesSchema = {
				type: "object",
				description: localize(1758, "Configure editor settings to be overridden for a language."),
				errorMessage: localize(1759, "This setting does not support per-language configuration."),
				$ref: resourceLanguageSettingsSchemaId
			};
			this.updatePropertyDefaultValue(overrideIdentifierProperty, resourceLanguagePropertiesSchema);
		}
	}
	registerOverridePropertyPatternKey() {
		localize(1760, "Configure editor settings to be overridden for a language."), localize(1761, "This setting does not support per-language configuration.");
		this._onDidSchemaChange.fire();
	}
	updatePropertyDefaultValue(key, property) {
		const configurationdefaultOverride = this.configurationDefaultsOverrides.get(key)?.configurationDefaultOverrideValue;
		let defaultValue = void 0;
		let defaultSource = void 0;
		if (configurationdefaultOverride && (!property.disallowConfigurationDefault || !configurationdefaultOverride.source)) {
			defaultValue = configurationdefaultOverride.value;
			defaultSource = configurationdefaultOverride.source;
		}
		if (isUndefined(defaultValue)) {
			defaultValue = property.defaultDefaultValue;
			defaultSource = void 0;
		}
		if (isUndefined(defaultValue)) defaultValue = getDefaultValue(property.type);
		property.default = defaultValue;
		property.defaultValueSource = defaultSource;
	}
};
var OVERRIDE_IDENTIFIER_PATTERN = `\\[([^\\]]+)\\]`;
var OVERRIDE_IDENTIFIER_REGEX = new RegExp(OVERRIDE_IDENTIFIER_PATTERN, "g");
var OVERRIDE_PROPERTY_PATTERN = `^(${OVERRIDE_IDENTIFIER_PATTERN})+$`;
var OVERRIDE_PROPERTY_REGEX = new RegExp(OVERRIDE_PROPERTY_PATTERN);
function overrideIdentifiersFromKey(key) {
	const identifiers = [];
	if (OVERRIDE_PROPERTY_REGEX.test(key)) {
		let matches = OVERRIDE_IDENTIFIER_REGEX.exec(key);
		while (matches?.length) {
			const identifier = matches[1].trim();
			if (identifier) identifiers.push(identifier);
			matches = OVERRIDE_IDENTIFIER_REGEX.exec(key);
		}
	}
	return distinct(identifiers);
}
function getDefaultValue(type) {
	switch (Array.isArray(type) ? type[0] : type) {
		case "boolean": return false;
		case "integer":
		case "number": return 0;
		case "string": return "";
		case "array": return [];
		case "object": return {};
		default: return null;
	}
}
var configurationRegistry = new ConfigurationRegistry();
Registry.add(Extensions$6.Configuration, configurationRegistry);
function validateProperty(property, schema, extensionId) {
	if (!property.trim()) return localize(1762, "Cannot register an empty property");
	if (OVERRIDE_PROPERTY_REGEX.test(property)) return localize(1763, "Cannot register '{0}'. This matches property pattern '\\\\[.*\\\\]$' for describing language specific editor settings. Use 'configurationDefaults' contribution.", property);
	if (configurationRegistry.getConfigurationProperties()[property] !== void 0 && (!extensionId || !EXTENSION_UNIFICATION_EXTENSION_IDS.has(extensionId.toLowerCase()))) return localize(1764, "Cannot register '{0}'. This property is already registered.", property);
	if (schema.policy && schema.policyReference) return localize(1765, "Cannot register '{0}'. A setting must not declare both 'policy' and 'policyReference'.", property);
	if (schema.policy?.name && configurationRegistry.getPolicyConfigurations().get(schema.policy?.name) !== void 0) return localize(1766, "Cannot register '{0}'. The associated policy {1} is already registered with {2}. To attach another setting to the same policy, use 'policyReference'.", property, schema.policy?.name, configurationRegistry.getPolicyConfigurations().get(schema.policy?.name));
	if (schema.agentHost) {
		for (const [owner, sync] of configurationRegistry.getAgentHostSyncConfigurations()) if (sync.key === schema.agentHost.key && owner !== property) return localize(1767, "Cannot register '{0}'. The agent host configuration key '{1}' is already mirrored from '{2}'.", property, schema.agentHost.key, owner);
	}
	return null;
}
var EXTENSION_UNIFICATION_EXTENSION_IDS = new Set(product$1.defaultChatAgent ? [product$1.defaultChatAgent.extensionId, product$1.defaultChatAgent.chatExtensionId].map((id) => id.toLowerCase()) : []);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/languages/modesRegistry.js
var Extensions$5 = { ModesRegistry: "editor.modesRegistry" };
var EditorModesRegistry = class extends Disposable {
	constructor() {
		super();
		this._onDidChangeLanguages = this._register(new Emitter$1());
		this.onDidChangeLanguages = this._onDidChangeLanguages.event;
		this._languages = [];
	}
	registerLanguage(def) {
		this._languages.push(def);
		this._onDidChangeLanguages.fire(void 0);
		return { dispose: () => {
			for (let i = 0, len = this._languages.length; i < len; i++) if (this._languages[i] === def) {
				this._languages.splice(i, 1);
				return;
			}
		} };
	}
	getLanguages() {
		return this._languages;
	}
};
var ModesRegistry = new EditorModesRegistry();
Registry.add(Extensions$5.ModesRegistry, ModesRegistry);
var PLAINTEXT_LANGUAGE_ID = "plaintext";
ModesRegistry.registerLanguage({
	id: PLAINTEXT_LANGUAGE_ID,
	extensions: [".txt"],
	aliases: [localize(834, "Plain Text"), "text"],
	mimetypes: [Mimes.text]
});
Registry.as(Extensions$6.Configuration).registerDefaultConfigurations([{ overrides: {
	"[plaintext]": {
		"editor.unicodeHighlight.ambiguousCharacters": false,
		"editor.unicodeHighlight.invisibleCharacters": false
	},
	"[go]": { "editor.insertSpaces": false },
	"[makefile]": { "editor.insertSpaces": false },
	"[shellscript]": { "files.eol": "\n" },
	"[yaml]": {
		"editor.insertSpaces": true,
		"editor.tabSize": 2
	}
} }]);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/languages/supports/languageBracketsConfiguration.js
/**
* Captures all bracket related configurations for a single language.
* Immutable.
*/
var LanguageBracketsConfiguration = class {
	constructor(languageId, config) {
		this.languageId = languageId;
		const bracketPairs = config.brackets ? filterValidBrackets(config.brackets) : [];
		const openingBracketInfos = new CachedFunction((bracket) => {
			const closing = /* @__PURE__ */ new Set();
			return {
				info: new OpeningBracketKind(this, bracket, closing),
				closing
			};
		});
		const closingBracketInfos = new CachedFunction((bracket) => {
			const opening = /* @__PURE__ */ new Set();
			const openingColorized = /* @__PURE__ */ new Set();
			return {
				info: new ClosingBracketKind(this, bracket, opening, openingColorized),
				opening,
				openingColorized
			};
		});
		for (const [open, close] of bracketPairs) {
			const opening = openingBracketInfos.get(open);
			const closing = closingBracketInfos.get(close);
			opening.closing.add(closing.info);
			closing.opening.add(opening.info);
		}
		const colorizedBracketPairs = config.colorizedBracketPairs ? filterValidBrackets(config.colorizedBracketPairs) : bracketPairs.filter((p) => !(p[0] === "<" && p[1] === ">"));
		for (const [open, close] of colorizedBracketPairs) {
			const opening = openingBracketInfos.get(open);
			const closing = closingBracketInfos.get(close);
			opening.closing.add(closing.info);
			closing.openingColorized.add(opening.info);
			closing.opening.add(opening.info);
		}
		this._openingBrackets = new Map([...openingBracketInfos.cachedValues].map(([k, v]) => [k, v.info]));
		this._closingBrackets = new Map([...closingBracketInfos.cachedValues].map(([k, v]) => [k, v.info]));
	}
	/**
	* No two brackets have the same bracket text.
	*/
	get openingBrackets() {
		return [...this._openingBrackets.values()];
	}
	/**
	* No two brackets have the same bracket text.
	*/
	get closingBrackets() {
		return [...this._closingBrackets.values()];
	}
	getOpeningBracketInfo(bracketText) {
		return this._openingBrackets.get(bracketText);
	}
	getClosingBracketInfo(bracketText) {
		return this._closingBrackets.get(bracketText);
	}
	getBracketInfo(bracketText) {
		return this.getOpeningBracketInfo(bracketText) || this.getClosingBracketInfo(bracketText);
	}
	getBracketRegExp(options) {
		return createBracketOrRegExp(Array.from([...this._openingBrackets.keys(), ...this._closingBrackets.keys()]), options);
	}
};
function filterValidBrackets(bracketPairs) {
	return bracketPairs.filter(([open, close]) => open !== "" && close !== "");
}
var BracketKindBase = class {
	constructor(config, bracketText) {
		this.config = config;
		this.bracketText = bracketText;
	}
	get languageId() {
		return this.config.languageId;
	}
};
var OpeningBracketKind = class extends BracketKindBase {
	constructor(config, bracketText, openedBrackets) {
		super(config, bracketText);
		this.openedBrackets = openedBrackets;
		this.isOpeningBracket = true;
	}
};
var ClosingBracketKind = class extends BracketKindBase {
	constructor(config, bracketText, openingBrackets, openingColorizedBrackets) {
		super(config, bracketText);
		this.openingBrackets = openingBrackets;
		this.openingColorizedBrackets = openingColorizedBrackets;
		this.isOpeningBracket = false;
	}
	/**
	* Checks if this bracket closes the given other bracket.
	* If the bracket infos come from different configurations, this method will return false.
	*/
	closes(other) {
		if (other["config"] !== this.config) return false;
		return this.openingBrackets.has(other);
	}
	closesColorized(other) {
		if (other["config"] !== this.config) return false;
		return this.openingColorizedBrackets.has(other);
	}
	getOpeningBrackets() {
		return [...this.openingBrackets];
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/languages/languageConfigurationRegistry.js
var __decorate$80 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$73 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var LanguageConfigurationServiceChangeEvent = class {
	constructor(languageId) {
		this.languageId = languageId;
	}
	affects(languageId) {
		return !this.languageId ? true : this.languageId === languageId;
	}
};
var ILanguageConfigurationService = createDecorator("languageConfigurationService");
var LanguageConfigurationService = class LanguageConfigurationService extends Disposable {
	constructor(configurationService, languageService) {
		super();
		this.configurationService = configurationService;
		this.languageService = languageService;
		this._registry = this._register(new LanguageConfigurationRegistry());
		this.onDidChangeEmitter = this._register(new Emitter$1({
			leakWarningThreshold: 500,
			leakWarningName: "LanguageConfigurationService.onDidChange"
		}));
		this.onDidChange = this.onDidChangeEmitter.event;
		this.configurations = /* @__PURE__ */ new Map();
		const languageConfigKeys = new Set(Object.values(customizedLanguageConfigKeys));
		this._register(this.configurationService.onDidChangeConfiguration((e) => {
			const globalConfigChanged = e.change.keys.some((k) => languageConfigKeys.has(k));
			const localConfigChanged = e.change.overrides.filter(([overrideLangName, keys]) => keys.some((k) => languageConfigKeys.has(k))).map(([overrideLangName]) => overrideLangName);
			if (globalConfigChanged) {
				this.configurations.clear();
				this.onDidChangeEmitter.fire(new LanguageConfigurationServiceChangeEvent(void 0));
			} else for (const languageId of localConfigChanged) if (this.languageService.isRegisteredLanguageId(languageId)) {
				this.configurations.delete(languageId);
				this.onDidChangeEmitter.fire(new LanguageConfigurationServiceChangeEvent(languageId));
			}
		}));
		this._register(this._registry.onDidChange((e) => {
			this.configurations.delete(e.languageId);
			this.onDidChangeEmitter.fire(new LanguageConfigurationServiceChangeEvent(e.languageId));
		}));
	}
	register(languageId, configuration, priority) {
		return this._registry.register(languageId, configuration, priority);
	}
	getLanguageConfiguration(languageId) {
		let result = this.configurations.get(languageId);
		if (!result) {
			result = computeConfig(languageId, this._registry, this.configurationService, this.languageService);
			this.configurations.set(languageId, result);
		}
		return result;
	}
};
LanguageConfigurationService = __decorate$80([__param$73(0, IConfigurationService), __param$73(1, ILanguageService)], LanguageConfigurationService);
function computeConfig(languageId, registry, configurationService, languageService) {
	let languageConfig = registry.getLanguageConfiguration(languageId);
	if (!languageConfig) {
		if (!languageService.isRegisteredLanguageId(languageId)) return new ResolvedLanguageConfiguration(languageId, {});
		languageConfig = new ResolvedLanguageConfiguration(languageId, {});
	}
	const customizedConfig = getCustomizedLanguageConfig(languageConfig.languageId, configurationService);
	const data = combineLanguageConfigurations([languageConfig.underlyingConfig, customizedConfig]);
	return new ResolvedLanguageConfiguration(languageConfig.languageId, data);
}
var customizedLanguageConfigKeys = {
	brackets: "editor.language.brackets",
	colorizedBracketPairs: "editor.language.colorizedBracketPairs"
};
function getCustomizedLanguageConfig(languageId, configurationService) {
	const brackets = configurationService.getValue(customizedLanguageConfigKeys.brackets, { overrideIdentifier: languageId });
	const colorizedBracketPairs = configurationService.getValue(customizedLanguageConfigKeys.colorizedBracketPairs, { overrideIdentifier: languageId });
	return {
		brackets: validateBracketPairs(brackets),
		colorizedBracketPairs: validateBracketPairs(colorizedBracketPairs)
	};
}
function validateBracketPairs(data) {
	if (!Array.isArray(data)) return;
	return data.map((pair) => {
		if (!Array.isArray(pair) || pair.length !== 2) return;
		return [pair[0], pair[1]];
	}).filter((p) => !!p);
}
function getIndentationAtPosition(model, lineNumber, column) {
	const lineText = model.getLineContent(lineNumber);
	let indentation = getLeadingWhitespace(lineText);
	if (indentation.length > column - 1) indentation = indentation.substring(0, column - 1);
	return indentation;
}
var ComposedLanguageConfiguration = class {
	constructor(languageId) {
		this.languageId = languageId;
		this._resolved = null;
		this._entries = [];
		this._order = 0;
		this._resolved = null;
	}
	register(configuration, priority) {
		const entry = new LanguageConfigurationContribution(configuration, priority, ++this._order);
		this._entries.push(entry);
		this._resolved = null;
		return markAsSingleton(toDisposable(() => {
			for (let i = 0; i < this._entries.length; i++) if (this._entries[i] === entry) {
				this._entries.splice(i, 1);
				this._resolved = null;
				break;
			}
		}));
	}
	getResolvedConfiguration() {
		if (!this._resolved) {
			const config = this._resolve();
			if (config) this._resolved = new ResolvedLanguageConfiguration(this.languageId, config);
		}
		return this._resolved;
	}
	_resolve() {
		if (this._entries.length === 0) return null;
		this._entries.sort(LanguageConfigurationContribution.cmp);
		return combineLanguageConfigurations(this._entries.map((e) => e.configuration));
	}
};
function combineLanguageConfigurations(configs) {
	let result = {
		comments: void 0,
		brackets: void 0,
		wordPattern: void 0,
		indentationRules: void 0,
		onEnterRules: void 0,
		autoClosingPairs: void 0,
		surroundingPairs: void 0,
		autoCloseBefore: void 0,
		folding: void 0,
		colorizedBracketPairs: void 0,
		__electricCharacterSupport: void 0
	};
	for (const entry of configs) result = {
		comments: entry.comments || result.comments,
		brackets: entry.brackets || result.brackets,
		wordPattern: entry.wordPattern || result.wordPattern,
		indentationRules: entry.indentationRules || result.indentationRules,
		onEnterRules: entry.onEnterRules || result.onEnterRules,
		autoClosingPairs: entry.autoClosingPairs || result.autoClosingPairs,
		surroundingPairs: entry.surroundingPairs || result.surroundingPairs,
		autoCloseBefore: entry.autoCloseBefore || result.autoCloseBefore,
		folding: entry.folding || result.folding,
		colorizedBracketPairs: entry.colorizedBracketPairs || result.colorizedBracketPairs,
		__electricCharacterSupport: entry.__electricCharacterSupport || result.__electricCharacterSupport
	};
	return result;
}
var LanguageConfigurationContribution = class {
	constructor(configuration, priority, order) {
		this.configuration = configuration;
		this.priority = priority;
		this.order = order;
	}
	static cmp(a, b) {
		if (a.priority === b.priority) return a.order - b.order;
		return a.priority - b.priority;
	}
};
var LanguageConfigurationChangeEvent = class {
	constructor(languageId) {
		this.languageId = languageId;
	}
};
var LanguageConfigurationRegistry = class extends Disposable {
	constructor() {
		super();
		this._entries = /* @__PURE__ */ new Map();
		this._onDidChange = this._register(new Emitter$1());
		this.onDidChange = this._onDidChange.event;
		this._register(this.register(PLAINTEXT_LANGUAGE_ID, {
			brackets: [
				["(", ")"],
				["[", "]"],
				["{", "}"]
			],
			surroundingPairs: [
				{
					open: "{",
					close: "}"
				},
				{
					open: "[",
					close: "]"
				},
				{
					open: "(",
					close: ")"
				},
				{
					open: "<",
					close: ">"
				},
				{
					open: "\"",
					close: "\""
				},
				{
					open: "'",
					close: "'"
				},
				{
					open: "`",
					close: "`"
				}
			],
			colorizedBracketPairs: [],
			folding: { offSide: true }
		}, 0));
	}
	/**
	* @param priority Use a higher number for higher priority
	*/
	register(languageId, configuration, priority = 0) {
		let entries = this._entries.get(languageId);
		if (!entries) {
			entries = new ComposedLanguageConfiguration(languageId);
			this._entries.set(languageId, entries);
		}
		const disposable = entries.register(configuration, priority);
		this._onDidChange.fire(new LanguageConfigurationChangeEvent(languageId));
		return markAsSingleton(toDisposable(() => {
			disposable.dispose();
			this._onDidChange.fire(new LanguageConfigurationChangeEvent(languageId));
		}));
	}
	getLanguageConfiguration(languageId) {
		return this._entries.get(languageId)?.getResolvedConfiguration() || null;
	}
};
/**
* Immutable.
*/
var ResolvedLanguageConfiguration = class ResolvedLanguageConfiguration {
	constructor(languageId, underlyingConfig) {
		this.languageId = languageId;
		this.underlyingConfig = underlyingConfig;
		this._brackets = null;
		this._electricCharacter = null;
		this._onEnterSupport = this.underlyingConfig.brackets || this.underlyingConfig.indentationRules || this.underlyingConfig.onEnterRules ? new OnEnterSupport(this.underlyingConfig) : null;
		this.comments = ResolvedLanguageConfiguration._handleComments(this.underlyingConfig);
		this.characterPair = new CharacterPairSupport(this.underlyingConfig);
		this.wordDefinition = this.underlyingConfig.wordPattern || DEFAULT_WORD_REGEXP;
		this.indentationRules = this.underlyingConfig.indentationRules;
		if (this.underlyingConfig.indentationRules) this.indentRulesSupport = new IndentRulesSupport(this.underlyingConfig.indentationRules);
		else this.indentRulesSupport = null;
		this.foldingRules = this.underlyingConfig.folding || {};
		this.bracketsNew = new LanguageBracketsConfiguration(languageId, this.underlyingConfig);
	}
	getWordDefinition() {
		return ensureValidWordDefinition(this.wordDefinition);
	}
	get brackets() {
		if (!this._brackets && this.underlyingConfig.brackets) this._brackets = new RichEditBrackets(this.languageId, this.underlyingConfig.brackets);
		return this._brackets;
	}
	get electricCharacter() {
		if (!this._electricCharacter) this._electricCharacter = new BracketElectricCharacterSupport(this.brackets);
		return this._electricCharacter;
	}
	onEnter(autoIndent, previousLineText, beforeEnterText, afterEnterText) {
		if (!this._onEnterSupport) return null;
		return this._onEnterSupport.onEnter(autoIndent, previousLineText, beforeEnterText, afterEnterText);
	}
	getAutoClosingPairs() {
		return new AutoClosingPairs(this.characterPair.getAutoClosingPairs());
	}
	getAutoCloseBeforeSet(forQuotes) {
		return this.characterPair.getAutoCloseBeforeSet(forQuotes);
	}
	getSurroundingPairs() {
		return this.characterPair.getSurroundingPairs();
	}
	static _handleComments(conf) {
		const commentRule = conf.comments;
		if (!commentRule) return null;
		const comments = {};
		if (commentRule.lineComment) {
			if (typeof commentRule.lineComment === "string") comments.lineCommentToken = commentRule.lineComment;
			else {
				comments.lineCommentToken = commentRule.lineComment.comment;
				comments.lineCommentNoIndent = commentRule.lineComment.noIndent;
			}
		}
		if (commentRule.blockComment) {
			const [blockStart, blockEnd] = commentRule.blockComment;
			comments.blockCommentStartToken = blockStart;
			comments.blockCommentEndToken = blockEnd;
		}
		return comments;
	}
};
registerSingleton(ILanguageConfigurationService, LanguageConfigurationService, 1);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/services/textResourceConfiguration.js
var ITextResourceConfigurationService = createDecorator("textResourceConfigurationService");
var ITextResourcePropertiesService = createDecorator("textResourcePropertiesService");
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/services/languageFeatures.js
var ILanguageFeaturesService = createDecorator("ILanguageFeaturesService");
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/services/completionsEnablement.js
/**
* Get the completions enablement setting name from product configuration.
*/
function getCompletionsEnablementSettingName() {
	return product$1.defaultChatAgent?.completionsEnablementSetting;
}
/**
* Checks if completions (e.g., Copilot) are enabled for a given language ID
* using `ITextResourceConfigurationService`.
*
* @param configurationService The text resource configuration service to read settings from.
* @param modeId The language ID to check. Defaults to '*' which checks the global setting.
* @returns `true` if completions are enabled for the language, `false` otherwise.
*/
function isCompletionsEnabledWithTextResourceConfig(configurationService, resource, modeId = "*") {
	const settingName = getCompletionsEnablementSettingName();
	if (!settingName) return false;
	return isCompletionsEnabledFromObject(configurationService.getValue(resource, settingName), modeId);
}
/**
* Checks if completions are enabled for a given language ID using a pre-fetched
* completions enablement object.
*
* @param completionsEnablementObject The object containing per-language enablement settings.
* @param modeId The language ID to check. Defaults to '*' which checks the global setting.
* @returns `true` if completions are enabled for the language, `false` otherwise.
*/
function isCompletionsEnabledFromObject(completionsEnablementObject, modeId = "*") {
	if (!isObject(completionsEnablementObject)) return false;
	if (typeof completionsEnablementObject[modeId] !== "undefined") return Boolean(completionsEnablementObject[modeId]);
	return Boolean(completionsEnablementObject["*"]);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/services/editorWorkerService.js
var __decorate$79 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$72 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var EditorWorkerService_1;
/**
* Stop the worker if it was not needed for 5 min.
*/
var STOP_WORKER_DELTA_TIME_MS = 3e5;
function canSyncModel(modelService, resource) {
	const model = modelService.getModel(resource);
	if (!model) return false;
	if (model.isTooLargeForSyncing()) return false;
	return true;
}
var EditorWorkerService = class EditorWorkerService extends Disposable {
	static {
		EditorWorkerService_1 = this;
	}
	static {
		this.workerDescriptor = new WebWorkerDescriptor({
			esmModuleLocation: () => FileAccess.asBrowserUri("vs/editor/common/services/editorWebWorkerMain.js"),
			esmModuleLocationBundler: () => new URL("data:text/javascript;base64,aW1wb3J0IHsgYm9vdHN0cmFwV2ViV29ya2VyIH0gZnJvbSAnLi4vLi4vLi4vYmFzZS9jb21tb24vd29ya2VyL3dlYldvcmtlckJvb3RzdHJhcC5qcyc7CmltcG9ydCB7IEVkaXRvcldvcmtlciB9IGZyb20gJy4vZWRpdG9yV2ViV29ya2VyLmpzJzsKCi8qLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tCiAqICBDb3B5cmlnaHQgKGMpIE1pY3Jvc29mdCBDb3Jwb3JhdGlvbi4gQWxsIHJpZ2h0cyByZXNlcnZlZC4KICogIExpY2Vuc2VkIHVuZGVyIHRoZSBNSVQgTGljZW5zZS4gU2VlIExpY2Vuc2UudHh0IGluIHRoZSBwcm9qZWN0IHJvb3QgZm9yIGxpY2Vuc2UgaW5mb3JtYXRpb24uCiAqLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0qLwpib290c3RyYXBXZWJXb3JrZXIoKCkgPT4gbmV3IEVkaXRvcldvcmtlcihudWxsKSk7Cg==", "" + import.meta.url),
			label: "editorWorkerService"
		});
	}
	constructor(modelService, configurationService, logService, _languageConfigurationService, languageFeaturesService, _webWorkerService) {
		super();
		this._languageConfigurationService = _languageConfigurationService;
		this._webWorkerService = _webWorkerService;
		this._modelService = modelService;
		this._workerManager = this._register(new WorkerManager(EditorWorkerService_1.workerDescriptor, this._modelService, this._webWorkerService));
		this._logService = logService;
		this._register(languageFeaturesService.linkProvider.register({
			language: "*",
			hasAccessToAllModels: true
		}, { provideLinks: async (model, token) => {
			if (!canSyncModel(this._modelService, model.uri)) return Promise.resolve({ links: [] });
			const links = await (await this._workerWithResources([model.uri])).$computeLinks(model.uri.toString());
			return links && { links };
		} }));
		this._register(languageFeaturesService.completionProvider.register("*", new WordBasedCompletionItemProvider(this._workerManager, configurationService, this._modelService, this._languageConfigurationService, this._logService, languageFeaturesService)));
	}
	canComputeUnicodeHighlights(uri) {
		return canSyncModel(this._modelService, uri);
	}
	async computedUnicodeHighlights(uri, options, range) {
		return (await this._workerWithResources([uri])).$computeUnicodeHighlights(uri.toString(), options, range);
	}
	async computeDiff(original, modified, options, algorithm) {
		const result = await (await this._workerWithResources([original, modified], true)).$computeDiff(original.toString(), modified.toString(), options, algorithm);
		if (!result) return null;
		return {
			identical: result.identical,
			quitEarly: result.quitEarly,
			changes: toLineRangeMappings(result.changes),
			moves: result.moves.map((m) => new MovedText(new LineRangeMapping(new LineRange(m[0], m[1]), new LineRange(m[2], m[3])), toLineRangeMappings(m[4])))
		};
		function toLineRangeMappings(changes) {
			return changes.map((c) => new DetailedLineRangeMapping(new LineRange(c[0], c[1]), new LineRange(c[2], c[3]), c[4]?.map((c) => new RangeMapping(new Range$2(c[0], c[1], c[2], c[3]), new Range$2(c[4], c[5], c[6], c[7])))));
		}
	}
	async computeMoreMinimalEdits(resource, edits, pretty = false) {
		if (isNonEmptyArray(edits)) {
			if (!canSyncModel(this._modelService, resource)) return Promise.resolve(edits);
			const sw = StopWatch.create();
			const result = this._workerWithResources([resource]).then((worker) => worker.$computeMoreMinimalEdits(resource.toString(), edits, pretty));
			result.finally(() => this._logService.trace("FORMAT#computeMoreMinimalEdits", resource.toString(true), sw.elapsed()));
			return Promise.race([result, timeout(1e3).then(() => edits)]);
		} else return Promise.resolve(void 0);
	}
	canNavigateValueSet(resource) {
		return canSyncModel(this._modelService, resource);
	}
	async navigateValueSet(resource, range, up) {
		const model = this._modelService.getModel(resource);
		if (!model) return null;
		const wordDefRegExp = this._languageConfigurationService.getLanguageConfiguration(model.getLanguageId()).getWordDefinition();
		const wordDef = wordDefRegExp.source;
		const wordDefFlags = wordDefRegExp.flags;
		return (await this._workerWithResources([resource])).$navigateValueSet(resource.toString(), range, up, wordDef, wordDefFlags);
	}
	canComputeWordRanges(resource) {
		return canSyncModel(this._modelService, resource);
	}
	async computeWordRanges(resource, range) {
		const model = this._modelService.getModel(resource);
		if (!model) return Promise.resolve(null);
		const wordDefRegExp = this._languageConfigurationService.getLanguageConfiguration(model.getLanguageId()).getWordDefinition();
		const wordDef = wordDefRegExp.source;
		const wordDefFlags = wordDefRegExp.flags;
		return (await this._workerWithResources([resource])).$computeWordRanges(resource.toString(), range, wordDef, wordDefFlags);
	}
	async findSectionHeaders(uri, options) {
		return (await this._workerWithResources([uri])).$findSectionHeaders(uri.toString(), options);
	}
	async computeDefaultDocumentColors(uri) {
		return (await this._workerWithResources([uri])).$computeDefaultDocumentColors(uri.toString());
	}
	async _workerWithResources(resources, forceLargeModels = false) {
		return await (await this._workerManager.withWorker()).workerWithSyncedResources(resources, forceLargeModels);
	}
};
EditorWorkerService = EditorWorkerService_1 = __decorate$79([
	__param$72(0, IModelService),
	__param$72(1, ITextResourceConfigurationService),
	__param$72(2, ILogService),
	__param$72(3, ILanguageConfigurationService),
	__param$72(4, ILanguageFeaturesService),
	__param$72(5, IWebWorkerService)
], EditorWorkerService);
var WordBasedCompletionItemProvider = class {
	constructor(workerManager, configurationService, modelService, languageConfigurationService, logService, languageFeaturesService) {
		this.languageConfigurationService = languageConfigurationService;
		this.logService = logService;
		this.languageFeaturesService = languageFeaturesService;
		this._debugDisplayName = "wordbasedCompletions";
		this._workerManager = workerManager;
		this._configurationService = configurationService;
		this._modelService = modelService;
	}
	async provideCompletionItems(model, position) {
		const config = this._configurationService.getValue(model.uri, position, "editor");
		if (config.wordBasedSuggestions === "off") return;
		if (config.wordBasedSuggestions === "offWithInlineSuggestions" && this.languageFeaturesService.inlineCompletionsProvider.has(model) && isCompletionsEnabledWithTextResourceConfig(this._configurationService, model.uri, model.getLanguageId())) return;
		const models = [];
		if (config.wordBasedSuggestions === "currentDocument") {
			if (canSyncModel(this._modelService, model.uri)) models.push(model.uri);
		} else for (const candidate of this._modelService.getModels()) {
			if (!canSyncModel(this._modelService, candidate.uri)) continue;
			if (candidate === model) models.unshift(candidate.uri);
			else if (config.wordBasedSuggestions === "allDocuments" || candidate.getLanguageId() === model.getLanguageId()) models.push(candidate.uri);
		}
		if (models.length === 0) return;
		const wordDefRegExp = this.languageConfigurationService.getLanguageConfiguration(model.getLanguageId()).getWordDefinition();
		const word = model.getWordAtPosition(position);
		const replace = !word ? Range$2.fromPositions(position) : new Range$2(position.lineNumber, word.startColumn, position.lineNumber, word.endColumn);
		const insert = replace.setEndPosition(position.lineNumber, position.column);
		this.logService.trace("[WordBasedCompletionItemProvider]", `word: "${word?.word || ""}", wordDef: "${wordDefRegExp}", replace: [${replace.toString()}], insert: [${insert.toString()}]`);
		const data = await (await this._workerManager.withWorker()).textualSuggest(models, word?.word, wordDefRegExp);
		if (!data) return;
		return {
			duration: data.duration,
			suggestions: data.words.map((word) => {
				return {
					kind: 18,
					label: word,
					insertText: word,
					range: {
						insert,
						replace
					}
				};
			})
		};
	}
};
var WorkerManager = class WorkerManager extends Disposable {
	constructor(_workerDescriptor, modelService, webWorkerService) {
		super();
		this._workerDescriptor = _workerDescriptor;
		this._modelService = modelService;
		this._webWorkerService = webWorkerService;
		this._editorWorkerClient = null;
		this._lastWorkerUsedTime = (/* @__PURE__ */ new Date()).getTime();
		this._register(new WindowIntervalTimer()).cancelAndSet(() => this._checkStopIdleWorker(), Math.round(STOP_WORKER_DELTA_TIME_MS / 2), mainWindow);
		this._register(this._modelService.onModelRemoved((_) => this._checkStopEmptyWorker()));
	}
	dispose() {
		if (this._editorWorkerClient) {
			this._editorWorkerClient.dispose();
			this._editorWorkerClient = null;
		}
		super.dispose();
	}
	/**
	* Check if the model service has no more models and stop the worker if that is the case.
	*/
	_checkStopEmptyWorker() {
		if (!this._editorWorkerClient) return;
		if (this._modelService.getModels().length === 0) {
			this._editorWorkerClient.dispose();
			this._editorWorkerClient = null;
		}
	}
	/**
	* Check if the worker has been idle for a while and then stop it.
	*/
	_checkStopIdleWorker() {
		if (!this._editorWorkerClient) return;
		if ((/* @__PURE__ */ new Date()).getTime() - this._lastWorkerUsedTime > STOP_WORKER_DELTA_TIME_MS) {
			this._editorWorkerClient.dispose();
			this._editorWorkerClient = null;
		}
	}
	withWorker() {
		this._lastWorkerUsedTime = (/* @__PURE__ */ new Date()).getTime();
		if (!this._editorWorkerClient) this._editorWorkerClient = new EditorWorkerClient(this._workerDescriptor, false, this._modelService, this._webWorkerService);
		return Promise.resolve(this._editorWorkerClient);
	}
};
WorkerManager = __decorate$79([__param$72(1, IModelService), __param$72(2, IWebWorkerService)], WorkerManager);
var SynchronousWorkerClient = class {
	constructor(instance) {
		this._instance = instance;
		this.proxy = this._instance;
	}
	dispose() {
		this._instance.dispose();
	}
	setChannel(channel, handler) {
		throw new Error(`Not supported`);
	}
};
var EditorWorkerClient = class EditorWorkerClient extends Disposable {
	constructor(_workerDescriptorOrWorker, keepIdleModels, modelService, webWorkerService) {
		super();
		this._workerDescriptorOrWorker = _workerDescriptorOrWorker;
		this._disposed = false;
		this._modelService = modelService;
		this._webWorkerService = webWorkerService;
		this._keepIdleModels = keepIdleModels;
		this._worker = null;
		this._modelManager = null;
	}
	fhr(method, args) {
		throw new Error(`Not implemented!`);
	}
	_getOrCreateWorker() {
		if (!this._worker) try {
			this._worker = this._register(this._webWorkerService.createWorkerClient(this._workerDescriptorOrWorker));
			EditorWorkerHost.setChannel(this._worker, this._createEditorWorkerHost());
		} catch (err) {
			logOnceWebWorkerWarning(err);
			this._worker = this._createFallbackLocalWorker();
		}
		return this._worker;
	}
	async _getProxy() {
		try {
			const proxy = this._getOrCreateWorker().proxy;
			await proxy.$ping();
			return proxy;
		} catch (err) {
			logOnceWebWorkerWarning(err);
			this._worker = this._createFallbackLocalWorker();
			return this._worker.proxy;
		}
	}
	_createFallbackLocalWorker() {
		return new SynchronousWorkerClient(new EditorWorker(null));
	}
	_createEditorWorkerHost() {
		return { $fhr: (method, args) => this.fhr(method, args) };
	}
	_getOrCreateModelManager(proxy) {
		if (!this._modelManager) this._modelManager = this._register(new WorkerTextModelSyncClient(proxy, this._modelService, this._keepIdleModels));
		return this._modelManager;
	}
	async workerWithSyncedResources(resources, forceLargeModels = false) {
		if (this._disposed) return Promise.reject(canceled());
		const proxy = await this._getProxy();
		this._getOrCreateModelManager(proxy).ensureSyncedResources(resources, forceLargeModels);
		return proxy;
	}
	async textualSuggest(resources, leadingWord, wordDefRegExp) {
		const proxy = await this.workerWithSyncedResources(resources);
		const wordDef = wordDefRegExp.source;
		const wordDefFlags = wordDefRegExp.flags;
		return proxy.$textualSuggest(resources.map((r) => r.toString()), leadingWord, wordDef, wordDefFlags);
	}
	dispose() {
		super.dispose();
		this._disposed = true;
	}
};
EditorWorkerClient = __decorate$79([__param$72(2, IModelService), __param$72(3, IWebWorkerService)], EditorWorkerClient);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/standalone/browser/standaloneWebWorker.js
/**
* Create a new web worker that has model syncing capabilities built in.
* Specify an AMD module to load that will `create` an object that will be proxied.
*/
function createWebWorker$1(modelService, webWorkerService, opts) {
	return new MonacoWebWorkerImpl(modelService, webWorkerService, opts);
}
var MonacoWebWorkerImpl = class extends EditorWorkerClient {
	constructor(modelService, webWorkerService, opts) {
		super(opts.worker, opts.keepIdleModels || false, modelService, webWorkerService);
		this._foreignModuleHost = opts.host || null;
		this._foreignProxy = this._getProxy().then((proxy) => {
			return new Proxy({}, { get(target, prop, receiver) {
				if (prop === "then") return;
				if (typeof prop !== "string") throw new Error(`Not supported`);
				return (...args) => {
					return proxy.$fmr(prop, args);
				};
			} });
		});
	}
	fhr(method, args) {
		if (!this._foreignModuleHost || typeof this._foreignModuleHost[method] !== "function") return Promise.reject(/* @__PURE__ */ new Error("Missing method " + method + " or missing main thread foreign host."));
		try {
			return Promise.resolve(this._foreignModuleHost[method].apply(this._foreignModuleHost, args));
		} catch (e) {
			return Promise.reject(e);
		}
	}
	getProxy() {
		return this._foreignProxy;
	}
	withSyncedResources(resources) {
		return this.workerWithSyncedResources(resources).then((_) => this.getProxy());
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/editorCommon.js
/**
* The type of the `IEditor`.
*/
var EditorType = {
	ICodeEditor: "vs.editor.ICodeEditor",
	IDiffEditor: "vs.editor.IDiffEditor"
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/languages/nullTokenize.js
var NullState = new class {
	clone() {
		return this;
	}
	equals(other) {
		return this === other;
	}
}();
function nullTokenize(languageId, state) {
	return new TokenizationResult([new Token$2(0, "", languageId)], state);
}
function nullTokenizeEncoded(languageId, state) {
	const tokens = /* @__PURE__ */ new Uint32Array(2);
	tokens[0] = 0;
	tokens[1] = (languageId << 0 | 33587200) >>> 0;
	return new EncodedTokenizationResult(tokens, [], state === null ? NullState : state);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/trustedTypes.js
function createTrustedTypesPolicy(policyName, policyOptions) {
	const monacoEnvironment = getMonacoEnvironment();
	if (monacoEnvironment?.createTrustedTypesPolicy) try {
		return monacoEnvironment.createTrustedTypesPolicy(policyName, policyOptions);
	} catch (err) {
		onUnexpectedError(err);
		return;
	}
	try {
		return globalThis.trustedTypes?.createPolicy(policyName, policyOptions);
	} catch (err) {
		onUnexpectedError(err);
		return;
	}
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/encodedTokenAttributes.js
/**
*/
var TokenMetadata = class {
	static getLanguageId(metadata) {
		return (metadata & 255) >>> 0;
	}
	static getTokenType(metadata) {
		return (metadata & 768) >>> 8;
	}
	static containsBalancedBrackets(metadata) {
		return (metadata & 1024) !== 0;
	}
	static getFontStyle(metadata) {
		return (metadata & 30720) >>> 11;
	}
	static getForeground(metadata) {
		return (metadata & 16744448) >>> 15;
	}
	static getBackground(metadata) {
		return (metadata & 4278190080) >>> 24;
	}
	static getClassNameFromMetadata(metadata) {
		let className = "mtk" + this.getForeground(metadata);
		const fontStyle = this.getFontStyle(metadata);
		if (fontStyle & 1) className += " mtki";
		if (fontStyle & 2) className += " mtkb";
		if (fontStyle & 4) className += " mtku";
		if (fontStyle & 8) className += " mtks";
		return className;
	}
	static getInlineStyleFromMetadata(metadata, colorMap) {
		const foreground = this.getForeground(metadata);
		const fontStyle = this.getFontStyle(metadata);
		let result = `color: ${colorMap[foreground]};`;
		if (fontStyle & 1) result += "font-style: italic;";
		if (fontStyle & 2) result += "font-weight: bold;";
		let textDecoration = "";
		if (fontStyle & 4) textDecoration += " underline";
		if (fontStyle & 8) textDecoration += " line-through";
		if (textDecoration) result += `text-decoration:${textDecoration};`;
		return result;
	}
	static getPresentationFromMetadata(metadata) {
		const foreground = this.getForeground(metadata);
		const fontStyle = this.getFontStyle(metadata);
		return {
			foreground,
			italic: Boolean(fontStyle & 1),
			bold: Boolean(fontStyle & 2),
			underline: Boolean(fontStyle & 4),
			strikethrough: Boolean(fontStyle & 8)
		};
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/tokens/lineTokens.js
var LineTokens = class LineTokens {
	static createEmpty(lineContent, decoder) {
		const defaultMetadata = LineTokens.defaultTokenMetadata;
		const tokens = /* @__PURE__ */ new Uint32Array(2);
		tokens[0] = lineContent.length;
		tokens[1] = defaultMetadata;
		return new LineTokens(tokens, lineContent, decoder);
	}
	static createFromTextAndMetadata(data, decoder) {
		let offset = 0;
		let fullText = "";
		const tokens = new Array();
		for (const { text, metadata } of data) {
			tokens.push(offset + text.length, metadata);
			offset += text.length;
			fullText += text;
		}
		return new LineTokens(new Uint32Array(tokens), fullText, decoder);
	}
	static convertToEndOffset(tokens, lineTextLength) {
		const lastTokenIndex = (tokens.length >>> 1) - 1;
		for (let tokenIndex = 0; tokenIndex < lastTokenIndex; tokenIndex++) tokens[tokenIndex << 1] = tokens[tokenIndex + 1 << 1];
		tokens[lastTokenIndex << 1] = lineTextLength;
	}
	static findIndexInTokensArray(tokens, desiredIndex) {
		if (tokens.length <= 2) return 0;
		let low = 0;
		let high = (tokens.length >>> 1) - 1;
		while (low < high) {
			const mid = low + Math.floor((high - low) / 2);
			const endOffset = tokens[mid << 1];
			if (endOffset === desiredIndex) return mid + 1;
			else if (endOffset < desiredIndex) low = mid + 1;
			else if (endOffset > desiredIndex) high = mid;
		}
		return low;
	}
	static {
		this.defaultTokenMetadata = 33587200;
	}
	constructor(tokens, text, decoder) {
		this._lineTokensBrand = void 0;
		if ((tokens.length > 1 ? tokens[tokens.length - 2] : 0) !== text.length) onUnexpectedError(/* @__PURE__ */ new Error("Token length and text length do not match!"));
		this._tokens = tokens;
		this._tokensCount = this._tokens.length >>> 1;
		this._text = text;
		this.languageIdCodec = decoder;
	}
	getTextLength() {
		return this._text.length;
	}
	equals(other) {
		if (other instanceof LineTokens) return this.slicedEquals(other, 0, this._tokensCount);
		return false;
	}
	slicedEquals(other, sliceFromTokenIndex, sliceTokenCount) {
		if (this._text !== other._text) return false;
		if (this._tokensCount !== other._tokensCount) return false;
		const from = sliceFromTokenIndex << 1;
		const to = from + (sliceTokenCount << 1);
		for (let i = from; i < to; i++) if (this._tokens[i] !== other._tokens[i]) return false;
		return true;
	}
	getLineContent() {
		return this._text;
	}
	getCount() {
		return this._tokensCount;
	}
	getStartOffset(tokenIndex) {
		if (tokenIndex > 0) return this._tokens[tokenIndex - 1 << 1];
		return 0;
	}
	getMetadata(tokenIndex) {
		return this._tokens[(tokenIndex << 1) + 1];
	}
	getLanguageId(tokenIndex) {
		const metadata = this._tokens[(tokenIndex << 1) + 1];
		const languageId = TokenMetadata.getLanguageId(metadata);
		return this.languageIdCodec.decodeLanguageId(languageId);
	}
	getStandardTokenType(tokenIndex) {
		const metadata = this._tokens[(tokenIndex << 1) + 1];
		return TokenMetadata.getTokenType(metadata);
	}
	getForeground(tokenIndex) {
		const metadata = this._tokens[(tokenIndex << 1) + 1];
		return TokenMetadata.getForeground(metadata);
	}
	getClassName(tokenIndex) {
		const metadata = this._tokens[(tokenIndex << 1) + 1];
		return TokenMetadata.getClassNameFromMetadata(metadata);
	}
	getInlineStyle(tokenIndex, colorMap) {
		const metadata = this._tokens[(tokenIndex << 1) + 1];
		return TokenMetadata.getInlineStyleFromMetadata(metadata, colorMap);
	}
	getPresentation(tokenIndex) {
		const metadata = this._tokens[(tokenIndex << 1) + 1];
		return TokenMetadata.getPresentationFromMetadata(metadata);
	}
	getEndOffset(tokenIndex) {
		return this._tokens[tokenIndex << 1];
	}
	/**
	* Find the token containing offset `offset`.
	* @param offset The search offset
	* @return The index of the token containing the offset.
	*/
	findTokenIndexAtOffset(offset) {
		return LineTokens.findIndexInTokensArray(this._tokens, offset);
	}
	inflate() {
		return this;
	}
	sliceAndInflate(startOffset, endOffset, deltaOffset) {
		return new SliceLineTokens(this, startOffset, endOffset, deltaOffset);
	}
	sliceZeroCopy(range) {
		return this.sliceAndInflate(range.start, range.endExclusive, 0);
	}
	/**
	* @pure
	* @param insertTokens Must be sorted by offset.
	*/
	withInserted(insertTokens) {
		if (insertTokens.length === 0) return this;
		let nextOriginalTokenIdx = 0;
		let nextInsertTokenIdx = 0;
		let text = "";
		const newTokens = new Array();
		let originalEndOffset = 0;
		while (true) {
			const nextOriginalTokenEndOffset = nextOriginalTokenIdx < this._tokensCount ? this._tokens[nextOriginalTokenIdx << 1] : -1;
			const nextInsertToken = nextInsertTokenIdx < insertTokens.length ? insertTokens[nextInsertTokenIdx] : null;
			if (nextOriginalTokenEndOffset !== -1 && (nextInsertToken === null || nextOriginalTokenEndOffset <= nextInsertToken.offset)) {
				text += this._text.substring(originalEndOffset, nextOriginalTokenEndOffset);
				const metadata = this._tokens[(nextOriginalTokenIdx << 1) + 1];
				newTokens.push(text.length, metadata);
				nextOriginalTokenIdx++;
				originalEndOffset = nextOriginalTokenEndOffset;
			} else if (nextInsertToken) {
				if (nextInsertToken.offset > originalEndOffset) {
					text += this._text.substring(originalEndOffset, nextInsertToken.offset);
					const metadata = this._tokens[(nextOriginalTokenIdx << 1) + 1];
					newTokens.push(text.length, metadata);
					originalEndOffset = nextInsertToken.offset;
				}
				text += nextInsertToken.text;
				newTokens.push(text.length, nextInsertToken.tokenMetadata);
				nextInsertTokenIdx++;
			} else break;
		}
		return new LineTokens(new Uint32Array(newTokens), text, this.languageIdCodec);
	}
	getTokensInRange(range) {
		const builder = new TokenArrayBuilder();
		const startTokenIndex = this.findTokenIndexAtOffset(range.start);
		const endTokenIndex = this.findTokenIndexAtOffset(range.endExclusive);
		for (let tokenIndex = startTokenIndex; tokenIndex <= endTokenIndex; tokenIndex++) {
			const length = new OffsetRange(this.getStartOffset(tokenIndex), this.getEndOffset(tokenIndex)).intersectionLength(range);
			if (length > 0) builder.add(length, this.getMetadata(tokenIndex));
		}
		return builder.build();
	}
	getTokenText(tokenIndex) {
		const startOffset = this.getStartOffset(tokenIndex);
		const endOffset = this.getEndOffset(tokenIndex);
		return this._text.substring(startOffset, endOffset);
	}
	forEach(callback) {
		const tokenCount = this.getCount();
		for (let tokenIndex = 0; tokenIndex < tokenCount; tokenIndex++) callback(tokenIndex);
	}
	toString() {
		let result = "";
		this.forEach((i) => {
			result += `[${this.getTokenText(i)}]{${this.getClassName(i)}}`;
		});
		return result;
	}
};
var SliceLineTokens = class SliceLineTokens {
	constructor(source, startOffset, endOffset, deltaOffset) {
		this._source = source;
		this._startOffset = startOffset;
		this._endOffset = endOffset;
		this._deltaOffset = deltaOffset;
		this._firstTokenIndex = source.findTokenIndexAtOffset(startOffset);
		this.languageIdCodec = source.languageIdCodec;
		this._tokensCount = 0;
		for (let i = this._firstTokenIndex, len = source.getCount(); i < len; i++) {
			if (source.getStartOffset(i) >= endOffset) break;
			this._tokensCount++;
		}
	}
	getMetadata(tokenIndex) {
		return this._source.getMetadata(this._firstTokenIndex + tokenIndex);
	}
	getLanguageId(tokenIndex) {
		return this._source.getLanguageId(this._firstTokenIndex + tokenIndex);
	}
	getLineContent() {
		return this._source.getLineContent().substring(this._startOffset, this._endOffset);
	}
	equals(other) {
		if (other instanceof SliceLineTokens) return this._startOffset === other._startOffset && this._endOffset === other._endOffset && this._deltaOffset === other._deltaOffset && this._source.slicedEquals(other._source, this._firstTokenIndex, this._tokensCount);
		return false;
	}
	getCount() {
		return this._tokensCount;
	}
	getStandardTokenType(tokenIndex) {
		return this._source.getStandardTokenType(this._firstTokenIndex + tokenIndex);
	}
	getForeground(tokenIndex) {
		return this._source.getForeground(this._firstTokenIndex + tokenIndex);
	}
	getEndOffset(tokenIndex) {
		const tokenEndOffset = this._source.getEndOffset(this._firstTokenIndex + tokenIndex);
		return Math.min(this._endOffset, tokenEndOffset) - this._startOffset + this._deltaOffset;
	}
	getClassName(tokenIndex) {
		return this._source.getClassName(this._firstTokenIndex + tokenIndex);
	}
	getInlineStyle(tokenIndex, colorMap) {
		return this._source.getInlineStyle(this._firstTokenIndex + tokenIndex, colorMap);
	}
	getPresentation(tokenIndex) {
		return this._source.getPresentation(this._firstTokenIndex + tokenIndex);
	}
	findTokenIndexAtOffset(offset) {
		return this._source.findTokenIndexAtOffset(offset + this._startOffset - this._deltaOffset) - this._firstTokenIndex;
	}
	getTokenText(tokenIndex) {
		const adjustedTokenIndex = this._firstTokenIndex + tokenIndex;
		const tokenStartOffset = this._source.getStartOffset(adjustedTokenIndex);
		const tokenEndOffset = this._source.getEndOffset(adjustedTokenIndex);
		let text = this._source.getTokenText(adjustedTokenIndex);
		if (tokenStartOffset < this._startOffset) text = text.substring(this._startOffset - tokenStartOffset);
		if (tokenEndOffset > this._endOffset) text = text.substring(0, text.length - (tokenEndOffset - this._endOffset));
		return text;
	}
	forEach(callback) {
		for (let tokenIndex = 0; tokenIndex < this.getCount(); tokenIndex++) callback(tokenIndex);
	}
};
function getStandardTokenTypeAtPosition(model, position) {
	const lineNumber = position.lineNumber;
	if (!model.tokenization.isCheapToTokenize(lineNumber)) return;
	model.tokenization.forceTokenization(lineNumber);
	const lineTokens = model.tokenization.getLineTokens(lineNumber);
	const tokenIndex = lineTokens.findTokenIndexAtOffset(position.column - 1);
	return lineTokens.getStandardTokenType(tokenIndex);
}
/**
* This class represents a sequence of tokens.
* Conceptually, each token has a length and a metadata number.
* A token array might be used to annotate a string with metadata.
* Use {@link TokenArrayBuilder} to efficiently create a token array.
*
* TODO: Make this class more efficient (e.g. by using a Int32Array).
*/
var TokenArray = class TokenArray {
	static fromLineTokens(lineTokens) {
		const tokenInfo = [];
		for (let i = 0; i < lineTokens.getCount(); i++) tokenInfo.push(new TokenInfo(lineTokens.getEndOffset(i) - lineTokens.getStartOffset(i), lineTokens.getMetadata(i)));
		return TokenArray.create(tokenInfo);
	}
	static create(tokenInfo) {
		return new TokenArray(tokenInfo);
	}
	constructor(_tokenInfo) {
		this._tokenInfo = _tokenInfo;
	}
	toLineTokens(lineContent, decoder) {
		return LineTokens.createFromTextAndMetadata(this.map((r, t) => ({
			text: r.substring(lineContent),
			metadata: t.metadata
		})), decoder);
	}
	forEach(cb) {
		let lengthSum = 0;
		for (const tokenInfo of this._tokenInfo) {
			cb(new OffsetRange(lengthSum, lengthSum + tokenInfo.length), tokenInfo);
			lengthSum += tokenInfo.length;
		}
	}
	map(cb) {
		const result = [];
		let lengthSum = 0;
		for (const tokenInfo of this._tokenInfo) {
			const range = new OffsetRange(lengthSum, lengthSum + tokenInfo.length);
			result.push(cb(range, tokenInfo));
			lengthSum += tokenInfo.length;
		}
		return result;
	}
	slice(range) {
		const result = [];
		let lengthSum = 0;
		for (const tokenInfo of this._tokenInfo) {
			const tokenStart = lengthSum;
			const tokenEndEx = tokenStart + tokenInfo.length;
			if (tokenEndEx > range.start) {
				if (tokenStart >= range.endExclusive) break;
				const deltaBefore = Math.max(0, range.start - tokenStart);
				const deltaAfter = Math.max(0, tokenEndEx - range.endExclusive);
				result.push(new TokenInfo(tokenInfo.length - deltaBefore - deltaAfter, tokenInfo.metadata));
			}
			lengthSum += tokenInfo.length;
		}
		return TokenArray.create(result);
	}
};
var TokenInfo = class {
	constructor(length, metadata) {
		this.length = length;
		this.metadata = metadata;
	}
};
/**
* TODO: Make this class more efficient (e.g. by using a Int32Array).
*/
var TokenArrayBuilder = class {
	constructor() {
		this._tokens = [];
	}
	add(length, metadata) {
		this._tokens.push(new TokenInfo(length, metadata));
	}
	build() {
		return TokenArray.create(this._tokens);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/viewLayout/lineDecorations.js
var LineDecoration = class LineDecoration {
	constructor(startColumn, endColumn, className, type) {
		this.startColumn = startColumn;
		this.endColumn = endColumn;
		this.className = className;
		this.type = type;
		this._lineDecorationBrand = void 0;
	}
	static _equals(a, b) {
		return a.startColumn === b.startColumn && a.endColumn === b.endColumn && a.className === b.className && a.type === b.type;
	}
	static equalsArr(a, b) {
		const aLen = a.length;
		if (aLen !== b.length) return false;
		for (let i = 0; i < aLen; i++) if (!LineDecoration._equals(a[i], b[i])) return false;
		return true;
	}
	static extractWrapped(arr, startOffset, endOffset) {
		if (arr.length === 0) return arr;
		const startColumn = startOffset + 1;
		const endColumn = endOffset + 1;
		const lineLength = endOffset - startOffset;
		const r = [];
		let rLength = 0;
		for (const dec of arr) {
			if (dec.endColumn <= startColumn || dec.startColumn >= endColumn) continue;
			r[rLength++] = new LineDecoration(Math.max(1, dec.startColumn - startColumn + 1), Math.min(lineLength + 1, dec.endColumn - startColumn + 1), dec.className, dec.type);
		}
		return r;
	}
	static filter(lineDecorations, lineNumber, minLineColumn, maxLineColumn) {
		if (lineDecorations.length === 0) return [];
		const result = [];
		let resultLen = 0;
		for (let i = 0, len = lineDecorations.length; i < len; i++) {
			const d = lineDecorations[i];
			const range = d.range;
			if (range.endLineNumber < lineNumber || range.startLineNumber > lineNumber) continue;
			if (range.isEmpty() && (d.type === 0 || d.type === 3)) continue;
			const startColumn = range.startLineNumber === lineNumber ? range.startColumn : minLineColumn;
			const endColumn = range.endLineNumber === lineNumber ? range.endColumn : maxLineColumn;
			result[resultLen++] = new LineDecoration(startColumn, endColumn, d.inlineClassName, d.type);
		}
		return result;
	}
	static _typeCompare(a, b) {
		const ORDER = [
			3,
			1,
			2,
			4,
			0
		];
		return ORDER[a] - ORDER[b];
	}
	static compare(a, b) {
		if (a.startColumn !== b.startColumn) return a.startColumn - b.startColumn;
		if (a.endColumn !== b.endColumn) return a.endColumn - b.endColumn;
		const typeCmp = LineDecoration._typeCompare(a.type, b.type);
		if (typeCmp !== 0) return typeCmp;
		if (a.className !== b.className) return a.className < b.className ? -1 : 1;
		return 0;
	}
};
var DecorationSegment = class {
	constructor(startOffset, endOffset, className, metadata) {
		this.startOffset = startOffset;
		this.endOffset = endOffset;
		this.className = className;
		this.metadata = metadata;
	}
};
var Stack = class Stack {
	constructor() {
		this.stopOffsets = [];
		this.classNames = [];
		this.metadata = [];
		this.count = 0;
	}
	static _metadata(metadata) {
		let result = 0;
		for (let i = 0, len = metadata.length; i < len; i++) result |= metadata[i];
		return result;
	}
	consumeLowerThan(maxStopOffset, nextStartOffset, result) {
		while (this.count > 0 && this.stopOffsets[0] < maxStopOffset) {
			let i = 0;
			while (i + 1 < this.count && this.stopOffsets[i] === this.stopOffsets[i + 1]) i++;
			result.push(new DecorationSegment(nextStartOffset, this.stopOffsets[i], this.classNames.join(" "), Stack._metadata(this.metadata)));
			nextStartOffset = this.stopOffsets[i] + 1;
			this.stopOffsets.splice(0, i + 1);
			this.classNames.splice(0, i + 1);
			this.metadata.splice(0, i + 1);
			this.count -= i + 1;
		}
		if (this.count > 0 && nextStartOffset < maxStopOffset) {
			result.push(new DecorationSegment(nextStartOffset, maxStopOffset - 1, this.classNames.join(" "), Stack._metadata(this.metadata)));
			nextStartOffset = maxStopOffset;
		}
		return nextStartOffset;
	}
	insert(stopOffset, className, metadata) {
		if (this.count === 0 || this.stopOffsets[this.count - 1] <= stopOffset) {
			this.stopOffsets.push(stopOffset);
			this.classNames.push(className);
			this.metadata.push(metadata);
		} else for (let i = 0; i < this.count; i++) if (this.stopOffsets[i] >= stopOffset) {
			this.stopOffsets.splice(i, 0, stopOffset);
			this.classNames.splice(i, 0, className);
			this.metadata.splice(i, 0, metadata);
			break;
		}
		this.count++;
	}
};
var LineDecorationsNormalizer = class {
	/**
	* Normalize line decorations. Overlapping decorations will generate multiple segments
	*/
	static normalize(lineContent, lineDecorations) {
		if (lineDecorations.length === 0) return [];
		const result = [];
		const stack = new Stack();
		let nextStartOffset = 0;
		for (let i = 0, len = lineDecorations.length; i < len; i++) {
			const d = lineDecorations[i];
			let startColumn = d.startColumn;
			let endColumn = d.endColumn;
			const className = d.className;
			const metadata = d.type === 1 ? 2 : d.type === 2 ? 4 : 0;
			if (startColumn > 1) {
				const charCodeBefore = lineContent.charCodeAt(startColumn - 2);
				if (isHighSurrogate(charCodeBefore)) startColumn--;
			}
			if (endColumn > 1) {
				const charCodeBefore = lineContent.charCodeAt(endColumn - 2);
				if (isHighSurrogate(charCodeBefore)) endColumn--;
			}
			const currentStartOffset = startColumn - 1;
			const currentEndOffset = endColumn - 2;
			nextStartOffset = stack.consumeLowerThan(currentStartOffset, nextStartOffset, result);
			if (stack.count === 0) nextStartOffset = currentStartOffset;
			stack.insert(currentEndOffset, className, metadata);
		}
		stack.consumeLowerThan(1073741824, nextStartOffset, result);
		return result;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/viewLayout/linePart.js
var LinePart = class {
	constructor(endIndex, type, metadata, containsRTL) {
		this.endIndex = endIndex;
		this.type = type;
		this.metadata = metadata;
		this.containsRTL = containsRTL;
		this._linePartBrand = void 0;
	}
	isWhitespace() {
		return this.metadata & 1 ? true : false;
	}
	isPseudoAfter() {
		return this.metadata & 4 ? true : false;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/viewLayout/viewLineRenderer.js
var RenderLineInput = class {
	get isLTR() {
		return !this.containsRTL && this.textDirection !== TextDirection.RTL;
	}
	constructor(useMonospaceOptimizations, canUseHalfwidthRightwardsArrow, lineContent, continuesWithWrappedLine, isBasicASCII, containsRTL, fauxIndentLength, lineTokens, lineDecorations, tabSize, startVisibleColumn, spaceWidth, middotWidth, wsmiddotWidth, stopRenderingLineAfter, renderWhitespace, renderControlCharacters, fontLigatures, selectionsOnLine, textDirection, verticalScrollbarSize, renderNewLineWhenEmpty = false, useTwoCellFullwidthCharacters = false) {
		this.useMonospaceOptimizations = useMonospaceOptimizations;
		this.canUseHalfwidthRightwardsArrow = canUseHalfwidthRightwardsArrow;
		this.lineContent = lineContent;
		this.continuesWithWrappedLine = continuesWithWrappedLine;
		this.isBasicASCII = isBasicASCII;
		this.containsRTL = containsRTL;
		this.fauxIndentLength = fauxIndentLength;
		this.lineTokens = lineTokens;
		this.lineDecorations = lineDecorations.sort(LineDecoration.compare);
		this.tabSize = tabSize;
		this.startVisibleColumn = startVisibleColumn;
		this.spaceWidth = spaceWidth;
		this.stopRenderingLineAfter = stopRenderingLineAfter;
		this.renderWhitespace = renderWhitespace === "all" ? 4 : renderWhitespace === "boundary" ? 1 : renderWhitespace === "selection" ? 2 : renderWhitespace === "trailing" ? 3 : 0;
		this.renderControlCharacters = renderControlCharacters;
		this.fontLigatures = fontLigatures;
		this.selectionsOnLine = selectionsOnLine && selectionsOnLine.sort((a, b) => a.start < b.start ? -1 : 1);
		this.renderNewLineWhenEmpty = renderNewLineWhenEmpty;
		this.useTwoCellFullwidthCharacters = useTwoCellFullwidthCharacters;
		this.textDirection = textDirection;
		this.verticalScrollbarSize = verticalScrollbarSize;
		if (Math.abs(wsmiddotWidth - spaceWidth) < Math.abs(middotWidth - spaceWidth)) {
			this.renderSpaceWidth = wsmiddotWidth;
			this.renderSpaceCharCode = 11825;
		} else {
			this.renderSpaceWidth = middotWidth;
			this.renderSpaceCharCode = 183;
		}
	}
	sameSelection(otherSelections) {
		if (this.selectionsOnLine === null) return otherSelections === null;
		if (otherSelections === null) return false;
		if (otherSelections.length !== this.selectionsOnLine.length) return false;
		for (let i = 0; i < this.selectionsOnLine.length; i++) if (!this.selectionsOnLine[i].equals(otherSelections[i])) return false;
		return true;
	}
	equals(other) {
		return this.useMonospaceOptimizations === other.useMonospaceOptimizations && this.canUseHalfwidthRightwardsArrow === other.canUseHalfwidthRightwardsArrow && this.lineContent === other.lineContent && this.continuesWithWrappedLine === other.continuesWithWrappedLine && this.isBasicASCII === other.isBasicASCII && this.containsRTL === other.containsRTL && this.fauxIndentLength === other.fauxIndentLength && this.tabSize === other.tabSize && this.startVisibleColumn === other.startVisibleColumn && this.spaceWidth === other.spaceWidth && this.renderSpaceWidth === other.renderSpaceWidth && this.renderSpaceCharCode === other.renderSpaceCharCode && this.stopRenderingLineAfter === other.stopRenderingLineAfter && this.renderWhitespace === other.renderWhitespace && this.renderControlCharacters === other.renderControlCharacters && this.fontLigatures === other.fontLigatures && LineDecoration.equalsArr(this.lineDecorations, other.lineDecorations) && this.lineTokens.equals(other.lineTokens) && this.sameSelection(other.selectionsOnLine) && this.textDirection === other.textDirection && this.verticalScrollbarSize === other.verticalScrollbarSize && this.renderNewLineWhenEmpty === other.renderNewLineWhenEmpty && this.useTwoCellFullwidthCharacters === other.useTwoCellFullwidthCharacters;
	}
};
var DomPosition = class {
	constructor(partIndex, charIndex) {
		this.partIndex = partIndex;
		this.charIndex = charIndex;
	}
};
/**
* Provides a both direction mapping between a line's character and its rendered position.
*/
var CharacterMapping = class CharacterMapping {
	static getPartIndex(partData) {
		return (partData & 4294901760) >>> 16;
	}
	static getCharIndex(partData) {
		return (partData & 65535) >>> 0;
	}
	constructor(length, partCount) {
		this.length = length;
		this._data = new Uint32Array(this.length);
		this._horizontalOffset = new Uint32Array(this.length);
	}
	setColumnInfo(column, partIndex, charIndex, horizontalOffset) {
		const partData = (partIndex << 16 | charIndex << 0) >>> 0;
		this._data[column - 1] = partData;
		this._horizontalOffset[column - 1] = horizontalOffset;
	}
	getHorizontalOffset(column) {
		if (this._horizontalOffset.length === 0) return 0;
		return this._horizontalOffset[column - 1];
	}
	charOffsetToPartData(charOffset) {
		if (this.length === 0) return 0;
		if (charOffset < 0) return this._data[0];
		if (charOffset >= this.length) return this._data[this.length - 1];
		return this._data[charOffset];
	}
	getDomPosition(column) {
		const partData = this.charOffsetToPartData(column - 1);
		return new DomPosition(CharacterMapping.getPartIndex(partData), CharacterMapping.getCharIndex(partData));
	}
	getColumn(domPosition, partLength) {
		return this.partDataToCharOffset(domPosition.partIndex, partLength, domPosition.charIndex) + 1;
	}
	partDataToCharOffset(partIndex, partLength, charIndex) {
		if (this.length === 0) return 0;
		const searchEntry = (partIndex << 16 | charIndex << 0) >>> 0;
		let min = 0;
		let max = this.length - 1;
		while (min + 1 < max) {
			const mid = min + max >>> 1;
			const midEntry = this._data[mid];
			if (midEntry === searchEntry) return mid;
			else if (midEntry > searchEntry) max = mid;
			else min = mid;
		}
		if (min === max) return min;
		const minEntry = this._data[min];
		const maxEntry = this._data[max];
		if (minEntry === searchEntry) return min;
		if (maxEntry === searchEntry) return max;
		const minPartIndex = CharacterMapping.getPartIndex(minEntry);
		const minCharIndex = CharacterMapping.getCharIndex(minEntry);
		const maxPartIndex = CharacterMapping.getPartIndex(maxEntry);
		let maxCharIndex;
		if (minPartIndex !== maxPartIndex) maxCharIndex = partLength;
		else maxCharIndex = CharacterMapping.getCharIndex(maxEntry);
		if (charIndex - minCharIndex <= maxCharIndex - charIndex) return min;
		return max;
	}
};
var RenderLineOutput = class {
	constructor(characterMapping, containsForeignElements) {
		this._renderLineOutputBrand = void 0;
		this.characterMapping = characterMapping;
		this.containsForeignElements = containsForeignElements;
	}
};
function renderViewLine(input, sb) {
	if (input.lineContent.length === 0) {
		if (input.lineDecorations.length > 0) {
			sb.appendString(`<span>`);
			let beforeCount = 0;
			let afterCount = 0;
			let containsForeignElements = 0;
			for (const lineDecoration of input.lineDecorations) if (lineDecoration.type === 1 || lineDecoration.type === 2 || lineDecoration.type === 4) {
				sb.appendString(`<span class="`);
				sb.appendString(lineDecoration.className);
				sb.appendString(`"></span>`);
				if (lineDecoration.type === 2) {
					containsForeignElements |= 2;
					afterCount++;
				} else {
					containsForeignElements |= 1;
					beforeCount++;
				}
			}
			sb.appendString(`</span>`);
			const characterMapping = new CharacterMapping(1, beforeCount + afterCount);
			characterMapping.setColumnInfo(1, beforeCount, 0, 0);
			return new RenderLineOutput(characterMapping, containsForeignElements);
		}
		if (input.renderNewLineWhenEmpty) sb.appendString("<span><span>\n</span></span>");
		else sb.appendString("<span><span></span></span>");
		return new RenderLineOutput(new CharacterMapping(0, 0), 0);
	}
	return _renderLine(resolveRenderLineInput(input), sb);
}
var RenderLineOutput2 = class {
	constructor(characterMapping, html, containsForeignElements) {
		this.characterMapping = characterMapping;
		this.html = html;
		this.containsForeignElements = containsForeignElements;
	}
};
function renderViewLine2(input) {
	const sb = new StringBuilder(1e4);
	const out = renderViewLine(input, sb);
	return new RenderLineOutput2(out.characterMapping, sb.build(), out.containsForeignElements);
}
var ResolvedRenderLineInput = class {
	constructor(fontIsMonospace, canUseHalfwidthRightwardsArrow, lineContent, len, isOverflowing, overflowingCharCount, parts, containsForeignElements, fauxIndentLength, tabSize, startVisibleColumn, spaceWidth, renderSpaceCharCode, renderWhitespace, renderControlCharacters, useTwoCellFullwidthCharacters) {
		this.fontIsMonospace = fontIsMonospace;
		this.canUseHalfwidthRightwardsArrow = canUseHalfwidthRightwardsArrow;
		this.lineContent = lineContent;
		this.len = len;
		this.isOverflowing = isOverflowing;
		this.overflowingCharCount = overflowingCharCount;
		this.parts = parts;
		this.containsForeignElements = containsForeignElements;
		this.fauxIndentLength = fauxIndentLength;
		this.tabSize = tabSize;
		this.startVisibleColumn = startVisibleColumn;
		this.spaceWidth = spaceWidth;
		this.renderSpaceCharCode = renderSpaceCharCode;
		this.renderWhitespace = renderWhitespace;
		this.renderControlCharacters = renderControlCharacters;
		this.useTwoCellFullwidthCharacters = useTwoCellFullwidthCharacters;
	}
};
function resolveRenderLineInput(input) {
	const lineContent = input.lineContent;
	let isOverflowing;
	let overflowingCharCount;
	let len;
	if (input.stopRenderingLineAfter !== -1 && input.stopRenderingLineAfter < lineContent.length) {
		isOverflowing = true;
		overflowingCharCount = lineContent.length - input.stopRenderingLineAfter;
		len = input.stopRenderingLineAfter;
	} else {
		isOverflowing = false;
		overflowingCharCount = 0;
		len = lineContent.length;
	}
	let tokens = transformAndRemoveOverflowing(lineContent, input.containsRTL, input.lineTokens, input.fauxIndentLength, len);
	if (input.renderControlCharacters && !input.isBasicASCII) tokens = extractControlCharacters(lineContent, tokens);
	if (input.renderWhitespace === 4 || input.renderWhitespace === 1 || input.renderWhitespace === 2 && !!input.selectionsOnLine || input.renderWhitespace === 3 && !input.continuesWithWrappedLine) tokens = _applyRenderWhitespace(input, lineContent, len, tokens);
	let containsForeignElements = 0;
	if (input.lineDecorations.length > 0) {
		for (let i = 0, len = input.lineDecorations.length; i < len; i++) {
			const lineDecoration = input.lineDecorations[i];
			if (lineDecoration.type === 3) containsForeignElements |= 1;
			else if (lineDecoration.type === 1) containsForeignElements |= 1;
			else if (lineDecoration.type === 2) containsForeignElements |= 2;
			else if (lineDecoration.type === 4) containsForeignElements |= 1;
		}
		tokens = _applyInlineDecorations(lineContent, len, tokens, input.lineDecorations);
	}
	if (!input.containsRTL) tokens = splitLargeTokens(lineContent, tokens, !input.isBasicASCII || input.fontLigatures);
	else tokens = splitLeadingWhitespaceFromRTL(lineContent, tokens);
	if (input.useTwoCellFullwidthCharacters) tokens = splitFullWidthCharacters(lineContent, tokens);
	return new ResolvedRenderLineInput(input.useMonospaceOptimizations, input.canUseHalfwidthRightwardsArrow, lineContent, len, isOverflowing, overflowingCharCount, tokens, containsForeignElements, input.fauxIndentLength, input.tabSize, input.startVisibleColumn, input.spaceWidth, input.renderSpaceCharCode, input.renderWhitespace, input.renderControlCharacters, input.useTwoCellFullwidthCharacters);
}
/** Splits parts such that every full-width character ends up in a part of its own. */
function splitFullWidthCharacters(lineContent, parts) {
	const result = [];
	let startOffset = 0;
	for (const part of parts) {
		let didSplit = false;
		for (let offset = startOffset; offset < part.endIndex; offset++) {
			if (!isFullWidthCharacter(lineContent.charCodeAt(offset))) continue;
			if (offset > startOffset) result.push(new LinePart(offset, part.type, part.metadata, part.containsRTL));
			result.push(new LinePart(offset + 1, part.type, part.metadata, part.containsRTL));
			startOffset = offset + 1;
			didSplit = true;
		}
		if (!didSplit || part.endIndex > startOffset) result.push(part);
		startOffset = part.endIndex;
	}
	return result;
}
/**
* In the rendering phase, characters are always looped until token.endIndex.
* Ensure that all tokens end before `len` and the last one ends precisely at `len`.
*/
function transformAndRemoveOverflowing(lineContent, lineContainsRTL, tokens, fauxIndentLength, len) {
	const result = [];
	let resultLen = 0;
	if (fauxIndentLength > 0) result[resultLen++] = new LinePart(fauxIndentLength, "", 0, false);
	let startOffset = fauxIndentLength;
	for (let tokenIndex = 0, tokensLen = tokens.getCount(); tokenIndex < tokensLen; tokenIndex++) {
		const endIndex = tokens.getEndOffset(tokenIndex);
		if (endIndex <= fauxIndentLength) continue;
		const type = tokens.getClassName(tokenIndex);
		if (endIndex >= len) {
			const tokenContainsRTL = lineContainsRTL ? containsRTL(lineContent.substring(startOffset, len)) : false;
			result[resultLen++] = new LinePart(len, type, 0, tokenContainsRTL);
			break;
		}
		const tokenContainsRTL = lineContainsRTL ? containsRTL(lineContent.substring(startOffset, endIndex)) : false;
		result[resultLen++] = new LinePart(endIndex, type, 0, tokenContainsRTL);
		startOffset = endIndex;
	}
	return result;
}
/**
* See https://github.com/microsoft/vscode/issues/6885.
* It appears that having very large spans causes very slow reading of character positions.
* So here we try to avoid that.
*/
function splitLargeTokens(lineContent, tokens, onlyAtSpaces) {
	let lastTokenEndIndex = 0;
	const result = [];
	let resultLen = 0;
	if (onlyAtSpaces) for (let i = 0, len = tokens.length; i < len; i++) {
		const token = tokens[i];
		const tokenEndIndex = token.endIndex;
		if (lastTokenEndIndex + 50 < tokenEndIndex) {
			const tokenType = token.type;
			const tokenMetadata = token.metadata;
			const tokenContainsRTL = token.containsRTL;
			let lastSpaceOffset = -1;
			let currTokenStart = lastTokenEndIndex;
			for (let j = lastTokenEndIndex; j < tokenEndIndex; j++) {
				if (lineContent.charCodeAt(j) === 32) lastSpaceOffset = j;
				if (lastSpaceOffset !== -1 && j - currTokenStart >= 50) {
					result[resultLen++] = new LinePart(lastSpaceOffset + 1, tokenType, tokenMetadata, tokenContainsRTL);
					currTokenStart = lastSpaceOffset + 1;
					lastSpaceOffset = -1;
				}
			}
			if (currTokenStart !== tokenEndIndex) result[resultLen++] = new LinePart(tokenEndIndex, tokenType, tokenMetadata, tokenContainsRTL);
		} else result[resultLen++] = token;
		lastTokenEndIndex = tokenEndIndex;
	}
	else for (let i = 0, len = tokens.length; i < len; i++) {
		const token = tokens[i];
		const tokenEndIndex = token.endIndex;
		const diff = tokenEndIndex - lastTokenEndIndex;
		if (diff > 50) {
			const tokenType = token.type;
			const tokenMetadata = token.metadata;
			const tokenContainsRTL = token.containsRTL;
			const piecesCount = Math.ceil(diff / 50);
			for (let j = 1; j < piecesCount; j++) {
				const pieceEndIndex = lastTokenEndIndex + j * 50;
				result[resultLen++] = new LinePart(pieceEndIndex, tokenType, tokenMetadata, tokenContainsRTL);
			}
			result[resultLen++] = new LinePart(tokenEndIndex, tokenType, tokenMetadata, tokenContainsRTL);
		} else result[resultLen++] = token;
		lastTokenEndIndex = tokenEndIndex;
	}
	return result;
}
/**
* Splits leading whitespace from the first token if it contains RTL text.
*/
function splitLeadingWhitespaceFromRTL(lineContent, tokens) {
	if (tokens.length === 0) return tokens;
	const firstToken = tokens[0];
	if (!firstToken.containsRTL) return tokens;
	const firstTokenEndIndex = firstToken.endIndex;
	let firstNonWhitespaceIndex = 0;
	for (let i = 0; i < firstTokenEndIndex; i++) {
		const charCode = lineContent.charCodeAt(i);
		if (charCode !== 32 && charCode !== 9) {
			firstNonWhitespaceIndex = i;
			break;
		}
	}
	if (firstNonWhitespaceIndex === 0) return tokens;
	const result = [];
	result.push(new LinePart(firstNonWhitespaceIndex, firstToken.type, firstToken.metadata, false));
	result.push(new LinePart(firstTokenEndIndex, firstToken.type, firstToken.metadata, firstToken.containsRTL));
	for (let i = 1; i < tokens.length; i++) result.push(tokens[i]);
	return result;
}
function isControlCharacter(charCode) {
	if (charCode < 32) return charCode !== 9;
	if (charCode === 127) return true;
	if (charCode >= 8234 && charCode <= 8238 || charCode >= 8294 && charCode <= 8297 || charCode >= 8206 && charCode <= 8207 || charCode === 1564) return true;
	return false;
}
function extractControlCharacters(lineContent, tokens) {
	const result = [];
	let lastLinePart = new LinePart(0, "", 0, false);
	let charOffset = 0;
	for (const token of tokens) {
		const tokenEndIndex = token.endIndex;
		for (; charOffset < tokenEndIndex; charOffset++) if (isControlCharacter(lineContent.charCodeAt(charOffset))) {
			if (charOffset > lastLinePart.endIndex) {
				lastLinePart = new LinePart(charOffset, token.type, token.metadata, token.containsRTL);
				result.push(lastLinePart);
			}
			lastLinePart = new LinePart(charOffset + 1, "mtkcontrol", token.metadata, false);
			result.push(lastLinePart);
		}
		if (charOffset > lastLinePart.endIndex) {
			lastLinePart = new LinePart(tokenEndIndex, token.type, token.metadata, token.containsRTL);
			result.push(lastLinePart);
		}
	}
	return result;
}
/**
* Whitespace is rendered by "replacing" tokens with a special-purpose `mtkw` type that is later recognized in the rendering phase.
* Moreover, a token is created for every visual indent because on some fonts the glyphs used for rendering whitespace (&rarr; or &middot;) do not have the same width as &nbsp;.
* The rendering phase will generate `style="width:..."` for these tokens.
*/
function _applyRenderWhitespace(input, lineContent, len, tokens) {
	const continuesWithWrappedLine = input.continuesWithWrappedLine;
	const fauxIndentLength = input.fauxIndentLength;
	const tabSize = input.tabSize;
	const startVisibleColumn = input.startVisibleColumn;
	const useMonospaceOptimizations = input.useMonospaceOptimizations;
	const selections = input.selectionsOnLine;
	const onlyBoundary = input.renderWhitespace === 1;
	const onlyTrailing = input.renderWhitespace === 3;
	const generateLinePartForEachWhitespace = input.renderSpaceWidth !== input.spaceWidth;
	const result = [];
	let resultLen = 0;
	let tokenIndex = 0;
	let tokenType = tokens[tokenIndex].type;
	let tokenContainsRTL = tokens[tokenIndex].containsRTL;
	let tokenEndIndex = tokens[tokenIndex].endIndex;
	const tokensLength = tokens.length;
	let lineIsEmptyOrWhitespace = false;
	let firstNonWhitespaceIndex$1 = firstNonWhitespaceIndex(lineContent);
	let lastNonWhitespaceIndex$1;
	if (firstNonWhitespaceIndex$1 === -1) {
		lineIsEmptyOrWhitespace = true;
		firstNonWhitespaceIndex$1 = len;
		lastNonWhitespaceIndex$1 = len;
	} else lastNonWhitespaceIndex$1 = lastNonWhitespaceIndex(lineContent);
	let wasInWhitespace = false;
	let currentSelectionIndex = 0;
	let currentSelection = selections && selections[currentSelectionIndex];
	let tmpIndent = startVisibleColumn % tabSize;
	for (let charIndex = fauxIndentLength; charIndex < len; charIndex++) {
		const chCode = lineContent.charCodeAt(charIndex);
		if (currentSelection && currentSelection.endExclusive <= charIndex) {
			currentSelectionIndex++;
			currentSelection = selections && selections[currentSelectionIndex];
		}
		let isInWhitespace;
		if (charIndex < firstNonWhitespaceIndex$1 || charIndex > lastNonWhitespaceIndex$1) isInWhitespace = true;
		else if (chCode === 9) isInWhitespace = true;
		else if (chCode === 32) {
			if (onlyBoundary) {
				if (wasInWhitespace) isInWhitespace = true;
				else {
					const nextChCode = charIndex + 1 < len ? lineContent.charCodeAt(charIndex + 1) : 0;
					isInWhitespace = nextChCode === 32 || nextChCode === 9;
				}
			} else isInWhitespace = true;
		} else isInWhitespace = false;
		if (isInWhitespace && selections) isInWhitespace = !!currentSelection && currentSelection.start <= charIndex && charIndex < currentSelection.endExclusive;
		if (isInWhitespace && onlyTrailing) isInWhitespace = lineIsEmptyOrWhitespace || charIndex > lastNonWhitespaceIndex$1;
		if (isInWhitespace && tokenContainsRTL) {
			if (charIndex >= firstNonWhitespaceIndex$1 && charIndex <= lastNonWhitespaceIndex$1) isInWhitespace = false;
		}
		if (wasInWhitespace) {
			if (!isInWhitespace || !useMonospaceOptimizations && tmpIndent >= tabSize) {
				if (generateLinePartForEachWhitespace) {
					const lastEndIndex = resultLen > 0 ? result[resultLen - 1].endIndex : fauxIndentLength;
					for (let i = lastEndIndex + 1; i <= charIndex; i++) result[resultLen++] = new LinePart(i, "mtkw", 1, false);
				} else result[resultLen++] = new LinePart(charIndex, "mtkw", 1, false);
				tmpIndent = tmpIndent % tabSize;
			}
		} else if (charIndex === tokenEndIndex || isInWhitespace && charIndex > fauxIndentLength) {
			result[resultLen++] = new LinePart(charIndex, tokenType, 0, tokenContainsRTL);
			tmpIndent = tmpIndent % tabSize;
		}
		if (chCode === 9) tmpIndent = tabSize;
		else if (isFullWidthCharacter(chCode)) tmpIndent += 2;
		else tmpIndent++;
		wasInWhitespace = isInWhitespace;
		while (charIndex === tokenEndIndex) {
			tokenIndex++;
			if (tokenIndex < tokensLength) {
				tokenType = tokens[tokenIndex].type;
				tokenContainsRTL = tokens[tokenIndex].containsRTL;
				tokenEndIndex = tokens[tokenIndex].endIndex;
			} else break;
		}
	}
	let generateWhitespace = false;
	if (wasInWhitespace) {
		if (continuesWithWrappedLine && onlyBoundary) {
			const lastCharCode = len > 0 ? lineContent.charCodeAt(len - 1) : 0;
			const prevCharCode = len > 1 ? lineContent.charCodeAt(len - 2) : 0;
			if (!(lastCharCode === 32 && prevCharCode !== 32 && prevCharCode !== 9)) generateWhitespace = true;
		} else generateWhitespace = true;
	}
	if (generateWhitespace) {
		if (generateLinePartForEachWhitespace) {
			const lastEndIndex = resultLen > 0 ? result[resultLen - 1].endIndex : fauxIndentLength;
			for (let i = lastEndIndex + 1; i <= len; i++) result[resultLen++] = new LinePart(i, "mtkw", 1, false);
		} else result[resultLen++] = new LinePart(len, "mtkw", 1, false);
	} else result[resultLen++] = new LinePart(len, tokenType, 0, tokenContainsRTL);
	return result;
}
/**
* Inline decorations are "merged" on top of tokens.
* Special care must be taken when multiple inline decorations are at play and they overlap.
*/
function _applyInlineDecorations(lineContent, len, tokens, _lineDecorations) {
	_lineDecorations.sort(LineDecoration.compare);
	const lineDecorations = LineDecorationsNormalizer.normalize(lineContent, _lineDecorations);
	const lineDecorationsLen = lineDecorations.length;
	let lineDecorationIndex = 0;
	const result = [];
	let resultLen = 0;
	let lastResultEndIndex = 0;
	for (let tokenIndex = 0, len = tokens.length; tokenIndex < len; tokenIndex++) {
		const token = tokens[tokenIndex];
		const tokenEndIndex = token.endIndex;
		const tokenType = token.type;
		const tokenMetadata = token.metadata;
		const tokenContainsRTL = token.containsRTL;
		while (lineDecorationIndex < lineDecorationsLen && lineDecorations[lineDecorationIndex].startOffset < tokenEndIndex) {
			const lineDecoration = lineDecorations[lineDecorationIndex];
			if (lineDecoration.startOffset > lastResultEndIndex) {
				lastResultEndIndex = lineDecoration.startOffset;
				result[resultLen++] = new LinePart(lastResultEndIndex, tokenType, tokenMetadata, tokenContainsRTL);
			}
			if (lineDecoration.endOffset + 1 <= tokenEndIndex) {
				lastResultEndIndex = lineDecoration.endOffset + 1;
				result[resultLen++] = new LinePart(lastResultEndIndex, tokenType + " " + lineDecoration.className, tokenMetadata | lineDecoration.metadata, tokenContainsRTL);
				lineDecorationIndex++;
			} else {
				lastResultEndIndex = tokenEndIndex;
				result[resultLen++] = new LinePart(lastResultEndIndex, tokenType + " " + lineDecoration.className, tokenMetadata | lineDecoration.metadata, tokenContainsRTL);
				break;
			}
		}
		if (tokenEndIndex > lastResultEndIndex) {
			lastResultEndIndex = tokenEndIndex;
			result[resultLen++] = new LinePart(lastResultEndIndex, tokenType, tokenMetadata, tokenContainsRTL);
		}
	}
	const lastTokenEndIndex = tokens[tokens.length - 1].endIndex;
	if (lineDecorationIndex < lineDecorationsLen && lineDecorations[lineDecorationIndex].startOffset === lastTokenEndIndex) while (lineDecorationIndex < lineDecorationsLen && lineDecorations[lineDecorationIndex].startOffset === lastTokenEndIndex) {
		const lineDecoration = lineDecorations[lineDecorationIndex];
		result[resultLen++] = new LinePart(lastResultEndIndex, lineDecoration.className, lineDecoration.metadata, false);
		lineDecorationIndex++;
	}
	return result;
}
/**
* This function is on purpose not split up into multiple functions to allow runtime type inference (i.e. performance reasons).
* Notice how all the needed data is fully resolved and passed in (i.e. no other calls).
*/
function _renderLine(input, sb) {
	const fontIsMonospace = input.fontIsMonospace;
	const canUseHalfwidthRightwardsArrow = input.canUseHalfwidthRightwardsArrow;
	const containsForeignElements = input.containsForeignElements;
	const lineContent = input.lineContent;
	const len = input.len;
	const isOverflowing = input.isOverflowing;
	const overflowingCharCount = input.overflowingCharCount;
	const parts = input.parts;
	const fauxIndentLength = input.fauxIndentLength;
	const tabSize = input.tabSize;
	const startVisibleColumn = input.startVisibleColumn;
	const spaceWidth = input.spaceWidth;
	const renderSpaceCharCode = input.renderSpaceCharCode;
	const renderWhitespace = input.renderWhitespace;
	const renderControlCharacters = input.renderControlCharacters;
	const useTwoCellFullwidthCharacters = input.useTwoCellFullwidthCharacters;
	const fullWidthCharacterWidth = 2 * input.spaceWidth;
	const characterMapping = new CharacterMapping(len + 1, parts.length);
	let lastCharacterMappingDefined = false;
	let charIndex = 0;
	let visibleColumn = startVisibleColumn;
	let charOffsetInPart = 0;
	let charHorizontalOffset = 0;
	let partDisplacement = 0;
	sb.appendString("<span>");
	for (let partIndex = 0, tokensLen = parts.length; partIndex < tokensLen; partIndex++) {
		const part = parts[partIndex];
		const partEndIndex = part.endIndex;
		const partType = part.type;
		const partContainsRTL = part.containsRTL;
		const partRendersWhitespace = renderWhitespace !== 0 && part.isWhitespace();
		const partRendersWhitespaceWithWidth = partRendersWhitespace && !fontIsMonospace && (partType === "mtkw" || !containsForeignElements);
		const partIsEmptyAndHasPseudoAfter = charIndex === partEndIndex && part.isPseudoAfter();
		const partIsCenteredFullWidth = !partContainsRTL && useTwoCellFullwidthCharacters && isFullWidthCharacter(lineContent.charCodeAt(charIndex));
		charOffsetInPart = 0;
		sb.appendString("<span ");
		if (partContainsRTL) sb.appendString("style=\"unicode-bidi:isolate\" ");
		else if (partIsCenteredFullWidth) {
			sb.appendString("style=\"width:");
			sb.appendString(String(fullWidthCharacterWidth));
			sb.appendString("px\" ");
		}
		sb.appendString("class=\"");
		sb.appendString(partRendersWhitespaceWithWidth ? "mtkz" : partType);
		if (partIsCenteredFullWidth) sb.appendString(" mtkfullwidth");
		sb.appendASCIICharCode(34);
		if (partRendersWhitespace) {
			let partWidth = 0;
			{
				let _charIndex = charIndex;
				let _visibleColumn = visibleColumn;
				for (; _charIndex < partEndIndex; _charIndex++) {
					const charWidth = (lineContent.charCodeAt(_charIndex) === 9 ? tabSize - _visibleColumn % tabSize : 1) | 0;
					partWidth += charWidth;
					if (_charIndex >= fauxIndentLength) _visibleColumn += charWidth;
				}
			}
			if (partRendersWhitespaceWithWidth) {
				sb.appendString(" style=\"width:");
				sb.appendString(String(spaceWidth * partWidth));
				sb.appendString("px\"");
			}
			sb.appendASCIICharCode(62);
			for (; charIndex < partEndIndex; charIndex++) {
				characterMapping.setColumnInfo(charIndex + 1, partIndex - partDisplacement, charOffsetInPart, charHorizontalOffset);
				partDisplacement = 0;
				const charCode = lineContent.charCodeAt(charIndex);
				let producedCharacters;
				let charWidth;
				if (charCode === 9) {
					producedCharacters = tabSize - visibleColumn % tabSize | 0;
					charWidth = producedCharacters;
					if (!canUseHalfwidthRightwardsArrow || charWidth > 1) sb.appendCharCode(8594);
					else sb.appendCharCode(65515);
					for (let space = 2; space <= charWidth; space++) sb.appendCharCode(160);
				} else {
					producedCharacters = 2;
					charWidth = 1;
					sb.appendCharCode(renderSpaceCharCode);
					sb.appendCharCode(8204);
				}
				charOffsetInPart += producedCharacters;
				charHorizontalOffset += charWidth;
				if (charIndex >= fauxIndentLength) visibleColumn += charWidth;
			}
		} else {
			sb.appendASCIICharCode(62);
			for (; charIndex < partEndIndex; charIndex++) {
				characterMapping.setColumnInfo(charIndex + 1, partIndex - partDisplacement, charOffsetInPart, charHorizontalOffset);
				partDisplacement = 0;
				const charCode = lineContent.charCodeAt(charIndex);
				let producedCharacters = 1;
				let charWidth = 1;
				switch (charCode) {
					case 9:
						producedCharacters = tabSize - visibleColumn % tabSize;
						charWidth = producedCharacters;
						for (let space = 1; space <= producedCharacters; space++) sb.appendCharCode(160);
						break;
					case 32:
						sb.appendCharCode(160);
						break;
					case 60:
						sb.appendString("&lt;");
						break;
					case 62:
						sb.appendString("&gt;");
						break;
					case 38:
						sb.appendString("&amp;");
						break;
					case 0:
						if (renderControlCharacters) sb.appendCharCode(9216);
						else sb.appendString("&#00;");
						break;
					case 65279:
					case 8232:
					case 8233:
					case 133:
						sb.appendCharCode(65533);
						break;
					default:
						if (isFullWidthCharacter(charCode)) charWidth++;
						if (renderControlCharacters && charCode < 32) sb.appendCharCode(9216 + charCode);
						else if (renderControlCharacters && charCode === 127) sb.appendCharCode(9249);
						else if (renderControlCharacters && isControlCharacter(charCode)) {
							sb.appendString("[U+");
							sb.appendString(to4CharHex(charCode));
							sb.appendString("]");
							producedCharacters = 8;
							charWidth = producedCharacters;
						} else sb.appendCharCode(charCode);
				}
				charOffsetInPart += producedCharacters;
				charHorizontalOffset += charWidth;
				if (charIndex >= fauxIndentLength) visibleColumn += charWidth;
			}
		}
		if (partIsEmptyAndHasPseudoAfter) partDisplacement++;
		else partDisplacement = 0;
		if (charIndex >= len && !lastCharacterMappingDefined && part.isPseudoAfter()) {
			lastCharacterMappingDefined = true;
			characterMapping.setColumnInfo(charIndex + 1, partIndex, charOffsetInPart, charHorizontalOffset);
		}
		sb.appendString("</span>");
	}
	if (!lastCharacterMappingDefined) characterMapping.setColumnInfo(len + 1, parts.length - 1, charOffsetInPart, charHorizontalOffset);
	if (isOverflowing) {
		sb.appendString("<span class=\"mtkoverflow\">");
		sb.appendString(localize(847, "Show more ({0})", renderOverflowingCharCount(overflowingCharCount)));
		sb.appendString("</span>");
	}
	sb.appendString("</span>");
	return new RenderLineOutput(characterMapping, containsForeignElements);
}
function to4CharHex(n) {
	return n.toString(16).toUpperCase().padStart(4, "0");
}
function renderOverflowingCharCount(n) {
	if (n < 1024) return localize(848, "{0} chars", n);
	if (n < 1048576) return `${(n / 1024).toFixed(1)} KB`;
	return `${(n / 1024 / 1024).toFixed(1)} MB`;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/viewModel.js
var Viewport = class {
	constructor(top, left, width, height) {
		this._viewportBrand = void 0;
		this.top = top | 0;
		this.left = left | 0;
		this.width = width | 0;
		this.height = height | 0;
	}
};
var MinimapLinesRenderingData = class {
	constructor(tabSize, data) {
		this.tabSize = tabSize;
		this.data = data;
	}
};
var ViewLineData = class {
	constructor(content, continuesWithWrappedLine, minColumn, maxColumn, startVisibleColumn, tokens, inlineDecorations) {
		this._viewLineDataBrand = void 0;
		this.content = content;
		this.continuesWithWrappedLine = continuesWithWrappedLine;
		this.minColumn = minColumn;
		this.maxColumn = maxColumn;
		this.startVisibleColumn = startVisibleColumn;
		this.tokens = tokens;
		this.inlineDecorations = inlineDecorations;
	}
};
var ViewLineRenderingData = class ViewLineRenderingData {
	constructor(minColumn, maxColumn, content, continuesWithWrappedLine, mightContainRTL, mightContainNonBasicASCII, tokens, inlineDecorations, tabSize, startVisibleColumn, textDirection, hasVariableFonts) {
		this.minColumn = minColumn;
		this.maxColumn = maxColumn;
		this.content = content;
		this.continuesWithWrappedLine = continuesWithWrappedLine;
		this.isBasicASCII = ViewLineRenderingData.isBasicASCII(content, mightContainNonBasicASCII);
		this.containsRTL = ViewLineRenderingData.containsRTL(content, this.isBasicASCII, mightContainRTL);
		this.tokens = tokens;
		this.inlineDecorations = inlineDecorations;
		this.tabSize = tabSize;
		this.startVisibleColumn = startVisibleColumn;
		this.textDirection = textDirection;
		this.hasVariableFonts = hasVariableFonts;
	}
	static isBasicASCII(lineContent, mightContainNonBasicASCII) {
		if (mightContainNonBasicASCII) return isBasicASCII(lineContent);
		return true;
	}
	static containsRTL(lineContent, isBasicASCII, mightContainRTL) {
		if (!isBasicASCII && mightContainRTL) return containsRTL(lineContent);
		return false;
	}
};
var OverviewRulerDecorationsGroup = class OverviewRulerDecorationsGroup {
	constructor(color, zIndex, data) {
		this.color = color;
		this.zIndex = zIndex;
		this.data = data;
	}
	static compareByRenderingProps(a, b) {
		if (a.zIndex === b.zIndex) {
			if (a.color < b.color) return -1;
			if (a.color > b.color) return 1;
			return 0;
		}
		return a.zIndex - b.zIndex;
	}
	static equals(a, b) {
		return a.color === b.color && a.zIndex === b.zIndex && equals$1(a.data, b.data);
	}
	static equalsArr(a, b) {
		return equals$1(a, b, OverviewRulerDecorationsGroup.equals);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/standalone/common/monarch/monarchCommon.js
function isFuzzyActionArr(what) {
	return Array.isArray(what);
}
function isFuzzyAction(what) {
	return !isFuzzyActionArr(what);
}
function isString(what) {
	return typeof what === "string";
}
function isIAction(what) {
	return !isString(what);
}
/**
* Is a string null, undefined, or empty?
*/
function empty(s) {
	return s ? false : true;
}
/**
* Puts a string to lower case if 'ignoreCase' is set.
*/
function fixCase(lexer, str) {
	return lexer.ignoreCase && str ? str.toLowerCase() : str;
}
/**
* Ensures there are no bad characters in a CSS token class.
*/
function sanitize(s) {
	return s.replace(/[&<>'"_]/g, "-");
}
/**
* Logs a message.
*/
function log(lexer, msg) {
	console.log(`${lexer.languageId}: ${msg}`);
}
function createError(lexer, msg) {
	return /* @__PURE__ */ new Error(`${lexer.languageId}: ${msg}`);
}
/**
* substituteMatches is used on lexer strings and can substitutes predefined patterns:
* 		$$  => $
* 		$#  => id
* 		$n  => matched entry n
* 		@attr => contents of lexer[attr]
*
* See documentation for more info
*/
function substituteMatches(lexer, str, id, matches, state) {
	const re = /\$((\$)|(#)|(\d\d?)|[sS](\d\d?)|@(\w+))/g;
	let stateMatches = null;
	return str.replace(re, function(full, sub, dollar, hash, n, s, attr, ofs, total) {
		if (!empty(dollar)) return "$";
		if (!empty(hash)) return fixCase(lexer, id);
		if (!empty(n) && n < matches.length) return fixCase(lexer, matches[n]);
		if (!empty(attr) && lexer && typeof lexer[attr] === "string") return lexer[attr];
		if (stateMatches === null) {
			stateMatches = state.split(".");
			stateMatches.unshift(state);
		}
		if (!empty(s) && s < stateMatches.length) return fixCase(lexer, stateMatches[s]);
		return "";
	});
}
/**
* substituteMatchesRe is used on lexer regex rules and can substitutes predefined patterns:
* 		$Sn => n'th part of state
*
*/
function substituteMatchesRe(lexer, str, state) {
	const re = /\$[sS](\d\d?)/g;
	let stateMatches = null;
	return str.replace(re, function(full, s) {
		if (stateMatches === null) {
			stateMatches = state.split(".");
			stateMatches.unshift(state);
		}
		if (!empty(s) && s < stateMatches.length) return escapeRegExpCharacters(fixCase(lexer, stateMatches[s]));
		return "";
	});
}
/**
* Find the tokenizer rules for a specific state (i.e. next action)
*/
function findRules(lexer, inState) {
	let state = inState;
	while (state && state.length > 0) {
		const rules = lexer.tokenizer[state];
		if (rules) return rules;
		const idx = state.lastIndexOf(".");
		if (idx < 0) state = null;
		else state = state.substr(0, idx);
	}
	return null;
}
/**
* Is a certain state defined? In contrast to 'findRules' this works on a ILexerMin.
* This is used during compilation where we may know the defined states
* but not yet whether the corresponding rules are correct.
*/
function stateExists(lexer, inState) {
	let state = inState;
	while (state && state.length > 0) {
		if (lexer.stateNames[state]) return true;
		const idx = state.lastIndexOf(".");
		if (idx < 0) state = null;
		else state = state.substr(0, idx);
	}
	return false;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/standalone/common/monarch/monarchLexer.js
var __decorate$78 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$71 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var MonarchTokenizer_1;
var CACHE_STACK_DEPTH = 5;
/**
* Reuse the same stack elements up to a certain depth.
*/
var MonarchStackElementFactory = class MonarchStackElementFactory {
	static {
		this._INSTANCE = new MonarchStackElementFactory(CACHE_STACK_DEPTH);
	}
	static create(parent, state) {
		return this._INSTANCE.create(parent, state);
	}
	constructor(maxCacheDepth) {
		this._maxCacheDepth = maxCacheDepth;
		this._entries = Object.create(null);
	}
	create(parent, state) {
		if (parent !== null && parent.depth >= this._maxCacheDepth) return new MonarchStackElement(parent, state);
		let stackElementId = MonarchStackElement.getStackElementId(parent);
		if (stackElementId.length > 0) stackElementId += "|";
		stackElementId += state;
		let result = this._entries[stackElementId];
		if (result) return result;
		result = new MonarchStackElement(parent, state);
		this._entries[stackElementId] = result;
		return result;
	}
};
var MonarchStackElement = class MonarchStackElement {
	constructor(parent, state) {
		this.parent = parent;
		this.state = state;
		this.depth = (this.parent ? this.parent.depth : 0) + 1;
	}
	static getStackElementId(element) {
		let result = "";
		while (element !== null) {
			if (result.length > 0) result += "|";
			result += element.state;
			element = element.parent;
		}
		return result;
	}
	static _equals(a, b) {
		while (a !== null && b !== null) {
			if (a === b) return true;
			if (a.state !== b.state) return false;
			a = a.parent;
			b = b.parent;
		}
		if (a === null && b === null) return true;
		return false;
	}
	equals(other) {
		return MonarchStackElement._equals(this, other);
	}
	push(state) {
		return MonarchStackElementFactory.create(this, state);
	}
	pop() {
		return this.parent;
	}
	popall() {
		let result = this;
		while (result.parent) result = result.parent;
		return result;
	}
	switchTo(state) {
		return MonarchStackElementFactory.create(this.parent, state);
	}
};
var EmbeddedLanguageData = class EmbeddedLanguageData {
	constructor(languageId, state) {
		this.languageId = languageId;
		this.state = state;
	}
	equals(other) {
		return this.languageId === other.languageId && this.state.equals(other.state);
	}
	clone() {
		if (this.state.clone() === this.state) return this;
		return new EmbeddedLanguageData(this.languageId, this.state);
	}
};
/**
* Reuse the same line states up to a certain depth.
*/
var MonarchLineStateFactory = class MonarchLineStateFactory {
	static {
		this._INSTANCE = new MonarchLineStateFactory(CACHE_STACK_DEPTH);
	}
	static create(stack, embeddedLanguageData) {
		return this._INSTANCE.create(stack, embeddedLanguageData);
	}
	constructor(maxCacheDepth) {
		this._maxCacheDepth = maxCacheDepth;
		this._entries = Object.create(null);
	}
	create(stack, embeddedLanguageData) {
		if (embeddedLanguageData !== null) return new MonarchLineState(stack, embeddedLanguageData);
		if (stack !== null && stack.depth >= this._maxCacheDepth) return new MonarchLineState(stack, embeddedLanguageData);
		const stackElementId = MonarchStackElement.getStackElementId(stack);
		let result = this._entries[stackElementId];
		if (result) return result;
		result = new MonarchLineState(stack, null);
		this._entries[stackElementId] = result;
		return result;
	}
};
var MonarchLineState = class MonarchLineState {
	constructor(stack, embeddedLanguageData) {
		this.stack = stack;
		this.embeddedLanguageData = embeddedLanguageData;
	}
	clone() {
		if ((this.embeddedLanguageData ? this.embeddedLanguageData.clone() : null) === this.embeddedLanguageData) return this;
		return MonarchLineStateFactory.create(this.stack, this.embeddedLanguageData);
	}
	equals(other) {
		if (!(other instanceof MonarchLineState)) return false;
		if (!this.stack.equals(other.stack)) return false;
		if (this.embeddedLanguageData === null && other.embeddedLanguageData === null) return true;
		if (this.embeddedLanguageData === null || other.embeddedLanguageData === null) return false;
		return this.embeddedLanguageData.equals(other.embeddedLanguageData);
	}
};
var MonarchClassicTokensCollector = class {
	constructor() {
		this._tokens = [];
		this._languageId = null;
		this._lastTokenType = null;
		this._lastTokenLanguage = null;
	}
	enterLanguage(languageId) {
		this._languageId = languageId;
	}
	emit(startOffset, type) {
		if (this._lastTokenType === type && this._lastTokenLanguage === this._languageId) return;
		this._lastTokenType = type;
		this._lastTokenLanguage = this._languageId;
		this._tokens.push(new Token$2(startOffset, type, this._languageId));
	}
	nestedLanguageTokenize(embeddedLanguageLine, hasEOL, embeddedLanguageData, offsetDelta) {
		const nestedLanguageId = embeddedLanguageData.languageId;
		const embeddedModeState = embeddedLanguageData.state;
		const nestedLanguageTokenizationSupport = TokenizationRegistry.get(nestedLanguageId);
		if (!nestedLanguageTokenizationSupport) {
			this.enterLanguage(nestedLanguageId);
			this.emit(offsetDelta, "");
			return embeddedModeState;
		}
		const nestedResult = nestedLanguageTokenizationSupport.tokenize(embeddedLanguageLine, hasEOL, embeddedModeState);
		if (offsetDelta !== 0) for (const token of nestedResult.tokens) this._tokens.push(new Token$2(token.offset + offsetDelta, token.type, token.language));
		else this._tokens = this._tokens.concat(nestedResult.tokens);
		this._lastTokenType = null;
		this._lastTokenLanguage = null;
		this._languageId = null;
		return nestedResult.endState;
	}
	finalize(endState) {
		return new TokenizationResult(this._tokens, endState);
	}
};
var MonarchModernTokensCollector = class MonarchModernTokensCollector {
	constructor(languageService, theme) {
		this._languageService = languageService;
		this._theme = theme;
		this._prependTokens = null;
		this._tokens = [];
		this._currentLanguageId = 0;
		this._lastTokenMetadata = 0;
	}
	enterLanguage(languageId) {
		this._currentLanguageId = this._languageService.languageIdCodec.encodeLanguageId(languageId);
	}
	emit(startOffset, type) {
		const metadata = this._theme.match(this._currentLanguageId, type) | 1024;
		if (this._lastTokenMetadata === metadata) return;
		this._lastTokenMetadata = metadata;
		this._tokens.push(startOffset);
		this._tokens.push(metadata);
	}
	static _merge(a, b, c) {
		const aLen = a !== null ? a.length : 0;
		const bLen = b.length;
		const cLen = c !== null ? c.length : 0;
		if (aLen === 0 && bLen === 0 && cLen === 0) return /* @__PURE__ */ new Uint32Array(0);
		if (aLen === 0 && bLen === 0) return c;
		if (bLen === 0 && cLen === 0) return a;
		const result = new Uint32Array(aLen + bLen + cLen);
		if (a !== null) result.set(a);
		for (let i = 0; i < bLen; i++) result[aLen + i] = b[i];
		if (c !== null) result.set(c, aLen + bLen);
		return result;
	}
	nestedLanguageTokenize(embeddedLanguageLine, hasEOL, embeddedLanguageData, offsetDelta) {
		const nestedLanguageId = embeddedLanguageData.languageId;
		const embeddedModeState = embeddedLanguageData.state;
		const nestedLanguageTokenizationSupport = TokenizationRegistry.get(nestedLanguageId);
		if (!nestedLanguageTokenizationSupport) {
			this.enterLanguage(nestedLanguageId);
			this.emit(offsetDelta, "");
			return embeddedModeState;
		}
		const nestedResult = nestedLanguageTokenizationSupport.tokenizeEncoded(embeddedLanguageLine, hasEOL, embeddedModeState);
		if (offsetDelta !== 0) for (let i = 0, len = nestedResult.tokens.length; i < len; i += 2) nestedResult.tokens[i] += offsetDelta;
		this._prependTokens = MonarchModernTokensCollector._merge(this._prependTokens, this._tokens, nestedResult.tokens);
		this._tokens = [];
		this._currentLanguageId = 0;
		this._lastTokenMetadata = 0;
		return nestedResult.endState;
	}
	finalize(endState) {
		return new EncodedTokenizationResult(MonarchModernTokensCollector._merge(this._prependTokens, this._tokens, null), [], endState);
	}
};
var MonarchTokenizer = MonarchTokenizer_1 = class MonarchTokenizer extends Disposable {
	constructor(languageService, standaloneThemeService, languageId, lexer, _configurationService) {
		super();
		this._configurationService = _configurationService;
		this._languageService = languageService;
		this._standaloneThemeService = standaloneThemeService;
		this._languageId = languageId;
		this._lexer = lexer;
		this._embeddedLanguages = Object.create(null);
		this.embeddedLoaded = Promise.resolve(void 0);
		let emitting = false;
		this._register(TokenizationRegistry.onDidChange((e) => {
			if (emitting) return;
			let isOneOfMyEmbeddedModes = false;
			for (let i = 0, len = e.changedLanguages.length; i < len; i++) {
				const language = e.changedLanguages[i];
				if (this._embeddedLanguages[language]) {
					isOneOfMyEmbeddedModes = true;
					break;
				}
			}
			if (isOneOfMyEmbeddedModes) {
				emitting = true;
				TokenizationRegistry.handleChange([this._languageId]);
				emitting = false;
			}
		}));
		this._maxTokenizationLineLength = this._configurationService.getValue("editor.maxTokenizationLineLength", { overrideIdentifier: this._languageId });
		this._register(this._configurationService.onDidChangeConfiguration((e) => {
			if (e.affectsConfiguration("editor.maxTokenizationLineLength")) this._maxTokenizationLineLength = this._configurationService.getValue("editor.maxTokenizationLineLength", { overrideIdentifier: this._languageId });
		}));
	}
	getLoadStatus() {
		const promises = [];
		for (const nestedLanguageId in this._embeddedLanguages) {
			const tokenizationSupport = TokenizationRegistry.get(nestedLanguageId);
			if (tokenizationSupport) {
				if (tokenizationSupport instanceof MonarchTokenizer_1) {
					const nestedModeStatus = tokenizationSupport.getLoadStatus();
					if (nestedModeStatus.loaded === false) promises.push(nestedModeStatus.promise);
				}
				continue;
			}
			if (!TokenizationRegistry.isResolved(nestedLanguageId)) promises.push(TokenizationRegistry.getOrCreate(nestedLanguageId));
		}
		if (promises.length === 0) return { loaded: true };
		return {
			loaded: false,
			promise: Promise.all(promises).then((_) => void 0)
		};
	}
	getInitialState() {
		const rootState = MonarchStackElementFactory.create(null, this._lexer.start);
		return MonarchLineStateFactory.create(rootState, null);
	}
	tokenize(line, hasEOL, lineState) {
		if (line.length >= this._maxTokenizationLineLength) return nullTokenize(this._languageId, lineState);
		const tokensCollector = new MonarchClassicTokensCollector();
		const endLineState = this._tokenize(line, hasEOL, lineState, tokensCollector);
		return tokensCollector.finalize(endLineState);
	}
	tokenizeEncoded(line, hasEOL, lineState) {
		if (line.length >= this._maxTokenizationLineLength) return nullTokenizeEncoded(this._languageService.languageIdCodec.encodeLanguageId(this._languageId), lineState);
		const tokensCollector = new MonarchModernTokensCollector(this._languageService, this._standaloneThemeService.getColorTheme().tokenTheme);
		const endLineState = this._tokenize(line, hasEOL, lineState, tokensCollector);
		return tokensCollector.finalize(endLineState);
	}
	_tokenize(line, hasEOL, lineState, collector) {
		if (lineState.embeddedLanguageData) return this._nestedTokenize(line, hasEOL, lineState, 0, collector);
		else return this._myTokenize(line, hasEOL, lineState, 0, collector);
	}
	_findLeavingNestedLanguageOffset(line, state) {
		let rules = this._lexer.tokenizer[state.stack.state];
		if (!rules) {
			rules = findRules(this._lexer, state.stack.state);
			if (!rules) throw createError(this._lexer, "tokenizer state is not defined: " + state.stack.state);
		}
		let popOffset = -1;
		let hasEmbeddedPopRule = false;
		for (const rule of rules) {
			if (!isIAction(rule.action) || !(rule.action.nextEmbedded === "@pop" || rule.action.hasEmbeddedEndInCases)) continue;
			hasEmbeddedPopRule = true;
			let regex = rule.resolveRegex(state.stack.state);
			const regexSource = regex.source;
			if (regexSource.substr(0, 4) === "^(?:" && regexSource.substr(regexSource.length - 1, 1) === ")") {
				const flags = (regex.ignoreCase ? "i" : "") + (regex.unicode ? "u" : "");
				regex = new RegExp(regexSource.substr(4, regexSource.length - 5), flags);
			}
			const result = line.search(regex);
			if (result === -1 || result !== 0 && rule.matchOnlyAtLineStart) continue;
			if (popOffset === -1 || result < popOffset) popOffset = result;
		}
		if (!hasEmbeddedPopRule) throw createError(this._lexer, "no rule containing nextEmbedded: \"@pop\" in tokenizer embedded state: " + state.stack.state);
		return popOffset;
	}
	_nestedTokenize(line, hasEOL, lineState, offsetDelta, tokensCollector) {
		const popOffset = this._findLeavingNestedLanguageOffset(line, lineState);
		if (popOffset === -1) {
			const nestedEndState = tokensCollector.nestedLanguageTokenize(line, hasEOL, lineState.embeddedLanguageData, offsetDelta);
			return MonarchLineStateFactory.create(lineState.stack, new EmbeddedLanguageData(lineState.embeddedLanguageData.languageId, nestedEndState));
		}
		const nestedLanguageLine = line.substring(0, popOffset);
		if (nestedLanguageLine.length > 0) tokensCollector.nestedLanguageTokenize(nestedLanguageLine, false, lineState.embeddedLanguageData, offsetDelta);
		const restOfTheLine = line.substring(popOffset);
		return this._myTokenize(restOfTheLine, hasEOL, lineState, offsetDelta + popOffset, tokensCollector);
	}
	_safeRuleName(rule) {
		if (rule) return rule.name;
		return "(unknown)";
	}
	_myTokenize(lineWithoutLF, hasEOL, lineState, offsetDelta, tokensCollector) {
		tokensCollector.enterLanguage(this._languageId);
		const lineWithoutLFLength = lineWithoutLF.length;
		const line = hasEOL && this._lexer.includeLF ? lineWithoutLF + "\n" : lineWithoutLF;
		const lineLength = line.length;
		let embeddedLanguageData = lineState.embeddedLanguageData;
		let stack = lineState.stack;
		let pos = 0;
		let groupMatching = null;
		let forceEvaluation = true;
		while (forceEvaluation || pos < lineLength) {
			const pos0 = pos;
			const stackLen0 = stack.depth;
			const groupLen0 = groupMatching ? groupMatching.groups.length : 0;
			const state = stack.state;
			let matches = null;
			let matched = null;
			let action = null;
			let rule = null;
			let enteringEmbeddedLanguage = null;
			if (groupMatching) {
				matches = groupMatching.matches;
				const groupEntry = groupMatching.groups.shift();
				matched = groupEntry.matched;
				action = groupEntry.action;
				rule = groupMatching.rule;
				if (groupMatching.groups.length === 0) groupMatching = null;
			} else {
				if (!forceEvaluation && pos >= lineLength) break;
				forceEvaluation = false;
				let rules = this._lexer.tokenizer[state];
				if (!rules) {
					rules = findRules(this._lexer, state);
					if (!rules) throw createError(this._lexer, "tokenizer state is not defined: " + state);
				}
				const restOfLine = line.substr(pos);
				for (const rule of rules) if (pos === 0 || !rule.matchOnlyAtLineStart) {
					matches = restOfLine.match(rule.resolveRegex(state));
					if (matches) {
						matched = matches[0];
						action = rule.action;
						break;
					}
				}
			}
			if (!matches) {
				matches = [""];
				matched = "";
			}
			if (!action) {
				if (pos < lineLength) {
					matches = [line.charAt(pos)];
					matched = matches[0];
				}
				action = this._lexer.defaultToken;
			}
			if (matched === null) break;
			pos += matched.length;
			while (isFuzzyAction(action) && isIAction(action) && action.test) action = action.test(matched, matches, state, pos === lineLength);
			let result = null;
			if (typeof action === "string" || Array.isArray(action)) result = action;
			else if (action.group) result = action.group;
			else if (action.token !== null && action.token !== void 0) {
				if (action.tokenSubst) result = substituteMatches(this._lexer, action.token, matched, matches, state);
				else result = action.token;
				if (action.nextEmbedded) {
					if (action.nextEmbedded === "@pop") {
						if (!embeddedLanguageData) throw createError(this._lexer, "cannot pop embedded language if not inside one");
						embeddedLanguageData = null;
					} else if (embeddedLanguageData) throw createError(this._lexer, "cannot enter embedded language from within an embedded language");
					else enteringEmbeddedLanguage = substituteMatches(this._lexer, action.nextEmbedded, matched, matches, state);
				}
				if (action.goBack) pos = Math.max(0, pos - action.goBack);
				if (action.switchTo && typeof action.switchTo === "string") {
					let nextState = substituteMatches(this._lexer, action.switchTo, matched, matches, state);
					if (nextState[0] === "@") nextState = nextState.substr(1);
					if (!findRules(this._lexer, nextState)) throw createError(this._lexer, "trying to switch to a state '" + nextState + "' that is undefined in rule: " + this._safeRuleName(rule));
					else stack = stack.switchTo(nextState);
				} else if (action.transform && typeof action.transform === "function") throw createError(this._lexer, "action.transform not supported");
				else if (action.next) {
					if (action.next === "@push") {
						if (stack.depth >= this._lexer.maxStack) throw createError(this._lexer, "maximum tokenizer stack size reached: [" + stack.state + "," + stack.parent.state + ",...]");
						else stack = stack.push(state);
					} else if (action.next === "@pop") {
						if (stack.depth <= 1) throw createError(this._lexer, "trying to pop an empty stack in rule: " + this._safeRuleName(rule));
						else stack = stack.pop();
					} else if (action.next === "@popall") stack = stack.popall();
					else {
						let nextState = substituteMatches(this._lexer, action.next, matched, matches, state);
						if (nextState[0] === "@") nextState = nextState.substr(1);
						if (!findRules(this._lexer, nextState)) throw createError(this._lexer, "trying to set a next state '" + nextState + "' that is undefined in rule: " + this._safeRuleName(rule));
						else stack = stack.push(nextState);
					}
				}
				if (action.log && typeof action.log === "string") log(this._lexer, this._lexer.languageId + ": " + substituteMatches(this._lexer, action.log, matched, matches, state));
			}
			if (result === null) throw createError(this._lexer, "lexer rule has no well-defined action in rule: " + this._safeRuleName(rule));
			const computeNewStateForEmbeddedLanguage = (enteringEmbeddedLanguage) => {
				const languageId = this._languageService.getLanguageIdByLanguageName(enteringEmbeddedLanguage) || this._languageService.getLanguageIdByMimeType(enteringEmbeddedLanguage) || enteringEmbeddedLanguage;
				const embeddedLanguageData = this._getNestedEmbeddedLanguageData(languageId);
				if (pos < lineLength) {
					const restOfLine = lineWithoutLF.substr(pos);
					return this._nestedTokenize(restOfLine, hasEOL, MonarchLineStateFactory.create(stack, embeddedLanguageData), offsetDelta + pos, tokensCollector);
				} else return MonarchLineStateFactory.create(stack, embeddedLanguageData);
			};
			if (Array.isArray(result)) {
				if (groupMatching && groupMatching.groups.length > 0) throw createError(this._lexer, "groups cannot be nested: " + this._safeRuleName(rule));
				if (matches.length !== result.length + 1) throw createError(this._lexer, "matched number of groups does not match the number of actions in rule: " + this._safeRuleName(rule));
				let totalLen = 0;
				for (let i = 1; i < matches.length; i++) totalLen += matches[i].length;
				if (totalLen !== matched.length) throw createError(this._lexer, "with groups, all characters should be matched in consecutive groups in rule: " + this._safeRuleName(rule));
				groupMatching = {
					rule,
					matches,
					groups: []
				};
				for (let i = 0; i < result.length; i++) groupMatching.groups[i] = {
					action: result[i],
					matched: matches[i + 1]
				};
				pos -= matched.length;
				continue;
			} else {
				if (result === "@rematch") {
					pos -= matched.length;
					matched = "";
					matches = null;
					result = "";
					if (enteringEmbeddedLanguage !== null) return computeNewStateForEmbeddedLanguage(enteringEmbeddedLanguage);
				}
				if (matched.length === 0) {
					if (lineLength === 0 || stackLen0 !== stack.depth || state !== stack.state || (!groupMatching ? 0 : groupMatching.groups.length) !== groupLen0) continue;
					else throw createError(this._lexer, "no progress in tokenizer in rule: " + this._safeRuleName(rule));
				}
				let tokenType = null;
				if (isString(result) && result.indexOf("@brackets") === 0) {
					const rest = result.substr(9);
					const bracket = findBracket(this._lexer, matched);
					if (!bracket) throw createError(this._lexer, "@brackets token returned but no bracket defined as: " + matched);
					tokenType = sanitize(bracket.token + rest);
				} else tokenType = sanitize(result === "" ? "" : result + this._lexer.tokenPostfix);
				if (pos0 < lineWithoutLFLength) tokensCollector.emit(pos0 + offsetDelta, tokenType);
			}
			if (enteringEmbeddedLanguage !== null) return computeNewStateForEmbeddedLanguage(enteringEmbeddedLanguage);
		}
		return MonarchLineStateFactory.create(stack, embeddedLanguageData);
	}
	_getNestedEmbeddedLanguageData(languageId) {
		if (!this._languageService.isRegisteredLanguageId(languageId)) return new EmbeddedLanguageData(languageId, NullState);
		if (languageId !== this._languageId) {
			this._languageService.requestBasicLanguageFeatures(languageId);
			TokenizationRegistry.getOrCreate(languageId);
			this._embeddedLanguages[languageId] = true;
		}
		const tokenizationSupport = TokenizationRegistry.get(languageId);
		if (tokenizationSupport) return new EmbeddedLanguageData(languageId, tokenizationSupport.getInitialState());
		return new EmbeddedLanguageData(languageId, NullState);
	}
};
MonarchTokenizer = MonarchTokenizer_1 = __decorate$78([__param$71(4, IConfigurationService)], MonarchTokenizer);
/**
* Searches for a bracket in the 'brackets' attribute that matches the input.
*/
function findBracket(lexer, matched) {
	if (!matched) return null;
	matched = fixCase(lexer, matched);
	const brackets = lexer.brackets;
	for (const bracket of brackets) if (bracket.open === matched) return {
		token: bracket.token,
		bracketType: 1
	};
	else if (bracket.close === matched) return {
		token: bracket.token,
		bracketType: -1
	};
	return null;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/standalone/browser/colorizer.js
var ttPolicy$4 = createTrustedTypesPolicy("standaloneColorizer", { createHTML: (value) => value });
var Colorizer = class {
	static colorizeElement(themeService, languageService, domNode, options) {
		options = options || {};
		const theme = options.theme || "vs";
		const mimeType = options.mimeType || domNode.getAttribute("lang") || domNode.getAttribute("data-lang");
		if (!mimeType) {
			console.error("Mode not detected");
			return Promise.resolve();
		}
		const languageId = languageService.getLanguageIdByMimeType(mimeType) || mimeType;
		themeService.setTheme(theme);
		const text = domNode.firstChild ? domNode.firstChild.nodeValue : "";
		domNode.className += " " + theme;
		const render = (str) => {
			domNode.innerHTML = ttPolicy$4?.createHTML(str) ?? str;
		};
		return this.colorize(languageService, text || "", languageId, options).then(render, (err) => console.error(err));
	}
	static async colorize(languageService, text, languageId, options) {
		const languageIdCodec = languageService.languageIdCodec;
		let tabSize = 4;
		if (options && typeof options.tabSize === "number") tabSize = options.tabSize;
		if (startsWithUTF8BOM(text)) text = text.substr(1);
		const lines = splitLines(text);
		if (!languageService.isRegisteredLanguageId(languageId)) return _fakeColorize(lines, tabSize, languageIdCodec);
		const tokenizationSupport = await TokenizationRegistry.getOrCreate(languageId);
		if (tokenizationSupport) return _colorize(lines, tabSize, tokenizationSupport, languageIdCodec);
		return _fakeColorize(lines, tabSize, languageIdCodec);
	}
	static colorizeLine(line, mightContainNonBasicASCII, mightContainRTL, tokens, tabSize = 4) {
		const isBasicASCII = ViewLineRenderingData.isBasicASCII(line, mightContainNonBasicASCII);
		return renderViewLine2(new RenderLineInput(false, true, line, false, isBasicASCII, ViewLineRenderingData.containsRTL(line, isBasicASCII, mightContainRTL), 0, tokens, [], tabSize, 0, 0, 0, 0, -1, "none", false, false, null, null, 0)).html;
	}
	static colorizeModelLine(model, lineNumber, tabSize = 4) {
		const content = model.getLineContent(lineNumber);
		model.tokenization.forceTokenization(lineNumber);
		const inflatedTokens = model.tokenization.getLineTokens(lineNumber).inflate();
		return this.colorizeLine(content, model.mightContainNonBasicASCII(), model.mightContainRTL(), inflatedTokens, tabSize);
	}
};
function _colorize(lines, tabSize, tokenizationSupport, languageIdCodec) {
	return new Promise((c, e) => {
		const execute = () => {
			const result = _actualColorize(lines, tabSize, tokenizationSupport, languageIdCodec);
			if (tokenizationSupport instanceof MonarchTokenizer) {
				const status = tokenizationSupport.getLoadStatus();
				if (status.loaded === false) {
					status.promise.then(execute, e);
					return;
				}
			}
			c(result);
		};
		execute();
	});
}
function _fakeColorize(lines, tabSize, languageIdCodec) {
	let html = [];
	const defaultMetadata = 33587200;
	const tokens = /* @__PURE__ */ new Uint32Array(2);
	tokens[0] = 0;
	tokens[1] = defaultMetadata;
	for (let i = 0, length = lines.length; i < length; i++) {
		const line = lines[i];
		tokens[0] = line.length;
		const lineTokens = new LineTokens(tokens, line, languageIdCodec);
		const isBasicASCII = ViewLineRenderingData.isBasicASCII(line, true);
		const renderResult = renderViewLine2(new RenderLineInput(false, true, line, false, isBasicASCII, ViewLineRenderingData.containsRTL(line, isBasicASCII, true), 0, lineTokens, [], tabSize, 0, 0, 0, 0, -1, "none", false, false, null, null, 0));
		html = html.concat(renderResult.html);
		html.push("<br/>");
	}
	return html.join("");
}
function _actualColorize(lines, tabSize, tokenizationSupport, languageIdCodec) {
	let html = [];
	let state = tokenizationSupport.getInitialState();
	for (let i = 0, length = lines.length; i < length; i++) {
		const line = lines[i];
		const tokenizeResult = tokenizationSupport.tokenizeEncoded(line, true, state);
		LineTokens.convertToEndOffset(tokenizeResult.tokens, line.length);
		const lineTokens = new LineTokens(tokenizeResult.tokens, line, languageIdCodec);
		const isBasicASCII = ViewLineRenderingData.isBasicASCII(line, true);
		const renderResult = renderViewLine2(new RenderLineInput(false, true, line, false, isBasicASCII, ViewLineRenderingData.containsRTL(line, isBasicASCII, true), 0, lineTokens.inflate(), [], tabSize, 0, 0, 0, 0, -1, "none", false, false, null, null, 0));
		html = html.concat(renderResult.html);
		html.push("<br/>");
		state = tokenizeResult.endState;
	}
	return html.join("");
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/aria/aria.js
var MAX_MESSAGE_LENGTH = 2e4;
var ariaContainer;
var alertContainer;
var alertContainer2;
var statusContainer;
var statusContainer2;
function setARIAContainer(parent) {
	ariaContainer = document.createElement("div");
	ariaContainer.className = "monaco-aria-container";
	const createAlertContainer = () => {
		const element = document.createElement("div");
		element.className = "monaco-alert";
		element.setAttribute("role", "alert");
		element.setAttribute("aria-atomic", "true");
		ariaContainer.appendChild(element);
		return element;
	};
	alertContainer = createAlertContainer();
	alertContainer2 = createAlertContainer();
	const createStatusContainer = () => {
		const element = document.createElement("div");
		element.className = "monaco-status";
		element.setAttribute("aria-live", "polite");
		element.setAttribute("aria-atomic", "true");
		ariaContainer.appendChild(element);
		return element;
	};
	statusContainer = createStatusContainer();
	statusContainer2 = createStatusContainer();
	parent.appendChild(ariaContainer);
}
/**
* Given the provided message, will make sure that it is read as alert to screen readers.
*/
function alert(msg) {
	if (!ariaContainer) return;
	if (alertContainer.textContent !== msg) {
		clearNode(alertContainer2);
		insertMessage(alertContainer, msg);
	} else {
		clearNode(alertContainer);
		insertMessage(alertContainer2, msg);
	}
}
/**
* Given the provided message, will make sure that it is read as status to screen readers.
*/
function status(msg) {
	if (!ariaContainer) return;
	if (statusContainer.textContent !== msg) {
		clearNode(statusContainer2);
		insertMessage(statusContainer, msg);
	} else {
		clearNode(statusContainer);
		insertMessage(statusContainer2, msg);
	}
}
function insertMessage(target, msg) {
	clearNode(target);
	if (msg.length > MAX_MESSAGE_LENGTH) msg = msg.substr(0, MAX_MESSAGE_LENGTH);
	target.textContent = msg;
	target.style.visibility = "hidden";
	target.style.visibility = "visible";
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/services/editorWorker.js
var IEditorWorkerService = createDecorator("editorWorkerService");
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/services/markerDecorations.js
var IMarkerDecorationsService = createDecorator("markerDecorationsService");
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/services/markerDecorations.js
var __decorate$77 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$70 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var MarkerDecorationsContribution = class MarkerDecorationsContribution {
	static {
		this.ID = "editor.contrib.markerDecorations";
	}
	constructor(_editor, _markerDecorationsService) {}
	dispose() {}
};
MarkerDecorationsContribution = __decorate$77([__param$70(1, IMarkerDecorationsService)], MarkerDecorationsContribution);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/services/contribution.js
registerSingleton(IEditorWorkerService, EditorWorkerService, 0);
registerEditorContribution(MarkerDecorationsContribution.ID, MarkerDecorationsContribution, 0);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/config/elementSizeObserver.js
var ElementSizeObserver = class extends Disposable {
	constructor(referenceDomElement, dimension) {
		super();
		this._onDidChange = this._register(new Emitter$1());
		this.onDidChange = this._onDidChange.event;
		this._referenceDomElement = referenceDomElement;
		this._width = -1;
		this._height = -1;
		this._resizeObserver = null;
		this.measureReferenceDomElement(false, dimension);
	}
	dispose() {
		this.stopObserving();
		super.dispose();
	}
	getWidth() {
		return this._width;
	}
	getHeight() {
		return this._height;
	}
	startObserving() {
		if (!this._resizeObserver && this._referenceDomElement) {
			let observedDimension = null;
			const observeNow = () => {
				if (observedDimension) this.observe({
					width: observedDimension.width,
					height: observedDimension.height
				});
				else this.observe();
			};
			let shouldObserve = false;
			let alreadyObservedThisAnimationFrame = false;
			const update = () => {
				if (shouldObserve && !alreadyObservedThisAnimationFrame) try {
					shouldObserve = false;
					alreadyObservedThisAnimationFrame = true;
					observeNow();
				} finally {
					scheduleAtNextAnimationFrame(getWindow(this._referenceDomElement), () => {
						alreadyObservedThisAnimationFrame = false;
						update();
					});
				}
			};
			this._resizeObserver = new ResizeObserver((entries) => {
				if (entries && entries[0] && entries[0].contentRect) observedDimension = {
					width: entries[0].contentRect.width,
					height: entries[0].contentRect.height
				};
				else observedDimension = null;
				shouldObserve = true;
				update();
			});
			this._resizeObserver.observe(this._referenceDomElement);
		}
	}
	stopObserving() {
		if (this._resizeObserver) {
			this._resizeObserver.disconnect();
			this._resizeObserver = null;
		}
	}
	observe(dimension) {
		this.measureReferenceDomElement(true, dimension);
	}
	measureReferenceDomElement(emitEvent, dimension) {
		let observedWidth = 0;
		let observedHeight = 0;
		if (dimension) {
			observedWidth = dimension.width;
			observedHeight = dimension.height;
		} else if (this._referenceDomElement) {
			observedWidth = this._referenceDomElement.clientWidth;
			observedHeight = this._referenceDomElement.clientHeight;
		}
		observedWidth = Math.max(5, observedWidth);
		observedHeight = Math.max(5, observedHeight);
		if (this._width !== observedWidth || this._height !== observedHeight) {
			this._width = observedWidth;
			this._height = observedHeight;
			if (emitEvent) this._onDidChange.fire();
		}
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/config/migrateOptions.js
var EditorSettingMigration = class EditorSettingMigration {
	static {
		this.items = [];
	}
	constructor(key, migrate) {
		this.key = key;
		this.migrate = migrate;
	}
	apply(options) {
		const value = EditorSettingMigration._read(options, this.key);
		const read = (key) => EditorSettingMigration._read(options, key);
		const write = (key, value) => EditorSettingMigration._write(options, key, value);
		this.migrate(value, read, write);
	}
	static _read(source, key) {
		if (typeof source === "undefined" || source === null) return;
		const firstDotIndex = key.indexOf(".");
		if (firstDotIndex >= 0) {
			const firstSegment = key.substring(0, firstDotIndex);
			return this._read(source[firstSegment], key.substring(firstDotIndex + 1));
		}
		return source[key];
	}
	static _write(target, key, value) {
		const firstDotIndex = key.indexOf(".");
		if (firstDotIndex >= 0) {
			const firstSegment = key.substring(0, firstDotIndex);
			target[firstSegment] = target[firstSegment] || {};
			this._write(target[firstSegment], key.substring(firstDotIndex + 1), value);
			return;
		}
		target[key] = value;
	}
};
function registerEditorSettingMigration(key, migrate) {
	EditorSettingMigration.items.push(new EditorSettingMigration(key, migrate));
}
function registerSimpleEditorSettingMigration(key, values) {
	registerEditorSettingMigration(key, (value, read, write) => {
		if (typeof value !== "undefined") {
			for (const [oldValue, newValue] of values) if (value === oldValue) {
				write(key, newValue);
				return;
			}
		}
	});
}
/**
* Compatibility with old options
*/
function migrateOptions(options) {
	EditorSettingMigration.items.forEach((migration) => migration.apply(options));
}
registerSimpleEditorSettingMigration("wordWrap", [[true, "on"], [false, "off"]]);
registerSimpleEditorSettingMigration("lineNumbers", [[true, "on"], [false, "off"]]);
registerSimpleEditorSettingMigration("cursorBlinking", [["visible", "solid"]]);
registerSimpleEditorSettingMigration("renderWhitespace", [[true, "boundary"], [false, "none"]]);
registerSimpleEditorSettingMigration("renderLineHighlight", [[true, "line"], [false, "none"]]);
registerSimpleEditorSettingMigration("acceptSuggestionOnEnter", [[true, "on"], [false, "off"]]);
registerSimpleEditorSettingMigration("tabCompletion", [[false, "off"], [true, "onlySnippets"]]);
registerSimpleEditorSettingMigration("hover", [[true, { enabled: true }], [false, { enabled: false }]]);
registerSimpleEditorSettingMigration("parameterHints", [[true, { enabled: true }], [false, { enabled: false }]]);
registerSimpleEditorSettingMigration("autoIndent", [[false, "advanced"], [true, "full"]]);
registerSimpleEditorSettingMigration("matchBrackets", [[true, "always"], [false, "never"]]);
registerSimpleEditorSettingMigration("renderFinalNewline", [[true, "on"], [false, "off"]]);
registerSimpleEditorSettingMigration("cursorSmoothCaretAnimation", [[true, "on"], [false, "off"]]);
registerSimpleEditorSettingMigration("occurrencesHighlight", [[true, "singleFile"], [false, "off"]]);
registerSimpleEditorSettingMigration("wordBasedSuggestions", [[true, "matchingDocuments"], [false, "off"]]);
registerSimpleEditorSettingMigration("defaultColorDecorators", [[true, "auto"], [false, "never"]]);
registerSimpleEditorSettingMigration("minimap.autohide", [[true, "mouseover"], [false, "none"]]);
registerEditorSettingMigration("autoClosingBrackets", (value, read, write) => {
	if (value === false) {
		write("autoClosingBrackets", "never");
		if (typeof read("autoClosingQuotes") === "undefined") write("autoClosingQuotes", "never");
		if (typeof read("autoSurround") === "undefined") write("autoSurround", "never");
	}
});
registerEditorSettingMigration("renderIndentGuides", (value, read, write) => {
	if (typeof value !== "undefined") {
		write("renderIndentGuides", void 0);
		if (typeof read("guides.indentation") === "undefined") write("guides.indentation", !!value);
	}
});
registerEditorSettingMigration("highlightActiveIndentGuide", (value, read, write) => {
	if (typeof value !== "undefined") {
		write("highlightActiveIndentGuide", void 0);
		if (typeof read("guides.highlightActiveIndentation") === "undefined") write("guides.highlightActiveIndentation", !!value);
	}
});
var suggestFilteredTypesMapping = {
	method: "showMethods",
	function: "showFunctions",
	constructor: "showConstructors",
	deprecated: "showDeprecated",
	field: "showFields",
	variable: "showVariables",
	class: "showClasses",
	struct: "showStructs",
	interface: "showInterfaces",
	module: "showModules",
	property: "showProperties",
	event: "showEvents",
	operator: "showOperators",
	unit: "showUnits",
	value: "showValues",
	constant: "showConstants",
	enum: "showEnums",
	enumMember: "showEnumMembers",
	keyword: "showKeywords",
	text: "showWords",
	color: "showColors",
	file: "showFiles",
	reference: "showReferences",
	folder: "showFolders",
	typeParameter: "showTypeParameters",
	snippet: "showSnippets"
};
registerEditorSettingMigration("suggest.filteredTypes", (value, read, write) => {
	if (value && typeof value === "object") {
		for (const entry of Object.entries(suggestFilteredTypesMapping)) if (value[entry[0]] === false) {
			if (typeof read(`suggest.${entry[1]}`) === "undefined") write(`suggest.${entry[1]}`, false);
		}
		write("suggest.filteredTypes", void 0);
	}
});
registerEditorSettingMigration("quickSuggestions", (input, read, write) => {
	if (typeof input === "boolean") {
		const value = input ? "on" : "off";
		write("quickSuggestions", {
			comments: value,
			strings: value,
			other: value
		});
	}
});
registerEditorSettingMigration("experimental.stickyScroll.enabled", (value, read, write) => {
	if (typeof value === "boolean") {
		write("experimental.stickyScroll.enabled", void 0);
		if (typeof read("stickyScroll.enabled") === "undefined") write("stickyScroll.enabled", value);
	}
});
registerEditorSettingMigration("experimental.stickyScroll.maxLineCount", (value, read, write) => {
	if (typeof value === "number") {
		write("experimental.stickyScroll.maxLineCount", void 0);
		if (typeof read("stickyScroll.maxLineCount") === "undefined") write("stickyScroll.maxLineCount", value);
	}
});
registerEditorSettingMigration("editor.experimentalEditContextEnabled", (value, read, write) => {
	if (typeof value === "boolean") {
		write("editor.experimentalEditContextEnabled", void 0);
		if (typeof read("editor.editContext") === "undefined") write("editor.editContext", value);
	}
});
registerEditorSettingMigration("codeActionsOnSave", (value, read, write) => {
	if (value && typeof value === "object") {
		let toBeModified = false;
		const newValue = {};
		for (const entry of Object.entries(value)) if (typeof entry[1] === "boolean") {
			toBeModified = true;
			newValue[entry[0]] = entry[1] ? "explicit" : "never";
		} else newValue[entry[0]] = entry[1];
		if (toBeModified) write(`codeActionsOnSave`, newValue);
	}
});
registerEditorSettingMigration("codeActionWidget.includeNearbyQuickfixes", (value, read, write) => {
	if (typeof value === "boolean") {
		write("codeActionWidget.includeNearbyQuickfixes", void 0);
		if (typeof read("codeActionWidget.includeNearbyQuickFixes") === "undefined") write("codeActionWidget.includeNearbyQuickFixes", value);
	}
});
registerEditorSettingMigration("lightbulb.enabled", (value, read, write) => {
	if (typeof value === "boolean") write("lightbulb.enabled", value ? void 0 : "off");
});
registerEditorSettingMigration("inlineSuggest.edits.codeShifting", (value, read, write) => {
	if (typeof value === "boolean") {
		write("inlineSuggest.edits.codeShifting", void 0);
		write("inlineSuggest.edits.allowCodeShifting", value ? "always" : "never");
	}
});
registerEditorSettingMigration("hover.enabled", (value, read, write) => {
	if (typeof value === "boolean") write("hover.enabled", value ? "on" : "off");
});
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/config/tabFocus.js
var TabFocusImpl = class extends Disposable {
	constructor() {
		super(...arguments);
		this._tabFocus = false;
		this._onDidChangeTabFocus = this._register(new Emitter$1());
		this.onDidChangeTabFocus = this._onDidChangeTabFocus.event;
	}
	getTabFocusMode() {
		return this._tabFocus;
	}
	setTabFocusMode(tabFocusMode) {
		this._tabFocus = tabFocusMode;
		this._onDidChangeTabFocus.fire(this._tabFocus);
	}
};
/**
* Control what pressing Tab does.
* If it is false, pressing Tab or Shift-Tab will be handled by the editor.
* If it is true, pressing Tab or Shift-Tab will move the browser focus.
* Defaults to false.
*/
var TabFocus = new TabFocusImpl();
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/config/fontInfoFromSettings.js
function createBareFontInfoFromValidatedSettings(options, pixelRatio, ignoreEditorZoom) {
	const fontFamily = options.get(58);
	const fontWeight = options.get(62);
	const fontSize = options.get(61);
	const fontFeatureSettings = options.get(60);
	const fontVariationSettings = options.get(63);
	const lineHeight = options.get(75);
	const letterSpacing = options.get(72);
	return BareFontInfo._create(fontFamily, fontWeight, fontSize, fontFeatureSettings, fontVariationSettings, lineHeight, letterSpacing, pixelRatio, ignoreEditorZoom);
}
function createBareFontInfoFromRawSettings(opts, pixelRatio, ignoreEditorZoom = false) {
	const fontFamily = EditorOptions.fontFamily.validate(opts.fontFamily);
	const fontWeight = EditorOptions.fontWeight.validate(opts.fontWeight);
	const fontSize = EditorOptions.fontSize.validate(opts.fontSize);
	const fontFeatureSettings = EditorOptions.fontLigatures2.validate(opts.fontLigatures);
	const fontVariationSettings = EditorOptions.fontVariations.validate(opts.fontVariations);
	const lineHeight = EditorOptions.lineHeight.validate(opts.lineHeight);
	const letterSpacing = EditorOptions.letterSpacing.validate(opts.letterSpacing);
	return BareFontInfo._create(fontFamily, fontWeight, fontSize, fontFeatureSettings, fontVariationSettings, lineHeight, letterSpacing, pixelRatio, ignoreEditorZoom);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/accessibility/common/accessibility.js
var IAccessibilityService = createDecorator("accessibilityService");
var CONTEXT_ACCESSIBILITY_MODE_ENABLED = new RawContextKey("accessibilityModeEnabled", false);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/inputMode.js
var InputModeImpl = class {
	constructor() {
		this._inputMode = "insert";
		this._onDidChangeInputMode = new Emitter$1();
		this.onDidChangeInputMode = this._onDidChangeInputMode.event;
	}
	getInputMode() {
		return this._inputMode;
	}
};
/**
* Controls the type mode, whether insert or overtype
*/
var InputMode = new InputModeImpl();
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/config/editorConfiguration.js
var __decorate$76 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$69 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var EditorConfiguration = class EditorConfiguration extends Disposable {
	constructor(isSimpleWidget, contextMenuId, options, container, _accessibilityService) {
		super();
		this._accessibilityService = _accessibilityService;
		this._onDidChange = this._register(new Emitter$1());
		this.onDidChange = this._onDidChange.event;
		this._onDidChangeFast = this._register(new Emitter$1());
		this.onDidChangeFast = this._onDidChangeFast.event;
		this._isDominatedByLongLines = false;
		this._viewLineCount = 1;
		this._lineNumbersDigitCount = 1;
		this._reservedHeight = 0;
		this._glyphMarginDecorationLaneCount = 1;
		this._computeOptionsMemory = new ComputeOptionsMemory();
		this.isSimpleWidget = isSimpleWidget;
		this.contextMenuId = contextMenuId;
		this._containerObserver = this._register(new ElementSizeObserver(container, options.dimension));
		this._targetWindowId = getWindow(container).vscodeWindowId;
		this._rawOptions = deepCloneAndMigrateOptions(options);
		this._validatedOptions = EditorOptionsUtil.validateOptions(this._rawOptions);
		this.options = this._computeOptions();
		if (this.options.get(19)) this._containerObserver.startObserving();
		this._register(EditorZoom.onDidChangeZoomLevel(() => this._recomputeOptions()));
		this._register(TabFocus.onDidChangeTabFocus(() => this._recomputeOptions()));
		this._register(this._containerObserver.onDidChange(() => this._recomputeOptions()));
		this._register(FontMeasurements.onDidChange(() => this._recomputeOptions()));
		this._register(PixelRatio.getInstance(getWindow(container)).onDidChange(() => this._recomputeOptions()));
		this._register(this._accessibilityService.onDidChangeScreenReaderOptimized(() => this._recomputeOptions()));
		this._register(InputMode.onDidChangeInputMode(() => this._recomputeOptions()));
	}
	_recomputeOptions() {
		const newOptions = this._computeOptions();
		const changeEvent = EditorOptionsUtil.checkEquals(this.options, newOptions);
		if (changeEvent === null) return;
		this.options = newOptions;
		this._onDidChangeFast.fire(changeEvent);
		this._onDidChange.fire(changeEvent);
	}
	_computeOptions() {
		const partialEnv = this._readEnvConfiguration();
		const bareFontInfo = createBareFontInfoFromValidatedSettings(this._validatedOptions, partialEnv.pixelRatio, this.isSimpleWidget);
		const fontInfo = this._readFontInfo(bareFontInfo);
		const env = {
			memory: this._computeOptionsMemory,
			outerWidth: partialEnv.outerWidth,
			outerHeight: partialEnv.outerHeight - this._reservedHeight,
			fontInfo,
			extraEditorClassName: partialEnv.extraEditorClassName,
			isDominatedByLongLines: this._isDominatedByLongLines,
			viewLineCount: this._viewLineCount,
			lineNumbersDigitCount: this._lineNumbersDigitCount,
			emptySelectionClipboard: partialEnv.emptySelectionClipboard,
			pixelRatio: partialEnv.pixelRatio,
			tabFocusMode: this._validatedOptions.get(165) || TabFocus.getTabFocusMode(),
			inputMode: InputMode.getInputMode(),
			accessibilitySupport: partialEnv.accessibilitySupport,
			glyphMarginDecorationLaneCount: this._glyphMarginDecorationLaneCount,
			editContextSupported: partialEnv.editContextSupported
		};
		return EditorOptionsUtil.computeOptions(this._validatedOptions, env);
	}
	_readEnvConfiguration() {
		return {
			extraEditorClassName: getExtraEditorClassName(),
			outerWidth: this._containerObserver.getWidth(),
			outerHeight: this._containerObserver.getHeight(),
			emptySelectionClipboard: isWebKit || isFirefox,
			pixelRatio: PixelRatio.getInstance(getWindowById(this._targetWindowId, true).window).value,
			editContextSupported: typeof globalThis.EditContext === "function",
			accessibilitySupport: this._accessibilityService.isScreenReaderOptimized() ? 2 : this._accessibilityService.getAccessibilitySupport()
		};
	}
	_readFontInfo(bareFontInfo) {
		return FontMeasurements.readFontInfo(getWindowById(this._targetWindowId, true).window, bareFontInfo);
	}
	getRawOptions() {
		return this._rawOptions;
	}
	updateOptions(_newOptions) {
		const newOptions = deepCloneAndMigrateOptions(_newOptions);
		if (!EditorOptionsUtil.applyUpdate(this._rawOptions, newOptions)) return;
		this._validatedOptions = EditorOptionsUtil.validateOptions(this._rawOptions);
		this._recomputeOptions();
	}
	observeContainer(dimension) {
		this._containerObserver.observe(dimension);
	}
	setIsDominatedByLongLines(isDominatedByLongLines) {
		if (this._isDominatedByLongLines === isDominatedByLongLines) return;
		this._isDominatedByLongLines = isDominatedByLongLines;
		this._recomputeOptions();
	}
	setModelLineCount(modelLineCount) {
		const lineNumbersDigitCount = digitCount(modelLineCount);
		if (this._lineNumbersDigitCount === lineNumbersDigitCount) return;
		this._lineNumbersDigitCount = lineNumbersDigitCount;
		this._recomputeOptions();
	}
	setViewLineCount(viewLineCount) {
		if (this._viewLineCount === viewLineCount) return;
		this._viewLineCount = viewLineCount;
		this._recomputeOptions();
	}
	setReservedHeight(reservedHeight) {
		if (this._reservedHeight === reservedHeight) return;
		this._reservedHeight = reservedHeight;
		this._recomputeOptions();
	}
	setGlyphMarginDecorationLaneCount(decorationLaneCount) {
		if (this._glyphMarginDecorationLaneCount === decorationLaneCount) return;
		this._glyphMarginDecorationLaneCount = decorationLaneCount;
		this._recomputeOptions();
	}
};
EditorConfiguration = __decorate$76([__param$69(4, IAccessibilityService)], EditorConfiguration);
function digitCount(n) {
	let r = 0;
	while (n) {
		n = Math.floor(n / 10);
		r++;
	}
	return r ? r : 1;
}
function getExtraEditorClassName() {
	let extra = "";
	if (isSafari || isWebkitWebView) {
		extra += "no-minimap-shadow ";
		extra += "enable-user-select ";
	} else extra += "no-user-select ";
	if (isMacintosh) extra += "mac ";
	return extra;
}
var ValidatedEditorOptions = class {
	constructor() {
		this._values = [];
	}
	_read(option) {
		return this._values[option];
	}
	get(id) {
		return this._values[id];
	}
	_write(option, value) {
		this._values[option] = value;
	}
};
var ComputedEditorOptions = class {
	constructor() {
		this._values = [];
	}
	_read(id) {
		if (id >= this._values.length) throw new Error("Cannot read uninitialized value");
		return this._values[id];
	}
	get(id) {
		return this._read(id);
	}
	_write(id, value) {
		this._values[id] = value;
	}
};
var EditorOptionsUtil = class EditorOptionsUtil {
	static validateOptions(options) {
		const result = new ValidatedEditorOptions();
		for (const editorOption of editorOptionsRegistry) {
			const value = editorOption.name === "_never_" ? void 0 : options[editorOption.name];
			result._write(editorOption.id, editorOption.validate(value));
		}
		return result;
	}
	static computeOptions(options, env) {
		const result = new ComputedEditorOptions();
		for (const editorOption of editorOptionsRegistry) result._write(editorOption.id, editorOption.compute(env, result, options._read(editorOption.id)));
		return result;
	}
	static _deepEquals(a, b) {
		if (typeof a !== "object" || typeof b !== "object" || !a || !b) return a === b;
		if (Array.isArray(a) || Array.isArray(b)) return Array.isArray(a) && Array.isArray(b) ? equals$1(a, b) : false;
		if (Object.keys(a).length !== Object.keys(b).length) return false;
		for (const key in a) if (!EditorOptionsUtil._deepEquals(a[key], b[key])) return false;
		return true;
	}
	static checkEquals(a, b) {
		const result = [];
		let somethingChanged = false;
		for (const editorOption of editorOptionsRegistry) {
			const changed = !EditorOptionsUtil._deepEquals(a._read(editorOption.id), b._read(editorOption.id));
			result[editorOption.id] = changed;
			if (changed) somethingChanged = true;
		}
		return somethingChanged ? new ConfigurationChangedEvent(result) : null;
	}
	/**
	* Returns true if something changed.
	* Modifies `options`.
	*/
	static applyUpdate(options, update) {
		let changed = false;
		for (const editorOption of editorOptionsRegistry) if (update.hasOwnProperty(editorOption.name)) {
			const result = editorOption.applyUpdate(options[editorOption.name], update[editorOption.name]);
			options[editorOption.name] = result.newValue;
			changed = changed || result.didChange;
		}
		return changed;
	}
};
function deepCloneAndMigrateOptions(_options) {
	const options = deepClone(_options);
	migrateOptions(options);
	return options;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/performance.js
var inputLatency;
(function(inputLatency) {
	const totalKeydownTime = {
		total: 0,
		min: Number.MAX_VALUE,
		max: 0
	};
	const totalInputTime = { ...totalKeydownTime };
	const totalRenderTime = { ...totalKeydownTime };
	const totalInputLatencyTime = { ...totalKeydownTime };
	let measurementsCount = 0;
	/**
	* Observable that increments each time a new input latency sample is recorded.
	* Consumers can use `debouncedObservable` to batch-report after a period of inactivity.
	*/
	inputLatency.sampleCount = observableValue("inputLatency.sampleCount", 0);
	const state = {
		keydown: 0,
		input: 0,
		render: 0
	};
	/**
	* Record the start of the keydown event.
	*/
	function onKeyDown() {
		/** Direct Check C. See explanation in {@link recordIfFinished} */
		recordIfFinished();
		performance.mark("inputlatency/start");
		performance.mark("keydown/start");
		state.keydown = 1;
		queueMicrotask(markKeyDownEnd);
	}
	inputLatency.onKeyDown = onKeyDown;
	/**
	* Mark the end of the keydown event.
	*/
	function markKeyDownEnd() {
		if (state.keydown === 1) {
			performance.mark("keydown/end");
			state.keydown = 2;
		}
	}
	/**
	* Record the start of the beforeinput event.
	*/
	function onBeforeInput() {
		performance.mark("input/start");
		state.input = 1;
		/** Schedule Task A. See explanation in {@link recordIfFinished} */
		scheduleRecordIfFinishedTask();
	}
	inputLatency.onBeforeInput = onBeforeInput;
	/**
	* Record the start of the input event.
	*/
	function onInput() {
		if (state.input === 0) onBeforeInput();
		queueMicrotask(markInputEnd);
	}
	inputLatency.onInput = onInput;
	function markInputEnd() {
		if (state.input === 1) {
			performance.mark("input/end");
			state.input = 2;
		}
	}
	/**
	* Record the start of the keyup event.
	*/
	function onKeyUp() {
		/** Direct Check D. See explanation in {@link recordIfFinished} */
		recordIfFinished();
	}
	inputLatency.onKeyUp = onKeyUp;
	/**
	* Record the start of the selectionchange event.
	*/
	function onSelectionChange() {
		/** Direct Check E. See explanation in {@link recordIfFinished} */
		recordIfFinished();
	}
	inputLatency.onSelectionChange = onSelectionChange;
	/**
	* Record the start of the animation frame performing the rendering.
	*/
	function onRenderStart() {
		if (state.keydown === 2 && state.input === 2 && state.render === 0) {
			performance.mark("render/start");
			state.render = 1;
			queueMicrotask(markRenderEnd);
			/** Schedule Task B. See explanation in {@link recordIfFinished} */
			scheduleRecordIfFinishedTask();
		}
	}
	inputLatency.onRenderStart = onRenderStart;
	/**
	* Mark the end of the animation frame performing the rendering.
	*/
	function markRenderEnd() {
		if (state.render === 1) {
			performance.mark("render/end");
			state.render = 2;
		}
	}
	function scheduleRecordIfFinishedTask() {
		setTimeout(recordIfFinished);
	}
	/**
	* Record the input latency sample if input handling and rendering are finished.
	*
	* The challenge here is that we want to record the latency in such a way that it includes
	* also the layout and painting work the browser does during the animation frame task.
	*
	* Simply scheduling a new task (via `setTimeout`) from the animation frame task would
	* schedule the new task at the end of the task queue (after other code that uses `setTimeout`),
	* so we need to use multiple strategies to make sure our task runs before others:
	*
	* We schedule tasks (A and B):
	*    - we schedule a task A (via a `setTimeout` call) when the input starts in `markInputStart`.
	*      If the animation frame task is scheduled quickly by the browser, then task A has a very good
	*      chance of being the very first task after the animation frame and thus will record the input latency.
	*    - however, if the animation frame task is scheduled a bit later, then task A might execute
	*      before the animation frame task. We therefore schedule another task B from `markRenderStart`.
	*
	* We do direct checks in browser event handlers (C, D, E):
	*    - if the browser has multiple keydown events queued up, they will be scheduled before the `setTimeout` tasks,
	*      so we do a direct check in the keydown event handler (C).
	*    - depending on timing, sometimes the animation frame is scheduled even before the `keyup` event, so we
	*      do a direct check there too (E).
	*    - the browser oftentimes emits a `selectionchange` event after an `input`, so we do a direct check there (D).
	*/
	function recordIfFinished() {
		if (state.keydown === 2 && state.input === 2 && state.render === 2) {
			performance.mark("inputlatency/end");
			performance.measure("keydown", "keydown/start", "keydown/end");
			performance.measure("input", "input/start", "input/end");
			performance.measure("render", "render/start", "render/end");
			performance.measure("inputlatency", "inputlatency/start", "inputlatency/end");
			addMeasure("keydown", totalKeydownTime);
			addMeasure("input", totalInputTime);
			addMeasure("render", totalRenderTime);
			addMeasure("inputlatency", totalInputLatencyTime);
			measurementsCount++;
			inputLatency.sampleCount.set(inputLatency.sampleCount.get() + 1, void 0);
			reset();
		}
	}
	function addMeasure(entryName, cumulativeMeasurement) {
		const duration = performance.getEntriesByName(entryName)[0].duration;
		cumulativeMeasurement.total += duration;
		cumulativeMeasurement.min = Math.min(cumulativeMeasurement.min, duration);
		cumulativeMeasurement.max = Math.max(cumulativeMeasurement.max, duration);
	}
	/**
	* Clear the current sample.
	*/
	function reset() {
		performance.clearMarks("keydown/start");
		performance.clearMarks("keydown/end");
		performance.clearMarks("input/start");
		performance.clearMarks("input/end");
		performance.clearMarks("render/start");
		performance.clearMarks("render/end");
		performance.clearMarks("inputlatency/start");
		performance.clearMarks("inputlatency/end");
		performance.clearMeasures("keydown");
		performance.clearMeasures("input");
		performance.clearMeasures("render");
		performance.clearMeasures("inputlatency");
		state.keydown = 0;
		state.input = 0;
		state.render = 0;
	}
	/**
	* Gets all input latency samples and clears the internal buffers to start recording a new set
	* of samples.
	*/
	function getAndClearMeasurements() {
		if (measurementsCount === 0) return;
		const result = {
			keydown: cumulativeToFinalMeasurement(totalKeydownTime),
			input: cumulativeToFinalMeasurement(totalInputTime),
			render: cumulativeToFinalMeasurement(totalRenderTime),
			total: cumulativeToFinalMeasurement(totalInputLatencyTime),
			sampleCount: measurementsCount
		};
		clearCumulativeMeasurement(totalKeydownTime);
		clearCumulativeMeasurement(totalInputTime);
		clearCumulativeMeasurement(totalRenderTime);
		clearCumulativeMeasurement(totalInputLatencyTime);
		measurementsCount = 0;
		return result;
	}
	inputLatency.getAndClearMeasurements = getAndClearMeasurements;
	function cumulativeToFinalMeasurement(cumulative) {
		return {
			average: cumulative.total / measurementsCount,
			max: cumulative.max,
			min: cumulative.min
		};
	}
	function clearCumulativeMeasurement(cumulative) {
		cumulative.total = 0;
		cumulative.min = Number.MAX_VALUE;
		cumulative.max = 0;
	}
})(inputLatency || (inputLatency = {}));
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/domStylesheets.js
var globalStylesheets = /* @__PURE__ */ new Map();
var WrappedStyleElement = class extends Disposable {
	constructor() {
		super(...arguments);
		this._currentCssStyle = "";
		this._styleSheet = void 0;
	}
	setStyle(cssStyle) {
		if (cssStyle === this._currentCssStyle) return;
		this._currentCssStyle = cssStyle;
		if (!this._styleSheet) this._styleSheet = createStyleSheet(mainWindow.document.head, (s) => s.textContent = cssStyle, this._store);
		else this._styleSheet.textContent = cssStyle;
	}
	dispose() {
		super.dispose();
		this._styleSheet = void 0;
	}
};
function createStyleSheet(container = mainWindow.document.head, beforeAppend, disposableStore) {
	const style = document.createElement("style");
	style.type = "text/css";
	style.media = "screen";
	beforeAppend?.(style);
	container.appendChild(style);
	if (disposableStore) disposableStore.add(toDisposable(() => style.remove()));
	if (container === mainWindow.document.head) {
		const globalStylesheetClones = /* @__PURE__ */ new Set();
		globalStylesheets.set(style, globalStylesheetClones);
		if (disposableStore) disposableStore.add(toDisposable(() => globalStylesheets.delete(style)));
		for (const { window: targetWindow, disposables } of getWindows()) {
			if (targetWindow === mainWindow) continue;
			const cloneDisposable = disposables.add(cloneGlobalStyleSheet(style, globalStylesheetClones, targetWindow));
			disposableStore?.add(cloneDisposable);
		}
	}
	return style;
}
function cloneGlobalStyleSheet(globalStylesheet, globalStylesheetClones, targetWindow) {
	const disposables = new DisposableStore();
	const clone = globalStylesheet.cloneNode(true);
	targetWindow.document.head.appendChild(clone);
	disposables.add(toDisposable(() => clone.remove()));
	for (const rule of globalStylesheet.sheet?.cssRules ?? []) clone.sheet?.insertRule(rule.cssText, clone.sheet?.cssRules.length);
	disposables.add(sharedMutationObserver.observe(globalStylesheet, disposables, {
		childList: true,
		subtree: isFirefox,
		characterData: isFirefox
	})(() => {
		clone.textContent = globalStylesheet.textContent;
	}));
	globalStylesheetClones.add(clone);
	disposables.add(toDisposable(() => globalStylesheetClones.delete(clone)));
	return disposables;
}
var _sharedStyleSheet = null;
function getSharedStyleSheet() {
	if (!_sharedStyleSheet) _sharedStyleSheet = createStyleSheet();
	return _sharedStyleSheet;
}
function createCSSRule(selector, cssText, style = getSharedStyleSheet()) {
	if (!style || !cssText) return;
	style.sheet?.insertRule(`${selector} {${cssText}}`, 0);
	for (const clonedGlobalStylesheet of globalStylesheets.get(style) ?? []) createCSSRule(selector, cssText, clonedGlobalStylesheet);
}
function removeCSSRulesContainingSelector(ruleName, style = getSharedStyleSheet()) {
	if (!style) return;
	const rules = style.sheet?.cssRules ?? [];
	const toDelete = [];
	for (let i = 0; i < rules.length; i++) {
		const rule = rules[i];
		if (isCSSStyleRule(rule) && rule.selectorText.indexOf(ruleName) !== -1) toDelete.push(i);
	}
	for (let i = toDelete.length - 1; i >= 0; i--) style.sheet?.deleteRule(toDelete[i]);
	for (const clonedGlobalStylesheet of globalStylesheets.get(style) ?? []) removeCSSRulesContainingSelector(ruleName, clonedGlobalStylesheet);
}
function isCSSStyleRule(rule) {
	return typeof rule.selectorText === "string";
}
function createStyleSheetFromObservable(css) {
	const store = new DisposableStore();
	const w = store.add(new WrappedStyleElement());
	store.add(autorun((reader) => {
		w.setStyle(css.read(reader));
	}));
	return store;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/globalPointerMoveMonitor.js
var GlobalPointerMoveMonitor = class {
	constructor() {
		this._hooks = new DisposableStore();
		this._pointerMoveCallback = null;
		this._onStopCallback = null;
	}
	dispose() {
		this.stopMonitoring(false);
		this._hooks.dispose();
	}
	stopMonitoring(invokeStopCallback, browserEvent) {
		if (!this.isMonitoring()) return;
		this._hooks.clear();
		this._pointerMoveCallback = null;
		const onStopCallback = this._onStopCallback;
		this._onStopCallback = null;
		if (invokeStopCallback && onStopCallback) onStopCallback(browserEvent);
	}
	isMonitoring() {
		return !!this._pointerMoveCallback;
	}
	startMonitoring(initialElement, pointerId, initialButtons, pointerMoveCallback, onStopCallback) {
		if (this.isMonitoring()) this.stopMonitoring(false);
		this._pointerMoveCallback = pointerMoveCallback;
		this._onStopCallback = onStopCallback;
		let eventSource = initialElement;
		try {
			initialElement.setPointerCapture(pointerId);
			this._hooks.add(toDisposable(() => {
				try {
					initialElement.releasePointerCapture(pointerId);
				} catch (err) {}
			}));
		} catch (err) {
			eventSource = getWindow(initialElement);
		}
		this._hooks.add(addDisposableListener(eventSource, EventType$1.POINTER_MOVE, (e) => {
			if (e.buttons !== initialButtons) {
				this.stopMonitoring(true);
				return;
			}
			e.preventDefault();
			this._pointerMoveCallback(e);
		}));
		this._hooks.add(addDisposableListener(eventSource, EventType$1.POINTER_UP, (e) => this.stopMonitoring(true)));
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/theme/common/colorUtils.js
/**
* Returns the css variable name for the given color identifier. Dots (`.`) are replaced with hyphens (`-`) and
* everything is prefixed with `--vscode-`.
*
* @sample `editorSuggestWidget.background` is `--vscode-editorSuggestWidget-background`.
*/
function asCssVariableName(colorIdent) {
	return `--vscode-${colorIdent.replace(/\./g, "-")}`;
}
function asCssVariable(color) {
	return `var(${asCssVariableName(color)})`;
}
function asCssVariableWithDefault(color, defaultCssValue) {
	return `var(${asCssVariableName(color)}, ${defaultCssValue})`;
}
function isColorDefaults(value) {
	return value !== null && typeof value === "object" && "light" in value && "dark" in value;
}
var Extensions$4 = { ColorContribution: "base.contributions.colors" };
var DEFAULT_COLOR_CONFIG_VALUE = "default";
var ColorRegistry = class extends Disposable {
	constructor() {
		super();
		this._onDidChangeSchema = this._register(new Emitter$1());
		this.onDidChangeSchema = this._onDidChangeSchema.event;
		this.colorSchema = {
			type: "object",
			properties: {}
		};
		this.colorReferenceSchema = {
			type: "string",
			enum: [],
			enumDescriptions: []
		};
		this.colorsById = {};
	}
	registerColor(id, defaults, description, needsTransparency = false, deprecationMessage) {
		const colorContribution = {
			id,
			description,
			defaults,
			needsTransparency,
			deprecationMessage
		};
		this.colorsById[id] = colorContribution;
		const propertySchema = {
			type: "string",
			format: "color-hex",
			defaultSnippets: [{ body: "${1:#ff0000}" }]
		};
		if (deprecationMessage) propertySchema.deprecationMessage = deprecationMessage;
		if (needsTransparency) {
			propertySchema.pattern = "^#(?:(?<rgba>[0-9a-fA-f]{3}[0-9a-eA-E])|(?:[0-9a-fA-F]{6}(?:(?![fF]{2})(?:[0-9a-fA-F]{2}))))?$";
			propertySchema.patternErrorMessage = localize(2124, "This color must be transparent or it will obscure content");
		}
		this.colorSchema.properties[id] = {
			description,
			oneOf: [propertySchema, {
				type: "string",
				const: DEFAULT_COLOR_CONFIG_VALUE,
				description: localize(2125, "Use the default color.")
			}]
		};
		this.colorReferenceSchema.enum.push(id);
		this.colorReferenceSchema.enumDescriptions.push(description);
		this._onDidChangeSchema.fire();
		return id;
	}
	getColors() {
		return Object.keys(this.colorsById).map((id) => this.colorsById[id]);
	}
	resolveDefaultColor(id, theme) {
		const colorDesc = this.colorsById[id];
		if (colorDesc?.defaults) return resolveColorValue(isColorDefaults(colorDesc.defaults) ? colorDesc.defaults[theme.type] : colorDesc.defaults, theme);
	}
	getColorSchema() {
		return this.colorSchema;
	}
	toString() {
		const sorter = (a, b) => {
			const cat1 = a.indexOf(".") === -1 ? 0 : 1;
			const cat2 = b.indexOf(".") === -1 ? 0 : 1;
			if (cat1 !== cat2) return cat1 - cat2;
			return a.localeCompare(b);
		};
		return Object.keys(this.colorsById).sort(sorter).map((k) => `- \`${k}\`: ${this.colorsById[k].description}`).join("\n");
	}
};
var colorRegistry$1 = new ColorRegistry();
Registry.add(Extensions$4.ColorContribution, colorRegistry$1);
function registerColor(id, defaults, description, needsTransparency, deprecationMessage) {
	return colorRegistry$1.registerColor(id, defaults, description, needsTransparency, deprecationMessage);
}
function executeTransform(transform, theme) {
	switch (transform.op) {
		case 0: return resolveColorValue(transform.value, theme)?.darken(transform.factor);
		case 1: return resolveColorValue(transform.value, theme)?.lighten(transform.factor);
		case 2: return resolveColorValue(transform.value, theme)?.transparent(transform.factor);
		case 7: {
			const primaryColor = resolveColorValue(transform.color, theme) || Color.transparent;
			const otherColor = resolveColorValue(transform.with, theme) || Color.transparent;
			return primaryColor.mix(otherColor, transform.ratio);
		}
		case 3: {
			const backgroundColor = resolveColorValue(transform.background, theme);
			if (!backgroundColor) return resolveColorValue(transform.value, theme);
			return resolveColorValue(transform.value, theme)?.makeOpaque(backgroundColor);
		}
		case 4:
			for (const candidate of transform.values) {
				const color = resolveColorValue(candidate, theme);
				if (color) return color;
			}
			return;
		case 6: return resolveColorValue(theme.defines(transform.if) ? transform.then : transform.else, theme);
		case 5: {
			const from = resolveColorValue(transform.value, theme);
			if (!from) return;
			const backgroundColor = resolveColorValue(transform.background, theme);
			if (!backgroundColor) return from.transparent(transform.factor * transform.transparency);
			return from.isDarkerThan(backgroundColor) ? Color.getLighterColor(from, backgroundColor, transform.factor).transparent(transform.transparency) : Color.getDarkerColor(from, backgroundColor, transform.factor).transparent(transform.transparency);
		}
		default: throw assertNever();
	}
}
function darken(colorValue, factor) {
	return {
		op: 0,
		value: colorValue,
		factor
	};
}
function lighten(colorValue, factor) {
	return {
		op: 1,
		value: colorValue,
		factor
	};
}
function transparent(colorValue, factor) {
	return {
		op: 2,
		value: colorValue,
		factor
	};
}
function oneOf(...colorValues) {
	return {
		op: 4,
		values: colorValues
	};
}
function ifDefinedThenElse(ifArg, thenArg, elseArg) {
	return {
		op: 6,
		if: ifArg,
		then: thenArg,
		else: elseArg
	};
}
function lessProminent(colorValue, backgroundColorValue, factor, transparency) {
	return {
		op: 5,
		value: colorValue,
		background: backgroundColorValue,
		factor,
		transparency
	};
}
/**
* @param colorValue Resolve a color value in the context of a theme
*/
function resolveColorValue(colorValue, theme) {
	if (colorValue === null) return;
	else if (typeof colorValue === "string") {
		if (colorValue[0] === "#") return Color.fromHex(colorValue);
		return theme.getColor(colorValue);
	} else if (colorValue instanceof Color) return colorValue;
	else if (typeof colorValue === "object") return executeTransform(colorValue, theme);
}
var workbenchColorsSchemaId = "vscode://schemas/workbench-colors";
var schemaRegistry$1 = Registry.as(Extensions$7.JSONContribution);
schemaRegistry$1.registerSchema(workbenchColorsSchemaId, colorRegistry$1.getColorSchema());
var delayer$1 = new RunOnceScheduler(() => schemaRegistry$1.notifySchemaChanged(workbenchColorsSchemaId), 200);
colorRegistry$1.onDidChangeSchema(() => {
	if (!delayer$1.isScheduled()) delayer$1.schedule();
});
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/theme/common/colors/baseColors.js
var foreground = registerColor("foreground", {
	dark: "#CCCCCC",
	light: "#616161",
	hcDark: "#FFFFFF",
	hcLight: "#292929"
}, localize(1871, "Overall foreground color. This color is only used if not overridden by a component."));
registerColor("strongForeground", {
	dark: "#FFFFFF",
	light: "#000000",
	hcDark: "#FFFFFF",
	hcLight: "#000000"
}, localize(1872, "Highest-contrast foreground color, intended for text or icons that need maximum legibility across various backgrounds. This color is only used if not overridden by a component."));
registerColor("disabledForeground", {
	dark: "#CCCCCC80",
	light: "#61616180",
	hcDark: "#A5A5A5",
	hcLight: "#7F7F7F"
}, localize(1873, "Overall foreground for disabled elements. This color is only used if not overridden by a component."));
registerColor("errorForeground", {
	dark: "#F48771",
	light: "#A1260D",
	hcDark: "#F48771",
	hcLight: "#B5200D"
}, localize(1874, "Overall foreground color for error messages. This color is only used if not overridden by a component."));
var descriptionForeground = registerColor("descriptionForeground", {
	light: "#717171",
	dark: transparent(foreground, .7),
	hcDark: transparent(foreground, .7),
	hcLight: transparent(foreground, .7)
}, localize(1875, "Foreground color for description text providing additional information, for example for a label."));
var iconForeground = registerColor("icon.foreground", {
	dark: "#C5C5C5",
	light: "#424242",
	hcDark: "#FFFFFF",
	hcLight: "#292929"
}, localize(1876, "The default color for icons in the workbench."));
var focusBorder = registerColor("focusBorder", {
	dark: "#007FD4",
	light: "#0090F1",
	hcDark: "#F38518",
	hcLight: "#006BBD"
}, localize(1877, "Overall border color for focused elements. This color is only used if not overridden by a component."));
var contrastBorder = registerColor("contrastBorder", {
	light: null,
	dark: null,
	hcDark: "#6FC3DF",
	hcLight: "#0F4A85"
}, localize(1878, "An extra border around elements to separate them from others for greater contrast."));
var activeContrastBorder = registerColor("contrastActiveBorder", {
	light: null,
	dark: null,
	hcDark: focusBorder,
	hcLight: focusBorder
}, localize(1879, "An extra border around active elements to separate them from others for greater contrast."));
registerColor("selection.background", null, localize(1880, "The background color of text selections in the workbench (e.g. for input fields or text areas). Note that this does not apply to selections within the editor."));
var textLinkForeground = registerColor("textLink.foreground", {
	light: "#006AB1",
	dark: "#3794FF",
	hcDark: "#21A6FF",
	hcLight: "#0F4A85"
}, localize(1881, "Foreground color for links in text."));
registerColor("textLink.activeForeground", {
	light: "#006AB1",
	dark: "#3794FF",
	hcDark: "#21A6FF",
	hcLight: "#0F4A85"
}, localize(1882, "Foreground color for links in text when clicked on and on mouse hover."));
registerColor("textSeparator.foreground", {
	light: "#0000002e",
	dark: "#ffffff2e",
	hcDark: Color.black,
	hcLight: "#292929"
}, localize(1883, "Color for text separators."));
registerColor("textPreformat.foreground", {
	light: "#A31515",
	dark: "#D7BA7D",
	hcDark: "#FFFFFF",
	hcLight: "#FFFFFF"
}, localize(1884, "Foreground color for preformatted text segments."));
registerColor("textPreformat.background", {
	light: "#0000001A",
	dark: "#FFFFFF1A",
	hcDark: null,
	hcLight: "#09345f"
}, localize(1885, "Background color for preformatted text segments."));
registerColor("textPreformat.border", {
	light: null,
	dark: null,
	hcDark: contrastBorder,
	hcLight: null
}, localize(1886, "Border color for preformatted text segments."));
registerColor("textBlockQuote.background", {
	light: "#f2f2f2",
	dark: "#222222",
	hcDark: null,
	hcLight: "#F2F2F2"
}, localize(1887, "Background color for block quotes in text."));
registerColor("textBlockQuote.border", {
	light: "#007acc80",
	dark: "#007acc80",
	hcDark: Color.white,
	hcLight: "#292929"
}, localize(1888, "Border color for block quotes in text."));
registerColor("textCodeBlock.background", {
	light: "#dcdcdc66",
	dark: "#0a0a0a66",
	hcDark: Color.black,
	hcLight: "#F2F2F2"
}, localize(1889, "Background color for code blocks in text."));
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/theme/common/colors/miscColors.js
registerColor("sash.hoverBorder", focusBorder, localize(2095, "Border color of active sashes."));
var badgeBackground = registerColor("badge.background", {
	dark: "#4D4D4D",
	light: "#C4C4C4",
	hcDark: Color.black,
	hcLight: "#0F4A85"
}, localize(2096, "Badge background color. Badges are small information labels, e.g. for search results count."));
var badgeForeground = registerColor("badge.foreground", {
	dark: Color.white,
	light: "#333",
	hcDark: Color.white,
	hcLight: Color.white
}, localize(2097, "Badge foreground color. Badges are small information labels, e.g. for search results count."));
registerColor("activityWarningBadge.foreground", {
	dark: Color.white,
	light: Color.white,
	hcDark: Color.white,
	hcLight: Color.white
}, localize(2098, "Foreground color of the warning activity badge"));
registerColor("activityWarningBadge.background", {
	dark: "#B27C00",
	light: "#B27C00",
	hcDark: null,
	hcLight: "#B27C00"
}, localize(2099, "Background color of the warning activity badge"));
registerColor("activityErrorBadge.foreground", {
	dark: Color.black.lighten(.2),
	light: Color.white,
	hcDark: null,
	hcLight: Color.black.lighten(.2)
}, localize(2100, "Foreground color of the error activity badge"));
registerColor("activityErrorBadge.background", {
	dark: "#F14C4C",
	light: "#E51400",
	hcDark: null,
	hcLight: "#F14C4C"
}, localize(2101, "Background color of the error activity badge"));
var scrollbarShadow = registerColor("scrollbar.shadow", {
	dark: "#000000",
	light: "#DDDDDD",
	hcDark: null,
	hcLight: null
}, localize(2102, "Scrollbar shadow to indicate that the view is scrolled."));
var scrollbarSliderBackground = registerColor("scrollbarSlider.background", {
	dark: Color.fromHex("#797979").transparent(.4),
	light: Color.fromHex("#646464").transparent(.4),
	hcDark: transparent(contrastBorder, .6),
	hcLight: transparent(contrastBorder, .4)
}, localize(2103, "Scrollbar slider background color."));
var scrollbarSliderHoverBackground = registerColor("scrollbarSlider.hoverBackground", {
	dark: Color.fromHex("#646464").transparent(.7),
	light: Color.fromHex("#646464").transparent(.7),
	hcDark: transparent(contrastBorder, .8),
	hcLight: transparent(contrastBorder, .8)
}, localize(2104, "Scrollbar slider background color when hovering."));
var scrollbarSliderActiveBackground = registerColor("scrollbarSlider.activeBackground", {
	dark: Color.fromHex("#BFBFBF").transparent(.4),
	light: Color.fromHex("#000000").transparent(.6),
	hcDark: contrastBorder,
	hcLight: contrastBorder
}, localize(2105, "Scrollbar slider background color when clicked on."));
registerColor("scrollbar.background", null, localize(2106, "Scrollbar track background color."));
var progressBarBackground = registerColor("progressBar.background", {
	dark: Color.fromHex("#0E70C0"),
	light: Color.fromHex("#0E70C0"),
	hcDark: contrastBorder,
	hcLight: contrastBorder
}, localize(2107, "Background color of the progress bar that can show for long running operations."));
registerColor("chart.line", {
	dark: "#236B8E",
	light: "#236B8E",
	hcDark: "#236B8E",
	hcLight: "#236B8E"
}, localize(2108, "Line color for the chart."));
registerColor("chart.axis", {
	dark: Color.fromHex("#BFBFBF").transparent(.4),
	light: Color.fromHex("#000000").transparent(.6),
	hcDark: contrastBorder,
	hcLight: contrastBorder
}, localize(2109, "Axis color for the chart."));
registerColor("chart.guide", {
	dark: Color.fromHex("#BFBFBF").transparent(.2),
	light: Color.fromHex("#000000").transparent(.2),
	hcDark: contrastBorder,
	hcLight: contrastBorder
}, localize(2110, "Guide line for the chart."));
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/theme/common/colors/editorColors.js
var editorBackground = registerColor("editor.background", {
	light: "#ffffff",
	dark: "#1E1E1E",
	hcDark: Color.black,
	hcLight: Color.white
}, localize(1898, "Editor background color."));
var editorForeground = registerColor("editor.foreground", {
	light: "#333333",
	dark: "#BBBBBB",
	hcDark: Color.white,
	hcLight: foreground
}, localize(1899, "Editor default foreground color."));
registerColor("editorStickyScroll.background", editorBackground, localize(1900, "Background color of sticky scroll in the editor"));
registerColor("editorStickyScrollGutter.background", editorBackground, localize(1901, "Background color of the gutter part of sticky scroll in the editor"));
registerColor("editorStickyScrollHover.background", {
	dark: "#2A2D2E",
	light: "#F0F0F0",
	hcDark: null,
	hcLight: Color.fromHex("#0F4A85").transparent(.1)
}, localize(1902, "Background color of sticky scroll on hover in the editor"));
registerColor("editorStickyScroll.border", {
	dark: null,
	light: null,
	hcDark: contrastBorder,
	hcLight: contrastBorder
}, localize(1903, "Border color of sticky scroll in the editor"));
registerColor("editorStickyScroll.shadow", scrollbarShadow, localize(1904, " Shadow color of sticky scroll in the editor"));
var editorWidgetBackground = registerColor("editorWidget.background", {
	dark: "#252526",
	light: "#F3F3F3",
	hcDark: "#0C141F",
	hcLight: Color.white
}, localize(1905, "Background color of editor widgets, such as find/replace."));
var editorWidgetForeground = registerColor("editorWidget.foreground", foreground, localize(1906, "Foreground color of editor widgets, such as find/replace."));
var editorWidgetBorder = registerColor("editorWidget.border", {
	dark: transparent(editorWidgetForeground, .2),
	light: transparent(editorWidgetForeground, .2),
	hcDark: contrastBorder,
	hcLight: contrastBorder
}, localize(1907, "Border color of editor widgets. The color is only used if the widget chooses to have a border and if the color is not overridden by a widget."));
registerColor("editorWidget.resizeBorder", null, localize(1908, "Border color of the resize bar of editor widgets. The color is only used if the widget chooses to have a resize border and if the color is not overridden by a widget."));
registerColor("editorError.background", null, localize(1909, "Background color of error text in the editor. The color must not be opaque so as not to hide underlying decorations."), true);
var editorErrorForeground = registerColor("editorError.foreground", {
	dark: "#F14C4C",
	light: "#E51400",
	hcDark: "#F48771",
	hcLight: "#B5200D"
}, localize(1910, "Foreground color of error squigglies in the editor."));
var editorErrorBorder = registerColor("editorError.border", {
	dark: null,
	light: null,
	hcDark: Color.fromHex("#E47777").transparent(.8),
	hcLight: "#B5200D"
}, localize(1911, "If set, color of double underlines for errors in the editor."));
var editorWarningBackground = registerColor("editorWarning.background", null, localize(1912, "Background color of warning text in the editor. The color must not be opaque so as not to hide underlying decorations."), true);
var editorWarningForeground = registerColor("editorWarning.foreground", {
	dark: "#CCA700",
	light: "#BF8803",
	hcDark: "#FFD370",
	hcLight: "#895503"
}, localize(1913, "Foreground color of warning squigglies in the editor."));
var editorWarningBorder = registerColor("editorWarning.border", {
	dark: null,
	light: null,
	hcDark: Color.fromHex("#FFCC00").transparent(.8),
	hcLight: Color.fromHex("#FFCC00").transparent(.8)
}, localize(1914, "If set, color of double underlines for warnings in the editor."));
registerColor("editorInfo.background", null, localize(1915, "Background color of info text in the editor. The color must not be opaque so as not to hide underlying decorations."), true);
var editorInfoForeground = registerColor("editorInfo.foreground", {
	dark: "#59a4f9",
	light: "#0063d3",
	hcDark: "#59a4f9",
	hcLight: "#0063d3"
}, localize(1916, "Foreground color of info squigglies in the editor."));
var editorInfoBorder = registerColor("editorInfo.border", {
	dark: null,
	light: null,
	hcDark: Color.fromHex("#59a4f9").transparent(.8),
	hcLight: "#292929"
}, localize(1917, "If set, color of double underlines for infos in the editor."));
var editorHintForeground = registerColor("editorHint.foreground", {
	dark: Color.fromHex("#eeeeee").transparent(.7),
	light: "#6c6c6c",
	hcDark: null,
	hcLight: null
}, localize(1918, "Foreground color of hint squigglies in the editor."));
registerColor("editorHint.border", {
	dark: null,
	light: null,
	hcDark: Color.fromHex("#eeeeee").transparent(.8),
	hcLight: "#292929"
}, localize(1919, "If set, color of double underlines for hints in the editor."));
var editorActiveLinkForeground = registerColor("editorLink.activeForeground", {
	dark: "#4E94CE",
	light: Color.blue,
	hcDark: Color.cyan,
	hcLight: "#292929"
}, localize(1920, "Color of active links."));
var editorSelectionBackground = registerColor("editor.selectionBackground", {
	light: "#ADD6FF",
	dark: "#264F78",
	hcDark: "#f3f518",
	hcLight: "#0F4A85"
}, localize(1921, "Color of the editor selection."));
var editorSelectionForeground = registerColor("editor.selectionForeground", {
	light: null,
	dark: null,
	hcDark: "#000000",
	hcLight: Color.white
}, localize(1922, "Color of the selected text for high contrast."));
var editorInactiveSelection = registerColor("editor.inactiveSelectionBackground", {
	light: transparent(editorSelectionBackground, .5),
	dark: transparent(editorSelectionBackground, .5),
	hcDark: transparent(editorSelectionBackground, .7),
	hcLight: transparent(editorSelectionBackground, .5)
}, localize(1923, "Color of the selection in an inactive editor. The color must not be opaque so as not to hide underlying decorations."), true);
var editorSelectionHighlight = registerColor("editor.selectionHighlightBackground", {
	light: lessProminent(editorSelectionBackground, editorBackground, .3, .6),
	dark: lessProminent(editorSelectionBackground, editorBackground, .3, .6),
	hcDark: null,
	hcLight: null
}, localize(1924, "Color for regions with the same content as the selection. The color must not be opaque so as not to hide underlying decorations."), true);
registerColor("editor.selectionHighlightBorder", {
	light: null,
	dark: null,
	hcDark: activeContrastBorder,
	hcLight: activeContrastBorder
}, localize(1925, "Border color for regions with the same content as the selection."));
registerColor("editor.compositionBorder", {
	light: "#000000",
	dark: "#ffffff",
	hcLight: "#000000",
	hcDark: "#ffffff"
}, localize(1926, "The border color for an IME composition."));
registerColor("editor.findMatchBackground", {
	light: "#A8AC94",
	dark: "#515C6A",
	hcDark: null,
	hcLight: null
}, localize(1927, "Color of the current search match."));
var editorFindMatchForeground = registerColor("editor.findMatchForeground", null, localize(1928, "Text color of the current search match."));
var editorFindMatchHighlight = registerColor("editor.findMatchHighlightBackground", {
	light: "#EA5C0055",
	dark: "#EA5C0055",
	hcDark: null,
	hcLight: null
}, localize(1929, "Color of the other search matches. The color must not be opaque so as not to hide underlying decorations."), true);
var editorFindMatchHighlightForeground = registerColor("editor.findMatchHighlightForeground", null, localize(1930, "Foreground color of the other search matches."), true);
registerColor("editor.findRangeHighlightBackground", {
	dark: "#3a3d4166",
	light: "#b4b4b44d",
	hcDark: null,
	hcLight: null
}, localize(1931, "Color of the range limiting the search. The color must not be opaque so as not to hide underlying decorations."), true);
registerColor("editor.findMatchBorder", {
	light: null,
	dark: null,
	hcDark: activeContrastBorder,
	hcLight: activeContrastBorder
}, localize(1932, "Border color of the current search match."));
var editorFindMatchHighlightBorder = registerColor("editor.findMatchHighlightBorder", {
	light: null,
	dark: null,
	hcDark: activeContrastBorder,
	hcLight: activeContrastBorder
}, localize(1933, "Border color of the other search matches."));
var editorFindRangeHighlightBorder = registerColor("editor.findRangeHighlightBorder", {
	dark: null,
	light: null,
	hcDark: transparent(activeContrastBorder, .4),
	hcLight: transparent(activeContrastBorder, .4)
}, localize(1934, "Border color of the range limiting the search. The color must not be opaque so as not to hide underlying decorations."), true);
registerColor("editor.hoverHighlightBackground", {
	light: "#ADD6FF26",
	dark: "#264f7840",
	hcDark: "#ADD6FF26",
	hcLight: null
}, localize(1935, "Highlight below the word for which a hover is shown. The color must not be opaque so as not to hide underlying decorations."), true);
var editorHoverBackground = registerColor("editorHoverWidget.background", editorWidgetBackground, localize(1936, "Background color of the editor hover."));
var editorHoverForeground = registerColor("editorHoverWidget.foreground", editorWidgetForeground, localize(1937, "Foreground color of the editor hover."));
var editorHoverBorder = registerColor("editorHoverWidget.border", editorWidgetBorder, localize(1938, "Border color of the editor hover."));
registerColor("editorHoverWidget.statusBarBackground", {
	dark: lighten(editorHoverBackground, .2),
	light: darken(editorHoverBackground, .05),
	hcDark: editorWidgetBackground,
	hcLight: editorWidgetBackground
}, localize(1939, "Background color of the editor hover status bar."));
var editorInlayHintForeground = registerColor("editorInlayHint.foreground", {
	dark: "#969696",
	light: "#969696",
	hcDark: Color.white,
	hcLight: Color.black
}, localize(1940, "Foreground color of inline hints"));
var editorInlayHintBackground = registerColor("editorInlayHint.background", {
	dark: transparent(badgeBackground, .1),
	light: transparent(badgeBackground, .1),
	hcDark: transparent(Color.white, .1),
	hcLight: transparent(badgeBackground, .1)
}, localize(1941, "Background color of inline hints"));
var editorInlayHintTypeForeground = registerColor("editorInlayHint.typeForeground", editorInlayHintForeground, localize(1942, "Foreground color of inline hints for types"));
var editorInlayHintTypeBackground = registerColor("editorInlayHint.typeBackground", editorInlayHintBackground, localize(1943, "Background color of inline hints for types"));
var editorInlayHintParameterForeground = registerColor("editorInlayHint.parameterForeground", editorInlayHintForeground, localize(1944, "Foreground color of inline hints for parameters"));
var editorInlayHintParameterBackground = registerColor("editorInlayHint.parameterBackground", editorInlayHintBackground, localize(1945, "Background color of inline hints for parameters"));
var editorLightBulbForeground = registerColor("editorLightBulb.foreground", {
	dark: "#FFCC00",
	light: "#DDB100",
	hcDark: "#FFCC00",
	hcLight: "#007ACC"
}, localize(1946, "The color used for the lightbulb actions icon."));
registerColor("editorLightBulbAutoFix.foreground", {
	dark: "#75BEFF",
	light: "#007ACC",
	hcDark: "#75BEFF",
	hcLight: "#007ACC"
}, localize(1947, "The color used for the lightbulb auto fix actions icon."));
registerColor("editorLightBulbAi.foreground", editorLightBulbForeground, localize(1948, "The color used for the lightbulb AI icon."));
registerColor("editor.snippetTabstopHighlightBackground", {
	dark: new Color(new RGBA(124, 124, 124, .3)),
	light: new Color(new RGBA(10, 50, 100, .2)),
	hcDark: new Color(new RGBA(124, 124, 124, .3)),
	hcLight: new Color(new RGBA(10, 50, 100, .2))
}, localize(1949, "Highlight background color of a snippet tabstop."));
registerColor("editor.snippetTabstopHighlightBorder", null, localize(1950, "Highlight border color of a snippet tabstop."));
registerColor("editor.snippetFinalTabstopHighlightBackground", null, localize(1951, "Highlight background color of the final tabstop of a snippet."));
registerColor("editor.snippetFinalTabstopHighlightBorder", {
	dark: "#525252",
	light: new Color(new RGBA(10, 50, 100, .5)),
	hcDark: "#525252",
	hcLight: "#292929"
}, localize(1952, "Highlight border color of the final tabstop of a snippet."));
var defaultInsertColor = new Color(new RGBA(155, 185, 85, .2));
var defaultRemoveColor = new Color(new RGBA(255, 0, 0, .2));
var diffInserted = registerColor("diffEditor.insertedTextBackground", {
	dark: "#9ccc2c33",
	light: "#9ccc2c40",
	hcDark: null,
	hcLight: null
}, localize(1953, "Background color for text that got inserted. The color must not be opaque so as not to hide underlying decorations."), true);
var diffRemoved = registerColor("diffEditor.removedTextBackground", {
	dark: "#ff000033",
	light: "#ff000033",
	hcDark: null,
	hcLight: null
}, localize(1954, "Background color for text that got removed. The color must not be opaque so as not to hide underlying decorations."), true);
var diffInsertedLine = registerColor("diffEditor.insertedLineBackground", {
	dark: defaultInsertColor,
	light: defaultInsertColor,
	hcDark: null,
	hcLight: null
}, localize(1955, "Background color for lines that got inserted. The color must not be opaque so as not to hide underlying decorations."), true);
registerColor("diffEditor.removedLineBackground", {
	dark: defaultRemoveColor,
	light: defaultRemoveColor,
	hcDark: null,
	hcLight: null
}, localize(1956, "Background color for lines that got removed. The color must not be opaque so as not to hide underlying decorations."), true);
registerColor("diffEditorGutter.insertedLineBackground", null, localize(1957, "Background color for the margin where lines got inserted."));
registerColor("diffEditorGutter.removedLineBackground", null, localize(1958, "Background color for the margin where lines got removed."));
var diffOverviewRulerInserted = registerColor("diffEditorOverview.insertedForeground", null, localize(1959, "Diff overview ruler foreground for inserted content."));
var diffOverviewRulerRemoved = registerColor("diffEditorOverview.removedForeground", null, localize(1960, "Diff overview ruler foreground for removed content."));
registerColor("diffEditor.insertedTextBorder", {
	dark: null,
	light: null,
	hcDark: "#33ff2eff",
	hcLight: "#374E06"
}, localize(1961, "Outline color for the text that got inserted."));
registerColor("diffEditor.removedTextBorder", {
	dark: null,
	light: null,
	hcDark: "#FF008F",
	hcLight: "#AD0707"
}, localize(1962, "Outline color for text that got removed."));
registerColor("diffEditor.border", {
	dark: null,
	light: null,
	hcDark: contrastBorder,
	hcLight: contrastBorder
}, localize(1963, "Border color between the two text editors."));
registerColor("diffEditor.diagonalFill", {
	dark: "#cccccc33",
	light: "#22222233",
	hcDark: null,
	hcLight: null
}, localize(1964, "Color of the diff editor's diagonal fill. The diagonal fill is used in side-by-side diff views."));
registerColor("diffEditor.unchangedRegionBackground", "sideBar.background", localize(1965, "The background color of unchanged blocks in the diff editor."));
registerColor("diffEditor.unchangedRegionForeground", "foreground", localize(1966, "The foreground color of unchanged blocks in the diff editor."));
registerColor("diffEditor.unchangedCodeBackground", {
	dark: "#74747429",
	light: "#b8b8b829",
	hcDark: null,
	hcLight: null
}, localize(1967, "The background color of unchanged code in the diff editor."));
var widgetShadow = registerColor("widget.shadow", {
	dark: transparent(Color.black, .36),
	light: transparent(Color.black, .16),
	hcDark: null,
	hcLight: null
}, localize(1968, "Shadow color of widgets such as find/replace inside the editor."));
var widgetBorder = registerColor("widget.border", {
	dark: null,
	light: null,
	hcDark: contrastBorder,
	hcLight: contrastBorder
}, localize(1969, "Border color of widgets such as find/replace inside the editor."));
var toolbarHoverBackground = registerColor("toolbar.hoverBackground", {
	dark: "#5a5d5e50",
	light: "#b8b8b850",
	hcDark: null,
	hcLight: null
}, localize(1970, "Toolbar background when hovering over actions using the mouse"));
registerColor("toolbar.hoverOutline", {
	dark: null,
	light: null,
	hcDark: activeContrastBorder,
	hcLight: activeContrastBorder
}, localize(1971, "Toolbar outline when hovering over actions using the mouse"));
registerColor("toolbar.activeBackground", {
	dark: lighten(toolbarHoverBackground, .1),
	light: darken(toolbarHoverBackground, .1),
	hcDark: null,
	hcLight: null
}, localize(1972, "Toolbar background when holding the mouse over actions"));
var breadcrumbsForeground = registerColor("breadcrumb.foreground", transparent(foreground, .8), localize(1973, "Color of focused breadcrumb items."));
var breadcrumbsBackground = registerColor("breadcrumb.background", editorBackground, localize(1974, "Background color of breadcrumb items."));
var breadcrumbsFocusForeground = registerColor("breadcrumb.focusForeground", {
	light: darken(foreground, .2),
	dark: lighten(foreground, .1),
	hcDark: lighten(foreground, .1),
	hcLight: lighten(foreground, .1)
}, localize(1975, "Color of focused breadcrumb items."));
var breadcrumbsActiveSelectionForeground = registerColor("breadcrumb.activeSelectionForeground", {
	light: darken(foreground, .2),
	dark: lighten(foreground, .1),
	hcDark: lighten(foreground, .1),
	hcLight: lighten(foreground, .1)
}, localize(1976, "Color of selected breadcrumb items."));
registerColor("breadcrumbPicker.background", editorWidgetBackground, localize(1977, "Background color of breadcrumb item picker."));
var headerTransparency = .5;
var currentBaseColor = Color.fromHex("#40C8AE").transparent(headerTransparency);
var incomingBaseColor = Color.fromHex("#40A6FF").transparent(headerTransparency);
var commonBaseColor = Color.fromHex("#606060").transparent(.4);
var contentTransparency = .4;
var rulerTransparency = 1;
var mergeCurrentHeaderBackground = registerColor("merge.currentHeaderBackground", {
	dark: currentBaseColor,
	light: currentBaseColor,
	hcDark: null,
	hcLight: null
}, localize(1978, "Current header background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), true);
registerColor("merge.currentContentBackground", transparent(mergeCurrentHeaderBackground, contentTransparency), localize(1979, "Current content background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), true);
var mergeIncomingHeaderBackground = registerColor("merge.incomingHeaderBackground", {
	dark: incomingBaseColor,
	light: incomingBaseColor,
	hcDark: null,
	hcLight: null
}, localize(1980, "Incoming header background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), true);
registerColor("merge.incomingContentBackground", transparent(mergeIncomingHeaderBackground, contentTransparency), localize(1981, "Incoming content background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), true);
var mergeCommonHeaderBackground = registerColor("merge.commonHeaderBackground", {
	dark: commonBaseColor,
	light: commonBaseColor,
	hcDark: null,
	hcLight: null
}, localize(1982, "Common ancestor header background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), true);
registerColor("merge.commonContentBackground", transparent(mergeCommonHeaderBackground, contentTransparency), localize(1983, "Common ancestor content background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), true);
var mergeBorder = registerColor("merge.border", {
	dark: null,
	light: null,
	hcDark: "#C3DF6F",
	hcLight: "#007ACC"
}, localize(1984, "Border color on headers and the splitter in inline merge-conflicts."));
registerColor("editorOverviewRuler.currentContentForeground", {
	dark: transparent(mergeCurrentHeaderBackground, rulerTransparency),
	light: transparent(mergeCurrentHeaderBackground, rulerTransparency),
	hcDark: mergeBorder,
	hcLight: mergeBorder
}, localize(1985, "Current overview ruler foreground for inline merge-conflicts."));
registerColor("editorOverviewRuler.incomingContentForeground", {
	dark: transparent(mergeIncomingHeaderBackground, rulerTransparency),
	light: transparent(mergeIncomingHeaderBackground, rulerTransparency),
	hcDark: mergeBorder,
	hcLight: mergeBorder
}, localize(1986, "Incoming overview ruler foreground for inline merge-conflicts."));
registerColor("editorOverviewRuler.commonContentForeground", {
	dark: transparent(mergeCommonHeaderBackground, rulerTransparency),
	light: transparent(mergeCommonHeaderBackground, rulerTransparency),
	hcDark: mergeBorder,
	hcLight: mergeBorder
}, localize(1987, "Common ancestor overview ruler foreground for inline merge-conflicts."));
var overviewRulerFindMatchForeground = registerColor("editorOverviewRuler.findMatchForeground", {
	dark: "#d186167e",
	light: "#d186167e",
	hcDark: "#AB5A00",
	hcLight: "#AB5A00"
}, localize(1988, "Overview ruler marker color for find matches. The color must not be opaque so as not to hide underlying decorations."), true);
var overviewRulerSelectionHighlightForeground = registerColor("editorOverviewRuler.selectionHighlightForeground", "#A0A0A0CC", localize(1989, "Overview ruler marker color for selection highlights. The color must not be opaque so as not to hide underlying decorations."), true);
var problemsErrorIconForeground = registerColor("problemsErrorIcon.foreground", editorErrorForeground, localize(1990, "The color used for the problems error icon."));
var problemsWarningIconForeground = registerColor("problemsWarningIcon.foreground", editorWarningForeground, localize(1991, "The color used for the problems warning icon."));
var problemsInfoIconForeground = registerColor("problemsInfoIcon.foreground", editorInfoForeground, localize(1992, "The color used for the problems info icon."));
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/theme/common/colors/minimapColors.js
var minimapFindMatch = registerColor("minimap.findMatchHighlight", editorFindMatchHighlight, localize(2084, "Minimap marker color for find matches."), true);
var minimapSelectionOccurrenceHighlight = registerColor("minimap.selectionOccurrenceHighlight", editorSelectionHighlight, localize(2085, "Minimap marker color for repeating editor selections."), true);
var minimapSelection = registerColor("minimap.selectionHighlight", editorSelectionBackground, localize(2086, "Minimap marker color for the editor selection."), true);
var minimapInfo = registerColor("minimap.infoHighlight", {
	dark: editorInfoForeground,
	light: editorInfoForeground,
	hcDark: editorInfoBorder,
	hcLight: editorInfoBorder
}, localize(2087, "Minimap marker color for infos."));
var minimapWarning = registerColor("minimap.warningHighlight", {
	dark: editorWarningForeground,
	light: editorWarningForeground,
	hcDark: editorWarningBorder,
	hcLight: editorWarningBorder
}, localize(2088, "Minimap marker color for warnings."));
var minimapError = registerColor("minimap.errorHighlight", {
	dark: new Color(new RGBA(255, 18, 18, .7)),
	light: new Color(new RGBA(255, 18, 18, .7)),
	hcDark: new Color(new RGBA(255, 50, 50, 1)),
	hcLight: "#B5200D"
}, localize(2089, "Minimap marker color for errors."));
var minimapBackground = registerColor("minimap.background", null, localize(2090, "Minimap background color."));
var minimapForegroundOpacity = registerColor("minimap.foregroundOpacity", Color.fromHex("#000f"), localize(2091, "Opacity of foreground elements rendered in the minimap. For example, \"#000000c0\" will render the elements with 75% opacity."));
registerColor("minimapSlider.background", transparent(scrollbarSliderBackground, .5), localize(2092, "Minimap slider background color."));
registerColor("minimapSlider.hoverBackground", transparent(scrollbarSliderHoverBackground, .5), localize(2093, "Minimap slider background color when hovering."));
registerColor("minimapSlider.activeBackground", transparent(scrollbarSliderActiveBackground, .5), localize(2094, "Minimap slider background color when clicked on."));
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/theme/common/colors/chartsColors.js
registerColor("charts.foreground", foreground, localize(1890, "The foreground color used in charts."));
registerColor("charts.lines", transparent(foreground, .5), localize(1891, "The color used for horizontal lines in charts."));
registerColor("charts.red", editorErrorForeground, localize(1892, "The red color used in chart visualizations."));
registerColor("charts.blue", editorInfoForeground, localize(1893, "The blue color used in chart visualizations."));
registerColor("charts.yellow", editorWarningForeground, localize(1894, "The yellow color used in chart visualizations."));
registerColor("charts.orange", minimapFindMatch, localize(1895, "The orange color used in chart visualizations."));
registerColor("charts.green", {
	dark: "#89D185",
	light: "#388A34",
	hcDark: "#89D185",
	hcLight: "#374e06"
}, localize(1896, "The green color used in chart visualizations."));
registerColor("charts.purple", {
	dark: "#B180D7",
	light: "#652D90",
	hcDark: "#B180D7",
	hcLight: "#652D90"
}, localize(1897, "The purple color used in chart visualizations."));
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/theme/common/colors/listColors.js
var listFocusBackground = registerColor("list.focusBackground", null, localize(2041, "List/Tree background color for the focused item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not."));
var listFocusForeground = registerColor("list.focusForeground", null, localize(2042, "List/Tree foreground color for the focused item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not."));
var listFocusOutline = registerColor("list.focusOutline", {
	dark: focusBorder,
	light: focusBorder,
	hcDark: activeContrastBorder,
	hcLight: activeContrastBorder
}, localize(2043, "List/Tree outline color for the focused item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not."));
var listFocusAndSelectionOutline = registerColor("list.focusAndSelectionOutline", null, localize(2044, "List/Tree outline color for the focused item when the list/tree is active and selected. An active list/tree has keyboard focus, an inactive does not."));
var listActiveSelectionBackground = registerColor("list.activeSelectionBackground", {
	dark: "#04395E",
	light: "#0060C0",
	hcDark: null,
	hcLight: Color.fromHex("#0F4A85").transparent(.1)
}, localize(2045, "List/Tree background color for the selected item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not."));
var listActiveSelectionForeground = registerColor("list.activeSelectionForeground", {
	dark: Color.white,
	light: Color.white,
	hcDark: null,
	hcLight: null
}, localize(2046, "List/Tree foreground color for the selected item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not."));
var listActiveSelectionIconForeground = registerColor("list.activeSelectionIconForeground", null, localize(2047, "List/Tree icon foreground color for the selected item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not."));
var listInactiveSelectionBackground = registerColor("list.inactiveSelectionBackground", {
	dark: "#37373D",
	light: "#E4E6F1",
	hcDark: null,
	hcLight: Color.fromHex("#0F4A85").transparent(.1)
}, localize(2048, "List/Tree background color for the selected item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not."));
var listInactiveSelectionForeground = registerColor("list.inactiveSelectionForeground", null, localize(2049, "List/Tree foreground color for the selected item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not."));
var listInactiveSelectionIconForeground = registerColor("list.inactiveSelectionIconForeground", null, localize(2050, "List/Tree icon foreground color for the selected item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not."));
var listInactiveFocusBackground = registerColor("list.inactiveFocusBackground", null, localize(2051, "List/Tree background color for the focused item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not."));
var listInactiveFocusOutline = registerColor("list.inactiveFocusOutline", null, localize(2052, "List/Tree outline color for the focused item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not."));
var listHoverBackground = registerColor("list.hoverBackground", {
	dark: "#2A2D2E",
	light: "#F0F0F0",
	hcDark: Color.white.transparent(.1),
	hcLight: Color.fromHex("#0F4A85").transparent(.1)
}, localize(2053, "List/Tree background when hovering over items using the mouse."));
var listHoverForeground = registerColor("list.hoverForeground", null, localize(2054, "List/Tree foreground when hovering over items using the mouse."));
var listDropOverBackground = registerColor("list.dropBackground", {
	dark: "#062F4A",
	light: "#D6EBFF",
	hcDark: null,
	hcLight: null
}, localize(2055, "List/Tree drag and drop background when moving items over other items when using the mouse."));
var listDropBetweenBackground = registerColor("list.dropBetweenBackground", {
	dark: iconForeground,
	light: iconForeground,
	hcDark: null,
	hcLight: null
}, localize(2056, "List/Tree drag and drop border color when moving items between items when using the mouse."));
var listHighlightForeground = registerColor("list.highlightForeground", {
	dark: "#2AAAFF",
	light: "#0066BF",
	hcDark: focusBorder,
	hcLight: focusBorder
}, localize(2057, "List/Tree foreground color of the match highlights when searching inside the list/tree."));
var listFocusHighlightForeground = registerColor("list.focusHighlightForeground", {
	dark: listHighlightForeground,
	light: ifDefinedThenElse(listActiveSelectionBackground, listHighlightForeground, "#BBE7FF"),
	hcDark: listHighlightForeground,
	hcLight: listHighlightForeground
}, localize(2058, "List/Tree foreground color of the match highlights on actively focused items when searching inside the list/tree."));
registerColor("list.invalidItemForeground", {
	dark: "#B89500",
	light: "#B89500",
	hcDark: "#B89500",
	hcLight: "#B5200D"
}, localize(2059, "List/Tree foreground color for invalid items, for example an unresolved root in explorer."));
registerColor("list.errorForeground", {
	dark: "#F88070",
	light: "#B01011",
	hcDark: null,
	hcLight: null
}, localize(2060, "Foreground color of list items containing errors."));
registerColor("list.warningForeground", {
	dark: "#CCA700",
	light: "#855F00",
	hcDark: null,
	hcLight: null
}, localize(2061, "Foreground color of list items containing warnings."));
var listFilterWidgetBackground = registerColor("listFilterWidget.background", {
	light: darken(editorWidgetBackground, 0),
	dark: lighten(editorWidgetBackground, 0),
	hcDark: editorWidgetBackground,
	hcLight: editorWidgetBackground
}, localize(2062, "Background color of the type filter widget in lists and trees."));
var listFilterWidgetOutline = registerColor("listFilterWidget.outline", {
	dark: Color.transparent,
	light: Color.transparent,
	hcDark: "#f38518",
	hcLight: "#007ACC"
}, localize(2063, "Outline color of the type filter widget in lists and trees."));
var listFilterWidgetNoMatchesOutline = registerColor("listFilterWidget.noMatchesOutline", {
	dark: "#BE1100",
	light: "#BE1100",
	hcDark: contrastBorder,
	hcLight: contrastBorder
}, localize(2064, "Outline color of the type filter widget in lists and trees, when there are no matches."));
var listFilterWidgetShadow = registerColor("listFilterWidget.shadow", widgetShadow, localize(2065, "Shadow color of the type filter widget in lists and trees."));
registerColor("list.filterMatchBackground", {
	dark: editorFindMatchHighlight,
	light: editorFindMatchHighlight,
	hcDark: null,
	hcLight: null
}, localize(2066, "Background color of the filtered match."));
registerColor("list.filterMatchBorder", {
	dark: editorFindMatchHighlightBorder,
	light: editorFindMatchHighlightBorder,
	hcDark: contrastBorder,
	hcLight: activeContrastBorder
}, localize(2067, "Border color of the filtered match."));
registerColor("list.deemphasizedForeground", {
	dark: "#8C8C8C",
	light: "#8E8E90",
	hcDark: "#A7A8A9",
	hcLight: "#666666"
}, localize(2068, "List/Tree foreground color for items that are deemphasized."));
var treeIndentGuidesStroke = registerColor("tree.indentGuidesStroke", {
	dark: "#585858",
	light: "#a9a9a9",
	hcDark: "#a9a9a9",
	hcLight: "#a5a5a5"
}, localize(2069, "Tree stroke color for the indentation guides."));
var treeInactiveIndentGuidesStroke = registerColor("tree.inactiveIndentGuidesStroke", transparent(treeIndentGuidesStroke, .4), localize(2070, "Tree stroke color for the indentation guides that are not active."));
var tableColumnsBorder = registerColor("tree.tableColumnsBorder", {
	dark: "#CCCCCC20",
	light: "#61616120",
	hcDark: null,
	hcLight: null
}, localize(2071, "Table border color between columns."));
var tableOddRowsBackgroundColor = registerColor("tree.tableOddRowsBackground", {
	dark: transparent(foreground, .04),
	light: transparent(foreground, .04),
	hcDark: null,
	hcLight: null
}, localize(2072, "Background color for odd table rows."));
registerColor("editorActionList.background", editorWidgetBackground, localize(2073, "Action List background color."));
var editorActionListForeground = registerColor("editorActionList.foreground", editorWidgetForeground, localize(2074, "Action List foreground color."));
registerColor("editorActionList.focusForeground", listActiveSelectionForeground, localize(2075, "Action List foreground color for the focused item."));
registerColor("editorActionList.focusBackground", listActiveSelectionBackground, localize(2076, "Action List background color for the focused item."));
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/theme/common/colors/inputColors.js
var inputBackground = registerColor("input.background", {
	dark: "#3C3C3C",
	light: Color.white,
	hcDark: Color.black,
	hcLight: Color.white
}, localize(1993, "Input box background."));
var inputForeground = registerColor("input.foreground", foreground, localize(1994, "Input box foreground."));
var inputBorder = registerColor("input.border", {
	dark: null,
	light: null,
	hcDark: contrastBorder,
	hcLight: contrastBorder
}, localize(1995, "Input box border."));
var inputActiveOptionBorder = registerColor("inputOption.activeBorder", {
	dark: "#007ACC",
	light: "#007ACC",
	hcDark: contrastBorder,
	hcLight: contrastBorder
}, localize(1996, "Border color of activated options in input fields."));
var inputActiveOptionHoverBackground = registerColor("inputOption.hoverBackground", {
	dark: "#5a5d5e80",
	light: "#b8b8b850",
	hcDark: null,
	hcLight: null
}, localize(1997, "Background color of activated options in input fields."));
var inputActiveOptionBackground = registerColor("inputOption.activeBackground", {
	dark: transparent(focusBorder, .4),
	light: transparent(focusBorder, .2),
	hcDark: Color.transparent,
	hcLight: Color.transparent
}, localize(1998, "Background hover color of options in input fields."));
var inputActiveOptionForeground = registerColor("inputOption.activeForeground", {
	dark: Color.white,
	light: Color.black,
	hcDark: foreground,
	hcLight: foreground
}, localize(1999, "Foreground color of activated options in input fields."));
registerColor("input.placeholderForeground", {
	light: transparent(foreground, .5),
	dark: transparent(foreground, .5),
	hcDark: transparent(foreground, .7),
	hcLight: transparent(foreground, .7)
}, localize(2e3, "Input box foreground color for placeholder text."));
var inputValidationInfoBackground = registerColor("inputValidation.infoBackground", {
	dark: "#063B49",
	light: "#D6ECF2",
	hcDark: Color.black,
	hcLight: Color.white
}, localize(2001, "Input validation background color for information severity."));
var inputValidationInfoForeground = registerColor("inputValidation.infoForeground", {
	dark: null,
	light: null,
	hcDark: null,
	hcLight: foreground
}, localize(2002, "Input validation foreground color for information severity."));
var inputValidationInfoBorder = registerColor("inputValidation.infoBorder", {
	dark: "#007acc",
	light: "#007acc",
	hcDark: contrastBorder,
	hcLight: contrastBorder
}, localize(2003, "Input validation border color for information severity."));
var inputValidationWarningBackground = registerColor("inputValidation.warningBackground", {
	dark: "#352A05",
	light: "#F6F5D2",
	hcDark: Color.black,
	hcLight: Color.white
}, localize(2004, "Input validation background color for warning severity."));
var inputValidationWarningForeground = registerColor("inputValidation.warningForeground", {
	dark: null,
	light: null,
	hcDark: null,
	hcLight: foreground
}, localize(2005, "Input validation foreground color for warning severity."));
var inputValidationWarningBorder = registerColor("inputValidation.warningBorder", {
	dark: "#B89500",
	light: "#B89500",
	hcDark: contrastBorder,
	hcLight: contrastBorder
}, localize(2006, "Input validation border color for warning severity."));
var inputValidationErrorBackground = registerColor("inputValidation.errorBackground", {
	dark: "#5A1D1D",
	light: "#F2DEDE",
	hcDark: Color.black,
	hcLight: Color.white
}, localize(2007, "Input validation background color for error severity."));
var inputValidationErrorForeground = registerColor("inputValidation.errorForeground", {
	dark: null,
	light: null,
	hcDark: null,
	hcLight: foreground
}, localize(2008, "Input validation foreground color for error severity."));
var inputValidationErrorBorder = registerColor("inputValidation.errorBorder", {
	dark: "#BE1100",
	light: "#BE1100",
	hcDark: contrastBorder,
	hcLight: contrastBorder
}, localize(2009, "Input validation border color for error severity."));
var selectBackground = registerColor("dropdown.background", {
	dark: "#3C3C3C",
	light: Color.white,
	hcDark: Color.black,
	hcLight: Color.white
}, localize(2010, "Dropdown background."));
var selectListBackground = registerColor("dropdown.listBackground", {
	dark: null,
	light: null,
	hcDark: Color.black,
	hcLight: Color.white
}, localize(2011, "Dropdown list background."));
var selectForeground = registerColor("dropdown.foreground", {
	dark: "#F0F0F0",
	light: foreground,
	hcDark: Color.white,
	hcLight: foreground
}, localize(2012, "Dropdown foreground."));
var selectBorder = registerColor("dropdown.border", {
	dark: selectBackground,
	light: "#CECECE",
	hcDark: contrastBorder,
	hcLight: contrastBorder
}, localize(2013, "Dropdown border."));
var buttonForeground = registerColor("button.foreground", Color.white, localize(2014, "Button foreground color."));
var buttonSeparator = registerColor("button.separator", transparent(buttonForeground, .4), localize(2015, "Button separator color."));
var buttonBackground = registerColor("button.background", {
	dark: "#0E639C",
	light: "#007ACC",
	hcDark: Color.black,
	hcLight: "#0F4A85"
}, localize(2016, "Button background color."));
var buttonHoverBackground = registerColor("button.hoverBackground", {
	dark: lighten(buttonBackground, .2),
	light: darken(buttonBackground, .2),
	hcDark: buttonBackground,
	hcLight: buttonBackground
}, localize(2017, "Button background color when hovering."));
var buttonBorder = registerColor("button.border", contrastBorder, localize(2018, "Button border color."));
var buttonSecondaryForeground = registerColor("button.secondaryForeground", {
	dark: foreground,
	light: foreground,
	hcDark: Color.white,
	hcLight: foreground
}, localize(2019, "Secondary button foreground color."));
var buttonSecondaryBackground = registerColor("button.secondaryBackground", {
	dark: listHoverBackground,
	light: listHoverBackground,
	hcDark: null,
	hcLight: Color.white
}, localize(2020, "Secondary button background color."));
var buttonSecondaryBorder = registerColor("button.secondaryBorder", {
	dark: transparent(foreground, .15),
	light: transparent(foreground, .15),
	hcDark: contrastBorder,
	hcLight: contrastBorder
}, localize(2021, "Secondary button border color."));
var buttonSecondaryHoverBackground = registerColor("button.secondaryHoverBackground", {
	dark: lighten(listHoverBackground, .2),
	light: lighten(listHoverBackground, .2),
	hcDark: null,
	hcLight: null
}, localize(2022, "Secondary button background color when hovering."));
var radioActiveForeground = registerColor("radio.activeForeground", inputActiveOptionForeground, localize(2023, "Foreground color of active radio option."));
var radioActiveBackground = registerColor("radio.activeBackground", inputActiveOptionBackground, localize(2024, "Background color of active radio option."));
var radioActiveBorder = registerColor("radio.activeBorder", inputActiveOptionBorder, localize(2025, "Border color of the active radio option."));
var radioInactiveForeground = registerColor("radio.inactiveForeground", null, localize(2026, "Foreground color of inactive radio option."));
var radioInactiveBackground = registerColor("radio.inactiveBackground", null, localize(2027, "Background color of inactive radio option."));
var radioInactiveBorder = registerColor("radio.inactiveBorder", {
	light: transparent(radioActiveForeground, .2),
	dark: transparent(radioActiveForeground, .2),
	hcDark: transparent(radioActiveForeground, .4),
	hcLight: transparent(radioActiveForeground, .2)
}, localize(2028, "Border color of the inactive radio option."));
var radioInactiveHoverBackground = registerColor("radio.inactiveHoverBackground", inputActiveOptionHoverBackground, localize(2029, "Background color of inactive active radio option when hovering."));
var checkboxBackground = registerColor("checkbox.background", selectBackground, localize(2030, "Background color of checkbox widget."));
registerColor("checkbox.selectBackground", editorWidgetBackground, localize(2031, "Background color of checkbox widget when the element it's in is selected."));
var checkboxForeground = registerColor("checkbox.foreground", selectForeground, localize(2032, "Foreground color of checkbox widget."));
var checkboxBorder = registerColor("checkbox.border", selectBorder, localize(2033, "Border color of checkbox widget."));
registerColor("checkbox.selectBorder", iconForeground, localize(2034, "Border color of checkbox widget when the element it's in is selected."));
var checkboxDisabledBackground = registerColor("checkbox.disabled.background", {
	op: 7,
	color: checkboxBackground,
	with: checkboxForeground,
	ratio: .33
}, localize(2035, "Background of a disabled checkbox."));
var checkboxDisabledForeground = registerColor("checkbox.disabled.foreground", {
	op: 7,
	color: checkboxForeground,
	with: checkboxBackground,
	ratio: .33
}, localize(2036, "Foreground of a disabled checkbox."));
var keybindingLabelBackground = registerColor("keybindingLabel.background", {
	dark: new Color(new RGBA(128, 128, 128, .17)),
	light: new Color(new RGBA(221, 221, 221, .4)),
	hcDark: Color.transparent,
	hcLight: Color.transparent
}, localize(2037, "Keybinding label background color. The keybinding label is used to represent a keyboard shortcut."));
var keybindingLabelForeground = registerColor("keybindingLabel.foreground", {
	dark: Color.fromHex("#CCCCCC"),
	light: Color.fromHex("#555555"),
	hcDark: Color.white,
	hcLight: foreground
}, localize(2038, "Keybinding label foreground color. The keybinding label is used to represent a keyboard shortcut."));
var keybindingLabelBorder = registerColor("keybindingLabel.border", {
	dark: new Color(new RGBA(51, 51, 51, .6)),
	light: new Color(new RGBA(204, 204, 204, .4)),
	hcDark: new Color(new RGBA(111, 195, 223)),
	hcLight: contrastBorder
}, localize(2039, "Keybinding label border color. The keybinding label is used to represent a keyboard shortcut."));
var keybindingLabelBottomBorder = registerColor("keybindingLabel.bottomBorder", {
	dark: new Color(new RGBA(68, 68, 68, .6)),
	light: new Color(new RGBA(187, 187, 187, .4)),
	hcDark: new Color(new RGBA(111, 195, 223)),
	hcLight: foreground
}, localize(2040, "Keybinding label border bottom color. The keybinding label is used to represent a keyboard shortcut."));
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/theme/common/colors/menuColors.js
var menuBorder = registerColor("menu.border", {
	dark: null,
	light: null,
	hcDark: contrastBorder,
	hcLight: contrastBorder
}, localize(2077, "Border color of menus."));
var menuForeground = registerColor("menu.foreground", selectForeground, localize(2078, "Foreground color of menu items."));
var menuBackground = registerColor("menu.background", selectBackground, localize(2079, "Background color of menu items."));
registerColor("menu.selectionForeground", listActiveSelectionForeground, localize(2080, "Foreground color of the selected menu item in menus."));
registerColor("menu.selectionBackground", listActiveSelectionBackground, localize(2081, "Background color of the selected menu item in menus."));
var menuSelectionBorder = registerColor("menu.selectionBorder", {
	dark: null,
	light: null,
	hcDark: activeContrastBorder,
	hcLight: activeContrastBorder
}, localize(2082, "Border color of the selected menu item in menus."));
var menuSeparatorBackground = registerColor("menu.separatorBackground", {
	dark: transparent(foreground, .2),
	light: transparent(foreground, .2),
	hcDark: contrastBorder,
	hcLight: contrastBorder
}, localize(2083, "Color of a separator menu item in menus."));
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/theme/common/colors/quickpickColors.js
var quickInputBackground = registerColor("quickInput.background", editorWidgetBackground, localize(2111, "Quick picker background color. The quick picker widget is the container for pickers like the command palette."));
var quickInputForeground = registerColor("quickInput.foreground", editorWidgetForeground, localize(2112, "Quick picker foreground color. The quick picker widget is the container for pickers like the command palette."));
var quickInputTitleBackground = registerColor("quickInputTitle.background", {
	dark: new Color(new RGBA(255, 255, 255, .105)),
	light: new Color(new RGBA(0, 0, 0, .06)),
	hcDark: "#000000",
	hcLight: Color.white
}, localize(2113, "Quick picker title background color. The quick picker widget is the container for pickers like the command palette."));
var pickerGroupForeground = registerColor("pickerGroup.foreground", {
	dark: "#3794FF",
	light: "#0066BF",
	hcDark: Color.white,
	hcLight: "#0F4A85"
}, localize(2114, "Quick picker color for grouping labels."));
var pickerGroupBorder = registerColor("pickerGroup.border", {
	dark: "#3F3F46",
	light: "#CCCEDB",
	hcDark: Color.white,
	hcLight: "#0F4A85"
}, localize(2115, "Quick picker color for grouping borders."));
var _deprecatedQuickInputListFocusBackground = registerColor("quickInput.list.focusBackground", null, "", void 0, localize(2116, "Please use quickInputList.focusBackground instead"));
var quickInputListFocusForeground = registerColor("quickInputList.focusForeground", listActiveSelectionForeground, localize(2117, "Quick picker foreground color for the focused item."));
var quickInputListFocusIconForeground = registerColor("quickInputList.focusIconForeground", listActiveSelectionIconForeground, localize(2118, "Quick picker icon foreground color for the focused item."));
var quickInputListFocusBackground = registerColor("quickInputList.focusBackground", {
	dark: oneOf(_deprecatedQuickInputListFocusBackground, listActiveSelectionBackground),
	light: oneOf(_deprecatedQuickInputListFocusBackground, listActiveSelectionBackground),
	hcDark: null,
	hcLight: null
}, localize(2119, "Quick picker background color for the focused item."));
registerColor("quickInputList.focusHighlightForeground", listFocusHighlightForeground, localize(2120, "Quick picker foreground color of the match highlights on the focused item."));
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/theme/common/colors/searchColors.js
registerColor("search.resultsInfoForeground", {
	light: foreground,
	dark: transparent(foreground, .65),
	hcDark: foreground,
	hcLight: foreground
}, localize(2121, "Color of the text in the search viewlet's completion message."));
registerColor("searchEditor.findMatchBackground", {
	light: transparent(editorFindMatchHighlight, .66),
	dark: transparent(editorFindMatchHighlight, .66),
	hcDark: editorFindMatchHighlight,
	hcLight: editorFindMatchHighlight
}, localize(2122, "Color of the Search Editor query matches."));
registerColor("searchEditor.findMatchBorder", {
	light: transparent(editorFindMatchHighlightBorder, .66),
	dark: transparent(editorFindMatchHighlightBorder, .66),
	hcDark: editorFindMatchHighlightBorder,
	hcLight: editorFindMatchHighlightBorder
}, localize(2123, "Border color of the Search Editor query matches."));
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/editorDom.js
/**
* Coordinates relative to the whole document (e.g. mouse event's pageX and pageY)
*/
var PageCoordinates = class {
	constructor(x, y) {
		this.x = x;
		this.y = y;
		this._pageCoordinatesBrand = void 0;
	}
	toClientCoordinates(targetWindow) {
		return new ClientCoordinates(this.x - targetWindow.scrollX, this.y - targetWindow.scrollY);
	}
};
/**
* Coordinates within the application's client area (i.e. origin is document's scroll position).
*
* For example, clicking in the top-left corner of the client area will
* always result in a mouse event with a client.x value of 0, regardless
* of whether the page is scrolled horizontally.
*/
var ClientCoordinates = class {
	constructor(clientX, clientY) {
		this.clientX = clientX;
		this.clientY = clientY;
		this._clientCoordinatesBrand = void 0;
	}
	toPageCoordinates(targetWindow) {
		return new PageCoordinates(this.clientX + targetWindow.scrollX, this.clientY + targetWindow.scrollY);
	}
};
/**
* The position of the editor in the page.
*/
var EditorPagePosition = class {
	constructor(x, y, width, height) {
		this.x = x;
		this.y = y;
		this.width = width;
		this.height = height;
		this._editorPagePositionBrand = void 0;
	}
};
/**
* Coordinates relative to the (top;left) of the editor that can be used safely with other internal editor metrics.
* **NOTE**: This position is obtained by taking page coordinates and transforming them relative to the
* editor's (top;left) position in a way in which scale transformations are taken into account.
* **NOTE**: These coordinates could be negative if the mouse position is outside the editor.
*/
var CoordinatesRelativeToEditor = class {
	constructor(x, y) {
		this.x = x;
		this.y = y;
		this._positionRelativeToEditorBrand = void 0;
	}
};
function createEditorPagePosition(editorViewDomNode) {
	const editorPos = getDomNodePagePosition(editorViewDomNode);
	return new EditorPagePosition(editorPos.left, editorPos.top, editorPos.width, editorPos.height);
}
function createCoordinatesRelativeToEditor(editorViewDomNode, editorPagePosition, pos) {
	const scaleX = editorPagePosition.width / editorViewDomNode.offsetWidth;
	const scaleY = editorPagePosition.height / editorViewDomNode.offsetHeight;
	return new CoordinatesRelativeToEditor((pos.x - editorPagePosition.x) / scaleX, (pos.y - editorPagePosition.y) / scaleY);
}
var EditorMouseEvent = class extends StandardMouseEvent {
	/**
	* Editor's coordinates relative to the whole document.
	*/
	get editorPos() {
		this._editorPos ??= createEditorPagePosition(this._editorViewDomNode);
		return this._editorPos;
	}
	/**
	* Coordinates relative to the (top;left) of the editor.
	* *NOTE*: These coordinates are preferred because they take into account transformations applied to the editor.
	* *NOTE*: These coordinates could be negative if the mouse position is outside the editor.
	*/
	get relativePos() {
		this._relativePos ??= createCoordinatesRelativeToEditor(this._editorViewDomNode, this.editorPos, this.pos);
		return this._relativePos;
	}
	constructor(e, isFromPointerCapture, editorViewDomNode) {
		super(getWindow(editorViewDomNode), e);
		this._editorMouseEventBrand = void 0;
		this.isFromPointerCapture = isFromPointerCapture;
		this.pos = new PageCoordinates(this.posx, this.posy);
		this._editorViewDomNode = editorViewDomNode;
	}
};
var EditorMouseEventFactory = class {
	constructor(editorViewDomNode) {
		this._editorViewDomNode = editorViewDomNode;
	}
	_create(e) {
		return new EditorMouseEvent(e, false, this._editorViewDomNode);
	}
	onContextMenu(target, callback) {
		return addDisposableListener(target, EventType$1.CONTEXT_MENU, (e) => {
			callback(this._create(e));
		});
	}
	onMouseUp(target, callback) {
		return addDisposableListener(target, EventType$1.MOUSE_UP, (e) => {
			callback(this._create(e));
		});
	}
	onMouseDown(target, callback) {
		return addDisposableListener(target, EventType$1.MOUSE_DOWN, (e) => {
			callback(this._create(e));
		});
	}
	onPointerDown(target, callback) {
		return addDisposableListener(target, EventType$1.POINTER_DOWN, (e) => {
			callback(this._create(e), e.pointerId);
		});
	}
	onMouseLeave(target, callback) {
		return addDisposableListener(target, EventType$1.MOUSE_LEAVE, (e) => {
			callback(this._create(e));
		});
	}
	onMouseMove(target, callback) {
		return addDisposableListener(target, EventType$1.MOUSE_MOVE, (e) => callback(this._create(e)));
	}
};
var EditorPointerEventFactory = class {
	constructor(editorViewDomNode) {
		this._editorViewDomNode = editorViewDomNode;
	}
	_create(e) {
		return new EditorMouseEvent(e, false, this._editorViewDomNode);
	}
	onPointerUp(target, callback) {
		return addDisposableListener(target, "pointerup", (e) => {
			callback(this._create(e));
		});
	}
	onPointerDown(target, callback) {
		return addDisposableListener(target, EventType$1.POINTER_DOWN, (e) => {
			callback(this._create(e), e.pointerId);
		});
	}
	onPointerLeave(target, callback) {
		return addDisposableListener(target, EventType$1.POINTER_LEAVE, (e) => {
			callback(this._create(e));
		});
	}
	onPointerMove(target, callback) {
		return addDisposableListener(target, "pointermove", (e) => callback(this._create(e)));
	}
};
var GlobalEditorPointerMoveMonitor = class extends Disposable {
	constructor(editorViewDomNode) {
		super();
		this._editorViewDomNode = editorViewDomNode;
		this._globalPointerMoveMonitor = this._register(new GlobalPointerMoveMonitor());
		this._keydownListener = null;
	}
	startMonitoring(initialElement, pointerId, initialButtons, pointerMoveCallback, onStopCallback) {
		this._keydownListener = addStandardDisposableListener(initialElement.ownerDocument, "keydown", (e) => {
			if (e.toKeyCodeChord().isModifierKey()) return;
			this._globalPointerMoveMonitor.stopMonitoring(true, e.browserEvent);
		}, true);
		this._globalPointerMoveMonitor.startMonitoring(initialElement, pointerId, initialButtons, (e) => {
			pointerMoveCallback(new EditorMouseEvent(e, true, this._editorViewDomNode));
		}, (e) => {
			this._keydownListener.dispose();
			onStopCallback(e);
		});
	}
	stopMonitoring() {
		this._globalPointerMoveMonitor.stopMonitoring(true);
	}
};
/**
* A helper to create dynamic css rules, bound to a class name.
* Rules are reused.
* Reference counting and delayed garbage collection ensure that no rules leak.
*/
var DynamicCssRules = class DynamicCssRules {
	static {
		this._idPool = 0;
	}
	constructor(_editor) {
		this._editor = _editor;
		this._instanceId = ++DynamicCssRules._idPool;
		this._counter = 0;
		this._rules = new DisposableMap();
		this._garbageCollectionScheduler = new RunOnceScheduler(() => this.garbageCollect(), 1e3);
	}
	dispose() {
		this._rules.dispose();
		this._garbageCollectionScheduler.dispose();
	}
	createClassNameRef(options) {
		const rule = this.getOrCreateRule(options);
		rule.increaseRefCount();
		return {
			className: rule.className,
			dispose: () => {
				rule.decreaseRefCount();
				this._garbageCollectionScheduler.schedule();
			}
		};
	}
	getOrCreateRule(properties) {
		const key = this.computeUniqueKey(properties);
		let existingRule = this._rules.get(key);
		if (!existingRule) {
			const counter = this._counter++;
			existingRule = new RefCountedCssRule(key, `dyn-rule-${this._instanceId}-${counter}`, isInShadowDOM(this._editor.getContainerDomNode()) ? this._editor.getContainerDomNode() : void 0, properties);
			this._rules.set(key, existingRule);
		}
		return existingRule;
	}
	computeUniqueKey(properties) {
		return JSON.stringify(properties);
	}
	garbageCollect() {
		for (const rule of this._rules.values()) if (!rule.hasReferences()) this._rules.deleteAndDispose(rule.key);
	}
};
var RefCountedCssRule = class {
	constructor(key, className, _containerElement, properties) {
		this.key = key;
		this.className = className;
		this.properties = properties;
		this._referenceCount = 0;
		this._styleElementDisposables = new DisposableStore();
		this._styleElement = createStyleSheet(_containerElement, void 0, this._styleElementDisposables);
		this._styleElement.textContent = this.getCssText(this.className, this.properties);
	}
	getCssText(className, properties) {
		let str = `.${className} {`;
		for (const prop in properties) {
			const value = properties[prop];
			let cssValue;
			if (typeof value === "object") cssValue = asCssVariable(value.id);
			else cssValue = value;
			const cssPropName = camelToDashes(prop);
			str += `\n\t${cssPropName}: ${cssValue};`;
		}
		str += `\n}`;
		return str;
	}
	dispose() {
		this._styleElementDisposables.dispose();
		this._styleElement = void 0;
	}
	increaseRefCount() {
		this._referenceCount++;
	}
	decreaseRefCount() {
		this._referenceCount--;
	}
	hasReferences() {
		return this._referenceCount > 0;
	}
};
function camelToDashes(str) {
	return str.replace(/(^[A-Z])/, ([first]) => first.toLowerCase()).replace(/([A-Z])/g, ([letter]) => `-${letter.toLowerCase()}`);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/viewEventHandler.js
var ViewEventHandler = class extends Disposable {
	constructor() {
		super();
		this._shouldRender = true;
	}
	shouldRender() {
		return this._shouldRender;
	}
	forceShouldRender() {
		this._shouldRender = true;
	}
	setShouldRender() {
		this._shouldRender = true;
	}
	onDidRender() {
		this._shouldRender = false;
	}
	onCompositionStart(e) {
		return false;
	}
	onCompositionEnd(e) {
		return false;
	}
	onConfigurationChanged(e) {
		return false;
	}
	onCursorStateChanged(e) {
		return false;
	}
	onDecorationsChanged(e) {
		return false;
	}
	onFlushed(e) {
		return false;
	}
	onFocusChanged(e) {
		return false;
	}
	onLanguageConfigurationChanged(e) {
		return false;
	}
	onLineMappingChanged(e) {
		return false;
	}
	onLinesChanged(e) {
		return false;
	}
	onLinesDeleted(e) {
		return false;
	}
	onLinesInserted(e) {
		return false;
	}
	onRevealRangeRequest(e) {
		return false;
	}
	onScrollChanged(e) {
		return false;
	}
	onThemeChanged(e) {
		return false;
	}
	onTokensChanged(e) {
		return false;
	}
	onTokensColorsChanged(e) {
		return false;
	}
	onZonesChanged(e) {
		return false;
	}
	handleEvents(events) {
		let shouldRender = false;
		for (let i = 0, len = events.length; i < len; i++) {
			const e = events[i];
			switch (e.type) {
				case 0:
					if (this.onCompositionStart(e)) shouldRender = true;
					break;
				case 1:
					if (this.onCompositionEnd(e)) shouldRender = true;
					break;
				case 2:
					if (this.onConfigurationChanged(e)) shouldRender = true;
					break;
				case 3:
					if (this.onCursorStateChanged(e)) shouldRender = true;
					break;
				case 4:
					if (this.onDecorationsChanged(e)) shouldRender = true;
					break;
				case 5:
					if (this.onFlushed(e)) shouldRender = true;
					break;
				case 6:
					if (this.onFocusChanged(e)) shouldRender = true;
					break;
				case 7:
					if (this.onLanguageConfigurationChanged(e)) shouldRender = true;
					break;
				case 8:
					if (this.onLineMappingChanged(e)) shouldRender = true;
					break;
				case 9:
					if (this.onLinesChanged(e)) shouldRender = true;
					break;
				case 10:
					if (this.onLinesDeleted(e)) shouldRender = true;
					break;
				case 11:
					if (this.onLinesInserted(e)) shouldRender = true;
					break;
				case 12:
					if (this.onRevealRangeRequest(e)) shouldRender = true;
					break;
				case 13:
					if (this.onScrollChanged(e)) shouldRender = true;
					break;
				case 15:
					if (this.onTokensChanged(e)) shouldRender = true;
					break;
				case 14:
					if (this.onThemeChanged(e)) shouldRender = true;
					break;
				case 16:
					if (this.onTokensColorsChanged(e)) shouldRender = true;
					break;
				case 17:
					if (this.onZonesChanged(e)) shouldRender = true;
					break;
				default:
					console.info("View received unknown event: ");
					console.info(e);
			}
		}
		if (shouldRender) this._shouldRender = true;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/view/viewPart.js
var ViewPart = class extends ViewEventHandler {
	constructor(context) {
		super();
		this._context = context;
		this._context.addEventHandler(this);
	}
	dispose() {
		this._context.removeEventHandler(this);
		super.dispose();
	}
	onBeforeRender(viewportData) {}
};
var PartFingerprints = class {
	static write(target, partId) {
		target.setAttribute("data-mprt", String(partId));
	}
	static read(target) {
		const r = target.getAttribute("data-mprt");
		if (r === null) return 0;
		return parseInt(r, 10);
	}
	static collect(child, stopAt) {
		const result = [];
		let resultLen = 0;
		while (child && child !== child.ownerDocument.body) {
			if (child === stopAt) break;
			if (child.nodeType === child.ELEMENT_NODE) result[resultLen++] = this.read(child);
			child = child.parentElement;
		}
		const r = new Uint8Array(resultLen);
		for (let i = 0; i < resultLen; i++) r[i] = result[resultLen - i - 1];
		return r;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/view/renderingContext.js
var RestrictedRenderingContext = class {
	constructor(viewLayout, viewportData) {
		this._restrictedRenderingContextBrand = void 0;
		this._viewLayout = viewLayout;
		this.viewportData = viewportData;
		this.scrollWidth = this._viewLayout.getScrollWidth();
		this.scrollHeight = this._viewLayout.getScrollHeight();
		this.visibleRange = this.viewportData.visibleRange;
		this.bigNumbersDelta = this.viewportData.bigNumbersDelta;
		const vInfo = this._viewLayout.getCurrentViewport();
		this.scrollTop = vInfo.top;
		this.scrollLeft = vInfo.left;
		this.viewportWidth = vInfo.width;
		this.viewportHeight = vInfo.height;
	}
	getScrolledTopFromAbsoluteTop(absoluteTop) {
		return absoluteTop - this.scrollTop;
	}
	getVerticalOffsetForLineNumber(lineNumber, includeViewZones) {
		return this._viewLayout.getVerticalOffsetForLineNumber(lineNumber, includeViewZones);
	}
	getVerticalOffsetAfterLineNumber(lineNumber, includeViewZones) {
		return this._viewLayout.getVerticalOffsetAfterLineNumber(lineNumber, includeViewZones);
	}
	getLineHeightForLineNumber(lineNumber) {
		return this._viewLayout.getLineHeightForLineNumber(lineNumber);
	}
	getDecorationsInViewport() {
		return this.viewportData.getDecorationsInViewport();
	}
};
var RenderingContext = class extends RestrictedRenderingContext {
	constructor(viewLayout, viewportData, viewLines, viewLinesGpu) {
		super(viewLayout, viewportData);
		this._renderingContextBrand = void 0;
		this._viewLines = viewLines;
		this._viewLinesGpu = viewLinesGpu;
	}
	linesVisibleRangesForRange(range, includeNewLines) {
		const domRanges = this._viewLines.linesVisibleRangesForRange(range, includeNewLines);
		if (!this._viewLinesGpu) return domRanges;
		const gpuRanges = this._viewLinesGpu.linesVisibleRangesForRange(range, includeNewLines);
		if (!domRanges) return gpuRanges;
		if (!gpuRanges) return domRanges;
		return domRanges.concat(gpuRanges).sort((a, b) => a.lineNumber - b.lineNumber);
	}
	visibleRangeForPosition(position) {
		return this._viewLines.visibleRangeForPosition(position) ?? this._viewLinesGpu?.visibleRangeForPosition(position) ?? null;
	}
};
var LineVisibleRanges = class {
	constructor(outsideRenderedLine, lineNumber, ranges, continuesOnNextLine) {
		this.outsideRenderedLine = outsideRenderedLine;
		this.lineNumber = lineNumber;
		this.ranges = ranges;
		this.continuesOnNextLine = continuesOnNextLine;
	}
};
var HorizontalRange = class HorizontalRange {
	static from(ranges) {
		const result = new Array(ranges.length);
		for (let i = 0, len = ranges.length; i < len; i++) {
			const range = ranges[i];
			result[i] = new HorizontalRange(range.left, range.width);
		}
		return result;
	}
	constructor(left, width) {
		this._horizontalRangeBrand = void 0;
		this.left = Math.round(left);
		this.width = Math.round(width);
	}
	toString() {
		return `[${this.left},${this.width}]`;
	}
};
var FloatHorizontalRange = class {
	constructor(left, width) {
		this._floatHorizontalRangeBrand = void 0;
		this.left = left;
		this.width = width;
	}
	toString() {
		return `[${this.left},${this.width}]`;
	}
	static compare(a, b) {
		return a.left - b.left;
	}
};
var HorizontalPosition = class {
	constructor(outsideRenderedLine, left) {
		this.outsideRenderedLine = outsideRenderedLine;
		this.originalLeft = left;
		this.left = Math.round(this.originalLeft);
	}
};
var VisibleRanges = class {
	constructor(outsideRenderedLine, ranges) {
		this.outsideRenderedLine = outsideRenderedLine;
		this.ranges = ranges;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/viewLines/rangeUtil.js
var RangeUtil = class {
	static _createRange() {
		if (!this._handyReadyRange) this._handyReadyRange = document.createRange();
		return this._handyReadyRange;
	}
	static _detachRange(range, endNode) {
		range.selectNodeContents(endNode);
	}
	static _readClientRects(startElement, startOffset, endElement, endOffset, endNode) {
		const range = this._createRange();
		try {
			range.setStart(startElement, startOffset);
			range.setEnd(endElement, endOffset);
			return range.getClientRects();
		} catch (e) {
			return null;
		} finally {
			this._detachRange(range, endNode);
		}
	}
	static _mergeAdjacentRanges(ranges) {
		if (ranges.length === 1) return ranges;
		ranges.sort(FloatHorizontalRange.compare);
		const result = [];
		let resultLen = 0;
		let prev = ranges[0];
		for (let i = 1, len = ranges.length; i < len; i++) {
			const range = ranges[i];
			if (prev.left + prev.width + .9 >= range.left) prev.width = Math.max(prev.width, range.left + range.width - prev.left);
			else {
				result[resultLen++] = prev;
				prev = range;
			}
		}
		result[resultLen++] = prev;
		return result;
	}
	static _createHorizontalRangesFromClientRects(clientRects, clientRectDeltaLeft, clientRectScale) {
		if (!clientRects || clientRects.length === 0) return null;
		const result = [];
		for (let i = 0, len = clientRects.length; i < len; i++) {
			const clientRect = clientRects[i];
			result[i] = new FloatHorizontalRange(Math.max(0, (clientRect.left - clientRectDeltaLeft) / clientRectScale), clientRect.width / clientRectScale);
		}
		return this._mergeAdjacentRanges(result);
	}
	/**
	* Reads the horizontal range occupied by a single child element. Unlike a collapsed text
	* range, this reports the edges of the element's box rather than the edges of its glyphs.
	*/
	static readHorizontalRangeForElement(domNode, childIndex, context) {
		const child = domNode.children[childIndex];
		if (!child) return null;
		const clientRects = child.getClientRects();
		context.markDidDomLayout();
		const ranges = this._createHorizontalRangesFromClientRects(clientRects, context.clientRectDeltaLeft, context.clientRectScale);
		return ranges && ranges.length > 0 ? ranges[0] : null;
	}
	static readHorizontalRanges(domNode, startChildIndex, startOffset, endChildIndex, endOffset, context) {
		const min = 0;
		const max = domNode.children.length - 1;
		if (min > max) return null;
		startChildIndex = Math.min(max, Math.max(min, startChildIndex));
		endChildIndex = Math.min(max, Math.max(min, endChildIndex));
		if (startChildIndex === endChildIndex && startOffset === endOffset && startOffset === 0 && !domNode.children[startChildIndex].firstChild) {
			const clientRects = domNode.children[startChildIndex].getClientRects();
			context.markDidDomLayout();
			return this._createHorizontalRangesFromClientRects(clientRects, context.clientRectDeltaLeft, context.clientRectScale);
		}
		if (startChildIndex !== endChildIndex) {
			if (endChildIndex > 0 && endOffset === 0) {
				endChildIndex--;
				endOffset = 1073741824;
			}
		}
		let startElement = domNode.children[startChildIndex].firstChild;
		let endElement = domNode.children[endChildIndex].firstChild;
		if (!startElement || !endElement) {
			if (!startElement && startOffset === 0 && startChildIndex > 0) {
				startElement = domNode.children[startChildIndex - 1].firstChild;
				startOffset = 1073741824;
			}
			if (!endElement && endOffset === 0 && endChildIndex > 0) {
				endElement = domNode.children[endChildIndex - 1].firstChild;
				endOffset = 1073741824;
			}
		}
		if (!startElement || !endElement) return null;
		startOffset = Math.min(startElement.textContent.length, Math.max(0, startOffset));
		endOffset = Math.min(endElement.textContent.length, Math.max(0, endOffset));
		const clientRects = this._readClientRects(startElement, startOffset, endElement, endOffset, context.endNode);
		context.markDidDomLayout();
		return this._createHorizontalRangesFromClientRects(clientRects, context.clientRectDeltaLeft, context.clientRectScale);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/theme/common/theme.js
/**
* Color scheme used by the OS and by color themes.
*/
var ColorScheme;
(function(ColorScheme) {
	ColorScheme["DARK"] = "dark";
	ColorScheme["LIGHT"] = "light";
	ColorScheme["HIGH_CONTRAST_DARK"] = "hcDark";
	ColorScheme["HIGH_CONTRAST_LIGHT"] = "hcLight";
})(ColorScheme || (ColorScheme = {}));
var ThemeTypeSelector;
(function(ThemeTypeSelector) {
	ThemeTypeSelector["VS"] = "vs";
	ThemeTypeSelector["VS_DARK"] = "vs-dark";
	ThemeTypeSelector["HC_BLACK"] = "hc-black";
	ThemeTypeSelector["HC_LIGHT"] = "hc-light";
})(ThemeTypeSelector || (ThemeTypeSelector = {}));
function isHighContrast(scheme) {
	return scheme === ColorScheme.HIGH_CONTRAST_DARK || scheme === ColorScheme.HIGH_CONTRAST_LIGHT;
}
function isDark(scheme) {
	return scheme === ColorScheme.DARK || scheme === ColorScheme.HIGH_CONTRAST_DARK;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/viewLines/viewLine.js
var canUseFastRenderedViewLine = (function() {
	if (isNative) return true;
	if (isLinux || isFirefox || isSafari) return false;
	return true;
})();
var monospaceAssumptionsAreValid = true;
var ViewLine = class ViewLine {
	static {
		this.CLASS_NAME = "view-line";
	}
	constructor(_viewGpuContext, options) {
		this._viewGpuContext = _viewGpuContext;
		this._options = options;
		this._isMaybeInvalid = true;
		this._renderedViewLine = null;
	}
	getDomNode() {
		if (this._renderedViewLine && this._renderedViewLine.domNode) return this._renderedViewLine.domNode.domNode;
		return null;
	}
	setDomNode(domNode) {
		if (this._renderedViewLine) this._renderedViewLine.domNode = createFastDomNode(domNode);
		else throw new Error("I have no rendered view line to set the dom node to...");
	}
	onContentChanged() {
		this._isMaybeInvalid = true;
	}
	onTokensChanged() {
		this._isMaybeInvalid = true;
	}
	onDecorationsChanged() {
		this._isMaybeInvalid = true;
	}
	onOptionsChanged(newOptions) {
		this._isMaybeInvalid = true;
		this._options = newOptions;
	}
	onSelectionChanged() {
		if (isHighContrast(this._options.themeType) || this._renderedViewLine?.input.renderWhitespace === 2) {
			this._isMaybeInvalid = true;
			return true;
		}
		return false;
	}
	renderLine(lineNumber, deltaTop, lineHeight, viewportData, sb) {
		if (this._options.useGpu && this._viewGpuContext?.canRender(this._options, viewportData, lineNumber)) {
			this._renderedViewLine?.domNode?.domNode.remove();
			this._renderedViewLine = null;
			return false;
		}
		if (this._isMaybeInvalid === false) return false;
		this._isMaybeInvalid = false;
		const lineData = viewportData.getViewLineRenderingData(lineNumber);
		const options = this._options;
		const actualInlineDecorations = LineDecoration.filter(lineData.inlineDecorations, lineNumber, lineData.minColumn, lineData.maxColumn);
		const renderWhitespace = options.experimentalWhitespaceRendering === "off" ? options.renderWhitespace : "none";
		const allowFastRendering = !lineData.hasVariableFonts;
		let selectionsOnLine = null;
		if (isHighContrast(options.themeType) || renderWhitespace === "selection") {
			const selections = viewportData.selections;
			for (const selection of selections) {
				if (selection.endLineNumber < lineNumber || selection.startLineNumber > lineNumber) continue;
				const startColumn = selection.startLineNumber === lineNumber ? selection.startColumn : lineData.minColumn;
				const endColumn = selection.endLineNumber === lineNumber ? selection.endColumn : lineData.maxColumn;
				if (startColumn < endColumn) {
					if (isHighContrast(options.themeType)) actualInlineDecorations.push(new LineDecoration(startColumn, endColumn, "inline-selected-text", 0));
					if (renderWhitespace === "selection") {
						if (!selectionsOnLine) selectionsOnLine = [];
						selectionsOnLine.push(new OffsetRange(startColumn - 1, endColumn - 1));
					}
				}
			}
		}
		const renderLineInput = new RenderLineInput(options.useMonospaceOptimizations, options.canUseHalfwidthRightwardsArrow, lineData.content, lineData.continuesWithWrappedLine, lineData.isBasicASCII, lineData.containsRTL, lineData.minColumn - 1, lineData.tokens, actualInlineDecorations, lineData.tabSize, lineData.startVisibleColumn, options.spaceWidth, options.middotWidth, options.wsmiddotWidth, options.stopRenderingLineAfter, renderWhitespace, options.renderControlCharacters, options.fontLigatures !== EditorFontLigatures.OFF, selectionsOnLine, lineData.textDirection, options.verticalScrollbarSize, false, options.useTwoCellFullwidthCharacters);
		if (this._renderedViewLine && this._renderedViewLine.input.equals(renderLineInput)) return false;
		sb.appendString("<div ");
		if (lineData.textDirection === TextDirection.RTL) sb.appendString("dir=\"rtl\" ");
		else if (lineData.containsRTL) sb.appendString("dir=\"ltr\" ");
		sb.appendString("style=\"top:");
		sb.appendString(String(deltaTop));
		sb.appendString("px;height:");
		sb.appendString(String(lineHeight));
		sb.appendString("px;line-height:");
		sb.appendString(String(lineHeight));
		if (lineData.textDirection === TextDirection.RTL) {
			sb.appendString("px;padding-right:");
			sb.appendString(String(options.verticalScrollbarSize));
		}
		sb.appendString("px;\" class=\"");
		sb.appendString(ViewLine.CLASS_NAME);
		sb.appendString("\">");
		const output = renderViewLine(renderLineInput, sb);
		sb.appendString("</div>");
		let renderedViewLine = null;
		if (allowFastRendering && monospaceAssumptionsAreValid && canUseFastRenderedViewLine && lineData.isBasicASCII && renderLineInput.isLTR && options.useMonospaceOptimizations && output.containsForeignElements === 0) renderedViewLine = new FastRenderedViewLine(this._renderedViewLine ? this._renderedViewLine.domNode : null, renderLineInput, output.characterMapping);
		if (!renderedViewLine) renderedViewLine = createRenderedLine(this._renderedViewLine ? this._renderedViewLine.domNode : null, renderLineInput, output.characterMapping, output.containsForeignElements);
		this._renderedViewLine = renderedViewLine;
		return true;
	}
	layoutLine(lineNumber, deltaTop, lineHeight) {
		if (this._renderedViewLine && this._renderedViewLine.domNode) {
			this._renderedViewLine.domNode.setTop(deltaTop);
			this._renderedViewLine.domNode.setHeight(lineHeight);
			this._renderedViewLine.domNode.setLineHeight(lineHeight);
		}
	}
	isRenderedRTL() {
		if (!this._renderedViewLine) return false;
		return this._renderedViewLine.input.textDirection === TextDirection.RTL;
	}
	getWidth(context) {
		if (!this._renderedViewLine) return 0;
		return this._renderedViewLine.getWidth(context);
	}
	getWidthIsFast() {
		if (!this._renderedViewLine) return true;
		return this._renderedViewLine.getWidthIsFast();
	}
	needsMonospaceFontCheck() {
		if (!this._renderedViewLine) return false;
		return this._renderedViewLine instanceof FastRenderedViewLine;
	}
	monospaceAssumptionsAreValid() {
		if (!this._renderedViewLine) return monospaceAssumptionsAreValid;
		if (this._renderedViewLine instanceof FastRenderedViewLine) return this._renderedViewLine.monospaceAssumptionsAreValid();
		return monospaceAssumptionsAreValid;
	}
	onMonospaceAssumptionsInvalidated() {
		if (this._renderedViewLine && this._renderedViewLine instanceof FastRenderedViewLine) this._renderedViewLine = this._renderedViewLine.toSlowRenderedLine();
	}
	getVisibleRangesForRange(lineNumber, startColumn, endColumn, context) {
		if (!this._renderedViewLine) return null;
		startColumn = Math.min(this._renderedViewLine.input.lineContent.length + 1, Math.max(1, startColumn));
		endColumn = Math.min(this._renderedViewLine.input.lineContent.length + 1, Math.max(1, endColumn));
		const stopRenderingLineAfter = this._renderedViewLine.input.stopRenderingLineAfter;
		if (stopRenderingLineAfter !== -1 && startColumn > stopRenderingLineAfter + 1 && endColumn > stopRenderingLineAfter + 1) return new VisibleRanges(true, [new FloatHorizontalRange(this.getWidth(context), 0)]);
		if (stopRenderingLineAfter !== -1 && startColumn > stopRenderingLineAfter + 1) startColumn = stopRenderingLineAfter + 1;
		if (stopRenderingLineAfter !== -1 && endColumn > stopRenderingLineAfter + 1) endColumn = stopRenderingLineAfter + 1;
		const horizontalRanges = this._renderedViewLine.getVisibleRangesForRange(lineNumber, startColumn, endColumn, context);
		if (horizontalRanges && horizontalRanges.length > 0) return new VisibleRanges(false, horizontalRanges);
		return null;
	}
	getColumnOfNodeOffset(spanNode, offset) {
		if (!this._renderedViewLine) return 1;
		return this._renderedViewLine.getColumnOfNodeOffset(spanNode, offset);
	}
	resetCachedWidth() {
		this._renderedViewLine?.resetCachedWidth();
	}
};
/**
* A rendered line which is guaranteed to contain only regular ASCII and is rendered with a monospace font.
*/
var FastRenderedViewLine = class {
	constructor(domNode, renderLineInput, characterMapping) {
		this._cachedWidth = -1;
		this.domNode = domNode;
		this.input = renderLineInput;
		const keyColumnCount = Math.floor(renderLineInput.lineContent.length / 300);
		if (keyColumnCount > 0) {
			this._keyColumnPixelOffsetCache = new Float32Array(keyColumnCount);
			for (let i = 0; i < keyColumnCount; i++) this._keyColumnPixelOffsetCache[i] = -1;
		} else this._keyColumnPixelOffsetCache = null;
		this._characterMapping = characterMapping;
		this._charWidth = renderLineInput.spaceWidth;
	}
	getWidth(context) {
		if (!this.domNode || this.input.lineContent.length < 300) {
			const horizontalOffset = this._characterMapping.getHorizontalOffset(this._characterMapping.length);
			return Math.round(this._charWidth * horizontalOffset);
		}
		if (this._cachedWidth === -1) {
			this._cachedWidth = this._getReadingTarget(this.domNode).offsetWidth;
			context?.markDidDomLayout();
		}
		return this._cachedWidth;
	}
	getWidthIsFast() {
		return this.input.lineContent.length < 300 || this._cachedWidth !== -1;
	}
	resetCachedWidth() {
		this._cachedWidth = -1;
	}
	monospaceAssumptionsAreValid() {
		if (!this.domNode) return monospaceAssumptionsAreValid;
		if (this.input.lineContent.length < 300) {
			const expectedWidth = this.getWidth(null);
			const actualWidth = this.domNode.domNode.firstChild.offsetWidth;
			if (Math.abs(expectedWidth - actualWidth) >= 2) {
				console.warn(`monospace assumptions have been violated, therefore disabling monospace optimizations!`);
				monospaceAssumptionsAreValid = false;
			}
		}
		return monospaceAssumptionsAreValid;
	}
	toSlowRenderedLine() {
		return createRenderedLine(this.domNode, this.input, this._characterMapping, 0);
	}
	getVisibleRangesForRange(lineNumber, startColumn, endColumn, context) {
		const startPosition = this._getColumnPixelOffset(lineNumber, startColumn, context);
		return [new FloatHorizontalRange(startPosition, this._getColumnPixelOffset(lineNumber, endColumn, context) - startPosition)];
	}
	_getColumnPixelOffset(lineNumber, column, context) {
		if (column <= 300) {
			const horizontalOffset = this._characterMapping.getHorizontalOffset(column);
			return this._charWidth * horizontalOffset;
		}
		const keyColumnOrdinal = Math.floor((column - 1) / 300) - 1;
		const keyColumn = (keyColumnOrdinal + 1) * 300 + 1;
		let keyColumnPixelOffset = -1;
		if (this._keyColumnPixelOffsetCache) {
			keyColumnPixelOffset = this._keyColumnPixelOffsetCache[keyColumnOrdinal];
			if (keyColumnPixelOffset === -1) {
				keyColumnPixelOffset = this._actualReadPixelOffset(lineNumber, keyColumn, context);
				this._keyColumnPixelOffsetCache[keyColumnOrdinal] = keyColumnPixelOffset;
			}
		}
		if (keyColumnPixelOffset === -1) {
			const horizontalOffset = this._characterMapping.getHorizontalOffset(column);
			return this._charWidth * horizontalOffset;
		}
		const keyColumnHorizontalOffset = this._characterMapping.getHorizontalOffset(keyColumn);
		const horizontalOffset = this._characterMapping.getHorizontalOffset(column);
		return keyColumnPixelOffset + this._charWidth * (horizontalOffset - keyColumnHorizontalOffset);
	}
	_getReadingTarget(myDomNode) {
		return myDomNode.domNode.firstChild;
	}
	_actualReadPixelOffset(lineNumber, column, context) {
		if (!this.domNode) return -1;
		const domPosition = this._characterMapping.getDomPosition(column);
		const r = RangeUtil.readHorizontalRanges(this._getReadingTarget(this.domNode), domPosition.partIndex, domPosition.charIndex, domPosition.partIndex, domPosition.charIndex, context);
		if (!r || r.length === 0) return -1;
		return r[0].left;
	}
	getColumnOfNodeOffset(spanNode, offset) {
		return getColumnOfNodeOffset(this._characterMapping, spanNode, offset);
	}
};
/**
* Every time we render a line, we save what we have rendered in an instance of this class.
*/
var RenderedViewLine = class {
	constructor(domNode, renderLineInput, characterMapping, containsForeignElements) {
		this.domNode = domNode;
		this.input = renderLineInput;
		this._characterMapping = characterMapping;
		this._isWhitespaceOnly = /^\s*$/.test(renderLineInput.lineContent);
		this._containsForeignElements = containsForeignElements;
		this._cachedWidth = -1;
		this._pixelOffsetCache = null;
		if (renderLineInput.isLTR) {
			this._pixelOffsetCache = new Float32Array(Math.max(2, this._characterMapping.length + 1));
			for (let column = 0, len = this._characterMapping.length; column <= len; column++) this._pixelOffsetCache[column] = -1;
		}
	}
	_getReadingTarget(myDomNode) {
		return myDomNode.domNode.firstChild;
	}
	/**
	* Width of the line in pixels
	*/
	getWidth(context) {
		if (!this.domNode) return 0;
		if (this._cachedWidth === -1) {
			this._cachedWidth = this._getReadingTarget(this.domNode).offsetWidth;
			context?.markDidDomLayout();
		}
		return this._cachedWidth;
	}
	getWidthIsFast() {
		if (this._cachedWidth === -1) return false;
		return true;
	}
	resetCachedWidth() {
		this._cachedWidth = -1;
		if (this._pixelOffsetCache !== null) for (let column = 0, len = this._pixelOffsetCache.length; column < len; column++) this._pixelOffsetCache[column] = -1;
	}
	/**
	* Visible ranges for a model range
	*/
	getVisibleRangesForRange(lineNumber, startColumn, endColumn, context) {
		if (!this.domNode) return null;
		if (this._pixelOffsetCache !== null) {
			const startOffset = this._readPixelOffset(this.domNode, lineNumber, startColumn, context);
			if (startOffset === -1) return null;
			const endOffset = this._readPixelOffset(this.domNode, lineNumber, endColumn, context);
			if (endOffset === -1) return null;
			return [new FloatHorizontalRange(startOffset, endOffset - startOffset)];
		}
		return this._readVisibleRangesForRange(this.domNode, lineNumber, startColumn, endColumn, context);
	}
	_readVisibleRangesForRange(domNode, lineNumber, startColumn, endColumn, context) {
		if (startColumn === endColumn) {
			const pixelOffset = this._readPixelOffset(domNode, lineNumber, startColumn, context);
			if (pixelOffset === -1) return null;
			else return [new FloatHorizontalRange(pixelOffset, 0)];
		} else return this._readRawVisibleRangesForRange(domNode, startColumn, endColumn, context);
	}
	_readPixelOffset(domNode, lineNumber, column, context) {
		if (this.input.isLTR && this._characterMapping.length === 0) {
			if (this._containsForeignElements === 0) return 0;
			if (this._containsForeignElements === 2) return 0;
			if (this._containsForeignElements === 1) return this.getWidth(context);
			const readingTarget = this._getReadingTarget(domNode);
			if (readingTarget.firstChild) {
				context.markDidDomLayout();
				return readingTarget.firstChild.offsetWidth;
			} else return 0;
		}
		if (this._pixelOffsetCache !== null) {
			const cachedPixelOffset = this._pixelOffsetCache[column];
			if (cachedPixelOffset !== -1) return cachedPixelOffset;
			const result = this._actualReadPixelOffset(domNode, lineNumber, column, context);
			this._pixelOffsetCache[column] = result;
			return result;
		}
		return this._actualReadPixelOffset(domNode, lineNumber, column, context);
	}
	_actualReadPixelOffset(domNode, lineNumber, column, context) {
		if (this._characterMapping.length === 0) {
			const r = RangeUtil.readHorizontalRanges(this._getReadingTarget(domNode), 0, 0, 0, 0, context);
			if (!r || r.length === 0) return -1;
			return r[0].left;
		}
		if (this.input.isLTR && column === this._characterMapping.length && this._isWhitespaceOnly && this._containsForeignElements === 0) return this.getWidth(context);
		const domPosition = this._characterMapping.getDomPosition(column);
		if (this.input.useTwoCellFullwidthCharacters) {
			const target = this._getReadingTarget(domNode);
			if (isFullWidthCharacter(this.input.lineContent.charCodeAt(column - 1))) {
				const r = RangeUtil.readHorizontalRangeForElement(target, domPosition.partIndex, context);
				if (r) return r.left;
			} else if (isFullWidthCharacter(this.input.lineContent.charCodeAt(column - 2))) {
				const previousDomPosition = this._characterMapping.getDomPosition(column - 1);
				const r = RangeUtil.readHorizontalRangeForElement(target, previousDomPosition.partIndex, context);
				if (r) return r.left + r.width;
			}
		}
		const r = RangeUtil.readHorizontalRanges(this._getReadingTarget(domNode), domPosition.partIndex, domPosition.charIndex, domPosition.partIndex, domPosition.charIndex, context);
		if (!r || r.length === 0) return -1;
		const result = r[0].left;
		if (this.input.isBasicASCII) {
			const horizontalOffset = this._characterMapping.getHorizontalOffset(column);
			const expectedResult = Math.round(this.input.spaceWidth * horizontalOffset);
			if (Math.abs(expectedResult - result) <= 1) return expectedResult;
		}
		return result;
	}
	_readRawVisibleRangesForRange(domNode, startColumn, endColumn, context) {
		if (this.input.isLTR && startColumn === 1 && endColumn === this._characterMapping.length) return [new FloatHorizontalRange(0, this.getWidth(context))];
		const startDomPosition = this._characterMapping.getDomPosition(startColumn);
		const endDomPosition = this._characterMapping.getDomPosition(endColumn);
		return RangeUtil.readHorizontalRanges(this._getReadingTarget(domNode), startDomPosition.partIndex, startDomPosition.charIndex, endDomPosition.partIndex, endDomPosition.charIndex, context);
	}
	/**
	* Returns the column for the text found at a specific offset inside a rendered dom node
	*/
	getColumnOfNodeOffset(spanNode, offset) {
		return getColumnOfNodeOffset(this._characterMapping, spanNode, offset);
	}
};
var WebKitRenderedViewLine = class extends RenderedViewLine {
	_readVisibleRangesForRange(domNode, lineNumber, startColumn, endColumn, context) {
		const output = super._readVisibleRangesForRange(domNode, lineNumber, startColumn, endColumn, context);
		if (!output || output.length === 0 || startColumn === endColumn || startColumn === 1 && endColumn === this._characterMapping.length) return output;
		if (this.input.isLTR) {
			const endPixelOffset = this._readPixelOffset(domNode, lineNumber, endColumn, context);
			if (endPixelOffset !== -1) {
				const lastRange = output[output.length - 1];
				if (lastRange.left < endPixelOffset) lastRange.width = endPixelOffset - lastRange.left;
			}
		}
		return output;
	}
};
var createRenderedLine = (function() {
	if (isWebKit) return createWebKitRenderedLine;
	return createNormalRenderedLine;
})();
function createWebKitRenderedLine(domNode, renderLineInput, characterMapping, containsForeignElements) {
	return new WebKitRenderedViewLine(domNode, renderLineInput, characterMapping, containsForeignElements);
}
function createNormalRenderedLine(domNode, renderLineInput, characterMapping, containsForeignElements) {
	return new RenderedViewLine(domNode, renderLineInput, characterMapping, containsForeignElements);
}
function getColumnOfNodeOffset(characterMapping, spanNode, offset) {
	const spanNodeTextContentLength = spanNode.textContent.length;
	let spanIndex = -1;
	while (spanNode) {
		spanNode = spanNode.previousSibling;
		spanIndex++;
	}
	return characterMapping.getColumn(new DomPosition(spanIndex, offset), spanNodeTextContentLength);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/core/cursorColumns.js
/**
* A column in a position is the gap between two adjacent characters. The methods here
* work with a concept called "visible column". A visible column is a very rough approximation
* of the horizontal screen position of a column. For example, using a tab size of 4:
* ```txt
* |<TAB>|<TAB>|T|ext
* |     |     | \---- column = 4, visible column = 9
* |     |     \------ column = 3, visible column = 8
* |     \------------ column = 2, visible column = 4
* \------------------ column = 1, visible column = 0
* ```
*
* **NOTE**: Visual columns do not work well for RTL text or variable-width fonts or characters.
*
* **NOTE**: These methods work and make sense both on the model and on the view model.
*/
var CursorColumns = class CursorColumns {
	static _nextVisibleColumn(codePoint, visibleColumn, tabSize) {
		if (codePoint === 9) return CursorColumns.nextRenderTabStop(visibleColumn, tabSize);
		if (isFullWidthCharacter(codePoint) || isEmojiImprecise(codePoint)) return visibleColumn + 2;
		return visibleColumn + 1;
	}
	/**
	* Returns a visible column from a column.
	* @see {@link CursorColumns}
	*/
	static visibleColumnFromColumn(lineContent, column, tabSize) {
		const textLen = Math.min(column - 1, lineContent.length);
		const text = lineContent.substring(0, textLen);
		const iterator = new GraphemeIterator(text);
		let result = 0;
		while (!iterator.eol()) {
			const codePoint = getNextCodePoint(text, textLen, iterator.offset);
			iterator.nextGraphemeLength();
			result = this._nextVisibleColumn(codePoint, result, tabSize);
		}
		return result;
	}
	/**
	* Returns a column from a visible column.
	* @see {@link CursorColumns}
	*/
	static columnFromVisibleColumn(lineContent, visibleColumn, tabSize) {
		if (visibleColumn <= 0) return 1;
		const lineContentLength = lineContent.length;
		const iterator = new GraphemeIterator(lineContent);
		let beforeVisibleColumn = 0;
		let beforeColumn = 1;
		while (!iterator.eol()) {
			const codePoint = getNextCodePoint(lineContent, lineContentLength, iterator.offset);
			iterator.nextGraphemeLength();
			const afterVisibleColumn = this._nextVisibleColumn(codePoint, beforeVisibleColumn, tabSize);
			const afterColumn = iterator.offset + 1;
			if (afterVisibleColumn >= visibleColumn) {
				const beforeDelta = visibleColumn - beforeVisibleColumn;
				if (afterVisibleColumn - visibleColumn < beforeDelta) return afterColumn;
				else return beforeColumn;
			}
			beforeVisibleColumn = afterVisibleColumn;
			beforeColumn = afterColumn;
		}
		return lineContentLength + 1;
	}
	/**
	* ATTENTION: This works with 0-based columns (as opposed to the regular 1-based columns)
	* @see {@link CursorColumns}
	*/
	static nextRenderTabStop(visibleColumn, tabSize) {
		return visibleColumn + tabSize - visibleColumn % tabSize;
	}
	/**
	* ATTENTION: This works with 0-based columns (as opposed to the regular 1-based columns)
	* @see {@link CursorColumns}
	*/
	static nextIndentTabStop(visibleColumn, indentSize) {
		return CursorColumns.nextRenderTabStop(visibleColumn, indentSize);
	}
	/**
	* ATTENTION: This works with 0-based columns (as opposed to the regular 1-based columns)
	* @see {@link CursorColumns}
	*/
	static prevRenderTabStop(column, tabSize) {
		return Math.max(0, column - 1 - (column - 1) % tabSize);
	}
	/**
	* ATTENTION: This works with 0-based columns (as opposed to the regular 1-based columns)
	* @see {@link CursorColumns}
	*/
	static prevIndentTabStop(column, indentSize) {
		return CursorColumns.prevRenderTabStop(column, indentSize);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/cursor/cursorAtomicMoveOperations.js
var AtomicTabMoveOperations = class AtomicTabMoveOperations {
	/**
	* Get the visible column at the position. If we get to a non-whitespace character first
	* or past the end of string then return -1.
	*
	* **Note** `position` and the return value are 0-based.
	*/
	static whitespaceVisibleColumn(lineContent, position, tabSize) {
		const lineLength = lineContent.length;
		let visibleColumn = 0;
		let prevTabStopPosition = -1;
		let prevTabStopVisibleColumn = -1;
		for (let i = 0; i < lineLength; i++) {
			if (i === position) return [
				prevTabStopPosition,
				prevTabStopVisibleColumn,
				visibleColumn
			];
			if (visibleColumn % tabSize === 0) {
				prevTabStopPosition = i;
				prevTabStopVisibleColumn = visibleColumn;
			}
			switch (lineContent.charCodeAt(i)) {
				case 32:
					visibleColumn += 1;
					break;
				case 9:
					visibleColumn = CursorColumns.nextRenderTabStop(visibleColumn, tabSize);
					break;
				default: return [
					-1,
					-1,
					-1
				];
			}
		}
		if (position === lineLength) return [
			prevTabStopPosition,
			prevTabStopVisibleColumn,
			visibleColumn
		];
		return [
			-1,
			-1,
			-1
		];
	}
	/**
	* Return the position that should result from a move left, right or to the
	* nearest tab, if atomic tabs are enabled. Left and right are used for the
	* arrow key movements, nearest is used for mouse selection. It returns
	* -1 if atomic tabs are not relevant and you should fall back to normal
	* behaviour.
	*
	* **Note**: `position` and the return value are 0-based.
	*/
	static atomicPosition(lineContent, position, tabSize, direction) {
		const lineLength = lineContent.length;
		const [prevTabStopPosition, prevTabStopVisibleColumn, visibleColumn] = AtomicTabMoveOperations.whitespaceVisibleColumn(lineContent, position, tabSize);
		if (visibleColumn === -1) return -1;
		let left;
		switch (direction) {
			case 0:
				left = true;
				break;
			case 1:
				left = false;
				break;
			case 2:
				if (visibleColumn % tabSize === 0) return position;
				left = visibleColumn % tabSize <= tabSize / 2;
		}
		if (left) {
			if (prevTabStopPosition === -1) return -1;
			let currentVisibleColumn = prevTabStopVisibleColumn;
			for (let i = prevTabStopPosition; i < lineLength; ++i) {
				if (currentVisibleColumn === prevTabStopVisibleColumn + tabSize) return prevTabStopPosition;
				switch (lineContent.charCodeAt(i)) {
					case 32:
						currentVisibleColumn += 1;
						break;
					case 9:
						currentVisibleColumn = CursorColumns.nextRenderTabStop(currentVisibleColumn, tabSize);
						break;
					default: return -1;
				}
			}
			if (currentVisibleColumn === prevTabStopVisibleColumn + tabSize) return prevTabStopPosition;
			return -1;
		}
		const targetVisibleColumn = CursorColumns.nextRenderTabStop(visibleColumn, tabSize);
		let currentVisibleColumn = visibleColumn;
		for (let i = position; i < lineLength; i++) {
			if (currentVisibleColumn === targetVisibleColumn) return i;
			switch (lineContent.charCodeAt(i)) {
				case 32:
					currentVisibleColumn += 1;
					break;
				case 9:
					currentVisibleColumn = CursorColumns.nextRenderTabStop(currentVisibleColumn, tabSize);
					break;
				default: return -1;
			}
		}
		if (currentVisibleColumn === targetVisibleColumn) return lineLength;
		return -1;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/controller/mouseTarget.js
var UnknownHitTestResult = class {
	constructor(hitTarget = null) {
		this.hitTarget = hitTarget;
		this.type = 0;
	}
};
var ContentHitTestResult = class {
	get hitTarget() {
		return this.spanNode;
	}
	constructor(position, spanNode, injectedText) {
		this.position = position;
		this.spanNode = spanNode;
		this.injectedText = injectedText;
		this.type = 1;
	}
};
var HitTestResult;
(function(HitTestResult) {
	function createFromDOMInfo(ctx, spanNode, offset) {
		const position = ctx.getPositionFromDOMInfo(spanNode, offset);
		if (position) return new ContentHitTestResult(position, spanNode, null);
		return new UnknownHitTestResult(spanNode);
	}
	HitTestResult.createFromDOMInfo = createFromDOMInfo;
})(HitTestResult || (HitTestResult = {}));
var PointerHandlerLastRenderData = class {
	constructor(lastViewCursorsRenderData, lastTextareaPosition) {
		this.lastViewCursorsRenderData = lastViewCursorsRenderData;
		this.lastTextareaPosition = lastTextareaPosition;
	}
};
var MouseTarget = class {
	static _deduceRage(position, range = null) {
		if (!range && position) return new Range$2(position.lineNumber, position.column, position.lineNumber, position.column);
		return range ?? null;
	}
	static createUnknown(element, mouseColumn, position) {
		return {
			type: 0,
			element,
			mouseColumn,
			position,
			range: this._deduceRage(position)
		};
	}
	static createTextarea(element, mouseColumn) {
		return {
			type: 1,
			element,
			mouseColumn,
			position: null,
			range: null
		};
	}
	static createMargin(type, element, mouseColumn, position, range, detail) {
		return {
			type,
			element,
			mouseColumn,
			position,
			range,
			detail
		};
	}
	static createViewZone(type, element, mouseColumn, position, detail) {
		return {
			type,
			element,
			mouseColumn,
			position,
			range: this._deduceRage(position),
			detail
		};
	}
	static createContentText(element, mouseColumn, position, range, detail) {
		return {
			type: 6,
			element,
			mouseColumn,
			position,
			range: this._deduceRage(position, range),
			detail
		};
	}
	static createContentEmpty(element, mouseColumn, position, detail) {
		return {
			type: 7,
			element,
			mouseColumn,
			position,
			range: this._deduceRage(position),
			detail
		};
	}
	static createContentWidget(element, mouseColumn, detail) {
		return {
			type: 9,
			element,
			mouseColumn,
			position: null,
			range: null,
			detail
		};
	}
	static createScrollbar(element, mouseColumn, position) {
		return {
			type: 11,
			element,
			mouseColumn,
			position,
			range: this._deduceRage(position)
		};
	}
	static createOverlayWidget(element, mouseColumn, detail) {
		return {
			type: 12,
			element,
			mouseColumn,
			position: null,
			range: null,
			detail
		};
	}
	static createOutsideEditor(mouseColumn, position, outsidePosition, outsideDistance) {
		return {
			type: 13,
			element: null,
			mouseColumn,
			position,
			range: this._deduceRage(position),
			outsidePosition,
			outsideDistance
		};
	}
	static _typeToString(type) {
		if (type === 1) return "TEXTAREA";
		if (type === 2) return "GUTTER_GLYPH_MARGIN";
		if (type === 3) return "GUTTER_LINE_NUMBERS";
		if (type === 4) return "GUTTER_LINE_DECORATIONS";
		if (type === 5) return "GUTTER_VIEW_ZONE";
		if (type === 6) return "CONTENT_TEXT";
		if (type === 7) return "CONTENT_EMPTY";
		if (type === 8) return "CONTENT_VIEW_ZONE";
		if (type === 9) return "CONTENT_WIDGET";
		if (type === 10) return "OVERVIEW_RULER";
		if (type === 11) return "SCROLLBAR";
		if (type === 12) return "OVERLAY_WIDGET";
		return "UNKNOWN";
	}
	static toString(target) {
		return this._typeToString(target.type) + ": " + target.position + " - " + target.range + " - " + JSON.stringify(target.detail);
	}
};
var ElementPath = class {
	static isTextArea(path) {
		return path.length === 2 && path[0] === 3 && path[1] === 7;
	}
	static isChildOfViewLines(path) {
		return path.length >= 4 && path[0] === 3 && path[3] === 8;
	}
	static isStrictChildOfViewLines(path) {
		return path.length > 4 && path[0] === 3 && path[3] === 8;
	}
	static isChildOfScrollableElement(path) {
		return path.length >= 2 && path[0] === 3 && path[1] === 6;
	}
	static isChildOfMinimap(path) {
		return path.length >= 2 && path[0] === 3 && path[1] === 9;
	}
	static isChildOfContentWidgets(path) {
		return path.length >= 4 && path[0] === 3 && path[3] === 1;
	}
	static isChildOfOverflowGuard(path) {
		return path.length >= 1 && path[0] === 3;
	}
	static isChildOfOverflowingContentWidgets(path) {
		return path.length >= 1 && path[0] === 2;
	}
	static isChildOfOverlayWidgets(path) {
		return path.length >= 2 && path[0] === 3 && path[1] === 4;
	}
	static isChildOfOverflowingOverlayWidgets(path) {
		return path.length >= 1 && path[0] === 5;
	}
};
var HitTestContext = class HitTestContext {
	constructor(context, viewHelper, lastRenderData) {
		this.viewModel = context.viewModel;
		const options = context.configuration.options;
		this.layoutInfo = options.get(166);
		this.viewDomNode = viewHelper.viewDomNode;
		this.viewLinesGpu = viewHelper.viewLinesGpu;
		this.lineHeight = options.get(75);
		this.stickyTabStops = options.get(132);
		this.typicalHalfwidthCharacterWidth = options.get(59).typicalHalfwidthCharacterWidth;
		this.lastRenderData = lastRenderData;
		this._context = context;
		this._viewHelper = viewHelper;
	}
	getZoneAtCoord(mouseVerticalOffset) {
		return HitTestContext.getZoneAtCoord(this._context, mouseVerticalOffset);
	}
	static getZoneAtCoord(context, mouseVerticalOffset) {
		const viewZoneWhitespace = context.viewLayout.getWhitespaceAtVerticalOffset(mouseVerticalOffset);
		if (viewZoneWhitespace) {
			const viewZoneMiddle = viewZoneWhitespace.verticalOffset + viewZoneWhitespace.height / 2;
			const lineCount = context.viewModel.getLineCount();
			let positionBefore = null;
			let position;
			let positionAfter = null;
			if (viewZoneWhitespace.afterLineNumber !== lineCount) positionAfter = new Position$1(viewZoneWhitespace.afterLineNumber + 1, 1);
			if (viewZoneWhitespace.afterLineNumber > 0) positionBefore = new Position$1(viewZoneWhitespace.afterLineNumber, context.viewModel.getLineMaxColumn(viewZoneWhitespace.afterLineNumber));
			if (positionAfter === null) position = positionBefore;
			else if (positionBefore === null) position = positionAfter;
			else if (mouseVerticalOffset < viewZoneMiddle) position = positionBefore;
			else position = positionAfter;
			return {
				viewZoneId: viewZoneWhitespace.id,
				afterLineNumber: viewZoneWhitespace.afterLineNumber,
				positionBefore,
				positionAfter,
				position
			};
		}
		return null;
	}
	getFullLineRangeAtCoord(mouseVerticalOffset) {
		if (this._context.viewLayout.isAfterLines(mouseVerticalOffset)) {
			const lineNumber = this._context.viewModel.getLineCount();
			const maxLineColumn = this._context.viewModel.getLineMaxColumn(lineNumber);
			return {
				range: new Range$2(lineNumber, maxLineColumn, lineNumber, maxLineColumn),
				isAfterLines: true
			};
		}
		const lineNumber = this._context.viewLayout.getLineNumberAtVerticalOffset(mouseVerticalOffset);
		const maxLineColumn = this._context.viewModel.getLineMaxColumn(lineNumber);
		return {
			range: new Range$2(lineNumber, 1, lineNumber, maxLineColumn),
			isAfterLines: false
		};
	}
	getLineNumberAtVerticalOffset(mouseVerticalOffset) {
		return this._context.viewLayout.getLineNumberAtVerticalOffset(mouseVerticalOffset);
	}
	isAfterLines(mouseVerticalOffset) {
		return this._context.viewLayout.isAfterLines(mouseVerticalOffset);
	}
	isInTopPadding(mouseVerticalOffset) {
		return this._context.viewLayout.isInTopPadding(mouseVerticalOffset);
	}
	isInBottomPadding(mouseVerticalOffset) {
		return this._context.viewLayout.isInBottomPadding(mouseVerticalOffset);
	}
	getVerticalOffsetForLineNumber(lineNumber) {
		return this._context.viewLayout.getVerticalOffsetForLineNumber(lineNumber);
	}
	findAttribute(element, attr) {
		return HitTestContext._findAttribute(element, attr, this._viewHelper.viewDomNode);
	}
	static _findAttribute(element, attr, stopAt) {
		while (element && element !== element.ownerDocument.body) {
			if (element.hasAttribute && element.hasAttribute(attr)) return element.getAttribute(attr);
			if (element === stopAt) return null;
			element = element.parentNode;
		}
		return null;
	}
	getLineWidth(lineNumber) {
		return this._viewHelper.getLineWidth(lineNumber);
	}
	isRtl(lineNumber) {
		return this.viewModel.getTextDirection(lineNumber) === TextDirection.RTL;
	}
	visibleRangeForPosition(lineNumber, column) {
		return this._viewHelper.visibleRangeForPosition(lineNumber, column);
	}
	getPositionFromDOMInfo(spanNode, offset) {
		return this._viewHelper.getPositionFromDOMInfo(spanNode, offset);
	}
	getCurrentScrollTop() {
		return this._context.viewLayout.getCurrentScrollTop();
	}
	getCurrentScrollLeft() {
		return this._context.viewLayout.getCurrentScrollLeft();
	}
};
var BareHitTestRequest = class {
	constructor(ctx, editorPos, pos, relativePos) {
		this.editorPos = editorPos;
		this.pos = pos;
		this.relativePos = relativePos;
		this.mouseVerticalOffset = Math.max(0, ctx.getCurrentScrollTop() + this.relativePos.y);
		this.mouseContentHorizontalOffset = ctx.getCurrentScrollLeft() + this.relativePos.x - ctx.layoutInfo.contentLeft;
		this.isInMarginArea = this.relativePos.x < ctx.layoutInfo.contentLeft && this.relativePos.x >= ctx.layoutInfo.glyphMarginLeft;
		this.isInContentArea = !this.isInMarginArea;
		this.mouseColumn = Math.max(0, MouseTargetFactory._getMouseColumn(this.mouseContentHorizontalOffset, ctx.typicalHalfwidthCharacterWidth));
	}
};
var HitTestRequest = class extends BareHitTestRequest {
	get target() {
		if (this._useHitTestTarget) return this.hitTestResult.value.hitTarget;
		return this._eventTarget;
	}
	get targetPath() {
		if (this._targetPathCacheElement !== this.target) {
			this._targetPathCacheElement = this.target;
			this._targetPathCacheValue = PartFingerprints.collect(this.target, this._ctx.viewDomNode);
		}
		return this._targetPathCacheValue;
	}
	constructor(ctx, editorPos, pos, relativePos, eventTarget) {
		super(ctx, editorPos, pos, relativePos);
		this.hitTestResult = new Lazy(() => MouseTargetFactory.doHitTest(this._ctx, this));
		this._targetPathCacheElement = null;
		this._targetPathCacheValue = /* @__PURE__ */ new Uint8Array(0);
		this._ctx = ctx;
		this._eventTarget = eventTarget;
		const hasEventTarget = Boolean(this._eventTarget);
		this._useHitTestTarget = !hasEventTarget;
	}
	toString() {
		return `pos(${this.pos.x},${this.pos.y}), editorPos(${this.editorPos.x},${this.editorPos.y}), relativePos(${this.relativePos.x},${this.relativePos.y}), mouseVerticalOffset: ${this.mouseVerticalOffset}, mouseContentHorizontalOffset: ${this.mouseContentHorizontalOffset}\n\ttarget: ${this.target ? this.target.outerHTML : null}`;
	}
	get wouldBenefitFromHitTestTargetSwitch() {
		return !this._useHitTestTarget && this.hitTestResult.value.hitTarget !== null && this.target !== this.hitTestResult.value.hitTarget;
	}
	switchToHitTestTarget() {
		this._useHitTestTarget = true;
	}
	_getMouseColumn(position = null) {
		if (position && position.column < this._ctx.viewModel.getLineMaxColumn(position.lineNumber)) return CursorColumns.visibleColumnFromColumn(this._ctx.viewModel.getLineContent(position.lineNumber), position.column, this._ctx.viewModel.model.getOptions().tabSize) + 1;
		return this.mouseColumn;
	}
	fulfillUnknown(position = null) {
		return MouseTarget.createUnknown(this.target, this._getMouseColumn(position), position);
	}
	fulfillTextarea() {
		return MouseTarget.createTextarea(this.target, this._getMouseColumn());
	}
	fulfillMargin(type, position, range, detail) {
		return MouseTarget.createMargin(type, this.target, this._getMouseColumn(position), position, range, detail);
	}
	fulfillViewZone(type, position, detail) {
		return MouseTarget.createViewZone(type, this.target, this._getMouseColumn(), position, detail);
	}
	fulfillContentText(position, range, detail) {
		return MouseTarget.createContentText(this.target, this._getMouseColumn(position), position, range, detail);
	}
	fulfillContentEmpty(position, detail) {
		return MouseTarget.createContentEmpty(this.target, this._getMouseColumn(position), position, detail);
	}
	fulfillContentWidget(detail) {
		return MouseTarget.createContentWidget(this.target, this._getMouseColumn(), detail);
	}
	fulfillScrollbar(position) {
		return MouseTarget.createScrollbar(this.target, this._getMouseColumn(position), position);
	}
	fulfillOverlayWidget(detail) {
		return MouseTarget.createOverlayWidget(this.target, this._getMouseColumn(), detail);
	}
};
var EMPTY_CONTENT_AFTER_LINES = { isAfterLines: true };
function createEmptyContentDataInLines(horizontalDistanceToText) {
	return {
		isAfterLines: false,
		horizontalDistanceToText
	};
}
var MouseTargetFactory = class MouseTargetFactory {
	constructor(context, viewHelper) {
		this._context = context;
		this._viewHelper = viewHelper;
	}
	mouseTargetIsWidget(e) {
		const t = e.target;
		const path = PartFingerprints.collect(t, this._viewHelper.viewDomNode);
		if (ElementPath.isChildOfContentWidgets(path) || ElementPath.isChildOfOverflowingContentWidgets(path)) return true;
		if (ElementPath.isChildOfOverlayWidgets(path) || ElementPath.isChildOfOverflowingOverlayWidgets(path)) return true;
		return false;
	}
	createMouseTarget(lastRenderData, editorPos, pos, relativePos, target) {
		const ctx = new HitTestContext(this._context, this._viewHelper, lastRenderData);
		const request = new HitTestRequest(ctx, editorPos, pos, relativePos, target);
		try {
			const r = MouseTargetFactory._createMouseTarget(ctx, request);
			if (r.type === 6) {
				if (ctx.stickyTabStops && r.position !== null) {
					const position = MouseTargetFactory._snapToSoftTabBoundary(r.position, ctx.viewModel);
					const range = Range$2.fromPositions(position, position).plusRange(r.range);
					return request.fulfillContentText(position, range, r.detail);
				}
			}
			return r;
		} catch (err) {
			return request.fulfillUnknown();
		}
	}
	static _createMouseTarget(ctx, request) {
		if (request.target === null) return request.fulfillUnknown();
		const resolvedRequest = request;
		let result = null;
		if (!ElementPath.isChildOfOverflowGuard(request.targetPath) && !ElementPath.isChildOfOverflowingContentWidgets(request.targetPath) && !ElementPath.isChildOfOverflowingOverlayWidgets(request.targetPath)) result = result || request.fulfillUnknown();
		result = result || MouseTargetFactory._hitTestContentWidget(ctx, resolvedRequest);
		result = result || MouseTargetFactory._hitTestOverlayWidget(ctx, resolvedRequest);
		result = result || MouseTargetFactory._hitTestMinimap(ctx, resolvedRequest);
		result = result || MouseTargetFactory._hitTestScrollbarSlider(ctx, resolvedRequest);
		result = result || MouseTargetFactory._hitTestViewZone(ctx, resolvedRequest);
		result = result || MouseTargetFactory._hitTestMargin(ctx, resolvedRequest);
		result = result || MouseTargetFactory._hitTestViewCursor(ctx, resolvedRequest);
		result = result || MouseTargetFactory._hitTestTextArea(ctx, resolvedRequest);
		result = result || MouseTargetFactory._hitTestViewLines(ctx, resolvedRequest);
		result = result || MouseTargetFactory._hitTestScrollbar(ctx, resolvedRequest);
		return result || request.fulfillUnknown();
	}
	static _hitTestContentWidget(ctx, request) {
		if (ElementPath.isChildOfContentWidgets(request.targetPath) || ElementPath.isChildOfOverflowingContentWidgets(request.targetPath)) {
			const widgetId = ctx.findAttribute(request.target, "widgetId");
			if (widgetId) return request.fulfillContentWidget(widgetId);
			else return request.fulfillUnknown();
		}
		return null;
	}
	static _hitTestOverlayWidget(ctx, request) {
		if (ElementPath.isChildOfOverlayWidgets(request.targetPath) || ElementPath.isChildOfOverflowingOverlayWidgets(request.targetPath)) {
			const widgetId = ctx.findAttribute(request.target, "widgetId");
			if (widgetId) return request.fulfillOverlayWidget(widgetId);
			else return request.fulfillUnknown();
		}
		return null;
	}
	static _hitTestViewCursor(ctx, request) {
		if (request.target) {
			const lastViewCursorsRenderData = ctx.lastRenderData.lastViewCursorsRenderData;
			for (const d of lastViewCursorsRenderData) if (request.target === d.domNode) return request.fulfillContentText(d.position, null, {
				mightBeForeignElement: false,
				injectedText: null
			});
		}
		if (request.isInContentArea) {
			const lastViewCursorsRenderData = ctx.lastRenderData.lastViewCursorsRenderData;
			const mouseContentHorizontalOffset = request.mouseContentHorizontalOffset;
			const mouseVerticalOffset = request.mouseVerticalOffset;
			for (const d of lastViewCursorsRenderData) {
				if (mouseContentHorizontalOffset < d.contentLeft) continue;
				if (mouseContentHorizontalOffset > d.contentLeft + d.width) continue;
				const cursorVerticalOffset = ctx.getVerticalOffsetForLineNumber(d.position.lineNumber);
				if (cursorVerticalOffset <= mouseVerticalOffset && mouseVerticalOffset <= cursorVerticalOffset + d.height) return request.fulfillContentText(d.position, null, {
					mightBeForeignElement: false,
					injectedText: null
				});
			}
		}
		return null;
	}
	static _hitTestViewZone(ctx, request) {
		const viewZoneData = ctx.getZoneAtCoord(request.mouseVerticalOffset);
		if (viewZoneData) {
			const mouseTargetType = request.isInContentArea ? 8 : 5;
			return request.fulfillViewZone(mouseTargetType, viewZoneData.position, viewZoneData);
		}
		return null;
	}
	static _hitTestTextArea(ctx, request) {
		if (ElementPath.isTextArea(request.targetPath)) {
			if (ctx.lastRenderData.lastTextareaPosition) return request.fulfillContentText(ctx.lastRenderData.lastTextareaPosition, null, {
				mightBeForeignElement: false,
				injectedText: null
			});
			return request.fulfillTextarea();
		}
		return null;
	}
	static _hitTestMargin(ctx, request) {
		if (request.isInMarginArea) {
			const res = ctx.getFullLineRangeAtCoord(request.mouseVerticalOffset);
			const pos = res.range.getStartPosition();
			let offset = Math.abs(request.relativePos.x);
			const detail = {
				isAfterLines: res.isAfterLines,
				glyphMarginLeft: ctx.layoutInfo.glyphMarginLeft,
				glyphMarginWidth: ctx.layoutInfo.glyphMarginWidth,
				lineNumbersWidth: ctx.layoutInfo.lineNumbersWidth,
				offsetX: offset
			};
			offset -= ctx.layoutInfo.glyphMarginLeft;
			if (offset <= ctx.layoutInfo.glyphMarginWidth) {
				const modelCoordinate = ctx.viewModel.coordinatesConverter.convertViewPositionToModelPosition(res.range.getStartPosition());
				detail.glyphMarginLane = ctx.viewModel.glyphLanes.getLanesAtLine(modelCoordinate.lineNumber)[Math.floor(offset / ctx.lineHeight)];
				return request.fulfillMargin(2, pos, res.range, detail);
			}
			offset -= ctx.layoutInfo.glyphMarginWidth;
			if (offset <= ctx.layoutInfo.lineNumbersWidth) return request.fulfillMargin(3, pos, res.range, detail);
			offset -= ctx.layoutInfo.lineNumbersWidth;
			return request.fulfillMargin(4, pos, res.range, detail);
		}
		return null;
	}
	static _hitTestViewLines(ctx, request) {
		if (!ElementPath.isChildOfViewLines(request.targetPath)) return null;
		if (ctx.isInTopPadding(request.mouseVerticalOffset)) return request.fulfillContentEmpty(new Position$1(1, 1), EMPTY_CONTENT_AFTER_LINES);
		if (ctx.isAfterLines(request.mouseVerticalOffset) || ctx.isInBottomPadding(request.mouseVerticalOffset)) {
			const lineCount = ctx.viewModel.getLineCount();
			const maxLineColumn = ctx.viewModel.getLineMaxColumn(lineCount);
			return request.fulfillContentEmpty(new Position$1(lineCount, maxLineColumn), EMPTY_CONTENT_AFTER_LINES);
		}
		if (ElementPath.isStrictChildOfViewLines(request.targetPath)) {
			const lineNumber = ctx.getLineNumberAtVerticalOffset(request.mouseVerticalOffset);
			const lineLength = ctx.viewModel.getLineLength(lineNumber);
			const lineWidth = ctx.getLineWidth(lineNumber);
			if (lineLength === 0) {
				const detail = createEmptyContentDataInLines(request.mouseContentHorizontalOffset - lineWidth);
				return request.fulfillContentEmpty(new Position$1(lineNumber, 1), detail);
			}
			if (ctx.isRtl(lineNumber)) {
				if (request.mouseContentHorizontalOffset + lineWidth <= ctx.layoutInfo.contentWidth - ctx.layoutInfo.verticalScrollbarWidth) {
					const detail = createEmptyContentDataInLines(request.mouseContentHorizontalOffset - lineWidth);
					const pos = new Position$1(lineNumber, ctx.viewModel.getLineMaxColumn(lineNumber));
					return request.fulfillContentEmpty(pos, detail);
				}
			} else if (request.mouseContentHorizontalOffset >= lineWidth) {
				const detail = createEmptyContentDataInLines(request.mouseContentHorizontalOffset - lineWidth);
				const pos = new Position$1(lineNumber, ctx.viewModel.getLineMaxColumn(lineNumber));
				return request.fulfillContentEmpty(pos, detail);
			}
		} else if (ctx.viewLinesGpu) {
			const lineNumber = ctx.getLineNumberAtVerticalOffset(request.mouseVerticalOffset);
			if (ctx.viewModel.getLineLength(lineNumber) === 0) {
				const lineWidth = ctx.getLineWidth(lineNumber);
				const detail = createEmptyContentDataInLines(request.mouseContentHorizontalOffset - lineWidth);
				return request.fulfillContentEmpty(new Position$1(lineNumber, 1), detail);
			}
			const lineWidth = ctx.getLineWidth(lineNumber);
			if (ctx.isRtl(lineNumber)) {
				if (request.mouseContentHorizontalOffset + lineWidth <= ctx.layoutInfo.contentWidth - ctx.layoutInfo.verticalScrollbarWidth) {
					const detail = createEmptyContentDataInLines(request.mouseContentHorizontalOffset - lineWidth);
					const pos = new Position$1(lineNumber, ctx.viewModel.getLineMaxColumn(lineNumber));
					return request.fulfillContentEmpty(pos, detail);
				}
			} else if (request.mouseContentHorizontalOffset >= lineWidth) {
				const detail = createEmptyContentDataInLines(request.mouseContentHorizontalOffset - lineWidth);
				const pos = new Position$1(lineNumber, ctx.viewModel.getLineMaxColumn(lineNumber));
				return request.fulfillContentEmpty(pos, detail);
			}
			const position = ctx.viewLinesGpu.getPositionAtCoordinate(lineNumber, request.mouseContentHorizontalOffset);
			if (position) return request.fulfillContentText(position, Range$2.fromPositions(position, position), {
				injectedText: null,
				mightBeForeignElement: false
			});
		}
		const hitTestResult = request.hitTestResult.value;
		if (hitTestResult.type === 1) return MouseTargetFactory.createMouseTargetFromHitTestPosition(ctx, request, hitTestResult.spanNode, hitTestResult.position, hitTestResult.injectedText);
		if (request.wouldBenefitFromHitTestTargetSwitch) {
			request.switchToHitTestTarget();
			return this._createMouseTarget(ctx, request);
		}
		return request.fulfillUnknown();
	}
	static _hitTestMinimap(ctx, request) {
		if (ElementPath.isChildOfMinimap(request.targetPath)) {
			const possibleLineNumber = ctx.getLineNumberAtVerticalOffset(request.mouseVerticalOffset);
			const maxColumn = ctx.viewModel.getLineMaxColumn(possibleLineNumber);
			return request.fulfillScrollbar(new Position$1(possibleLineNumber, maxColumn));
		}
		return null;
	}
	static _hitTestScrollbarSlider(ctx, request) {
		if (ElementPath.isChildOfScrollableElement(request.targetPath)) {
			if (request.target && request.target.nodeType === 1) {
				const className = request.target.className;
				if (className && /\b(slider|scrollbar)\b/.test(className)) {
					const possibleLineNumber = ctx.getLineNumberAtVerticalOffset(request.mouseVerticalOffset);
					const maxColumn = ctx.viewModel.getLineMaxColumn(possibleLineNumber);
					return request.fulfillScrollbar(new Position$1(possibleLineNumber, maxColumn));
				}
			}
		}
		return null;
	}
	static _hitTestScrollbar(ctx, request) {
		if (ElementPath.isChildOfScrollableElement(request.targetPath)) {
			const possibleLineNumber = ctx.getLineNumberAtVerticalOffset(request.mouseVerticalOffset);
			const maxColumn = ctx.viewModel.getLineMaxColumn(possibleLineNumber);
			return request.fulfillScrollbar(new Position$1(possibleLineNumber, maxColumn));
		}
		return null;
	}
	getMouseColumn(relativePos) {
		const options = this._context.configuration.options;
		const layoutInfo = options.get(166);
		const mouseContentHorizontalOffset = this._context.viewLayout.getCurrentScrollLeft() + relativePos.x - layoutInfo.contentLeft;
		return MouseTargetFactory._getMouseColumn(mouseContentHorizontalOffset, options.get(59).typicalHalfwidthCharacterWidth);
	}
	static _getMouseColumn(mouseContentHorizontalOffset, typicalHalfwidthCharacterWidth) {
		if (mouseContentHorizontalOffset < 0) return 1;
		return Math.round(mouseContentHorizontalOffset / typicalHalfwidthCharacterWidth) + 1;
	}
	static createMouseTargetFromHitTestPosition(ctx, request, spanNode, pos, injectedText) {
		const lineNumber = pos.lineNumber;
		const column = pos.column;
		const lineWidth = ctx.getLineWidth(lineNumber);
		if (request.mouseContentHorizontalOffset > lineWidth) {
			const detail = createEmptyContentDataInLines(request.mouseContentHorizontalOffset - lineWidth);
			return request.fulfillContentEmpty(pos, detail);
		}
		const visibleRange = ctx.visibleRangeForPosition(lineNumber, column);
		if (!visibleRange) return request.fulfillUnknown(pos);
		const columnHorizontalOffset = visibleRange.left;
		if (Math.abs(request.mouseContentHorizontalOffset - columnHorizontalOffset) < 1) return request.fulfillContentText(pos, null, {
			mightBeForeignElement: !!injectedText,
			injectedText
		});
		const points = [];
		points.push({
			offset: visibleRange.left,
			column
		});
		if (column > 1) {
			const visibleRange = ctx.visibleRangeForPosition(lineNumber, column - 1);
			if (visibleRange) points.push({
				offset: visibleRange.left,
				column: column - 1
			});
		}
		if (column < ctx.viewModel.getLineMaxColumn(lineNumber)) {
			const visibleRange = ctx.visibleRangeForPosition(lineNumber, column + 1);
			if (visibleRange) points.push({
				offset: visibleRange.left,
				column: column + 1
			});
		}
		points.sort((a, b) => a.offset - b.offset);
		const mouseCoordinates = request.pos.toClientCoordinates(getWindow(ctx.viewDomNode));
		const spanNodeClientRect = spanNode.getBoundingClientRect();
		const mouseIsOverSpanNode = spanNodeClientRect.left <= mouseCoordinates.clientX && mouseCoordinates.clientX <= spanNodeClientRect.right;
		let rng = null;
		for (let i = 1; i < points.length; i++) {
			const prev = points[i - 1];
			const curr = points[i];
			if (prev.offset <= request.mouseContentHorizontalOffset && request.mouseContentHorizontalOffset <= curr.offset) {
				rng = new Range$2(lineNumber, prev.column, lineNumber, curr.column);
				pos = Math.abs(prev.offset - request.mouseContentHorizontalOffset) < Math.abs(curr.offset - request.mouseContentHorizontalOffset) ? new Position$1(lineNumber, prev.column) : new Position$1(lineNumber, curr.column);
				break;
			}
		}
		return request.fulfillContentText(pos, rng, {
			mightBeForeignElement: !mouseIsOverSpanNode || !!injectedText,
			injectedText
		});
	}
	/**
	* Most probably WebKit browsers and Edge
	*/
	static _doHitTestWithCaretRangeFromPoint(ctx, request) {
		const lineNumber = ctx.getLineNumberAtVerticalOffset(request.mouseVerticalOffset);
		const lineStartVerticalOffset = ctx.getVerticalOffsetForLineNumber(lineNumber);
		const lineEndVerticalOffset = lineStartVerticalOffset + ctx.lineHeight;
		if (!(lineNumber === ctx.viewModel.getLineCount() && request.mouseVerticalOffset > lineEndVerticalOffset)) {
			const lineCenteredVerticalOffset = Math.floor((lineStartVerticalOffset + lineEndVerticalOffset) / 2);
			let adjustedPageY = request.pos.y + (lineCenteredVerticalOffset - request.mouseVerticalOffset);
			if (adjustedPageY <= request.editorPos.y) adjustedPageY = request.editorPos.y + 1;
			if (adjustedPageY >= request.editorPos.y + request.editorPos.height) adjustedPageY = request.editorPos.y + request.editorPos.height - 1;
			const adjustedPage = new PageCoordinates(request.pos.x, adjustedPageY);
			const r = this._actualDoHitTestWithCaretRangeFromPoint(ctx, adjustedPage.toClientCoordinates(getWindow(ctx.viewDomNode)));
			if (r.type === 1) return r;
		}
		return this._actualDoHitTestWithCaretRangeFromPoint(ctx, request.pos.toClientCoordinates(getWindow(ctx.viewDomNode)));
	}
	static _actualDoHitTestWithCaretRangeFromPoint(ctx, coords) {
		const shadowRoot = getShadowRoot(ctx.viewDomNode);
		let range;
		if (shadowRoot) {
			if (typeof shadowRoot.caretRangeFromPoint === "undefined") range = shadowCaretRangeFromPoint(shadowRoot, coords.clientX, coords.clientY);
			else range = shadowRoot.caretRangeFromPoint(coords.clientX, coords.clientY);
		} else range = ctx.viewDomNode.ownerDocument.caretRangeFromPoint(coords.clientX, coords.clientY);
		if (!range || !range.startContainer) return new UnknownHitTestResult();
		const startContainer = range.startContainer;
		if (startContainer.nodeType === startContainer.TEXT_NODE) {
			const parent1 = startContainer.parentNode;
			const parent2 = parent1 ? parent1.parentNode : null;
			const parent3 = parent2 ? parent2.parentNode : null;
			if ((parent3 && parent3.nodeType === parent3.ELEMENT_NODE ? parent3.className : null) === ViewLine.CLASS_NAME) return HitTestResult.createFromDOMInfo(ctx, parent1, range.startOffset);
			else return new UnknownHitTestResult(startContainer.parentNode);
		} else if (startContainer.nodeType === startContainer.ELEMENT_NODE) {
			const parent1 = startContainer.parentNode;
			const parent2 = parent1 ? parent1.parentNode : null;
			if ((parent2 && parent2.nodeType === parent2.ELEMENT_NODE ? parent2.className : null) === ViewLine.CLASS_NAME) return HitTestResult.createFromDOMInfo(ctx, startContainer, startContainer.textContent.length);
			else return new UnknownHitTestResult(startContainer);
		}
		return new UnknownHitTestResult();
	}
	/**
	* Most probably Gecko
	*/
	static _doHitTestWithCaretPositionFromPoint(ctx, coords) {
		const hitResult = ctx.viewDomNode.ownerDocument.caretPositionFromPoint(coords.clientX, coords.clientY);
		if (hitResult.offsetNode.nodeType === hitResult.offsetNode.TEXT_NODE) {
			const parent1 = hitResult.offsetNode.parentNode;
			const parent2 = parent1 ? parent1.parentNode : null;
			const parent3 = parent2 ? parent2.parentNode : null;
			if ((parent3 && parent3.nodeType === parent3.ELEMENT_NODE ? parent3.className : null) === ViewLine.CLASS_NAME) return HitTestResult.createFromDOMInfo(ctx, hitResult.offsetNode.parentNode, hitResult.offset);
			else return new UnknownHitTestResult(hitResult.offsetNode.parentNode);
		}
		if (hitResult.offsetNode.nodeType === hitResult.offsetNode.ELEMENT_NODE) {
			const parent1 = hitResult.offsetNode.parentNode;
			const parent1ClassName = parent1 && parent1.nodeType === parent1.ELEMENT_NODE ? parent1.className : null;
			const parent2 = parent1 ? parent1.parentNode : null;
			const parent2ClassName = parent2 && parent2.nodeType === parent2.ELEMENT_NODE ? parent2.className : null;
			if (parent1ClassName === ViewLine.CLASS_NAME) {
				const tokenSpan = hitResult.offsetNode.childNodes[Math.min(hitResult.offset, hitResult.offsetNode.childNodes.length - 1)];
				if (tokenSpan) return HitTestResult.createFromDOMInfo(ctx, tokenSpan, 0);
			} else if (parent2ClassName === ViewLine.CLASS_NAME) return HitTestResult.createFromDOMInfo(ctx, hitResult.offsetNode, 0);
		}
		return new UnknownHitTestResult(hitResult.offsetNode);
	}
	static _snapToSoftTabBoundary(position, viewModel) {
		const lineContent = viewModel.getLineContent(position.lineNumber);
		const { tabSize } = viewModel.model.getOptions();
		const newPosition = AtomicTabMoveOperations.atomicPosition(lineContent, position.column - 1, tabSize, 2);
		if (newPosition !== -1) return new Position$1(position.lineNumber, newPosition + 1);
		return position;
	}
	static doHitTest(ctx, request) {
		let result = new UnknownHitTestResult();
		if (typeof ctx.viewDomNode.ownerDocument.caretRangeFromPoint === "function") result = this._doHitTestWithCaretRangeFromPoint(ctx, request);
		else if (ctx.viewDomNode.ownerDocument.caretPositionFromPoint) result = this._doHitTestWithCaretPositionFromPoint(ctx, request.pos.toClientCoordinates(getWindow(ctx.viewDomNode)));
		if (result.type === 1) {
			const injectedText = ctx.viewModel.getInjectedTextAt(result.position);
			const normalizedPosition = ctx.viewModel.normalizePosition(result.position, 2);
			if (injectedText || !normalizedPosition.equals(result.position)) result = new ContentHitTestResult(normalizedPosition, result.spanNode, injectedText);
		}
		return result;
	}
};
function shadowCaretRangeFromPoint(shadowRoot, x, y) {
	const range = document.createRange();
	let el = shadowRoot.elementFromPoint(x, y);
	if (el?.hasChildNodes()) {
		while (el && el.firstChild && el.firstChild.nodeType !== el.firstChild.TEXT_NODE && el.lastChild && el.lastChild.firstChild) el = el.lastChild;
		const rect = el.getBoundingClientRect();
		const computedStyle = getWindow(el).getComputedStyle(el, null);
		const font = `${computedStyle.getPropertyValue("font-style")} ${computedStyle.getPropertyValue("font-variant")} ${computedStyle.getPropertyValue("font-weight")} ${computedStyle.getPropertyValue("font-size")}/${computedStyle.getPropertyValue("line-height")} ${computedStyle.getPropertyValue("font-family")}`;
		const text = el.innerText;
		let pixelCursor = rect.left;
		let offset = 0;
		let step;
		if (x > rect.left + rect.width) offset = text.length;
		else {
			const charWidthReader = CharWidthReader.getInstance();
			for (let i = 0; i < text.length + 1; i++) {
				step = charWidthReader.getCharWidth(text.charAt(i), font) / 2;
				pixelCursor += step;
				if (x < pixelCursor) {
					offset = i;
					break;
				}
				pixelCursor += step;
			}
		}
		range.setStart(el.firstChild, offset);
		range.setEnd(el.firstChild, offset);
	}
	return range;
}
var CharWidthReader = class CharWidthReader {
	static {
		this._INSTANCE = null;
	}
	static getInstance() {
		if (!CharWidthReader._INSTANCE) CharWidthReader._INSTANCE = new CharWidthReader();
		return CharWidthReader._INSTANCE;
	}
	constructor() {
		this._cache = {};
		this._canvas = document.createElement("canvas");
	}
	getCharWidth(char, font) {
		const cacheKey = char + font;
		if (this._cache[cacheKey]) return this._cache[cacheKey];
		const context = this._canvas.getContext("2d");
		context.font = font;
		const width = context.measureText(char).width;
		this._cache[cacheKey] = width;
		return width;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/decorators.js
function memoize(_target, key, descriptor) {
	let fnKey = null;
	let fn = null;
	if (typeof descriptor.value === "function") {
		fnKey = "value";
		fn = descriptor.value;
		if (fn.length !== 0) console.warn("Memoize should only be used in functions with zero parameters");
	} else if (typeof descriptor.get === "function") {
		fnKey = "get";
		fn = descriptor.get;
	}
	if (!fn) throw new Error("not supported");
	const memoizeKey = `$memoize$${key}`;
	descriptor[fnKey] = function(...args) {
		if (!this.hasOwnProperty(memoizeKey)) Object.defineProperty(this, memoizeKey, {
			configurable: false,
			enumerable: false,
			writable: false,
			value: fn.apply(this, args)
		});
		return this[memoizeKey];
	};
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/touch.js
var __decorate$75 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var EventType;
(function(EventType) {
	EventType.Tap = "-monaco-gesturetap";
	EventType.Change = "-monaco-gesturechange";
	EventType.Start = "-monaco-gesturestart";
	EventType.End = "-monaco-gesturesend";
	EventType.Contextmenu = "-monaco-gesturecontextmenu";
})(EventType || (EventType = {}));
var Gesture = class Gesture extends Disposable {
	static {
		this.SCROLL_FRICTION = -.005;
	}
	static {
		this.HOLD_DELAY = 700;
	}
	static {
		this.CLEAR_TAP_COUNT_TIME = 400;
	}
	constructor() {
		super();
		this.dispatched = false;
		this.targets = new LinkedList();
		this.ignoreTargets = new LinkedList();
		this.activeTouches = {};
		this.handle = null;
		this._lastSetTapCountTime = 0;
		this._register(Event.runAndSubscribe(onDidRegisterWindow, ({ window, disposables }) => {
			disposables.add(addDisposableListener(window.document, "touchstart", (e) => this.onTouchStart(e), { passive: false }));
			disposables.add(addDisposableListener(window.document, "touchend", (e) => this.onTouchEnd(window, e)));
			disposables.add(addDisposableListener(window.document, "touchmove", (e) => this.onTouchMove(e), { passive: false }));
		}, {
			window: mainWindow,
			disposables: this._store
		}));
	}
	static addTarget(element) {
		if (!Gesture.isTouchDevice()) return Disposable.None;
		if (!Gesture.INSTANCE) Gesture.INSTANCE = markAsSingleton(new Gesture());
		const remove = Gesture.INSTANCE.targets.push(element);
		return toDisposable(remove);
	}
	static ignoreTarget(element) {
		if (!Gesture.isTouchDevice()) return Disposable.None;
		if (!Gesture.INSTANCE) Gesture.INSTANCE = markAsSingleton(new Gesture());
		const remove = Gesture.INSTANCE.ignoreTargets.push(element);
		return toDisposable(remove);
	}
	/**
	* Whether the device is able to represent touch events.
	*/
	static isTouchDevice() {
		return "ontouchstart" in mainWindow || navigator.maxTouchPoints > 0;
	}
	dispose() {
		if (this.handle) {
			this.handle.dispose();
			this.handle = null;
		}
		super.dispose();
	}
	onTouchStart(e) {
		const timestamp = Date.now();
		if (this.handle) {
			this.handle.dispose();
			this.handle = null;
		}
		for (let i = 0, len = e.targetTouches.length; i < len; i++) {
			const touch = e.targetTouches.item(i);
			this.activeTouches[touch.identifier] = {
				id: touch.identifier,
				initialTarget: touch.target,
				initialTimeStamp: timestamp,
				initialPageX: touch.pageX,
				initialPageY: touch.pageY,
				rollingTimestamps: [timestamp],
				rollingPageX: [touch.pageX],
				rollingPageY: [touch.pageY]
			};
			const evt = this.newGestureEvent(EventType.Start, touch.target);
			evt.pageX = touch.pageX;
			evt.pageY = touch.pageY;
			this.dispatchEvent(evt);
		}
		if (this.dispatched) {
			e.preventDefault();
			e.stopPropagation();
			this.dispatched = false;
		}
	}
	onTouchEnd(targetWindow, e) {
		const timestamp = Date.now();
		const activeTouchCount = Object.keys(this.activeTouches).length;
		for (let i = 0, len = e.changedTouches.length; i < len; i++) {
			const touch = e.changedTouches.item(i);
			if (!this.activeTouches.hasOwnProperty(String(touch.identifier))) {
				console.warn("move of an UNKNOWN touch", touch);
				continue;
			}
			const data = this.activeTouches[touch.identifier], holdTime = Date.now() - data.initialTimeStamp;
			if (holdTime < Gesture.HOLD_DELAY && Math.abs(data.initialPageX - data.rollingPageX.at(-1)) < 30 && Math.abs(data.initialPageY - data.rollingPageY.at(-1)) < 30) {
				const evt = this.newGestureEvent(EventType.Tap, data.initialTarget);
				evt.pageX = data.rollingPageX.at(-1);
				evt.pageY = data.rollingPageY.at(-1);
				this.dispatchEvent(evt);
			} else if (holdTime >= Gesture.HOLD_DELAY && Math.abs(data.initialPageX - data.rollingPageX.at(-1)) < 30 && Math.abs(data.initialPageY - data.rollingPageY.at(-1)) < 30) {
				const evt = this.newGestureEvent(EventType.Contextmenu, data.initialTarget);
				evt.pageX = data.rollingPageX.at(-1);
				evt.pageY = data.rollingPageY.at(-1);
				this.dispatchEvent(evt);
			} else if (activeTouchCount === 1) {
				const finalX = data.rollingPageX.at(-1);
				const finalY = data.rollingPageY.at(-1);
				const deltaT = data.rollingTimestamps.at(-1) - data.rollingTimestamps[0];
				const deltaX = finalX - data.rollingPageX[0];
				const deltaY = finalY - data.rollingPageY[0];
				const dispatchTo = [...this.targets].filter((t) => data.initialTarget instanceof Node && t.contains(data.initialTarget));
				this.inertia(targetWindow, dispatchTo, timestamp, Math.abs(deltaX) / deltaT, deltaX > 0 ? 1 : -1, finalX, Math.abs(deltaY) / deltaT, deltaY > 0 ? 1 : -1, finalY);
			}
			this.dispatchEvent(this.newGestureEvent(EventType.End, data.initialTarget));
			delete this.activeTouches[touch.identifier];
		}
		if (this.dispatched) {
			e.preventDefault();
			e.stopPropagation();
			this.dispatched = false;
		}
	}
	newGestureEvent(type, initialTarget) {
		const event = document.createEvent("CustomEvent");
		event.initEvent(type, false, true);
		event.initialTarget = initialTarget;
		event.tapCount = 0;
		return event;
	}
	dispatchEvent(event) {
		if (event.type === EventType.Tap) {
			const currentTime = (/* @__PURE__ */ new Date()).getTime();
			let setTapCount = 0;
			if (currentTime - this._lastSetTapCountTime > Gesture.CLEAR_TAP_COUNT_TIME) setTapCount = 1;
			else setTapCount = 2;
			this._lastSetTapCountTime = currentTime;
			event.tapCount = setTapCount;
		} else if (event.type === EventType.Change || event.type === EventType.Contextmenu) this._lastSetTapCountTime = 0;
		if (event.initialTarget instanceof Node) {
			for (const ignoreTarget of this.ignoreTargets) if (ignoreTarget.contains(event.initialTarget)) return;
			const targets = [];
			for (const target of this.targets) if (target.contains(event.initialTarget)) {
				let depth = 0;
				let now = event.initialTarget;
				while (now && now !== target) {
					depth++;
					now = now.parentElement;
				}
				targets.push([depth, target]);
			}
			targets.sort((a, b) => a[0] - b[0]);
			for (const [_, target] of targets) {
				target.dispatchEvent(event);
				this.dispatched = true;
			}
		}
	}
	inertia(targetWindow, dispatchTo, t1, vX, dirX, x, vY, dirY, y) {
		this.handle = scheduleAtNextAnimationFrame(targetWindow, () => {
			const now = Date.now();
			const deltaT = now - t1;
			let delta_pos_x = 0, delta_pos_y = 0;
			let stopped = true;
			vX += Gesture.SCROLL_FRICTION * deltaT;
			vY += Gesture.SCROLL_FRICTION * deltaT;
			if (vX > 0) {
				stopped = false;
				delta_pos_x = dirX * vX * deltaT;
			}
			if (vY > 0) {
				stopped = false;
				delta_pos_y = dirY * vY * deltaT;
			}
			const evt = this.newGestureEvent(EventType.Change);
			evt.translationX = delta_pos_x;
			evt.translationY = delta_pos_y;
			dispatchTo.forEach((d) => d.dispatchEvent(evt));
			if (!stopped) this.inertia(targetWindow, dispatchTo, now, vX, dirX, x + delta_pos_x, vY, dirY, y + delta_pos_y);
		});
	}
	onTouchMove(e) {
		const timestamp = Date.now();
		for (let i = 0, len = e.changedTouches.length; i < len; i++) {
			const touch = e.changedTouches.item(i);
			if (!this.activeTouches.hasOwnProperty(String(touch.identifier))) {
				console.warn("end of an UNKNOWN touch", touch);
				continue;
			}
			const data = this.activeTouches[touch.identifier];
			const evt = this.newGestureEvent(EventType.Change, data.initialTarget);
			evt.translationX = touch.pageX - data.rollingPageX.at(-1);
			evt.translationY = touch.pageY - data.rollingPageY.at(-1);
			evt.pageX = touch.pageX;
			evt.pageY = touch.pageY;
			this.dispatchEvent(evt);
			if (data.rollingPageX.length > 3) {
				data.rollingPageX.shift();
				data.rollingPageY.shift();
				data.rollingTimestamps.shift();
			}
			data.rollingPageX.push(touch.pageX);
			data.rollingPageY.push(touch.pageY);
			data.rollingTimestamps.push(timestamp);
		}
		if (this.dispatched) {
			e.preventDefault();
			e.stopPropagation();
			this.dispatched = false;
		}
	}
};
__decorate$75([memoize], Gesture, "isTouchDevice", null);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/widget.js
var Widget$1 = class extends Disposable {
	onclick(domNode, listener) {
		this._register(addDisposableListener(domNode, EventType$1.CLICK, (e) => listener(new StandardMouseEvent(getWindow(domNode), e))));
	}
	onmousedown(domNode, listener) {
		this._register(addDisposableListener(domNode, EventType$1.MOUSE_DOWN, (e) => listener(new StandardMouseEvent(getWindow(domNode), e))));
	}
	onmouseover(domNode, listener) {
		this._register(addDisposableListener(domNode, EventType$1.MOUSE_OVER, (e) => listener(new StandardMouseEvent(getWindow(domNode), e))));
	}
	onmouseleave(domNode, listener) {
		this._register(addDisposableListener(domNode, EventType$1.MOUSE_LEAVE, (e) => listener(new StandardMouseEvent(getWindow(domNode), e))));
	}
	onkeydown(domNode, listener) {
		this._register(addDisposableListener(domNode, EventType$1.KEY_DOWN, (e) => listener(new StandardKeyboardEvent(e))));
	}
	onkeyup(domNode, listener) {
		this._register(addDisposableListener(domNode, EventType$1.KEY_UP, (e) => listener(new StandardKeyboardEvent(e))));
	}
	oninput(domNode, listener) {
		this._register(addDisposableListener(domNode, EventType$1.INPUT, listener));
	}
	onblur(domNode, listener) {
		this._register(addDisposableListener(domNode, EventType$1.BLUR, listener));
	}
	onfocus(domNode, listener) {
		this._register(addDisposableListener(domNode, EventType$1.FOCUS, listener));
	}
	ignoreGesture(domNode) {
		return Gesture.ignoreTarget(domNode);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/scrollbar/scrollbarArrow.js
var ScrollbarArrow = class extends Widget$1 {
	constructor(opts) {
		super();
		this._onActivate = opts.onActivate;
		this.bgDomNode = document.createElement("div");
		this.bgDomNode.className = "arrow-background";
		this.bgDomNode.style.position = "absolute";
		this.bgDomNode.style.width = opts.bgWidth + "px";
		this.bgDomNode.style.height = opts.bgHeight + "px";
		if (typeof opts.top !== "undefined") this.bgDomNode.style.top = "0px";
		if (typeof opts.left !== "undefined") this.bgDomNode.style.left = "0px";
		if (typeof opts.bottom !== "undefined") this.bgDomNode.style.bottom = "0px";
		if (typeof opts.right !== "undefined") this.bgDomNode.style.right = "0px";
		this.domNode = document.createElement("div");
		this.domNode.className = opts.className;
		this.domNode.classList.add(...ThemeIcon.asClassNameArray(opts.icon));
		this.domNode.style.position = "absolute";
		this.domNode.style.width = "11px";
		this.domNode.style.height = "11px";
		if (typeof opts.top !== "undefined") this.domNode.style.top = opts.top + "px";
		if (typeof opts.left !== "undefined") this.domNode.style.left = opts.left + "px";
		if (typeof opts.bottom !== "undefined") this.domNode.style.bottom = opts.bottom + "px";
		if (typeof opts.right !== "undefined") this.domNode.style.right = opts.right + "px";
		this._pointerMoveMonitor = this._register(new GlobalPointerMoveMonitor());
		this._register(addStandardDisposableListener(this.bgDomNode, EventType$1.POINTER_DOWN, (e) => this._arrowPointerDown(e)));
		this._register(addStandardDisposableListener(this.domNode, EventType$1.POINTER_DOWN, (e) => this._arrowPointerDown(e)));
		this._pointerdownRepeatTimer = this._register(new WindowIntervalTimer());
		this._pointerdownScheduleRepeatTimer = this._register(new TimeoutTimer());
	}
	_arrowPointerDown(e) {
		if (!e.target || !(e.target instanceof Element)) return;
		const scheduleRepeater = () => {
			this._pointerdownRepeatTimer.cancelAndSet(() => this._onActivate(), 1e3 / 24, getWindow(e));
		};
		this._onActivate();
		this._pointerdownRepeatTimer.cancel();
		this._pointerdownScheduleRepeatTimer.cancelAndSet(scheduleRepeater, 200);
		this._pointerMoveMonitor.startMonitoring(e.target, e.pointerId, e.buttons, (pointerMoveData) => {}, () => {
			this._pointerdownRepeatTimer.cancel();
			this._pointerdownScheduleRepeatTimer.cancel();
		});
		e.preventDefault();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/scrollbar/scrollbarVisibilityController.js
var ScrollbarVisibilityController = class extends Disposable {
	constructor(visibility, visibleClassName, invisibleClassName) {
		super();
		this._visibility = visibility;
		this._visibleClassName = visibleClassName;
		this._invisibleClassName = invisibleClassName;
		this._domNode = null;
		this._isVisible = false;
		this._isNeeded = false;
		this._rawShouldBeVisible = false;
		this._shouldBeVisible = false;
		this._revealTimer = this._register(new TimeoutTimer());
	}
	setVisibility(visibility) {
		if (this._visibility !== visibility) {
			this._visibility = visibility;
			this._updateShouldBeVisible();
		}
	}
	setShouldBeVisible(rawShouldBeVisible) {
		this._rawShouldBeVisible = rawShouldBeVisible;
		this._updateShouldBeVisible();
	}
	_applyVisibilitySetting() {
		if (this._visibility === 2) return false;
		if (this._visibility === 3) return true;
		return this._rawShouldBeVisible;
	}
	_updateShouldBeVisible() {
		const shouldBeVisible = this._applyVisibilitySetting();
		if (this._shouldBeVisible !== shouldBeVisible) {
			this._shouldBeVisible = shouldBeVisible;
			this.ensureVisibility();
		}
	}
	setIsNeeded(isNeeded) {
		if (this._isNeeded !== isNeeded) {
			this._isNeeded = isNeeded;
			this.ensureVisibility();
		}
	}
	setDomNode(domNode) {
		this._domNode = domNode;
		this._domNode.setClassName(this._invisibleClassName);
		this.setShouldBeVisible(false);
	}
	ensureVisibility() {
		if (!this._isNeeded) {
			this._hide(false);
			return;
		}
		if (this._shouldBeVisible) this._reveal();
		else this._hide(true);
	}
	_reveal() {
		if (this._isVisible) return;
		this._isVisible = true;
		this._revealTimer.setIfNotSet(() => {
			this._domNode?.setClassName(this._visibleClassName);
		}, 0);
	}
	_hide(withFadeAway) {
		this._revealTimer.cancel();
		if (!this._isVisible) return;
		this._isVisible = false;
		this._domNode?.setClassName(this._invisibleClassName + (withFadeAway ? " fade" : ""));
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/scrollbar/abstractScrollbar.js
/**
* The orthogonal distance to the slider at which dragging "resets". This implements "snapping"
*/
var POINTER_DRAG_RESET_DISTANCE$1 = 140;
var AbstractScrollbar = class extends Widget$1 {
	constructor(opts) {
		super();
		this._lazyRender = opts.lazyRender;
		this._host = opts.host;
		this._scrollable = opts.scrollable;
		this._scrollByPage = opts.scrollByPage;
		this._scrollbarState = opts.scrollbarState;
		this._visibilityController = this._register(new ScrollbarVisibilityController(opts.visibility, "visible scrollbar " + opts.extraScrollbarClassName, "invisible scrollbar " + opts.extraScrollbarClassName));
		this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded());
		this._pointerMoveMonitor = this._register(new GlobalPointerMoveMonitor());
		this._shouldRender = true;
		this.domNode = createFastDomNode(document.createElement("div"));
		this.domNode.setAttribute("role", "presentation");
		this.domNode.setAttribute("aria-hidden", "true");
		this._visibilityController.setDomNode(this.domNode);
		this.domNode.setPosition("absolute");
		this._register(addDisposableListener(this.domNode.domNode, EventType$1.POINTER_DOWN, (e) => this._domNodePointerDown(e)));
	}
	/**
	* Creates the dom node for an arrow & adds it to the container
	*/
	_createArrow(opts) {
		const arrow = this._register(new ScrollbarArrow(opts));
		this.domNode.domNode.appendChild(arrow.bgDomNode);
		this.domNode.domNode.appendChild(arrow.domNode);
	}
	/**
	* Creates the slider dom node, adds it to the container & hooks up the events
	*/
	_createSlider(top, left, width, height) {
		this.slider = createFastDomNode(document.createElement("div"));
		this.slider.setClassName("slider");
		this.slider.setPosition("absolute");
		this.slider.setTop(top);
		this.slider.setLeft(left);
		if (typeof width === "number") this.slider.setWidth(width);
		if (typeof height === "number") this.slider.setHeight(height);
		this.slider.setLayerHinting(true);
		this.slider.setContain("strict");
		this.domNode.domNode.appendChild(this.slider.domNode);
		this._register(addDisposableListener(this.slider.domNode, EventType$1.POINTER_DOWN, (e) => {
			if (e.button === 0) {
				e.preventDefault();
				this._sliderPointerDown(e);
			}
		}));
		this.onclick(this.slider.domNode, (e) => {
			if (e.leftButton) e.stopPropagation();
		});
	}
	_onElementSize(visibleSize) {
		if (this._scrollbarState.setVisibleSize(visibleSize)) {
			this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded());
			this._shouldRender = true;
			if (!this._lazyRender) this.render();
		}
		return this._shouldRender;
	}
	_onElementScrollSize(elementScrollSize) {
		if (this._scrollbarState.setScrollSize(elementScrollSize)) {
			this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded());
			this._shouldRender = true;
			if (!this._lazyRender) this.render();
		}
		return this._shouldRender;
	}
	_onElementScrollPosition(elementScrollPosition) {
		if (this._scrollbarState.setScrollPosition(elementScrollPosition)) {
			this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded());
			this._shouldRender = true;
			if (!this._lazyRender) this.render();
		}
		return this._shouldRender;
	}
	beginReveal() {
		this._visibilityController.setShouldBeVisible(true);
	}
	beginHide() {
		this._visibilityController.setShouldBeVisible(false);
	}
	render() {
		if (!this._shouldRender) return;
		this._shouldRender = false;
		this._renderDomNode(this._scrollbarState.getRectangleLargeSize(), this._scrollbarState.getRectangleSmallSize());
		this._updateSlider(this._scrollbarState.getSliderSize(), this._scrollbarState.getArrowSize() + this._scrollbarState.getSliderPosition());
	}
	_domNodePointerDown(e) {
		if (e.target !== this.domNode.domNode) return;
		this._onPointerDown(e);
	}
	delegatePointerDown(e) {
		const domTop = this.domNode.domNode.getClientRects()[0].top;
		const sliderStart = domTop + this._scrollbarState.getSliderPosition();
		const sliderStop = domTop + this._scrollbarState.getSliderPosition() + this._scrollbarState.getSliderSize();
		const pointerPos = this._sliderPointerPosition(e);
		if (sliderStart <= pointerPos && pointerPos <= sliderStop) {
			if (e.button === 0) {
				e.preventDefault();
				this._sliderPointerDown(e);
			}
		} else this._onPointerDown(e);
	}
	_onPointerDown(e) {
		let offsetX;
		let offsetY;
		if (e.target === this.domNode.domNode && typeof e.offsetX === "number" && typeof e.offsetY === "number") {
			offsetX = e.offsetX;
			offsetY = e.offsetY;
		} else {
			const domNodePosition = getDomNodePagePosition(this.domNode.domNode);
			offsetX = e.pageX - domNodePosition.left;
			offsetY = e.pageY - domNodePosition.top;
		}
		const isMouse = e.pointerType === "mouse";
		const isLeftClick = e.button === 0;
		if (isLeftClick || !isMouse) {
			const offset = this._pointerDownRelativePosition(offsetX, offsetY);
			this._setDesiredScrollPositionNow(this._scrollByPage ? this._scrollbarState.getDesiredScrollPositionFromOffsetPaged(offset) : this._scrollbarState.getDesiredScrollPositionFromOffset(offset));
		}
		if (isLeftClick) {
			e.preventDefault();
			this._sliderPointerDown(e);
		}
	}
	_sliderPointerDown(e) {
		if (!e.target || !(e.target instanceof Element)) return;
		const initialPointerPosition = this._sliderPointerPosition(e);
		const initialPointerOrthogonalPosition = this._sliderOrthogonalPointerPosition(e);
		const initialScrollbarState = this._scrollbarState.clone();
		this.slider.toggleClassName("active", true);
		this._pointerMoveMonitor.startMonitoring(e.target, e.pointerId, e.buttons, (pointerMoveData) => {
			const pointerOrthogonalPosition = this._sliderOrthogonalPointerPosition(pointerMoveData);
			const pointerOrthogonalDelta = Math.abs(pointerOrthogonalPosition - initialPointerOrthogonalPosition);
			if (isWindows && pointerOrthogonalDelta > POINTER_DRAG_RESET_DISTANCE$1) {
				this._setDesiredScrollPositionNow(initialScrollbarState.getScrollPosition());
				return;
			}
			const pointerDelta = this._sliderPointerPosition(pointerMoveData) - initialPointerPosition;
			this._setDesiredScrollPositionNow(initialScrollbarState.getDesiredScrollPositionFromDelta(pointerDelta));
		}, () => {
			this.slider.toggleClassName("active", false);
			this._host.onDragEnd();
		});
		this._host.onDragStart();
	}
	_setDesiredScrollPositionNow(_desiredScrollPosition) {
		const desiredScrollPosition = {};
		this.writeScrollPosition(desiredScrollPosition, _desiredScrollPosition);
		this._scrollable.setScrollPositionNow(desiredScrollPosition);
	}
	updateScrollbarSize(scrollbarSize) {
		this._updateScrollbarSize(scrollbarSize);
		this._scrollbarState.setScrollbarSize(scrollbarSize);
		this._shouldRender = true;
		if (!this._lazyRender) this.render();
	}
	isNeeded() {
		return this._scrollbarState.isNeeded();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/scrollbar/scrollbarState.js
/**
* The minimal size of the slider (such that it can still be clickable) -- it is artificially enlarged.
*/
var MINIMUM_SLIDER_SIZE = 20;
var ScrollbarState = class ScrollbarState {
	constructor(arrowSize, scrollbarSize, oppositeScrollbarSize, visibleSize, scrollSize, scrollPosition) {
		this._scrollbarSize = Math.round(scrollbarSize);
		this._oppositeScrollbarSize = Math.round(oppositeScrollbarSize);
		this._arrowSize = Math.round(arrowSize);
		this._visibleSize = visibleSize;
		this._scrollSize = scrollSize;
		this._scrollPosition = scrollPosition;
		this._computedAvailableSize = 0;
		this._computedIsNeeded = false;
		this._computedSliderSize = 0;
		this._computedSliderRatio = 0;
		this._computedSliderPosition = 0;
		this._refreshComputedValues();
	}
	clone() {
		return new ScrollbarState(this._arrowSize, this._scrollbarSize, this._oppositeScrollbarSize, this._visibleSize, this._scrollSize, this._scrollPosition);
	}
	setVisibleSize(visibleSize) {
		const iVisibleSize = Math.round(visibleSize);
		if (this._visibleSize !== iVisibleSize) {
			this._visibleSize = iVisibleSize;
			this._refreshComputedValues();
			return true;
		}
		return false;
	}
	setScrollSize(scrollSize) {
		const iScrollSize = Math.round(scrollSize);
		if (this._scrollSize !== iScrollSize) {
			this._scrollSize = iScrollSize;
			this._refreshComputedValues();
			return true;
		}
		return false;
	}
	setScrollPosition(scrollPosition) {
		const iScrollPosition = Math.round(scrollPosition);
		if (this._scrollPosition !== iScrollPosition) {
			this._scrollPosition = iScrollPosition;
			this._refreshComputedValues();
			return true;
		}
		return false;
	}
	setScrollbarSize(scrollbarSize) {
		this._scrollbarSize = Math.round(scrollbarSize);
	}
	setOppositeScrollbarSize(oppositeScrollbarSize) {
		this._oppositeScrollbarSize = Math.round(oppositeScrollbarSize);
	}
	static _computeValues(oppositeScrollbarSize, arrowSize, visibleSize, scrollSize, scrollPosition) {
		const computedAvailableSize = Math.max(0, visibleSize - oppositeScrollbarSize);
		const computedRepresentableSize = Math.max(0, computedAvailableSize - 2 * arrowSize);
		const computedIsNeeded = scrollSize > 0 && scrollSize > visibleSize;
		if (!computedIsNeeded) return {
			computedAvailableSize: Math.round(computedAvailableSize),
			computedIsNeeded,
			computedSliderSize: Math.round(computedRepresentableSize),
			computedSliderRatio: 0,
			computedSliderPosition: 0
		};
		const computedSliderSize = Math.round(Math.max(MINIMUM_SLIDER_SIZE, Math.floor(visibleSize * computedRepresentableSize / scrollSize)));
		const computedSliderRatio = (computedRepresentableSize - computedSliderSize) / (scrollSize - visibleSize);
		const computedSliderPosition = scrollPosition * computedSliderRatio;
		return {
			computedAvailableSize: Math.round(computedAvailableSize),
			computedIsNeeded,
			computedSliderSize: Math.round(computedSliderSize),
			computedSliderRatio,
			computedSliderPosition: Math.round(computedSliderPosition)
		};
	}
	_refreshComputedValues() {
		const r = ScrollbarState._computeValues(this._oppositeScrollbarSize, this._arrowSize, this._visibleSize, this._scrollSize, this._scrollPosition);
		this._computedAvailableSize = r.computedAvailableSize;
		this._computedIsNeeded = r.computedIsNeeded;
		this._computedSliderSize = r.computedSliderSize;
		this._computedSliderRatio = r.computedSliderRatio;
		this._computedSliderPosition = r.computedSliderPosition;
	}
	getArrowSize() {
		return this._arrowSize;
	}
	getScrollPosition() {
		return this._scrollPosition;
	}
	getRectangleLargeSize() {
		return this._computedAvailableSize;
	}
	getRectangleSmallSize() {
		return this._scrollbarSize;
	}
	isNeeded() {
		return this._computedIsNeeded;
	}
	getSliderSize() {
		return this._computedSliderSize;
	}
	getSliderPosition() {
		return this._computedSliderPosition;
	}
	/**
	* Compute a desired `scrollPosition` such that `offset` ends up in the center of the slider.
	* `offset` is based on the same coordinate system as the `sliderPosition`.
	*/
	getDesiredScrollPositionFromOffset(offset) {
		if (!this._computedIsNeeded) return 0;
		const desiredSliderPosition = offset - this._arrowSize - this._computedSliderSize / 2;
		return Math.round(desiredSliderPosition / this._computedSliderRatio);
	}
	/**
	* Compute a desired `scrollPosition` from if offset is before or after the slider position.
	* If offset is before slider, treat as a page up (or left).  If after, page down (or right).
	* `offset` and `_computedSliderPosition` are based on the same coordinate system.
	* `_visibleSize` corresponds to a "page" of lines in the returned coordinate system.
	*/
	getDesiredScrollPositionFromOffsetPaged(offset) {
		if (!this._computedIsNeeded) return 0;
		const correctedOffset = offset - this._arrowSize;
		let desiredScrollPosition = this._scrollPosition;
		if (correctedOffset < this._computedSliderPosition) desiredScrollPosition -= this._visibleSize;
		else desiredScrollPosition += this._visibleSize;
		return desiredScrollPosition;
	}
	/**
	* Compute a desired `scrollPosition` such that the slider moves by `delta`.
	*/
	getDesiredScrollPositionFromDelta(delta) {
		if (!this._computedIsNeeded) return 0;
		const desiredSliderPosition = this._computedSliderPosition + delta;
		return Math.round(desiredSliderPosition / this._computedSliderRatio);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/scrollbar/horizontalScrollbar.js
var HorizontalScrollbar = class extends AbstractScrollbar {
	constructor(scrollable, options, host) {
		const scrollDimensions = scrollable.getScrollDimensions();
		const scrollPosition = scrollable.getCurrentScrollPosition();
		super({
			lazyRender: options.lazyRender,
			host,
			scrollbarState: new ScrollbarState(options.horizontalHasArrows ? options.arrowSize : 0, options.horizontal === 2 ? 0 : options.horizontalScrollbarSize, options.vertical === 2 ? 0 : options.verticalScrollbarSize, scrollDimensions.width, scrollDimensions.scrollWidth, scrollPosition.scrollLeft),
			visibility: options.horizontal,
			extraScrollbarClassName: "horizontal",
			scrollable,
			scrollByPage: options.scrollByPage
		});
		if (options.horizontalHasArrows) {
			const arrowDelta = (options.arrowSize - 11) / 2;
			const scrollbarDelta = (options.horizontalScrollbarSize - 11) / 2;
			this._createArrow({
				className: "scra",
				icon: Codicon.scrollbarButtonLeft,
				top: scrollbarDelta,
				left: arrowDelta,
				bottom: void 0,
				right: void 0,
				bgWidth: options.arrowSize,
				bgHeight: options.horizontalScrollbarSize,
				onActivate: () => this._host.onMouseWheel(new StandardWheelEvent(null, 1, 0))
			});
			this._createArrow({
				className: "scra",
				icon: Codicon.scrollbarButtonRight,
				top: scrollbarDelta,
				left: void 0,
				bottom: void 0,
				right: arrowDelta,
				bgWidth: options.arrowSize,
				bgHeight: options.horizontalScrollbarSize,
				onActivate: () => this._host.onMouseWheel(new StandardWheelEvent(null, -1, 0))
			});
		}
		this._createSlider(Math.floor((options.horizontalScrollbarSize - options.horizontalSliderSize) / 2), 0, void 0, options.horizontalSliderSize);
	}
	_updateSlider(sliderSize, sliderPosition) {
		this.slider.setWidth(sliderSize);
		this.slider.setLeft(sliderPosition);
	}
	_renderDomNode(largeSize, smallSize) {
		this.domNode.setWidth(largeSize);
		this.domNode.setHeight(smallSize);
		this.domNode.setLeft(0);
		this.domNode.setBottom(0);
	}
	onDidScroll(e) {
		this._shouldRender = this._onElementScrollSize(e.scrollWidth) || this._shouldRender;
		this._shouldRender = this._onElementScrollPosition(e.scrollLeft) || this._shouldRender;
		this._shouldRender = this._onElementSize(e.width) || this._shouldRender;
		return this._shouldRender;
	}
	_pointerDownRelativePosition(offsetX, offsetY) {
		return offsetX;
	}
	_sliderPointerPosition(e) {
		return e.pageX;
	}
	_sliderOrthogonalPointerPosition(e) {
		return e.pageY;
	}
	_updateScrollbarSize(size) {
		this.slider.setHeight(size);
	}
	writeScrollPosition(target, scrollPosition) {
		target.scrollLeft = scrollPosition;
	}
	updateOptions(options) {
		this.updateScrollbarSize(options.horizontal === 2 ? 0 : options.horizontalScrollbarSize);
		this._scrollbarState.setOppositeScrollbarSize(options.vertical === 2 ? 0 : options.verticalScrollbarSize);
		this._visibilityController.setVisibility(options.horizontal);
		this._scrollByPage = options.scrollByPage;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/scrollbar/verticalScrollbar.js
var VerticalScrollbar = class extends AbstractScrollbar {
	constructor(scrollable, options, host) {
		const scrollDimensions = scrollable.getScrollDimensions();
		const scrollPosition = scrollable.getCurrentScrollPosition();
		super({
			lazyRender: options.lazyRender,
			host,
			scrollbarState: new ScrollbarState(options.verticalHasArrows ? options.arrowSize : 0, options.vertical === 2 ? 0 : options.verticalScrollbarSize, 0, scrollDimensions.height, scrollDimensions.scrollHeight, scrollPosition.scrollTop),
			visibility: options.vertical,
			extraScrollbarClassName: "vertical",
			scrollable,
			scrollByPage: options.scrollByPage
		});
		if (options.verticalHasArrows) {
			const arrowDelta = (options.arrowSize - 11) / 2;
			const scrollbarDelta = (options.verticalScrollbarSize - 11) / 2;
			this._createArrow({
				className: "scra",
				icon: Codicon.scrollbarButtonUp,
				top: arrowDelta,
				left: scrollbarDelta,
				bottom: void 0,
				right: void 0,
				bgWidth: options.verticalScrollbarSize,
				bgHeight: options.arrowSize,
				onActivate: () => this._host.onMouseWheel(new StandardWheelEvent(null, 0, 1))
			});
			this._createArrow({
				className: "scra",
				icon: Codicon.scrollbarButtonDown,
				top: void 0,
				left: scrollbarDelta,
				bottom: arrowDelta,
				right: void 0,
				bgWidth: options.verticalScrollbarSize,
				bgHeight: options.arrowSize,
				onActivate: () => this._host.onMouseWheel(new StandardWheelEvent(null, 0, -1))
			});
		}
		this._createSlider(0, Math.floor((options.verticalScrollbarSize - options.verticalSliderSize) / 2), options.verticalSliderSize, void 0);
	}
	_updateSlider(sliderSize, sliderPosition) {
		this.slider.setHeight(sliderSize);
		this.slider.setTop(sliderPosition);
	}
	_renderDomNode(largeSize, smallSize) {
		this.domNode.setWidth(smallSize);
		this.domNode.setHeight(largeSize);
		this.domNode.setRight(0);
		this.domNode.setTop(0);
	}
	onDidScroll(e) {
		this._shouldRender = this._onElementScrollSize(e.scrollHeight) || this._shouldRender;
		this._shouldRender = this._onElementScrollPosition(e.scrollTop) || this._shouldRender;
		this._shouldRender = this._onElementSize(e.height) || this._shouldRender;
		return this._shouldRender;
	}
	_pointerDownRelativePosition(offsetX, offsetY) {
		return offsetY;
	}
	_sliderPointerPosition(e) {
		return e.pageY;
	}
	_sliderOrthogonalPointerPosition(e) {
		return e.pageX;
	}
	_updateScrollbarSize(size) {
		this.slider.setWidth(size);
	}
	writeScrollPosition(target, scrollPosition) {
		target.scrollTop = scrollPosition;
	}
	updateOptions(options) {
		this.updateScrollbarSize(options.vertical === 2 ? 0 : options.verticalScrollbarSize);
		this._scrollbarState.setOppositeScrollbarSize(0);
		this._visibilityController.setVisibility(options.vertical);
		this._scrollByPage = options.scrollByPage;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/scrollable.js
var ScrollState = class ScrollState {
	constructor(_forceIntegerValues, width, scrollWidth, scrollLeft, height, scrollHeight, scrollTop) {
		this._forceIntegerValues = _forceIntegerValues;
		this._scrollStateBrand = void 0;
		if (this._forceIntegerValues) {
			width = width | 0;
			scrollWidth = scrollWidth | 0;
			scrollLeft = scrollLeft | 0;
			height = height | 0;
			scrollHeight = scrollHeight | 0;
			scrollTop = scrollTop | 0;
		}
		this.rawScrollLeft = scrollLeft;
		this.rawScrollTop = scrollTop;
		if (width < 0) width = 0;
		if (scrollLeft + width > scrollWidth) scrollLeft = scrollWidth - width;
		if (scrollLeft < 0) scrollLeft = 0;
		if (height < 0) height = 0;
		if (scrollTop + height > scrollHeight) scrollTop = scrollHeight - height;
		if (scrollTop < 0) scrollTop = 0;
		this.width = width;
		this.scrollWidth = scrollWidth;
		this.scrollLeft = scrollLeft;
		this.height = height;
		this.scrollHeight = scrollHeight;
		this.scrollTop = scrollTop;
	}
	equals(other) {
		return this.rawScrollLeft === other.rawScrollLeft && this.rawScrollTop === other.rawScrollTop && this.width === other.width && this.scrollWidth === other.scrollWidth && this.scrollLeft === other.scrollLeft && this.height === other.height && this.scrollHeight === other.scrollHeight && this.scrollTop === other.scrollTop;
	}
	withScrollDimensions(update, useRawScrollPositions) {
		return new ScrollState(this._forceIntegerValues, typeof update.width !== "undefined" ? update.width : this.width, typeof update.scrollWidth !== "undefined" ? update.scrollWidth : this.scrollWidth, useRawScrollPositions ? this.rawScrollLeft : this.scrollLeft, typeof update.height !== "undefined" ? update.height : this.height, typeof update.scrollHeight !== "undefined" ? update.scrollHeight : this.scrollHeight, useRawScrollPositions ? this.rawScrollTop : this.scrollTop);
	}
	withScrollPosition(update) {
		return new ScrollState(this._forceIntegerValues, this.width, this.scrollWidth, typeof update.scrollLeft !== "undefined" ? update.scrollLeft : this.rawScrollLeft, this.height, this.scrollHeight, typeof update.scrollTop !== "undefined" ? update.scrollTop : this.rawScrollTop);
	}
	createScrollEvent(previous, inSmoothScrolling) {
		const widthChanged = this.width !== previous.width;
		const scrollWidthChanged = this.scrollWidth !== previous.scrollWidth;
		const scrollLeftChanged = this.scrollLeft !== previous.scrollLeft;
		const heightChanged = this.height !== previous.height;
		const scrollHeightChanged = this.scrollHeight !== previous.scrollHeight;
		const scrollTopChanged = this.scrollTop !== previous.scrollTop;
		return {
			inSmoothScrolling,
			oldWidth: previous.width,
			oldScrollWidth: previous.scrollWidth,
			oldScrollLeft: previous.scrollLeft,
			width: this.width,
			scrollWidth: this.scrollWidth,
			scrollLeft: this.scrollLeft,
			oldHeight: previous.height,
			oldScrollHeight: previous.scrollHeight,
			oldScrollTop: previous.scrollTop,
			height: this.height,
			scrollHeight: this.scrollHeight,
			scrollTop: this.scrollTop,
			widthChanged,
			scrollWidthChanged,
			scrollLeftChanged,
			heightChanged,
			scrollHeightChanged,
			scrollTopChanged
		};
	}
};
var Scrollable = class extends Disposable {
	constructor(options) {
		super();
		this._scrollableBrand = void 0;
		this._onScroll = this._register(new Emitter$1());
		this.onScroll = this._onScroll.event;
		this._smoothScrollDuration = options.smoothScrollDuration;
		this._scheduleAtNextAnimationFrame = options.scheduleAtNextAnimationFrame;
		this._state = new ScrollState(options.forceIntegerValues, 0, 0, 0, 0, 0, 0);
		this._smoothScrolling = null;
	}
	dispose() {
		if (this._smoothScrolling) {
			this._smoothScrolling.dispose();
			this._smoothScrolling = null;
		}
		super.dispose();
	}
	setSmoothScrollDuration(smoothScrollDuration) {
		this._smoothScrollDuration = smoothScrollDuration;
	}
	validateScrollPosition(scrollPosition) {
		return this._state.withScrollPosition(scrollPosition);
	}
	getScrollDimensions() {
		return this._state;
	}
	setScrollDimensions(dimensions, useRawScrollPositions) {
		const newState = this._state.withScrollDimensions(dimensions, useRawScrollPositions);
		this._setState(newState, Boolean(this._smoothScrolling));
		this._smoothScrolling?.acceptScrollDimensions(this._state);
	}
	/**
	* Returns the final scroll position that the instance will have once the smooth scroll animation concludes.
	* If no scroll animation is occurring, it will return the current scroll position instead.
	*/
	getFutureScrollPosition() {
		if (this._smoothScrolling) return this._smoothScrolling.to;
		return this._state;
	}
	/**
	* Returns the current scroll position.
	* Note: This result might be an intermediate scroll position, as there might be an ongoing smooth scroll animation.
	*/
	getCurrentScrollPosition() {
		return this._state;
	}
	setScrollPositionNow(update) {
		const newState = this._state.withScrollPosition(update);
		if (this._smoothScrolling) {
			this._smoothScrolling.dispose();
			this._smoothScrolling = null;
		}
		this._setState(newState, false);
	}
	setScrollPositionSmooth(update, reuseAnimation) {
		if (this._smoothScrollDuration === 0) return this.setScrollPositionNow(update);
		if (this._smoothScrolling) {
			update = {
				scrollLeft: typeof update.scrollLeft === "undefined" ? this._smoothScrolling.to.scrollLeft : update.scrollLeft,
				scrollTop: typeof update.scrollTop === "undefined" ? this._smoothScrolling.to.scrollTop : update.scrollTop
			};
			const validTarget = this._state.withScrollPosition(update);
			if (this._smoothScrolling.to.scrollLeft === validTarget.scrollLeft && this._smoothScrolling.to.scrollTop === validTarget.scrollTop) return;
			let newSmoothScrolling;
			if (reuseAnimation) newSmoothScrolling = new SmoothScrollingOperation(this._smoothScrolling.from, validTarget, this._smoothScrolling.startTime, this._smoothScrolling.duration);
			else newSmoothScrolling = this._smoothScrolling.combine(this._state, validTarget, this._smoothScrollDuration);
			this._smoothScrolling.dispose();
			this._smoothScrolling = newSmoothScrolling;
		} else {
			const validTarget = this._state.withScrollPosition(update);
			this._smoothScrolling = SmoothScrollingOperation.start(this._state, validTarget, this._smoothScrollDuration);
		}
		this._smoothScrolling.animationFrameDisposable = this._scheduleAtNextAnimationFrame(() => {
			if (!this._smoothScrolling) return;
			this._smoothScrolling.animationFrameDisposable = null;
			this._performSmoothScrolling();
		});
	}
	hasPendingScrollAnimation() {
		return Boolean(this._smoothScrolling);
	}
	_performSmoothScrolling() {
		if (!this._smoothScrolling) return;
		const update = this._smoothScrolling.tick();
		const newState = this._state.withScrollPosition(update);
		this._setState(newState, true);
		if (!this._smoothScrolling) return;
		if (update.isDone) {
			this._smoothScrolling.dispose();
			this._smoothScrolling = null;
			return;
		}
		this._smoothScrolling.animationFrameDisposable = this._scheduleAtNextAnimationFrame(() => {
			if (!this._smoothScrolling) return;
			this._smoothScrolling.animationFrameDisposable = null;
			this._performSmoothScrolling();
		});
	}
	_setState(newState, inSmoothScrolling) {
		const oldState = this._state;
		if (oldState.equals(newState)) return;
		this._state = newState;
		this._onScroll.fire(this._state.createScrollEvent(oldState, inSmoothScrolling));
	}
};
var SmoothScrollingUpdate = class {
	constructor(scrollLeft, scrollTop, isDone) {
		this.scrollLeft = scrollLeft;
		this.scrollTop = scrollTop;
		this.isDone = isDone;
	}
};
function createEaseOutCubic(from, to) {
	const delta = to - from;
	return function(completion) {
		return from + delta * easeOutCubic(completion);
	};
}
function createComposed(a, b, cut) {
	return function(completion) {
		if (completion < cut) return a(completion / cut);
		return b((completion - cut) / (1 - cut));
	};
}
var SmoothScrollingOperation = class SmoothScrollingOperation {
	constructor(from, to, startTime, duration) {
		this.from = from;
		this.to = to;
		this.duration = duration;
		this.startTime = startTime;
		this.animationFrameDisposable = null;
		this._initAnimations();
	}
	_initAnimations() {
		this.scrollLeft = this._initAnimation(this.from.scrollLeft, this.to.scrollLeft, this.to.width);
		this.scrollTop = this._initAnimation(this.from.scrollTop, this.to.scrollTop, this.to.height);
	}
	_initAnimation(from, to, viewportSize) {
		if (Math.abs(from - to) > 2.5 * viewportSize) {
			let stop1, stop2;
			if (from < to) {
				stop1 = from + .75 * viewportSize;
				stop2 = to - .75 * viewportSize;
			} else {
				stop1 = from - .75 * viewportSize;
				stop2 = to + .75 * viewportSize;
			}
			return createComposed(createEaseOutCubic(from, stop1), createEaseOutCubic(stop2, to), .33);
		}
		return createEaseOutCubic(from, to);
	}
	dispose() {
		if (this.animationFrameDisposable !== null) {
			this.animationFrameDisposable.dispose();
			this.animationFrameDisposable = null;
		}
	}
	acceptScrollDimensions(state) {
		this.to = state.withScrollPosition(this.to);
		this._initAnimations();
	}
	tick() {
		return this._tick(Date.now());
	}
	_tick(now) {
		const completion = (now - this.startTime) / this.duration;
		if (completion < 1) return new SmoothScrollingUpdate(this.scrollLeft(completion), this.scrollTop(completion), false);
		return new SmoothScrollingUpdate(this.to.scrollLeft, this.to.scrollTop, true);
	}
	combine(from, to, duration) {
		return SmoothScrollingOperation.start(from, to, duration);
	}
	static start(from, to, duration) {
		duration = duration + 10;
		const startTime = Date.now() - 10;
		return new SmoothScrollingOperation(from, to, startTime, duration);
	}
};
function easeInCubic(t) {
	return Math.pow(t, 3);
}
function easeOutCubic(t) {
	return 1 - easeInCubic(1 - t);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/scrollbar/scrollableElement.js
var HIDE_TIMEOUT = 500;
var SCROLL_WHEEL_SENSITIVITY = 50;
var globalDefaultScrollbarSize = 10;
var onDidChangeDefaultScrollbarSize = new Emitter$1().event;
var MouseWheelClassifierItem = class {
	constructor(timestamp, deltaX, deltaY) {
		this.timestamp = timestamp;
		this.deltaX = deltaX;
		this.deltaY = deltaY;
		this.score = 0;
	}
};
var MouseWheelClassifier = class MouseWheelClassifier {
	static {
		this.INSTANCE = new MouseWheelClassifier();
	}
	constructor() {
		this._capacity = 5;
		this._memory = [];
		this._front = -1;
		this._rear = -1;
	}
	isPhysicalMouseWheel() {
		if (this._front === -1 && this._rear === -1) return false;
		let remainingInfluence = 1;
		let score = 0;
		let iteration = 1;
		let index = this._rear;
		do {
			const influence = index === this._front ? remainingInfluence : Math.pow(2, -iteration);
			remainingInfluence -= influence;
			score += this._memory[index].score * influence;
			if (index === this._front) break;
			index = (this._capacity + index - 1) % this._capacity;
			iteration++;
		} while (true);
		return score <= .5;
	}
	acceptStandardWheelEvent(e) {
		if (isChrome) {
			const pageZoomFactor = getZoomFactor(getWindow(e.browserEvent));
			this.accept(Date.now(), e.deltaX * pageZoomFactor, e.deltaY * pageZoomFactor);
		} else this.accept(Date.now(), e.deltaX, e.deltaY);
	}
	accept(timestamp, deltaX, deltaY) {
		let previousItem = null;
		const item = new MouseWheelClassifierItem(timestamp, deltaX, deltaY);
		if (this._front === -1 && this._rear === -1) {
			this._memory[0] = item;
			this._front = 0;
			this._rear = 0;
		} else {
			previousItem = this._memory[this._rear];
			this._rear = (this._rear + 1) % this._capacity;
			if (this._rear === this._front) this._front = (this._front + 1) % this._capacity;
			this._memory[this._rear] = item;
		}
		item.score = this._computeScore(item, previousItem);
	}
	/**
	* A score between 0 and 1 for `item`.
	*  - a score towards 0 indicates that the source appears to be a physical mouse wheel
	*  - a score towards 1 indicates that the source appears to be a touchpad or magic mouse, etc.
	*/
	_computeScore(item, previousItem) {
		if (Math.abs(item.deltaX) > 0 && Math.abs(item.deltaY) > 0) return 1;
		let score = .5;
		if (!this._isAlmostInt(item.deltaX) || !this._isAlmostInt(item.deltaY)) score += .25;
		if (previousItem) {
			const absDeltaX = Math.abs(item.deltaX);
			const absDeltaY = Math.abs(item.deltaY);
			const absPreviousDeltaX = Math.abs(previousItem.deltaX);
			const absPreviousDeltaY = Math.abs(previousItem.deltaY);
			const minDeltaX = Math.max(Math.min(absDeltaX, absPreviousDeltaX), 1);
			const minDeltaY = Math.max(Math.min(absDeltaY, absPreviousDeltaY), 1);
			const maxDeltaX = Math.max(absDeltaX, absPreviousDeltaX);
			const maxDeltaY = Math.max(absDeltaY, absPreviousDeltaY);
			if (maxDeltaX % minDeltaX === 0 && maxDeltaY % minDeltaY === 0) score -= .5;
		}
		return Math.min(Math.max(score, 0), 1);
	}
	_isAlmostInt(value) {
		const epsilon = Number.EPSILON * 100;
		return Math.abs(Math.round(value) - value) < .01 + epsilon;
	}
};
var AbstractScrollableElement = class extends Widget$1 {
	get onScroll() {
		return this._onScroll.event;
	}
	get options() {
		return this._options;
	}
	constructor(element, options, scrollable) {
		super();
		this._inertialTimeout = null;
		this._inertialSpeed = {
			X: 0,
			Y: 0
		};
		this._onScroll = this._register(new Emitter$1());
		this._onWillScroll = this._register(new Emitter$1());
		element.style.overflow = "hidden";
		this._options = resolveOptions(options);
		this._scrollable = scrollable;
		this._register(this._scrollable.onScroll((e) => {
			this._onWillScroll.fire(e);
			this._onDidScroll(e);
			this._onScroll.fire(e);
		}));
		const scrollbarHost = {
			onMouseWheel: (mouseWheelEvent) => this._onMouseWheel(mouseWheelEvent),
			onDragStart: () => this._onDragStart(),
			onDragEnd: () => this._onDragEnd()
		};
		this._verticalScrollbar = this._register(new VerticalScrollbar(this._scrollable, this._options, scrollbarHost));
		this._horizontalScrollbar = this._register(new HorizontalScrollbar(this._scrollable, this._options, scrollbarHost));
		this._domNode = document.createElement("div");
		this._domNode.className = "monaco-scrollable-element " + this._options.className;
		this._domNode.setAttribute("role", "presentation");
		this._domNode.style.position = "relative";
		this._domNode.style.overflow = "hidden";
		this._domNode.appendChild(element);
		this._domNode.appendChild(this._horizontalScrollbar.domNode.domNode);
		this._domNode.appendChild(this._verticalScrollbar.domNode.domNode);
		if (this._options.useShadows) {
			this._leftShadowDomNode = createFastDomNode(document.createElement("div"));
			this._leftShadowDomNode.setClassName("shadow");
			this._domNode.appendChild(this._leftShadowDomNode.domNode);
			this._topShadowDomNode = createFastDomNode(document.createElement("div"));
			this._topShadowDomNode.setClassName("shadow");
			this._domNode.appendChild(this._topShadowDomNode.domNode);
			this._topLeftShadowDomNode = createFastDomNode(document.createElement("div"));
			this._topLeftShadowDomNode.setClassName("shadow");
			this._domNode.appendChild(this._topLeftShadowDomNode.domNode);
		} else {
			this._leftShadowDomNode = null;
			this._topShadowDomNode = null;
			this._topLeftShadowDomNode = null;
		}
		this._listenOnDomNode = this._options.listenOnDomNode || this._domNode;
		this._mouseWheelToDispose = [];
		this._setListeningToMouseWheel(this._options.handleMouseWheel);
		this.onmouseover(this._listenOnDomNode, (e) => this._onMouseOver(e));
		this.onmouseleave(this._listenOnDomNode, (e) => this._onMouseLeave(e));
		this._hideTimeout = this._register(new TimeoutTimer());
		this._isDragging = false;
		this._mouseIsOver = false;
		this._shouldRender = true;
		this._revealOnScroll = true;
		const hSizeExplicit = typeof options.horizontalScrollbarSize !== "undefined";
		const vSizeExplicit = typeof options.verticalScrollbarSize !== "undefined";
		if (!hSizeExplicit || !vSizeExplicit) this._register(onDidChangeDefaultScrollbarSize((newSize) => {
			this.updateOptions({
				...!hSizeExplicit ? { horizontalScrollbarSize: newSize } : {},
				...!vSizeExplicit ? { verticalScrollbarSize: newSize } : {}
			});
		}));
	}
	dispose() {
		this._mouseWheelToDispose = dispose(this._mouseWheelToDispose);
		if (this._inertialTimeout) {
			this._inertialTimeout.dispose();
			this._inertialTimeout = null;
		}
		super.dispose();
	}
	/**
	* Get the generated 'scrollable' dom node
	*/
	getDomNode() {
		return this._domNode;
	}
	getOverviewRulerLayoutInfo() {
		return {
			parent: this._domNode,
			insertBefore: this._verticalScrollbar.domNode.domNode
		};
	}
	/**
	* Delegate a pointer down event to the vertical scrollbar.
	* This is to help with clicking somewhere else and having the scrollbar react.
	*/
	delegateVerticalScrollbarPointerDown(browserEvent) {
		this._verticalScrollbar.delegatePointerDown(browserEvent);
	}
	getScrollDimensions() {
		return this._scrollable.getScrollDimensions();
	}
	setScrollDimensions(dimensions) {
		this._scrollable.setScrollDimensions(dimensions, false);
	}
	/**
	* Update the class name of the scrollable element.
	*/
	updateClassName(newClassName) {
		this._options.className = newClassName;
		if (isMacintosh) this._options.className += " mac";
		this._domNode.className = "monaco-scrollable-element " + this._options.className;
	}
	/**
	* Update configuration options for the scrollbar.
	*/
	updateOptions(newOptions) {
		if (typeof newOptions.handleMouseWheel !== "undefined") {
			this._options.handleMouseWheel = newOptions.handleMouseWheel;
			this._setListeningToMouseWheel(this._options.handleMouseWheel);
		}
		if (typeof newOptions.mouseWheelScrollSensitivity !== "undefined") this._options.mouseWheelScrollSensitivity = newOptions.mouseWheelScrollSensitivity;
		if (typeof newOptions.fastScrollSensitivity !== "undefined") this._options.fastScrollSensitivity = newOptions.fastScrollSensitivity;
		if (typeof newOptions.scrollPredominantAxis !== "undefined") this._options.scrollPredominantAxis = newOptions.scrollPredominantAxis;
		if (typeof newOptions.horizontal !== "undefined") this._options.horizontal = newOptions.horizontal;
		if (typeof newOptions.vertical !== "undefined") this._options.vertical = newOptions.vertical;
		if (typeof newOptions.horizontalScrollbarSize !== "undefined") this._options.horizontalScrollbarSize = newOptions.horizontalScrollbarSize;
		if (typeof newOptions.verticalScrollbarSize !== "undefined") this._options.verticalScrollbarSize = newOptions.verticalScrollbarSize;
		if (typeof newOptions.scrollByPage !== "undefined") this._options.scrollByPage = newOptions.scrollByPage;
		this._horizontalScrollbar.updateOptions(this._options);
		this._verticalScrollbar.updateOptions(this._options);
		if (!this._options.lazyRender) this._render();
	}
	delegateScrollFromMouseWheelEvent(browserEvent) {
		this._onMouseWheel(new StandardWheelEvent(browserEvent));
	}
	async _periodicSync() {
		let scheduleAgain = false;
		if (this._inertialSpeed.X !== 0 || this._inertialSpeed.Y !== 0) {
			this._scrollable.setScrollPositionNow({
				scrollTop: this._scrollable.getCurrentScrollPosition().scrollTop - this._inertialSpeed.Y * 100,
				scrollLeft: this._scrollable.getCurrentScrollPosition().scrollLeft - this._inertialSpeed.X * 100
			});
			this._inertialSpeed.X *= .9;
			this._inertialSpeed.Y *= .9;
			if (Math.abs(this._inertialSpeed.X) < .01) this._inertialSpeed.X = 0;
			if (Math.abs(this._inertialSpeed.Y) < .01) this._inertialSpeed.Y = 0;
			scheduleAgain = this._inertialSpeed.X !== 0 || this._inertialSpeed.Y !== 0;
		}
		if (scheduleAgain) {
			if (!this._inertialTimeout) this._inertialTimeout = new TimeoutTimer();
			this._inertialTimeout.cancelAndSet(() => this._periodicSync(), 1e3 / 60);
		} else {
			this._inertialTimeout?.dispose();
			this._inertialTimeout = null;
		}
	}
	_setListeningToMouseWheel(shouldListen) {
		if (this._mouseWheelToDispose.length > 0 === shouldListen) return;
		this._mouseWheelToDispose = dispose(this._mouseWheelToDispose);
		if (shouldListen) {
			const onMouseWheel = (browserEvent) => {
				this._onMouseWheel(new StandardWheelEvent(browserEvent));
			};
			this._mouseWheelToDispose.push(addDisposableListener(this._listenOnDomNode, EventType$1.MOUSE_WHEEL, onMouseWheel, { passive: false }));
		}
	}
	_onMouseWheel(e) {
		if (e.browserEvent?.defaultPrevented) return;
		const classifier = MouseWheelClassifier.INSTANCE;
		classifier.acceptStandardWheelEvent(e);
		let didScroll = false;
		if (e.deltaY || e.deltaX) {
			let deltaY = e.deltaY * this._options.mouseWheelScrollSensitivity;
			let deltaX = e.deltaX * this._options.mouseWheelScrollSensitivity;
			if (this._options.scrollPredominantAxis) {
				if (this._options.scrollYToX && deltaX + deltaY === 0) deltaX = deltaY = 0;
				else if (Math.abs(deltaY) >= Math.abs(deltaX)) deltaX = 0;
				else deltaY = 0;
			}
			if (this._options.flipAxes) [deltaY, deltaX] = [deltaX, deltaY];
			const shiftConvert = !isMacintosh && e.browserEvent && e.browserEvent.shiftKey;
			if ((this._options.scrollYToX || shiftConvert) && !deltaX) {
				deltaX = deltaY;
				deltaY = 0;
			}
			if (e.browserEvent && e.browserEvent.altKey) {
				deltaX = deltaX * this._options.fastScrollSensitivity;
				deltaY = deltaY * this._options.fastScrollSensitivity;
			}
			const futureScrollPosition = this._scrollable.getFutureScrollPosition();
			let desiredScrollPosition = {};
			if (deltaY) {
				const deltaScrollTop = SCROLL_WHEEL_SENSITIVITY * deltaY;
				const desiredScrollTop = futureScrollPosition.scrollTop - (deltaScrollTop < 0 ? Math.floor(deltaScrollTop) : Math.ceil(deltaScrollTop));
				this._verticalScrollbar.writeScrollPosition(desiredScrollPosition, desiredScrollTop);
			}
			if (deltaX) {
				const deltaScrollLeft = SCROLL_WHEEL_SENSITIVITY * deltaX;
				const desiredScrollLeft = futureScrollPosition.scrollLeft - (deltaScrollLeft < 0 ? Math.floor(deltaScrollLeft) : Math.ceil(deltaScrollLeft));
				this._horizontalScrollbar.writeScrollPosition(desiredScrollPosition, desiredScrollLeft);
			}
			desiredScrollPosition = this._scrollable.validateScrollPosition(desiredScrollPosition);
			if (this._options.inertialScroll && (deltaX || deltaY) && !classifier.isPhysicalMouseWheel()) {
				let startPeriodic = false;
				if (this._inertialSpeed.X === 0 && this._inertialSpeed.Y === 0) startPeriodic = true;
				this._inertialSpeed.Y = (deltaY < 0 ? -1 : 1) * Math.abs(deltaY) ** 1.02;
				this._inertialSpeed.X = (deltaX < 0 ? -1 : 1) * Math.abs(deltaX) ** 1.02;
				if (startPeriodic) this._periodicSync();
			}
			if (futureScrollPosition.scrollLeft !== desiredScrollPosition.scrollLeft || futureScrollPosition.scrollTop !== desiredScrollPosition.scrollTop) {
				if (this._options.mouseWheelSmoothScroll && classifier.isPhysicalMouseWheel()) this._scrollable.setScrollPositionSmooth(desiredScrollPosition);
				else this._scrollable.setScrollPositionNow(desiredScrollPosition);
				didScroll = true;
			}
		}
		let consumeMouseWheel = didScroll;
		if (!consumeMouseWheel && this._options.alwaysConsumeMouseWheel) consumeMouseWheel = true;
		if (!consumeMouseWheel && this._options.consumeMouseWheelIfScrollbarIsNeeded && (this._verticalScrollbar.isNeeded() || this._horizontalScrollbar.isNeeded())) consumeMouseWheel = true;
		if (consumeMouseWheel) {
			e.preventDefault();
			e.stopPropagation();
		}
	}
	_onDidScroll(e) {
		this._shouldRender = this._horizontalScrollbar.onDidScroll(e) || this._shouldRender;
		this._shouldRender = this._verticalScrollbar.onDidScroll(e) || this._shouldRender;
		if (this._options.useShadows) this._shouldRender = true;
		if (this._revealOnScroll) this._reveal();
		if (!this._options.lazyRender) this._render();
	}
	/**
	* Render / mutate the DOM now.
	* Should be used together with the ctor option `lazyRender`.
	*/
	renderNow() {
		if (!this._options.lazyRender) throw new Error("Please use `lazyRender` together with `renderNow`!");
		this._render();
	}
	_render() {
		if (!this._shouldRender) return;
		this._shouldRender = false;
		this._horizontalScrollbar.render();
		this._verticalScrollbar.render();
		if (this._options.useShadows) {
			const scrollState = this._scrollable.getCurrentScrollPosition();
			const enableTop = scrollState.scrollTop > 0;
			const enableLeft = scrollState.scrollLeft > 0;
			const leftClassName = enableLeft ? " left" : "";
			const topClassName = enableTop ? " top" : "";
			const topLeftClassName = enableLeft || enableTop ? " top-left-corner" : "";
			this._leftShadowDomNode.setClassName(`shadow${leftClassName}`);
			this._topShadowDomNode.setClassName(`shadow${topClassName}`);
			this._topLeftShadowDomNode.setClassName(`shadow${topLeftClassName}${topClassName}${leftClassName}`);
		}
	}
	_onDragStart() {
		this._isDragging = true;
		this._reveal();
	}
	_onDragEnd() {
		this._isDragging = false;
		this._hide();
	}
	_onMouseLeave(e) {
		this._mouseIsOver = false;
		this._hide();
	}
	_onMouseOver(e) {
		this._mouseIsOver = true;
		this._reveal();
	}
	_reveal() {
		this._verticalScrollbar.beginReveal();
		this._horizontalScrollbar.beginReveal();
		this._scheduleHide();
	}
	_hide() {
		if (!this._mouseIsOver && !this._isDragging) {
			this._verticalScrollbar.beginHide();
			this._horizontalScrollbar.beginHide();
		}
	}
	_scheduleHide() {
		if (!this._mouseIsOver && !this._isDragging) this._hideTimeout.cancelAndSet(() => this._hide(), HIDE_TIMEOUT);
	}
};
var ScrollableElement = class extends AbstractScrollableElement {
	constructor(element, options) {
		options = options || {};
		options.mouseWheelSmoothScroll = false;
		const scrollable = new Scrollable({
			forceIntegerValues: true,
			smoothScrollDuration: 0,
			scheduleAtNextAnimationFrame: (callback) => scheduleAtNextAnimationFrame(getWindow(element), callback)
		});
		super(element, options, scrollable);
		this._register(scrollable);
	}
	setScrollPosition(update) {
		this._scrollable.setScrollPositionNow(update);
	}
};
var SmoothScrollableElement = class extends AbstractScrollableElement {
	constructor(element, options, scrollable) {
		super(element, options, scrollable);
	}
	setScrollPosition(update) {
		if (update.reuseAnimation) this._scrollable.setScrollPositionSmooth(update, update.reuseAnimation);
		else this._scrollable.setScrollPositionNow(update);
	}
	getScrollPosition() {
		return this._scrollable.getCurrentScrollPosition();
	}
};
var DomScrollableElement = class extends AbstractScrollableElement {
	constructor(element, options) {
		options = options || {};
		options.mouseWheelSmoothScroll = false;
		const scrollable = new Scrollable({
			forceIntegerValues: false,
			smoothScrollDuration: 0,
			scheduleAtNextAnimationFrame: (callback) => scheduleAtNextAnimationFrame(getWindow(element), callback)
		});
		super(element, options, scrollable);
		this._register(scrollable);
		this._element = element;
		this._register(this.onScroll((e) => {
			if (e.scrollTopChanged) this._element.scrollTop = e.scrollTop;
			if (e.scrollLeftChanged) this._element.scrollLeft = e.scrollLeft;
		}));
		this.scanDomNode();
	}
	setScrollPosition(update) {
		this._scrollable.setScrollPositionNow(update);
	}
	getScrollPosition() {
		return this._scrollable.getCurrentScrollPosition();
	}
	scanDomNode() {
		this.setScrollDimensions({
			width: this._element.clientWidth,
			scrollWidth: this._element.scrollWidth,
			height: this._element.clientHeight,
			scrollHeight: this._element.scrollHeight
		});
		this.setScrollPosition({
			scrollLeft: this._element.scrollLeft,
			scrollTop: this._element.scrollTop
		});
	}
};
function resolveOptions(opts) {
	const result = {
		lazyRender: typeof opts.lazyRender !== "undefined" ? opts.lazyRender : false,
		className: typeof opts.className !== "undefined" ? opts.className : "",
		useShadows: typeof opts.useShadows !== "undefined" ? opts.useShadows : true,
		handleMouseWheel: typeof opts.handleMouseWheel !== "undefined" ? opts.handleMouseWheel : true,
		flipAxes: typeof opts.flipAxes !== "undefined" ? opts.flipAxes : false,
		consumeMouseWheelIfScrollbarIsNeeded: typeof opts.consumeMouseWheelIfScrollbarIsNeeded !== "undefined" ? opts.consumeMouseWheelIfScrollbarIsNeeded : false,
		alwaysConsumeMouseWheel: typeof opts.alwaysConsumeMouseWheel !== "undefined" ? opts.alwaysConsumeMouseWheel : false,
		scrollYToX: typeof opts.scrollYToX !== "undefined" ? opts.scrollYToX : false,
		mouseWheelScrollSensitivity: typeof opts.mouseWheelScrollSensitivity !== "undefined" ? opts.mouseWheelScrollSensitivity : 1,
		fastScrollSensitivity: typeof opts.fastScrollSensitivity !== "undefined" ? opts.fastScrollSensitivity : 5,
		scrollPredominantAxis: typeof opts.scrollPredominantAxis !== "undefined" ? opts.scrollPredominantAxis : true,
		mouseWheelSmoothScroll: typeof opts.mouseWheelSmoothScroll !== "undefined" ? opts.mouseWheelSmoothScroll : true,
		inertialScroll: typeof opts.inertialScroll !== "undefined" ? opts.inertialScroll : false,
		arrowSize: typeof opts.arrowSize !== "undefined" ? opts.arrowSize : 11,
		listenOnDomNode: typeof opts.listenOnDomNode !== "undefined" ? opts.listenOnDomNode : null,
		horizontal: typeof opts.horizontal !== "undefined" ? opts.horizontal : 1,
		horizontalScrollbarSize: typeof opts.horizontalScrollbarSize !== "undefined" ? opts.horizontalScrollbarSize : globalDefaultScrollbarSize,
		horizontalSliderSize: typeof opts.horizontalSliderSize !== "undefined" ? opts.horizontalSliderSize : 0,
		horizontalHasArrows: typeof opts.horizontalHasArrows !== "undefined" ? opts.horizontalHasArrows : false,
		vertical: typeof opts.vertical !== "undefined" ? opts.vertical : 1,
		verticalScrollbarSize: typeof opts.verticalScrollbarSize !== "undefined" ? opts.verticalScrollbarSize : globalDefaultScrollbarSize,
		verticalHasArrows: typeof opts.verticalHasArrows !== "undefined" ? opts.verticalHasArrows : false,
		verticalSliderSize: typeof opts.verticalSliderSize !== "undefined" ? opts.verticalSliderSize : 0,
		scrollByPage: typeof opts.scrollByPage !== "undefined" ? opts.scrollByPage : false
	};
	result.horizontalSliderSize = typeof opts.horizontalSliderSize !== "undefined" ? opts.horizontalSliderSize : result.horizontalScrollbarSize;
	result.verticalSliderSize = typeof opts.verticalSliderSize !== "undefined" ? opts.verticalSliderSize : result.verticalScrollbarSize;
	if (isMacintosh) result.className += " mac";
	return result;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/controller/dragScrolling.js
var DragScrolling = class extends Disposable {
	constructor(_context, _viewHelper, _mouseTargetFactory, _dispatchMouse) {
		super();
		this._context = _context;
		this._viewHelper = _viewHelper;
		this._mouseTargetFactory = _mouseTargetFactory;
		this._dispatchMouse = _dispatchMouse;
		this._operation = null;
	}
	dispose() {
		super.dispose();
		this.stop();
	}
	start(position, mouseEvent) {
		if (this._operation) this._operation.setPosition(position, mouseEvent);
		else this._operation = this._createDragScrollingOperation(position, mouseEvent);
	}
	stop() {
		if (this._operation) {
			this._operation.dispose();
			this._operation = null;
		}
	}
};
var DragScrollingOperation = class extends Disposable {
	constructor(_context, _viewHelper, _mouseTargetFactory, _dispatchMouse, position, mouseEvent) {
		super();
		this._context = _context;
		this._viewHelper = _viewHelper;
		this._mouseTargetFactory = _mouseTargetFactory;
		this._dispatchMouse = _dispatchMouse;
		this._position = position;
		this._mouseEvent = mouseEvent;
		this._lastTime = Date.now();
		this._animationFrameDisposable = scheduleAtNextAnimationFrame(getWindow(mouseEvent.browserEvent), () => this._execute());
	}
	dispose() {
		this._animationFrameDisposable.dispose();
		super.dispose();
	}
	setPosition(position, mouseEvent) {
		this._position = position;
		this._mouseEvent = mouseEvent;
	}
	/**
	* update internal state and return elapsed ms since last time
	*/
	_tick() {
		const now = Date.now();
		const elapsed = now - this._lastTime;
		this._lastTime = now;
		return elapsed;
	}
};
var TopBottomDragScrolling = class extends DragScrolling {
	_createDragScrollingOperation(position, mouseEvent) {
		return new TopBottomDragScrollingOperation(this._context, this._viewHelper, this._mouseTargetFactory, this._dispatchMouse, position, mouseEvent);
	}
};
var TopBottomDragScrollingOperation = class extends DragScrollingOperation {
	/**
	* get the number of lines per second to auto-scroll
	*/
	_getScrollSpeed() {
		const lineHeight = this._context.configuration.options.get(75);
		const viewportInLines = this._context.configuration.options.get(166).height / lineHeight;
		const outsideDistanceInLines = this._position.outsideDistance / lineHeight;
		if (outsideDistanceInLines <= 1.5) return Math.max(30, viewportInLines * (1 + outsideDistanceInLines));
		if (outsideDistanceInLines <= 3) return Math.max(60, viewportInLines * (2 + outsideDistanceInLines));
		return Math.max(200, viewportInLines * (7 + outsideDistanceInLines));
	}
	_execute() {
		const lineHeight = this._context.configuration.options.get(75);
		const scrollInPixels = this._getScrollSpeed() * (this._tick() / 1e3) * lineHeight;
		const scrollValue = this._position.outsidePosition === "above" ? -scrollInPixels : scrollInPixels;
		this._context.viewModel.viewLayout.deltaScrollNow(0, scrollValue);
		this._viewHelper.renderNow();
		const viewportData = this._context.viewLayout.getLinesViewportData();
		const edgeLineNumber = this._position.outsidePosition === "above" ? viewportData.startLineNumber : viewportData.endLineNumber;
		const cannotScrollAnymore = this._position.outsidePosition === "above" ? viewportData.startLineNumber === 1 : viewportData.endLineNumber === this._context.viewModel.getLineCount();
		let mouseTarget;
		{
			const editorPos = createEditorPagePosition(this._viewHelper.viewDomNode);
			const horizontalScrollbarHeight = this._context.configuration.options.get(166).horizontalScrollbarHeight;
			const pos = new PageCoordinates(this._mouseEvent.pos.x, editorPos.y + editorPos.height - horizontalScrollbarHeight - .1);
			const relativePos = createCoordinatesRelativeToEditor(this._viewHelper.viewDomNode, editorPos, pos);
			mouseTarget = this._mouseTargetFactory.createMouseTarget(this._viewHelper.getLastRenderData(), editorPos, pos, relativePos, null);
		}
		if (!mouseTarget.position || mouseTarget.position.lineNumber !== edgeLineNumber || cannotScrollAnymore) {
			if (this._position.outsidePosition === "above") mouseTarget = MouseTarget.createOutsideEditor(this._position.mouseColumn, new Position$1(edgeLineNumber, 1), "above", this._position.outsideDistance);
			else mouseTarget = MouseTarget.createOutsideEditor(this._position.mouseColumn, new Position$1(edgeLineNumber, this._context.viewModel.getLineMaxColumn(edgeLineNumber)), "below", this._position.outsideDistance);
		}
		this._dispatchMouse(mouseTarget, true, 2);
		this._animationFrameDisposable = scheduleAtNextAnimationFrame(getWindow(mouseTarget.element), () => this._execute());
	}
};
var LeftRightDragScrolling = class extends DragScrolling {
	_createDragScrollingOperation(position, mouseEvent) {
		return new LeftRightDragScrollingOperation(this._context, this._viewHelper, this._mouseTargetFactory, this._dispatchMouse, position, mouseEvent);
	}
};
var LeftRightDragScrollingOperation = class extends DragScrollingOperation {
	/**
	* get the number of cols per second to auto-scroll
	*/
	_getScrollSpeed() {
		const charWidth = this._context.configuration.options.get(59).typicalFullwidthCharacterWidth;
		const viewportInChars = this._context.configuration.options.get(166).contentWidth / charWidth;
		const outsideDistanceInChars = this._position.outsideDistance / charWidth;
		if (outsideDistanceInChars <= 1.5) return Math.max(30, viewportInChars * (1 + outsideDistanceInChars));
		if (outsideDistanceInChars <= 3) return Math.max(60, viewportInChars * (2 + outsideDistanceInChars));
		return Math.max(200, viewportInChars * (7 + outsideDistanceInChars));
	}
	_execute() {
		const charWidth = this._context.configuration.options.get(59).typicalFullwidthCharacterWidth;
		const scrollInPixels = this._getScrollSpeed() * (this._tick() / 1e3) * charWidth * .5;
		const scrollValue = this._position.outsidePosition === "left" ? -scrollInPixels : scrollInPixels;
		this._context.viewModel.viewLayout.deltaScrollNow(scrollValue, 0);
		this._viewHelper.renderNow();
		if (!this._position.position) return;
		const edgeLineNumber = this._position.position.lineNumber;
		let mouseTarget;
		const exceedingPosition = this._context.viewModel.getTextDirection(edgeLineNumber) === TextDirection.RTL ? "left" : "right";
		if (this._position.outsidePosition === exceedingPosition) {
			const lineWidth = this._context.viewModel.getLineMaxColumn(edgeLineNumber);
			mouseTarget = MouseTarget.createOutsideEditor(lineWidth, new Position$1(edgeLineNumber, lineWidth), "right", this._position.outsideDistance);
		} else mouseTarget = MouseTarget.createOutsideEditor(1, new Position$1(edgeLineNumber, 1), "left", this._position.outsideDistance);
		this._dispatchMouse(mouseTarget, true, 2);
		this._animationFrameDisposable = scheduleAtNextAnimationFrame(getWindow(mouseTarget.element), () => this._execute());
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/controller/mouseHandler.js
var MouseHandler = class extends ViewEventHandler {
	constructor(context, viewController, viewHelper) {
		super();
		this._mouseLeaveMonitor = null;
		this._context = context;
		this.viewController = viewController;
		this.viewHelper = viewHelper;
		this.mouseTargetFactory = new MouseTargetFactory(this._context, viewHelper);
		this._mouseDownOperation = this._register(new MouseDownOperation(this._context, this.viewController, this.viewHelper, this.mouseTargetFactory, (e, testEventTarget) => this._createMouseTarget(e, testEventTarget), (e) => this._getMouseColumn(e)));
		this.lastMouseLeaveTime = -1;
		this._height = this._context.configuration.options.get(166).height;
		const mouseEvents = new EditorMouseEventFactory(this.viewHelper.viewDomNode);
		this._register(mouseEvents.onContextMenu(this.viewHelper.viewDomNode, (e) => this._onContextMenu(e, true)));
		this._register(mouseEvents.onMouseMove(this.viewHelper.viewDomNode, (e) => {
			this._onMouseMove(e);
			if (!this._mouseLeaveMonitor) this._mouseLeaveMonitor = addDisposableListener(this.viewHelper.viewDomNode.ownerDocument, "mousemove", (e) => {
				if (!this.viewHelper.viewDomNode.contains(e.target)) this._onMouseLeave(new EditorMouseEvent(e, false, this.viewHelper.viewDomNode));
			});
		}));
		this._register(mouseEvents.onMouseUp(this.viewHelper.viewDomNode, (e) => this._onMouseUp(e)));
		this._register(mouseEvents.onMouseLeave(this.viewHelper.viewDomNode, (e) => this._onMouseLeave(e)));
		let capturePointerId = 0;
		this._register(mouseEvents.onPointerDown(this.viewHelper.viewDomNode, (e, pointerId) => {
			capturePointerId = pointerId;
		}));
		this._register(addDisposableListener(this.viewHelper.viewDomNode, EventType$1.POINTER_UP, (e) => {
			this._mouseDownOperation.onPointerUp();
		}));
		this._register(mouseEvents.onMouseDown(this.viewHelper.viewDomNode, (e) => this._onMouseDown(e, capturePointerId)));
		this._setupMouseWheelZoomListener();
		this._context.addEventHandler(this);
	}
	_setupMouseWheelZoomListener() {
		const classifier = MouseWheelClassifier.INSTANCE;
		let prevMouseWheelTime = 0;
		let gestureStartZoomLevel = EditorZoom.getZoomLevel();
		let gestureHasZoomModifiers = false;
		let gestureAccumulatedDelta = 0;
		const onMouseWheel = (browserEvent) => {
			this.viewController.emitMouseWheel(browserEvent);
			if (!this._context.configuration.options.get(84)) return;
			const e = new StandardWheelEvent(browserEvent);
			classifier.acceptStandardWheelEvent(e);
			if (classifier.isPhysicalMouseWheel()) {
				if (hasMouseWheelZoomModifiers(browserEvent)) {
					const zoomLevel = EditorZoom.getZoomLevel();
					const delta = e.deltaY > 0 ? 1 : -1;
					EditorZoom.setZoomLevel(zoomLevel + delta);
					e.preventDefault();
					e.stopPropagation();
				}
			} else {
				if (Date.now() - prevMouseWheelTime > 50) {
					gestureStartZoomLevel = EditorZoom.getZoomLevel();
					gestureHasZoomModifiers = hasMouseWheelZoomModifiers(browserEvent);
					gestureAccumulatedDelta = 0;
				}
				prevMouseWheelTime = Date.now();
				gestureAccumulatedDelta += e.deltaY;
				if (gestureHasZoomModifiers) {
					EditorZoom.setZoomLevel(gestureStartZoomLevel + gestureAccumulatedDelta / 5);
					e.preventDefault();
					e.stopPropagation();
				}
			}
		};
		this._register(addDisposableListener(this.viewHelper.viewDomNode, EventType$1.MOUSE_WHEEL, onMouseWheel, {
			capture: true,
			passive: false
		}));
		function hasMouseWheelZoomModifiers(browserEvent) {
			return isMacintosh ? (browserEvent.metaKey || browserEvent.ctrlKey) && !browserEvent.shiftKey && !browserEvent.altKey : browserEvent.ctrlKey && !browserEvent.metaKey && !browserEvent.shiftKey && !browserEvent.altKey;
		}
	}
	dispose() {
		this._context.removeEventHandler(this);
		if (this._mouseLeaveMonitor) {
			this._mouseLeaveMonitor.dispose();
			this._mouseLeaveMonitor = null;
		}
		super.dispose();
	}
	onConfigurationChanged(e) {
		if (e.hasChanged(166)) {
			const height = this._context.configuration.options.get(166).height;
			if (this._height !== height) {
				this._height = height;
				this._mouseDownOperation.onHeightChanged();
			}
		}
		return false;
	}
	onCursorStateChanged(e) {
		this._mouseDownOperation.onCursorStateChanged(e);
		return false;
	}
	onFocusChanged(e) {
		return false;
	}
	getTargetAtClientPoint(clientX, clientY) {
		const pos = new ClientCoordinates(clientX, clientY).toPageCoordinates(getWindow(this.viewHelper.viewDomNode));
		const editorPos = createEditorPagePosition(this.viewHelper.viewDomNode);
		if (pos.y < editorPos.y || pos.y > editorPos.y + editorPos.height || pos.x < editorPos.x || pos.x > editorPos.x + editorPos.width) return null;
		const relativePos = createCoordinatesRelativeToEditor(this.viewHelper.viewDomNode, editorPos, pos);
		return this.mouseTargetFactory.createMouseTarget(this.viewHelper.getLastRenderData(), editorPos, pos, relativePos, null);
	}
	_createMouseTarget(e, testEventTarget) {
		let target = e.target;
		if (!this.viewHelper.viewDomNode.contains(target)) {
			const shadowRoot = getShadowRoot(this.viewHelper.viewDomNode);
			if (shadowRoot) target = shadowRoot.elementsFromPoint(e.posx, e.posy).find((el) => this.viewHelper.viewDomNode.contains(el)) ?? null;
		}
		return this.mouseTargetFactory.createMouseTarget(this.viewHelper.getLastRenderData(), e.editorPos, e.pos, e.relativePos, testEventTarget ? target : null);
	}
	_getMouseColumn(e) {
		return this.mouseTargetFactory.getMouseColumn(e.relativePos);
	}
	_onContextMenu(e, testEventTarget) {
		this.viewController.emitContextMenu({
			event: e,
			target: this._createMouseTarget(e, testEventTarget)
		});
	}
	_onMouseMove(e) {
		if (!this.mouseTargetFactory.mouseTargetIsWidget(e)) e.preventDefault();
		if (this._mouseDownOperation.isActive()) return;
		if (e.timestamp < this.lastMouseLeaveTime) return;
		this.viewController.emitMouseMove({
			event: e,
			target: this._createMouseTarget(e, true)
		});
	}
	_onMouseLeave(e) {
		if (this._mouseLeaveMonitor) {
			this._mouseLeaveMonitor.dispose();
			this._mouseLeaveMonitor = null;
		}
		this.lastMouseLeaveTime = (/* @__PURE__ */ new Date()).getTime();
		this.viewController.emitMouseLeave({
			event: e,
			target: null
		});
	}
	_onMouseUp(e) {
		this.viewController.emitMouseUp({
			event: e,
			target: this._createMouseTarget(e, true)
		});
	}
	_onMouseDown(e, pointerId) {
		const t = this._createMouseTarget(e, true);
		const targetIsContent = t.type === 6 || t.type === 7;
		const targetIsGutter = t.type === 2 || t.type === 3 || t.type === 4;
		const targetIsLineNumbers = t.type === 3;
		const selectOnLineNumbers = this._context.configuration.options.get(125);
		const targetIsViewZone = t.type === 8 || t.type === 5;
		const targetIsWidget = t.type === 9;
		let shouldHandle = e.leftButton || e.middleButton;
		if (isMacintosh && e.leftButton && e.ctrlKey) shouldHandle = false;
		const focus = () => {
			e.preventDefault();
			this.viewHelper.focusTextArea();
		};
		if (shouldHandle && (targetIsContent || targetIsLineNumbers && selectOnLineNumbers)) {
			focus();
			this._mouseDownOperation.start(t.type, e, pointerId);
		} else if (targetIsGutter) e.preventDefault();
		else if (targetIsViewZone) {
			const viewZoneData = t.detail;
			if (shouldHandle && this.viewHelper.shouldSuppressMouseDownOnViewZone(viewZoneData.viewZoneId)) {
				focus();
				this._mouseDownOperation.start(t.type, e, pointerId);
				e.preventDefault();
			}
		} else if (targetIsWidget && this.viewHelper.shouldSuppressMouseDownOnWidget(t.detail)) {
			focus();
			e.preventDefault();
		}
		this.viewController.emitMouseDown({
			event: e,
			target: t
		});
	}
};
var MouseDownOperation = class extends Disposable {
	constructor(_context, _viewController, _viewHelper, _mouseTargetFactory, createMouseTarget, getMouseColumn) {
		super();
		this._context = _context;
		this._viewController = _viewController;
		this._viewHelper = _viewHelper;
		this._mouseTargetFactory = _mouseTargetFactory;
		this._createMouseTarget = createMouseTarget;
		this._getMouseColumn = getMouseColumn;
		this._mouseMoveMonitor = this._register(new GlobalEditorPointerMoveMonitor(this._viewHelper.viewDomNode));
		this._topBottomDragScrolling = this._register(new TopBottomDragScrolling(this._context, this._viewHelper, this._mouseTargetFactory, (position, inSelectionMode, revealType) => this._dispatchMouse(position, inSelectionMode, revealType)));
		this._leftRightDragScrolling = this._register(new LeftRightDragScrolling(this._context, this._viewHelper, this._mouseTargetFactory, (position, inSelectionMode, revealType) => this._dispatchMouse(position, inSelectionMode, revealType)));
		this._mouseState = new MouseDownState();
		this._currentSelection = new Selection$1(1, 1, 1, 1);
		this._isActive = false;
		this._lastMouseEvent = null;
	}
	isActive() {
		return this._isActive;
	}
	_onMouseDownThenMove(e) {
		this._lastMouseEvent = e;
		this._mouseState.setModifiers(e);
		const position = this._findMousePosition(e, false);
		if (!position) return;
		if (this._mouseState.isDragAndDrop) this._viewController.emitMouseDrag({
			event: e,
			target: position
		});
		else if (position.type === 13) {
			if (position.outsidePosition === "above" || position.outsidePosition === "below") {
				this._topBottomDragScrolling.start(position, e);
				this._leftRightDragScrolling.stop();
			} else {
				this._leftRightDragScrolling.start(position, e);
				this._topBottomDragScrolling.stop();
			}
		} else {
			this._topBottomDragScrolling.stop();
			this._leftRightDragScrolling.stop();
			this._dispatchMouse(position, true, 1);
		}
	}
	start(targetType, e, pointerId) {
		this._lastMouseEvent = e;
		this._mouseState.setStartedOnLineNumbers(targetType === 3);
		this._mouseState.setStartButtons(e);
		this._mouseState.setModifiers(e);
		const position = this._findMousePosition(e, true);
		if (!position || !position.position) return;
		this._mouseState.trySetCount(e.detail, position.position);
		e.detail = this._mouseState.count;
		const options = this._context.configuration.options;
		if (!options.get(104) && options.get(42) && !options.get(28) && !this._mouseState.altKey && e.detail < 2 && !this._isActive && !this._currentSelection.isEmpty() && position.type === 6 && position.position && this._currentSelection.containsPosition(position.position)) {
			this._mouseState.isDragAndDrop = true;
			this._isActive = true;
			this._mouseMoveMonitor.startMonitoring(this._viewHelper.viewLinesDomNode, pointerId, e.buttons, (e) => this._onMouseDownThenMove(e), (browserEvent) => {
				const position = this._findMousePosition(this._lastMouseEvent, false);
				if (isKeyboardEvent(browserEvent)) this._viewController.emitMouseDropCanceled();
				else this._viewController.emitMouseDrop({
					event: this._lastMouseEvent,
					target: position ? this._createMouseTarget(this._lastMouseEvent, true) : null
				});
				this._stop();
			});
			return;
		}
		this._mouseState.isDragAndDrop = false;
		this._dispatchMouse(position, e.shiftKey, 1);
		if (!this._isActive) {
			this._isActive = true;
			this._mouseMoveMonitor.startMonitoring(this._viewHelper.viewLinesDomNode, pointerId, e.buttons, (e) => this._onMouseDownThenMove(e), () => this._stop());
		}
	}
	_stop() {
		this._isActive = false;
		this._topBottomDragScrolling.stop();
		this._leftRightDragScrolling.stop();
	}
	onHeightChanged() {
		this._mouseMoveMonitor.stopMonitoring();
	}
	onPointerUp() {
		this._mouseMoveMonitor.stopMonitoring();
	}
	onCursorStateChanged(e) {
		this._currentSelection = e.selections[0];
	}
	_getPositionOutsideEditor(e) {
		const editorContent = e.editorPos;
		const model = this._context.viewModel;
		const viewLayout = this._context.viewLayout;
		const mouseColumn = this._getMouseColumn(e);
		if (e.posy < editorContent.y) {
			const outsideDistance = editorContent.y - e.posy;
			const verticalOffset = Math.max(viewLayout.getCurrentScrollTop() - outsideDistance, 0);
			const viewZoneData = HitTestContext.getZoneAtCoord(this._context, verticalOffset);
			if (viewZoneData) {
				const newPosition = this._helpPositionJumpOverViewZone(viewZoneData);
				if (newPosition) return MouseTarget.createOutsideEditor(mouseColumn, newPosition, "above", outsideDistance);
			}
			const aboveLineNumber = viewLayout.getLineNumberAtVerticalOffset(verticalOffset);
			return MouseTarget.createOutsideEditor(mouseColumn, new Position$1(aboveLineNumber, 1), "above", outsideDistance);
		}
		if (e.posy > editorContent.y + editorContent.height) {
			const outsideDistance = e.posy - editorContent.y - editorContent.height;
			const verticalOffset = viewLayout.getCurrentScrollTop() + e.relativePos.y;
			const viewZoneData = HitTestContext.getZoneAtCoord(this._context, verticalOffset);
			if (viewZoneData) {
				const newPosition = this._helpPositionJumpOverViewZone(viewZoneData);
				if (newPosition) return MouseTarget.createOutsideEditor(mouseColumn, newPosition, "below", outsideDistance);
			}
			const belowLineNumber = viewLayout.getLineNumberAtVerticalOffset(verticalOffset);
			return MouseTarget.createOutsideEditor(mouseColumn, new Position$1(belowLineNumber, model.getLineMaxColumn(belowLineNumber)), "below", outsideDistance);
		}
		const possibleLineNumber = viewLayout.getLineNumberAtVerticalOffset(viewLayout.getCurrentScrollTop() + e.relativePos.y);
		const layoutInfo = this._context.configuration.options.get(166);
		const xLeftBoundary = layoutInfo.contentLeft;
		if (e.relativePos.x <= xLeftBoundary) {
			const outsideDistance = xLeftBoundary - e.relativePos.x;
			const isRtl = model.getTextDirection(possibleLineNumber) === TextDirection.RTL;
			return MouseTarget.createOutsideEditor(mouseColumn, new Position$1(possibleLineNumber, isRtl ? model.getLineMaxColumn(possibleLineNumber) : 1), "left", outsideDistance);
		}
		const xRightBoundary = layoutInfo.minimap.minimapLeft === 0 ? layoutInfo.width - layoutInfo.verticalScrollbarWidth : layoutInfo.minimap.minimapLeft;
		if (e.relativePos.x >= xRightBoundary) {
			const outsideDistance = e.relativePos.x - xRightBoundary;
			const isRtl = model.getTextDirection(possibleLineNumber) === TextDirection.RTL;
			return MouseTarget.createOutsideEditor(mouseColumn, new Position$1(possibleLineNumber, isRtl ? 1 : model.getLineMaxColumn(possibleLineNumber)), "right", outsideDistance);
		}
		return null;
	}
	_findMousePosition(e, testEventTarget) {
		const positionOutsideEditor = this._getPositionOutsideEditor(e);
		if (positionOutsideEditor) return positionOutsideEditor;
		const t = this._createMouseTarget(e, testEventTarget);
		if (!t.position) return null;
		if (t.type === 8 || t.type === 5) {
			const newPosition = this._helpPositionJumpOverViewZone(t.detail);
			if (newPosition) return MouseTarget.createViewZone(t.type, t.element, t.mouseColumn, newPosition, t.detail);
		}
		return t;
	}
	_helpPositionJumpOverViewZone(viewZoneData) {
		const selectionStart = new Position$1(this._currentSelection.selectionStartLineNumber, this._currentSelection.selectionStartColumn);
		const positionBefore = viewZoneData.positionBefore;
		const positionAfter = viewZoneData.positionAfter;
		if (positionBefore && positionAfter) {
			if (positionBefore.isBefore(selectionStart)) return positionBefore;
			else return positionAfter;
		}
		return null;
	}
	_dispatchMouse(position, inSelectionMode, revealType) {
		if (!position.position) return;
		this._viewController.dispatchMouse({
			position: position.position,
			mouseColumn: position.mouseColumn,
			startedOnLineNumbers: this._mouseState.startedOnLineNumbers,
			revealType,
			inSelectionMode,
			mouseDownCount: this._mouseState.count,
			altKey: this._mouseState.altKey,
			ctrlKey: this._mouseState.ctrlKey,
			metaKey: this._mouseState.metaKey,
			shiftKey: this._mouseState.shiftKey,
			leftButton: this._mouseState.leftButton,
			middleButton: this._mouseState.middleButton,
			onInjectedText: position.type === 6 && position.detail.injectedText !== null
		});
	}
};
var MouseDownState = class MouseDownState {
	static {
		this.CLEAR_MOUSE_DOWN_COUNT_TIME = 400;
	}
	get altKey() {
		return this._altKey;
	}
	get ctrlKey() {
		return this._ctrlKey;
	}
	get metaKey() {
		return this._metaKey;
	}
	get shiftKey() {
		return this._shiftKey;
	}
	get leftButton() {
		return this._leftButton;
	}
	get middleButton() {
		return this._middleButton;
	}
	get startedOnLineNumbers() {
		return this._startedOnLineNumbers;
	}
	constructor() {
		this._altKey = false;
		this._ctrlKey = false;
		this._metaKey = false;
		this._shiftKey = false;
		this._leftButton = false;
		this._middleButton = false;
		this._startedOnLineNumbers = false;
		this._lastMouseDownPosition = null;
		this._lastMouseDownPositionEqualCount = 0;
		this._lastMouseDownCount = 0;
		this._lastSetMouseDownCountTime = 0;
		this.isDragAndDrop = false;
	}
	get count() {
		return this._lastMouseDownCount;
	}
	setModifiers(source) {
		this._altKey = source.altKey;
		this._ctrlKey = source.ctrlKey;
		this._metaKey = source.metaKey;
		this._shiftKey = source.shiftKey;
	}
	setStartButtons(source) {
		this._leftButton = source.leftButton;
		this._middleButton = source.middleButton;
	}
	setStartedOnLineNumbers(startedOnLineNumbers) {
		this._startedOnLineNumbers = startedOnLineNumbers;
	}
	trySetCount(setMouseDownCount, newMouseDownPosition) {
		const currentTime = (/* @__PURE__ */ new Date()).getTime();
		if (currentTime - this._lastSetMouseDownCountTime > MouseDownState.CLEAR_MOUSE_DOWN_COUNT_TIME) setMouseDownCount = 1;
		this._lastSetMouseDownCountTime = currentTime;
		if (setMouseDownCount > this._lastMouseDownCount + 1) setMouseDownCount = this._lastMouseDownCount + 1;
		if (this._lastMouseDownPosition && this._lastMouseDownPosition.equals(newMouseDownPosition)) this._lastMouseDownPositionEqualCount++;
		else this._lastMouseDownPositionEqualCount = 1;
		this._lastMouseDownPosition = newMouseDownPosition;
		this._lastMouseDownCount = Math.min(setMouseDownCount, this._lastMouseDownPositionEqualCount);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/event.js
var DomEmitter = class {
	get event() {
		return this.emitter.event;
	}
	constructor(element, type, useCapture) {
		const fn = (e) => this.emitter.fire(e);
		this.emitter = new Emitter$1({
			onWillAddFirstListener: () => element.addEventListener(type, fn, useCapture),
			onDidRemoveLastListener: () => element.removeEventListener(type, fn, useCapture)
		});
	}
	dispose() {
		this.emitter.dispose();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/uuid.js
var generateUuid = (function() {
	if (typeof crypto.randomUUID === "function") return crypto.randomUUID.bind(crypto);
	const _data = /* @__PURE__ */ new Uint8Array(16);
	const _hex = [];
	for (let i = 0; i < 256; i++) _hex.push(i.toString(16).padStart(2, "0"));
	return function generateUuid() {
		crypto.getRandomValues(_data);
		_data[6] = _data[6] & 15 | 64;
		_data[8] = _data[8] & 63 | 128;
		let i = 0;
		let result = "";
		result += _hex[_data[i++]];
		result += _hex[_data[i++]];
		result += _hex[_data[i++]];
		result += _hex[_data[i++]];
		result += "-";
		result += _hex[_data[i++]];
		result += _hex[_data[i++]];
		result += "-";
		result += _hex[_data[i++]];
		result += _hex[_data[i++]];
		result += "-";
		result += _hex[_data[i++]];
		result += _hex[_data[i++]];
		result += "-";
		result += _hex[_data[i++]];
		result += _hex[_data[i++]];
		result += _hex[_data[i++]];
		result += _hex[_data[i++]];
		result += _hex[_data[i++]];
		result += _hex[_data[i++]];
		return result;
	};
})();
/** Namespace should be 3 letters, e.g. `abc-<uuid>`. */
function prefixedUuid(namespace) {
	return `${namespace}-${generateUuid()}`;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/dnd.js
var DataTransfers = {
	/**
	* Application specific resource transfer type
	*/
	RESOURCES: "ResourceURLs",
	/**
	* Typically transfer type for copy/paste transfers.
	*/
	TEXT: Mimes.text,
	/**
	* Internal type used to pass around text/uri-list data.
	*
	* This is needed to work around https://bugs.chromium.org/p/chromium/issues/detail?id=239745.
	*/
	INTERNAL_URI_LIST: "application/vnd.code.uri-list"
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/dataTransfer.js
function createStringDataTransferItem(stringOrPromise, id) {
	return {
		id,
		asString: async () => stringOrPromise,
		asFile: () => void 0,
		value: typeof stringOrPromise === "string" ? stringOrPromise : void 0
	};
}
function createFileDataTransferItem(fileName, uri, data, id) {
	const file = {
		id: generateUuid(),
		name: fileName,
		uri,
		data
	};
	return {
		id,
		asString: async () => "",
		asFile: () => file,
		value: void 0
	};
}
var VSDataTransfer = class {
	constructor() {
		this._entries = /* @__PURE__ */ new Map();
	}
	get size() {
		let size = 0;
		for (const _ of this._entries) size++;
		return size;
	}
	has(mimeType) {
		return this._entries.has(this.toKey(mimeType));
	}
	matches(pattern) {
		const mimes = [...this._entries.keys()];
		if (Iterable.some(this, ([_, item]) => item.asFile())) mimes.push("files");
		return matchesMimeType_normalized(normalizeMimeType(pattern), mimes);
	}
	get(mimeType) {
		return this._entries.get(this.toKey(mimeType))?.[0];
	}
	/**
	* Add a new entry to this data transfer.
	*
	* This does not replace existing entries for `mimeType`.
	*/
	append(mimeType, value) {
		const existing = this._entries.get(mimeType);
		if (existing) existing.push(value);
		else this._entries.set(this.toKey(mimeType), [value]);
	}
	/**
	* Set the entry for a given mime type.
	*
	* This replaces all existing entries for `mimeType`.
	*/
	replace(mimeType, value) {
		this._entries.set(this.toKey(mimeType), [value]);
	}
	/**
	* Remove all entries for `mimeType`.
	*/
	delete(mimeType) {
		this._entries.delete(this.toKey(mimeType));
	}
	/**
	* Iterate over all `[mime, item]` pairs in this data transfer.
	*
	* There may be multiple entries for each mime type.
	*/
	*[Symbol.iterator]() {
		for (const [mine, items] of this._entries) for (const item of items) yield [mine, item];
	}
	toKey(mimeType) {
		return normalizeMimeType(mimeType);
	}
};
function normalizeMimeType(mimeType) {
	return mimeType.toLowerCase();
}
function matchesMimeType(pattern, mimeTypes) {
	return matchesMimeType_normalized(normalizeMimeType(pattern), mimeTypes.map(normalizeMimeType));
}
function matchesMimeType_normalized(normalizedPattern, normalizedMimeTypes) {
	if (normalizedPattern === "*/*") return normalizedMimeTypes.length > 0;
	if (normalizedMimeTypes.includes(normalizedPattern)) return true;
	const wildcard = normalizedPattern.match(/^([a-z]+)\/([a-z]+|\*)$/i);
	if (!wildcard) return false;
	const [_, type, subtype] = wildcard;
	if (subtype === "*") return normalizedMimeTypes.some((mime) => mime.startsWith(type + "/"));
	return false;
}
var UriList = Object.freeze({
	create: (entries) => {
		return distinct(entries.map((x) => x.toString())).join("\r\n");
	},
	split: (str) => {
		return str.split("\r\n");
	},
	parse: (str) => {
		return UriList.split(str).filter((value) => !value.startsWith("#"));
	}
});
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/dnd/browser/dnd.js
var CodeDataTransfers = {
	EDITORS: "CodeEditors",
	FILES: "CodeFiles"
};
var DragAndDropContributionRegistry = class {};
Registry.add({ DragAndDropContribution: "workbench.contributions.dragAndDrop" }.DragAndDropContribution, new DragAndDropContributionRegistry());
/**
* A singleton to store transfer data during drag & drop operations that are only valid within the application.
*/
var LocalSelectionTransfer = class LocalSelectionTransfer {
	static {
		this.INSTANCE = new LocalSelectionTransfer();
	}
	constructor() {}
	static getInstance() {
		return LocalSelectionTransfer.INSTANCE;
	}
	hasData(proto) {
		return proto && proto === this.proto;
	}
	getData(proto) {
		if (this.hasData(proto)) return this.data;
	}
};
/**
* A helper to get access to Electrons `webUtils.getPathForFile` function
* in a safe way without crashing the application when running in the web.
*/
function getPathForFile(file) {
	if (isNative && typeof globalThis.vscode?.webUtils?.getPathForFile === "function") return globalThis.vscode?.webUtils?.getPathForFile(file);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/dataTransfer.js
function toVSDataTransfer(dataTransfer) {
	const vsDataTransfer = new VSDataTransfer();
	for (const item of dataTransfer.items) {
		const type = item.type;
		if (item.kind === "string") {
			const asStringValue = new Promise((resolve) => item.getAsString(resolve));
			vsDataTransfer.append(type, createStringDataTransferItem(asStringValue));
		} else if (item.kind === "file") {
			const file = item.getAsFile();
			if (file) vsDataTransfer.append(type, createFileDataTransferItemFromFile(file));
		}
	}
	return vsDataTransfer;
}
function createFileDataTransferItemFromFile(file) {
	const path = getPathForFile(file);
	const uri = path ? URI.parse(path) : void 0;
	return createFileDataTransferItem(file.name, uri, async () => {
		return new Uint8Array(await file.arrayBuffer());
	});
}
var INTERNAL_DND_MIME_TYPES = Object.freeze([
	CodeDataTransfers.EDITORS,
	CodeDataTransfers.FILES,
	DataTransfers.RESOURCES,
	DataTransfers.INTERNAL_URI_LIST
]);
function toExternalVSDataTransfer(sourceDataTransfer, overwriteUriList = false) {
	const vsDataTransfer = toVSDataTransfer(sourceDataTransfer);
	const uriList = vsDataTransfer.get(DataTransfers.INTERNAL_URI_LIST);
	if (uriList) vsDataTransfer.replace(Mimes.uriList, uriList);
	else if (overwriteUriList || !vsDataTransfer.has(Mimes.uriList)) {
		const editorData = [];
		for (const item of sourceDataTransfer.items) {
			const file = item.getAsFile();
			if (file) {
				const path = getPathForFile(file);
				try {
					if (path) editorData.push(URI.file(path).toString());
					else editorData.push(URI.parse(file.name, true).toString());
				} catch {}
			}
		}
		if (editorData.length) vsDataTransfer.replace(Mimes.uriList, createStringDataTransferItem(UriList.create(editorData)));
	}
	for (const internal of INTERNAL_DND_MIME_TYPES) vsDataTransfer.delete(internal);
	return vsDataTransfer;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/controller/editContext/clipboardUtils.js
function generateDataToCopyAndStoreInMemory(viewModel, id, isFirefox) {
	const { dataToCopy, metadata } = generateDataToCopy(viewModel);
	storeMetadataInMemory(dataToCopy.text, metadata, isFirefox);
	return {
		dataToCopy,
		metadata
	};
}
function storeMetadataInMemory(textToCopy, metadata, isFirefox) {
	InMemoryClipboardMetadataManager.INSTANCE.set(isFirefox ? textToCopy.replace(/\r\n/g, "\n") : textToCopy, metadata);
}
function generateDataToCopy(viewModel) {
	const emptySelectionClipboard = viewModel.getEditorOption(45);
	const copyWithSyntaxHighlighting = viewModel.getEditorOption(31);
	const dataToCopy = getDataToCopy(viewModel, viewModel.getCursorStates().map((cursorState) => cursorState.modelState.selection), emptySelectionClipboard, copyWithSyntaxHighlighting);
	return {
		dataToCopy,
		metadata: {
			version: 1,
			id: generateUuid(),
			isFromEmptySelection: dataToCopy.isFromEmptySelection,
			multicursorText: dataToCopy.multicursorText,
			mode: dataToCopy.mode
		}
	};
}
function getDataToCopy(viewModel, modelSelections, emptySelectionClipboard, copyWithSyntaxHighlighting) {
	const { sourceRanges, sourceText } = viewModel.getPlainTextToCopy(modelSelections, emptySelectionClipboard, isWindows);
	const newLineCharacter = viewModel.model.getEOL();
	const isFromEmptySelection = emptySelectionClipboard && modelSelections.length === 1 && modelSelections[0].isEmpty();
	const multicursorText = Array.isArray(sourceText) ? sourceText : null;
	const text = Array.isArray(sourceText) ? sourceText.join(newLineCharacter) : sourceText;
	let html = void 0;
	let mode = null;
	if (CopyOptions.forceCopyWithSyntaxHighlighting || copyWithSyntaxHighlighting && sourceText.length < 65536) {
		const richText = viewModel.getRichTextToCopy(modelSelections, emptySelectionClipboard);
		if (richText) {
			html = richText.html;
			mode = richText.mode;
		}
	}
	return {
		isFromEmptySelection,
		sourceRanges,
		multicursorText,
		text,
		html,
		mode
	};
}
/**
* Every time we write to the clipboard, we record a bit of extra metadata here.
* Every time we read from the cipboard, if the text matches our last written text,
* we can fetch the previous metadata.
*/
var InMemoryClipboardMetadataManager = class InMemoryClipboardMetadataManager {
	static {
		this.INSTANCE = new InMemoryClipboardMetadataManager();
	}
	constructor() {
		this._lastState = null;
	}
	set(lastCopiedValue, data) {
		this._lastState = {
			lastCopiedValue,
			data
		};
	}
	get(pastedText) {
		if (this._lastState && this._lastState.lastCopiedValue === pastedText) return this._lastState.data;
		this._lastState = null;
		return null;
	}
};
var CopyOptions = {
	forceCopyWithSyntaxHighlighting: false,
	electronBugWorkaroundCopyEventHasFired: false
};
var ClipboardEventUtils = {
	getTextData(clipboardData) {
		const text = clipboardData.getData(Mimes.text);
		let metadata = null;
		const rawmetadata = clipboardData.getData("vscode-editor-data");
		if (typeof rawmetadata === "string") try {
			metadata = JSON.parse(rawmetadata);
			if (metadata.version !== 1) metadata = null;
		} catch (err) {}
		if (text.length === 0 && metadata === null && clipboardData.files.length > 0) return [Array.prototype.slice.call(clipboardData.files, 0).map((file) => file.name).join("\n"), null];
		return [text, metadata];
	},
	setTextData(clipboardData, text, html, metadata) {
		clipboardData.setData(Mimes.text, text);
		if (typeof html === "string") clipboardData.setData("text/html", html);
		clipboardData.setData("vscode-editor-data", JSON.stringify(metadata));
	}
};
/**
* Creates an IClipboardCopyEvent from a DOM ClipboardEvent.
*/
function createClipboardCopyEvent(e, isCut, context, logService, isFirefox) {
	const { dataToCopy, metadata } = generateDataToCopy(context.viewModel);
	let handled = false;
	return {
		isCut,
		clipboardData: { setData: (type, value) => {
			e.clipboardData?.setData(type, value);
		} },
		dataToCopy,
		ensureClipboardGetsEditorData: () => {
			e.preventDefault();
			if (e.clipboardData) ClipboardEventUtils.setTextData(e.clipboardData, dataToCopy.text, dataToCopy.html, metadata);
			storeMetadataInMemory(dataToCopy.text, metadata, isFirefox);
			logService.trace("ensureClipboardGetsEditorSelection with id : ", metadata.id, " with text.length: ", dataToCopy.text.length);
		},
		setHandled: () => {
			handled = true;
			e.preventDefault();
			e.stopImmediatePropagation();
		},
		get isHandled() {
			return handled;
		}
	};
}
/**
* Creates an IClipboardPasteEvent from a DOM ClipboardEvent.
*/
function createClipboardPasteEvent(e) {
	let handled = false;
	let [text, metadata] = e.clipboardData ? ClipboardEventUtils.getTextData(e.clipboardData) : ["", null];
	metadata = metadata || InMemoryClipboardMetadataManager.INSTANCE.get(text);
	return {
		clipboardData: createReadableClipboardData(e.clipboardData),
		metadata,
		text,
		toExternalVSDataTransfer: () => e.clipboardData ? toExternalVSDataTransfer(e.clipboardData) : void 0,
		browserEvent: e,
		setHandled: () => {
			handled = true;
			e.preventDefault();
			e.stopImmediatePropagation();
		},
		get isHandled() {
			return handled;
		}
	};
}
function createReadableClipboardData(dataTransfer) {
	return {
		types: Array.from(dataTransfer?.types ?? []),
		files: Array.prototype.slice.call(dataTransfer?.files ?? [], 0),
		getData: (type) => dataTransfer?.getData(type) ?? ""
	};
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/controller/editContext/textArea/textAreaEditContextState.js
var TextAreaState = class TextAreaState {
	static {
		this.EMPTY = new TextAreaState("", 0, 0, null, void 0);
	}
	constructor(value, selectionStart, selectionEnd, selection, newlineCountBeforeSelection) {
		this.value = value;
		this.selectionStart = selectionStart;
		this.selectionEnd = selectionEnd;
		this.selection = selection;
		this.newlineCountBeforeSelection = newlineCountBeforeSelection;
	}
	toString() {
		return `[ <${this.value}>, selectionStart: ${this.selectionStart}, selectionEnd: ${this.selectionEnd}]`;
	}
	static readFromTextArea(textArea, previousState) {
		const value = textArea.getValue();
		const selectionStart = textArea.getSelectionStart();
		const selectionEnd = textArea.getSelectionEnd();
		let newlineCountBeforeSelection = void 0;
		if (previousState) {
			if (value.substring(0, selectionStart) === previousState.value.substring(0, previousState.selectionStart)) newlineCountBeforeSelection = previousState.newlineCountBeforeSelection;
		}
		return new TextAreaState(value, selectionStart, selectionEnd, null, newlineCountBeforeSelection);
	}
	collapseSelection() {
		if (this.selectionStart === this.value.length) return this;
		return new TextAreaState(this.value, this.value.length, this.value.length, null, void 0);
	}
	isWrittenToTextArea(textArea, select) {
		const valuesEqual = this.value === textArea.getValue();
		if (!select) return valuesEqual;
		return this.selectionStart === textArea.getSelectionStart() && this.selectionEnd === textArea.getSelectionEnd() && valuesEqual;
	}
	writeToTextArea(reason, textArea, select) {
		textArea.setValue(reason, this.value);
		if (select) textArea.setSelectionRange(reason, this.selectionStart, this.selectionEnd);
	}
	deduceEditorPosition(offset) {
		if (offset <= this.selectionStart) {
			const str = this.value.substring(offset, this.selectionStart);
			return this._finishDeduceEditorPosition(this.selection?.getStartPosition() ?? null, str, -1);
		}
		if (offset >= this.selectionEnd) {
			const str = this.value.substring(this.selectionEnd, offset);
			return this._finishDeduceEditorPosition(this.selection?.getEndPosition() ?? null, str, 1);
		}
		const str1 = this.value.substring(this.selectionStart, offset);
		if (str1.indexOf(String.fromCharCode(8230)) === -1) return this._finishDeduceEditorPosition(this.selection?.getStartPosition() ?? null, str1, 1);
		const str2 = this.value.substring(offset, this.selectionEnd);
		return this._finishDeduceEditorPosition(this.selection?.getEndPosition() ?? null, str2, -1);
	}
	_finishDeduceEditorPosition(anchor, deltaText, signum) {
		let lineFeedCnt = 0;
		let lastLineFeedIndex = -1;
		while ((lastLineFeedIndex = deltaText.indexOf("\n", lastLineFeedIndex + 1)) !== -1) lineFeedCnt++;
		return [
			anchor,
			signum * deltaText.length,
			lineFeedCnt
		];
	}
	static deduceInput(previousState, currentState, couldBeEmojiInput) {
		if (!previousState) return {
			text: "",
			replacePrevCharCnt: 0,
			replaceNextCharCnt: 0,
			positionDelta: 0
		};
		const prefixLength = Math.min(commonPrefixLength(previousState.value, currentState.value), previousState.selectionStart, currentState.selectionStart);
		const suffixLength = Math.min(commonSuffixLength(previousState.value, currentState.value), previousState.value.length - previousState.selectionEnd, currentState.value.length - currentState.selectionEnd);
		previousState.value.substring(prefixLength, previousState.value.length - suffixLength);
		const currentValue = currentState.value.substring(prefixLength, currentState.value.length - suffixLength);
		const previousSelectionStart = previousState.selectionStart - prefixLength;
		const previousSelectionEnd = previousState.selectionEnd - prefixLength;
		if (currentState.selectionStart - prefixLength === currentState.selectionEnd - prefixLength) return {
			text: currentValue,
			replacePrevCharCnt: previousState.selectionStart - prefixLength,
			replaceNextCharCnt: 0,
			positionDelta: 0
		};
		return {
			text: currentValue,
			replacePrevCharCnt: previousSelectionEnd - previousSelectionStart,
			replaceNextCharCnt: 0,
			positionDelta: 0
		};
	}
	static deduceAndroidCompositionInput(previousState, currentState) {
		if (!previousState) return {
			text: "",
			replacePrevCharCnt: 0,
			replaceNextCharCnt: 0,
			positionDelta: 0
		};
		if (previousState.value === currentState.value) return {
			text: "",
			replacePrevCharCnt: 0,
			replaceNextCharCnt: 0,
			positionDelta: currentState.selectionEnd - previousState.selectionEnd
		};
		const prefixLength = Math.min(commonPrefixLength(previousState.value, currentState.value), previousState.selectionEnd);
		const suffixLength = Math.min(commonSuffixLength(previousState.value, currentState.value), previousState.value.length - previousState.selectionEnd);
		const previousValue = previousState.value.substring(prefixLength, previousState.value.length - suffixLength);
		const currentValue = currentState.value.substring(prefixLength, currentState.value.length - suffixLength);
		previousState.selectionStart - prefixLength;
		const previousSelectionEnd = previousState.selectionEnd - prefixLength;
		currentState.selectionStart - prefixLength;
		const currentSelectionEnd = currentState.selectionEnd - prefixLength;
		return {
			text: currentValue,
			replacePrevCharCnt: previousSelectionEnd,
			replaceNextCharCnt: previousValue.length - previousSelectionEnd,
			positionDelta: currentSelectionEnd - currentValue.length
		};
	}
	static fromScreenReaderContentState(screenReaderContentState) {
		let selectionStart;
		let selectionEnd;
		switch (screenReaderContentState.selection.getDirection()) {
			case 0:
				selectionStart = screenReaderContentState.selectionStart;
				selectionEnd = screenReaderContentState.selectionEnd;
				break;
			case 1:
				selectionStart = screenReaderContentState.selectionEnd;
				selectionEnd = screenReaderContentState.selectionStart;
		}
		return new TextAreaState(screenReaderContentState.value, selectionStart, selectionEnd, screenReaderContentState.selection, screenReaderContentState.newlineCountBeforeSelection);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/controller/editContext/textArea/textAreaEditContextInput.js
var __decorate$74 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$68 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var TextAreaSyntethicEvents;
(function(TextAreaSyntethicEvents) {
	TextAreaSyntethicEvents.Tap = "-monaco-textarea-synthetic-tap";
})(TextAreaSyntethicEvents || (TextAreaSyntethicEvents = {}));
var CompositionContext = class {
	constructor() {
		this._lastTypeTextLength = 0;
	}
	handleCompositionUpdate(text) {
		text = text || "";
		const typeInput = {
			text,
			replacePrevCharCnt: this._lastTypeTextLength,
			replaceNextCharCnt: 0,
			positionDelta: 0
		};
		this._lastTypeTextLength = text.length;
		return typeInput;
	}
};
/**
* Writes screen reader content to the textarea and is able to analyze its input events to generate:
*  - onCut
*  - onPaste
*  - onType
*
* Composition events are generated for presentation purposes (composition input is reflected in onType).
*/
var TextAreaInput = class TextAreaInput extends Disposable {
	get textAreaState() {
		return this._textAreaState;
	}
	constructor(_host, _textArea, _OS, _browser, _accessibilityService, _logService) {
		super();
		this._host = _host;
		this._textArea = _textArea;
		this._OS = _OS;
		this._browser = _browser;
		this._accessibilityService = _accessibilityService;
		this._logService = _logService;
		this._onFocus = this._register(new Emitter$1());
		this.onFocus = this._onFocus.event;
		this._onBlur = this._register(new Emitter$1());
		this.onBlur = this._onBlur.event;
		this._onKeyDown = this._register(new Emitter$1());
		this.onKeyDown = this._onKeyDown.event;
		this._onKeyUp = this._register(new Emitter$1());
		this.onKeyUp = this._onKeyUp.event;
		this._onCut = this._register(new Emitter$1());
		this.onCut = this._onCut.event;
		this._onPaste = this._register(new Emitter$1());
		this.onPaste = this._onPaste.event;
		this._onWillCopy = this._register(new Emitter$1());
		this.onWillCopy = this._onWillCopy.event;
		this._onWillCut = this._register(new Emitter$1());
		this.onWillCut = this._onWillCut.event;
		this._onWillPaste = this._register(new Emitter$1());
		this.onWillPaste = this._onWillPaste.event;
		this._onType = this._register(new Emitter$1());
		this.onType = this._onType.event;
		this._onCompositionStart = this._register(new Emitter$1());
		this.onCompositionStart = this._onCompositionStart.event;
		this._onCompositionUpdate = this._register(new Emitter$1());
		this.onCompositionUpdate = this._onCompositionUpdate.event;
		this._onCompositionEnd = this._register(new Emitter$1());
		this.onCompositionEnd = this._onCompositionEnd.event;
		this._onSelectionChangeRequest = this._register(new Emitter$1());
		this.onSelectionChangeRequest = this._onSelectionChangeRequest.event;
		this._asyncFocusGainWriteScreenReaderContent = this._register(new MutableDisposable());
		this._asyncTriggerCut = this._register(new RunOnceScheduler(() => this._onCut.fire(), 0));
		this._textAreaState = TextAreaState.EMPTY;
		this._selectionChangeListener = null;
		if (this._accessibilityService.isScreenReaderOptimized()) this.writeNativeTextAreaContent("ctor");
		this._register(Event.runAndSubscribe(this._accessibilityService.onDidChangeScreenReaderOptimized, () => {
			if (this._accessibilityService.isScreenReaderOptimized() && !this._asyncFocusGainWriteScreenReaderContent.value) this._asyncFocusGainWriteScreenReaderContent.value = new RunOnceScheduler(() => this.writeNativeTextAreaContent("asyncFocusGain"), 0);
			else this._asyncFocusGainWriteScreenReaderContent.clear();
		}));
		this._hasFocus = false;
		this._currentComposition = null;
		let lastKeyDown = null;
		this._register(this._textArea.onKeyDown((_e) => {
			const e = new StandardKeyboardEvent(_e);
			if (e.keyCode === 114 || this._currentComposition && e.keyCode === 1) e.stopPropagation();
			if (e.equals(9)) e.preventDefault();
			lastKeyDown = e;
			this._onKeyDown.fire(e);
		}));
		this._register(this._textArea.onKeyUp((_e) => {
			const e = new StandardKeyboardEvent(_e);
			this._onKeyUp.fire(e);
		}));
		this._register(this._textArea.onCompositionStart((e) => {
			const currentComposition = new CompositionContext();
			if (this._currentComposition) {
				this._currentComposition = currentComposition;
				return;
			}
			this._currentComposition = currentComposition;
			if (this._OS === 2 && lastKeyDown && lastKeyDown.equals(114) && this._textAreaState.selectionStart === this._textAreaState.selectionEnd && this._textAreaState.selectionStart > 0 && this._textAreaState.value.substr(this._textAreaState.selectionStart - 1, 1) === e.data && (lastKeyDown.code === "ArrowRight" || lastKeyDown.code === "ArrowLeft")) {
				currentComposition.handleCompositionUpdate("x");
				this._onCompositionStart.fire({ data: e.data });
				return;
			}
			if (this._browser.isAndroid) {
				this._onCompositionStart.fire({ data: e.data });
				return;
			}
			this._onCompositionStart.fire({ data: e.data });
		}));
		this._register(this._textArea.onCompositionUpdate((e) => {
			const currentComposition = this._currentComposition;
			if (!currentComposition) return;
			if (this._browser.isAndroid) {
				const newState = TextAreaState.readFromTextArea(this._textArea, this._textAreaState);
				const typeInput = TextAreaState.deduceAndroidCompositionInput(this._textAreaState, newState);
				this._textAreaState = newState;
				this._onType.fire(typeInput);
				this._onCompositionUpdate.fire(e);
				return;
			}
			const typeInput = currentComposition.handleCompositionUpdate(e.data);
			this._textAreaState = TextAreaState.readFromTextArea(this._textArea, this._textAreaState);
			this._onType.fire(typeInput);
			this._onCompositionUpdate.fire(e);
		}));
		this._register(this._textArea.onCompositionEnd((e) => {
			const currentComposition = this._currentComposition;
			if (!currentComposition) return;
			this._currentComposition = null;
			if (this._browser.isAndroid) {
				const newState = TextAreaState.readFromTextArea(this._textArea, this._textAreaState);
				const typeInput = TextAreaState.deduceAndroidCompositionInput(this._textAreaState, newState);
				this._textAreaState = newState;
				this._onType.fire(typeInput);
				this._onCompositionEnd.fire();
				return;
			}
			const typeInput = currentComposition.handleCompositionUpdate(e.data);
			this._textAreaState = TextAreaState.readFromTextArea(this._textArea, this._textAreaState);
			this._onType.fire(typeInput);
			this._onCompositionEnd.fire();
		}));
		this._register(this._textArea.onInput((e) => {
			this._textArea.setIgnoreSelectionChangeTime("received input event");
			if (this._currentComposition) return;
			const newState = TextAreaState.readFromTextArea(this._textArea, this._textAreaState);
			const typeInput = TextAreaState.deduceInput(this._textAreaState, newState, this._OS === 2);
			if (typeInput.replacePrevCharCnt === 0 && typeInput.text.length === 1) {
				if (isHighSurrogate(typeInput.text.charCodeAt(0)) || typeInput.text.charCodeAt(0) === 127) return;
			}
			this._textAreaState = newState;
			if (typeInput.text !== "" || typeInput.replacePrevCharCnt !== 0 || typeInput.replaceNextCharCnt !== 0 || typeInput.positionDelta !== 0) {
				if (e.inputType === "insertFromPaste") this._onPaste.fire({
					text: typeInput.text,
					metadata: InMemoryClipboardMetadataManager.INSTANCE.get(typeInput.text)
				});
				else this._onType.fire(typeInput);
			}
		}));
		this._register(this._textArea.onCut((e) => {
			this._logService.trace(`TextAreaInput#onCut`, e);
			const cutEvent = createClipboardCopyEvent(e, true, this._host.context, this._logService, this._browser.isFirefox);
			this._onWillCut.fire(cutEvent);
			if (cutEvent.isHandled) return;
			this._textArea.setIgnoreSelectionChangeTime("received cut event");
			cutEvent.ensureClipboardGetsEditorData();
			this._asyncTriggerCut.schedule();
		}));
		this._register(this._textArea.onCopy((e) => {
			this._logService.trace(`TextAreaInput#onCopy`, e);
			CopyOptions.electronBugWorkaroundCopyEventHasFired = true;
			const copyEvent = createClipboardCopyEvent(e, false, this._host.context, this._logService, this._browser.isFirefox);
			this._onWillCopy.fire(copyEvent);
			if (copyEvent.isHandled) return;
			copyEvent.ensureClipboardGetsEditorData();
		}));
		this._register(this._textArea.onPaste((e) => {
			this._logService.trace(`TextAreaInput#onPaste`, e);
			const pasteEvent = createClipboardPasteEvent(e);
			this._onWillPaste.fire(pasteEvent);
			if (pasteEvent.isHandled) return;
			this._textArea.setIgnoreSelectionChangeTime("received paste event");
			e.preventDefault();
			this._logService.trace(`TextAreaInput#onPaste with id : `, pasteEvent.metadata?.id, " with text.length: ", pasteEvent.text.length);
			if (!pasteEvent.text) return;
			this._logService.trace(`TextAreaInput#onPaste (before onPaste)`);
			this._onPaste.fire({
				text: pasteEvent.text,
				metadata: pasteEvent.metadata
			});
		}));
		this._register(this._textArea.onFocus(() => {
			const hadFocus = this._hasFocus;
			this._setHasFocus(true);
			if (this._accessibilityService.isScreenReaderOptimized() && this._browser.isSafari && !hadFocus && this._hasFocus) {
				if (!this._asyncFocusGainWriteScreenReaderContent.value) this._asyncFocusGainWriteScreenReaderContent.value = new RunOnceScheduler(() => this.writeNativeTextAreaContent("asyncFocusGain"), 0);
				this._asyncFocusGainWriteScreenReaderContent.value.schedule();
			}
		}));
		this._register(this._textArea.onBlur(() => {
			if (this._currentComposition) {
				this._currentComposition = null;
				this.writeNativeTextAreaContent("blurWithoutCompositionEnd");
				this._onCompositionEnd.fire();
			}
			this._setHasFocus(false);
		}));
		this._register(this._textArea.onSyntheticTap(() => {
			if (this._browser.isAndroid && this._currentComposition) {
				this._currentComposition = null;
				this.writeNativeTextAreaContent("tapWithoutCompositionEnd");
				this._onCompositionEnd.fire();
			}
		}));
	}
	_installSelectionChangeListener() {
		let previousSelectionChangeEventTime = 0;
		return addDisposableListener(this._textArea.ownerDocument, "selectionchange", (e) => {
			inputLatency.onSelectionChange();
			if (!this._hasFocus) return;
			if (this._currentComposition) return;
			if (!this._browser.isChrome) return;
			const now = Date.now();
			const delta1 = now - previousSelectionChangeEventTime;
			previousSelectionChangeEventTime = now;
			if (delta1 < 5) return;
			const delta2 = now - this._textArea.getIgnoreSelectionChangeTime();
			this._textArea.resetSelectionChangeTime();
			if (delta2 < 100) return;
			if (!this._textAreaState.selection) return;
			const newValue = this._textArea.getValue();
			if (this._textAreaState.value !== newValue) return;
			const newSelectionStart = this._textArea.getSelectionStart();
			const newSelectionEnd = this._textArea.getSelectionEnd();
			if (this._textAreaState.selectionStart === newSelectionStart && this._textAreaState.selectionEnd === newSelectionEnd) return;
			const _newSelectionStartPosition = this._textAreaState.deduceEditorPosition(newSelectionStart);
			const newSelectionStartPosition = this._host.deduceModelPosition(_newSelectionStartPosition[0], _newSelectionStartPosition[1], _newSelectionStartPosition[2]);
			const _newSelectionEndPosition = this._textAreaState.deduceEditorPosition(newSelectionEnd);
			const newSelectionEndPosition = this._host.deduceModelPosition(_newSelectionEndPosition[0], _newSelectionEndPosition[1], _newSelectionEndPosition[2]);
			const newSelection = new Selection$1(newSelectionStartPosition.lineNumber, newSelectionStartPosition.column, newSelectionEndPosition.lineNumber, newSelectionEndPosition.column);
			this._onSelectionChangeRequest.fire(newSelection);
		});
	}
	dispose() {
		super.dispose();
		if (this._selectionChangeListener) {
			this._selectionChangeListener.dispose();
			this._selectionChangeListener = null;
		}
	}
	focusTextArea() {
		this._setHasFocus(true);
		this.refreshFocusState();
	}
	isFocused() {
		return this._hasFocus;
	}
	refreshFocusState() {
		this._setHasFocus(this._textArea.hasFocus());
	}
	_setHasFocus(newHasFocus) {
		if (this._hasFocus === newHasFocus) return;
		this._hasFocus = newHasFocus;
		if (this._selectionChangeListener) {
			this._selectionChangeListener.dispose();
			this._selectionChangeListener = null;
		}
		if (this._hasFocus) this._selectionChangeListener = this._installSelectionChangeListener();
		if (this._hasFocus) this.writeNativeTextAreaContent("focusgain");
		if (this._hasFocus) this._onFocus.fire();
		else this._onBlur.fire();
	}
	_setAndWriteTextAreaState(reason, textAreaState) {
		if (!this._hasFocus) textAreaState = textAreaState.collapseSelection();
		if (!textAreaState.isWrittenToTextArea(this._textArea, this._hasFocus)) this._logService.trace(`writeTextAreaState(reason: ${reason})`);
		textAreaState.writeToTextArea(reason, this._textArea, this._hasFocus);
		this._textAreaState = textAreaState;
	}
	writeNativeTextAreaContent(reason) {
		if (!this._accessibilityService.isScreenReaderOptimized() && reason === "render" || this._currentComposition) return;
		this._setAndWriteTextAreaState(reason, this._host.getScreenReaderContent());
	}
};
TextAreaInput = __decorate$74([__param$68(4, IAccessibilityService), __param$68(5, ILogService)], TextAreaInput);
var TextAreaWrapper = class extends Disposable {
	get ownerDocument() {
		return this._actual.ownerDocument;
	}
	constructor(_actual) {
		super();
		this._actual = _actual;
		this._onSyntheticTap = this._register(new Emitter$1());
		this.onSyntheticTap = this._onSyntheticTap.event;
		this._ignoreSelectionChangeTime = 0;
		this.onKeyDown = this._register(new DomEmitter(this._actual, "keydown")).event;
		this.onKeyPress = this._register(new DomEmitter(this._actual, "keypress")).event;
		this.onKeyUp = this._register(new DomEmitter(this._actual, "keyup")).event;
		this.onCompositionStart = this._register(new DomEmitter(this._actual, "compositionstart")).event;
		this.onCompositionUpdate = this._register(new DomEmitter(this._actual, "compositionupdate")).event;
		this.onCompositionEnd = this._register(new DomEmitter(this._actual, "compositionend")).event;
		this.onBeforeInput = this._register(new DomEmitter(this._actual, "beforeinput")).event;
		this.onInput = this._register(new DomEmitter(this._actual, "input")).event;
		this.onCut = this._register(new DomEmitter(this._actual, "cut")).event;
		this.onCopy = this._register(new DomEmitter(this._actual, "copy")).event;
		this.onPaste = this._register(new DomEmitter(this._actual, "paste")).event;
		this.onFocus = this._register(new DomEmitter(this._actual, "focus")).event;
		this.onBlur = this._register(new DomEmitter(this._actual, "blur")).event;
		this._register(this.onKeyDown(() => inputLatency.onKeyDown()));
		this._register(this.onBeforeInput(() => inputLatency.onBeforeInput()));
		this._register(this.onInput(() => inputLatency.onInput()));
		this._register(this.onKeyUp(() => inputLatency.onKeyUp()));
		this._register(addDisposableListener(this._actual, TextAreaSyntethicEvents.Tap, () => this._onSyntheticTap.fire()));
	}
	hasFocus() {
		const shadowRoot = getShadowRoot(this._actual);
		if (shadowRoot) return shadowRoot.activeElement === this._actual;
		else if (this._actual.isConnected) return getActiveElement() === this._actual;
		else return false;
	}
	setIgnoreSelectionChangeTime(reason) {
		this._ignoreSelectionChangeTime = Date.now();
	}
	getIgnoreSelectionChangeTime() {
		return this._ignoreSelectionChangeTime;
	}
	resetSelectionChangeTime() {
		this._ignoreSelectionChangeTime = 0;
	}
	getValue() {
		return this._actual.value;
	}
	setValue(reason, value) {
		const textArea = this._actual;
		if (textArea.value === value) return;
		this.setIgnoreSelectionChangeTime("setValue");
		textArea.value = value;
	}
	getSelectionStart() {
		return this._actual.selectionDirection === "backward" ? this._actual.selectionEnd : this._actual.selectionStart;
	}
	getSelectionEnd() {
		return this._actual.selectionDirection === "backward" ? this._actual.selectionStart : this._actual.selectionEnd;
	}
	setSelectionRange(reason, selectionStart, selectionEnd) {
		const textArea = this._actual;
		let activeElement = null;
		const shadowRoot = getShadowRoot(textArea);
		if (shadowRoot) activeElement = shadowRoot.activeElement;
		else activeElement = getActiveElement();
		const activeWindow = getWindow(activeElement);
		const currentIsFocused = activeElement === textArea;
		const currentSelectionStart = textArea.selectionStart;
		const currentSelectionEnd = textArea.selectionEnd;
		if (currentIsFocused && currentSelectionStart === selectionStart && currentSelectionEnd === selectionEnd) {
			if (isFirefox && activeWindow.parent !== activeWindow) textArea.focus();
			return;
		}
		if (currentIsFocused) {
			this.setIgnoreSelectionChangeTime("setSelectionRange");
			textArea.setSelectionRange(selectionStart, selectionEnd);
			if (isFirefox && activeWindow.parent !== activeWindow) textArea.focus();
			return;
		}
		try {
			const scrollState = saveParentsScrollTop(textArea);
			this.setIgnoreSelectionChangeTime("setSelectionRange");
			textArea.focus();
			textArea.setSelectionRange(selectionStart, selectionEnd);
			restoreParentsScrollTop(textArea, scrollState);
		} catch (e) {}
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/controller/pointerHandler.js
/**
* Currently only tested on iOS 13/ iPadOS.
*/
var PointerEventHandler = class extends MouseHandler {
	constructor(context, viewController, viewHelper) {
		super(context, viewController, viewHelper);
		this._register(Gesture.addTarget(this.viewHelper.linesContentDomNode));
		this._register(addDisposableListener(this.viewHelper.linesContentDomNode, EventType.Tap, (e) => this.onTap(e)));
		this._register(addDisposableListener(this.viewHelper.linesContentDomNode, EventType.Change, (e) => this.onChange(e)));
		this._register(addDisposableListener(this.viewHelper.linesContentDomNode, EventType.Contextmenu, (e) => this._onContextMenu(new EditorMouseEvent(e, false, this.viewHelper.viewDomNode), false)));
		this._lastPointerType = "mouse";
		this._register(addDisposableListener(this.viewHelper.linesContentDomNode, "pointerdown", (e) => {
			const pointerType = e.pointerType;
			if (pointerType === "mouse") {
				this._lastPointerType = "mouse";
				return;
			} else if (pointerType === "touch") this._lastPointerType = "touch";
			else this._lastPointerType = "pen";
		}));
		const pointerEvents = new EditorPointerEventFactory(this.viewHelper.viewDomNode);
		this._register(pointerEvents.onPointerMove(this.viewHelper.viewDomNode, (e) => this._onMouseMove(e)));
		this._register(pointerEvents.onPointerUp(this.viewHelper.viewDomNode, (e) => this._onMouseUp(e)));
		this._register(pointerEvents.onPointerLeave(this.viewHelper.viewDomNode, (e) => this._onMouseLeave(e)));
		this._register(pointerEvents.onPointerDown(this.viewHelper.viewDomNode, (e, pointerId) => this._onMouseDown(e, pointerId)));
	}
	onTap(event) {
		if (!event.initialTarget || !this.viewHelper.linesContentDomNode.contains(event.initialTarget)) return;
		event.preventDefault();
		this.viewHelper.focusTextArea();
		this._dispatchGesture(event, false);
	}
	onChange(event) {
		if (this._lastPointerType === "touch") this._context.viewModel.viewLayout.deltaScrollNow(-event.translationX, -event.translationY);
		if (this._lastPointerType === "pen") this._dispatchGesture(event, true);
	}
	_dispatchGesture(event, inSelectionMode) {
		const target = this._createMouseTarget(new EditorMouseEvent(event, false, this.viewHelper.viewDomNode), false);
		if (target.position) this.viewController.dispatchMouse({
			position: target.position,
			mouseColumn: target.position.column,
			startedOnLineNumbers: false,
			revealType: 1,
			mouseDownCount: event.tapCount,
			inSelectionMode,
			altKey: false,
			ctrlKey: false,
			metaKey: false,
			shiftKey: false,
			leftButton: false,
			middleButton: false,
			onInjectedText: target.type === 6 && target.detail.injectedText !== null
		});
	}
	_onMouseDown(e, pointerId) {
		if (e.browserEvent.pointerType === "touch") return;
		super._onMouseDown(e, pointerId);
	}
};
var TouchHandler = class extends MouseHandler {
	constructor(context, viewController, viewHelper) {
		super(context, viewController, viewHelper);
		this._register(Gesture.addTarget(this.viewHelper.linesContentDomNode));
		this._register(addDisposableListener(this.viewHelper.linesContentDomNode, EventType.Tap, (e) => this.onTap(e)));
		this._register(addDisposableListener(this.viewHelper.linesContentDomNode, EventType.Change, (e) => this.onChange(e)));
		this._register(addDisposableListener(this.viewHelper.linesContentDomNode, EventType.Contextmenu, (e) => this._onContextMenu(new EditorMouseEvent(e, false, this.viewHelper.viewDomNode), false)));
	}
	onTap(event) {
		event.preventDefault();
		this.viewHelper.focusTextArea();
		const target = this._createMouseTarget(new EditorMouseEvent(event, false, this.viewHelper.viewDomNode), false);
		if (target.position) {
			const event = document.createEvent("CustomEvent");
			event.initEvent(TextAreaSyntethicEvents.Tap, false, true);
			this.viewHelper.dispatchTextAreaEvent(event);
			this.viewController.moveTo(target.position, 1);
		}
	}
	onChange(e) {
		this._context.viewModel.viewLayout.deltaScrollNow(-e.translationX, -e.translationY);
	}
};
var PointerHandler = class extends Disposable {
	constructor(context, viewController, viewHelper) {
		super();
		if ((isIOS || isAndroid$1 && isMobile) && BrowserFeatures.pointerEvents) this.handler = this._register(new PointerEventHandler(context, viewController, viewHelper));
		else if (mainWindow.TouchEvent) this.handler = this._register(new TouchHandler(context, viewController, viewHelper));
		else this.handler = this._register(new MouseHandler(context, viewController, viewHelper));
	}
	getTargetAtClientPoint(clientX, clientY) {
		return this.handler.getTargetAtClientPoint(clientX, clientY);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/core/misc/indentation.js
function _normalizeIndentationFromWhitespace(str, indentSize, insertSpaces) {
	let spacesCnt = 0;
	for (let i = 0; i < str.length; i++) if (str.charAt(i) === "	") spacesCnt = CursorColumns.nextIndentTabStop(spacesCnt, indentSize);
	else spacesCnt++;
	let result = "";
	if (!insertSpaces) {
		const tabsCnt = Math.floor(spacesCnt / indentSize);
		spacesCnt = spacesCnt % indentSize;
		for (let i = 0; i < tabsCnt; i++) result += "	";
	}
	for (let i = 0; i < spacesCnt; i++) result += " ";
	return result;
}
function normalizeIndentation(str, indentSize, insertSpaces) {
	let firstNonWhitespaceIndex$1 = firstNonWhitespaceIndex(str);
	if (firstNonWhitespaceIndex$1 === -1) firstNonWhitespaceIndex$1 = str.length;
	return _normalizeIndentationFromWhitespace(str.substring(0, firstNonWhitespaceIndex$1), indentSize, insertSpaces) + str.substring(firstNonWhitespaceIndex$1);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/cursorCommon.js
var autoCloseAlways = () => true;
var autoCloseNever = () => false;
var autoCloseBeforeWhitespace = (chr) => chr === " " || chr === "	";
var CursorConfiguration = class {
	static shouldRecreate(e) {
		return e.hasChanged(166) || e.hasChanged(148) || e.hasChanged(45) || e.hasChanged(85) || e.hasChanged(88) || e.hasChanged(89) || e.hasChanged(10) || e.hasChanged(11) || e.hasChanged(15) || e.hasChanged(13) || e.hasChanged(14) || e.hasChanged(20) || e.hasChanged(145) || e.hasChanged(141) || e.hasChanged(59) || e.hasChanged(104) || e.hasChanged(147) || e.hasChanged(93);
	}
	constructor(languageId, modelOptions, configuration, languageConfigurationService) {
		this.languageConfigurationService = languageConfigurationService;
		this._cursorMoveConfigurationBrand = void 0;
		this._languageId = languageId;
		const options = configuration.options;
		const layoutInfo = options.get(166);
		const fontInfo = options.get(59);
		this.readOnly = options.get(104);
		this.tabSize = modelOptions.tabSize;
		this.indentSize = modelOptions.indentSize;
		this.insertSpaces = modelOptions.insertSpaces;
		this.stickyTabStops = options.get(132);
		this.lineHeight = fontInfo.lineHeight;
		this.typicalHalfwidthCharacterWidth = fontInfo.typicalHalfwidthCharacterWidth;
		this.pageSize = Math.max(1, Math.floor(layoutInfo.height / this.lineHeight) - 2);
		this.useTabStops = options.get(145);
		this.trimWhitespaceOnDelete = options.get(141);
		this.wordSeparators = options.get(148);
		this.emptySelectionClipboard = options.get(45);
		this.copyWithSyntaxHighlighting = options.get(31);
		this.multiCursorMergeOverlapping = options.get(85);
		this.multiCursorPaste = options.get(88);
		this.multiCursorLimit = options.get(89);
		this.autoClosingBrackets = options.get(10);
		this.autoClosingComments = options.get(11);
		this.autoClosingQuotes = options.get(15);
		this.autoClosingDelete = options.get(13);
		this.autoClosingOvertype = options.get(14);
		this.autoSurround = options.get(20);
		this.autoIndent = options.get(16);
		this.wordSegmenterLocales = options.get(147);
		this.overtypeOnPaste = options.get(93);
		this.surroundingPairs = {};
		this._electricChars = null;
		this.shouldAutoCloseBefore = {
			quote: this._getShouldAutoClose(languageId, this.autoClosingQuotes, true),
			comment: this._getShouldAutoClose(languageId, this.autoClosingComments, false),
			bracket: this._getShouldAutoClose(languageId, this.autoClosingBrackets, false)
		};
		this.autoClosingPairs = this.languageConfigurationService.getLanguageConfiguration(languageId).getAutoClosingPairs();
		const surroundingPairs = this.languageConfigurationService.getLanguageConfiguration(languageId).getSurroundingPairs();
		if (surroundingPairs) for (const pair of surroundingPairs) this.surroundingPairs[pair.open] = pair.close;
		const commentsConfiguration = this.languageConfigurationService.getLanguageConfiguration(languageId).comments;
		this.blockCommentStartToken = commentsConfiguration?.blockCommentStartToken ?? null;
	}
	get electricChars() {
		if (!this._electricChars) {
			this._electricChars = {};
			const electricChars = this.languageConfigurationService.getLanguageConfiguration(this._languageId).electricCharacter?.getElectricCharacters();
			if (electricChars) for (const char of electricChars) this._electricChars[char] = true;
		}
		return this._electricChars;
	}
	get inputMode() {
		return InputMode.getInputMode();
	}
	/**
	* Should return opening bracket type to match indentation with
	*/
	onElectricCharacter(character, context, column) {
		const scopedLineTokens = createScopedLineTokens(context, column - 1);
		const electricCharacterSupport = this.languageConfigurationService.getLanguageConfiguration(scopedLineTokens.languageId).electricCharacter;
		if (!electricCharacterSupport) return null;
		return electricCharacterSupport.onElectricCharacter(character, scopedLineTokens, column - scopedLineTokens.firstCharOffset);
	}
	normalizeIndentation(str) {
		return normalizeIndentation(str, this.indentSize, this.insertSpaces);
	}
	_getShouldAutoClose(languageId, autoCloseConfig, forQuotes) {
		switch (autoCloseConfig) {
			case "beforeWhitespace": return autoCloseBeforeWhitespace;
			case "languageDefined": return this._getLanguageDefinedShouldAutoClose(languageId, forQuotes);
			case "always": return autoCloseAlways;
			case "never": return autoCloseNever;
		}
	}
	_getLanguageDefinedShouldAutoClose(languageId, forQuotes) {
		const autoCloseBeforeSet = this.languageConfigurationService.getLanguageConfiguration(languageId).getAutoCloseBeforeSet(forQuotes);
		return (c) => autoCloseBeforeSet.indexOf(c) !== -1;
	}
	/**
	* Returns a visible column from a column.
	* @see {@link CursorColumns}
	*/
	visibleColumnFromColumn(model, position) {
		return CursorColumns.visibleColumnFromColumn(model.getLineContent(position.lineNumber), position.column, this.tabSize);
	}
	/**
	* Returns a visible column from a column.
	* @see {@link CursorColumns}
	*/
	columnFromVisibleColumn(model, lineNumber, visibleColumn) {
		const result = CursorColumns.columnFromVisibleColumn(model.getLineContent(lineNumber), visibleColumn, this.tabSize);
		const minColumn = model.getLineMinColumn(lineNumber);
		if (result < minColumn) return minColumn;
		const maxColumn = model.getLineMaxColumn(lineNumber);
		if (result > maxColumn) return maxColumn;
		return result;
	}
};
var CursorState = class CursorState {
	static fromModelState(modelState) {
		return new PartialModelCursorState(modelState);
	}
	static fromViewState(viewState) {
		return new PartialViewCursorState(viewState);
	}
	static fromModelSelection(modelSelection) {
		const selection = Selection$1.liftSelection(modelSelection);
		const modelState = new SingleCursorState(Range$2.fromPositions(selection.getSelectionStart()), 0, 0, selection.getPosition(), 0);
		return CursorState.fromModelState(modelState);
	}
	static fromModelSelections(modelSelections) {
		const states = [];
		for (let i = 0, len = modelSelections.length; i < len; i++) states[i] = this.fromModelSelection(modelSelections[i]);
		return states;
	}
	constructor(modelState, viewState) {
		this._cursorStateBrand = void 0;
		this.modelState = modelState;
		this.viewState = viewState;
	}
	equals(other) {
		return this.viewState.equals(other.viewState) && this.modelState.equals(other.modelState);
	}
};
var PartialModelCursorState = class {
	constructor(modelState) {
		this.modelState = modelState;
		this.viewState = null;
	}
};
var PartialViewCursorState = class {
	constructor(viewState) {
		this.modelState = null;
		this.viewState = viewState;
	}
};
/**
* Represents the cursor state on either the model or on the view model.
*/
var SingleCursorState = class SingleCursorState {
	constructor(selectionStart, selectionStartKind, selectionStartLeftoverVisibleColumns, position, leftoverVisibleColumns) {
		this.selectionStart = selectionStart;
		this.selectionStartKind = selectionStartKind;
		this.selectionStartLeftoverVisibleColumns = selectionStartLeftoverVisibleColumns;
		this.position = position;
		this.leftoverVisibleColumns = leftoverVisibleColumns;
		this._singleCursorStateBrand = void 0;
		this.selection = SingleCursorState._computeSelection(this.selectionStart, this.position);
	}
	equals(other) {
		return this.selectionStartLeftoverVisibleColumns === other.selectionStartLeftoverVisibleColumns && this.leftoverVisibleColumns === other.leftoverVisibleColumns && this.selectionStartKind === other.selectionStartKind && this.position.equals(other.position) && this.selectionStart.equalsRange(other.selectionStart);
	}
	hasSelection() {
		return !this.selection.isEmpty() || !this.selectionStart.isEmpty();
	}
	move(inSelectionMode, lineNumber, column, leftoverVisibleColumns) {
		if (inSelectionMode) return new SingleCursorState(this.selectionStart, this.selectionStartKind, this.selectionStartLeftoverVisibleColumns, new Position$1(lineNumber, column), leftoverVisibleColumns);
		else return new SingleCursorState(new Range$2(lineNumber, column, lineNumber, column), 0, leftoverVisibleColumns, new Position$1(lineNumber, column), leftoverVisibleColumns);
	}
	static _computeSelection(selectionStart, position) {
		if (selectionStart.isEmpty() || !position.isBeforeOrEqual(selectionStart.getStartPosition())) return Selection$1.fromPositions(selectionStart.getStartPosition(), position);
		else return Selection$1.fromPositions(selectionStart.getEndPosition(), position);
	}
};
var EditOperationResult = class {
	constructor(type, commands, opts) {
		this._editOperationResultBrand = void 0;
		this.type = type;
		this.commands = commands;
		this.shouldPushStackElementBefore = opts.shouldPushStackElementBefore;
		this.shouldPushStackElementAfter = opts.shouldPushStackElementAfter;
	}
};
function isQuote(ch) {
	return ch === "'" || ch === "\"" || ch === "`";
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/cursor/cursorColumnSelection.js
var ColumnSelection = class ColumnSelection {
	static columnSelect(config, model, fromLineNumber, fromVisibleColumn, toLineNumber, toVisibleColumn) {
		const lineCount = Math.abs(toLineNumber - fromLineNumber) + 1;
		const reversed = fromLineNumber > toLineNumber;
		const isRTL = fromVisibleColumn > toVisibleColumn;
		const isLTR = fromVisibleColumn < toVisibleColumn;
		const result = [];
		for (let i = 0; i < lineCount; i++) {
			const lineNumber = fromLineNumber + (reversed ? -i : i);
			const startColumn = config.columnFromVisibleColumn(model, lineNumber, fromVisibleColumn);
			const endColumn = config.columnFromVisibleColumn(model, lineNumber, toVisibleColumn);
			const visibleStartColumn = config.visibleColumnFromColumn(model, new Position$1(lineNumber, startColumn));
			const visibleEndColumn = config.visibleColumnFromColumn(model, new Position$1(lineNumber, endColumn));
			if (isLTR) {
				if (visibleStartColumn > toVisibleColumn) continue;
				if (visibleEndColumn < fromVisibleColumn) continue;
			}
			if (isRTL) {
				if (visibleEndColumn > fromVisibleColumn) continue;
				if (visibleStartColumn < toVisibleColumn) continue;
			}
			result.push(new SingleCursorState(new Range$2(lineNumber, startColumn, lineNumber, startColumn), 0, 0, new Position$1(lineNumber, endColumn), 0));
		}
		if (result.length === 0) for (let i = 0; i < lineCount; i++) {
			const lineNumber = fromLineNumber + (reversed ? -i : i);
			const maxColumn = model.getLineMaxColumn(lineNumber);
			result.push(new SingleCursorState(new Range$2(lineNumber, maxColumn, lineNumber, maxColumn), 0, 0, new Position$1(lineNumber, maxColumn), 0));
		}
		return {
			viewStates: result,
			reversed,
			fromLineNumber,
			fromVisualColumn: fromVisibleColumn,
			toLineNumber,
			toVisualColumn: toVisibleColumn
		};
	}
	static columnSelectLeft(config, model, prevColumnSelectData) {
		let toViewVisualColumn = prevColumnSelectData.toViewVisualColumn;
		if (toViewVisualColumn > 0) toViewVisualColumn--;
		return ColumnSelection.columnSelect(config, model, prevColumnSelectData.fromViewLineNumber, prevColumnSelectData.fromViewVisualColumn, prevColumnSelectData.toViewLineNumber, toViewVisualColumn);
	}
	static columnSelectRight(config, model, prevColumnSelectData) {
		let maxVisualViewColumn = 0;
		const minViewLineNumber = Math.min(prevColumnSelectData.fromViewLineNumber, prevColumnSelectData.toViewLineNumber);
		const maxViewLineNumber = Math.max(prevColumnSelectData.fromViewLineNumber, prevColumnSelectData.toViewLineNumber);
		for (let lineNumber = minViewLineNumber; lineNumber <= maxViewLineNumber; lineNumber++) {
			const lineMaxViewColumn = model.getLineMaxColumn(lineNumber);
			const lineMaxVisualViewColumn = config.visibleColumnFromColumn(model, new Position$1(lineNumber, lineMaxViewColumn));
			maxVisualViewColumn = Math.max(maxVisualViewColumn, lineMaxVisualViewColumn);
		}
		let toViewVisualColumn = prevColumnSelectData.toViewVisualColumn;
		if (toViewVisualColumn < maxVisualViewColumn) toViewVisualColumn++;
		return this.columnSelect(config, model, prevColumnSelectData.fromViewLineNumber, prevColumnSelectData.fromViewVisualColumn, prevColumnSelectData.toViewLineNumber, toViewVisualColumn);
	}
	static columnSelectUp(config, model, prevColumnSelectData, isPaged) {
		const linesCount = isPaged ? config.pageSize : 1;
		const toViewLineNumber = Math.max(1, prevColumnSelectData.toViewLineNumber - linesCount);
		return this.columnSelect(config, model, prevColumnSelectData.fromViewLineNumber, prevColumnSelectData.fromViewVisualColumn, toViewLineNumber, prevColumnSelectData.toViewVisualColumn);
	}
	static columnSelectDown(config, model, prevColumnSelectData, isPaged) {
		const linesCount = isPaged ? config.pageSize : 1;
		const toViewLineNumber = Math.min(model.getLineCount(), prevColumnSelectData.toViewLineNumber + linesCount);
		return this.columnSelect(config, model, prevColumnSelectData.fromViewLineNumber, prevColumnSelectData.fromViewVisualColumn, toViewLineNumber, prevColumnSelectData.toViewVisualColumn);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/commands/replaceCommand.js
var ReplaceCommand = class {
	constructor(range, text, insertsAutoWhitespace = false) {
		this._range = range;
		this._text = text;
		this.insertsAutoWhitespace = insertsAutoWhitespace;
	}
	getEditOperations(model, builder) {
		builder.addTrackedEditOperation(this._range, this._text);
	}
	computeCursorState(model, helper) {
		const srcRange = helper.getInverseEditOperations()[0].range;
		return Selection$1.fromPositions(srcRange.getEndPosition());
	}
};
var ReplaceOvertypeCommand = class {
	constructor(range, text, insertsAutoWhitespace = false) {
		this._range = range;
		this._text = text;
		this.insertsAutoWhitespace = insertsAutoWhitespace;
	}
	getEditOperations(model, builder) {
		const initialStartPosition = this._range.getStartPosition();
		const initialEndPosition = this._range.getEndPosition();
		const initialEndLineNumber = initialEndPosition.lineNumber;
		let endPosition = addPositiveOffsetToModelPosition(model, initialEndPosition, this._text.length + (this._range.isEmpty() ? 0 : -1));
		if (endPosition.lineNumber > initialEndLineNumber) endPosition = new Position$1(initialEndLineNumber, model.getLineMaxColumn(initialEndLineNumber));
		const replaceRange = Range$2.fromPositions(initialStartPosition, endPosition);
		builder.addTrackedEditOperation(replaceRange, this._text);
	}
	computeCursorState(model, helper) {
		const srcRange = helper.getInverseEditOperations()[0].range;
		return Selection$1.fromPositions(srcRange.getEndPosition());
	}
};
var ReplaceCommandThatSelectsText = class {
	constructor(range, text) {
		this._range = range;
		this._text = text;
	}
	getEditOperations(model, builder) {
		builder.addTrackedEditOperation(this._range, this._text);
	}
	computeCursorState(model, helper) {
		const srcRange = helper.getInverseEditOperations()[0].range;
		return Selection$1.fromRange(srcRange, 0);
	}
};
var ReplaceCommandWithoutChangingPosition = class {
	constructor(range, text, insertsAutoWhitespace = false) {
		this._range = range;
		this._text = text;
		this.insertsAutoWhitespace = insertsAutoWhitespace;
	}
	getEditOperations(model, builder) {
		builder.addTrackedEditOperation(this._range, this._text);
	}
	computeCursorState(model, helper) {
		const srcRange = helper.getInverseEditOperations()[0].range;
		return Selection$1.fromPositions(srcRange.getStartPosition());
	}
};
var ReplaceCommandWithOffsetCursorState = class {
	constructor(range, text, lineNumberDeltaOffset, columnDeltaOffset, insertsAutoWhitespace = false) {
		this._range = range;
		this._text = text;
		this._columnDeltaOffset = columnDeltaOffset;
		this._lineNumberDeltaOffset = lineNumberDeltaOffset;
		this.insertsAutoWhitespace = insertsAutoWhitespace;
	}
	getEditOperations(model, builder) {
		builder.addTrackedEditOperation(this._range, this._text);
	}
	computeCursorState(model, helper) {
		const srcRange = helper.getInverseEditOperations()[0].range;
		return Selection$1.fromPositions(srcRange.getEndPosition().delta(this._lineNumberDeltaOffset, this._columnDeltaOffset));
	}
};
var ReplaceOvertypeCommandOnCompositionEnd = class {
	constructor(range) {
		this._range = range;
	}
	getEditOperations(model, builder) {
		const text = model.getValueInRange(this._range);
		const initialEndPosition = this._range.getEndPosition();
		const initialEndLineNumber = initialEndPosition.lineNumber;
		let endPosition = addPositiveOffsetToModelPosition(model, initialEndPosition, text.length);
		if (endPosition.lineNumber > initialEndLineNumber) endPosition = new Position$1(initialEndLineNumber, model.getLineMaxColumn(initialEndLineNumber));
		const replaceRange = Range$2.fromPositions(initialEndPosition, endPosition);
		builder.addTrackedEditOperation(replaceRange, "");
	}
	computeCursorState(model, helper) {
		const srcRange = helper.getInverseEditOperations()[0].range;
		return Selection$1.fromPositions(srcRange.getEndPosition());
	}
};
var ReplaceCommandThatPreservesSelection = class {
	constructor(editRange, text, initialSelection, forceMoveMarkers = false) {
		this._range = editRange;
		this._text = text;
		this._initialSelection = initialSelection;
		this._forceMoveMarkers = forceMoveMarkers;
		this._selectionId = null;
	}
	getEditOperations(model, builder) {
		builder.addTrackedEditOperation(this._range, this._text, this._forceMoveMarkers);
		this._selectionId = builder.trackSelection(this._initialSelection);
	}
	computeCursorState(model, helper) {
		return helper.getTrackedSelection(this._selectionId);
	}
};
function addPositiveOffsetToModelPosition(model, position, offset) {
	if (offset < 0) throw new Error("Unexpected negative delta");
	const lineCount = model.getLineCount();
	let endPosition = new Position$1(lineCount, model.getLineMaxColumn(lineCount));
	for (let lineNumber = position.lineNumber; lineNumber <= lineCount; lineNumber++) if (lineNumber === position.lineNumber) {
		const futureOffset = offset - model.getLineMaxColumn(position.lineNumber) + position.column;
		if (futureOffset <= 0) {
			endPosition = new Position$1(position.lineNumber, position.column + offset);
			break;
		}
		offset = futureOffset;
	} else {
		const futureOffset = offset - model.getLineMaxColumn(lineNumber);
		if (futureOffset <= 0) {
			endPosition = new Position$1(lineNumber, offset);
			break;
		}
		offset = futureOffset;
	}
	return endPosition;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/cursor/cursorMoveOperations.js
var CursorPosition = class {
	constructor(lineNumber, column, leftoverVisibleColumns) {
		this._cursorPositionBrand = void 0;
		this.lineNumber = lineNumber;
		this.column = column;
		this.leftoverVisibleColumns = leftoverVisibleColumns;
	}
};
var MoveOperations = class MoveOperations {
	static leftPosition(model, position) {
		if (position.column > model.getLineMinColumn(position.lineNumber)) return position.delta(void 0, -prevCharLength(model.getLineContent(position.lineNumber), position.column - 1));
		else if (position.lineNumber > 1) {
			const newLineNumber = position.lineNumber - 1;
			return new Position$1(newLineNumber, model.getLineMaxColumn(newLineNumber));
		} else return position;
	}
	static leftPositionAtomicSoftTabs(model, position, tabSize) {
		if (position.column <= model.getLineIndentColumn(position.lineNumber)) {
			const minColumn = model.getLineMinColumn(position.lineNumber);
			const lineContent = model.getLineContent(position.lineNumber);
			const newPosition = AtomicTabMoveOperations.atomicPosition(lineContent, position.column - 1, tabSize, 0);
			if (newPosition !== -1 && newPosition + 1 >= minColumn) return new Position$1(position.lineNumber, newPosition + 1);
		}
		return this.leftPosition(model, position);
	}
	static left(config, model, position) {
		const pos = config.stickyTabStops ? MoveOperations.leftPositionAtomicSoftTabs(model, position, config.tabSize) : MoveOperations.leftPosition(model, position);
		return new CursorPosition(pos.lineNumber, pos.column, 0);
	}
	/**
	* @param noOfColumns Must be either `1`
	* or `Math.round(viewModel.getLineContent(viewLineNumber).length / 2)` (for half lines).
	*/
	static moveLeft(config, model, cursor, inSelectionMode, noOfColumns) {
		let lineNumber, column;
		if (cursor.hasSelection() && !inSelectionMode) {
			lineNumber = cursor.selection.startLineNumber;
			column = cursor.selection.startColumn;
		} else {
			const pos = cursor.position.delta(void 0, -(noOfColumns - 1));
			const normalizedPos = model.normalizePosition(MoveOperations.clipPositionColumn(pos, model), 0);
			const p = MoveOperations.left(config, model, normalizedPos);
			lineNumber = p.lineNumber;
			column = p.column;
		}
		return cursor.move(inSelectionMode, lineNumber, column, 0);
	}
	/**
	* Adjusts the column so that it is within min/max of the line.
	*/
	static clipPositionColumn(position, model) {
		return new Position$1(position.lineNumber, MoveOperations.clipRange(position.column, model.getLineMinColumn(position.lineNumber), model.getLineMaxColumn(position.lineNumber)));
	}
	static clipRange(value, min, max) {
		if (value < min) return min;
		if (value > max) return max;
		return value;
	}
	static rightPosition(model, lineNumber, column) {
		if (column < model.getLineMaxColumn(lineNumber)) column = column + nextCharLength(model.getLineContent(lineNumber), column - 1);
		else if (lineNumber < model.getLineCount()) {
			lineNumber = lineNumber + 1;
			column = model.getLineMinColumn(lineNumber);
		}
		return model.normalizePosition(new Position$1(lineNumber, column), 1);
	}
	static rightPositionAtomicSoftTabs(model, lineNumber, column, tabSize, indentSize) {
		if (column < model.getLineIndentColumn(lineNumber)) {
			const lineContent = model.getLineContent(lineNumber);
			const newPosition = AtomicTabMoveOperations.atomicPosition(lineContent, column - 1, tabSize, 1);
			if (newPosition !== -1) return new Position$1(lineNumber, newPosition + 1);
		}
		return this.rightPosition(model, lineNumber, column);
	}
	static right(config, model, position) {
		const pos = config.stickyTabStops ? MoveOperations.rightPositionAtomicSoftTabs(model, position.lineNumber, position.column, config.tabSize, config.indentSize) : MoveOperations.rightPosition(model, position.lineNumber, position.column);
		return new CursorPosition(pos.lineNumber, pos.column, 0);
	}
	static moveRight(config, model, cursor, inSelectionMode, noOfColumns) {
		let lineNumber, column;
		if (cursor.hasSelection() && !inSelectionMode) {
			lineNumber = cursor.selection.endLineNumber;
			column = cursor.selection.endColumn;
		} else {
			const pos = cursor.position.delta(void 0, noOfColumns - 1);
			const normalizedPos = model.normalizePosition(MoveOperations.clipPositionColumn(pos, model), 1);
			const r = MoveOperations.right(config, model, normalizedPos);
			lineNumber = r.lineNumber;
			column = r.column;
		}
		return cursor.move(inSelectionMode, lineNumber, column, 0);
	}
	static vertical(config, model, lineNumber, column, leftoverVisibleColumns, newLineNumber, allowMoveOnEdgeLine, normalizationAffinity) {
		const currentVisibleColumn = CursorColumns.visibleColumnFromColumn(model.getLineContent(lineNumber), column, config.tabSize) + leftoverVisibleColumns;
		const lineCount = model.getLineCount();
		const wasOnFirstPosition = lineNumber === 1 && column === 1;
		const wasOnLastPosition = lineNumber === lineCount && column === model.getLineMaxColumn(lineNumber);
		const wasAtEdgePosition = newLineNumber < lineNumber ? wasOnFirstPosition : wasOnLastPosition;
		lineNumber = newLineNumber;
		if (lineNumber < 1) {
			lineNumber = 1;
			if (allowMoveOnEdgeLine) column = model.getLineMinColumn(lineNumber);
			else column = Math.min(model.getLineMaxColumn(lineNumber), column);
		} else if (lineNumber > lineCount) {
			lineNumber = lineCount;
			if (allowMoveOnEdgeLine) column = model.getLineMaxColumn(lineNumber);
			else column = Math.min(model.getLineMaxColumn(lineNumber), column);
		} else column = config.columnFromVisibleColumn(model, lineNumber, currentVisibleColumn);
		if (wasAtEdgePosition) leftoverVisibleColumns = 0;
		else leftoverVisibleColumns = currentVisibleColumn - CursorColumns.visibleColumnFromColumn(model.getLineContent(lineNumber), column, config.tabSize);
		if (normalizationAffinity !== void 0) {
			const position = new Position$1(lineNumber, column);
			const newPosition = model.normalizePosition(position, normalizationAffinity);
			leftoverVisibleColumns = leftoverVisibleColumns + (column - newPosition.column);
			lineNumber = newPosition.lineNumber;
			column = newPosition.column;
		}
		return new CursorPosition(lineNumber, column, leftoverVisibleColumns);
	}
	static down(config, model, lineNumber, column, leftoverVisibleColumns, count, allowMoveOnLastLine) {
		return this.vertical(config, model, lineNumber, column, leftoverVisibleColumns, lineNumber + count, allowMoveOnLastLine, 4);
	}
	static moveDown(config, model, cursor, inSelectionMode, linesCount) {
		let lineNumber, column;
		if (cursor.hasSelection() && !inSelectionMode) {
			lineNumber = cursor.selection.endLineNumber;
			column = cursor.selection.endColumn;
		} else {
			lineNumber = cursor.position.lineNumber;
			column = cursor.position.column;
		}
		let i = 0;
		let r;
		do {
			r = MoveOperations.down(config, model, lineNumber + i, column, cursor.leftoverVisibleColumns, linesCount, true);
			if (model.normalizePosition(new Position$1(r.lineNumber, r.column), 2).lineNumber > lineNumber) break;
		} while (i++ < 10 && lineNumber + i < model.getLineCount());
		return cursor.move(inSelectionMode, r.lineNumber, r.column, r.leftoverVisibleColumns);
	}
	static translateDown(config, model, cursor) {
		const selection = cursor.selection;
		const selectionStart = MoveOperations.down(config, model, selection.selectionStartLineNumber, selection.selectionStartColumn, cursor.selectionStartLeftoverVisibleColumns, 1, false);
		const position = MoveOperations.down(config, model, selection.positionLineNumber, selection.positionColumn, cursor.leftoverVisibleColumns, 1, false);
		return new SingleCursorState(new Range$2(selectionStart.lineNumber, selectionStart.column, selectionStart.lineNumber, selectionStart.column), 0, selectionStart.leftoverVisibleColumns, new Position$1(position.lineNumber, position.column), position.leftoverVisibleColumns);
	}
	static up(config, model, lineNumber, column, leftoverVisibleColumns, count, allowMoveOnFirstLine) {
		return this.vertical(config, model, lineNumber, column, leftoverVisibleColumns, lineNumber - count, allowMoveOnFirstLine, 3);
	}
	static moveUp(config, model, cursor, inSelectionMode, linesCount) {
		let lineNumber, column;
		if (cursor.hasSelection() && !inSelectionMode) {
			lineNumber = cursor.selection.startLineNumber;
			column = cursor.selection.startColumn;
		} else {
			lineNumber = cursor.position.lineNumber;
			column = cursor.position.column;
		}
		const r = MoveOperations.up(config, model, lineNumber, column, cursor.leftoverVisibleColumns, linesCount, true);
		return cursor.move(inSelectionMode, r.lineNumber, r.column, r.leftoverVisibleColumns);
	}
	static translateUp(config, model, cursor) {
		const selection = cursor.selection;
		const selectionStart = MoveOperations.up(config, model, selection.selectionStartLineNumber, selection.selectionStartColumn, cursor.selectionStartLeftoverVisibleColumns, 1, false);
		const position = MoveOperations.up(config, model, selection.positionLineNumber, selection.positionColumn, cursor.leftoverVisibleColumns, 1, false);
		return new SingleCursorState(new Range$2(selectionStart.lineNumber, selectionStart.column, selectionStart.lineNumber, selectionStart.column), 0, selectionStart.leftoverVisibleColumns, new Position$1(position.lineNumber, position.column), position.leftoverVisibleColumns);
	}
	static _isBlankLine(model, lineNumber) {
		if (model.getLineFirstNonWhitespaceColumn(lineNumber) === 0) return true;
		return false;
	}
	static moveToPrevBlankLine(config, model, cursor, inSelectionMode) {
		let lineNumber = cursor.position.lineNumber;
		while (lineNumber > 1 && this._isBlankLine(model, lineNumber)) lineNumber--;
		while (lineNumber > 1 && !this._isBlankLine(model, lineNumber)) lineNumber--;
		return cursor.move(inSelectionMode, lineNumber, model.getLineMinColumn(lineNumber), 0);
	}
	static moveToNextBlankLine(config, model, cursor, inSelectionMode) {
		const lineCount = model.getLineCount();
		let lineNumber = cursor.position.lineNumber;
		while (lineNumber < lineCount && this._isBlankLine(model, lineNumber)) lineNumber++;
		while (lineNumber < lineCount && !this._isBlankLine(model, lineNumber)) lineNumber++;
		return cursor.move(inSelectionMode, lineNumber, model.getLineMinColumn(lineNumber), 0);
	}
	static moveToBeginningOfLine(config, model, cursor, inSelectionMode) {
		const lineNumber = cursor.position.lineNumber;
		const minColumn = model.getLineMinColumn(lineNumber);
		const firstNonBlankColumn = model.getLineFirstNonWhitespaceColumn(lineNumber) || minColumn;
		let column;
		if (cursor.position.column === firstNonBlankColumn) column = minColumn;
		else column = firstNonBlankColumn;
		return cursor.move(inSelectionMode, lineNumber, column, 0);
	}
	static moveToEndOfLine(config, model, cursor, inSelectionMode, sticky) {
		const lineNumber = cursor.position.lineNumber;
		const maxColumn = model.getLineMaxColumn(lineNumber);
		return cursor.move(inSelectionMode, lineNumber, maxColumn, sticky ? 1073741824 - maxColumn : 0);
	}
	static moveToBeginningOfBuffer(config, model, cursor, inSelectionMode) {
		return cursor.move(inSelectionMode, 1, 1, 0);
	}
	static moveToEndOfBuffer(config, model, cursor, inSelectionMode) {
		const lastLineNumber = model.getLineCount();
		const lastColumn = model.getLineMaxColumn(lastLineNumber);
		return cursor.move(inSelectionMode, lastLineNumber, lastColumn, 0);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/cursor/cursorDeleteOperations.js
var DeleteOperations = class DeleteOperations {
	static deleteRight(prevEditOperationType, config, model, selections) {
		const commands = [];
		let shouldPushStackElementBefore = prevEditOperationType !== 3;
		for (let i = 0, len = selections.length; i < len; i++) {
			const selection = selections[i];
			const deleteSelection = this.getDeleteRightRange(selection, model, config);
			if (deleteSelection.isEmpty()) {
				commands[i] = null;
				continue;
			}
			if (deleteSelection.startLineNumber !== deleteSelection.endLineNumber) shouldPushStackElementBefore = true;
			commands[i] = new ReplaceCommand(deleteSelection, "");
		}
		return [shouldPushStackElementBefore, commands];
	}
	static getDeleteRightRange(selection, model, config) {
		if (!selection.isEmpty()) return selection;
		const position = selection.getPosition();
		const rightOfPosition = MoveOperations.right(config, model, position);
		if (config.trimWhitespaceOnDelete && rightOfPosition.lineNumber !== position.lineNumber) {
			const currentLineHasContent = model.getLineFirstNonWhitespaceColumn(position.lineNumber) > 0;
			const firstNonWhitespaceColumn = model.getLineFirstNonWhitespaceColumn(rightOfPosition.lineNumber);
			if (currentLineHasContent && firstNonWhitespaceColumn > 0) return new Range$2(rightOfPosition.lineNumber, firstNonWhitespaceColumn, position.lineNumber, position.column);
		}
		return new Range$2(rightOfPosition.lineNumber, rightOfPosition.column, position.lineNumber, position.column);
	}
	static isAutoClosingPairDelete(autoClosingDelete, autoClosingBrackets, autoClosingQuotes, autoClosingPairsOpen, model, selections, autoClosedCharacters) {
		if (autoClosingBrackets === "never" && autoClosingQuotes === "never") return false;
		if (autoClosingDelete === "never") return false;
		for (let i = 0, len = selections.length; i < len; i++) {
			const selection = selections[i];
			const position = selection.getPosition();
			if (!selection.isEmpty()) return false;
			const lineText = model.getLineContent(position.lineNumber);
			if (position.column < 2 || position.column >= lineText.length + 1) return false;
			const character = lineText.charAt(position.column - 2);
			const autoClosingPairCandidates = autoClosingPairsOpen.get(character);
			if (!autoClosingPairCandidates) return false;
			if (isQuote(character)) {
				if (autoClosingQuotes === "never") return false;
			} else if (autoClosingBrackets === "never") return false;
			const afterCharacter = lineText.charAt(position.column - 1);
			let foundAutoClosingPair = false;
			for (const autoClosingPairCandidate of autoClosingPairCandidates) if (autoClosingPairCandidate.open === character && autoClosingPairCandidate.close === afterCharacter) foundAutoClosingPair = true;
			if (!foundAutoClosingPair) return false;
			if (autoClosingDelete === "auto") {
				let found = false;
				for (let j = 0, lenJ = autoClosedCharacters.length; j < lenJ; j++) {
					const autoClosedCharacter = autoClosedCharacters[j];
					if (position.lineNumber === autoClosedCharacter.startLineNumber && position.column === autoClosedCharacter.startColumn) {
						found = true;
						break;
					}
				}
				if (!found) return false;
			}
		}
		return true;
	}
	static _runAutoClosingPairDelete(config, model, selections) {
		const commands = [];
		for (let i = 0, len = selections.length; i < len; i++) {
			const position = selections[i].getPosition();
			const deleteSelection = new Range$2(position.lineNumber, position.column - 1, position.lineNumber, position.column + 1);
			commands[i] = new ReplaceCommand(deleteSelection, "");
		}
		return [true, commands];
	}
	static deleteLeft(prevEditOperationType, config, model, selections, autoClosedCharacters) {
		if (this.isAutoClosingPairDelete(config.autoClosingDelete, config.autoClosingBrackets, config.autoClosingQuotes, config.autoClosingPairs.autoClosingPairsOpenByEnd, model, selections, autoClosedCharacters)) return this._runAutoClosingPairDelete(config, model, selections);
		const commands = [];
		let shouldPushStackElementBefore = prevEditOperationType !== 2;
		for (let i = 0, len = selections.length; i < len; i++) {
			const deleteRange = DeleteOperations.getDeleteLeftRange(selections[i], model, config);
			if (deleteRange.isEmpty()) {
				commands[i] = null;
				continue;
			}
			if (deleteRange.startLineNumber !== deleteRange.endLineNumber) shouldPushStackElementBefore = true;
			commands[i] = new ReplaceCommand(deleteRange, "");
		}
		return [shouldPushStackElementBefore, commands];
	}
	static getDeleteLeftRange(selection, model, config) {
		if (!selection.isEmpty()) return selection;
		const position = selection.getPosition();
		if (config.useTabStops && position.column > 1) {
			const lineContent = model.getLineContent(position.lineNumber);
			const firstNonWhitespaceIndex$1 = firstNonWhitespaceIndex(lineContent);
			const lastIndentationColumn = firstNonWhitespaceIndex$1 === -1 ? lineContent.length + 1 : firstNonWhitespaceIndex$1 + 1;
			if (position.column <= lastIndentationColumn) {
				const fromVisibleColumn = config.visibleColumnFromColumn(model, position);
				const toVisibleColumn = CursorColumns.prevIndentTabStop(fromVisibleColumn, config.indentSize);
				const toColumn = config.columnFromVisibleColumn(model, position.lineNumber, toVisibleColumn);
				return new Range$2(position.lineNumber, toColumn, position.lineNumber, position.column);
			}
		}
		return Range$2.fromPositions(DeleteOperations.getPositionAfterDeleteLeft(position, model), position);
	}
	static getPositionAfterDeleteLeft(position, model) {
		if (position.column > 1) {
			const idx = getLeftDeleteOffset(position.column - 1, model.getLineContent(position.lineNumber));
			return position.with(void 0, idx + 1);
		} else if (position.lineNumber > 1) {
			const newLine = position.lineNumber - 1;
			return new Position$1(newLine, model.getLineMaxColumn(newLine));
		} else return position;
	}
	static cut(config, model, selections) {
		const commands = [];
		let lastCutRange = null;
		selections.sort((a, b) => Position$1.compare(a.getStartPosition(), b.getEndPosition()));
		for (let i = 0, len = selections.length; i < len; i++) {
			const selection = selections[i];
			if (selection.isEmpty()) {
				if (config.emptySelectionClipboard) {
					const position = selection.getPosition();
					let startLineNumber, startColumn, endLineNumber, endColumn;
					if (position.lineNumber < model.getLineCount()) {
						startLineNumber = position.lineNumber;
						startColumn = 1;
						endLineNumber = position.lineNumber + 1;
						endColumn = 1;
					} else if (position.lineNumber > 1 && lastCutRange?.endLineNumber !== position.lineNumber) {
						startLineNumber = position.lineNumber - 1;
						startColumn = model.getLineMaxColumn(position.lineNumber - 1);
						endLineNumber = position.lineNumber;
						endColumn = model.getLineMaxColumn(position.lineNumber);
					} else {
						startLineNumber = position.lineNumber;
						startColumn = 1;
						endLineNumber = position.lineNumber;
						endColumn = model.getLineMaxColumn(position.lineNumber);
					}
					const deleteSelection = new Range$2(startLineNumber, startColumn, endLineNumber, endColumn);
					lastCutRange = deleteSelection;
					if (!deleteSelection.isEmpty()) commands[i] = new ReplaceCommand(deleteSelection, "");
					else commands[i] = null;
				} else commands[i] = null;
			} else commands[i] = new ReplaceCommand(selection, "");
		}
		return new EditOperationResult(0, commands, {
			shouldPushStackElementBefore: true,
			shouldPushStackElementAfter: true
		});
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/cursor/cursorWordOperations.js
var WordOperations = class WordOperations {
	static _createWord(lineContent, wordType, nextCharClass, start, end) {
		return {
			start,
			end,
			wordType,
			nextCharClass
		};
	}
	static _createIntlWord(intlWord, nextCharClass) {
		return {
			start: intlWord.index,
			end: intlWord.index + intlWord.segment.length,
			wordType: 1,
			nextCharClass
		};
	}
	static _findPreviousWordOnLine(wordSeparators, model, position) {
		const lineContent = model.getLineContent(position.lineNumber);
		return this._doFindPreviousWordOnLine(lineContent, wordSeparators, position);
	}
	static _doFindPreviousWordOnLine(lineContent, wordSeparators, position) {
		let wordType = 0;
		const previousIntlWord = wordSeparators.findPrevIntlWordBeforeOrAtOffset(lineContent, position.column - 2);
		for (let chIndex = position.column - 2; chIndex >= 0; chIndex--) {
			const chCode = lineContent.charCodeAt(chIndex);
			const chClass = wordSeparators.get(chCode);
			if (previousIntlWord && chIndex === previousIntlWord.index) return this._createIntlWord(previousIntlWord, chClass);
			if (chClass === 0) {
				if (wordType === 2) return this._createWord(lineContent, wordType, chClass, chIndex + 1, this._findEndOfWord(lineContent, wordSeparators, wordType, chIndex + 1));
				wordType = 1;
			} else if (chClass === 2) {
				if (wordType === 1) return this._createWord(lineContent, wordType, chClass, chIndex + 1, this._findEndOfWord(lineContent, wordSeparators, wordType, chIndex + 1));
				wordType = 2;
			} else if (chClass === 1) {
				if (wordType !== 0) return this._createWord(lineContent, wordType, chClass, chIndex + 1, this._findEndOfWord(lineContent, wordSeparators, wordType, chIndex + 1));
			}
		}
		if (wordType !== 0) return this._createWord(lineContent, wordType, 1, 0, this._findEndOfWord(lineContent, wordSeparators, wordType, 0));
		return null;
	}
	static _findEndOfWord(lineContent, wordSeparators, wordType, startIndex) {
		const nextIntlWord = wordSeparators.findNextIntlWordAtOrAfterOffset(lineContent, startIndex);
		const len = lineContent.length;
		for (let chIndex = startIndex; chIndex < len; chIndex++) {
			const chCode = lineContent.charCodeAt(chIndex);
			const chClass = wordSeparators.get(chCode);
			if (nextIntlWord && chIndex === nextIntlWord.index + nextIntlWord.segment.length) return chIndex;
			if (chClass === 1) return chIndex;
			if (wordType === 1 && chClass === 2) return chIndex;
			if (wordType === 2 && chClass === 0) return chIndex;
		}
		return len;
	}
	static _findNextWordOnLine(wordSeparators, model, position) {
		const lineContent = model.getLineContent(position.lineNumber);
		return this._doFindNextWordOnLine(lineContent, wordSeparators, position);
	}
	static _doFindNextWordOnLine(lineContent, wordSeparators, position) {
		let wordType = 0;
		const len = lineContent.length;
		const nextIntlWord = wordSeparators.findNextIntlWordAtOrAfterOffset(lineContent, position.column - 1);
		for (let chIndex = position.column - 1; chIndex < len; chIndex++) {
			const chCode = lineContent.charCodeAt(chIndex);
			const chClass = wordSeparators.get(chCode);
			if (nextIntlWord && chIndex === nextIntlWord.index) return this._createIntlWord(nextIntlWord, chClass);
			if (chClass === 0) {
				if (wordType === 2) return this._createWord(lineContent, wordType, chClass, this._findStartOfWord(lineContent, wordSeparators, wordType, chIndex - 1), chIndex);
				wordType = 1;
			} else if (chClass === 2) {
				if (wordType === 1) return this._createWord(lineContent, wordType, chClass, this._findStartOfWord(lineContent, wordSeparators, wordType, chIndex - 1), chIndex);
				wordType = 2;
			} else if (chClass === 1) {
				if (wordType !== 0) return this._createWord(lineContent, wordType, chClass, this._findStartOfWord(lineContent, wordSeparators, wordType, chIndex - 1), chIndex);
			}
		}
		if (wordType !== 0) return this._createWord(lineContent, wordType, 1, this._findStartOfWord(lineContent, wordSeparators, wordType, len - 1), len);
		return null;
	}
	static _findStartOfWord(lineContent, wordSeparators, wordType, startIndex) {
		const previousIntlWord = wordSeparators.findPrevIntlWordBeforeOrAtOffset(lineContent, startIndex);
		for (let chIndex = startIndex; chIndex >= 0; chIndex--) {
			const chCode = lineContent.charCodeAt(chIndex);
			const chClass = wordSeparators.get(chCode);
			if (previousIntlWord && chIndex === previousIntlWord.index) return chIndex;
			if (chClass === 1) return chIndex + 1;
			if (wordType === 1 && chClass === 2) return chIndex + 1;
			if (wordType === 2 && chClass === 0) return chIndex + 1;
		}
		return 0;
	}
	static moveWordLeft(wordSeparators, model, position, wordNavigationType, hasMulticursor) {
		let lineNumber = position.lineNumber;
		let column = position.column;
		if (column === 1) {
			if (lineNumber > 1) {
				lineNumber = lineNumber - 1;
				column = model.getLineMaxColumn(lineNumber);
			}
		}
		let prevWordOnLine = WordOperations._findPreviousWordOnLine(wordSeparators, model, new Position$1(lineNumber, column));
		if (wordNavigationType === 0) return new Position$1(lineNumber, prevWordOnLine ? prevWordOnLine.start + 1 : 1);
		if (wordNavigationType === 1) {
			if (!hasMulticursor && prevWordOnLine && prevWordOnLine.wordType === 2 && prevWordOnLine.end - prevWordOnLine.start === 1 && prevWordOnLine.nextCharClass === 0) prevWordOnLine = WordOperations._findPreviousWordOnLine(wordSeparators, model, new Position$1(lineNumber, prevWordOnLine.start + 1));
			return new Position$1(lineNumber, prevWordOnLine ? prevWordOnLine.start + 1 : 1);
		}
		if (wordNavigationType === 3) {
			while (prevWordOnLine && prevWordOnLine.wordType === 2) prevWordOnLine = WordOperations._findPreviousWordOnLine(wordSeparators, model, new Position$1(lineNumber, prevWordOnLine.start + 1));
			return new Position$1(lineNumber, prevWordOnLine ? prevWordOnLine.start + 1 : 1);
		}
		if (prevWordOnLine && column <= prevWordOnLine.end + 1) prevWordOnLine = WordOperations._findPreviousWordOnLine(wordSeparators, model, new Position$1(lineNumber, prevWordOnLine.start + 1));
		return new Position$1(lineNumber, prevWordOnLine ? prevWordOnLine.end + 1 : 1);
	}
	static _moveWordPartLeft(model, position) {
		const lineNumber = position.lineNumber;
		const maxColumn = model.getLineMaxColumn(lineNumber);
		if (position.column === 1) return lineNumber > 1 ? new Position$1(lineNumber - 1, model.getLineMaxColumn(lineNumber - 1)) : position;
		const lineContent = model.getLineContent(lineNumber);
		for (let column = position.column - 1; column > 1; column--) {
			const left = lineContent.charCodeAt(column - 2);
			const right = lineContent.charCodeAt(column - 1);
			if (left === 95 && right !== 95) return new Position$1(lineNumber, column);
			if (left === 45 && right !== 45) return new Position$1(lineNumber, column);
			if ((isLowerAsciiLetter(left) || isAsciiDigit(left)) && isUpperAsciiLetter(right)) return new Position$1(lineNumber, column);
			if (isUpperAsciiLetter(left) && isUpperAsciiLetter(right)) {
				if (column + 1 < maxColumn) {
					const rightRight = lineContent.charCodeAt(column);
					if (isLowerAsciiLetter(rightRight) || isAsciiDigit(rightRight)) return new Position$1(lineNumber, column);
				}
			}
		}
		return new Position$1(lineNumber, 1);
	}
	static moveWordRight(wordSeparators, model, position, wordNavigationType) {
		let lineNumber = position.lineNumber;
		let column = position.column;
		let movedDown = false;
		if (column === model.getLineMaxColumn(lineNumber)) {
			if (lineNumber < model.getLineCount()) {
				movedDown = true;
				lineNumber = lineNumber + 1;
				column = 1;
			}
		}
		let nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, new Position$1(lineNumber, column));
		if (wordNavigationType === 2) {
			if (nextWordOnLine && nextWordOnLine.wordType === 2) {
				if (nextWordOnLine.end - nextWordOnLine.start === 1 && nextWordOnLine.nextCharClass === 0) nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, new Position$1(lineNumber, nextWordOnLine.end + 1));
			}
			if (nextWordOnLine) column = nextWordOnLine.end + 1;
			else column = model.getLineMaxColumn(lineNumber);
		} else if (wordNavigationType === 3) {
			if (movedDown) column = 0;
			while (nextWordOnLine && (nextWordOnLine.wordType === 2 || nextWordOnLine.start + 1 <= column)) nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, new Position$1(lineNumber, nextWordOnLine.end + 1));
			if (nextWordOnLine) column = nextWordOnLine.start + 1;
			else column = model.getLineMaxColumn(lineNumber);
		} else {
			if (nextWordOnLine && !movedDown && column >= nextWordOnLine.start + 1) nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, new Position$1(lineNumber, nextWordOnLine.end + 1));
			if (nextWordOnLine) column = nextWordOnLine.start + 1;
			else column = model.getLineMaxColumn(lineNumber);
		}
		return new Position$1(lineNumber, column);
	}
	static _moveWordPartRight(model, position) {
		const lineNumber = position.lineNumber;
		const maxColumn = model.getLineMaxColumn(lineNumber);
		if (position.column === maxColumn) return lineNumber < model.getLineCount() ? new Position$1(lineNumber + 1, 1) : position;
		const lineContent = model.getLineContent(lineNumber);
		for (let column = position.column + 1; column < maxColumn; column++) {
			const left = lineContent.charCodeAt(column - 2);
			const right = lineContent.charCodeAt(column - 1);
			if (left !== 95 && right === 95) return new Position$1(lineNumber, column);
			if (left !== 45 && right === 45) return new Position$1(lineNumber, column);
			if ((isLowerAsciiLetter(left) || isAsciiDigit(left)) && isUpperAsciiLetter(right)) return new Position$1(lineNumber, column);
			if (isUpperAsciiLetter(left) && isUpperAsciiLetter(right)) {
				if (column + 1 < maxColumn) {
					const rightRight = lineContent.charCodeAt(column);
					if (isLowerAsciiLetter(rightRight) || isAsciiDigit(rightRight)) return new Position$1(lineNumber, column);
				}
			}
		}
		return new Position$1(lineNumber, maxColumn);
	}
	static _deleteWordLeftWhitespace(model, position) {
		const lineContent = model.getLineContent(position.lineNumber);
		const startIndex = position.column - 2;
		const lastNonWhitespace = lastNonWhitespaceIndex(lineContent, startIndex);
		if (lastNonWhitespace + 1 < startIndex) return new Range$2(position.lineNumber, lastNonWhitespace + 2, position.lineNumber, position.column);
		return null;
	}
	static deleteWordLeft(ctx, wordNavigationType) {
		const wordSeparators = ctx.wordSeparators;
		const model = ctx.model;
		const selection = ctx.selection;
		const whitespaceHeuristics = ctx.whitespaceHeuristics;
		if (!selection.isEmpty()) return selection;
		if (DeleteOperations.isAutoClosingPairDelete(ctx.autoClosingDelete, ctx.autoClosingBrackets, ctx.autoClosingQuotes, ctx.autoClosingPairs.autoClosingPairsOpenByEnd, ctx.model, [ctx.selection], ctx.autoClosedCharacters)) {
			const position = ctx.selection.getPosition();
			return new Range$2(position.lineNumber, position.column - 1, position.lineNumber, position.column + 1);
		}
		const position = new Position$1(selection.positionLineNumber, selection.positionColumn);
		let lineNumber = position.lineNumber;
		let column = position.column;
		if (lineNumber === 1 && column === 1) return null;
		if (whitespaceHeuristics) {
			const r = this._deleteWordLeftWhitespace(model, position);
			if (r) return r;
		}
		let prevWordOnLine = WordOperations._findPreviousWordOnLine(wordSeparators, model, position);
		if (wordNavigationType === 0) {
			if (prevWordOnLine) column = prevWordOnLine.start + 1;
			else if (column > 1) column = 1;
			else {
				lineNumber--;
				column = model.getLineMaxColumn(lineNumber);
			}
		} else {
			if (prevWordOnLine && column <= prevWordOnLine.end + 1) prevWordOnLine = WordOperations._findPreviousWordOnLine(wordSeparators, model, new Position$1(lineNumber, prevWordOnLine.start + 1));
			if (prevWordOnLine) column = prevWordOnLine.end + 1;
			else if (column > 1) column = 1;
			else {
				lineNumber--;
				column = model.getLineMaxColumn(lineNumber);
			}
		}
		return new Range$2(lineNumber, column, position.lineNumber, position.column);
	}
	static deleteInsideWord(wordSeparators, model, selection, onlyWord = false) {
		if (!selection.isEmpty()) return selection;
		const position = new Position$1(selection.positionLineNumber, selection.positionColumn);
		const r = this._deleteInsideWordWhitespace(model, position);
		if (r) return r;
		return this._deleteInsideWordDetermineDeleteRange(wordSeparators, model, position, onlyWord);
	}
	static _charAtIsWhitespace(str, index) {
		const charCode = str.charCodeAt(index);
		return charCode === 32 || charCode === 9;
	}
	static _deleteInsideWordWhitespace(model, position) {
		const lineContent = model.getLineContent(position.lineNumber);
		const lineContentLength = lineContent.length;
		if (lineContentLength === 0) return null;
		let leftIndex = Math.max(position.column - 2, 0);
		if (!this._charAtIsWhitespace(lineContent, leftIndex)) return null;
		let rightIndex = Math.min(position.column - 1, lineContentLength - 1);
		if (!this._charAtIsWhitespace(lineContent, rightIndex)) return null;
		while (leftIndex > 0 && this._charAtIsWhitespace(lineContent, leftIndex - 1)) leftIndex--;
		while (rightIndex + 1 < lineContentLength && this._charAtIsWhitespace(lineContent, rightIndex + 1)) rightIndex++;
		return new Range$2(position.lineNumber, leftIndex + 1, position.lineNumber, rightIndex + 2);
	}
	static _deleteInsideWordDetermineDeleteRange(wordSeparators, model, position, onlyWord) {
		const lineContent = model.getLineContent(position.lineNumber);
		const lineLength = lineContent.length;
		if (lineLength === 0) {
			if (position.lineNumber > 1) return new Range$2(position.lineNumber - 1, model.getLineMaxColumn(position.lineNumber - 1), position.lineNumber, 1);
			else if (position.lineNumber < model.getLineCount()) return new Range$2(position.lineNumber, 1, position.lineNumber + 1, 1);
			else return new Range$2(position.lineNumber, 1, position.lineNumber, 1);
		}
		const touchesWord = (word) => {
			return word.start + 1 <= position.column && position.column <= word.end + 1;
		};
		const createRangeWithPosition = (startColumn, endColumn) => {
			startColumn = Math.min(startColumn, position.column);
			endColumn = Math.max(endColumn, position.column);
			return new Range$2(position.lineNumber, startColumn, position.lineNumber, endColumn);
		};
		const deleteWordAndAdjacentWhitespace = (word) => {
			let startColumn = word.start + 1;
			let endColumn = word.end + 1;
			if (onlyWord) return createRangeWithPosition(startColumn, endColumn);
			let expandedToTheRight = false;
			while (endColumn - 1 < lineLength && this._charAtIsWhitespace(lineContent, endColumn - 1)) {
				expandedToTheRight = true;
				endColumn++;
			}
			if (!expandedToTheRight) while (startColumn > 1 && this._charAtIsWhitespace(lineContent, startColumn - 2)) startColumn--;
			return createRangeWithPosition(startColumn, endColumn);
		};
		const prevWordOnLine = WordOperations._findPreviousWordOnLine(wordSeparators, model, position);
		if (prevWordOnLine && touchesWord(prevWordOnLine)) return deleteWordAndAdjacentWhitespace(prevWordOnLine);
		const nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, position);
		if (nextWordOnLine && touchesWord(nextWordOnLine)) return deleteWordAndAdjacentWhitespace(nextWordOnLine);
		if (prevWordOnLine && nextWordOnLine) return createRangeWithPosition(prevWordOnLine.end + 1, nextWordOnLine.start + 1);
		if (prevWordOnLine) return createRangeWithPosition(prevWordOnLine.start + 1, prevWordOnLine.end + 1);
		if (nextWordOnLine) return createRangeWithPosition(nextWordOnLine.start + 1, nextWordOnLine.end + 1);
		return createRangeWithPosition(1, lineLength + 1);
	}
	static _deleteWordPartLeft(model, selection) {
		if (!selection.isEmpty()) return selection;
		const pos = selection.getPosition();
		const toPosition = WordOperations._moveWordPartLeft(model, pos);
		return new Range$2(pos.lineNumber, pos.column, toPosition.lineNumber, toPosition.column);
	}
	static _findFirstNonWhitespaceChar(str, startIndex) {
		const len = str.length;
		for (let chIndex = startIndex; chIndex < len; chIndex++) {
			const ch = str.charAt(chIndex);
			if (ch !== " " && ch !== "	") return chIndex;
		}
		return len;
	}
	static _deleteWordRightWhitespace(model, position) {
		const lineContent = model.getLineContent(position.lineNumber);
		const startIndex = position.column - 1;
		const firstNonWhitespace = this._findFirstNonWhitespaceChar(lineContent, startIndex);
		if (startIndex < firstNonWhitespace) return new Range$2(position.lineNumber, position.column, position.lineNumber, firstNonWhitespace + 1);
		return null;
	}
	static deleteWordRight(ctx, wordNavigationType) {
		const wordSeparators = ctx.wordSeparators;
		const model = ctx.model;
		const selection = ctx.selection;
		const whitespaceHeuristics = ctx.whitespaceHeuristics;
		if (!selection.isEmpty()) return selection;
		const position = new Position$1(selection.positionLineNumber, selection.positionColumn);
		let lineNumber = position.lineNumber;
		let column = position.column;
		const lineCount = model.getLineCount();
		const maxColumn = model.getLineMaxColumn(lineNumber);
		if (lineNumber === lineCount && column === maxColumn) return null;
		if (whitespaceHeuristics) {
			const r = this._deleteWordRightWhitespace(model, position);
			if (r) return r;
		}
		let nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, position);
		if (wordNavigationType === 2) {
			if (nextWordOnLine) column = nextWordOnLine.end + 1;
			else if (column < maxColumn || lineNumber === lineCount) column = maxColumn;
			else {
				lineNumber++;
				nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, new Position$1(lineNumber, 1));
				if (nextWordOnLine) column = nextWordOnLine.start + 1;
				else column = model.getLineMaxColumn(lineNumber);
			}
		} else {
			if (nextWordOnLine && column >= nextWordOnLine.start + 1) nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, new Position$1(lineNumber, nextWordOnLine.end + 1));
			if (nextWordOnLine) column = nextWordOnLine.start + 1;
			else if (column < maxColumn || lineNumber === lineCount) column = maxColumn;
			else {
				lineNumber++;
				nextWordOnLine = WordOperations._findNextWordOnLine(wordSeparators, model, new Position$1(lineNumber, 1));
				if (nextWordOnLine) column = nextWordOnLine.start + 1;
				else column = model.getLineMaxColumn(lineNumber);
			}
		}
		return new Range$2(lineNumber, column, position.lineNumber, position.column);
	}
	static _deleteWordPartRight(model, selection) {
		if (!selection.isEmpty()) return selection;
		const pos = selection.getPosition();
		const toPosition = WordOperations._moveWordPartRight(model, pos);
		return new Range$2(pos.lineNumber, pos.column, toPosition.lineNumber, toPosition.column);
	}
	static _createWordAtPosition(model, lineNumber, word) {
		const range = new Range$2(lineNumber, word.start + 1, lineNumber, word.end + 1);
		return {
			word: model.getValueInRange(range),
			startColumn: range.startColumn,
			endColumn: range.endColumn
		};
	}
	static getWordAtPosition(model, _wordSeparators, _intlSegmenterLocales, position) {
		const wordSeparators = getMapForWordSeparators(_wordSeparators, _intlSegmenterLocales);
		const prevWord = WordOperations._findPreviousWordOnLine(wordSeparators, model, position);
		if (prevWord && prevWord.wordType === 1 && prevWord.start <= position.column - 1 && position.column - 1 <= prevWord.end) return WordOperations._createWordAtPosition(model, position.lineNumber, prevWord);
		const nextWord = WordOperations._findNextWordOnLine(wordSeparators, model, position);
		if (nextWord && nextWord.wordType === 1 && nextWord.start <= position.column - 1 && position.column - 1 <= nextWord.end) return WordOperations._createWordAtPosition(model, position.lineNumber, nextWord);
		return null;
	}
	static word(config, model, cursor, inSelectionMode, position) {
		const wordSeparators = getMapForWordSeparators(config.wordSeparators, config.wordSegmenterLocales);
		const prevWord = WordOperations._findPreviousWordOnLine(wordSeparators, model, position);
		const nextWord = WordOperations._findNextWordOnLine(wordSeparators, model, position);
		if (!inSelectionMode) {
			let startColumn;
			let endColumn;
			if (prevWord && prevWord.wordType === 1 && prevWord.start <= position.column - 1 && position.column - 1 <= prevWord.end) {
				startColumn = prevWord.start + 1;
				endColumn = prevWord.end + 1;
			} else if (prevWord && prevWord.wordType === 2 && prevWord.start <= position.column - 1 && position.column - 1 < prevWord.end) {
				startColumn = prevWord.start + 1;
				endColumn = prevWord.end + 1;
			} else if (nextWord && nextWord.wordType === 1 && nextWord.start <= position.column - 1 && position.column - 1 <= nextWord.end) {
				startColumn = nextWord.start + 1;
				endColumn = nextWord.end + 1;
			} else if (nextWord && nextWord.wordType === 2 && nextWord.start <= position.column - 1 && position.column - 1 < nextWord.end) {
				startColumn = nextWord.start + 1;
				endColumn = nextWord.end + 1;
			} else {
				if (prevWord) startColumn = prevWord.end + 1;
				else startColumn = 1;
				if (nextWord) endColumn = nextWord.start + 1;
				else endColumn = model.getLineMaxColumn(position.lineNumber);
			}
			return new SingleCursorState(new Range$2(position.lineNumber, startColumn, position.lineNumber, endColumn), 1, 0, new Position$1(position.lineNumber, endColumn), 0);
		}
		let startColumn;
		let endColumn;
		if (prevWord && prevWord.wordType === 1 && prevWord.start < position.column - 1 && position.column - 1 < prevWord.end) {
			startColumn = prevWord.start + 1;
			endColumn = prevWord.end + 1;
		} else if (nextWord && nextWord.wordType === 1 && nextWord.start < position.column - 1 && position.column - 1 < nextWord.end) {
			startColumn = nextWord.start + 1;
			endColumn = nextWord.end + 1;
		} else {
			startColumn = position.column;
			endColumn = position.column;
		}
		const lineNumber = position.lineNumber;
		let column;
		if (cursor.selectionStart.containsPosition(position)) column = cursor.selectionStart.endColumn;
		else if (position.isBeforeOrEqual(cursor.selectionStart.getStartPosition())) {
			column = startColumn;
			const possiblePosition = new Position$1(lineNumber, column);
			if (cursor.selectionStart.containsPosition(possiblePosition)) column = cursor.selectionStart.endColumn;
		} else {
			column = endColumn;
			const possiblePosition = new Position$1(lineNumber, column);
			if (cursor.selectionStart.containsPosition(possiblePosition)) column = cursor.selectionStart.startColumn;
		}
		return cursor.move(true, lineNumber, column, 0);
	}
};
var WordPartOperations = class extends WordOperations {
	static deleteWordPartLeft(ctx) {
		const candidates = enforceDefined([
			WordOperations.deleteWordLeft(ctx, 0),
			WordOperations.deleteWordLeft(ctx, 2),
			WordOperations._deleteWordPartLeft(ctx.model, ctx.selection)
		]);
		candidates.sort(Range$2.compareRangesUsingEnds);
		return candidates[2];
	}
	static deleteWordPartRight(ctx) {
		const candidates = enforceDefined([
			WordOperations.deleteWordRight(ctx, 0),
			WordOperations.deleteWordRight(ctx, 2),
			WordOperations._deleteWordPartRight(ctx.model, ctx.selection)
		]);
		candidates.sort(Range$2.compareRangesUsingStarts);
		return candidates[0];
	}
	static moveWordPartLeft(wordSeparators, model, position, hasMulticursor) {
		const candidates = enforceDefined([
			WordOperations.moveWordLeft(wordSeparators, model, position, 0, hasMulticursor),
			WordOperations.moveWordLeft(wordSeparators, model, position, 2, hasMulticursor),
			WordOperations._moveWordPartLeft(model, position)
		]);
		candidates.sort(Position$1.compare);
		return candidates[2];
	}
	static moveWordPartRight(wordSeparators, model, position) {
		const candidates = enforceDefined([
			WordOperations.moveWordRight(wordSeparators, model, position, 0),
			WordOperations.moveWordRight(wordSeparators, model, position, 2),
			WordOperations._moveWordPartRight(model, position)
		]);
		candidates.sort(Position$1.compare);
		return candidates[0];
	}
};
function enforceDefined(arr) {
	return arr.filter((el) => Boolean(el));
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/cursor/cursorMoveCommands.js
var CursorMoveCommands = class CursorMoveCommands {
	static addCursorDown(viewModel, cursors, useLogicalLine) {
		const result = [];
		let resultLen = 0;
		for (let i = 0, len = cursors.length; i < len; i++) {
			const cursor = cursors[i];
			result[resultLen++] = new CursorState(cursor.modelState, cursor.viewState);
			if (useLogicalLine) result[resultLen++] = CursorState.fromModelState(MoveOperations.translateDown(viewModel.cursorConfig, viewModel.model, cursor.modelState));
			else result[resultLen++] = CursorState.fromViewState(MoveOperations.translateDown(viewModel.cursorConfig, viewModel, cursor.viewState));
		}
		return result;
	}
	static addCursorUp(viewModel, cursors, useLogicalLine) {
		const result = [];
		let resultLen = 0;
		for (let i = 0, len = cursors.length; i < len; i++) {
			const cursor = cursors[i];
			result[resultLen++] = new CursorState(cursor.modelState, cursor.viewState);
			if (useLogicalLine) result[resultLen++] = CursorState.fromModelState(MoveOperations.translateUp(viewModel.cursorConfig, viewModel.model, cursor.modelState));
			else result[resultLen++] = CursorState.fromViewState(MoveOperations.translateUp(viewModel.cursorConfig, viewModel, cursor.viewState));
		}
		return result;
	}
	static moveToBeginningOfLine(viewModel, cursors, inSelectionMode) {
		const result = [];
		for (let i = 0, len = cursors.length; i < len; i++) {
			const cursor = cursors[i];
			result[i] = this._moveToLineStart(viewModel, cursor, inSelectionMode);
		}
		return result;
	}
	static _moveToLineStart(viewModel, cursor, inSelectionMode) {
		const currentViewStateColumn = cursor.viewState.position.column;
		const isFirstLineOfWrappedLine = currentViewStateColumn === cursor.modelState.position.column;
		const currentViewStatelineNumber = cursor.viewState.position.lineNumber;
		const isBeginningOfViewLine = currentViewStateColumn === viewModel.getLineFirstNonWhitespaceColumn(currentViewStatelineNumber);
		if (!isFirstLineOfWrappedLine && !isBeginningOfViewLine) return this._moveToLineStartByView(viewModel, cursor, inSelectionMode);
		else return this._moveToLineStartByModel(viewModel, cursor, inSelectionMode);
	}
	static _moveToLineStartByView(viewModel, cursor, inSelectionMode) {
		return CursorState.fromViewState(MoveOperations.moveToBeginningOfLine(viewModel.cursorConfig, viewModel, cursor.viewState, inSelectionMode));
	}
	static _moveToLineStartByModel(viewModel, cursor, inSelectionMode) {
		return CursorState.fromModelState(MoveOperations.moveToBeginningOfLine(viewModel.cursorConfig, viewModel.model, cursor.modelState, inSelectionMode));
	}
	static moveToEndOfLine(viewModel, cursors, inSelectionMode, sticky) {
		const result = [];
		for (let i = 0, len = cursors.length; i < len; i++) {
			const cursor = cursors[i];
			result[i] = this._moveToLineEnd(viewModel, cursor, inSelectionMode, sticky);
		}
		return result;
	}
	static _moveToLineEnd(viewModel, cursor, inSelectionMode, sticky) {
		const viewStatePosition = cursor.viewState.position;
		const viewModelMaxColumn = viewModel.getLineMaxColumn(viewStatePosition.lineNumber);
		const isEndOfViewLine = viewStatePosition.column === viewModelMaxColumn;
		const modelStatePosition = cursor.modelState.position;
		const modelMaxColumn = viewModel.model.getLineMaxColumn(modelStatePosition.lineNumber);
		const isEndLineOfWrappedLine = viewModelMaxColumn - viewStatePosition.column === modelMaxColumn - modelStatePosition.column;
		if (isEndOfViewLine || isEndLineOfWrappedLine) return this._moveToLineEndByModel(viewModel, cursor, inSelectionMode, sticky);
		else return this._moveToLineEndByView(viewModel, cursor, inSelectionMode, sticky);
	}
	static _moveToLineEndByView(viewModel, cursor, inSelectionMode, sticky) {
		return CursorState.fromViewState(MoveOperations.moveToEndOfLine(viewModel.cursorConfig, viewModel, cursor.viewState, inSelectionMode, sticky));
	}
	static _moveToLineEndByModel(viewModel, cursor, inSelectionMode, sticky) {
		return CursorState.fromModelState(MoveOperations.moveToEndOfLine(viewModel.cursorConfig, viewModel.model, cursor.modelState, inSelectionMode, sticky));
	}
	static expandLineSelection(viewModel, cursors) {
		const result = [];
		for (let i = 0, len = cursors.length; i < len; i++) {
			const cursor = cursors[i];
			const startLineNumber = cursor.modelState.selection.startLineNumber;
			const lineCount = viewModel.model.getLineCount();
			let endLineNumber = cursor.modelState.selection.endLineNumber;
			let endColumn;
			if (endLineNumber === lineCount) endColumn = viewModel.model.getLineMaxColumn(lineCount);
			else {
				endLineNumber++;
				endColumn = 1;
			}
			result[i] = CursorState.fromModelState(new SingleCursorState(new Range$2(startLineNumber, 1, startLineNumber, 1), 0, 0, new Position$1(endLineNumber, endColumn), 0));
		}
		return result;
	}
	static moveToBeginningOfBuffer(viewModel, cursors, inSelectionMode) {
		const result = [];
		for (let i = 0, len = cursors.length; i < len; i++) {
			const cursor = cursors[i];
			result[i] = CursorState.fromModelState(MoveOperations.moveToBeginningOfBuffer(viewModel.cursorConfig, viewModel.model, cursor.modelState, inSelectionMode));
		}
		return result;
	}
	static moveToEndOfBuffer(viewModel, cursors, inSelectionMode) {
		const result = [];
		for (let i = 0, len = cursors.length; i < len; i++) {
			const cursor = cursors[i];
			result[i] = CursorState.fromModelState(MoveOperations.moveToEndOfBuffer(viewModel.cursorConfig, viewModel.model, cursor.modelState, inSelectionMode));
		}
		return result;
	}
	static selectAll(viewModel, cursor) {
		const lineCount = viewModel.model.getLineCount();
		const maxColumn = viewModel.model.getLineMaxColumn(lineCount);
		return CursorState.fromModelState(new SingleCursorState(new Range$2(1, 1, 1, 1), 0, 0, new Position$1(lineCount, maxColumn), 0));
	}
	static line(viewModel, cursor, inSelectionMode, _position, _viewPosition) {
		const position = viewModel.model.validatePosition(_position);
		const viewPosition = _viewPosition ? viewModel.coordinatesConverter.validateViewPosition(new Position$1(_viewPosition.lineNumber, _viewPosition.column), position) : viewModel.coordinatesConverter.convertModelPositionToViewPosition(position);
		if (!inSelectionMode) {
			const lineCount = viewModel.model.getLineCount();
			let selectToLineNumber = position.lineNumber + 1;
			let selectToColumn = 1;
			if (selectToLineNumber > lineCount) {
				selectToLineNumber = lineCount;
				selectToColumn = viewModel.model.getLineMaxColumn(selectToLineNumber);
			}
			return CursorState.fromModelState(new SingleCursorState(new Range$2(position.lineNumber, 1, selectToLineNumber, selectToColumn), 2, 0, new Position$1(selectToLineNumber, selectToColumn), 0));
		}
		const enteringLineNumber = cursor.modelState.selectionStart.getStartPosition().lineNumber;
		if (position.lineNumber < enteringLineNumber) return CursorState.fromViewState(cursor.viewState.move(true, viewPosition.lineNumber, 1, 0));
		else if (position.lineNumber > enteringLineNumber) {
			const lineCount = viewModel.getLineCount();
			let selectToViewLineNumber = viewPosition.lineNumber + 1;
			let selectToViewColumn = 1;
			if (selectToViewLineNumber > lineCount) {
				selectToViewLineNumber = lineCount;
				selectToViewColumn = viewModel.getLineMaxColumn(selectToViewLineNumber);
			}
			return CursorState.fromViewState(cursor.viewState.move(true, selectToViewLineNumber, selectToViewColumn, 0));
		} else {
			const endPositionOfSelectionStart = cursor.modelState.selectionStart.getEndPosition();
			return CursorState.fromModelState(cursor.modelState.move(true, endPositionOfSelectionStart.lineNumber, endPositionOfSelectionStart.column, 0));
		}
	}
	static word(viewModel, cursor, inSelectionMode, _position) {
		const position = viewModel.model.validatePosition(_position);
		return CursorState.fromModelState(WordOperations.word(viewModel.cursorConfig, viewModel.model, cursor.modelState, inSelectionMode, position));
	}
	static cancelSelection(viewModel, cursor) {
		if (!cursor.modelState.hasSelection()) return new CursorState(cursor.modelState, cursor.viewState);
		const lineNumber = cursor.viewState.position.lineNumber;
		const column = cursor.viewState.position.column;
		return CursorState.fromViewState(new SingleCursorState(new Range$2(lineNumber, column, lineNumber, column), 0, 0, new Position$1(lineNumber, column), 0));
	}
	static moveTo(viewModel, cursor, inSelectionMode, _position, _viewPosition) {
		if (inSelectionMode) {
			if (cursor.modelState.selectionStartKind === 1) return this.word(viewModel, cursor, inSelectionMode, _position);
			if (cursor.modelState.selectionStartKind === 2) return this.line(viewModel, cursor, inSelectionMode, _position, _viewPosition);
		}
		const position = viewModel.model.validatePosition(_position);
		const viewPosition = _viewPosition ? viewModel.coordinatesConverter.validateViewPosition(new Position$1(_viewPosition.lineNumber, _viewPosition.column), position) : viewModel.coordinatesConverter.convertModelPositionToViewPosition(position);
		return CursorState.fromViewState(cursor.viewState.move(inSelectionMode, viewPosition.lineNumber, viewPosition.column, 0));
	}
	static simpleMove(viewModel, cursors, direction, inSelectionMode, value, unit) {
		switch (direction) {
			case 0: if (unit === 4) return this._moveHalfLineLeft(viewModel, cursors, inSelectionMode);
			else return this._moveLeft(viewModel, cursors, inSelectionMode, value);
			case 1: if (unit === 4) return this._moveHalfLineRight(viewModel, cursors, inSelectionMode);
			else return this._moveRight(viewModel, cursors, inSelectionMode, value);
			case 2: if (unit === 2) return this._moveUpByViewLines(viewModel, cursors, inSelectionMode, value);
			else if (unit === 5) return this._moveUpByFoldedLines(viewModel, cursors, inSelectionMode, value);
			else return this._moveUpByModelLines(viewModel, cursors, inSelectionMode, value);
			case 3: if (unit === 2) return this._moveDownByViewLines(viewModel, cursors, inSelectionMode, value);
			else if (unit === 5) return this._moveDownByFoldedLines(viewModel, cursors, inSelectionMode, value);
			else return this._moveDownByModelLines(viewModel, cursors, inSelectionMode, value);
			case 4: if (unit === 2) return cursors.map((cursor) => CursorState.fromViewState(MoveOperations.moveToPrevBlankLine(viewModel.cursorConfig, viewModel, cursor.viewState, inSelectionMode)));
			else return cursors.map((cursor) => CursorState.fromModelState(MoveOperations.moveToPrevBlankLine(viewModel.cursorConfig, viewModel.model, cursor.modelState, inSelectionMode)));
			case 5: if (unit === 2) return cursors.map((cursor) => CursorState.fromViewState(MoveOperations.moveToNextBlankLine(viewModel.cursorConfig, viewModel, cursor.viewState, inSelectionMode)));
			else return cursors.map((cursor) => CursorState.fromModelState(MoveOperations.moveToNextBlankLine(viewModel.cursorConfig, viewModel.model, cursor.modelState, inSelectionMode)));
			case 6: return this._moveToViewMinColumn(viewModel, cursors, inSelectionMode);
			case 7: return this._moveToViewFirstNonWhitespaceColumn(viewModel, cursors, inSelectionMode);
			case 8: return this._moveToViewCenterColumn(viewModel, cursors, inSelectionMode);
			case 9: return this._moveToViewMaxColumn(viewModel, cursors, inSelectionMode);
			case 10: return this._moveToViewLastNonWhitespaceColumn(viewModel, cursors, inSelectionMode);
			default: return null;
		}
	}
	static viewportMove(viewModel, cursors, direction, inSelectionMode, value) {
		const visibleViewRange = viewModel.getCompletelyVisibleViewRange();
		const visibleModelRange = viewModel.coordinatesConverter.convertViewRangeToModelRange(visibleViewRange);
		switch (direction) {
			case 11: {
				const modelLineNumber = this._firstLineNumberInRange(viewModel.model, visibleModelRange, value);
				const modelColumn = viewModel.model.getLineFirstNonWhitespaceColumn(modelLineNumber);
				return [this._moveToModelPosition(viewModel, cursors[0], inSelectionMode, modelLineNumber, modelColumn)];
			}
			case 13: {
				const modelLineNumber = this._lastLineNumberInRange(viewModel.model, visibleModelRange, value);
				const modelColumn = viewModel.model.getLineFirstNonWhitespaceColumn(modelLineNumber);
				return [this._moveToModelPosition(viewModel, cursors[0], inSelectionMode, modelLineNumber, modelColumn)];
			}
			case 12: {
				const modelLineNumber = Math.round((visibleModelRange.startLineNumber + visibleModelRange.endLineNumber) / 2);
				const modelColumn = viewModel.model.getLineFirstNonWhitespaceColumn(modelLineNumber);
				return [this._moveToModelPosition(viewModel, cursors[0], inSelectionMode, modelLineNumber, modelColumn)];
			}
			case 14: {
				const result = [];
				for (let i = 0, len = cursors.length; i < len; i++) {
					const cursor = cursors[i];
					result[i] = this.findPositionInViewportIfOutside(viewModel, cursor, visibleViewRange, inSelectionMode);
				}
				return result;
			}
			default: return null;
		}
	}
	static findPositionInViewportIfOutside(viewModel, cursor, visibleViewRange, inSelectionMode) {
		const viewLineNumber = cursor.viewState.position.lineNumber;
		if (visibleViewRange.startLineNumber <= viewLineNumber && viewLineNumber <= visibleViewRange.endLineNumber - 1) return new CursorState(cursor.modelState, cursor.viewState);
		else {
			let newViewLineNumber;
			if (viewLineNumber > visibleViewRange.endLineNumber - 1) newViewLineNumber = visibleViewRange.endLineNumber - 1;
			else if (viewLineNumber < visibleViewRange.startLineNumber) newViewLineNumber = visibleViewRange.startLineNumber;
			else newViewLineNumber = viewLineNumber;
			const position = MoveOperations.vertical(viewModel.cursorConfig, viewModel, viewLineNumber, cursor.viewState.position.column, cursor.viewState.leftoverVisibleColumns, newViewLineNumber, false);
			return CursorState.fromViewState(cursor.viewState.move(inSelectionMode, position.lineNumber, position.column, position.leftoverVisibleColumns));
		}
	}
	/**
	* Find the nth line start included in the range (from the start).
	*/
	static _firstLineNumberInRange(model, range, count) {
		let startLineNumber = range.startLineNumber;
		if (range.startColumn !== model.getLineMinColumn(startLineNumber)) startLineNumber++;
		return Math.min(range.endLineNumber, startLineNumber + count - 1);
	}
	/**
	* Find the nth line start included in the range (from the end).
	*/
	static _lastLineNumberInRange(model, range, count) {
		let startLineNumber = range.startLineNumber;
		if (range.startColumn !== model.getLineMinColumn(startLineNumber)) startLineNumber++;
		return Math.max(startLineNumber, range.endLineNumber - count + 1);
	}
	static _moveLeft(viewModel, cursors, inSelectionMode, noOfColumns) {
		return cursors.map((cursor) => {
			const isRtl = viewModel.getTextDirection(cursor.viewState.position.lineNumber) === TextDirection.RTL;
			return CursorState.fromViewState(isRtl ? MoveOperations.moveRight(viewModel.cursorConfig, viewModel, cursor.viewState, inSelectionMode, noOfColumns) : MoveOperations.moveLeft(viewModel.cursorConfig, viewModel, cursor.viewState, inSelectionMode, noOfColumns));
		});
	}
	static _moveHalfLineLeft(viewModel, cursors, inSelectionMode) {
		const result = [];
		for (let i = 0, len = cursors.length; i < len; i++) {
			const cursor = cursors[i];
			const viewLineNumber = cursor.viewState.position.lineNumber;
			const halfLine = Math.round(viewModel.getLineLength(viewLineNumber) / 2);
			result[i] = CursorState.fromViewState(MoveOperations.moveLeft(viewModel.cursorConfig, viewModel, cursor.viewState, inSelectionMode, halfLine));
		}
		return result;
	}
	static _moveRight(viewModel, cursors, inSelectionMode, noOfColumns) {
		return cursors.map((cursor) => {
			const isRtl = viewModel.getTextDirection(cursor.viewState.position.lineNumber) === TextDirection.RTL;
			return CursorState.fromViewState(isRtl ? MoveOperations.moveLeft(viewModel.cursorConfig, viewModel, cursor.viewState, inSelectionMode, noOfColumns) : MoveOperations.moveRight(viewModel.cursorConfig, viewModel, cursor.viewState, inSelectionMode, noOfColumns));
		});
	}
	static _moveHalfLineRight(viewModel, cursors, inSelectionMode) {
		const result = [];
		for (let i = 0, len = cursors.length; i < len; i++) {
			const cursor = cursors[i];
			const viewLineNumber = cursor.viewState.position.lineNumber;
			const halfLine = Math.round(viewModel.getLineLength(viewLineNumber) / 2);
			result[i] = CursorState.fromViewState(MoveOperations.moveRight(viewModel.cursorConfig, viewModel, cursor.viewState, inSelectionMode, halfLine));
		}
		return result;
	}
	static _moveDownByViewLines(viewModel, cursors, inSelectionMode, linesCount) {
		const result = [];
		for (let i = 0, len = cursors.length; i < len; i++) {
			const cursor = cursors[i];
			result[i] = CursorState.fromViewState(MoveOperations.moveDown(viewModel.cursorConfig, viewModel, cursor.viewState, inSelectionMode, linesCount));
		}
		return result;
	}
	static _moveDownByModelLines(viewModel, cursors, inSelectionMode, linesCount) {
		const result = [];
		for (let i = 0, len = cursors.length; i < len; i++) {
			const cursor = cursors[i];
			result[i] = CursorState.fromModelState(MoveOperations.moveDown(viewModel.cursorConfig, viewModel.model, cursor.modelState, inSelectionMode, linesCount));
		}
		return result;
	}
	static _moveUpByViewLines(viewModel, cursors, inSelectionMode, linesCount) {
		const result = [];
		for (let i = 0, len = cursors.length; i < len; i++) {
			const cursor = cursors[i];
			result[i] = CursorState.fromViewState(MoveOperations.moveUp(viewModel.cursorConfig, viewModel, cursor.viewState, inSelectionMode, linesCount));
		}
		return result;
	}
	static _moveUpByModelLines(viewModel, cursors, inSelectionMode, linesCount) {
		const result = [];
		for (let i = 0, len = cursors.length; i < len; i++) {
			const cursor = cursors[i];
			result[i] = CursorState.fromModelState(MoveOperations.moveUp(viewModel.cursorConfig, viewModel.model, cursor.modelState, inSelectionMode, linesCount));
		}
		return result;
	}
	static _moveDownByFoldedLines(viewModel, cursors, inSelectionMode, count) {
		const model = viewModel.model;
		const lineCount = model.getLineCount();
		const hiddenAreas = viewModel.getHiddenAreas();
		return cursors.map((cursor) => {
			const startLine = cursor.modelState.hasSelection() && !inSelectionMode ? cursor.modelState.selection.endLineNumber : cursor.modelState.position.lineNumber;
			const delta = CursorMoveCommands._targetFoldedDown(startLine, count, hiddenAreas, lineCount) - startLine;
			if (delta === 0) return CursorState.fromModelState(cursor.modelState);
			return CursorState.fromModelState(MoveOperations.moveDown(viewModel.cursorConfig, model, cursor.modelState, inSelectionMode, delta));
		});
	}
	static _moveUpByFoldedLines(viewModel, cursors, inSelectionMode, count) {
		const model = viewModel.model;
		const hiddenAreas = viewModel.getHiddenAreas();
		return cursors.map((cursor) => {
			const startLine = cursor.modelState.hasSelection() && !inSelectionMode ? cursor.modelState.selection.startLineNumber : cursor.modelState.position.lineNumber;
			const delta = startLine - CursorMoveCommands._targetFoldedUp(startLine, count, hiddenAreas);
			if (delta === 0) return CursorState.fromModelState(cursor.modelState);
			return CursorState.fromModelState(MoveOperations.moveUp(viewModel.cursorConfig, model, cursor.modelState, inSelectionMode, delta));
		});
	}
	static _targetFoldedDown(startLine, count, hiddenAreas, lineCount) {
		let line = startLine;
		let i = 0;
		while (i < hiddenAreas.length && hiddenAreas[i].endLineNumber < line + 1) i++;
		for (let step = 0; step < count; step++) {
			if (line >= lineCount) return lineCount;
			let candidate = line + 1;
			while (i < hiddenAreas.length && hiddenAreas[i].endLineNumber < candidate) i++;
			if (i < hiddenAreas.length && hiddenAreas[i].startLineNumber <= candidate) candidate = hiddenAreas[i].endLineNumber + 1;
			if (candidate > lineCount) return line;
			line = candidate;
		}
		return line;
	}
	static _targetFoldedUp(startLine, count, hiddenAreas) {
		let line = startLine;
		let i = hiddenAreas.length - 1;
		while (i >= 0 && hiddenAreas[i].startLineNumber > line - 1) i--;
		for (let step = 0; step < count; step++) {
			if (line <= 1) return 1;
			let candidate = line - 1;
			while (i >= 0 && hiddenAreas[i].startLineNumber > candidate) i--;
			if (i >= 0 && hiddenAreas[i].endLineNumber >= candidate) candidate = hiddenAreas[i].startLineNumber - 1;
			if (candidate < 1) return line;
			line = candidate;
		}
		return line;
	}
	static _moveToViewPosition(viewModel, cursor, inSelectionMode, toViewLineNumber, toViewColumn) {
		return CursorState.fromViewState(cursor.viewState.move(inSelectionMode, toViewLineNumber, toViewColumn, 0));
	}
	static _moveToModelPosition(viewModel, cursor, inSelectionMode, toModelLineNumber, toModelColumn) {
		return CursorState.fromModelState(cursor.modelState.move(inSelectionMode, toModelLineNumber, toModelColumn, 0));
	}
	static _moveToViewMinColumn(viewModel, cursors, inSelectionMode) {
		const result = [];
		for (let i = 0, len = cursors.length; i < len; i++) {
			const cursor = cursors[i];
			const viewLineNumber = cursor.viewState.position.lineNumber;
			const viewColumn = viewModel.getLineMinColumn(viewLineNumber);
			result[i] = this._moveToViewPosition(viewModel, cursor, inSelectionMode, viewLineNumber, viewColumn);
		}
		return result;
	}
	static _moveToViewFirstNonWhitespaceColumn(viewModel, cursors, inSelectionMode) {
		const result = [];
		for (let i = 0, len = cursors.length; i < len; i++) {
			const cursor = cursors[i];
			const viewLineNumber = cursor.viewState.position.lineNumber;
			const viewColumn = viewModel.getLineFirstNonWhitespaceColumn(viewLineNumber);
			result[i] = this._moveToViewPosition(viewModel, cursor, inSelectionMode, viewLineNumber, viewColumn);
		}
		return result;
	}
	static _moveToViewCenterColumn(viewModel, cursors, inSelectionMode) {
		const result = [];
		for (let i = 0, len = cursors.length; i < len; i++) {
			const cursor = cursors[i];
			const viewLineNumber = cursor.viewState.position.lineNumber;
			const viewColumn = Math.round((viewModel.getLineMaxColumn(viewLineNumber) + viewModel.getLineMinColumn(viewLineNumber)) / 2);
			result[i] = this._moveToViewPosition(viewModel, cursor, inSelectionMode, viewLineNumber, viewColumn);
		}
		return result;
	}
	static _moveToViewMaxColumn(viewModel, cursors, inSelectionMode) {
		const result = [];
		for (let i = 0, len = cursors.length; i < len; i++) {
			const cursor = cursors[i];
			const viewLineNumber = cursor.viewState.position.lineNumber;
			const viewColumn = viewModel.getLineMaxColumn(viewLineNumber);
			result[i] = this._moveToViewPosition(viewModel, cursor, inSelectionMode, viewLineNumber, viewColumn);
		}
		return result;
	}
	static _moveToViewLastNonWhitespaceColumn(viewModel, cursors, inSelectionMode) {
		const result = [];
		for (let i = 0, len = cursors.length; i < len; i++) {
			const cursor = cursors[i];
			const viewLineNumber = cursor.viewState.position.lineNumber;
			const viewColumn = viewModel.getLineLastNonWhitespaceColumn(viewLineNumber);
			result[i] = this._moveToViewPosition(viewModel, cursor, inSelectionMode, viewLineNumber, viewColumn);
		}
		return result;
	}
};
var CursorMove;
(function(CursorMove) {
	const isCursorMoveArgs = function(arg) {
		if (!isObject(arg)) return false;
		const cursorMoveArg = arg;
		if (!isString$1(cursorMoveArg.to)) return false;
		if (!isUndefined(cursorMoveArg.select) && !isBoolean(cursorMoveArg.select)) return false;
		if (!isUndefined(cursorMoveArg.by) && !isString$1(cursorMoveArg.by)) return false;
		if (!isUndefined(cursorMoveArg.value) && !isNumber$1(cursorMoveArg.value)) return false;
		if (!isUndefined(cursorMoveArg.noHistory) && !isBoolean(cursorMoveArg.noHistory)) return false;
		return true;
	};
	CursorMove.metadata = {
		description: "Move cursor to a logical position in the view",
		args: [{
			name: "Cursor move argument object",
			description: `Property-value pairs that can be passed through this argument:
					* 'to': A mandatory logical position value providing where to move the cursor.
						\`\`\`
						'left', 'right', 'up', 'down', 'prevBlankLine', 'nextBlankLine',
						'wrappedLineStart', 'wrappedLineEnd', 'wrappedLineColumnCenter'
						'wrappedLineFirstNonWhitespaceCharacter', 'wrappedLineLastNonWhitespaceCharacter'
						'viewPortTop', 'viewPortCenter', 'viewPortBottom', 'viewPortIfOutside'
						\`\`\`
					* 'by': Unit to move. Default is computed based on 'to' value.
						\`\`\`
						'line', 'wrappedLine', 'character', 'halfLine', 'foldedLine'
						\`\`\`
						Use 'foldedLine' with 'up'/'down' to move by logical lines while treating each
						folded region as a single step.
					* 'value': Number of units to move. Default is '1'.
					* 'select': If 'true' makes the selection. Default is 'false'.
					* 'noHistory': If 'true' does not add the movement to navigation history. Default is 'false'.
				`,
			constraint: isCursorMoveArgs,
			schema: {
				"type": "object",
				"required": ["to"],
				"properties": {
					"to": {
						"type": "string",
						"enum": [
							"left",
							"right",
							"up",
							"down",
							"prevBlankLine",
							"nextBlankLine",
							"wrappedLineStart",
							"wrappedLineEnd",
							"wrappedLineColumnCenter",
							"wrappedLineFirstNonWhitespaceCharacter",
							"wrappedLineLastNonWhitespaceCharacter",
							"viewPortTop",
							"viewPortCenter",
							"viewPortBottom",
							"viewPortIfOutside"
						]
					},
					"by": {
						"type": "string",
						"enum": [
							"line",
							"wrappedLine",
							"character",
							"halfLine",
							"foldedLine"
						]
					},
					"value": {
						"type": "number",
						"default": 1
					},
					"select": {
						"type": "boolean",
						"default": false
					},
					"noHistory": {
						"type": "boolean",
						"default": false
					}
				}
			}
		}]
	};
	/**
	* Positions in the view for cursor move command.
	*/
	CursorMove.RawDirection = {
		Left: "left",
		Right: "right",
		Up: "up",
		Down: "down",
		PrevBlankLine: "prevBlankLine",
		NextBlankLine: "nextBlankLine",
		WrappedLineStart: "wrappedLineStart",
		WrappedLineFirstNonWhitespaceCharacter: "wrappedLineFirstNonWhitespaceCharacter",
		WrappedLineColumnCenter: "wrappedLineColumnCenter",
		WrappedLineEnd: "wrappedLineEnd",
		WrappedLineLastNonWhitespaceCharacter: "wrappedLineLastNonWhitespaceCharacter",
		ViewPortTop: "viewPortTop",
		ViewPortCenter: "viewPortCenter",
		ViewPortBottom: "viewPortBottom",
		ViewPortIfOutside: "viewPortIfOutside"
	};
	/**
	* Units for Cursor move 'by' argument
	*/
	CursorMove.RawUnit = {
		Line: "line",
		WrappedLine: "wrappedLine",
		Character: "character",
		HalfLine: "halfLine",
		FoldedLine: "foldedLine"
	};
	function parse(args) {
		if (!args.to) return null;
		let direction;
		switch (args.to) {
			case CursorMove.RawDirection.Left:
				direction = 0;
				break;
			case CursorMove.RawDirection.Right:
				direction = 1;
				break;
			case CursorMove.RawDirection.Up:
				direction = 2;
				break;
			case CursorMove.RawDirection.Down:
				direction = 3;
				break;
			case CursorMove.RawDirection.PrevBlankLine:
				direction = 4;
				break;
			case CursorMove.RawDirection.NextBlankLine:
				direction = 5;
				break;
			case CursorMove.RawDirection.WrappedLineStart:
				direction = 6;
				break;
			case CursorMove.RawDirection.WrappedLineFirstNonWhitespaceCharacter:
				direction = 7;
				break;
			case CursorMove.RawDirection.WrappedLineColumnCenter:
				direction = 8;
				break;
			case CursorMove.RawDirection.WrappedLineEnd:
				direction = 9;
				break;
			case CursorMove.RawDirection.WrappedLineLastNonWhitespaceCharacter:
				direction = 10;
				break;
			case CursorMove.RawDirection.ViewPortTop:
				direction = 11;
				break;
			case CursorMove.RawDirection.ViewPortBottom:
				direction = 13;
				break;
			case CursorMove.RawDirection.ViewPortCenter:
				direction = 12;
				break;
			case CursorMove.RawDirection.ViewPortIfOutside:
				direction = 14;
				break;
			default: return null;
		}
		let unit = 0;
		switch (args.by) {
			case CursorMove.RawUnit.Line:
				unit = 1;
				break;
			case CursorMove.RawUnit.WrappedLine:
				unit = 2;
				break;
			case CursorMove.RawUnit.Character:
				unit = 3;
				break;
			case CursorMove.RawUnit.HalfLine:
				unit = 4;
				break;
			case CursorMove.RawUnit.FoldedLine: unit = 5;
		}
		return {
			direction,
			unit,
			select: !!args.select,
			value: args.value || 1,
			noHistory: !!args.noHistory
		};
	}
	CursorMove.parse = parse;
})(CursorMove || (CursorMove = {}));
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/languages/supports/indentationLineProcessor.js
/**
* This class is a wrapper class around {@link IndentRulesSupport}.
* It processes the lines by removing the language configuration brackets from the regex, string and comment tokens.
* It then calls into the {@link IndentRulesSupport} to validate the indentation conditions.
*/
var ProcessedIndentRulesSupport = class {
	constructor(model, indentRulesSupport, languageConfigurationService) {
		this._indentRulesSupport = indentRulesSupport;
		this._indentationLineProcessor = new IndentationLineProcessor(model, languageConfigurationService);
	}
	/**
	* Apply the new indentation and return whether the indentation level should be increased after the given line number
	*/
	shouldIncrease(lineNumber, newIndentation) {
		const processedLine = this._indentationLineProcessor.getProcessedLine(lineNumber, newIndentation);
		return this._indentRulesSupport.shouldIncrease(processedLine);
	}
	/**
	* Apply the new indentation and return whether the indentation level should be decreased after the given line number
	*/
	shouldDecrease(lineNumber, newIndentation) {
		const processedLine = this._indentationLineProcessor.getProcessedLine(lineNumber, newIndentation);
		return this._indentRulesSupport.shouldDecrease(processedLine);
	}
	/**
	* Apply the new indentation and return whether the indentation level should remain unchanged at the given line number
	*/
	shouldIgnore(lineNumber, newIndentation) {
		const processedLine = this._indentationLineProcessor.getProcessedLine(lineNumber, newIndentation);
		return this._indentRulesSupport.shouldIgnore(processedLine);
	}
	/**
	* Apply the new indentation and return whether the indentation level should increase on the line after the given line number
	*/
	shouldIndentNextLine(lineNumber, newIndentation) {
		const processedLine = this._indentationLineProcessor.getProcessedLine(lineNumber, newIndentation);
		return this._indentRulesSupport.shouldIndentNextLine(processedLine);
	}
};
/**
* This class fetches the processed text around a range which can be used for indentation evaluation.
* It returns:
* - The processed text before the given range and on the same start line
* - The processed text after the given range and on the same end line
* - The processed text on the previous line
*/
var IndentationContextProcessor = class {
	constructor(model, languageConfigurationService) {
		this.model = model;
		this.indentationLineProcessor = new IndentationLineProcessor(model, languageConfigurationService);
	}
	/**
	* Returns the processed text, stripped from the language configuration brackets within the string, comment and regex tokens, around the given range
	*/
	getProcessedTokenContextAroundRange(range) {
		return {
			beforeRangeProcessedTokens: this._getProcessedTokensBeforeRange(range),
			afterRangeProcessedTokens: this._getProcessedTokensAfterRange(range),
			previousLineProcessedTokens: this._getProcessedPreviousLineTokens(range)
		};
	}
	_getProcessedTokensBeforeRange(range) {
		this.model.tokenization.forceTokenization(range.startLineNumber);
		const lineTokens = this.model.tokenization.getLineTokens(range.startLineNumber);
		const scopedLineTokens = createScopedLineTokens(lineTokens, range.startColumn - 1);
		let slicedTokens;
		if (isLanguageDifferentFromLineStart(this.model, range.getStartPosition())) {
			const columnIndexWithinScope = range.startColumn - 1 - scopedLineTokens.firstCharOffset;
			const firstCharacterOffset = scopedLineTokens.firstCharOffset;
			const lastCharacterOffset = firstCharacterOffset + columnIndexWithinScope;
			slicedTokens = lineTokens.sliceAndInflate(firstCharacterOffset, lastCharacterOffset, 0);
		} else {
			const columnWithinLine = range.startColumn - 1;
			slicedTokens = lineTokens.sliceAndInflate(0, columnWithinLine, 0);
		}
		return this.indentationLineProcessor.getProcessedTokens(slicedTokens);
	}
	_getProcessedTokensAfterRange(range) {
		const position = range.isEmpty() ? range.getStartPosition() : range.getEndPosition();
		this.model.tokenization.forceTokenization(position.lineNumber);
		const lineTokens = this.model.tokenization.getLineTokens(position.lineNumber);
		const scopedLineTokens = createScopedLineTokens(lineTokens, position.column - 1);
		const columnIndexWithinScope = position.column - 1 - scopedLineTokens.firstCharOffset;
		const firstCharacterOffset = scopedLineTokens.firstCharOffset + columnIndexWithinScope;
		const lastCharacterOffset = scopedLineTokens.firstCharOffset + scopedLineTokens.getLineLength();
		const slicedTokens = lineTokens.sliceAndInflate(firstCharacterOffset, lastCharacterOffset, 0);
		return this.indentationLineProcessor.getProcessedTokens(slicedTokens);
	}
	_getProcessedPreviousLineTokens(range) {
		const getScopedLineTokensAtEndColumnOfLine = (lineNumber) => {
			this.model.tokenization.forceTokenization(lineNumber);
			return createScopedLineTokens(this.model.tokenization.getLineTokens(lineNumber), this.model.getLineMaxColumn(lineNumber) - 1);
		};
		this.model.tokenization.forceTokenization(range.startLineNumber);
		const scopedLineTokens = createScopedLineTokens(this.model.tokenization.getLineTokens(range.startLineNumber), range.startColumn - 1);
		const emptyTokens = LineTokens.createEmpty("", scopedLineTokens.languageIdCodec);
		const previousLineNumber = range.startLineNumber - 1;
		if (previousLineNumber === 0) return emptyTokens;
		if (!(scopedLineTokens.firstCharOffset === 0)) return emptyTokens;
		const scopedLineTokensAtEndColumnOfPreviousLine = getScopedLineTokensAtEndColumnOfLine(previousLineNumber);
		if (!(scopedLineTokens.languageId === scopedLineTokensAtEndColumnOfPreviousLine.languageId)) return emptyTokens;
		const previousSlicedLineTokens = scopedLineTokensAtEndColumnOfPreviousLine.toIViewLineTokens();
		return this.indentationLineProcessor.getProcessedTokens(previousSlicedLineTokens);
	}
};
/**
* This class performs the actual processing of the indentation lines.
* The brackets of the language configuration are removed from the regex, string and comment tokens.
*/
var IndentationLineProcessor = class {
	constructor(model, languageConfigurationService) {
		this.model = model;
		this.languageConfigurationService = languageConfigurationService;
	}
	/**
	* Get the processed line for the given line number and potentially adjust the indentation level.
	* Remove the language configuration brackets from the regex, string and comment tokens.
	*/
	getProcessedLine(lineNumber, newIndentation) {
		const replaceIndentation = (line, newIndentation) => {
			const currentIndentation = getLeadingWhitespace(line);
			return newIndentation + line.substring(currentIndentation.length);
		};
		this.model.tokenization.forceTokenization?.(lineNumber);
		const tokens = this.model.tokenization.getLineTokens(lineNumber);
		let processedLine = this.getProcessedTokens(tokens).getLineContent();
		if (newIndentation !== void 0) processedLine = replaceIndentation(processedLine, newIndentation);
		return processedLine;
	}
	/**
	* Process the line with the given tokens, remove the language configuration brackets from the regex, string and comment tokens.
	*/
	getProcessedTokens(tokens) {
		const shouldRemoveBracketsFromTokenType = (tokenType) => {
			return tokenType === 2 || tokenType === 3 || tokenType === 1;
		};
		const languageId = tokens.getLanguageId(0);
		const bracketsRegExp = this.languageConfigurationService.getLanguageConfiguration(languageId).bracketsNew.getBracketRegExp({ global: true });
		const textAndMetadata = [];
		tokens.forEach((tokenIndex) => {
			const tokenType = tokens.getStandardTokenType(tokenIndex);
			let text = tokens.getTokenText(tokenIndex);
			if (shouldRemoveBracketsFromTokenType(tokenType)) text = text.replace(bracketsRegExp, "");
			const metadata = tokens.getMetadata(tokenIndex);
			textAndMetadata.push({
				text,
				metadata
			});
		});
		return LineTokens.createFromTextAndMetadata(textAndMetadata, tokens.languageIdCodec);
	}
};
function isLanguageDifferentFromLineStart(model, position) {
	model.tokenization.forceTokenization(position.lineNumber);
	const lineTokens = model.tokenization.getLineTokens(position.lineNumber);
	const scopedLineTokens = createScopedLineTokens(lineTokens, position.column - 1);
	const doesScopeStartAtOffsetZero = scopedLineTokens.firstCharOffset === 0;
	const isScopedLanguageEqualToFirstLanguageOnLine = lineTokens.getLanguageId(0) === scopedLineTokens.languageId;
	return !doesScopeStartAtOffsetZero && !isScopedLanguageEqualToFirstLanguageOnLine;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/languages/enterAction.js
function getEnterAction(autoIndent, model, range, languageConfigurationService) {
	model.tokenization.forceTokenization(range.startLineNumber);
	const languageId = model.getLanguageIdAtPosition(range.startLineNumber, range.startColumn);
	const richEditSupport = languageConfigurationService.getLanguageConfiguration(languageId);
	if (!richEditSupport) return null;
	const processedContextTokens = new IndentationContextProcessor(model, languageConfigurationService).getProcessedTokenContextAroundRange(range);
	const previousLineText = processedContextTokens.previousLineProcessedTokens.getLineContent();
	const beforeEnterText = processedContextTokens.beforeRangeProcessedTokens.getLineContent();
	const afterEnterText = processedContextTokens.afterRangeProcessedTokens.getLineContent();
	const enterResult = richEditSupport.onEnter(autoIndent, previousLineText, beforeEnterText, afterEnterText);
	if (!enterResult) return null;
	const indentAction = enterResult.indentAction;
	let appendText = enterResult.appendText;
	const removeText = enterResult.removeText || 0;
	if (!appendText) {
		if (indentAction === IndentAction.Indent || indentAction === IndentAction.IndentOutdent) appendText = "	";
		else appendText = "";
	} else if (indentAction === IndentAction.Indent) appendText = "	" + appendText;
	let indentation = getIndentationAtPosition(model, range.startLineNumber, range.startColumn);
	if (removeText) indentation = indentation.substring(0, indentation.length - removeText);
	return {
		indentAction,
		appendText,
		removeText,
		indentation
	};
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/commands/shiftCommand.js
var __decorate$73 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$67 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var ShiftCommand_1;
var repeatCache = Object.create(null);
function cachedStringRepeat(str, count) {
	if (count <= 0) return "";
	if (!repeatCache[str]) repeatCache[str] = ["", str];
	const cache = repeatCache[str];
	for (let i = cache.length; i <= count; i++) cache[i] = cache[i - 1] + str;
	return cache[count];
}
var ShiftCommand = ShiftCommand_1 = class ShiftCommand {
	static unshiftIndent(line, column, tabSize, indentSize, insertSpaces) {
		const contentStartVisibleColumn = CursorColumns.visibleColumnFromColumn(line, column, tabSize);
		if (insertSpaces) return cachedStringRepeat(cachedStringRepeat(" ", indentSize), CursorColumns.prevIndentTabStop(contentStartVisibleColumn, indentSize) / indentSize);
		else return cachedStringRepeat("	", CursorColumns.prevRenderTabStop(contentStartVisibleColumn, tabSize) / tabSize);
	}
	static shiftIndent(line, column, tabSize, indentSize, insertSpaces) {
		const contentStartVisibleColumn = CursorColumns.visibleColumnFromColumn(line, column, tabSize);
		if (insertSpaces) return cachedStringRepeat(cachedStringRepeat(" ", indentSize), CursorColumns.nextIndentTabStop(contentStartVisibleColumn, indentSize) / indentSize);
		else return cachedStringRepeat("	", CursorColumns.nextRenderTabStop(contentStartVisibleColumn, tabSize) / tabSize);
	}
	constructor(range, opts, _languageConfigurationService) {
		this._languageConfigurationService = _languageConfigurationService;
		this._opts = opts;
		this._selection = range;
		this._selectionId = null;
		this._useLastEditRangeForCursorEndPosition = false;
		this._selectionStartColumnStaysPut = false;
	}
	_addEditOperation(builder, range, text) {
		if (this._useLastEditRangeForCursorEndPosition) builder.addTrackedEditOperation(range, text);
		else builder.addEditOperation(range, text);
	}
	getEditOperations(model, builder) {
		const startLine = this._selection.startLineNumber;
		let endLine = this._selection.endLineNumber;
		if (this._selection.endColumn === 1 && startLine !== endLine) endLine = endLine - 1;
		const { tabSize, indentSize, insertSpaces } = this._opts;
		const shouldIndentEmptyLines = startLine === endLine;
		if (this._opts.useTabStops) {
			if (this._selection.isEmpty()) {
				if (/^\s*$/.test(model.getLineContent(startLine))) this._useLastEditRangeForCursorEndPosition = true;
			}
			let previousLineExtraSpaces = 0, extraSpaces = 0;
			for (let lineNumber = startLine; lineNumber <= endLine; lineNumber++, previousLineExtraSpaces = extraSpaces) {
				extraSpaces = 0;
				const lineText = model.getLineContent(lineNumber);
				let indentationEndIndex = firstNonWhitespaceIndex(lineText);
				if (this._opts.isUnshift && (lineText.length === 0 || indentationEndIndex === 0)) continue;
				if (!shouldIndentEmptyLines && !this._opts.isUnshift && lineText.length === 0) continue;
				if (indentationEndIndex === -1) indentationEndIndex = lineText.length;
				if (lineNumber > 1) {
					if (CursorColumns.visibleColumnFromColumn(lineText, indentationEndIndex + 1, tabSize) % indentSize !== 0) {
						if (model.tokenization.isCheapToTokenize(lineNumber - 1)) {
							const enterAction = getEnterAction(this._opts.autoIndent, model, new Range$2(lineNumber - 1, model.getLineMaxColumn(lineNumber - 1), lineNumber - 1, model.getLineMaxColumn(lineNumber - 1)), this._languageConfigurationService);
							if (enterAction) {
								extraSpaces = previousLineExtraSpaces;
								if (enterAction.appendText) for (let j = 0, lenJ = enterAction.appendText.length; j < lenJ && extraSpaces < indentSize; j++) if (enterAction.appendText.charCodeAt(j) === 32) extraSpaces++;
								else break;
								if (enterAction.removeText) extraSpaces = Math.max(0, extraSpaces - enterAction.removeText);
								for (let j = 0; j < extraSpaces; j++) {
									if (indentationEndIndex === 0 || lineText.charCodeAt(indentationEndIndex - 1) !== 32) break;
									indentationEndIndex--;
								}
							}
						}
					}
				}
				if (this._opts.isUnshift && indentationEndIndex === 0) continue;
				let desiredIndent;
				if (this._opts.isUnshift) desiredIndent = ShiftCommand_1.unshiftIndent(lineText, indentationEndIndex + 1, tabSize, indentSize, insertSpaces);
				else desiredIndent = ShiftCommand_1.shiftIndent(lineText, indentationEndIndex + 1, tabSize, indentSize, insertSpaces);
				this._addEditOperation(builder, new Range$2(lineNumber, 1, lineNumber, indentationEndIndex + 1), desiredIndent);
				if (lineNumber === startLine && !this._selection.isEmpty()) this._selectionStartColumnStaysPut = this._selection.startColumn <= indentationEndIndex + 1;
			}
		} else {
			if (!this._opts.isUnshift && this._selection.isEmpty() && model.getLineLength(startLine) === 0) this._useLastEditRangeForCursorEndPosition = true;
			const oneIndent = insertSpaces ? cachedStringRepeat(" ", indentSize) : "	";
			for (let lineNumber = startLine; lineNumber <= endLine; lineNumber++) {
				const lineText = model.getLineContent(lineNumber);
				let indentationEndIndex = firstNonWhitespaceIndex(lineText);
				if (this._opts.isUnshift && (lineText.length === 0 || indentationEndIndex === 0)) continue;
				if (!shouldIndentEmptyLines && !this._opts.isUnshift && lineText.length === 0) continue;
				if (indentationEndIndex === -1) indentationEndIndex = lineText.length;
				if (this._opts.isUnshift && indentationEndIndex === 0) continue;
				if (this._opts.isUnshift) {
					indentationEndIndex = Math.min(indentationEndIndex, indentSize);
					for (let i = 0; i < indentationEndIndex; i++) if (lineText.charCodeAt(i) === 9) {
						indentationEndIndex = i + 1;
						break;
					}
					this._addEditOperation(builder, new Range$2(lineNumber, 1, lineNumber, indentationEndIndex + 1), "");
				} else {
					this._addEditOperation(builder, new Range$2(lineNumber, 1, lineNumber, 1), oneIndent);
					if (lineNumber === startLine && !this._selection.isEmpty()) this._selectionStartColumnStaysPut = this._selection.startColumn === 1;
				}
			}
		}
		this._selectionId = builder.trackSelection(this._selection);
	}
	computeCursorState(model, helper) {
		if (this._useLastEditRangeForCursorEndPosition) {
			const lastOp = helper.getInverseEditOperations()[0];
			return new Selection$1(lastOp.range.endLineNumber, lastOp.range.endColumn, lastOp.range.endLineNumber, lastOp.range.endColumn);
		}
		const result = helper.getTrackedSelection(this._selectionId);
		if (this._selectionStartColumnStaysPut) {
			const initialStartColumn = this._selection.startColumn;
			if (result.startColumn <= initialStartColumn) return result;
			if (result.getDirection() === 0) return new Selection$1(result.startLineNumber, initialStartColumn, result.endLineNumber, result.endColumn);
			return new Selection$1(result.endLineNumber, result.endColumn, result.startLineNumber, initialStartColumn);
		}
		return result;
	}
};
ShiftCommand = ShiftCommand_1 = __decorate$73([__param$67(2, ILanguageConfigurationService)], ShiftCommand);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/commands/surroundSelectionCommand.js
var SurroundSelectionCommand = class {
	constructor(range, charBeforeSelection, charAfterSelection) {
		this._range = range;
		this._charBeforeSelection = charBeforeSelection;
		this._charAfterSelection = charAfterSelection;
	}
	getEditOperations(model, builder) {
		builder.addTrackedEditOperation(new Range$2(this._range.startLineNumber, this._range.startColumn, this._range.startLineNumber, this._range.startColumn), this._charBeforeSelection);
		builder.addTrackedEditOperation(new Range$2(this._range.endLineNumber, this._range.endColumn, this._range.endLineNumber, this._range.endColumn), this._charAfterSelection || null);
	}
	computeCursorState(model, helper) {
		const inverseEditOperations = helper.getInverseEditOperations();
		const firstOperationRange = inverseEditOperations[0].range;
		const secondOperationRange = inverseEditOperations[1].range;
		return new Selection$1(firstOperationRange.endLineNumber, firstOperationRange.endColumn, secondOperationRange.endLineNumber, secondOperationRange.endColumn - this._charAfterSelection.length);
	}
};
/**
* A surround selection command that runs after composition finished.
*/
var CompositionSurroundSelectionCommand = class {
	constructor(_position, _text, _charAfter) {
		this._position = _position;
		this._text = _text;
		this._charAfter = _charAfter;
	}
	getEditOperations(model, builder) {
		builder.addTrackedEditOperation(new Range$2(this._position.lineNumber, this._position.column, this._position.lineNumber, this._position.column), this._text + this._charAfter);
	}
	computeCursorState(model, helper) {
		const opRange = helper.getInverseEditOperations()[0].range;
		return new Selection$1(opRange.endLineNumber, opRange.startColumn, opRange.endLineNumber, opRange.endColumn - this._charAfter.length);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/languages/autoIndent.js
/**
* Get nearest preceding line which doesn't match unIndentPattern or contains all whitespace.
* Result:
* -1: run into the boundary of embedded languages
* 0: every line above are invalid
* else: nearest preceding line of the same language
*/
function getPrecedingValidLine(model, lineNumber, processedIndentRulesSupport) {
	const languageId = model.tokenization.getLanguageIdAtPosition(lineNumber, 0);
	if (lineNumber > 1) {
		let lastLineNumber;
		let resultLineNumber = -1;
		for (lastLineNumber = lineNumber - 1; lastLineNumber >= 1; lastLineNumber--) {
			if (model.tokenization.getLanguageIdAtPosition(lastLineNumber, 0) !== languageId) return resultLineNumber;
			const text = model.getLineContent(lastLineNumber);
			if (processedIndentRulesSupport.shouldIgnore(lastLineNumber) || /^\s+$/.test(text) || text === "") {
				resultLineNumber = lastLineNumber;
				continue;
			}
			return lastLineNumber;
		}
	}
	return -1;
}
/**
* Get inherited indentation from above lines.
* 1. Find the nearest preceding line which doesn't match unIndentedLinePattern.
* 2. If this line matches indentNextLinePattern or increaseIndentPattern, it means that the indent level of `lineNumber` should be 1 greater than this line.
* 3. If this line doesn't match any indent rules
*   a. check whether the line above it matches indentNextLinePattern
*   b. If not, the indent level of this line is the result
*   c. If so, it means the indent of this line is *temporary*, go upward utill we find a line whose indent is not temporary (the same workflow a -> b -> c).
* 4. Otherwise, we fail to get an inherited indent from aboves. Return null and we should not touch the indent of `lineNumber`
*
* This function only return the inherited indent based on above lines, it doesn't check whether current line should decrease or not.
*/
function getInheritIndentForLine(autoIndent, model, lineNumber, honorIntentialIndent = true, languageConfigurationService) {
	if (autoIndent < 4) return null;
	const indentRulesSupport = languageConfigurationService.getLanguageConfiguration(model.tokenization.getLanguageId()).indentRulesSupport;
	if (!indentRulesSupport) return null;
	const processedIndentRulesSupport = new ProcessedIndentRulesSupport(model, indentRulesSupport, languageConfigurationService);
	if (lineNumber <= 1) return {
		indentation: "",
		action: null
	};
	for (let priorLineNumber = lineNumber - 1; priorLineNumber > 0; priorLineNumber--) {
		if (model.getLineContent(priorLineNumber) !== "") break;
		if (priorLineNumber === 1) return {
			indentation: "",
			action: null
		};
	}
	const precedingUnIgnoredLine = getPrecedingValidLine(model, lineNumber, processedIndentRulesSupport);
	if (precedingUnIgnoredLine < 0) return null;
	else if (precedingUnIgnoredLine < 1) return {
		indentation: "",
		action: null
	};
	if (processedIndentRulesSupport.shouldIncrease(precedingUnIgnoredLine) || processedIndentRulesSupport.shouldIndentNextLine(precedingUnIgnoredLine)) {
		const precedingUnIgnoredLineContent = model.getLineContent(precedingUnIgnoredLine);
		return {
			indentation: getLeadingWhitespace(precedingUnIgnoredLineContent),
			action: IndentAction.Indent,
			line: precedingUnIgnoredLine
		};
	} else if (processedIndentRulesSupport.shouldDecrease(precedingUnIgnoredLine)) {
		const precedingUnIgnoredLineContent = model.getLineContent(precedingUnIgnoredLine);
		return {
			indentation: getLeadingWhitespace(precedingUnIgnoredLineContent),
			action: null,
			line: precedingUnIgnoredLine
		};
	} else {
		if (precedingUnIgnoredLine === 1) return {
			indentation: getLeadingWhitespace(model.getLineContent(precedingUnIgnoredLine)),
			action: null,
			line: precedingUnIgnoredLine
		};
		const previousLine = precedingUnIgnoredLine - 1;
		const previousLineIndentMetadata = indentRulesSupport.getIndentMetadata(model.getLineContent(previousLine));
		if (!(previousLineIndentMetadata & 3) && previousLineIndentMetadata & 4) {
			let stopLine = 0;
			for (let i = previousLine - 1; i > 0; i--) {
				if (processedIndentRulesSupport.shouldIndentNextLine(i)) continue;
				stopLine = i;
				break;
			}
			return {
				indentation: getLeadingWhitespace(model.getLineContent(stopLine + 1)),
				action: null,
				line: stopLine + 1
			};
		}
		if (honorIntentialIndent) return {
			indentation: getLeadingWhitespace(model.getLineContent(precedingUnIgnoredLine)),
			action: null,
			line: precedingUnIgnoredLine
		};
		else {
			for (let i = precedingUnIgnoredLine; i > 0; i--) if (processedIndentRulesSupport.shouldIncrease(i)) return {
				indentation: getLeadingWhitespace(model.getLineContent(i)),
				action: IndentAction.Indent,
				line: i
			};
			else if (processedIndentRulesSupport.shouldIndentNextLine(i)) {
				let stopLine = 0;
				for (let j = i - 1; j > 0; j--) {
					if (processedIndentRulesSupport.shouldIndentNextLine(i)) continue;
					stopLine = j;
					break;
				}
				return {
					indentation: getLeadingWhitespace(model.getLineContent(stopLine + 1)),
					action: null,
					line: stopLine + 1
				};
			} else if (processedIndentRulesSupport.shouldDecrease(i)) return {
				indentation: getLeadingWhitespace(model.getLineContent(i)),
				action: null,
				line: i
			};
			return {
				indentation: getLeadingWhitespace(model.getLineContent(1)),
				action: null,
				line: 1
			};
		}
	}
}
function getGoodIndentForLine(autoIndent, virtualModel, languageId, lineNumber, indentConverter, languageConfigurationService) {
	if (autoIndent < 4) return null;
	const richEditSupport = languageConfigurationService.getLanguageConfiguration(languageId);
	if (!richEditSupport) return null;
	const indentRulesSupport = languageConfigurationService.getLanguageConfiguration(languageId).indentRulesSupport;
	if (!indentRulesSupport) return null;
	const processedIndentRulesSupport = new ProcessedIndentRulesSupport(virtualModel, indentRulesSupport, languageConfigurationService);
	const indent = getInheritIndentForLine(autoIndent, virtualModel, lineNumber, void 0, languageConfigurationService);
	if (indent) {
		const inheritLine = indent.line;
		if (inheritLine !== void 0) {
			let shouldApplyEnterRules = true;
			for (let inBetweenLine = inheritLine; inBetweenLine < lineNumber - 1; inBetweenLine++) if (!/^\s*$/.test(virtualModel.getLineContent(inBetweenLine))) {
				shouldApplyEnterRules = false;
				break;
			}
			if (shouldApplyEnterRules) {
				const enterResult = richEditSupport.onEnter(autoIndent, "", virtualModel.getLineContent(inheritLine), "");
				if (enterResult) {
					let indentation = getLeadingWhitespace(virtualModel.getLineContent(inheritLine));
					if (enterResult.removeText) indentation = indentation.substring(0, indentation.length - enterResult.removeText);
					if (enterResult.indentAction === IndentAction.Indent || enterResult.indentAction === IndentAction.IndentOutdent) indentation = indentConverter.shiftIndent(indentation);
					else if (enterResult.indentAction === IndentAction.Outdent) indentation = indentConverter.unshiftIndent(indentation);
					if (processedIndentRulesSupport.shouldDecrease(lineNumber)) indentation = indentConverter.unshiftIndent(indentation);
					if (enterResult.appendText) indentation += enterResult.appendText;
					return getLeadingWhitespace(indentation);
				}
			}
		}
		if (processedIndentRulesSupport.shouldDecrease(lineNumber)) {
			if (indent.action === IndentAction.Indent) return indent.indentation;
			else return indentConverter.unshiftIndent(indent.indentation);
		} else if (indent.action === IndentAction.Indent) return indentConverter.shiftIndent(indent.indentation);
		else return indent.indentation;
	}
	return null;
}
function getIndentForEnter(autoIndent, model, range, indentConverter, languageConfigurationService) {
	if (autoIndent < 4) return null;
	const languageId = model.getLanguageIdAtPosition(range.startLineNumber, range.startColumn);
	const indentRulesSupport = languageConfigurationService.getLanguageConfiguration(languageId).indentRulesSupport;
	if (!indentRulesSupport) return null;
	model.tokenization.forceTokenization(range.startLineNumber);
	const processedContextTokens = new IndentationContextProcessor(model, languageConfigurationService).getProcessedTokenContextAroundRange(range);
	const afterEnterProcessedTokens = processedContextTokens.afterRangeProcessedTokens;
	const beforeEnterProcessedTokens = processedContextTokens.beforeRangeProcessedTokens;
	const beforeEnterIndent = getLeadingWhitespace(beforeEnterProcessedTokens.getLineContent());
	const virtualModel = createVirtualModelWithModifiedTokensAtLine(model, range.startLineNumber, beforeEnterProcessedTokens);
	const languageIsDifferentFromLineStart = isLanguageDifferentFromLineStart(model, range.getStartPosition());
	const currentLine = model.getLineContent(range.startLineNumber);
	const currentLineIndent = getLeadingWhitespace(currentLine);
	const afterEnterAction = getInheritIndentForLine(autoIndent, virtualModel, range.startLineNumber + 1, void 0, languageConfigurationService);
	if (!afterEnterAction) {
		const beforeEnter = languageIsDifferentFromLineStart ? currentLineIndent : beforeEnterIndent;
		return {
			beforeEnter,
			afterEnter: beforeEnter
		};
	}
	let afterEnterIndent = languageIsDifferentFromLineStart ? currentLineIndent : afterEnterAction.indentation;
	if (afterEnterAction.action === IndentAction.Indent) afterEnterIndent = indentConverter.shiftIndent(afterEnterIndent);
	if (indentRulesSupport.shouldDecrease(afterEnterProcessedTokens.getLineContent())) afterEnterIndent = indentConverter.unshiftIndent(afterEnterIndent);
	return {
		beforeEnter: languageIsDifferentFromLineStart ? currentLineIndent : beforeEnterIndent,
		afterEnter: afterEnterIndent
	};
}
/**
* We should always allow intentional indentation. It means, if users change the indentation of `lineNumber` and the content of
* this line doesn't match decreaseIndentPattern, we should not adjust the indentation.
*/
function getIndentActionForType(cursorConfig, model, range, ch, indentConverter, languageConfigurationService) {
	const autoIndent = cursorConfig.autoIndent;
	if (autoIndent < 4) return null;
	if (isLanguageDifferentFromLineStart(model, range.getStartPosition())) return null;
	const languageId = model.getLanguageIdAtPosition(range.startLineNumber, range.startColumn);
	const indentRulesSupport = languageConfigurationService.getLanguageConfiguration(languageId).indentRulesSupport;
	if (!indentRulesSupport) return null;
	const processedContextTokens = new IndentationContextProcessor(model, languageConfigurationService).getProcessedTokenContextAroundRange(range);
	const beforeRangeText = processedContextTokens.beforeRangeProcessedTokens.getLineContent();
	const afterRangeText = processedContextTokens.afterRangeProcessedTokens.getLineContent();
	const textAroundRange = beforeRangeText + afterRangeText;
	const textAroundRangeWithCharacter = beforeRangeText + ch + afterRangeText;
	if (!indentRulesSupport.shouldDecrease(textAroundRange) && indentRulesSupport.shouldDecrease(textAroundRangeWithCharacter)) {
		const r = getInheritIndentForLine(autoIndent, model, range.startLineNumber, false, languageConfigurationService);
		if (!r) return null;
		let indentation = r.indentation;
		if (r.action !== IndentAction.Indent) indentation = indentConverter.unshiftIndent(indentation);
		return indentation;
	}
	const previousLineNumber = range.startLineNumber - 1;
	if (range.isEmpty() && previousLineNumber > 0) {
		const previousLine = model.getLineContent(previousLineNumber);
		if (indentRulesSupport.shouldIndentNextLine(previousLine) && indentRulesSupport.shouldIncrease(textAroundRangeWithCharacter)) {
			const inheritedIndentation = getInheritIndentForLine(autoIndent, model, range.startLineNumber, false, languageConfigurationService)?.indentation;
			if (inheritedIndentation !== void 0) {
				const currentLine = model.getLineContent(range.startLineNumber);
				const actualCurrentIndentation = getLeadingWhitespace(currentLine);
				const inferredIndentationEqualsActual = indentConverter.shiftIndent(inheritedIndentation) === actualCurrentIndentation;
				const textAroundRangeContainsOnlyWhitespace = /^\s*$/.test(textAroundRange);
				const autoClosingPairs = cursorConfig.autoClosingPairs.autoClosingPairsOpenByEnd.get(ch);
				const isChFirstNonWhitespaceCharacterAndInAutoClosingPair = autoClosingPairs && autoClosingPairs.length > 0 && textAroundRangeContainsOnlyWhitespace;
				if (inferredIndentationEqualsActual && isChFirstNonWhitespaceCharacterAndInAutoClosingPair) return inheritedIndentation;
			}
		}
	}
	return null;
}
function getIndentMetadata(model, lineNumber, languageConfigurationService) {
	const indentRulesSupport = languageConfigurationService.getLanguageConfiguration(model.getLanguageId()).indentRulesSupport;
	if (!indentRulesSupport) return null;
	if (lineNumber < 1 || lineNumber > model.getLineCount()) return null;
	return indentRulesSupport.getIndentMetadata(model.getLineContent(lineNumber));
}
function createVirtualModelWithModifiedTokensAtLine(model, modifiedLineNumber, modifiedTokens) {
	return {
		tokenization: {
			getLineTokens: (lineNumber) => {
				if (lineNumber === modifiedLineNumber) return modifiedTokens;
				else return model.tokenization.getLineTokens(lineNumber);
			},
			getLanguageId: () => {
				return model.getLanguageId();
			},
			getLanguageIdAtPosition: (lineNumber, column) => {
				return model.getLanguageIdAtPosition(lineNumber, column);
			}
		},
		getLineContent: (lineNumber) => {
			if (lineNumber === modifiedLineNumber) return modifiedTokens.getLineContent();
			else return model.getLineContent(lineNumber);
		}
	};
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/cursor/cursorTypeEditOperations.js
var AutoIndentOperation = class {
	static getEdits(config, model, selections, ch, isDoingComposition) {
		if (!isDoingComposition && this._isAutoIndentType(config, model, selections)) {
			const indentationForSelections = [];
			for (const selection of selections) {
				const indentation = this._findActualIndentationForSelection(config, model, selection, ch);
				if (indentation === null) return;
				indentationForSelections.push({
					selection,
					indentation
				});
			}
			const autoClosingPairClose = AutoClosingOpenCharTypeOperation.getAutoClosingPairClose(config, model, selections, ch, false);
			return this._getIndentationAndAutoClosingPairEdits(config, model, indentationForSelections, ch, autoClosingPairClose);
		}
	}
	static _isAutoIndentType(config, model, selections) {
		if (config.autoIndent < 4) return false;
		for (let i = 0, len = selections.length; i < len; i++) if (!model.tokenization.isCheapToTokenize(selections[i].getEndPosition().lineNumber)) return false;
		return true;
	}
	static _findActualIndentationForSelection(config, model, selection, ch) {
		const actualIndentation = getIndentActionForType(config, model, selection, ch, {
			shiftIndent: (indentation) => {
				return shiftIndent(config, indentation);
			},
			unshiftIndent: (indentation) => {
				return unshiftIndent(config, indentation);
			}
		}, config.languageConfigurationService);
		if (actualIndentation === null) return null;
		const currentIndentation = getIndentationAtPosition(model, selection.startLineNumber, selection.startColumn);
		if (actualIndentation === config.normalizeIndentation(currentIndentation)) return null;
		return actualIndentation;
	}
	static _getIndentationAndAutoClosingPairEdits(config, model, indentationForSelections, ch, autoClosingPairClose) {
		return new EditOperationResult(4, indentationForSelections.map(({ selection, indentation }) => {
			if (autoClosingPairClose !== null) return new TypeWithIndentationAndAutoClosingCommand(this._getEditFromIndentationAndSelection(config, model, indentation, selection, ch, false), selection, ch, autoClosingPairClose);
			else {
				const indentationEdit = this._getEditFromIndentationAndSelection(config, model, indentation, selection, ch, true);
				return typeCommand(indentationEdit.range, indentationEdit.text, false);
			}
		}), {
			shouldPushStackElementBefore: true,
			shouldPushStackElementAfter: false
		});
	}
	static _getEditFromIndentationAndSelection(config, model, indentation, selection, ch, includeChInEdit = true) {
		const startLineNumber = selection.startLineNumber;
		const firstNonWhitespaceColumn = model.getLineFirstNonWhitespaceColumn(startLineNumber);
		let text = config.normalizeIndentation(indentation);
		if (firstNonWhitespaceColumn !== 0) {
			const startLine = model.getLineContent(startLineNumber);
			text += startLine.substring(firstNonWhitespaceColumn - 1, selection.startColumn - 1);
		}
		text += includeChInEdit ? ch : "";
		return {
			range: new Range$2(startLineNumber, 1, selection.endLineNumber, selection.endColumn),
			text
		};
	}
};
var AutoClosingOvertypeOperation = class {
	static getEdits(prevEditOperationType, config, model, selections, autoClosedCharacters, ch) {
		if (isAutoClosingOvertype(config, model, selections, autoClosedCharacters, ch)) return this._runAutoClosingOvertype(prevEditOperationType, selections, ch);
	}
	static _runAutoClosingOvertype(prevEditOperationType, selections, ch) {
		const commands = [];
		for (let i = 0, len = selections.length; i < len; i++) {
			const position = selections[i].getPosition();
			const typeSelection = new Range$2(position.lineNumber, position.column, position.lineNumber, position.column + 1);
			commands[i] = new ReplaceCommand(typeSelection, ch);
		}
		return new EditOperationResult(4, commands, {
			shouldPushStackElementBefore: shouldPushStackElementBetween(prevEditOperationType, 4),
			shouldPushStackElementAfter: false
		});
	}
};
var AutoClosingOvertypeWithInterceptorsOperation = class {
	static getEdits(config, model, selections, autoClosedCharacters, ch) {
		if (isAutoClosingOvertype(config, model, selections, autoClosedCharacters, ch)) return new EditOperationResult(4, selections.map((s) => new ReplaceCommand(new Range$2(s.positionLineNumber, s.positionColumn, s.positionLineNumber, s.positionColumn + 1), "", false)), {
			shouldPushStackElementBefore: true,
			shouldPushStackElementAfter: false
		});
	}
};
var AutoClosingOpenCharTypeOperation = class {
	static getEdits(config, model, selections, ch, chIsAlreadyTyped, isDoingComposition) {
		if (!isDoingComposition) {
			const autoClosingPairClose = this.getAutoClosingPairClose(config, model, selections, ch, chIsAlreadyTyped);
			if (autoClosingPairClose !== null) return this._runAutoClosingOpenCharType(selections, ch, chIsAlreadyTyped, autoClosingPairClose);
		}
	}
	static _runAutoClosingOpenCharType(selections, ch, chIsAlreadyTyped, autoClosingPairClose) {
		const commands = [];
		for (let i = 0, len = selections.length; i < len; i++) {
			const selection = selections[i];
			commands[i] = new TypeWithAutoClosingCommand(selection, ch, !chIsAlreadyTyped, autoClosingPairClose);
		}
		return new EditOperationResult(4, commands, {
			shouldPushStackElementBefore: true,
			shouldPushStackElementAfter: false
		});
	}
	static getAutoClosingPairClose(config, model, selections, ch, chIsAlreadyTyped) {
		for (const selection of selections) if (!selection.isEmpty()) return null;
		const positions = selections.map((s) => {
			const position = s.getPosition();
			if (chIsAlreadyTyped) return {
				lineNumber: position.lineNumber,
				beforeColumn: position.column - ch.length,
				afterColumn: position.column
			};
			else return {
				lineNumber: position.lineNumber,
				beforeColumn: position.column,
				afterColumn: position.column
			};
		});
		const pair = this._findAutoClosingPairOpen(config, model, positions.map((p) => new Position$1(p.lineNumber, p.beforeColumn)), ch);
		if (!pair) return null;
		let autoCloseConfig;
		let shouldAutoCloseBefore;
		let shouldCheckBracketBalance = false;
		if (isQuote(ch)) {
			autoCloseConfig = config.autoClosingQuotes;
			shouldAutoCloseBefore = config.shouldAutoCloseBefore.quote;
		} else if (config.blockCommentStartToken ? pair.open.includes(config.blockCommentStartToken) : false) {
			autoCloseConfig = config.autoClosingComments;
			shouldAutoCloseBefore = config.shouldAutoCloseBefore.comment;
		} else {
			autoCloseConfig = config.autoClosingBrackets;
			shouldAutoCloseBefore = config.shouldAutoCloseBefore.bracket;
			shouldCheckBracketBalance = true;
		}
		if (autoCloseConfig === "never") return null;
		const containedPair = this._findContainedAutoClosingPair(config, pair);
		const containedPairClose = containedPair ? containedPair.close : "";
		let isContainedPairPresent = true;
		for (const position of positions) {
			const { lineNumber, beforeColumn, afterColumn } = position;
			const lineText = model.getLineContent(lineNumber);
			const lineBefore = lineText.substring(0, beforeColumn - 1);
			const lineAfter = lineText.substring(afterColumn - 1);
			if (!lineAfter.startsWith(containedPairClose)) isContainedPairPresent = false;
			if (lineAfter.length > 0) {
				const characterAfter = lineAfter.charAt(0);
				if (!this._isBeforeClosingBrace(config, lineAfter) && !shouldAutoCloseBefore(characterAfter)) return null;
			}
			if (shouldCheckBracketBalance && autoCloseConfig !== "always" && !chIsAlreadyTyped && model.bracketPairs.hasUnmatchedClosingBracketAfter(new Position$1(lineNumber, beforeColumn), pair.open)) return null;
			if (pair.open.length === 1 && (ch === "'" || ch === "\"") && autoCloseConfig !== "always") {
				const wordSeparators = getMapForWordSeparators(config.wordSeparators, []);
				if (lineBefore.length > 0) {
					const characterBefore = lineBefore.charCodeAt(lineBefore.length - 1);
					if (wordSeparators.get(characterBefore) === 0) return null;
				}
			}
			if (!model.tokenization.isCheapToTokenize(lineNumber)) return null;
			model.tokenization.forceTokenization(lineNumber);
			const scopedLineTokens = createScopedLineTokens(model.tokenization.getLineTokens(lineNumber), beforeColumn - 1);
			if (!pair.shouldAutoClose(scopedLineTokens, beforeColumn - scopedLineTokens.firstCharOffset)) return null;
			const neutralCharacter = pair.findNeutralCharacter();
			if (neutralCharacter) {
				const tokenType = model.tokenization.getTokenTypeIfInsertingCharacter(lineNumber, beforeColumn, neutralCharacter);
				if (!pair.isOK(tokenType)) return null;
			}
		}
		if (isContainedPairPresent) return pair.close.substring(0, pair.close.length - containedPairClose.length);
		else return pair.close;
	}
	/**
	* Find another auto-closing pair that is contained by the one passed in.
	*
	* e.g. when having [(,)] and [(*,*)] as auto-closing pairs
	* this method will find [(,)] as a containment pair for [(*,*)]
	*/
	static _findContainedAutoClosingPair(config, pair) {
		if (pair.open.length <= 1) return null;
		const lastChar = pair.close.charAt(pair.close.length - 1);
		const candidates = config.autoClosingPairs.autoClosingPairsCloseByEnd.get(lastChar) || [];
		let result = null;
		for (const candidate of candidates) if (candidate.open !== pair.open && pair.open.includes(candidate.open) && pair.close.endsWith(candidate.close)) {
			if (!result || candidate.open.length > result.open.length) result = candidate;
		}
		return result;
	}
	/**
	* Determine if typing `ch` at all `positions` in the `model` results in an
	* auto closing open sequence being typed.
	*
	* Auto closing open sequences can consist of multiple characters, which
	* can lead to ambiguities. In such a case, the longest auto-closing open
	* sequence is returned.
	*/
	static _findAutoClosingPairOpen(config, model, positions, ch) {
		const candidates = config.autoClosingPairs.autoClosingPairsOpenByEnd.get(ch);
		if (!candidates) return null;
		let result = null;
		for (const candidate of candidates) if (result === null || candidate.open.length > result.open.length) {
			let candidateIsMatch = true;
			for (const position of positions) if (model.getValueInRange(new Range$2(position.lineNumber, position.column - candidate.open.length + 1, position.lineNumber, position.column)) + ch !== candidate.open) {
				candidateIsMatch = false;
				break;
			}
			if (candidateIsMatch) result = candidate;
		}
		return result;
	}
	static _isBeforeClosingBrace(config, lineAfter) {
		const nextChar = lineAfter.charAt(0);
		const potentialStartingBraces = config.autoClosingPairs.autoClosingPairsOpenByStart.get(nextChar) || [];
		const potentialClosingBraces = config.autoClosingPairs.autoClosingPairsCloseByStart.get(nextChar) || [];
		const isBeforeStartingBrace = potentialStartingBraces.some((x) => lineAfter.startsWith(x.open));
		const isBeforeClosingBrace = potentialClosingBraces.some((x) => lineAfter.startsWith(x.close));
		return !isBeforeStartingBrace && isBeforeClosingBrace;
	}
};
var CompositionEndOvertypeOperation = class {
	static getEdits(config, compositions) {
		if (!(config.inputMode === "overtype")) return null;
		return new EditOperationResult(4, compositions.map((composition) => new ReplaceOvertypeCommandOnCompositionEnd(composition.insertedTextRange)), {
			shouldPushStackElementBefore: true,
			shouldPushStackElementAfter: false
		});
	}
};
var SurroundSelectionOperation = class {
	static getEdits(config, model, selections, ch, isDoingComposition) {
		if (!isDoingComposition && this._isSurroundSelectionType(config, model, selections, ch)) return this._runSurroundSelectionType(config, selections, ch);
	}
	static _runSurroundSelectionType(config, selections, ch) {
		const commands = [];
		for (let i = 0, len = selections.length; i < len; i++) {
			const selection = selections[i];
			const closeCharacter = config.surroundingPairs[ch];
			commands[i] = new SurroundSelectionCommand(selection, ch, closeCharacter);
		}
		return new EditOperationResult(0, commands, {
			shouldPushStackElementBefore: true,
			shouldPushStackElementAfter: true
		});
	}
	static _isSurroundSelectionType(config, model, selections, ch) {
		if (!shouldSurroundChar(config, ch) || !config.surroundingPairs.hasOwnProperty(ch)) return false;
		const isTypingAQuoteCharacter = isQuote(ch);
		for (const selection of selections) {
			if (selection.isEmpty()) return false;
			let selectionContainsOnlyWhitespace = true;
			for (let lineNumber = selection.startLineNumber; lineNumber <= selection.endLineNumber; lineNumber++) {
				const lineText = model.getLineContent(lineNumber);
				const startIndex = lineNumber === selection.startLineNumber ? selection.startColumn - 1 : 0;
				const endIndex = lineNumber === selection.endLineNumber ? selection.endColumn - 1 : lineText.length;
				const selectedText = lineText.substring(startIndex, endIndex);
				if (/[^ \t]/.test(selectedText)) {
					selectionContainsOnlyWhitespace = false;
					break;
				}
			}
			if (selectionContainsOnlyWhitespace) return false;
			if (isTypingAQuoteCharacter && selection.startLineNumber === selection.endLineNumber && selection.startColumn + 1 === selection.endColumn) {
				if (isQuote(model.getValueInRange(selection))) return false;
			}
		}
		return true;
	}
};
var InterceptorElectricCharOperation = class {
	static getEdits(prevEditOperationType, config, model, selections, ch, isDoingComposition) {
		if (!isDoingComposition && this._isTypeInterceptorElectricChar(config, model, selections)) {
			const r = this._typeInterceptorElectricChar(prevEditOperationType, config, model, selections[0], ch);
			if (r) return r;
		}
	}
	static _isTypeInterceptorElectricChar(config, model, selections) {
		if (selections.length === 1 && model.tokenization.isCheapToTokenize(selections[0].getEndPosition().lineNumber)) return true;
		return false;
	}
	static _typeInterceptorElectricChar(prevEditOperationType, config, model, selection, ch) {
		if (!config.electricChars.hasOwnProperty(ch) || !selection.isEmpty()) return null;
		const position = selection.getPosition();
		model.tokenization.forceTokenization(position.lineNumber);
		const lineTokens = model.tokenization.getLineTokens(position.lineNumber);
		let electricAction;
		try {
			electricAction = config.onElectricCharacter(ch, lineTokens, position.column);
		} catch (e) {
			onUnexpectedError(e);
			return null;
		}
		if (!electricAction) return null;
		if (electricAction.matchOpenBracket) {
			const endColumn = (lineTokens.getLineContent() + ch).lastIndexOf(electricAction.matchOpenBracket) + 1;
			const match = model.bracketPairs.findMatchingBracketUp(electricAction.matchOpenBracket, {
				lineNumber: position.lineNumber,
				column: endColumn
			}, 500);
			if (match) {
				if (match.startLineNumber === position.lineNumber) return null;
				const matchLine = model.getLineContent(match.startLineNumber);
				const matchLineIndentation = getLeadingWhitespace(matchLine);
				const newIndentation = config.normalizeIndentation(matchLineIndentation);
				const lineText = model.getLineContent(position.lineNumber);
				const lineFirstNonBlankColumn = model.getLineFirstNonWhitespaceColumn(position.lineNumber) || position.column;
				const typeText = newIndentation + lineText.substring(lineFirstNonBlankColumn - 1, position.column - 1) + ch;
				const command = new ReplaceCommand(new Range$2(position.lineNumber, 1, position.lineNumber, position.column), typeText);
				return new EditOperationResult(getTypingOperation(typeText, prevEditOperationType), [command], {
					shouldPushStackElementBefore: false,
					shouldPushStackElementAfter: true
				});
			}
		}
		return null;
	}
};
var SimpleCharacterTypeOperation = class {
	static getEdits(config, prevEditOperationType, selections, ch, isDoingComposition) {
		const commands = [];
		for (let i = 0, len = selections.length; i < len; i++) {
			const ChosenReplaceCommand = config.inputMode === "overtype" && !isDoingComposition ? ReplaceOvertypeCommand : ReplaceCommand;
			commands[i] = new ChosenReplaceCommand(selections[i], ch);
		}
		const opType = getTypingOperation(ch, prevEditOperationType);
		return new EditOperationResult(opType, commands, {
			shouldPushStackElementBefore: shouldPushStackElementBetween(prevEditOperationType, opType),
			shouldPushStackElementAfter: false
		});
	}
};
var EnterOperation = class {
	static getEdits(config, model, selections, ch, isDoingComposition) {
		if (!isDoingComposition && ch === "\n") {
			const commands = [];
			for (let i = 0, len = selections.length; i < len; i++) commands[i] = this._enter(config, model, false, selections[i]);
			return new EditOperationResult(4, commands, {
				shouldPushStackElementBefore: true,
				shouldPushStackElementAfter: false
			});
		}
	}
	static _enter(config, model, keepPosition, range) {
		if (config.autoIndent === 0) return typeCommand(range, "\n", keepPosition);
		if (!model.tokenization.isCheapToTokenize(range.getStartPosition().lineNumber) || config.autoIndent === 1) {
			const lineText = model.getLineContent(range.startLineNumber);
			const indentation = getLeadingWhitespace(lineText).substring(0, range.startColumn - 1);
			return typeCommand(range, "\n" + config.normalizeIndentation(indentation), keepPosition);
		}
		const r = getEnterAction(config.autoIndent, model, range, config.languageConfigurationService);
		if (r) {
			if (r.indentAction === IndentAction.None) return typeCommand(range, "\n" + config.normalizeIndentation(r.indentation + r.appendText), keepPosition);
			else if (r.indentAction === IndentAction.Indent) return typeCommand(range, "\n" + config.normalizeIndentation(r.indentation + r.appendText), keepPosition);
			else if (r.indentAction === IndentAction.IndentOutdent) {
				const normalIndent = config.normalizeIndentation(r.indentation);
				const increasedIndent = config.normalizeIndentation(r.indentation + r.appendText);
				const typeText = "\n" + increasedIndent + "\n" + normalIndent;
				if (keepPosition) return new ReplaceCommandWithoutChangingPosition(range, typeText, true);
				else return new ReplaceCommandWithOffsetCursorState(range, typeText, -1, increasedIndent.length - normalIndent.length, true);
			} else if (r.indentAction === IndentAction.Outdent) {
				const actualIndentation = unshiftIndent(config, r.indentation);
				return typeCommand(range, "\n" + config.normalizeIndentation(actualIndentation + r.appendText), keepPosition);
			}
		}
		const lineText = model.getLineContent(range.startLineNumber);
		const indentation = getLeadingWhitespace(lineText).substring(0, range.startColumn - 1);
		if (config.autoIndent >= 4) {
			const ir = getIndentForEnter(config.autoIndent, model, range, {
				unshiftIndent: (indent) => {
					return unshiftIndent(config, indent);
				},
				shiftIndent: (indent) => {
					return shiftIndent(config, indent);
				},
				normalizeIndentation: (indent) => {
					return config.normalizeIndentation(indent);
				}
			}, config.languageConfigurationService);
			if (ir) {
				let oldEndViewColumn = config.visibleColumnFromColumn(model, range.getEndPosition());
				const oldEndColumn = range.endColumn;
				const newLineContent = model.getLineContent(range.endLineNumber);
				const firstNonWhitespace = firstNonWhitespaceIndex(newLineContent);
				if (firstNonWhitespace >= 0) range = range.setEndPosition(range.endLineNumber, Math.max(range.endColumn, firstNonWhitespace + 1));
				else range = range.setEndPosition(range.endLineNumber, model.getLineMaxColumn(range.endLineNumber));
				if (keepPosition) return new ReplaceCommandWithoutChangingPosition(range, "\n" + config.normalizeIndentation(ir.afterEnter), true);
				else {
					let offset = 0;
					if (oldEndColumn <= firstNonWhitespace + 1) {
						if (!config.insertSpaces) oldEndViewColumn = Math.ceil(oldEndViewColumn / config.indentSize);
						offset = Math.min(oldEndViewColumn + 1 - config.normalizeIndentation(ir.afterEnter).length - 1, 0);
					}
					return new ReplaceCommandWithOffsetCursorState(range, "\n" + config.normalizeIndentation(ir.afterEnter), 0, offset, true);
				}
			}
		}
		return typeCommand(range, "\n" + config.normalizeIndentation(indentation), keepPosition);
	}
	static lineInsertBefore(config, model, selections) {
		if (model === null || selections === null) return [];
		const commands = [];
		for (let i = 0, len = selections.length; i < len; i++) {
			let lineNumber = selections[i].positionLineNumber;
			if (lineNumber === 1) commands[i] = new ReplaceCommandWithoutChangingPosition(new Range$2(1, 1, 1, 1), "\n");
			else {
				lineNumber--;
				const column = model.getLineMaxColumn(lineNumber);
				commands[i] = this._enter(config, model, false, new Range$2(lineNumber, column, lineNumber, column));
			}
		}
		return commands;
	}
	static lineInsertAfter(config, model, selections) {
		if (model === null || selections === null) return [];
		const commands = [];
		for (let i = 0, len = selections.length; i < len; i++) {
			const lineNumber = selections[i].positionLineNumber;
			const column = model.getLineMaxColumn(lineNumber);
			commands[i] = this._enter(config, model, false, new Range$2(lineNumber, column, lineNumber, column));
		}
		return commands;
	}
	static lineBreakInsert(config, model, selections) {
		const commands = [];
		for (let i = 0, len = selections.length; i < len; i++) commands[i] = this._enter(config, model, true, selections[i]);
		return commands;
	}
};
var PasteOperation = class {
	static getEdits(config, model, selections, text, pasteOnNewLine, multicursorText) {
		const distributedPaste = this._distributePasteToCursors(config, selections, text, pasteOnNewLine, multicursorText);
		if (distributedPaste) {
			selections = selections.sort(Range$2.compareRangesUsingStarts);
			return this._distributedPaste(config, model, selections, distributedPaste);
		} else return this._simplePaste(config, model, selections, text, pasteOnNewLine);
	}
	static _distributePasteToCursors(config, selections, text, pasteOnNewLine, multicursorText) {
		if (selections.length === 1) return null;
		if (multicursorText && multicursorText.length === selections.length) return multicursorText;
		if (pasteOnNewLine) return null;
		if (config.multiCursorPaste === "spread") {
			if (text.charCodeAt(text.length - 1) === 10) text = text.substring(0, text.length - 1);
			if (text.charCodeAt(text.length - 1) === 13) text = text.substring(0, text.length - 1);
			const lines = splitLines(text);
			if (lines.length === selections.length) return lines;
		}
		return null;
	}
	static _distributedPaste(config, model, selections, text) {
		const commands = [];
		for (let i = 0, len = selections.length; i < len; i++) {
			const ChosenReplaceCommand = config.overtypeOnPaste && config.inputMode === "overtype" ? ReplaceOvertypeCommand : ReplaceCommand;
			commands[i] = new ChosenReplaceCommand(selections[i], text[i]);
		}
		return new EditOperationResult(0, commands, {
			shouldPushStackElementBefore: true,
			shouldPushStackElementAfter: true
		});
	}
	static _simplePaste(config, model, selections, text, pasteOnNewLine) {
		const commands = [];
		for (let i = 0, len = selections.length; i < len; i++) {
			const selection = selections[i];
			const position = selection.getPosition();
			if (pasteOnNewLine && !selection.isEmpty()) pasteOnNewLine = false;
			if (pasteOnNewLine && text.indexOf("\n") !== text.length - 1) pasteOnNewLine = false;
			if (pasteOnNewLine) {
				const typeSelection = new Range$2(position.lineNumber, 1, position.lineNumber, 1);
				commands[i] = new ReplaceCommandThatPreservesSelection(typeSelection, text, selection, true);
			} else {
				const ChosenReplaceCommand = config.overtypeOnPaste && config.inputMode === "overtype" ? ReplaceOvertypeCommand : ReplaceCommand;
				commands[i] = new ChosenReplaceCommand(selection, text);
			}
		}
		return new EditOperationResult(0, commands, {
			shouldPushStackElementBefore: true,
			shouldPushStackElementAfter: true
		});
	}
};
var CompositionOperation = class {
	static getEdits(prevEditOperationType, config, model, selections, text, replacePrevCharCnt, replaceNextCharCnt, positionDelta) {
		return new EditOperationResult(4, selections.map((selection) => this._compositionType(model, selection, text, replacePrevCharCnt, replaceNextCharCnt, positionDelta)), {
			shouldPushStackElementBefore: shouldPushStackElementBetween(prevEditOperationType, 4),
			shouldPushStackElementAfter: false
		});
	}
	static _compositionType(model, selection, text, replacePrevCharCnt, replaceNextCharCnt, positionDelta) {
		if (!selection.isEmpty()) return null;
		const pos = selection.getPosition();
		const startColumn = Math.max(1, pos.column - replacePrevCharCnt);
		const endColumn = Math.min(model.getLineMaxColumn(pos.lineNumber), pos.column + replaceNextCharCnt);
		return new ReplaceCommandWithOffsetCursorState(new Range$2(pos.lineNumber, startColumn, pos.lineNumber, endColumn), text, 0, positionDelta);
	}
};
var TypeWithoutInterceptorsOperation = class {
	static getEdits(prevEditOperationType, selections, str) {
		const commands = [];
		for (let i = 0, len = selections.length; i < len; i++) commands[i] = new ReplaceCommand(selections[i], str);
		const opType = getTypingOperation(str, prevEditOperationType);
		return new EditOperationResult(opType, commands, {
			shouldPushStackElementBefore: shouldPushStackElementBetween(prevEditOperationType, opType),
			shouldPushStackElementAfter: false
		});
	}
};
var TabOperation = class {
	static getCommands(config, model, selections) {
		const commands = [];
		for (let i = 0, len = selections.length; i < len; i++) {
			const selection = selections[i];
			if (selection.isEmpty()) {
				const lineText = model.getLineContent(selection.startLineNumber);
				if (/^\s*$/.test(lineText) && model.tokenization.isCheapToTokenize(selection.startLineNumber)) {
					let goodIndent = this._goodIndentForLine(config, model, selection.startLineNumber);
					goodIndent = goodIndent || "	";
					const possibleTypeText = config.normalizeIndentation(goodIndent);
					if (!lineText.startsWith(possibleTypeText)) {
						commands[i] = new ReplaceCommand(new Range$2(selection.startLineNumber, 1, selection.startLineNumber, lineText.length + 1), possibleTypeText, true);
						continue;
					}
				}
				commands[i] = this._replaceJumpToNextIndent(config, model, selection, true);
			} else {
				if (selection.startLineNumber === selection.endLineNumber) {
					const lineMaxColumn = model.getLineMaxColumn(selection.startLineNumber);
					if (selection.startColumn !== 1 || selection.endColumn !== lineMaxColumn) {
						commands[i] = this._replaceJumpToNextIndent(config, model, selection, false);
						continue;
					}
				}
				commands[i] = new ShiftCommand(selection, {
					isUnshift: false,
					tabSize: config.tabSize,
					indentSize: config.indentSize,
					insertSpaces: config.insertSpaces,
					useTabStops: config.useTabStops,
					autoIndent: config.autoIndent
				}, config.languageConfigurationService);
			}
		}
		return commands;
	}
	static _goodIndentForLine(config, model, lineNumber) {
		let action = null;
		let indentation = "";
		const expectedIndentAction = getInheritIndentForLine(config.autoIndent, model, lineNumber, false, config.languageConfigurationService);
		if (expectedIndentAction) {
			action = expectedIndentAction.action;
			indentation = expectedIndentAction.indentation;
		} else if (lineNumber > 1) {
			let lastLineNumber;
			for (lastLineNumber = lineNumber - 1; lastLineNumber >= 1; lastLineNumber--) {
				const lineText = model.getLineContent(lastLineNumber);
				if (lastNonWhitespaceIndex(lineText) >= 0) break;
			}
			if (lastLineNumber < 1) return null;
			const maxColumn = model.getLineMaxColumn(lastLineNumber);
			const expectedEnterAction = getEnterAction(config.autoIndent, model, new Range$2(lastLineNumber, maxColumn, lastLineNumber, maxColumn), config.languageConfigurationService);
			if (expectedEnterAction) indentation = expectedEnterAction.indentation + expectedEnterAction.appendText;
		}
		if (action) {
			if (action === IndentAction.Indent) indentation = shiftIndent(config, indentation);
			if (action === IndentAction.Outdent) indentation = unshiftIndent(config, indentation);
			indentation = config.normalizeIndentation(indentation);
		}
		if (!indentation) return null;
		return indentation;
	}
	static _replaceJumpToNextIndent(config, model, selection, insertsAutoWhitespace) {
		let typeText = "";
		const position = selection.getStartPosition();
		if (config.insertSpaces) {
			const visibleColumnFromColumn = config.visibleColumnFromColumn(model, position);
			const indentSize = config.indentSize;
			const spacesCnt = indentSize - visibleColumnFromColumn % indentSize;
			for (let i = 0; i < spacesCnt; i++) typeText += " ";
		} else typeText = "	";
		return new ReplaceCommand(selection, typeText, insertsAutoWhitespace);
	}
};
var BaseTypeWithAutoClosingCommand = class extends ReplaceCommandWithOffsetCursorState {
	constructor(selection, text, lineNumberDeltaOffset, columnDeltaOffset, openCharacter, closeCharacter) {
		super(selection, text, lineNumberDeltaOffset, columnDeltaOffset);
		this._openCharacter = openCharacter;
		this._closeCharacter = closeCharacter;
		this.closeCharacterRange = null;
		this.enclosingRange = null;
	}
	_computeCursorStateWithRange(model, range, helper) {
		this.closeCharacterRange = new Range$2(range.startLineNumber, range.endColumn - this._closeCharacter.length, range.endLineNumber, range.endColumn);
		this.enclosingRange = new Range$2(range.startLineNumber, range.endColumn - this._openCharacter.length - this._closeCharacter.length, range.endLineNumber, range.endColumn);
		return super.computeCursorState(model, helper);
	}
};
var TypeWithAutoClosingCommand = class extends BaseTypeWithAutoClosingCommand {
	constructor(selection, openCharacter, insertOpenCharacter, closeCharacter) {
		const text = (insertOpenCharacter ? openCharacter : "") + closeCharacter;
		const lineNumberDeltaOffset = 0;
		const columnDeltaOffset = -closeCharacter.length;
		super(selection, text, lineNumberDeltaOffset, columnDeltaOffset, openCharacter, closeCharacter);
	}
	computeCursorState(model, helper) {
		const range = helper.getInverseEditOperations()[0].range;
		return this._computeCursorStateWithRange(model, range, helper);
	}
};
var TypeWithIndentationAndAutoClosingCommand = class extends BaseTypeWithAutoClosingCommand {
	constructor(autoIndentationEdit, selection, openCharacter, closeCharacter) {
		const text = openCharacter + closeCharacter;
		const lineNumberDeltaOffset = 0;
		const columnDeltaOffset = openCharacter.length;
		super(selection, text, lineNumberDeltaOffset, columnDeltaOffset, openCharacter, closeCharacter);
		this._autoIndentationEdit = autoIndentationEdit;
		this._autoClosingEdit = {
			range: selection,
			text
		};
	}
	getEditOperations(model, builder) {
		builder.addTrackedEditOperation(this._autoIndentationEdit.range, this._autoIndentationEdit.text);
		builder.addTrackedEditOperation(this._autoClosingEdit.range, this._autoClosingEdit.text);
	}
	computeCursorState(model, helper) {
		const inverseEditOperations = helper.getInverseEditOperations();
		if (inverseEditOperations.length !== 2) throw new Error("There should be two inverse edit operations!");
		const range1 = inverseEditOperations[0].range;
		const range2 = inverseEditOperations[1].range;
		const range = range1.plusRange(range2);
		return this._computeCursorStateWithRange(model, range, helper);
	}
};
function getTypingOperation(typedText, previousTypingOperation) {
	if (typedText === " ") return previousTypingOperation === 5 || previousTypingOperation === 6 ? 6 : 5;
	return 4;
}
function shouldPushStackElementBetween(previousTypingOperation, typingOperation) {
	if (isTypingOperation(previousTypingOperation) && !isTypingOperation(typingOperation)) return true;
	if (previousTypingOperation === 5) return false;
	return normalizeOperationType(previousTypingOperation) !== normalizeOperationType(typingOperation);
}
function normalizeOperationType(type) {
	return type === 6 || type === 5 ? "space" : type;
}
function isTypingOperation(type) {
	return type === 4 || type === 5 || type === 6;
}
function isAutoClosingOvertype(config, model, selections, autoClosedCharacters, ch) {
	if (config.autoClosingOvertype === "never") return false;
	if (!config.autoClosingPairs.autoClosingPairsCloseSingleChar.has(ch)) return false;
	for (let i = 0, len = selections.length; i < len; i++) {
		const selection = selections[i];
		if (!selection.isEmpty()) return false;
		const position = selection.getPosition();
		const lineText = model.getLineContent(position.lineNumber);
		if (lineText.charAt(position.column - 1) !== ch) return false;
		const chIsQuote = isQuote(ch);
		if ((position.column > 2 ? lineText.charCodeAt(position.column - 2) : 0) === 92 && chIsQuote) return false;
		if (config.autoClosingOvertype === "auto") {
			let found = false;
			for (let j = 0, lenJ = autoClosedCharacters.length; j < lenJ; j++) {
				const autoClosedCharacter = autoClosedCharacters[j];
				if (position.lineNumber === autoClosedCharacter.startLineNumber && position.column === autoClosedCharacter.startColumn) {
					found = true;
					break;
				}
			}
			if (!found) return false;
		}
	}
	return true;
}
function typeCommand(range, text, keepPosition) {
	if (keepPosition) return new ReplaceCommandWithoutChangingPosition(range, text, true);
	else return new ReplaceCommand(range, text, true);
}
function shiftIndent(config, indentation, count) {
	count = count || 1;
	return ShiftCommand.shiftIndent(indentation, indentation.length + count, config.tabSize, config.indentSize, config.insertSpaces);
}
function unshiftIndent(config, indentation, count) {
	count = count || 1;
	return ShiftCommand.unshiftIndent(indentation, indentation.length + count, config.tabSize, config.indentSize, config.insertSpaces);
}
function shouldSurroundChar(config, ch) {
	if (isQuote(ch)) return config.autoSurround === "quotes" || config.autoSurround === "languageDefined";
	else return config.autoSurround === "brackets" || config.autoSurround === "languageDefined";
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/cursor/cursorTypeOperations.js
var TypeOperations = class {
	static indent(config, model, selections) {
		if (model === null || selections === null) return [];
		const commands = [];
		for (let i = 0, len = selections.length; i < len; i++) commands[i] = new ShiftCommand(selections[i], {
			isUnshift: false,
			tabSize: config.tabSize,
			indentSize: config.indentSize,
			insertSpaces: config.insertSpaces,
			useTabStops: config.useTabStops,
			autoIndent: config.autoIndent
		}, config.languageConfigurationService);
		return commands;
	}
	static outdent(config, model, selections) {
		const commands = [];
		for (let i = 0, len = selections.length; i < len; i++) commands[i] = new ShiftCommand(selections[i], {
			isUnshift: true,
			tabSize: config.tabSize,
			indentSize: config.indentSize,
			insertSpaces: config.insertSpaces,
			useTabStops: config.useTabStops,
			autoIndent: config.autoIndent
		}, config.languageConfigurationService);
		return commands;
	}
	static paste(config, model, selections, text, pasteOnNewLine, multicursorText) {
		return PasteOperation.getEdits(config, model, selections, text, pasteOnNewLine, multicursorText);
	}
	static tab(config, model, selections) {
		return TabOperation.getCommands(config, model, selections);
	}
	static compositionType(prevEditOperationType, config, model, selections, text, replacePrevCharCnt, replaceNextCharCnt, positionDelta) {
		return CompositionOperation.getEdits(prevEditOperationType, config, model, selections, text, replacePrevCharCnt, replaceNextCharCnt, positionDelta);
	}
	/**
	* This is very similar with typing, but the character is already in the text buffer!
	*/
	static compositionEndWithInterceptors(prevEditOperationType, config, model, compositions, selections, autoClosedCharacters) {
		if (!compositions) return null;
		let insertedText = null;
		for (const composition of compositions) if (insertedText === null) insertedText = composition.insertedText;
		else if (insertedText !== composition.insertedText) return null;
		if (!insertedText || insertedText.length !== 1) return CompositionEndOvertypeOperation.getEdits(config, compositions);
		const ch = insertedText;
		let hasDeletion = false;
		for (const composition of compositions) if (composition.deletedText.length !== 0) {
			hasDeletion = true;
			break;
		}
		if (hasDeletion) {
			if (!shouldSurroundChar(config, ch) || !config.surroundingPairs.hasOwnProperty(ch)) return null;
			const isTypingAQuoteCharacter = isQuote(ch);
			for (const composition of compositions) {
				if (composition.deletedSelectionStart !== 0 || composition.deletedSelectionEnd !== composition.deletedText.length) return null;
				if (/^[ \t]+$/.test(composition.deletedText)) return null;
				if (isTypingAQuoteCharacter && isQuote(composition.deletedText)) return null;
			}
			const positions = [];
			for (const selection of selections) {
				if (!selection.isEmpty()) return null;
				positions.push(selection.getPosition());
			}
			if (positions.length !== compositions.length) return null;
			const commands = [];
			for (let i = 0, len = positions.length; i < len; i++) commands.push(new CompositionSurroundSelectionCommand(positions[i], compositions[i].deletedText, config.surroundingPairs[ch]));
			return new EditOperationResult(4, commands, {
				shouldPushStackElementBefore: true,
				shouldPushStackElementAfter: false
			});
		}
		const autoClosingOvertypeEdits = AutoClosingOvertypeWithInterceptorsOperation.getEdits(config, model, selections, autoClosedCharacters, ch);
		if (autoClosingOvertypeEdits !== void 0) return autoClosingOvertypeEdits;
		const autoClosingOpenCharEdits = AutoClosingOpenCharTypeOperation.getEdits(config, model, selections, ch, true, false);
		if (autoClosingOpenCharEdits !== void 0) return autoClosingOpenCharEdits;
		return CompositionEndOvertypeOperation.getEdits(config, compositions);
	}
	static typeWithInterceptors(isDoingComposition, prevEditOperationType, config, model, selections, autoClosedCharacters, ch) {
		const enterEdits = EnterOperation.getEdits(config, model, selections, ch, isDoingComposition);
		if (enterEdits !== void 0) return enterEdits;
		const autoIndentEdits = AutoIndentOperation.getEdits(config, model, selections, ch, isDoingComposition);
		if (autoIndentEdits !== void 0) return autoIndentEdits;
		const autoClosingOverTypeEdits = AutoClosingOvertypeOperation.getEdits(prevEditOperationType, config, model, selections, autoClosedCharacters, ch);
		if (autoClosingOverTypeEdits !== void 0) return autoClosingOverTypeEdits;
		const autoClosingOpenCharEdits = AutoClosingOpenCharTypeOperation.getEdits(config, model, selections, ch, false, isDoingComposition);
		if (autoClosingOpenCharEdits !== void 0) return autoClosingOpenCharEdits;
		const surroundSelectionEdits = SurroundSelectionOperation.getEdits(config, model, selections, ch, isDoingComposition);
		if (surroundSelectionEdits !== void 0) return surroundSelectionEdits;
		const interceptorElectricCharOperation = InterceptorElectricCharOperation.getEdits(prevEditOperationType, config, model, selections, ch, isDoingComposition);
		if (interceptorElectricCharOperation !== void 0) return interceptorElectricCharOperation;
		return SimpleCharacterTypeOperation.getEdits(config, prevEditOperationType, selections, ch, isDoingComposition);
	}
	static typeWithoutInterceptors(prevEditOperationType, config, model, selections, str) {
		return TypeWithoutInterceptorsOperation.getEdits(prevEditOperationType, selections, str);
	}
};
var CompositionOutcome = class {
	constructor(deletedText, deletedSelectionStart, deletedSelectionEnd, insertedText, insertedSelectionStart, insertedSelectionEnd, insertedTextRange) {
		this.deletedText = deletedText;
		this.deletedSelectionStart = deletedSelectionStart;
		this.deletedSelectionEnd = deletedSelectionEnd;
		this.insertedText = insertedText;
		this.insertedSelectionStart = insertedSelectionStart;
		this.insertedSelectionEnd = insertedSelectionEnd;
		this.insertedTextRange = insertedTextRange;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/editorContextKeys.js
var EditorContextKeys;
(function(EditorContextKeys) {
	EditorContextKeys.editorSimpleInput = new RawContextKey("editorSimpleInput", false, true);
	/**
	* A context key that is set when the editor's text has focus (cursor is blinking).
	* Is false when focus is in simple editor widgets (repl input, scm commit input).
	*/
	EditorContextKeys.editorTextFocus = new RawContextKey("editorTextFocus", false, localize(725, "Whether the editor text has focus (cursor is blinking)"));
	/**
	* A context key that is set when the editor's text or an editor's widget has focus.
	*/
	EditorContextKeys.focus = new RawContextKey("editorFocus", false, localize(726, "Whether the editor or an editor widget has focus (e.g. focus is in the find widget)"));
	/**
	* A context key that is set when any editor input has focus (regular editor, repl input...).
	*/
	EditorContextKeys.textInputFocus = new RawContextKey("textInputFocus", false, localize(727, "Whether an editor or a rich text input has focus (cursor is blinking)"));
	EditorContextKeys.readOnly = new RawContextKey("editorReadonly", false, localize(728, "Whether the editor is read-only"));
	EditorContextKeys.inDiffEditor = new RawContextKey("inDiffEditor", false, localize(729, "Whether the context is a diff editor"));
	EditorContextKeys.isEmbeddedDiffEditor = new RawContextKey("isEmbeddedDiffEditor", false, localize(730, "Whether the context is an embedded diff editor"));
	EditorContextKeys.inMultiDiffEditor = new RawContextKey("inMultiDiffEditor", false, localize(731, "Whether the context is a multi diff editor"));
	EditorContextKeys.multiDiffEditorAllCollapsed = new RawContextKey("multiDiffEditorAllCollapsed", void 0, localize(732, "Whether all files in multi diff editor are collapsed"));
	EditorContextKeys.multiDiffEditorItemAllUnchangedRegionsShown = new RawContextKey("multiDiffEditorItemAllUnchangedRegionsShown", false, localize(733, "Whether all unchanged regions of a multi diff editor file are revealed"));
	EditorContextKeys.multiDiffEditorRenderSideBySide = new RawContextKey("multiDiffEditorRenderSideBySide", true, localize(734, "Whether the multi diff editor renders diffs side by side instead of inline"));
	EditorContextKeys.hasChanges = new RawContextKey("diffEditorHasChanges", false, localize(735, "Whether the diff editor has changes"));
	EditorContextKeys.comparingMovedCode = new RawContextKey("comparingMovedCode", false, localize(736, "Whether a moved code block is selected for comparison"));
	EditorContextKeys.accessibleDiffViewerVisible = new RawContextKey("accessibleDiffViewerVisible", false, localize(737, "Whether the accessible diff viewer is visible"));
	EditorContextKeys.diffEditorRenderSideBySideInlineBreakpointReached = new RawContextKey("diffEditorRenderSideBySideInlineBreakpointReached", false, localize(738, "Whether the diff editor render side by side inline breakpoint is reached"));
	EditorContextKeys.diffEditorInlineMode = new RawContextKey("diffEditorInlineMode", false, localize(739, "Whether inline mode is active"));
	EditorContextKeys.diffEditorTemporaryInlineMode = new RawContextKey("diffEditorTemporaryInlineMode", false, localize(740, "Whether inline mode is temporarily active after manually resizing the diff editor"));
	EditorContextKeys.diffEditorAutomaticRenderSideBySide = new RawContextKey("diffEditorAutomaticRenderSideBySide", true, localize(741, "Whether automatic diff editor layout would render side by side"));
	EditorContextKeys.diffEditorOriginalWritable = new RawContextKey("diffEditorOriginalWritable", false, localize(742, "Whether modified is writable in the diff editor"));
	EditorContextKeys.diffEditorModifiedWritable = new RawContextKey("diffEditorModifiedWritable", false, localize(743, "Whether modified is writable in the diff editor"));
	EditorContextKeys.diffEditorOriginalUri = new RawContextKey("diffEditorOriginalUri", "", localize(744, "The uri of the original document"));
	EditorContextKeys.diffEditorModifiedUri = new RawContextKey("diffEditorModifiedUri", "", localize(745, "The uri of the modified document"));
	EditorContextKeys.columnSelection = new RawContextKey("editorColumnSelection", false, localize(746, "Whether `editor.columnSelection` is enabled"));
	EditorContextKeys.writable = EditorContextKeys.readOnly.toNegated();
	EditorContextKeys.hasNonEmptySelection = new RawContextKey("editorHasSelection", false, localize(747, "Whether the editor has text selected"));
	EditorContextKeys.hasOnlyEmptySelection = EditorContextKeys.hasNonEmptySelection.toNegated();
	EditorContextKeys.hasMultipleSelections = new RawContextKey("editorHasMultipleSelections", false, localize(748, "Whether the editor has multiple selections"));
	EditorContextKeys.hasSingleSelection = EditorContextKeys.hasMultipleSelections.toNegated();
	EditorContextKeys.tabMovesFocus = new RawContextKey("editorTabMovesFocus", false, localize(749, "Whether `Tab` will move focus out of the editor"));
	EditorContextKeys.tabDoesNotMoveFocus = EditorContextKeys.tabMovesFocus.toNegated();
	EditorContextKeys.isInEmbeddedEditor = new RawContextKey("isInEmbeddedEditor", false, true);
	EditorContextKeys.canUndo = new RawContextKey("canUndo", false, true);
	EditorContextKeys.canRedo = new RawContextKey("canRedo", false, true);
	EditorContextKeys.hoverVisible = new RawContextKey("editorHoverVisible", false, localize(750, "Whether the editor hover is visible"));
	EditorContextKeys.hoverFocused = new RawContextKey("editorHoverFocused", false, localize(751, "Whether the editor hover is focused"));
	EditorContextKeys.stickyScrollFocused = new RawContextKey("stickyScrollFocused", false, localize(752, "Whether the sticky scroll is focused"));
	EditorContextKeys.stickyScrollVisible = new RawContextKey("stickyScrollVisible", false, localize(753, "Whether the sticky scroll is visible"));
	EditorContextKeys.standaloneColorPickerVisible = new RawContextKey("standaloneColorPickerVisible", false, localize(754, "Whether the standalone color picker is visible"));
	EditorContextKeys.standaloneColorPickerFocused = new RawContextKey("standaloneColorPickerFocused", false, localize(755, "Whether the standalone color picker is focused"));
	EditorContextKeys.isComposing = new RawContextKey("isComposing", false, localize(756, "Whether the editor is in the composition mode"));
	/**
	* A context key that is set when an editor is part of a larger editor, like notebooks or
	* (future) a diff editor
	*/
	EditorContextKeys.inCompositeEditor = new RawContextKey("inCompositeEditor", void 0, localize(757, "Whether the editor is part of a larger editor (e.g. notebooks)"));
	EditorContextKeys.notInCompositeEditor = EditorContextKeys.inCompositeEditor.toNegated();
	EditorContextKeys.languageId = new RawContextKey("editorLangId", "", localize(758, "The language identifier of the editor"));
	EditorContextKeys.hasCompletionItemProvider = new RawContextKey("editorHasCompletionItemProvider", false, localize(759, "Whether the editor has a completion item provider"));
	EditorContextKeys.hasCodeActionsProvider = new RawContextKey("editorHasCodeActionsProvider", false, localize(760, "Whether the editor has a code actions provider"));
	EditorContextKeys.hasCodeLensProvider = new RawContextKey("editorHasCodeLensProvider", false, localize(761, "Whether the editor has a code lens provider"));
	EditorContextKeys.hasDefinitionProvider = new RawContextKey("editorHasDefinitionProvider", false, localize(762, "Whether the editor has a definition provider"));
	EditorContextKeys.hasDeclarationProvider = new RawContextKey("editorHasDeclarationProvider", false, localize(763, "Whether the editor has a declaration provider"));
	EditorContextKeys.hasImplementationProvider = new RawContextKey("editorHasImplementationProvider", false, localize(764, "Whether the editor has an implementation provider"));
	EditorContextKeys.hasTypeDefinitionProvider = new RawContextKey("editorHasTypeDefinitionProvider", false, localize(765, "Whether the editor has a type definition provider"));
	EditorContextKeys.hasHoverProvider = new RawContextKey("editorHasHoverProvider", false, localize(766, "Whether the editor has a hover provider"));
	EditorContextKeys.hasDocumentHighlightProvider = new RawContextKey("editorHasDocumentHighlightProvider", false, localize(767, "Whether the editor has a document highlight provider"));
	EditorContextKeys.hasDocumentSymbolProvider = new RawContextKey("editorHasDocumentSymbolProvider", false, localize(768, "Whether the editor has a document symbol provider"));
	EditorContextKeys.hasReferenceProvider = new RawContextKey("editorHasReferenceProvider", false, localize(769, "Whether the editor has a reference provider"));
	EditorContextKeys.hasRenameProvider = new RawContextKey("editorHasRenameProvider", false, localize(770, "Whether the editor has a rename provider"));
	EditorContextKeys.hasSignatureHelpProvider = new RawContextKey("editorHasSignatureHelpProvider", false, localize(771, "Whether the editor has a signature help provider"));
	EditorContextKeys.hasInlayHintsProvider = new RawContextKey("editorHasInlayHintsProvider", false, localize(772, "Whether the editor has an inline hints provider"));
	EditorContextKeys.hasDocumentFormattingProvider = new RawContextKey("editorHasDocumentFormattingProvider", false, localize(773, "Whether the editor has a document formatting provider"));
	EditorContextKeys.hasDocumentSelectionFormattingProvider = new RawContextKey("editorHasDocumentSelectionFormattingProvider", false, localize(774, "Whether the editor has a document selection formatting provider"));
	EditorContextKeys.hasMultipleDocumentFormattingProvider = new RawContextKey("editorHasMultipleDocumentFormattingProvider", false, localize(775, "Whether the editor has multiple document formatting providers"));
	EditorContextKeys.hasMultipleDocumentSelectionFormattingProvider = new RawContextKey("editorHasMultipleDocumentSelectionFormattingProvider", false, localize(776, "Whether the editor has multiple document selection formatting providers"));
	EditorContextKeys.selectionHasDiagnostics = new RawContextKey("editorSelectionHasDiagnostics", false, localize(777, "Whether any diagnostic is present in the current editor selection"));
})(EditorContextKeys || (EditorContextKeys = {}));
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/coreCommands.js
var CORE_WEIGHT = 0;
var CoreEditorCommand = class extends EditorCommand {
	runEditorCommand(accessor, editor, args) {
		const viewModel = editor._getViewModel();
		if (!viewModel) return;
		this.runCoreEditorCommand(viewModel, args || {});
	}
};
var EditorScroll_;
(function(EditorScroll_) {
	const isEditorScrollArgs = function(arg) {
		if (!isObject(arg)) return false;
		const scrollArg = arg;
		if (!isString$1(scrollArg.to)) return false;
		if (!isUndefined(scrollArg.by) && !isString$1(scrollArg.by)) return false;
		if (!isUndefined(scrollArg.value) && !isNumber$1(scrollArg.value)) return false;
		if (!isUndefined(scrollArg.revealCursor) && !isBoolean(scrollArg.revealCursor)) return false;
		return true;
	};
	EditorScroll_.metadata = {
		description: "Scroll editor in the given direction",
		args: [{
			name: "Editor scroll argument object",
			description: `Property-value pairs that can be passed through this argument:
					* 'to': A mandatory direction value.
						\`\`\`
						'up', 'down'
						\`\`\`
					* 'by': Unit to move. Default is computed based on 'to' value.
						\`\`\`
						'line', 'wrappedLine', 'page', 'halfPage', 'editor'
						\`\`\`
					* 'value': Number of units to move. Default is '1'.
					* 'revealCursor': If 'true' reveals the cursor if it is outside view port.
				`,
			constraint: isEditorScrollArgs,
			schema: {
				"type": "object",
				"required": ["to"],
				"properties": {
					"to": {
						"type": "string",
						"enum": ["up", "down"]
					},
					"by": {
						"type": "string",
						"enum": [
							"line",
							"wrappedLine",
							"page",
							"halfPage",
							"editor"
						]
					},
					"value": {
						"type": "number",
						"default": 1
					},
					"revealCursor": { "type": "boolean" }
				}
			}
		}]
	};
	/**
	* Directions in the view for editor scroll command.
	*/
	EditorScroll_.RawDirection = {
		Up: "up",
		Right: "right",
		Down: "down",
		Left: "left"
	};
	/**
	* Units for editor scroll 'by' argument
	*/
	EditorScroll_.RawUnit = {
		Line: "line",
		WrappedLine: "wrappedLine",
		Page: "page",
		HalfPage: "halfPage",
		Editor: "editor",
		Column: "column"
	};
	function parse(args) {
		let direction;
		switch (args.to) {
			case EditorScroll_.RawDirection.Up:
				direction = 1;
				break;
			case EditorScroll_.RawDirection.Right:
				direction = 2;
				break;
			case EditorScroll_.RawDirection.Down:
				direction = 3;
				break;
			case EditorScroll_.RawDirection.Left:
				direction = 4;
				break;
			default: return null;
		}
		let unit;
		switch (args.by) {
			case EditorScroll_.RawUnit.Line:
				unit = 1;
				break;
			case EditorScroll_.RawUnit.WrappedLine:
				unit = 2;
				break;
			case EditorScroll_.RawUnit.Page:
				unit = 3;
				break;
			case EditorScroll_.RawUnit.HalfPage:
				unit = 4;
				break;
			case EditorScroll_.RawUnit.Editor:
				unit = 5;
				break;
			case EditorScroll_.RawUnit.Column:
				unit = 6;
				break;
			default: unit = 2;
		}
		const value = Math.floor(args.value || 1);
		const revealCursor = !!args.revealCursor;
		return {
			direction,
			unit,
			value,
			revealCursor,
			select: !!args.select
		};
	}
	EditorScroll_.parse = parse;
})(EditorScroll_ || (EditorScroll_ = {}));
var RevealLine_;
(function(RevealLine_) {
	const isRevealLineArgs = function(arg) {
		if (!isObject(arg)) return false;
		const reveaLineArg = arg;
		if (!isNumber$1(reveaLineArg.lineNumber) && !isString$1(reveaLineArg.lineNumber)) return false;
		if (!isUndefined(reveaLineArg.at) && !isString$1(reveaLineArg.at)) return false;
		return true;
	};
	RevealLine_.metadata = {
		description: "Reveal the given line at the given logical position",
		args: [{
			name: "Reveal line argument object",
			description: `Property-value pairs that can be passed through this argument:
					* 'lineNumber': A mandatory line number value.
					* 'at': Logical position at which line has to be revealed.
						\`\`\`
						'top', 'center', 'bottom'
						\`\`\`
				`,
			constraint: isRevealLineArgs,
			schema: {
				"type": "object",
				"required": ["lineNumber"],
				"properties": {
					"lineNumber": { "type": ["number", "string"] },
					"at": {
						"type": "string",
						"enum": [
							"top",
							"center",
							"bottom"
						]
					}
				}
			}
		}]
	};
	/**
	* Values for reveal line 'at' argument
	*/
	RevealLine_.RawAtArgument = {
		Top: "top",
		Center: "center",
		Bottom: "bottom"
	};
})(RevealLine_ || (RevealLine_ = {}));
var EditorOrNativeTextInputCommand = class {
	constructor(target) {
		target.addImplementation(1e4, "code-editor", (accessor, args) => {
			const focusedEditor = accessor.get(ICodeEditorService).getFocusedCodeEditor();
			if (focusedEditor && focusedEditor.hasTextFocus()) return this._runEditorCommand(accessor, focusedEditor, args);
			return false;
		});
		target.addImplementation(1e3, "generic-dom-input-textarea", (accessor, args) => {
			const activeElement = getActiveElement();
			if (activeElement && isEditableElement(activeElement)) {
				this.runDOMCommand(activeElement);
				return true;
			}
			return false;
		});
		target.addImplementation(0, "generic-dom", (accessor, args) => {
			const activeEditor = accessor.get(ICodeEditorService).getActiveCodeEditor();
			if (activeEditor) {
				activeEditor.focus();
				return this._runEditorCommand(accessor, activeEditor, args);
			}
			return false;
		});
	}
	_runEditorCommand(accessor, editor, args) {
		const result = this.runEditorCommand(accessor, editor, args);
		if (result) return result;
		return true;
	}
};
var CoreNavigationCommands;
(function(CoreNavigationCommands) {
	class BaseMoveToCommand extends CoreEditorCommand {
		constructor(opts) {
			super(opts);
			this._inSelectionMode = opts.inSelectionMode;
		}
		runCoreEditorCommand(viewModel, args) {
			if (!args.position) return;
			viewModel.model.pushStackElement();
			if (viewModel.setCursorStates(args.source, 3, [CursorMoveCommands.moveTo(viewModel, viewModel.getPrimaryCursorState(), this._inSelectionMode, args.position, args.viewPosition)]) && args.revealType !== 2) viewModel.revealAllCursors(args.source, true, true);
		}
	}
	CoreNavigationCommands.MoveTo = registerEditorCommand(new BaseMoveToCommand({
		id: "_moveTo",
		inSelectionMode: false,
		precondition: void 0
	}));
	CoreNavigationCommands.MoveToSelect = registerEditorCommand(new BaseMoveToCommand({
		id: "_moveToSelect",
		inSelectionMode: true,
		precondition: void 0
	}));
	class ColumnSelectCommand extends CoreEditorCommand {
		runCoreEditorCommand(viewModel, args) {
			viewModel.model.pushStackElement();
			const result = this._getColumnSelectResult(viewModel, viewModel.getPrimaryCursorState(), viewModel.getCursorColumnSelectData(), args);
			if (result === null) return;
			viewModel.setCursorStates(args.source, 3, result.viewStates.map((viewState) => CursorState.fromViewState(viewState)));
			viewModel.setCursorColumnSelectData({
				isReal: true,
				fromViewLineNumber: result.fromLineNumber,
				fromViewVisualColumn: result.fromVisualColumn,
				toViewLineNumber: result.toLineNumber,
				toViewVisualColumn: result.toVisualColumn
			});
			if (result.reversed) viewModel.revealTopMostCursor(args.source);
			else viewModel.revealBottomMostCursor(args.source);
		}
	}
	CoreNavigationCommands.ColumnSelect = registerEditorCommand(new class extends ColumnSelectCommand {
		constructor() {
			super({
				id: "columnSelect",
				precondition: void 0
			});
		}
		_getColumnSelectResult(viewModel, primary, prevColumnSelectData, args) {
			if (typeof args.position === "undefined" || typeof args.viewPosition === "undefined" || typeof args.mouseColumn === "undefined") return null;
			const validatedPosition = viewModel.model.validatePosition(args.position);
			const validatedViewPosition = viewModel.coordinatesConverter.validateViewPosition(new Position$1(args.viewPosition.lineNumber, args.viewPosition.column), validatedPosition);
			const fromViewLineNumber = args.doColumnSelect ? prevColumnSelectData.fromViewLineNumber : validatedViewPosition.lineNumber;
			const fromViewVisualColumn = args.doColumnSelect ? prevColumnSelectData.fromViewVisualColumn : args.mouseColumn - 1;
			return ColumnSelection.columnSelect(viewModel.cursorConfig, viewModel, fromViewLineNumber, fromViewVisualColumn, validatedViewPosition.lineNumber, args.mouseColumn - 1);
		}
	}());
	CoreNavigationCommands.CursorColumnSelectLeft = registerEditorCommand(new class extends ColumnSelectCommand {
		constructor() {
			super({
				id: "cursorColumnSelectLeft",
				precondition: void 0,
				kbOpts: {
					weight: CORE_WEIGHT,
					kbExpr: EditorContextKeys.textInputFocus,
					primary: 3599,
					linux: { primary: 0 }
				}
			});
		}
		_getColumnSelectResult(viewModel, primary, prevColumnSelectData, args) {
			return ColumnSelection.columnSelectLeft(viewModel.cursorConfig, viewModel, prevColumnSelectData);
		}
	}());
	CoreNavigationCommands.CursorColumnSelectRight = registerEditorCommand(new class extends ColumnSelectCommand {
		constructor() {
			super({
				id: "cursorColumnSelectRight",
				precondition: void 0,
				kbOpts: {
					weight: CORE_WEIGHT,
					kbExpr: EditorContextKeys.textInputFocus,
					primary: 3601,
					linux: { primary: 0 }
				}
			});
		}
		_getColumnSelectResult(viewModel, primary, prevColumnSelectData, args) {
			return ColumnSelection.columnSelectRight(viewModel.cursorConfig, viewModel, prevColumnSelectData);
		}
	}());
	class ColumnSelectUpCommand extends ColumnSelectCommand {
		constructor(opts) {
			super(opts);
			this._isPaged = opts.isPaged;
		}
		_getColumnSelectResult(viewModel, primary, prevColumnSelectData, args) {
			return ColumnSelection.columnSelectUp(viewModel.cursorConfig, viewModel, prevColumnSelectData, this._isPaged);
		}
	}
	CoreNavigationCommands.CursorColumnSelectUp = registerEditorCommand(new ColumnSelectUpCommand({
		isPaged: false,
		id: "cursorColumnSelectUp",
		precondition: void 0,
		kbOpts: {
			weight: CORE_WEIGHT,
			kbExpr: EditorContextKeys.textInputFocus,
			primary: 3600,
			linux: { primary: 0 }
		}
	}));
	CoreNavigationCommands.CursorColumnSelectPageUp = registerEditorCommand(new ColumnSelectUpCommand({
		isPaged: true,
		id: "cursorColumnSelectPageUp",
		precondition: void 0,
		kbOpts: {
			weight: CORE_WEIGHT,
			kbExpr: EditorContextKeys.textInputFocus,
			primary: 3595,
			linux: { primary: 0 }
		}
	}));
	class ColumnSelectDownCommand extends ColumnSelectCommand {
		constructor(opts) {
			super(opts);
			this._isPaged = opts.isPaged;
		}
		_getColumnSelectResult(viewModel, primary, prevColumnSelectData, args) {
			return ColumnSelection.columnSelectDown(viewModel.cursorConfig, viewModel, prevColumnSelectData, this._isPaged);
		}
	}
	CoreNavigationCommands.CursorColumnSelectDown = registerEditorCommand(new ColumnSelectDownCommand({
		isPaged: false,
		id: "cursorColumnSelectDown",
		precondition: void 0,
		kbOpts: {
			weight: CORE_WEIGHT,
			kbExpr: EditorContextKeys.textInputFocus,
			primary: 3602,
			linux: { primary: 0 }
		}
	}));
	CoreNavigationCommands.CursorColumnSelectPageDown = registerEditorCommand(new ColumnSelectDownCommand({
		isPaged: true,
		id: "cursorColumnSelectPageDown",
		precondition: void 0,
		kbOpts: {
			weight: CORE_WEIGHT,
			kbExpr: EditorContextKeys.textInputFocus,
			primary: 3596,
			linux: { primary: 0 }
		}
	}));
	class CursorMoveImpl extends CoreEditorCommand {
		constructor() {
			super({
				id: "cursorMove",
				precondition: void 0,
				metadata: CursorMove.metadata
			});
		}
		runCoreEditorCommand(viewModel, args) {
			const parsed = CursorMove.parse(args);
			if (!parsed) return;
			this._runCursorMove(viewModel, args.source, parsed);
		}
		_runCursorMove(viewModel, source, args) {
			const effectiveSource = args.noHistory ? "api" : source;
			viewModel.model.pushStackElement();
			viewModel.setCursorStates(effectiveSource, 3, CursorMoveImpl._move(viewModel, viewModel.getCursorStates(), args));
			viewModel.revealAllCursors(effectiveSource, true);
		}
		static _move(viewModel, cursors, args) {
			const inSelectionMode = args.select;
			const value = args.value;
			switch (args.direction) {
				case 0:
				case 1:
				case 2:
				case 3:
				case 4:
				case 5:
				case 6:
				case 7:
				case 8:
				case 9:
				case 10: return CursorMoveCommands.simpleMove(viewModel, cursors, args.direction, inSelectionMode, value, args.unit);
				case 11:
				case 13:
				case 12:
				case 14: return CursorMoveCommands.viewportMove(viewModel, cursors, args.direction, inSelectionMode, value);
				default: return null;
			}
		}
	}
	CoreNavigationCommands.CursorMoveImpl = CursorMoveImpl;
	CoreNavigationCommands.CursorMove = registerEditorCommand(new CursorMoveImpl());
	class CursorMoveBasedCommand extends CoreEditorCommand {
		constructor(opts) {
			super(opts);
			this._staticArgs = opts.args;
		}
		runCoreEditorCommand(viewModel, dynamicArgs) {
			let args = this._staticArgs;
			if (this._staticArgs.value === -1) args = {
				direction: this._staticArgs.direction,
				unit: this._staticArgs.unit,
				select: this._staticArgs.select,
				value: dynamicArgs.pageSize || viewModel.cursorConfig.pageSize
			};
			viewModel.model.pushStackElement();
			viewModel.setCursorStates(dynamicArgs.source, 3, CursorMoveCommands.simpleMove(viewModel, viewModel.getCursorStates(), args.direction, args.select, args.value, args.unit));
			viewModel.revealAllCursors(dynamicArgs.source, true);
		}
	}
	CoreNavigationCommands.CursorLeft = registerEditorCommand(new CursorMoveBasedCommand({
		args: {
			direction: 0,
			unit: 0,
			select: false,
			value: 1
		},
		id: "cursorLeft",
		precondition: void 0,
		kbOpts: {
			weight: CORE_WEIGHT,
			kbExpr: EditorContextKeys.textInputFocus,
			primary: 15,
			mac: {
				primary: 15,
				secondary: [288]
			}
		}
	}));
	CoreNavigationCommands.CursorLeftSelect = registerEditorCommand(new CursorMoveBasedCommand({
		args: {
			direction: 0,
			unit: 0,
			select: true,
			value: 1
		},
		id: "cursorLeftSelect",
		precondition: void 0,
		kbOpts: {
			weight: CORE_WEIGHT,
			kbExpr: EditorContextKeys.textInputFocus,
			primary: 1039
		}
	}));
	CoreNavigationCommands.CursorRight = registerEditorCommand(new CursorMoveBasedCommand({
		args: {
			direction: 1,
			unit: 0,
			select: false,
			value: 1
		},
		id: "cursorRight",
		precondition: void 0,
		kbOpts: {
			weight: CORE_WEIGHT,
			kbExpr: EditorContextKeys.textInputFocus,
			primary: 17,
			mac: {
				primary: 17,
				secondary: [292]
			}
		}
	}));
	CoreNavigationCommands.CursorRightSelect = registerEditorCommand(new CursorMoveBasedCommand({
		args: {
			direction: 1,
			unit: 0,
			select: true,
			value: 1
		},
		id: "cursorRightSelect",
		precondition: void 0,
		kbOpts: {
			weight: CORE_WEIGHT,
			kbExpr: EditorContextKeys.textInputFocus,
			primary: 1041
		}
	}));
	CoreNavigationCommands.CursorUp = registerEditorCommand(new CursorMoveBasedCommand({
		args: {
			direction: 2,
			unit: 2,
			select: false,
			value: 1
		},
		id: "cursorUp",
		precondition: void 0,
		kbOpts: {
			weight: CORE_WEIGHT,
			kbExpr: EditorContextKeys.textInputFocus,
			primary: 16,
			mac: {
				primary: 16,
				secondary: [302]
			}
		}
	}));
	CoreNavigationCommands.CursorUpSelect = registerEditorCommand(new CursorMoveBasedCommand({
		args: {
			direction: 2,
			unit: 2,
			select: true,
			value: 1
		},
		id: "cursorUpSelect",
		precondition: void 0,
		kbOpts: {
			weight: CORE_WEIGHT,
			kbExpr: EditorContextKeys.textInputFocus,
			primary: 1040,
			secondary: [3088],
			mac: { primary: 1040 },
			linux: { primary: 1040 }
		}
	}));
	CoreNavigationCommands.CursorPageUp = registerEditorCommand(new CursorMoveBasedCommand({
		args: {
			direction: 2,
			unit: 2,
			select: false,
			value: -1
		},
		id: "cursorPageUp",
		precondition: void 0,
		kbOpts: {
			weight: CORE_WEIGHT,
			kbExpr: EditorContextKeys.textInputFocus,
			primary: 11
		}
	}));
	CoreNavigationCommands.CursorPageUpSelect = registerEditorCommand(new CursorMoveBasedCommand({
		args: {
			direction: 2,
			unit: 2,
			select: true,
			value: -1
		},
		id: "cursorPageUpSelect",
		precondition: void 0,
		kbOpts: {
			weight: CORE_WEIGHT,
			kbExpr: EditorContextKeys.textInputFocus,
			primary: 1035
		}
	}));
	CoreNavigationCommands.CursorDown = registerEditorCommand(new CursorMoveBasedCommand({
		args: {
			direction: 3,
			unit: 2,
			select: false,
			value: 1
		},
		id: "cursorDown",
		precondition: void 0,
		kbOpts: {
			weight: CORE_WEIGHT,
			kbExpr: EditorContextKeys.textInputFocus,
			primary: 18,
			mac: {
				primary: 18,
				secondary: [300]
			}
		}
	}));
	CoreNavigationCommands.CursorDownSelect = registerEditorCommand(new CursorMoveBasedCommand({
		args: {
			direction: 3,
			unit: 2,
			select: true,
			value: 1
		},
		id: "cursorDownSelect",
		precondition: void 0,
		kbOpts: {
			weight: CORE_WEIGHT,
			kbExpr: EditorContextKeys.textInputFocus,
			primary: 1042,
			secondary: [3090],
			mac: { primary: 1042 },
			linux: { primary: 1042 }
		}
	}));
	CoreNavigationCommands.CursorPageDown = registerEditorCommand(new CursorMoveBasedCommand({
		args: {
			direction: 3,
			unit: 2,
			select: false,
			value: -1
		},
		id: "cursorPageDown",
		precondition: void 0,
		kbOpts: {
			weight: CORE_WEIGHT,
			kbExpr: EditorContextKeys.textInputFocus,
			primary: 12
		}
	}));
	CoreNavigationCommands.CursorPageDownSelect = registerEditorCommand(new CursorMoveBasedCommand({
		args: {
			direction: 3,
			unit: 2,
			select: true,
			value: -1
		},
		id: "cursorPageDownSelect",
		precondition: void 0,
		kbOpts: {
			weight: CORE_WEIGHT,
			kbExpr: EditorContextKeys.textInputFocus,
			primary: 1036
		}
	}));
	CoreNavigationCommands.CreateCursor = registerEditorCommand(new class extends CoreEditorCommand {
		constructor() {
			super({
				id: "createCursor",
				precondition: void 0
			});
		}
		runCoreEditorCommand(viewModel, args) {
			if (!args.position) return;
			let newState;
			if (args.wholeLine) newState = CursorMoveCommands.line(viewModel, viewModel.getPrimaryCursorState(), false, args.position, args.viewPosition);
			else newState = CursorMoveCommands.moveTo(viewModel, viewModel.getPrimaryCursorState(), false, args.position, args.viewPosition);
			const states = viewModel.getCursorStates();
			if (states.length > 1) {
				const newModelPosition = newState.modelState ? newState.modelState.position : null;
				const newViewPosition = newState.viewState ? newState.viewState.position : null;
				for (let i = 0, len = states.length; i < len; i++) {
					const state = states[i];
					if (newModelPosition && !state.modelState.selection.containsPosition(newModelPosition)) continue;
					if (newViewPosition && !state.viewState.selection.containsPosition(newViewPosition)) continue;
					states.splice(i, 1);
					viewModel.model.pushStackElement();
					viewModel.setCursorStates(args.source, 3, states);
					return;
				}
			}
			states.push(newState);
			viewModel.model.pushStackElement();
			viewModel.setCursorStates(args.source, 3, states);
		}
	}());
	CoreNavigationCommands.LastCursorMoveToSelect = registerEditorCommand(new class extends CoreEditorCommand {
		constructor() {
			super({
				id: "_lastCursorMoveToSelect",
				precondition: void 0
			});
		}
		runCoreEditorCommand(viewModel, args) {
			if (!args.position) return;
			const lastAddedCursorIndex = viewModel.getLastAddedCursorIndex();
			const states = viewModel.getCursorStates();
			const newStates = states.slice(0);
			newStates[lastAddedCursorIndex] = CursorMoveCommands.moveTo(viewModel, states[lastAddedCursorIndex], true, args.position, args.viewPosition);
			viewModel.model.pushStackElement();
			viewModel.setCursorStates(args.source, 3, newStates);
		}
	}());
	class HomeCommand extends CoreEditorCommand {
		constructor(opts) {
			super(opts);
			this._inSelectionMode = opts.inSelectionMode;
		}
		runCoreEditorCommand(viewModel, args) {
			viewModel.model.pushStackElement();
			viewModel.setCursorStates(args.source, 3, CursorMoveCommands.moveToBeginningOfLine(viewModel, viewModel.getCursorStates(), this._inSelectionMode));
			viewModel.revealAllCursors(args.source, true);
		}
	}
	CoreNavigationCommands.CursorHome = registerEditorCommand(new HomeCommand({
		inSelectionMode: false,
		id: "cursorHome",
		precondition: void 0,
		kbOpts: {
			weight: CORE_WEIGHT,
			kbExpr: EditorContextKeys.textInputFocus,
			primary: 14,
			mac: {
				primary: 14,
				secondary: [2063]
			}
		}
	}));
	CoreNavigationCommands.CursorHomeSelect = registerEditorCommand(new HomeCommand({
		inSelectionMode: true,
		id: "cursorHomeSelect",
		precondition: void 0,
		kbOpts: {
			weight: CORE_WEIGHT,
			kbExpr: EditorContextKeys.textInputFocus,
			primary: 1038,
			mac: {
				primary: 1038,
				secondary: [3087]
			}
		}
	}));
	class LineStartCommand extends CoreEditorCommand {
		constructor(opts) {
			super(opts);
			this._inSelectionMode = opts.inSelectionMode;
		}
		runCoreEditorCommand(viewModel, args) {
			viewModel.model.pushStackElement();
			viewModel.setCursorStates(args.source, 3, this._exec(viewModel.getCursorStates()));
			viewModel.revealAllCursors(args.source, true);
		}
		_exec(cursors) {
			const result = [];
			for (let i = 0, len = cursors.length; i < len; i++) {
				const cursor = cursors[i];
				const lineNumber = cursor.modelState.position.lineNumber;
				result[i] = CursorState.fromModelState(cursor.modelState.move(this._inSelectionMode, lineNumber, 1, 0));
			}
			return result;
		}
	}
	CoreNavigationCommands.CursorLineStart = registerEditorCommand(new LineStartCommand({
		inSelectionMode: false,
		id: "cursorLineStart",
		precondition: void 0,
		kbOpts: {
			weight: CORE_WEIGHT,
			kbExpr: EditorContextKeys.textInputFocus,
			primary: 0,
			mac: { primary: 287 }
		}
	}));
	CoreNavigationCommands.CursorLineStartSelect = registerEditorCommand(new LineStartCommand({
		inSelectionMode: true,
		id: "cursorLineStartSelect",
		precondition: void 0,
		kbOpts: {
			weight: CORE_WEIGHT,
			kbExpr: EditorContextKeys.textInputFocus,
			primary: 0,
			mac: { primary: 1311 }
		}
	}));
	class EndCommand extends CoreEditorCommand {
		constructor(opts) {
			super(opts);
			this._inSelectionMode = opts.inSelectionMode;
		}
		runCoreEditorCommand(viewModel, args) {
			viewModel.model.pushStackElement();
			viewModel.setCursorStates(args.source, 3, CursorMoveCommands.moveToEndOfLine(viewModel, viewModel.getCursorStates(), this._inSelectionMode, args.sticky || false));
			viewModel.revealAllCursors(args.source, true);
		}
	}
	CoreNavigationCommands.CursorEnd = registerEditorCommand(new EndCommand({
		inSelectionMode: false,
		id: "cursorEnd",
		precondition: void 0,
		kbOpts: {
			args: { sticky: false },
			weight: CORE_WEIGHT,
			kbExpr: EditorContextKeys.textInputFocus,
			primary: 13,
			mac: {
				primary: 13,
				secondary: [2065]
			}
		},
		metadata: {
			description: `Go to End`,
			args: [{
				name: "args",
				schema: {
					type: "object",
					properties: { "sticky": {
						description: localize(70, "Stick to the end even when going to longer lines"),
						type: "boolean",
						default: false
					} }
				}
			}]
		}
	}));
	CoreNavigationCommands.CursorEndSelect = registerEditorCommand(new EndCommand({
		inSelectionMode: true,
		id: "cursorEndSelect",
		precondition: void 0,
		kbOpts: {
			args: { sticky: false },
			weight: CORE_WEIGHT,
			kbExpr: EditorContextKeys.textInputFocus,
			primary: 1037,
			mac: {
				primary: 1037,
				secondary: [3089]
			}
		},
		metadata: {
			description: `Select to End`,
			args: [{
				name: "args",
				schema: {
					type: "object",
					properties: { "sticky": {
						description: localize(71, "Stick to the end even when going to longer lines"),
						type: "boolean",
						default: false
					} }
				}
			}]
		}
	}));
	class LineEndCommand extends CoreEditorCommand {
		constructor(opts) {
			super(opts);
			this._inSelectionMode = opts.inSelectionMode;
		}
		runCoreEditorCommand(viewModel, args) {
			viewModel.model.pushStackElement();
			viewModel.setCursorStates(args.source, 3, this._exec(viewModel, viewModel.getCursorStates()));
			viewModel.revealAllCursors(args.source, true);
		}
		_exec(viewModel, cursors) {
			const result = [];
			for (let i = 0, len = cursors.length; i < len; i++) {
				const cursor = cursors[i];
				const lineNumber = cursor.modelState.position.lineNumber;
				const maxColumn = viewModel.model.getLineMaxColumn(lineNumber);
				result[i] = CursorState.fromModelState(cursor.modelState.move(this._inSelectionMode, lineNumber, maxColumn, 0));
			}
			return result;
		}
	}
	CoreNavigationCommands.CursorLineEnd = registerEditorCommand(new LineEndCommand({
		inSelectionMode: false,
		id: "cursorLineEnd",
		precondition: void 0,
		kbOpts: {
			weight: CORE_WEIGHT,
			kbExpr: EditorContextKeys.textInputFocus,
			primary: 0,
			mac: { primary: 291 }
		}
	}));
	CoreNavigationCommands.CursorLineEndSelect = registerEditorCommand(new LineEndCommand({
		inSelectionMode: true,
		id: "cursorLineEndSelect",
		precondition: void 0,
		kbOpts: {
			weight: CORE_WEIGHT,
			kbExpr: EditorContextKeys.textInputFocus,
			primary: 0,
			mac: { primary: 1315 }
		}
	}));
	class TopCommand extends CoreEditorCommand {
		constructor(opts) {
			super(opts);
			this._inSelectionMode = opts.inSelectionMode;
		}
		runCoreEditorCommand(viewModel, args) {
			viewModel.model.pushStackElement();
			viewModel.setCursorStates(args.source, 3, CursorMoveCommands.moveToBeginningOfBuffer(viewModel, viewModel.getCursorStates(), this._inSelectionMode));
			viewModel.revealAllCursors(args.source, true);
		}
	}
	CoreNavigationCommands.CursorTop = registerEditorCommand(new TopCommand({
		inSelectionMode: false,
		id: "cursorTop",
		precondition: void 0,
		kbOpts: {
			weight: CORE_WEIGHT,
			kbExpr: EditorContextKeys.textInputFocus,
			primary: 2062,
			mac: { primary: 2064 }
		}
	}));
	CoreNavigationCommands.CursorTopSelect = registerEditorCommand(new TopCommand({
		inSelectionMode: true,
		id: "cursorTopSelect",
		precondition: void 0,
		kbOpts: {
			weight: CORE_WEIGHT,
			kbExpr: EditorContextKeys.textInputFocus,
			primary: 3086,
			mac: { primary: 3088 }
		}
	}));
	class BottomCommand extends CoreEditorCommand {
		constructor(opts) {
			super(opts);
			this._inSelectionMode = opts.inSelectionMode;
		}
		runCoreEditorCommand(viewModel, args) {
			viewModel.model.pushStackElement();
			viewModel.setCursorStates(args.source, 3, CursorMoveCommands.moveToEndOfBuffer(viewModel, viewModel.getCursorStates(), this._inSelectionMode));
			viewModel.revealAllCursors(args.source, true);
		}
	}
	CoreNavigationCommands.CursorBottom = registerEditorCommand(new BottomCommand({
		inSelectionMode: false,
		id: "cursorBottom",
		precondition: void 0,
		kbOpts: {
			weight: CORE_WEIGHT,
			kbExpr: EditorContextKeys.textInputFocus,
			primary: 2061,
			mac: { primary: 2066 }
		}
	}));
	CoreNavigationCommands.CursorBottomSelect = registerEditorCommand(new BottomCommand({
		inSelectionMode: true,
		id: "cursorBottomSelect",
		precondition: void 0,
		kbOpts: {
			weight: CORE_WEIGHT,
			kbExpr: EditorContextKeys.textInputFocus,
			primary: 3085,
			mac: { primary: 3090 }
		}
	}));
	class EditorScrollImpl extends CoreEditorCommand {
		constructor() {
			super({
				id: "editorScroll",
				precondition: void 0,
				metadata: EditorScroll_.metadata
			});
		}
		determineScrollMethod(args) {
			const horizontalUnits = [6];
			const verticalUnits = [
				1,
				2,
				3,
				4,
				5
			];
			const horizontalDirections = [4, 2];
			const verticalDirections = [1, 3];
			if (horizontalUnits.includes(args.unit) && horizontalDirections.includes(args.direction)) return this._runHorizontalEditorScroll.bind(this);
			if (verticalUnits.includes(args.unit) && verticalDirections.includes(args.direction)) return this._runVerticalEditorScroll.bind(this);
			return null;
		}
		runCoreEditorCommand(viewModel, args) {
			const parsed = EditorScroll_.parse(args);
			if (!parsed) return;
			const runEditorScroll = this.determineScrollMethod(parsed);
			if (!runEditorScroll) return;
			runEditorScroll(viewModel, args.source, parsed);
		}
		_runVerticalEditorScroll(viewModel, source, args) {
			const desiredScrollTop = this._computeDesiredScrollTop(viewModel, args);
			if (args.revealCursor) {
				const desiredVisibleViewRange = viewModel.getCompletelyVisibleViewRangeAtScrollTop(desiredScrollTop);
				const paddedRange = viewModel.getViewRangeWithCursorPadding(desiredVisibleViewRange);
				viewModel.setCursorStates(source, 3, [CursorMoveCommands.findPositionInViewportIfOutside(viewModel, viewModel.getPrimaryCursorState(), paddedRange, args.select)]);
			}
			viewModel.viewLayout.setScrollPosition({ scrollTop: desiredScrollTop }, 0);
		}
		_computeDesiredScrollTop(viewModel, args) {
			if (args.unit === 1) {
				const futureViewport = viewModel.viewLayout.getFutureViewport();
				const visibleViewRange = viewModel.getCompletelyVisibleViewRangeAtScrollTop(futureViewport.top);
				const visibleModelRange = viewModel.coordinatesConverter.convertViewRangeToModelRange(visibleViewRange);
				let desiredTopModelLineNumber;
				if (args.direction === 1) desiredTopModelLineNumber = Math.max(1, visibleModelRange.startLineNumber - args.value);
				else desiredTopModelLineNumber = Math.min(viewModel.model.getLineCount(), visibleModelRange.startLineNumber + args.value);
				const viewPosition = viewModel.coordinatesConverter.convertModelPositionToViewPosition(new Position$1(desiredTopModelLineNumber, 1));
				return viewModel.viewLayout.getVerticalOffsetForLineNumber(viewPosition.lineNumber);
			}
			if (args.unit === 5) {
				let desiredTopModelLineNumber = 0;
				if (args.direction === 3) desiredTopModelLineNumber = viewModel.model.getLineCount() - viewModel.cursorConfig.pageSize;
				return viewModel.viewLayout.getVerticalOffsetForLineNumber(desiredTopModelLineNumber);
			}
			let noOfLines;
			if (args.unit === 3) noOfLines = viewModel.cursorConfig.pageSize * args.value;
			else if (args.unit === 4) noOfLines = Math.round(viewModel.cursorConfig.pageSize / 2) * args.value;
			else noOfLines = args.value;
			const deltaLines = (args.direction === 1 ? -1 : 1) * noOfLines;
			return viewModel.viewLayout.getCurrentScrollTop() + deltaLines * viewModel.cursorConfig.lineHeight;
		}
		_runHorizontalEditorScroll(viewModel, source, args) {
			const desiredScrollLeft = this._computeDesiredScrollLeft(viewModel, args);
			viewModel.viewLayout.setScrollPosition({ scrollLeft: desiredScrollLeft }, 0);
		}
		_computeDesiredScrollLeft(viewModel, args) {
			const deltaColumns = (args.direction === 4 ? -1 : 1) * args.value;
			return viewModel.viewLayout.getCurrentScrollLeft() + deltaColumns * viewModel.cursorConfig.typicalHalfwidthCharacterWidth;
		}
	}
	CoreNavigationCommands.EditorScrollImpl = EditorScrollImpl;
	CoreNavigationCommands.EditorScroll = registerEditorCommand(new EditorScrollImpl());
	CoreNavigationCommands.ScrollLineUp = registerEditorCommand(new class extends CoreEditorCommand {
		constructor() {
			super({
				id: "scrollLineUp",
				precondition: void 0,
				kbOpts: {
					weight: CORE_WEIGHT,
					kbExpr: EditorContextKeys.textInputFocus,
					primary: 2064,
					mac: { primary: 267 }
				}
			});
		}
		runCoreEditorCommand(viewModel, args) {
			CoreNavigationCommands.EditorScroll.runCoreEditorCommand(viewModel, {
				to: EditorScroll_.RawDirection.Up,
				by: EditorScroll_.RawUnit.WrappedLine,
				value: 1,
				revealCursor: false,
				select: false,
				source: args.source
			});
		}
	}());
	CoreNavigationCommands.ScrollPageUp = registerEditorCommand(new class extends CoreEditorCommand {
		constructor() {
			super({
				id: "scrollPageUp",
				precondition: void 0,
				kbOpts: {
					weight: CORE_WEIGHT,
					kbExpr: EditorContextKeys.textInputFocus,
					primary: 2059,
					win: { primary: 523 },
					linux: { primary: 523 }
				}
			});
		}
		runCoreEditorCommand(viewModel, args) {
			CoreNavigationCommands.EditorScroll.runCoreEditorCommand(viewModel, {
				to: EditorScroll_.RawDirection.Up,
				by: EditorScroll_.RawUnit.Page,
				value: 1,
				revealCursor: false,
				select: false,
				source: args.source
			});
		}
	}());
	CoreNavigationCommands.ScrollEditorTop = registerEditorCommand(new class extends CoreEditorCommand {
		constructor() {
			super({
				id: "scrollEditorTop",
				precondition: void 0,
				kbOpts: {
					weight: CORE_WEIGHT,
					kbExpr: EditorContextKeys.textInputFocus
				}
			});
		}
		runCoreEditorCommand(viewModel, args) {
			CoreNavigationCommands.EditorScroll.runCoreEditorCommand(viewModel, {
				to: EditorScroll_.RawDirection.Up,
				by: EditorScroll_.RawUnit.Editor,
				value: 1,
				revealCursor: false,
				select: false,
				source: args.source
			});
		}
	}());
	CoreNavigationCommands.ScrollLineDown = registerEditorCommand(new class extends CoreEditorCommand {
		constructor() {
			super({
				id: "scrollLineDown",
				precondition: void 0,
				kbOpts: {
					weight: CORE_WEIGHT,
					kbExpr: EditorContextKeys.textInputFocus,
					primary: 2066,
					mac: { primary: 268 }
				}
			});
		}
		runCoreEditorCommand(viewModel, args) {
			CoreNavigationCommands.EditorScroll.runCoreEditorCommand(viewModel, {
				to: EditorScroll_.RawDirection.Down,
				by: EditorScroll_.RawUnit.WrappedLine,
				value: 1,
				revealCursor: false,
				select: false,
				source: args.source
			});
		}
	}());
	CoreNavigationCommands.ScrollPageDown = registerEditorCommand(new class extends CoreEditorCommand {
		constructor() {
			super({
				id: "scrollPageDown",
				precondition: void 0,
				kbOpts: {
					weight: CORE_WEIGHT,
					kbExpr: EditorContextKeys.textInputFocus,
					primary: 2060,
					win: { primary: 524 },
					linux: { primary: 524 }
				}
			});
		}
		runCoreEditorCommand(viewModel, args) {
			CoreNavigationCommands.EditorScroll.runCoreEditorCommand(viewModel, {
				to: EditorScroll_.RawDirection.Down,
				by: EditorScroll_.RawUnit.Page,
				value: 1,
				revealCursor: false,
				select: false,
				source: args.source
			});
		}
	}());
	CoreNavigationCommands.ScrollEditorBottom = registerEditorCommand(new class extends CoreEditorCommand {
		constructor() {
			super({
				id: "scrollEditorBottom",
				precondition: void 0,
				kbOpts: {
					weight: CORE_WEIGHT,
					kbExpr: EditorContextKeys.textInputFocus
				}
			});
		}
		runCoreEditorCommand(viewModel, args) {
			CoreNavigationCommands.EditorScroll.runCoreEditorCommand(viewModel, {
				to: EditorScroll_.RawDirection.Down,
				by: EditorScroll_.RawUnit.Editor,
				value: 1,
				revealCursor: false,
				select: false,
				source: args.source
			});
		}
	}());
	CoreNavigationCommands.ScrollLeft = registerEditorCommand(new class extends CoreEditorCommand {
		constructor() {
			super({
				id: "scrollLeft",
				precondition: void 0,
				kbOpts: {
					weight: CORE_WEIGHT,
					kbExpr: EditorContextKeys.textInputFocus
				}
			});
		}
		runCoreEditorCommand(viewModel, args) {
			CoreNavigationCommands.EditorScroll.runCoreEditorCommand(viewModel, {
				to: EditorScroll_.RawDirection.Left,
				by: EditorScroll_.RawUnit.Column,
				value: 2,
				revealCursor: false,
				select: false,
				source: args.source
			});
		}
	}());
	CoreNavigationCommands.ScrollRight = registerEditorCommand(new class extends CoreEditorCommand {
		constructor() {
			super({
				id: "scrollRight",
				precondition: void 0,
				kbOpts: {
					weight: CORE_WEIGHT,
					kbExpr: EditorContextKeys.textInputFocus
				}
			});
		}
		runCoreEditorCommand(viewModel, args) {
			CoreNavigationCommands.EditorScroll.runCoreEditorCommand(viewModel, {
				to: EditorScroll_.RawDirection.Right,
				by: EditorScroll_.RawUnit.Column,
				value: 2,
				revealCursor: false,
				select: false,
				source: args.source
			});
		}
	}());
	class WordCommand extends CoreEditorCommand {
		constructor(opts) {
			super(opts);
			this._inSelectionMode = opts.inSelectionMode;
		}
		runCoreEditorCommand(viewModel, args) {
			if (!args.position) return;
			viewModel.model.pushStackElement();
			viewModel.setCursorStates(args.source, 3, [CursorMoveCommands.word(viewModel, viewModel.getPrimaryCursorState(), this._inSelectionMode, args.position)]);
			if (args.revealType !== 2) viewModel.revealAllCursors(args.source, true, true);
		}
	}
	CoreNavigationCommands.WordSelect = registerEditorCommand(new WordCommand({
		inSelectionMode: false,
		id: "_wordSelect",
		precondition: void 0
	}));
	CoreNavigationCommands.WordSelectDrag = registerEditorCommand(new WordCommand({
		inSelectionMode: true,
		id: "_wordSelectDrag",
		precondition: void 0
	}));
	CoreNavigationCommands.LastCursorWordSelect = registerEditorCommand(new class extends CoreEditorCommand {
		constructor() {
			super({
				id: "lastCursorWordSelect",
				precondition: void 0
			});
		}
		runCoreEditorCommand(viewModel, args) {
			if (!args.position) return;
			const lastAddedCursorIndex = viewModel.getLastAddedCursorIndex();
			const states = viewModel.getCursorStates();
			const newStates = states.slice(0);
			const lastAddedState = states[lastAddedCursorIndex];
			newStates[lastAddedCursorIndex] = CursorMoveCommands.word(viewModel, lastAddedState, lastAddedState.modelState.hasSelection(), args.position);
			viewModel.model.pushStackElement();
			viewModel.setCursorStates(args.source, 3, newStates);
		}
	}());
	class LineCommand extends CoreEditorCommand {
		constructor(opts) {
			super(opts);
			this._inSelectionMode = opts.inSelectionMode;
		}
		runCoreEditorCommand(viewModel, args) {
			if (!args.position) return;
			viewModel.model.pushStackElement();
			viewModel.setCursorStates(args.source, 3, [CursorMoveCommands.line(viewModel, viewModel.getPrimaryCursorState(), this._inSelectionMode, args.position, args.viewPosition)]);
			if (args.revealType !== 2) viewModel.revealAllCursors(args.source, false, true);
		}
	}
	CoreNavigationCommands.LineSelect = registerEditorCommand(new LineCommand({
		inSelectionMode: false,
		id: "_lineSelect",
		precondition: void 0
	}));
	CoreNavigationCommands.LineSelectDrag = registerEditorCommand(new LineCommand({
		inSelectionMode: true,
		id: "_lineSelectDrag",
		precondition: void 0
	}));
	class LastCursorLineCommand extends CoreEditorCommand {
		constructor(opts) {
			super(opts);
			this._inSelectionMode = opts.inSelectionMode;
		}
		runCoreEditorCommand(viewModel, args) {
			if (!args.position) return;
			const lastAddedCursorIndex = viewModel.getLastAddedCursorIndex();
			const states = viewModel.getCursorStates();
			const newStates = states.slice(0);
			newStates[lastAddedCursorIndex] = CursorMoveCommands.line(viewModel, states[lastAddedCursorIndex], this._inSelectionMode, args.position, args.viewPosition);
			viewModel.model.pushStackElement();
			viewModel.setCursorStates(args.source, 3, newStates);
		}
	}
	CoreNavigationCommands.LastCursorLineSelect = registerEditorCommand(new LastCursorLineCommand({
		inSelectionMode: false,
		id: "lastCursorLineSelect",
		precondition: void 0
	}));
	CoreNavigationCommands.LastCursorLineSelectDrag = registerEditorCommand(new LastCursorLineCommand({
		inSelectionMode: true,
		id: "lastCursorLineSelectDrag",
		precondition: void 0
	}));
	CoreNavigationCommands.CancelSelection = registerEditorCommand(new class extends CoreEditorCommand {
		constructor() {
			super({
				id: "cancelSelection",
				precondition: EditorContextKeys.hasNonEmptySelection,
				kbOpts: {
					weight: CORE_WEIGHT,
					kbExpr: EditorContextKeys.textInputFocus,
					primary: 9,
					secondary: [1033]
				}
			});
		}
		runCoreEditorCommand(viewModel, args) {
			viewModel.model.pushStackElement();
			viewModel.setCursorStates(args.source, 3, [CursorMoveCommands.cancelSelection(viewModel, viewModel.getPrimaryCursorState())]);
			viewModel.revealAllCursors(args.source, true);
		}
	}());
	CoreNavigationCommands.RemoveSecondaryCursors = registerEditorCommand(new class extends CoreEditorCommand {
		constructor() {
			super({
				id: "removeSecondaryCursors",
				precondition: EditorContextKeys.hasMultipleSelections,
				kbOpts: {
					weight: 1,
					kbExpr: EditorContextKeys.textInputFocus,
					primary: 9,
					secondary: [1033]
				}
			});
		}
		runCoreEditorCommand(viewModel, args) {
			viewModel.model.pushStackElement();
			viewModel.setCursorStates(args.source, 3, [viewModel.getPrimaryCursorState()]);
			viewModel.revealAllCursors(args.source, true);
			status(localize(72, "Removed secondary cursors"));
		}
	}());
	CoreNavigationCommands.RevealLine = registerEditorCommand(new class extends CoreEditorCommand {
		constructor() {
			super({
				id: "revealLine",
				precondition: void 0,
				metadata: RevealLine_.metadata
			});
		}
		runCoreEditorCommand(viewModel, args) {
			const revealLineArg = args;
			const lineNumberArg = revealLineArg.lineNumber || 0;
			let lineNumber = typeof lineNumberArg === "number" ? lineNumberArg + 1 : parseInt(lineNumberArg) + 1;
			if (lineNumber < 1) lineNumber = 1;
			const lineCount = viewModel.model.getLineCount();
			if (lineNumber > lineCount) lineNumber = lineCount;
			const range = new Range$2(lineNumber, 1, lineNumber, viewModel.model.getLineMaxColumn(lineNumber));
			let revealAt = 0;
			if (revealLineArg.at) switch (revealLineArg.at) {
				case RevealLine_.RawAtArgument.Top:
					revealAt = 3;
					break;
				case RevealLine_.RawAtArgument.Center:
					revealAt = 1;
					break;
				case RevealLine_.RawAtArgument.Bottom: revealAt = 4;
			}
			const viewRange = viewModel.coordinatesConverter.convertModelRangeToViewRange(range);
			viewModel.revealRange(args.source, false, viewRange, revealAt, 0);
		}
	}());
	CoreNavigationCommands.SelectAll = new class extends EditorOrNativeTextInputCommand {
		constructor() {
			super(SelectAllCommand);
		}
		runDOMCommand(activeElement) {
			if (isFirefox) {
				activeElement.focus();
				activeElement.select();
			}
			activeElement.ownerDocument.execCommand("selectAll");
		}
		runEditorCommand(accessor, editor, args) {
			const viewModel = editor._getViewModel();
			if (!viewModel) return;
			this.runCoreEditorCommand(viewModel, args);
		}
		runCoreEditorCommand(viewModel, args) {
			viewModel.model.pushStackElement();
			viewModel.setCursorStates("keyboard", 3, [CursorMoveCommands.selectAll(viewModel, viewModel.getPrimaryCursorState())]);
		}
	}();
	CoreNavigationCommands.SetSelection = registerEditorCommand(new class extends CoreEditorCommand {
		constructor() {
			super({
				id: "setSelection",
				precondition: void 0
			});
		}
		runCoreEditorCommand(viewModel, args) {
			if (!args.selection) return;
			viewModel.model.pushStackElement();
			viewModel.setCursorStates(args.source, 3, [CursorState.fromModelSelection(args.selection)]);
		}
	}());
})(CoreNavigationCommands || (CoreNavigationCommands = {}));
var columnSelectionCondition = ContextKeyExpr.and(EditorContextKeys.textInputFocus, EditorContextKeys.columnSelection);
function registerColumnSelection(id, keybinding) {
	KeybindingsRegistry.registerKeybindingRule({
		id,
		primary: keybinding,
		when: columnSelectionCondition,
		weight: 1
	});
}
registerColumnSelection(CoreNavigationCommands.CursorColumnSelectLeft.id, 1039);
registerColumnSelection(CoreNavigationCommands.CursorColumnSelectRight.id, 1041);
registerColumnSelection(CoreNavigationCommands.CursorColumnSelectUp.id, 1040);
registerColumnSelection(CoreNavigationCommands.CursorColumnSelectPageUp.id, 1035);
registerColumnSelection(CoreNavigationCommands.CursorColumnSelectDown.id, 1042);
registerColumnSelection(CoreNavigationCommands.CursorColumnSelectPageDown.id, 1036);
function registerCommand$1(command) {
	command.register();
	return command;
}
var CoreEditingCommands;
(function(CoreEditingCommands) {
	class CoreEditingCommand extends EditorCommand {
		runEditorCommand(accessor, editor, args) {
			const viewModel = editor._getViewModel();
			if (!viewModel) return;
			this.runCoreEditingCommand(editor, viewModel, args || {});
		}
	}
	CoreEditingCommands.CoreEditingCommand = CoreEditingCommand;
	CoreEditingCommands.LineBreakInsert = registerEditorCommand(new class extends CoreEditingCommand {
		constructor() {
			super({
				id: "lineBreakInsert",
				precondition: EditorContextKeys.writable,
				kbOpts: {
					weight: CORE_WEIGHT,
					kbExpr: EditorContextKeys.textInputFocus,
					primary: 0,
					mac: { primary: 301 }
				}
			});
		}
		runCoreEditingCommand(editor, viewModel, args) {
			editor.pushUndoStop();
			editor.executeCommands(this.id, EnterOperation.lineBreakInsert(viewModel.cursorConfig, viewModel.model, viewModel.getCursorStates().map((s) => s.modelState.selection)));
		}
	}());
	CoreEditingCommands.Outdent = registerEditorCommand(new class extends CoreEditingCommand {
		constructor() {
			super({
				id: "outdent",
				precondition: EditorContextKeys.writable,
				kbOpts: {
					weight: CORE_WEIGHT,
					kbExpr: ContextKeyExpr.and(EditorContextKeys.editorTextFocus, EditorContextKeys.tabDoesNotMoveFocus),
					primary: 1026
				}
			});
		}
		runCoreEditingCommand(editor, viewModel, args) {
			editor.pushUndoStop();
			editor.executeCommands(this.id, TypeOperations.outdent(viewModel.cursorConfig, viewModel.model, viewModel.getCursorStates().map((s) => s.modelState.selection)));
			editor.pushUndoStop();
		}
	}());
	CoreEditingCommands.Tab = registerEditorCommand(new class extends CoreEditingCommand {
		constructor() {
			super({
				id: "tab",
				precondition: EditorContextKeys.writable,
				kbOpts: {
					weight: CORE_WEIGHT,
					kbExpr: ContextKeyExpr.and(EditorContextKeys.editorTextFocus, EditorContextKeys.tabDoesNotMoveFocus),
					primary: 2
				}
			});
		}
		runCoreEditingCommand(editor, viewModel, args) {
			editor.pushUndoStop();
			editor.executeCommands(this.id, TypeOperations.tab(viewModel.cursorConfig, viewModel.model, viewModel.getCursorStates().map((s) => s.modelState.selection)));
			editor.pushUndoStop();
		}
	}());
	CoreEditingCommands.DeleteLeft = registerEditorCommand(new class extends CoreEditingCommand {
		constructor() {
			super({
				id: "deleteLeft",
				precondition: void 0,
				kbOpts: {
					weight: CORE_WEIGHT,
					kbExpr: EditorContextKeys.textInputFocus,
					primary: 1,
					secondary: [1025],
					mac: {
						primary: 1,
						secondary: [
							1025,
							294,
							257
						]
					}
				}
			});
		}
		runCoreEditingCommand(editor, viewModel, args) {
			const [shouldPushStackElementBefore, commands] = DeleteOperations.deleteLeft(viewModel.getPrevEditOperationType(), viewModel.cursorConfig, viewModel.model, viewModel.getCursorStates().map((s) => s.modelState.selection), viewModel.getCursorAutoClosedCharacters());
			if (shouldPushStackElementBefore) editor.pushUndoStop();
			editor.executeCommands(this.id, commands);
			viewModel.setPrevEditOperationType(2);
		}
	}());
	CoreEditingCommands.DeleteRight = registerEditorCommand(new class extends CoreEditingCommand {
		constructor() {
			super({
				id: "deleteRight",
				precondition: void 0,
				kbOpts: {
					weight: CORE_WEIGHT,
					kbExpr: EditorContextKeys.textInputFocus,
					primary: 20,
					mac: {
						primary: 20,
						secondary: [290, 276]
					}
				}
			});
		}
		runCoreEditingCommand(editor, viewModel, args) {
			const [shouldPushStackElementBefore, commands] = DeleteOperations.deleteRight(viewModel.getPrevEditOperationType(), viewModel.cursorConfig, viewModel.model, viewModel.getCursorStates().map((s) => s.modelState.selection));
			if (shouldPushStackElementBefore) editor.pushUndoStop();
			editor.executeCommands(this.id, commands);
			viewModel.setPrevEditOperationType(3);
		}
	}());
	CoreEditingCommands.Undo = new class extends EditorOrNativeTextInputCommand {
		constructor() {
			super(UndoCommand);
		}
		runDOMCommand(activeElement) {
			activeElement.ownerDocument.execCommand("undo");
		}
		runEditorCommand(accessor, editor, args) {
			if (!editor.hasModel() || editor.getOption(104) === true) return;
			return editor.getModel().undo();
		}
	}();
	CoreEditingCommands.Redo = new class extends EditorOrNativeTextInputCommand {
		constructor() {
			super(RedoCommand);
		}
		runDOMCommand(activeElement) {
			activeElement.ownerDocument.execCommand("redo");
		}
		runEditorCommand(accessor, editor, args) {
			if (!editor.hasModel() || editor.getOption(104) === true) return;
			return editor.getModel().redo();
		}
	}();
})(CoreEditingCommands || (CoreEditingCommands = {}));
/**
* A command that will invoke a command on the focused editor.
*/
var EditorHandlerCommand = class extends Command {
	constructor(id, handlerId, metadata) {
		super({
			id,
			precondition: void 0,
			metadata
		});
		this._handlerId = handlerId;
	}
	runCommand(accessor, args) {
		const editor = accessor.get(ICodeEditorService).getFocusedCodeEditor();
		if (!editor) return;
		editor.trigger("keyboard", this._handlerId, args);
	}
};
function registerOverwritableCommand(handlerId, metadata) {
	registerCommand$1(new EditorHandlerCommand("default:" + handlerId, handlerId));
	registerCommand$1(new EditorHandlerCommand(handlerId, handlerId, metadata));
}
registerOverwritableCommand("type", {
	description: `Type`,
	args: [{
		name: "args",
		schema: {
			"type": "object",
			"required": ["text"],
			"properties": { "text": { "type": "string" } }
		}
	}]
});
registerOverwritableCommand("replacePreviousChar");
registerOverwritableCommand("compositionType");
registerOverwritableCommand("compositionStart");
registerOverwritableCommand("compositionEnd");
registerOverwritableCommand("paste");
registerOverwritableCommand("cut");
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/view/viewController.js
var ViewController = class ViewController {
	constructor(configuration, viewModel, userInputEvents, commandDelegate) {
		this.configuration = configuration;
		this.viewModel = viewModel;
		this.userInputEvents = userInputEvents;
		this.commandDelegate = commandDelegate;
	}
	paste(text, pasteOnNewLine, multicursorText, mode) {
		this.commandDelegate.paste(text, pasteOnNewLine, multicursorText, mode);
	}
	type(text) {
		this.commandDelegate.type(text);
	}
	compositionType(text, replacePrevCharCnt, replaceNextCharCnt, positionDelta) {
		this.commandDelegate.compositionType(text, replacePrevCharCnt, replaceNextCharCnt, positionDelta);
	}
	compositionStart() {
		this.commandDelegate.startComposition();
	}
	compositionEnd() {
		this.commandDelegate.endComposition();
	}
	cut() {
		this.commandDelegate.cut();
	}
	setSelection(modelSelection) {
		CoreNavigationCommands.SetSelection.runCoreEditorCommand(this.viewModel, {
			source: "keyboard",
			selection: modelSelection
		});
	}
	_validateViewColumn(viewPosition) {
		const minColumn = this.viewModel.getLineMinColumn(viewPosition.lineNumber);
		if (viewPosition.column < minColumn) return new Position$1(viewPosition.lineNumber, minColumn);
		return viewPosition;
	}
	_hasMulticursorModifier(data) {
		switch (this.configuration.options.get(86)) {
			case "altKey": return data.altKey;
			case "ctrlKey": return data.ctrlKey;
			case "metaKey": return data.metaKey;
			default: return false;
		}
	}
	_hasNonMulticursorModifier(data) {
		switch (this.configuration.options.get(86)) {
			case "altKey": return data.ctrlKey || data.metaKey;
			case "ctrlKey": return data.altKey || data.metaKey;
			case "metaKey": return data.ctrlKey || data.altKey;
			default: return false;
		}
	}
	/**
	* Selects content inside brackets if the position is right after an opening bracket or right before a closing bracket.
	* @param pos The position in the model.
	* @param model The text model.
	*/
	static _trySelectBracketContent(model, pos) {
		if (pos.column > 1) {
			const pair = model.bracketPairs.matchBracket(pos.with(void 0, pos.column - 1));
			if (pair && pair[0].getEndPosition().equals(pos)) return Selection$1.fromPositions(pair[0].getEndPosition(), pair[1].getStartPosition());
		}
		if (pos.column <= model.getLineMaxColumn(pos.lineNumber)) {
			const pair = model.bracketPairs.matchBracket(pos);
			if (pair && pair[1].getStartPosition().equals(pos)) return Selection$1.fromPositions(pair[0].getEndPosition(), pair[1].getStartPosition());
		}
	}
	/**
	* Selects content inside a string if the position is right after an opening quote or right before a closing quote.
	* @param pos The position in the model.
	* @param model The text model.
	*/
	static _trySelectStringContent(model, pos) {
		const { lineNumber, column } = pos;
		const { tokenization: tokens } = model;
		if (!tokens.hasAccurateTokensForLine(lineNumber)) {
			if (tokens.isCheapToTokenize(lineNumber)) tokens.forceTokenization(lineNumber);
			else return;
		}
		const lineTokens = tokens.getLineTokens(lineNumber);
		let startIndex = lineTokens.findTokenIndexAtOffset(column - 1);
		let endIndex = startIndex;
		while (startIndex > 0 && lineTokens.getStandardTokenType(startIndex - 1) === 2) startIndex--;
		while (endIndex + 1 < lineTokens.getCount() && lineTokens.getStandardTokenType(endIndex + 1) === 2) endIndex++;
		const tokenStart = lineTokens.getStartOffset(startIndex);
		const tokenEnd = lineTokens.getEndOffset(endIndex);
		if (column !== tokenStart + 2 && column !== tokenEnd) return;
		const lineContent = model.getLineContent(lineNumber);
		const firstChar = lineContent.charAt(tokenStart);
		if (firstChar !== "\"" && firstChar !== "'" && firstChar !== "`") return;
		if (lineContent.charAt(tokenEnd - 1) !== firstChar) return;
		const content = lineContent.substring(tokenStart + 1, tokenEnd - 1);
		if (containsRTL(content)) return;
		return new Selection$1(lineNumber, tokenStart + 2, lineNumber, tokenEnd);
	}
	dispatchMouse(data) {
		const options = this.configuration.options;
		const selectionClipboardIsOn = isLinux && options.get(121);
		const columnSelection = options.get(28);
		const scrollOnMiddleClick = options.get(172);
		if (data.middleButton && !selectionClipboardIsOn) {
			if (scrollOnMiddleClick);
			else this._columnSelect(data.position, data.mouseColumn, data.inSelectionMode);
		} else if (data.startedOnLineNumbers) {
			if (this._hasMulticursorModifier(data)) {
				if (data.inSelectionMode) this._lastCursorLineSelect(data.position, data.revealType);
				else this._createCursor(data.position, true);
			} else if (data.inSelectionMode) this._lineSelectDrag(data.position, data.revealType);
			else this._lineSelect(data.position, data.revealType);
		} else if (data.mouseDownCount >= 4) this._selectAll();
		else if (data.mouseDownCount === 3) {
			if (this._hasMulticursorModifier(data)) {
				if (data.inSelectionMode) this._lastCursorLineSelectDrag(data.position, data.revealType);
				else this._lastCursorLineSelect(data.position, data.revealType);
			} else if (data.inSelectionMode) this._lineSelectDrag(data.position, data.revealType);
			else this._lineSelect(data.position, data.revealType);
		} else if (data.mouseDownCount === 2) {
			if (!data.onInjectedText) {
				if (this._hasMulticursorModifier(data)) this._lastCursorWordSelect(data.position, data.revealType);
				else if (data.inSelectionMode) this._wordSelectDrag(data.position, data.revealType);
				else {
					let selection;
					if (options.get(174)) {
						const model = this.viewModel.model;
						const modelPos = this._convertViewToModelPosition(data.position);
						selection = ViewController._trySelectBracketContent(model, modelPos) || ViewController._trySelectStringContent(model, modelPos);
					}
					if (selection) this._select(selection);
					else this._wordSelect(data.position, data.revealType);
				}
			}
		} else if (this._hasMulticursorModifier(data)) {
			if (!this._hasNonMulticursorModifier(data)) {
				if (data.shiftKey) this._columnSelect(data.position, data.mouseColumn, true);
				else if (data.inSelectionMode) this._lastCursorMoveToSelect(data.position, data.revealType);
				else this._createCursor(data.position, false);
			}
		} else if (data.inSelectionMode) {
			if (data.altKey) this._columnSelect(data.position, data.mouseColumn, true);
			else if (columnSelection) this._columnSelect(data.position, data.mouseColumn, true);
			else this._moveToSelect(data.position, data.revealType);
		} else this.moveTo(data.position, data.revealType);
	}
	_usualArgs(viewPosition, revealType) {
		viewPosition = this._validateViewColumn(viewPosition);
		return {
			source: "mouse",
			position: this._convertViewToModelPosition(viewPosition),
			viewPosition,
			revealType
		};
	}
	moveTo(viewPosition, revealType) {
		CoreNavigationCommands.MoveTo.runCoreEditorCommand(this.viewModel, this._usualArgs(viewPosition, revealType));
	}
	_moveToSelect(viewPosition, revealType) {
		CoreNavigationCommands.MoveToSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(viewPosition, revealType));
	}
	_columnSelect(viewPosition, mouseColumn, doColumnSelect) {
		viewPosition = this._validateViewColumn(viewPosition);
		CoreNavigationCommands.ColumnSelect.runCoreEditorCommand(this.viewModel, {
			source: "mouse",
			position: this._convertViewToModelPosition(viewPosition),
			viewPosition,
			mouseColumn,
			doColumnSelect
		});
	}
	_createCursor(viewPosition, wholeLine) {
		viewPosition = this._validateViewColumn(viewPosition);
		CoreNavigationCommands.CreateCursor.runCoreEditorCommand(this.viewModel, {
			source: "mouse",
			position: this._convertViewToModelPosition(viewPosition),
			viewPosition,
			wholeLine
		});
	}
	_lastCursorMoveToSelect(viewPosition, revealType) {
		CoreNavigationCommands.LastCursorMoveToSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(viewPosition, revealType));
	}
	_wordSelect(viewPosition, revealType) {
		CoreNavigationCommands.WordSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(viewPosition, revealType));
	}
	_wordSelectDrag(viewPosition, revealType) {
		CoreNavigationCommands.WordSelectDrag.runCoreEditorCommand(this.viewModel, this._usualArgs(viewPosition, revealType));
	}
	_lastCursorWordSelect(viewPosition, revealType) {
		CoreNavigationCommands.LastCursorWordSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(viewPosition, revealType));
	}
	_lineSelect(viewPosition, revealType) {
		CoreNavigationCommands.LineSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(viewPosition, revealType));
	}
	_lineSelectDrag(viewPosition, revealType) {
		CoreNavigationCommands.LineSelectDrag.runCoreEditorCommand(this.viewModel, this._usualArgs(viewPosition, revealType));
	}
	_lastCursorLineSelect(viewPosition, revealType) {
		CoreNavigationCommands.LastCursorLineSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(viewPosition, revealType));
	}
	_lastCursorLineSelectDrag(viewPosition, revealType) {
		CoreNavigationCommands.LastCursorLineSelectDrag.runCoreEditorCommand(this.viewModel, this._usualArgs(viewPosition, revealType));
	}
	_select(selection) {
		CoreNavigationCommands.SetSelection.runCoreEditorCommand(this.viewModel, {
			source: "mouse",
			selection
		});
	}
	_selectAll() {
		CoreNavigationCommands.SelectAll.runCoreEditorCommand(this.viewModel, { source: "mouse" });
	}
	_convertViewToModelPosition(viewPosition) {
		return this.viewModel.coordinatesConverter.convertViewPositionToModelPosition(viewPosition);
	}
	emitKeyDown(e) {
		this.userInputEvents.emitKeyDown(e);
	}
	emitKeyUp(e) {
		this.userInputEvents.emitKeyUp(e);
	}
	emitContextMenu(e) {
		this.userInputEvents.emitContextMenu(e);
	}
	emitMouseMove(e) {
		this.userInputEvents.emitMouseMove(e);
	}
	emitMouseLeave(e) {
		this.userInputEvents.emitMouseLeave(e);
	}
	emitMouseUp(e) {
		this.userInputEvents.emitMouseUp(e);
	}
	emitMouseDown(e) {
		this.userInputEvents.emitMouseDown(e);
	}
	emitMouseDrag(e) {
		this.userInputEvents.emitMouseDrag(e);
	}
	emitMouseDrop(e) {
		this.userInputEvents.emitMouseDrop(e);
	}
	emitMouseDropCanceled() {
		this.userInputEvents.emitMouseDropCanceled();
	}
	emitMouseWheel(e) {
		this.userInputEvents.emitMouseWheel(e);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/view/viewLayer.js
var RenderedLinesCollection = class {
	constructor(_lineFactory) {
		this._lineFactory = _lineFactory;
		this._set(1, []);
	}
	flush() {
		this._set(1, []);
	}
	_set(rendLineNumberStart, lines) {
		this._lines = lines;
		this._rendLineNumberStart = rendLineNumberStart;
	}
	_get() {
		return {
			rendLineNumberStart: this._rendLineNumberStart,
			lines: this._lines
		};
	}
	/**
	* @returns Inclusive line number that is inside this collection
	*/
	getStartLineNumber() {
		return this._rendLineNumberStart;
	}
	/**
	* @returns Inclusive line number that is inside this collection
	*/
	getEndLineNumber() {
		return this._rendLineNumberStart + this._lines.length - 1;
	}
	getCount() {
		return this._lines.length;
	}
	getLine(lineNumber) {
		const lineIndex = lineNumber - this._rendLineNumberStart;
		if (lineIndex < 0 || lineIndex >= this._lines.length) throw new BugIndicatingError("Illegal value for lineNumber");
		return this._lines[lineIndex];
	}
	/**
	* @returns Lines that were removed from this collection
	*/
	onLinesDeleted(deleteFromLineNumber, deleteToLineNumber) {
		if (this.getCount() === 0) return null;
		const startLineNumber = this.getStartLineNumber();
		const endLineNumber = this.getEndLineNumber();
		if (deleteToLineNumber < startLineNumber) {
			const deleteCnt = deleteToLineNumber - deleteFromLineNumber + 1;
			this._rendLineNumberStart -= deleteCnt;
			return null;
		}
		if (deleteFromLineNumber > endLineNumber) return null;
		let deleteStartIndex = 0;
		let deleteCount = 0;
		for (let lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++) {
			const lineIndex = lineNumber - this._rendLineNumberStart;
			if (deleteFromLineNumber <= lineNumber && lineNumber <= deleteToLineNumber) {
				if (deleteCount === 0) {
					deleteStartIndex = lineIndex;
					deleteCount = 1;
				} else deleteCount++;
			}
		}
		if (deleteFromLineNumber < startLineNumber) {
			let deleteAboveCount = 0;
			if (deleteToLineNumber < startLineNumber) deleteAboveCount = deleteToLineNumber - deleteFromLineNumber + 1;
			else deleteAboveCount = startLineNumber - deleteFromLineNumber;
			this._rendLineNumberStart -= deleteAboveCount;
		}
		return this._lines.splice(deleteStartIndex, deleteCount);
	}
	onLinesChanged(changeFromLineNumber, changeCount) {
		const changeToLineNumber = changeFromLineNumber + changeCount - 1;
		if (this.getCount() === 0) return false;
		const startLineNumber = this.getStartLineNumber();
		const endLineNumber = this.getEndLineNumber();
		let someoneNotified = false;
		for (let changedLineNumber = changeFromLineNumber; changedLineNumber <= changeToLineNumber; changedLineNumber++) if (changedLineNumber >= startLineNumber && changedLineNumber <= endLineNumber) {
			this._lines[changedLineNumber - this._rendLineNumberStart].onContentChanged();
			someoneNotified = true;
		}
		return someoneNotified;
	}
	onLinesInserted(insertFromLineNumber, insertToLineNumber) {
		if (this.getCount() === 0) return null;
		const insertCnt = insertToLineNumber - insertFromLineNumber + 1;
		const startLineNumber = this.getStartLineNumber();
		const endLineNumber = this.getEndLineNumber();
		if (insertFromLineNumber <= startLineNumber) {
			this._rendLineNumberStart += insertCnt;
			return null;
		}
		if (insertFromLineNumber > endLineNumber) return null;
		if (insertCnt + insertFromLineNumber > endLineNumber) return this._lines.splice(insertFromLineNumber - this._rendLineNumberStart, endLineNumber - insertFromLineNumber + 1);
		const newLines = [];
		for (let i = 0; i < insertCnt; i++) newLines[i] = this._lineFactory.createLine();
		const insertIndex = insertFromLineNumber - this._rendLineNumberStart;
		const beforeLines = this._lines.slice(0, insertIndex);
		const afterLines = this._lines.slice(insertIndex, this._lines.length - insertCnt);
		const deletedLines = this._lines.slice(this._lines.length - insertCnt, this._lines.length);
		this._lines = beforeLines.concat(newLines).concat(afterLines);
		return deletedLines;
	}
	onTokensChanged(ranges) {
		if (this.getCount() === 0) return false;
		const startLineNumber = this.getStartLineNumber();
		const endLineNumber = this.getEndLineNumber();
		let notifiedSomeone = false;
		for (let i = 0, len = ranges.length; i < len; i++) {
			const rng = ranges[i];
			if (rng.toLineNumber < startLineNumber || rng.fromLineNumber > endLineNumber) continue;
			const from = Math.max(startLineNumber, rng.fromLineNumber);
			const to = Math.min(endLineNumber, rng.toLineNumber);
			for (let lineNumber = from; lineNumber <= to; lineNumber++) {
				const lineIndex = lineNumber - this._rendLineNumberStart;
				this._lines[lineIndex].onTokensChanged();
				notifiedSomeone = true;
			}
		}
		return notifiedSomeone;
	}
};
var VisibleLinesCollection = class {
	constructor(_viewContext, _lineFactory) {
		this._viewContext = _viewContext;
		this._lineFactory = _lineFactory;
		this.domNode = this._createDomNode();
		this._linesCollection = new RenderedLinesCollection(this._lineFactory);
	}
	_createDomNode() {
		const domNode = createFastDomNode(document.createElement("div"));
		domNode.setClassName("view-layer");
		domNode.setPosition("absolute");
		domNode.domNode.setAttribute("role", "presentation");
		domNode.domNode.setAttribute("aria-hidden", "true");
		return domNode;
	}
	onConfigurationChanged(e) {
		if (e.hasChanged(166)) return true;
		return false;
	}
	onFlushed(e, flushDom) {
		if (flushDom) {
			const start = this._linesCollection.getStartLineNumber();
			const end = this._linesCollection.getEndLineNumber();
			for (let i = start; i <= end; i++) this._linesCollection.getLine(i).getDomNode()?.remove();
		}
		this._linesCollection.flush();
		return true;
	}
	onLinesChanged(e) {
		return this._linesCollection.onLinesChanged(e.fromLineNumber, e.count);
	}
	onLinesDeleted(e) {
		const deleted = this._linesCollection.onLinesDeleted(e.fromLineNumber, e.toLineNumber);
		if (deleted) for (let i = 0, len = deleted.length; i < len; i++) deleted[i].getDomNode()?.remove();
		return true;
	}
	onLinesInserted(e) {
		const deleted = this._linesCollection.onLinesInserted(e.fromLineNumber, e.toLineNumber);
		if (deleted) for (let i = 0, len = deleted.length; i < len; i++) deleted[i].getDomNode()?.remove();
		return true;
	}
	onScrollChanged(e) {
		return e.scrollTopChanged;
	}
	onTokensChanged(e) {
		return this._linesCollection.onTokensChanged(e.ranges);
	}
	onZonesChanged(e) {
		return true;
	}
	getStartLineNumber() {
		return this._linesCollection.getStartLineNumber();
	}
	getEndLineNumber() {
		return this._linesCollection.getEndLineNumber();
	}
	getVisibleLine(lineNumber) {
		return this._linesCollection.getLine(lineNumber);
	}
	renderLines(viewportData) {
		const inp = this._linesCollection._get();
		const renderer = new ViewLayerRenderer(this.domNode.domNode, this._lineFactory, viewportData, this._viewContext);
		const ctx = {
			rendLineNumberStart: inp.rendLineNumberStart,
			lines: inp.lines,
			linesLength: inp.lines.length
		};
		const resCtx = renderer.render(ctx, viewportData.startLineNumber, viewportData.endLineNumber, viewportData.relativeVerticalOffset);
		this._linesCollection._set(resCtx.rendLineNumberStart, resCtx.lines);
	}
};
var ViewLayerRenderer = class ViewLayerRenderer {
	static {
		this._ttPolicy = createTrustedTypesPolicy("editorViewLayer", { createHTML: (value) => value });
	}
	constructor(_domNode, _lineFactory, _viewportData, _viewContext) {
		this._domNode = _domNode;
		this._lineFactory = _lineFactory;
		this._viewportData = _viewportData;
		this._viewContext = _viewContext;
	}
	render(inContext, startLineNumber, stopLineNumber, deltaTop) {
		const ctx = {
			rendLineNumberStart: inContext.rendLineNumberStart,
			lines: inContext.lines.slice(0),
			linesLength: inContext.linesLength
		};
		if (ctx.rendLineNumberStart + ctx.linesLength - 1 < startLineNumber || stopLineNumber < ctx.rendLineNumberStart) {
			ctx.rendLineNumberStart = startLineNumber;
			ctx.linesLength = stopLineNumber - startLineNumber + 1;
			ctx.lines = [];
			for (let x = startLineNumber; x <= stopLineNumber; x++) ctx.lines[x - startLineNumber] = this._lineFactory.createLine();
			this._finishRendering(ctx, true, deltaTop);
			return ctx;
		}
		this._renderUntouchedLines(ctx, Math.max(startLineNumber - ctx.rendLineNumberStart, 0), Math.min(stopLineNumber - ctx.rendLineNumberStart, ctx.linesLength - 1), deltaTop, startLineNumber);
		if (ctx.rendLineNumberStart > startLineNumber) {
			const fromLineNumber = startLineNumber;
			const toLineNumber = Math.min(stopLineNumber, ctx.rendLineNumberStart - 1);
			if (fromLineNumber <= toLineNumber) {
				this._insertLinesBefore(ctx, fromLineNumber, toLineNumber, deltaTop, startLineNumber);
				ctx.linesLength += toLineNumber - fromLineNumber + 1;
			}
		} else if (ctx.rendLineNumberStart < startLineNumber) {
			const removeCnt = Math.min(ctx.linesLength, startLineNumber - ctx.rendLineNumberStart);
			if (removeCnt > 0) {
				this._removeLinesBefore(ctx, removeCnt);
				ctx.linesLength -= removeCnt;
			}
		}
		ctx.rendLineNumberStart = startLineNumber;
		if (ctx.rendLineNumberStart + ctx.linesLength - 1 < stopLineNumber) {
			const fromLineNumber = ctx.rendLineNumberStart + ctx.linesLength;
			const toLineNumber = stopLineNumber;
			if (fromLineNumber <= toLineNumber) {
				this._insertLinesAfter(ctx, fromLineNumber, toLineNumber, deltaTop, startLineNumber);
				ctx.linesLength += toLineNumber - fromLineNumber + 1;
			}
		} else if (ctx.rendLineNumberStart + ctx.linesLength - 1 > stopLineNumber) {
			const fromLineNumber = Math.max(0, stopLineNumber - ctx.rendLineNumberStart + 1);
			const removeCnt = ctx.linesLength - 1 - fromLineNumber + 1;
			if (removeCnt > 0) {
				this._removeLinesAfter(ctx, removeCnt);
				ctx.linesLength -= removeCnt;
			}
		}
		this._finishRendering(ctx, false, deltaTop);
		return ctx;
	}
	_renderUntouchedLines(ctx, startIndex, endIndex, deltaTop, deltaLN) {
		const rendLineNumberStart = ctx.rendLineNumberStart;
		const lines = ctx.lines;
		for (let i = startIndex; i <= endIndex; i++) {
			const lineNumber = rendLineNumberStart + i;
			lines[i].layoutLine(lineNumber, deltaTop[lineNumber - deltaLN], this._lineHeightForLineNumber(lineNumber));
		}
	}
	_insertLinesBefore(ctx, fromLineNumber, toLineNumber, deltaTop, deltaLN) {
		const newLines = [];
		let newLinesLen = 0;
		for (let lineNumber = fromLineNumber; lineNumber <= toLineNumber; lineNumber++) newLines[newLinesLen++] = this._lineFactory.createLine();
		ctx.lines = newLines.concat(ctx.lines);
	}
	_removeLinesBefore(ctx, removeCount) {
		for (let i = 0; i < removeCount; i++) ctx.lines[i].getDomNode()?.remove();
		ctx.lines.splice(0, removeCount);
	}
	_insertLinesAfter(ctx, fromLineNumber, toLineNumber, deltaTop, deltaLN) {
		const newLines = [];
		let newLinesLen = 0;
		for (let lineNumber = fromLineNumber; lineNumber <= toLineNumber; lineNumber++) newLines[newLinesLen++] = this._lineFactory.createLine();
		ctx.lines = ctx.lines.concat(newLines);
	}
	_removeLinesAfter(ctx, removeCount) {
		const removeIndex = ctx.linesLength - removeCount;
		for (let i = 0; i < removeCount; i++) ctx.lines[removeIndex + i].getDomNode()?.remove();
		ctx.lines.splice(removeIndex, removeCount);
	}
	_finishRenderingNewLines(ctx, domNodeIsEmpty, newLinesHTML, wasNew) {
		if (ViewLayerRenderer._ttPolicy) newLinesHTML = ViewLayerRenderer._ttPolicy.createHTML(newLinesHTML);
		const lastChild = this._domNode.lastChild;
		if (domNodeIsEmpty || !lastChild) this._domNode.innerHTML = newLinesHTML;
		else lastChild.insertAdjacentHTML("afterend", newLinesHTML);
		let currChild = this._domNode.lastChild;
		for (let i = ctx.linesLength - 1; i >= 0; i--) {
			const line = ctx.lines[i];
			if (wasNew[i]) {
				line.setDomNode(currChild);
				currChild = currChild.previousSibling;
			}
		}
	}
	_finishRenderingInvalidLines(ctx, invalidLinesHTML, wasInvalid) {
		const hugeDomNode = document.createElement("div");
		if (ViewLayerRenderer._ttPolicy) invalidLinesHTML = ViewLayerRenderer._ttPolicy.createHTML(invalidLinesHTML);
		hugeDomNode.innerHTML = invalidLinesHTML;
		for (let i = 0; i < ctx.linesLength; i++) {
			const line = ctx.lines[i];
			if (wasInvalid[i]) {
				const source = hugeDomNode.firstChild;
				line.getDomNode().replaceWith(source);
				line.setDomNode(source);
			}
		}
	}
	static {
		this._sb = new StringBuilder(1e5);
	}
	_finishRendering(ctx, domNodeIsEmpty, deltaTop) {
		const sb = ViewLayerRenderer._sb;
		const linesLength = ctx.linesLength;
		const lines = ctx.lines;
		const rendLineNumberStart = ctx.rendLineNumberStart;
		const wasNew = [];
		{
			sb.reset();
			let hadNewLine = false;
			for (let i = 0; i < linesLength; i++) {
				const line = lines[i];
				wasNew[i] = false;
				if (line.getDomNode()) continue;
				const renderedLineNumber = i + rendLineNumberStart;
				if (!line.renderLine(renderedLineNumber, deltaTop[i], this._lineHeightForLineNumber(renderedLineNumber), this._viewportData, sb)) continue;
				wasNew[i] = true;
				hadNewLine = true;
			}
			if (hadNewLine) this._finishRenderingNewLines(ctx, domNodeIsEmpty, sb.build(), wasNew);
		}
		{
			sb.reset();
			let hadInvalidLine = false;
			const wasInvalid = [];
			for (let i = 0; i < linesLength; i++) {
				const line = lines[i];
				wasInvalid[i] = false;
				if (wasNew[i]) continue;
				const renderedLineNumber = i + rendLineNumberStart;
				if (!line.renderLine(renderedLineNumber, deltaTop[i], this._lineHeightForLineNumber(renderedLineNumber), this._viewportData, sb)) continue;
				wasInvalid[i] = true;
				hadInvalidLine = true;
			}
			if (hadInvalidLine) this._finishRenderingInvalidLines(ctx, sb.build(), wasInvalid);
		}
	}
	_lineHeightForLineNumber(lineNumber) {
		return this._viewContext.viewLayout.getLineHeightForLineNumber(lineNumber);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/view/viewOverlays.js
var ViewOverlays = class extends ViewPart {
	constructor(context) {
		super(context);
		this._dynamicOverlays = [];
		this._isFocused = false;
		this._visibleLines = new VisibleLinesCollection(this._context, { createLine: () => new ViewOverlayLine(this._dynamicOverlays) });
		this.domNode = this._visibleLines.domNode;
		const fontInfo = this._context.configuration.options.get(59);
		applyFontInfo(this.domNode, fontInfo);
		this.domNode.setClassName("view-overlays");
	}
	shouldRender() {
		if (super.shouldRender()) return true;
		for (let i = 0, len = this._dynamicOverlays.length; i < len; i++) if (this._dynamicOverlays[i].shouldRender()) return true;
		return false;
	}
	dispose() {
		super.dispose();
		for (let i = 0, len = this._dynamicOverlays.length; i < len; i++) this._dynamicOverlays[i].dispose();
		this._dynamicOverlays = [];
	}
	getDomNode() {
		return this.domNode;
	}
	addDynamicOverlay(overlay) {
		this._dynamicOverlays.push(overlay);
	}
	onConfigurationChanged(e) {
		this._visibleLines.onConfigurationChanged(e);
		const fontInfo = this._context.configuration.options.get(59);
		applyFontInfo(this.domNode, fontInfo);
		return true;
	}
	onFlushed(e) {
		return this._visibleLines.onFlushed(e);
	}
	onFocusChanged(e) {
		this._isFocused = e.isFocused;
		return true;
	}
	onLinesChanged(e) {
		return this._visibleLines.onLinesChanged(e);
	}
	onLinesDeleted(e) {
		return this._visibleLines.onLinesDeleted(e);
	}
	onLinesInserted(e) {
		return this._visibleLines.onLinesInserted(e);
	}
	onScrollChanged(e) {
		return this._visibleLines.onScrollChanged(e) || true;
	}
	onTokensChanged(e) {
		return this._visibleLines.onTokensChanged(e);
	}
	onZonesChanged(e) {
		return this._visibleLines.onZonesChanged(e);
	}
	prepareRender(ctx) {
		const toRender = this._dynamicOverlays.filter((overlay) => overlay.shouldRender());
		for (let i = 0, len = toRender.length; i < len; i++) {
			const dynamicOverlay = toRender[i];
			dynamicOverlay.prepareRender(ctx);
			dynamicOverlay.onDidRender();
		}
	}
	render(ctx) {
		this._viewOverlaysRender(ctx);
		this.domNode.toggleClassName("focused", this._isFocused);
	}
	_viewOverlaysRender(ctx) {
		this._visibleLines.renderLines(ctx.viewportData);
	}
};
var ViewOverlayLine = class {
	constructor(dynamicOverlays) {
		this._dynamicOverlays = dynamicOverlays;
		this._domNode = null;
		this._renderedContent = null;
	}
	getDomNode() {
		if (!this._domNode) return null;
		return this._domNode.domNode;
	}
	setDomNode(domNode) {
		this._domNode = createFastDomNode(domNode);
	}
	onContentChanged() {}
	onTokensChanged() {}
	renderLine(lineNumber, deltaTop, lineHeight, viewportData, sb) {
		let result = "";
		for (let i = 0, len = this._dynamicOverlays.length; i < len; i++) {
			const dynamicOverlay = this._dynamicOverlays[i];
			result += dynamicOverlay.render(viewportData.startLineNumber, lineNumber);
		}
		if (this._renderedContent === result) return false;
		this._renderedContent = result;
		sb.appendString("<div style=\"top:");
		sb.appendString(String(deltaTop));
		sb.appendString("px;height:");
		sb.appendString(String(lineHeight));
		sb.appendString("px;line-height:");
		sb.appendString(String(lineHeight));
		sb.appendString("px;\">");
		sb.appendString(result);
		sb.appendString("</div>");
		return true;
	}
	layoutLine(lineNumber, deltaTop, lineHeight) {
		if (this._domNode) {
			this._domNode.setTop(deltaTop);
			this._domNode.setHeight(lineHeight);
			this._domNode.setLineHeight(lineHeight);
		}
	}
};
var ContentViewOverlays = class extends ViewOverlays {
	constructor(context) {
		super(context);
		const layoutInfo = this._context.configuration.options.get(166);
		this._contentWidth = layoutInfo.contentWidth;
		this.domNode.setHeight(0);
	}
	onConfigurationChanged(e) {
		const layoutInfo = this._context.configuration.options.get(166);
		this._contentWidth = layoutInfo.contentWidth;
		return super.onConfigurationChanged(e) || true;
	}
	onScrollChanged(e) {
		return super.onScrollChanged(e) || e.scrollWidthChanged;
	}
	_viewOverlaysRender(ctx) {
		super._viewOverlaysRender(ctx);
		this.domNode.setWidth(Math.max(ctx.scrollWidth, this._contentWidth));
	}
};
var MarginViewOverlays = class extends ViewOverlays {
	constructor(context) {
		super(context);
		const options = this._context.configuration.options;
		const layoutInfo = options.get(166);
		this._contentLeft = layoutInfo.contentLeft;
		this.domNode.setClassName("margin-view-overlays");
		this.domNode.setWidth(1);
		applyFontInfo(this.domNode, options.get(59));
	}
	onConfigurationChanged(e) {
		const options = this._context.configuration.options;
		applyFontInfo(this.domNode, options.get(59));
		const layoutInfo = options.get(166);
		this._contentLeft = layoutInfo.contentLeft;
		return super.onConfigurationChanged(e) || true;
	}
	onScrollChanged(e) {
		return super.onScrollChanged(e) || e.scrollHeightChanged;
	}
	_viewOverlaysRender(ctx) {
		super._viewOverlaysRender(ctx);
		const height = Math.min(ctx.scrollHeight, 1e6);
		this.domNode.setHeight(height);
		this.domNode.setWidth(this._contentLeft);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/view/viewUserInputEvents.js
var ViewUserInputEvents = class ViewUserInputEvents {
	constructor(coordinatesConverter) {
		this.onKeyDown = null;
		this.onKeyUp = null;
		this.onContextMenu = null;
		this.onMouseMove = null;
		this.onMouseLeave = null;
		this.onMouseDown = null;
		this.onMouseUp = null;
		this.onMouseDrag = null;
		this.onMouseDrop = null;
		this.onMouseDropCanceled = null;
		this.onMouseWheel = null;
		this._coordinatesConverter = coordinatesConverter;
	}
	emitKeyDown(e) {
		this.onKeyDown?.(e);
	}
	emitKeyUp(e) {
		this.onKeyUp?.(e);
	}
	emitContextMenu(e) {
		this.onContextMenu?.(this._convertViewToModelMouseEvent(e));
	}
	emitMouseMove(e) {
		this.onMouseMove?.(this._convertViewToModelMouseEvent(e));
	}
	emitMouseLeave(e) {
		this.onMouseLeave?.(this._convertViewToModelMouseEvent(e));
	}
	emitMouseDown(e) {
		this.onMouseDown?.(this._convertViewToModelMouseEvent(e));
	}
	emitMouseUp(e) {
		this.onMouseUp?.(this._convertViewToModelMouseEvent(e));
	}
	emitMouseDrag(e) {
		this.onMouseDrag?.(this._convertViewToModelMouseEvent(e));
	}
	emitMouseDrop(e) {
		this.onMouseDrop?.(this._convertViewToModelMouseEvent(e));
	}
	emitMouseDropCanceled() {
		this.onMouseDropCanceled?.();
	}
	emitMouseWheel(e) {
		this.onMouseWheel?.(e);
	}
	_convertViewToModelMouseEvent(e) {
		if (e.target) return {
			event: e.event,
			target: this._convertViewToModelMouseTarget(e.target)
		};
		return e;
	}
	_convertViewToModelMouseTarget(target) {
		return ViewUserInputEvents.convertViewToModelMouseTarget(target, this._coordinatesConverter);
	}
	static convertViewToModelMouseTarget(target, coordinatesConverter) {
		const result = { ...target };
		if (result.position) result.position = coordinatesConverter.convertViewPositionToModelPosition(result.position);
		if (result.range) result.range = coordinatesConverter.convertViewRangeToModelRange(result.range);
		if (result.type === 5 || result.type === 8) result.detail = this.convertViewToModelViewZoneData(result.detail, coordinatesConverter);
		return result;
	}
	static convertViewToModelViewZoneData(data, coordinatesConverter) {
		return {
			viewZoneId: data.viewZoneId,
			positionBefore: data.positionBefore ? coordinatesConverter.convertViewPositionToModelPosition(data.positionBefore) : data.positionBefore,
			positionAfter: data.positionAfter ? coordinatesConverter.convertViewPositionToModelPosition(data.positionAfter) : data.positionAfter,
			position: coordinatesConverter.convertViewPositionToModelPosition(data.position),
			afterLineNumber: coordinatesConverter.convertViewPositionToModelPosition(new Position$1(data.afterLineNumber, 1)).lineNumber
		};
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/blockDecorations/blockDecorations.js
var BlockDecorations = class extends ViewPart {
	constructor(context) {
		super(context);
		this.blocks = [];
		this.contentWidth = -1;
		this.contentLeft = 0;
		this.domNode = createFastDomNode(document.createElement("div"));
		this.domNode.setAttribute("role", "presentation");
		this.domNode.setAttribute("aria-hidden", "true");
		this.domNode.setClassName("blockDecorations-container");
		this.update();
	}
	update() {
		let didChange = false;
		const layoutInfo = this._context.configuration.options.get(166);
		const newContentWidth = layoutInfo.contentWidth - layoutInfo.verticalScrollbarWidth;
		if (this.contentWidth !== newContentWidth) {
			this.contentWidth = newContentWidth;
			didChange = true;
		}
		const newContentLeft = layoutInfo.contentLeft;
		if (this.contentLeft !== newContentLeft) {
			this.contentLeft = newContentLeft;
			didChange = true;
		}
		return didChange;
	}
	onConfigurationChanged(e) {
		return this.update();
	}
	onScrollChanged(e) {
		return e.scrollTopChanged || e.scrollLeftChanged;
	}
	onDecorationsChanged(e) {
		return true;
	}
	onZonesChanged(e) {
		return true;
	}
	prepareRender(ctx) {}
	render(ctx) {
		let count = 0;
		const decorations = ctx.getDecorationsInViewport();
		for (const decoration of decorations) {
			if (!decoration.options.blockClassName) continue;
			let block = this.blocks[count];
			if (!block) {
				block = this.blocks[count] = createFastDomNode(document.createElement("div"));
				this.domNode.appendChild(block);
			}
			let top;
			let bottom;
			if (decoration.options.blockIsAfterEnd) {
				top = ctx.getVerticalOffsetAfterLineNumber(decoration.range.endLineNumber, false);
				bottom = ctx.getVerticalOffsetAfterLineNumber(decoration.range.endLineNumber, true);
			} else {
				top = ctx.getVerticalOffsetForLineNumber(decoration.range.startLineNumber, true);
				bottom = decoration.range.isEmpty() && !decoration.options.blockDoesNotCollapse ? ctx.getVerticalOffsetForLineNumber(decoration.range.startLineNumber, false) : ctx.getVerticalOffsetAfterLineNumber(decoration.range.endLineNumber, true);
			}
			const [paddingTop, paddingRight, paddingBottom, paddingLeft] = decoration.options.blockPadding ?? [
				0,
				0,
				0,
				0
			];
			block.setClassName("blockDecorations-block " + decoration.options.blockClassName);
			block.setLeft(this.contentLeft - paddingLeft);
			block.setWidth(this.contentWidth + paddingLeft + paddingRight);
			block.setTop(top - ctx.scrollTop - paddingTop);
			block.setHeight(bottom - top + paddingTop + paddingBottom);
			count++;
		}
		for (let i = count; i < this.blocks.length; i++) this.blocks[i].domNode.remove();
		this.blocks.length = count;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/contentWidgets/contentWidgets.js
/**
* This view part is responsible for rendering the content widgets, which are
* used for rendering elements that are associated to an editor position,
* such as suggestions or the parameter hints.
*/
var ViewContentWidgets = class extends ViewPart {
	constructor(context, viewDomNode) {
		super(context);
		this._viewDomNode = viewDomNode;
		this._widgets = {};
		this.domNode = createFastDomNode(document.createElement("div"));
		PartFingerprints.write(this.domNode, 1);
		this.domNode.setClassName("contentWidgets");
		this.domNode.setPosition("absolute");
		this.domNode.setTop(0);
		this.overflowingContentWidgetsDomNode = createFastDomNode(document.createElement("div"));
		PartFingerprints.write(this.overflowingContentWidgetsDomNode, 2);
		this.overflowingContentWidgetsDomNode.setClassName("overflowingContentWidgets");
	}
	dispose() {
		super.dispose();
		this._widgets = {};
	}
	onConfigurationChanged(e) {
		const keys = Object.keys(this._widgets);
		for (const widgetId of keys) this._widgets[widgetId].onConfigurationChanged(e);
		return true;
	}
	onDecorationsChanged(e) {
		return true;
	}
	onFlushed(e) {
		return true;
	}
	onLineMappingChanged(e) {
		this._updateAnchorsViewPositions();
		return true;
	}
	onLinesChanged(e) {
		this._updateAnchorsViewPositions();
		return true;
	}
	onLinesDeleted(e) {
		this._updateAnchorsViewPositions();
		return true;
	}
	onLinesInserted(e) {
		this._updateAnchorsViewPositions();
		return true;
	}
	onScrollChanged(e) {
		return true;
	}
	onZonesChanged(e) {
		return true;
	}
	_updateAnchorsViewPositions() {
		const keys = Object.keys(this._widgets);
		for (const widgetId of keys) this._widgets[widgetId].updateAnchorViewPosition();
	}
	addWidget(_widget) {
		const myWidget = new Widget(this._context, this._viewDomNode, _widget);
		this._widgets[myWidget.id] = myWidget;
		if (myWidget.allowEditorOverflow) this.overflowingContentWidgetsDomNode.appendChild(myWidget.domNode);
		else this.domNode.appendChild(myWidget.domNode);
		this.setShouldRender();
	}
	setWidgetPosition(widget, primaryAnchor, secondaryAnchor, preference, affinity) {
		const myWidget = this._widgets[widget.getId()];
		myWidget.setPosition(primaryAnchor, secondaryAnchor, preference, affinity);
		if (!myWidget.useDisplayNone) this.setShouldRender();
	}
	removeWidget(widget) {
		const widgetId = widget.getId();
		if (this._widgets.hasOwnProperty(widgetId)) {
			const myWidget = this._widgets[widgetId];
			delete this._widgets[widgetId];
			const domNode = myWidget.domNode.domNode;
			domNode.remove();
			domNode.removeAttribute("monaco-visible-content-widget");
			this.setShouldRender();
		}
	}
	shouldSuppressMouseDownOnWidget(widgetId) {
		if (this._widgets.hasOwnProperty(widgetId)) return this._widgets[widgetId].suppressMouseDown;
		return false;
	}
	onBeforeRender(viewportData) {
		const keys = Object.keys(this._widgets);
		for (const widgetId of keys) this._widgets[widgetId].onBeforeRender(viewportData);
	}
	prepareRender(ctx) {
		const keys = Object.keys(this._widgets);
		for (const widgetId of keys) this._widgets[widgetId].prepareRender(ctx);
	}
	render(ctx) {
		const keys = Object.keys(this._widgets);
		for (const widgetId of keys) this._widgets[widgetId].render(ctx);
	}
};
var Widget = class {
	constructor(context, viewDomNode, actual) {
		this._primaryAnchor = new PositionPair(null, null);
		this._secondaryAnchor = new PositionPair(null, null);
		this._context = context;
		this._viewDomNode = viewDomNode;
		this._actual = actual;
		const options = this._context.configuration.options;
		const layoutInfo = options.get(166);
		const allowOverflow = options.get(4);
		this.domNode = createFastDomNode(this._actual.getDomNode());
		this.id = this._actual.getId();
		this.allowEditorOverflow = (this._actual.allowEditorOverflow || false) && allowOverflow;
		this.suppressMouseDown = this._actual.suppressMouseDown || false;
		this.useDisplayNone = this._actual.useDisplayNone || false;
		this._fixedOverflowWidgets = options.get(51);
		this._contentWidth = layoutInfo.contentWidth;
		this._contentLeft = layoutInfo.contentLeft;
		this._affinity = null;
		this._preference = [];
		this._cachedDomNodeOffsetWidth = -1;
		this._cachedDomNodeOffsetHeight = -1;
		this._maxWidth = this._getMaxWidth();
		this._isVisible = false;
		this._renderData = null;
		this.domNode.setPosition(this._fixedOverflowWidgets && this.allowEditorOverflow ? "fixed" : "absolute");
		this.domNode.setDisplay("none");
		this.domNode.setVisibility("hidden");
		this.domNode.setAttribute("widgetId", this.id);
		this.domNode.setMaxWidth(this._maxWidth);
	}
	onConfigurationChanged(e) {
		const options = this._context.configuration.options;
		if (e.hasChanged(166)) {
			const layoutInfo = options.get(166);
			this._contentLeft = layoutInfo.contentLeft;
			this._contentWidth = layoutInfo.contentWidth;
			this._maxWidth = this._getMaxWidth();
		}
	}
	updateAnchorViewPosition() {
		this._setPosition(this._affinity, this._primaryAnchor.modelPosition, this._secondaryAnchor.modelPosition);
	}
	_setPosition(affinity, primaryAnchor, secondaryAnchor) {
		this._affinity = affinity;
		this._primaryAnchor = getValidPositionPair(primaryAnchor, this._context.viewModel, this._affinity);
		this._secondaryAnchor = getValidPositionPair(secondaryAnchor, this._context.viewModel, this._affinity);
		function getValidPositionPair(position, viewModel, affinity) {
			if (!position) return new PositionPair(null, null);
			const validModelPosition = viewModel.model.validatePosition(position);
			if (viewModel.coordinatesConverter.modelPositionIsVisible(validModelPosition)) return new PositionPair(position, viewModel.coordinatesConverter.convertModelPositionToViewPosition(validModelPosition, affinity ?? void 0));
			return new PositionPair(position, null);
		}
	}
	_getMaxWidth() {
		const elDocument = this.domNode.domNode.ownerDocument;
		const elWindow = elDocument.defaultView;
		return this.allowEditorOverflow ? elWindow?.innerWidth || elDocument.documentElement.offsetWidth || elDocument.body.offsetWidth : this._contentWidth;
	}
	setPosition(primaryAnchor, secondaryAnchor, preference, affinity) {
		this._setPosition(affinity, primaryAnchor, secondaryAnchor);
		this._preference = preference;
		if (!this.useDisplayNone && this._primaryAnchor.viewPosition && this._preference && this._preference.length > 0) this.domNode.setDisplay("block");
		else this.domNode.setDisplay("none");
		this._cachedDomNodeOffsetWidth = -1;
		this._cachedDomNodeOffsetHeight = -1;
	}
	_layoutBoxInViewport(anchor, width, height, ctx) {
		const aboveLineTop = anchor.top;
		const heightAvailableAboveLine = aboveLineTop;
		const underLineTop = anchor.top + anchor.height;
		const heightAvailableUnderLine = ctx.viewportHeight - underLineTop;
		const aboveTop = aboveLineTop - height;
		const fitsAbove = heightAvailableAboveLine >= height;
		const belowTop = underLineTop;
		const fitsBelow = heightAvailableUnderLine >= height;
		let left = anchor.left;
		if (left + width > ctx.scrollLeft + ctx.viewportWidth) left = ctx.scrollLeft + ctx.viewportWidth - width;
		if (left < ctx.scrollLeft) left = ctx.scrollLeft;
		return {
			fitsAbove,
			aboveTop,
			fitsBelow,
			belowTop,
			left
		};
	}
	_layoutHorizontalSegmentInPage(windowSize, domNodePosition, left, width) {
		const LEFT_PADDING = 15;
		const RIGHT_PADDING = 15;
		const MIN_LIMIT = Math.max(LEFT_PADDING, domNodePosition.left - width);
		const MAX_LIMIT = Math.min(domNodePosition.left + domNodePosition.width + width, windowSize.width - RIGHT_PADDING);
		const elWindow = this._viewDomNode.domNode.ownerDocument.defaultView;
		let absoluteLeft = domNodePosition.left + left - (elWindow?.scrollX ?? 0);
		if (absoluteLeft + width > MAX_LIMIT) {
			const delta = absoluteLeft - (MAX_LIMIT - width);
			absoluteLeft -= delta;
			left -= delta;
		}
		if (absoluteLeft < MIN_LIMIT) {
			const delta = absoluteLeft - MIN_LIMIT;
			absoluteLeft -= delta;
			left -= delta;
		}
		return [left, absoluteLeft];
	}
	_layoutBoxInPage(anchor, width, height, ctx) {
		const aboveTop = anchor.top - height;
		const belowTop = anchor.top + anchor.height;
		const domNodePosition = getDomNodePagePosition(this._viewDomNode.domNode);
		const elDocument = this._viewDomNode.domNode.ownerDocument;
		const elWindow = elDocument.defaultView;
		const absoluteAboveTop = domNodePosition.top + aboveTop - (elWindow?.scrollY ?? 0);
		const absoluteBelowTop = domNodePosition.top + belowTop - (elWindow?.scrollY ?? 0);
		const windowSize = getClientArea(elDocument.body);
		const [left, absoluteAboveLeft] = this._layoutHorizontalSegmentInPage(windowSize, domNodePosition, anchor.left - ctx.scrollLeft + this._contentLeft, width);
		const TOP_PADDING = 22;
		const BOTTOM_PADDING = 22;
		const fitsAbove = absoluteAboveTop >= TOP_PADDING;
		const fitsBelow = absoluteBelowTop + height <= windowSize.height - BOTTOM_PADDING;
		if (this._fixedOverflowWidgets) return {
			fitsAbove,
			aboveTop: Math.max(absoluteAboveTop, TOP_PADDING),
			fitsBelow,
			belowTop: absoluteBelowTop,
			left: absoluteAboveLeft
		};
		return {
			fitsAbove,
			aboveTop,
			fitsBelow,
			belowTop,
			left
		};
	}
	_prepareRenderWidgetAtExactPositionOverflowing(topLeft) {
		return new Coordinate(topLeft.top, topLeft.left + this._contentLeft);
	}
	/**
	* Compute the coordinates above and below the primary and secondary anchors.
	* The content widget *must* touch the primary anchor.
	* The content widget should touch if possible the secondary anchor.
	*/
	_getAnchorsCoordinates(ctx) {
		return {
			primary: getCoordinates(this._primaryAnchor.viewPosition, this._affinity),
			secondary: getCoordinates(this._secondaryAnchor.viewPosition?.lineNumber === this._primaryAnchor.viewPosition?.lineNumber ? this._secondaryAnchor.viewPosition : null, this._affinity)
		};
		function getCoordinates(position, affinity) {
			if (!position) return null;
			const horizontalPosition = ctx.visibleRangeForPosition(position);
			if (!horizontalPosition) return null;
			const left = position.column === 1 && affinity === 3 ? 0 : horizontalPosition.left;
			return new AnchorCoordinate(ctx.getVerticalOffsetForLineNumber(position.lineNumber) - ctx.scrollTop, left, ctx.getLineHeightForLineNumber(position.lineNumber));
		}
	}
	_reduceAnchorCoordinates(primary, secondary, width) {
		if (!secondary) return primary;
		const fontInfo = this._context.configuration.options.get(59);
		let left = secondary.left;
		if (left < primary.left) left = Math.max(left, primary.left - width + fontInfo.typicalFullwidthCharacterWidth);
		else left = Math.min(left, primary.left + width - fontInfo.typicalFullwidthCharacterWidth);
		return new AnchorCoordinate(primary.top, left, primary.height);
	}
	_prepareRenderWidget(ctx) {
		if (!this._preference || this._preference.length === 0) return null;
		const { primary, secondary } = this._getAnchorsCoordinates(ctx);
		if (!primary) return {
			kind: "offViewport",
			preserveFocus: this.domNode.domNode.contains(this.domNode.domNode.ownerDocument.activeElement)
		};
		if (this._cachedDomNodeOffsetWidth === -1 || this._cachedDomNodeOffsetHeight === -1) {
			let preferredDimensions = null;
			if (typeof this._actual.beforeRender === "function") preferredDimensions = safeInvoke(this._actual.beforeRender, this._actual);
			if (preferredDimensions) {
				this._cachedDomNodeOffsetWidth = preferredDimensions.width;
				this._cachedDomNodeOffsetHeight = preferredDimensions.height;
			} else {
				const clientRect = this.domNode.domNode.getBoundingClientRect();
				this._cachedDomNodeOffsetWidth = Math.round(clientRect.width);
				this._cachedDomNodeOffsetHeight = Math.round(clientRect.height);
			}
		}
		const anchor = this._reduceAnchorCoordinates(primary, secondary, this._cachedDomNodeOffsetWidth);
		let placement;
		if (this.allowEditorOverflow) placement = this._layoutBoxInPage(anchor, this._cachedDomNodeOffsetWidth, this._cachedDomNodeOffsetHeight, ctx);
		else placement = this._layoutBoxInViewport(anchor, this._cachedDomNodeOffsetWidth, this._cachedDomNodeOffsetHeight, ctx);
		for (let pass = 1; pass <= 2; pass++) for (const pref of this._preference) if (pref === 1) {
			if (!placement) return null;
			if (pass === 2 || placement.fitsAbove) return {
				kind: "inViewport",
				coordinate: new Coordinate(placement.aboveTop, placement.left),
				position: 1
			};
		} else if (pref === 2) {
			if (!placement) return null;
			if (pass === 2 || placement.fitsBelow) return {
				kind: "inViewport",
				coordinate: new Coordinate(placement.belowTop, placement.left),
				position: 2
			};
		} else if (this.allowEditorOverflow) return {
			kind: "inViewport",
			coordinate: this._prepareRenderWidgetAtExactPositionOverflowing(new Coordinate(anchor.top, anchor.left)),
			position: 0
		};
		else return {
			kind: "inViewport",
			coordinate: new Coordinate(anchor.top, anchor.left),
			position: 0
		};
		return null;
	}
	/**
	* On this first pass, we ensure that the content widget (if it is in the viewport) has the max width set correctly.
	*/
	onBeforeRender(viewportData) {
		if (!this._primaryAnchor.viewPosition || !this._preference) return;
		if (this._primaryAnchor.viewPosition.lineNumber < viewportData.startLineNumber || this._primaryAnchor.viewPosition.lineNumber > viewportData.endLineNumber) return;
		this.domNode.setMaxWidth(this._maxWidth);
	}
	prepareRender(ctx) {
		this._renderData = this._prepareRenderWidget(ctx);
	}
	render(ctx) {
		if (!this._renderData || this._renderData.kind === "offViewport") {
			if (this._isVisible) {
				this.domNode.removeAttribute("monaco-visible-content-widget");
				this._isVisible = false;
				if (this._renderData?.kind === "offViewport" && this._renderData.preserveFocus) this.domNode.setTop(-1e3);
				else this.domNode.setVisibility("hidden");
			}
			if (typeof this._actual.afterRender === "function") safeInvoke(this._actual.afterRender, this._actual, null, null);
			return;
		}
		if (this.allowEditorOverflow) {
			this.domNode.setTop(this._renderData.coordinate.top);
			this.domNode.setLeft(this._renderData.coordinate.left);
		} else {
			this.domNode.setTop(this._renderData.coordinate.top + ctx.scrollTop - ctx.bigNumbersDelta);
			this.domNode.setLeft(this._renderData.coordinate.left);
		}
		if (!this._isVisible) {
			this.domNode.setVisibility("inherit");
			this.domNode.setAttribute("monaco-visible-content-widget", "true");
			this._isVisible = true;
		}
		if (typeof this._actual.afterRender === "function") safeInvoke(this._actual.afterRender, this._actual, this._renderData.position, this._renderData.coordinate);
	}
};
var PositionPair = class {
	constructor(modelPosition, viewPosition) {
		this.modelPosition = modelPosition;
		this.viewPosition = viewPosition;
	}
};
var Coordinate = class {
	constructor(top, left) {
		this.top = top;
		this.left = left;
		this._coordinateBrand = void 0;
	}
};
var AnchorCoordinate = class {
	constructor(top, left, height) {
		this.top = top;
		this.left = left;
		this.height = height;
		this._anchorCoordinateBrand = void 0;
	}
};
function safeInvoke(fn, thisArg, ...args) {
	try {
		return fn.call(thisArg, ...args);
	} catch {
		return null;
	}
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/view/dynamicViewOverlay.js
var DynamicViewOverlay = class extends ViewEventHandler {};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/theme/common/themeService.js
var IThemeService = createDecorator("themeService");
function themeColorFromId(id) {
	return { id };
}
function getThemeTypeSelector(type) {
	switch (type) {
		case ColorScheme.DARK: return ThemeTypeSelector.VS_DARK;
		case ColorScheme.HIGH_CONTRAST_DARK: return ThemeTypeSelector.HC_BLACK;
		case ColorScheme.HIGH_CONTRAST_LIGHT: return ThemeTypeSelector.HC_LIGHT;
		default: return ThemeTypeSelector.VS;
	}
}
var Extensions$2 = { ThemingContribution: "base.contributions.theming" };
var ThemingRegistry = class extends Disposable {
	constructor() {
		super();
		this.themingParticipants = [];
		this.themingParticipants = [];
		this.onThemingParticipantAddedEmitter = this._register(new Emitter$1());
	}
	onColorThemeChange(participant) {
		this.themingParticipants.push(participant);
		this.onThemingParticipantAddedEmitter.fire(participant);
		return toDisposable(() => {
			const idx = this.themingParticipants.indexOf(participant);
			this.themingParticipants.splice(idx, 1);
		});
	}
	getThemingParticipants() {
		return this.themingParticipants;
	}
};
var themingRegistry$1 = new ThemingRegistry();
Registry.add(Extensions$2.ThemingContribution, themingRegistry$1);
function registerThemingParticipant(participant) {
	return themingRegistry$1.onColorThemeChange(participant);
}
/**
* Utility base class for all themable components.
*/
var Themable = class extends Disposable {
	constructor(themeService) {
		super();
		this.themeService = themeService;
		this.theme = themeService.getColorTheme();
		this._register(this.themeService.onDidColorThemeChange((theme) => this.onThemeChange(theme)));
	}
	onThemeChange(theme) {
		this.theme = theme;
		this.updateStyles();
	}
	updateStyles() {}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/core/editorColorRegistry.js
/**
* Definition of the editor colors
*/
var editorLineHighlight = registerColor("editor.lineHighlightBackground", null, localize(651, "Background color for the highlight of line at the cursor position."));
var editorInactiveLineHighlight = registerColor("editor.inactiveLineHighlightBackground", editorLineHighlight, localize(652, "Background color for the highlight of line at the cursor position when the editor is not focused."));
var editorLineHighlightBorder = registerColor("editor.lineHighlightBorder", {
	dark: "#282828",
	light: "#eeeeee",
	hcDark: "#f38518",
	hcLight: contrastBorder
}, localize(653, "Background color for the border around the line at the cursor position."));
registerColor("editor.rangeHighlightBackground", {
	dark: "#ffffff0b",
	light: "#fdff0033",
	hcDark: null,
	hcLight: null
}, localize(654, "Background color of highlighted ranges, like by quick open and find features. The color must not be opaque so as not to hide underlying decorations."), true);
registerColor("editor.rangeHighlightBorder", {
	dark: null,
	light: null,
	hcDark: activeContrastBorder,
	hcLight: activeContrastBorder
}, localize(655, "Background color of the border around highlighted ranges."));
registerColor("editor.symbolHighlightBackground", {
	dark: editorFindMatchHighlight,
	light: editorFindMatchHighlight,
	hcDark: null,
	hcLight: null
}, localize(656, "Background color of highlighted symbol, like for go to definition or go next/previous symbol. The color must not be opaque so as not to hide underlying decorations."), true);
registerColor("editor.symbolHighlightBorder", {
	dark: null,
	light: null,
	hcDark: activeContrastBorder,
	hcLight: activeContrastBorder
}, localize(657, "Background color of the border around highlighted symbols."));
var editorCursorForeground = registerColor("editorCursor.foreground", {
	dark: "#AEAFAD",
	light: Color.black,
	hcDark: Color.white,
	hcLight: "#0F4A85"
}, localize(658, "Color of the editor cursor."));
var editorCursorBackground = registerColor("editorCursor.background", null, localize(659, "The background color of the editor cursor. Allows customizing the color of a character overlapped by a block cursor."));
var editorMultiCursorPrimaryForeground = registerColor("editorMultiCursor.primary.foreground", editorCursorForeground, localize(660, "Color of the primary editor cursor when multiple cursors are present."));
var editorMultiCursorPrimaryBackground = registerColor("editorMultiCursor.primary.background", editorCursorBackground, localize(661, "The background color of the primary editor cursor when multiple cursors are present. Allows customizing the color of a character overlapped by a block cursor."));
var editorMultiCursorSecondaryForeground = registerColor("editorMultiCursor.secondary.foreground", editorCursorForeground, localize(662, "Color of secondary editor cursors when multiple cursors are present."));
var editorMultiCursorSecondaryBackground = registerColor("editorMultiCursor.secondary.background", editorCursorBackground, localize(663, "The background color of secondary editor cursors when multiple cursors are present. Allows customizing the color of a character overlapped by a block cursor."));
var editorWhitespaces = registerColor("editorWhitespace.foreground", {
	dark: "#e3e4e229",
	light: "#33333333",
	hcDark: "#e3e4e229",
	hcLight: "#CCCCCC"
}, localize(664, "Color of whitespace characters in the editor."));
registerColor("editorWordWrapIndicator.foreground", editorWhitespaces, localize(665, "Color of the indicator shown at the end of a soft wrapped line in the editor."));
var editorLineNumbers = registerColor("editorLineNumber.foreground", {
	dark: "#858585",
	light: "#237893",
	hcDark: Color.white,
	hcLight: "#292929"
}, localize(666, "Color of editor line numbers."));
var deprecatedEditorIndentGuides = registerColor("editorIndentGuide.background", editorWhitespaces, localize(667, "Color of the editor indentation guides."), false, localize(668, "'editorIndentGuide.background' is deprecated. Use 'editorIndentGuide.background1' instead."));
var deprecatedEditorActiveIndentGuides = registerColor("editorIndentGuide.activeBackground", editorWhitespaces, localize(669, "Color of the active editor indentation guides."), false, localize(670, "'editorIndentGuide.activeBackground' is deprecated. Use 'editorIndentGuide.activeBackground1' instead."));
var editorIndentGuide1 = registerColor("editorIndentGuide.background1", deprecatedEditorIndentGuides, localize(671, "Color of the editor indentation guides (1)."));
var editorIndentGuide2 = registerColor("editorIndentGuide.background2", "#00000000", localize(672, "Color of the editor indentation guides (2)."));
var editorIndentGuide3 = registerColor("editorIndentGuide.background3", "#00000000", localize(673, "Color of the editor indentation guides (3)."));
var editorIndentGuide4 = registerColor("editorIndentGuide.background4", "#00000000", localize(674, "Color of the editor indentation guides (4)."));
var editorIndentGuide5 = registerColor("editorIndentGuide.background5", "#00000000", localize(675, "Color of the editor indentation guides (5)."));
var editorIndentGuide6 = registerColor("editorIndentGuide.background6", "#00000000", localize(676, "Color of the editor indentation guides (6)."));
var editorActiveIndentGuide1 = registerColor("editorIndentGuide.activeBackground1", deprecatedEditorActiveIndentGuides, localize(677, "Color of the active editor indentation guides (1)."));
var editorActiveIndentGuide2 = registerColor("editorIndentGuide.activeBackground2", "#00000000", localize(678, "Color of the active editor indentation guides (2)."));
var editorActiveIndentGuide3 = registerColor("editorIndentGuide.activeBackground3", "#00000000", localize(679, "Color of the active editor indentation guides (3)."));
var editorActiveIndentGuide4 = registerColor("editorIndentGuide.activeBackground4", "#00000000", localize(680, "Color of the active editor indentation guides (4)."));
var editorActiveIndentGuide5 = registerColor("editorIndentGuide.activeBackground5", "#00000000", localize(681, "Color of the active editor indentation guides (5)."));
var editorActiveIndentGuide6 = registerColor("editorIndentGuide.activeBackground6", "#00000000", localize(682, "Color of the active editor indentation guides (6)."));
registerColor("editorLineNumber.activeForeground", registerColor("editorActiveLineNumber.foreground", {
	dark: "#c6c6c6",
	light: "#0B216F",
	hcDark: activeContrastBorder,
	hcLight: activeContrastBorder
}, localize(683, "Color of editor active line number"), false, localize(684, "Id is deprecated. Use 'editorLineNumber.activeForeground' instead.")), localize(685, "Color of editor active line number"));
var editorDimmedLineNumber = registerColor("editorLineNumber.dimmedForeground", null, localize(686, "Color of the final editor line when editor.renderFinalNewline is set to dimmed."));
var editorRuler = registerColor("editorRuler.foreground", {
	dark: "#5A5A5A",
	light: Color.lightgrey,
	hcDark: Color.white,
	hcLight: "#292929"
}, localize(687, "Color of the editor rulers."));
registerColor("editorCodeLens.foreground", {
	dark: "#999999",
	light: "#919191",
	hcDark: "#999999",
	hcLight: "#292929"
}, localize(688, "Foreground color of editor CodeLens"));
registerColor("editorBracketMatch.background", {
	dark: "#0064001a",
	light: "#0064001a",
	hcDark: "#0064001a",
	hcLight: "#0000"
}, localize(689, "Background color behind matching brackets"));
registerColor("editorBracketMatch.border", {
	dark: "#888",
	light: "#B9B9B9",
	hcDark: contrastBorder,
	hcLight: contrastBorder
}, localize(690, "Color for matching brackets boxes"));
var editorBracketMatchForeground = registerColor("editorBracketMatch.foreground", null, localize(691, "Foreground color for matching brackets"));
var editorOverviewRulerBorder = registerColor("editorOverviewRuler.border", {
	dark: "#7f7f7f4d",
	light: "#7f7f7f4d",
	hcDark: "#7f7f7f4d",
	hcLight: "#666666"
}, localize(692, "Color of the overview ruler border."));
var editorOverviewRulerBackground = registerColor("editorOverviewRuler.background", null, localize(693, "Background color of the editor overview ruler."));
registerColor("editorGutter.background", editorBackground, localize(694, "Background color of the editor gutter. The gutter contains the glyph margins and the line numbers."));
registerColor("editorUnnecessaryCode.border", {
	dark: null,
	light: null,
	hcDark: Color.fromHex("#fff").transparent(.8),
	hcLight: contrastBorder
}, localize(695, "Border color of unnecessary (unused) source code in the editor."));
var editorUnnecessaryCodeOpacity = registerColor("editorUnnecessaryCode.opacity", {
	dark: Color.fromHex("#000a"),
	light: Color.fromHex("#0007"),
	hcDark: null,
	hcLight: null
}, localize(696, "Opacity of unnecessary (unused) source code in the editor. For example, \"#000000c0\" will render the code with 75% opacity. For high contrast themes, use the  'editorUnnecessaryCode.border' theme color to underline unnecessary code instead of fading it out."));
registerColor("editorGhostText.border", {
	dark: null,
	light: null,
	hcDark: Color.fromHex("#fff").transparent(.8),
	hcLight: Color.fromHex("#292929").transparent(.8)
}, localize(697, "Border color of ghost text in the editor."));
var ghostTextForeground = registerColor("editorGhostText.foreground", {
	dark: Color.fromHex("#ffffff56"),
	light: Color.fromHex("#0007"),
	hcDark: null,
	hcLight: null
}, localize(698, "Foreground color of the ghost text in the editor."));
registerColor("editorGhostText.background", null, localize(699, "Background color of the ghost text in the editor."));
var overviewRulerRangeHighlight = registerColor("editorOverviewRuler.rangeHighlightForeground", new Color(new RGBA(0, 122, 204, .6)), localize(700, "Overview ruler marker color for range highlights. The color must not be opaque so as not to hide underlying decorations."), true);
var overviewRulerError = registerColor("editorOverviewRuler.errorForeground", {
	dark: new Color(new RGBA(255, 18, 18, .7)),
	light: new Color(new RGBA(255, 18, 18, .7)),
	hcDark: new Color(new RGBA(255, 50, 50, 1)),
	hcLight: "#B5200D"
}, localize(701, "Overview ruler marker color for errors."));
var overviewRulerWarning = registerColor("editorOverviewRuler.warningForeground", {
	dark: editorWarningForeground,
	light: editorWarningForeground,
	hcDark: editorWarningBorder,
	hcLight: editorWarningBorder
}, localize(702, "Overview ruler marker color for warnings."));
var overviewRulerInfo = registerColor("editorOverviewRuler.infoForeground", {
	dark: editorInfoForeground,
	light: editorInfoForeground,
	hcDark: editorInfoBorder,
	hcLight: editorInfoBorder
}, localize(703, "Overview ruler marker color for infos."));
var editorBracketHighlightingForeground1 = registerColor("editorBracketHighlight.foreground1", {
	dark: "#FFD700",
	light: "#0431FAFF",
	hcDark: "#FFD700",
	hcLight: "#0431FAFF"
}, localize(704, "Foreground color of brackets (1). Requires enabling bracket pair colorization."));
var editorBracketHighlightingForeground2 = registerColor("editorBracketHighlight.foreground2", {
	dark: "#DA70D6",
	light: "#319331FF",
	hcDark: "#DA70D6",
	hcLight: "#319331FF"
}, localize(705, "Foreground color of brackets (2). Requires enabling bracket pair colorization."));
var editorBracketHighlightingForeground3 = registerColor("editorBracketHighlight.foreground3", {
	dark: "#179FFF",
	light: "#7B3814FF",
	hcDark: "#87CEFA",
	hcLight: "#7B3814FF"
}, localize(706, "Foreground color of brackets (3). Requires enabling bracket pair colorization."));
var editorBracketHighlightingForeground4 = registerColor("editorBracketHighlight.foreground4", "#00000000", localize(707, "Foreground color of brackets (4). Requires enabling bracket pair colorization."));
var editorBracketHighlightingForeground5 = registerColor("editorBracketHighlight.foreground5", "#00000000", localize(708, "Foreground color of brackets (5). Requires enabling bracket pair colorization."));
var editorBracketHighlightingForeground6 = registerColor("editorBracketHighlight.foreground6", "#00000000", localize(709, "Foreground color of brackets (6). Requires enabling bracket pair colorization."));
var editorBracketHighlightingUnexpectedBracketForeground = registerColor("editorBracketHighlight.unexpectedBracket.foreground", {
	dark: new Color(new RGBA(255, 18, 18, .8)),
	light: new Color(new RGBA(255, 18, 18, .8)),
	hcDark: new Color(new RGBA(255, 50, 50, 1)),
	hcLight: "#B5200D"
}, localize(710, "Foreground color of unexpected brackets."));
var editorBracketPairGuideBackground1 = registerColor("editorBracketPairGuide.background1", "#00000000", localize(711, "Background color of inactive bracket pair guides (1). Requires enabling bracket pair guides."));
var editorBracketPairGuideBackground2 = registerColor("editorBracketPairGuide.background2", "#00000000", localize(712, "Background color of inactive bracket pair guides (2). Requires enabling bracket pair guides."));
var editorBracketPairGuideBackground3 = registerColor("editorBracketPairGuide.background3", "#00000000", localize(713, "Background color of inactive bracket pair guides (3). Requires enabling bracket pair guides."));
var editorBracketPairGuideBackground4 = registerColor("editorBracketPairGuide.background4", "#00000000", localize(714, "Background color of inactive bracket pair guides (4). Requires enabling bracket pair guides."));
var editorBracketPairGuideBackground5 = registerColor("editorBracketPairGuide.background5", "#00000000", localize(715, "Background color of inactive bracket pair guides (5). Requires enabling bracket pair guides."));
var editorBracketPairGuideBackground6 = registerColor("editorBracketPairGuide.background6", "#00000000", localize(716, "Background color of inactive bracket pair guides (6). Requires enabling bracket pair guides."));
var editorBracketPairGuideActiveBackground1 = registerColor("editorBracketPairGuide.activeBackground1", "#00000000", localize(717, "Background color of active bracket pair guides (1). Requires enabling bracket pair guides."));
var editorBracketPairGuideActiveBackground2 = registerColor("editorBracketPairGuide.activeBackground2", "#00000000", localize(718, "Background color of active bracket pair guides (2). Requires enabling bracket pair guides."));
var editorBracketPairGuideActiveBackground3 = registerColor("editorBracketPairGuide.activeBackground3", "#00000000", localize(719, "Background color of active bracket pair guides (3). Requires enabling bracket pair guides."));
var editorBracketPairGuideActiveBackground4 = registerColor("editorBracketPairGuide.activeBackground4", "#00000000", localize(720, "Background color of active bracket pair guides (4). Requires enabling bracket pair guides."));
var editorBracketPairGuideActiveBackground5 = registerColor("editorBracketPairGuide.activeBackground5", "#00000000", localize(721, "Background color of active bracket pair guides (5). Requires enabling bracket pair guides."));
var editorBracketPairGuideActiveBackground6 = registerColor("editorBracketPairGuide.activeBackground6", "#00000000", localize(722, "Background color of active bracket pair guides (6). Requires enabling bracket pair guides."));
registerColor("editorUnicodeHighlight.border", editorWarningForeground, localize(723, "Border color used to highlight unicode characters."));
registerColor("editorUnicodeHighlight.background", editorWarningBackground, localize(724, "Background color used to highlight unicode characters."));
registerThemingParticipant((theme, collector) => {
	const background = theme.getColor(editorBackground);
	const lineHighlight = theme.getColor(editorLineHighlight);
	const imeBackground = lineHighlight && !lineHighlight.isTransparent() ? lineHighlight : background;
	if (imeBackground) collector.addRule(`.monaco-editor .inputarea.ime-input { background-color: ${imeBackground}; }`);
});
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/currentLineHighlight/currentLineHighlight.js
var AbstractLineHighlightOverlay = class extends DynamicViewOverlay {
	constructor(context) {
		super();
		this._context = context;
		const options = this._context.configuration.options;
		const layoutInfo = options.get(166);
		this._renderLineHighlight = options.get(110);
		this._renderLineHighlightOnlyWhenFocus = options.get(111);
		this._wordWrap = layoutInfo.isViewportWrapping;
		this._contentLeft = layoutInfo.contentLeft;
		this._contentWidth = layoutInfo.contentWidth;
		this._selectionIsEmpty = true;
		this._focused = false;
		this._cursorLineNumbers = [1];
		this._selections = [new Selection$1(1, 1, 1, 1)];
		this._renderData = null;
		this._context.addEventHandler(this);
	}
	dispose() {
		this._context.removeEventHandler(this);
		super.dispose();
	}
	_readFromSelections() {
		let hasChanged = false;
		const lineNumbers = /* @__PURE__ */ new Set();
		for (const selection of this._selections) lineNumbers.add(selection.positionLineNumber);
		const cursorsLineNumbers = Array.from(lineNumbers);
		cursorsLineNumbers.sort((a, b) => a - b);
		if (!equals$1(this._cursorLineNumbers, cursorsLineNumbers)) {
			this._cursorLineNumbers = cursorsLineNumbers;
			hasChanged = true;
		}
		const selectionIsEmpty = this._selections.every((s) => s.isEmpty());
		if (this._selectionIsEmpty !== selectionIsEmpty) {
			this._selectionIsEmpty = selectionIsEmpty;
			hasChanged = true;
		}
		return hasChanged;
	}
	onThemeChanged(e) {
		return this._readFromSelections();
	}
	onConfigurationChanged(e) {
		const options = this._context.configuration.options;
		const layoutInfo = options.get(166);
		this._renderLineHighlight = options.get(110);
		this._renderLineHighlightOnlyWhenFocus = options.get(111);
		this._wordWrap = layoutInfo.isViewportWrapping;
		this._contentLeft = layoutInfo.contentLeft;
		this._contentWidth = layoutInfo.contentWidth;
		return true;
	}
	onCursorStateChanged(e) {
		this._selections = e.selections;
		return this._readFromSelections();
	}
	onFlushed(e) {
		return true;
	}
	onLinesDeleted(e) {
		return true;
	}
	onLinesInserted(e) {
		return true;
	}
	onScrollChanged(e) {
		return e.scrollWidthChanged || e.scrollTopChanged;
	}
	onZonesChanged(e) {
		return true;
	}
	onFocusChanged(e) {
		if (!this._renderLineHighlightOnlyWhenFocus) return false;
		this._focused = e.isFocused;
		return true;
	}
	prepareRender(ctx) {
		if (!this._shouldRenderThis()) {
			this._renderData = null;
			return;
		}
		const visibleStartLineNumber = ctx.visibleRange.startLineNumber;
		const visibleEndLineNumber = ctx.visibleRange.endLineNumber;
		const renderData = [];
		for (let lineNumber = visibleStartLineNumber; lineNumber <= visibleEndLineNumber; lineNumber++) {
			const lineIndex = lineNumber - visibleStartLineNumber;
			renderData[lineIndex] = "";
		}
		if (this._wordWrap) {
			const renderedLineWrapped = this._renderOne(ctx, false);
			for (const cursorLineNumber of this._cursorLineNumbers) {
				const coordinatesConverter = this._context.viewModel.coordinatesConverter;
				const modelLineNumber = coordinatesConverter.convertViewPositionToModelPosition(new Position$1(cursorLineNumber, 1)).lineNumber;
				const firstViewLineNumber = coordinatesConverter.convertModelPositionToViewPosition(new Position$1(modelLineNumber, 1)).lineNumber;
				const lastViewLineNumber = coordinatesConverter.convertModelPositionToViewPosition(new Position$1(modelLineNumber, this._context.viewModel.model.getLineMaxColumn(modelLineNumber))).lineNumber;
				const firstLine = Math.max(firstViewLineNumber, visibleStartLineNumber);
				const lastLine = Math.min(lastViewLineNumber, visibleEndLineNumber);
				for (let lineNumber = firstLine; lineNumber <= lastLine; lineNumber++) {
					const lineIndex = lineNumber - visibleStartLineNumber;
					renderData[lineIndex] = renderedLineWrapped;
				}
			}
		}
		const renderedLineExact = this._renderOne(ctx, true);
		for (const cursorLineNumber of this._cursorLineNumbers) {
			if (cursorLineNumber < visibleStartLineNumber || cursorLineNumber > visibleEndLineNumber) continue;
			const lineIndex = cursorLineNumber - visibleStartLineNumber;
			renderData[lineIndex] = renderedLineExact;
		}
		this._renderData = renderData;
	}
	render(startLineNumber, lineNumber) {
		if (!this._renderData) return "";
		const lineIndex = lineNumber - startLineNumber;
		if (lineIndex >= this._renderData.length) return "";
		return this._renderData[lineIndex];
	}
	_shouldRenderInMargin() {
		return (this._renderLineHighlight === "gutter" || this._renderLineHighlight === "all") && (!this._renderLineHighlightOnlyWhenFocus || this._focused);
	}
	_shouldRenderInContent() {
		return (this._renderLineHighlight === "line" || this._renderLineHighlight === "all") && this._selectionIsEmpty && (!this._renderLineHighlightOnlyWhenFocus || this._focused);
	}
};
/**
* Emphasizes the current line by drawing a border around it.
*/
var CurrentLineHighlightOverlay = class extends AbstractLineHighlightOverlay {
	_renderOne(ctx, exact) {
		return `<div class="${"current-line" + (this._shouldRenderInMargin() ? " current-line-both" : "") + (exact ? " current-line-exact" : "")}" style="width:${Math.max(ctx.scrollWidth, this._contentWidth)}px;"></div>`;
	}
	_shouldRenderThis() {
		return this._shouldRenderInContent();
	}
	_shouldRenderOther() {
		return this._shouldRenderInMargin();
	}
};
/**
* Emphasizes the current line margin/gutter by drawing a border around it.
*/
var CurrentLineMarginHighlightOverlay = class extends AbstractLineHighlightOverlay {
	_renderOne(ctx, exact) {
		return `<div class="${"current-line" + (this._shouldRenderInMargin() ? " current-line-margin" : "") + (this._shouldRenderOther() ? " current-line-margin-both" : "") + (this._shouldRenderInMargin() && exact ? " current-line-exact-margin" : "")}" style="width:${this._contentLeft}px"></div>`;
	}
	_shouldRenderThis() {
		return true;
	}
	_shouldRenderOther() {
		return this._shouldRenderInContent();
	}
};
registerThemingParticipant((theme, collector) => {
	const lineHighlight = theme.getColor(editorLineHighlight);
	const inactiveLineHighlight = theme.getColor(editorInactiveLineHighlight);
	if (lineHighlight) {
		collector.addRule(`.monaco-editor.focused .view-overlays .current-line { background-color: ${lineHighlight}; }`);
		collector.addRule(`.monaco-editor.focused .margin-view-overlays .current-line-margin { background-color: ${lineHighlight}; border: none; }`);
	}
	if (inactiveLineHighlight) {
		collector.addRule(`.monaco-editor .view-overlays .current-line { background-color: ${inactiveLineHighlight}; }`);
		collector.addRule(`.monaco-editor .margin-view-overlays .current-line-margin { background-color: ${inactiveLineHighlight}; border: none; }`);
	}
	if (!lineHighlight || lineHighlight.isTransparent() || theme.defines(editorLineHighlightBorder)) {
		const lineHighlightBorder = theme.getColor(editorLineHighlightBorder);
		if (lineHighlightBorder) {
			collector.addRule(`.monaco-editor .view-overlays .current-line-exact { border: 2px solid ${lineHighlightBorder}; }`);
			collector.addRule(`.monaco-editor .margin-view-overlays .current-line-exact-margin { border: 2px solid ${lineHighlightBorder}; }`);
			if (isHighContrast(theme.type)) {
				collector.addRule(`.monaco-editor .view-overlays .current-line-exact { border-width: 1px; }`);
				collector.addRule(`.monaco-editor .margin-view-overlays .current-line-exact-margin { border-width: 1px; }`);
			}
		}
	}
});
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/decorations/decorations.js
var DecorationsOverlay = class extends DynamicViewOverlay {
	constructor(context) {
		super();
		this._context = context;
		const options = this._context.configuration.options;
		this._typicalHalfwidthCharacterWidth = options.get(59).typicalHalfwidthCharacterWidth;
		this._renderResult = null;
		this._context.addEventHandler(this);
	}
	dispose() {
		this._context.removeEventHandler(this);
		this._renderResult = null;
		super.dispose();
	}
	onConfigurationChanged(e) {
		const options = this._context.configuration.options;
		this._typicalHalfwidthCharacterWidth = options.get(59).typicalHalfwidthCharacterWidth;
		return true;
	}
	onDecorationsChanged(e) {
		return true;
	}
	onFlushed(e) {
		return true;
	}
	onLinesChanged(e) {
		return true;
	}
	onLinesDeleted(e) {
		return true;
	}
	onLinesInserted(e) {
		return true;
	}
	onScrollChanged(e) {
		return e.scrollTopChanged || e.scrollWidthChanged;
	}
	onZonesChanged(e) {
		return true;
	}
	prepareRender(ctx) {
		const _decorations = ctx.getDecorationsInViewport();
		let decorations = [];
		let decorationsLen = 0;
		for (let i = 0, len = _decorations.length; i < len; i++) {
			const d = _decorations[i];
			if (d.options.className) decorations[decorationsLen++] = d;
		}
		decorations = decorations.sort((a, b) => {
			if (a.options.zIndex < b.options.zIndex) return -1;
			if (a.options.zIndex > b.options.zIndex) return 1;
			const aClassName = a.options.className;
			const bClassName = b.options.className;
			if (aClassName < bClassName) return -1;
			if (aClassName > bClassName) return 1;
			return Range$2.compareRangesUsingStarts(a.range, b.range);
		});
		const visibleStartLineNumber = ctx.visibleRange.startLineNumber;
		const visibleEndLineNumber = ctx.visibleRange.endLineNumber;
		const output = [];
		for (let lineNumber = visibleStartLineNumber; lineNumber <= visibleEndLineNumber; lineNumber++) {
			const lineIndex = lineNumber - visibleStartLineNumber;
			output[lineIndex] = "";
		}
		this._renderWholeLineDecorations(ctx, decorations, output);
		this._renderNormalDecorations(ctx, decorations, output);
		this._renderResult = output;
	}
	_renderWholeLineDecorations(ctx, decorations, output) {
		const visibleStartLineNumber = ctx.visibleRange.startLineNumber;
		const visibleEndLineNumber = ctx.visibleRange.endLineNumber;
		for (let i = 0, lenI = decorations.length; i < lenI; i++) {
			const d = decorations[i];
			if (!d.options.isWholeLine) continue;
			const decorationOutput = "<div class=\"cdr " + d.options.className + "\" style=\"left:0;width:100%;\"></div>";
			const startLineNumber = Math.max(d.range.startLineNumber, visibleStartLineNumber);
			const endLineNumber = Math.min(d.range.endLineNumber, visibleEndLineNumber);
			for (let j = startLineNumber; j <= endLineNumber; j++) {
				const lineIndex = j - visibleStartLineNumber;
				output[lineIndex] += decorationOutput;
			}
		}
	}
	_renderNormalDecorations(ctx, decorations, output) {
		const visibleStartLineNumber = ctx.visibleRange.startLineNumber;
		let prevClassName = null;
		let prevShowIfCollapsed = false;
		let prevRange = null;
		let prevShouldFillLineOnLineBreak = false;
		for (let i = 0, lenI = decorations.length; i < lenI; i++) {
			const d = decorations[i];
			if (d.options.isWholeLine) continue;
			const className = d.options.className;
			const showIfCollapsed = Boolean(d.options.showIfCollapsed);
			let range = d.range;
			if (showIfCollapsed && range.endColumn === 1 && range.endLineNumber !== range.startLineNumber) range = new Range$2(range.startLineNumber, range.startColumn, range.endLineNumber - 1, this._context.viewModel.getLineMaxColumn(range.endLineNumber - 1));
			if (prevClassName === className && prevShowIfCollapsed === showIfCollapsed && Range$2.areIntersectingOrTouching(prevRange, range)) {
				prevRange = Range$2.plusRange(prevRange, range);
				continue;
			}
			if (prevClassName !== null) this._renderNormalDecoration(ctx, prevRange, prevClassName, prevShouldFillLineOnLineBreak, prevShowIfCollapsed, visibleStartLineNumber, output);
			prevClassName = className;
			prevShowIfCollapsed = showIfCollapsed;
			prevRange = range;
			prevShouldFillLineOnLineBreak = d.options.shouldFillLineOnLineBreak ?? false;
		}
		if (prevClassName !== null) this._renderNormalDecoration(ctx, prevRange, prevClassName, prevShouldFillLineOnLineBreak, prevShowIfCollapsed, visibleStartLineNumber, output);
	}
	_renderNormalDecoration(ctx, range, className, shouldFillLineOnLineBreak, showIfCollapsed, visibleStartLineNumber, output) {
		const linesVisibleRanges = ctx.linesVisibleRangesForRange(range, className === "findMatch");
		if (!linesVisibleRanges) return;
		for (let j = 0, lenJ = linesVisibleRanges.length; j < lenJ; j++) {
			const lineVisibleRanges = linesVisibleRanges[j];
			if (lineVisibleRanges.outsideRenderedLine) continue;
			const lineIndex = lineVisibleRanges.lineNumber - visibleStartLineNumber;
			if (showIfCollapsed && lineVisibleRanges.ranges.length === 1) {
				const singleVisibleRange = lineVisibleRanges.ranges[0];
				if (singleVisibleRange.width < this._typicalHalfwidthCharacterWidth) {
					const center = Math.round(singleVisibleRange.left + singleVisibleRange.width / 2);
					const left = Math.max(0, Math.round(center - this._typicalHalfwidthCharacterWidth / 2));
					lineVisibleRanges.ranges[0] = new HorizontalRange(left, this._typicalHalfwidthCharacterWidth);
				}
			}
			for (let k = 0, lenK = lineVisibleRanges.ranges.length; k < lenK; k++) {
				const expandToLeft = shouldFillLineOnLineBreak && lineVisibleRanges.continuesOnNextLine && lenK === 1;
				const visibleRange = lineVisibleRanges.ranges[k];
				const decorationOutput = "<div class=\"cdr " + className + "\" style=\"left:" + String(visibleRange.left) + "px;width:" + (expandToLeft ? "100%;" : String(visibleRange.width) + "px;") + "\"></div>";
				output[lineIndex] += decorationOutput;
			}
		}
	}
	render(startLineNumber, lineNumber) {
		if (!this._renderResult) return "";
		const lineIndex = lineNumber - startLineNumber;
		if (lineIndex < 0 || lineIndex >= this._renderResult.length) return "";
		return this._renderResult[lineIndex];
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/editorScrollbar/editorScrollbar.js
/**
* The editor scrollbar built on VS Code's scrollable element that sits beside
* the minimap.
*/
var EditorScrollbar = class extends ViewPart {
	constructor(context, linesContent, viewDomNode, overflowGuardDomNode) {
		super(context);
		const options = this._context.configuration.options;
		const scrollbar = options.get(117);
		const mouseWheelScrollSensitivity = options.get(83);
		const fastScrollSensitivity = options.get(49);
		const scrollPredominantAxis = options.get(120);
		const inertialScroll = options.get(158);
		const scrollbarOptions = {
			listenOnDomNode: viewDomNode.domNode,
			className: "editor-scrollable " + getThemeTypeSelector(context.theme.type),
			useShadows: false,
			lazyRender: true,
			vertical: scrollbar.vertical,
			horizontal: scrollbar.horizontal,
			verticalHasArrows: scrollbar.verticalHasArrows,
			horizontalHasArrows: scrollbar.horizontalHasArrows,
			verticalScrollbarSize: scrollbar.verticalScrollbarSize,
			verticalSliderSize: scrollbar.verticalSliderSize,
			horizontalScrollbarSize: scrollbar.horizontalScrollbarSize,
			horizontalSliderSize: scrollbar.horizontalSliderSize,
			handleMouseWheel: scrollbar.handleMouseWheel,
			alwaysConsumeMouseWheel: scrollbar.alwaysConsumeMouseWheel,
			arrowSize: scrollbar.arrowSize,
			mouseWheelScrollSensitivity,
			fastScrollSensitivity,
			scrollPredominantAxis,
			scrollByPage: scrollbar.scrollByPage,
			inertialScroll
		};
		this.scrollbar = this._register(new SmoothScrollableElement(linesContent.domNode, scrollbarOptions, this._context.viewLayout.getScrollable()));
		PartFingerprints.write(this.scrollbar.getDomNode(), 6);
		this.scrollbarDomNode = createFastDomNode(this.scrollbar.getDomNode());
		this.scrollbarDomNode.setPosition("absolute");
		this._setLayout();
		const onBrowserDesperateReveal = (domNode, lookAtScrollTop, lookAtScrollLeft) => {
			const newScrollPosition = {};
			{
				const deltaTop = domNode.scrollTop;
				if (deltaTop) {
					newScrollPosition.scrollTop = this._context.viewLayout.getCurrentScrollTop() + deltaTop;
					domNode.scrollTop = 0;
				}
			}
			if (lookAtScrollLeft) {
				const deltaLeft = domNode.scrollLeft;
				if (deltaLeft) {
					newScrollPosition.scrollLeft = this._context.viewLayout.getCurrentScrollLeft() + deltaLeft;
					domNode.scrollLeft = 0;
				}
			}
			this._context.viewModel.viewLayout.setScrollPosition(newScrollPosition, 1);
		};
		this._register(addDisposableListener(viewDomNode.domNode, "scroll", (e) => onBrowserDesperateReveal(viewDomNode.domNode, true, true)));
		this._register(addDisposableListener(linesContent.domNode, "scroll", (e) => onBrowserDesperateReveal(linesContent.domNode, true, false)));
		this._register(addDisposableListener(overflowGuardDomNode.domNode, "scroll", (e) => onBrowserDesperateReveal(overflowGuardDomNode.domNode, true, false)));
		this._register(addDisposableListener(this.scrollbarDomNode.domNode, "scroll", (e) => onBrowserDesperateReveal(this.scrollbarDomNode.domNode, true, false)));
	}
	_setLayout() {
		const options = this._context.configuration.options;
		const layoutInfo = options.get(166);
		this.scrollbarDomNode.setLeft(layoutInfo.contentLeft);
		if (options.get(81).side === "right") this.scrollbarDomNode.setWidth(layoutInfo.contentWidth + layoutInfo.minimap.minimapWidth);
		else this.scrollbarDomNode.setWidth(layoutInfo.contentWidth);
		this.scrollbarDomNode.setHeight(layoutInfo.height);
	}
	getOverviewRulerLayoutInfo() {
		return this.scrollbar.getOverviewRulerLayoutInfo();
	}
	getDomNode() {
		return this.scrollbarDomNode;
	}
	delegateVerticalScrollbarPointerDown(browserEvent) {
		this.scrollbar.delegateVerticalScrollbarPointerDown(browserEvent);
	}
	delegateScrollFromMouseWheelEvent(browserEvent) {
		this.scrollbar.delegateScrollFromMouseWheelEvent(browserEvent);
	}
	onConfigurationChanged(e) {
		if (e.hasChanged(117) || e.hasChanged(83) || e.hasChanged(49)) {
			const options = this._context.configuration.options;
			const scrollbar = options.get(117);
			const mouseWheelScrollSensitivity = options.get(83);
			const fastScrollSensitivity = options.get(49);
			const scrollPredominantAxis = options.get(120);
			const newOpts = {
				vertical: scrollbar.vertical,
				horizontal: scrollbar.horizontal,
				verticalScrollbarSize: scrollbar.verticalScrollbarSize,
				horizontalScrollbarSize: scrollbar.horizontalScrollbarSize,
				scrollByPage: scrollbar.scrollByPage,
				handleMouseWheel: scrollbar.handleMouseWheel,
				mouseWheelScrollSensitivity,
				fastScrollSensitivity,
				scrollPredominantAxis
			};
			this.scrollbar.updateOptions(newOpts);
		}
		if (e.hasChanged(166)) this._setLayout();
		return true;
	}
	onScrollChanged(e) {
		return true;
	}
	onThemeChanged(e) {
		this.scrollbar.updateClassName("editor-scrollable " + getThemeTypeSelector(this._context.theme.type));
		return true;
	}
	prepareRender(ctx) {}
	render(ctx) {
		this.scrollbar.renderNow();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/glyphMargin/glyphMargin.js
/**
* Represents a decoration that should be shown along the lines from `startLineNumber` to `endLineNumber`.
* This can end up producing multiple `LineDecorationToRender`.
*/
var DecorationToRender = class {
	constructor(startLineNumber, endLineNumber, className, tooltip, zIndex) {
		this.startLineNumber = startLineNumber;
		this.endLineNumber = endLineNumber;
		this.className = className;
		this.tooltip = tooltip;
		this._decorationToRenderBrand = void 0;
		this.zIndex = zIndex ?? 0;
	}
};
/**
* A decoration that should be shown along a line.
*/
var LineDecorationToRender = class {
	constructor(className, zIndex, tooltip) {
		this.className = className;
		this.zIndex = zIndex;
		this.tooltip = tooltip;
	}
};
/**
* Decorations to render on a visible line.
*/
var VisibleLineDecorationsToRender = class {
	constructor() {
		this.decorations = [];
	}
	add(decoration) {
		this.decorations.push(decoration);
	}
	getDecorations() {
		return this.decorations;
	}
};
var DedupOverlay = class extends DynamicViewOverlay {
	/**
	* Returns an array with an element for each visible line number.
	*/
	_render(visibleStartLineNumber, visibleEndLineNumber, decorations) {
		const output = [];
		for (let lineNumber = visibleStartLineNumber; lineNumber <= visibleEndLineNumber; lineNumber++) {
			const lineIndex = lineNumber - visibleStartLineNumber;
			output[lineIndex] = new VisibleLineDecorationsToRender();
		}
		if (decorations.length === 0) return output;
		decorations.sort((a, b) => {
			if (a.className === b.className) {
				if (a.startLineNumber === b.startLineNumber) return a.endLineNumber - b.endLineNumber;
				return a.startLineNumber - b.startLineNumber;
			}
			return a.className < b.className ? -1 : 1;
		});
		let prevClassName = null;
		let prevEndLineIndex = 0;
		for (const d of decorations) {
			const className = d.className;
			const zIndex = d.zIndex;
			let startLineIndex = Math.max(d.startLineNumber, visibleStartLineNumber) - visibleStartLineNumber;
			const endLineIndex = Math.min(d.endLineNumber, visibleEndLineNumber) - visibleStartLineNumber;
			if (prevClassName === className) {
				startLineIndex = Math.max(prevEndLineIndex + 1, startLineIndex);
				prevEndLineIndex = Math.max(prevEndLineIndex, endLineIndex);
			} else {
				prevClassName = className;
				prevEndLineIndex = endLineIndex;
			}
			for (let lineIndex = startLineIndex; lineIndex <= prevEndLineIndex; lineIndex++) output[lineIndex].add(new LineDecorationToRender(className, zIndex, d.tooltip));
		}
		return output;
	}
};
var GlyphMarginWidgets = class extends ViewPart {
	constructor(context) {
		super(context);
		this._widgets = {};
		this._context = context;
		const options = this._context.configuration.options;
		const layoutInfo = options.get(166);
		this.domNode = createFastDomNode(document.createElement("div"));
		this.domNode.setClassName("glyph-margin-widgets");
		this.domNode.setPosition("absolute");
		this.domNode.setTop(0);
		this._lineHeight = options.get(75);
		this._glyphMargin = options.get(66);
		this._glyphMarginLeft = layoutInfo.glyphMarginLeft;
		this._glyphMarginWidth = layoutInfo.glyphMarginWidth;
		this._glyphMarginDecorationLaneCount = layoutInfo.glyphMarginDecorationLaneCount;
		this._managedDomNodes = [];
		this._decorationGlyphsToRender = [];
	}
	dispose() {
		this._managedDomNodes = [];
		this._decorationGlyphsToRender = [];
		this._widgets = {};
		super.dispose();
	}
	getWidgets() {
		return Object.values(this._widgets);
	}
	onConfigurationChanged(e) {
		const options = this._context.configuration.options;
		const layoutInfo = options.get(166);
		this._lineHeight = options.get(75);
		this._glyphMargin = options.get(66);
		this._glyphMarginLeft = layoutInfo.glyphMarginLeft;
		this._glyphMarginWidth = layoutInfo.glyphMarginWidth;
		this._glyphMarginDecorationLaneCount = layoutInfo.glyphMarginDecorationLaneCount;
		return true;
	}
	onDecorationsChanged(e) {
		return true;
	}
	onFlushed(e) {
		return true;
	}
	onLinesChanged(e) {
		return true;
	}
	onLinesDeleted(e) {
		return true;
	}
	onLinesInserted(e) {
		return true;
	}
	onScrollChanged(e) {
		return e.scrollTopChanged;
	}
	onZonesChanged(e) {
		return true;
	}
	addWidget(widget) {
		const domNode = createFastDomNode(widget.getDomNode());
		this._widgets[widget.getId()] = {
			widget,
			preference: widget.getPosition(),
			domNode,
			renderInfo: null
		};
		domNode.setPosition("absolute");
		domNode.setDisplay("none");
		domNode.setAttribute("widgetId", widget.getId());
		this.domNode.appendChild(domNode);
		this.setShouldRender();
	}
	setWidgetPosition(widget, preference) {
		const myWidget = this._widgets[widget.getId()];
		if (myWidget.preference.lane === preference.lane && myWidget.preference.zIndex === preference.zIndex && Range$2.equalsRange(myWidget.preference.range, preference.range)) return false;
		myWidget.preference = preference;
		this.setShouldRender();
		return true;
	}
	removeWidget(widget) {
		const widgetId = widget.getId();
		if (this._widgets[widgetId]) {
			const domNode = this._widgets[widgetId].domNode.domNode;
			delete this._widgets[widgetId];
			domNode.remove();
			this.setShouldRender();
		}
	}
	_collectDecorationBasedGlyphRenderRequest(ctx, requests) {
		const visibleStartLineNumber = ctx.visibleRange.startLineNumber;
		const visibleEndLineNumber = ctx.visibleRange.endLineNumber;
		const decorations = ctx.getDecorationsInViewport();
		for (const d of decorations) {
			const glyphMarginClassName = d.options.glyphMarginClassName;
			if (!glyphMarginClassName) continue;
			const startLineNumber = Math.max(d.range.startLineNumber, visibleStartLineNumber);
			const endLineNumber = Math.min(d.range.endLineNumber, visibleEndLineNumber);
			const lane = d.options.glyphMargin?.position ?? GlyphMarginLane.Center;
			const zIndex = d.options.zIndex ?? 0;
			for (let lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++) {
				const modelPosition = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new Position$1(lineNumber, 0));
				const laneIndex = this._context.viewModel.glyphLanes.getLanesAtLine(modelPosition.lineNumber).indexOf(lane);
				requests.push(new DecorationBasedGlyphRenderRequest(lineNumber, laneIndex, zIndex, glyphMarginClassName));
			}
		}
	}
	_collectWidgetBasedGlyphRenderRequest(ctx, requests) {
		const visibleStartLineNumber = ctx.visibleRange.startLineNumber;
		const visibleEndLineNumber = ctx.visibleRange.endLineNumber;
		for (const widget of Object.values(this._widgets)) {
			const range = widget.preference.range;
			const { startLineNumber, endLineNumber } = this._context.viewModel.coordinatesConverter.convertModelRangeToViewRange(Range$2.lift(range));
			if (!startLineNumber || !endLineNumber || endLineNumber < visibleStartLineNumber || startLineNumber > visibleEndLineNumber) continue;
			const widgetLineNumber = Math.max(startLineNumber, visibleStartLineNumber);
			const modelPosition = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new Position$1(widgetLineNumber, 0));
			const laneIndex = this._context.viewModel.glyphLanes.getLanesAtLine(modelPosition.lineNumber).indexOf(widget.preference.lane);
			requests.push(new WidgetBasedGlyphRenderRequest(widgetLineNumber, laneIndex, widget.preference.zIndex, widget));
		}
	}
	_collectSortedGlyphRenderRequests(ctx) {
		const requests = [];
		this._collectDecorationBasedGlyphRenderRequest(ctx, requests);
		this._collectWidgetBasedGlyphRenderRequest(ctx, requests);
		requests.sort((a, b) => {
			if (a.lineNumber === b.lineNumber) {
				if (a.laneIndex === b.laneIndex) {
					if (a.zIndex === b.zIndex) {
						if (b.type === a.type) {
							if (a.type === 0 && b.type === 0) return a.className < b.className ? -1 : 1;
							return 0;
						}
						return b.type - a.type;
					}
					return b.zIndex - a.zIndex;
				}
				return a.laneIndex - b.laneIndex;
			}
			return a.lineNumber - b.lineNumber;
		});
		return requests;
	}
	/**
	* Will store render information in each widget's renderInfo and in `_decorationGlyphsToRender`.
	*/
	prepareRender(ctx) {
		if (!this._glyphMargin) {
			this._decorationGlyphsToRender = [];
			return;
		}
		for (const widget of Object.values(this._widgets)) widget.renderInfo = null;
		const requests = new ArrayQueue(this._collectSortedGlyphRenderRequests(ctx));
		const decorationGlyphsToRender = [];
		while (requests.length > 0) {
			const first = requests.peek();
			if (!first) break;
			const requestsAtLocation = requests.takeWhile((el) => el.lineNumber === first.lineNumber && el.laneIndex === first.laneIndex);
			if (!requestsAtLocation || requestsAtLocation.length === 0) break;
			const winner = requestsAtLocation[0];
			if (winner.type === 0) {
				const classNames = [];
				for (const request of requestsAtLocation) {
					if (request.zIndex !== winner.zIndex || request.type !== winner.type) break;
					if (classNames.length === 0 || classNames[classNames.length - 1] !== request.className) classNames.push(request.className);
				}
				decorationGlyphsToRender.push(winner.accept(classNames.join(" ")));
			} else winner.widget.renderInfo = {
				lineNumber: winner.lineNumber,
				laneIndex: winner.laneIndex
			};
		}
		this._decorationGlyphsToRender = decorationGlyphsToRender;
	}
	render(ctx) {
		if (!this._glyphMargin) {
			for (const widget of Object.values(this._widgets)) widget.domNode.setDisplay("none");
			while (this._managedDomNodes.length > 0) this._managedDomNodes.pop()?.domNode.remove();
			return;
		}
		const width = Math.round(this._glyphMarginWidth / this._glyphMarginDecorationLaneCount);
		for (const widget of Object.values(this._widgets)) if (!widget.renderInfo) widget.domNode.setDisplay("none");
		else {
			const top = ctx.viewportData.relativeVerticalOffset[widget.renderInfo.lineNumber - ctx.viewportData.startLineNumber];
			const left = this._glyphMarginLeft + widget.renderInfo.laneIndex * this._lineHeight;
			widget.domNode.setDisplay("block");
			widget.domNode.setTop(top);
			widget.domNode.setLeft(left);
			widget.domNode.setWidth(width);
			widget.domNode.setHeight(this._lineHeight);
		}
		for (let i = 0; i < this._decorationGlyphsToRender.length; i++) {
			const dec = this._decorationGlyphsToRender[i];
			const decLineNumber = dec.lineNumber;
			const top = ctx.viewportData.relativeVerticalOffset[decLineNumber - ctx.viewportData.startLineNumber];
			const left = this._glyphMarginLeft + dec.laneIndex * this._lineHeight;
			let domNode;
			if (i < this._managedDomNodes.length) domNode = this._managedDomNodes[i];
			else {
				domNode = createFastDomNode(document.createElement("div"));
				this._managedDomNodes.push(domNode);
				this.domNode.appendChild(domNode);
			}
			const lineHeight = this._context.viewLayout.getLineHeightForLineNumber(decLineNumber);
			domNode.setClassName(`cgmr codicon ` + dec.combinedClassName);
			domNode.setPosition(`absolute`);
			domNode.setTop(top);
			domNode.setLeft(left);
			domNode.setWidth(width);
			domNode.setHeight(lineHeight);
		}
		while (this._managedDomNodes.length > this._decorationGlyphsToRender.length) this._managedDomNodes.pop()?.domNode.remove();
	}
};
/**
* A request to render a decoration in the glyph margin at a certain location.
*/
var DecorationBasedGlyphRenderRequest = class {
	constructor(lineNumber, laneIndex, zIndex, className) {
		this.lineNumber = lineNumber;
		this.laneIndex = laneIndex;
		this.zIndex = zIndex;
		this.className = className;
		this.type = 0;
	}
	accept(combinedClassName) {
		return new DecorationBasedGlyph(this.lineNumber, this.laneIndex, combinedClassName);
	}
};
/**
* A request to render a widget in the glyph margin at a certain location.
*/
var WidgetBasedGlyphRenderRequest = class {
	constructor(lineNumber, laneIndex, zIndex, widget) {
		this.lineNumber = lineNumber;
		this.laneIndex = laneIndex;
		this.zIndex = zIndex;
		this.widget = widget;
		this.type = 1;
	}
};
var DecorationBasedGlyph = class {
	constructor(lineNumber, laneIndex, combinedClassName) {
		this.lineNumber = lineNumber;
		this.laneIndex = laneIndex;
		this.combinedClassName = combinedClassName;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/textModelPart.js
var TextModelPart = class extends Disposable {
	constructor() {
		super(...arguments);
		this._isDisposed = false;
	}
	dispose() {
		super.dispose();
		this._isDisposed = true;
	}
	assertNotDisposed() {
		if (this._isDisposed) throw new Error("TextModelPart is disposed!");
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/utils.js
/**
* Returns:
*  - -1 => the line consists of whitespace
*  - otherwise => the indent level is returned value
*/
function computeIndentLevel(line, tabSize) {
	let indent = 0;
	let i = 0;
	const len = line.length;
	while (i < len) {
		const chCode = line.charCodeAt(i);
		if (chCode === 32) indent++;
		else if (chCode === 9) indent = indent - indent % tabSize + tabSize;
		else break;
		i++;
	}
	if (i === len) return -1;
	return indent;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/textModelGuides.js
var HorizontalGuidesState;
(function(HorizontalGuidesState) {
	HorizontalGuidesState[HorizontalGuidesState["Disabled"] = 0] = "Disabled";
	HorizontalGuidesState[HorizontalGuidesState["EnabledForActive"] = 1] = "EnabledForActive";
	HorizontalGuidesState[HorizontalGuidesState["Enabled"] = 2] = "Enabled";
})(HorizontalGuidesState || (HorizontalGuidesState = {}));
var IndentGuide = class {
	constructor(visibleColumn, column, className, horizontalLine, forWrappedLinesAfterColumn, forWrappedLinesBeforeOrAtColumn) {
		this.visibleColumn = visibleColumn;
		this.column = column;
		this.className = className;
		this.horizontalLine = horizontalLine;
		this.forWrappedLinesAfterColumn = forWrappedLinesAfterColumn;
		this.forWrappedLinesBeforeOrAtColumn = forWrappedLinesBeforeOrAtColumn;
		if (visibleColumn !== -1 === (column !== -1)) throw new Error();
	}
};
var IndentGuideHorizontalLine = class {
	constructor(top, endColumn) {
		this.top = top;
		this.endColumn = endColumn;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/guidesTextModelPart.js
var GuidesTextModelPart = class extends TextModelPart {
	constructor(textModel, languageConfigurationService) {
		super();
		this.textModel = textModel;
		this.languageConfigurationService = languageConfigurationService;
	}
	getLanguageConfiguration(languageId) {
		return this.languageConfigurationService.getLanguageConfiguration(languageId);
	}
	_computeIndentLevel(lineIndex) {
		return computeIndentLevel(this.textModel.getLineContent(lineIndex + 1), this.textModel.getOptions().tabSize);
	}
	getActiveIndentGuide(lineNumber, minLineNumber, maxLineNumber) {
		this.assertNotDisposed();
		const lineCount = this.textModel.getLineCount();
		if (lineNumber < 1 || lineNumber > lineCount) throw new BugIndicatingError("Illegal value for lineNumber");
		const foldingRules = this.getLanguageConfiguration(this.textModel.getLanguageId()).foldingRules;
		const offSide = Boolean(foldingRules && foldingRules.offSide);
		let up_aboveContentLineIndex = -2;
		let up_aboveContentLineIndent = -1;
		let up_belowContentLineIndex = -2;
		let up_belowContentLineIndent = -1;
		const up_resolveIndents = (lineNumber) => {
			if (up_aboveContentLineIndex !== -1 && (up_aboveContentLineIndex === -2 || up_aboveContentLineIndex > lineNumber - 1)) {
				up_aboveContentLineIndex = -1;
				up_aboveContentLineIndent = -1;
				for (let lineIndex = lineNumber - 2; lineIndex >= 0; lineIndex--) {
					const indent = this._computeIndentLevel(lineIndex);
					if (indent >= 0) {
						up_aboveContentLineIndex = lineIndex;
						up_aboveContentLineIndent = indent;
						break;
					}
				}
			}
			if (up_belowContentLineIndex === -2) {
				up_belowContentLineIndex = -1;
				up_belowContentLineIndent = -1;
				for (let lineIndex = lineNumber; lineIndex < lineCount; lineIndex++) {
					const indent = this._computeIndentLevel(lineIndex);
					if (indent >= 0) {
						up_belowContentLineIndex = lineIndex;
						up_belowContentLineIndent = indent;
						break;
					}
				}
			}
		};
		let down_aboveContentLineIndex = -2;
		let down_aboveContentLineIndent = -1;
		let down_belowContentLineIndex = -2;
		let down_belowContentLineIndent = -1;
		const down_resolveIndents = (lineNumber) => {
			if (down_aboveContentLineIndex === -2) {
				down_aboveContentLineIndex = -1;
				down_aboveContentLineIndent = -1;
				for (let lineIndex = lineNumber - 2; lineIndex >= 0; lineIndex--) {
					const indent = this._computeIndentLevel(lineIndex);
					if (indent >= 0) {
						down_aboveContentLineIndex = lineIndex;
						down_aboveContentLineIndent = indent;
						break;
					}
				}
			}
			if (down_belowContentLineIndex !== -1 && (down_belowContentLineIndex === -2 || down_belowContentLineIndex < lineNumber - 1)) {
				down_belowContentLineIndex = -1;
				down_belowContentLineIndent = -1;
				for (let lineIndex = lineNumber; lineIndex < lineCount; lineIndex++) {
					const indent = this._computeIndentLevel(lineIndex);
					if (indent >= 0) {
						down_belowContentLineIndex = lineIndex;
						down_belowContentLineIndent = indent;
						break;
					}
				}
			}
		};
		let startLineNumber = 0;
		let goUp = true;
		let endLineNumber = 0;
		let goDown = true;
		let indent = 0;
		let initialIndent = 0;
		for (let distance = 0; goUp || goDown; distance++) {
			const upLineNumber = lineNumber - distance;
			const downLineNumber = lineNumber + distance;
			if (distance > 1 && (upLineNumber < 1 || upLineNumber < minLineNumber)) goUp = false;
			if (distance > 1 && (downLineNumber > lineCount || downLineNumber > maxLineNumber)) goDown = false;
			if (distance > 5e4) {
				goUp = false;
				goDown = false;
			}
			let upLineIndentLevel = -1;
			if (goUp && upLineNumber >= 1) {
				const currentIndent = this._computeIndentLevel(upLineNumber - 1);
				if (currentIndent >= 0) {
					up_belowContentLineIndex = upLineNumber - 1;
					up_belowContentLineIndent = currentIndent;
					upLineIndentLevel = Math.ceil(currentIndent / this.textModel.getOptions().indentSize);
				} else {
					up_resolveIndents(upLineNumber);
					upLineIndentLevel = this._getIndentLevelForWhitespaceLine(offSide, up_aboveContentLineIndent, up_belowContentLineIndent);
				}
			}
			let downLineIndentLevel = -1;
			if (goDown && downLineNumber <= lineCount) {
				const currentIndent = this._computeIndentLevel(downLineNumber - 1);
				if (currentIndent >= 0) {
					down_aboveContentLineIndex = downLineNumber - 1;
					down_aboveContentLineIndent = currentIndent;
					downLineIndentLevel = Math.ceil(currentIndent / this.textModel.getOptions().indentSize);
				} else {
					down_resolveIndents(downLineNumber);
					downLineIndentLevel = this._getIndentLevelForWhitespaceLine(offSide, down_aboveContentLineIndent, down_belowContentLineIndent);
				}
			}
			if (distance === 0) {
				initialIndent = upLineIndentLevel;
				continue;
			}
			if (distance === 1) {
				if (downLineNumber <= lineCount && downLineIndentLevel >= 0 && initialIndent + 1 === downLineIndentLevel) {
					goUp = false;
					startLineNumber = downLineNumber;
					endLineNumber = downLineNumber;
					indent = downLineIndentLevel;
					continue;
				}
				if (upLineNumber >= 1 && upLineIndentLevel >= 0 && upLineIndentLevel - 1 === initialIndent) {
					goDown = false;
					startLineNumber = upLineNumber;
					endLineNumber = upLineNumber;
					indent = upLineIndentLevel;
					continue;
				}
				startLineNumber = lineNumber;
				endLineNumber = lineNumber;
				indent = initialIndent;
				if (indent === 0) return {
					startLineNumber,
					endLineNumber,
					indent
				};
			}
			if (goUp) {
				if (upLineIndentLevel >= indent) startLineNumber = upLineNumber;
				else goUp = false;
			}
			if (goDown) {
				if (downLineIndentLevel >= indent) endLineNumber = downLineNumber;
				else goDown = false;
			}
		}
		return {
			startLineNumber,
			endLineNumber,
			indent
		};
	}
	getLinesBracketGuides(startLineNumber, endLineNumber, activePosition, options) {
		const result = [];
		for (let lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++) result.push([]);
		const includeSingleLinePairs = true;
		const bracketPairs = this.textModel.bracketPairs.getBracketPairsInRangeWithMinIndentation(new Range$2(startLineNumber, 1, endLineNumber, this.textModel.getLineMaxColumn(endLineNumber))).toArray();
		let activeBracketPairRange = void 0;
		if (activePosition && bracketPairs.length > 0) {
			const bracketsContainingActivePosition = (startLineNumber <= activePosition.lineNumber && activePosition.lineNumber <= endLineNumber ? bracketPairs : this.textModel.bracketPairs.getBracketPairsInRange(Range$2.fromPositions(activePosition)).toArray()).filter((bp) => Range$2.strictContainsPosition(bp.range, activePosition));
			activeBracketPairRange = findLast(bracketsContainingActivePosition, (i) => includeSingleLinePairs)?.range;
		}
		const independentColorPoolPerBracketType = this.textModel.getOptions().bracketPairColorizationOptions.independentColorPoolPerBracketType;
		const colorProvider = new BracketPairGuidesClassNames();
		for (const pair of bracketPairs) {
			if (!pair.closingBracketRange) continue;
			const isActive = activeBracketPairRange && pair.range.equalsRange(activeBracketPairRange);
			if (!isActive && !options.includeInactive) continue;
			const className = colorProvider.getInlineClassName(pair.nestingLevel, pair.nestingLevelOfEqualBracketType, independentColorPoolPerBracketType) + (options.highlightActive && isActive ? " " + colorProvider.activeClassName : "");
			const start = pair.openingBracketRange.getStartPosition();
			const end = pair.closingBracketRange.getStartPosition();
			const horizontalGuides = options.horizontalGuides === HorizontalGuidesState.Enabled || options.horizontalGuides === HorizontalGuidesState.EnabledForActive && isActive;
			if (pair.range.startLineNumber === pair.range.endLineNumber) {
				if (horizontalGuides) result[pair.range.startLineNumber - startLineNumber].push(new IndentGuide(-1, pair.openingBracketRange.getEndPosition().column, className, new IndentGuideHorizontalLine(false, end.column), -1, -1));
				continue;
			}
			const endVisibleColumn = this.getVisibleColumnFromPosition(end);
			const startVisibleColumn = this.getVisibleColumnFromPosition(pair.openingBracketRange.getStartPosition());
			const guideVisibleColumn = Math.min(startVisibleColumn, endVisibleColumn, pair.minVisibleColumnIndentation + 1);
			let renderHorizontalEndLineAtTheBottom = false;
			if (firstNonWhitespaceIndex(this.textModel.getLineContent(pair.closingBracketRange.startLineNumber)) < pair.closingBracketRange.startColumn - 1) renderHorizontalEndLineAtTheBottom = true;
			const visibleGuideStartLineNumber = Math.max(start.lineNumber, startLineNumber);
			const visibleGuideEndLineNumber = Math.min(end.lineNumber, endLineNumber);
			const offset = renderHorizontalEndLineAtTheBottom ? 1 : 0;
			for (let l = visibleGuideStartLineNumber; l < visibleGuideEndLineNumber + offset; l++) result[l - startLineNumber].push(new IndentGuide(guideVisibleColumn, -1, className, null, l === start.lineNumber ? start.column : -1, l === end.lineNumber ? end.column : -1));
			if (horizontalGuides) {
				if (start.lineNumber >= startLineNumber && startVisibleColumn > guideVisibleColumn) result[start.lineNumber - startLineNumber].push(new IndentGuide(guideVisibleColumn, -1, className, new IndentGuideHorizontalLine(false, start.column), -1, -1));
				if (end.lineNumber <= endLineNumber && endVisibleColumn > guideVisibleColumn) result[end.lineNumber - startLineNumber].push(new IndentGuide(guideVisibleColumn, -1, className, new IndentGuideHorizontalLine(!renderHorizontalEndLineAtTheBottom, end.column), -1, -1));
			}
		}
		for (const guides of result) guides.sort((a, b) => a.visibleColumn - b.visibleColumn);
		return result;
	}
	getVisibleColumnFromPosition(position) {
		return CursorColumns.visibleColumnFromColumn(this.textModel.getLineContent(position.lineNumber), position.column, this.textModel.getOptions().tabSize) + 1;
	}
	getLinesIndentGuides(startLineNumber, endLineNumber) {
		this.assertNotDisposed();
		const lineCount = this.textModel.getLineCount();
		if (startLineNumber < 1 || startLineNumber > lineCount) throw new Error("Illegal value for startLineNumber");
		if (endLineNumber < 1 || endLineNumber > lineCount) throw new Error("Illegal value for endLineNumber");
		const options = this.textModel.getOptions();
		const foldingRules = this.getLanguageConfiguration(this.textModel.getLanguageId()).foldingRules;
		const offSide = Boolean(foldingRules && foldingRules.offSide);
		const result = new Array(endLineNumber - startLineNumber + 1);
		let aboveContentLineIndex = -2;
		let aboveContentLineIndent = -1;
		let belowContentLineIndex = -2;
		let belowContentLineIndent = -1;
		for (let lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++) {
			const resultIndex = lineNumber - startLineNumber;
			const currentIndent = this._computeIndentLevel(lineNumber - 1);
			if (currentIndent >= 0) {
				aboveContentLineIndex = lineNumber - 1;
				aboveContentLineIndent = currentIndent;
				result[resultIndex] = Math.ceil(currentIndent / options.indentSize);
				continue;
			}
			if (aboveContentLineIndex === -2) {
				aboveContentLineIndex = -1;
				aboveContentLineIndent = -1;
				for (let lineIndex = lineNumber - 2; lineIndex >= 0; lineIndex--) {
					const indent = this._computeIndentLevel(lineIndex);
					if (indent >= 0) {
						aboveContentLineIndex = lineIndex;
						aboveContentLineIndent = indent;
						break;
					}
				}
			}
			if (belowContentLineIndex !== -1 && (belowContentLineIndex === -2 || belowContentLineIndex < lineNumber - 1)) {
				belowContentLineIndex = -1;
				belowContentLineIndent = -1;
				for (let lineIndex = lineNumber; lineIndex < lineCount; lineIndex++) {
					const indent = this._computeIndentLevel(lineIndex);
					if (indent >= 0) {
						belowContentLineIndex = lineIndex;
						belowContentLineIndent = indent;
						break;
					}
				}
			}
			result[resultIndex] = this._getIndentLevelForWhitespaceLine(offSide, aboveContentLineIndent, belowContentLineIndent);
		}
		return result;
	}
	_getIndentLevelForWhitespaceLine(offSide, aboveContentLineIndent, belowContentLineIndent) {
		const options = this.textModel.getOptions();
		if (aboveContentLineIndent === -1 || belowContentLineIndent === -1) return 0;
		else if (aboveContentLineIndent < belowContentLineIndent) return 1 + Math.floor(aboveContentLineIndent / options.indentSize);
		else if (aboveContentLineIndent === belowContentLineIndent) return Math.ceil(belowContentLineIndent / options.indentSize);
		else if (offSide) return Math.ceil(belowContentLineIndent / options.indentSize);
		else return 1 + Math.floor(belowContentLineIndent / options.indentSize);
	}
};
var BracketPairGuidesClassNames = class {
	constructor() {
		this.activeClassName = "indent-active";
	}
	getInlineClassName(nestingLevel, nestingLevelOfEqualBracketType, independentColorPoolPerBracketType) {
		return this.getInlineClassNameOfLevel(independentColorPoolPerBracketType ? nestingLevelOfEqualBracketType : nestingLevel);
	}
	getInlineClassNameOfLevel(level) {
		return `bracket-indent-guide lvl-${level % 30}`;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/indentGuides/indentGuides.js
/**
* Indent guides are vertical lines that help identify the indentation level of
* the code.
*/
var IndentGuidesOverlay = class extends DynamicViewOverlay {
	constructor(context) {
		super();
		this._context = context;
		this._primaryPosition = null;
		const options = this._context.configuration.options;
		const wrappingInfo = options.get(167);
		const fontInfo = options.get(59);
		this._spaceWidth = fontInfo.spaceWidth;
		this._maxIndentLeft = wrappingInfo.wrappingColumn === -1 ? -1 : wrappingInfo.wrappingColumn * fontInfo.typicalHalfwidthCharacterWidth;
		this._bracketPairGuideOptions = options.get(22);
		this._renderResult = null;
		this._context.addEventHandler(this);
	}
	dispose() {
		this._context.removeEventHandler(this);
		this._renderResult = null;
		super.dispose();
	}
	onConfigurationChanged(e) {
		const options = this._context.configuration.options;
		const wrappingInfo = options.get(167);
		const fontInfo = options.get(59);
		this._spaceWidth = fontInfo.spaceWidth;
		this._maxIndentLeft = wrappingInfo.wrappingColumn === -1 ? -1 : wrappingInfo.wrappingColumn * fontInfo.typicalHalfwidthCharacterWidth;
		this._bracketPairGuideOptions = options.get(22);
		return true;
	}
	onCursorStateChanged(e) {
		const newPosition = e.selections[0].getPosition();
		if (!this._primaryPosition?.equals(newPosition)) {
			this._primaryPosition = newPosition;
			return true;
		}
		return false;
	}
	onDecorationsChanged(e) {
		return true;
	}
	onFlushed(e) {
		return true;
	}
	onLinesChanged(e) {
		return true;
	}
	onLinesDeleted(e) {
		return true;
	}
	onLinesInserted(e) {
		return true;
	}
	onScrollChanged(e) {
		return e.scrollTopChanged;
	}
	onZonesChanged(e) {
		return true;
	}
	onLanguageConfigurationChanged(e) {
		return true;
	}
	prepareRender(ctx) {
		if (!this._bracketPairGuideOptions.indentation && this._bracketPairGuideOptions.bracketPairs === false) {
			this._renderResult = null;
			return;
		}
		const visibleStartLineNumber = ctx.visibleRange.startLineNumber;
		const visibleEndLineNumber = ctx.visibleRange.endLineNumber;
		const scrollWidth = ctx.scrollWidth;
		const activeCursorPosition = this._primaryPosition;
		const indents = this.getGuidesByLine(visibleStartLineNumber, Math.min(visibleEndLineNumber + 1, this._context.viewModel.getLineCount()), activeCursorPosition);
		const output = [];
		for (let lineNumber = visibleStartLineNumber; lineNumber <= visibleEndLineNumber; lineNumber++) {
			const lineIndex = lineNumber - visibleStartLineNumber;
			const indent = indents[lineIndex];
			let result = "";
			const leftOffset = ctx.visibleRangeForPosition(new Position$1(lineNumber, 1))?.left ?? 0;
			for (const guide of indent) {
				const left = guide.column === -1 ? leftOffset + (guide.visibleColumn - 1) * this._spaceWidth : ctx.visibleRangeForPosition(new Position$1(lineNumber, guide.column)).left;
				if (left > scrollWidth || this._maxIndentLeft > 0 && left > this._maxIndentLeft) break;
				const className = guide.horizontalLine ? guide.horizontalLine.top ? "horizontal-top" : "horizontal-bottom" : "vertical";
				const width = guide.horizontalLine ? (ctx.visibleRangeForPosition(new Position$1(lineNumber, guide.horizontalLine.endColumn))?.left ?? left + this._spaceWidth) - left : this._spaceWidth;
				result += `<div class="core-guide ${guide.className} ${className}" style="left:${left}px;width:${width}px"></div>`;
			}
			output[lineIndex] = result;
		}
		this._renderResult = output;
	}
	getGuidesByLine(visibleStartLineNumber, visibleEndLineNumber, activeCursorPosition) {
		const bracketGuides = this._bracketPairGuideOptions.bracketPairs !== false ? this._context.viewModel.getBracketGuidesInRangeByLine(visibleStartLineNumber, visibleEndLineNumber, activeCursorPosition, {
			highlightActive: this._bracketPairGuideOptions.highlightActiveBracketPair,
			horizontalGuides: this._bracketPairGuideOptions.bracketPairsHorizontal === true ? HorizontalGuidesState.Enabled : this._bracketPairGuideOptions.bracketPairsHorizontal === "active" ? HorizontalGuidesState.EnabledForActive : HorizontalGuidesState.Disabled,
			includeInactive: this._bracketPairGuideOptions.bracketPairs === true
		}) : null;
		const indentGuides = this._bracketPairGuideOptions.indentation ? this._context.viewModel.getLinesIndentGuides(visibleStartLineNumber, visibleEndLineNumber) : null;
		let activeIndentStartLineNumber = 0;
		let activeIndentEndLineNumber = 0;
		let activeIndentLevel = 0;
		if (this._bracketPairGuideOptions.highlightActiveIndentation !== false && activeCursorPosition) {
			const activeIndentInfo = this._context.viewModel.getActiveIndentGuide(activeCursorPosition.lineNumber, visibleStartLineNumber, visibleEndLineNumber);
			activeIndentStartLineNumber = activeIndentInfo.startLineNumber;
			activeIndentEndLineNumber = activeIndentInfo.endLineNumber;
			activeIndentLevel = activeIndentInfo.indent;
		}
		const { indentSize } = this._context.viewModel.model.getOptions();
		const result = [];
		for (let lineNumber = visibleStartLineNumber; lineNumber <= visibleEndLineNumber; lineNumber++) {
			const lineGuides = new Array();
			result.push(lineGuides);
			const bracketGuidesInLine = bracketGuides ? bracketGuides[lineNumber - visibleStartLineNumber] : [];
			const bracketGuidesInLineQueue = new ArrayQueue(bracketGuidesInLine);
			const indentGuidesInLine = indentGuides ? indentGuides[lineNumber - visibleStartLineNumber] : 0;
			for (let indentLvl = 1; indentLvl <= indentGuidesInLine; indentLvl++) {
				const indentGuide = (indentLvl - 1) * indentSize + 1;
				const isActive = (this._bracketPairGuideOptions.highlightActiveIndentation === "always" || bracketGuidesInLine.length === 0) && activeIndentStartLineNumber <= lineNumber && lineNumber <= activeIndentEndLineNumber && indentLvl === activeIndentLevel;
				lineGuides.push(...bracketGuidesInLineQueue.takeWhile((g) => g.visibleColumn < indentGuide) || []);
				const peeked = bracketGuidesInLineQueue.peek();
				if (!peeked || peeked.visibleColumn !== indentGuide || peeked.horizontalLine) lineGuides.push(new IndentGuide(indentGuide, -1, `core-guide-indent lvl-${(indentLvl - 1) % 30}` + (isActive ? " indent-active" : ""), null, -1, -1));
			}
			lineGuides.push(...bracketGuidesInLineQueue.takeWhile((g) => true) || []);
		}
		return result;
	}
	render(startLineNumber, lineNumber) {
		if (!this._renderResult) return "";
		const lineIndex = lineNumber - startLineNumber;
		if (lineIndex < 0 || lineIndex >= this._renderResult.length) return "";
		return this._renderResult[lineIndex];
	}
};
function transparentToUndefined(color) {
	if (color && color.isTransparent()) return;
	return color;
}
registerThemingParticipant((theme, collector) => {
	const colors = [
		{
			bracketColor: editorBracketHighlightingForeground1,
			guideColor: editorBracketPairGuideBackground1,
			guideColorActive: editorBracketPairGuideActiveBackground1
		},
		{
			bracketColor: editorBracketHighlightingForeground2,
			guideColor: editorBracketPairGuideBackground2,
			guideColorActive: editorBracketPairGuideActiveBackground2
		},
		{
			bracketColor: editorBracketHighlightingForeground3,
			guideColor: editorBracketPairGuideBackground3,
			guideColorActive: editorBracketPairGuideActiveBackground3
		},
		{
			bracketColor: editorBracketHighlightingForeground4,
			guideColor: editorBracketPairGuideBackground4,
			guideColorActive: editorBracketPairGuideActiveBackground4
		},
		{
			bracketColor: editorBracketHighlightingForeground5,
			guideColor: editorBracketPairGuideBackground5,
			guideColorActive: editorBracketPairGuideActiveBackground5
		},
		{
			bracketColor: editorBracketHighlightingForeground6,
			guideColor: editorBracketPairGuideBackground6,
			guideColorActive: editorBracketPairGuideActiveBackground6
		}
	];
	const colorProvider = new BracketPairGuidesClassNames();
	const indentColors = [
		{
			indentColor: editorIndentGuide1,
			indentColorActive: editorActiveIndentGuide1
		},
		{
			indentColor: editorIndentGuide2,
			indentColorActive: editorActiveIndentGuide2
		},
		{
			indentColor: editorIndentGuide3,
			indentColorActive: editorActiveIndentGuide3
		},
		{
			indentColor: editorIndentGuide4,
			indentColorActive: editorActiveIndentGuide4
		},
		{
			indentColor: editorIndentGuide5,
			indentColorActive: editorActiveIndentGuide5
		},
		{
			indentColor: editorIndentGuide6,
			indentColorActive: editorActiveIndentGuide6
		}
	];
	const colorValues = colors.map((c) => {
		const bracketColor = theme.getColor(c.bracketColor);
		const guideColor = theme.getColor(c.guideColor);
		const guideColorActive = theme.getColor(c.guideColorActive);
		const effectiveGuideColor = transparentToUndefined(transparentToUndefined(guideColor) ?? bracketColor?.transparent(.3));
		const effectiveGuideColorActive = transparentToUndefined(transparentToUndefined(guideColorActive) ?? bracketColor);
		if (!effectiveGuideColor || !effectiveGuideColorActive) return;
		return {
			guideColor: effectiveGuideColor,
			guideColorActive: effectiveGuideColorActive
		};
	}).filter(isDefined);
	const indentColorValues = indentColors.map((c) => {
		const indentColor = theme.getColor(c.indentColor);
		const indentColorActive = theme.getColor(c.indentColorActive);
		const effectiveIndentColor = transparentToUndefined(indentColor);
		const effectiveIndentColorActive = transparentToUndefined(indentColorActive);
		if (!effectiveIndentColor || !effectiveIndentColorActive) return;
		return {
			indentColor: effectiveIndentColor,
			indentColorActive: effectiveIndentColorActive
		};
	}).filter(isDefined);
	if (colorValues.length > 0) {
		for (let level = 0; level < 30; level++) {
			const colors = colorValues[level % colorValues.length];
			collector.addRule(`.monaco-editor .${colorProvider.getInlineClassNameOfLevel(level).replace(/ /g, ".")} { --guide-color: ${colors.guideColor}; --guide-color-active: ${colors.guideColorActive}; }`);
		}
		collector.addRule(`.monaco-editor .vertical { box-shadow: 1px 0 0 0 var(--guide-color) inset; }`);
		collector.addRule(`.monaco-editor .horizontal-top { border-top: 1px solid var(--guide-color); }`);
		collector.addRule(`.monaco-editor .horizontal-bottom { border-bottom: 1px solid var(--guide-color); }`);
		collector.addRule(`.monaco-editor .vertical.${colorProvider.activeClassName} { box-shadow: 1px 0 0 0 var(--guide-color-active) inset; }`);
		collector.addRule(`.monaco-editor .horizontal-top.${colorProvider.activeClassName} { border-top: 1px solid var(--guide-color-active); }`);
		collector.addRule(`.monaco-editor .horizontal-bottom.${colorProvider.activeClassName} { border-bottom: 1px solid var(--guide-color-active); }`);
	}
	if (indentColorValues.length > 0) {
		for (let level = 0; level < 30; level++) {
			const colors = indentColorValues[level % indentColorValues.length];
			collector.addRule(`.monaco-editor .lines-content .core-guide-indent.lvl-${level} { --indent-color: ${colors.indentColor}; --indent-color-active: ${colors.indentColorActive}; }`);
		}
		collector.addRule(`.monaco-editor .lines-content .core-guide-indent { box-shadow: 1px 0 0 0 var(--indent-color) inset; }`);
		collector.addRule(`.monaco-editor .lines-content .core-guide-indent.indent-active { box-shadow: 1px 0 0 0 var(--indent-color-active) inset; }`);
	}
});
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/lineNumbers/lineNumbers.js
/**
* Renders line numbers to the left of the main view lines content.
*/
var LineNumbersOverlay = class LineNumbersOverlay extends DynamicViewOverlay {
	static {
		this.CLASS_NAME = "line-numbers";
	}
	constructor(context) {
		super();
		this._context = context;
		this._readConfig();
		this._lastCursorModelPosition = new Position$1(1, 1);
		this._renderResult = null;
		this._activeModelLineNumber = 1;
		this._context.addEventHandler(this);
	}
	_readConfig() {
		const options = this._context.configuration.options;
		this._lineHeight = options.get(75);
		const lineNumbers = options.get(76);
		this._renderLineNumbers = lineNumbers.renderType;
		this._renderCustomLineNumbers = lineNumbers.renderFn;
		this._renderFinalNewline = options.get(109);
		const layoutInfo = options.get(166);
		this._lineNumbersLeft = layoutInfo.lineNumbersLeft;
		this._lineNumbersWidth = layoutInfo.lineNumbersWidth;
	}
	dispose() {
		this._context.removeEventHandler(this);
		this._renderResult = null;
		super.dispose();
	}
	onConfigurationChanged(e) {
		this._readConfig();
		return true;
	}
	onCursorStateChanged(e) {
		const primaryViewPosition = e.selections[0].getPosition();
		this._lastCursorModelPosition = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(primaryViewPosition);
		let shouldRender = false;
		if (this._activeModelLineNumber !== this._lastCursorModelPosition.lineNumber) {
			this._activeModelLineNumber = this._lastCursorModelPosition.lineNumber;
			shouldRender = true;
		}
		if (this._renderLineNumbers === 2 || this._renderLineNumbers === 3) shouldRender = true;
		return shouldRender;
	}
	onFlushed(e) {
		return true;
	}
	onLinesChanged(e) {
		return true;
	}
	onLinesDeleted(e) {
		return true;
	}
	onLinesInserted(e) {
		return true;
	}
	onScrollChanged(e) {
		return e.scrollTopChanged;
	}
	onZonesChanged(e) {
		return true;
	}
	onDecorationsChanged(e) {
		return e.affectsLineNumber;
	}
	_getLineRenderLineNumber(viewLineNumber) {
		const modelPosition = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new Position$1(viewLineNumber, 1));
		if (modelPosition.column !== 1) return "";
		const modelLineNumber = modelPosition.lineNumber;
		if (this._renderCustomLineNumbers) return this._renderCustomLineNumbers(modelLineNumber);
		if (this._renderLineNumbers === 2) {
			const diff = Math.abs(this._lastCursorModelPosition.lineNumber - modelLineNumber);
			if (diff === 0) return "<span class=\"relative-current-line-number\">" + modelLineNumber + "</span>";
			return String(diff);
		}
		if (this._renderLineNumbers === 3) {
			if (this._lastCursorModelPosition.lineNumber === modelLineNumber) return String(modelLineNumber);
			if (modelLineNumber % 10 === 0) return String(modelLineNumber);
			if (modelLineNumber === this._context.viewModel.getLineCount()) return String(modelLineNumber);
			return "";
		}
		return String(modelLineNumber);
	}
	prepareRender(ctx) {
		if (this._renderLineNumbers === 0) {
			this._renderResult = null;
			return;
		}
		const lineHeightClassName = isLinux ? this._lineHeight % 2 === 0 ? " lh-even" : " lh-odd" : "";
		const visibleStartLineNumber = ctx.visibleRange.startLineNumber;
		const visibleEndLineNumber = ctx.visibleRange.endLineNumber;
		const lineNoDecorations = this._context.viewModel.getDecorationsInViewport(ctx.visibleRange).filter((d) => !!d.options.lineNumberClassName);
		lineNoDecorations.sort((a, b) => Range$2.compareRangesUsingEnds(a.range, b.range));
		let decorationStartIndex = 0;
		const lineCount = this._context.viewModel.getLineCount();
		const output = [];
		for (let lineNumber = visibleStartLineNumber; lineNumber <= visibleEndLineNumber; lineNumber++) {
			const lineIndex = lineNumber - visibleStartLineNumber;
			const modelLineNumber = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new Position$1(lineNumber, 1)).lineNumber;
			let renderLineNumber = this._getLineRenderLineNumber(lineNumber);
			let extraClassNames = "";
			while (decorationStartIndex < lineNoDecorations.length && lineNoDecorations[decorationStartIndex].range.endLineNumber < lineNumber) decorationStartIndex++;
			for (let i = decorationStartIndex; i < lineNoDecorations.length; i++) {
				const { range, options } = lineNoDecorations[i];
				if (range.startLineNumber <= lineNumber) extraClassNames += " " + options.lineNumberClassName;
			}
			if (!renderLineNumber && !extraClassNames) {
				output[lineIndex] = "";
				continue;
			}
			if (lineNumber === lineCount && this._context.viewModel.getLineLength(lineNumber) === 0) {
				if (this._renderFinalNewline === "off") renderLineNumber = "";
				if (this._renderFinalNewline === "dimmed") extraClassNames += " dimmed-line-number";
			}
			if (modelLineNumber === this._activeModelLineNumber) extraClassNames += " active-line-number";
			output[lineIndex] = `<div class="${LineNumbersOverlay.CLASS_NAME}${lineHeightClassName}${extraClassNames}" style="left:${this._lineNumbersLeft}px;width:${this._lineNumbersWidth}px;">${renderLineNumber}</div>`;
		}
		this._renderResult = output;
	}
	render(startLineNumber, lineNumber) {
		if (!this._renderResult) return "";
		const lineIndex = lineNumber - startLineNumber;
		if (lineIndex < 0 || lineIndex >= this._renderResult.length) return "";
		return this._renderResult[lineIndex];
	}
};
registerThemingParticipant((theme, collector) => {
	const editorLineNumbersColor = theme.getColor(editorLineNumbers);
	const editorDimmedLineNumberColor = theme.getColor(editorDimmedLineNumber);
	if (editorDimmedLineNumberColor) collector.addRule(`.monaco-editor .line-numbers.dimmed-line-number { color: ${editorDimmedLineNumberColor}; }`);
	else if (editorLineNumbersColor) collector.addRule(`.monaco-editor .line-numbers.dimmed-line-number { color: ${editorLineNumbersColor.transparent(.4)}; }`);
});
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/mouseCursor/mouseCursor.js
var MOUSE_CURSOR_TEXT_CSS_CLASS_NAME = `monaco-mouse-cursor-text`;
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/viewLines/domReadingContext.js
var DomReadingContext = class {
	get didDomLayout() {
		return this._didDomLayout;
	}
	readClientRect() {
		if (!this._clientRectRead) {
			this._clientRectRead = true;
			const rect = this._domNode.getBoundingClientRect();
			this.markDidDomLayout();
			this._clientRectDeltaLeft = rect.left;
			const offsetWidth = this._domNode.offsetWidth;
			this._clientRectScale = offsetWidth > 0 ? rect.width / offsetWidth : 1;
		}
	}
	get clientRectDeltaLeft() {
		if (!this._clientRectRead) this.readClientRect();
		return this._clientRectDeltaLeft;
	}
	get clientRectScale() {
		if (!this._clientRectRead) this.readClientRect();
		return this._clientRectScale;
	}
	constructor(_domNode, endNode) {
		this._domNode = _domNode;
		this.endNode = endNode;
		this._didDomLayout = false;
		this._clientRectDeltaLeft = 0;
		this._clientRectScale = 1;
		this._clientRectRead = false;
	}
	markDidDomLayout() {
		this._didDomLayout = true;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/viewLines/viewLineOptions.js
var ViewLineOptions = class {
	constructor(config, themeType) {
		this.themeType = themeType;
		const options = config.options;
		const fontInfo = options.get(59);
		this.renderWhitespace = options.get(113);
		this.experimentalWhitespaceRendering = options.get(47);
		this.renderControlCharacters = options.get(108);
		this.spaceWidth = fontInfo.spaceWidth;
		this.middotWidth = fontInfo.middotWidth;
		this.wsmiddotWidth = fontInfo.wsmiddotWidth;
		this.useMonospaceOptimizations = fontInfo.isMonospace && !options.get(40);
		this.canUseHalfwidthRightwardsArrow = fontInfo.canUseHalfwidthRightwardsArrow;
		this.lineHeight = options.get(75);
		this.stopRenderingLineAfter = options.get(133);
		this.fontLigatures = options.get(60);
		this.verticalScrollbarSize = options.get(117).verticalScrollbarSize;
		this.useGpu = options.get(46) === "on";
		this.useTwoCellFullwidthCharacters = options.get(176) === "twoCells";
	}
	equals(other) {
		return this.themeType === other.themeType && this.renderWhitespace === other.renderWhitespace && this.experimentalWhitespaceRendering === other.experimentalWhitespaceRendering && this.renderControlCharacters === other.renderControlCharacters && this.spaceWidth === other.spaceWidth && this.middotWidth === other.middotWidth && this.wsmiddotWidth === other.wsmiddotWidth && this.useMonospaceOptimizations === other.useMonospaceOptimizations && this.canUseHalfwidthRightwardsArrow === other.canUseHalfwidthRightwardsArrow && this.lineHeight === other.lineHeight && this.stopRenderingLineAfter === other.stopRenderingLineAfter && this.fontLigatures === other.fontLigatures && this.verticalScrollbarSize === other.verticalScrollbarSize && this.useGpu === other.useGpu && this.useTwoCellFullwidthCharacters === other.useTwoCellFullwidthCharacters;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/viewLines/viewLines.js
var LastRenderedData = class {
	constructor() {
		this._currentVisibleRange = new Range$2(1, 1, 1, 1);
	}
	getCurrentVisibleRange() {
		return this._currentVisibleRange;
	}
	setCurrentVisibleRange(currentVisibleRange) {
		this._currentVisibleRange = currentVisibleRange;
	}
};
var HorizontalRevealRangeRequest = class {
	constructor(minimalReveal, lineNumber, startColumn, endColumn, startScrollTop, stopScrollTop, scrollType) {
		this.minimalReveal = minimalReveal;
		this.lineNumber = lineNumber;
		this.startColumn = startColumn;
		this.endColumn = endColumn;
		this.startScrollTop = startScrollTop;
		this.stopScrollTop = stopScrollTop;
		this.scrollType = scrollType;
		this.type = "range";
		this.minLineNumber = lineNumber;
		this.maxLineNumber = lineNumber;
	}
};
var HorizontalRevealSelectionsRequest = class {
	constructor(minimalReveal, selections, startScrollTop, stopScrollTop, scrollType) {
		this.minimalReveal = minimalReveal;
		this.selections = selections;
		this.startScrollTop = startScrollTop;
		this.stopScrollTop = stopScrollTop;
		this.scrollType = scrollType;
		this.type = "selections";
		let minLineNumber = selections[0].startLineNumber;
		let maxLineNumber = selections[0].endLineNumber;
		for (let i = 1, len = selections.length; i < len; i++) {
			const selection = selections[i];
			minLineNumber = Math.min(minLineNumber, selection.startLineNumber);
			maxLineNumber = Math.max(maxLineNumber, selection.endLineNumber);
		}
		this.minLineNumber = minLineNumber;
		this.maxLineNumber = maxLineNumber;
	}
};
/**
* The view lines part is responsible for rendering the actual content of a
* file.
*/
var ViewLines = class ViewLines extends ViewPart {
	/**
	* Adds this amount of pixels to the right of lines (no-one wants to type near the edge of the viewport)
	*/
	static {
		this.HORIZONTAL_EXTRA_PX = 30;
	}
	constructor(context, viewGpuContext, linesContent) {
		super(context);
		const conf = this._context.configuration;
		const options = this._context.configuration.options;
		const fontInfo = options.get(59);
		const wrappingInfo = options.get(167);
		this._lineHeight = options.get(75);
		this._typicalHalfwidthCharacterWidth = fontInfo.typicalHalfwidthCharacterWidth;
		this._isViewportWrapping = wrappingInfo.isViewportWrapping;
		this._revealHorizontalRightPadding = options.get(114);
		this._cursorSurroundingLines = options.get(35);
		this._cursorSurroundingLinesStyle = options.get(36);
		this._canUseLayerHinting = !options.get(39);
		this._viewLineOptions = new ViewLineOptions(conf, this._context.theme.type);
		this._linesContent = linesContent;
		this._textRangeRestingSpot = document.createElement("div");
		this._visibleLines = new VisibleLinesCollection(this._context, { createLine: () => new ViewLine(viewGpuContext, this._viewLineOptions) });
		this.domNode = this._visibleLines.domNode;
		PartFingerprints.write(this.domNode, 8);
		this.domNode.setClassName(`view-lines ${MOUSE_CURSOR_TEXT_CSS_CLASS_NAME}`);
		applyFontInfo(this.domNode, fontInfo);
		this._maxLineWidth = 0;
		this._asyncUpdateLineWidths = new RunOnceScheduler(() => {
			this._updateLineWidthsSlow();
		}, 200);
		this._asyncCheckMonospaceFontAssumptions = new RunOnceScheduler(() => {
			this._checkMonospaceFontAssumptions();
		}, 2e3);
		this._lastRenderedData = new LastRenderedData();
		this._horizontalRevealRequest = null;
		this._stickyScrollEnabled = options.get(131).enabled;
		this._maxNumberStickyLines = options.get(131).maxLineCount;
	}
	dispose() {
		this._asyncUpdateLineWidths.dispose();
		this._asyncCheckMonospaceFontAssumptions.dispose();
		super.dispose();
	}
	getDomNode() {
		return this.domNode;
	}
	onConfigurationChanged(e) {
		this._visibleLines.onConfigurationChanged(e);
		if (e.hasChanged(167)) this._maxLineWidth = 0;
		const options = this._context.configuration.options;
		const fontInfo = options.get(59);
		const wrappingInfo = options.get(167);
		this._lineHeight = options.get(75);
		this._typicalHalfwidthCharacterWidth = fontInfo.typicalHalfwidthCharacterWidth;
		this._isViewportWrapping = wrappingInfo.isViewportWrapping;
		this._revealHorizontalRightPadding = options.get(114);
		this._cursorSurroundingLines = options.get(35);
		this._cursorSurroundingLinesStyle = options.get(36);
		this._canUseLayerHinting = !options.get(39);
		this._stickyScrollEnabled = options.get(131).enabled;
		this._maxNumberStickyLines = options.get(131).maxLineCount;
		applyFontInfo(this.domNode, fontInfo);
		this._onOptionsMaybeChanged();
		if (e.hasChanged(166)) this._maxLineWidth = 0;
		return true;
	}
	_onOptionsMaybeChanged() {
		const conf = this._context.configuration;
		const newViewLineOptions = new ViewLineOptions(conf, this._context.theme.type);
		if (!this._viewLineOptions.equals(newViewLineOptions)) {
			this._viewLineOptions = newViewLineOptions;
			const startLineNumber = this._visibleLines.getStartLineNumber();
			const endLineNumber = this._visibleLines.getEndLineNumber();
			for (let lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++) this._visibleLines.getVisibleLine(lineNumber).onOptionsChanged(this._viewLineOptions);
			return true;
		}
		return false;
	}
	onCursorStateChanged(e) {
		const rendStartLineNumber = this._visibleLines.getStartLineNumber();
		const rendEndLineNumber = this._visibleLines.getEndLineNumber();
		let r = false;
		for (let lineNumber = rendStartLineNumber; lineNumber <= rendEndLineNumber; lineNumber++) r = this._visibleLines.getVisibleLine(lineNumber).onSelectionChanged() || r;
		return r;
	}
	onDecorationsChanged(e) {
		const rendStartLineNumber = this._visibleLines.getStartLineNumber();
		const rendEndLineNumber = this._visibleLines.getEndLineNumber();
		for (let lineNumber = rendStartLineNumber; lineNumber <= rendEndLineNumber; lineNumber++) this._visibleLines.getVisibleLine(lineNumber).onDecorationsChanged();
		return true;
	}
	onFlushed(e) {
		const shouldRender = this._visibleLines.onFlushed(e, this._viewLineOptions.useGpu);
		this._maxLineWidth = 0;
		return shouldRender;
	}
	onLinesChanged(e) {
		return this._visibleLines.onLinesChanged(e);
	}
	onLinesDeleted(e) {
		return this._visibleLines.onLinesDeleted(e);
	}
	onLinesInserted(e) {
		return this._visibleLines.onLinesInserted(e);
	}
	onRevealRangeRequest(e) {
		const desiredScrollTop = this._computeScrollTopToRevealRange(this._context.viewLayout.getFutureViewport(), e.source, e.minimalReveal, e.range, e.selections, e.verticalType);
		if (desiredScrollTop === -1) return false;
		let newScrollPosition = this._context.viewLayout.validateScrollPosition({ scrollTop: desiredScrollTop });
		if (e.revealHorizontal) {
			if (e.range && e.range.startLineNumber !== e.range.endLineNumber) newScrollPosition = {
				scrollTop: newScrollPosition.scrollTop,
				scrollLeft: 0
			};
			else if (e.range) this._horizontalRevealRequest = new HorizontalRevealRangeRequest(e.minimalReveal, e.range.startLineNumber, e.range.startColumn, e.range.endColumn, this._context.viewLayout.getCurrentScrollTop(), newScrollPosition.scrollTop, e.scrollType);
			else if (e.selections && e.selections.length > 0) this._horizontalRevealRequest = new HorizontalRevealSelectionsRequest(e.minimalReveal, e.selections, this._context.viewLayout.getCurrentScrollTop(), newScrollPosition.scrollTop, e.scrollType);
		} else this._horizontalRevealRequest = null;
		const scrollType = Math.abs(this._context.viewLayout.getCurrentScrollTop() - newScrollPosition.scrollTop) <= this._lineHeight ? 1 : e.scrollType;
		this._context.viewModel.viewLayout.setScrollPosition(newScrollPosition, scrollType);
		return true;
	}
	onScrollChanged(e) {
		if (this._horizontalRevealRequest && e.scrollLeftChanged) this._horizontalRevealRequest = null;
		if (this._horizontalRevealRequest && e.scrollTopChanged) {
			const min = Math.min(this._horizontalRevealRequest.startScrollTop, this._horizontalRevealRequest.stopScrollTop);
			const max = Math.max(this._horizontalRevealRequest.startScrollTop, this._horizontalRevealRequest.stopScrollTop);
			if (e.scrollTop < min || e.scrollTop > max) this._horizontalRevealRequest = null;
		}
		this.domNode.setWidth(e.scrollWidth);
		return this._visibleLines.onScrollChanged(e) || e.scrollTopChanged || e.scrollLeftChanged;
	}
	onTokensChanged(e) {
		return this._visibleLines.onTokensChanged(e);
	}
	onZonesChanged(e) {
		this._context.viewModel.viewLayout.setMaxLineWidth(this._maxLineWidth);
		return this._visibleLines.onZonesChanged(e);
	}
	onThemeChanged(e) {
		return this._onOptionsMaybeChanged();
	}
	getPositionFromDOMInfo(spanNode, offset) {
		const viewLineDomNode = this._getViewLineDomNode(spanNode);
		if (viewLineDomNode === null) return null;
		const lineNumber = this._getLineNumberFor(viewLineDomNode);
		if (lineNumber === -1) return null;
		if (lineNumber < 1 || lineNumber > this._context.viewModel.getLineCount()) return null;
		if (this._context.viewModel.getLineMaxColumn(lineNumber) === 1) return new Position$1(lineNumber, 1);
		const rendStartLineNumber = this._visibleLines.getStartLineNumber();
		const rendEndLineNumber = this._visibleLines.getEndLineNumber();
		if (lineNumber < rendStartLineNumber || lineNumber > rendEndLineNumber) return null;
		let column = this._visibleLines.getVisibleLine(lineNumber).getColumnOfNodeOffset(spanNode, offset);
		const minColumn = this._context.viewModel.getLineMinColumn(lineNumber);
		if (column < minColumn) column = minColumn;
		return new Position$1(lineNumber, column);
	}
	_getViewLineDomNode(node) {
		while (node && node.nodeType === 1) {
			if (node.className === ViewLine.CLASS_NAME) return node;
			node = node.parentElement;
		}
		return null;
	}
	/**
	* @returns the line number of this view line dom node.
	*/
	_getLineNumberFor(domNode) {
		const startLineNumber = this._visibleLines.getStartLineNumber();
		const endLineNumber = this._visibleLines.getEndLineNumber();
		for (let lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++) if (domNode === this._visibleLines.getVisibleLine(lineNumber).getDomNode()) return lineNumber;
		return -1;
	}
	getLineWidth(lineNumber) {
		const rendStartLineNumber = this._visibleLines.getStartLineNumber();
		const rendEndLineNumber = this._visibleLines.getEndLineNumber();
		if (lineNumber < rendStartLineNumber || lineNumber > rendEndLineNumber) return -1;
		const context = new DomReadingContext(this.domNode.domNode, this._textRangeRestingSpot);
		const result = this._visibleLines.getVisibleLine(lineNumber).getWidth(context);
		this._updateLineWidthsSlowIfDomDidLayout(context);
		return result;
	}
	resetLineWidthCaches() {
		const rendStartLineNumber = this._visibleLines.getStartLineNumber();
		const rendEndLineNumber = this._visibleLines.getEndLineNumber();
		for (let lineNumber = rendStartLineNumber; lineNumber <= rendEndLineNumber; lineNumber++) this._visibleLines.getVisibleLine(lineNumber).resetCachedWidth();
	}
	linesVisibleRangesForRange(_range, includeNewLines) {
		const originalEndLineNumber = _range.endLineNumber;
		const range = Range$2.intersectRanges(_range, this._lastRenderedData.getCurrentVisibleRange());
		if (!range) return null;
		const visibleRanges = [];
		let visibleRangesLen = 0;
		const domReadingContext = new DomReadingContext(this.domNode.domNode, this._textRangeRestingSpot);
		let nextLineModelLineNumber = 0;
		if (includeNewLines) nextLineModelLineNumber = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new Position$1(range.startLineNumber, 1)).lineNumber;
		const rendStartLineNumber = this._visibleLines.getStartLineNumber();
		const rendEndLineNumber = this._visibleLines.getEndLineNumber();
		for (let lineNumber = range.startLineNumber; lineNumber <= range.endLineNumber; lineNumber++) {
			if (lineNumber < rendStartLineNumber || lineNumber > rendEndLineNumber) continue;
			const startColumn = lineNumber === range.startLineNumber ? range.startColumn : 1;
			const continuesInNextLine = lineNumber !== originalEndLineNumber;
			const endColumn = continuesInNextLine ? this._context.viewModel.getLineMaxColumn(lineNumber) : range.endColumn;
			const visibleRangesForLine = this._visibleLines.getVisibleLine(lineNumber).getVisibleRangesForRange(lineNumber, startColumn, endColumn, domReadingContext);
			if (!visibleRangesForLine) continue;
			if (includeNewLines && lineNumber < originalEndLineNumber) {
				const currentLineModelLineNumber = nextLineModelLineNumber;
				nextLineModelLineNumber = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new Position$1(lineNumber + 1, 1)).lineNumber;
				if (currentLineModelLineNumber !== nextLineModelLineNumber) {
					const floatHorizontalRange = visibleRangesForLine.ranges[visibleRangesForLine.ranges.length - 1];
					floatHorizontalRange.width += this._typicalHalfwidthCharacterWidth;
					if (this._context.viewModel.getTextDirection(currentLineModelLineNumber) === TextDirection.RTL) floatHorizontalRange.left -= this._typicalHalfwidthCharacterWidth;
				}
			}
			visibleRanges[visibleRangesLen++] = new LineVisibleRanges(visibleRangesForLine.outsideRenderedLine, lineNumber, HorizontalRange.from(visibleRangesForLine.ranges), continuesInNextLine);
		}
		this._updateLineWidthsSlowIfDomDidLayout(domReadingContext);
		if (visibleRangesLen === 0) return null;
		return visibleRanges;
	}
	_visibleRangesForLineRange(lineNumber, startColumn, endColumn) {
		if (lineNumber < this._visibleLines.getStartLineNumber() || lineNumber > this._visibleLines.getEndLineNumber()) return null;
		const domReadingContext = new DomReadingContext(this.domNode.domNode, this._textRangeRestingSpot);
		const result = this._visibleLines.getVisibleLine(lineNumber).getVisibleRangesForRange(lineNumber, startColumn, endColumn, domReadingContext);
		this._updateLineWidthsSlowIfDomDidLayout(domReadingContext);
		return result;
	}
	_lineIsRenderedRTL(lineNumber) {
		if (lineNumber < this._visibleLines.getStartLineNumber() || lineNumber > this._visibleLines.getEndLineNumber()) return false;
		return this._visibleLines.getVisibleLine(lineNumber).isRenderedRTL();
	}
	visibleRangeForPosition(position) {
		const visibleRanges = this._visibleRangesForLineRange(position.lineNumber, position.column, position.column);
		if (!visibleRanges) return null;
		return new HorizontalPosition(visibleRanges.outsideRenderedLine, visibleRanges.ranges[0].left);
	}
	/**
	* Updates the max line width if it is fast to compute.
	* Returns true if all lines were taken into account.
	* Returns false if some lines need to be reevaluated (in a slow fashion).
	*/
	_updateLineWidthsFast() {
		return this._updateLineWidths(true);
	}
	_updateLineWidthsSlow() {
		this._updateLineWidths(false);
	}
	/**
	* Update the line widths using DOM layout information after someone else
	* has caused a synchronous layout.
	*/
	_updateLineWidthsSlowIfDomDidLayout(domReadingContext) {
		if (!domReadingContext.didDomLayout) return;
		if (!this._asyncUpdateLineWidths.isScheduled()) return;
		this._asyncUpdateLineWidths.cancel();
		this._updateLineWidthsSlow();
	}
	_updateLineWidths(fast) {
		const rendStartLineNumber = this._visibleLines.getStartLineNumber();
		const rendEndLineNumber = this._visibleLines.getEndLineNumber();
		let localMaxLineWidth = 1;
		let allWidthsComputed = true;
		for (let lineNumber = rendStartLineNumber; lineNumber <= rendEndLineNumber; lineNumber++) {
			const visibleLine = this._visibleLines.getVisibleLine(lineNumber);
			if (fast && !visibleLine.getWidthIsFast()) {
				allWidthsComputed = false;
				continue;
			}
			localMaxLineWidth = Math.max(localMaxLineWidth, visibleLine.getWidth(null));
		}
		if (allWidthsComputed && rendStartLineNumber === 1 && rendEndLineNumber === this._context.viewModel.getLineCount()) this._maxLineWidth = 0;
		this._ensureMaxLineWidth(localMaxLineWidth);
		return allWidthsComputed;
	}
	_checkMonospaceFontAssumptions() {
		let longestLineNumber = -1;
		let longestWidth = -1;
		const rendStartLineNumber = this._visibleLines.getStartLineNumber();
		const rendEndLineNumber = this._visibleLines.getEndLineNumber();
		for (let lineNumber = rendStartLineNumber; lineNumber <= rendEndLineNumber; lineNumber++) {
			const visibleLine = this._visibleLines.getVisibleLine(lineNumber);
			if (visibleLine.needsMonospaceFontCheck()) {
				const lineWidth = visibleLine.getWidth(null);
				if (lineWidth > longestWidth) {
					longestWidth = lineWidth;
					longestLineNumber = lineNumber;
				}
			}
		}
		if (longestLineNumber === -1) return;
		if (!this._visibleLines.getVisibleLine(longestLineNumber).monospaceAssumptionsAreValid()) for (let lineNumber = rendStartLineNumber; lineNumber <= rendEndLineNumber; lineNumber++) this._visibleLines.getVisibleLine(lineNumber).onMonospaceAssumptionsInvalidated();
	}
	prepareRender() {
		throw new Error("Not supported");
	}
	render() {
		throw new Error("Not supported");
	}
	renderText(viewportData) {
		this._visibleLines.renderLines(viewportData);
		this._lastRenderedData.setCurrentVisibleRange(viewportData.visibleRange);
		this.domNode.setWidth(this._context.viewLayout.getScrollWidth());
		this.domNode.setHeight(Math.min(this._context.viewLayout.getScrollHeight(), 1e6));
		if (this._horizontalRevealRequest) {
			const horizontalRevealRequest = this._horizontalRevealRequest;
			if (viewportData.startLineNumber <= horizontalRevealRequest.minLineNumber && horizontalRevealRequest.maxLineNumber <= viewportData.endLineNumber) {
				this._horizontalRevealRequest = null;
				this.onDidRender();
				const newScrollLeft = this._computeScrollLeftToReveal(horizontalRevealRequest);
				if (newScrollLeft) {
					if (!this._isViewportWrapping && !newScrollLeft.hasRTL) this._ensureMaxLineWidth(newScrollLeft.maxHorizontalOffset);
					this._context.viewModel.viewLayout.setScrollPosition({ scrollLeft: newScrollLeft.scrollLeft }, horizontalRevealRequest.scrollType);
				}
			}
		}
		if (!this._updateLineWidthsFast()) this._asyncUpdateLineWidths.schedule();
		else this._asyncUpdateLineWidths.cancel();
		if (isLinux && !this._asyncCheckMonospaceFontAssumptions.isScheduled()) {
			const rendStartLineNumber = this._visibleLines.getStartLineNumber();
			const rendEndLineNumber = this._visibleLines.getEndLineNumber();
			for (let lineNumber = rendStartLineNumber; lineNumber <= rendEndLineNumber; lineNumber++) if (this._visibleLines.getVisibleLine(lineNumber).needsMonospaceFontCheck()) {
				this._asyncCheckMonospaceFontAssumptions.schedule();
				break;
			}
		}
		this._linesContent.setLayerHinting(this._canUseLayerHinting);
		this._linesContent.setContain("strict");
		const adjustedScrollTop = this._context.viewLayout.getCurrentScrollTop() - viewportData.bigNumbersDelta;
		this._linesContent.setTop(-adjustedScrollTop);
		this._linesContent.setLeft(-this._context.viewLayout.getCurrentScrollLeft());
	}
	_ensureMaxLineWidth(lineWidth) {
		if (this._viewLineOptions.useGpu) return;
		const iLineWidth = Math.ceil(lineWidth);
		if (this._maxLineWidth < iLineWidth) {
			this._maxLineWidth = iLineWidth;
			this._context.viewModel.viewLayout.setMaxLineWidth(this._maxLineWidth);
		}
	}
	_computeScrollTopToRevealRange(viewport, source, minimalReveal, range, selections, verticalType) {
		const viewportStartY = viewport.top;
		const viewportHeight = viewport.height;
		const viewportEndY = viewportStartY + viewportHeight;
		let boxIsSingleRange;
		let boxStartY;
		let boxEndY;
		if (selections && selections.length > 0) {
			let minLineNumber = selections[0].startLineNumber;
			let maxLineNumber = selections[0].endLineNumber;
			for (let i = 1, len = selections.length; i < len; i++) {
				const selection = selections[i];
				minLineNumber = Math.min(minLineNumber, selection.startLineNumber);
				maxLineNumber = Math.max(maxLineNumber, selection.endLineNumber);
			}
			boxIsSingleRange = false;
			boxStartY = this._context.viewLayout.getVerticalOffsetForLineNumber(minLineNumber);
			boxEndY = this._context.viewLayout.getVerticalOffsetForLineNumber(maxLineNumber) + this._lineHeight;
		} else if (range) {
			boxIsSingleRange = true;
			boxStartY = this._context.viewLayout.getVerticalOffsetForLineNumber(range.startLineNumber);
			boxEndY = this._context.viewLayout.getVerticalOffsetForLineNumber(range.endLineNumber) + this._lineHeight;
		} else return -1;
		const shouldIgnoreScrollOff = (source === "mouse" || minimalReveal) && this._cursorSurroundingLinesStyle === "default";
		let paddingTop = 0;
		let paddingBottom = 0;
		if (!shouldIgnoreScrollOff) {
			const maxLinesInViewport = viewportHeight / this._lineHeight;
			const surroundingLines = Math.max(this._cursorSurroundingLines, this._stickyScrollEnabled ? this._maxNumberStickyLines : 0);
			const context = Math.min(maxLinesInViewport / 2, surroundingLines);
			paddingTop = context * this._lineHeight;
			paddingBottom = Math.max(0, context - 1) * this._lineHeight;
		} else if (!minimalReveal) paddingTop = this._lineHeight;
		if (!minimalReveal) {
			if (verticalType === 0 || verticalType === 4) paddingBottom += this._lineHeight;
		}
		boxStartY -= paddingTop;
		boxEndY += paddingBottom;
		let newScrollTop;
		if (boxEndY - boxStartY > viewportHeight) {
			if (!boxIsSingleRange) return -1;
			newScrollTop = boxStartY;
		} else if (verticalType === 5 || verticalType === 6) {
			if (verticalType === 6 && viewportStartY <= boxStartY && boxEndY <= viewportEndY) newScrollTop = viewportStartY;
			else {
				const desiredGapAbove = Math.max(5 * this._lineHeight, viewportHeight * .2);
				const desiredScrollTop = boxStartY - desiredGapAbove;
				const minScrollTop = boxEndY - viewportHeight;
				newScrollTop = Math.max(minScrollTop, desiredScrollTop);
			}
		} else if (verticalType === 1 || verticalType === 2) {
			if (verticalType === 2 && viewportStartY <= boxStartY && boxEndY <= viewportEndY) newScrollTop = viewportStartY;
			else {
				const boxMiddleY = (boxStartY + boxEndY) / 2;
				newScrollTop = Math.max(0, boxMiddleY - viewportHeight / 2);
			}
		} else newScrollTop = this._computeMinimumScrolling(viewportStartY, viewportEndY, boxStartY, boxEndY, verticalType === 3, verticalType === 4);
		return newScrollTop;
	}
	_computeScrollLeftToReveal(horizontalRevealRequest) {
		const viewport = this._context.viewLayout.getCurrentViewport();
		const layoutInfo = this._context.configuration.options.get(166);
		const viewportStartX = viewport.left;
		const viewportEndX = viewportStartX + viewport.width - layoutInfo.verticalScrollbarWidth;
		let boxStartX = 1073741824;
		let boxEndX = 0;
		let hasRTL = false;
		if (horizontalRevealRequest.type === "range") {
			hasRTL = this._lineIsRenderedRTL(horizontalRevealRequest.lineNumber);
			const visibleRanges = this._visibleRangesForLineRange(horizontalRevealRequest.lineNumber, horizontalRevealRequest.startColumn, horizontalRevealRequest.endColumn);
			if (!visibleRanges) return null;
			for (const visibleRange of visibleRanges.ranges) {
				boxStartX = Math.min(boxStartX, Math.round(visibleRange.left));
				boxEndX = Math.max(boxEndX, Math.round(visibleRange.left + visibleRange.width));
			}
		} else for (const selection of horizontalRevealRequest.selections) {
			if (selection.startLineNumber !== selection.endLineNumber) return null;
			const visibleRanges = this._visibleRangesForLineRange(selection.startLineNumber, selection.startColumn, selection.endColumn);
			hasRTL ||= this._lineIsRenderedRTL(selection.startLineNumber);
			if (!visibleRanges) return null;
			for (const visibleRange of visibleRanges.ranges) {
				boxStartX = Math.min(boxStartX, Math.round(visibleRange.left));
				boxEndX = Math.max(boxEndX, Math.round(visibleRange.left + visibleRange.width));
			}
		}
		if (!horizontalRevealRequest.minimalReveal) {
			boxStartX = Math.max(0, boxStartX - ViewLines.HORIZONTAL_EXTRA_PX);
			boxEndX += this._revealHorizontalRightPadding;
		}
		if (horizontalRevealRequest.type === "selections" && boxEndX - boxStartX > viewport.width) return null;
		return {
			scrollLeft: this._computeMinimumScrolling(viewportStartX, viewportEndX, boxStartX, boxEndX),
			maxHorizontalOffset: boxEndX,
			hasRTL
		};
	}
	_computeMinimumScrolling(viewportStart, viewportEnd, boxStart, boxEnd, revealAtStart, revealAtEnd) {
		viewportStart = viewportStart | 0;
		viewportEnd = viewportEnd | 0;
		boxStart = boxStart | 0;
		boxEnd = boxEnd | 0;
		revealAtStart = !!revealAtStart;
		revealAtEnd = !!revealAtEnd;
		const viewportLength = viewportEnd - viewportStart;
		if (boxEnd - boxStart < viewportLength) {
			if (revealAtStart) return boxStart;
			if (revealAtEnd) return Math.max(0, boxEnd - viewportLength);
			if (boxStart < viewportStart) return boxStart;
			else if (boxEnd > viewportEnd) return Math.max(0, boxEnd - viewportLength);
		} else return boxStart;
		return viewportStart;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/linesDecorations/linesDecorations.js
var LinesDecorationsOverlay = class extends DedupOverlay {
	constructor(context) {
		super();
		this._context = context;
		const layoutInfo = this._context.configuration.options.get(166);
		this._decorationsLeft = layoutInfo.decorationsLeft;
		this._decorationsWidth = layoutInfo.decorationsWidth;
		this._renderResult = null;
		this._context.addEventHandler(this);
	}
	dispose() {
		this._context.removeEventHandler(this);
		this._renderResult = null;
		super.dispose();
	}
	onConfigurationChanged(e) {
		const layoutInfo = this._context.configuration.options.get(166);
		this._decorationsLeft = layoutInfo.decorationsLeft;
		this._decorationsWidth = layoutInfo.decorationsWidth;
		return true;
	}
	onDecorationsChanged(e) {
		return true;
	}
	onFlushed(e) {
		return true;
	}
	onLinesChanged(e) {
		return true;
	}
	onLinesDeleted(e) {
		return true;
	}
	onLinesInserted(e) {
		return true;
	}
	onScrollChanged(e) {
		return e.scrollTopChanged;
	}
	onZonesChanged(e) {
		return true;
	}
	_getDecorations(ctx) {
		const decorations = ctx.getDecorationsInViewport();
		const r = [];
		let rLen = 0;
		for (let i = 0, len = decorations.length; i < len; i++) {
			const d = decorations[i];
			const linesDecorationsClassName = d.options.linesDecorationsClassName;
			const zIndex = d.options.zIndex;
			if (linesDecorationsClassName) r[rLen++] = new DecorationToRender(d.range.startLineNumber, d.range.endLineNumber, linesDecorationsClassName, d.options.linesDecorationsTooltip ?? null, zIndex);
			const firstLineDecorationClassName = d.options.firstLineDecorationClassName;
			if (firstLineDecorationClassName) r[rLen++] = new DecorationToRender(d.range.startLineNumber, d.range.startLineNumber, firstLineDecorationClassName, d.options.linesDecorationsTooltip ?? null, zIndex);
		}
		return r;
	}
	prepareRender(ctx) {
		const visibleStartLineNumber = ctx.visibleRange.startLineNumber;
		const visibleEndLineNumber = ctx.visibleRange.endLineNumber;
		const toRender = this._render(visibleStartLineNumber, visibleEndLineNumber, this._getDecorations(ctx));
		const left = this._decorationsLeft.toString();
		const width = this._decorationsWidth.toString();
		const common = "\" style=\"left:" + left + "px;width:" + width + "px;\"></div>";
		const output = [];
		for (let lineNumber = visibleStartLineNumber; lineNumber <= visibleEndLineNumber; lineNumber++) {
			const lineIndex = lineNumber - visibleStartLineNumber;
			const decorations = toRender[lineIndex].getDecorations();
			let lineOutput = "";
			for (const decoration of decorations) {
				let addition = "<div class=\"cldr " + decoration.className;
				if (decoration.tooltip !== null) addition += "\" title=\"" + decoration.tooltip;
				addition += common;
				lineOutput += addition;
			}
			output[lineIndex] = lineOutput;
		}
		this._renderResult = output;
	}
	render(startLineNumber, lineNumber) {
		if (!this._renderResult) return "";
		return this._renderResult[lineNumber - startLineNumber];
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/margin/margin.js
/**
* Margin is a vertical strip located on the left of the editor's content area.
* It is used for various features such as line numbers, folding markers, and
* decorations that provide additional information about the lines of code.
*/
var Margin = class Margin extends ViewPart {
	static {
		this.CLASS_NAME = "glyph-margin";
	}
	static {
		this.OUTER_CLASS_NAME = "margin";
	}
	constructor(context) {
		super(context);
		const options = this._context.configuration.options;
		const layoutInfo = options.get(166);
		this._canUseLayerHinting = !options.get(39);
		this._contentLeft = layoutInfo.contentLeft;
		this._glyphMarginLeft = layoutInfo.glyphMarginLeft;
		this._glyphMarginWidth = layoutInfo.glyphMarginWidth;
		this._domNode = createFastDomNode(document.createElement("div"));
		this._domNode.setClassName(Margin.OUTER_CLASS_NAME);
		this._domNode.setPosition("absolute");
		this._domNode.setAttribute("role", "presentation");
		this._domNode.setAttribute("aria-hidden", "true");
		this._glyphMarginBackgroundDomNode = createFastDomNode(document.createElement("div"));
		this._glyphMarginBackgroundDomNode.setClassName(Margin.CLASS_NAME);
		this._domNode.appendChild(this._glyphMarginBackgroundDomNode);
	}
	getDomNode() {
		return this._domNode;
	}
	onConfigurationChanged(e) {
		const options = this._context.configuration.options;
		const layoutInfo = options.get(166);
		this._canUseLayerHinting = !options.get(39);
		this._contentLeft = layoutInfo.contentLeft;
		this._glyphMarginLeft = layoutInfo.glyphMarginLeft;
		this._glyphMarginWidth = layoutInfo.glyphMarginWidth;
		return true;
	}
	onScrollChanged(e) {
		return super.onScrollChanged(e) || e.scrollTopChanged;
	}
	prepareRender(ctx) {}
	render(ctx) {
		this._domNode.setLayerHinting(this._canUseLayerHinting);
		this._domNode.setContain("strict");
		const adjustedScrollTop = ctx.scrollTop - ctx.bigNumbersDelta;
		this._domNode.setTop(-adjustedScrollTop);
		const height = Math.min(ctx.scrollHeight, 1e6);
		this._domNode.setHeight(height);
		this._domNode.setWidth(this._contentLeft);
		this._glyphMarginBackgroundDomNode.setLeft(this._glyphMarginLeft);
		this._glyphMarginBackgroundDomNode.setWidth(this._glyphMarginWidth);
		this._glyphMarginBackgroundDomNode.setHeight(height);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/marginDecorations/marginDecorations.js
var MarginViewLineDecorationsOverlay = class extends DedupOverlay {
	constructor(context) {
		super();
		this._context = context;
		this._renderResult = null;
		this._context.addEventHandler(this);
	}
	dispose() {
		this._context.removeEventHandler(this);
		this._renderResult = null;
		super.dispose();
	}
	onConfigurationChanged(e) {
		return true;
	}
	onDecorationsChanged(e) {
		return true;
	}
	onFlushed(e) {
		return true;
	}
	onLinesChanged(e) {
		return true;
	}
	onLinesDeleted(e) {
		return true;
	}
	onLinesInserted(e) {
		return true;
	}
	onScrollChanged(e) {
		return e.scrollTopChanged;
	}
	onZonesChanged(e) {
		return true;
	}
	_getDecorations(ctx) {
		const decorations = ctx.getDecorationsInViewport();
		const r = [];
		let rLen = 0;
		for (let i = 0, len = decorations.length; i < len; i++) {
			const d = decorations[i];
			const marginClassName = d.options.marginClassName;
			const zIndex = d.options.zIndex;
			if (marginClassName) r[rLen++] = new DecorationToRender(d.range.startLineNumber, d.range.endLineNumber, marginClassName, null, zIndex);
		}
		return r;
	}
	prepareRender(ctx) {
		const visibleStartLineNumber = ctx.visibleRange.startLineNumber;
		const visibleEndLineNumber = ctx.visibleRange.endLineNumber;
		const toRender = this._render(visibleStartLineNumber, visibleEndLineNumber, this._getDecorations(ctx));
		const output = [];
		for (let lineNumber = visibleStartLineNumber; lineNumber <= visibleEndLineNumber; lineNumber++) {
			const lineIndex = lineNumber - visibleStartLineNumber;
			const decorations = toRender[lineIndex].getDecorations();
			let lineOutput = "";
			for (const decoration of decorations) lineOutput += "<div class=\"cmdr " + decoration.className + "\" style=\"\"></div>";
			output[lineIndex] = lineOutput;
		}
		this._renderResult = output;
	}
	render(startLineNumber, lineNumber) {
		if (!this._renderResult) return "";
		return this._renderResult[lineNumber - startLineNumber];
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/core/misc/rgba.js
/**
* A very VM friendly rgba datastructure.
* Please don't touch unless you take a look at the IR.
*/
var RGBA8 = class RGBA8 {
	static {
		this.Empty = new RGBA8(0, 0, 0, 0);
	}
	constructor(r, g, b, a) {
		this._rgba8Brand = void 0;
		this.r = RGBA8._clamp(r);
		this.g = RGBA8._clamp(g);
		this.b = RGBA8._clamp(b);
		this.a = RGBA8._clamp(a);
	}
	equals(other) {
		return this.r === other.r && this.g === other.g && this.b === other.b && this.a === other.a;
	}
	static _clamp(c) {
		if (c < 0) return 0;
		if (c > 255) return 255;
		return c | 0;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/viewModel/minimapTokensColorTracker.js
var MinimapTokensColorTracker = class MinimapTokensColorTracker extends Disposable {
	static {
		this._INSTANCE = null;
	}
	static getInstance() {
		if (!this._INSTANCE) this._INSTANCE = markAsSingleton(new MinimapTokensColorTracker());
		return this._INSTANCE;
	}
	constructor() {
		super();
		this._onDidChange = this._register(new Emitter$1());
		this.onDidChange = this._onDidChange.event;
		this._updateColorMap();
		this._register(TokenizationRegistry.onDidChange((e) => {
			if (e.changedColorMap) this._updateColorMap();
		}));
	}
	_updateColorMap() {
		const colorMap = TokenizationRegistry.getColorMap();
		if (!colorMap) {
			this._colors = [];
			for (let i = 0; i <= 2; i++) this._colors[i] = RGBA8.Empty;
			this._backgroundIsLight = true;
			return;
		}
		this._colors = [RGBA8.Empty];
		for (let colorId = 1; colorId < colorMap.length; colorId++) {
			const source = colorMap[colorId].rgba;
			this._colors[colorId] = new RGBA8(source.r, source.g, source.b, Math.round(source.a * 255));
		}
		const backgroundLuminosity = colorMap[2].getRelativeLuminance();
		this._backgroundIsLight = backgroundLuminosity >= .5;
		this._onDidChange.fire(void 0);
	}
	getColor(colorId) {
		if (colorId < 1 || colorId >= this._colors.length) colorId = 2;
		let color = this._colors[colorId];
		if (!color) {
			onUnexpectedError(new BugIndicatingError(`Missing color for colorId ${colorId}`));
			color = RGBA8.Empty;
		}
		return color;
	}
	backgroundIsLight() {
		return this._backgroundIsLight;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/minimap/minimapCharSheet.js
var allCharCodes = (() => {
	const v = [];
	for (let i = 32; i <= 126; i++) v.push(i);
	v.push(65533);
	return v;
})();
var getCharIndex = (chCode, fontScale) => {
	chCode -= 32;
	if (chCode < 0 || chCode > 96) {
		if (fontScale <= 2) return (chCode + 96) % 96;
		return 95;
	}
	return chCode;
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/minimap/minimapCharRenderer.js
var MinimapCharRenderer = class MinimapCharRenderer {
	constructor(charData, scale) {
		this.scale = scale;
		this._minimapCharRendererBrand = void 0;
		this.charDataNormal = MinimapCharRenderer.soften(charData, 12 / 15);
		this.charDataLight = MinimapCharRenderer.soften(charData, 50 / 60);
	}
	static soften(input, ratio) {
		const result = new Uint8ClampedArray(input.length);
		for (let i = 0, len = input.length; i < len; i++) result[i] = toUint8(input[i] * ratio);
		return result;
	}
	renderChar(target, dx, dy, chCode, color, foregroundAlpha, backgroundColor, backgroundAlpha, fontScale, useLighterFont, force1pxHeight) {
		const charWidth = 1 * this.scale;
		const charHeight = 2 * this.scale;
		const renderHeight = force1pxHeight ? 1 : charHeight;
		if (dx + charWidth > target.width || dy + renderHeight > target.height) {
			console.warn("bad render request outside image data");
			return;
		}
		const charData = useLighterFont ? this.charDataLight : this.charDataNormal;
		const charIndex = getCharIndex(chCode, fontScale);
		const destWidth = target.width * 4;
		const backgroundR = backgroundColor.r;
		const backgroundG = backgroundColor.g;
		const backgroundB = backgroundColor.b;
		const deltaR = color.r - backgroundR;
		const deltaG = color.g - backgroundG;
		const deltaB = color.b - backgroundB;
		const destAlpha = Math.max(foregroundAlpha, backgroundAlpha);
		const dest = target.data;
		let sourceOffset = charIndex * charWidth * charHeight;
		let row = dy * destWidth + dx * 4;
		for (let y = 0; y < renderHeight; y++) {
			let column = row;
			for (let x = 0; x < charWidth; x++) {
				const c = charData[sourceOffset++] / 255 * (foregroundAlpha / 255);
				dest[column++] = backgroundR + deltaR * c;
				dest[column++] = backgroundG + deltaG * c;
				dest[column++] = backgroundB + deltaB * c;
				dest[column++] = destAlpha;
			}
			row += destWidth;
		}
	}
	blockRenderChar(target, dx, dy, color, foregroundAlpha, backgroundColor, backgroundAlpha, force1pxHeight) {
		const charWidth = 1 * this.scale;
		const charHeight = 2 * this.scale;
		const renderHeight = force1pxHeight ? 1 : charHeight;
		if (dx + charWidth > target.width || dy + renderHeight > target.height) {
			console.warn("bad render request outside image data");
			return;
		}
		const destWidth = target.width * 4;
		const c = .5 * (foregroundAlpha / 255);
		const backgroundR = backgroundColor.r;
		const backgroundG = backgroundColor.g;
		const backgroundB = backgroundColor.b;
		const deltaR = color.r - backgroundR;
		const deltaG = color.g - backgroundG;
		const deltaB = color.b - backgroundB;
		const colorR = backgroundR + deltaR * c;
		const colorG = backgroundG + deltaG * c;
		const colorB = backgroundB + deltaB * c;
		const destAlpha = Math.max(foregroundAlpha, backgroundAlpha);
		const dest = target.data;
		let row = dy * destWidth + dx * 4;
		for (let y = 0; y < renderHeight; y++) {
			let column = row;
			for (let x = 0; x < charWidth; x++) {
				dest[column++] = colorR;
				dest[column++] = colorG;
				dest[column++] = colorB;
				dest[column++] = destAlpha;
			}
			row += destWidth;
		}
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/minimap/minimapPreBaked.js
var charTable = {
	"0": 0,
	"1": 1,
	"2": 2,
	"3": 3,
	"4": 4,
	"5": 5,
	"6": 6,
	"7": 7,
	"8": 8,
	"9": 9,
	A: 10,
	B: 11,
	C: 12,
	D: 13,
	E: 14,
	F: 15
};
var decodeData = (str) => {
	const output = new Uint8ClampedArray(str.length / 2);
	for (let i = 0; i < str.length; i += 2) output[i >> 1] = charTable[str[i]] << 4 | charTable[str[i + 1]] & 15;
	return output;
};
/**
* Map of minimap scales to prebaked sample data at those scales. We don't
* sample much larger data, because then font family becomes visible, which
* is use-configurable.
*/
var prebakedMiniMaps = {
	1: createSingleCallFunction(() => decodeData("0000511D6300CF609C709645A78432005642574171487021003C451900274D35D762755E8B629C5BA856AF57BA649530C167D1512A272A3F6038604460398526BCA2A968DB6F8957C768BE5FBE2FB467CF5D8D5B795DC7625B5DFF50DE64C466DB2FC47CD860A65E9A2EB96CB54CE06DA763AB2EA26860524D3763536601005116008177A8705E53AB738E6A982F88BAA35B5F5B626D9C636B449B737E5B7B678598869A662F6B5B8542706C704C80736A607578685B70594A49715A4522E792")),
	2: createSingleCallFunction(() => decodeData("000000000000000055394F383D2800008B8B1F210002000081B1CBCBCC820000847AAF6B9AAF2119BE08B8881AD60000A44FD07DCCF107015338130C00000000385972265F390B406E2437634B4B48031B12B8A0847000001E15B29A402F0000000000004B33460B00007A752C2A0000000000004D3900000084394B82013400ABA5CFC7AD9C0302A45A3E5A98AB000089A43382D97900008BA54AA087A70A0248A6A7AE6DBE0000BF6F94987EA40A01A06DCFA7A7A9030496C32F77891D0000A99FB1A0AFA80603B29AB9CA75930D010C0948354D3900000C0948354F37460D0028BE673D8400000000AF9D7B6E00002B007AA8933400007AA642675C2700007984CFB9C3985B768772A8A6B7B20000CAAECAAFC4B700009F94A6009F840009D09F9BA4CA9C0000CC8FC76DC87F0000C991C472A2000000A894A48CA7B501079BA2C9C69BA20000B19A5D3FA89000005CA6009DA2960901B0A7F0669FB200009D009E00B7890000DAD0F5D092820000D294D4C48BD10000B5A7A4A3B1A50402CAB6CBA6A2000000B5A7A4A3B1A8044FCDADD19D9CB00000B7778F7B8AAE0803C9AB5D3F5D3F00009EA09EA0BAB006039EA0989A8C7900009B9EF4D6B7C00000A9A7816CACA80000ABAC84705D3F000096DA635CDC8C00006F486F266F263D4784006124097B00374F6D2D6D2D6D4A3A95872322000000030000000000008D8939130000000000002E22A5C9CBC70600AB25C0B5C9B400061A2DB04CA67001082AA6BEBEBFC606002321DACBC19E03087AA08B6768380000282FBAC0B8CA7A88AD25BBA5A29900004C396C5894A6000040485A6E356E9442A32CD17EADA70000B4237923628600003E2DE9C1D7B500002F25BBA5A2990000231DB6AFB4A804023025C0B5CAB588062B2CBDBEC0C706882435A75CA20000002326BD6A82A908048B4B9A5A668000002423A09CB4BB060025259C9D8A7900001C1FCAB2C7C700002A2A9387ABA200002626A4A47D6E9D14333163A0C87500004B6F9C2D643A257049364936493647358A34438355497F1A0000A24C1D590000D38DFFBDD4CD3126"))
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/minimap/minimapCharRendererFactory.js
/**
* Creates character renderers. It takes a 'scale' that determines how large
* characters should be drawn. Using this, it draws data into a canvas and
* then downsamples the characters as necessary for the current display.
* This makes rendering more efficient, rather than drawing a full (tiny)
* font, or downsampling in real-time.
*/
var MinimapCharRendererFactory = class MinimapCharRendererFactory {
	/**
	* Creates a new character renderer factory with the given scale.
	*/
	static create(scale, fontFamily) {
		if (this.lastCreated && scale === this.lastCreated.scale && fontFamily === this.lastFontFamily) return this.lastCreated;
		let factory;
		if (prebakedMiniMaps[scale]) factory = new MinimapCharRenderer(prebakedMiniMaps[scale](), scale);
		else factory = MinimapCharRendererFactory.createFromSampleData(MinimapCharRendererFactory.createSampleData(fontFamily).data, scale);
		this.lastFontFamily = fontFamily;
		this.lastCreated = factory;
		return factory;
	}
	/**
	* Creates the font sample data, writing to a canvas.
	*/
	static createSampleData(fontFamily) {
		const canvas = document.createElement("canvas");
		const ctx = canvas.getContext("2d");
		canvas.style.height = `16px`;
		canvas.height = 16;
		canvas.width = 960;
		canvas.style.width = "960px";
		ctx.fillStyle = "#ffffff";
		ctx.font = `bold 16px ${fontFamily}`;
		ctx.textBaseline = "middle";
		let x = 0;
		for (const code of allCharCodes) {
			ctx.fillText(String.fromCharCode(code), x, 8);
			x += 10;
		}
		return ctx.getImageData(0, 0, 960, 16);
	}
	/**
	* Creates a character renderer from the canvas sample data.
	*/
	static createFromSampleData(source, scale) {
		if (source.length !== 61440) throw new Error("Unexpected source in MinimapCharRenderer");
		return new MinimapCharRenderer(MinimapCharRendererFactory._downsample(source, scale), scale);
	}
	static _downsampleChar(source, sourceOffset, dest, destOffset, scale) {
		const width = 1 * scale;
		const height = 2 * scale;
		let targetIndex = destOffset;
		let brightest = 0;
		for (let y = 0; y < height; y++) {
			const sourceY1 = y / height * 16;
			const sourceY2 = (y + 1) / height * 16;
			for (let x = 0; x < width; x++) {
				const sourceX1 = x / width * 10;
				const sourceX2 = (x + 1) / width * 10;
				let value = 0;
				let samples = 0;
				for (let sy = sourceY1; sy < sourceY2; sy++) {
					const sourceRow = sourceOffset + Math.floor(sy) * 3840;
					const yBalance = 1 - (sy - Math.floor(sy));
					for (let sx = sourceX1; sx < sourceX2; sx++) {
						const xBalance = 1 - (sx - Math.floor(sx));
						const sourceIndex = sourceRow + Math.floor(sx) * 4;
						const weight = xBalance * yBalance;
						samples += weight;
						value += source[sourceIndex] * source[sourceIndex + 3] / 255 * weight;
					}
				}
				const final = value / samples;
				brightest = Math.max(brightest, final);
				dest[targetIndex++] = toUint8(final);
			}
		}
		return brightest;
	}
	static _downsample(data, scale) {
		const pixelsPerCharacter = 2 * scale * 1 * scale;
		const resultLen = pixelsPerCharacter * 96;
		const result = new Uint8ClampedArray(resultLen);
		let resultOffset = 0;
		let sourceOffset = 0;
		let brightest = 0;
		for (let charIndex = 0; charIndex < 96; charIndex++) {
			brightest = Math.max(brightest, this._downsampleChar(data, sourceOffset, result, resultOffset, scale));
			resultOffset += pixelsPerCharacter;
			sourceOffset += 40;
		}
		if (brightest > 0) {
			const adjust = 255 / brightest;
			for (let i = 0; i < resultLen; i++) result[i] *= adjust;
		}
		return result;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/fonts.js
/**
* The best font-family to be used in CSS based on the platform:
* - Windows: Segoe preferred, fallback to sans-serif
* - macOS: standard system font, fallback to sans-serif
* - Linux: standard system font preferred, fallback to Ubuntu fonts
*
* Note: this currently does not adjust for different locales.
*/
var DEFAULT_FONT_FAMILY = isWindows ? "\"Segoe WPC\", \"Segoe UI\", sans-serif" : isMacintosh ? "-apple-system, BlinkMacSystemFont, sans-serif" : "system-ui, \"Ubuntu\", \"Droid Sans\", sans-serif";
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/viewModel/viewModelDecoration.js
var ViewModelDecoration = class {
	constructor(range, options) {
		this._viewModelDecorationBrand = void 0;
		this.range = range;
		this.options = options;
	}
};
function isModelDecorationVisible(model, decoration) {
	if (decoration.options.hideInCommentTokens && isModelDecorationInComment(model, decoration)) return false;
	if (decoration.options.hideInStringTokens && isModelDecorationInString(model, decoration)) return false;
	return true;
}
function isModelDecorationInComment(model, decoration) {
	return testTokensInRange(model, decoration.range, (tokenType) => tokenType === 1);
}
function isModelDecorationInString(model, decoration) {
	return testTokensInRange(model, decoration.range, (tokenType) => tokenType === 2);
}
/**
* Calls the callback for every token that intersects the range.
* If the callback returns `false`, iteration stops and `false` is returned.
* Otherwise, `true` is returned.
*/
function testTokensInRange(model, range, callback) {
	for (let lineNumber = range.startLineNumber; lineNumber <= range.endLineNumber; lineNumber++) {
		const lineTokens = model.tokenization.getLineTokens(lineNumber);
		const isFirstLine = lineNumber === range.startLineNumber;
		const isEndLine = lineNumber === range.endLineNumber;
		let tokenIdx = isFirstLine ? lineTokens.findTokenIndexAtOffset(range.startColumn - 1) : 0;
		while (tokenIdx < lineTokens.getCount()) {
			if (isEndLine) {
				if (lineTokens.getStartOffset(tokenIdx) > range.endColumn - 1) break;
			}
			if (!callback(lineTokens.getStandardTokenType(tokenIdx))) return false;
			tokenIdx++;
		}
	}
	return true;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/minimap/minimap.js
/**
* The orthogonal distance to the slider at which dragging "resets". This implements "snapping"
*/
var POINTER_DRAG_RESET_DISTANCE = 140;
var GUTTER_DECORATION_WIDTH = 2;
var MinimapOptions = class MinimapOptions {
	constructor(configuration, theme, tokensColorTracker) {
		const options = configuration.options;
		const pixelRatio = options.get(164);
		const layoutInfo = options.get(166);
		const minimapLayout = layoutInfo.minimap;
		const fontInfo = options.get(59);
		const minimapOpts = options.get(81);
		this.renderMinimap = minimapLayout.renderMinimap;
		this.size = minimapOpts.size;
		this.minimapHeightIsEditorHeight = minimapLayout.minimapHeightIsEditorHeight;
		this.scrollBeyondLastLine = options.get(119);
		this.paddingTop = options.get(96).top;
		this.paddingBottom = options.get(96).bottom;
		this.showSlider = minimapOpts.showSlider;
		this.autohide = minimapOpts.autohide;
		this.pixelRatio = pixelRatio;
		this.typicalHalfwidthCharacterWidth = fontInfo.typicalHalfwidthCharacterWidth;
		this.lineHeight = options.get(75);
		this.minimapLeft = minimapLayout.minimapLeft;
		this.minimapWidth = minimapLayout.minimapWidth;
		this.minimapHeight = layoutInfo.height;
		this.canvasInnerWidth = minimapLayout.minimapCanvasInnerWidth;
		this.canvasInnerHeight = minimapLayout.minimapCanvasInnerHeight;
		this.canvasOuterWidth = minimapLayout.minimapCanvasOuterWidth;
		this.canvasOuterHeight = minimapLayout.minimapCanvasOuterHeight;
		this.isSampling = minimapLayout.minimapIsSampling;
		this.editorHeight = layoutInfo.height;
		this.fontScale = minimapLayout.minimapScale;
		this.minimapLineHeight = minimapLayout.minimapLineHeight;
		this.minimapCharWidth = 1 * this.fontScale;
		this.sectionHeaderFontFamily = DEFAULT_FONT_FAMILY;
		this.sectionHeaderFontSize = minimapOpts.sectionHeaderFontSize * pixelRatio;
		this.sectionHeaderLetterSpacing = minimapOpts.sectionHeaderLetterSpacing;
		this.sectionHeaderFontColor = MinimapOptions._getSectionHeaderColor(theme, tokensColorTracker.getColor(1));
		this.charRenderer = createSingleCallFunction(() => MinimapCharRendererFactory.create(this.fontScale, fontInfo.fontFamily));
		this.defaultBackgroundColor = tokensColorTracker.getColor(2);
		this.backgroundColor = MinimapOptions._getMinimapBackground(theme, this.defaultBackgroundColor);
		this.foregroundAlpha = MinimapOptions._getMinimapForegroundOpacity(theme);
	}
	static _getMinimapBackground(theme, defaultBackgroundColor) {
		const themeColor = theme.getColor(minimapBackground);
		if (themeColor) return new RGBA8(themeColor.rgba.r, themeColor.rgba.g, themeColor.rgba.b, Math.round(255 * themeColor.rgba.a));
		return defaultBackgroundColor;
	}
	static _getMinimapForegroundOpacity(theme) {
		const themeColor = theme.getColor(minimapForegroundOpacity);
		if (themeColor) return RGBA8._clamp(Math.round(255 * themeColor.rgba.a));
		return 255;
	}
	static _getSectionHeaderColor(theme, defaultForegroundColor) {
		const themeColor = theme.getColor(editorForeground);
		if (themeColor) return new RGBA8(themeColor.rgba.r, themeColor.rgba.g, themeColor.rgba.b, Math.round(255 * themeColor.rgba.a));
		return defaultForegroundColor;
	}
	equals(other) {
		return this.renderMinimap === other.renderMinimap && this.size === other.size && this.minimapHeightIsEditorHeight === other.minimapHeightIsEditorHeight && this.scrollBeyondLastLine === other.scrollBeyondLastLine && this.paddingTop === other.paddingTop && this.paddingBottom === other.paddingBottom && this.showSlider === other.showSlider && this.autohide === other.autohide && this.pixelRatio === other.pixelRatio && this.typicalHalfwidthCharacterWidth === other.typicalHalfwidthCharacterWidth && this.lineHeight === other.lineHeight && this.minimapLeft === other.minimapLeft && this.minimapWidth === other.minimapWidth && this.minimapHeight === other.minimapHeight && this.canvasInnerWidth === other.canvasInnerWidth && this.canvasInnerHeight === other.canvasInnerHeight && this.canvasOuterWidth === other.canvasOuterWidth && this.canvasOuterHeight === other.canvasOuterHeight && this.isSampling === other.isSampling && this.editorHeight === other.editorHeight && this.fontScale === other.fontScale && this.minimapLineHeight === other.minimapLineHeight && this.minimapCharWidth === other.minimapCharWidth && this.sectionHeaderFontSize === other.sectionHeaderFontSize && this.sectionHeaderLetterSpacing === other.sectionHeaderLetterSpacing && this.defaultBackgroundColor && this.defaultBackgroundColor.equals(other.defaultBackgroundColor) && this.backgroundColor && this.backgroundColor.equals(other.backgroundColor) && this.foregroundAlpha === other.foregroundAlpha;
	}
};
var MinimapLayout = class MinimapLayout {
	constructor(scrollTop, scrollHeight, sliderNeeded, _computedSliderRatio, sliderTop, sliderHeight, topPaddingLineCount, startLineNumber, endLineNumber) {
		this.scrollTop = scrollTop;
		this.scrollHeight = scrollHeight;
		this.sliderNeeded = sliderNeeded;
		this._computedSliderRatio = _computedSliderRatio;
		this.sliderTop = sliderTop;
		this.sliderHeight = sliderHeight;
		this.topPaddingLineCount = topPaddingLineCount;
		this.startLineNumber = startLineNumber;
		this.endLineNumber = endLineNumber;
	}
	/**
	* Compute a desired `scrollPosition` such that the slider moves by `delta`.
	*/
	getDesiredScrollTopFromDelta(delta) {
		return Math.round(this.scrollTop + delta / this._computedSliderRatio);
	}
	getDesiredScrollTopFromTouchLocation(pageY) {
		return Math.round((pageY - this.sliderHeight / 2) / this._computedSliderRatio);
	}
	/**
	* Intersect a line range with `this.startLineNumber` and `this.endLineNumber`.
	*/
	intersectWithViewport(range) {
		const startLineNumber = Math.max(this.startLineNumber, range.startLineNumber);
		const endLineNumber = Math.min(this.endLineNumber, range.endLineNumber);
		if (startLineNumber > endLineNumber) return null;
		return [startLineNumber, endLineNumber];
	}
	/**
	* Get the inner minimap y coordinate for a line number.
	*/
	getYForLineNumber(lineNumber, minimapLineHeight) {
		return +(lineNumber - this.startLineNumber + this.topPaddingLineCount) * minimapLineHeight;
	}
	static create(options, viewportStartLineNumber, viewportEndLineNumber, viewportStartLineNumberVerticalOffset, viewportHeight, viewportContainsWhitespaceGaps, lineCount, realLineCount, scrollTop, scrollHeight, previousLayout) {
		const pixelRatio = options.pixelRatio;
		const minimapLineHeight = options.minimapLineHeight;
		const minimapLinesFitting = Math.floor(options.canvasInnerHeight / minimapLineHeight);
		const lineHeight = options.lineHeight;
		if (options.minimapHeightIsEditorHeight) {
			let logicalScrollHeight = realLineCount * options.lineHeight + options.paddingTop + options.paddingBottom;
			if (options.scrollBeyondLastLine) logicalScrollHeight += Math.max(0, viewportHeight - options.lineHeight - options.paddingBottom);
			const sliderHeight = Math.max(1, Math.floor(viewportHeight * viewportHeight / logicalScrollHeight));
			const maxMinimapSliderTop = Math.max(0, options.minimapHeight - sliderHeight);
			const computedSliderRatio = maxMinimapSliderTop / (scrollHeight - viewportHeight);
			const sliderTop = scrollTop * computedSliderRatio;
			const sliderNeeded = maxMinimapSliderTop > 0;
			const maxLinesFitting = Math.floor(options.canvasInnerHeight / options.minimapLineHeight);
			const topPaddingLineCount = Math.floor(options.paddingTop / options.lineHeight);
			return new MinimapLayout(scrollTop, scrollHeight, sliderNeeded, computedSliderRatio, sliderTop, sliderHeight, topPaddingLineCount, 1, Math.min(lineCount, maxLinesFitting));
		}
		let sliderHeight;
		if (viewportContainsWhitespaceGaps && viewportEndLineNumber !== lineCount) {
			const viewportLineCount = viewportEndLineNumber - viewportStartLineNumber + 1;
			sliderHeight = Math.floor(viewportLineCount * minimapLineHeight / pixelRatio);
		} else {
			const expectedViewportLineCount = viewportHeight / lineHeight;
			sliderHeight = Math.floor(expectedViewportLineCount * minimapLineHeight / pixelRatio);
		}
		const extraLinesAtTheTop = Math.floor(options.paddingTop / lineHeight);
		let extraLinesAtTheBottom = Math.floor(options.paddingBottom / lineHeight);
		if (options.scrollBeyondLastLine) {
			const expectedViewportLineCount = viewportHeight / lineHeight;
			extraLinesAtTheBottom = Math.max(extraLinesAtTheBottom, expectedViewportLineCount - 1);
		}
		let maxMinimapSliderTop;
		if (extraLinesAtTheBottom > 0) {
			const expectedViewportLineCount = viewportHeight / lineHeight;
			maxMinimapSliderTop = (extraLinesAtTheTop + lineCount + extraLinesAtTheBottom - expectedViewportLineCount - 1) * minimapLineHeight / pixelRatio;
		} else maxMinimapSliderTop = Math.max(0, (extraLinesAtTheTop + lineCount) * minimapLineHeight / pixelRatio - sliderHeight);
		maxMinimapSliderTop = Math.min(options.minimapHeight - sliderHeight, maxMinimapSliderTop);
		const computedSliderRatio = maxMinimapSliderTop / (scrollHeight - viewportHeight);
		const sliderTop = scrollTop * computedSliderRatio;
		if (minimapLinesFitting >= extraLinesAtTheTop + lineCount + extraLinesAtTheBottom) return new MinimapLayout(scrollTop, scrollHeight, maxMinimapSliderTop > 0, computedSliderRatio, sliderTop, sliderHeight, extraLinesAtTheTop, 1, lineCount);
		else {
			let consideringStartLineNumber;
			if (viewportStartLineNumber > 1) consideringStartLineNumber = viewportStartLineNumber + extraLinesAtTheTop;
			else consideringStartLineNumber = Math.max(1, scrollTop / lineHeight);
			let topPaddingLineCount;
			let startLineNumber = Math.max(1, Math.floor(consideringStartLineNumber - sliderTop * pixelRatio / minimapLineHeight));
			if (startLineNumber < extraLinesAtTheTop) {
				topPaddingLineCount = extraLinesAtTheTop - startLineNumber + 1;
				startLineNumber = 1;
			} else {
				topPaddingLineCount = 0;
				startLineNumber = Math.max(1, startLineNumber - extraLinesAtTheTop);
			}
			if (previousLayout && previousLayout.scrollHeight === scrollHeight) {
				if (previousLayout.scrollTop > scrollTop) {
					startLineNumber = Math.min(startLineNumber, previousLayout.startLineNumber);
					topPaddingLineCount = Math.max(topPaddingLineCount, previousLayout.topPaddingLineCount);
				}
				if (previousLayout.scrollTop < scrollTop) {
					startLineNumber = Math.max(startLineNumber, previousLayout.startLineNumber);
					topPaddingLineCount = Math.min(topPaddingLineCount, previousLayout.topPaddingLineCount);
				}
			}
			const endLineNumber = Math.min(lineCount, startLineNumber - topPaddingLineCount + minimapLinesFitting - 1);
			const partialLine = (scrollTop - viewportStartLineNumberVerticalOffset) / lineHeight;
			let sliderTopAligned;
			if (scrollTop >= options.paddingTop) sliderTopAligned = (viewportStartLineNumber - startLineNumber + topPaddingLineCount + partialLine) * minimapLineHeight / pixelRatio;
			else sliderTopAligned = scrollTop / options.paddingTop * (topPaddingLineCount + partialLine) * minimapLineHeight / pixelRatio;
			return new MinimapLayout(scrollTop, scrollHeight, true, computedSliderRatio, sliderTopAligned, sliderHeight, topPaddingLineCount, startLineNumber, endLineNumber);
		}
	}
};
var MinimapLine = class MinimapLine {
	static {
		this.INVALID = new MinimapLine(-1);
	}
	constructor(dy) {
		this.dy = dy;
	}
	onContentChanged() {
		this.dy = -1;
	}
	onTokensChanged() {
		this.dy = -1;
	}
};
var RenderData = class {
	constructor(renderedLayout, imageData, lines) {
		this.renderedLayout = renderedLayout;
		this._imageData = imageData;
		this._renderedLines = new RenderedLinesCollection({ createLine: () => MinimapLine.INVALID });
		this._renderedLines._set(renderedLayout.startLineNumber, lines);
	}
	/**
	* Check if the current RenderData matches accurately the new desired layout and no painting is needed.
	*/
	linesEquals(layout) {
		if (!this.scrollEquals(layout)) return false;
		const lines = this._renderedLines._get().lines;
		for (let i = 0, len = lines.length; i < len; i++) if (lines[i].dy === -1) return false;
		return true;
	}
	/**
	* Check if the current RenderData matches the new layout's scroll position
	*/
	scrollEquals(layout) {
		return this.renderedLayout.startLineNumber === layout.startLineNumber && this.renderedLayout.endLineNumber === layout.endLineNumber;
	}
	_get() {
		const tmp = this._renderedLines._get();
		return {
			imageData: this._imageData,
			rendLineNumberStart: tmp.rendLineNumberStart,
			lines: tmp.lines
		};
	}
	onLinesChanged(changeFromLineNumber, changeCount) {
		return this._renderedLines.onLinesChanged(changeFromLineNumber, changeCount);
	}
	onLinesDeleted(deleteFromLineNumber, deleteToLineNumber) {
		this._renderedLines.onLinesDeleted(deleteFromLineNumber, deleteToLineNumber);
	}
	onLinesInserted(insertFromLineNumber, insertToLineNumber) {
		this._renderedLines.onLinesInserted(insertFromLineNumber, insertToLineNumber);
	}
	onTokensChanged(ranges) {
		return this._renderedLines.onTokensChanged(ranges);
	}
};
/**
* Some sort of double buffering.
*
* Keeps two buffers around that will be rotated for painting.
* Always gives a buffer that is filled with the background color.
*/
var MinimapBuffers = class MinimapBuffers {
	constructor(ctx, WIDTH, HEIGHT, background) {
		this._backgroundFillData = MinimapBuffers._createBackgroundFillData(WIDTH, HEIGHT, background);
		this._buffers = [ctx.createImageData(WIDTH, HEIGHT), ctx.createImageData(WIDTH, HEIGHT)];
		this._lastUsedBuffer = 0;
	}
	getBuffer() {
		this._lastUsedBuffer = 1 - this._lastUsedBuffer;
		const result = this._buffers[this._lastUsedBuffer];
		result.data.set(this._backgroundFillData);
		return result;
	}
	static _createBackgroundFillData(WIDTH, HEIGHT, background) {
		const backgroundR = background.r;
		const backgroundG = background.g;
		const backgroundB = background.b;
		const backgroundA = background.a;
		const result = new Uint8ClampedArray(WIDTH * HEIGHT * 4);
		let offset = 0;
		for (let i = 0; i < HEIGHT; i++) for (let j = 0; j < WIDTH; j++) {
			result[offset] = backgroundR;
			result[offset + 1] = backgroundG;
			result[offset + 2] = backgroundB;
			result[offset + 3] = backgroundA;
			offset += 4;
		}
		return result;
	}
};
var MinimapSamplingState = class MinimapSamplingState {
	static compute(options, viewLineCount, oldSamplingState) {
		if (options.renderMinimap === 0 || !options.isSampling) return [null, []];
		const { minimapLineCount } = EditorLayoutInfoComputer.computeContainedMinimapLineCount({
			viewLineCount,
			scrollBeyondLastLine: options.scrollBeyondLastLine,
			paddingTop: options.paddingTop,
			paddingBottom: options.paddingBottom,
			height: options.editorHeight,
			lineHeight: options.lineHeight,
			pixelRatio: options.pixelRatio
		});
		const ratio = viewLineCount / minimapLineCount;
		const halfRatio = ratio / 2;
		if (!oldSamplingState || oldSamplingState.minimapLines.length === 0) {
			const result = [];
			result[0] = 1;
			if (minimapLineCount > 1) {
				for (let i = 0, lastIndex = minimapLineCount - 1; i < lastIndex; i++) result[i] = Math.round(i * ratio + halfRatio);
				result[minimapLineCount - 1] = viewLineCount;
			}
			return [new MinimapSamplingState(ratio, result), []];
		}
		const oldMinimapLines = oldSamplingState.minimapLines;
		const oldLength = oldMinimapLines.length;
		const result = [];
		let oldIndex = 0;
		let oldDeltaLineCount = 0;
		let minViewLineNumber = 1;
		const MAX_EVENT_COUNT = 10;
		let events = [];
		let lastEvent = null;
		for (let i = 0; i < minimapLineCount; i++) {
			const fromViewLineNumber = Math.max(minViewLineNumber, Math.round(i * ratio));
			const toViewLineNumber = Math.max(fromViewLineNumber, Math.round((i + 1) * ratio));
			while (oldIndex < oldLength && oldMinimapLines[oldIndex] < fromViewLineNumber) {
				if (events.length < MAX_EVENT_COUNT) {
					const oldMinimapLineNumber = oldIndex + 1 + oldDeltaLineCount;
					if (lastEvent && lastEvent.type === "deleted" && lastEvent._oldIndex === oldIndex - 1) lastEvent.deleteToLineNumber++;
					else {
						lastEvent = {
							type: "deleted",
							_oldIndex: oldIndex,
							deleteFromLineNumber: oldMinimapLineNumber,
							deleteToLineNumber: oldMinimapLineNumber
						};
						events.push(lastEvent);
					}
					oldDeltaLineCount--;
				}
				oldIndex++;
			}
			let selectedViewLineNumber;
			if (oldIndex < oldLength && oldMinimapLines[oldIndex] <= toViewLineNumber) {
				selectedViewLineNumber = oldMinimapLines[oldIndex];
				oldIndex++;
			} else {
				if (i === 0) selectedViewLineNumber = 1;
				else if (i + 1 === minimapLineCount) selectedViewLineNumber = viewLineCount;
				else selectedViewLineNumber = Math.round(i * ratio + halfRatio);
				if (events.length < MAX_EVENT_COUNT) {
					const oldMinimapLineNumber = oldIndex + 1 + oldDeltaLineCount;
					if (lastEvent && lastEvent.type === "inserted" && lastEvent._i === i - 1) lastEvent.insertToLineNumber++;
					else {
						lastEvent = {
							type: "inserted",
							_i: i,
							insertFromLineNumber: oldMinimapLineNumber,
							insertToLineNumber: oldMinimapLineNumber
						};
						events.push(lastEvent);
					}
					oldDeltaLineCount++;
				}
			}
			result[i] = selectedViewLineNumber;
			minViewLineNumber = selectedViewLineNumber;
		}
		if (events.length < MAX_EVENT_COUNT) while (oldIndex < oldLength) {
			const oldMinimapLineNumber = oldIndex + 1 + oldDeltaLineCount;
			if (lastEvent && lastEvent.type === "deleted" && lastEvent._oldIndex === oldIndex - 1) lastEvent.deleteToLineNumber++;
			else {
				lastEvent = {
					type: "deleted",
					_oldIndex: oldIndex,
					deleteFromLineNumber: oldMinimapLineNumber,
					deleteToLineNumber: oldMinimapLineNumber
				};
				events.push(lastEvent);
			}
			oldDeltaLineCount--;
			oldIndex++;
		}
		else events = [{ type: "flush" }];
		return [new MinimapSamplingState(ratio, result), events];
	}
	constructor(samplingRatio, minimapLines) {
		this.samplingRatio = samplingRatio;
		this.minimapLines = minimapLines;
	}
	modelLineToMinimapLine(lineNumber) {
		return Math.min(this.minimapLines.length, Math.max(1, Math.round(lineNumber / this.samplingRatio)));
	}
	/**
	* Will return null if the model line ranges are not intersecting with a sampled model line.
	*/
	modelLineRangeToMinimapLineRange(fromLineNumber, toLineNumber) {
		let fromLineIndex = this.modelLineToMinimapLine(fromLineNumber) - 1;
		while (fromLineIndex > 0 && this.minimapLines[fromLineIndex - 1] >= fromLineNumber) fromLineIndex--;
		let toLineIndex = this.modelLineToMinimapLine(toLineNumber) - 1;
		while (toLineIndex + 1 < this.minimapLines.length && this.minimapLines[toLineIndex + 1] <= toLineNumber) toLineIndex++;
		if (fromLineIndex === toLineIndex) {
			const sampledLineNumber = this.minimapLines[fromLineIndex];
			if (sampledLineNumber < fromLineNumber || sampledLineNumber > toLineNumber) return null;
		}
		return [fromLineIndex + 1, toLineIndex + 1];
	}
	/**
	* Will always return a range, even if it is not intersecting with a sampled model line.
	*/
	decorationLineRangeToMinimapLineRange(startLineNumber, endLineNumber) {
		let minimapLineStart = this.modelLineToMinimapLine(startLineNumber);
		let minimapLineEnd = this.modelLineToMinimapLine(endLineNumber);
		if (startLineNumber !== endLineNumber && minimapLineEnd === minimapLineStart) {
			if (minimapLineEnd === this.minimapLines.length) {
				if (minimapLineStart > 1) minimapLineStart--;
			} else minimapLineEnd++;
		}
		return [minimapLineStart, minimapLineEnd];
	}
	onLinesDeleted(e) {
		const deletedLineCount = e.toLineNumber - e.fromLineNumber + 1;
		let changeStartIndex = this.minimapLines.length;
		let changeEndIndex = 0;
		for (let i = this.minimapLines.length - 1; i >= 0; i--) {
			if (this.minimapLines[i] < e.fromLineNumber) break;
			if (this.minimapLines[i] <= e.toLineNumber) {
				this.minimapLines[i] = Math.max(1, e.fromLineNumber - 1);
				changeStartIndex = Math.min(changeStartIndex, i);
				changeEndIndex = Math.max(changeEndIndex, i);
			} else this.minimapLines[i] -= deletedLineCount;
		}
		return [changeStartIndex, changeEndIndex];
	}
	onLinesInserted(e) {
		const insertedLineCount = e.toLineNumber - e.fromLineNumber + 1;
		for (let i = this.minimapLines.length - 1; i >= 0; i--) {
			if (this.minimapLines[i] < e.fromLineNumber) break;
			this.minimapLines[i] += insertedLineCount;
		}
	}
};
/**
* The minimap appears beside the editor scroll bar and visualizes a zoomed out
* view of the file.
*/
var Minimap = class extends ViewPart {
	constructor(context) {
		super(context);
		this._sectionHeaderCache = new LRUCache(10, 1.5);
		this.tokensColorTracker = MinimapTokensColorTracker.getInstance();
		this._selections = [];
		this._minimapSelections = null;
		this.options = new MinimapOptions(this._context.configuration, this._context.theme, this.tokensColorTracker);
		const [samplingState] = MinimapSamplingState.compute(this.options, this._context.viewModel.getLineCount(), null);
		this._samplingState = samplingState;
		this._shouldCheckSampling = false;
		this._actual = new InnerMinimap(context.theme, this);
	}
	dispose() {
		this._actual.dispose();
		super.dispose();
	}
	getDomNode() {
		return this._actual.getDomNode();
	}
	_onOptionsMaybeChanged() {
		const opts = new MinimapOptions(this._context.configuration, this._context.theme, this.tokensColorTracker);
		if (this.options.equals(opts)) return false;
		this.options = opts;
		this._recreateLineSampling();
		this._actual.onDidChangeOptions();
		return true;
	}
	onConfigurationChanged(e) {
		return this._onOptionsMaybeChanged();
	}
	onCursorStateChanged(e) {
		this._selections = e.selections;
		this._minimapSelections = null;
		return this._actual.onSelectionChanged();
	}
	onDecorationsChanged(e) {
		if (e.affectsMinimap) return this._actual.onDecorationsChanged();
		return false;
	}
	onFlushed(e) {
		if (this._samplingState) this._shouldCheckSampling = true;
		return this._actual.onFlushed();
	}
	onLinesChanged(e) {
		if (this._samplingState) {
			const minimapLineRange = this._samplingState.modelLineRangeToMinimapLineRange(e.fromLineNumber, e.fromLineNumber + e.count - 1);
			if (minimapLineRange) return this._actual.onLinesChanged(minimapLineRange[0], minimapLineRange[1] - minimapLineRange[0] + 1);
			else return false;
		} else return this._actual.onLinesChanged(e.fromLineNumber, e.count);
	}
	onLinesDeleted(e) {
		if (this._samplingState) {
			const [changeStartIndex, changeEndIndex] = this._samplingState.onLinesDeleted(e);
			if (changeStartIndex <= changeEndIndex) this._actual.onLinesChanged(changeStartIndex + 1, changeEndIndex - changeStartIndex + 1);
			this._shouldCheckSampling = true;
			return true;
		} else return this._actual.onLinesDeleted(e.fromLineNumber, e.toLineNumber);
	}
	onLinesInserted(e) {
		if (this._samplingState) {
			this._samplingState.onLinesInserted(e);
			this._shouldCheckSampling = true;
			return true;
		} else return this._actual.onLinesInserted(e.fromLineNumber, e.toLineNumber);
	}
	onScrollChanged(e) {
		return this._actual.onScrollChanged(e);
	}
	onThemeChanged(e) {
		this._actual.onThemeChanged();
		this._onOptionsMaybeChanged();
		return true;
	}
	onTokensChanged(e) {
		if (this._samplingState) {
			const ranges = [];
			for (const range of e.ranges) {
				const minimapLineRange = this._samplingState.modelLineRangeToMinimapLineRange(range.fromLineNumber, range.toLineNumber);
				if (minimapLineRange) ranges.push({
					fromLineNumber: minimapLineRange[0],
					toLineNumber: minimapLineRange[1]
				});
			}
			if (ranges.length) return this._actual.onTokensChanged(ranges);
			else return false;
		} else return this._actual.onTokensChanged(e.ranges);
	}
	onTokensColorsChanged(e) {
		this._onOptionsMaybeChanged();
		return this._actual.onTokensColorsChanged();
	}
	onZonesChanged(e) {
		return this._actual.onZonesChanged();
	}
	prepareRender(ctx) {
		if (this._shouldCheckSampling) {
			this._shouldCheckSampling = false;
			this._recreateLineSampling();
		}
	}
	render(ctx) {
		let viewportStartLineNumber = ctx.visibleRange.startLineNumber;
		let viewportEndLineNumber = ctx.visibleRange.endLineNumber;
		if (this._samplingState) {
			viewportStartLineNumber = this._samplingState.modelLineToMinimapLine(viewportStartLineNumber);
			viewportEndLineNumber = this._samplingState.modelLineToMinimapLine(viewportEndLineNumber);
		}
		const minimapCtx = {
			viewportContainsWhitespaceGaps: ctx.viewportData.whitespaceViewportData.length > 0,
			scrollWidth: ctx.scrollWidth,
			scrollHeight: ctx.scrollHeight,
			viewportStartLineNumber,
			viewportEndLineNumber,
			viewportStartLineNumberVerticalOffset: ctx.getVerticalOffsetForLineNumber(viewportStartLineNumber),
			scrollTop: ctx.scrollTop,
			scrollLeft: ctx.scrollLeft,
			viewportWidth: ctx.viewportWidth,
			viewportHeight: ctx.viewportHeight
		};
		this._actual.render(minimapCtx);
	}
	_recreateLineSampling() {
		this._minimapSelections = null;
		const wasSampling = Boolean(this._samplingState);
		const [samplingState, events] = MinimapSamplingState.compute(this.options, this._context.viewModel.getLineCount(), this._samplingState);
		this._samplingState = samplingState;
		if (wasSampling && this._samplingState) for (const event of events) switch (event.type) {
			case "deleted":
				this._actual.onLinesDeleted(event.deleteFromLineNumber, event.deleteToLineNumber);
				break;
			case "inserted":
				this._actual.onLinesInserted(event.insertFromLineNumber, event.insertToLineNumber);
				break;
			case "flush": this._actual.onFlushed();
		}
	}
	getLineCount() {
		if (this._samplingState) return this._samplingState.minimapLines.length;
		return this._context.viewModel.getLineCount();
	}
	getRealLineCount() {
		return this._context.viewModel.getLineCount();
	}
	getLineContent(lineNumber) {
		if (this._samplingState) return this._context.viewModel.getLineContent(this._samplingState.minimapLines[lineNumber - 1]);
		return this._context.viewModel.getLineContent(lineNumber);
	}
	getLineMaxColumn(lineNumber) {
		if (this._samplingState) return this._context.viewModel.getLineMaxColumn(this._samplingState.minimapLines[lineNumber - 1]);
		return this._context.viewModel.getLineMaxColumn(lineNumber);
	}
	getMinimapLinesRenderingData(startLineNumber, endLineNumber, needed) {
		if (this._samplingState) {
			const result = [];
			for (let lineIndex = 0, lineCount = endLineNumber - startLineNumber + 1; lineIndex < lineCount; lineIndex++) if (needed[lineIndex]) result[lineIndex] = this._context.viewModel.getViewLineData(this._samplingState.minimapLines[startLineNumber + lineIndex - 1]);
			else result[lineIndex] = null;
			return result;
		}
		return this._context.viewModel.getMinimapLinesRenderingData(startLineNumber, endLineNumber, needed).data;
	}
	getSelections() {
		if (this._minimapSelections === null) {
			if (this._samplingState) {
				this._minimapSelections = [];
				for (const selection of this._selections) {
					const [minimapLineStart, minimapLineEnd] = this._samplingState.decorationLineRangeToMinimapLineRange(selection.startLineNumber, selection.endLineNumber);
					this._minimapSelections.push(new Selection$1(minimapLineStart, selection.startColumn, minimapLineEnd, selection.endColumn));
				}
			} else this._minimapSelections = this._selections;
		}
		return this._minimapSelections;
	}
	getMinimapDecorationsInViewport(startLineNumber, endLineNumber) {
		return this._getMinimapDecorationsInViewport(startLineNumber, endLineNumber).filter((decoration) => !decoration.options.minimap?.sectionHeaderStyle);
	}
	getSectionHeaderDecorationsInViewport(startLineNumber, endLineNumber) {
		const headerHeightInMinimapLines = this.options.sectionHeaderFontSize / this.options.minimapLineHeight;
		startLineNumber = Math.floor(Math.max(1, startLineNumber - headerHeightInMinimapLines));
		return this._getMinimapDecorationsInViewport(startLineNumber, endLineNumber).filter((decoration) => !!decoration.options.minimap?.sectionHeaderStyle);
	}
	_getMinimapDecorationsInViewport(startLineNumber, endLineNumber) {
		let visibleRange;
		if (this._samplingState) {
			const modelStartLineNumber = this._samplingState.minimapLines[startLineNumber - 1];
			const modelEndLineNumber = this._samplingState.minimapLines[endLineNumber - 1];
			visibleRange = new Range$2(modelStartLineNumber, 1, modelEndLineNumber, this._context.viewModel.getLineMaxColumn(modelEndLineNumber));
		} else visibleRange = new Range$2(startLineNumber, 1, endLineNumber, this._context.viewModel.getLineMaxColumn(endLineNumber));
		const decorations = this._context.viewModel.getMinimapDecorationsInRange(visibleRange);
		if (this._samplingState) {
			const result = [];
			for (const decoration of decorations) {
				if (!decoration.options.minimap) continue;
				const range = decoration.range;
				const minimapStartLineNumber = this._samplingState.modelLineToMinimapLine(range.startLineNumber);
				const minimapEndLineNumber = this._samplingState.modelLineToMinimapLine(range.endLineNumber);
				result.push(new ViewModelDecoration(new Range$2(minimapStartLineNumber, range.startColumn, minimapEndLineNumber, range.endColumn), decoration.options));
			}
			return result;
		}
		return decorations;
	}
	getSectionHeaderText(decoration, fitWidth) {
		const headerText = decoration.options.minimap?.sectionHeaderText;
		if (!headerText) return null;
		const cachedText = this._sectionHeaderCache.get(headerText);
		if (cachedText) return cachedText;
		const fittedText = fitWidth(headerText);
		this._sectionHeaderCache.set(headerText, fittedText);
		return fittedText;
	}
	getOptions() {
		return this._context.viewModel.model.getOptions();
	}
	revealLineNumber(lineNumber) {
		if (this._samplingState) lineNumber = this._samplingState.minimapLines[lineNumber - 1];
		this._context.viewModel.revealRange("mouse", false, new Range$2(lineNumber, 1, lineNumber, 1), 1, 0);
	}
	setScrollTop(scrollTop) {
		this._context.viewModel.viewLayout.setScrollPosition({ scrollTop }, 1);
	}
};
var InnerMinimap = class InnerMinimap extends Disposable {
	constructor(theme, model) {
		super();
		this._renderDecorations = false;
		this._gestureInProgress = false;
		this._isMouseOverMinimap = false;
		this._theme = theme;
		this._model = model;
		this._lastRenderData = null;
		this._buffers = null;
		this._selectionColor = this._theme.getColor(minimapSelection);
		this._domNode = createFastDomNode(document.createElement("div"));
		PartFingerprints.write(this._domNode, 9);
		this._domNode.setClassName(this._getMinimapDomNodeClassName());
		this._domNode.setPosition("absolute");
		this._domNode.setAttribute("role", "presentation");
		this._domNode.setAttribute("aria-hidden", "true");
		this._shadow = createFastDomNode(document.createElement("div"));
		this._shadow.setClassName("minimap-shadow-hidden");
		this._domNode.appendChild(this._shadow);
		this._canvas = createFastDomNode(document.createElement("canvas"));
		this._canvas.setPosition("absolute");
		this._canvas.setLeft(0);
		this._domNode.appendChild(this._canvas);
		this._decorationsCanvas = createFastDomNode(document.createElement("canvas"));
		this._decorationsCanvas.setPosition("absolute");
		this._decorationsCanvas.setClassName("minimap-decorations-layer");
		this._decorationsCanvas.setLeft(0);
		this._domNode.appendChild(this._decorationsCanvas);
		this._slider = createFastDomNode(document.createElement("div"));
		this._slider.setPosition("absolute");
		this._slider.setClassName("minimap-slider");
		this._slider.setLayerHinting(true);
		this._slider.setContain("strict");
		this._domNode.appendChild(this._slider);
		this._sliderHorizontal = createFastDomNode(document.createElement("div"));
		this._sliderHorizontal.setPosition("absolute");
		this._sliderHorizontal.setClassName("minimap-slider-horizontal");
		this._slider.appendChild(this._sliderHorizontal);
		this._applyLayout();
		this._hideDelayedScheduler = this._register(new RunOnceScheduler(() => this._hideImmediatelyIfMouseIsOutside(), 500));
		this._register(addStandardDisposableListener(this._domNode.domNode, EventType$1.MOUSE_OVER, () => {
			this._isMouseOverMinimap = true;
		}));
		this._register(addStandardDisposableListener(this._domNode.domNode, EventType$1.MOUSE_LEAVE, () => {
			this._isMouseOverMinimap = false;
		}));
		this._pointerDownListener = addStandardDisposableListener(this._domNode.domNode, EventType$1.POINTER_DOWN, (e) => {
			e.preventDefault();
			const isMouse = e.pointerType === "mouse";
			const isLeftClick = e.button === 0;
			if (this._model.options.renderMinimap === 0) return;
			if (!this._lastRenderData) return;
			if (this._model.options.size !== "proportional") {
				if (isLeftClick && this._lastRenderData) {
					const position = getDomNodePagePosition(this._slider.domNode);
					const initialPosY = position.top + position.height / 2;
					this._startSliderDragging(e, initialPosY, this._lastRenderData.renderedLayout);
				}
				return;
			}
			if (isLeftClick || !isMouse) {
				const minimapLineHeight = this._model.options.minimapLineHeight;
				const internalOffsetY = this._model.options.canvasInnerHeight / this._model.options.canvasOuterHeight * e.offsetY;
				let lineNumber = Math.floor(internalOffsetY / minimapLineHeight) + this._lastRenderData.renderedLayout.startLineNumber - this._lastRenderData.renderedLayout.topPaddingLineCount;
				lineNumber = Math.min(lineNumber, this._model.getLineCount());
				this._model.revealLineNumber(lineNumber);
			}
		});
		this._sliderPointerMoveMonitor = new GlobalPointerMoveMonitor();
		this._sliderPointerDownListener = addStandardDisposableListener(this._slider.domNode, EventType$1.POINTER_DOWN, (e) => {
			e.preventDefault();
			e.stopPropagation();
			if (e.button === 0 && this._lastRenderData) this._startSliderDragging(e, e.pageY, this._lastRenderData.renderedLayout);
		});
		this._gestureDisposable = Gesture.addTarget(this._domNode.domNode);
		this._sliderTouchStartListener = addDisposableListener(this._domNode.domNode, EventType.Start, (e) => {
			e.preventDefault();
			e.stopPropagation();
			if (this._lastRenderData) {
				this._slider.toggleClassName("active", true);
				this._gestureInProgress = true;
				this.scrollDueToTouchEvent(e);
			}
		}, { passive: false });
		this._sliderTouchMoveListener = addDisposableListener(this._domNode.domNode, EventType.Change, (e) => {
			e.preventDefault();
			e.stopPropagation();
			if (this._lastRenderData && this._gestureInProgress) this.scrollDueToTouchEvent(e);
		}, { passive: false });
		this._sliderTouchEndListener = addStandardDisposableListener(this._domNode.domNode, EventType.End, (e) => {
			e.preventDefault();
			e.stopPropagation();
			this._gestureInProgress = false;
			this._slider.toggleClassName("active", false);
		});
	}
	_hideSoon() {
		this._hideDelayedScheduler.cancel();
		this._hideDelayedScheduler.schedule();
	}
	_hideImmediatelyIfMouseIsOutside() {
		if (this._isMouseOverMinimap) {
			this._hideSoon();
			return;
		}
		this._domNode.toggleClassName("active", false);
	}
	_startSliderDragging(e, initialPosY, initialSliderState) {
		if (!e.target || !(e.target instanceof Element)) return;
		const initialPosX = e.pageX;
		this._slider.toggleClassName("active", true);
		const handlePointerMove = (posy, posx) => {
			const minimapPosition = getDomNodePagePosition(this._domNode.domNode);
			const pointerOrthogonalDelta = Math.min(Math.abs(posx - initialPosX), Math.abs(posx - minimapPosition.left), Math.abs(posx - minimapPosition.left - minimapPosition.width));
			if (isWindows && pointerOrthogonalDelta > POINTER_DRAG_RESET_DISTANCE) {
				this._model.setScrollTop(initialSliderState.scrollTop);
				return;
			}
			const pointerDelta = posy - initialPosY;
			this._model.setScrollTop(initialSliderState.getDesiredScrollTopFromDelta(pointerDelta));
		};
		if (e.pageY !== initialPosY) handlePointerMove(e.pageY, initialPosX);
		this._sliderPointerMoveMonitor.startMonitoring(e.target, e.pointerId, e.buttons, (pointerMoveData) => handlePointerMove(pointerMoveData.pageY, pointerMoveData.pageX), () => {
			this._slider.toggleClassName("active", false);
		});
	}
	scrollDueToTouchEvent(touch) {
		const startY = this._domNode.domNode.getBoundingClientRect().top;
		const scrollTop = this._lastRenderData.renderedLayout.getDesiredScrollTopFromTouchLocation(touch.pageY - startY);
		this._model.setScrollTop(scrollTop);
	}
	dispose() {
		this._pointerDownListener.dispose();
		this._sliderPointerMoveMonitor.dispose();
		this._sliderPointerDownListener.dispose();
		this._gestureDisposable.dispose();
		this._sliderTouchStartListener.dispose();
		this._sliderTouchMoveListener.dispose();
		this._sliderTouchEndListener.dispose();
		super.dispose();
	}
	_getMinimapDomNodeClassName() {
		const class_ = ["minimap"];
		if (this._model.options.showSlider === "always") class_.push("slider-always");
		else class_.push("slider-mouseover");
		if (this._model.options.autohide === "mouseover") class_.push("minimap-autohide-mouseover");
		else if (this._model.options.autohide === "scroll") class_.push("minimap-autohide-scroll");
		return class_.join(" ");
	}
	getDomNode() {
		return this._domNode;
	}
	_applyLayout() {
		this._domNode.setLeft(this._model.options.minimapLeft);
		this._domNode.setWidth(this._model.options.minimapWidth);
		this._domNode.setHeight(this._model.options.minimapHeight);
		this._shadow.setHeight(this._model.options.minimapHeight);
		this._canvas.setWidth(this._model.options.canvasOuterWidth);
		this._canvas.setHeight(this._model.options.canvasOuterHeight);
		this._canvas.domNode.width = this._model.options.canvasInnerWidth;
		this._canvas.domNode.height = this._model.options.canvasInnerHeight;
		this._decorationsCanvas.setWidth(this._model.options.canvasOuterWidth);
		this._decorationsCanvas.setHeight(this._model.options.canvasOuterHeight);
		this._decorationsCanvas.domNode.width = this._model.options.canvasInnerWidth;
		this._decorationsCanvas.domNode.height = this._model.options.canvasInnerHeight;
		this._slider.setWidth(this._model.options.minimapWidth);
	}
	_getBuffer() {
		if (!this._buffers) {
			if (this._model.options.canvasInnerWidth > 0 && this._model.options.canvasInnerHeight > 0) this._buffers = new MinimapBuffers(this._canvas.domNode.getContext("2d"), this._model.options.canvasInnerWidth, this._model.options.canvasInnerHeight, this._model.options.backgroundColor);
		}
		return this._buffers ? this._buffers.getBuffer() : null;
	}
	onDidChangeOptions() {
		this._lastRenderData = null;
		this._buffers = null;
		this._applyLayout();
		this._domNode.setClassName(this._getMinimapDomNodeClassName());
	}
	onSelectionChanged() {
		this._renderDecorations = true;
		return true;
	}
	onDecorationsChanged() {
		this._renderDecorations = true;
		return true;
	}
	onFlushed() {
		this._lastRenderData = null;
		return true;
	}
	onLinesChanged(changeFromLineNumber, changeCount) {
		if (this._lastRenderData) return this._lastRenderData.onLinesChanged(changeFromLineNumber, changeCount);
		return false;
	}
	onLinesDeleted(deleteFromLineNumber, deleteToLineNumber) {
		this._lastRenderData?.onLinesDeleted(deleteFromLineNumber, deleteToLineNumber);
		return true;
	}
	onLinesInserted(insertFromLineNumber, insertToLineNumber) {
		this._lastRenderData?.onLinesInserted(insertFromLineNumber, insertToLineNumber);
		return true;
	}
	onScrollChanged(e) {
		if (this._model.options.autohide === "scroll" && (e.scrollTopChanged || e.scrollHeightChanged)) {
			this._domNode.toggleClassName("active", true);
			this._hideSoon();
		}
		this._renderDecorations = true;
		return true;
	}
	onThemeChanged() {
		this._selectionColor = this._theme.getColor(minimapSelection);
		this._renderDecorations = true;
		return true;
	}
	onTokensChanged(ranges) {
		if (this._lastRenderData) return this._lastRenderData.onTokensChanged(ranges);
		return false;
	}
	onTokensColorsChanged() {
		this._lastRenderData = null;
		this._buffers = null;
		return true;
	}
	onZonesChanged() {
		this._lastRenderData = null;
		return true;
	}
	render(renderingCtx) {
		if (this._model.options.renderMinimap === 0) {
			this._shadow.setClassName("minimap-shadow-hidden");
			this._sliderHorizontal.setWidth(0);
			this._sliderHorizontal.setHeight(0);
			return;
		}
		if (renderingCtx.scrollLeft + renderingCtx.viewportWidth >= renderingCtx.scrollWidth) this._shadow.setClassName("minimap-shadow-hidden");
		else this._shadow.setClassName("minimap-shadow-visible");
		const layout = MinimapLayout.create(this._model.options, renderingCtx.viewportStartLineNumber, renderingCtx.viewportEndLineNumber, renderingCtx.viewportStartLineNumberVerticalOffset, renderingCtx.viewportHeight, renderingCtx.viewportContainsWhitespaceGaps, this._model.getLineCount(), this._model.getRealLineCount(), renderingCtx.scrollTop, renderingCtx.scrollHeight, this._lastRenderData ? this._lastRenderData.renderedLayout : null);
		this._slider.setDisplay(layout.sliderNeeded ? "block" : "none");
		this._slider.setTop(layout.sliderTop);
		this._slider.setHeight(layout.sliderHeight);
		this._sliderHorizontal.setLeft(0);
		this._sliderHorizontal.setWidth(this._model.options.minimapWidth);
		this._sliderHorizontal.setTop(0);
		this._sliderHorizontal.setHeight(layout.sliderHeight);
		this.renderDecorations(layout);
		this._lastRenderData = this.renderLines(layout);
	}
	renderDecorations(layout) {
		if (this._renderDecorations) {
			this._renderDecorations = false;
			const selections = this._model.getSelections();
			selections.sort(Range$2.compareRangesUsingStarts);
			const decorations = this._model.getMinimapDecorationsInViewport(layout.startLineNumber, layout.endLineNumber);
			decorations.sort((a, b) => (a.options.zIndex || 0) - (b.options.zIndex || 0));
			const { canvasInnerWidth, canvasInnerHeight } = this._model.options;
			const minimapLineHeight = this._model.options.minimapLineHeight;
			const minimapCharWidth = this._model.options.minimapCharWidth;
			const tabSize = this._model.getOptions().tabSize;
			const canvasContext = this._decorationsCanvas.domNode.getContext("2d");
			canvasContext.clearRect(0, 0, canvasInnerWidth, canvasInnerHeight);
			const highlightedLines = new ContiguousLineMap(layout.startLineNumber, layout.endLineNumber, false);
			this._renderSelectionLineHighlights(canvasContext, selections, highlightedLines, layout, minimapLineHeight);
			this._renderDecorationsLineHighlights(canvasContext, decorations, highlightedLines, layout, minimapLineHeight);
			const lineOffsetMap = new ContiguousLineMap(layout.startLineNumber, layout.endLineNumber, null);
			this._renderSelectionsHighlights(canvasContext, selections, lineOffsetMap, layout, minimapLineHeight, tabSize, minimapCharWidth, canvasInnerWidth);
			this._renderDecorationsHighlights(canvasContext, decorations, lineOffsetMap, layout, minimapLineHeight, tabSize, minimapCharWidth, canvasInnerWidth);
			this._renderSectionHeaders(layout);
		}
	}
	_renderSelectionLineHighlights(canvasContext, selections, highlightedLines, layout, minimapLineHeight) {
		if (!this._selectionColor || this._selectionColor.isTransparent()) return;
		canvasContext.fillStyle = this._selectionColor.transparent(.5).toString();
		let y1 = 0;
		let y2 = 0;
		for (const selection of selections) {
			const intersection = layout.intersectWithViewport(selection);
			if (!intersection) continue;
			const [startLineNumber, endLineNumber] = intersection;
			for (let line = startLineNumber; line <= endLineNumber; line++) highlightedLines.set(line, true);
			const yy1 = layout.getYForLineNumber(startLineNumber, minimapLineHeight);
			const yy2 = layout.getYForLineNumber(endLineNumber, minimapLineHeight);
			if (y2 >= yy1) y2 = yy2;
			else {
				if (y2 > y1) canvasContext.fillRect(8, y1, canvasContext.canvas.width, y2 - y1);
				y1 = yy1;
				y2 = yy2;
			}
		}
		if (y2 > y1) canvasContext.fillRect(8, y1, canvasContext.canvas.width, y2 - y1);
	}
	_renderDecorationsLineHighlights(canvasContext, decorations, highlightedLines, layout, minimapLineHeight) {
		const highlightColors = /* @__PURE__ */ new Map();
		for (let i = decorations.length - 1; i >= 0; i--) {
			const decoration = decorations[i];
			const minimapOptions = decoration.options.minimap;
			if (!minimapOptions || minimapOptions.position !== 1) continue;
			const intersection = layout.intersectWithViewport(decoration.range);
			if (!intersection) continue;
			const [startLineNumber, endLineNumber] = intersection;
			const decorationColor = minimapOptions.getColor(this._theme.value);
			if (!decorationColor || decorationColor.isTransparent()) continue;
			let highlightColor = highlightColors.get(decorationColor.toString());
			if (!highlightColor) {
				highlightColor = decorationColor.transparent(.5).toString();
				highlightColors.set(decorationColor.toString(), highlightColor);
			}
			canvasContext.fillStyle = highlightColor;
			for (let line = startLineNumber; line <= endLineNumber; line++) {
				if (highlightedLines.has(line)) continue;
				highlightedLines.set(line, true);
				const y = layout.getYForLineNumber(line, minimapLineHeight);
				canvasContext.fillRect(8, y, canvasContext.canvas.width, minimapLineHeight);
			}
		}
	}
	_renderSelectionsHighlights(canvasContext, selections, lineOffsetMap, layout, lineHeight, tabSize, characterWidth, canvasInnerWidth) {
		if (!this._selectionColor || this._selectionColor.isTransparent()) return;
		for (const selection of selections) {
			const intersection = layout.intersectWithViewport(selection);
			if (!intersection) continue;
			const [startLineNumber, endLineNumber] = intersection;
			for (let line = startLineNumber; line <= endLineNumber; line++) this.renderDecorationOnLine(canvasContext, lineOffsetMap, selection, this._selectionColor, layout, line, lineHeight, lineHeight, tabSize, characterWidth, canvasInnerWidth);
		}
	}
	_renderDecorationsHighlights(canvasContext, decorations, lineOffsetMap, layout, minimapLineHeight, tabSize, characterWidth, canvasInnerWidth) {
		for (const decoration of decorations) {
			const minimapOptions = decoration.options.minimap;
			if (!minimapOptions) continue;
			const intersection = layout.intersectWithViewport(decoration.range);
			if (!intersection) continue;
			const [startLineNumber, endLineNumber] = intersection;
			const decorationColor = minimapOptions.getColor(this._theme.value);
			if (!decorationColor || decorationColor.isTransparent()) continue;
			for (let line = startLineNumber; line <= endLineNumber; line++) switch (minimapOptions.position) {
				case 1:
					this.renderDecorationOnLine(canvasContext, lineOffsetMap, decoration.range, decorationColor, layout, line, minimapLineHeight, minimapLineHeight, tabSize, characterWidth, canvasInnerWidth);
					continue;
				case 2: {
					const y = layout.getYForLineNumber(line, minimapLineHeight);
					this.renderDecoration(canvasContext, decorationColor, 2, y, GUTTER_DECORATION_WIDTH, minimapLineHeight);
					continue;
				}
			}
		}
	}
	renderDecorationOnLine(canvasContext, lineOffsetMap, decorationRange, decorationColor, layout, lineNumber, height, minimapLineHeight, tabSize, charWidth, canvasInnerWidth) {
		const y = layout.getYForLineNumber(lineNumber, minimapLineHeight);
		if (y + height < 0 || y > this._model.options.canvasInnerHeight) return;
		const { startLineNumber, endLineNumber } = decorationRange;
		const startColumn = startLineNumber === lineNumber ? decorationRange.startColumn : 1;
		const endColumn = endLineNumber === lineNumber ? decorationRange.endColumn : this._model.getLineMaxColumn(lineNumber);
		const x1 = this.getXOffsetForPosition(lineOffsetMap, lineNumber, startColumn, tabSize, charWidth, canvasInnerWidth);
		const x2 = this.getXOffsetForPosition(lineOffsetMap, lineNumber, endColumn, tabSize, charWidth, canvasInnerWidth);
		this.renderDecoration(canvasContext, decorationColor, x1, y, x2 - x1, height);
	}
	getXOffsetForPosition(lineOffsetMap, lineNumber, column, tabSize, charWidth, canvasInnerWidth) {
		if (column === 1) return 8;
		if ((column - 1) * charWidth >= canvasInnerWidth) return canvasInnerWidth;
		let lineIndexToXOffset = lineOffsetMap.get(lineNumber);
		if (!lineIndexToXOffset) {
			const lineData = this._model.getLineContent(lineNumber);
			lineIndexToXOffset = [8];
			let prevx = 8;
			for (let i = 1; i < lineData.length + 1; i++) {
				const charCode = lineData.charCodeAt(i - 1);
				const dx = charCode === 9 ? tabSize * charWidth : isFullWidthCharacter(charCode) ? 2 * charWidth : charWidth;
				const x = prevx + dx;
				if (x >= canvasInnerWidth) {
					lineIndexToXOffset[i] = canvasInnerWidth;
					break;
				}
				lineIndexToXOffset[i] = x;
				prevx = x;
			}
			lineOffsetMap.set(lineNumber, lineIndexToXOffset);
		}
		if (column - 1 < lineIndexToXOffset.length) return lineIndexToXOffset[column - 1];
		return canvasInnerWidth;
	}
	renderDecoration(canvasContext, decorationColor, x, y, width, height) {
		canvasContext.fillStyle = decorationColor && decorationColor.toString() || "";
		canvasContext.fillRect(x, y, width, height);
	}
	_renderSectionHeaders(layout) {
		const minimapLineHeight = this._model.options.minimapLineHeight;
		const sectionHeaderFontSize = this._model.options.sectionHeaderFontSize;
		const sectionHeaderLetterSpacing = this._model.options.sectionHeaderLetterSpacing;
		const backgroundFillHeight = sectionHeaderFontSize * 1.5;
		const { canvasInnerWidth } = this._model.options;
		const backgroundColor = this._model.options.backgroundColor;
		const backgroundFill = `rgb(${backgroundColor.r} ${backgroundColor.g} ${backgroundColor.b} / .7)`;
		const foregroundColor = this._model.options.sectionHeaderFontColor;
		const foregroundFill = `rgb(${foregroundColor.r} ${foregroundColor.g} ${foregroundColor.b})`;
		const separatorStroke = foregroundFill;
		const canvasContext = this._decorationsCanvas.domNode.getContext("2d");
		canvasContext.letterSpacing = sectionHeaderLetterSpacing + "px";
		canvasContext.font = "500 " + sectionHeaderFontSize + "px " + this._model.options.sectionHeaderFontFamily;
		canvasContext.strokeStyle = separatorStroke;
		canvasContext.lineWidth = .4;
		const decorations = this._model.getSectionHeaderDecorationsInViewport(layout.startLineNumber, layout.endLineNumber);
		decorations.sort((a, b) => a.range.startLineNumber - b.range.startLineNumber);
		const fitWidth = InnerMinimap._fitSectionHeader.bind(null, canvasContext, canvasInnerWidth - 8);
		for (const decoration of decorations) {
			const y = layout.getYForLineNumber(decoration.range.startLineNumber, minimapLineHeight) + sectionHeaderFontSize;
			const backgroundFillY = y - sectionHeaderFontSize;
			const separatorY = backgroundFillY + 2;
			const headerText = this._model.getSectionHeaderText(decoration, fitWidth);
			InnerMinimap._renderSectionLabel(canvasContext, headerText, decoration.options.minimap?.sectionHeaderStyle === 2, backgroundFill, foregroundFill, canvasInnerWidth, backgroundFillY, backgroundFillHeight, y, separatorY);
		}
	}
	static _fitSectionHeader(target, maxWidth, headerText) {
		if (!headerText) return headerText;
		const ellipsis = "…";
		const width = target.measureText(headerText).width;
		const ellipsisWidth = target.measureText(ellipsis).width;
		if (width <= maxWidth || width <= ellipsisWidth) return headerText;
		const len = headerText.length;
		const averageCharWidth = width / headerText.length;
		const maxCharCount = Math.floor((maxWidth - ellipsisWidth) / averageCharWidth) - 1;
		let halfCharCount = Math.ceil(maxCharCount / 2);
		while (halfCharCount > 0 && /\s/.test(headerText[halfCharCount - 1])) --halfCharCount;
		return headerText.substring(0, halfCharCount) + ellipsis + headerText.substring(len - (maxCharCount - halfCharCount));
	}
	static _renderSectionLabel(target, headerText, hasSeparatorLine, backgroundFill, foregroundFill, minimapWidth, backgroundFillY, backgroundFillHeight, textY, separatorY) {
		if (headerText) {
			target.fillStyle = backgroundFill;
			target.fillRect(0, backgroundFillY, minimapWidth, backgroundFillHeight);
			target.fillStyle = foregroundFill;
			target.fillText(headerText, 8, textY);
		}
		if (hasSeparatorLine) {
			target.beginPath();
			target.moveTo(0, separatorY);
			target.lineTo(minimapWidth, separatorY);
			target.closePath();
			target.stroke();
		}
	}
	renderLines(layout) {
		const startLineNumber = layout.startLineNumber;
		const endLineNumber = layout.endLineNumber;
		const minimapLineHeight = this._model.options.minimapLineHeight;
		if (this._lastRenderData && this._lastRenderData.linesEquals(layout)) {
			const _lastData = this._lastRenderData._get();
			return new RenderData(layout, _lastData.imageData, _lastData.lines);
		}
		const imageData = this._getBuffer();
		if (!imageData) return null;
		const [_dirtyY1, _dirtyY2, needed] = InnerMinimap._renderUntouchedLines(imageData, layout.topPaddingLineCount, startLineNumber, endLineNumber, minimapLineHeight, this._lastRenderData);
		const lineInfo = this._model.getMinimapLinesRenderingData(startLineNumber, endLineNumber, needed);
		const tabSize = this._model.getOptions().tabSize;
		const defaultBackground = this._model.options.defaultBackgroundColor;
		const background = this._model.options.backgroundColor;
		const foregroundAlpha = this._model.options.foregroundAlpha;
		const tokensColorTracker = this._model.tokensColorTracker;
		const useLighterFont = tokensColorTracker.backgroundIsLight();
		const renderMinimap = this._model.options.renderMinimap;
		const charRenderer = this._model.options.charRenderer();
		const fontScale = this._model.options.fontScale;
		const minimapCharWidth = this._model.options.minimapCharWidth;
		const renderMinimapLineHeight = (renderMinimap === 1 ? 2 : 3) * fontScale;
		const innerLinePadding = minimapLineHeight > renderMinimapLineHeight ? Math.floor((minimapLineHeight - renderMinimapLineHeight) / 2) : 0;
		const backgroundA = background.a / 255;
		const renderBackground = new RGBA8(Math.round((background.r - defaultBackground.r) * backgroundA + defaultBackground.r), Math.round((background.g - defaultBackground.g) * backgroundA + defaultBackground.g), Math.round((background.b - defaultBackground.b) * backgroundA + defaultBackground.b), 255);
		let dy = layout.topPaddingLineCount * minimapLineHeight;
		const renderedLines = [];
		for (let lineIndex = 0, lineCount = endLineNumber - startLineNumber + 1; lineIndex < lineCount; lineIndex++) {
			if (needed[lineIndex]) InnerMinimap._renderLine(imageData, renderBackground, background.a, useLighterFont, renderMinimap, minimapCharWidth, tokensColorTracker, foregroundAlpha, charRenderer, dy, innerLinePadding, tabSize, lineInfo[lineIndex], fontScale, minimapLineHeight);
			renderedLines[lineIndex] = new MinimapLine(dy);
			dy += minimapLineHeight;
		}
		const dirtyY1 = _dirtyY1 === -1 ? 0 : _dirtyY1;
		const dirtyHeight = (_dirtyY2 === -1 ? imageData.height : _dirtyY2) - dirtyY1;
		this._canvas.domNode.getContext("2d").putImageData(imageData, 0, 0, 0, dirtyY1, imageData.width, dirtyHeight);
		return new RenderData(layout, imageData, renderedLines);
	}
	static _renderUntouchedLines(target, topPaddingLineCount, startLineNumber, endLineNumber, minimapLineHeight, lastRenderData) {
		const needed = [];
		if (!lastRenderData) {
			for (let i = 0, len = endLineNumber - startLineNumber + 1; i < len; i++) needed[i] = true;
			return [
				-1,
				-1,
				needed
			];
		}
		const _lastData = lastRenderData._get();
		const lastTargetData = _lastData.imageData.data;
		const lastStartLineNumber = _lastData.rendLineNumberStart;
		const lastLines = _lastData.lines;
		const lastLinesLength = lastLines.length;
		const WIDTH = target.width;
		const targetData = target.data;
		const maxDestPixel = (endLineNumber - startLineNumber + 1) * minimapLineHeight * WIDTH * 4;
		let dirtyPixel1 = -1;
		let dirtyPixel2 = -1;
		let copySourceStart = -1;
		let copySourceEnd = -1;
		let copyDestStart = -1;
		let copyDestEnd = -1;
		let dest_dy = topPaddingLineCount * minimapLineHeight;
		for (let lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++) {
			const lineIndex = lineNumber - startLineNumber;
			const lastLineIndex = lineNumber - lastStartLineNumber;
			const source_dy = lastLineIndex >= 0 && lastLineIndex < lastLinesLength ? lastLines[lastLineIndex].dy : -1;
			if (source_dy === -1) {
				needed[lineIndex] = true;
				dest_dy += minimapLineHeight;
				continue;
			}
			const sourceStart = source_dy * WIDTH * 4;
			const sourceEnd = (source_dy + minimapLineHeight) * WIDTH * 4;
			const destStart = dest_dy * WIDTH * 4;
			const destEnd = (dest_dy + minimapLineHeight) * WIDTH * 4;
			if (copySourceEnd === sourceStart && copyDestEnd === destStart) {
				copySourceEnd = sourceEnd;
				copyDestEnd = destEnd;
			} else {
				if (copySourceStart !== -1) {
					targetData.set(lastTargetData.subarray(copySourceStart, copySourceEnd), copyDestStart);
					if (dirtyPixel1 === -1 && copySourceStart === 0 && copySourceStart === copyDestStart) dirtyPixel1 = copySourceEnd;
					if (dirtyPixel2 === -1 && copySourceEnd === maxDestPixel && copySourceStart === copyDestStart) dirtyPixel2 = copySourceStart;
				}
				copySourceStart = sourceStart;
				copySourceEnd = sourceEnd;
				copyDestStart = destStart;
				copyDestEnd = destEnd;
			}
			needed[lineIndex] = false;
			dest_dy += minimapLineHeight;
		}
		if (copySourceStart !== -1) {
			targetData.set(lastTargetData.subarray(copySourceStart, copySourceEnd), copyDestStart);
			if (dirtyPixel1 === -1 && copySourceStart === 0 && copySourceStart === copyDestStart) dirtyPixel1 = copySourceEnd;
			if (dirtyPixel2 === -1 && copySourceEnd === maxDestPixel && copySourceStart === copyDestStart) dirtyPixel2 = copySourceStart;
		}
		return [
			dirtyPixel1 === -1 ? -1 : dirtyPixel1 / (WIDTH * 4),
			dirtyPixel2 === -1 ? -1 : dirtyPixel2 / (WIDTH * 4),
			needed
		];
	}
	static _renderLine(target, backgroundColor, backgroundAlpha, useLighterFont, renderMinimap, charWidth, colorTracker, foregroundAlpha, minimapCharRenderer, dy, innerLinePadding, tabSize, lineData, fontScale, minimapLineHeight) {
		const content = lineData.content;
		const tokens = lineData.tokens;
		const maxDx = target.width - charWidth;
		const force1pxHeight = minimapLineHeight === 1;
		let dx = 8;
		let charIndex = 0;
		let tabsCharDelta = 0;
		for (let tokenIndex = 0, tokensLen = tokens.getCount(); tokenIndex < tokensLen; tokenIndex++) {
			const tokenEndIndex = tokens.getEndOffset(tokenIndex);
			const tokenColorId = tokens.getForeground(tokenIndex);
			const tokenColor = colorTracker.getColor(tokenColorId);
			for (; charIndex < tokenEndIndex; charIndex++) {
				if (dx > maxDx) return;
				const charCode = content.charCodeAt(charIndex);
				if (charCode === 9) {
					const insertSpacesCount = tabSize - (charIndex + tabsCharDelta) % tabSize;
					tabsCharDelta += insertSpacesCount - 1;
					dx += insertSpacesCount * charWidth;
				} else if (charCode === 32) dx += charWidth;
				else {
					const count = isFullWidthCharacter(charCode) ? 2 : 1;
					for (let i = 0; i < count; i++) {
						if (renderMinimap === 2) minimapCharRenderer.blockRenderChar(target, dx, dy + innerLinePadding, tokenColor, foregroundAlpha, backgroundColor, backgroundAlpha, force1pxHeight);
						else minimapCharRenderer.renderChar(target, dx, dy + innerLinePadding, charCode, tokenColor, foregroundAlpha, backgroundColor, backgroundAlpha, fontScale, useLighterFont, force1pxHeight);
						dx += charWidth;
						if (dx > maxDx) return;
					}
				}
			}
		}
	}
};
var ContiguousLineMap = class {
	constructor(startLineNumber, endLineNumber, defaultValue) {
		this._startLineNumber = startLineNumber;
		this._endLineNumber = endLineNumber;
		this._defaultValue = defaultValue;
		this._values = [];
		for (let i = 0, count = this._endLineNumber - this._startLineNumber + 1; i < count; i++) this._values[i] = defaultValue;
	}
	has(lineNumber) {
		return this.get(lineNumber) !== this._defaultValue;
	}
	set(lineNumber, value) {
		if (lineNumber < this._startLineNumber || lineNumber > this._endLineNumber) return;
		this._values[lineNumber - this._startLineNumber] = value;
	}
	get(lineNumber) {
		if (lineNumber < this._startLineNumber || lineNumber > this._endLineNumber) return this._defaultValue;
		return this._values[lineNumber - this._startLineNumber];
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/overlayWidgets/overlayWidgets.js
var ViewOverlayWidgets = class extends ViewPart {
	constructor(context, viewDomNode) {
		super(context);
		this._viewDomNode = viewDomNode;
		const layoutInfo = this._context.configuration.options.get(166);
		this._widgets = {};
		this._verticalScrollbarWidth = layoutInfo.verticalScrollbarWidth;
		this._minimapWidth = layoutInfo.minimap.minimapWidth;
		this._horizontalScrollbarHeight = layoutInfo.horizontalScrollbarHeight;
		this._editorHeight = layoutInfo.height;
		this._editorWidth = layoutInfo.width;
		this._viewDomNodeRect = {
			top: 0,
			left: 0,
			width: 0,
			height: 0
		};
		this._domNode = createFastDomNode(document.createElement("div"));
		PartFingerprints.write(this._domNode, 4);
		this._domNode.setClassName("overlayWidgets");
		this.overflowingOverlayWidgetsDomNode = createFastDomNode(document.createElement("div"));
		PartFingerprints.write(this.overflowingOverlayWidgetsDomNode, 5);
		this.overflowingOverlayWidgetsDomNode.setClassName("overflowingOverlayWidgets");
	}
	dispose() {
		super.dispose();
		this._widgets = {};
	}
	getDomNode() {
		return this._domNode;
	}
	onConfigurationChanged(e) {
		const layoutInfo = this._context.configuration.options.get(166);
		this._verticalScrollbarWidth = layoutInfo.verticalScrollbarWidth;
		this._minimapWidth = layoutInfo.minimap.minimapWidth;
		this._horizontalScrollbarHeight = layoutInfo.horizontalScrollbarHeight;
		this._editorHeight = layoutInfo.height;
		this._editorWidth = layoutInfo.width;
		return true;
	}
	_widgetCanOverflow(widget) {
		const allowOverflow = this._context.configuration.options.get(4);
		return (widget.allowEditorOverflow || false) && allowOverflow;
	}
	addWidget(widget) {
		const domNode = createFastDomNode(widget.getDomNode());
		this._widgets[widget.getId()] = {
			widget,
			preference: null,
			domNode
		};
		domNode.setPosition("absolute");
		domNode.setAttribute("widgetId", widget.getId());
		if (this._widgetCanOverflow(widget)) this.overflowingOverlayWidgetsDomNode.appendChild(domNode);
		else this._domNode.appendChild(domNode);
		this.setShouldRender();
		this._updateMaxMinWidth();
	}
	setWidgetPosition(widget, position) {
		const widgetData = this._widgets[widget.getId()];
		const preference = position ? position.preference : null;
		const stack = position?.stackOrdinal;
		if (widgetData.preference === preference && widgetData.stack === stack) {
			this._updateMaxMinWidth();
			return false;
		}
		widgetData.preference = preference;
		widgetData.stack = stack;
		this.setShouldRender();
		this._updateMaxMinWidth();
		return true;
	}
	removeWidget(widget) {
		const widgetId = widget.getId();
		if (this._widgets.hasOwnProperty(widgetId)) {
			const domNode = this._widgets[widgetId].domNode.domNode;
			delete this._widgets[widgetId];
			domNode.remove();
			this.setShouldRender();
			this._updateMaxMinWidth();
		}
	}
	_updateMaxMinWidth() {
		let maxMinWidth = 0;
		const keys = Object.keys(this._widgets);
		for (let i = 0, len = keys.length; i < len; i++) {
			const widgetId = keys[i];
			const widgetMinWidthInPx = this._widgets[widgetId].widget.getMinContentWidthInPx?.();
			if (typeof widgetMinWidthInPx !== "undefined") maxMinWidth = Math.max(maxMinWidth, widgetMinWidthInPx);
		}
		this._context.viewLayout.setOverlayWidgetsMinWidth(maxMinWidth);
	}
	_renderWidget(widgetData, stackCoordinates) {
		const domNode = widgetData.domNode;
		if (widgetData.preference === null) {
			domNode.setTop("");
			return;
		}
		const maxRight = 2 * this._verticalScrollbarWidth + this._minimapWidth;
		if (widgetData.preference === 0 || widgetData.preference === 1) {
			if (widgetData.preference === 1) {
				const widgetHeight = domNode.domNode.clientHeight;
				domNode.setTop(this._editorHeight - widgetHeight - 2 * this._horizontalScrollbarHeight);
			} else domNode.setTop(0);
			if (widgetData.stack !== void 0) {
				domNode.setTop(stackCoordinates[widgetData.preference]);
				stackCoordinates[widgetData.preference] += domNode.domNode.clientWidth;
			} else domNode.setRight(maxRight);
		} else if (widgetData.preference === 2) {
			domNode.domNode.style.right = "50%";
			if (widgetData.stack !== void 0) {
				domNode.setTop(stackCoordinates[2]);
				stackCoordinates[2] += domNode.domNode.clientHeight;
			} else domNode.setTop(0);
		} else {
			const { top, left } = widgetData.preference;
			if (this._context.configuration.options.get(51) && this._widgetCanOverflow(widgetData.widget)) {
				const editorBoundingBox = this._viewDomNodeRect;
				domNode.setTop(top + editorBoundingBox.top);
				domNode.setLeft(left + editorBoundingBox.left);
				domNode.setPosition("fixed");
			} else {
				domNode.setTop(top);
				domNode.setLeft(left);
				domNode.setPosition("absolute");
			}
		}
	}
	prepareRender(ctx) {
		this._viewDomNodeRect = getDomNodePagePosition(this._viewDomNode.domNode);
	}
	render(ctx) {
		this._domNode.setWidth(this._editorWidth);
		const keys = Object.keys(this._widgets);
		const stackCoordinates = Array.from({ length: 3 }, () => 0);
		keys.sort((a, b) => (this._widgets[a].stack || 0) - (this._widgets[b].stack || 0));
		for (let i = 0, len = keys.length; i < len; i++) {
			const widgetId = keys[i];
			this._renderWidget(this._widgets[widgetId], stackCoordinates);
		}
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/overviewRuler/decorationsOverviewRuler.js
var Settings = class {
	constructor(config, theme) {
		const options = config.options;
		this.lineHeight = options.get(75);
		this.pixelRatio = options.get(164);
		this.overviewRulerLanes = options.get(95);
		this.renderBorder = options.get(94);
		const borderColor = theme.getColor(editorOverviewRulerBorder);
		this.borderColor = borderColor ? borderColor.toString() : null;
		this.hideCursor = options.get(68);
		const cursorColorSingle = theme.getColor(editorCursorForeground);
		this.cursorColorSingle = cursorColorSingle ? cursorColorSingle.transparent(.7).toString() : null;
		const cursorColorPrimary = theme.getColor(editorMultiCursorPrimaryForeground);
		this.cursorColorPrimary = cursorColorPrimary ? cursorColorPrimary.transparent(.7).toString() : null;
		const cursorColorSecondary = theme.getColor(editorMultiCursorSecondaryForeground);
		this.cursorColorSecondary = cursorColorSecondary ? cursorColorSecondary.transparent(.7).toString() : null;
		this.themeType = theme.type;
		const minimapOpts = options.get(81);
		const minimapEnabled = minimapOpts.enabled;
		const minimapSide = minimapOpts.side;
		const themeColor = theme.getColor(editorOverviewRulerBackground);
		const defaultBackground = TokenizationRegistry.getDefaultBackground();
		if (themeColor) this.backgroundColor = themeColor;
		else if (minimapEnabled && minimapSide === "right") this.backgroundColor = defaultBackground;
		else this.backgroundColor = null;
		const position = options.get(166).overviewRuler;
		this.top = position.top;
		this.right = position.right;
		this.domWidth = position.width;
		this.domHeight = position.height;
		if (this.overviewRulerLanes === 0) {
			this.canvasWidth = 0;
			this.canvasHeight = 0;
		} else {
			this.canvasWidth = this.domWidth * this.pixelRatio | 0;
			this.canvasHeight = this.domHeight * this.pixelRatio | 0;
		}
		const [x, w] = this._initLanes(1, this.canvasWidth, this.overviewRulerLanes);
		this.x = x;
		this.w = w;
	}
	_initLanes(canvasLeftOffset, canvasWidth, laneCount) {
		const remainingWidth = canvasWidth - canvasLeftOffset;
		if (laneCount >= 3) {
			const leftWidth = Math.floor(remainingWidth / 3);
			const rightWidth = Math.floor(remainingWidth / 3);
			const centerWidth = remainingWidth - leftWidth - rightWidth;
			const leftOffset = canvasLeftOffset;
			const centerOffset = leftOffset + leftWidth;
			return [[
				0,
				leftOffset,
				centerOffset,
				leftOffset,
				leftOffset + leftWidth + centerWidth,
				leftOffset,
				centerOffset,
				leftOffset
			], [
				0,
				leftWidth,
				centerWidth,
				leftWidth + centerWidth,
				rightWidth,
				leftWidth + centerWidth + rightWidth,
				centerWidth + rightWidth,
				leftWidth + centerWidth + rightWidth
			]];
		} else if (laneCount === 2) {
			const leftWidth = Math.floor(remainingWidth / 2);
			const rightWidth = remainingWidth - leftWidth;
			const leftOffset = canvasLeftOffset;
			return [[
				0,
				leftOffset,
				leftOffset,
				leftOffset,
				leftOffset + leftWidth,
				leftOffset,
				leftOffset,
				leftOffset
			], [
				0,
				leftWidth,
				leftWidth,
				leftWidth,
				rightWidth,
				leftWidth + rightWidth,
				leftWidth + rightWidth,
				leftWidth + rightWidth
			]];
		} else {
			const offset = canvasLeftOffset;
			const width = remainingWidth;
			return [[
				0,
				offset,
				offset,
				offset,
				offset,
				offset,
				offset,
				offset
			], [
				0,
				width,
				width,
				width,
				width,
				width,
				width,
				width
			]];
		}
	}
	equals(other) {
		return this.lineHeight === other.lineHeight && this.pixelRatio === other.pixelRatio && this.overviewRulerLanes === other.overviewRulerLanes && this.renderBorder === other.renderBorder && this.borderColor === other.borderColor && this.hideCursor === other.hideCursor && this.cursorColorSingle === other.cursorColorSingle && this.cursorColorPrimary === other.cursorColorPrimary && this.cursorColorSecondary === other.cursorColorSecondary && this.themeType === other.themeType && Color.equals(this.backgroundColor, other.backgroundColor) && this.top === other.top && this.right === other.right && this.domWidth === other.domWidth && this.domHeight === other.domHeight && this.canvasWidth === other.canvasWidth && this.canvasHeight === other.canvasHeight;
	}
};
var DecorationsOverviewRuler = class extends ViewPart {
	constructor(context) {
		super(context);
		this._actualShouldRender = 0;
		this._renderedDecorations = [];
		this._renderedCursorPositions = [];
		this._domNode = createFastDomNode(document.createElement("canvas"));
		this._domNode.setClassName("decorationsOverviewRuler");
		this._domNode.setPosition("absolute");
		this._domNode.setLayerHinting(true);
		this._domNode.setContain("strict");
		this._domNode.setAttribute("aria-hidden", "true");
		this._updateSettings(false);
		this._tokensColorTrackerListener = TokenizationRegistry.onDidChange((e) => {
			if (e.changedColorMap) this._updateSettings(true);
		});
		this._cursorPositions = [{
			position: new Position$1(1, 1),
			color: this._settings.cursorColorSingle
		}];
	}
	dispose() {
		super.dispose();
		this._tokensColorTrackerListener.dispose();
	}
	_updateSettings(renderNow) {
		const newSettings = new Settings(this._context.configuration, this._context.theme);
		if (this._settings && this._settings.equals(newSettings)) return false;
		this._settings = newSettings;
		this._domNode.setTop(this._settings.top);
		this._domNode.setRight(this._settings.right);
		this._domNode.setWidth(this._settings.domWidth);
		this._domNode.setHeight(this._settings.domHeight);
		this._domNode.domNode.width = this._settings.canvasWidth;
		this._domNode.domNode.height = this._settings.canvasHeight;
		if (renderNow) this._render();
		return true;
	}
	_markRenderingIsNeeded() {
		this._actualShouldRender = 2;
		return true;
	}
	_markRenderingIsMaybeNeeded() {
		this._actualShouldRender = 1;
		return true;
	}
	onConfigurationChanged(e) {
		return this._updateSettings(false) ? this._markRenderingIsNeeded() : false;
	}
	onCursorStateChanged(e) {
		this._cursorPositions = [];
		for (let i = 0, len = e.selections.length; i < len; i++) {
			let color = this._settings.cursorColorSingle;
			if (len > 1) color = i === 0 ? this._settings.cursorColorPrimary : this._settings.cursorColorSecondary;
			this._cursorPositions.push({
				position: e.selections[i].getPosition(),
				color
			});
		}
		this._cursorPositions.sort((a, b) => Position$1.compare(a.position, b.position));
		return this._markRenderingIsMaybeNeeded();
	}
	onDecorationsChanged(e) {
		if (e.affectsOverviewRuler) return this._markRenderingIsMaybeNeeded();
		return false;
	}
	onFlushed(e) {
		return this._markRenderingIsNeeded();
	}
	onScrollChanged(e) {
		return e.scrollHeightChanged ? this._markRenderingIsNeeded() : false;
	}
	onZonesChanged(e) {
		return this._markRenderingIsNeeded();
	}
	onThemeChanged(e) {
		return this._updateSettings(false) ? this._markRenderingIsNeeded() : false;
	}
	getDomNode() {
		return this._domNode.domNode;
	}
	prepareRender(ctx) {}
	render(editorCtx) {
		this._render();
		this._actualShouldRender = 0;
	}
	_render() {
		const backgroundColor = this._settings.backgroundColor;
		if (this._settings.overviewRulerLanes === 0) {
			this._domNode.setBackgroundColor(backgroundColor ? Color.Format.CSS.formatHexA(backgroundColor) : "");
			this._domNode.setDisplay("none");
			return;
		}
		const decorations = this._context.viewModel.getAllOverviewRulerDecorations(this._context.theme);
		decorations.sort(OverviewRulerDecorationsGroup.compareByRenderingProps);
		if (this._actualShouldRender === 1 && !OverviewRulerDecorationsGroup.equalsArr(this._renderedDecorations, decorations)) this._actualShouldRender = 2;
		if (this._actualShouldRender === 1 && !equals$1(this._renderedCursorPositions, this._cursorPositions, (a, b) => a.position.lineNumber === b.position.lineNumber && a.color === b.color)) this._actualShouldRender = 2;
		if (this._actualShouldRender === 1) return;
		this._renderedDecorations = decorations;
		this._renderedCursorPositions = this._cursorPositions;
		this._domNode.setDisplay("block");
		const canvasWidth = this._settings.canvasWidth;
		const canvasHeight = this._settings.canvasHeight;
		const lineHeight = this._settings.lineHeight;
		const viewLayout = this._context.viewLayout;
		const heightRatio = canvasHeight / this._context.viewLayout.getScrollHeight();
		const minDecorationHeight = 6 * this._settings.pixelRatio | 0;
		const halfMinDecorationHeight = minDecorationHeight / 2 | 0;
		const canvasCtx = this._domNode.domNode.getContext("2d");
		if (backgroundColor) {
			if (backgroundColor.isOpaque()) {
				canvasCtx.fillStyle = Color.Format.CSS.formatHexA(backgroundColor);
				canvasCtx.fillRect(0, 0, canvasWidth, canvasHeight);
			} else {
				canvasCtx.clearRect(0, 0, canvasWidth, canvasHeight);
				canvasCtx.fillStyle = Color.Format.CSS.formatHexA(backgroundColor);
				canvasCtx.fillRect(0, 0, canvasWidth, canvasHeight);
			}
		} else canvasCtx.clearRect(0, 0, canvasWidth, canvasHeight);
		const x = this._settings.x;
		const w = this._settings.w;
		for (const decorationGroup of decorations) {
			const color = decorationGroup.color;
			const decorationGroupData = decorationGroup.data;
			canvasCtx.fillStyle = color;
			let prevLane = 0;
			let prevY1 = 0;
			let prevY2 = 0;
			for (let i = 0, len = decorationGroupData.length / 3; i < len; i++) {
				const lane = decorationGroupData[3 * i];
				const startLineNumber = decorationGroupData[3 * i + 1];
				const endLineNumber = decorationGroupData[3 * i + 2];
				let y1 = viewLayout.getVerticalOffsetForLineNumber(startLineNumber) * heightRatio | 0;
				let y2 = (viewLayout.getVerticalOffsetForLineNumber(endLineNumber) + lineHeight) * heightRatio | 0;
				if (y2 - y1 < minDecorationHeight) {
					let yCenter = (y1 + y2) / 2 | 0;
					if (yCenter < halfMinDecorationHeight) yCenter = halfMinDecorationHeight;
					else if (yCenter + halfMinDecorationHeight > canvasHeight) yCenter = canvasHeight - halfMinDecorationHeight;
					y1 = yCenter - halfMinDecorationHeight;
					y2 = yCenter + halfMinDecorationHeight;
				}
				if (y1 > prevY2 + 1 || lane !== prevLane) {
					if (i !== 0) canvasCtx.fillRect(x[prevLane], prevY1, w[prevLane], prevY2 - prevY1);
					prevLane = lane;
					prevY1 = y1;
					prevY2 = y2;
				} else if (y2 > prevY2) prevY2 = y2;
			}
			canvasCtx.fillRect(x[prevLane], prevY1, w[prevLane], prevY2 - prevY1);
		}
		if (!this._settings.hideCursor) {
			const cursorHeight = 2 * this._settings.pixelRatio | 0;
			const halfCursorHeight = cursorHeight / 2 | 0;
			const cursorX = this._settings.x[7];
			const cursorW = this._settings.w[7];
			let prevY1 = -100;
			let prevY2 = -100;
			let prevColor = null;
			for (let i = 0, len = this._cursorPositions.length; i < len; i++) {
				const color = this._cursorPositions[i].color;
				if (!color) continue;
				const cursor = this._cursorPositions[i].position;
				let yCenter = viewLayout.getVerticalOffsetForLineNumber(cursor.lineNumber) * heightRatio | 0;
				if (yCenter < halfCursorHeight) yCenter = halfCursorHeight;
				else if (yCenter + halfCursorHeight > canvasHeight) yCenter = canvasHeight - halfCursorHeight;
				const y1 = yCenter - halfCursorHeight;
				const y2 = y1 + cursorHeight;
				if (y1 > prevY2 + 1 || color !== prevColor) {
					if (i !== 0 && prevColor) canvasCtx.fillRect(cursorX, prevY1, cursorW, prevY2 - prevY1);
					prevY1 = y1;
					prevY2 = y2;
				} else if (y2 > prevY2) prevY2 = y2;
				prevColor = color;
				canvasCtx.fillStyle = color;
			}
			if (prevColor) canvasCtx.fillRect(cursorX, prevY1, cursorW, prevY2 - prevY1);
		}
		if (this._settings.renderBorder && this._settings.borderColor && this._settings.overviewRulerLanes > 0) {
			canvasCtx.beginPath();
			canvasCtx.lineWidth = 1;
			canvasCtx.strokeStyle = this._settings.borderColor;
			canvasCtx.moveTo(0, 0);
			canvasCtx.lineTo(0, canvasHeight);
			canvasCtx.moveTo(1, 0);
			canvasCtx.lineTo(canvasWidth, 0);
			canvasCtx.stroke();
		}
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/viewModel/overviewZoneManager.js
var ColorZone = class {
	constructor(from, to, colorId) {
		this._colorZoneBrand = void 0;
		this.from = from | 0;
		this.to = to | 0;
		this.colorId = colorId | 0;
	}
	static compare(a, b) {
		if (a.colorId === b.colorId) {
			if (a.from === b.from) return a.to - b.to;
			return a.from - b.from;
		}
		return a.colorId - b.colorId;
	}
};
/**
* A zone in the overview ruler
*/
var OverviewRulerZone = class {
	constructor(startLineNumber, endLineNumber, heightInLines, color) {
		this._overviewRulerZoneBrand = void 0;
		this.startLineNumber = startLineNumber;
		this.endLineNumber = endLineNumber;
		this.heightInLines = heightInLines;
		this.color = color;
		this._colorZone = null;
	}
	static compare(a, b) {
		if (a.color === b.color) {
			if (a.startLineNumber === b.startLineNumber) {
				if (a.heightInLines === b.heightInLines) return a.endLineNumber - b.endLineNumber;
				return a.heightInLines - b.heightInLines;
			}
			return a.startLineNumber - b.startLineNumber;
		}
		return a.color < b.color ? -1 : 1;
	}
	setColorZone(colorZone) {
		this._colorZone = colorZone;
	}
	getColorZones() {
		return this._colorZone;
	}
};
var OverviewZoneManager = class {
	constructor(getVerticalOffsetForLine) {
		this._getVerticalOffsetForLine = getVerticalOffsetForLine;
		this._zones = [];
		this._colorZonesInvalid = false;
		this._lineHeight = 0;
		this._domWidth = 0;
		this._domHeight = 0;
		this._outerHeight = 0;
		this._pixelRatio = 1;
		this._lastAssignedId = 0;
		this._color2Id = Object.create(null);
		this._id2Color = [];
	}
	getId2Color() {
		return this._id2Color;
	}
	setZones(newZones) {
		this._zones = newZones;
		this._zones.sort(OverviewRulerZone.compare);
	}
	setLineHeight(lineHeight) {
		if (this._lineHeight === lineHeight) return false;
		this._lineHeight = lineHeight;
		this._colorZonesInvalid = true;
		return true;
	}
	setPixelRatio(pixelRatio) {
		this._pixelRatio = pixelRatio;
		this._colorZonesInvalid = true;
	}
	getDOMWidth() {
		return this._domWidth;
	}
	getCanvasWidth() {
		return this._domWidth * this._pixelRatio;
	}
	setDOMWidth(width) {
		if (this._domWidth === width) return false;
		this._domWidth = width;
		this._colorZonesInvalid = true;
		return true;
	}
	getDOMHeight() {
		return this._domHeight;
	}
	getCanvasHeight() {
		return this._domHeight * this._pixelRatio;
	}
	setDOMHeight(height) {
		if (this._domHeight === height) return false;
		this._domHeight = height;
		this._colorZonesInvalid = true;
		return true;
	}
	getOuterHeight() {
		return this._outerHeight;
	}
	setOuterHeight(outerHeight) {
		if (this._outerHeight === outerHeight) return false;
		this._outerHeight = outerHeight;
		this._colorZonesInvalid = true;
		return true;
	}
	resolveColorZones() {
		const colorZonesInvalid = this._colorZonesInvalid;
		const lineHeight = Math.floor(this._lineHeight);
		const totalHeight = Math.floor(this.getCanvasHeight());
		const heightRatio = totalHeight / Math.floor(this._outerHeight);
		const halfMinimumHeight = Math.floor(4 * this._pixelRatio / 2);
		const allColorZones = [];
		for (let i = 0, len = this._zones.length; i < len; i++) {
			const zone = this._zones[i];
			if (!colorZonesInvalid) {
				const colorZone = zone.getColorZones();
				if (colorZone) {
					allColorZones.push(colorZone);
					continue;
				}
			}
			const offset1 = this._getVerticalOffsetForLine(zone.startLineNumber);
			const offset2 = zone.heightInLines === 0 ? this._getVerticalOffsetForLine(zone.endLineNumber) + lineHeight : offset1 + zone.heightInLines * lineHeight;
			const y1 = Math.floor(heightRatio * offset1);
			const y2 = Math.floor(heightRatio * offset2);
			let ycenter = Math.floor((y1 + y2) / 2);
			let halfHeight = y2 - ycenter;
			if (halfHeight < halfMinimumHeight) halfHeight = halfMinimumHeight;
			if (ycenter - halfHeight < 0) ycenter = halfHeight;
			if (ycenter + halfHeight > totalHeight) ycenter = totalHeight - halfHeight;
			const color = zone.color;
			let colorId = this._color2Id[color];
			if (!colorId) {
				colorId = ++this._lastAssignedId;
				this._color2Id[color] = colorId;
				this._id2Color[colorId] = color;
			}
			const colorZone = new ColorZone(ycenter - halfHeight, ycenter + halfHeight, colorId);
			zone.setColorZone(colorZone);
			allColorZones.push(colorZone);
		}
		this._colorZonesInvalid = false;
		allColorZones.sort(ColorZone.compare);
		return allColorZones;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/overviewRuler/overviewRuler.js
/**
* The overview ruler appears underneath the editor scroll bar and shows things
* like the cursor, various decorations, etc.
*/
var OverviewRuler = class extends ViewEventHandler {
	constructor(context, cssClassName) {
		super();
		this._context = context;
		const options = this._context.configuration.options;
		this._domNode = createFastDomNode(document.createElement("canvas"));
		this._domNode.setClassName(cssClassName);
		this._domNode.setPosition("absolute");
		this._domNode.setLayerHinting(true);
		this._domNode.setContain("strict");
		this._zoneManager = new OverviewZoneManager((lineNumber) => this._context.viewLayout.getVerticalOffsetForLineNumber(lineNumber));
		this._zoneManager.setDOMWidth(0);
		this._zoneManager.setDOMHeight(0);
		this._zoneManager.setOuterHeight(this._context.viewLayout.getScrollHeight());
		this._zoneManager.setLineHeight(options.get(75));
		this._zoneManager.setPixelRatio(options.get(164));
		this._context.addEventHandler(this);
	}
	dispose() {
		this._context.removeEventHandler(this);
		super.dispose();
	}
	onConfigurationChanged(e) {
		const options = this._context.configuration.options;
		if (e.hasChanged(75)) {
			this._zoneManager.setLineHeight(options.get(75));
			this._render();
		}
		if (e.hasChanged(164)) {
			this._zoneManager.setPixelRatio(options.get(164));
			this._domNode.setWidth(this._zoneManager.getDOMWidth());
			this._domNode.setHeight(this._zoneManager.getDOMHeight());
			this._domNode.domNode.width = this._zoneManager.getCanvasWidth();
			this._domNode.domNode.height = this._zoneManager.getCanvasHeight();
			this._render();
		}
		return true;
	}
	onFlushed(e) {
		this._render();
		return true;
	}
	onScrollChanged(e) {
		if (e.scrollHeightChanged) {
			this._zoneManager.setOuterHeight(e.scrollHeight);
			this._render();
		}
		return true;
	}
	onZonesChanged(e) {
		this._render();
		return true;
	}
	getDomNode() {
		return this._domNode.domNode;
	}
	setLayout(position) {
		this._domNode.setTop(position.top);
		this._domNode.setRight(position.right);
		let hasChanged = false;
		hasChanged = this._zoneManager.setDOMWidth(position.width) || hasChanged;
		hasChanged = this._zoneManager.setDOMHeight(position.height) || hasChanged;
		if (hasChanged) {
			this._domNode.setWidth(this._zoneManager.getDOMWidth());
			this._domNode.setHeight(this._zoneManager.getDOMHeight());
			this._domNode.domNode.width = this._zoneManager.getCanvasWidth();
			this._domNode.domNode.height = this._zoneManager.getCanvasHeight();
			this._render();
		}
	}
	setZones(zones) {
		this._zoneManager.setZones(zones);
		this._render();
	}
	_render() {
		if (this._zoneManager.getOuterHeight() === 0) return false;
		const width = this._zoneManager.getCanvasWidth();
		const height = this._zoneManager.getCanvasHeight();
		const colorZones = this._zoneManager.resolveColorZones();
		const id2Color = this._zoneManager.getId2Color();
		const ctx = this._domNode.domNode.getContext("2d");
		ctx.clearRect(0, 0, width, height);
		if (colorZones.length > 0) this._renderOneLane(ctx, colorZones, id2Color, width);
		return true;
	}
	_renderOneLane(ctx, colorZones, id2Color, width) {
		let currentColorId = 0;
		let currentFrom = 0;
		let currentTo = 0;
		for (const zone of colorZones) {
			const zoneColorId = zone.colorId;
			const zoneFrom = zone.from;
			const zoneTo = zone.to;
			if (zoneColorId !== currentColorId) {
				if (currentColorId !== 0) ctx.fillRect(0, currentFrom, width, currentTo - currentFrom);
				currentColorId = zoneColorId;
				ctx.fillStyle = id2Color[currentColorId];
				currentFrom = zoneFrom;
				currentTo = zoneTo;
			} else if (currentTo >= zoneFrom) currentTo = Math.max(currentTo, zoneTo);
			else {
				ctx.fillRect(0, currentFrom, width, currentTo - currentFrom);
				currentFrom = zoneFrom;
				currentTo = zoneTo;
			}
		}
		ctx.fillRect(0, currentFrom, width, currentTo - currentFrom);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/rulers/rulers.js
/**
* Rulers are vertical lines that appear at certain columns in the editor. There can be >= 0 rulers
* at a time.
*/
var Rulers = class extends ViewPart {
	constructor(context) {
		super(context);
		this.domNode = createFastDomNode(document.createElement("div"));
		this.domNode.setAttribute("role", "presentation");
		this.domNode.setAttribute("aria-hidden", "true");
		this.domNode.setClassName("view-rulers");
		this._renderedRulers = [];
		const options = this._context.configuration.options;
		this._rulers = options.get(116);
		this._typicalHalfwidthCharacterWidth = options.get(59).typicalHalfwidthCharacterWidth;
	}
	onConfigurationChanged(e) {
		const options = this._context.configuration.options;
		this._rulers = options.get(116);
		this._typicalHalfwidthCharacterWidth = options.get(59).typicalHalfwidthCharacterWidth;
		return true;
	}
	onScrollChanged(e) {
		return e.scrollHeightChanged;
	}
	prepareRender(ctx) {}
	_ensureRulersCount() {
		const currentCount = this._renderedRulers.length;
		const desiredCount = this._rulers.length;
		if (currentCount === desiredCount) return;
		if (currentCount < desiredCount) {
			let addCount = desiredCount - currentCount;
			while (addCount > 0) {
				const node = createFastDomNode(document.createElement("div"));
				node.setClassName("view-ruler");
				node.setWidth("1ch");
				this.domNode.appendChild(node);
				this._renderedRulers.push(node);
				addCount--;
			}
			return;
		}
		let removeCount = currentCount - desiredCount;
		while (removeCount > 0) {
			const node = this._renderedRulers.pop();
			this.domNode.removeChild(node);
			removeCount--;
		}
	}
	render(ctx) {
		this._ensureRulersCount();
		for (let i = 0, len = this._rulers.length; i < len; i++) {
			const node = this._renderedRulers[i];
			const ruler = this._rulers[i];
			node.setBoxShadow(ruler.color ? `1px 0 0 0 ${ruler.color} inset` : ``);
			node.setHeight(Math.min(ctx.scrollHeight, 1e6));
			node.setLeft(ruler.column * this._typicalHalfwidthCharacterWidth);
		}
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/scrollDecoration/scrollDecoration.js
var ScrollDecorationViewPart = class extends ViewPart {
	constructor(context) {
		super(context);
		this._scrollTop = 0;
		this._width = 0;
		this._updateWidth();
		this._shouldShow = false;
		const scrollbar = this._context.configuration.options.get(117);
		this._useShadows = scrollbar.useShadows;
		this._domNode = createFastDomNode(document.createElement("div"));
		this._domNode.setAttribute("role", "presentation");
		this._domNode.setAttribute("aria-hidden", "true");
	}
	_updateShouldShow() {
		const newShouldShow = this._useShadows && this._scrollTop > 0;
		if (this._shouldShow !== newShouldShow) {
			this._shouldShow = newShouldShow;
			return true;
		}
		return false;
	}
	getDomNode() {
		return this._domNode;
	}
	_updateWidth() {
		const layoutInfo = this._context.configuration.options.get(166);
		if (layoutInfo.minimap.renderMinimap === 0 || layoutInfo.minimap.minimapWidth > 0 && layoutInfo.minimap.minimapLeft === 0) this._width = layoutInfo.width;
		else this._width = layoutInfo.width - layoutInfo.verticalScrollbarWidth;
	}
	onConfigurationChanged(e) {
		const scrollbar = this._context.configuration.options.get(117);
		this._useShadows = scrollbar.useShadows;
		this._updateWidth();
		this._updateShouldShow();
		return true;
	}
	onScrollChanged(e) {
		this._scrollTop = e.scrollTop;
		return this._updateShouldShow();
	}
	prepareRender(ctx) {}
	render(ctx) {
		this._domNode.setWidth(this._width);
		this._domNode.setClassName(this._shouldShow ? "scroll-decoration" : "");
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/selections/selections.js
var HorizontalRangeWithStyle = class {
	constructor(other) {
		this.left = other.left;
		this.width = other.width;
		this.startStyle = null;
		this.endStyle = null;
	}
};
var LineVisibleRangesWithStyle = class {
	constructor(lineNumber, ranges) {
		this.lineNumber = lineNumber;
		this.ranges = ranges;
	}
};
function toStyledRange(item) {
	return new HorizontalRangeWithStyle(item);
}
function toStyled(item) {
	return new LineVisibleRangesWithStyle(item.lineNumber, item.ranges.map(toStyledRange));
}
/**
* This view part displays selected text to the user. Every line has its own selection overlay.
*/
var SelectionsOverlay = class SelectionsOverlay extends DynamicViewOverlay {
	static {
		this.SELECTION_CLASS_NAME = "selected-text";
	}
	static {
		this.SELECTION_TOP_LEFT = "top-left-radius";
	}
	static {
		this.SELECTION_BOTTOM_LEFT = "bottom-left-radius";
	}
	static {
		this.SELECTION_TOP_RIGHT = "top-right-radius";
	}
	static {
		this.SELECTION_BOTTOM_RIGHT = "bottom-right-radius";
	}
	static {
		this.EDITOR_BACKGROUND_CLASS_NAME = "monaco-editor-background";
	}
	static {
		this.ROUNDED_PIECE_WIDTH = 10;
	}
	constructor(context) {
		super();
		this._previousFrameVisibleRangesWithStyle = [];
		this._context = context;
		const options = this._context.configuration.options;
		this._roundedSelection = options.get(115);
		this._typicalHalfwidthCharacterWidth = options.get(59).typicalHalfwidthCharacterWidth;
		this._selections = [];
		this._renderResult = null;
		this._context.addEventHandler(this);
	}
	dispose() {
		this._context.removeEventHandler(this);
		this._renderResult = null;
		super.dispose();
	}
	onConfigurationChanged(e) {
		const options = this._context.configuration.options;
		this._roundedSelection = options.get(115);
		this._typicalHalfwidthCharacterWidth = options.get(59).typicalHalfwidthCharacterWidth;
		return true;
	}
	onCursorStateChanged(e) {
		this._selections = e.selections.slice(0);
		return true;
	}
	onDecorationsChanged(e) {
		return true;
	}
	onFlushed(e) {
		return true;
	}
	onLinesChanged(e) {
		return true;
	}
	onLinesDeleted(e) {
		return true;
	}
	onLinesInserted(e) {
		return true;
	}
	onScrollChanged(e) {
		return e.scrollTopChanged;
	}
	onZonesChanged(e) {
		return true;
	}
	_visibleRangesHaveGaps(linesVisibleRanges) {
		for (let i = 0, len = linesVisibleRanges.length; i < len; i++) if (linesVisibleRanges[i].ranges.length > 1) return true;
		return false;
	}
	_enrichVisibleRangesWithStyle(viewport, linesVisibleRanges, previousFrame) {
		const epsilon = this._typicalHalfwidthCharacterWidth / 4;
		let previousFrameTop = null;
		let previousFrameBottom = null;
		if (previousFrame && previousFrame.length > 0 && linesVisibleRanges.length > 0) {
			const topLineNumber = linesVisibleRanges[0].lineNumber;
			if (topLineNumber === viewport.startLineNumber) {
				for (let i = 0; !previousFrameTop && i < previousFrame.length; i++) if (previousFrame[i].lineNumber === topLineNumber) previousFrameTop = previousFrame[i].ranges[0];
			}
			const bottomLineNumber = linesVisibleRanges[linesVisibleRanges.length - 1].lineNumber;
			if (bottomLineNumber === viewport.endLineNumber) {
				for (let i = previousFrame.length - 1; !previousFrameBottom && i >= 0; i--) if (previousFrame[i].lineNumber === bottomLineNumber) previousFrameBottom = previousFrame[i].ranges[0];
			}
			if (previousFrameTop && !previousFrameTop.startStyle) previousFrameTop = null;
			if (previousFrameBottom && !previousFrameBottom.startStyle) previousFrameBottom = null;
		}
		for (let i = 0, len = linesVisibleRanges.length; i < len; i++) {
			const curLineRange = linesVisibleRanges[i].ranges[0];
			const curLeft = curLineRange.left;
			const curRight = curLineRange.left + curLineRange.width;
			const startStyle = {
				top: 0,
				bottom: 0
			};
			const endStyle = {
				top: 0,
				bottom: 0
			};
			if (i > 0) {
				const prevLeft = linesVisibleRanges[i - 1].ranges[0].left;
				const prevRight = linesVisibleRanges[i - 1].ranges[0].left + linesVisibleRanges[i - 1].ranges[0].width;
				if (abs(curLeft - prevLeft) < epsilon) startStyle.top = 2;
				else if (curLeft > prevLeft) startStyle.top = 1;
				if (abs(curRight - prevRight) < epsilon) endStyle.top = 2;
				else if (prevLeft < curRight && curRight < prevRight) endStyle.top = 1;
			} else if (previousFrameTop) {
				startStyle.top = previousFrameTop.startStyle.top;
				endStyle.top = previousFrameTop.endStyle.top;
			}
			if (i + 1 < len) {
				const nextLeft = linesVisibleRanges[i + 1].ranges[0].left;
				const nextRight = linesVisibleRanges[i + 1].ranges[0].left + linesVisibleRanges[i + 1].ranges[0].width;
				if (abs(curLeft - nextLeft) < epsilon) startStyle.bottom = 2;
				else if (nextLeft < curLeft && curLeft < nextRight) startStyle.bottom = 1;
				if (abs(curRight - nextRight) < epsilon) endStyle.bottom = 2;
				else if (curRight < nextRight) endStyle.bottom = 1;
			} else if (previousFrameBottom) {
				startStyle.bottom = previousFrameBottom.startStyle.bottom;
				endStyle.bottom = previousFrameBottom.endStyle.bottom;
			}
			curLineRange.startStyle = startStyle;
			curLineRange.endStyle = endStyle;
		}
	}
	_getVisibleRangesWithStyle(selection, ctx, previousFrame) {
		const linesVisibleRanges = (ctx.linesVisibleRangesForRange(selection, true) || []).map(toStyled);
		if (!this._visibleRangesHaveGaps(linesVisibleRanges) && this._roundedSelection) this._enrichVisibleRangesWithStyle(ctx.visibleRange, linesVisibleRanges, previousFrame);
		return linesVisibleRanges;
	}
	_createSelectionPiece(top, bottom, className, left, width) {
		return "<div class=\"cslr " + className + "\" style=\"top:" + top.toString() + "px;bottom:" + bottom.toString() + "px;left:" + left.toString() + "px;width:" + width.toString() + "px;\"></div>";
	}
	_actualRenderOneSelection(output2, visibleStartLineNumber, hasMultipleSelections, visibleRanges) {
		if (visibleRanges.length === 0) return;
		const visibleRangesHaveStyle = !!visibleRanges[0].ranges[0].startStyle;
		const firstLineNumber = visibleRanges[0].lineNumber;
		const lastLineNumber = visibleRanges[visibleRanges.length - 1].lineNumber;
		for (let i = 0, len = visibleRanges.length; i < len; i++) {
			const lineVisibleRanges = visibleRanges[i];
			const lineNumber = lineVisibleRanges.lineNumber;
			const lineIndex = lineNumber - visibleStartLineNumber;
			const top = hasMultipleSelections ? lineNumber === firstLineNumber ? 1 : 0 : 0;
			const bottom = hasMultipleSelections ? lineNumber !== firstLineNumber && lineNumber === lastLineNumber ? 1 : 0 : 0;
			let innerCornerOutput = "";
			let restOfSelectionOutput = "";
			for (let j = 0, lenJ = lineVisibleRanges.ranges.length; j < lenJ; j++) {
				const visibleRange = lineVisibleRanges.ranges[j];
				if (visibleRangesHaveStyle) {
					const startStyle = visibleRange.startStyle;
					const endStyle = visibleRange.endStyle;
					if (startStyle.top === 1 || startStyle.bottom === 1) {
						innerCornerOutput += this._createSelectionPiece(top, bottom, SelectionsOverlay.SELECTION_CLASS_NAME, visibleRange.left - SelectionsOverlay.ROUNDED_PIECE_WIDTH, SelectionsOverlay.ROUNDED_PIECE_WIDTH);
						let className = SelectionsOverlay.EDITOR_BACKGROUND_CLASS_NAME;
						if (startStyle.top === 1) className += " " + SelectionsOverlay.SELECTION_TOP_RIGHT;
						if (startStyle.bottom === 1) className += " " + SelectionsOverlay.SELECTION_BOTTOM_RIGHT;
						innerCornerOutput += this._createSelectionPiece(top, bottom, className, visibleRange.left - SelectionsOverlay.ROUNDED_PIECE_WIDTH, SelectionsOverlay.ROUNDED_PIECE_WIDTH);
					}
					if (endStyle.top === 1 || endStyle.bottom === 1) {
						innerCornerOutput += this._createSelectionPiece(top, bottom, SelectionsOverlay.SELECTION_CLASS_NAME, visibleRange.left + visibleRange.width, SelectionsOverlay.ROUNDED_PIECE_WIDTH);
						let className = SelectionsOverlay.EDITOR_BACKGROUND_CLASS_NAME;
						if (endStyle.top === 1) className += " " + SelectionsOverlay.SELECTION_TOP_LEFT;
						if (endStyle.bottom === 1) className += " " + SelectionsOverlay.SELECTION_BOTTOM_LEFT;
						innerCornerOutput += this._createSelectionPiece(top, bottom, className, visibleRange.left + visibleRange.width, SelectionsOverlay.ROUNDED_PIECE_WIDTH);
					}
				}
				let className = SelectionsOverlay.SELECTION_CLASS_NAME;
				if (visibleRangesHaveStyle) {
					const startStyle = visibleRange.startStyle;
					const endStyle = visibleRange.endStyle;
					if (startStyle.top === 0) className += " " + SelectionsOverlay.SELECTION_TOP_LEFT;
					if (startStyle.bottom === 0) className += " " + SelectionsOverlay.SELECTION_BOTTOM_LEFT;
					if (endStyle.top === 0) className += " " + SelectionsOverlay.SELECTION_TOP_RIGHT;
					if (endStyle.bottom === 0) className += " " + SelectionsOverlay.SELECTION_BOTTOM_RIGHT;
				}
				restOfSelectionOutput += this._createSelectionPiece(top, bottom, className, visibleRange.left, visibleRange.width);
			}
			output2[lineIndex][0] += innerCornerOutput;
			output2[lineIndex][1] += restOfSelectionOutput;
		}
	}
	prepareRender(ctx) {
		const output = [];
		const visibleStartLineNumber = ctx.visibleRange.startLineNumber;
		const visibleEndLineNumber = ctx.visibleRange.endLineNumber;
		for (let lineNumber = visibleStartLineNumber; lineNumber <= visibleEndLineNumber; lineNumber++) {
			const lineIndex = lineNumber - visibleStartLineNumber;
			output[lineIndex] = ["", ""];
		}
		const thisFrameVisibleRangesWithStyle = [];
		for (let i = 0, len = this._selections.length; i < len; i++) {
			const selection = this._selections[i];
			if (selection.isEmpty()) {
				thisFrameVisibleRangesWithStyle[i] = null;
				continue;
			}
			const visibleRangesWithStyle = this._getVisibleRangesWithStyle(selection, ctx, this._previousFrameVisibleRangesWithStyle[i]);
			thisFrameVisibleRangesWithStyle[i] = visibleRangesWithStyle;
			this._actualRenderOneSelection(output, visibleStartLineNumber, this._selections.length > 1, visibleRangesWithStyle);
		}
		this._previousFrameVisibleRangesWithStyle = thisFrameVisibleRangesWithStyle;
		this._renderResult = output.map(([internalCorners, restOfSelection]) => internalCorners + restOfSelection);
	}
	render(startLineNumber, lineNumber) {
		if (!this._renderResult) return "";
		const lineIndex = lineNumber - startLineNumber;
		if (lineIndex < 0 || lineIndex >= this._renderResult.length) return "";
		return this._renderResult[lineIndex];
	}
};
registerThemingParticipant((theme, collector) => {
	const editorSelectionForegroundColor = theme.getColor(editorSelectionForeground);
	if (editorSelectionForegroundColor && !editorSelectionForegroundColor.isTransparent()) collector.addRule(`.monaco-editor .view-line span.inline-selected-text { color: ${editorSelectionForegroundColor}; }`);
});
function abs(n) {
	return n < 0 ? -n : n;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/viewCursors/viewCursor.js
var ViewCursorRenderData = class {
	constructor(top, left, paddingLeft, width, height, textContent, textContentClassName) {
		this.top = top;
		this.left = left;
		this.paddingLeft = paddingLeft;
		this.width = width;
		this.height = height;
		this.textContent = textContent;
		this.textContentClassName = textContentClassName;
	}
};
var CursorPlurality;
(function(CursorPlurality) {
	CursorPlurality[CursorPlurality["Single"] = 0] = "Single";
	CursorPlurality[CursorPlurality["MultiPrimary"] = 1] = "MultiPrimary";
	CursorPlurality[CursorPlurality["MultiSecondary"] = 2] = "MultiSecondary";
})(CursorPlurality || (CursorPlurality = {}));
var ViewCursor = class {
	constructor(context, plurality) {
		this._context = context;
		const options = this._context.configuration.options;
		const fontInfo = options.get(59);
		this._cursorStyle = options.get(162);
		this._typicalHalfwidthCharacterWidth = fontInfo.typicalHalfwidthCharacterWidth;
		this._lineCursorWidth = Math.min(options.get(37), this._typicalHalfwidthCharacterWidth);
		this._lineCursorHeight = options.get(38);
		this._isVisible = true;
		this._domNode = createFastDomNode(document.createElement("div"));
		this._domNode.setClassName(`cursor ${MOUSE_CURSOR_TEXT_CSS_CLASS_NAME}`);
		this._domNode.setHeight(this._context.viewLayout.getLineHeightForLineNumber(1));
		this._domNode.setTop(0);
		this._domNode.setLeft(0);
		applyFontInfo(this._domNode, fontInfo);
		this._domNode.setDisplay("none");
		this._position = new Position$1(1, 1);
		this._pluralityClass = "";
		this.setPlurality(plurality);
		this._lastRenderedContent = "";
		this._renderData = null;
	}
	getDomNode() {
		return this._domNode;
	}
	getPosition() {
		return this._position;
	}
	setPlurality(plurality) {
		switch (plurality) {
			default:
			case CursorPlurality.Single:
				this._pluralityClass = "";
				break;
			case CursorPlurality.MultiPrimary:
				this._pluralityClass = "cursor-primary";
				break;
			case CursorPlurality.MultiSecondary: this._pluralityClass = "cursor-secondary";
		}
	}
	show() {
		if (!this._isVisible) {
			this._domNode.setVisibility("inherit");
			this._isVisible = true;
		}
	}
	hide() {
		if (this._isVisible) {
			this._domNode.setVisibility("hidden");
			this._isVisible = false;
		}
	}
	onConfigurationChanged(e) {
		const options = this._context.configuration.options;
		const fontInfo = options.get(59);
		this._cursorStyle = options.get(162);
		this._typicalHalfwidthCharacterWidth = fontInfo.typicalHalfwidthCharacterWidth;
		this._lineCursorWidth = Math.min(options.get(37), this._typicalHalfwidthCharacterWidth);
		this._lineCursorHeight = options.get(38);
		applyFontInfo(this._domNode, fontInfo);
		return true;
	}
	onCursorPositionChanged(position, pauseAnimation) {
		if (pauseAnimation) this._domNode.domNode.style.transitionProperty = "none";
		else this._domNode.domNode.style.transitionProperty = "";
		this._position = position;
		return true;
	}
	/**
	* If `this._position` is inside a grapheme, returns the position where the grapheme starts.
	* Also returns the next grapheme.
	*/
	_getGraphemeAwarePosition() {
		const { lineNumber, column } = this._position;
		const lineContent = this._context.viewModel.getLineContent(lineNumber);
		const [startOffset, endOffset] = getCharContainingOffset(lineContent, column - 1);
		return [new Position$1(lineNumber, startOffset + 1), lineContent.substring(startOffset, endOffset)];
	}
	_prepareRender(ctx) {
		let textContent = "";
		let textContentClassName = "";
		const [position, nextGrapheme] = this._getGraphemeAwarePosition();
		const lineHeight = this._context.viewLayout.getLineHeightForLineNumber(position.lineNumber);
		const lineCursorHeight = this._lineCursorHeight === 0 ? lineHeight : Math.min(lineHeight, this._lineCursorHeight);
		const lineHeightAdjustment = (lineHeight - lineCursorHeight) / 2;
		if (this._cursorStyle === TextEditorCursorStyle.Line || this._cursorStyle === TextEditorCursorStyle.LineThin) {
			const visibleRange = ctx.visibleRangeForPosition(position);
			if (!visibleRange || visibleRange.outsideRenderedLine) return null;
			const window = getWindow(this._domNode.domNode);
			let width;
			if (this._cursorStyle === TextEditorCursorStyle.Line) {
				width = computeScreenAwareSize(window, this._lineCursorWidth > 0 ? this._lineCursorWidth : 2);
				if (width > 2) {
					textContent = nextGrapheme;
					textContentClassName = this._getTokenClassName(position);
				}
			} else width = computeScreenAwareSize(window, 1);
			let left = visibleRange.left;
			let paddingLeft = 0;
			if (width >= 2 && left >= 1) {
				paddingLeft = 1;
				left -= paddingLeft;
			}
			return new ViewCursorRenderData(ctx.getVerticalOffsetForLineNumber(position.lineNumber) - ctx.bigNumbersDelta + lineHeightAdjustment, left, paddingLeft, width, lineCursorHeight, textContent, textContentClassName);
		}
		const visibleRangeForCharacter = ctx.linesVisibleRangesForRange(new Range$2(position.lineNumber, position.column, position.lineNumber, position.column + nextGrapheme.length), false);
		if (!visibleRangeForCharacter || visibleRangeForCharacter.length === 0) return null;
		const firstVisibleRangeForCharacter = visibleRangeForCharacter[0];
		if (firstVisibleRangeForCharacter.outsideRenderedLine || firstVisibleRangeForCharacter.ranges.length === 0) return null;
		const range = firstVisibleRangeForCharacter.ranges[0];
		const width = nextGrapheme === "	" ? this._typicalHalfwidthCharacterWidth : range.width < 1 ? this._typicalHalfwidthCharacterWidth : range.width;
		if (this._cursorStyle === TextEditorCursorStyle.Block) {
			textContent = nextGrapheme;
			textContentClassName = this._getTokenClassName(position);
		}
		let top = ctx.getVerticalOffsetForLineNumber(position.lineNumber) - ctx.bigNumbersDelta;
		let height = lineHeight;
		if (this._cursorStyle === TextEditorCursorStyle.Underline || this._cursorStyle === TextEditorCursorStyle.UnderlineThin) {
			top += lineHeight - 2;
			height = 2;
		}
		return new ViewCursorRenderData(top, range.left, 0, width, height, textContent, textContentClassName);
	}
	_getTokenClassName(position) {
		const lineData = this._context.viewModel.getViewLineData(position.lineNumber);
		const tokenIndex = lineData.tokens.findTokenIndexAtOffset(position.column - 1);
		return lineData.tokens.getClassName(tokenIndex);
	}
	prepareRender(ctx) {
		this._renderData = this._prepareRender(ctx);
	}
	render(ctx) {
		if (!this._renderData) {
			this._domNode.setDisplay("none");
			return null;
		}
		if (this._lastRenderedContent !== this._renderData.textContent) {
			this._lastRenderedContent = this._renderData.textContent;
			this._domNode.domNode.textContent = this._lastRenderedContent;
		}
		this._domNode.setClassName(`cursor ${this._pluralityClass} ${MOUSE_CURSOR_TEXT_CSS_CLASS_NAME} ${this._renderData.textContentClassName}`);
		this._domNode.setDisplay("block");
		this._domNode.setTop(this._renderData.top);
		this._domNode.setLeft(this._renderData.left);
		this._domNode.setPaddingLeft(this._renderData.paddingLeft);
		this._domNode.setWidth(this._renderData.width);
		this._domNode.setLineHeight(this._renderData.height);
		this._domNode.setHeight(this._renderData.height);
		return {
			domNode: this._domNode.domNode,
			position: this._position,
			contentLeft: this._renderData.left,
			height: this._renderData.height,
			width: 2
		};
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/viewCursors/viewCursors.js
/**
* View cursors is a view part responsible for rendering the primary cursor and
* any secondary cursors that are currently active.
*/
var ViewCursors = class ViewCursors extends ViewPart {
	static {
		this.BLINK_INTERVAL = 500;
	}
	constructor(context) {
		super(context);
		const options = this._context.configuration.options;
		this._readOnly = options.get(104);
		this._cursorBlinking = options.get(32);
		this._cursorStyle = options.get(162);
		this._cursorSmoothCaretAnimation = options.get(33);
		this._editContextEnabled = options.get(171);
		this._selectionIsEmpty = true;
		this._isComposingInput = false;
		this._isVisible = false;
		this._primaryCursor = new ViewCursor(this._context, CursorPlurality.Single);
		this._secondaryCursors = [];
		this._renderData = [];
		this._domNode = createFastDomNode(document.createElement("div"));
		this._domNode.setAttribute("role", "presentation");
		this._domNode.setAttribute("aria-hidden", "true");
		this._updateDomClassName();
		this._domNode.appendChild(this._primaryCursor.getDomNode());
		this._startCursorBlinkAnimation = new TimeoutTimer();
		this._cursorFlatBlinkInterval = new WindowIntervalTimer();
		this._blinkingEnabled = false;
		this._editorHasFocus = false;
		this._updateBlinking();
	}
	dispose() {
		super.dispose();
		this._startCursorBlinkAnimation.dispose();
		this._cursorFlatBlinkInterval.dispose();
	}
	getDomNode() {
		return this._domNode;
	}
	onCompositionStart(e) {
		this._isComposingInput = true;
		this._updateBlinking();
		return true;
	}
	onCompositionEnd(e) {
		this._isComposingInput = false;
		this._updateBlinking();
		return true;
	}
	onConfigurationChanged(e) {
		const options = this._context.configuration.options;
		this._readOnly = options.get(104);
		this._cursorBlinking = options.get(32);
		this._cursorStyle = options.get(162);
		this._cursorSmoothCaretAnimation = options.get(33);
		this._editContextEnabled = options.get(171);
		this._updateBlinking();
		this._updateDomClassName();
		this._primaryCursor.onConfigurationChanged(e);
		for (let i = 0, len = this._secondaryCursors.length; i < len; i++) this._secondaryCursors[i].onConfigurationChanged(e);
		return true;
	}
	_onCursorPositionChanged(position, secondaryPositions, reason) {
		const pauseAnimation = this._secondaryCursors.length !== secondaryPositions.length || this._cursorSmoothCaretAnimation === "explicit" && reason !== 3;
		this._primaryCursor.setPlurality(secondaryPositions.length ? CursorPlurality.MultiPrimary : CursorPlurality.Single);
		this._primaryCursor.onCursorPositionChanged(position, pauseAnimation);
		this._updateBlinking();
		if (this._secondaryCursors.length < secondaryPositions.length) {
			const addCnt = secondaryPositions.length - this._secondaryCursors.length;
			for (let i = 0; i < addCnt; i++) {
				const newCursor = new ViewCursor(this._context, CursorPlurality.MultiSecondary);
				this._domNode.domNode.insertBefore(newCursor.getDomNode().domNode, this._primaryCursor.getDomNode().domNode.nextSibling);
				this._secondaryCursors.push(newCursor);
			}
		} else if (this._secondaryCursors.length > secondaryPositions.length) {
			const removeCnt = this._secondaryCursors.length - secondaryPositions.length;
			for (let i = 0; i < removeCnt; i++) {
				this._domNode.removeChild(this._secondaryCursors[0].getDomNode());
				this._secondaryCursors.splice(0, 1);
			}
		}
		for (let i = 0; i < secondaryPositions.length; i++) this._secondaryCursors[i].onCursorPositionChanged(secondaryPositions[i], pauseAnimation);
	}
	onCursorStateChanged(e) {
		const positions = [];
		for (let i = 0, len = e.selections.length; i < len; i++) positions[i] = e.selections[i].getPosition();
		this._onCursorPositionChanged(positions[0], positions.slice(1), e.reason);
		const selectionIsEmpty = e.selections[0].isEmpty();
		if (this._selectionIsEmpty !== selectionIsEmpty) {
			this._selectionIsEmpty = selectionIsEmpty;
			this._updateDomClassName();
		}
		return true;
	}
	onDecorationsChanged(e) {
		return true;
	}
	onFlushed(e) {
		return true;
	}
	onFocusChanged(e) {
		this._editorHasFocus = e.isFocused;
		this._updateBlinking();
		return false;
	}
	onLinesChanged(e) {
		return true;
	}
	onLinesDeleted(e) {
		return true;
	}
	onLinesInserted(e) {
		return true;
	}
	onScrollChanged(e) {
		return true;
	}
	onTokensChanged(e) {
		const shouldRender = (position) => {
			for (let i = 0, len = e.ranges.length; i < len; i++) if (e.ranges[i].fromLineNumber <= position.lineNumber && position.lineNumber <= e.ranges[i].toLineNumber) return true;
			return false;
		};
		if (shouldRender(this._primaryCursor.getPosition())) return true;
		for (const secondaryCursor of this._secondaryCursors) if (shouldRender(secondaryCursor.getPosition())) return true;
		return false;
	}
	onZonesChanged(e) {
		return true;
	}
	_getCursorBlinking() {
		if (this._isComposingInput && !this._editContextEnabled) return 0;
		if (!this._editorHasFocus) return 0;
		if (this._readOnly) return 5;
		return this._cursorBlinking;
	}
	_updateBlinking() {
		this._startCursorBlinkAnimation.cancel();
		this._cursorFlatBlinkInterval.cancel();
		const blinkingStyle = this._getCursorBlinking();
		const isHidden = blinkingStyle === 0;
		const isSolid = blinkingStyle === 5;
		if (isHidden) this._hide();
		else this._show();
		this._blinkingEnabled = false;
		this._updateDomClassName();
		if (!isHidden && !isSolid) {
			if (blinkingStyle === 1) this._cursorFlatBlinkInterval.cancelAndSet(() => {
				if (this._isVisible) this._hide();
				else this._show();
			}, ViewCursors.BLINK_INTERVAL, getWindow(this._domNode.domNode));
			else this._startCursorBlinkAnimation.setIfNotSet(() => {
				this._blinkingEnabled = true;
				this._updateDomClassName();
			}, ViewCursors.BLINK_INTERVAL);
		}
	}
	_updateDomClassName() {
		this._domNode.setClassName(this._getClassName());
	}
	_getClassName() {
		let result = "cursors-layer";
		if (!this._selectionIsEmpty) result += " has-selection";
		switch (this._cursorStyle) {
			case TextEditorCursorStyle.Line:
				result += " cursor-line-style";
				break;
			case TextEditorCursorStyle.Block:
				result += " cursor-block-style";
				break;
			case TextEditorCursorStyle.Underline:
				result += " cursor-underline-style";
				break;
			case TextEditorCursorStyle.LineThin:
				result += " cursor-line-thin-style";
				break;
			case TextEditorCursorStyle.BlockOutline:
				result += " cursor-block-outline-style";
				break;
			case TextEditorCursorStyle.UnderlineThin:
				result += " cursor-underline-thin-style";
				break;
			default: result += " cursor-line-style";
		}
		if (this._blinkingEnabled) switch (this._getCursorBlinking()) {
			case 1:
				result += " cursor-blink";
				break;
			case 2:
				result += " cursor-smooth";
				break;
			case 3:
				result += " cursor-phase";
				break;
			case 4:
				result += " cursor-expand";
				break;
			case 5:
				result += " cursor-solid";
				break;
			default: result += " cursor-solid";
		}
		else result += " cursor-solid";
		if (this._cursorSmoothCaretAnimation === "on" || this._cursorSmoothCaretAnimation === "explicit") result += " cursor-smooth-caret-animation";
		return result;
	}
	_show() {
		this._primaryCursor.show();
		for (let i = 0, len = this._secondaryCursors.length; i < len; i++) this._secondaryCursors[i].show();
		this._isVisible = true;
	}
	_hide() {
		this._primaryCursor.hide();
		for (let i = 0, len = this._secondaryCursors.length; i < len; i++) this._secondaryCursors[i].hide();
		this._isVisible = false;
	}
	prepareRender(ctx) {
		this._primaryCursor.prepareRender(ctx);
		for (let i = 0, len = this._secondaryCursors.length; i < len; i++) this._secondaryCursors[i].prepareRender(ctx);
	}
	render(ctx) {
		const renderData = [];
		let renderDataLen = 0;
		const primaryRenderData = this._primaryCursor.render(ctx);
		if (primaryRenderData) renderData[renderDataLen++] = primaryRenderData;
		for (let i = 0, len = this._secondaryCursors.length; i < len; i++) {
			const secondaryRenderData = this._secondaryCursors[i].render(ctx);
			if (secondaryRenderData) renderData[renderDataLen++] = secondaryRenderData;
		}
		this._renderData = renderData;
	}
	getLastRenderData() {
		return this._renderData;
	}
};
registerThemingParticipant((theme, collector) => {
	const cursorThemes = [
		{
			class: ".cursor",
			foreground: editorCursorForeground,
			background: editorCursorBackground
		},
		{
			class: ".cursor-primary",
			foreground: editorMultiCursorPrimaryForeground,
			background: editorMultiCursorPrimaryBackground
		},
		{
			class: ".cursor-secondary",
			foreground: editorMultiCursorSecondaryForeground,
			background: editorMultiCursorSecondaryBackground
		}
	];
	for (const cursorTheme of cursorThemes) {
		const caret = theme.getColor(cursorTheme.foreground);
		if (caret) {
			let caretBackground = theme.getColor(cursorTheme.background);
			if (!caretBackground) caretBackground = caret.opposite();
			collector.addRule(`.monaco-editor .cursors-layer ${cursorTheme.class} { background-color: ${caret}; border-color: ${caret}; color: ${caretBackground}; }`);
			if (isHighContrast(theme.type)) collector.addRule(`.monaco-editor .cursors-layer.has-selection ${cursorTheme.class} { border-left: 1px solid ${caretBackground}; border-right: 1px solid ${caretBackground}; }`);
		}
	}
});
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/viewZones/viewZones.js
var invalidFunc$1 = () => {
	throw new Error(`Invalid change accessor`);
};
/**
* A view zone is a rectangle that is a section that is inserted into the editor
* lines that can be used for various purposes such as showing a diffs, peeking
* an implementation, etc.
*/
var ViewZones = class extends ViewPart {
	constructor(context) {
		super(context);
		const options = this._context.configuration.options;
		const layoutInfo = options.get(166);
		this._lineHeight = options.get(75);
		this._contentWidth = layoutInfo.contentWidth;
		this._contentLeft = layoutInfo.contentLeft;
		this.domNode = createFastDomNode(document.createElement("div"));
		this.domNode.setClassName("view-zones");
		this.domNode.setPosition("absolute");
		this.domNode.setAttribute("role", "presentation");
		this.domNode.setAttribute("aria-hidden", "true");
		this.marginDomNode = createFastDomNode(document.createElement("div"));
		this.marginDomNode.setClassName("margin-view-zones");
		this.marginDomNode.setPosition("absolute");
		this.marginDomNode.setAttribute("role", "presentation");
		this.marginDomNode.setAttribute("aria-hidden", "true");
		this._zones = {};
	}
	dispose() {
		super.dispose();
		this._zones = {};
	}
	_recomputeWhitespacesProps() {
		const whitespaces = this._context.viewLayout.getWhitespaces();
		const oldWhitespaces = /* @__PURE__ */ new Map();
		for (const whitespace of whitespaces) oldWhitespaces.set(whitespace.id, whitespace);
		let hadAChange = false;
		this._context.viewModel.changeWhitespace((whitespaceAccessor) => {
			const keys = Object.keys(this._zones);
			for (let i = 0, len = keys.length; i < len; i++) {
				const id = keys[i];
				const zone = this._zones[id];
				const props = this._computeWhitespaceProps(zone.delegate);
				zone.isInHiddenArea = props.isInHiddenArea;
				const oldWhitespace = oldWhitespaces.get(id);
				if (oldWhitespace && (oldWhitespace.afterLineNumber !== props.afterViewLineNumber || oldWhitespace.height !== props.heightInPx)) {
					whitespaceAccessor.changeOneWhitespace(id, props.afterViewLineNumber, props.heightInPx);
					this._safeCallOnComputedHeight(zone.delegate, props.heightInPx);
					hadAChange = true;
				}
			}
		});
		return hadAChange;
	}
	onConfigurationChanged(e) {
		const options = this._context.configuration.options;
		const layoutInfo = options.get(166);
		this._lineHeight = options.get(75);
		this._contentWidth = layoutInfo.contentWidth;
		this._contentLeft = layoutInfo.contentLeft;
		if (e.hasChanged(75)) this._recomputeWhitespacesProps();
		return true;
	}
	onLineMappingChanged(e) {
		return this._recomputeWhitespacesProps();
	}
	onLinesDeleted(e) {
		return true;
	}
	onScrollChanged(e) {
		return e.scrollTopChanged || e.scrollWidthChanged;
	}
	onZonesChanged(e) {
		return true;
	}
	onLinesInserted(e) {
		return true;
	}
	_getZoneOrdinal(zone) {
		return zone.ordinal ?? zone.afterColumn ?? 1e4;
	}
	_computeWhitespaceProps(zone) {
		if (zone.afterLineNumber === 0) return {
			isInHiddenArea: false,
			afterViewLineNumber: 0,
			heightInPx: this._heightInPixels(zone),
			minWidthInPx: this._minWidthInPixels(zone)
		};
		let zoneAfterModelPosition;
		if (typeof zone.afterColumn !== "undefined") zoneAfterModelPosition = this._context.viewModel.model.validatePosition({
			lineNumber: zone.afterLineNumber,
			column: zone.afterColumn
		});
		else {
			const validAfterLineNumber = this._context.viewModel.model.validatePosition({
				lineNumber: zone.afterLineNumber,
				column: 1
			}).lineNumber;
			zoneAfterModelPosition = new Position$1(validAfterLineNumber, this._context.viewModel.model.getLineMaxColumn(validAfterLineNumber));
		}
		let zoneBeforeModelPosition;
		if (zoneAfterModelPosition.column === this._context.viewModel.model.getLineMaxColumn(zoneAfterModelPosition.lineNumber)) zoneBeforeModelPosition = this._context.viewModel.model.validatePosition({
			lineNumber: zoneAfterModelPosition.lineNumber + 1,
			column: 1
		});
		else zoneBeforeModelPosition = this._context.viewModel.model.validatePosition({
			lineNumber: zoneAfterModelPosition.lineNumber,
			column: zoneAfterModelPosition.column + 1
		});
		const viewPosition = this._context.viewModel.coordinatesConverter.convertModelPositionToViewPosition(zoneAfterModelPosition, zone.afterColumnAffinity, true);
		const isVisible = zone.showInHiddenAreas || this._context.viewModel.coordinatesConverter.modelPositionIsVisible(zoneBeforeModelPosition);
		return {
			isInHiddenArea: !isVisible,
			afterViewLineNumber: viewPosition.lineNumber,
			heightInPx: isVisible ? this._heightInPixels(zone) : 0,
			minWidthInPx: this._minWidthInPixels(zone)
		};
	}
	changeViewZones(callback) {
		let zonesHaveChanged = false;
		this._context.viewModel.changeWhitespace((whitespaceAccessor) => {
			const changeAccessor = {
				addZone: (zone) => {
					zonesHaveChanged = true;
					return this._addZone(whitespaceAccessor, zone);
				},
				removeZone: (id) => {
					if (!id) return;
					zonesHaveChanged = this._removeZone(whitespaceAccessor, id) || zonesHaveChanged;
				},
				layoutZone: (id) => {
					if (!id) return;
					zonesHaveChanged = this._layoutZone(whitespaceAccessor, id) || zonesHaveChanged;
				}
			};
			safeInvoke1Arg(callback, changeAccessor);
			changeAccessor.addZone = invalidFunc$1;
			changeAccessor.removeZone = invalidFunc$1;
			changeAccessor.layoutZone = invalidFunc$1;
		});
		return zonesHaveChanged;
	}
	_addZone(whitespaceAccessor, zone) {
		const props = this._computeWhitespaceProps(zone);
		const myZone = {
			whitespaceId: whitespaceAccessor.insertWhitespace(props.afterViewLineNumber, this._getZoneOrdinal(zone), props.heightInPx, props.minWidthInPx),
			delegate: zone,
			isInHiddenArea: props.isInHiddenArea,
			isVisible: false,
			domNode: createFastDomNode(zone.domNode),
			marginDomNode: zone.marginDomNode ? createFastDomNode(zone.marginDomNode) : null
		};
		this._safeCallOnComputedHeight(myZone.delegate, props.heightInPx);
		myZone.domNode.setPosition("absolute");
		myZone.domNode.domNode.style.width = "100%";
		myZone.domNode.setDisplay("none");
		myZone.domNode.setAttribute("monaco-view-zone", myZone.whitespaceId);
		this.domNode.appendChild(myZone.domNode);
		if (myZone.marginDomNode) {
			myZone.marginDomNode.setPosition("absolute");
			myZone.marginDomNode.domNode.style.width = "100%";
			myZone.marginDomNode.setDisplay("none");
			myZone.marginDomNode.setAttribute("monaco-view-zone", myZone.whitespaceId);
			this.marginDomNode.appendChild(myZone.marginDomNode);
		}
		this._zones[myZone.whitespaceId] = myZone;
		this.setShouldRender();
		return myZone.whitespaceId;
	}
	_removeZone(whitespaceAccessor, id) {
		if (this._zones.hasOwnProperty(id)) {
			const zone = this._zones[id];
			delete this._zones[id];
			whitespaceAccessor.removeWhitespace(zone.whitespaceId);
			zone.domNode.removeAttribute("monaco-visible-view-zone");
			zone.domNode.removeAttribute("monaco-view-zone");
			zone.domNode.domNode.remove();
			if (zone.marginDomNode) {
				zone.marginDomNode.removeAttribute("monaco-visible-view-zone");
				zone.marginDomNode.removeAttribute("monaco-view-zone");
				zone.marginDomNode.domNode.remove();
			}
			this.setShouldRender();
			return true;
		}
		return false;
	}
	_layoutZone(whitespaceAccessor, id) {
		if (this._zones.hasOwnProperty(id)) {
			const zone = this._zones[id];
			const props = this._computeWhitespaceProps(zone.delegate);
			zone.isInHiddenArea = props.isInHiddenArea;
			whitespaceAccessor.changeOneWhitespace(zone.whitespaceId, props.afterViewLineNumber, props.heightInPx);
			this._safeCallOnComputedHeight(zone.delegate, props.heightInPx);
			this.setShouldRender();
			return true;
		}
		return false;
	}
	shouldSuppressMouseDownOnViewZone(id) {
		if (this._zones.hasOwnProperty(id)) {
			const zone = this._zones[id];
			return Boolean(zone.delegate.suppressMouseDown);
		}
		return false;
	}
	_heightInPixels(zone) {
		if (typeof zone.heightInPx === "number") return zone.heightInPx;
		if (typeof zone.heightInLines === "number") return this._lineHeight * zone.heightInLines;
		return this._lineHeight;
	}
	_minWidthInPixels(zone) {
		if (typeof zone.minWidthInPx === "number") return zone.minWidthInPx;
		return 0;
	}
	_safeCallOnComputedHeight(zone, height) {
		if (typeof zone.onComputedHeight === "function") try {
			zone.onComputedHeight(height);
		} catch (e) {
			onUnexpectedError(e);
		}
	}
	_safeCallOnDomNodeTop(zone, top) {
		if (typeof zone.onDomNodeTop === "function") try {
			zone.onDomNodeTop(top);
		} catch (e) {
			onUnexpectedError(e);
		}
	}
	prepareRender(ctx) {}
	render(ctx) {
		const visibleWhitespaces = ctx.viewportData.whitespaceViewportData;
		const visibleZones = {};
		let hasVisibleZone = false;
		for (const visibleWhitespace of visibleWhitespaces) {
			if (this._zones[visibleWhitespace.id].isInHiddenArea) continue;
			visibleZones[visibleWhitespace.id] = visibleWhitespace;
			hasVisibleZone = true;
		}
		const keys = Object.keys(this._zones);
		for (let i = 0, len = keys.length; i < len; i++) {
			const id = keys[i];
			const zone = this._zones[id];
			let newTop = 0;
			let newHeight = 0;
			let newDisplay = "none";
			if (visibleZones.hasOwnProperty(id)) {
				newTop = visibleZones[id].verticalOffset - ctx.bigNumbersDelta;
				newHeight = visibleZones[id].height;
				newDisplay = "block";
				if (!zone.isVisible) {
					zone.domNode.setAttribute("monaco-visible-view-zone", "true");
					zone.isVisible = true;
				}
				this._safeCallOnDomNodeTop(zone.delegate, ctx.getScrolledTopFromAbsoluteTop(visibleZones[id].verticalOffset));
			} else {
				if (zone.isVisible) {
					zone.domNode.removeAttribute("monaco-visible-view-zone");
					zone.isVisible = false;
				}
				this._safeCallOnDomNodeTop(zone.delegate, ctx.getScrolledTopFromAbsoluteTop(-1e6));
			}
			zone.domNode.setTop(newTop);
			zone.domNode.setHeight(newHeight);
			zone.domNode.setDisplay(newDisplay);
			if (zone.marginDomNode) {
				zone.marginDomNode.setTop(newTop);
				zone.marginDomNode.setHeight(newHeight);
				zone.marginDomNode.setDisplay(newDisplay);
			}
		}
		if (hasVisibleZone) {
			this.domNode.setWidth(Math.max(ctx.scrollWidth, this._contentWidth));
			this.marginDomNode.setWidth(this._contentLeft);
		}
	}
};
function safeInvoke1Arg(func, arg1) {
	try {
		return func(arg1);
	} catch (e) {
		onUnexpectedError(e);
		return;
	}
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/whitespace/whitespace.js
/**
* The whitespace overlay will visual certain whitespace depending on the
* current editor configuration (boundary, selection, etc.).
*/
var WhitespaceOverlay = class extends DynamicViewOverlay {
	constructor(context) {
		super();
		this._context = context;
		this._options = new WhitespaceOptions(this._context.configuration);
		this._selection = [];
		this._renderResult = null;
		this._context.addEventHandler(this);
	}
	dispose() {
		this._context.removeEventHandler(this);
		this._renderResult = null;
		super.dispose();
	}
	onConfigurationChanged(e) {
		const newOptions = new WhitespaceOptions(this._context.configuration);
		if (this._options.equals(newOptions)) return e.hasChanged(166);
		this._options = newOptions;
		return true;
	}
	onCursorStateChanged(e) {
		this._selection = e.selections;
		if (this._options.renderWhitespace === "selection") return true;
		return false;
	}
	onDecorationsChanged(e) {
		return true;
	}
	onFlushed(e) {
		return true;
	}
	onLinesChanged(e) {
		return true;
	}
	onLinesDeleted(e) {
		return true;
	}
	onLinesInserted(e) {
		return true;
	}
	onScrollChanged(e) {
		return e.scrollTopChanged;
	}
	onZonesChanged(e) {
		return true;
	}
	prepareRender(ctx) {
		if (this._options.renderWhitespace === "none") {
			this._renderResult = null;
			return;
		}
		this._renderResult = [];
		for (let lineNumber = ctx.viewportData.startLineNumber; lineNumber <= ctx.viewportData.endLineNumber; lineNumber++) {
			const lineIndex = lineNumber - ctx.viewportData.startLineNumber;
			const lineData = this._context.viewModel.getViewLineRenderingData(lineNumber);
			let selectionsOnLine = null;
			if (this._options.renderWhitespace === "selection") {
				const selections = this._selection;
				for (const selection of selections) {
					if (selection.endLineNumber < lineNumber || selection.startLineNumber > lineNumber) continue;
					const startColumn = selection.startLineNumber === lineNumber ? selection.startColumn : lineData.minColumn;
					const endColumn = selection.endLineNumber === lineNumber ? selection.endColumn : lineData.maxColumn;
					if (startColumn < endColumn) {
						if (!selectionsOnLine) selectionsOnLine = [];
						selectionsOnLine.push(new OffsetRange(startColumn - 1, endColumn - 1));
					}
				}
			}
			this._renderResult[lineIndex] = this._applyRenderWhitespace(ctx, lineNumber, selectionsOnLine, lineData);
		}
	}
	_applyRenderWhitespace(ctx, lineNumber, selections, lineData) {
		if (this._options.renderWhitespace === "selection" && !selections) return "";
		if (this._options.renderWhitespace === "trailing" && lineData.continuesWithWrappedLine) return "";
		const color = this._context.theme.getColor(editorWhitespaces);
		const USE_SVG = this._options.renderWithSVG;
		const lineContent = lineData.content;
		const len = this._options.stopRenderingLineAfter === -1 ? lineContent.length : Math.min(this._options.stopRenderingLineAfter, lineContent.length);
		const continuesWithWrappedLine = lineData.continuesWithWrappedLine;
		const fauxIndentLength = lineData.minColumn - 1;
		const onlyBoundary = this._options.renderWhitespace === "boundary";
		const onlyTrailing = this._options.renderWhitespace === "trailing";
		const lineHeight = ctx.getLineHeightForLineNumber(lineNumber);
		const middotWidth = this._options.middotWidth;
		const wsmiddotWidth = this._options.wsmiddotWidth;
		const spaceWidth = this._options.spaceWidth;
		const renderSpaceCharCode = Math.abs(wsmiddotWidth - spaceWidth) < Math.abs(middotWidth - spaceWidth) ? 11825 : 183;
		const canUseHalfwidthRightwardsArrow = this._options.canUseHalfwidthRightwardsArrow;
		let result = "";
		let lineIsEmptyOrWhitespace = false;
		let firstNonWhitespaceIndex$1 = firstNonWhitespaceIndex(lineContent);
		let lastNonWhitespaceIndex$1;
		if (firstNonWhitespaceIndex$1 === -1) {
			lineIsEmptyOrWhitespace = true;
			firstNonWhitespaceIndex$1 = len;
			lastNonWhitespaceIndex$1 = len;
		} else lastNonWhitespaceIndex$1 = lastNonWhitespaceIndex(lineContent);
		let currentSelectionIndex = 0;
		let currentSelection = selections && selections[currentSelectionIndex];
		let maxLeft = 0;
		for (let charIndex = fauxIndentLength; charIndex < len; charIndex++) {
			const chCode = lineContent.charCodeAt(charIndex);
			if (currentSelection && currentSelection.endExclusive <= charIndex) {
				currentSelectionIndex++;
				currentSelection = selections && selections[currentSelectionIndex];
			}
			if (chCode !== 9 && chCode !== 32) continue;
			if (onlyTrailing && !lineIsEmptyOrWhitespace && charIndex <= lastNonWhitespaceIndex$1) continue;
			if (onlyBoundary && charIndex >= firstNonWhitespaceIndex$1 && charIndex <= lastNonWhitespaceIndex$1 && chCode === 32) {
				const prevChCode = charIndex - 1 >= 0 ? lineContent.charCodeAt(charIndex - 1) : 0;
				const nextChCode = charIndex + 1 < len ? lineContent.charCodeAt(charIndex + 1) : 0;
				if (prevChCode !== 32 && nextChCode !== 32) continue;
			}
			if (onlyBoundary && continuesWithWrappedLine && charIndex === len - 1) {
				const prevCharCode = charIndex - 1 >= 0 ? lineContent.charCodeAt(charIndex - 1) : 0;
				if (chCode === 32 && prevCharCode !== 32 && prevCharCode !== 9) continue;
			}
			if (selections && !(currentSelection && currentSelection.start <= charIndex && charIndex < currentSelection.endExclusive)) continue;
			const visibleRange = ctx.visibleRangeForPosition(new Position$1(lineNumber, charIndex + 1));
			if (!visibleRange) continue;
			if (USE_SVG) {
				maxLeft = Math.max(maxLeft, visibleRange.left);
				if (chCode === 9) result += this._renderArrow(lineHeight, spaceWidth, visibleRange.left);
				else result += this._renderCircle(lineHeight, spaceWidth, visibleRange.left);
			} else if (chCode === 9) result += `<div class="mwh" style="left:${visibleRange.left}px;height:${lineHeight}px;">${canUseHalfwidthRightwardsArrow ? String.fromCharCode(65515) : String.fromCharCode(8594)}</div>`;
			else result += `<div class="mwh" style="left:${visibleRange.left}px;height:${lineHeight}px;">${String.fromCharCode(renderSpaceCharCode)}</div>`;
		}
		if (USE_SVG) {
			maxLeft = Math.round(maxLeft + spaceWidth);
			return `<svg style="bottom:0;position:absolute;width:${maxLeft}px;height:${lineHeight}px" viewBox="0 0 ${maxLeft} ${lineHeight}" xmlns="http://www.w3.org/2000/svg" fill="${color}">` + (result ? `<path d="${result}" />` : "") + `</svg>`;
		}
		return result;
	}
	_renderCircle(lineHeight, spaceWidth, left) {
		const radius = Number((spaceWidth / 7).toFixed(2));
		const centerX = Number((left + spaceWidth / 2).toFixed(2));
		const centerY = (lineHeight / 2).toFixed(2);
		const diameter = (radius * 2).toFixed(2);
		return `M ${(centerX - radius).toFixed(2)} ${centerY} a ${radius} ${radius} 0 1 0 ${diameter} 0 a ${radius} ${radius} 0 1 0 -${diameter} 0 Z `;
	}
	_renderArrow(lineHeight, spaceWidth, left) {
		const strokeWidth = spaceWidth / 7;
		const width = spaceWidth;
		const dy = lineHeight / 2;
		const dx = left;
		const p1 = {
			x: 0,
			y: strokeWidth / 2
		};
		const p2 = {
			x: 100 / 125 * width,
			y: p1.y
		};
		const p3 = {
			x: p2.x - .2 * p2.x,
			y: p2.y + .2 * p2.x
		};
		const p4 = {
			x: p3.x + .1 * p2.x,
			y: p3.y + .1 * p2.x
		};
		const p5 = {
			x: p4.x + .35 * p2.x,
			y: p4.y - .35 * p2.x
		};
		return `M ${[
			p1,
			p2,
			p3,
			p4,
			p5,
			{
				x: p5.x,
				y: -p5.y
			},
			{
				x: p4.x,
				y: -p4.y
			},
			{
				x: p3.x,
				y: -p3.y
			},
			{
				x: p2.x,
				y: -p2.y
			},
			{
				x: p1.x,
				y: -p1.y
			}
		].map((p) => `${(dx + p.x).toFixed(2)} ${(dy + p.y).toFixed(2)}`).join(" L ")} Z `;
	}
	render(startLineNumber, lineNumber) {
		if (!this._renderResult) return "";
		const lineIndex = lineNumber - startLineNumber;
		if (lineIndex < 0 || lineIndex >= this._renderResult.length) return "";
		return this._renderResult[lineIndex];
	}
};
var WhitespaceOptions = class {
	constructor(config) {
		const options = config.options;
		const fontInfo = options.get(59);
		const experimentalWhitespaceRendering = options.get(47);
		if (experimentalWhitespaceRendering === "off") {
			this.renderWhitespace = "none";
			this.renderWithSVG = false;
		} else if (experimentalWhitespaceRendering === "svg") {
			this.renderWhitespace = options.get(113);
			this.renderWithSVG = true;
		} else {
			this.renderWhitespace = options.get(113);
			this.renderWithSVG = false;
		}
		this.spaceWidth = fontInfo.spaceWidth;
		this.middotWidth = fontInfo.middotWidth;
		this.wsmiddotWidth = fontInfo.wsmiddotWidth;
		this.canUseHalfwidthRightwardsArrow = fontInfo.canUseHalfwidthRightwardsArrow;
		this.lineHeight = options.get(75);
		this.stopRenderingLineAfter = options.get(133);
	}
	equals(other) {
		return this.renderWhitespace === other.renderWhitespace && this.renderWithSVG === other.renderWithSVG && this.spaceWidth === other.spaceWidth && this.middotWidth === other.middotWidth && this.wsmiddotWidth === other.wsmiddotWidth && this.canUseHalfwidthRightwardsArrow === other.canUseHalfwidthRightwardsArrow && this.lineHeight === other.lineHeight && this.stopRenderingLineAfter === other.stopRenderingLineAfter;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/wordWrapIndicator/wordWrapIndicator.js
/**
* U+21A9 - LEFTWARDS ARROW WITH HOOK.
*/
var WORD_WRAP_INDICATOR_CHAR_CODE = 8617;
/**
* The word wrap indicator overlay renders a small glyph at the wrapping column of every view
* line which is soft wrapped, so that a wrapped line can be told apart from a real line break.
*/
var WordWrapIndicatorOverlay = class extends DynamicViewOverlay {
	constructor(context) {
		super();
		this._context = context;
		this._options = new WordWrapIndicatorOptions(this._context.configuration);
		this._renderResult = null;
		this._context.addEventHandler(this);
	}
	dispose() {
		this._context.removeEventHandler(this);
		this._renderResult = null;
		super.dispose();
	}
	/**
	* Whether the overlay paints anything at all. While it does not, every view event can be
	* answered with `false`, so the view is never asked to repaint on this overlay's behalf.
	*/
	get _isEnabled() {
		return this._options.wordWrapIndicator && this._options.isWrapping;
	}
	onConfigurationChanged(e) {
		const wasEnabled = this._isEnabled;
		const newOptions = new WordWrapIndicatorOptions(this._context.configuration);
		const optionsChanged = !this._options.equals(newOptions);
		this._options = newOptions;
		return (wasEnabled || this._isEnabled) && optionsChanged;
	}
	onDecorationsChanged(e) {
		return this._isEnabled;
	}
	onFlushed(e) {
		return this._isEnabled;
	}
	onLineMappingChanged(e) {
		return this._isEnabled;
	}
	onLinesChanged(e) {
		return this._isEnabled;
	}
	onLinesDeleted(e) {
		return this._isEnabled;
	}
	onLinesInserted(e) {
		return this._isEnabled;
	}
	onScrollChanged(e) {
		return this._isEnabled && e.scrollTopChanged;
	}
	onTokensChanged(e) {
		return false;
	}
	onZonesChanged(e) {
		return this._isEnabled;
	}
	prepareRender(ctx) {
		if (!this._isEnabled) {
			this._renderResult = null;
			return;
		}
		this._renderResult = [];
		for (let lineNumber = ctx.viewportData.startLineNumber; lineNumber <= ctx.viewportData.endLineNumber; lineNumber++) {
			const lineIndex = lineNumber - ctx.viewportData.startLineNumber;
			this._renderResult[lineIndex] = this._renderLine(ctx, lineNumber);
		}
	}
	_renderLine(ctx, lineNumber) {
		if (!ctx.viewportData.getViewLineContinuesWithWrappedLine(lineNumber)) return "";
		const lineHeight = ctx.getLineHeightForLineNumber(lineNumber);
		return `<div class="wwi" style="left:${this._options.indicatorLeft}px;height:${lineHeight}px;">${String.fromCharCode(WORD_WRAP_INDICATOR_CHAR_CODE)}</div>`;
	}
	render(startLineNumber, lineNumber) {
		if (!this._renderResult) return "";
		const lineIndex = lineNumber - startLineNumber;
		if (lineIndex < 0 || lineIndex >= this._renderResult.length) return "";
		return this._renderResult[lineIndex];
	}
};
/**
* The subset of the editor configuration the overlay reads, snapshotted so that a configuration
* change can be told apart from one that leaves the rendered result untouched.
*/
var WordWrapIndicatorOptions = class {
	constructor(config) {
		const options = config.options;
		const fontInfo = options.get(59);
		const wrappingColumn = options.get(167).wrappingColumn;
		this.wordWrapIndicator = options.get(161);
		this.isWrapping = wrappingColumn !== -1;
		this.indicatorLeft = wrappingColumn * fontInfo.typicalHalfwidthCharacterWidth;
	}
	equals(other) {
		return this.wordWrapIndicator === other.wordWrapIndicator && this.isWrapping === other.isWrapping && this.indicatorLeft === other.indicatorLeft;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/viewLayout/viewLinesViewportData.js
/**
* Contains all data needed to render at a specific viewport.
*/
var ViewportData = class {
	constructor(selections, partialData, whitespaceViewportData, model) {
		this.selections = selections;
		this.startLineNumber = partialData.startLineNumber | 0;
		this.endLineNumber = partialData.endLineNumber | 0;
		this.relativeVerticalOffset = partialData.relativeVerticalOffset;
		this.bigNumbersDelta = partialData.bigNumbersDelta | 0;
		this.lineHeight = partialData.lineHeight | 0;
		this.whitespaceViewportData = whitespaceViewportData;
		this._model = model;
		this.visibleRange = new Range$2(partialData.startLineNumber, this._model.getLineMinColumn(partialData.startLineNumber), partialData.endLineNumber, this._model.getLineMaxColumn(partialData.endLineNumber));
	}
	getViewLineRenderingData(lineNumber) {
		return this._model.getViewportViewLineRenderingData(this.visibleRange, lineNumber);
	}
	getViewLineContinuesWithWrappedLine(lineNumber) {
		return this._model.getViewLineContinuesWithWrappedLine(lineNumber);
	}
	getDecorationsInViewport() {
		return this._model.getDecorationsInViewport(this.visibleRange);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/editorTheme.js
var EditorTheme = class {
	get type() {
		return this._theme.type;
	}
	get value() {
		return this._theme;
	}
	constructor(theme) {
		this._theme = theme;
	}
	update(theme) {
		this._theme = theme;
	}
	getColor(color) {
		return this._theme.getColor(color);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/viewModel/viewContext.js
var ViewContext = class {
	constructor(configuration, theme, model) {
		this.configuration = configuration;
		this.theme = new EditorTheme(theme);
		this.viewModel = model;
		this.viewLayout = model.viewLayout;
	}
	addEventHandler(eventHandler) {
		this.viewModel.addViewEventHandler(eventHandler);
	}
	removeEventHandler(eventHandler) {
		this.viewModel.removeViewEventHandler(eventHandler);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/gpu/gpuUtils.js
var quadVertices = new Float32Array([
	1,
	0,
	1,
	1,
	0,
	1,
	0,
	0,
	0,
	1,
	1,
	0
]);
function ensureNonNullable(value) {
	if (!value) throw new Error(`Value "${value}" cannot be null`);
	return value;
}
function observeDevicePixelDimensions(element, parentWindow, callback) {
	let observer = new parentWindow.ResizeObserver((entries) => {
		const entry = entries.find((entry) => entry.target === element);
		if (!entry) return;
		if (!("devicePixelContentBoxSize" in entry)) {
			observer?.disconnect();
			observer = void 0;
			return;
		}
		const width = entry.devicePixelContentBoxSize[0].inlineSize;
		const height = entry.devicePixelContentBoxSize[0].blockSize;
		if (width > 0 && height > 0) callback(width, height);
	});
	try {
		observer.observe(element, { box: ["device-pixel-content-box"] });
	} catch {
		observer.disconnect();
		observer = void 0;
		throw new BugIndicatingError("Could not observe device pixel dimensions");
	}
	return toDisposable(() => observer?.disconnect());
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/gpu/raster/glyphRasterizer.js
var __decorate$72 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var nextId = 0;
var GlyphRasterizer = class extends Disposable {
	get cacheKey() {
		return `${this.fontFamily}_${this.fontSize}px`;
	}
	constructor(fontSize, fontFamily, devicePixelRatio, _decorationStyleCache) {
		super();
		this.fontSize = fontSize;
		this.fontFamily = fontFamily;
		this.devicePixelRatio = devicePixelRatio;
		this._decorationStyleCache = _decorationStyleCache;
		this.id = nextId++;
		this._workGlyph = {
			source: null,
			boundingBox: {
				left: 0,
				bottom: 0,
				right: 0,
				top: 0
			},
			originOffset: {
				x: 0,
				y: 0
			},
			fontBoundingBoxAscent: 0,
			fontBoundingBoxDescent: 0
		};
		this._workGlyphConfig = {
			chars: void 0,
			tokenMetadata: 0,
			decorationStyleSetId: 0
		};
		this._antiAliasing = isMacintosh ? "greyscale" : "subpixel";
		const devicePixelFontSize = Math.ceil(this.fontSize * devicePixelRatio);
		this._canvas = new OffscreenCanvas(devicePixelFontSize * 3, devicePixelFontSize * 3);
		this._ctx = ensureNonNullable(this._canvas.getContext("2d", {
			willReadFrequently: true,
			alpha: this._antiAliasing === "greyscale"
		}));
		this._ctx.textBaseline = "top";
		this._ctx.fillStyle = "#FFFFFF";
		this._ctx.font = `${devicePixelFontSize}px ${this.fontFamily}`;
		this._textMetrics = this._ctx.measureText("A");
	}
	/**
	* Rasterizes a glyph. Note that the returned object is reused across different glyphs and
	* therefore is only safe for synchronous access.
	*/
	rasterizeGlyph(chars, tokenMetadata, decorationStyleSetId, colorMap) {
		if (chars === "") return {
			source: this._canvas,
			boundingBox: {
				top: 0,
				left: 0,
				bottom: -1,
				right: -1
			},
			originOffset: {
				x: 0,
				y: 0
			},
			fontBoundingBoxAscent: 0,
			fontBoundingBoxDescent: 0
		};
		if (this._workGlyphConfig.chars === chars && this._workGlyphConfig.tokenMetadata === tokenMetadata && this._workGlyphConfig.decorationStyleSetId === decorationStyleSetId) return this._workGlyph;
		this._workGlyphConfig.chars = chars;
		this._workGlyphConfig.tokenMetadata = tokenMetadata;
		this._workGlyphConfig.decorationStyleSetId = decorationStyleSetId;
		return this._rasterizeGlyph(chars, tokenMetadata, decorationStyleSetId, colorMap);
	}
	_rasterizeGlyph(chars, tokenMetadata, decorationStyleSetId, colorMap) {
		const devicePixelFontSize = Math.ceil(this.fontSize * this.devicePixelRatio);
		const canvasDim = devicePixelFontSize * 3;
		if (this._canvas.width !== canvasDim) {
			this._canvas.width = canvasDim;
			this._canvas.height = canvasDim;
		}
		this._ctx.save();
		const subPixelXOffset = (tokenMetadata & 15) / 10;
		const bg = colorMap[TokenMetadata.getBackground(tokenMetadata)] ?? colorMap[2];
		const decorationStyleSet = this._decorationStyleCache.getStyleSet(decorationStyleSetId);
		if (this._antiAliasing === "subpixel") {
			this._ctx.fillStyle = bg;
			this._ctx.fillRect(0, 0, this._canvas.width, this._canvas.height);
		} else this._ctx.clearRect(0, 0, this._canvas.width, this._canvas.height);
		const fontSb = new StringBuilder(200);
		const fontStyle = TokenMetadata.getFontStyle(tokenMetadata);
		if (fontStyle & 1) fontSb.appendString("italic ");
		if (decorationStyleSet?.bold !== void 0) {
			if (decorationStyleSet.bold) fontSb.appendString("bold ");
		} else if (fontStyle & 2) fontSb.appendString("bold ");
		fontSb.appendString(`${devicePixelFontSize}px ${this.fontFamily}`);
		this._ctx.font = fontSb.build();
		const originX = devicePixelFontSize;
		const originY = devicePixelFontSize;
		if (decorationStyleSet?.color !== void 0) this._ctx.fillStyle = `#${decorationStyleSet.color.toString(16).padStart(8, "0")}`;
		else this._ctx.fillStyle = colorMap[TokenMetadata.getForeground(tokenMetadata)];
		if (decorationStyleSet?.opacity !== void 0) this._ctx.globalAlpha = decorationStyleSet.opacity;
		this._ctx.textBaseline = "top";
		this._ctx.fillText(chars, originX + subPixelXOffset, originY);
		if (decorationStyleSet?.strikethrough) {
			const strikethroughY = Math.round(originY - this._textMetrics.alphabeticBaseline * .65);
			const lineWidth = decorationStyleSet?.strikethroughThickness !== void 0 ? Math.round(decorationStyleSet.strikethroughThickness * this.devicePixelRatio) : Math.max(1, Math.floor(devicePixelFontSize / 10));
			if (decorationStyleSet?.strikethroughColor !== void 0) this._ctx.fillStyle = `#${decorationStyleSet.strikethroughColor.toString(16).padStart(8, "0")}`;
			this._ctx.fillRect(originX, strikethroughY - Math.floor(lineWidth / 2), Math.ceil(this._textMetrics.width), lineWidth);
		}
		this._ctx.restore();
		const imageData = this._ctx.getImageData(0, 0, this._canvas.width, this._canvas.height);
		if (this._antiAliasing === "subpixel") {
			const bgR = parseInt(bg.substring(1, 3), 16);
			const bgG = parseInt(bg.substring(3, 5), 16);
			const bgB = parseInt(bg.substring(5, 7), 16);
			this._clearColor(imageData, bgR, bgG, bgB);
			this._ctx.putImageData(imageData, 0, 0);
		}
		this._findGlyphBoundingBox(imageData, this._workGlyph.boundingBox);
		this._workGlyph.source = this._canvas;
		this._workGlyph.originOffset.x = this._workGlyph.boundingBox.left - originX;
		this._workGlyph.originOffset.y = this._workGlyph.boundingBox.top - originY;
		this._workGlyph.fontBoundingBoxAscent = this._textMetrics.fontBoundingBoxAscent;
		this._workGlyph.fontBoundingBoxDescent = this._textMetrics.fontBoundingBoxDescent;
		return this._workGlyph;
	}
	_clearColor(imageData, r, g, b) {
		for (let offset = 0; offset < imageData.data.length; offset += 4) if (imageData.data[offset] === r && imageData.data[offset + 1] === g && imageData.data[offset + 2] === b) imageData.data[offset + 3] = 0;
	}
	_findGlyphBoundingBox(imageData, outBoundingBox) {
		const height = this._canvas.height;
		const width = this._canvas.width;
		let found = false;
		for (let y = 0; y < height; y++) {
			for (let x = 0; x < width; x++) {
				const alphaOffset = y * width * 4 + x * 4 + 3;
				if (imageData.data[alphaOffset] !== 0) {
					outBoundingBox.top = y;
					found = true;
					break;
				}
			}
			if (found) break;
		}
		outBoundingBox.left = 0;
		found = false;
		for (let x = 0; x < width; x++) {
			for (let y = 0; y < height; y++) {
				const alphaOffset = y * width * 4 + x * 4 + 3;
				if (imageData.data[alphaOffset] !== 0) {
					outBoundingBox.left = x;
					found = true;
					break;
				}
			}
			if (found) break;
		}
		outBoundingBox.right = width;
		found = false;
		for (let x = width - 1; x >= outBoundingBox.left; x--) {
			for (let y = 0; y < height; y++) {
				const alphaOffset = y * width * 4 + x * 4 + 3;
				if (imageData.data[alphaOffset] !== 0) {
					outBoundingBox.right = x;
					found = true;
					break;
				}
			}
			if (found) break;
		}
		outBoundingBox.bottom = outBoundingBox.top;
		found = false;
		for (let y = height - 1; y >= 0; y--) {
			for (let x = 0; x < width; x++) {
				const alphaOffset = y * width * 4 + x * 4 + 3;
				if (imageData.data[alphaOffset] !== 0) {
					outBoundingBox.bottom = y;
					found = true;
					break;
				}
			}
			if (found) break;
		}
	}
	getTextMetrics(text) {
		return this._ctx.measureText(text);
	}
};
__decorate$72([memoize], GlyphRasterizer.prototype, "cacheKey", null);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/gpu/taskQueue.js
var __decorate$71 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$66 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var TaskQueue = class TaskQueue extends Disposable {
	constructor(_logService) {
		super();
		this._logService = _logService;
		this._tasks = [];
		this._i = 0;
		this._register(toDisposable(() => this.clear()));
	}
	enqueue(task) {
		this._tasks.push(task);
		this._start();
	}
	clear() {
		if (this._idleCallback) {
			this._cancelCallback(this._idleCallback);
			this._idleCallback = void 0;
		}
		this._i = 0;
		this._tasks.length = 0;
	}
	_start() {
		if (!this._idleCallback) this._idleCallback = this._requestCallback(this._process.bind(this));
	}
	_process(deadline) {
		this._idleCallback = void 0;
		let taskDuration = 0;
		let longestTask = 0;
		let lastDeadlineRemaining = deadline.timeRemaining();
		let deadlineRemaining = 0;
		while (this._i < this._tasks.length) {
			taskDuration = Date.now();
			if (!this._tasks[this._i]()) this._i++;
			taskDuration = Math.max(1, Date.now() - taskDuration);
			longestTask = Math.max(taskDuration, longestTask);
			deadlineRemaining = deadline.timeRemaining();
			if (longestTask * 1.5 > deadlineRemaining) {
				if (lastDeadlineRemaining - taskDuration < -20) this._logService.warn(`task queue exceeded allotted deadline by ${Math.abs(Math.round(lastDeadlineRemaining - taskDuration))}ms`);
				this._start();
				return;
			}
			lastDeadlineRemaining = deadlineRemaining;
		}
		this.clear();
	}
};
TaskQueue = __decorate$71([__param$66(0, ILogService)], TaskQueue);
/**
* A queue of that runs tasks over several tasks via setTimeout, trying to maintain above 60 frames
* per second. The tasks will run in the order they are enqueued, but they will run some time later,
* and care should be taken to ensure they're non-urgent and will not introduce race conditions.
*/
var PriorityTaskQueue = class extends TaskQueue {
	_requestCallback(callback) {
		return getActiveWindow().setTimeout(() => callback(this._createDeadline(16)));
	}
	_cancelCallback(identifier) {
		getActiveWindow().clearTimeout(identifier);
	}
	_createDeadline(duration) {
		const end = Date.now() + duration;
		return { timeRemaining: () => Math.max(0, end - Date.now()) };
	}
};
var IdleTaskQueueInternal = class extends TaskQueue {
	_requestCallback(callback) {
		return getActiveWindow().requestIdleCallback(callback);
	}
	_cancelCallback(identifier) {
		getActiveWindow().cancelIdleCallback(identifier);
	}
};
/**
* A queue of that runs tasks over several idle callbacks, trying to respect the idle callback's
* deadline given by the environment. The tasks will run in the order they are enqueued, but they
* will run some time later, and care should be taken to ensure they're non-urgent and will not
* introduce race conditions.
*
* This reverts to a {@link PriorityTaskQueue} if the environment does not support idle callbacks.
*/
var IdleTaskQueue = "requestIdleCallback" in getActiveWindow() ? IdleTaskQueueInternal : PriorityTaskQueue;
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/gpu/atlas/textureAtlasShelfAllocator.js
/**
* The shelf allocator is a simple allocator that places glyphs in rows, starting a new row when the
* current row is full. Due to its simplicity, it can waste space but it is very fast.
*/
var TextureAtlasShelfAllocator = class {
	constructor(_canvas, _textureIndex) {
		this._canvas = _canvas;
		this._textureIndex = _textureIndex;
		this._currentRow = {
			x: 0,
			y: 0,
			h: 0
		};
		/** A set of all glyphs allocated, this is only tracked to enable debug related functionality */
		this._allocatedGlyphs = /* @__PURE__ */ new Set();
		this._nextIndex = 0;
		this._ctx = ensureNonNullable(this._canvas.getContext("2d", { willReadFrequently: true }));
	}
	allocate(rasterizedGlyph) {
		const glyphWidth = rasterizedGlyph.boundingBox.right - rasterizedGlyph.boundingBox.left + 1;
		const glyphHeight = rasterizedGlyph.boundingBox.bottom - rasterizedGlyph.boundingBox.top + 1;
		if (glyphWidth > this._canvas.width || glyphHeight > this._canvas.height) throw new BugIndicatingError("Glyph is too large for the atlas page");
		if (rasterizedGlyph.boundingBox.right - rasterizedGlyph.boundingBox.left + 1 > this._canvas.width - this._currentRow.x) {
			this._currentRow.x = 0;
			this._currentRow.y += this._currentRow.h;
			this._currentRow.h = 1;
		}
		if (this._currentRow.y + rasterizedGlyph.boundingBox.bottom - rasterizedGlyph.boundingBox.top + 1 > this._canvas.height) return;
		this._ctx.drawImage(rasterizedGlyph.source, rasterizedGlyph.boundingBox.left, rasterizedGlyph.boundingBox.top, glyphWidth, glyphHeight, this._currentRow.x, this._currentRow.y, glyphWidth, glyphHeight);
		const glyph = {
			pageIndex: this._textureIndex,
			glyphIndex: this._nextIndex++,
			x: this._currentRow.x,
			y: this._currentRow.y,
			w: glyphWidth,
			h: glyphHeight,
			originOffsetX: rasterizedGlyph.originOffset.x,
			originOffsetY: rasterizedGlyph.originOffset.y,
			fontBoundingBoxAscent: rasterizedGlyph.fontBoundingBoxAscent,
			fontBoundingBoxDescent: rasterizedGlyph.fontBoundingBoxDescent
		};
		this._currentRow.x += glyphWidth;
		this._currentRow.h = Math.max(this._currentRow.h, glyphHeight);
		this._allocatedGlyphs.add(glyph);
		return glyph;
	}
	getUsagePreview() {
		const w = this._canvas.width;
		const h = this._canvas.height;
		const canvas = new OffscreenCanvas(w, h);
		const ctx = ensureNonNullable(canvas.getContext("2d"));
		ctx.fillStyle = "#808080";
		ctx.fillRect(0, 0, w, h);
		const rowHeight = /* @__PURE__ */ new Map();
		const rowWidth = /* @__PURE__ */ new Map();
		for (const g of this._allocatedGlyphs) {
			rowHeight.set(g.y, Math.max(rowHeight.get(g.y) ?? 0, g.h));
			rowWidth.set(g.y, Math.max(rowWidth.get(g.y) ?? 0, g.x + g.w));
		}
		for (const g of this._allocatedGlyphs) {
			ctx.fillStyle = "#4040FF";
			ctx.fillRect(g.x, g.y, g.w, g.h);
			ctx.fillStyle = "#FF0000";
			ctx.fillRect(g.x, g.y + g.h, g.w, rowHeight.get(g.y) - g.h);
		}
		for (const [rowY, rowW] of rowWidth.entries()) if (rowY !== this._currentRow.y) {
			ctx.fillStyle = "#FF0000";
			ctx.fillRect(rowW, rowY, w - rowW, rowHeight.get(rowY));
		}
		return canvas.convertToBlob();
	}
	getStats() {
		const w = this._canvas.width;
		const h = this._canvas.height;
		let usedPixels = 0;
		let wastedPixels = 0;
		const totalPixels = w * h;
		const rowHeight = /* @__PURE__ */ new Map();
		const rowWidth = /* @__PURE__ */ new Map();
		for (const g of this._allocatedGlyphs) {
			rowHeight.set(g.y, Math.max(rowHeight.get(g.y) ?? 0, g.h));
			rowWidth.set(g.y, Math.max(rowWidth.get(g.y) ?? 0, g.x + g.w));
		}
		for (const g of this._allocatedGlyphs) {
			usedPixels += g.w * g.h;
			wastedPixels += g.w * (rowHeight.get(g.y) - g.h);
		}
		for (const [rowY, rowW] of rowWidth.entries()) if (rowY !== this._currentRow.y) wastedPixels += (w - rowW) * rowHeight.get(rowY);
		return [
			`page${this._textureIndex}:`,
			`     Total: ${totalPixels} (${w}x${h})`,
			`      Used: ${usedPixels} (${(usedPixels / totalPixels * 100).toPrecision(2)}%)`,
			`    Wasted: ${wastedPixels} (${(wastedPixels / totalPixels * 100).toPrecision(2)}%)`,
			`Efficiency: ${(usedPixels / (usedPixels + wastedPixels) * 100).toPrecision(2)}%`
		].join("\n");
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/gpu/atlas/textureAtlasSlabAllocator.js
/**
* The slab allocator is a more complex allocator that places glyphs in square slabs of a fixed
* size. Slabs are defined by a small range of glyphs sizes they can house, this places like-sized
* glyphs in the same slab which reduces wasted space.
*
* Slabs also may contain "unused" regions on the left and bottom depending on the size of the
* glyphs they include. This space is used to place very thin or short glyphs, which would otherwise
* waste a lot of space in their own slab.
*/
var TextureAtlasSlabAllocator = class {
	constructor(_canvas, _textureIndex, options) {
		this._canvas = _canvas;
		this._textureIndex = _textureIndex;
		this._slabs = [];
		this._activeSlabsByDims = new NKeyMap();
		this._unusedRects = [];
		this._openRegionsByHeight = /* @__PURE__ */ new Map();
		this._openRegionsByWidth = /* @__PURE__ */ new Map();
		/** A set of all glyphs allocated, this is only tracked to enable debug related functionality */
		this._allocatedGlyphs = /* @__PURE__ */ new Set();
		this._nextIndex = 0;
		this._ctx = ensureNonNullable(this._canvas.getContext("2d", { willReadFrequently: true }));
		this._slabW = Math.min(options?.slabW ?? 64 << Math.max(Math.floor(getActiveWindow().devicePixelRatio) - 1, 0), this._canvas.width);
		this._slabH = Math.min(options?.slabH ?? this._slabW, this._canvas.height);
		this._slabsPerRow = Math.floor(this._canvas.width / this._slabW);
		this._slabsPerColumn = Math.floor(this._canvas.height / this._slabH);
	}
	allocate(rasterizedGlyph) {
		const glyphWidth = rasterizedGlyph.boundingBox.right - rasterizedGlyph.boundingBox.left + 1;
		const glyphHeight = rasterizedGlyph.boundingBox.bottom - rasterizedGlyph.boundingBox.top + 1;
		if (glyphWidth > this._canvas.width || glyphHeight > this._canvas.height) throw new BugIndicatingError("Glyph is too large for the atlas page");
		if (glyphWidth > this._slabW || glyphHeight > this._slabH) {
			if (this._allocatedGlyphs.size > 0) return;
			let sizeCandidate = this._canvas.width;
			while (glyphWidth < sizeCandidate / 2 && glyphHeight < sizeCandidate / 2) sizeCandidate /= 2;
			this._slabW = sizeCandidate;
			this._slabH = sizeCandidate;
			this._slabsPerRow = Math.floor(this._canvas.width / this._slabW);
			this._slabsPerColumn = Math.floor(this._canvas.height / this._slabH);
		}
		const desiredSlabSize = {
			w: glyphWidth,
			h: glyphHeight
		};
		let slab = this._activeSlabsByDims.get(desiredSlabSize.w, desiredSlabSize.h);
		if (slab) {
			const glyphsPerSlab = Math.floor(this._slabW / slab.entryW) * Math.floor(this._slabH / slab.entryH);
			if (slab.count >= glyphsPerSlab) slab = void 0;
		}
		let dx;
		let dy;
		if (!slab) {
			if (glyphWidth < glyphHeight) {
				const openRegions = this._openRegionsByWidth.get(glyphWidth);
				if (openRegions?.length) for (let i = openRegions.length - 1; i >= 0; i--) {
					const r = openRegions[i];
					if (r.w >= glyphWidth && r.h >= glyphHeight) {
						dx = r.x;
						dy = r.y;
						if (glyphWidth < r.w) this._unusedRects.push({
							x: r.x + glyphWidth,
							y: r.y,
							w: r.w - glyphWidth,
							h: glyphHeight
						});
						r.y += glyphHeight;
						r.h -= glyphHeight;
						if (r.h === 0) {
							if (i === openRegions.length - 1) openRegions.pop();
							else this._unusedRects.splice(i, 1);
						}
						break;
					}
				}
			} else {
				const openRegions = this._openRegionsByHeight.get(glyphHeight);
				if (openRegions?.length) for (let i = openRegions.length - 1; i >= 0; i--) {
					const r = openRegions[i];
					if (r.w >= glyphWidth && r.h >= glyphHeight) {
						dx = r.x;
						dy = r.y;
						if (glyphHeight < r.h) this._unusedRects.push({
							x: r.x,
							y: r.y + glyphHeight,
							w: glyphWidth,
							h: r.h - glyphHeight
						});
						r.x += glyphWidth;
						r.w -= glyphWidth;
						if (r.h === 0) {
							if (i === openRegions.length - 1) openRegions.pop();
							else this._unusedRects.splice(i, 1);
						}
						break;
					}
				}
			}
		}
		if (dx === void 0 || dy === void 0) {
			if (!slab) {
				if (this._slabs.length >= this._slabsPerRow * this._slabsPerColumn) return;
				slab = {
					x: Math.floor(this._slabs.length % this._slabsPerRow) * this._slabW,
					y: Math.floor(this._slabs.length / this._slabsPerRow) * this._slabH,
					entryW: desiredSlabSize.w,
					entryH: desiredSlabSize.h,
					count: 0
				};
				const unusedW = this._slabW % slab.entryW;
				const unusedH = this._slabH % slab.entryH;
				if (unusedW) addEntryToMapArray(this._openRegionsByWidth, unusedW, {
					x: slab.x + this._slabW - unusedW,
					w: unusedW,
					y: slab.y,
					h: this._slabH - (unusedH ?? 0)
				});
				if (unusedH) addEntryToMapArray(this._openRegionsByHeight, unusedH, {
					x: slab.x,
					w: this._slabW,
					y: slab.y + this._slabH - unusedH,
					h: unusedH
				});
				this._slabs.push(slab);
				this._activeSlabsByDims.set(slab, desiredSlabSize.w, desiredSlabSize.h);
			}
			const glyphsPerRow = Math.floor(this._slabW / slab.entryW);
			dx = slab.x + Math.floor(slab.count % glyphsPerRow) * slab.entryW;
			dy = slab.y + Math.floor(slab.count / glyphsPerRow) * slab.entryH;
			slab.count++;
		}
		this._ctx.drawImage(rasterizedGlyph.source, rasterizedGlyph.boundingBox.left, rasterizedGlyph.boundingBox.top, glyphWidth, glyphHeight, dx, dy, glyphWidth, glyphHeight);
		const glyph = {
			pageIndex: this._textureIndex,
			glyphIndex: this._nextIndex++,
			x: dx,
			y: dy,
			w: glyphWidth,
			h: glyphHeight,
			originOffsetX: rasterizedGlyph.originOffset.x,
			originOffsetY: rasterizedGlyph.originOffset.y,
			fontBoundingBoxAscent: rasterizedGlyph.fontBoundingBoxAscent,
			fontBoundingBoxDescent: rasterizedGlyph.fontBoundingBoxDescent
		};
		this._allocatedGlyphs.add(glyph);
		return glyph;
	}
	getUsagePreview() {
		const w = this._canvas.width;
		const h = this._canvas.height;
		const canvas = new OffscreenCanvas(w, h);
		const ctx = ensureNonNullable(canvas.getContext("2d"));
		ctx.fillStyle = "#808080";
		ctx.fillRect(0, 0, w, h);
		let slabEntryPixels = 0;
		let usedPixels = 0;
		let restrictedPixels = 0;
		const slabW = 64 << Math.floor(getActiveWindow().devicePixelRatio) - 1;
		const slabH = slabW;
		for (const slab of this._slabs) {
			let x = 0;
			let y = 0;
			for (let i = 0; i < slab.count; i++) {
				if (x + slab.entryW > slabW) {
					x = 0;
					y += slab.entryH;
				}
				ctx.fillStyle = "#FF0000";
				ctx.fillRect(slab.x + x, slab.y + y, slab.entryW, slab.entryH);
				slabEntryPixels += slab.entryW * slab.entryH;
				x += slab.entryW;
			}
			const entriesPerRow = Math.floor(slabW / slab.entryW);
			const entriesPerCol = Math.floor(slabH / slab.entryH);
			slab.entryW * entriesPerRow * slab.entryH * entriesPerCol;
		}
		for (const g of this._allocatedGlyphs) {
			usedPixels += g.w * g.h;
			ctx.fillStyle = "#4040FF";
			ctx.fillRect(g.x, g.y, g.w, g.h);
		}
		const unusedRegions = Array.from(this._openRegionsByWidth.values()).flat().concat(Array.from(this._openRegionsByHeight.values()).flat());
		for (const r of unusedRegions) {
			ctx.fillStyle = "#FF000088";
			ctx.fillRect(r.x, r.y, r.w, r.h);
			restrictedPixels += r.w * r.h;
		}
		ctx.globalAlpha = .5;
		ctx.drawImage(this._canvas, 0, 0);
		ctx.globalAlpha = 1;
		return canvas.convertToBlob();
	}
	getStats() {
		const w = this._canvas.width;
		const h = this._canvas.height;
		let slabEntryPixels = 0;
		let usedPixels = 0;
		let slabEdgePixels = 0;
		let wastedPixels = 0;
		let restrictedPixels = 0;
		const totalPixels = w * h;
		const slabW = 64 << Math.floor(getActiveWindow().devicePixelRatio) - 1;
		const slabH = slabW;
		for (const slab of this._slabs) {
			let x = 0;
			let y = 0;
			for (let i = 0; i < slab.count; i++) {
				if (x + slab.entryW > slabW) {
					x = 0;
					y += slab.entryH;
				}
				slabEntryPixels += slab.entryW * slab.entryH;
				x += slab.entryW;
			}
			const entriesPerRow = Math.floor(slabW / slab.entryW);
			const entriesPerCol = Math.floor(slabH / slab.entryH);
			const thisSlabPixels = slab.entryW * entriesPerRow * slab.entryH * entriesPerCol;
			slabEdgePixels += slabW * slabH - thisSlabPixels;
		}
		for (const g of this._allocatedGlyphs) usedPixels += g.w * g.h;
		const unusedRegions = Array.from(this._openRegionsByWidth.values()).flat().concat(Array.from(this._openRegionsByHeight.values()).flat());
		for (const r of unusedRegions) restrictedPixels += r.w * r.h;
		const edgeUsedPixels = slabEdgePixels - restrictedPixels;
		wastedPixels = slabEntryPixels - (usedPixels - edgeUsedPixels);
		const efficiency = usedPixels / (usedPixels + wastedPixels + restrictedPixels);
		return [
			`page[${this._textureIndex}]:`,
			`     Total: ${totalPixels}px (${w}x${h})`,
			`      Used: ${usedPixels}px (${(usedPixels / totalPixels * 100).toFixed(2)}%)`,
			`    Wasted: ${wastedPixels}px (${(wastedPixels / totalPixels * 100).toFixed(2)}%)`,
			`Restricted: ${restrictedPixels}px (${(restrictedPixels / totalPixels * 100).toFixed(2)}%) (hard to allocate)`,
			`Efficiency: ${efficiency === 1 ? "100" : (efficiency * 100).toFixed(2)}%`,
			`     Slabs: ${this._slabs.length} of ${Math.floor(this._canvas.width / slabW) * Math.floor(this._canvas.height / slabH)}`
		].join("\n");
	}
};
function addEntryToMapArray(map, key, entry) {
	let list = map.get(key);
	if (!list) {
		list = [];
		map.set(key, list);
	}
	list.push(entry);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/gpu/atlas/textureAtlasPage.js
var __decorate$70 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$65 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var TextureAtlasPage_1;
var TextureAtlasPage = class TextureAtlasPage extends Disposable {
	static {
		TextureAtlasPage_1 = this;
	}
	get version() {
		return this._version;
	}
	/**
	* The maximum number of glyphs that can be drawn to the page. This is currently a hard static
	* cap that must not be reached as it will cause the GPU buffer to overflow.
	*/
	static {
		this.maximumGlyphCount = 5e3;
	}
	get usedArea() {
		return this._usedArea;
	}
	get source() {
		return this._canvas;
	}
	get glyphs() {
		return this._glyphInOrderSet.values();
	}
	constructor(textureIndex, pageSize, allocatorType, _logService, themeService) {
		super();
		this._logService = _logService;
		this._version = 0;
		this._usedArea = {
			left: 0,
			top: 0,
			right: 0,
			bottom: 0
		};
		this._glyphMap = new NKeyMap();
		this._glyphInOrderSet = /* @__PURE__ */ new Set();
		this._canvas = new OffscreenCanvas(pageSize, pageSize);
		this._colorMap = themeService.getColorTheme().tokenColorMap;
		switch (allocatorType) {
			case "shelf":
				this._allocator = new TextureAtlasShelfAllocator(this._canvas, textureIndex);
				break;
			case "slab":
				this._allocator = new TextureAtlasSlabAllocator(this._canvas, textureIndex);
				break;
			default: this._allocator = allocatorType(this._canvas, textureIndex);
		}
		this._register(toDisposable(() => {
			this._canvas.width = 1;
			this._canvas.height = 1;
		}));
	}
	getGlyph(rasterizer, chars, tokenMetadata, decorationStyleSetId) {
		return this._glyphMap.get(chars, tokenMetadata, decorationStyleSetId, rasterizer.cacheKey) ?? this._createGlyph(rasterizer, chars, tokenMetadata, decorationStyleSetId);
	}
	_createGlyph(rasterizer, chars, tokenMetadata, decorationStyleSetId) {
		if (this._glyphInOrderSet.size >= TextureAtlasPage_1.maximumGlyphCount) return;
		const rasterizedGlyph = rasterizer.rasterizeGlyph(chars, tokenMetadata, decorationStyleSetId, this._colorMap);
		const glyph = this._allocator.allocate(rasterizedGlyph);
		if (glyph === void 0) return;
		this._glyphMap.set(glyph, chars, tokenMetadata, decorationStyleSetId, rasterizer.cacheKey);
		this._glyphInOrderSet.add(glyph);
		this._version++;
		this._usedArea.right = Math.max(this._usedArea.right, glyph.x + glyph.w - 1);
		this._usedArea.bottom = Math.max(this._usedArea.bottom, glyph.y + glyph.h - 1);
		if (this._logService.getLevel() === LogLevel.Trace) this._logService.trace("New glyph", {
			chars,
			tokenMetadata,
			decorationStyleSetId,
			rasterizedGlyph,
			glyph
		});
		return glyph;
	}
	getUsagePreview() {
		return this._allocator.getUsagePreview();
	}
	getStats() {
		return this._allocator.getStats();
	}
};
TextureAtlasPage = TextureAtlasPage_1 = __decorate$70([__param$65(3, ILogService), __param$65(4, IThemeService)], TextureAtlasPage);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/gpu/atlas/textureAtlas.js
var __decorate$69 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$64 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var TextureAtlas_1;
var TextureAtlas = class TextureAtlas extends Disposable {
	static {
		TextureAtlas_1 = this;
	}
	/**
	* The maximum number of texture atlas pages. This is currently a hard static cap that must not
	* be reached.
	*/
	static {
		this.maximumPageCount = 16;
	}
	get pages() {
		return this._pages;
	}
	constructor(_maxTextureSize, options, _decorationStyleCache, _themeService, _instantiationService) {
		super();
		this._maxTextureSize = _maxTextureSize;
		this._decorationStyleCache = _decorationStyleCache;
		this._themeService = _themeService;
		this._instantiationService = _instantiationService;
		this._warmUpTask = this._register(new MutableDisposable());
		this._warmedUpRasterizers = /* @__PURE__ */ new Set();
		/**
		* The main texture atlas pages which are both larger textures and more efficiently packed
		* relative to the scratch page. The idea is the main pages are drawn to and uploaded to the GPU
		* much less frequently so as to not drop frames.
		*/
		this._pages = [];
		/**
		* A maps of glyph keys to the page to start searching for the glyph. This is set before
		* searching to have as little runtime overhead (branching, intermediate variables) as possible,
		* so it is not guaranteed to be the actual page the glyph is on. But it is guaranteed that all
		* pages with a lower index do not contain the glyph.
		*/
		this._glyphPageIndex = new NKeyMap();
		this._onDidDeleteGlyphs = this._register(new Emitter$1());
		this.onDidDeleteGlyphs = this._onDidDeleteGlyphs.event;
		this._allocatorType = options?.allocatorType ?? "slab";
		this._register(Event.runAndSubscribe(this._themeService.onDidColorThemeChange, () => {
			if (this._colorMap) this.clear();
			this._colorMap = this._themeService.getColorTheme().tokenColorMap;
		}));
		const dprFactor = Math.max(1, Math.floor(getActiveWindow().devicePixelRatio));
		this.pageSize = Math.min(1024 * dprFactor, this._maxTextureSize);
		this._initFirstPage();
		this._register(toDisposable(() => dispose(this._pages)));
	}
	_initFirstPage() {
		const firstPage = this._instantiationService.createInstance(TextureAtlasPage, 0, this.pageSize, this._allocatorType);
		this._pages.push(firstPage);
		const nullRasterizer = new GlyphRasterizer(1, "", 1, this._decorationStyleCache);
		firstPage.getGlyph(nullRasterizer, "", 0, 0);
		nullRasterizer.dispose();
	}
	clear() {
		for (const page of this._pages) page.dispose();
		this._pages.length = 0;
		this._glyphPageIndex.clear();
		this._warmedUpRasterizers.clear();
		this._warmUpTask.clear();
		this._initFirstPage();
		this._onDidDeleteGlyphs.fire();
	}
	getGlyph(rasterizer, chars, tokenMetadata, decorationStyleSetId, x) {
		tokenMetadata &= -2048;
		tokenMetadata |= Math.floor(x % 1 * 10);
		if (!this._warmedUpRasterizers.has(rasterizer.id)) {
			this._warmUpAtlas(rasterizer);
			this._warmedUpRasterizers.add(rasterizer.id);
		}
		return this._tryGetGlyph(this._glyphPageIndex.get(chars, tokenMetadata, decorationStyleSetId, rasterizer.cacheKey) ?? 0, rasterizer, chars, tokenMetadata, decorationStyleSetId);
	}
	_tryGetGlyph(pageIndex, rasterizer, chars, tokenMetadata, decorationStyleSetId) {
		this._glyphPageIndex.set(pageIndex, chars, tokenMetadata, decorationStyleSetId, rasterizer.cacheKey);
		return this._pages[pageIndex].getGlyph(rasterizer, chars, tokenMetadata, decorationStyleSetId) ?? (pageIndex + 1 < this._pages.length ? this._tryGetGlyph(pageIndex + 1, rasterizer, chars, tokenMetadata, decorationStyleSetId) : void 0) ?? this._getGlyphFromNewPage(rasterizer, chars, tokenMetadata, decorationStyleSetId);
	}
	_getGlyphFromNewPage(rasterizer, chars, tokenMetadata, decorationStyleSetId) {
		if (this._pages.length >= TextureAtlas_1.maximumPageCount) throw new Error(`Attempt to create a texture atlas page past the limit ${TextureAtlas_1.maximumPageCount}`);
		this._pages.push(this._instantiationService.createInstance(TextureAtlasPage, this._pages.length, this.pageSize, this._allocatorType));
		this._glyphPageIndex.set(this._pages.length - 1, chars, tokenMetadata, decorationStyleSetId, rasterizer.cacheKey);
		return this._pages[this._pages.length - 1].getGlyph(rasterizer, chars, tokenMetadata, decorationStyleSetId);
	}
	getStats() {
		return this._pages.map((e) => e.getStats());
	}
	/**
	* Warms up the atlas by rasterizing all printable ASCII characters for each token color. This
	* is distrubuted over multiple idle callbacks to avoid blocking the main thread.
	*/
	_warmUpAtlas(rasterizer) {
		const colorMap = this._colorMap;
		if (!colorMap) throw new BugIndicatingError("Cannot warm atlas without color map");
		this._warmUpTask.value?.clear();
		const taskQueue = this._warmUpTask.value = this._instantiationService.createInstance(IdleTaskQueue);
		for (let code = 65; code <= 90; code++) for (const fgColor of colorMap.keys()) taskQueue.enqueue(() => {
			for (let x = 0; x < 1; x += .1) this.getGlyph(rasterizer, String.fromCharCode(code), fgColor << 15 & 16744448, 0, x);
		});
		for (let code = 97; code <= 122; code++) for (const fgColor of colorMap.keys()) taskQueue.enqueue(() => {
			for (let x = 0; x < 1; x += .1) this.getGlyph(rasterizer, String.fromCharCode(code), fgColor << 15 & 16744448, 0, x);
		});
		for (let code = 33; code <= 126; code++) for (const fgColor of colorMap.keys()) taskQueue.enqueue(() => {
			for (let x = 0; x < 1; x += .1) this.getGlyph(rasterizer, String.fromCharCode(code), fgColor << 15 & 16744448, 0, x);
		});
	}
};
TextureAtlas = TextureAtlas_1 = __decorate$69([__param$64(3, IThemeService), __param$64(4, IInstantiationService)], TextureAtlas);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/severity.js
var Severity$1;
(function(Severity) {
	Severity[Severity["Ignore"] = 0] = "Ignore";
	Severity[Severity["Info"] = 1] = "Info";
	Severity[Severity["Warning"] = 2] = "Warning";
	Severity[Severity["Error"] = 3] = "Error";
})(Severity$1 || (Severity$1 = {}));
(function(Severity) {
	const _error = "error";
	const _warning = "warning";
	const _warn = "warn";
	const _info = "info";
	const _ignore = "ignore";
	/**
	* Parses 'error', 'warning', 'warn', 'info' in call casings
	* and falls back to ignore.
	*/
	function fromValue(value) {
		if (!value) return Severity.Ignore;
		if (equalsIgnoreCase(_error, value)) return Severity.Error;
		if (equalsIgnoreCase(_warning, value) || equalsIgnoreCase(_warn, value)) return Severity.Warning;
		if (equalsIgnoreCase(_info, value)) return Severity.Info;
		return Severity.Ignore;
	}
	Severity.fromValue = fromValue;
	function toString(severity) {
		switch (severity) {
			case Severity.Error: return _error;
			case Severity.Warning: return _warning;
			case Severity.Info: return _info;
			default: return _ignore;
		}
	}
	Severity.toString = toString;
})(Severity$1 || (Severity$1 = {}));
var Severity$1$1 = Severity$1;
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/notification/common/notification.js
var Severity = Severity$1$1;
var INotificationService = createDecorator("notificationService");
var NoOpNotification = class {};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/gpu/gpuDisposable.js
var GPULifecycle;
(function(GPULifecycle) {
	async function requestDevice(fallback) {
		try {
			if (!navigator.gpu) throw new Error("This browser does not support WebGPU");
			const adapter = await navigator.gpu.requestAdapter();
			if (!adapter) throw new Error("This browser supports WebGPU but it appears to be disabled");
			return wrapDestroyableInDisposable(await adapter.requestDevice());
		} catch (e) {
			if (fallback) fallback(e.message);
			throw e;
		}
	}
	GPULifecycle.requestDevice = requestDevice;
	function createBuffer(device, descriptor, initialValues) {
		const buffer = device.createBuffer(descriptor);
		if (initialValues) device.queue.writeBuffer(buffer, 0, isFunction(initialValues) ? initialValues() : initialValues);
		return wrapDestroyableInDisposable(buffer);
	}
	GPULifecycle.createBuffer = createBuffer;
	function createTexture(device, descriptor) {
		return wrapDestroyableInDisposable(device.createTexture(descriptor));
	}
	GPULifecycle.createTexture = createTexture;
})(GPULifecycle || (GPULifecycle = {}));
function wrapDestroyableInDisposable(value) {
	return {
		object: value,
		dispose: () => value.destroy()
	};
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/gpu/bufferDirtyTracker.js
/**
* A simple tracker for dirty regions in a buffer.
*/
var BufferDirtyTracker = class {
	get dataOffset() {
		return this._startIndex;
	}
	get dirtySize() {
		if (this._startIndex === void 0 || this._endIndex === void 0) return;
		return this._endIndex - this._startIndex + 1;
	}
	get isDirty() {
		return this._startIndex !== void 0;
	}
	/**
	* Flag the index(es) as modified. Returns the index flagged.
	* @param index An index to flag.
	* @param length An optional length to flag. Defaults to 1.
	*/
	flag(index, length = 1) {
		this._flag(index);
		if (length > 1) this._flag(index + length - 1);
		return index;
	}
	_flag(index) {
		if (this._startIndex === void 0 || index < this._startIndex) this._startIndex = index;
		if (this._endIndex === void 0 || index > this._endIndex) this._endIndex = index;
	}
	clear() {
		this._startIndex = void 0;
		this._endIndex = void 0;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/gpu/objectCollectionBuffer.js
function createObjectCollectionBuffer(propertySpecs, capacity) {
	return new ObjectCollectionBuffer(propertySpecs, capacity);
}
var ObjectCollectionBuffer = class extends Disposable {
	get entryCount() {
		return this._entries.size;
	}
	get dirtyTracker() {
		return this._dirtyTracker;
	}
	constructor(propertySpecs, capacity) {
		super();
		this.propertySpecs = propertySpecs;
		this.capacity = capacity;
		this._dirtyTracker = new BufferDirtyTracker();
		this._propertySpecsMap = /* @__PURE__ */ new Map();
		this._entries = new LinkedList();
		this._onDidChange = this._register(new Emitter$1());
		this._onDidChangeBuffer = this._register(new Emitter$1());
		this.onDidChangeBuffer = this._onDidChangeBuffer.event;
		this.view = new Float32Array(capacity * propertySpecs.length);
		this.buffer = this.view.buffer;
		this._entrySize = propertySpecs.length;
		for (let i = 0; i < propertySpecs.length; i++) {
			const spec = {
				offset: i,
				...propertySpecs[i]
			};
			this._propertySpecsMap.set(spec.name, spec);
		}
		this._register(toDisposable(() => dispose(this._entries)));
	}
	createEntry(data) {
		if (this._entries.size === this.capacity) {
			this._expandBuffer();
			this._onDidChangeBuffer.fire();
		}
		const value = new ObjectCollectionBufferEntry(this.view, this._propertySpecsMap, this._dirtyTracker, this._entries.size, data);
		const removeFromEntries = this._entries.push(value);
		const listeners = [];
		listeners.push(Event.forward(value.onDidChange, this._onDidChange));
		listeners.push(value.onWillDispose(() => {
			const deletedEntryIndex = value.i;
			removeFromEntries();
			this.view.set(this.view.subarray(deletedEntryIndex * this._entrySize + 2, this._entries.size * this._entrySize + 2), deletedEntryIndex * this._entrySize);
			for (const entry of this._entries) if (entry.i > deletedEntryIndex) entry.i--;
			this._dirtyTracker.flag(deletedEntryIndex, (this._entries.size - deletedEntryIndex) * this._entrySize);
			dispose(listeners);
		}));
		return value;
	}
	_expandBuffer() {
		this.capacity *= 2;
		const newView = new Float32Array(this.capacity * this._entrySize);
		newView.set(this.view);
		this.view = newView;
		this.buffer = this.view.buffer;
	}
};
var ObjectCollectionBufferEntry = class extends Disposable {
	constructor(_view, _propertySpecsMap, _dirtyTracker, i, data) {
		super();
		this._view = _view;
		this._propertySpecsMap = _propertySpecsMap;
		this._dirtyTracker = _dirtyTracker;
		this.i = i;
		this._onDidChange = this._register(new Emitter$1());
		this.onDidChange = this._onDidChange.event;
		this._onWillDispose = this._register(new Emitter$1());
		this.onWillDispose = this._onWillDispose.event;
		for (const propertySpec of this._propertySpecsMap.values()) this._view[this.i * this._propertySpecsMap.size + propertySpec.offset] = data[propertySpec.name];
		this._dirtyTracker.flag(this.i * this._propertySpecsMap.size, this._propertySpecsMap.size);
	}
	dispose() {
		this._onWillDispose.fire();
		super.dispose();
	}
	setRaw(data) {
		if (data.length !== this._propertySpecsMap.size) throw new Error(`Data length ${data.length} does not match the number of properties in the collection (${this._propertySpecsMap.size})`);
		this._view.set(data, this.i * this._propertySpecsMap.size);
		this._dirtyTracker.flag(this.i * this._propertySpecsMap.size, this._propertySpecsMap.size);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/gpu/rectangleRenderer.wgsl.js
var rectangleRendererWgsl = `

struct Vertex {
	@location(0) position: vec2f,
};

struct LayoutInfo {
	canvasDims: vec2f,
	viewportOffset: vec2f,
	viewportDims: vec2f,
}

struct ScrollOffset {
	offset: vec2f,
}

struct Shape {
	position: vec2f,
	size: vec2f,
	color: vec4f,
};

struct VSOutput {
	@builtin(position) position: vec4f,
	@location(1)       color:    vec4f,
};

// Uniforms
@group(0) @binding(1) var<uniform>       layoutInfo:      LayoutInfo;

// Storage buffers
@group(0) @binding(0)            var<storage, read> shapes:          array<Shape>;
@group(0) @binding(2)      var<uniform>       scrollOffset:    ScrollOffset;

@vertex fn vs(
	vert: Vertex,
	@builtin(instance_index) instanceIndex: u32,
	@builtin(vertex_index) vertexIndex : u32
) -> VSOutput {
	let shape = shapes[instanceIndex];

	var vsOut: VSOutput;
	vsOut.position = vec4f(
		(
			// Top left corner
			vec2f(-1,  1) +
			// Convert pixel position to clipspace
			vec2f( 2, -2) / layoutInfo.canvasDims *
			// Shape position and size
			(layoutInfo.viewportOffset - scrollOffset.offset + shape.position + vert.position * shape.size)
		),
		0.0,
		1.0
	);
	vsOut.color = shape.color;
	return vsOut;
}

@fragment fn fs(vsOut: VSOutput) -> @location(0) vec4f {
	return vsOut.color;
}
`;
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/gpu/rectangleRenderer.js
var RectangleRenderer = class extends ViewEventHandler {
	constructor(_context, _contentLeft, _devicePixelRatio, _canvas, _ctx, device) {
		super();
		this._context = _context;
		this._contentLeft = _contentLeft;
		this._devicePixelRatio = _devicePixelRatio;
		this._canvas = _canvas;
		this._ctx = _ctx;
		this._shapeBindBuffer = this._register(new MutableDisposable());
		this._initialized = false;
		this._shapeCollection = this._register(createObjectCollectionBuffer([
			{ name: "x" },
			{ name: "y" },
			{ name: "width" },
			{ name: "height" },
			{ name: "red" },
			{ name: "green" },
			{ name: "blue" },
			{ name: "alpha" }
		], 32));
		this._context.addEventHandler(this);
		this._initWebgpu(device);
	}
	async _initWebgpu(device) {
		this._device = await device;
		if (this._store.isDisposed) return;
		const presentationFormat = navigator.gpu.getPreferredCanvasFormat();
		this._ctx.configure({
			device: this._device,
			format: presentationFormat,
			alphaMode: "premultiplied"
		});
		this._renderPassColorAttachment = {
			view: null,
			loadOp: "load",
			storeOp: "store"
		};
		this._renderPassDescriptor = {
			label: "Monaco rectangle renderer render pass",
			colorAttachments: [this._renderPassColorAttachment]
		};
		let layoutInfoUniformBuffer;
		{
			const bufferValues = /* @__PURE__ */ new Float32Array(6);
			const updateBufferValues = (canvasDevicePixelWidth = this._canvas.width, canvasDevicePixelHeight = this._canvas.height) => {
				bufferValues[0] = canvasDevicePixelWidth;
				bufferValues[1] = canvasDevicePixelHeight;
				bufferValues[2] = Math.ceil(this._context.configuration.options.get(166).contentLeft * getActiveWindow().devicePixelRatio);
				bufferValues[3] = 0;
				bufferValues[4] = bufferValues[0] - bufferValues[2];
				bufferValues[5] = bufferValues[1] - bufferValues[3];
				return bufferValues;
			};
			layoutInfoUniformBuffer = this._register(GPULifecycle.createBuffer(this._device, {
				label: "Monaco rectangle renderer uniform buffer",
				size: 24,
				usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST
			}, () => updateBufferValues())).object;
			this._register(observeDevicePixelDimensions(this._canvas, getActiveWindow(), (w, h) => {
				this._device.queue.writeBuffer(layoutInfoUniformBuffer, 0, updateBufferValues(w, h));
			}));
		}
		const scrollOffsetBufferSize = 2;
		this._scrollOffsetBindBuffer = this._register(GPULifecycle.createBuffer(this._device, {
			label: "Monaco rectangle renderer scroll offset buffer",
			size: scrollOffsetBufferSize * Float32Array.BYTES_PER_ELEMENT,
			usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST
		})).object;
		this._scrollOffsetValueBuffer = new Float32Array(scrollOffsetBufferSize);
		const createShapeBindBuffer = () => {
			return GPULifecycle.createBuffer(this._device, {
				label: "Monaco rectangle renderer shape buffer",
				size: this._shapeCollection.buffer.byteLength,
				usage: GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST
			});
		};
		this._shapeBindBuffer.value = createShapeBindBuffer();
		this._register(Event.runAndSubscribe(this._shapeCollection.onDidChangeBuffer, () => {
			this._shapeBindBuffer.value = createShapeBindBuffer();
			if (this._pipeline) this._updateBindGroup(this._pipeline, layoutInfoUniformBuffer);
		}));
		this._vertexBuffer = this._register(GPULifecycle.createBuffer(this._device, {
			label: "Monaco rectangle renderer vertex buffer",
			size: quadVertices.byteLength,
			usage: GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST
		}, quadVertices)).object;
		const module = this._device.createShaderModule({
			label: "Monaco rectangle renderer shader module",
			code: rectangleRendererWgsl
		});
		this._pipeline = this._device.createRenderPipeline({
			label: "Monaco rectangle renderer render pipeline",
			layout: "auto",
			vertex: {
				module,
				buffers: [{
					arrayStride: 2 * Float32Array.BYTES_PER_ELEMENT,
					attributes: [{
						shaderLocation: 0,
						offset: 0,
						format: "float32x2"
					}]
				}]
			},
			fragment: {
				module,
				targets: [{
					format: presentationFormat,
					blend: {
						color: {
							srcFactor: "src-alpha",
							dstFactor: "one-minus-src-alpha"
						},
						alpha: {
							srcFactor: "src-alpha",
							dstFactor: "one-minus-src-alpha"
						}
					}
				}]
			}
		});
		this._updateBindGroup(this._pipeline, layoutInfoUniformBuffer);
		this._initialized = true;
	}
	_updateBindGroup(pipeline, layoutInfoUniformBuffer) {
		this._bindGroup = this._device.createBindGroup({
			label: "Monaco rectangle renderer bind group",
			layout: pipeline.getBindGroupLayout(0),
			entries: [
				{
					binding: 0,
					resource: { buffer: this._shapeBindBuffer.value.object }
				},
				{
					binding: 1,
					resource: { buffer: layoutInfoUniformBuffer }
				},
				{
					binding: 2,
					resource: { buffer: this._scrollOffsetBindBuffer }
				}
			]
		});
	}
	register(x, y, width, height, red, green, blue, alpha) {
		return this._shapeCollection.createEntry({
			x,
			y,
			width,
			height,
			red,
			green,
			blue,
			alpha
		});
	}
	onScrollChanged(e) {
		if (this._device) {
			const dpr = getActiveWindow().devicePixelRatio;
			this._scrollOffsetValueBuffer[0] = this._context.viewLayout.getCurrentScrollLeft() * dpr;
			this._scrollOffsetValueBuffer[1] = this._context.viewLayout.getCurrentScrollTop() * dpr;
			this._device.queue.writeBuffer(this._scrollOffsetBindBuffer, 0, this._scrollOffsetValueBuffer);
		}
		return true;
	}
	_update() {
		if (!this._device) return;
		const shapes = this._shapeCollection;
		if (shapes.dirtyTracker.isDirty) {
			this._device.queue.writeBuffer(this._shapeBindBuffer.value.object, 0, shapes.buffer, shapes.dirtyTracker.dataOffset, shapes.dirtyTracker.dirtySize * shapes.view.BYTES_PER_ELEMENT);
			shapes.dirtyTracker.clear();
		}
	}
	draw(viewportData) {
		if (!this._initialized) return;
		this._update();
		const encoder = this._device.createCommandEncoder({ label: "Monaco rectangle renderer command encoder" });
		this._renderPassColorAttachment.view = this._ctx.getCurrentTexture().createView();
		const pass = encoder.beginRenderPass(this._renderPassDescriptor);
		pass.setPipeline(this._pipeline);
		pass.setVertexBuffer(0, this._vertexBuffer);
		pass.setBindGroup(0, this._bindGroup);
		const contentLeft = Math.ceil(this._contentLeft.get() * this._devicePixelRatio.get());
		pass.setScissorRect(contentLeft, 0, this._canvas.width - contentLeft, this._canvas.height);
		pass.draw(quadVertices.length / 2, this._shapeCollection.entryCount);
		pass.end();
		const commandBuffer = encoder.finish();
		this._device.queue.submit([commandBuffer]);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/gpu/css/decorationCssRuleExtractor.js
/**
* Extracts CSS rules that would be applied to certain decoration classes.
*/
var DecorationCssRuleExtractor = class extends Disposable {
	constructor() {
		super();
		this._ruleCache = /* @__PURE__ */ new Map();
		this._cssVariableCache = /* @__PURE__ */ new Map();
		this._container = $$10("div.monaco-decoration-css-rule-extractor");
		this._dummyElement = $$10("span");
		this._container.appendChild(this._dummyElement);
		this._register(toDisposable(() => this._container.remove()));
	}
	getStyleRules(canvas, decorationClassName) {
		const existing = this._ruleCache.get(decorationClassName);
		if (existing) return existing;
		this._dummyElement.className = decorationClassName;
		canvas.appendChild(this._container);
		const rules = this._getStyleRules(decorationClassName);
		this._ruleCache.set(decorationClassName, rules);
		canvas.removeChild(this._container);
		return rules;
	}
	_getStyleRules(className) {
		const rules = [];
		const stylesheets = [...getActiveDocument().styleSheets];
		const classNames = className.split(" ").filter((c) => c.length > 0);
		for (let i = 0; i < stylesheets.length; i++) {
			const stylesheet = stylesheets[i];
			this._collectMatchingRules(stylesheet.cssRules, classNames, rules);
		}
		return rules;
	}
	_collectMatchingRules(cssRules, classNames, result) {
		for (const rule of cssRules) if (rule instanceof CSSImportRule) {
			if (rule.styleSheet) this._collectMatchingRules(rule.styleSheet.cssRules, classNames, result);
		} else if (rule instanceof CSSStyleRule) {
			for (const className of classNames) {
				const searchTerm = `.${className}`;
				const index = rule.selectorText.indexOf(searchTerm);
				if (index !== -1) {
					const endOfResult = index + searchTerm.length;
					if (rule.selectorText.length === endOfResult || rule.selectorText.substring(endOfResult, endOfResult + 1).match(/[ :.]/)) {
						result.push(rule);
						break;
					}
				}
			}
			if (rule.cssRules?.length) this._collectMatchingRules(rule.cssRules, classNames, result);
		}
	}
	/**
	* Resolves a CSS variable to its computed value using the container element.
	*/
	resolveCssVariable(canvas, variableName) {
		let result = this._cssVariableCache.get(variableName);
		if (result === void 0) {
			canvas.appendChild(this._container);
			result = getActiveWindow().getComputedStyle(this._container).getPropertyValue(variableName).trim();
			canvas.removeChild(this._container);
			this._cssVariableCache.set(variableName, result);
		}
		return result;
	}
	/**
	* Clears all cached CSS rules and CSS variable values. This should be called when the theme
	* changes to ensure fresh values are computed.
	*/
	clear() {
		this._ruleCache.clear();
		this._cssVariableCache.clear();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/gpu/css/decorationStyleCache.js
var DecorationStyleCache = class {
	constructor() {
		this._nextId = 1;
		this._cacheById = /* @__PURE__ */ new Map();
		this._cacheByStyle = new NKeyMap();
	}
	getOrCreateEntry(color, bold, opacity, strikethrough, strikethroughThickness, strikethroughColor) {
		if (color === void 0 && bold === void 0 && opacity === void 0 && strikethrough === void 0 && strikethroughThickness === void 0 && strikethroughColor === void 0) return 0;
		const result = this._cacheByStyle.get(color ?? 0, bold ? 1 : 0, opacity === void 0 ? "" : opacity.toFixed(2), strikethrough ? 1 : 0, strikethroughThickness === void 0 ? "" : strikethroughThickness.toFixed(2), strikethroughColor ?? 0);
		if (result) return result.id;
		const id = this._nextId++;
		const entry = {
			id,
			color,
			bold,
			opacity,
			strikethrough,
			strikethroughThickness,
			strikethroughColor
		};
		this._cacheById.set(id, entry);
		this._cacheByStyle.set(entry, color ?? 0, bold ? 1 : 0, opacity === void 0 ? "" : opacity.toFixed(2), strikethrough ? 1 : 0, strikethroughThickness === void 0 ? "" : strikethroughThickness.toFixed(2), strikethroughColor ?? 0);
		return id;
	}
	getStyleSet(id) {
		if (id === 0) return;
		return this._cacheById.get(id);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/observableInternal/utils/runOnChange.js
function runOnChange(observable, cb) {
	let _previousValue;
	let _firstRun = true;
	return autorunWithStoreHandleChanges({ changeTracker: {
		createChangeSummary: () => ({
			deltas: [],
			didChange: false
		}),
		handleChange: (context, changeSummary) => {
			if (context.didChange(observable)) {
				const e = context.change;
				if (e !== void 0) changeSummary.deltas.push(e);
				changeSummary.didChange = true;
			}
			return true;
		}
	} }, (reader, changeSummary) => {
		const value = observable.read(reader);
		const previousValue = _previousValue;
		if (changeSummary.didChange) {
			_previousValue = value;
			cb(value, previousValue, changeSummary.deltas);
		}
		if (_firstRun) {
			_firstRun = false;
			_previousValue = value;
		}
	});
}
function runOnChangeWithStore(observable, cb) {
	const store = new DisposableStore();
	const disposable = runOnChange(observable, (value, previousValue, deltas) => {
		store.clear();
		cb(value, previousValue, deltas, store);
	});
	return { dispose() {
		disposable.dispose();
		store.dispose();
	} };
}
function runOnChangeWithCancellationToken(observable, cb) {
	return runOnChangeWithStore(observable, (value, previousValue, deltas, store) => {
		cb(value, previousValue, deltas, cancelOnDispose(store));
	});
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/gpu/viewGpuContext.js
var __decorate$68 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$63 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var ViewGpuContext_1;
var ViewGpuContext = class ViewGpuContext extends Disposable {
	static {
		ViewGpuContext_1 = this;
	}
	static {
		this._decorationCssRuleExtractor = new DecorationCssRuleExtractor();
	}
	static get decorationCssRuleExtractor() {
		return ViewGpuContext_1._decorationCssRuleExtractor;
	}
	static {
		this._decorationStyleCache = new DecorationStyleCache();
	}
	static get decorationStyleCache() {
		return ViewGpuContext_1._decorationStyleCache;
	}
	/**
	* The shared texture atlas to use across all views.
	*
	* @throws if called before the GPU device is resolved
	*/
	static get atlas() {
		if (!ViewGpuContext_1._atlas) throw new BugIndicatingError("Cannot call ViewGpuContext.textureAtlas before device is resolved");
		return ViewGpuContext_1._atlas;
	}
	/**
	* The shared texture atlas to use across all views. This is a convenience alias for
	* {@link ViewGpuContext.atlas}.
	*
	* @throws if called before the GPU device is resolved
	*/
	get atlas() {
		return ViewGpuContext_1.atlas;
	}
	constructor(context, _instantiationService, _notificationService, configurationService, _themeService) {
		super();
		this._instantiationService = _instantiationService;
		this._notificationService = _notificationService;
		this.configurationService = configurationService;
		this._themeService = _themeService;
		/**
		* The hard cap for line columns rendered by the GPU renderer.
		*/
		this.maxGpuCols = 2e3;
		this.canvas = createFastDomNode(document.createElement("canvas"));
		this.canvas.setClassName("editorCanvas");
		this._register(Event.runAndSubscribe(configurationService.onDidChangeConfiguration, (e) => {
			if (!e || e.affectsConfiguration("editor.scrollbar.verticalScrollbarSize")) {
				const verticalScrollbarSize = configurationService.getValue("editor").scrollbar?.verticalScrollbarSize ?? 14;
				this.canvas.domNode.style.boxSizing = "border-box";
				this.canvas.domNode.style.paddingRight = `${verticalScrollbarSize}px`;
			}
		}));
		this.ctx = ensureNonNullable(this.canvas.domNode.getContext("webgpu"));
		if (!ViewGpuContext_1.device) ViewGpuContext_1.device = GPULifecycle.requestDevice((message) => {
			const choices = [{
				label: localize(82, "Use DOM-based rendering"),
				run: () => this.configurationService.updateValue("editor.experimentalGpuAcceleration", "off")
			}];
			this._notificationService.prompt(Severity.Warning, message, choices);
		}).then((ref) => {
			ViewGpuContext_1.deviceSync = ref.object;
			if (!ViewGpuContext_1._atlas) ViewGpuContext_1._atlas = this._instantiationService.createInstance(TextureAtlas, ref.object.limits.maxTextureDimension2D, void 0, ViewGpuContext_1.decorationStyleCache);
			return ref.object;
		});
		const dprObs = observableValue(this, getActiveWindow().devicePixelRatio);
		this._register(addDisposableListener(getActiveWindow(), "resize", () => {
			dprObs.set(getActiveWindow().devicePixelRatio, void 0);
		}));
		this.devicePixelRatio = dprObs;
		this._register(runOnChange(this.devicePixelRatio, () => ViewGpuContext_1.atlas?.clear()));
		this._register(this._themeService.onDidColorThemeChange(() => {
			ViewGpuContext_1.decorationCssRuleExtractor.clear();
			ViewGpuContext_1.atlas?.clear();
		}));
		const canvasDevicePixelDimensions = observableValue(this, {
			width: this.canvas.domNode.width,
			height: this.canvas.domNode.height
		});
		this._register(observeDevicePixelDimensions(this.canvas.domNode, getActiveWindow(), (width, height) => {
			this.canvas.domNode.width = width;
			this.canvas.domNode.height = height;
			canvasDevicePixelDimensions.set({
				width,
				height
			}, void 0);
		}));
		this.canvasDevicePixelDimensions = canvasDevicePixelDimensions;
		const contentLeft = observableValue(this, 0);
		this._register(this.configurationService.onDidChangeConfiguration((e) => {
			contentLeft.set(context.configuration.options.get(166).contentLeft, void 0);
		}));
		this.contentLeft = contentLeft;
		this.rectangleRenderer = this._register(this._instantiationService.createInstance(RectangleRenderer, context, this.contentLeft, this.devicePixelRatio, this.canvas.domNode, this.ctx, ViewGpuContext_1.device));
	}
	/**
	* This method determines which lines can be and are allowed to be rendered using the GPU
	* renderer. Eventually this should trend all lines, except maybe exceptional cases like
	* decorations that use class names.
	*/
	canRender(options, viewportData, lineNumber) {
		const data = viewportData.getViewLineRenderingData(lineNumber);
		if (data.containsRTL || data.maxColumn > this.maxGpuCols || requiresDomFullwidthCharacterRendering(options, data.content)) return false;
		if (data.inlineDecorations.length > 0) {
			let supported = true;
			for (const decoration of data.inlineDecorations) {
				if (decoration.type !== 0) {
					supported = false;
					break;
				}
				const styleRules = ViewGpuContext_1._decorationCssRuleExtractor.getStyleRules(this.canvas.domNode, decoration.inlineClassName);
				supported &&= styleRules.every((rule) => {
					if (rule.selectorText.includes(":")) return false;
					for (const r of rule.style) if (!supportsCssRule(r, rule.style)) return false;
					return true;
				});
				if (!supported) break;
			}
			return supported;
		}
		return true;
	}
	/**
	* Like {@link canRender} but returns detailed information about why the line cannot be rendered.
	*/
	canRenderDetailed(options, viewportData, lineNumber) {
		const data = viewportData.getViewLineRenderingData(lineNumber);
		const reasons = [];
		if (data.containsRTL) reasons.push("containsRTL");
		if (data.maxColumn > this.maxGpuCols) reasons.push("maxColumn > maxGpuCols");
		if (requiresDomFullwidthCharacterRendering(options, data.content)) reasons.push("useTwoCellFullwidthCharacters");
		if (data.inlineDecorations.length > 0) {
			let supported = true;
			const problemTypes = [];
			const problemSelectors = [];
			const problemRules = [];
			for (const decoration of data.inlineDecorations) {
				if (decoration.type !== 0) {
					problemTypes.push(decoration.type);
					supported = false;
					continue;
				}
				const styleRules = ViewGpuContext_1._decorationCssRuleExtractor.getStyleRules(this.canvas.domNode, decoration.inlineClassName);
				supported &&= styleRules.every((rule) => {
					if (rule.selectorText.includes(":")) {
						problemSelectors.push(rule.selectorText);
						return false;
					}
					for (const r of rule.style) if (!supportsCssRule(r, rule.style)) {
						problemRules.push(`${r}: ${rule.style[r]}`);
						return false;
					}
					return true;
				});
				if (!supported) continue;
			}
			if (problemTypes.length > 0) reasons.push(`inlineDecorations with unsupported types (${problemTypes.map((e) => `\`${e}\``).join(", ")})`);
			if (problemRules.length > 0) reasons.push(`inlineDecorations with unsupported CSS rules (${problemRules.map((e) => `\`${e}\``).join(", ")})`);
			if (problemSelectors.length > 0) reasons.push(`inlineDecorations with unsupported CSS selectors (${problemSelectors.map((e) => `\`${e}\``).join(", ")})`);
		}
		return reasons;
	}
};
ViewGpuContext = ViewGpuContext_1 = __decorate$68([
	__param$63(1, IInstantiationService),
	__param$63(2, INotificationService),
	__param$63(3, IConfigurationService),
	__param$63(4, IThemeService)
], ViewGpuContext);
function requiresDomFullwidthCharacterRendering(options, content) {
	if (!options.useTwoCellFullwidthCharacters) return false;
	const limit = options.stopRenderingLineAfter === -1 ? content.length : Math.min(options.stopRenderingLineAfter, content.length);
	for (let offset = 0; offset < limit; offset++) if (isFullWidthCharacter(content.charCodeAt(offset))) return true;
	return false;
}
/**
* A list of supported decoration CSS rules that can be used in the GPU renderer.
*/
var gpuSupportedDecorationCssRules = [
	"color",
	"font-weight",
	"opacity",
	"text-decoration",
	"text-decoration-color",
	"text-decoration-line",
	"text-decoration-style",
	"text-decoration-thickness"
];
function supportsCssRule(rule, style) {
	if (!gpuSupportedDecorationCssRules.includes(rule)) return false;
	switch (rule) {
		case "text-decoration":
		case "text-decoration-line": return style.getPropertyValue(rule) === "line-through";
		case "text-decoration-color": {
			const value = style.getPropertyValue(rule);
			if (/^var\(--[^,]+,\s*(?:initial|inherit)\)$/.test(value)) return true;
			return Color.Format.CSS.parse(value) !== null;
		}
		case "text-decoration-style": return style.getPropertyValue(rule) === "initial";
		case "text-decoration-thickness": {
			const value = style.getPropertyValue(rule);
			return value === "initial" || /^\d+(\.\d+)?px$/.test(value);
		}
		default: return true;
	}
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/gpu/contentSegmenter.js
function createContentSegmenter(lineData, options) {
	if (lineData.isBasicASCII && options.useMonospaceOptimizations) return new AsciiContentSegmenter(lineData);
	return new GraphemeContentSegmenter(lineData);
}
var AsciiContentSegmenter = class {
	constructor(lineData) {
		this._content = lineData.content;
	}
	getSegmentAtIndex(index) {
		return this._content[index];
	}
};
/**
* This is a more modern version of {@link GraphemeIterator}, relying on browser APIs instead of a
* manual table approach.
*/
var GraphemeContentSegmenter = class {
	constructor(lineData) {
		this._segments = [];
		const content = lineData.content;
		const segmenter = safeIntl.Segmenter(void 0, { granularity: "grapheme" }).value;
		const segmentedContent = Array.from(segmenter.segment(content));
		let segmenterIndex = 0;
		for (let x = 0; x < content.length; x++) {
			const segment = segmentedContent[segmenterIndex];
			if (!segment) break;
			if (segment.index !== x) {
				this._segments.push(void 0);
				continue;
			}
			segmenterIndex++;
			this._segments.push(segment);
		}
	}
	getSegmentAtIndex(index) {
		return this._segments[index]?.segment;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/gpu/renderStrategy/baseRenderStrategy.js
var BaseRenderStrategy = class extends ViewEventHandler {
	get glyphRasterizer() {
		return this._glyphRasterizer.value;
	}
	constructor(_context, _viewGpuContext, _device, _glyphRasterizer) {
		super();
		this._context = _context;
		this._viewGpuContext = _viewGpuContext;
		this._device = _device;
		this._glyphRasterizer = _glyphRasterizer;
		this._context.addEventHandler(this);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/gpu/renderStrategy/fullFileRenderStrategy.wgsl.js
var fullFileRenderStrategyWgsl = `
struct GlyphInfo {
	position: vec2f,
	size: vec2f,
	origin: vec2f,
};

struct Vertex {
	@location(0) position: vec2f,
};

struct Cell {
	position: vec2f,
	unused1: vec2f,
	glyphIndex: f32,
	textureIndex: f32
};

struct LayoutInfo {
	canvasDims: vec2f,
	viewportOffset: vec2f,
	viewportDims: vec2f,
}

struct ScrollOffset {
	offset: vec2f
}

struct VSOutput {
	@builtin(position) position:   vec4f,
	@location(1)       layerIndex: f32,
	@location(0)       texcoord:   vec2f,
};

// Uniforms
@group(0) @binding(4)       var<uniform>       layoutInfo:      LayoutInfo;
@group(0) @binding(5)  var<uniform>       atlasDims:       vec2f;
@group(0) @binding(6)            var<uniform>       scrollOffset:    ScrollOffset;

// Storage buffers
@group(0) @binding(0)               var<storage, read> glyphInfo:       array<array<GlyphInfo, ${TextureAtlasPage.maximumGlyphCount}>, ${TextureAtlas.maximumPageCount}>;
@group(0) @binding(1)                   var<storage, read> cells:           array<Cell>;

@vertex fn vs(
	vert: Vertex,
	@builtin(instance_index) instanceIndex: u32,
	@builtin(vertex_index) vertexIndex : u32
) -> VSOutput {
	let cell = cells[instanceIndex];
	var glyph = glyphInfo[u32(cell.textureIndex)][u32(cell.glyphIndex)];

	var vsOut: VSOutput;
	// Multiple vert.position by 2,-2 to get it into clipspace which ranged from -1 to 1
	vsOut.position = vec4f(
		// Make everything relative to top left instead of center
		vec2f(-1, 1) +
		((vert.position * vec2f(2, -2)) / layoutInfo.canvasDims) * glyph.size +
		((cell.position * vec2f(2, -2)) / layoutInfo.canvasDims) +
		((glyph.origin * vec2f(2, -2)) / layoutInfo.canvasDims) +
		(((layoutInfo.viewportOffset - scrollOffset.offset * vec2(1, -1)) * 2) / layoutInfo.canvasDims),
		0.0,
		1.0
	);

	vsOut.layerIndex = cell.textureIndex;
	// Textures are flipped from natural direction on the y-axis, so flip it back
	vsOut.texcoord = vert.position;
	vsOut.texcoord = (
		// Glyph offset (0-1)
		(glyph.position / atlasDims) +
		// Glyph coordinate (0-1)
		(vsOut.texcoord * (glyph.size / atlasDims))
	);

	return vsOut;
}

@group(0) @binding(2) var ourSampler: sampler;
@group(0) @binding(3)        var ourTexture: texture_2d_array<f32>;

@fragment fn fs(vsOut: VSOutput) -> @location(0) vec4f {
	return textureSample(ourTexture, ourSampler, vsOut.texcoord, u32(vsOut.layerIndex));
}
`;
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/gpu/renderStrategy/viewportRenderStrategy.js
/**
* A render strategy that uploads the content of the entire viewport every frame.
*/
var ViewportRenderStrategy = class ViewportRenderStrategy extends BaseRenderStrategy {
	/**
	* The hard cap for line columns that can be rendered by the GPU renderer.
	*/
	static {
		this.maxSupportedColumns = 2e3;
	}
	get bindGroupEntries() {
		return [{
			binding: 1,
			resource: { buffer: this._cellBindBuffer }
		}, {
			binding: 6,
			resource: { buffer: this._scrollOffsetBindBuffer }
		}];
	}
	constructor(context, viewGpuContext, device, glyphRasterizer) {
		super(context, viewGpuContext, device, glyphRasterizer);
		this.type = "viewport";
		this.wgsl = fullFileRenderStrategyWgsl;
		this._cellBindBufferLineCapacity = 63;
		this._activeDoubleBufferIndex = 0;
		this._visibleObjectCount = 0;
		this._lastViewportLineCount = 0;
		this._scrollInitialized = false;
		this._onDidChangeBindGroupEntries = this._register(new Emitter$1());
		this.onDidChangeBindGroupEntries = this._onDidChangeBindGroupEntries.event;
		this._rebuildCellBuffer(this._cellBindBufferLineCapacity);
		const scrollOffsetBufferSize = 2;
		this._scrollOffsetBindBuffer = this._register(GPULifecycle.createBuffer(this._device, {
			label: "Monaco scroll offset buffer",
			size: scrollOffsetBufferSize * Float32Array.BYTES_PER_ELEMENT,
			usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST
		})).object;
		this._scrollOffsetValueBuffer = new Float32Array(scrollOffsetBufferSize);
	}
	_rebuildCellBuffer(lineCount) {
		this._cellBindBuffer?.destroy();
		const lineCountWithIncrement = (Math.floor(lineCount / 32) + 1) * 32;
		const bufferSize = lineCountWithIncrement * ViewportRenderStrategy.maxSupportedColumns * 6 * Float32Array.BYTES_PER_ELEMENT;
		this._cellBindBuffer = this._register(GPULifecycle.createBuffer(this._device, {
			label: "Monaco full file cell buffer",
			size: bufferSize,
			usage: GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST
		})).object;
		this._cellValueBuffers = [new ArrayBuffer(bufferSize), new ArrayBuffer(bufferSize)];
		this._cellBindBufferLineCapacity = lineCountWithIncrement;
		this._lastViewportLineCount = 0;
		this._onDidChangeBindGroupEntries.fire();
	}
	onConfigurationChanged(e) {
		return true;
	}
	onDecorationsChanged(e) {
		return true;
	}
	onTokensChanged(e) {
		return true;
	}
	onLinesDeleted(e) {
		return true;
	}
	onLinesInserted(e) {
		return true;
	}
	onLinesChanged(e) {
		return true;
	}
	onScrollChanged(e) {
		if (this._store.isDisposed) return false;
		const dpr = getActiveWindow().devicePixelRatio;
		this._scrollOffsetValueBuffer[0] = (e?.scrollLeft ?? this._context.viewLayout.getCurrentScrollLeft()) * dpr;
		this._scrollOffsetValueBuffer[1] = (e?.scrollTop ?? this._context.viewLayout.getCurrentScrollTop()) * dpr;
		this._device.queue.writeBuffer(this._scrollOffsetBindBuffer, 0, this._scrollOffsetValueBuffer);
		return true;
	}
	onThemeChanged(e) {
		return true;
	}
	onLineMappingChanged(e) {
		return true;
	}
	onZonesChanged(e) {
		return true;
	}
	reset() {
		for (const bufferIndex of [0, 1]) {
			const buffer = new Float32Array(this._cellValueBuffers[bufferIndex]);
			buffer.fill(0, 0, buffer.length);
			this._device.queue.writeBuffer(this._cellBindBuffer, 0, buffer.buffer, 0, buffer.byteLength);
		}
		this._lastViewportLineCount = 0;
	}
	update(viewportData, viewLineOptions) {
		let chars = "";
		let segment;
		let charWidth = 0;
		let y = 0;
		let x = 0;
		let absoluteOffsetX = 0;
		let absoluteOffsetY = 0;
		let tabXOffset = 0;
		let glyph;
		let cellIndex = 0;
		let tokenStartIndex = 0;
		let tokenEndIndex = 0;
		let tokenMetadata = 0;
		let decorationStyleSetBold;
		let decorationStyleSetColor;
		let decorationStyleSetOpacity;
		let decorationStyleSetStrikethrough;
		let decorationStyleSetStrikethroughThickness;
		let decorationStyleSetStrikethroughColor;
		let lineData;
		let decoration;
		let fillStartIndex = 0;
		let fillEndIndex = 0;
		let tokens;
		const dpr = getActiveWindow().devicePixelRatio;
		let contentSegmenter;
		if (!this._scrollInitialized) {
			this.onScrollChanged();
			this._scrollInitialized = true;
		}
		if (this._cellBindBufferLineCapacity < viewportData.endLineNumber - viewportData.startLineNumber + 1) this._rebuildCellBuffer(viewportData.endLineNumber - viewportData.startLineNumber + 1);
		const cellBuffer = new Float32Array(this._cellValueBuffers[this._activeDoubleBufferIndex]);
		cellBuffer.fill(0);
		const lineIndexCount = ViewportRenderStrategy.maxSupportedColumns * 6;
		for (y = viewportData.startLineNumber; y <= viewportData.endLineNumber; y++) {
			if (!this._viewGpuContext.canRender(viewLineOptions, viewportData, y)) continue;
			lineData = viewportData.getViewLineRenderingData(y);
			tabXOffset = 0;
			contentSegmenter = createContentSegmenter(lineData, viewLineOptions);
			charWidth = viewLineOptions.spaceWidth * dpr;
			absoluteOffsetX = (lineData.minColumn - 1) * charWidth;
			tokens = lineData.tokens;
			tokenStartIndex = lineData.minColumn - 1;
			tokenEndIndex = 0;
			for (let tokenIndex = 0, tokensLen = tokens.getCount(); tokenIndex < tokensLen; tokenIndex++) {
				tokenEndIndex = tokens.getEndOffset(tokenIndex);
				if (tokenEndIndex <= tokenStartIndex) continue;
				tokenMetadata = tokens.getMetadata(tokenIndex);
				for (x = tokenStartIndex; x < tokenEndIndex; x++) {
					if (x > ViewportRenderStrategy.maxSupportedColumns) break;
					segment = contentSegmenter.getSegmentAtIndex(x);
					if (segment === void 0) continue;
					chars = segment;
					if (!(lineData.isBasicASCII && viewLineOptions.useMonospaceOptimizations)) charWidth = this.glyphRasterizer.getTextMetrics(chars).width;
					decorationStyleSetColor = void 0;
					decorationStyleSetBold = void 0;
					decorationStyleSetOpacity = void 0;
					decorationStyleSetStrikethrough = void 0;
					decorationStyleSetStrikethroughThickness = void 0;
					decorationStyleSetStrikethroughColor = void 0;
					for (decoration of lineData.inlineDecorations) {
						if (y < decoration.range.startLineNumber || y > decoration.range.endLineNumber || y === decoration.range.startLineNumber && x < decoration.range.startColumn - 1 || y === decoration.range.endLineNumber && x >= decoration.range.endColumn - 1) continue;
						const rules = ViewGpuContext.decorationCssRuleExtractor.getStyleRules(this._viewGpuContext.canvas.domNode, decoration.inlineClassName);
						for (const rule of rules) for (const r of rule.style) {
							const value = rule.styleMap.get(r)?.toString() ?? "";
							switch (r) {
								case "color": {
									const parsedColor = Color.Format.CSS.parse(value);
									if (!parsedColor) throw new BugIndicatingError("Invalid color format " + value);
									decorationStyleSetColor = parsedColor.toNumber32Bit();
									break;
								}
								case "font-weight":
									if (parseCssFontWeight$1(value) >= 400) decorationStyleSetBold = true;
									else decorationStyleSetBold = false;
									break;
								case "opacity":
									decorationStyleSetOpacity = parseCssOpacity$1(value);
									break;
								case "text-decoration":
								case "text-decoration-line":
									if (value === "line-through") decorationStyleSetStrikethrough = true;
									break;
								case "text-decoration-thickness": {
									const match = value.match(/^(\d+(?:\.\d+)?)px$/);
									if (match) decorationStyleSetStrikethroughThickness = parseFloat(match[1]);
									break;
								}
								case "text-decoration-color": {
									let colorValue = value;
									const varMatch = value.match(/^var\((--[^,]+),\s*(?:initial|inherit)\)$/);
									if (varMatch) colorValue = ViewGpuContext.decorationCssRuleExtractor.resolveCssVariable(this._viewGpuContext.canvas.domNode, varMatch[1]);
									const parsedColor = Color.Format.CSS.parse(colorValue);
									if (parsedColor) decorationStyleSetStrikethroughColor = parsedColor.toNumber32Bit();
									break;
								}
								case "text-decoration-style": break;
								default: throw new BugIndicatingError("Unexpected inline decoration style");
							}
						}
					}
					if (chars === " " || chars === "	") {
						cellIndex = ((y - 1) * ViewportRenderStrategy.maxSupportedColumns + x) * 6;
						cellBuffer.fill(0, cellIndex, cellIndex + 6);
						if (chars === "	") {
							const offsetBefore = x + tabXOffset;
							tabXOffset = CursorColumns.nextRenderTabStop(x + tabXOffset, lineData.tabSize);
							absoluteOffsetX += charWidth * (tabXOffset - offsetBefore);
							tabXOffset -= x + 1;
						} else absoluteOffsetX += charWidth;
						continue;
					}
					const decorationStyleSetId = ViewGpuContext.decorationStyleCache.getOrCreateEntry(decorationStyleSetColor, decorationStyleSetBold, decorationStyleSetOpacity, decorationStyleSetStrikethrough, decorationStyleSetStrikethroughThickness, decorationStyleSetStrikethroughColor);
					glyph = this._viewGpuContext.atlas.getGlyph(this.glyphRasterizer, chars, tokenMetadata, decorationStyleSetId, absoluteOffsetX);
					absoluteOffsetY = Math.round(viewportData.relativeVerticalOffset[y - viewportData.startLineNumber] * dpr + Math.floor((viewportData.lineHeight * dpr - (glyph.fontBoundingBoxAscent + glyph.fontBoundingBoxDescent)) / 2) + glyph.fontBoundingBoxAscent);
					cellIndex = ((y - viewportData.startLineNumber) * ViewportRenderStrategy.maxSupportedColumns + x) * 6;
					cellBuffer[cellIndex + 0] = Math.floor(absoluteOffsetX);
					cellBuffer[cellIndex + 1] = absoluteOffsetY;
					cellBuffer[cellIndex + 4] = glyph.glyphIndex;
					cellBuffer[cellIndex + 5] = glyph.pageIndex;
					absoluteOffsetX += charWidth;
				}
				tokenStartIndex = tokenEndIndex;
			}
			fillStartIndex = ((y - viewportData.startLineNumber) * ViewportRenderStrategy.maxSupportedColumns + tokenEndIndex) * 6;
			fillEndIndex = (y - viewportData.startLineNumber) * ViewportRenderStrategy.maxSupportedColumns * 6;
			cellBuffer.fill(0, fillStartIndex, fillEndIndex);
		}
		const visibleObjectCount = (viewportData.endLineNumber - viewportData.startLineNumber + 1) * lineIndexCount;
		const viewportLineCount = viewportData.endLineNumber - viewportData.startLineNumber + 1;
		this._device.queue.writeBuffer(this._cellBindBuffer, 0, cellBuffer.buffer, 0, visibleObjectCount * Float32Array.BYTES_PER_ELEMENT);
		if (viewportLineCount < this._lastViewportLineCount) {
			const staleLineCount = this._lastViewportLineCount - viewportLineCount;
			const staleStartOffset = visibleObjectCount * Float32Array.BYTES_PER_ELEMENT;
			const staleByteCount = staleLineCount * lineIndexCount * Float32Array.BYTES_PER_ELEMENT;
			this._device.queue.writeBuffer(this._cellBindBuffer, staleStartOffset, cellBuffer.buffer, visibleObjectCount * Float32Array.BYTES_PER_ELEMENT, staleByteCount);
		}
		this._lastViewportLineCount = viewportLineCount;
		this._activeDoubleBufferIndex = this._activeDoubleBufferIndex ? 0 : 1;
		this._visibleObjectCount = visibleObjectCount;
		return visibleObjectCount;
	}
	draw(pass, viewportData) {
		if (this._visibleObjectCount <= 0) throw new BugIndicatingError("Attempt to draw 0 objects");
		pass.draw(quadVertices.length / 2, this._visibleObjectCount);
	}
};
function parseCssFontWeight$1(value) {
	switch (value) {
		case "lighter":
		case "normal": return 400;
		case "bolder":
		case "bold": return 700;
	}
	return parseInt(value);
}
function parseCssOpacity$1(value) {
	if (value.endsWith("%")) return parseFloat(value.substring(0, value.length - 1)) / 100;
	if (value.match(/^\d+(?:\.\d*)/)) return parseFloat(value);
	return 1;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/gpu/renderStrategy/fullFileRenderStrategy.js
/**
* A render strategy that tracks a large buffer, uploading only dirty lines as they change and
* leveraging heavy caching. This is the most performant strategy but has limitations around long
* lines and too many lines.
*/
var FullFileRenderStrategy = class FullFileRenderStrategy extends BaseRenderStrategy {
	/**
	* The hard cap for line count that can be rendered by the GPU renderer.
	*/
	static {
		this.maxSupportedLines = 3e3;
	}
	/**
	* The hard cap for line columns that can be rendered by the GPU renderer.
	*/
	static {
		this.maxSupportedColumns = 200;
	}
	get bindGroupEntries() {
		return [{
			binding: 1,
			resource: { buffer: this._cellBindBuffer }
		}, {
			binding: 6,
			resource: { buffer: this._scrollOffsetBindBuffer }
		}];
	}
	constructor(context, viewGpuContext, device, glyphRasterizer) {
		super(context, viewGpuContext, device, glyphRasterizer);
		this.type = "fullfile";
		this.wgsl = fullFileRenderStrategyWgsl;
		this._activeDoubleBufferIndex = 0;
		this._upToDateLines = [/* @__PURE__ */ new Set(), /* @__PURE__ */ new Set()];
		this._visibleObjectCount = 0;
		this._finalRenderedLine = 0;
		this._scrollInitialized = false;
		this._queuedBufferUpdates = [[], []];
		const bufferSize = FullFileRenderStrategy.maxSupportedLines * FullFileRenderStrategy.maxSupportedColumns * 6 * Float32Array.BYTES_PER_ELEMENT;
		this._cellBindBuffer = this._register(GPULifecycle.createBuffer(this._device, {
			label: "Monaco full file cell buffer",
			size: bufferSize,
			usage: GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST
		})).object;
		this._cellValueBuffers = [new ArrayBuffer(bufferSize), new ArrayBuffer(bufferSize)];
		const scrollOffsetBufferSize = 2;
		this._scrollOffsetBindBuffer = this._register(GPULifecycle.createBuffer(this._device, {
			label: "Monaco scroll offset buffer",
			size: scrollOffsetBufferSize * Float32Array.BYTES_PER_ELEMENT,
			usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST
		})).object;
		this._scrollOffsetValueBuffer = new Float32Array(scrollOffsetBufferSize);
	}
	onConfigurationChanged(e) {
		this._invalidateAllLines();
		this._queueBufferUpdate(e);
		return true;
	}
	onDecorationsChanged(e) {
		this._invalidateAllLines();
		return true;
	}
	onTokensChanged(e) {
		for (const range of e.ranges) this._invalidateLineRange(range.fromLineNumber, range.toLineNumber);
		return true;
	}
	onLinesDeleted(e) {
		this._invalidateLinesFrom(e.fromLineNumber);
		this._queueBufferUpdate(e);
		return true;
	}
	onLinesInserted(e) {
		this._invalidateLinesFrom(e.fromLineNumber);
		return true;
	}
	onLinesChanged(e) {
		this._invalidateLineRange(e.fromLineNumber, e.fromLineNumber + e.count);
		return true;
	}
	onScrollChanged(e) {
		if (this._store.isDisposed) return false;
		const dpr = getActiveWindow().devicePixelRatio;
		this._scrollOffsetValueBuffer[0] = (e?.scrollLeft ?? this._context.viewLayout.getCurrentScrollLeft()) * dpr;
		this._scrollOffsetValueBuffer[1] = (e?.scrollTop ?? this._context.viewLayout.getCurrentScrollTop()) * dpr;
		this._device.queue.writeBuffer(this._scrollOffsetBindBuffer, 0, this._scrollOffsetValueBuffer);
		return true;
	}
	onThemeChanged(e) {
		this._invalidateAllLines();
		return true;
	}
	onLineMappingChanged(e) {
		this._invalidateAllLines();
		this._queueBufferUpdate(e);
		return true;
	}
	onZonesChanged(e) {
		this._invalidateAllLines();
		this._queueBufferUpdate(e);
		return true;
	}
	_invalidateAllLines() {
		this._upToDateLines[0].clear();
		this._upToDateLines[1].clear();
	}
	_invalidateLinesFrom(lineNumber) {
		for (const i of [0, 1]) {
			const upToDateLines = this._upToDateLines[i];
			for (const upToDateLine of upToDateLines) if (upToDateLine >= lineNumber) upToDateLines.delete(upToDateLine);
		}
	}
	_invalidateLineRange(fromLineNumber, toLineNumber) {
		for (let i = fromLineNumber; i <= toLineNumber; i++) {
			this._upToDateLines[0].delete(i);
			this._upToDateLines[1].delete(i);
		}
	}
	reset() {
		this._invalidateAllLines();
		for (const bufferIndex of [0, 1]) {
			const buffer = new Float32Array(this._cellValueBuffers[bufferIndex]);
			buffer.fill(0, 0, buffer.length);
			this._device.queue.writeBuffer(this._cellBindBuffer, 0, buffer.buffer, 0, buffer.byteLength);
		}
		this._finalRenderedLine = 0;
	}
	update(viewportData, viewLineOptions) {
		let chars = "";
		let segment;
		let charWidth = 0;
		let y = 0;
		let x = 0;
		let absoluteOffsetX = 0;
		let absoluteOffsetY = 0;
		let tabXOffset = 0;
		let glyph;
		let cellIndex = 0;
		let tokenStartIndex = 0;
		let tokenEndIndex = 0;
		let tokenMetadata = 0;
		let decorationStyleSetBold;
		let decorationStyleSetColor;
		let decorationStyleSetOpacity;
		let decorationStyleSetStrikethrough;
		let decorationStyleSetStrikethroughThickness;
		let decorationStyleSetStrikethroughColor;
		let lineData;
		let decoration;
		let fillStartIndex = 0;
		let fillEndIndex = 0;
		let tokens;
		const dpr = getActiveWindow().devicePixelRatio;
		let contentSegmenter;
		if (!this._scrollInitialized) {
			this.onScrollChanged();
			this._scrollInitialized = true;
		}
		const cellBuffer = new Float32Array(this._cellValueBuffers[this._activeDoubleBufferIndex]);
		const lineIndexCount = FullFileRenderStrategy.maxSupportedColumns * 6;
		const upToDateLines = this._upToDateLines[this._activeDoubleBufferIndex];
		let dirtyLineStart = 3e3;
		let dirtyLineEnd = 0;
		const queuedBufferUpdates = this._queuedBufferUpdates[this._activeDoubleBufferIndex];
		while (queuedBufferUpdates.length) {
			const e = queuedBufferUpdates.shift();
			switch (e.type) {
				case 2:
				case 8:
				case 17:
					cellBuffer.fill(0);
					dirtyLineStart = 1;
					dirtyLineEnd = Math.max(dirtyLineEnd, this._finalRenderedLine);
					this._finalRenderedLine = 0;
					break;
				case 10: {
					const deletedLineContentStartIndex = (e.fromLineNumber - 1) * FullFileRenderStrategy.maxSupportedColumns * 6;
					const deletedLineContentEndIndex = e.toLineNumber * FullFileRenderStrategy.maxSupportedColumns * 6;
					const nullContentStartIndex = (this._finalRenderedLine - (e.toLineNumber - e.fromLineNumber + 1)) * FullFileRenderStrategy.maxSupportedColumns * 6;
					cellBuffer.set(cellBuffer.subarray(deletedLineContentEndIndex), deletedLineContentStartIndex);
					cellBuffer.fill(0, nullContentStartIndex);
					dirtyLineStart = Math.min(dirtyLineStart, e.fromLineNumber);
					dirtyLineEnd = Math.max(dirtyLineEnd, this._finalRenderedLine);
					this._finalRenderedLine -= e.toLineNumber - e.fromLineNumber + 1;
					break;
				}
			}
		}
		for (y = viewportData.startLineNumber; y <= viewportData.endLineNumber; y++) {
			if (!this._viewGpuContext.canRender(viewLineOptions, viewportData, y)) {
				fillStartIndex = (y - 1) * FullFileRenderStrategy.maxSupportedColumns * 6;
				fillEndIndex = y * FullFileRenderStrategy.maxSupportedColumns * 6;
				cellBuffer.fill(0, fillStartIndex, fillEndIndex);
				dirtyLineStart = Math.min(dirtyLineStart, y);
				dirtyLineEnd = Math.max(dirtyLineEnd, y);
				continue;
			}
			if (upToDateLines.has(y)) continue;
			dirtyLineStart = Math.min(dirtyLineStart, y);
			dirtyLineEnd = Math.max(dirtyLineEnd, y);
			lineData = viewportData.getViewLineRenderingData(y);
			tabXOffset = 0;
			contentSegmenter = createContentSegmenter(lineData, viewLineOptions);
			charWidth = viewLineOptions.spaceWidth * dpr;
			absoluteOffsetX = (lineData.minColumn - 1) * charWidth;
			tokens = lineData.tokens;
			tokenStartIndex = lineData.minColumn - 1;
			tokenEndIndex = 0;
			for (let tokenIndex = 0, tokensLen = tokens.getCount(); tokenIndex < tokensLen; tokenIndex++) {
				tokenEndIndex = tokens.getEndOffset(tokenIndex);
				if (tokenEndIndex <= tokenStartIndex) continue;
				tokenMetadata = tokens.getMetadata(tokenIndex);
				for (x = tokenStartIndex; x < tokenEndIndex; x++) {
					if (x > FullFileRenderStrategy.maxSupportedColumns) break;
					segment = contentSegmenter.getSegmentAtIndex(x);
					if (segment === void 0) continue;
					chars = segment;
					if (!(lineData.isBasicASCII && viewLineOptions.useMonospaceOptimizations)) charWidth = this.glyphRasterizer.getTextMetrics(chars).width;
					decorationStyleSetColor = void 0;
					decorationStyleSetBold = void 0;
					decorationStyleSetOpacity = void 0;
					decorationStyleSetStrikethrough = void 0;
					decorationStyleSetStrikethroughThickness = void 0;
					decorationStyleSetStrikethroughColor = void 0;
					for (decoration of lineData.inlineDecorations) {
						if (y < decoration.range.startLineNumber || y > decoration.range.endLineNumber || y === decoration.range.startLineNumber && x < decoration.range.startColumn - 1 || y === decoration.range.endLineNumber && x >= decoration.range.endColumn - 1) continue;
						const rules = ViewGpuContext.decorationCssRuleExtractor.getStyleRules(this._viewGpuContext.canvas.domNode, decoration.inlineClassName);
						for (const rule of rules) for (const r of rule.style) {
							const value = rule.styleMap.get(r)?.toString() ?? "";
							switch (r) {
								case "color": {
									const parsedColor = Color.Format.CSS.parse(value);
									if (!parsedColor) throw new BugIndicatingError("Invalid color format " + value);
									decorationStyleSetColor = parsedColor.toNumber32Bit();
									break;
								}
								case "font-weight":
									if (parseCssFontWeight(value) >= 400) decorationStyleSetBold = true;
									else decorationStyleSetBold = false;
									break;
								case "opacity":
									decorationStyleSetOpacity = parseCssOpacity(value);
									break;
								case "text-decoration":
								case "text-decoration-line":
									if (value === "line-through") decorationStyleSetStrikethrough = true;
									break;
								case "text-decoration-thickness": {
									const match = value.match(/^(\d+(?:\.\d+)?)px$/);
									if (match) decorationStyleSetStrikethroughThickness = parseFloat(match[1]);
									break;
								}
								case "text-decoration-color": {
									let colorValue = value;
									const varMatch = value.match(/^var\((--[^,]+),\s*(?:initial|inherit)\)$/);
									if (varMatch) colorValue = ViewGpuContext.decorationCssRuleExtractor.resolveCssVariable(this._viewGpuContext.canvas.domNode, varMatch[1]);
									const parsedColor = Color.Format.CSS.parse(colorValue);
									if (parsedColor) decorationStyleSetStrikethroughColor = parsedColor.toNumber32Bit();
									break;
								}
								case "text-decoration-style": break;
								default: throw new BugIndicatingError("Unexpected inline decoration style");
							}
						}
					}
					if (chars === " " || chars === "	") {
						cellIndex = ((y - 1) * FullFileRenderStrategy.maxSupportedColumns + x) * 6;
						cellBuffer.fill(0, cellIndex, cellIndex + 6);
						if (chars === "	") {
							const offsetBefore = x + tabXOffset;
							tabXOffset = CursorColumns.nextRenderTabStop(x + tabXOffset, lineData.tabSize);
							absoluteOffsetX += charWidth * (tabXOffset - offsetBefore);
							tabXOffset -= x + 1;
						} else absoluteOffsetX += charWidth;
						continue;
					}
					const decorationStyleSetId = ViewGpuContext.decorationStyleCache.getOrCreateEntry(decorationStyleSetColor, decorationStyleSetBold, decorationStyleSetOpacity, decorationStyleSetStrikethrough, decorationStyleSetStrikethroughThickness, decorationStyleSetStrikethroughColor);
					glyph = this._viewGpuContext.atlas.getGlyph(this.glyphRasterizer, chars, tokenMetadata, decorationStyleSetId, absoluteOffsetX);
					absoluteOffsetY = Math.round(viewportData.relativeVerticalOffset[y - viewportData.startLineNumber] * dpr + Math.floor((viewportData.lineHeight * dpr - (glyph.fontBoundingBoxAscent + glyph.fontBoundingBoxDescent)) / 2) + glyph.fontBoundingBoxAscent);
					cellIndex = ((y - 1) * FullFileRenderStrategy.maxSupportedColumns + x) * 6;
					cellBuffer[cellIndex + 0] = Math.floor(absoluteOffsetX);
					cellBuffer[cellIndex + 1] = absoluteOffsetY;
					cellBuffer[cellIndex + 4] = glyph.glyphIndex;
					cellBuffer[cellIndex + 5] = glyph.pageIndex;
					absoluteOffsetX += charWidth;
				}
				tokenStartIndex = tokenEndIndex;
			}
			fillStartIndex = ((y - 1) * FullFileRenderStrategy.maxSupportedColumns + tokenEndIndex) * 6;
			fillEndIndex = y * FullFileRenderStrategy.maxSupportedColumns * 6;
			cellBuffer.fill(0, fillStartIndex, fillEndIndex);
			upToDateLines.add(y);
		}
		const visibleObjectCount = (viewportData.endLineNumber - viewportData.startLineNumber + 1) * lineIndexCount;
		dirtyLineStart = Math.min(dirtyLineStart, FullFileRenderStrategy.maxSupportedLines);
		dirtyLineEnd = Math.min(dirtyLineEnd, FullFileRenderStrategy.maxSupportedLines);
		if (dirtyLineStart <= dirtyLineEnd) this._device.queue.writeBuffer(this._cellBindBuffer, (dirtyLineStart - 1) * lineIndexCount * Float32Array.BYTES_PER_ELEMENT, cellBuffer.buffer, (dirtyLineStart - 1) * lineIndexCount * Float32Array.BYTES_PER_ELEMENT, (dirtyLineEnd - dirtyLineStart + 1) * lineIndexCount * Float32Array.BYTES_PER_ELEMENT);
		this._finalRenderedLine = Math.max(this._finalRenderedLine, dirtyLineEnd);
		this._activeDoubleBufferIndex = this._activeDoubleBufferIndex ? 0 : 1;
		this._visibleObjectCount = visibleObjectCount;
		return visibleObjectCount;
	}
	draw(pass, viewportData) {
		if (this._visibleObjectCount <= 0) throw new BugIndicatingError("Attempt to draw 0 objects");
		pass.draw(quadVertices.length / 2, this._visibleObjectCount, void 0, (viewportData.startLineNumber - 1) * FullFileRenderStrategy.maxSupportedColumns);
	}
	/**
	* Queue updates that need to happen on the active buffer, not just the cache. This will be
	* deferred to when the actual cell buffer is changed since the active buffer could be locked by
	* the GPU which would block the main thread.
	*/
	_queueBufferUpdate(e) {
		this._queuedBufferUpdates[0].push(e);
		this._queuedBufferUpdates[1].push(e);
	}
};
function parseCssFontWeight(value) {
	switch (value) {
		case "lighter":
		case "normal": return 400;
		case "bolder":
		case "bold": return 700;
	}
	return parseInt(value);
}
function parseCssOpacity(value) {
	if (value.endsWith("%")) return parseFloat(value.substring(0, value.length - 1)) / 100;
	if (value.match(/^\d+(?:\.\d*)/)) return parseFloat(value);
	return 1;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/viewLinesGpu/viewLinesGpu.js
var __decorate$67 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$62 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
/**
* The GPU implementation of the ViewLines part.
*/
var ViewLinesGpu = class ViewLinesGpu extends ViewPart {
	constructor(context, _viewGpuContext, _instantiationService, _logService) {
		super(context);
		this._viewGpuContext = _viewGpuContext;
		this._instantiationService = _instantiationService;
		this._logService = _logService;
		/**
		* Tracks the maximum line width seen so far for horizontal scrollbar sizing.
		* This is needed because GPU-rendered lines don't have DOM nodes to measure.
		*/
		this._maxLineWidth = 0;
		this._atlasGpuTextureVersions = [];
		this._initialized = false;
		this._glyphRasterizer = this._register(new MutableDisposable());
		this._renderStrategy = this._register(new MutableDisposable());
		this.canvas = this._viewGpuContext.canvas.domNode;
		this._register(autorun((reader) => {
			this._viewGpuContext.canvasDevicePixelDimensions.read(reader);
			const lastViewportData = this._lastViewportData;
			if (lastViewportData) setTimeout(() => {
				if (lastViewportData === this._lastViewportData) this.renderText(lastViewportData);
			});
		}));
		this.initWebgpu();
	}
	async initWebgpu() {
		this._device = ViewGpuContext.deviceSync || await ViewGpuContext.device;
		if (this._store.isDisposed) return;
		const atlas = ViewGpuContext.atlas;
		this._register(atlas.onDidDeleteGlyphs(() => {
			this._atlasGpuTextureVersions.length = 0;
			this._atlasGpuTextureVersions[0] = 0;
			this._atlasGpuTextureVersions[1] = 0;
			this._renderStrategy.value.reset();
		}));
		const presentationFormat = navigator.gpu.getPreferredCanvasFormat();
		this._viewGpuContext.ctx.configure({
			device: this._device,
			format: presentationFormat,
			alphaMode: "premultiplied"
		});
		this._renderPassColorAttachment = {
			view: null,
			loadOp: "load",
			storeOp: "store"
		};
		this._renderPassDescriptor = {
			label: "Monaco render pass",
			colorAttachments: [this._renderPassColorAttachment]
		};
		let layoutInfoUniformBuffer;
		{
			const bufferValues = /* @__PURE__ */ new Float32Array(6);
			const updateBufferValues = (canvasDevicePixelWidth = this.canvas.width, canvasDevicePixelHeight = this.canvas.height) => {
				bufferValues[0] = canvasDevicePixelWidth;
				bufferValues[1] = canvasDevicePixelHeight;
				bufferValues[2] = Math.ceil(this._context.configuration.options.get(166).contentLeft * getActiveWindow().devicePixelRatio);
				bufferValues[3] = 0;
				bufferValues[4] = bufferValues[0] - bufferValues[2];
				bufferValues[5] = bufferValues[1] - bufferValues[3];
				return bufferValues;
			};
			layoutInfoUniformBuffer = this._register(GPULifecycle.createBuffer(this._device, {
				label: "Monaco uniform buffer",
				size: 24,
				usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST
			}, () => updateBufferValues())).object;
			this._register(runOnChange(this._viewGpuContext.canvasDevicePixelDimensions, ({ width, height }) => {
				this._device.queue.writeBuffer(layoutInfoUniformBuffer, 0, updateBufferValues(width, height));
			}));
			this._register(runOnChange(this._viewGpuContext.contentLeft, () => {
				this._device.queue.writeBuffer(layoutInfoUniformBuffer, 0, updateBufferValues());
			}));
		}
		let atlasInfoUniformBuffer;
		atlasInfoUniformBuffer = this._register(GPULifecycle.createBuffer(this._device, {
			label: "Monaco atlas info uniform buffer",
			size: 8,
			usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST
		}, () => {
			const values = /* @__PURE__ */ new Float32Array(2);
			values[0] = atlas.pageSize;
			values[1] = atlas.pageSize;
			return values;
		})).object;
		const fontFamily = this._context.configuration.options.get(58);
		const fontSize = this._context.configuration.options.get(61);
		this._glyphRasterizer.value = this._register(new GlyphRasterizer(fontSize, fontFamily, this._viewGpuContext.devicePixelRatio.get(), ViewGpuContext.decorationStyleCache));
		this._register(runOnChange(this._viewGpuContext.devicePixelRatio, () => {
			this._refreshGlyphRasterizer();
		}));
		this._renderStrategy.value = this._instantiationService.createInstance(FullFileRenderStrategy, this._context, this._viewGpuContext, this._device, this._glyphRasterizer);
		this._glyphStorageBuffer = this._register(GPULifecycle.createBuffer(this._device, {
			label: "Monaco glyph storage buffer",
			size: TextureAtlas.maximumPageCount * (TextureAtlasPage.maximumGlyphCount * 24),
			usage: GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST
		})).object;
		this._atlasGpuTextureVersions[0] = 0;
		this._atlasGpuTextureVersions[1] = 0;
		this._atlasGpuTexture = this._register(GPULifecycle.createTexture(this._device, {
			label: "Monaco atlas texture",
			format: "rgba8unorm",
			size: {
				width: atlas.pageSize,
				height: atlas.pageSize,
				depthOrArrayLayers: TextureAtlas.maximumPageCount
			},
			dimension: "2d",
			usage: GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.RENDER_ATTACHMENT
		})).object;
		this._updateAtlasStorageBufferAndTexture();
		this._vertexBuffer = this._register(GPULifecycle.createBuffer(this._device, {
			label: "Monaco vertex buffer",
			size: quadVertices.byteLength,
			usage: GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST
		}, quadVertices)).object;
		const module = this._device.createShaderModule({
			label: "Monaco shader module",
			code: this._renderStrategy.value.wgsl
		});
		this._pipeline = this._device.createRenderPipeline({
			label: "Monaco render pipeline",
			layout: "auto",
			vertex: {
				module,
				buffers: [{
					arrayStride: 2 * Float32Array.BYTES_PER_ELEMENT,
					attributes: [{
						shaderLocation: 0,
						offset: 0,
						format: "float32x2"
					}]
				}]
			},
			fragment: {
				module,
				targets: [{
					format: presentationFormat,
					blend: {
						color: {
							srcFactor: "src-alpha",
							dstFactor: "one-minus-src-alpha"
						},
						alpha: {
							srcFactor: "src-alpha",
							dstFactor: "one-minus-src-alpha"
						}
					}
				}]
			}
		});
		this._rebuildBindGroup = () => {
			this._bindGroup = this._device.createBindGroup({
				label: "Monaco bind group",
				layout: this._pipeline.getBindGroupLayout(0),
				entries: [
					{
						binding: 0,
						resource: { buffer: this._glyphStorageBuffer }
					},
					{
						binding: 2,
						resource: this._device.createSampler({
							label: "Monaco atlas sampler",
							magFilter: "nearest",
							minFilter: "nearest"
						})
					},
					{
						binding: 3,
						resource: this._atlasGpuTexture.createView()
					},
					{
						binding: 4,
						resource: { buffer: layoutInfoUniformBuffer }
					},
					{
						binding: 5,
						resource: { buffer: atlasInfoUniformBuffer }
					},
					...this._renderStrategy.value.bindGroupEntries
				]
			});
		};
		this._rebuildBindGroup();
		this._initialized = true;
		if (this._initViewportData) {
			for (const viewportData of this._initViewportData) this.renderText(viewportData);
			this._initViewportData = void 0;
		}
	}
	_refreshRenderStrategy(viewportData) {
		if (this._renderStrategy.value?.type === "viewport") return;
		if (viewportData.endLineNumber < FullFileRenderStrategy.maxSupportedLines && this._viewportMaxColumn(viewportData) < FullFileRenderStrategy.maxSupportedColumns) return;
		this._logService.trace(`File is larger than ${FullFileRenderStrategy.maxSupportedLines} lines or ${FullFileRenderStrategy.maxSupportedColumns} columns, switching to viewport render strategy`);
		const viewportRenderStrategy = this._instantiationService.createInstance(ViewportRenderStrategy, this._context, this._viewGpuContext, this._device, this._glyphRasterizer);
		this._renderStrategy.value = viewportRenderStrategy;
		this._register(viewportRenderStrategy.onDidChangeBindGroupEntries(() => this._rebuildBindGroup?.()));
		this._rebuildBindGroup?.();
	}
	_viewportMaxColumn(viewportData) {
		let maxColumn = 0;
		let lineData;
		for (let i = viewportData.startLineNumber; i <= viewportData.endLineNumber; i++) {
			lineData = viewportData.getViewLineRenderingData(i);
			maxColumn = Math.max(maxColumn, lineData.maxColumn);
		}
		return maxColumn;
	}
	_updateAtlasStorageBufferAndTexture() {
		for (const [layerIndex, page] of ViewGpuContext.atlas.pages.entries()) {
			if (layerIndex >= TextureAtlas.maximumPageCount) {
				console.log(`Attempt to upload atlas page [${layerIndex}], only ${TextureAtlas.maximumPageCount} are supported currently`);
				continue;
			}
			if (page.version === this._atlasGpuTextureVersions[layerIndex]) continue;
			this._logService.trace("Updating atlas page[", layerIndex, "] from version ", this._atlasGpuTextureVersions[layerIndex], " to version ", page.version);
			const entryCount = 6 * TextureAtlasPage.maximumGlyphCount;
			const values = new Float32Array(entryCount);
			let entryOffset = 0;
			for (const glyph of page.glyphs) {
				values[entryOffset + 0] = glyph.x;
				values[entryOffset + 0 + 1] = glyph.y;
				values[entryOffset + 2] = glyph.w;
				values[entryOffset + 2 + 1] = glyph.h;
				values[entryOffset + 4] = glyph.originOffsetX;
				values[entryOffset + 4 + 1] = glyph.originOffsetY;
				entryOffset += 6;
			}
			if (entryOffset / 6 > TextureAtlasPage.maximumGlyphCount) throw new Error(`Attempting to write more glyphs (${entryOffset / 6}) than the GPUBuffer can hold (${TextureAtlasPage.maximumGlyphCount})`);
			this._device.queue.writeBuffer(this._glyphStorageBuffer, layerIndex * 6 * TextureAtlasPage.maximumGlyphCount * Float32Array.BYTES_PER_ELEMENT, values, 0, 6 * TextureAtlasPage.maximumGlyphCount);
			if (page.usedArea.right - page.usedArea.left > 0 && page.usedArea.bottom - page.usedArea.top > 0) this._device.queue.copyExternalImageToTexture({ source: page.source }, {
				texture: this._atlasGpuTexture,
				origin: {
					x: page.usedArea.left,
					y: page.usedArea.top,
					z: layerIndex
				}
			}, {
				width: page.usedArea.right - page.usedArea.left + 1,
				height: page.usedArea.bottom - page.usedArea.top + 1
			});
			this._atlasGpuTextureVersions[layerIndex] = page.version;
		}
	}
	prepareRender(ctx) {
		throw new BugIndicatingError("Should not be called");
	}
	render(ctx) {
		throw new BugIndicatingError("Should not be called");
	}
	onConfigurationChanged(e) {
		this._refreshGlyphRasterizer();
		this._maxLineWidth = 0;
		return true;
	}
	onCursorStateChanged(e) {
		return true;
	}
	onDecorationsChanged(e) {
		return true;
	}
	onFlushed(e) {
		this._maxLineWidth = 0;
		return true;
	}
	onLinesChanged(e) {
		return true;
	}
	onLinesDeleted(e) {
		this._maxLineWidth = 0;
		return true;
	}
	onLinesInserted(e) {
		return true;
	}
	onLineMappingChanged(e) {
		return true;
	}
	onRevealRangeRequest(e) {
		return true;
	}
	onScrollChanged(e) {
		return true;
	}
	onThemeChanged(e) {
		return true;
	}
	onZonesChanged(e) {
		return true;
	}
	_refreshGlyphRasterizer() {
		const glyphRasterizer = this._glyphRasterizer.value;
		if (!glyphRasterizer) return;
		const fontFamily = this._context.configuration.options.get(58);
		const fontSize = this._context.configuration.options.get(61);
		const devicePixelRatio = this._viewGpuContext.devicePixelRatio.get();
		if (glyphRasterizer.fontFamily !== fontFamily || glyphRasterizer.fontSize !== fontSize || glyphRasterizer.devicePixelRatio !== devicePixelRatio) this._glyphRasterizer.value = new GlyphRasterizer(fontSize, fontFamily, devicePixelRatio, ViewGpuContext.decorationStyleCache);
	}
	renderText(viewportData) {
		if (this._initialized) {
			this._refreshRenderStrategy(viewportData);
			return this._renderText(viewportData);
		} else {
			this._initViewportData = this._initViewportData ?? [];
			this._initViewportData.push(viewportData);
		}
	}
	_renderText(viewportData) {
		this._viewGpuContext.rectangleRenderer.draw(viewportData);
		const options = new ViewLineOptions(this._context.configuration, this._context.theme.type);
		this._renderStrategy.value.update(viewportData, options);
		this._updateAtlasStorageBufferAndTexture();
		const encoder = this._device.createCommandEncoder({ label: "Monaco command encoder" });
		this._renderPassColorAttachment.view = this._viewGpuContext.ctx.getCurrentTexture().createView({ label: "Monaco canvas texture view" });
		const pass = encoder.beginRenderPass(this._renderPassDescriptor);
		pass.setPipeline(this._pipeline);
		pass.setVertexBuffer(0, this._vertexBuffer);
		const contentLeft = Math.ceil(this._viewGpuContext.contentLeft.get() * this._viewGpuContext.devicePixelRatio.get());
		pass.setScissorRect(contentLeft, 0, this.canvas.width - contentLeft, this.canvas.height);
		pass.setBindGroup(0, this._bindGroup);
		this._renderStrategy.value.draw(pass, viewportData);
		pass.end();
		const commandBuffer = encoder.finish();
		this._device.queue.submit([commandBuffer]);
		this._lastViewportData = viewportData;
		this._lastViewLineOptions = options;
		this._updateMaxLineWidth(viewportData, options);
	}
	/**
	* Update the max line width based on GPU-rendered lines.
	* This is needed because GPU-rendered lines don't have DOM nodes to measure.
	*/
	_updateMaxLineWidth(viewportData, viewLineOptions) {
		const dpr = getActiveWindow().devicePixelRatio;
		let localMaxLineWidth = 0;
		for (let lineNumber = viewportData.startLineNumber; lineNumber <= viewportData.endLineNumber; lineNumber++) {
			if (!this._viewGpuContext.canRender(viewLineOptions, viewportData, lineNumber)) continue;
			const lineData = viewportData.getViewLineRenderingData(lineNumber);
			const lineWidth = this._computeLineWidth(lineData, viewLineOptions, dpr);
			localMaxLineWidth = Math.max(localMaxLineWidth, lineWidth);
		}
		const iLineWidth = Math.ceil(localMaxLineWidth);
		if (iLineWidth > this._maxLineWidth) {
			this._maxLineWidth = iLineWidth;
			this._context.viewModel.viewLayout.setMaxLineWidth(this._maxLineWidth);
		}
	}
	/**
	* Compute the width of a line in CSS pixels.
	*/
	_computeLineWidth(lineData, viewLineOptions, dpr) {
		const content = lineData.content;
		let contentSegmenter;
		if (!(lineData.isBasicASCII && viewLineOptions.useMonospaceOptimizations)) contentSegmenter = createContentSegmenter(lineData, viewLineOptions);
		let width = 0;
		let tabXOffset = 0;
		for (let x = 0; x < content.length; x++) {
			let chars;
			if (lineData.isBasicASCII && viewLineOptions.useMonospaceOptimizations) chars = content.charAt(x);
			else {
				const segment = contentSegmenter.getSegmentAtIndex(x);
				if (segment === void 0) continue;
				chars = segment;
			}
			if (chars === "	") {
				const offsetBefore = x + tabXOffset;
				tabXOffset = CursorColumns.nextRenderTabStop(x + tabXOffset, lineData.tabSize);
				width += viewLineOptions.spaceWidth * (tabXOffset - offsetBefore);
				tabXOffset -= x + 1;
			} else if (lineData.isBasicASCII && viewLineOptions.useMonospaceOptimizations) width += viewLineOptions.spaceWidth;
			else width += this._renderStrategy.value.glyphRasterizer.getTextMetrics(chars).width / dpr;
		}
		return width;
	}
	linesVisibleRangesForRange(_range, includeNewLines) {
		if (!this._lastViewportData) return null;
		const originalEndLineNumber = _range.endLineNumber;
		const range = Range$2.intersectRanges(_range, this._lastViewportData.visibleRange);
		if (!range) return null;
		const rendStartLineNumber = this._lastViewportData.startLineNumber;
		const rendEndLineNumber = this._lastViewportData.endLineNumber;
		const viewportData = this._lastViewportData;
		const viewLineOptions = this._lastViewLineOptions;
		if (!viewportData || !viewLineOptions) return null;
		const visibleRanges = [];
		let nextLineModelLineNumber = 0;
		if (includeNewLines) nextLineModelLineNumber = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new Position$1(range.startLineNumber, 1)).lineNumber;
		for (let lineNumber = range.startLineNumber; lineNumber <= range.endLineNumber; lineNumber++) {
			if (lineNumber < rendStartLineNumber || lineNumber > rendEndLineNumber) continue;
			const startColumn = lineNumber === range.startLineNumber ? range.startColumn : 1;
			const continuesInNextLine = lineNumber !== originalEndLineNumber;
			const endColumn = continuesInNextLine ? this._context.viewModel.getLineMaxColumn(lineNumber) : range.endColumn;
			const visibleRangesForLine = this._visibleRangesForLineRange(lineNumber, startColumn, endColumn);
			if (!visibleRangesForLine) continue;
			if (includeNewLines && lineNumber < originalEndLineNumber) {
				const currentLineModelLineNumber = nextLineModelLineNumber;
				nextLineModelLineNumber = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new Position$1(lineNumber + 1, 1)).lineNumber;
				if (currentLineModelLineNumber !== nextLineModelLineNumber) visibleRangesForLine.ranges[visibleRangesForLine.ranges.length - 1].width += viewLineOptions.spaceWidth;
			}
			visibleRanges.push(new LineVisibleRanges(visibleRangesForLine.outsideRenderedLine, lineNumber, HorizontalRange.from(visibleRangesForLine.ranges), continuesInNextLine));
		}
		if (visibleRanges.length === 0) return null;
		return visibleRanges;
	}
	_visibleRangesForLineRange(lineNumber, startColumn, endColumn) {
		if (this.shouldRender()) return null;
		const viewportData = this._lastViewportData;
		const viewLineOptions = this._lastViewLineOptions;
		if (!viewportData || !viewLineOptions || lineNumber < viewportData.startLineNumber || lineNumber > viewportData.endLineNumber) return null;
		const lineData = viewportData.getViewLineRenderingData(lineNumber);
		const content = lineData.content;
		let contentSegmenter;
		if (!(lineData.isBasicASCII && viewLineOptions.useMonospaceOptimizations)) contentSegmenter = createContentSegmenter(lineData, viewLineOptions);
		let chars = "";
		let resolvedStartColumn = 0;
		let resolvedStartCssPixelOffset = 0;
		for (let x = 0; x < startColumn - 1; x++) {
			if (lineData.isBasicASCII && viewLineOptions.useMonospaceOptimizations) chars = content.charAt(x);
			else {
				chars = contentSegmenter.getSegmentAtIndex(x);
				if (chars === void 0) continue;
				resolvedStartCssPixelOffset += this._renderStrategy.value.glyphRasterizer.getTextMetrics(chars).width / getActiveWindow().devicePixelRatio - viewLineOptions.spaceWidth;
			}
			if (chars === "	") resolvedStartColumn = CursorColumns.nextRenderTabStop(resolvedStartColumn, lineData.tabSize);
			else resolvedStartColumn++;
		}
		let resolvedEndColumn = resolvedStartColumn;
		let resolvedEndCssPixelOffset = 0;
		for (let x = startColumn - 1; x < endColumn - 1; x++) {
			if (lineData.isBasicASCII && viewLineOptions.useMonospaceOptimizations) chars = content.charAt(x);
			else {
				chars = contentSegmenter.getSegmentAtIndex(x);
				if (chars === void 0) continue;
				resolvedEndCssPixelOffset += this._renderStrategy.value.glyphRasterizer.getTextMetrics(chars).width / getActiveWindow().devicePixelRatio - viewLineOptions.spaceWidth;
			}
			if (chars === "	") resolvedEndColumn = CursorColumns.nextRenderTabStop(resolvedEndColumn, lineData.tabSize);
			else resolvedEndColumn++;
		}
		return new VisibleRanges(false, [new FloatHorizontalRange(resolvedStartColumn * viewLineOptions.spaceWidth + resolvedStartCssPixelOffset, (resolvedEndColumn - resolvedStartColumn) * viewLineOptions.spaceWidth + resolvedEndCssPixelOffset)]);
	}
	visibleRangeForPosition(position) {
		const visibleRanges = this._visibleRangesForLineRange(position.lineNumber, position.column, position.column);
		if (!visibleRanges) return null;
		return new HorizontalPosition(visibleRanges.outsideRenderedLine, visibleRanges.ranges[0].left);
	}
	getLineWidth(lineNumber) {
		if (!this._lastViewportData || !this._lastViewLineOptions) return;
		if (!this._viewGpuContext.canRender(this._lastViewLineOptions, this._lastViewportData, lineNumber)) return;
		const lineData = this._lastViewportData.getViewLineRenderingData(lineNumber);
		const lastRange = this._visibleRangesForLineRange(lineNumber, 1, lineData.maxColumn)?.ranges.at(-1);
		if (lastRange) return lastRange.left + lastRange.width;
	}
	getPositionAtCoordinate(lineNumber, mouseContentHorizontalOffset) {
		if (!this._lastViewportData || !this._lastViewLineOptions) return;
		if (!this._viewGpuContext.canRender(this._lastViewLineOptions, this._lastViewportData, lineNumber)) return;
		const lineData = this._lastViewportData.getViewLineRenderingData(lineNumber);
		const content = lineData.content;
		const dpr = getActiveWindow().devicePixelRatio;
		const mouseContentHorizontalOffsetDevicePixels = mouseContentHorizontalOffset * dpr;
		const spaceWidthDevicePixels = this._lastViewLineOptions.spaceWidth * dpr;
		const contentSegmenter = createContentSegmenter(lineData, this._lastViewLineOptions);
		let widthSoFar = 0;
		let charWidth = 0;
		let tabXOffset = 0;
		let column = 0;
		for (let x = 0; x < content.length; x++) {
			const chars = contentSegmenter.getSegmentAtIndex(x);
			if (chars === void 0) {
				column++;
				continue;
			}
			if (chars === "	") {
				const offsetBefore = x + tabXOffset;
				tabXOffset = CursorColumns.nextRenderTabStop(x + tabXOffset, lineData.tabSize);
				charWidth = spaceWidthDevicePixels * (tabXOffset - offsetBefore);
				tabXOffset -= x + 1;
			} else if (lineData.isBasicASCII && this._lastViewLineOptions.useMonospaceOptimizations) charWidth = spaceWidthDevicePixels;
			else charWidth = this._renderStrategy.value.glyphRasterizer.getTextMetrics(chars).width;
			if (mouseContentHorizontalOffsetDevicePixels < widthSoFar + charWidth / 2) break;
			widthSoFar += charWidth;
			column++;
		}
		return new Position$1(lineNumber, column + 1);
	}
};
ViewLinesGpu = __decorate$67([__param$62(2, IInstantiationService), __param$62(3, ILogService)], ViewLinesGpu);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/ime.js
var IMEImpl = class {
	constructor() {
		this._onDidChange = new Emitter$1();
		this.onDidChange = this._onDidChange.event;
		this._enabled = true;
	}
	get enabled() {
		return this._enabled;
	}
	/**
	* Enable IME
	*/
	enable() {
		this._enabled = true;
		this._onDidChange.fire();
	}
	/**
	* Disable IME
	*/
	disable() {
		this._enabled = false;
		this._onDidChange.fire();
	}
};
var IME = new IMEImpl();
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/keybinding/common/keybinding.js
var IKeybindingService = createDecorator("keybindingService");
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/controller/editContext/editContext.js
var AbstractEditContext = class extends ViewPart {
	constructor() {
		super(...arguments);
		this._onWillCopy = this._register(new Emitter$1());
		this.onWillCopy = this._onWillCopy.event;
		this._onWillCut = this._register(new Emitter$1());
		this.onWillCut = this._onWillCut.event;
		this._onWillPaste = this._register(new Emitter$1());
		this.onWillPaste = this._onWillPaste.event;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/controller/editContext/screenReaderUtils.js
var SimplePagedScreenReaderStrategy = class {
	_getPageOfLine(lineNumber, linesPerPage) {
		return Math.floor((lineNumber - 1) / linesPerPage);
	}
	_getRangeForPage(page, linesPerPage) {
		const offset = page * linesPerPage;
		const startLineNumber = offset + 1;
		const endLineNumber = offset + linesPerPage;
		return new Range$2(startLineNumber, 1, endLineNumber + 1, 1);
	}
	fromEditorSelection(model, selection, linesPerPage, trimLongText) {
		const LIMIT_CHARS = 500;
		const selectionStartPage = this._getPageOfLine(selection.startLineNumber, linesPerPage);
		const selectionStartPageRange = this._getRangeForPage(selectionStartPage, linesPerPage);
		const selectionEndPage = this._getPageOfLine(selection.endLineNumber, linesPerPage);
		const selectionEndPageRange = this._getRangeForPage(selectionEndPage, linesPerPage);
		let pretextRange = selectionStartPageRange.intersectRanges(new Range$2(1, 1, selection.startLineNumber, selection.startColumn));
		if (trimLongText && model.getValueLengthInRange(pretextRange, 1) > LIMIT_CHARS) {
			const pretextStart = model.modifyPosition(pretextRange.getEndPosition(), -500);
			pretextRange = Range$2.fromPositions(pretextStart, pretextRange.getEndPosition());
		}
		const pretext = model.getValueInRange(pretextRange, 1);
		const lastLine = model.getLineCount();
		const lastLineMaxColumn = model.getLineMaxColumn(lastLine);
		let posttextRange = selectionEndPageRange.intersectRanges(new Range$2(selection.endLineNumber, selection.endColumn, lastLine, lastLineMaxColumn));
		if (trimLongText && model.getValueLengthInRange(posttextRange, 1) > LIMIT_CHARS) {
			const posttextEnd = model.modifyPosition(posttextRange.getStartPosition(), LIMIT_CHARS);
			posttextRange = Range$2.fromPositions(posttextRange.getStartPosition(), posttextEnd);
		}
		const posttext = model.getValueInRange(posttextRange, 1);
		let text;
		if (selectionStartPage === selectionEndPage || selectionStartPage + 1 === selectionEndPage) text = model.getValueInRange(selection, 1);
		else {
			const selectionRange1 = selectionStartPageRange.intersectRanges(selection);
			const selectionRange2 = selectionEndPageRange.intersectRanges(selection);
			text = model.getValueInRange(selectionRange1, 1) + String.fromCharCode(8230) + model.getValueInRange(selectionRange2, 1);
		}
		if (trimLongText && text.length > 2 * LIMIT_CHARS) text = text.substring(0, LIMIT_CHARS) + String.fromCharCode(8230) + text.substring(text.length - LIMIT_CHARS, text.length);
		let selectionStart;
		let selectionEnd;
		if (selection.getDirection() === 0) {
			selectionStart = pretext.length;
			selectionEnd = pretext.length + text.length;
		} else {
			selectionEnd = pretext.length;
			selectionStart = pretext.length + text.length;
		}
		return {
			value: pretext + text + posttext,
			selection,
			selectionStart,
			selectionEnd,
			startPositionWithinEditor: pretextRange.getStartPosition(),
			newlineCountBeforeSelection: pretextRange.endLineNumber - pretextRange.startLineNumber
		};
	}
};
function ariaLabelForScreenReaderContent(options, keybindingService) {
	if (options.get(2) === 1) {
		const toggleKeybindingLabel = keybindingService.lookupKeybinding("editor.action.toggleScreenReaderAccessibilityMode")?.getAriaLabel();
		const runCommandKeybindingLabel = keybindingService.lookupKeybinding("workbench.action.showCommands")?.getAriaLabel();
		const keybindingEditorKeybindingLabel = keybindingService.lookupKeybinding("workbench.action.openGlobalKeybindings")?.getAriaLabel();
		const editorNotAccessibleMessage = localize(65, "The editor is not accessible at this time.");
		if (toggleKeybindingLabel) return localize(66, "{0} To enable screen reader optimized mode, use {1}", editorNotAccessibleMessage, toggleKeybindingLabel);
		else if (runCommandKeybindingLabel) return localize(67, "{0} To enable screen reader optimized mode, open the quick pick with {1} and run the command Toggle Screen Reader Accessibility Mode, which is currently not triggerable via keyboard.", editorNotAccessibleMessage, runCommandKeybindingLabel);
		else if (keybindingEditorKeybindingLabel) return localize(68, "{0} Please assign a keybinding for the command Toggle Screen Reader Accessibility Mode by accessing the keybindings editor with {1} and run it.", editorNotAccessibleMessage, keybindingEditorKeybindingLabel);
		else return editorNotAccessibleMessage;
	}
	return options.get(8);
}
function newlinecount(text) {
	let result = 0;
	let startIndex = -1;
	do {
		startIndex = text.indexOf("\n", startIndex + 1);
		if (startIndex === -1) break;
		result++;
	} while (true);
	return result;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/controller/editContext/textArea/textAreaEditContextRegistry.js
var TextAreaEditContextRegistryImpl = class {
	constructor() {
		this._textAreaEditContextMapping = /* @__PURE__ */ new Map();
	}
	register(ownerID, textAreaEditContext) {
		this._textAreaEditContextMapping.set(ownerID, textAreaEditContext);
		return { dispose: () => {
			this._textAreaEditContextMapping.delete(ownerID);
		} };
	}
};
var TextAreaEditContextRegistry = new TextAreaEditContextRegistryImpl();
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/controller/editContext/textArea/textAreaEditContext.js
var __decorate$66 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$61 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var VisibleTextAreaData = class {
	constructor(_context, modelLineNumber, distanceToModelLineStart, widthOfHiddenLineTextBefore, distanceToModelLineEnd) {
		this._context = _context;
		this.modelLineNumber = modelLineNumber;
		this.distanceToModelLineStart = distanceToModelLineStart;
		this.widthOfHiddenLineTextBefore = widthOfHiddenLineTextBefore;
		this.distanceToModelLineEnd = distanceToModelLineEnd;
		this._visibleTextAreaBrand = void 0;
		this.startPosition = null;
		this.endPosition = null;
		this.visibleTextareaStart = null;
		this.visibleTextareaEnd = null;
		/**
		* When doing composition, the currently composed text might be split up into
		* multiple tokens, then merged again into a single token, etc. Here we attempt
		* to keep the presentation of the <textarea> stable by using the previous used
		* style if multiple tokens come into play. This avoids flickering.
		*/
		this._previousPresentation = null;
	}
	prepareRender(visibleRangeProvider) {
		const startModelPosition = new Position$1(this.modelLineNumber, this.distanceToModelLineStart + 1);
		const endModelPosition = new Position$1(this.modelLineNumber, this._context.viewModel.model.getLineMaxColumn(this.modelLineNumber) - this.distanceToModelLineEnd);
		this.startPosition = this._context.viewModel.coordinatesConverter.convertModelPositionToViewPosition(startModelPosition);
		this.endPosition = this._context.viewModel.coordinatesConverter.convertModelPositionToViewPosition(endModelPosition);
		if (this.startPosition.lineNumber === this.endPosition.lineNumber) {
			this.visibleTextareaStart = visibleRangeProvider.visibleRangeForPosition(this.startPosition);
			this.visibleTextareaEnd = visibleRangeProvider.visibleRangeForPosition(this.endPosition);
		} else {
			this.visibleTextareaStart = null;
			this.visibleTextareaEnd = null;
		}
	}
	definePresentation(tokenPresentation) {
		if (!this._previousPresentation) {
			if (tokenPresentation) this._previousPresentation = tokenPresentation;
			else this._previousPresentation = {
				foreground: 1,
				italic: false,
				bold: false,
				underline: false,
				strikethrough: false
			};
		}
		return this._previousPresentation;
	}
};
var canUseZeroSizeTextarea = isFirefox;
var TextAreaEditContext = class TextAreaEditContext extends AbstractEditContext {
	constructor(ownerID, context, overflowGuardContainer, viewController, visibleRangeProvider, _keybindingService, _instantiationService) {
		super(context);
		this._keybindingService = _keybindingService;
		this._instantiationService = _instantiationService;
		this._primaryCursorPosition = new Position$1(1, 1);
		this._primaryCursorVisibleRange = null;
		this._viewController = viewController;
		this._visibleRangeProvider = visibleRangeProvider;
		this._scrollLeft = 0;
		this._scrollTop = 0;
		const options = this._context.configuration.options;
		const layoutInfo = options.get(166);
		this._setAccessibilityOptions(options);
		this._contentLeft = layoutInfo.contentLeft;
		this._contentWidth = layoutInfo.contentWidth;
		this._contentHeight = layoutInfo.height;
		this._fontInfo = options.get(59);
		this._emptySelectionClipboard = options.get(45);
		this._visibleTextArea = null;
		this._selections = [new Selection$1(1, 1, 1, 1)];
		this._modelSelections = [new Selection$1(1, 1, 1, 1)];
		this._lastRenderPosition = null;
		this.textArea = createFastDomNode(document.createElement("textarea"));
		PartFingerprints.write(this.textArea, 7);
		this.textArea.setClassName(`inputarea ${MOUSE_CURSOR_TEXT_CSS_CLASS_NAME}`);
		this.textArea.setAttribute("wrap", this._textAreaWrapping && !this._visibleTextArea ? "on" : "off");
		const { tabSize } = this._context.viewModel.model.getOptions();
		this.textArea.domNode.style.tabSize = `${tabSize * this._fontInfo.spaceWidth}px`;
		this.textArea.setAttribute("autocorrect", "off");
		this.textArea.setAttribute("autocapitalize", "off");
		this.textArea.setAttribute("autocomplete", "off");
		this.textArea.setAttribute("spellcheck", "false");
		this.textArea.setAttribute("aria-label", ariaLabelForScreenReaderContent(options, this._keybindingService));
		this.textArea.setAttribute("aria-required", options.get(9) ? "true" : "false");
		this.textArea.setAttribute("tabindex", String(options.get(140)));
		this.textArea.setAttribute("role", "textbox");
		this.textArea.setAttribute("aria-roledescription", localize(69, "editor"));
		this.textArea.setAttribute("aria-multiline", "true");
		this.textArea.setAttribute("aria-autocomplete", options.get(104) ? "none" : "both");
		this._ensureReadOnlyAttribute();
		this.textAreaCover = createFastDomNode(document.createElement("div"));
		this.textAreaCover.setPosition("absolute");
		overflowGuardContainer.appendChild(this.textArea);
		overflowGuardContainer.appendChild(this.textAreaCover);
		const simplePagedScreenReaderStrategy = new SimplePagedScreenReaderStrategy();
		const textAreaInputHost = {
			context: this._context,
			getScreenReaderContent: () => {
				if (this._accessibilitySupport === 1) {
					const selection = this._selections[0];
					if (isMacintosh && selection.isEmpty()) {
						const position = selection.getStartPosition();
						let textBefore = this._getWordBeforePosition(position);
						if (textBefore.length === 0) textBefore = this._getCharacterBeforePosition(position);
						if (textBefore.length > 0) return new TextAreaState(textBefore, textBefore.length, textBefore.length, Range$2.fromPositions(position), 0);
					}
					if (isMacintosh && !selection.isEmpty() && this._context.viewModel.getValueLengthInRange(selection, 0) < 500) {
						const text = this._context.viewModel.getValueInRange(selection, 0);
						return new TextAreaState(text, 0, text.length, selection, 0);
					}
					if (isSafari && !selection.isEmpty()) return new TextAreaState("vscode-placeholder", 0, 18, null, void 0);
					return TextAreaState.EMPTY;
				}
				if (isAndroid) {
					const selection = this._selections[0];
					if (selection.isEmpty()) {
						const position = selection.getStartPosition();
						const [wordAtPosition, positionOffsetInWord] = this._getAndroidWordAtPosition(position);
						if (wordAtPosition.length > 0) return new TextAreaState(wordAtPosition, positionOffsetInWord, positionOffsetInWord, Range$2.fromPositions(position), 0);
					}
					return TextAreaState.EMPTY;
				}
				const screenReaderContentState = simplePagedScreenReaderStrategy.fromEditorSelection(this._context.viewModel, this._selections[0], this._accessibilityPageSize, this._accessibilitySupport === 0);
				return TextAreaState.fromScreenReaderContentState(screenReaderContentState);
			},
			deduceModelPosition: (viewAnchorPosition, deltaOffset, lineFeedCnt) => {
				return this._context.viewModel.deduceModelPositionRelativeToViewPosition(viewAnchorPosition, deltaOffset, lineFeedCnt);
			}
		};
		const textAreaWrapper = this._register(new TextAreaWrapper(this.textArea.domNode));
		this._textAreaInput = this._register(this._instantiationService.createInstance(TextAreaInput, textAreaInputHost, textAreaWrapper, OS, {
			isAndroid,
			isChrome,
			isFirefox,
			isSafari
		}));
		this._register(this._textAreaInput.onWillCopy((e) => this._onWillCopy.fire(e)));
		this._register(this._textAreaInput.onWillCut((e) => this._onWillCut.fire(e)));
		this._register(this._textAreaInput.onWillPaste((e) => this._onWillPaste.fire(e)));
		this._register(this._textAreaInput.onKeyDown((e) => {
			this._viewController.emitKeyDown(e);
		}));
		this._register(this._textAreaInput.onKeyUp((e) => {
			this._viewController.emitKeyUp(e);
		}));
		this._register(this._textAreaInput.onPaste((e) => {
			let pasteOnNewLine = false;
			let multicursorText = null;
			let mode = null;
			if (e.metadata) {
				pasteOnNewLine = this._emptySelectionClipboard && !!e.metadata.isFromEmptySelection;
				multicursorText = typeof e.metadata.multicursorText !== "undefined" ? e.metadata.multicursorText : null;
				mode = e.metadata.mode;
			}
			this._viewController.paste(e.text, pasteOnNewLine, multicursorText, mode);
		}));
		this._register(this._textAreaInput.onCut(() => {
			this._viewController.cut();
		}));
		this._register(this._textAreaInput.onType((e) => {
			if (e.replacePrevCharCnt || e.replaceNextCharCnt || e.positionDelta) this._viewController.compositionType(e.text, e.replacePrevCharCnt, e.replaceNextCharCnt, e.positionDelta);
			else this._viewController.type(e.text);
		}));
		this._register(this._textAreaInput.onSelectionChangeRequest((modelSelection) => {
			this._viewController.setSelection(modelSelection);
		}));
		this._register(this._textAreaInput.onCompositionStart((e) => {
			const ta = this.textArea.domNode;
			const modelSelection = this._modelSelections[0];
			const { distanceToModelLineStart, widthOfHiddenTextBefore } = (() => {
				const textBeforeSelection = ta.value.substring(0, Math.min(ta.selectionStart, ta.selectionEnd));
				const lineFeedOffset1 = textBeforeSelection.lastIndexOf("\n");
				const lineTextBeforeSelection = textBeforeSelection.substring(lineFeedOffset1 + 1);
				const tabOffset1 = lineTextBeforeSelection.lastIndexOf("	");
				const desiredVisibleBeforeCharCount = lineTextBeforeSelection.length - tabOffset1 - 1;
				const startModelPosition = modelSelection.getStartPosition();
				const visibleBeforeCharCount = Math.min(startModelPosition.column - 1, desiredVisibleBeforeCharCount);
				const distanceToModelLineStart = startModelPosition.column - 1 - visibleBeforeCharCount;
				const hiddenLineTextBefore = lineTextBeforeSelection.substring(0, lineTextBeforeSelection.length - visibleBeforeCharCount);
				const { tabSize } = this._context.viewModel.model.getOptions();
				return {
					distanceToModelLineStart,
					widthOfHiddenTextBefore: measureText(this.textArea.domNode.ownerDocument, hiddenLineTextBefore, this._fontInfo, tabSize)
				};
			})();
			const { distanceToModelLineEnd } = (() => {
				const textAfterSelection = ta.value.substring(Math.max(ta.selectionStart, ta.selectionEnd));
				const lineFeedOffset2 = textAfterSelection.indexOf("\n");
				const lineTextAfterSelection = lineFeedOffset2 === -1 ? textAfterSelection : textAfterSelection.substring(0, lineFeedOffset2);
				const tabOffset2 = lineTextAfterSelection.indexOf("	");
				const desiredVisibleAfterCharCount = tabOffset2 === -1 ? lineTextAfterSelection.length : lineTextAfterSelection.length - tabOffset2 - 1;
				const endModelPosition = modelSelection.getEndPosition();
				const visibleAfterCharCount = Math.min(this._context.viewModel.model.getLineMaxColumn(endModelPosition.lineNumber) - endModelPosition.column, desiredVisibleAfterCharCount);
				return { distanceToModelLineEnd: this._context.viewModel.model.getLineMaxColumn(endModelPosition.lineNumber) - endModelPosition.column - visibleAfterCharCount };
			})();
			this._context.viewModel.revealRange("keyboard", true, Range$2.fromPositions(this._selections[0].getStartPosition()), 0, 1);
			this._visibleTextArea = new VisibleTextAreaData(this._context, modelSelection.startLineNumber, distanceToModelLineStart, widthOfHiddenTextBefore, distanceToModelLineEnd);
			this.textArea.setAttribute("wrap", this._textAreaWrapping && !this._visibleTextArea ? "on" : "off");
			this._visibleTextArea.prepareRender(this._visibleRangeProvider);
			this._render();
			this.textArea.setClassName(`inputarea ${MOUSE_CURSOR_TEXT_CSS_CLASS_NAME} ime-input`);
			this._viewController.compositionStart();
			this._context.viewModel.onCompositionStart();
		}));
		this._register(this._textAreaInput.onCompositionUpdate((e) => {
			if (!this._visibleTextArea) return;
			this._visibleTextArea.prepareRender(this._visibleRangeProvider);
			this._render();
		}));
		this._register(this._textAreaInput.onCompositionEnd(() => {
			this._visibleTextArea = null;
			this.textArea.setAttribute("wrap", this._textAreaWrapping && !this._visibleTextArea ? "on" : "off");
			this._render();
			this.textArea.setClassName(`inputarea ${MOUSE_CURSOR_TEXT_CSS_CLASS_NAME}`);
			this._viewController.compositionEnd();
			this._context.viewModel.onCompositionEnd();
		}));
		this._register(this._textAreaInput.onFocus(() => {
			this._context.viewModel.setHasFocus(true);
		}));
		this._register(this._textAreaInput.onBlur(() => {
			this._context.viewModel.setHasFocus(false);
		}));
		this._register(IME.onDidChange(() => {
			this._ensureReadOnlyAttribute();
		}));
		this._register(TextAreaEditContextRegistry.register(ownerID, this));
	}
	get domNode() {
		return this.textArea;
	}
	writeScreenReaderContent(reason) {
		this._textAreaInput.writeNativeTextAreaContent(reason);
	}
	dispose() {
		super.dispose();
		this.textArea.domNode.remove();
		this.textAreaCover.domNode.remove();
	}
	_getAndroidWordAtPosition(position) {
		if (position.lineNumber > this._context.viewModel.getLineCount()) return ["", 0];
		const ANDROID_WORD_SEPARATORS = "`~!@#$%^&*()-=+[{]}\\|;:\",.<>/?";
		const lineContent = this._context.viewModel.getLineContent(position.lineNumber);
		const wordSeparators = getMapForWordSeparators(ANDROID_WORD_SEPARATORS, []);
		let goingLeft = true;
		let startColumn = position.column;
		let goingRight = true;
		let endColumn = position.column;
		let distance = 0;
		while (distance < 50 && (goingLeft || goingRight)) {
			if (goingLeft && startColumn <= 1) goingLeft = false;
			if (goingLeft) {
				const charCode = lineContent.charCodeAt(startColumn - 2);
				if (wordSeparators.get(charCode) !== 0) goingLeft = false;
				else startColumn--;
			}
			if (goingRight && endColumn > lineContent.length) goingRight = false;
			if (goingRight) {
				const charCode = lineContent.charCodeAt(endColumn - 1);
				if (wordSeparators.get(charCode) !== 0) goingRight = false;
				else endColumn++;
			}
			distance++;
		}
		return [lineContent.substring(startColumn - 1, endColumn - 1), position.column - startColumn];
	}
	_getWordBeforePosition(position) {
		if (position.lineNumber > this._context.viewModel.getLineCount()) return "";
		const lineContent = this._context.viewModel.getLineContent(position.lineNumber);
		const wordSeparators = getMapForWordSeparators(this._context.configuration.options.get(148), []);
		let column = position.column;
		let distance = 0;
		while (column > 1) {
			const charCode = lineContent.charCodeAt(column - 2);
			if (wordSeparators.get(charCode) !== 0 || distance > 50) return lineContent.substring(column - 1, position.column - 1);
			distance++;
			column--;
		}
		return lineContent.substring(0, position.column - 1);
	}
	_getCharacterBeforePosition(position) {
		if (position.column > 1) {
			if (position.lineNumber > this._context.viewModel.getLineCount()) return "";
			const charBefore = this._context.viewModel.getLineContent(position.lineNumber).charAt(position.column - 2);
			if (!isHighSurrogate(charBefore.charCodeAt(0))) return charBefore;
		}
		return "";
	}
	_setAccessibilityOptions(options) {
		this._accessibilitySupport = options.get(2);
		const accessibilityPageSize = options.get(3);
		if (this._accessibilitySupport === 2 && accessibilityPageSize === EditorOptions.accessibilityPageSize.defaultValue) this._accessibilityPageSize = 500;
		else this._accessibilityPageSize = accessibilityPageSize;
		const wrappingColumn = options.get(166).wrappingColumn;
		if (wrappingColumn !== -1 && this._accessibilitySupport !== 1) {
			const fontInfo = options.get(59);
			this._textAreaWrapping = true;
			this._textAreaWidth = Math.round(wrappingColumn * fontInfo.typicalHalfwidthCharacterWidth);
		} else {
			this._textAreaWrapping = false;
			this._textAreaWidth = canUseZeroSizeTextarea ? 0 : 1;
		}
	}
	onConfigurationChanged(e) {
		const options = this._context.configuration.options;
		const layoutInfo = options.get(166);
		this._setAccessibilityOptions(options);
		this._contentLeft = layoutInfo.contentLeft;
		this._contentWidth = layoutInfo.contentWidth;
		this._contentHeight = layoutInfo.height;
		this._fontInfo = options.get(59);
		this._emptySelectionClipboard = options.get(45);
		this.textArea.setAttribute("wrap", this._textAreaWrapping && !this._visibleTextArea ? "on" : "off");
		const { tabSize } = this._context.viewModel.model.getOptions();
		this.textArea.domNode.style.tabSize = `${tabSize * this._fontInfo.spaceWidth}px`;
		this.textArea.setAttribute("aria-label", ariaLabelForScreenReaderContent(options, this._keybindingService));
		this.textArea.setAttribute("aria-required", options.get(9) ? "true" : "false");
		this.textArea.setAttribute("tabindex", String(options.get(140)));
		if (e.hasChanged(41) || e.hasChanged(104)) this._ensureReadOnlyAttribute();
		if (e.hasChanged(2)) this._textAreaInput.writeNativeTextAreaContent("strategy changed");
		return true;
	}
	onCursorStateChanged(e) {
		this._selections = e.selections.slice(0);
		this._modelSelections = e.modelSelections.slice(0);
		this._textAreaInput.writeNativeTextAreaContent("selection changed");
		return true;
	}
	onDecorationsChanged(e) {
		return true;
	}
	onFlushed(e) {
		return true;
	}
	onLinesChanged(e) {
		return true;
	}
	onLinesDeleted(e) {
		return true;
	}
	onLinesInserted(e) {
		return true;
	}
	onScrollChanged(e) {
		this._scrollLeft = e.scrollLeft;
		this._scrollTop = e.scrollTop;
		return true;
	}
	onZonesChanged(e) {
		return true;
	}
	isFocused() {
		return this._textAreaInput.isFocused();
	}
	focus() {
		this._textAreaInput.focusTextArea();
	}
	refreshFocusState() {
		this._textAreaInput.refreshFocusState();
	}
	getLastRenderData() {
		return this._lastRenderPosition;
	}
	setAriaOptions(options) {
		if (options.activeDescendant) {
			this.textArea.setAttribute("aria-haspopup", "true");
			this.textArea.setAttribute("aria-autocomplete", "list");
			this.textArea.setAttribute("aria-activedescendant", options.activeDescendant);
		} else {
			this.textArea.setAttribute("aria-haspopup", "false");
			this.textArea.setAttribute("aria-autocomplete", "both");
			this.textArea.removeAttribute("aria-activedescendant");
		}
		if (options.role) this.textArea.setAttribute("role", options.role);
	}
	_ensureReadOnlyAttribute() {
		const options = this._context.configuration.options;
		if (!IME.enabled || options.get(41) && options.get(104)) this.textArea.setAttribute("readonly", "true");
		else this.textArea.removeAttribute("readonly");
	}
	prepareRender(ctx) {
		this._primaryCursorPosition = new Position$1(this._selections[0].positionLineNumber, this._selections[0].positionColumn);
		this._primaryCursorVisibleRange = ctx.visibleRangeForPosition(this._primaryCursorPosition);
		this._visibleTextArea?.prepareRender(ctx);
	}
	render(ctx) {
		this._textAreaInput.writeNativeTextAreaContent("render");
		this._render();
	}
	_render() {
		if (this._visibleTextArea) {
			const visibleStart = this._visibleTextArea.visibleTextareaStart;
			const visibleEnd = this._visibleTextArea.visibleTextareaEnd;
			const startPosition = this._visibleTextArea.startPosition;
			const endPosition = this._visibleTextArea.endPosition;
			if (startPosition && endPosition && visibleStart && visibleEnd && visibleEnd.left >= this._scrollLeft && visibleStart.left <= this._scrollLeft + this._contentWidth) {
				const top = this._context.viewLayout.getVerticalOffsetForLineNumber(this._primaryCursorPosition.lineNumber) - this._scrollTop;
				const lineCount = newlinecount(this.textArea.domNode.value.substr(0, this.textArea.domNode.selectionStart));
				let scrollLeft = this._visibleTextArea.widthOfHiddenLineTextBefore;
				let left = this._contentLeft + visibleStart.left - this._scrollLeft;
				let width = visibleEnd.left - visibleStart.left + 1;
				if (left < this._contentLeft) {
					const delta = this._contentLeft - left;
					left += delta;
					scrollLeft += delta;
					width -= delta;
				}
				if (width > this._contentWidth) width = this._contentWidth;
				const lineHeight = this._context.viewLayout.getLineHeightForLineNumber(startPosition.lineNumber);
				const fontSize = this._context.viewModel.getFontSizeAtPosition(this._primaryCursorPosition);
				const viewLineData = this._context.viewModel.getViewLineData(startPosition.lineNumber);
				const startTokenIndex = viewLineData.tokens.findTokenIndexAtOffset(startPosition.column - 1);
				const textareaSpansSingleToken = startTokenIndex === viewLineData.tokens.findTokenIndexAtOffset(endPosition.column - 1);
				const presentation = this._visibleTextArea.definePresentation(textareaSpansSingleToken ? viewLineData.tokens.getPresentation(startTokenIndex) : null);
				this.textArea.domNode.scrollTop = lineCount * lineHeight;
				this.textArea.domNode.scrollLeft = scrollLeft;
				this._doRender({
					lastRenderPosition: null,
					top,
					left,
					width,
					height: lineHeight,
					useCover: false,
					color: (TokenizationRegistry.getColorMap() || [])[presentation.foreground],
					italic: presentation.italic,
					bold: presentation.bold,
					underline: presentation.underline,
					strikethrough: presentation.strikethrough,
					fontSize
				});
			}
			return;
		}
		if (!this._primaryCursorVisibleRange) {
			this._renderAtTopLeft();
			return;
		}
		const left = this._contentLeft + this._primaryCursorVisibleRange.left - this._scrollLeft;
		if (left < this._contentLeft || left > this._contentLeft + this._contentWidth) {
			this._renderAtTopLeft();
			return;
		}
		const top = this._context.viewLayout.getVerticalOffsetForLineNumber(this._selections[0].positionLineNumber) - this._scrollTop;
		if (top < 0 || top > this._contentHeight) {
			this._renderAtTopLeft();
			return;
		}
		if (isMacintosh || this._accessibilitySupport === 2) {
			const lineNumber = this._primaryCursorPosition.lineNumber;
			const lineHeight = this._context.viewLayout.getLineHeightForLineNumber(lineNumber);
			this._doRender({
				lastRenderPosition: this._primaryCursorPosition,
				top,
				left: this._textAreaWrapping ? this._contentLeft : left,
				width: this._textAreaWidth,
				height: lineHeight,
				useCover: false
			});
			this.textArea.domNode.scrollLeft = this._primaryCursorVisibleRange.left;
			const lineCount = this._textAreaInput.textAreaState.newlineCountBeforeSelection ?? newlinecount(this.textArea.domNode.value.substring(0, this.textArea.domNode.selectionStart));
			this.textArea.domNode.scrollTop = lineCount * lineHeight;
			return;
		}
		this._doRender({
			lastRenderPosition: this._primaryCursorPosition,
			top,
			left: this._textAreaWrapping ? this._contentLeft : left,
			width: this._textAreaWidth,
			height: canUseZeroSizeTextarea ? 0 : 1,
			useCover: false
		});
	}
	_renderAtTopLeft() {
		this._doRender({
			lastRenderPosition: null,
			top: 0,
			left: 0,
			width: this._textAreaWidth,
			height: canUseZeroSizeTextarea ? 0 : 1,
			useCover: true
		});
	}
	_doRender(renderData) {
		this._lastRenderPosition = renderData.lastRenderPosition;
		const ta = this.textArea;
		const tac = this.textAreaCover;
		applyFontInfo(ta, this._fontInfo);
		ta.setTop(renderData.top);
		ta.setLeft(renderData.left);
		ta.setWidth(renderData.width);
		ta.setHeight(renderData.height);
		ta.setLineHeight(renderData.height);
		ta.setFontSize(renderData.fontSize ?? this._fontInfo.fontSize);
		ta.setColor(renderData.color ? Color.Format.CSS.formatHex(renderData.color) : "");
		ta.setFontStyle(renderData.italic ? "italic" : "");
		if (renderData.bold) ta.setFontWeight("bold");
		ta.setTextDecoration(`${renderData.underline ? " underline" : ""}${renderData.strikethrough ? " line-through" : ""}`);
		tac.setTop(renderData.useCover ? renderData.top : 0);
		tac.setLeft(renderData.useCover ? renderData.left : 0);
		tac.setWidth(renderData.useCover ? renderData.width : 0);
		tac.setHeight(renderData.useCover ? renderData.height : 0);
		const options = this._context.configuration.options;
		if (options.get(66)) tac.setClassName("monaco-editor-background textAreaCover " + Margin.OUTER_CLASS_NAME);
		else if (options.get(76).renderType !== 0) tac.setClassName("monaco-editor-background textAreaCover " + LineNumbersOverlay.CLASS_NAME);
		else tac.setClassName("monaco-editor-background textAreaCover");
	}
};
TextAreaEditContext = __decorate$66([__param$61(5, IKeybindingService), __param$61(6, IInstantiationService)], TextAreaEditContext);
function measureText(targetDocument, text, fontInfo, tabSize) {
	if (text.length === 0) return 0;
	const container = $$10("div");
	container.style.position = "absolute";
	container.style.top = "-50000px";
	container.style.width = "50000px";
	const regularDomNode = $$10("span");
	applyFontInfo(regularDomNode, fontInfo);
	regularDomNode.style.whiteSpace = "pre";
	regularDomNode.style.tabSize = `${tabSize * fontInfo.spaceWidth}px`;
	regularDomNode.append(text);
	container.appendChild(regularDomNode);
	targetDocument.body.appendChild(container);
	const res = regularDomNode.offsetWidth;
	container.remove();
	return res;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/controller/editContext/native/nativeEditContextUtils.js
var __decorate$65 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$60 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var FocusTracker = class FocusTracker extends Disposable {
	constructor(_logService, _domNode, _onFocusChange) {
		super();
		this._domNode = _domNode;
		this._onFocusChange = _onFocusChange;
		this._isFocused = false;
		this._isPaused = false;
		this._register(addDisposableListener(this._domNode, "focus", () => {
			_logService.trace("NativeEditContext.focus");
			if (this._isPaused) return;
			this.refreshFocusState();
		}));
		this._register(addDisposableListener(this._domNode, "blur", () => {
			_logService.trace("NativeEditContext.blur");
			if (this._isPaused) return;
			this._handleFocusedChanged(false);
		}));
	}
	pause() {
		this._isPaused = true;
	}
	resume() {
		this._isPaused = false;
		this.refreshFocusState();
	}
	_handleFocusedChanged(focused) {
		if (this._isFocused === focused) return;
		this._isFocused = focused;
		this._onFocusChange(this._isFocused);
	}
	focus() {
		this._domNode.focus();
		this.refreshFocusState();
	}
	refreshFocusState() {
		const shadowRoot = getShadowRoot(this._domNode);
		const activeElement = shadowRoot ? shadowRoot.activeElement : this._domNode.ownerDocument.activeElement;
		const focused = this._domNode === activeElement;
		this._handleFocusedChanged(focused);
	}
	get isFocused() {
		return this._isFocused;
	}
};
FocusTracker = __decorate$65([__param$60(0, ILogService)], FocusTracker);
function editContextAddDisposableListener(target, type, listener, options) {
	target.addEventListener(type, listener, options);
	return { dispose() {
		target.removeEventListener(type, listener);
	} };
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/controller/editContext/native/screenReaderContentRich.js
var __decorate$64 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$59 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var ttPolicy$3 = createTrustedTypesPolicy("richScreenReaderContent", { createHTML: (value) => value });
var LINE_NUMBER_ATTRIBUTE = "data-line-number";
var RichScreenReaderContent = class RichScreenReaderContent extends Disposable {
	constructor(_domNode, _context, _viewController, _accessibilityService) {
		super();
		this._domNode = _domNode;
		this._context = _context;
		this._viewController = _viewController;
		this._accessibilityService = _accessibilityService;
		this._selectionChangeListener = this._register(new MutableDisposable());
		this._accessibilityPageSize = 1;
		this._ignoreSelectionChangeTime = 0;
		this._state = RichScreenReaderState.NULL;
		this._strategy = new RichPagedScreenReaderStrategy();
		this._renderedLines = /* @__PURE__ */ new Map();
		this._renderedSelection = new Selection$1(1, 1, 1, 1);
		this.onConfigurationChanged(this._context.configuration.options);
	}
	updateScreenReaderContent(primarySelection) {
		const focusedElement = getActiveWindow().document.activeElement;
		if (!focusedElement || focusedElement !== this._domNode.domNode) return;
		if (this._accessibilityService.isScreenReaderOptimized()) {
			const state = this._getScreenReaderContentLineIntervals(primarySelection);
			if (!this._state.equals(state)) {
				this._state = state;
				this._renderedLines = this._renderScreenReaderContent(state);
			}
			if (!this._renderedSelection.equalsSelection(primarySelection)) {
				this._renderedSelection = primarySelection;
				this._setSelectionOnScreenReaderContent(this._context, this._renderedLines, primarySelection);
			}
		} else {
			this._state = RichScreenReaderState.NULL;
			this._setIgnoreSelectionChangeTime("setValue");
			this._domNode.domNode.textContent = "";
		}
	}
	updateScrollTop(primarySelection) {
		const intervals = this._state.intervals;
		if (!intervals.length) return;
		const viewLayout = this._context.viewModel.viewLayout;
		const stateStartLineNumber = intervals[0].startLine;
		const verticalOffsetOfStateStartLineNumber = viewLayout.getVerticalOffsetForLineNumber(stateStartLineNumber);
		const verticalOffsetOfPositionLineNumber = viewLayout.getVerticalOffsetForLineNumber(primarySelection.positionLineNumber);
		this._domNode.domNode.scrollTop = verticalOffsetOfPositionLineNumber - verticalOffsetOfStateStartLineNumber;
	}
	onFocusChange(newFocusValue) {
		if (newFocusValue) this._selectionChangeListener.value = this._setSelectionChangeListener();
		else this._selectionChangeListener.value = void 0;
	}
	onConfigurationChanged(options) {
		this._accessibilityPageSize = options.get(3);
	}
	onWillCut() {
		this._setIgnoreSelectionChangeTime("onCut");
	}
	onWillPaste() {
		this._setIgnoreSelectionChangeTime("onWillPaste");
	}
	_setIgnoreSelectionChangeTime(reason) {
		this._ignoreSelectionChangeTime = Date.now();
	}
	_setSelectionChangeListener() {
		let previousSelectionChangeEventTime = 0;
		return addDisposableListener(this._domNode.domNode.ownerDocument, "selectionchange", () => {
			if (!(getActiveWindow().document.activeElement === this._domNode.domNode)) return;
			if (!this._accessibilityService.isScreenReaderOptimized() || !IME.enabled) return;
			const now = Date.now();
			const delta1 = now - previousSelectionChangeEventTime;
			previousSelectionChangeEventTime = now;
			if (delta1 < 5) return;
			const delta2 = now - this._ignoreSelectionChangeTime;
			this._ignoreSelectionChangeTime = 0;
			if (delta2 < 100) return;
			const selection = this._getEditorSelectionFromDomRange();
			if (!selection) return;
			this._viewController.setSelection(selection);
		});
	}
	_renderScreenReaderContent(state) {
		const nodes = [];
		const renderedLines = /* @__PURE__ */ new Map();
		for (const interval of state.intervals) for (let lineNumber = interval.startLine; lineNumber <= interval.endLine; lineNumber++) {
			const renderedLine = this._renderLine(lineNumber);
			renderedLines.set(lineNumber, renderedLine);
			nodes.push(renderedLine.domNode);
		}
		this._setIgnoreSelectionChangeTime("setValue");
		this._domNode.domNode.replaceChildren(...nodes);
		return renderedLines;
	}
	_renderLine(viewLineNumber) {
		const viewModel = this._context.viewModel;
		const positionLineData = viewModel.getViewLineRenderingData(viewLineNumber);
		const options = this._context.configuration.options;
		const fontInfo = options.get(59);
		const stopRenderingLineAfter = options.get(133);
		const renderControlCharacters = options.get(108);
		const fontLigatures = options.get(60);
		const disableMonospaceOptimizations = options.get(40);
		const lineDecorations = LineDecoration.filter(positionLineData.inlineDecorations, viewLineNumber, positionLineData.minColumn, positionLineData.maxColumn);
		const useMonospaceOptimizations = fontInfo.isMonospace && !disableMonospaceOptimizations;
		const useFontLigatures = fontLigatures !== EditorFontLigatures.OFF;
		let renderWhitespace;
		if (options.get(47) === "off") renderWhitespace = options.get(113);
		else renderWhitespace = "none";
		const renderLineInput = new RenderLineInput(useMonospaceOptimizations, fontInfo.canUseHalfwidthRightwardsArrow, positionLineData.content, positionLineData.continuesWithWrappedLine, positionLineData.isBasicASCII, positionLineData.containsRTL, positionLineData.minColumn - 1, positionLineData.tokens, lineDecorations, positionLineData.tabSize, positionLineData.startVisibleColumn, fontInfo.spaceWidth, fontInfo.middotWidth, fontInfo.wsmiddotWidth, stopRenderingLineAfter, renderWhitespace, renderControlCharacters, useFontLigatures, null, null, 0, true);
		const htmlBuilder = new StringBuilder(1e4);
		const renderOutput = renderViewLine(renderLineInput, htmlBuilder);
		const html = htmlBuilder.build();
		const trustedhtml = ttPolicy$3?.createHTML(html) ?? html;
		const lineHeight = viewModel.viewLayout.getLineHeightForLineNumber(viewLineNumber) + "px";
		const domNode = document.createElement("div");
		domNode.innerHTML = trustedhtml;
		domNode.style.lineHeight = lineHeight;
		domNode.style.height = lineHeight;
		domNode.setAttribute(LINE_NUMBER_ATTRIBUTE, viewLineNumber.toString());
		return new RichRenderedScreenReaderLine(domNode, renderOutput.characterMapping);
	}
	_setSelectionOnScreenReaderContent(context, renderedLines, viewSelection) {
		const activeDocumentSelection = getActiveWindow().document.getSelection();
		if (!activeDocumentSelection) return;
		const startLineNumber = viewSelection.startLineNumber;
		const endLineNumber = viewSelection.endLineNumber;
		const startRenderedLine = renderedLines.get(startLineNumber);
		const endRenderedLine = renderedLines.get(endLineNumber);
		if (!startRenderedLine || !endRenderedLine) return;
		const viewModel = context.viewModel;
		const model = viewModel.model;
		const coordinatesConverter = viewModel.coordinatesConverter;
		const startRange = new Range$2(startLineNumber, 1, startLineNumber, viewSelection.selectionStartColumn);
		const modelStartRange = coordinatesConverter.convertViewRangeToModelRange(startRange);
		const characterCountForStart = model.getCharacterCountInRange(modelStartRange);
		const endRange = new Range$2(endLineNumber, 1, endLineNumber, viewSelection.positionColumn);
		const modelEndRange = coordinatesConverter.convertViewRangeToModelRange(endRange);
		const characterCountForEnd = model.getCharacterCountInRange(modelEndRange);
		const startDomPosition = startRenderedLine.characterMapping.getDomPosition(characterCountForStart);
		const endDomPosition = endRenderedLine.characterMapping.getDomPosition(characterCountForEnd);
		const startDomNode = startRenderedLine.domNode.firstChild;
		const endDomNode = endRenderedLine.domNode.firstChild;
		const startChildren = startDomNode.childNodes;
		const endChildren = endDomNode.childNodes;
		const startNode = startChildren.item(startDomPosition.partIndex);
		const endNode = endChildren.item(endDomPosition.partIndex);
		if (!startNode.firstChild || !endNode.firstChild) return;
		this._setIgnoreSelectionChangeTime("setRange");
		activeDocumentSelection.setBaseAndExtent(startNode.firstChild, viewSelection.startColumn === 1 ? 0 : startDomPosition.charIndex + 1, endNode.firstChild, viewSelection.endColumn === 1 ? 0 : endDomPosition.charIndex + 1);
	}
	_getScreenReaderContentLineIntervals(primarySelection) {
		return this._strategy.fromEditorSelection(this._context.viewModel, primarySelection, this._accessibilityPageSize);
	}
	_getEditorSelectionFromDomRange() {
		if (!this._renderedLines) return;
		const selection = getActiveWindow().document.getSelection();
		if (!selection) return;
		if (selection.rangeCount === 0) return;
		const range = selection.getRangeAt(0);
		const startContainer = range.startContainer;
		const endContainer = range.endContainer;
		const startSpanElement = startContainer.parentElement;
		const endSpanElement = endContainer.parentElement;
		if (!startSpanElement || !isHTMLElement(startSpanElement) || !endSpanElement || !isHTMLElement(endSpanElement)) return;
		const startLineDomNode = startSpanElement.parentElement?.parentElement;
		const endLineDomNode = endSpanElement.parentElement?.parentElement;
		if (!startLineDomNode || !endLineDomNode) return;
		const startLineNumberAttribute = startLineDomNode.getAttribute(LINE_NUMBER_ATTRIBUTE);
		const endLineNumberAttribute = endLineDomNode.getAttribute(LINE_NUMBER_ATTRIBUTE);
		if (!startLineNumberAttribute || !endLineNumberAttribute) return;
		const startLineNumber = parseInt(startLineNumberAttribute);
		const endLineNumber = parseInt(endLineNumberAttribute);
		const startMapping = this._renderedLines.get(startLineNumber)?.characterMapping;
		const endMapping = this._renderedLines.get(endLineNumber)?.characterMapping;
		if (!startMapping || !endMapping) return;
		const startColumn = getColumnOfNodeOffset(startMapping, startSpanElement, range.startOffset);
		const endColumn = getColumnOfNodeOffset(endMapping, endSpanElement, range.endOffset);
		if (selection.direction === "forward") return new Selection$1(startLineNumber, startColumn, endLineNumber, endColumn);
		else return new Selection$1(endLineNumber, endColumn, startLineNumber, startColumn);
	}
};
RichScreenReaderContent = __decorate$64([__param$59(3, IAccessibilityService)], RichScreenReaderContent);
var RichRenderedScreenReaderLine = class {
	constructor(domNode, characterMapping) {
		this.domNode = domNode;
		this.characterMapping = characterMapping;
	}
};
var LineInterval = class {
	constructor(startLine, endLine) {
		this.startLine = startLine;
		this.endLine = endLine;
	}
};
var RichScreenReaderState = class RichScreenReaderState {
	constructor(model, intervals) {
		this.intervals = intervals;
		let value = "";
		for (const interval of intervals) for (let lineNumber = interval.startLine; lineNumber <= interval.endLine; lineNumber++) value += model.getLineContent(lineNumber) + "\n";
		this.value = value;
	}
	equals(other) {
		return this.value === other.value;
	}
	static get NULL() {
		return new RichScreenReaderState({
			getLineContent: () => "",
			getLineCount: () => 1,
			getLineMaxColumn: () => 1,
			getValueInRange: () => "",
			getValueLengthInRange: () => 0,
			modifyPosition: (position, offset) => position
		}, []);
	}
};
var RichPagedScreenReaderStrategy = class {
	constructor() {}
	_getPageOfLine(lineNumber, linesPerPage) {
		return Math.floor((lineNumber - 1) / linesPerPage);
	}
	_getRangeForPage(context, page, linesPerPage) {
		const offset = page * linesPerPage;
		return new LineInterval(offset + 1, Math.min(offset + linesPerPage, context.getLineCount()));
	}
	fromEditorSelection(context, viewSelection, linesPerPage) {
		const selectionStartPage = this._getPageOfLine(viewSelection.startLineNumber, linesPerPage);
		const selectionStartPageRange = this._getRangeForPage(context, selectionStartPage, linesPerPage);
		const selectionEndPage = this._getPageOfLine(viewSelection.endLineNumber, linesPerPage);
		const selectionEndPageRange = this._getRangeForPage(context, selectionEndPage, linesPerPage);
		const lineIntervals = [{
			startLine: selectionStartPageRange.startLine,
			endLine: selectionStartPageRange.endLine
		}];
		if (selectionStartPage + 1 < selectionEndPage) lineIntervals.push({
			startLine: selectionEndPageRange.startLine,
			endLine: selectionEndPageRange.endLine
		});
		return new RichScreenReaderState(context, lineIntervals);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/controller/editContext/native/screenReaderContentSimple.js
var __decorate$63 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$58 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var SimpleScreenReaderContent = class SimpleScreenReaderContent extends Disposable {
	constructor(_domNode, _context, _viewController, _accessibilityService) {
		super();
		this._domNode = _domNode;
		this._context = _context;
		this._viewController = _viewController;
		this._accessibilityService = _accessibilityService;
		this._selectionChangeListener = this._register(new MutableDisposable());
		this._accessibilityPageSize = 1;
		this._ignoreSelectionChangeTime = 0;
		this._strategy = new SimplePagedScreenReaderStrategy();
		this.onConfigurationChanged(this._context.configuration.options);
	}
	updateScreenReaderContent(primarySelection) {
		const domNode = this._domNode.domNode;
		const focusedElement = getActiveWindow().document.activeElement;
		if (!focusedElement || focusedElement !== domNode) return;
		if (this._accessibilityService.isScreenReaderOptimized()) {
			this._state = this._getScreenReaderContentState(primarySelection);
			if (domNode.textContent !== this._state.value) {
				this._setIgnoreSelectionChangeTime("setValue");
				domNode.textContent = this._state.value;
			}
			const selection = getActiveWindow().document.getSelection();
			if (!selection) return;
			const data = this._getScreenReaderRange(this._state.selectionStart, this._state.selectionEnd);
			if (!data) return;
			this._setIgnoreSelectionChangeTime("setRange");
			selection.setBaseAndExtent(data.anchorNode, data.anchorOffset, data.focusNode, data.focusOffset);
		} else {
			this._state = void 0;
			this._setIgnoreSelectionChangeTime("setValue");
			this._domNode.domNode.textContent = "";
		}
	}
	updateScrollTop(primarySelection) {
		if (!this._state) return;
		const viewLayout = this._context.viewModel.viewLayout;
		const stateStartLineNumber = this._state.startPositionWithinEditor.lineNumber;
		const verticalOffsetOfStateStartLineNumber = viewLayout.getVerticalOffsetForLineNumber(stateStartLineNumber);
		const verticalOffsetOfPositionLineNumber = viewLayout.getVerticalOffsetForLineNumber(primarySelection.positionLineNumber);
		this._domNode.domNode.scrollTop = verticalOffsetOfPositionLineNumber - verticalOffsetOfStateStartLineNumber;
	}
	onFocusChange(newFocusValue) {
		if (newFocusValue) this._selectionChangeListener.value = this._setSelectionChangeListener();
		else this._selectionChangeListener.value = void 0;
	}
	onConfigurationChanged(options) {
		this._accessibilityPageSize = options.get(3);
	}
	onWillCut() {
		this._setIgnoreSelectionChangeTime("onCut");
	}
	onWillPaste() {
		this._setIgnoreSelectionChangeTime("onWillPaste");
	}
	_setIgnoreSelectionChangeTime(reason) {
		this._ignoreSelectionChangeTime = Date.now();
	}
	_setSelectionChangeListener() {
		let previousSelectionChangeEventTime = 0;
		return addDisposableListener(this._domNode.domNode.ownerDocument, "selectionchange", () => {
			const isScreenReaderOptimized = this._accessibilityService.isScreenReaderOptimized();
			if (!this._state || !isScreenReaderOptimized || !IME.enabled) return;
			if (!(getActiveWindow().document.activeElement === this._domNode.domNode)) return;
			const selection = getActiveWindow().document.getSelection();
			if (!selection) return;
			if (selection.rangeCount === 0) return;
			const range = selection.getRangeAt(0);
			const now = Date.now();
			const delta1 = now - previousSelectionChangeEventTime;
			previousSelectionChangeEventTime = now;
			if (delta1 < 5) return;
			const delta2 = now - this._ignoreSelectionChangeTime;
			this._ignoreSelectionChangeTime = 0;
			if (delta2 < 100) return;
			this._viewController.setSelection(this._getEditorSelectionFromDomRange(this._context, this._state, selection.direction, range));
		});
	}
	_getScreenReaderContentState(primarySelection) {
		const state = this._strategy.fromEditorSelection(this._context.viewModel, primarySelection, this._accessibilityPageSize, this._accessibilityService.getAccessibilitySupport() === 0);
		const endPosition = this._context.viewModel.model.getPositionAt(Infinity);
		let value = state.value;
		if (endPosition.column === 1 && primarySelection.getEndPosition().equals(endPosition)) value += "\n";
		state.value = value;
		return state;
	}
	_getScreenReaderRange(selectionOffsetStart, selectionOffsetEnd) {
		const textContent = this._domNode.domNode.firstChild;
		if (!textContent) return;
		const range = new globalThis.Range();
		range.setStart(textContent, selectionOffsetStart);
		range.setEnd(textContent, selectionOffsetEnd);
		return {
			anchorNode: textContent,
			anchorOffset: selectionOffsetStart,
			focusNode: textContent,
			focusOffset: selectionOffsetEnd
		};
	}
	_getEditorSelectionFromDomRange(context, state, direction, range) {
		const viewModel = context.viewModel;
		const model = viewModel.model;
		const modelScreenReaderContentStartPositionWithinEditor = viewModel.coordinatesConverter.convertViewPositionToModelPosition(state.startPositionWithinEditor);
		const offsetOfStartOfScreenReaderContent = model.getOffsetAt(modelScreenReaderContentStartPositionWithinEditor);
		let offsetOfSelectionStart = range.startOffset + offsetOfStartOfScreenReaderContent;
		let offsetOfSelectionEnd = range.endOffset + offsetOfStartOfScreenReaderContent;
		if (model.getEndOfLineSequence() === 1) {
			const screenReaderContentText = state.value;
			const offsetTransformer = new PositionOffsetTransformer(screenReaderContentText);
			const positionOfStartWithinText = offsetTransformer.getPosition(range.startOffset);
			const positionOfEndWithinText = offsetTransformer.getPosition(range.endOffset);
			offsetOfSelectionStart += positionOfStartWithinText.lineNumber - 1;
			offsetOfSelectionEnd += positionOfEndWithinText.lineNumber - 1;
		}
		const positionOfSelectionStart = model.getPositionAt(offsetOfSelectionStart);
		const positionOfSelectionEnd = model.getPositionAt(offsetOfSelectionEnd);
		const selectionStart = direction === "forward" ? positionOfSelectionStart : positionOfSelectionEnd;
		const selectionEnd = direction === "forward" ? positionOfSelectionEnd : positionOfSelectionStart;
		return Selection$1.fromPositions(selectionStart, selectionEnd);
	}
};
SimpleScreenReaderContent = __decorate$63([__param$58(3, IAccessibilityService)], SimpleScreenReaderContent);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/controller/editContext/native/screenReaderSupport.js
var __decorate$62 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$57 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var ScreenReaderSupport = class ScreenReaderSupport extends Disposable {
	constructor(_domNode, _context, _viewController, _keybindingService, _accessibilityService) {
		super();
		this._domNode = _domNode;
		this._context = _context;
		this._viewController = _viewController;
		this._keybindingService = _keybindingService;
		this._accessibilityService = _accessibilityService;
		this._contentLeft = 1;
		this._contentWidth = 1;
		this._contentHeight = 1;
		this._divWidth = 1;
		this._primarySelection = new Selection$1(1, 1, 1, 1);
		this._primaryCursorVisibleRange = null;
		this._state = this._register(new MutableDisposable());
		this._instantiateScreenReaderContent();
		this._updateConfigurationSettings();
		this._updateDomAttributes();
	}
	onWillPaste() {
		this._state.value?.onWillPaste();
	}
	onWillCut() {
		this._state.value?.onWillCut();
	}
	handleFocusChange(newFocusValue) {
		this._state.value?.onFocusChange(newFocusValue);
		this.writeScreenReaderContent();
	}
	onConfigurationChanged(e) {
		this._instantiateScreenReaderContent();
		this._updateConfigurationSettings();
		this._updateDomAttributes();
		if (e.hasChanged(2)) this.writeScreenReaderContent();
	}
	_instantiateScreenReaderContent() {
		const renderRichContent = this._context.configuration.options.get(107);
		if (this._renderRichContent !== renderRichContent) {
			this._renderRichContent = renderRichContent;
			this._state.value = this._createScreenReaderContent(renderRichContent);
		}
	}
	_createScreenReaderContent(renderRichContent) {
		if (renderRichContent) return new RichScreenReaderContent(this._domNode, this._context, this._viewController, this._accessibilityService);
		else return new SimpleScreenReaderContent(this._domNode, this._context, this._viewController, this._accessibilityService);
	}
	_updateConfigurationSettings() {
		const options = this._context.configuration.options;
		const layoutInfo = options.get(166);
		const wrappingColumn = layoutInfo.wrappingColumn;
		this._contentLeft = layoutInfo.contentLeft;
		this._contentWidth = layoutInfo.contentWidth;
		this._contentHeight = layoutInfo.height;
		this._fontInfo = options.get(59);
		this._divWidth = Math.round(wrappingColumn * this._fontInfo.typicalHalfwidthCharacterWidth);
		this._state.value?.onConfigurationChanged(options);
	}
	_updateDomAttributes() {
		const options = this._context.configuration.options;
		this._domNode.domNode.setAttribute("role", "textbox");
		this._domNode.domNode.setAttribute("aria-required", options.get(9) ? "true" : "false");
		this._domNode.domNode.setAttribute("aria-multiline", "true");
		this._domNode.domNode.setAttribute("aria-autocomplete", options.get(104) ? "none" : "both");
		this._domNode.domNode.setAttribute("aria-roledescription", localize(64, "editor"));
		this._domNode.domNode.setAttribute("aria-label", ariaLabelForScreenReaderContent(options, this._keybindingService));
		const tabSize = this._context.viewModel.model.getOptions().tabSize;
		const spaceWidth = options.get(59).spaceWidth;
		this._domNode.domNode.style.tabSize = `${tabSize * spaceWidth}px`;
		const wordWrapOverride2 = options.get(154);
		const wordWrapOverride1 = wordWrapOverride2 === "inherit" ? options.get(153) : wordWrapOverride2;
		const wordWrap = wordWrapOverride1 === "inherit" ? options.get(149) : wordWrapOverride1;
		this._domNode.domNode.style.textWrap = wordWrap === "off" ? "nowrap" : "wrap";
	}
	onCursorStateChanged(e) {
		this._primarySelection = e.selections[0] ?? new Selection$1(1, 1, 1, 1);
	}
	prepareRender(ctx) {
		this.writeScreenReaderContent();
		this._primaryCursorVisibleRange = ctx.visibleRangeForPosition(this._primarySelection.getPosition());
	}
	render(ctx) {
		if (!this._primaryCursorVisibleRange) {
			this._renderAtTopLeft();
			return;
		}
		const editorScrollLeft = this._context.viewLayout.getCurrentScrollLeft();
		const left = this._contentLeft + this._primaryCursorVisibleRange.left - editorScrollLeft;
		if (left < this._contentLeft || left > this._contentLeft + this._contentWidth) {
			this._renderAtTopLeft();
			return;
		}
		const editorScrollTop = this._context.viewLayout.getCurrentScrollTop();
		const positionLineNumber = this._primarySelection.positionLineNumber;
		const top = this._context.viewLayout.getVerticalOffsetForLineNumber(positionLineNumber) - editorScrollTop;
		if (top < 0 || top > this._contentHeight) {
			this._renderAtTopLeft();
			return;
		}
		const lineHeight = this._context.viewLayout.getLineHeightForLineNumber(positionLineNumber);
		this._doRender(top, this._contentLeft, this._divWidth, lineHeight);
		this._state.value?.updateScrollTop(this._primarySelection);
	}
	_renderAtTopLeft() {
		this._doRender(0, 0, this._contentWidth, 1);
	}
	_doRender(top, left, width, height) {
		applyFontInfo(this._domNode, this._fontInfo);
		this._domNode.setTop(top);
		this._domNode.setLeft(left);
		this._domNode.setWidth(width);
		this._domNode.setHeight(height);
		this._domNode.setLineHeight(height);
	}
	setAriaOptions(options) {
		if (options.activeDescendant) {
			this._domNode.setAttribute("aria-haspopup", "true");
			this._domNode.setAttribute("aria-autocomplete", "list");
			this._domNode.setAttribute("aria-activedescendant", options.activeDescendant);
		} else {
			this._domNode.setAttribute("aria-haspopup", "false");
			this._domNode.setAttribute("aria-autocomplete", "both");
			this._domNode.removeAttribute("aria-activedescendant");
		}
		if (options.role) this._domNode.setAttribute("role", options.role);
	}
	writeScreenReaderContent() {
		this._state.value?.updateScreenReaderContent(this._primarySelection);
	}
};
ScreenReaderSupport = __decorate$62([__param$57(3, IKeybindingService), __param$57(4, IAccessibilityService)], ScreenReaderSupport);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/controller/editContext/native/editContextFactory.js
var EditContext;
(function(EditContext) {
	/**
	* Create an edit context.
	*/
	function create(window, options) {
		return new window.EditContext(options);
	}
	EditContext.create = create;
})(EditContext || (EditContext = {}));
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/controller/editContext/native/nativeEditContextRegistry.js
var NativeEditContextRegistryImpl = class {
	constructor() {
		this._nativeEditContextMapping = /* @__PURE__ */ new Map();
	}
	register(ownerID, nativeEditContext) {
		this._nativeEditContextMapping.set(ownerID, nativeEditContext);
		return { dispose: () => {
			this._nativeEditContextMapping.delete(ownerID);
		} };
	}
	get(ownerID) {
		return this._nativeEditContextMapping.get(ownerID);
	}
};
var NativeEditContextRegistry = new NativeEditContextRegistryImpl();
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/controller/editContext/native/nativeEditContext.js
var __decorate$61 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$56 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var CompositionClassName;
(function(CompositionClassName) {
	CompositionClassName["NONE"] = "edit-context-composition-none";
	CompositionClassName["SECONDARY"] = "edit-context-composition-secondary";
	CompositionClassName["PRIMARY"] = "edit-context-composition-primary";
})(CompositionClassName || (CompositionClassName = {}));
var NativeEditContext = class NativeEditContext extends AbstractEditContext {
	constructor(ownerID, context, overflowGuardContainer, _viewController, _visibleRangeProvider, instantiationService, logService) {
		super(context);
		this._viewController = _viewController;
		this._visibleRangeProvider = _visibleRangeProvider;
		this.logService = logService;
		this._previousEditContextSelection = new OffsetRange(0, 0);
		this._previousEditContextText = "";
		this._editContextPrimarySelection = new Selection$1(1, 1, 1, 1);
		/**
		* Marks the native EditContext as needing a refresh of its text / selection.
		*
		* We defer the actual update until render time so that a single large edit
		* (e.g. "Transform to Uppercase" over a many-MB selection) does not
		* synchronously hand a huge string to the native EditContext from inside
		* the model's content-change / view's cursor-state event handlers — which
		* used to freeze the editor for seconds. See issue #262473.
		*/
		this._editContextNeedsRefresh = false;
		this._parentBounds = null;
		this._decorations = [];
		this._primarySelection = new Selection$1(1, 1, 1, 1);
		this._targetWindowId = -1;
		this._scrollTop = 0;
		this._scrollLeft = 0;
		this._linesVisibleRanges = null;
		this.domNode = new FastDomNode(document.createElement("div"));
		this.domNode.setClassName(`native-edit-context`);
		this._imeTextArea = new FastDomNode(document.createElement("textarea"));
		this._imeTextArea.setClassName(`ime-text-area`);
		this._imeTextArea.setAttribute("readonly", "true");
		this._imeTextArea.setAttribute("tabindex", "-1");
		this._imeTextArea.setAttribute("aria-hidden", "true");
		this.domNode.setAttribute("autocorrect", "off");
		this.domNode.setAttribute("autocapitalize", "off");
		this.domNode.setAttribute("autocomplete", "off");
		this.domNode.setAttribute("spellcheck", "false");
		this._updateDomAttributes();
		overflowGuardContainer.appendChild(this.domNode);
		overflowGuardContainer.appendChild(this._imeTextArea);
		this._parent = overflowGuardContainer.domNode;
		this._focusTracker = this._register(new FocusTracker(logService, this.domNode.domNode, (newFocusValue) => {
			logService.trace("NativeEditContext#handleFocusChange : ", newFocusValue);
			this._screenReaderSupport.handleFocusChange(newFocusValue);
			this._context.viewModel.setHasFocus(newFocusValue);
		}));
		const window = getWindow(this.domNode.domNode);
		this._editContext = EditContext.create(window);
		this.setEditContextOnDomNode();
		this._screenReaderSupport = this._register(instantiationService.createInstance(ScreenReaderSupport, this.domNode, context, this._viewController));
		this._register(addDisposableListener(this.domNode.domNode, "copy", (e) => {
			this.logService.trace("NativeEditContext#copy");
			CopyOptions.electronBugWorkaroundCopyEventHasFired = true;
			const copyEvent = createClipboardCopyEvent(e, false, this._context, this.logService, isFirefox);
			this._onWillCopy.fire(copyEvent);
			if (copyEvent.isHandled) return;
			copyEvent.ensureClipboardGetsEditorData();
		}));
		this._register(addDisposableListener(this.domNode.domNode, "cut", (e) => {
			this.logService.trace("NativeEditContext#cut");
			const cutEvent = createClipboardCopyEvent(e, true, this._context, this.logService, isFirefox);
			this._onWillCut.fire(cutEvent);
			if (cutEvent.isHandled) return;
			this._screenReaderSupport.onWillCut();
			cutEvent.ensureClipboardGetsEditorData();
			this.logService.trace("NativeEditContext#cut (before viewController.cut)");
			this._viewController.cut();
		}));
		this._register(addDisposableListener(this.domNode.domNode, "selectionchange", () => {
			inputLatency.onSelectionChange();
		}));
		this._register(addDisposableListener(this.domNode.domNode, "keyup", (e) => this._onKeyUp(e)));
		this._register(addDisposableListener(this.domNode.domNode, "keydown", async (e) => this._onKeyDown(e)));
		this._register(addDisposableListener(this._imeTextArea.domNode, "keyup", (e) => this._onKeyUp(e)));
		this._register(addDisposableListener(this._imeTextArea.domNode, "keydown", async (e) => this._onKeyDown(e)));
		this._register(addDisposableListener(this.domNode.domNode, "beforeinput", async (e) => {
			inputLatency.onBeforeInput();
			if (e.inputType === "insertParagraph" || e.inputType === "insertLineBreak") this._onType(this._viewController, {
				text: "\n",
				replacePrevCharCnt: 0,
				replaceNextCharCnt: 0,
				positionDelta: 0
			});
		}));
		this._register(addDisposableListener(this.domNode.domNode, "paste", (e) => {
			this.logService.trace("NativeEditContext#paste");
			const pasteEvent = createClipboardPasteEvent(e);
			this._onWillPaste.fire(pasteEvent);
			if (pasteEvent.isHandled) {
				e.preventDefault();
				return;
			}
			e.preventDefault();
			if (!e.clipboardData) return;
			this.logService.trace("NativeEditContext#paste with id : ", pasteEvent.metadata?.id, " with text.length: ", pasteEvent.text.length);
			if (!pasteEvent.text) return;
			let pasteOnNewLine = false;
			let multicursorText = null;
			let mode = null;
			if (pasteEvent.metadata) {
				pasteOnNewLine = this._context.configuration.options.get(45) && !!pasteEvent.metadata.isFromEmptySelection;
				multicursorText = typeof pasteEvent.metadata.multicursorText !== "undefined" ? pasteEvent.metadata.multicursorText : null;
				mode = pasteEvent.metadata.mode;
			}
			this.logService.trace("NativeEditContext#paste (before viewController.paste)");
			this._viewController.paste(pasteEvent.text, pasteOnNewLine, multicursorText, mode);
		}));
		this._register(editContextAddDisposableListener(this._editContext, "textformatupdate", (e) => this._handleTextFormatUpdate(e)));
		this._register(editContextAddDisposableListener(this._editContext, "characterboundsupdate", (e) => this._updateCharacterBounds(e)));
		let highSurrogateCharacter;
		this._register(editContextAddDisposableListener(this._editContext, "textupdate", (e) => {
			inputLatency.onInput();
			const text = e.text;
			if (text.length === 1) {
				const charCode = text.charCodeAt(0);
				if (isHighSurrogate(charCode)) {
					highSurrogateCharacter = text;
					return;
				}
				if (isLowSurrogate(charCode) && highSurrogateCharacter) {
					const textUpdateEvent = {
						text: highSurrogateCharacter + text,
						selectionEnd: e.selectionEnd,
						selectionStart: e.selectionStart,
						updateRangeStart: e.updateRangeStart - 1,
						updateRangeEnd: e.updateRangeEnd - 1
					};
					highSurrogateCharacter = void 0;
					this._emitTypeEvent(this._viewController, textUpdateEvent);
					return;
				}
			}
			this._emitTypeEvent(this._viewController, e);
		}));
		this._register(editContextAddDisposableListener(this._editContext, "compositionstart", (e) => {
			this._updateEditContext();
			this._viewController.compositionStart();
			this._context.viewModel.onCompositionStart();
		}));
		this._register(editContextAddDisposableListener(this._editContext, "compositionend", (e) => {
			this._updateEditContext();
			this._viewController.compositionEnd();
			this._context.viewModel.onCompositionEnd();
		}));
		let reenableTracking = false;
		this._register(IME.onDidChange(() => {
			if (IME.enabled && reenableTracking) {
				this._focusTracker.resume();
				this.domNode.focus();
				reenableTracking = false;
			}
			if (!IME.enabled && this.isFocused()) {
				this._focusTracker.pause();
				this._imeTextArea.focus();
				reenableTracking = true;
			}
		}));
		this._register(NativeEditContextRegistry.register(ownerID, this));
		this._register(context.viewModel.model.onDidChangeContent((e) => {
			let doChange = false;
			for (const change of e.changes) if (change.range.startLineNumber <= this._editContextPrimarySelection.endLineNumber && change.range.endLineNumber >= this._editContextPrimarySelection.startLineNumber) {
				doChange = true;
				break;
			}
			if (doChange) {
				this._editContextNeedsRefresh = true;
				this.setShouldRender();
			}
		}));
	}
	dispose() {
		this.domNode.domNode.editContext = void 0;
		this.domNode.domNode.blur();
		this.domNode.domNode.remove();
		this._imeTextArea.domNode.remove();
		super.dispose();
	}
	setAriaOptions(options) {
		this._screenReaderSupport.setAriaOptions(options);
	}
	getLastRenderData() {
		return this._primarySelection.getPosition();
	}
	onBeforeRender(viewportData) {
		this._parentBounds = this._parent.getBoundingClientRect();
	}
	prepareRender(ctx) {
		if (this._editContextNeedsRefresh) this._updateEditContext();
		this._screenReaderSupport.prepareRender(ctx);
		this._updateSelectionAndControlBoundsData(ctx);
	}
	render(ctx) {
		this._screenReaderSupport.render(ctx);
		this._updateSelectionAndControlBounds();
	}
	onCursorStateChanged(e) {
		this._primarySelection = e.modelSelections[0] ?? new Selection$1(1, 1, 1, 1);
		this._screenReaderSupport.onCursorStateChanged(e);
		this._editContextNeedsRefresh = true;
		return true;
	}
	onConfigurationChanged(e) {
		this._screenReaderSupport.onConfigurationChanged(e);
		this._updateDomAttributes();
		return true;
	}
	onDecorationsChanged(e) {
		return true;
	}
	onFlushed(e) {
		return true;
	}
	onLinesChanged(e) {
		return true;
	}
	onLinesDeleted(e) {
		return true;
	}
	onLinesInserted(e) {
		return true;
	}
	onScrollChanged(e) {
		this._scrollLeft = e.scrollLeft;
		this._scrollTop = e.scrollTop;
		return true;
	}
	onZonesChanged(e) {
		return true;
	}
	handleWillPaste() {
		this.logService.trace("NativeEditContext#handleWillPaste");
		this._prepareScreenReaderForPaste();
	}
	_prepareScreenReaderForPaste() {
		this._screenReaderSupport.onWillPaste();
	}
	handleWillCopy() {
		this.logService.trace("NativeEditContext#handleWillCopy");
		this.logService.trace("NativeEditContext#isFocused : ", this.domNode.domNode === getActiveElement());
	}
	writeScreenReaderContent() {
		this._screenReaderSupport.writeScreenReaderContent();
	}
	isFocused() {
		return this._focusTracker.isFocused;
	}
	focus() {
		this._focusTracker.focus();
		this.refreshFocusState();
	}
	refreshFocusState() {
		this._focusTracker.refreshFocusState();
	}
	setEditContextOnDomNode() {
		const targetWindowId = getWindowId(getWindow(this.domNode.domNode));
		if (this._targetWindowId !== targetWindowId) {
			this.domNode.domNode.editContext = this._editContext;
			this._targetWindowId = targetWindowId;
		}
	}
	_onKeyUp(e) {
		inputLatency.onKeyUp();
		this._viewController.emitKeyUp(new StandardKeyboardEvent(e));
	}
	_onKeyDown(e) {
		inputLatency.onKeyDown();
		const standardKeyboardEvent = new StandardKeyboardEvent(e);
		if (standardKeyboardEvent.keyCode === 114) standardKeyboardEvent.stopPropagation();
		this._viewController.emitKeyDown(standardKeyboardEvent);
	}
	_updateDomAttributes() {
		const options = this._context.configuration.options;
		this.domNode.domNode.setAttribute("tabindex", String(options.get(140)));
	}
	_updateEditContext() {
		this._editContextNeedsRefresh = false;
		const editContextState = this._getNewEditContextState();
		if (!editContextState) return;
		const newText = editContextState.text ?? " ";
		if (newText !== this._previousEditContextText) {
			this._editContext.updateText(0, this._previousEditContextText.length, newText);
			this._previousEditContextText = newText;
		}
		if (editContextState.selectionStartOffset !== this._previousEditContextSelection.start || editContextState.selectionEndOffset !== this._previousEditContextSelection.endExclusive) this._editContext.updateSelection(editContextState.selectionStartOffset, editContextState.selectionEndOffset);
		this._editContextPrimarySelection = editContextState.editContextPrimarySelection;
		this._previousEditContextSelection = new OffsetRange(editContextState.selectionStartOffset, editContextState.selectionEndOffset);
	}
	_emitTypeEvent(viewController, e) {
		if (!this._editContext) return;
		const selectionEndOffset = this._previousEditContextSelection.endExclusive;
		const selectionStartOffset = this._previousEditContextSelection.start;
		this._previousEditContextSelection = new OffsetRange(e.selectionStart, e.selectionEnd);
		let replaceNextCharCnt = 0;
		let replacePrevCharCnt = 0;
		if (e.updateRangeEnd > selectionEndOffset) replaceNextCharCnt = e.updateRangeEnd - selectionEndOffset;
		if (e.updateRangeStart < selectionStartOffset) replacePrevCharCnt = selectionStartOffset - e.updateRangeStart;
		let text = "";
		if (selectionStartOffset < e.updateRangeStart) text += this._editContext.text.substring(selectionStartOffset, e.updateRangeStart);
		text += e.text;
		if (selectionEndOffset > e.updateRangeEnd) text += this._editContext.text.substring(e.updateRangeEnd, selectionEndOffset);
		let positionDelta = 0;
		if (e.selectionStart === e.selectionEnd && selectionStartOffset === selectionEndOffset) positionDelta = e.selectionStart - (e.updateRangeStart + e.text.length);
		const typeInput = {
			text,
			replacePrevCharCnt,
			replaceNextCharCnt,
			positionDelta
		};
		this._onType(viewController, typeInput);
	}
	_onType(viewController, typeInput) {
		if (typeInput.replacePrevCharCnt || typeInput.replaceNextCharCnt || typeInput.positionDelta) viewController.compositionType(typeInput.text, typeInput.replacePrevCharCnt, typeInput.replaceNextCharCnt, typeInput.positionDelta);
		else viewController.type(typeInput.text);
	}
	_getNewEditContextState() {
		const editContextPrimarySelection = this._primarySelection;
		const model = this._context.viewModel.model;
		if (!model.isValidRange(editContextPrimarySelection)) return;
		const primarySelectionStartLine = editContextPrimarySelection.startLineNumber;
		const primarySelectionEndLine = editContextPrimarySelection.endLineNumber;
		const endColumnOfEndLineNumber = model.getLineMaxColumn(primarySelectionEndLine);
		const rangeOfText = new Range$2(primarySelectionStartLine, 1, primarySelectionEndLine, endColumnOfEndLineNumber);
		const text = model.getValueInRange(rangeOfText, 0);
		return {
			text,
			selectionStartOffset: editContextPrimarySelection.startColumn - 1,
			selectionEndOffset: text.length + editContextPrimarySelection.endColumn - endColumnOfEndLineNumber,
			editContextPrimarySelection
		};
	}
	_editContextStartPosition() {
		return new Position$1(this._editContextPrimarySelection.startLineNumber, 1);
	}
	_handleTextFormatUpdate(e) {
		if (!this._editContext) return;
		const formats = e.getTextFormats();
		const editContextStartPosition = this._editContextStartPosition();
		const decorations = [];
		formats.forEach((f) => {
			const textModel = this._context.viewModel.model;
			const offsetOfEditContextText = textModel.getOffsetAt(editContextStartPosition);
			const startPositionOfDecoration = textModel.getPositionAt(offsetOfEditContextText + f.rangeStart);
			const endPositionOfDecoration = textModel.getPositionAt(offsetOfEditContextText + f.rangeEnd);
			const decorationRange = Range$2.fromPositions(startPositionOfDecoration, endPositionOfDecoration);
			const thickness = f.underlineThickness.toLowerCase();
			let decorationClassName = CompositionClassName.NONE;
			switch (thickness) {
				case "thin":
					decorationClassName = CompositionClassName.SECONDARY;
					break;
				case "thick": decorationClassName = CompositionClassName.PRIMARY;
			}
			decorations.push({
				range: decorationRange,
				options: {
					description: "textFormatDecoration",
					inlineClassName: decorationClassName
				}
			});
		});
		this._decorations = this._context.viewModel.model.deltaDecorations(this._decorations, decorations);
	}
	_updateSelectionAndControlBoundsData(ctx) {
		const viewSelection = this._context.viewModel.coordinatesConverter.convertModelRangeToViewRange(this._primarySelection);
		if (this._primarySelection.isEmpty()) {
			const linesVisibleRanges = ctx.visibleRangeForPosition(viewSelection.getStartPosition());
			this._linesVisibleRanges = linesVisibleRanges;
		} else this._linesVisibleRanges = null;
	}
	_updateSelectionAndControlBounds() {
		const contentLeft = this._context.configuration.options.get(166).contentLeft;
		const viewSelection = this._context.viewModel.coordinatesConverter.convertModelRangeToViewRange(this._primarySelection);
		const verticalOffsetStart = this._context.viewLayout.getVerticalOffsetForLineNumber(viewSelection.startLineNumber);
		const verticalOffsetEnd = this._context.viewLayout.getVerticalOffsetAfterLineNumber(viewSelection.endLineNumber);
		const parentBounds = this._parentBounds;
		const top = parentBounds.top + verticalOffsetStart - this._scrollTop;
		const height = verticalOffsetEnd - verticalOffsetStart;
		let left = parentBounds.left + contentLeft - this._scrollLeft;
		let width;
		if (this._primarySelection.isEmpty()) {
			if (this._linesVisibleRanges) left += this._linesVisibleRanges.left;
			width = 0;
		} else width = parentBounds.width - contentLeft;
		const selectionBounds = new DOMRect(left, top, width, height);
		this._editContext.updateSelectionBounds(selectionBounds);
		this._editContext.updateControlBounds(selectionBounds);
	}
	_updateCharacterBounds(e) {
		const options = this._context.configuration.options;
		const typicalHalfWidthCharacterWidth = options.get(59).typicalHalfwidthCharacterWidth;
		const contentLeft = options.get(166).contentLeft;
		const parentBounds = this._parentBounds;
		const characterBounds = [];
		const offsetTransformer = new PositionOffsetTransformer(this._editContext.text);
		for (let offset = e.rangeStart; offset < e.rangeEnd; offset++) {
			const editContextStartPosition = offsetTransformer.getPosition(offset);
			const textStartLineOffsetWithinEditor = this._editContextPrimarySelection.startLineNumber - 1;
			const characterStartPosition = new Position$1(textStartLineOffsetWithinEditor + editContextStartPosition.lineNumber, editContextStartPosition.column);
			const characterEndPosition = characterStartPosition.delta(0, 1);
			const characterModelRange = Range$2.fromPositions(characterStartPosition, characterEndPosition);
			const characterViewRange = this._context.viewModel.coordinatesConverter.convertModelRangeToViewRange(characterModelRange);
			const characterLinesVisibleRanges = this._visibleRangeProvider.linesVisibleRangesForRange(characterViewRange, true) ?? [];
			const lineNumber = characterViewRange.startLineNumber;
			const characterVerticalOffset = this._context.viewLayout.getVerticalOffsetForLineNumber(lineNumber);
			const top = parentBounds.top + characterVerticalOffset - this._scrollTop;
			let left = 0;
			let width = typicalHalfWidthCharacterWidth;
			if (characterLinesVisibleRanges.length > 0) for (const visibleRange of characterLinesVisibleRanges[0].ranges) {
				left = visibleRange.left;
				width = visibleRange.width;
				break;
			}
			const lineHeight = this._context.viewLayout.getLineHeightForLineNumber(lineNumber);
			characterBounds.push(new DOMRect(parentBounds.left + contentLeft + left - this._scrollLeft, top, width, lineHeight));
		}
		this._editContext.updateCharacterBounds(e.rangeStart, characterBounds);
	}
};
NativeEditContext = __decorate$61([__param$56(5, IInstantiationService), __param$56(6, ILogService)], NativeEditContext);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/rulersGpu/rulersGpu.js
/**
* Rulers are vertical lines that appear at certain columns in the editor. There can be >= 0 rulers
* at a time.
*/
var RulersGpu = class extends ViewPart {
	constructor(context, _viewGpuContext) {
		super(context);
		this._viewGpuContext = _viewGpuContext;
		this._gpuShapes = [];
		this._register(autorun((reader) => this._updateEntries(reader)));
	}
	onConfigurationChanged(e) {
		this._updateEntries(void 0);
		return true;
	}
	prepareRender(ctx) {}
	render(ctx) {}
	_updateEntries(reader) {
		const options = this._context.configuration.options;
		const rulers = options.get(116);
		const typicalHalfwidthCharacterWidth = options.get(59).typicalHalfwidthCharacterWidth;
		const devicePixelRatio = this._viewGpuContext.devicePixelRatio.read(reader);
		for (let i = 0, len = rulers.length; i < len; i++) {
			const ruler = rulers[i];
			const shape = this._gpuShapes[i];
			const color = ruler.color ? Color.fromHex(ruler.color) : this._context.theme.getColor(editorRuler) ?? Color.white;
			const rulerData = [
				ruler.column * typicalHalfwidthCharacterWidth * devicePixelRatio,
				0,
				Math.max(1, Math.ceil(devicePixelRatio)),
				Number.MAX_SAFE_INTEGER,
				color.rgba.r / 255,
				color.rgba.g / 255,
				color.rgba.b / 255,
				color.rgba.a
			];
			if (!shape) this._gpuShapes[i] = this._viewGpuContext.rectangleRenderer.register(...rulerData);
			else shape.setRaw(rulerData);
		}
		while (this._gpuShapes.length > rulers.length) this._gpuShapes.splice(-1, 1)[0].dispose();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/viewParts/gpuMark/gpuMark.js
/**
* A mark on lines to make identification of GPU-rendered lines vs DOM easier.
*/
var GpuMarkOverlay = class GpuMarkOverlay extends DynamicViewOverlay {
	static {
		this.CLASS_NAME = "gpu-mark";
	}
	constructor(context, _viewGpuContext) {
		super();
		this._viewGpuContext = _viewGpuContext;
		this._context = context;
		this._renderResult = null;
		this._context.addEventHandler(this);
	}
	dispose() {
		this._context.removeEventHandler(this);
		this._renderResult = null;
		super.dispose();
	}
	onConfigurationChanged(e) {
		return true;
	}
	onCursorStateChanged(e) {
		return true;
	}
	onFlushed(e) {
		return true;
	}
	onLinesChanged(e) {
		return true;
	}
	onLinesDeleted(e) {
		return true;
	}
	onLinesInserted(e) {
		return true;
	}
	onScrollChanged(e) {
		return e.scrollTopChanged;
	}
	onZonesChanged(e) {
		return true;
	}
	onDecorationsChanged(e) {
		return true;
	}
	prepareRender(ctx) {
		const visibleStartLineNumber = ctx.visibleRange.startLineNumber;
		const visibleEndLineNumber = ctx.visibleRange.endLineNumber;
		const viewportData = ctx.viewportData;
		const options = new ViewLineOptions(this._context.configuration, this._context.theme.type);
		const output = [];
		for (let lineNumber = visibleStartLineNumber; lineNumber <= visibleEndLineNumber; lineNumber++) {
			const lineIndex = lineNumber - visibleStartLineNumber;
			const cannotRenderReasons = this._viewGpuContext.canRenderDetailed(options, viewportData, lineNumber);
			output[lineIndex] = cannotRenderReasons.length ? `<div class="${GpuMarkOverlay.CLASS_NAME}" title="Cannot render on GPU: ${cannotRenderReasons.join(", ")}"></div>` : "";
		}
		this._renderResult = output;
	}
	render(startLineNumber, lineNumber) {
		if (!this._renderResult) return "";
		const lineIndex = lineNumber - startLineNumber;
		if (lineIndex < 0 || lineIndex >= this._renderResult.length) return "";
		return this._renderResult[lineIndex];
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/userInteraction/browser/userInteractionService.js
var IUserInteractionService = createDecorator("userInteractionService");
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/view.js
var __decorate$60 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$55 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var View$1 = class View extends ViewEventHandler {
	constructor(editorContainer, ownerID, commandDelegate, configuration, colorTheme, model, userInputEvents, overflowWidgetsDomNode, _instantiationService, _userInteractionService) {
		super();
		this._instantiationService = _instantiationService;
		this._userInteractionService = _userInteractionService;
		this._editContextClipboardListeners = new DisposableStore();
		this._onWillCopy = this._register(new Emitter$1());
		this.onWillCopy = this._onWillCopy.event;
		this._onWillCut = this._register(new Emitter$1());
		this.onWillCut = this._onWillCut.event;
		this._onWillPaste = this._register(new Emitter$1());
		this.onWillPaste = this._onWillPaste.event;
		this._shouldRecomputeGlyphMarginLanes = false;
		this._ownerID = ownerID;
		this._widgetFocusTracker = this._register(new CodeEditorWidgetFocusTracker(editorContainer, overflowWidgetsDomNode, this._userInteractionService));
		this._register(this._widgetFocusTracker.onChange(() => {
			this._context.viewModel.setHasWidgetFocus(this._widgetFocusTracker.hasFocus());
		}));
		this._selections = [new Selection$1(1, 1, 1, 1)];
		this._renderAnimationFrame = null;
		this._overflowGuardContainer = createFastDomNode(document.createElement("div"));
		PartFingerprints.write(this._overflowGuardContainer, 3);
		this._overflowGuardContainer.setClassName("overflow-guard");
		this._viewController = new ViewController(configuration, model, userInputEvents, commandDelegate);
		this._context = new ViewContext(configuration, colorTheme, model);
		this._context.addEventHandler(this);
		this._viewParts = [];
		this._editContextEnabled = this._context.configuration.options.get(171);
		this._accessibilitySupport = this._context.configuration.options.get(2);
		this._editContext = this._instantiateEditContext();
		this._connectEditContextClipboardEvents();
		this._viewParts.push(this._editContext);
		this._linesContent = createFastDomNode(document.createElement("div"));
		this._linesContent.setClassName("lines-content monaco-editor-background");
		this._linesContent.setPosition("absolute");
		this.domNode = createFastDomNode(document.createElement("div"));
		this.domNode.setClassName(this._getEditorClassName());
		this.domNode.setAttribute("role", "code");
		if (this._context.configuration.options.get(46) === "on") this._viewGpuContext = this._instantiationService.createInstance(ViewGpuContext, this._context);
		this._scrollbar = new EditorScrollbar(this._context, this._linesContent, this.domNode, this._overflowGuardContainer);
		this._viewParts.push(this._scrollbar);
		this._viewLines = new ViewLines(this._context, this._viewGpuContext, this._linesContent);
		if (this._viewGpuContext) this._viewLinesGpu = this._instantiationService.createInstance(ViewLinesGpu, this._context, this._viewGpuContext);
		this._viewZones = new ViewZones(this._context);
		this._viewParts.push(this._viewZones);
		const decorationsOverviewRuler = new DecorationsOverviewRuler(this._context);
		this._viewParts.push(decorationsOverviewRuler);
		const scrollDecoration = new ScrollDecorationViewPart(this._context);
		this._viewParts.push(scrollDecoration);
		const contentViewOverlays = new ContentViewOverlays(this._context);
		this._viewParts.push(contentViewOverlays);
		contentViewOverlays.addDynamicOverlay(new CurrentLineHighlightOverlay(this._context));
		contentViewOverlays.addDynamicOverlay(new SelectionsOverlay(this._context));
		contentViewOverlays.addDynamicOverlay(new IndentGuidesOverlay(this._context));
		contentViewOverlays.addDynamicOverlay(new DecorationsOverlay(this._context));
		contentViewOverlays.addDynamicOverlay(new WhitespaceOverlay(this._context));
		contentViewOverlays.addDynamicOverlay(new WordWrapIndicatorOverlay(this._context));
		const marginViewOverlays = new MarginViewOverlays(this._context);
		this._viewParts.push(marginViewOverlays);
		marginViewOverlays.addDynamicOverlay(new CurrentLineMarginHighlightOverlay(this._context));
		marginViewOverlays.addDynamicOverlay(new MarginViewLineDecorationsOverlay(this._context));
		marginViewOverlays.addDynamicOverlay(new LinesDecorationsOverlay(this._context));
		marginViewOverlays.addDynamicOverlay(new LineNumbersOverlay(this._context));
		if (this._viewGpuContext) marginViewOverlays.addDynamicOverlay(new GpuMarkOverlay(this._context, this._viewGpuContext));
		this._glyphMarginWidgets = new GlyphMarginWidgets(this._context);
		this._viewParts.push(this._glyphMarginWidgets);
		const margin = new Margin(this._context);
		margin.getDomNode().appendChild(this._viewZones.marginDomNode);
		margin.getDomNode().appendChild(marginViewOverlays.getDomNode());
		margin.getDomNode().appendChild(this._glyphMarginWidgets.domNode);
		this._viewParts.push(margin);
		this._contentWidgets = new ViewContentWidgets(this._context, this.domNode);
		this._viewParts.push(this._contentWidgets);
		this._viewCursors = new ViewCursors(this._context);
		this._viewParts.push(this._viewCursors);
		this._overlayWidgets = new ViewOverlayWidgets(this._context, this.domNode);
		this._viewParts.push(this._overlayWidgets);
		const rulers = this._viewGpuContext ? new RulersGpu(this._context, this._viewGpuContext) : new Rulers(this._context);
		this._viewParts.push(rulers);
		const blockOutline = new BlockDecorations(this._context);
		this._viewParts.push(blockOutline);
		const minimap = new Minimap(this._context);
		this._viewParts.push(minimap);
		if (decorationsOverviewRuler) {
			const overviewRulerData = this._scrollbar.getOverviewRulerLayoutInfo();
			overviewRulerData.parent.insertBefore(decorationsOverviewRuler.getDomNode(), overviewRulerData.insertBefore);
		}
		this._linesContent.appendChild(contentViewOverlays.getDomNode());
		if ("domNode" in rulers) this._linesContent.appendChild(rulers.domNode);
		this._linesContent.appendChild(this._viewZones.domNode);
		this._linesContent.appendChild(this._viewLines.getDomNode());
		this._linesContent.appendChild(this._contentWidgets.domNode);
		this._linesContent.appendChild(this._viewCursors.getDomNode());
		this._overflowGuardContainer.appendChild(margin.getDomNode());
		this._overflowGuardContainer.appendChild(this._scrollbar.getDomNode());
		if (this._viewGpuContext) this._overflowGuardContainer.appendChild(this._viewGpuContext.canvas);
		this._overflowGuardContainer.appendChild(scrollDecoration.getDomNode());
		this._overflowGuardContainer.appendChild(this._overlayWidgets.getDomNode());
		this._overflowGuardContainer.appendChild(minimap.getDomNode());
		this._overflowGuardContainer.appendChild(blockOutline.domNode);
		this.domNode.appendChild(this._overflowGuardContainer);
		if (overflowWidgetsDomNode) {
			overflowWidgetsDomNode.appendChild(this._contentWidgets.overflowingContentWidgetsDomNode.domNode);
			overflowWidgetsDomNode.appendChild(this._overlayWidgets.overflowingOverlayWidgetsDomNode.domNode);
		} else {
			this.domNode.appendChild(this._contentWidgets.overflowingContentWidgetsDomNode);
			this.domNode.appendChild(this._overlayWidgets.overflowingOverlayWidgetsDomNode);
		}
		this._applyLayout();
		this._pointerHandler = this._register(new PointerHandler(this._context, this._viewController, this._createPointerHandlerHelper()));
	}
	_instantiateEditContext() {
		if (this._context.configuration.options.get(171)) return this._instantiationService.createInstance(NativeEditContext, this._ownerID, this._context, this._overflowGuardContainer, this._viewController, this._createTextAreaHandlerHelper());
		else return this._instantiationService.createInstance(TextAreaEditContext, this._ownerID, this._context, this._overflowGuardContainer, this._viewController, this._createTextAreaHandlerHelper());
	}
	_updateEditContext() {
		const editContextEnabled = this._context.configuration.options.get(171);
		const accessibilitySupport = this._context.configuration.options.get(2);
		if (this._editContextEnabled === editContextEnabled && this._accessibilitySupport === accessibilitySupport) return;
		this._editContextEnabled = editContextEnabled;
		this._accessibilitySupport = accessibilitySupport;
		const isEditContextFocused = this._editContext.isFocused();
		const indexOfEditContext = this._viewParts.indexOf(this._editContext);
		this._editContext.dispose();
		this._editContext = this._instantiateEditContext();
		this._connectEditContextClipboardEvents();
		if (isEditContextFocused) this._editContext.focus();
		if (indexOfEditContext !== -1) this._viewParts.splice(indexOfEditContext, 1, this._editContext);
	}
	_connectEditContextClipboardEvents() {
		this._editContextClipboardListeners.clear();
		this._editContextClipboardListeners.add(this._editContext.onWillCopy((e) => this._onWillCopy.fire(e)));
		this._editContextClipboardListeners.add(this._editContext.onWillCut((e) => this._onWillCut.fire(e)));
		this._editContextClipboardListeners.add(this._editContext.onWillPaste((e) => this._onWillPaste.fire(e)));
	}
	_computeGlyphMarginLanes() {
		const model = this._context.viewModel.model;
		const laneModel = this._context.viewModel.glyphLanes;
		let glyphs = [];
		let maxLineNumber = 0;
		glyphs = glyphs.concat(model.getAllMarginDecorations().map((decoration) => {
			const lane = decoration.options.glyphMargin?.position ?? GlyphMarginLane.Center;
			maxLineNumber = Math.max(maxLineNumber, decoration.range.endLineNumber);
			return {
				range: decoration.range,
				lane,
				persist: decoration.options.glyphMargin?.persistLane
			};
		}));
		glyphs = glyphs.concat(this._glyphMarginWidgets.getWidgets().map((widget) => {
			const range = model.validateRange(widget.preference.range);
			maxLineNumber = Math.max(maxLineNumber, range.endLineNumber);
			return {
				range,
				lane: widget.preference.lane
			};
		}));
		glyphs.sort((a, b) => Range$2.compareRangesUsingStarts(a.range, b.range));
		laneModel.reset(maxLineNumber);
		for (const glyph of glyphs) laneModel.push(glyph.lane, glyph.range, glyph.persist);
		return laneModel;
	}
	_createPointerHandlerHelper() {
		return {
			viewDomNode: this.domNode.domNode,
			linesContentDomNode: this._linesContent.domNode,
			viewLinesDomNode: this._viewLines.getDomNode().domNode,
			viewLinesGpu: this._viewLinesGpu,
			focusTextArea: () => {
				this.focus();
			},
			dispatchTextAreaEvent: (event) => {
				this._editContext.domNode.domNode.dispatchEvent(event);
			},
			getLastRenderData: () => {
				return new PointerHandlerLastRenderData(this._viewCursors.getLastRenderData() || [], this._editContext.getLastRenderData());
			},
			renderNow: () => {
				this.render(true, false);
			},
			shouldSuppressMouseDownOnViewZone: (viewZoneId) => {
				return this._viewZones.shouldSuppressMouseDownOnViewZone(viewZoneId);
			},
			shouldSuppressMouseDownOnWidget: (widgetId) => {
				return this._contentWidgets.shouldSuppressMouseDownOnWidget(widgetId);
			},
			getPositionFromDOMInfo: (spanNode, offset) => {
				this._flushAccumulatedAndRenderNow();
				return this._viewLines.getPositionFromDOMInfo(spanNode, offset);
			},
			visibleRangeForPosition: (lineNumber, column) => {
				this._flushAccumulatedAndRenderNow();
				const position = new Position$1(lineNumber, column);
				return this._viewLines.visibleRangeForPosition(position) ?? this._viewLinesGpu?.visibleRangeForPosition(position) ?? null;
			},
			getLineWidth: (lineNumber) => {
				this._flushAccumulatedAndRenderNow();
				if (this._viewLinesGpu) {
					const result = this._viewLinesGpu.getLineWidth(lineNumber);
					if (result !== void 0) return result;
				}
				return this._viewLines.getLineWidth(lineNumber);
			}
		};
	}
	_createTextAreaHandlerHelper() {
		return {
			visibleRangeForPosition: (position) => {
				this._flushAccumulatedAndRenderNow();
				return this._viewLines.visibleRangeForPosition(position);
			},
			linesVisibleRangesForRange: (range, includeNewLines) => {
				this._flushAccumulatedAndRenderNow();
				return this._viewLines.linesVisibleRangesForRange(range, includeNewLines);
			}
		};
	}
	_applyLayout() {
		const layoutInfo = this._context.configuration.options.get(166);
		this.domNode.setWidth(layoutInfo.width);
		this.domNode.setHeight(layoutInfo.height);
		this._overflowGuardContainer.setWidth(layoutInfo.width);
		this._overflowGuardContainer.setHeight(layoutInfo.height);
		this._linesContent.setWidth(16777216);
		this._linesContent.setHeight(16777216);
	}
	_getEditorClassName() {
		const focused = this._editContext.isFocused() ? " focused" : "";
		return this._context.configuration.options.get(163) + " " + getThemeTypeSelector(this._context.theme.type) + focused;
	}
	handleEvents(events) {
		super.handleEvents(events);
		this._scheduleRender();
	}
	onConfigurationChanged(e) {
		this.domNode.setClassName(this._getEditorClassName());
		this._updateEditContext();
		this._applyLayout();
		return false;
	}
	onCursorStateChanged(e) {
		this._selections = e.selections;
		return false;
	}
	onDecorationsChanged(e) {
		if (e.affectsGlyphMargin) this._shouldRecomputeGlyphMarginLanes = true;
		return false;
	}
	onFocusChanged(e) {
		this.domNode.setClassName(this._getEditorClassName());
		return false;
	}
	onThemeChanged(e) {
		this._context.theme.update(e.theme);
		this.domNode.setClassName(this._getEditorClassName());
		return false;
	}
	dispose() {
		if (this._renderAnimationFrame !== null) {
			this._renderAnimationFrame.dispose();
			this._renderAnimationFrame = null;
		}
		this._editContextClipboardListeners.dispose();
		this._contentWidgets.overflowingContentWidgetsDomNode.domNode.remove();
		this._overlayWidgets.overflowingOverlayWidgetsDomNode.domNode.remove();
		this._context.removeEventHandler(this);
		this._viewGpuContext?.dispose();
		this._viewLines.dispose();
		this._viewLinesGpu?.dispose();
		for (const viewPart of this._viewParts) viewPart.dispose();
		super.dispose();
	}
	_scheduleRender() {
		if (this._store.isDisposed) throw new BugIndicatingError();
		if (this._renderAnimationFrame === null) {
			if (this._editContext instanceof NativeEditContext) this._editContext.setEditContextOnDomNode();
			const rendering = this._createCoordinatedRendering();
			this._renderAnimationFrame = EditorRenderingCoordinator.INSTANCE.scheduleCoordinatedRendering({
				window: getWindow(this.domNode?.domNode),
				prepareRenderText: () => {
					if (this._store.isDisposed) throw new BugIndicatingError();
					try {
						return rendering.prepareRenderText();
					} finally {
						this._renderAnimationFrame = null;
					}
				},
				renderText: (viewportData) => {
					if (this._store.isDisposed) throw new BugIndicatingError();
					return rendering.renderText(viewportData);
				},
				prepareRender: (viewParts, ctx) => {
					if (this._store.isDisposed) throw new BugIndicatingError();
					return rendering.prepareRender(viewParts, ctx);
				},
				render: (viewParts, ctx) => {
					if (this._store.isDisposed) throw new BugIndicatingError();
					return rendering.render(viewParts, ctx);
				}
			});
		}
	}
	_flushAccumulatedAndRenderNow() {
		const rendering = this._createCoordinatedRendering();
		const viewportData = safeInvokeNoArg(() => rendering.prepareRenderText());
		if (!viewportData) return;
		const data = safeInvokeNoArg(() => rendering.renderText(viewportData));
		if (!data) return;
		const [viewParts, ctx] = data;
		safeInvokeNoArg(() => rendering.prepareRender(viewParts, ctx));
		safeInvokeNoArg(() => rendering.render(viewParts, ctx));
	}
	_getViewPartsToRender() {
		const result = [];
		let resultLen = 0;
		for (const viewPart of this._viewParts) if (viewPart.shouldRender()) result[resultLen++] = viewPart;
		return result;
	}
	_createCoordinatedRendering() {
		return {
			prepareRenderText: () => {
				if (this._shouldRecomputeGlyphMarginLanes) {
					this._shouldRecomputeGlyphMarginLanes = false;
					const model = this._computeGlyphMarginLanes();
					this._context.configuration.setGlyphMarginDecorationLaneCount(model.requiredLanes);
				}
				inputLatency.onRenderStart();
				if (!this.domNode.domNode.isConnected) return null;
				const viewPartsToRender = this._getViewPartsToRender();
				if (!this._viewLines.shouldRender() && viewPartsToRender.length === 0) return null;
				const partialViewportData = this._context.viewLayout.getLinesViewportData();
				this._context.viewModel.setViewport(partialViewportData.startLineNumber, partialViewportData.endLineNumber, partialViewportData.centeredLineNumber);
				const viewportData = new ViewportData(this._selections, partialViewportData, this._context.viewLayout.getWhitespaceViewportData(), this._context.viewModel);
				for (const viewPart of this._viewParts) if (viewPart.shouldRender()) viewPart.onBeforeRender(viewportData);
				return viewportData;
			},
			renderText: (viewportData) => {
				if (this._viewLines.shouldRender()) {
					this._viewLines.renderText(viewportData);
					this._viewLines.onDidRender();
				}
				if (this._viewLinesGpu?.shouldRender()) {
					this._viewLinesGpu.renderText(viewportData);
					this._viewLinesGpu.onDidRender();
				}
				return [this._getViewPartsToRender(), new RenderingContext(this._context.viewLayout, viewportData, this._viewLines, this._viewLinesGpu)];
			},
			prepareRender: (viewPartsToRender, ctx) => {
				for (const viewPart of viewPartsToRender) viewPart.prepareRender(ctx);
			},
			render: (viewPartsToRender, ctx) => {
				for (const viewPart of viewPartsToRender) {
					viewPart.render(ctx);
					viewPart.onDidRender();
				}
			}
		};
	}
	delegateVerticalScrollbarPointerDown(browserEvent) {
		this._scrollbar.delegateVerticalScrollbarPointerDown(browserEvent);
	}
	delegateScrollFromMouseWheelEvent(browserEvent) {
		this._scrollbar.delegateScrollFromMouseWheelEvent(browserEvent);
	}
	restoreState(scrollPosition) {
		this._context.viewModel.viewLayout.setScrollPosition({
			scrollTop: scrollPosition.scrollTop,
			scrollLeft: scrollPosition.scrollLeft
		}, 1);
		this._context.viewModel.visibleLinesStabilized();
	}
	getOffsetForColumn(modelLineNumber, modelColumn) {
		const modelPosition = this._context.viewModel.model.validatePosition({
			lineNumber: modelLineNumber,
			column: modelColumn
		});
		const viewPosition = this._context.viewModel.coordinatesConverter.convertModelPositionToViewPosition(modelPosition);
		this._flushAccumulatedAndRenderNow();
		const visibleRange = this._viewLines.visibleRangeForPosition(new Position$1(viewPosition.lineNumber, viewPosition.column));
		if (!visibleRange) return -1;
		return visibleRange.left;
	}
	getLineWidth(modelLineNumber) {
		const model = this._context.viewModel.model;
		const viewLine = this._context.viewModel.coordinatesConverter.convertModelPositionToViewPosition(new Position$1(modelLineNumber, model.getLineMaxColumn(modelLineNumber))).lineNumber;
		this._flushAccumulatedAndRenderNow();
		return this._viewLines.getLineWidth(viewLine);
	}
	resetLineWidthCaches() {
		this._viewLines.resetLineWidthCaches();
	}
	getTargetAtClientPoint(clientX, clientY) {
		const mouseTarget = this._pointerHandler.getTargetAtClientPoint(clientX, clientY);
		if (!mouseTarget) return null;
		return ViewUserInputEvents.convertViewToModelMouseTarget(mouseTarget, this._context.viewModel.coordinatesConverter);
	}
	createOverviewRuler(cssClassName) {
		return new OverviewRuler(this._context, cssClassName);
	}
	change(callback) {
		this._viewZones.changeViewZones(callback);
		this._scheduleRender();
	}
	render(now, everything) {
		if (everything) {
			this._viewLines.forceShouldRender();
			for (const viewPart of this._viewParts) viewPart.forceShouldRender();
		}
		if (now) this._flushAccumulatedAndRenderNow();
		else this._scheduleRender();
	}
	writeScreenReaderContent(reason) {
		this._editContext.writeScreenReaderContent(reason);
	}
	focus() {
		this._editContext.focus();
	}
	isFocused() {
		return this._editContext.isFocused();
	}
	isWidgetFocused() {
		return this._widgetFocusTracker.hasFocus();
	}
	setAriaOptions(options) {
		this._editContext.setAriaOptions(options);
	}
	addContentWidget(widgetData) {
		this._contentWidgets.addWidget(widgetData.widget);
		this.layoutContentWidget(widgetData);
		this._scheduleRender();
	}
	layoutContentWidget(widgetData) {
		this._contentWidgets.setWidgetPosition(widgetData.widget, widgetData.position?.position ?? null, widgetData.position?.secondaryPosition ?? null, widgetData.position?.preference ?? null, widgetData.position?.positionAffinity ?? null);
		if (this._contentWidgets.shouldRender()) this._scheduleRender();
	}
	removeContentWidget(widgetData) {
		this._contentWidgets.removeWidget(widgetData.widget);
		this._scheduleRender();
	}
	addOverlayWidget(widgetData) {
		this._overlayWidgets.addWidget(widgetData.widget);
		this.layoutOverlayWidget(widgetData);
		this._scheduleRender();
	}
	layoutOverlayWidget(widgetData) {
		if (this._overlayWidgets.setWidgetPosition(widgetData.widget, widgetData.position)) this._scheduleRender();
	}
	removeOverlayWidget(widgetData) {
		this._overlayWidgets.removeWidget(widgetData.widget);
		this._scheduleRender();
	}
	addGlyphMarginWidget(widgetData) {
		this._glyphMarginWidgets.addWidget(widgetData.widget);
		this._shouldRecomputeGlyphMarginLanes = true;
		this._scheduleRender();
	}
	layoutGlyphMarginWidget(widgetData) {
		const newPreference = widgetData.position;
		if (this._glyphMarginWidgets.setWidgetPosition(widgetData.widget, newPreference)) {
			this._shouldRecomputeGlyphMarginLanes = true;
			this._scheduleRender();
		}
	}
	removeGlyphMarginWidget(widgetData) {
		this._glyphMarginWidgets.removeWidget(widgetData.widget);
		this._shouldRecomputeGlyphMarginLanes = true;
		this._scheduleRender();
	}
};
View$1 = __decorate$60([__param$55(8, IInstantiationService), __param$55(9, IUserInteractionService)], View$1);
function safeInvokeNoArg(func) {
	try {
		return func();
	} catch (e) {
		onUnexpectedError(e);
		return null;
	}
}
var EditorRenderingCoordinator = class EditorRenderingCoordinator {
	static {
		this.INSTANCE = new EditorRenderingCoordinator();
	}
	constructor() {
		this._coordinatedRenderings = [];
		this._animationFrameRunners = /* @__PURE__ */ new Map();
	}
	scheduleCoordinatedRendering(rendering) {
		this._coordinatedRenderings.push(rendering);
		this._scheduleRender(rendering.window);
		return { dispose: () => {
			const renderingIndex = this._coordinatedRenderings.indexOf(rendering);
			if (renderingIndex === -1) return;
			this._coordinatedRenderings.splice(renderingIndex, 1);
			if (this._coordinatedRenderings.length === 0) {
				for (const [_, disposable] of this._animationFrameRunners) disposable.dispose();
				this._animationFrameRunners.clear();
			}
		} };
	}
	_scheduleRender(window) {
		if (!this._animationFrameRunners.has(window)) {
			const runner = () => {
				this._animationFrameRunners.delete(window);
				this._onRenderScheduled();
			};
			this._animationFrameRunners.set(window, runAtThisOrScheduleAtNextAnimationFrame(window, runner, 100));
		}
	}
	_onRenderScheduled() {
		const coordinatedRenderings = this._coordinatedRenderings.slice(0);
		this._coordinatedRenderings = [];
		const viewportDatas = [];
		for (let i = 0, len = coordinatedRenderings.length; i < len; i++) {
			const rendering = coordinatedRenderings[i];
			viewportDatas[i] = safeInvokeNoArg(() => rendering.prepareRenderText());
		}
		const datas = [];
		for (let i = 0, len = coordinatedRenderings.length; i < len; i++) {
			const rendering = coordinatedRenderings[i];
			const viewportData = viewportDatas[i];
			if (!viewportData) {
				datas[i] = null;
				continue;
			}
			datas[i] = safeInvokeNoArg(() => rendering.renderText(viewportData));
		}
		for (let i = 0, len = coordinatedRenderings.length; i < len; i++) {
			const rendering = coordinatedRenderings[i];
			const data = datas[i];
			if (!data) continue;
			const [viewParts, ctx] = data;
			safeInvokeNoArg(() => rendering.prepareRender(viewParts, ctx));
		}
		for (let i = 0, len = coordinatedRenderings.length; i < len; i++) {
			const rendering = coordinatedRenderings[i];
			const data = datas[i];
			if (!data) continue;
			const [viewParts, ctx] = data;
			safeInvokeNoArg(() => rendering.render(viewParts, ctx));
		}
	}
};
var CodeEditorWidgetFocusTracker = class extends Disposable {
	constructor(domElement, overflowWidgetsDomNode, userInteractionService) {
		super();
		this._onChange = this._register(new Emitter$1());
		this.onChange = this._onChange.event;
		this._hadFocus = void 0;
		this._hasDomElementFocus = false;
		this._domFocusTracker = this._register(userInteractionService.createDomFocusTracker(domElement));
		this._overflowWidgetsDomNodeHasFocus = false;
		this._register(this._domFocusTracker.onDidFocus(() => {
			this._hasDomElementFocus = true;
			this._update();
		}));
		this._register(this._domFocusTracker.onDidBlur(() => {
			this._hasDomElementFocus = false;
			this._update();
		}));
		if (overflowWidgetsDomNode) {
			this._overflowWidgetsDomNode = this._register(userInteractionService.createDomFocusTracker(overflowWidgetsDomNode));
			this._register(this._overflowWidgetsDomNode.onDidFocus(() => {
				this._overflowWidgetsDomNodeHasFocus = true;
				this._update();
			}));
			this._register(this._overflowWidgetsDomNode.onDidBlur(() => {
				this._overflowWidgetsDomNodeHasFocus = false;
				this._update();
			}));
		}
	}
	_update() {
		const focused = this._hasDomElementFocus || this._overflowWidgetsDomNodeHasFocus;
		if (this._hadFocus !== focused) {
			this._hadFocus = focused;
			this._onChange.fire(void 0);
		}
	}
	hasFocus() {
		return this._hadFocus ?? false;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/modelLineProjectionData.js
/**
* *input*:
* ```
* xxxxxxxxxxxxxxxxxxxxxxxxxxx
* ```
*
* -> Applying injections `[i...i]`, *inputWithInjections*:
* ```
* xxxxxx[iiiiiiiiii]xxxxxxxxxxxxxxxxx[ii]xxxx
* ```
*
* -> breaking at offsets `|` in `xxxxxx[iiiiiii|iii]xxxxxxxxxxx|xxxxxx[ii]xxxx|`:
* ```
* xxxxxx[iiiiiii
* iii]xxxxxxxxxxx
* xxxxxx[ii]xxxx
* ```
*
* -> applying wrappedTextIndentLength, *output*:
* ```
* xxxxxx[iiiiiii
*    iii]xxxxxxxxxxx
*    xxxxxx[ii]xxxx
* ```
*/
var ModelLineProjectionData = class {
	constructor(injectionOffsets, injectionOptions, breakOffsets, breakOffsetsVisibleColumn, wrappedTextIndentLength) {
		this.injectionOffsets = injectionOffsets;
		this.injectionOptions = injectionOptions;
		this.breakOffsets = breakOffsets;
		this.breakOffsetsVisibleColumn = breakOffsetsVisibleColumn;
		this.wrappedTextIndentLength = wrappedTextIndentLength;
	}
	getOutputLineCount() {
		return this.breakOffsets.length;
	}
	getMinOutputOffset(outputLineIndex) {
		if (outputLineIndex > 0) return this.wrappedTextIndentLength;
		return 0;
	}
	getLineLength(outputLineIndex) {
		const startOffset = outputLineIndex > 0 ? this.breakOffsets[outputLineIndex - 1] : 0;
		let lineLength = this.breakOffsets[outputLineIndex] - startOffset;
		if (outputLineIndex > 0) lineLength += this.wrappedTextIndentLength;
		return lineLength;
	}
	getMaxOutputOffset(outputLineIndex) {
		return this.getLineLength(outputLineIndex);
	}
	translateToInputOffset(outputLineIndex, outputOffset) {
		if (outputLineIndex > 0) outputOffset = Math.max(0, outputOffset - this.wrappedTextIndentLength);
		let offsetInInput = outputLineIndex === 0 ? outputOffset : this.breakOffsets[outputLineIndex - 1] + outputOffset;
		if (this.injectionOffsets !== null) for (let i = 0; i < this.injectionOffsets.length; i++) if (offsetInInput > this.injectionOffsets[i]) {
			if (offsetInInput < this.injectionOffsets[i] + this.injectionOptions[i].content.length) offsetInInput = this.injectionOffsets[i];
			else offsetInInput -= this.injectionOptions[i].content.length;
		} else break;
		return offsetInInput;
	}
	translateToOutputPosition(inputOffset, affinity = 2) {
		let inputOffsetInInputWithInjection = inputOffset;
		if (this.injectionOffsets !== null) for (let i = 0; i < this.injectionOffsets.length; i++) {
			if (inputOffset < this.injectionOffsets[i]) break;
			if (affinity !== 1 && inputOffset === this.injectionOffsets[i]) break;
			inputOffsetInInputWithInjection += this.injectionOptions[i].content.length;
		}
		return this.offsetInInputWithInjectionsToOutputPosition(inputOffsetInInputWithInjection, affinity);
	}
	offsetInInputWithInjectionsToOutputPosition(offsetInInputWithInjections, affinity = 2) {
		let low = 0;
		let high = this.breakOffsets.length - 1;
		let mid = 0;
		let midStart = 0;
		while (low <= high) {
			mid = low + (high - low) / 2 | 0;
			const midStop = this.breakOffsets[mid];
			midStart = mid > 0 ? this.breakOffsets[mid - 1] : 0;
			if (affinity === 0) {
				if (offsetInInputWithInjections <= midStart) high = mid - 1;
				else if (offsetInInputWithInjections > midStop) low = mid + 1;
				else break;
			} else if (offsetInInputWithInjections < midStart) high = mid - 1;
			else if (offsetInInputWithInjections >= midStop) low = mid + 1;
			else break;
		}
		let outputOffset = offsetInInputWithInjections - midStart;
		if (mid > 0) outputOffset += this.wrappedTextIndentLength;
		return new OutputPosition(mid, outputOffset);
	}
	normalizeOutputPosition(outputLineIndex, outputOffset, affinity) {
		if (this.injectionOffsets !== null) {
			const offsetInInputWithInjections = this.outputPositionToOffsetInInputWithInjections(outputLineIndex, outputOffset);
			const normalizedOffsetInUnwrappedLine = this.normalizeOffsetInInputWithInjectionsAroundInjections(offsetInInputWithInjections, affinity);
			if (normalizedOffsetInUnwrappedLine !== offsetInInputWithInjections) return this.offsetInInputWithInjectionsToOutputPosition(normalizedOffsetInUnwrappedLine, affinity);
		}
		if (affinity === 0) {
			if (outputLineIndex > 0 && outputOffset === this.getMinOutputOffset(outputLineIndex)) return new OutputPosition(outputLineIndex - 1, this.getMaxOutputOffset(outputLineIndex - 1));
		} else if (affinity === 1) {
			if (outputLineIndex < this.getOutputLineCount() - 1 && outputOffset === this.getMaxOutputOffset(outputLineIndex)) return new OutputPosition(outputLineIndex + 1, this.getMinOutputOffset(outputLineIndex + 1));
		}
		return new OutputPosition(outputLineIndex, outputOffset);
	}
	outputPositionToOffsetInInputWithInjections(outputLineIndex, outputOffset) {
		if (outputLineIndex > 0) outputOffset = Math.max(0, outputOffset - this.wrappedTextIndentLength);
		return (outputLineIndex > 0 ? this.breakOffsets[outputLineIndex - 1] : 0) + outputOffset;
	}
	normalizeOffsetInInputWithInjectionsAroundInjections(offsetInInputWithInjections, affinity) {
		const injectedText = this.getInjectedTextAtOffset(offsetInInputWithInjections);
		if (!injectedText) return offsetInInputWithInjections;
		if (affinity === 2) {
			if (offsetInInputWithInjections === injectedText.offsetInInputWithInjections + injectedText.length && hasRightCursorStop(this.injectionOptions[injectedText.injectedTextIndex].cursorStops)) return injectedText.offsetInInputWithInjections + injectedText.length;
			else {
				let result = injectedText.offsetInInputWithInjections;
				if (hasLeftCursorStop(this.injectionOptions[injectedText.injectedTextIndex].cursorStops)) return result;
				let index = injectedText.injectedTextIndex - 1;
				while (index >= 0 && this.injectionOffsets[index] === this.injectionOffsets[injectedText.injectedTextIndex]) {
					if (hasRightCursorStop(this.injectionOptions[index].cursorStops)) break;
					result -= this.injectionOptions[index].content.length;
					if (hasLeftCursorStop(this.injectionOptions[index].cursorStops)) break;
					index--;
				}
				return result;
			}
		} else if (affinity === 1 || affinity === 4) {
			let result = injectedText.offsetInInputWithInjections + injectedText.length;
			let index = injectedText.injectedTextIndex;
			while (index + 1 < this.injectionOffsets.length && this.injectionOffsets[index + 1] === this.injectionOffsets[index]) {
				result += this.injectionOptions[index + 1].content.length;
				index++;
			}
			return result;
		} else if (affinity === 0 || affinity === 3) {
			let result = injectedText.offsetInInputWithInjections;
			let index = injectedText.injectedTextIndex;
			while (index - 1 >= 0 && this.injectionOffsets[index - 1] === this.injectionOffsets[index]) {
				result -= this.injectionOptions[index - 1].content.length;
				index--;
			}
			return result;
		}
		assertNever();
	}
	getInjectedText(outputLineIndex, outputOffset) {
		const offset = this.outputPositionToOffsetInInputWithInjections(outputLineIndex, outputOffset);
		const injectedText = this.getInjectedTextAtOffset(offset);
		if (!injectedText) return null;
		return { options: this.injectionOptions[injectedText.injectedTextIndex] };
	}
	getInjectedTextAtOffset(offsetInInputWithInjections) {
		const injectionOffsets = this.injectionOffsets;
		const injectionOptions = this.injectionOptions;
		if (injectionOffsets !== null) {
			let totalInjectedTextLengthBefore = 0;
			for (let i = 0; i < injectionOffsets.length; i++) {
				const length = injectionOptions[i].content.length;
				const injectedTextStartOffsetInInputWithInjections = injectionOffsets[i] + totalInjectedTextLengthBefore;
				const injectedTextEndOffsetInInputWithInjections = injectionOffsets[i] + totalInjectedTextLengthBefore + length;
				if (injectedTextStartOffsetInInputWithInjections > offsetInInputWithInjections) break;
				if (offsetInInputWithInjections <= injectedTextEndOffsetInInputWithInjections) return {
					injectedTextIndex: i,
					offsetInInputWithInjections: injectedTextStartOffsetInInputWithInjections,
					length
				};
				totalInjectedTextLengthBefore += length;
			}
		}
	}
};
function hasRightCursorStop(cursorStop) {
	if (cursorStop === null || cursorStop === void 0) return true;
	return cursorStop === InjectedTextCursorStops.Right || cursorStop === InjectedTextCursorStops.Both;
}
function hasLeftCursorStop(cursorStop) {
	if (cursorStop === null || cursorStop === void 0) return true;
	return cursorStop === InjectedTextCursorStops.Left || cursorStop === InjectedTextCursorStops.Both;
}
var OutputPosition = class {
	constructor(outputLineIndex, outputOffset) {
		this.outputLineIndex = outputLineIndex;
		this.outputOffset = outputOffset;
	}
	toString() {
		return `${this.outputLineIndex}:${this.outputOffset}`;
	}
	toPosition(baseLineNumber) {
		return new Position$1(baseLineNumber + this.outputLineIndex, this.outputOffset + 1);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/textModelEvents.js
/**
* An event describing that a model has been reset to a new value.
* @internal
*/
var ModelRawFlush = class {
	constructor() {
		this.changeType = 1;
	}
};
/**
* Whether injected text takes up space on a line, either through its content or, when it is
* width-only (e.g. `{ content: '', widthInEm: 1 }`), through the horizontal space it reserves.
*/
function occupiesHorizontalSpace(options) {
	return options.content.length > 0 || options.widthInEm !== void 0 && options.widthInEm > 0;
}
/**
* Represents text injected on a line
* @internal
*/
var LineInjectedText = class LineInjectedText {
	static applyInjectedText(lineText, injectedTexts) {
		if (!injectedTexts || injectedTexts.length === 0) return lineText;
		let result = "";
		let lastOriginalOffset = 0;
		for (const injectedText of injectedTexts) {
			result += lineText.substring(lastOriginalOffset, injectedText.column - 1);
			lastOriginalOffset = injectedText.column - 1;
			result += injectedText.options.content;
		}
		result += lineText.substring(lastOriginalOffset);
		return result;
	}
	static fromDecorations(decorations) {
		const result = [];
		for (const decoration of decorations) {
			if (decoration.options.before && occupiesHorizontalSpace(decoration.options.before)) result.push(new LineInjectedText(decoration.ownerId, decoration.range.startLineNumber, decoration.range.startColumn, decoration.options.before, 0));
			if (decoration.options.after && occupiesHorizontalSpace(decoration.options.after)) result.push(new LineInjectedText(decoration.ownerId, decoration.range.endLineNumber, decoration.range.endColumn, decoration.options.after, 1));
		}
		result.sort((a, b) => {
			if (a.lineNumber === b.lineNumber) {
				if (a.column === b.column) return a.order - b.order;
				return a.column - b.column;
			}
			return a.lineNumber - b.lineNumber;
		});
		return result;
	}
	/**
	* The ranges of `applyInjectedText(...)` that are rendered at a fixed width. Width-only injected
	* text produces an empty range (`startOffset === endOffset`) which reserves horizontal space
	* without covering any character.
	*
	* `injectedTexts` must be sorted by column, which is what `fromDecorations` produces and what
	* `applyInjectedText` already requires. The result is then sorted by `startOffset` and never
	* overlaps: injections at the same column are laid out one after the other, so only an injection
	* with empty content leaves the next one starting at the same offset.
	*/
	static getFixedWidthInjectedTextRanges(injectedTexts) {
		const result = [];
		let injectedTextLength = 0;
		for (const injectedText of injectedTexts ?? []) {
			const length = injectedText.options.content.length;
			const startOffset = injectedText.column - 1 + injectedTextLength;
			const endOffset = startOffset + length;
			const widthInEm = injectedText.options.widthInEm;
			if (widthInEm !== void 0) result.push({
				startOffset,
				endOffset,
				widthInEm
			});
			injectedTextLength += length;
		}
		return result;
	}
	constructor(ownerId, lineNumber, column, options, order) {
		this.ownerId = ownerId;
		this.lineNumber = lineNumber;
		this.column = column;
		this.options = options;
		this.order = order;
	}
};
/**
* An event describing that a line has changed in a model.
* @internal
*/
var ModelRawLineChanged = class {
	constructor(lineNumber, lineNumberPostEdit) {
		this.changeType = 2;
		this.lineNumber = lineNumber;
		this.lineNumberPostEdit = lineNumberPostEdit;
	}
};
/**
* An event describing that a line height has changed in the model.
* @internal
*/
var ModelLineHeightChanged = class {
	constructor(ownerId, decorationId, lineNumber, lineHeightMultiplier) {
		this.ownerId = ownerId;
		this.decorationId = decorationId;
		this.lineNumber = lineNumber;
		this.lineHeightMultiplier = lineHeightMultiplier;
	}
};
/**
* An event describing that a line height has changed in the model.
* @internal
*/
var ModelFontChanged = class {
	constructor(ownerId, lineNumber) {
		this.ownerId = ownerId;
		this.lineNumber = lineNumber;
	}
};
/**
* An event describing that line(s) have been deleted in a model.
* @internal
*/
var ModelRawLinesDeleted = class {
	constructor(fromLineNumber, toLineNumber, lastUntouchedLinePostEdit) {
		this.changeType = 3;
		this.fromLineNumber = fromLineNumber;
		this.toLineNumber = toLineNumber;
		this.lastUntouchedLinePostEdit = lastUntouchedLinePostEdit;
	}
};
/**
* An event describing that line(s) have been inserted in a model.
* @internal
*/
var ModelRawLinesInserted = class {
	/**
	* `toLineNumber` - `fromLineNumber` + 1 denotes the number of lines that were inserted
	*/
	get toLineNumber() {
		return this.fromLineNumber + this.count - 1;
	}
	/**
	* The actual end line number of the insertion in the updated buffer.
	*/
	get toLineNumberPostEdit() {
		return this.fromLineNumberPostEdit + this.count - 1;
	}
	constructor(fromLineNumber, fromLineNumberPostEdit, count) {
		this.changeType = 4;
		this.fromLineNumber = fromLineNumber;
		this.fromLineNumberPostEdit = fromLineNumberPostEdit;
		this.count = count;
	}
};
/**
* An event describing that a model has had its EOL changed.
* @internal
*/
var ModelRawEOLChanged = class {
	constructor() {
		this.changeType = 5;
	}
};
/**
* An event describing a change in the text of a model.
* @internal
*/
var ModelRawContentChangedEvent = class ModelRawContentChangedEvent {
	constructor(changes, versionId, isUndoing, isRedoing) {
		this.changes = changes;
		this.versionId = versionId;
		this.isUndoing = isUndoing;
		this.isRedoing = isRedoing;
		this.resultingSelection = null;
	}
	containsEvent(type) {
		for (let i = 0, len = this.changes.length; i < len; i++) if (this.changes[i].changeType === type) return true;
		return false;
	}
	static merge(a, b) {
		const changes = [].concat(a.changes).concat(b.changes);
		const versionId = b.versionId;
		const isUndoing = a.isUndoing || b.isUndoing;
		const isRedoing = a.isRedoing || b.isRedoing;
		return new ModelRawContentChangedEvent(changes, versionId, isUndoing, isRedoing);
	}
};
/**
* An event describing a change in injected text.
* @internal
*/
var ModelInjectedTextChangedEvent = class {
	constructor(changes) {
		this.changes = changes;
	}
};
/**
* An event describing a change of a line height.
* @internal
*/
var ModelLineHeightChangedEvent$1 = class {
	constructor(changes) {
		this.changes = changes;
	}
};
/**
* An event describing a change in fonts.
* @internal
*/
var ModelFontChangedEvent$1 = class {
	constructor(changes) {
		this.changes = changes;
	}
};
/**
* @internal
*/
var InternalModelContentChangeEvent = class InternalModelContentChangeEvent {
	constructor(rawContentChangedEvent, contentChangedEvent) {
		this.rawContentChangedEvent = rawContentChangedEvent;
		this.contentChangedEvent = contentChangedEvent;
	}
	merge(other) {
		const rawContentChangedEvent = ModelRawContentChangedEvent.merge(this.rawContentChangedEvent, other.rawContentChangedEvent);
		const contentChangedEvent = InternalModelContentChangeEvent._mergeChangeEvents(this.contentChangedEvent, other.contentChangedEvent);
		return new InternalModelContentChangeEvent(rawContentChangedEvent, contentChangedEvent);
	}
	static _mergeChangeEvents(a, b) {
		const changes = [].concat(a.changes).concat(b.changes);
		const eol = b.eol;
		const versionId = b.versionId;
		const isUndoing = a.isUndoing || b.isUndoing;
		const isRedoing = a.isRedoing || b.isRedoing;
		const isFlush = a.isFlush || b.isFlush;
		return {
			changes,
			eol,
			isEolChange: a.isEolChange && b.isEolChange,
			versionId,
			isUndoing,
			isRedoing,
			isFlush,
			detailedReasons: a.detailedReasons.concat(b.detailedReasons),
			detailedReasonsChangeLengths: a.detailedReasonsChangeLengths.concat(b.detailedReasonsChangeLengths)
		};
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/view/domLineBreaksComputer.js
var ttPolicy$2 = createTrustedTypesPolicy("domLineBreaksComputer", { createHTML: (value) => value });
var DOMLineBreaksComputerFactory = class DOMLineBreaksComputerFactory {
	static create(targetWindow) {
		return new DOMLineBreaksComputerFactory(new WeakRef(targetWindow));
	}
	constructor(targetWindow) {
		this.targetWindow = targetWindow;
	}
	createLineBreaksComputer(context, fontInfo, tabSize, wrappingColumn, wrappingIndent, wordBreak, wrapOnEscapedLineFeeds, useTwoCellFullwidthCharacters) {
		const lineNumbers = [];
		return {
			addRequest: (lineNumber, previousLineBreakData) => {
				lineNumbers.push(lineNumber);
			},
			finalize: () => {
				return createLineBreaks$1(assertReturnsDefined(this.targetWindow.deref()), context, lineNumbers, fontInfo, tabSize, wrappingColumn, wrappingIndent, wordBreak, useTwoCellFullwidthCharacters);
			}
		};
	}
};
function createLineBreaks$1(targetWindow, context, lineNumbers, fontInfo, tabSize, firstLineBreakColumn, wrappingIndent, wordBreak, useTwoCellFullwidthCharacters) {
	function createEmptyLineBreakWithPossiblyInjectedText(lineNumber) {
		const injectedTexts = context.getLineInjectedText(lineNumber);
		if (injectedTexts) {
			const lineContent = context.getLineContent(lineNumber);
			const lineText = LineInjectedText.applyInjectedText(lineContent, injectedTexts);
			const injectionOptions = injectedTexts.map((t) => t.options);
			return new ModelLineProjectionData(injectedTexts.map((text) => text.column - 1), injectionOptions, [lineText.length], [], 0);
		} else return null;
	}
	if (firstLineBreakColumn === -1) {
		const result = [];
		for (let i = 0, len = lineNumbers.length; i < len; i++) result[i] = createEmptyLineBreakWithPossiblyInjectedText(lineNumbers[i]);
		return result;
	}
	const overallWidth = Math.round(firstLineBreakColumn * fontInfo.typicalHalfwidthCharacterWidth);
	const additionalIndentSize = Math.round(tabSize * (wrappingIndent === 3 ? 2 : wrappingIndent === 2 ? 1 : 0));
	const additionalIndentLength = Math.ceil(fontInfo.spaceWidth * additionalIndentSize);
	const fullwidthCharacterWidth = useTwoCellFullwidthCharacters ? 2 * fontInfo.spaceWidth : void 0;
	const containerDomNode = document.createElement("div");
	applyFontInfo(containerDomNode, fontInfo);
	const sb = new StringBuilder(1e4);
	const firstNonWhitespaceIndices = [];
	const wrappedTextIndentLengths = [];
	const renderLineContents = [];
	const allCharOffsets = [];
	const allSpanStartOffsets = [];
	const allVisibleColumns = [];
	for (let i = 0; i < lineNumbers.length; i++) {
		const lineNumber = lineNumbers[i];
		const injectedTexts = context.getLineInjectedText(lineNumber);
		const lineContent = LineInjectedText.applyInjectedText(context.getLineContent(lineNumber), injectedTexts);
		const fixedWidthRanges = LineInjectedText.getFixedWidthInjectedTextRanges(injectedTexts);
		let firstNonWhitespaceIndex$1 = 0;
		let wrappedTextIndentLength = 0;
		let width = overallWidth;
		if (wrappingIndent !== 0) {
			firstNonWhitespaceIndex$1 = firstNonWhitespaceIndex(lineContent);
			if (firstNonWhitespaceIndex$1 === -1) firstNonWhitespaceIndex$1 = 0;
			else {
				for (let i = 0; i < firstNonWhitespaceIndex$1; i++) {
					const fixedWidthRange = fixedWidthRanges[0];
					if (fixedWidthRange && fixedWidthRange.startOffset === i) {
						firstNonWhitespaceIndex$1 = i;
						break;
					} else {
						const charWidth = lineContent.charCodeAt(i) === 9 ? tabSize - wrappedTextIndentLength % tabSize : 1;
						wrappedTextIndentLength += charWidth;
					}
				}
				const indentWidth = Math.ceil(fontInfo.spaceWidth * wrappedTextIndentLength);
				if (indentWidth + (fullwidthCharacterWidth ?? fontInfo.typicalFullwidthCharacterWidth) > overallWidth) {
					firstNonWhitespaceIndex$1 = 0;
					wrappedTextIndentLength = 0;
				} else width = overallWidth - indentWidth;
			}
		}
		const renderLineContent = lineContent.substr(firstNonWhitespaceIndex$1);
		const shiftedFixedWidthRanges = firstNonWhitespaceIndex$1 === 0 ? fixedWidthRanges : fixedWidthRanges.map((range) => ({
			startOffset: Math.max(0, range.startOffset - firstNonWhitespaceIndex$1),
			endOffset: range.endOffset - firstNonWhitespaceIndex$1,
			widthInEm: range.widthInEm
		}));
		const tmp = renderLine(renderLineContent, wrappedTextIndentLength, tabSize, width, sb, additionalIndentLength, shiftedFixedWidthRanges, fullwidthCharacterWidth);
		firstNonWhitespaceIndices[i] = firstNonWhitespaceIndex$1;
		wrappedTextIndentLengths[i] = wrappedTextIndentLength;
		renderLineContents[i] = renderLineContent;
		allCharOffsets[i] = tmp[0];
		allSpanStartOffsets[i] = tmp[2];
		allVisibleColumns[i] = tmp[1];
	}
	const html = sb.build();
	containerDomNode.innerHTML = ttPolicy$2?.createHTML(html) ?? html;
	containerDomNode.style.position = "absolute";
	containerDomNode.style.top = "10000px";
	if (wordBreak === "keepAll") {
		containerDomNode.style.wordBreak = "keep-all";
		containerDomNode.style.overflowWrap = "anywhere";
	} else {
		containerDomNode.style.wordBreak = "inherit";
		containerDomNode.style.overflowWrap = "break-word";
	}
	targetWindow.document.body.appendChild(containerDomNode);
	const range = document.createRange();
	const lineDomNodes = Array.prototype.slice.call(containerDomNode.children, 0);
	const result = [];
	for (let i = 0; i < lineNumbers.length; i++) {
		const lineNumber = lineNumbers[i];
		const lineDomNode = lineDomNodes[i];
		const breakOffsets = readLineBreaks(range, lineDomNode, renderLineContents[i], allCharOffsets[i], allSpanStartOffsets[i]);
		if (breakOffsets === null) {
			result[i] = createEmptyLineBreakWithPossiblyInjectedText(lineNumber);
			continue;
		}
		const firstNonWhitespaceIndex = firstNonWhitespaceIndices[i];
		const wrappedTextIndentLength = wrappedTextIndentLengths[i] + additionalIndentSize;
		const visibleColumns = allVisibleColumns[i];
		const breakOffsetsVisibleColumn = [];
		for (let j = 0, len = breakOffsets.length; j < len; j++) breakOffsetsVisibleColumn[j] = visibleColumns[breakOffsets[j]];
		if (firstNonWhitespaceIndex !== 0) for (let j = 0, len = breakOffsets.length; j < len; j++) breakOffsets[j] += firstNonWhitespaceIndex;
		let injectionOptions;
		let injectionOffsets;
		const curInjectedTexts = context.getLineInjectedText(lineNumber);
		if (curInjectedTexts) {
			injectionOptions = curInjectedTexts.map((t) => t.options);
			injectionOffsets = curInjectedTexts.map((text) => text.column - 1);
		} else {
			injectionOptions = null;
			injectionOffsets = null;
		}
		result[i] = new ModelLineProjectionData(injectionOffsets, injectionOptions, breakOffsets, breakOffsetsVisibleColumn, wrappedTextIndentLength);
	}
	containerDomNode.remove();
	return result;
}
function renderLine(lineContent, initialVisibleColumn, tabSize, width, sb, wrappingIndentLength, fixedWidthRanges, fullwidthCharacterWidth) {
	if (wrappingIndentLength !== 0) {
		const hangingOffset = String(wrappingIndentLength);
		sb.appendString("<div style=\"text-indent: -");
		sb.appendString(hangingOffset);
		sb.appendString("px; padding-left: ");
		sb.appendString(hangingOffset);
		sb.appendString("px; box-sizing: border-box; width:");
	} else sb.appendString("<div style=\"width:");
	sb.appendString(String(width));
	sb.appendString("px;\">");
	const len = lineContent.length;
	let visibleColumn = initialVisibleColumn;
	let charOffset = 0;
	let fixedWidthRangeIndex = 0;
	const charOffsets = [];
	const spanStartOffsets = [0];
	const visibleColumns = [];
	let spanOpen = true;
	sb.appendString("<span>");
	for (let charIndex = 0; charIndex < len; charIndex++) {
		let fixedWidthRange = fixedWidthRanges[fixedWidthRangeIndex];
		const startsFixedWidth = fixedWidthRange && fixedWidthRange.startOffset === charIndex;
		const charCode = lineContent.charCodeAt(charIndex);
		const isFullWidthCharacter$1 = fullwidthCharacterWidth !== void 0 && isFullWidthCharacter(charCode);
		if (startsFixedWidth) {
			if (spanOpen) sb.appendString("</span>");
			while (fixedWidthRange && fixedWidthRange.startOffset === charIndex && fixedWidthRange.endOffset === charIndex) {
				sb.appendString("<span style=\"display:inline-block;box-sizing:border-box;white-space:nowrap;width:");
				sb.appendString(String(fixedWidthRange.widthInEm));
				sb.appendString("em;\">");
				sb.appendString("</span>");
				spanStartOffsets.push(charOffset);
				fixedWidthRange = fixedWidthRanges[++fixedWidthRangeIndex];
			}
			if (fixedWidthRange && fixedWidthRange.startOffset === charIndex) {
				sb.appendString("<span style=\"display:inline-block;box-sizing:border-box;white-space:nowrap;width:");
				sb.appendString(String(fixedWidthRange.widthInEm));
				sb.appendString("em;\">");
			} else sb.appendString("<span>");
			spanStartOffsets.push(charOffset);
			spanOpen = true;
		} else if (isFullWidthCharacter$1) {
			if (spanOpen) sb.appendString("</span>");
			sb.appendString("<span class=\"mtkfullwidth\" style=\"width:");
			sb.appendString(String(fullwidthCharacterWidth));
			sb.appendString("px;\">");
			spanStartOffsets.push(charOffset);
			spanOpen = true;
		} else if (!spanOpen) {
			sb.appendString("<span>");
			spanStartOffsets.push(charOffset);
			spanOpen = true;
		} else if ((!fixedWidthRange || charIndex < fixedWidthRange.startOffset) && charIndex !== 0 && charIndex % 16384 === 0) {
			sb.appendString("</span><span>");
			spanStartOffsets.push(charOffset);
		}
		charOffsets[charIndex] = charOffset;
		visibleColumns[charIndex] = visibleColumn;
		let producedCharacters = 1;
		let charWidth = 1;
		if (isFullWidthCharacter$1) {
			sb.appendCharCode(charCode);
			charWidth = 2;
			sb.appendString("</span>");
			spanOpen = false;
		} else switch (charCode) {
			case 9:
				producedCharacters = tabSize - visibleColumn % tabSize;
				charWidth = producedCharacters;
				for (let space = 1; space <= producedCharacters; space++) if (space < producedCharacters) sb.appendCharCode(160);
				else sb.appendASCIICharCode(32);
				break;
			case 32:
				if (lineContent.charCodeAt(charIndex + 1) === 32) sb.appendCharCode(160);
				else sb.appendASCIICharCode(32);
				break;
			case 60:
				sb.appendString("&lt;");
				break;
			case 62:
				sb.appendString("&gt;");
				break;
			case 38:
				sb.appendString("&amp;");
				break;
			case 0:
				sb.appendString("&#00;");
				break;
			case 65279:
			case 8232:
			case 8233:
			case 133:
				sb.appendCharCode(65533);
				break;
			default:
				if (isFullWidthCharacter(charCode)) charWidth++;
				if (charCode < 32) sb.appendCharCode(9216 + charCode);
				else sb.appendCharCode(charCode);
		}
		charOffset += producedCharacters;
		visibleColumn += charWidth;
		if (fixedWidthRange && fixedWidthRange.startOffset < fixedWidthRange.endOffset && charIndex + 1 === fixedWidthRange.endOffset) {
			sb.appendString("</span>");
			spanOpen = false;
			fixedWidthRangeIndex++;
		}
	}
	if (spanOpen) sb.appendString("</span>");
	charOffsets[lineContent.length] = charOffset;
	visibleColumns[lineContent.length] = visibleColumn;
	sb.appendString("</div>");
	return [
		charOffsets,
		visibleColumns,
		spanStartOffsets
	];
}
function readLineBreaks(range, lineDomNode, lineContent, charOffsets, spanStartOffsets) {
	if (lineContent.length <= 1) return null;
	const spans = Array.prototype.slice.call(lineDomNode.children, 0);
	const breakOffsets = [];
	try {
		discoverBreaks(range, spans, charOffsets, spanStartOffsets, 0, null, lineContent.length - 1, null, breakOffsets);
	} catch (err) {
		console.error(err);
		return null;
	}
	if (breakOffsets.length === 0) return null;
	breakOffsets.push(lineContent.length);
	return breakOffsets;
}
function discoverBreaks(range, spans, charOffsets, spanStartOffsets, low, lowRects, high, highRects, result) {
	if (low === high) return;
	lowRects = lowRects || readClientRect(range, spans, charOffsets[low], charOffsets[low + 1], spanStartOffsets);
	highRects = highRects || readClientRect(range, spans, charOffsets[high], charOffsets[high + 1], spanStartOffsets);
	if (Math.abs(lowRects[0].top - highRects[0].top) <= .1) return;
	if (low + 1 === high) {
		result.push(high);
		return;
	}
	const mid = low + (high - low) / 2 | 0;
	const midRects = readClientRect(range, spans, charOffsets[mid], charOffsets[mid + 1], spanStartOffsets);
	discoverBreaks(range, spans, charOffsets, spanStartOffsets, low, lowRects, mid, midRects, result);
	discoverBreaks(range, spans, charOffsets, spanStartOffsets, mid, midRects, high, highRects, result);
}
function readClientRect(range, spans, startOffset, endOffset, spanStartOffsets) {
	if (!spanStartOffsets) {
		range.setStart(spans[startOffset / 16384 | 0].firstChild, startOffset % 16384);
		range.setEnd(spans[endOffset / 16384 | 0].firstChild, endOffset % 16384);
		return range.getClientRects();
	}
	const startSpanIndex = findSpanIndex(spanStartOffsets, startOffset);
	const endSpanIndex = findSpanIndex(spanStartOffsets, endOffset);
	range.setStart(spans[startSpanIndex].firstChild, startOffset - spanStartOffsets[startSpanIndex]);
	range.setEnd(spans[endSpanIndex].firstChild, endOffset - spanStartOffsets[endSpanIndex]);
	return range.getClientRects();
}
function findSpanIndex(spanStartOffsets, offset) {
	let low = 0;
	let high = spanStartOffsets.length;
	while (low < high) {
		const mid = low + high >>> 1;
		if (spanStartOffsets[mid] <= offset) low = mid + 1;
		else high = mid;
	}
	return low - 1;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/codeEditor/codeEditorContributions.js
var CodeEditorContributions = class extends Disposable {
	constructor() {
		super();
		this._editor = null;
		this._instantiationService = null;
		/**
		* Contains all instantiated contributions.
		*/
		this._instances = this._register(new DisposableMap());
		/**
		* Contains contributions which are not yet instantiated.
		*/
		this._pending = /* @__PURE__ */ new Map();
		/**
		* Tracks which instantiation kinds are still left in `_pending`.
		*/
		this._finishedInstantiation = [];
		this._finishedInstantiation[0] = false;
		this._finishedInstantiation[1] = false;
		this._finishedInstantiation[2] = false;
		this._finishedInstantiation[3] = false;
	}
	initialize(editor, contributions, instantiationService) {
		this._editor = editor;
		this._instantiationService = instantiationService;
		for (const desc of contributions) {
			if (this._pending.has(desc.id)) {
				onUnexpectedError(/* @__PURE__ */ new Error(`Cannot have two contributions with the same id ${desc.id}`));
				continue;
			}
			this._pending.set(desc.id, desc);
		}
		this._instantiateSome(0);
		this._register(runWhenWindowIdle(getWindow(this._editor.getDomNode()), () => {
			this._instantiateSome(1);
		}));
		this._register(runWhenWindowIdle(getWindow(this._editor.getDomNode()), () => {
			this._instantiateSome(2);
		}));
		this._register(runWhenWindowIdle(getWindow(this._editor.getDomNode()), () => {
			this._instantiateSome(3);
		}, 5e3));
	}
	saveViewState() {
		const contributionsState = {};
		for (const [id, contribution] of this._instances) if (typeof contribution.saveViewState === "function") contributionsState[id] = contribution.saveViewState();
		return contributionsState;
	}
	restoreViewState(contributionsState) {
		for (const [id, contribution] of this._instances) if (typeof contribution.restoreViewState === "function") contribution.restoreViewState(contributionsState[id]);
	}
	get(id) {
		this._instantiateById(id);
		return this._instances.get(id) || null;
	}
	onBeforeInteractionEvent() {
		this._instantiateSome(2);
	}
	onAfterModelAttached() {
		return runWhenWindowIdle(getWindow(this._editor?.getDomNode()), () => {
			this._instantiateSome(1);
		}, 50);
	}
	_instantiateSome(instantiation) {
		if (this._finishedInstantiation[instantiation]) return;
		this._finishedInstantiation[instantiation] = true;
		const contribs = this._findPendingContributionsByInstantiation(instantiation);
		for (const contrib of contribs) this._instantiateById(contrib.id);
	}
	_findPendingContributionsByInstantiation(instantiation) {
		const result = [];
		for (const [, desc] of this._pending) if (desc.instantiation === instantiation) result.push(desc);
		return result;
	}
	_instantiateById(id) {
		const desc = this._pending.get(id);
		if (!desc) return;
		this._pending.delete(id);
		if (!this._instantiationService || !this._editor) throw new Error(`Cannot instantiate contributions before being initialized!`);
		try {
			const instance = this._instantiationService.createInstance(desc.ctor, this._editor);
			this._instances.set(desc.id, instance);
			if (typeof instance.restoreViewState === "function" && desc.instantiation !== 0) console.warn(`Editor contribution '${desc.id}' should be eager instantiated because it uses saveViewState / restoreViewState.`);
		} catch (err) {
			onUnexpectedError(err);
		}
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/editorAction.js
var InternalEditorAction = class {
	constructor(id, label, alias, metadata, _precondition, _run, _contextKeyService) {
		this.id = id;
		this.label = label;
		this.alias = alias;
		this.metadata = metadata;
		this._precondition = _precondition;
		this._run = _run;
		this._contextKeyService = _contextKeyService;
	}
	isSupported() {
		return this._contextKeyService.contextMatchesRules(this._precondition);
	}
	run(args) {
		if (!this.isSupported()) return Promise.resolve(void 0);
		return this._run(args);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/collections.js
var _a;
function groupByMap(data, groupFn) {
	const result = /* @__PURE__ */ new Map();
	for (const element of data) {
		const key = groupFn(element);
		let target = result.get(key);
		if (!target) {
			target = [];
			result.set(key, target);
		}
		target.push(element);
	}
	return result;
}
function diffSets(before, after) {
	const removed = [];
	const added = [];
	for (const element of before) if (!after.has(element)) removed.push(element);
	for (const element of after) if (!before.has(element)) added.push(element);
	return {
		removed,
		added
	};
}
/**
* Computes the intersection of two sets.
*
* @param setA - The first set.
* @param setB - The second iterable.
* @returns A new set containing the elements that are in both `setA` and `setB`.
*/
function intersection(setA, setB) {
	const result = /* @__PURE__ */ new Set();
	for (const elem of setB) if (setA.has(elem)) result.add(elem);
	return result;
}
var SetWithKey = class {
	static {
		_a = Symbol.toStringTag;
	}
	constructor(values, toKey) {
		this.toKey = toKey;
		this._map = /* @__PURE__ */ new Map();
		this[_a] = "SetWithKey";
		for (const value of values) this.add(value);
	}
	get size() {
		return this._map.size;
	}
	add(value) {
		const key = this.toKey(value);
		this._map.set(key, value);
		return this;
	}
	delete(value) {
		return this._map.delete(this.toKey(value));
	}
	has(value) {
		return this._map.has(this.toKey(value));
	}
	*entries() {
		for (const entry of this._map.values()) yield [entry, entry];
	}
	keys() {
		return this.values();
	}
	*values() {
		for (const entry of this._map.values()) yield entry;
	}
	clear() {
		this._map.clear();
	}
	forEach(callbackfn, thisArg) {
		this._map.forEach((entry) => callbackfn.call(thisArg, entry, entry, this));
	}
	[Symbol.iterator]() {
		return this.values();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/undoRedo/common/undoRedo.js
var IUndoRedoService = createDecorator("undoRedoService");
var ResourceEditStackSnapshot = class {
	constructor(resource, elements) {
		this.resource = resource;
		this.elements = elements;
	}
};
var UndoRedoGroup = class UndoRedoGroup {
	static {
		this._ID = 0;
	}
	constructor() {
		this.id = UndoRedoGroup._ID++;
		this.order = 1;
	}
	nextOrder() {
		if (this.id === 0) return 0;
		return this.order++;
	}
	static {
		this.None = new UndoRedoGroup();
	}
};
var UndoRedoSource = class UndoRedoSource {
	static {
		this._ID = 0;
	}
	constructor() {
		this.id = UndoRedoSource._ID++;
		this.order = 1;
	}
	nextOrder() {
		if (this.id === 0) return 0;
		return this.order++;
	}
	static {
		this.None = new UndoRedoSource();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/core/misc/eolCounter.js
function countEOL(text) {
	let eolCount = 0;
	let firstLineLength = 0;
	let lastLineStart = 0;
	let eol = 0;
	for (let i = 0, len = text.length; i < len; i++) {
		const chr = text.charCodeAt(i);
		if (chr === 13) {
			if (eolCount === 0) firstLineLength = i;
			eolCount++;
			if (i + 1 < len && text.charCodeAt(i + 1) === 10) {
				eol |= 2;
				i++;
			} else eol |= 3;
			lastLineStart = i + 1;
		} else if (chr === 10) {
			eol |= 1;
			if (eolCount === 0) firstLineLength = i;
			eolCount++;
			lastLineStart = i + 1;
		}
	}
	if (eolCount === 0) firstLineLength = text.length;
	return [
		eolCount,
		firstLineLength,
		text.length - lastLineStart,
		eol
	];
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/textModelEditSource.js
var privateSymbol = Symbol("TextModelEditSource");
var TextModelEditSource = class {
	constructor(metadata, _privateCtorGuard) {
		this.metadata = metadata;
	}
	toString() {
		return `${this.metadata.source}`;
	}
	getType() {
		const metadata = this.metadata;
		switch (metadata.source) {
			case "cursor": return metadata.kind;
			case "inlineCompletionAccept": return metadata.source + (metadata.$nes ? ":nes" : "");
			case "unknown": return metadata.name || "unknown";
			default: return metadata.source;
		}
	}
	/**
	* Converts the metadata to a key string.
	* Only includes properties/values that have `level` many `$` prefixes or less.
	*/
	toKey(level, filter = {}) {
		const metadata = this.metadata;
		return Object.entries(metadata).filter(([key, value]) => {
			const filterVal = filter[key];
			if (filterVal !== void 0) return filterVal;
			return (key.match(/\$/g) || []).length <= level && value !== void 0 && value !== null && value !== "";
		}).map(([key, value]) => `${key}:${value}`).join("-");
	}
};
function createEditSource(metadata) {
	return new TextModelEditSource(metadata, privateSymbol);
}
var EditSources = {
	unknown(data) {
		return createEditSource({
			source: "unknown",
			name: data.name
		});
	},
	rename: (oldName, newName) => createEditSource({
		source: "rename",
		$$$oldName: oldName,
		$$$newName: newName
	}),
	chatApplyEdits(data) {
		return createEditSource({
			source: "Chat.applyEdits",
			$modelId: avoidPathRedaction(data.modelId),
			$extensionId: data.extensionId?.extensionId,
			$extensionVersion: data.extensionId?.version,
			$harness: data.harness,
			$origin: data.origin,
			$$languageId: data.languageId,
			$$sessionId: data.sessionId,
			$$requestId: data.requestId,
			$$mode: data.mode,
			$$codeBlockSuggestionId: data.codeBlockSuggestionId
		});
	},
	agentHostChatApplyEdits(data) {
		return EditSources.chatApplyEdits({
			modelId: data.modelId,
			sessionId: data.sessionId,
			requestId: data.requestId,
			languageId: "",
			mode: void 0,
			extensionId: void 0,
			codeBlockSuggestionId: void 0,
			origin: "agentHost",
			harness: data.harness
		});
	},
	chatUndoEdits: () => createEditSource({ source: "Chat.undoEdits" }),
	chatReset: () => createEditSource({ source: "Chat.reset" }),
	inlineCompletionAccept(data) {
		return createEditSource({
			source: "inlineCompletionAccept",
			$nes: data.nes,
			...toProperties(data.providerId),
			$$correlationId: data.correlationId,
			$$requestUuid: data.requestUuid,
			$$languageId: data.languageId
		});
	},
	inlineCompletionPartialAccept(data) {
		return createEditSource({
			source: "inlineCompletionPartialAccept",
			type: data.type,
			$nes: data.nes,
			...toProperties(data.providerId),
			$$correlationId: data.correlationId,
			$$requestUuid: data.requestUuid,
			$$languageId: data.languageId
		});
	},
	inlineChatApplyEdit(data) {
		return createEditSource({
			source: "inlineChat.applyEdits",
			$modelId: avoidPathRedaction(data.modelId),
			$extensionId: data.extensionId?.extensionId,
			$extensionVersion: data.extensionId?.version,
			$$sessionId: data.sessionId,
			$$requestId: data.requestId,
			$$languageId: data.languageId
		});
	},
	reloadFromDisk: () => createEditSource({ source: "reloadFromDisk" }),
	cursor(data) {
		return createEditSource({
			source: "cursor",
			kind: data.kind,
			detailedSource: data.detailedSource
		});
	},
	setValue: () => createEditSource({ source: "setValue" }),
	eolChange: () => createEditSource({ source: "eolChange" }),
	applyEdits: () => createEditSource({ source: "applyEdits" }),
	snippet: () => createEditSource({ source: "snippet" }),
	suggest: (data) => createEditSource({
		source: "suggest",
		...toProperties(data.providerId)
	}),
	codeAction: (data) => createEditSource({
		source: "codeAction",
		$kind: data.kind,
		...toProperties(data.providerId)
	})
};
function toProperties(version) {
	if (!version) return {};
	return {
		$extensionId: version.extensionId,
		$extensionVersion: version.extensionVersion,
		$providerId: version.providerId
	};
}
function avoidPathRedaction(str) {
	if (str === void 0) return;
	return str.replaceAll("/", "|");
}
var EditDeltaInfo = class EditDeltaInfo {
	static fromText(text) {
		const linesAdded = TextLength.ofText(text).lineCount;
		const charsAdded = text.length;
		return new EditDeltaInfo(linesAdded, 0, charsAdded, 0);
	}
	static tryCreate(linesAdded, linesRemoved, charsAdded, charsRemoved) {
		if (linesAdded === void 0 || linesRemoved === void 0 || charsAdded === void 0 || charsRemoved === void 0) return;
		return new EditDeltaInfo(linesAdded, linesRemoved, charsAdded, charsRemoved);
	}
	constructor(linesAdded, linesRemoved, charsAdded, charsRemoved) {
		this.linesAdded = linesAdded;
		this.linesRemoved = linesRemoved;
		this.charsAdded = charsAdded;
		this.charsRemoved = charsRemoved;
	}
};
var EditSuggestionId;
(function(EditSuggestionId) {
	/**
	* Use AiEditTelemetryServiceImpl to create a new id!
	*/
	function newId(genPrefixedUuid) {
		return toEditIdentity(genPrefixedUuid ? genPrefixedUuid("sgt") : prefixedUuid("sgt"));
	}
	EditSuggestionId.newId = newId;
})(EditSuggestionId || (EditSuggestionId = {}));
function toEditIdentity(id) {
	return id;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/textModelBracketPairs.js
var BracketInfo = class {
	constructor(range, nestingLevel, nestingLevelOfEqualBracketType, isInvalid) {
		this.range = range;
		this.nestingLevel = nestingLevel;
		this.nestingLevelOfEqualBracketType = nestingLevelOfEqualBracketType;
		this.isInvalid = isInvalid;
	}
};
var BracketPairInfo = class {
	constructor(range, openingBracketRange, closingBracketRange, nestingLevel, nestingLevelOfEqualBracketType, bracketPairNode) {
		this.range = range;
		this.openingBracketRange = openingBracketRange;
		this.closingBracketRange = closingBracketRange;
		this.nestingLevel = nestingLevel;
		this.nestingLevelOfEqualBracketType = nestingLevelOfEqualBracketType;
		this.bracketPairNode = bracketPairNode;
	}
	get openingBracketInfo() {
		return this.bracketPairNode.openingBracket.bracketInfo;
	}
};
var BracketPairWithMinIndentationInfo = class extends BracketPairInfo {
	constructor(range, openingBracketRange, closingBracketRange, nestingLevel, nestingLevelOfEqualBracketType, bracketPairNode, minVisibleColumnIndentation) {
		super(range, openingBracketRange, closingBracketRange, nestingLevel, nestingLevelOfEqualBracketType, bracketPairNode);
		this.minVisibleColumnIndentation = minVisibleColumnIndentation;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/bracketPairsTextModelPart/bracketPairsTree/length.js
/**
* The end must be greater than or equal to the start.
*/
function lengthDiff(startLineCount, startColumnCount, endLineCount, endColumnCount) {
	return startLineCount !== endLineCount ? toLength(endLineCount - startLineCount, endColumnCount) : toLength(0, endColumnCount - startColumnCount);
}
function lengthIsZero(length) {
	return length === 0;
}
var factor = 2 ** 26;
function toLength(lineCount, columnCount) {
	return lineCount * factor + columnCount;
}
function lengthToObj(length) {
	const l = length;
	const lineCount = Math.floor(l / factor);
	const columnCount = l - lineCount * factor;
	return new TextLength(lineCount, columnCount);
}
function lengthGetLineCount(length) {
	return Math.floor(length / factor);
}
/**
* Returns the amount of columns of the given length, assuming that it does not span any line.
*/
function lengthGetColumnCountIfZeroLineCount(length) {
	return length;
}
function lengthAdd(l1, l2) {
	let r = l1 + l2;
	if (l2 >= factor) r = r - l1 % factor;
	return r;
}
function sumLengths(items, lengthFn) {
	return items.reduce((a, b) => lengthAdd(a, lengthFn(b)), 0);
}
function lengthEquals(length1, length2) {
	return length1 === length2;
}
/**
* Returns a non negative length `result` such that `lengthAdd(length1, result) = length2`, or zero if such length does not exist.
*/
function lengthDiffNonNegative(length1, length2) {
	const l1 = length1;
	const l2 = length2;
	if (l2 - l1 <= 0) return 0;
	const lineCount1 = Math.floor(l1 / factor);
	const lineCount2 = Math.floor(l2 / factor);
	const colCount2 = l2 - lineCount2 * factor;
	if (lineCount1 === lineCount2) return toLength(0, colCount2 - (l1 - lineCount1 * factor));
	else return toLength(lineCount2 - lineCount1, colCount2);
}
function lengthLessThan(length1, length2) {
	return length1 < length2;
}
function lengthLessThanEqual(length1, length2) {
	return length1 <= length2;
}
function lengthGreaterThanEqual(length1, length2) {
	return length1 >= length2;
}
function positionToLength(position) {
	return toLength(position.lineNumber - 1, position.column - 1);
}
function lengthsToRange(lengthStart, lengthEnd) {
	const l = lengthStart;
	const lineCount = Math.floor(l / factor);
	const colCount = l - lineCount * factor;
	const l2 = lengthEnd;
	const lineCount2 = Math.floor(l2 / factor);
	const colCount2 = l2 - lineCount2 * factor;
	return new Range$2(lineCount + 1, colCount + 1, lineCount2 + 1, colCount2 + 1);
}
function lengthOfString(str) {
	const lines = splitLines(str);
	return toLength(lines.length - 1, lines[lines.length - 1].length);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/bracketPairsTextModelPart/bracketPairsTree/beforeEditPositionMapper.js
var TextEditInfo = class TextEditInfo {
	static fromModelContentChanges(changes) {
		return changes.map((c) => {
			const range = Range$2.lift(c.range);
			return new TextEditInfo(positionToLength(range.getStartPosition()), positionToLength(range.getEndPosition()), lengthOfString(c.text));
		}).reverse();
	}
	constructor(startOffset, endOffset, newLength) {
		this.startOffset = startOffset;
		this.endOffset = endOffset;
		this.newLength = newLength;
	}
	toString() {
		return `[${lengthToObj(this.startOffset)}...${lengthToObj(this.endOffset)}) -> ${lengthToObj(this.newLength)}`;
	}
};
var BeforeEditPositionMapper = class {
	/**
	* @param edits Must be sorted by offset in ascending order.
	*/
	constructor(edits) {
		this.nextEditIdx = 0;
		this.deltaOldToNewLineCount = 0;
		this.deltaOldToNewColumnCount = 0;
		this.deltaLineIdxInOld = -1;
		this.edits = edits.map((edit) => TextEditInfoCache.from(edit));
	}
	/**
	* @param offset Must be equal to or greater than the last offset this method has been called with.
	*/
	getOffsetBeforeChange(offset) {
		this.adjustNextEdit(offset);
		return this.translateCurToOld(offset);
	}
	/**
	* @param offset Must be equal to or greater than the last offset this method has been called with.
	* Returns null if there is no edit anymore.
	*/
	getDistanceToNextChange(offset) {
		this.adjustNextEdit(offset);
		const nextEdit = this.edits[this.nextEditIdx];
		const nextChangeOffset = nextEdit ? this.translateOldToCur(nextEdit.offsetObj) : null;
		if (nextChangeOffset === null) return null;
		return lengthDiffNonNegative(offset, nextChangeOffset);
	}
	translateOldToCur(oldOffsetObj) {
		if (oldOffsetObj.lineCount === this.deltaLineIdxInOld) return toLength(oldOffsetObj.lineCount + this.deltaOldToNewLineCount, oldOffsetObj.columnCount + this.deltaOldToNewColumnCount);
		else return toLength(oldOffsetObj.lineCount + this.deltaOldToNewLineCount, oldOffsetObj.columnCount);
	}
	translateCurToOld(newOffset) {
		const offsetObj = lengthToObj(newOffset);
		if (offsetObj.lineCount - this.deltaOldToNewLineCount === this.deltaLineIdxInOld) return toLength(offsetObj.lineCount - this.deltaOldToNewLineCount, offsetObj.columnCount - this.deltaOldToNewColumnCount);
		else return toLength(offsetObj.lineCount - this.deltaOldToNewLineCount, offsetObj.columnCount);
	}
	adjustNextEdit(offset) {
		while (this.nextEditIdx < this.edits.length) {
			const nextEdit = this.edits[this.nextEditIdx];
			const nextEditEndOffsetInCur = this.translateOldToCur(nextEdit.endOffsetAfterObj);
			if (lengthLessThanEqual(nextEditEndOffsetInCur, offset)) {
				this.nextEditIdx++;
				const nextEditEndOffsetInCurObj = lengthToObj(nextEditEndOffsetInCur);
				const nextEditEndOffsetBeforeInCurObj = lengthToObj(this.translateOldToCur(nextEdit.endOffsetBeforeObj));
				const lineDelta = nextEditEndOffsetInCurObj.lineCount - nextEditEndOffsetBeforeInCurObj.lineCount;
				this.deltaOldToNewLineCount += lineDelta;
				const previousColumnDelta = this.deltaLineIdxInOld === nextEdit.endOffsetBeforeObj.lineCount ? this.deltaOldToNewColumnCount : 0;
				const columnDelta = nextEditEndOffsetInCurObj.columnCount - nextEditEndOffsetBeforeInCurObj.columnCount;
				this.deltaOldToNewColumnCount = previousColumnDelta + columnDelta;
				this.deltaLineIdxInOld = nextEdit.endOffsetBeforeObj.lineCount;
			} else break;
		}
	}
};
var TextEditInfoCache = class TextEditInfoCache {
	static from(edit) {
		return new TextEditInfoCache(edit.startOffset, edit.endOffset, edit.newLength);
	}
	constructor(startOffset, endOffset, textLength) {
		this.endOffsetBeforeObj = lengthToObj(endOffset);
		this.endOffsetAfterObj = lengthToObj(lengthAdd(startOffset, textLength));
		this.offsetObj = lengthToObj(startOffset);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/bracketPairsTextModelPart/bracketPairsTree/smallImmutableSet.js
var emptyArr$2 = [];
/**
* Represents an immutable set that works best for a small number of elements (less than 32).
* It uses bits to encode element membership efficiently.
*/
var SmallImmutableSet = class SmallImmutableSet {
	static {
		this.cache = new Array(129);
	}
	static create(items, additionalItems) {
		if (items <= 128 && additionalItems.length === 0) {
			let cached = SmallImmutableSet.cache[items];
			if (!cached) {
				cached = new SmallImmutableSet(items, additionalItems);
				SmallImmutableSet.cache[items] = cached;
			}
			return cached;
		}
		return new SmallImmutableSet(items, additionalItems);
	}
	static {
		this.empty = SmallImmutableSet.create(0, emptyArr$2);
	}
	static getEmpty() {
		return this.empty;
	}
	constructor(items, additionalItems) {
		this.items = items;
		this.additionalItems = additionalItems;
	}
	add(value, keyProvider) {
		const key = keyProvider.getKey(value);
		let idx = key >> 5;
		if (idx === 0) {
			const newItem = 1 << key | this.items;
			if (newItem === this.items) return this;
			return SmallImmutableSet.create(newItem, this.additionalItems);
		}
		idx--;
		const newItems = this.additionalItems.slice(0);
		while (newItems.length < idx) newItems.push(0);
		newItems[idx] |= 1 << (key & 31);
		return SmallImmutableSet.create(this.items, newItems);
	}
	merge(other) {
		const merged = this.items | other.items;
		if (this.additionalItems === emptyArr$2 && other.additionalItems === emptyArr$2) {
			if (merged === this.items) return this;
			if (merged === other.items) return other;
			return SmallImmutableSet.create(merged, emptyArr$2);
		}
		const newItems = [];
		for (let i = 0; i < Math.max(this.additionalItems.length, other.additionalItems.length); i++) {
			const item1 = this.additionalItems[i] || 0;
			const item2 = other.additionalItems[i] || 0;
			newItems.push(item1 | item2);
		}
		return SmallImmutableSet.create(merged, newItems);
	}
	intersects(other) {
		if ((this.items & other.items) !== 0) return true;
		for (let i = 0; i < Math.min(this.additionalItems.length, other.additionalItems.length); i++) if ((this.additionalItems[i] & other.additionalItems[i]) !== 0) return true;
		return false;
	}
};
var identityKeyProvider = { getKey(value) {
	return value;
} };
/**
* Assigns values a unique incrementing key.
*/
var DenseKeyProvider = class {
	constructor() {
		this.items = /* @__PURE__ */ new Map();
	}
	getKey(value) {
		let existing = this.items.get(value);
		if (existing === void 0) {
			existing = this.items.size;
			this.items.set(value, existing);
		}
		return existing;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/bracketPairsTextModelPart/bracketPairsTree/ast.js
/**
* The base implementation for all AST nodes.
*/
var BaseAstNode = class {
	/**
	* The length of the entire node, which should equal the sum of lengths of all children.
	*/
	get length() {
		return this._length;
	}
	constructor(length) {
		this._length = length;
	}
};
/**
* Represents a bracket pair including its child (e.g. `{ ... }`).
* Might be unclosed.
* Immutable, if all children are immutable.
*/
var PairAstNode = class PairAstNode extends BaseAstNode {
	static create(openingBracket, child, closingBracket) {
		let length = openingBracket.length;
		if (child) length = lengthAdd(length, child.length);
		if (closingBracket) length = lengthAdd(length, closingBracket.length);
		return new PairAstNode(length, openingBracket, child, closingBracket, child ? child.missingOpeningBracketIds : SmallImmutableSet.getEmpty());
	}
	get kind() {
		return 2;
	}
	get listHeight() {
		return 0;
	}
	get childrenLength() {
		return 3;
	}
	getChild(idx) {
		switch (idx) {
			case 0: return this.openingBracket;
			case 1: return this.child;
			case 2: return this.closingBracket;
		}
		throw new Error("Invalid child index");
	}
	/**
	* Avoid using this property, it allocates an array!
	*/
	get children() {
		const result = [];
		result.push(this.openingBracket);
		if (this.child) result.push(this.child);
		if (this.closingBracket) result.push(this.closingBracket);
		return result;
	}
	constructor(length, openingBracket, child, closingBracket, missingOpeningBracketIds) {
		super(length);
		this.openingBracket = openingBracket;
		this.child = child;
		this.closingBracket = closingBracket;
		this.missingOpeningBracketIds = missingOpeningBracketIds;
	}
	canBeReused(openBracketIds) {
		if (this.closingBracket === null) return false;
		if (openBracketIds.intersects(this.missingOpeningBracketIds)) return false;
		return true;
	}
	deepClone() {
		return new PairAstNode(this.length, this.openingBracket.deepClone(), this.child && this.child.deepClone(), this.closingBracket && this.closingBracket.deepClone(), this.missingOpeningBracketIds);
	}
	computeMinIndentation(offset, textModel) {
		return this.child ? this.child.computeMinIndentation(lengthAdd(offset, this.openingBracket.length), textModel) : Number.MAX_SAFE_INTEGER;
	}
};
var ListAstNode = class extends BaseAstNode {
	/**
	* This method uses more memory-efficient list nodes that can only store 2 or 3 children.
	*/
	static create23(item1, item2, item3, immutable = false) {
		let length = item1.length;
		let missingBracketIds = item1.missingOpeningBracketIds;
		if (item1.listHeight !== item2.listHeight) throw new Error("Invalid list heights");
		length = lengthAdd(length, item2.length);
		missingBracketIds = missingBracketIds.merge(item2.missingOpeningBracketIds);
		if (item3) {
			if (item1.listHeight !== item3.listHeight) throw new Error("Invalid list heights");
			length = lengthAdd(length, item3.length);
			missingBracketIds = missingBracketIds.merge(item3.missingOpeningBracketIds);
		}
		return immutable ? new Immutable23ListAstNode(length, item1.listHeight + 1, item1, item2, item3, missingBracketIds) : new TwoThreeListAstNode(length, item1.listHeight + 1, item1, item2, item3, missingBracketIds);
	}
	static getEmpty() {
		return new ImmutableArrayListAstNode(0, 0, [], SmallImmutableSet.getEmpty());
	}
	get kind() {
		return 4;
	}
	get missingOpeningBracketIds() {
		return this._missingOpeningBracketIds;
	}
	/**
	* Use ListAstNode.create.
	*/
	constructor(length, listHeight, _missingOpeningBracketIds) {
		super(length);
		this.listHeight = listHeight;
		this._missingOpeningBracketIds = _missingOpeningBracketIds;
		this.cachedMinIndentation = -1;
	}
	throwIfImmutable() {}
	makeLastElementMutable() {
		this.throwIfImmutable();
		const childCount = this.childrenLength;
		if (childCount === 0) return;
		const lastChild = this.getChild(childCount - 1);
		const mutable = lastChild.kind === 4 ? lastChild.toMutable() : lastChild;
		if (lastChild !== mutable) this.setChild(childCount - 1, mutable);
		return mutable;
	}
	makeFirstElementMutable() {
		this.throwIfImmutable();
		if (this.childrenLength === 0) return;
		const firstChild = this.getChild(0);
		const mutable = firstChild.kind === 4 ? firstChild.toMutable() : firstChild;
		if (firstChild !== mutable) this.setChild(0, mutable);
		return mutable;
	}
	canBeReused(openBracketIds) {
		if (openBracketIds.intersects(this.missingOpeningBracketIds)) return false;
		if (this.childrenLength === 0) return false;
		let lastChild = this;
		while (lastChild.kind === 4) {
			const lastLength = lastChild.childrenLength;
			if (lastLength === 0) throw new BugIndicatingError();
			lastChild = lastChild.getChild(lastLength - 1);
		}
		return lastChild.canBeReused(openBracketIds);
	}
	handleChildrenChanged() {
		this.throwIfImmutable();
		const count = this.childrenLength;
		let length = this.getChild(0).length;
		let unopenedBrackets = this.getChild(0).missingOpeningBracketIds;
		for (let i = 1; i < count; i++) {
			const child = this.getChild(i);
			length = lengthAdd(length, child.length);
			unopenedBrackets = unopenedBrackets.merge(child.missingOpeningBracketIds);
		}
		this._length = length;
		this._missingOpeningBracketIds = unopenedBrackets;
		this.cachedMinIndentation = -1;
	}
	computeMinIndentation(offset, textModel) {
		if (this.cachedMinIndentation !== -1) return this.cachedMinIndentation;
		let minIndentation = Number.MAX_SAFE_INTEGER;
		let childOffset = offset;
		for (let i = 0; i < this.childrenLength; i++) {
			const child = this.getChild(i);
			if (child) {
				minIndentation = Math.min(minIndentation, child.computeMinIndentation(childOffset, textModel));
				childOffset = lengthAdd(childOffset, child.length);
			}
		}
		this.cachedMinIndentation = minIndentation;
		return minIndentation;
	}
};
var TwoThreeListAstNode = class TwoThreeListAstNode extends ListAstNode {
	get childrenLength() {
		return this._item3 !== null ? 3 : 2;
	}
	getChild(idx) {
		switch (idx) {
			case 0: return this._item1;
			case 1: return this._item2;
			case 2: return this._item3;
		}
		throw new Error("Invalid child index");
	}
	setChild(idx, node) {
		switch (idx) {
			case 0:
				this._item1 = node;
				return;
			case 1:
				this._item2 = node;
				return;
			case 2:
				this._item3 = node;
				return;
		}
		throw new Error("Invalid child index");
	}
	get children() {
		return this._item3 ? [
			this._item1,
			this._item2,
			this._item3
		] : [this._item1, this._item2];
	}
	get item1() {
		return this._item1;
	}
	get item2() {
		return this._item2;
	}
	get item3() {
		return this._item3;
	}
	constructor(length, listHeight, _item1, _item2, _item3, missingOpeningBracketIds) {
		super(length, listHeight, missingOpeningBracketIds);
		this._item1 = _item1;
		this._item2 = _item2;
		this._item3 = _item3;
	}
	deepClone() {
		return new TwoThreeListAstNode(this.length, this.listHeight, this._item1.deepClone(), this._item2.deepClone(), this._item3 ? this._item3.deepClone() : null, this.missingOpeningBracketIds);
	}
	appendChildOfSameHeight(node) {
		if (this._item3) throw new Error("Cannot append to a full (2,3) tree node");
		this.throwIfImmutable();
		this._item3 = node;
		this.handleChildrenChanged();
	}
	unappendChild() {
		if (!this._item3) throw new Error("Cannot remove from a non-full (2,3) tree node");
		this.throwIfImmutable();
		const result = this._item3;
		this._item3 = null;
		this.handleChildrenChanged();
		return result;
	}
	prependChildOfSameHeight(node) {
		if (this._item3) throw new Error("Cannot prepend to a full (2,3) tree node");
		this.throwIfImmutable();
		this._item3 = this._item2;
		this._item2 = this._item1;
		this._item1 = node;
		this.handleChildrenChanged();
	}
	unprependChild() {
		if (!this._item3) throw new Error("Cannot remove from a non-full (2,3) tree node");
		this.throwIfImmutable();
		const result = this._item1;
		this._item1 = this._item2;
		this._item2 = this._item3;
		this._item3 = null;
		this.handleChildrenChanged();
		return result;
	}
	toMutable() {
		return this;
	}
};
/**
* Immutable, if all children are immutable.
*/
var Immutable23ListAstNode = class extends TwoThreeListAstNode {
	toMutable() {
		return new TwoThreeListAstNode(this.length, this.listHeight, this.item1, this.item2, this.item3, this.missingOpeningBracketIds);
	}
	throwIfImmutable() {
		throw new Error("this instance is immutable");
	}
};
/**
* For debugging.
*/
var ArrayListAstNode = class ArrayListAstNode extends ListAstNode {
	get childrenLength() {
		return this._children.length;
	}
	getChild(idx) {
		return this._children[idx];
	}
	setChild(idx, child) {
		this._children[idx] = child;
	}
	get children() {
		return this._children;
	}
	constructor(length, listHeight, _children, missingOpeningBracketIds) {
		super(length, listHeight, missingOpeningBracketIds);
		this._children = _children;
	}
	deepClone() {
		const children = new Array(this._children.length);
		for (let i = 0; i < this._children.length; i++) children[i] = this._children[i].deepClone();
		return new ArrayListAstNode(this.length, this.listHeight, children, this.missingOpeningBracketIds);
	}
	appendChildOfSameHeight(node) {
		this.throwIfImmutable();
		this._children.push(node);
		this.handleChildrenChanged();
	}
	unappendChild() {
		this.throwIfImmutable();
		const item = this._children.pop();
		this.handleChildrenChanged();
		return item;
	}
	prependChildOfSameHeight(node) {
		this.throwIfImmutable();
		this._children.unshift(node);
		this.handleChildrenChanged();
	}
	unprependChild() {
		this.throwIfImmutable();
		const item = this._children.shift();
		this.handleChildrenChanged();
		return item;
	}
	toMutable() {
		return this;
	}
};
/**
* Immutable, if all children are immutable.
*/
var ImmutableArrayListAstNode = class extends ArrayListAstNode {
	toMutable() {
		return new ArrayListAstNode(this.length, this.listHeight, [...this.children], this.missingOpeningBracketIds);
	}
	throwIfImmutable() {
		throw new Error("this instance is immutable");
	}
};
var emptyArray = [];
var ImmutableLeafAstNode = class extends BaseAstNode {
	get listHeight() {
		return 0;
	}
	get childrenLength() {
		return 0;
	}
	getChild(idx) {
		return null;
	}
	get children() {
		return emptyArray;
	}
	deepClone() {
		return this;
	}
};
var TextAstNode = class extends ImmutableLeafAstNode {
	get kind() {
		return 0;
	}
	get missingOpeningBracketIds() {
		return SmallImmutableSet.getEmpty();
	}
	canBeReused(_openedBracketIds) {
		return true;
	}
	computeMinIndentation(offset, textModel) {
		const start = lengthToObj(offset);
		const startLineNumber = (start.columnCount === 0 ? start.lineCount : start.lineCount + 1) + 1;
		const endLineNumber = lengthGetLineCount(lengthAdd(offset, this.length)) + 1;
		let result = Number.MAX_SAFE_INTEGER;
		for (let lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++) {
			const firstNonWsColumn = textModel.getLineFirstNonWhitespaceColumn(lineNumber);
			const lineContent = textModel.getLineContent(lineNumber);
			if (firstNonWsColumn === 0) continue;
			const visibleColumn = CursorColumns.visibleColumnFromColumn(lineContent, firstNonWsColumn, textModel.getOptions().tabSize);
			result = Math.min(result, visibleColumn);
		}
		return result;
	}
};
var BracketAstNode = class BracketAstNode extends ImmutableLeafAstNode {
	static create(length, bracketInfo, bracketIds) {
		return new BracketAstNode(length, bracketInfo, bracketIds);
	}
	get kind() {
		return 1;
	}
	get missingOpeningBracketIds() {
		return SmallImmutableSet.getEmpty();
	}
	constructor(length, bracketInfo, bracketIds) {
		super(length);
		this.bracketInfo = bracketInfo;
		this.bracketIds = bracketIds;
	}
	get text() {
		return this.bracketInfo.bracketText;
	}
	get languageId() {
		return this.bracketInfo.languageId;
	}
	canBeReused(_openedBracketIds) {
		return false;
	}
	computeMinIndentation(offset, textModel) {
		return Number.MAX_SAFE_INTEGER;
	}
};
var InvalidBracketAstNode = class extends ImmutableLeafAstNode {
	get kind() {
		return 3;
	}
	constructor(closingBrackets, length) {
		super(length);
		this.missingOpeningBracketIds = closingBrackets;
	}
	canBeReused(openedBracketIds) {
		return !openedBracketIds.intersects(this.missingOpeningBracketIds);
	}
	computeMinIndentation(offset, textModel) {
		return Number.MAX_SAFE_INTEGER;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/bracketPairsTextModelPart/bracketPairsTree/tokenizer.js
var Token$1 = class {
	constructor(length, kind, bracketId, bracketIds, astNode) {
		this.length = length;
		this.kind = kind;
		this.bracketId = bracketId;
		this.bracketIds = bracketIds;
		this.astNode = astNode;
	}
};
var TextBufferTokenizer = class {
	constructor(textModel, bracketTokens) {
		this.textModel = textModel;
		this.bracketTokens = bracketTokens;
		this.reader = new NonPeekableTextBufferTokenizer(this.textModel, this.bracketTokens);
		this._offset = 0;
		this.didPeek = false;
		this.peeked = null;
		this.textBufferLineCount = textModel.getLineCount();
		this.textBufferLastLineLength = textModel.getLineLength(this.textBufferLineCount);
	}
	get offset() {
		return this._offset;
	}
	get length() {
		return toLength(this.textBufferLineCount - 1, this.textBufferLastLineLength);
	}
	skip(length) {
		this.didPeek = false;
		this._offset = lengthAdd(this._offset, length);
		const obj = lengthToObj(this._offset);
		this.reader.setPosition(obj.lineCount, obj.columnCount);
	}
	read() {
		let token;
		if (this.peeked) {
			this.didPeek = false;
			token = this.peeked;
		} else token = this.reader.read();
		if (token) this._offset = lengthAdd(this._offset, token.length);
		return token;
	}
	peek() {
		if (!this.didPeek) {
			this.peeked = this.reader.read();
			this.didPeek = true;
		}
		return this.peeked;
	}
};
/**
* Does not support peek.
*/
var NonPeekableTextBufferTokenizer = class {
	constructor(textModel, bracketTokens) {
		this.textModel = textModel;
		this.bracketTokens = bracketTokens;
		this.lineIdx = 0;
		this.line = null;
		this.lineCharOffset = 0;
		this.lineTokens = null;
		this.lineTokenOffset = 0;
		/** Must be a zero line token. The end of the document cannot be peeked. */
		this.peekedToken = null;
		this.textBufferLineCount = textModel.getLineCount();
		this.textBufferLastLineLength = textModel.getLineLength(this.textBufferLineCount);
	}
	setPosition(lineIdx, column) {
		if (lineIdx === this.lineIdx) {
			this.lineCharOffset = column;
			if (this.line !== null) this.lineTokenOffset = this.lineCharOffset === 0 ? 0 : this.lineTokens.findTokenIndexAtOffset(this.lineCharOffset);
		} else {
			this.lineIdx = lineIdx;
			this.lineCharOffset = column;
			this.line = null;
		}
		this.peekedToken = null;
	}
	read() {
		if (this.peekedToken) {
			const token = this.peekedToken;
			this.peekedToken = null;
			this.lineCharOffset += lengthGetColumnCountIfZeroLineCount(token.length);
			return token;
		}
		if (this.lineIdx > this.textBufferLineCount - 1 || this.lineIdx === this.textBufferLineCount - 1 && this.lineCharOffset >= this.textBufferLastLineLength) return null;
		if (this.line === null) {
			this.lineTokens = this.textModel.tokenization.getLineTokens(this.lineIdx + 1);
			this.line = this.lineTokens.getLineContent();
			this.lineTokenOffset = this.lineCharOffset === 0 ? 0 : this.lineTokens.findTokenIndexAtOffset(this.lineCharOffset);
		}
		const startLineIdx = this.lineIdx;
		const startLineCharOffset = this.lineCharOffset;
		let lengthHeuristic = 0;
		while (true) {
			const lineTokens = this.lineTokens;
			const tokenCount = lineTokens.getCount();
			let peekedBracketToken = null;
			if (this.lineTokenOffset < tokenCount) {
				const tokenMetadata = lineTokens.getMetadata(this.lineTokenOffset);
				while (this.lineTokenOffset + 1 < tokenCount && tokenMetadata === lineTokens.getMetadata(this.lineTokenOffset + 1)) this.lineTokenOffset++;
				const isOther = TokenMetadata.getTokenType(tokenMetadata) === 0;
				const containsBracketType = TokenMetadata.containsBalancedBrackets(tokenMetadata);
				const endOffset = lineTokens.getEndOffset(this.lineTokenOffset);
				if (containsBracketType && isOther && this.lineCharOffset < endOffset) {
					const languageId = lineTokens.getLanguageId(this.lineTokenOffset);
					const text = this.line.substring(this.lineCharOffset, endOffset);
					const brackets = this.bracketTokens.getSingleLanguageBracketTokens(languageId);
					const regexp = brackets.regExpGlobal;
					if (regexp) {
						regexp.lastIndex = 0;
						const match = regexp.exec(text);
						if (match) {
							peekedBracketToken = brackets.getToken(match[0]);
							if (peekedBracketToken) this.lineCharOffset += match.index;
						}
					}
				}
				lengthHeuristic += endOffset - this.lineCharOffset;
				if (peekedBracketToken) {
					if (startLineIdx !== this.lineIdx || startLineCharOffset !== this.lineCharOffset) {
						this.peekedToken = peekedBracketToken;
						break;
					} else {
						this.lineCharOffset += lengthGetColumnCountIfZeroLineCount(peekedBracketToken.length);
						return peekedBracketToken;
					}
				} else {
					this.lineTokenOffset++;
					this.lineCharOffset = endOffset;
				}
			} else {
				if (this.lineIdx === this.textBufferLineCount - 1) break;
				this.lineIdx++;
				this.lineTokens = this.textModel.tokenization.getLineTokens(this.lineIdx + 1);
				this.lineTokenOffset = 0;
				this.line = this.lineTokens.getLineContent();
				this.lineCharOffset = 0;
				lengthHeuristic += 33;
				if (lengthHeuristic > 1e3) break;
			}
			if (lengthHeuristic > 1500) break;
		}
		const length = lengthDiff(startLineIdx, startLineCharOffset, this.lineIdx, this.lineCharOffset);
		return new Token$1(length, 0, -1, SmallImmutableSet.getEmpty(), new TextAstNode(length));
	}
};
var FastTokenizer = class {
	constructor(text, brackets) {
		this.text = text;
		this._offset = 0;
		this.idx = 0;
		const regExpStr = brackets.getRegExpStr();
		const regexp = regExpStr ? new RegExp(regExpStr + "|\n", "gi") : null;
		const tokens = [];
		let match;
		let curLineCount = 0;
		let lastLineBreakOffset = 0;
		let lastTokenEndOffset = 0;
		let lastTokenEndLine = 0;
		const smallTextTokens0Line = [];
		for (let i = 0; i < 60; i++) smallTextTokens0Line.push(new Token$1(toLength(0, i), 0, -1, SmallImmutableSet.getEmpty(), new TextAstNode(toLength(0, i))));
		const smallTextTokens1Line = [];
		for (let i = 0; i < 60; i++) smallTextTokens1Line.push(new Token$1(toLength(1, i), 0, -1, SmallImmutableSet.getEmpty(), new TextAstNode(toLength(1, i))));
		if (regexp) {
			regexp.lastIndex = 0;
			while ((match = regexp.exec(text)) !== null) {
				const curOffset = match.index;
				const value = match[0];
				if (value === "\n") {
					curLineCount++;
					lastLineBreakOffset = curOffset + 1;
				} else {
					if (lastTokenEndOffset !== curOffset) {
						let token;
						if (lastTokenEndLine === curLineCount) {
							const colCount = curOffset - lastTokenEndOffset;
							if (colCount < smallTextTokens0Line.length) token = smallTextTokens0Line[colCount];
							else {
								const length = toLength(0, colCount);
								token = new Token$1(length, 0, -1, SmallImmutableSet.getEmpty(), new TextAstNode(length));
							}
						} else {
							const lineCount = curLineCount - lastTokenEndLine;
							const colCount = curOffset - lastLineBreakOffset;
							if (lineCount === 1 && colCount < smallTextTokens1Line.length) token = smallTextTokens1Line[colCount];
							else {
								const length = toLength(lineCount, colCount);
								token = new Token$1(length, 0, -1, SmallImmutableSet.getEmpty(), new TextAstNode(length));
							}
						}
						tokens.push(token);
					}
					tokens.push(brackets.getToken(value));
					lastTokenEndOffset = curOffset + value.length;
					lastTokenEndLine = curLineCount;
				}
			}
		}
		const offset = text.length;
		if (lastTokenEndOffset !== offset) {
			const length = lastTokenEndLine === curLineCount ? toLength(0, offset - lastTokenEndOffset) : toLength(curLineCount - lastTokenEndLine, offset - lastLineBreakOffset);
			tokens.push(new Token$1(length, 0, -1, SmallImmutableSet.getEmpty(), new TextAstNode(length)));
		}
		this.length = toLength(curLineCount, offset - lastLineBreakOffset);
		this.tokens = tokens;
	}
	get offset() {
		return this._offset;
	}
	read() {
		return this.tokens[this.idx++] || null;
	}
	peek() {
		return this.tokens[this.idx] || null;
	}
	skip(length) {
		throw new NotSupportedError();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/bracketPairsTextModelPart/bracketPairsTree/brackets.js
var BracketTokens = class BracketTokens {
	static createFromLanguage(configuration, denseKeyProvider) {
		function getId(bracketInfo) {
			return denseKeyProvider.getKey(`${bracketInfo.languageId}:::${bracketInfo.bracketText}`);
		}
		const map = /* @__PURE__ */ new Map();
		for (const openingBracket of configuration.bracketsNew.openingBrackets) {
			const length = toLength(0, openingBracket.bracketText.length);
			const openingTextId = getId(openingBracket);
			const bracketIds = SmallImmutableSet.getEmpty().add(openingTextId, identityKeyProvider);
			map.set(openingBracket.bracketText, new Token$1(length, 1, openingTextId, bracketIds, BracketAstNode.create(length, openingBracket, bracketIds)));
		}
		for (const closingBracket of configuration.bracketsNew.closingBrackets) {
			const length = toLength(0, closingBracket.bracketText.length);
			let bracketIds = SmallImmutableSet.getEmpty();
			const closingBrackets = closingBracket.getOpeningBrackets();
			for (const bracket of closingBrackets) bracketIds = bracketIds.add(getId(bracket), identityKeyProvider);
			map.set(closingBracket.bracketText, new Token$1(length, 2, getId(closingBrackets[0]), bracketIds, BracketAstNode.create(length, closingBracket, bracketIds)));
		}
		return new BracketTokens(map);
	}
	constructor(map) {
		this.map = map;
		this.hasRegExp = false;
		this._regExpGlobal = null;
	}
	getRegExpStr() {
		if (this.isEmpty) return null;
		else {
			const keys = [...this.map.keys()];
			keys.sort();
			keys.reverse();
			return keys.map((k) => prepareBracketForRegExp(k)).join("|");
		}
	}
	/**
	* Returns null if there is no such regexp (because there are no brackets).
	*/
	get regExpGlobal() {
		if (!this.hasRegExp) {
			const regExpStr = this.getRegExpStr();
			this._regExpGlobal = regExpStr ? new RegExp(regExpStr, "gi") : null;
			this.hasRegExp = true;
		}
		return this._regExpGlobal;
	}
	getToken(value) {
		return this.map.get(value.toLowerCase());
	}
	findClosingTokenText(openingBracketIds) {
		for (const [closingText, info] of this.map) if (info.kind === 2 && info.bracketIds.intersects(openingBracketIds)) return closingText;
	}
	get isEmpty() {
		return this.map.size === 0;
	}
};
function prepareBracketForRegExp(str) {
	let escaped = escapeRegExpCharacters(str);
	if (/^[\w ]+/.test(str)) escaped = `\\b${escaped}`;
	if (/[\w ]+$/.test(str)) escaped = `${escaped}\\b`;
	return escaped;
}
var LanguageAgnosticBracketTokens = class {
	constructor(denseKeyProvider, getLanguageConfiguration) {
		this.denseKeyProvider = denseKeyProvider;
		this.getLanguageConfiguration = getLanguageConfiguration;
		this.languageIdToBracketTokens = /* @__PURE__ */ new Map();
	}
	didLanguageChange(languageId) {
		return this.languageIdToBracketTokens.has(languageId);
	}
	getSingleLanguageBracketTokens(languageId) {
		let singleLanguageBracketTokens = this.languageIdToBracketTokens.get(languageId);
		if (!singleLanguageBracketTokens) {
			singleLanguageBracketTokens = BracketTokens.createFromLanguage(this.getLanguageConfiguration(languageId), this.denseKeyProvider);
			this.languageIdToBracketTokens.set(languageId, singleLanguageBracketTokens);
		}
		return singleLanguageBracketTokens;
	}
	getToken(value, languageId) {
		return this.getSingleLanguageBracketTokens(languageId).getToken(value);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/bracketPairsTextModelPart/bracketPairsTree/concat23Trees.js
/**
* Concatenates a list of (2,3) AstNode's into a single (2,3) AstNode.
* This mutates the items of the input array!
* If all items have the same height, this method has runtime O(items.length).
* Otherwise, it has runtime O(items.length * max(log(items.length), items.max(i => i.height))).
*/
function concat23Trees(items) {
	if (items.length === 0) return null;
	if (items.length === 1) return items[0];
	let i = 0;
	/**
	* Reads nodes of same height and concatenates them to a single node.
	*/
	function readNode() {
		if (i >= items.length) return null;
		const start = i;
		const height = items[start].listHeight;
		i++;
		while (i < items.length && items[i].listHeight === height) i++;
		if (i - start >= 2) return concat23TreesOfSameHeight(start === 0 && i === items.length ? items : items.slice(start, i), false);
		else return items[start];
	}
	let first = readNode();
	let second = readNode();
	if (!second) return first;
	for (let item = readNode(); item; item = readNode()) if (heightDiff(first, second) <= heightDiff(second, item)) {
		first = concat$2(first, second);
		second = item;
	} else second = concat$2(second, item);
	return concat$2(first, second);
}
function concat23TreesOfSameHeight(items, createImmutableLists = false) {
	if (items.length === 0) return null;
	if (items.length === 1) return items[0];
	let length = items.length;
	while (length > 3) {
		const newLength = length >> 1;
		for (let i = 0; i < newLength; i++) {
			const j = i << 1;
			items[i] = ListAstNode.create23(items[j], items[j + 1], j + 3 === length ? items[j + 2] : null, createImmutableLists);
		}
		length = newLength;
	}
	return ListAstNode.create23(items[0], items[1], length >= 3 ? items[2] : null, createImmutableLists);
}
function heightDiff(node1, node2) {
	return Math.abs(node1.listHeight - node2.listHeight);
}
function concat$2(node1, node2) {
	if (node1.listHeight === node2.listHeight) return ListAstNode.create23(node1, node2, null, false);
	else if (node1.listHeight > node2.listHeight) return append$1(node1, node2);
	else return prepend$1(node2, node1);
}
/**
* Appends the given node to the end of this (2,3) tree.
* Returns the new root.
*/
function append$1(list, nodeToAppend) {
	list = list.toMutable();
	let curNode = list;
	const parents = [];
	let nodeToAppendOfCorrectHeight;
	while (true) {
		if (nodeToAppend.listHeight === curNode.listHeight) {
			nodeToAppendOfCorrectHeight = nodeToAppend;
			break;
		}
		if (curNode.kind !== 4) throw new Error("unexpected");
		parents.push(curNode);
		curNode = curNode.makeLastElementMutable();
	}
	for (let i = parents.length - 1; i >= 0; i--) {
		const parent = parents[i];
		if (nodeToAppendOfCorrectHeight) {
			if (parent.childrenLength >= 3) nodeToAppendOfCorrectHeight = ListAstNode.create23(parent.unappendChild(), nodeToAppendOfCorrectHeight, null, false);
			else {
				parent.appendChildOfSameHeight(nodeToAppendOfCorrectHeight);
				nodeToAppendOfCorrectHeight = void 0;
			}
		} else parent.handleChildrenChanged();
	}
	if (nodeToAppendOfCorrectHeight) return ListAstNode.create23(list, nodeToAppendOfCorrectHeight, null, false);
	else return list;
}
/**
* Prepends the given node to the end of this (2,3) tree.
* Returns the new root.
*/
function prepend$1(list, nodeToAppend) {
	list = list.toMutable();
	let curNode = list;
	const parents = [];
	while (nodeToAppend.listHeight !== curNode.listHeight) {
		if (curNode.kind !== 4) throw new Error("unexpected");
		parents.push(curNode);
		curNode = curNode.makeFirstElementMutable();
	}
	let nodeToPrependOfCorrectHeight = nodeToAppend;
	for (let i = parents.length - 1; i >= 0; i--) {
		const parent = parents[i];
		if (nodeToPrependOfCorrectHeight) {
			if (parent.childrenLength >= 3) nodeToPrependOfCorrectHeight = ListAstNode.create23(nodeToPrependOfCorrectHeight, parent.unprependChild(), null, false);
			else {
				parent.prependChildOfSameHeight(nodeToPrependOfCorrectHeight);
				nodeToPrependOfCorrectHeight = void 0;
			}
		} else parent.handleChildrenChanged();
	}
	if (nodeToPrependOfCorrectHeight) return ListAstNode.create23(nodeToPrependOfCorrectHeight, list, null, false);
	else return list;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/bracketPairsTextModelPart/bracketPairsTree/nodeReader.js
/**
* Allows to efficiently find a longest child at a given offset in a fixed node.
* The requested offsets must increase monotonously.
*/
var NodeReader = class {
	constructor(node) {
		this.lastOffset = 0;
		this.nextNodes = [node];
		this.offsets = [0];
		this.idxs = [];
	}
	/**
	* Returns the longest node at `offset` that satisfies the predicate.
	* @param offset must be greater than or equal to the last offset this method has been called with!
	*/
	readLongestNodeAt(offset, predicate) {
		if (lengthLessThan(offset, this.lastOffset)) throw new Error("Invalid offset");
		this.lastOffset = offset;
		while (true) {
			const curNode = lastOrUndefined(this.nextNodes);
			if (!curNode) return;
			const curNodeOffset = lastOrUndefined(this.offsets);
			if (lengthLessThan(offset, curNodeOffset)) return;
			if (lengthLessThan(curNodeOffset, offset)) {
				if (lengthAdd(curNodeOffset, curNode.length) <= offset) this.nextNodeAfterCurrent();
				else {
					const nextChildIdx = getNextChildIdx(curNode);
					if (nextChildIdx !== -1) {
						this.nextNodes.push(curNode.getChild(nextChildIdx));
						this.offsets.push(curNodeOffset);
						this.idxs.push(nextChildIdx);
					} else this.nextNodeAfterCurrent();
				}
			} else if (predicate(curNode)) {
				this.nextNodeAfterCurrent();
				return curNode;
			} else {
				const nextChildIdx = getNextChildIdx(curNode);
				if (nextChildIdx === -1) {
					this.nextNodeAfterCurrent();
					return;
				} else {
					this.nextNodes.push(curNode.getChild(nextChildIdx));
					this.offsets.push(curNodeOffset);
					this.idxs.push(nextChildIdx);
				}
			}
		}
	}
	nextNodeAfterCurrent() {
		while (true) {
			const currentOffset = lastOrUndefined(this.offsets);
			const currentNode = lastOrUndefined(this.nextNodes);
			this.nextNodes.pop();
			this.offsets.pop();
			if (this.idxs.length === 0) break;
			const parent = lastOrUndefined(this.nextNodes);
			const nextChildIdx = getNextChildIdx(parent, this.idxs[this.idxs.length - 1]);
			if (nextChildIdx !== -1) {
				this.nextNodes.push(parent.getChild(nextChildIdx));
				this.offsets.push(lengthAdd(currentOffset, currentNode.length));
				this.idxs[this.idxs.length - 1] = nextChildIdx;
				break;
			} else this.idxs.pop();
		}
	}
};
function getNextChildIdx(node, curIdx = -1) {
	while (true) {
		curIdx++;
		if (curIdx >= node.childrenLength) return -1;
		if (node.getChild(curIdx)) return curIdx;
	}
}
function lastOrUndefined(arr) {
	return arr.length > 0 ? arr[arr.length - 1] : void 0;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/bracketPairsTextModelPart/bracketPairsTree/parser.js
/**
* Non incrementally built ASTs are immutable.
*/
function parseDocument(tokenizer, edits, oldNode, createImmutableLists) {
	return new Parser(tokenizer, edits, oldNode, createImmutableLists).parseDocument();
}
/**
* Non incrementally built ASTs are immutable.
*/
var Parser = class {
	constructor(tokenizer, edits, oldNode, createImmutableLists) {
		this.tokenizer = tokenizer;
		this.createImmutableLists = createImmutableLists;
		this._itemsConstructed = 0;
		this._itemsFromCache = 0;
		if (oldNode && createImmutableLists) throw new Error("Not supported");
		this.oldNodeReader = oldNode ? new NodeReader(oldNode) : void 0;
		this.positionMapper = new BeforeEditPositionMapper(edits);
	}
	parseDocument() {
		this._itemsConstructed = 0;
		this._itemsFromCache = 0;
		let result = this.parseList(SmallImmutableSet.getEmpty(), 0);
		if (!result) result = ListAstNode.getEmpty();
		return result;
	}
	parseList(openedBracketIds, level) {
		const items = [];
		while (true) {
			let child = this.tryReadChildFromCache(openedBracketIds);
			if (!child) {
				const token = this.tokenizer.peek();
				if (!token || token.kind === 2 && token.bracketIds.intersects(openedBracketIds)) break;
				child = this.parseChild(openedBracketIds, level + 1);
			}
			if (child.kind === 4 && child.childrenLength === 0) continue;
			items.push(child);
		}
		return this.oldNodeReader ? concat23Trees(items) : concat23TreesOfSameHeight(items, this.createImmutableLists);
	}
	tryReadChildFromCache(openedBracketIds) {
		if (this.oldNodeReader) {
			const maxCacheableLength = this.positionMapper.getDistanceToNextChange(this.tokenizer.offset);
			if (maxCacheableLength === null || !lengthIsZero(maxCacheableLength)) {
				const cachedNode = this.oldNodeReader.readLongestNodeAt(this.positionMapper.getOffsetBeforeChange(this.tokenizer.offset), (curNode) => {
					if (maxCacheableLength !== null && !lengthLessThan(curNode.length, maxCacheableLength)) return false;
					return curNode.canBeReused(openedBracketIds);
				});
				if (cachedNode) {
					this._itemsFromCache++;
					this.tokenizer.skip(cachedNode.length);
					return cachedNode;
				}
			}
		}
	}
	parseChild(openedBracketIds, level) {
		this._itemsConstructed++;
		const token = this.tokenizer.read();
		switch (token.kind) {
			case 2: return new InvalidBracketAstNode(token.bracketIds, token.length);
			case 0: return token.astNode;
			case 1: {
				if (level > 300) return new TextAstNode(token.length);
				const set = openedBracketIds.merge(token.bracketIds);
				const child = this.parseList(set, level + 1);
				const nextToken = this.tokenizer.peek();
				if (nextToken && nextToken.kind === 2 && (nextToken.bracketId === token.bracketId || nextToken.bracketIds.intersects(token.bracketIds))) {
					this.tokenizer.read();
					return PairAstNode.create(token.astNode, child, nextToken.astNode);
				} else return PairAstNode.create(token.astNode, child, null);
			}
			default: throw new Error("unexpected");
		}
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/bracketPairsTextModelPart/bracketPairsTree/combineTextEditInfos.js
function combineTextEditInfos(textEditInfoFirst, textEditInfoSecond) {
	if (textEditInfoFirst.length === 0) return textEditInfoSecond;
	if (textEditInfoSecond.length === 0) return textEditInfoFirst;
	const s0ToS1Map = new ArrayQueue(toLengthMapping(textEditInfoFirst));
	const s1ToS2Map = toLengthMapping(textEditInfoSecond);
	s1ToS2Map.push({
		modified: false,
		lengthBefore: void 0,
		lengthAfter: void 0
	});
	let curItem = s0ToS1Map.dequeue();
	/**
	* @param s1Length Use undefined for length "infinity"
	*/
	function nextS0ToS1MapWithS1LengthOf(s1Length) {
		if (s1Length === void 0) {
			const arr = s0ToS1Map.takeWhile((v) => true) || [];
			if (curItem) arr.unshift(curItem);
			return arr;
		}
		const result = [];
		while (curItem && !lengthIsZero(s1Length)) {
			const [item, remainingItem] = curItem.splitAt(s1Length);
			result.push(item);
			s1Length = lengthDiffNonNegative(item.lengthAfter, s1Length);
			curItem = remainingItem ?? s0ToS1Map.dequeue();
		}
		if (!lengthIsZero(s1Length)) result.push(new LengthMapping(false, s1Length, s1Length));
		return result;
	}
	const result = [];
	function pushEdit(startOffset, endOffset, newLength) {
		if (result.length > 0 && lengthEquals(result[result.length - 1].endOffset, startOffset)) {
			const lastResult = result[result.length - 1];
			result[result.length - 1] = new TextEditInfo(lastResult.startOffset, endOffset, lengthAdd(lastResult.newLength, newLength));
		} else result.push({
			startOffset,
			endOffset,
			newLength
		});
	}
	let s0offset = 0;
	for (const s1ToS2 of s1ToS2Map) {
		const s0ToS1Map = nextS0ToS1MapWithS1LengthOf(s1ToS2.lengthBefore);
		if (s1ToS2.modified) {
			const s0Length = sumLengths(s0ToS1Map, (s) => s.lengthBefore);
			const s0EndOffset = lengthAdd(s0offset, s0Length);
			pushEdit(s0offset, s0EndOffset, s1ToS2.lengthAfter);
			s0offset = s0EndOffset;
		} else for (const s1 of s0ToS1Map) {
			const s0startOffset = s0offset;
			s0offset = lengthAdd(s0offset, s1.lengthBefore);
			if (s1.modified) pushEdit(s0startOffset, s0offset, s1.lengthAfter);
		}
	}
	return result;
}
var LengthMapping = class LengthMapping {
	constructor(modified, lengthBefore, lengthAfter) {
		this.modified = modified;
		this.lengthBefore = lengthBefore;
		this.lengthAfter = lengthAfter;
	}
	splitAt(lengthAfter) {
		const remainingLengthAfter = lengthDiffNonNegative(lengthAfter, this.lengthAfter);
		if (lengthEquals(remainingLengthAfter, 0)) return [this, void 0];
		else if (this.modified) return [new LengthMapping(this.modified, this.lengthBefore, lengthAfter), new LengthMapping(this.modified, 0, remainingLengthAfter)];
		else return [new LengthMapping(this.modified, lengthAfter, lengthAfter), new LengthMapping(this.modified, remainingLengthAfter, remainingLengthAfter)];
	}
	toString() {
		return `${this.modified ? "M" : "U"}:${lengthToObj(this.lengthBefore)} -> ${lengthToObj(this.lengthAfter)}`;
	}
};
function toLengthMapping(textEditInfos) {
	const result = [];
	let lastOffset = 0;
	for (const textEditInfo of textEditInfos) {
		const spaceLength = lengthDiffNonNegative(lastOffset, textEditInfo.startOffset);
		if (!lengthIsZero(spaceLength)) result.push(new LengthMapping(false, spaceLength, spaceLength));
		const lengthBefore = lengthDiffNonNegative(textEditInfo.startOffset, textEditInfo.endOffset);
		result.push(new LengthMapping(true, lengthBefore, textEditInfo.newLength));
		lastOffset = textEditInfo.endOffset;
	}
	return result;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/bracketPairsTextModelPart/bracketPairsTree/bracketPairsTree.js
var BracketPairsTree = class extends Disposable {
	didLanguageChange(languageId) {
		return this.brackets.didLanguageChange(languageId);
	}
	constructor(textModel, getLanguageConfiguration) {
		super();
		this.textModel = textModel;
		this.getLanguageConfiguration = getLanguageConfiguration;
		this.didChangeEmitter = this._register(new Emitter$1());
		this.denseKeyProvider = new DenseKeyProvider();
		this.brackets = new LanguageAgnosticBracketTokens(this.denseKeyProvider, this.getLanguageConfiguration);
		this.onDidChange = this.didChangeEmitter.event;
		this.queuedTextEditsForInitialAstWithoutTokens = [];
		this.queuedTextEdits = [];
		if (!textModel.tokenization.hasTokens) {
			const brackets = this.brackets.getSingleLanguageBracketTokens(this.textModel.getLanguageId());
			const tokenizer = new FastTokenizer(this.textModel.getValue(), brackets);
			this.initialAstWithoutTokens = parseDocument(tokenizer, [], void 0, true);
			this.astWithTokens = this.initialAstWithoutTokens;
		} else if (textModel.tokenization.backgroundTokenizationState === 2) {
			this.initialAstWithoutTokens = void 0;
			this.astWithTokens = this.parseDocumentFromTextBuffer([], void 0, false);
		} else {
			this.initialAstWithoutTokens = this.parseDocumentFromTextBuffer([], void 0, true);
			this.astWithTokens = this.initialAstWithoutTokens;
		}
	}
	handleDidChangeBackgroundTokenizationState() {
		if (this.textModel.tokenization.backgroundTokenizationState === 2) {
			const wasUndefined = this.initialAstWithoutTokens === void 0;
			this.initialAstWithoutTokens = void 0;
			if (!wasUndefined) this.didChangeEmitter.fire();
		}
	}
	handleDidChangeTokens({ ranges }) {
		const edits = ranges.map((r) => new TextEditInfo(toLength(r.fromLineNumber - 1, 0), toLength(r.toLineNumber, 0), toLength(r.toLineNumber - r.fromLineNumber + 1, 0)));
		this.handleEdits(edits, true);
		if (!this.initialAstWithoutTokens) this.didChangeEmitter.fire();
	}
	handleContentChanged(change) {
		const edits = TextEditInfo.fromModelContentChanges(change.changes);
		this.handleEdits(edits, false);
	}
	handleEdits(edits, tokenChange) {
		const result = combineTextEditInfos(this.queuedTextEdits, edits);
		this.queuedTextEdits = result;
		if (this.initialAstWithoutTokens && !tokenChange) this.queuedTextEditsForInitialAstWithoutTokens = combineTextEditInfos(this.queuedTextEditsForInitialAstWithoutTokens, edits);
	}
	flushQueue() {
		if (this.queuedTextEdits.length > 0) {
			this.astWithTokens = this.parseDocumentFromTextBuffer(this.queuedTextEdits, this.astWithTokens, false);
			this.queuedTextEdits = [];
		}
		if (this.queuedTextEditsForInitialAstWithoutTokens.length > 0) {
			if (this.initialAstWithoutTokens) this.initialAstWithoutTokens = this.parseDocumentFromTextBuffer(this.queuedTextEditsForInitialAstWithoutTokens, this.initialAstWithoutTokens, false);
			this.queuedTextEditsForInitialAstWithoutTokens = [];
		}
	}
	/**
	* @pure (only if isPure = true)
	*/
	parseDocumentFromTextBuffer(edits, previousAst, immutable) {
		const previousAstClone = previousAst;
		return parseDocument(new TextBufferTokenizer(this.textModel, this.brackets), edits, previousAstClone, immutable);
	}
	getBracketsInRange(range, onlyColorizedBrackets) {
		this.flushQueue();
		const startOffset = toLength(range.startLineNumber - 1, range.startColumn - 1);
		const endOffset = toLength(range.endLineNumber - 1, range.endColumn - 1);
		return new CallbackIterable((cb) => {
			const node = this.initialAstWithoutTokens || this.astWithTokens;
			collectBrackets(node, 0, node.length, startOffset, endOffset, cb, 0, 0, /* @__PURE__ */ new Map(), onlyColorizedBrackets);
		});
	}
	getBracketPairsInRange(range, includeMinIndentation) {
		this.flushQueue();
		const startLength = positionToLength(range.getStartPosition());
		const endLength = positionToLength(range.getEndPosition());
		return new CallbackIterable((cb) => {
			const node = this.initialAstWithoutTokens || this.astWithTokens;
			const context = new CollectBracketPairsContext(cb, includeMinIndentation, this.textModel);
			collectBracketPairs(node, 0, node.length, startLength, endLength, context, 0, /* @__PURE__ */ new Map());
		});
	}
	hasUnmatchedClosingBracketAfter(position, openingBracket) {
		if (!this.textModel.tokenization.hasAccurateTokensForLine(this.textModel.getLineCount())) return false;
		this.flushQueue();
		const openingBracketToken = this.brackets.getToken(openingBracket.bracketText, openingBracket.languageId);
		if (!openingBracketToken || openingBracketToken.kind !== 1) return false;
		const node = this.astWithTokens;
		return hasUnmatchedClosingBracketAfter(node, positionToLength(position), openingBracketToken);
	}
	getFirstBracketAfter(position) {
		this.flushQueue();
		const node = this.initialAstWithoutTokens || this.astWithTokens;
		return getFirstBracketAfter(node, 0, node.length, positionToLength(position));
	}
	getFirstBracketBefore(position) {
		this.flushQueue();
		const node = this.initialAstWithoutTokens || this.astWithTokens;
		return getFirstBracketBefore(node, 0, node.length, positionToLength(position));
	}
};
function hasUnmatchedClosingBracketAfter(root, positionLength, openingBracketToken) {
	const openingBracketIds = openingBracketToken.bracketIds;
	if (!root.missingOpeningBracketIds.intersects(openingBracketIds)) return false;
	const nodesToVisit = [{
		node: root,
		offset: 0
	}];
	while (nodesToVisit.length > 0) {
		const { node, offset } = nodesToVisit.pop();
		if (node.kind === 3) {
			if (lengthGreaterThanEqual(offset, positionLength)) return true;
			continue;
		}
		let childOffset = offset;
		for (const child of node.children) {
			const childEndOffset = lengthAdd(childOffset, child.length);
			const childEndsAfterPosition = lengthGreaterThanEqual(childEndOffset, positionLength);
			const childCanContainMatchingOrphan = child.missingOpeningBracketIds.intersects(openingBracketIds);
			if (childEndsAfterPosition && childCanContainMatchingOrphan) nodesToVisit.push({
				node: child,
				offset: childOffset
			});
			childOffset = childEndOffset;
		}
	}
	return false;
}
function getFirstBracketBefore(node, nodeOffsetStart, nodeOffsetEnd, position) {
	if (node.kind === 4 || node.kind === 2) {
		const lengths = [];
		for (const child of node.children) {
			nodeOffsetEnd = lengthAdd(nodeOffsetStart, child.length);
			lengths.push({
				nodeOffsetStart,
				nodeOffsetEnd
			});
			nodeOffsetStart = nodeOffsetEnd;
		}
		for (let i = lengths.length - 1; i >= 0; i--) {
			const { nodeOffsetStart, nodeOffsetEnd } = lengths[i];
			if (lengthLessThan(nodeOffsetStart, position)) {
				const result = getFirstBracketBefore(node.children[i], nodeOffsetStart, nodeOffsetEnd, position);
				if (result) return result;
			}
		}
		return null;
	} else if (node.kind === 3) return null;
	else if (node.kind === 1) {
		const range = lengthsToRange(nodeOffsetStart, nodeOffsetEnd);
		return {
			bracketInfo: node.bracketInfo,
			range
		};
	}
	return null;
}
function getFirstBracketAfter(node, nodeOffsetStart, nodeOffsetEnd, position) {
	if (node.kind === 4 || node.kind === 2) {
		for (const child of node.children) {
			nodeOffsetEnd = lengthAdd(nodeOffsetStart, child.length);
			if (lengthLessThan(position, nodeOffsetEnd)) {
				const result = getFirstBracketAfter(child, nodeOffsetStart, nodeOffsetEnd, position);
				if (result) return result;
			}
			nodeOffsetStart = nodeOffsetEnd;
		}
		return null;
	} else if (node.kind === 3) return null;
	else if (node.kind === 1) {
		const range = lengthsToRange(nodeOffsetStart, nodeOffsetEnd);
		return {
			bracketInfo: node.bracketInfo,
			range
		};
	}
	return null;
}
function collectBrackets(node, nodeOffsetStart, nodeOffsetEnd, startOffset, endOffset, push, level, nestingLevelOfEqualBracketType, levelPerBracketType, onlyColorizedBrackets, parentPairIsIncomplete = false) {
	if (level > 200) return true;
	whileLoop: while (true) switch (node.kind) {
		case 4: {
			const childCount = node.childrenLength;
			for (let i = 0; i < childCount; i++) {
				const child = node.getChild(i);
				if (!child) continue;
				nodeOffsetEnd = lengthAdd(nodeOffsetStart, child.length);
				if (lengthLessThanEqual(nodeOffsetStart, endOffset) && lengthGreaterThanEqual(nodeOffsetEnd, startOffset)) {
					if (lengthGreaterThanEqual(nodeOffsetEnd, endOffset)) {
						node = child;
						continue whileLoop;
					}
					if (!collectBrackets(child, nodeOffsetStart, nodeOffsetEnd, startOffset, endOffset, push, level, 0, levelPerBracketType, onlyColorizedBrackets)) return false;
				}
				nodeOffsetStart = nodeOffsetEnd;
			}
			return true;
		}
		case 2: {
			const colorize = !onlyColorizedBrackets || !node.closingBracket || node.closingBracket.bracketInfo.closesColorized(node.openingBracket.bracketInfo);
			let levelPerBracket = 0;
			if (levelPerBracketType) {
				let existing = levelPerBracketType.get(node.openingBracket.text);
				if (existing === void 0) existing = 0;
				levelPerBracket = existing;
				if (colorize) {
					existing++;
					levelPerBracketType.set(node.openingBracket.text, existing);
				}
			}
			const childCount = node.childrenLength;
			for (let i = 0; i < childCount; i++) {
				const child = node.getChild(i);
				if (!child) continue;
				nodeOffsetEnd = lengthAdd(nodeOffsetStart, child.length);
				if (lengthLessThanEqual(nodeOffsetStart, endOffset) && lengthGreaterThanEqual(nodeOffsetEnd, startOffset)) {
					if (lengthGreaterThanEqual(nodeOffsetEnd, endOffset) && child.kind !== 1) {
						node = child;
						if (colorize) {
							level++;
							nestingLevelOfEqualBracketType = levelPerBracket + 1;
						} else nestingLevelOfEqualBracketType = levelPerBracket;
						continue whileLoop;
					}
					if (colorize || child.kind !== 1 || !node.closingBracket) {
						if (!collectBrackets(child, nodeOffsetStart, nodeOffsetEnd, startOffset, endOffset, push, colorize ? level + 1 : level, colorize ? levelPerBracket + 1 : levelPerBracket, levelPerBracketType, onlyColorizedBrackets, !node.closingBracket)) return false;
					}
				}
				nodeOffsetStart = nodeOffsetEnd;
			}
			levelPerBracketType?.set(node.openingBracket.text, levelPerBracket);
			return true;
		}
		case 3: return push(new BracketInfo(lengthsToRange(nodeOffsetStart, nodeOffsetEnd), level - 1, 0, true));
		case 1: return push(new BracketInfo(lengthsToRange(nodeOffsetStart, nodeOffsetEnd), level - 1, nestingLevelOfEqualBracketType - 1, parentPairIsIncomplete));
		case 0: return true;
	}
}
var CollectBracketPairsContext = class {
	constructor(push, includeMinIndentation, textModel) {
		this.push = push;
		this.includeMinIndentation = includeMinIndentation;
		this.textModel = textModel;
	}
};
function collectBracketPairs(node, nodeOffsetStart, nodeOffsetEnd, startOffset, endOffset, context, level, levelPerBracketType) {
	if (level > 200) return true;
	let shouldContinue = true;
	if (node.kind === 2) {
		let levelPerBracket = 0;
		if (levelPerBracketType) {
			let existing = levelPerBracketType.get(node.openingBracket.text);
			if (existing === void 0) existing = 0;
			levelPerBracket = existing;
			existing++;
			levelPerBracketType.set(node.openingBracket.text, existing);
		}
		const openingBracketEnd = lengthAdd(nodeOffsetStart, node.openingBracket.length);
		let minIndentation = -1;
		if (context.includeMinIndentation) minIndentation = node.computeMinIndentation(nodeOffsetStart, context.textModel);
		shouldContinue = context.push(new BracketPairWithMinIndentationInfo(lengthsToRange(nodeOffsetStart, nodeOffsetEnd), lengthsToRange(nodeOffsetStart, openingBracketEnd), node.closingBracket ? lengthsToRange(lengthAdd(openingBracketEnd, node.child?.length || 0), nodeOffsetEnd) : void 0, level, levelPerBracket, node, minIndentation));
		nodeOffsetStart = openingBracketEnd;
		if (shouldContinue && node.child) {
			const child = node.child;
			nodeOffsetEnd = lengthAdd(nodeOffsetStart, child.length);
			if (lengthLessThanEqual(nodeOffsetStart, endOffset) && lengthGreaterThanEqual(nodeOffsetEnd, startOffset)) {
				shouldContinue = collectBracketPairs(child, nodeOffsetStart, nodeOffsetEnd, startOffset, endOffset, context, level + 1, levelPerBracketType);
				if (!shouldContinue) return false;
			}
		}
		levelPerBracketType?.set(node.openingBracket.text, levelPerBracket);
	} else {
		let curOffset = nodeOffsetStart;
		for (const child of node.children) {
			const childOffset = curOffset;
			curOffset = lengthAdd(curOffset, child.length);
			if (lengthLessThanEqual(childOffset, endOffset) && lengthLessThanEqual(startOffset, curOffset)) {
				shouldContinue = collectBracketPairs(child, childOffset, curOffset, startOffset, endOffset, context, level, levelPerBracketType);
				if (!shouldContinue) return false;
			}
		}
	}
	return shouldContinue;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/bracketPairsTextModelPart/bracketPairsImpl.js
var BracketPairsTextModelPart = class extends Disposable {
	get canBuildAST() {
		return this.textModel.getValueLength() <= 5e6;
	}
	constructor(textModel, languageConfigurationService) {
		super();
		this.textModel = textModel;
		this.languageConfigurationService = languageConfigurationService;
		this.bracketPairsTree = this._register(new MutableDisposable());
		this.onDidChangeEmitter = this._register(new Emitter$1());
		this.onDidChange = this.onDidChangeEmitter.event;
		this.bracketsRequested = false;
	}
	handleLanguageConfigurationServiceChange(e) {
		if (!e.languageId || this.bracketPairsTree.value?.object.didLanguageChange(e.languageId)) {
			this.bracketPairsTree.clear();
			this.updateBracketPairsTree();
		}
	}
	handleDidChangeOptions(e) {
		this.bracketPairsTree.clear();
		this.updateBracketPairsTree();
	}
	handleDidChangeLanguage(e) {
		this.bracketPairsTree.clear();
		this.updateBracketPairsTree();
	}
	handleDidChangeContent(change) {
		this.bracketPairsTree.value?.object.handleContentChanged(change);
	}
	handleDidChangeBackgroundTokenizationState() {
		this.bracketPairsTree.value?.object.handleDidChangeBackgroundTokenizationState();
	}
	handleDidChangeTokens(e) {
		this.bracketPairsTree.value?.object.handleDidChangeTokens(e);
	}
	updateBracketPairsTree() {
		if (this.bracketsRequested && this.canBuildAST) {
			if (!this.bracketPairsTree.value) {
				const store = new DisposableStore();
				this.bracketPairsTree.value = createDisposableRef(store.add(new BracketPairsTree(this.textModel, (languageId) => {
					return this.languageConfigurationService.getLanguageConfiguration(languageId);
				})), store);
				store.add(this.bracketPairsTree.value.object.onDidChange((e) => this.onDidChangeEmitter.fire(e)));
				this.onDidChangeEmitter.fire();
			}
		} else if (this.bracketPairsTree.value) {
			this.bracketPairsTree.clear();
			this.onDidChangeEmitter.fire();
		}
	}
	/**
	* Returns all bracket pairs that intersect the given range.
	* The result is sorted by the start position.
	*/
	getBracketPairsInRange(range) {
		this.bracketsRequested = true;
		this.updateBracketPairsTree();
		return this.bracketPairsTree.value?.object.getBracketPairsInRange(range, false) || CallbackIterable.empty;
	}
	getBracketPairsInRangeWithMinIndentation(range) {
		this.bracketsRequested = true;
		this.updateBracketPairsTree();
		return this.bracketPairsTree.value?.object.getBracketPairsInRange(range, true) || CallbackIterable.empty;
	}
	getBracketsInRange(range, onlyColorizedBrackets = false) {
		this.bracketsRequested = true;
		this.updateBracketPairsTree();
		return this.bracketPairsTree.value?.object.getBracketsInRange(range, onlyColorizedBrackets) || CallbackIterable.empty;
	}
	hasUnmatchedClosingBracketAfter(_position, openingBracket) {
		const position = this.textModel.validatePosition(_position);
		const languageId = this.textModel.getLanguageIdAtPosition(position.lineNumber, position.column);
		const openingBracketInfo = this.languageConfigurationService.getLanguageConfiguration(languageId).bracketsNew.getOpeningBracketInfo(openingBracket);
		if (!openingBracketInfo) return false;
		this.bracketsRequested = true;
		this.updateBracketPairsTree();
		return this.bracketPairsTree.value?.object.hasUnmatchedClosingBracketAfter(position, openingBracketInfo) ?? false;
	}
	findMatchingBracketUp(_bracket, _position, maxDuration) {
		const position = this.textModel.validatePosition(_position);
		const languageId = this.textModel.getLanguageIdAtPosition(position.lineNumber, position.column);
		if (this.canBuildAST) {
			const closingBracketInfo = this.languageConfigurationService.getLanguageConfiguration(languageId).bracketsNew.getClosingBracketInfo(_bracket);
			if (!closingBracketInfo) return null;
			const bracketPair = this.getBracketPairsInRange(Range$2.fromPositions(_position, _position)).findLast((b) => closingBracketInfo.closes(b.openingBracketInfo));
			if (bracketPair) return bracketPair.openingBracketRange;
			return null;
		} else {
			const bracket = _bracket.toLowerCase();
			const bracketsSupport = this.languageConfigurationService.getLanguageConfiguration(languageId).brackets;
			if (!bracketsSupport) return null;
			const data = bracketsSupport.textIsBracket[bracket];
			if (!data) return null;
			return stripBracketSearchCanceled(this._findMatchingBracketUp(data, position, createTimeBasedContinueBracketSearchPredicate(maxDuration)));
		}
	}
	matchBracket(position, maxDuration) {
		if (this.canBuildAST) {
			const bracketPair = this.getBracketPairsInRange(Range$2.fromPositions(position, position)).filter((item) => item.closingBracketRange !== void 0 && (item.openingBracketRange.containsPosition(position) || item.closingBracketRange.containsPosition(position))).findLastMaxBy(compareBy((item) => item.openingBracketRange.containsPosition(position) ? item.openingBracketRange : item.closingBracketRange, Range$2.compareRangesUsingStarts));
			if (bracketPair) return [bracketPair.openingBracketRange, bracketPair.closingBracketRange];
			return null;
		} else {
			const continueSearchPredicate = createTimeBasedContinueBracketSearchPredicate(maxDuration);
			return this._matchBracket(this.textModel.validatePosition(position), continueSearchPredicate);
		}
	}
	_establishBracketSearchOffsets(position, lineTokens, modeBrackets, tokenIndex) {
		const tokenCount = lineTokens.getCount();
		const currentLanguageId = lineTokens.getLanguageId(tokenIndex);
		let searchStartOffset = Math.max(0, position.column - 1 - modeBrackets.maxBracketLength);
		for (let i = tokenIndex - 1; i >= 0; i--) {
			const tokenEndOffset = lineTokens.getEndOffset(i);
			if (tokenEndOffset <= searchStartOffset) break;
			if (ignoreBracketsInToken(lineTokens.getStandardTokenType(i)) || lineTokens.getLanguageId(i) !== currentLanguageId) {
				searchStartOffset = tokenEndOffset;
				break;
			}
		}
		let searchEndOffset = Math.min(lineTokens.getLineContent().length, position.column - 1 + modeBrackets.maxBracketLength);
		for (let i = tokenIndex + 1; i < tokenCount; i++) {
			const tokenStartOffset = lineTokens.getStartOffset(i);
			if (tokenStartOffset >= searchEndOffset) break;
			if (ignoreBracketsInToken(lineTokens.getStandardTokenType(i)) || lineTokens.getLanguageId(i) !== currentLanguageId) {
				searchEndOffset = tokenStartOffset;
				break;
			}
		}
		return {
			searchStartOffset,
			searchEndOffset
		};
	}
	_matchBracket(position, continueSearchPredicate) {
		const lineNumber = position.lineNumber;
		const lineTokens = this.textModel.tokenization.getLineTokens(lineNumber);
		const lineText = this.textModel.getLineContent(lineNumber);
		const tokenIndex = lineTokens.findTokenIndexAtOffset(position.column - 1);
		if (tokenIndex < 0) return null;
		const currentModeBrackets = this.languageConfigurationService.getLanguageConfiguration(lineTokens.getLanguageId(tokenIndex)).brackets;
		if (currentModeBrackets && !ignoreBracketsInToken(lineTokens.getStandardTokenType(tokenIndex))) {
			let { searchStartOffset, searchEndOffset } = this._establishBracketSearchOffsets(position, lineTokens, currentModeBrackets, tokenIndex);
			let bestResult = null;
			while (true) {
				const foundBracket = BracketsUtils.findNextBracketInRange(currentModeBrackets.forwardRegex, lineNumber, lineText, searchStartOffset, searchEndOffset);
				if (!foundBracket) break;
				if (foundBracket.startColumn <= position.column && position.column <= foundBracket.endColumn) {
					const foundBracketText = lineText.substring(foundBracket.startColumn - 1, foundBracket.endColumn - 1).toLowerCase();
					const r = this._matchFoundBracket(foundBracket, currentModeBrackets.textIsBracket[foundBracketText], currentModeBrackets.textIsOpenBracket[foundBracketText], continueSearchPredicate);
					if (r) {
						if (r instanceof BracketSearchCanceled) return null;
						bestResult = r;
					}
				}
				searchStartOffset = foundBracket.endColumn - 1;
			}
			if (bestResult) return bestResult;
		}
		if (tokenIndex > 0 && lineTokens.getStartOffset(tokenIndex) === position.column - 1) {
			const prevTokenIndex = tokenIndex - 1;
			const prevModeBrackets = this.languageConfigurationService.getLanguageConfiguration(lineTokens.getLanguageId(prevTokenIndex)).brackets;
			if (prevModeBrackets && !ignoreBracketsInToken(lineTokens.getStandardTokenType(prevTokenIndex))) {
				const { searchStartOffset, searchEndOffset } = this._establishBracketSearchOffsets(position, lineTokens, prevModeBrackets, prevTokenIndex);
				const foundBracket = BracketsUtils.findPrevBracketInRange(prevModeBrackets.reversedRegex, lineNumber, lineText, searchStartOffset, searchEndOffset);
				if (foundBracket && foundBracket.startColumn <= position.column && position.column <= foundBracket.endColumn) {
					const foundBracketText = lineText.substring(foundBracket.startColumn - 1, foundBracket.endColumn - 1).toLowerCase();
					const r = this._matchFoundBracket(foundBracket, prevModeBrackets.textIsBracket[foundBracketText], prevModeBrackets.textIsOpenBracket[foundBracketText], continueSearchPredicate);
					if (r) {
						if (r instanceof BracketSearchCanceled) return null;
						return r;
					}
				}
			}
		}
		return null;
	}
	_matchFoundBracket(foundBracket, data, isOpen, continueSearchPredicate) {
		if (!data) return null;
		const matched = isOpen ? this._findMatchingBracketDown(data, foundBracket.getEndPosition(), continueSearchPredicate) : this._findMatchingBracketUp(data, foundBracket.getStartPosition(), continueSearchPredicate);
		if (!matched) return null;
		if (matched instanceof BracketSearchCanceled) return matched;
		return [foundBracket, matched];
	}
	_findMatchingBracketUp(bracket, position, continueSearchPredicate) {
		const languageId = bracket.languageId;
		const reversedBracketRegex = bracket.reversedRegex;
		let count = -1;
		let totalCallCount = 0;
		const searchPrevMatchingBracketInRange = (lineNumber, lineText, searchStartOffset, searchEndOffset) => {
			while (true) {
				if (continueSearchPredicate && ++totalCallCount % 100 === 0 && !continueSearchPredicate()) return BracketSearchCanceled.INSTANCE;
				const r = BracketsUtils.findPrevBracketInRange(reversedBracketRegex, lineNumber, lineText, searchStartOffset, searchEndOffset);
				if (!r) break;
				const hitText = lineText.substring(r.startColumn - 1, r.endColumn - 1).toLowerCase();
				if (bracket.isOpen(hitText)) count++;
				else if (bracket.isClose(hitText)) count--;
				if (count === 0) return r;
				searchEndOffset = r.startColumn - 1;
			}
			return null;
		};
		for (let lineNumber = position.lineNumber; lineNumber >= 1; lineNumber--) {
			const lineTokens = this.textModel.tokenization.getLineTokens(lineNumber);
			const tokenCount = lineTokens.getCount();
			const lineText = this.textModel.getLineContent(lineNumber);
			let tokenIndex = tokenCount - 1;
			let searchStartOffset = lineText.length;
			let searchEndOffset = lineText.length;
			if (lineNumber === position.lineNumber) {
				tokenIndex = lineTokens.findTokenIndexAtOffset(position.column - 1);
				searchStartOffset = position.column - 1;
				searchEndOffset = position.column - 1;
			}
			let prevSearchInToken = true;
			for (; tokenIndex >= 0; tokenIndex--) {
				const searchInToken = lineTokens.getLanguageId(tokenIndex) === languageId && !ignoreBracketsInToken(lineTokens.getStandardTokenType(tokenIndex));
				if (searchInToken) {
					if (prevSearchInToken) searchStartOffset = lineTokens.getStartOffset(tokenIndex);
					else {
						searchStartOffset = lineTokens.getStartOffset(tokenIndex);
						searchEndOffset = lineTokens.getEndOffset(tokenIndex);
					}
				} else if (prevSearchInToken && searchStartOffset !== searchEndOffset) {
					const r = searchPrevMatchingBracketInRange(lineNumber, lineText, searchStartOffset, searchEndOffset);
					if (r) return r;
				}
				prevSearchInToken = searchInToken;
			}
			if (prevSearchInToken && searchStartOffset !== searchEndOffset) {
				const r = searchPrevMatchingBracketInRange(lineNumber, lineText, searchStartOffset, searchEndOffset);
				if (r) return r;
			}
		}
		return null;
	}
	_findMatchingBracketDown(bracket, position, continueSearchPredicate) {
		const languageId = bracket.languageId;
		const bracketRegex = bracket.forwardRegex;
		let count = 1;
		let totalCallCount = 0;
		const searchNextMatchingBracketInRange = (lineNumber, lineText, searchStartOffset, searchEndOffset) => {
			while (true) {
				if (continueSearchPredicate && ++totalCallCount % 100 === 0 && !continueSearchPredicate()) return BracketSearchCanceled.INSTANCE;
				const r = BracketsUtils.findNextBracketInRange(bracketRegex, lineNumber, lineText, searchStartOffset, searchEndOffset);
				if (!r) break;
				const hitText = lineText.substring(r.startColumn - 1, r.endColumn - 1).toLowerCase();
				if (bracket.isOpen(hitText)) count++;
				else if (bracket.isClose(hitText)) count--;
				if (count === 0) return r;
				searchStartOffset = r.endColumn - 1;
			}
			return null;
		};
		const lineCount = this.textModel.getLineCount();
		for (let lineNumber = position.lineNumber; lineNumber <= lineCount; lineNumber++) {
			const lineTokens = this.textModel.tokenization.getLineTokens(lineNumber);
			const tokenCount = lineTokens.getCount();
			const lineText = this.textModel.getLineContent(lineNumber);
			let tokenIndex = 0;
			let searchStartOffset = 0;
			let searchEndOffset = 0;
			if (lineNumber === position.lineNumber) {
				tokenIndex = lineTokens.findTokenIndexAtOffset(position.column - 1);
				searchStartOffset = position.column - 1;
				searchEndOffset = position.column - 1;
			}
			let prevSearchInToken = true;
			for (; tokenIndex < tokenCount; tokenIndex++) {
				const searchInToken = lineTokens.getLanguageId(tokenIndex) === languageId && !ignoreBracketsInToken(lineTokens.getStandardTokenType(tokenIndex));
				if (searchInToken) {
					if (prevSearchInToken) searchEndOffset = lineTokens.getEndOffset(tokenIndex);
					else {
						searchStartOffset = lineTokens.getStartOffset(tokenIndex);
						searchEndOffset = lineTokens.getEndOffset(tokenIndex);
					}
				} else if (prevSearchInToken && searchStartOffset !== searchEndOffset) {
					const r = searchNextMatchingBracketInRange(lineNumber, lineText, searchStartOffset, searchEndOffset);
					if (r) return r;
				}
				prevSearchInToken = searchInToken;
			}
			if (prevSearchInToken && searchStartOffset !== searchEndOffset) {
				const r = searchNextMatchingBracketInRange(lineNumber, lineText, searchStartOffset, searchEndOffset);
				if (r) return r;
			}
		}
		return null;
	}
	findPrevBracket(_position) {
		const position = this.textModel.validatePosition(_position);
		if (this.canBuildAST) {
			this.bracketsRequested = true;
			this.updateBracketPairsTree();
			return this.bracketPairsTree.value?.object.getFirstBracketBefore(position) || null;
		}
		let languageId = null;
		let modeBrackets = null;
		let bracketConfig = null;
		for (let lineNumber = position.lineNumber; lineNumber >= 1; lineNumber--) {
			const lineTokens = this.textModel.tokenization.getLineTokens(lineNumber);
			const tokenCount = lineTokens.getCount();
			const lineText = this.textModel.getLineContent(lineNumber);
			let tokenIndex = tokenCount - 1;
			let searchStartOffset = lineText.length;
			let searchEndOffset = lineText.length;
			if (lineNumber === position.lineNumber) {
				tokenIndex = lineTokens.findTokenIndexAtOffset(position.column - 1);
				searchStartOffset = position.column - 1;
				searchEndOffset = position.column - 1;
				const tokenLanguageId = lineTokens.getLanguageId(tokenIndex);
				if (languageId !== tokenLanguageId) {
					languageId = tokenLanguageId;
					modeBrackets = this.languageConfigurationService.getLanguageConfiguration(languageId).brackets;
					bracketConfig = this.languageConfigurationService.getLanguageConfiguration(languageId).bracketsNew;
				}
			}
			let prevSearchInToken = true;
			for (; tokenIndex >= 0; tokenIndex--) {
				const tokenLanguageId = lineTokens.getLanguageId(tokenIndex);
				if (languageId !== tokenLanguageId) {
					if (modeBrackets && bracketConfig && prevSearchInToken && searchStartOffset !== searchEndOffset) {
						const r = BracketsUtils.findPrevBracketInRange(modeBrackets.reversedRegex, lineNumber, lineText, searchStartOffset, searchEndOffset);
						if (r) return this._toFoundBracket(bracketConfig, r);
						prevSearchInToken = false;
					}
					languageId = tokenLanguageId;
					modeBrackets = this.languageConfigurationService.getLanguageConfiguration(languageId).brackets;
					bracketConfig = this.languageConfigurationService.getLanguageConfiguration(languageId).bracketsNew;
				}
				const searchInToken = !!modeBrackets && !ignoreBracketsInToken(lineTokens.getStandardTokenType(tokenIndex));
				if (searchInToken) {
					if (prevSearchInToken) searchStartOffset = lineTokens.getStartOffset(tokenIndex);
					else {
						searchStartOffset = lineTokens.getStartOffset(tokenIndex);
						searchEndOffset = lineTokens.getEndOffset(tokenIndex);
					}
				} else if (bracketConfig && modeBrackets && prevSearchInToken && searchStartOffset !== searchEndOffset) {
					const r = BracketsUtils.findPrevBracketInRange(modeBrackets.reversedRegex, lineNumber, lineText, searchStartOffset, searchEndOffset);
					if (r) return this._toFoundBracket(bracketConfig, r);
				}
				prevSearchInToken = searchInToken;
			}
			if (bracketConfig && modeBrackets && prevSearchInToken && searchStartOffset !== searchEndOffset) {
				const r = BracketsUtils.findPrevBracketInRange(modeBrackets.reversedRegex, lineNumber, lineText, searchStartOffset, searchEndOffset);
				if (r) return this._toFoundBracket(bracketConfig, r);
			}
		}
		return null;
	}
	findNextBracket(_position) {
		const position = this.textModel.validatePosition(_position);
		if (this.canBuildAST) {
			this.bracketsRequested = true;
			this.updateBracketPairsTree();
			return this.bracketPairsTree.value?.object.getFirstBracketAfter(position) || null;
		}
		const lineCount = this.textModel.getLineCount();
		let languageId = null;
		let modeBrackets = null;
		let bracketConfig = null;
		for (let lineNumber = position.lineNumber; lineNumber <= lineCount; lineNumber++) {
			const lineTokens = this.textModel.tokenization.getLineTokens(lineNumber);
			const tokenCount = lineTokens.getCount();
			const lineText = this.textModel.getLineContent(lineNumber);
			let tokenIndex = 0;
			let searchStartOffset = 0;
			let searchEndOffset = 0;
			if (lineNumber === position.lineNumber) {
				tokenIndex = lineTokens.findTokenIndexAtOffset(position.column - 1);
				searchStartOffset = position.column - 1;
				searchEndOffset = position.column - 1;
				const tokenLanguageId = lineTokens.getLanguageId(tokenIndex);
				if (languageId !== tokenLanguageId) {
					languageId = tokenLanguageId;
					modeBrackets = this.languageConfigurationService.getLanguageConfiguration(languageId).brackets;
					bracketConfig = this.languageConfigurationService.getLanguageConfiguration(languageId).bracketsNew;
				}
			}
			let prevSearchInToken = true;
			for (; tokenIndex < tokenCount; tokenIndex++) {
				const tokenLanguageId = lineTokens.getLanguageId(tokenIndex);
				if (languageId !== tokenLanguageId) {
					if (bracketConfig && modeBrackets && prevSearchInToken && searchStartOffset !== searchEndOffset) {
						const r = BracketsUtils.findNextBracketInRange(modeBrackets.forwardRegex, lineNumber, lineText, searchStartOffset, searchEndOffset);
						if (r) return this._toFoundBracket(bracketConfig, r);
						prevSearchInToken = false;
					}
					languageId = tokenLanguageId;
					modeBrackets = this.languageConfigurationService.getLanguageConfiguration(languageId).brackets;
					bracketConfig = this.languageConfigurationService.getLanguageConfiguration(languageId).bracketsNew;
				}
				const searchInToken = !!modeBrackets && !ignoreBracketsInToken(lineTokens.getStandardTokenType(tokenIndex));
				if (searchInToken) {
					if (prevSearchInToken) searchEndOffset = lineTokens.getEndOffset(tokenIndex);
					else {
						searchStartOffset = lineTokens.getStartOffset(tokenIndex);
						searchEndOffset = lineTokens.getEndOffset(tokenIndex);
					}
				} else if (bracketConfig && modeBrackets && prevSearchInToken && searchStartOffset !== searchEndOffset) {
					const r = BracketsUtils.findNextBracketInRange(modeBrackets.forwardRegex, lineNumber, lineText, searchStartOffset, searchEndOffset);
					if (r) return this._toFoundBracket(bracketConfig, r);
				}
				prevSearchInToken = searchInToken;
			}
			if (bracketConfig && modeBrackets && prevSearchInToken && searchStartOffset !== searchEndOffset) {
				const r = BracketsUtils.findNextBracketInRange(modeBrackets.forwardRegex, lineNumber, lineText, searchStartOffset, searchEndOffset);
				if (r) return this._toFoundBracket(bracketConfig, r);
			}
		}
		return null;
	}
	findEnclosingBrackets(_position, maxDuration) {
		const position = this.textModel.validatePosition(_position);
		if (this.canBuildAST) {
			const range = Range$2.fromPositions(position);
			const bracketPair = this.getBracketPairsInRange(Range$2.fromPositions(position, position)).findLast((item) => item.closingBracketRange !== void 0 && item.range.strictContainsRange(range));
			if (bracketPair) return [bracketPair.openingBracketRange, bracketPair.closingBracketRange];
			return null;
		}
		const continueSearchPredicate = createTimeBasedContinueBracketSearchPredicate(maxDuration);
		const lineCount = this.textModel.getLineCount();
		const savedCounts = /* @__PURE__ */ new Map();
		let counts = [];
		const resetCounts = (languageId, modeBrackets) => {
			if (!savedCounts.has(languageId)) {
				const tmp = [];
				for (let i = 0, len = modeBrackets ? modeBrackets.brackets.length : 0; i < len; i++) tmp[i] = 0;
				savedCounts.set(languageId, tmp);
			}
			counts = savedCounts.get(languageId);
		};
		let totalCallCount = 0;
		const searchInRange = (modeBrackets, lineNumber, lineText, searchStartOffset, searchEndOffset) => {
			while (true) {
				if (continueSearchPredicate && ++totalCallCount % 100 === 0 && !continueSearchPredicate()) return BracketSearchCanceled.INSTANCE;
				const r = BracketsUtils.findNextBracketInRange(modeBrackets.forwardRegex, lineNumber, lineText, searchStartOffset, searchEndOffset);
				if (!r) break;
				const hitText = lineText.substring(r.startColumn - 1, r.endColumn - 1).toLowerCase();
				const bracket = modeBrackets.textIsBracket[hitText];
				if (bracket) {
					if (bracket.isOpen(hitText)) counts[bracket.index]++;
					else if (bracket.isClose(hitText)) counts[bracket.index]--;
					if (counts[bracket.index] === -1) return this._matchFoundBracket(r, bracket, false, continueSearchPredicate);
				}
				searchStartOffset = r.endColumn - 1;
			}
			return null;
		};
		let languageId = null;
		let modeBrackets = null;
		for (let lineNumber = position.lineNumber; lineNumber <= lineCount; lineNumber++) {
			const lineTokens = this.textModel.tokenization.getLineTokens(lineNumber);
			const tokenCount = lineTokens.getCount();
			const lineText = this.textModel.getLineContent(lineNumber);
			let tokenIndex = 0;
			let searchStartOffset = 0;
			let searchEndOffset = 0;
			if (lineNumber === position.lineNumber) {
				tokenIndex = lineTokens.findTokenIndexAtOffset(position.column - 1);
				searchStartOffset = position.column - 1;
				searchEndOffset = position.column - 1;
				const tokenLanguageId = lineTokens.getLanguageId(tokenIndex);
				if (languageId !== tokenLanguageId) {
					languageId = tokenLanguageId;
					modeBrackets = this.languageConfigurationService.getLanguageConfiguration(languageId).brackets;
					resetCounts(languageId, modeBrackets);
				}
			}
			let prevSearchInToken = true;
			for (; tokenIndex < tokenCount; tokenIndex++) {
				const tokenLanguageId = lineTokens.getLanguageId(tokenIndex);
				if (languageId !== tokenLanguageId) {
					if (modeBrackets && prevSearchInToken && searchStartOffset !== searchEndOffset) {
						const r = searchInRange(modeBrackets, lineNumber, lineText, searchStartOffset, searchEndOffset);
						if (r) return stripBracketSearchCanceled(r);
						prevSearchInToken = false;
					}
					languageId = tokenLanguageId;
					modeBrackets = this.languageConfigurationService.getLanguageConfiguration(languageId).brackets;
					resetCounts(languageId, modeBrackets);
				}
				const searchInToken = !!modeBrackets && !ignoreBracketsInToken(lineTokens.getStandardTokenType(tokenIndex));
				if (searchInToken) {
					if (prevSearchInToken) searchEndOffset = lineTokens.getEndOffset(tokenIndex);
					else {
						searchStartOffset = lineTokens.getStartOffset(tokenIndex);
						searchEndOffset = lineTokens.getEndOffset(tokenIndex);
					}
				} else if (modeBrackets && prevSearchInToken && searchStartOffset !== searchEndOffset) {
					const r = searchInRange(modeBrackets, lineNumber, lineText, searchStartOffset, searchEndOffset);
					if (r) return stripBracketSearchCanceled(r);
				}
				prevSearchInToken = searchInToken;
			}
			if (modeBrackets && prevSearchInToken && searchStartOffset !== searchEndOffset) {
				const r = searchInRange(modeBrackets, lineNumber, lineText, searchStartOffset, searchEndOffset);
				if (r) return stripBracketSearchCanceled(r);
			}
		}
		return null;
	}
	_toFoundBracket(bracketConfig, r) {
		if (!r) return null;
		let text = this.textModel.getValueInRange(r);
		text = text.toLowerCase();
		const bracketInfo = bracketConfig.getBracketInfo(text);
		if (!bracketInfo) return null;
		return {
			range: r,
			bracketInfo
		};
	}
};
function createDisposableRef(object, disposable) {
	return {
		object,
		dispose: () => disposable?.dispose()
	};
}
function createTimeBasedContinueBracketSearchPredicate(maxDuration) {
	if (typeof maxDuration === "undefined") return () => true;
	else {
		const startTime = Date.now();
		return () => {
			return Date.now() - startTime <= maxDuration;
		};
	}
}
var BracketSearchCanceled = class BracketSearchCanceled {
	static {
		this.INSTANCE = new BracketSearchCanceled();
	}
	constructor() {
		this._searchCanceledBrand = void 0;
	}
};
function stripBracketSearchCanceled(result) {
	if (result instanceof BracketSearchCanceled) return null;
	return result;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/bracketPairsTextModelPart/colorizedBracketPairsDecorationProvider.js
var ColorizedBracketPairsDecorationProvider = class extends Disposable {
	constructor(textModel) {
		super();
		this.textModel = textModel;
		this.colorProvider = new ColorProvider();
		this.onDidChangeEmitter = this._register(new Emitter$1());
		this.onDidChange = this.onDidChangeEmitter.event;
		this.colorizationOptions = textModel.getOptions().bracketPairColorizationOptions;
		this._register(textModel.bracketPairs.onDidChange((e) => {
			this.onDidChangeEmitter.fire();
		}));
	}
	handleDidChangeOptions(e) {
		this.colorizationOptions = this.textModel.getOptions().bracketPairColorizationOptions;
	}
	getDecorationsInRange(range, ownerId, filterOutValidation, filterFontDecorations, onlyMinimapDecorations) {
		if (onlyMinimapDecorations) return [];
		if (ownerId === void 0) return [];
		if (!this.colorizationOptions.enabled) return [];
		return this.textModel.bracketPairs.getBracketsInRange(range, true).map((bracket) => ({
			id: `bracket${bracket.range.toString()}-${bracket.nestingLevel}`,
			options: {
				description: "BracketPairColorization",
				inlineClassName: this.colorProvider.getInlineClassName(bracket, this.colorizationOptions.independentColorPoolPerBracketType)
			},
			ownerId: 0,
			range: bracket.range
		})).toArray();
	}
	getAllDecorations(ownerId, filterOutValidation, filterFontDecorations) {
		if (ownerId === void 0) return [];
		if (!this.colorizationOptions.enabled) return [];
		return this.getDecorationsInRange(new Range$2(1, 1, this.textModel.getLineCount(), 1), ownerId, filterOutValidation, filterFontDecorations);
	}
};
var ColorProvider = class {
	constructor() {
		this.unexpectedClosingBracketClassName = "unexpected-closing-bracket";
	}
	getInlineClassName(bracket, independentColorPoolPerBracketType) {
		if (bracket.isInvalid) return this.unexpectedClosingBracketClassName;
		return this.getInlineClassNameOfLevel(independentColorPoolPerBracketType ? bracket.nestingLevelOfEqualBracketType : bracket.nestingLevel);
	}
	getInlineClassNameOfLevel(level) {
		return `bracket-highlighting-${level % 30}`;
	}
};
registerThemingParticipant((theme, collector) => {
	const colors = [
		editorBracketHighlightingForeground1,
		editorBracketHighlightingForeground2,
		editorBracketHighlightingForeground3,
		editorBracketHighlightingForeground4,
		editorBracketHighlightingForeground5,
		editorBracketHighlightingForeground6
	];
	const colorProvider = new ColorProvider();
	collector.addRule(`.monaco-editor .${colorProvider.unexpectedClosingBracketClassName} { color: ${theme.getColor(editorBracketHighlightingUnexpectedBracketForeground)}; }`);
	const colorValues = colors.map((c) => theme.getColor(c)).filter((c) => !!c).filter((c) => !c.isTransparent());
	for (let level = 0; level < 30; level++) {
		const color = colorValues[level % colorValues.length];
		collector.addRule(`.monaco-editor .${colorProvider.getInlineClassNameOfLevel(level)} { color: ${color}; }`);
	}
});
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/core/textChange.js
function escapeNewLine(str) {
	return str.replace(/\n/g, "\\n").replace(/\r/g, "\\r");
}
var TextChange = class TextChange {
	get oldLength() {
		return this.oldText.length;
	}
	get oldEnd() {
		return this.oldPosition + this.oldText.length;
	}
	get newLength() {
		return this.newText.length;
	}
	get newEnd() {
		return this.newPosition + this.newText.length;
	}
	constructor(oldPosition, oldText, newPosition, newText) {
		this.oldPosition = oldPosition;
		this.oldText = oldText;
		this.newPosition = newPosition;
		this.newText = newText;
	}
	toString() {
		if (this.oldText.length === 0) return `(insert@${this.oldPosition} "${escapeNewLine(this.newText)}")`;
		if (this.newText.length === 0) return `(delete@${this.oldPosition} "${escapeNewLine(this.oldText)}")`;
		return `(replace@${this.oldPosition} "${escapeNewLine(this.oldText)}" with "${escapeNewLine(this.newText)}")`;
	}
	static _writeStringSize(str) {
		return 4 + 2 * str.length;
	}
	static _writeString(b, str, offset) {
		const len = str.length;
		writeUInt32BE(b, len, offset);
		offset += 4;
		for (let i = 0; i < len; i++) {
			writeUInt16LE(b, str.charCodeAt(i), offset);
			offset += 2;
		}
		return offset;
	}
	static _readString(b, offset) {
		const len = readUInt32BE(b, offset);
		offset += 4;
		return decodeUTF16LE(b, offset, len);
	}
	writeSize() {
		return 8 + TextChange._writeStringSize(this.oldText) + TextChange._writeStringSize(this.newText);
	}
	write(b, offset) {
		writeUInt32BE(b, this.oldPosition, offset);
		offset += 4;
		writeUInt32BE(b, this.newPosition, offset);
		offset += 4;
		offset = TextChange._writeString(b, this.oldText, offset);
		offset = TextChange._writeString(b, this.newText, offset);
		return offset;
	}
	static read(b, offset, dest) {
		const oldPosition = readUInt32BE(b, offset);
		offset += 4;
		const newPosition = readUInt32BE(b, offset);
		offset += 4;
		const oldText = TextChange._readString(b, offset);
		offset += TextChange._writeStringSize(oldText);
		const newText = TextChange._readString(b, offset);
		offset += TextChange._writeStringSize(newText);
		dest.push(new TextChange(oldPosition, oldText, newPosition, newText));
		return offset;
	}
};
function compressConsecutiveTextChanges(prevEdits, currEdits) {
	if (prevEdits === null || prevEdits.length === 0) return currEdits;
	return new TextChangeCompressor(prevEdits, currEdits).compress();
}
var TextChangeCompressor = class TextChangeCompressor {
	constructor(prevEdits, currEdits) {
		this._prevEdits = prevEdits;
		this._currEdits = currEdits;
		this._result = [];
		this._resultLen = 0;
		this._prevLen = this._prevEdits.length;
		this._prevDeltaOffset = 0;
		this._currLen = this._currEdits.length;
		this._currDeltaOffset = 0;
	}
	compress() {
		let prevIndex = 0;
		let currIndex = 0;
		let prevEdit = this._getPrev(prevIndex);
		let currEdit = this._getCurr(currIndex);
		while (prevIndex < this._prevLen || currIndex < this._currLen) {
			if (prevEdit === null) {
				this._acceptCurr(currEdit);
				currEdit = this._getCurr(++currIndex);
				continue;
			}
			if (currEdit === null) {
				this._acceptPrev(prevEdit);
				prevEdit = this._getPrev(++prevIndex);
				continue;
			}
			if (currEdit.oldEnd <= prevEdit.newPosition) {
				this._acceptCurr(currEdit);
				currEdit = this._getCurr(++currIndex);
				continue;
			}
			if (prevEdit.newEnd <= currEdit.oldPosition) {
				this._acceptPrev(prevEdit);
				prevEdit = this._getPrev(++prevIndex);
				continue;
			}
			if (currEdit.oldPosition < prevEdit.newPosition) {
				const [e1, e2] = TextChangeCompressor._splitCurr(currEdit, prevEdit.newPosition - currEdit.oldPosition);
				this._acceptCurr(e1);
				currEdit = e2;
				continue;
			}
			if (prevEdit.newPosition < currEdit.oldPosition) {
				const [e1, e2] = TextChangeCompressor._splitPrev(prevEdit, currEdit.oldPosition - prevEdit.newPosition);
				this._acceptPrev(e1);
				prevEdit = e2;
				continue;
			}
			let mergePrev;
			let mergeCurr;
			if (currEdit.oldEnd === prevEdit.newEnd) {
				mergePrev = prevEdit;
				mergeCurr = currEdit;
				prevEdit = this._getPrev(++prevIndex);
				currEdit = this._getCurr(++currIndex);
			} else if (currEdit.oldEnd < prevEdit.newEnd) {
				const [e1, e2] = TextChangeCompressor._splitPrev(prevEdit, currEdit.oldLength);
				mergePrev = e1;
				mergeCurr = currEdit;
				prevEdit = e2;
				currEdit = this._getCurr(++currIndex);
			} else {
				const [e1, e2] = TextChangeCompressor._splitCurr(currEdit, prevEdit.newLength);
				mergePrev = prevEdit;
				mergeCurr = e1;
				prevEdit = this._getPrev(++prevIndex);
				currEdit = e2;
			}
			this._result[this._resultLen++] = new TextChange(mergePrev.oldPosition, mergePrev.oldText, mergeCurr.newPosition, mergeCurr.newText);
			this._prevDeltaOffset += mergePrev.newLength - mergePrev.oldLength;
			this._currDeltaOffset += mergeCurr.newLength - mergeCurr.oldLength;
		}
		const merged = TextChangeCompressor._merge(this._result);
		return TextChangeCompressor._removeNoOps(merged);
	}
	_acceptCurr(currEdit) {
		this._result[this._resultLen++] = TextChangeCompressor._rebaseCurr(this._prevDeltaOffset, currEdit);
		this._currDeltaOffset += currEdit.newLength - currEdit.oldLength;
	}
	_getCurr(currIndex) {
		return currIndex < this._currLen ? this._currEdits[currIndex] : null;
	}
	_acceptPrev(prevEdit) {
		this._result[this._resultLen++] = TextChangeCompressor._rebasePrev(this._currDeltaOffset, prevEdit);
		this._prevDeltaOffset += prevEdit.newLength - prevEdit.oldLength;
	}
	_getPrev(prevIndex) {
		return prevIndex < this._prevLen ? this._prevEdits[prevIndex] : null;
	}
	static _rebaseCurr(prevDeltaOffset, currEdit) {
		return new TextChange(currEdit.oldPosition - prevDeltaOffset, currEdit.oldText, currEdit.newPosition, currEdit.newText);
	}
	static _rebasePrev(currDeltaOffset, prevEdit) {
		return new TextChange(prevEdit.oldPosition, prevEdit.oldText, prevEdit.newPosition + currDeltaOffset, prevEdit.newText);
	}
	static _splitPrev(edit, offset) {
		const preText = edit.newText.substr(0, offset);
		const postText = edit.newText.substr(offset);
		return [new TextChange(edit.oldPosition, edit.oldText, edit.newPosition, preText), new TextChange(edit.oldEnd, "", edit.newPosition + offset, postText)];
	}
	static _splitCurr(edit, offset) {
		const preText = edit.oldText.substr(0, offset);
		const postText = edit.oldText.substr(offset);
		return [new TextChange(edit.oldPosition, preText, edit.newPosition, edit.newText), new TextChange(edit.oldPosition + offset, postText, edit.newEnd, "")];
	}
	static _merge(edits) {
		if (edits.length === 0) return edits;
		const result = [];
		let resultLen = 0;
		let prev = edits[0];
		for (let i = 1; i < edits.length; i++) {
			const curr = edits[i];
			if (prev.oldEnd === curr.oldPosition) prev = new TextChange(prev.oldPosition, prev.oldText + curr.oldText, prev.newPosition, prev.newText + curr.newText);
			else {
				result[resultLen++] = prev;
				prev = curr;
			}
		}
		result[resultLen++] = prev;
		return result;
	}
	static _removeNoOps(edits) {
		if (edits.length === 0) return edits;
		const result = [];
		let resultLen = 0;
		for (let i = 0; i < edits.length; i++) {
			const edit = edits[i];
			if (edit.oldText === edit.newText) continue;
			result[resultLen++] = edit;
		}
		return result;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/editStack.js
function uriGetComparisonKey(resource) {
	return resource.toString();
}
var SingleModelEditStackData = class SingleModelEditStackData {
	static create(model, beforeCursorState) {
		const alternativeVersionId = model.getAlternativeVersionId();
		const eol = getModelEOL(model);
		return new SingleModelEditStackData(alternativeVersionId, alternativeVersionId, eol, eol, beforeCursorState, beforeCursorState, []);
	}
	constructor(beforeVersionId, afterVersionId, beforeEOL, afterEOL, beforeCursorState, afterCursorState, changes) {
		this.beforeVersionId = beforeVersionId;
		this.afterVersionId = afterVersionId;
		this.beforeEOL = beforeEOL;
		this.afterEOL = afterEOL;
		this.beforeCursorState = beforeCursorState;
		this.afterCursorState = afterCursorState;
		this.changes = changes;
	}
	append(model, textChanges, afterEOL, afterVersionId, afterCursorState) {
		if (textChanges.length > 0) this.changes = compressConsecutiveTextChanges(this.changes, textChanges);
		this.afterEOL = afterEOL;
		this.afterVersionId = afterVersionId;
		this.afterCursorState = afterCursorState;
	}
	static _writeSelectionsSize(selections) {
		return 4 + 16 * (selections ? selections.length : 0);
	}
	static _writeSelections(b, selections, offset) {
		writeUInt32BE(b, selections ? selections.length : 0, offset);
		offset += 4;
		if (selections) for (const selection of selections) {
			writeUInt32BE(b, selection.selectionStartLineNumber, offset);
			offset += 4;
			writeUInt32BE(b, selection.selectionStartColumn, offset);
			offset += 4;
			writeUInt32BE(b, selection.positionLineNumber, offset);
			offset += 4;
			writeUInt32BE(b, selection.positionColumn, offset);
			offset += 4;
		}
		return offset;
	}
	static _readSelections(b, offset, dest) {
		const count = readUInt32BE(b, offset);
		offset += 4;
		for (let i = 0; i < count; i++) {
			const selectionStartLineNumber = readUInt32BE(b, offset);
			offset += 4;
			const selectionStartColumn = readUInt32BE(b, offset);
			offset += 4;
			const positionLineNumber = readUInt32BE(b, offset);
			offset += 4;
			const positionColumn = readUInt32BE(b, offset);
			offset += 4;
			dest.push(new Selection$1(selectionStartLineNumber, selectionStartColumn, positionLineNumber, positionColumn));
		}
		return offset;
	}
	serialize() {
		let necessarySize = 10 + SingleModelEditStackData._writeSelectionsSize(this.beforeCursorState) + SingleModelEditStackData._writeSelectionsSize(this.afterCursorState) + 4;
		for (const change of this.changes) necessarySize += change.writeSize();
		const b = new Uint8Array(necessarySize);
		let offset = 0;
		writeUInt32BE(b, this.beforeVersionId, offset);
		offset += 4;
		writeUInt32BE(b, this.afterVersionId, offset);
		offset += 4;
		writeUInt8(b, this.beforeEOL, offset);
		offset += 1;
		writeUInt8(b, this.afterEOL, offset);
		offset += 1;
		offset = SingleModelEditStackData._writeSelections(b, this.beforeCursorState, offset);
		offset = SingleModelEditStackData._writeSelections(b, this.afterCursorState, offset);
		writeUInt32BE(b, this.changes.length, offset);
		offset += 4;
		for (const change of this.changes) offset = change.write(b, offset);
		return b.buffer;
	}
	static deserialize(source) {
		const b = new Uint8Array(source);
		let offset = 0;
		const beforeVersionId = readUInt32BE(b, offset);
		offset += 4;
		const afterVersionId = readUInt32BE(b, offset);
		offset += 4;
		const beforeEOL = readUInt8(b, offset);
		offset += 1;
		const afterEOL = readUInt8(b, offset);
		offset += 1;
		const beforeCursorState = [];
		offset = SingleModelEditStackData._readSelections(b, offset, beforeCursorState);
		const afterCursorState = [];
		offset = SingleModelEditStackData._readSelections(b, offset, afterCursorState);
		const changeCount = readUInt32BE(b, offset);
		offset += 4;
		const changes = [];
		for (let i = 0; i < changeCount; i++) offset = TextChange.read(b, offset, changes);
		return new SingleModelEditStackData(beforeVersionId, afterVersionId, beforeEOL, afterEOL, beforeCursorState, afterCursorState, changes);
	}
};
var SingleModelEditStackElement = class {
	get type() {
		return 0;
	}
	get resource() {
		if (URI.isUri(this.model)) return this.model;
		return this.model.uri;
	}
	constructor(label, code, model, beforeCursorState) {
		this.label = label;
		this.code = code;
		this.model = model;
		this._data = SingleModelEditStackData.create(model, beforeCursorState);
	}
	toString() {
		return (this._data instanceof SingleModelEditStackData ? this._data : SingleModelEditStackData.deserialize(this._data)).changes.map((change) => change.toString()).join(", ");
	}
	matchesResource(resource) {
		return (URI.isUri(this.model) ? this.model : this.model.uri).toString() === resource.toString();
	}
	setModel(model) {
		this.model = model;
	}
	canAppend(model) {
		return this.model === model && this._data instanceof SingleModelEditStackData;
	}
	append(model, textChanges, afterEOL, afterVersionId, afterCursorState) {
		if (this._data instanceof SingleModelEditStackData) this._data.append(model, textChanges, afterEOL, afterVersionId, afterCursorState);
	}
	close() {
		if (this._data instanceof SingleModelEditStackData) this._data = this._data.serialize();
	}
	open() {
		if (!(this._data instanceof SingleModelEditStackData)) this._data = SingleModelEditStackData.deserialize(this._data);
	}
	undo() {
		if (URI.isUri(this.model)) throw new Error(`Invalid SingleModelEditStackElement`);
		if (this._data instanceof SingleModelEditStackData) this._data = this._data.serialize();
		const data = SingleModelEditStackData.deserialize(this._data);
		this.model._applyUndo(data.changes, data.beforeEOL, data.beforeVersionId, data.beforeCursorState);
	}
	redo() {
		if (URI.isUri(this.model)) throw new Error(`Invalid SingleModelEditStackElement`);
		if (this._data instanceof SingleModelEditStackData) this._data = this._data.serialize();
		const data = SingleModelEditStackData.deserialize(this._data);
		this.model._applyRedo(data.changes, data.afterEOL, data.afterVersionId, data.afterCursorState);
	}
	heapSize() {
		if (this._data instanceof SingleModelEditStackData) this._data = this._data.serialize();
		return this._data.byteLength + 168;
	}
};
var MultiModelEditStackElement = class {
	get resources() {
		return this._editStackElementsArr.map((editStackElement) => editStackElement.resource);
	}
	constructor(label, code, editStackElements) {
		this.label = label;
		this.code = code;
		this.type = 1;
		this._isOpen = true;
		this._editStackElementsArr = editStackElements.slice(0);
		this._editStackElementsMap = /* @__PURE__ */ new Map();
		for (const editStackElement of this._editStackElementsArr) {
			const key = uriGetComparisonKey(editStackElement.resource);
			this._editStackElementsMap.set(key, editStackElement);
		}
		this._delegate = null;
	}
	prepareUndoRedo() {
		if (this._delegate) return this._delegate.prepareUndoRedo(this);
	}
	matchesResource(resource) {
		const key = uriGetComparisonKey(resource);
		return this._editStackElementsMap.has(key);
	}
	setModel(model) {
		const key = uriGetComparisonKey(URI.isUri(model) ? model : model.uri);
		if (this._editStackElementsMap.has(key)) this._editStackElementsMap.get(key).setModel(model);
	}
	canAppend(model) {
		if (!this._isOpen) return false;
		const key = uriGetComparisonKey(model.uri);
		if (this._editStackElementsMap.has(key)) return this._editStackElementsMap.get(key).canAppend(model);
		return false;
	}
	append(model, textChanges, afterEOL, afterVersionId, afterCursorState) {
		const key = uriGetComparisonKey(model.uri);
		this._editStackElementsMap.get(key).append(model, textChanges, afterEOL, afterVersionId, afterCursorState);
	}
	close() {
		this._isOpen = false;
	}
	open() {}
	undo() {
		this._isOpen = false;
		for (const editStackElement of this._editStackElementsArr) editStackElement.undo();
	}
	redo() {
		for (const editStackElement of this._editStackElementsArr) editStackElement.redo();
	}
	heapSize(resource) {
		const key = uriGetComparisonKey(resource);
		if (this._editStackElementsMap.has(key)) return this._editStackElementsMap.get(key).heapSize();
		return 0;
	}
	split() {
		return this._editStackElementsArr;
	}
	toString() {
		const result = [];
		for (const editStackElement of this._editStackElementsArr) result.push(`${basename(editStackElement.resource)}: ${editStackElement}`);
		return `{${result.join(", ")}}`;
	}
};
function getModelEOL(model) {
	if (model.getEOL() === "\n") return 0;
	else return 1;
}
function isEditStackElement(element) {
	if (!element) return false;
	return element instanceof SingleModelEditStackElement || element instanceof MultiModelEditStackElement;
}
var EditStack = class EditStack {
	constructor(model, undoRedoService) {
		this._model = model;
		this._undoRedoService = undoRedoService;
	}
	pushStackElement() {
		const lastElement = this._undoRedoService.getLastElement(this._model.uri);
		if (isEditStackElement(lastElement)) lastElement.close();
	}
	popStackElement() {
		const lastElement = this._undoRedoService.getLastElement(this._model.uri);
		if (isEditStackElement(lastElement)) lastElement.open();
	}
	clear() {
		this._undoRedoService.removeElements(this._model.uri);
	}
	_getOrCreateEditStackElement(beforeCursorState, group) {
		const lastElement = this._undoRedoService.getLastElement(this._model.uri);
		if (isEditStackElement(lastElement) && lastElement.canAppend(this._model)) return lastElement;
		const newElement = new SingleModelEditStackElement(localize(835, "Typing"), "undoredo.textBufferEdit", this._model, beforeCursorState);
		this._undoRedoService.pushElement(newElement, group);
		return newElement;
	}
	pushEOL(eol) {
		const editStackElement = this._getOrCreateEditStackElement(null, void 0);
		this._model.setEOL(eol);
		editStackElement.append(this._model, [], getModelEOL(this._model), this._model.getAlternativeVersionId(), null);
	}
	pushEditOperation(beforeCursorState, editOperations, cursorStateComputer, group, reason = EditSources.unknown({ name: "pushEditOperation" })) {
		const editStackElement = this._getOrCreateEditStackElement(beforeCursorState, group);
		const inverseEditOperations = this._model.applyEdits(editOperations, true, reason);
		const afterCursorState = EditStack._computeCursorState(cursorStateComputer, inverseEditOperations);
		const textChanges = inverseEditOperations.map((op, index) => ({
			index,
			textChange: op.textChange
		}));
		textChanges.sort((a, b) => {
			if (a.textChange.oldPosition === b.textChange.oldPosition) return a.index - b.index;
			return a.textChange.oldPosition - b.textChange.oldPosition;
		});
		editStackElement.append(this._model, textChanges.map((op) => op.textChange), getModelEOL(this._model), this._model.getAlternativeVersionId(), afterCursorState);
		return afterCursorState;
	}
	static _computeCursorState(cursorStateComputer, inverseEditOperations) {
		try {
			return cursorStateComputer ? cursorStateComputer(inverseEditOperations) : null;
		} catch (e) {
			onUnexpectedError(e);
			return null;
		}
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/indentationGuesser.js
var SpacesDiffResult = class {
	constructor() {
		this.spacesDiff = 0;
		this.looksLikeAlignment = false;
	}
};
/**
* Compute the diff in spaces between two line's indentation.
*/
function spacesDiff(a, aLength, b, bLength, result) {
	result.spacesDiff = 0;
	result.looksLikeAlignment = false;
	let i = 0;
	for (; i < aLength && i < bLength; i++) if (a.charCodeAt(i) !== b.charCodeAt(i)) break;
	let aSpacesCnt = 0, aTabsCount = 0;
	for (let j = i; j < aLength; j++) if (a.charCodeAt(j) === 32) aSpacesCnt++;
	else aTabsCount++;
	let bSpacesCnt = 0, bTabsCount = 0;
	for (let j = i; j < bLength; j++) if (b.charCodeAt(j) === 32) bSpacesCnt++;
	else bTabsCount++;
	if (aSpacesCnt > 0 && aTabsCount > 0) return;
	if (bSpacesCnt > 0 && bTabsCount > 0) return;
	const tabsDiff = Math.abs(aTabsCount - bTabsCount);
	const spacesDiff = Math.abs(aSpacesCnt - bSpacesCnt);
	if (tabsDiff === 0) {
		result.spacesDiff = spacesDiff;
		if (spacesDiff > 0 && 0 <= bSpacesCnt - 1 && bSpacesCnt - 1 < a.length && bSpacesCnt < b.length) {
			if (b.charCodeAt(bSpacesCnt) !== 32 && a.charCodeAt(bSpacesCnt - 1) === 32) {
				if (a.charCodeAt(a.length - 1) === 44) result.looksLikeAlignment = true;
			}
		}
		return;
	}
	if (spacesDiff % tabsDiff === 0) {
		result.spacesDiff = spacesDiff / tabsDiff;
		return;
	}
}
function guessIndentation(source, defaultTabSize, defaultInsertSpaces) {
	const linesCount = Math.min(source.getLineCount(), 1e4);
	let linesIndentedWithTabsCount = 0;
	let linesIndentedWithSpacesCount = 0;
	let previousLineText = "";
	let previousLineIndentation = 0;
	const ALLOWED_TAB_SIZE_GUESSES = [
		2,
		4,
		6,
		8,
		3,
		5,
		7
	];
	const MAX_ALLOWED_TAB_SIZE_GUESS = 8;
	const spacesDiffCount = [
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0
	];
	const tmp = new SpacesDiffResult();
	for (let lineNumber = 1; lineNumber <= linesCount; lineNumber++) {
		const currentLineLength = source.getLineLength(lineNumber);
		const currentLineText = source.getLineContent(lineNumber);
		const useCurrentLineText = currentLineLength <= 65536;
		let currentLineHasContent = false;
		let currentLineIndentation = 0;
		let currentLineSpacesCount = 0;
		let currentLineTabsCount = 0;
		for (let j = 0, lenJ = currentLineLength; j < lenJ; j++) {
			const charCode = useCurrentLineText ? currentLineText.charCodeAt(j) : source.getLineCharCode(lineNumber, j);
			if (charCode === 9) currentLineTabsCount++;
			else if (charCode === 32) currentLineSpacesCount++;
			else {
				currentLineHasContent = true;
				currentLineIndentation = j;
				break;
			}
		}
		if (!currentLineHasContent) continue;
		if (currentLineTabsCount > 0) linesIndentedWithTabsCount++;
		else if (currentLineSpacesCount > 1) linesIndentedWithSpacesCount++;
		spacesDiff(previousLineText, previousLineIndentation, currentLineText, currentLineIndentation, tmp);
		if (tmp.looksLikeAlignment) {
			if (!(defaultInsertSpaces && defaultTabSize === tmp.spacesDiff)) continue;
		}
		const currentSpacesDiff = tmp.spacesDiff;
		if (currentSpacesDiff <= MAX_ALLOWED_TAB_SIZE_GUESS) spacesDiffCount[currentSpacesDiff]++;
		previousLineText = currentLineText;
		previousLineIndentation = currentLineIndentation;
	}
	let insertSpaces = defaultInsertSpaces;
	if (linesIndentedWithTabsCount !== linesIndentedWithSpacesCount) insertSpaces = linesIndentedWithTabsCount < linesIndentedWithSpacesCount;
	let tabSize = defaultTabSize;
	if (insertSpaces) {
		let tabSizeScore = 0;
		ALLOWED_TAB_SIZE_GUESSES.forEach((possibleTabSize) => {
			const possibleTabSizeScore = spacesDiffCount[possibleTabSize];
			if (possibleTabSizeScore > tabSizeScore) {
				tabSizeScore = possibleTabSizeScore;
				tabSize = possibleTabSize;
			}
		});
		if (tabSize === 4 && spacesDiffCount[4] > 0 && spacesDiffCount[2] > 0 && spacesDiffCount[2] >= spacesDiffCount[4] * 2 / 3) tabSize = 2;
	}
	return {
		insertSpaces,
		tabSize
	};
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/intervalTree.js
function getNodeColor(node) {
	return (node.metadata & 1) >>> 0;
}
function setNodeColor(node, color) {
	node.metadata = node.metadata & 254 | color << 0;
}
function getNodeIsVisited(node) {
	return (node.metadata & 2) >>> 1 === 1;
}
function setNodeIsVisited(node, value) {
	node.metadata = node.metadata & 253 | (value ? 1 : 0) << 1;
}
function getNodeIsForValidation(node) {
	return (node.metadata & 4) >>> 2 === 1;
}
function setNodeIsForValidation(node, value) {
	node.metadata = node.metadata & 251 | (value ? 1 : 0) << 2;
}
function getNodeIsInGlyphMargin(node) {
	return (node.metadata & 64) >>> 6 === 1;
}
function setNodeIsInGlyphMargin(node, value) {
	node.metadata = node.metadata & 191 | (value ? 1 : 0) << 6;
}
function getNodeAffectsFont(node) {
	return (node.metadata & 128) >>> 7 === 1;
}
function setNodeAffectsFont(node, value) {
	node.metadata = node.metadata & 127 | (value ? 1 : 0) << 7;
}
function getNodeStickiness(node) {
	return (node.metadata & 24) >>> 3;
}
function _setNodeStickiness(node, stickiness) {
	node.metadata = node.metadata & 231 | stickiness << 3;
}
function getCollapseOnReplaceEdit(node) {
	return (node.metadata & 32) >>> 5 === 1;
}
function setCollapseOnReplaceEdit(node, value) {
	node.metadata = node.metadata & 223 | (value ? 1 : 0) << 5;
}
var IntervalNode = class {
	constructor(id, start, end) {
		this.metadata = 0;
		this.parent = this;
		this.left = this;
		this.right = this;
		setNodeColor(this, 1);
		this.start = start;
		this.end = end;
		this.delta = 0;
		this.maxEnd = end;
		this.id = id;
		this.ownerId = 0;
		this.options = null;
		setNodeIsForValidation(this, false);
		setNodeIsInGlyphMargin(this, false);
		_setNodeStickiness(this, 1);
		setCollapseOnReplaceEdit(this, false);
		setNodeAffectsFont(this, false);
		this.cachedVersionId = 0;
		this.cachedAbsoluteStart = start;
		this.cachedAbsoluteEnd = end;
		this.range = null;
		setNodeIsVisited(this, false);
	}
	reset(versionId, start, end, range) {
		this.start = start;
		this.end = end;
		this.maxEnd = end;
		this.cachedVersionId = versionId;
		this.cachedAbsoluteStart = start;
		this.cachedAbsoluteEnd = end;
		this.range = range;
	}
	setOptions(options) {
		this.options = options;
		const className = this.options.className;
		setNodeIsForValidation(this, className === "squiggly-error" || className === "squiggly-warning" || className === "squiggly-info");
		setNodeIsInGlyphMargin(this, this.options.glyphMarginClassName !== null);
		_setNodeStickiness(this, this.options.stickiness);
		setCollapseOnReplaceEdit(this, this.options.collapseOnReplaceEdit);
		setNodeAffectsFont(this, this.options.affectsFont ?? false);
	}
	setCachedOffsets(absoluteStart, absoluteEnd, cachedVersionId) {
		if (this.cachedVersionId !== cachedVersionId) this.range = null;
		this.cachedVersionId = cachedVersionId;
		this.cachedAbsoluteStart = absoluteStart;
		this.cachedAbsoluteEnd = absoluteEnd;
	}
	detach() {
		this.parent = null;
		this.left = null;
		this.right = null;
	}
};
var SENTINEL$1 = new IntervalNode(null, 0, 0);
SENTINEL$1.parent = SENTINEL$1;
SENTINEL$1.left = SENTINEL$1;
SENTINEL$1.right = SENTINEL$1;
setNodeColor(SENTINEL$1, 0);
var IntervalTree = class {
	constructor() {
		this.root = SENTINEL$1;
		this.requestNormalizeDelta = false;
	}
	intervalSearch(start, end, filterOwnerId, filterOutValidation, filterFontDecorations, cachedVersionId, onlyMarginDecorations) {
		if (this.root === SENTINEL$1) return [];
		return intervalSearch(this, start, end, filterOwnerId, filterOutValidation, filterFontDecorations, cachedVersionId, onlyMarginDecorations);
	}
	search(filterOwnerId, filterOutValidation, filterFontDecorations, cachedVersionId, onlyMarginDecorations) {
		if (this.root === SENTINEL$1) return [];
		return search(this, filterOwnerId, filterOutValidation, filterFontDecorations, cachedVersionId, onlyMarginDecorations);
	}
	/**
	* Will not set `cachedAbsoluteStart` nor `cachedAbsoluteEnd` on the returned nodes!
	*/
	collectNodesFromOwner(ownerId) {
		return collectNodesFromOwner(this, ownerId);
	}
	/**
	* Will not set `cachedAbsoluteStart` nor `cachedAbsoluteEnd` on the returned nodes!
	*/
	collectNodesPostOrder() {
		return collectNodesPostOrder(this);
	}
	insert(node) {
		rbTreeInsert(this, node);
		this._normalizeDeltaIfNecessary();
	}
	delete(node) {
		rbTreeDelete(this, node);
		this._normalizeDeltaIfNecessary();
	}
	resolveNode(node, cachedVersionId) {
		const initialNode = node;
		let delta = 0;
		while (node !== this.root) {
			if (node === node.parent.right) delta += node.parent.delta;
			node = node.parent;
		}
		const nodeStart = initialNode.start + delta;
		const nodeEnd = initialNode.end + delta;
		initialNode.setCachedOffsets(nodeStart, nodeEnd, cachedVersionId);
	}
	acceptReplace(offset, length, textLength, forceMoveMarkers) {
		const nodesOfInterest = searchForEditing(this, offset, offset + length);
		for (let i = 0, len = nodesOfInterest.length; i < len; i++) {
			const node = nodesOfInterest[i];
			rbTreeDelete(this, node);
		}
		this._normalizeDeltaIfNecessary();
		noOverlapReplace(this, offset, offset + length, textLength);
		this._normalizeDeltaIfNecessary();
		for (let i = 0, len = nodesOfInterest.length; i < len; i++) {
			const node = nodesOfInterest[i];
			node.start = node.cachedAbsoluteStart;
			node.end = node.cachedAbsoluteEnd;
			nodeAcceptEdit(node, offset, offset + length, textLength, forceMoveMarkers);
			node.maxEnd = node.end;
			rbTreeInsert(this, node);
		}
		this._normalizeDeltaIfNecessary();
	}
	_normalizeDeltaIfNecessary() {
		if (!this.requestNormalizeDelta) return;
		this.requestNormalizeDelta = false;
		normalizeDelta(this);
	}
};
function normalizeDelta(T) {
	let node = T.root;
	let delta = 0;
	while (node !== SENTINEL$1) {
		if (node.left !== SENTINEL$1 && !getNodeIsVisited(node.left)) {
			node = node.left;
			continue;
		}
		if (node.right !== SENTINEL$1 && !getNodeIsVisited(node.right)) {
			delta += node.delta;
			node = node.right;
			continue;
		}
		node.start = delta + node.start;
		node.end = delta + node.end;
		node.delta = 0;
		recomputeMaxEnd(node);
		setNodeIsVisited(node, true);
		setNodeIsVisited(node.left, false);
		setNodeIsVisited(node.right, false);
		if (node === node.parent.right) delta -= node.parent.delta;
		node = node.parent;
	}
	setNodeIsVisited(T.root, false);
}
function adjustMarkerBeforeColumn(markerOffset, markerStickToPreviousCharacter, checkOffset, moveSemantics) {
	if (markerOffset < checkOffset) return true;
	if (markerOffset > checkOffset) return false;
	if (moveSemantics === 1) return false;
	if (moveSemantics === 2) return true;
	return markerStickToPreviousCharacter;
}
/**
* This is a lot more complicated than strictly necessary to maintain the same behaviour
* as when decorations were implemented using two markers.
*/
function nodeAcceptEdit(node, start, end, textLength, forceMoveMarkers) {
	const nodeStickiness = getNodeStickiness(node);
	const startStickToPreviousCharacter = nodeStickiness === 0 || nodeStickiness === 2;
	const endStickToPreviousCharacter = nodeStickiness === 1 || nodeStickiness === 2;
	const deletingCnt = end - start;
	const insertingCnt = textLength;
	const commonLength = Math.min(deletingCnt, insertingCnt);
	const nodeStart = node.start;
	let startDone = false;
	const nodeEnd = node.end;
	let endDone = false;
	if (start <= nodeStart && nodeEnd <= end && getCollapseOnReplaceEdit(node)) {
		node.start = start;
		startDone = true;
		node.end = start;
		endDone = true;
	}
	{
		const moveSemantics = forceMoveMarkers ? 1 : deletingCnt > 0 ? 2 : 0;
		if (!startDone && adjustMarkerBeforeColumn(nodeStart, startStickToPreviousCharacter, start, moveSemantics)) startDone = true;
		if (!endDone && adjustMarkerBeforeColumn(nodeEnd, endStickToPreviousCharacter, start, moveSemantics)) endDone = true;
	}
	if (commonLength > 0 && !forceMoveMarkers) {
		const moveSemantics = deletingCnt > insertingCnt ? 2 : 0;
		if (!startDone && adjustMarkerBeforeColumn(nodeStart, startStickToPreviousCharacter, start + commonLength, moveSemantics)) startDone = true;
		if (!endDone && adjustMarkerBeforeColumn(nodeEnd, endStickToPreviousCharacter, start + commonLength, moveSemantics)) endDone = true;
	}
	{
		const moveSemantics = forceMoveMarkers ? 1 : 0;
		if (!startDone && adjustMarkerBeforeColumn(nodeStart, startStickToPreviousCharacter, end, moveSemantics)) {
			node.start = start + insertingCnt;
			startDone = true;
		}
		if (!endDone && adjustMarkerBeforeColumn(nodeEnd, endStickToPreviousCharacter, end, moveSemantics)) {
			node.end = start + insertingCnt;
			endDone = true;
		}
	}
	const deltaColumn = insertingCnt - deletingCnt;
	if (!startDone) node.start = Math.max(0, nodeStart + deltaColumn);
	if (!endDone) node.end = Math.max(0, nodeEnd + deltaColumn);
	if (node.start > node.end) node.end = node.start;
}
function searchForEditing(T, start, end) {
	let node = T.root;
	let delta = 0;
	let nodeMaxEnd = 0;
	let nodeStart = 0;
	let nodeEnd = 0;
	const result = [];
	let resultLen = 0;
	while (node !== SENTINEL$1) {
		if (getNodeIsVisited(node)) {
			setNodeIsVisited(node.left, false);
			setNodeIsVisited(node.right, false);
			if (node === node.parent.right) delta -= node.parent.delta;
			node = node.parent;
			continue;
		}
		if (!getNodeIsVisited(node.left)) {
			nodeMaxEnd = delta + node.maxEnd;
			if (nodeMaxEnd < start) {
				setNodeIsVisited(node, true);
				continue;
			}
			if (node.left !== SENTINEL$1) {
				node = node.left;
				continue;
			}
		}
		nodeStart = delta + node.start;
		if (nodeStart > end) {
			setNodeIsVisited(node, true);
			continue;
		}
		nodeEnd = delta + node.end;
		if (nodeEnd >= start) {
			node.setCachedOffsets(nodeStart, nodeEnd, 0);
			result[resultLen++] = node;
		}
		setNodeIsVisited(node, true);
		if (node.right !== SENTINEL$1 && !getNodeIsVisited(node.right)) {
			delta += node.delta;
			node = node.right;
			continue;
		}
	}
	setNodeIsVisited(T.root, false);
	return result;
}
function noOverlapReplace(T, start, end, textLength) {
	let node = T.root;
	let delta = 0;
	let nodeMaxEnd = 0;
	let nodeStart = 0;
	const editDelta = textLength - (end - start);
	while (node !== SENTINEL$1) {
		if (getNodeIsVisited(node)) {
			setNodeIsVisited(node.left, false);
			setNodeIsVisited(node.right, false);
			if (node === node.parent.right) delta -= node.parent.delta;
			recomputeMaxEnd(node);
			node = node.parent;
			continue;
		}
		if (!getNodeIsVisited(node.left)) {
			nodeMaxEnd = delta + node.maxEnd;
			if (nodeMaxEnd < start) {
				setNodeIsVisited(node, true);
				continue;
			}
			if (node.left !== SENTINEL$1) {
				node = node.left;
				continue;
			}
		}
		nodeStart = delta + node.start;
		if (nodeStart > end) {
			node.start += editDelta;
			node.end += editDelta;
			node.delta += editDelta;
			if (node.delta < -1073741824 || node.delta > 1073741824) T.requestNormalizeDelta = true;
			setNodeIsVisited(node, true);
			continue;
		}
		setNodeIsVisited(node, true);
		if (node.right !== SENTINEL$1 && !getNodeIsVisited(node.right)) {
			delta += node.delta;
			node = node.right;
			continue;
		}
	}
	setNodeIsVisited(T.root, false);
}
function collectNodesFromOwner(T, ownerId) {
	let node = T.root;
	const result = [];
	let resultLen = 0;
	while (node !== SENTINEL$1) {
		if (getNodeIsVisited(node)) {
			setNodeIsVisited(node.left, false);
			setNodeIsVisited(node.right, false);
			node = node.parent;
			continue;
		}
		if (node.left !== SENTINEL$1 && !getNodeIsVisited(node.left)) {
			node = node.left;
			continue;
		}
		if (node.ownerId === ownerId) result[resultLen++] = node;
		setNodeIsVisited(node, true);
		if (node.right !== SENTINEL$1 && !getNodeIsVisited(node.right)) {
			node = node.right;
			continue;
		}
	}
	setNodeIsVisited(T.root, false);
	return result;
}
function collectNodesPostOrder(T) {
	let node = T.root;
	const result = [];
	let resultLen = 0;
	while (node !== SENTINEL$1) {
		if (getNodeIsVisited(node)) {
			setNodeIsVisited(node.left, false);
			setNodeIsVisited(node.right, false);
			node = node.parent;
			continue;
		}
		if (node.left !== SENTINEL$1 && !getNodeIsVisited(node.left)) {
			node = node.left;
			continue;
		}
		if (node.right !== SENTINEL$1 && !getNodeIsVisited(node.right)) {
			node = node.right;
			continue;
		}
		result[resultLen++] = node;
		setNodeIsVisited(node, true);
	}
	setNodeIsVisited(T.root, false);
	return result;
}
function search(T, filterOwnerId, filterOutValidation, filterFontDecorations, cachedVersionId, onlyMarginDecorations) {
	let node = T.root;
	let delta = 0;
	let nodeStart = 0;
	let nodeEnd = 0;
	const result = [];
	let resultLen = 0;
	while (node !== SENTINEL$1) {
		if (getNodeIsVisited(node)) {
			setNodeIsVisited(node.left, false);
			setNodeIsVisited(node.right, false);
			if (node === node.parent.right) delta -= node.parent.delta;
			node = node.parent;
			continue;
		}
		if (node.left !== SENTINEL$1 && !getNodeIsVisited(node.left)) {
			node = node.left;
			continue;
		}
		nodeStart = delta + node.start;
		nodeEnd = delta + node.end;
		node.setCachedOffsets(nodeStart, nodeEnd, cachedVersionId);
		let include = true;
		if (filterOwnerId && node.ownerId && node.ownerId !== filterOwnerId) include = false;
		if (filterOutValidation && getNodeIsForValidation(node)) include = false;
		if (filterFontDecorations && getNodeAffectsFont(node)) include = false;
		if (onlyMarginDecorations && !getNodeIsInGlyphMargin(node)) include = false;
		if (include) result[resultLen++] = node;
		setNodeIsVisited(node, true);
		if (node.right !== SENTINEL$1 && !getNodeIsVisited(node.right)) {
			delta += node.delta;
			node = node.right;
			continue;
		}
	}
	setNodeIsVisited(T.root, false);
	return result;
}
function intervalSearch(T, intervalStart, intervalEnd, filterOwnerId, filterOutValidation, filterFontDecorations, cachedVersionId, onlyMarginDecorations) {
	let node = T.root;
	let delta = 0;
	let nodeMaxEnd = 0;
	let nodeStart = 0;
	let nodeEnd = 0;
	const result = [];
	let resultLen = 0;
	while (node !== SENTINEL$1) {
		if (getNodeIsVisited(node)) {
			setNodeIsVisited(node.left, false);
			setNodeIsVisited(node.right, false);
			if (node === node.parent.right) delta -= node.parent.delta;
			node = node.parent;
			continue;
		}
		if (!getNodeIsVisited(node.left)) {
			nodeMaxEnd = delta + node.maxEnd;
			if (nodeMaxEnd < intervalStart) {
				setNodeIsVisited(node, true);
				continue;
			}
			if (node.left !== SENTINEL$1) {
				node = node.left;
				continue;
			}
		}
		nodeStart = delta + node.start;
		if (nodeStart > intervalEnd) {
			setNodeIsVisited(node, true);
			continue;
		}
		nodeEnd = delta + node.end;
		if (nodeEnd >= intervalStart) {
			node.setCachedOffsets(nodeStart, nodeEnd, cachedVersionId);
			let include = true;
			if (filterOwnerId && node.ownerId && node.ownerId !== filterOwnerId) include = false;
			if (filterOutValidation && getNodeIsForValidation(node)) include = false;
			if (filterFontDecorations && getNodeAffectsFont(node)) include = false;
			if (onlyMarginDecorations && !getNodeIsInGlyphMargin(node)) include = false;
			if (include) result[resultLen++] = node;
		}
		setNodeIsVisited(node, true);
		if (node.right !== SENTINEL$1 && !getNodeIsVisited(node.right)) {
			delta += node.delta;
			node = node.right;
			continue;
		}
	}
	setNodeIsVisited(T.root, false);
	return result;
}
function rbTreeInsert(T, newNode) {
	if (T.root === SENTINEL$1) {
		newNode.parent = SENTINEL$1;
		newNode.left = SENTINEL$1;
		newNode.right = SENTINEL$1;
		setNodeColor(newNode, 0);
		T.root = newNode;
		return T.root;
	}
	treeInsert(T, newNode);
	recomputeMaxEndWalkToRoot(newNode.parent);
	let x = newNode;
	while (x !== T.root && getNodeColor(x.parent) === 1) if (x.parent === x.parent.parent.left) {
		const y = x.parent.parent.right;
		if (getNodeColor(y) === 1) {
			setNodeColor(x.parent, 0);
			setNodeColor(y, 0);
			setNodeColor(x.parent.parent, 1);
			x = x.parent.parent;
		} else {
			if (x === x.parent.right) {
				x = x.parent;
				leftRotate$1(T, x);
			}
			setNodeColor(x.parent, 0);
			setNodeColor(x.parent.parent, 1);
			rightRotate$1(T, x.parent.parent);
		}
	} else {
		const y = x.parent.parent.left;
		if (getNodeColor(y) === 1) {
			setNodeColor(x.parent, 0);
			setNodeColor(y, 0);
			setNodeColor(x.parent.parent, 1);
			x = x.parent.parent;
		} else {
			if (x === x.parent.left) {
				x = x.parent;
				rightRotate$1(T, x);
			}
			setNodeColor(x.parent, 0);
			setNodeColor(x.parent.parent, 1);
			leftRotate$1(T, x.parent.parent);
		}
	}
	setNodeColor(T.root, 0);
	return newNode;
}
function treeInsert(T, z) {
	let delta = 0;
	let x = T.root;
	const zAbsoluteStart = z.start;
	const zAbsoluteEnd = z.end;
	while (true) if (intervalCompare(zAbsoluteStart, zAbsoluteEnd, x.start + delta, x.end + delta) < 0) {
		if (x.left === SENTINEL$1) {
			z.start -= delta;
			z.end -= delta;
			z.maxEnd -= delta;
			x.left = z;
			break;
		} else x = x.left;
	} else if (x.right === SENTINEL$1) {
		z.start -= delta + x.delta;
		z.end -= delta + x.delta;
		z.maxEnd -= delta + x.delta;
		x.right = z;
		break;
	} else {
		delta += x.delta;
		x = x.right;
	}
	z.parent = x;
	z.left = SENTINEL$1;
	z.right = SENTINEL$1;
	setNodeColor(z, 1);
}
function rbTreeDelete(T, z) {
	let x;
	let y;
	if (z.left === SENTINEL$1) {
		x = z.right;
		y = z;
		x.delta += z.delta;
		if (x.delta < -1073741824 || x.delta > 1073741824) T.requestNormalizeDelta = true;
		x.start += z.delta;
		x.end += z.delta;
	} else if (z.right === SENTINEL$1) {
		x = z.left;
		y = z;
	} else {
		y = leftest$1(z.right);
		x = y.right;
		x.start += y.delta;
		x.end += y.delta;
		x.delta += y.delta;
		if (x.delta < -1073741824 || x.delta > 1073741824) T.requestNormalizeDelta = true;
		y.start += z.delta;
		y.end += z.delta;
		y.delta = z.delta;
		if (y.delta < -1073741824 || y.delta > 1073741824) T.requestNormalizeDelta = true;
	}
	if (y === T.root) {
		T.root = x;
		setNodeColor(x, 0);
		z.detach();
		resetSentinel$1();
		recomputeMaxEnd(x);
		T.root.parent = SENTINEL$1;
		return;
	}
	const yWasRed = getNodeColor(y) === 1;
	if (y === y.parent.left) y.parent.left = x;
	else y.parent.right = x;
	if (y === z) x.parent = y.parent;
	else {
		if (y.parent === z) x.parent = y;
		else x.parent = y.parent;
		y.left = z.left;
		y.right = z.right;
		y.parent = z.parent;
		setNodeColor(y, getNodeColor(z));
		if (z === T.root) T.root = y;
		else if (z === z.parent.left) z.parent.left = y;
		else z.parent.right = y;
		if (y.left !== SENTINEL$1) y.left.parent = y;
		if (y.right !== SENTINEL$1) y.right.parent = y;
	}
	z.detach();
	if (yWasRed) {
		recomputeMaxEndWalkToRoot(x.parent);
		if (y !== z) {
			recomputeMaxEndWalkToRoot(y);
			recomputeMaxEndWalkToRoot(y.parent);
		}
		resetSentinel$1();
		return;
	}
	recomputeMaxEndWalkToRoot(x);
	recomputeMaxEndWalkToRoot(x.parent);
	if (y !== z) {
		recomputeMaxEndWalkToRoot(y);
		recomputeMaxEndWalkToRoot(y.parent);
	}
	let w;
	while (x !== T.root && getNodeColor(x) === 0) if (x === x.parent.left) {
		w = x.parent.right;
		if (getNodeColor(w) === 1) {
			setNodeColor(w, 0);
			setNodeColor(x.parent, 1);
			leftRotate$1(T, x.parent);
			w = x.parent.right;
		}
		if (getNodeColor(w.left) === 0 && getNodeColor(w.right) === 0) {
			setNodeColor(w, 1);
			x = x.parent;
		} else {
			if (getNodeColor(w.right) === 0) {
				setNodeColor(w.left, 0);
				setNodeColor(w, 1);
				rightRotate$1(T, w);
				w = x.parent.right;
			}
			setNodeColor(w, getNodeColor(x.parent));
			setNodeColor(x.parent, 0);
			setNodeColor(w.right, 0);
			leftRotate$1(T, x.parent);
			x = T.root;
		}
	} else {
		w = x.parent.left;
		if (getNodeColor(w) === 1) {
			setNodeColor(w, 0);
			setNodeColor(x.parent, 1);
			rightRotate$1(T, x.parent);
			w = x.parent.left;
		}
		if (getNodeColor(w.left) === 0 && getNodeColor(w.right) === 0) {
			setNodeColor(w, 1);
			x = x.parent;
		} else {
			if (getNodeColor(w.left) === 0) {
				setNodeColor(w.right, 0);
				setNodeColor(w, 1);
				leftRotate$1(T, w);
				w = x.parent.left;
			}
			setNodeColor(w, getNodeColor(x.parent));
			setNodeColor(x.parent, 0);
			setNodeColor(w.left, 0);
			rightRotate$1(T, x.parent);
			x = T.root;
		}
	}
	setNodeColor(x, 0);
	resetSentinel$1();
}
function leftest$1(node) {
	while (node.left !== SENTINEL$1) node = node.left;
	return node;
}
function resetSentinel$1() {
	SENTINEL$1.parent = SENTINEL$1;
	SENTINEL$1.delta = 0;
	SENTINEL$1.start = 0;
	SENTINEL$1.end = 0;
}
function leftRotate$1(T, x) {
	const y = x.right;
	y.delta += x.delta;
	if (y.delta < -1073741824 || y.delta > 1073741824) T.requestNormalizeDelta = true;
	y.start += x.delta;
	y.end += x.delta;
	x.right = y.left;
	if (y.left !== SENTINEL$1) y.left.parent = x;
	y.parent = x.parent;
	if (x.parent === SENTINEL$1) T.root = y;
	else if (x === x.parent.left) x.parent.left = y;
	else x.parent.right = y;
	y.left = x;
	x.parent = y;
	recomputeMaxEnd(x);
	recomputeMaxEnd(y);
}
function rightRotate$1(T, y) {
	const x = y.left;
	y.delta -= x.delta;
	if (y.delta < -1073741824 || y.delta > 1073741824) T.requestNormalizeDelta = true;
	y.start -= x.delta;
	y.end -= x.delta;
	y.left = x.right;
	if (x.right !== SENTINEL$1) x.right.parent = y;
	x.parent = y.parent;
	if (y.parent === SENTINEL$1) T.root = x;
	else if (y === y.parent.right) y.parent.right = x;
	else y.parent.left = x;
	x.right = y;
	y.parent = x;
	recomputeMaxEnd(y);
	recomputeMaxEnd(x);
}
function computeMaxEnd(node) {
	let maxEnd = node.end;
	if (node.left !== SENTINEL$1) {
		const leftMaxEnd = node.left.maxEnd;
		if (leftMaxEnd > maxEnd) maxEnd = leftMaxEnd;
	}
	if (node.right !== SENTINEL$1) {
		const rightMaxEnd = node.right.maxEnd + node.delta;
		if (rightMaxEnd > maxEnd) maxEnd = rightMaxEnd;
	}
	return maxEnd;
}
function recomputeMaxEnd(node) {
	node.maxEnd = computeMaxEnd(node);
}
function recomputeMaxEndWalkToRoot(node) {
	while (node !== SENTINEL$1) {
		const maxEnd = computeMaxEnd(node);
		if (node.maxEnd === maxEnd) return;
		node.maxEnd = maxEnd;
		node = node.parent;
	}
}
function intervalCompare(aStart, aEnd, bStart, bEnd) {
	if (aStart === bStart) return aEnd - bEnd;
	return aStart - bStart;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/pieceTreeTextBuffer/rbTreeBase.js
var TreeNode = class {
	constructor(piece, color) {
		this.piece = piece;
		this.color = color;
		this.size_left = 0;
		this.lf_left = 0;
		this.parent = this;
		this.left = this;
		this.right = this;
	}
	next() {
		if (this.right !== SENTINEL) return leftest(this.right);
		let node = this;
		while (node.parent !== SENTINEL) {
			if (node.parent.left === node) break;
			node = node.parent;
		}
		if (node.parent === SENTINEL) return SENTINEL;
		else return node.parent;
	}
	prev() {
		if (this.left !== SENTINEL) return righttest(this.left);
		let node = this;
		while (node.parent !== SENTINEL) {
			if (node.parent.right === node) break;
			node = node.parent;
		}
		if (node.parent === SENTINEL) return SENTINEL;
		else return node.parent;
	}
	detach() {
		this.parent = null;
		this.left = null;
		this.right = null;
	}
};
var SENTINEL = new TreeNode(null, 0);
SENTINEL.parent = SENTINEL;
SENTINEL.left = SENTINEL;
SENTINEL.right = SENTINEL;
SENTINEL.color = 0;
function leftest(node) {
	while (node.left !== SENTINEL) node = node.left;
	return node;
}
function righttest(node) {
	while (node.right !== SENTINEL) node = node.right;
	return node;
}
function calculateSize(node) {
	if (node === SENTINEL) return 0;
	return node.size_left + node.piece.length + calculateSize(node.right);
}
function calculateLF(node) {
	if (node === SENTINEL) return 0;
	return node.lf_left + node.piece.lineFeedCnt + calculateLF(node.right);
}
function resetSentinel() {
	SENTINEL.parent = SENTINEL;
}
function leftRotate(tree, x) {
	const y = x.right;
	y.size_left += x.size_left + (x.piece ? x.piece.length : 0);
	y.lf_left += x.lf_left + (x.piece ? x.piece.lineFeedCnt : 0);
	x.right = y.left;
	if (y.left !== SENTINEL) y.left.parent = x;
	y.parent = x.parent;
	if (x.parent === SENTINEL) tree.root = y;
	else if (x.parent.left === x) x.parent.left = y;
	else x.parent.right = y;
	y.left = x;
	x.parent = y;
}
function rightRotate(tree, y) {
	const x = y.left;
	y.left = x.right;
	if (x.right !== SENTINEL) x.right.parent = y;
	x.parent = y.parent;
	y.size_left -= x.size_left + (x.piece ? x.piece.length : 0);
	y.lf_left -= x.lf_left + (x.piece ? x.piece.lineFeedCnt : 0);
	if (y.parent === SENTINEL) tree.root = x;
	else if (y === y.parent.right) y.parent.right = x;
	else y.parent.left = x;
	x.right = y;
	y.parent = x;
}
function rbDelete(tree, z) {
	let x;
	let y;
	if (z.left === SENTINEL) {
		y = z;
		x = y.right;
	} else if (z.right === SENTINEL) {
		y = z;
		x = y.left;
	} else {
		y = leftest(z.right);
		x = y.right;
	}
	if (y === tree.root) {
		tree.root = x;
		x.color = 0;
		z.detach();
		resetSentinel();
		tree.root.parent = SENTINEL;
		return;
	}
	const yWasRed = y.color === 1;
	if (y === y.parent.left) y.parent.left = x;
	else y.parent.right = x;
	if (y === z) {
		x.parent = y.parent;
		recomputeTreeMetadata(tree, x);
	} else {
		if (y.parent === z) x.parent = y;
		else x.parent = y.parent;
		recomputeTreeMetadata(tree, x);
		y.left = z.left;
		y.right = z.right;
		y.parent = z.parent;
		y.color = z.color;
		if (z === tree.root) tree.root = y;
		else if (z === z.parent.left) z.parent.left = y;
		else z.parent.right = y;
		if (y.left !== SENTINEL) y.left.parent = y;
		if (y.right !== SENTINEL) y.right.parent = y;
		y.size_left = z.size_left;
		y.lf_left = z.lf_left;
		recomputeTreeMetadata(tree, y);
	}
	z.detach();
	if (x.parent.left === x) {
		const newSizeLeft = calculateSize(x);
		const newLFLeft = calculateLF(x);
		if (newSizeLeft !== x.parent.size_left || newLFLeft !== x.parent.lf_left) {
			const delta = newSizeLeft - x.parent.size_left;
			const lf_delta = newLFLeft - x.parent.lf_left;
			x.parent.size_left = newSizeLeft;
			x.parent.lf_left = newLFLeft;
			updateTreeMetadata(tree, x.parent, delta, lf_delta);
		}
	}
	recomputeTreeMetadata(tree, x.parent);
	if (yWasRed) {
		resetSentinel();
		return;
	}
	let w;
	while (x !== tree.root && x.color === 0) if (x === x.parent.left) {
		w = x.parent.right;
		if (w.color === 1) {
			w.color = 0;
			x.parent.color = 1;
			leftRotate(tree, x.parent);
			w = x.parent.right;
		}
		if (w.left.color === 0 && w.right.color === 0) {
			w.color = 1;
			x = x.parent;
		} else {
			if (w.right.color === 0) {
				w.left.color = 0;
				w.color = 1;
				rightRotate(tree, w);
				w = x.parent.right;
			}
			w.color = x.parent.color;
			x.parent.color = 0;
			w.right.color = 0;
			leftRotate(tree, x.parent);
			x = tree.root;
		}
	} else {
		w = x.parent.left;
		if (w.color === 1) {
			w.color = 0;
			x.parent.color = 1;
			rightRotate(tree, x.parent);
			w = x.parent.left;
		}
		if (w.left.color === 0 && w.right.color === 0) {
			w.color = 1;
			x = x.parent;
		} else {
			if (w.left.color === 0) {
				w.right.color = 0;
				w.color = 1;
				leftRotate(tree, w);
				w = x.parent.left;
			}
			w.color = x.parent.color;
			x.parent.color = 0;
			w.left.color = 0;
			rightRotate(tree, x.parent);
			x = tree.root;
		}
	}
	x.color = 0;
	resetSentinel();
}
function fixInsert(tree, x) {
	recomputeTreeMetadata(tree, x);
	while (x !== tree.root && x.parent.color === 1) if (x.parent === x.parent.parent.left) {
		const y = x.parent.parent.right;
		if (y.color === 1) {
			x.parent.color = 0;
			y.color = 0;
			x.parent.parent.color = 1;
			x = x.parent.parent;
		} else {
			if (x === x.parent.right) {
				x = x.parent;
				leftRotate(tree, x);
			}
			x.parent.color = 0;
			x.parent.parent.color = 1;
			rightRotate(tree, x.parent.parent);
		}
	} else {
		const y = x.parent.parent.left;
		if (y.color === 1) {
			x.parent.color = 0;
			y.color = 0;
			x.parent.parent.color = 1;
			x = x.parent.parent;
		} else {
			if (x === x.parent.left) {
				x = x.parent;
				rightRotate(tree, x);
			}
			x.parent.color = 0;
			x.parent.parent.color = 1;
			leftRotate(tree, x.parent.parent);
		}
	}
	tree.root.color = 0;
}
function updateTreeMetadata(tree, x, delta, lineFeedCntDelta) {
	while (x !== tree.root && x !== SENTINEL) {
		if (x.parent.left === x) {
			x.parent.size_left += delta;
			x.parent.lf_left += lineFeedCntDelta;
		}
		x = x.parent;
	}
}
function recomputeTreeMetadata(tree, x) {
	let delta = 0;
	let lf_delta = 0;
	if (x === tree.root) return;
	while (x !== tree.root && x === x.parent.right) x = x.parent;
	if (x === tree.root) return;
	x = x.parent;
	delta = calculateSize(x.left) - x.size_left;
	lf_delta = calculateLF(x.left) - x.lf_left;
	x.size_left += delta;
	x.lf_left += lf_delta;
	while (x !== tree.root && (delta !== 0 || lf_delta !== 0)) {
		if (x.parent.left === x) {
			x.parent.size_left += delta;
			x.parent.lf_left += lf_delta;
		}
		x = x.parent;
	}
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/pieceTreeTextBuffer/pieceTreeBase.js
var AverageBufferSize = 65535;
function createUintArray(arr) {
	let r;
	if (arr[arr.length - 1] < 65536) r = new Uint16Array(arr.length);
	else r = new Uint32Array(arr.length);
	r.set(arr, 0);
	return r;
}
var LineStarts = class {
	constructor(lineStarts, cr, lf, crlf, isBasicASCII) {
		this.lineStarts = lineStarts;
		this.cr = cr;
		this.lf = lf;
		this.crlf = crlf;
		this.isBasicASCII = isBasicASCII;
	}
};
function createLineStartsFast(str, readonly = true) {
	const r = [0];
	let rLength = 1;
	for (let i = 0, len = str.length; i < len; i++) {
		const chr = str.charCodeAt(i);
		if (chr === 13) {
			if (i + 1 < len && str.charCodeAt(i + 1) === 10) {
				r[rLength++] = i + 2;
				i++;
			} else r[rLength++] = i + 1;
		} else if (chr === 10) r[rLength++] = i + 1;
	}
	if (readonly) return createUintArray(r);
	else return r;
}
function createLineStarts(r, str) {
	r.length = 0;
	r[0] = 0;
	let rLength = 1;
	let cr = 0, lf = 0, crlf = 0;
	let isBasicASCII = true;
	for (let i = 0, len = str.length; i < len; i++) {
		const chr = str.charCodeAt(i);
		if (chr === 13) {
			if (i + 1 < len && str.charCodeAt(i + 1) === 10) {
				crlf++;
				r[rLength++] = i + 2;
				i++;
			} else {
				cr++;
				r[rLength++] = i + 1;
			}
		} else if (chr === 10) {
			lf++;
			r[rLength++] = i + 1;
		} else if (isBasicASCII) {
			if (chr !== 9 && (chr < 32 || chr > 126)) isBasicASCII = false;
		}
	}
	const result = new LineStarts(createUintArray(r), cr, lf, crlf, isBasicASCII);
	r.length = 0;
	return result;
}
var Piece = class {
	constructor(bufferIndex, start, end, lineFeedCnt, length) {
		this.bufferIndex = bufferIndex;
		this.start = start;
		this.end = end;
		this.lineFeedCnt = lineFeedCnt;
		this.length = length;
	}
};
var StringBuffer = class {
	constructor(buffer, lineStarts) {
		this.buffer = buffer;
		this.lineStarts = lineStarts;
	}
};
/**
* Readonly snapshot for piece tree.
* In a real multiple thread environment, to make snapshot reading always work correctly, we need to
* 1. Make TreeNode.piece immutable, then reading and writing can run in parallel.
* 2. TreeNode/Buffers normalization should not happen during snapshot reading.
*/
var PieceTreeSnapshot = class {
	constructor(tree, BOM) {
		this._pieces = [];
		this._tree = tree;
		this._BOM = BOM;
		this._index = 0;
		if (tree.root !== SENTINEL) tree.iterate(tree.root, (node) => {
			if (node !== SENTINEL) this._pieces.push(node.piece);
			return true;
		});
	}
	read() {
		if (this._pieces.length === 0) {
			if (this._index === 0) {
				this._index++;
				return this._BOM;
			} else return null;
		}
		if (this._index > this._pieces.length - 1) return null;
		if (this._index === 0) return this._BOM + this._tree.getPieceContent(this._pieces[this._index++]);
		return this._tree.getPieceContent(this._pieces[this._index++]);
	}
};
var PieceTreeSearchCache = class {
	constructor(limit) {
		this._limit = limit;
		this._cache = [];
	}
	get(offset) {
		for (let i = this._cache.length - 1; i >= 0; i--) {
			const nodePos = this._cache[i];
			if (nodePos.nodeStartOffset <= offset && nodePos.nodeStartOffset + nodePos.node.piece.length >= offset) return nodePos;
		}
		return null;
	}
	get2(lineNumber) {
		for (let i = this._cache.length - 1; i >= 0; i--) {
			const nodePos = this._cache[i];
			if (nodePos.nodeStartLineNumber && nodePos.nodeStartLineNumber < lineNumber && nodePos.nodeStartLineNumber + nodePos.node.piece.lineFeedCnt >= lineNumber) return nodePos;
		}
		return null;
	}
	set(nodePosition) {
		if (this._cache.length >= this._limit) this._cache.shift();
		this._cache.push(nodePosition);
	}
	validate(offset) {
		let hasInvalidVal = false;
		const tmp = this._cache;
		for (let i = 0; i < tmp.length; i++) {
			const nodePos = tmp[i];
			if (nodePos.node.parent === null || nodePos.nodeStartOffset >= offset) {
				tmp[i] = null;
				hasInvalidVal = true;
				continue;
			}
		}
		if (hasInvalidVal) {
			const newArr = [];
			for (const entry of tmp) if (entry !== null) newArr.push(entry);
			this._cache = newArr;
		}
	}
};
var PieceTreeBase = class {
	constructor(chunks, eol, eolNormalized) {
		this.create(chunks, eol, eolNormalized);
	}
	create(chunks, eol, eolNormalized) {
		this._buffers = [new StringBuffer("", [0])];
		this._lastChangeBufferPos = {
			line: 0,
			column: 0
		};
		this.root = SENTINEL;
		this._lineCnt = 1;
		this._length = 0;
		this._EOL = eol;
		this._EOLLength = eol.length;
		this._EOLNormalized = eolNormalized;
		let lastNode = null;
		for (let i = 0, len = chunks.length; i < len; i++) if (chunks[i].buffer.length > 0) {
			if (!chunks[i].lineStarts) chunks[i].lineStarts = createLineStartsFast(chunks[i].buffer);
			const piece = new Piece(i + 1, {
				line: 0,
				column: 0
			}, {
				line: chunks[i].lineStarts.length - 1,
				column: chunks[i].buffer.length - chunks[i].lineStarts[chunks[i].lineStarts.length - 1]
			}, chunks[i].lineStarts.length - 1, chunks[i].buffer.length);
			this._buffers.push(chunks[i]);
			lastNode = this.rbInsertRight(lastNode, piece);
		}
		this._searchCache = new PieceTreeSearchCache(1);
		this._lastVisitedLine = {
			lineNumber: 0,
			value: ""
		};
		this.computeBufferMetadata();
	}
	normalizeEOL(eol) {
		const averageBufferSize = AverageBufferSize;
		const min = averageBufferSize - Math.floor(averageBufferSize / 3);
		const max = min * 2;
		let tempChunk = "";
		let tempChunkLen = 0;
		const chunks = [];
		this.iterate(this.root, (node) => {
			const str = this.getNodeContent(node);
			const len = str.length;
			if (tempChunkLen <= min || tempChunkLen + len < max) {
				tempChunk += str;
				tempChunkLen += len;
				return true;
			}
			const text = tempChunk.replace(/\r\n|\r|\n/g, eol);
			chunks.push(new StringBuffer(text, createLineStartsFast(text)));
			tempChunk = str;
			tempChunkLen = len;
			return true;
		});
		if (tempChunkLen > 0) {
			const text = tempChunk.replace(/\r\n|\r|\n/g, eol);
			chunks.push(new StringBuffer(text, createLineStartsFast(text)));
		}
		this.create(chunks, eol, true);
	}
	getEOL() {
		return this._EOL;
	}
	setEOL(newEOL) {
		this._EOL = newEOL;
		this._EOLLength = this._EOL.length;
		this.normalizeEOL(newEOL);
	}
	createSnapshot(BOM) {
		return new PieceTreeSnapshot(this, BOM);
	}
	getOffsetAt(lineNumber, column) {
		let leftLen = 0;
		let x = this.root;
		while (x !== SENTINEL) if (x.left !== SENTINEL && x.lf_left + 1 >= lineNumber) x = x.left;
		else if (x.lf_left + x.piece.lineFeedCnt + 1 >= lineNumber) {
			leftLen += x.size_left;
			const accumualtedValInCurrentIndex = this.getAccumulatedValue(x, lineNumber - x.lf_left - 2);
			return leftLen += accumualtedValInCurrentIndex + column - 1;
		} else {
			lineNumber -= x.lf_left + x.piece.lineFeedCnt;
			leftLen += x.size_left + x.piece.length;
			x = x.right;
		}
		return leftLen;
	}
	getPositionAt(offset) {
		offset = Math.floor(offset);
		offset = Math.max(0, offset);
		let x = this.root;
		let lfCnt = 0;
		const originalOffset = offset;
		while (x !== SENTINEL) if (x.size_left !== 0 && x.size_left >= offset) x = x.left;
		else if (x.size_left + x.piece.length >= offset) {
			const out = this.getIndexOf(x, offset - x.size_left);
			lfCnt += x.lf_left + out.index;
			if (out.index === 0) {
				const column = originalOffset - this.getOffsetAt(lfCnt + 1, 1);
				return new Position$1(lfCnt + 1, column + 1);
			}
			return new Position$1(lfCnt + 1, out.remainder + 1);
		} else {
			offset -= x.size_left + x.piece.length;
			lfCnt += x.lf_left + x.piece.lineFeedCnt;
			if (x.right === SENTINEL) {
				const lineStartOffset = this.getOffsetAt(lfCnt + 1, 1);
				const column = originalOffset - offset - lineStartOffset;
				return new Position$1(lfCnt + 1, column + 1);
			} else x = x.right;
		}
		return new Position$1(1, 1);
	}
	getValueInRange(range, eol) {
		if (range.startLineNumber === range.endLineNumber && range.startColumn === range.endColumn) return "";
		const startPosition = this.nodeAt2(range.startLineNumber, range.startColumn);
		const endPosition = this.nodeAt2(range.endLineNumber, range.endColumn);
		const value = this.getValueInRange2(startPosition, endPosition);
		if (eol) {
			if (eol !== this._EOL || !this._EOLNormalized) return value.replace(/\r\n|\r|\n/g, eol);
			if (eol === this.getEOL() && this._EOLNormalized) return value;
			return value.replace(/\r\n|\r|\n/g, eol);
		}
		return value;
	}
	getValueInRange2(startPosition, endPosition) {
		if (startPosition.node === endPosition.node) {
			const node = startPosition.node;
			const buffer = this._buffers[node.piece.bufferIndex].buffer;
			const startOffset = this.offsetInBuffer(node.piece.bufferIndex, node.piece.start);
			return buffer.substring(startOffset + startPosition.remainder, startOffset + endPosition.remainder);
		}
		let x = startPosition.node;
		const buffer = this._buffers[x.piece.bufferIndex].buffer;
		const startOffset = this.offsetInBuffer(x.piece.bufferIndex, x.piece.start);
		let ret = buffer.substring(startOffset + startPosition.remainder, startOffset + x.piece.length);
		x = x.next();
		while (x !== SENTINEL) {
			const buffer = this._buffers[x.piece.bufferIndex].buffer;
			const startOffset = this.offsetInBuffer(x.piece.bufferIndex, x.piece.start);
			if (x === endPosition.node) {
				ret += buffer.substring(startOffset, startOffset + endPosition.remainder);
				break;
			} else ret += buffer.substr(startOffset, x.piece.length);
			x = x.next();
		}
		return ret;
	}
	getLinesContent() {
		const lines = [];
		let linesLength = 0;
		let currentLine = "";
		let danglingCR = false;
		this.iterate(this.root, (node) => {
			if (node === SENTINEL) return true;
			const piece = node.piece;
			let pieceLength = piece.length;
			if (pieceLength === 0) return true;
			const buffer = this._buffers[piece.bufferIndex].buffer;
			const lineStarts = this._buffers[piece.bufferIndex].lineStarts;
			const pieceStartLine = piece.start.line;
			const pieceEndLine = piece.end.line;
			let pieceStartOffset = lineStarts[pieceStartLine] + piece.start.column;
			if (danglingCR) {
				if (buffer.charCodeAt(pieceStartOffset) === 10) {
					pieceStartOffset++;
					pieceLength--;
				}
				lines[linesLength++] = currentLine;
				currentLine = "";
				danglingCR = false;
				if (pieceLength === 0) return true;
			}
			if (pieceStartLine === pieceEndLine) {
				if (!this._EOLNormalized && buffer.charCodeAt(pieceStartOffset + pieceLength - 1) === 13) {
					danglingCR = true;
					currentLine += buffer.substr(pieceStartOffset, pieceLength - 1);
				} else currentLine += buffer.substr(pieceStartOffset, pieceLength);
				return true;
			}
			currentLine += this._EOLNormalized ? buffer.substring(pieceStartOffset, Math.max(pieceStartOffset, lineStarts[pieceStartLine + 1] - this._EOLLength)) : buffer.substring(pieceStartOffset, lineStarts[pieceStartLine + 1]).replace(/(\r\n|\r|\n)$/, "");
			lines[linesLength++] = currentLine;
			for (let line = pieceStartLine + 1; line < pieceEndLine; line++) {
				currentLine = this._EOLNormalized ? buffer.substring(lineStarts[line], lineStarts[line + 1] - this._EOLLength) : buffer.substring(lineStarts[line], lineStarts[line + 1]).replace(/(\r\n|\r|\n)$/, "");
				lines[linesLength++] = currentLine;
			}
			if (!this._EOLNormalized && buffer.charCodeAt(lineStarts[pieceEndLine] + piece.end.column - 1) === 13) {
				danglingCR = true;
				if (piece.end.column === 0) linesLength--;
				else currentLine = buffer.substr(lineStarts[pieceEndLine], piece.end.column - 1);
			} else currentLine = buffer.substr(lineStarts[pieceEndLine], piece.end.column);
			return true;
		});
		if (danglingCR) {
			lines[linesLength++] = currentLine;
			currentLine = "";
		}
		lines[linesLength++] = currentLine;
		return lines;
	}
	getLength() {
		return this._length;
	}
	getLineCount() {
		return this._lineCnt;
	}
	getLineContent(lineNumber) {
		if (this._lastVisitedLine.lineNumber === lineNumber) return this._lastVisitedLine.value;
		this._lastVisitedLine.lineNumber = lineNumber;
		if (lineNumber === this._lineCnt) this._lastVisitedLine.value = this.getLineRawContent(lineNumber);
		else if (this._EOLNormalized) this._lastVisitedLine.value = this.getLineRawContent(lineNumber, this._EOLLength);
		else this._lastVisitedLine.value = this.getLineRawContent(lineNumber).replace(/(\r\n|\r|\n)$/, "");
		return this._lastVisitedLine.value;
	}
	_getCharCode(nodePos) {
		if (nodePos.remainder === nodePos.node.piece.length) {
			const matchingNode = nodePos.node.next();
			if (!matchingNode) return 0;
			const buffer = this._buffers[matchingNode.piece.bufferIndex];
			const startOffset = this.offsetInBuffer(matchingNode.piece.bufferIndex, matchingNode.piece.start);
			return buffer.buffer.charCodeAt(startOffset);
		} else {
			const buffer = this._buffers[nodePos.node.piece.bufferIndex];
			const targetOffset = this.offsetInBuffer(nodePos.node.piece.bufferIndex, nodePos.node.piece.start) + nodePos.remainder;
			return buffer.buffer.charCodeAt(targetOffset);
		}
	}
	getLineCharCode(lineNumber, index) {
		const nodePos = this.nodeAt2(lineNumber, index + 1);
		return this._getCharCode(nodePos);
	}
	getLineLength(lineNumber) {
		if (lineNumber === this.getLineCount()) {
			const startOffset = this.getOffsetAt(lineNumber, 1);
			return this.getLength() - startOffset;
		}
		return this.getOffsetAt(lineNumber + 1, 1) - this.getOffsetAt(lineNumber, 1) - this._EOLLength;
	}
	getNearestChunk(offset) {
		const nodePos = this.nodeAt(offset);
		if (nodePos.remainder === nodePos.node.piece.length) {
			const matchingNode = nodePos.node.next();
			if (!matchingNode || matchingNode === SENTINEL) return "";
			const buffer = this._buffers[matchingNode.piece.bufferIndex];
			const startOffset = this.offsetInBuffer(matchingNode.piece.bufferIndex, matchingNode.piece.start);
			return buffer.buffer.substring(startOffset, startOffset + matchingNode.piece.length);
		} else {
			const buffer = this._buffers[nodePos.node.piece.bufferIndex];
			const startOffset = this.offsetInBuffer(nodePos.node.piece.bufferIndex, nodePos.node.piece.start);
			const targetOffset = startOffset + nodePos.remainder;
			const targetEnd = startOffset + nodePos.node.piece.length;
			return buffer.buffer.substring(targetOffset, targetEnd);
		}
	}
	findMatchesInNode(node, searcher, startLineNumber, startColumn, startCursor, endCursor, searchData, captureMatches, limitResultCount, resultLen, result) {
		const buffer = this._buffers[node.piece.bufferIndex];
		const startOffsetInBuffer = this.offsetInBuffer(node.piece.bufferIndex, node.piece.start);
		const start = this.offsetInBuffer(node.piece.bufferIndex, startCursor);
		const end = this.offsetInBuffer(node.piece.bufferIndex, endCursor);
		let m;
		const ret = {
			line: 0,
			column: 0
		};
		let searchText;
		let offsetInBuffer;
		if (searcher._wordSeparators) {
			searchText = buffer.buffer.substring(start, end);
			offsetInBuffer = (offset) => offset + start;
			searcher.reset(0);
		} else {
			searchText = buffer.buffer;
			offsetInBuffer = (offset) => offset;
			searcher.reset(start);
		}
		do {
			m = searcher.next(searchText);
			if (m) {
				if (offsetInBuffer(m.index) >= end) return resultLen;
				this.positionInBuffer(node, offsetInBuffer(m.index) - startOffsetInBuffer, ret);
				const lineFeedCnt = this.getLineFeedCnt(node.piece.bufferIndex, startCursor, ret);
				const retStartColumn = ret.line === startCursor.line ? ret.column - startCursor.column + startColumn : ret.column + 1;
				const retEndColumn = retStartColumn + m[0].length;
				result[resultLen++] = createFindMatch(new Range$2(startLineNumber + lineFeedCnt, retStartColumn, startLineNumber + lineFeedCnt, retEndColumn), m, captureMatches);
				if (offsetInBuffer(m.index) + m[0].length >= end) return resultLen;
				if (resultLen >= limitResultCount) return resultLen;
			}
		} while (m);
		return resultLen;
	}
	findMatchesLineByLine(searchRange, searchData, captureMatches, limitResultCount) {
		const result = [];
		let resultLen = 0;
		const searcher = new Searcher(searchData.wordSeparators, searchData.regex);
		let startPosition = this.nodeAt2(searchRange.startLineNumber, searchRange.startColumn);
		if (startPosition === null) return [];
		const endPosition = this.nodeAt2(searchRange.endLineNumber, searchRange.endColumn);
		if (endPosition === null) return [];
		let start = this.positionInBuffer(startPosition.node, startPosition.remainder);
		const end = this.positionInBuffer(endPosition.node, endPosition.remainder);
		if (startPosition.node === endPosition.node) {
			this.findMatchesInNode(startPosition.node, searcher, searchRange.startLineNumber, searchRange.startColumn, start, end, searchData, captureMatches, limitResultCount, resultLen, result);
			return result;
		}
		let startLineNumber = searchRange.startLineNumber;
		let currentNode = startPosition.node;
		while (currentNode !== endPosition.node) {
			const lineBreakCnt = this.getLineFeedCnt(currentNode.piece.bufferIndex, start, currentNode.piece.end);
			if (lineBreakCnt >= 1) {
				const lineStarts = this._buffers[currentNode.piece.bufferIndex].lineStarts;
				const startOffsetInBuffer = this.offsetInBuffer(currentNode.piece.bufferIndex, currentNode.piece.start);
				const nextLineStartOffset = lineStarts[start.line + lineBreakCnt];
				const startColumn = startLineNumber === searchRange.startLineNumber ? searchRange.startColumn : 1;
				resultLen = this.findMatchesInNode(currentNode, searcher, startLineNumber, startColumn, start, this.positionInBuffer(currentNode, nextLineStartOffset - startOffsetInBuffer), searchData, captureMatches, limitResultCount, resultLen, result);
				if (resultLen >= limitResultCount) return result;
				startLineNumber += lineBreakCnt;
			}
			const startColumn = startLineNumber === searchRange.startLineNumber ? searchRange.startColumn - 1 : 0;
			if (startLineNumber === searchRange.endLineNumber) {
				const text = this.getLineContent(startLineNumber).substring(startColumn, searchRange.endColumn - 1);
				resultLen = this._findMatchesInLine(searchData, searcher, text, searchRange.endLineNumber, startColumn, resultLen, result, captureMatches, limitResultCount);
				return result;
			}
			resultLen = this._findMatchesInLine(searchData, searcher, this.getLineContent(startLineNumber).substr(startColumn), startLineNumber, startColumn, resultLen, result, captureMatches, limitResultCount);
			if (resultLen >= limitResultCount) return result;
			startLineNumber++;
			startPosition = this.nodeAt2(startLineNumber, 1);
			currentNode = startPosition.node;
			start = this.positionInBuffer(startPosition.node, startPosition.remainder);
		}
		if (startLineNumber === searchRange.endLineNumber) {
			const startColumn = startLineNumber === searchRange.startLineNumber ? searchRange.startColumn - 1 : 0;
			const text = this.getLineContent(startLineNumber).substring(startColumn, searchRange.endColumn - 1);
			resultLen = this._findMatchesInLine(searchData, searcher, text, searchRange.endLineNumber, startColumn, resultLen, result, captureMatches, limitResultCount);
			return result;
		}
		const startColumn = startLineNumber === searchRange.startLineNumber ? searchRange.startColumn : 1;
		resultLen = this.findMatchesInNode(endPosition.node, searcher, startLineNumber, startColumn, start, end, searchData, captureMatches, limitResultCount, resultLen, result);
		return result;
	}
	_findMatchesInLine(searchData, searcher, text, lineNumber, deltaOffset, resultLen, result, captureMatches, limitResultCount) {
		const wordSeparators = searchData.wordSeparators;
		if (!captureMatches && searchData.simpleSearch) {
			const searchString = searchData.simpleSearch;
			const searchStringLen = searchString.length;
			const textLength = text.length;
			let lastMatchIndex = -searchStringLen;
			while ((lastMatchIndex = text.indexOf(searchString, lastMatchIndex + searchStringLen)) !== -1) if (!wordSeparators || isValidMatch(wordSeparators, text, textLength, lastMatchIndex, searchStringLen)) {
				result[resultLen++] = new FindMatch(new Range$2(lineNumber, lastMatchIndex + 1 + deltaOffset, lineNumber, lastMatchIndex + 1 + searchStringLen + deltaOffset), null);
				if (resultLen >= limitResultCount) return resultLen;
			}
			return resultLen;
		}
		let m;
		searcher.reset(0);
		do {
			m = searcher.next(text);
			if (m) {
				result[resultLen++] = createFindMatch(new Range$2(lineNumber, m.index + 1 + deltaOffset, lineNumber, m.index + 1 + m[0].length + deltaOffset), m, captureMatches);
				if (resultLen >= limitResultCount) return resultLen;
			}
		} while (m);
		return resultLen;
	}
	insert(offset, value, eolNormalized = false) {
		this._EOLNormalized = this._EOLNormalized && eolNormalized;
		this._lastVisitedLine.lineNumber = 0;
		this._lastVisitedLine.value = "";
		if (this.root !== SENTINEL) {
			const { node, remainder, nodeStartOffset } = this.nodeAt(offset);
			const piece = node.piece;
			const bufferIndex = piece.bufferIndex;
			const insertPosInBuffer = this.positionInBuffer(node, remainder);
			if (node.piece.bufferIndex === 0 && piece.end.line === this._lastChangeBufferPos.line && piece.end.column === this._lastChangeBufferPos.column && nodeStartOffset + piece.length === offset && value.length < AverageBufferSize) {
				this.appendToNode(node, value);
				this.computeBufferMetadata();
				return;
			}
			if (nodeStartOffset === offset) {
				this.insertContentToNodeLeft(value, node);
				this._searchCache.validate(offset);
			} else if (nodeStartOffset + node.piece.length > offset) {
				const nodesToDel = [];
				let newRightPiece = new Piece(piece.bufferIndex, insertPosInBuffer, piece.end, this.getLineFeedCnt(piece.bufferIndex, insertPosInBuffer, piece.end), this.offsetInBuffer(bufferIndex, piece.end) - this.offsetInBuffer(bufferIndex, insertPosInBuffer));
				if (this.shouldCheckCRLF() && this.endWithCR(value)) {
					if (this.nodeCharCodeAt(node, remainder) === 10) {
						const newStart = {
							line: newRightPiece.start.line + 1,
							column: 0
						};
						newRightPiece = new Piece(newRightPiece.bufferIndex, newStart, newRightPiece.end, this.getLineFeedCnt(newRightPiece.bufferIndex, newStart, newRightPiece.end), newRightPiece.length - 1);
						value += "\n";
					}
				}
				if (this.shouldCheckCRLF() && this.startWithLF(value)) {
					if (this.nodeCharCodeAt(node, remainder - 1) === 13) {
						const previousPos = this.positionInBuffer(node, remainder - 1);
						this.deleteNodeTail(node, previousPos);
						value = "\r" + value;
						if (node.piece.length === 0) nodesToDel.push(node);
					} else this.deleteNodeTail(node, insertPosInBuffer);
				} else this.deleteNodeTail(node, insertPosInBuffer);
				const newPieces = this.createNewPieces(value);
				if (newRightPiece.length > 0) this.rbInsertRight(node, newRightPiece);
				let tmpNode = node;
				for (let k = 0; k < newPieces.length; k++) tmpNode = this.rbInsertRight(tmpNode, newPieces[k]);
				this.deleteNodes(nodesToDel);
			} else this.insertContentToNodeRight(value, node);
		} else {
			const pieces = this.createNewPieces(value);
			let node = this.rbInsertLeft(null, pieces[0]);
			for (let k = 1; k < pieces.length; k++) node = this.rbInsertRight(node, pieces[k]);
		}
		this.computeBufferMetadata();
	}
	delete(offset, cnt) {
		this._lastVisitedLine.lineNumber = 0;
		this._lastVisitedLine.value = "";
		if (cnt <= 0 || this.root === SENTINEL) return;
		const startPosition = this.nodeAt(offset);
		const endPosition = this.nodeAt(offset + cnt);
		const startNode = startPosition.node;
		const endNode = endPosition.node;
		if (startNode === endNode) {
			const startSplitPosInBuffer = this.positionInBuffer(startNode, startPosition.remainder);
			const endSplitPosInBuffer = this.positionInBuffer(startNode, endPosition.remainder);
			if (startPosition.nodeStartOffset === offset) {
				if (cnt === startNode.piece.length) {
					const next = startNode.next();
					rbDelete(this, startNode);
					this.validateCRLFWithPrevNode(next);
					this.computeBufferMetadata();
					return;
				}
				this.deleteNodeHead(startNode, endSplitPosInBuffer);
				this._searchCache.validate(offset);
				this.validateCRLFWithPrevNode(startNode);
				this.computeBufferMetadata();
				return;
			}
			if (startPosition.nodeStartOffset + startNode.piece.length === offset + cnt) {
				this.deleteNodeTail(startNode, startSplitPosInBuffer);
				this.validateCRLFWithNextNode(startNode);
				this.computeBufferMetadata();
				return;
			}
			this.shrinkNode(startNode, startSplitPosInBuffer, endSplitPosInBuffer);
			this.computeBufferMetadata();
			return;
		}
		const nodesToDel = [];
		const startSplitPosInBuffer = this.positionInBuffer(startNode, startPosition.remainder);
		this.deleteNodeTail(startNode, startSplitPosInBuffer);
		this._searchCache.validate(offset);
		if (startNode.piece.length === 0) nodesToDel.push(startNode);
		const endSplitPosInBuffer = this.positionInBuffer(endNode, endPosition.remainder);
		this.deleteNodeHead(endNode, endSplitPosInBuffer);
		if (endNode.piece.length === 0) nodesToDel.push(endNode);
		const secondNode = startNode.next();
		for (let node = secondNode; node !== SENTINEL && node !== endNode; node = node.next()) nodesToDel.push(node);
		const prev = startNode.piece.length === 0 ? startNode.prev() : startNode;
		this.deleteNodes(nodesToDel);
		this.validateCRLFWithNextNode(prev);
		this.computeBufferMetadata();
	}
	insertContentToNodeLeft(value, node) {
		const nodesToDel = [];
		if (this.shouldCheckCRLF() && this.endWithCR(value) && this.startWithLF(node)) {
			const piece = node.piece;
			const newStart = {
				line: piece.start.line + 1,
				column: 0
			};
			node.piece = new Piece(piece.bufferIndex, newStart, piece.end, this.getLineFeedCnt(piece.bufferIndex, newStart, piece.end), piece.length - 1);
			value += "\n";
			updateTreeMetadata(this, node, -1, -1);
			if (node.piece.length === 0) nodesToDel.push(node);
		}
		const newPieces = this.createNewPieces(value);
		let newNode = this.rbInsertLeft(node, newPieces[newPieces.length - 1]);
		for (let k = newPieces.length - 2; k >= 0; k--) newNode = this.rbInsertLeft(newNode, newPieces[k]);
		this.validateCRLFWithPrevNode(newNode);
		this.deleteNodes(nodesToDel);
	}
	insertContentToNodeRight(value, node) {
		if (this.adjustCarriageReturnFromNext(value, node)) value += "\n";
		const newPieces = this.createNewPieces(value);
		const newNode = this.rbInsertRight(node, newPieces[0]);
		let tmpNode = newNode;
		for (let k = 1; k < newPieces.length; k++) tmpNode = this.rbInsertRight(tmpNode, newPieces[k]);
		this.validateCRLFWithPrevNode(newNode);
	}
	positionInBuffer(node, remainder, ret) {
		const piece = node.piece;
		const bufferIndex = node.piece.bufferIndex;
		const lineStarts = this._buffers[bufferIndex].lineStarts;
		const offset = lineStarts[piece.start.line] + piece.start.column + remainder;
		let low = piece.start.line;
		let high = piece.end.line;
		let mid = 0;
		let midStop = 0;
		let midStart = 0;
		while (low <= high) {
			mid = low + (high - low) / 2 | 0;
			midStart = lineStarts[mid];
			if (mid === high) break;
			midStop = lineStarts[mid + 1];
			if (offset < midStart) high = mid - 1;
			else if (offset >= midStop) low = mid + 1;
			else break;
		}
		if (ret) {
			ret.line = mid;
			ret.column = offset - midStart;
			return null;
		}
		return {
			line: mid,
			column: offset - midStart
		};
	}
	getLineFeedCnt(bufferIndex, start, end) {
		if (end.column === 0) return end.line - start.line;
		const lineStarts = this._buffers[bufferIndex].lineStarts;
		if (end.line === lineStarts.length - 1) return end.line - start.line;
		const nextLineStartOffset = lineStarts[end.line + 1];
		const endOffset = lineStarts[end.line] + end.column;
		if (nextLineStartOffset > endOffset + 1) return end.line - start.line;
		const previousCharOffset = endOffset - 1;
		if (this._buffers[bufferIndex].buffer.charCodeAt(previousCharOffset) === 13) return end.line - start.line + 1;
		else return end.line - start.line;
	}
	offsetInBuffer(bufferIndex, cursor) {
		return this._buffers[bufferIndex].lineStarts[cursor.line] + cursor.column;
	}
	deleteNodes(nodes) {
		for (let i = 0; i < nodes.length; i++) rbDelete(this, nodes[i]);
	}
	createNewPieces(text) {
		if (text.length > AverageBufferSize) {
			const newPieces = [];
			while (text.length > AverageBufferSize) {
				const lastChar = text.charCodeAt(65534);
				let splitText;
				if (lastChar === 13 || lastChar >= 55296 && lastChar <= 56319) {
					splitText = text.substring(0, 65534);
					text = text.substring(65534);
				} else {
					splitText = text.substring(0, AverageBufferSize);
					text = text.substring(AverageBufferSize);
				}
				const lineStarts = createLineStartsFast(splitText);
				newPieces.push(new Piece(this._buffers.length, {
					line: 0,
					column: 0
				}, {
					line: lineStarts.length - 1,
					column: splitText.length - lineStarts[lineStarts.length - 1]
				}, lineStarts.length - 1, splitText.length));
				this._buffers.push(new StringBuffer(splitText, lineStarts));
			}
			const lineStarts = createLineStartsFast(text);
			newPieces.push(new Piece(this._buffers.length, {
				line: 0,
				column: 0
			}, {
				line: lineStarts.length - 1,
				column: text.length - lineStarts[lineStarts.length - 1]
			}, lineStarts.length - 1, text.length));
			this._buffers.push(new StringBuffer(text, lineStarts));
			return newPieces;
		}
		let startOffset = this._buffers[0].buffer.length;
		const lineStarts = createLineStartsFast(text, false);
		let start = this._lastChangeBufferPos;
		if (this._buffers[0].lineStarts[this._buffers[0].lineStarts.length - 1] === startOffset && startOffset !== 0 && this.startWithLF(text) && this.endWithCR(this._buffers[0].buffer)) {
			this._lastChangeBufferPos = {
				line: this._lastChangeBufferPos.line,
				column: this._lastChangeBufferPos.column + 1
			};
			start = this._lastChangeBufferPos;
			for (let i = 0; i < lineStarts.length; i++) lineStarts[i] += startOffset + 1;
			this._buffers[0].lineStarts = this._buffers[0].lineStarts.concat(lineStarts.slice(1));
			this._buffers[0].buffer += "_" + text;
			startOffset += 1;
		} else {
			if (startOffset !== 0) for (let i = 0; i < lineStarts.length; i++) lineStarts[i] += startOffset;
			this._buffers[0].lineStarts = this._buffers[0].lineStarts.concat(lineStarts.slice(1));
			this._buffers[0].buffer += text;
		}
		const endOffset = this._buffers[0].buffer.length;
		const endIndex = this._buffers[0].lineStarts.length - 1;
		const endPos = {
			line: endIndex,
			column: endOffset - this._buffers[0].lineStarts[endIndex]
		};
		const newPiece = new Piece(
			0,
			/** todo@peng */
			start,
			endPos,
			this.getLineFeedCnt(0, start, endPos),
			endOffset - startOffset
		);
		this._lastChangeBufferPos = endPos;
		return [newPiece];
	}
	getLineRawContent(lineNumber, endOffset = 0) {
		let x = this.root;
		let ret = "";
		const cache = this._searchCache.get2(lineNumber);
		if (cache) {
			x = cache.node;
			const prevAccumulatedValue = this.getAccumulatedValue(x, lineNumber - cache.nodeStartLineNumber - 1);
			const buffer = this._buffers[x.piece.bufferIndex].buffer;
			const startOffset = this.offsetInBuffer(x.piece.bufferIndex, x.piece.start);
			if (cache.nodeStartLineNumber + x.piece.lineFeedCnt === lineNumber) ret = buffer.substring(startOffset + prevAccumulatedValue, startOffset + x.piece.length);
			else {
				const accumulatedValue = this.getAccumulatedValue(x, lineNumber - cache.nodeStartLineNumber);
				return buffer.substring(startOffset + prevAccumulatedValue, startOffset + accumulatedValue - endOffset);
			}
		} else {
			let nodeStartOffset = 0;
			const originalLineNumber = lineNumber;
			while (x !== SENTINEL) if (x.left !== SENTINEL && x.lf_left >= lineNumber - 1) x = x.left;
			else if (x.lf_left + x.piece.lineFeedCnt > lineNumber - 1) {
				const prevAccumulatedValue = this.getAccumulatedValue(x, lineNumber - x.lf_left - 2);
				const accumulatedValue = this.getAccumulatedValue(x, lineNumber - x.lf_left - 1);
				const buffer = this._buffers[x.piece.bufferIndex].buffer;
				const startOffset = this.offsetInBuffer(x.piece.bufferIndex, x.piece.start);
				nodeStartOffset += x.size_left;
				this._searchCache.set({
					node: x,
					nodeStartOffset,
					nodeStartLineNumber: originalLineNumber - (lineNumber - 1 - x.lf_left)
				});
				return buffer.substring(startOffset + prevAccumulatedValue, startOffset + accumulatedValue - endOffset);
			} else if (x.lf_left + x.piece.lineFeedCnt === lineNumber - 1) {
				const prevAccumulatedValue = this.getAccumulatedValue(x, lineNumber - x.lf_left - 2);
				const buffer = this._buffers[x.piece.bufferIndex].buffer;
				const startOffset = this.offsetInBuffer(x.piece.bufferIndex, x.piece.start);
				ret = buffer.substring(startOffset + prevAccumulatedValue, startOffset + x.piece.length);
				break;
			} else {
				lineNumber -= x.lf_left + x.piece.lineFeedCnt;
				nodeStartOffset += x.size_left + x.piece.length;
				x = x.right;
			}
		}
		x = x.next();
		while (x !== SENTINEL) {
			const buffer = this._buffers[x.piece.bufferIndex].buffer;
			if (x.piece.lineFeedCnt > 0) {
				const accumulatedValue = this.getAccumulatedValue(x, 0);
				const startOffset = this.offsetInBuffer(x.piece.bufferIndex, x.piece.start);
				ret += buffer.substring(startOffset, startOffset + accumulatedValue - endOffset);
				return ret;
			} else {
				const startOffset = this.offsetInBuffer(x.piece.bufferIndex, x.piece.start);
				ret += buffer.substr(startOffset, x.piece.length);
			}
			x = x.next();
		}
		return ret;
	}
	computeBufferMetadata() {
		let x = this.root;
		let lfCnt = 1;
		let len = 0;
		while (x !== SENTINEL) {
			lfCnt += x.lf_left + x.piece.lineFeedCnt;
			len += x.size_left + x.piece.length;
			x = x.right;
		}
		this._lineCnt = lfCnt;
		this._length = len;
		this._searchCache.validate(this._length);
	}
	getIndexOf(node, accumulatedValue) {
		const piece = node.piece;
		const pos = this.positionInBuffer(node, accumulatedValue);
		const lineCnt = pos.line - piece.start.line;
		if (this.offsetInBuffer(piece.bufferIndex, piece.end) - this.offsetInBuffer(piece.bufferIndex, piece.start) === accumulatedValue) {
			const realLineCnt = this.getLineFeedCnt(node.piece.bufferIndex, piece.start, pos);
			if (realLineCnt !== lineCnt) return {
				index: realLineCnt,
				remainder: 0
			};
		}
		return {
			index: lineCnt,
			remainder: pos.column
		};
	}
	getAccumulatedValue(node, index) {
		if (index < 0) return 0;
		const piece = node.piece;
		const lineStarts = this._buffers[piece.bufferIndex].lineStarts;
		const expectedLineStartIndex = piece.start.line + index + 1;
		if (expectedLineStartIndex > piece.end.line) return lineStarts[piece.end.line] + piece.end.column - lineStarts[piece.start.line] - piece.start.column;
		else return lineStarts[expectedLineStartIndex] - lineStarts[piece.start.line] - piece.start.column;
	}
	deleteNodeTail(node, pos) {
		const piece = node.piece;
		const originalLFCnt = piece.lineFeedCnt;
		const originalEndOffset = this.offsetInBuffer(piece.bufferIndex, piece.end);
		const newEnd = pos;
		const newEndOffset = this.offsetInBuffer(piece.bufferIndex, newEnd);
		const newLineFeedCnt = this.getLineFeedCnt(piece.bufferIndex, piece.start, newEnd);
		const lf_delta = newLineFeedCnt - originalLFCnt;
		const size_delta = newEndOffset - originalEndOffset;
		const newLength = piece.length + size_delta;
		node.piece = new Piece(piece.bufferIndex, piece.start, newEnd, newLineFeedCnt, newLength);
		updateTreeMetadata(this, node, size_delta, lf_delta);
	}
	deleteNodeHead(node, pos) {
		const piece = node.piece;
		const originalLFCnt = piece.lineFeedCnt;
		const originalStartOffset = this.offsetInBuffer(piece.bufferIndex, piece.start);
		const newStart = pos;
		const newLineFeedCnt = this.getLineFeedCnt(piece.bufferIndex, newStart, piece.end);
		const newStartOffset = this.offsetInBuffer(piece.bufferIndex, newStart);
		const lf_delta = newLineFeedCnt - originalLFCnt;
		const size_delta = originalStartOffset - newStartOffset;
		const newLength = piece.length + size_delta;
		node.piece = new Piece(piece.bufferIndex, newStart, piece.end, newLineFeedCnt, newLength);
		updateTreeMetadata(this, node, size_delta, lf_delta);
	}
	shrinkNode(node, start, end) {
		const piece = node.piece;
		const originalStartPos = piece.start;
		const originalEndPos = piece.end;
		const oldLength = piece.length;
		const oldLFCnt = piece.lineFeedCnt;
		const newEnd = start;
		const newLineFeedCnt = this.getLineFeedCnt(piece.bufferIndex, piece.start, newEnd);
		const newLength = this.offsetInBuffer(piece.bufferIndex, start) - this.offsetInBuffer(piece.bufferIndex, originalStartPos);
		node.piece = new Piece(piece.bufferIndex, piece.start, newEnd, newLineFeedCnt, newLength);
		updateTreeMetadata(this, node, newLength - oldLength, newLineFeedCnt - oldLFCnt);
		const newPiece = new Piece(piece.bufferIndex, end, originalEndPos, this.getLineFeedCnt(piece.bufferIndex, end, originalEndPos), this.offsetInBuffer(piece.bufferIndex, originalEndPos) - this.offsetInBuffer(piece.bufferIndex, end));
		const newNode = this.rbInsertRight(node, newPiece);
		this.validateCRLFWithPrevNode(newNode);
	}
	appendToNode(node, value) {
		if (this.adjustCarriageReturnFromNext(value, node)) value += "\n";
		const hitCRLF = this.shouldCheckCRLF() && this.startWithLF(value) && this.endWithCR(node);
		const startOffset = this._buffers[0].buffer.length;
		this._buffers[0].buffer += value;
		const lineStarts = createLineStartsFast(value, false);
		for (let i = 0; i < lineStarts.length; i++) lineStarts[i] += startOffset;
		if (hitCRLF) {
			const prevStartOffset = this._buffers[0].lineStarts[this._buffers[0].lineStarts.length - 2];
			this._buffers[0].lineStarts.pop();
			this._lastChangeBufferPos = {
				line: this._lastChangeBufferPos.line - 1,
				column: startOffset - prevStartOffset
			};
		}
		this._buffers[0].lineStarts = this._buffers[0].lineStarts.concat(lineStarts.slice(1));
		const endIndex = this._buffers[0].lineStarts.length - 1;
		const newEnd = {
			line: endIndex,
			column: this._buffers[0].buffer.length - this._buffers[0].lineStarts[endIndex]
		};
		const newLength = node.piece.length + value.length;
		const oldLineFeedCnt = node.piece.lineFeedCnt;
		const newLineFeedCnt = this.getLineFeedCnt(0, node.piece.start, newEnd);
		const lf_delta = newLineFeedCnt - oldLineFeedCnt;
		node.piece = new Piece(node.piece.bufferIndex, node.piece.start, newEnd, newLineFeedCnt, newLength);
		this._lastChangeBufferPos = newEnd;
		updateTreeMetadata(this, node, value.length, lf_delta);
	}
	nodeAt(offset) {
		let x = this.root;
		const cache = this._searchCache.get(offset);
		if (cache) return {
			node: cache.node,
			nodeStartOffset: cache.nodeStartOffset,
			remainder: offset - cache.nodeStartOffset
		};
		let nodeStartOffset = 0;
		while (x !== SENTINEL) if (x.size_left > offset) x = x.left;
		else if (x.size_left + x.piece.length >= offset) {
			nodeStartOffset += x.size_left;
			const ret = {
				node: x,
				remainder: offset - x.size_left,
				nodeStartOffset
			};
			this._searchCache.set(ret);
			return ret;
		} else {
			offset -= x.size_left + x.piece.length;
			nodeStartOffset += x.size_left + x.piece.length;
			x = x.right;
		}
		return null;
	}
	nodeAt2(lineNumber, column) {
		let x = this.root;
		let nodeStartOffset = 0;
		while (x !== SENTINEL) if (x.left !== SENTINEL && x.lf_left >= lineNumber - 1) x = x.left;
		else if (x.lf_left + x.piece.lineFeedCnt > lineNumber - 1) {
			const prevAccumualtedValue = this.getAccumulatedValue(x, lineNumber - x.lf_left - 2);
			const accumulatedValue = this.getAccumulatedValue(x, lineNumber - x.lf_left - 1);
			nodeStartOffset += x.size_left;
			return {
				node: x,
				remainder: Math.min(prevAccumualtedValue + column - 1, accumulatedValue),
				nodeStartOffset
			};
		} else if (x.lf_left + x.piece.lineFeedCnt === lineNumber - 1) {
			const prevAccumualtedValue = this.getAccumulatedValue(x, lineNumber - x.lf_left - 2);
			if (prevAccumualtedValue + column - 1 <= x.piece.length) return {
				node: x,
				remainder: prevAccumualtedValue + column - 1,
				nodeStartOffset
			};
			else {
				column -= x.piece.length - prevAccumualtedValue;
				break;
			}
		} else {
			lineNumber -= x.lf_left + x.piece.lineFeedCnt;
			nodeStartOffset += x.size_left + x.piece.length;
			x = x.right;
		}
		x = x.next();
		while (x !== SENTINEL) {
			if (x.piece.lineFeedCnt > 0) {
				const accumulatedValue = this.getAccumulatedValue(x, 0);
				const nodeStartOffset = this.offsetOfNode(x);
				return {
					node: x,
					remainder: Math.min(column - 1, accumulatedValue),
					nodeStartOffset
				};
			} else if (x.piece.length >= column - 1) {
				const nodeStartOffset = this.offsetOfNode(x);
				return {
					node: x,
					remainder: column - 1,
					nodeStartOffset
				};
			} else column -= x.piece.length;
			x = x.next();
		}
		return null;
	}
	nodeCharCodeAt(node, offset) {
		if (node.piece.lineFeedCnt < 1) return -1;
		const buffer = this._buffers[node.piece.bufferIndex];
		const newOffset = this.offsetInBuffer(node.piece.bufferIndex, node.piece.start) + offset;
		return buffer.buffer.charCodeAt(newOffset);
	}
	offsetOfNode(node) {
		if (!node) return 0;
		let pos = node.size_left;
		while (node !== this.root) {
			if (node.parent.right === node) pos += node.parent.size_left + node.parent.piece.length;
			node = node.parent;
		}
		return pos;
	}
	shouldCheckCRLF() {
		return !(this._EOLNormalized && this._EOL === "\n");
	}
	startWithLF(val) {
		if (typeof val === "string") return val.charCodeAt(0) === 10;
		if (val === SENTINEL || val.piece.lineFeedCnt === 0) return false;
		const piece = val.piece;
		const lineStarts = this._buffers[piece.bufferIndex].lineStarts;
		const line = piece.start.line;
		const startOffset = lineStarts[line] + piece.start.column;
		if (line === lineStarts.length - 1) return false;
		if (lineStarts[line + 1] > startOffset + 1) return false;
		return this._buffers[piece.bufferIndex].buffer.charCodeAt(startOffset) === 10;
	}
	endWithCR(val) {
		if (typeof val === "string") return val.charCodeAt(val.length - 1) === 13;
		if (val === SENTINEL || val.piece.lineFeedCnt === 0) return false;
		return this.nodeCharCodeAt(val, val.piece.length - 1) === 13;
	}
	validateCRLFWithPrevNode(nextNode) {
		if (this.shouldCheckCRLF() && this.startWithLF(nextNode)) {
			const node = nextNode.prev();
			if (this.endWithCR(node)) this.fixCRLF(node, nextNode);
		}
	}
	validateCRLFWithNextNode(node) {
		if (this.shouldCheckCRLF() && this.endWithCR(node)) {
			const nextNode = node.next();
			if (this.startWithLF(nextNode)) this.fixCRLF(node, nextNode);
		}
	}
	fixCRLF(prev, next) {
		const nodesToDel = [];
		const lineStarts = this._buffers[prev.piece.bufferIndex].lineStarts;
		let newEnd;
		if (prev.piece.end.column === 0) newEnd = {
			line: prev.piece.end.line - 1,
			column: lineStarts[prev.piece.end.line] - lineStarts[prev.piece.end.line - 1] - 1
		};
		else newEnd = {
			line: prev.piece.end.line,
			column: prev.piece.end.column - 1
		};
		const prevNewLength = prev.piece.length - 1;
		const prevNewLFCnt = prev.piece.lineFeedCnt - 1;
		prev.piece = new Piece(prev.piece.bufferIndex, prev.piece.start, newEnd, prevNewLFCnt, prevNewLength);
		updateTreeMetadata(this, prev, -1, -1);
		if (prev.piece.length === 0) nodesToDel.push(prev);
		const newStart = {
			line: next.piece.start.line + 1,
			column: 0
		};
		const newLength = next.piece.length - 1;
		const newLineFeedCnt = this.getLineFeedCnt(next.piece.bufferIndex, newStart, next.piece.end);
		next.piece = new Piece(next.piece.bufferIndex, newStart, next.piece.end, newLineFeedCnt, newLength);
		updateTreeMetadata(this, next, -1, -1);
		if (next.piece.length === 0) nodesToDel.push(next);
		const pieces = this.createNewPieces("\r\n");
		this.rbInsertRight(prev, pieces[0]);
		for (let i = 0; i < nodesToDel.length; i++) rbDelete(this, nodesToDel[i]);
	}
	adjustCarriageReturnFromNext(value, node) {
		if (this.shouldCheckCRLF() && this.endWithCR(value)) {
			const nextNode = node.next();
			if (this.startWithLF(nextNode)) {
				value += "\n";
				if (nextNode.piece.length === 1) rbDelete(this, nextNode);
				else {
					const piece = nextNode.piece;
					const newStart = {
						line: piece.start.line + 1,
						column: 0
					};
					const newLength = piece.length - 1;
					const newLineFeedCnt = this.getLineFeedCnt(piece.bufferIndex, newStart, piece.end);
					nextNode.piece = new Piece(piece.bufferIndex, newStart, piece.end, newLineFeedCnt, newLength);
					updateTreeMetadata(this, nextNode, -1, -1);
				}
				return true;
			}
		}
		return false;
	}
	iterate(node, callback) {
		if (node === SENTINEL) return callback(SENTINEL);
		const leftRet = this.iterate(node.left, callback);
		if (!leftRet) return leftRet;
		return callback(node) && this.iterate(node.right, callback);
	}
	getNodeContent(node) {
		if (node === SENTINEL) return "";
		const buffer = this._buffers[node.piece.bufferIndex];
		const piece = node.piece;
		const startOffset = this.offsetInBuffer(piece.bufferIndex, piece.start);
		const endOffset = this.offsetInBuffer(piece.bufferIndex, piece.end);
		return buffer.buffer.substring(startOffset, endOffset);
	}
	getPieceContent(piece) {
		const buffer = this._buffers[piece.bufferIndex];
		const startOffset = this.offsetInBuffer(piece.bufferIndex, piece.start);
		const endOffset = this.offsetInBuffer(piece.bufferIndex, piece.end);
		return buffer.buffer.substring(startOffset, endOffset);
	}
	/**
	*      node              node
	*     /  \              /  \
	*    a   b    <----   a    b
	*                         /
	*                        z
	*/
	rbInsertRight(node, p) {
		const z = new TreeNode(p, 1);
		z.left = SENTINEL;
		z.right = SENTINEL;
		z.parent = SENTINEL;
		z.size_left = 0;
		z.lf_left = 0;
		if (this.root === SENTINEL) {
			this.root = z;
			z.color = 0;
		} else if (node.right === SENTINEL) {
			node.right = z;
			z.parent = node;
		} else {
			const nextNode = leftest(node.right);
			nextNode.left = z;
			z.parent = nextNode;
		}
		fixInsert(this, z);
		return z;
	}
	/**
	*      node              node
	*     /  \              /  \
	*    a   b     ---->   a    b
	*                       \
	*                        z
	*/
	rbInsertLeft(node, p) {
		const z = new TreeNode(p, 1);
		z.left = SENTINEL;
		z.right = SENTINEL;
		z.parent = SENTINEL;
		z.size_left = 0;
		z.lf_left = 0;
		if (this.root === SENTINEL) {
			this.root = z;
			z.color = 0;
		} else if (node.left === SENTINEL) {
			node.left = z;
			z.parent = node;
		} else {
			const prevNode = righttest(node.left);
			prevNode.right = z;
			z.parent = prevNode;
		}
		fixInsert(this, z);
		return z;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/pieceTreeTextBuffer/pieceTreeTextBuffer.js
var PieceTreeTextBuffer = class PieceTreeTextBuffer extends Disposable {
	constructor(chunks, BOM, eol, containsRTL, containsUnusualLineTerminators, isBasicASCII, eolNormalized) {
		super();
		this._onDidChangeContent = this._register(new Emitter$1());
		this._BOM = BOM;
		this._mightContainNonBasicASCII = !isBasicASCII;
		this._mightContainRTL = containsRTL;
		this._mightContainUnusualLineTerminators = containsUnusualLineTerminators;
		this._pieceTree = new PieceTreeBase(chunks, eol, eolNormalized);
	}
	mightContainRTL() {
		return this._mightContainRTL;
	}
	mightContainUnusualLineTerminators() {
		return this._mightContainUnusualLineTerminators;
	}
	resetMightContainUnusualLineTerminators() {
		this._mightContainUnusualLineTerminators = false;
	}
	mightContainNonBasicASCII() {
		return this._mightContainNonBasicASCII;
	}
	getBOM() {
		return this._BOM;
	}
	getEOL() {
		return this._pieceTree.getEOL();
	}
	createSnapshot(preserveBOM) {
		return this._pieceTree.createSnapshot(preserveBOM ? this._BOM : "");
	}
	getOffsetAt(lineNumber, column) {
		return this._pieceTree.getOffsetAt(lineNumber, column);
	}
	getPositionAt(offset) {
		return this._pieceTree.getPositionAt(offset);
	}
	getRangeAt(start, length) {
		const end = start + length;
		const startPosition = this.getPositionAt(start);
		const endPosition = this.getPositionAt(end);
		return new Range$2(startPosition.lineNumber, startPosition.column, endPosition.lineNumber, endPosition.column);
	}
	getValueInRange(range, eol = 0) {
		if (range.isEmpty()) return "";
		const lineEnding = this._getEndOfLine(eol);
		return this._pieceTree.getValueInRange(range, lineEnding);
	}
	getValueLengthInRange(range, eol = 0) {
		if (range.isEmpty()) return 0;
		if (range.startLineNumber === range.endLineNumber) return range.endColumn - range.startColumn;
		const startOffset = this.getOffsetAt(range.startLineNumber, range.startColumn);
		const endOffset = this.getOffsetAt(range.endLineNumber, range.endColumn);
		let eolOffsetCompensation = 0;
		const desiredEOL = this._getEndOfLine(eol);
		const actualEOL = this.getEOL();
		if (desiredEOL.length !== actualEOL.length) eolOffsetCompensation = (desiredEOL.length - actualEOL.length) * (range.endLineNumber - range.startLineNumber);
		return endOffset - startOffset + eolOffsetCompensation;
	}
	getCharacterCountInRange(range, eol = 0) {
		if (this._mightContainNonBasicASCII) {
			let result = 0;
			const fromLineNumber = range.startLineNumber;
			const toLineNumber = range.endLineNumber;
			for (let lineNumber = fromLineNumber; lineNumber <= toLineNumber; lineNumber++) {
				const lineContent = this.getLineContent(lineNumber);
				const fromOffset = lineNumber === fromLineNumber ? range.startColumn - 1 : 0;
				const toOffset = lineNumber === toLineNumber ? range.endColumn - 1 : lineContent.length;
				for (let offset = fromOffset; offset < toOffset; offset++) if (isHighSurrogate(lineContent.charCodeAt(offset))) {
					result = result + 1;
					offset = offset + 1;
				} else result = result + 1;
			}
			result += this._getEndOfLine(eol).length * (toLineNumber - fromLineNumber);
			return result;
		}
		return this.getValueLengthInRange(range, eol);
	}
	getNearestChunk(offset) {
		return this._pieceTree.getNearestChunk(offset);
	}
	getLength() {
		return this._pieceTree.getLength();
	}
	getLineCount() {
		return this._pieceTree.getLineCount();
	}
	getLinesContent() {
		return this._pieceTree.getLinesContent();
	}
	getLineContent(lineNumber) {
		return this._pieceTree.getLineContent(lineNumber);
	}
	getLineCharCode(lineNumber, index) {
		return this._pieceTree.getLineCharCode(lineNumber, index);
	}
	getLineLength(lineNumber) {
		return this._pieceTree.getLineLength(lineNumber);
	}
	getLineFirstNonWhitespaceColumn(lineNumber) {
		const result = firstNonWhitespaceIndex(this.getLineContent(lineNumber));
		if (result === -1) return 0;
		return result + 1;
	}
	getLineLastNonWhitespaceColumn(lineNumber) {
		const result = lastNonWhitespaceIndex(this.getLineContent(lineNumber));
		if (result === -1) return 0;
		return result + 2;
	}
	_getEndOfLine(eol) {
		switch (eol) {
			case 1: return "\n";
			case 2: return "\r\n";
			case 0: return this.getEOL();
			default: throw new Error("Unknown EOL preference");
		}
	}
	setEOL(newEOL) {
		this._pieceTree.setEOL(newEOL);
	}
	applyEdits(rawOperations, recordTrimAutoWhitespace, computeUndoEdits) {
		let mightContainRTL = this._mightContainRTL;
		let mightContainUnusualLineTerminators = this._mightContainUnusualLineTerminators;
		let mightContainNonBasicASCII = this._mightContainNonBasicASCII;
		let canReduceOperations = true;
		let operations = [];
		for (let i = 0; i < rawOperations.length; i++) {
			const op = rawOperations[i];
			if (canReduceOperations && op._isTracked) canReduceOperations = false;
			const validatedRange = op.range;
			if (op.text) {
				let textMightContainNonBasicASCII = true;
				if (!mightContainNonBasicASCII) {
					textMightContainNonBasicASCII = !isBasicASCII(op.text);
					mightContainNonBasicASCII = textMightContainNonBasicASCII;
				}
				if (!mightContainRTL && textMightContainNonBasicASCII) mightContainRTL = containsRTL(op.text);
				if (!mightContainUnusualLineTerminators && textMightContainNonBasicASCII) mightContainUnusualLineTerminators = containsUnusualLineTerminators(op.text);
			}
			let validText = "";
			let eolCount = 0;
			let firstLineLength = 0;
			let lastLineLength = 0;
			if (op.text) {
				let strEOL;
				[eolCount, firstLineLength, lastLineLength, strEOL] = countEOL(op.text);
				const bufferEOL = this.getEOL();
				if (strEOL === 0 || strEOL === (bufferEOL === "\r\n" ? 2 : 1)) validText = op.text;
				else validText = op.text.replace(/\r\n|\r|\n/g, bufferEOL);
			}
			operations[i] = {
				sortIndex: i,
				identifier: op.identifier || null,
				range: validatedRange,
				rangeOffset: this.getOffsetAt(validatedRange.startLineNumber, validatedRange.startColumn),
				rangeLength: this.getValueLengthInRange(validatedRange),
				text: validText,
				eolCount,
				firstLineLength,
				lastLineLength,
				forceMoveMarkers: Boolean(op.forceMoveMarkers),
				isAutoWhitespaceEdit: op.isAutoWhitespaceEdit || false
			};
		}
		operations.sort(PieceTreeTextBuffer._sortOpsAscending);
		let hasTouchingRanges = false;
		for (let i = 0, count = operations.length - 1; i < count; i++) {
			const rangeEnd = operations[i].range.getEndPosition();
			const nextRangeStart = operations[i + 1].range.getStartPosition();
			if (nextRangeStart.isBeforeOrEqual(rangeEnd)) {
				if (nextRangeStart.isBefore(rangeEnd)) throw new Error("Overlapping ranges are not allowed!");
				hasTouchingRanges = true;
			}
		}
		if (canReduceOperations) operations = this._reduceOperations(operations);
		const reverseRanges = computeUndoEdits || recordTrimAutoWhitespace ? PieceTreeTextBuffer._getInverseEditRanges(operations) : [];
		const newTrimAutoWhitespaceCandidates = [];
		if (recordTrimAutoWhitespace) for (let i = 0; i < operations.length; i++) {
			const op = operations[i];
			const reverseRange = reverseRanges[i];
			if (op.isAutoWhitespaceEdit && op.range.isEmpty()) for (let lineNumber = reverseRange.startLineNumber; lineNumber <= reverseRange.endLineNumber; lineNumber++) {
				let currentLineContent = "";
				if (lineNumber === reverseRange.startLineNumber) {
					currentLineContent = this.getLineContent(op.range.startLineNumber);
					if (firstNonWhitespaceIndex(currentLineContent) !== -1) continue;
				}
				newTrimAutoWhitespaceCandidates.push({
					lineNumber,
					oldContent: currentLineContent
				});
			}
		}
		let reverseOperations = null;
		if (computeUndoEdits) {
			let reverseRangeDeltaOffset = 0;
			reverseOperations = [];
			for (let i = 0; i < operations.length; i++) {
				const op = operations[i];
				const reverseRange = reverseRanges[i];
				const bufferText = this.getValueInRange(op.range);
				const reverseRangeOffset = op.rangeOffset + reverseRangeDeltaOffset;
				reverseRangeDeltaOffset += op.text.length - bufferText.length;
				reverseOperations[i] = {
					sortIndex: op.sortIndex,
					identifier: op.identifier,
					range: reverseRange,
					text: bufferText,
					textChange: new TextChange(op.rangeOffset, bufferText, reverseRangeOffset, op.text)
				};
			}
			if (!hasTouchingRanges) reverseOperations.sort((a, b) => a.sortIndex - b.sortIndex);
		}
		this._mightContainRTL = mightContainRTL;
		this._mightContainUnusualLineTerminators = mightContainUnusualLineTerminators;
		this._mightContainNonBasicASCII = mightContainNonBasicASCII;
		const contentChanges = this._doApplyEdits(operations);
		let trimAutoWhitespaceLineNumbers = null;
		if (recordTrimAutoWhitespace && newTrimAutoWhitespaceCandidates.length > 0) {
			newTrimAutoWhitespaceCandidates.sort((a, b) => b.lineNumber - a.lineNumber);
			trimAutoWhitespaceLineNumbers = [];
			for (let i = 0, len = newTrimAutoWhitespaceCandidates.length; i < len; i++) {
				const lineNumber = newTrimAutoWhitespaceCandidates[i].lineNumber;
				if (i > 0 && newTrimAutoWhitespaceCandidates[i - 1].lineNumber === lineNumber) continue;
				const prevContent = newTrimAutoWhitespaceCandidates[i].oldContent;
				const lineContent = this.getLineContent(lineNumber);
				if (lineContent.length === 0 || lineContent === prevContent || firstNonWhitespaceIndex(lineContent) !== -1) continue;
				trimAutoWhitespaceLineNumbers.push(lineNumber);
			}
		}
		this._onDidChangeContent.fire();
		return new ApplyEditsResult(reverseOperations, contentChanges, trimAutoWhitespaceLineNumbers);
	}
	/**
	* Transform operations such that they represent the same logic edit,
	* but that they also do not cause OOM crashes.
	*/
	_reduceOperations(operations) {
		if (operations.length < 1e3) return operations;
		return [this._toSingleEditOperation(operations)];
	}
	_toSingleEditOperation(operations) {
		let forceMoveMarkers = false;
		const firstEditRange = operations[0].range;
		const lastEditRange = operations[operations.length - 1].range;
		const entireEditRange = new Range$2(firstEditRange.startLineNumber, firstEditRange.startColumn, lastEditRange.endLineNumber, lastEditRange.endColumn);
		let lastEndLineNumber = firstEditRange.startLineNumber;
		let lastEndColumn = firstEditRange.startColumn;
		const result = [];
		for (let i = 0, len = operations.length; i < len; i++) {
			const operation = operations[i];
			const range = operation.range;
			forceMoveMarkers = forceMoveMarkers || operation.forceMoveMarkers;
			result.push(this.getValueInRange(new Range$2(lastEndLineNumber, lastEndColumn, range.startLineNumber, range.startColumn)));
			if (operation.text.length > 0) result.push(operation.text);
			lastEndLineNumber = range.endLineNumber;
			lastEndColumn = range.endColumn;
		}
		const text = result.join("");
		const [eolCount, firstLineLength, lastLineLength] = countEOL(text);
		return {
			sortIndex: 0,
			identifier: operations[0].identifier,
			range: entireEditRange,
			rangeOffset: this.getOffsetAt(entireEditRange.startLineNumber, entireEditRange.startColumn),
			rangeLength: this.getValueLengthInRange(entireEditRange, 0),
			text,
			eolCount,
			firstLineLength,
			lastLineLength,
			forceMoveMarkers,
			isAutoWhitespaceEdit: false
		};
	}
	_doApplyEdits(operations) {
		operations.sort(PieceTreeTextBuffer._sortOpsDescending);
		const contentChanges = [];
		for (let i = 0; i < operations.length; i++) {
			const op = operations[i];
			const startLineNumber = op.range.startLineNumber;
			const startColumn = op.range.startColumn;
			const endLineNumber = op.range.endLineNumber;
			const endColumn = op.range.endColumn;
			if (startLineNumber === endLineNumber && startColumn === endColumn && op.text.length === 0) continue;
			if (op.text) {
				this._pieceTree.delete(op.rangeOffset, op.rangeLength);
				this._pieceTree.insert(op.rangeOffset, op.text, true);
			} else this._pieceTree.delete(op.rangeOffset, op.rangeLength);
			const contentChangeRange = new Range$2(startLineNumber, startColumn, endLineNumber, endColumn);
			contentChanges.push({
				range: contentChangeRange,
				rangeLength: op.rangeLength,
				text: op.text,
				rangeOffset: op.rangeOffset,
				forceMoveMarkers: op.forceMoveMarkers
			});
		}
		return contentChanges;
	}
	findMatchesLineByLine(searchRange, searchData, captureMatches, limitResultCount) {
		return this._pieceTree.findMatchesLineByLine(searchRange, searchData, captureMatches, limitResultCount);
	}
	/**
	* Assumes `operations` are validated and sorted ascending
	*/
	static _getInverseEditRanges(operations) {
		const result = [];
		let prevOpEndLineNumber = 0;
		let prevOpEndColumn = 0;
		let prevOp = null;
		for (let i = 0, len = operations.length; i < len; i++) {
			const op = operations[i];
			let startLineNumber;
			let startColumn;
			if (prevOp) {
				if (prevOp.range.endLineNumber === op.range.startLineNumber) {
					startLineNumber = prevOpEndLineNumber;
					startColumn = prevOpEndColumn + (op.range.startColumn - prevOp.range.endColumn);
				} else {
					startLineNumber = prevOpEndLineNumber + (op.range.startLineNumber - prevOp.range.endLineNumber);
					startColumn = op.range.startColumn;
				}
			} else {
				startLineNumber = op.range.startLineNumber;
				startColumn = op.range.startColumn;
			}
			let resultRange;
			if (op.text.length > 0) {
				const lineCount = op.eolCount + 1;
				if (lineCount === 1) resultRange = new Range$2(startLineNumber, startColumn, startLineNumber, startColumn + op.firstLineLength);
				else resultRange = new Range$2(startLineNumber, startColumn, startLineNumber + lineCount - 1, op.lastLineLength + 1);
			} else resultRange = new Range$2(startLineNumber, startColumn, startLineNumber, startColumn);
			prevOpEndLineNumber = resultRange.endLineNumber;
			prevOpEndColumn = resultRange.endColumn;
			result.push(resultRange);
			prevOp = op;
		}
		return result;
	}
	static _sortOpsAscending(a, b) {
		const r = Range$2.compareRangesUsingEnds(a.range, b.range);
		if (r === 0) return a.sortIndex - b.sortIndex;
		return r;
	}
	static _sortOpsDescending(a, b) {
		const r = Range$2.compareRangesUsingEnds(a.range, b.range);
		if (r === 0) return b.sortIndex - a.sortIndex;
		return -r;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/pieceTreeTextBuffer/pieceTreeTextBufferBuilder.js
var PieceTreeTextBufferFactory = class {
	constructor(_chunks, _bom, _cr, _lf, _crlf, _containsRTL, _containsUnusualLineTerminators, _isBasicASCII, _normalizeEOL) {
		this._chunks = _chunks;
		this._bom = _bom;
		this._cr = _cr;
		this._lf = _lf;
		this._crlf = _crlf;
		this._containsRTL = _containsRTL;
		this._containsUnusualLineTerminators = _containsUnusualLineTerminators;
		this._isBasicASCII = _isBasicASCII;
		this._normalizeEOL = _normalizeEOL;
	}
	_getEOL(defaultEOL) {
		const totalEOLCount = this._cr + this._lf + this._crlf;
		const totalCRCount = this._cr + this._crlf;
		if (totalEOLCount === 0) return defaultEOL === 1 ? "\n" : "\r\n";
		if (totalCRCount > totalEOLCount / 2) return "\r\n";
		return "\n";
	}
	create(defaultEOL) {
		const eol = this._getEOL(defaultEOL);
		const chunks = this._chunks;
		if (this._normalizeEOL && (eol === "\r\n" && (this._cr > 0 || this._lf > 0) || eol === "\n" && (this._cr > 0 || this._crlf > 0))) for (let i = 0, len = chunks.length; i < len; i++) {
			const str = chunks[i].buffer.replace(/\r\n|\r|\n/g, eol);
			const newLineStart = createLineStartsFast(str);
			chunks[i] = new StringBuffer(str, newLineStart);
		}
		const textBuffer = new PieceTreeTextBuffer(chunks, this._bom, eol, this._containsRTL, this._containsUnusualLineTerminators, this._isBasicASCII, this._normalizeEOL);
		return {
			textBuffer,
			disposable: textBuffer
		};
	}
};
var PieceTreeTextBufferBuilder = class {
	constructor() {
		this.chunks = [];
		this.BOM = "";
		this._hasPreviousChar = false;
		this._previousChar = 0;
		this._tmpLineStarts = [];
		this.cr = 0;
		this.lf = 0;
		this.crlf = 0;
		this.containsRTL = false;
		this.containsUnusualLineTerminators = false;
		this.isBasicASCII = true;
	}
	acceptChunk(chunk) {
		if (chunk.length === 0) return;
		if (this.chunks.length === 0) {
			if (startsWithUTF8BOM(chunk)) {
				this.BOM = "﻿";
				chunk = chunk.substr(1);
			}
		}
		const lastChar = chunk.charCodeAt(chunk.length - 1);
		if (lastChar === 13 || lastChar >= 55296 && lastChar <= 56319) {
			this._acceptChunk1(chunk.substr(0, chunk.length - 1), false);
			this._hasPreviousChar = true;
			this._previousChar = lastChar;
		} else {
			this._acceptChunk1(chunk, false);
			this._hasPreviousChar = false;
			this._previousChar = lastChar;
		}
	}
	_acceptChunk1(chunk, allowEmptyStrings) {
		if (!allowEmptyStrings && chunk.length === 0) return;
		if (this._hasPreviousChar) this._acceptChunk2(String.fromCharCode(this._previousChar) + chunk);
		else this._acceptChunk2(chunk);
	}
	_acceptChunk2(chunk) {
		const lineStarts = createLineStarts(this._tmpLineStarts, chunk);
		this.chunks.push(new StringBuffer(chunk, lineStarts.lineStarts));
		this.cr += lineStarts.cr;
		this.lf += lineStarts.lf;
		this.crlf += lineStarts.crlf;
		if (!lineStarts.isBasicASCII) {
			this.isBasicASCII = false;
			if (!this.containsRTL) this.containsRTL = containsRTL(chunk);
			if (!this.containsUnusualLineTerminators) this.containsUnusualLineTerminators = containsUnusualLineTerminators(chunk);
		}
	}
	finish(normalizeEOL = true) {
		this._finish();
		return new PieceTreeTextBufferFactory(this.chunks, this.BOM, this.cr, this.lf, this.crlf, this.containsRTL, this.containsUnusualLineTerminators, this.isBasicASCII, normalizeEOL);
	}
	_finish() {
		if (this.chunks.length === 0) this._acceptChunk1("", true);
		if (this._hasPreviousChar) {
			this._hasPreviousChar = false;
			const lastChunk = this.chunks[this.chunks.length - 1];
			lastChunk.buffer += String.fromCharCode(this._previousChar);
			lastChunk.lineStarts = createLineStartsFast(lastChunk.buffer);
			if (this._previousChar === 13) this.cr++;
		}
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/observableInternal/observables/lazyObservableValue.js
/**
* Holds off updating observers until the value is actually read.
*/
var LazyObservableValue = class extends BaseObservable {
	get debugName() {
		return this._debugNameData.getDebugName(this) ?? "LazyObservableValue";
	}
	constructor(_debugNameData, initialValue, _equalityComparator, debugLocation) {
		super(debugLocation);
		this._debugNameData = _debugNameData;
		this._equalityComparator = _equalityComparator;
		this._isUpToDate = true;
		this._deltas = [];
		this._updateCounter = 0;
		this._value = initialValue;
	}
	get() {
		this._update();
		return this._value;
	}
	_update() {
		if (this._isUpToDate) return;
		this._isUpToDate = true;
		if (this._deltas.length > 0) {
			for (const change of this._deltas) {
				getLogger()?.handleObservableUpdated(this, {
					change,
					didChange: true,
					oldValue: "(unknown)",
					newValue: this._value,
					hadValue: true
				});
				for (const observer of this._observers) observer.handleChange(this, change);
			}
			this._deltas.length = 0;
		} else {
			getLogger()?.handleObservableUpdated(this, {
				change: void 0,
				didChange: true,
				oldValue: "(unknown)",
				newValue: this._value,
				hadValue: true
			});
			for (const observer of this._observers) observer.handleChange(this, void 0);
		}
	}
	_beginUpdate() {
		this._updateCounter++;
		if (this._updateCounter === 1) for (const observer of this._observers) observer.beginUpdate(this);
	}
	_endUpdate() {
		this._updateCounter--;
		if (this._updateCounter === 0) {
			this._update();
			const observers = [...this._observers];
			for (const r of observers) r.endUpdate(this);
		}
	}
	addObserver(observer) {
		const shouldCallBeginUpdate = !this._observers.has(observer) && this._updateCounter > 0;
		super.addObserver(observer);
		if (shouldCallBeginUpdate) observer.beginUpdate(this);
	}
	removeObserver(observer) {
		const shouldCallEndUpdate = this._observers.has(observer) && this._updateCounter > 0;
		super.removeObserver(observer);
		if (shouldCallEndUpdate) observer.endUpdate(this);
	}
	set(value, tx, change) {
		if (change === void 0 && this._equalityComparator(this._value, value)) return;
		let _tx;
		if (!tx) tx = _tx = new TransactionImpl(() => {}, () => `Setting ${this.debugName}`);
		try {
			this._isUpToDate = false;
			this._setValue(value);
			if (change !== void 0) this._deltas.push(change);
			tx.updateObserver({
				beginUpdate: () => this._beginUpdate(),
				endUpdate: () => this._endUpdate(),
				handleChange: (observable, change) => {},
				handlePossibleChange: (observable) => {}
			}, this);
			if (this._updateCounter > 1) for (const observer of this._observers) observer.handlePossibleChange(this);
		} finally {
			if (_tx) _tx.finish();
		}
	}
	toString() {
		return `${this.debugName}: ${this._value}`;
	}
	_setValue(newValue) {
		this._value = newValue;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/observableInternal/observables/observableValueOpts.js
function observableValueOpts(options, initialValue, debugLocation = DebugLocation.ofCaller()) {
	if (options.lazy) return new LazyObservableValue(new DebugNameData(options.owner, options.debugName, void 0), initialValue, options.equalsFn ?? strictEquals, debugLocation);
	return new ObservableValue(new DebugNameData(options.owner, options.debugName, void 0), initialValue, options.equalsFn ?? strictEquals, debugLocation);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/tokens/abstractSyntaxTokenBackend.js
/**
* @internal
*/
var AttachedViews = class {
	constructor() {
		this._onDidChangeVisibleRanges = new Emitter$1();
		this.onDidChangeVisibleRanges = this._onDidChangeVisibleRanges.event;
		this._views = /* @__PURE__ */ new Set();
		this._viewsChanged = observableSignal(this);
		this.visibleLineRanges = derivedOpts({
			owner: this,
			equalsFn: arrayEqualsC(thisEqualsC())
		}, (reader) => {
			this._viewsChanged.read(reader);
			return LineRange.joinMany([...this._views].map((view) => view.state.read(reader)?.visibleLineRanges ?? []));
		});
	}
	attachView() {
		const view = new AttachedViewImpl((state) => {
			this._onDidChangeVisibleRanges.fire({
				view,
				state
			});
		});
		this._views.add(view);
		this._viewsChanged.trigger(void 0);
		return view;
	}
	detachView(view) {
		this._views.delete(view);
		this._onDidChangeVisibleRanges.fire({
			view,
			state: void 0
		});
		this._viewsChanged.trigger(void 0);
	}
	dispose() {
		this._onDidChangeVisibleRanges.dispose();
	}
};
/**
* @internal
*/
var AttachedViewState = class {
	constructor(visibleLineRanges, stabilized) {
		this.visibleLineRanges = visibleLineRanges;
		this.stabilized = stabilized;
	}
	equals(other) {
		if (this === other) return true;
		if (!equals$1(this.visibleLineRanges, other.visibleLineRanges, (a, b) => a.equals(b))) return false;
		if (this.stabilized !== other.stabilized) return false;
		return true;
	}
};
var AttachedViewImpl = class {
	get state() {
		return this._state;
	}
	constructor(handleStateChange) {
		this.handleStateChange = handleStateChange;
		this._state = observableValueOpts({
			owner: this,
			equalsFn: equalsIfDefinedC((a, b) => a.equals(b))
		}, void 0);
	}
	setVisibleLines(visibleLines, stabilized) {
		const state = new AttachedViewState(visibleLines.map((line) => new LineRange(line.startLineNumber, line.endLineNumber + 1)), stabilized);
		this._state.set(state, void 0, void 0);
		this.handleStateChange(state);
	}
};
var AttachedViewHandler = class extends Disposable {
	get lineRanges() {
		return this._lineRanges;
	}
	constructor(_refreshTokens) {
		super();
		this._refreshTokens = _refreshTokens;
		this.runner = this._register(new RunOnceScheduler(() => this.update(), 50));
		this._computedLineRanges = [];
		this._lineRanges = [];
	}
	update() {
		if (equals$1(this._computedLineRanges, this._lineRanges, (a, b) => a.equals(b))) return;
		this._computedLineRanges = this._lineRanges;
		this._refreshTokens();
	}
	handleStateChange(state) {
		this._lineRanges = state.visibleLineRanges;
		if (state.stabilized) {
			this.runner.cancel();
			this.update();
		} else this.runner.schedule();
	}
};
var AbstractSyntaxTokenBackend = class extends Disposable {
	get backgroundTokenizationState() {
		return this._backgroundTokenizationState;
	}
	constructor(_languageIdCodec, _textModel) {
		super();
		this._languageIdCodec = _languageIdCodec;
		this._textModel = _textModel;
		this._onDidChangeTokens = this._register(new Emitter$1());
		/** @internal, should not be exposed by the text model! */
		this.onDidChangeTokens = this._onDidChangeTokens.event;
		this._onDidChangeFontTokens = this._register(new Emitter$1());
		/** @internal, should not be exposed by the text model! */
		this.onDidChangeFontTokens = this._onDidChangeFontTokens.event;
	}
	tokenizeIfCheap(lineNumber) {
		if (this.isCheapToTokenize(lineNumber)) this.forceTokenization(lineNumber);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/decorationProvider.js
var LineHeightChangingDecoration = class {
	static toKey(obj) {
		return `${obj.ownerId};${obj.decorationId};${obj.lineNumber}`;
	}
	constructor(ownerId, decorationId, lineNumber, lineHeight) {
		this.ownerId = ownerId;
		this.decorationId = decorationId;
		this.lineNumber = lineNumber;
		this.lineHeight = lineHeight;
	}
};
var LineFontChangingDecoration = class {
	static toKey(obj) {
		return `${obj.ownerId};${obj.decorationId};${obj.lineNumber}`;
	}
	constructor(ownerId, decorationId, lineNumber) {
		this.ownerId = ownerId;
		this.decorationId = decorationId;
		this.lineNumber = lineNumber;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/languages/supports/tokenization.js
var ParsedTokenThemeRule = class {
	constructor(token, index, fontStyle, foreground, background) {
		this._parsedThemeRuleBrand = void 0;
		this.token = token;
		this.index = index;
		this.fontStyle = fontStyle;
		this.foreground = foreground;
		this.background = background;
	}
};
/**
* Parse a raw theme into rules.
*/
function parseTokenTheme(source) {
	if (!source || !Array.isArray(source)) return [];
	const result = [];
	let resultLen = 0;
	for (let i = 0, len = source.length; i < len; i++) {
		const entry = source[i];
		let fontStyle = -1;
		if (typeof entry.fontStyle === "string") {
			fontStyle = 0;
			const segments = entry.fontStyle.split(" ");
			for (let j = 0, lenJ = segments.length; j < lenJ; j++) switch (segments[j]) {
				case "italic":
					fontStyle = fontStyle | 1;
					break;
				case "bold":
					fontStyle = fontStyle | 2;
					break;
				case "underline":
					fontStyle = fontStyle | 4;
					break;
				case "strikethrough": fontStyle = fontStyle | 8;
			}
		}
		let foreground = null;
		if (typeof entry.foreground === "string") foreground = entry.foreground;
		let background = null;
		if (typeof entry.background === "string") background = entry.background;
		result[resultLen++] = new ParsedTokenThemeRule(entry.token || "", i, fontStyle, foreground, background);
	}
	return result;
}
/**
* Resolve rules (i.e. inheritance).
*/
function resolveParsedTokenThemeRules(parsedThemeRules, customTokenColors) {
	parsedThemeRules.sort((a, b) => {
		const r = strcmp(a.token, b.token);
		if (r !== 0) return r;
		return a.index - b.index;
	});
	let defaultFontStyle = 0;
	let defaultForeground = "000000";
	let defaultBackground = "ffffff";
	while (parsedThemeRules.length >= 1 && parsedThemeRules[0].token === "") {
		const incomingDefaults = parsedThemeRules.shift();
		if (incomingDefaults.fontStyle !== -1) defaultFontStyle = incomingDefaults.fontStyle;
		if (incomingDefaults.foreground !== null) defaultForeground = incomingDefaults.foreground;
		if (incomingDefaults.background !== null) defaultBackground = incomingDefaults.background;
	}
	const colorMap = new ColorMap();
	for (const color of customTokenColors) colorMap.getId(color);
	const foregroundColorId = colorMap.getId(defaultForeground);
	const backgroundColorId = colorMap.getId(defaultBackground);
	const root = new ThemeTrieElement(new ThemeTrieElementRule(defaultFontStyle, foregroundColorId, backgroundColorId));
	for (let i = 0, len = parsedThemeRules.length; i < len; i++) {
		const rule = parsedThemeRules[i];
		root.insert(rule.token, rule.fontStyle, colorMap.getId(rule.foreground), colorMap.getId(rule.background));
	}
	return new TokenTheme(colorMap, root);
}
var colorRegExp = /^#?([0-9A-Fa-f]{6})([0-9A-Fa-f]{2})?$/;
var ColorMap = class {
	constructor() {
		this._lastColorId = 0;
		this._id2color = [];
		this._color2id = /* @__PURE__ */ new Map();
	}
	getId(color) {
		if (color === null) return 0;
		const match = color.match(colorRegExp);
		if (!match) throw new Error("Illegal value for token color: " + color);
		color = match[1].toUpperCase();
		let value = this._color2id.get(color);
		if (value) return value;
		value = ++this._lastColorId;
		this._color2id.set(color, value);
		this._id2color[value] = Color.fromHex("#" + color);
		return value;
	}
	getColorMap() {
		return this._id2color.slice(0);
	}
};
var TokenTheme = class {
	static createFromRawTokenTheme(source, customTokenColors) {
		return this.createFromParsedTokenTheme(parseTokenTheme(source), customTokenColors);
	}
	static createFromParsedTokenTheme(source, customTokenColors) {
		return resolveParsedTokenThemeRules(source, customTokenColors);
	}
	constructor(colorMap, root) {
		this._colorMap = colorMap;
		this._root = root;
		this._cache = /* @__PURE__ */ new Map();
	}
	getColorMap() {
		return this._colorMap.getColorMap();
	}
	_match(token) {
		return this._root.match(token);
	}
	match(languageId, token) {
		let result = this._cache.get(token);
		if (typeof result === "undefined") {
			const rule = this._match(token);
			const standardToken = toStandardTokenType(token);
			result = (rule.metadata | standardToken << 8) >>> 0;
			this._cache.set(token, result);
		}
		return (result | languageId << 0) >>> 0;
	}
};
var STANDARD_TOKEN_TYPE_REGEXP = /\b(comment|string|regex|regexp)\b/;
function toStandardTokenType(tokenType) {
	const m = tokenType.match(STANDARD_TOKEN_TYPE_REGEXP);
	if (!m) return 0;
	switch (m[1]) {
		case "comment": return 1;
		case "string": return 2;
		case "regex": return 3;
		case "regexp": return 3;
	}
	throw new Error("Unexpected match for standard token type!");
}
function strcmp(a, b) {
	if (a < b) return -1;
	if (a > b) return 1;
	return 0;
}
var ThemeTrieElementRule = class ThemeTrieElementRule {
	constructor(fontStyle, foreground, background) {
		this._themeTrieElementRuleBrand = void 0;
		this._fontStyle = fontStyle;
		this._foreground = foreground;
		this._background = background;
		this.metadata = (this._fontStyle << 11 | this._foreground << 15 | this._background << 24) >>> 0;
	}
	clone() {
		return new ThemeTrieElementRule(this._fontStyle, this._foreground, this._background);
	}
	acceptOverwrite(fontStyle, foreground, background) {
		if (fontStyle !== -1) this._fontStyle = fontStyle;
		if (foreground !== 0) this._foreground = foreground;
		if (background !== 0) this._background = background;
		this.metadata = (this._fontStyle << 11 | this._foreground << 15 | this._background << 24) >>> 0;
	}
};
var ThemeTrieElement = class ThemeTrieElement {
	constructor(mainRule) {
		this._themeTrieElementBrand = void 0;
		this._mainRule = mainRule;
		this._children = /* @__PURE__ */ new Map();
	}
	match(token) {
		if (token === "") return this._mainRule;
		const dotIndex = token.indexOf(".");
		let head;
		let tail;
		if (dotIndex === -1) {
			head = token;
			tail = "";
		} else {
			head = token.substring(0, dotIndex);
			tail = token.substring(dotIndex + 1);
		}
		const child = this._children.get(head);
		if (typeof child !== "undefined") return child.match(tail);
		return this._mainRule;
	}
	insert(token, fontStyle, foreground, background) {
		if (token === "") {
			this._mainRule.acceptOverwrite(fontStyle, foreground, background);
			return;
		}
		const dotIndex = token.indexOf(".");
		let head;
		let tail;
		if (dotIndex === -1) {
			head = token;
			tail = "";
		} else {
			head = token.substring(0, dotIndex);
			tail = token.substring(dotIndex + 1);
		}
		let child = this._children.get(head);
		if (typeof child === "undefined") {
			child = new ThemeTrieElement(this._mainRule.clone());
			this._children.set(head, child);
		}
		child.insert(tail, fontStyle, foreground, background);
	}
};
function generateTokensCSSForColorMap(colorMap) {
	const rules = [];
	for (let i = 1, len = colorMap.length; i < len; i++) {
		const color = colorMap[i];
		rules[i] = `.mtk${i} { color: ${color}; }`;
	}
	rules.push(".mtki { font-style: italic; }");
	rules.push(".mtkb { font-weight: bold; }");
	rules.push(".mtku { text-decoration: underline; text-underline-position: under; }");
	rules.push(".mtks { text-decoration: line-through; }");
	rules.push(".mtks.mtku { text-decoration: underline line-through; text-underline-position: under; }");
	return rules.join("\n");
}
function classNameForFontTokenDecorations(fontFamily, fontSize) {
	return cleanClassName$1(`font-decoration-${sanitizeFontFamilyForClassName(fontFamily)}-${fontSize}`);
}
function sanitizeFontFamilyForClassName(fontFamily) {
	const normalized = fontFamily.toLowerCase().trim();
	if (!normalized) return "default";
	return cleanClassName$1(normalized);
}
function cleanClassName$1(className) {
	return className.replace(/[^a-z0-9_-]/gi, "-");
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/tokens/annotations.js
var AnnotatedString = class {
	constructor(annotations = []) {
		/**
		* Annotations are non intersecting and contiguous in the array.
		*/
		this._annotations = [];
		this._annotations = annotations;
	}
	/**
	* Set annotations for a specific range.
	* Annotations should be sorted and non-overlapping.
	* If the annotation value is undefined, the annotation is removed.
	*/
	setAnnotations(annotations) {
		for (const annotation of annotations.annotations) {
			const startIndex = this._getStartIndexOfIntersectingAnnotation(annotation.range.start);
			const endIndexExclusive = this._getEndIndexOfIntersectingAnnotation(annotation.range.endExclusive);
			if (annotation.annotation !== void 0) this._annotations.splice(startIndex, endIndexExclusive - startIndex, {
				range: annotation.range,
				annotation: annotation.annotation
			});
			else this._annotations.splice(startIndex, endIndexExclusive - startIndex);
		}
	}
	/**
	* Returns all annotations that intersect with the given offset range.
	*/
	getAnnotationsIntersecting(range) {
		const startIndex = this._getStartIndexOfIntersectingAnnotation(range.start);
		const endIndexExclusive = this._getEndIndexOfIntersectingAnnotation(range.endExclusive);
		return this._annotations.slice(startIndex, endIndexExclusive);
	}
	_getStartIndexOfIntersectingAnnotation(offset) {
		const startIndexWhereToReplace = binarySearch2(this._annotations.length, (index) => {
			return this._annotations[index].range.start - offset;
		});
		let startIndex;
		if (startIndexWhereToReplace >= 0) {
			startIndex = startIndexWhereToReplace;
			const nextCandidate = this._annotations[startIndex]?.range;
			if (nextCandidate && nextCandidate.endExclusive === offset) startIndex--;
		} else {
			const candidate = this._annotations[-(startIndexWhereToReplace + 2)]?.range;
			if (candidate && offset >= candidate.start && offset < candidate.endExclusive) startIndex = -(startIndexWhereToReplace + 2);
			else startIndex = -(startIndexWhereToReplace + 1);
		}
		return startIndex;
	}
	_getEndIndexOfIntersectingAnnotation(offset) {
		const endIndexWhereToReplace = binarySearch2(this._annotations.length, (index) => {
			return this._annotations[index].range.endExclusive - offset;
		});
		let endIndexExclusive;
		if (endIndexWhereToReplace >= 0) {
			endIndexExclusive = endIndexWhereToReplace + 1;
			const nextCandidate = this._annotations[endIndexExclusive]?.range;
			if (nextCandidate && nextCandidate.start === offset) endIndexExclusive++;
		} else {
			const candidate = this._annotations[-(endIndexWhereToReplace + 1)]?.range;
			if (candidate && offset >= candidate.start && offset <= candidate.endExclusive) endIndexExclusive = -endIndexWhereToReplace;
			else endIndexExclusive = -(endIndexWhereToReplace + 1);
		}
		return endIndexExclusive;
	}
	/**
	* Applies a string edit to the annotated string, updating annotation ranges accordingly.
	* @param edit The string edit to apply.
	* @returns The annotations that were deleted (became empty) as a result of the edit.
	*/
	applyEdit(edit) {
		const annotations = this._annotations.slice();
		const finalAnnotations = [];
		const deletedAnnotations = [];
		let offset = 0;
		for (const e of edit.replacements) {
			while (true) {
				const annotation = annotations[0];
				if (!annotation) break;
				const range = annotation.range;
				if (range.endExclusive >= e.replaceRange.start) break;
				annotations.shift();
				const newAnnotation = {
					range: range.delta(offset),
					annotation: annotation.annotation
				};
				if (!newAnnotation.range.isEmpty) finalAnnotations.push(newAnnotation);
				else deletedAnnotations.push(newAnnotation);
			}
			const intersecting = [];
			while (true) {
				const annotation = annotations[0];
				if (!annotation) break;
				if (!annotation.range.intersectsOrTouches(e.replaceRange)) break;
				annotations.shift();
				intersecting.push(annotation);
			}
			for (let i = intersecting.length - 1; i >= 0; i--) {
				const annotation = intersecting[i];
				let r = annotation.range;
				const shouldExtend = i === 0 && e.replaceRange.endExclusive > r.start && e.replaceRange.start < r.endExclusive;
				const overlap = r.intersect(e.replaceRange).length;
				r = r.deltaEnd(-overlap + (shouldExtend ? e.newText.length : 0));
				const rangeAheadOfReplaceRange = r.start - e.replaceRange.start;
				if (rangeAheadOfReplaceRange > 0) r = r.delta(-rangeAheadOfReplaceRange);
				if (!shouldExtend && rangeAheadOfReplaceRange >= 0) r = r.delta(e.newText.length);
				r = r.delta(-(e.newText.length - e.replaceRange.length));
				annotations.unshift({
					annotation: annotation.annotation,
					range: r
				});
			}
			offset += e.newText.length - e.replaceRange.length;
		}
		while (true) {
			const annotation = annotations[0];
			if (!annotation) break;
			annotations.shift();
			const newAnnotation = {
				annotation: annotation.annotation,
				range: annotation.range.delta(offset)
			};
			if (!newAnnotation.range.isEmpty) finalAnnotations.push(newAnnotation);
			else deletedAnnotations.push(newAnnotation);
		}
		this._annotations = finalAnnotations;
		return deletedAnnotations;
	}
};
var AnnotationsUpdate = class AnnotationsUpdate {
	static create(annotations) {
		return new AnnotationsUpdate(annotations);
	}
	constructor(annotations) {
		this._annotations = annotations;
	}
	get annotations() {
		return this._annotations;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/textModelStringEdit.js
function offsetEditFromContentChanges(contentChanges) {
	const editsArr = contentChanges.map((c) => new StringReplacement(OffsetRange.ofStartAndLength(c.rangeOffset, c.rangeLength), c.text));
	editsArr.reverse();
	return new StringEdit(editsArr);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/tokens/tokenizationFontDecorationsProvider.js
var TokenizationFontDecorationProvider = class TokenizationFontDecorationProvider extends Disposable {
	static {
		this.DECORATION_COUNT = 0;
	}
	constructor(textModel, tokenizationTextModelPart) {
		super();
		this.textModel = textModel;
		this.tokenizationTextModelPart = tokenizationTextModelPart;
		this._onDidChangeLineHeight = this._register(new Emitter$1());
		this.onDidChangeLineHeight = this._onDidChangeLineHeight.event;
		this._onDidChangeFont = this._register(new Emitter$1());
		this.onDidChangeFont = this._onDidChangeFont.event;
		this._fontAnnotatedString = new AnnotatedString();
		this._register(this.tokenizationTextModelPart.onDidChangeFontTokens((fontChanges) => {
			const linesChanged = /* @__PURE__ */ new Set();
			const fontTokenAnnotations = [];
			const affectedLineHeights = /* @__PURE__ */ new Set();
			const affectedLineFonts = /* @__PURE__ */ new Set();
			for (const annotation of fontChanges.changes.annotations) {
				const lineNumber = this.textModel.getPositionAt(annotation.range.start).lineNumber;
				let fontTokenAnnotation;
				if (annotation.annotation === void 0) fontTokenAnnotation = {
					range: annotation.range,
					annotation: void 0
				};
				else {
					const decorationId = `tokenization-font-decoration-${TokenizationFontDecorationProvider.DECORATION_COUNT}`;
					const fontTokenDecoration = {
						fontToken: annotation.annotation,
						decorationId
					};
					fontTokenAnnotation = {
						range: annotation.range,
						annotation: fontTokenDecoration
					};
					TokenizationFontDecorationProvider.DECORATION_COUNT++;
					if (annotation.annotation.lineHeightMultiplier) affectedLineHeights.add(new LineHeightChangingDecoration(0, decorationId, lineNumber, annotation.annotation.lineHeightMultiplier));
					affectedLineFonts.add(new LineFontChangingDecoration(0, decorationId, lineNumber));
				}
				fontTokenAnnotations.push(fontTokenAnnotation);
				if (!linesChanged.has(lineNumber)) {
					const lineNumberStartOffset = this.textModel.getOffsetAt(new Position$1(lineNumber, 1));
					const lineNumberEndOffset = this.textModel.getOffsetAt(new Position$1(lineNumber, this.textModel.getLineMaxColumn(lineNumber)));
					const lineOffsetRange = new OffsetRange(lineNumberStartOffset, lineNumberEndOffset);
					const lineAnnotations = this._fontAnnotatedString.getAnnotationsIntersecting(lineOffsetRange);
					for (const annotation of lineAnnotations) {
						const decorationId = annotation.annotation.decorationId;
						affectedLineHeights.add(new LineHeightChangingDecoration(0, decorationId, lineNumber, null));
						affectedLineFonts.add(new LineFontChangingDecoration(0, decorationId, lineNumber));
					}
					linesChanged.add(lineNumber);
				}
			}
			this._fontAnnotatedString.setAnnotations(AnnotationsUpdate.create(fontTokenAnnotations));
			this._onDidChangeLineHeight.fire(affectedLineHeights);
			this._onDidChangeFont.fire(affectedLineFonts);
		}));
	}
	handleDidChangeContent(change) {
		const edits = offsetEditFromContentChanges(change.changes);
		const deletedAnnotations = this._fontAnnotatedString.applyEdit(edits);
		if (deletedAnnotations.length === 0) return;
		const affectedLineHeights = /* @__PURE__ */ new Set();
		const affectedLineFonts = /* @__PURE__ */ new Set();
		for (const deletedAnnotation of deletedAnnotations) {
			const lineNumber = this.textModel.getPositionAt(deletedAnnotation.range.start).lineNumber;
			const decorationId = deletedAnnotation.annotation.decorationId;
			affectedLineHeights.add(new LineHeightChangingDecoration(0, decorationId, lineNumber, null));
			affectedLineFonts.add(new LineFontChangingDecoration(0, decorationId, lineNumber));
		}
		this._onDidChangeLineHeight.fire(affectedLineHeights);
		this._onDidChangeFont.fire(affectedLineFonts);
	}
	getDecorationsInRange(range, ownerId, filterOutValidation, filterFontDecorations, onlyMinimapDecorations) {
		const startOffsetOfRange = this.textModel.getOffsetAt(range.getStartPosition());
		const endOffsetOfRange = this.textModel.getOffsetAt(range.getEndPosition());
		const annotations = this._fontAnnotatedString.getAnnotationsIntersecting(new OffsetRange(startOffsetOfRange, endOffsetOfRange));
		const decorations = [];
		for (const annotation of annotations) {
			const anno = annotation.annotation;
			const affectsFont = !!(anno.fontToken.fontFamily || anno.fontToken.fontSizeMultiplier);
			if (!(affectsFont && filterFontDecorations)) {
				const annotationStartPosition = this.textModel.getPositionAt(annotation.range.start);
				const annotationEndPosition = this.textModel.getPositionAt(annotation.range.endExclusive);
				const range = Range$2.fromPositions(annotationStartPosition, annotationEndPosition);
				const anno = annotation.annotation;
				const className = classNameForFontTokenDecorations(anno.fontToken.fontFamily ?? "", anno.fontToken.fontSizeMultiplier ?? 0);
				const id = anno.decorationId;
				decorations.push({
					id,
					options: {
						description: "FontOptionDecoration",
						inlineClassName: className,
						lineHeight: anno.fontToken.lineHeightMultiplier,
						affectsFont
					},
					ownerId: 0,
					range
				});
			}
		}
		return decorations;
	}
	getAllDecorations(ownerId, filterOutValidation) {
		return this.getDecorationsInRange(new Range$2(1, 1, this.textModel.getLineCount(), this.textModel.getLineMaxColumn(this.textModel.getLineCount())), ownerId, filterOutValidation);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/tokens/treeSitter/cursorUtils.js
function gotoNextSibling(newCursor, oldCursor) {
	const n = newCursor.gotoNextSibling();
	const o = oldCursor.gotoNextSibling();
	if (n !== o) throw new Error("Trees are out of sync");
	return n && o;
}
function gotoParent(newCursor, oldCursor) {
	const n = newCursor.gotoParent();
	const o = oldCursor.gotoParent();
	if (n !== o) throw new Error("Trees are out of sync");
	return n && o;
}
function gotoNthChild(newCursor, oldCursor, index) {
	const n = newCursor.gotoFirstChild();
	const o = oldCursor.gotoFirstChild();
	if (n !== o) throw new Error("Trees are out of sync");
	if (index === 0) return n && o;
	for (let i = 1; i <= index; i++) {
		const nn = newCursor.gotoNextSibling();
		const oo = oldCursor.gotoNextSibling();
		if (nn !== oo) throw new Error("Trees are out of sync");
		if (!nn || !oo) return false;
	}
	return n && o;
}
function nextSiblingOrParentSibling(newCursor, oldCursor) {
	do {
		if (newCursor.currentNode.nextSibling) return gotoNextSibling(newCursor, oldCursor);
		if (newCursor.currentNode.parent) gotoParent(newCursor, oldCursor);
	} while (newCursor.currentNode.nextSibling || newCursor.currentNode.parent);
	return false;
}
function getClosestPreviousNodes(cursor, tree) {
	const findPrev = tree.walk();
	findPrev.resetTo(cursor);
	const startingNode = cursor.currentNode;
	do
		if (findPrev.currentNode.previousSibling && findPrev.currentNode.endIndex - findPrev.currentNode.startIndex !== 0) findPrev.gotoPreviousSibling();
		else {
			while (!findPrev.currentNode.previousSibling && findPrev.currentNode.parent) findPrev.gotoParent();
			findPrev.gotoPreviousSibling();
		}
	while (findPrev.currentNode.endIndex > startingNode.startIndex && (findPrev.currentNode.parent || findPrev.currentNode.previousSibling) && findPrev.currentNode.id !== startingNode.id);
	if (findPrev.currentNode.id !== startingNode.id && findPrev.currentNode.endIndex <= startingNode.startIndex) return findPrev.currentNode;
	else return;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/tokens/treeSitter/treeSitterTree.js
var __decorate$59 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$54 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var TreeSitterTree = class TreeSitterTree extends Disposable {
	constructor(languageId, _ranges, _parser, _parserClass, textModel, _logService, _telemetryService) {
		super();
		this.languageId = languageId;
		this._ranges = _ranges;
		this._parser = _parser;
		this._parserClass = _parserClass;
		this.textModel = textModel;
		this._logService = _logService;
		this._telemetryService = _telemetryService;
		this._tree = observableValue(this, void 0);
		this.tree = this._tree;
		this._treeLastParsedVersion = observableValue(this, -1);
		this.treeLastParsedVersion = this._treeLastParsedVersion;
		this._onDidChangeContentQueue = new TaskQueue$1();
		this._tree = observableValue(this, void 0);
		this.tree = this._tree;
		this._register(toDisposable(() => {
			this._tree.get()?.delete();
			this._lastFullyParsed?.delete();
			this._lastFullyParsedWithEdits?.delete();
			this._parser.delete();
		}));
		this.handleContentChange(void 0, this._ranges);
	}
	handleContentChange(e, ranges) {
		const version = this.textModel.getVersionId();
		let newRanges = [];
		if (ranges) newRanges = this._setRanges(ranges);
		if (e) this._applyEdits(e.changes);
		this._onDidChangeContentQueue.clearPending();
		this._onDidChangeContentQueue.schedule(async () => {
			if (this._store.isDisposed) return;
			const oldTree = this._lastFullyParsed;
			let changedNodes;
			if (this._lastFullyParsedWithEdits && this._lastFullyParsed) changedNodes = this._findChangedNodes(this._lastFullyParsedWithEdits, this._lastFullyParsed);
			const completed = await this._parseAndUpdateTree(version);
			if (completed) {
				let ranges;
				if (!changedNodes) {
					if (this._ranges) ranges = this._ranges.map((r) => ({
						newRange: new Range$2(r.startPosition.row + 1, r.startPosition.column + 1, r.endPosition.row + 1, r.endPosition.column + 1),
						oldRangeLength: r.endIndex - r.startIndex,
						newRangeStartOffset: r.startIndex,
						newRangeEndOffset: r.endIndex
					}));
				} else if (oldTree && changedNodes) ranges = this._findTreeChanges(completed, changedNodes, newRanges);
				if (!ranges) ranges = [{
					newRange: this.textModel.getFullModelRange(),
					newRangeStartOffset: 0,
					newRangeEndOffset: this.textModel.getValueLength()
				}];
				const previousTree = this._tree.get();
				transaction((tx) => {
					this._tree.set(completed, tx, {
						ranges,
						versionId: version
					});
					this._treeLastParsedVersion.set(version, tx);
				});
				previousTree?.delete();
			}
		});
	}
	_applyEdits(changes) {
		for (const change of changes) {
			const originalTextLength = TextLength.ofRange(Range$2.lift(change.range));
			const newTextLength = TextLength.ofText(change.text);
			const summedTextLengths = change.text.length === 0 ? newTextLength : originalTextLength.add(newTextLength);
			const edit = {
				startIndex: change.rangeOffset,
				oldEndIndex: change.rangeOffset + change.rangeLength,
				newEndIndex: change.rangeOffset + change.text.length,
				startPosition: {
					row: change.range.startLineNumber - 1,
					column: change.range.startColumn - 1
				},
				oldEndPosition: {
					row: change.range.endLineNumber - 1,
					column: change.range.endColumn - 1
				},
				newEndPosition: {
					row: change.range.startLineNumber + summedTextLengths.lineCount - 1,
					column: summedTextLengths.lineCount ? summedTextLengths.columnCount : change.range.endColumn + summedTextLengths.columnCount
				}
			};
			this._tree.get()?.edit(edit);
			this._lastFullyParsedWithEdits?.edit(edit);
		}
	}
	_findChangedNodes(newTree, oldTree) {
		if (this._ranges && this._ranges.every((range) => range.startPosition.row !== newTree.rootNode.startPosition.row) || newTree.rootNode.startPosition.row !== 0) return [];
		const newCursor = newTree.walk();
		const oldCursor = oldTree.walk();
		const nodes = [];
		let next = true;
		do
			if (newCursor.currentNode.hasChanges) {
				const newChildren = newCursor.currentNode.children;
				const indexChangedChildren = [];
				const changedChildren = newChildren.filter((c, index) => {
					if (c?.hasChanges || oldCursor.currentNode.children.length <= index) {
						indexChangedChildren.push(index);
						return true;
					}
					return false;
				});
				if (changedChildren.length === 0 || newCursor.currentNode.hasError !== oldCursor.currentNode.hasError) {
					while (newCursor.currentNode.parent && next && !newCursor.currentNode.isNamed) next = gotoParent(newCursor, oldCursor);
					const newNode = newCursor.currentNode;
					const closestPreviousNode = getClosestPreviousNodes(newCursor, newTree) ?? newNode;
					nodes.push({
						startIndex: closestPreviousNode.startIndex,
						endIndex: newNode.endIndex,
						startPosition: closestPreviousNode.startPosition,
						endPosition: newNode.endPosition
					});
					next = nextSiblingOrParentSibling(newCursor, oldCursor);
				} else if (changedChildren.length >= 1) next = gotoNthChild(newCursor, oldCursor, indexChangedChildren[0]);
			} else next = nextSiblingOrParentSibling(newCursor, oldCursor);
		while (next);
		newCursor.delete();
		oldCursor.delete();
		return nodes;
	}
	_findTreeChanges(newTree, changedNodes, newRanges) {
		let newRangeIndex = 0;
		const mergedChanges = [];
		for (let nodeIndex = 0; nodeIndex < changedNodes.length; nodeIndex++) {
			const node = changedNodes[nodeIndex];
			if (mergedChanges.length > 0) {
				if (node.startIndex >= mergedChanges[mergedChanges.length - 1].newRangeStartOffset && node.endIndex <= mergedChanges[mergedChanges.length - 1].newRangeEndOffset) continue;
			}
			const cursor = newTree.walk();
			const cursorContainersNode = () => cursor.startIndex < node.startIndex && cursor.endIndex > node.endIndex;
			while (cursorContainersNode()) {
				let child = cursor.gotoFirstChild();
				let foundChild = false;
				while (child) if (cursorContainersNode() && cursor.currentNode.isNamed) {
					foundChild = true;
					break;
				} else child = cursor.gotoNextSibling();
				if (!foundChild) {
					cursor.gotoParent();
					break;
				}
				if (cursor.currentNode.childCount === 0) break;
			}
			const startPosition = cursor.currentNode.startPosition;
			const endPosition = cursor.currentNode.endPosition;
			const startIndex = cursor.currentNode.startIndex;
			const endIndex = cursor.currentNode.endIndex;
			const newChange = {
				newRange: new Range$2(startPosition.row + 1, startPosition.column + 1, endPosition.row + 1, endPosition.column + 1),
				newRangeStartOffset: startIndex,
				newRangeEndOffset: endIndex
			};
			if (newRangeIndex < newRanges.length && rangesIntersect(newRanges[newRangeIndex], {
				startIndex,
				endIndex
			})) {
				if (newRanges[newRangeIndex].startIndex < newChange.newRangeStartOffset) {
					newChange.newRange = newChange.newRange.setStartPosition(newRanges[newRangeIndex].startPosition.row + 1, newRanges[newRangeIndex].startPosition.column + 1);
					newChange.newRangeStartOffset = newRanges[newRangeIndex].startIndex;
				}
				if (newRanges[newRangeIndex].endIndex > newChange.newRangeEndOffset) {
					newChange.newRange = newChange.newRange.setEndPosition(newRanges[newRangeIndex].endPosition.row + 1, newRanges[newRangeIndex].endPosition.column + 1);
					newChange.newRangeEndOffset = newRanges[newRangeIndex].endIndex;
				}
				newRangeIndex++;
			} else if (newRangeIndex < newRanges.length && newRanges[newRangeIndex].endIndex < newChange.newRangeStartOffset) mergedChanges.push({
				newRange: new Range$2(newRanges[newRangeIndex].startPosition.row + 1, newRanges[newRangeIndex].startPosition.column + 1, newRanges[newRangeIndex].endPosition.row + 1, newRanges[newRangeIndex].endPosition.column + 1),
				newRangeStartOffset: newRanges[newRangeIndex].startIndex,
				newRangeEndOffset: newRanges[newRangeIndex].endIndex
			});
			if (mergedChanges.length > 0 && mergedChanges[mergedChanges.length - 1].newRangeEndOffset >= newChange.newRangeStartOffset) {
				mergedChanges[mergedChanges.length - 1].newRange = Range$2.fromPositions(mergedChanges[mergedChanges.length - 1].newRange.getStartPosition(), newChange.newRange.getEndPosition());
				mergedChanges[mergedChanges.length - 1].newRangeEndOffset = newChange.newRangeEndOffset;
			} else mergedChanges.push(newChange);
		}
		return this._constrainRanges(mergedChanges);
	}
	_constrainRanges(changes) {
		if (!this._ranges) return changes;
		const constrainedChanges = [];
		let changesIndex = 0;
		let rangesIndex = 0;
		while (changesIndex < changes.length && rangesIndex < this._ranges.length) {
			const change = changes[changesIndex];
			const range = this._ranges[rangesIndex];
			if (change.newRangeEndOffset < range.startIndex) changesIndex++;
			else if (change.newRangeStartOffset > range.endIndex) rangesIndex++;
			else {
				const newRangeStartOffset = Math.max(change.newRangeStartOffset, range.startIndex);
				const newRangeEndOffset = Math.min(change.newRangeEndOffset, range.endIndex);
				const newRange = change.newRange.intersectRanges(new Range$2(range.startPosition.row + 1, range.startPosition.column + 1, range.endPosition.row + 1, range.endPosition.column + 1));
				constrainedChanges.push({
					newRange,
					newRangeEndOffset,
					newRangeStartOffset
				});
				if (newRangeEndOffset < change.newRangeEndOffset) {
					change.newRange = Range$2.fromPositions(newRange.getEndPosition(), change.newRange.getEndPosition());
					change.newRangeStartOffset = newRangeEndOffset + 1;
				} else changesIndex++;
			}
		}
		return constrainedChanges;
	}
	async _parseAndUpdateTree(version) {
		const tree = await this._parse();
		if (tree) {
			this._lastFullyParsed?.delete();
			this._lastFullyParsed = tree.copy();
			this._lastFullyParsedWithEdits?.delete();
			this._lastFullyParsedWithEdits = tree.copy();
			return tree;
		} else if (!this._tree.get()) this._parser.reset();
	}
	_parse() {
		let parseType = "fullParse";
		if (this._tree.get()) parseType = "incrementalParse";
		return this._parseAndYield(parseType);
	}
	async _parseAndYield(parseType) {
		let time = 0;
		let passes = 0;
		const inProgressVersion = this.textModel.getVersionId();
		let newTree;
		const progressCallback = newTimeOutProgressCallback();
		do {
			const timer = performance.now();
			newTree = this._parser.parse((index, position) => this._parseCallback(index), this._tree.get(), {
				progressCallback,
				includedRanges: this._ranges
			});
			time += performance.now() - timer;
			passes++;
			await new Promise((resolve) => setTimeout0(resolve));
		} while (!this._store.isDisposed && !newTree && inProgressVersion === this.textModel.getVersionId());
		this._sendParseTimeTelemetry(parseType, time, passes);
		return newTree && inProgressVersion === this.textModel.getVersionId() ? newTree : void 0;
	}
	_parseCallback(index) {
		try {
			return this.textModel.getTextBuffer().getNearestChunk(index);
		} catch (e) {
			this._logService.debug("Error getting chunk for tree-sitter parsing", e);
		}
	}
	_setRanges(newRanges) {
		const unKnownRanges = [];
		if (this._ranges) for (const newRange of newRanges) {
			let isFullyIncluded = false;
			for (let i = 0; i < this._ranges.length; i++) {
				const existingRange = this._ranges[i];
				if (rangesEqual(existingRange, newRange) || rangesIntersect(existingRange, newRange)) {
					isFullyIncluded = true;
					break;
				}
			}
			if (!isFullyIncluded) unKnownRanges.push(newRange);
		}
		else unKnownRanges.push(...newRanges);
		this._ranges = newRanges;
		return unKnownRanges;
	}
	_sendParseTimeTelemetry(parseType, time, passes) {
		this._logService.debug(`Tree parsing (${parseType}) took ${time} ms and ${passes} passes.`);
		if (parseType === "fullParse") this._telemetryService.publicLog2(`treeSitter.fullParse`, {
			languageId: this.languageId,
			time,
			passes
		});
		else this._telemetryService.publicLog2(`treeSitter.incrementalParse`, {
			languageId: this.languageId,
			time,
			passes
		});
	}
	createParsedTreeSync(src) {
		const parser = new this._parserClass();
		parser.setLanguage(this._parser.language);
		const tree = parser.parse(src);
		parser.delete();
		return tree ?? void 0;
	}
};
TreeSitterTree = __decorate$59([__param$54(5, ILogService), __param$54(6, ITelemetryService)], TreeSitterTree);
function newTimeOutProgressCallback() {
	let lastYieldTime = performance.now();
	return function parseProgressCallback(_state) {
		const now = performance.now();
		if (now - lastYieldTime > 50) {
			lastYieldTime = now;
			return true;
		}
		return false;
	};
}
function rangesEqual(a, b) {
	return a.startPosition.row === b.startPosition.row && a.startPosition.column === b.startPosition.column && a.endPosition.row === b.endPosition.row && a.endPosition.column === b.endPosition.column && a.startIndex === b.startIndex && a.endIndex === b.endIndex;
}
function rangesIntersect(a, b) {
	return a.startIndex <= b.startIndex && a.endIndex >= b.startIndex || b.startIndex <= a.startIndex && b.endIndex >= a.startIndex;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/fixedArray.js
/**
* An array that avoids being sparse by always
* filling up unused indices with a default value.
*/
var FixedArray = class {
	constructor(_default) {
		this._default = _default;
		this._store = [];
	}
	get(index) {
		if (index < this._store.length) return this._store[index];
		return this._default;
	}
	set(index, value) {
		while (index >= this._store.length) this._store[this._store.length] = this._default;
		this._store[index] = value;
	}
	replace(index, oldLength, newLength) {
		if (index >= this._store.length) return;
		if (oldLength === 0) {
			this.insert(index, newLength);
			return;
		} else if (newLength === 0) {
			this.delete(index, oldLength);
			return;
		}
		const before = this._store.slice(0, index);
		const after = this._store.slice(index + oldLength);
		const insertArr = arrayFill(newLength, this._default);
		this._store = before.concat(insertArr, after);
	}
	delete(deleteIndex, deleteCount) {
		if (deleteCount === 0 || deleteIndex >= this._store.length) return;
		this._store.splice(deleteIndex, deleteCount);
	}
	insert(insertIndex, insertCount) {
		if (insertCount === 0 || insertIndex >= this._store.length) return;
		const arr = [];
		for (let i = 0; i < insertCount; i++) arr[i] = this._default;
		this._store = arrayInsert(this._store, insertIndex, arr);
	}
};
function arrayFill(length, value) {
	const arr = [];
	for (let i = 0; i < length; i++) arr[i] = value;
	return arr;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/tokens/contiguousMultilineTokens.js
/**
* Represents contiguous tokens over a contiguous range of lines.
*/
var ContiguousMultilineTokens = class {
	/**
	* (Inclusive) start line number for these tokens.
	*/
	get startLineNumber() {
		return this._startLineNumber;
	}
	/**
	* (Inclusive) end line number for these tokens.
	*/
	get endLineNumber() {
		return this._startLineNumber + this._tokens.length - 1;
	}
	constructor(startLineNumber, tokens) {
		this._startLineNumber = startLineNumber;
		this._tokens = tokens;
	}
	/**
	* @see {@link _tokens}
	*/
	getLineTokens(lineNumber) {
		return this._tokens[lineNumber - this._startLineNumber];
	}
	appendLineTokens(lineTokens) {
		this._tokens.push(lineTokens);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/tokens/contiguousMultilineTokensBuilder.js
var ContiguousMultilineTokensBuilder = class {
	constructor() {
		this._tokens = [];
	}
	add(lineNumber, lineTokens) {
		if (this._tokens.length > 0) {
			const last = this._tokens[this._tokens.length - 1];
			if (last.endLineNumber + 1 === lineNumber) {
				last.appendLineTokens(lineTokens);
				return;
			}
		}
		this._tokens.push(new ContiguousMultilineTokens(lineNumber, [lineTokens]));
	}
	finalize() {
		return this._tokens;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/textModelTokens.js
var TokenizerWithStateStore = class {
	constructor(lineCount, tokenizationSupport) {
		this.tokenizationSupport = tokenizationSupport;
		this.initialState = this.tokenizationSupport.getInitialState();
		this.store = new TrackingTokenizationStateStore(lineCount);
	}
	getStartState(lineNumber) {
		return this.store.getStartState(lineNumber, this.initialState);
	}
	getFirstInvalidLine() {
		return this.store.getFirstInvalidLine(this.initialState);
	}
};
var TokenizerWithStateStoreAndTextModel = class extends TokenizerWithStateStore {
	constructor(lineCount, tokenizationSupport, _textModel, _languageIdCodec) {
		super(lineCount, tokenizationSupport);
		this._textModel = _textModel;
		this._languageIdCodec = _languageIdCodec;
	}
	updateTokensUntilLine(builder, lineNumber) {
		const languageId = this._textModel.getLanguageId();
		while (true) {
			const lineToTokenize = this.getFirstInvalidLine();
			if (!lineToTokenize || lineToTokenize.lineNumber > lineNumber) break;
			const text = this._textModel.getLineContent(lineToTokenize.lineNumber);
			const r = safeTokenize(this._languageIdCodec, languageId, this.tokenizationSupport, text, true, lineToTokenize.startState);
			builder.add(lineToTokenize.lineNumber, r.tokens);
			this.store.setEndState(lineToTokenize.lineNumber, r.endState);
		}
	}
	/** assumes state is up to date */
	getTokenTypeIfInsertingCharacter(position, character) {
		const lineStartState = this.getStartState(position.lineNumber);
		if (!lineStartState) return 0;
		const languageId = this._textModel.getLanguageId();
		const lineContent = this._textModel.getLineContent(position.lineNumber);
		const text = lineContent.substring(0, position.column - 1) + character + lineContent.substring(position.column - 1);
		const lineTokens = new LineTokens(safeTokenize(this._languageIdCodec, languageId, this.tokenizationSupport, text, true, lineStartState).tokens, text, this._languageIdCodec);
		if (lineTokens.getCount() === 0) return 0;
		const tokenIndex = lineTokens.findTokenIndexAtOffset(position.column - 1);
		return lineTokens.getStandardTokenType(tokenIndex);
	}
	/** assumes state is up to date */
	tokenizeLinesAt(lineNumber, lines) {
		const lineStartState = this.getStartState(lineNumber);
		if (!lineStartState) return null;
		const languageId = this._textModel.getLanguageId();
		const result = [];
		let state = lineStartState;
		for (const line of lines) {
			const r = safeTokenize(this._languageIdCodec, languageId, this.tokenizationSupport, line, true, state);
			result.push(new LineTokens(r.tokens, line, this._languageIdCodec));
			state = r.endState;
		}
		return result;
	}
	hasAccurateTokensForLine(lineNumber) {
		return lineNumber < this.store.getFirstInvalidEndStateLineNumberOrMax();
	}
	isCheapToTokenize(lineNumber) {
		const firstInvalidLineNumber = this.store.getFirstInvalidEndStateLineNumberOrMax();
		if (lineNumber < firstInvalidLineNumber) return true;
		if (lineNumber === firstInvalidLineNumber && this._textModel.getLineLength(lineNumber) < 2048) return true;
		return false;
	}
	/**
	* The result is not cached.
	*/
	tokenizeHeuristically(builder, startLineNumber, endLineNumber) {
		if (endLineNumber <= this.store.getFirstInvalidEndStateLineNumberOrMax()) return { heuristicTokens: false };
		if (startLineNumber <= this.store.getFirstInvalidEndStateLineNumberOrMax()) {
			this.updateTokensUntilLine(builder, endLineNumber);
			return { heuristicTokens: false };
		}
		let state = this.guessStartState(startLineNumber);
		const languageId = this._textModel.getLanguageId();
		for (let lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++) {
			const text = this._textModel.getLineContent(lineNumber);
			const r = safeTokenize(this._languageIdCodec, languageId, this.tokenizationSupport, text, true, state);
			builder.add(lineNumber, r.tokens);
			state = r.endState;
		}
		return { heuristicTokens: true };
	}
	guessStartState(lineNumber) {
		let { likelyRelevantLines, initialState } = findLikelyRelevantLines(this._textModel, lineNumber, this);
		if (!initialState) initialState = this.tokenizationSupport.getInitialState();
		const languageId = this._textModel.getLanguageId();
		let state = initialState;
		for (const line of likelyRelevantLines) state = safeTokenize(this._languageIdCodec, languageId, this.tokenizationSupport, line, false, state).endState;
		return state;
	}
};
function findLikelyRelevantLines(model, lineNumber, store) {
	let nonWhitespaceColumn = model.getLineFirstNonWhitespaceColumn(lineNumber);
	const likelyRelevantLines = [];
	let initialState = null;
	for (let i = lineNumber - 1; nonWhitespaceColumn > 1 && i >= 1; i--) {
		const newNonWhitespaceIndex = model.getLineFirstNonWhitespaceColumn(i);
		if (newNonWhitespaceIndex === 0) continue;
		if (newNonWhitespaceIndex < nonWhitespaceColumn) {
			likelyRelevantLines.push(model.getLineContent(i));
			nonWhitespaceColumn = newNonWhitespaceIndex;
			initialState = store?.getStartState(i);
			if (initialState) break;
		}
	}
	likelyRelevantLines.reverse();
	return {
		likelyRelevantLines,
		initialState: initialState ?? void 0
	};
}
/**
* **Invariant:**
* If the text model is retokenized from line 1 to {@link getFirstInvalidEndStateLineNumber}() - 1,
* then the recomputed end state for line l will be equal to {@link getEndState}(l).
*/
var TrackingTokenizationStateStore = class {
	constructor(lineCount) {
		this.lineCount = lineCount;
		this._tokenizationStateStore = new TokenizationStateStore();
		this._invalidEndStatesLineNumbers = new RangePriorityQueueImpl();
		this._invalidEndStatesLineNumbers.addRange(new OffsetRange(1, lineCount + 1));
	}
	getEndState(lineNumber) {
		return this._tokenizationStateStore.getEndState(lineNumber);
	}
	/**
	* @returns if the end state has changed.
	*/
	setEndState(lineNumber, state) {
		if (!state) throw new BugIndicatingError("Cannot set null/undefined state");
		this._invalidEndStatesLineNumbers.delete(lineNumber);
		const r = this._tokenizationStateStore.setEndState(lineNumber, state);
		if (r && lineNumber < this.lineCount) this._invalidEndStatesLineNumbers.addRange(new OffsetRange(lineNumber + 1, lineNumber + 2));
		return r;
	}
	acceptChange(range, newLineCount) {
		this.lineCount += newLineCount - range.length;
		this._tokenizationStateStore.acceptChange(range, newLineCount);
		this._invalidEndStatesLineNumbers.addRangeAndResize(new OffsetRange(range.startLineNumber, range.endLineNumberExclusive), newLineCount);
	}
	acceptChanges(changes) {
		for (const c of changes) {
			const [eolCount] = countEOL(c.text);
			this.acceptChange(new LineRange(c.range.startLineNumber, c.range.endLineNumber + 1), eolCount + 1);
		}
	}
	invalidateEndStateRange(range) {
		this._invalidEndStatesLineNumbers.addRange(new OffsetRange(range.startLineNumber, range.endLineNumberExclusive));
	}
	getFirstInvalidEndStateLineNumber() {
		return this._invalidEndStatesLineNumbers.min;
	}
	getFirstInvalidEndStateLineNumberOrMax() {
		return this.getFirstInvalidEndStateLineNumber() || Number.MAX_SAFE_INTEGER;
	}
	allStatesValid() {
		return this._invalidEndStatesLineNumbers.min === null;
	}
	getStartState(lineNumber, initialState) {
		if (lineNumber === 1) return initialState;
		return this.getEndState(lineNumber - 1);
	}
	getFirstInvalidLine(initialState) {
		const lineNumber = this.getFirstInvalidEndStateLineNumber();
		if (lineNumber === null) return null;
		const startState = this.getStartState(lineNumber, initialState);
		if (!startState) throw new BugIndicatingError("Start state must be defined");
		return {
			lineNumber,
			startState
		};
	}
};
var TokenizationStateStore = class {
	constructor() {
		this._lineEndStates = new FixedArray(null);
	}
	getEndState(lineNumber) {
		return this._lineEndStates.get(lineNumber);
	}
	setEndState(lineNumber, state) {
		const oldState = this._lineEndStates.get(lineNumber);
		if (oldState && oldState.equals(state)) return false;
		this._lineEndStates.set(lineNumber, state);
		return true;
	}
	acceptChange(range, newLineCount) {
		let length = range.length;
		if (newLineCount > 0 && length > 0) {
			length--;
			newLineCount--;
		}
		this._lineEndStates.replace(range.startLineNumber, length, newLineCount);
	}
};
var RangePriorityQueueImpl = class {
	constructor() {
		this._ranges = [];
	}
	get min() {
		if (this._ranges.length === 0) return null;
		return this._ranges[0].start;
	}
	delete(value) {
		const idx = this._ranges.findIndex((r) => r.contains(value));
		if (idx !== -1) {
			const range = this._ranges[idx];
			if (range.start === value) {
				if (range.endExclusive === value + 1) this._ranges.splice(idx, 1);
				else this._ranges[idx] = new OffsetRange(value + 1, range.endExclusive);
			} else if (range.endExclusive === value + 1) this._ranges[idx] = new OffsetRange(range.start, value);
			else this._ranges.splice(idx, 1, new OffsetRange(range.start, value), new OffsetRange(value + 1, range.endExclusive));
		}
	}
	addRange(range) {
		OffsetRange.addRange(range, this._ranges);
	}
	addRangeAndResize(range, newLength) {
		let idxFirstMightBeIntersecting = 0;
		while (!(idxFirstMightBeIntersecting >= this._ranges.length || range.start <= this._ranges[idxFirstMightBeIntersecting].endExclusive)) idxFirstMightBeIntersecting++;
		let idxFirstIsAfter = idxFirstMightBeIntersecting;
		while (!(idxFirstIsAfter >= this._ranges.length || range.endExclusive < this._ranges[idxFirstIsAfter].start)) idxFirstIsAfter++;
		const delta = newLength - range.length;
		for (let i = idxFirstIsAfter; i < this._ranges.length; i++) this._ranges[i] = this._ranges[i].delta(delta);
		if (idxFirstMightBeIntersecting === idxFirstIsAfter) {
			const newRange = new OffsetRange(range.start, range.start + newLength);
			if (!newRange.isEmpty) this._ranges.splice(idxFirstMightBeIntersecting, 0, newRange);
		} else {
			const start = Math.min(range.start, this._ranges[idxFirstMightBeIntersecting].start);
			const endEx = Math.max(range.endExclusive, this._ranges[idxFirstIsAfter - 1].endExclusive);
			const newRange = new OffsetRange(start, endEx + delta);
			if (!newRange.isEmpty) this._ranges.splice(idxFirstMightBeIntersecting, idxFirstIsAfter - idxFirstMightBeIntersecting, newRange);
			else this._ranges.splice(idxFirstMightBeIntersecting, idxFirstIsAfter - idxFirstMightBeIntersecting);
		}
	}
	toString() {
		return this._ranges.map((r) => r.toString()).join(" + ");
	}
};
function safeTokenize(languageIdCodec, languageId, tokenizationSupport, text, hasEOL, state) {
	let r = null;
	if (tokenizationSupport) try {
		r = tokenizationSupport.tokenizeEncoded(text, hasEOL, state.clone());
	} catch (e) {
		onUnexpectedError(e);
	}
	if (!r) r = nullTokenizeEncoded(languageIdCodec.encodeLanguageId(languageId), state);
	LineTokens.convertToEndOffset(r.tokens, text.length);
	return r;
}
var DefaultBackgroundTokenizer = class {
	constructor(_tokenizerWithStateStore, _backgroundTokenStore) {
		this._tokenizerWithStateStore = _tokenizerWithStateStore;
		this._backgroundTokenStore = _backgroundTokenStore;
		this._isDisposed = false;
		this._isScheduled = false;
	}
	dispose() {
		this._isDisposed = true;
	}
	handleChanges() {
		this._beginBackgroundTokenization();
	}
	_beginBackgroundTokenization() {
		if (this._isScheduled || !this._tokenizerWithStateStore._textModel.isAttachedToEditor() || !this._hasLinesToTokenize()) return;
		this._isScheduled = true;
		runWhenGlobalIdle((deadline) => {
			this._isScheduled = false;
			this._backgroundTokenizeWithDeadline(deadline);
		});
	}
	/**
	* Tokenize until the deadline occurs, but try to yield every 1-2ms.
	*/
	_backgroundTokenizeWithDeadline(deadline) {
		const endTime = Date.now() + deadline.timeRemaining();
		const execute = () => {
			if (this._isDisposed || !this._tokenizerWithStateStore._textModel.isAttachedToEditor() || !this._hasLinesToTokenize()) return;
			this._backgroundTokenizeForAtLeast1ms();
			if (Date.now() < endTime) setTimeout0(execute);
			else this._beginBackgroundTokenization();
		};
		execute();
	}
	/**
	* Tokenize for at least 1ms.
	*/
	_backgroundTokenizeForAtLeast1ms() {
		const lineCount = this._tokenizerWithStateStore._textModel.getLineCount();
		const builder = new ContiguousMultilineTokensBuilder();
		const sw = StopWatch.create(false);
		do {
			if (sw.elapsed() > 1) break;
			if (this._tokenizeOneInvalidLine(builder) >= lineCount) break;
		} while (this._hasLinesToTokenize());
		this._backgroundTokenStore.setTokens(builder.finalize());
		this.checkFinished();
	}
	_hasLinesToTokenize() {
		if (!this._tokenizerWithStateStore) return false;
		return !this._tokenizerWithStateStore.store.allStatesValid();
	}
	_tokenizeOneInvalidLine(builder) {
		const firstInvalidLine = this._tokenizerWithStateStore?.getFirstInvalidLine();
		if (!firstInvalidLine) return this._tokenizerWithStateStore._textModel.getLineCount() + 1;
		this._tokenizerWithStateStore.updateTokensUntilLine(builder, firstInvalidLine.lineNumber);
		return firstInvalidLine.lineNumber;
	}
	checkFinished() {
		if (this._isDisposed) return;
		if (this._tokenizerWithStateStore.store.allStatesValid()) this._backgroundTokenStore.backgroundTokenizationFinished();
	}
	requestTokens(startLineNumber, endLineNumberExclusive) {
		this._tokenizerWithStateStore.store.invalidateEndStateRange(new LineRange(startLineNumber, endLineNumberExclusive));
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/tokens/treeSitter/tokenStore.js
var ListNode = class ListNode {
	get children() {
		return this._children;
	}
	get length() {
		return this._length;
	}
	constructor(height) {
		this.height = height;
		this._children = [];
		this._length = 0;
	}
	static create(node1, node2) {
		const list = new ListNode(node1.height + 1);
		list.appendChild(node1);
		list.appendChild(node2);
		return list;
	}
	canAppendChild() {
		return this._children.length < 3;
	}
	appendChild(node) {
		if (!this.canAppendChild()) throw new Error("Cannot insert more than 3 children in a ListNode");
		this._children.push(node);
		this._length += node.length;
		this._updateParentLength(node.length);
		if (!isLeaf(node)) node.parent = this;
	}
	_updateParentLength(delta) {
		let updateParent = this.parent;
		while (updateParent) {
			updateParent._length += delta;
			updateParent = updateParent.parent;
		}
	}
	unappendChild() {
		const child = this._children.pop();
		this._length -= child.length;
		this._updateParentLength(-child.length);
		return child;
	}
	prependChild(node) {
		if (this._children.length >= 3) throw new Error("Cannot prepend more than 3 children in a ListNode");
		this._children.unshift(node);
		this._length += node.length;
		this._updateParentLength(node.length);
		if (!isLeaf(node)) node.parent = this;
	}
	unprependChild() {
		const child = this._children.shift();
		this._length -= child.length;
		this._updateParentLength(-child.length);
		return child;
	}
	lastChild() {
		return this._children[this._children.length - 1];
	}
	dispose() {
		this._children.splice(0, this._children.length);
	}
};
var TokenQuality;
(function(TokenQuality) {
	TokenQuality[TokenQuality["None"] = 0] = "None";
	TokenQuality[TokenQuality["ViewportGuess"] = 1] = "ViewportGuess";
	TokenQuality[TokenQuality["EditGuess"] = 2] = "EditGuess";
	TokenQuality[TokenQuality["Accurate"] = 3] = "Accurate";
})(TokenQuality || (TokenQuality = {}));
function isLeaf(node) {
	return node.token !== void 0;
}
function append(node, nodeToAppend) {
	let curNode = node;
	const parents = [];
	let nodeToAppendOfCorrectHeight;
	while (true) {
		if (nodeToAppend.height === curNode.height) {
			nodeToAppendOfCorrectHeight = nodeToAppend;
			break;
		}
		if (isLeaf(curNode)) throw new Error("unexpected");
		parents.push(curNode);
		curNode = curNode.lastChild();
	}
	for (let i = parents.length - 1; i >= 0; i--) {
		const parent = parents[i];
		if (nodeToAppendOfCorrectHeight) {
			if (parent.children.length >= 3) nodeToAppendOfCorrectHeight = ListNode.create(parent.unappendChild(), nodeToAppendOfCorrectHeight);
			else {
				parent.appendChild(nodeToAppendOfCorrectHeight);
				nodeToAppendOfCorrectHeight = void 0;
			}
		}
	}
	if (nodeToAppendOfCorrectHeight) {
		const newList = new ListNode(nodeToAppendOfCorrectHeight.height + 1);
		newList.appendChild(node);
		newList.appendChild(nodeToAppendOfCorrectHeight);
		return newList;
	} else return node;
}
function prepend(list, nodeToAppend) {
	let curNode = list;
	const parents = [];
	while (nodeToAppend.height !== curNode.height) {
		if (isLeaf(curNode)) throw new Error("unexpected");
		parents.push(curNode);
		curNode = curNode.children[0];
	}
	let nodeToPrependOfCorrectHeight = nodeToAppend;
	for (let i = parents.length - 1; i >= 0; i--) {
		const parent = parents[i];
		if (nodeToPrependOfCorrectHeight) {
			if (parent.children.length >= 3) nodeToPrependOfCorrectHeight = ListNode.create(nodeToPrependOfCorrectHeight, parent.unprependChild());
			else {
				parent.prependChild(nodeToPrependOfCorrectHeight);
				nodeToPrependOfCorrectHeight = void 0;
			}
		}
	}
	if (nodeToPrependOfCorrectHeight) return ListNode.create(nodeToPrependOfCorrectHeight, list);
	else return list;
}
function concat$1(node1, node2) {
	if (node1.height === node2.height) return ListNode.create(node1, node2);
	else if (node1.height > node2.height) return append(node1, node2);
	else return prepend(node2, node1);
}
var TokenStore = class {
	constructor(_textModel) {
		this._textModel = _textModel;
		this._root = this.createEmptyRoot();
	}
	createEmptyRoot() {
		return {
			length: this._textModel.getValueLength(),
			token: 0,
			height: 0,
			tokenQuality: TokenQuality.None
		};
	}
	/**
	*
	* @param update all the tokens for the document in sequence
	*/
	buildStore(tokens, tokenQuality) {
		this._root = this.createFromUpdates(tokens, tokenQuality);
	}
	createFromUpdates(tokens, tokenQuality) {
		if (tokens.length === 0) return this.createEmptyRoot();
		let newRoot = {
			length: tokens[0].length,
			token: tokens[0].token,
			height: 0,
			tokenQuality
		};
		for (let j = 1; j < tokens.length; j++) newRoot = append(newRoot, {
			length: tokens[j].length,
			token: tokens[j].token,
			height: 0,
			tokenQuality
		});
		return newRoot;
	}
	/**
	*
	* @param tokens tokens are in sequence in the document.
	*/
	update(length, tokens, tokenQuality) {
		if (tokens.length === 0) return;
		this.replace(length, tokens[0].startOffsetInclusive, tokens, tokenQuality);
	}
	delete(length, startOffset) {
		this.replace(length, startOffset, [], TokenQuality.EditGuess);
	}
	/**
	*
	* @param tokens tokens are in sequence in the document.
	*/
	replace(length, updateOffsetStart, tokens, tokenQuality) {
		const firstUnchangedOffsetAfterUpdate = updateOffsetStart + length;
		const precedingNodes = [];
		const postcedingNodes = [];
		const stack = [{
			node: this._root,
			offset: 0
		}];
		while (stack.length > 0) {
			const node = stack.pop();
			const currentOffset = node.offset;
			if (currentOffset < updateOffsetStart && currentOffset + node.node.length <= updateOffsetStart) {
				if (!isLeaf(node.node)) node.node.parent = void 0;
				precedingNodes.push(node.node);
				continue;
			} else if (isLeaf(node.node) && currentOffset < updateOffsetStart) precedingNodes.push({
				length: updateOffsetStart - currentOffset,
				token: node.node.token,
				height: 0,
				tokenQuality: node.node.tokenQuality
			});
			if (updateOffsetStart <= currentOffset && currentOffset + node.node.length <= firstUnchangedOffsetAfterUpdate) continue;
			if (currentOffset >= firstUnchangedOffsetAfterUpdate) {
				if (!isLeaf(node.node)) node.node.parent = void 0;
				postcedingNodes.push(node.node);
				continue;
			} else if (isLeaf(node.node) && currentOffset + node.node.length > firstUnchangedOffsetAfterUpdate) {
				postcedingNodes.push({
					length: currentOffset + node.node.length - firstUnchangedOffsetAfterUpdate,
					token: node.node.token,
					height: 0,
					tokenQuality: node.node.tokenQuality
				});
				continue;
			}
			if (!isLeaf(node.node)) {
				let childOffset = currentOffset + node.node.length;
				for (let i = node.node.children.length - 1; i >= 0; i--) {
					childOffset -= node.node.children[i].length;
					stack.push({
						node: node.node.children[i],
						offset: childOffset
					});
				}
			}
		}
		let allNodes;
		if (tokens.length > 0) allNodes = precedingNodes.concat(this.createFromUpdates(tokens, tokenQuality), postcedingNodes);
		else allNodes = precedingNodes.concat(postcedingNodes);
		let newRoot = allNodes[0];
		for (let i = 1; i < allNodes.length; i++) newRoot = concat$1(newRoot, allNodes[i]);
		this._root = newRoot ?? this.createEmptyRoot();
	}
	/**
	*
	* @param startOffsetInclusive
	* @param endOffsetExclusive
	* @param visitor Return true from visitor to exit early
	* @returns
	*/
	traverseInOrderInRange(startOffsetInclusive, endOffsetExclusive, visitor) {
		const stack = [{
			node: this._root,
			offset: 0
		}];
		while (stack.length > 0) {
			const { node, offset } = stack.pop();
			if (offset + node.length <= startOffsetInclusive || offset >= endOffsetExclusive) continue;
			if (visitor(node, offset)) return;
			if (!isLeaf(node)) {
				let childOffset = offset + node.length;
				for (let i = node.children.length - 1; i >= 0; i--) {
					childOffset -= node.children[i].length;
					stack.push({
						node: node.children[i],
						offset: childOffset
					});
				}
			}
		}
	}
	getTokenAt(offset) {
		let result;
		this.traverseInOrderInRange(offset, this._root.length, (node, offset) => {
			if (isLeaf(node)) {
				result = {
					token: node.token,
					startOffsetInclusive: offset,
					length: node.length
				};
				return true;
			}
			return false;
		});
		return result;
	}
	getTokensInRange(startOffsetInclusive, endOffsetExclusive) {
		const result = [];
		this.traverseInOrderInRange(startOffsetInclusive, endOffsetExclusive, (node, offset) => {
			if (isLeaf(node)) {
				let clippedLength = node.length;
				let clippedOffset = offset;
				if (offset < startOffsetInclusive && offset + node.length > endOffsetExclusive) {
					clippedOffset = startOffsetInclusive;
					clippedLength = endOffsetExclusive - startOffsetInclusive;
				} else if (offset < startOffsetInclusive) {
					clippedLength -= startOffsetInclusive - offset;
					clippedOffset = startOffsetInclusive;
				} else if (offset + node.length > endOffsetExclusive) clippedLength -= offset + node.length - endOffsetExclusive;
				result.push({
					token: node.token,
					startOffsetInclusive: clippedOffset,
					length: clippedLength
				});
			}
			return false;
		});
		return result;
	}
	markForRefresh(startOffsetInclusive, endOffsetExclusive) {
		this.traverseInOrderInRange(startOffsetInclusive, endOffsetExclusive, (node) => {
			if (isLeaf(node)) node.tokenQuality = TokenQuality.None;
			return false;
		});
	}
	rangeHasTokens(startOffsetInclusive, endOffsetExclusive, minimumTokenQuality) {
		let hasAny = true;
		this.traverseInOrderInRange(startOffsetInclusive, endOffsetExclusive, (node) => {
			if (isLeaf(node) && node.tokenQuality < minimumTokenQuality) hasAny = false;
			return false;
		});
		return hasAny;
	}
	rangeNeedsRefresh(startOffsetInclusive, endOffsetExclusive) {
		let needsRefresh = false;
		this.traverseInOrderInRange(startOffsetInclusive, endOffsetExclusive, (node) => {
			if (isLeaf(node) && node.tokenQuality !== TokenQuality.Accurate) needsRefresh = true;
			return false;
		});
		return needsRefresh;
	}
	getNeedsRefresh() {
		const result = [];
		this.traverseInOrderInRange(0, this._textModel.getValueLength(), (node, offset) => {
			if (isLeaf(node) && node.tokenQuality !== TokenQuality.Accurate) {
				if (result.length > 0 && result[result.length - 1].endOffset === offset) result[result.length - 1].endOffset += node.length;
				else result.push({
					startOffset: offset,
					endOffset: offset + node.length
				});
			}
			return false;
		});
		return result;
	}
	dispose() {
		const stack = [[this._root, false]];
		while (stack.length > 0) {
			const [node, visited] = stack.pop();
			if (isLeaf(node));
			else if (!visited) {
				stack.push([node, true]);
				for (let i = node.children.length - 1; i >= 0; i--) stack.push([node.children[i], false]);
			} else {
				node.dispose();
				node.parent = void 0;
			}
		}
		this._root = void 0;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/services/treeSitter/treeSitterThemeService.js
var ITreeSitterThemeService = createDecorator("treeSitterThemeService");
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/observableInternal/changeTracker.js
/**
* Subscribes to and records changes and the last value of the given observables.
* Don't use the key "changes", as it is reserved for the changes array!
*/
function recordChanges(obs) {
	return {
		createChangeSummary: (_previousChangeSummary) => {
			return { changes: [] };
		},
		handleChange(ctx, changeSummary) {
			for (const key in obs) if (ctx.didChange(obs[key])) changeSummary.changes.push({
				key,
				change: ctx.change
			});
			return true;
		},
		beforeUpdate(reader, changeSummary) {
			for (const key in obs) {
				if (key === "changes") throw new BugIndicatingError("property name \"changes\" is reserved for change tracking");
				changeSummary[key] = obs[key].read(reader);
			}
		}
	};
}
/**
* Subscribes to and records changes and the last value of the given observables.
* Don't use the key "changes", as it is reserved for the changes array!
*/
function recordChangesLazy(getObs) {
	let obs = void 0;
	return {
		createChangeSummary: (_previousChangeSummary) => {
			return { changes: [] };
		},
		handleChange(ctx, changeSummary) {
			if (!obs) obs = getObs();
			for (const key in obs) if (ctx.didChange(obs[key])) changeSummary.changes.push({
				key,
				change: ctx.change
			});
			return true;
		},
		beforeUpdate(reader, changeSummary) {
			if (!obs) obs = getObs();
			for (const key in obs) {
				if (key === "changes") throw new BugIndicatingError("property name \"changes\" is reserved for change tracking");
				changeSummary[key] = obs[key].read(reader);
			}
		}
	};
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/tokens/treeSitter/treeSitterTokenizationImpl.js
var __decorate$58 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$53 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var TreeSitterTokenizationImpl = class TreeSitterTokenizationImpl extends Disposable {
	get _textModel() {
		return this._tree.textModel;
	}
	constructor(_tree, _highlightingQueries, _languageIdCodec, _visibleLineRanges, _treeSitterThemeService) {
		super();
		this._tree = _tree;
		this._highlightingQueries = _highlightingQueries;
		this._languageIdCodec = _languageIdCodec;
		this._visibleLineRanges = _visibleLineRanges;
		this._treeSitterThemeService = _treeSitterThemeService;
		this._onDidChangeTokens = this._register(new Emitter$1());
		this.onDidChangeTokens = this._onDidChangeTokens.event;
		this._onDidCompleteBackgroundTokenization = this._register(new Emitter$1());
		this.onDidChangeBackgroundTokenization = this._onDidCompleteBackgroundTokenization.event;
		this._encodedLanguageId = this._languageIdCodec.encodeLanguageId(this._tree.languageId);
		this._register(runOnChange(this._treeSitterThemeService.onChange, () => {
			this._updateTheme();
		}));
		this._tokenStore = this._register(new TokenStore(this._textModel));
		this._accurateVersion = this._textModel.getVersionId();
		this._guessVersion = this._textModel.getVersionId();
		this._tokenStore.buildStore(this._createEmptyTokens(), TokenQuality.None);
		this._register(autorun((reader) => {
			const visibleLineRanges = this._visibleLineRanges.read(reader);
			this._parseAndTokenizeViewPort(visibleLineRanges);
		}));
		this._register(autorunHandleChanges({
			owner: this,
			changeTracker: recordChanges({ tree: this._tree.tree })
		}, (reader, ctx) => {
			const changeEvent = ctx.changes.at(0)?.change;
			if (ctx.changes.length > 1) throw new BugIndicatingError("The tree changed twice in one transaction. This is currently not supported and should not happen.");
			if (!changeEvent) {
				if (ctx.tree) this._firstTreeUpdate(this._tree.treeLastParsedVersion.read(reader));
			} else {
				if (this.hasTokens()) for (const range of changeEvent.ranges) this._markForRefresh(range.newRange);
				if (!this.hasTokens()) this._firstTreeUpdate(changeEvent.versionId);
				else this._handleTreeUpdate(changeEvent.ranges, changeEvent.versionId);
			}
		}));
	}
	handleContentChanged(e) {
		this._guessVersion = e.versionId;
		for (const change of e.changes) if (change.text.length > change.rangeLength) {
			const offset = change.rangeOffset > 0 ? change.rangeOffset - 1 : change.rangeOffset;
			const oldToken = this._tokenStore.getTokenAt(offset);
			let newToken;
			if (oldToken) {
				newToken = {
					startOffsetInclusive: oldToken.startOffsetInclusive,
					length: oldToken.length + change.text.length - change.rangeLength,
					token: oldToken.token
				};
				this._tokenStore.markForRefresh(offset, change.rangeOffset + (change.text.length > change.rangeLength ? change.text.length : change.rangeLength));
			} else newToken = {
				startOffsetInclusive: offset,
				length: change.text.length,
				token: 0
			};
			this._tokenStore.update(oldToken?.length ?? 0, [newToken], TokenQuality.EditGuess);
		} else if (change.text.length < change.rangeLength) {
			const deletedCharCount = change.rangeLength - change.text.length;
			this._tokenStore.delete(deletedCharCount, change.rangeOffset);
		}
	}
	getLineTokens(lineNumber) {
		const content = this._textModel.getLineContent(lineNumber);
		return new LineTokens(this.getTokens(lineNumber), content, this._languageIdCodec);
	}
	_createEmptyTokens() {
		const emptyToken = this._emptyToken();
		const modelEndOffset = this._textModel.getValueLength();
		return [this._emptyTokensForOffsetAndLength(0, modelEndOffset, emptyToken)];
	}
	_emptyToken() {
		return this._treeSitterThemeService.findMetadata([], this._encodedLanguageId, false, void 0);
	}
	_emptyTokensForOffsetAndLength(offset, length, emptyToken) {
		return {
			token: emptyToken,
			length: offset + length,
			startOffsetInclusive: 0
		};
	}
	hasAccurateTokensForLine(lineNumber) {
		return this.hasTokens(new Range$2(lineNumber, 1, lineNumber, this._textModel.getLineMaxColumn(lineNumber)));
	}
	tokenizeLinesAt(lineNumber, lines) {
		const rawLineTokens = this._guessTokensForLinesContent(lineNumber, lines);
		const lineTokens = [];
		if (!rawLineTokens) return null;
		for (let i = 0; i < rawLineTokens.length; i++) lineTokens.push(new LineTokens(rawLineTokens[i], lines[i], this._languageIdCodec));
		return lineTokens;
	}
	_rangeHasTokens(range, minimumTokenQuality) {
		return this._tokenStore.rangeHasTokens(this._textModel.getOffsetAt(range.getStartPosition()), this._textModel.getOffsetAt(range.getEndPosition()), minimumTokenQuality);
	}
	hasTokens(accurateForRange) {
		if (!accurateForRange || this._guessVersion === this._accurateVersion) return true;
		return !this._tokenStore.rangeNeedsRefresh(this._textModel.getOffsetAt(accurateForRange.getStartPosition()), this._textModel.getOffsetAt(accurateForRange.getEndPosition()));
	}
	getTokens(line) {
		const lineStartOffset = this._textModel.getOffsetAt({
			lineNumber: line,
			column: 1
		});
		const lineEndOffset = this._textModel.getOffsetAt({
			lineNumber: line,
			column: this._textModel.getLineLength(line) + 1
		});
		const lineTokens = this._tokenStore.getTokensInRange(lineStartOffset, lineEndOffset);
		const result = new Uint32Array(lineTokens.length * 2);
		for (let i = 0; i < lineTokens.length; i++) {
			result[i * 2] = lineTokens[i].startOffsetInclusive - lineStartOffset + lineTokens[i].length;
			result[i * 2 + 1] = lineTokens[i].token;
		}
		return result;
	}
	getTokensInRange(range, rangeStartOffset, rangeEndOffset, captures) {
		const tokens = captures ? this._tokenizeCapturesWithMetadata(captures, rangeStartOffset, rangeEndOffset) : this._tokenize(range, rangeStartOffset, rangeEndOffset);
		if (tokens?.endOffsetsAndMetadata) return this._rangeTokensAsUpdates(rangeStartOffset, tokens.endOffsetsAndMetadata);
	}
	_updateTokensInStore(version, updates, tokenQuality) {
		this._accurateVersion = version;
		for (const update of updates) {
			const lastToken = update.newTokens.length > 0 ? update.newTokens[update.newTokens.length - 1] : void 0;
			let oldRangeLength;
			if (lastToken && this._guessVersion >= version) oldRangeLength = lastToken.startOffsetInclusive + lastToken.length - update.newTokens[0].startOffsetInclusive;
			else if (update.oldRangeLength) oldRangeLength = update.oldRangeLength;
			else oldRangeLength = 0;
			this._tokenStore.update(oldRangeLength, update.newTokens, tokenQuality);
		}
	}
	_markForRefresh(range) {
		this._tokenStore.markForRefresh(this._textModel.getOffsetAt(range.getStartPosition()), this._textModel.getOffsetAt(range.getEndPosition()));
	}
	_getNeedsRefresh() {
		const needsRefreshOffsetRanges = this._tokenStore.getNeedsRefresh();
		if (!needsRefreshOffsetRanges) return [];
		return needsRefreshOffsetRanges.map((range) => ({
			range: Range$2.fromPositions(this._textModel.getPositionAt(range.startOffset), this._textModel.getPositionAt(range.endOffset)),
			startOffset: range.startOffset,
			endOffset: range.endOffset
		}));
	}
	_parseAndTokenizeViewPort(lineRanges) {
		const viewportRanges = lineRanges.map((r) => r.toInclusiveRange()).filter(isDefined);
		for (const range of viewportRanges) {
			const startOffsetOfRangeInDocument = this._textModel.getOffsetAt(range.getStartPosition());
			const endOffsetOfRangeInDocument = this._textModel.getOffsetAt(range.getEndPosition());
			const version = this._textModel.getVersionId();
			if (this._rangeHasTokens(range, TokenQuality.ViewportGuess)) continue;
			const content = this._textModel.getValueInRange(range);
			const tokenUpdates = this._forceParseAndTokenizeContent(range, startOffsetOfRangeInDocument, endOffsetOfRangeInDocument, content, true);
			if (!tokenUpdates || this._rangeHasTokens(range, TokenQuality.ViewportGuess)) continue;
			if (tokenUpdates.length === 0) continue;
			const lastToken = tokenUpdates[tokenUpdates.length - 1];
			const oldRangeLength = lastToken.startOffsetInclusive + lastToken.length - tokenUpdates[0].startOffsetInclusive;
			this._updateTokensInStore(version, [{
				newTokens: tokenUpdates,
				oldRangeLength
			}], TokenQuality.ViewportGuess);
			this._onDidChangeTokens.fire({ changes: {
				semanticTokensApplied: false,
				ranges: [{
					fromLineNumber: range.startLineNumber,
					toLineNumber: range.endLineNumber
				}]
			} });
		}
	}
	_guessTokensForLinesContent(lineNumber, lines) {
		if (lines.length === 0) return;
		const lineContent = lines.join(this._textModel.getEOL());
		const range = new Range$2(1, 1, lineNumber + lines.length, lines[lines.length - 1].length + 1);
		const startOffset = this._textModel.getOffsetAt({
			lineNumber,
			column: 1
		});
		const tokens = this._forceParseAndTokenizeContent(range, startOffset, startOffset + lineContent.length, lineContent, false);
		if (!tokens) return;
		const tokensByLine = new Array(lines.length);
		let tokensIndex = 0;
		let tokenStartOffset = 0;
		let lineStartOffset = 0;
		for (let i = 0; i < lines.length; i++) {
			const tokensForLine = [];
			let moveToNextLine = false;
			for (let j = tokensIndex; !moveToNextLine && j < tokens.length; j++) {
				const token = tokens[j];
				const lineAdjustedEndOffset = token.endOffset - lineStartOffset;
				const lineAdjustedStartOffset = tokenStartOffset - lineStartOffset;
				if (lineAdjustedEndOffset <= lines[i].length) {
					tokensForLine.push({
						endOffset: lineAdjustedEndOffset,
						metadata: token.metadata
					});
					tokensIndex++;
				} else if (lineAdjustedStartOffset < lines[i].length) {
					const partialToken = {
						endOffset: lines[i].length,
						metadata: token.metadata
					};
					tokensForLine.push(partialToken);
					moveToNextLine = true;
				} else moveToNextLine = true;
				tokenStartOffset = token.endOffset;
			}
			tokensByLine[i] = this._endOffsetTokensToUint32Array(tokensForLine);
			lineStartOffset += lines[i].length + this._textModel.getEOL().length;
		}
		return tokensByLine;
	}
	_forceParseAndTokenizeContent(range, startOffsetOfRangeInDocument, endOffsetOfRangeInDocument, content, asUpdate) {
		const likelyRelevantLines = findLikelyRelevantLines(this._textModel, range.startLineNumber).likelyRelevantLines;
		const likelyRelevantPrefix = likelyRelevantLines.join(this._textModel.getEOL());
		const tree = this._tree.createParsedTreeSync(`${likelyRelevantPrefix}${content}`);
		if (!tree) return;
		const treeRange = new Range$2(1, 1, range.endLineNumber - range.startLineNumber + 1 + likelyRelevantLines.length, range.endColumn);
		const captures = this.captureAtRange(treeRange);
		const tokens = this._tokenizeCapturesWithMetadata(captures, likelyRelevantPrefix.length, endOffsetOfRangeInDocument - startOffsetOfRangeInDocument + likelyRelevantPrefix.length);
		tree.delete();
		if (!tokens) return;
		if (asUpdate) return this._rangeTokensAsUpdates(startOffsetOfRangeInDocument, tokens.endOffsetsAndMetadata, likelyRelevantPrefix.length);
		else return tokens.endOffsetsAndMetadata;
	}
	_firstTreeUpdate(versionId) {
		return this._setViewPortTokens(versionId);
	}
	_setViewPortTokens(versionId) {
		const rangeChanges = this._visibleLineRanges.get().map((lineRange) => {
			const range = lineRange.toInclusiveRange();
			if (!range) return;
			const newRangeStartOffset = this._textModel.getOffsetAt(range.getStartPosition());
			return {
				newRange: range,
				newRangeEndOffset: this._textModel.getOffsetAt(range.getEndPosition()),
				newRangeStartOffset
			};
		}).filter(isDefined);
		return this._handleTreeUpdate(rangeChanges, versionId);
	}
	/**
	* Do not await in this method, it will cause a race
	*/
	_handleTreeUpdate(ranges, versionId) {
		const rangeChanges = [];
		const chunkSize = 1e3;
		for (let i = 0; i < ranges.length; i++) if (ranges[i].newRange.endLineNumber - ranges[i].newRange.startLineNumber > chunkSize) {
			const fullRangeEndLineNumber = ranges[i].newRange.endLineNumber;
			let chunkLineStart = ranges[i].newRange.startLineNumber;
			let chunkColumnStart = ranges[i].newRange.startColumn;
			let chunkLineEnd = chunkLineStart + chunkSize;
			do {
				const chunkStartingPosition = new Position$1(chunkLineStart, chunkColumnStart);
				const chunkEndColumn = chunkLineEnd === ranges[i].newRange.endLineNumber ? ranges[i].newRange.endColumn : this._textModel.getLineMaxColumn(chunkLineEnd);
				const chunkEndPosition = new Position$1(chunkLineEnd, chunkEndColumn);
				const chunkRange = Range$2.fromPositions(chunkStartingPosition, chunkEndPosition);
				rangeChanges.push({
					range: chunkRange,
					startOffset: this._textModel.getOffsetAt(chunkRange.getStartPosition()),
					endOffset: this._textModel.getOffsetAt(chunkRange.getEndPosition())
				});
				chunkLineStart = chunkLineEnd + 1;
				chunkColumnStart = 1;
				if (chunkLineEnd < fullRangeEndLineNumber && chunkLineEnd + chunkSize > fullRangeEndLineNumber) chunkLineEnd = fullRangeEndLineNumber;
				else chunkLineEnd = chunkLineEnd + chunkSize;
			} while (chunkLineEnd <= fullRangeEndLineNumber);
		} else if (i === 0 || rangeChanges[i - 1].endOffset < ranges[i].newRangeStartOffset) rangeChanges.push({
			range: ranges[i].newRange,
			startOffset: ranges[i].newRangeStartOffset,
			endOffset: ranges[i].newRangeEndOffset
		});
		else if (rangeChanges[i - 1].endOffset < ranges[i].newRangeEndOffset) {
			const startPosition = this._textModel.getPositionAt(rangeChanges[i - 1].endOffset + 1);
			const range = new Range$2(startPosition.lineNumber, startPosition.column, ranges[i].newRange.endLineNumber, ranges[i].newRange.endColumn);
			rangeChanges.push({
				range,
				startOffset: rangeChanges[i - 1].endOffset + 1,
				endOffset: ranges[i].newRangeEndOffset
			});
		}
		const captures = rangeChanges.map((range) => this._getCaptures(range.range));
		return this._updateTreeForRanges(rangeChanges, versionId, captures).then(() => {
			if (!this._textModel.isDisposed() && this._tree.treeLastParsedVersion.get() === this._textModel.getVersionId()) this._refreshNeedsRefresh(versionId);
		});
	}
	async _updateTreeForRanges(rangeChanges, versionId, captures) {
		let tokenUpdate;
		for (let i = 0; i < rangeChanges.length; i++) {
			if (!this._textModel.isDisposed() && versionId !== this._textModel.getVersionId()) break;
			const capture = captures[i];
			const range = rangeChanges[i];
			const updates = this.getTokensInRange(range.range, range.startOffset, range.endOffset, capture);
			if (updates) tokenUpdate = { newTokens: updates };
			else tokenUpdate = { newTokens: [] };
			this._updateTokensInStore(versionId, [tokenUpdate], TokenQuality.Accurate);
			this._onDidChangeTokens.fire({ changes: {
				semanticTokensApplied: false,
				ranges: [{
					fromLineNumber: range.range.getStartPosition().lineNumber,
					toLineNumber: range.range.getEndPosition().lineNumber
				}]
			} });
			await new Promise((resolve) => setTimeout0(resolve));
		}
		this._onDidCompleteBackgroundTokenization.fire();
	}
	_refreshNeedsRefresh(versionId) {
		const rangesToRefresh = this._getNeedsRefresh();
		if (rangesToRefresh.length === 0) return;
		const rangeChanges = new Array(rangesToRefresh.length);
		for (let i = 0; i < rangesToRefresh.length; i++) {
			const range = rangesToRefresh[i];
			rangeChanges[i] = {
				newRange: range.range,
				newRangeStartOffset: range.startOffset,
				newRangeEndOffset: range.endOffset
			};
		}
		this._handleTreeUpdate(rangeChanges, versionId);
	}
	_rangeTokensAsUpdates(rangeOffset, endOffsetToken, startingOffsetInArray) {
		const updates = [];
		let lastEnd = 0;
		for (const token of endOffsetToken) {
			if (token.endOffset <= lastEnd || startingOffsetInArray && token.endOffset < startingOffsetInArray) continue;
			let tokenUpdate;
			if (startingOffsetInArray && lastEnd < startingOffsetInArray) tokenUpdate = {
				startOffsetInclusive: rangeOffset + startingOffsetInArray,
				length: token.endOffset - startingOffsetInArray,
				token: token.metadata
			};
			else tokenUpdate = {
				startOffsetInclusive: rangeOffset + lastEnd,
				length: token.endOffset - lastEnd,
				token: token.metadata
			};
			updates.push(tokenUpdate);
			lastEnd = token.endOffset;
		}
		return updates;
	}
	_updateTheme() {
		const modelRange = this._textModel.getFullModelRange();
		this._markForRefresh(modelRange);
		this._parseAndTokenizeViewPort(this._visibleLineRanges.get());
	}
	captureAtRange(range) {
		const tree = this._tree.tree.get();
		if (!tree) return [];
		return this._highlightingQueries.captures(tree.rootNode, {
			startPosition: {
				row: range.startLineNumber - 1,
				column: range.startColumn - 1
			},
			endPosition: {
				row: range.endLineNumber - 1,
				column: range.endColumn - 1
			}
		}).map((capture) => ({
			name: capture.name,
			text: capture.node.text,
			node: {
				startIndex: capture.node.startIndex,
				endIndex: capture.node.endIndex,
				startPosition: {
					lineNumber: capture.node.startPosition.row + 1,
					column: capture.node.startPosition.column + 1
				},
				endPosition: {
					lineNumber: capture.node.endPosition.row + 1,
					column: capture.node.endPosition.column + 1
				}
			},
			encodedLanguageId: this._encodedLanguageId
		}));
	}
	captureAtRangeWithInjections(range) {
		const captures = this.captureAtRange(range);
		for (let i = 0; i < captures.length; i++) {
			const capture = captures[i];
			const capStartLine = capture.node.startPosition.lineNumber;
			const capEndLine = capture.node.endPosition.lineNumber;
			const capStartColumn = capture.node.startPosition.column;
			const capEndColumn = capture.node.endPosition.column;
			const startLine = capStartLine > range.startLineNumber && capStartLine < range.endLineNumber ? capStartLine : range.startLineNumber;
			const endLine = capEndLine > range.startLineNumber && capEndLine < range.endLineNumber ? capEndLine : range.endLineNumber;
			const startColumn = capStartLine === range.startLineNumber ? capStartColumn < range.startColumn ? range.startColumn : capStartColumn : capStartLine < range.startLineNumber ? range.startColumn : capStartColumn;
			const endColumn = capEndLine === range.endLineNumber ? capEndColumn > range.endColumn ? range.endColumn : capEndColumn : capEndLine > range.endLineNumber ? range.endColumn : capEndColumn;
			const injectionRange = new Range$2(startLine, startColumn, endLine, endColumn);
			const injection = this._getInjectionCaptures(capture, injectionRange);
			if (injection && injection.length > 0) {
				captures.splice(i + 1, 0, ...injection);
				i += injection.length;
			}
		}
		return captures;
	}
	/**
	* Gets the tokens for a given line.
	* Each token takes 2 elements in the array. The first element is the offset of the end of the token *in the line, not in the document*, and the second element is the metadata.
	*
	* @param lineNumber
	* @returns
	*/
	tokenizeEncoded(lineNumber) {
		const tokens = this._tokenizeEncoded(lineNumber);
		if (!tokens) return;
		const updates = this._rangeTokensAsUpdates(this._textModel.getOffsetAt({
			lineNumber,
			column: 1
		}), tokens.result);
		if (tokens.versionId === this._textModel.getVersionId()) this._updateTokensInStore(tokens.versionId, [{
			newTokens: updates,
			oldRangeLength: this._textModel.getLineLength(lineNumber)
		}], TokenQuality.Accurate);
	}
	_getCaptures(range) {
		return this.captureAtRangeWithInjections(range);
	}
	_tokenize(range, rangeStartOffset, rangeEndOffset) {
		const captures = this._getCaptures(range);
		const result = this._tokenizeCapturesWithMetadata(captures, rangeStartOffset, rangeEndOffset);
		if (!result) return;
		return {
			...result,
			versionId: this._tree.treeLastParsedVersion.get()
		};
	}
	_createTokensFromCaptures(captures, rangeStartOffset, rangeEndOffset) {
		const tree = this._tree.tree.get();
		const stopwatch = StopWatch.create();
		const rangeLength = rangeEndOffset - rangeStartOffset;
		const encodedLanguageId = this._languageIdCodec.encodeLanguageId(this._tree.languageId);
		const baseScope = TREESITTER_BASE_SCOPES[this._tree.languageId] || "source";
		if (captures.length === 0) {
			if (tree) {
				stopwatch.stop();
				return {
					endOffsets: [{
						endOffset: rangeLength,
						scopes: [],
						encodedLanguageId
					}],
					captureTime: stopwatch.elapsed()
				};
			}
			return;
		}
		const endOffsetsAndScopes = Array(captures.length);
		endOffsetsAndScopes.fill({
			endOffset: 0,
			scopes: [baseScope],
			encodedLanguageId
		});
		let tokenIndex = 0;
		const increaseSizeOfTokensByOneToken = () => {
			endOffsetsAndScopes.push({
				endOffset: 0,
				scopes: [baseScope],
				encodedLanguageId
			});
		};
		const brackets = (capture, startOffset) => {
			return capture.name.includes("punctuation") && capture.text ? Array.from(capture.text.matchAll(BRACKETS)).map((match) => startOffset + match.index) : void 0;
		};
		const addCurrentTokenToArray = (capture, startOffset, endOffset, position) => {
			if (position !== void 0) {
				const oldScopes = endOffsetsAndScopes[position].scopes;
				let oldBracket = endOffsetsAndScopes[position].bracket;
				if ((position > 0 ? endOffsetsAndScopes[position - 1].endOffset : 0) !== startOffset) {
					let preInsertBracket = void 0;
					if (oldBracket && oldBracket.length > 0) {
						preInsertBracket = [];
						const postInsertBracket = [];
						for (let i = 0; i < oldBracket.length; i++) {
							const bracket = oldBracket[i];
							if (bracket < startOffset) preInsertBracket.push(bracket);
							else if (bracket > endOffset) postInsertBracket.push(bracket);
						}
						if (preInsertBracket.length === 0) preInsertBracket = void 0;
						if (postInsertBracket.length === 0) oldBracket = void 0;
						else oldBracket = postInsertBracket;
					}
					endOffsetsAndScopes.splice(position, 0, {
						endOffset: startOffset,
						scopes: [...oldScopes],
						bracket: preInsertBracket,
						encodedLanguageId: capture.encodedLanguageId
					});
					position++;
					increaseSizeOfTokensByOneToken();
					tokenIndex++;
				}
				endOffsetsAndScopes.splice(position, 0, {
					endOffset,
					scopes: [...oldScopes, capture.name],
					bracket: brackets(capture, startOffset),
					encodedLanguageId: capture.encodedLanguageId
				});
				endOffsetsAndScopes[tokenIndex].bracket = oldBracket;
			} else endOffsetsAndScopes[tokenIndex] = {
				endOffset,
				scopes: [baseScope, capture.name],
				bracket: brackets(capture, startOffset),
				encodedLanguageId: capture.encodedLanguageId
			};
			tokenIndex++;
		};
		for (let captureIndex = 0; captureIndex < captures.length; captureIndex++) {
			const capture = captures[captureIndex];
			const tokenEndIndex = capture.node.endIndex < rangeEndOffset ? capture.node.endIndex < rangeStartOffset ? rangeStartOffset : capture.node.endIndex : rangeEndOffset;
			const tokenStartIndex = capture.node.startIndex < rangeStartOffset ? rangeStartOffset : capture.node.startIndex;
			const endOffset = tokenEndIndex - rangeStartOffset;
			let previousEndOffset;
			const currentTokenLength = tokenEndIndex - tokenStartIndex;
			if (captureIndex > 0) previousEndOffset = endOffsetsAndScopes[tokenIndex - 1].endOffset;
			else previousEndOffset = tokenStartIndex - rangeStartOffset - 1;
			const startOffset = endOffset - currentTokenLength;
			if (previousEndOffset >= 0 && previousEndOffset < startOffset) {
				endOffsetsAndScopes[tokenIndex] = {
					endOffset: startOffset,
					scopes: [baseScope],
					encodedLanguageId: this._encodedLanguageId
				};
				tokenIndex++;
				increaseSizeOfTokensByOneToken();
			}
			if (currentTokenLength < 0) continue;
			if (previousEndOffset >= endOffset) {
				let withinTokenIndex = tokenIndex - 1;
				let previousTokenEndOffset = endOffsetsAndScopes[withinTokenIndex].endOffset;
				let previousTokenStartOffset = withinTokenIndex >= 2 ? endOffsetsAndScopes[withinTokenIndex - 1].endOffset : 0;
				do {
					if (previousTokenStartOffset + currentTokenLength === previousTokenEndOffset) {
						if (previousTokenStartOffset === startOffset) {
							endOffsetsAndScopes[withinTokenIndex].scopes.push(capture.name);
							const oldBracket = endOffsetsAndScopes[withinTokenIndex].bracket;
							endOffsetsAndScopes[withinTokenIndex].bracket = oldBracket && oldBracket.length > 0 ? oldBracket : brackets(capture, startOffset);
						}
					} else if (previousTokenStartOffset <= startOffset) {
						addCurrentTokenToArray(capture, startOffset, endOffset, withinTokenIndex);
						break;
					}
					withinTokenIndex--;
					previousTokenStartOffset = withinTokenIndex >= 1 ? endOffsetsAndScopes[withinTokenIndex - 1].endOffset : 0;
					previousTokenEndOffset = withinTokenIndex >= 0 ? endOffsetsAndScopes[withinTokenIndex].endOffset : 0;
				} while (previousTokenEndOffset > startOffset);
			} else addCurrentTokenToArray(capture, startOffset, endOffset);
		}
		if (endOffsetsAndScopes[tokenIndex - 1].endOffset < rangeLength) {
			if (rangeLength - endOffsetsAndScopes[tokenIndex - 1].endOffset > 0) {
				increaseSizeOfTokensByOneToken();
				endOffsetsAndScopes[tokenIndex] = {
					endOffset: rangeLength,
					scopes: endOffsetsAndScopes[tokenIndex].scopes,
					encodedLanguageId: this._encodedLanguageId
				};
				tokenIndex++;
			}
		}
		for (let i = 0; i < endOffsetsAndScopes.length; i++) if (endOffsetsAndScopes[i].endOffset === 0 && i !== 0) {
			endOffsetsAndScopes.splice(i, endOffsetsAndScopes.length - i);
			break;
		}
		return {
			endOffsets: endOffsetsAndScopes,
			captureTime: stopwatch.elapsed()
		};
	}
	_getInjectionCaptures(parentCapture, range) {
		return [];
	}
	_tokenizeCapturesWithMetadata(captures, rangeStartOffset, rangeEndOffset) {
		const stopwatch = StopWatch.create();
		const emptyTokens = this._createTokensFromCaptures(captures, rangeStartOffset, rangeEndOffset);
		if (!emptyTokens) return;
		const endOffsetsAndScopes = emptyTokens.endOffsets;
		for (let i = 0; i < endOffsetsAndScopes.length; i++) {
			const token = endOffsetsAndScopes[i];
			token.metadata = this._treeSitterThemeService.findMetadata(token.scopes, token.encodedLanguageId, !!token.bracket && token.bracket.length > 0, void 0);
		}
		const metadataTime = stopwatch.elapsed();
		return {
			endOffsetsAndMetadata: endOffsetsAndScopes,
			captureTime: emptyTokens.captureTime,
			metadataTime
		};
	}
	_tokenizeEncoded(lineNumber) {
		const lineOffset = this._textModel.getOffsetAt({
			lineNumber,
			column: 1
		});
		const maxLine = this._textModel.getLineCount();
		const lineEndOffset = lineNumber + 1 <= maxLine ? this._textModel.getOffsetAt({
			lineNumber: lineNumber + 1,
			column: 1
		}) : this._textModel.getValueLength();
		const lineLength = lineEndOffset - lineOffset;
		const result = this._tokenize(new Range$2(lineNumber, 1, lineNumber, lineLength + 1), lineOffset, lineEndOffset);
		if (!result) return;
		return {
			result: result.endOffsetsAndMetadata,
			captureTime: result.captureTime,
			metadataTime: result.metadataTime,
			versionId: result.versionId
		};
	}
	_endOffsetTokensToUint32Array(endOffsetsAndMetadata) {
		const uint32Array = new Uint32Array(endOffsetsAndMetadata.length * 2);
		for (let i = 0; i < endOffsetsAndMetadata.length; i++) {
			uint32Array[i * 2] = endOffsetsAndMetadata[i].endOffset;
			uint32Array[i * 2 + 1] = endOffsetsAndMetadata[i].metadata;
		}
		return uint32Array;
	}
};
TreeSitterTokenizationImpl = __decorate$58([__param$53(4, ITreeSitterThemeService)], TreeSitterTokenizationImpl);
var TREESITTER_BASE_SCOPES = {
	"css": "source.css",
	"typescript": "source.ts",
	"ini": "source.ini",
	"regex": "source.regex"
};
var BRACKETS = /[\{\}\[\]\<\>\(\)]/g;
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/services/treeSitter/treeSitterLibraryService.js
var ITreeSitterLibraryService = createDecorator("treeSitterLibraryService");
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/observableInternal/utils/promise.js
/**
* A promise whose state is observable.
*/
var ObservablePromise = class ObservablePromise {
	static fromFn(fn) {
		return new ObservablePromise(fn());
	}
	constructor(promise) {
		this._value = observableValue(this, void 0);
		/**
		* The current state of the promise.
		* Is `undefined` if the promise didn't resolve yet.
		*/
		this.promiseResult = this._value;
		this.promise = promise.then((value) => {
			transaction((tx) => {
				/** @description onPromiseResolved */
				this._value.set(new PromiseResult(value, void 0), tx);
			});
			return value;
		}, (error) => {
			transaction((tx) => {
				/** @description onPromiseRejected */
				this._value.set(new PromiseResult(void 0, error), tx);
			});
			throw error;
		});
	}
};
var PromiseResult = class {
	constructor(data, error) {
		this.data = data;
		this.error = error;
	}
	/**
	* Returns the value if the promise resolved, otherwise throws the error.
	*/
	getDataOrThrow() {
		if (this.error) throw this.error;
		return this.data;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/tokens/treeSitter/treeSitterSyntaxTokenBackend.js
var __decorate$57 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$52 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var TreeSitterSyntaxTokenBackend = class TreeSitterSyntaxTokenBackend extends AbstractSyntaxTokenBackend {
	constructor(_languageIdObs, languageIdCodec, textModel, visibleLineRanges, _treeSitterLibraryService, _instantiationService) {
		super(languageIdCodec, textModel);
		this._languageIdObs = _languageIdObs;
		this._treeSitterLibraryService = _treeSitterLibraryService;
		this._instantiationService = _instantiationService;
		this._backgroundTokenizationState = 1;
		this._onDidChangeBackgroundTokenizationState = this._register(new Emitter$1());
		this.onDidChangeBackgroundTokenizationState = this._onDidChangeBackgroundTokenizationState.event;
		const parserClassPromise = new ObservablePromise(this._treeSitterLibraryService.getParserClass());
		const parserClassObs = derived(this, (reader) => {
			return parserClassPromise.promiseResult?.read(reader)?.getDataOrThrow();
		});
		this._tree = derived(this, (reader) => {
			const parserClass = parserClassObs.read(reader);
			if (!parserClass) return;
			const currentLanguage = this._languageIdObs.read(reader);
			const treeSitterLang = this._treeSitterLibraryService.getLanguage(currentLanguage, false, reader);
			if (!treeSitterLang) return;
			const parser = new parserClass();
			reader.store.add(toDisposable(() => {
				parser.delete();
			}));
			parser.setLanguage(treeSitterLang);
			if (this._treeSitterLibraryService.getInjectionQueries(currentLanguage, reader) === void 0) return;
			return reader.store.add(this._instantiationService.createInstance(TreeSitterTree, currentLanguage, void 0, parser, parserClass, this._textModel));
		});
		this._tokenizationImpl = derived(this, (reader) => {
			const treeModel = this._tree.read(reader);
			if (!treeModel) return;
			const queries = this._treeSitterLibraryService.getHighlightingQueries(treeModel.languageId, reader);
			if (!queries) return;
			return reader.store.add(this._instantiationService.createInstance(TreeSitterTokenizationImpl, treeModel, queries, this._languageIdCodec, visibleLineRanges));
		});
		this._register(autorun((reader) => {
			const tokModel = this._tokenizationImpl.read(reader);
			if (!tokModel) return;
			reader.store.add(tokModel.onDidChangeTokens((e) => {
				this._onDidChangeTokens.fire(e.changes);
			}));
			reader.store.add(tokModel.onDidChangeBackgroundTokenization((e) => {
				this._backgroundTokenizationState = 2;
				this._onDidChangeBackgroundTokenizationState.fire();
			}));
		}));
	}
	getLineTokens(lineNumber) {
		const model = this._tokenizationImpl.get();
		if (!model) {
			const content = this._textModel.getLineContent(lineNumber);
			return LineTokens.createEmpty(content, this._languageIdCodec);
		}
		return model.getLineTokens(lineNumber);
	}
	todo_resetTokenization(fireTokenChangeEvent = true) {
		if (fireTokenChangeEvent) this._onDidChangeTokens.fire({
			semanticTokensApplied: false,
			ranges: [{
				fromLineNumber: 1,
				toLineNumber: this._textModel.getLineCount()
			}]
		});
	}
	handleDidChangeAttached() {}
	handleDidChangeContent(e) {
		if (e.isFlush) this.todo_resetTokenization(false);
		else this._tokenizationImpl.get()?.handleContentChanged(e);
		this._tree.get()?.handleContentChange(e);
	}
	forceTokenization(lineNumber) {
		const model = this._tokenizationImpl.get();
		if (!model) return;
		if (!model.hasAccurateTokensForLine(lineNumber)) model.tokenizeEncoded(lineNumber);
	}
	hasAccurateTokensForLine(lineNumber) {
		const model = this._tokenizationImpl.get();
		if (!model) return false;
		return model.hasAccurateTokensForLine(lineNumber);
	}
	isCheapToTokenize(lineNumber) {
		return true;
	}
	getTokenTypeIfInsertingCharacter(lineNumber, column, character) {
		return 0;
	}
	tokenizeLinesAt(lineNumber, lines) {
		const model = this._tokenizationImpl.get();
		if (!model) return null;
		return model.tokenizeLinesAt(lineNumber, lines);
	}
	get hasTokens() {
		const model = this._tokenizationImpl.get();
		if (!model) return false;
		return model.hasTokens();
	}
};
TreeSitterSyntaxTokenBackend = __decorate$57([__param$52(4, ITreeSitterLibraryService), __param$52(5, IInstantiationService)], TreeSitterSyntaxTokenBackend);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/tokens/sparseTokensStore.js
/**
* Represents sparse tokens in a text model.
*/
var SparseTokensStore = class SparseTokensStore {
	constructor(languageIdCodec) {
		this._pieces = [];
		this._isComplete = false;
		this._languageIdCodec = languageIdCodec;
	}
	flush() {
		this._pieces = [];
		this._isComplete = false;
	}
	isEmpty() {
		return this._pieces.length === 0;
	}
	set(pieces, isComplete, textModel = void 0) {
		this._pieces = pieces || [];
		this._isComplete = isComplete;
		if (textModel) for (const p of this._pieces) p.reportIfInvalid(textModel);
	}
	setPartial(_range, pieces) {
		let range = _range;
		if (pieces.length > 0) {
			const _firstRange = pieces[0].getRange();
			const _lastRange = pieces[pieces.length - 1].getRange();
			if (!_firstRange || !_lastRange) return _range;
			range = _range.plusRange(_firstRange).plusRange(_lastRange);
		}
		let insertPosition = null;
		for (let i = 0, len = this._pieces.length; i < len; i++) {
			const piece = this._pieces[i];
			if (piece.endLineNumber < range.startLineNumber) continue;
			if (piece.startLineNumber > range.endLineNumber) {
				insertPosition = insertPosition || { index: i };
				break;
			}
			piece.removeTokens(range);
			if (piece.isEmpty()) {
				this._pieces.splice(i, 1);
				i--;
				len--;
				continue;
			}
			if (piece.endLineNumber < range.startLineNumber) continue;
			if (piece.startLineNumber > range.endLineNumber) {
				insertPosition = insertPosition || { index: i };
				continue;
			}
			const [a, b] = piece.split(range);
			if (a.isEmpty()) {
				insertPosition = insertPosition || { index: i };
				continue;
			}
			if (b.isEmpty()) continue;
			this._pieces.splice(i, 1, a, b);
			i++;
			len++;
			insertPosition = insertPosition || { index: i };
		}
		insertPosition = insertPosition || { index: this._pieces.length };
		if (pieces.length > 0) this._pieces = arrayInsert(this._pieces, insertPosition.index, pieces);
		return range;
	}
	isComplete() {
		return this._isComplete;
	}
	addSparseTokens(lineNumber, aTokens) {
		if (aTokens.getTextLength() === 0) return aTokens;
		const pieces = this._pieces;
		if (pieces.length === 0) return aTokens;
		const bTokens = pieces[SparseTokensStore._findFirstPieceWithLine(pieces, lineNumber)].getLineTokens(lineNumber);
		if (!bTokens) return aTokens;
		const aLen = aTokens.getCount();
		const bLen = bTokens.getCount();
		let aIndex = 0;
		const result = [];
		let resultLen = 0;
		let lastEndOffset = 0;
		const emitToken = (endOffset, metadata) => {
			if (endOffset <= lastEndOffset) return;
			lastEndOffset = endOffset;
			result[resultLen++] = endOffset;
			result[resultLen++] = metadata;
		};
		for (let bIndex = 0; bIndex < bLen; bIndex++) {
			const bStartCharacter = Math.min(bTokens.getStartCharacter(bIndex), aTokens.getTextLength());
			const bEndCharacter = Math.min(bTokens.getEndCharacter(bIndex), aTokens.getTextLength());
			const bMetadata = bTokens.getMetadata(bIndex);
			const bMask = ((bMetadata & 1 ? 2048 : 0) | (bMetadata & 2 ? 4096 : 0) | (bMetadata & 4 ? 8192 : 0) | (bMetadata & 8 ? 16384 : 0) | (bMetadata & 16 ? 16744448 : 0) | (bMetadata & 32 ? 4278190080 : 0)) >>> 0;
			const aMask = ~bMask >>> 0;
			while (aIndex < aLen && aTokens.getEndOffset(aIndex) <= bStartCharacter) {
				emitToken(aTokens.getEndOffset(aIndex), aTokens.getMetadata(aIndex));
				aIndex++;
			}
			if (aIndex < aLen && aTokens.getStartOffset(aIndex) < bStartCharacter) emitToken(bStartCharacter, aTokens.getMetadata(aIndex));
			while (aIndex < aLen && aTokens.getEndOffset(aIndex) < bEndCharacter) {
				emitToken(aTokens.getEndOffset(aIndex), aTokens.getMetadata(aIndex) & aMask | bMetadata & bMask);
				aIndex++;
			}
			if (aIndex < aLen) {
				emitToken(bEndCharacter, aTokens.getMetadata(aIndex) & aMask | bMetadata & bMask);
				if (aTokens.getEndOffset(aIndex) === bEndCharacter) aIndex++;
			} else {
				const aMergeIndex = Math.min(Math.max(0, aIndex - 1), aLen - 1);
				emitToken(bEndCharacter, aTokens.getMetadata(aMergeIndex) & aMask | bMetadata & bMask);
			}
		}
		while (aIndex < aLen) {
			emitToken(aTokens.getEndOffset(aIndex), aTokens.getMetadata(aIndex));
			aIndex++;
		}
		return new LineTokens(new Uint32Array(result), aTokens.getLineContent(), this._languageIdCodec);
	}
	static _findFirstPieceWithLine(pieces, lineNumber) {
		let low = 0;
		let high = pieces.length - 1;
		while (low < high) {
			let mid = low + Math.floor((high - low) / 2);
			if (pieces[mid].endLineNumber < lineNumber) low = mid + 1;
			else if (pieces[mid].startLineNumber > lineNumber) high = mid - 1;
			else {
				while (mid > low && pieces[mid - 1].startLineNumber <= lineNumber && lineNumber <= pieces[mid - 1].endLineNumber) mid--;
				return mid;
			}
		}
		return low;
	}
	acceptEdit(range, eolCount, firstLineLength, lastLineLength, firstCharCode) {
		for (let i = 0; i < this._pieces.length; i++) {
			const piece = this._pieces[i];
			piece.acceptEdit(range, eolCount, firstLineLength, lastLineLength, firstCharCode);
			if (piece.isEmpty()) {
				this._pieces.splice(i, 1);
				i--;
			}
		}
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/tokens/contiguousTokensEditing.js
var EMPTY_LINE_TOKENS = (/* @__PURE__ */ new Uint32Array(0)).buffer;
var ContiguousTokensEditing = class ContiguousTokensEditing {
	static deleteBeginning(lineTokens, toChIndex) {
		if (lineTokens === null || lineTokens === EMPTY_LINE_TOKENS) return lineTokens;
		return ContiguousTokensEditing.delete(lineTokens, 0, toChIndex);
	}
	static deleteEnding(lineTokens, fromChIndex) {
		if (lineTokens === null || lineTokens === EMPTY_LINE_TOKENS) return lineTokens;
		const tokens = toUint32Array(lineTokens);
		const lineTextLength = tokens[tokens.length - 2];
		return ContiguousTokensEditing.delete(lineTokens, fromChIndex, lineTextLength);
	}
	static delete(lineTokens, fromChIndex, toChIndex) {
		if (lineTokens === null || lineTokens === EMPTY_LINE_TOKENS || fromChIndex === toChIndex) return lineTokens;
		const tokens = toUint32Array(lineTokens);
		const tokensCount = tokens.length >>> 1;
		if (fromChIndex === 0 && tokens[tokens.length - 2] === toChIndex) return EMPTY_LINE_TOKENS;
		const fromTokenIndex = LineTokens.findIndexInTokensArray(tokens, fromChIndex);
		const fromTokenStartOffset = fromTokenIndex > 0 ? tokens[fromTokenIndex - 1 << 1] : 0;
		if (toChIndex < tokens[fromTokenIndex << 1]) {
			const delta = toChIndex - fromChIndex;
			for (let i = fromTokenIndex; i < tokensCount; i++) tokens[i << 1] -= delta;
			return lineTokens;
		}
		let dest;
		let lastEnd;
		if (fromTokenStartOffset !== fromChIndex) {
			tokens[fromTokenIndex << 1] = fromChIndex;
			dest = fromTokenIndex + 1 << 1;
			lastEnd = fromChIndex;
		} else {
			dest = fromTokenIndex << 1;
			lastEnd = fromTokenStartOffset;
		}
		const delta = toChIndex - fromChIndex;
		for (let tokenIndex = fromTokenIndex + 1; tokenIndex < tokensCount; tokenIndex++) {
			const tokenEndOffset = tokens[tokenIndex << 1] - delta;
			if (tokenEndOffset > lastEnd) {
				tokens[dest++] = tokenEndOffset;
				tokens[dest++] = tokens[(tokenIndex << 1) + 1];
				lastEnd = tokenEndOffset;
			}
		}
		if (dest === tokens.length) return lineTokens;
		const tmp = new Uint32Array(dest);
		tmp.set(tokens.subarray(0, dest), 0);
		return tmp.buffer;
	}
	static append(lineTokens, _otherTokens) {
		if (_otherTokens === EMPTY_LINE_TOKENS) return lineTokens;
		if (lineTokens === EMPTY_LINE_TOKENS) return _otherTokens;
		if (lineTokens === null) return lineTokens;
		if (_otherTokens === null) return null;
		const myTokens = toUint32Array(lineTokens);
		const otherTokens = toUint32Array(_otherTokens);
		const otherTokensCount = otherTokens.length >>> 1;
		const result = new Uint32Array(myTokens.length + otherTokens.length);
		result.set(myTokens, 0);
		let dest = myTokens.length;
		const delta = myTokens[myTokens.length - 2];
		for (let i = 0; i < otherTokensCount; i++) {
			result[dest++] = otherTokens[i << 1] + delta;
			result[dest++] = otherTokens[(i << 1) + 1];
		}
		return result.buffer;
	}
	static insert(lineTokens, chIndex, textLength) {
		if (lineTokens === null || lineTokens === EMPTY_LINE_TOKENS) return lineTokens;
		const tokens = toUint32Array(lineTokens);
		const tokensCount = tokens.length >>> 1;
		let fromTokenIndex = LineTokens.findIndexInTokensArray(tokens, chIndex);
		if (fromTokenIndex > 0) {
			if (tokens[fromTokenIndex - 1 << 1] === chIndex) fromTokenIndex--;
		}
		for (let tokenIndex = fromTokenIndex; tokenIndex < tokensCount; tokenIndex++) tokens[tokenIndex << 1] += textLength;
		return lineTokens;
	}
};
function toUint32Array(arr) {
	if (arr instanceof Uint32Array) return arr;
	else return new Uint32Array(arr);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/tokens/contiguousTokensStore.js
/**
* Represents contiguous tokens in a text model.
*/
var ContiguousTokensStore = class ContiguousTokensStore {
	constructor(languageIdCodec) {
		this._lineTokens = [];
		this._len = 0;
		this._languageIdCodec = languageIdCodec;
	}
	flush() {
		this._lineTokens = [];
		this._len = 0;
	}
	get hasTokens() {
		return this._lineTokens.length > 0;
	}
	getTokens(topLevelLanguageId, lineIndex, lineText) {
		let rawLineTokens = null;
		if (lineIndex < this._len) rawLineTokens = this._lineTokens[lineIndex];
		if (rawLineTokens !== null && rawLineTokens !== EMPTY_LINE_TOKENS) return new LineTokens(toUint32Array(rawLineTokens), lineText, this._languageIdCodec);
		const lineTokens = /* @__PURE__ */ new Uint32Array(2);
		lineTokens[0] = lineText.length;
		lineTokens[1] = getDefaultMetadata(this._languageIdCodec.encodeLanguageId(topLevelLanguageId));
		return new LineTokens(lineTokens, lineText, this._languageIdCodec);
	}
	static _massageTokens(topLevelLanguageId, lineTextLength, _tokens) {
		const tokens = _tokens ? toUint32Array(_tokens) : null;
		if (lineTextLength === 0) {
			let hasDifferentLanguageId = false;
			if (tokens && tokens.length > 1) hasDifferentLanguageId = TokenMetadata.getLanguageId(tokens[1]) !== topLevelLanguageId;
			if (!hasDifferentLanguageId) return EMPTY_LINE_TOKENS;
		}
		if (!tokens || tokens.length === 0) {
			const tokens = /* @__PURE__ */ new Uint32Array(2);
			tokens[0] = lineTextLength;
			tokens[1] = getDefaultMetadata(topLevelLanguageId);
			return tokens.buffer;
		}
		tokens[tokens.length - 2] = lineTextLength;
		if (tokens.byteOffset === 0 && tokens.byteLength === tokens.buffer.byteLength) return tokens.buffer;
		return tokens;
	}
	_ensureLine(lineIndex) {
		while (lineIndex >= this._len) {
			this._lineTokens[this._len] = null;
			this._len++;
		}
	}
	_deleteLines(start, deleteCount) {
		if (deleteCount === 0) return;
		if (start + deleteCount > this._len) deleteCount = this._len - start;
		this._lineTokens.splice(start, deleteCount);
		this._len -= deleteCount;
	}
	_insertLines(insertIndex, insertCount) {
		if (insertCount === 0) return;
		const lineTokens = [];
		for (let i = 0; i < insertCount; i++) lineTokens[i] = null;
		this._lineTokens = arrayInsert(this._lineTokens, insertIndex, lineTokens);
		this._len += insertCount;
	}
	setTokens(topLevelLanguageId, lineIndex, lineTextLength, _tokens, checkEquality) {
		const tokens = ContiguousTokensStore._massageTokens(this._languageIdCodec.encodeLanguageId(topLevelLanguageId), lineTextLength, _tokens);
		this._ensureLine(lineIndex);
		const oldTokens = this._lineTokens[lineIndex];
		this._lineTokens[lineIndex] = tokens;
		if (checkEquality) return !ContiguousTokensStore._equals(oldTokens, tokens);
		return false;
	}
	static _equals(_a, _b) {
		if (!_a || !_b) return !_a && !_b;
		const a = toUint32Array(_a);
		const b = toUint32Array(_b);
		if (a.length !== b.length) return false;
		for (let i = 0, len = a.length; i < len; i++) if (a[i] !== b[i]) return false;
		return true;
	}
	acceptEdit(range, eolCount, firstLineLength) {
		this._acceptDeleteRange(range);
		this._acceptInsertText(new Position$1(range.startLineNumber, range.startColumn), eolCount, firstLineLength);
	}
	_acceptDeleteRange(range) {
		const firstLineIndex = range.startLineNumber - 1;
		if (firstLineIndex >= this._len) return;
		if (range.startLineNumber === range.endLineNumber) {
			if (range.startColumn === range.endColumn) return;
			this._lineTokens[firstLineIndex] = ContiguousTokensEditing.delete(this._lineTokens[firstLineIndex], range.startColumn - 1, range.endColumn - 1);
			return;
		}
		this._lineTokens[firstLineIndex] = ContiguousTokensEditing.deleteEnding(this._lineTokens[firstLineIndex], range.startColumn - 1);
		const lastLineIndex = range.endLineNumber - 1;
		let lastLineTokens = null;
		if (lastLineIndex < this._len) lastLineTokens = ContiguousTokensEditing.deleteBeginning(this._lineTokens[lastLineIndex], range.endColumn - 1);
		this._lineTokens[firstLineIndex] = ContiguousTokensEditing.append(this._lineTokens[firstLineIndex], lastLineTokens);
		this._deleteLines(range.startLineNumber, range.endLineNumber - range.startLineNumber);
	}
	_acceptInsertText(position, eolCount, firstLineLength) {
		if (eolCount === 0 && firstLineLength === 0) return;
		const lineIndex = position.lineNumber - 1;
		if (lineIndex >= this._len) return;
		if (eolCount === 0) {
			this._lineTokens[lineIndex] = ContiguousTokensEditing.insert(this._lineTokens[lineIndex], position.column - 1, firstLineLength);
			return;
		}
		this._lineTokens[lineIndex] = ContiguousTokensEditing.deleteEnding(this._lineTokens[lineIndex], position.column - 1);
		this._lineTokens[lineIndex] = ContiguousTokensEditing.insert(this._lineTokens[lineIndex], position.column - 1, firstLineLength);
		this._insertLines(position.lineNumber, eolCount);
	}
	setMultilineTokens(tokens, textModel) {
		if (tokens.length === 0) return { changes: [] };
		const ranges = [];
		for (let i = 0, len = tokens.length; i < len; i++) {
			const element = tokens[i];
			let minChangedLineNumber = 0;
			let maxChangedLineNumber = 0;
			let hasChange = false;
			for (let lineNumber = element.startLineNumber; lineNumber <= element.endLineNumber; lineNumber++) if (hasChange) {
				this.setTokens(textModel.getLanguageId(), lineNumber - 1, textModel.getLineLength(lineNumber), element.getLineTokens(lineNumber), false);
				maxChangedLineNumber = lineNumber;
			} else if (this.setTokens(textModel.getLanguageId(), lineNumber - 1, textModel.getLineLength(lineNumber), element.getLineTokens(lineNumber), true)) {
				hasChange = true;
				minChangedLineNumber = lineNumber;
				maxChangedLineNumber = lineNumber;
			}
			if (hasChange) ranges.push({
				fromLineNumber: minChangedLineNumber,
				toLineNumber: maxChangedLineNumber
			});
		}
		return { changes: ranges };
	}
};
function getDefaultMetadata(topLevelLanguageId) {
	return (topLevelLanguageId << 0 | 33588224) >>> 0;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/tokens/tokenizerSyntaxTokenBackend.js
/** For TextMate */
var TokenizerSyntaxTokenBackend = class extends AbstractSyntaxTokenBackend {
	constructor(languageIdCodec, textModel, getLanguageId, attachedViews) {
		super(languageIdCodec, textModel);
		this.getLanguageId = getLanguageId;
		this._tokenizer = null;
		this._backgroundTokenizationState = 1;
		this._onDidChangeBackgroundTokenizationState = this._register(new Emitter$1());
		this.onDidChangeBackgroundTokenizationState = this._onDidChangeBackgroundTokenizationState.event;
		this._defaultBackgroundTokenizer = null;
		this._backgroundTokenizer = this._register(new MutableDisposable());
		this._tokens = new ContiguousTokensStore(this._languageIdCodec);
		this._debugBackgroundTokenizer = this._register(new MutableDisposable());
		this._attachedViewStates = this._register(new DisposableMap());
		this._register(TokenizationRegistry.onDidChange((e) => {
			const languageId = this.getLanguageId();
			if (e.changedLanguages.indexOf(languageId) === -1) return;
			this.todo_resetTokenization();
		}));
		this.todo_resetTokenization();
		this._register(attachedViews.onDidChangeVisibleRanges(({ view, state }) => {
			if (state) {
				let existing = this._attachedViewStates.get(view);
				if (!existing) {
					existing = new AttachedViewHandler(() => this.refreshRanges(existing.lineRanges));
					this._attachedViewStates.set(view, existing);
				}
				existing.handleStateChange(state);
			} else this._attachedViewStates.deleteAndDispose(view);
		}));
	}
	todo_resetTokenization(fireTokenChangeEvent = true) {
		this._tokens.flush();
		this._debugBackgroundTokens?.flush();
		if (this._debugBackgroundStates) this._debugBackgroundStates = new TrackingTokenizationStateStore(this._textModel.getLineCount());
		if (fireTokenChangeEvent) this._onDidChangeTokens.fire({
			semanticTokensApplied: false,
			ranges: [{
				fromLineNumber: 1,
				toLineNumber: this._textModel.getLineCount()
			}]
		});
		const initializeTokenization = () => {
			if (this._textModel.isTooLargeForTokenization()) return [null, null];
			const tokenizationSupport = TokenizationRegistry.get(this.getLanguageId());
			if (!tokenizationSupport) return [null, null];
			let initialState;
			try {
				initialState = tokenizationSupport.getInitialState();
			} catch (e) {
				onUnexpectedError(e);
				return [null, null];
			}
			return [tokenizationSupport, initialState];
		};
		const [tokenizationSupport, initialState] = initializeTokenization();
		if (tokenizationSupport && initialState) this._tokenizer = new TokenizerWithStateStoreAndTextModel(this._textModel.getLineCount(), tokenizationSupport, this._textModel, this._languageIdCodec);
		else this._tokenizer = null;
		this._backgroundTokenizer.clear();
		this._defaultBackgroundTokenizer = null;
		if (this._tokenizer) {
			const b = {
				setTokens: (tokens) => {
					this.setTokens(tokens);
				},
				setFontInfo: (changes) => {
					this.setFontInfo(changes);
				},
				backgroundTokenizationFinished: () => {
					if (this._backgroundTokenizationState === 2) return;
					const newState = 2;
					this._backgroundTokenizationState = newState;
					this._onDidChangeBackgroundTokenizationState.fire();
				},
				setEndState: (lineNumber, state) => {
					if (!this._tokenizer) return;
					const firstInvalidEndStateLineNumber = this._tokenizer.store.getFirstInvalidEndStateLineNumber();
					if (firstInvalidEndStateLineNumber !== null && lineNumber >= firstInvalidEndStateLineNumber) this._tokenizer?.store.setEndState(lineNumber, state);
				}
			};
			if (tokenizationSupport && tokenizationSupport.createBackgroundTokenizer && !tokenizationSupport.backgroundTokenizerShouldOnlyVerifyTokens) this._backgroundTokenizer.value = tokenizationSupport.createBackgroundTokenizer(this._textModel, b);
			if (!this._backgroundTokenizer.value && !this._textModel.isTooLargeForTokenization()) {
				this._backgroundTokenizer.value = this._defaultBackgroundTokenizer = new DefaultBackgroundTokenizer(this._tokenizer, b);
				this._defaultBackgroundTokenizer.handleChanges();
			}
			if (tokenizationSupport?.backgroundTokenizerShouldOnlyVerifyTokens && tokenizationSupport.createBackgroundTokenizer) {
				this._debugBackgroundTokens = new ContiguousTokensStore(this._languageIdCodec);
				this._debugBackgroundStates = new TrackingTokenizationStateStore(this._textModel.getLineCount());
				this._debugBackgroundTokenizer.clear();
				this._debugBackgroundTokenizer.value = tokenizationSupport.createBackgroundTokenizer(this._textModel, {
					setTokens: (tokens) => {
						this._debugBackgroundTokens?.setMultilineTokens(tokens, this._textModel);
					},
					setFontInfo: (changes) => {
						this.setFontInfo(changes);
					},
					backgroundTokenizationFinished() {},
					setEndState: (lineNumber, state) => {
						this._debugBackgroundStates?.setEndState(lineNumber, state);
					}
				});
			} else {
				this._debugBackgroundTokens = void 0;
				this._debugBackgroundStates = void 0;
				this._debugBackgroundTokenizer.value = void 0;
			}
		}
		this.refreshAllVisibleLineTokens();
	}
	handleDidChangeAttached() {
		this._defaultBackgroundTokenizer?.handleChanges();
	}
	handleDidChangeContent(e) {
		if (e.isFlush) this.todo_resetTokenization(false);
		else if (!e.isEolChange) {
			for (const c of e.changes) {
				const [eolCount, firstLineLength] = countEOL(c.text);
				this._tokens.acceptEdit(c.range, eolCount, firstLineLength);
				this._debugBackgroundTokens?.acceptEdit(c.range, eolCount, firstLineLength);
			}
			this._debugBackgroundStates?.acceptChanges(e.changes);
			if (this._tokenizer) this._tokenizer.store.acceptChanges(e.changes);
			this._defaultBackgroundTokenizer?.handleChanges();
		}
	}
	setTokens(tokens) {
		const { changes } = this._tokens.setMultilineTokens(tokens, this._textModel);
		if (changes.length > 0) this._onDidChangeTokens.fire({
			semanticTokensApplied: false,
			ranges: changes
		});
		return { changes };
	}
	setFontInfo(changes) {
		this._onDidChangeFontTokens.fire({ changes });
	}
	refreshAllVisibleLineTokens() {
		const ranges = LineRange.joinMany([...this._attachedViewStates].map(([_, s]) => s.lineRanges));
		this.refreshRanges(ranges);
	}
	refreshRanges(ranges) {
		for (const range of ranges) this.refreshRange(range.startLineNumber, range.endLineNumberExclusive - 1);
	}
	refreshRange(startLineNumber, endLineNumber) {
		if (!this._tokenizer) return;
		startLineNumber = Math.max(1, Math.min(this._textModel.getLineCount(), startLineNumber));
		endLineNumber = Math.min(this._textModel.getLineCount(), endLineNumber);
		const builder = new ContiguousMultilineTokensBuilder();
		const { heuristicTokens } = this._tokenizer.tokenizeHeuristically(builder, startLineNumber, endLineNumber);
		const changedTokens = this.setTokens(builder.finalize());
		if (heuristicTokens) for (const c of changedTokens.changes) this._backgroundTokenizer.value?.requestTokens(c.fromLineNumber, c.toLineNumber + 1);
		this._defaultBackgroundTokenizer?.checkFinished();
	}
	forceTokenization(lineNumber) {
		const builder = new ContiguousMultilineTokensBuilder();
		this._tokenizer?.updateTokensUntilLine(builder, lineNumber);
		this.setTokens(builder.finalize());
		this._defaultBackgroundTokenizer?.checkFinished();
	}
	hasAccurateTokensForLine(lineNumber) {
		if (!this._tokenizer) return true;
		return this._tokenizer.hasAccurateTokensForLine(lineNumber);
	}
	isCheapToTokenize(lineNumber) {
		if (!this._tokenizer) return true;
		return this._tokenizer.isCheapToTokenize(lineNumber);
	}
	getLineTokens(lineNumber) {
		const lineText = this._textModel.getLineContent(lineNumber);
		const result = this._tokens.getTokens(this._textModel.getLanguageId(), lineNumber - 1, lineText);
		if (this._debugBackgroundTokens && this._debugBackgroundStates && this._tokenizer) {
			if (this._debugBackgroundStates.getFirstInvalidEndStateLineNumberOrMax() > lineNumber && this._tokenizer.store.getFirstInvalidEndStateLineNumberOrMax() > lineNumber) {
				const backgroundResult = this._debugBackgroundTokens.getTokens(this._textModel.getLanguageId(), lineNumber - 1, lineText);
				if (!result.equals(backgroundResult) && this._debugBackgroundTokenizer.value?.reportMismatchingTokens) this._debugBackgroundTokenizer.value.reportMismatchingTokens(lineNumber);
			}
		}
		return result;
	}
	getTokenTypeIfInsertingCharacter(lineNumber, column, character) {
		if (!this._tokenizer) return 0;
		const position = this._textModel.validatePosition(new Position$1(lineNumber, column));
		this.forceTokenization(position.lineNumber);
		return this._tokenizer.getTokenTypeIfInsertingCharacter(position, character);
	}
	tokenizeLinesAt(lineNumber, lines) {
		if (!this._tokenizer) return null;
		this.forceTokenization(lineNumber);
		return this._tokenizer.tokenizeLinesAt(lineNumber, lines);
	}
	get hasTokens() {
		return this._tokens.hasTokens;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/tokens/tokenizationTextModelPart.js
var __decorate$56 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$51 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var TokenizationTextModelPart_1;
var TokenizationTextModelPart = TokenizationTextModelPart_1 = class TokenizationTextModelPart extends TextModelPart {
	constructor(_textModel, _bracketPairsTextModelPart, _languageId, _attachedViews, _languageService, _languageConfigurationService, _instantiationService, _treeSitterLibraryService) {
		super();
		this._textModel = _textModel;
		this._bracketPairsTextModelPart = _bracketPairsTextModelPart;
		this._languageId = _languageId;
		this._attachedViews = _attachedViews;
		this._languageService = _languageService;
		this._languageConfigurationService = _languageConfigurationService;
		this._instantiationService = _instantiationService;
		this._treeSitterLibraryService = _treeSitterLibraryService;
		this._onDidChangeFontTokens = this._register(new Emitter$1());
		this.onDidChangeFontTokens = this._onDidChangeFontTokens.event;
		this._languageIdObs = observableValue(this, this._languageId);
		this._useTreeSitter = derived(this, (reader) => {
			const languageId = this._languageIdObs.read(reader);
			return this._treeSitterLibraryService.supportsLanguage(languageId, reader);
		});
		this.tokens = derived(this, (reader) => {
			let tokens;
			if (this._useTreeSitter.read(reader)) tokens = reader.store.add(this._instantiationService.createInstance(TreeSitterSyntaxTokenBackend, this._languageIdObs, this._languageService.languageIdCodec, this._textModel, this._attachedViews.visibleLineRanges));
			else tokens = reader.store.add(new TokenizerSyntaxTokenBackend(this._languageService.languageIdCodec, this._textModel, () => this._languageId, this._attachedViews));
			reader.store.add(tokens.onDidChangeTokens((e) => {
				this._emitModelTokensChangedEvent(e);
			}));
			reader.store.add(tokens.onDidChangeFontTokens((e) => {
				if (!this._textModel._isDisposing()) this._onDidChangeFontTokens.fire(e);
			}));
			reader.store.add(tokens.onDidChangeBackgroundTokenizationState((e) => {
				this._bracketPairsTextModelPart.handleDidChangeBackgroundTokenizationState();
			}));
			return tokens;
		});
		let hadTokens = false;
		this.tokens.recomputeInitiallyAndOnChange(this._store, (value) => {
			if (hadTokens) value.todo_resetTokenization();
			hadTokens = true;
		});
		this._semanticTokens = new SparseTokensStore(this._languageService.languageIdCodec);
		this._onDidChangeLanguage = this._register(new Emitter$1());
		this.onDidChangeLanguage = this._onDidChangeLanguage.event;
		this._onDidChangeLanguageConfiguration = this._register(new Emitter$1());
		this.onDidChangeLanguageConfiguration = this._onDidChangeLanguageConfiguration.event;
		this._onDidChangeTokens = this._register(new Emitter$1());
		this.onDidChangeTokens = this._onDidChangeTokens.event;
		this._onDidChangeFontTokens = this._register(new Emitter$1());
		this.onDidChangeFontTokens = this._onDidChangeFontTokens.event;
	}
	handleLanguageConfigurationServiceChange(e) {
		if (e.affects(this._languageId)) this._onDidChangeLanguageConfiguration.fire({});
	}
	handleDidChangeContent(e) {
		if (e.isFlush) this._semanticTokens.flush();
		else if (!e.isEolChange) for (const c of e.changes) {
			const [eolCount, firstLineLength, lastLineLength] = countEOL(c.text);
			this._semanticTokens.acceptEdit(c.range, eolCount, firstLineLength, lastLineLength, c.text.length > 0 ? c.text.charCodeAt(0) : 0);
		}
		this.tokens.get().handleDidChangeContent(e);
	}
	handleDidChangeAttached() {
		this.tokens.get().handleDidChangeAttached();
	}
	/**
	* Includes grammar and semantic tokens.
	*/
	getLineTokens(lineNumber) {
		this.validateLineNumber(lineNumber);
		const syntacticTokens = this.tokens.get().getLineTokens(lineNumber);
		return this._semanticTokens.addSparseTokens(lineNumber, syntacticTokens);
	}
	_emitModelTokensChangedEvent(e) {
		if (!this._textModel._isDisposing()) {
			this._bracketPairsTextModelPart.handleDidChangeTokens(e);
			this._onDidChangeTokens.fire(e);
		}
	}
	validateLineNumber(lineNumber) {
		if (lineNumber < 1 || lineNumber > this._textModel.getLineCount()) throw new BugIndicatingError("Illegal value for lineNumber");
	}
	get hasTokens() {
		return this.tokens.get().hasTokens;
	}
	resetTokenization() {
		this.tokens.get().todo_resetTokenization();
	}
	get backgroundTokenizationState() {
		return this.tokens.get().backgroundTokenizationState;
	}
	forceTokenization(lineNumber) {
		this.validateLineNumber(lineNumber);
		this.tokens.get().forceTokenization(lineNumber);
	}
	hasAccurateTokensForLine(lineNumber) {
		this.validateLineNumber(lineNumber);
		return this.tokens.get().hasAccurateTokensForLine(lineNumber);
	}
	isCheapToTokenize(lineNumber) {
		this.validateLineNumber(lineNumber);
		return this.tokens.get().isCheapToTokenize(lineNumber);
	}
	tokenizeIfCheap(lineNumber) {
		this.validateLineNumber(lineNumber);
		this.tokens.get().tokenizeIfCheap(lineNumber);
	}
	getTokenTypeIfInsertingCharacter(lineNumber, column, character) {
		return this.tokens.get().getTokenTypeIfInsertingCharacter(lineNumber, column, character);
	}
	tokenizeLinesAt(lineNumber, lines) {
		return this.tokens.get().tokenizeLinesAt(lineNumber, lines);
	}
	setSemanticTokens(tokens, isComplete) {
		this._semanticTokens.set(tokens, isComplete, this._textModel);
		this._emitModelTokensChangedEvent({
			semanticTokensApplied: tokens !== null,
			ranges: [{
				fromLineNumber: 1,
				toLineNumber: this._textModel.getLineCount()
			}]
		});
	}
	hasCompleteSemanticTokens() {
		return this._semanticTokens.isComplete();
	}
	hasSomeSemanticTokens() {
		return !this._semanticTokens.isEmpty();
	}
	setPartialSemanticTokens(range, tokens) {
		if (this.hasCompleteSemanticTokens()) return;
		const changedRange = this._textModel.validateRange(this._semanticTokens.setPartial(range, tokens));
		this._emitModelTokensChangedEvent({
			semanticTokensApplied: true,
			ranges: [{
				fromLineNumber: changedRange.startLineNumber,
				toLineNumber: changedRange.endLineNumber
			}]
		});
	}
	getWordAtPosition(_position) {
		this.assertNotDisposed();
		const position = this._textModel.validatePosition(_position);
		const lineContent = this._textModel.getLineContent(position.lineNumber);
		const lineTokens = this.getLineTokens(position.lineNumber);
		const tokenIndex = lineTokens.findTokenIndexAtOffset(position.column - 1);
		const [rbStartOffset, rbEndOffset] = TokenizationTextModelPart_1._findLanguageBoundaries(lineTokens, tokenIndex);
		const rightBiasedWord = getWordAtText(position.column, this.getLanguageConfiguration(lineTokens.getLanguageId(tokenIndex)).getWordDefinition(), lineContent.substring(rbStartOffset, rbEndOffset), rbStartOffset);
		if (rightBiasedWord && rightBiasedWord.startColumn <= _position.column && _position.column <= rightBiasedWord.endColumn) return rightBiasedWord;
		if (tokenIndex > 0 && rbStartOffset === position.column - 1) {
			const [lbStartOffset, lbEndOffset] = TokenizationTextModelPart_1._findLanguageBoundaries(lineTokens, tokenIndex - 1);
			const leftBiasedWord = getWordAtText(position.column, this.getLanguageConfiguration(lineTokens.getLanguageId(tokenIndex - 1)).getWordDefinition(), lineContent.substring(lbStartOffset, lbEndOffset), lbStartOffset);
			if (leftBiasedWord && leftBiasedWord.startColumn <= _position.column && _position.column <= leftBiasedWord.endColumn) return leftBiasedWord;
		}
		return null;
	}
	getLanguageConfiguration(languageId) {
		return this._languageConfigurationService.getLanguageConfiguration(languageId);
	}
	static _findLanguageBoundaries(lineTokens, tokenIndex) {
		const languageId = lineTokens.getLanguageId(tokenIndex);
		let startOffset = 0;
		for (let i = tokenIndex; i >= 0 && lineTokens.getLanguageId(i) === languageId; i--) startOffset = lineTokens.getStartOffset(i);
		let endOffset = lineTokens.getLineContent().length;
		for (let i = tokenIndex, tokenCount = lineTokens.getCount(); i < tokenCount && lineTokens.getLanguageId(i) === languageId; i++) endOffset = lineTokens.getEndOffset(i);
		return [startOffset, endOffset];
	}
	getWordUntilPosition(position) {
		const wordAtPosition = this.getWordAtPosition(position);
		if (!wordAtPosition) return {
			word: "",
			startColumn: position.column,
			endColumn: position.column
		};
		return {
			word: wordAtPosition.word.substr(0, position.column - wordAtPosition.startColumn),
			startColumn: wordAtPosition.startColumn,
			endColumn: position.column
		};
	}
	getLanguageId() {
		return this._languageId;
	}
	getLanguageIdAtPosition(lineNumber, column) {
		const position = this._textModel.validatePosition(new Position$1(lineNumber, column));
		const lineTokens = this.getLineTokens(position.lineNumber);
		return lineTokens.getLanguageId(lineTokens.findTokenIndexAtOffset(position.column - 1));
	}
	setLanguageId(languageId, source = "api") {
		if (this._languageId === languageId) return;
		const e = {
			oldLanguage: this._languageId,
			newLanguage: languageId,
			source
		};
		this._languageId = languageId;
		this._languageIdObs.set(languageId, void 0);
		this._bracketPairsTextModelPart.handleDidChangeLanguage(e);
		this._onDidChangeLanguage.fire(e);
		this._onDidChangeLanguageConfiguration.fire({});
	}
};
TokenizationTextModelPart = TokenizationTextModelPart_1 = __decorate$56([
	__param$51(4, ILanguageService),
	__param$51(5, ILanguageConfigurationService),
	__param$51(6, IInstantiationService),
	__param$51(7, ITreeSitterLibraryService)
], TokenizationTextModelPart);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/textModel.js
var __decorate$55 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$50 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var TextModel_1;
function createTextBufferFactory(text) {
	const builder = new PieceTreeTextBufferBuilder();
	builder.acceptChunk(text);
	return builder.finish();
}
function createTextBufferFactoryFromSnapshot(snapshot) {
	const builder = new PieceTreeTextBufferBuilder();
	let chunk;
	while (typeof (chunk = snapshot.read()) === "string") builder.acceptChunk(chunk);
	return builder.finish();
}
function createTextBuffer(value, defaultEOL) {
	let factory;
	if (typeof value === "string") factory = createTextBufferFactory(value);
	else if (isITextSnapshot(value)) factory = createTextBufferFactoryFromSnapshot(value);
	else factory = value;
	return factory.create(defaultEOL);
}
var MODEL_ID$1 = 0;
var LIMIT_FIND_COUNT = 999;
var LONG_LINE_BOUNDARY = 1e4;
var LINE_HEIGHT_CEILING = 300;
var TextModelSnapshot = class {
	constructor(source) {
		this._source = source;
		this._eos = false;
	}
	read() {
		if (this._eos) return null;
		const result = [];
		let resultCnt = 0;
		let resultLength = 0;
		do {
			const tmp = this._source.read();
			if (tmp === null) {
				this._eos = true;
				if (resultCnt === 0) return null;
				else return result.join("");
			}
			if (tmp.length > 0) {
				result[resultCnt++] = tmp;
				resultLength += tmp.length;
			}
			if (resultLength >= 65536) return result.join("");
		} while (true);
	}
};
var invalidFunc = () => {
	throw new Error(`Invalid change accessor`);
};
var TextModel = class TextModel extends Disposable {
	static {
		TextModel_1 = this;
	}
	static {
		this._MODEL_SYNC_LIMIT = 52428800;
	}
	static {
		this.LARGE_FILE_SIZE_THRESHOLD = 20971520;
	}
	static {
		this.LARGE_FILE_LINE_COUNT_THRESHOLD = 3e5;
	}
	static {
		this.LARGE_FILE_HEAP_OPERATION_THRESHOLD = 268435456;
	}
	static {
		this.DEFAULT_CREATION_OPTIONS = {
			isForSimpleWidget: false,
			tabSize: EDITOR_MODEL_DEFAULTS.tabSize,
			indentSize: EDITOR_MODEL_DEFAULTS.indentSize,
			insertSpaces: EDITOR_MODEL_DEFAULTS.insertSpaces,
			detectIndentation: false,
			defaultEOL: 1,
			trimAutoWhitespace: EDITOR_MODEL_DEFAULTS.trimAutoWhitespace,
			largeFileOptimizations: EDITOR_MODEL_DEFAULTS.largeFileOptimizations,
			bracketPairColorizationOptions: EDITOR_MODEL_DEFAULTS.bracketPairColorizationOptions
		};
	}
	static resolveOptions(textBuffer, options) {
		if (options.detectIndentation) {
			const guessedIndentation = guessIndentation(textBuffer, options.tabSize, options.insertSpaces);
			return new TextModelResolvedOptions({
				tabSize: guessedIndentation.tabSize,
				indentSize: "tabSize",
				insertSpaces: guessedIndentation.insertSpaces,
				trimAutoWhitespace: options.trimAutoWhitespace,
				defaultEOL: options.defaultEOL,
				bracketPairColorizationOptions: options.bracketPairColorizationOptions
			});
		}
		return new TextModelResolvedOptions(options);
	}
	get onDidChangeLanguage() {
		return this._tokenizationTextModelPart.onDidChangeLanguage;
	}
	get onDidChangeLanguageConfiguration() {
		return this._tokenizationTextModelPart.onDidChangeLanguageConfiguration;
	}
	get onDidChangeTokens() {
		return this._tokenizationTextModelPart.onDidChangeTokens;
	}
	get onDidChangeOptions() {
		return this._onDidChangeOptions.event;
	}
	get onDidChangeAttached() {
		return this._onDidChangeAttached.event;
	}
	get onDidChangeLineHeight() {
		return this._onDidChangeLineHeight.event;
	}
	get onDidChangeFont() {
		return this._onDidChangeFont.event;
	}
	onDidChangeContent(listener) {
		return this._eventEmitter.event((e) => listener(e.contentChangedEvent));
	}
	_isDisposing() {
		return this.__isDisposing;
	}
	get tokenization() {
		return this._tokenizationTextModelPart;
	}
	get bracketPairs() {
		return this._bracketPairs;
	}
	get guides() {
		return this._guidesTextModelPart;
	}
	constructor(source, languageIdOrSelection, creationOptions, associatedResource = null, _undoRedoService, _languageService, _languageConfigurationService, instantiationService) {
		super();
		this._undoRedoService = _undoRedoService;
		this._languageService = _languageService;
		this._languageConfigurationService = _languageConfigurationService;
		this.instantiationService = instantiationService;
		this._onWillDispose = this._register(new Emitter$1());
		this.onWillDispose = this._onWillDispose.event;
		this._onDidChangeDecorations = this._register(new DidChangeDecorationsEmitter((affectedInjectedTextLines, affectedLineHeights, affectedFontLines) => this.handleBeforeFireDecorationsChangedEvent(affectedInjectedTextLines, affectedLineHeights, affectedFontLines)));
		this.onDidChangeDecorations = this._onDidChangeDecorations.event;
		this._onDidChangeOptions = this._register(new Emitter$1());
		this._onDidChangeAttached = this._register(new Emitter$1());
		this._onDidChangeLineHeight = this._register(new Emitter$1());
		this._onDidChangeFont = this._register(new Emitter$1());
		this._eventEmitter = this._register(new DidChangeContentEmitter());
		this._languageSelectionListener = this._register(new MutableDisposable());
		this._deltaDecorationCallCnt = 0;
		this._attachedViews = this._register(new AttachedViews());
		this._viewModels = /* @__PURE__ */ new Set();
		MODEL_ID$1++;
		this.id = "$model" + MODEL_ID$1;
		this.isForSimpleWidget = creationOptions.isForSimpleWidget;
		if (typeof associatedResource === "undefined" || associatedResource === null) this._associatedResource = URI.parse("inmemory://model/" + MODEL_ID$1);
		else this._associatedResource = associatedResource;
		this._attachedEditorCount = 0;
		const { textBuffer, disposable } = createTextBuffer(source, creationOptions.defaultEOL);
		this._buffer = textBuffer;
		this._bufferDisposable = disposable;
		const bufferLineCount = this._buffer.getLineCount();
		const bufferTextLength = this._buffer.getValueLengthInRange(new Range$2(1, 1, bufferLineCount, this._buffer.getLineLength(bufferLineCount) + 1), 0);
		if (creationOptions.largeFileOptimizations) {
			this._isTooLargeForTokenization = bufferTextLength > TextModel_1.LARGE_FILE_SIZE_THRESHOLD || bufferLineCount > TextModel_1.LARGE_FILE_LINE_COUNT_THRESHOLD;
			this._isTooLargeForHeapOperation = bufferTextLength > TextModel_1.LARGE_FILE_HEAP_OPERATION_THRESHOLD;
		} else {
			this._isTooLargeForTokenization = false;
			this._isTooLargeForHeapOperation = false;
		}
		this._options = TextModel_1.resolveOptions(this._buffer, creationOptions);
		const languageId = typeof languageIdOrSelection === "string" ? languageIdOrSelection : languageIdOrSelection.languageId;
		if (typeof languageIdOrSelection !== "string") this._languageSelectionListener.value = languageIdOrSelection.onDidChange(() => this._setLanguage(languageIdOrSelection.languageId));
		this._bracketPairs = this._register(new BracketPairsTextModelPart(this, this._languageConfigurationService));
		this._guidesTextModelPart = this._register(new GuidesTextModelPart(this, this._languageConfigurationService));
		this._decorationProvider = this._register(new ColorizedBracketPairsDecorationProvider(this));
		this._tokenizationTextModelPart = this.instantiationService.createInstance(TokenizationTextModelPart, this, this._bracketPairs, languageId, this._attachedViews);
		this._fontTokenDecorationsProvider = this._register(new TokenizationFontDecorationProvider(this, this._tokenizationTextModelPart));
		this._isTooLargeForSyncing = bufferTextLength > TextModel_1._MODEL_SYNC_LIMIT;
		this._versionId = 1;
		this._alternativeVersionId = 1;
		this._initialUndoRedoSnapshot = null;
		this._isDisposed = false;
		this.__isDisposing = false;
		this._instanceId = singleLetterHash(MODEL_ID$1);
		this._lastDecorationId = 0;
		this._decorations = Object.create(null);
		this._decorationsTree = new DecorationsTrees();
		this._commandManager = new EditStack(this, this._undoRedoService);
		this._isUndoing = false;
		this._isRedoing = false;
		this._trimAutoWhitespaceLines = null;
		this._register(this._decorationProvider.onDidChange(() => {
			this._onDidChangeDecorations.beginDeferredEmit();
			this._onDidChangeDecorations.fire();
			this._onDidChangeDecorations.endDeferredEmit();
		}));
		this._register(this._fontTokenDecorationsProvider.onDidChangeLineHeight((affectedLineHeights) => {
			this._onDidChangeDecorations.beginDeferredEmit();
			this._onDidChangeDecorations.fire();
			this._fireOnDidChangeLineHeight(affectedLineHeights);
			this._onDidChangeDecorations.endDeferredEmit();
		}));
		this._register(this._fontTokenDecorationsProvider.onDidChangeFont((affectedFontLines) => {
			this._onDidChangeDecorations.beginDeferredEmit();
			this._onDidChangeDecorations.fire();
			this._fireOnDidChangeFont(affectedFontLines);
			this._onDidChangeDecorations.endDeferredEmit();
		}));
		this._languageService.requestRichLanguageFeatures(languageId);
		this._register(this._languageConfigurationService.onDidChange((e) => {
			this._bracketPairs.handleLanguageConfigurationServiceChange(e);
			this._tokenizationTextModelPart.handleLanguageConfigurationServiceChange(e);
		}));
	}
	dispose() {
		this.__isDisposing = true;
		this._onWillDispose.fire();
		this._tokenizationTextModelPart.dispose();
		this._isDisposed = true;
		super.dispose();
		this._bufferDisposable.dispose();
		this.__isDisposing = false;
		const emptyDisposedTextBuffer = new PieceTreeTextBuffer([], "", "\n", false, false, true, true);
		emptyDisposedTextBuffer.dispose();
		this._buffer = emptyDisposedTextBuffer;
		this._bufferDisposable = Disposable.None;
	}
	_assertNotDisposed() {
		if (this._isDisposed) throw new BugIndicatingError("Model is disposed!");
	}
	registerViewModel(viewModel) {
		this._viewModels.add(viewModel);
	}
	unregisterViewModel(viewModel) {
		this._viewModels.delete(viewModel);
	}
	getTextBuffer() {
		this._assertNotDisposed();
		return this._buffer;
	}
	_emitContentChangedEvent(rawChange, change, resultingSelection = null) {
		if (this.__isDisposing) return;
		this._tokenizationTextModelPart.handleDidChangeContent(change);
		this._bracketPairs.handleDidChangeContent(change);
		this._fontTokenDecorationsProvider.handleDidChangeContent(change);
		const contentChangeEvent = new InternalModelContentChangeEvent(rawChange, change);
		if (resultingSelection) contentChangeEvent.rawContentChangedEvent.resultingSelection = resultingSelection;
		this._onDidChangeContentOrInjectedText(contentChangeEvent);
		this._eventEmitter.fire(contentChangeEvent);
	}
	setValue(value, reason = EditSources.setValue()) {
		this._assertNotDisposed();
		if (value === null || value === void 0) throw illegalArgument();
		const { textBuffer, disposable } = createTextBuffer(value, this._options.defaultEOL);
		this._setValueFromTextBuffer(textBuffer, disposable, reason);
	}
	_createContentChanged2(range, rangeOffset, rangeLength, rangeEndPosition, text, isUndoing, isRedoing, isFlush, isEolChange, reason) {
		return {
			changes: [{
				range,
				rangeOffset,
				rangeLength,
				text
			}],
			eol: this._buffer.getEOL(),
			isEolChange,
			versionId: this.getVersionId(),
			isUndoing,
			isRedoing,
			isFlush,
			detailedReasons: [reason],
			detailedReasonsChangeLengths: [1]
		};
	}
	_setValueFromTextBuffer(textBuffer, textBufferDisposable, reason) {
		this._assertNotDisposed();
		const oldFullModelRange = this.getFullModelRange();
		const oldModelValueLength = this.getValueLengthInRange(oldFullModelRange);
		const endLineNumber = this.getLineCount();
		const endColumn = this.getLineMaxColumn(endLineNumber);
		this._buffer = textBuffer;
		this._bufferDisposable.dispose();
		this._bufferDisposable = textBufferDisposable;
		this._increaseVersionId();
		this._decorations = Object.create(null);
		this._decorationsTree = new DecorationsTrees();
		this._commandManager.clear();
		this._trimAutoWhitespaceLines = null;
		this._emitContentChangedEvent(new ModelRawContentChangedEvent([new ModelRawFlush()], this._versionId, false, false), this._createContentChanged2(new Range$2(1, 1, endLineNumber, endColumn), 0, oldModelValueLength, new Position$1(endLineNumber, endColumn), this.getValue(), false, false, true, false, reason));
	}
	setEOL(eol) {
		this._assertNotDisposed();
		const newEOL = eol === 1 ? "\r\n" : "\n";
		if (this._buffer.getEOL() === newEOL) return;
		const oldFullModelRange = this.getFullModelRange();
		const oldModelValueLength = this.getValueLengthInRange(oldFullModelRange);
		const endLineNumber = this.getLineCount();
		const endColumn = this.getLineMaxColumn(endLineNumber);
		this._onBeforeEOLChange();
		this._buffer.setEOL(newEOL);
		this._increaseVersionId();
		this._onAfterEOLChange();
		this._emitContentChangedEvent(new ModelRawContentChangedEvent([new ModelRawEOLChanged()], this._versionId, false, false), this._createContentChanged2(new Range$2(1, 1, endLineNumber, endColumn), 0, oldModelValueLength, new Position$1(endLineNumber, endColumn), this.getValue(), false, false, false, true, EditSources.eolChange()));
	}
	_onBeforeEOLChange() {
		this._decorationsTree.ensureAllNodesHaveRanges(this);
	}
	_onAfterEOLChange() {
		const versionId = this.getVersionId();
		const allDecorations = this._decorationsTree.collectNodesPostOrder();
		for (let i = 0, len = allDecorations.length; i < len; i++) {
			const node = allDecorations[i];
			const range = node.range;
			const delta = node.cachedAbsoluteStart - node.start;
			const startOffset = this._buffer.getOffsetAt(range.startLineNumber, range.startColumn);
			const endOffset = this._buffer.getOffsetAt(range.endLineNumber, range.endColumn);
			node.cachedAbsoluteStart = startOffset;
			node.cachedAbsoluteEnd = endOffset;
			node.cachedVersionId = versionId;
			node.start = startOffset - delta;
			node.end = endOffset - delta;
			recomputeMaxEnd(node);
		}
	}
	onBeforeAttached() {
		this._attachedEditorCount++;
		if (this._attachedEditorCount === 1) {
			this._tokenizationTextModelPart.handleDidChangeAttached();
			this._onDidChangeAttached.fire(void 0);
		}
		return this._attachedViews.attachView();
	}
	onBeforeDetached(view) {
		this._attachedEditorCount--;
		if (this._attachedEditorCount === 0) {
			this._tokenizationTextModelPart.handleDidChangeAttached();
			this._onDidChangeAttached.fire(void 0);
		}
		this._attachedViews.detachView(view);
	}
	isAttachedToEditor() {
		return this._attachedEditorCount > 0;
	}
	getAttachedEditorCount() {
		return this._attachedEditorCount;
	}
	isTooLargeForSyncing() {
		return this._isTooLargeForSyncing;
	}
	isTooLargeForTokenization() {
		return this._isTooLargeForTokenization;
	}
	isTooLargeForHeapOperation() {
		return this._isTooLargeForHeapOperation;
	}
	isDisposed() {
		return this._isDisposed;
	}
	isDominatedByLongLines() {
		this._assertNotDisposed();
		if (this.isTooLargeForTokenization()) return false;
		let smallLineCharCount = 0;
		let longLineCharCount = 0;
		const lineCount = this._buffer.getLineCount();
		for (let lineNumber = 1; lineNumber <= lineCount; lineNumber++) {
			const lineLength = this._buffer.getLineLength(lineNumber);
			if (lineLength >= LONG_LINE_BOUNDARY) longLineCharCount += lineLength;
			else smallLineCharCount += lineLength;
		}
		return longLineCharCount > smallLineCharCount;
	}
	get uri() {
		return this._associatedResource;
	}
	getOptions() {
		this._assertNotDisposed();
		return this._options;
	}
	getFormattingOptions() {
		return {
			tabSize: this._options.indentSize,
			insertSpaces: this._options.insertSpaces
		};
	}
	updateOptions(_newOpts) {
		this._assertNotDisposed();
		const tabSize = typeof _newOpts.tabSize !== "undefined" ? _newOpts.tabSize : this._options.tabSize;
		const indentSize = typeof _newOpts.indentSize !== "undefined" ? _newOpts.indentSize : this._options.originalIndentSize;
		const insertSpaces = typeof _newOpts.insertSpaces !== "undefined" ? _newOpts.insertSpaces : this._options.insertSpaces;
		const trimAutoWhitespace = typeof _newOpts.trimAutoWhitespace !== "undefined" ? _newOpts.trimAutoWhitespace : this._options.trimAutoWhitespace;
		const bracketPairColorizationOptions = typeof _newOpts.bracketColorizationOptions !== "undefined" ? _newOpts.bracketColorizationOptions : this._options.bracketPairColorizationOptions;
		const newOpts = new TextModelResolvedOptions({
			tabSize,
			indentSize,
			insertSpaces,
			defaultEOL: this._options.defaultEOL,
			trimAutoWhitespace,
			bracketPairColorizationOptions
		});
		if (this._options.equals(newOpts)) return;
		const e = this._options.createChangeEvent(newOpts);
		this._options = newOpts;
		this._bracketPairs.handleDidChangeOptions(e);
		this._decorationProvider.handleDidChangeOptions(e);
		this._onDidChangeOptions.fire(e);
	}
	detectIndentation(defaultInsertSpaces, defaultTabSize) {
		this._assertNotDisposed();
		const guessedIndentation = guessIndentation(this._buffer, defaultTabSize, defaultInsertSpaces);
		this.updateOptions({
			insertSpaces: guessedIndentation.insertSpaces,
			tabSize: guessedIndentation.tabSize,
			indentSize: guessedIndentation.tabSize
		});
	}
	normalizeIndentation(str) {
		this._assertNotDisposed();
		return normalizeIndentation(str, this._options.indentSize, this._options.insertSpaces);
	}
	getVersionId() {
		this._assertNotDisposed();
		return this._versionId;
	}
	mightContainRTL() {
		return this._buffer.mightContainRTL();
	}
	mightContainUnusualLineTerminators() {
		return this._buffer.mightContainUnusualLineTerminators();
	}
	removeUnusualLineTerminators(selections = null) {
		const matches = this.findMatches(UNUSUAL_LINE_TERMINATORS.source, false, true, false, null, false, 1073741824);
		this._buffer.resetMightContainUnusualLineTerminators();
		this.pushEditOperations(selections, matches.map((m) => ({
			range: m.range,
			text: null
		})), () => null);
	}
	mightContainNonBasicASCII() {
		return this._buffer.mightContainNonBasicASCII();
	}
	getAlternativeVersionId() {
		this._assertNotDisposed();
		return this._alternativeVersionId;
	}
	getInitialUndoRedoSnapshot() {
		this._assertNotDisposed();
		return this._initialUndoRedoSnapshot;
	}
	getOffsetAt(rawPosition) {
		this._assertNotDisposed();
		const position = this._validatePosition(rawPosition.lineNumber, rawPosition.column, 0);
		return this._buffer.getOffsetAt(position.lineNumber, position.column);
	}
	getPositionAt(rawOffset) {
		this._assertNotDisposed();
		const offset = Math.min(this._buffer.getLength(), Math.max(0, rawOffset));
		return this._buffer.getPositionAt(offset);
	}
	_increaseVersionId() {
		this._versionId = this._versionId + 1;
		this._alternativeVersionId = this._versionId;
	}
	_overwriteVersionId(versionId) {
		this._versionId = versionId;
	}
	_overwriteAlternativeVersionId(newAlternativeVersionId) {
		this._alternativeVersionId = newAlternativeVersionId;
	}
	_overwriteInitialUndoRedoSnapshot(newInitialUndoRedoSnapshot) {
		this._initialUndoRedoSnapshot = newInitialUndoRedoSnapshot;
	}
	getValue(eol, preserveBOM = false) {
		this._assertNotDisposed();
		if (this.isTooLargeForHeapOperation()) throw new BugIndicatingError("Operation would exceed heap memory limits");
		const fullModelRange = this.getFullModelRange();
		const fullModelValue = this.getValueInRange(fullModelRange, eol);
		if (preserveBOM) return this._buffer.getBOM() + fullModelValue;
		return fullModelValue;
	}
	createSnapshot(preserveBOM = false) {
		return new TextModelSnapshot(this._buffer.createSnapshot(preserveBOM));
	}
	getValueLength(eol, preserveBOM = false) {
		this._assertNotDisposed();
		const fullModelRange = this.getFullModelRange();
		const fullModelValue = this.getValueLengthInRange(fullModelRange, eol);
		if (preserveBOM) return this._buffer.getBOM().length + fullModelValue;
		return fullModelValue;
	}
	getValueInRange(rawRange, eol = 0) {
		this._assertNotDisposed();
		return this._buffer.getValueInRange(this.validateRange(rawRange), eol);
	}
	getValueLengthInRange(rawRange, eol = 0) {
		this._assertNotDisposed();
		return this._buffer.getValueLengthInRange(this.validateRange(rawRange), eol);
	}
	getCharacterCountInRange(rawRange, eol = 0) {
		this._assertNotDisposed();
		return this._buffer.getCharacterCountInRange(this.validateRange(rawRange), eol);
	}
	getLineCount() {
		this._assertNotDisposed();
		return this._buffer.getLineCount();
	}
	getLineContent(lineNumber) {
		this._assertNotDisposed();
		if (lineNumber < 1 || lineNumber > this.getLineCount()) throw new BugIndicatingError("Illegal value for lineNumber");
		return this._buffer.getLineContent(lineNumber);
	}
	getLineLength(lineNumber) {
		this._assertNotDisposed();
		if (lineNumber < 1 || lineNumber > this.getLineCount()) throw new BugIndicatingError("Illegal value for lineNumber");
		return this._buffer.getLineLength(lineNumber);
	}
	getLinesContent() {
		this._assertNotDisposed();
		if (this.isTooLargeForHeapOperation()) throw new BugIndicatingError("Operation would exceed heap memory limits");
		return this._buffer.getLinesContent();
	}
	getEOL() {
		this._assertNotDisposed();
		return this._buffer.getEOL();
	}
	getEndOfLineSequence() {
		this._assertNotDisposed();
		return this._buffer.getEOL() === "\n" ? 0 : 1;
	}
	getLineMinColumn(lineNumber) {
		this._assertNotDisposed();
		return 1;
	}
	getLineMaxColumn(lineNumber) {
		this._assertNotDisposed();
		if (lineNumber < 1 || lineNumber > this.getLineCount()) throw new BugIndicatingError("Illegal value for lineNumber");
		return this._buffer.getLineLength(lineNumber) + 1;
	}
	getLineFirstNonWhitespaceColumn(lineNumber) {
		this._assertNotDisposed();
		if (lineNumber < 1 || lineNumber > this.getLineCount()) throw new BugIndicatingError("Illegal value for lineNumber");
		return this._buffer.getLineFirstNonWhitespaceColumn(lineNumber);
	}
	getLineLastNonWhitespaceColumn(lineNumber) {
		this._assertNotDisposed();
		if (lineNumber < 1 || lineNumber > this.getLineCount()) throw new BugIndicatingError("Illegal value for lineNumber");
		return this._buffer.getLineLastNonWhitespaceColumn(lineNumber);
	}
	/**
	* Validates `range` is within buffer bounds, but allows it to sit in between surrogate pairs, etc.
	* Will try to not allocate if possible.
	*/
	_validateRangeRelaxedNoAllocations(range) {
		const linesCount = this._buffer.getLineCount();
		const initialStartLineNumber = range.startLineNumber;
		const initialStartColumn = range.startColumn;
		let startLineNumber = Math.floor(typeof initialStartLineNumber === "number" && !isNaN(initialStartLineNumber) ? initialStartLineNumber : 1);
		let startColumn = Math.floor(typeof initialStartColumn === "number" && !isNaN(initialStartColumn) ? initialStartColumn : 1);
		if (startLineNumber < 1) {
			startLineNumber = 1;
			startColumn = 1;
		} else if (startLineNumber > linesCount) {
			startLineNumber = linesCount;
			startColumn = this.getLineMaxColumn(startLineNumber);
		} else if (startColumn <= 1) startColumn = 1;
		else {
			const maxColumn = this.getLineMaxColumn(startLineNumber);
			if (startColumn >= maxColumn) startColumn = maxColumn;
		}
		const initialEndLineNumber = range.endLineNumber;
		const initialEndColumn = range.endColumn;
		let endLineNumber = Math.floor(typeof initialEndLineNumber === "number" && !isNaN(initialEndLineNumber) ? initialEndLineNumber : 1);
		let endColumn = Math.floor(typeof initialEndColumn === "number" && !isNaN(initialEndColumn) ? initialEndColumn : 1);
		if (endLineNumber < 1) {
			endLineNumber = 1;
			endColumn = 1;
		} else if (endLineNumber > linesCount) {
			endLineNumber = linesCount;
			endColumn = this.getLineMaxColumn(endLineNumber);
		} else if (endColumn <= 1) endColumn = 1;
		else {
			const maxColumn = this.getLineMaxColumn(endLineNumber);
			if (endColumn >= maxColumn) endColumn = maxColumn;
		}
		if (initialStartLineNumber === startLineNumber && initialStartColumn === startColumn && initialEndLineNumber === endLineNumber && initialEndColumn === endColumn && range instanceof Range$2 && !(range instanceof Selection$1)) return range;
		return new Range$2(startLineNumber, startColumn, endLineNumber, endColumn);
	}
	_isValidPosition(lineNumber, column, validationType) {
		if (typeof lineNumber !== "number" || typeof column !== "number") return false;
		if (isNaN(lineNumber) || isNaN(column)) return false;
		if (lineNumber < 1 || column < 1) return false;
		if ((lineNumber | 0) !== lineNumber || (column | 0) !== column) return false;
		if (lineNumber > this._buffer.getLineCount()) return false;
		if (column === 1) return true;
		if (column > this.getLineMaxColumn(lineNumber)) return false;
		if (validationType === 1) {
			const charCodeBefore = this._buffer.getLineCharCode(lineNumber, column - 2);
			if (isHighSurrogate(charCodeBefore)) return false;
		}
		return true;
	}
	_validatePosition(_lineNumber, _column, validationType) {
		const lineNumber = Math.floor(typeof _lineNumber === "number" && !isNaN(_lineNumber) ? _lineNumber : 1);
		const column = Math.floor(typeof _column === "number" && !isNaN(_column) ? _column : 1);
		const lineCount = this._buffer.getLineCount();
		if (lineNumber < 1) return new Position$1(1, 1);
		if (lineNumber > lineCount) return new Position$1(lineCount, this.getLineMaxColumn(lineCount));
		if (column <= 1) return new Position$1(lineNumber, 1);
		const maxColumn = this.getLineMaxColumn(lineNumber);
		if (column >= maxColumn) return new Position$1(lineNumber, maxColumn);
		if (validationType === 1) {
			const charCodeBefore = this._buffer.getLineCharCode(lineNumber, column - 2);
			if (isHighSurrogate(charCodeBefore)) return new Position$1(lineNumber, column - 1);
		}
		return new Position$1(lineNumber, column);
	}
	validatePosition(position) {
		const validationType = 1;
		this._assertNotDisposed();
		if (position instanceof Position$1) {
			if (this._isValidPosition(position.lineNumber, position.column, validationType)) return position;
		}
		return this._validatePosition(position.lineNumber, position.column, validationType);
	}
	isValidRange(range) {
		return this._isValidRange(range, 1);
	}
	_isValidRange(range, validationType) {
		const startLineNumber = range.startLineNumber;
		const startColumn = range.startColumn;
		const endLineNumber = range.endLineNumber;
		const endColumn = range.endColumn;
		if (!this._isValidPosition(startLineNumber, startColumn, 0)) return false;
		if (!this._isValidPosition(endLineNumber, endColumn, 0)) return false;
		if (validationType === 1) {
			const charCodeBeforeStart = startColumn > 1 ? this._buffer.getLineCharCode(startLineNumber, startColumn - 2) : 0;
			const charCodeBeforeEnd = endColumn > 1 && endColumn <= this._buffer.getLineLength(endLineNumber) ? this._buffer.getLineCharCode(endLineNumber, endColumn - 2) : 0;
			const startInsideSurrogatePair = isHighSurrogate(charCodeBeforeStart);
			const endInsideSurrogatePair = isHighSurrogate(charCodeBeforeEnd);
			if (!startInsideSurrogatePair && !endInsideSurrogatePair) return true;
			return false;
		}
		return true;
	}
	validateRange(_range) {
		const validationType = 1;
		this._assertNotDisposed();
		if (_range instanceof Range$2 && !(_range instanceof Selection$1)) {
			if (this._isValidRange(_range, validationType)) return _range;
		}
		const start = this._validatePosition(_range.startLineNumber, _range.startColumn, 0);
		const end = this._validatePosition(_range.endLineNumber, _range.endColumn, 0);
		const startLineNumber = start.lineNumber;
		const startColumn = start.column;
		const endLineNumber = end.lineNumber;
		const endColumn = end.column;
		{
			const charCodeBeforeStart = startColumn > 1 ? this._buffer.getLineCharCode(startLineNumber, startColumn - 2) : 0;
			const charCodeBeforeEnd = endColumn > 1 && endColumn <= this._buffer.getLineLength(endLineNumber) ? this._buffer.getLineCharCode(endLineNumber, endColumn - 2) : 0;
			const startInsideSurrogatePair = isHighSurrogate(charCodeBeforeStart);
			const endInsideSurrogatePair = isHighSurrogate(charCodeBeforeEnd);
			if (!startInsideSurrogatePair && !endInsideSurrogatePair) return new Range$2(startLineNumber, startColumn, endLineNumber, endColumn);
			if (startLineNumber === endLineNumber && startColumn === endColumn) return new Range$2(startLineNumber, startColumn - 1, endLineNumber, endColumn - 1);
			if (startInsideSurrogatePair && endInsideSurrogatePair) return new Range$2(startLineNumber, startColumn - 1, endLineNumber, endColumn + 1);
			if (startInsideSurrogatePair) return new Range$2(startLineNumber, startColumn - 1, endLineNumber, endColumn);
			return new Range$2(startLineNumber, startColumn, endLineNumber, endColumn + 1);
		}
	}
	modifyPosition(rawPosition, offset) {
		this._assertNotDisposed();
		const candidate = this.getOffsetAt(rawPosition) + offset;
		return this.getPositionAt(Math.min(this._buffer.getLength(), Math.max(0, candidate)));
	}
	getFullModelRange() {
		this._assertNotDisposed();
		const lineCount = this.getLineCount();
		return new Range$2(1, 1, lineCount, this.getLineMaxColumn(lineCount));
	}
	findMatchesLineByLine(searchRange, searchData, captureMatches, limitResultCount) {
		return this._buffer.findMatchesLineByLine(searchRange, searchData, captureMatches, limitResultCount);
	}
	findMatches(searchString, rawSearchScope, isRegex, matchCase, wordSeparators, captureMatches, limitResultCount = LIMIT_FIND_COUNT) {
		this._assertNotDisposed();
		let searchRanges = null;
		if (rawSearchScope !== null && typeof rawSearchScope !== "boolean") {
			if (!Array.isArray(rawSearchScope)) rawSearchScope = [rawSearchScope];
			if (rawSearchScope.every((searchScope) => Range$2.isIRange(searchScope))) searchRanges = rawSearchScope.map((searchScope) => this.validateRange(searchScope));
		}
		if (searchRanges === null) searchRanges = [this.getFullModelRange()];
		searchRanges = searchRanges.sort((d1, d2) => d1.startLineNumber - d2.startLineNumber || d1.startColumn - d2.startColumn);
		const uniqueSearchRanges = [];
		uniqueSearchRanges.push(searchRanges.reduce((prev, curr) => {
			if (Range$2.areIntersecting(prev, curr)) return prev.plusRange(curr);
			uniqueSearchRanges.push(prev);
			return curr;
		}));
		let matchMapper;
		if (!isRegex && searchString.indexOf("\n") < 0) {
			const searchData = new SearchParams(searchString, isRegex, matchCase, wordSeparators).parseSearchRequest();
			if (!searchData) return [];
			matchMapper = (searchRange) => this.findMatchesLineByLine(searchRange, searchData, captureMatches, limitResultCount);
		} else matchMapper = (searchRange) => TextModelSearch.findMatches(this, new SearchParams(searchString, isRegex, matchCase, wordSeparators), searchRange, captureMatches, limitResultCount);
		return uniqueSearchRanges.map(matchMapper).reduce((arr, matches) => arr.concat(matches), []);
	}
	findNextMatch(searchString, rawSearchStart, isRegex, matchCase, wordSeparators, captureMatches) {
		this._assertNotDisposed();
		const searchStart = this.validatePosition(rawSearchStart);
		if (!isRegex && searchString.indexOf("\n") < 0) {
			const searchData = new SearchParams(searchString, isRegex, matchCase, wordSeparators).parseSearchRequest();
			if (!searchData) return null;
			const lineCount = this.getLineCount();
			let searchRange = new Range$2(searchStart.lineNumber, searchStart.column, lineCount, this.getLineMaxColumn(lineCount));
			let ret = this.findMatchesLineByLine(searchRange, searchData, captureMatches, 1);
			TextModelSearch.findNextMatch(this, new SearchParams(searchString, isRegex, matchCase, wordSeparators), searchStart, captureMatches);
			if (ret.length > 0) return ret[0];
			searchRange = new Range$2(1, 1, searchStart.lineNumber, this.getLineMaxColumn(searchStart.lineNumber));
			ret = this.findMatchesLineByLine(searchRange, searchData, captureMatches, 1);
			if (ret.length > 0) return ret[0];
			return null;
		}
		return TextModelSearch.findNextMatch(this, new SearchParams(searchString, isRegex, matchCase, wordSeparators), searchStart, captureMatches);
	}
	findPreviousMatch(searchString, rawSearchStart, isRegex, matchCase, wordSeparators, captureMatches) {
		this._assertNotDisposed();
		const searchStart = this.validatePosition(rawSearchStart);
		return TextModelSearch.findPreviousMatch(this, new SearchParams(searchString, isRegex, matchCase, wordSeparators), searchStart, captureMatches);
	}
	pushStackElement() {
		this._commandManager.pushStackElement();
	}
	popStackElement() {
		this._commandManager.popStackElement();
	}
	pushEOL(eol) {
		if ((this.getEOL() === "\n" ? 0 : 1) === eol) return;
		try {
			this._onDidChangeDecorations.beginDeferredEmit();
			this._eventEmitter.beginDeferredEmit();
			if (this._initialUndoRedoSnapshot === null) this._initialUndoRedoSnapshot = this._undoRedoService.createSnapshot(this.uri);
			this._commandManager.pushEOL(eol);
		} finally {
			this._eventEmitter.endDeferredEmit();
			this._onDidChangeDecorations.endDeferredEmit();
		}
	}
	_validateEditOperation(rawOperation) {
		if (rawOperation instanceof ValidAnnotatedEditOperation) return rawOperation;
		const validatedRange = this.validateRange(rawOperation.range);
		let opText = rawOperation.text;
		if (opText) {
			const endsWithLoneCR = opText.length > 0 && opText.charCodeAt(opText.length - 1) === 13;
			if (this.getEOL() === "\r\n" && endsWithLoneCR && validatedRange.endColumn === this.getLineMaxColumn(validatedRange.endLineNumber)) opText = opText.substring(0, opText.length - 1);
		}
		return new ValidAnnotatedEditOperation(rawOperation.identifier || null, validatedRange, opText, rawOperation.forceMoveMarkers || false, rawOperation.isAutoWhitespaceEdit || false, rawOperation._isTracked || false);
	}
	_validateEditOperations(rawOperations) {
		const result = [];
		for (let i = 0, len = rawOperations.length; i < len; i++) result[i] = this._validateEditOperation(rawOperations[i]);
		return result;
	}
	edit(edit, options) {
		this.pushEditOperations(null, edit.replacements.map((r) => ({
			range: r.range,
			text: r.text
		})), null);
	}
	pushEditOperations(beforeCursorState, editOperations, cursorStateComputer, group, reason) {
		try {
			this._onDidChangeDecorations.beginDeferredEmit();
			this._eventEmitter.beginDeferredEmit();
			return this._pushEditOperations(beforeCursorState, this._validateEditOperations(editOperations), cursorStateComputer, group, reason);
		} finally {
			this._eventEmitter.endDeferredEmit();
			this._onDidChangeDecorations.endDeferredEmit();
		}
	}
	_pushEditOperations(beforeCursorState, editOperations, cursorStateComputer, group, reason) {
		if (this._options.trimAutoWhitespace && this._trimAutoWhitespaceLines) {
			const incomingEdits = editOperations.map((op) => {
				return {
					range: this.validateRange(op.range),
					text: op.text
				};
			});
			let editsAreNearCursors = true;
			if (beforeCursorState) for (let i = 0, len = beforeCursorState.length; i < len; i++) {
				const sel = beforeCursorState[i];
				let foundEditNearSel = false;
				for (let j = 0, lenJ = incomingEdits.length; j < lenJ; j++) {
					const editRange = incomingEdits[j].range;
					const selIsAbove = editRange.startLineNumber > sel.endLineNumber;
					const selIsBelow = sel.startLineNumber > editRange.endLineNumber;
					if (!selIsAbove && !selIsBelow) {
						foundEditNearSel = true;
						break;
					}
				}
				if (!foundEditNearSel) {
					editsAreNearCursors = false;
					break;
				}
			}
			if (editsAreNearCursors) for (let i = 0, len = this._trimAutoWhitespaceLines.length; i < len; i++) {
				const trimLineNumber = this._trimAutoWhitespaceLines[i];
				const maxLineColumn = this.getLineMaxColumn(trimLineNumber);
				let allowTrimLine = true;
				for (let j = 0, lenJ = incomingEdits.length; j < lenJ; j++) {
					const editRange = incomingEdits[j].range;
					const editText = incomingEdits[j].text;
					if (trimLineNumber < editRange.startLineNumber || trimLineNumber > editRange.endLineNumber) continue;
					if (trimLineNumber === editRange.startLineNumber && editRange.startColumn === maxLineColumn && editRange.isEmpty() && editText && editText.length > 0 && editText.charAt(0) === "\n") continue;
					if (trimLineNumber === editRange.startLineNumber && editRange.startColumn === 1 && editRange.isEmpty() && editText && editText.length > 0 && editText.charAt(editText.length - 1) === "\n") continue;
					allowTrimLine = false;
					break;
				}
				if (allowTrimLine) {
					const trimRange = new Range$2(trimLineNumber, 1, trimLineNumber, maxLineColumn);
					editOperations.push(new ValidAnnotatedEditOperation(null, trimRange, null, false, false, false));
				}
			}
			this._trimAutoWhitespaceLines = null;
		}
		if (this._initialUndoRedoSnapshot === null) this._initialUndoRedoSnapshot = this._undoRedoService.createSnapshot(this.uri);
		return this._commandManager.pushEditOperation(beforeCursorState, editOperations, cursorStateComputer, group, reason);
	}
	_applyUndo(changes, eol, resultingAlternativeVersionId, resultingSelection) {
		const edits = changes.map((change) => {
			const rangeStart = this.getPositionAt(change.newPosition);
			const rangeEnd = this.getPositionAt(change.newEnd);
			return {
				range: new Range$2(rangeStart.lineNumber, rangeStart.column, rangeEnd.lineNumber, rangeEnd.column),
				text: change.oldText
			};
		});
		this._applyUndoRedoEdits(edits, eol, true, false, resultingAlternativeVersionId, resultingSelection);
	}
	_applyRedo(changes, eol, resultingAlternativeVersionId, resultingSelection) {
		const edits = changes.map((change) => {
			const rangeStart = this.getPositionAt(change.oldPosition);
			const rangeEnd = this.getPositionAt(change.oldEnd);
			return {
				range: new Range$2(rangeStart.lineNumber, rangeStart.column, rangeEnd.lineNumber, rangeEnd.column),
				text: change.newText
			};
		});
		this._applyUndoRedoEdits(edits, eol, false, true, resultingAlternativeVersionId, resultingSelection);
	}
	_applyUndoRedoEdits(edits, eol, isUndoing, isRedoing, resultingAlternativeVersionId, resultingSelection) {
		try {
			this._onDidChangeDecorations.beginDeferredEmit();
			this._eventEmitter.beginDeferredEmit();
			this._isUndoing = isUndoing;
			this._isRedoing = isRedoing;
			const operations = this._validateEditOperations(edits);
			this._doApplyEdits(operations, false, EditSources.applyEdits(), resultingSelection);
			this.setEOL(eol);
			this._overwriteAlternativeVersionId(resultingAlternativeVersionId);
		} finally {
			this._isUndoing = false;
			this._isRedoing = false;
			this._eventEmitter.endDeferredEmit(resultingSelection);
			this._onDidChangeDecorations.endDeferredEmit();
		}
	}
	applyEdits(rawOperations, computeUndoEdits, reason) {
		try {
			this._onDidChangeDecorations.beginDeferredEmit();
			this._eventEmitter.beginDeferredEmit();
			const operations = this._validateEditOperations(rawOperations);
			return this._doApplyEdits(operations, computeUndoEdits ?? false, reason ?? EditSources.applyEdits());
		} finally {
			this._eventEmitter.endDeferredEmit();
			this._onDidChangeDecorations.endDeferredEmit();
		}
	}
	_doApplyEdits(rawOperations, computeUndoEdits, reason, resultingSelection = null) {
		const oldLineCount = this._buffer.getLineCount();
		const result = this._buffer.applyEdits(rawOperations, this._options.trimAutoWhitespace, computeUndoEdits);
		const newLineCount = this._buffer.getLineCount();
		const contentChanges = result.changes;
		this._trimAutoWhitespaceLines = result.trimAutoWhitespaceLineNumbers;
		if (contentChanges.length !== 0) {
			for (let i = 0, len = contentChanges.length; i < len; i++) {
				const change = contentChanges[i];
				this._decorationsTree.acceptReplace(change.rangeOffset, change.rangeLength, change.text.length, change.forceMoveMarkers);
			}
			const rawContentChanges = [];
			this._increaseVersionId();
			let lineCount = oldLineCount;
			for (let i = 0, len = contentChanges.length; i < len; i++) {
				const change = contentChanges[i];
				const [eolCount] = countEOL(change.text);
				this._onDidChangeDecorations.fire();
				const startLineNumber = change.range.startLineNumber;
				const endLineNumber = change.range.endLineNumber;
				const deletingLinesCnt = endLineNumber - startLineNumber;
				const insertingLinesCnt = eolCount;
				const editingLinesCnt = Math.min(deletingLinesCnt, insertingLinesCnt);
				const changeLineCountDelta = insertingLinesCnt - deletingLinesCnt;
				const currentEditStartLineNumber = newLineCount - lineCount - changeLineCountDelta + startLineNumber;
				for (let j = editingLinesCnt; j >= 0; j--) {
					const editLineNumber = startLineNumber + j;
					const currentEditLineNumber = currentEditStartLineNumber + j;
					rawContentChanges.push(new ModelRawLineChanged(editLineNumber, currentEditLineNumber));
				}
				if (editingLinesCnt < deletingLinesCnt) {
					const spliceStartLineNumber = startLineNumber + editingLinesCnt;
					const cnt = insertingLinesCnt - deletingLinesCnt;
					const lastUntouchedLinePostEdit = newLineCount - lineCount - cnt + spliceStartLineNumber;
					rawContentChanges.push(new ModelRawLinesDeleted(spliceStartLineNumber + 1, endLineNumber, lastUntouchedLinePostEdit));
				}
				if (editingLinesCnt < insertingLinesCnt) {
					const spliceLineNumber = startLineNumber + editingLinesCnt;
					const cnt = insertingLinesCnt - editingLinesCnt;
					const fromLineNumber = newLineCount - lineCount - cnt + spliceLineNumber + 1;
					rawContentChanges.push(new ModelRawLinesInserted(spliceLineNumber + 1, fromLineNumber, cnt));
				}
				lineCount += changeLineCountDelta;
			}
			this._emitContentChangedEvent(new ModelRawContentChangedEvent(rawContentChanges, this.getVersionId(), this._isUndoing, this._isRedoing), {
				changes: contentChanges,
				eol: this._buffer.getEOL(),
				isEolChange: false,
				versionId: this.getVersionId(),
				isUndoing: this._isUndoing,
				isRedoing: this._isRedoing,
				isFlush: false,
				detailedReasons: [reason],
				detailedReasonsChangeLengths: [contentChanges.length]
			}, resultingSelection);
		}
		return result.reverseEdits === null ? void 0 : result.reverseEdits;
	}
	undo() {
		return this._undoRedoService.undo(this.uri);
	}
	canUndo() {
		return this._undoRedoService.canUndo(this.uri);
	}
	redo() {
		return this._undoRedoService.redo(this.uri);
	}
	canRedo() {
		return this._undoRedoService.canRedo(this.uri);
	}
	handleBeforeFireDecorationsChangedEvent(affectedInjectedTextLines, affectedLineHeights, affectedFontLines) {
		if (affectedInjectedTextLines && affectedInjectedTextLines.size > 0) {
			const lineChangeEvents = Array.from(affectedInjectedTextLines).map((lineNumber) => new ModelRawLineChanged(lineNumber, lineNumber));
			this._onDidChangeContentOrInjectedText(new ModelInjectedTextChangedEvent(lineChangeEvents));
		}
		this._fireOnDidChangeLineHeight(affectedLineHeights);
		this._fireOnDidChangeFont(affectedFontLines);
	}
	_fireOnDidChangeLineHeight(affectedLineHeights) {
		if (affectedLineHeights && affectedLineHeights.size > 0) {
			const lineHeightChangeEvent = Array.from(affectedLineHeights).map((specialLineHeightChange) => new ModelLineHeightChanged(specialLineHeightChange.ownerId, specialLineHeightChange.decorationId, specialLineHeightChange.lineNumber, specialLineHeightChange.lineHeight));
			this._onDidChangeLineHeight.fire(new ModelLineHeightChangedEvent$1(lineHeightChangeEvent));
		}
	}
	_fireOnDidChangeFont(affectedFontLines) {
		if (affectedFontLines && affectedFontLines.size > 0) {
			const fontChangeEvent = Array.from(affectedFontLines).map((fontChange) => new ModelFontChanged(fontChange.ownerId, fontChange.lineNumber));
			this._onDidChangeFont.fire(new ModelFontChangedEvent$1(fontChangeEvent));
		}
	}
	_onDidChangeContentOrInjectedText(e) {
		for (const viewModel of this._viewModels) try {
			viewModel.onDidChangeContentOrInjectedText(e);
		} catch (error) {
			onUnexpectedError(error);
		}
		for (const viewModel of this._viewModels) try {
			viewModel.emitContentChangeEvent(e);
		} catch (error) {
			onUnexpectedError(error);
		}
	}
	changeDecorations(callback, ownerId = 0) {
		this._assertNotDisposed();
		try {
			this._onDidChangeDecorations.beginDeferredEmit();
			return this._changeDecorations(ownerId, callback);
		} finally {
			this._onDidChangeDecorations.endDeferredEmit();
		}
	}
	_changeDecorations(ownerId, callback) {
		const changeAccessor = {
			addDecoration: (range, options) => {
				return this._deltaDecorationsImpl(ownerId, [], [{
					range,
					options
				}])[0];
			},
			changeDecoration: (id, newRange) => {
				this._changeDecorationImpl(ownerId, id, newRange);
			},
			changeDecorationOptions: (id, options) => {
				this._changeDecorationOptionsImpl(ownerId, id, _normalizeOptions(options));
			},
			removeDecoration: (id) => {
				this._deltaDecorationsImpl(ownerId, [id], []);
			},
			deltaDecorations: (oldDecorations, newDecorations) => {
				if (oldDecorations.length === 0 && newDecorations.length === 0) return [];
				return this._deltaDecorationsImpl(ownerId, oldDecorations, newDecorations);
			}
		};
		let result = null;
		try {
			result = callback(changeAccessor);
		} catch (e) {
			onUnexpectedError(e);
		}
		changeAccessor.addDecoration = invalidFunc;
		changeAccessor.changeDecoration = invalidFunc;
		changeAccessor.changeDecorationOptions = invalidFunc;
		changeAccessor.removeDecoration = invalidFunc;
		changeAccessor.deltaDecorations = invalidFunc;
		return result;
	}
	deltaDecorations(oldDecorations, newDecorations, ownerId = 0) {
		this._assertNotDisposed();
		if (!oldDecorations) oldDecorations = [];
		if (oldDecorations.length === 0 && newDecorations.length === 0) return [];
		try {
			this._deltaDecorationCallCnt++;
			if (this._deltaDecorationCallCnt > 1) {
				console.warn(`Invoking deltaDecorations recursively could lead to leaking decorations.`);
				onUnexpectedError(/* @__PURE__ */ new Error(`Invoking deltaDecorations recursively could lead to leaking decorations.`));
			}
			this._onDidChangeDecorations.beginDeferredEmit();
			return this._deltaDecorationsImpl(ownerId, oldDecorations, newDecorations);
		} finally {
			this._onDidChangeDecorations.endDeferredEmit();
			this._deltaDecorationCallCnt--;
		}
	}
	_getTrackedRange(id) {
		return this.getDecorationRange(id);
	}
	_setTrackedRange(id, newRange, newStickiness) {
		const node = id ? this._decorations[id] : null;
		if (!node) {
			if (!newRange) return null;
			return this._deltaDecorationsImpl(0, [], [{
				range: newRange,
				options: TRACKED_RANGE_OPTIONS[newStickiness]
			}], true)[0];
		}
		if (!newRange) {
			this._decorationsTree.delete(node);
			delete this._decorations[node.id];
			return null;
		}
		const range = this._validateRangeRelaxedNoAllocations(newRange);
		const startOffset = this._buffer.getOffsetAt(range.startLineNumber, range.startColumn);
		const endOffset = this._buffer.getOffsetAt(range.endLineNumber, range.endColumn);
		this._decorationsTree.delete(node);
		node.reset(this.getVersionId(), startOffset, endOffset, range);
		node.setOptions(TRACKED_RANGE_OPTIONS[newStickiness]);
		this._decorationsTree.insert(node);
		return node.id;
	}
	removeAllDecorationsWithOwnerId(ownerId) {
		if (this._isDisposed) return;
		const nodes = this._decorationsTree.collectNodesFromOwner(ownerId);
		for (let i = 0, len = nodes.length; i < len; i++) {
			const node = nodes[i];
			this._decorationsTree.delete(node);
			delete this._decorations[node.id];
		}
	}
	getDecorationOptions(decorationId) {
		const node = this._decorations[decorationId];
		if (!node) return null;
		return node.options;
	}
	getDecorationRange(decorationId) {
		const node = this._decorations[decorationId];
		if (!node) return null;
		return this._decorationsTree.getNodeRange(this, node);
	}
	getLineDecorations(lineNumber, ownerId = 0, filterOutValidation = false, filterFontDecorations = false) {
		if (lineNumber < 1 || lineNumber > this.getLineCount()) return [];
		return this.getLinesDecorations(lineNumber, lineNumber, ownerId, filterOutValidation, filterFontDecorations);
	}
	getLinesDecorations(_startLineNumber, _endLineNumber, ownerId = 0, filterOutValidation = false, filterFontDecorations = false, onlyMarginDecorations = false) {
		const lineCount = this.getLineCount();
		const startLineNumber = Math.min(lineCount, Math.max(1, _startLineNumber));
		const endLineNumber = Math.min(lineCount, Math.max(1, _endLineNumber));
		const endColumn = this.getLineMaxColumn(endLineNumber);
		const range = new Range$2(startLineNumber, 1, endLineNumber, endColumn);
		const decorations = this._getDecorationsInRange(range, ownerId, filterOutValidation, filterFontDecorations, onlyMarginDecorations);
		pushMany(decorations, this._decorationProvider.getDecorationsInRange(range, ownerId, filterOutValidation, filterFontDecorations));
		pushMany(decorations, this._fontTokenDecorationsProvider.getDecorationsInRange(range, ownerId, filterOutValidation, filterFontDecorations));
		return decorations;
	}
	getDecorationsInRange(range, ownerId = 0, filterOutValidation = false, filterFontDecorations = false, onlyMinimapDecorations = false, onlyMarginDecorations = false) {
		const validatedRange = this.validateRange(range);
		const decorations = this._getDecorationsInRange(validatedRange, ownerId, filterOutValidation, filterFontDecorations, onlyMarginDecorations);
		pushMany(decorations, this._decorationProvider.getDecorationsInRange(validatedRange, ownerId, filterOutValidation, filterFontDecorations, onlyMinimapDecorations));
		pushMany(decorations, this._fontTokenDecorationsProvider.getDecorationsInRange(validatedRange, ownerId, filterOutValidation, filterFontDecorations, onlyMinimapDecorations));
		return decorations;
	}
	getOverviewRulerDecorations(ownerId = 0, filterOutValidation = false, filterFontDecorations = false) {
		return this._decorationsTree.getAll(this, ownerId, filterOutValidation, filterFontDecorations, true, false);
	}
	getInjectedTextDecorations(ownerId = 0) {
		return this._decorationsTree.getAllInjectedText(this, ownerId);
	}
	getCustomLineHeightsDecorations(ownerId = 0) {
		const decs = this._decorationsTree.getAllCustomLineHeights(this, ownerId);
		pushMany(decs, this._fontTokenDecorationsProvider.getAllDecorations(ownerId));
		return decs;
	}
	getCustomLineHeightsDecorationsInRange(range, ownerId = 0) {
		const decs = this._decorationsTree.getCustomLineHeightsInInterval(this, this.getOffsetAt(range.getStartPosition()), this.getOffsetAt(range.getEndPosition()), ownerId);
		pushMany(decs, this._fontTokenDecorationsProvider.getDecorationsInRange(range, ownerId));
		return decs;
	}
	getLineInjectedText(lineNumber, ownerId = 0) {
		const startOffset = this._buffer.getOffsetAt(lineNumber, 1);
		const endOffset = startOffset + this._buffer.getLineLength(lineNumber);
		const result = this._decorationsTree.getInjectedTextInInterval(this, startOffset, endOffset, ownerId);
		return LineInjectedText.fromDecorations(result).filter((t) => t.lineNumber === lineNumber);
	}
	getFontDecorationsInRange(range, ownerId = 0) {
		const startOffset = this._buffer.getOffsetAt(range.startLineNumber, range.startColumn);
		const endOffset = this._buffer.getOffsetAt(range.endLineNumber, range.endColumn);
		return this._decorationsTree.getFontDecorationsInInterval(this, startOffset, endOffset, ownerId);
	}
	getAllDecorations(ownerId = 0, filterOutValidation = false, filterFontDecorations = false) {
		let result = this._decorationsTree.getAll(this, ownerId, filterOutValidation, filterFontDecorations, false, false);
		result = result.concat(this._decorationProvider.getAllDecorations(ownerId, filterOutValidation));
		result = result.concat(this._fontTokenDecorationsProvider.getAllDecorations(ownerId, filterOutValidation));
		return result;
	}
	getAllMarginDecorations(ownerId = 0) {
		return this._decorationsTree.getAll(this, ownerId, false, false, false, true);
	}
	_getDecorationsInRange(filterRange, filterOwnerId, filterOutValidation, filterFontDecorations, onlyMarginDecorations) {
		const startOffset = this._buffer.getOffsetAt(filterRange.startLineNumber, filterRange.startColumn);
		const endOffset = this._buffer.getOffsetAt(filterRange.endLineNumber, filterRange.endColumn);
		return this._decorationsTree.getAllInInterval(this, startOffset, endOffset, filterOwnerId, filterOutValidation, filterFontDecorations, onlyMarginDecorations);
	}
	getRangeAt(start, end) {
		return this._buffer.getRangeAt(start, end - start);
	}
	_changeDecorationImpl(ownerId, decorationId, _range) {
		const node = this._decorations[decorationId];
		if (!node) return;
		if (node.options.after) {
			const oldRange = this.getDecorationRange(decorationId);
			this._onDidChangeDecorations.recordLineAffectedByInjectedText(oldRange.endLineNumber);
		}
		if (node.options.before) {
			const oldRange = this.getDecorationRange(decorationId);
			this._onDidChangeDecorations.recordLineAffectedByInjectedText(oldRange.startLineNumber);
		}
		if (node.options.lineHeight !== null) {
			const oldRange = this.getDecorationRange(decorationId);
			this._onDidChangeDecorations.recordLineAffectedByLineHeightChange(ownerId, decorationId, oldRange.startLineNumber, null);
		}
		if (node.options.affectsFont) {
			const oldRange = this.getDecorationRange(decorationId);
			this._onDidChangeDecorations.recordLineAffectedByFontChange(ownerId, node.id, oldRange.startLineNumber);
		}
		const range = this._validateRangeRelaxedNoAllocations(_range);
		const startOffset = this._buffer.getOffsetAt(range.startLineNumber, range.startColumn);
		const endOffset = this._buffer.getOffsetAt(range.endLineNumber, range.endColumn);
		this._decorationsTree.delete(node);
		node.reset(this.getVersionId(), startOffset, endOffset, range);
		this._decorationsTree.insert(node);
		this._onDidChangeDecorations.checkAffectedAndFire(node.options);
		if (node.options.after) this._onDidChangeDecorations.recordLineAffectedByInjectedText(range.endLineNumber);
		if (node.options.before) this._onDidChangeDecorations.recordLineAffectedByInjectedText(range.startLineNumber);
		if (node.options.lineHeight !== null) this._onDidChangeDecorations.recordLineAffectedByLineHeightChange(ownerId, decorationId, range.startLineNumber, node.options.lineHeight);
		if (node.options.affectsFont) this._onDidChangeDecorations.recordLineAffectedByFontChange(ownerId, node.id, range.startLineNumber);
	}
	_changeDecorationOptionsImpl(ownerId, decorationId, options) {
		const node = this._decorations[decorationId];
		if (!node) return;
		const nodeWasInOverviewRuler = node.options.overviewRuler && node.options.overviewRuler.color ? true : false;
		const nodeIsInOverviewRuler = options.overviewRuler && options.overviewRuler.color ? true : false;
		this._onDidChangeDecorations.checkAffectedAndFire(node.options);
		this._onDidChangeDecorations.checkAffectedAndFire(options);
		if (node.options.after || options.after) {
			const nodeRange = this._decorationsTree.getNodeRange(this, node);
			this._onDidChangeDecorations.recordLineAffectedByInjectedText(nodeRange.endLineNumber);
		}
		if (node.options.before || options.before) {
			const nodeRange = this._decorationsTree.getNodeRange(this, node);
			this._onDidChangeDecorations.recordLineAffectedByInjectedText(nodeRange.startLineNumber);
		}
		if (node.options.lineHeight !== null || options.lineHeight !== null) {
			const nodeRange = this._decorationsTree.getNodeRange(this, node);
			this._onDidChangeDecorations.recordLineAffectedByLineHeightChange(ownerId, decorationId, nodeRange.startLineNumber, options.lineHeight);
		}
		if (node.options.affectsFont || options.affectsFont) {
			const nodeRange = this._decorationsTree.getNodeRange(this, node);
			this._onDidChangeDecorations.recordLineAffectedByFontChange(ownerId, decorationId, nodeRange.startLineNumber);
		}
		const movedInOverviewRuler = nodeWasInOverviewRuler !== nodeIsInOverviewRuler;
		const changedWhetherInjectedText = isOptionsInjectedText(options) !== isNodeInjectedText(node);
		if (movedInOverviewRuler || changedWhetherInjectedText) {
			this._decorationsTree.delete(node);
			node.setOptions(options);
			this._decorationsTree.insert(node);
		} else node.setOptions(options);
	}
	_deltaDecorationsImpl(ownerId, oldDecorationsIds, newDecorations, suppressEvents = false) {
		const versionId = this.getVersionId();
		const oldDecorationsLen = oldDecorationsIds.length;
		let oldDecorationIndex = 0;
		const newDecorationsLen = newDecorations.length;
		let newDecorationIndex = 0;
		this._onDidChangeDecorations.beginDeferredEmit();
		try {
			const result = new Array(newDecorationsLen);
			while (oldDecorationIndex < oldDecorationsLen || newDecorationIndex < newDecorationsLen) {
				let node = null;
				if (oldDecorationIndex < oldDecorationsLen) {
					let decorationId;
					do {
						decorationId = oldDecorationsIds[oldDecorationIndex++];
						node = this._decorations[decorationId];
					} while (!node && oldDecorationIndex < oldDecorationsLen);
					if (node) {
						if (node.options.after) {
							const nodeRange = this._decorationsTree.getNodeRange(this, node);
							this._onDidChangeDecorations.recordLineAffectedByInjectedText(nodeRange.endLineNumber);
						}
						if (node.options.before) {
							const nodeRange = this._decorationsTree.getNodeRange(this, node);
							this._onDidChangeDecorations.recordLineAffectedByInjectedText(nodeRange.startLineNumber);
						}
						if (node.options.lineHeight !== null) {
							const nodeRange = this._decorationsTree.getNodeRange(this, node);
							this._onDidChangeDecorations.recordLineAffectedByLineHeightChange(ownerId, decorationId, nodeRange.startLineNumber, null);
						}
						if (node.options.affectsFont) {
							const nodeRange = this._decorationsTree.getNodeRange(this, node);
							this._onDidChangeDecorations.recordLineAffectedByFontChange(ownerId, decorationId, nodeRange.startLineNumber);
						}
						this._decorationsTree.delete(node);
						if (!suppressEvents) this._onDidChangeDecorations.checkAffectedAndFire(node.options);
					}
				}
				if (newDecorationIndex < newDecorationsLen) {
					if (!node) {
						const internalDecorationId = ++this._lastDecorationId;
						const decorationId = `${this._instanceId};${internalDecorationId}`;
						node = new IntervalNode(decorationId, 0, 0);
						this._decorations[decorationId] = node;
					}
					const newDecoration = newDecorations[newDecorationIndex];
					const range = this._validateRangeRelaxedNoAllocations(newDecoration.range);
					const options = _normalizeOptions(newDecoration.options);
					const startOffset = this._buffer.getOffsetAt(range.startLineNumber, range.startColumn);
					const endOffset = this._buffer.getOffsetAt(range.endLineNumber, range.endColumn);
					node.ownerId = ownerId;
					node.reset(versionId, startOffset, endOffset, range);
					node.setOptions(options);
					if (node.options.after) this._onDidChangeDecorations.recordLineAffectedByInjectedText(range.endLineNumber);
					if (node.options.before) this._onDidChangeDecorations.recordLineAffectedByInjectedText(range.startLineNumber);
					if (node.options.lineHeight !== null) this._onDidChangeDecorations.recordLineAffectedByLineHeightChange(ownerId, node.id, range.startLineNumber, node.options.lineHeight);
					if (node.options.affectsFont) this._onDidChangeDecorations.recordLineAffectedByFontChange(ownerId, node.id, range.startLineNumber);
					if (!suppressEvents) this._onDidChangeDecorations.checkAffectedAndFire(options);
					this._decorationsTree.insert(node);
					result[newDecorationIndex] = node.id;
					newDecorationIndex++;
				} else if (node) delete this._decorations[node.id];
			}
			return result;
		} finally {
			this._onDidChangeDecorations.endDeferredEmit();
		}
	}
	getLanguageId() {
		return this.tokenization.getLanguageId();
	}
	setLanguage(languageIdOrSelection, source) {
		if (typeof languageIdOrSelection === "string") {
			this._languageSelectionListener.clear();
			this._setLanguage(languageIdOrSelection, source);
		} else {
			this._languageSelectionListener.value = languageIdOrSelection.onDidChange(() => this._setLanguage(languageIdOrSelection.languageId, source));
			this._setLanguage(languageIdOrSelection.languageId, source);
		}
	}
	_setLanguage(languageId, source) {
		this.tokenization.setLanguageId(languageId, source);
		this._languageService.requestRichLanguageFeatures(languageId);
	}
	getLanguageIdAtPosition(lineNumber, column) {
		return this.tokenization.getLanguageIdAtPosition(lineNumber, column);
	}
	getWordAtPosition(position) {
		return this._tokenizationTextModelPart.getWordAtPosition(position);
	}
	getWordUntilPosition(position) {
		return this._tokenizationTextModelPart.getWordUntilPosition(position);
	}
	normalizePosition(position, affinity) {
		return position;
	}
	/**
	* Gets the column at which indentation stops at a given line.
	* @internal
	*/
	getLineIndentColumn(lineNumber) {
		return indentOfLine(this.getLineContent(lineNumber)) + 1;
	}
	toString() {
		return `TextModel(${this.uri.toString()})`;
	}
};
TextModel = TextModel_1 = __decorate$55([
	__param$50(4, IUndoRedoService),
	__param$50(5, ILanguageService),
	__param$50(6, ILanguageConfigurationService),
	__param$50(7, IInstantiationService)
], TextModel);
function getLineTokensWithInjections(tokens, injectionOptions, injectionOffsets) {
	let lineTokens;
	if (injectionOffsets) {
		const tokensToInsert = [];
		for (let idx = 0; idx < injectionOffsets.length; idx++) {
			const offset = injectionOffsets[idx];
			const tokens = injectionOptions[idx].tokens;
			if (tokens) tokens.forEach((range, info) => {
				tokensToInsert.push({
					offset,
					text: range.substring(injectionOptions[idx].content),
					tokenMetadata: info.metadata
				});
			});
			else tokensToInsert.push({
				offset,
				text: injectionOptions[idx].content,
				tokenMetadata: LineTokens.defaultTokenMetadata
			});
		}
		lineTokens = tokens.withInserted(tokensToInsert);
	} else lineTokens = tokens;
	return lineTokens;
}
function indentOfLine(line) {
	let indent = 0;
	for (const c of line) if (c === " " || c === "	") indent++;
	else break;
	return indent;
}
function isNodeInOverviewRuler(node) {
	return node.options.overviewRuler && node.options.overviewRuler.color ? true : false;
}
function isOptionsInjectedText(options) {
	return !!options.after || !!options.before;
}
function isNodeInjectedText(node) {
	return !!node.options.after || !!node.options.before;
}
var DecorationsTrees = class {
	constructor() {
		this._decorationsTree0 = new IntervalTree();
		this._decorationsTree1 = new IntervalTree();
		this._injectedTextDecorationsTree = new IntervalTree();
	}
	ensureAllNodesHaveRanges(host) {
		this.getAll(host, 0, false, false, false, false);
	}
	_ensureNodesHaveRanges(host, nodes) {
		for (const node of nodes) if (node.range === null) node.range = host.getRangeAt(node.cachedAbsoluteStart, node.cachedAbsoluteEnd);
		return nodes;
	}
	getAllInInterval(host, start, end, filterOwnerId, filterOutValidation, filterFontDecorations, onlyMarginDecorations) {
		const versionId = host.getVersionId();
		const result = this._intervalSearch(start, end, filterOwnerId, filterOutValidation, filterFontDecorations, versionId, onlyMarginDecorations);
		return this._ensureNodesHaveRanges(host, result);
	}
	_intervalSearch(start, end, filterOwnerId, filterOutValidation, filterFontDecorations, cachedVersionId, onlyMarginDecorations) {
		const r0 = this._decorationsTree0.intervalSearch(start, end, filterOwnerId, filterOutValidation, filterFontDecorations, cachedVersionId, onlyMarginDecorations);
		const r1 = this._decorationsTree1.intervalSearch(start, end, filterOwnerId, filterOutValidation, filterFontDecorations, cachedVersionId, onlyMarginDecorations);
		const r2 = this._injectedTextDecorationsTree.intervalSearch(start, end, filterOwnerId, filterOutValidation, filterFontDecorations, cachedVersionId, onlyMarginDecorations);
		return r0.concat(r1).concat(r2);
	}
	getInjectedTextInInterval(host, start, end, filterOwnerId) {
		const versionId = host.getVersionId();
		const result = this._injectedTextDecorationsTree.intervalSearch(start, end, filterOwnerId, false, false, versionId, false);
		return this._ensureNodesHaveRanges(host, result).filter((i) => i.options.showIfCollapsed || !i.range.isEmpty());
	}
	getFontDecorationsInInterval(host, start, end, filterOwnerId) {
		const versionId = host.getVersionId();
		const decorations = this._decorationsTree0.intervalSearch(start, end, filterOwnerId, false, false, versionId, false);
		return this._ensureNodesHaveRanges(host, decorations).filter((i) => i.options.affectsFont);
	}
	getAllInjectedText(host, filterOwnerId) {
		const versionId = host.getVersionId();
		const result = this._injectedTextDecorationsTree.search(filterOwnerId, false, false, versionId, false);
		return this._ensureNodesHaveRanges(host, result).filter((i) => i.options.showIfCollapsed || !i.range.isEmpty());
	}
	getAllCustomLineHeights(host, filterOwnerId) {
		const versionId = host.getVersionId();
		const result = this._search(filterOwnerId, false, false, false, versionId, false);
		return this._ensureNodesHaveRanges(host, result).filter((i) => typeof i.options.lineHeight === "number");
	}
	getCustomLineHeightsInInterval(host, start, end, filterOwnerId) {
		const versionId = host.getVersionId();
		const result = this._intervalSearch(start, end, filterOwnerId, false, false, versionId, false);
		return this._ensureNodesHaveRanges(host, result).filter((i) => typeof i.options.lineHeight === "number");
	}
	getAll(host, filterOwnerId, filterOutValidation, filterFontDecorations, overviewRulerOnly, onlyMarginDecorations) {
		const versionId = host.getVersionId();
		const result = this._search(filterOwnerId, filterOutValidation, filterFontDecorations, overviewRulerOnly, versionId, onlyMarginDecorations);
		return this._ensureNodesHaveRanges(host, result);
	}
	_search(filterOwnerId, filterOutValidation, filterFontDecorations, overviewRulerOnly, cachedVersionId, onlyMarginDecorations) {
		if (overviewRulerOnly) return this._decorationsTree1.search(filterOwnerId, filterOutValidation, filterFontDecorations, cachedVersionId, onlyMarginDecorations);
		else {
			const r0 = this._decorationsTree0.search(filterOwnerId, filterOutValidation, filterFontDecorations, cachedVersionId, onlyMarginDecorations);
			const r1 = this._decorationsTree1.search(filterOwnerId, filterOutValidation, filterFontDecorations, cachedVersionId, onlyMarginDecorations);
			const r2 = this._injectedTextDecorationsTree.search(filterOwnerId, filterOutValidation, filterFontDecorations, cachedVersionId, onlyMarginDecorations);
			return r0.concat(r1).concat(r2);
		}
	}
	collectNodesFromOwner(ownerId) {
		const r0 = this._decorationsTree0.collectNodesFromOwner(ownerId);
		const r1 = this._decorationsTree1.collectNodesFromOwner(ownerId);
		const r2 = this._injectedTextDecorationsTree.collectNodesFromOwner(ownerId);
		return r0.concat(r1).concat(r2);
	}
	collectNodesPostOrder() {
		const r0 = this._decorationsTree0.collectNodesPostOrder();
		const r1 = this._decorationsTree1.collectNodesPostOrder();
		const r2 = this._injectedTextDecorationsTree.collectNodesPostOrder();
		return r0.concat(r1).concat(r2);
	}
	insert(node) {
		if (isNodeInjectedText(node)) this._injectedTextDecorationsTree.insert(node);
		else if (isNodeInOverviewRuler(node)) this._decorationsTree1.insert(node);
		else this._decorationsTree0.insert(node);
	}
	delete(node) {
		if (isNodeInjectedText(node)) this._injectedTextDecorationsTree.delete(node);
		else if (isNodeInOverviewRuler(node)) this._decorationsTree1.delete(node);
		else this._decorationsTree0.delete(node);
	}
	getNodeRange(host, node) {
		const versionId = host.getVersionId();
		if (node.cachedVersionId !== versionId) this._resolveNode(node, versionId);
		if (node.range === null) node.range = host.getRangeAt(node.cachedAbsoluteStart, node.cachedAbsoluteEnd);
		return node.range;
	}
	_resolveNode(node, cachedVersionId) {
		if (isNodeInjectedText(node)) this._injectedTextDecorationsTree.resolveNode(node, cachedVersionId);
		else if (isNodeInOverviewRuler(node)) this._decorationsTree1.resolveNode(node, cachedVersionId);
		else this._decorationsTree0.resolveNode(node, cachedVersionId);
	}
	acceptReplace(offset, length, textLength, forceMoveMarkers) {
		this._decorationsTree0.acceptReplace(offset, length, textLength, forceMoveMarkers);
		this._decorationsTree1.acceptReplace(offset, length, textLength, forceMoveMarkers);
		this._injectedTextDecorationsTree.acceptReplace(offset, length, textLength, forceMoveMarkers);
	}
};
function cleanClassName(className) {
	return className.replace(/[^a-z0-9\-_]/gi, " ");
}
var DecorationOptions = class {
	constructor(options) {
		this.color = options.color || "";
		this.darkColor = options.darkColor || "";
	}
};
var ModelDecorationOverviewRulerOptions = class extends DecorationOptions {
	constructor(options) {
		super(options);
		this._resolvedColor = null;
		this.position = typeof options.position === "number" ? options.position : OverviewRulerLane.Center;
	}
	getColor(theme) {
		if (!this._resolvedColor) {
			if (isDark(theme.type) && this.darkColor) this._resolvedColor = this._resolveColor(this.darkColor, theme);
			else this._resolvedColor = this._resolveColor(this.color, theme);
		}
		return this._resolvedColor;
	}
	invalidateCachedColor() {
		this._resolvedColor = null;
	}
	_resolveColor(color, theme) {
		if (typeof color === "string") return color;
		const c = color ? theme.getColor(color.id) : null;
		if (!c) return "";
		return c.toString();
	}
};
var ModelDecorationGlyphMarginOptions = class {
	constructor(options) {
		this.position = options?.position ?? GlyphMarginLane.Center;
		this.persistLane = options?.persistLane;
	}
};
var ModelDecorationMinimapOptions = class extends DecorationOptions {
	constructor(options) {
		super(options);
		this.position = options.position;
		this.sectionHeaderStyle = options.sectionHeaderStyle ?? null;
		this.sectionHeaderText = options.sectionHeaderText ?? null;
	}
	getColor(theme) {
		if (!this._resolvedColor) {
			if (isDark(theme.type) && this.darkColor) this._resolvedColor = this._resolveColor(this.darkColor, theme);
			else this._resolvedColor = this._resolveColor(this.color, theme);
		}
		return this._resolvedColor;
	}
	invalidateCachedColor() {
		this._resolvedColor = void 0;
	}
	_resolveColor(color, theme) {
		if (typeof color === "string") return Color.fromHex(color);
		return theme.getColor(color.id);
	}
};
var ModelDecorationInjectedTextOptions = class ModelDecorationInjectedTextOptions {
	static from(options) {
		if (options instanceof ModelDecorationInjectedTextOptions) return options;
		return new ModelDecorationInjectedTextOptions(options);
	}
	constructor(options) {
		this.content = options.content || "";
		this.tokens = options.tokens ?? null;
		this.inlineClassName = options.inlineClassName || null;
		this.inlineClassNameAffectsLetterSpacing = options.inlineClassNameAffectsLetterSpacing || false;
		this.widthInEm = options.widthInEm !== void 0 && Number.isFinite(options.widthInEm) && options.widthInEm >= 0 ? options.widthInEm : void 0;
		this.attachedData = options.attachedData || null;
		this.cursorStops = options.cursorStops || null;
	}
};
var ModelDecorationOptions = class ModelDecorationOptions {
	static register(options) {
		return new ModelDecorationOptions(options);
	}
	static createDynamic(options) {
		return new ModelDecorationOptions(options);
	}
	constructor(options) {
		this.description = options.description;
		this.blockClassName = options.blockClassName ? cleanClassName(options.blockClassName) : null;
		this.blockDoesNotCollapse = options.blockDoesNotCollapse ?? null;
		this.blockIsAfterEnd = options.blockIsAfterEnd ?? null;
		this.blockPadding = options.blockPadding ?? null;
		this.stickiness = options.stickiness || 0;
		this.zIndex = options.zIndex || 0;
		this.className = options.className ? cleanClassName(options.className) : null;
		this.shouldFillLineOnLineBreak = options.shouldFillLineOnLineBreak ?? null;
		this.hoverMessage = options.hoverMessage || null;
		this.glyphMarginHoverMessage = options.glyphMarginHoverMessage || null;
		this.lineNumberHoverMessage = options.lineNumberHoverMessage || null;
		this.isWholeLine = options.isWholeLine || false;
		this.lineHeight = options.lineHeight ? Math.min(options.lineHeight, LINE_HEIGHT_CEILING) : null;
		this.fontSize = options.fontSize || null;
		this.affectsFont = !!options.fontSize || !!options.fontFamily || !!options.fontWeight || !!options.fontStyle;
		this.showIfCollapsed = options.showIfCollapsed || false;
		this.collapseOnReplaceEdit = options.collapseOnReplaceEdit || false;
		this.overviewRuler = options.overviewRuler ? new ModelDecorationOverviewRulerOptions(options.overviewRuler) : null;
		this.minimap = options.minimap ? new ModelDecorationMinimapOptions(options.minimap) : null;
		this.glyphMargin = options.glyphMarginClassName ? new ModelDecorationGlyphMarginOptions(options.glyphMargin) : null;
		this.glyphMarginClassName = options.glyphMarginClassName ? cleanClassName(options.glyphMarginClassName) : null;
		this.linesDecorationsClassName = options.linesDecorationsClassName ? cleanClassName(options.linesDecorationsClassName) : null;
		this.lineNumberClassName = options.lineNumberClassName ? cleanClassName(options.lineNumberClassName) : null;
		this.linesDecorationsTooltip = options.linesDecorationsTooltip ? htmlAttributeEncodeValue(options.linesDecorationsTooltip) : null;
		this.firstLineDecorationClassName = options.firstLineDecorationClassName ? cleanClassName(options.firstLineDecorationClassName) : null;
		this.marginClassName = options.marginClassName ? cleanClassName(options.marginClassName) : null;
		this.inlineClassName = options.inlineClassName ? cleanClassName(options.inlineClassName) : null;
		this.inlineClassNameAffectsLetterSpacing = options.inlineClassNameAffectsLetterSpacing || false;
		this.beforeContentClassName = options.beforeContentClassName ? cleanClassName(options.beforeContentClassName) : null;
		this.afterContentClassName = options.afterContentClassName ? cleanClassName(options.afterContentClassName) : null;
		this.after = options.after ? ModelDecorationInjectedTextOptions.from(options.after) : null;
		this.before = options.before ? ModelDecorationInjectedTextOptions.from(options.before) : null;
		this.hideInCommentTokens = options.hideInCommentTokens ?? false;
		this.hideInStringTokens = options.hideInStringTokens ?? false;
		this.textDirection = options.textDirection ?? null;
	}
};
ModelDecorationOptions.EMPTY = ModelDecorationOptions.register({ description: "empty" });
/**
* The order carefully matches the values of the enum.
*/
var TRACKED_RANGE_OPTIONS = [
	ModelDecorationOptions.register({
		description: "tracked-range-always-grows-when-typing-at-edges",
		stickiness: 0
	}),
	ModelDecorationOptions.register({
		description: "tracked-range-never-grows-when-typing-at-edges",
		stickiness: 1
	}),
	ModelDecorationOptions.register({
		description: "tracked-range-grows-only-when-typing-before",
		stickiness: 2
	}),
	ModelDecorationOptions.register({
		description: "tracked-range-grows-only-when-typing-after",
		stickiness: 3
	})
];
function _normalizeOptions(options) {
	if (options instanceof ModelDecorationOptions) return options;
	return ModelDecorationOptions.createDynamic(options);
}
var DidChangeDecorationsEmitter = class extends Disposable {
	constructor(handleBeforeFire) {
		super();
		this.handleBeforeFire = handleBeforeFire;
		this._actual = this._register(new Emitter$1());
		this.event = this._actual.event;
		this._affectedInjectedTextLines = null;
		this._affectedLineHeights = null;
		this._affectedFontLines = null;
		this._deferredCnt = 0;
		this._shouldFireDeferred = false;
		this._affectsMinimap = false;
		this._affectsOverviewRuler = false;
		this._affectsGlyphMargin = false;
		this._affectsLineNumber = false;
	}
	beginDeferredEmit() {
		this._deferredCnt++;
	}
	endDeferredEmit() {
		this._deferredCnt--;
		if (this._deferredCnt === 0) {
			if (this._shouldFireDeferred) this.doFire();
			this._affectedInjectedTextLines?.clear();
			this._affectedInjectedTextLines = null;
			this._affectedLineHeights?.clear();
			this._affectedLineHeights = null;
			this._affectedFontLines?.clear();
			this._affectedFontLines = null;
		}
	}
	recordLineAffectedByInjectedText(lineNumber) {
		if (!this._affectedInjectedTextLines) this._affectedInjectedTextLines = /* @__PURE__ */ new Set();
		this._affectedInjectedTextLines.add(lineNumber);
	}
	recordLineAffectedByLineHeightChange(ownerId, decorationId, lineNumber, lineHeight) {
		if (!this._affectedLineHeights) this._affectedLineHeights = new SetWithKey([], LineHeightChangingDecoration.toKey);
		this._affectedLineHeights.add(new LineHeightChangingDecoration(ownerId, decorationId, lineNumber, lineHeight));
	}
	recordLineAffectedByFontChange(ownerId, decorationId, lineNumber) {
		if (!this._affectedFontLines) this._affectedFontLines = new SetWithKey([], LineFontChangingDecoration.toKey);
		this._affectedFontLines.add(new LineFontChangingDecoration(ownerId, decorationId, lineNumber));
	}
	checkAffectedAndFire(options) {
		this._affectsMinimap ||= !!options.minimap?.position;
		this._affectsOverviewRuler ||= !!options.overviewRuler?.color;
		this._affectsGlyphMargin ||= !!options.glyphMarginClassName;
		this._affectsLineNumber ||= !!options.lineNumberClassName;
		this.tryFire();
	}
	fire() {
		this._affectsMinimap = true;
		this._affectsOverviewRuler = true;
		this._affectsGlyphMargin = true;
		this.tryFire();
	}
	tryFire() {
		if (this._deferredCnt === 0) this.doFire();
		else this._shouldFireDeferred = true;
	}
	doFire() {
		this.handleBeforeFire(this._affectedInjectedTextLines, this._affectedLineHeights, this._affectedFontLines);
		const event = {
			affectsMinimap: this._affectsMinimap,
			affectsOverviewRuler: this._affectsOverviewRuler,
			affectsGlyphMargin: this._affectsGlyphMargin,
			affectsLineNumber: this._affectsLineNumber
		};
		this._shouldFireDeferred = false;
		this._affectsMinimap = false;
		this._affectsOverviewRuler = false;
		this._affectsGlyphMargin = false;
		this._actual.fire(event);
	}
};
var DidChangeContentEmitter = class extends Disposable {
	constructor() {
		super();
		this._emitter = this._register(new Emitter$1());
		this.event = this._emitter.event;
		this._deferredCnt = 0;
		this._deferredEvent = null;
	}
	beginDeferredEmit() {
		this._deferredCnt++;
	}
	endDeferredEmit(resultingSelection = null) {
		this._deferredCnt--;
		if (this._deferredCnt === 0) {
			if (this._deferredEvent !== null) {
				this._deferredEvent.rawContentChangedEvent.resultingSelection = resultingSelection;
				const e = this._deferredEvent;
				this._deferredEvent = null;
				this._emitter.fire(e);
			}
		}
	}
	fire(e) {
		if (this._deferredCnt > 0) {
			if (this._deferredEvent) this._deferredEvent = this._deferredEvent.merge(e);
			else this._deferredEvent = e;
			return;
		}
		this._emitter.fire(e);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/viewModel/monospaceLineBreaksComputer.js
var MonospaceLineBreaksComputerFactory = class MonospaceLineBreaksComputerFactory {
	static create(options) {
		return new MonospaceLineBreaksComputerFactory(options.get(151), options.get(150));
	}
	constructor(breakBeforeChars, breakAfterChars) {
		this.classifier = new WrappingCharacterClassifier(breakBeforeChars, breakAfterChars);
	}
	createLineBreaksComputer(context, fontInfo, tabSize, wrappingColumn, wrappingIndent, wordBreak, wrapOnEscapedLineFeeds, useTwoCellFullwidthCharacters) {
		const lineNumbers = [];
		const previousBreakingData = [];
		return {
			addRequest: (lineNumber, previousLineBreakData) => {
				lineNumbers.push(lineNumber);
				previousBreakingData.push(previousLineBreakData);
			},
			finalize: () => {
				const columnsForFullWidthChar = fontInfo.typicalFullwidthCharacterWidth / fontInfo.typicalHalfwidthCharacterWidth;
				const result = [];
				for (let i = 0, len = lineNumbers.length; i < len; i++) {
					const lineNumber = lineNumbers[i];
					const injectedText = context.getLineInjectedText(lineNumber);
					const lineText = context.getLineContent(lineNumber);
					const previousLineBreakData = previousBreakingData[i];
					const isLineFeedWrappingEnabled = wrapOnEscapedLineFeeds && lineText.includes("\"") && lineText.includes("\\n");
					if (previousLineBreakData && !previousLineBreakData.injectionOptions && !injectedText && !isLineFeedWrappingEnabled) result[i] = createLineBreaksFromPreviousLineBreaks(this.classifier, previousLineBreakData, lineText, tabSize, wrappingColumn, columnsForFullWidthChar, wrappingIndent, wordBreak, useTwoCellFullwidthCharacters);
					else result[i] = createLineBreaks(this.classifier, lineText, injectedText, tabSize, wrappingColumn, columnsForFullWidthChar, fontInfo, wrappingIndent, wordBreak, isLineFeedWrappingEnabled, useTwoCellFullwidthCharacters);
				}
				arrPool1.length = 0;
				arrPool2.length = 0;
				return result;
			}
		};
	}
};
var WrappingCharacterClassifier = class extends CharacterClassifier {
	constructor(BREAK_BEFORE, BREAK_AFTER) {
		super(0);
		for (let i = 0; i < BREAK_BEFORE.length; i++) this.set(BREAK_BEFORE.charCodeAt(i), 1);
		for (let i = 0; i < BREAK_AFTER.length; i++) this.set(BREAK_AFTER.charCodeAt(i), 2);
	}
	get(charCode) {
		if (charCode >= 0 && charCode < 256) return this._asciiMap[charCode];
		else {
			if (charCode >= 12352 && charCode <= 12543 || charCode >= 13312 && charCode <= 19903 || charCode >= 19968 && charCode <= 40959) return 3;
			return this._map.get(charCode) || this._defaultValue;
		}
	}
};
var arrPool1 = [];
var arrPool2 = [];
function createLineBreaksFromPreviousLineBreaks(classifier, previousBreakingData, lineText, tabSize, firstLineBreakColumn, columnsForFullWidthChar, wrappingIndent, wordBreak, useTwoCellFullwidthCharacters) {
	if (firstLineBreakColumn === -1) return null;
	const len = lineText.length;
	if (len <= 1) return null;
	const isKeepAll = wordBreak === "keepAll";
	const prevBreakingOffsets = previousBreakingData.breakOffsets;
	const prevBreakingOffsetsVisibleColumn = previousBreakingData.breakOffsetsVisibleColumn;
	const wrappedTextIndentLength = computeWrappedTextIndentLength(lineText, tabSize, firstLineBreakColumn, fullWidthCharacterColumns(columnsForFullWidthChar, useTwoCellFullwidthCharacters), wrappingIndent);
	const wrappedLineBreakColumn = firstLineBreakColumn - wrappedTextIndentLength;
	const breakingOffsets = arrPool1;
	const breakingOffsetsVisibleColumn = arrPool2;
	let breakingOffsetsCount = 0;
	let lastBreakingOffset = 0;
	let lastBreakingOffsetVisibleColumn = 0;
	let breakingColumn = firstLineBreakColumn;
	const prevLen = prevBreakingOffsets.length;
	let prevIndex = 0;
	if (prevIndex >= 0) {
		let bestDistance = Math.abs(prevBreakingOffsetsVisibleColumn[prevIndex] - breakingColumn);
		while (prevIndex + 1 < prevLen) {
			const distance = Math.abs(prevBreakingOffsetsVisibleColumn[prevIndex + 1] - breakingColumn);
			if (distance >= bestDistance) break;
			bestDistance = distance;
			prevIndex++;
		}
	}
	while (prevIndex < prevLen) {
		let prevBreakOffset = prevIndex < 0 ? 0 : prevBreakingOffsets[prevIndex];
		let prevBreakOffsetVisibleColumn = prevIndex < 0 ? 0 : prevBreakingOffsetsVisibleColumn[prevIndex];
		if (lastBreakingOffset > prevBreakOffset) {
			prevBreakOffset = lastBreakingOffset;
			prevBreakOffsetVisibleColumn = lastBreakingOffsetVisibleColumn;
		}
		let breakOffset = 0;
		let breakOffsetVisibleColumn = 0;
		let forcedBreakOffset = 0;
		let forcedBreakOffsetVisibleColumn = 0;
		if (prevBreakOffsetVisibleColumn <= breakingColumn) {
			let visibleColumn = prevBreakOffsetVisibleColumn;
			let prevCharCode = prevBreakOffset === 0 ? 0 : lineText.charCodeAt(prevBreakOffset - 1);
			let prevCharCodeClass = prevBreakOffset === 0 ? 0 : classifier.get(prevCharCode);
			let entireLineFits = true;
			for (let i = prevBreakOffset; i < len; i++) {
				const charStartOffset = i;
				const charCode = lineText.charCodeAt(i);
				let charCodeClass;
				let charWidth;
				if (isHighSurrogate(charCode)) {
					i++;
					charCodeClass = 0;
					charWidth = 2;
				} else {
					charCodeClass = classifier.get(charCode);
					charWidth = computeCharWidth(charCode, visibleColumn, tabSize, columnsForFullWidthChar, useTwoCellFullwidthCharacters);
				}
				if (charStartOffset > lastBreakingOffset && canBreak(prevCharCode, prevCharCodeClass, charCode, charCodeClass, isKeepAll)) {
					breakOffset = charStartOffset;
					breakOffsetVisibleColumn = visibleColumn;
				}
				visibleColumn += charWidth;
				if (visibleColumn > breakingColumn) {
					if (charStartOffset > lastBreakingOffset) {
						forcedBreakOffset = charStartOffset;
						forcedBreakOffsetVisibleColumn = visibleColumn - charWidth;
					} else {
						forcedBreakOffset = i + 1;
						forcedBreakOffsetVisibleColumn = visibleColumn;
					}
					if (visibleColumn - breakOffsetVisibleColumn > wrappedLineBreakColumn) breakOffset = 0;
					entireLineFits = false;
					break;
				}
				prevCharCode = charCode;
				prevCharCodeClass = charCodeClass;
			}
			if (entireLineFits) {
				if (breakingOffsetsCount > 0) {
					breakingOffsets[breakingOffsetsCount] = prevBreakingOffsets[prevBreakingOffsets.length - 1];
					breakingOffsetsVisibleColumn[breakingOffsetsCount] = prevBreakingOffsetsVisibleColumn[prevBreakingOffsets.length - 1];
					breakingOffsetsCount++;
				}
				break;
			}
		}
		if (breakOffset === 0) {
			let visibleColumn = prevBreakOffsetVisibleColumn;
			let charCode = lineText.charCodeAt(prevBreakOffset);
			let charCodeClass = classifier.get(charCode);
			let hitATabCharacter = false;
			for (let i = prevBreakOffset - 1; i >= lastBreakingOffset; i--) {
				const charStartOffset = i + 1;
				const prevCharCode = lineText.charCodeAt(i);
				if (prevCharCode === 9) {
					hitATabCharacter = true;
					break;
				}
				let prevCharCodeClass;
				let prevCharWidth;
				if (isLowSurrogate(prevCharCode)) {
					i--;
					prevCharCodeClass = 0;
					prevCharWidth = 2;
				} else {
					prevCharCodeClass = classifier.get(prevCharCode);
					prevCharWidth = isFullWidthCharacter(prevCharCode) ? fullWidthCharacterColumns(columnsForFullWidthChar, useTwoCellFullwidthCharacters) : 1;
				}
				if (visibleColumn <= breakingColumn) {
					if (forcedBreakOffset === 0) {
						forcedBreakOffset = charStartOffset;
						forcedBreakOffsetVisibleColumn = visibleColumn;
					}
					if (visibleColumn <= breakingColumn - wrappedLineBreakColumn) break;
					if (canBreak(prevCharCode, prevCharCodeClass, charCode, charCodeClass, isKeepAll)) {
						breakOffset = charStartOffset;
						breakOffsetVisibleColumn = visibleColumn;
						break;
					}
				}
				visibleColumn -= prevCharWidth;
				charCode = prevCharCode;
				charCodeClass = prevCharCodeClass;
			}
			if (breakOffset !== 0) {
				const remainingWidthOfNextLine = wrappedLineBreakColumn - (forcedBreakOffsetVisibleColumn - breakOffsetVisibleColumn);
				if (remainingWidthOfNextLine <= tabSize) {
					const charCodeAtForcedBreakOffset = lineText.charCodeAt(forcedBreakOffset);
					let charWidth;
					if (isHighSurrogate(charCodeAtForcedBreakOffset)) charWidth = 2;
					else charWidth = computeCharWidth(charCodeAtForcedBreakOffset, forcedBreakOffsetVisibleColumn, tabSize, columnsForFullWidthChar, useTwoCellFullwidthCharacters);
					if (remainingWidthOfNextLine - charWidth < 0) breakOffset = 0;
				}
			}
			if (hitATabCharacter) {
				prevIndex--;
				continue;
			}
		}
		if (breakOffset === 0) {
			breakOffset = forcedBreakOffset;
			breakOffsetVisibleColumn = forcedBreakOffsetVisibleColumn;
		}
		if (breakOffset <= lastBreakingOffset) {
			const charCode = lineText.charCodeAt(lastBreakingOffset);
			if (isHighSurrogate(charCode)) {
				breakOffset = lastBreakingOffset + 2;
				breakOffsetVisibleColumn = lastBreakingOffsetVisibleColumn + 2;
			} else {
				breakOffset = lastBreakingOffset + 1;
				breakOffsetVisibleColumn = lastBreakingOffsetVisibleColumn + computeCharWidth(charCode, lastBreakingOffsetVisibleColumn, tabSize, columnsForFullWidthChar, useTwoCellFullwidthCharacters);
			}
		}
		lastBreakingOffset = breakOffset;
		breakingOffsets[breakingOffsetsCount] = breakOffset;
		lastBreakingOffsetVisibleColumn = breakOffsetVisibleColumn;
		breakingOffsetsVisibleColumn[breakingOffsetsCount] = breakOffsetVisibleColumn;
		breakingOffsetsCount++;
		breakingColumn = breakOffsetVisibleColumn + wrappedLineBreakColumn;
		while (prevIndex < 0 || prevIndex < prevLen && prevBreakingOffsetsVisibleColumn[prevIndex] < breakOffsetVisibleColumn) prevIndex++;
		let bestDistance = Math.abs(prevBreakingOffsetsVisibleColumn[prevIndex] - breakingColumn);
		while (prevIndex + 1 < prevLen) {
			const distance = Math.abs(prevBreakingOffsetsVisibleColumn[prevIndex + 1] - breakingColumn);
			if (distance >= bestDistance) break;
			bestDistance = distance;
			prevIndex++;
		}
	}
	if (breakingOffsetsCount === 0) return null;
	breakingOffsets.length = breakingOffsetsCount;
	breakingOffsetsVisibleColumn.length = breakingOffsetsCount;
	arrPool1 = previousBreakingData.breakOffsets;
	arrPool2 = previousBreakingData.breakOffsetsVisibleColumn;
	previousBreakingData.breakOffsets = breakingOffsets;
	previousBreakingData.breakOffsetsVisibleColumn = breakingOffsetsVisibleColumn;
	previousBreakingData.wrappedTextIndentLength = wrappedTextIndentLength;
	return previousBreakingData;
}
function createLineBreaks(classifier, _lineText, injectedTexts, tabSize, firstLineBreakColumn, columnsForFullWidthChar, fontInfo, wrappingIndent, wordBreak, wrapOnEscapedLineFeeds, useTwoCellFullwidthCharacters) {
	const lineText = LineInjectedText.applyInjectedText(_lineText, injectedTexts);
	const fixedWidthRanges = LineInjectedText.getFixedWidthInjectedTextRanges(injectedTexts);
	let injectionOptions;
	let injectionOffsets;
	if (injectedTexts && injectedTexts.length > 0) {
		injectionOptions = injectedTexts.map((t) => t.options);
		injectionOffsets = injectedTexts.map((text) => text.column - 1);
	} else {
		injectionOptions = null;
		injectionOffsets = null;
	}
	if (firstLineBreakColumn === -1) {
		if (!injectionOptions) return null;
		return new ModelLineProjectionData(injectionOffsets, injectionOptions, [lineText.length], [], 0);
	}
	const len = lineText.length;
	if (len <= 1) {
		if (!injectionOptions) return null;
		return new ModelLineProjectionData(injectionOffsets, injectionOptions, [lineText.length], [], 0);
	}
	const isKeepAll = wordBreak === "keepAll";
	const wrappedTextIndentLength = computeWrappedTextIndentLength(lineText, tabSize, firstLineBreakColumn, fullWidthCharacterColumns(columnsForFullWidthChar, useTwoCellFullwidthCharacters), wrappingIndent, fixedWidthRanges);
	const typicalHalfwidthCharacterWidth = fontInfo.typicalHalfwidthCharacterWidth;
	const wrappedLineBreakPixelWidth = (firstLineBreakColumn - wrappedTextIndentLength) * typicalHalfwidthCharacterWidth;
	const breakingOffsets = [];
	const breakingOffsetsVisibleColumn = [];
	let breakingOffsetsCount = 0;
	let breakOffset = 0;
	let breakOffsetVisibleColumn = 0;
	let breakOffsetPixelWidth = 0;
	let breakingPixelWidth = firstLineBreakColumn * typicalHalfwidthCharacterWidth;
	let fixedWidthRangeIndex = 0;
	const firstFixedWidthRange = fixedWidthRanges.length > 0 ? fixedWidthRanges[0] : null;
	const startsWithFixedWidth = firstFixedWidthRange && firstFixedWidthRange.startOffset === 0;
	let prevCharCode;
	let prevCharCodeClass;
	let visibleColumn;
	let currentLinePixelWidth;
	let startOffset;
	if (startsWithFixedWidth) {
		prevCharCode = 0;
		prevCharCodeClass = 0;
		visibleColumn = computeFixedWidthRangeColumnWidth(lineText, firstFixedWidthRange, 0, tabSize, columnsForFullWidthChar, useTwoCellFullwidthCharacters);
		currentLinePixelWidth = firstFixedWidthRange.widthInEm * fontInfo.fontSize;
		startOffset = firstFixedWidthRange.endOffset;
		fixedWidthRangeIndex++;
	} else {
		prevCharCode = lineText.charCodeAt(0);
		visibleColumn = computeCharWidth(prevCharCode, 0, tabSize, columnsForFullWidthChar, useTwoCellFullwidthCharacters);
		currentLinePixelWidth = computeCharPixelWidth(prevCharCode, 0, tabSize, fontInfo, useTwoCellFullwidthCharacters);
		startOffset = 1;
		if (isHighSurrogate(prevCharCode)) {
			visibleColumn += 1;
			currentLinePixelWidth += typicalHalfwidthCharacterWidth;
			prevCharCode = lineText.charCodeAt(1);
			startOffset++;
		}
		prevCharCodeClass = classifier.get(prevCharCode);
	}
	for (let i = startOffset; i < len; i++) {
		const fixedWidthRange = fixedWidthRanges.length > 0 && fixedWidthRangeIndex < fixedWidthRanges.length ? fixedWidthRanges[fixedWidthRangeIndex] : null;
		const charStartOffset = i;
		let charCode = lineText.charCodeAt(i);
		let charCodeClass;
		let charWidth;
		let charPixelWidth;
		let wrapEscapedLineFeed = false;
		if (fixedWidthRange && fixedWidthRange.startOffset === i) {
			charCode = 0;
			charCodeClass = 0;
			charWidth = computeFixedWidthRangeColumnWidth(lineText, fixedWidthRange, visibleColumn, tabSize, columnsForFullWidthChar, useTwoCellFullwidthCharacters);
			charPixelWidth = fixedWidthRange.widthInEm * fontInfo.fontSize;
			i = fixedWidthRange.endOffset - 1;
			fixedWidthRangeIndex++;
		} else if (isHighSurrogate(charCode)) {
			i++;
			charCodeClass = 0;
			charWidth = 2;
			charPixelWidth = 2 * typicalHalfwidthCharacterWidth;
		} else {
			charCodeClass = classifier.get(charCode);
			charWidth = computeCharWidth(charCode, visibleColumn, tabSize, columnsForFullWidthChar, useTwoCellFullwidthCharacters);
			charPixelWidth = computeCharPixelWidth(charCode, visibleColumn, tabSize, fontInfo, useTwoCellFullwidthCharacters);
		}
		if (wrapOnEscapedLineFeeds && isEscapedLineBreakAtPosition(lineText, charStartOffset)) {
			breakOffset = charStartOffset;
			breakOffsetVisibleColumn = visibleColumn;
			breakOffsetPixelWidth = currentLinePixelWidth;
			wrapEscapedLineFeed = true;
		} else if (canBreak(prevCharCode, prevCharCodeClass, charCode, charCodeClass, isKeepAll)) {
			breakOffset = charStartOffset;
			breakOffsetVisibleColumn = visibleColumn;
			breakOffsetPixelWidth = currentLinePixelWidth;
		}
		visibleColumn += charWidth;
		currentLinePixelWidth += charPixelWidth;
		if (currentLinePixelWidth > breakingPixelWidth || wrapEscapedLineFeed) {
			if (breakOffset === 0 || currentLinePixelWidth - breakOffsetPixelWidth > wrappedLineBreakPixelWidth) {
				breakOffset = charStartOffset;
				breakOffsetVisibleColumn = visibleColumn - charWidth;
				breakOffsetPixelWidth = currentLinePixelWidth - charPixelWidth;
			}
			const currentLineStartOffset = breakingOffsetsCount > 0 ? breakingOffsets[breakingOffsetsCount - 1] : 0;
			if (breakOffset > currentLineStartOffset) {
				breakingOffsets[breakingOffsetsCount] = breakOffset;
				breakingOffsetsVisibleColumn[breakingOffsetsCount] = breakOffsetVisibleColumn;
				breakingOffsetsCount++;
				breakingPixelWidth = breakOffsetPixelWidth + wrappedLineBreakPixelWidth;
				breakOffset = 0;
			}
		}
		prevCharCode = charCode;
		prevCharCodeClass = charCodeClass;
	}
	if (breakingOffsetsCount === 0 && (!injectedTexts || injectedTexts.length === 0)) return null;
	breakingOffsets[breakingOffsetsCount] = len;
	breakingOffsetsVisibleColumn[breakingOffsetsCount] = visibleColumn;
	return new ModelLineProjectionData(injectionOffsets, injectionOptions, breakingOffsets, breakingOffsetsVisibleColumn, wrappedTextIndentLength);
}
function computeCharWidth(charCode, visibleColumn, tabSize, columnsForFullWidthChar, useTwoCellFullwidthCharacters) {
	if (charCode === 9) return tabSize - visibleColumn % tabSize;
	if (isFullWidthCharacter(charCode)) return fullWidthCharacterColumns(columnsForFullWidthChar, useTwoCellFullwidthCharacters);
	if (charCode < 32) return columnsForFullWidthChar;
	return 1;
}
/**
* The number of columns a full-width character occupies: exactly two cells when full-width
* characters are forced into two monospace cells, otherwise the ratio measured from the font.
*/
function fullWidthCharacterColumns(columnsForFullWidthChar, useTwoCellFullwidthCharacters) {
	return useTwoCellFullwidthCharacters ? 2 : columnsForFullWidthChar;
}
function tabCharacterWidth(visibleColumn, tabSize) {
	return tabSize - visibleColumn % tabSize;
}
/**
* The width in pixels a character occupies. Used for the wrapping decision, which must reason
* in real widths because injected text can request an arbitrary width via `widthInEm`.
*/
function computeCharPixelWidth(charCode, visibleColumn, tabSize, fontInfo, useTwoCellFullwidthCharacters) {
	if (charCode === 9) return tabCharacterWidth(visibleColumn, tabSize) * fontInfo.typicalHalfwidthCharacterWidth;
	if (isFullWidthCharacter(charCode)) return useTwoCellFullwidthCharacters ? 2 * fontInfo.typicalHalfwidthCharacterWidth : fontInfo.typicalFullwidthCharacterWidth;
	if (charCode < 32) return fontInfo.typicalFullwidthCharacterWidth;
	return fontInfo.typicalHalfwidthCharacterWidth;
}
/**
* The number of columns the characters of a fixed width injected text range occupy, which is 0 for
* a width-only injection. `widthInEm` is deliberately ignored here: `visibleColumn` only drives tab
* expansion, which must stay in sync with the line rendering, and the rendering does not know about
* `widthInEm`.
*/
function computeFixedWidthRangeColumnWidth(lineText, range, visibleColumn, tabSize, columnsForFullWidthChar, useTwoCellFullwidthCharacters) {
	let width = 0;
	for (let i = range.startOffset; i < range.endOffset; i++) width += computeCharWidth(lineText.charCodeAt(i), visibleColumn + width, tabSize, columnsForFullWidthChar, useTwoCellFullwidthCharacters);
	return width;
}
/**
* Checks if the current position in the text should trigger a soft wrap due to escaped line feeds.
* This handles the wrapOnEscapedLineFeeds feature which allows \n sequences in strings to trigger wrapping.
*/
function isEscapedLineBreakAtPosition(lineText, i) {
	if (i >= 2 && lineText.charAt(i - 1) === "n") {
		let escapeCount = 0;
		for (let j = i - 2; j >= 0; j--) if (lineText.charAt(j) === "\\") escapeCount++;
		else return escapeCount % 2 === 1;
	}
	return false;
}
/**
* Kinsoku Shori : Don't break after a leading character, like an open bracket
* Kinsoku Shori : Don't break before a trailing character, like a period
*/
function canBreak(prevCharCode, prevCharCodeClass, charCode, charCodeClass, isKeepAll) {
	return charCode !== 32 && (prevCharCodeClass === 2 && charCodeClass !== 2 || prevCharCodeClass !== 1 && charCodeClass === 1 || !isKeepAll && prevCharCodeClass === 3 && charCodeClass !== 2 || !isKeepAll && charCodeClass === 3 && prevCharCodeClass !== 1);
}
function computeWrappedTextIndentLength(lineText, tabSize, firstLineBreakColumn, columnsForFullWidthChar, wrappingIndent, fixedWidthRanges) {
	let wrappedTextIndentLength = 0;
	if (wrappingIndent !== 0) {
		const firstNonWhitespaceIndex$1 = firstNonWhitespaceIndex(lineText);
		if (firstNonWhitespaceIndex$1 !== -1) {
			for (let i = 0; i < firstNonWhitespaceIndex$1; i++) {
				if (fixedWidthRanges?.[0]?.startOffset === i) break;
				const charWidth = lineText.charCodeAt(i) === 9 ? tabCharacterWidth(wrappedTextIndentLength, tabSize) : 1;
				wrappedTextIndentLength += charWidth;
			}
			const numberOfAdditionalTabs = wrappingIndent === 3 ? 2 : wrappingIndent === 2 ? 1 : 0;
			for (let i = 0; i < numberOfAdditionalTabs; i++) {
				const charWidth = tabCharacterWidth(wrappedTextIndentLength, tabSize);
				wrappedTextIndentLength += charWidth;
			}
			if (wrappedTextIndentLength + columnsForFullWidthChar > firstLineBreakColumn) wrappedTextIndentLength = 0;
		}
	}
	return wrappedTextIndentLength;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/cursor/oneCursor.js
/**
* Represents a single cursor.
*/
var Cursor = class Cursor {
	constructor(context) {
		this._selTrackedRange = null;
		this._trackSelection = true;
		this._setState(context, new SingleCursorState(new Range$2(1, 1, 1, 1), 0, 0, new Position$1(1, 1), 0), new SingleCursorState(new Range$2(1, 1, 1, 1), 0, 0, new Position$1(1, 1), 0));
	}
	dispose(context) {
		this._removeTrackedRange(context);
	}
	startTrackingSelection(context) {
		this._trackSelection = true;
		this._updateTrackedRange(context);
	}
	stopTrackingSelection(context) {
		this._trackSelection = false;
		this._removeTrackedRange(context);
	}
	_updateTrackedRange(context) {
		if (!this._trackSelection) return;
		this._selTrackedRange = context.model._setTrackedRange(this._selTrackedRange, this.modelState.selection, 0);
	}
	_removeTrackedRange(context) {
		this._selTrackedRange = context.model._setTrackedRange(this._selTrackedRange, null, 0);
	}
	asCursorState() {
		return new CursorState(this.modelState, this.viewState);
	}
	readSelectionFromMarkers(context) {
		const range = context.model._getTrackedRange(this._selTrackedRange);
		if (this.modelState.selection.isEmpty() && !range.isEmpty()) return Selection$1.fromRange(range.collapseToEnd(), this.modelState.selection.getDirection());
		return Selection$1.fromRange(range, this.modelState.selection.getDirection());
	}
	ensureValidState(context) {
		this._setState(context, this.modelState, this.viewState);
	}
	setState(context, modelState, viewState) {
		this._setState(context, modelState, viewState);
	}
	static _validatePositionWithCache(viewModel, position, cacheInput, cacheOutput) {
		if (position.equals(cacheInput)) return cacheOutput;
		return viewModel.normalizePosition(position, 2);
	}
	static _validateViewState(viewModel, viewState) {
		const position = viewState.position;
		const sStartPosition = viewState.selectionStart.getStartPosition();
		const sEndPosition = viewState.selectionStart.getEndPosition();
		const validPosition = viewModel.normalizePosition(position, 2);
		const validSStartPosition = this._validatePositionWithCache(viewModel, sStartPosition, position, validPosition);
		const validSEndPosition = this._validatePositionWithCache(viewModel, sEndPosition, sStartPosition, validSStartPosition);
		if (position.equals(validPosition) && sStartPosition.equals(validSStartPosition) && sEndPosition.equals(validSEndPosition)) return viewState;
		return new SingleCursorState(Range$2.fromPositions(validSStartPosition, validSEndPosition), viewState.selectionStartKind, viewState.selectionStartLeftoverVisibleColumns + sStartPosition.column - validSStartPosition.column, validPosition, viewState.leftoverVisibleColumns + position.column - validPosition.column);
	}
	_setState(context, modelState, viewState) {
		if (viewState) viewState = Cursor._validateViewState(context.viewModel, viewState);
		if (!modelState) {
			if (!viewState) return;
			const selectionStart = context.model.validateRange(context.coordinatesConverter.convertViewRangeToModelRange(viewState.selectionStart));
			const position = context.model.validatePosition(context.coordinatesConverter.convertViewPositionToModelPosition(viewState.position));
			modelState = new SingleCursorState(selectionStart, viewState.selectionStartKind, viewState.selectionStartLeftoverVisibleColumns, position, viewState.leftoverVisibleColumns);
		} else {
			const selectionStart = context.model.validateRange(modelState.selectionStart);
			const selectionStartLeftoverVisibleColumns = modelState.selectionStart.equalsRange(selectionStart) ? modelState.selectionStartLeftoverVisibleColumns : 0;
			const position = context.model.validatePosition(modelState.position);
			const leftoverVisibleColumns = modelState.position.equals(position) ? modelState.leftoverVisibleColumns : 0;
			modelState = new SingleCursorState(selectionStart, modelState.selectionStartKind, selectionStartLeftoverVisibleColumns, position, leftoverVisibleColumns);
		}
		if (!viewState) {
			const viewSelectionStart1 = context.coordinatesConverter.convertModelPositionToViewPosition(new Position$1(modelState.selectionStart.startLineNumber, modelState.selectionStart.startColumn));
			const viewSelectionStart2 = context.coordinatesConverter.convertModelPositionToViewPosition(new Position$1(modelState.selectionStart.endLineNumber, modelState.selectionStart.endColumn));
			const viewSelectionStart = new Range$2(viewSelectionStart1.lineNumber, viewSelectionStart1.column, viewSelectionStart2.lineNumber, viewSelectionStart2.column);
			const viewPosition = context.coordinatesConverter.convertModelPositionToViewPosition(modelState.position);
			viewState = new SingleCursorState(viewSelectionStart, modelState.selectionStartKind, modelState.selectionStartLeftoverVisibleColumns, viewPosition, modelState.leftoverVisibleColumns);
		} else {
			const viewSelectionStart = context.coordinatesConverter.validateViewRange(viewState.selectionStart, modelState.selectionStart);
			const viewPosition = context.coordinatesConverter.validateViewPosition(viewState.position, modelState.position);
			viewState = new SingleCursorState(viewSelectionStart, modelState.selectionStartKind, modelState.selectionStartLeftoverVisibleColumns, viewPosition, modelState.leftoverVisibleColumns);
		}
		this.modelState = modelState;
		this.viewState = viewState;
		this._updateTrackedRange(context);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/cursor/cursorCollection.js
var CursorCollection = class {
	constructor(context) {
		this.context = context;
		this.cursors = [new Cursor(context)];
		this.lastAddedCursorIndex = 0;
	}
	dispose() {
		for (const cursor of this.cursors) cursor.dispose(this.context);
	}
	startTrackingSelections() {
		for (const cursor of this.cursors) cursor.startTrackingSelection(this.context);
	}
	stopTrackingSelections() {
		for (const cursor of this.cursors) cursor.stopTrackingSelection(this.context);
	}
	updateContext(context) {
		this.context = context;
	}
	ensureValidState() {
		for (const cursor of this.cursors) cursor.ensureValidState(this.context);
	}
	readSelectionFromMarkers() {
		return this.cursors.map((c) => c.readSelectionFromMarkers(this.context));
	}
	getAll() {
		return this.cursors.map((c) => c.asCursorState());
	}
	getViewPositions() {
		return this.cursors.map((c) => c.viewState.position);
	}
	getTopMostViewPosition() {
		return findFirstMin(this.cursors, compareBy((c) => c.viewState.position, Position$1.compare)).viewState.position;
	}
	getBottomMostViewPosition() {
		return findLastMax(this.cursors, compareBy((c) => c.viewState.position, Position$1.compare)).viewState.position;
	}
	getSelections() {
		return this.cursors.map((c) => c.modelState.selection);
	}
	getViewSelections() {
		return this.cursors.map((c) => c.viewState.selection);
	}
	setSelections(selections) {
		this.setStates(CursorState.fromModelSelections(selections));
	}
	getPrimaryCursor() {
		return this.cursors[0].asCursorState();
	}
	setStates(states) {
		if (states === null) return;
		this.cursors[0].setState(this.context, states[0].modelState, states[0].viewState);
		this._setSecondaryStates(states.slice(1));
	}
	/**
	* Creates or disposes secondary cursors as necessary to match the number of `secondarySelections`.
	*/
	_setSecondaryStates(secondaryStates) {
		const secondaryCursorsLength = this.cursors.length - 1;
		const secondaryStatesLength = secondaryStates.length;
		if (secondaryCursorsLength < secondaryStatesLength) {
			const createCnt = secondaryStatesLength - secondaryCursorsLength;
			for (let i = 0; i < createCnt; i++) this._addSecondaryCursor();
		} else if (secondaryCursorsLength > secondaryStatesLength) {
			const removeCnt = secondaryCursorsLength - secondaryStatesLength;
			for (let i = 0; i < removeCnt; i++) this._removeSecondaryCursor(this.cursors.length - 2);
		}
		for (let i = 0; i < secondaryStatesLength; i++) this.cursors[i + 1].setState(this.context, secondaryStates[i].modelState, secondaryStates[i].viewState);
	}
	killSecondaryCursors() {
		this._setSecondaryStates([]);
	}
	_addSecondaryCursor() {
		this.cursors.push(new Cursor(this.context));
		this.lastAddedCursorIndex = this.cursors.length - 1;
	}
	getLastAddedCursorIndex() {
		if (this.cursors.length === 1 || this.lastAddedCursorIndex === 0) return 0;
		return this.lastAddedCursorIndex;
	}
	_removeSecondaryCursor(removeIndex) {
		if (this.lastAddedCursorIndex >= removeIndex + 1) this.lastAddedCursorIndex--;
		this.cursors[removeIndex + 1].dispose(this.context);
		this.cursors.splice(removeIndex + 1, 1);
	}
	normalize() {
		if (this.cursors.length === 1) return;
		const cursors = this.cursors.slice(0);
		const sortedCursors = [];
		for (let i = 0, len = cursors.length; i < len; i++) sortedCursors.push({
			index: i,
			selection: cursors[i].modelState.selection
		});
		sortedCursors.sort(compareBy((s) => s.selection, Range$2.compareRangesUsingStarts));
		for (let sortedCursorIndex = 0; sortedCursorIndex < sortedCursors.length - 1; sortedCursorIndex++) {
			const current = sortedCursors[sortedCursorIndex];
			const next = sortedCursors[sortedCursorIndex + 1];
			const currentSelection = current.selection;
			const nextSelection = next.selection;
			if (!this.context.cursorConfig.multiCursorMergeOverlapping) continue;
			let shouldMergeCursors;
			if (nextSelection.isEmpty() || currentSelection.isEmpty()) shouldMergeCursors = nextSelection.getStartPosition().isBeforeOrEqual(currentSelection.getEndPosition());
			else shouldMergeCursors = nextSelection.getStartPosition().isBefore(currentSelection.getEndPosition());
			if (shouldMergeCursors) {
				const winnerSortedCursorIndex = current.index < next.index ? sortedCursorIndex : sortedCursorIndex + 1;
				const looserSortedCursorIndex = current.index < next.index ? sortedCursorIndex + 1 : sortedCursorIndex;
				const looserIndex = sortedCursors[looserSortedCursorIndex].index;
				const winnerIndex = sortedCursors[winnerSortedCursorIndex].index;
				const looserSelection = sortedCursors[looserSortedCursorIndex].selection;
				const winnerSelection = sortedCursors[winnerSortedCursorIndex].selection;
				if (!looserSelection.equalsSelection(winnerSelection)) {
					const resultingRange = looserSelection.plusRange(winnerSelection);
					const looserSelectionIsLTR = looserSelection.selectionStartLineNumber === looserSelection.startLineNumber && looserSelection.selectionStartColumn === looserSelection.startColumn;
					const winnerSelectionIsLTR = winnerSelection.selectionStartLineNumber === winnerSelection.startLineNumber && winnerSelection.selectionStartColumn === winnerSelection.startColumn;
					let resultingSelectionIsLTR;
					if (looserIndex === this.lastAddedCursorIndex) {
						resultingSelectionIsLTR = looserSelectionIsLTR;
						this.lastAddedCursorIndex = winnerIndex;
					} else resultingSelectionIsLTR = winnerSelectionIsLTR;
					let resultingSelection;
					if (resultingSelectionIsLTR) resultingSelection = new Selection$1(resultingRange.startLineNumber, resultingRange.startColumn, resultingRange.endLineNumber, resultingRange.endColumn);
					else resultingSelection = new Selection$1(resultingRange.endLineNumber, resultingRange.endColumn, resultingRange.startLineNumber, resultingRange.startColumn);
					sortedCursors[winnerSortedCursorIndex].selection = resultingSelection;
					const resultingState = CursorState.fromModelSelection(resultingSelection);
					cursors[winnerIndex].setState(this.context, resultingState.modelState, resultingState.viewState);
				}
				for (const sortedCursor of sortedCursors) if (sortedCursor.index > looserIndex) sortedCursor.index--;
				cursors.splice(looserIndex, 1);
				sortedCursors.splice(looserSortedCursorIndex, 1);
				this._removeSecondaryCursor(looserIndex - 1);
				sortedCursorIndex--;
			}
		}
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/cursor/cursorContext.js
var CursorContext = class {
	constructor(model, viewModel, coordinatesConverter, cursorConfig) {
		this._cursorContextBrand = void 0;
		this.model = model;
		this.viewModel = viewModel;
		this.coordinatesConverter = coordinatesConverter;
		this.cursorConfig = cursorConfig;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/viewEvents.js
var ViewCompositionStartEvent = class {
	constructor() {
		this.type = 0;
	}
};
var ViewCompositionEndEvent = class {
	constructor() {
		this.type = 1;
	}
};
var ViewConfigurationChangedEvent = class {
	constructor(source) {
		this.type = 2;
		this._source = source;
	}
	hasChanged(id) {
		return this._source.hasChanged(id);
	}
};
var ViewCursorStateChangedEvent = class {
	constructor(selections, modelSelections, reason) {
		this.selections = selections;
		this.modelSelections = modelSelections;
		this.reason = reason;
		this.type = 3;
	}
};
var ViewDecorationsChangedEvent = class {
	constructor(source) {
		this.type = 4;
		if (source) {
			this.affectsMinimap = source.affectsMinimap;
			this.affectsOverviewRuler = source.affectsOverviewRuler;
			this.affectsGlyphMargin = source.affectsGlyphMargin;
			this.affectsLineNumber = source.affectsLineNumber;
		} else {
			this.affectsMinimap = true;
			this.affectsOverviewRuler = true;
			this.affectsGlyphMargin = true;
			this.affectsLineNumber = true;
		}
	}
};
var ViewFlushedEvent = class {
	constructor() {
		this.type = 5;
	}
};
var ViewFocusChangedEvent = class {
	constructor(isFocused) {
		this.type = 6;
		this.isFocused = isFocused;
	}
};
var ViewLanguageConfigurationEvent = class {
	constructor() {
		this.type = 7;
	}
};
var ViewLineMappingChangedEvent = class {
	constructor() {
		this.type = 8;
	}
};
var ViewLinesChangedEvent = class {
	constructor(fromLineNumber, count) {
		this.fromLineNumber = fromLineNumber;
		this.count = count;
		this.type = 9;
	}
};
var ViewLinesDeletedEvent = class {
	constructor(fromLineNumber, toLineNumber) {
		this.type = 10;
		this.fromLineNumber = fromLineNumber;
		this.toLineNumber = toLineNumber;
	}
};
var ViewLinesInsertedEvent = class {
	constructor(fromLineNumber, toLineNumber) {
		this.type = 11;
		this.fromLineNumber = fromLineNumber;
		this.toLineNumber = toLineNumber;
	}
};
var ViewRevealRangeRequestEvent = class {
	constructor(source, minimalReveal, range, selections, verticalType, revealHorizontal, scrollType) {
		this.source = source;
		this.minimalReveal = minimalReveal;
		this.range = range;
		this.selections = selections;
		this.verticalType = verticalType;
		this.revealHorizontal = revealHorizontal;
		this.scrollType = scrollType;
		this.type = 12;
	}
};
var ViewScrollChangedEvent = class {
	constructor(source) {
		this.type = 13;
		this.scrollWidth = source.scrollWidth;
		this.scrollLeft = source.scrollLeft;
		this.scrollHeight = source.scrollHeight;
		this.scrollTop = source.scrollTop;
		this.scrollWidthChanged = source.scrollWidthChanged;
		this.scrollLeftChanged = source.scrollLeftChanged;
		this.scrollHeightChanged = source.scrollHeightChanged;
		this.scrollTopChanged = source.scrollTopChanged;
	}
};
var ViewThemeChangedEvent = class {
	constructor(theme) {
		this.theme = theme;
		this.type = 14;
	}
};
var ViewTokensChangedEvent = class {
	constructor(ranges) {
		this.type = 15;
		this.ranges = ranges;
	}
};
var ViewTokensColorsChangedEvent = class {
	constructor() {
		this.type = 16;
	}
};
var ViewZonesChangedEvent$1 = class {
	constructor() {
		this.type = 17;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/viewModelEventDispatcher.js
var ViewModelEventDispatcher = class extends Disposable {
	constructor() {
		super();
		this._onEvent = this._register(new Emitter$1());
		this.onEvent = this._onEvent.event;
		this._eventHandlers = [];
		this._viewEventQueue = null;
		this._isConsumingViewEventQueue = false;
		this._collector = null;
		this._collectorCnt = 0;
		this._outgoingEvents = [];
	}
	emitOutgoingEvent(e) {
		this._addOutgoingEvent(e);
		this._emitOutgoingEvents();
	}
	_addOutgoingEvent(e) {
		for (let i = 0, len = this._outgoingEvents.length; i < len; i++) {
			const mergeResult = this._outgoingEvents[i].kind === e.kind ? this._outgoingEvents[i].attemptToMerge(e) : null;
			if (mergeResult) {
				this._outgoingEvents[i] = mergeResult;
				return;
			}
		}
		this._outgoingEvents.push(e);
	}
	_emitOutgoingEvents() {
		while (this._outgoingEvents.length > 0) {
			if (this._collector || this._isConsumingViewEventQueue) return;
			const event = this._outgoingEvents.shift();
			if (event.isNoOp()) continue;
			this._onEvent.fire(event);
		}
	}
	addViewEventHandler(eventHandler) {
		for (let i = 0, len = this._eventHandlers.length; i < len; i++) if (this._eventHandlers[i] === eventHandler) console.warn("Detected duplicate listener in ViewEventDispatcher", eventHandler);
		this._eventHandlers.push(eventHandler);
	}
	removeViewEventHandler(eventHandler) {
		for (let i = 0; i < this._eventHandlers.length; i++) if (this._eventHandlers[i] === eventHandler) {
			this._eventHandlers.splice(i, 1);
			break;
		}
	}
	beginEmitViewEvents() {
		this._collectorCnt++;
		if (this._collectorCnt === 1) this._collector = new ViewModelEventsCollector();
		return this._collector;
	}
	endEmitViewEvents() {
		this._collectorCnt--;
		if (this._collectorCnt === 0) {
			const outgoingEvents = this._collector.outgoingEvents;
			const viewEvents = this._collector.viewEvents;
			this._collector = null;
			for (const outgoingEvent of outgoingEvents) this._addOutgoingEvent(outgoingEvent);
			if (viewEvents.length > 0) this._emitMany(viewEvents);
		}
		this._emitOutgoingEvents();
	}
	emitSingleViewEvent(event) {
		try {
			this.beginEmitViewEvents().emitViewEvent(event);
		} finally {
			this.endEmitViewEvents();
		}
	}
	_emitMany(events) {
		if (this._viewEventQueue) this._viewEventQueue = this._viewEventQueue.concat(events);
		else this._viewEventQueue = events;
		if (!this._isConsumingViewEventQueue) this._consumeViewEventQueue();
	}
	_consumeViewEventQueue() {
		try {
			this._isConsumingViewEventQueue = true;
			this._doConsumeQueue();
		} finally {
			this._isConsumingViewEventQueue = false;
		}
	}
	_doConsumeQueue() {
		while (this._viewEventQueue) {
			const events = this._viewEventQueue;
			this._viewEventQueue = null;
			const eventHandlers = this._eventHandlers.slice(0);
			for (const eventHandler of eventHandlers) eventHandler.handleEvents(events);
		}
	}
};
var ViewModelEventsCollector = class {
	constructor() {
		this.viewEvents = [];
		this.outgoingEvents = [];
	}
	emitViewEvent(event) {
		this.viewEvents.push(event);
	}
	emitOutgoingEvent(e) {
		this.outgoingEvents.push(e);
	}
};
var ContentSizeChangedEvent = class ContentSizeChangedEvent {
	constructor(oldContentWidth, oldContentHeight, contentWidth, contentHeight) {
		this.kind = 0;
		this._oldContentWidth = oldContentWidth;
		this._oldContentHeight = oldContentHeight;
		this.contentWidth = contentWidth;
		this.contentHeight = contentHeight;
		this.contentWidthChanged = this._oldContentWidth !== this.contentWidth;
		this.contentHeightChanged = this._oldContentHeight !== this.contentHeight;
	}
	isNoOp() {
		return !this.contentWidthChanged && !this.contentHeightChanged;
	}
	attemptToMerge(other) {
		if (other.kind !== this.kind) return null;
		return new ContentSizeChangedEvent(this._oldContentWidth, this._oldContentHeight, other.contentWidth, other.contentHeight);
	}
};
var FocusChangedEvent = class FocusChangedEvent {
	constructor(oldHasFocus, hasFocus) {
		this.kind = 1;
		this.oldHasFocus = oldHasFocus;
		this.hasFocus = hasFocus;
	}
	isNoOp() {
		return this.oldHasFocus === this.hasFocus;
	}
	attemptToMerge(other) {
		if (other.kind !== this.kind) return null;
		return new FocusChangedEvent(this.oldHasFocus, other.hasFocus);
	}
};
var WidgetFocusChangedEvent = class {
	constructor(oldHasFocus, hasFocus) {
		this.kind = 2;
		this.oldHasFocus = oldHasFocus;
		this.hasFocus = hasFocus;
	}
	isNoOp() {
		return this.oldHasFocus === this.hasFocus;
	}
	attemptToMerge(other) {
		if (other.kind !== this.kind) return null;
		return new FocusChangedEvent(this.oldHasFocus, other.hasFocus);
	}
};
var ScrollChangedEvent = class ScrollChangedEvent {
	constructor(oldScrollWidth, oldScrollLeft, oldScrollHeight, oldScrollTop, scrollWidth, scrollLeft, scrollHeight, scrollTop) {
		this.kind = 3;
		this._oldScrollWidth = oldScrollWidth;
		this._oldScrollLeft = oldScrollLeft;
		this._oldScrollHeight = oldScrollHeight;
		this._oldScrollTop = oldScrollTop;
		this.scrollWidth = scrollWidth;
		this.scrollLeft = scrollLeft;
		this.scrollHeight = scrollHeight;
		this.scrollTop = scrollTop;
		this.scrollWidthChanged = this._oldScrollWidth !== this.scrollWidth;
		this.scrollLeftChanged = this._oldScrollLeft !== this.scrollLeft;
		this.scrollHeightChanged = this._oldScrollHeight !== this.scrollHeight;
		this.scrollTopChanged = this._oldScrollTop !== this.scrollTop;
	}
	isNoOp() {
		return !this.scrollWidthChanged && !this.scrollLeftChanged && !this.scrollHeightChanged && !this.scrollTopChanged;
	}
	attemptToMerge(other) {
		if (other.kind !== this.kind) return null;
		return new ScrollChangedEvent(this._oldScrollWidth, this._oldScrollLeft, this._oldScrollHeight, this._oldScrollTop, other.scrollWidth, other.scrollLeft, other.scrollHeight, other.scrollTop);
	}
};
var ViewZonesChangedEvent = class {
	constructor() {
		this.kind = 4;
	}
	isNoOp() {
		return false;
	}
	attemptToMerge(other) {
		if (other.kind !== this.kind) return null;
		return this;
	}
};
var HiddenAreasChangedEvent = class {
	constructor() {
		this.kind = 5;
	}
	isNoOp() {
		return false;
	}
	attemptToMerge(other) {
		if (other.kind !== this.kind) return null;
		return this;
	}
};
var CursorStateChangedEvent = class CursorStateChangedEvent {
	constructor(oldSelections, selections, oldModelVersionId, modelVersionId, source, reason, reachedMaxCursorCount) {
		this.kind = 7;
		this.oldSelections = oldSelections;
		this.selections = selections;
		this.oldModelVersionId = oldModelVersionId;
		this.modelVersionId = modelVersionId;
		this.source = source;
		this.reason = reason;
		this.reachedMaxCursorCount = reachedMaxCursorCount;
	}
	static _selectionsAreEqual(a, b) {
		if (!a && !b) return true;
		if (!a || !b) return false;
		const aLen = a.length;
		if (aLen !== b.length) return false;
		for (let i = 0; i < aLen; i++) if (!a[i].equalsSelection(b[i])) return false;
		return true;
	}
	isNoOp() {
		return CursorStateChangedEvent._selectionsAreEqual(this.oldSelections, this.selections) && this.oldModelVersionId === this.modelVersionId;
	}
	attemptToMerge(other) {
		if (other.kind !== this.kind) return null;
		return new CursorStateChangedEvent(this.oldSelections, other.selections, this.oldModelVersionId, other.modelVersionId, other.source, other.reason, this.reachedMaxCursorCount || other.reachedMaxCursorCount);
	}
};
var ReadOnlyEditAttemptEvent = class {
	constructor() {
		this.kind = 6;
	}
	isNoOp() {
		return false;
	}
	attemptToMerge(other) {
		if (other.kind !== this.kind) return null;
		return this;
	}
};
var ModelDecorationsChangedEvent = class {
	constructor(event) {
		this.event = event;
		this.kind = 8;
	}
	isNoOp() {
		return false;
	}
	attemptToMerge(other) {
		return null;
	}
};
var ModelLanguageChangedEvent = class {
	constructor(event) {
		this.event = event;
		this.kind = 9;
	}
	isNoOp() {
		return false;
	}
	attemptToMerge(other) {
		return null;
	}
};
var ModelLanguageConfigurationChangedEvent = class {
	constructor(event) {
		this.event = event;
		this.kind = 10;
	}
	isNoOp() {
		return false;
	}
	attemptToMerge(other) {
		return null;
	}
};
var ModelContentChangedEvent = class {
	constructor(event) {
		this.event = event;
		this.kind = 11;
	}
	isNoOp() {
		return false;
	}
	attemptToMerge(other) {
		return null;
	}
};
var ModelOptionsChangedEvent = class {
	constructor(event) {
		this.event = event;
		this.kind = 12;
	}
	isNoOp() {
		return false;
	}
	attemptToMerge(other) {
		return null;
	}
};
var ModelTokensChangedEvent = class {
	constructor(event) {
		this.event = event;
		this.kind = 13;
	}
	isNoOp() {
		return false;
	}
	attemptToMerge(other) {
		return null;
	}
};
var ModelLineHeightChangedEvent = class {
	constructor(event) {
		this.event = event;
		this.kind = 14;
	}
	isNoOp() {
		return false;
	}
	attemptToMerge(other) {
		return null;
	}
};
var ModelFontChangedEvent = class {
	constructor(event) {
		this.event = event;
		this.kind = 15;
	}
	isNoOp() {
		return false;
	}
	attemptToMerge(other) {
		return null;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/cursor/cursor.js
var CursorsController = class extends Disposable {
	constructor(model, viewModel, coordinatesConverter, cursorConfig) {
		super();
		this._model = model;
		this._knownModelVersionId = this._model.getVersionId();
		this._viewModel = viewModel;
		this._coordinatesConverter = coordinatesConverter;
		this.context = new CursorContext(this._model, this._viewModel, this._coordinatesConverter, cursorConfig);
		this._cursors = new CursorCollection(this.context);
		this._hasFocus = false;
		this._isHandling = false;
		this._compositionState = null;
		this._columnSelectData = null;
		this._autoClosedActions = [];
		this._prevEditOperationType = 0;
	}
	dispose() {
		this._cursors.dispose();
		this._autoClosedActions = dispose(this._autoClosedActions);
		super.dispose();
	}
	updateConfiguration(cursorConfig) {
		this.context = new CursorContext(this._model, this._viewModel, this._coordinatesConverter, cursorConfig);
		this._cursors.updateContext(this.context);
	}
	onLineMappingChanged(eventsCollector) {
		if (this._knownModelVersionId !== this._model.getVersionId()) return;
		this.setStates(eventsCollector, "viewModel", 0, this.getCursorStates());
	}
	setHasFocus(hasFocus) {
		this._hasFocus = hasFocus;
	}
	_validateAutoClosedActions() {
		if (this._autoClosedActions.length > 0) {
			const selections = this._cursors.getSelections();
			for (let i = 0; i < this._autoClosedActions.length; i++) {
				const autoClosedAction = this._autoClosedActions[i];
				if (!autoClosedAction.isValid(selections)) {
					autoClosedAction.dispose();
					this._autoClosedActions.splice(i, 1);
					i--;
				}
			}
		}
	}
	getPrimaryCursorState() {
		return this._cursors.getPrimaryCursor();
	}
	getLastAddedCursorIndex() {
		return this._cursors.getLastAddedCursorIndex();
	}
	getCursorStates() {
		return this._cursors.getAll();
	}
	setStates(eventsCollector, source, reason, states) {
		let reachedMaxCursorCount = false;
		const multiCursorLimit = this.context.cursorConfig.multiCursorLimit;
		if (states !== null && states.length > multiCursorLimit) {
			states = states.slice(0, multiCursorLimit);
			reachedMaxCursorCount = true;
		}
		const oldState = CursorModelState.from(this._model, this);
		this._cursors.setStates(states);
		this._cursors.normalize();
		this._columnSelectData = null;
		this._validateAutoClosedActions();
		return this._emitStateChangedIfNecessary(eventsCollector, source, reason, oldState, reachedMaxCursorCount);
	}
	setCursorColumnSelectData(columnSelectData) {
		this._columnSelectData = columnSelectData;
	}
	revealAll(eventsCollector, source, minimalReveal, verticalType, revealHorizontal, scrollType) {
		const viewPositions = this._cursors.getViewPositions();
		let revealViewRange = null;
		let revealViewSelections = null;
		if (viewPositions.length > 1) revealViewSelections = this._cursors.getViewSelections();
		else revealViewRange = Range$2.fromPositions(viewPositions[0], viewPositions[0]);
		eventsCollector.emitViewEvent(new ViewRevealRangeRequestEvent(source, minimalReveal, revealViewRange, revealViewSelections, verticalType, revealHorizontal, scrollType));
	}
	revealPrimary(eventsCollector, source, minimalReveal, verticalType, revealHorizontal, scrollType) {
		const revealViewSelections = [this._cursors.getPrimaryCursor().viewState.selection];
		eventsCollector.emitViewEvent(new ViewRevealRangeRequestEvent(source, minimalReveal, null, revealViewSelections, verticalType, revealHorizontal, scrollType));
	}
	saveState() {
		const result = [];
		const selections = this._cursors.getSelections();
		for (let i = 0, len = selections.length; i < len; i++) {
			const selection = selections[i];
			result.push({
				inSelectionMode: !selection.isEmpty(),
				selectionStart: {
					lineNumber: selection.selectionStartLineNumber,
					column: selection.selectionStartColumn
				},
				position: {
					lineNumber: selection.positionLineNumber,
					column: selection.positionColumn
				}
			});
		}
		return result;
	}
	restoreState(eventsCollector, states) {
		const desiredSelections = [];
		for (let i = 0, len = states.length; i < len; i++) {
			const state = states[i];
			let positionLineNumber = 1;
			let positionColumn = 1;
			if (state.position && state.position.lineNumber) positionLineNumber = state.position.lineNumber;
			if (state.position && state.position.column) positionColumn = state.position.column;
			let selectionStartLineNumber = positionLineNumber;
			let selectionStartColumn = positionColumn;
			if (state.selectionStart && state.selectionStart.lineNumber) selectionStartLineNumber = state.selectionStart.lineNumber;
			if (state.selectionStart && state.selectionStart.column) selectionStartColumn = state.selectionStart.column;
			desiredSelections.push({
				selectionStartLineNumber,
				selectionStartColumn,
				positionLineNumber,
				positionColumn
			});
		}
		this.setStates(eventsCollector, "restoreState", 0, CursorState.fromModelSelections(desiredSelections));
		this.revealAll(eventsCollector, "restoreState", false, 0, true, 1);
	}
	onModelContentChanged(eventsCollector, event) {
		if (event instanceof ModelInjectedTextChangedEvent) {
			if (this._isHandling) return;
			this._isHandling = true;
			try {
				this.setStates(eventsCollector, "modelChange", 0, this.getCursorStates());
			} finally {
				this._isHandling = false;
			}
		} else {
			const e = event.rawContentChangedEvent;
			this._knownModelVersionId = e.versionId;
			if (this._isHandling) return;
			const hadFlushEvent = e.containsEvent(1);
			this._prevEditOperationType = 0;
			if (hadFlushEvent) {
				this._cursors.dispose();
				this._cursors = new CursorCollection(this.context);
				this._validateAutoClosedActions();
				this._emitStateChangedIfNecessary(eventsCollector, "model", 1, null, false);
			} else if (this._hasFocus && e.resultingSelection && e.resultingSelection.length > 0) {
				const cursorState = CursorState.fromModelSelections(e.resultingSelection);
				if (this.setStates(eventsCollector, "modelChange", e.isUndoing ? 5 : e.isRedoing ? 6 : 2, cursorState)) this.revealAll(eventsCollector, "modelChange", false, 0, true, 0);
			} else {
				const selectionsFromMarkers = this._cursors.readSelectionFromMarkers();
				this.setStates(eventsCollector, "modelChange", 2, CursorState.fromModelSelections(selectionsFromMarkers));
			}
		}
	}
	getSelection() {
		return this._cursors.getPrimaryCursor().modelState.selection;
	}
	getTopMostViewPosition() {
		return this._cursors.getTopMostViewPosition();
	}
	getBottomMostViewPosition() {
		return this._cursors.getBottomMostViewPosition();
	}
	getCursorColumnSelectData() {
		if (this._columnSelectData) return this._columnSelectData;
		const primaryCursor = this._cursors.getPrimaryCursor();
		const viewSelectionStart = primaryCursor.viewState.selectionStart.getStartPosition();
		const viewPosition = primaryCursor.viewState.position;
		return {
			isReal: false,
			fromViewLineNumber: viewSelectionStart.lineNumber,
			fromViewVisualColumn: this.context.cursorConfig.visibleColumnFromColumn(this._viewModel, viewSelectionStart),
			toViewLineNumber: viewPosition.lineNumber,
			toViewVisualColumn: this.context.cursorConfig.visibleColumnFromColumn(this._viewModel, viewPosition)
		};
	}
	getSelections() {
		return this._cursors.getSelections();
	}
	setSelections(eventsCollector, source, selections, reason) {
		this.setStates(eventsCollector, source, reason, CursorState.fromModelSelections(selections));
	}
	getPrevEditOperationType() {
		return this._prevEditOperationType;
	}
	setPrevEditOperationType(type) {
		this._prevEditOperationType = type;
	}
	_pushAutoClosedAction(autoClosedCharactersRanges, autoClosedEnclosingRanges) {
		const autoClosedCharactersDeltaDecorations = [];
		const autoClosedEnclosingDeltaDecorations = [];
		for (let i = 0, len = autoClosedCharactersRanges.length; i < len; i++) {
			autoClosedCharactersDeltaDecorations.push({
				range: autoClosedCharactersRanges[i],
				options: {
					description: "auto-closed-character",
					inlineClassName: "auto-closed-character",
					stickiness: 1
				}
			});
			autoClosedEnclosingDeltaDecorations.push({
				range: autoClosedEnclosingRanges[i],
				options: {
					description: "auto-closed-enclosing",
					stickiness: 1
				}
			});
		}
		const autoClosedCharactersDecorations = this._model.deltaDecorations([], autoClosedCharactersDeltaDecorations);
		const autoClosedEnclosingDecorations = this._model.deltaDecorations([], autoClosedEnclosingDeltaDecorations);
		this._autoClosedActions.push(new AutoClosedAction(this._model, autoClosedCharactersDecorations, autoClosedEnclosingDecorations));
	}
	_executeEditOperation(opResult, editReason) {
		if (!opResult) return;
		if (opResult.shouldPushStackElementBefore) this._model.pushStackElement();
		const result = CommandExecutor.executeCommands(this._model, this._cursors.getSelections(), opResult.commands, editReason);
		if (result) {
			this._interpretCommandResult(result);
			const autoClosedCharactersRanges = [];
			const autoClosedEnclosingRanges = [];
			for (let i = 0; i < opResult.commands.length; i++) {
				const command = opResult.commands[i];
				if (command instanceof BaseTypeWithAutoClosingCommand && command.enclosingRange && command.closeCharacterRange) {
					autoClosedCharactersRanges.push(command.closeCharacterRange);
					autoClosedEnclosingRanges.push(command.enclosingRange);
				}
			}
			if (autoClosedCharactersRanges.length > 0) this._pushAutoClosedAction(autoClosedCharactersRanges, autoClosedEnclosingRanges);
			this._prevEditOperationType = opResult.type;
		}
		if (opResult.shouldPushStackElementAfter) this._model.pushStackElement();
	}
	_interpretCommandResult(cursorState) {
		if (!cursorState || cursorState.length === 0) cursorState = this._cursors.readSelectionFromMarkers();
		this._columnSelectData = null;
		this._cursors.setSelections(cursorState);
		this._cursors.normalize();
	}
	_emitStateChangedIfNecessary(eventsCollector, source, reason, oldState, reachedMaxCursorCount) {
		const newState = CursorModelState.from(this._model, this);
		if (newState.equals(oldState)) return false;
		const selections = this._cursors.getSelections();
		const viewSelections = this._cursors.getViewSelections();
		eventsCollector.emitViewEvent(new ViewCursorStateChangedEvent(viewSelections, selections, reason));
		if (!oldState || oldState.cursorState.length !== newState.cursorState.length || newState.cursorState.some((newCursorState, i) => !newCursorState.modelState.equals(oldState.cursorState[i].modelState))) {
			const oldSelections = oldState ? oldState.cursorState.map((s) => s.modelState.selection) : null;
			const oldModelVersionId = oldState ? oldState.modelVersionId : 0;
			eventsCollector.emitOutgoingEvent(new CursorStateChangedEvent(oldSelections, selections, oldModelVersionId, newState.modelVersionId, source || "keyboard", reason, reachedMaxCursorCount));
		}
		return true;
	}
	_findAutoClosingPairs(edits) {
		if (!edits.length) return null;
		const indices = [];
		for (let i = 0, len = edits.length; i < len; i++) {
			const edit = edits[i];
			if (!edit.text || edit.text.indexOf("\n") >= 0) return null;
			const m = edit.text.match(/([)\]}>'"`])([^)\]}>'"`]*)$/);
			if (!m) return null;
			const closeChar = m[1];
			const autoClosingPairsCandidates = this.context.cursorConfig.autoClosingPairs.autoClosingPairsCloseSingleChar.get(closeChar);
			if (!autoClosingPairsCandidates || autoClosingPairsCandidates.length !== 1) return null;
			const openChar = autoClosingPairsCandidates[0].open;
			const closeCharIndex = edit.text.length - m[2].length - 1;
			const openCharIndex = edit.text.lastIndexOf(openChar, closeCharIndex - 1);
			if (openCharIndex === -1) return null;
			indices.push([openCharIndex, closeCharIndex]);
		}
		return indices;
	}
	executeEdits(eventsCollector, source, edits, cursorStateComputer, reason) {
		let autoClosingIndices = null;
		if (source === "snippet") autoClosingIndices = this._findAutoClosingPairs(edits);
		if (autoClosingIndices) edits[0]._isTracked = true;
		const autoClosedCharactersRanges = [];
		const autoClosedEnclosingRanges = [];
		const selections = this._model.pushEditOperations(this.getSelections(), edits, (undoEdits) => {
			if (autoClosingIndices) for (let i = 0, len = autoClosingIndices.length; i < len; i++) {
				const [openCharInnerIndex, closeCharInnerIndex] = autoClosingIndices[i];
				const undoEdit = undoEdits[i];
				const lineNumber = undoEdit.range.startLineNumber;
				const openCharIndex = undoEdit.range.startColumn - 1 + openCharInnerIndex;
				const closeCharIndex = undoEdit.range.startColumn - 1 + closeCharInnerIndex;
				autoClosedCharactersRanges.push(new Range$2(lineNumber, closeCharIndex + 1, lineNumber, closeCharIndex + 2));
				autoClosedEnclosingRanges.push(new Range$2(lineNumber, openCharIndex + 1, lineNumber, closeCharIndex + 2));
			}
			const selections = cursorStateComputer(undoEdits);
			if (selections) this._isHandling = true;
			return selections;
		}, void 0, reason);
		if (selections) {
			this._isHandling = false;
			this.setSelections(eventsCollector, source, selections, 0);
		}
		if (autoClosedCharactersRanges.length > 0) this._pushAutoClosedAction(autoClosedCharactersRanges, autoClosedEnclosingRanges);
	}
	_executeEdit(callback, eventsCollector, source, cursorChangeReason = 0) {
		if (this.context.cursorConfig.readOnly) return;
		const oldState = CursorModelState.from(this._model, this);
		this._cursors.stopTrackingSelections();
		this._isHandling = true;
		try {
			this._cursors.ensureValidState();
			callback();
		} catch (err) {
			onUnexpectedError(err);
		}
		this._isHandling = false;
		this._cursors.startTrackingSelections();
		this._validateAutoClosedActions();
		if (this._emitStateChangedIfNecessary(eventsCollector, source, cursorChangeReason, oldState, false)) this.revealAll(eventsCollector, source, false, 0, true, 0);
	}
	getAutoClosedCharacters() {
		return AutoClosedAction.getAllAutoClosedCharacters(this._autoClosedActions);
	}
	startComposition(eventsCollector) {
		this._compositionState = new CompositionState(this._model, this.getSelections());
	}
	endComposition(eventsCollector, source) {
		const reason = EditSources.cursor({
			kind: "compositionEnd",
			detailedSource: source
		});
		const compositionOutcome = this._compositionState ? this._compositionState.deduceOutcome(this._model, this.getSelections()) : null;
		this._compositionState = null;
		this._executeEdit(() => {
			if (source === "keyboard") this._executeEditOperation(TypeOperations.compositionEndWithInterceptors(this._prevEditOperationType, this.context.cursorConfig, this._model, compositionOutcome, this.getSelections(), this.getAutoClosedCharacters()), reason);
		}, eventsCollector, source);
	}
	type(eventsCollector, text, source) {
		const reason = EditSources.cursor({
			kind: "type",
			detailedSource: source
		});
		this._executeEdit(() => {
			if (source === "keyboard") {
				const len = text.length;
				let offset = 0;
				while (offset < len) {
					const charLength = nextCharLength(text, offset);
					const chr = text.substr(offset, charLength);
					this._executeEditOperation(TypeOperations.typeWithInterceptors(!!this._compositionState, this._prevEditOperationType, this.context.cursorConfig, this._model, this.getSelections(), this.getAutoClosedCharacters(), chr), reason);
					offset += charLength;
				}
			} else this._executeEditOperation(TypeOperations.typeWithoutInterceptors(this._prevEditOperationType, this.context.cursorConfig, this._model, this.getSelections(), text), reason);
		}, eventsCollector, source);
	}
	compositionType(eventsCollector, text, replacePrevCharCnt, replaceNextCharCnt, positionDelta, source) {
		const reason = EditSources.cursor({
			kind: "compositionType",
			detailedSource: source
		});
		if (text.length === 0 && replacePrevCharCnt === 0 && replaceNextCharCnt === 0) {
			if (positionDelta !== 0) {
				const newSelections = this.getSelections().map((selection) => {
					const position = selection.getPosition();
					return new Selection$1(position.lineNumber, position.column + positionDelta, position.lineNumber, position.column + positionDelta);
				});
				this.setSelections(eventsCollector, source, newSelections, 0);
			}
			return;
		}
		this._executeEdit(() => {
			this._executeEditOperation(TypeOperations.compositionType(this._prevEditOperationType, this.context.cursorConfig, this._model, this.getSelections(), text, replacePrevCharCnt, replaceNextCharCnt, positionDelta), reason);
		}, eventsCollector, source);
	}
	paste(eventsCollector, text, pasteOnNewLine, multicursorText, source) {
		const reason = EditSources.cursor({
			kind: "paste",
			detailedSource: source
		});
		this._executeEdit(() => {
			this._executeEditOperation(TypeOperations.paste(this.context.cursorConfig, this._model, this.getSelections(), text, pasteOnNewLine, multicursorText || []), reason);
		}, eventsCollector, source, 4);
	}
	cut(eventsCollector, source) {
		const reason = EditSources.cursor({
			kind: "cut",
			detailedSource: source
		});
		this._executeEdit(() => {
			this._executeEditOperation(DeleteOperations.cut(this.context.cursorConfig, this._model, this.getSelections()), reason);
		}, eventsCollector, source);
	}
	executeCommand(eventsCollector, command, source) {
		const reason = EditSources.cursor({
			kind: "executeCommand",
			detailedSource: source
		});
		this._executeEdit(() => {
			this._cursors.killSecondaryCursors();
			this._executeEditOperation(new EditOperationResult(0, [command], {
				shouldPushStackElementBefore: false,
				shouldPushStackElementAfter: false
			}), reason);
		}, eventsCollector, source);
	}
	executeCommands(eventsCollector, commands, source) {
		const reason = EditSources.cursor({
			kind: "executeCommands",
			detailedSource: source
		});
		this._executeEdit(() => {
			this._executeEditOperation(new EditOperationResult(0, commands, {
				shouldPushStackElementBefore: false,
				shouldPushStackElementAfter: false
			}), reason);
		}, eventsCollector, source);
	}
};
/**
* A snapshot of the cursor and the model state
*/
var CursorModelState = class CursorModelState {
	static from(model, cursor) {
		return new CursorModelState(model.getVersionId(), cursor.getCursorStates());
	}
	constructor(modelVersionId, cursorState) {
		this.modelVersionId = modelVersionId;
		this.cursorState = cursorState;
	}
	equals(other) {
		if (!other) return false;
		if (this.modelVersionId !== other.modelVersionId) return false;
		if (this.cursorState.length !== other.cursorState.length) return false;
		for (let i = 0, len = this.cursorState.length; i < len; i++) if (!this.cursorState[i].equals(other.cursorState[i])) return false;
		return true;
	}
};
var AutoClosedAction = class {
	static getAllAutoClosedCharacters(autoClosedActions) {
		let autoClosedCharacters = [];
		for (const autoClosedAction of autoClosedActions) autoClosedCharacters = autoClosedCharacters.concat(autoClosedAction.getAutoClosedCharactersRanges());
		return autoClosedCharacters;
	}
	constructor(model, autoClosedCharactersDecorations, autoClosedEnclosingDecorations) {
		this._model = model;
		this._autoClosedCharactersDecorations = autoClosedCharactersDecorations;
		this._autoClosedEnclosingDecorations = autoClosedEnclosingDecorations;
	}
	dispose() {
		this._autoClosedCharactersDecorations = this._model.deltaDecorations(this._autoClosedCharactersDecorations, []);
		this._autoClosedEnclosingDecorations = this._model.deltaDecorations(this._autoClosedEnclosingDecorations, []);
	}
	getAutoClosedCharactersRanges() {
		const result = [];
		for (let i = 0; i < this._autoClosedCharactersDecorations.length; i++) {
			const decorationRange = this._model.getDecorationRange(this._autoClosedCharactersDecorations[i]);
			if (decorationRange) result.push(decorationRange);
		}
		return result;
	}
	isValid(selections) {
		const enclosingRanges = [];
		for (let i = 0; i < this._autoClosedEnclosingDecorations.length; i++) {
			const decorationRange = this._model.getDecorationRange(this._autoClosedEnclosingDecorations[i]);
			if (decorationRange) {
				enclosingRanges.push(decorationRange);
				if (decorationRange.startLineNumber !== decorationRange.endLineNumber) return false;
			}
		}
		enclosingRanges.sort(Range$2.compareRangesUsingStarts);
		selections.sort(Range$2.compareRangesUsingStarts);
		for (let i = 0; i < selections.length; i++) {
			if (i >= enclosingRanges.length) return false;
			if (!enclosingRanges[i].strictContainsRange(selections[i])) return false;
		}
		return true;
	}
};
var CommandExecutor = class {
	static executeCommands(model, selectionsBefore, commands, editReason = EditSources.unknown({ name: "executeCommands" })) {
		const ctx = {
			model,
			selectionsBefore,
			trackedRanges: [],
			trackedRangesDirection: []
		};
		const result = this._innerExecuteCommands(ctx, commands, editReason);
		for (let i = 0, len = ctx.trackedRanges.length; i < len; i++) ctx.model._setTrackedRange(ctx.trackedRanges[i], null, 0);
		return result;
	}
	static _innerExecuteCommands(ctx, commands, editReason) {
		if (this._arrayIsEmpty(commands)) return null;
		const commandsData = this._getEditOperations(ctx, commands);
		if (commandsData.operations.length === 0) return null;
		const rawOperations = commandsData.operations;
		const loserCursorsMap = this._getLoserCursorMap(rawOperations);
		if (loserCursorsMap.hasOwnProperty("0")) {
			console.warn("Ignoring commands");
			return null;
		}
		const filteredOperations = [];
		for (let i = 0, len = rawOperations.length; i < len; i++) if (!loserCursorsMap.hasOwnProperty(rawOperations[i].identifier.major.toString())) filteredOperations.push(rawOperations[i]);
		if (commandsData.hadTrackedEditOperation && filteredOperations.length > 0) filteredOperations[0]._isTracked = true;
		let selectionsAfter = ctx.model.pushEditOperations(ctx.selectionsBefore, filteredOperations, (inverseEditOperations) => {
			const groupedInverseEditOperations = [];
			for (let i = 0; i < ctx.selectionsBefore.length; i++) groupedInverseEditOperations[i] = [];
			for (const op of inverseEditOperations) {
				if (!op.identifier) continue;
				groupedInverseEditOperations[op.identifier.major].push(op);
			}
			const minorBasedSorter = (a, b) => {
				return a.identifier.minor - b.identifier.minor;
			};
			const cursorSelections = [];
			for (let i = 0; i < ctx.selectionsBefore.length; i++) if (groupedInverseEditOperations[i].length > 0) {
				groupedInverseEditOperations[i].sort(minorBasedSorter);
				cursorSelections[i] = commands[i].computeCursorState(ctx.model, {
					getInverseEditOperations: () => {
						return groupedInverseEditOperations[i];
					},
					getTrackedSelection: (id) => {
						const idx = parseInt(id, 10);
						const range = ctx.model._getTrackedRange(ctx.trackedRanges[idx]);
						if (ctx.trackedRangesDirection[idx] === 0) return new Selection$1(range.startLineNumber, range.startColumn, range.endLineNumber, range.endColumn);
						return new Selection$1(range.endLineNumber, range.endColumn, range.startLineNumber, range.startColumn);
					}
				});
			} else cursorSelections[i] = ctx.selectionsBefore[i];
			return cursorSelections;
		}, void 0, editReason);
		if (!selectionsAfter) selectionsAfter = ctx.selectionsBefore;
		const losingCursors = [];
		for (const losingCursorIndex in loserCursorsMap) if (loserCursorsMap.hasOwnProperty(losingCursorIndex)) losingCursors.push(parseInt(losingCursorIndex, 10));
		losingCursors.sort((a, b) => {
			return b - a;
		});
		for (const losingCursor of losingCursors) selectionsAfter.splice(losingCursor, 1);
		return selectionsAfter;
	}
	static _arrayIsEmpty(commands) {
		for (let i = 0, len = commands.length; i < len; i++) if (commands[i]) return false;
		return true;
	}
	static _getEditOperations(ctx, commands) {
		let operations = [];
		let hadTrackedEditOperation = false;
		for (let i = 0, len = commands.length; i < len; i++) {
			const command = commands[i];
			if (command) {
				const r = this._getEditOperationsFromCommand(ctx, i, command);
				operations = operations.concat(r.operations);
				hadTrackedEditOperation = hadTrackedEditOperation || r.hadTrackedEditOperation;
			}
		}
		return {
			operations,
			hadTrackedEditOperation
		};
	}
	static _getEditOperationsFromCommand(ctx, majorIdentifier, command) {
		const operations = [];
		let operationMinor = 0;
		const addEditOperation = (range, text, forceMoveMarkers = false) => {
			if (Range$2.isEmpty(range) && text === "") return;
			operations.push({
				identifier: {
					major: majorIdentifier,
					minor: operationMinor++
				},
				range,
				text,
				forceMoveMarkers,
				isAutoWhitespaceEdit: command.insertsAutoWhitespace
			});
		};
		let hadTrackedEditOperation = false;
		const addTrackedEditOperation = (selection, text, forceMoveMarkers) => {
			hadTrackedEditOperation = true;
			addEditOperation(selection, text, forceMoveMarkers);
		};
		const trackSelection = (_selection, trackPreviousOnEmpty) => {
			const selection = Selection$1.liftSelection(_selection);
			let stickiness;
			if (selection.isEmpty()) {
				if (typeof trackPreviousOnEmpty === "boolean") {
					if (trackPreviousOnEmpty) stickiness = 2;
					else stickiness = 3;
				} else {
					const maxLineColumn = ctx.model.getLineMaxColumn(selection.startLineNumber);
					if (selection.startColumn === maxLineColumn) stickiness = 2;
					else stickiness = 3;
				}
			} else stickiness = 1;
			const l = ctx.trackedRanges.length;
			const id = ctx.model._setTrackedRange(null, selection, stickiness);
			ctx.trackedRanges[l] = id;
			ctx.trackedRangesDirection[l] = selection.getDirection();
			return l.toString();
		};
		const editOperationBuilder = {
			addEditOperation,
			addTrackedEditOperation,
			trackSelection
		};
		try {
			command.getEditOperations(ctx.model, editOperationBuilder);
		} catch (e) {
			onUnexpectedError(e);
			return {
				operations: [],
				hadTrackedEditOperation: false
			};
		}
		return {
			operations,
			hadTrackedEditOperation
		};
	}
	static _getLoserCursorMap(operations) {
		operations = operations.slice(0);
		operations.sort((a, b) => {
			return -Range$2.compareRangesUsingEnds(a.range, b.range);
		});
		const loserCursorsMap = {};
		for (let i = 1; i < operations.length; i++) {
			const previousOp = operations[i - 1];
			const currentOp = operations[i];
			if (Range$2.getStartPosition(previousOp.range).isBefore(Range$2.getEndPosition(currentOp.range))) {
				let loserMajor;
				if (previousOp.identifier.major > currentOp.identifier.major) loserMajor = previousOp.identifier.major;
				else loserMajor = currentOp.identifier.major;
				loserCursorsMap[loserMajor.toString()] = true;
				for (let j = 0; j < operations.length; j++) if (operations[j].identifier.major === loserMajor) {
					operations.splice(j, 1);
					if (j < i) i--;
					j--;
				}
				if (i > 0) i--;
			}
		}
		return loserCursorsMap;
	}
};
var CompositionLineState = class {
	constructor(text, lineNumber, startSelectionOffset, endSelectionOffset) {
		this.text = text;
		this.lineNumber = lineNumber;
		this.startSelectionOffset = startSelectionOffset;
		this.endSelectionOffset = endSelectionOffset;
	}
};
var CompositionState = class CompositionState {
	static _capture(textModel, selections) {
		const result = [];
		for (const selection of selections) {
			if (selection.startLineNumber !== selection.endLineNumber) return null;
			const lineNumber = selection.startLineNumber;
			result.push(new CompositionLineState(textModel.getLineContent(lineNumber), lineNumber, selection.startColumn - 1, selection.endColumn - 1));
		}
		return result;
	}
	constructor(textModel, selections) {
		this._original = CompositionState._capture(textModel, selections);
	}
	/**
	* Returns the inserted text during this composition.
	* If the composition resulted in existing text being changed (i.e. not a pure insertion) it returns null.
	*/
	deduceOutcome(textModel, selections) {
		if (!this._original) return null;
		const current = CompositionState._capture(textModel, selections);
		if (!current) return null;
		if (this._original.length !== current.length) return null;
		const result = [];
		for (let i = 0, len = this._original.length; i < len; i++) result.push(CompositionState._deduceOutcome(this._original[i], current[i]));
		return result;
	}
	static _deduceOutcome(original, current) {
		const commonPrefix = Math.min(original.startSelectionOffset, current.startSelectionOffset, commonPrefixLength(original.text, current.text));
		const commonSuffix = Math.min(original.text.length - original.endSelectionOffset, current.text.length - current.endSelectionOffset, commonSuffixLength(original.text, current.text));
		const deletedText = original.text.substring(commonPrefix, original.text.length - commonSuffix);
		const insertedTextStartOffset = commonPrefix;
		const insertedTextEndOffset = current.text.length - commonSuffix;
		const insertedText = current.text.substring(insertedTextStartOffset, insertedTextEndOffset);
		const insertedTextRange = new Range$2(current.lineNumber, insertedTextStartOffset + 1, current.lineNumber, insertedTextEndOffset + 1);
		return new CompositionOutcome(deletedText, original.startSelectionOffset - commonPrefix, original.endSelectionOffset - commonPrefix, insertedText, current.startSelectionOffset - commonPrefix, current.endSelectionOffset - commonPrefix, insertedTextRange);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/languages/textToHtmlTokenizer.js
var fallback = {
	getInitialState: () => NullState,
	tokenizeEncoded: (buffer, hasEOL, state) => nullTokenizeEncoded(0, state)
};
async function tokenizeToString(languageService, text, languageId) {
	if (!languageId) return _tokenizeToString(text, languageService.languageIdCodec, fallback);
	const tokenizationSupport = await TokenizationRegistry.getOrCreate(languageId);
	return _tokenizeToString(text, languageService.languageIdCodec, tokenizationSupport || fallback);
}
function tokenizeLineToHTML(text, viewLineTokens, colorMap, startOffset, endOffset, tabSize, useNbsp) {
	let result = `<div>`;
	let charIndex = 0;
	let width = 0;
	let prevIsSpace = true;
	for (let tokenIndex = 0, tokenCount = viewLineTokens.getCount(); tokenIndex < tokenCount; tokenIndex++) {
		const tokenEndIndex = viewLineTokens.getEndOffset(tokenIndex);
		let partContent = "";
		for (; charIndex < tokenEndIndex && charIndex < endOffset; charIndex++) {
			const charCode = text.charCodeAt(charIndex);
			const isTab = charCode === 9;
			width += isFullWidthCharacter(charCode) ? 2 : isTab ? 0 : 1;
			if (charIndex < startOffset) {
				if (isTab) {
					const remainder = width % tabSize;
					width += remainder === 0 ? tabSize : tabSize - remainder;
				}
				continue;
			}
			switch (charCode) {
				case 9: {
					const remainder = width % tabSize;
					const insertSpacesCount = remainder === 0 ? tabSize : tabSize - remainder;
					width += insertSpacesCount;
					let spacesRemaining = insertSpacesCount;
					while (spacesRemaining > 0) {
						if (useNbsp && prevIsSpace) {
							partContent += "&#160;";
							prevIsSpace = false;
						} else {
							partContent += " ";
							prevIsSpace = true;
						}
						spacesRemaining--;
					}
					break;
				}
				case 60:
					partContent += "&lt;";
					prevIsSpace = false;
					break;
				case 62:
					partContent += "&gt;";
					prevIsSpace = false;
					break;
				case 38:
					partContent += "&amp;";
					prevIsSpace = false;
					break;
				case 0:
					partContent += "&#00;";
					prevIsSpace = false;
					break;
				case 65279:
				case 8232:
				case 8233:
				case 133:
					partContent += "�";
					prevIsSpace = false;
					break;
				case 13:
					partContent += "&#8203";
					prevIsSpace = false;
					break;
				case 32:
					if (useNbsp && prevIsSpace) {
						partContent += "&#160;";
						prevIsSpace = false;
					} else {
						partContent += " ";
						prevIsSpace = true;
					}
					break;
				default:
					partContent += String.fromCharCode(charCode);
					prevIsSpace = false;
			}
		}
		if (tokenEndIndex <= startOffset) continue;
		result += `<span style="${viewLineTokens.getInlineStyle(tokenIndex, colorMap)}">${partContent}</span>`;
		if (tokenEndIndex > endOffset || charIndex >= endOffset || startOffset >= endOffset) break;
	}
	result += `</div>`;
	return result;
}
function _tokenizeToString(text, languageIdCodec, tokenizationSupport) {
	let result = `<div class="monaco-tokenized-source">`;
	const lines = splitLines(text);
	let currentState = tokenizationSupport.getInitialState();
	for (let i = 0, len = lines.length; i < len; i++) {
		const line = lines[i];
		if (i > 0) result += `<br/>`;
		const tokenizationResult = tokenizationSupport.tokenizeEncoded(line, true, currentState);
		LineTokens.convertToEndOffset(tokenizationResult.tokens, line.length);
		const viewLineTokens = new LineTokens(tokenizationResult.tokens, line, languageIdCodec).inflate();
		let startOffset = 0;
		for (let j = 0, lenJ = viewLineTokens.getCount(); j < lenJ; j++) {
			const type = viewLineTokens.getClassName(j);
			const endIndex = viewLineTokens.getEndOffset(j);
			result += `<span class="${type}">${escape$2(line.substring(startOffset, endIndex))}</span>`;
			startOffset = endIndex;
		}
		currentState = tokenizationResult.endState;
	}
	result += `</div>`;
	return result;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/viewLayout/lineHeights.js
var CustomLine = class {
	constructor(decorationId, index, lineNumber, specialHeight, prefixSum) {
		this.decorationId = decorationId;
		this.index = index;
		this.lineNumber = lineNumber;
		this.specialHeight = Math.round(specialHeight);
		this.prefixSum = prefixSum;
		this.maximumSpecialHeight = Math.round(specialHeight);
		this.deleted = false;
	}
};
/**
* Manages line heights in the editor with support for custom line heights from decorations.
*
* This class maintains an ordered collection of line heights, where each line can have either
* the default height or a custom height specified by decorations. It supports efficient querying
* of individual line heights as well as accumulated heights up to a specific line.
*
* Line heights are stored in a sorted array for efficient binary search operations. Each line
* with custom height is represented by a {@link CustomLine} object which tracks its special height,
* accumulated height prefix sum, and associated decoration ID.
*
* The class optimizes performance by:
* - Using binary search to locate lines in the ordered array
* - Batching updates through a pending changes mechanism
* - Computing prefix sums for O(1) accumulated height lookup
* - Tracking maximum height for lines with multiple decorations
* - Efficiently handling document changes (line insertions and deletions)
*
* When lines are inserted or deleted, the manager updates line numbers and prefix sums
* for all affected lines. It also handles special cases like decorations that span
* the insertion/deletion points by re-applying those decorations appropriately.
*
* All query operations automatically commit pending changes to ensure consistent results.
* Clients can modify line heights by adding or removing custom line height decorations,
* which are tracked by their unique decoration IDs.
*/
var LineHeightsManager = class {
	constructor(defaultLineHeight, customLineHeightData) {
		this._decorationIDToCustomLine = new ArrayMap();
		this._orderedCustomLines = [];
		this._pendingChanges = [];
		this._invalidIndex = Infinity;
		this._hasPending = false;
		this._defaultLineHeight = defaultLineHeight;
		for (const data of customLineHeightData) this.insertOrChangeCustomLineHeight(data.decorationId, data.startLineNumber, data.endLineNumber, data.lineHeight);
	}
	set defaultLineHeight(defaultLineHeight) {
		this._defaultLineHeight = defaultLineHeight;
	}
	get defaultLineHeight() {
		return this._defaultLineHeight;
	}
	removeCustomLineHeight(decorationID) {
		this._pendingChanges.push({
			kind: 1,
			decorationId: decorationID
		});
		this._hasPending = true;
	}
	insertOrChangeCustomLineHeight(decorationId, startLineNumber, endLineNumber, lineHeight) {
		this._pendingChanges.push({
			kind: 0,
			decorationId,
			startLineNumber,
			endLineNumber,
			lineHeight
		});
		this._hasPending = true;
	}
	heightForLineNumber(lineNumber) {
		this._commit();
		const searchIndex = this._binarySearchOverOrderedCustomLinesArray(lineNumber);
		if (searchIndex >= 0) return this._orderedCustomLines[searchIndex].maximumSpecialHeight;
		return this._defaultLineHeight;
	}
	getAccumulatedLineHeightsIncludingLineNumber(lineNumber) {
		this._commit();
		const searchIndex = this._binarySearchOverOrderedCustomLinesArray(lineNumber);
		if (searchIndex >= 0) return this._orderedCustomLines[searchIndex].prefixSum + this._orderedCustomLines[searchIndex].maximumSpecialHeight;
		if (searchIndex === -1) return this._defaultLineHeight * lineNumber;
		const modifiedIndex = -(searchIndex + 1);
		const previousSpecialLine = this._orderedCustomLines[modifiedIndex - 1];
		return previousSpecialLine.prefixSum + previousSpecialLine.maximumSpecialHeight + this._defaultLineHeight * (lineNumber - previousSpecialLine.lineNumber);
	}
	onLinesDeleted(fromLineNumber, toLineNumber) {
		this._pendingChanges.push({
			kind: 2,
			fromLineNumber,
			toLineNumber
		});
		this._hasPending = true;
	}
	onLinesInserted(fromLineNumber, toLineNumber) {
		this._pendingChanges.push({
			kind: 3,
			fromLineNumber,
			toLineNumber
		});
		this._hasPending = true;
	}
	_commit() {
		if (!this._hasPending) return;
		const changes = this._pendingChanges;
		this._pendingChanges = [];
		this._hasPending = false;
		const stagedInserts = [];
		const stagedIdMap = new ArrayMap();
		for (const change of changes) switch (change.kind) {
			case 1:
				this._doRemoveCustomLineHeight(change.decorationId, stagedIdMap);
				break;
			case 0:
				this._doInsertOrChangeCustomLineHeight(change.decorationId, change.startLineNumber, change.endLineNumber, change.lineHeight, stagedInserts, stagedIdMap);
				break;
			case 2:
				this._flushStagedDecorationChanges(stagedInserts, stagedIdMap);
				this._doLinesDeleted(change.fromLineNumber, change.toLineNumber);
				break;
			case 3:
				this._flushStagedDecorationChanges(stagedInserts, stagedIdMap);
				this._doLinesInserted(change.fromLineNumber, change.toLineNumber, stagedInserts, stagedIdMap);
		}
		this._flushStagedDecorationChanges(stagedInserts, stagedIdMap);
	}
	_doRemoveCustomLineHeight(decorationID, stagedIdMap) {
		const customLines = this._decorationIDToCustomLine.get(decorationID);
		if (customLines) {
			this._decorationIDToCustomLine.delete(decorationID);
			for (const customLine of customLines) {
				customLine.deleted = true;
				this._invalidIndex = Math.min(this._invalidIndex, customLine.index);
			}
		}
		const stagedLines = stagedIdMap.get(decorationID);
		if (stagedLines) {
			stagedIdMap.delete(decorationID);
			for (const line of stagedLines) line.deleted = true;
		}
	}
	_doInsertOrChangeCustomLineHeight(decorationId, startLineNumber, endLineNumber, lineHeight, stagedInserts, stagedIdMap) {
		this._doRemoveCustomLineHeight(decorationId, stagedIdMap);
		for (let lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++) {
			const customLine = new CustomLine(decorationId, -1, lineNumber, lineHeight, 0);
			stagedInserts.push(customLine);
			stagedIdMap.add(decorationId, customLine);
		}
	}
	_flushStagedDecorationChanges(stagedInserts, stagedIdMap) {
		if (stagedInserts.length === 0 && this._invalidIndex === Infinity) return;
		for (const pendingChange of stagedInserts) {
			if (pendingChange.deleted) continue;
			const candidateInsertionIndex = this._binarySearchOverOrderedCustomLinesArray(pendingChange.lineNumber);
			const insertionIndex = candidateInsertionIndex >= 0 ? candidateInsertionIndex : -(candidateInsertionIndex + 1);
			this._orderedCustomLines.splice(insertionIndex, 0, pendingChange);
			this._invalidIndex = Math.min(this._invalidIndex, insertionIndex);
		}
		stagedInserts.length = 0;
		stagedIdMap.clear();
		if (this._invalidIndex === Infinity) return;
		const newDecorationIDToSpecialLine = new ArrayMap();
		const newOrderedSpecialLines = [];
		for (let i = 0; i < this._invalidIndex; i++) {
			const customLine = this._orderedCustomLines[i];
			newOrderedSpecialLines.push(customLine);
			newDecorationIDToSpecialLine.add(customLine.decorationId, customLine);
		}
		let numberOfDeletions = 0;
		let previousSpecialLine = this._invalidIndex > 0 ? newOrderedSpecialLines[this._invalidIndex - 1] : void 0;
		for (let i = this._invalidIndex; i < this._orderedCustomLines.length; i++) {
			const customLine = this._orderedCustomLines[i];
			if (customLine.deleted) {
				numberOfDeletions++;
				continue;
			}
			customLine.index = i - numberOfDeletions;
			if (previousSpecialLine && previousSpecialLine.lineNumber === customLine.lineNumber) {
				customLine.maximumSpecialHeight = previousSpecialLine.maximumSpecialHeight;
				customLine.prefixSum = previousSpecialLine.prefixSum;
			} else {
				let maximumSpecialHeight = customLine.specialHeight;
				for (let j = i; j < this._orderedCustomLines.length; j++) {
					const nextSpecialLine = this._orderedCustomLines[j];
					if (nextSpecialLine.deleted) continue;
					if (nextSpecialLine.lineNumber !== customLine.lineNumber) break;
					maximumSpecialHeight = Math.max(maximumSpecialHeight, nextSpecialLine.specialHeight);
				}
				customLine.maximumSpecialHeight = maximumSpecialHeight;
				let prefixSum;
				if (previousSpecialLine) prefixSum = previousSpecialLine.prefixSum + previousSpecialLine.maximumSpecialHeight + this._defaultLineHeight * (customLine.lineNumber - previousSpecialLine.lineNumber - 1);
				else prefixSum = this._defaultLineHeight * (customLine.lineNumber - 1);
				customLine.prefixSum = prefixSum;
			}
			previousSpecialLine = customLine;
			newOrderedSpecialLines.push(customLine);
			newDecorationIDToSpecialLine.add(customLine.decorationId, customLine);
		}
		this._orderedCustomLines = newOrderedSpecialLines;
		this._decorationIDToCustomLine = newDecorationIDToSpecialLine;
		this._invalidIndex = Infinity;
	}
	_doLinesDeleted(fromLineNumber, toLineNumber) {
		const deleteCount = toLineNumber - fromLineNumber + 1;
		const numberOfCustomLines = this._orderedCustomLines.length;
		const candidateStartIndexOfDeletion = this._binarySearchOverOrderedCustomLinesArray(fromLineNumber);
		let startIndexOfDeletion;
		if (candidateStartIndexOfDeletion >= 0) {
			startIndexOfDeletion = candidateStartIndexOfDeletion;
			for (let i = candidateStartIndexOfDeletion - 1; i >= 0; i--) if (this._orderedCustomLines[i].lineNumber === fromLineNumber) startIndexOfDeletion--;
			else break;
		} else startIndexOfDeletion = candidateStartIndexOfDeletion === -(numberOfCustomLines + 1) && candidateStartIndexOfDeletion !== -1 ? numberOfCustomLines - 1 : -(candidateStartIndexOfDeletion + 1);
		const candidateEndIndexOfDeletion = this._binarySearchOverOrderedCustomLinesArray(toLineNumber);
		let endIndexOfDeletion;
		if (candidateEndIndexOfDeletion >= 0) {
			endIndexOfDeletion = candidateEndIndexOfDeletion;
			for (let i = candidateEndIndexOfDeletion + 1; i < numberOfCustomLines; i++) if (this._orderedCustomLines[i].lineNumber === toLineNumber) endIndexOfDeletion++;
			else break;
		} else endIndexOfDeletion = candidateEndIndexOfDeletion === -(numberOfCustomLines + 1) && candidateEndIndexOfDeletion !== -1 ? numberOfCustomLines - 1 : -(candidateEndIndexOfDeletion + 1);
		const isEndIndexBiggerThanStartIndex = endIndexOfDeletion > startIndexOfDeletion;
		const isEndIndexEqualToStartIndexAndCoversCustomLine = endIndexOfDeletion === startIndexOfDeletion && this._orderedCustomLines[startIndexOfDeletion] && this._orderedCustomLines[startIndexOfDeletion].lineNumber >= fromLineNumber && this._orderedCustomLines[startIndexOfDeletion].lineNumber <= toLineNumber;
		if (isEndIndexBiggerThanStartIndex || isEndIndexEqualToStartIndexAndCoversCustomLine) {
			let maximumSpecialHeightOnDeletedInterval = 0;
			for (let i = startIndexOfDeletion; i <= endIndexOfDeletion; i++) maximumSpecialHeightOnDeletedInterval = Math.max(maximumSpecialHeightOnDeletedInterval, this._orderedCustomLines[i].maximumSpecialHeight);
			let prefixSumOnDeletedInterval = 0;
			if (startIndexOfDeletion > 0) {
				const previousSpecialLine = this._orderedCustomLines[startIndexOfDeletion - 1];
				prefixSumOnDeletedInterval = previousSpecialLine.prefixSum + previousSpecialLine.maximumSpecialHeight + this._defaultLineHeight * (fromLineNumber - previousSpecialLine.lineNumber - 1);
			} else prefixSumOnDeletedInterval = fromLineNumber > 0 ? (fromLineNumber - 1) * this._defaultLineHeight : 0;
			const firstSpecialLineDeleted = this._orderedCustomLines[startIndexOfDeletion];
			const lastSpecialLineDeleted = this._orderedCustomLines[endIndexOfDeletion];
			const firstSpecialLineAfterDeletion = this._orderedCustomLines[endIndexOfDeletion + 1];
			const heightOfFirstLineAfterDeletion = firstSpecialLineAfterDeletion && firstSpecialLineAfterDeletion.lineNumber === toLineNumber + 1 ? firstSpecialLineAfterDeletion.maximumSpecialHeight : this._defaultLineHeight;
			const totalHeightDeleted = lastSpecialLineDeleted.prefixSum + lastSpecialLineDeleted.maximumSpecialHeight - firstSpecialLineDeleted.prefixSum + this._defaultLineHeight * (toLineNumber - lastSpecialLineDeleted.lineNumber) + this._defaultLineHeight * (firstSpecialLineDeleted.lineNumber - fromLineNumber) + heightOfFirstLineAfterDeletion - maximumSpecialHeightOnDeletedInterval;
			const decorationIdsSeen = /* @__PURE__ */ new Set();
			const newOrderedCustomLines = [];
			const newDecorationIDToSpecialLine = new ArrayMap();
			let numberOfDeletions = 0;
			for (let i = 0; i < this._orderedCustomLines.length; i++) {
				const customLine = this._orderedCustomLines[i];
				if (i < startIndexOfDeletion) {
					newOrderedCustomLines.push(customLine);
					newDecorationIDToSpecialLine.add(customLine.decorationId, customLine);
				} else if (i >= startIndexOfDeletion && i <= endIndexOfDeletion) {
					const decorationId = customLine.decorationId;
					if (!decorationIdsSeen.has(decorationId)) {
						customLine.index -= numberOfDeletions;
						customLine.lineNumber = fromLineNumber;
						customLine.prefixSum = prefixSumOnDeletedInterval;
						customLine.maximumSpecialHeight = maximumSpecialHeightOnDeletedInterval;
						newOrderedCustomLines.push(customLine);
						newDecorationIDToSpecialLine.add(customLine.decorationId, customLine);
					} else numberOfDeletions++;
				} else if (i > endIndexOfDeletion) {
					customLine.index -= numberOfDeletions;
					customLine.lineNumber -= deleteCount;
					customLine.prefixSum -= totalHeightDeleted;
					newOrderedCustomLines.push(customLine);
					newDecorationIDToSpecialLine.add(customLine.decorationId, customLine);
				}
				decorationIdsSeen.add(customLine.decorationId);
			}
			this._orderedCustomLines = newOrderedCustomLines;
			this._decorationIDToCustomLine = newDecorationIDToSpecialLine;
		} else {
			const totalHeightDeleted = deleteCount * this._defaultLineHeight;
			for (let i = endIndexOfDeletion; i < this._orderedCustomLines.length; i++) {
				const customLine = this._orderedCustomLines[i];
				if (customLine.lineNumber > toLineNumber) {
					customLine.lineNumber -= deleteCount;
					customLine.prefixSum -= totalHeightDeleted;
				}
			}
		}
	}
	_doLinesInserted(fromLineNumber, toLineNumber, stagedInserts, stagedIdMap) {
		const insertCount = toLineNumber - fromLineNumber + 1;
		const candidateStartIndexOfInsertion = this._binarySearchOverOrderedCustomLinesArray(fromLineNumber);
		let startIndexOfInsertion;
		if (candidateStartIndexOfInsertion >= 0) {
			startIndexOfInsertion = candidateStartIndexOfInsertion;
			for (let i = candidateStartIndexOfInsertion - 1; i >= 0; i--) if (this._orderedCustomLines[i].lineNumber === fromLineNumber) startIndexOfInsertion--;
			else break;
		} else startIndexOfInsertion = -(candidateStartIndexOfInsertion + 1);
		const toReAdd = [];
		const decorationsImmediatelyAfter = /* @__PURE__ */ new Set();
		for (let i = startIndexOfInsertion; i < this._orderedCustomLines.length; i++) if (this._orderedCustomLines[i].lineNumber === fromLineNumber) decorationsImmediatelyAfter.add(this._orderedCustomLines[i].decorationId);
		const decorationsImmediatelyBefore = /* @__PURE__ */ new Set();
		for (let i = startIndexOfInsertion - 1; i >= 0; i--) if (this._orderedCustomLines[i].lineNumber === fromLineNumber - 1) decorationsImmediatelyBefore.add(this._orderedCustomLines[i].decorationId);
		const decorationsWithGaps = intersection(decorationsImmediatelyBefore, decorationsImmediatelyAfter);
		const prefixSumToAdd = insertCount * this._defaultLineHeight;
		for (let i = startIndexOfInsertion; i < this._orderedCustomLines.length; i++) {
			this._orderedCustomLines[i].lineNumber += insertCount;
			this._orderedCustomLines[i].prefixSum += prefixSumToAdd;
		}
		if (decorationsWithGaps.size > 0) {
			for (const decorationId of decorationsWithGaps) {
				const decoration = this._decorationIDToCustomLine.get(decorationId);
				if (decoration) {
					const startLineNumber = decoration.reduce((min, l) => Math.min(min, l.lineNumber), fromLineNumber);
					const endLineNumber = decoration.reduce((max, l) => Math.max(max, l.lineNumber), fromLineNumber);
					const lineHeight = decoration.reduce((max, l) => Math.max(max, l.specialHeight), 0);
					toReAdd.push({
						decorationId,
						startLineNumber,
						endLineNumber,
						lineHeight
					});
				}
			}
			for (const dec of toReAdd) this._doInsertOrChangeCustomLineHeight(dec.decorationId, dec.startLineNumber, dec.endLineNumber, dec.lineHeight, stagedInserts, stagedIdMap);
		}
	}
	_binarySearchOverOrderedCustomLinesArray(lineNumber) {
		return binarySearch2(this._orderedCustomLines.length, (index) => {
			const line = this._orderedCustomLines[index];
			if (line.lineNumber === lineNumber) return 0;
			else if (line.lineNumber < lineNumber) return -1;
			else return 1;
		});
	}
};
var CustomLineHeightData = class CustomLineHeightData {
	constructor(decorationId, startLineNumber, endLineNumber, lineHeight) {
		this.decorationId = decorationId;
		this.startLineNumber = startLineNumber;
		this.endLineNumber = endLineNumber;
		this.lineHeight = lineHeight;
	}
	static fromDecorations(decorations, coordinatesConverter, configuration) {
		const defaultLineHeight = configuration.options.get(75);
		return decorations.map((d) => {
			const viewRange = coordinatesConverter.convertModelRangeToViewRange(d.range);
			return new CustomLineHeightData(d.id, viewRange.startLineNumber, viewRange.endLineNumber, d.options.lineHeight ? d.options.lineHeight * defaultLineHeight : 0);
		});
	}
};
var ArrayMap = class {
	constructor() {
		this._map = /* @__PURE__ */ new Map();
	}
	add(key, value) {
		const array = this._map.get(key);
		if (!array) this._map.set(key, [value]);
		else array.push(value);
	}
	get(key) {
		return this._map.get(key);
	}
	delete(key) {
		this._map.delete(key);
	}
	clear() {
		this._map.clear();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/viewLayout/linesLayout.js
var PendingChanges = class {
	constructor() {
		this._hasPending = false;
		this._inserts = [];
		this._changes = [];
		this._removes = [];
	}
	insert(x) {
		this._hasPending = true;
		this._inserts.push(x);
	}
	change(x) {
		this._hasPending = true;
		this._changes.push(x);
	}
	remove(x) {
		this._hasPending = true;
		this._removes.push(x);
	}
	commit(linesLayout) {
		if (!this._hasPending) return;
		const inserts = this._inserts;
		const changes = this._changes;
		const removes = this._removes;
		this._hasPending = false;
		this._inserts = [];
		this._changes = [];
		this._removes = [];
		linesLayout._commitPendingChanges(inserts, changes, removes);
	}
};
var EditorWhitespace = class {
	constructor(id, afterLineNumber, ordinal, height, minWidth) {
		this.id = id;
		this.afterLineNumber = afterLineNumber;
		this.ordinal = ordinal;
		this.height = height;
		this.minWidth = minWidth;
		this.prefixSum = 0;
	}
};
/**
* Layouting of objects that take vertical space (by having a height) and push down other objects.
*
* These objects are basically either text (lines) or spaces between those lines (whitespaces).
* This provides commodity operations for working with lines that contain whitespace that pushes lines lower (vertically).
*/
var LinesLayout$1 = class LinesLayout$1 {
	static {
		this.INSTANCE_COUNT = 0;
	}
	constructor(lineCount, defaultLineHeight, paddingTop, paddingBottom, customLineHeightData) {
		this._instanceId = singleLetterHash(++LinesLayout$1.INSTANCE_COUNT);
		this._pendingChanges = new PendingChanges();
		this._lastWhitespaceId = 0;
		this._arr = [];
		this._prefixSumValidIndex = -1;
		this._minWidth = -1;
		this._lineCount = lineCount;
		this._paddingTop = paddingTop;
		this._paddingBottom = paddingBottom;
		this._lineHeightsManager = new LineHeightsManager(defaultLineHeight, customLineHeightData);
	}
	/**
	* Find the insertion index for a new value inside a sorted array of values.
	* If the value is already present in the sorted array, the insertion index will be after the already existing value.
	*/
	static findInsertionIndex(arr, afterLineNumber, ordinal) {
		let low = 0;
		let high = arr.length;
		while (low < high) {
			const mid = low + high >>> 1;
			if (afterLineNumber === arr[mid].afterLineNumber) {
				if (ordinal < arr[mid].ordinal) high = mid;
				else low = mid + 1;
			} else if (afterLineNumber < arr[mid].afterLineNumber) high = mid;
			else low = mid + 1;
		}
		return low;
	}
	/**
	* Change the height of a line in pixels.
	*/
	setDefaultLineHeight(lineHeight) {
		this._lineHeightsManager.defaultLineHeight = lineHeight;
	}
	/**
	* Changes the padding used to calculate vertical offsets.
	*/
	setPadding(paddingTop, paddingBottom) {
		this._paddingTop = paddingTop;
		this._paddingBottom = paddingBottom;
	}
	/**
	* Set the number of lines.
	*
	* @param lineCount New number of lines.
	*/
	onFlushed(lineCount, customLineHeightData) {
		this._lineCount = lineCount;
		this._lineHeightsManager = new LineHeightsManager(this._lineHeightsManager.defaultLineHeight, customLineHeightData);
	}
	changeLineHeights(callback) {
		let hadAChange = false;
		callback({
			insertOrChangeCustomLineHeight: (decorationId, startLineNumber, endLineNumber, lineHeight) => {
				hadAChange = true;
				this._lineHeightsManager.insertOrChangeCustomLineHeight(decorationId, startLineNumber, endLineNumber, lineHeight);
			},
			removeCustomLineHeight: (decorationId) => {
				hadAChange = true;
				this._lineHeightsManager.removeCustomLineHeight(decorationId);
			}
		});
		return hadAChange;
	}
	changeWhitespace(callback) {
		let hadAChange = false;
		try {
			callback({
				insertWhitespace: (afterLineNumber, ordinal, heightInPx, minWidth) => {
					hadAChange = true;
					afterLineNumber = afterLineNumber | 0;
					ordinal = ordinal | 0;
					heightInPx = heightInPx | 0;
					minWidth = minWidth | 0;
					const id = this._instanceId + ++this._lastWhitespaceId;
					this._pendingChanges.insert(new EditorWhitespace(id, afterLineNumber, ordinal, heightInPx, minWidth));
					return id;
				},
				changeOneWhitespace: (id, newAfterLineNumber, newHeight) => {
					hadAChange = true;
					newAfterLineNumber = newAfterLineNumber | 0;
					newHeight = newHeight | 0;
					this._pendingChanges.change({
						id,
						newAfterLineNumber,
						newHeight
					});
				},
				removeWhitespace: (id) => {
					hadAChange = true;
					this._pendingChanges.remove({ id });
				}
			});
		} finally {
			this._pendingChanges.commit(this);
		}
		return hadAChange;
	}
	_commitPendingChanges(inserts, changes, removes) {
		if (inserts.length > 0 || removes.length > 0) this._minWidth = -1;
		if (inserts.length + changes.length + removes.length <= 1) {
			for (const insert of inserts) this._insertWhitespace(insert);
			for (const change of changes) this._changeOneWhitespace(change.id, change.newAfterLineNumber, change.newHeight);
			for (const remove of removes) {
				const index = this._findWhitespaceIndex(remove.id);
				if (index === -1) continue;
				this._removeWhitespace(index);
			}
			return;
		}
		const toRemove = /* @__PURE__ */ new Set();
		for (const remove of removes) toRemove.add(remove.id);
		const toChange = /* @__PURE__ */ new Map();
		for (const change of changes) toChange.set(change.id, change);
		const applyRemoveAndChange = (whitespaces) => {
			const result = [];
			for (const whitespace of whitespaces) {
				if (toRemove.has(whitespace.id)) continue;
				if (toChange.has(whitespace.id)) {
					const change = toChange.get(whitespace.id);
					whitespace.afterLineNumber = change.newAfterLineNumber;
					whitespace.height = change.newHeight;
				}
				result.push(whitespace);
			}
			return result;
		};
		const result = applyRemoveAndChange(this._arr).concat(applyRemoveAndChange(inserts));
		result.sort((a, b) => {
			if (a.afterLineNumber === b.afterLineNumber) return a.ordinal - b.ordinal;
			return a.afterLineNumber - b.afterLineNumber;
		});
		this._arr = result;
		this._prefixSumValidIndex = -1;
	}
	_insertWhitespace(whitespace) {
		const insertIndex = LinesLayout$1.findInsertionIndex(this._arr, whitespace.afterLineNumber, whitespace.ordinal);
		this._arr.splice(insertIndex, 0, whitespace);
		this._prefixSumValidIndex = Math.min(this._prefixSumValidIndex, insertIndex - 1);
	}
	_findWhitespaceIndex(id) {
		const arr = this._arr;
		for (let i = 0, len = arr.length; i < len; i++) if (arr[i].id === id) return i;
		return -1;
	}
	_changeOneWhitespace(id, newAfterLineNumber, newHeight) {
		const index = this._findWhitespaceIndex(id);
		if (index === -1) return;
		if (this._arr[index].height !== newHeight) {
			this._arr[index].height = newHeight;
			this._prefixSumValidIndex = Math.min(this._prefixSumValidIndex, index - 1);
		}
		if (this._arr[index].afterLineNumber !== newAfterLineNumber) {
			const whitespace = this._arr[index];
			this._removeWhitespace(index);
			whitespace.afterLineNumber = newAfterLineNumber;
			this._insertWhitespace(whitespace);
		}
	}
	_removeWhitespace(removeIndex) {
		this._arr.splice(removeIndex, 1);
		this._prefixSumValidIndex = Math.min(this._prefixSumValidIndex, removeIndex - 1);
	}
	/**
	* Notify the layouter that lines have been deleted (a continuous zone of lines).
	*
	* @param fromLineNumber The line number at which the deletion started, inclusive
	* @param toLineNumber The line number at which the deletion ended, inclusive
	*/
	onLinesDeleted(fromLineNumber, toLineNumber) {
		fromLineNumber = fromLineNumber | 0;
		toLineNumber = toLineNumber | 0;
		this._lineCount -= toLineNumber - fromLineNumber + 1;
		for (let i = 0, len = this._arr.length; i < len; i++) {
			const afterLineNumber = this._arr[i].afterLineNumber;
			if (fromLineNumber <= afterLineNumber && afterLineNumber <= toLineNumber) this._arr[i].afterLineNumber = fromLineNumber - 1;
			else if (afterLineNumber > toLineNumber) this._arr[i].afterLineNumber -= toLineNumber - fromLineNumber + 1;
		}
		this._lineHeightsManager.onLinesDeleted(fromLineNumber, toLineNumber);
	}
	/**
	* Notify the layouter that lines have been inserted (a continuous zone of lines).
	*
	* @param fromLineNumber The line number at which the insertion started, inclusive
	* @param toLineNumber The line number at which the insertion ended, inclusive.
	*/
	onLinesInserted(fromLineNumber, toLineNumber) {
		fromLineNumber = fromLineNumber | 0;
		toLineNumber = toLineNumber | 0;
		this._lineCount += toLineNumber - fromLineNumber + 1;
		for (let i = 0, len = this._arr.length; i < len; i++) {
			const afterLineNumber = this._arr[i].afterLineNumber;
			if (fromLineNumber <= afterLineNumber) this._arr[i].afterLineNumber += toLineNumber - fromLineNumber + 1;
		}
		this._lineHeightsManager.onLinesInserted(fromLineNumber, toLineNumber);
	}
	/**
	* Get the sum of all the whitespaces.
	*/
	getWhitespacesTotalHeight() {
		if (this._arr.length === 0) return 0;
		return this.getWhitespacesAccumulatedHeight(this._arr.length - 1);
	}
	/**
	* Return the sum of the heights of the whitespaces at [0..index].
	* This includes the whitespace at `index`.
	*
	* @param index The index of the whitespace.
	* @return The sum of the heights of all whitespaces before the one at `index`, including the one at `index`.
	*/
	getWhitespacesAccumulatedHeight(index) {
		index = index | 0;
		let startIndex = Math.max(0, this._prefixSumValidIndex + 1);
		if (startIndex === 0) {
			this._arr[0].prefixSum = this._arr[0].height;
			startIndex++;
		}
		for (let i = startIndex; i <= index; i++) this._arr[i].prefixSum = this._arr[i - 1].prefixSum + this._arr[i].height;
		this._prefixSumValidIndex = Math.max(this._prefixSumValidIndex, index);
		return this._arr[index].prefixSum;
	}
	/**
	* Get the sum of heights for all objects.
	*
	* @return The sum of heights for all objects.
	*/
	getLinesTotalHeight() {
		return this._lineHeightsManager.getAccumulatedLineHeightsIncludingLineNumber(this._lineCount) + this.getWhitespacesTotalHeight() + this._paddingTop + this._paddingBottom;
	}
	/**
	* Returns the accumulated height of whitespaces before the given line number.
	*
	* @param lineNumber The line number
	*/
	getWhitespaceAccumulatedHeightBeforeLineNumber(lineNumber) {
		lineNumber = lineNumber | 0;
		const lastWhitespaceBeforeLineNumber = this._findLastWhitespaceBeforeLineNumber(lineNumber);
		if (lastWhitespaceBeforeLineNumber === -1) return 0;
		return this.getWhitespacesAccumulatedHeight(lastWhitespaceBeforeLineNumber);
	}
	_findLastWhitespaceBeforeLineNumber(lineNumber) {
		lineNumber = lineNumber | 0;
		const arr = this._arr;
		let low = 0;
		let high = arr.length - 1;
		while (low <= high) {
			const halfDelta = (high - low | 0) / 2 | 0;
			const mid = low + halfDelta | 0;
			if (arr[mid].afterLineNumber < lineNumber) {
				if (mid + 1 >= arr.length || arr[mid + 1].afterLineNumber >= lineNumber) return mid;
				else low = mid + 1 | 0;
			} else high = mid - 1 | 0;
		}
		return -1;
	}
	_findFirstWhitespaceAfterLineNumber(lineNumber) {
		lineNumber = lineNumber | 0;
		const firstWhitespaceAfterLineNumber = this._findLastWhitespaceBeforeLineNumber(lineNumber) + 1;
		if (firstWhitespaceAfterLineNumber < this._arr.length) return firstWhitespaceAfterLineNumber;
		return -1;
	}
	/**
	* Find the index of the first whitespace which has `afterLineNumber` >= `lineNumber`.
	* @return The index of the first whitespace with `afterLineNumber` >= `lineNumber` or -1 if no whitespace is found.
	*/
	getFirstWhitespaceIndexAfterLineNumber(lineNumber) {
		lineNumber = lineNumber | 0;
		return this._findFirstWhitespaceAfterLineNumber(lineNumber);
	}
	/**
	* Get the vertical offset (the sum of heights for all objects above) a certain line number.
	*
	* @param lineNumber The line number
	* @return The sum of heights for all objects above `lineNumber`.
	*/
	getVerticalOffsetForLineNumber(lineNumber, includeViewZones = false) {
		lineNumber = lineNumber | 0;
		let previousLinesHeight;
		if (lineNumber > 1) previousLinesHeight = this._lineHeightsManager.getAccumulatedLineHeightsIncludingLineNumber(lineNumber - 1);
		else previousLinesHeight = 0;
		const previousWhitespacesHeight = this.getWhitespaceAccumulatedHeightBeforeLineNumber(lineNumber - (includeViewZones ? 1 : 0));
		return previousLinesHeight + previousWhitespacesHeight + this._paddingTop;
	}
	getLineHeightForLineNumber(lineNumber) {
		return this._lineHeightsManager.heightForLineNumber(lineNumber);
	}
	/**
	* Get the vertical offset (the sum of heights for all objects above) a certain line number and also the line height of the line.
	*
	* @param lineNumber The line number
	* @return The sum of heights for all objects above `lineNumber`.
	*/
	getVerticalOffsetAfterLineNumber(lineNumber, includeViewZones = false) {
		lineNumber = lineNumber | 0;
		return this._lineHeightsManager.getAccumulatedLineHeightsIncludingLineNumber(lineNumber) + this.getWhitespaceAccumulatedHeightBeforeLineNumber(lineNumber + (includeViewZones ? 1 : 0)) + this._paddingTop;
	}
	/**
	* The maximum min width for all whitespaces.
	*/
	getWhitespaceMinWidth() {
		if (this._minWidth === -1) {
			let minWidth = 0;
			for (let i = 0, len = this._arr.length; i < len; i++) minWidth = Math.max(minWidth, this._arr[i].minWidth);
			this._minWidth = minWidth;
		}
		return this._minWidth;
	}
	/**
	* Check if `verticalOffset` is below all lines.
	*/
	isAfterLines(verticalOffset) {
		return verticalOffset > this.getLinesTotalHeight();
	}
	isInTopPadding(verticalOffset) {
		if (this._paddingTop === 0) return false;
		return verticalOffset < this._paddingTop;
	}
	isInBottomPadding(verticalOffset) {
		if (this._paddingBottom === 0) return false;
		return verticalOffset >= this.getLinesTotalHeight() - this._paddingBottom;
	}
	/**
	* Find the first line number that is at or after vertical offset `verticalOffset`.
	* i.e. if getVerticalOffsetForLine(line) is x and getVerticalOffsetForLine(line + 1) is y, then
	* getLineNumberAtOrAfterVerticalOffset(i) = line, x <= i < y.
	*
	* @param verticalOffset The vertical offset to search at.
	* @return The line number at or after vertical offset `verticalOffset`.
	*/
	getLineNumberAtOrAfterVerticalOffset(verticalOffset) {
		verticalOffset = verticalOffset | 0;
		if (verticalOffset < 0) return 1;
		const linesCount = this._lineCount | 0;
		let minLineNumber = 1;
		let maxLineNumber = linesCount;
		while (minLineNumber < maxLineNumber) {
			const midLineNumber = (minLineNumber + maxLineNumber) / 2 | 0;
			const lineHeight = this.getLineHeightForLineNumber(midLineNumber);
			const midLineNumberVerticalOffset = this.getVerticalOffsetForLineNumber(midLineNumber) | 0;
			if (verticalOffset >= midLineNumberVerticalOffset + lineHeight) minLineNumber = midLineNumber + 1;
			else if (verticalOffset >= midLineNumberVerticalOffset) return midLineNumber;
			else maxLineNumber = midLineNumber;
		}
		if (minLineNumber > linesCount) return linesCount;
		return minLineNumber;
	}
	/**
	* Get all the lines and their relative vertical offsets that are positioned between `verticalOffset1` and `verticalOffset2`.
	*
	* @param verticalOffset1 The beginning of the viewport.
	* @param verticalOffset2 The end of the viewport.
	* @return A structure describing the lines positioned between `verticalOffset1` and `verticalOffset2`.
	*/
	getLinesViewportData(verticalOffset1, verticalOffset2) {
		verticalOffset1 = verticalOffset1 | 0;
		verticalOffset2 = verticalOffset2 | 0;
		const startLineNumber = this.getLineNumberAtOrAfterVerticalOffset(verticalOffset1) | 0;
		const startLineNumberVerticalOffset = this.getVerticalOffsetForLineNumber(startLineNumber) | 0;
		let endLineNumber = this._lineCount | 0;
		let whitespaceIndex = this.getFirstWhitespaceIndexAfterLineNumber(startLineNumber) | 0;
		const whitespaceCount = this.getWhitespacesCount() | 0;
		let currentWhitespaceHeight;
		let currentWhitespaceAfterLineNumber;
		if (whitespaceIndex === -1) {
			whitespaceIndex = whitespaceCount;
			currentWhitespaceAfterLineNumber = endLineNumber + 1;
			currentWhitespaceHeight = 0;
		} else {
			currentWhitespaceAfterLineNumber = this.getAfterLineNumberForWhitespaceIndex(whitespaceIndex) | 0;
			currentWhitespaceHeight = this.getHeightForWhitespaceIndex(whitespaceIndex) | 0;
		}
		let currentVerticalOffset = startLineNumberVerticalOffset;
		let currentLineRelativeOffset = currentVerticalOffset;
		const STEP_SIZE = 5e5;
		let bigNumbersDelta = 0;
		if (startLineNumberVerticalOffset >= STEP_SIZE) {
			bigNumbersDelta = Math.floor(startLineNumberVerticalOffset / STEP_SIZE) * STEP_SIZE;
			bigNumbersDelta = Math.floor(bigNumbersDelta / this._lineHeightsManager.defaultLineHeight) * this._lineHeightsManager.defaultLineHeight;
			currentLineRelativeOffset -= bigNumbersDelta;
		}
		const linesOffsets = [];
		const verticalCenter = verticalOffset1 + (verticalOffset2 - verticalOffset1) / 2;
		let centeredLineNumber = -1;
		for (let lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++) {
			const lineHeight = this.getLineHeightForLineNumber(lineNumber);
			if (centeredLineNumber === -1) {
				const currentLineTop = currentVerticalOffset;
				const currentLineBottom = currentVerticalOffset + lineHeight;
				if (currentLineTop <= verticalCenter && verticalCenter < currentLineBottom || currentLineTop > verticalCenter) centeredLineNumber = lineNumber;
			}
			currentVerticalOffset += lineHeight;
			linesOffsets[lineNumber - startLineNumber] = currentLineRelativeOffset;
			currentLineRelativeOffset += lineHeight;
			while (currentWhitespaceAfterLineNumber === lineNumber) {
				currentLineRelativeOffset += currentWhitespaceHeight;
				currentVerticalOffset += currentWhitespaceHeight;
				whitespaceIndex++;
				if (whitespaceIndex >= whitespaceCount) currentWhitespaceAfterLineNumber = endLineNumber + 1;
				else {
					currentWhitespaceAfterLineNumber = this.getAfterLineNumberForWhitespaceIndex(whitespaceIndex) | 0;
					currentWhitespaceHeight = this.getHeightForWhitespaceIndex(whitespaceIndex) | 0;
				}
			}
			if (currentVerticalOffset >= verticalOffset2) {
				endLineNumber = lineNumber;
				break;
			}
		}
		if (centeredLineNumber === -1) centeredLineNumber = endLineNumber;
		const endLineNumberVerticalOffset = this.getVerticalOffsetForLineNumber(endLineNumber) | 0;
		let completelyVisibleStartLineNumber = startLineNumber;
		let completelyVisibleEndLineNumber = endLineNumber;
		if (completelyVisibleStartLineNumber < completelyVisibleEndLineNumber) {
			if (startLineNumberVerticalOffset < verticalOffset1) completelyVisibleStartLineNumber++;
		}
		if (completelyVisibleStartLineNumber < completelyVisibleEndLineNumber) {
			if (endLineNumberVerticalOffset + this.getLineHeightForLineNumber(endLineNumber) > verticalOffset2) completelyVisibleEndLineNumber--;
		}
		return {
			bigNumbersDelta,
			startLineNumber,
			endLineNumber,
			relativeVerticalOffset: linesOffsets,
			centeredLineNumber,
			completelyVisibleStartLineNumber,
			completelyVisibleEndLineNumber,
			lineHeight: this._lineHeightsManager.defaultLineHeight
		};
	}
	getVerticalOffsetForWhitespaceIndex(whitespaceIndex) {
		whitespaceIndex = whitespaceIndex | 0;
		const afterLineNumber = this.getAfterLineNumberForWhitespaceIndex(whitespaceIndex);
		let previousLinesHeight;
		if (afterLineNumber >= 1) previousLinesHeight = this._lineHeightsManager.getAccumulatedLineHeightsIncludingLineNumber(afterLineNumber);
		else previousLinesHeight = 0;
		let previousWhitespacesHeight;
		if (whitespaceIndex > 0) previousWhitespacesHeight = this.getWhitespacesAccumulatedHeight(whitespaceIndex - 1);
		else previousWhitespacesHeight = 0;
		return previousLinesHeight + previousWhitespacesHeight + this._paddingTop;
	}
	getWhitespaceIndexAtOrAfterVerticallOffset(verticalOffset) {
		verticalOffset = verticalOffset | 0;
		let minWhitespaceIndex = 0;
		let maxWhitespaceIndex = this.getWhitespacesCount() - 1;
		if (maxWhitespaceIndex < 0) return -1;
		const maxWhitespaceVerticalOffset = this.getVerticalOffsetForWhitespaceIndex(maxWhitespaceIndex);
		const maxWhitespaceHeight = this.getHeightForWhitespaceIndex(maxWhitespaceIndex);
		if (verticalOffset >= maxWhitespaceVerticalOffset + maxWhitespaceHeight) return -1;
		while (minWhitespaceIndex < maxWhitespaceIndex) {
			const midWhitespaceIndex = Math.floor((minWhitespaceIndex + maxWhitespaceIndex) / 2);
			const midWhitespaceVerticalOffset = this.getVerticalOffsetForWhitespaceIndex(midWhitespaceIndex);
			const midWhitespaceHeight = this.getHeightForWhitespaceIndex(midWhitespaceIndex);
			if (verticalOffset >= midWhitespaceVerticalOffset + midWhitespaceHeight) minWhitespaceIndex = midWhitespaceIndex + 1;
			else if (verticalOffset >= midWhitespaceVerticalOffset) return midWhitespaceIndex;
			else maxWhitespaceIndex = midWhitespaceIndex;
		}
		return minWhitespaceIndex;
	}
	/**
	* Get exactly the whitespace that is layouted at `verticalOffset`.
	*
	* @param verticalOffset The vertical offset.
	* @return Precisely the whitespace that is layouted at `verticaloffset` or null.
	*/
	getWhitespaceAtVerticalOffset(verticalOffset) {
		verticalOffset = verticalOffset | 0;
		const candidateIndex = this.getWhitespaceIndexAtOrAfterVerticallOffset(verticalOffset);
		if (candidateIndex < 0) return null;
		if (candidateIndex >= this.getWhitespacesCount()) return null;
		const candidateTop = this.getVerticalOffsetForWhitespaceIndex(candidateIndex);
		if (candidateTop > verticalOffset) return null;
		const candidateHeight = this.getHeightForWhitespaceIndex(candidateIndex);
		return {
			id: this.getIdForWhitespaceIndex(candidateIndex),
			afterLineNumber: this.getAfterLineNumberForWhitespaceIndex(candidateIndex),
			verticalOffset: candidateTop,
			height: candidateHeight
		};
	}
	/**
	* Get a list of whitespaces that are positioned between `verticalOffset1` and `verticalOffset2`.
	*
	* @param verticalOffset1 The beginning of the viewport.
	* @param verticalOffset2 The end of the viewport.
	* @return An array with all the whitespaces in the viewport. If no whitespace is in viewport, the array is empty.
	*/
	getWhitespaceViewportData(verticalOffset1, verticalOffset2) {
		verticalOffset1 = verticalOffset1 | 0;
		verticalOffset2 = verticalOffset2 | 0;
		const startIndex = this.getWhitespaceIndexAtOrAfterVerticallOffset(verticalOffset1);
		const endIndex = this.getWhitespacesCount() - 1;
		if (startIndex < 0) return [];
		const result = [];
		for (let i = startIndex; i <= endIndex; i++) {
			const top = this.getVerticalOffsetForWhitespaceIndex(i);
			const height = this.getHeightForWhitespaceIndex(i);
			if (top >= verticalOffset2) break;
			result.push({
				id: this.getIdForWhitespaceIndex(i),
				afterLineNumber: this.getAfterLineNumberForWhitespaceIndex(i),
				verticalOffset: top,
				height
			});
		}
		return result;
	}
	/**
	* Get all whitespaces.
	*/
	getWhitespaces() {
		return this._arr.slice(0);
	}
	/**
	* The number of whitespaces.
	*/
	getWhitespacesCount() {
		return this._arr.length;
	}
	/**
	* Get the `id` for whitespace at index `index`.
	*
	* @param index The index of the whitespace.
	* @return `id` of whitespace at `index`.
	*/
	getIdForWhitespaceIndex(index) {
		index = index | 0;
		return this._arr[index].id;
	}
	/**
	* Get the `afterLineNumber` for whitespace at index `index`.
	*
	* @param index The index of the whitespace.
	* @return `afterLineNumber` of whitespace at `index`.
	*/
	getAfterLineNumberForWhitespaceIndex(index) {
		index = index | 0;
		return this._arr[index].afterLineNumber;
	}
	/**
	* Get the `height` for whitespace at index `index`.
	*
	* @param index The index of the whitespace.
	* @return `height` of whitespace at `index`.
	*/
	getHeightForWhitespaceIndex(index) {
		index = index | 0;
		return this._arr[index].height;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/viewLayout/viewLayout.js
var SMOOTH_SCROLLING_TIME = 125;
var EditorScrollDimensions = class {
	constructor(width, contentWidth, height, contentHeight) {
		width = width | 0;
		contentWidth = contentWidth | 0;
		height = height | 0;
		contentHeight = contentHeight | 0;
		if (width < 0) width = 0;
		if (contentWidth < 0) contentWidth = 0;
		if (height < 0) height = 0;
		if (contentHeight < 0) contentHeight = 0;
		this.width = width;
		this.contentWidth = contentWidth;
		this.scrollWidth = Math.max(width, contentWidth);
		this.height = height;
		this.contentHeight = contentHeight;
		this.scrollHeight = Math.max(height, contentHeight);
	}
	equals(other) {
		return this.width === other.width && this.contentWidth === other.contentWidth && this.height === other.height && this.contentHeight === other.contentHeight;
	}
};
var EditorScrollable = class extends Disposable {
	constructor(smoothScrollDuration, scheduleAtNextAnimationFrame) {
		super();
		this._onDidContentSizeChange = this._register(new Emitter$1());
		this.onDidContentSizeChange = this._onDidContentSizeChange.event;
		this._dimensions = new EditorScrollDimensions(0, 0, 0, 0);
		this._scrollable = this._register(new Scrollable({
			forceIntegerValues: true,
			smoothScrollDuration,
			scheduleAtNextAnimationFrame
		}));
		this.onDidScroll = this._scrollable.onScroll;
	}
	getScrollable() {
		return this._scrollable;
	}
	setSmoothScrollDuration(smoothScrollDuration) {
		this._scrollable.setSmoothScrollDuration(smoothScrollDuration);
	}
	validateScrollPosition(scrollPosition) {
		return this._scrollable.validateScrollPosition(scrollPosition);
	}
	getScrollDimensions() {
		return this._dimensions;
	}
	setScrollDimensions(dimensions) {
		if (this._dimensions.equals(dimensions)) return;
		const oldDimensions = this._dimensions;
		this._dimensions = dimensions;
		this._scrollable.setScrollDimensions({
			width: dimensions.width,
			scrollWidth: dimensions.scrollWidth,
			height: dimensions.height,
			scrollHeight: dimensions.scrollHeight
		}, true);
		const contentWidthChanged = oldDimensions.contentWidth !== dimensions.contentWidth;
		const contentHeightChanged = oldDimensions.contentHeight !== dimensions.contentHeight;
		if (contentWidthChanged || contentHeightChanged) this._onDidContentSizeChange.fire(new ContentSizeChangedEvent(oldDimensions.contentWidth, oldDimensions.contentHeight, dimensions.contentWidth, dimensions.contentHeight));
	}
	getFutureScrollPosition() {
		return this._scrollable.getFutureScrollPosition();
	}
	getCurrentScrollPosition() {
		return this._scrollable.getCurrentScrollPosition();
	}
	setScrollPositionNow(update) {
		this._scrollable.setScrollPositionNow(update);
	}
	setScrollPositionSmooth(update) {
		this._scrollable.setScrollPositionSmooth(update);
	}
	hasPendingScrollAnimation() {
		return this._scrollable.hasPendingScrollAnimation();
	}
};
var ViewLayout = class extends Disposable {
	constructor(configuration, lineCount, customLineHeightData, scheduleAtNextAnimationFrame) {
		super();
		this._configuration = configuration;
		const options = this._configuration.options;
		const layoutInfo = options.get(166);
		const padding = options.get(96);
		this._linesLayout = new LinesLayout$1(lineCount, options.get(75), padding.top, padding.bottom, customLineHeightData);
		this._maxLineWidth = 0;
		this._overlayWidgetsMinWidth = 0;
		this._scrollable = this._register(new EditorScrollable(0, scheduleAtNextAnimationFrame));
		this._configureSmoothScrollDuration();
		this._scrollable.setScrollDimensions(new EditorScrollDimensions(layoutInfo.contentWidth, 0, layoutInfo.height, 0));
		this.onDidScroll = this._scrollable.onDidScroll;
		this.onDidContentSizeChange = this._scrollable.onDidContentSizeChange;
		this._updateHeight();
	}
	getScrollable() {
		return this._scrollable.getScrollable();
	}
	onHeightMaybeChanged() {
		this._updateHeight();
	}
	_configureSmoothScrollDuration() {
		this._scrollable.setSmoothScrollDuration(this._configuration.options.get(130) ? SMOOTH_SCROLLING_TIME : 0);
	}
	onConfigurationChanged(e) {
		const options = this._configuration.options;
		if (e.hasChanged(75)) this._linesLayout.setDefaultLineHeight(options.get(75));
		if (e.hasChanged(96)) {
			const padding = options.get(96);
			this._linesLayout.setPadding(padding.top, padding.bottom);
		}
		if (e.hasChanged(166)) {
			const layoutInfo = options.get(166);
			const width = layoutInfo.contentWidth;
			const height = layoutInfo.height;
			const scrollDimensions = this._scrollable.getScrollDimensions();
			const contentWidth = scrollDimensions.contentWidth;
			this._scrollable.setScrollDimensions(new EditorScrollDimensions(width, scrollDimensions.contentWidth, height, this._getContentHeight(width, height, contentWidth)));
		} else this._updateHeight();
		if (e.hasChanged(130)) this._configureSmoothScrollDuration();
	}
	onFlushed(lineCount, customLineHeightData) {
		this._linesLayout.onFlushed(lineCount, customLineHeightData);
	}
	onLinesDeleted(fromLineNumber, toLineNumber) {
		this._linesLayout.onLinesDeleted(fromLineNumber, toLineNumber);
	}
	onLinesInserted(fromLineNumber, toLineNumber) {
		this._linesLayout.onLinesInserted(fromLineNumber, toLineNumber);
	}
	_getHorizontalScrollbarHeight(width, scrollWidth) {
		const scrollbar = this._configuration.options.get(117);
		if (scrollbar.horizontal === 2) return 0;
		if (width >= scrollWidth) return 0;
		return scrollbar.horizontalScrollbarSize;
	}
	_getContentHeight(width, height, contentWidth) {
		const options = this._configuration.options;
		let result = this._linesLayout.getLinesTotalHeight();
		if (options.get(119)) result += Math.max(0, height - options.get(75) - options.get(96).bottom);
		else if (!options.get(117).ignoreHorizontalScrollbarInContentHeight) result += this._getHorizontalScrollbarHeight(width, contentWidth);
		return result;
	}
	_updateHeight() {
		const scrollDimensions = this._scrollable.getScrollDimensions();
		const width = scrollDimensions.width;
		const height = scrollDimensions.height;
		const contentWidth = scrollDimensions.contentWidth;
		this._scrollable.setScrollDimensions(new EditorScrollDimensions(width, scrollDimensions.contentWidth, height, this._getContentHeight(width, height, contentWidth)));
	}
	getCurrentViewport() {
		const scrollDimensions = this._scrollable.getScrollDimensions();
		const currentScrollPosition = this._scrollable.getCurrentScrollPosition();
		return new Viewport(currentScrollPosition.scrollTop, currentScrollPosition.scrollLeft, scrollDimensions.width, scrollDimensions.height);
	}
	getFutureViewport() {
		const scrollDimensions = this._scrollable.getScrollDimensions();
		const currentScrollPosition = this._scrollable.getFutureScrollPosition();
		return new Viewport(currentScrollPosition.scrollTop, currentScrollPosition.scrollLeft, scrollDimensions.width, scrollDimensions.height);
	}
	_computeContentWidth() {
		const options = this._configuration.options;
		const maxLineWidth = this._maxLineWidth;
		const wrappingInfo = options.get(167);
		const fontInfo = options.get(59);
		const layoutInfo = options.get(166);
		if (wrappingInfo.isViewportWrapping) {
			const minimap = options.get(81);
			if (maxLineWidth > layoutInfo.contentWidth + fontInfo.typicalHalfwidthCharacterWidth) {
				if (minimap.enabled && minimap.side === "right") return maxLineWidth + layoutInfo.verticalScrollbarWidth;
			}
			return maxLineWidth;
		} else {
			const extraHorizontalSpace = options.get(118) * fontInfo.typicalHalfwidthCharacterWidth;
			const whitespaceMinWidth = this._linesLayout.getWhitespaceMinWidth();
			return Math.max(maxLineWidth + extraHorizontalSpace + layoutInfo.verticalScrollbarWidth, whitespaceMinWidth, this._overlayWidgetsMinWidth);
		}
	}
	setMaxLineWidth(maxLineWidth) {
		this._maxLineWidth = maxLineWidth;
		this._updateContentWidth();
	}
	setOverlayWidgetsMinWidth(maxMinWidth) {
		this._overlayWidgetsMinWidth = maxMinWidth;
		this._updateContentWidth();
	}
	_updateContentWidth() {
		const scrollDimensions = this._scrollable.getScrollDimensions();
		this._scrollable.setScrollDimensions(new EditorScrollDimensions(scrollDimensions.width, this._computeContentWidth(), scrollDimensions.height, scrollDimensions.contentHeight));
		this._updateHeight();
	}
	saveState() {
		const currentScrollPosition = this._scrollable.getFutureScrollPosition();
		const scrollTop = currentScrollPosition.scrollTop;
		const firstLineNumberInViewport = this._linesLayout.getLineNumberAtOrAfterVerticalOffset(scrollTop);
		return {
			scrollTop,
			scrollTopWithoutViewZones: scrollTop - this._linesLayout.getWhitespaceAccumulatedHeightBeforeLineNumber(firstLineNumberInViewport),
			scrollLeft: currentScrollPosition.scrollLeft
		};
	}
	changeWhitespace(callback) {
		const hadAChange = this._linesLayout.changeWhitespace(callback);
		if (hadAChange) this.onHeightMaybeChanged();
		return hadAChange;
	}
	changeSpecialLineHeights(callback) {
		const hadAChange = this._linesLayout.changeLineHeights(callback);
		if (hadAChange) this.onHeightMaybeChanged();
		return hadAChange;
	}
	getVerticalOffsetForLineNumber(lineNumber, includeViewZones = false) {
		return this._linesLayout.getVerticalOffsetForLineNumber(lineNumber, includeViewZones);
	}
	getVerticalOffsetAfterLineNumber(lineNumber, includeViewZones = false) {
		return this._linesLayout.getVerticalOffsetAfterLineNumber(lineNumber, includeViewZones);
	}
	getLineHeightForLineNumber(lineNumber) {
		return this._linesLayout.getLineHeightForLineNumber(lineNumber);
	}
	isAfterLines(verticalOffset) {
		return this._linesLayout.isAfterLines(verticalOffset);
	}
	isInTopPadding(verticalOffset) {
		return this._linesLayout.isInTopPadding(verticalOffset);
	}
	isInBottomPadding(verticalOffset) {
		return this._linesLayout.isInBottomPadding(verticalOffset);
	}
	getLineNumberAtVerticalOffset(verticalOffset) {
		return this._linesLayout.getLineNumberAtOrAfterVerticalOffset(verticalOffset);
	}
	getWhitespaceAtVerticalOffset(verticalOffset) {
		return this._linesLayout.getWhitespaceAtVerticalOffset(verticalOffset);
	}
	getLinesViewportData() {
		const visibleBox = this.getCurrentViewport();
		return this._linesLayout.getLinesViewportData(visibleBox.top, visibleBox.top + visibleBox.height);
	}
	getLinesViewportDataAtScrollTop(scrollTop) {
		const scrollDimensions = this._scrollable.getScrollDimensions();
		if (scrollTop + scrollDimensions.height > scrollDimensions.scrollHeight) scrollTop = scrollDimensions.scrollHeight - scrollDimensions.height;
		if (scrollTop < 0) scrollTop = 0;
		return this._linesLayout.getLinesViewportData(scrollTop, scrollTop + scrollDimensions.height);
	}
	getWhitespaceViewportData() {
		const visibleBox = this.getCurrentViewport();
		return this._linesLayout.getWhitespaceViewportData(visibleBox.top, visibleBox.top + visibleBox.height);
	}
	getWhitespaces() {
		return this._linesLayout.getWhitespaces();
	}
	getContentWidth() {
		return this._scrollable.getScrollDimensions().contentWidth;
	}
	getScrollWidth() {
		return this._scrollable.getScrollDimensions().scrollWidth;
	}
	getContentHeight() {
		return this._scrollable.getScrollDimensions().contentHeight;
	}
	getScrollHeight() {
		return this._scrollable.getScrollDimensions().scrollHeight;
	}
	getCurrentScrollLeft() {
		return this._scrollable.getCurrentScrollPosition().scrollLeft;
	}
	getCurrentScrollTop() {
		return this._scrollable.getCurrentScrollPosition().scrollTop;
	}
	validateScrollPosition(scrollPosition) {
		return this._scrollable.validateScrollPosition(scrollPosition);
	}
	setScrollPosition(position, type) {
		if (type === 1) this._scrollable.setScrollPositionNow(position);
		else this._scrollable.setScrollPositionSmooth(position);
	}
	hasPendingScrollAnimation() {
		return this._scrollable.hasPendingScrollAnimation();
	}
	deltaScrollNow(deltaScrollLeft, deltaScrollTop) {
		const currentScrollPosition = this._scrollable.getCurrentScrollPosition();
		this._scrollable.setScrollPositionNow({
			scrollLeft: currentScrollPosition.scrollLeft + deltaScrollLeft,
			scrollTop: currentScrollPosition.scrollTop + deltaScrollTop
		});
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/viewModel/inlineDecorations.js
var InlineDecoration = class {
	constructor(range, inlineClassName, type) {
		this.range = range;
		this.inlineClassName = inlineClassName;
		this.type = type;
	}
};
var InlineModelDecorationsComputer = class {
	constructor(context, model, coordinatesConverter) {
		this.context = context;
		this.model = model;
		this.coordinatesConverter = coordinatesConverter;
		this._decorationsCache = Object.create(null);
	}
	getInlineDecorations(modelLineNumber) {
		const modelRange = new Range$2(modelLineNumber, 1, modelLineNumber, this.model.getLineMaxColumn(modelLineNumber));
		const viewRange = this.coordinatesConverter.convertModelRangeToViewRange(modelRange);
		return this.getDecorations(viewRange, false, false).inlineDecorations;
	}
	getDecorations(viewRange, onlyMinimapDecorations, onlyMarginDecorations) {
		const modelDecorations = this.context.getModelDecorations(viewRange, onlyMinimapDecorations, onlyMarginDecorations);
		const startLineNumber = viewRange.startLineNumber;
		const endLineNumber = viewRange.endLineNumber;
		const decorationsInViewport = [];
		let decorationsInViewportLen = 0;
		const inlineDecorations = [];
		const hasVariableFonts = [];
		for (let j = startLineNumber; j <= endLineNumber; j++) {
			inlineDecorations[j - startLineNumber] = [];
			hasVariableFonts[j - startLineNumber] = false;
		}
		for (let i = 0, len = modelDecorations.length; i < len; i++) {
			const modelDecoration = modelDecorations[i];
			const decorationOptions = modelDecoration.options;
			if (!isModelDecorationVisible(this.model, modelDecoration)) continue;
			const viewModelDecoration = this._getOrCreateViewModelDecoration(modelDecoration);
			const viewRange = viewModelDecoration.range;
			decorationsInViewport[decorationsInViewportLen++] = viewModelDecoration;
			if (decorationOptions.inlineClassName) {
				const inlineDecoration = new InlineDecoration(viewRange, decorationOptions.inlineClassName, decorationOptions.inlineClassNameAffectsLetterSpacing ? 3 : 0);
				const intersectedStartLineNumber = Math.max(startLineNumber, viewRange.startLineNumber);
				const intersectedEndLineNumber = Math.min(endLineNumber, viewRange.endLineNumber);
				for (let j = intersectedStartLineNumber; j <= intersectedEndLineNumber; j++) {
					inlineDecorations[j - startLineNumber].push(inlineDecoration);
					if (decorationOptions.affectsFont) hasVariableFonts[j - startLineNumber] = true;
				}
			}
			if (decorationOptions.beforeContentClassName) {
				if (startLineNumber <= viewRange.startLineNumber && viewRange.startLineNumber <= endLineNumber) {
					const inlineDecoration = new InlineDecoration(new Range$2(viewRange.startLineNumber, viewRange.startColumn, viewRange.startLineNumber, viewRange.startColumn), decorationOptions.beforeContentClassName, 1);
					inlineDecorations[viewRange.startLineNumber - startLineNumber].push(inlineDecoration);
					if (decorationOptions.affectsFont) hasVariableFonts[viewRange.startLineNumber - startLineNumber] = true;
				}
			}
			if (decorationOptions.afterContentClassName) {
				if (startLineNumber <= viewRange.endLineNumber && viewRange.endLineNumber <= endLineNumber) {
					const inlineDecoration = new InlineDecoration(new Range$2(viewRange.endLineNumber, viewRange.endColumn, viewRange.endLineNumber, viewRange.endColumn), decorationOptions.afterContentClassName, 2);
					inlineDecorations[viewRange.endLineNumber - startLineNumber].push(inlineDecoration);
					if (decorationOptions.affectsFont) hasVariableFonts[viewRange.endLineNumber - startLineNumber] = true;
				}
			}
		}
		return {
			decorations: decorationsInViewport,
			inlineDecorations,
			hasVariableFonts
		};
	}
	reset() {
		this._decorationsCache = Object.create(null);
	}
	onModelDecorationsChanged() {
		this.reset();
	}
	onLineMappingChanged() {
		this.reset();
	}
	_getOrCreateViewModelDecoration(modelDecoration) {
		const id = modelDecoration.id;
		let r = this._decorationsCache[id];
		if (!r) {
			const modelRange = modelDecoration.range;
			const options = modelDecoration.options;
			let viewRange;
			if (options.isWholeLine) {
				const start = this.coordinatesConverter.convertModelPositionToViewPosition(new Position$1(modelRange.startLineNumber, 1), 0, false, true);
				const end = this.coordinatesConverter.convertModelPositionToViewPosition(new Position$1(modelRange.endLineNumber, this.model.getLineMaxColumn(modelRange.endLineNumber)), 1);
				viewRange = new Range$2(start.lineNumber, start.column, end.lineNumber, end.column);
			} else viewRange = this.coordinatesConverter.convertModelRangeToViewRange(modelRange, 1);
			r = new ViewModelDecoration(viewRange, options);
			this._decorationsCache[id] = r;
		}
		return r;
	}
};
var InjectedTextInlineDecorationsComputer = class {
	constructor(context) {
		this.context = context;
	}
	getInlineDecorations(modelLineNumber) {
		const injectionOffsets = this.context.getInjectionOffsets(modelLineNumber);
		if (!injectionOffsets) return [];
		const lineInlineDecorations = [];
		let totalInjectedTextLengthBefore = 0;
		let currentInjectedOffset = 0;
		const injectionOptions = this.context.getInjectionOptions(modelLineNumber);
		const breakOffsets = this.context.getBreakOffsets(modelLineNumber);
		for (let outputLineIndex = 0; outputLineIndex < breakOffsets.length; outputLineIndex++) {
			const inlineDecorations = new Array();
			lineInlineDecorations[outputLineIndex] = inlineDecorations;
			const lineStartOffsetInInputWithInjections = outputLineIndex > 0 ? breakOffsets[outputLineIndex - 1] : 0;
			const lineEndOffsetInInputWithInjections = breakOffsets[outputLineIndex];
			while (currentInjectedOffset < injectionOffsets.length) {
				const options = injectionOptions[currentInjectedOffset];
				const length = options.content.length;
				const injectedTextStartOffsetInInputWithInjections = injectionOffsets[currentInjectedOffset] + totalInjectedTextLengthBefore;
				const injectedTextEndOffsetInInputWithInjections = injectedTextStartOffsetInInputWithInjections + length;
				const isWidthOnly = length === 0 && options.widthInEm !== void 0;
				const isLastOutputLine = outputLineIndex === breakOffsets.length - 1;
				if (injectedTextStartOffsetInInputWithInjections > lineEndOffsetInInputWithInjections || isWidthOnly && injectedTextStartOffsetInInputWithInjections === lineEndOffsetInInputWithInjections && !isLastOutputLine) break;
				if (isWidthOnly ? lineStartOffsetInInputWithInjections <= injectedTextStartOffsetInInputWithInjections && (injectedTextStartOffsetInInputWithInjections < lineEndOffsetInInputWithInjections || isLastOutputLine) : lineStartOffsetInInputWithInjections < injectedTextEndOffsetInInputWithInjections) {
					if (options.inlineClassName) {
						const wrappedTextIndentLength = this.context.getWrappedTextIndentLength(modelLineNumber);
						const offset = outputLineIndex > 0 ? wrappedTextIndentLength : 0;
						const start = offset + Math.max(injectedTextStartOffsetInInputWithInjections - lineStartOffsetInInputWithInjections, 0);
						const end = offset + Math.min(injectedTextEndOffsetInInputWithInjections - lineStartOffsetInInputWithInjections, lineEndOffsetInInputWithInjections - lineStartOffsetInInputWithInjections);
						if (start !== end || isWidthOnly) {
							const viewLineNumber = this.context.getBaseViewLineNumber(modelLineNumber) + outputLineIndex;
							const range = new Range$2(viewLineNumber, start + 1, viewLineNumber, end + 1);
							const type = isWidthOnly ? 4 : options.inlineClassNameAffectsLetterSpacing ? 3 : 0;
							inlineDecorations.push(new InlineDecoration(range, options.inlineClassName, type));
						}
					}
				}
				if (injectedTextEndOffsetInInputWithInjections <= lineEndOffsetInInputWithInjections) {
					totalInjectedTextLengthBefore += length;
					currentInjectedOffset++;
				} else break;
			}
		}
		return lineInlineDecorations;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/viewModel/viewModelDecorations.js
var ViewModelDecorations = class {
	constructor(editorId, model, configuration, linesCollection, coordinatesConverter) {
		this.editorId = editorId;
		this.configuration = configuration;
		this._linesCollection = linesCollection;
		const context = { getModelDecorations: (viewRange, onlyMinimapDecorations, onlyMarginDecorations) => this._linesCollection.getDecorationsInRange(viewRange, this.editorId, filterValidationDecorations(this.configuration.options), filterFontDecorations(this.configuration.options), onlyMinimapDecorations, onlyMarginDecorations) };
		this._inlineDecorationsComputer = new InlineModelDecorationsComputer(context, model, coordinatesConverter);
		this._cachedModelDecorationsResolver = null;
		this._cachedModelDecorationsResolverViewRange = null;
	}
	_clearCachedModelDecorationsResolver() {
		this._cachedModelDecorationsResolver = null;
		this._cachedModelDecorationsResolverViewRange = null;
	}
	dispose() {
		this._inlineDecorationsComputer.reset();
		this._clearCachedModelDecorationsResolver();
	}
	reset() {
		this._inlineDecorationsComputer.reset();
		this._clearCachedModelDecorationsResolver();
	}
	onModelDecorationsChanged() {
		this._inlineDecorationsComputer.onModelDecorationsChanged();
		this._clearCachedModelDecorationsResolver();
	}
	onLineMappingChanged() {
		this._inlineDecorationsComputer.onLineMappingChanged();
		this._clearCachedModelDecorationsResolver();
	}
	getMinimapDecorationsInRange(range) {
		return this._inlineDecorationsComputer.getDecorations(range, true, false).decorations;
	}
	getDecorationsViewportData(viewRange) {
		let cacheIsValid = this._cachedModelDecorationsResolver !== null;
		cacheIsValid = cacheIsValid && viewRange.equalsRange(this._cachedModelDecorationsResolverViewRange);
		if (!cacheIsValid) {
			this._cachedModelDecorationsResolver = this._inlineDecorationsComputer.getDecorations(viewRange, false, false);
			this._cachedModelDecorationsResolverViewRange = viewRange;
		}
		return this._cachedModelDecorationsResolver;
	}
	getDecorationsOnLine(lineNumber, onlyMinimapDecorations = false, onlyMarginDecorations = false) {
		const range = new Range$2(lineNumber, this._linesCollection.getViewLineMinColumn(lineNumber), lineNumber, this._linesCollection.getViewLineMaxColumn(lineNumber));
		return this._inlineDecorationsComputer.getDecorations(range, onlyMinimapDecorations, onlyMarginDecorations);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/viewModel/modelLineProjection.js
function createModelLineProjection(lineBreakData, isVisible) {
	if (lineBreakData === null) {
		if (isVisible) return IdentityModelLineProjection.INSTANCE;
		return HiddenModelLineProjection.INSTANCE;
	} else return new ModelLineProjection(lineBreakData, isVisible);
}
/**
* This projection is used to
* * wrap model lines
* * inject text
*/
var ModelLineProjection = class {
	constructor(lineBreakData, isVisible) {
		this._projectionData = lineBreakData;
		this._isVisible = isVisible;
	}
	isVisible() {
		return this._isVisible;
	}
	setVisible(isVisible) {
		this._isVisible = isVisible;
		return this;
	}
	getProjectionData() {
		return this._projectionData;
	}
	getViewLineCount() {
		if (!this._isVisible) return 0;
		return this._projectionData.getOutputLineCount();
	}
	getViewLineContent(model, modelLineNumber, outputLineIndex) {
		this._assertVisible();
		const startOffsetInInputWithInjections = outputLineIndex > 0 ? this._projectionData.breakOffsets[outputLineIndex - 1] : 0;
		const endOffsetInInputWithInjections = this._projectionData.breakOffsets[outputLineIndex];
		let r;
		if (this._projectionData.injectionOffsets !== null) {
			const injectedTexts = this._projectionData.injectionOffsets.map((offset, idx) => new LineInjectedText(0, 0, offset + 1, this._projectionData.injectionOptions[idx], 0));
			r = LineInjectedText.applyInjectedText(model.getLineContent(modelLineNumber), injectedTexts).substring(startOffsetInInputWithInjections, endOffsetInInputWithInjections);
		} else r = model.getValueInRange({
			startLineNumber: modelLineNumber,
			startColumn: startOffsetInInputWithInjections + 1,
			endLineNumber: modelLineNumber,
			endColumn: endOffsetInInputWithInjections + 1
		});
		if (outputLineIndex > 0) r = spaces(this._projectionData.wrappedTextIndentLength) + r;
		return r;
	}
	getViewLineLength(model, modelLineNumber, outputLineIndex) {
		this._assertVisible();
		return this._projectionData.getLineLength(outputLineIndex);
	}
	getViewLineMinColumn(_model, _modelLineNumber, outputLineIndex) {
		this._assertVisible();
		return this._projectionData.getMinOutputOffset(outputLineIndex) + 1;
	}
	getViewLineMaxColumn(model, modelLineNumber, outputLineIndex) {
		this._assertVisible();
		return this._projectionData.getMaxOutputOffset(outputLineIndex) + 1;
	}
	getViewLineContinuesWithWrappedLine(outputLineIndex) {
		return outputLineIndex + 1 < this.getViewLineCount();
	}
	/**
	* Try using {@link getViewLinesData} instead.
	*/
	getViewLineData(model, modelLineNumber, outputLineIndex, baseViewLineNumber) {
		const arr = new Array();
		this.getViewLinesData(model, modelLineNumber, outputLineIndex, 1, baseViewLineNumber, 0, [true], arr);
		return arr[0];
	}
	getViewLinesData(model, modelLineNumber, outputLineIdx, lineCount, baseViewLineNumber, globalStartIndex, needed, result) {
		this._assertVisible();
		const lineBreakData = this._projectionData;
		const injectionOffsets = lineBreakData.injectionOffsets;
		const injectionOptions = lineBreakData.injectionOptions;
		const lineInlineDecorations = new InjectedTextInlineDecorationsComputer({
			getInjectionOptions: () => injectionOptions,
			getInjectionOffsets: () => injectionOffsets,
			getBreakOffsets: () => lineBreakData.breakOffsets,
			getWrappedTextIndentLength: () => lineBreakData.wrappedTextIndentLength,
			getBaseViewLineNumber: () => baseViewLineNumber
		}).getInlineDecorations(modelLineNumber);
		const lineWithInjections = getLineTokensWithInjections(model.tokenization.getLineTokens(modelLineNumber), injectionOptions, injectionOffsets);
		for (let outputLineIndex = outputLineIdx; outputLineIndex < outputLineIdx + lineCount; outputLineIndex++) {
			const globalIndex = globalStartIndex + outputLineIndex - outputLineIdx;
			if (!needed[globalIndex]) {
				result[globalIndex] = null;
				continue;
			}
			result[globalIndex] = this._getViewLineData(lineWithInjections, lineInlineDecorations ? lineInlineDecorations[outputLineIndex] : null, outputLineIndex);
		}
	}
	_getViewLineData(lineWithInjections, inlineDecorations, outputLineIndex) {
		this._assertVisible();
		const lineBreakData = this._projectionData;
		const deltaStartIndex = outputLineIndex > 0 ? lineBreakData.wrappedTextIndentLength : 0;
		const lineStartOffsetInInputWithInjections = outputLineIndex > 0 ? lineBreakData.breakOffsets[outputLineIndex - 1] : 0;
		const lineEndOffsetInInputWithInjections = lineBreakData.breakOffsets[outputLineIndex];
		const tokens = lineWithInjections.sliceAndInflate(lineStartOffsetInInputWithInjections, lineEndOffsetInInputWithInjections, deltaStartIndex);
		let lineContent = tokens.getLineContent();
		if (outputLineIndex > 0) lineContent = spaces(lineBreakData.wrappedTextIndentLength) + lineContent;
		const minColumn = this._projectionData.getMinOutputOffset(outputLineIndex) + 1;
		const maxColumn = lineContent.length + 1;
		const continuesWithWrappedLine = this.getViewLineContinuesWithWrappedLine(outputLineIndex);
		const startVisibleColumn = outputLineIndex === 0 ? 0 : lineBreakData.breakOffsetsVisibleColumn[outputLineIndex - 1];
		return new ViewLineData(lineContent, continuesWithWrappedLine, minColumn, maxColumn, startVisibleColumn, tokens, inlineDecorations);
	}
	getModelColumnOfViewPosition(outputLineIndex, outputColumn) {
		this._assertVisible();
		return this._projectionData.translateToInputOffset(outputLineIndex, outputColumn - 1) + 1;
	}
	getViewPositionOfModelPosition(deltaLineNumber, inputColumn, affinity = 2) {
		this._assertVisible();
		return this._projectionData.translateToOutputPosition(inputColumn - 1, affinity).toPosition(deltaLineNumber);
	}
	getViewLineNumberOfModelPosition(deltaLineNumber, inputColumn) {
		this._assertVisible();
		return deltaLineNumber + this._projectionData.translateToOutputPosition(inputColumn - 1).outputLineIndex;
	}
	normalizePosition(outputLineIndex, outputPosition, affinity) {
		const baseViewLineNumber = outputPosition.lineNumber - outputLineIndex;
		return this._projectionData.normalizeOutputPosition(outputLineIndex, outputPosition.column - 1, affinity).toPosition(baseViewLineNumber);
	}
	getInjectedTextAt(outputLineIndex, outputColumn) {
		return this._projectionData.getInjectedText(outputLineIndex, outputColumn - 1);
	}
	_assertVisible() {
		if (!this._isVisible) throw new Error("Not supported");
	}
};
/**
* This projection does not change the model line.
*/
var IdentityModelLineProjection = class IdentityModelLineProjection {
	static {
		this.INSTANCE = new IdentityModelLineProjection();
	}
	constructor() {}
	isVisible() {
		return true;
	}
	setVisible(isVisible) {
		if (isVisible) return this;
		return HiddenModelLineProjection.INSTANCE;
	}
	getProjectionData() {
		return null;
	}
	getViewLineCount() {
		return 1;
	}
	getViewLineContent(model, modelLineNumber, _outputLineIndex) {
		return model.getLineContent(modelLineNumber);
	}
	getViewLineLength(model, modelLineNumber, _outputLineIndex) {
		return model.getLineLength(modelLineNumber);
	}
	getViewLineMinColumn(model, modelLineNumber, _outputLineIndex) {
		return model.getLineMinColumn(modelLineNumber);
	}
	getViewLineMaxColumn(model, modelLineNumber, _outputLineIndex) {
		return model.getLineMaxColumn(modelLineNumber);
	}
	getViewLineContinuesWithWrappedLine(_outputLineIndex) {
		return false;
	}
	getViewLineData(model, modelLineNumber, _outputLineIndex, _baseViewLineNumber) {
		const lineTokens = model.tokenization.getLineTokens(modelLineNumber);
		const lineContent = lineTokens.getLineContent();
		return new ViewLineData(lineContent, false, 1, lineContent.length + 1, 0, lineTokens.inflate(), null);
	}
	getViewLinesData(model, modelLineNumber, _fromOuputLineIndex, _toOutputLineIndex, _baseViewLineNumber, globalStartIndex, needed, result) {
		if (!needed[globalStartIndex]) {
			result[globalStartIndex] = null;
			return;
		}
		result[globalStartIndex] = this.getViewLineData(model, modelLineNumber, 0, _baseViewLineNumber);
	}
	getModelColumnOfViewPosition(_outputLineIndex, outputColumn) {
		return outputColumn;
	}
	getViewPositionOfModelPosition(deltaLineNumber, inputColumn) {
		return new Position$1(deltaLineNumber, inputColumn);
	}
	getViewLineNumberOfModelPosition(deltaLineNumber, _inputColumn) {
		return deltaLineNumber;
	}
	normalizePosition(outputLineIndex, outputPosition, affinity) {
		return outputPosition;
	}
	getInjectedTextAt(_outputLineIndex, _outputColumn) {
		return null;
	}
};
/**
* This projection hides the model line.
*/
var HiddenModelLineProjection = class HiddenModelLineProjection {
	static {
		this.INSTANCE = new HiddenModelLineProjection();
	}
	constructor() {}
	isVisible() {
		return false;
	}
	setVisible(isVisible) {
		if (!isVisible) return this;
		return IdentityModelLineProjection.INSTANCE;
	}
	getProjectionData() {
		return null;
	}
	getViewLineCount() {
		return 0;
	}
	getViewLineContent(_model, _modelLineNumber, _outputLineIndex) {
		throw new Error("Not supported");
	}
	getViewLineLength(_model, _modelLineNumber, _outputLineIndex) {
		throw new Error("Not supported");
	}
	getViewLineMinColumn(_model, _modelLineNumber, _outputLineIndex) {
		throw new Error("Not supported");
	}
	getViewLineMaxColumn(_model, _modelLineNumber, _outputLineIndex) {
		throw new Error("Not supported");
	}
	getViewLineContinuesWithWrappedLine(_outputLineIndex) {
		throw new Error("Not supported");
	}
	getViewLineData(_model, _modelLineNumber, _outputLineIndex, _baseViewLineNumber) {
		throw new Error("Not supported");
	}
	getViewLinesData(_model, _modelLineNumber, _fromOuputLineIndex, _toOutputLineIndex, _baseViewLineNumber, _globalStartIndex, _needed, _result) {
		throw new Error("Not supported");
	}
	getModelColumnOfViewPosition(_outputLineIndex, _outputColumn) {
		throw new Error("Not supported");
	}
	getViewPositionOfModelPosition(_deltaLineNumber, _inputColumn) {
		throw new Error("Not supported");
	}
	getViewLineNumberOfModelPosition(_deltaLineNumber, _inputColumn) {
		throw new Error("Not supported");
	}
	normalizePosition(outputLineIndex, outputPosition, affinity) {
		throw new Error("Not supported");
	}
	getInjectedTextAt(_outputLineIndex, _outputColumn) {
		throw new Error("Not supported");
	}
};
var _spaces = [""];
function spaces(count) {
	if (count >= _spaces.length) for (let i = 1; i <= count; i++) _spaces[i] = _makeSpaces(i);
	return _spaces[count];
}
function _makeSpaces(count) {
	return new Array(count + 1).join(" ");
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/coordinatesConverter.js
var IdentityCoordinatesConverter = class {
	constructor(model) {
		this._model = model;
	}
	_validPosition(pos) {
		return this._model.validatePosition(pos);
	}
	_validRange(range) {
		return this._model.validateRange(range);
	}
	convertViewPositionToModelPosition(viewPosition) {
		return this._validPosition(viewPosition);
	}
	convertViewRangeToModelRange(viewRange) {
		return this._validRange(viewRange);
	}
	validateViewPosition(_viewPosition, expectedModelPosition) {
		return this._validPosition(expectedModelPosition);
	}
	validateViewRange(_viewRange, expectedModelRange) {
		return this._validRange(expectedModelRange);
	}
	convertModelPositionToViewPosition(modelPosition) {
		return this._validPosition(modelPosition);
	}
	convertModelRangeToViewRange(modelRange) {
		return this._validRange(modelRange);
	}
	modelPositionIsVisible(modelPosition) {
		const lineCount = this._model.getLineCount();
		if (modelPosition.lineNumber < 1 || modelPosition.lineNumber > lineCount) return false;
		return true;
	}
	getModelLineViewLineCount(modelLineNumber) {
		return 1;
	}
	getViewLineNumberOfModelPosition(modelLineNumber, modelColumn) {
		return modelLineNumber;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/viewModel/viewModelLines.js
var ViewModelLinesFromProjectedModel = class {
	constructor(editorId, model, domLineBreaksComputerFactory, monospaceLineBreaksComputerFactory, fontInfo, tabSize, wrappingStrategy, wrappingColumn, wrappingIndent, wordBreak, wrapOnEscapedLineFeeds, useTwoCellFullwidthCharacters) {
		this._editorId = editorId;
		this.model = model;
		this._validModelVersionId = -1;
		this._domLineBreaksComputerFactory = domLineBreaksComputerFactory;
		this._monospaceLineBreaksComputerFactory = monospaceLineBreaksComputerFactory;
		this.fontInfo = fontInfo;
		this.tabSize = tabSize;
		this.wrappingStrategy = wrappingStrategy;
		this.wrappingColumn = wrappingColumn;
		this.wrappingIndent = wrappingIndent;
		this.wordBreak = wordBreak;
		this.wrapOnEscapedLineFeeds = wrapOnEscapedLineFeeds;
		this.useTwoCellFullwidthCharacters = useTwoCellFullwidthCharacters;
		this._constructLines(true, null);
	}
	dispose() {
		this.hiddenAreasDecorationIds = this.model.deltaDecorations(this.hiddenAreasDecorationIds, []);
	}
	createCoordinatesConverter() {
		return new CoordinatesConverter(this);
	}
	_constructLines(resetHiddenAreas, previousLineBreaks) {
		this.modelLineProjections = [];
		if (resetHiddenAreas) this.hiddenAreasDecorationIds = this.model.deltaDecorations(this.hiddenAreasDecorationIds, []);
		const lineCount = this.model.getLinesContent().length;
		const lineBreaksComputer = this.createLineBreaksComputer();
		for (let i = 0; i < lineCount; i++) lineBreaksComputer.addRequest(i + 1, previousLineBreaks ? previousLineBreaks[i] : null);
		const linesBreaks = lineBreaksComputer.finalize();
		const values = [];
		const hiddenAreas = this.hiddenAreasDecorationIds.map((areaId) => this.model.getDecorationRange(areaId)).sort(Range$2.compareRangesUsingStarts);
		let hiddenAreaStart = 1, hiddenAreaEnd = 0;
		let hiddenAreaIdx = -1;
		let nextLineNumberToUpdateHiddenArea = hiddenAreaIdx + 1 < hiddenAreas.length ? hiddenAreaEnd + 1 : lineCount + 2;
		for (let i = 0; i < lineCount; i++) {
			const lineNumber = i + 1;
			if (lineNumber === nextLineNumberToUpdateHiddenArea) {
				hiddenAreaIdx++;
				hiddenAreaStart = hiddenAreas[hiddenAreaIdx].startLineNumber;
				hiddenAreaEnd = hiddenAreas[hiddenAreaIdx].endLineNumber;
				nextLineNumberToUpdateHiddenArea = hiddenAreaIdx + 1 < hiddenAreas.length ? hiddenAreaEnd + 1 : lineCount + 2;
			}
			const isInHiddenArea = lineNumber >= hiddenAreaStart && lineNumber <= hiddenAreaEnd;
			const line = createModelLineProjection(linesBreaks[i], !isInHiddenArea);
			values[i] = line.getViewLineCount();
			this.modelLineProjections[i] = line;
		}
		this._validModelVersionId = this.model.getVersionId();
		this.projectedModelLineLineCounts = new ConstantTimePrefixSumComputer(values);
		this._ensureAtLeastOneVisibleLine();
	}
	getHiddenAreas() {
		return this.hiddenAreasDecorationIds.map((decId) => this.model.getDecorationRange(decId));
	}
	setHiddenAreas(_ranges) {
		const newRanges = normalizeLineRanges(_ranges.map((r) => this.model.validateRange(r)));
		const oldRanges = this.hiddenAreasDecorationIds.map((areaId) => this.model.getDecorationRange(areaId)).sort(Range$2.compareRangesUsingStarts);
		if (newRanges.length === oldRanges.length) {
			let hasDifference = false;
			for (let i = 0; i < newRanges.length; i++) if (!newRanges[i].equalsRange(oldRanges[i])) {
				hasDifference = true;
				break;
			}
			if (!hasDifference) return false;
		}
		const newDecorations = newRanges.map((r) => ({
			range: r,
			options: ModelDecorationOptions.EMPTY
		}));
		this.hiddenAreasDecorationIds = this.model.deltaDecorations(this.hiddenAreasDecorationIds, newDecorations);
		const hiddenAreas = newRanges;
		let hiddenAreaStart = 1, hiddenAreaEnd = 0;
		let hiddenAreaIdx = -1;
		let nextLineNumberToUpdateHiddenArea = hiddenAreaIdx + 1 < hiddenAreas.length ? hiddenAreaEnd + 1 : this.modelLineProjections.length + 2;
		let hasVisibleLine = false;
		for (let i = 0; i < this.modelLineProjections.length; i++) {
			const lineNumber = i + 1;
			if (lineNumber === nextLineNumberToUpdateHiddenArea) {
				hiddenAreaIdx++;
				hiddenAreaStart = hiddenAreas[hiddenAreaIdx].startLineNumber;
				hiddenAreaEnd = hiddenAreas[hiddenAreaIdx].endLineNumber;
				nextLineNumberToUpdateHiddenArea = hiddenAreaIdx + 1 < hiddenAreas.length ? hiddenAreaEnd + 1 : this.modelLineProjections.length + 2;
			}
			let lineChanged = false;
			if (lineNumber >= hiddenAreaStart && lineNumber <= hiddenAreaEnd) {
				if (this.modelLineProjections[i].isVisible()) {
					this.modelLineProjections[i] = this.modelLineProjections[i].setVisible(false);
					lineChanged = true;
				}
			} else {
				hasVisibleLine = true;
				if (!this.modelLineProjections[i].isVisible()) {
					this.modelLineProjections[i] = this.modelLineProjections[i].setVisible(true);
					lineChanged = true;
				}
			}
			if (lineChanged) {
				const newOutputLineCount = this.modelLineProjections[i].getViewLineCount();
				this.projectedModelLineLineCounts.setValue(i, newOutputLineCount);
			}
		}
		if (!hasVisibleLine) this.setHiddenAreas([]);
		return true;
	}
	modelPositionIsVisible(modelLineNumber, _modelColumn) {
		if (modelLineNumber < 1 || modelLineNumber > this.modelLineProjections.length) return false;
		return this.modelLineProjections[modelLineNumber - 1].isVisible();
	}
	getModelLineViewLineCount(modelLineNumber) {
		if (modelLineNumber < 1 || modelLineNumber > this.modelLineProjections.length) return 1;
		return this.modelLineProjections[modelLineNumber - 1].getViewLineCount();
	}
	setTabSize(newTabSize) {
		if (this.tabSize === newTabSize) return false;
		this.tabSize = newTabSize;
		this._constructLines(false, null);
		return true;
	}
	setWrappingSettings(fontInfo, wrappingStrategy, wrappingColumn, wrappingIndent, wordBreak, useTwoCellFullwidthCharacters) {
		const equalFontInfo = this.fontInfo.equals(fontInfo);
		const equalWrappingStrategy = this.wrappingStrategy === wrappingStrategy;
		const equalWrappingColumn = this.wrappingColumn === wrappingColumn;
		const equalWrappingIndent = this.wrappingIndent === wrappingIndent;
		const equalWordBreak = this.wordBreak === wordBreak;
		const equalUseTwoCellFullwidthCharacters = this.useTwoCellFullwidthCharacters === useTwoCellFullwidthCharacters;
		if (equalFontInfo && equalWrappingStrategy && equalWrappingColumn && equalWrappingIndent && equalWordBreak && equalUseTwoCellFullwidthCharacters) return false;
		const onlyWrappingColumnChanged = equalFontInfo && equalWrappingStrategy && !equalWrappingColumn && equalWrappingIndent && equalWordBreak && equalUseTwoCellFullwidthCharacters;
		this.fontInfo = fontInfo;
		this.wrappingStrategy = wrappingStrategy;
		this.wrappingColumn = wrappingColumn;
		this.wrappingIndent = wrappingIndent;
		this.wordBreak = wordBreak;
		this.useTwoCellFullwidthCharacters = useTwoCellFullwidthCharacters;
		let previousLineBreaks = null;
		if (onlyWrappingColumnChanged) {
			previousLineBreaks = [];
			for (let i = 0, len = this.modelLineProjections.length; i < len; i++) previousLineBreaks[i] = this.modelLineProjections[i].getProjectionData();
		}
		this._constructLines(false, previousLineBreaks);
		return true;
	}
	createLineBreaksComputer(_context) {
		const lineBreaksComputerFactory = this.wrappingStrategy === "advanced" ? this._domLineBreaksComputerFactory : this._monospaceLineBreaksComputerFactory;
		const context = _context ?? {
			getLineContent: (lineNumber) => {
				return this.model.getLineContent(lineNumber);
			},
			getLineInjectedText: (lineNumber) => {
				return this.model.getLineInjectedText(lineNumber, this._editorId);
			}
		};
		return lineBreaksComputerFactory.createLineBreaksComputer(context, this.fontInfo, this.tabSize, this.wrappingColumn, this.wrappingIndent, this.wordBreak, this.wrapOnEscapedLineFeeds, this.useTwoCellFullwidthCharacters);
	}
	onModelFlushed() {
		this._constructLines(true, null);
	}
	onModelLinesDeleted(versionId, fromLineNumber, toLineNumber) {
		if (!versionId || versionId <= this._validModelVersionId) return null;
		const outputFromLineNumber = fromLineNumber === 1 ? 1 : this.projectedModelLineLineCounts.getPrefixSum(fromLineNumber - 1) + 1;
		const outputToLineNumber = this.projectedModelLineLineCounts.getPrefixSum(toLineNumber);
		this.modelLineProjections.splice(fromLineNumber - 1, toLineNumber - fromLineNumber + 1);
		this.projectedModelLineLineCounts.removeValues(fromLineNumber - 1, toLineNumber - fromLineNumber + 1);
		return new ViewLinesDeletedEvent(outputFromLineNumber, outputToLineNumber);
	}
	onModelLinesInserted(versionId, fromLineNumber, _toLineNumber, lineBreaks) {
		if (!versionId || versionId <= this._validModelVersionId) return null;
		const isInHiddenArea = fromLineNumber > 2 && !this.modelLineProjections[fromLineNumber - 2].isVisible();
		const outputFromLineNumber = fromLineNumber === 1 ? 1 : this.projectedModelLineLineCounts.getPrefixSum(fromLineNumber - 1) + 1;
		let totalOutputLineCount = 0;
		const insertLines = [];
		const insertPrefixSumValues = [];
		for (let i = 0, len = lineBreaks.length; i < len; i++) {
			const line = createModelLineProjection(lineBreaks[i], !isInHiddenArea);
			insertLines.push(line);
			const outputLineCount = line.getViewLineCount();
			totalOutputLineCount += outputLineCount;
			insertPrefixSumValues[i] = outputLineCount;
		}
		this.modelLineProjections = this.modelLineProjections.slice(0, fromLineNumber - 1).concat(insertLines).concat(this.modelLineProjections.slice(fromLineNumber - 1));
		this.projectedModelLineLineCounts.insertValues(fromLineNumber - 1, insertPrefixSumValues);
		return new ViewLinesInsertedEvent(outputFromLineNumber, outputFromLineNumber + totalOutputLineCount - 1);
	}
	onModelLineChanged(versionId, lineNumber, lineBreakData) {
		if (versionId !== null && versionId <= this._validModelVersionId) return [
			false,
			null,
			null,
			null
		];
		const lineIndex = lineNumber - 1;
		const oldOutputLineCount = this.modelLineProjections[lineIndex].getViewLineCount();
		const line = createModelLineProjection(lineBreakData, this.modelLineProjections[lineIndex].isVisible());
		this.modelLineProjections[lineIndex] = line;
		const newOutputLineCount = this.modelLineProjections[lineIndex].getViewLineCount();
		let lineMappingChanged = false;
		let changeFrom = 0;
		let changeTo = -1;
		let insertFrom = 0;
		let insertTo = -1;
		let deleteFrom = 0;
		let deleteTo = -1;
		if (oldOutputLineCount > newOutputLineCount) {
			changeFrom = this.projectedModelLineLineCounts.getPrefixSum(lineNumber - 1) + 1;
			changeTo = changeFrom + newOutputLineCount - 1;
			deleteFrom = changeTo + 1;
			deleteTo = deleteFrom + (oldOutputLineCount - newOutputLineCount) - 1;
			lineMappingChanged = true;
		} else if (oldOutputLineCount < newOutputLineCount) {
			changeFrom = this.projectedModelLineLineCounts.getPrefixSum(lineNumber - 1) + 1;
			changeTo = changeFrom + oldOutputLineCount - 1;
			insertFrom = changeTo + 1;
			insertTo = insertFrom + (newOutputLineCount - oldOutputLineCount) - 1;
			lineMappingChanged = true;
		} else {
			changeFrom = this.projectedModelLineLineCounts.getPrefixSum(lineNumber - 1) + 1;
			changeTo = changeFrom + newOutputLineCount - 1;
		}
		this.projectedModelLineLineCounts.setValue(lineIndex, newOutputLineCount);
		const viewLinesChangedEvent = changeFrom <= changeTo ? new ViewLinesChangedEvent(changeFrom, changeTo - changeFrom + 1) : null;
		const viewLinesInsertedEvent = insertFrom <= insertTo ? new ViewLinesInsertedEvent(insertFrom, insertTo) : null;
		const viewLinesDeletedEvent = deleteFrom <= deleteTo ? new ViewLinesDeletedEvent(deleteFrom, deleteTo) : null;
		return [
			lineMappingChanged,
			viewLinesChangedEvent,
			viewLinesInsertedEvent,
			viewLinesDeletedEvent
		];
	}
	acceptVersionId(versionId) {
		this._validModelVersionId = versionId;
		this._ensureAtLeastOneVisibleLine();
	}
	_ensureAtLeastOneVisibleLine() {
		if (this.getViewLineCount() === 0 && this.modelLineProjections.length > 0) {
			this.modelLineProjections[0] = this.modelLineProjections[0].setVisible(true);
			this.projectedModelLineLineCounts.setValue(0, this.modelLineProjections[0].getViewLineCount());
		}
	}
	getViewLineCount() {
		return this.projectedModelLineLineCounts.getTotalSum();
	}
	_toValidViewLineNumber(viewLineNumber) {
		if (viewLineNumber < 1) return 1;
		const viewLineCount = this.getViewLineCount();
		if (viewLineNumber > viewLineCount) return viewLineCount;
		return viewLineNumber | 0;
	}
	getActiveIndentGuide(viewLineNumber, minLineNumber, maxLineNumber) {
		viewLineNumber = this._toValidViewLineNumber(viewLineNumber);
		minLineNumber = this._toValidViewLineNumber(minLineNumber);
		maxLineNumber = this._toValidViewLineNumber(maxLineNumber);
		const modelPosition = this.convertViewPositionToModelPosition(viewLineNumber, this.getViewLineMinColumn(viewLineNumber));
		const modelMinPosition = this.convertViewPositionToModelPosition(minLineNumber, this.getViewLineMinColumn(minLineNumber));
		const modelMaxPosition = this.convertViewPositionToModelPosition(maxLineNumber, this.getViewLineMinColumn(maxLineNumber));
		const result = this.model.guides.getActiveIndentGuide(modelPosition.lineNumber, modelMinPosition.lineNumber, modelMaxPosition.lineNumber);
		const viewStartPosition = this.convertModelPositionToViewPosition(result.startLineNumber, 1);
		const viewEndPosition = this.convertModelPositionToViewPosition(result.endLineNumber, this.model.getLineMaxColumn(result.endLineNumber));
		return {
			startLineNumber: viewStartPosition.lineNumber,
			endLineNumber: viewEndPosition.lineNumber,
			indent: result.indent
		};
	}
	getViewLineInfo(viewLineNumber) {
		viewLineNumber = this._toValidViewLineNumber(viewLineNumber);
		const r = this.projectedModelLineLineCounts.getIndexOf(viewLineNumber - 1);
		const lineIndex = r.index;
		const remainder = r.remainder;
		return new ViewLineInfo(lineIndex + 1, remainder);
	}
	getMinColumnOfViewLine(viewLineInfo) {
		return this.modelLineProjections[viewLineInfo.modelLineNumber - 1].getViewLineMinColumn(this.model, viewLineInfo.modelLineNumber, viewLineInfo.modelLineWrappedLineIdx);
	}
	getMaxColumnOfViewLine(viewLineInfo) {
		return this.modelLineProjections[viewLineInfo.modelLineNumber - 1].getViewLineMaxColumn(this.model, viewLineInfo.modelLineNumber, viewLineInfo.modelLineWrappedLineIdx);
	}
	getModelStartPositionOfViewLine(viewLineInfo) {
		const line = this.modelLineProjections[viewLineInfo.modelLineNumber - 1];
		const minViewColumn = line.getViewLineMinColumn(this.model, viewLineInfo.modelLineNumber, viewLineInfo.modelLineWrappedLineIdx);
		const column = line.getModelColumnOfViewPosition(viewLineInfo.modelLineWrappedLineIdx, minViewColumn);
		return new Position$1(viewLineInfo.modelLineNumber, column);
	}
	getModelEndPositionOfViewLine(viewLineInfo) {
		const line = this.modelLineProjections[viewLineInfo.modelLineNumber - 1];
		const maxViewColumn = line.getViewLineMaxColumn(this.model, viewLineInfo.modelLineNumber, viewLineInfo.modelLineWrappedLineIdx);
		const column = line.getModelColumnOfViewPosition(viewLineInfo.modelLineWrappedLineIdx, maxViewColumn);
		return new Position$1(viewLineInfo.modelLineNumber, column);
	}
	getViewLineInfosGroupedByModelRanges(viewStartLineNumber, viewEndLineNumber) {
		const startViewLine = this.getViewLineInfo(viewStartLineNumber);
		const endViewLine = this.getViewLineInfo(viewEndLineNumber);
		const result = new Array();
		let lastVisibleModelPos = this.getModelStartPositionOfViewLine(startViewLine);
		let viewLines = new Array();
		for (let curModelLine = startViewLine.modelLineNumber; curModelLine <= endViewLine.modelLineNumber; curModelLine++) {
			const line = this.modelLineProjections[curModelLine - 1];
			if (line.isVisible()) {
				const startOffset = curModelLine === startViewLine.modelLineNumber ? startViewLine.modelLineWrappedLineIdx : 0;
				const endOffset = curModelLine === endViewLine.modelLineNumber ? endViewLine.modelLineWrappedLineIdx + 1 : line.getViewLineCount();
				for (let i = startOffset; i < endOffset; i++) viewLines.push(new ViewLineInfo(curModelLine, i));
			}
			if (!line.isVisible() && lastVisibleModelPos) {
				const lastVisibleModelPos2 = new Position$1(curModelLine - 1, this.model.getLineMaxColumn(curModelLine - 1) + 1);
				const modelRange = Range$2.fromPositions(lastVisibleModelPos, lastVisibleModelPos2);
				result.push(new ViewLineInfoGroupedByModelRange(modelRange, viewLines));
				viewLines = [];
				lastVisibleModelPos = null;
			} else if (line.isVisible() && !lastVisibleModelPos) lastVisibleModelPos = new Position$1(curModelLine, 1);
		}
		if (lastVisibleModelPos) {
			const modelRange = Range$2.fromPositions(lastVisibleModelPos, this.getModelEndPositionOfViewLine(endViewLine));
			result.push(new ViewLineInfoGroupedByModelRange(modelRange, viewLines));
		}
		return result;
	}
	getViewLinesBracketGuides(viewStartLineNumber, viewEndLineNumber, activeViewPosition, options) {
		const modelActivePosition = activeViewPosition ? this.convertViewPositionToModelPosition(activeViewPosition.lineNumber, activeViewPosition.column) : null;
		const resultPerViewLine = [];
		for (const group of this.getViewLineInfosGroupedByModelRanges(viewStartLineNumber, viewEndLineNumber)) {
			const modelRangeStartLineNumber = group.modelRange.startLineNumber;
			const bracketGuidesPerModelLine = this.model.guides.getLinesBracketGuides(modelRangeStartLineNumber, group.modelRange.endLineNumber, modelActivePosition, options);
			for (const viewLineInfo of group.viewLines) {
				const result = bracketGuidesPerModelLine[viewLineInfo.modelLineNumber - modelRangeStartLineNumber].map((g) => {
					if (g.forWrappedLinesAfterColumn !== -1) {
						if (this.modelLineProjections[viewLineInfo.modelLineNumber - 1].getViewPositionOfModelPosition(0, g.forWrappedLinesAfterColumn).lineNumber >= viewLineInfo.modelLineWrappedLineIdx) return;
					}
					if (g.forWrappedLinesBeforeOrAtColumn !== -1) {
						if (this.modelLineProjections[viewLineInfo.modelLineNumber - 1].getViewPositionOfModelPosition(0, g.forWrappedLinesBeforeOrAtColumn).lineNumber < viewLineInfo.modelLineWrappedLineIdx) return;
					}
					if (!g.horizontalLine) return g;
					let column = -1;
					if (g.column !== -1) {
						const p = this.modelLineProjections[viewLineInfo.modelLineNumber - 1].getViewPositionOfModelPosition(0, g.column);
						if (p.lineNumber === viewLineInfo.modelLineWrappedLineIdx) column = p.column;
						else if (p.lineNumber < viewLineInfo.modelLineWrappedLineIdx) column = this.getMinColumnOfViewLine(viewLineInfo);
						else if (p.lineNumber > viewLineInfo.modelLineWrappedLineIdx) return;
					}
					const viewPosition = this.convertModelPositionToViewPosition(viewLineInfo.modelLineNumber, g.horizontalLine.endColumn);
					const p = this.modelLineProjections[viewLineInfo.modelLineNumber - 1].getViewPositionOfModelPosition(0, g.horizontalLine.endColumn);
					if (p.lineNumber === viewLineInfo.modelLineWrappedLineIdx) return new IndentGuide(g.visibleColumn, column, g.className, new IndentGuideHorizontalLine(g.horizontalLine.top, viewPosition.column), -1, -1);
					else if (p.lineNumber < viewLineInfo.modelLineWrappedLineIdx) return;
					else {
						if (g.visibleColumn !== -1) return;
						return new IndentGuide(g.visibleColumn, column, g.className, new IndentGuideHorizontalLine(g.horizontalLine.top, this.getMaxColumnOfViewLine(viewLineInfo)), -1, -1);
					}
				});
				resultPerViewLine.push(result.filter((r) => !!r));
			}
		}
		return resultPerViewLine;
	}
	getViewLinesIndentGuides(viewStartLineNumber, viewEndLineNumber) {
		viewStartLineNumber = this._toValidViewLineNumber(viewStartLineNumber);
		viewEndLineNumber = this._toValidViewLineNumber(viewEndLineNumber);
		const modelStart = this.convertViewPositionToModelPosition(viewStartLineNumber, this.getViewLineMinColumn(viewStartLineNumber));
		const modelEnd = this.convertViewPositionToModelPosition(viewEndLineNumber, this.getViewLineMaxColumn(viewEndLineNumber));
		let result = [];
		const resultRepeatCount = [];
		const resultRepeatOption = [];
		const modelStartLineIndex = modelStart.lineNumber - 1;
		const modelEndLineIndex = modelEnd.lineNumber - 1;
		let reqStart = null;
		for (let modelLineIndex = modelStartLineIndex; modelLineIndex <= modelEndLineIndex; modelLineIndex++) {
			const line = this.modelLineProjections[modelLineIndex];
			if (line.isVisible()) {
				const viewLineStartIndex = line.getViewLineNumberOfModelPosition(0, modelLineIndex === modelStartLineIndex ? modelStart.column : 1);
				const viewLineEndIndex = line.getViewLineNumberOfModelPosition(0, this.model.getLineMaxColumn(modelLineIndex + 1));
				const count = viewLineEndIndex - viewLineStartIndex + 1;
				let option = 0;
				if (count > 1 && line.getViewLineMinColumn(this.model, modelLineIndex + 1, viewLineEndIndex) === 1) option = viewLineStartIndex === 0 ? 1 : 2;
				resultRepeatCount.push(count);
				resultRepeatOption.push(option);
				if (reqStart === null) reqStart = new Position$1(modelLineIndex + 1, 0);
			} else if (reqStart !== null) {
				result = result.concat(this.model.guides.getLinesIndentGuides(reqStart.lineNumber, modelLineIndex));
				reqStart = null;
			}
		}
		if (reqStart !== null) {
			result = result.concat(this.model.guides.getLinesIndentGuides(reqStart.lineNumber, modelEnd.lineNumber));
			reqStart = null;
		}
		const viewLineCount = viewEndLineNumber - viewStartLineNumber + 1;
		const viewIndents = new Array(viewLineCount);
		let currIndex = 0;
		for (let i = 0, len = result.length; i < len; i++) {
			let value = result[i];
			const count = Math.min(viewLineCount - currIndex, resultRepeatCount[i]);
			const option = resultRepeatOption[i];
			let blockAtIndex;
			if (option === 2) blockAtIndex = 0;
			else if (option === 1) blockAtIndex = 1;
			else blockAtIndex = count;
			for (let j = 0; j < count; j++) {
				if (j === blockAtIndex) value = 0;
				viewIndents[currIndex++] = value;
			}
		}
		return viewIndents;
	}
	getViewLineContent(viewLineNumber) {
		const info = this.getViewLineInfo(viewLineNumber);
		return this.modelLineProjections[info.modelLineNumber - 1].getViewLineContent(this.model, info.modelLineNumber, info.modelLineWrappedLineIdx);
	}
	getViewLineLength(viewLineNumber) {
		const info = this.getViewLineInfo(viewLineNumber);
		return this.modelLineProjections[info.modelLineNumber - 1].getViewLineLength(this.model, info.modelLineNumber, info.modelLineWrappedLineIdx);
	}
	getViewLineMinColumn(viewLineNumber) {
		const info = this.getViewLineInfo(viewLineNumber);
		return this.modelLineProjections[info.modelLineNumber - 1].getViewLineMinColumn(this.model, info.modelLineNumber, info.modelLineWrappedLineIdx);
	}
	getViewLineMaxColumn(viewLineNumber) {
		const info = this.getViewLineInfo(viewLineNumber);
		return this.modelLineProjections[info.modelLineNumber - 1].getViewLineMaxColumn(this.model, info.modelLineNumber, info.modelLineWrappedLineIdx);
	}
	getViewLineContinuesWithWrappedLine(viewLineNumber) {
		const info = this.getViewLineInfo(viewLineNumber);
		return this.modelLineProjections[info.modelLineNumber - 1].getViewLineContinuesWithWrappedLine(info.modelLineWrappedLineIdx);
	}
	getViewLineData(viewLineNumber) {
		const info = this.getViewLineInfo(viewLineNumber);
		const baseViewLineNumber = this.projectedModelLineLineCounts.getPrefixSum(info.modelLineNumber - 1) + 1;
		return this.modelLineProjections[info.modelLineNumber - 1].getViewLineData(this.model, info.modelLineNumber, info.modelLineWrappedLineIdx, baseViewLineNumber);
	}
	getViewLinesData(viewStartLineNumber, viewEndLineNumber, needed) {
		viewStartLineNumber = this._toValidViewLineNumber(viewStartLineNumber);
		viewEndLineNumber = this._toValidViewLineNumber(viewEndLineNumber);
		const start = this.projectedModelLineLineCounts.getIndexOf(viewStartLineNumber - 1);
		let viewLineNumber = viewStartLineNumber;
		const startModelLineIndex = start.index;
		const startRemainder = start.remainder;
		const result = [];
		for (let modelLineIndex = startModelLineIndex, len = this.model.getLineCount(); modelLineIndex < len; modelLineIndex++) {
			const line = this.modelLineProjections[modelLineIndex];
			if (!line.isVisible()) continue;
			const fromViewLineIndex = modelLineIndex === startModelLineIndex ? startRemainder : 0;
			let remainingViewLineCount = line.getViewLineCount() - fromViewLineIndex;
			let lastLine = false;
			if (viewLineNumber + remainingViewLineCount > viewEndLineNumber) {
				lastLine = true;
				remainingViewLineCount = viewEndLineNumber - viewLineNumber + 1;
			}
			const baseViewLineNumber = this.projectedModelLineLineCounts.getPrefixSum(modelLineIndex) + 1;
			line.getViewLinesData(this.model, modelLineIndex + 1, fromViewLineIndex, remainingViewLineCount, baseViewLineNumber, viewLineNumber - viewStartLineNumber, needed, result);
			viewLineNumber += remainingViewLineCount;
			if (lastLine) break;
		}
		return result;
	}
	validateViewPosition(viewLineNumber, viewColumn, expectedModelPosition) {
		viewLineNumber = this._toValidViewLineNumber(viewLineNumber);
		const r = this.projectedModelLineLineCounts.getIndexOf(viewLineNumber - 1);
		const lineIndex = r.index;
		const remainder = r.remainder;
		const line = this.modelLineProjections[lineIndex];
		const minColumn = line.getViewLineMinColumn(this.model, lineIndex + 1, remainder);
		const maxColumn = line.getViewLineMaxColumn(this.model, lineIndex + 1, remainder);
		if (viewColumn < minColumn) viewColumn = minColumn;
		if (viewColumn > maxColumn) viewColumn = maxColumn;
		const computedModelColumn = line.getModelColumnOfViewPosition(remainder, viewColumn);
		if (this.model.validatePosition(new Position$1(lineIndex + 1, computedModelColumn)).equals(expectedModelPosition)) return new Position$1(viewLineNumber, viewColumn);
		return this.convertModelPositionToViewPosition(expectedModelPosition.lineNumber, expectedModelPosition.column);
	}
	validateViewRange(viewRange, expectedModelRange) {
		const validViewStart = this.validateViewPosition(viewRange.startLineNumber, viewRange.startColumn, expectedModelRange.getStartPosition());
		const validViewEnd = this.validateViewPosition(viewRange.endLineNumber, viewRange.endColumn, expectedModelRange.getEndPosition());
		return new Range$2(validViewStart.lineNumber, validViewStart.column, validViewEnd.lineNumber, validViewEnd.column);
	}
	convertViewPositionToModelPosition(viewLineNumber, viewColumn) {
		const info = this.getViewLineInfo(viewLineNumber);
		const inputColumn = this.modelLineProjections[info.modelLineNumber - 1].getModelColumnOfViewPosition(info.modelLineWrappedLineIdx, viewColumn);
		return this.model.validatePosition(new Position$1(info.modelLineNumber, inputColumn));
	}
	convertViewRangeToModelRange(viewRange) {
		const start = this.convertViewPositionToModelPosition(viewRange.startLineNumber, viewRange.startColumn);
		const end = this.convertViewPositionToModelPosition(viewRange.endLineNumber, viewRange.endColumn);
		return new Range$2(start.lineNumber, start.column, end.lineNumber, end.column);
	}
	convertModelPositionToViewPosition(_modelLineNumber, _modelColumn, affinity = 2, allowZeroLineNumber = false, belowHiddenRanges = false) {
		const validPosition = this.model.validatePosition(new Position$1(_modelLineNumber, _modelColumn));
		const inputLineNumber = validPosition.lineNumber;
		const inputColumn = validPosition.column;
		let lineIndex = inputLineNumber - 1, lineIndexChanged = false;
		if (belowHiddenRanges) while (lineIndex < this.modelLineProjections.length && !this.modelLineProjections[lineIndex].isVisible()) {
			lineIndex++;
			lineIndexChanged = true;
		}
		else while (lineIndex > 0 && !this.modelLineProjections[lineIndex].isVisible()) {
			lineIndex--;
			lineIndexChanged = true;
		}
		if (lineIndex === 0 && !this.modelLineProjections[lineIndex].isVisible()) return new Position$1(allowZeroLineNumber ? 0 : 1, 1);
		const deltaLineNumber = 1 + this.projectedModelLineLineCounts.getPrefixSum(lineIndex);
		let r;
		if (lineIndexChanged) {
			if (belowHiddenRanges) r = this.modelLineProjections[lineIndex].getViewPositionOfModelPosition(deltaLineNumber, 1, affinity);
			else r = this.modelLineProjections[lineIndex].getViewPositionOfModelPosition(deltaLineNumber, this.model.getLineMaxColumn(lineIndex + 1), affinity);
		} else r = this.modelLineProjections[inputLineNumber - 1].getViewPositionOfModelPosition(deltaLineNumber, inputColumn, affinity);
		return r;
	}
	/**
	* @param affinity The affinity in case of an empty range. Has no effect for non-empty ranges.
	*/
	convertModelRangeToViewRange(modelRange, affinity = 0) {
		if (modelRange.isEmpty()) {
			const start = this.convertModelPositionToViewPosition(modelRange.startLineNumber, modelRange.startColumn, affinity);
			return Range$2.fromPositions(start);
		} else {
			const start = this.convertModelPositionToViewPosition(modelRange.startLineNumber, modelRange.startColumn, 1);
			const end = this.convertModelPositionToViewPosition(modelRange.endLineNumber, modelRange.endColumn, 0);
			return new Range$2(start.lineNumber, start.column, end.lineNumber, end.column);
		}
	}
	getViewLineNumberOfModelPosition(modelLineNumber, modelColumn) {
		let lineIndex = modelLineNumber - 1;
		if (this.modelLineProjections[lineIndex].isVisible()) {
			const deltaLineNumber = 1 + this.projectedModelLineLineCounts.getPrefixSum(lineIndex);
			return this.modelLineProjections[lineIndex].getViewLineNumberOfModelPosition(deltaLineNumber, modelColumn);
		}
		while (lineIndex > 0 && !this.modelLineProjections[lineIndex].isVisible()) lineIndex--;
		if (lineIndex === 0 && !this.modelLineProjections[lineIndex].isVisible()) return 1;
		const deltaLineNumber = 1 + this.projectedModelLineLineCounts.getPrefixSum(lineIndex);
		return this.modelLineProjections[lineIndex].getViewLineNumberOfModelPosition(deltaLineNumber, this.model.getLineMaxColumn(lineIndex + 1));
	}
	getDecorationsInRange(range, ownerId, filterOutValidation, filterFontDecorations, onlyMinimapDecorations, onlyMarginDecorations) {
		const modelStart = this.convertViewPositionToModelPosition(range.startLineNumber, range.startColumn);
		const modelEnd = this.convertViewPositionToModelPosition(range.endLineNumber, range.endColumn);
		if (modelEnd.lineNumber - modelStart.lineNumber <= range.endLineNumber - range.startLineNumber) return this.model.getDecorationsInRange(new Range$2(modelStart.lineNumber, 1, modelEnd.lineNumber, modelEnd.column), ownerId, filterOutValidation, filterFontDecorations, onlyMinimapDecorations, onlyMarginDecorations);
		let result = [];
		const modelStartLineIndex = modelStart.lineNumber - 1;
		const modelEndLineIndex = modelEnd.lineNumber - 1;
		let reqStart = null;
		for (let modelLineIndex = modelStartLineIndex; modelLineIndex <= modelEndLineIndex; modelLineIndex++) if (this.modelLineProjections[modelLineIndex].isVisible()) {
			if (reqStart === null) reqStart = new Position$1(modelLineIndex + 1, modelLineIndex === modelStartLineIndex ? modelStart.column : 1);
		} else if (reqStart !== null) {
			const maxLineColumn = this.model.getLineMaxColumn(modelLineIndex);
			result = result.concat(this.model.getDecorationsInRange(new Range$2(reqStart.lineNumber, reqStart.column, modelLineIndex, maxLineColumn), ownerId, filterOutValidation, filterFontDecorations, onlyMinimapDecorations));
			reqStart = null;
		}
		if (reqStart !== null) {
			result = result.concat(this.model.getDecorationsInRange(new Range$2(reqStart.lineNumber, reqStart.column, modelEnd.lineNumber, modelEnd.column), ownerId, filterOutValidation, filterFontDecorations, onlyMinimapDecorations));
			reqStart = null;
		}
		result.sort((a, b) => {
			const res = Range$2.compareRangesUsingStarts(a.range, b.range);
			if (res === 0) {
				if (a.id < b.id) return -1;
				if (a.id > b.id) return 1;
				return 0;
			}
			return res;
		});
		const finalResult = [];
		let finalResultLen = 0;
		let prevDecId = null;
		for (const dec of result) {
			const decId = dec.id;
			if (prevDecId === decId) continue;
			prevDecId = decId;
			finalResult[finalResultLen++] = dec;
		}
		return finalResult;
	}
	getInjectedTextAt(position) {
		const info = this.getViewLineInfo(position.lineNumber);
		return this.modelLineProjections[info.modelLineNumber - 1].getInjectedTextAt(info.modelLineWrappedLineIdx, position.column);
	}
	normalizePosition(position, affinity) {
		const info = this.getViewLineInfo(position.lineNumber);
		return this.modelLineProjections[info.modelLineNumber - 1].normalizePosition(info.modelLineWrappedLineIdx, position, affinity);
	}
	getLineIndentColumn(lineNumber) {
		const info = this.getViewLineInfo(lineNumber);
		if (info.modelLineWrappedLineIdx === 0) return this.model.getLineIndentColumn(info.modelLineNumber);
		return 0;
	}
};
/**
* Overlapping unsorted ranges:
* [   )      [ )       [  )
*    [    )      [       )
* ->
* Non overlapping sorted ranges:
* [       )  [ ) [        )
*
* Note: This function only considers line information! Columns are ignored.
*/
function normalizeLineRanges(ranges) {
	if (ranges.length === 0) return [];
	const sortedRanges = ranges.slice();
	sortedRanges.sort(Range$2.compareRangesUsingStarts);
	const result = [];
	let currentRangeStart = sortedRanges[0].startLineNumber;
	let currentRangeEnd = sortedRanges[0].endLineNumber;
	for (let i = 1, len = sortedRanges.length; i < len; i++) {
		const range = sortedRanges[i];
		if (range.startLineNumber > currentRangeEnd + 1) {
			result.push(new Range$2(currentRangeStart, 1, currentRangeEnd, 1));
			currentRangeStart = range.startLineNumber;
			currentRangeEnd = range.endLineNumber;
		} else if (range.endLineNumber > currentRangeEnd) currentRangeEnd = range.endLineNumber;
	}
	result.push(new Range$2(currentRangeStart, 1, currentRangeEnd, 1));
	return result;
}
/**
* Represents a view line. Can be used to efficiently query more information about it.
*/
var ViewLineInfo = class {
	constructor(modelLineNumber, modelLineWrappedLineIdx) {
		this.modelLineNumber = modelLineNumber;
		this.modelLineWrappedLineIdx = modelLineWrappedLineIdx;
	}
};
/**
* A list of view lines that have a contiguous span in the model.
*/
var ViewLineInfoGroupedByModelRange = class {
	constructor(modelRange, viewLines) {
		this.modelRange = modelRange;
		this.viewLines = viewLines;
	}
};
var CoordinatesConverter = class {
	constructor(lines) {
		this._lines = lines;
	}
	convertViewPositionToModelPosition(viewPosition) {
		return this._lines.convertViewPositionToModelPosition(viewPosition.lineNumber, viewPosition.column);
	}
	convertViewRangeToModelRange(viewRange) {
		return this._lines.convertViewRangeToModelRange(viewRange);
	}
	validateViewPosition(viewPosition, expectedModelPosition) {
		return this._lines.validateViewPosition(viewPosition.lineNumber, viewPosition.column, expectedModelPosition);
	}
	validateViewRange(viewRange, expectedModelRange) {
		return this._lines.validateViewRange(viewRange, expectedModelRange);
	}
	convertModelPositionToViewPosition(modelPosition, affinity, allowZero, belowHiddenRanges) {
		return this._lines.convertModelPositionToViewPosition(modelPosition.lineNumber, modelPosition.column, affinity, allowZero, belowHiddenRanges);
	}
	convertModelRangeToViewRange(modelRange, affinity) {
		return this._lines.convertModelRangeToViewRange(modelRange, affinity);
	}
	modelPositionIsVisible(modelPosition) {
		return this._lines.modelPositionIsVisible(modelPosition.lineNumber, modelPosition.column);
	}
	getModelLineViewLineCount(modelLineNumber) {
		return this._lines.getModelLineViewLineCount(modelLineNumber);
	}
	getViewLineNumberOfModelPosition(modelLineNumber, modelColumn) {
		return this._lines.getViewLineNumberOfModelPosition(modelLineNumber, modelColumn);
	}
};
var ViewModelLinesFromModelAsIs = class {
	constructor(model) {
		this.model = model;
	}
	dispose() {}
	createCoordinatesConverter() {
		return new IdentityCoordinatesConverter(this.model);
	}
	getHiddenAreas() {
		return [];
	}
	setHiddenAreas(_ranges) {
		return false;
	}
	setTabSize(_newTabSize) {
		return false;
	}
	setWrappingSettings(_fontInfo, _wrappingStrategy, _wrappingColumn, _wrappingIndent) {
		return false;
	}
	createLineBreaksComputer() {
		const result = [];
		return {
			addRequest: (lineNumber, previousLineBreakData) => {
				result.push(null);
			},
			finalize: () => {
				return result;
			}
		};
	}
	onModelFlushed() {}
	onModelLinesDeleted(_versionId, fromLineNumber, toLineNumber) {
		return new ViewLinesDeletedEvent(fromLineNumber, toLineNumber);
	}
	onModelLinesInserted(_versionId, fromLineNumber, toLineNumber, lineBreaks) {
		return new ViewLinesInsertedEvent(fromLineNumber, toLineNumber);
	}
	onModelLineChanged(_versionId, lineNumber, lineBreakData) {
		return [
			false,
			new ViewLinesChangedEvent(lineNumber, 1),
			null,
			null
		];
	}
	acceptVersionId(_versionId) {}
	getViewLineCount() {
		return this.model.getLineCount();
	}
	getActiveIndentGuide(viewLineNumber, _minLineNumber, _maxLineNumber) {
		return {
			startLineNumber: viewLineNumber,
			endLineNumber: viewLineNumber,
			indent: 0
		};
	}
	getViewLinesBracketGuides(startLineNumber, endLineNumber, activePosition) {
		return new Array(endLineNumber - startLineNumber + 1).fill([]);
	}
	getViewLinesIndentGuides(viewStartLineNumber, viewEndLineNumber) {
		const viewLineCount = viewEndLineNumber - viewStartLineNumber + 1;
		const result = new Array(viewLineCount);
		for (let i = 0; i < viewLineCount; i++) result[i] = 0;
		return result;
	}
	getViewLineContent(viewLineNumber) {
		return this.model.getLineContent(viewLineNumber);
	}
	getViewLineLength(viewLineNumber) {
		return this.model.getLineLength(viewLineNumber);
	}
	getViewLineMinColumn(viewLineNumber) {
		return this.model.getLineMinColumn(viewLineNumber);
	}
	getViewLineMaxColumn(viewLineNumber) {
		return this.model.getLineMaxColumn(viewLineNumber);
	}
	getViewLineContinuesWithWrappedLine(_viewLineNumber) {
		return false;
	}
	getViewLineData(viewLineNumber) {
		const lineTokens = this.model.tokenization.getLineTokens(viewLineNumber);
		const lineContent = lineTokens.getLineContent();
		return new ViewLineData(lineContent, false, 1, lineContent.length + 1, 0, lineTokens.inflate(), null);
	}
	getViewLinesData(viewStartLineNumber, viewEndLineNumber, needed) {
		const lineCount = this.model.getLineCount();
		viewStartLineNumber = Math.min(Math.max(1, viewStartLineNumber), lineCount);
		viewEndLineNumber = Math.min(Math.max(1, viewEndLineNumber), lineCount);
		const result = [];
		for (let lineNumber = viewStartLineNumber; lineNumber <= viewEndLineNumber; lineNumber++) {
			const idx = lineNumber - viewStartLineNumber;
			result[idx] = needed[idx] ? this.getViewLineData(lineNumber) : null;
		}
		return result;
	}
	getDecorationsInRange(range, ownerId, filterOutValidation, filterFontDecorations, onlyMinimapDecorations, onlyMarginDecorations) {
		return this.model.getDecorationsInRange(range, ownerId, filterOutValidation, filterFontDecorations, onlyMinimapDecorations, onlyMarginDecorations);
	}
	normalizePosition(position, affinity) {
		return this.model.normalizePosition(position, affinity);
	}
	getLineIndentColumn(lineNumber) {
		return this.model.getLineIndentColumn(lineNumber);
	}
	getInjectedTextAt(position) {
		return null;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/viewModel/glyphLanesModel.js
var MAX_LANE = GlyphMarginLane.Right;
var GlyphMarginLanesModel = class {
	constructor(maxLine) {
		this.persist = 0;
		this._requiredLanes = 1;
		this.lanes = new Uint8Array(Math.ceil((maxLine + 1) * MAX_LANE / 8));
	}
	reset(maxLine) {
		const bytes = Math.ceil((maxLine + 1) * MAX_LANE / 8);
		if (this.lanes.length < bytes) this.lanes = new Uint8Array(bytes);
		else this.lanes.fill(0);
		this._requiredLanes = 1;
	}
	get requiredLanes() {
		return this._requiredLanes;
	}
	push(lane, range, persist) {
		if (persist) this.persist |= 1 << lane - 1;
		for (let i = range.startLineNumber; i <= range.endLineNumber; i++) {
			const bit = MAX_LANE * i + (lane - 1);
			this.lanes[bit >>> 3] |= 1 << bit % 8;
			this._requiredLanes = Math.max(this._requiredLanes, this.countAtLine(i));
		}
	}
	getLanesAtLine(lineNumber) {
		const lanes = [];
		let bit = MAX_LANE * lineNumber;
		for (let i = 0; i < MAX_LANE; i++) {
			if (this.persist & 1 << i || this.lanes[bit >>> 3] & 1 << bit % 8) lanes.push(i + 1);
			bit++;
		}
		return lanes.length ? lanes : [GlyphMarginLane.Center];
	}
	countAtLine(lineNumber) {
		let bit = MAX_LANE * lineNumber;
		let count = 0;
		for (let i = 0; i < MAX_LANE; i++) {
			if (this.persist & 1 << i || this.lanes[bit >>> 3] & 1 << bit % 8) count++;
			bit++;
		}
		return count;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/viewModel/viewModelImpl.js
var ViewModel$1 = class extends Disposable {
	constructor(editorId, configuration, model, domLineBreaksComputerFactory, monospaceLineBreaksComputerFactory, scheduleAtNextAnimationFrame, languageConfigurationService, _themeService, _attachedView, _transactionalTarget) {
		super();
		this.languageConfigurationService = languageConfigurationService;
		this._themeService = _themeService;
		this._attachedView = _attachedView;
		this._transactionalTarget = _transactionalTarget;
		this.hiddenAreasModel = new HiddenAreasModel();
		this.previousHiddenAreas = [];
		this._editorId = editorId;
		this._configuration = configuration;
		this.model = model;
		this._eventDispatcher = new ViewModelEventDispatcher();
		this.onEvent = this._eventDispatcher.onEvent;
		this.cursorConfig = new CursorConfiguration(this.model.getLanguageId(), this.model.getOptions(), this._configuration, this.languageConfigurationService);
		this._updateConfigurationViewLineCount = this._register(new RunOnceScheduler(() => this._updateConfigurationViewLineCountNow(), 0));
		this._hasFocus = false;
		this._viewportStart = ViewportStart.create(this.model);
		this.glyphLanes = new GlyphMarginLanesModel(0);
		if (this.model.isTooLargeForTokenization()) this._lines = new ViewModelLinesFromModelAsIs(this.model);
		else {
			const options = this._configuration.options;
			const fontInfo = options.get(59);
			const wrappingStrategy = options.get(156);
			const wrappingInfo = options.get(167);
			const wrappingIndent = options.get(155);
			const wordBreak = options.get(146);
			const wrapOnEscapedLineFeeds = options.get(160);
			const useTwoCellFullwidthCharacters = options.get(176) === "twoCells";
			this._lines = new ViewModelLinesFromProjectedModel(this._editorId, this.model, domLineBreaksComputerFactory, monospaceLineBreaksComputerFactory, fontInfo, this.model.getOptions().tabSize, wrappingStrategy, wrappingInfo.wrappingColumn, wrappingIndent, wordBreak, wrapOnEscapedLineFeeds, useTwoCellFullwidthCharacters);
		}
		this.coordinatesConverter = this._lines.createCoordinatesConverter();
		this._cursor = this._register(new CursorsController(model, this, this.coordinatesConverter, this.cursorConfig));
		this.viewLayout = this._register(new ViewLayout(this._configuration, this.getLineCount(), this._getCustomLineHeights(), scheduleAtNextAnimationFrame));
		this._register(this.viewLayout.onDidScroll((e) => {
			if (e.scrollTopChanged) this._handleVisibleLinesChanged();
			if (e.scrollTopChanged) this._viewportStart.invalidate();
			this._eventDispatcher.emitSingleViewEvent(new ViewScrollChangedEvent(e));
			this._eventDispatcher.emitOutgoingEvent(new ScrollChangedEvent(e.oldScrollWidth, e.oldScrollLeft, e.oldScrollHeight, e.oldScrollTop, e.scrollWidth, e.scrollLeft, e.scrollHeight, e.scrollTop));
		}));
		this._register(this.viewLayout.onDidContentSizeChange((e) => {
			this._eventDispatcher.emitOutgoingEvent(e);
		}));
		this._decorations = new ViewModelDecorations(this._editorId, this.model, this._configuration, this._lines, this.coordinatesConverter);
		this._registerModelEvents();
		this._register(this._configuration.onDidChangeFast((e) => {
			try {
				const eventsCollector = this._eventDispatcher.beginEmitViewEvents();
				this._onConfigurationChanged(eventsCollector, e);
			} finally {
				this._eventDispatcher.endEmitViewEvents();
			}
		}));
		this._register(MinimapTokensColorTracker.getInstance().onDidChange(() => {
			this._eventDispatcher.emitSingleViewEvent(new ViewTokensColorsChangedEvent());
		}));
		this._register(this._themeService.onDidColorThemeChange((theme) => {
			this._invalidateDecorationsColorCache();
			this._eventDispatcher.emitSingleViewEvent(new ViewThemeChangedEvent(theme));
		}));
		this._updateConfigurationViewLineCountNow();
		this.model.registerViewModel(this);
	}
	dispose() {
		super.dispose();
		this._decorations.dispose();
		this._lines.dispose();
		this._viewportStart.dispose();
		this._eventDispatcher.dispose();
		this.model.unregisterViewModel(this);
	}
	getEditorOption(id) {
		return this._configuration.options.get(id);
	}
	createLineBreaksComputer(context) {
		return this._lines.createLineBreaksComputer(context);
	}
	addViewEventHandler(eventHandler) {
		this._eventDispatcher.addViewEventHandler(eventHandler);
	}
	removeViewEventHandler(eventHandler) {
		this._eventDispatcher.removeViewEventHandler(eventHandler);
	}
	_getCustomLineHeights() {
		if (!this._configuration.options.get(5)) return [];
		const decorations = this.model.getCustomLineHeightsDecorations(this._editorId);
		return CustomLineHeightData.fromDecorations(decorations, this.coordinatesConverter, this._configuration);
	}
	_getCustomLineHeightsForLines(fromLineNumber, toLineNumber) {
		if (!this._configuration.options.get(5)) return [];
		const modelRange = new Range$2(fromLineNumber, 1, toLineNumber, this.model.getLineMaxColumn(toLineNumber));
		const decorations = this.model.getCustomLineHeightsDecorationsInRange(modelRange, this._editorId);
		return CustomLineHeightData.fromDecorations(decorations, this.coordinatesConverter, this._configuration);
	}
	_updateConfigurationViewLineCountNow() {
		this._configuration.setViewLineCount(this._lines.getViewLineCount());
	}
	getModelVisibleRanges() {
		const linesViewportData = this.viewLayout.getLinesViewportData();
		const viewVisibleRange = new Range$2(linesViewportData.startLineNumber, this.getLineMinColumn(linesViewportData.startLineNumber), linesViewportData.endLineNumber, this.getLineMaxColumn(linesViewportData.endLineNumber));
		return this._toModelVisibleRanges(viewVisibleRange);
	}
	visibleLinesStabilized() {
		const modelVisibleRanges = this.getModelVisibleRanges();
		this._attachedView.setVisibleLines(modelVisibleRanges, true);
	}
	_handleVisibleLinesChanged() {
		const modelVisibleRanges = this.getModelVisibleRanges();
		this._attachedView.setVisibleLines(modelVisibleRanges, false);
	}
	setHasFocus(hasFocus) {
		this._hasFocus = hasFocus;
		this._cursor.setHasFocus(hasFocus);
		this._eventDispatcher.emitSingleViewEvent(new ViewFocusChangedEvent(hasFocus));
		this._eventDispatcher.emitOutgoingEvent(new FocusChangedEvent(!hasFocus, hasFocus));
	}
	setHasWidgetFocus(hasWidgetFocus) {
		this._eventDispatcher.emitOutgoingEvent(new WidgetFocusChangedEvent(!hasWidgetFocus, hasWidgetFocus));
	}
	onCompositionStart() {
		this._eventDispatcher.emitSingleViewEvent(new ViewCompositionStartEvent());
	}
	onCompositionEnd() {
		this._eventDispatcher.emitSingleViewEvent(new ViewCompositionEndEvent());
	}
	_captureStableViewport() {
		if (this._viewportStart.isValid && this.viewLayout.getCurrentScrollTop() > 0) {
			const previousViewportStartViewPosition = new Position$1(this._viewportStart.viewLineNumber, this.getLineMinColumn(this._viewportStart.viewLineNumber));
			return new StableViewport(this.coordinatesConverter.convertViewPositionToModelPosition(previousViewportStartViewPosition), this._viewportStart.startLineDelta);
		}
		return new StableViewport(null, 0);
	}
	_onConfigurationChanged(eventsCollector, e) {
		const stableViewport = this._captureStableViewport();
		const options = this._configuration.options;
		const fontInfo = options.get(59);
		const wrappingStrategy = options.get(156);
		const wrappingInfo = options.get(167);
		const wrappingIndent = options.get(155);
		const wordBreak = options.get(146);
		const useTwoCellFullwidthCharacters = options.get(176) === "twoCells";
		if (this._lines.setWrappingSettings(fontInfo, wrappingStrategy, wrappingInfo.wrappingColumn, wrappingIndent, wordBreak, useTwoCellFullwidthCharacters)) {
			eventsCollector.emitViewEvent(new ViewFlushedEvent());
			eventsCollector.emitViewEvent(new ViewLineMappingChangedEvent());
			eventsCollector.emitViewEvent(new ViewDecorationsChangedEvent(null));
			this._cursor.onLineMappingChanged(eventsCollector);
			this._decorations.onLineMappingChanged();
			this.viewLayout.onFlushed(this.getLineCount(), this._getCustomLineHeights());
			this._updateConfigurationViewLineCount.schedule();
		}
		if (e.hasChanged(104)) {
			this._decorations.reset();
			eventsCollector.emitViewEvent(new ViewDecorationsChangedEvent(null));
		}
		if (e.hasChanged(112)) {
			this._decorations.reset();
			eventsCollector.emitViewEvent(new ViewDecorationsChangedEvent(null));
		}
		eventsCollector.emitViewEvent(new ViewConfigurationChangedEvent(e));
		this.viewLayout.onConfigurationChanged(e);
		stableViewport.recoverViewportStart(this.coordinatesConverter, this.viewLayout);
		if (CursorConfiguration.shouldRecreate(e)) {
			this.cursorConfig = new CursorConfiguration(this.model.getLanguageId(), this.model.getOptions(), this._configuration, this.languageConfigurationService);
			this._cursor.updateConfiguration(this.cursorConfig);
		}
	}
	/**
	* Gets called directly by the text model.
	*/
	onDidChangeContentOrInjectedText(e) {
		try {
			const eventsCollector = this._eventDispatcher.beginEmitViewEvents();
			let hadOtherModelChange = false;
			let hadModelLineChangeThatChangedLineMapping = false;
			const changes = e instanceof InternalModelContentChangeEvent ? e.rawContentChangedEvent.changes : e.changes;
			const versionId = e instanceof InternalModelContentChangeEvent ? e.rawContentChangedEvent.versionId : null;
			const lineBreaksComputer = this._lines.createLineBreaksComputer();
			for (const change of changes) switch (change.changeType) {
				case 4:
					for (let i = 0; i < change.count; i++) lineBreaksComputer.addRequest(change.fromLineNumberPostEdit + i, null);
					break;
				case 2: lineBreaksComputer.addRequest(change.lineNumberPostEdit, null);
			}
			const lineBreaks = lineBreaksComputer.finalize();
			const lineBreakQueue = new ArrayQueue(lineBreaks);
			const customLineHeightRangesToInsert = [];
			for (const change of changes) switch (change.changeType) {
				case 1:
					this._lines.onModelFlushed();
					eventsCollector.emitViewEvent(new ViewFlushedEvent());
					this._decorations.reset();
					this.viewLayout.onFlushed(this.getLineCount(), this._getCustomLineHeights());
					hadOtherModelChange = true;
					break;
				case 3: {
					const linesDeletedEvent = this._lines.onModelLinesDeleted(versionId, change.fromLineNumber, change.toLineNumber);
					if (linesDeletedEvent !== null) {
						eventsCollector.emitViewEvent(linesDeletedEvent);
						this.viewLayout.onLinesDeleted(linesDeletedEvent.fromLineNumber, linesDeletedEvent.toLineNumber);
						customLineHeightRangesToInsert.push({
							fromLineNumber: change.lastUntouchedLinePostEdit,
							toLineNumber: change.lastUntouchedLinePostEdit
						});
					}
					hadOtherModelChange = true;
					break;
				}
				case 4: {
					const insertedLineBreaks = lineBreakQueue.takeCount(change.count);
					const linesInsertedEvent = this._lines.onModelLinesInserted(versionId, change.fromLineNumber, change.toLineNumber, insertedLineBreaks);
					if (linesInsertedEvent !== null) {
						eventsCollector.emitViewEvent(linesInsertedEvent);
						this.viewLayout.onLinesInserted(linesInsertedEvent.fromLineNumber, linesInsertedEvent.toLineNumber);
						customLineHeightRangesToInsert.push({
							fromLineNumber: change.fromLineNumberPostEdit,
							toLineNumber: change.toLineNumberPostEdit
						});
					}
					hadOtherModelChange = true;
					break;
				}
				case 2: {
					const changedLineBreakData = lineBreakQueue.dequeue();
					const [lineMappingChanged, linesChangedEvent, linesInsertedEvent, linesDeletedEvent] = this._lines.onModelLineChanged(versionId, change.lineNumber, changedLineBreakData);
					hadModelLineChangeThatChangedLineMapping = lineMappingChanged;
					if (linesChangedEvent) eventsCollector.emitViewEvent(linesChangedEvent);
					if (linesInsertedEvent) {
						eventsCollector.emitViewEvent(linesInsertedEvent);
						this.viewLayout.onLinesInserted(linesInsertedEvent.fromLineNumber, linesInsertedEvent.toLineNumber);
						customLineHeightRangesToInsert.push({
							fromLineNumber: change.lineNumberPostEdit,
							toLineNumber: change.lineNumberPostEdit
						});
					}
					if (linesDeletedEvent) {
						eventsCollector.emitViewEvent(linesDeletedEvent);
						this.viewLayout.onLinesDeleted(linesDeletedEvent.fromLineNumber, linesDeletedEvent.toLineNumber);
						customLineHeightRangesToInsert.push({
							fromLineNumber: change.lineNumberPostEdit,
							toLineNumber: change.lineNumberPostEdit
						});
					}
					break;
				}
			}
			if (versionId !== null) this._lines.acceptVersionId(versionId);
			if (customLineHeightRangesToInsert.length > 0) this.viewLayout.changeSpecialLineHeights((accessor) => {
				for (const range of customLineHeightRangesToInsert) {
					const customLineHeights = this._getCustomLineHeightsForLines(range.fromLineNumber, range.toLineNumber);
					for (const data of customLineHeights) accessor.insertOrChangeCustomLineHeight(data.decorationId, data.startLineNumber, data.endLineNumber, data.lineHeight);
				}
			});
			this.viewLayout.onHeightMaybeChanged();
			if (!hadOtherModelChange && hadModelLineChangeThatChangedLineMapping) {
				eventsCollector.emitViewEvent(new ViewLineMappingChangedEvent());
				eventsCollector.emitViewEvent(new ViewDecorationsChangedEvent(null));
				this._cursor.onLineMappingChanged(eventsCollector);
				this._decorations.onLineMappingChanged();
			}
		} finally {
			this._eventDispatcher.endEmitViewEvents();
		}
		const viewportStartWasValid = this._viewportStart.isValid;
		this._viewportStart.invalidate();
		this._configuration.setModelLineCount(this.model.getLineCount());
		this._updateConfigurationViewLineCountNow();
		if (!this._hasFocus && this.model.getAttachedEditorCount() >= 2 && viewportStartWasValid) {
			const modelRange = this.model._getTrackedRange(this._viewportStart.modelTrackedRange);
			if (modelRange) {
				const viewPosition = this.coordinatesConverter.convertModelPositionToViewPosition(modelRange.getStartPosition());
				const viewPositionTop = this.viewLayout.getVerticalOffsetForLineNumber(viewPosition.lineNumber);
				this.viewLayout.setScrollPosition({ scrollTop: viewPositionTop + this._viewportStart.startLineDelta }, 1);
			}
		}
		this._handleVisibleLinesChanged();
	}
	/**
	* Gets called directly by the text model.
	*/
	emitContentChangeEvent(e) {
		this._emitViewEvent((eventsCollector) => {
			if (e instanceof InternalModelContentChangeEvent) eventsCollector.emitOutgoingEvent(new ModelContentChangedEvent(e.contentChangedEvent));
			this._cursor.onModelContentChanged(eventsCollector, e);
		});
	}
	_registerModelEvents() {
		if (this._configuration.options.get(5)) this._register(this.model.onDidChangeLineHeight((e) => {
			const filteredChanges = e.changes.filter((change) => change.ownerId === this._editorId || change.ownerId === 0);
			this.viewLayout.changeSpecialLineHeights((accessor) => {
				for (const change of filteredChanges) {
					const { decorationId, lineNumber, lineHeightMultiplier } = change;
					const viewRange = this.coordinatesConverter.convertModelRangeToViewRange(new Range$2(lineNumber, 1, lineNumber, this.model.getLineMaxColumn(lineNumber)));
					if (lineHeightMultiplier !== null) accessor.insertOrChangeCustomLineHeight(decorationId, viewRange.startLineNumber, viewRange.endLineNumber, lineHeightMultiplier * this._configuration.options.get(75));
					else accessor.removeCustomLineHeight(decorationId);
				}
			});
			if (filteredChanges.length > 0) {
				const filteredEvent = new ModelLineHeightChangedEvent$1(filteredChanges);
				this._eventDispatcher.emitOutgoingEvent(new ModelLineHeightChangedEvent(filteredEvent));
			}
		}));
		if (this._configuration.options.get(173)) this._register(this.model.onDidChangeFont((e) => {
			const filteredChanges = e.changes.filter((change) => change.ownerId === this._editorId || change.ownerId === 0);
			if (filteredChanges.length > 0) {
				const filteredEvent = new ModelFontChangedEvent$1(filteredChanges);
				this._eventDispatcher.emitOutgoingEvent(new ModelFontChangedEvent(filteredEvent));
			}
		}));
		this._register(this.model.onDidChangeTokens((e) => {
			const viewRanges = [];
			for (let j = 0, lenJ = e.ranges.length; j < lenJ; j++) {
				const modelRange = e.ranges[j];
				const viewStartLineNumber = this.coordinatesConverter.convertModelPositionToViewPosition(new Position$1(modelRange.fromLineNumber, 1)).lineNumber;
				const viewEndLineNumber = this.coordinatesConverter.convertModelPositionToViewPosition(new Position$1(modelRange.toLineNumber, this.model.getLineMaxColumn(modelRange.toLineNumber))).lineNumber;
				viewRanges[j] = {
					fromLineNumber: viewStartLineNumber,
					toLineNumber: viewEndLineNumber
				};
			}
			this._eventDispatcher.emitSingleViewEvent(new ViewTokensChangedEvent(viewRanges));
			this._eventDispatcher.emitOutgoingEvent(new ModelTokensChangedEvent(e));
		}));
		this._register(this.model.onDidChangeLanguageConfiguration((e) => {
			this._eventDispatcher.emitSingleViewEvent(new ViewLanguageConfigurationEvent());
			this.cursorConfig = new CursorConfiguration(this.model.getLanguageId(), this.model.getOptions(), this._configuration, this.languageConfigurationService);
			this._cursor.updateConfiguration(this.cursorConfig);
			this._eventDispatcher.emitOutgoingEvent(new ModelLanguageConfigurationChangedEvent(e));
		}));
		this._register(this.model.onDidChangeLanguage((e) => {
			this.cursorConfig = new CursorConfiguration(this.model.getLanguageId(), this.model.getOptions(), this._configuration, this.languageConfigurationService);
			this._cursor.updateConfiguration(this.cursorConfig);
			this._eventDispatcher.emitOutgoingEvent(new ModelLanguageChangedEvent(e));
		}));
		this._register(this.model.onDidChangeOptions((e) => {
			if (this._lines.setTabSize(this.model.getOptions().tabSize)) {
				try {
					const eventsCollector = this._eventDispatcher.beginEmitViewEvents();
					eventsCollector.emitViewEvent(new ViewFlushedEvent());
					eventsCollector.emitViewEvent(new ViewLineMappingChangedEvent());
					eventsCollector.emitViewEvent(new ViewDecorationsChangedEvent(null));
					this._cursor.onLineMappingChanged(eventsCollector);
					this._decorations.onLineMappingChanged();
					this.viewLayout.onFlushed(this.getLineCount(), this._getCustomLineHeights());
				} finally {
					this._eventDispatcher.endEmitViewEvents();
				}
				this._updateConfigurationViewLineCount.schedule();
			}
			this.cursorConfig = new CursorConfiguration(this.model.getLanguageId(), this.model.getOptions(), this._configuration, this.languageConfigurationService);
			this._cursor.updateConfiguration(this.cursorConfig);
			this._eventDispatcher.emitOutgoingEvent(new ModelOptionsChangedEvent(e));
		}));
		this._register(this.model.onDidChangeDecorations((e) => {
			this._decorations.onModelDecorationsChanged();
			this._eventDispatcher.emitSingleViewEvent(new ViewDecorationsChangedEvent(e));
			this._eventDispatcher.emitOutgoingEvent(new ModelDecorationsChangedEvent(e));
		}));
	}
	getFontSizeAtPosition(position) {
		if (!this._configuration.options.get(173)) return null;
		const fontDecorations = this.model.getFontDecorationsInRange(Range$2.fromPositions(position), this._editorId);
		let fontSize = this._configuration.options.get(59).fontSize + "px";
		for (const fontDecoration of fontDecorations) if (fontDecoration.options.fontSize) {
			fontSize = fontDecoration.options.fontSize;
			break;
		}
		return fontSize;
	}
	/**
	* @param forceUpdate If true, the hidden areas will be updated even if the new ranges are the same as the previous ranges.
	* This is because the model might have changed, which resets the hidden areas, but not the last cached value.
	* This needs a better fix in the future.
	*/
	setHiddenAreas(ranges, source, forceUpdate) {
		this.hiddenAreasModel.setHiddenAreas(source, ranges);
		const mergedRanges = this.hiddenAreasModel.getMergedRanges();
		if (mergedRanges === this.previousHiddenAreas && !forceUpdate) return;
		this.previousHiddenAreas = mergedRanges;
		const stableViewport = this._captureStableViewport();
		let lineMappingChanged = false;
		try {
			const eventsCollector = this._eventDispatcher.beginEmitViewEvents();
			lineMappingChanged = this._lines.setHiddenAreas(mergedRanges);
			if (lineMappingChanged) {
				eventsCollector.emitViewEvent(new ViewFlushedEvent());
				eventsCollector.emitViewEvent(new ViewLineMappingChangedEvent());
				eventsCollector.emitViewEvent(new ViewDecorationsChangedEvent(null));
				this._cursor.onLineMappingChanged(eventsCollector);
				this._decorations.onLineMappingChanged();
				this.viewLayout.onFlushed(this.getLineCount(), this._getCustomLineHeights());
				this.viewLayout.onHeightMaybeChanged();
			}
			const firstModelLineInViewPort = stableViewport.viewportStartModelPosition?.lineNumber;
			if (!(firstModelLineInViewPort && mergedRanges.some((range) => range.startLineNumber <= firstModelLineInViewPort && firstModelLineInViewPort <= range.endLineNumber))) stableViewport.recoverViewportStart(this.coordinatesConverter, this.viewLayout);
		} finally {
			this._eventDispatcher.endEmitViewEvents();
		}
		this._updateConfigurationViewLineCount.schedule();
		if (lineMappingChanged) this._eventDispatcher.emitOutgoingEvent(new HiddenAreasChangedEvent());
	}
	getVisibleRangesPlusViewportAboveBelow() {
		const layoutInfo = this._configuration.options.get(166);
		const lineHeight = this._configuration.options.get(75);
		const linesAround = Math.max(20, Math.round(layoutInfo.height / lineHeight));
		const partialData = this.viewLayout.getLinesViewportData();
		const startViewLineNumber = Math.max(1, partialData.completelyVisibleStartLineNumber - linesAround);
		const endViewLineNumber = Math.min(this.getLineCount(), partialData.completelyVisibleEndLineNumber + linesAround);
		return this._toModelVisibleRanges(new Range$2(startViewLineNumber, this.getLineMinColumn(startViewLineNumber), endViewLineNumber, this.getLineMaxColumn(endViewLineNumber)));
	}
	getVisibleRanges() {
		const visibleViewRange = this.getCompletelyVisibleViewRange();
		return this._toModelVisibleRanges(visibleViewRange);
	}
	getHiddenAreas() {
		return this._lines.getHiddenAreas();
	}
	_toModelVisibleRanges(visibleViewRange) {
		const visibleRange = this.coordinatesConverter.convertViewRangeToModelRange(visibleViewRange);
		const hiddenAreas = this._lines.getHiddenAreas();
		if (hiddenAreas.length === 0) return [visibleRange];
		const result = [];
		let resultLen = 0;
		let startLineNumber = visibleRange.startLineNumber;
		let startColumn = visibleRange.startColumn;
		const endLineNumber = visibleRange.endLineNumber;
		const endColumn = visibleRange.endColumn;
		for (let i = 0, len = hiddenAreas.length; i < len; i++) {
			const hiddenStartLineNumber = hiddenAreas[i].startLineNumber;
			const hiddenEndLineNumber = hiddenAreas[i].endLineNumber;
			if (hiddenEndLineNumber < startLineNumber) continue;
			if (hiddenStartLineNumber > endLineNumber) continue;
			if (startLineNumber < hiddenStartLineNumber) result[resultLen++] = new Range$2(startLineNumber, startColumn, hiddenStartLineNumber - 1, this.model.getLineMaxColumn(hiddenStartLineNumber - 1));
			startLineNumber = hiddenEndLineNumber + 1;
			startColumn = 1;
		}
		if (startLineNumber < endLineNumber || startLineNumber === endLineNumber && startColumn < endColumn) result[resultLen++] = new Range$2(startLineNumber, startColumn, endLineNumber, endColumn);
		return result;
	}
	getCompletelyVisibleViewRange() {
		const partialData = this.viewLayout.getLinesViewportData();
		const startViewLineNumber = partialData.completelyVisibleStartLineNumber;
		const endViewLineNumber = partialData.completelyVisibleEndLineNumber;
		return new Range$2(startViewLineNumber, this.getLineMinColumn(startViewLineNumber), endViewLineNumber, this.getLineMaxColumn(endViewLineNumber));
	}
	getCompletelyVisibleViewRangeAtScrollTop(scrollTop) {
		const partialData = this.viewLayout.getLinesViewportDataAtScrollTop(scrollTop);
		const startViewLineNumber = partialData.completelyVisibleStartLineNumber;
		const endViewLineNumber = partialData.completelyVisibleEndLineNumber;
		return new Range$2(startViewLineNumber, this.getLineMinColumn(startViewLineNumber), endViewLineNumber, this.getLineMaxColumn(endViewLineNumber));
	}
	/**
	* Applies `cursorSurroundingLines` and `stickyScroll` padding to the given view range.
	*/
	getViewRangeWithCursorPadding(viewRange) {
		const options = this._configuration.options;
		const cursorSurroundingLines = options.get(35);
		const stickyScroll = options.get(131);
		let { startLineNumber, endLineNumber } = viewRange;
		const padding = Math.min(Math.max(cursorSurroundingLines, stickyScroll.enabled ? stickyScroll.maxLineCount : 0), Math.floor((endLineNumber - startLineNumber + 1) / 2));
		startLineNumber += padding;
		endLineNumber -= Math.max(0, padding - 1);
		if (padding === 0 || startLineNumber > endLineNumber) return viewRange;
		return new Range$2(startLineNumber, this.getLineMinColumn(startLineNumber), endLineNumber, this.getLineMaxColumn(endLineNumber));
	}
	saveState() {
		const compatViewState = this.viewLayout.saveState();
		const scrollTop = compatViewState.scrollTop;
		const firstViewLineNumber = this.viewLayout.getLineNumberAtVerticalOffset(scrollTop);
		const firstPosition = this.coordinatesConverter.convertViewPositionToModelPosition(new Position$1(firstViewLineNumber, this.getLineMinColumn(firstViewLineNumber)));
		const firstPositionDeltaTop = this.viewLayout.getVerticalOffsetForLineNumber(firstViewLineNumber) - scrollTop;
		return {
			scrollLeft: compatViewState.scrollLeft,
			firstPosition,
			firstPositionDeltaTop
		};
	}
	reduceRestoreState(state) {
		if (typeof state.firstPosition === "undefined") return this._reduceRestoreStateCompatibility(state);
		const modelPosition = this.model.validatePosition(state.firstPosition);
		const viewPosition = this.coordinatesConverter.convertModelPositionToViewPosition(modelPosition);
		const scrollTop = this.viewLayout.getVerticalOffsetForLineNumber(viewPosition.lineNumber) - state.firstPositionDeltaTop;
		return {
			scrollLeft: state.scrollLeft,
			scrollTop
		};
	}
	_reduceRestoreStateCompatibility(state) {
		return {
			scrollLeft: state.scrollLeft,
			scrollTop: state.scrollTopWithoutViewZones
		};
	}
	getTabSize() {
		return this.model.getOptions().tabSize;
	}
	getLineCount() {
		return this._lines.getViewLineCount();
	}
	/**
	* Gives a hint that a lot of requests are about to come in for these line numbers.
	*/
	setViewport(startLineNumber, endLineNumber, centeredLineNumber) {
		this._viewportStart.update(this, startLineNumber);
	}
	getActiveIndentGuide(lineNumber, minLineNumber, maxLineNumber) {
		return this._lines.getActiveIndentGuide(lineNumber, minLineNumber, maxLineNumber);
	}
	getLinesIndentGuides(startLineNumber, endLineNumber) {
		return this._lines.getViewLinesIndentGuides(startLineNumber, endLineNumber);
	}
	getBracketGuidesInRangeByLine(startLineNumber, endLineNumber, activePosition, options) {
		return this._lines.getViewLinesBracketGuides(startLineNumber, endLineNumber, activePosition, options);
	}
	getLineContent(lineNumber) {
		return this._lines.getViewLineContent(lineNumber);
	}
	getLineLength(lineNumber) {
		return this._lines.getViewLineLength(lineNumber);
	}
	getLineMinColumn(lineNumber) {
		return this._lines.getViewLineMinColumn(lineNumber);
	}
	getLineMaxColumn(lineNumber) {
		return this._lines.getViewLineMaxColumn(lineNumber);
	}
	getLineFirstNonWhitespaceColumn(lineNumber) {
		const result = firstNonWhitespaceIndex(this.getLineContent(lineNumber));
		if (result === -1) return 0;
		return result + 1;
	}
	getLineLastNonWhitespaceColumn(lineNumber) {
		const result = lastNonWhitespaceIndex(this.getLineContent(lineNumber));
		if (result === -1) return 0;
		return result + 2;
	}
	getMinimapDecorationsInRange(range) {
		return this._decorations.getMinimapDecorationsInRange(range);
	}
	getDecorationsInViewport(visibleRange) {
		return this._decorations.getDecorationsViewportData(visibleRange).decorations;
	}
	getInjectedTextAt(viewPosition) {
		return this._lines.getInjectedTextAt(viewPosition);
	}
	_getTextDirection(lineNumber, decorations) {
		let rtlCount = 0;
		for (const decoration of decorations) {
			const range = decoration.range;
			if (range.startLineNumber > lineNumber || range.endLineNumber < lineNumber) continue;
			const textDirection = decoration.options.textDirection;
			if (textDirection === TextDirection.RTL) rtlCount++;
			else if (textDirection === TextDirection.LTR) rtlCount--;
		}
		return rtlCount > 0 ? TextDirection.RTL : TextDirection.LTR;
	}
	getTextDirection(lineNumber) {
		const decorationsCollection = this._decorations.getDecorationsOnLine(lineNumber);
		return this._getTextDirection(lineNumber, decorationsCollection.decorations);
	}
	getViewportViewLineRenderingData(visibleRange, lineNumber) {
		const viewportDecorationsCollection = this._decorations.getDecorationsViewportData(visibleRange);
		const relativeLineNumber = lineNumber - visibleRange.startLineNumber;
		const inlineDecorations = viewportDecorationsCollection.inlineDecorations[relativeLineNumber];
		const hasVariableFonts = viewportDecorationsCollection.hasVariableFonts[relativeLineNumber];
		return this._getViewLineRenderingData(lineNumber, inlineDecorations, hasVariableFonts, viewportDecorationsCollection.decorations);
	}
	getViewLineRenderingData(lineNumber) {
		const decorationsCollection = this._decorations.getDecorationsOnLine(lineNumber);
		return this._getViewLineRenderingData(lineNumber, decorationsCollection.inlineDecorations[0], decorationsCollection.hasVariableFonts[0], decorationsCollection.decorations);
	}
	_getViewLineRenderingData(lineNumber, inlineDecorations, hasVariableFonts, decorations) {
		const mightContainRTL = this.model.mightContainRTL();
		const mightContainNonBasicASCII = this.model.mightContainNonBasicASCII();
		const tabSize = this.getTabSize();
		const lineData = this._lines.getViewLineData(lineNumber);
		if (lineData.inlineDecorations) inlineDecorations = [...inlineDecorations, ...lineData.inlineDecorations];
		return new ViewLineRenderingData(lineData.minColumn, lineData.maxColumn, lineData.content, lineData.continuesWithWrappedLine, mightContainRTL, mightContainNonBasicASCII, lineData.tokens, inlineDecorations, tabSize, lineData.startVisibleColumn, this._getTextDirection(lineNumber, decorations), hasVariableFonts);
	}
	getViewLineData(lineNumber) {
		return this._lines.getViewLineData(lineNumber);
	}
	getViewLineContinuesWithWrappedLine(lineNumber) {
		return this._lines.getViewLineContinuesWithWrappedLine(lineNumber);
	}
	getMinimapLinesRenderingData(startLineNumber, endLineNumber, needed) {
		const result = this._lines.getViewLinesData(startLineNumber, endLineNumber, needed);
		return new MinimapLinesRenderingData(this.getTabSize(), result);
	}
	getAllOverviewRulerDecorations(theme) {
		const decorations = this.model.getOverviewRulerDecorations(this._editorId, filterValidationDecorations(this._configuration.options), filterFontDecorations(this._configuration.options));
		const result = new OverviewRulerDecorations();
		for (const decoration of decorations) {
			const decorationOptions = decoration.options;
			const opts = decorationOptions.overviewRuler;
			if (!opts) continue;
			const lane = opts.position;
			if (lane === 0) continue;
			const color = opts.getColor(theme.value);
			const viewStartLineNumber = this.coordinatesConverter.getViewLineNumberOfModelPosition(decoration.range.startLineNumber, decoration.range.startColumn);
			const viewEndLineNumber = this.coordinatesConverter.getViewLineNumberOfModelPosition(decoration.range.endLineNumber, decoration.range.endColumn);
			result.accept(color, decorationOptions.zIndex, viewStartLineNumber, viewEndLineNumber, lane);
		}
		return result.asArray;
	}
	_invalidateDecorationsColorCache() {
		const decorations = this.model.getOverviewRulerDecorations();
		for (const decoration of decorations) {
			decoration.options.overviewRuler?.invalidateCachedColor();
			decoration.options.minimap?.invalidateCachedColor();
		}
	}
	getValueInRange(range, eol) {
		const modelRange = this.coordinatesConverter.convertViewRangeToModelRange(range);
		return this.model.getValueInRange(modelRange, eol);
	}
	getValueLengthInRange(range, eol) {
		const modelRange = this.coordinatesConverter.convertViewRangeToModelRange(range);
		return this.model.getValueLengthInRange(modelRange, eol);
	}
	modifyPosition(position, offset) {
		const modelPosition = this.coordinatesConverter.convertViewPositionToModelPosition(position);
		const resultModelPosition = this.model.modifyPosition(modelPosition, offset);
		return this.coordinatesConverter.convertModelPositionToViewPosition(resultModelPosition);
	}
	deduceModelPositionRelativeToViewPosition(viewAnchorPosition, deltaOffset, lineFeedCnt) {
		const modelAnchor = this.coordinatesConverter.convertViewPositionToModelPosition(viewAnchorPosition);
		if (this.model.getEOL().length === 2) {
			if (deltaOffset < 0) deltaOffset -= lineFeedCnt;
			else deltaOffset += lineFeedCnt;
		}
		const resultOffset = this.model.getOffsetAt(modelAnchor) + deltaOffset;
		return this.model.getPositionAt(resultOffset);
	}
	getPlainTextToCopy(modelRanges, emptySelectionClipboard, forceCRLF) {
		const newLineCharacter = forceCRLF ? "\r\n" : this.model.getEOL();
		modelRanges = modelRanges.slice(0);
		modelRanges.sort(Range$2.compareRangesUsingStarts);
		let hasEmptyRange = false;
		let hasNonEmptyRange = false;
		for (const range of modelRanges) if (range.isEmpty()) hasEmptyRange = true;
		else hasNonEmptyRange = true;
		if (!hasNonEmptyRange && !emptySelectionClipboard) return {
			sourceRanges: [],
			sourceText: ""
		};
		const ranges = [];
		const result = [];
		const pushRange = (modelRange, append = "") => {
			ranges.push(modelRange);
			result.push(this.model.getValueInRange(modelRange, forceCRLF ? 2 : 0) + append);
		};
		if (hasEmptyRange && emptySelectionClipboard) {
			let prevModelLineNumber = 0;
			for (const modelRange of modelRanges) {
				const modelLineNumber = modelRange.startLineNumber;
				if (modelRange.isEmpty()) {
					if (modelLineNumber !== prevModelLineNumber) pushRange(new Range$2(modelLineNumber, this.model.getLineMinColumn(modelLineNumber), modelLineNumber, this.model.getLineMaxColumn(modelLineNumber)), newLineCharacter);
				} else pushRange(modelRange);
				prevModelLineNumber = modelLineNumber;
			}
		} else for (const modelRange of modelRanges) if (!modelRange.isEmpty()) pushRange(modelRange);
		return {
			sourceRanges: ranges,
			sourceText: result.length === 1 ? result[0] : result
		};
	}
	getRichTextToCopy(modelRanges, emptySelectionClipboard) {
		const languageId = this.model.getLanguageId();
		if (languageId === "plaintext") return null;
		if (modelRanges.length !== 1) return null;
		let range = modelRanges[0];
		if (range.isEmpty()) {
			if (!emptySelectionClipboard) return null;
			const lineNumber = range.startLineNumber;
			range = new Range$2(lineNumber, this.model.getLineMinColumn(lineNumber), lineNumber, this.model.getLineMaxColumn(lineNumber));
		}
		const fontInfo = this._configuration.options.get(59);
		const colorMap = this._getColorMap();
		const useDefaultFontFamily = /[:;\\\/<>]/.test(fontInfo.fontFamily) || fontInfo.fontFamily === EDITOR_FONT_DEFAULTS.fontFamily;
		let fontFamily;
		if (useDefaultFontFamily) fontFamily = EDITOR_FONT_DEFAULTS.fontFamily;
		else {
			fontFamily = fontInfo.fontFamily;
			fontFamily = fontFamily.replace(/"/g, "'");
			if (!/[,']/.test(fontFamily)) {
				if (/[+ ]/.test(fontFamily)) fontFamily = `'${fontFamily}'`;
			}
			fontFamily = `${fontFamily}, ${EDITOR_FONT_DEFAULTS.fontFamily}`;
		}
		return {
			mode: languageId,
			html: `<div style="color: ${colorMap[1]};background-color: ${colorMap[2]};font-family: ${fontFamily};font-weight: ${fontInfo.fontWeight};font-size: ${fontInfo.fontSize}px;line-height: ${fontInfo.lineHeight}px;white-space: pre;">` + this._getHTMLToCopy(range, colorMap) + "</div>"
		};
	}
	_getHTMLToCopy(modelRange, colorMap) {
		const startLineNumber = modelRange.startLineNumber;
		const startColumn = modelRange.startColumn;
		const endLineNumber = modelRange.endLineNumber;
		const endColumn = modelRange.endColumn;
		const tabSize = this.getTabSize();
		let result = "";
		for (let lineNumber = startLineNumber; lineNumber <= endLineNumber; lineNumber++) {
			const lineTokens = this.model.tokenization.getLineTokens(lineNumber);
			const lineContent = lineTokens.getLineContent();
			const startOffset = lineNumber === startLineNumber ? startColumn - 1 : 0;
			const endOffset = lineNumber === endLineNumber ? endColumn - 1 : lineContent.length;
			if (lineContent === "") result += "<br>";
			else result += tokenizeLineToHTML(lineContent, lineTokens.inflate(), colorMap, startOffset, endOffset, tabSize, isWindows);
		}
		return result;
	}
	_getColorMap() {
		const colorMap = TokenizationRegistry.getColorMap();
		const result = ["#000000"];
		if (colorMap) for (let i = 1, len = colorMap.length; i < len; i++) result[i] = Color.Format.CSS.formatHex(colorMap[i]);
		return result;
	}
	getPrimaryCursorState() {
		return this._cursor.getPrimaryCursorState();
	}
	getLastAddedCursorIndex() {
		return this._cursor.getLastAddedCursorIndex();
	}
	getCursorStates() {
		return this._cursor.getCursorStates();
	}
	setCursorStates(source, reason, states) {
		return this._withViewEventsCollector((eventsCollector) => this._cursor.setStates(eventsCollector, source, reason, states));
	}
	getCursorColumnSelectData() {
		return this._cursor.getCursorColumnSelectData();
	}
	getCursorAutoClosedCharacters() {
		return this._cursor.getAutoClosedCharacters();
	}
	setCursorColumnSelectData(columnSelectData) {
		this._cursor.setCursorColumnSelectData(columnSelectData);
	}
	getPrevEditOperationType() {
		return this._cursor.getPrevEditOperationType();
	}
	setPrevEditOperationType(type) {
		this._cursor.setPrevEditOperationType(type);
	}
	getSelection() {
		return this._cursor.getSelection();
	}
	getSelections() {
		return this._cursor.getSelections();
	}
	getPosition() {
		return this._cursor.getPrimaryCursorState().modelState.position;
	}
	setSelections(source, selections, reason = 0) {
		this._withViewEventsCollector((eventsCollector) => this._cursor.setSelections(eventsCollector, source, selections, reason));
	}
	saveCursorState() {
		return this._cursor.saveState();
	}
	restoreCursorState(states) {
		this._withViewEventsCollector((eventsCollector) => this._cursor.restoreState(eventsCollector, states));
	}
	_executeCursorEdit(callback) {
		if (this._cursor.context.cursorConfig.readOnly) {
			this._eventDispatcher.emitOutgoingEvent(new ReadOnlyEditAttemptEvent());
			return;
		}
		this._withViewEventsCollector(callback);
	}
	executeEdits(source, edits, cursorStateComputer, reason) {
		this._executeCursorEdit((eventsCollector) => this._cursor.executeEdits(eventsCollector, source, edits, cursorStateComputer, reason));
	}
	startComposition() {
		this._executeCursorEdit((eventsCollector) => this._cursor.startComposition(eventsCollector));
	}
	endComposition(source) {
		this._executeCursorEdit((eventsCollector) => this._cursor.endComposition(eventsCollector, source));
	}
	type(text, source) {
		this._executeCursorEdit((eventsCollector) => this._cursor.type(eventsCollector, text, source));
	}
	compositionType(text, replacePrevCharCnt, replaceNextCharCnt, positionDelta, source) {
		this._executeCursorEdit((eventsCollector) => this._cursor.compositionType(eventsCollector, text, replacePrevCharCnt, replaceNextCharCnt, positionDelta, source));
	}
	paste(text, pasteOnNewLine, multicursorText, source) {
		this._executeCursorEdit((eventsCollector) => this._cursor.paste(eventsCollector, text, pasteOnNewLine, multicursorText, source));
	}
	cut(source) {
		this._executeCursorEdit((eventsCollector) => this._cursor.cut(eventsCollector, source));
	}
	executeCommand(command, source) {
		this._executeCursorEdit((eventsCollector) => this._cursor.executeCommand(eventsCollector, command, source));
	}
	executeCommands(commands, source) {
		this._executeCursorEdit((eventsCollector) => this._cursor.executeCommands(eventsCollector, commands, source));
	}
	revealAllCursors(source, revealHorizontal, minimalReveal = false) {
		this._withViewEventsCollector((eventsCollector) => this._cursor.revealAll(eventsCollector, source, minimalReveal, 0, revealHorizontal, 0));
	}
	revealPrimaryCursor(source, revealHorizontal, minimalReveal = false) {
		this._withViewEventsCollector((eventsCollector) => this._cursor.revealPrimary(eventsCollector, source, minimalReveal, 0, revealHorizontal, 0));
	}
	revealTopMostCursor(source) {
		const viewPosition = this._cursor.getTopMostViewPosition();
		const viewRange = new Range$2(viewPosition.lineNumber, viewPosition.column, viewPosition.lineNumber, viewPosition.column);
		this._withViewEventsCollector((eventsCollector) => eventsCollector.emitViewEvent(new ViewRevealRangeRequestEvent(source, false, viewRange, null, 0, true, 0)));
	}
	revealBottomMostCursor(source) {
		const viewPosition = this._cursor.getBottomMostViewPosition();
		const viewRange = new Range$2(viewPosition.lineNumber, viewPosition.column, viewPosition.lineNumber, viewPosition.column);
		this._withViewEventsCollector((eventsCollector) => eventsCollector.emitViewEvent(new ViewRevealRangeRequestEvent(source, false, viewRange, null, 0, true, 0)));
	}
	revealRange(source, revealHorizontal, viewRange, verticalType, scrollType) {
		this._withViewEventsCollector((eventsCollector) => eventsCollector.emitViewEvent(new ViewRevealRangeRequestEvent(source, false, viewRange, null, verticalType, revealHorizontal, scrollType)));
	}
	changeWhitespace(callback) {
		if (this.viewLayout.changeWhitespace(callback)) {
			this._eventDispatcher.emitSingleViewEvent(new ViewZonesChangedEvent$1());
			this._eventDispatcher.emitOutgoingEvent(new ViewZonesChangedEvent());
		}
	}
	_withViewEventsCollector(callback) {
		return this._transactionalTarget.batchChanges(() => {
			return this._emitViewEvent(callback);
		});
	}
	_emitViewEvent(callback) {
		try {
			return callback(this._eventDispatcher.beginEmitViewEvents());
		} finally {
			this._eventDispatcher.endEmitViewEvents();
		}
	}
	batchEvents(callback) {
		this._withViewEventsCollector(() => {
			callback();
		});
	}
	normalizePosition(position, affinity) {
		return this._lines.normalizePosition(position, affinity);
	}
	/**
	* Gets the column at which indentation stops at a given line.
	* @internal
	*/
	getLineIndentColumn(lineNumber) {
		return this._lines.getLineIndentColumn(lineNumber);
	}
};
var ViewportStart = class ViewportStart {
	static create(model) {
		const viewportStartLineTrackedRange = model._setTrackedRange(null, new Range$2(1, 1, 1, 1), 1);
		return new ViewportStart(model, 1, false, viewportStartLineTrackedRange, 0);
	}
	get viewLineNumber() {
		return this._viewLineNumber;
	}
	get isValid() {
		return this._isValid;
	}
	get modelTrackedRange() {
		return this._modelTrackedRange;
	}
	get startLineDelta() {
		return this._startLineDelta;
	}
	constructor(_model, _viewLineNumber, _isValid, _modelTrackedRange, _startLineDelta) {
		this._model = _model;
		this._viewLineNumber = _viewLineNumber;
		this._isValid = _isValid;
		this._modelTrackedRange = _modelTrackedRange;
		this._startLineDelta = _startLineDelta;
	}
	dispose() {
		this._model._setTrackedRange(this._modelTrackedRange, null, 1);
	}
	update(viewModel, startLineNumber) {
		const position = viewModel.coordinatesConverter.convertViewPositionToModelPosition(new Position$1(startLineNumber, viewModel.getLineMinColumn(startLineNumber)));
		const viewportStartLineTrackedRange = viewModel.model._setTrackedRange(this._modelTrackedRange, new Range$2(position.lineNumber, position.column, position.lineNumber, position.column), 1);
		const viewportStartLineTop = viewModel.viewLayout.getVerticalOffsetForLineNumber(startLineNumber);
		const scrollTop = viewModel.viewLayout.getCurrentScrollTop();
		this._viewLineNumber = startLineNumber;
		this._isValid = true;
		this._modelTrackedRange = viewportStartLineTrackedRange;
		this._startLineDelta = scrollTop - viewportStartLineTop;
	}
	invalidate() {
		this._isValid = false;
	}
};
var OverviewRulerDecorations = class {
	constructor() {
		this._asMap = Object.create(null);
		this.asArray = [];
	}
	accept(color, zIndex, startLineNumber, endLineNumber, lane) {
		const prevGroup = this._asMap[color];
		if (prevGroup) {
			const prevData = prevGroup.data;
			const prevLane = prevData[prevData.length - 3];
			const prevEndLineNumber = prevData[prevData.length - 1];
			if (prevLane === lane && prevEndLineNumber + 1 >= startLineNumber) {
				if (endLineNumber > prevEndLineNumber) prevData[prevData.length - 1] = endLineNumber;
				return;
			}
			prevData.push(lane, startLineNumber, endLineNumber);
		} else {
			const group = new OverviewRulerDecorationsGroup(color, zIndex, [
				lane,
				startLineNumber,
				endLineNumber
			]);
			this._asMap[color] = group;
			this.asArray.push(group);
		}
	}
};
var HiddenAreasModel = class {
	constructor() {
		this.hiddenAreas = /* @__PURE__ */ new Map();
		this.shouldRecompute = false;
		this.ranges = [];
	}
	setHiddenAreas(source, ranges) {
		const existing = this.hiddenAreas.get(source);
		if (existing && rangeArraysEqual(existing, ranges)) return;
		this.hiddenAreas.set(source, ranges);
		this.shouldRecompute = true;
	}
	/**
	* The returned array is immutable.
	*/
	getMergedRanges() {
		if (!this.shouldRecompute) return this.ranges;
		this.shouldRecompute = false;
		const newRanges = Array.from(this.hiddenAreas.values()).reduce((r, hiddenAreas) => mergeLineRangeArray(r, hiddenAreas), []);
		if (rangeArraysEqual(this.ranges, newRanges)) return this.ranges;
		this.ranges = newRanges;
		return this.ranges;
	}
};
function mergeLineRangeArray(arr1, arr2) {
	const result = [];
	let i = 0;
	let j = 0;
	while (i < arr1.length && j < arr2.length) {
		const item1 = arr1[i];
		const item2 = arr2[j];
		if (item1.endLineNumber < item2.startLineNumber - 1) result.push(arr1[i++]);
		else if (item2.endLineNumber < item1.startLineNumber - 1) result.push(arr2[j++]);
		else {
			const startLineNumber = Math.min(item1.startLineNumber, item2.startLineNumber);
			const endLineNumber = Math.max(item1.endLineNumber, item2.endLineNumber);
			result.push(new Range$2(startLineNumber, 1, endLineNumber, 1));
			i++;
			j++;
		}
	}
	while (i < arr1.length) result.push(arr1[i++]);
	while (j < arr2.length) result.push(arr2[j++]);
	return result;
}
function rangeArraysEqual(arr1, arr2) {
	if (arr1.length !== arr2.length) return false;
	for (let i = 0; i < arr1.length; i++) if (!arr1[i].equalsRange(arr2[i])) return false;
	return true;
}
/**
* Maintain a stable viewport by trying to keep the first line in the viewport constant.
*/
var StableViewport = class {
	constructor(viewportStartModelPosition, startLineDelta) {
		this.viewportStartModelPosition = viewportStartModelPosition;
		this.startLineDelta = startLineDelta;
	}
	recoverViewportStart(coordinatesConverter, viewLayout) {
		if (!this.viewportStartModelPosition) return;
		const viewPosition = coordinatesConverter.convertModelPositionToViewPosition(this.viewportStartModelPosition);
		const viewPositionTop = viewLayout.getVerticalOffsetForLineNumber(viewPosition.lineNumber);
		viewLayout.setScrollPosition({ scrollTop: viewPositionTop + this.startLineDelta }, 1);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/instantiation/common/serviceCollection.js
var ServiceCollection = class {
	constructor(...entries) {
		this._entries = /* @__PURE__ */ new Map();
		for (const [id, service] of entries) this.set(id, service);
	}
	set(id, instanceOrDescriptor) {
		const result = this._entries.get(id);
		this._entries.set(id, instanceOrDescriptor);
		return result;
	}
	get(id) {
		return this._entries.get(id);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/codeEditor/codeEditorWidget.js
var __decorate$54 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$49 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var CodeEditorWidget_1;
var CodeEditorWidget = class CodeEditorWidget extends Disposable {
	static {
		CodeEditorWidget_1 = this;
	}
	static {
		this.dropIntoEditorDecorationOptions = ModelDecorationOptions.register({
			description: "workbench-dnd-target",
			className: "dnd-target"
		});
	}
	get isSimpleWidget() {
		return this._configuration.isSimpleWidget;
	}
	get contextMenuId() {
		return this._configuration.contextMenuId;
	}
	get contextKeyService() {
		return this._contextKeyService;
	}
	constructor(domElement, _options, codeEditorWidgetOptions, instantiationService, codeEditorService, commandService, contextKeyService, themeService, notificationService, accessibilityService, languageConfigurationService, languageFeaturesService, userInteractionService) {
		super();
		this.languageConfigurationService = languageConfigurationService;
		this._deliveryQueue = createEventDeliveryQueue();
		this._contributions = this._register(new CodeEditorContributions());
		this._onDidDispose = this._register(new Emitter$1());
		this.onDidDispose = this._onDidDispose.event;
		this._onDidChangeModelContent = this._register(new Emitter$1({ deliveryQueue: this._deliveryQueue }));
		this.onDidChangeModelContent = this._onDidChangeModelContent.event;
		this._onDidChangeModelLanguage = this._register(new Emitter$1({ deliveryQueue: this._deliveryQueue }));
		this.onDidChangeModelLanguage = this._onDidChangeModelLanguage.event;
		this._onDidChangeModelLanguageConfiguration = this._register(new Emitter$1({ deliveryQueue: this._deliveryQueue }));
		this.onDidChangeModelLanguageConfiguration = this._onDidChangeModelLanguageConfiguration.event;
		this._onDidChangeModelOptions = this._register(new Emitter$1({ deliveryQueue: this._deliveryQueue }));
		this.onDidChangeModelOptions = this._onDidChangeModelOptions.event;
		this._onDidChangeModelDecorations = this._register(new Emitter$1({ deliveryQueue: this._deliveryQueue }));
		this.onDidChangeModelDecorations = this._onDidChangeModelDecorations.event;
		this._onDidChangeLineHeight = this._register(new Emitter$1({ deliveryQueue: this._deliveryQueue }));
		this.onDidChangeLineHeight = this._onDidChangeLineHeight.event;
		this._onDidChangeFont = this._register(new Emitter$1({ deliveryQueue: this._deliveryQueue }));
		this.onDidChangeFont = this._onDidChangeFont.event;
		this._onDidChangeModelTokens = this._register(new Emitter$1({ deliveryQueue: this._deliveryQueue }));
		this.onDidChangeModelTokens = this._onDidChangeModelTokens.event;
		this._onDidChangeConfiguration = this._register(new Emitter$1({ deliveryQueue: this._deliveryQueue }));
		this.onDidChangeConfiguration = this._onDidChangeConfiguration.event;
		this._onWillChangeModel = this._register(new Emitter$1({ deliveryQueue: this._deliveryQueue }));
		this.onWillChangeModel = this._onWillChangeModel.event;
		this._onDidChangeModel = this._register(new Emitter$1({ deliveryQueue: this._deliveryQueue }));
		this.onDidChangeModel = this._onDidChangeModel.event;
		this._onDidChangeCursorPosition = this._register(new Emitter$1({ deliveryQueue: this._deliveryQueue }));
		this.onDidChangeCursorPosition = this._onDidChangeCursorPosition.event;
		this._onDidChangeCursorSelection = this._register(new Emitter$1({ deliveryQueue: this._deliveryQueue }));
		this.onDidChangeCursorSelection = this._onDidChangeCursorSelection.event;
		this._onDidAttemptReadOnlyEdit = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
		this.onDidAttemptReadOnlyEdit = this._onDidAttemptReadOnlyEdit.event;
		this._onDidLayoutChange = this._register(new Emitter$1({ deliveryQueue: this._deliveryQueue }));
		this.onDidLayoutChange = this._onDidLayoutChange.event;
		this._editorTextFocus = this._register(new BooleanEventEmitter({ deliveryQueue: this._deliveryQueue }));
		this.onDidFocusEditorText = this._editorTextFocus.onDidChangeToTrue;
		this.onDidBlurEditorText = this._editorTextFocus.onDidChangeToFalse;
		this._editorWidgetFocus = this._register(new BooleanEventEmitter({ deliveryQueue: this._deliveryQueue }));
		this.onDidFocusEditorWidget = this._editorWidgetFocus.onDidChangeToTrue;
		this.onDidBlurEditorWidget = this._editorWidgetFocus.onDidChangeToFalse;
		this._onWillType = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
		this.onWillType = this._onWillType.event;
		this._onDidType = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
		this.onDidType = this._onDidType.event;
		this._onDidCompositionStart = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
		this.onDidCompositionStart = this._onDidCompositionStart.event;
		this._onDidCompositionEnd = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
		this.onDidCompositionEnd = this._onDidCompositionEnd.event;
		this._onDidPaste = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
		this.onDidPaste = this._onDidPaste.event;
		this._onWillCopy = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
		this.onWillCopy = this._onWillCopy.event;
		this._onWillCut = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
		this.onWillCut = this._onWillCut.event;
		this._onWillPaste = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
		this.onWillPaste = this._onWillPaste.event;
		this._onMouseUp = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
		this.onMouseUp = this._onMouseUp.event;
		this._onMouseDown = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
		this.onMouseDown = this._onMouseDown.event;
		this._onMouseDrag = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
		this.onMouseDrag = this._onMouseDrag.event;
		this._onMouseDrop = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
		this.onMouseDrop = this._onMouseDrop.event;
		this._onMouseDropCanceled = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
		this.onMouseDropCanceled = this._onMouseDropCanceled.event;
		this._onDropIntoEditor = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
		this.onDropIntoEditor = this._onDropIntoEditor.event;
		this._onContextMenu = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
		this.onContextMenu = this._onContextMenu.event;
		this._onMouseMove = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
		this.onMouseMove = this._onMouseMove.event;
		this._onMouseLeave = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
		this.onMouseLeave = this._onMouseLeave.event;
		this._onMouseWheel = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
		this.onMouseWheel = this._onMouseWheel.event;
		this._onKeyUp = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
		this.onKeyUp = this._onKeyUp.event;
		this._onKeyDown = this._register(new InteractionEmitter(this._contributions, this._deliveryQueue));
		this.onKeyDown = this._onKeyDown.event;
		this._onDidContentSizeChange = this._register(new Emitter$1({ deliveryQueue: this._deliveryQueue }));
		this.onDidContentSizeChange = this._onDidContentSizeChange.event;
		this._onDidScrollChange = this._register(new Emitter$1({ deliveryQueue: this._deliveryQueue }));
		this.onDidScrollChange = this._onDidScrollChange.event;
		this._onDidChangeViewZones = this._register(new Emitter$1({ deliveryQueue: this._deliveryQueue }));
		this.onDidChangeViewZones = this._onDidChangeViewZones.event;
		this._onDidChangeHiddenAreas = this._register(new Emitter$1({ deliveryQueue: this._deliveryQueue }));
		this.onDidChangeHiddenAreas = this._onDidChangeHiddenAreas.event;
		this._updateCounter = 0;
		this._onWillTriggerEditorOperationEvent = this._register(new Emitter$1());
		this._onBeginUpdate = this._register(new Emitter$1());
		this.onBeginUpdate = this._onBeginUpdate.event;
		this._onEndUpdate = this._register(new Emitter$1());
		this.onEndUpdate = this._onEndUpdate.event;
		this._onBeforeExecuteEdit = this._register(new Emitter$1());
		this.onBeforeExecuteEdit = this._onBeforeExecuteEdit.event;
		this._actions = /* @__PURE__ */ new Map();
		this._bannerDomNode = null;
		this._dropIntoEditorDecorations = this.createDecorationsCollection();
		this.inComposition = false;
		codeEditorService.willCreateCodeEditor();
		const options = { ..._options };
		this._domElement = domElement;
		this._userInteractionService = userInteractionService;
		this._overflowWidgetsDomNode = options.overflowWidgetsDomNode;
		delete options.overflowWidgetsDomNode;
		this._id = ++EDITOR_ID;
		this._decorationTypeKeysToIds = {};
		this._decorationTypeSubtypes = {};
		this._telemetryData = codeEditorWidgetOptions.telemetryData;
		this._configuration = this._register(this._createConfiguration(codeEditorWidgetOptions.isSimpleWidget || false, codeEditorWidgetOptions.contextMenuId ?? (codeEditorWidgetOptions.isSimpleWidget ? MenuId.SimpleEditorContext : MenuId.EditorContext), options, accessibilityService));
		this._domElement.style?.setProperty("--editor-font-size", this._configuration.options.get(61) + "px");
		this._register(this._configuration.onDidChange((e) => {
			this._onDidChangeConfiguration.fire(e);
			const options = this._configuration.options;
			if (e.hasChanged(166)) {
				const layoutInfo = options.get(166);
				this._onDidLayoutChange.fire(layoutInfo);
			}
			if (e.hasChanged(61)) this._domElement.style.setProperty("--editor-font-size", options.get(61) + "px");
		}));
		this._contextKeyService = this._register(contextKeyService.createScoped(this._domElement));
		if (codeEditorWidgetOptions.contextKeyValues) for (const [key, value] of Object.entries(codeEditorWidgetOptions.contextKeyValues)) this._contextKeyService.createKey(key, value);
		this._notificationService = notificationService;
		this._codeEditorService = codeEditorService;
		this._commandService = commandService;
		this._themeService = themeService;
		this._register(new EditorContextKeysManager(this, this._contextKeyService));
		this._register(new EditorModeContext(this, this._contextKeyService, languageFeaturesService));
		this._instantiationService = this._register(instantiationService.createChild(new ServiceCollection([IContextKeyService, this._contextKeyService])));
		this._modelData = null;
		this._contentWidgets = {};
		this._overlayWidgets = {};
		this._glyphMarginWidgets = {};
		let contributions;
		if (Array.isArray(codeEditorWidgetOptions.contributions)) contributions = codeEditorWidgetOptions.contributions;
		else contributions = EditorExtensionsRegistry.getEditorContributions();
		this._contributions.initialize(this, contributions, this._instantiationService);
		for (const action of EditorExtensionsRegistry.getEditorActions()) {
			if (this._actions.has(action.id)) {
				onUnexpectedError(/* @__PURE__ */ new Error(`Cannot have two actions with the same id ${action.id}`));
				continue;
			}
			const internalAction = new InternalEditorAction(action.id, action.label, action.alias, action.metadata, action.precondition ?? void 0, (args) => {
				return this._instantiationService.invokeFunction((accessor) => {
					return Promise.resolve(action.runEditorCommand(accessor, this, args));
				});
			}, this._contextKeyService);
			this._actions.set(internalAction.id, internalAction);
		}
		const isDropIntoEnabled = () => {
			return !this._configuration.options.get(104) && this._configuration.options.get(43).enabled;
		};
		this._register(new DragAndDropObserver(this._domElement, {
			onDragOver: (e) => {
				if (!isDropIntoEnabled()) return;
				const target = this.getTargetAtClientPoint(e.clientX, e.clientY);
				if (target?.position) this.showDropIndicatorAt(target.position);
			},
			onDrop: async (e) => {
				if (!isDropIntoEnabled()) return;
				this.removeDropIndicator();
				if (!e.dataTransfer) return;
				const target = this.getTargetAtClientPoint(e.clientX, e.clientY);
				if (target?.position) this._onDropIntoEditor.fire({
					position: target.position,
					event: e
				});
			},
			onDragLeave: () => {
				this.removeDropIndicator();
			},
			onDragEnd: () => {
				this.removeDropIndicator();
			}
		}));
		this._codeEditorService.addCodeEditor(this);
	}
	writeScreenReaderContent(reason) {
		this._modelData?.view.writeScreenReaderContent(reason);
	}
	_createConfiguration(isSimpleWidget, contextMenuId, options, accessibilityService) {
		return new EditorConfiguration(isSimpleWidget, contextMenuId, options, this._domElement, accessibilityService);
	}
	getId() {
		return this.getEditorType() + ":" + this._id;
	}
	getEditorType() {
		return EditorType.ICodeEditor;
	}
	dispose() {
		this._codeEditorService.removeCodeEditor(this);
		this._actions.clear();
		this._contentWidgets = {};
		this._overlayWidgets = {};
		this._removeDecorationTypes();
		this._postDetachModelCleanup(this._detachModel());
		this._onDidDispose.fire();
		super.dispose();
	}
	invokeWithinContext(fn) {
		return this._instantiationService.invokeFunction(fn);
	}
	updateOptions(newOptions) {
		this._configuration.updateOptions(newOptions || {});
	}
	getOptions() {
		return this._configuration.options;
	}
	getOption(id) {
		return this._configuration.options.get(id);
	}
	getRawOptions() {
		return this._configuration.getRawOptions();
	}
	getOverflowWidgetsDomNode() {
		return this._overflowWidgetsDomNode;
	}
	getConfiguredWordAtPosition(position) {
		if (!this._modelData) return null;
		return WordOperations.getWordAtPosition(this._modelData.model, this._configuration.options.get(148), this._configuration.options.get(147), position);
	}
	getValue(options = null) {
		if (!this._modelData) return "";
		const preserveBOM = options && options.preserveBOM ? true : false;
		let eolPreference = 0;
		if (options && options.lineEnding && options.lineEnding === "\n") eolPreference = 1;
		else if (options && options.lineEnding && options.lineEnding === "\r\n") eolPreference = 2;
		return this._modelData.model.getValue(eolPreference, preserveBOM);
	}
	setValue(newValue) {
		try {
			this._beginUpdate();
			if (!this._modelData) return;
			this._modelData.model.setValue(newValue);
		} finally {
			this._endUpdate();
		}
	}
	getModel() {
		if (!this._modelData) return null;
		return this._modelData.model;
	}
	setModel(_model = null) {
		try {
			this._beginUpdate();
			const model = _model;
			if (this._modelData === null && model === null) return;
			if (this._modelData && this._modelData.model === model) return;
			const e = {
				oldModelUrl: this._modelData?.model.uri || null,
				newModelUrl: model?.uri || null
			};
			this._onWillChangeModel.fire(e);
			const hasTextFocus = this.hasTextFocus();
			const detachedModel = this._detachModel();
			this._attachModel(model);
			if (this.hasModel()) {
				if (hasTextFocus) this.focus();
			} else {
				this._editorTextFocus.setValue(false);
				this._editorWidgetFocus.setValue(false);
			}
			this._removeDecorationTypes();
			this._onDidChangeModel.fire(e);
			this._postDetachModelCleanup(detachedModel);
			this._contributionsDisposable = this._contributions.onAfterModelAttached();
		} finally {
			this._endUpdate();
		}
	}
	_removeDecorationTypes() {
		this._decorationTypeKeysToIds = {};
		if (this._decorationTypeSubtypes) {
			for (const decorationType in this._decorationTypeSubtypes) {
				const subTypes = this._decorationTypeSubtypes[decorationType];
				for (const subType in subTypes) this._removeDecorationType(decorationType + "-" + subType);
			}
			this._decorationTypeSubtypes = {};
		}
	}
	getVisibleRanges() {
		if (!this._modelData) return [];
		return this._modelData.viewModel.getVisibleRanges();
	}
	getVisibleRangesPlusViewportAboveBelow() {
		if (!this._modelData) return [];
		return this._modelData.viewModel.getVisibleRangesPlusViewportAboveBelow();
	}
	getWhitespaces() {
		if (!this._modelData) return [];
		return this._modelData.viewModel.viewLayout.getWhitespaces();
	}
	static _getVerticalOffsetAfterPosition(modelData, modelLineNumber, modelColumn, includeViewZones) {
		const modelPosition = modelData.model.validatePosition({
			lineNumber: modelLineNumber,
			column: modelColumn
		});
		const viewPosition = modelData.viewModel.coordinatesConverter.convertModelPositionToViewPosition(modelPosition);
		return modelData.viewModel.viewLayout.getVerticalOffsetAfterLineNumber(viewPosition.lineNumber, includeViewZones);
	}
	getTopForLineNumber(lineNumber, includeViewZones = false) {
		if (!this._modelData) return -1;
		return CodeEditorWidget_1._getVerticalOffsetForPosition(this._modelData, lineNumber, 1, includeViewZones);
	}
	getTopForPosition(lineNumber, column) {
		if (!this._modelData) return -1;
		return CodeEditorWidget_1._getVerticalOffsetForPosition(this._modelData, lineNumber, column, false);
	}
	static _getVerticalOffsetForPosition(modelData, modelLineNumber, modelColumn, includeViewZones = false) {
		const modelPosition = modelData.model.validatePosition({
			lineNumber: modelLineNumber,
			column: modelColumn
		});
		const viewPosition = modelData.viewModel.coordinatesConverter.convertModelPositionToViewPosition(modelPosition);
		return modelData.viewModel.viewLayout.getVerticalOffsetForLineNumber(viewPosition.lineNumber, includeViewZones);
	}
	getBottomForLineNumber(lineNumber, includeViewZones = false) {
		if (!this._modelData) return -1;
		return CodeEditorWidget_1._getVerticalOffsetAfterPosition(this._modelData, lineNumber, Number.MAX_SAFE_INTEGER, includeViewZones);
	}
	getLineHeightForPosition(position) {
		if (!this._modelData) return -1;
		const viewModel = this._modelData.viewModel;
		const coordinatesConverter = viewModel.coordinatesConverter;
		const pos = Position$1.lift(position);
		if (coordinatesConverter.modelPositionIsVisible(pos)) {
			const viewPosition = coordinatesConverter.convertModelPositionToViewPosition(pos);
			return viewModel.viewLayout.getLineHeightForLineNumber(viewPosition.lineNumber);
		}
		return 0;
	}
	setHiddenAreas(ranges, source, forceUpdate) {
		this._modelData?.viewModel.setHiddenAreas(ranges.map((r) => Range$2.lift(r)), source, forceUpdate);
	}
	getVisibleColumnFromPosition(rawPosition) {
		if (!this._modelData) return rawPosition.column;
		const position = this._modelData.model.validatePosition(rawPosition);
		const tabSize = this._modelData.model.getOptions().tabSize;
		return CursorColumns.visibleColumnFromColumn(this._modelData.model.getLineContent(position.lineNumber), position.column, tabSize) + 1;
	}
	getPosition() {
		if (!this._modelData) return null;
		return this._modelData.viewModel.getPosition();
	}
	setPosition(position, source = "api") {
		if (!this._modelData) return;
		if (!Position$1.isIPosition(position)) throw new Error("Invalid arguments");
		this._modelData.viewModel.setSelections(source, [{
			selectionStartLineNumber: position.lineNumber,
			selectionStartColumn: position.column,
			positionLineNumber: position.lineNumber,
			positionColumn: position.column
		}]);
	}
	_sendRevealRange(modelRange, verticalType, revealHorizontal, scrollType) {
		if (!this._modelData) return;
		if (!Range$2.isIRange(modelRange)) throw new Error("Invalid arguments");
		const validatedModelRange = this._modelData.model.validateRange(modelRange);
		const viewRange = this._modelData.viewModel.coordinatesConverter.convertModelRangeToViewRange(validatedModelRange);
		this._modelData.viewModel.revealRange("api", revealHorizontal, viewRange, verticalType, scrollType);
	}
	revealAllCursors(revealHorizontal, minimalReveal) {
		if (!this._modelData) return;
		this._modelData.viewModel.revealAllCursors("api", revealHorizontal, minimalReveal);
	}
	revealLine(lineNumber, scrollType = 0) {
		this._revealLine(lineNumber, 0, scrollType);
	}
	revealLineInCenter(lineNumber, scrollType = 0) {
		this._revealLine(lineNumber, 1, scrollType);
	}
	revealLineInCenterIfOutsideViewport(lineNumber, scrollType = 0) {
		this._revealLine(lineNumber, 2, scrollType);
	}
	revealLineNearTop(lineNumber, scrollType = 0) {
		this._revealLine(lineNumber, 5, scrollType);
	}
	_revealLine(lineNumber, revealType, scrollType) {
		if (typeof lineNumber !== "number") throw new Error("Invalid arguments");
		this._sendRevealRange(new Range$2(lineNumber, 1, lineNumber, 1), revealType, false, scrollType);
	}
	revealPosition(position, scrollType = 0) {
		this._revealPosition(position, 0, true, scrollType);
	}
	revealPositionInCenter(position, scrollType = 0) {
		this._revealPosition(position, 1, true, scrollType);
	}
	revealPositionInCenterIfOutsideViewport(position, scrollType = 0) {
		this._revealPosition(position, 2, true, scrollType);
	}
	revealPositionNearTop(position, scrollType = 0) {
		this._revealPosition(position, 5, true, scrollType);
	}
	_revealPosition(position, verticalType, revealHorizontal, scrollType) {
		if (!Position$1.isIPosition(position)) throw new Error("Invalid arguments");
		this._sendRevealRange(new Range$2(position.lineNumber, position.column, position.lineNumber, position.column), verticalType, revealHorizontal, scrollType);
	}
	getSelection() {
		if (!this._modelData) return null;
		return this._modelData.viewModel.getSelection();
	}
	getSelections() {
		if (!this._modelData) return null;
		return this._modelData.viewModel.getSelections();
	}
	setSelection(something, source = "api") {
		const isSelection = Selection$1.isISelection(something);
		const isRange = Range$2.isIRange(something);
		if (!isSelection && !isRange) throw new Error("Invalid arguments");
		if (isSelection) this._setSelectionImpl(something, source);
		else if (isRange) {
			const selection = {
				selectionStartLineNumber: something.startLineNumber,
				selectionStartColumn: something.startColumn,
				positionLineNumber: something.endLineNumber,
				positionColumn: something.endColumn
			};
			this._setSelectionImpl(selection, source);
		}
	}
	_setSelectionImpl(sel, source) {
		if (!this._modelData) return;
		const selection = new Selection$1(sel.selectionStartLineNumber, sel.selectionStartColumn, sel.positionLineNumber, sel.positionColumn);
		this._modelData.viewModel.setSelections(source, [selection]);
	}
	revealLines(startLineNumber, endLineNumber, scrollType = 0) {
		this._revealLines(startLineNumber, endLineNumber, 0, scrollType);
	}
	revealLinesInCenter(startLineNumber, endLineNumber, scrollType = 0) {
		this._revealLines(startLineNumber, endLineNumber, 1, scrollType);
	}
	revealLinesInCenterIfOutsideViewport(startLineNumber, endLineNumber, scrollType = 0) {
		this._revealLines(startLineNumber, endLineNumber, 2, scrollType);
	}
	revealLinesNearTop(startLineNumber, endLineNumber, scrollType = 0) {
		this._revealLines(startLineNumber, endLineNumber, 5, scrollType);
	}
	_revealLines(startLineNumber, endLineNumber, verticalType, scrollType) {
		if (typeof startLineNumber !== "number" || typeof endLineNumber !== "number") throw new Error("Invalid arguments");
		this._sendRevealRange(new Range$2(startLineNumber, 1, endLineNumber, 1), verticalType, false, scrollType);
	}
	revealRange(range, scrollType = 0, revealVerticalInCenter = false, revealHorizontal = true) {
		this._revealRange(range, revealVerticalInCenter ? 1 : 0, revealHorizontal, scrollType);
	}
	revealRangeInCenter(range, scrollType = 0) {
		this._revealRange(range, 1, true, scrollType);
	}
	revealRangeInCenterIfOutsideViewport(range, scrollType = 0) {
		this._revealRange(range, 2, true, scrollType);
	}
	revealRangeNearTop(range, scrollType = 0) {
		this._revealRange(range, 5, true, scrollType);
	}
	revealRangeNearTopIfOutsideViewport(range, scrollType = 0) {
		this._revealRange(range, 6, true, scrollType);
	}
	revealRangeAtTop(range, scrollType = 0) {
		this._revealRange(range, 3, true, scrollType);
	}
	_revealRange(range, verticalType, revealHorizontal, scrollType) {
		if (!Range$2.isIRange(range)) throw new Error("Invalid arguments");
		this._sendRevealRange(Range$2.lift(range), verticalType, revealHorizontal, scrollType);
	}
	setSelections(ranges, source = "api", reason = 0) {
		if (!this._modelData) return;
		if (!ranges || ranges.length === 0) throw new Error("Invalid arguments");
		for (let i = 0, len = ranges.length; i < len; i++) if (!Selection$1.isISelection(ranges[i])) throw new Error("Invalid arguments");
		this._modelData.viewModel.setSelections(source, ranges, reason);
	}
	getContentWidth() {
		if (!this._modelData) return -1;
		return this._modelData.viewModel.viewLayout.getContentWidth();
	}
	getScrollWidth() {
		if (!this._modelData) return -1;
		return this._modelData.viewModel.viewLayout.getScrollWidth();
	}
	getScrollLeft() {
		if (!this._modelData) return -1;
		return this._modelData.viewModel.viewLayout.getCurrentScrollLeft();
	}
	getContentHeight() {
		if (!this._modelData) return -1;
		return this._modelData.viewModel.viewLayout.getContentHeight();
	}
	getScrollHeight() {
		if (!this._modelData) return -1;
		return this._modelData.viewModel.viewLayout.getScrollHeight();
	}
	getScrollTop() {
		if (!this._modelData) return -1;
		return this._modelData.viewModel.viewLayout.getCurrentScrollTop();
	}
	setScrollLeft(newScrollLeft, scrollType = 1) {
		if (!this._modelData) return;
		if (typeof newScrollLeft !== "number") throw new Error("Invalid arguments");
		this._modelData.viewModel.viewLayout.setScrollPosition({ scrollLeft: newScrollLeft }, scrollType);
	}
	setScrollTop(newScrollTop, scrollType = 1) {
		if (!this._modelData) return;
		if (typeof newScrollTop !== "number") throw new Error("Invalid arguments");
		this._modelData.viewModel.viewLayout.setScrollPosition({ scrollTop: newScrollTop }, scrollType);
	}
	setScrollPosition(position, scrollType = 1) {
		if (!this._modelData) return;
		this._modelData.viewModel.viewLayout.setScrollPosition(position, scrollType);
	}
	hasPendingScrollAnimation() {
		if (!this._modelData) return false;
		return this._modelData.viewModel.viewLayout.hasPendingScrollAnimation();
	}
	saveViewState() {
		if (!this._modelData) return null;
		const contributionsState = this._contributions.saveViewState();
		return {
			cursorState: this._modelData.viewModel.saveCursorState(),
			viewState: this._modelData.viewModel.saveState(),
			contributionsState
		};
	}
	restoreViewState(s) {
		if (!this._modelData || !this._modelData.hasRealView) return;
		const codeEditorState = s;
		if (codeEditorState && codeEditorState.cursorState && codeEditorState.viewState) {
			const cursorState = codeEditorState.cursorState;
			if (Array.isArray(cursorState)) {
				if (cursorState.length > 0) this._modelData.viewModel.restoreCursorState(cursorState);
			} else this._modelData.viewModel.restoreCursorState([cursorState]);
			this._contributions.restoreViewState(codeEditorState.contributionsState || {});
			const reducedState = this._modelData.viewModel.reduceRestoreState(codeEditorState.viewState);
			this._modelData.view.restoreState(reducedState);
		}
	}
	handleInitialized() {
		this._getViewModel()?.visibleLinesStabilized();
	}
	getContribution(id) {
		return this._contributions.get(id);
	}
	getActions() {
		return Array.from(this._actions.values());
	}
	getSupportedActions() {
		let result = this.getActions();
		result = result.filter((action) => action.isSupported());
		return result;
	}
	getAction(id) {
		return this._actions.get(id) || null;
	}
	trigger(source, handlerId, payload) {
		payload = payload || {};
		try {
			this._onWillTriggerEditorOperationEvent.fire({
				source,
				handlerId,
				payload
			});
			this._beginUpdate();
			switch (handlerId) {
				case "compositionStart":
					this._startComposition();
					return;
				case "compositionEnd":
					this._endComposition(source);
					return;
				case "type": {
					const args = payload;
					this._type(source, args.text || "");
					return;
				}
				case "replacePreviousChar": {
					const args = payload;
					this._compositionType(source, args.text || "", args.replaceCharCnt || 0, 0, 0);
					return;
				}
				case "compositionType": {
					const args = payload;
					this._compositionType(source, args.text || "", args.replacePrevCharCnt || 0, args.replaceNextCharCnt || 0, args.positionDelta || 0);
					return;
				}
				case "paste": {
					const args = payload;
					this._paste(source, args.text || "", args.pasteOnNewLine || false, args.multicursorText || null, args.mode || null, args.clipboardEvent);
					return;
				}
				case "cut":
					this._cut(source);
					return;
			}
			const action = this.getAction(handlerId);
			if (action) {
				Promise.resolve(action.run(payload)).then(void 0, onUnexpectedError);
				return;
			}
			if (!this._modelData) return;
			if (this._triggerEditorCommand(source, handlerId, payload)) return;
			this._triggerCommand(handlerId, payload);
		} finally {
			this._endUpdate();
		}
	}
	_triggerCommand(handlerId, payload) {
		this._commandService.executeCommand(handlerId, payload);
	}
	_startComposition() {
		if (!this._modelData) return;
		this.inComposition = true;
		this._modelData.viewModel.startComposition();
		this._onDidCompositionStart.fire();
	}
	_endComposition(source) {
		if (!this._modelData) return;
		this.inComposition = false;
		this._modelData.viewModel.endComposition(source);
		this._onDidCompositionEnd.fire();
	}
	_type(source, text) {
		if (!this._modelData || text.length === 0) return;
		if (source === "keyboard") this._onWillType.fire(text);
		this._modelData.viewModel.type(text, source);
		if (source === "keyboard") this._onDidType.fire(text);
	}
	_compositionType(source, text, replacePrevCharCnt, replaceNextCharCnt, positionDelta) {
		if (!this._modelData) return;
		this._modelData.viewModel.compositionType(text, replacePrevCharCnt, replaceNextCharCnt, positionDelta, source);
	}
	_paste(source, text, pasteOnNewLine, multicursorText, mode, clipboardEvent) {
		if (!this._modelData) return;
		const viewModel = this._modelData.viewModel;
		const startPosition = viewModel.getSelection().getStartPosition();
		viewModel.paste(text, pasteOnNewLine, multicursorText, source);
		const endPosition = viewModel.getSelection().getStartPosition();
		if (source === "keyboard") this._onDidPaste.fire({
			clipboardEvent,
			range: new Range$2(startPosition.lineNumber, startPosition.column, endPosition.lineNumber, endPosition.column),
			languageId: mode
		});
	}
	_cut(source) {
		if (!this._modelData) return;
		this._modelData.viewModel.cut(source);
	}
	_triggerEditorCommand(source, handlerId, payload) {
		const command = EditorExtensionsRegistry.getEditorCommand(handlerId);
		if (command) {
			payload = payload || {};
			if (isObject(payload)) payload.source = source;
			this._instantiationService.invokeFunction((accessor) => {
				Promise.resolve(command.runEditorCommand(accessor, this, payload)).then(void 0, onUnexpectedError);
			});
			return true;
		}
		return false;
	}
	_getViewModel() {
		if (!this._modelData) return null;
		return this._modelData.viewModel;
	}
	pushUndoStop() {
		if (!this._modelData) return false;
		if (this._configuration.options.get(104)) return false;
		this._modelData.model.pushStackElement();
		return true;
	}
	popUndoStop() {
		if (!this._modelData) return false;
		if (this._configuration.options.get(104)) return false;
		this._modelData.model.popStackElement();
		return true;
	}
	edit(edit, reason) {
		return this.executeEdits(reason, edit.replacements.map((e) => ({
			range: e.range,
			text: e.text
		})), void 0);
	}
	executeEdits(source, edits, endCursorState) {
		if (!this._modelData) return false;
		if (this._configuration.options.get(104)) return false;
		let cursorStateComputer;
		if (!endCursorState) cursorStateComputer = () => null;
		else if (Array.isArray(endCursorState)) cursorStateComputer = () => endCursorState;
		else cursorStateComputer = endCursorState;
		let sourceStr;
		let reason;
		if (source instanceof TextModelEditSource) {
			reason = source;
			sourceStr = source.metadata.source;
		} else {
			reason = EditSources.unknown({ name: source });
			sourceStr = source;
		}
		this._onBeforeExecuteEdit.fire({ source: sourceStr ?? void 0 });
		this._modelData.viewModel.executeEdits(sourceStr, edits, cursorStateComputer, reason);
		return true;
	}
	executeCommand(source, command) {
		if (!this._modelData) return;
		this._modelData.viewModel.executeCommand(command, source);
	}
	executeCommands(source, commands) {
		if (!this._modelData) return;
		this._modelData.viewModel.executeCommands(commands, source);
	}
	createDecorationsCollection(decorations) {
		return new EditorDecorationsCollection(this, decorations);
	}
	changeDecorations(callback) {
		if (!this._modelData) return null;
		return this._modelData.model.changeDecorations(callback, this._id);
	}
	getLineDecorations(lineNumber) {
		if (!this._modelData) return null;
		const options = this._configuration.options;
		return this._modelData.model.getLineDecorations(lineNumber, this._id, filterValidationDecorations(options), filterFontDecorations(options));
	}
	getDecorationsInRange(range) {
		if (!this._modelData) return null;
		const options = this._configuration.options;
		return this._modelData.model.getDecorationsInRange(range, this._id, filterValidationDecorations(options), filterFontDecorations(options));
	}
	getFontSizeAtPosition(position) {
		if (!this._modelData) return null;
		return this._modelData.viewModel.getFontSizeAtPosition(position);
	}
	/**
	* @deprecated
	*/
	deltaDecorations(oldDecorations, newDecorations) {
		if (!this._modelData) return [];
		if (oldDecorations.length === 0 && newDecorations.length === 0) return oldDecorations;
		return this._modelData.model.deltaDecorations(oldDecorations, newDecorations, this._id);
	}
	removeDecorations(decorationIds) {
		if (!this._modelData || decorationIds.length === 0) return;
		this._modelData.model.changeDecorations((changeAccessor) => {
			changeAccessor.deltaDecorations(decorationIds, []);
		});
	}
	removeDecorationsByType(decorationTypeKey) {
		const oldDecorationsIds = this._decorationTypeKeysToIds[decorationTypeKey];
		if (oldDecorationsIds) this.changeDecorations((accessor) => accessor.deltaDecorations(oldDecorationsIds, []));
		if (this._decorationTypeKeysToIds.hasOwnProperty(decorationTypeKey)) delete this._decorationTypeKeysToIds[decorationTypeKey];
		if (this._decorationTypeSubtypes.hasOwnProperty(decorationTypeKey)) {
			const items = this._decorationTypeSubtypes[decorationTypeKey];
			for (const subType of Object.keys(items)) this._removeDecorationType(decorationTypeKey + "-" + subType);
			delete this._decorationTypeSubtypes[decorationTypeKey];
		}
	}
	getLayoutInfo() {
		return this._configuration.options.get(166);
	}
	createOverviewRuler(cssClassName) {
		if (!this._modelData || !this._modelData.hasRealView) return null;
		return this._modelData.view.createOverviewRuler(cssClassName);
	}
	getContainerDomNode() {
		return this._domElement;
	}
	getDomNode() {
		if (!this._modelData || !this._modelData.hasRealView) return null;
		return this._modelData.view.domNode.domNode;
	}
	delegateVerticalScrollbarPointerDown(browserEvent) {
		if (!this._modelData || !this._modelData.hasRealView) return;
		this._modelData.view.delegateVerticalScrollbarPointerDown(browserEvent);
	}
	delegateScrollFromMouseWheelEvent(browserEvent) {
		if (!this._modelData || !this._modelData.hasRealView) return;
		this._modelData.view.delegateScrollFromMouseWheelEvent(browserEvent);
	}
	layout(dimension, postponeRendering = false) {
		this._configuration.observeContainer(dimension);
		if (!postponeRendering) this.render();
	}
	focus() {
		if (!this._modelData || !this._modelData.hasRealView) return;
		this._modelData.view.focus();
	}
	hasTextFocus() {
		if (!this._modelData || !this._modelData.hasRealView) return false;
		return this._modelData.view.isFocused();
	}
	hasWidgetFocus() {
		if (!this._modelData || !this._modelData.hasRealView) return false;
		return this._modelData.view.isWidgetFocused();
	}
	addContentWidget(widget) {
		const widgetData = {
			widget,
			position: widget.getPosition()
		};
		if (this._contentWidgets.hasOwnProperty(widget.getId())) console.warn("Overwriting a content widget with the same id:" + widget.getId());
		this._contentWidgets[widget.getId()] = widgetData;
		if (this._modelData && this._modelData.hasRealView) this._modelData.view.addContentWidget(widgetData);
	}
	layoutContentWidget(widget) {
		const widgetId = widget.getId();
		if (this._contentWidgets.hasOwnProperty(widgetId)) {
			const widgetData = this._contentWidgets[widgetId];
			widgetData.position = widget.getPosition();
			if (this._modelData && this._modelData.hasRealView) this._modelData.view.layoutContentWidget(widgetData);
		}
	}
	removeContentWidget(widget) {
		const widgetId = widget.getId();
		if (this._contentWidgets.hasOwnProperty(widgetId)) {
			const widgetData = this._contentWidgets[widgetId];
			delete this._contentWidgets[widgetId];
			if (this._modelData && this._modelData.hasRealView) this._modelData.view.removeContentWidget(widgetData);
		}
	}
	addOverlayWidget(widget) {
		const widgetData = {
			widget,
			position: widget.getPosition()
		};
		if (this._overlayWidgets.hasOwnProperty(widget.getId())) console.warn("Overwriting an overlay widget with the same id.");
		this._overlayWidgets[widget.getId()] = widgetData;
		if (this._modelData && this._modelData.hasRealView) this._modelData.view.addOverlayWidget(widgetData);
	}
	layoutOverlayWidget(widget) {
		const widgetId = widget.getId();
		if (this._overlayWidgets.hasOwnProperty(widgetId)) {
			const widgetData = this._overlayWidgets[widgetId];
			widgetData.position = widget.getPosition();
			if (this._modelData && this._modelData.hasRealView) this._modelData.view.layoutOverlayWidget(widgetData);
		}
	}
	removeOverlayWidget(widget) {
		const widgetId = widget.getId();
		if (this._overlayWidgets.hasOwnProperty(widgetId)) {
			const widgetData = this._overlayWidgets[widgetId];
			delete this._overlayWidgets[widgetId];
			if (this._modelData && this._modelData.hasRealView) this._modelData.view.removeOverlayWidget(widgetData);
		}
	}
	addGlyphMarginWidget(widget) {
		const widgetData = {
			widget,
			position: widget.getPosition()
		};
		if (this._glyphMarginWidgets.hasOwnProperty(widget.getId())) console.warn("Overwriting a glyph margin widget with the same id.");
		this._glyphMarginWidgets[widget.getId()] = widgetData;
		if (this._modelData && this._modelData.hasRealView) this._modelData.view.addGlyphMarginWidget(widgetData);
	}
	layoutGlyphMarginWidget(widget) {
		const widgetId = widget.getId();
		if (this._glyphMarginWidgets.hasOwnProperty(widgetId)) {
			const widgetData = this._glyphMarginWidgets[widgetId];
			widgetData.position = widget.getPosition();
			if (this._modelData && this._modelData.hasRealView) this._modelData.view.layoutGlyphMarginWidget(widgetData);
		}
	}
	removeGlyphMarginWidget(widget) {
		const widgetId = widget.getId();
		if (this._glyphMarginWidgets.hasOwnProperty(widgetId)) {
			const widgetData = this._glyphMarginWidgets[widgetId];
			delete this._glyphMarginWidgets[widgetId];
			if (this._modelData && this._modelData.hasRealView) this._modelData.view.removeGlyphMarginWidget(widgetData);
		}
	}
	changeViewZones(callback) {
		if (!this._modelData || !this._modelData.hasRealView) return;
		this._modelData.view.change(callback);
	}
	getTargetAtClientPoint(clientX, clientY) {
		if (!this._modelData || !this._modelData.hasRealView) return null;
		return this._modelData.view.getTargetAtClientPoint(clientX, clientY);
	}
	getScrolledVisiblePosition(rawPosition) {
		if (!this._modelData || !this._modelData.hasRealView) return null;
		const position = this._modelData.model.validatePosition(rawPosition);
		const layoutInfo = this._configuration.options.get(166);
		return {
			top: CodeEditorWidget_1._getVerticalOffsetForPosition(this._modelData, position.lineNumber, position.column) - this.getScrollTop(),
			left: this._modelData.view.getOffsetForColumn(position.lineNumber, position.column) + layoutInfo.glyphMarginWidth + layoutInfo.lineNumbersWidth + layoutInfo.decorationsWidth - this.getScrollLeft(),
			height: this.getLineHeightForPosition(position)
		};
	}
	getOffsetForColumn(lineNumber, column) {
		if (!this._modelData || !this._modelData.hasRealView) return -1;
		return this._modelData.view.getOffsetForColumn(lineNumber, column);
	}
	getWidthOfLine(lineNumber) {
		if (!this._modelData || !this._modelData.hasRealView) return -1;
		return this._modelData.view.getLineWidth(lineNumber);
	}
	resetLineWidthCaches() {
		if (!this._modelData || !this._modelData.hasRealView) return;
		this._modelData.view.resetLineWidthCaches();
	}
	render(forceRedraw = false) {
		if (!this._modelData || !this._modelData.hasRealView) return;
		this._modelData.viewModel.batchEvents(() => {
			this._modelData.view.render(true, forceRedraw);
		});
	}
	renderAsync(forceRedraw = false) {
		if (!this._modelData || !this._modelData.hasRealView) return;
		this._modelData.viewModel.batchEvents(() => {
			this._modelData.view.render(false, forceRedraw);
		});
	}
	setAriaOptions(options) {
		if (!this._modelData || !this._modelData.hasRealView) return;
		this._modelData.view.setAriaOptions(options);
	}
	applyFontInfo(target) {
		applyFontInfo(target, this._configuration.options.get(59));
	}
	setBanner(domNode, domNodeHeight) {
		if (this._bannerDomNode && this._domElement.contains(this._bannerDomNode)) this._bannerDomNode.remove();
		this._bannerDomNode = domNode;
		this._configuration.setReservedHeight(domNode ? domNodeHeight : 0);
		if (this._bannerDomNode) this._domElement.prepend(this._bannerDomNode);
	}
	_attachModel(model) {
		if (!model) {
			this._modelData = null;
			return;
		}
		const listenersToRemove = [];
		this._domElement.setAttribute("data-mode-id", model.getLanguageId());
		this._configuration.setIsDominatedByLongLines(model.isDominatedByLongLines());
		this._configuration.setModelLineCount(model.getLineCount());
		const attachedView = model.onBeforeAttached();
		const viewModel = new ViewModel$1(this._id, this._configuration, model, DOMLineBreaksComputerFactory.create(getWindow(this._domElement)), MonospaceLineBreaksComputerFactory.create(this._configuration.options), (callback) => scheduleAtNextAnimationFrame(getWindow(this._domElement), callback), this.languageConfigurationService, this._themeService, attachedView, { batchChanges: (cb) => {
			try {
				this._beginUpdate();
				return cb();
			} finally {
				this._endUpdate();
			}
		} });
		listenersToRemove.push(model.onWillDispose(() => this.setModel(null)));
		listenersToRemove.push(viewModel.onEvent((e) => {
			switch (e.kind) {
				case 0:
					this._onDidContentSizeChange.fire(e);
					break;
				case 1:
					this._editorTextFocus.setValue(e.hasFocus);
					break;
				case 2:
					this._editorWidgetFocus.setValue(e.hasFocus);
					break;
				case 3:
					this._onDidScrollChange.fire(e);
					break;
				case 4:
					this._onDidChangeViewZones.fire();
					break;
				case 5:
					this._onDidChangeHiddenAreas.fire();
					break;
				case 6:
					this._onDidAttemptReadOnlyEdit.fire();
					break;
				case 7: {
					if (e.reachedMaxCursorCount) {
						const multiCursorLimit = this.getOption(89);
						const message = localize(99, "The number of cursors has been limited to {0}. Consider using [find and replace](https://code.visualstudio.com/docs/editor/codebasics#_find-and-replace) for larger changes or increase the editor multi cursor limit setting.", multiCursorLimit);
						this._notificationService.prompt(Severity.Warning, message, [{
							label: "Find and Replace",
							run: () => {
								this._commandService.executeCommand("editor.action.startFindReplaceAction");
							}
						}, {
							label: localize(100, "Increase Multi Cursor Limit"),
							run: () => {
								this._commandService.executeCommand("workbench.action.openSettings2", { query: "editor.multiCursorLimit" });
							}
						}]);
					}
					const positions = [];
					for (let i = 0, len = e.selections.length; i < len; i++) positions[i] = e.selections[i].getPosition();
					const e1 = {
						position: positions[0],
						secondaryPositions: positions.slice(1),
						reason: e.reason,
						source: e.source
					};
					this._onDidChangeCursorPosition.fire(e1);
					const e2 = {
						selection: e.selections[0],
						secondarySelections: e.selections.slice(1),
						modelVersionId: e.modelVersionId,
						oldSelections: e.oldSelections,
						oldModelVersionId: e.oldModelVersionId,
						source: e.source,
						reason: e.reason
					};
					this._onDidChangeCursorSelection.fire(e2);
					break;
				}
				case 8:
					this._onDidChangeModelDecorations.fire(e.event);
					break;
				case 9:
					this._domElement.setAttribute("data-mode-id", model.getLanguageId());
					this._onDidChangeModelLanguage.fire(e.event);
					break;
				case 10:
					this._onDidChangeModelLanguageConfiguration.fire(e.event);
					break;
				case 11:
					this._onDidChangeModelContent.fire(e.event);
					break;
				case 12:
					this._onDidChangeModelOptions.fire(e.event);
					break;
				case 13:
					this._onDidChangeModelTokens.fire(e.event);
					break;
				case 14:
					this._onDidChangeLineHeight.fire(e.event);
					break;
				case 15: this._onDidChangeFont.fire(e.event);
			}
		}));
		const [view, hasRealView] = this._createView(viewModel);
		if (hasRealView) {
			this._domElement.appendChild(view.domNode.domNode);
			let keys = Object.keys(this._contentWidgets);
			for (let i = 0, len = keys.length; i < len; i++) {
				const widgetId = keys[i];
				view.addContentWidget(this._contentWidgets[widgetId]);
			}
			keys = Object.keys(this._overlayWidgets);
			for (let i = 0, len = keys.length; i < len; i++) {
				const widgetId = keys[i];
				view.addOverlayWidget(this._overlayWidgets[widgetId]);
			}
			keys = Object.keys(this._glyphMarginWidgets);
			for (let i = 0, len = keys.length; i < len; i++) {
				const widgetId = keys[i];
				view.addGlyphMarginWidget(this._glyphMarginWidgets[widgetId]);
			}
			view.render(false, true);
			view.domNode.domNode.setAttribute("data-uri", model.uri.toString());
			listenersToRemove.push(view.onWillCopy((e) => this._onWillCopy.fire(e)));
			listenersToRemove.push(view.onWillCut((e) => this._onWillCut.fire(e)));
			listenersToRemove.push(view.onWillPaste((e) => this._onWillPaste.fire(e)));
		}
		this._modelData = new ModelData$1(model, viewModel, view, hasRealView, listenersToRemove, attachedView);
	}
	_createView(viewModel) {
		let commandDelegate;
		if (this.isSimpleWidget) commandDelegate = {
			paste: (text, pasteOnNewLine, multicursorText, mode) => {
				this._paste("keyboard", text, pasteOnNewLine, multicursorText, mode);
			},
			type: (text) => {
				this._type("keyboard", text);
			},
			compositionType: (text, replacePrevCharCnt, replaceNextCharCnt, positionDelta) => {
				this._compositionType("keyboard", text, replacePrevCharCnt, replaceNextCharCnt, positionDelta);
			},
			startComposition: () => {
				this._startComposition();
			},
			endComposition: () => {
				this._endComposition("keyboard");
			},
			cut: () => {
				this._cut("keyboard");
			}
		};
		else commandDelegate = {
			paste: (text, pasteOnNewLine, multicursorText, mode) => {
				const payload = {
					text,
					pasteOnNewLine,
					multicursorText,
					mode
				};
				this._commandService.executeCommand("paste", payload);
			},
			type: (text) => {
				const payload = { text };
				this._commandService.executeCommand("type", payload);
			},
			compositionType: (text, replacePrevCharCnt, replaceNextCharCnt, positionDelta) => {
				if (replaceNextCharCnt || positionDelta) {
					const payload = {
						text,
						replacePrevCharCnt,
						replaceNextCharCnt,
						positionDelta
					};
					this._commandService.executeCommand("compositionType", payload);
				} else {
					const payload = {
						text,
						replaceCharCnt: replacePrevCharCnt
					};
					this._commandService.executeCommand("replacePreviousChar", payload);
				}
			},
			startComposition: () => {
				this._commandService.executeCommand("compositionStart", {});
			},
			endComposition: () => {
				this._commandService.executeCommand("compositionEnd", {});
			},
			cut: () => {
				this._commandService.executeCommand("cut", {});
			}
		};
		const viewUserInputEvents = new ViewUserInputEvents(viewModel.coordinatesConverter);
		viewUserInputEvents.onKeyDown = (e) => this._onKeyDown.fire(e);
		viewUserInputEvents.onKeyUp = (e) => this._onKeyUp.fire(e);
		viewUserInputEvents.onContextMenu = (e) => this._onContextMenu.fire(e);
		viewUserInputEvents.onMouseMove = (e) => this._onMouseMove.fire(e);
		viewUserInputEvents.onMouseLeave = (e) => this._onMouseLeave.fire(e);
		viewUserInputEvents.onMouseDown = (e) => this._onMouseDown.fire(e);
		viewUserInputEvents.onMouseUp = (e) => this._onMouseUp.fire(e);
		viewUserInputEvents.onMouseDrag = (e) => this._onMouseDrag.fire(e);
		viewUserInputEvents.onMouseDrop = (e) => this._onMouseDrop.fire(e);
		viewUserInputEvents.onMouseDropCanceled = (e) => this._onMouseDropCanceled.fire(e);
		viewUserInputEvents.onMouseWheel = (e) => this._onMouseWheel.fire(e);
		return [new View$1(this._domElement, this.getId(), commandDelegate, this._configuration, this._themeService.getColorTheme(), viewModel, viewUserInputEvents, this._overflowWidgetsDomNode, this._instantiationService, this._userInteractionService), true];
	}
	_postDetachModelCleanup(detachedModel) {
		detachedModel?.removeAllDecorationsWithOwnerId(this._id);
	}
	_detachModel() {
		this._contributionsDisposable?.dispose();
		this._contributionsDisposable = void 0;
		if (!this._modelData) return null;
		const model = this._modelData.model;
		const removeDomNode = this._modelData.hasRealView ? this._modelData.view.domNode.domNode : null;
		this._modelData.dispose();
		this._modelData = null;
		this._domElement.removeAttribute("data-mode-id");
		if (removeDomNode && this._domElement.contains(removeDomNode)) removeDomNode.remove();
		if (this._bannerDomNode && this._domElement.contains(this._bannerDomNode)) this._bannerDomNode.remove();
		return model;
	}
	_removeDecorationType(key) {
		this._codeEditorService.removeDecorationType(key);
	}
	hasModel() {
		return this._modelData !== null;
	}
	showDropIndicatorAt(position) {
		const newDecorations = [{
			range: new Range$2(position.lineNumber, position.column, position.lineNumber, position.column),
			options: CodeEditorWidget_1.dropIntoEditorDecorationOptions
		}];
		this._dropIntoEditorDecorations.set(newDecorations);
		this.revealPosition(position, 1);
	}
	removeDropIndicator() {
		this._dropIntoEditorDecorations.clear();
	}
	_beginUpdate() {
		this._updateCounter++;
		if (this._updateCounter === 1) this._onBeginUpdate.fire();
	}
	_endUpdate() {
		this._updateCounter--;
		if (this._updateCounter === 0) this._onEndUpdate.fire();
	}
};
CodeEditorWidget = CodeEditorWidget_1 = __decorate$54([
	__param$49(3, IInstantiationService),
	__param$49(4, ICodeEditorService),
	__param$49(5, ICommandService),
	__param$49(6, IContextKeyService),
	__param$49(7, IThemeService),
	__param$49(8, INotificationService),
	__param$49(9, IAccessibilityService),
	__param$49(10, ILanguageConfigurationService),
	__param$49(11, ILanguageFeaturesService),
	__param$49(12, IUserInteractionService)
], CodeEditorWidget);
var EDITOR_ID = 0;
var ModelData$1 = class {
	constructor(model, viewModel, view, hasRealView, listenersToRemove, attachedView) {
		this.model = model;
		this.viewModel = viewModel;
		this.view = view;
		this.hasRealView = hasRealView;
		this.listenersToRemove = listenersToRemove;
		this.attachedView = attachedView;
	}
	dispose() {
		dispose(this.listenersToRemove);
		this.model.onBeforeDetached(this.attachedView);
		if (this.hasRealView) this.view.dispose();
		this.viewModel.dispose();
	}
};
var BooleanEventEmitter = class extends Disposable {
	constructor(_emitterOptions) {
		super();
		this._emitterOptions = _emitterOptions;
		this._onDidChangeToTrue = this._register(new Emitter$1(this._emitterOptions));
		this.onDidChangeToTrue = this._onDidChangeToTrue.event;
		this._onDidChangeToFalse = this._register(new Emitter$1(this._emitterOptions));
		this.onDidChangeToFalse = this._onDidChangeToFalse.event;
		this._value = 0;
	}
	setValue(_value) {
		const value = _value ? 2 : 1;
		if (this._value === value) return;
		this._value = value;
		if (this._value === 2) this._onDidChangeToTrue.fire();
		else if (this._value === 1) this._onDidChangeToFalse.fire();
	}
};
/**
* A regular event emitter that also makes sure contributions are instantiated if necessary
*/
var InteractionEmitter = class extends Emitter$1 {
	constructor(_contributions, deliveryQueue) {
		super({ deliveryQueue });
		this._contributions = _contributions;
	}
	fire(event) {
		this._contributions.onBeforeInteractionEvent();
		super.fire(event);
	}
};
var EditorContextKeysManager = class extends Disposable {
	constructor(editor, contextKeyService) {
		super();
		this._editor = editor;
		contextKeyService.createKey("editorId", editor.getId());
		this._editorSimpleInput = EditorContextKeys.editorSimpleInput.bindTo(contextKeyService);
		this._editorFocus = EditorContextKeys.focus.bindTo(contextKeyService);
		this._textInputFocus = EditorContextKeys.textInputFocus.bindTo(contextKeyService);
		this._editorTextFocus = EditorContextKeys.editorTextFocus.bindTo(contextKeyService);
		this._tabMovesFocus = EditorContextKeys.tabMovesFocus.bindTo(contextKeyService);
		this._editorReadonly = EditorContextKeys.readOnly.bindTo(contextKeyService);
		this._inDiffEditor = EditorContextKeys.inDiffEditor.bindTo(contextKeyService);
		this._editorColumnSelection = EditorContextKeys.columnSelection.bindTo(contextKeyService);
		this._hasMultipleSelections = EditorContextKeys.hasMultipleSelections.bindTo(contextKeyService);
		this._hasNonEmptySelection = EditorContextKeys.hasNonEmptySelection.bindTo(contextKeyService);
		this._canUndo = EditorContextKeys.canUndo.bindTo(contextKeyService);
		this._canRedo = EditorContextKeys.canRedo.bindTo(contextKeyService);
		this._register(this._editor.onDidChangeConfiguration(() => this._updateFromConfig()));
		this._register(this._editor.onDidChangeCursorSelection(() => this._updateFromSelection()));
		this._register(this._editor.onDidFocusEditorWidget(() => this._updateFromFocus()));
		this._register(this._editor.onDidBlurEditorWidget(() => this._updateFromFocus()));
		this._register(this._editor.onDidFocusEditorText(() => this._updateFromFocus()));
		this._register(this._editor.onDidBlurEditorText(() => this._updateFromFocus()));
		this._register(this._editor.onDidChangeModel(() => this._updateFromModel()));
		this._register(this._editor.onDidChangeConfiguration(() => this._updateFromModel()));
		this._register(TabFocus.onDidChangeTabFocus((tabFocusMode) => this._tabMovesFocus.set(tabFocusMode)));
		this._updateFromConfig();
		this._updateFromSelection();
		this._updateFromFocus();
		this._updateFromModel();
		this._editorSimpleInput.set(this._editor.isSimpleWidget);
	}
	_updateFromConfig() {
		const options = this._editor.getOptions();
		this._tabMovesFocus.set(options.get(165) || TabFocus.getTabFocusMode());
		this._editorReadonly.set(options.get(104));
		this._inDiffEditor.set(options.get(70));
		this._editorColumnSelection.set(options.get(28));
	}
	_updateFromSelection() {
		const selections = this._editor.getSelections();
		if (!selections) {
			this._hasMultipleSelections.reset();
			this._hasNonEmptySelection.reset();
		} else {
			this._hasMultipleSelections.set(selections.length > 1);
			this._hasNonEmptySelection.set(selections.some((s) => !s.isEmpty()));
		}
	}
	_updateFromFocus() {
		this._editorFocus.set(this._editor.hasWidgetFocus() && !this._editor.isSimpleWidget);
		this._editorTextFocus.set(this._editor.hasTextFocus() && !this._editor.isSimpleWidget);
		this._textInputFocus.set(this._editor.hasTextFocus());
	}
	_updateFromModel() {
		const model = this._editor.getModel();
		this._canUndo.set(Boolean(model && model.canUndo()));
		this._canRedo.set(Boolean(model && model.canRedo()));
	}
};
var EditorModeContext = class extends Disposable {
	constructor(_editor, _contextKeyService, _languageFeaturesService) {
		super();
		this._editor = _editor;
		this._contextKeyService = _contextKeyService;
		this._languageFeaturesService = _languageFeaturesService;
		this._langId = EditorContextKeys.languageId.bindTo(_contextKeyService);
		this._hasCompletionItemProvider = EditorContextKeys.hasCompletionItemProvider.bindTo(_contextKeyService);
		this._hasCodeActionsProvider = EditorContextKeys.hasCodeActionsProvider.bindTo(_contextKeyService);
		this._hasCodeLensProvider = EditorContextKeys.hasCodeLensProvider.bindTo(_contextKeyService);
		this._hasDefinitionProvider = EditorContextKeys.hasDefinitionProvider.bindTo(_contextKeyService);
		this._hasDeclarationProvider = EditorContextKeys.hasDeclarationProvider.bindTo(_contextKeyService);
		this._hasImplementationProvider = EditorContextKeys.hasImplementationProvider.bindTo(_contextKeyService);
		this._hasTypeDefinitionProvider = EditorContextKeys.hasTypeDefinitionProvider.bindTo(_contextKeyService);
		this._hasHoverProvider = EditorContextKeys.hasHoverProvider.bindTo(_contextKeyService);
		this._hasDocumentHighlightProvider = EditorContextKeys.hasDocumentHighlightProvider.bindTo(_contextKeyService);
		this._hasDocumentSymbolProvider = EditorContextKeys.hasDocumentSymbolProvider.bindTo(_contextKeyService);
		this._hasReferenceProvider = EditorContextKeys.hasReferenceProvider.bindTo(_contextKeyService);
		this._hasRenameProvider = EditorContextKeys.hasRenameProvider.bindTo(_contextKeyService);
		this._hasSignatureHelpProvider = EditorContextKeys.hasSignatureHelpProvider.bindTo(_contextKeyService);
		this._hasInlayHintsProvider = EditorContextKeys.hasInlayHintsProvider.bindTo(_contextKeyService);
		this._hasDocumentFormattingProvider = EditorContextKeys.hasDocumentFormattingProvider.bindTo(_contextKeyService);
		this._hasDocumentSelectionFormattingProvider = EditorContextKeys.hasDocumentSelectionFormattingProvider.bindTo(_contextKeyService);
		this._hasMultipleDocumentFormattingProvider = EditorContextKeys.hasMultipleDocumentFormattingProvider.bindTo(_contextKeyService);
		this._hasMultipleDocumentSelectionFormattingProvider = EditorContextKeys.hasMultipleDocumentSelectionFormattingProvider.bindTo(_contextKeyService);
		this._isInEmbeddedEditor = EditorContextKeys.isInEmbeddedEditor.bindTo(_contextKeyService);
		const update = () => this._update();
		this._register(_editor.onDidChangeModel(update));
		this._register(_editor.onDidChangeModelLanguage(update));
		this._register(_languageFeaturesService.completionProvider.onDidChange(update));
		this._register(_languageFeaturesService.codeActionProvider.onDidChange(update));
		this._register(_languageFeaturesService.codeLensProvider.onDidChange(update));
		this._register(_languageFeaturesService.definitionProvider.onDidChange(update));
		this._register(_languageFeaturesService.declarationProvider.onDidChange(update));
		this._register(_languageFeaturesService.implementationProvider.onDidChange(update));
		this._register(_languageFeaturesService.typeDefinitionProvider.onDidChange(update));
		this._register(_languageFeaturesService.hoverProvider.onDidChange(update));
		this._register(_languageFeaturesService.documentHighlightProvider.onDidChange(update));
		this._register(_languageFeaturesService.documentSymbolProvider.onDidChange(update));
		this._register(_languageFeaturesService.referenceProvider.onDidChange(update));
		this._register(_languageFeaturesService.renameProvider.onDidChange(update));
		this._register(_languageFeaturesService.documentFormattingEditProvider.onDidChange(update));
		this._register(_languageFeaturesService.documentRangeFormattingEditProvider.onDidChange(update));
		this._register(_languageFeaturesService.signatureHelpProvider.onDidChange(update));
		this._register(_languageFeaturesService.inlayHintsProvider.onDidChange(update));
		update();
	}
	dispose() {
		super.dispose();
	}
	reset() {
		this._contextKeyService.bufferChangeEvents(() => {
			this._langId.reset();
			this._hasCompletionItemProvider.reset();
			this._hasCodeActionsProvider.reset();
			this._hasCodeLensProvider.reset();
			this._hasDefinitionProvider.reset();
			this._hasDeclarationProvider.reset();
			this._hasImplementationProvider.reset();
			this._hasTypeDefinitionProvider.reset();
			this._hasHoverProvider.reset();
			this._hasDocumentHighlightProvider.reset();
			this._hasDocumentSymbolProvider.reset();
			this._hasReferenceProvider.reset();
			this._hasRenameProvider.reset();
			this._hasDocumentFormattingProvider.reset();
			this._hasDocumentSelectionFormattingProvider.reset();
			this._hasSignatureHelpProvider.reset();
			this._isInEmbeddedEditor.reset();
		});
	}
	_update() {
		const model = this._editor.getModel();
		if (!model) {
			this.reset();
			return;
		}
		this._contextKeyService.bufferChangeEvents(() => {
			this._langId.set(model.getLanguageId());
			this._hasCompletionItemProvider.set(this._languageFeaturesService.completionProvider.has(model));
			this._hasCodeActionsProvider.set(this._languageFeaturesService.codeActionProvider.has(model));
			this._hasCodeLensProvider.set(this._languageFeaturesService.codeLensProvider.has(model));
			this._hasDefinitionProvider.set(this._languageFeaturesService.definitionProvider.has(model));
			this._hasDeclarationProvider.set(this._languageFeaturesService.declarationProvider.has(model));
			this._hasImplementationProvider.set(this._languageFeaturesService.implementationProvider.has(model));
			this._hasTypeDefinitionProvider.set(this._languageFeaturesService.typeDefinitionProvider.has(model));
			this._hasHoverProvider.set(this._languageFeaturesService.hoverProvider.has(model));
			this._hasDocumentHighlightProvider.set(this._languageFeaturesService.documentHighlightProvider.has(model));
			this._hasDocumentSymbolProvider.set(this._languageFeaturesService.documentSymbolProvider.has(model));
			this._hasReferenceProvider.set(this._languageFeaturesService.referenceProvider.has(model));
			this._hasRenameProvider.set(this._languageFeaturesService.renameProvider.has(model));
			this._hasSignatureHelpProvider.set(this._languageFeaturesService.signatureHelpProvider.has(model));
			this._hasInlayHintsProvider.set(this._languageFeaturesService.inlayHintsProvider.has(model));
			this._hasDocumentFormattingProvider.set(this._languageFeaturesService.documentFormattingEditProvider.has(model) || this._languageFeaturesService.documentRangeFormattingEditProvider.has(model));
			this._hasDocumentSelectionFormattingProvider.set(this._languageFeaturesService.documentRangeFormattingEditProvider.has(model));
			this._hasMultipleDocumentFormattingProvider.set(this._languageFeaturesService.documentFormattingEditProvider.all(model).length + this._languageFeaturesService.documentRangeFormattingEditProvider.all(model).length > 1);
			this._hasMultipleDocumentSelectionFormattingProvider.set(this._languageFeaturesService.documentRangeFormattingEditProvider.all(model).length > 1);
			this._isInEmbeddedEditor.set(model.uri.scheme === Schemas.walkThroughSnippet || model.uri.scheme === Schemas.vscodeChatCodeBlock);
		});
	}
};
var EditorDecorationsCollection = class {
	get length() {
		return this._decorationIds.length;
	}
	constructor(_editor, decorations) {
		this._editor = _editor;
		this._decorationIds = [];
		this._isChangingDecorations = false;
		if (Array.isArray(decorations) && decorations.length > 0) this.set(decorations);
	}
	onDidChange(listener, thisArgs, disposables) {
		return this._editor.onDidChangeModelDecorations((e) => {
			if (this._isChangingDecorations) return;
			listener.call(thisArgs, e);
		}, disposables);
	}
	getRange(index) {
		if (!this._editor.hasModel()) return null;
		if (index >= this._decorationIds.length) return null;
		return this._editor.getModel().getDecorationRange(this._decorationIds[index]);
	}
	getRanges() {
		if (!this._editor.hasModel()) return [];
		const model = this._editor.getModel();
		const result = [];
		for (const decorationId of this._decorationIds) {
			const range = model.getDecorationRange(decorationId);
			if (range) result.push(range);
		}
		return result;
	}
	has(decoration) {
		return this._decorationIds.includes(decoration.id);
	}
	clear() {
		if (this._decorationIds.length === 0) return;
		this.set([]);
	}
	set(newDecorations) {
		try {
			this._isChangingDecorations = true;
			this._editor.changeDecorations((accessor) => {
				this._decorationIds = accessor.deltaDecorations(this._decorationIds, newDecorations);
			});
		} finally {
			this._isChangingDecorations = false;
		}
		return this._decorationIds;
	}
	append(newDecorations) {
		let newDecorationIds = [];
		try {
			this._isChangingDecorations = true;
			this._editor.changeDecorations((accessor) => {
				newDecorationIds = accessor.deltaDecorations([], newDecorations);
				this._decorationIds = this._decorationIds.concat(newDecorationIds);
			});
		} finally {
			this._isChangingDecorations = false;
		}
		return newDecorationIds;
	}
};
var squigglyStart = encodeURIComponent(`<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 3' enable-background='new 0 0 6 3' height='3' width='6'><g fill='`);
var squigglyEnd = encodeURIComponent(`'><polygon points='5.5,0 2.5,3 1.1,3 4.1,0'/><polygon points='4,0 6,2 6,0.6 5.4,0'/><polygon points='0,2 1,3 2.4,3 0,0.6'/></g></svg>`);
function getSquigglySVGData(color) {
	return squigglyStart + encodeURIComponent(color.toString()) + squigglyEnd;
}
var dotdotdotStart = encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" height="3" width="12"><g fill="`);
var dotdotdotEnd = encodeURIComponent(`"><circle cx="1" cy="1" r="1"/><circle cx="5" cy="1" r="1"/><circle cx="9" cy="1" r="1"/></g></svg>`);
function getDotDotDotSVGData(color) {
	return dotdotdotStart + encodeURIComponent(color.toString()) + dotdotdotEnd;
}
registerThemingParticipant((theme, collector) => {
	const errorForeground = theme.getColor(editorErrorForeground);
	if (errorForeground) {
		collector.addRule(`.monaco-editor .squiggly-error { background: url("data:image/svg+xml,${getSquigglySVGData(errorForeground)}") repeat-x bottom left; }`);
		collector.addRule(`:root { --monaco-editor-error-decoration: url("data:image/svg+xml,${getSquigglySVGData(errorForeground)}"); }`);
	}
	const warningForeground = theme.getColor(editorWarningForeground);
	if (warningForeground) {
		collector.addRule(`.monaco-editor .squiggly-warning { background: url("data:image/svg+xml,${getSquigglySVGData(warningForeground)}") repeat-x bottom left; }`);
		collector.addRule(`:root { --monaco-editor-warning-decoration: url("data:image/svg+xml,${getSquigglySVGData(warningForeground)}"); }`);
	}
	const infoForeground = theme.getColor(editorInfoForeground);
	if (infoForeground) {
		collector.addRule(`.monaco-editor .squiggly-info { background: url("data:image/svg+xml,${getSquigglySVGData(infoForeground)}") repeat-x bottom left; }`);
		collector.addRule(`:root { --monaco-editor-info-decoration: url("data:image/svg+xml,${getSquigglySVGData(infoForeground)}"); }`);
	}
	const hintForeground = theme.getColor(editorHintForeground);
	if (hintForeground) {
		collector.addRule(`.monaco-editor .squiggly-hint { background: url("data:image/svg+xml,${getDotDotDotSVGData(hintForeground)}") no-repeat bottom left; }`);
		collector.addRule(`:root { --monaco-editor-hint-decoration: url("data:image/svg+xml,${getDotDotDotSVGData(hintForeground)}"); }`);
	}
	const unnecessaryForeground = theme.getColor(editorUnnecessaryCodeOpacity);
	if (unnecessaryForeground) {
		collector.addRule(`.monaco-editor.showUnused .squiggly-inline-unnecessary { opacity: ${unnecessaryForeground.rgba.a}; }`);
		collector.addRule(`:root { --monaco-editor-unnecessary-decoration-opacity: ${unnecessaryForeground.rgba.a}; }`);
	}
});
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/hover/browser/hover.js
var __decorate$53 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$48 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var IHoverService = createDecorator("hoverService");
var WorkbenchHoverDelegate = class WorkbenchHoverDelegate extends Disposable {
	get delay() {
		if (this.isInstantlyHovering()) return 0;
		if (this.hoverOptions?.dynamicDelay) return (content) => this.hoverOptions?.dynamicDelay?.(content) ?? this._delay;
		return this._delay;
	}
	constructor(placement, hoverOptions, overrideOptions = {}, configurationService, hoverService) {
		super();
		this.placement = placement;
		this.hoverOptions = hoverOptions;
		this.overrideOptions = overrideOptions;
		this.configurationService = configurationService;
		this.hoverService = hoverService;
		this.lastHoverHideTime = 0;
		this.timeLimit = 200;
		this.hoverDisposables = this._register(new DisposableStore());
		this._delay = this.configurationService.getValue("workbench.hover.delay");
		this._register(this.configurationService.onDidChangeConfiguration((e) => {
			if (e.affectsConfiguration("workbench.hover.delay")) this._delay = this.configurationService.getValue("workbench.hover.delay");
		}));
	}
	showHover(options, focus) {
		const overrideOptions = typeof this.overrideOptions === "function" ? this.overrideOptions(options, focus) : this.overrideOptions;
		this.hoverDisposables.clear();
		const targets = isHTMLElement(options.target) ? [options.target] : options.target.targetElements;
		for (const target of targets) this.hoverDisposables.add(addStandardDisposableListener(target, "keydown", (e) => {
			if (e.equals(9)) this.hoverService.hideHover();
		}));
		const id = isHTMLElement(options.content) ? void 0 : typeof options.content === "string" ? options.content.toString() : options.content.value;
		return this.hoverService.showInstantHover({
			...options,
			...overrideOptions,
			persistence: {
				hideOnKeyDown: true,
				...overrideOptions.persistence
			},
			id,
			appearance: {
				...options.appearance,
				compact: true,
				skipFadeInAnimation: this.isInstantlyHovering(),
				...overrideOptions.appearance
			}
		}, focus);
	}
	isInstantlyHovering() {
		return !!this.hoverOptions?.instantHover && Date.now() - this.lastHoverHideTime < this.timeLimit;
	}
	onDidHideHover() {
		this.hoverDisposables.clear();
		if (this.hoverOptions?.instantHover) this.lastHoverHideTime = Date.now();
	}
};
WorkbenchHoverDelegate = __decorate$53([__param$48(3, IConfigurationService), __param$48(4, IHoverService)], WorkbenchHoverDelegate);
var nativeHoverDelegate = {
	showHover: function() {
		throw new Error("Native hover function not implemented.");
	},
	delay: 0,
	showNativeHover: true
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/contextview/browser/contextView.js
var IContextViewService = createDecorator("contextViewService");
var IContextMenuService = createDecorator("contextMenuService");
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/hover/hoverWidget.js
var $$9 = $$10;
var HoverWidget$1 = class extends Disposable {
	constructor(fadeIn) {
		super();
		this.containerDomNode = document.createElement("div");
		this.containerDomNode.className = "monaco-hover";
		this.containerDomNode.classList.toggle("fade-in", !!fadeIn);
		this.containerDomNode.tabIndex = 0;
		this.containerDomNode.setAttribute("role", "tooltip");
		this.contentsDomNode = document.createElement("div");
		this.contentsDomNode.className = "monaco-hover-content";
		this.scrollbar = this._register(new DomScrollableElement(this.contentsDomNode, { consumeMouseWheelIfScrollbarIsNeeded: true }));
		this.containerDomNode.appendChild(this.scrollbar.getDomNode());
	}
	onContentsChanged() {
		this.scrollbar.scanDomNode();
	}
};
var HoverAction = class HoverAction extends Disposable {
	static render(parent, actionOptions, keybindingLabel) {
		return new HoverAction(parent, actionOptions, keybindingLabel);
	}
	constructor(parent, actionOptions, keybindingLabel) {
		super();
		this.actionLabel = actionOptions.label;
		this.actionKeybindingLabel = keybindingLabel;
		this.actionContainer = append$2(parent, $$9("div.action-container"));
		this.actionContainer.setAttribute("tabindex", "0");
		this.action = append$2(this.actionContainer, $$9("a.action"));
		this.action.setAttribute("role", "button");
		if (actionOptions.iconClass) append$2(this.action, $$9(`span.icon`)).classList.add(...actionOptions.iconClass.split(" "));
		this.actionRenderedLabel = keybindingLabel ? `${actionOptions.label} (${keybindingLabel})` : actionOptions.label;
		const label = append$2(this.action, $$9("span"));
		label.textContent = this.actionRenderedLabel;
		this._store.add(new ClickAction(this.actionContainer, actionOptions.run));
		this._store.add(new KeyDownAction(this.actionContainer, actionOptions.run, [3, 10]));
		this.setEnabled(true);
	}
	setEnabled(enabled) {
		if (enabled) {
			this.actionContainer.classList.remove("disabled");
			this.actionContainer.removeAttribute("aria-disabled");
		} else {
			this.actionContainer.classList.add("disabled");
			this.actionContainer.setAttribute("aria-disabled", "true");
		}
	}
};
function getHoverAccessibleViewHint(shouldHaveHint, keybinding) {
	return shouldHaveHint && keybinding ? localize(7, "Inspect this in the accessible view with {0}.", keybinding) : shouldHaveHint ? localize(8, "Inspect this in the accessible view via the command Open Accessible View which is currently not triggerable via keybinding.") : "";
}
var ClickAction = class extends Disposable {
	constructor(container, run) {
		super();
		this._register(addDisposableListener(container, EventType$1.CLICK, (e) => {
			e.stopPropagation();
			e.preventDefault();
			run(container);
		}));
	}
};
var KeyDownAction = class extends Disposable {
	constructor(container, run, keyCodes) {
		super();
		this._register(addDisposableListener(container, EventType$1.KEY_DOWN, (e) => {
			const event = new StandardKeyboardEvent(e);
			if (keyCodes.some((keyCode) => event.equals(keyCode))) {
				e.stopPropagation();
				e.preventDefault();
				run(container);
			}
		}));
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/naturalLanguage/korean.js
/**
* Gets alternative Korean characters for the character code. This will return the ascii
* character code(s) that a Hangul character may have been input with using a qwerty layout.
*
* This only aims to cover modern (not archaic) Hangul syllables.
*
* @param code The character code to get alternate characters for
*/
function getKoreanAltChars(code) {
	const result = disassembleKorean(code);
	if (result && result.length > 0) return new Uint32Array(result);
}
var codeBufferLength = 0;
var codeBuffer = /* @__PURE__ */ new Uint32Array(10);
function disassembleKorean(code) {
	codeBufferLength = 0;
	getCodesFromArray(code, modernConsonants, 4352);
	if (codeBufferLength > 0) return codeBuffer.subarray(0, codeBufferLength);
	getCodesFromArray(code, modernVowels, 4449);
	if (codeBufferLength > 0) return codeBuffer.subarray(0, codeBufferLength);
	getCodesFromArray(code, modernFinalConsonants, 4520);
	if (codeBufferLength > 0) return codeBuffer.subarray(0, codeBufferLength);
	getCodesFromArray(code, compatibilityJamo, 12593);
	if (codeBufferLength) return codeBuffer.subarray(0, codeBufferLength);
	if (code >= 44032 && code <= 55203) {
		const hangulIndex = code - 44032;
		const vowelAndFinalConsonantProduct = hangulIndex % 588;
		const initialConsonantIndex = Math.floor(hangulIndex / 588);
		const vowelIndex = Math.floor(vowelAndFinalConsonantProduct / 28);
		const finalConsonantIndex = vowelAndFinalConsonantProduct % 28 - 1;
		if (initialConsonantIndex < modernConsonants.length) getCodesFromArray(initialConsonantIndex, modernConsonants, 0);
		else if (4352 + initialConsonantIndex - 12593 < compatibilityJamo.length) getCodesFromArray(4352 + initialConsonantIndex, compatibilityJamo, 12593);
		if (vowelIndex < modernVowels.length) getCodesFromArray(vowelIndex, modernVowels, 0);
		else if (4449 + vowelIndex - 12593 < compatibilityJamo.length) getCodesFromArray(4449 + vowelIndex - 12593, compatibilityJamo, 12593);
		if (finalConsonantIndex >= 0) {
			if (finalConsonantIndex < modernFinalConsonants.length) getCodesFromArray(finalConsonantIndex, modernFinalConsonants, 0);
			else if (4520 + finalConsonantIndex - 12593 < compatibilityJamo.length) getCodesFromArray(4520 + finalConsonantIndex - 12593, compatibilityJamo, 12593);
		}
		if (codeBufferLength > 0) return codeBuffer.subarray(0, codeBufferLength);
	}
}
function getCodesFromArray(code, array, arrayStartIndex) {
	if (code >= arrayStartIndex && code < arrayStartIndex + array.length) addCodesToBuffer(array[code - arrayStartIndex]);
}
function addCodesToBuffer(codes) {
	if (codes === 0) return;
	codeBuffer[codeBufferLength++] = codes & 255;
	if (codes >> 8) codeBuffer[codeBufferLength++] = codes >> 8 & 255;
	if (codes >> 16) codeBuffer[codeBufferLength++] = codes >> 16 & 255;
}
/**
* Hangul Jamo - Modern consonants #1
*
* Range U+1100..U+1112
*
* |        | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | A | B | C | D | E | F |
* |--------|---|---|---|---|---|---|---|---|---|---|---|---|---|---|---|---|
* | U+110x | ᄀ | ᄁ | ᄂ | ᄃ | ᄄ | ᄅ | ᄆ | ᄇ | ᄈ | ᄉ | ᄊ | ᄋ | ᄌ | ᄍ | ᄎ | ᄏ |
* | U+111x | ᄐ | ᄑ | ᄒ |
*/
var modernConsonants = new Uint8Array([
	114,
	82,
	115,
	101,
	69,
	102,
	97,
	113,
	81,
	116,
	84,
	100,
	119,
	87,
	99,
	122,
	120,
	118,
	103
]);
/**
* Hangul Jamo - Modern Vowels
*
* Range U+1161..U+1175
*
* |        | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | A | B | C | D | E | F |
* |--------|---|---|---|---|---|---|---|---|---|---|---|---|---|---|---|---|
* | U+116x |   | ᅡ | ᅢ | ᅣ | ᅤ | ᅥ | ᅦ | ᅧ | ᅨ | ᅩ | ᅪ | ᅫ | ᅬ | ᅭ | ᅮ | ᅯ |
* | U+117x | ᅰ | ᅱ | ᅲ | ᅳ | ᅴ | ᅵ |
*/
var modernVowels = new Uint16Array([
	107,
	111,
	105,
	79,
	106,
	112,
	117,
	80,
	104,
	27496,
	28520,
	27752,
	121,
	110,
	27246,
	28782,
	27758,
	98,
	109,
	27757,
	108
]);
/**
* Hangul Jamo - Modern Consonants #2
*
* Range U+11A8..U+11C2
*
* |        | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | A | B | C | D | E | F |
* |--------|---|---|---|---|---|---|---|---|---|---|---|---|---|---|---|---|
* | U+11Ax |   |   |   |   |   |   |   |   | ᆨ | ᆩ | ᆪ | ᆫ | ᆬ | ᆭ | ᆮ | ᆯ |
* | U+11Bx | ᆰ | ᆱ | ᆲ | ᆳ | ᆴ | ᆵ | ᆶ | ᆷ | ᆸ | ᆹ | ᆺ | ᆻ | ᆼ | ᆽ | ᆾ | ᆿ |
* | U+11Cx | ᇀ | ᇁ | ᇂ |
*/
var modernFinalConsonants = new Uint16Array([
	114,
	82,
	29810,
	115,
	30579,
	26483,
	101,
	102,
	29286,
	24934,
	29030,
	29798,
	30822,
	30310,
	26470,
	97,
	113,
	29809,
	116,
	84,
	100,
	119,
	99,
	122,
	120,
	118,
	103
]);
/**
* Hangul Compatibility Jamo
*
* Range U+3131..U+318F
*
* This includes range includes archaic jamo which we don't consider, these are
* given the NUL character code in order to be ignored.
*
* |        | 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | A | B | C | D | E | F |
* |--------|---|---|---|---|---|---|---|---|---|---|---|---|---|---|---|---|
* | U+313x |   | ㄱ | ㄲ | ㄳ | ㄴ | ㄵ | ㄶ | ㄷ | ㄸ | ㄹ | ㄺ | ㄻ | ㄼ | ㄽ | ㄾ | ㄿ |
* | U+314x | ㅀ | ㅁ | ㅂ | ㅃ | ㅄ | ㅅ | ㅆ | ㅇ | ㅈ | ㅉ | ㅊ | ㅋ | ㅌ | ㅍ | ㅎ | ㅏ |
* | U+315x | ㅐ | ㅑ | ㅒ | ㅓ | ㅔ | ㅕ | ㅖ | ㅗ | ㅘ | ㅙ | ㅚ | ㅛ | ㅜ | ㅝ | ㅞ | ㅟ |
* | U+316x | ㅠ | ㅡ | ㅢ | ㅣ | HF | ㅥ | ㅦ | ㅧ | ㅨ | ㅩ | ㅪ | ㅫ | ㅬ | ㅭ | ㅮ | ㅯ |
* | U+317x | ㅰ | ㅱ | ㅲ | ㅳ | ㅴ | ㅵ | ㅶ | ㅷ | ㅸ | ㅹ | ㅺ | ㅻ | ㅼ | ㅽ | ㅾ | ㅿ |
* | U+318x | ㆀ | ㆁ | ㆂ | ㆃ | ㆄ | ㆅ | ㆆ | ㆇ | ㆈ | ㆉ | ㆊ | ㆋ | ㆌ | ㆍ | ㆎ |
*/
var compatibilityJamo = new Uint16Array([
	114,
	82,
	29810,
	115,
	30579,
	26483,
	101,
	69,
	102,
	29286,
	24934,
	29030,
	29798,
	30822,
	30310,
	26470,
	97,
	113,
	81,
	29809,
	116,
	84,
	100,
	119,
	87,
	99,
	122,
	120,
	118,
	103,
	107,
	111,
	105,
	79,
	106,
	112,
	117,
	80,
	104,
	27496,
	28520,
	27752,
	121,
	110,
	27246,
	28782,
	27758,
	98,
	109,
	27757,
	108
]);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/normalization.js
new LRUCache(1e4);
var nfdCache = new LRUCache(1e4);
function normalizeNFD(str) {
	return normalize(str, "NFD", nfdCache);
}
var nonAsciiCharactersPattern = /[^\u0000-\u0080]/;
function normalize(str, form, normalizedCache) {
	if (!str) return str;
	const cached = normalizedCache.get(str);
	if (cached) return cached;
	let res;
	if (nonAsciiCharactersPattern.test(str)) res = str.normalize(form);
	else res = str;
	normalizedCache.set(str, res);
	return res;
}
/**
* Attempts to normalize the string to Unicode base format (NFD -> remove accents -> lower case).
* When original string contains accent characters directly, only lower casing will be performed.
* This is done so as to keep the string length the same and not affect indices.
*
* @see https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript/37511463#37511463
*/
var tryNormalizeToBase = function() {
	const cache = new LRUCache(1e4);
	const accentsRegex = /[\u0300-\u036f]/g;
	return function(str) {
		const cached = cache.get(str);
		if (cached) return cached;
		const noAccents = normalizeNFD(str).replace(accentsRegex, "");
		const result = (noAccents.length === str.length ? noAccents : str).toLowerCase();
		cache.set(str, result);
		return result;
	};
}();
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/filters.js
/**
* @returns A filter which combines the provided set
* of filters with an or. The *first* filters that
* matches defined the return value of the returned
* filter.
*/
function or(...filter) {
	return function(word, wordToMatchAgainst) {
		for (let i = 0, len = filter.length; i < len; i++) {
			const match = filter[i](word, wordToMatchAgainst);
			if (match) return match;
		}
		return null;
	};
}
_matchesPrefix.bind(void 0, false);
var matchesPrefix = _matchesPrefix.bind(void 0, true);
function _matchesPrefix(ignoreCase, word, wordToMatchAgainst) {
	if (!wordToMatchAgainst || wordToMatchAgainst.length < word.length) return null;
	let matches;
	if (ignoreCase) matches = startsWithIgnoreCase(wordToMatchAgainst, word);
	else matches = wordToMatchAgainst.indexOf(word) === 0;
	if (!matches) return null;
	return word.length > 0 ? [{
		start: 0,
		end: word.length
	}] : [];
}
function matchesContiguousSubString(word, wordToMatchAgainst) {
	if (word.length > wordToMatchAgainst.length) return null;
	const index = wordToMatchAgainst.toLowerCase().indexOf(word.toLowerCase());
	if (index === -1) return null;
	return [{
		start: index,
		end: index + word.length
	}];
}
function matchesBaseContiguousSubString(word, wordToMatchAgainst) {
	if (word.length > wordToMatchAgainst.length) return null;
	word = tryNormalizeToBase(word);
	wordToMatchAgainst = tryNormalizeToBase(wordToMatchAgainst);
	const index = wordToMatchAgainst.indexOf(word);
	if (index === -1) return null;
	return [{
		start: index,
		end: index + word.length
	}];
}
function matchesSubString(word, wordToMatchAgainst) {
	if (word.length > wordToMatchAgainst.length) return null;
	return _matchesSubString(word.toLowerCase(), wordToMatchAgainst.toLowerCase(), 0, 0);
}
function _matchesSubString(word, wordToMatchAgainst, i, j) {
	if (i === word.length) return [];
	else if (j === wordToMatchAgainst.length) return null;
	else {
		if (word[i] === wordToMatchAgainst[j]) {
			let result = null;
			if (result = _matchesSubString(word, wordToMatchAgainst, i + 1, j + 1)) return join({
				start: j,
				end: j + 1
			}, result);
			return null;
		}
		return _matchesSubString(word, wordToMatchAgainst, i, j + 1);
	}
}
function isLower(code) {
	return 97 <= code && code <= 122;
}
function isUpper(code) {
	return 65 <= code && code <= 90;
}
function isNumber(code) {
	return 48 <= code && code <= 57;
}
function isWhitespace(code) {
	return code === 32 || code === 9 || code === 10 || code === 13;
}
var wordSeparators = /* @__PURE__ */ new Set();
"()[]{}<>`'\"-/;:,.?!".split("").forEach((s) => wordSeparators.add(s.charCodeAt(0)));
function isWordSeparator(code) {
	return isWhitespace(code) || wordSeparators.has(code);
}
function charactersMatch(codeA, codeB) {
	return codeA === codeB || isWordSeparator(codeA) && isWordSeparator(codeB);
}
var alternateCharsCache = /* @__PURE__ */ new Map();
/**
* Gets alternative codes to the character code passed in. This comes in the
* form of an array of character codes, all of which must match _in order_ to
* successfully match.
*
* @param code The character code to check.
*/
function getAlternateCodes(code) {
	if (alternateCharsCache.has(code)) return alternateCharsCache.get(code);
	let result;
	const codes = getKoreanAltChars(code);
	if (codes) result = codes;
	alternateCharsCache.set(code, result);
	return result;
}
function isAlphanumeric(code) {
	return isLower(code) || isUpper(code) || isNumber(code);
}
function join(head, tail) {
	if (tail.length === 0) tail = [head];
	else if (head.end === tail[0].start) tail[0].start = head.start;
	else tail.unshift(head);
	return tail;
}
function nextAnchor(camelCaseWord, start) {
	for (let i = start; i < camelCaseWord.length; i++) {
		const c = camelCaseWord.charCodeAt(i);
		if (isUpper(c) || isNumber(c) || i > 0 && !isAlphanumeric(camelCaseWord.charCodeAt(i - 1))) return i;
	}
	return camelCaseWord.length;
}
function _matchesCamelCase(word, camelCaseWord, i, j) {
	if (i === word.length) return [];
	else if (j === camelCaseWord.length) return null;
	else if (word[i] !== camelCaseWord[j].toLowerCase()) return null;
	else {
		let result = null;
		let nextUpperIndex = j + 1;
		result = _matchesCamelCase(word, camelCaseWord, i + 1, j + 1);
		while (!result && (nextUpperIndex = nextAnchor(camelCaseWord, nextUpperIndex)) < camelCaseWord.length) {
			result = _matchesCamelCase(word, camelCaseWord, i + 1, nextUpperIndex);
			nextUpperIndex++;
		}
		return result === null ? null : join({
			start: j,
			end: j + 1
		}, result);
	}
}
function analyzeCamelCaseWord(word) {
	let upper = 0, lower = 0, alpha = 0, numeric = 0, code = 0;
	for (let i = 0; i < word.length; i++) {
		code = word.charCodeAt(i);
		if (isUpper(code)) upper++;
		if (isLower(code)) lower++;
		if (isAlphanumeric(code)) alpha++;
		if (isNumber(code)) numeric++;
	}
	return {
		upperPercent: upper / word.length,
		lowerPercent: lower / word.length,
		alphaPercent: alpha / word.length,
		numericPercent: numeric / word.length
	};
}
function isUpperCaseWord(analysis) {
	const { upperPercent, lowerPercent } = analysis;
	return lowerPercent === 0 && upperPercent > .6;
}
function isCamelCaseWord(analysis) {
	const { upperPercent, lowerPercent, alphaPercent, numericPercent } = analysis;
	return lowerPercent > .2 && upperPercent < .8 && alphaPercent > .6 && numericPercent < .2;
}
function isCamelCasePattern(word) {
	let upper = 0, lower = 0, code = 0, whitespace = 0;
	for (let i = 0; i < word.length; i++) {
		code = word.charCodeAt(i);
		if (isUpper(code)) upper++;
		if (isLower(code)) lower++;
		if (isWhitespace(code)) whitespace++;
	}
	if ((upper === 0 || lower === 0) && whitespace === 0) return word.length <= 30;
	else return upper <= 5;
}
function matchesCamelCase(word, camelCaseWord) {
	if (!camelCaseWord) return null;
	camelCaseWord = camelCaseWord.trim();
	if (camelCaseWord.length === 0) return null;
	if (!isCamelCasePattern(word)) return null;
	if (camelCaseWord.length > 60) camelCaseWord = camelCaseWord.substring(0, 60);
	const analysis = analyzeCamelCaseWord(camelCaseWord);
	if (!isCamelCaseWord(analysis)) {
		if (!isUpperCaseWord(analysis)) return null;
		camelCaseWord = camelCaseWord.toLowerCase();
	}
	let result = null;
	let i = 0;
	word = word.toLowerCase();
	while (i < camelCaseWord.length && (result = _matchesCamelCase(word, camelCaseWord, 0, i)) === null) i = nextAnchor(camelCaseWord, i + 1);
	return result;
}
function matchesWords(word, target, contiguous = false) {
	if (!target || target.length === 0) return null;
	let result = null;
	let targetIndex = 0;
	word = tryNormalizeToBase(word);
	target = tryNormalizeToBase(target);
	const memo = /* @__PURE__ */ new Map();
	while (targetIndex < target.length) {
		result = _matchesWords(word, target, 0, targetIndex, contiguous, memo);
		if (result !== null) break;
		targetIndex = nextWord(target, targetIndex + 1);
	}
	return result;
}
function cloneMatches(matches) {
	if (matches === null) return null;
	const result = [];
	for (const m of matches) result.push({
		start: m.start,
		end: m.end
	});
	return result;
}
function _matchesWords(word, target, wordIndex, targetIndex, contiguous, memo) {
	if (wordIndex === word.length) return [];
	else if (targetIndex === target.length) return null;
	const memoKey = wordIndex * (target.length + 1) + targetIndex;
	const cached = memo.get(memoKey);
	if (cached !== void 0) return cloneMatches(cached);
	const computed = _matchesWordsCompute(word, target, wordIndex, targetIndex, contiguous, memo);
	memo.set(memoKey, cloneMatches(computed));
	return computed;
}
function _matchesWordsCompute(word, target, wordIndex, targetIndex, contiguous, memo) {
	let targetIndexOffset = 0;
	if (!charactersMatch(word.charCodeAt(wordIndex), target.charCodeAt(targetIndex))) {
		const altChars = getAlternateCodes(word.charCodeAt(wordIndex));
		if (!altChars) return null;
		for (let k = 0; k < altChars.length; k++) if (!charactersMatch(altChars[k], target.charCodeAt(targetIndex + k))) return null;
		targetIndexOffset += altChars.length - 1;
	}
	let result = null;
	let nextWordIndex = targetIndex + targetIndexOffset + 1;
	result = _matchesWords(word, target, wordIndex + 1, nextWordIndex, contiguous, memo);
	if (!contiguous) while (!result && (nextWordIndex = nextWord(target, nextWordIndex)) < target.length) {
		result = _matchesWords(word, target, wordIndex + 1, nextWordIndex, contiguous, memo);
		nextWordIndex++;
	}
	if (!result) return null;
	if (word.charCodeAt(wordIndex) !== target.charCodeAt(targetIndex)) {
		const altChars = getAlternateCodes(word.charCodeAt(wordIndex));
		if (!altChars) return result;
		for (let k = 0; k < altChars.length; k++) if (altChars[k] !== target.charCodeAt(targetIndex + k)) return result;
	}
	return join({
		start: targetIndex,
		end: targetIndex + targetIndexOffset + 1
	}, result);
}
function nextWord(word, start) {
	for (let i = start; i < word.length; i++) if (isWordSeparator(word.charCodeAt(i)) || i > 0 && isWordSeparator(word.charCodeAt(i - 1))) return i;
	return word.length;
}
var fuzzyContiguousFilter = or(matchesPrefix, matchesCamelCase, matchesContiguousSubString);
var fuzzySeparateFilter = or(matchesPrefix, matchesCamelCase, matchesSubString);
var fuzzyRegExpCache = new LRUCache(1e4);
function matchesFuzzy(word, wordToMatchAgainst, enableSeparateSubstringMatching = false) {
	if (typeof word !== "string" || typeof wordToMatchAgainst !== "string") return null;
	let regexp = fuzzyRegExpCache.get(word);
	if (!regexp) {
		regexp = new RegExp(convertSimple2RegExpPattern(word), "i");
		fuzzyRegExpCache.set(word, regexp);
	}
	const match = regexp.exec(wordToMatchAgainst);
	if (match) return [{
		start: match.index,
		end: match.index + match[0].length
	}];
	return enableSeparateSubstringMatching ? fuzzySeparateFilter(word, wordToMatchAgainst) : fuzzyContiguousFilter(word, wordToMatchAgainst);
}
/**
* Match pattern against word in a fuzzy way. As in IntelliSense and faster and more
* powerful than `matchesFuzzy`
*/
function matchesFuzzy2(pattern, word) {
	const score = fuzzyScore(pattern, pattern.toLowerCase(), 0, word, word.toLowerCase(), 0, {
		firstMatchCanBeWeak: true,
		boostFullMatch: true
	});
	return score ? createMatches(score) : null;
}
function anyScore(pattern, lowPattern, patternPos, word, lowWord, wordPos) {
	const max = Math.min(13, pattern.length);
	for (; patternPos < max; patternPos++) {
		const result = fuzzyScore(pattern, lowPattern, patternPos, word, lowWord, wordPos, {
			firstMatchCanBeWeak: true,
			boostFullMatch: true
		});
		if (result) return result;
	}
	return [0, wordPos];
}
function createMatches(score) {
	if (typeof score === "undefined") return [];
	const res = [];
	const wordPos = score[1];
	for (let i = score.length - 1; i > 1; i--) {
		const pos = score[i] + wordPos;
		const last = res[res.length - 1];
		if (last && last.end === pos) last.end = pos + 1;
		else res.push({
			start: pos,
			end: pos + 1
		});
	}
	return res;
}
var _maxLen = 128;
function initTable() {
	const table = [];
	const row = [];
	for (let i = 0; i <= _maxLen; i++) row[i] = 0;
	for (let i = 0; i <= _maxLen; i++) table.push(row.slice(0));
	return table;
}
function initArr(maxLen) {
	const row = [];
	for (let i = 0; i <= maxLen; i++) row[i] = 0;
	return row;
}
var _minWordMatchPos = initArr(256);
var _maxWordMatchPos = initArr(256);
var _diag = initTable();
var _table = initTable();
var _arrows = initTable();
function isSeparatorAtPos(value, index) {
	if (index < 0 || index >= value.length) return false;
	const code = value.codePointAt(index);
	switch (code) {
		case 95:
		case 45:
		case 46:
		case 32:
		case 47:
		case 92:
		case 39:
		case 34:
		case 58:
		case 36:
		case 60:
		case 62:
		case 40:
		case 41:
		case 91:
		case 93:
		case 123:
		case 125: return true;
		case void 0: return false;
		default:
			if (isEmojiImprecise(code)) return true;
			return false;
	}
}
function isWhitespaceAtPos(value, index) {
	if (index < 0 || index >= value.length) return false;
	switch (value.charCodeAt(index)) {
		case 32:
		case 9: return true;
		default: return false;
	}
}
function isUpperCaseAtPos(pos, word, wordLow) {
	return word[pos] !== wordLow[pos];
}
function isPatternInWord(patternLow, patternPos, patternLen, wordLow, wordPos, wordLen, fillMinWordPosArr = false) {
	while (patternPos < patternLen && wordPos < wordLen) {
		if (patternLow[patternPos] === wordLow[wordPos]) {
			if (fillMinWordPosArr) _minWordMatchPos[patternPos] = wordPos;
			patternPos += 1;
		}
		wordPos += 1;
	}
	return patternPos === patternLen;
}
var FuzzyScore;
(function(FuzzyScore) {
	/**
	* No matches and value `-100`
	*/
	FuzzyScore.Default = [-100, 0];
	function isDefault(score) {
		return !score || score.length === 2 && score[0] === -100 && score[1] === 0;
	}
	FuzzyScore.isDefault = isDefault;
})(FuzzyScore || (FuzzyScore = {}));
var FuzzyScoreOptions = class {
	static {
		this.default = {
			boostFullMatch: true,
			firstMatchCanBeWeak: false
		};
	}
	constructor(firstMatchCanBeWeak, boostFullMatch) {
		this.firstMatchCanBeWeak = firstMatchCanBeWeak;
		this.boostFullMatch = boostFullMatch;
	}
};
function fuzzyScore(pattern, patternLow, patternStart, word, wordLow, wordStart, options = FuzzyScoreOptions.default) {
	const patternLen = pattern.length > _maxLen ? _maxLen : pattern.length;
	const wordLen = word.length > _maxLen ? _maxLen : word.length;
	if (patternStart >= patternLen || wordStart >= wordLen || patternLen - patternStart > wordLen - wordStart) return;
	if (!isPatternInWord(patternLow, patternStart, patternLen, wordLow, wordStart, wordLen, true)) return;
	_fillInMaxWordMatchPos(patternLen, wordLen, patternStart, wordStart, patternLow, wordLow);
	let row = 1;
	let column = 1;
	let patternPos = patternStart;
	let wordPos = wordStart;
	const hasStrongFirstMatch = [false];
	for (row = 1, patternPos = patternStart; patternPos < patternLen; row++, patternPos++) {
		const minWordMatchPos = _minWordMatchPos[patternPos];
		const maxWordMatchPos = _maxWordMatchPos[patternPos];
		const nextMaxWordMatchPos = patternPos + 1 < patternLen ? _maxWordMatchPos[patternPos + 1] : wordLen;
		for (column = minWordMatchPos - wordStart + 1, wordPos = minWordMatchPos; wordPos < nextMaxWordMatchPos; column++, wordPos++) {
			let score = Number.MIN_SAFE_INTEGER;
			let canComeDiag = false;
			if (wordPos <= maxWordMatchPos) score = _doScore(pattern, patternLow, patternPos, patternStart, word, wordLow, wordPos, wordLen, wordStart, _diag[row - 1][column - 1] === 0, hasStrongFirstMatch);
			let diagScore = 0;
			if (score !== Number.MIN_SAFE_INTEGER) {
				canComeDiag = true;
				diagScore = score + _table[row - 1][column - 1];
			}
			const canComeLeft = wordPos > minWordMatchPos;
			const leftScore = canComeLeft ? _table[row][column - 1] + (_diag[row][column - 1] > 0 ? -5 : 0) : 0;
			const canComeLeftLeft = wordPos > minWordMatchPos + 1 && _diag[row][column - 1] > 0;
			const leftLeftScore = canComeLeftLeft ? _table[row][column - 2] + (_diag[row][column - 2] > 0 ? -5 : 0) : 0;
			if (canComeLeftLeft && (!canComeLeft || leftLeftScore >= leftScore) && (!canComeDiag || leftLeftScore >= diagScore)) {
				_table[row][column] = leftLeftScore;
				_arrows[row][column] = 3;
				_diag[row][column] = 0;
			} else if (canComeLeft && (!canComeDiag || leftScore >= diagScore)) {
				_table[row][column] = leftScore;
				_arrows[row][column] = 2;
				_diag[row][column] = 0;
			} else if (canComeDiag) {
				_table[row][column] = diagScore;
				_arrows[row][column] = 1;
				_diag[row][column] = _diag[row - 1][column - 1] + 1;
			} else throw new Error(`not possible`);
		}
	}
	if (!hasStrongFirstMatch[0] && !options.firstMatchCanBeWeak) return;
	row--;
	column--;
	const result = [_table[row][column], wordStart];
	let backwardsDiagLength = 0;
	let maxMatchColumn = 0;
	while (row >= 1) {
		let diagColumn = column;
		do {
			const arrow = _arrows[row][diagColumn];
			if (arrow === 3) diagColumn = diagColumn - 2;
			else if (arrow === 2) diagColumn = diagColumn - 1;
			else break;
		} while (diagColumn >= 1);
		if (backwardsDiagLength > 1 && patternLow[patternStart + row - 1] === wordLow[wordStart + column - 1] && !isUpperCaseAtPos(diagColumn + wordStart - 1, word, wordLow) && backwardsDiagLength + 1 > _diag[row][diagColumn]) diagColumn = column;
		if (diagColumn === column) backwardsDiagLength++;
		else backwardsDiagLength = 1;
		if (!maxMatchColumn) maxMatchColumn = diagColumn;
		row--;
		column = diagColumn - 1;
		result.push(column);
	}
	if (wordLen - wordStart === patternLen && options.boostFullMatch) result[0] += 2;
	const skippedCharsCount = maxMatchColumn - patternLen;
	result[0] -= skippedCharsCount;
	return result;
}
function _fillInMaxWordMatchPos(patternLen, wordLen, patternStart, wordStart, patternLow, wordLow) {
	let patternPos = patternLen - 1;
	let wordPos = wordLen - 1;
	while (patternPos >= patternStart && wordPos >= wordStart) {
		if (patternLow[patternPos] === wordLow[wordPos]) {
			_maxWordMatchPos[patternPos] = wordPos;
			patternPos--;
		}
		wordPos--;
	}
}
function _doScore(pattern, patternLow, patternPos, patternStart, word, wordLow, wordPos, wordLen, wordStart, newMatchStart, outFirstMatchStrong) {
	if (patternLow[patternPos] !== wordLow[wordPos]) return Number.MIN_SAFE_INTEGER;
	let score = 1;
	let isGapLocation = false;
	if (wordPos === patternPos - patternStart) score = pattern[patternPos] === word[wordPos] ? 7 : 5;
	else if (isUpperCaseAtPos(wordPos, word, wordLow) && (wordPos === 0 || !isUpperCaseAtPos(wordPos - 1, word, wordLow))) {
		score = pattern[patternPos] === word[wordPos] ? 7 : 5;
		isGapLocation = true;
	} else if (isSeparatorAtPos(wordLow, wordPos) && (wordPos === 0 || !isSeparatorAtPos(wordLow, wordPos - 1))) score = 5;
	else if (isSeparatorAtPos(wordLow, wordPos - 1) || isWhitespaceAtPos(wordLow, wordPos - 1)) {
		score = 5;
		isGapLocation = true;
	}
	if (score > 1 && patternPos === patternStart) outFirstMatchStrong[0] = true;
	if (!isGapLocation) isGapLocation = isUpperCaseAtPos(wordPos, word, wordLow) || isSeparatorAtPos(wordLow, wordPos - 1) || isWhitespaceAtPos(wordLow, wordPos - 1);
	if (patternPos === patternStart) {
		if (wordPos > wordStart) score -= isGapLocation ? 3 : 5;
	} else if (newMatchStart) score += isGapLocation ? 2 : 0;
	else score += isGapLocation ? 0 : 1;
	if (wordPos + 1 === wordLen) score -= isGapLocation ? 3 : 5;
	return score;
}
function fuzzyScoreGracefulAggressive(pattern, lowPattern, patternPos, word, lowWord, wordPos, options) {
	return fuzzyScoreWithPermutations(pattern, lowPattern, patternPos, word, lowWord, wordPos, true, options);
}
function fuzzyScoreWithPermutations(pattern, lowPattern, patternPos, word, lowWord, wordPos, aggressive, options) {
	let top = fuzzyScore(pattern, lowPattern, patternPos, word, lowWord, wordPos, options);
	if (pattern.length >= 3) {
		const tries = Math.min(7, pattern.length - 1);
		for (let movingPatternPos = patternPos + 1; movingPatternPos < tries; movingPatternPos++) {
			const newPattern = nextTypoPermutation(pattern, movingPatternPos);
			if (newPattern) {
				const candidate = fuzzyScore(newPattern, newPattern.toLowerCase(), patternPos, word, lowWord, wordPos, options);
				if (candidate) {
					candidate[0] -= 3;
					if (!top || candidate[0] > top[0]) top = candidate;
				}
			}
		}
	}
	return top;
}
function nextTypoPermutation(pattern, patternPos) {
	if (patternPos + 1 >= pattern.length) return;
	const swap1 = pattern[patternPos];
	const swap2 = pattern[patternPos + 1];
	if (swap1 === swap2) return;
	return pattern.slice(0, patternPos) + swap2 + swap1 + pattern.slice(patternPos + 2);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/iconLabels.js
var iconStartMarker = "$(";
var iconsRegex = new RegExp(`\\$\\(${ThemeIcon.iconNameExpression}(?:${ThemeIcon.iconModifierExpression})?\\)`, "g");
var escapeIconsRegex = new RegExp(`(\\\\)?${iconsRegex.source}`, "g");
function escapeIcons(text) {
	return text.replace(escapeIconsRegex, (match, escaped) => escaped ? match : `\\${match}`);
}
var markdownEscapedIconsRegex = new RegExp(`\\\\${iconsRegex.source}`, "g");
function markdownEscapeEscapedIcons(text) {
	return text.replace(markdownEscapedIconsRegex, (match) => `\\${match}`);
}
var stripIconsRegex = new RegExp(`(\\s)?(\\\\)?${iconsRegex.source}(\\s)?`, "g");
/**
* Takes a label with icons (`$(iconId)xyz`)  and strips the icons out (`xyz`)
*/
function stripIcons(text) {
	if (text.indexOf(iconStartMarker) === -1) return text;
	return text.replace(stripIconsRegex, (match, preWhitespace, escaped, postWhitespace) => escaped ? match : preWhitespace || postWhitespace || "");
}
/**
* Takes a label with icons (`$(iconId)xyz`), removes the icon syntax adds whitespace so that screen readers can read the text better.
*/
function getCodiconAriaLabel(text) {
	if (!text) return "";
	return text.replace(/\$\((.*?)\)/g, (_match, codiconName) => ` ${codiconName} `).trim();
}
var _parseIconsRegex = new RegExp(`\\$\\(${ThemeIcon.iconNameCharacter}+\\)`, "g");
/**
* Takes a label with icons (`abc $(iconId)xyz`) and returns the text (`abc xyz`) and the offsets of the icons (`[3]`)
*/
function parseLabelWithIcons(input) {
	_parseIconsRegex.lastIndex = 0;
	let text = "";
	const iconOffsets = [];
	let iconsOffset = 0;
	while (true) {
		const pos = _parseIconsRegex.lastIndex;
		const match = _parseIconsRegex.exec(input);
		const chars = input.substring(pos, match?.index);
		if (chars.length > 0) {
			text += chars;
			for (let i = 0; i < chars.length; i++) iconOffsets.push(iconsOffset);
		}
		if (!match) break;
		iconsOffset += match[0].length;
	}
	return {
		text,
		iconOffsets
	};
}
function matchesFuzzyIconAware(query, target, enableSeparateSubstringMatching = false) {
	const { text, iconOffsets } = target;
	if (!iconOffsets || iconOffsets.length === 0) return matchesFuzzy(query, text, enableSeparateSubstringMatching);
	const wordToMatchAgainstWithoutIconsTrimmed = ltrim(text, " ");
	const leadingWhitespaceOffset = text.length - wordToMatchAgainstWithoutIconsTrimmed.length;
	const matches = matchesFuzzy(query, wordToMatchAgainstWithoutIconsTrimmed, enableSeparateSubstringMatching);
	if (matches) for (const match of matches) {
		const iconOffset = iconOffsets[match.start + leadingWhitespaceOffset] + leadingWhitespaceOffset;
		match.start += iconOffset;
		match.end += iconOffset;
	}
	return matches;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/htmlContent.js
var MarkdownString = class {
	constructor(value = "", isTrustedOrOptions = false) {
		this.value = value;
		if (typeof this.value !== "string") throw illegalArgument("value");
		if (typeof isTrustedOrOptions === "boolean") {
			this.isTrusted = isTrustedOrOptions;
			this.supportThemeIcons = false;
			this.supportHtml = false;
			this.supportAlertSyntax = false;
		} else {
			this.isTrusted = isTrustedOrOptions.isTrusted ?? void 0;
			this.supportThemeIcons = isTrustedOrOptions.supportThemeIcons ?? false;
			this.supportHtml = isTrustedOrOptions.supportHtml ?? false;
			this.supportAlertSyntax = isTrustedOrOptions.supportAlertSyntax ?? false;
		}
	}
	appendText(value, newlineStyle = 0) {
		this.value += escapeMarkdownSyntaxTokens(this.supportThemeIcons ? escapeIcons(value) : value).replace(/([ \t]+)/g, (_match, g1) => "&nbsp;".repeat(g1.length)).replace(/\>/gm, "\\>").replace(/\n/g, newlineStyle === 1 ? "\\\n" : "\n\n");
		return this;
	}
	appendMarkdown(value) {
		this.value += value;
		return this;
	}
	appendCodeblock(langId, code) {
		this.value += `\n${appendEscapedMarkdownCodeBlockFence(code, langId)}\n`;
		return this;
	}
	appendLink(target, label, title) {
		this.value += "[";
		this.value += this._escape(label, "]");
		this.value += "](";
		this.value += this._escape(String(target), ")");
		if (title) this.value += ` "${this._escape(this._escape(title, "\""), ")")}"`;
		this.value += ")";
		return this;
	}
	_escape(value, ch) {
		const r = new RegExp(escapeRegExpCharacters(ch), "g");
		return value.replace(r, (match, offset) => {
			if (value.charAt(offset - 1) !== "\\") return `\\${match}`;
			else return match;
		});
	}
};
function isEmptyMarkdownString(oneOrMany) {
	if (isMarkdownString(oneOrMany)) return !oneOrMany.value;
	else if (Array.isArray(oneOrMany)) return oneOrMany.every(isEmptyMarkdownString);
	else return true;
}
function isMarkdownString(thing) {
	if (thing instanceof MarkdownString) return true;
	else if (thing && typeof thing === "object") return typeof thing.value === "string" && (typeof thing.isTrusted === "boolean" || typeof thing.isTrusted === "object" || thing.isTrusted === void 0) && (typeof thing.supportThemeIcons === "boolean" || thing.supportThemeIcons === void 0) && (typeof thing.supportAlertSyntax === "boolean" || thing.supportAlertSyntax === void 0);
	return false;
}
function markdownStringEqual(a, b) {
	if (a === b) return true;
	else if (!a || !b) return false;
	else return a.value === b.value && a.isTrusted === b.isTrusted && a.supportThemeIcons === b.supportThemeIcons && a.supportHtml === b.supportHtml && a.supportAlertSyntax === b.supportAlertSyntax && (a.baseUri === b.baseUri || !!a.baseUri && !!b.baseUri && isEqual(URI.from(a.baseUri), URI.from(b.baseUri)));
}
function escapeMarkdownSyntaxTokens(text) {
	return text.replace(/[\\`*_{}[\]()#+!~]/g, "\\$&").replace(/^([ \t]*)-/gm, "$1\\-");
}
/**
* @see https://github.com/microsoft/vscode/issues/193746
*/
function appendEscapedMarkdownCodeBlockFence(code, langId) {
	const longestFenceLength = code.match(/^`+/gm)?.reduce((a, b) => a.length > b.length ? a : b).length ?? 0;
	const desiredFenceLength = longestFenceLength >= 3 ? longestFenceLength + 1 : 3;
	return [
		`${"`".repeat(desiredFenceLength)}${langId}`,
		code,
		`${"`".repeat(desiredFenceLength)}`
	].join("\n");
}
function escapeDoubleQuotes(input) {
	return input.replace(/"/g, "&quot;");
}
function removeMarkdownEscapes(text) {
	if (!text) return text;
	return text.replace(/\\([\\`*_{}[\]()#+\-.!~])/g, "$1");
}
function parseHrefAndDimensions(href) {
	const dimensions = [];
	const splitted = href.split("|").map((s) => s.trim());
	href = splitted[0];
	const parameters = splitted[1];
	if (parameters) {
		const heightFromParams = /height=(\d+)/.exec(parameters);
		const widthFromParams = /width=(\d+)/.exec(parameters);
		const height = heightFromParams ? heightFromParams[1] : "";
		const width = widthFromParams ? widthFromParams[1] : "";
		const widthIsFinite = isFinite(parseInt(width));
		const heightIsFinite = isFinite(parseInt(height));
		if (widthIsFinite) dimensions.push(`width="${width}"`);
		if (heightIsFinite) dimensions.push(`height="${height}"`);
	}
	return {
		href,
		dimensions
	};
}
function createCommandUri(commandId, ...commandArgs) {
	return URI.from({
		scheme: Schemas.command,
		path: commandId,
		query: commandArgs.length ? encodeURIComponent(JSON.stringify(commandArgs)) : void 0
	});
}
/**
* VS Code addresses some content with placeholder `http` URLs whose authority is wrapped in
* underscores, such as `http://_vscodecontentref_/0`. Underscores are illegal in hostnames, so
* no real site collides with this shape.
*/
var placeholderAuthority = /^https?:\/\/_[^/?#]*_(?:[/?#]|$)/i;
/** Whether a target still resolves once content is copied into another application. */
function isPortableLinkTarget(target) {
	const trimmed = target.trim();
	return matchesSomeScheme(trimmed, Schemas.http, Schemas.https, Schemas.mailto) && !placeholderAuthority.test(trimmed);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/idGenerator.js
var IdGenerator = class {
	constructor(prefix) {
		this._prefix = prefix;
		this._lastId = 0;
	}
	nextId() {
		return this._prefix + ++this._lastId;
	}
};
var defaultGenerator = new IdGenerator("id#");
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/marked/marked.js
/**
* marked v14.0.0 - a markdown parser
* Copyright (c) 2011-2024, Christopher Jeffrey. (MIT Licensed)
* https://github.com/markedjs/marked
*/
/**
* DO NOT EDIT THIS FILE
* The code in this file is generated from files in ./src/
*/
/**
* Gets the original marked default options.
*/
function _getDefaults() {
	return {
		async: false,
		breaks: false,
		extensions: null,
		gfm: true,
		hooks: null,
		pedantic: false,
		renderer: null,
		silent: false,
		tokenizer: null,
		walkTokens: null
	};
}
var _defaults = _getDefaults();
function changeDefaults(newDefaults) {
	_defaults = newDefaults;
}
/**
* Helpers
*/
var escapeTest = /[&<>"']/;
var escapeReplace = new RegExp(escapeTest.source, "g");
var escapeTestNoEncode = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/;
var escapeReplaceNoEncode = new RegExp(escapeTestNoEncode.source, "g");
var escapeReplacements = {
	"&": "&amp;",
	"<": "&lt;",
	">": "&gt;",
	"\"": "&quot;",
	"'": "&#39;"
};
var getEscapeReplacement = (ch) => escapeReplacements[ch];
function escape$1(html, encode) {
	if (encode) {
		if (escapeTest.test(html)) return html.replace(escapeReplace, getEscapeReplacement);
	} else if (escapeTestNoEncode.test(html)) return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
	return html;
}
var caret = /(^|[^\[])\^/g;
function edit(regex, opt) {
	let source = typeof regex === "string" ? regex : regex.source;
	opt = opt || "";
	const obj = {
		replace: (name, val) => {
			let valSource = typeof val === "string" ? val : val.source;
			valSource = valSource.replace(caret, "$1");
			source = source.replace(name, valSource);
			return obj;
		},
		getRegex: () => {
			return new RegExp(source, opt);
		}
	};
	return obj;
}
function cleanUrl(href) {
	try {
		href = encodeURI(href).replace(/%25/g, "%");
	} catch {
		return null;
	}
	return href;
}
var noopTest = { exec: () => null };
function splitCells(tableRow, count) {
	const cells = tableRow.replace(/\|/g, (match, offset, str) => {
		let escaped = false;
		let curr = offset;
		while (--curr >= 0 && str[curr] === "\\") escaped = !escaped;
		if (escaped) return "|";
		else return " |";
	}).split(/ \|/);
	let i = 0;
	if (!cells[0].trim()) cells.shift();
	if (cells.length > 0 && !cells[cells.length - 1].trim()) cells.pop();
	if (count) {
		if (cells.length > count) cells.splice(count);
		else while (cells.length < count) cells.push("");
	}
	for (; i < cells.length; i++) cells[i] = cells[i].trim().replace(/\\\|/g, "|");
	return cells;
}
/**
* Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
* /c*$/ is vulnerable to REDOS.
*
* @param str
* @param c
* @param invert Remove suffix of non-c chars instead. Default falsey.
*/
function rtrim(str, c, invert) {
	const l = str.length;
	if (l === 0) return "";
	let suffLen = 0;
	while (suffLen < l) if (str.charAt(l - suffLen - 1) === c && true) suffLen++;
	else break;
	return str.slice(0, l - suffLen);
}
function findClosingBracket(str, b) {
	if (str.indexOf(b[1]) === -1) return -1;
	let level = 0;
	for (let i = 0; i < str.length; i++) if (str[i] === "\\") i++;
	else if (str[i] === b[0]) level++;
	else if (str[i] === b[1]) {
		level--;
		if (level < 0) return i;
	}
	return -1;
}
function outputLink(cap, link, raw, lexer) {
	const href = link.href;
	const title = link.title ? escape$1(link.title) : null;
	const text = cap[1].replace(/\\([\[\]])/g, "$1");
	if (cap[0].charAt(0) !== "!") {
		lexer.state.inLink = true;
		const token = {
			type: "link",
			raw,
			href,
			title,
			text,
			tokens: lexer.inlineTokens(text)
		};
		lexer.state.inLink = false;
		return token;
	}
	return {
		type: "image",
		raw,
		href,
		title,
		text: escape$1(text)
	};
}
function indentCodeCompensation(raw, text) {
	const matchIndentToCode = raw.match(/^(\s+)(?:```)/);
	if (matchIndentToCode === null) return text;
	const indentToCode = matchIndentToCode[1];
	return text.split("\n").map((node) => {
		const matchIndentInNode = node.match(/^\s+/);
		if (matchIndentInNode === null) return node;
		const [indentInNode] = matchIndentInNode;
		if (indentInNode.length >= indentToCode.length) return node.slice(indentToCode.length);
		return node;
	}).join("\n");
}
/**
* Tokenizer
*/
var _Tokenizer = class {
	options;
	rules;
	lexer;
	constructor(options) {
		this.options = options || _defaults;
	}
	space(src) {
		const cap = this.rules.block.newline.exec(src);
		if (cap && cap[0].length > 0) return {
			type: "space",
			raw: cap[0]
		};
	}
	code(src) {
		const cap = this.rules.block.code.exec(src);
		if (cap) {
			const text = cap[0].replace(/^ {1,4}/gm, "");
			return {
				type: "code",
				raw: cap[0],
				codeBlockStyle: "indented",
				text: !this.options.pedantic ? rtrim(text, "\n") : text
			};
		}
	}
	fences(src) {
		const cap = this.rules.block.fences.exec(src);
		if (cap) {
			const raw = cap[0];
			const text = indentCodeCompensation(raw, cap[3] || "");
			return {
				type: "code",
				raw,
				lang: cap[2] ? cap[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : cap[2],
				text
			};
		}
	}
	heading(src) {
		const cap = this.rules.block.heading.exec(src);
		if (cap) {
			let text = cap[2].trim();
			if (/#$/.test(text)) {
				const trimmed = rtrim(text, "#");
				if (this.options.pedantic) text = trimmed.trim();
				else if (!trimmed || / $/.test(trimmed)) text = trimmed.trim();
			}
			return {
				type: "heading",
				raw: cap[0],
				depth: cap[1].length,
				text,
				tokens: this.lexer.inline(text)
			};
		}
	}
	hr(src) {
		const cap = this.rules.block.hr.exec(src);
		if (cap) return {
			type: "hr",
			raw: rtrim(cap[0], "\n")
		};
	}
	blockquote(src) {
		const cap = this.rules.block.blockquote.exec(src);
		if (cap) {
			let lines = rtrim(cap[0], "\n").split("\n");
			let raw = "";
			let text = "";
			const tokens = [];
			while (lines.length > 0) {
				let inBlockquote = false;
				const currentLines = [];
				let i = 0;
				for (; i < lines.length; i++) if (/^ {0,3}>/.test(lines[i])) {
					currentLines.push(lines[i]);
					inBlockquote = true;
				} else if (!inBlockquote) currentLines.push(lines[i]);
				else break;
				lines = lines.slice(i);
				const currentRaw = currentLines.join("\n");
				const currentText = currentRaw.replace(/\n {0,3}((?:=+|-+) *)(?=\n|$)/g, "\n    $1").replace(/^ {0,3}>[ \t]?/gm, "");
				raw = raw ? `${raw}\n${currentRaw}` : currentRaw;
				text = text ? `${text}\n${currentText}` : currentText;
				const top = this.lexer.state.top;
				this.lexer.state.top = true;
				this.lexer.blockTokens(currentText, tokens, true);
				this.lexer.state.top = top;
				if (lines.length === 0) break;
				const lastToken = tokens[tokens.length - 1];
				if (lastToken?.type === "code") break;
				else if (lastToken?.type === "blockquote") {
					const oldToken = lastToken;
					const newText = oldToken.raw + "\n" + lines.join("\n");
					const newToken = this.blockquote(newText);
					tokens[tokens.length - 1] = newToken;
					raw = raw.substring(0, raw.length - oldToken.raw.length) + newToken.raw;
					text = text.substring(0, text.length - oldToken.text.length) + newToken.text;
					break;
				} else if (lastToken?.type === "list") {
					const oldToken = lastToken;
					const newText = oldToken.raw + "\n" + lines.join("\n");
					const newToken = this.list(newText);
					tokens[tokens.length - 1] = newToken;
					raw = raw.substring(0, raw.length - lastToken.raw.length) + newToken.raw;
					text = text.substring(0, text.length - oldToken.raw.length) + newToken.raw;
					lines = newText.substring(tokens[tokens.length - 1].raw.length).split("\n");
					continue;
				}
			}
			return {
				type: "blockquote",
				raw,
				tokens,
				text
			};
		}
	}
	list(src) {
		let cap = this.rules.block.list.exec(src);
		if (cap) {
			let bull = cap[1].trim();
			const isordered = bull.length > 1;
			const list = {
				type: "list",
				raw: "",
				ordered: isordered,
				start: isordered ? +bull.slice(0, -1) : "",
				loose: false,
				items: []
			};
			bull = isordered ? `\\d{1,9}\\${bull.slice(-1)}` : `\\${bull}`;
			if (this.options.pedantic) bull = isordered ? bull : "[*+-]";
			const itemRegex = new RegExp(`^( {0,3}${bull})((?:[\t ][^\\n]*)?(?:\\n|$))`);
			let endsWithBlankLine = false;
			while (src) {
				let endEarly = false;
				let raw = "";
				let itemContents = "";
				if (!(cap = itemRegex.exec(src))) break;
				if (this.rules.block.hr.test(src)) break;
				raw = cap[0];
				src = src.substring(raw.length);
				let line = cap[2].split("\n", 1)[0].replace(/^\t+/, (t) => " ".repeat(3 * t.length));
				let nextLine = src.split("\n", 1)[0];
				let blankLine = !line.trim();
				let indent = 0;
				if (this.options.pedantic) {
					indent = 2;
					itemContents = line.trimStart();
				} else if (blankLine) indent = cap[1].length + 1;
				else {
					indent = cap[2].search(/[^ ]/);
					indent = indent > 4 ? 1 : indent;
					itemContents = line.slice(indent);
					indent += cap[1].length;
				}
				if (blankLine && /^ *$/.test(nextLine)) {
					raw += nextLine + "\n";
					src = src.substring(nextLine.length + 1);
					endEarly = true;
				}
				if (!endEarly) {
					const nextBulletRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ \t][^\\n]*)?(?:\\n|$))`);
					const hrRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`);
					const fencesBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:\`\`\`|~~~)`);
					const headingBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}#`);
					while (src) {
						const rawLine = src.split("\n", 1)[0];
						nextLine = rawLine;
						if (this.options.pedantic) nextLine = nextLine.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ");
						if (fencesBeginRegex.test(nextLine)) break;
						if (headingBeginRegex.test(nextLine)) break;
						if (nextBulletRegex.test(nextLine)) break;
						if (hrRegex.test(src)) break;
						if (nextLine.search(/[^ ]/) >= indent || !nextLine.trim()) itemContents += "\n" + nextLine.slice(indent);
						else {
							if (blankLine) break;
							if (line.search(/[^ ]/) >= 4) break;
							if (fencesBeginRegex.test(line)) break;
							if (headingBeginRegex.test(line)) break;
							if (hrRegex.test(line)) break;
							itemContents += "\n" + nextLine;
						}
						if (!blankLine && !nextLine.trim()) blankLine = true;
						raw += rawLine + "\n";
						src = src.substring(rawLine.length + 1);
						line = nextLine.slice(indent);
					}
				}
				if (!list.loose) {
					if (endsWithBlankLine) list.loose = true;
					else if (/\n *\n *$/.test(raw)) endsWithBlankLine = true;
				}
				let istask = null;
				let ischecked;
				if (this.options.gfm) {
					istask = /^\[[ xX]\] /.exec(itemContents);
					if (istask) {
						ischecked = istask[0] !== "[ ] ";
						itemContents = itemContents.replace(/^\[[ xX]\] +/, "");
					}
				}
				list.items.push({
					type: "list_item",
					raw,
					task: !!istask,
					checked: ischecked,
					loose: false,
					text: itemContents,
					tokens: []
				});
				list.raw += raw;
			}
			list.items[list.items.length - 1].raw = list.items[list.items.length - 1].raw.trimEnd();
			list.items[list.items.length - 1].text = list.items[list.items.length - 1].text.trimEnd();
			list.raw = list.raw.trimEnd();
			for (let i = 0; i < list.items.length; i++) {
				this.lexer.state.top = false;
				list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);
				if (!list.loose) {
					const spacers = list.items[i].tokens.filter((t) => t.type === "space");
					list.loose = spacers.length > 0 && spacers.some((t) => /\n.*\n/.test(t.raw));
				}
			}
			if (list.loose) for (let i = 0; i < list.items.length; i++) list.items[i].loose = true;
			return list;
		}
	}
	html(src) {
		const cap = this.rules.block.html.exec(src);
		if (cap) return {
			type: "html",
			block: true,
			raw: cap[0],
			pre: cap[1] === "pre" || cap[1] === "script" || cap[1] === "style",
			text: cap[0]
		};
	}
	def(src) {
		const cap = this.rules.block.def.exec(src);
		if (cap) {
			const tag = cap[1].toLowerCase().replace(/\s+/g, " ");
			const href = cap[2] ? cap[2].replace(/^<(.*)>$/, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "";
			const title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : cap[3];
			return {
				type: "def",
				tag,
				raw: cap[0],
				href,
				title
			};
		}
	}
	table(src) {
		const cap = this.rules.block.table.exec(src);
		if (!cap) return;
		if (!/[:|]/.test(cap[2])) return;
		const headers = splitCells(cap[1]);
		const aligns = cap[2].replace(/^\||\| *$/g, "").split("|");
		const rows = cap[3] && cap[3].trim() ? cap[3].replace(/\n[ \t]*$/, "").split("\n") : [];
		const item = {
			type: "table",
			raw: cap[0],
			header: [],
			align: [],
			rows: []
		};
		if (headers.length !== aligns.length) return;
		for (const align of aligns) if (/^ *-+: *$/.test(align)) item.align.push("right");
		else if (/^ *:-+: *$/.test(align)) item.align.push("center");
		else if (/^ *:-+ *$/.test(align)) item.align.push("left");
		else item.align.push(null);
		for (let i = 0; i < headers.length; i++) item.header.push({
			text: headers[i],
			tokens: this.lexer.inline(headers[i]),
			header: true,
			align: item.align[i]
		});
		for (const row of rows) item.rows.push(splitCells(row, item.header.length).map((cell, i) => {
			return {
				text: cell,
				tokens: this.lexer.inline(cell),
				header: false,
				align: item.align[i]
			};
		}));
		return item;
	}
	lheading(src) {
		const cap = this.rules.block.lheading.exec(src);
		if (cap) return {
			type: "heading",
			raw: cap[0],
			depth: cap[2].charAt(0) === "=" ? 1 : 2,
			text: cap[1],
			tokens: this.lexer.inline(cap[1])
		};
	}
	paragraph(src) {
		const cap = this.rules.block.paragraph.exec(src);
		if (cap) {
			const text = cap[1].charAt(cap[1].length - 1) === "\n" ? cap[1].slice(0, -1) : cap[1];
			return {
				type: "paragraph",
				raw: cap[0],
				text,
				tokens: this.lexer.inline(text)
			};
		}
	}
	text(src) {
		const cap = this.rules.block.text.exec(src);
		if (cap) return {
			type: "text",
			raw: cap[0],
			text: cap[0],
			tokens: this.lexer.inline(cap[0])
		};
	}
	escape(src) {
		const cap = this.rules.inline.escape.exec(src);
		if (cap) return {
			type: "escape",
			raw: cap[0],
			text: escape$1(cap[1])
		};
	}
	tag(src) {
		const cap = this.rules.inline.tag.exec(src);
		if (cap) {
			if (!this.lexer.state.inLink && /^<a /i.test(cap[0])) this.lexer.state.inLink = true;
			else if (this.lexer.state.inLink && /^<\/a>/i.test(cap[0])) this.lexer.state.inLink = false;
			if (!this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) this.lexer.state.inRawBlock = true;
			else if (this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) this.lexer.state.inRawBlock = false;
			return {
				type: "html",
				raw: cap[0],
				inLink: this.lexer.state.inLink,
				inRawBlock: this.lexer.state.inRawBlock,
				block: false,
				text: cap[0]
			};
		}
	}
	link(src) {
		const cap = this.rules.inline.link.exec(src);
		if (cap) {
			const trimmedUrl = cap[2].trim();
			if (!this.options.pedantic && /^</.test(trimmedUrl)) {
				if (!/>$/.test(trimmedUrl)) return;
				const rtrimSlash = rtrim(trimmedUrl.slice(0, -1), "\\");
				if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) return;
			} else {
				const lastParenIndex = findClosingBracket(cap[2], "()");
				if (lastParenIndex > -1) {
					const linkLen = (cap[0].indexOf("!") === 0 ? 5 : 4) + cap[1].length + lastParenIndex;
					cap[2] = cap[2].substring(0, lastParenIndex);
					cap[0] = cap[0].substring(0, linkLen).trim();
					cap[3] = "";
				}
			}
			let href = cap[2];
			let title = "";
			if (this.options.pedantic) {
				const link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);
				if (link) {
					href = link[1];
					title = link[3];
				}
			} else title = cap[3] ? cap[3].slice(1, -1) : "";
			href = href.trim();
			if (/^</.test(href)) {
				if (this.options.pedantic && !/>$/.test(trimmedUrl)) href = href.slice(1);
				else href = href.slice(1, -1);
			}
			return outputLink(cap, {
				href: href ? href.replace(this.rules.inline.anyPunctuation, "$1") : href,
				title: title ? title.replace(this.rules.inline.anyPunctuation, "$1") : title
			}, cap[0], this.lexer);
		}
	}
	reflink(src, links) {
		let cap;
		if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
			const link = links[(cap[2] || cap[1]).replace(/\s+/g, " ").toLowerCase()];
			if (!link) {
				const text = cap[0].charAt(0);
				return {
					type: "text",
					raw: text,
					text
				};
			}
			return outputLink(cap, link, cap[0], this.lexer);
		}
	}
	emStrong(src, maskedSrc, prevChar = "") {
		let match = this.rules.inline.emStrongLDelim.exec(src);
		if (!match) return;
		if (match[3] && prevChar.match(/[\p{L}\p{N}]/u)) return;
		if (!(match[1] || match[2] || "") || !prevChar || this.rules.inline.punctuation.exec(prevChar)) {
			const lLength = [...match[0]].length - 1;
			let rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
			const endReg = match[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
			endReg.lastIndex = 0;
			maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
			while ((match = endReg.exec(maskedSrc)) != null) {
				rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
				if (!rDelim) continue;
				rLength = [...rDelim].length;
				if (match[3] || match[4]) {
					delimTotal += rLength;
					continue;
				} else if (match[5] || match[6]) {
					if (lLength % 3 && !((lLength + rLength) % 3)) {
						midDelimTotal += rLength;
						continue;
					}
				}
				delimTotal -= rLength;
				if (delimTotal > 0) continue;
				rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
				const lastCharLength = [...match[0]][0].length;
				const raw = src.slice(0, lLength + match.index + lastCharLength + rLength);
				if (Math.min(lLength, rLength) % 2) {
					const text = raw.slice(1, -1);
					return {
						type: "em",
						raw,
						text,
						tokens: this.lexer.inlineTokens(text)
					};
				}
				const text = raw.slice(2, -2);
				return {
					type: "strong",
					raw,
					text,
					tokens: this.lexer.inlineTokens(text)
				};
			}
		}
	}
	codespan(src) {
		const cap = this.rules.inline.code.exec(src);
		if (cap) {
			let text = cap[2].replace(/\n/g, " ");
			const hasNonSpaceChars = /[^ ]/.test(text);
			const hasSpaceCharsOnBothEnds = /^ /.test(text) && / $/.test(text);
			if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) text = text.substring(1, text.length - 1);
			text = escape$1(text, true);
			return {
				type: "codespan",
				raw: cap[0],
				text
			};
		}
	}
	br(src) {
		const cap = this.rules.inline.br.exec(src);
		if (cap) return {
			type: "br",
			raw: cap[0]
		};
	}
	del(src) {
		const cap = this.rules.inline.del.exec(src);
		if (cap) return {
			type: "del",
			raw: cap[0],
			text: cap[2],
			tokens: this.lexer.inlineTokens(cap[2])
		};
	}
	autolink(src) {
		const cap = this.rules.inline.autolink.exec(src);
		if (cap) {
			let text, href;
			if (cap[2] === "@") {
				text = escape$1(cap[1]);
				href = "mailto:" + text;
			} else {
				text = escape$1(cap[1]);
				href = text;
			}
			return {
				type: "link",
				raw: cap[0],
				text,
				href,
				tokens: [{
					type: "text",
					raw: text,
					text
				}]
			};
		}
	}
	url(src) {
		let cap;
		if (cap = this.rules.inline.url.exec(src)) {
			let text, href;
			if (cap[2] === "@") {
				text = escape$1(cap[0]);
				href = "mailto:" + text;
			} else {
				let prevCapZero;
				do {
					prevCapZero = cap[0];
					cap[0] = this.rules.inline._backpedal.exec(cap[0])?.[0] ?? "";
				} while (prevCapZero !== cap[0]);
				text = escape$1(cap[0]);
				if (cap[1] === "www.") href = "http://" + cap[0];
				else href = cap[0];
			}
			return {
				type: "link",
				raw: cap[0],
				text,
				href,
				tokens: [{
					type: "text",
					raw: text,
					text
				}]
			};
		}
	}
	inlineText(src) {
		const cap = this.rules.inline.text.exec(src);
		if (cap) {
			let text;
			if (this.lexer.state.inRawBlock) text = cap[0];
			else text = escape$1(cap[0]);
			return {
				type: "text",
				raw: cap[0],
				text
			};
		}
	}
};
/**
* Block-Level Grammar
*/
var newline = /^(?: *(?:\n|$))+/;
var blockCode = /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/;
var fences = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/;
var hr = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/;
var heading = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/;
var bullet = /(?:[*+-]|\d{1,9}[.)])/;
var lheading = edit(/^(?!bull |blockCode|fences|blockquote|heading|html)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html))+?)\n {0,3}(=+|-+) *(?:\n+|$)/).replace(/bull/g, bullet).replace(/blockCode/g, / {4}/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).getRegex();
var _paragraph = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/;
var blockText = /^[^\n]+/;
var _blockLabel = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
var def = edit(/^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/).replace("label", _blockLabel).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex();
var list = edit(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, bullet).getRegex();
var _tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
var _comment = /<!--(?:-?>|[\s\S]*?(?:-->|$))/;
var html$2 = edit("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))", "i").replace("comment", _comment).replace("tag", _tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
var paragraph = edit(_paragraph).replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag).getRegex();
/**
* Normal Block Grammar
*/
var blockNormal = {
	blockquote: edit(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", paragraph).getRegex(),
	code: blockCode,
	def,
	fences,
	heading,
	hr,
	html: html$2,
	lheading,
	list,
	newline,
	paragraph,
	table: noopTest,
	text: blockText
};
/**
* GFM Block Grammar
*/
var gfmTable = edit("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag).getRegex();
var blockGfm = {
	...blockNormal,
	table: gfmTable,
	paragraph: edit(_paragraph).replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", gfmTable).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag).getRegex()
};
/**
* Pedantic grammar (original John Gruber's loose markdown specification)
*/
var blockPedantic = {
	...blockNormal,
	html: edit("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace("comment", _comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
	def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
	heading: /^(#{1,6})(.*)(?:\n+|$)/,
	fences: noopTest,
	lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
	paragraph: edit(_paragraph).replace("hr", hr).replace("heading", " *#{1,6} *[^\n]").replace("lheading", lheading).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
};
/**
* Inline-Level Grammar
*/
var escape = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/;
var inlineCode = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/;
var br = /^( {2,}|\\)\n(?!\s*$)/;
var inlineText = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/;
var _punctuation = "\\p{P}\\p{S}";
var punctuation = edit(/^((?![*_])[\spunctuation])/, "u").replace(/punctuation/g, _punctuation).getRegex();
var blockSkip = /\[[^[\]]*?\]\([^\(\)]*?\)|`[^`]*?`|<[^<>]*?>/g;
var emStrongLDelim = edit(/^(?:\*+(?:((?!\*)[punct])|[^\s*]))|^_+(?:((?!_)[punct])|([^\s_]))/, "u").replace(/punct/g, _punctuation).getRegex();
var emStrongRDelimAst = edit("^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)[punct](\\*+)(?=[\\s]|$)|[^punct\\s](\\*+)(?!\\*)(?=[punct\\s]|$)|(?!\\*)[punct\\s](\\*+)(?=[^punct\\s])|[\\s](\\*+)(?!\\*)(?=[punct])|(?!\\*)[punct](\\*+)(?!\\*)(?=[punct])|[^punct\\s](\\*+)(?=[^punct\\s])", "gu").replace(/punct/g, _punctuation).getRegex();
var emStrongRDelimUnd = edit("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)[punct](_+)(?=[\\s]|$)|[^punct\\s](_+)(?!_)(?=[punct\\s]|$)|(?!_)[punct\\s](_+)(?=[^punct\\s])|[\\s](_+)(?!_)(?=[punct])|(?!_)[punct](_+)(?!_)(?=[punct])", "gu").replace(/punct/g, _punctuation).getRegex();
var anyPunctuation = edit(/\\([punct])/, "gu").replace(/punct/g, _punctuation).getRegex();
var autolink = edit(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex();
var _inlineComment = edit(_comment).replace("(?:-->|$)", "-->").getRegex();
var tag = edit("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", _inlineComment).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex();
var _inlineLabel = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
var link = edit(/^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/).replace("label", _inlineLabel).replace("href", /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex();
var reflink = edit(/^!?\[(label)\]\[(ref)\]/).replace("label", _inlineLabel).replace("ref", _blockLabel).getRegex();
var nolink = edit(/^!?\[(ref)\](?:\[\])?/).replace("ref", _blockLabel).getRegex();
/**
* Normal Inline Grammar
*/
var inlineNormal = {
	_backpedal: noopTest,
	anyPunctuation,
	autolink,
	blockSkip,
	br,
	code: inlineCode,
	del: noopTest,
	emStrongLDelim,
	emStrongRDelimAst,
	emStrongRDelimUnd,
	escape,
	link,
	nolink,
	punctuation,
	reflink,
	reflinkSearch: edit("reflink|nolink(?!\\()", "g").replace("reflink", reflink).replace("nolink", nolink).getRegex(),
	tag,
	text: inlineText,
	url: noopTest
};
/**
* Pedantic Inline Grammar
*/
var inlinePedantic = {
	...inlineNormal,
	link: edit(/^!?\[(label)\]\((.*?)\)/).replace("label", _inlineLabel).getRegex(),
	reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", _inlineLabel).getRegex()
};
/**
* GFM Inline Grammar
*/
var inlineGfm = {
	...inlineNormal,
	escape: edit(escape).replace("])", "~|])").getRegex(),
	url: edit(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, "i").replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
	_backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
	del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
	text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
};
/**
* GFM + Line Breaks Inline Grammar
*/
var inlineBreaks = {
	...inlineGfm,
	br: edit(br).replace("{2,}", "*").getRegex(),
	text: edit(inlineGfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
};
/**
* exports
*/
var block = {
	normal: blockNormal,
	gfm: blockGfm,
	pedantic: blockPedantic
};
var inline$1 = {
	normal: inlineNormal,
	gfm: inlineGfm,
	breaks: inlineBreaks,
	pedantic: inlinePedantic
};
/**
* Block Lexer
*/
var _Lexer = class _Lexer {
	tokens;
	options;
	state;
	tokenizer;
	inlineQueue;
	constructor(options) {
		this.tokens = [];
		this.tokens.links = Object.create(null);
		this.options = options || _defaults;
		this.options.tokenizer = this.options.tokenizer || new _Tokenizer();
		this.tokenizer = this.options.tokenizer;
		this.tokenizer.options = this.options;
		this.tokenizer.lexer = this;
		this.inlineQueue = [];
		this.state = {
			inLink: false,
			inRawBlock: false,
			top: true
		};
		const rules = {
			block: block.normal,
			inline: inline$1.normal
		};
		if (this.options.pedantic) {
			rules.block = block.pedantic;
			rules.inline = inline$1.pedantic;
		} else if (this.options.gfm) {
			rules.block = block.gfm;
			if (this.options.breaks) rules.inline = inline$1.breaks;
			else rules.inline = inline$1.gfm;
		}
		this.tokenizer.rules = rules;
	}
	/**
	* Expose Rules
	*/
	static get rules() {
		return {
			block,
			inline: inline$1
		};
	}
	/**
	* Static Lex Method
	*/
	static lex(src, options) {
		return new _Lexer(options).lex(src);
	}
	/**
	* Static Lex Inline Method
	*/
	static lexInline(src, options) {
		return new _Lexer(options).inlineTokens(src);
	}
	/**
	* Preprocessing
	*/
	lex(src) {
		src = src.replace(/\r\n|\r/g, "\n");
		this.blockTokens(src, this.tokens);
		for (let i = 0; i < this.inlineQueue.length; i++) {
			const next = this.inlineQueue[i];
			this.inlineTokens(next.src, next.tokens);
		}
		this.inlineQueue = [];
		return this.tokens;
	}
	blockTokens(src, tokens = [], lastParagraphClipped = false) {
		if (this.options.pedantic) src = src.replace(/\t/g, "    ").replace(/^ +$/gm, "");
		else src = src.replace(/^( *)(\t+)/gm, (_, leading, tabs) => {
			return leading + "    ".repeat(tabs.length);
		});
		let token;
		let lastToken;
		let cutSrc;
		while (src) {
			if (this.options.extensions && this.options.extensions.block && this.options.extensions.block.some((extTokenizer) => {
				if (token = extTokenizer.call({ lexer: this }, src, tokens)) {
					src = src.substring(token.raw.length);
					tokens.push(token);
					return true;
				}
				return false;
			})) continue;
			if (token = this.tokenizer.space(src)) {
				src = src.substring(token.raw.length);
				if (token.raw.length === 1 && tokens.length > 0) tokens[tokens.length - 1].raw += "\n";
				else tokens.push(token);
				continue;
			}
			if (token = this.tokenizer.code(src)) {
				src = src.substring(token.raw.length);
				lastToken = tokens[tokens.length - 1];
				if (lastToken && (lastToken.type === "paragraph" || lastToken.type === "text")) {
					lastToken.raw += "\n" + token.raw;
					lastToken.text += "\n" + token.text;
					this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
				} else tokens.push(token);
				continue;
			}
			if (token = this.tokenizer.fences(src)) {
				src = src.substring(token.raw.length);
				tokens.push(token);
				continue;
			}
			if (token = this.tokenizer.heading(src)) {
				src = src.substring(token.raw.length);
				tokens.push(token);
				continue;
			}
			if (token = this.tokenizer.hr(src)) {
				src = src.substring(token.raw.length);
				tokens.push(token);
				continue;
			}
			if (token = this.tokenizer.blockquote(src)) {
				src = src.substring(token.raw.length);
				tokens.push(token);
				continue;
			}
			if (token = this.tokenizer.list(src)) {
				src = src.substring(token.raw.length);
				tokens.push(token);
				continue;
			}
			if (token = this.tokenizer.html(src)) {
				src = src.substring(token.raw.length);
				tokens.push(token);
				continue;
			}
			if (token = this.tokenizer.def(src)) {
				src = src.substring(token.raw.length);
				lastToken = tokens[tokens.length - 1];
				if (lastToken && (lastToken.type === "paragraph" || lastToken.type === "text")) {
					lastToken.raw += "\n" + token.raw;
					lastToken.text += "\n" + token.raw;
					this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
				} else if (!this.tokens.links[token.tag]) this.tokens.links[token.tag] = {
					href: token.href,
					title: token.title
				};
				continue;
			}
			if (token = this.tokenizer.table(src)) {
				src = src.substring(token.raw.length);
				tokens.push(token);
				continue;
			}
			if (token = this.tokenizer.lheading(src)) {
				src = src.substring(token.raw.length);
				tokens.push(token);
				continue;
			}
			cutSrc = src;
			if (this.options.extensions && this.options.extensions.startBlock) {
				let startIndex = Infinity;
				const tempSrc = src.slice(1);
				let tempStart;
				this.options.extensions.startBlock.forEach((getStartIndex) => {
					tempStart = getStartIndex.call({ lexer: this }, tempSrc);
					if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
				});
				if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
			}
			if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
				lastToken = tokens[tokens.length - 1];
				if (lastParagraphClipped && lastToken?.type === "paragraph") {
					lastToken.raw += "\n" + token.raw;
					lastToken.text += "\n" + token.text;
					this.inlineQueue.pop();
					this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
				} else tokens.push(token);
				lastParagraphClipped = cutSrc.length !== src.length;
				src = src.substring(token.raw.length);
				continue;
			}
			if (token = this.tokenizer.text(src)) {
				src = src.substring(token.raw.length);
				lastToken = tokens[tokens.length - 1];
				if (lastToken && lastToken.type === "text") {
					lastToken.raw += "\n" + token.raw;
					lastToken.text += "\n" + token.text;
					this.inlineQueue.pop();
					this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
				} else tokens.push(token);
				continue;
			}
			if (src) {
				const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
				if (this.options.silent) {
					console.error(errMsg);
					break;
				} else throw new Error(errMsg);
			}
		}
		this.state.top = true;
		return tokens;
	}
	inline(src, tokens = []) {
		this.inlineQueue.push({
			src,
			tokens
		});
		return tokens;
	}
	/**
	* Lexing/Compiling
	*/
	inlineTokens(src, tokens = []) {
		let token, lastToken, cutSrc;
		let maskedSrc = src;
		let match;
		let keepPrevChar, prevChar;
		if (this.tokens.links) {
			const links = Object.keys(this.tokens.links);
			if (links.length > 0) {
				while ((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null) if (links.includes(match[0].slice(match[0].lastIndexOf("[") + 1, -1))) maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
			}
		}
		while ((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null) maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
		while ((match = this.tokenizer.rules.inline.anyPunctuation.exec(maskedSrc)) != null) maskedSrc = maskedSrc.slice(0, match.index) + "++" + maskedSrc.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
		while (src) {
			if (!keepPrevChar) prevChar = "";
			keepPrevChar = false;
			if (this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some((extTokenizer) => {
				if (token = extTokenizer.call({ lexer: this }, src, tokens)) {
					src = src.substring(token.raw.length);
					tokens.push(token);
					return true;
				}
				return false;
			})) continue;
			if (token = this.tokenizer.escape(src)) {
				src = src.substring(token.raw.length);
				tokens.push(token);
				continue;
			}
			if (token = this.tokenizer.tag(src)) {
				src = src.substring(token.raw.length);
				lastToken = tokens[tokens.length - 1];
				if (lastToken && token.type === "text" && lastToken.type === "text") {
					lastToken.raw += token.raw;
					lastToken.text += token.text;
				} else tokens.push(token);
				continue;
			}
			if (token = this.tokenizer.link(src)) {
				src = src.substring(token.raw.length);
				tokens.push(token);
				continue;
			}
			if (token = this.tokenizer.reflink(src, this.tokens.links)) {
				src = src.substring(token.raw.length);
				lastToken = tokens[tokens.length - 1];
				if (lastToken && token.type === "text" && lastToken.type === "text") {
					lastToken.raw += token.raw;
					lastToken.text += token.text;
				} else tokens.push(token);
				continue;
			}
			if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
				src = src.substring(token.raw.length);
				tokens.push(token);
				continue;
			}
			if (token = this.tokenizer.codespan(src)) {
				src = src.substring(token.raw.length);
				tokens.push(token);
				continue;
			}
			if (token = this.tokenizer.br(src)) {
				src = src.substring(token.raw.length);
				tokens.push(token);
				continue;
			}
			if (token = this.tokenizer.del(src)) {
				src = src.substring(token.raw.length);
				tokens.push(token);
				continue;
			}
			if (token = this.tokenizer.autolink(src)) {
				src = src.substring(token.raw.length);
				tokens.push(token);
				continue;
			}
			if (!this.state.inLink && (token = this.tokenizer.url(src))) {
				src = src.substring(token.raw.length);
				tokens.push(token);
				continue;
			}
			cutSrc = src;
			if (this.options.extensions && this.options.extensions.startInline) {
				let startIndex = Infinity;
				const tempSrc = src.slice(1);
				let tempStart;
				this.options.extensions.startInline.forEach((getStartIndex) => {
					tempStart = getStartIndex.call({ lexer: this }, tempSrc);
					if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
				});
				if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
			}
			if (token = this.tokenizer.inlineText(cutSrc)) {
				src = src.substring(token.raw.length);
				if (token.raw.slice(-1) !== "_") prevChar = token.raw.slice(-1);
				keepPrevChar = true;
				lastToken = tokens[tokens.length - 1];
				if (lastToken && lastToken.type === "text") {
					lastToken.raw += token.raw;
					lastToken.text += token.text;
				} else tokens.push(token);
				continue;
			}
			if (src) {
				const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
				if (this.options.silent) {
					console.error(errMsg);
					break;
				} else throw new Error(errMsg);
			}
		}
		return tokens;
	}
};
/**
* Renderer
*/
var _Renderer = class {
	options;
	parser;
	constructor(options) {
		this.options = options || _defaults;
	}
	space(token) {
		return "";
	}
	code({ text, lang, escaped }) {
		const langString = (lang || "").match(/^\S*/)?.[0];
		const code = text.replace(/\n$/, "") + "\n";
		if (!langString) return "<pre><code>" + (escaped ? code : escape$1(code, true)) + "</code></pre>\n";
		return "<pre><code class=\"language-" + escape$1(langString) + "\">" + (escaped ? code : escape$1(code, true)) + "</code></pre>\n";
	}
	blockquote({ tokens }) {
		return `<blockquote>\n${this.parser.parse(tokens)}</blockquote>\n`;
	}
	html({ text }) {
		return text;
	}
	heading({ tokens, depth }) {
		return `<h${depth}>${this.parser.parseInline(tokens)}</h${depth}>\n`;
	}
	hr(token) {
		return "<hr>\n";
	}
	list(token) {
		const ordered = token.ordered;
		const start = token.start;
		let body = "";
		for (let j = 0; j < token.items.length; j++) {
			const item = token.items[j];
			body += this.listitem(item);
		}
		const type = ordered ? "ol" : "ul";
		const startAttr = ordered && start !== 1 ? " start=\"" + start + "\"" : "";
		return "<" + type + startAttr + ">\n" + body + "</" + type + ">\n";
	}
	listitem(item) {
		let itemBody = "";
		if (item.task) {
			const checkbox = this.checkbox({ checked: !!item.checked });
			if (item.loose) {
				if (item.tokens.length > 0 && item.tokens[0].type === "paragraph") {
					item.tokens[0].text = checkbox + " " + item.tokens[0].text;
					if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === "text") item.tokens[0].tokens[0].text = checkbox + " " + item.tokens[0].tokens[0].text;
				} else item.tokens.unshift({
					type: "text",
					raw: checkbox + " ",
					text: checkbox + " "
				});
			} else itemBody += checkbox + " ";
		}
		itemBody += this.parser.parse(item.tokens, !!item.loose);
		return `<li>${itemBody}</li>\n`;
	}
	checkbox({ checked }) {
		return "<input " + (checked ? "checked=\"\" " : "") + "disabled=\"\" type=\"checkbox\">";
	}
	paragraph({ tokens }) {
		return `<p>${this.parser.parseInline(tokens)}</p>\n`;
	}
	table(token) {
		let header = "";
		let cell = "";
		for (let j = 0; j < token.header.length; j++) cell += this.tablecell(token.header[j]);
		header += this.tablerow({ text: cell });
		let body = "";
		for (let j = 0; j < token.rows.length; j++) {
			const row = token.rows[j];
			cell = "";
			for (let k = 0; k < row.length; k++) cell += this.tablecell(row[k]);
			body += this.tablerow({ text: cell });
		}
		if (body) body = `<tbody>${body}</tbody>`;
		return "<table>\n<thead>\n" + header + "</thead>\n" + body + "</table>\n";
	}
	tablerow({ text }) {
		return `<tr>\n${text}</tr>\n`;
	}
	tablecell(token) {
		const content = this.parser.parseInline(token.tokens);
		const type = token.header ? "th" : "td";
		return (token.align ? `<${type} align="${token.align}">` : `<${type}>`) + content + `</${type}>\n`;
	}
	/**
	* span level renderer
	*/
	strong({ tokens }) {
		return `<strong>${this.parser.parseInline(tokens)}</strong>`;
	}
	em({ tokens }) {
		return `<em>${this.parser.parseInline(tokens)}</em>`;
	}
	codespan({ text }) {
		return `<code>${text}</code>`;
	}
	br(token) {
		return "<br>";
	}
	del({ tokens }) {
		return `<del>${this.parser.parseInline(tokens)}</del>`;
	}
	link({ href, title, tokens }) {
		const text = this.parser.parseInline(tokens);
		const cleanHref = cleanUrl(href);
		if (cleanHref === null) return text;
		href = cleanHref;
		let out = "<a href=\"" + href + "\"";
		if (title) out += " title=\"" + title + "\"";
		out += ">" + text + "</a>";
		return out;
	}
	image({ href, title, text }) {
		const cleanHref = cleanUrl(href);
		if (cleanHref === null) return text;
		href = cleanHref;
		let out = `<img src="${href}" alt="${text}"`;
		if (title) out += ` title="${title}"`;
		out += ">";
		return out;
	}
	text(token) {
		return "tokens" in token && token.tokens ? this.parser.parseInline(token.tokens) : token.text;
	}
};
/**
* TextRenderer
* returns only the textual part of the token
*/
var _TextRenderer = class {
	strong({ text }) {
		return text;
	}
	em({ text }) {
		return text;
	}
	codespan({ text }) {
		return text;
	}
	del({ text }) {
		return text;
	}
	html({ text }) {
		return text;
	}
	text({ text }) {
		return text;
	}
	link({ text }) {
		return "" + text;
	}
	image({ text }) {
		return "" + text;
	}
	br() {
		return "";
	}
};
/**
* Parsing & Compiling
*/
var _Parser = class _Parser {
	options;
	renderer;
	textRenderer;
	constructor(options) {
		this.options = options || _defaults;
		this.options.renderer = this.options.renderer || new _Renderer();
		this.renderer = this.options.renderer;
		this.renderer.options = this.options;
		this.renderer.parser = this;
		this.textRenderer = new _TextRenderer();
	}
	/**
	* Static Parse Method
	*/
	static parse(tokens, options) {
		return new _Parser(options).parse(tokens);
	}
	/**
	* Static Parse Inline Method
	*/
	static parseInline(tokens, options) {
		return new _Parser(options).parseInline(tokens);
	}
	/**
	* Parse Loop
	*/
	parse(tokens, top = true) {
		let out = "";
		for (let i = 0; i < tokens.length; i++) {
			const anyToken = tokens[i];
			if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[anyToken.type]) {
				const genericToken = anyToken;
				const ret = this.options.extensions.renderers[genericToken.type].call({ parser: this }, genericToken);
				if (ret !== false || ![
					"space",
					"hr",
					"heading",
					"code",
					"table",
					"blockquote",
					"list",
					"html",
					"paragraph",
					"text"
				].includes(genericToken.type)) {
					out += ret || "";
					continue;
				}
			}
			const token = anyToken;
			switch (token.type) {
				case "space":
					out += this.renderer.space(token);
					continue;
				case "hr":
					out += this.renderer.hr(token);
					continue;
				case "heading":
					out += this.renderer.heading(token);
					continue;
				case "code":
					out += this.renderer.code(token);
					continue;
				case "table":
					out += this.renderer.table(token);
					continue;
				case "blockquote":
					out += this.renderer.blockquote(token);
					continue;
				case "list":
					out += this.renderer.list(token);
					continue;
				case "html":
					out += this.renderer.html(token);
					continue;
				case "paragraph":
					out += this.renderer.paragraph(token);
					continue;
				case "text": {
					let textToken = token;
					let body = this.renderer.text(textToken);
					while (i + 1 < tokens.length && tokens[i + 1].type === "text") {
						textToken = tokens[++i];
						body += "\n" + this.renderer.text(textToken);
					}
					if (top) out += this.renderer.paragraph({
						type: "paragraph",
						raw: body,
						text: body,
						tokens: [{
							type: "text",
							raw: body,
							text: body
						}]
					});
					else out += body;
					continue;
				}
				default: {
					const errMsg = "Token with \"" + token.type + "\" type was not found.";
					if (this.options.silent) {
						console.error(errMsg);
						return "";
					} else throw new Error(errMsg);
				}
			}
		}
		return out;
	}
	/**
	* Parse Inline Tokens
	*/
	parseInline(tokens, renderer) {
		renderer = renderer || this.renderer;
		let out = "";
		for (let i = 0; i < tokens.length; i++) {
			const anyToken = tokens[i];
			if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[anyToken.type]) {
				const ret = this.options.extensions.renderers[anyToken.type].call({ parser: this }, anyToken);
				if (ret !== false || ![
					"escape",
					"html",
					"link",
					"image",
					"strong",
					"em",
					"codespan",
					"br",
					"del",
					"text"
				].includes(anyToken.type)) {
					out += ret || "";
					continue;
				}
			}
			const token = anyToken;
			switch (token.type) {
				case "escape":
					out += renderer.text(token);
					break;
				case "html":
					out += renderer.html(token);
					break;
				case "link":
					out += renderer.link(token);
					break;
				case "image":
					out += renderer.image(token);
					break;
				case "strong":
					out += renderer.strong(token);
					break;
				case "em":
					out += renderer.em(token);
					break;
				case "codespan":
					out += renderer.codespan(token);
					break;
				case "br":
					out += renderer.br(token);
					break;
				case "del":
					out += renderer.del(token);
					break;
				case "text":
					out += renderer.text(token);
					break;
				default: {
					const errMsg = "Token with \"" + token.type + "\" type was not found.";
					if (this.options.silent) {
						console.error(errMsg);
						return "";
					} else throw new Error(errMsg);
				}
			}
		}
		return out;
	}
};
var _Hooks = class {
	options;
	constructor(options) {
		this.options = options || _defaults;
	}
	static passThroughHooks = /* @__PURE__ */ new Set([
		"preprocess",
		"postprocess",
		"processAllTokens"
	]);
	/**
	* Process markdown before marked
	*/
	preprocess(markdown) {
		return markdown;
	}
	/**
	* Process HTML after marked is finished
	*/
	postprocess(html) {
		return html;
	}
	/**
	* Process all tokens before walk tokens
	*/
	processAllTokens(tokens) {
		return tokens;
	}
};
var Marked = class {
	defaults = _getDefaults();
	options = this.setOptions;
	parse = this.parseMarkdown(_Lexer.lex, _Parser.parse);
	parseInline = this.parseMarkdown(_Lexer.lexInline, _Parser.parseInline);
	Parser = _Parser;
	Renderer = _Renderer;
	TextRenderer = _TextRenderer;
	Lexer = _Lexer;
	Tokenizer = _Tokenizer;
	Hooks = _Hooks;
	constructor(...args) {
		this.use(...args);
	}
	/**
	* Run callback for every token
	*/
	walkTokens(tokens, callback) {
		let values = [];
		for (const token of tokens) {
			values = values.concat(callback.call(this, token));
			switch (token.type) {
				case "table": {
					const tableToken = token;
					for (const cell of tableToken.header) values = values.concat(this.walkTokens(cell.tokens, callback));
					for (const row of tableToken.rows) for (const cell of row) values = values.concat(this.walkTokens(cell.tokens, callback));
					break;
				}
				case "list": {
					const listToken = token;
					values = values.concat(this.walkTokens(listToken.items, callback));
					break;
				}
				default: {
					const genericToken = token;
					if (this.defaults.extensions?.childTokens?.[genericToken.type]) this.defaults.extensions.childTokens[genericToken.type].forEach((childTokens) => {
						const tokens = genericToken[childTokens].flat(Infinity);
						values = values.concat(this.walkTokens(tokens, callback));
					});
					else if (genericToken.tokens) values = values.concat(this.walkTokens(genericToken.tokens, callback));
				}
			}
		}
		return values;
	}
	use(...args) {
		const extensions = this.defaults.extensions || {
			renderers: {},
			childTokens: {}
		};
		args.forEach((pack) => {
			const opts = { ...pack };
			opts.async = this.defaults.async || opts.async || false;
			if (pack.extensions) {
				pack.extensions.forEach((ext) => {
					if (!ext.name) throw new Error("extension name required");
					if ("renderer" in ext) {
						const prevRenderer = extensions.renderers[ext.name];
						if (prevRenderer) extensions.renderers[ext.name] = function(...args) {
							let ret = ext.renderer.apply(this, args);
							if (ret === false) ret = prevRenderer.apply(this, args);
							return ret;
						};
						else extensions.renderers[ext.name] = ext.renderer;
					}
					if ("tokenizer" in ext) {
						if (!ext.level || ext.level !== "block" && ext.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
						const extLevel = extensions[ext.level];
						if (extLevel) extLevel.unshift(ext.tokenizer);
						else extensions[ext.level] = [ext.tokenizer];
						if (ext.start) {
							if (ext.level === "block") {
								if (extensions.startBlock) extensions.startBlock.push(ext.start);
								else extensions.startBlock = [ext.start];
							} else if (ext.level === "inline") {
								if (extensions.startInline) extensions.startInline.push(ext.start);
								else extensions.startInline = [ext.start];
							}
						}
					}
					if ("childTokens" in ext && ext.childTokens) extensions.childTokens[ext.name] = ext.childTokens;
				});
				opts.extensions = extensions;
			}
			if (pack.renderer) {
				const renderer = this.defaults.renderer || new _Renderer(this.defaults);
				for (const prop in pack.renderer) {
					if (!(prop in renderer)) throw new Error(`renderer '${prop}' does not exist`);
					if (["options", "parser"].includes(prop)) continue;
					const rendererProp = prop;
					const rendererFunc = pack.renderer[rendererProp];
					const prevRenderer = renderer[rendererProp];
					renderer[rendererProp] = (...args) => {
						let ret = rendererFunc.apply(renderer, args);
						if (ret === false) ret = prevRenderer.apply(renderer, args);
						return ret || "";
					};
				}
				opts.renderer = renderer;
			}
			if (pack.tokenizer) {
				const tokenizer = this.defaults.tokenizer || new _Tokenizer(this.defaults);
				for (const prop in pack.tokenizer) {
					if (!(prop in tokenizer)) throw new Error(`tokenizer '${prop}' does not exist`);
					if ([
						"options",
						"rules",
						"lexer"
					].includes(prop)) continue;
					const tokenizerProp = prop;
					const tokenizerFunc = pack.tokenizer[tokenizerProp];
					const prevTokenizer = tokenizer[tokenizerProp];
					tokenizer[tokenizerProp] = (...args) => {
						let ret = tokenizerFunc.apply(tokenizer, args);
						if (ret === false) ret = prevTokenizer.apply(tokenizer, args);
						return ret;
					};
				}
				opts.tokenizer = tokenizer;
			}
			if (pack.hooks) {
				const hooks = this.defaults.hooks || new _Hooks();
				for (const prop in pack.hooks) {
					if (!(prop in hooks)) throw new Error(`hook '${prop}' does not exist`);
					if (prop === "options") continue;
					const hooksProp = prop;
					const hooksFunc = pack.hooks[hooksProp];
					const prevHook = hooks[hooksProp];
					if (_Hooks.passThroughHooks.has(prop)) hooks[hooksProp] = (arg) => {
						if (this.defaults.async) return Promise.resolve(hooksFunc.call(hooks, arg)).then((ret) => {
							return prevHook.call(hooks, ret);
						});
						const ret = hooksFunc.call(hooks, arg);
						return prevHook.call(hooks, ret);
					};
					else hooks[hooksProp] = (...args) => {
						let ret = hooksFunc.apply(hooks, args);
						if (ret === false) ret = prevHook.apply(hooks, args);
						return ret;
					};
				}
				opts.hooks = hooks;
			}
			if (pack.walkTokens) {
				const walkTokens = this.defaults.walkTokens;
				const packWalktokens = pack.walkTokens;
				opts.walkTokens = function(token) {
					let values = [];
					values.push(packWalktokens.call(this, token));
					if (walkTokens) values = values.concat(walkTokens.call(this, token));
					return values;
				};
			}
			this.defaults = {
				...this.defaults,
				...opts
			};
		});
		return this;
	}
	setOptions(opt) {
		this.defaults = {
			...this.defaults,
			...opt
		};
		return this;
	}
	lexer(src, options) {
		return _Lexer.lex(src, options ?? this.defaults);
	}
	parser(tokens, options) {
		return _Parser.parse(tokens, options ?? this.defaults);
	}
	parseMarkdown(lexer, parser) {
		const parse = (src, options) => {
			const origOpt = { ...options };
			const opt = {
				...this.defaults,
				...origOpt
			};
			const throwError = this.onError(!!opt.silent, !!opt.async);
			if (this.defaults.async === true && origOpt.async === false) return throwError(/* @__PURE__ */ new Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
			if (typeof src === "undefined" || src === null) return throwError(/* @__PURE__ */ new Error("marked(): input parameter is undefined or null"));
			if (typeof src !== "string") return throwError(/* @__PURE__ */ new Error("marked(): input parameter is of type " + Object.prototype.toString.call(src) + ", string expected"));
			if (opt.hooks) opt.hooks.options = opt;
			if (opt.async) return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then((src) => lexer(src, opt)).then((tokens) => opt.hooks ? opt.hooks.processAllTokens(tokens) : tokens).then((tokens) => opt.walkTokens ? Promise.all(this.walkTokens(tokens, opt.walkTokens)).then(() => tokens) : tokens).then((tokens) => parser(tokens, opt)).then((html) => opt.hooks ? opt.hooks.postprocess(html) : html).catch(throwError);
			try {
				if (opt.hooks) src = opt.hooks.preprocess(src);
				let tokens = lexer(src, opt);
				if (opt.hooks) tokens = opt.hooks.processAllTokens(tokens);
				if (opt.walkTokens) this.walkTokens(tokens, opt.walkTokens);
				let html = parser(tokens, opt);
				if (opt.hooks) html = opt.hooks.postprocess(html);
				return html;
			} catch (e) {
				return throwError(e);
			}
		};
		return parse;
	}
	onError(silent, async) {
		return (e) => {
			e.message += "\nPlease report this to https://github.com/markedjs/marked.";
			if (silent) {
				const msg = "<p>An error occurred:</p><pre>" + escape$1(e.message + "", true) + "</pre>";
				if (async) return Promise.resolve(msg);
				return msg;
			}
			if (async) return Promise.reject(e);
			throw e;
		};
	}
};
var markedInstance = new Marked();
function marked(src, opt) {
	return markedInstance.parse(src, opt);
}
/**
* Sets the default options.
*
* @param options Hash of options
*/
marked.options = marked.setOptions = function(options) {
	markedInstance.setOptions(options);
	marked.defaults = markedInstance.defaults;
	changeDefaults(marked.defaults);
	return marked;
};
/**
* Gets the original marked default options.
*/
marked.getDefaults = _getDefaults;
marked.defaults = _defaults;
/**
* Use Extension
*/
marked.use = function(...args) {
	markedInstance.use(...args);
	marked.defaults = markedInstance.defaults;
	changeDefaults(marked.defaults);
	return marked;
};
/**
* Run callback for every token
*/
marked.walkTokens = function(tokens, callback) {
	return markedInstance.walkTokens(tokens, callback);
};
/**
* Compiles markdown to HTML without enclosing `p` tag.
*
* @param src String of markdown source to be compiled
* @param options Hash of options
* @return String of compiled HTML
*/
marked.parseInline = markedInstance.parseInline;
/**
* Expose
*/
marked.Parser = _Parser;
marked.parser = _Parser.parse;
marked.Renderer = _Renderer;
marked.TextRenderer = _TextRenderer;
marked.Lexer = _Lexer;
marked.lexer = _Lexer.lex;
marked.Tokenizer = _Tokenizer;
marked.Hooks = _Hooks;
marked.parse = marked;
marked.options;
marked.setOptions;
marked.use;
marked.walkTokens;
marked.parseInline;
var parse$2 = marked;
_Parser.parse;
var lexer = _Lexer.lex;
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/marshalling.js
function stringify(obj) {
	return JSON.stringify(obj, replacer);
}
function parse$1(text) {
	let data = JSON.parse(text);
	data = revive(data);
	return data;
}
function replacer(key, value) {
	if (value instanceof RegExp) return {
		$mid: 2,
		source: value.source,
		flags: value.flags
	};
	return value;
}
function revive(obj, depth = 0) {
	if (!obj || depth > 200) return obj;
	if (typeof obj === "object") {
		switch (obj.$mid) {
			case 1: return URI.revive(obj);
			case 2: return new RegExp(obj.source, obj.flags);
			case 17: return new Date(obj.source);
		}
		if (obj instanceof VSBuffer || obj instanceof Uint8Array) return obj;
		if (Array.isArray(obj)) for (let i = 0; i < obj.length; ++i) obj[i] = revive(obj[i], depth + 1);
		else for (const key in obj) if (Object.hasOwnProperty.call(obj, key)) obj[key] = revive(obj[key], depth + 1);
	}
	return obj;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/dompurify/dompurify.js
/*! @license DOMPurify 3.4.15 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.15/LICENSE */
function _arrayLikeToArray(r, a) {
	(null == a || a > r.length) && (a = r.length);
	for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
	return n;
}
function _arrayWithHoles(r) {
	if (Array.isArray(r)) return r;
}
function _iterableToArrayLimit(r, l) {
	var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
	if (null != t) {
		var e, n, i, u, a = [], f = true, o = false;
		try {
			if (i = (t = t.call(r)).next, 0 === l);
			else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
		} catch (r) {
			o = true, n = r;
		} finally {
			try {
				if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
			} finally {
				if (o) throw n;
			}
		}
		return a;
	}
}
function _nonIterableRest() {
	throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(r, e) {
	return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _unsupportedIterableToArray(r, a) {
	if (r) {
		if ("string" == typeof r) return _arrayLikeToArray(r, a);
		var t = {}.toString.call(r).slice(8, -1);
		return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
	}
}
var entries = Object.entries;
var setPrototypeOf = Object.setPrototypeOf;
var isFrozen = Object.isFrozen;
var getPrototypeOf = Object.getPrototypeOf;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var freeze$1 = Object.freeze;
var seal = Object.seal;
var create$1 = Object.create;
var _ref = typeof Reflect !== "undefined" && Reflect;
var apply = _ref.apply;
var construct = _ref.construct;
if (!freeze$1) freeze$1 = function freeze(x) {
	return x;
};
if (!seal) seal = function seal(x) {
	return x;
};
if (!apply) apply = function apply(func, thisArg) {
	for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) args[_key - 2] = arguments[_key];
	return func.apply(thisArg, args);
};
if (!construct) construct = function construct(Func) {
	for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) args[_key2 - 1] = arguments[_key2];
	return new Func(...args);
};
var arrayForEach = unapply(Array.prototype.forEach);
var arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
var arrayPop = unapply(Array.prototype.pop);
var arrayPush = unapply(Array.prototype.push);
var arraySplice = unapply(Array.prototype.splice);
var arrayIsArray = Array.isArray;
var stringToLowerCase = unapply(String.prototype.toLowerCase);
var stringToString = unapply(String.prototype.toString);
var stringMatch = unapply(String.prototype.match);
var stringReplace = unapply(String.prototype.replace);
var stringIndexOf = unapply(String.prototype.indexOf);
var stringTrim = unapply(String.prototype.trim);
var numberToString = unapply(Number.prototype.toString);
var booleanToString = unapply(Boolean.prototype.toString);
var bigintToString = typeof BigInt === "undefined" ? null : unapply(BigInt.prototype.toString);
var symbolToString = typeof Symbol === "undefined" ? null : unapply(Symbol.prototype.toString);
var objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
var objectToString = unapply(Object.prototype.toString);
var regExpTest = unapply(RegExp.prototype.test);
var typeErrorCreate = unconstruct(TypeError);
/**
* Creates a new function that calls the given function with a specified thisArg and arguments.
*
* @param func - The function to be wrapped and called.
* @returns A new function that calls the given function with a specified thisArg and arguments.
*/
function unapply(func) {
	return function(thisArg) {
		if (thisArg instanceof RegExp) thisArg.lastIndex = 0;
		for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) args[_key3 - 1] = arguments[_key3];
		return apply(func, thisArg, args);
	};
}
/**
* Creates a new function that constructs an instance of the given constructor function with the provided arguments.
*
* @param func - The constructor function to be wrapped and called.
* @returns A new function that constructs an instance of the given constructor function with the provided arguments.
*/
function unconstruct(Func) {
	return function() {
		for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) args[_key4] = arguments[_key4];
		return construct(Func, args);
	};
}
/**
* Add properties to a lookup table
*
* @param set - The set to which elements will be added.
* @param array - The array containing elements to be added to the set.
* @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
* @returns The modified set with added elements.
*/
function addToSet(set, array) {
	let transformCaseFunc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : stringToLowerCase;
	if (setPrototypeOf) setPrototypeOf(set, null);
	if (!arrayIsArray(array)) return set;
	let l = array.length;
	while (l--) {
		let element = array[l];
		if (typeof element === "string") {
			const lcElement = transformCaseFunc(element);
			if (lcElement !== element) {
				if (!isFrozen(array)) array[l] = lcElement;
				element = lcElement;
			}
		}
		set[element] = true;
	}
	return set;
}
/**
* Clean up an array to harden against CSPP
*
* @param array - The array to be cleaned.
* @returns The cleaned version of the array
*/
function cleanArray(array) {
	for (let index = 0; index < array.length; index++) if (!objectHasOwnProperty(array, index)) array[index] = null;
	return array;
}
/**
* Shallow clone an object
*
* @param object - The object to be cloned.
* @returns A new object that copies the original.
*/
function clone(object) {
	const newObject = create$1(null);
	for (const _ref2 of entries(object)) {
		var _ref3 = _slicedToArray(_ref2, 2);
		const property = _ref3[0];
		const value = _ref3[1];
		if (objectHasOwnProperty(object, property)) {
			if (arrayIsArray(value)) newObject[property] = cleanArray(value);
			else if (value && typeof value === "object" && value.constructor === Object) newObject[property] = clone(value);
			else newObject[property] = value;
		}
	}
	return newObject;
}
/**
* Convert non-node values into strings without depending on direct property access.
*
* @param value - The value to stringify.
* @returns A string representation of the provided value.
*/
function stringifyValue(value) {
	switch (typeof value) {
		case "string": return value;
		case "number": return numberToString(value);
		case "boolean": return booleanToString(value);
		case "bigint": return bigintToString ? bigintToString(value) : "0";
		case "symbol": return symbolToString ? symbolToString(value) : "Symbol()";
		case "undefined": return objectToString(value);
		case "function":
		case "object": {
			if (value === null) return objectToString(value);
			const valueAsRecord = value;
			const valueToString = lookupGetter(valueAsRecord, "toString");
			if (typeof valueToString === "function") {
				const stringified = valueToString(valueAsRecord);
				return typeof stringified === "string" ? stringified : objectToString(stringified);
			}
			return objectToString(value);
		}
		default: return objectToString(value);
	}
}
/**
* This method automatically checks if the prop is function or getter and behaves accordingly.
*
* @param object - The object to look up the getter function in its prototype chain.
* @param prop - The property name for which to find the getter function.
* @returns The getter function found in the prototype chain or a fallback function.
*/
function lookupGetter(object, prop) {
	while (object !== null) {
		const desc = getOwnPropertyDescriptor(object, prop);
		if (desc) {
			if (desc.get) return unapply(desc.get);
			if (typeof desc.value === "function") return unapply(desc.value);
		}
		object = getPrototypeOf(object);
	}
	function fallbackValue() {
		return null;
	}
	return fallbackValue;
}
function isRegex(value) {
	try {
		regExpTest(value, "");
		return true;
	} catch (_unused) {
		return false;
	}
}
var html$1 = freeze$1([
	"a",
	"abbr",
	"acronym",
	"address",
	"area",
	"article",
	"aside",
	"audio",
	"b",
	"bdi",
	"bdo",
	"big",
	"blink",
	"blockquote",
	"body",
	"br",
	"button",
	"canvas",
	"caption",
	"center",
	"cite",
	"code",
	"col",
	"colgroup",
	"content",
	"data",
	"datalist",
	"dd",
	"decorator",
	"del",
	"details",
	"dfn",
	"dialog",
	"dir",
	"div",
	"dl",
	"dt",
	"element",
	"em",
	"fieldset",
	"figcaption",
	"figure",
	"font",
	"footer",
	"form",
	"h1",
	"h2",
	"h3",
	"h4",
	"h5",
	"h6",
	"head",
	"header",
	"hgroup",
	"hr",
	"html",
	"i",
	"img",
	"input",
	"ins",
	"kbd",
	"label",
	"legend",
	"li",
	"main",
	"map",
	"mark",
	"marquee",
	"menu",
	"menuitem",
	"meter",
	"nav",
	"nobr",
	"ol",
	"optgroup",
	"option",
	"output",
	"p",
	"picture",
	"pre",
	"progress",
	"q",
	"rp",
	"rt",
	"ruby",
	"s",
	"samp",
	"search",
	"section",
	"select",
	"shadow",
	"slot",
	"small",
	"source",
	"spacer",
	"span",
	"strike",
	"strong",
	"style",
	"sub",
	"summary",
	"sup",
	"table",
	"tbody",
	"td",
	"template",
	"textarea",
	"tfoot",
	"th",
	"thead",
	"time",
	"tr",
	"track",
	"tt",
	"u",
	"ul",
	"var",
	"video",
	"wbr"
]);
var svg$1 = freeze$1([
	"svg",
	"a",
	"altglyph",
	"altglyphdef",
	"altglyphitem",
	"animatecolor",
	"animatemotion",
	"animatetransform",
	"circle",
	"clippath",
	"defs",
	"desc",
	"ellipse",
	"enterkeyhint",
	"exportparts",
	"filter",
	"font",
	"g",
	"glyph",
	"glyphref",
	"hkern",
	"image",
	"inputmode",
	"line",
	"lineargradient",
	"marker",
	"mask",
	"metadata",
	"mpath",
	"part",
	"path",
	"pattern",
	"polygon",
	"polyline",
	"radialgradient",
	"rect",
	"stop",
	"style",
	"switch",
	"symbol",
	"text",
	"textpath",
	"title",
	"tref",
	"tspan",
	"view",
	"vkern"
]);
var svgFilters = freeze$1([
	"feBlend",
	"feColorMatrix",
	"feComponentTransfer",
	"feComposite",
	"feConvolveMatrix",
	"feDiffuseLighting",
	"feDisplacementMap",
	"feDistantLight",
	"feDropShadow",
	"feFlood",
	"feFuncA",
	"feFuncB",
	"feFuncG",
	"feFuncR",
	"feGaussianBlur",
	"feImage",
	"feMerge",
	"feMergeNode",
	"feMorphology",
	"feOffset",
	"fePointLight",
	"feSpecularLighting",
	"feSpotLight",
	"feTile",
	"feTurbulence"
]);
var svgDisallowed = freeze$1([
	"animate",
	"color-profile",
	"cursor",
	"discard",
	"font-face",
	"font-face-format",
	"font-face-name",
	"font-face-src",
	"font-face-uri",
	"foreignobject",
	"hatch",
	"hatchpath",
	"mesh",
	"meshgradient",
	"meshpatch",
	"meshrow",
	"missing-glyph",
	"script",
	"set",
	"solidcolor",
	"unknown",
	"use"
]);
var mathMl$1 = freeze$1([
	"math",
	"menclose",
	"merror",
	"mfenced",
	"mfrac",
	"mglyph",
	"mi",
	"mlabeledtr",
	"mmultiscripts",
	"mn",
	"mo",
	"mover",
	"mpadded",
	"mphantom",
	"mroot",
	"mrow",
	"ms",
	"mspace",
	"msqrt",
	"mstyle",
	"msub",
	"msup",
	"msubsup",
	"mtable",
	"mtd",
	"mtext",
	"mtr",
	"munder",
	"munderover",
	"mprescripts"
]);
var mathMlDisallowed = freeze$1([
	"maction",
	"maligngroup",
	"malignmark",
	"mlongdiv",
	"mscarries",
	"mscarry",
	"msgroup",
	"mstack",
	"msline",
	"msrow",
	"semantics",
	"annotation",
	"annotation-xml",
	"mprescripts",
	"none"
]);
var text = freeze$1(["#text"]);
var html = freeze$1([
	"accept",
	"action",
	"align",
	"alt",
	"autocapitalize",
	"autocomplete",
	"autopictureinpicture",
	"autoplay",
	"background",
	"bgcolor",
	"border",
	"capture",
	"cellpadding",
	"cellspacing",
	"checked",
	"cite",
	"class",
	"clear",
	"color",
	"cols",
	"colspan",
	"command",
	"commandfor",
	"controls",
	"controlslist",
	"coords",
	"crossorigin",
	"datetime",
	"decoding",
	"default",
	"dir",
	"disabled",
	"disablepictureinpicture",
	"disableremoteplayback",
	"download",
	"draggable",
	"enctype",
	"enterkeyhint",
	"exportparts",
	"face",
	"for",
	"headers",
	"height",
	"hidden",
	"high",
	"href",
	"hreflang",
	"id",
	"inert",
	"inputmode",
	"integrity",
	"ismap",
	"kind",
	"label",
	"lang",
	"list",
	"loading",
	"loop",
	"low",
	"max",
	"maxlength",
	"media",
	"method",
	"min",
	"minlength",
	"multiple",
	"muted",
	"name",
	"nonce",
	"noshade",
	"novalidate",
	"nowrap",
	"open",
	"optimum",
	"part",
	"pattern",
	"placeholder",
	"playsinline",
	"popover",
	"popovertarget",
	"popovertargetaction",
	"poster",
	"preload",
	"pubdate",
	"radiogroup",
	"readonly",
	"rel",
	"required",
	"rev",
	"reversed",
	"role",
	"rows",
	"rowspan",
	"spellcheck",
	"scope",
	"selected",
	"shape",
	"size",
	"sizes",
	"slot",
	"span",
	"srclang",
	"start",
	"src",
	"srcset",
	"step",
	"style",
	"summary",
	"tabindex",
	"title",
	"translate",
	"type",
	"usemap",
	"valign",
	"value",
	"width",
	"wrap",
	"xmlns"
]);
var svg = freeze$1([
	"accent-height",
	"accumulate",
	"additive",
	"alignment-baseline",
	"amplitude",
	"ascent",
	"attributename",
	"attributetype",
	"azimuth",
	"basefrequency",
	"baseline-shift",
	"begin",
	"bias",
	"by",
	"class",
	"clip",
	"clippathunits",
	"clip-path",
	"clip-rule",
	"color",
	"color-interpolation",
	"color-interpolation-filters",
	"color-profile",
	"color-rendering",
	"cx",
	"cy",
	"d",
	"dx",
	"dy",
	"diffuseconstant",
	"direction",
	"display",
	"divisor",
	"dominant-baseline",
	"dur",
	"edgemode",
	"elevation",
	"end",
	"exponent",
	"fill",
	"fill-opacity",
	"fill-rule",
	"filter",
	"filterunits",
	"flood-color",
	"flood-opacity",
	"font-family",
	"font-size",
	"font-size-adjust",
	"font-stretch",
	"font-style",
	"font-variant",
	"font-weight",
	"fx",
	"fy",
	"g1",
	"g2",
	"glyph-name",
	"glyphref",
	"gradientunits",
	"gradienttransform",
	"height",
	"href",
	"id",
	"image-rendering",
	"in",
	"in2",
	"intercept",
	"k",
	"k1",
	"k2",
	"k3",
	"k4",
	"kerning",
	"keypoints",
	"keysplines",
	"keytimes",
	"lang",
	"lengthadjust",
	"letter-spacing",
	"kernelmatrix",
	"kernelunitlength",
	"lighting-color",
	"local",
	"marker-end",
	"marker-mid",
	"marker-start",
	"markerheight",
	"markerunits",
	"markerwidth",
	"maskcontentunits",
	"maskunits",
	"max",
	"mask",
	"mask-type",
	"media",
	"method",
	"mode",
	"min",
	"name",
	"numoctaves",
	"offset",
	"operator",
	"opacity",
	"order",
	"orient",
	"orientation",
	"origin",
	"overflow",
	"paint-order",
	"path",
	"pathlength",
	"patterncontentunits",
	"patterntransform",
	"patternunits",
	"pointer-events",
	"points",
	"preservealpha",
	"preserveaspectratio",
	"primitiveunits",
	"r",
	"rx",
	"ry",
	"radius",
	"refx",
	"refy",
	"repeatcount",
	"repeatdur",
	"restart",
	"result",
	"rotate",
	"scale",
	"seed",
	"shape-rendering",
	"slope",
	"specularconstant",
	"specularexponent",
	"spreadmethod",
	"startoffset",
	"stddeviation",
	"stitchtiles",
	"stop-color",
	"stop-opacity",
	"stroke-dasharray",
	"stroke-dashoffset",
	"stroke-linecap",
	"stroke-linejoin",
	"stroke-miterlimit",
	"stroke-opacity",
	"stroke",
	"stroke-width",
	"style",
	"surfacescale",
	"systemlanguage",
	"tabindex",
	"tablevalues",
	"targetx",
	"targety",
	"transform",
	"transform-origin",
	"text-anchor",
	"text-decoration",
	"text-orientation",
	"text-rendering",
	"textlength",
	"type",
	"u1",
	"u2",
	"unicode",
	"values",
	"vector-effect",
	"viewbox",
	"visibility",
	"version",
	"vert-adv-y",
	"vert-origin-x",
	"vert-origin-y",
	"width",
	"word-spacing",
	"wrap",
	"writing-mode",
	"xchannelselector",
	"ychannelselector",
	"x",
	"x1",
	"x2",
	"xmlns",
	"y",
	"y1",
	"y2",
	"z",
	"zoomandpan"
]);
var mathMl = freeze$1([
	"accent",
	"accentunder",
	"align",
	"bevelled",
	"close",
	"columnalign",
	"columnlines",
	"columnspacing",
	"columnspan",
	"denomalign",
	"depth",
	"dir",
	"display",
	"displaystyle",
	"encoding",
	"fence",
	"frame",
	"height",
	"href",
	"id",
	"largeop",
	"length",
	"linethickness",
	"lquote",
	"lspace",
	"mathbackground",
	"mathcolor",
	"mathsize",
	"mathvariant",
	"maxsize",
	"minsize",
	"movablelimits",
	"notation",
	"numalign",
	"open",
	"rowalign",
	"rowlines",
	"rowspacing",
	"rowspan",
	"rspace",
	"rquote",
	"scriptlevel",
	"scriptminsize",
	"scriptsizemultiplier",
	"selection",
	"separator",
	"separators",
	"stretchy",
	"subscriptshift",
	"supscriptshift",
	"symmetric",
	"voffset",
	"width",
	"xmlns"
]);
var xml = freeze$1([
	"xlink:href",
	"xml:id",
	"xlink:title",
	"xml:space",
	"xmlns:xlink"
]);
var MUSTACHE_EXPR = seal(/{{[\w\W]*|^[\w\W]*}}/g);
var ERB_EXPR = seal(/<%[\w\W]*|^[\w\W]*%>/g);
var TMPLIT_EXPR = seal(/\${[\w\W]*/g);
var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/);
var ARIA_ATTR = seal(/^aria-[\-\w]+$/);
var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i);
var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g);
var DOCTYPE_NAME = seal(/^html$/i);
var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
var ELEMENT_MARKUP_PROBE = seal(/<[/\w!]/g);
var COMMENT_MARKUP_PROBE = seal(/<[/\w]/g);
var FALLBACK_TAG_CLOSE = seal(/<\/no(script|embed|frames)/i);
var SELF_CLOSING_TAG = seal(/\/>/i);
var NODE_TYPE = {
	element: 1,
	attribute: 2,
	text: 3,
	cdataSection: 4,
	entityReference: 5,
	entityNode: 6,
	processingInstruction: 7,
	comment: 8,
	document: 9,
	documentType: 10,
	documentFragment: 11,
	notation: 12
};
var LITERAL_TEXT_ELEMENT_NAMES = [
	"style",
	"script",
	"xmp",
	"iframe",
	"noembed",
	"noframes",
	"plaintext",
	"noscript"
];
var LITERAL_TEXT_ELEMENTS = freeze$1(addToSet({}, LITERAL_TEXT_ELEMENT_NAMES));
var LITERAL_TEXT_CLOSE = function() {
	const map = {};
	arrayForEach(LITERAL_TEXT_ELEMENT_NAMES, (name) => {
		map[name] = seal(new RegExp("</" + name + "(?=[\\t\\n\\f\\r />])", "i"));
	});
	return freeze$1(map);
}();
var getGlobal = function getGlobal() {
	return typeof window === "undefined" ? null : window;
};
/**
* Creates a no-op policy for internal use only.
* Don't export this function outside this module!
* @param trustedTypes The policy factory.
* @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
* @return The policy created (or null, if Trusted Types
* are not supported or creating the policy failed).
*/
var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
	if (typeof trustedTypes !== "object" || typeof trustedTypes.createPolicy !== "function") return null;
	let suffix = null;
	const ATTR_NAME = "data-tt-policy-suffix";
	if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
	const policyName = "dompurify" + (suffix ? "#" + suffix : "");
	try {
		return trustedTypes.createPolicy(policyName, {
			createHTML(html) {
				return html;
			},
			createScriptURL(scriptUrl) {
				return scriptUrl;
			}
		});
	} catch (_) {
		console.warn("TrustedTypes policy " + policyName + " could not be created.");
		return null;
	}
};
var _createHooksMap = function _createHooksMap() {
	return {
		afterSanitizeAttributes: [],
		afterSanitizeElements: [],
		afterSanitizeShadowDOM: [],
		beforeSanitizeAttributes: [],
		beforeSanitizeElements: [],
		beforeSanitizeShadowDOM: [],
		uponSanitizeAttribute: [],
		uponSanitizeElement: [],
		uponSanitizeShadowNode: []
	};
};
/**
* Resolve a set-valued configuration option: a fresh set built from
* cfg[key] when it is an own array property (seeded with a clone of
* options.base when given, case-normalized via options.transform),
* the fallback set otherwise.
*
* @param cfg the cloned, prototype-free configuration object
* @param key the configuration property to read
* @param fallback the set to use when the option is absent or not an array
* @param options transform and optional base set to merge into
* @returns the resolved set
*/
var _resolveSetOption = function _resolveSetOption(cfg, key, fallback, options) {
	return objectHasOwnProperty(cfg, key) && arrayIsArray(cfg[key]) ? addToSet(options.base ? clone(options.base) : {}, cfg[key], options.transform) : fallback;
};
/**
* Resolve an object-valued configuration option: a prototype-free clone
* of cfg[key] when it is an own, truthy object property, else a fresh
* fallback built by makeFallback (fresh on every parse, so a previous
* parse can never leak state into the next one).
*
* @param cfg the cloned, prototype-free configuration object
* @param key the configuration property to read
* @param makeFallback builds the fallback value when the option is absent
* @returns the resolved object
*/
var _resolveObjectOption = function _resolveObjectOption(cfg, key, makeFallback) {
	const value = objectHasOwnProperty(cfg, key) ? cfg[key] : void 0;
	return value && typeof value === "object" ? clone(value) : makeFallback();
};
function createDOMPurify() {
	let window = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getGlobal();
	const DOMPurify = (root) => createDOMPurify(root);
	DOMPurify.version = "3.4.15";
	DOMPurify.removed = [];
	if (!window || !window.document || window.document.nodeType !== NODE_TYPE.document || !window.Element) {
		DOMPurify.isSupported = false;
		return DOMPurify;
	}
	let document = window.document;
	const originalDocument = document;
	const currentScript = originalDocument.currentScript;
	window.DocumentFragment;
	const HTMLTemplateElement = window.HTMLTemplateElement, Node = window.Node, Element = window.Element, NodeFilter = window.NodeFilter;
	window.NamedNodeMap === void 0 && (window.NamedNodeMap || window.MozNamedAttrMap);
	window.HTMLFormElement;
	const DOMParser = window.DOMParser, trustedTypes = window.trustedTypes;
	const ElementPrototype = Element.prototype;
	const cloneNode = lookupGetter(ElementPrototype, "cloneNode");
	const remove = lookupGetter(ElementPrototype, "remove");
	const removeAttributeNode = lookupGetter(ElementPrototype, "removeAttributeNode");
	const getNextSibling = lookupGetter(ElementPrototype, "nextSibling");
	const getChildNodes = lookupGetter(ElementPrototype, "childNodes");
	const getParentNode = lookupGetter(ElementPrototype, "parentNode");
	const getShadowRoot = lookupGetter(ElementPrototype, "shadowRoot");
	const getAttributes = lookupGetter(ElementPrototype, "attributes");
	const getNodeType = Node && Node.prototype ? lookupGetter(Node.prototype, "nodeType") : null;
	const getNodeName = Node && Node.prototype ? lookupGetter(Node.prototype, "nodeName") : null;
	const getOwnerDocument = Node && Node.prototype ? lookupGetter(Node.prototype, "ownerDocument") : null;
	const _readNodeType = function _readNodeType(node) {
		return getNodeType ? getNodeType(node) : node.nodeType;
	};
	const _readNodeName = function _readNodeName(node) {
		return getNodeName ? getNodeName(node) : node.nodeName;
	};
	if (typeof HTMLTemplateElement === "function") {
		const template = document.createElement("template");
		if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
	}
	let trustedTypesPolicy;
	let emptyHTML = "";
	let defaultTrustedTypesPolicy;
	let defaultTrustedTypesPolicyResolved = false;
	let IN_TRUSTED_TYPES_POLICY = 0;
	const _assertNotInTrustedTypesPolicy = function _assertNotInTrustedTypesPolicy() {
		if (IN_TRUSTED_TYPES_POLICY > 0) throw typeErrorCreate("A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the \"DOMPurify and Trusted Types\" section of the README.");
	};
	const _createTrustedHTML = function _createTrustedHTML(html) {
		_assertNotInTrustedTypesPolicy();
		IN_TRUSTED_TYPES_POLICY++;
		try {
			return trustedTypesPolicy.createHTML(html);
		} finally {
			IN_TRUSTED_TYPES_POLICY--;
		}
	};
	const _createTrustedScriptURL = function _createTrustedScriptURL(scriptUrl) {
		_assertNotInTrustedTypesPolicy();
		IN_TRUSTED_TYPES_POLICY++;
		try {
			return trustedTypesPolicy.createScriptURL(scriptUrl);
		} finally {
			IN_TRUSTED_TYPES_POLICY--;
		}
	};
	const _getDefaultTrustedTypesPolicy = function _getDefaultTrustedTypesPolicy() {
		if (!defaultTrustedTypesPolicyResolved) {
			defaultTrustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
			defaultTrustedTypesPolicyResolved = true;
		}
		return defaultTrustedTypesPolicy;
	};
	const _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
	const importNode = originalDocument.importNode;
	let hooks = _createHooksMap();
	/**
	* Expose whether this browser supports running the full DOMPurify.
	*/
	DOMPurify.isSupported = typeof entries === "function" && typeof getParentNode === "function" && implementation && implementation.createHTMLDocument !== void 0;
	const MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
	let IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
	/**
	* We consider the elements and attributes below to be safe. Ideally
	* don't add any new ones but feel free to remove unwanted ones.
	*/
	let ALLOWED_TAGS = null;
	const DEFAULT_ALLOWED_TAGS = addToSet({}, [
		...html$1,
		...svg$1,
		...svgFilters,
		...mathMl$1,
		...text
	]);
	let ALLOWED_ATTR = null;
	const DEFAULT_ALLOWED_ATTR = addToSet({}, [
		...html,
		...svg,
		...mathMl,
		...xml
	]);
	let CUSTOM_ELEMENT_HANDLING = Object.seal(create$1(null, {
		tagNameCheck: {
			writable: true,
			configurable: false,
			enumerable: true,
			value: null
		},
		attributeNameCheck: {
			writable: true,
			configurable: false,
			enumerable: true,
			value: null
		},
		allowCustomizedBuiltInElements: {
			writable: true,
			configurable: false,
			enumerable: true,
			value: false
		}
	}));
	let FORBID_TAGS = null;
	let FORBID_ATTR = null;
	const EXTRA_ELEMENT_HANDLING = Object.seal(create$1(null, {
		tagCheck: {
			writable: true,
			configurable: false,
			enumerable: true,
			value: null
		},
		attributeCheck: {
			writable: true,
			configurable: false,
			enumerable: true,
			value: null
		}
	}));
	let ALLOW_ARIA_ATTR = true;
	let ALLOW_DATA_ATTR = true;
	let ALLOW_UNKNOWN_PROTOCOLS = false;
	let ALLOW_SELF_CLOSE_IN_ATTR = true;
	let SAFE_FOR_TEMPLATES = false;
	let SAFE_FOR_XML = true;
	let WHOLE_DOCUMENT = false;
	let SET_CONFIG = false;
	let SET_CONFIG_ALLOWED_TAGS = null;
	let SET_CONFIG_ALLOWED_ATTR = null;
	let FORCE_BODY = false;
	let RETURN_DOM = false;
	let RETURN_DOM_FRAGMENT = false;
	let RETURN_TRUSTED_TYPE = false;
	let SANITIZE_DOM = true;
	let SANITIZE_NAMED_PROPS = false;
	const SANITIZE_NAMED_PROPS_PREFIX = "user-content-";
	let KEEP_CONTENT = true;
	let IN_PLACE = false;
	let USE_PROFILES = {};
	let FORBID_CONTENTS = null;
	const DEFAULT_FORBID_CONTENTS = addToSet({}, [
		"annotation-xml",
		"audio",
		"colgroup",
		"desc",
		"foreignobject",
		"head",
		"iframe",
		"math",
		"mi",
		"mn",
		"mo",
		"ms",
		"mtext",
		"noembed",
		"noframes",
		"noscript",
		"plaintext",
		"script",
		"selectedcontent",
		"style",
		"svg",
		"template",
		"thead",
		"title",
		"video",
		"xmp"
	]);
	let DATA_URI_TAGS = null;
	const DEFAULT_DATA_URI_TAGS = addToSet({}, [
		"audio",
		"video",
		"img",
		"source",
		"image",
		"track"
	]);
	let URI_SAFE_ATTRIBUTES = null;
	const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
		"alt",
		"class",
		"for",
		"id",
		"label",
		"name",
		"pattern",
		"placeholder",
		"role",
		"summary",
		"title",
		"value",
		"style",
		"xmlns"
	]);
	const MATHML_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
	const SVG_NAMESPACE = "http://www.w3.org/2000/svg";
	const HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
	let NAMESPACE = HTML_NAMESPACE;
	let IS_EMPTY_INPUT = false;
	let ALLOWED_NAMESPACES = null;
	const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
		MATHML_NAMESPACE,
		SVG_NAMESPACE,
		HTML_NAMESPACE
	], stringToString);
	const DEFAULT_MATHML_TEXT_INTEGRATION_POINTS = freeze$1([
		"mi",
		"mo",
		"mn",
		"ms",
		"mtext"
	]);
	let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, DEFAULT_MATHML_TEXT_INTEGRATION_POINTS);
	const DEFAULT_HTML_INTEGRATION_POINTS = freeze$1(["annotation-xml"]);
	let HTML_INTEGRATION_POINTS = addToSet({}, DEFAULT_HTML_INTEGRATION_POINTS);
	const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
		"title",
		"style",
		"font",
		"a",
		"script"
	]);
	let PARSER_MEDIA_TYPE = null;
	const SUPPORTED_PARSER_MEDIA_TYPES = ["application/xhtml+xml", "text/html"];
	const DEFAULT_PARSER_MEDIA_TYPE = "text/html";
	let transformCaseFunc = null;
	let CONFIG = null;
	const formElement = document.createElement("form");
	const isRegexOrFunction = function isRegexOrFunction(testValue) {
		return testValue instanceof RegExp || testValue instanceof Function;
	};
	/**
	* _parseConfig
	*
	* @param cfg optional config literal
	*/
	const _parseConfig = function _parseConfig() {
		let cfg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		if (CONFIG && CONFIG === cfg) return;
		if (!cfg || typeof cfg !== "object") cfg = {};
		cfg = clone(cfg);
		PARSER_MEDIA_TYPE = SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
		transformCaseFunc = PARSER_MEDIA_TYPE === "application/xhtml+xml" ? stringToString : stringToLowerCase;
		ALLOWED_TAGS = _resolveSetOption(cfg, "ALLOWED_TAGS", DEFAULT_ALLOWED_TAGS, { transform: transformCaseFunc });
		ALLOWED_ATTR = _resolveSetOption(cfg, "ALLOWED_ATTR", DEFAULT_ALLOWED_ATTR, { transform: transformCaseFunc });
		ALLOWED_NAMESPACES = _resolveSetOption(cfg, "ALLOWED_NAMESPACES", DEFAULT_ALLOWED_NAMESPACES, { transform: stringToString });
		URI_SAFE_ATTRIBUTES = _resolveSetOption(cfg, "ADD_URI_SAFE_ATTR", DEFAULT_URI_SAFE_ATTRIBUTES, {
			transform: transformCaseFunc,
			base: DEFAULT_URI_SAFE_ATTRIBUTES
		});
		DATA_URI_TAGS = _resolveSetOption(cfg, "ADD_DATA_URI_TAGS", DEFAULT_DATA_URI_TAGS, {
			transform: transformCaseFunc,
			base: DEFAULT_DATA_URI_TAGS
		});
		FORBID_CONTENTS = _resolveSetOption(cfg, "FORBID_CONTENTS", DEFAULT_FORBID_CONTENTS, { transform: transformCaseFunc });
		FORBID_TAGS = _resolveSetOption(cfg, "FORBID_TAGS", clone({}), { transform: transformCaseFunc });
		FORBID_ATTR = _resolveSetOption(cfg, "FORBID_ATTR", clone({}), { transform: transformCaseFunc });
		USE_PROFILES = objectHasOwnProperty(cfg, "USE_PROFILES") ? cfg.USE_PROFILES && typeof cfg.USE_PROFILES === "object" ? clone(cfg.USE_PROFILES) : cfg.USE_PROFILES : false;
		ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false;
		ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false;
		ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false;
		ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false;
		SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false;
		SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false;
		WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false;
		RETURN_DOM = cfg.RETURN_DOM || false;
		RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false;
		RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false;
		FORCE_BODY = cfg.FORCE_BODY || false;
		SANITIZE_DOM = cfg.SANITIZE_DOM !== false;
		SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false;
		KEEP_CONTENT = cfg.KEEP_CONTENT !== false;
		IN_PLACE = cfg.IN_PLACE || false;
		IS_ALLOWED_URI$1 = isRegex(cfg.ALLOWED_URI_REGEXP) ? cfg.ALLOWED_URI_REGEXP : IS_ALLOWED_URI;
		NAMESPACE = typeof cfg.NAMESPACE === "string" ? cfg.NAMESPACE : HTML_NAMESPACE;
		MATHML_TEXT_INTEGRATION_POINTS = _resolveObjectOption(cfg, "MATHML_TEXT_INTEGRATION_POINTS", () => addToSet({}, DEFAULT_MATHML_TEXT_INTEGRATION_POINTS));
		HTML_INTEGRATION_POINTS = _resolveObjectOption(cfg, "HTML_INTEGRATION_POINTS", () => addToSet({}, DEFAULT_HTML_INTEGRATION_POINTS));
		const customElementHandling = _resolveObjectOption(cfg, "CUSTOM_ELEMENT_HANDLING", () => create$1(null));
		CUSTOM_ELEMENT_HANDLING = create$1(null);
		if (objectHasOwnProperty(customElementHandling, "tagNameCheck") && isRegexOrFunction(customElementHandling.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = customElementHandling.tagNameCheck;
		if (objectHasOwnProperty(customElementHandling, "attributeNameCheck") && isRegexOrFunction(customElementHandling.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = customElementHandling.attributeNameCheck;
		if (objectHasOwnProperty(customElementHandling, "allowCustomizedBuiltInElements") && typeof customElementHandling.allowCustomizedBuiltInElements === "boolean") CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = customElementHandling.allowCustomizedBuiltInElements;
		seal(CUSTOM_ELEMENT_HANDLING);
		if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
		if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
		if (USE_PROFILES) {
			ALLOWED_TAGS = addToSet({}, text);
			ALLOWED_ATTR = create$1(null);
			if (USE_PROFILES.html === true) {
				addToSet(ALLOWED_TAGS, html$1);
				addToSet(ALLOWED_ATTR, html);
			}
			if (USE_PROFILES.svg === true) {
				addToSet(ALLOWED_TAGS, svg$1);
				addToSet(ALLOWED_ATTR, svg);
				addToSet(ALLOWED_ATTR, xml);
			}
			if (USE_PROFILES.svgFilters === true) {
				addToSet(ALLOWED_TAGS, svgFilters);
				addToSet(ALLOWED_ATTR, svg);
				addToSet(ALLOWED_ATTR, xml);
			}
			if (USE_PROFILES.mathMl === true) {
				addToSet(ALLOWED_TAGS, mathMl$1);
				addToSet(ALLOWED_ATTR, mathMl);
				addToSet(ALLOWED_ATTR, xml);
			}
		}
		EXTRA_ELEMENT_HANDLING.tagCheck = null;
		EXTRA_ELEMENT_HANDLING.attributeCheck = null;
		if (objectHasOwnProperty(cfg, "ADD_TAGS")) {
			if (typeof cfg.ADD_TAGS === "function") EXTRA_ELEMENT_HANDLING.tagCheck = cfg.ADD_TAGS;
			else if (arrayIsArray(cfg.ADD_TAGS)) {
				if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
				addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
			}
		}
		if (objectHasOwnProperty(cfg, "ADD_ATTR")) {
			if (typeof cfg.ADD_ATTR === "function") EXTRA_ELEMENT_HANDLING.attributeCheck = cfg.ADD_ATTR;
			else if (arrayIsArray(cfg.ADD_ATTR)) {
				if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
				addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
			}
		}
		if (objectHasOwnProperty(cfg, "ADD_FORBID_CONTENTS") && arrayIsArray(cfg.ADD_FORBID_CONTENTS)) {
			if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
			addToSet(FORBID_CONTENTS, cfg.ADD_FORBID_CONTENTS, transformCaseFunc);
		}
		if (KEEP_CONTENT) ALLOWED_TAGS["#text"] = true;
		if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
			"html",
			"head",
			"body"
		]);
		if (ALLOWED_TAGS.table) {
			addToSet(ALLOWED_TAGS, ["tbody"]);
			delete FORBID_TAGS.tbody;
		}
		if (cfg.TRUSTED_TYPES_POLICY) {
			if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== "function") throw typeErrorCreate("TRUSTED_TYPES_POLICY configuration option must provide a \"createHTML\" hook.");
			if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== "function") throw typeErrorCreate("TRUSTED_TYPES_POLICY configuration option must provide a \"createScriptURL\" hook.");
			const previousTrustedTypesPolicy = trustedTypesPolicy;
			trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
			try {
				emptyHTML = _createTrustedHTML("");
			} catch (error) {
				trustedTypesPolicy = previousTrustedTypesPolicy;
				throw error;
			}
		} else if (cfg.TRUSTED_TYPES_POLICY === null) {
			trustedTypesPolicy = void 0;
			emptyHTML = "";
		} else {
			if (trustedTypesPolicy === void 0) trustedTypesPolicy = _getDefaultTrustedTypesPolicy();
			if (trustedTypesPolicy && typeof emptyHTML === "string") emptyHTML = _createTrustedHTML("");
		}
		if (freeze$1) freeze$1(cfg);
		CONFIG = cfg;
	};
	const ALL_SVG_TAGS = addToSet({}, [
		...svg$1,
		...svgFilters,
		...svgDisallowed
	]);
	const ALL_MATHML_TAGS = addToSet({}, [...mathMl$1, ...mathMlDisallowed]);
	/**
	* Namespace rules for an element in the SVG namespace.
	*
	* @param tagName the element's lowercase tag name
	* @param parent the (possibly simulated) parent node
	* @param parentTagName the parent's lowercase tag name
	* @returns true if a spec-compliant parser could produce this element
	*/
	const _checkSvgNamespace = function _checkSvgNamespace(tagName, parent, parentTagName) {
		if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "svg";
		if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === "svg" && (parentTagName === "annotation-xml" || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
		return Boolean(ALL_SVG_TAGS[tagName]);
	};
	/**
	* Namespace rules for an element in the MathML namespace.
	*
	* @param tagName the element's lowercase tag name
	* @param parent the (possibly simulated) parent node
	* @param parentTagName the parent's lowercase tag name
	* @returns true if a spec-compliant parser could produce this element
	*/
	const _checkMathMlNamespace = function _checkMathMlNamespace(tagName, parent, parentTagName) {
		if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "math";
		if (parent.namespaceURI === SVG_NAMESPACE) return tagName === "math" && HTML_INTEGRATION_POINTS[parentTagName];
		return Boolean(ALL_MATHML_TAGS[tagName]);
	};
	/**
	* Namespace rules for an element in the HTML namespace.
	*
	* @param tagName the element's lowercase tag name
	* @param parent the (possibly simulated) parent node
	* @param parentTagName the parent's lowercase tag name
	* @returns true if a spec-compliant parser could produce this element
	*/
	const _checkHtmlNamespace = function _checkHtmlNamespace(tagName, parent, parentTagName) {
		if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
		if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
		return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
	};
	/**
	* @param element a DOM element whose namespace is being checked
	* @returns Return false if the element has a
	*  namespace that a spec-compliant parser would never
	*  return. Return true otherwise.
	*/
	const _checkValidNamespace = function _checkValidNamespace(element) {
		let parent = getParentNode(element);
		if (!parent || !parent.tagName) parent = {
			namespaceURI: NAMESPACE,
			tagName: "template"
		};
		const tagName = stringToLowerCase(element.tagName);
		const parentTagName = stringToLowerCase(parent.tagName);
		if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
		if (element.namespaceURI === SVG_NAMESPACE) return _checkSvgNamespace(tagName, parent, parentTagName);
		if (element.namespaceURI === MATHML_NAMESPACE) return _checkMathMlNamespace(tagName, parent, parentTagName);
		if (element.namespaceURI === HTML_NAMESPACE) return _checkHtmlNamespace(tagName, parent, parentTagName);
		if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
		return false;
	};
	/**
	* _forceRemove
	*
	* @param node a DOM node
	*/
	const _forceRemove = function _forceRemove(node) {
		arrayPush(DOMPurify.removed, { element: node });
		try {
			getParentNode(node).removeChild(node);
		} catch (_) {
			remove(node);
			if (!getParentNode(node)) throw typeErrorCreate("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
		}
	};
	/**
	* _stripAttributeNode
	*
	* Remove a single Attr node case/namespace-exactly on an attribute-teardown
	* path. Name-based removeAttribute() ASCII-lowercases its lookup key for an
	* HTML element in an HTML document and so silently misses a case-preserved
	* handler (e.g. `ONERROR` off an XML/XHTML import) - the same defect
	* _removeAttribute() was fixed for, which a name-based call would reintroduce
	* on these IN_PLACE teardown paths. Unlike _removeAttribute this does not
	* record into DOMPurify.removed: the neutralize passes intentionally do not
	* book-keep. A clobbered/detached node falls back to best-effort name-based
	* removal.
	*
	* @param element the element to strip the attribute from
	* @param attribute the Attr node to remove
	* @param name the attribute's name, for the fallback path
	*/
	const _stripAttributeNode = function _stripAttributeNode(element, attribute, name) {
		try {
			removeAttributeNode(element, attribute);
		} catch (_) {
			try {
				element.removeAttribute(name);
			} catch (_) {}
		}
	};
	/**
	* _neutralizeRoot
	*
	* Fail-closed teardown of an in-place root after the sanitize walk aborts
	* (campaign-3 F2). An internal throw mid-walk — e.g. a page-registered
	* custom element's reaction detaches a node so `_forceRemove`'s deliberate
	* parentless guard throws, or any other re-entrant engine mutation — would
	* otherwise leave the caller's *live* tree half-sanitized, with everything
	* after the abort point still carrying its handlers. There is no safe way
	* to resume the walk (the tree mutated under us), so we strip the root bare:
	* remove every child and every attribute, then let the caller's catch see
	* the original error. Clobber-safe (cached `remove`/`childNodes`/`attributes`
	* getters; the root was already clobber-pre-flighted at the IN_PLACE entry).
	*
	* @param root the in-place root to empty
	*/
	const _neutralizeRoot = function _neutralizeRoot(root) {
		_neutralizeSubtree(root);
		const childNodes = getChildNodes(root);
		if (childNodes) {
			const snapshot = [];
			arrayForEach(childNodes, (child) => {
				arrayPush(snapshot, child);
			});
			arrayForEach(snapshot, (child) => {
				try {
					remove(child);
				} catch (_) {}
			});
		}
		const attributes = getAttributes(root);
		if (attributes) for (let i = attributes.length - 1; i >= 0; --i) {
			const attribute = attributes[i];
			const name = attribute && attribute.name;
			if (typeof name === "string") _stripAttributeNode(root, attribute, name);
		}
	};
	/**
	* _removeAttribute
	*
	* Name-based getAttributeNode()/removeAttribute() ASCII-lowercase their
	* lookup key for HTML elements in an HTML document, so they silently miss an
	* attribute whose stored qualified name still contains uppercase ASCII
	* letters. That happens when the node came from a case-preserving source
	* (an XML/XHTML document imported via importNode(), or createAttributeNS()),
	* where e.g. `ONERROR` survives the walk: the policy check lowercases to
	* `onerror` and rejects it, but `removeAttribute('ONERROR')` looks up
	* `onerror` and finds nothing. Remove the exact Attr node instead, which is
	* case- and namespace-exact, and fall back to name-based removal only when
	* the caller could not supply the node.
	*
	* @param name an Attribute name
	* @param element a DOM node
	* @param attr the exact Attr node to remove, when the caller has it
	*/
	const _removeAttribute = function _removeAttribute(name, element, attr) {
		if (!attr) try {
			attr = element.getAttributeNode(name);
		} catch (_) {
			attr = null;
		}
		arrayPush(DOMPurify.removed, {
			attribute: attr || null,
			from: element
		});
		try {
			if (attr) removeAttributeNode(element, attr);
			else element.removeAttribute(name);
		} catch (_) {
			try {
				element.removeAttribute(name);
			} catch (_) {}
		}
		if (name === "is") {
			if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
				_forceRemove(element);
			} catch (_) {}
			else try {
				element.setAttribute(name, "");
			} catch (_) {}
		}
	};
	/**
	* _stripDisallowedAttributes
	*
	* Removes every attribute the active configuration does not allow from a
	* single element, using the same allowlist as the main attribute pass (so
	* `on*` handlers go, but no `/^on/` blocklist is introduced). Used only to
	* neutralise nodes that are being discarded from an in-place tree.
	*
	* @param element the element to strip
	*/
	const _stripDisallowedAttributes = function _stripDisallowedAttributes(element) {
		const attributes = getAttributes(element);
		if (!attributes) return;
		for (let i = attributes.length - 1; i >= 0; --i) {
			const attribute = attributes[i];
			const name = attribute && attribute.name;
			if (typeof name !== "string" || ALLOWED_ATTR[transformCaseFunc(name)]) continue;
			_stripAttributeNode(element, attribute, name);
		}
	};
	/**
	* _neutralizeSubtree
	*
	* Completes the audit-5 F1 fix across every removal path. The KEEP_CONTENT
	* move-hoist neutralises only disallowed-tag removals; clobber, mXSS-canary,
	* namespace, comment, processing-instruction and KEEP_CONTENT:false removals
	* all drop their subtree wholesale via `_forceRemove`. On the IN_PLACE path
	* those dropped nodes are detached from the caller's LIVE tree but a
	* handler-bearing original among them (an `<img onerror>`/`<video>` that was
	* loading) keeps its queued resource event, which fires in page scope after
	* sanitize returns. This walks a removed subtree and strips every attribute
	* the active configuration does not allow — so `on*` handlers are cancelled
	* through the SAME allowlist that governs kept nodes, not a separate `/^on/`
	* blocklist. Run synchronously before sanitize returns, i.e. before any
	* queued event can fire. Hook-free by design: these nodes leave the output,
	* so firing attribute hooks for them would be surprising. Clobber-safe reads;
	* a doomed clobbered node may shadow `removeAttribute` (its own attributes are
	* irrelevant — it is discarded — while its non-clobbered descendants, e.g.
	* the `<img>`, are reached and scrubbed).
	*
	* @param root the root of a removed subtree to neutralise
	*/
	const _neutralizeSubtree = function _neutralizeSubtree(root) {
		const stack = [root];
		while (stack.length > 0) {
			const node = stack.pop();
			if (_readNodeType(node) === NODE_TYPE.element) _stripDisallowedAttributes(node);
			const childNodes = getChildNodes(node);
			if (childNodes) for (let i = childNodes.length - 1; i >= 0; --i) stack.push(childNodes[i]);
		}
	};
	/**
	* _neutralizePatchLinkage
	*
	* IN_PLACE entry pre-pass (declarative-partial-updates / streaming
	* hardening, https://github.com/WICG/declarative-partial-updates).
	*
	* The main walk strips patch linkage (`for`/`patchsrc`) and removes range
	* markers (PIs / markup comments) node-by-node, in document order, AS it
	* reaches each node. On a live in-place root that leaves a window: from the
	* moment the root is connected until the walk arrives at a given node, that
	* node's linkage is live. A patch applied on connection/stream can fire as
	* a microtask during the walk and inject or teleport an unsanitized DOM
	* range into a region the iterator has already passed and will not revisit,
	* so the post-return "tree is sanitized" contract is violated. Sweep the
	* whole tree once up front and sever every linkage before the walk begins,
	* closing that window.
	*
	* This CANNOT undo a patch that already fired before sanitize ran — that is
	* the irreducible "do not IN_PLACE a live-connected attacker tree" caveat —
	* but it closes everything from sanitize-start onward. Gated on SAFE_FOR_XML
	* to group with the rest of the declarative-partial-updates handling and
	* stay overridable, consistent with the codebase.
	*
	* Clobber-safe traversal (cached childNodes getter); per-node try/catch so a
	* clobbered root cannot defeat the sweep of its non-clobbered descendants.
	*
	* NOTE (pending real-Chrome confirmation, see test/declarative-patch-probe
	* .html Q1): this mirrors the existing policy of keeping `for` on
	* <label>/<output>. If the shipping feature can drive a patch through a
	* surviving `for`-on-label/output + `id` pair, this pre-pass and the
	* attribute check at _isBasicCustomElement's caller must additionally drop
	* that pair on the IN_PLACE path. Left as-is until the taxonomy is verified.
	*
	* @param root the in-place root to sweep
	*/
	/**
	* Central policy for declarative-partial-updates patch-linkage attributes,
	* shared by the _neutralizePatchLinkage pre-pass and _isValidAttribute so
	* the two sites cannot drift: `patchsrc` always links, `for` links
	* everywhere except on <label>/<output>, and the whole policy is gated on
	* SAFE_FOR_XML (see the rationale block in _isValidAttribute).
	*
	* @param lcName the transformCaseFunc'd attribute name
	* @param lcTag the transformCaseFunc'd tag name of the carrying element
	* @return true if the attribute is patch linkage and must be dropped
	*/
	const _isPatchLinkageAttribute = function _isPatchLinkageAttribute(lcName, lcTag) {
		if (!SAFE_FOR_XML) return false;
		if (lcName === "patchsrc") return true;
		return lcName === "for" && lcTag !== "label" && lcTag !== "output";
	};
	const _neutralizePatchLinkage = function _neutralizePatchLinkage(root) {
		if (!SAFE_FOR_XML) return;
		const stack = [root];
		while (stack.length > 0) {
			const node = stack.pop();
			const nodeType = _readNodeType(node);
			if (nodeType === NODE_TYPE.processingInstruction || nodeType === NODE_TYPE.comment && regExpTest(COMMENT_MARKUP_PROBE, node.data)) {
				try {
					remove(node);
				} catch (_) {}
				continue;
			}
			if (nodeType === NODE_TYPE.element) {
				const element = node;
				const lcTag = transformCaseFunc(_readNodeName(node));
				try {
					if (element.hasAttribute && element.hasAttribute("patchsrc")) element.removeAttribute("patchsrc");
					if (element.hasAttribute && element.hasAttribute("for") && _isPatchLinkageAttribute("for", lcTag)) element.removeAttribute("for");
				} catch (_) {}
			}
			const childNodes = getChildNodes(node);
			if (childNodes) for (let i = childNodes.length - 1; i >= 0; --i) stack.push(childNodes[i]);
		}
	};
	/**
	* _initDocument
	*
	* @param dirty - a string of dirty markup
	* @return a DOM, filled with the dirty markup
	*/
	const _initDocument = function _initDocument(dirty) {
		let doc = null;
		let leadingWhitespace = null;
		if (FORCE_BODY) dirty = "<remove></remove>" + dirty;
		else {
			const matches = stringMatch(dirty, /^[\r\n\t ]+/);
			leadingWhitespace = matches && matches[0];
		}
		if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && NAMESPACE === HTML_NAMESPACE) dirty = "<html xmlns=\"http://www.w3.org/1999/xhtml\"><head></head><body>" + dirty + "</body></html>";
		const dirtyPayload = trustedTypesPolicy ? _createTrustedHTML(dirty) : dirty;
		if (NAMESPACE === HTML_NAMESPACE) try {
			doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
		} catch (_) {}
		if (!doc || !doc.documentElement) {
			doc = implementation.createDocument(NAMESPACE, "template", null);
			try {
				doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
			} catch (_) {}
		}
		const body = doc.body || doc.documentElement;
		if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
		if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? "html" : "body")[0];
		return WHOLE_DOCUMENT ? doc.documentElement : body;
	};
	/**
	* Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
	*
	* @param root The root element or node to start traversing on.
	* @return The created NodeIterator
	*/
	const _createNodeIterator = function _createNodeIterator(root) {
		const doc = getOwnerDocument ? getOwnerDocument(root) : root.ownerDocument;
		return createNodeIterator.call(doc || root, root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
	};
	/**
	* Replace template expression syntax (mustache, ERB, template
	* literal) with a space; shared by all SAFE_FOR_TEMPLATES scrub
	* sites. Order matters: mustache, then ERB, then template literal.
	*
	* @param value the string to scrub
	* @returns the scrubbed string
	*/
	const _stripTemplateExpressions = function _stripTemplateExpressions(value) {
		value = stringReplace(value, MUSTACHE_EXPR$1, " ");
		value = stringReplace(value, ERB_EXPR$1, " ");
		value = stringReplace(value, TMPLIT_EXPR$1, " ");
		return value;
	};
	/**
	* Strip template-engine expressions ({{...}}, ${...}, <%...%>) from the
	* character data of an element subtree. Used as the final safety net for
	* SAFE_FOR_TEMPLATES on every DOM-returning code path so that expressions
	* which only form after text-node normalization (e.g. fragments split across
	* stripped elements) cannot survive into a template-evaluating framework.
	*
	* Walks text/comment/CDATA/processing-instruction nodes and mutates `.data`
	* in place rather than round-tripping through innerHTML. This preserves
	* descendant node references (important for IN_PLACE callers), avoids a
	* serialize/reparse cycle, and reads literal character data — which means
	* `<%...%>` in text content matches the ERB regex against its real bytes
	* instead of the HTML-entity-escaped form innerHTML would produce.
	*
	* Attribute values are not visited here; SAFE_FOR_TEMPLATES handling for
	* attributes is performed during the per-node `_sanitizeAttributes` pass.
	*
	* @param node The root element whose character data should be scrubbed.
	*/
	const _scrubTemplateExpressions2 = function _scrubTemplateExpressions(node) {
		var _node$querySelectorAl;
		node.normalize();
		const doc = getOwnerDocument ? getOwnerDocument(node) : node.ownerDocument;
		const walker = createNodeIterator.call(doc || node, node, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_CDATA_SECTION | NodeFilter.SHOW_PROCESSING_INSTRUCTION, null);
		let currentNode = walker.nextNode();
		while (currentNode) {
			currentNode.data = _stripTemplateExpressions(currentNode.data);
			currentNode = walker.nextNode();
		}
		const templates = (_node$querySelectorAl = node.querySelectorAll) === null || _node$querySelectorAl === void 0 ? void 0 : _node$querySelectorAl.call(node, "template");
		if (templates) arrayForEach(templates, (tmpl) => {
			if (_isDocumentFragment(tmpl.content)) _scrubTemplateExpressions2(tmpl.content);
		});
	};
	/**
	* _isClobbered
	*
	* Detect DOM-clobbering on HTMLFormElement nodes. Form is the only HTML
	* interface with [LegacyOverrideBuiltIns]; a descendant element with a
	* `name` attribute matching a prototype property shadows that property
	* on direct reads. We use this check at the IN_PLACE entry-point and
	* during attribute sanitization to refuse clobbered forms.
	*
	* @param element element to check for clobbering attacks
	* @return true if clobbered, false if safe
	*/
	const _isClobbered = function _isClobbered(element) {
		const realTagName = getNodeName ? getNodeName(element) : null;
		if (typeof realTagName !== "string") return false;
		if (transformCaseFunc(realTagName) !== "form") return false;
		return typeof element.nodeName !== "string" || typeof element.textContent !== "string" || typeof element.removeChild !== "function" || element.attributes !== getAttributes(element) || typeof element.removeAttribute !== "function" || typeof element.removeAttributeNode !== "function" || typeof element.getAttributeNode !== "function" || typeof element.setAttribute !== "function" || typeof element.namespaceURI !== "string" || typeof element.insertBefore !== "function" || typeof element.hasChildNodes !== "function" || element.nodeType !== getNodeType(element) || element.childNodes !== getChildNodes(element);
	};
	/**
	* Checks whether the given value is a DocumentFragment from any realm.
	*
	* The realm-independent replacement reads `nodeType` through the cached
	* Node.prototype getter and compares to the DOCUMENT_FRAGMENT_NODE
	* constant (11). nodeType is a numeric value resolved from the node's
	* internal slot, identical across realms for the same kind of node.
	*
	* @param value object to check
	* @return true if value is a DocumentFragment-shaped node from any realm
	*/
	const _isDocumentFragment = function _isDocumentFragment(value) {
		if (!getNodeType || typeof value !== "object" || value === null) return false;
		try {
			return getNodeType(value) === NODE_TYPE.documentFragment;
		} catch (_) {
			return false;
		}
	};
	/**
	* Checks whether the given object is a DOM node, including nodes that
	* originate from a different window/realm (e.g. an iframe's
	* contentDocument). The previous `value instanceof Node` check was
	* realm-bound: nodes from a different window failed it, causing
	* sanitize() to silently stringify them and reset IN_PLACE to false,
	* returning the original node unsanitized. See GHSA-4w3q-35jp-p934.
	*
	* @param value object to check whether it's a DOM node
	* @return true if value is a DOM node from any realm
	*/
	const _isNode = function _isNode(value) {
		if (!getNodeType || typeof value !== "object" || value === null) return false;
		try {
			return typeof getNodeType(value) === "number";
		} catch (_) {
			return false;
		}
	};
	function _executeHooks(hooks, currentNode, data) {
		if (hooks.length === 0) return;
		arrayForEach(hooks, (hook) => {
			hook.call(DOMPurify, currentNode, data, CONFIG);
		});
	}
	/**
	* Structural-threat checks that condemn a node regardless of the
	* allowlists: mXSS via namespace confusion, risky CSS construction,
	* processing instructions, markup-bearing comments. Pure predicate;
	* the caller removes. Check order is load-bearing.
	*
	* @param currentNode the node to inspect
	* @param tagName the node's transformCaseFunc'd tag name
	* @return true if the node must be removed
	*/
	const _isUnsafeNode = function _isUnsafeNode(currentNode, tagName) {
		if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(ELEMENT_MARKUP_PROBE, currentNode.textContent) && regExpTest(ELEMENT_MARKUP_PROBE, currentNode.innerHTML)) return true;
		if (SAFE_FOR_XML && currentNode.namespaceURI === HTML_NAMESPACE && LITERAL_TEXT_ELEMENTS[tagName] && (_isNode(currentNode.firstElementChild) || typeof currentNode.textContent === "string" && regExpTest(LITERAL_TEXT_CLOSE[tagName], currentNode.textContent))) return true;
		if (currentNode.nodeType === NODE_TYPE.processingInstruction) return true;
		if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(COMMENT_MARKUP_PROBE, currentNode.data)) return true;
		return false;
	};
	/**
	* Evaluate a CUSTOM_ELEMENT_HANDLING check (a RegExp or a predicate
	* function, per the validation in _parseConfig) against a name.
	* Additional arguments are forwarded to predicate functions - the
	* attributeNameCheck predicate receives the tag name as its second
	* argument. A null/absent check never matches.
	*
	* @param check the configured tagNameCheck / attributeNameCheck value
	* @param name the name to test
	* @param args extra arguments forwarded to a predicate function
	* @return true if the check matches the name
	*/
	const _matchesNameCheck = function _matchesNameCheck(check, name) {
		if (check instanceof RegExp) return regExpTest(check, name);
		if (check instanceof Function) {
			for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) args[_key - 2] = arguments[_key];
			return Boolean(check(name, ...args));
		}
		return false;
	};
	/**
	* Handle a node whose tag is forbidden or not allowlisted: keep
	* allowed custom elements (false return exits _sanitizeElements
	* early - the namespace and fallback-tag removal checks are
	* intentionally skipped for kept custom elements), else hoist
	* content per KEEP_CONTENT and remove.
	*
	* A kept custom element is the ONLY case in which this function
	* returns false, so the caller uses that return value to run the
	* afterSanitizeElements hook on the kept element and keep the
	* element-hook lifecycle consistent with normal allowlisted
	* elements (GHSA-c2j3-45gr-mqc4).
	*
	* @param currentNode the disallowed node
	* @param tagName the node's transformCaseFunc'd tag name
	* @return true if the node was removed, false if kept
	*/
	const _sanitizeDisallowedNode = function _sanitizeDisallowedNode(currentNode, tagName, root) {
		if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName) && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
		if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
			const parentNode = getParentNode(currentNode);
			const childNodes = getChildNodes(currentNode);
			if (childNodes && parentNode) {
				const childCount = childNodes.length;
				for (let i = childCount - 1; i >= 0; --i) {
					const hoisted = currentNode === root ? cloneNode(childNodes[i], true) : childNodes[i];
					parentNode.insertBefore(hoisted, getNextSibling(currentNode));
				}
			}
		}
		_forceRemove(currentNode);
		return true;
	};
	/**
	* Fork a hook-mutable allowlist off its shared binding the first time a
	* (possibly lazily-installed) uponSanitize* hook is about to see it, so the
	* hook cannot widen the per-instance default or the setConfig binding by
	* reference and leak past the call. Returns the set unchanged once it is
	* already call-local, so repeated calls across elements are idempotent.
	*
	* @param hookList the uponSanitize* hook array for this event
	* @param set the current ALLOWED_TAGS / ALLOWED_ATTR binding
	* @param defaultSet the per-instance DEFAULT_ALLOWED_* constant
	* @param setConfigSet the captured setConfig() binding, or null
	* @return a call-local clone if a hook is present and set is still shared,
	*   else set unchanged
	*/
	const _forkSharedAllowlist = function _forkSharedAllowlist(hookList, set, defaultSet, setConfigSet) {
		if (hookList.length === 0) return set;
		return set === defaultSet || set === setConfigSet ? clone(set) : set;
	};
	/**
	* Shared guard for a node that a hook has detached from the walk tree,
	* used after each element-hook site in _sanitizeElements. Detaching is a
	* long-standing user pattern (issue #469; draw.io-style foreignObject
	* filtering). Per the cached, unclobberable parentNode getter the node is
	* genuinely out of the tree, so it can reach neither the serialized
	* output nor an IN_PLACE live tree; treat it as removed and stop
	* processing it. Without this guard, the unsafe-node / namespace checks
	* would call _forceRemove on a parentless node and hit the REPORT-3
	* fail-closed throw — which exists for nodes DOMPurify wants gone but
	* *cannot* detach (clobbered / parentless roots), the opposite of a node
	* that is already safely gone. The walk root is exempt: a detached
	* IN_PLACE root is legitimate input and must still be fully sanitized,
	* and a kill-decision on it must keep hitting the REPORT-3 throw.
	*
	* Nodes detached by hooks stay the hook's responsibility for placement:
	* they are not recorded in DOMPurify.removed, so the post-walk IN_PLACE
	* pass (which iterates DOMPurify.removed) does not reach them. But a
	* hook-detached subtree can still hold a queued resource-event handler -
	* e.g. an <img onload> that began loading when the caller built the live
	* tree - which fires in page scope after sanitize returns even though the
	* handler never reached the returned tree. That is the audit-5 F1 hazard,
	* and the documented node.remove() hook pattern walks straight into it.
	* So on the IN_PLACE path we neutralize the detached subtree inline,
	* stripping its non-allow-listed attributes before returning, exactly as
	* the post-walk pass does for _forceRemove'd subtrees.
	*
	* @param currentNode the node a hook may have detached
	* @param root the current walk root
	* @return true if the node is detached and now handled, false otherwise
	*/
	const _handleHookDetachedNode = function _handleHookDetachedNode(currentNode, root) {
		if (currentNode === root || getParentNode(currentNode) !== null) return false;
		if (IN_PLACE) _neutralizeSubtree(currentNode);
		return true;
	};
	/**
	* _sanitizeElements
	*
	* @protect nodeName
	* @protect textContent
	* @protect removeChild
	* @param currentNode to check for permission to exist
	* @return true if node was killed, false if left alive
	*/
	const _sanitizeElements = function _sanitizeElements(currentNode, root) {
		_executeHooks(hooks.beforeSanitizeElements, currentNode, null);
		if (_handleHookDetachedNode(currentNode, root)) return true;
		if (_isClobbered(currentNode)) {
			_forceRemove(currentNode);
			return true;
		}
		const tagName = transformCaseFunc(_readNodeName(currentNode));
		ALLOWED_TAGS = _forkSharedAllowlist(hooks.uponSanitizeElement, ALLOWED_TAGS, DEFAULT_ALLOWED_TAGS, SET_CONFIG_ALLOWED_TAGS);
		_executeHooks(hooks.uponSanitizeElement, currentNode, {
			tagName,
			allowedTags: ALLOWED_TAGS
		});
		if (_handleHookDetachedNode(currentNode, root)) return true;
		if (_isUnsafeNode(currentNode, tagName)) {
			_forceRemove(currentNode);
			return true;
		}
		if (FORBID_TAGS[tagName] || !(EXTRA_ELEMENT_HANDLING.tagCheck instanceof Function && EXTRA_ELEMENT_HANDLING.tagCheck(tagName)) && !ALLOWED_TAGS[tagName]) {
			const removed = _sanitizeDisallowedNode(currentNode, tagName, root);
			if (removed === false) _executeHooks(hooks.afterSanitizeElements, currentNode, null);
			return removed;
		}
		if (_readNodeType(currentNode) === NODE_TYPE.element && !_checkValidNamespace(currentNode)) {
			_forceRemove(currentNode);
			return true;
		}
		if ((tagName === "noscript" || tagName === "noembed" || tagName === "noframes") && regExpTest(FALLBACK_TAG_CLOSE, currentNode.innerHTML)) {
			_forceRemove(currentNode);
			return true;
		}
		if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
			const content = _stripTemplateExpressions(currentNode.textContent);
			if (currentNode.textContent !== content) {
				arrayPush(DOMPurify.removed, { element: currentNode.cloneNode() });
				currentNode.textContent = content;
			}
		}
		_executeHooks(hooks.afterSanitizeElements, currentNode, null);
		return false;
	};
	/**
	* _isValidAttribute
	*
	* @param lcTag Lowercase tag name of containing element.
	* @param lcName Lowercase attribute name.
	* @param value Attribute value.
	* @return Returns true if `value` is valid, otherwise false.
	*/
	const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
		if (FORBID_ATTR[lcName]) return false;
		if (_isPatchLinkageAttribute(lcName, lcTag)) return false;
		if (SANITIZE_DOM && (lcName === "id" || lcName === "name") && (value in document || value in formElement)) return false;
		const nameIsPermitted = ALLOWED_ATTR[lcName] || EXTRA_ELEMENT_HANDLING.attributeCheck instanceof Function && EXTRA_ELEMENT_HANDLING.attributeCheck(lcName, lcTag);
		if (ALLOW_DATA_ATTR && regExpTest(DATA_ATTR$1, lcName)) return true;
		if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) return true;
		if (!nameIsPermitted) return _isBasicCustomElement(lcTag) && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName, lcTag) || lcName === "is" && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value);
		if (URI_SAFE_ATTRIBUTES[lcName]) return true;
		if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ""))) return true;
		if ((lcName === "src" || lcName === "xlink:href" || lcName === "href") && lcTag !== "script" && stringIndexOf(value, "data:") === 0 && DATA_URI_TAGS[lcTag]) return true;
		if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ""))) return true;
		return !value;
	};
	const RESERVED_CUSTOM_ELEMENT_NAMES = addToSet({}, [
		"annotation-xml",
		"color-profile",
		"font-face",
		"font-face-format",
		"font-face-name",
		"font-face-src",
		"font-face-uri",
		"missing-glyph"
	]);
	/**
	* _isBasicCustomElement
	* checks if at least one dash is included in tagName, and it's not the first char
	* for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
	*
	* @param tagName name of the tag of the node to sanitize
	* @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
	*/
	const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
		return !RESERVED_CUSTOM_ELEMENT_NAMES[stringToLowerCase(tagName)] && regExpTest(CUSTOM_ELEMENT$1, tagName);
	};
	/**
	* Wrap an attribute value in the matching Trusted Types object when
	* the active policy requires it. Namespaced attributes pass through
	* unchanged (no TT support yet, see
	* https://bugs.chromium.org/p/chromium/issues/detail?id=1305293).
	*
	* @param lcTag lowercase tag name of the containing element
	* @param lcName lowercase attribute name
	* @param namespaceURI the attribute's namespace, if any
	* @param value the attribute value to wrap
	* @return the value, wrapped when Trusted Types demand it
	*/
	const _applyTrustedTypesToAttribute = function _applyTrustedTypesToAttribute(lcTag, lcName, namespaceURI, value) {
		if (trustedTypesPolicy && typeof trustedTypes === "object" && typeof trustedTypes.getAttributeType === "function" && !namespaceURI) switch (trustedTypes.getAttributeType(lcTag, lcName)) {
			case "TrustedHTML": return _createTrustedHTML(value);
			case "TrustedScriptURL": return _createTrustedScriptURL(value);
		}
		return value;
	};
	/**
	* Write a modified attribute value back onto the element. On
	* success, re-probe for clobbering introduced by the new value and
	* remove the element when found; otherwise, when this writeback is the
	* recreate half of the SANITIZE_NAMED_PROPS remove-and-recreate, pop the
	* removal entry that path recorded so it does not show as removed. On
	* failure, remove the attribute instead.
	*
	* Returns true only on a clean write (the value was set and the new value
	* introduced no clobbering). The caller uses that, together with its own
	* knowledge of whether this attribute pushed a DOMPurify.removed record, to
	* decide whether to pop that record. The pop must happen ONLY for the
	* named-prop remove-and-recreate; popping on any other value change (trim,
	* template scrubbing, Trusted Types) would consume an unrelated _forceRemove
	* subtree-cleanup record and let that detached subtree keep a live event
	* handler through the IN_PLACE neutralization pass (SO-001).
	*
	* @param currentNode the element carrying the attribute
	* @param name the attribute name as present on the element
	* @param namespaceURI the attribute's namespace, if any
	* @param value the new attribute value
	* @return true if the value was written without introducing clobbering
	*/
	const _setAttributeValue = function _setAttributeValue(currentNode, name, namespaceURI, value) {
		try {
			if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
			else currentNode.setAttribute(name, value);
			if (_isClobbered(currentNode)) {
				_forceRemove(currentNode);
				return false;
			}
			return true;
		} catch (_) {
			_removeAttribute(name, currentNode);
			return false;
		}
	};
	/**
	* _sanitizeAttributes
	*
	* @protect attributes
	* @protect nodeName
	* @protect removeAttribute
	* @protect setAttribute
	*
	* @param currentNode to sanitize
	*/
	const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
		_executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
		const attributes = currentNode.attributes;
		if (!attributes || _isClobbered(currentNode)) return;
		ALLOWED_ATTR = _forkSharedAllowlist(hooks.uponSanitizeAttribute, ALLOWED_ATTR, DEFAULT_ALLOWED_ATTR, SET_CONFIG_ALLOWED_ATTR);
		const hookEvent = {
			attrName: "",
			attrValue: "",
			keepAttr: true,
			allowedAttributes: ALLOWED_ATTR,
			forceKeepAttr: void 0
		};
		let l = attributes.length;
		const lcTag = transformCaseFunc(currentNode.nodeName);
		while (l--) {
			const attr = attributes[l];
			const name = attr.name, namespaceURI = attr.namespaceURI, attrValue = attr.value;
			const lcName = transformCaseFunc(name);
			const initValue = attrValue;
			let value = name === "value" ? initValue : stringTrim(initValue);
			let recreatedNamedProp = false;
			hookEvent.attrName = lcName;
			hookEvent.attrValue = value;
			hookEvent.keepAttr = true;
			hookEvent.forceKeepAttr = void 0;
			_executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
			value = hookEvent.attrValue;
			if (SANITIZE_NAMED_PROPS && (lcName === "id" || lcName === "name") && stringIndexOf(value, SANITIZE_NAMED_PROPS_PREFIX) !== 0) {
				_removeAttribute(name, currentNode, attr);
				value = SANITIZE_NAMED_PROPS_PREFIX + value;
				recreatedNamedProp = true;
			}
			if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, value)) {
				_removeAttribute(name, currentNode, attr);
				continue;
			}
			if (lcName === "attributename" && stringMatch(value, "href")) {
				_removeAttribute(name, currentNode, attr);
				continue;
			}
			if (hookEvent.forceKeepAttr) continue;
			if (!hookEvent.keepAttr) {
				_removeAttribute(name, currentNode, attr);
				continue;
			}
			if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(SELF_CLOSING_TAG, value)) {
				_removeAttribute(name, currentNode, attr);
				continue;
			}
			if (SAFE_FOR_TEMPLATES) value = _stripTemplateExpressions(value);
			if (!_isValidAttribute(lcTag, lcName, value)) {
				_removeAttribute(name, currentNode, attr);
				continue;
			}
			value = _applyTrustedTypesToAttribute(lcTag, lcName, namespaceURI, value);
			if (value !== initValue) {
				if (_setAttributeValue(currentNode, name, namespaceURI, value) && recreatedNamedProp) arrayPop(DOMPurify.removed);
			}
		}
		_executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
	};
	/**
	* _sanitizeShadowDOM
	*
	* @param fragment to iterate over recursively
	*/
	const _sanitizeShadowDOM2 = function _sanitizeShadowDOM(fragment) {
		let shadowNode = null;
		const shadowIterator = _createNodeIterator(fragment);
		_executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
		while (shadowNode = shadowIterator.nextNode()) {
			_executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
			_sanitizeElements(shadowNode, fragment);
			_sanitizeAttributes(shadowNode);
			if (_isDocumentFragment(shadowNode.content)) _sanitizeShadowDOM2(shadowNode.content);
			if (_readNodeType(shadowNode) === NODE_TYPE.element) {
				const innerSr = getShadowRoot(shadowNode);
				if (_isDocumentFragment(innerSr)) {
					_sanitizeAttachedShadowRoots(innerSr);
					_sanitizeShadowDOM2(innerSr);
				}
			}
		}
		_executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
	};
	/**
	* _sanitizeAttachedShadowRoots
	*
	* Walks `root` and feeds every attached shadow root we encounter into
	* the existing _sanitizeShadowDOM pipeline. The default node iterator
	* does not descend into shadow trees, so nodes inside an attached
	* shadow root would otherwise be skipped entirely.
	*
	* Two real input paths put attached shadow roots in front of us:
	*   1. IN_PLACE on a DOM node that already has shadow roots attached.
	*   2. DOM-node input where importNode(dirty, true) deep-clones the
	*      shadow root because it was created with `clonable: true`.
	*
	* This pass runs once, up front, so the main iteration loop (and the
	* existing _sanitizeShadowDOM template-content recursion) stay
	* untouched — string-input paths are not affected.
	*
	* @param root the subtree root to walk for attached shadow roots
	*/
	const _sanitizeAttachedShadowRoots = function _sanitizeAttachedShadowRoots(root) {
		const stack = [{
			node: root,
			shadow: null
		}];
		while (stack.length > 0) {
			const item = stack.pop();
			if (item.shadow) {
				_sanitizeShadowDOM2(item.shadow);
				continue;
			}
			const node = item.node;
			const isElement = _readNodeType(node) === NODE_TYPE.element;
			const childNodes = getChildNodes(node);
			if (childNodes) for (let i = childNodes.length - 1; i >= 0; --i) stack.push({
				node: childNodes[i],
				shadow: null
			});
			if (isElement) {
				const rootName = getNodeName ? getNodeName(node) : null;
				if (typeof rootName === "string" && transformCaseFunc(rootName) === "template") {
					const content = node.content;
					if (_isDocumentFragment(content)) stack.push({
						node: content,
						shadow: null
					});
				}
			}
			if (isElement) {
				const sr = getShadowRoot(node);
				if (_isDocumentFragment(sr)) stack.push({
					node: null,
					shadow: sr
				}, {
					node: sr,
					shadow: null
				});
			}
		}
	};
	DOMPurify.sanitize = function(dirty) {
		let cfg = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		let body = null;
		let importedNode = null;
		let currentNode = null;
		let returnNode = null;
		IS_EMPTY_INPUT = !dirty;
		if (IS_EMPTY_INPUT) dirty = "<!-->";
		if (typeof dirty !== "string" && !_isNode(dirty)) {
			dirty = stringifyValue(dirty);
			if (typeof dirty !== "string") throw typeErrorCreate("dirty is not a string, aborting");
		}
		if (!DOMPurify.isSupported) return dirty;
		if (SET_CONFIG) {
			ALLOWED_TAGS = SET_CONFIG_ALLOWED_TAGS;
			ALLOWED_ATTR = SET_CONFIG_ALLOWED_ATTR;
		} else _parseConfig(cfg);
		if (hooks.uponSanitizeElement.length > 0 || hooks.uponSanitizeAttribute.length > 0) ALLOWED_TAGS = clone(ALLOWED_TAGS);
		if (hooks.uponSanitizeAttribute.length > 0) ALLOWED_ATTR = clone(ALLOWED_ATTR);
		DOMPurify.removed = [];
		const inPlace = IN_PLACE && typeof dirty !== "string" && _isNode(dirty);
		if (inPlace) {
			_neutralizePatchLinkage(dirty);
			const nn = _readNodeName(dirty);
			if (typeof nn === "string") {
				const tagName = transformCaseFunc(nn);
				if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
					_neutralizeRoot(dirty);
					throw typeErrorCreate("root node is forbidden and cannot be sanitized in-place");
				}
			}
			if (_isClobbered(dirty)) {
				_neutralizeRoot(dirty);
				throw typeErrorCreate("root node is clobbered and cannot be sanitized in-place");
			}
			try {
				_sanitizeAttachedShadowRoots(dirty);
			} catch (error) {
				_neutralizeRoot(dirty);
				throw error;
			}
		} else if (_isNode(dirty)) {
			body = _initDocument("<!---->");
			importedNode = body.ownerDocument.importNode(dirty, true);
			if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === "BODY") body = importedNode;
			else if (importedNode.nodeName === "HTML") body = importedNode;
			else body.appendChild(importedNode);
			_sanitizeAttachedShadowRoots(body);
		} else {
			if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && dirty.indexOf("<") === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? _createTrustedHTML(dirty) : dirty;
			body = _initDocument(dirty);
			if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : "";
		}
		if (body && FORCE_BODY) _forceRemove(body.firstChild);
		const walkRoot = inPlace ? dirty : body;
		try {
			const nodeIterator = _createNodeIterator(walkRoot);
			while (currentNode = nodeIterator.nextNode()) {
				_sanitizeElements(currentNode, walkRoot);
				_sanitizeAttributes(currentNode);
				if (_isDocumentFragment(currentNode.content)) _sanitizeShadowDOM2(currentNode.content);
			}
		} catch (error) {
			if (inPlace) {
				_neutralizeRoot(dirty);
				arrayForEach(DOMPurify.removed, (entry) => {
					if (entry.element) _neutralizeSubtree(entry.element);
				});
			}
			throw error;
		}
		if (inPlace) {
			arrayForEach(DOMPurify.removed, (entry) => {
				if (entry.element) _neutralizeSubtree(entry.element);
			});
			if (SAFE_FOR_TEMPLATES) _scrubTemplateExpressions2(dirty);
			return dirty;
		}
		if (RETURN_DOM) {
			if (SAFE_FOR_TEMPLATES) _scrubTemplateExpressions2(body);
			if (RETURN_DOM_FRAGMENT) {
				returnNode = createDocumentFragment.call(body.ownerDocument);
				while (body.firstChild) returnNode.appendChild(body.firstChild);
			} else returnNode = body;
			if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) returnNode = importNode.call(originalDocument, returnNode, true);
			return returnNode;
		}
		let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
		if (WHOLE_DOCUMENT && ALLOWED_TAGS["!doctype"] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = "<!DOCTYPE " + body.ownerDocument.doctype.name + ">\n" + serializedHTML;
		if (SAFE_FOR_TEMPLATES) serializedHTML = _stripTemplateExpressions(serializedHTML);
		return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? _createTrustedHTML(serializedHTML) : serializedHTML;
	};
	DOMPurify.setConfig = function() {
		let cfg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		_parseConfig(cfg);
		SET_CONFIG = true;
		SET_CONFIG_ALLOWED_TAGS = ALLOWED_TAGS;
		SET_CONFIG_ALLOWED_ATTR = ALLOWED_ATTR;
	};
	DOMPurify.clearConfig = function() {
		CONFIG = null;
		SET_CONFIG = false;
		SET_CONFIG_ALLOWED_TAGS = null;
		SET_CONFIG_ALLOWED_ATTR = null;
		trustedTypesPolicy = defaultTrustedTypesPolicy;
		emptyHTML = "";
	};
	DOMPurify.isValidAttribute = function(tag, attr, value) {
		if (!CONFIG) _parseConfig({});
		const lcTag = transformCaseFunc(tag);
		const lcName = transformCaseFunc(attr);
		return _isValidAttribute(lcTag, lcName, value);
	};
	DOMPurify.addHook = function(entryPoint, hookFunction) {
		if (typeof hookFunction !== "function") return;
		if (!objectHasOwnProperty(hooks, entryPoint)) return;
		arrayPush(hooks[entryPoint], hookFunction);
	};
	DOMPurify.removeHook = function(entryPoint, hookFunction) {
		if (!objectHasOwnProperty(hooks, entryPoint)) return;
		if (hookFunction !== void 0) {
			const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
			return index === -1 ? void 0 : arraySplice(hooks[entryPoint], index, 1)[0];
		}
		return arrayPop(hooks[entryPoint]);
	};
	DOMPurify.removeHooks = function(entryPoint) {
		if (!objectHasOwnProperty(hooks, entryPoint)) return;
		hooks[entryPoint] = [];
	};
	DOMPurify.removeAllHooks = function() {
		hooks = _createHooksMap();
	};
	return DOMPurify;
}
var purify = createDOMPurify();
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/domSanitize.js
/**
* List of safe, non-input html tags.
*/
var basicMarkupHtmlTags = Object.freeze([
	"a",
	"abbr",
	"b",
	"bdo",
	"blockquote",
	"br",
	"caption",
	"cite",
	"code",
	"col",
	"colgroup",
	"dd",
	"del",
	"details",
	"dfn",
	"div",
	"dl",
	"dt",
	"em",
	"figcaption",
	"figure",
	"h1",
	"h2",
	"h3",
	"h4",
	"h5",
	"h6",
	"hr",
	"i",
	"img",
	"ins",
	"kbd",
	"label",
	"li",
	"mark",
	"ol",
	"p",
	"pre",
	"q",
	"rp",
	"rt",
	"ruby",
	"s",
	"samp",
	"small",
	"small",
	"source",
	"span",
	"strike",
	"strong",
	"sub",
	"summary",
	"sup",
	"table",
	"tbody",
	"td",
	"tfoot",
	"th",
	"thead",
	"time",
	"tr",
	"tt",
	"u",
	"ul",
	"var",
	"video",
	"wbr"
]);
var defaultAllowedAttrs = Object.freeze([
	"href",
	"target",
	"src",
	"alt",
	"title",
	"for",
	"name",
	"role",
	"tabindex",
	"x-dispatch",
	"required",
	"checked",
	"placeholder",
	"type",
	"start",
	"width",
	"height",
	"align"
]);
var fakeRelativeUrlProtocol = "vscode-relative-path";
function validateLink(value, allowedProtocols) {
	if (allowedProtocols.override === "*") return true;
	try {
		const url = new URL(value, "vscode-relative-path://");
		if (allowedProtocols.override.includes(url.protocol.replace(/:$/, ""))) return true;
		if (allowedProtocols.allowRelativePaths && url.protocol === "vscode-relative-path:" && !value.trim().toLowerCase().startsWith(fakeRelativeUrlProtocol)) return true;
		return false;
	} catch (e) {
		return false;
	}
}
/**
* Hooks dompurify using `afterSanitizeAttributes` to check link and media-loading attributes.
*/
function hookDomPurifyHrefAndSrcSanitizer(allowedLinkProtocols, allowedMediaProtocols, mediaSourceIsAllowed, replaceWithPlaintext) {
	purify.addHook("afterSanitizeAttributes", (node) => {
		for (const attr of [
			"href",
			"src",
			"poster"
		]) if (node.hasAttribute(attr)) {
			const attrValue = node.getAttribute(attr);
			if (attr === "href" && node.nodeName.toLowerCase() === "a") {
				if (!attrValue.startsWith("#") && !validateLink(attrValue, allowedLinkProtocols)) node.removeAttribute(attr);
			} else if (attr === "href" && attrValue.startsWith("#")) continue;
			else if (!validateLink(attrValue, allowedMediaProtocols)) node.removeAttribute(attr);
			else if (mediaSourceIsAllowed && !mediaSourceIsAllowed(attrValue)) {
				const replacement = replaceWithPlaintext ? convertTagToPlaintext(node) : void 0;
				if (replacement && node.parentNode) {
					node.parentNode.replaceChild(replacement, node);
					return;
				} else node.removeAttribute(attr);
			}
		}
	});
}
var defaultDomPurifyConfig = Object.freeze({
	ALLOWED_TAGS: [...basicMarkupHtmlTags],
	ALLOWED_ATTR: [...defaultAllowedAttrs],
	ALLOW_UNKNOWN_PROTOCOLS: true
});
/**
* Sanitizes an html string.
*
* @param untrusted The HTML string to sanitize.
* @param config Optional configuration for sanitization. If not provided, defaults to a safe configuration.
*
* @returns A sanitized string of html.
*/
function sanitizeHtml(untrusted, config) {
	return doSanitizeHtml(untrusted, config, "trusted");
}
function doSanitizeHtml(untrusted, config, outputType) {
	try {
		const resolvedConfig = { ...defaultDomPurifyConfig };
		if (config?.allowedTags) {
			if (config.allowedTags.override) resolvedConfig.ALLOWED_TAGS = [...config.allowedTags.override];
			if (config.allowedTags.augment) resolvedConfig.ALLOWED_TAGS = [...resolvedConfig.ALLOWED_TAGS ?? [], ...config.allowedTags.augment];
		}
		let resolvedAttributes = [...defaultAllowedAttrs];
		if (config?.allowedAttributes) {
			if (config.allowedAttributes.override) resolvedAttributes = [...config.allowedAttributes.override];
			if (config.allowedAttributes.augment) resolvedAttributes = [...resolvedAttributes, ...config.allowedAttributes.augment];
		}
		resolvedAttributes = resolvedAttributes.map((attr) => {
			if (typeof attr === "string") return attr.toLowerCase();
			return {
				attributeName: attr.attributeName.toLowerCase(),
				shouldKeep: attr.shouldKeep
			};
		});
		const allowedAttrNames = new Set(resolvedAttributes.map((attr) => typeof attr === "string" ? attr : attr.attributeName));
		const allowedAttrPredicates = /* @__PURE__ */ new Map();
		for (const attr of resolvedAttributes) if (typeof attr === "string") allowedAttrPredicates.delete(attr);
		else allowedAttrPredicates.set(attr.attributeName, attr);
		resolvedConfig.ALLOWED_ATTR = Array.from(allowedAttrNames);
		hookDomPurifyHrefAndSrcSanitizer({
			override: config?.allowedLinkProtocols?.override ?? [Schemas.http, Schemas.https],
			allowRelativePaths: config?.allowRelativeLinkPaths ?? false
		}, {
			override: config?.allowedMediaProtocols?.override ?? [Schemas.http, Schemas.https],
			allowRelativePaths: config?.allowRelativeMediaPaths ?? false
		}, config?.mediaSourceIsAllowed, config?.replaceWithPlaintext ?? false);
		if (config?.replaceWithPlaintext) purify.addHook("uponSanitizeElement", replaceWithPlainTextHook);
		if (allowedAttrPredicates.size) purify.addHook("uponSanitizeAttribute", (node, e) => {
			const predicate = allowedAttrPredicates.get(e.attrName);
			if (predicate) {
				const result = predicate.shouldKeep(node, e);
				if (typeof result === "string") {
					e.keepAttr = true;
					e.attrValue = result;
				} else e.keepAttr = result;
			} else e.keepAttr = allowedAttrNames.has(e.attrName);
		});
		if (outputType === "dom") return sanitizeSurvivingStalePolicy(untrusted, {
			...resolvedConfig,
			RETURN_DOM_FRAGMENT: true
		});
		else return sanitizeSurvivingStalePolicy(untrusted, {
			...resolvedConfig,
			RETURN_TRUSTED_TYPE: true
		});
	} finally {
		purify.removeAllHooks();
	}
}
/** Names a replacement policy; Trusted Types rejects a name that is already taken. */
var stalePolicyReplacementCount = 0;
/**
* Sanitizes HTML, replacing the sanitizer's Trusted Types policy first when the policy's
* creating realm is gone and every call would otherwise throw. The replacement is kept
* for later calls, so this recovers once rather than on every call.
*
* Exported, with `sanitize` injectable, only so a test can drive the recovery: dompurify
* caches one policy for the lifetime of the module, so once anything has sanitized, no
* later stand-in policy is ever consulted. Prefer {@link sanitizeHtml}.
*/
function sanitizeSurvivingStalePolicy(untrusted, config, sanitize = (html, cfg) => purify.sanitize(html, cfg)) {
	try {
		return sanitize(untrusted, config);
	} catch (error) {
		if (!isStaleTrustedTypesPolicy(error)) throw error;
		const replacement = createTrustedTypesPolicy(`domSanitize${stalePolicyReplacementCount++}`, {
			createHTML: (value) => value,
			createScriptURL: (value) => value
		});
		if (!replacement) throw error;
		const policy = replacement;
		return sanitize(untrusted, {
			...config,
			TRUSTED_TYPES_POLICY: policy
		});
	}
}
/** Whether the failure is a Trusted Types policy whose realm is gone, rather than bad markup. */
function isStaleTrustedTypesPolicy(error) {
	return error instanceof Error && /no longer runnable/i.test(error.message);
}
var selfClosingTags = [
	"area",
	"base",
	"br",
	"col",
	"command",
	"embed",
	"hr",
	"img",
	"input",
	"keygen",
	"link",
	"meta",
	"param",
	"source",
	"track",
	"wbr"
];
var replaceWithPlainTextHook = (node, data, _config) => {
	if (!data.allowedTags[data.tagName] && data.tagName !== "body") {
		const replacement = convertTagToPlaintext(node);
		if (replacement) {
			if (node.nodeType === Node.COMMENT_NODE) node.parentElement?.insertBefore(replacement, node);
			else node.parentElement?.replaceChild(replacement, node);
		}
	}
};
function convertTagToPlaintext(node) {
	if (!node.ownerDocument) return;
	let startTagText;
	let endTagText;
	if (node.nodeType === Node.COMMENT_NODE) startTagText = `<!--${node.textContent}-->`;
	else if (node instanceof Element) {
		const tagName = node.tagName.toLowerCase();
		const isSelfClosing = selfClosingTags.includes(tagName);
		startTagText = `<${tagName}${node.attributes.length ? " " + Array.from(node.attributes).map((attr) => `${attr.name}="${attr.value}"`).join(" ") : ""}>`;
		if (!isSelfClosing) endTagText = `</${tagName}>`;
	} else return;
	const fragment = node.ownerDocument.createDocumentFragment();
	const textNode = node.ownerDocument.createTextNode(startTagText);
	fragment.appendChild(textNode);
	while (node.firstChild) fragment.appendChild(node.firstChild);
	const endTagTextNode = endTagText ? node.ownerDocument.createTextNode(endTagText) : void 0;
	if (endTagTextNode) fragment.appendChild(endTagTextNode);
	return fragment;
}
/**
* Sanitizes the given `value` and reset the given `node` with it.
*/
function safeSetInnerHtml(node, untrusted, config) {
	reset(node, doSanitizeHtml(untrusted, config, "dom"));
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/iconLabel/iconLabels.js
var labelWithIconsRegex = new RegExp(`(\\\\)?\\$\\((${ThemeIcon.iconNameExpression}(?:${ThemeIcon.iconModifierExpression})?)\\)`, "g");
function renderLabelWithIcons(text, renderIconsInDefaultColor) {
	const elements = new Array();
	let match;
	let textStart = 0, textStop = 0;
	while ((match = labelWithIconsRegex.exec(text)) !== null) {
		textStop = match.index || 0;
		if (textStart < textStop) elements.push(text.substring(textStart, textStop));
		textStart = (match.index || 0) + match[0].length;
		const [, escaped, codicon] = match;
		elements.push(escaped ? `$(${codicon})` : renderIcon({ id: codicon }, renderIconsInDefaultColor));
	}
	if (textStart < text.length) elements.push(text.substring(textStart));
	return elements;
}
function renderIcon(icon, renderDefaultColor) {
	const node = $$10(`span`);
	const classes = ThemeIcon.asClassNameArray(icon);
	if (renderDefaultColor) classes.push("codicon-colored");
	node.classList.add(...classes);
	return node;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/markdownRenderer.js
/**
* Returns a human-readable tooltip string for a link href.
* For file:// URIs, converts to a decoded OS file system path to avoid
* showing raw URL-encoded paths (e.g. "C:\Users\..." instead of "file:///c%3A/Users/...").
*/
function getLinkTitle(href) {
	try {
		const parsed = URI.parse(href);
		if (parsed.scheme === Schemas.file) {
			const path = parsed.fsPath;
			const fragment = parsed.fragment;
			return escapeDoubleQuotes(fragment ? `${path}#${fragment}` : path);
		}
	} catch {}
	return "";
}
function renderImage({ href, title, text }, transformUri) {
	let dimensions = [];
	let attributes = [];
	if (href) {
		({href, dimensions} = parseHrefAndDimensions(href));
		href = transformUri?.(href) ?? href;
		attributes.push(`src="${escapeDoubleQuotes(href)}"`);
	}
	if (text) attributes.push(`alt="${escapeDoubleQuotes(text)}"`);
	if (title) attributes.push(`title="${escapeDoubleQuotes(title)}"`);
	if (dimensions.length) attributes = attributes.concat(dimensions);
	return "<img " + attributes.join(" ") + ">";
}
var defaultMarkedRenderers = Object.freeze({
	image: renderImage,
	paragraph({ tokens }) {
		return `<p>${this.parser.parseInline(tokens)}</p>`;
	},
	link({ href, title, tokens }) {
		let text = this.parser.parseInline(tokens);
		if (typeof href !== "string") return "";
		if (href === text) text = removeMarkdownEscapes(text);
		title = typeof title === "string" ? escapeDoubleQuotes(removeMarkdownEscapes(title)) : "";
		href = removeMarkdownEscapes(href);
		if (!title && href.startsWith(`${Schemas.file}:`)) title = getLinkTitle(href);
		const isCommandUri = href.startsWith(`${Schemas.command}:`);
		href = href.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
		return `<a href="${href}" title="${title || (isCommandUri ? "" : href)}" draggable="false">${text}</a>`;
	}
});
/**
* Blockquote renderer that processes GitHub-style alert syntax.
* Transforms blockquotes like "> [!NOTE]" into structured alert markup with icons.
*
* Based on GitHub's alert syntax: https://docs.github.com/en/get-started/writing-on-github/getting-started-with-writing-and-formatting-on-github/basic-writing-and-formatting-syntax#alerts
*/
function createAlertBlockquoteRenderer(fallbackRenderer) {
	return function(token) {
		const { tokens } = token;
		const firstToken = tokens[0];
		if (firstToken?.type !== "paragraph") return fallbackRenderer.call(this, token);
		const paragraphTokens = firstToken.tokens;
		if (!paragraphTokens || paragraphTokens.length === 0) return fallbackRenderer.call(this, token);
		const firstTextToken = paragraphTokens[0];
		if (firstTextToken?.type !== "text") return fallbackRenderer.call(this, token);
		const pattern = /^\s*\[!(NOTE|TIP|IMPORTANT|WARNING|CAUTION)\]\s*?\n*/i;
		const match = firstTextToken.raw.match(pattern);
		if (!match) return fallbackRenderer.call(this, token);
		firstTextToken.raw = firstTextToken.raw.replace(pattern, "");
		firstTextToken.text = firstTextToken.text.replace(pattern, "");
		const alertIcons = {
			"note": "info",
			"tip": "light-bulb",
			"important": "comment",
			"warning": "alert",
			"caution": "stop"
		};
		const type = match[1];
		const typeCapitalized = type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();
		const severity = type.toLowerCase();
		return `<blockquote data-severity="${severity}"><p><span>${renderIcon({ id: alertIcons[severity] }).outerHTML}${typeCapitalized}</span>${this.parser.parse(tokens).substring(3)}</blockquote>\n`;
	};
}
/**
* Low-level way create a html element from a markdown string.
*
* **Note** that for most cases you should be using {@link import('../../editor/browser/widget/markdownRenderer/browser/markdownRenderer.js').MarkdownRenderer MarkdownRenderer}
* which comes with support for pretty code block rendering and which uses the default way of handling links.
*/
function renderMarkdown(markdown, options = {}, target) {
	const disposables = new DisposableStore();
	let isDisposed = false;
	const markedInstance = new Marked(...options.markedExtensions ?? []);
	const { renderer, codeBlocks, syncCodeBlocks } = createMarkdownRenderer(markedInstance, options, markdown);
	const value = preprocessMarkdownString(markdown);
	let renderedMarkdown;
	if (options.fillInIncompleteTokens) {
		const opts = {
			...markedInstance.defaults,
			...options.markedOptions,
			renderer
		};
		const newTokens = fillInIncompleteTokens(markedInstance.lexer(value, opts));
		renderedMarkdown = markedInstance.parser(newTokens, opts);
	} else renderedMarkdown = markedInstance.parse(value, {
		...options?.markedOptions,
		renderer,
		async: false
	});
	if (markdown.supportThemeIcons) renderedMarkdown = renderLabelWithIcons(renderedMarkdown).map((e) => typeof e === "string" ? e : e.outerHTML).join("");
	const renderedContent = document.createElement("div");
	const sanitizerConfig = getDomSanitizerConfig(markdown, options.sanitizerConfig ?? {});
	safeSetInnerHtml(renderedContent, renderedMarkdown, sanitizerConfig);
	rewriteRenderedLinks(markdown, options, renderedContent);
	let outElement;
	if (target) {
		outElement = target;
		if (syncCodeBlocks.some(([, element]) => target.contains(element))) replaceChildrenPreservingCodeBlocks(target, renderedContent, syncCodeBlocks);
		else reset(target, ...renderedContent.childNodes);
	} else outElement = renderedContent;
	if (codeBlocks.length > 0) Promise.all(codeBlocks).then((tuples) => {
		if (isDisposed) return;
		const renderedElements = new Map(tuples);
		const placeholderElements = outElement.querySelectorAll(`div[data-code]`);
		for (const placeholderElement of placeholderElements) {
			const renderedElement = renderedElements.get(placeholderElement.dataset["code"] ?? "");
			if (renderedElement) reset(placeholderElement, renderedElement);
		}
		options.asyncRenderCallback?.();
	});
	else if (syncCodeBlocks.length > 0) {
		const renderedElements = new Map(syncCodeBlocks);
		const placeholderElements = outElement.querySelectorAll(`div[data-code]`);
		for (const placeholderElement of placeholderElements) {
			const renderedElement = renderedElements.get(placeholderElement.dataset["code"] ?? "");
			if (renderedElement && (placeholderElement.childNodes.length !== 1 || placeholderElement.firstChild !== renderedElement)) reset(placeholderElement, renderedElement);
		}
	}
	if (options.asyncRenderCallback) for (const img of outElement.getElementsByTagName("img")) {
		const listener = disposables.add(addDisposableListener(img, "load", () => {
			listener.dispose();
			options.asyncRenderCallback();
		}));
	}
	if (options.actionHandler) {
		const clickCb = (e) => {
			const mouseEvent = new StandardMouseEvent(getWindow(outElement), e);
			if (!mouseEvent.leftButton && !mouseEvent.middleButton) return;
			activateLink(markdown, options, mouseEvent);
		};
		disposables.add(addDisposableListener(outElement, "click", clickCb));
		disposables.add(addDisposableListener(outElement, "auxclick", clickCb));
		disposables.add(addDisposableListener(outElement, "keydown", (e) => {
			const keyboardEvent = new StandardKeyboardEvent(e);
			if (!keyboardEvent.equals(10) && !keyboardEvent.equals(3)) return;
			activateLink(markdown, options, keyboardEvent);
		}));
	}
	for (const input of [...outElement.getElementsByTagName("input")]) if (input.attributes.getNamedItem("type")?.value === "checkbox") input.setAttribute("disabled", "");
	else if (options.sanitizerConfig?.replaceWithPlaintext) {
		const replacement = convertTagToPlaintext(input);
		if (replacement) input.parentElement?.replaceChild(replacement, input);
		else input.remove();
	} else input.remove();
	return {
		element: outElement,
		dispose: () => {
			isDisposed = true;
			disposables.dispose();
		}
	};
}
/** Keeps reused code blocks and their matching ancestors connected so embedded iframes do not reload. */
function replaceChildrenPreservingCodeBlocks(target, source, codeBlocks) {
	const renderedElements = new Map(codeBlocks);
	const replacements = /* @__PURE__ */ new Map();
	const existingToNew = /* @__PURE__ */ new Map();
	const preservedCodeBlocks = /* @__PURE__ */ new Set();
	for (const placeholder of source.querySelectorAll("div[data-code]")) {
		const renderedElement = renderedElements.get(placeholder.dataset.code ?? "");
		if (!renderedElement || !target.contains(renderedElement)) continue;
		let existing = renderedElement.parentElement;
		if (!existing?.hasAttribute("data-code") || existing.childNodes.length !== 1) continue;
		let incoming = placeholder;
		const ancestors = [];
		while (existing && incoming && existing !== target && incoming !== source && existing.tagName === incoming.tagName && (!replacements.has(incoming) || replacements.get(incoming) === existing) && (!existingToNew.has(existing) || existingToNew.get(existing) === incoming)) {
			ancestors.push([incoming, existing]);
			existing = existing.parentElement;
			incoming = incoming.parentElement;
		}
		if (existing === target && incoming === source) {
			for (const [newElement, existingElement] of ancestors) {
				replacements.set(newElement, existingElement);
				existingToNew.set(existingElement, newElement);
			}
			preservedCodeBlocks.add(placeholder);
		}
	}
	if (replacements.size === 0) {
		reset(target, ...source.childNodes);
		return;
	}
	const updateChildren = (parent, newParent) => {
		const children = Array.from(newParent.childNodes, (child) => {
			if (!isHTMLElement(child)) return child;
			const replacement = replacements.get(child);
			if (!replacement) return child;
			for (const name of replacement.getAttributeNames()) if (!child.hasAttribute(name)) replacement.removeAttribute(name);
			copyAttributes(child, replacement);
			if (!preservedCodeBlocks.has(child)) updateChildren(replacement, child);
			return replacement;
		});
		const retainedChildren = new Set(children);
		for (const child of Array.from(parent.childNodes)) if (!retainedChildren.has(child)) parent.removeChild(child);
		let cursor = parent.firstChild;
		for (const child of children) if (cursor === child) cursor = cursor.nextSibling;
		else parent.insertBefore(child, cursor);
	};
	updateChildren(target, source);
}
function rewriteRenderedLinks(markdown, options, root) {
	for (const el of root.querySelectorAll("img, audio, video, source")) {
		const src = el.getAttribute("src");
		if (src) {
			let href = src;
			try {
				if (markdown.baseUri) href = resolveWithBaseUri(URI.from(markdown.baseUri), href);
			} catch (err) {}
			el.setAttribute("src", massageHref(markdown, href, true));
		}
	}
	for (const el of root.querySelectorAll("a")) {
		const href = el.getAttribute("href");
		el.setAttribute("href", "");
		if (!href || /^data:|javascript:/i.test(href) || /^command:/i.test(href) && !markdown.isTrusted || /^command:(\/\/\/)?_workbench\.downloadResource/i.test(href)) el.replaceWith(...el.childNodes);
		else {
			let resolvedHref = massageHref(markdown, href, false);
			if (markdown.baseUri) resolvedHref = resolveWithBaseUri(URI.from(markdown.baseUri), href);
			el.dataset.href = resolvedHref;
			if (options.actionHandler && isPortableLinkTarget(resolvedHref)) el.setAttribute("href", resolvedHref);
		}
	}
}
function createMarkdownRenderer(marked, options, markdown) {
	const renderer = new marked.Renderer(options.markedOptions);
	renderer.image = (token) => renderImage(token, (href) => options.transformUri?.(href, "image") ?? href);
	renderer.link = (token) => defaultMarkedRenderers.link.call(renderer, {
		...token,
		href: options.transformUri?.(token.href, "link") ?? token.href
	});
	renderer.paragraph = defaultMarkedRenderers.paragraph;
	if (markdown.supportAlertSyntax) renderer.blockquote = createAlertBlockquoteRenderer(renderer.blockquote);
	const codeBlocks = [];
	const syncCodeBlocks = [];
	if (options.codeBlockRendererSync) renderer.code = ({ text, lang, raw }) => {
		const id = defaultGenerator.nextId();
		const value = options.codeBlockRendererSync(postProcessCodeBlockLanguageId(lang), text, raw);
		syncCodeBlocks.push([id, value]);
		return `<div class="code" data-code="${id}">${escape$2(text)}</div>`;
	};
	else if (options.codeBlockRenderer) renderer.code = ({ text, lang }) => {
		const id = defaultGenerator.nextId();
		const value = options.codeBlockRenderer(postProcessCodeBlockLanguageId(lang), text);
		codeBlocks.push(value.then((element) => [id, element]));
		return `<div class="code" data-code="${id}">${escape$2(text)}</div>`;
	};
	if (!markdown.supportHtml) renderer.html = ({ text }) => {
		if (options.sanitizerConfig?.replaceWithPlaintext) return escape$2(text);
		return (markdown.isTrusted ? text.match(/^(<span[^>]+>)|(<\/\s*span>)$/) : void 0) ? text : "";
	};
	return {
		renderer,
		codeBlocks,
		syncCodeBlocks
	};
}
function preprocessMarkdownString(markdown) {
	let value = markdown.value;
	if (value.length > 1e5) value = `${value.substr(0, 1e5)}…`;
	if (markdown.supportThemeIcons) value = markdownEscapeEscapedIcons(value);
	return value;
}
function activateLink(mdStr, options, event) {
	const target = event.target.closest("a[data-href]");
	if (!isHTMLElement(target)) return;
	try {
		let href = target.dataset["href"];
		if (href) {
			if (mdStr.baseUri) href = resolveWithBaseUri(URI.from(mdStr.baseUri), href);
			options.actionHandler?.(href, mdStr);
		}
	} catch (err) {
		onUnexpectedError(err);
	} finally {
		event.preventDefault();
		event.stopPropagation();
	}
}
function uriMassage(markdown, part) {
	let data;
	try {
		data = parse$1(decodeURIComponent(part));
	} catch (e) {}
	if (!data) return part;
	data = cloneAndChange(data, (value) => {
		if (markdown.uris && markdown.uris[value]) return URI.revive(markdown.uris[value]);
		else return;
	});
	return encodeURIComponent(JSON.stringify(data));
}
function massageHref(markdown, href, isDomUri) {
	const data = markdown.uris && markdown.uris[href];
	let uri = URI.revive(data);
	if (isDomUri) {
		if (href.startsWith(Schemas.data + ":")) return href;
		if (!uri) uri = URI.parse(href);
		return FileAccess.uriToBrowserUri(uri).toString(true);
	}
	if (!uri) return href;
	if (URI.parse(href).toString() === uri.toString()) return href;
	if (uri.query) uri = uri.with({ query: uriMassage(markdown, uri.query) });
	return uri.toString();
}
function postProcessCodeBlockLanguageId(lang) {
	if (!lang) return "";
	const parts = lang.split(/[\s+|:|,|\{|\?]/, 1);
	if (parts.length) return parts[0];
	return lang;
}
function resolveWithBaseUri(baseUri, href) {
	if (/^\w[\w\d+.-]*:/.test(href)) return href;
	if (baseUri.path.endsWith("/")) return resolvePath(baseUri, href).toString();
	else return resolvePath(dirname(baseUri), href).toString();
}
function isLocalFileUri(uri) {
	return uri.scheme === Schemas.file && !uri.authority && !isUNC(uri.fsPath);
}
function isMediaSourceAllowed(mdStrConfig, source, remoteImageIsAllowed) {
	let uri;
	try {
		const baseUri = mdStrConfig.baseUri ? URI.from(mdStrConfig.baseUri) : void 0;
		if (!/^\w[\w\d+.-]*:/.test(source) && baseUri?.scheme === Schemas.file && !isLocalFileUri(baseUri)) return false;
		const href = baseUri ? resolveWithBaseUri(baseUri, source) : source;
		uri = URI.parse(href);
	} catch {
		return false;
	}
	return isLocalFileUri(uri) || uri.scheme === Schemas.data || remoteImageIsAllowed(uri);
}
function sanitizeRenderedMarkdown(renderedMarkdown, originalMdStrConfig, options = {}) {
	return sanitizeHtml(renderedMarkdown, getDomSanitizerConfig(originalMdStrConfig, options));
}
var allowedMarkdownHtmlTags = Object.freeze([...basicMarkupHtmlTags, "input"]);
var allowedMarkdownHtmlAttributes = Object.freeze([
	"align",
	"autoplay",
	"alt",
	"colspan",
	"controls",
	"draggable",
	"height",
	"href",
	"loop",
	"muted",
	"playsinline",
	"poster",
	"rowspan",
	"src",
	"target",
	"title",
	"type",
	"width",
	"start",
	"checked",
	"disabled",
	"value",
	"data-code",
	"data-href",
	"data-severity",
	{
		attributeName: "style",
		shouldKeep: (element, data) => {
			if (element.tagName === "SPAN") {
				if (data.attrName === "style") return /^(color\:(#[0-9a-fA-F]+|var\(--vscode(-[a-zA-Z0-9]+)+\));)?(background-color\:(#[0-9a-fA-F]+|var\(--vscode(-[a-zA-Z0-9]+)+\));)?(display\:inline-block;)?(border-radius:[0-9]+px;)?$/.test(data.attrValue);
			}
			return false;
		}
	},
	{
		attributeName: "class",
		shouldKeep: (element, data) => {
			if (element.tagName === "SPAN") {
				if (data.attrName === "class") return /^codicon codicon-[a-z\-]+( codicon-modifier-[a-z\-]+)?$/.test(data.attrValue);
			}
			return false;
		}
	}
]);
function getDomSanitizerConfig(mdStrConfig, options) {
	const isTrusted = mdStrConfig.isTrusted ?? false;
	const remoteImageIsAllowed = options.remoteImageIsAllowed;
	const allowedLinkSchemes = [
		Schemas.http,
		Schemas.https,
		Schemas.mailto,
		Schemas.file,
		Schemas.vscodeFileResource,
		Schemas.vscodeRemote,
		Schemas.vscodeRemoteResource,
		Schemas.vscodeNotebookCell,
		Schemas.internal
	];
	if (isTrusted) allowedLinkSchemes.push(Schemas.command);
	if (options.allowedLinkSchemes?.augment) allowedLinkSchemes.push(...options.allowedLinkSchemes.augment);
	return {
		allowedTags: { override: options.allowedTags?.override ?? allowedMarkdownHtmlTags },
		allowedAttributes: { override: options.allowedAttributes?.override ?? allowedMarkdownHtmlAttributes },
		allowedLinkProtocols: { override: allowedLinkSchemes },
		allowRelativeLinkPaths: !!mdStrConfig.baseUri,
		allowedMediaProtocols: { override: [
			Schemas.http,
			Schemas.https,
			Schemas.data,
			Schemas.file,
			Schemas.vscodeFileResource,
			Schemas.vscodeRemote,
			Schemas.vscodeRemoteResource
		] },
		allowRelativeMediaPaths: !!mdStrConfig.baseUri,
		mediaSourceIsAllowed: remoteImageIsAllowed ? (source) => isMediaSourceAllowed(mdStrConfig, source, remoteImageIsAllowed) : void 0,
		replaceWithPlaintext: options.replaceWithPlaintext
	};
}
/**
* Renders `str` as plaintext, stripping out Markdown syntax if it's a {@link IMarkdownString}.
*
* For example `# Header` would be output as `Header`.
*/
function renderAsPlaintext(str, options) {
	if (typeof str === "string") return str;
	let value = str.value ?? "";
	if (value.length > 1e5) value = `${value.substr(0, 1e5)}…`;
	const renderer = createPlainTextRenderer();
	return sanitizeRenderedMarkdown(parse$2(value, {
		async: false,
		renderer
	}), { isTrusted: false }, {}).toString().replace(/&(#\d+|[a-zA-Z]+);/g, (m) => unescapeInfo.get(m) ?? m).trim();
}
var unescapeInfo = /* @__PURE__ */ new Map([
	["&quot;", "\""],
	["&nbsp;", " "],
	["&amp;", "&"],
	["&#39;", "'"],
	["&lt;", "<"],
	["&gt;", ">"]
]);
function createPlainTextRenderer() {
	const renderer = new _Renderer();
	renderer.code = ({ text }) => {
		return escape$2(text);
	};
	renderer.blockquote = ({ text }) => {
		return text + "\n";
	};
	renderer.html = (_) => {
		return "";
	};
	renderer.heading = function({ tokens }) {
		return this.parser.parseInline(tokens) + "\n";
	};
	renderer.hr = () => {
		return "";
	};
	renderer.list = function({ items }) {
		return items.map((x) => this.listitem(x)).join("\n") + "\n";
	};
	renderer.listitem = ({ text }) => {
		return text + "\n";
	};
	renderer.paragraph = function({ tokens }) {
		return this.parser.parseInline(tokens) + "\n";
	};
	renderer.table = function({ header, rows }) {
		return header.map((cell) => this.tablecell(cell)).join(" ") + "\n" + rows.map((cells) => cells.map((cell) => this.tablecell(cell)).join(" ")).join("\n") + "\n";
	};
	renderer.tablerow = ({ text }) => {
		return text;
	};
	renderer.tablecell = function({ tokens }) {
		return this.parser.parseInline(tokens);
	};
	renderer.strong = ({ text }) => {
		return text;
	};
	renderer.em = ({ text }) => {
		return text;
	};
	renderer.codespan = ({ text }) => {
		return text;
	};
	renderer.br = (_) => {
		return "\n";
	};
	renderer.del = ({ text }) => {
		return text;
	};
	renderer.image = (_) => {
		return "";
	};
	renderer.text = ({ text }) => {
		return text;
	};
	renderer.link = ({ text }) => {
		return text;
	};
	return renderer;
}
function mergeRawTokenText(tokens) {
	let mergedTokenText = "";
	tokens.forEach((token) => {
		mergedTokenText += token.raw;
	});
	return mergedTokenText;
}
function completeSingleLinePattern(token) {
	if (!token.tokens) return;
	for (let i = token.tokens.length - 1; i >= 0; i--) {
		const subtoken = token.tokens[i];
		if (subtoken.type === "text") {
			const lines = subtoken.raw.split("\n");
			const lastLine = lines[lines.length - 1];
			if (hasLinkTextAndStartOfLinkTarget(lastLine) || hasStartOfLinkTargetAndNoLinkText(lastLine) && token.tokens.slice(0, i).some((t) => t.type === "text" && t.raw.match(/\[[^\]]*$/))) {
				const nextTwoSubTokens = token.tokens.slice(i + 1);
				if (nextTwoSubTokens[0]?.type === "link" && nextTwoSubTokens[1]?.type === "text" && nextTwoSubTokens[1].raw.match(/^ *"[^"]*$/) || lastLine.match(/^[^"]* +"[^"]*$/)) return completeLinkTargetArg(token);
				return completeLinkTarget(token);
			} else if (lastLine.includes("`")) return completeCodespan(token);
			else if (lastLine.includes("**")) return completeDoublestar(token);
			else if (lastLine.match(/\*\w/)) return completeStar(token);
			else if (lastLine.match(/(^|\s)__\w/)) return completeDoubleUnderscore(token);
			else if (lastLine.match(/(^|\s)_\w/)) return completeUnderscore(token);
			else if (lastLine.match(/(^|\s)\[\w*[^\]]*$/)) return completeLinkText(token);
		}
	}
}
function hasLinkTextAndStartOfLinkTarget(str) {
	return !!str.match(/(?:^|[\s(*_~])\[.*\]\(\w*/);
}
function hasStartOfLinkTargetAndNoLinkText(str) {
	return !!str.match(/^[^\[]*\]\([^\)]*$/);
}
function completeBlockquotePattern(blockquote, links) {
	let lastInterestingIndex = blockquote.tokens.length - 1;
	while (lastInterestingIndex >= 0 && blockquote.tokens[lastInterestingIndex].type === "space") lastInterestingIndex--;
	const lastToken = blockquote.tokens[lastInterestingIndex];
	if (lastToken?.type !== "paragraph") return;
	const completedToken = completeSingleLinePattern(lastToken);
	if (!completedToken) return;
	const completion = completedToken.raw.slice(lastToken.raw.trimEnd().length);
	const trailingQuoteOnlyLines = blockquote.raw.match(/(?:\n[ \t]*>[ \t]*(?=\n|$))+\n?$/)?.[0] ?? "";
	const insertionIndex = blockquote.raw.length - trailingQuoteOnlyLines.length;
	const completedRaw = blockquote.raw.slice(0, insertionIndex) + completion + trailingQuoteOnlyLines;
	const lexer = new _Lexer();
	lexer.tokens.links = links;
	const completedBlockquote = lexer.lex(completedRaw)[0];
	if (completedBlockquote.type === "blockquote") return completedBlockquote;
}
function completeListItemPattern(list) {
	const lastListItem = list.items[list.items.length - 1];
	const lastListSubToken = lastListItem.tokens ? lastListItem.tokens[lastListItem.tokens.length - 1] : void 0;
	const listEndsInHeading = (list) => {
		const lastToken = list.items.at(-1)?.tokens.at(-1);
		return lastToken?.type === "heading" || lastToken?.type === "list" && listEndsInHeading(lastToken);
	};
	let newToken;
	if (lastListSubToken?.type === "text" && !("inRawBlock" in lastListItem)) newToken = completeSingleLinePattern(lastListSubToken);
	else if (listEndsInHeading(list)) {
		const newList = lexer(list.raw.trim() + " &nbsp;")[0];
		if (newList.type !== "list") return;
		return newList;
	}
	if (!newToken || newToken.type !== "paragraph") return;
	const previousListItemsText = mergeRawTokenText(list.items.slice(0, -1));
	const lastListItemLead = lastListItem.raw.match(/^(\s*(-|\d+\.|\*) +)/)?.[0];
	if (!lastListItemLead) return;
	const newList = lexer(previousListItemsText + (lastListItemLead + mergeRawTokenText(lastListItem.tokens.slice(0, -1)) + newToken.raw))[0];
	if (newList.type !== "list") return;
	return newList;
}
function completeHeading(token, fullRawText) {
	if (token.raw.match(/-\s*$/)) return lexer(fullRawText + " &nbsp;");
}
var maxIncompleteTokensFixRounds = 3;
function fillInIncompleteTokens(tokens) {
	for (let i = 0; i < maxIncompleteTokensFixRounds; i++) {
		const newTokens = fillInIncompleteTokensOnce(tokens);
		if (newTokens) tokens = newTokens;
		else break;
	}
	return tokens;
}
function fillInIncompleteTokensOnce(tokens) {
	let i;
	let newTokens;
	for (i = 0; i < tokens.length; i++) {
		const token = tokens[i];
		if (token.type === "paragraph" && token.raw.match(/(\n|^)\|/)) {
			newTokens = completeTable(tokens.slice(i));
			break;
		}
	}
	let lastInterestingIdx = tokens.length - 1;
	while (lastInterestingIdx >= 0 && (tokens[lastInterestingIdx].type === "space" || tokens[lastInterestingIdx].type === "html")) lastInterestingIdx--;
	const lastInterestingToken = lastInterestingIdx >= 0 ? tokens[lastInterestingIdx] : void 0;
	const trailingTokens = tokens.slice(lastInterestingIdx + 1);
	if (!newTokens && lastInterestingToken?.type === "list") {
		const newListToken = completeListItemPattern(lastInterestingToken);
		if (newListToken) {
			newTokens = [newListToken, ...trailingTokens];
			i = lastInterestingIdx;
		}
	}
	if (!newTokens && lastInterestingToken?.type === "blockquote") {
		const newBlockquoteToken = completeBlockquotePattern(lastInterestingToken, tokens.links);
		if (newBlockquoteToken) {
			newTokens = [newBlockquoteToken, ...trailingTokens];
			i = lastInterestingIdx;
		}
	}
	if (!newTokens && lastInterestingToken?.type === "paragraph") {
		const newToken = completeSingleLinePattern(lastInterestingToken);
		if (newToken) {
			newTokens = [newToken, ...trailingTokens];
			i = lastInterestingIdx;
		}
	}
	if (newTokens) {
		const newTokensList = [...tokens.slice(0, i), ...newTokens];
		newTokensList.links = tokens.links;
		return newTokensList;
	}
	const lastToken = tokens.at(-1);
	if (lastToken?.type === "heading") {
		const completeTokens = completeHeading(lastToken, mergeRawTokenText(tokens));
		if (completeTokens) return completeTokens;
	}
	return null;
}
function completeCodespan(token) {
	return completeWithString(token, "`");
}
function completeStar(tokens) {
	return completeWithString(tokens, "*");
}
function completeUnderscore(tokens) {
	return completeWithString(tokens, "_");
}
function completeLinkTarget(tokens) {
	return completeWithString(tokens, ")", false);
}
function completeLinkTargetArg(tokens) {
	return completeWithString(tokens, "\")", false);
}
function completeLinkText(tokens) {
	return completeWithString(tokens, "](https://microsoft.com)", false);
}
function completeDoublestar(tokens) {
	return completeWithString(tokens, "**");
}
function completeDoubleUnderscore(tokens) {
	return completeWithString(tokens, "__");
}
function completeWithString(tokens, closingString, shouldTrim = true) {
	const mergedRawText = mergeRawTokenText(Array.isArray(tokens) ? tokens : [tokens]);
	return lexer((shouldTrim ? mergedRawText.trimEnd() : mergedRawText) + closingString)[0];
}
function completeTable(tokens) {
	const mergedRawText = mergeRawTokenText(tokens);
	const lines = mergedRawText.split("\n");
	let numCols;
	let hasSeparatorRow = false;
	for (let i = 0; i < lines.length; i++) {
		const line = lines[i].trim();
		if (typeof numCols === "undefined" && line.match(/^\s*\|/)) {
			const line1Matches = line.match(/(\|[^\|]+)(?=\||$)/g);
			if (line1Matches) numCols = line1Matches.length;
		} else if (typeof numCols === "number") {
			if (line.match(/^\s*\|/)) {
				if (i !== lines.length - 1) return;
				hasSeparatorRow = true;
			} else return;
		}
	}
	if (typeof numCols === "number" && numCols > 0) {
		const prefixText = hasSeparatorRow ? lines.slice(0, -1).join("\n") : mergedRawText;
		return lexer(prefixText + (!!prefixText.match(/\|\s*$/) ? "" : "|") + `\n|${" --- |".repeat(numCols)}`);
	}
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/opener/common/opener.js
var IOpenerService = createDecorator("openerService");
/**
* Encodes selection into the `URI`.
*
* IMPORTANT: you MUST use `extractSelection` to separate the selection
* again from the original `URI` before passing the `URI` into any
* component that is not aware of selections.
*/
function withSelection(uri, selection) {
	return uri.with({ fragment: `${selection.startLineNumber},${selection.startColumn}${selection.endLineNumber ? `-${selection.endLineNumber}${selection.endColumn ? `,${selection.endColumn}` : ""}` : ""}` });
}
/**
* file:///some/file.js#73
* file:///some/file.js#L73
* file:///some/file.js#73,84
* file:///some/file.js#L73,84
* file:///some/file.js#73-83
* file:///some/file.js#L73-L83
* file:///some/file.js#73,84-83,52
* file:///some/file.js#L73,84-L83,52
*/
function extractSelection(uri) {
	let selection = void 0;
	const match = /^L?(\d+)(?:,(\d+))?(-L?(\d+)(?:,(\d+))?)?/.exec(uri.fragment);
	if (match) {
		selection = {
			startLineNumber: parseInt(match[1]),
			startColumn: match[2] ? parseInt(match[2]) : 1,
			endLineNumber: match[4] ? parseInt(match[4]) : void 0,
			endColumn: match[4] ? match[5] ? parseInt(match[5]) : 1 : void 0
		};
		uri = uri.with({ fragment: "" });
	}
	return {
		selection,
		uri
	};
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/markdown/browser/markdownRenderer.js
var __decorate$52 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$47 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var IMarkdownRendererService = createDecorator("markdownRendererService");
var MarkdownRendererService = class MarkdownRendererService {
	constructor(_openerService) {
		this._openerService = _openerService;
	}
	render(markdown, options, outElement) {
		const resolvedOptions = { ...options };
		if (!resolvedOptions.actionHandler) resolvedOptions.actionHandler = (link, mdStr) => {
			return openLinkFromMarkdown(this._openerService, link, mdStr.isTrusted);
		};
		if (!resolvedOptions.codeBlockRenderer) resolvedOptions.codeBlockRenderer = (alias, value) => {
			return this._defaultCodeBlockRenderer?.renderCodeBlock(alias, value, resolvedOptions ?? {}) ?? Promise.resolve(document.createElement("span"));
		};
		const rendered = renderMarkdown(markdown, resolvedOptions, outElement);
		rendered.element.classList.add("rendered-markdown");
		return rendered;
	}
	setDefaultCodeBlockRenderer(renderer) {
		this._defaultCodeBlockRenderer = renderer;
	}
};
MarkdownRendererService = __decorate$52([__param$47(0, IOpenerService)], MarkdownRendererService);
async function openLinkFromMarkdown(openerService, link, isTrusted, skipValidation) {
	try {
		return await openerService.open(link, {
			fromUserGesture: true,
			allowContributedOpeners: true,
			allowCommands: toAllowCommandsOption(isTrusted),
			skipValidation
		});
	} catch (e) {
		onUnexpectedError(e);
		return false;
	}
}
function toAllowCommandsOption(isTrusted) {
	if (isTrusted === true) return true;
	if (isTrusted && Array.isArray(isTrusted.enabledCommands)) return isTrusted.enabledCommands;
	return false;
}
registerSingleton(IMarkdownRendererService, MarkdownRendererService, 1);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/hover/browser/hoverWidget.js
var __decorate$51 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$46 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var $$8 = $$10;
var HoverWidget = class HoverWidget extends Widget$1 {
	get _targetWindow() {
		return getWindow(this._target.targetElements[0]);
	}
	get _targetDocumentElement() {
		return getWindow(this._target.targetElements[0]).document.documentElement;
	}
	get isDisposed() {
		return this._isDisposed;
	}
	get isMouseIn() {
		return this._lockMouseTracker.isMouseIn;
	}
	get domNode() {
		return this._hover.containerDomNode;
	}
	get onDispose() {
		return this._onDispose.event;
	}
	get onRequestLayout() {
		return this._onRequestLayout.event;
	}
	get anchor() {
		return this._hoverPosition === 2 ? 0 : 1;
	}
	get x() {
		return this._x;
	}
	get y() {
		return this._y;
	}
	/**
	* Whether the hover is "locked" by holding the alt/option key. When locked, the hover will not
	* hide and can be hovered regardless of whether the `hideOnHover` hover option is set.
	*/
	get isLocked() {
		return this._isLocked;
	}
	set isLocked(value) {
		if (this._isLocked === value) return;
		this._isLocked = value;
		this._hoverContainer.classList.toggle("locked", this._isLocked);
	}
	/**
	* Adds an element to be tracked by this hover's mouse tracker. Mouse events on
	* this element will be considered as being "inside" the hover, preventing it
	* from closing. This is used for nested hovers where the child hover's container
	* should be treated as part of the parent hover.
	*/
	addMouseTrackingElement(element) {
		return this._lockMouseTracker.addElement(element);
	}
	constructor(options, _keybindingService, _configurationService, _markdownRenderer, _accessibilityService) {
		super();
		this._keybindingService = _keybindingService;
		this._configurationService = _configurationService;
		this._markdownRenderer = _markdownRenderer;
		this._accessibilityService = _accessibilityService;
		this._messageListeners = new DisposableStore();
		this._isDisposed = false;
		this._forcePosition = false;
		this._x = 0;
		this._y = 0;
		this._isLocked = false;
		this._enableFocusTraps = false;
		this._addedFocusTrap = false;
		this._maxHeightRatioRelativeToWindow = .5;
		this._onDispose = this._register(new Emitter$1());
		this._onRequestLayout = this._register(new Emitter$1());
		this._linkHandler = options.linkHandler;
		this._target = "targetElements" in options.target ? options.target : new ElementHoverTarget(options.target);
		this._anchorAlignment = options.position?.anchorAlignment ?? 0;
		if (options.style) switch (options.style) {
			case 1:
				options.appearance ??= {};
				options.appearance.compact ??= true;
				options.appearance.showPointer ??= true;
				break;
			case 2:
				options.appearance ??= {};
				options.appearance.compact ??= true;
		}
		this._hoverPointer = options.appearance?.showPointer ? $$8("div.workbench-hover-pointer") : void 0;
		this._hover = this._register(new HoverWidget$1(!options.appearance?.skipFadeInAnimation));
		this._hover.containerDomNode.classList.add("workbench-hover");
		if (options.appearance?.compact) this._hover.containerDomNode.classList.add("workbench-hover", "compact");
		if (this._hoverPointer) this._hover.containerDomNode.classList.add("with-pointer");
		if (options.additionalClasses) this._hover.containerDomNode.classList.add(...options.additionalClasses);
		if (options.position?.forcePosition) this._forcePosition = true;
		if (options.trapFocus) this._enableFocusTraps = true;
		const maxHeightRatio = options.appearance?.maxHeightRatio;
		if (maxHeightRatio !== void 0 && maxHeightRatio > 0 && maxHeightRatio <= 1) this._maxHeightRatioRelativeToWindow = maxHeightRatio;
		this._hoverPosition = options.position?.hoverPosition === void 0 ? 3 : isNumber$1(options.position.hoverPosition) ? options.position.hoverPosition : 2;
		this.onmousedown(this._hover.containerDomNode, (e) => e.stopPropagation());
		this.onkeydown(this._hover.containerDomNode, (e) => {
			if (e.equals(9)) this.dispose();
		});
		this._register(addDisposableListener(this._targetWindow, "blur", () => this.dispose()));
		const rowElement = $$8("div.hover-row.markdown-hover");
		const contentsElement = $$8("div.hover-contents");
		if (typeof options.content === "string") {
			contentsElement.textContent = options.content;
			contentsElement.style.whiteSpace = "pre-wrap";
		} else if (isHTMLElement(options.content)) {
			contentsElement.appendChild(options.content);
			contentsElement.classList.add("html-hover-contents");
			const resizeObserver = new ResizeObserver(() => {
				this.layout();
				this._onRequestLayout.fire();
			});
			resizeObserver.observe(contentsElement);
			this._register(toDisposable(() => resizeObserver.disconnect()));
		} else {
			const markdown = options.content;
			const { element } = this._register(this._markdownRenderer.render(markdown, {
				actionHandler: this._linkHandler,
				asyncRenderCallback: () => {
					contentsElement.classList.add("code-hover-contents");
					this.layout();
					this._onRequestLayout.fire();
				}
			}));
			contentsElement.appendChild(element);
		}
		rowElement.appendChild(contentsElement);
		this._hover.contentsDomNode.appendChild(rowElement);
		if (options.actions && options.actions.length > 0) {
			const statusBarElement = $$8("div.hover-row.status-bar");
			const actionsElement = $$8("div.actions");
			options.actions.forEach((action) => {
				const keybinding = this._keybindingService.lookupKeybinding(action.commandId);
				const keybindingLabel = keybinding ? keybinding.getLabel() : null;
				this._register(HoverAction.render(actionsElement, {
					label: action.label,
					commandId: action.commandId,
					run: (e) => {
						action.run(e);
						this.dispose();
					},
					iconClass: action.iconClass
				}, keybindingLabel));
			});
			statusBarElement.appendChild(actionsElement);
			this._hover.containerDomNode.appendChild(statusBarElement);
		}
		this._hoverContainer = $$8("div.workbench-hover-container");
		if (this._hoverPointer) this._hoverContainer.appendChild(this._hoverPointer);
		this._hoverContainer.appendChild(this._hover.containerDomNode);
		let hideOnHover;
		if (options.actions && options.actions.length > 0) hideOnHover = false;
		else if (options.persistence?.hideOnHover === void 0) hideOnHover = typeof options.content === "string" || isMarkdownString(options.content) && !options.content.value.includes("](") && !options.content.value.includes("</a>");
		else hideOnHover = options.persistence.hideOnHover;
		if (options.appearance?.showHoverHint) {
			const statusBarElement = $$8("div.hover-row.status-bar");
			const infoElement = $$8("div.info");
			infoElement.textContent = localize(1794, "Hold {0} key to mouse over", isMacintosh ? "Option" : "Alt");
			statusBarElement.appendChild(infoElement);
			this._hover.containerDomNode.appendChild(statusBarElement);
		}
		const mouseTrackerTargets = [...this._target.targetElements];
		if (!hideOnHover) mouseTrackerTargets.push(this._hoverContainer);
		const mouseTracker = this._mouseTracker = this._register(new CompositeMouseTracker(mouseTrackerTargets));
		this._register(mouseTracker.onMouseOut(() => {
			if (!this._isLocked) this.dispose();
		}));
		if (hideOnHover) {
			const mouseTracker2Targets = [...this._target.targetElements, this._hoverContainer];
			this._lockMouseTracker = this._register(new CompositeMouseTracker(mouseTracker2Targets));
			this._register(this._lockMouseTracker.onMouseOut(() => {
				if (!this._isLocked) this.dispose();
			}));
		} else this._lockMouseTracker = mouseTracker;
	}
	addFocusTrap() {
		if (!this._enableFocusTraps || this._addedFocusTrap) return;
		this._addedFocusTrap = true;
		const firstContainerFocusElement = this._hover.containerDomNode;
		const lastContainerFocusElement = this.findLastFocusableChild(this._hover.containerDomNode);
		if (lastContainerFocusElement) {
			const beforeContainerFocusElement = prepend$2(this._hoverContainer, $$8("div"));
			const afterContainerFocusElement = append$2(this._hoverContainer, $$8("div"));
			beforeContainerFocusElement.tabIndex = 0;
			afterContainerFocusElement.tabIndex = 0;
			this._register(addDisposableListener(afterContainerFocusElement, "focus", (e) => {
				firstContainerFocusElement.focus();
				e.preventDefault();
			}));
			this._register(addDisposableListener(beforeContainerFocusElement, "focus", (e) => {
				lastContainerFocusElement.focus();
				e.preventDefault();
			}));
		}
	}
	findLastFocusableChild(root) {
		if (root.hasChildNodes()) for (let i = 0; i < root.childNodes.length; i++) {
			const node = root.childNodes.item(root.childNodes.length - i - 1);
			if (node.nodeType === node.ELEMENT_NODE) {
				const parsedNode = node;
				if (typeof parsedNode.tabIndex === "number" && parsedNode.tabIndex >= 0) return parsedNode;
			}
			const recursivelyFoundElement = this.findLastFocusableChild(node);
			if (recursivelyFoundElement) return recursivelyFoundElement;
		}
	}
	render(container) {
		container.appendChild(this._hoverContainer);
		const accessibleViewHint = this._hoverContainer.contains(this._hoverContainer.ownerDocument.activeElement) && getHoverAccessibleViewHint(this._configurationService.getValue("accessibility.verbosity.hover") === true && this._accessibilityService.isScreenReaderOptimized(), this._keybindingService.lookupKeybinding("editor.action.accessibleView")?.getAriaLabel());
		if (accessibleViewHint) status(accessibleViewHint);
		this.layout();
		this.addFocusTrap();
	}
	layout() {
		this._mouseTracker?.suppressPendingMouseOut();
		if (this._lockMouseTracker !== this._mouseTracker) this._lockMouseTracker?.suppressPendingMouseOut();
		this._hover.containerDomNode.classList.remove("right-aligned");
		this._hover.contentsDomNode.style.maxHeight = "";
		this._hover.containerDomNode.style.maxWidth = "";
		const getZoomAccountedBoundingClientRect = (e) => {
			const zoom = getDomNodeZoomLevel(e);
			const boundingRect = e.getBoundingClientRect();
			return {
				top: boundingRect.top * zoom,
				bottom: boundingRect.bottom * zoom,
				right: boundingRect.right * zoom,
				left: boundingRect.left * zoom
			};
		};
		const { top, right, bottom, left } = this._target.targetElements.map((e) => getZoomAccountedBoundingClientRect(e))[0];
		const width = right - left;
		const height = bottom - top;
		const targetRect = {
			top,
			right,
			bottom,
			left,
			width,
			height,
			center: {
				x: left + width / 2,
				y: top + height / 2
			}
		};
		this.adjustHorizontalHoverPosition(targetRect);
		this.adjustVerticalHoverPosition(targetRect);
		this.adjustHoverMaxHeight(targetRect);
		this._hoverContainer.style.padding = "";
		this._hoverContainer.style.margin = "";
		if (this._hoverPointer) {
			switch (this._hoverPosition) {
				case 1:
					targetRect.left += 3;
					targetRect.right += 3;
					this._hoverContainer.style.paddingLeft = `3px`;
					this._hoverContainer.style.marginLeft = `-3px`;
					break;
				case 0:
					targetRect.left -= 3;
					targetRect.right -= 3;
					this._hoverContainer.style.paddingRight = `3px`;
					this._hoverContainer.style.marginRight = `-3px`;
					break;
				case 2:
					targetRect.top += 3;
					targetRect.bottom += 3;
					this._hoverContainer.style.paddingTop = `3px`;
					this._hoverContainer.style.marginTop = `-3px`;
					break;
				case 3:
					targetRect.top -= 3;
					targetRect.bottom -= 3;
					this._hoverContainer.style.paddingBottom = `3px`;
					this._hoverContainer.style.marginBottom = `-3px`;
			}
			targetRect.center.x = targetRect.left + width / 2;
			targetRect.center.y = targetRect.top + height / 2;
		}
		this.computeXCordinate(targetRect);
		this.computeYCordinate(targetRect);
		if (this._hoverPointer) {
			this._hoverPointer.classList.remove("top");
			this._hoverPointer.classList.remove("left");
			this._hoverPointer.classList.remove("right");
			this._hoverPointer.classList.remove("bottom");
			this.setHoverPointerPosition(targetRect);
		}
		this._hover.onContentsChanged();
	}
	computeXCordinate(target) {
		const hoverWidth = this._hover.containerDomNode.clientWidth + 2;
		const documentElementClientLeft = this._targetDocumentElement.clientLeft;
		if (this._target.x !== void 0) this._x = this._target.x;
		else if (this._hoverPosition === 1) this._x = target.right;
		else if (this._hoverPosition === 0) this._x = target.left - hoverWidth;
		else {
			if (this._anchorAlignment === 1) this._x = target.right - hoverWidth;
			else if (this._hoverPointer) this._x = target.center.x - this._hover.containerDomNode.clientWidth / 2;
			else this._x = target.left;
			const documentElementClientWidth = this._targetDocumentElement.clientWidth;
			if (this._x + hoverWidth >= documentElementClientWidth) {
				this._hover.containerDomNode.classList.add("right-aligned");
				this._x = Math.max(documentElementClientWidth - hoverWidth - 2, documentElementClientLeft);
			}
		}
		if (this._x < documentElementClientLeft) this._x = target.left + 2;
	}
	computeYCordinate(target) {
		if (this._target.y !== void 0) this._y = this._target.y;
		else if (this._hoverPosition === 3) this._y = target.top;
		else if (this._hoverPosition === 2) this._y = target.bottom - 2;
		else if (this._hoverPointer) this._y = target.center.y + this._hover.containerDomNode.clientHeight / 2;
		else this._y = target.bottom;
		if (this._y > this._targetWindow.innerHeight) this._y = target.bottom;
	}
	adjustHorizontalHoverPosition(target) {
		if (this._target.x !== void 0) return;
		if (this._anchorAlignment === 1 && (this._hoverPosition === 3 || this._hoverPosition === 2)) {
			const availableWidth = target.right - this._targetDocumentElement.clientLeft - 2 - 2;
			if (this._hover.containerDomNode.clientWidth > availableWidth) this._hover.containerDomNode.style.maxWidth = `${Math.max(availableWidth, 0)}px`;
			return;
		}
		const hoverPointerOffset = this._hoverPointer ? 3 : 0;
		if (this._forcePosition) {
			const padding = hoverPointerOffset + 2;
			if (this._hoverPosition === 1) this._hover.containerDomNode.style.maxWidth = `${this._targetDocumentElement.clientWidth - target.right - padding}px`;
			else if (this._hoverPosition === 0) this._hover.containerDomNode.style.maxWidth = `${target.left - padding}px`;
			return;
		}
		if (this._hoverPosition === 1) {
			if (this._targetDocumentElement.clientWidth - target.right < this._hover.containerDomNode.clientWidth + hoverPointerOffset) {
				if (target.left >= this._hover.containerDomNode.clientWidth + hoverPointerOffset) this._hoverPosition = 0;
				else this._hoverPosition = 2;
			}
		} else if (this._hoverPosition === 0) {
			if (target.left < this._hover.containerDomNode.clientWidth + hoverPointerOffset) {
				if (this._targetDocumentElement.clientWidth - target.right >= this._hover.containerDomNode.clientWidth + hoverPointerOffset) this._hoverPosition = 1;
				else this._hoverPosition = 2;
			}
			if (target.left - this._hover.containerDomNode.clientWidth - hoverPointerOffset <= this._targetDocumentElement.clientLeft) this._hoverPosition = 1;
		}
	}
	adjustVerticalHoverPosition(target) {
		if (this._target.y !== void 0 || this._forcePosition) return;
		const hoverPointerOffset = this._hoverPointer ? 3 : 0;
		if (this._hoverPosition === 3) {
			if (target.top - this._hover.containerDomNode.clientHeight - hoverPointerOffset < 0) this._hoverPosition = 2;
		} else if (this._hoverPosition === 2) {
			if (target.bottom + this._hover.containerDomNode.offsetHeight + hoverPointerOffset > this._targetWindow.innerHeight) this._hoverPosition = 3;
		}
	}
	adjustHoverMaxHeight(target) {
		let maxHeight = this._targetWindow.innerHeight * this._maxHeightRatioRelativeToWindow;
		if (this._forcePosition) {
			const padding = (this._hoverPointer ? 3 : 0) + 2;
			if (this._hoverPosition === 3) maxHeight = Math.min(maxHeight, target.top - padding);
			else if (this._hoverPosition === 2) maxHeight = Math.min(maxHeight, this._targetWindow.innerHeight - target.bottom - padding);
		}
		this._hover.containerDomNode.style.maxHeight = "";
		const heightOutsideContents = this._hover.containerDomNode.offsetHeight - this._hover.contentsDomNode.offsetHeight;
		const contentsMaxHeight = Math.max(0, maxHeight - heightOutsideContents);
		this._hover.containerDomNode.style.maxHeight = `${maxHeight}px`;
		this._hover.contentsDomNode.style.maxHeight = `${contentsMaxHeight}px`;
		if (this._hover.contentsDomNode.clientHeight < this._hover.contentsDomNode.scrollHeight) {
			const extraRightPadding = `${this._hover.scrollbar.options.verticalScrollbarSize}px`;
			if (this._hover.contentsDomNode.style.paddingRight !== extraRightPadding) this._hover.contentsDomNode.style.paddingRight = extraRightPadding;
		}
	}
	setHoverPointerPosition(target) {
		if (!this._hoverPointer) return;
		switch (this._hoverPosition) {
			case 0:
			case 1: {
				this._hoverPointer.classList.add(this._hoverPosition === 0 ? "right" : "left");
				const hoverHeight = this._hover.containerDomNode.clientHeight;
				if (hoverHeight > target.height) this._hoverPointer.style.top = `${target.center.y - (this._y - hoverHeight) - 3}px`;
				else this._hoverPointer.style.top = `${hoverHeight / 2 - 3}px`;
				break;
			}
			case 3:
			case 2: {
				this._hoverPointer.classList.add(this._hoverPosition === 3 ? "bottom" : "top");
				let pointerLeftPosition = this._hover.containerDomNode.clientWidth / 2 - 3;
				const pointerX = this._x + pointerLeftPosition;
				if (pointerX < target.left || pointerX > target.right) pointerLeftPosition = target.center.x - this._x - 3;
				this._hoverPointer.style.left = `${pointerLeftPosition}px`;
				break;
			}
		}
	}
	focus() {
		this._hover.containerDomNode.focus();
	}
	dispose() {
		if (!this._isDisposed) {
			this._onDispose.fire();
			this._target.dispose?.();
			this._hoverContainer.remove();
			this._messageListeners.dispose();
			super.dispose();
		}
		this._isDisposed = true;
	}
};
HoverWidget = __decorate$51([
	__param$46(1, IKeybindingService),
	__param$46(2, IConfigurationService),
	__param$46(3, IMarkdownRendererService),
	__param$46(4, IAccessibilityService)
], HoverWidget);
var CompositeMouseTracker = class extends Widget$1 {
	get onMouseOut() {
		return this._onMouseOut.event;
	}
	get isMouseIn() {
		return this._isMouseIn;
	}
	/**
	* @param _elements The target elements to track mouse in/out events on.
	* @param _eventDebounceDelay The delay in ms to debounce the event firing. This is used to
	* allow a short period for the mouse to move into the hover or a nearby target element. For
	* example hovering a scroll bar will not hide the hover immediately.
	*/
	constructor(_elements, _eventDebounceDelay = 200) {
		super();
		this._elements = _elements;
		this._eventDebounceDelay = _eventDebounceDelay;
		this._isMouseIn = true;
		this._suppressNextMouseOut = false;
		this._mouseTimer = this._register(new MutableDisposable());
		this._onMouseOut = this._register(new Emitter$1());
		for (const element of this._elements) {
			this.onmouseover(element, () => this._onTargetMouseOver());
			this.onmouseleave(element, () => this._onTargetMouseLeave());
		}
	}
	_onTargetMouseOver() {
		this._isMouseIn = true;
		this._suppressNextMouseOut = false;
		this._mouseTimer.clear();
	}
	_onTargetMouseLeave() {
		this._isMouseIn = false;
		this._mouseTimer.value = new TimeoutTimer(() => this._fireIfMouseOutside(), this._eventDebounceDelay);
	}
	_fireIfMouseOutside() {
		if (!this._isMouseIn && !this._suppressNextMouseOut) this._onMouseOut.fire();
	}
	/**
	* Suppresses the next pending mouseout dismissal. Call this when tracked
	* elements are being resized or repositioned to avoid spurious dismissals
	* caused by the element shrinking away from the cursor. The suppression
	* is cleared when the mouse next enters a tracked element.
	*/
	suppressPendingMouseOut() {
		if (!this._isMouseIn) this._suppressNextMouseOut = true;
	}
	/**
	* Adds an element to be tracked by this mouse tracker. Mouse events on this
	* element will be considered as being "inside" the tracked area.
	*/
	addElement(element) {
		if (this._elements.includes(element)) return Disposable.None;
		this._elements.push(element);
		const store = new DisposableStore();
		store.add(addDisposableListener(element, EventType$1.MOUSE_OVER, () => this._onTargetMouseOver()));
		store.add(addDisposableListener(element, EventType$1.MOUSE_LEAVE, () => this._onTargetMouseLeave()));
		store.add(toDisposable(() => {
			const index = this._elements.indexOf(element);
			if (index >= 0) this._elements.splice(index, 1);
		}));
		return store;
	}
};
var ElementHoverTarget = class {
	constructor(_element) {
		this._element = _element;
		this.targetElements = [this._element];
	}
	dispose() {}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/range.js
var Range$1;
(function(Range) {
	/**
	* Returns the intersection between two ranges as a range itself.
	* Returns `{ start: 0, end: 0 }` if the intersection is empty.
	*/
	function intersect(one, other) {
		if (one.start >= other.end || other.start >= one.end) return {
			start: 0,
			end: 0
		};
		const start = Math.max(one.start, other.start);
		const end = Math.min(one.end, other.end);
		if (end - start <= 0) return {
			start: 0,
			end: 0
		};
		return {
			start,
			end
		};
	}
	Range.intersect = intersect;
	function isEmpty(range) {
		return range.end - range.start <= 0;
	}
	Range.isEmpty = isEmpty;
	function intersects(one, other) {
		return !isEmpty(intersect(one, other));
	}
	Range.intersects = intersects;
	function relativeComplement(one, other) {
		const result = [];
		const first = {
			start: one.start,
			end: Math.min(other.start, one.end)
		};
		const second = {
			start: Math.max(other.end, one.start),
			end: one.end
		};
		if (!isEmpty(first)) result.push(first);
		if (!isEmpty(second)) result.push(second);
		return result;
	}
	Range.relativeComplement = relativeComplement;
})(Range$1 || (Range$1 = {}));
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/layout.js
var LayoutAnchorMode;
(function(LayoutAnchorMode) {
	LayoutAnchorMode[LayoutAnchorMode["AVOID"] = 0] = "AVOID";
	LayoutAnchorMode[LayoutAnchorMode["ALIGN"] = 1] = "ALIGN";
})(LayoutAnchorMode || (LayoutAnchorMode = {}));
/**
* Lays out a one dimensional view next to an anchor in a viewport.
*
* @returns The view offset within the viewport.
*/
function layout(viewportSize, viewSize, anchor) {
	const layoutAfterAnchorBoundary = anchor.mode === LayoutAnchorMode.ALIGN ? anchor.offset : anchor.offset + anchor.size;
	const layoutBeforeAnchorBoundary = anchor.mode === LayoutAnchorMode.ALIGN ? anchor.offset + anchor.size : anchor.offset;
	if (anchor.position === 0) {
		if (viewSize <= viewportSize - layoutAfterAnchorBoundary) return {
			position: layoutAfterAnchorBoundary,
			result: "ok"
		};
		if (viewSize <= layoutBeforeAnchorBoundary) return {
			position: layoutBeforeAnchorBoundary - viewSize,
			result: "flipped"
		};
		return {
			position: Math.max(viewportSize - viewSize, 0),
			result: "overlap"
		};
	} else {
		if (viewSize <= layoutBeforeAnchorBoundary) return {
			position: layoutBeforeAnchorBoundary - viewSize,
			result: "ok"
		};
		if (viewSize <= viewportSize - layoutAfterAnchorBoundary && layoutBeforeAnchorBoundary < viewSize / 2) return {
			position: layoutAfterAnchorBoundary,
			result: "flipped"
		};
		return {
			position: 0,
			result: "overlap"
		};
	}
}
function layout2d(viewport, view, anchor, options) {
	let anchorAlignment = options?.anchorAlignment ?? 0;
	let anchorPosition = options?.anchorPosition ?? 0;
	const anchorAxisAlignment = options?.anchorAxisAlignment ?? 0;
	let top;
	let left;
	if (anchorAxisAlignment === 0) {
		const verticalAnchor = {
			offset: anchor.top - viewport.top,
			size: anchor.height,
			position: anchorPosition === 0 ? 0 : 1
		};
		const horizontalAnchor = {
			offset: anchor.left,
			size: anchor.width,
			position: anchorAlignment === 0 ? 0 : 1,
			mode: LayoutAnchorMode.ALIGN
		};
		const verticalLayoutResult = layout(viewport.height, view.height, verticalAnchor);
		top = verticalLayoutResult.position + viewport.top;
		if (verticalLayoutResult.result === "flipped") anchorPosition = anchorPosition === 0 ? 1 : 0;
		if (Range$1.intersects({
			start: top,
			end: top + view.height
		}, {
			start: verticalAnchor.offset,
			end: verticalAnchor.offset + verticalAnchor.size
		})) horizontalAnchor.mode = LayoutAnchorMode.AVOID;
		const horizontalLayoutResult = layout(viewport.width, view.width, horizontalAnchor);
		left = horizontalLayoutResult.position;
		if (horizontalLayoutResult.result === "flipped") anchorAlignment = anchorAlignment === 0 ? 1 : 0;
	} else {
		const horizontalAnchor = {
			offset: anchor.left,
			size: anchor.width,
			position: anchorAlignment === 0 ? 0 : 1
		};
		const verticalAnchor = {
			offset: anchor.top,
			size: anchor.height,
			position: anchorPosition === 0 ? 0 : 1,
			mode: LayoutAnchorMode.ALIGN
		};
		const horizontalLayoutResult = layout(viewport.width, view.width, horizontalAnchor);
		left = horizontalLayoutResult.position;
		if (horizontalLayoutResult.result === "flipped") anchorAlignment = anchorAlignment === 0 ? 1 : 0;
		if (Range$1.intersects({
			start: left,
			end: left + view.width
		}, {
			start: horizontalAnchor.offset,
			end: horizontalAnchor.offset + horizontalAnchor.size
		})) verticalAnchor.mode = LayoutAnchorMode.AVOID;
		const verticalLayoutResult = layout(viewport.height, view.height, verticalAnchor);
		top = verticalLayoutResult.position + viewport.top;
		if (verticalLayoutResult.result === "flipped") anchorPosition = anchorPosition === 0 ? 1 : 0;
	}
	const right = viewport.width - (left + view.width);
	const bottom = viewport.height - (top + view.height);
	return {
		top,
		left,
		bottom,
		right,
		anchorAlignment,
		anchorPosition
	};
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/contextview/contextview.js
function isAnchor(obj) {
	const anchor = obj;
	return !!anchor && typeof anchor.x === "number" && typeof anchor.y === "number";
}
var CONTEXT_VIEW_MENU_MOTION_CLASS = "context-view-menu-motion";
var CONTEXT_VIEW_MENU_MOTION_CLOSING_CLASS = "context-view-menu-motion-closing";
var CONTEXT_VIEW_MENU_MOTION_ANCESTOR_CLASSES = ["modern-ui", "monaco-enable-motion"];
var CONTEXT_VIEW_CLOSE_ANIMATION_DURATION_VARIABLE = "--vscode-context-view-close-animation-duration";
var CONTEXT_VIEW_MENU_MOTION_SHADOW_VARIABLE = "--vscode-context-view-menu-motion-shadow";
var CONTEXT_VIEW_MENU_MOTION_CLOSE_START_OPACITY_VARIABLE = "--vscode-context-view-menu-motion-close-start-opacity";
var CONTEXT_VIEW_MENU_MOTION_CLOSE_START_TRANSFORM_VARIABLE = "--vscode-context-view-menu-motion-close-start-transform";
var CONTEXT_VIEW_MENU_MOTION_OPEN_DURATION_MS = 250;
var CONTEXT_VIEW_MENU_MOTION_EASING = "cubic-bezier(0.22, 1, 0.36, 1)";
var contextViewMenuCloseAnimation = {
	className: CONTEXT_VIEW_MENU_MOTION_CLOSING_CLASS,
	duration: 150,
	requiredAncestorClasses: CONTEXT_VIEW_MENU_MOTION_ANCESTOR_CLASSES
};
function getContextViewMenuMotionCss(enabledSelectorPrefix) {
	return `
	${enabledSelectorPrefix} .context-view.${CONTEXT_VIEW_MENU_MOTION_CLASS} {
		animation: none;
		box-shadow: none;
		overflow: visible;
	}

	${enabledSelectorPrefix} .context-view.${CONTEXT_VIEW_MENU_MOTION_CLASS} > .monaco-scrollable-element {
		animation: context-view-menu-motion-open ${CONTEXT_VIEW_MENU_MOTION_OPEN_DURATION_MS}ms ${CONTEXT_VIEW_MENU_MOTION_EASING} backwards;
		box-shadow: var(${CONTEXT_VIEW_MENU_MOTION_SHADOW_VARIABLE});
		transform-origin: top left;
		will-change: opacity;
	}

	${enabledSelectorPrefix} .context-view.${CONTEXT_VIEW_MENU_MOTION_CLASS}.right > .monaco-scrollable-element {
		transform-origin: top right;
	}

	${enabledSelectorPrefix} .context-view.${CONTEXT_VIEW_MENU_MOTION_CLASS}.top > .monaco-scrollable-element {
		transform-origin: bottom left;
	}

	${enabledSelectorPrefix} .context-view.${CONTEXT_VIEW_MENU_MOTION_CLASS}.top.right > .monaco-scrollable-element {
		transform-origin: bottom right;
	}

	${enabledSelectorPrefix} .context-view.${CONTEXT_VIEW_MENU_MOTION_CLASS}.${CONTEXT_VIEW_MENU_MOTION_CLOSING_CLASS} > .monaco-scrollable-element {
		animation: context-view-menu-motion-close var(${CONTEXT_VIEW_CLOSE_ANIMATION_DURATION_VARIABLE}) ${CONTEXT_VIEW_MENU_MOTION_EASING} both;
		pointer-events: none;
	}

	@keyframes context-view-menu-motion-open {
		0% {
			opacity: 0;
			transform: scale(0.97);
		}

		100% {
			opacity: 1;
			transform: scale(1);
		}
	}

	@keyframes context-view-menu-motion-close {
		0% {
			opacity: var(${CONTEXT_VIEW_MENU_MOTION_CLOSE_START_OPACITY_VARIABLE}, 1);
			transform: var(${CONTEXT_VIEW_MENU_MOTION_CLOSE_START_TRANSFORM_VARIABLE}, scale(1));
		}

		100% {
			opacity: 0;
			transform: scale(0.99);
		}
	}`;
}
var contextViewMenuMotionStyleSheet;
function ensureContextViewMenuMotionStyleSheet() {
	if (!contextViewMenuMotionStyleSheet) contextViewMenuMotionStyleSheet = createStyleSheet(void 0, (style) => {
		style.textContent = getContextViewMenuMotionCss(".modern-ui.monaco-enable-motion");
	});
}
function getAnchorRect(anchor) {
	if (isHTMLElement(anchor)) {
		const elementPosition = getDomNodePagePosition(anchor);
		const zoom = getDomNodeZoomLevel(anchor);
		return {
			top: elementPosition.top * zoom,
			left: elementPosition.left * zoom,
			width: elementPosition.width * zoom,
			height: elementPosition.height * zoom
		};
	} else if (isAnchor(anchor)) return {
		top: anchor.y,
		left: anchor.x,
		width: anchor.width || 1,
		height: anchor.height || 2
	};
	else return {
		top: anchor.posy,
		left: anchor.posx,
		width: 2,
		height: 2
	};
}
var ContextView = class ContextView extends Disposable {
	static {
		this.BUBBLE_UP_EVENTS = [
			"click",
			"keydown",
			"focus",
			"blur"
		];
	}
	static {
		this.BUBBLE_DOWN_EVENTS = ["click"];
	}
	constructor(container, domPosition) {
		super();
		this.container = null;
		this.useFixedPosition = false;
		this.useShadowDOM = false;
		this.delegate = null;
		this.toDisposeOnClean = Disposable.None;
		this.toDisposeOnSetContainer = Disposable.None;
		this.shadowRoot = null;
		this.shadowRootHostElement = null;
		ensureContextViewMenuMotionStyleSheet();
		this.view = $$10(".context-view");
		hide(this.view);
		this.setContainer(container, domPosition);
		this._register(toDisposable(() => this.setContainer(null, 1)));
	}
	setContainer(container, domPosition) {
		this.useFixedPosition = domPosition !== 1;
		const usedShadowDOM = this.useShadowDOM;
		this.useShadowDOM = domPosition === 3;
		if (container === this.container && usedShadowDOM === this.useShadowDOM) return;
		if (this.container) {
			this.toDisposeOnSetContainer.dispose();
			this.view.remove();
			if (this.shadowRoot) {
				this.shadowRoot = null;
				this.shadowRootHostElement?.remove();
				this.shadowRootHostElement = null;
			}
			this.container = null;
		}
		if (container) {
			this.container = container;
			if (this.useShadowDOM) {
				this.shadowRootHostElement = $$10(".shadow-root-host");
				Object.assign(this.shadowRootHostElement.style, {
					position: "fixed",
					top: "0",
					left: "0",
					width: "0",
					height: "0"
				});
				this.container.appendChild(this.shadowRootHostElement);
				this.shadowRoot = this.shadowRootHostElement.attachShadow({ mode: "open" });
				const style = document.createElement("style");
				style.textContent = SHADOW_ROOT_CSS;
				this.shadowRoot.appendChild(style);
				this.shadowRoot.appendChild(this.view);
				this.shadowRoot.appendChild($$10("slot"));
			} else this.container.appendChild(this.view);
			const toDisposeOnSetContainer = new DisposableStore();
			ContextView.BUBBLE_UP_EVENTS.forEach((event) => {
				toDisposeOnSetContainer.add(addStandardDisposableListener(this.container, event, (e) => {
					this.onDOMEvent(e, false);
				}));
			});
			ContextView.BUBBLE_DOWN_EVENTS.forEach((event) => {
				toDisposeOnSetContainer.add(addStandardDisposableListener(this.container, event, (e) => {
					this.onDOMEvent(e, true);
				}, true));
			});
			this.toDisposeOnSetContainer = toDisposeOnSetContainer;
		}
	}
	show(delegate) {
		this.completeHideAnimation();
		if (this.isVisible()) this.hide(void 0, true);
		clearNode(this.view);
		this.view.className = "context-view monaco-component";
		this.view.style.top = "0px";
		this.view.style.left = "0px";
		const zIndex = `${2575 + (delegate.layer ?? 0)}`;
		this.view.style.zIndex = zIndex;
		if (this.shadowRootHostElement) this.shadowRootHostElement.style.zIndex = zIndex;
		this.view.style.position = this.useFixedPosition ? "fixed" : "absolute";
		show(this.view);
		this.toDisposeOnClean = delegate.render(this.view) || Disposable.None;
		this.delegate = delegate;
		this.doLayout();
		this.delegate.focus?.();
	}
	getViewElement() {
		return this.view;
	}
	layout() {
		if (!this.isVisible()) return;
		if (this.delegate.canRelayout === false && !(isIOS && BrowserFeatures.pointerEvents)) {
			this.hide();
			return;
		}
		this.delegate?.layout?.();
		this.doLayout();
	}
	doLayout() {
		if (!this.isVisible()) return;
		const anchor = getAnchorRect(this.delegate.getAnchor());
		const containerWindow = this.container ? getWindow(this.container) : getActiveWindow();
		const viewport = {
			top: containerWindow.pageYOffset,
			left: containerWindow.pageXOffset,
			width: containerWindow.innerWidth,
			height: containerWindow.innerHeight
		};
		this.view.classList.toggle("fixed", this.useFixedPosition);
		this.view.style.top = "0px";
		this.view.style.left = "0px";
		const positioningOrigin = getDomNodePagePosition(this.view);
		const view = {
			width: getTotalWidth(this.view),
			height: getTotalHeight(this.view)
		};
		const anchorPosition = this.delegate.anchorPosition;
		const anchorAlignment = this.delegate.anchorAlignment;
		const anchorAxisAlignment = this.delegate.anchorAxisAlignment;
		const layoutResult = layout2d(viewport, view, anchor, {
			anchorAlignment,
			anchorPosition,
			anchorAxisAlignment
		});
		const { top, left } = layoutResult;
		this.view.classList.remove("top", "bottom", "left", "right");
		this.view.classList.add(layoutResult.anchorPosition === 0 ? "bottom" : "top");
		this.view.classList.add(layoutResult.anchorAlignment === 0 ? "left" : "right");
		this.view.style.top = `${top - positioningOrigin.top}px`;
		this.view.style.left = `${left - positioningOrigin.left}px`;
		this.view.style.width = "initial";
	}
	hide(data, skipAnimation = false) {
		if (this.hidingContextView) {
			if (skipAnimation) this.completeHideAnimation();
			return;
		}
		const delegate = this.delegate;
		this.delegate = null;
		if (!delegate) return;
		const toDispose = this.toDisposeOnClean;
		this.toDisposeOnClean = Disposable.None;
		delegate.onHide?.(data);
		const closeAnimation = delegate.closeAnimation;
		if (!skipAnimation && closeAnimation && closeAnimation.duration > 0 && this.hasRequiredAncestorClasses(closeAnimation.requiredAncestorClasses)) {
			this.view.style.setProperty(CONTEXT_VIEW_CLOSE_ANIMATION_DURATION_VARIABLE, `${closeAnimation.duration}ms`);
			this.prepareMenuCloseAnimation();
			this.view.inert = true;
			this.view.classList.add(closeAnimation.className);
			const timeout = setTimeout(() => this.completeHideAnimation(), closeAnimation.duration);
			this.hidingContextView = {
				disposable: toDisposable(() => clearTimeout(timeout)),
				toDispose,
				className: closeAnimation.className
			};
			return;
		}
		toDispose.dispose();
		hide(this.view);
	}
	isVisible() {
		return !!this.delegate;
	}
	completeHideAnimation() {
		const hidingContextView = this.hidingContextView;
		if (!hidingContextView) return;
		this.hidingContextView = void 0;
		hidingContextView.disposable.dispose();
		this.view.classList.remove(hidingContextView.className);
		this.view.style.removeProperty(CONTEXT_VIEW_CLOSE_ANIMATION_DURATION_VARIABLE);
		this.view.style.removeProperty(CONTEXT_VIEW_MENU_MOTION_CLOSE_START_OPACITY_VARIABLE);
		this.view.style.removeProperty(CONTEXT_VIEW_MENU_MOTION_CLOSE_START_TRANSFORM_VARIABLE);
		hidingContextView.toDispose.dispose();
		hide(this.view);
		this.view.inert = false;
	}
	prepareMenuCloseAnimation() {
		if (!this.view.classList.contains("context-view-menu-motion")) return;
		const surface = Array.from(this.view.children).find((element) => isHTMLElement(element) && element.classList.contains("monaco-scrollable-element"));
		if (!isHTMLElement(surface)) return;
		const computedStyle = getWindow(surface).getComputedStyle(surface);
		this.view.style.setProperty(CONTEXT_VIEW_MENU_MOTION_CLOSE_START_OPACITY_VARIABLE, computedStyle.opacity);
		this.view.style.setProperty(CONTEXT_VIEW_MENU_MOTION_CLOSE_START_TRANSFORM_VARIABLE, computedStyle.transform);
	}
	hasRequiredAncestorClasses(classNames) {
		if (!classNames?.length) return true;
		for (let candidate = this.view; candidate;) {
			const current = candidate;
			if (classNames.every((className) => current.classList.contains(className))) return true;
			if (current.parentElement) candidate = current.parentElement;
			else {
				const root = current.getRootNode();
				candidate = root instanceof ShadowRoot && isHTMLElement(root.host) ? root.host : null;
			}
		}
		return false;
	}
	onDOMEvent(e, onCapture) {
		if (this.delegate) {
			if (this.delegate.onDOMEvent) this.delegate.onDOMEvent(e, getWindow(e).document.activeElement);
			else if (onCapture && !isAncestor$1(e.target, this.container)) this.hide();
		}
	}
	dispose() {
		this.hide();
		this.completeHideAnimation();
		super.dispose();
	}
};
var SHADOW_ROOT_CSS = `
	:host {
		all: initial; /* 1st rule so subsequent properties are reset. */
	}

	.codicon[class*='codicon-'] {
		font: normal normal normal 16px/1 codicon;
		display: inline-block;
		text-decoration: none;
		text-rendering: auto;
		text-align: center;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
	}

	:host {
		font-family: -apple-system, BlinkMacSystemFont, "Segoe WPC", "Segoe UI", "HelveticaNeue-Light", system-ui, "Ubuntu", "Droid Sans", sans-serif;
	}

	:host-context(.mac) { font-family: -apple-system, BlinkMacSystemFont, sans-serif; }
	:host-context(.mac:lang(zh-Hans)) { font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Hiragino Sans GB", sans-serif; }
	:host-context(.mac:lang(zh-Hant)) { font-family: -apple-system, BlinkMacSystemFont, "PingFang TC", sans-serif; }
	:host-context(.mac:lang(ja)) { font-family: -apple-system, BlinkMacSystemFont, "Hiragino Kaku Gothic Pro", sans-serif; }
	:host-context(.mac:lang(ko)) { font-family: -apple-system, BlinkMacSystemFont, "Apple SD Gothic Neo", "Nanum Gothic", "AppleGothic", sans-serif; }

	:host-context(.windows) { font-family: "Segoe WPC", "Segoe UI", sans-serif; }
	:host-context(.windows:lang(zh-Hans)) { font-family: "Segoe WPC", "Segoe UI", "Microsoft YaHei", sans-serif; }
	:host-context(.windows:lang(zh-Hant)) { font-family: "Segoe WPC", "Segoe UI", "Microsoft Jhenghei", sans-serif; }
	:host-context(.windows:lang(ja)) { font-family: "Segoe WPC", "Segoe UI", "Yu Gothic UI", "Meiryo UI", sans-serif; }
	:host-context(.windows:lang(ko)) { font-family: "Segoe WPC", "Segoe UI", "Malgun Gothic", "Dotom", sans-serif; }

	:host-context(.linux) { font-family: system-ui, "Ubuntu", "Droid Sans", sans-serif; }
	:host-context(.linux:lang(zh-Hans)) { font-family: system-ui, "Ubuntu", "Droid Sans", "Source Han Sans SC", "Source Han Sans CN", "Source Han Sans", sans-serif; }
	:host-context(.linux:lang(zh-Hant)) { font-family: system-ui, "Ubuntu", "Droid Sans", "Source Han Sans TC", "Source Han Sans TW", "Source Han Sans", sans-serif; }
	:host-context(.linux:lang(ja)) { font-family: system-ui, "Ubuntu", "Droid Sans", "Source Han Sans J", "Source Han Sans JP", "Source Han Sans", sans-serif; }
	:host-context(.linux:lang(ko)) { font-family: system-ui, "Ubuntu", "Droid Sans", "Source Han Sans K", "Source Han Sans JR", "Source Han Sans", "UnDotum", "FBaekmuk Gulim", sans-serif; }
	${getContextViewMenuMotionCss(":host-context(.modern-ui.monaco-enable-motion)")}
`;
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/layout/browser/layoutService.js
var ILayoutService = createDecorator("layoutService");
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/hover/hover.js
function isManagedHoverTooltipMarkdownString(obj) {
	const candidate = obj;
	return typeof candidate === "object" && "markdown" in candidate && "markdownNotSupportedFallback" in candidate;
}
function isManagedHoverTooltipHTMLElement(obj) {
	const candidate = obj;
	return typeof candidate === "object" && "element" in candidate;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/hover/browser/updatableHoverWidget.js
var ManagedHoverWidget = class {
	constructor(hoverDelegate, target, fadeInAnimation) {
		this.hoverDelegate = hoverDelegate;
		this.target = target;
		this.fadeInAnimation = fadeInAnimation;
	}
	async update(content, focus, options) {
		if (this._cancellationTokenSource) {
			this._cancellationTokenSource.dispose(true);
			this._cancellationTokenSource = void 0;
		}
		if (this.isDisposed) return;
		const contentOwnsPadding = isManagedHoverTooltipHTMLElement(content) && content.contentOwnsPadding === true;
		let resolvedContent;
		if (isString$1(content) || isHTMLElement(content) || content === void 0) resolvedContent = content;
		else {
			this._cancellationTokenSource = new CancellationTokenSource$1();
			const token = this._cancellationTokenSource.token;
			let managedContent;
			if (isManagedHoverTooltipMarkdownString(content)) {
				if (isFunction(content.markdown)) managedContent = content.markdown(token).then((resolvedContent) => resolvedContent ?? content.markdownNotSupportedFallback);
				else managedContent = content.markdown ?? content.markdownNotSupportedFallback;
			} else managedContent = content.element(token);
			if (managedContent instanceof Promise) {
				if (!this._hoverWidget) this.show(localize(1795, "Loading..."), focus, options, false);
				resolvedContent = await managedContent;
			} else resolvedContent = managedContent;
			if (this.isDisposed || token.isCancellationRequested) return;
		}
		this.show(resolvedContent, focus, options, contentOwnsPadding);
	}
	show(content, focus, options, contentOwnsPadding) {
		const oldHoverWidget = this._hoverWidget;
		if (this.hasContent(content)) {
			const hoverOptions = {
				content,
				target: this.target,
				actions: options?.actions,
				linkHandler: options?.linkHandler,
				trapFocus: options?.trapFocus,
				additionalClasses: [...options?.additionalClasses ?? [], ...contentOwnsPadding ? ["managed-hover-content-owns-padding"] : []],
				appearance: {
					showPointer: this.hoverDelegate.placement === "element",
					skipFadeInAnimation: !this.fadeInAnimation || !!oldHoverWidget,
					showHoverHint: options?.appearance?.showHoverHint
				},
				position: {
					hoverPosition: 2,
					anchorAlignment: options?.position?.anchorAlignment
				}
			};
			this._hoverWidget = this.hoverDelegate.showHover(hoverOptions, focus);
		}
		oldHoverWidget?.dispose();
	}
	hasContent(content) {
		if (!content) return false;
		if (isMarkdownString(content)) return !!content.value;
		return true;
	}
	get isDisposed() {
		return this._hoverWidget?.isDisposed;
	}
	dispose() {
		this._hoverWidget?.dispose();
		this._cancellationTokenSource?.dispose(true);
		this._cancellationTokenSource = void 0;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/hover/browser/hoverService.js
var __decorate$50 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$45 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
/**
* Maximum nesting depth for hovers. This prevents runaway nesting.
*/
var MAX_HOVER_NESTING_DEPTH = 3;
var HoverService = class HoverService extends Disposable {
	/**
	* Gets the current (topmost) hover from the stack, if any.
	*/
	get _currentHover() {
		return this._hoverStack.at(-1)?.hover;
	}
	/**
	* Gets the current (topmost) hover options from the stack, if any.
	*/
	get _currentHoverOptions() {
		return this._hoverStack.at(-1)?.options;
	}
	/**
	* Returns whether the target element is inside any of the hovers in the stack.
	* If it is, returns the index of the containing hover, otherwise returns -1.
	*/
	_getContainingHoverIndex(target) {
		const targetElements = isHTMLElement(target) ? [target] : target.targetElements;
		for (let i = this._hoverStack.length - 1; i >= 0; i--) for (const targetElement of targetElements) if (isAncestor$1(targetElement, this._hoverStack[i].hover.domNode)) return i;
		return -1;
	}
	constructor(_instantiationService, _configurationService, contextMenuService, _keybindingService, _layoutService, _accessibilityService) {
		super();
		this._instantiationService = _instantiationService;
		this._configurationService = _configurationService;
		this._keybindingService = _keybindingService;
		this._layoutService = _layoutService;
		this._accessibilityService = _accessibilityService;
		/**
		* Stack of currently visible hovers. The last entry is the topmost hover.
		* This enables nested hovers where hovering inside a hover can show another hover.
		*/
		this._hoverStack = [];
		this._currentDelayedHoverWasShown = false;
		this._delayedHovers = /* @__PURE__ */ new Map();
		this._managedHovers = /* @__PURE__ */ new Map();
		this._register(contextMenuService.onDidShowContextMenu(() => this.hideHover()));
		this._register(KeybindingsRegistry.registerCommandAndKeybindingRule({
			id: "workbench.action.showHover",
			weight: 0,
			primary: KeyChord(2089, 2087),
			handler: () => {
				this._showAndFocusHoverForActiveElement();
			}
		}));
	}
	showInstantHover(options, focus, skipLastFocusedUpdate, dontShow) {
		const hover = this._createHover(options, skipLastFocusedUpdate);
		if (!hover) return;
		this._showHover(hover, options, focus);
		return hover.hover;
	}
	showDelayedHover(options, lifecycleOptions) {
		if (options.id === void 0) options.id = getHoverIdFromContent(options.content);
		if (!this._currentDelayedHover || this._currentDelayedHoverWasShown) {
			if (this._currentHover?.isLocked && this._getContainingHoverIndex(options.target) < 0) return;
			if (getHoverOptionsIdentity(this._currentHoverOptions) === getHoverOptionsIdentity(options)) return this._currentHover;
			if (this._currentHover && !this._currentHover.isDisposed && this._currentDelayedHoverGroupId !== void 0 && this._currentDelayedHoverGroupId === lifecycleOptions?.groupId) return this.showInstantHover({
				...options,
				appearance: {
					...options.appearance,
					skipFadeInAnimation: true
				}
			});
		} else if (this._currentDelayedHover && getHoverOptionsIdentity(this._currentHoverOptions) === getHoverOptionsIdentity(options)) return this._currentDelayedHover;
		const hover = this._createHover(options, void 0);
		if (!hover) {
			this._currentDelayedHover = void 0;
			this._currentDelayedHoverWasShown = false;
			this._currentDelayedHoverGroupId = void 0;
			return;
		}
		this._currentDelayedHover = hover.hover;
		this._currentDelayedHoverWasShown = false;
		this._currentDelayedHoverGroupId = lifecycleOptions?.groupId;
		const delay = lifecycleOptions?.reducedDelay ? this._configurationService.getValue("workbench.hover.reducedDelay") : this._configurationService.getValue("workbench.hover.delay");
		timeout(delay).then(() => {
			if (hover.hover && !hover.hover.isDisposed) {
				this._currentDelayedHoverWasShown = true;
				this._showHover(hover, options);
			}
		});
		return hover.hover;
	}
	setupDelayedHover(target, options, lifecycleOptions) {
		const resolveHoverOptions = (e) => {
			const resolved = {
				...typeof options === "function" ? options() : options,
				target
			};
			if (resolved.style === 2 && e) resolved.target = resolveMouseStyleHoverTarget(target, e);
			return resolved;
		};
		return this._setupDelayedHover(target, resolveHoverOptions, lifecycleOptions);
	}
	setupDelayedHoverAtMouse(target, options, lifecycleOptions) {
		const resolveHoverOptions = (e) => ({
			...typeof options === "function" ? options() : options,
			target: e ? resolveMouseStyleHoverTarget(target, e) : target
		});
		return this._setupDelayedHover(target, resolveHoverOptions, lifecycleOptions);
	}
	_setupDelayedHover(target, resolveHoverOptions, lifecycleOptions) {
		const store = new DisposableStore();
		store.add(addDisposableListener(target, EventType$1.MOUSE_OVER, (e) => {
			this.showDelayedHover(resolveHoverOptions(e), {
				groupId: lifecycleOptions?.groupId,
				reducedDelay: lifecycleOptions?.reducedDelay
			});
		}));
		if (lifecycleOptions?.setupKeyboardEvents) store.add(addDisposableListener(target, EventType$1.KEY_DOWN, (e) => {
			const evt = new StandardKeyboardEvent(e);
			if (evt.equals(10) || evt.equals(3)) this.showInstantHover(resolveHoverOptions(), true);
		}));
		this._delayedHovers.set(target, { show: (focus) => {
			this.showInstantHover(resolveHoverOptions(), focus);
		} });
		store.add(toDisposable(() => this._delayedHovers.delete(target)));
		return store;
	}
	_createHover(options, skipLastFocusedUpdate) {
		this._currentDelayedHover?.dispose();
		this._currentDelayedHover = void 0;
		if (options.content === "") return;
		if (options.id === void 0) options.id = getHoverIdFromContent(options.content);
		if (this._getContainingHoverIndex(options.target) >= 0) {
			if (this._hoverStack.length >= MAX_HOVER_NESTING_DEPTH) return;
		} else {
			if (this._currentHover?.isLocked) return;
			if (getHoverOptionsIdentity(this._currentHoverOptions) === getHoverOptionsIdentity(options)) return;
		}
		this._lastHoverOptions = options;
		const trapFocus = options.trapFocus || this._accessibilityService.isScreenReaderOptimized();
		const activeElement = getActiveElement();
		let lastFocusedElementBeforeOpen;
		if (!skipLastFocusedUpdate) {
			if (trapFocus && activeElement) {
				if (!activeElement.classList.contains("monaco-hover")) lastFocusedElementBeforeOpen = activeElement;
			}
		}
		const hoverDisposables = new DisposableStore();
		const hover = this._instantiationService.createInstance(HoverWidget, options);
		if (options.persistence?.sticky) hover.isLocked = true;
		if (options.position?.hoverPosition && !isNumber$1(options.position.hoverPosition)) options.target = {
			targetElements: isHTMLElement(options.target) ? [options.target] : options.target.targetElements,
			x: options.position.hoverPosition.x + 10
		};
		hover.onDispose(() => {
			const stackIndex = this._hoverStack.findIndex((entry) => entry.hover === hover);
			if (stackIndex >= 0) {
				const entry = this._hoverStack[stackIndex];
				if (isAncestorOfActiveElement(hover.domNode) && entry.lastFocusedElementBeforeOpen) entry.lastFocusedElementBeforeOpen.focus();
				while (this._hoverStack.length > stackIndex + 1) {
					const nestedEntry = this._hoverStack.pop();
					nestedEntry.contextView.dispose();
					nestedEntry.hover.dispose();
				}
				this._hoverStack.splice(stackIndex, 1);
				entry.contextView.dispose();
			}
			hoverDisposables.dispose();
		}, void 0, hoverDisposables);
		if (!options.container) {
			const targetElement = isHTMLElement(options.target) ? options.target : options.target.targetElements[0];
			options.container = this._layoutService.getContainer(getWindow(targetElement));
		}
		hoverDisposables.add(addDisposableListener(getWindow(options.container).document, EventType$1.MOUSE_DOWN, (e) => {
			if (!isAncestor$1(e.target, hover.domNode)) this._hideHoverAndDescendants(hover);
		}));
		if (!options.persistence?.sticky) {
			if ("targetElements" in options.target) for (const element of options.target.targetElements) hoverDisposables.add(addDisposableListener(element, EventType$1.CLICK, () => this._hideHoverAndDescendants(hover)));
			else hoverDisposables.add(addDisposableListener(options.target, EventType$1.CLICK, () => this._hideHoverAndDescendants(hover)));
			const focusedElement = getActiveElement();
			if (focusedElement) {
				const focusedElementDocument = getWindow(focusedElement).document;
				hoverDisposables.add(addDisposableListener(focusedElement, EventType$1.KEY_DOWN, (e) => this._keyDown(e, hover, !!options.persistence?.hideOnKeyDown)));
				hoverDisposables.add(addDisposableListener(focusedElementDocument, EventType$1.KEY_DOWN, (e) => this._keyDown(e, hover, !!options.persistence?.hideOnKeyDown)));
				hoverDisposables.add(addDisposableListener(focusedElement, EventType$1.KEY_UP, (e) => this._keyUp(e, hover)));
				hoverDisposables.add(addDisposableListener(focusedElementDocument, EventType$1.KEY_UP, (e) => this._keyUp(e, hover)));
			}
		}
		if ("IntersectionObserver" in mainWindow) {
			const observer = new IntersectionObserver((e) => this._intersectionChange(e, hover), { threshold: 0 });
			const firstTargetElement = "targetElements" in options.target ? options.target.targetElements[0] : options.target;
			observer.observe(firstTargetElement);
			hoverDisposables.add(toDisposable(() => observer.disconnect()));
		}
		return {
			hover,
			lastFocusedElementBeforeOpen,
			store: hoverDisposables
		};
	}
	_showHover(result, options, focus) {
		const { hover, lastFocusedElementBeforeOpen, store } = result;
		const containingHoverIndex = this._getContainingHoverIndex(options.target);
		const isNesting = containingHoverIndex >= 0;
		if (!isNesting) this._hideAllHovers();
		else {
			for (let i = this._hoverStack.length - 1; i > containingHoverIndex; i--) this._hoverStack[i].hover.dispose();
			this._hoverStack.length = containingHoverIndex + 1;
		}
		if (isNesting) for (let i = 0; i <= containingHoverIndex; i++) store.add(this._hoverStack[i].hover.addMouseTrackingElement(hover.domNode));
		const container = options.container ?? this._layoutService.getContainer(getWindow(isHTMLElement(options.target) ? options.target : options.target.targetElements[0]));
		const contextView = new ContextView(container, 1);
		const stackEntry = {
			hover,
			options,
			contextView,
			lastFocusedElementBeforeOpen
		};
		this._hoverStack.push(stackEntry);
		const delegate = new HoverContextViewDelegate(hover, focus, this._hoverStack.length);
		contextView.show(delegate);
		store.add(hover.onRequestLayout(() => contextView.layout()));
		if (focus || options.persistence?.sticky) {
			const targetWindow = getWindow(container);
			store.add(addDisposableListener(targetWindow, EventType$1.RESIZE, () => contextView.layout()));
		}
		if (options.onDidHide) {
			const onDidHide = options.onDidHide;
			store.add(toDisposable(() => onDidHide()));
		}
		options.onDidShow?.();
	}
	/**
	* Hides a specific hover and all hovers nested inside it.
	*/
	_hideHoverAndDescendants(hover) {
		const stackIndex = this._hoverStack.findIndex((entry) => entry.hover === hover);
		if (stackIndex < 0) {
			if (hover === this._currentDelayedHover) this._cancelPendingDelayedHover();
			return;
		}
		for (let i = this._hoverStack.length - 1; i >= stackIndex; i--) this._hoverStack[i].hover.dispose();
		this._hoverStack.length = stackIndex;
	}
	/**
	* Cancels a delayed hover that was created but whose delay has not elapsed yet, so it
	* never gets shown.
	*/
	_cancelPendingDelayedHover() {
		if (!this._currentDelayedHover || this._currentDelayedHoverWasShown) return;
		this._currentDelayedHover.dispose();
		this._currentDelayedHover = void 0;
		this._currentDelayedHoverGroupId = void 0;
	}
	/**
	* Hides all hovers in the stack.
	*/
	_hideAllHovers() {
		for (let i = this._hoverStack.length - 1; i >= 0; i--) this._hoverStack[i].hover.dispose();
		this._hoverStack.length = 0;
	}
	hideHover(force) {
		if (!force && this._currentHover?.isLocked) return;
		this._cancelPendingDelayedHover();
		if (this._hoverStack.length === 0) return;
		this.doHideHover();
	}
	doHideHover() {
		const length = this._hoverStack.length;
		this._hoverStack[length - 1]?.hover.dispose();
		this._hoverStack.length = length - 1;
	}
	_intersectionChange(entries, hover) {
		if (!entries[entries.length - 1].isIntersecting) hover.dispose();
	}
	showAndFocusLastHover() {
		if (!this._lastHoverOptions) return;
		this.showInstantHover(this._lastHoverOptions, true, true);
	}
	_showAndFocusHoverForActiveElement() {
		let activeElement = getActiveElement();
		while (activeElement) {
			const hover = this._delayedHovers.get(activeElement) ?? this._managedHovers.get(activeElement);
			if (hover) {
				hover.show(true);
				return;
			}
			activeElement = activeElement.parentElement;
		}
	}
	_keyDown(e, hover, hideOnKeyDown) {
		if (e.key === "Alt") {
			for (const entry of this._hoverStack) entry.hover.isLocked = true;
			return;
		}
		const event = new StandardKeyboardEvent(e);
		if (this._keybindingService.resolveKeyboardEvent(event).getSingleModifierDispatchChords().some((value) => !!value) || this._keybindingService.softDispatch(event, event.target).kind !== 0) return;
		if (hideOnKeyDown && (!this._currentHoverOptions?.trapFocus || e.key !== "Tab")) {
			const stackEntry = this._hoverStack.find((entry) => entry.hover === hover);
			this._hideHoverAndDescendants(hover);
			stackEntry?.lastFocusedElementBeforeOpen?.focus();
		}
	}
	_keyUp(e, hover) {
		if (e.key === "Alt") {
			for (const entry of this._hoverStack) if (!entry.options.persistence?.sticky) entry.hover.isLocked = false;
			if (!this._hoverStack.some((entry) => entry.hover.isMouseIn)) {
				const topEntry = this._hoverStack[this._hoverStack.length - 1];
				this._hideAllHovers();
				topEntry?.lastFocusedElementBeforeOpen?.focus();
			}
		}
	}
	setupManagedHover(hoverDelegate, targetElement, content, options) {
		if (hoverDelegate.showNativeHover) return setupNativeHover(targetElement, content);
		targetElement.setAttribute("custom-hover", "true");
		if (targetElement.title !== "") {
			console.warn("HTML element already has a title attribute, which will conflict with the custom hover. Please remove the title attribute.");
			targetElement.title = "";
		}
		let hoverPreparation;
		let hoverWidget;
		const hideHover = (disposeWidget, disposePreparation) => {
			const hadHover = hoverWidget !== void 0;
			if (disposeWidget) {
				hoverWidget?.dispose();
				hoverWidget = void 0;
			}
			if (disposePreparation) {
				hoverPreparation?.dispose();
				hoverPreparation = void 0;
			}
			if (hadHover) {
				hoverDelegate.onDidHideHover?.();
				hoverWidget = void 0;
			}
		};
		const triggerShowHover = (delay, focus, target, trapFocus) => {
			return new TimeoutTimer(async () => {
				if (!hoverWidget || hoverWidget.isDisposed) {
					hoverWidget = new ManagedHoverWidget(hoverDelegate, target || targetElement, delay > 0);
					await hoverWidget.update(typeof content === "function" ? content() : content, focus, {
						...options,
						trapFocus
					});
				}
			}, delay);
		};
		const store = new DisposableStore();
		let isMouseDown = false;
		store.add(addDisposableListener(targetElement, EventType$1.MOUSE_DOWN, () => {
			isMouseDown = true;
			hideHover(true, true);
		}, true));
		store.add(addDisposableListener(targetElement, EventType$1.MOUSE_UP, () => {
			isMouseDown = false;
		}, true));
		store.add(addDisposableListener(targetElement, EventType$1.MOUSE_LEAVE, (e) => {
			isMouseDown = false;
			hideHover(false, e.fromElement === targetElement);
		}, true));
		store.add(addDisposableListener(targetElement, EventType$1.MOUSE_OVER, (e) => {
			if (hoverPreparation) return;
			const mouseOverStore = new DisposableStore();
			const target = {
				targetElements: [targetElement],
				dispose: () => {}
			};
			if (hoverDelegate.placement === void 0 || hoverDelegate.placement === "mouse") {
				const onMouseMove = (e) => {
					target.x = e.x + 10;
					if (!eventIsRelatedToTarget(e, targetElement)) hideHover(true, true);
				};
				mouseOverStore.add(addDisposableListener(targetElement, EventType$1.MOUSE_MOVE, onMouseMove, true));
			}
			hoverPreparation = mouseOverStore;
			if (!eventIsRelatedToTarget(e, targetElement)) return;
			mouseOverStore.add(triggerShowHover(typeof hoverDelegate.delay === "function" ? hoverDelegate.delay(content) : hoverDelegate.delay, false, target));
		}, true));
		const onFocus = (e) => {
			if (isMouseDown || hoverPreparation) return;
			if (hoverWidget?.isDisposed) hoverWidget = void 0;
			if (isHTMLElement(e.relatedTarget) && e.relatedTarget.closest(".monaco-hover") || !e.relatedTarget) return;
			if (!eventIsRelatedToTarget(e, targetElement)) return;
			const target = {
				targetElements: [targetElement],
				dispose: () => {}
			};
			const toDispose = new DisposableStore();
			const onBlur = () => hideHover(true, true);
			toDispose.add(addDisposableListener(targetElement, EventType$1.BLUR, onBlur, true));
			toDispose.add(triggerShowHover(typeof hoverDelegate.delay === "function" ? hoverDelegate.delay(content) : hoverDelegate.delay, false, target));
			hoverPreparation = toDispose;
		};
		if (!isEditableElement(targetElement)) store.add(addDisposableListener(targetElement, EventType$1.FOCUS, onFocus, true));
		const hover = {
			show: (focus) => {
				hideHover(false, true);
				triggerShowHover(0, focus, void 0, focus);
			},
			hide: () => {
				hideHover(true, true);
			},
			update: async (newContent, hoverOptions) => {
				content = newContent;
				options = hoverOptions;
				await hoverWidget?.update(content, void 0, options);
			},
			dispose: () => {
				this._managedHovers.delete(targetElement);
				store.dispose();
				hideHover(true, true);
			}
		};
		this._managedHovers.set(targetElement, hover);
		return hover;
	}
	showManagedHover(target) {
		const hover = this._managedHovers.get(target);
		if (hover) hover.show(true);
	}
	dispose() {
		this._managedHovers.forEach((hover) => hover.dispose());
		super.dispose();
	}
};
HoverService = __decorate$50([
	__param$45(0, IInstantiationService),
	__param$45(1, IConfigurationService),
	__param$45(2, IContextMenuService),
	__param$45(3, IKeybindingService),
	__param$45(4, ILayoutService),
	__param$45(5, IAccessibilityService)
], HoverService);
function getHoverOptionsIdentity(options) {
	if (options === void 0) return;
	return options?.id ?? options;
}
function getHoverIdFromContent(content) {
	if (isHTMLElement(content)) return;
	if (typeof content === "string") return content.toString();
	return content.value;
}
function getStringContent(contentOrFactory) {
	const content = typeof contentOrFactory === "function" ? contentOrFactory() : contentOrFactory;
	if (isString$1(content)) return stripIcons(content);
	if (isManagedHoverTooltipMarkdownString(content)) return content.markdownNotSupportedFallback;
}
function setupNativeHover(targetElement, content) {
	function updateTitle(title) {
		if (title) targetElement.setAttribute("title", title);
		else targetElement.removeAttribute("title");
	}
	updateTitle(getStringContent(content));
	return {
		update: (content) => updateTitle(getStringContent(content)),
		show: () => {},
		hide: () => {},
		dispose: () => updateTitle(void 0)
	};
}
var HoverContextViewDelegate = class {
	get anchorPosition() {
		return this._hover.anchor;
	}
	constructor(_hover, _focus = false, stackDepth = 1) {
		this._hover = _hover;
		this._focus = _focus;
		this.layer = stackDepth;
	}
	render(container) {
		this._hover.render(container);
		if (this._focus) this._hover.focus();
		return this._hover;
	}
	getAnchor() {
		return {
			x: this._hover.x,
			y: this._hover.y
		};
	}
	layout() {
		this._hover.layout();
	}
};
function eventIsRelatedToTarget(event, target) {
	return isHTMLElement(event.target) && getHoverTargetElement(event.target, target) === target;
}
function getHoverTargetElement(element, stopElement) {
	stopElement = stopElement ?? getWindow(element).document.body;
	while (!element.hasAttribute("custom-hover") && element !== stopElement) element = element.parentElement;
	return element;
}
function resolveMouseStyleHoverTarget(target, e) {
	return {
		targetElements: [target],
		x: e.x + 10
	};
}
registerSingleton(IHoverService, HoverService, 1);
registerThemingParticipant((theme, collector) => {
	const hoverBorder = theme.getColor(editorHoverBorder);
	if (hoverBorder) {
		collector.addRule(`.monaco-hover.workbench-hover .hover-row:not(:first-child):not(:empty) { border-top: 1px solid ${hoverBorder.transparent(.5)}; }`);
		collector.addRule(`.monaco-hover.workbench-hover hr { border-top: 1px solid ${hoverBorder.transparent(.5)}; }`);
	}
});
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/dialogs/common/dialogs.js
var IDialogService = createDecorator("dialogService");
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/undoRedo/common/undoRedoService.js
var __decorate$49 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$44 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
function getResourceLabel(resource) {
	return resource.scheme === Schemas.file ? resource.fsPath : resource.path;
}
var stackElementCounter = 0;
var ResourceStackElement = class {
	constructor(actual, resourceLabel, strResource, groupId, groupOrder, sourceId, sourceOrder) {
		this.id = ++stackElementCounter;
		this.type = 0;
		this.actual = actual;
		this.label = actual.label;
		this.confirmBeforeUndo = actual.confirmBeforeUndo || false;
		this.resourceLabel = resourceLabel;
		this.strResource = strResource;
		this.resourceLabels = [this.resourceLabel];
		this.strResources = [this.strResource];
		this.groupId = groupId;
		this.groupOrder = groupOrder;
		this.sourceId = sourceId;
		this.sourceOrder = sourceOrder;
		this.isValid = true;
	}
	setValid(isValid) {
		this.isValid = isValid;
	}
	toString() {
		return `[id:${this.id}] [group:${this.groupId}] [${this.isValid ? "  VALID" : "INVALID"}] ${this.actual.constructor.name} - ${this.actual}`;
	}
};
var ResourceReasonPair = class {
	constructor(resourceLabel, reason) {
		this.resourceLabel = resourceLabel;
		this.reason = reason;
	}
};
var RemovedResources = class {
	constructor() {
		this.elements = /* @__PURE__ */ new Map();
	}
	createMessage() {
		const externalRemoval = [];
		const noParallelUniverses = [];
		for (const [, element] of this.elements) (element.reason === 0 ? externalRemoval : noParallelUniverses).push(element.resourceLabel);
		const messages = [];
		if (externalRemoval.length > 0) messages.push(localize(2132, "The following files have been closed and modified on disk: {0}.", externalRemoval.join(", ")));
		if (noParallelUniverses.length > 0) messages.push(localize(2133, "The following files have been modified in an incompatible way: {0}.", noParallelUniverses.join(", ")));
		return messages.join("\n");
	}
	get size() {
		return this.elements.size;
	}
	has(strResource) {
		return this.elements.has(strResource);
	}
	set(strResource, value) {
		this.elements.set(strResource, value);
	}
	delete(strResource) {
		return this.elements.delete(strResource);
	}
};
var WorkspaceStackElement = class {
	constructor(actual, resourceLabels, strResources, groupId, groupOrder, sourceId, sourceOrder) {
		this.id = ++stackElementCounter;
		this.type = 1;
		this.actual = actual;
		this.label = actual.label;
		this.confirmBeforeUndo = actual.confirmBeforeUndo || false;
		this.resourceLabels = resourceLabels;
		this.strResources = strResources;
		this.groupId = groupId;
		this.groupOrder = groupOrder;
		this.sourceId = sourceId;
		this.sourceOrder = sourceOrder;
		this.removedResources = null;
		this.invalidatedResources = null;
	}
	canSplit() {
		return typeof this.actual.split === "function";
	}
	removeResource(resourceLabel, strResource, reason) {
		if (!this.removedResources) this.removedResources = new RemovedResources();
		if (!this.removedResources.has(strResource)) this.removedResources.set(strResource, new ResourceReasonPair(resourceLabel, reason));
	}
	setValid(resourceLabel, strResource, isValid) {
		if (isValid) {
			if (this.invalidatedResources) {
				this.invalidatedResources.delete(strResource);
				if (this.invalidatedResources.size === 0) this.invalidatedResources = null;
			}
		} else {
			if (!this.invalidatedResources) this.invalidatedResources = new RemovedResources();
			if (!this.invalidatedResources.has(strResource)) this.invalidatedResources.set(strResource, new ResourceReasonPair(resourceLabel, 0));
		}
	}
	toString() {
		return `[id:${this.id}] [group:${this.groupId}] [${this.invalidatedResources ? "INVALID" : "  VALID"}] ${this.actual.constructor.name} - ${this.actual}`;
	}
};
var ResourceEditStack = class {
	constructor(resourceLabel, strResource) {
		this.resourceLabel = resourceLabel;
		this.strResource = strResource;
		this._past = [];
		this._future = [];
		this.locked = false;
		this.versionId = 1;
	}
	dispose() {
		for (const element of this._past) if (element.type === 1) element.removeResource(this.resourceLabel, this.strResource, 0);
		for (const element of this._future) if (element.type === 1) element.removeResource(this.resourceLabel, this.strResource, 0);
		this.versionId++;
	}
	toString() {
		const result = [];
		result.push(`* ${this.strResource}:`);
		for (let i = 0; i < this._past.length; i++) result.push(`   * [UNDO] ${this._past[i]}`);
		for (let i = this._future.length - 1; i >= 0; i--) result.push(`   * [REDO] ${this._future[i]}`);
		return result.join("\n");
	}
	flushAllElements() {
		this._past = [];
		this._future = [];
		this.versionId++;
	}
	_setElementValidFlag(element, isValid) {
		if (element.type === 1) element.setValid(this.resourceLabel, this.strResource, isValid);
		else element.setValid(isValid);
	}
	setElementsValidFlag(isValid, filter) {
		for (const element of this._past) if (filter(element.actual)) this._setElementValidFlag(element, isValid);
		for (const element of this._future) if (filter(element.actual)) this._setElementValidFlag(element, isValid);
	}
	pushElement(element) {
		for (const futureElement of this._future) if (futureElement.type === 1) futureElement.removeResource(this.resourceLabel, this.strResource, 1);
		this._future = [];
		this._past.push(element);
		this.versionId++;
	}
	createSnapshot(resource) {
		const elements = [];
		for (let i = 0, len = this._past.length; i < len; i++) elements.push(this._past[i].id);
		for (let i = this._future.length - 1; i >= 0; i--) elements.push(this._future[i].id);
		return new ResourceEditStackSnapshot(resource, elements);
	}
	restoreSnapshot(snapshot) {
		const snapshotLength = snapshot.elements.length;
		let isOK = true;
		let snapshotIndex = 0;
		let removePastAfter = -1;
		for (let i = 0, len = this._past.length; i < len; i++, snapshotIndex++) {
			const element = this._past[i];
			if (isOK && (snapshotIndex >= snapshotLength || element.id !== snapshot.elements[snapshotIndex])) {
				isOK = false;
				removePastAfter = i;
			}
			if (!isOK && element.type === 1) element.removeResource(this.resourceLabel, this.strResource, 0);
		}
		let removeFutureBefore = -1;
		for (let i = this._future.length - 1; i >= 0; i--, snapshotIndex++) {
			const element = this._future[i];
			if (isOK && (snapshotIndex >= snapshotLength || element.id !== snapshot.elements[snapshotIndex])) {
				isOK = false;
				removeFutureBefore = i;
			}
			if (!isOK && element.type === 1) element.removeResource(this.resourceLabel, this.strResource, 0);
		}
		if (removePastAfter !== -1) this._past = this._past.slice(0, removePastAfter);
		if (removeFutureBefore !== -1) this._future = this._future.slice(removeFutureBefore + 1);
		this.versionId++;
	}
	getElements() {
		const past = [];
		const future = [];
		for (const element of this._past) past.push(element.actual);
		for (const element of this._future) future.push(element.actual);
		return {
			past,
			future
		};
	}
	getClosestPastElement() {
		if (this._past.length === 0) return null;
		return this._past[this._past.length - 1];
	}
	getSecondClosestPastElement() {
		if (this._past.length < 2) return null;
		return this._past[this._past.length - 2];
	}
	getClosestFutureElement() {
		if (this._future.length === 0) return null;
		return this._future[this._future.length - 1];
	}
	hasPastElements() {
		return this._past.length > 0;
	}
	hasFutureElements() {
		return this._future.length > 0;
	}
	splitPastWorkspaceElement(toRemove, individualMap) {
		for (let j = this._past.length - 1; j >= 0; j--) if (this._past[j] === toRemove) {
			if (individualMap.has(this.strResource)) this._past[j] = individualMap.get(this.strResource);
			else this._past.splice(j, 1);
			break;
		}
		this.versionId++;
	}
	splitFutureWorkspaceElement(toRemove, individualMap) {
		for (let j = this._future.length - 1; j >= 0; j--) if (this._future[j] === toRemove) {
			if (individualMap.has(this.strResource)) this._future[j] = individualMap.get(this.strResource);
			else this._future.splice(j, 1);
			break;
		}
		this.versionId++;
	}
	moveBackward(element) {
		this._past.pop();
		this._future.push(element);
		this.versionId++;
	}
	moveForward(element) {
		this._future.pop();
		this._past.push(element);
		this.versionId++;
	}
};
var EditStackSnapshot = class {
	constructor(editStacks) {
		this.editStacks = editStacks;
		this._versionIds = [];
		for (let i = 0, len = this.editStacks.length; i < len; i++) this._versionIds[i] = this.editStacks[i].versionId;
	}
	isValid() {
		for (let i = 0, len = this.editStacks.length; i < len; i++) if (this._versionIds[i] !== this.editStacks[i].versionId) return false;
		return true;
	}
};
var missingEditStack = new ResourceEditStack("", "");
missingEditStack.locked = true;
var UndoRedoService = class UndoRedoService {
	constructor(_dialogService, _notificationService) {
		this._dialogService = _dialogService;
		this._notificationService = _notificationService;
		this._editStacks = /* @__PURE__ */ new Map();
		this._uriComparisonKeyComputers = [];
	}
	getUriComparisonKey(resource) {
		for (const uriComparisonKeyComputer of this._uriComparisonKeyComputers) if (uriComparisonKeyComputer[0] === resource.scheme) return uriComparisonKeyComputer[1].getComparisonKey(resource);
		return resource.toString();
	}
	_print(label) {
		console.log(`------------------------------------`);
		console.log(`AFTER ${label}: `);
		const str = [];
		for (const element of this._editStacks) str.push(element[1].toString());
		console.log(str.join("\n"));
	}
	pushElement(element, group = UndoRedoGroup.None, source = UndoRedoSource.None) {
		if (element.type === 0) {
			const resourceLabel = getResourceLabel(element.resource);
			const strResource = this.getUriComparisonKey(element.resource);
			this._pushElement(new ResourceStackElement(element, resourceLabel, strResource, group.id, group.nextOrder(), source.id, source.nextOrder()));
		} else {
			const seen = /* @__PURE__ */ new Set();
			const resourceLabels = [];
			const strResources = [];
			for (const resource of element.resources) {
				const resourceLabel = getResourceLabel(resource);
				const strResource = this.getUriComparisonKey(resource);
				if (seen.has(strResource)) continue;
				seen.add(strResource);
				resourceLabels.push(resourceLabel);
				strResources.push(strResource);
			}
			if (resourceLabels.length === 1) this._pushElement(new ResourceStackElement(element, resourceLabels[0], strResources[0], group.id, group.nextOrder(), source.id, source.nextOrder()));
			else this._pushElement(new WorkspaceStackElement(element, resourceLabels, strResources, group.id, group.nextOrder(), source.id, source.nextOrder()));
		}
	}
	_pushElement(element) {
		for (let i = 0, len = element.strResources.length; i < len; i++) {
			const resourceLabel = element.resourceLabels[i];
			const strResource = element.strResources[i];
			let editStack;
			if (this._editStacks.has(strResource)) editStack = this._editStacks.get(strResource);
			else {
				editStack = new ResourceEditStack(resourceLabel, strResource);
				this._editStacks.set(strResource, editStack);
			}
			editStack.pushElement(element);
		}
	}
	getLastElement(resource) {
		const strResource = this.getUriComparisonKey(resource);
		if (this._editStacks.has(strResource)) {
			const editStack = this._editStacks.get(strResource);
			if (editStack.hasFutureElements()) return null;
			const closestPastElement = editStack.getClosestPastElement();
			return closestPastElement ? closestPastElement.actual : null;
		}
		return null;
	}
	_splitPastWorkspaceElement(toRemove, ignoreResources) {
		const individualArr = toRemove.actual.split();
		const individualMap = /* @__PURE__ */ new Map();
		for (const _element of individualArr) {
			const element = new ResourceStackElement(_element, getResourceLabel(_element.resource), this.getUriComparisonKey(_element.resource), 0, 0, 0, 0);
			individualMap.set(element.strResource, element);
		}
		for (const strResource of toRemove.strResources) {
			if (ignoreResources && ignoreResources.has(strResource)) continue;
			this._editStacks.get(strResource).splitPastWorkspaceElement(toRemove, individualMap);
		}
	}
	_splitFutureWorkspaceElement(toRemove, ignoreResources) {
		const individualArr = toRemove.actual.split();
		const individualMap = /* @__PURE__ */ new Map();
		for (const _element of individualArr) {
			const element = new ResourceStackElement(_element, getResourceLabel(_element.resource), this.getUriComparisonKey(_element.resource), 0, 0, 0, 0);
			individualMap.set(element.strResource, element);
		}
		for (const strResource of toRemove.strResources) {
			if (ignoreResources && ignoreResources.has(strResource)) continue;
			this._editStacks.get(strResource).splitFutureWorkspaceElement(toRemove, individualMap);
		}
	}
	removeElements(resource) {
		const strResource = typeof resource === "string" ? resource : this.getUriComparisonKey(resource);
		if (this._editStacks.has(strResource)) {
			this._editStacks.get(strResource).dispose();
			this._editStacks.delete(strResource);
		}
	}
	setElementsValidFlag(resource, isValid, filter) {
		const strResource = this.getUriComparisonKey(resource);
		if (this._editStacks.has(strResource)) this._editStacks.get(strResource).setElementsValidFlag(isValid, filter);
	}
	createSnapshot(resource) {
		const strResource = this.getUriComparisonKey(resource);
		if (this._editStacks.has(strResource)) return this._editStacks.get(strResource).createSnapshot(resource);
		return new ResourceEditStackSnapshot(resource, []);
	}
	restoreSnapshot(snapshot) {
		const strResource = this.getUriComparisonKey(snapshot.resource);
		if (this._editStacks.has(strResource)) {
			const editStack = this._editStacks.get(strResource);
			editStack.restoreSnapshot(snapshot);
			if (!editStack.hasPastElements() && !editStack.hasFutureElements()) {
				editStack.dispose();
				this._editStacks.delete(strResource);
			}
		}
	}
	getElements(resource) {
		const strResource = this.getUriComparisonKey(resource);
		if (this._editStacks.has(strResource)) return this._editStacks.get(strResource).getElements();
		return {
			past: [],
			future: []
		};
	}
	_findClosestUndoElementWithSource(sourceId) {
		if (!sourceId) return [null, null];
		let matchedElement = null;
		let matchedStrResource = null;
		for (const [strResource, editStack] of this._editStacks) {
			const candidate = editStack.getClosestPastElement();
			if (!candidate) continue;
			if (candidate.sourceId === sourceId) {
				if (!matchedElement || candidate.sourceOrder > matchedElement.sourceOrder) {
					matchedElement = candidate;
					matchedStrResource = strResource;
				}
			}
		}
		return [matchedElement, matchedStrResource];
	}
	canUndo(resourceOrSource) {
		if (resourceOrSource instanceof UndoRedoSource) {
			const [, matchedStrResource] = this._findClosestUndoElementWithSource(resourceOrSource.id);
			return matchedStrResource ? true : false;
		}
		const strResource = this.getUriComparisonKey(resourceOrSource);
		if (this._editStacks.has(strResource)) return this._editStacks.get(strResource).hasPastElements();
		return false;
	}
	_onError(err, element) {
		onUnexpectedError(err);
		for (const strResource of element.strResources) this.removeElements(strResource);
		this._notificationService.error(err);
	}
	_acquireLocks(editStackSnapshot) {
		for (const editStack of editStackSnapshot.editStacks) if (editStack.locked) throw new Error("Cannot acquire edit stack lock");
		for (const editStack of editStackSnapshot.editStacks) editStack.locked = true;
		return () => {
			for (const editStack of editStackSnapshot.editStacks) editStack.locked = false;
		};
	}
	_safeInvokeWithLocks(element, invoke, editStackSnapshot, cleanup, continuation) {
		const releaseLocks = this._acquireLocks(editStackSnapshot);
		let result;
		try {
			result = invoke();
		} catch (err) {
			releaseLocks();
			cleanup.dispose();
			return this._onError(err, element);
		}
		if (result) return result.then(() => {
			releaseLocks();
			cleanup.dispose();
			return continuation();
		}, (err) => {
			releaseLocks();
			cleanup.dispose();
			return this._onError(err, element);
		});
		else {
			releaseLocks();
			cleanup.dispose();
			return continuation();
		}
	}
	async _invokeWorkspacePrepare(element) {
		if (typeof element.actual.prepareUndoRedo === "undefined") return Disposable.None;
		const result = element.actual.prepareUndoRedo();
		if (typeof result === "undefined") return Disposable.None;
		return result;
	}
	_invokeResourcePrepare(element, callback) {
		if (element.actual.type !== 1 || typeof element.actual.prepareUndoRedo === "undefined") return callback(Disposable.None);
		const r = element.actual.prepareUndoRedo();
		if (!r) return callback(Disposable.None);
		if (isDisposable(r)) return callback(r);
		return r.then((disposable) => {
			return callback(disposable);
		});
	}
	_getAffectedEditStacks(element) {
		const affectedEditStacks = [];
		for (const strResource of element.strResources) affectedEditStacks.push(this._editStacks.get(strResource) || missingEditStack);
		return new EditStackSnapshot(affectedEditStacks);
	}
	_tryToSplitAndUndo(strResource, element, ignoreResources, message) {
		if (element.canSplit()) {
			this._splitPastWorkspaceElement(element, ignoreResources);
			this._notificationService.warn(message);
			return new WorkspaceVerificationError(this._undo(strResource, 0, true));
		} else {
			for (const strResource of element.strResources) this.removeElements(strResource);
			this._notificationService.warn(message);
			return new WorkspaceVerificationError();
		}
	}
	_checkWorkspaceUndo(strResource, element, editStackSnapshot, checkInvalidatedResources) {
		if (element.removedResources) return this._tryToSplitAndUndo(strResource, element, element.removedResources, localize(2134, "Could not undo '{0}' across all files. {1}", element.label, element.removedResources.createMessage()));
		if (checkInvalidatedResources && element.invalidatedResources) return this._tryToSplitAndUndo(strResource, element, element.invalidatedResources, localize(2135, "Could not undo '{0}' across all files. {1}", element.label, element.invalidatedResources.createMessage()));
		const cannotUndoDueToResources = [];
		for (const editStack of editStackSnapshot.editStacks) if (editStack.getClosestPastElement() !== element) cannotUndoDueToResources.push(editStack.resourceLabel);
		if (cannotUndoDueToResources.length > 0) return this._tryToSplitAndUndo(strResource, element, null, localize(2136, "Could not undo '{0}' across all files because changes were made to {1}", element.label, cannotUndoDueToResources.join(", ")));
		const cannotLockDueToResources = [];
		for (const editStack of editStackSnapshot.editStacks) if (editStack.locked) cannotLockDueToResources.push(editStack.resourceLabel);
		if (cannotLockDueToResources.length > 0) return this._tryToSplitAndUndo(strResource, element, null, localize(2137, "Could not undo '{0}' across all files because there is already an undo or redo operation running on {1}", element.label, cannotLockDueToResources.join(", ")));
		if (!editStackSnapshot.isValid()) return this._tryToSplitAndUndo(strResource, element, null, localize(2138, "Could not undo '{0}' across all files because an undo or redo operation occurred in the meantime", element.label));
		return null;
	}
	_workspaceUndo(strResource, element, undoConfirmed) {
		const affectedEditStacks = this._getAffectedEditStacks(element);
		const verificationError = this._checkWorkspaceUndo(strResource, element, affectedEditStacks, false);
		if (verificationError) return verificationError.returnValue;
		return this._confirmAndExecuteWorkspaceUndo(strResource, element, affectedEditStacks, undoConfirmed);
	}
	_isPartOfUndoGroup(element) {
		if (!element.groupId) return false;
		for (const [, editStack] of this._editStacks) {
			const pastElement = editStack.getClosestPastElement();
			if (!pastElement) continue;
			if (pastElement === element) {
				const secondPastElement = editStack.getSecondClosestPastElement();
				if (secondPastElement && secondPastElement.groupId === element.groupId) return true;
			}
			if (pastElement.groupId === element.groupId) return true;
		}
		return false;
	}
	async _confirmAndExecuteWorkspaceUndo(strResource, element, editStackSnapshot, undoConfirmed) {
		if (element.canSplit() && !this._isPartOfUndoGroup(element)) {
			let UndoChoice;
			(function(UndoChoice) {
				UndoChoice[UndoChoice["All"] = 0] = "All";
				UndoChoice[UndoChoice["This"] = 1] = "This";
				UndoChoice[UndoChoice["Cancel"] = 2] = "Cancel";
			})(UndoChoice || (UndoChoice = {}));
			const { result } = await this._dialogService.prompt({
				type: Severity$1$1.Info,
				message: localize(2139, "Would you like to undo '{0}' across all files?", element.label),
				buttons: [{
					label: localize(2140, "&&Undo in {0} Files", editStackSnapshot.editStacks.length),
					run: () => UndoChoice.All
				}, {
					label: localize(2141, "Undo this &&File"),
					run: () => UndoChoice.This
				}],
				cancelButton: { run: () => UndoChoice.Cancel }
			});
			if (result === UndoChoice.Cancel) return;
			if (result === UndoChoice.This) {
				this._splitPastWorkspaceElement(element, null);
				return this._undo(strResource, 0, true);
			}
			const verificationError1 = this._checkWorkspaceUndo(strResource, element, editStackSnapshot, false);
			if (verificationError1) return verificationError1.returnValue;
			undoConfirmed = true;
		}
		let cleanup;
		try {
			cleanup = await this._invokeWorkspacePrepare(element);
		} catch (err) {
			return this._onError(err, element);
		}
		const verificationError2 = this._checkWorkspaceUndo(strResource, element, editStackSnapshot, true);
		if (verificationError2) {
			cleanup.dispose();
			return verificationError2.returnValue;
		}
		for (const editStack of editStackSnapshot.editStacks) editStack.moveBackward(element);
		return this._safeInvokeWithLocks(element, () => element.actual.undo(), editStackSnapshot, cleanup, () => this._continueUndoInGroup(element.groupId, undoConfirmed));
	}
	_resourceUndo(editStack, element, undoConfirmed) {
		if (!element.isValid) {
			editStack.flushAllElements();
			return;
		}
		if (editStack.locked) {
			const message = localize(2142, "Could not undo '{0}' because there is already an undo or redo operation running.", element.label);
			this._notificationService.warn(message);
			return;
		}
		return this._invokeResourcePrepare(element, (cleanup) => {
			editStack.moveBackward(element);
			return this._safeInvokeWithLocks(element, () => element.actual.undo(), new EditStackSnapshot([editStack]), cleanup, () => this._continueUndoInGroup(element.groupId, undoConfirmed));
		});
	}
	_findClosestUndoElementInGroup(groupId) {
		if (!groupId) return [null, null];
		let matchedElement = null;
		let matchedStrResource = null;
		for (const [strResource, editStack] of this._editStacks) {
			const candidate = editStack.getClosestPastElement();
			if (!candidate) continue;
			if (candidate.groupId === groupId) {
				if (!matchedElement || candidate.groupOrder > matchedElement.groupOrder) {
					matchedElement = candidate;
					matchedStrResource = strResource;
				}
			}
		}
		return [matchedElement, matchedStrResource];
	}
	_continueUndoInGroup(groupId, undoConfirmed) {
		if (!groupId) return;
		const [, matchedStrResource] = this._findClosestUndoElementInGroup(groupId);
		if (matchedStrResource) return this._undo(matchedStrResource, 0, undoConfirmed);
	}
	undo(resourceOrSource) {
		if (resourceOrSource instanceof UndoRedoSource) {
			const [, matchedStrResource] = this._findClosestUndoElementWithSource(resourceOrSource.id);
			return matchedStrResource ? this._undo(matchedStrResource, resourceOrSource.id, false) : void 0;
		}
		if (typeof resourceOrSource === "string") return this._undo(resourceOrSource, 0, false);
		return this._undo(this.getUriComparisonKey(resourceOrSource), 0, false);
	}
	_undo(strResource, sourceId = 0, undoConfirmed) {
		if (!this._editStacks.has(strResource)) return;
		const editStack = this._editStacks.get(strResource);
		const element = editStack.getClosestPastElement();
		if (!element) return;
		if (element.groupId) {
			const [matchedElement, matchedStrResource] = this._findClosestUndoElementInGroup(element.groupId);
			if (element !== matchedElement && matchedStrResource) return this._undo(matchedStrResource, sourceId, undoConfirmed);
		}
		if ((element.sourceId !== sourceId || element.confirmBeforeUndo) && !undoConfirmed) return this._confirmAndContinueUndo(strResource, sourceId, element);
		try {
			if (element.type === 1) return this._workspaceUndo(strResource, element, undoConfirmed);
			else return this._resourceUndo(editStack, element, undoConfirmed);
		} finally {}
	}
	async _confirmAndContinueUndo(strResource, sourceId, element) {
		if (!(await this._dialogService.confirm({
			message: localize(2143, "Would you like to undo '{0}'?", element.label),
			primaryButton: localize(2144, "&&Yes"),
			cancelButton: localize(2145, "No")
		})).confirmed) return;
		return this._undo(strResource, sourceId, true);
	}
	_findClosestRedoElementWithSource(sourceId) {
		if (!sourceId) return [null, null];
		let matchedElement = null;
		let matchedStrResource = null;
		for (const [strResource, editStack] of this._editStacks) {
			const candidate = editStack.getClosestFutureElement();
			if (!candidate) continue;
			if (candidate.sourceId === sourceId) {
				if (!matchedElement || candidate.sourceOrder < matchedElement.sourceOrder) {
					matchedElement = candidate;
					matchedStrResource = strResource;
				}
			}
		}
		return [matchedElement, matchedStrResource];
	}
	canRedo(resourceOrSource) {
		if (resourceOrSource instanceof UndoRedoSource) {
			const [, matchedStrResource] = this._findClosestRedoElementWithSource(resourceOrSource.id);
			return matchedStrResource ? true : false;
		}
		const strResource = this.getUriComparisonKey(resourceOrSource);
		if (this._editStacks.has(strResource)) return this._editStacks.get(strResource).hasFutureElements();
		return false;
	}
	_tryToSplitAndRedo(strResource, element, ignoreResources, message) {
		if (element.canSplit()) {
			this._splitFutureWorkspaceElement(element, ignoreResources);
			this._notificationService.warn(message);
			return new WorkspaceVerificationError(this._redo(strResource));
		} else {
			for (const strResource of element.strResources) this.removeElements(strResource);
			this._notificationService.warn(message);
			return new WorkspaceVerificationError();
		}
	}
	_checkWorkspaceRedo(strResource, element, editStackSnapshot, checkInvalidatedResources) {
		if (element.removedResources) return this._tryToSplitAndRedo(strResource, element, element.removedResources, localize(2146, "Could not redo '{0}' across all files. {1}", element.label, element.removedResources.createMessage()));
		if (checkInvalidatedResources && element.invalidatedResources) return this._tryToSplitAndRedo(strResource, element, element.invalidatedResources, localize(2147, "Could not redo '{0}' across all files. {1}", element.label, element.invalidatedResources.createMessage()));
		const cannotRedoDueToResources = [];
		for (const editStack of editStackSnapshot.editStacks) if (editStack.getClosestFutureElement() !== element) cannotRedoDueToResources.push(editStack.resourceLabel);
		if (cannotRedoDueToResources.length > 0) return this._tryToSplitAndRedo(strResource, element, null, localize(2148, "Could not redo '{0}' across all files because changes were made to {1}", element.label, cannotRedoDueToResources.join(", ")));
		const cannotLockDueToResources = [];
		for (const editStack of editStackSnapshot.editStacks) if (editStack.locked) cannotLockDueToResources.push(editStack.resourceLabel);
		if (cannotLockDueToResources.length > 0) return this._tryToSplitAndRedo(strResource, element, null, localize(2149, "Could not redo '{0}' across all files because there is already an undo or redo operation running on {1}", element.label, cannotLockDueToResources.join(", ")));
		if (!editStackSnapshot.isValid()) return this._tryToSplitAndRedo(strResource, element, null, localize(2150, "Could not redo '{0}' across all files because an undo or redo operation occurred in the meantime", element.label));
		return null;
	}
	_workspaceRedo(strResource, element) {
		const affectedEditStacks = this._getAffectedEditStacks(element);
		const verificationError = this._checkWorkspaceRedo(strResource, element, affectedEditStacks, false);
		if (verificationError) return verificationError.returnValue;
		return this._executeWorkspaceRedo(strResource, element, affectedEditStacks);
	}
	async _executeWorkspaceRedo(strResource, element, editStackSnapshot) {
		let cleanup;
		try {
			cleanup = await this._invokeWorkspacePrepare(element);
		} catch (err) {
			return this._onError(err, element);
		}
		const verificationError = this._checkWorkspaceRedo(strResource, element, editStackSnapshot, true);
		if (verificationError) {
			cleanup.dispose();
			return verificationError.returnValue;
		}
		for (const editStack of editStackSnapshot.editStacks) editStack.moveForward(element);
		return this._safeInvokeWithLocks(element, () => element.actual.redo(), editStackSnapshot, cleanup, () => this._continueRedoInGroup(element.groupId));
	}
	_resourceRedo(editStack, element) {
		if (!element.isValid) {
			editStack.flushAllElements();
			return;
		}
		if (editStack.locked) {
			const message = localize(2151, "Could not redo '{0}' because there is already an undo or redo operation running.", element.label);
			this._notificationService.warn(message);
			return;
		}
		return this._invokeResourcePrepare(element, (cleanup) => {
			editStack.moveForward(element);
			return this._safeInvokeWithLocks(element, () => element.actual.redo(), new EditStackSnapshot([editStack]), cleanup, () => this._continueRedoInGroup(element.groupId));
		});
	}
	_findClosestRedoElementInGroup(groupId) {
		if (!groupId) return [null, null];
		let matchedElement = null;
		let matchedStrResource = null;
		for (const [strResource, editStack] of this._editStacks) {
			const candidate = editStack.getClosestFutureElement();
			if (!candidate) continue;
			if (candidate.groupId === groupId) {
				if (!matchedElement || candidate.groupOrder < matchedElement.groupOrder) {
					matchedElement = candidate;
					matchedStrResource = strResource;
				}
			}
		}
		return [matchedElement, matchedStrResource];
	}
	_continueRedoInGroup(groupId) {
		if (!groupId) return;
		const [, matchedStrResource] = this._findClosestRedoElementInGroup(groupId);
		if (matchedStrResource) return this._redo(matchedStrResource);
	}
	redo(resourceOrSource) {
		if (resourceOrSource instanceof UndoRedoSource) {
			const [, matchedStrResource] = this._findClosestRedoElementWithSource(resourceOrSource.id);
			return matchedStrResource ? this._redo(matchedStrResource) : void 0;
		}
		if (typeof resourceOrSource === "string") return this._redo(resourceOrSource);
		return this._redo(this.getUriComparisonKey(resourceOrSource));
	}
	_redo(strResource) {
		if (!this._editStacks.has(strResource)) return;
		const editStack = this._editStacks.get(strResource);
		const element = editStack.getClosestFutureElement();
		if (!element) return;
		if (element.groupId) {
			const [matchedElement, matchedStrResource] = this._findClosestRedoElementInGroup(element.groupId);
			if (element !== matchedElement && matchedStrResource) return this._redo(matchedStrResource);
		}
		try {
			if (element.type === 1) return this._workspaceRedo(strResource, element);
			else return this._resourceRedo(editStack, element);
		} finally {}
	}
};
UndoRedoService = __decorate$49([__param$44(0, IDialogService), __param$44(1, INotificationService)], UndoRedoService);
var WorkspaceVerificationError = class {
	constructor(returnValue) {
		this.returnValue = returnValue;
	}
};
registerSingleton(IUndoRedoService, UndoRedoService, 1);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/quickinput/common/quickInput.js
function isKeyModified(keyMods) {
	return keyMods.ctrlCmd || keyMods.alt || keyMods.shift;
}
var NO_KEY_MODS = {
	ctrlCmd: false,
	alt: false,
	shift: false
};
var QuickInputHideReason;
(function(QuickInputHideReason) {
	/**
	* Focus moved away from the quick input.
	*/
	QuickInputHideReason[QuickInputHideReason["Blur"] = 1] = "Blur";
	/**
	* An explicit user gesture, e.g. pressing Escape key.
	*/
	QuickInputHideReason[QuickInputHideReason["Gesture"] = 2] = "Gesture";
	/**
	* Anything else.
	*/
	QuickInputHideReason[QuickInputHideReason["Other"] = 3] = "Other";
})(QuickInputHideReason || (QuickInputHideReason = {}));
/**
* Represents the activation behavior for items in a quick input. This means which item will be
* "active" (aka focused).
*/
var ItemActivation;
(function(ItemActivation) {
	/**
	* No item will be active.
	*/
	ItemActivation[ItemActivation["NONE"] = 0] = "NONE";
	/**
	* First item will be active.
	*/
	ItemActivation[ItemActivation["FIRST"] = 1] = "FIRST";
	/**
	* Second item will be active.
	*/
	ItemActivation[ItemActivation["SECOND"] = 2] = "SECOND";
	/**
	* Last item will be active.
	*/
	ItemActivation[ItemActivation["LAST"] = 3] = "LAST";
})(ItemActivation || (ItemActivation = {}));
/**
* Represents the focus options for a quick pick.
*/
var QuickPickFocus;
(function(QuickPickFocus) {
	/**
	* Focus the first item in the list.
	*/
	QuickPickFocus[QuickPickFocus["First"] = 1] = "First";
	/**
	* Focus the second item in the list.
	*/
	QuickPickFocus[QuickPickFocus["Second"] = 2] = "Second";
	/**
	* Focus the last item in the list.
	*/
	QuickPickFocus[QuickPickFocus["Last"] = 3] = "Last";
	/**
	* Focus the next item in the list.
	*/
	QuickPickFocus[QuickPickFocus["Next"] = 4] = "Next";
	/**
	* Focus the previous item in the list.
	*/
	QuickPickFocus[QuickPickFocus["Previous"] = 5] = "Previous";
	/**
	* Focus the next page in the list.
	*/
	QuickPickFocus[QuickPickFocus["NextPage"] = 6] = "NextPage";
	/**
	* Focus the previous page in the list.
	*/
	QuickPickFocus[QuickPickFocus["PreviousPage"] = 7] = "PreviousPage";
	/**
	* Focus the first item under the next separator.
	*/
	QuickPickFocus[QuickPickFocus["NextSeparator"] = 8] = "NextSeparator";
	/**
	* Focus the first item under the current separator.
	*/
	QuickPickFocus[QuickPickFocus["PreviousSeparator"] = 9] = "PreviousSeparator";
})(QuickPickFocus || (QuickPickFocus = {}));
var QuickInputButtonLocation;
(function(QuickInputButtonLocation) {
	/**
	* In the title bar.
	*/
	QuickInputButtonLocation[QuickInputButtonLocation["Title"] = 1] = "Title";
	/**
	* To the right of the input box.
	*/
	QuickInputButtonLocation[QuickInputButtonLocation["Inline"] = 2] = "Inline";
	/**
	* At the far end inside the input box.
	* Used by the public API to create toggles.
	*/
	QuickInputButtonLocation[QuickInputButtonLocation["Input"] = 3] = "Input";
})(QuickInputButtonLocation || (QuickInputButtonLocation = {}));
var IQuickInputService = createDecorator("quickInputService");
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/parts/storage/common/storage.js
var StorageHint;
(function(StorageHint) {
	StorageHint[StorageHint["STORAGE_DOES_NOT_EXIST"] = 0] = "STORAGE_DOES_NOT_EXIST";
	StorageHint[StorageHint["STORAGE_IN_MEMORY"] = 1] = "STORAGE_IN_MEMORY";
})(StorageHint || (StorageHint = {}));
var StorageState;
(function(StorageState) {
	StorageState[StorageState["None"] = 0] = "None";
	StorageState[StorageState["Initialized"] = 1] = "Initialized";
	StorageState[StorageState["Closed"] = 2] = "Closed";
})(StorageState || (StorageState = {}));
var Storage = class Storage extends Disposable {
	static {
		this.DEFAULT_FLUSH_DELAY = 100;
	}
	constructor(database, options = Object.create(null)) {
		super();
		this.database = database;
		this.options = options;
		this._onDidChangeStorage = this._register(new PauseableEmitter());
		this.onDidChangeStorage = this._onDidChangeStorage.event;
		this.state = StorageState.None;
		this.cache = /* @__PURE__ */ new Map();
		this.flushDelayer = this._register(new ThrottledDelayer(Storage.DEFAULT_FLUSH_DELAY));
		this.pendingDeletes = /* @__PURE__ */ new Set();
		this.pendingInserts = /* @__PURE__ */ new Map();
		this.pendingClose = void 0;
		this.whenFlushedCallbacks = [];
		this.registerListeners();
	}
	registerListeners() {
		this._register(this.database.onDidChangeItemsExternal((e) => this.onDidChangeItemsExternal(e)));
	}
	onDidChangeItemsExternal(e) {
		this._onDidChangeStorage.pause();
		try {
			e.changed?.forEach((value, key) => this.acceptExternal(key, value));
			e.deleted?.forEach((key) => this.acceptExternal(key, void 0));
		} finally {
			this._onDidChangeStorage.resume();
		}
	}
	acceptExternal(key, value) {
		if (this.state === StorageState.Closed) return;
		let changed = false;
		if (isUndefinedOrNull(value)) changed = this.cache.delete(key);
		else if (this.cache.get(key) !== value) {
			this.cache.set(key, value);
			changed = true;
		}
		if (changed) this._onDidChangeStorage.fire({
			key,
			external: true
		});
	}
	get(key, fallbackValue) {
		const value = this.cache.get(key);
		if (isUndefinedOrNull(value)) return fallbackValue;
		return value;
	}
	getBoolean(key, fallbackValue) {
		const value = this.get(key);
		if (isUndefinedOrNull(value)) return fallbackValue;
		return value === "true";
	}
	getNumber(key, fallbackValue) {
		const value = this.get(key);
		if (isUndefinedOrNull(value)) return fallbackValue;
		return parseInt(value, 10);
	}
	async set(key, value, external = false) {
		if (this.state === StorageState.Closed) return;
		if (isUndefinedOrNull(value)) return this.delete(key, external);
		const valueStr = isObject(value) || Array.isArray(value) ? stringify(value) : String(value);
		if (this.cache.get(key) === valueStr) return;
		this.cache.set(key, valueStr);
		this.pendingInserts.set(key, valueStr);
		this.pendingDeletes.delete(key);
		this._onDidChangeStorage.fire({
			key,
			external
		});
		return this.doFlush();
	}
	async delete(key, external = false) {
		if (this.state === StorageState.Closed) return;
		if (!this.cache.delete(key)) return;
		if (!this.pendingDeletes.has(key)) this.pendingDeletes.add(key);
		this.pendingInserts.delete(key);
		this._onDidChangeStorage.fire({
			key,
			external
		});
		return this.doFlush();
	}
	get hasPending() {
		return this.pendingInserts.size > 0 || this.pendingDeletes.size > 0;
	}
	async flushPending() {
		if (!this.hasPending) return;
		const updateRequest = {
			insert: this.pendingInserts,
			delete: this.pendingDeletes
		};
		this.pendingDeletes = /* @__PURE__ */ new Set();
		this.pendingInserts = /* @__PURE__ */ new Map();
		return this.database.updateItems(updateRequest).finally(() => {
			if (!this.hasPending) while (this.whenFlushedCallbacks.length) this.whenFlushedCallbacks.pop()?.();
		});
	}
	async flush(delay) {
		if (this.state === StorageState.Closed || this.pendingClose) return;
		return this.doFlush(delay);
	}
	async doFlush(delay) {
		if (this.options.hint === StorageHint.STORAGE_IN_MEMORY) return this.flushPending();
		return this.flushDelayer.trigger(() => this.flushPending(), delay);
	}
	async whenFlushed() {
		if (!this.hasPending) return;
		return new Promise((resolve) => this.whenFlushedCallbacks.push(resolve));
	}
};
var InMemoryStorageDatabase = class {
	constructor() {
		this.onDidChangeItemsExternal = Event.None;
		this.items = /* @__PURE__ */ new Map();
	}
	async updateItems(request) {
		request.insert?.forEach((value, key) => this.items.set(key, value));
		request.delete?.forEach((key) => this.items.delete(key));
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/storage/common/storage.js
var TARGET_KEY = "__$__targetStorageMarker";
var IStorageService = createDecorator("storageService");
var WillSaveStateReason;
(function(WillSaveStateReason) {
	/**
	* No specific reason to save state.
	*/
	WillSaveStateReason[WillSaveStateReason["NONE"] = 0] = "NONE";
	/**
	* A hint that the workbench is about to shutdown.
	*/
	WillSaveStateReason[WillSaveStateReason["SHUTDOWN"] = 1] = "SHUTDOWN";
})(WillSaveStateReason || (WillSaveStateReason = {}));
function loadKeyTargets(storage) {
	const keysRaw = storage.get(TARGET_KEY);
	if (keysRaw) try {
		return JSON.parse(keysRaw);
	} catch (error) {}
	return Object.create(null);
}
var AbstractStorageService = class AbstractStorageService extends Disposable {
	static {
		this.DEFAULT_FLUSH_INTERVAL = 6e4;
	}
	constructor(options = { flushInterval: AbstractStorageService.DEFAULT_FLUSH_INTERVAL }) {
		super();
		this._onDidChangeValue = this._register(new PauseableEmitter());
		this._onDidChangeTarget = this._register(new PauseableEmitter());
		this._onWillSaveState = this._register(new Emitter$1());
		this.onWillSaveState = this._onWillSaveState.event;
		this.runFlushWhenIdle = this._register(new MutableDisposable());
		this._workspaceKeyTargets = void 0;
		this._profileKeyTargets = void 0;
		this._applicationKeyTargets = void 0;
		this._applicationSharedKeyTargets = void 0;
		this.flushWhenIdleScheduler = this._register(new RunOnceScheduler(() => this.doFlushWhenIdle(), options.flushInterval));
	}
	onDidChangeValue(scope, key, disposable) {
		return Event.filter(this._onDidChangeValue.event, (e) => e.scope === scope && (key === void 0 || e.key === key), disposable);
	}
	doFlushWhenIdle() {
		this.runFlushWhenIdle.value = runWhenGlobalIdle(() => {
			if (this.shouldFlushWhenIdle()) this.flush();
			this.flushWhenIdleScheduler.schedule();
		});
	}
	shouldFlushWhenIdle() {
		return true;
	}
	emitDidChangeValue(scope, event) {
		const { key, external } = event;
		if (key === "__$__targetStorageMarker") {
			switch (scope) {
				case -2:
					this._applicationSharedKeyTargets = void 0;
					break;
				case -1:
					this._applicationKeyTargets = void 0;
					break;
				case 0:
					this._profileKeyTargets = void 0;
					break;
				case 1: this._workspaceKeyTargets = void 0;
			}
			this._onDidChangeTarget.fire({ scope });
		} else this._onDidChangeValue.fire({
			scope,
			key,
			target: this.getKeyTargets(scope)[key],
			external
		});
	}
	get(key, scope, fallbackValue) {
		return this.getStorage(scope)?.get(key, fallbackValue);
	}
	getBoolean(key, scope, fallbackValue) {
		return this.getStorage(scope)?.getBoolean(key, fallbackValue);
	}
	getNumber(key, scope, fallbackValue) {
		return this.getStorage(scope)?.getNumber(key, fallbackValue);
	}
	store(key, value, scope, target, external = false) {
		if (isUndefinedOrNull(value)) {
			this.remove(key, scope, external);
			return;
		}
		this.withPausedEmitters(() => {
			this.updateKeyTarget(key, scope, target);
			this.getStorage(scope)?.set(key, value, external);
		});
	}
	remove(key, scope, external = false) {
		this.withPausedEmitters(() => {
			this.updateKeyTarget(key, scope, void 0);
			this.getStorage(scope)?.delete(key, external);
		});
	}
	withPausedEmitters(fn) {
		this._onDidChangeValue.pause();
		this._onDidChangeTarget.pause();
		try {
			fn();
		} finally {
			this._onDidChangeValue.resume();
			this._onDidChangeTarget.resume();
		}
	}
	updateKeyTarget(key, scope, target, external = false) {
		const keyTargets = this.getKeyTargets(scope);
		if (typeof target === "number") {
			if (keyTargets[key] !== target) {
				keyTargets[key] = target;
				this.getStorage(scope)?.set(TARGET_KEY, JSON.stringify(keyTargets), external);
			}
		} else if (typeof keyTargets[key] === "number") {
			delete keyTargets[key];
			this.getStorage(scope)?.set(TARGET_KEY, JSON.stringify(keyTargets), external);
		}
	}
	get workspaceKeyTargets() {
		if (!this._workspaceKeyTargets) this._workspaceKeyTargets = this.loadKeyTargets(1);
		return this._workspaceKeyTargets;
	}
	get profileKeyTargets() {
		if (!this._profileKeyTargets) this._profileKeyTargets = this.loadKeyTargets(0);
		return this._profileKeyTargets;
	}
	get applicationKeyTargets() {
		if (!this._applicationKeyTargets) this._applicationKeyTargets = this.loadKeyTargets(-1);
		return this._applicationKeyTargets;
	}
	get applicationSharedKeyTargets() {
		if (!this._applicationSharedKeyTargets) this._applicationSharedKeyTargets = this.loadKeyTargets(-2);
		return this._applicationSharedKeyTargets;
	}
	getKeyTargets(scope) {
		switch (scope) {
			case -2: return this.applicationSharedKeyTargets;
			case -1: return this.applicationKeyTargets;
			case 0: return this.profileKeyTargets;
			default: return this.workspaceKeyTargets;
		}
	}
	loadKeyTargets(scope) {
		const storage = this.getStorage(scope);
		return storage ? loadKeyTargets(storage) : Object.create(null);
	}
	async flush(reason = WillSaveStateReason.NONE) {
		this._onWillSaveState.fire({ reason });
		const applicationStorage = this.getStorage(-1);
		const applicationSharedStorage = this.getStorage(-2);
		const profileStorage = this.getStorage(0);
		const workspaceStorage = this.getStorage(1);
		switch (reason) {
			case WillSaveStateReason.NONE:
				await Promises.settled([
					applicationStorage?.whenFlushed() ?? Promise.resolve(),
					applicationSharedStorage?.whenFlushed() ?? Promise.resolve(),
					profileStorage?.whenFlushed() ?? Promise.resolve(),
					workspaceStorage?.whenFlushed() ?? Promise.resolve()
				]);
				break;
			case WillSaveStateReason.SHUTDOWN: await Promises.settled([
				applicationStorage?.flush(0) ?? Promise.resolve(),
				applicationSharedStorage?.flush(0) ?? Promise.resolve(),
				profileStorage?.flush(0) ?? Promise.resolve(),
				workspaceStorage?.flush(0) ?? Promise.resolve()
			]);
		}
	}
};
var InMemoryStorageService = class extends AbstractStorageService {
	constructor() {
		super();
		this.applicationStorage = this._register(new Storage(new InMemoryStorageDatabase(), { hint: StorageHint.STORAGE_IN_MEMORY }));
		this.applicationSharedStorage = this._register(new Storage(new InMemoryStorageDatabase(), { hint: StorageHint.STORAGE_IN_MEMORY }));
		this.profileStorage = this._register(new Storage(new InMemoryStorageDatabase(), { hint: StorageHint.STORAGE_IN_MEMORY }));
		this.workspaceStorage = this._register(new Storage(new InMemoryStorageDatabase(), { hint: StorageHint.STORAGE_IN_MEMORY }));
		this._register(this.workspaceStorage.onDidChangeStorage((e) => this.emitDidChangeValue(1, e)));
		this._register(this.profileStorage.onDidChangeStorage((e) => this.emitDidChangeValue(0, e)));
		this._register(this.applicationStorage.onDidChangeStorage((e) => this.emitDidChangeValue(-1, e)));
		this._register(this.applicationSharedStorage.onDidChangeStorage((e) => this.emitDidChangeValue(-2, e)));
	}
	getStorage(scope) {
		switch (scope) {
			case -2: return this.applicationSharedStorage;
			case -1: return this.applicationStorage;
			case 0: return this.profileStorage;
			default: return this.workspaceStorage;
		}
	}
	shouldFlushWhenIdle() {
		return false;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/services/inlineCompletionsService.js
var __decorate$48 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$43 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var IInlineCompletionsService = createDecorator("IInlineCompletionsService");
var InlineCompletionsSnoozing = new RawContextKey("inlineCompletions.snoozed", false, localize(83, "Whether inline completions are currently snoozed"));
var InlineCompletionsService = class InlineCompletionsService extends Disposable {
	get snoozeTimeLeft() {
		if (this._snoozeTimeEnd === void 0) return 0;
		return Math.max(0, this._snoozeTimeEnd - Date.now());
	}
	constructor(_contextKeyService, _telemetryService) {
		super();
		this._contextKeyService = _contextKeyService;
		this._telemetryService = _telemetryService;
		this._onDidChangeIsSnoozing = this._register(new Emitter$1());
		this.onDidChangeIsSnoozing = this._onDidChangeIsSnoozing.event;
		this._snoozeTimeEnd = void 0;
		this._recentCompletionIds = [];
		this._timer = this._register(new TimeoutTimer());
		const inlineCompletionsSnoozing = InlineCompletionsSnoozing.bindTo(this._contextKeyService);
		this._register(this.onDidChangeIsSnoozing(() => inlineCompletionsSnoozing.set(this.isSnoozing())));
	}
	setSnoozeDuration(durationMs) {
		if (durationMs < 0) throw new BugIndicatingError(`Invalid snooze duration: ${durationMs}. Duration must be non-negative.`);
		if (durationMs === 0) {
			this.cancelSnooze();
			return;
		}
		const wasSnoozing = this.isSnoozing();
		const timeLeft = this.snoozeTimeLeft;
		this._snoozeTimeEnd = Date.now() + durationMs;
		if (!wasSnoozing) this._onDidChangeIsSnoozing.fire(true);
		this._timer.cancelAndSet(() => {
			if (!this.isSnoozing()) this._onDidChangeIsSnoozing.fire(false);
			else throw new BugIndicatingError("Snooze timer did not fire as expected");
		}, this.snoozeTimeLeft + 1);
		this._reportSnooze(durationMs - timeLeft, durationMs);
	}
	isSnoozing() {
		return this.snoozeTimeLeft > 0;
	}
	cancelSnooze() {
		if (this.isSnoozing()) {
			this._reportSnooze(-this.snoozeTimeLeft, 0);
			this._snoozeTimeEnd = void 0;
			this._timer.cancel();
			this._onDidChangeIsSnoozing.fire(false);
		}
	}
	reportNewCompletion(requestUuid) {
		this._lastCompletionId = requestUuid;
		this._recentCompletionIds.unshift(requestUuid);
		if (this._recentCompletionIds.length > 5) this._recentCompletionIds.pop();
	}
	_reportSnooze(deltaMs, totalMs) {
		const deltaSeconds = Math.round(deltaMs / 1e3);
		const totalSeconds = Math.round(totalMs / 1e3);
		this._telemetryService.publicLog2("inlineCompletions.snooze", {
			deltaSeconds,
			totalSeconds,
			lastCompletionId: this._lastCompletionId,
			recentCompletionIds: this._recentCompletionIds
		});
	}
};
InlineCompletionsService = __decorate$48([__param$43(0, IContextKeyService), __param$43(1, ITelemetryService)], InlineCompletionsService);
registerSingleton(IInlineCompletionsService, InlineCompletionsService, 1);
var snoozeInlineSuggestId = "editor.action.inlineSuggest.snooze";
var cancelSnoozeInlineSuggestId = "editor.action.inlineSuggest.cancelSnooze";
var LAST_SNOOZE_DURATION_KEY = "inlineCompletions.lastSnoozeDuration";
var SnoozeInlineCompletion = class SnoozeInlineCompletion extends Action2 {
	static {
		this.ID = snoozeInlineSuggestId;
	}
	constructor() {
		super({
			id: SnoozeInlineCompletion.ID,
			title: localize2(97, "Snooze Inline Suggestions"),
			precondition: ContextKeyExpr.true(),
			f1: true
		});
	}
	async run(accessor, ...args) {
		const quickInputService = accessor.get(IQuickInputService);
		const inlineCompletionsService = accessor.get(IInlineCompletionsService);
		const storageService = accessor.get(IStorageService);
		let durationMs;
		if (args.length > 0 && typeof args[0] === "number") durationMs = args[0] * 6e4;
		if (!durationMs) durationMs = await this.getDurationFromUser(quickInputService, storageService);
		if (durationMs) inlineCompletionsService.setSnoozeDuration(durationMs);
	}
	async getDurationFromUser(quickInputService, storageService) {
		const lastSelectedDuration = storageService.getNumber(LAST_SNOOZE_DURATION_KEY, 0, 3e5);
		const predefinedItems = [
			{
				label: localize(84, "1 minute"),
				id: "1",
				value: 6e4
			},
			{
				label: localize(85, "5 minutes"),
				id: "5",
				value: 3e5
			},
			{
				label: localize(86, "10 minutes"),
				id: "10",
				value: 6e5
			},
			{
				label: localize(87, "15 minutes"),
				id: "15",
				value: 9e5
			},
			{
				label: localize(88, "30 minutes"),
				id: "30",
				value: 18e5
			},
			{
				label: localize(89, "60 minutes"),
				id: "60",
				value: 36e5
			}
		];
		let items = predefinedItems;
		if (lastSelectedDuration > 0 && !predefinedItems.some((item) => item.value === lastSelectedDuration)) {
			const minutes = lastSelectedDuration / 6e4;
			const customItem = {
				label: localize(90, "{0} minutes (Last used)", minutes),
				id: "last-custom",
				value: lastSelectedDuration,
				description: localize(91, "Last used custom duration")
			};
			const index = predefinedItems.findIndex((item) => item.value > lastSelectedDuration);
			if (index === -1) items = [...predefinedItems, customItem];
			else items = [
				...predefinedItems.slice(0, index),
				customItem,
				...predefinedItems.slice(index)
			];
		}
		items.push({
			label: localize(92, "Custom..."),
			id: "custom",
			value: -1
		});
		const picked = await quickInputService.pick(items, {
			placeHolder: localize(93, "Select snooze duration for Inline Suggestions"),
			activeItem: items.find((item) => item.value === lastSelectedDuration)
		});
		if (picked) {
			if (picked.id === "custom") return this.getCustomDurationFromUser(quickInputService, storageService);
			storageService.store(LAST_SNOOZE_DURATION_KEY, picked.value, 0, 0);
			return picked.value;
		}
	}
	async getCustomDurationFromUser(quickInputService, storageService) {
		const customMinutes = await quickInputService.input({
			placeHolder: localize(94, "Duration in minutes (e.g. 90)"),
			prompt: localize(95, "Enter snooze duration in minutes"),
			validateInput: async (value) => {
				const n = Number(value);
				if (isNaN(n) || n <= 0 || !Number.isFinite(n)) return localize(96, "Please enter a positive number");
			}
		});
		if (customMinutes) {
			const ms = Number(customMinutes) * 6e4;
			storageService.store(LAST_SNOOZE_DURATION_KEY, ms, 0, 0);
			return ms;
		}
	}
};
var CancelSnoozeInlineCompletion = class CancelSnoozeInlineCompletion extends Action2 {
	static {
		this.ID = cancelSnoozeInlineSuggestId;
	}
	constructor() {
		super({
			id: CancelSnoozeInlineCompletion.ID,
			title: localize2(98, "Cancel Snooze Inline Suggestions"),
			precondition: InlineCompletionsSnoozing,
			f1: true
		});
	}
	async run(accessor) {
		accessor.get(IInlineCompletionsService).cancelSnooze();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/environment/common/environment.js
var IEnvironmentService = createDecorator("environmentService");
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/services/languageFeatureDebounce.js
var __decorate$47 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$42 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var ILanguageFeatureDebounceService = createDecorator("ILanguageFeatureDebounceService");
var IdentityHash;
(function(IdentityHash) {
	const _hashes = /* @__PURE__ */ new WeakMap();
	let pool = 0;
	function of(obj) {
		let value = _hashes.get(obj);
		if (value === void 0) {
			value = ++pool;
			_hashes.set(obj, value);
		}
		return value;
	}
	IdentityHash.of = of;
})(IdentityHash || (IdentityHash = {}));
var NullDebounceInformation = class {
	constructor(_default) {
		this._default = _default;
	}
	get(_model) {
		return this._default;
	}
	update(_model, _value) {
		return this._default;
	}
	default() {
		return this._default;
	}
};
var FeatureDebounceInformation = class {
	constructor(_logService, _name, _registry, _default, _min, _max) {
		this._logService = _logService;
		this._name = _name;
		this._registry = _registry;
		this._default = _default;
		this._min = _min;
		this._max = _max;
		this._cache = new LRUCache(50, .7);
	}
	_key(model) {
		return model.id + this._registry.all(model).reduce((hashVal, obj) => doHash(IdentityHash.of(obj), hashVal), 0);
	}
	get(model) {
		const key = this._key(model);
		const avg = this._cache.get(key);
		return avg ? clamp(avg.value, this._min, this._max) : this.default();
	}
	update(model, value) {
		const key = this._key(model);
		let avg = this._cache.get(key);
		if (!avg) {
			avg = new SlidingWindowAverage(6);
			this._cache.set(key, avg);
		}
		const newValue = clamp(avg.update(value), this._min, this._max);
		if (!matchesScheme(model.uri, "output")) this._logService.trace(`[DEBOUNCE: ${this._name}] for ${model.uri.toString()} is ${newValue}ms`);
		return newValue;
	}
	_overall() {
		const result = new MovingAverage();
		for (const [, avg] of this._cache) result.update(avg.value);
		return result.value;
	}
	default() {
		return clamp(this._overall() | 0 || this._default, this._min, this._max);
	}
};
var LanguageFeatureDebounceService = class LanguageFeatureDebounceService {
	constructor(_logService, envService) {
		this._logService = _logService;
		this._data = /* @__PURE__ */ new Map();
		this._isDev = envService.isExtensionDevelopment || !envService.isBuilt;
	}
	for(feature, name, config) {
		const min = config?.min ?? 50;
		const max = config?.max ?? min ** 2;
		const extra = config?.key ?? void 0;
		const key = `${IdentityHash.of(feature)},${min}${extra ? "," + extra : ""}`;
		let info = this._data.get(key);
		if (!info) {
			if (this._isDev) {
				this._logService.debug(`[DEBOUNCE: ${name}] is disabled in developed mode`);
				info = new NullDebounceInformation(min * 1.5);
			} else info = new FeatureDebounceInformation(this._logService, name, feature, this._overallAverage() | 0 || min * 1.5, min, max);
			this._data.set(key, info);
		}
		return info;
	}
	_overallAverage() {
		const result = new MovingAverage();
		for (const info of this._data.values()) result.update(info.default());
		return result.value;
	}
};
LanguageFeatureDebounceService = __decorate$47([__param$42(0, ILogService), __param$42(1, IEnvironmentService)], LanguageFeatureDebounceService);
registerSingleton(ILanguageFeatureDebounceService, LanguageFeatureDebounceService, 1);
var PATH_REGEX = "[/\\\\]";
var NO_PATH_REGEX = "[^/\\\\]";
var ALL_FORWARD_SLASHES = /\//g;
function starsToRegExp(starCount, isLastPattern) {
	switch (starCount) {
		case 0: return "";
		case 1: return `${NO_PATH_REGEX}*?`;
		default: return `(?:${PATH_REGEX}|${NO_PATH_REGEX}+${PATH_REGEX}${isLastPattern ? `|${PATH_REGEX}${NO_PATH_REGEX}+` : ""})*?`;
	}
}
function splitGlobAware(pattern, splitChar) {
	if (!pattern) return [];
	const segments = [];
	let inBraces = false;
	let inBrackets = false;
	let curVal = "";
	for (const char of pattern) {
		switch (char) {
			case splitChar:
				if (!inBraces && !inBrackets) {
					segments.push(curVal);
					curVal = "";
					continue;
				}
				break;
			case "{":
				inBraces = true;
				break;
			case "}":
				inBraces = false;
				break;
			case "[":
				inBrackets = true;
				break;
			case "]": inBrackets = false;
		}
		curVal += char;
	}
	if (curVal) segments.push(curVal);
	return segments;
}
function parseRegExp(pattern) {
	if (!pattern) return "";
	let regEx = "";
	const segments = splitGlobAware(pattern, "/");
	if (segments.every((segment) => segment === "**")) regEx = ".*";
	else {
		let previousSegmentWasGlobStar = false;
		segments.forEach((segment, index) => {
			if (segment === "**") {
				if (previousSegmentWasGlobStar) return;
				regEx += starsToRegExp(2, index === segments.length - 1);
			} else {
				let inBraces = false;
				let braceVal = "";
				let inBrackets = false;
				let bracketVal = "";
				for (const char of segment) {
					if (char !== "}" && inBraces) {
						braceVal += char;
						continue;
					}
					if (inBrackets && (char !== "]" || !bracketVal)) {
						let res;
						if (char === "-") res = char;
						else if ((char === "^" || char === "!") && !bracketVal) res = "^";
						else if (char === "/") res = "";
						else res = escapeRegExpCharacters(char);
						bracketVal += res;
						continue;
					}
					switch (char) {
						case "{":
							inBraces = true;
							continue;
						case "[":
							inBrackets = true;
							continue;
						case "}": {
							const braceRegExp = `(?:${splitGlobAware(braceVal, ",").map((choice) => parseRegExp(choice)).join("|")})`;
							regEx += braceRegExp;
							inBraces = false;
							braceVal = "";
							break;
						}
						case "]":
							regEx += "[" + bracketVal + "]";
							inBrackets = false;
							bracketVal = "";
							break;
						case "?":
							regEx += NO_PATH_REGEX;
							continue;
						case "*":
							regEx += starsToRegExp(1);
							continue;
						default: regEx += escapeRegExpCharacters(char);
					}
				}
				if (index < segments.length - 1 && (segments[index + 1] !== "**" || index + 2 < segments.length)) regEx += PATH_REGEX;
			}
			previousSegmentWasGlobStar = segment === "**";
		});
	}
	return regEx;
}
var T1 = /^\*\*\/\*\.[\w\.-]+$/;
var T2 = /^\*\*\/([\w\.-]+)\/?$/;
var T3 = /^{\*\*\/\*?[\w\.-]+\/?(,\*\*\/\*?[\w\.-]+\/?)*}$/;
var T3_2 = /^{\*\*\/\*?[\w\.-]+(\/(\*\*)?)?(,\*\*\/\*?[\w\.-]+(\/(\*\*)?)?)*}$/;
var T4 = /^\*\*((\/[\w\.-]+)+)\/?$/;
var T5 = /^([\w\.-]+(\/[\w\.-]+)*)\/?$/;
var CACHE = new LRUCache(1e4);
var FALSE = function() {
	return false;
};
var NULL = function() {
	return null;
};
function parsePattern(arg1, options, cacheKey) {
	if (!arg1) return NULL;
	let pattern;
	if (typeof arg1 !== "string") pattern = arg1.pattern;
	else pattern = arg1;
	pattern = pattern.trim();
	const ignoreCase = options.ignoreCase ?? false;
	const internalOptions = {
		...options,
		equals: ignoreCase ? equalsIgnoreCase : (a, b) => a === b,
		endsWith: ignoreCase ? endsWithIgnoreCase : (str, candidate) => str.endsWith(candidate),
		isEqualOrParent: (base, candidate) => isEqualOrParent(base, candidate, options.ignoreCase ?? !isLinux)
	};
	const patternKey = `${cacheKey === void 0 ? `default:${ignoreCase ? pattern.toLowerCase() : pattern}` : `custom:${cacheKey}`}_${!!options.trimForExclusions}_${ignoreCase}`;
	let parsedPattern = CACHE.get(patternKey);
	if (parsedPattern) return wrapRelativePattern(parsedPattern, arg1, internalOptions);
	let match;
	if (T1.test(pattern)) parsedPattern = trivia1(pattern.substring(4), pattern, internalOptions);
	else if (match = T2.exec(trimForExclusions(pattern, internalOptions))) parsedPattern = trivia2(match[1], pattern, internalOptions);
	else if ((options.trimForExclusions ? T3_2 : T3).test(pattern)) parsedPattern = trivia3(pattern, internalOptions);
	else if (match = T4.exec(trimForExclusions(pattern, internalOptions))) parsedPattern = trivia4and5(match[1].substring(1), pattern, true, internalOptions);
	else if (match = T5.exec(trimForExclusions(pattern, internalOptions))) parsedPattern = trivia4and5(match[1], pattern, false, internalOptions);
	else parsedPattern = toRegExp(pattern, internalOptions);
	CACHE.set(patternKey, parsedPattern);
	return wrapRelativePattern(parsedPattern, arg1, internalOptions);
}
function wrapRelativePattern(parsedPattern, arg2, options) {
	if (typeof arg2 === "string") return parsedPattern;
	const wrappedPattern = function(path, basename) {
		if (!options.isEqualOrParent(path, arg2.base)) return null;
		return parsedPattern(ltrim(path.substring(arg2.base.length), sep), basename);
	};
	wrappedPattern.allBasenames = parsedPattern.allBasenames;
	wrappedPattern.allPaths = parsedPattern.allPaths;
	wrappedPattern.basenames = parsedPattern.basenames;
	wrappedPattern.patterns = parsedPattern.patterns;
	return wrappedPattern;
}
function trimForExclusions(pattern, options) {
	return options.trimForExclusions && pattern.endsWith("/**") ? pattern.substring(0, pattern.length - 2) : pattern;
}
function trivia1(base, pattern, options) {
	return function(path, basename) {
		return typeof path === "string" && options.endsWith(path, base) ? pattern : null;
	};
}
function trivia2(base, pattern, options) {
	const slashBase = `/${base}`;
	const backslashBase = `\\${base}`;
	const parsedPattern = function(path, basename) {
		if (typeof path !== "string") return null;
		if (basename) return options.equals(basename, base) ? pattern : null;
		return options.equals(path, base) || options.endsWith(path, slashBase) || options.endsWith(path, backslashBase) ? pattern : null;
	};
	const basenames = [base];
	parsedPattern.basenames = basenames;
	parsedPattern.patterns = [pattern];
	parsedPattern.allBasenames = basenames;
	return parsedPattern;
}
function trivia3(pattern, options) {
	const parsedPatterns = aggregateBasenameMatches(pattern.slice(1, -1).split(",").map((pattern) => parsePattern(pattern, options)).filter((pattern) => pattern !== NULL), pattern, options.ignoreCase);
	const patternsLength = parsedPatterns.length;
	if (!patternsLength) return NULL;
	if (patternsLength === 1) return parsedPatterns[0];
	const parsedPattern = function(path, basename) {
		for (let i = 0, n = parsedPatterns.length; i < n; i++) if (parsedPatterns[i](path, basename)) return pattern;
		return null;
	};
	const withBasenames = parsedPatterns.find((pattern) => !!pattern.allBasenames);
	if (withBasenames) parsedPattern.allBasenames = withBasenames.allBasenames;
	const allPaths = parsedPatterns.reduce((all, current) => current.allPaths ? all.concat(current.allPaths) : all, []);
	if (allPaths.length) parsedPattern.allPaths = allPaths;
	return parsedPattern;
}
function trivia4and5(targetPath, pattern, matchPathEnds, options) {
	const usingPosixSep = sep === posix.sep;
	const nativePath = usingPosixSep ? targetPath : targetPath.replace(ALL_FORWARD_SLASHES, sep);
	const nativePathEnd = sep + nativePath;
	const targetPathEnd = posix.sep + targetPath;
	let parsedPattern;
	if (matchPathEnds) parsedPattern = function(path, basename) {
		return typeof path === "string" && (options.equals(path, nativePath) || options.endsWith(path, nativePathEnd) || !usingPosixSep && (options.equals(path, targetPath) || options.endsWith(path, targetPathEnd))) ? pattern : null;
	};
	else parsedPattern = function(path, basename) {
		return typeof path === "string" && (options.equals(path, nativePath) || !usingPosixSep && options.equals(path, targetPath)) ? pattern : null;
	};
	parsedPattern.allPaths = [(matchPathEnds ? "*/" : "./") + targetPath];
	return parsedPattern;
}
function toRegExp(pattern, options) {
	try {
		const regExp = new RegExp(`^${parseRegExp(pattern)}$`, options.ignoreCase ? "i" : void 0);
		return function(path) {
			regExp.lastIndex = 0;
			return typeof path === "string" && regExp.test(path) ? pattern : null;
		};
	} catch {
		return NULL;
	}
}
function match(arg1, path, options) {
	if (!arg1 || typeof path !== "string") return false;
	return parse(arg1, options)(path);
}
function parse(arg1, options = {}) {
	if (!arg1) return FALSE;
	if (typeof arg1 === "string" || isRelativePattern(arg1)) {
		const parsedPattern = parsePattern(arg1, options);
		if (parsedPattern === NULL) return FALSE;
		const resultPattern = function(path, basename) {
			return !!parsedPattern(path, basename);
		};
		if (parsedPattern.allBasenames) resultPattern.allBasenames = parsedPattern.allBasenames;
		if (parsedPattern.allPaths) resultPattern.allPaths = parsedPattern.allPaths;
		return resultPattern;
	}
	return parsedExpression(arg1, options);
}
function isRelativePattern(obj) {
	const rp = obj;
	if (!rp) return false;
	return typeof rp.base === "string" && typeof rp.pattern === "string";
}
function parsedExpression(expression, options) {
	const parsedPatterns = aggregateBasenameMatches(Object.getOwnPropertyNames(expression).map((pattern) => parseExpressionPattern(pattern, expression[pattern], options)).filter((pattern) => pattern !== NULL), void 0, options.ignoreCase);
	const patternsLength = parsedPatterns.length;
	if (!patternsLength) return NULL;
	if (!parsedPatterns.some((parsedPattern) => !!parsedPattern.requiresSiblings)) {
		if (patternsLength === 1) return parsedPatterns[0];
		const resultExpression = function(path, basename) {
			let resultPromises = void 0;
			for (let i = 0, n = parsedPatterns.length; i < n; i++) {
				const result = parsedPatterns[i](path, basename);
				if (typeof result === "string") return result;
				if (isThenable$1(result)) {
					if (!resultPromises) resultPromises = [];
					resultPromises.push(result);
				}
			}
			if (resultPromises) return (async () => {
				for (const resultPromise of resultPromises) {
					const result = await resultPromise;
					if (typeof result === "string") return result;
				}
				return null;
			})();
			return null;
		};
		const withBasenames = parsedPatterns.find((pattern) => !!pattern.allBasenames);
		if (withBasenames) resultExpression.allBasenames = withBasenames.allBasenames;
		const allPaths = parsedPatterns.reduce((all, current) => current.allPaths ? all.concat(current.allPaths) : all, []);
		if (allPaths.length) resultExpression.allPaths = allPaths;
		return resultExpression;
	}
	const resultExpression = function(path, base, hasSibling) {
		let name = void 0;
		let resultPromises = void 0;
		for (let i = 0, n = parsedPatterns.length; i < n; i++) {
			const parsedPattern = parsedPatterns[i];
			if (parsedPattern.requiresSiblings && hasSibling) {
				if (!base) base = basename$1(path);
				if (!name) name = base.substring(0, base.length - extname$1(path).length);
			}
			const result = parsedPattern(path, base, name, hasSibling);
			if (typeof result === "string") return result;
			if (isThenable$1(result)) {
				if (!resultPromises) resultPromises = [];
				resultPromises.push(result);
			}
		}
		if (resultPromises) return (async () => {
			for (const resultPromise of resultPromises) {
				const result = await resultPromise;
				if (typeof result === "string") return result;
			}
			return null;
		})();
		return null;
	};
	const withBasenames = parsedPatterns.find((pattern) => !!pattern.allBasenames);
	if (withBasenames) resultExpression.allBasenames = withBasenames.allBasenames;
	const allPaths = parsedPatterns.reduce((all, current) => current.allPaths ? all.concat(current.allPaths) : all, []);
	if (allPaths.length) resultExpression.allPaths = allPaths;
	return resultExpression;
}
function parseExpressionPattern(pattern, value, options) {
	if (value === false) return NULL;
	const parsedPattern = parsePattern(pattern, options, pattern);
	if (parsedPattern === NULL) return NULL;
	if (typeof value === "boolean") return parsedPattern;
	if (value) {
		const when = value.when;
		if (typeof when === "string") {
			const result = (path, basename, name, hasSibling) => {
				if (!hasSibling || !parsedPattern(path, basename)) return null;
				const matched = hasSibling(when.replace("$(basename)", () => name));
				return isThenable$1(matched) ? matched.then((match) => match ? pattern : null) : matched ? pattern : null;
			};
			result.requiresSiblings = true;
			return result;
		}
	}
	return parsedPattern;
}
function aggregateBasenameMatches(parsedPatterns, result, ignoreCase) {
	const basenamePatterns = parsedPatterns.filter((parsedPattern) => !!parsedPattern.basenames);
	if (basenamePatterns.length < 2) return parsedPatterns;
	const basenames = basenamePatterns.reduce((all, current) => {
		const basenames = current.basenames;
		return basenames ? all.concat(basenames) : all;
	}, []);
	let patterns;
	if (result) {
		patterns = [];
		for (let i = 0, n = basenames.length; i < n; i++) patterns.push(result);
	} else patterns = basenamePatterns.reduce((all, current) => {
		const patterns = current.patterns;
		return patterns ? all.concat(patterns) : all;
	}, []);
	const aggregate = function(path, basename) {
		if (typeof path !== "string") return null;
		if (!basename) {
			let i;
			for (i = path.length; i > 0; i--) {
				const ch = path.charCodeAt(i - 1);
				if (ch === 47 || ch === 92) break;
			}
			basename = path.substring(i);
		}
		const index = ignoreCase ? basenames.findIndex((candidate) => equalsIgnoreCase(candidate, basename)) : basenames.indexOf(basename);
		return index !== -1 ? patterns[index] : null;
	};
	aggregate.basenames = basenames;
	aggregate.patterns = patterns;
	aggregate.allBasenames = basenames;
	const aggregatedPatterns = parsedPatterns.filter((parsedPattern) => !parsedPattern.basenames);
	aggregatedPatterns.push(aggregate);
	return aggregatedPatterns;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/languageSelector.js
function score$1(selector, candidateUri, candidateLanguage, candidateIsSynchronized, candidateNotebookUri, candidateNotebookType) {
	if (Array.isArray(selector)) {
		let ret = 0;
		for (const filter of selector) {
			const value = score$1(filter, candidateUri, candidateLanguage, candidateIsSynchronized, candidateNotebookUri, candidateNotebookType);
			if (value === 10) return value;
			if (value > ret) ret = value;
		}
		return ret;
	} else if (typeof selector === "string") {
		if (!candidateIsSynchronized) return 0;
		if (selector === "*") return 5;
		else if (selector === candidateLanguage) return 10;
		else return 0;
	} else if (selector) {
		const { language, pattern, scheme, hasAccessToAllModels, notebookType } = selector;
		if (!candidateIsSynchronized && !hasAccessToAllModels) return 0;
		if (notebookType && candidateNotebookUri) candidateUri = candidateNotebookUri;
		let ret = 0;
		if (scheme) {
			if (scheme === candidateUri.scheme) ret = 10;
			else if (scheme === "*") ret = 5;
			else return 0;
		}
		if (language) {
			if (language === candidateLanguage) ret = 10;
			else if (language === "*") ret = Math.max(ret, 5);
			else return 0;
		}
		if (notebookType) {
			if (notebookType === candidateNotebookType) ret = 10;
			else if (notebookType === "*" && candidateNotebookType !== void 0) ret = Math.max(ret, 5);
			else return 0;
		}
		if (pattern) {
			let normalizedPattern;
			if (typeof pattern === "string") normalizedPattern = pattern;
			else normalizedPattern = {
				...pattern,
				base: normalize$1(pattern.base)
			};
			if (normalizedPattern === candidateUri.fsPath || match(normalizedPattern, candidateUri.fsPath)) ret = 10;
			else return 0;
		}
		return ret;
	} else return 0;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/languageFeatureRegistry.js
function isExclusive(selector) {
	if (typeof selector === "string") return false;
	else if (Array.isArray(selector)) return selector.every(isExclusive);
	else return !!selector.exclusive;
}
var MatchCandidate = class {
	constructor(uri, languageId, notebookUri, notebookType, recursive) {
		this.uri = uri;
		this.languageId = languageId;
		this.notebookUri = notebookUri;
		this.notebookType = notebookType;
		this.recursive = recursive;
	}
	equals(other) {
		return this.notebookType === other.notebookType && this.languageId === other.languageId && this.uri.toString() === other.uri.toString() && this.notebookUri?.toString() === other.notebookUri?.toString() && this.recursive === other.recursive;
	}
};
var LanguageFeatureRegistry = class LanguageFeatureRegistry {
	get onDidChange() {
		return this._onDidChange.event;
	}
	constructor(_notebookInfoResolver) {
		this._notebookInfoResolver = _notebookInfoResolver;
		this._clock = 0;
		this._entries = [];
		this._onDidChange = new Emitter$1();
	}
	register(selector, provider) {
		let entry = {
			selector,
			provider,
			_score: -1,
			_time: this._clock++
		};
		this._entries.push(entry);
		this._lastCandidate = void 0;
		this._onDidChange.fire(this._entries.length);
		return toDisposable(() => {
			if (entry) {
				const idx = this._entries.indexOf(entry);
				if (idx >= 0) {
					this._entries.splice(idx, 1);
					this._lastCandidate = void 0;
					this._onDidChange.fire(this._entries.length);
					entry = void 0;
				}
			}
		});
	}
	has(model) {
		return this.all(model).length > 0;
	}
	all(model) {
		if (!model) return [];
		this._updateScores(model, false);
		const result = [];
		for (const entry of this._entries) if (entry._score > 0) result.push(entry.provider);
		return result;
	}
	allNoModel() {
		return this._entries.map((entry) => entry.provider);
	}
	ordered(model, recursive = false) {
		const result = [];
		this._orderedForEach(model, recursive, (entry) => result.push(entry.provider));
		return result;
	}
	orderedGroups(model) {
		const result = [];
		let lastBucket;
		let lastBucketScore;
		this._orderedForEach(model, false, (entry) => {
			if (lastBucket && lastBucketScore === entry._score) lastBucket.push(entry.provider);
			else {
				lastBucketScore = entry._score;
				lastBucket = [entry.provider];
				result.push(lastBucket);
			}
		});
		return result;
	}
	_orderedForEach(model, recursive, callback) {
		this._updateScores(model, recursive);
		for (const entry of this._entries) if (entry._score > 0) callback(entry);
	}
	_updateScores(model, recursive) {
		const notebookInfo = this._notebookInfoResolver?.(model.uri);
		const candidate = notebookInfo ? new MatchCandidate(model.uri, model.getLanguageId(), notebookInfo.uri, notebookInfo.type, recursive) : new MatchCandidate(model.uri, model.getLanguageId(), void 0, void 0, recursive);
		if (this._lastCandidate?.equals(candidate)) return;
		this._lastCandidate = candidate;
		for (const entry of this._entries) {
			entry._score = score$1(entry.selector, candidate.uri, candidate.languageId, shouldSynchronizeModel(model), candidate.notebookUri, candidate.notebookType);
			if (isExclusive(entry.selector) && entry._score > 0) {
				if (recursive) entry._score = 0;
				else {
					for (const entry of this._entries) entry._score = 0;
					entry._score = 1e3;
					break;
				}
			}
		}
		this._entries.sort(LanguageFeatureRegistry._compareByScoreAndTime);
	}
	static _compareByScoreAndTime(a, b) {
		if (a._score < b._score) return 1;
		else if (a._score > b._score) return -1;
		if (isBuiltinSelector(a.selector) && !isBuiltinSelector(b.selector)) return 1;
		else if (!isBuiltinSelector(a.selector) && isBuiltinSelector(b.selector)) return -1;
		if (a._time < b._time) return 1;
		else if (a._time > b._time) return -1;
		else return 0;
	}
};
function isBuiltinSelector(selector) {
	if (typeof selector === "string") return false;
	if (Array.isArray(selector)) return selector.some(isBuiltinSelector);
	return Boolean(selector.isBuiltin);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/services/languageFeaturesService.js
var LanguageFeaturesService = class {
	constructor() {
		this.referenceProvider = new LanguageFeatureRegistry(this._score.bind(this));
		this.renameProvider = new LanguageFeatureRegistry(this._score.bind(this));
		this.newSymbolNamesProvider = new LanguageFeatureRegistry(this._score.bind(this));
		this.codeActionProvider = new LanguageFeatureRegistry(this._score.bind(this));
		this.definitionProvider = new LanguageFeatureRegistry(this._score.bind(this));
		this.typeDefinitionProvider = new LanguageFeatureRegistry(this._score.bind(this));
		this.declarationProvider = new LanguageFeatureRegistry(this._score.bind(this));
		this.implementationProvider = new LanguageFeatureRegistry(this._score.bind(this));
		this.documentSymbolProvider = new LanguageFeatureRegistry(this._score.bind(this));
		this.inlayHintsProvider = new LanguageFeatureRegistry(this._score.bind(this));
		this.colorProvider = new LanguageFeatureRegistry(this._score.bind(this));
		this.codeLensProvider = new LanguageFeatureRegistry(this._score.bind(this));
		this.documentFormattingEditProvider = new LanguageFeatureRegistry(this._score.bind(this));
		this.documentRangeFormattingEditProvider = new LanguageFeatureRegistry(this._score.bind(this));
		this.onTypeFormattingEditProvider = new LanguageFeatureRegistry(this._score.bind(this));
		this.signatureHelpProvider = new LanguageFeatureRegistry(this._score.bind(this));
		this.hoverProvider = new LanguageFeatureRegistry(this._score.bind(this));
		this.documentHighlightProvider = new LanguageFeatureRegistry(this._score.bind(this));
		this.multiDocumentHighlightProvider = new LanguageFeatureRegistry(this._score.bind(this));
		this.selectionRangeProvider = new LanguageFeatureRegistry(this._score.bind(this));
		this.foldingRangeProvider = new LanguageFeatureRegistry(this._score.bind(this));
		this.linkProvider = new LanguageFeatureRegistry(this._score.bind(this));
		this.inlineCompletionsProvider = new LanguageFeatureRegistry(this._score.bind(this));
		this.completionProvider = new LanguageFeatureRegistry(this._score.bind(this));
		this.linkedEditingRangeProvider = new LanguageFeatureRegistry(this._score.bind(this));
		this.documentRangeSemanticTokensProvider = new LanguageFeatureRegistry(this._score.bind(this));
		this.documentSemanticTokensProvider = new LanguageFeatureRegistry(this._score.bind(this));
		this.documentDropEditProvider = new LanguageFeatureRegistry(this._score.bind(this));
		this.documentPasteEditProvider = new LanguageFeatureRegistry(this._score.bind(this));
	}
	_score(uri) {
		return this._notebookTypeResolver?.(uri);
	}
};
registerSingleton(ILanguageFeaturesService, LanguageFeaturesService, 1);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/tokens/common.js
var RateLimiter = class {
	constructor(timesPerSecond = 5) {
		this.timesPerSecond = timesPerSecond;
		this._lastRun = 0;
		this._minimumTimeBetweenRuns = 1e3 / timesPerSecond;
	}
	runIfNotLimited(callback) {
		const now = Date.now();
		if (now - this._lastRun >= this._minimumTimeBetweenRuns) {
			this._lastRun = now;
			callback();
		}
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/tokens/sparseMultilineTokens.js
/**
* Represents sparse tokens over a contiguous range of lines.
*/
var SparseMultilineTokens = class SparseMultilineTokens {
	static create(startLineNumber, tokens) {
		return new SparseMultilineTokens(startLineNumber, new SparseMultilineTokensStorage(tokens));
	}
	/**
	* (Inclusive) start line number for these tokens.
	*/
	get startLineNumber() {
		return this._startLineNumber;
	}
	/**
	* (Inclusive) end line number for these tokens.
	*/
	get endLineNumber() {
		return this._endLineNumber;
	}
	constructor(startLineNumber, tokens) {
		this._startLineNumber = startLineNumber;
		this._tokens = tokens;
		this._endLineNumber = this._startLineNumber + this._tokens.getMaxDeltaLine();
	}
	toString() {
		return this._tokens.toString(this._startLineNumber);
	}
	_updateEndLineNumber() {
		this._endLineNumber = this._startLineNumber + this._tokens.getMaxDeltaLine();
	}
	isEmpty() {
		return this._tokens.isEmpty();
	}
	getLineTokens(lineNumber) {
		if (this._startLineNumber <= lineNumber && lineNumber <= this._endLineNumber) return this._tokens.getLineTokens(lineNumber - this._startLineNumber);
		return null;
	}
	getRange() {
		const deltaRange = this._tokens.getRange();
		if (!deltaRange) return deltaRange;
		return new Range$2(this._startLineNumber + deltaRange.startLineNumber, deltaRange.startColumn, this._startLineNumber + deltaRange.endLineNumber, deltaRange.endColumn);
	}
	removeTokens(range) {
		const startLineIndex = range.startLineNumber - this._startLineNumber;
		const endLineIndex = range.endLineNumber - this._startLineNumber;
		this._startLineNumber += this._tokens.removeTokens(startLineIndex, range.startColumn - 1, endLineIndex, range.endColumn - 1);
		this._updateEndLineNumber();
	}
	split(range) {
		const startLineIndex = range.startLineNumber - this._startLineNumber;
		const endLineIndex = range.endLineNumber - this._startLineNumber;
		const [a, b, bDeltaLine] = this._tokens.split(startLineIndex, range.startColumn - 1, endLineIndex, range.endColumn - 1);
		return [new SparseMultilineTokens(this._startLineNumber, a), new SparseMultilineTokens(this._startLineNumber + bDeltaLine, b)];
	}
	applyEdit(range, text) {
		const [eolCount, firstLineLength, lastLineLength] = countEOL(text);
		this.acceptEdit(range, eolCount, firstLineLength, lastLineLength, text.length > 0 ? text.charCodeAt(0) : 0);
	}
	acceptEdit(range, eolCount, firstLineLength, lastLineLength, firstCharCode) {
		this._acceptDeleteRange(range);
		this._acceptInsertText(new Position$1(range.startLineNumber, range.startColumn), eolCount, firstLineLength, lastLineLength, firstCharCode);
		this._updateEndLineNumber();
	}
	_acceptDeleteRange(range) {
		if (range.startLineNumber === range.endLineNumber && range.startColumn === range.endColumn) return;
		const firstLineIndex = range.startLineNumber - this._startLineNumber;
		const lastLineIndex = range.endLineNumber - this._startLineNumber;
		if (lastLineIndex < 0) {
			const deletedLinesCount = lastLineIndex - firstLineIndex;
			this._startLineNumber -= deletedLinesCount;
			return;
		}
		const tokenMaxDeltaLine = this._tokens.getMaxDeltaLine();
		if (firstLineIndex >= tokenMaxDeltaLine + 1) return;
		if (firstLineIndex < 0 && lastLineIndex >= tokenMaxDeltaLine + 1) {
			this._startLineNumber = 0;
			this._tokens.clear();
			return;
		}
		if (firstLineIndex < 0) {
			const deletedBefore = -firstLineIndex;
			this._startLineNumber -= deletedBefore;
			this._tokens.acceptDeleteRange(range.startColumn - 1, 0, 0, lastLineIndex, range.endColumn - 1);
		} else this._tokens.acceptDeleteRange(0, firstLineIndex, range.startColumn - 1, lastLineIndex, range.endColumn - 1);
	}
	_acceptInsertText(position, eolCount, firstLineLength, lastLineLength, firstCharCode) {
		if (eolCount === 0 && firstLineLength === 0) return;
		const lineIndex = position.lineNumber - this._startLineNumber;
		if (lineIndex < 0) {
			this._startLineNumber += eolCount;
			return;
		}
		if (lineIndex >= this._tokens.getMaxDeltaLine() + 1) return;
		this._tokens.acceptInsertText(lineIndex, position.column - 1, eolCount, firstLineLength, lastLineLength, firstCharCode);
	}
	reportIfInvalid(model) {
		this._tokens.reportIfInvalid(model, this._startLineNumber);
	}
};
var SparseMultilineTokensStorage = class SparseMultilineTokensStorage {
	constructor(tokens) {
		this._tokens = tokens;
		this._tokenCount = tokens.length / 4;
	}
	toString(startLineNumber) {
		const pieces = [];
		for (let i = 0; i < this._tokenCount; i++) pieces.push(`(${this._getDeltaLine(i) + startLineNumber},${this._getStartCharacter(i)}-${this._getEndCharacter(i)})`);
		return `[${pieces.join(",")}]`;
	}
	getMaxDeltaLine() {
		const tokenCount = this._getTokenCount();
		if (tokenCount === 0) return -1;
		return this._getDeltaLine(tokenCount - 1);
	}
	getRange() {
		const tokenCount = this._getTokenCount();
		if (tokenCount === 0) return null;
		const startChar = this._getStartCharacter(0);
		const maxDeltaLine = this._getDeltaLine(tokenCount - 1);
		const endChar = this._getEndCharacter(tokenCount - 1);
		return new Range$2(0, startChar + 1, maxDeltaLine, endChar + 1);
	}
	_getTokenCount() {
		return this._tokenCount;
	}
	_getDeltaLine(tokenIndex) {
		return this._tokens[4 * tokenIndex];
	}
	_getStartCharacter(tokenIndex) {
		return this._tokens[4 * tokenIndex + 1];
	}
	_getEndCharacter(tokenIndex) {
		return this._tokens[4 * tokenIndex + 2];
	}
	isEmpty() {
		return this._getTokenCount() === 0;
	}
	getLineTokens(deltaLine) {
		let low = 0;
		let high = this._getTokenCount() - 1;
		while (low < high) {
			const mid = low + Math.floor((high - low) / 2);
			const midDeltaLine = this._getDeltaLine(mid);
			if (midDeltaLine < deltaLine) low = mid + 1;
			else if (midDeltaLine > deltaLine) high = mid - 1;
			else {
				let min = mid;
				while (min > low && this._getDeltaLine(min - 1) === deltaLine) min--;
				let max = mid;
				while (max < high && this._getDeltaLine(max + 1) === deltaLine) max++;
				return new SparseLineTokens(this._tokens.subarray(4 * min, 4 * max + 4));
			}
		}
		if (this._getDeltaLine(low) === deltaLine) return new SparseLineTokens(this._tokens.subarray(4 * low, 4 * low + 4));
		return null;
	}
	clear() {
		this._tokenCount = 0;
	}
	removeTokens(startDeltaLine, startChar, endDeltaLine, endChar) {
		const tokens = this._tokens;
		const tokenCount = this._tokenCount;
		let newTokenCount = 0;
		let hasDeletedTokens = false;
		let firstDeltaLine = 0;
		for (let i = 0; i < tokenCount; i++) {
			const srcOffset = 4 * i;
			const tokenDeltaLine = tokens[srcOffset];
			const tokenStartCharacter = tokens[srcOffset + 1];
			const tokenEndCharacter = tokens[srcOffset + 2];
			const tokenMetadata = tokens[srcOffset + 3];
			if ((tokenDeltaLine > startDeltaLine || tokenDeltaLine === startDeltaLine && tokenEndCharacter >= startChar) && (tokenDeltaLine < endDeltaLine || tokenDeltaLine === endDeltaLine && tokenStartCharacter <= endChar)) hasDeletedTokens = true;
			else {
				if (newTokenCount === 0) firstDeltaLine = tokenDeltaLine;
				if (hasDeletedTokens) {
					const destOffset = 4 * newTokenCount;
					tokens[destOffset] = tokenDeltaLine - firstDeltaLine;
					tokens[destOffset + 1] = tokenStartCharacter;
					tokens[destOffset + 2] = tokenEndCharacter;
					tokens[destOffset + 3] = tokenMetadata;
				} else if (firstDeltaLine !== 0) tokens[srcOffset] = tokenDeltaLine - firstDeltaLine;
				newTokenCount++;
			}
		}
		this._tokenCount = newTokenCount;
		return firstDeltaLine;
	}
	split(startDeltaLine, startChar, endDeltaLine, endChar) {
		const tokens = this._tokens;
		const tokenCount = this._tokenCount;
		const aTokens = [];
		const bTokens = [];
		let destTokens = aTokens;
		let destOffset = 0;
		let destFirstDeltaLine = 0;
		for (let i = 0; i < tokenCount; i++) {
			const srcOffset = 4 * i;
			const tokenDeltaLine = tokens[srcOffset];
			const tokenStartCharacter = tokens[srcOffset + 1];
			const tokenEndCharacter = tokens[srcOffset + 2];
			const tokenMetadata = tokens[srcOffset + 3];
			if (tokenDeltaLine > startDeltaLine || tokenDeltaLine === startDeltaLine && tokenEndCharacter >= startChar) {
				if (tokenDeltaLine < endDeltaLine || tokenDeltaLine === endDeltaLine && tokenStartCharacter <= endChar) continue;
				else if (destTokens !== bTokens) {
					destTokens = bTokens;
					destOffset = 0;
					destFirstDeltaLine = tokenDeltaLine;
				}
			}
			destTokens[destOffset++] = tokenDeltaLine - destFirstDeltaLine;
			destTokens[destOffset++] = tokenStartCharacter;
			destTokens[destOffset++] = tokenEndCharacter;
			destTokens[destOffset++] = tokenMetadata;
		}
		return [
			new SparseMultilineTokensStorage(new Uint32Array(aTokens)),
			new SparseMultilineTokensStorage(new Uint32Array(bTokens)),
			destFirstDeltaLine
		];
	}
	acceptDeleteRange(horizontalShiftForFirstLineTokens, startDeltaLine, startCharacter, endDeltaLine, endCharacter) {
		const tokens = this._tokens;
		const tokenCount = this._tokenCount;
		const deletedLineCount = endDeltaLine - startDeltaLine;
		let newTokenCount = 0;
		let hasDeletedTokens = false;
		for (let i = 0; i < tokenCount; i++) {
			const srcOffset = 4 * i;
			let tokenDeltaLine = tokens[srcOffset];
			let tokenStartCharacter = tokens[srcOffset + 1];
			let tokenEndCharacter = tokens[srcOffset + 2];
			const tokenMetadata = tokens[srcOffset + 3];
			if (tokenDeltaLine < startDeltaLine || tokenDeltaLine === startDeltaLine && tokenEndCharacter <= startCharacter) {
				newTokenCount++;
				continue;
			} else if (tokenDeltaLine === startDeltaLine && tokenStartCharacter < startCharacter) {
				if (tokenDeltaLine === endDeltaLine && tokenEndCharacter > endCharacter) tokenEndCharacter -= endCharacter - startCharacter;
				else tokenEndCharacter = startCharacter;
			} else if (tokenDeltaLine === startDeltaLine && tokenStartCharacter === startCharacter) {
				if (tokenDeltaLine === endDeltaLine && tokenEndCharacter > endCharacter) tokenEndCharacter -= endCharacter - startCharacter;
				else {
					hasDeletedTokens = true;
					continue;
				}
			} else if (tokenDeltaLine < endDeltaLine || tokenDeltaLine === endDeltaLine && tokenStartCharacter < endCharacter) {
				if (tokenDeltaLine === endDeltaLine && tokenEndCharacter > endCharacter) {
					tokenDeltaLine = startDeltaLine;
					tokenStartCharacter = startCharacter;
					tokenEndCharacter = tokenStartCharacter + (tokenEndCharacter - endCharacter);
				} else {
					hasDeletedTokens = true;
					continue;
				}
			} else if (tokenDeltaLine > endDeltaLine) {
				if (deletedLineCount === 0 && !hasDeletedTokens) {
					newTokenCount = tokenCount;
					break;
				}
				tokenDeltaLine -= deletedLineCount;
			} else if (tokenDeltaLine === endDeltaLine && tokenStartCharacter >= endCharacter) {
				if (horizontalShiftForFirstLineTokens && tokenDeltaLine === 0) {
					tokenStartCharacter += horizontalShiftForFirstLineTokens;
					tokenEndCharacter += horizontalShiftForFirstLineTokens;
				}
				tokenDeltaLine -= deletedLineCount;
				tokenStartCharacter -= endCharacter - startCharacter;
				tokenEndCharacter -= endCharacter - startCharacter;
			} else throw new Error(`Not possible!`);
			const destOffset = 4 * newTokenCount;
			tokens[destOffset] = tokenDeltaLine;
			tokens[destOffset + 1] = tokenStartCharacter;
			tokens[destOffset + 2] = tokenEndCharacter;
			tokens[destOffset + 3] = tokenMetadata;
			newTokenCount++;
		}
		this._tokenCount = newTokenCount;
	}
	acceptInsertText(deltaLine, character, eolCount, firstLineLength, lastLineLength, firstCharCode) {
		const isInsertingPreciselyOneWordCharacter = eolCount === 0 && firstLineLength === 1 && (firstCharCode >= 48 && firstCharCode <= 57 || firstCharCode >= 65 && firstCharCode <= 90 || firstCharCode >= 97 && firstCharCode <= 122);
		const tokens = this._tokens;
		const tokenCount = this._tokenCount;
		for (let i = 0; i < tokenCount; i++) {
			const offset = 4 * i;
			let tokenDeltaLine = tokens[offset];
			let tokenStartCharacter = tokens[offset + 1];
			let tokenEndCharacter = tokens[offset + 2];
			if (tokenDeltaLine < deltaLine || tokenDeltaLine === deltaLine && tokenEndCharacter < character) continue;
			else if (tokenDeltaLine === deltaLine && tokenEndCharacter === character) {
				if (isInsertingPreciselyOneWordCharacter) tokenEndCharacter += 1;
				else continue;
			} else if (tokenDeltaLine === deltaLine && tokenStartCharacter < character && character < tokenEndCharacter) {
				if (eolCount === 0) tokenEndCharacter += firstLineLength;
				else tokenEndCharacter = character;
			} else {
				if (tokenDeltaLine === deltaLine && tokenStartCharacter === character) {
					if (isInsertingPreciselyOneWordCharacter) continue;
				}
				if (tokenDeltaLine === deltaLine) {
					tokenDeltaLine += eolCount;
					if (eolCount === 0) {
						tokenStartCharacter += firstLineLength;
						tokenEndCharacter += firstLineLength;
					} else {
						const tokenLength = tokenEndCharacter - tokenStartCharacter;
						tokenStartCharacter = lastLineLength + (tokenStartCharacter - character);
						tokenEndCharacter = tokenStartCharacter + tokenLength;
					}
				} else tokenDeltaLine += eolCount;
			}
			tokens[offset] = tokenDeltaLine;
			tokens[offset + 1] = tokenStartCharacter;
			tokens[offset + 2] = tokenEndCharacter;
		}
	}
	static {
		this._rateLimiter = new RateLimiter(10 / 60);
	}
	reportIfInvalid(model, startLineNumber) {
		for (let i = 0; i < this._tokenCount; i++) {
			const lineNumber = this._getDeltaLine(i) + startLineNumber;
			if (lineNumber < 1) SparseMultilineTokensStorage._rateLimiter.runIfNotLimited(() => {
				console.error("Invalid Semantic Tokens Data From Extension: lineNumber < 1");
			});
			else if (lineNumber > model.getLineCount()) SparseMultilineTokensStorage._rateLimiter.runIfNotLimited(() => {
				console.error("Invalid Semantic Tokens Data From Extension: lineNumber > model.getLineCount()");
			});
			else if (this._getEndCharacter(i) > model.getLineLength(lineNumber)) SparseMultilineTokensStorage._rateLimiter.runIfNotLimited(() => {
				console.error("Invalid Semantic Tokens Data From Extension: end character > model.getLineLength(lineNumber)");
			});
		}
	}
};
var SparseLineTokens = class {
	constructor(tokens) {
		this._tokens = tokens;
	}
	getCount() {
		return this._tokens.length / 4;
	}
	getStartCharacter(tokenIndex) {
		return this._tokens[4 * tokenIndex + 1];
	}
	getEndCharacter(tokenIndex) {
		return this._tokens[4 * tokenIndex + 2];
	}
	getMetadata(tokenIndex) {
		return this._tokens[4 * tokenIndex + 3];
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/services/semanticTokensProviderStyling.js
var __decorate$46 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$41 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var SemanticTokensProviderStyling = class SemanticTokensProviderStyling {
	constructor(_legend, _themeService, _languageService, _logService) {
		this._legend = _legend;
		this._themeService = _themeService;
		this._languageService = _languageService;
		this._logService = _logService;
		this._hasWarnedOverlappingTokens = false;
		this._hasWarnedInvalidLengthTokens = false;
		this._hasWarnedInvalidEditStart = false;
		this._hasWarnedInvalidEditDeleteCount = false;
		this._hashTable = new HashTable();
	}
	getMetadata(tokenTypeIndex, tokenModifierSet, languageId) {
		const encodedLanguageId = this._languageService.languageIdCodec.encodeLanguageId(languageId);
		const entry = this._hashTable.get(tokenTypeIndex, tokenModifierSet, encodedLanguageId);
		let metadata;
		if (entry) metadata = entry.metadata;
		else {
			let tokenType = this._legend.tokenTypes[tokenTypeIndex];
			const tokenModifiers = [];
			if (tokenType) {
				let modifierSet = tokenModifierSet;
				for (let modifierIndex = 0; modifierSet > 0 && modifierIndex < this._legend.tokenModifiers.length; modifierIndex++) {
					if (modifierSet & 1) tokenModifiers.push(this._legend.tokenModifiers[modifierIndex]);
					modifierSet = modifierSet >> 1;
				}
				const tokenStyle = this._themeService.getColorTheme().getTokenStyleMetadata(tokenType, tokenModifiers, languageId);
				if (typeof tokenStyle === "undefined") metadata = 2147483647;
				else {
					metadata = 0;
					if (typeof tokenStyle.italic !== "undefined") {
						const italicBit = (tokenStyle.italic ? 1 : 0) << 11;
						metadata |= italicBit | 1;
					}
					if (typeof tokenStyle.bold !== "undefined") {
						const boldBit = (tokenStyle.bold ? 2 : 0) << 11;
						metadata |= boldBit | 2;
					}
					if (typeof tokenStyle.underline !== "undefined") {
						const underlineBit = (tokenStyle.underline ? 4 : 0) << 11;
						metadata |= underlineBit | 4;
					}
					if (typeof tokenStyle.strikethrough !== "undefined") {
						const strikethroughBit = (tokenStyle.strikethrough ? 8 : 0) << 11;
						metadata |= strikethroughBit | 8;
					}
					if (tokenStyle.foreground) {
						const foregroundBits = tokenStyle.foreground << 15;
						metadata |= foregroundBits | 16;
					}
					if (metadata === 0) metadata = 2147483647;
				}
			} else {
				metadata = 2147483647;
				tokenType = "not-in-legend";
			}
			this._hashTable.add(tokenTypeIndex, tokenModifierSet, encodedLanguageId, metadata);
		}
		return metadata;
	}
	warnOverlappingSemanticTokens(lineNumber, startColumn) {
		if (!this._hasWarnedOverlappingTokens) {
			this._hasWarnedOverlappingTokens = true;
			this._logService.warn(`Overlapping semantic tokens detected at lineNumber ${lineNumber}, column ${startColumn}`);
		}
	}
	warnInvalidLengthSemanticTokens(lineNumber, startColumn) {
		if (!this._hasWarnedInvalidLengthTokens) {
			this._hasWarnedInvalidLengthTokens = true;
			this._logService.warn(`Semantic token with invalid length detected at lineNumber ${lineNumber}, column ${startColumn}`);
		}
	}
	warnInvalidEditStart(previousResultId, resultId, editIndex, editStart, maxExpectedStart) {
		if (!this._hasWarnedInvalidEditStart) {
			this._hasWarnedInvalidEditStart = true;
			this._logService.warn(`Invalid semantic tokens edit detected (previousResultId: ${previousResultId}, resultId: ${resultId}) at edit #${editIndex}: The provided start offset ${editStart} is outside the previous data (length ${maxExpectedStart}).`);
		}
	}
	warnInvalidEditDeleteCount(previousResultId, resultId, srcLength, deltaLength) {
		if (!this._hasWarnedInvalidEditDeleteCount) {
			this._hasWarnedInvalidEditDeleteCount = true;
			this._logService.warn(`Invalid semantic tokens edit detected (previousResultId: ${previousResultId}, resultId: ${resultId}): The edits delete more tokens than the previous data contains (previous length ${srcLength}, computed length ${srcLength + deltaLength}).`);
		}
	}
};
SemanticTokensProviderStyling = __decorate$46([
	__param$41(1, IThemeService),
	__param$41(2, ILanguageService),
	__param$41(3, ILogService)
], SemanticTokensProviderStyling);
function toMultilineTokens2(tokens, styling, languageId) {
	const srcData = tokens.data;
	const tokenCount = tokens.data.length / 5 | 0;
	const tokensPerArea = Math.max(Math.ceil(tokenCount / 1024), 400);
	const result = [];
	let tokenIndex = 0;
	let lastLineNumber = 1;
	let lastStartCharacter = 0;
	while (tokenIndex < tokenCount) {
		const tokenStartIndex = tokenIndex;
		let tokenEndIndex = Math.min(tokenStartIndex + tokensPerArea, tokenCount);
		if (tokenEndIndex < tokenCount) {
			let smallTokenEndIndex = tokenEndIndex;
			while (smallTokenEndIndex - 1 > tokenStartIndex && srcData[5 * smallTokenEndIndex] === 0) smallTokenEndIndex--;
			if (smallTokenEndIndex - 1 === tokenStartIndex) {
				let bigTokenEndIndex = tokenEndIndex;
				while (bigTokenEndIndex + 1 < tokenCount && srcData[5 * bigTokenEndIndex] === 0) bigTokenEndIndex++;
				tokenEndIndex = bigTokenEndIndex;
			} else tokenEndIndex = smallTokenEndIndex;
		}
		let destData = new Uint32Array((tokenEndIndex - tokenStartIndex) * 4);
		let destOffset = 0;
		let areaLine = 0;
		let prevLineNumber = 0;
		let prevEndCharacter = 0;
		while (tokenIndex < tokenEndIndex) {
			const srcOffset = 5 * tokenIndex;
			const deltaLine = srcData[srcOffset];
			const deltaCharacter = srcData[srcOffset + 1];
			const lineNumber = lastLineNumber + deltaLine | 0;
			const startCharacter = deltaLine === 0 ? lastStartCharacter + deltaCharacter | 0 : deltaCharacter;
			const endCharacter = startCharacter + srcData[srcOffset + 2] | 0;
			const tokenTypeIndex = srcData[srcOffset + 3];
			const tokenModifierSet = srcData[srcOffset + 4];
			if (endCharacter <= startCharacter) styling.warnInvalidLengthSemanticTokens(lineNumber, startCharacter + 1);
			else if (prevLineNumber === lineNumber && prevEndCharacter > startCharacter) styling.warnOverlappingSemanticTokens(lineNumber, startCharacter + 1);
			else {
				const metadata = styling.getMetadata(tokenTypeIndex, tokenModifierSet, languageId);
				if (metadata !== 2147483647) {
					if (areaLine === 0) areaLine = lineNumber;
					destData[destOffset] = lineNumber - areaLine;
					destData[destOffset + 1] = startCharacter;
					destData[destOffset + 2] = endCharacter;
					destData[destOffset + 3] = metadata;
					destOffset += 4;
					prevLineNumber = lineNumber;
					prevEndCharacter = endCharacter;
				}
			}
			lastLineNumber = lineNumber;
			lastStartCharacter = startCharacter;
			tokenIndex++;
		}
		if (destOffset !== destData.length) destData = destData.subarray(0, destOffset);
		const tokens = SparseMultilineTokens.create(areaLine, destData);
		result.push(tokens);
	}
	return result;
}
var HashTableEntry = class {
	constructor(tokenTypeIndex, tokenModifierSet, languageId, metadata) {
		this.tokenTypeIndex = tokenTypeIndex;
		this.tokenModifierSet = tokenModifierSet;
		this.languageId = languageId;
		this.metadata = metadata;
		this.next = null;
	}
};
var HashTable = class HashTable {
	static {
		this._SIZES = [
			3,
			7,
			13,
			31,
			61,
			127,
			251,
			509,
			1021,
			2039,
			4093,
			8191,
			16381,
			32749,
			65521,
			131071,
			262139,
			524287,
			1048573,
			2097143
		];
	}
	constructor() {
		this._elementsCount = 0;
		this._currentLengthIndex = 0;
		this._currentLength = HashTable._SIZES[this._currentLengthIndex];
		this._growCount = Math.round(this._currentLengthIndex + 1 < HashTable._SIZES.length ? 2 / 3 * this._currentLength : 0);
		this._elements = [];
		HashTable._nullOutEntries(this._elements, this._currentLength);
	}
	static _nullOutEntries(entries, length) {
		for (let i = 0; i < length; i++) entries[i] = null;
	}
	_hash2(n1, n2) {
		return (n1 << 5) - n1 + n2 | 0;
	}
	_hashFunc(tokenTypeIndex, tokenModifierSet, languageId) {
		return this._hash2(this._hash2(tokenTypeIndex, tokenModifierSet), languageId) % this._currentLength;
	}
	get(tokenTypeIndex, tokenModifierSet, languageId) {
		const hash = this._hashFunc(tokenTypeIndex, tokenModifierSet, languageId);
		let p = this._elements[hash];
		while (p) {
			if (p.tokenTypeIndex === tokenTypeIndex && p.tokenModifierSet === tokenModifierSet && p.languageId === languageId) return p;
			p = p.next;
		}
		return null;
	}
	add(tokenTypeIndex, tokenModifierSet, languageId, metadata) {
		this._elementsCount++;
		if (this._growCount !== 0 && this._elementsCount >= this._growCount) {
			const oldElements = this._elements;
			this._currentLengthIndex++;
			this._currentLength = HashTable._SIZES[this._currentLengthIndex];
			this._growCount = Math.round(this._currentLengthIndex + 1 < HashTable._SIZES.length ? 2 / 3 * this._currentLength : 0);
			this._elements = [];
			HashTable._nullOutEntries(this._elements, this._currentLength);
			for (const first of oldElements) {
				let p = first;
				while (p) {
					const oldNext = p.next;
					p.next = null;
					this._add(p);
					p = oldNext;
				}
			}
		}
		this._add(new HashTableEntry(tokenTypeIndex, tokenModifierSet, languageId, metadata));
	}
	_add(element) {
		const hash = this._hashFunc(element.tokenTypeIndex, element.tokenModifierSet, element.languageId);
		element.next = this._elements[hash];
		this._elements[hash] = element;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/services/semanticTokensStyling.js
var ISemanticTokensStylingService = createDecorator("semanticTokensStylingService");
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/services/semanticTokensStylingService.js
var __decorate$45 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$40 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var SemanticTokensStylingService = class SemanticTokensStylingService extends Disposable {
	constructor(_themeService, _logService, _languageService) {
		super();
		this._themeService = _themeService;
		this._logService = _logService;
		this._languageService = _languageService;
		this._caches = /* @__PURE__ */ new WeakMap();
		this._register(this._themeService.onDidColorThemeChange(() => {
			this._caches = /* @__PURE__ */ new WeakMap();
		}));
	}
	getStyling(provider) {
		if (!this._caches.has(provider)) this._caches.set(provider, new SemanticTokensProviderStyling(provider.getLegend(), this._themeService, this._languageService, this._logService));
		return this._caches.get(provider);
	}
};
SemanticTokensStylingService = __decorate$45([
	__param$40(0, IThemeService),
	__param$40(1, ILogService),
	__param$40(2, ILanguageService)
], SemanticTokensStylingService);
registerSingleton(ISemanticTokensStylingService, SemanticTokensStylingService, 1);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/services/abstractCodeEditorService.js
var __decorate$44 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$39 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var AbstractCodeEditorService = class AbstractCodeEditorService extends Disposable {
	constructor(_themeService) {
		super();
		this._themeService = _themeService;
		this._onWillCreateCodeEditor = this._register(new Emitter$1());
		this._onCodeEditorAdd = this._register(new Emitter$1());
		this.onCodeEditorAdd = this._onCodeEditorAdd.event;
		this._onCodeEditorRemove = this._register(new Emitter$1());
		this.onCodeEditorRemove = this._onCodeEditorRemove.event;
		this._onWillCreateDiffEditor = this._register(new Emitter$1());
		this._onDiffEditorAdd = this._register(new Emitter$1());
		this.onDiffEditorAdd = this._onDiffEditorAdd.event;
		this._onDiffEditorRemove = this._register(new Emitter$1());
		this.onDiffEditorRemove = this._onDiffEditorRemove.event;
		this._decorationOptionProviders = /* @__PURE__ */ new Map();
		this._codeEditorOpenHandlers = new LinkedList();
		this._modelProperties = /* @__PURE__ */ new Map();
		this._codeEditors = Object.create(null);
		this._diffEditors = Object.create(null);
		this._globalStyleSheet = null;
	}
	willCreateCodeEditor() {
		this._onWillCreateCodeEditor.fire();
	}
	addCodeEditor(editor) {
		this._codeEditors[editor.getId()] = editor;
		this._onCodeEditorAdd.fire(editor);
	}
	removeCodeEditor(editor) {
		if (delete this._codeEditors[editor.getId()]) this._onCodeEditorRemove.fire(editor);
	}
	listCodeEditors() {
		return Object.keys(this._codeEditors).map((id) => this._codeEditors[id]);
	}
	willCreateDiffEditor() {
		this._onWillCreateDiffEditor.fire();
	}
	addDiffEditor(editor) {
		this._diffEditors[editor.getId()] = editor;
		this._onDiffEditorAdd.fire(editor);
	}
	removeDiffEditor(editor) {
		if (delete this._diffEditors[editor.getId()]) this._onDiffEditorRemove.fire(editor);
	}
	listDiffEditors() {
		return Object.keys(this._diffEditors).map((id) => this._diffEditors[id]);
	}
	getFocusedCodeEditor() {
		let editorWithWidgetFocus = null;
		const editors = this.listCodeEditors();
		for (const editor of editors) {
			if (editor.hasTextFocus()) return editor;
			if (editor.hasWidgetFocus()) editorWithWidgetFocus = editor;
		}
		return editorWithWidgetFocus;
	}
	removeDecorationType(key) {
		const provider = this._decorationOptionProviders.get(key);
		if (provider) {
			provider.refCount--;
			if (provider.refCount <= 0) {
				this._decorationOptionProviders.delete(key);
				provider.dispose();
				this.listCodeEditors().forEach((ed) => ed.removeDecorationsByType(key));
			}
		}
	}
	setModelProperty(resource, key, value) {
		const key1 = resource.toString();
		let dest;
		if (this._modelProperties.has(key1)) dest = this._modelProperties.get(key1);
		else {
			dest = /* @__PURE__ */ new Map();
			this._modelProperties.set(key1, dest);
		}
		dest.set(key, value);
	}
	getModelProperty(resource, key) {
		const key1 = resource.toString();
		if (this._modelProperties.has(key1)) return this._modelProperties.get(key1).get(key);
	}
	async openCodeEditor(input, source, sideBySide) {
		for (const handler of this._codeEditorOpenHandlers) {
			const candidate = await handler(input, source, sideBySide);
			if (candidate !== null) return candidate;
		}
		return null;
	}
	registerCodeEditorOpenHandler(handler) {
		const rm = this._codeEditorOpenHandlers.unshift(handler);
		return toDisposable(rm);
	}
};
AbstractCodeEditorService = __decorate$44([__param$39(0, IThemeService)], AbstractCodeEditorService);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/standalone/browser/standaloneCodeEditorService.js
var __decorate$43 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$38 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var StandaloneCodeEditorService = class StandaloneCodeEditorService extends AbstractCodeEditorService {
	constructor(contextKeyService, themeService) {
		super(themeService);
		this._register(this.onCodeEditorAdd(() => this._checkContextKey()));
		this._register(this.onCodeEditorRemove(() => this._checkContextKey()));
		this._editorIsOpen = contextKeyService.createKey("editorIsOpen", false);
		this._activeCodeEditor = null;
		this._register(this.registerCodeEditorOpenHandler(async (input, source, sideBySide) => {
			if (!source) return null;
			return this.doOpenEditor(source, input);
		}));
	}
	_checkContextKey() {
		let hasCodeEditor = false;
		for (const editor of this.listCodeEditors()) if (!editor.isSimpleWidget) {
			hasCodeEditor = true;
			break;
		}
		this._editorIsOpen.set(hasCodeEditor);
	}
	setActiveCodeEditor(activeCodeEditor) {
		this._activeCodeEditor = activeCodeEditor;
	}
	getActiveCodeEditor() {
		return this._activeCodeEditor;
	}
	doOpenEditor(editor, input) {
		if (!this.findModel(editor, input.resource)) {
			if (input.resource) {
				const schema = input.resource.scheme;
				if (schema === Schemas.http || schema === Schemas.https) {
					windowOpenNoOpener(input.resource.toString());
					return editor;
				}
			}
			return null;
		}
		const selection = input.options ? input.options.selection : null;
		if (selection) {
			if (typeof selection.endLineNumber === "number" && typeof selection.endColumn === "number") {
				editor.setSelection(selection);
				editor.revealRangeInCenter(selection, 1);
			} else {
				const pos = {
					lineNumber: selection.startLineNumber,
					column: selection.startColumn
				};
				editor.setPosition(pos);
				editor.revealPositionInCenter(pos, 1);
			}
		}
		return editor;
	}
	findModel(editor, resource) {
		const model = editor.getModel();
		if (model && model.uri.toString() !== resource.toString()) return null;
		return model;
	}
};
StandaloneCodeEditorService = __decorate$43([__param$38(0, IContextKeyService), __param$38(1, IThemeService)], StandaloneCodeEditorService);
registerSingleton(ICodeEditorService, StandaloneCodeEditorService, 0);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/standalone/browser/standaloneLayoutService.js
var __decorate$42 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$37 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var StandaloneLayoutService = class StandaloneLayoutService {
	get mainContainer() {
		return this._codeEditorService.listCodeEditors().at(0)?.getContainerDomNode() ?? mainWindow.document.body;
	}
	get activeContainer() {
		return (this._codeEditorService.getFocusedCodeEditor() ?? this._codeEditorService.getActiveCodeEditor())?.getContainerDomNode() ?? this.mainContainer;
	}
	get mainContainerDimension() {
		return getClientArea(this.mainContainer);
	}
	get activeContainerDimension() {
		return getClientArea(this.activeContainer);
	}
	get containers() {
		return coalesce(this._codeEditorService.listCodeEditors().map((codeEditor) => codeEditor.getContainerDomNode()));
	}
	getContainer() {
		return this.activeContainer;
	}
	whenContainerStylesLoaded() {}
	focus() {
		this._codeEditorService.getFocusedCodeEditor()?.focus();
	}
	constructor(_codeEditorService) {
		this._codeEditorService = _codeEditorService;
		this.onDidLayoutMainContainer = Event.None;
		this.onDidLayoutActiveContainer = Event.None;
		this.onDidLayoutContainer = Event.None;
		this.onDidChangeActiveContainer = Event.None;
		this.onDidAddContainer = Event.None;
		this.mainContainerOffset = {
			top: 0,
			quickPickTop: 0
		};
		this.activeContainerOffset = {
			top: 0,
			quickPickTop: 0
		};
	}
};
StandaloneLayoutService = __decorate$42([__param$37(0, ICodeEditorService)], StandaloneLayoutService);
var EditorScopedLayoutService = class EditorScopedLayoutService extends StandaloneLayoutService {
	get mainContainer() {
		return this._container;
	}
	constructor(_container, codeEditorService) {
		super(codeEditorService);
		this._container = _container;
	}
};
EditorScopedLayoutService = __decorate$42([__param$37(1, ICodeEditorService)], EditorScopedLayoutService);
registerSingleton(ILayoutService, StandaloneLayoutService, 1);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/accessibility/browser/accessibilityService.js
var __decorate$41 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$36 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var AccessibilityService = class AccessibilityService extends Disposable {
	constructor(_contextKeyService, _layoutService, _configurationService) {
		super();
		this._contextKeyService = _contextKeyService;
		this._layoutService = _layoutService;
		this._configurationService = _configurationService;
		this._accessibilitySupport = 0;
		this._onDidChangeScreenReaderOptimized = this._register(new Emitter$1());
		this._onDidChangeReducedMotion = this._register(new Emitter$1());
		this._onDidChangeReducedTransparency = this._register(new Emitter$1());
		this._onDidChangeLinkUnderline = this._register(new Emitter$1());
		this._accessibilityModeEnabledContext = CONTEXT_ACCESSIBILITY_MODE_ENABLED.bindTo(this._contextKeyService);
		const updateContextKey = () => this._accessibilityModeEnabledContext.set(this.isScreenReaderOptimized());
		this._register(this._configurationService.onDidChangeConfiguration((e) => {
			if (e.affectsConfiguration("editor.accessibilitySupport")) {
				updateContextKey();
				this._onDidChangeScreenReaderOptimized.fire();
			}
			if (e.affectsConfiguration("workbench.reduceMotion")) {
				this._configMotionReduced = this._configurationService.getValue("workbench.reduceMotion");
				this._onDidChangeReducedMotion.fire();
			}
			if (e.affectsConfiguration("workbench.reduceTransparency")) {
				this._configTransparencyReduced = this._configurationService.getValue("workbench.reduceTransparency");
				this._onDidChangeReducedTransparency.fire();
			}
		}));
		updateContextKey();
		this._register(this.onDidChangeScreenReaderOptimized(() => updateContextKey()));
		const reduceMotionMatcher = mainWindow.matchMedia(`(prefers-reduced-motion: reduce)`);
		this._systemMotionReduced = reduceMotionMatcher.matches;
		this._configMotionReduced = this._configurationService.getValue("workbench.reduceMotion");
		const reduceTransparencyMatcher = mainWindow.matchMedia(`(prefers-reduced-transparency: reduce)`);
		this._systemTransparencyReduced = reduceTransparencyMatcher.matches;
		this._configTransparencyReduced = this._configurationService.getValue("workbench.reduceTransparency");
		this._linkUnderlinesEnabled = this._configurationService.getValue("accessibility.underlineLinks");
		this.initReducedMotionListeners(reduceMotionMatcher);
		this.initReducedTransparencyListeners(reduceTransparencyMatcher);
		this.initLinkUnderlineListeners();
	}
	initReducedMotionListeners(reduceMotionMatcher) {
		this._register(addDisposableListener(reduceMotionMatcher, "change", () => {
			this._systemMotionReduced = reduceMotionMatcher.matches;
			if (this._configMotionReduced === "auto") this._onDidChangeReducedMotion.fire();
		}));
		const updateContainerClasses = (container) => {
			const reduce = this.isMotionReduced();
			container.classList.toggle("monaco-reduce-motion", reduce);
			container.classList.toggle("monaco-enable-motion", !reduce);
		};
		const updateRootClasses = () => {
			for (const container of this._layoutService.containers) updateContainerClasses(container);
		};
		updateRootClasses();
		this._register(this.onDidChangeReducedMotion(() => updateRootClasses()));
		this._register(this._layoutService.onDidAddContainer(({ container }) => updateContainerClasses(container)));
	}
	initReducedTransparencyListeners(reduceTransparencyMatcher) {
		this._register(addDisposableListener(reduceTransparencyMatcher, "change", () => {
			this._systemTransparencyReduced = reduceTransparencyMatcher.matches;
			if (this._configTransparencyReduced === "auto") this._onDidChangeReducedTransparency.fire();
		}));
		const updateRootClasses = () => {
			const reduce = this.isTransparencyReduced();
			this._layoutService.mainContainer.classList.toggle("monaco-reduce-transparency", reduce);
		};
		updateRootClasses();
		this._register(this.onDidChangeReducedTransparency(() => updateRootClasses()));
	}
	initLinkUnderlineListeners() {
		this._register(this._configurationService.onDidChangeConfiguration((e) => {
			if (e.affectsConfiguration("accessibility.underlineLinks")) {
				const linkUnderlinesEnabled = this._configurationService.getValue("accessibility.underlineLinks");
				this._linkUnderlinesEnabled = linkUnderlinesEnabled;
				this._onDidChangeLinkUnderline.fire();
			}
		}));
		const updateLinkUnderlineClasses = () => {
			const underlineLinks = this._linkUnderlinesEnabled;
			this._layoutService.mainContainer.classList.toggle("underline-links", underlineLinks);
		};
		updateLinkUnderlineClasses();
		this._register(this.onDidChangeLinkUnderlines(() => updateLinkUnderlineClasses()));
	}
	onDidChangeLinkUnderlines(listener) {
		return this._onDidChangeLinkUnderline.event(listener);
	}
	get onDidChangeScreenReaderOptimized() {
		return this._onDidChangeScreenReaderOptimized.event;
	}
	isScreenReaderOptimized() {
		const config = this.getAccessibilitySupportConfigurationValue();
		return config === "on" || config === "auto" && this._accessibilitySupport === 2;
	}
	getAccessibilitySupportConfigurationValue() {
		const inspectedValue = this._configurationService.inspect("editor.accessibilitySupport");
		return inspectedValue.policyValue ?? inspectedValue.memoryValue ?? inspectedValue.workspaceFolderValue ?? inspectedValue.workspaceValue ?? inspectedValue.userValue ?? inspectedValue.applicationValue ?? inspectedValue.defaultValue ?? "auto";
	}
	get onDidChangeReducedMotion() {
		return this._onDidChangeReducedMotion.event;
	}
	isMotionReduced() {
		const config = this._configMotionReduced;
		return config === "on" || config === "auto" && this._systemMotionReduced;
	}
	get onDidChangeReducedTransparency() {
		return this._onDidChangeReducedTransparency.event;
	}
	isTransparencyReduced() {
		const config = this._configTransparencyReduced;
		return config === "on" || config === "auto" && this._systemTransparencyReduced;
	}
	getAccessibilitySupport() {
		return this._accessibilitySupport;
	}
};
AccessibilityService = __decorate$41([
	__param$36(0, IContextKeyService),
	__param$36(1, ILayoutService),
	__param$36(2, IConfigurationService)
], AccessibilityService);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/accessibilitySignal/browser/accessibilitySignalService.js
var IAccessibilitySignalService = createDecorator("accessibilitySignalService");
/**
* Corresponds to the audio files in ./media.
*/
var Sound = class Sound {
	static register(options) {
		return new Sound(options.fileName);
	}
	static {
		this.error = Sound.register({ fileName: "error.mp3" });
	}
	static {
		this.warning = Sound.register({ fileName: "warning.mp3" });
	}
	static {
		this.success = Sound.register({ fileName: "success.mp3" });
	}
	static {
		this.foldedArea = Sound.register({ fileName: "foldedAreas.mp3" });
	}
	static {
		this.break = Sound.register({ fileName: "break.mp3" });
	}
	static {
		this.quickFixes = Sound.register({ fileName: "quickFixes.mp3" });
	}
	static {
		this.taskCompleted = Sound.register({ fileName: "taskCompleted.mp3" });
	}
	static {
		this.taskFailed = Sound.register({ fileName: "taskFailed.mp3" });
	}
	static {
		this.terminalBell = Sound.register({ fileName: "terminalBell.mp3" });
	}
	static {
		this.diffLineInserted = Sound.register({ fileName: "diffLineInserted.mp3" });
	}
	static {
		this.diffLineDeleted = Sound.register({ fileName: "diffLineDeleted.mp3" });
	}
	static {
		this.diffLineModified = Sound.register({ fileName: "diffLineModified.mp3" });
	}
	static {
		this.requestSent = Sound.register({ fileName: "requestSent.mp3" });
	}
	static {
		this.responseReceived1 = Sound.register({ fileName: "responseReceived1.mp3" });
	}
	static {
		this.responseReceived2 = Sound.register({ fileName: "responseReceived2.mp3" });
	}
	static {
		this.responseReceived3 = Sound.register({ fileName: "responseReceived3.mp3" });
	}
	static {
		this.responseReceived4 = Sound.register({ fileName: "responseReceived4.mp3" });
	}
	static {
		this.clear = Sound.register({ fileName: "clear.mp3" });
	}
	static {
		this.save = Sound.register({ fileName: "save.mp3" });
	}
	static {
		this.format = Sound.register({ fileName: "format.mp3" });
	}
	static {
		this.voiceRecordingStarted = Sound.register({ fileName: "voiceRecordingStarted.mp3" });
	}
	static {
		this.voiceRecordingStopped = Sound.register({ fileName: "voiceRecordingStopped.mp3" });
	}
	static {
		this.progress = Sound.register({ fileName: "progress.mp3" });
	}
	static {
		this.chatEditModifiedFile = Sound.register({ fileName: "chatEditModifiedFile.mp3" });
	}
	static {
		this.editsKept = Sound.register({ fileName: "editsKept.mp3" });
	}
	static {
		this.editsUndone = Sound.register({ fileName: "editsUndone.mp3" });
	}
	static {
		this.nextEditSuggestion = Sound.register({ fileName: "nextEditSuggestion.mp3" });
	}
	static {
		this.terminalCommandSucceeded = Sound.register({ fileName: "terminalCommandSucceeded.mp3" });
	}
	static {
		this.chatUserActionRequired = Sound.register({ fileName: "chatUserActionRequired.mp3" });
	}
	static {
		this.codeActionTriggered = Sound.register({ fileName: "codeActionTriggered.mp3" });
	}
	static {
		this.codeActionApplied = Sound.register({ fileName: "codeActionApplied.mp3" });
	}
	constructor(fileName) {
		this.fileName = fileName;
	}
};
var SoundSource = class {
	constructor(randomOneOf) {
		this.randomOneOf = randomOneOf;
	}
};
var AccessibilitySignal = class AccessibilitySignal {
	constructor(sound, name, legacySoundSettingsKey, settingsKey, legacyAnnouncementSettingsKey, announcementMessage, managesOwnEnablement = false) {
		this.sound = sound;
		this.name = name;
		this.legacySoundSettingsKey = legacySoundSettingsKey;
		this.settingsKey = settingsKey;
		this.legacyAnnouncementSettingsKey = legacyAnnouncementSettingsKey;
		this.announcementMessage = announcementMessage;
		this.managesOwnEnablement = managesOwnEnablement;
	}
	static {
		this._signals = /* @__PURE__ */ new Set();
	}
	static register(options) {
		const soundSource = new SoundSource("randomOneOf" in options.sound ? options.sound.randomOneOf : [options.sound]);
		const signal = new AccessibilitySignal(soundSource, options.name, options.legacySoundSettingsKey, options.settingsKey, options.legacyAnnouncementSettingsKey, options.announcementMessage, options.managesOwnEnablement);
		AccessibilitySignal._signals.add(signal);
		return signal;
	}
	static {
		this.errorAtPosition = AccessibilitySignal.register({
			name: localize(1652, "Error at Position"),
			sound: Sound.error,
			announcementMessage: localize(1653, "Error"),
			settingsKey: "accessibility.signals.positionHasError",
			delaySettingsKey: "accessibility.signalOptions.delays.errorAtPosition"
		});
	}
	static {
		this.warningAtPosition = AccessibilitySignal.register({
			name: localize(1654, "Warning at Position"),
			sound: Sound.warning,
			announcementMessage: localize(1655, "Warning"),
			settingsKey: "accessibility.signals.positionHasWarning",
			delaySettingsKey: "accessibility.signalOptions.delays.warningAtPosition"
		});
	}
	static {
		this.errorOnLine = AccessibilitySignal.register({
			name: localize(1656, "Error on Line"),
			sound: Sound.error,
			legacySoundSettingsKey: "audioCues.lineHasError",
			legacyAnnouncementSettingsKey: "accessibility.alert.error",
			announcementMessage: localize(1657, "Error on Line"),
			settingsKey: "accessibility.signals.lineHasError"
		});
	}
	static {
		this.warningOnLine = AccessibilitySignal.register({
			name: localize(1658, "Warning on Line"),
			sound: Sound.warning,
			legacySoundSettingsKey: "audioCues.lineHasWarning",
			legacyAnnouncementSettingsKey: "accessibility.alert.warning",
			announcementMessage: localize(1659, "Warning on Line"),
			settingsKey: "accessibility.signals.lineHasWarning"
		});
	}
	static {
		this.foldedArea = AccessibilitySignal.register({
			name: localize(1660, "Folded Area on Line"),
			sound: Sound.foldedArea,
			legacySoundSettingsKey: "audioCues.lineHasFoldedArea",
			legacyAnnouncementSettingsKey: "accessibility.alert.foldedArea",
			announcementMessage: localize(1661, "Folded"),
			settingsKey: "accessibility.signals.lineHasFoldedArea"
		});
	}
	static {
		this.break = AccessibilitySignal.register({
			name: localize(1662, "Breakpoint on Line"),
			sound: Sound.break,
			legacySoundSettingsKey: "audioCues.lineHasBreakpoint",
			legacyAnnouncementSettingsKey: "accessibility.alert.breakpoint",
			announcementMessage: localize(1663, "Breakpoint"),
			settingsKey: "accessibility.signals.lineHasBreakpoint"
		});
	}
	static {
		this.inlineSuggestion = AccessibilitySignal.register({
			name: localize(1664, "Inline Suggestion on Line"),
			sound: Sound.quickFixes,
			legacySoundSettingsKey: "audioCues.lineHasInlineSuggestion",
			settingsKey: "accessibility.signals.lineHasInlineSuggestion"
		});
	}
	static {
		this.nextEditSuggestion = AccessibilitySignal.register({
			name: localize(1665, "Next Edit Suggestion on Line"),
			sound: Sound.nextEditSuggestion,
			legacySoundSettingsKey: "audioCues.nextEditSuggestion",
			settingsKey: "accessibility.signals.nextEditSuggestion",
			announcementMessage: localize(1666, "Next Edit Suggestion")
		});
	}
	static {
		this.terminalQuickFix = AccessibilitySignal.register({
			name: localize(1667, "Terminal Quick Fix"),
			sound: Sound.quickFixes,
			legacySoundSettingsKey: "audioCues.terminalQuickFix",
			legacyAnnouncementSettingsKey: "accessibility.alert.terminalQuickFix",
			announcementMessage: localize(1668, "Quick Fix"),
			settingsKey: "accessibility.signals.terminalQuickFix"
		});
	}
	static {
		this.onDebugBreak = AccessibilitySignal.register({
			name: localize(1669, "Debugger Stopped on Breakpoint"),
			sound: Sound.break,
			legacySoundSettingsKey: "audioCues.onDebugBreak",
			legacyAnnouncementSettingsKey: "accessibility.alert.onDebugBreak",
			announcementMessage: localize(1670, "Breakpoint"),
			settingsKey: "accessibility.signals.onDebugBreak"
		});
	}
	static {
		this.noInlayHints = AccessibilitySignal.register({
			name: localize(1671, "No Inlay Hints on Line"),
			sound: Sound.error,
			legacySoundSettingsKey: "audioCues.noInlayHints",
			legacyAnnouncementSettingsKey: "accessibility.alert.noInlayHints",
			announcementMessage: localize(1672, "No Inlay Hints"),
			settingsKey: "accessibility.signals.noInlayHints"
		});
	}
	static {
		this.taskCompleted = AccessibilitySignal.register({
			name: localize(1673, "Task Completed"),
			sound: Sound.taskCompleted,
			legacySoundSettingsKey: "audioCues.taskCompleted",
			legacyAnnouncementSettingsKey: "accessibility.alert.taskCompleted",
			announcementMessage: localize(1674, "Task Completed"),
			settingsKey: "accessibility.signals.taskCompleted"
		});
	}
	static {
		this.taskFailed = AccessibilitySignal.register({
			name: localize(1675, "Task Failed"),
			sound: Sound.taskFailed,
			legacySoundSettingsKey: "audioCues.taskFailed",
			legacyAnnouncementSettingsKey: "accessibility.alert.taskFailed",
			announcementMessage: localize(1676, "Task Failed"),
			settingsKey: "accessibility.signals.taskFailed"
		});
	}
	static {
		this.terminalCommandFailed = AccessibilitySignal.register({
			name: localize(1677, "Terminal Command Failed"),
			sound: Sound.error,
			legacySoundSettingsKey: "audioCues.terminalCommandFailed",
			legacyAnnouncementSettingsKey: "accessibility.alert.terminalCommandFailed",
			announcementMessage: localize(1678, "Command Failed"),
			settingsKey: "accessibility.signals.terminalCommandFailed"
		});
	}
	static {
		this.terminalCommandSucceeded = AccessibilitySignal.register({
			name: localize(1679, "Terminal Command Succeeded"),
			sound: Sound.terminalCommandSucceeded,
			announcementMessage: localize(1680, "Command Succeeded"),
			settingsKey: "accessibility.signals.terminalCommandSucceeded"
		});
	}
	static {
		this.terminalBell = AccessibilitySignal.register({
			name: localize(1681, "Terminal Bell"),
			sound: Sound.terminalBell,
			legacySoundSettingsKey: "audioCues.terminalBell",
			legacyAnnouncementSettingsKey: "accessibility.alert.terminalBell",
			announcementMessage: localize(1682, "Terminal Bell"),
			settingsKey: "accessibility.signals.terminalBell"
		});
	}
	static {
		this.notebookCellCompleted = AccessibilitySignal.register({
			name: localize(1683, "Notebook Cell Completed"),
			sound: Sound.taskCompleted,
			legacySoundSettingsKey: "audioCues.notebookCellCompleted",
			legacyAnnouncementSettingsKey: "accessibility.alert.notebookCellCompleted",
			announcementMessage: localize(1684, "Notebook Cell Completed"),
			settingsKey: "accessibility.signals.notebookCellCompleted"
		});
	}
	static {
		this.notebookCellFailed = AccessibilitySignal.register({
			name: localize(1685, "Notebook Cell Failed"),
			sound: Sound.taskFailed,
			legacySoundSettingsKey: "audioCues.notebookCellFailed",
			legacyAnnouncementSettingsKey: "accessibility.alert.notebookCellFailed",
			announcementMessage: localize(1686, "Notebook Cell Failed"),
			settingsKey: "accessibility.signals.notebookCellFailed"
		});
	}
	static {
		this.diffLineInserted = AccessibilitySignal.register({
			name: localize(1687, "Diff Line Inserted"),
			sound: Sound.diffLineInserted,
			legacySoundSettingsKey: "audioCues.diffLineInserted",
			settingsKey: "accessibility.signals.diffLineInserted"
		});
	}
	static {
		this.diffLineDeleted = AccessibilitySignal.register({
			name: localize(1688, "Diff Line Deleted"),
			sound: Sound.diffLineDeleted,
			legacySoundSettingsKey: "audioCues.diffLineDeleted",
			settingsKey: "accessibility.signals.diffLineDeleted"
		});
	}
	static {
		this.diffLineModified = AccessibilitySignal.register({
			name: localize(1689, "Diff Line Modified"),
			sound: Sound.diffLineModified,
			legacySoundSettingsKey: "audioCues.diffLineModified",
			settingsKey: "accessibility.signals.diffLineModified"
		});
	}
	static {
		this.chatEditModifiedFile = AccessibilitySignal.register({
			name: localize(1690, "Chat Edit Modified File"),
			sound: Sound.chatEditModifiedFile,
			announcementMessage: localize(1691, "File Modified from Chat Edits"),
			settingsKey: "accessibility.signals.chatEditModifiedFile"
		});
	}
	static {
		this.chatRequestSent = AccessibilitySignal.register({
			name: localize(1692, "Chat Request Sent"),
			sound: Sound.requestSent,
			legacySoundSettingsKey: "audioCues.chatRequestSent",
			legacyAnnouncementSettingsKey: "accessibility.alert.chatRequestSent",
			announcementMessage: localize(1693, "Chat Request Sent"),
			settingsKey: "accessibility.signals.chatRequestSent"
		});
	}
	static {
		this.chatResponseReceived = AccessibilitySignal.register({
			name: localize(1694, "Chat Response Received"),
			legacySoundSettingsKey: "audioCues.chatResponseReceived",
			sound: { randomOneOf: [
				Sound.responseReceived1,
				Sound.responseReceived2,
				Sound.responseReceived3,
				Sound.responseReceived4
			] },
			settingsKey: "accessibility.signals.chatResponseReceived"
		});
	}
	static {
		this.codeActionTriggered = AccessibilitySignal.register({
			name: localize(1695, "Code Action Request Triggered"),
			sound: Sound.codeActionTriggered,
			legacySoundSettingsKey: "audioCues.codeActionRequestTriggered",
			legacyAnnouncementSettingsKey: "accessibility.alert.codeActionRequestTriggered",
			announcementMessage: localize(1696, "Code Action Request Triggered"),
			settingsKey: "accessibility.signals.codeActionTriggered"
		});
	}
	static {
		this.codeActionApplied = AccessibilitySignal.register({
			name: localize(1697, "Code Action Applied"),
			legacySoundSettingsKey: "audioCues.codeActionApplied",
			sound: Sound.codeActionApplied,
			settingsKey: "accessibility.signals.codeActionApplied"
		});
	}
	static {
		this.progress = AccessibilitySignal.register({
			name: localize(1698, "Progress"),
			sound: Sound.progress,
			legacySoundSettingsKey: "audioCues.chatResponsePending",
			legacyAnnouncementSettingsKey: "accessibility.alert.progress",
			announcementMessage: localize(1699, "Progress"),
			settingsKey: "accessibility.signals.progress"
		});
	}
	static {
		this.clear = AccessibilitySignal.register({
			name: localize(1700, "Clear"),
			sound: Sound.clear,
			legacySoundSettingsKey: "audioCues.clear",
			legacyAnnouncementSettingsKey: "accessibility.alert.clear",
			announcementMessage: localize(1701, "Clear"),
			settingsKey: "accessibility.signals.clear"
		});
	}
	static {
		this.save = AccessibilitySignal.register({
			name: localize(1702, "Save"),
			sound: Sound.save,
			legacySoundSettingsKey: "audioCues.save",
			legacyAnnouncementSettingsKey: "accessibility.alert.save",
			announcementMessage: localize(1703, "Save"),
			settingsKey: "accessibility.signals.save"
		});
	}
	static {
		this.format = AccessibilitySignal.register({
			name: localize(1704, "Format"),
			sound: Sound.format,
			legacySoundSettingsKey: "audioCues.format",
			legacyAnnouncementSettingsKey: "accessibility.alert.format",
			announcementMessage: localize(1705, "Format"),
			settingsKey: "accessibility.signals.format"
		});
	}
	static {
		this.voiceRecordingStarted = AccessibilitySignal.register({
			name: localize(1706, "Voice Recording Started"),
			sound: Sound.voiceRecordingStarted,
			legacySoundSettingsKey: "audioCues.voiceRecordingStarted",
			settingsKey: "accessibility.signals.voiceRecordingStarted"
		});
	}
	static {
		this.voiceModeStarted = AccessibilitySignal.register({
			name: localize(1707, "Voice Mode Started"),
			sound: Sound.voiceRecordingStarted,
			announcementMessage: localize(1708, "Voice Mode Started"),
			settingsKey: "accessibility.signals.voiceModeStarted"
		});
	}
	static {
		this.voiceRecordingStopped = AccessibilitySignal.register({
			name: localize(1709, "Voice Recording Stopped"),
			sound: Sound.voiceRecordingStopped,
			legacySoundSettingsKey: "audioCues.voiceRecordingStopped",
			settingsKey: "accessibility.signals.voiceRecordingStopped"
		});
	}
	static {
		this.voiceModeStopped = AccessibilitySignal.register({
			name: localize(1710, "Voice Mode Stopped"),
			sound: Sound.voiceRecordingStopped,
			announcementMessage: localize(1711, "Voice Mode Stopped"),
			settingsKey: "accessibility.signals.voiceModeStopped"
		});
	}
	static {
		this.editsKept = AccessibilitySignal.register({
			name: localize(1712, "Edits Kept"),
			sound: Sound.editsKept,
			announcementMessage: localize(1713, "Edits Kept"),
			settingsKey: "accessibility.signals.editsKept"
		});
	}
	static {
		this.editsUndone = AccessibilitySignal.register({
			name: localize(1714, "Undo Edits"),
			sound: Sound.editsUndone,
			announcementMessage: localize(1715, "Edits Undone"),
			settingsKey: "accessibility.signals.editsUndone"
		});
	}
	static {
		this.chatUserActionRequired = AccessibilitySignal.register({
			name: localize(1716, "Chat User Action Required"),
			sound: Sound.chatUserActionRequired,
			announcementMessage: localize(1717, "Chat User Action Required"),
			settingsKey: "accessibility.signals.chatUserActionRequired"
		});
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/actions/common/menuService.js
var __decorate$40 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$35 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var PersistedMenuHideState_1;
var MenuInfo_1;
var MenuService = class MenuService extends Disposable {
	constructor(_commandService, _keybindingService, storageService) {
		super();
		this._commandService = _commandService;
		this._keybindingService = _keybindingService;
		this._hiddenStates = this._register(new PersistedMenuHideState(storageService));
	}
	createMenu(id, contextKeyService, options) {
		return new MenuImpl(id, this._hiddenStates, {
			emitEventsForSubmenuChanges: false,
			eventDebounceDelay: 50,
			...options
		}, this._commandService, this._keybindingService, contextKeyService);
	}
	getMenuActions(id, contextKeyService, options) {
		return createMenuActionGroups(id, options, this._hiddenStates, this._commandService, this._keybindingService, contextKeyService);
	}
	resetHiddenStates(ids) {
		this._hiddenStates.reset(ids);
	}
};
MenuService = __decorate$40([
	__param$35(0, ICommandService),
	__param$35(1, IKeybindingService),
	__param$35(2, IStorageService)
], MenuService);
var PersistedMenuHideState = class PersistedMenuHideState {
	static {
		PersistedMenuHideState_1 = this;
	}
	static {
		this._key = "menu.hiddenCommands";
	}
	constructor(_storageService) {
		this._storageService = _storageService;
		this._disposables = new DisposableStore();
		this._onDidChange = new Emitter$1();
		this.onDidChange = this._onDidChange.event;
		this._ignoreChangeEvent = false;
		this._hiddenByDefaultCache = /* @__PURE__ */ new Map();
		try {
			const raw = _storageService.get(PersistedMenuHideState_1._key, 0, "{}");
			this._data = JSON.parse(raw);
		} catch (err) {
			this._data = Object.create(null);
		}
		this._disposables.add(_storageService.onDidChangeValue(0, PersistedMenuHideState_1._key, this._disposables)(() => {
			if (!this._ignoreChangeEvent) try {
				const raw = _storageService.get(PersistedMenuHideState_1._key, 0, "{}");
				this._data = JSON.parse(raw);
			} catch (err) {
				console.log("FAILED to read storage after UPDATE", err);
			}
			this._onDidChange.fire();
		}));
	}
	dispose() {
		this._onDidChange.dispose();
		this._disposables.dispose();
	}
	_isHiddenByDefault(menu, commandId) {
		return this._hiddenByDefaultCache.get(`${menu.id}/${commandId}`) ?? false;
	}
	setDefaultState(menu, commandId, hidden) {
		this._hiddenByDefaultCache.set(`${menu.id}/${commandId}`, hidden);
	}
	isHidden(menu, commandId) {
		const hiddenByDefault = this._isHiddenByDefault(menu, commandId);
		const state = this._data[menu.id]?.includes(commandId) ?? false;
		return hiddenByDefault ? !state : state;
	}
	updateHidden(menu, commandId, hidden) {
		if (this._isHiddenByDefault(menu, commandId)) hidden = !hidden;
		const entries = this._data[menu.id];
		if (!hidden) {
			if (entries) {
				const idx = entries.indexOf(commandId);
				if (idx >= 0) removeFastWithoutKeepingOrder(entries, idx);
				if (entries.length === 0) delete this._data[menu.id];
			}
		} else if (!entries) this._data[menu.id] = [commandId];
		else if (entries.indexOf(commandId) < 0) entries.push(commandId);
		this._persist();
	}
	reset(menus) {
		if (menus === void 0) {
			this._data = Object.create(null);
			this._persist();
		} else {
			for (const { id } of menus) if (this._data[id]) delete this._data[id];
			this._persist();
		}
	}
	_persist() {
		try {
			this._ignoreChangeEvent = true;
			const raw = JSON.stringify(this._data);
			this._storageService.store(PersistedMenuHideState_1._key, raw, 0, 0);
		} finally {
			this._ignoreChangeEvent = false;
		}
	}
};
PersistedMenuHideState = PersistedMenuHideState_1 = __decorate$40([__param$35(0, IStorageService)], PersistedMenuHideState);
function groupMenuItems(menuItems) {
	return Array.from(groupAdjacentBy(menuItems, (a, b) => (a.group || "") === (b.group || "")), (items) => [items[0].group || "", items]);
}
function createMenuActionGroups(id, options, hiddenStates, commandService, keybindingService, contextKeyService) {
	const menuItems = MenuRegistry.getMenuItems(id).filter((item) => contextKeyService.contextMatchesRules(item.when));
	menuItems.sort(MenuInfo.compareMenuItems);
	return createActionGroups(id, groupMenuItems(menuItems), options, hiddenStates, commandService, keybindingService, contextKeyService);
}
function createActionGroups(menuId, menuGroups, options, hiddenStates, commandService, keybindingService, contextKeyService) {
	const result = [];
	for (const [id, items] of menuGroups) {
		const activeActions = [];
		for (const item of items) {
			const isMenuItem = isIMenuItem(item);
			if (isMenuItem) hiddenStates.setDefaultState(menuId, item.command.id, !!item.isHiddenByDefault);
			const menuHide = createMenuHide(menuId, isMenuItem ? item.command : item, hiddenStates);
			if (isMenuItem) {
				const menuKeybinding = createConfigureKeybindingAction(commandService, keybindingService, item.command.id, item.when);
				activeActions.push(new MenuItemAction(item.command, item.alt, options, menuHide, menuKeybinding, contextKeyService, commandService));
			} else {
				const groups = createMenuActionGroups(item.submenu, options, hiddenStates, commandService, keybindingService, contextKeyService);
				const submenuActions = Separator.join(...groups.map((g) => g[1]));
				if (submenuActions.length > 0) activeActions.push(new SubmenuItemAction(item, menuHide, submenuActions));
			}
		}
		if (activeActions.length > 0) result.push([id, activeActions]);
	}
	return result;
}
var MenuInfoSnapshot = class MenuInfoSnapshot {
	constructor(_id, _collectContextKeysForSubmenus) {
		this._id = _id;
		this._collectContextKeysForSubmenus = _collectContextKeysForSubmenus;
		this._menuGroups = [];
		this._allMenuIds = /* @__PURE__ */ new Set();
		this._structureContextKeys = /* @__PURE__ */ new Set();
		this._preconditionContextKeys = /* @__PURE__ */ new Set();
		this._toggledContextKeys = /* @__PURE__ */ new Set();
		this.refresh();
	}
	get allMenuIds() {
		return this._allMenuIds;
	}
	get structureContextKeys() {
		return this._structureContextKeys;
	}
	get preconditionContextKeys() {
		return this._preconditionContextKeys;
	}
	get toggledContextKeys() {
		return this._toggledContextKeys;
	}
	refresh() {
		this._allMenuIds.clear();
		this._structureContextKeys.clear();
		this._preconditionContextKeys.clear();
		this._toggledContextKeys.clear();
		const menuItems = this._sort(MenuRegistry.getMenuItems(this._id));
		this._menuGroups = groupMenuItems(menuItems);
		for (const item of menuItems) this._collectContextKeysAndSubmenuIds(item);
		this._allMenuIds.add(this._id);
	}
	_sort(menuItems) {
		return menuItems;
	}
	_collectContextKeysAndSubmenuIds(item) {
		MenuInfoSnapshot._fillInKbExprKeys(item.when, this._structureContextKeys);
		if (isIMenuItem(item)) {
			if (item.command.precondition) MenuInfoSnapshot._fillInKbExprKeys(item.command.precondition, this._preconditionContextKeys);
			if (item.command.toggled) {
				const toggledExpression = item.command.toggled.condition || item.command.toggled;
				MenuInfoSnapshot._fillInKbExprKeys(toggledExpression, this._toggledContextKeys);
			}
		} else if (this._collectContextKeysForSubmenus) {
			MenuRegistry.getMenuItems(item.submenu).forEach(this._collectContextKeysAndSubmenuIds, this);
			this._allMenuIds.add(item.submenu);
		}
	}
	static _fillInKbExprKeys(exp, set) {
		if (exp) for (const key of exp.keys()) set.add(key);
	}
};
var MenuInfo = MenuInfo_1 = class MenuInfo extends MenuInfoSnapshot {
	constructor(_id, _hiddenStates, _collectContextKeysForSubmenus, _commandService, _keybindingService, _contextKeyService) {
		super(_id, _collectContextKeysForSubmenus);
		this._hiddenStates = _hiddenStates;
		this._commandService = _commandService;
		this._keybindingService = _keybindingService;
		this._contextKeyService = _contextKeyService;
	}
	createActionGroups(options) {
		const groups = Iterable.map(this._menuGroups, ([id, items]) => [id, items.filter((item) => this._contextKeyService.contextMatchesRules(item.when))]);
		return createActionGroups(this._id, groups, options, this._hiddenStates, this._commandService, this._keybindingService, this._contextKeyService);
	}
	_sort(menuItems) {
		return menuItems.sort(MenuInfo_1.compareMenuItems);
	}
	static compareMenuItems(a, b) {
		const aGroup = a.group || "";
		const bGroup = b.group || "";
		if (aGroup !== bGroup) {
			if (!aGroup) return 1;
			else if (!bGroup) return -1;
			if (aGroup === "navigation") return -1;
			else if (bGroup === "navigation") return 1;
			const value = aGroup.localeCompare(bGroup);
			if (value !== 0) return value;
		}
		const aPrio = a.order || 0;
		const bPrio = b.order || 0;
		if (aPrio < bPrio) return -1;
		else if (aPrio > bPrio) return 1;
		return MenuInfo_1._compareTitles(isIMenuItem(a) ? a.command.title : a.title, isIMenuItem(b) ? b.command.title : b.title);
	}
	static _compareTitles(a, b) {
		const aStr = typeof a === "string" ? a : a.original;
		const bStr = typeof b === "string" ? b : b.original;
		return aStr.localeCompare(bStr);
	}
};
MenuInfo = MenuInfo_1 = __decorate$40([
	__param$35(3, ICommandService),
	__param$35(4, IKeybindingService),
	__param$35(5, IContextKeyService)
], MenuInfo);
var MenuImpl = class MenuImpl {
	constructor(id, hiddenStates, options, commandService, keybindingService, contextKeyService) {
		this._disposables = new DisposableStore();
		this._menuInfo = new MenuInfo(id, hiddenStates, options.emitEventsForSubmenuChanges, commandService, keybindingService, contextKeyService);
		const rebuildMenuSoon = new RunOnceScheduler(() => {
			this._menuInfo.refresh();
			this._onDidChange.fire({
				menu: this,
				isStructuralChange: true,
				isEnablementChange: true,
				isToggleChange: true
			});
		}, options.eventDebounceDelay);
		this._disposables.add(rebuildMenuSoon);
		this._disposables.add(MenuRegistry.onDidChangeMenu((e) => {
			for (const id of this._menuInfo.allMenuIds) if (e.has(id)) {
				rebuildMenuSoon.schedule();
				break;
			}
		}));
		const lazyListener = this._disposables.add(new DisposableStore());
		const merge = (events) => {
			let isStructuralChange = false;
			let isEnablementChange = false;
			let isToggleChange = false;
			for (const item of events) {
				isStructuralChange = isStructuralChange || item.isStructuralChange;
				isEnablementChange = isEnablementChange || item.isEnablementChange;
				isToggleChange = isToggleChange || item.isToggleChange;
				if (isStructuralChange && isEnablementChange && isToggleChange) break;
			}
			return {
				menu: this,
				isStructuralChange,
				isEnablementChange,
				isToggleChange
			};
		};
		const startLazyListener = () => {
			lazyListener.add(contextKeyService.onDidChangeContext((e) => {
				const isStructuralChange = e.affectsSome(this._menuInfo.structureContextKeys);
				const isEnablementChange = e.affectsSome(this._menuInfo.preconditionContextKeys);
				const isToggleChange = e.affectsSome(this._menuInfo.toggledContextKeys);
				if (isStructuralChange || isEnablementChange || isToggleChange) this._onDidChange.fire({
					menu: this,
					isStructuralChange,
					isEnablementChange,
					isToggleChange
				});
			}));
			lazyListener.add(hiddenStates.onDidChange((e) => {
				this._onDidChange.fire({
					menu: this,
					isStructuralChange: true,
					isEnablementChange: false,
					isToggleChange: false
				});
			}));
		};
		this._onDidChange = new DebounceEmitter({
			onWillAddFirstListener: startLazyListener,
			onDidRemoveLastListener: lazyListener.clear.bind(lazyListener),
			delay: options.eventDebounceDelay,
			merge
		});
		this.onDidChange = this._onDidChange.event;
	}
	getActions(options) {
		return this._menuInfo.createActionGroups(options);
	}
	dispose() {
		this._disposables.dispose();
		this._onDidChange.dispose();
	}
};
MenuImpl = __decorate$40([
	__param$35(3, ICommandService),
	__param$35(4, IKeybindingService),
	__param$35(5, IContextKeyService)
], MenuImpl);
function createMenuHide(menu, command, states) {
	const id = isISubmenuItem(command) ? command.submenu.id : command.id;
	const title = typeof command.title === "string" ? command.title : command.title.value;
	const hide = toAction({
		id: `hide/${menu.id}/${id}`,
		label: localize(1729, "Hide '{0}'", title),
		run() {
			states.updateHidden(menu, id, true);
		}
	});
	const toggle = toAction({
		id: `toggle/${menu.id}/${id}`,
		label: title,
		get checked() {
			return !states.isHidden(menu, id);
		},
		run() {
			states.updateHidden(menu, id, !!this.checked);
		}
	});
	return {
		hide,
		toggle,
		get isHidden() {
			return !toggle.checked;
		}
	};
}
function createConfigureKeybindingAction(commandService, keybindingService, commandId, when = void 0, enabled = true) {
	return toAction({
		id: `configureKeybinding/${commandId}`,
		label: localize(1730, "Configure Keybinding"),
		enabled,
		run() {
			const whenValue = !!!keybindingService.lookupKeybinding(commandId) && when ? when.serialize() : void 0;
			commandService.executeCommand("workbench.action.openGlobalKeybindings", `@command:${commandId}` + (whenValue ? ` +when:${whenValue}` : ""));
		}
	});
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/clipboard/browser/clipboardService.js
var __decorate$39 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$34 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var BrowserClipboardService_1;
/**
* Custom mime type used for storing a list of uris in the clipboard.
*
* Requires support for custom web clipboards https://github.com/w3c/clipboard-apis/pull/175
*/
var vscodeResourcesMime = "application/vnd.code.resources";
var BrowserClipboardService = class BrowserClipboardService extends Disposable {
	static {
		BrowserClipboardService_1 = this;
	}
	constructor(layoutService, logService) {
		super();
		this.layoutService = layoutService;
		this.logService = logService;
		this.mapTextToType = /* @__PURE__ */ new Map();
		this.findText = "";
		this.resources = [];
		this.resourcesStateHash = void 0;
		if (isSafari || isWebkitWebView) this.installWebKitWriteTextWorkaround();
		this._register(Event.runAndSubscribe(onDidRegisterWindow, ({ window, disposables }) => {
			disposables.add(addDisposableListener(window.document, "copy", () => this.clearResourcesState()));
		}, {
			window: mainWindow,
			disposables: this._store
		}));
	}
	triggerPaste() {
		this.logService.trace("BrowserClipboardService#triggerPaste");
	}
	installWebKitWriteTextWorkaround() {
		const handler = () => {
			const clipboard = getActiveWindow().navigator.clipboard;
			if (!clipboard) return;
			const currentWritePromise = new DeferredPromise();
			if (this.webKitPendingClipboardWritePromise && !this.webKitPendingClipboardWritePromise.isSettled) this.webKitPendingClipboardWritePromise.cancel();
			this.webKitPendingClipboardWritePromise = currentWritePromise;
			clipboard.write([new ClipboardItem({ "text/plain": currentWritePromise.p })]).catch(async (err) => {
				if (!(err instanceof Error) || err.name !== "NotAllowedError" || !currentWritePromise.isRejected) this.logService.error(err);
			});
		};
		this._register(Event.runAndSubscribe(this.layoutService.onDidAddContainer, ({ container, disposables }) => {
			disposables.add(addDisposableListener(container, "click", handler));
			disposables.add(addDisposableListener(container, "keydown", handler));
		}, {
			container: this.layoutService.mainContainer,
			disposables: this._store
		}));
	}
	async writeText(text, type) {
		this.logService.trace("BrowserClipboardService#writeText called with type:", type, " text.length:", text.length);
		this.clearResourcesState();
		if (type) {
			this.mapTextToType.set(type, text);
			this.logService.trace("BrowserClipboardService#writeText");
			return;
		}
		if (this.webKitPendingClipboardWritePromise) return this.webKitPendingClipboardWritePromise.complete(text);
		try {
			this.logService.trace("before navigator.clipboard.writeText");
			return await getActiveWindow().navigator.clipboard.writeText(text);
		} catch (error) {
			console.error(error);
		}
		this.fallbackWriteText(text);
	}
	fallbackWriteText(text) {
		this.logService.trace("BrowserClipboardService#fallbackWriteText");
		const activeDocument = getActiveDocument();
		const activeElement = activeDocument.activeElement;
		const textArea = activeDocument.body.appendChild($$10("textarea", { "aria-hidden": true }));
		textArea.style.height = "1px";
		textArea.style.width = "1px";
		textArea.style.position = "absolute";
		textArea.value = text;
		textArea.focus();
		textArea.select();
		activeDocument.execCommand("copy");
		if (isHTMLElement(activeElement)) activeElement.focus();
		textArea.remove();
	}
	async readText(type) {
		this.logService.trace("BrowserClipboardService#readText called with type:", type);
		if (type) {
			const readText = this.mapTextToType.get(type) || "";
			this.logService.trace("BrowserClipboardService#readText text.length:", readText.length);
			return readText;
		}
		try {
			const readText = await getActiveWindow().navigator.clipboard.readText();
			this.logService.trace("BrowserClipboardService#readText text.length:", readText.length);
			return readText;
		} catch (error) {
			console.error(error);
		}
		return "";
	}
	async readFindText() {
		return this.findText;
	}
	async writeFindText(text) {
		this.findText = text;
	}
	static {
		this.MAX_RESOURCE_STATE_SOURCE_LENGTH = 1e3;
	}
	async readResources() {
		try {
			const items = await getActiveWindow().navigator.clipboard.read();
			for (const item of items) if (item.types.includes(`web ${vscodeResourcesMime}`)) {
				const blob = await item.getType(`web ${vscodeResourcesMime}`);
				return JSON.parse(await blob.text()).map((x) => URI.from(x));
			}
		} catch (error) {}
		const resourcesStateHash = await this.computeResourcesStateHash();
		if (this.resourcesStateHash !== resourcesStateHash) this.clearResourcesState();
		return this.resources;
	}
	async computeResourcesStateHash() {
		if (this.resources.length === 0) return;
		const clipboardText = await this.readText();
		return hash(clipboardText.substring(0, BrowserClipboardService_1.MAX_RESOURCE_STATE_SOURCE_LENGTH));
	}
	clearInternalState() {
		this.clearResourcesState();
	}
	clearResourcesState() {
		this.resources = [];
		this.resourcesStateHash = void 0;
	}
};
BrowserClipboardService = BrowserClipboardService_1 = __decorate$39([__param$34(0, ILayoutService), __param$34(1, ILogService)], BrowserClipboardService);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/clipboard/common/clipboardService.js
var IClipboardService = createDecorator("clipboardService");
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/configuration/common/configurationModels.js
function freeze(data) {
	return Object.isFrozen(data) ? data : deepFreeze(data);
}
var ConfigurationModel = class ConfigurationModel {
	static createEmptyModel(logService) {
		return new ConfigurationModel({}, [], [], void 0, logService);
	}
	constructor(_contents, _keys, _overrides, _raw, logService) {
		this._contents = _contents;
		this._keys = _keys;
		this._overrides = _overrides;
		this._raw = _raw;
		this.logService = logService;
		this.overrideConfigurations = /* @__PURE__ */ new Map();
	}
	get rawConfiguration() {
		if (!this._rawConfiguration) {
			if (this._raw) {
				const rawConfigurationModels = (Array.isArray(this._raw) ? this._raw : [this._raw]).map((raw) => {
					if (raw instanceof ConfigurationModel) return raw;
					const parser = new ConfigurationModelParser("", this.logService);
					parser.parseRaw(raw);
					return parser.configurationModel;
				});
				this._rawConfiguration = rawConfigurationModels.reduce((previous, current) => current === previous ? current : previous.merge(current), rawConfigurationModels[0]);
			} else this._rawConfiguration = this;
		}
		return this._rawConfiguration;
	}
	get contents() {
		return this._contents;
	}
	get overrides() {
		return this._overrides;
	}
	get keys() {
		return this._keys;
	}
	get raw() {
		if (!this._raw) return;
		if (Array.isArray(this._raw) && this._raw.every((raw) => raw instanceof ConfigurationModel)) return;
		return this._raw;
	}
	isEmpty() {
		return this._keys.length === 0 && Object.keys(this._contents).length === 0 && this._overrides.length === 0;
	}
	getValue(section) {
		return section ? getConfigurationValue(this.contents, section) : this.contents;
	}
	inspect(section, overrideIdentifier) {
		const that = this;
		return {
			get value() {
				return freeze(that.rawConfiguration.getValue(section));
			},
			get override() {
				return overrideIdentifier ? freeze(that.rawConfiguration.getOverrideValue(section, overrideIdentifier)) : void 0;
			},
			get merged() {
				return freeze(overrideIdentifier ? that.rawConfiguration.override(overrideIdentifier).getValue(section) : that.rawConfiguration.getValue(section));
			},
			get overrides() {
				const overrides = [];
				for (const { contents, identifiers, keys } of that.rawConfiguration.overrides) {
					const value = new ConfigurationModel(contents, keys, [], void 0, that.logService).getValue(section);
					if (value !== void 0) overrides.push({
						identifiers,
						value
					});
				}
				return overrides.length ? freeze(overrides) : void 0;
			}
		};
	}
	getOverrideValue(section, overrideIdentifier) {
		const overrideContents = this.getContentsForOverrideIdentifer(overrideIdentifier);
		return overrideContents ? section ? getConfigurationValue(overrideContents, section) : overrideContents : void 0;
	}
	override(identifier) {
		let overrideConfigurationModel = this.overrideConfigurations.get(identifier);
		if (!overrideConfigurationModel) {
			overrideConfigurationModel = this.createOverrideConfigurationModel(identifier);
			this.overrideConfigurations.set(identifier, overrideConfigurationModel);
		}
		return overrideConfigurationModel;
	}
	merge(...others) {
		const contents = deepClone(this.contents);
		const overrides = deepClone(this.overrides);
		const keys = [...this.keys];
		const raws = this._raw ? Array.isArray(this._raw) ? [...this._raw] : [this._raw] : [this];
		for (const other of others) {
			raws.push(...other._raw ? Array.isArray(other._raw) ? other._raw : [other._raw] : [other]);
			if (other.isEmpty()) continue;
			this.mergeContents(contents, other.contents);
			for (const otherOverride of other.overrides) {
				const [override] = overrides.filter((o) => equals$1(o.identifiers, otherOverride.identifiers));
				if (override) {
					this.mergeContents(override.contents, otherOverride.contents);
					override.keys.push(...otherOverride.keys);
					override.keys = distinct(override.keys);
				} else overrides.push(deepClone(otherOverride));
			}
			for (const key of other.keys) if (keys.indexOf(key) === -1) keys.push(key);
		}
		return new ConfigurationModel(contents, keys, overrides, !raws.length || raws.every((raw) => raw instanceof ConfigurationModel) ? void 0 : raws, this.logService);
	}
	createOverrideConfigurationModel(identifier) {
		const overrideContents = this.getContentsForOverrideIdentifer(identifier);
		if (!overrideContents || typeof overrideContents !== "object" || !Object.keys(overrideContents).length) return this;
		const contents = {};
		for (const key of distinct([...Object.keys(this.contents), ...Object.keys(overrideContents)])) {
			let contentsForKey = this.contents[key];
			const overrideContentsForKey = overrideContents[key];
			if (overrideContentsForKey) {
				if (typeof contentsForKey === "object" && typeof overrideContentsForKey === "object") {
					contentsForKey = deepClone(contentsForKey);
					this.mergeContents(contentsForKey, overrideContentsForKey);
				} else contentsForKey = overrideContentsForKey;
			}
			contents[key] = contentsForKey;
		}
		return new ConfigurationModel(contents, this.keys, this.overrides, void 0, this.logService);
	}
	mergeContents(source, target) {
		for (const key of Object.keys(target)) {
			if (key in source) {
				if (isObject(source[key]) && isObject(target[key])) {
					this.mergeContents(source[key], target[key]);
					continue;
				}
			}
			source[key] = deepClone(target[key]);
		}
	}
	getContentsForOverrideIdentifer(identifier) {
		let contentsForIdentifierOnly = null;
		let contents = null;
		const mergeContents = (contentsToMerge) => {
			if (contentsToMerge) {
				if (contents) this.mergeContents(contents, contentsToMerge);
				else contents = deepClone(contentsToMerge);
			}
		};
		for (const override of this.overrides) if (override.identifiers.length === 1 && override.identifiers[0] === identifier) contentsForIdentifierOnly = override.contents;
		else if (override.identifiers.includes(identifier)) mergeContents(override.contents);
		mergeContents(contentsForIdentifierOnly);
		return contents;
	}
	toJSON() {
		return {
			contents: this.contents,
			overrides: this.overrides,
			keys: this.keys
		};
	}
	setValue(key, value) {
		this.updateValue(key, value, false);
	}
	removeValue(key) {
		const index = this.keys.indexOf(key);
		if (index === -1) return;
		this.keys.splice(index, 1);
		removeFromValueTree(this.contents, key);
		if (OVERRIDE_PROPERTY_REGEX.test(key)) this.overrides.splice(this.overrides.findIndex((o) => equals$1(o.identifiers, overrideIdentifiersFromKey(key))), 1);
	}
	updateValue(key, value, add) {
		addToValueTree(this.contents, key, value, (e) => this.logService.error(e));
		add = add || this.keys.indexOf(key) === -1;
		if (add) this.keys.push(key);
		if (OVERRIDE_PROPERTY_REGEX.test(key)) {
			const overrideContents = this.contents[key];
			const identifiers = overrideIdentifiersFromKey(key);
			const override = {
				identifiers,
				keys: Object.keys(overrideContents),
				contents: toValuesTree(overrideContents, (message) => this.logService.error(message))
			};
			const index = this.overrides.findIndex((o) => equals$1(o.identifiers, identifiers));
			if (index !== -1) this.overrides[index] = override;
			else this.overrides.push(override);
		}
	}
};
var ConfigurationModelParser = class {
	constructor(_name, logService) {
		this._name = _name;
		this.logService = logService;
		this._raw = null;
		this._configurationModel = null;
		this._restrictedConfigurations = [];
	}
	get configurationModel() {
		return this._configurationModel || ConfigurationModel.createEmptyModel(this.logService);
	}
	parseRaw(raw, options) {
		this._raw = raw;
		const { contents, keys, overrides, restricted, hasExcludedProperties } = this.doParseRaw(raw, options);
		this._configurationModel = new ConfigurationModel(contents, keys, overrides, hasExcludedProperties ? [raw] : void 0, this.logService);
		this._restrictedConfigurations = restricted || [];
	}
	doParseRaw(raw, options) {
		const registry = Registry.as(Extensions$6.Configuration);
		const configurationProperties = registry.getConfigurationProperties();
		const excludedConfigurationProperties = registry.getExcludedConfigurationProperties();
		const filtered = this.filter(raw, configurationProperties, excludedConfigurationProperties, true, options);
		raw = filtered.raw;
		return {
			contents: toValuesTree(raw, (message) => this.logService.error(`Conflict in settings file ${this._name}: ${message}`)),
			keys: Object.keys(raw),
			overrides: this.toOverrides(raw, (message) => this.logService.error(`Conflict in settings file ${this._name}: ${message}`)),
			restricted: filtered.restricted,
			hasExcludedProperties: filtered.hasExcludedProperties
		};
	}
	filter(properties, configurationProperties, excludedConfigurationProperties, filterOverriddenProperties, options) {
		let hasExcludedProperties = false;
		if (!options?.scopes && !options?.skipRestricted && !options?.skipUnregistered && !options?.exclude?.length) return {
			raw: properties,
			restricted: [],
			hasExcludedProperties
		};
		const raw = {};
		const restricted = [];
		for (const key in properties) if (OVERRIDE_PROPERTY_REGEX.test(key) && filterOverriddenProperties) {
			const result = this.filter(properties[key], configurationProperties, excludedConfigurationProperties, false, options);
			raw[key] = result.raw;
			hasExcludedProperties = hasExcludedProperties || result.hasExcludedProperties;
			restricted.push(...result.restricted);
		} else {
			const result = this.filterProperty(key, properties[key], configurationProperties, excludedConfigurationProperties, options);
			restricted.push(...result.restricted);
			hasExcludedProperties = hasExcludedProperties || result.hasExcludedProperties;
			if (result.included) raw[key] = result.value;
			else hasExcludedProperties = true;
		}
		return {
			raw,
			restricted,
			hasExcludedProperties
		};
	}
	filterProperty(path, value, configurationProperties, excludedConfigurationProperties, options) {
		const propertySchema = configurationProperties[path];
		if (propertySchema) return {
			included: this.shouldInclude(path, propertySchema, excludedConfigurationProperties, options),
			value,
			restricted: propertySchema.restricted ? [path] : [],
			hasExcludedProperties: false
		};
		if (!isObject(value) || Array.isArray(value)) return {
			included: this.shouldInclude(path, propertySchema, excludedConfigurationProperties, options),
			value,
			restricted: [],
			hasExcludedProperties: false
		};
		if (excludedConfigurationProperties[path]) return {
			included: this.shouldInclude(path, propertySchema, excludedConfigurationProperties, options),
			value,
			restricted: [],
			hasExcludedProperties: false
		};
		if (options.exclude?.includes(path)) return {
			included: false,
			value,
			restricted: [],
			hasExcludedProperties: false
		};
		const keys = Object.keys(value);
		if (keys.length === 0) return {
			included: this.shouldInclude(path, propertySchema, excludedConfigurationProperties, options),
			value,
			restricted: [],
			hasExcludedProperties: false
		};
		const nested = {};
		const restricted = [];
		let included = false;
		let hasExcludedProperties = false;
		for (const key of keys) {
			const result = this.filterProperty(`${path}.${key}`, value[key], configurationProperties, excludedConfigurationProperties, options);
			if (result.restricted.length) restricted.push(...result.restricted);
			hasExcludedProperties = hasExcludedProperties || result.hasExcludedProperties;
			if (result.included) {
				nested[key] = result.value;
				included = true;
			} else hasExcludedProperties = true;
		}
		return {
			included,
			value: nested,
			restricted,
			hasExcludedProperties
		};
	}
	shouldInclude(key, propertySchema, excludedConfigurationProperties, options) {
		if (options.exclude?.includes(key)) return false;
		if (options.include?.includes(key)) return true;
		if (options.skipRestricted && propertySchema?.restricted) return false;
		if (options.skipUnregistered && !propertySchema) return false;
		const schema = propertySchema ?? excludedConfigurationProperties[key];
		const scope = schema ? typeof schema.scope !== "undefined" ? schema.scope : 4 : void 0;
		if (scope === void 0 || options.scopes === void 0) return true;
		return options.scopes.includes(scope);
	}
	toOverrides(raw, conflictReporter) {
		const overrides = [];
		for (const key of Object.keys(raw)) if (OVERRIDE_PROPERTY_REGEX.test(key)) {
			const overrideRaw = {};
			const rawKey = raw[key];
			for (const keyInOverrideRaw in rawKey) overrideRaw[keyInOverrideRaw] = rawKey[keyInOverrideRaw];
			overrides.push({
				identifiers: overrideIdentifiersFromKey(key),
				keys: Object.keys(overrideRaw),
				contents: toValuesTree(overrideRaw, conflictReporter)
			});
		}
		return overrides;
	}
};
var ConfigurationInspectValue = class {
	constructor(key, overrides, _value, overrideIdentifiers, defaultConfiguration, policyConfiguration, applicationConfiguration, userConfiguration, localUserConfiguration, remoteUserConfiguration, workspaceConfiguration, folderConfigurationModel, memoryConfigurationModel) {
		this.key = key;
		this.overrides = overrides;
		this._value = _value;
		this.overrideIdentifiers = overrideIdentifiers;
		this.defaultConfiguration = defaultConfiguration;
		this.policyConfiguration = policyConfiguration;
		this.applicationConfiguration = applicationConfiguration;
		this.userConfiguration = userConfiguration;
		this.localUserConfiguration = localUserConfiguration;
		this.remoteUserConfiguration = remoteUserConfiguration;
		this.workspaceConfiguration = workspaceConfiguration;
		this.folderConfigurationModel = folderConfigurationModel;
		this.memoryConfigurationModel = memoryConfigurationModel;
	}
	toInspectValue(inspectValue) {
		return inspectValue?.value !== void 0 || inspectValue?.override !== void 0 || inspectValue?.overrides !== void 0 ? inspectValue : void 0;
	}
	get defaultInspectValue() {
		if (!this._defaultInspectValue) this._defaultInspectValue = this.defaultConfiguration.inspect(this.key, this.overrides.overrideIdentifier);
		return this._defaultInspectValue;
	}
	get defaultValue() {
		return this.defaultInspectValue.merged;
	}
	get policyInspectValue() {
		if (this._policyInspectValue === void 0) this._policyInspectValue = this.policyConfiguration ? this.policyConfiguration.inspect(this.key) : null;
		return this._policyInspectValue;
	}
	get policyValue() {
		return this.policyInspectValue?.merged;
	}
	get applicationInspectValue() {
		if (this._applicationInspectValue === void 0) this._applicationInspectValue = this.applicationConfiguration ? this.applicationConfiguration.inspect(this.key) : null;
		return this._applicationInspectValue;
	}
	get applicationValue() {
		return this.applicationInspectValue?.merged;
	}
	get userInspectValue() {
		if (!this._userInspectValue) this._userInspectValue = this.userConfiguration.inspect(this.key, this.overrides.overrideIdentifier);
		return this._userInspectValue;
	}
	get userValue() {
		return this.userInspectValue.merged;
	}
	get user() {
		return this.toInspectValue(this.userInspectValue);
	}
	get workspaceInspectValue() {
		if (this._workspaceInspectValue === void 0) this._workspaceInspectValue = this.workspaceConfiguration ? this.workspaceConfiguration.inspect(this.key, this.overrides.overrideIdentifier) : null;
		return this._workspaceInspectValue;
	}
	get workspaceValue() {
		return this.workspaceInspectValue?.merged;
	}
	get workspaceFolderInspectValue() {
		if (this._workspaceFolderInspectValue === void 0) this._workspaceFolderInspectValue = this.folderConfigurationModel ? this.folderConfigurationModel.inspect(this.key, this.overrides.overrideIdentifier) : null;
		return this._workspaceFolderInspectValue;
	}
	get workspaceFolderValue() {
		return this.workspaceFolderInspectValue?.merged;
	}
	get memoryInspectValue() {
		if (this._memoryInspectValue === void 0) this._memoryInspectValue = this.memoryConfigurationModel.inspect(this.key, this.overrides.overrideIdentifier);
		return this._memoryInspectValue;
	}
	get memoryValue() {
		return this.memoryInspectValue.merged;
	}
};
var Configuration = class Configuration {
	constructor(_defaultConfiguration, _policyConfiguration, _applicationConfiguration, _localUserConfiguration, _remoteUserConfiguration, _workspaceConfiguration, _folderConfigurations, _memoryConfiguration, _memoryConfigurationByResource, logService) {
		this._defaultConfiguration = _defaultConfiguration;
		this._policyConfiguration = _policyConfiguration;
		this._applicationConfiguration = _applicationConfiguration;
		this._localUserConfiguration = _localUserConfiguration;
		this._remoteUserConfiguration = _remoteUserConfiguration;
		this._workspaceConfiguration = _workspaceConfiguration;
		this._folderConfigurations = _folderConfigurations;
		this._memoryConfiguration = _memoryConfiguration;
		this._memoryConfigurationByResource = _memoryConfigurationByResource;
		this.logService = logService;
		this._workspaceConsolidatedConfiguration = null;
		this._foldersConsolidatedConfigurations = new ResourceMap();
		this._userConfiguration = null;
	}
	getValue(section, overrides, workspace) {
		return this.getConsolidatedConfigurationModel(section, overrides, workspace).getValue(section);
	}
	updateValue(key, value, overrides = {}) {
		let memoryConfiguration;
		if (overrides.resource) {
			memoryConfiguration = this._memoryConfigurationByResource.get(overrides.resource);
			if (!memoryConfiguration) {
				memoryConfiguration = ConfigurationModel.createEmptyModel(this.logService);
				this._memoryConfigurationByResource.set(overrides.resource, memoryConfiguration);
			}
		} else memoryConfiguration = this._memoryConfiguration;
		if (value === void 0) memoryConfiguration.removeValue(key);
		else memoryConfiguration.setValue(key, value);
		if (!overrides.resource) this._workspaceConsolidatedConfiguration = null;
	}
	inspect(key, overrides, workspace) {
		const consolidateConfigurationModel = this.getConsolidatedConfigurationModel(key, overrides, workspace);
		const folderConfigurationModel = this.getFolderConfigurationModelForResource(overrides.resource, workspace);
		const memoryConfigurationModel = overrides.resource ? this._memoryConfigurationByResource.get(overrides.resource) || this._memoryConfiguration : this._memoryConfiguration;
		const overrideIdentifiers = /* @__PURE__ */ new Set();
		for (const override of consolidateConfigurationModel.overrides) for (const overrideIdentifier of override.identifiers) if (consolidateConfigurationModel.getOverrideValue(key, overrideIdentifier) !== void 0) overrideIdentifiers.add(overrideIdentifier);
		return new ConfigurationInspectValue(key, overrides, consolidateConfigurationModel.getValue(key), overrideIdentifiers.size ? [...overrideIdentifiers] : void 0, this._defaultConfiguration, this._policyConfiguration.isEmpty() ? void 0 : this._policyConfiguration, this.applicationConfiguration.isEmpty() ? void 0 : this.applicationConfiguration, this.userConfiguration, this.localUserConfiguration, this.remoteUserConfiguration, workspace ? this._workspaceConfiguration : void 0, folderConfigurationModel ? folderConfigurationModel : void 0, memoryConfigurationModel);
	}
	get applicationConfiguration() {
		return this._applicationConfiguration;
	}
	get userConfiguration() {
		if (!this._userConfiguration) {
			if (this._remoteUserConfiguration.isEmpty()) this._userConfiguration = this._localUserConfiguration;
			else {
				const merged = this._localUserConfiguration.merge(this._remoteUserConfiguration);
				this._userConfiguration = new ConfigurationModel(merged.contents, merged.keys, merged.overrides, void 0, this.logService);
			}
		}
		return this._userConfiguration;
	}
	get localUserConfiguration() {
		return this._localUserConfiguration;
	}
	get remoteUserConfiguration() {
		return this._remoteUserConfiguration;
	}
	getConsolidatedConfigurationModel(section, overrides, workspace) {
		let configurationModel = this.getConsolidatedConfigurationModelForResource(overrides, workspace);
		if (overrides.overrideIdentifier) configurationModel = configurationModel.override(overrides.overrideIdentifier);
		if (!this._policyConfiguration.isEmpty() && this._policyConfiguration.getValue(section) !== void 0) {
			configurationModel = configurationModel.merge();
			for (const key of this._policyConfiguration.keys) configurationModel.setValue(key, this._policyConfiguration.getValue(key));
		}
		return configurationModel;
	}
	getConsolidatedConfigurationModelForResource({ resource }, workspace) {
		let consolidateConfiguration = this.getWorkspaceConsolidatedConfiguration();
		if (workspace && resource) {
			const root = workspace.getFolder(resource);
			if (root) consolidateConfiguration = this.getFolderConsolidatedConfiguration(root.uri) || consolidateConfiguration;
			const memoryConfigurationForResource = this._memoryConfigurationByResource.get(resource);
			if (memoryConfigurationForResource) consolidateConfiguration = consolidateConfiguration.merge(memoryConfigurationForResource);
		}
		return consolidateConfiguration;
	}
	getWorkspaceConsolidatedConfiguration() {
		if (!this._workspaceConsolidatedConfiguration) this._workspaceConsolidatedConfiguration = this._defaultConfiguration.merge(this.applicationConfiguration, this.userConfiguration, this._workspaceConfiguration, this._memoryConfiguration);
		return this._workspaceConsolidatedConfiguration;
	}
	getFolderConsolidatedConfiguration(folder) {
		let folderConsolidatedConfiguration = this._foldersConsolidatedConfigurations.get(folder);
		if (!folderConsolidatedConfiguration) {
			const workspaceConsolidateConfiguration = this.getWorkspaceConsolidatedConfiguration();
			const folderConfiguration = this._folderConfigurations.get(folder);
			if (folderConfiguration) {
				folderConsolidatedConfiguration = workspaceConsolidateConfiguration.merge(folderConfiguration);
				this._foldersConsolidatedConfigurations.set(folder, folderConsolidatedConfiguration);
			} else folderConsolidatedConfiguration = workspaceConsolidateConfiguration;
		}
		return folderConsolidatedConfiguration;
	}
	getFolderConfigurationModelForResource(resource, workspace) {
		if (workspace && resource) {
			const root = workspace.getFolder(resource);
			if (root) return this._folderConfigurations.get(root.uri);
		}
	}
	toData() {
		return {
			defaults: {
				contents: this._defaultConfiguration.contents,
				overrides: this._defaultConfiguration.overrides,
				keys: this._defaultConfiguration.keys
			},
			policy: {
				contents: this._policyConfiguration.contents,
				overrides: this._policyConfiguration.overrides,
				keys: this._policyConfiguration.keys
			},
			application: {
				contents: this.applicationConfiguration.contents,
				overrides: this.applicationConfiguration.overrides,
				keys: this.applicationConfiguration.keys,
				raw: Array.isArray(this.applicationConfiguration.raw) ? void 0 : this.applicationConfiguration.raw
			},
			userLocal: {
				contents: this.localUserConfiguration.contents,
				overrides: this.localUserConfiguration.overrides,
				keys: this.localUserConfiguration.keys,
				raw: Array.isArray(this.localUserConfiguration.raw) ? void 0 : this.localUserConfiguration.raw
			},
			userRemote: {
				contents: this.remoteUserConfiguration.contents,
				overrides: this.remoteUserConfiguration.overrides,
				keys: this.remoteUserConfiguration.keys,
				raw: Array.isArray(this.remoteUserConfiguration.raw) ? void 0 : this.remoteUserConfiguration.raw
			},
			workspace: {
				contents: this._workspaceConfiguration.contents,
				overrides: this._workspaceConfiguration.overrides,
				keys: this._workspaceConfiguration.keys
			},
			folders: [...this._folderConfigurations.keys()].reduce((result, folder) => {
				const { contents, overrides, keys } = this._folderConfigurations.get(folder);
				result.push([folder, {
					contents,
					overrides,
					keys
				}]);
				return result;
			}, [])
		};
	}
	static parse(data, logService) {
		const defaultConfiguration = this.parseConfigurationModel(data.defaults, logService);
		const policyConfiguration = this.parseConfigurationModel(data.policy, logService);
		const applicationConfiguration = this.parseConfigurationModel(data.application, logService);
		const userLocalConfiguration = this.parseConfigurationModel(data.userLocal, logService);
		const userRemoteConfiguration = this.parseConfigurationModel(data.userRemote, logService);
		const workspaceConfiguration = this.parseConfigurationModel(data.workspace, logService);
		const folders = data.folders.reduce((result, value) => {
			result.set(URI.revive(value[0]), this.parseConfigurationModel(value[1], logService));
			return result;
		}, new ResourceMap());
		return new Configuration(defaultConfiguration, policyConfiguration, applicationConfiguration, userLocalConfiguration, userRemoteConfiguration, workspaceConfiguration, folders, ConfigurationModel.createEmptyModel(logService), new ResourceMap(), logService);
	}
	static parseConfigurationModel(model, logService) {
		return new ConfigurationModel(model.contents, model.keys, model.overrides, model.raw, logService);
	}
};
var ConfigurationChangeEvent = class {
	constructor(change, previous, currentConfiguraiton, currentWorkspace, logService) {
		this.change = change;
		this.previous = previous;
		this.currentConfiguraiton = currentConfiguraiton;
		this.currentWorkspace = currentWorkspace;
		this.logService = logService;
		this._marker = "\n";
		this._markerCode1 = this._marker.charCodeAt(0);
		this._markerCode2 = ".".charCodeAt(0);
		this.affectedKeys = /* @__PURE__ */ new Set();
		this._previousConfiguration = void 0;
		for (const key of change.keys) this.affectedKeys.add(key);
		for (const [, keys] of change.overrides) for (const key of keys) this.affectedKeys.add(key);
		this._affectsConfigStr = this._marker;
		for (const key of this.affectedKeys) this._affectsConfigStr += key + this._marker;
	}
	get previousConfiguration() {
		if (!this._previousConfiguration && this.previous) this._previousConfiguration = Configuration.parse(this.previous.data, this.logService);
		return this._previousConfiguration;
	}
	affectsConfiguration(section, overrides) {
		const needle = this._marker + section;
		const idx = this._affectsConfigStr.indexOf(needle);
		if (idx < 0) return false;
		const pos = idx + needle.length;
		if (pos >= this._affectsConfigStr.length) return false;
		const code = this._affectsConfigStr.charCodeAt(pos);
		if (code !== this._markerCode1 && code !== this._markerCode2) return false;
		if (overrides) {
			const value1 = this.previousConfiguration ? this.previousConfiguration.getValue(section, overrides, this.previous?.workspace) : void 0;
			const value2 = this.currentConfiguraiton.getValue(section, overrides, this.currentWorkspace);
			return !equals$2(value1, value2);
		}
		return true;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/configuration/common/configurations.js
var DefaultConfiguration = class extends Disposable {
	get configurationModel() {
		return this._configurationModel;
	}
	constructor(logService) {
		super();
		this.logService = logService;
		this._configurationModel = ConfigurationModel.createEmptyModel(logService);
	}
	reload() {
		this.resetConfigurationModel();
		return this.configurationModel;
	}
	getConfigurationDefaultOverrides() {
		return {};
	}
	resetConfigurationModel() {
		this._configurationModel = ConfigurationModel.createEmptyModel(this.logService);
		const properties = Registry.as(Extensions$6.Configuration).getConfigurationProperties();
		this.updateConfigurationModel(Object.keys(properties), properties);
	}
	updateConfigurationModel(properties, configurationProperties) {
		const configurationDefaultsOverrides = this.getConfigurationDefaultOverrides();
		for (const key of properties) {
			const defaultOverrideValue = configurationDefaultsOverrides[key];
			const propertySchema = configurationProperties[key];
			if (defaultOverrideValue !== void 0) this._configurationModel.setValue(key, defaultOverrideValue);
			else if (propertySchema) this._configurationModel.setValue(key, this.getDefaultValue(key, propertySchema));
			else this._configurationModel.removeValue(key);
		}
	}
	getDefaultValue(_key, propertySchema) {
		return deepClone(propertySchema.default);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/ternarySearchTree.js
var StringIterator = class {
	constructor() {
		this._value = "";
		this._pos = 0;
	}
	reset(key) {
		this._value = key;
		this._pos = 0;
		return this;
	}
	next() {
		this._pos += 1;
		return this;
	}
	hasNext() {
		return this._pos < this._value.length - 1;
	}
	cmp(a) {
		return a.charCodeAt(0) - this._value.charCodeAt(this._pos);
	}
	value() {
		return this._value[this._pos];
	}
};
var ConfigKeysIterator = class {
	constructor(_caseSensitive = true) {
		this._caseSensitive = _caseSensitive;
	}
	reset(key) {
		this._value = key;
		this._from = 0;
		this._to = 0;
		return this.next();
	}
	hasNext() {
		return this._to < this._value.length;
	}
	next() {
		this._from = this._to;
		let justSeps = true;
		for (; this._to < this._value.length; this._to++) if (this._value.charCodeAt(this._to) === 46) {
			if (justSeps) this._from++;
			else break;
		} else justSeps = false;
		return this;
	}
	cmp(a) {
		return this._caseSensitive ? compareSubstring(a, this._value, 0, a.length, this._from, this._to) : compareSubstringIgnoreCase(a, this._value, 0, a.length, this._from, this._to);
	}
	value() {
		return this._value.substring(this._from, this._to);
	}
};
var PathIterator = class {
	constructor(_splitOnBackslash = true, _caseSensitive = true) {
		this._splitOnBackslash = _splitOnBackslash;
		this._caseSensitive = _caseSensitive;
	}
	reset(key) {
		this._from = 0;
		this._to = 0;
		this._value = key;
		this._valueLen = key.length;
		for (let pos = key.length - 1; pos >= 0; pos--, this._valueLen--) {
			const ch = this._value.charCodeAt(pos);
			if (!(ch === 47 || this._splitOnBackslash && ch === 92)) break;
		}
		return this.next();
	}
	hasNext() {
		return this._to < this._valueLen;
	}
	next() {
		this._from = this._to;
		let justSeps = true;
		for (; this._to < this._valueLen; this._to++) {
			const ch = this._value.charCodeAt(this._to);
			if (ch === 47 || this._splitOnBackslash && ch === 92) {
				if (justSeps) this._from++;
				else break;
			} else justSeps = false;
		}
		return this;
	}
	cmp(a) {
		return this._caseSensitive ? compareSubstring(a, this._value, 0, a.length, this._from, this._to) : compareSubstringIgnoreCase(a, this._value, 0, a.length, this._from, this._to);
	}
	value() {
		return this._value.substring(this._from, this._to);
	}
};
var UriIterator = class {
	constructor(_ignorePathCasing, _ignoreQueryAndFragment) {
		this._ignorePathCasing = _ignorePathCasing;
		this._ignoreQueryAndFragment = _ignoreQueryAndFragment;
		this._states = [];
		this._stateIdx = 0;
	}
	reset(key) {
		this._value = key;
		this._states = [];
		if (this._value.scheme) this._states.push(1);
		if (this._value.authority) this._states.push(2);
		if (this._value.path) {
			this._pathIterator = new PathIterator(false, !this._ignorePathCasing(key));
			this._pathIterator.reset(key.path);
			if (this._pathIterator.value()) this._states.push(3);
		}
		if (!this._ignoreQueryAndFragment(key)) {
			if (this._value.query) this._states.push(4);
			if (this._value.fragment) this._states.push(5);
		}
		this._stateIdx = 0;
		return this;
	}
	next() {
		if (this._states[this._stateIdx] === 3 && this._pathIterator.hasNext()) this._pathIterator.next();
		else this._stateIdx += 1;
		return this;
	}
	hasNext() {
		return this._states[this._stateIdx] === 3 && this._pathIterator.hasNext() || this._stateIdx < this._states.length - 1;
	}
	cmp(a) {
		if (this._states[this._stateIdx] === 1) return compareIgnoreCase(a, this._value.scheme);
		else if (this._states[this._stateIdx] === 2) return compareIgnoreCase(a, this._value.authority);
		else if (this._states[this._stateIdx] === 3) return this._pathIterator.cmp(a);
		else if (this._states[this._stateIdx] === 4) return compare(a, this._value.query);
		else if (this._states[this._stateIdx] === 5) return compare(a, this._value.fragment);
		throw new Error();
	}
	value() {
		if (this._states[this._stateIdx] === 1) return this._value.scheme;
		else if (this._states[this._stateIdx] === 2) return this._value.authority;
		else if (this._states[this._stateIdx] === 3) return this._pathIterator.value();
		else if (this._states[this._stateIdx] === 4) return this._value.query;
		else if (this._states[this._stateIdx] === 5) return this._value.fragment;
		throw new Error();
	}
};
var Undef = class Undef {
	static {
		this.Val = Symbol("undefined_placeholder");
	}
	static wrap(value) {
		return value === void 0 ? Undef.Val : value;
	}
	static unwrap(value) {
		return value === Undef.Val ? void 0 : value;
	}
};
var TernarySearchTreeNode = class {
	constructor() {
		this.height = 1;
		this.value = void 0;
		this.key = void 0;
		this.left = void 0;
		this.mid = void 0;
		this.right = void 0;
	}
	rotateLeft() {
		const tmp = this.right;
		this.right = tmp.left;
		tmp.left = this;
		this.updateHeight();
		tmp.updateHeight();
		return tmp;
	}
	rotateRight() {
		const tmp = this.left;
		this.left = tmp.right;
		tmp.right = this;
		this.updateHeight();
		tmp.updateHeight();
		return tmp;
	}
	updateHeight() {
		this.height = 1 + Math.max(this.heightLeft, this.heightRight);
	}
	balanceFactor() {
		return this.heightRight - this.heightLeft;
	}
	get heightLeft() {
		return this.left?.height ?? 0;
	}
	get heightRight() {
		return this.right?.height ?? 0;
	}
};
var TernarySearchTree = class TernarySearchTree {
	static forUris(ignorePathCasing = () => false, ignoreQueryAndFragment = () => false) {
		return new TernarySearchTree(new UriIterator(ignorePathCasing, ignoreQueryAndFragment));
	}
	static forStrings() {
		return new TernarySearchTree(new StringIterator());
	}
	static forConfigKeys() {
		return new TernarySearchTree(new ConfigKeysIterator());
	}
	constructor(segments) {
		this._iter = segments;
	}
	clear() {
		this._root = void 0;
	}
	set(key, element) {
		const iter = this._iter.reset(key);
		let node;
		if (!this._root) {
			this._root = new TernarySearchTreeNode();
			this._root.segment = iter.value();
		}
		const stack = [];
		node = this._root;
		while (true) {
			const val = iter.cmp(node.segment);
			if (val > 0) {
				if (!node.left) {
					node.left = new TernarySearchTreeNode();
					node.left.segment = iter.value();
				}
				stack.push([-1, node]);
				node = node.left;
			} else if (val < 0) {
				if (!node.right) {
					node.right = new TernarySearchTreeNode();
					node.right.segment = iter.value();
				}
				stack.push([1, node]);
				node = node.right;
			} else if (iter.hasNext()) {
				iter.next();
				if (!node.mid) {
					node.mid = new TernarySearchTreeNode();
					node.mid.segment = iter.value();
				}
				stack.push([0, node]);
				node = node.mid;
			} else break;
		}
		const oldElement = Undef.unwrap(node.value);
		node.value = Undef.wrap(element);
		node.key = key;
		for (let i = stack.length - 1; i >= 0; i--) {
			const node = stack[i][1];
			node.updateHeight();
			const bf = node.balanceFactor();
			if (bf < -1 || bf > 1) {
				const d1 = stack[i][0];
				const d2 = stack[i + 1][0];
				if (d1 === 1 && d2 === 1) stack[i][1] = node.rotateLeft();
				else if (d1 === -1 && d2 === -1) stack[i][1] = node.rotateRight();
				else if (d1 === 1 && d2 === -1) {
					node.right = stack[i + 1][1] = stack[i + 1][1].rotateRight();
					stack[i][1] = node.rotateLeft();
				} else if (d1 === -1 && d2 === 1) {
					node.left = stack[i + 1][1] = stack[i + 1][1].rotateLeft();
					stack[i][1] = node.rotateRight();
				} else throw new Error();
				if (i > 0) switch (stack[i - 1][0]) {
					case -1:
						stack[i - 1][1].left = stack[i][1];
						break;
					case 1:
						stack[i - 1][1].right = stack[i][1];
						break;
					case 0: stack[i - 1][1].mid = stack[i][1];
				}
				else this._root = stack[0][1];
			}
		}
		return oldElement;
	}
	get(key) {
		return Undef.unwrap(this._getNode(key)?.value);
	}
	_getNode(key) {
		const iter = this._iter.reset(key);
		let node = this._root;
		while (node) {
			const val = iter.cmp(node.segment);
			if (val > 0) node = node.left;
			else if (val < 0) node = node.right;
			else if (iter.hasNext()) {
				iter.next();
				node = node.mid;
			} else break;
		}
		return node;
	}
	has(key) {
		const node = this._getNode(key);
		return !(node?.value === void 0 && node?.mid === void 0);
	}
	delete(key) {
		return this._delete(key, false);
	}
	deleteSuperstr(key) {
		return this._delete(key, true);
	}
	_delete(key, superStr) {
		const iter = this._iter.reset(key);
		const stack = [];
		let node = this._root;
		while (node) {
			const val = iter.cmp(node.segment);
			if (val > 0) {
				stack.push([-1, node]);
				node = node.left;
			} else if (val < 0) {
				stack.push([1, node]);
				node = node.right;
			} else if (iter.hasNext()) {
				iter.next();
				stack.push([0, node]);
				node = node.mid;
			} else break;
		}
		if (!node) return;
		if (superStr) {
			node.left = void 0;
			node.mid = void 0;
			node.right = void 0;
			node.height = 1;
		} else {
			node.key = void 0;
			node.value = void 0;
		}
		if (!node.mid && !node.value) {
			if (node.left && node.right) {
				const stack2 = [[1, node]];
				const min = this._min(node.right, stack2);
				if (min.key) {
					node.key = min.key;
					node.value = min.value;
					node.segment = min.segment;
					const newChild = min.right;
					if (stack2.length > 1) {
						const [dir, parent] = stack2[stack2.length - 1];
						switch (dir) {
							case -1:
								parent.left = newChild;
								break;
							case 0: assert(false);
							case 1: assert(false);
						}
					} else node.right = newChild;
					const newChild2 = this._balanceByStack(stack2);
					if (stack.length > 0) {
						const [dir, parent] = stack[stack.length - 1];
						switch (dir) {
							case -1:
								parent.left = newChild2;
								break;
							case 0:
								parent.mid = newChild2;
								break;
							case 1: parent.right = newChild2;
						}
					} else this._root = newChild2;
				}
			} else {
				const newChild = node.left ?? node.right;
				if (stack.length > 0) {
					const [dir, parent] = stack[stack.length - 1];
					switch (dir) {
						case -1:
							parent.left = newChild;
							break;
						case 0:
							parent.mid = newChild;
							break;
						case 1: parent.right = newChild;
					}
				} else this._root = newChild;
			}
		}
		this._root = this._balanceByStack(stack) ?? this._root;
	}
	_min(node, stack) {
		while (node.left) {
			stack.push([-1, node]);
			node = node.left;
		}
		return node;
	}
	_balanceByStack(stack) {
		for (let i = stack.length - 1; i >= 0; i--) {
			const node = stack[i][1];
			node.updateHeight();
			const bf = node.balanceFactor();
			if (bf > 1) {
				if (node.right.balanceFactor() >= 0) stack[i][1] = node.rotateLeft();
				else {
					node.right = node.right.rotateRight();
					stack[i][1] = node.rotateLeft();
				}
			} else if (bf < -1) {
				if (node.left.balanceFactor() <= 0) stack[i][1] = node.rotateRight();
				else {
					node.left = node.left.rotateLeft();
					stack[i][1] = node.rotateRight();
				}
			}
			if (i > 0) switch (stack[i - 1][0]) {
				case -1:
					stack[i - 1][1].left = stack[i][1];
					break;
				case 1:
					stack[i - 1][1].right = stack[i][1];
					break;
				case 0: stack[i - 1][1].mid = stack[i][1];
			}
			else return stack[0][1];
		}
	}
	findSubstr(key) {
		const iter = this._iter.reset(key);
		let node = this._root;
		let candidate = void 0;
		while (node) {
			const val = iter.cmp(node.segment);
			if (val > 0) node = node.left;
			else if (val < 0) node = node.right;
			else if (iter.hasNext()) {
				iter.next();
				candidate = Undef.unwrap(node.value) || candidate;
				node = node.mid;
			} else break;
		}
		return node && Undef.unwrap(node.value) || candidate;
	}
	findSuperstr(key) {
		return this._findSuperstrOrElement(key, false);
	}
	_findSuperstrOrElement(key, allowValue) {
		const iter = this._iter.reset(key);
		let node = this._root;
		while (node) {
			const val = iter.cmp(node.segment);
			if (val > 0) node = node.left;
			else if (val < 0) node = node.right;
			else if (iter.hasNext()) {
				iter.next();
				node = node.mid;
			} else if (!node.mid) {
				if (allowValue) return Undef.unwrap(node.value);
				else return;
			} else return this._entries(node.mid);
		}
	}
	forEach(callback) {
		for (const [key, value] of this) callback(value, key);
	}
	*[Symbol.iterator]() {
		yield* this._entries(this._root);
	}
	_entries(node) {
		const result = [];
		this._dfsEntries(node, result);
		return result[Symbol.iterator]();
	}
	_dfsEntries(node, bucket) {
		if (!node) return;
		if (node.left) this._dfsEntries(node.left, bucket);
		if (node.value !== void 0) bucket.push([node.key, Undef.unwrap(node.value)]);
		if (node.mid) this._dfsEntries(node.mid, bucket);
		if (node.right) this._dfsEntries(node.right, bucket);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/contextkey/common/contextkeys.js
new RawContextKey("isMac", isMacintosh, localize(1778, "Whether the operating system is macOS"));
new RawContextKey("isLinux", isLinux, localize(1779, "Whether the operating system is Linux"));
var IsWindowsContext = new RawContextKey("isWindows", isWindows, localize(1780, "Whether the operating system is Windows"));
new RawContextKey("isChromeOS", isChromeOS, localize(1781, "Whether the operating system is ChromeOS"));
var IsWebContext = new RawContextKey("isWeb", isWeb, localize(1782, "Whether the platform is a web browser"));
new RawContextKey("isMacNative", isMacintosh && !isWeb, localize(1783, "Whether the operating system is macOS on a non-browser platform"));
new RawContextKey("isIOS", isIOS, localize(1784, "Whether the operating system is iOS"));
new RawContextKey("isMobile", isMobile, localize(1785, "Whether the platform is a mobile web browser"));
new RawContextKey("isDevelopment", false, true);
new RawContextKey("productQualityType", "", localize(1786, "Quality type of VS Code"));
var InputFocusedContextKey = "inputFocus";
var InputFocusedContext = new RawContextKey(InputFocusedContextKey, false, localize(1787, "Whether keyboard focus is inside an input box"));
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/contextkey/browser/contextKeyService.js
var __decorate$38 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$33 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var KEYBINDING_CONTEXT_ATTR = "data-keybinding-context";
var Context = class {
	constructor(id, parent) {
		this._id = id;
		this._parent = parent;
		this._value = Object.create(null);
		this._value["_contextId"] = id;
	}
	get value() {
		return { ...this._value };
	}
	setValue(key, value) {
		if (!equals$2(this._value[key], value)) {
			this._value[key] = value;
			return true;
		}
		return false;
	}
	removeValue(key) {
		if (key in this._value) {
			delete this._value[key];
			return true;
		}
		return false;
	}
	getValue(key) {
		const ret = this._value[key];
		if (typeof ret === "undefined" && this._parent) return this._parent.getValue(key);
		return ret;
	}
};
var NullContext = class NullContext extends Context {
	static {
		this.INSTANCE = new NullContext();
	}
	constructor() {
		super(-1, null);
	}
	setValue(key, value) {
		return false;
	}
	removeValue(key) {
		return false;
	}
	getValue(key) {}
};
var ConfigAwareContextValuesContainer = class ConfigAwareContextValuesContainer extends Context {
	static {
		this._keyPrefix = "config.";
	}
	constructor(id, _configurationService, emitter) {
		super(id, null);
		this._configurationService = _configurationService;
		this._values = TernarySearchTree.forConfigKeys();
		this._listener = this._configurationService.onDidChangeConfiguration((event) => {
			if (event.source === 7) {
				const allKeys = Array.from(this._values, ([k]) => k);
				this._values.clear();
				emitter.fire(new ArrayContextKeyChangeEvent(allKeys));
			} else {
				const changedKeys = [];
				for (const configKey of event.affectedKeys) {
					const contextKey = `config.${configKey}`;
					const cachedItems = this._values.findSuperstr(contextKey);
					if (cachedItems !== void 0) {
						changedKeys.push(...Iterable.map(cachedItems, ([key]) => key));
						this._values.deleteSuperstr(contextKey);
					}
					if (this._values.has(contextKey)) {
						changedKeys.push(contextKey);
						this._values.delete(contextKey);
					}
				}
				emitter.fire(new ArrayContextKeyChangeEvent(changedKeys));
			}
		});
	}
	dispose() {
		this._listener.dispose();
	}
	getValue(key) {
		if (key.indexOf(ConfigAwareContextValuesContainer._keyPrefix) !== 0) return super.getValue(key);
		if (this._values.has(key)) return this._values.get(key);
		const configKey = key.substr(ConfigAwareContextValuesContainer._keyPrefix.length);
		const configValue = this._configurationService.getValue(configKey);
		let value = void 0;
		switch (typeof configValue) {
			case "number":
			case "boolean":
			case "string":
				value = configValue;
				break;
			default: if (Array.isArray(configValue)) value = JSON.stringify(configValue);
			else value = configValue;
		}
		this._values.set(key, value);
		return value;
	}
	setValue(key, value) {
		return super.setValue(key, value);
	}
	removeValue(key) {
		return super.removeValue(key);
	}
};
var ContextKey = class {
	constructor(service, key, defaultValue) {
		this._service = service;
		this._key = key;
		this._defaultValue = defaultValue;
		this.reset();
	}
	set(value) {
		this._service.setContext(this._key, value);
	}
	reset() {
		if (typeof this._defaultValue === "undefined") this._service.removeContext(this._key);
		else this._service.setContext(this._key, this._defaultValue);
	}
	get() {
		return this._service.getContextKeyValue(this._key);
	}
};
var SimpleContextKeyChangeEvent = class {
	constructor(key) {
		this.key = key;
	}
	affectsSome(keys) {
		return keys.has(this.key);
	}
	allKeysContainedIn(keys) {
		return this.affectsSome(keys);
	}
};
var ArrayContextKeyChangeEvent = class {
	constructor(keys) {
		this.keys = keys;
	}
	affectsSome(keys) {
		for (const key of this.keys) if (keys.has(key)) return true;
		return false;
	}
	allKeysContainedIn(keys) {
		return this.keys.every((key) => keys.has(key));
	}
};
var CompositeContextKeyChangeEvent = class {
	constructor(events) {
		this.events = events;
	}
	affectsSome(keys) {
		for (const e of this.events) if (e.affectsSome(keys)) return true;
		return false;
	}
	allKeysContainedIn(keys) {
		return this.events.every((evt) => evt.allKeysContainedIn(keys));
	}
};
function allEventKeysInContext(event, context) {
	return event.allKeysContainedIn(new Set(Object.keys(context)));
}
var AbstractContextKeyService = class extends Disposable {
	get onDidChangeContext() {
		return this._onDidChangeContext.event;
	}
	constructor(myContextId) {
		super();
		this._onDidChangeContext = this._register(new PauseableEmitter({ merge: (input) => new CompositeContextKeyChangeEvent(input) }));
		this._isDisposed = false;
		this._myContextId = myContextId;
	}
	createKey(key, defaultValue) {
		if (this._isDisposed) throw new Error(`AbstractContextKeyService has been disposed`);
		return new ContextKey(this, key, defaultValue);
	}
	bufferChangeEvents(callback) {
		this._onDidChangeContext.pause();
		try {
			callback();
		} finally {
			this._onDidChangeContext.resume();
		}
	}
	createScoped(domNode) {
		if (this._isDisposed) throw new Error(`AbstractContextKeyService has been disposed`);
		return new ScopedContextKeyService(this, domNode);
	}
	contextMatchesRules(rules) {
		if (this._isDisposed) throw new Error(`AbstractContextKeyService has been disposed`);
		const context = this.getContextValuesContainer(this._myContextId);
		return rules ? rules.evaluate(context) : true;
	}
	getContextKeyValue(key) {
		if (this._isDisposed) return;
		return this.getContextValuesContainer(this._myContextId).getValue(key);
	}
	setContext(key, value) {
		if (this._isDisposed) return;
		const myContext = this.getContextValuesContainer(this._myContextId);
		if (!myContext) return;
		if (myContext.setValue(key, value)) this._onDidChangeContext.fire(new SimpleContextKeyChangeEvent(key));
	}
	removeContext(key) {
		if (this._isDisposed) return;
		if (this.getContextValuesContainer(this._myContextId).removeValue(key)) this._onDidChangeContext.fire(new SimpleContextKeyChangeEvent(key));
	}
	getContext(target) {
		if (this._isDisposed) return NullContext.INSTANCE;
		return this.getContextValuesContainer(findContextAttr(target));
	}
	dispose() {
		super.dispose();
		this._isDisposed = true;
	}
};
var ContextKeyService = class ContextKeyService extends AbstractContextKeyService {
	constructor(configurationService) {
		super(0);
		this._contexts = /* @__PURE__ */ new Map();
		this._lastContextId = 0;
		this.inputFocusedContext = InputFocusedContext.bindTo(this);
		const myContext = this._register(new ConfigAwareContextValuesContainer(this._myContextId, configurationService, this._onDidChangeContext));
		this._contexts.set(this._myContextId, myContext);
		this._register(Event.runAndSubscribe(onDidRegisterWindow, ({ window, disposables }) => {
			const onFocusDisposables = disposables.add(new MutableDisposable());
			disposables.add(addDisposableListener(window, EventType$1.FOCUS_IN, () => {
				onFocusDisposables.value = new DisposableStore();
				this.updateInputContextKeys(window.document, onFocusDisposables.value);
			}, true));
		}, {
			window: mainWindow,
			disposables: this._store
		}));
	}
	updateInputContextKeys(ownerDocument, disposables) {
		function activeElementIsInput() {
			return !!ownerDocument.activeElement && isEditableElement(ownerDocument.activeElement);
		}
		const isInputFocused = activeElementIsInput();
		this.inputFocusedContext.set(isInputFocused);
		if (isInputFocused) {
			const tracker = disposables.add(trackFocus(ownerDocument.activeElement));
			Event.once(tracker.onDidBlur)(() => {
				if (getActiveWindow().document === ownerDocument) this.inputFocusedContext.set(activeElementIsInput());
				tracker.dispose();
			}, void 0, disposables);
		}
	}
	getContextValuesContainer(contextId) {
		if (this._isDisposed) return NullContext.INSTANCE;
		return this._contexts.get(contextId) || NullContext.INSTANCE;
	}
	createChildContext(parentContextId = this._myContextId) {
		if (this._isDisposed) throw new Error(`ContextKeyService has been disposed`);
		const id = ++this._lastContextId;
		this._contexts.set(id, new Context(id, this.getContextValuesContainer(parentContextId)));
		return id;
	}
	disposeContext(contextId) {
		if (!this._isDisposed) this._contexts.delete(contextId);
	}
};
ContextKeyService = __decorate$38([__param$33(0, IConfigurationService)], ContextKeyService);
var ScopedContextKeyService = class extends AbstractContextKeyService {
	constructor(parent, domNode) {
		super(parent.createChildContext());
		this._parentChangeListener = this._register(new MutableDisposable());
		this._parent = parent;
		this._updateParentChangeListener();
		this._domNode = domNode;
		if (this._domNode.hasAttribute(KEYBINDING_CONTEXT_ATTR)) {
			let extraInfo = "";
			if (this._domNode.classList) extraInfo = Array.from(this._domNode.classList.values()).join(", ");
			console.error(`Element already has context attribute${extraInfo ? ": " + extraInfo : ""}`);
		}
		this._domNode.setAttribute(KEYBINDING_CONTEXT_ATTR, String(this._myContextId));
	}
	_updateParentChangeListener() {
		this._parentChangeListener.value = this._parent.onDidChangeContext((e) => {
			const thisContextValues = this._parent.getContextValuesContainer(this._myContextId).value;
			if (!allEventKeysInContext(e, thisContextValues)) this._onDidChangeContext.fire(e);
		});
	}
	dispose() {
		if (this._isDisposed) return;
		this._parentChangeListener.clear();
		this._parent.disposeContext(this._myContextId);
		this._domNode.removeAttribute(KEYBINDING_CONTEXT_ATTR);
		super.dispose();
	}
	getContextValuesContainer(contextId) {
		if (this._isDisposed) return NullContext.INSTANCE;
		return this._parent.getContextValuesContainer(contextId);
	}
	createChildContext(parentContextId = this._myContextId) {
		if (this._isDisposed) throw new Error(`ScopedContextKeyService has been disposed`);
		return this._parent.createChildContext(parentContextId);
	}
	disposeContext(contextId) {
		this._parent.disposeContext(contextId);
	}
};
function findContextAttr(domNode) {
	while (domNode) {
		if (domNode.hasAttribute(KEYBINDING_CONTEXT_ATTR)) {
			const attr = domNode.getAttribute(KEYBINDING_CONTEXT_ATTR);
			if (attr) return parseInt(attr, 10);
			return NaN;
		}
		domNode = domNode.parentElement;
	}
	return 0;
}
function setContext(accessor, contextKey, contextValue) {
	accessor.get(IContextKeyService).createKey(String(contextKey), stringifyURIs(contextValue));
}
function stringifyURIs(contextValue) {
	return cloneAndChange(contextValue, (obj) => {
		if (typeof obj === "object" && obj.$mid === 1) return URI.revive(obj).toString();
		if (obj instanceof URI) return obj.toString();
	});
}
CommandsRegistry.registerCommand("_setContext", setContext);
CommandsRegistry.registerCommand({
	id: "getContextKeyInfo",
	handler() {
		return [...RawContextKey.all()].sort((a, b) => a.key.localeCompare(b.key));
	},
	metadata: {
		description: localize(1768, "A command that returns information about context keys"),
		args: []
	}
});
CommandsRegistry.registerCommand("_generateContextKeyInfo", function() {
	const result = [];
	const seen = /* @__PURE__ */ new Set();
	for (const info of RawContextKey.all()) if (!seen.has(info.key)) {
		seen.add(info.key);
		result.push(info);
	}
	result.sort((a, b) => a.key.localeCompare(b.key));
	console.log(JSON.stringify(result, void 0, 2));
});
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/cssValue.js
function asFragment(raw) {
	return raw;
}
function asCssValueWithDefault(cssPropertyValue, dflt) {
	if (cssPropertyValue !== void 0) {
		const variableMatch = cssPropertyValue.match(/^\s*var\((.+)\)$/);
		if (variableMatch) {
			const varArguments = variableMatch[1].split(",", 2);
			if (varArguments.length === 2) dflt = asCssValueWithDefault(varArguments[1].trim(), dflt);
			return `var(${varArguments[0]}, ${dflt})`;
		}
		return cssPropertyValue;
	}
	return dflt;
}
function identValue(value) {
	const out = value.replaceAll(/[^_\-a-z0-9]/gi, "");
	if (out !== value) console.warn(`CSS ident value ${value} modified to ${out} to be safe for CSS`);
	return asFragment(out);
}
function stringValue(value) {
	return asFragment(`'${value.replaceAll(/'/g, "\\000027")}'`);
}
/**
* returns url('...')
*/
function asCSSUrl(uri) {
	if (!uri) return asFragment(`url('')`);
	return inline`url('${asFragment(CSS.escape(FileAccess.uriToBrowserUri(uri).toString(true)))}')`;
}
function className(value, escapingExpected = false) {
	const out = CSS.escape(value);
	if (!escapingExpected && out !== value) console.warn(`CSS class name ${value} modified to ${out} to be safe for CSS`);
	return asFragment(out);
}
/**
* Template string tag that that constructs a CSS fragment.
*
* All expressions in the template must be css safe values.
*/
function inline(strings, ...values) {
	return asFragment(strings.reduce((result, str, i) => {
		const value = values[i] || "";
		return result + str + value;
	}, ""));
}
var Builder = class {
	constructor() {
		this._parts = [];
	}
	push(...parts) {
		this._parts.push(...parts);
	}
	join(joiner = "\n") {
		return asFragment(this._parts.join(joiner));
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/hover/hoverDelegateFactory.js
var nullHoverDelegateFactory = () => ({
	get delay() {
		return -1;
	},
	dispose: () => {},
	showHover: () => {}
});
var hoverDelegateFactory = nullHoverDelegateFactory;
var defaultHoverDelegateMouse = new Lazy(() => hoverDelegateFactory("mouse", false));
var defaultHoverDelegateElement = new Lazy(() => hoverDelegateFactory("element", false));
function setHoverDelegateFactory(hoverDelegateProvider) {
	hoverDelegateFactory = hoverDelegateProvider;
}
function getDefaultHoverDelegate(placement) {
	if (placement === "element") return defaultHoverDelegateElement.value;
	return defaultHoverDelegateMouse.value;
}
function createInstantHoverDelegate() {
	return hoverDelegateFactory("element", true);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/hover/hoverDelegate2.js
var baseHoverDelegate = {
	showInstantHover: () => void 0,
	showDelayedHover: () => void 0,
	setupDelayedHover: () => Disposable.None,
	setupDelayedHoverAtMouse: () => Disposable.None,
	hideHover: () => void 0,
	showAndFocusLastHover: () => void 0,
	setupManagedHover: () => ({
		dispose: () => void 0,
		show: () => void 0,
		hide: () => void 0,
		update: () => void 0
	}),
	showManagedHover: () => void 0
};
/**
* Sets the hover delegate for use **only in the `base/` layer**.
*/
function setBaseLayerHoverDelegate(hoverDelegate) {
	baseHoverDelegate = hoverDelegate;
}
/**
* Gets the hover delegate for use **only in the `base/` layer**.
*
* Since the hover service depends on various platform services, this delegate essentially bypasses
* the standard dependency injection mechanism by injecting a global hover service at start up. The
* only reason this should be used is if `IHoverService` is not available.
*/
function getBaseLayerHoverDelegate() {
	return baseHoverDelegate;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/list/splice.js
var CombinedSpliceable = class {
	constructor(spliceables) {
		this.spliceables = spliceables;
	}
	splice(start, deleteCount, elements) {
		this.spliceables.forEach((s) => s.splice(start, deleteCount, elements));
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/list/list.js
var NotSelectableGroupId = "notSelectable";
var ListError = class extends Error {
	constructor(user, message) {
		super(`ListError [${user}] ${message}`);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/list/rangeMap.js
/**
* Returns the intersection between a ranged group and a range.
* Returns `[]` if the intersection is empty.
*/
function groupIntersect(range, groups) {
	const result = [];
	for (const r of groups) {
		if (range.start >= r.range.end) continue;
		if (range.end < r.range.start) break;
		const intersection = Range$1.intersect(range, r.range);
		if (Range$1.isEmpty(intersection)) continue;
		result.push({
			range: intersection,
			size: r.size
		});
	}
	return result;
}
/**
* Shifts a range by that `much`.
*/
function shift({ start, end }, much) {
	return {
		start: start + much,
		end: end + much
	};
}
/**
* Consolidates a collection of ranged groups.
*
* Consolidation is the process of merging consecutive ranged groups
* that share the same `size`.
*/
function consolidate(groups) {
	const result = [];
	let previousGroup = null;
	for (const group of groups) {
		const start = group.range.start;
		const end = group.range.end;
		const size = group.size;
		if (previousGroup && size === previousGroup.size) {
			previousGroup.range.end = end;
			continue;
		}
		previousGroup = {
			range: {
				start,
				end
			},
			size
		};
		result.push(previousGroup);
	}
	return result;
}
/**
* Concatenates several collections of ranged groups into a single
* collection.
*/
function concat(...groups) {
	return consolidate(groups.reduce((r, g) => r.concat(g), []));
}
var RangeMap = class {
	get paddingTop() {
		return this._paddingTop;
	}
	set paddingTop(paddingTop) {
		this._size = this._size + paddingTop - this._paddingTop;
		this._paddingTop = paddingTop;
	}
	constructor(topPadding) {
		this.groups = [];
		this._size = 0;
		this._paddingTop = 0;
		this._paddingTop = topPadding ?? 0;
		this._size = this._paddingTop;
	}
	splice(index, deleteCount, items = []) {
		const diff = items.length - deleteCount;
		const before = groupIntersect({
			start: 0,
			end: index
		}, this.groups);
		const after = groupIntersect({
			start: index + deleteCount,
			end: Number.POSITIVE_INFINITY
		}, this.groups).map((g) => ({
			range: shift(g.range, diff),
			size: g.size
		}));
		const middle = items.map((item, i) => ({
			range: {
				start: index + i,
				end: index + i + 1
			},
			size: item.size
		}));
		this.groups = concat(before, middle, after);
		this._size = this._paddingTop + this.groups.reduce((t, g) => t + g.size * (g.range.end - g.range.start), 0);
	}
	/**
	* Returns the number of items in the range map.
	*/
	get count() {
		const len = this.groups.length;
		if (!len) return 0;
		return this.groups[len - 1].range.end;
	}
	/**
	* Returns the sum of the sizes of all items in the range map.
	*/
	get size() {
		return this._size;
	}
	/**
	* Returns the index of the item at the given position.
	*/
	indexAt(position) {
		if (position < 0) return -1;
		if (position < this._paddingTop) return 0;
		let index = 0;
		let size = this._paddingTop;
		for (const group of this.groups) {
			const count = group.range.end - group.range.start;
			const newSize = size + count * group.size;
			if (position < newSize) return index + Math.floor((position - size) / group.size);
			index += count;
			size = newSize;
		}
		return index;
	}
	/**
	* Returns the index of the item right after the item at the
	* index of the given position.
	*/
	indexAfter(position) {
		return Math.min(this.indexAt(position) + 1, this.count);
	}
	/**
	* Returns the start position of the item at the given index.
	*/
	positionAt(index) {
		if (index < 0) return -1;
		let position = 0;
		let count = 0;
		for (const group of this.groups) {
			const groupCount = group.range.end - group.range.start;
			const newCount = count + groupCount;
			if (index < newCount) return this._paddingTop + position + (index - count) * group.size;
			position += groupCount * group.size;
			count = newCount;
		}
		return -1;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/list/rowCache.js
var RowCache = class {
	constructor(renderers) {
		this.renderers = renderers;
		this.cache = /* @__PURE__ */ new Map();
		this.transactionNodesPendingRemoval = /* @__PURE__ */ new Set();
		this.inTransaction = false;
	}
	/**
	* Returns a row either by creating a new one or reusing
	* a previously released row which shares the same templateId.
	*
	* @returns A row and `isReusingConnectedDomNode` if the row's node is already in the dom in a stale position.
	*/
	alloc(templateId) {
		let result = this.getTemplateCache(templateId).pop();
		let isStale = false;
		if (result) isStale = this.transactionNodesPendingRemoval.delete(result.domNode);
		else {
			const domNode = $$10(".monaco-list-row");
			result = {
				domNode,
				templateId,
				templateData: this.getRenderer(templateId).renderTemplate(domNode)
			};
		}
		return {
			row: result,
			isReusingConnectedDomNode: isStale
		};
	}
	/**
	* Releases the row for eventual reuse.
	*/
	release(row) {
		if (!row) return;
		this.releaseRow(row);
	}
	/**
	* Begin a set of changes that use the cache. This lets us skip work when a row is removed and then inserted again.
	*/
	transact(makeChanges) {
		if (this.inTransaction) throw new Error("Already in transaction");
		this.inTransaction = true;
		try {
			makeChanges();
		} finally {
			for (const domNode of this.transactionNodesPendingRemoval) this.doRemoveNode(domNode);
			this.transactionNodesPendingRemoval.clear();
			this.inTransaction = false;
		}
	}
	releaseRow(row) {
		const { domNode, templateId } = row;
		if (domNode) {
			if (this.inTransaction) this.transactionNodesPendingRemoval.add(domNode);
			else this.doRemoveNode(domNode);
		}
		this.getTemplateCache(templateId).push(row);
	}
	doRemoveNode(domNode) {
		domNode.classList.remove("scrolling");
		domNode.remove();
	}
	getTemplateCache(templateId) {
		let result = this.cache.get(templateId);
		if (!result) {
			result = [];
			this.cache.set(templateId, result);
		}
		return result;
	}
	dispose() {
		this.cache.forEach((cachedRows, templateId) => {
			for (const cachedRow of cachedRows) {
				this.getRenderer(templateId).disposeTemplate(cachedRow.templateData);
				cachedRow.templateData = null;
			}
		});
		this.cache.clear();
		this.transactionNodesPendingRemoval.clear();
	}
	getRenderer(templateId) {
		const renderer = this.renderers.get(templateId);
		if (!renderer) throw new Error(`No renderer found for ${templateId}`);
		return renderer;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/dnd/dnd.js
function applyDragImage(event, container, label, extraClasses = []) {
	if (!event.dataTransfer) return;
	const dragImage = $$10(".monaco-drag-image");
	dragImage.textContent = label;
	dragImage.classList.add(...extraClasses);
	const getDragImageContainer = (e) => {
		while (e && !e.classList.contains("monaco-workbench")) e = e.parentElement;
		return e || container.ownerDocument.body;
	};
	getDragImageContainer(container).appendChild(dragImage);
	event.dataTransfer.setDragImage(dragImage, -10, -10);
	setTimeout(() => dragImage.remove(), 0);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/list/listView.js
var __decorate$37 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var StaticDND = { CurrentDragAndDropData: void 0 };
var DefaultOptions$1 = {
	useShadows: true,
	verticalScrollMode: 1,
	setRowLineHeight: true,
	setRowHeight: true,
	supportDynamicHeights: false,
	dnd: {
		getDragElements(e) {
			return [e];
		},
		getDragURI() {
			return null;
		},
		onDragStart() {},
		onDragOver() {
			return false;
		},
		drop() {},
		dispose() {}
	},
	horizontalScrolling: false,
	transformOptimization: true,
	alwaysConsumeMouseWheel: true
};
var ElementsDragAndDropData = class {
	constructor(elements) {
		this.elements = elements;
	}
	update() {}
	getData() {
		return this.elements;
	}
};
var ExternalElementsDragAndDropData = class {
	constructor(elements) {
		this.elements = elements;
	}
	update() {}
	getData() {
		return this.elements;
	}
};
var NativeDragAndDropData = class {
	constructor() {
		this.types = [];
		this.files = [];
	}
	update(dataTransfer) {
		if (dataTransfer.types) this.types.splice(0, this.types.length, ...dataTransfer.types);
		if (dataTransfer.files) {
			this.files.splice(0, this.files.length);
			for (let i = 0; i < dataTransfer.files.length; i++) {
				const file = dataTransfer.files.item(i);
				if (file && (file.size || file.type)) this.files.push(file);
			}
		}
	}
	getData() {
		return {
			types: this.types,
			files: this.files
		};
	}
};
function equalsDragFeedback(f1, f2) {
	if (Array.isArray(f1) && Array.isArray(f2)) return equals$1(f1, f2);
	return f1 === f2;
}
var ListViewAccessibilityProvider = class {
	constructor(accessibilityProvider) {
		if (accessibilityProvider?.getSetSize) this.getSetSize = accessibilityProvider.getSetSize.bind(accessibilityProvider);
		else this.getSetSize = (e, i, l) => l;
		if (accessibilityProvider?.getPosInSet) this.getPosInSet = accessibilityProvider.getPosInSet.bind(accessibilityProvider);
		else this.getPosInSet = (e, i) => i + 1;
		if (accessibilityProvider?.getRole) this.getRole = accessibilityProvider.getRole.bind(accessibilityProvider);
		else this.getRole = (_) => "listitem";
		if (accessibilityProvider?.isChecked) this.isChecked = accessibilityProvider.isChecked.bind(accessibilityProvider);
		else this.isChecked = (_) => void 0;
	}
};
/**
* The {@link ListView} is a virtual scrolling engine.
*
* Given that it only renders elements within its viewport, it can hold large
* collections of elements and stay very performant. The performance bottleneck
* usually lies within the user's rendering code for each element.
*
* @remarks It is a low-level widget, not meant to be used directly. Refer to the
* List widget instead.
*/
var ListView = class ListView {
	static {
		this.InstanceCount = 0;
	}
	get contentHeight() {
		return this.rangeMap.size;
	}
	get onDidScroll() {
		return this.scrollableElement.onScroll;
	}
	get scrollableElementDomNode() {
		return this.scrollableElement.getDomNode();
	}
	get horizontalScrolling() {
		return this._horizontalScrolling;
	}
	set horizontalScrolling(value) {
		if (value === this._horizontalScrolling) return;
		if (value && this.supportDynamicHeights) throw new Error("Horizontal scrolling and dynamic heights not supported simultaneously");
		this._horizontalScrolling = value;
		this.domNode.classList.toggle("horizontal-scrolling", this._horizontalScrolling);
		if (this._horizontalScrolling) {
			this.measureItemWidths(this.items);
			this.updateScrollWidth();
			this.scrollableElement.setScrollDimensions({ width: getContentWidth(this.domNode) });
			this.rowsContainer.style.width = `${Math.max(this.scrollWidth || 0, this.renderWidth)}px`;
		} else {
			this.scrollableElementWidthDelayer.cancel();
			this.scrollableElement.setScrollDimensions({
				width: this.renderWidth,
				scrollWidth: this.renderWidth
			});
			this.rowsContainer.style.width = "";
			this.domNode.style.removeProperty("--list-scroll-right-offset");
		}
	}
	constructor(container, virtualDelegate, renderers, options = DefaultOptions$1) {
		this.virtualDelegate = virtualDelegate;
		this.domId = `list_id_${++ListView.InstanceCount}`;
		this.renderers = /* @__PURE__ */ new Map();
		this.renderWidth = 0;
		this._scrollHeight = 0;
		this.scrollableElementUpdateDisposable = null;
		this.scrollableElementWidthDelayer = new Delayer(50);
		this.splicing = false;
		this.dragOverAnimationStopDisposable = Disposable.None;
		this.dragOverMouseY = 0;
		this.disposables = new DisposableStore();
		this.canDrop = false;
		this.currentDragFeedbackDisposable = Disposable.None;
		this.onDragLeaveTimeout = Disposable.None;
		this.currentSelectionDisposable = this.disposables.add(new MutableDisposable());
		this.currentSelectionMovementDisposable = this.disposables.add(new MutableDisposable());
		this._onDidChangeContentHeight = this.disposables.add(new Emitter$1());
		this._onDidChangeContentWidth = this.disposables.add(new Emitter$1());
		this.onDidChangeContentHeight = Event.latch(this._onDidChangeContentHeight.event, void 0, this.disposables);
		this._horizontalScrolling = false;
		if (options.horizontalScrolling && options.supportDynamicHeights) throw new Error("Horizontal scrolling and dynamic heights not supported simultaneously");
		this.items = [];
		this.itemId = 0;
		this.rangeMap = this.createRangeMap(options.paddingTop ?? 0);
		for (const renderer of renderers) this.renderers.set(renderer.templateId, renderer);
		this.cache = this.disposables.add(new RowCache(this.renderers));
		this.lastRenderTop = 0;
		this.lastRenderHeight = 0;
		this.domNode = document.createElement("div");
		this.domNode.className = "monaco-list";
		this.domNode.classList.add(this.domId);
		this.domNode.tabIndex = 0;
		this.domNode.classList.toggle("mouse-support", typeof options.mouseSupport === "boolean" ? options.mouseSupport : true);
		this._horizontalScrolling = options.horizontalScrolling ?? DefaultOptions$1.horizontalScrolling;
		this.domNode.classList.toggle("horizontal-scrolling", this._horizontalScrolling);
		this.paddingBottom = typeof options.paddingBottom === "undefined" ? 0 : options.paddingBottom;
		this.accessibilityProvider = new ListViewAccessibilityProvider(options.accessibilityProvider);
		this.rowsContainer = document.createElement("div");
		this.rowsContainer.className = "monaco-list-rows";
		if (options.transformOptimization ?? DefaultOptions$1.transformOptimization) {
			this.rowsContainer.style.transform = "translate3d(0px, 0px, 0px)";
			this.rowsContainer.style.overflow = "hidden";
			this.rowsContainer.style.contain = "strict";
		}
		this.disposables.add(Gesture.addTarget(this.rowsContainer));
		this.scrollable = this.disposables.add(new Scrollable({
			forceIntegerValues: true,
			smoothScrollDuration: options.smoothScrolling ?? false ? 125 : 0,
			scheduleAtNextAnimationFrame: (cb) => scheduleAtNextAnimationFrame(getWindow(this.domNode), cb)
		}));
		this.scrollableElement = this.disposables.add(new SmoothScrollableElement(this.rowsContainer, {
			alwaysConsumeMouseWheel: options.alwaysConsumeMouseWheel ?? DefaultOptions$1.alwaysConsumeMouseWheel,
			horizontal: 1,
			vertical: options.verticalScrollMode ?? DefaultOptions$1.verticalScrollMode,
			useShadows: options.useShadows ?? DefaultOptions$1.useShadows,
			mouseWheelScrollSensitivity: options.mouseWheelScrollSensitivity,
			fastScrollSensitivity: options.fastScrollSensitivity,
			scrollByPage: options.scrollByPage
		}, this.scrollable));
		this.domNode.appendChild(this.scrollableElement.getDomNode());
		container.appendChild(this.domNode);
		this.scrollableElement.onScroll(this.onScroll, this, this.disposables);
		this.disposables.add(addDisposableListener(this.rowsContainer, EventType.Change, (e) => this.onTouchChange(e)));
		this.disposables.add(addDisposableListener(this.scrollableElement.getDomNode(), "scroll", (e) => {
			const element = e.target;
			const scrollValue = element.scrollTop;
			element.scrollTop = 0;
			if (options.scrollToActiveElement) this.setScrollTop(this.scrollTop + scrollValue);
		}));
		this.disposables.add(addDisposableListener(this.domNode, "dragover", (e) => this.onDragOver(this.toDragEvent(e))));
		this.disposables.add(addDisposableListener(this.domNode, "drop", (e) => this.onDrop(this.toDragEvent(e))));
		this.disposables.add(addDisposableListener(this.domNode, "dragleave", (e) => this.onDragLeave(this.toDragEvent(e))));
		this.disposables.add(addDisposableListener(this.domNode, "dragend", (e) => this.onDragEnd(e)));
		if (options.userSelection) {
			if (options.dnd) throw new Error("DND and user selection cannot be used simultaneously");
			this.disposables.add(addDisposableListener(this.domNode, "mousedown", (e) => this.onPotentialSelectionStart(e)));
		}
		this.setRowLineHeight = options.setRowLineHeight ?? DefaultOptions$1.setRowLineHeight;
		this.setRowHeight = options.setRowHeight ?? DefaultOptions$1.setRowHeight;
		this.supportDynamicHeights = options.supportDynamicHeights ?? DefaultOptions$1.supportDynamicHeights;
		this.dnd = options.dnd ?? this.disposables.add(DefaultOptions$1.dnd);
		this.layout(options.initialSize?.height, options.initialSize?.width);
		if (options.scrollToActiveElement) this._setupFocusObserver(container);
	}
	_setupFocusObserver(container) {
		this.disposables.add(addDisposableListener(container, "focus", () => {
			const element = getActiveElement();
			if (this.activeElement !== element && element !== null) {
				this.activeElement = element;
				this._scrollToActiveElement(this.activeElement, container);
			}
		}, true));
	}
	_scrollToActiveElement(element, container) {
		const containerRect = container.getBoundingClientRect();
		const topOffset = element.getBoundingClientRect().top - containerRect.top;
		if (topOffset < 0) this.setScrollTop(this.scrollTop + topOffset);
	}
	updateOptions(options) {
		if (options.paddingBottom !== void 0) {
			this.paddingBottom = options.paddingBottom;
			this.scrollableElement.setScrollDimensions({ scrollHeight: this.scrollHeight });
		}
		if (options.smoothScrolling !== void 0) this.scrollable.setSmoothScrollDuration(options.smoothScrolling ? 125 : 0);
		if (options.horizontalScrolling !== void 0) this.horizontalScrolling = options.horizontalScrolling;
		let scrollableOptions;
		if (options.scrollByPage !== void 0) scrollableOptions = {
			...scrollableOptions ?? {},
			scrollByPage: options.scrollByPage
		};
		if (options.mouseWheelScrollSensitivity !== void 0) scrollableOptions = {
			...scrollableOptions ?? {},
			mouseWheelScrollSensitivity: options.mouseWheelScrollSensitivity
		};
		if (options.fastScrollSensitivity !== void 0) scrollableOptions = {
			...scrollableOptions ?? {},
			fastScrollSensitivity: options.fastScrollSensitivity
		};
		if (scrollableOptions) this.scrollableElement.updateOptions(scrollableOptions);
		if (options.paddingTop !== void 0 && options.paddingTop !== this.rangeMap.paddingTop) {
			const lastRenderRange = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight);
			const offset = options.paddingTop - this.rangeMap.paddingTop;
			this.rangeMap.paddingTop = options.paddingTop;
			this.render(lastRenderRange, Math.max(0, this.lastRenderTop + offset), this.lastRenderHeight, void 0, void 0, true);
			this.setScrollTop(this.lastRenderTop);
			this.eventuallyUpdateScrollDimensions();
			if (this.supportDynamicHeights) this._rerender(this.lastRenderTop, this.lastRenderHeight);
		}
	}
	updateElementHeight(index, size, anchorIndex) {
		if (index < 0 || index >= this.items.length) return;
		const originalSize = this.items[index].size;
		if (typeof size === "undefined") {
			if (!this.supportDynamicHeights) {
				console.warn("Dynamic heights not supported", (/* @__PURE__ */ new Error()).stack);
				return;
			}
			this.items[index].lastDynamicHeightWidth = void 0;
			size = originalSize + this.probeDynamicHeight(index);
		}
		if (originalSize === size) return;
		const lastRenderRange = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight);
		let heightDiff = 0;
		if (index < lastRenderRange.start) heightDiff = size - originalSize;
		else if (anchorIndex !== null && anchorIndex > index && anchorIndex < lastRenderRange.end) heightDiff = size - originalSize;
		else heightDiff = 0;
		this.rangeMap.splice(index, 1, [{ size }]);
		this.items[index].size = size;
		this.render(lastRenderRange, Math.max(0, this.lastRenderTop + heightDiff), this.lastRenderHeight, void 0, void 0, true);
		this.setScrollTop(this.lastRenderTop);
		this.eventuallyUpdateScrollDimensions();
		if (this.supportDynamicHeights) this._rerender(this.lastRenderTop, this.lastRenderHeight);
		else this._onDidChangeContentHeight.fire(this.contentHeight);
	}
	createRangeMap(paddingTop) {
		return new RangeMap(paddingTop);
	}
	splice(start, deleteCount, elements = []) {
		if (this.splicing) throw new Error("Can't run recursive splices.");
		this.splicing = true;
		try {
			return this._splice(start, deleteCount, elements);
		} finally {
			this.splicing = false;
			this._onDidChangeContentHeight.fire(this.contentHeight);
		}
	}
	_splice(start, deleteCount, elements = []) {
		const previousRenderRange = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight);
		const deleteRange = {
			start,
			end: start + deleteCount
		};
		const removeRange = Range$1.intersect(previousRenderRange, deleteRange);
		const rowsToDispose = /* @__PURE__ */ new Map();
		for (let i = removeRange.end - 1; i >= removeRange.start; i--) {
			const item = this.items[i];
			item.dragStartDisposable.dispose();
			item.checkedDisposable.dispose();
			if (item.row) {
				let rows = rowsToDispose.get(item.templateId);
				if (!rows) {
					rows = [];
					rowsToDispose.set(item.templateId, rows);
				}
				const renderer = this.renderers.get(item.templateId);
				if (renderer && renderer.disposeElement) renderer.disposeElement(item.element, i, item.row.templateData, { height: item.size });
				rows.unshift(item.row);
			}
			item.row = null;
			item.stale = true;
		}
		const previousRestRange = {
			start: start + deleteCount,
			end: this.items.length
		};
		const previousRenderedRestRange = Range$1.intersect(previousRestRange, previousRenderRange);
		const previousUnrenderedRestRanges = Range$1.relativeComplement(previousRestRange, previousRenderRange);
		const inserted = elements.map((element) => ({
			id: String(this.itemId++),
			element,
			templateId: this.virtualDelegate.getTemplateId(element),
			size: this.virtualDelegate.getHeight(element),
			width: void 0,
			hasDynamicHeight: !!this.virtualDelegate.hasDynamicHeight && this.virtualDelegate.hasDynamicHeight(element),
			lastDynamicHeightWidth: void 0,
			row: null,
			uri: void 0,
			dropTarget: false,
			dragStartDisposable: Disposable.None,
			checkedDisposable: Disposable.None,
			stale: false
		}));
		let deleted;
		if (start === 0 && deleteCount >= this.items.length) {
			this.rangeMap = this.createRangeMap(this.rangeMap.paddingTop);
			this.rangeMap.splice(0, 0, inserted);
			deleted = this.items;
			this.items = inserted;
		} else {
			this.rangeMap.splice(start, deleteCount, inserted);
			deleted = splice$1(this.items, start, deleteCount, inserted);
		}
		const delta = elements.length - deleteCount;
		const renderRange = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight);
		const renderedRestRange = shift(previousRenderedRestRange, delta);
		const updateRange = Range$1.intersect(renderRange, renderedRestRange);
		for (let i = updateRange.start; i < updateRange.end; i++) if (this.items[i].row) this.updateItemInDOM(this.items[i], i);
		const removeRanges = Range$1.relativeComplement(renderedRestRange, renderRange);
		for (const range of removeRanges) for (let i = range.start; i < range.end; i++) this.removeItemFromDOM(i);
		const unrenderedRestRanges = previousUnrenderedRestRanges.map((r) => shift(r, delta));
		const insertRanges = [{
			start,
			end: start + elements.length
		}, ...unrenderedRestRanges].map((r) => Range$1.intersect(renderRange, r)).reverse();
		const insertedItems = [];
		for (const range of insertRanges) for (let i = range.end - 1; i >= range.start; i--) {
			const item = this.items[i];
			const row = rowsToDispose.get(item.templateId)?.pop();
			this.insertItemInDOM(i, row);
			insertedItems.push(item);
		}
		for (const rows of rowsToDispose.values()) for (const row of rows) this.cache.release(row);
		if (this.horizontalScrolling && insertedItems.length > 0) {
			this.measureItemWidths(insertedItems);
			this.eventuallyUpdateScrollWidth();
		}
		this.eventuallyUpdateScrollDimensions();
		if (this.supportDynamicHeights) this._rerender(this.scrollTop, this.renderHeight);
		return deleted.map((i) => i.element);
	}
	eventuallyUpdateScrollDimensions() {
		this._scrollHeight = this.contentHeight;
		this.rowsContainer.style.height = `${this._scrollHeight}px`;
		if (!this.scrollableElementUpdateDisposable) this.scrollableElementUpdateDisposable = scheduleAtNextAnimationFrame(getWindow(this.domNode), () => {
			this.scrollableElement.setScrollDimensions({ scrollHeight: this.scrollHeight });
			this.updateScrollWidth();
			this.scrollableElementUpdateDisposable = null;
		});
	}
	eventuallyUpdateScrollWidth() {
		if (!this.horizontalScrolling) {
			this.scrollableElementWidthDelayer.cancel();
			return;
		}
		this.scrollableElementWidthDelayer.trigger(() => this.updateScrollWidth());
	}
	updateScrollWidth() {
		if (!this.horizontalScrolling) return;
		let scrollWidth = 0;
		for (const item of this.items) if (typeof item.width !== "undefined") scrollWidth = Math.max(scrollWidth, item.width);
		this.scrollWidth = scrollWidth;
		this.scrollableElement.setScrollDimensions({ scrollWidth: scrollWidth === 0 ? 0 : scrollWidth + 10 });
		this._onDidChangeContentWidth.fire(this.scrollWidth);
	}
	rerender() {
		if (!this.supportDynamicHeights) return;
		for (const item of this.items) item.lastDynamicHeightWidth = void 0;
		this._rerender(this.lastRenderTop, this.lastRenderHeight);
	}
	get length() {
		return this.items.length;
	}
	get renderHeight() {
		return this.scrollableElement.getScrollDimensions().height;
	}
	get firstVisibleIndex() {
		return this.getVisibleRange(this.lastRenderTop, this.lastRenderHeight).start;
	}
	element(index) {
		return this.items[index].element;
	}
	indexOf(element) {
		return this.items.findIndex((item) => item.element === element);
	}
	domElement(index) {
		const row = this.items[index].row;
		return row && row.domNode;
	}
	elementHeight(index) {
		return this.items[index].size;
	}
	elementTop(index) {
		return this.rangeMap.positionAt(index);
	}
	indexAt(position) {
		return this.rangeMap.indexAt(position);
	}
	indexAfter(position) {
		return this.rangeMap.indexAfter(position);
	}
	layout(height, width) {
		const scrollDimensions = { height: typeof height === "number" ? height : getContentHeight(this.domNode) };
		if (this.scrollableElementUpdateDisposable) {
			this.scrollableElementUpdateDisposable.dispose();
			this.scrollableElementUpdateDisposable = null;
			scrollDimensions.scrollHeight = this.scrollHeight;
		}
		this.scrollableElement.setScrollDimensions(scrollDimensions);
		if (typeof width !== "undefined") {
			this.renderWidth = width;
			if (this.supportDynamicHeights) this._rerender(this.scrollTop, this.renderHeight);
		}
		if (this.horizontalScrolling) {
			this.scrollableElement.setScrollDimensions({ width: typeof width === "number" ? width : getContentWidth(this.domNode) });
			const scrollPos = this.scrollableElement.getScrollPosition();
			const scrollDims = this.scrollableElement.getScrollDimensions();
			const rightOffset = Math.max(0, scrollDims.scrollWidth - scrollPos.scrollLeft - this.renderWidth);
			this.domNode.style.setProperty("--list-scroll-right-offset", `${Math.max(rightOffset - 12, 0)}px`);
		}
	}
	render(previousRenderRange, renderTop, renderHeight, renderLeft, scrollWidth, updateItemsInDOM = false, onScroll = false) {
		const renderRange = this.getRenderRange(renderTop, renderHeight);
		const rangesToInsert = Range$1.relativeComplement(renderRange, previousRenderRange).reverse();
		const rangesToRemove = Range$1.relativeComplement(previousRenderRange, renderRange);
		if (updateItemsInDOM) {
			const rangesToUpdate = Range$1.intersect(previousRenderRange, renderRange);
			for (let i = rangesToUpdate.start; i < rangesToUpdate.end; i++) this.updateItemInDOM(this.items[i], i);
		}
		const insertedItems = [];
		this.cache.transact(() => {
			for (const range of rangesToRemove) for (let i = range.start; i < range.end; i++) this.removeItemFromDOM(i, onScroll);
			for (const range of rangesToInsert) for (let i = range.end - 1; i >= range.start; i--) {
				this.insertItemInDOM(i);
				insertedItems.push(this.items[i]);
			}
		});
		if (this.horizontalScrolling && insertedItems.length > 0) {
			this.measureItemWidths(insertedItems);
			this.eventuallyUpdateScrollWidth();
		}
		if (renderLeft !== void 0) this.rowsContainer.style.left = `-${renderLeft}px`;
		this.rowsContainer.style.top = `-${renderTop}px`;
		if (this.horizontalScrolling && scrollWidth !== void 0) {
			this.rowsContainer.style.width = `${Math.max(scrollWidth, this.renderWidth)}px`;
			const rightOffset = Math.max(0, scrollWidth - (renderLeft ?? 0) - this.renderWidth);
			this.domNode.style.setProperty("--list-scroll-right-offset", `${Math.max(rightOffset - 12, 0)}px`);
		}
		this.lastRenderTop = renderTop;
		this.lastRenderHeight = renderHeight;
	}
	insertItemInDOM(index, row, alreadyRendered = false) {
		const item = this.items[index];
		if (!item.row) {
			if (row) {
				item.row = row;
				item.stale = true;
			} else {
				const result = this.cache.alloc(item.templateId);
				item.row = result.row;
				item.stale ||= result.isReusingConnectedDomNode;
			}
		}
		const role = this.accessibilityProvider.getRole(item.element) || "listitem";
		item.row.domNode.setAttribute("role", role);
		const checked = this.accessibilityProvider.isChecked(item.element);
		const toAriaState = (value) => value === "mixed" ? "mixed" : String(!!value);
		if (typeof checked === "boolean" || checked === "mixed") item.row.domNode.setAttribute("aria-checked", toAriaState(checked));
		else if (checked) {
			const update = (value) => item.row.domNode.setAttribute("aria-checked", toAriaState(value));
			update(checked.value);
			item.checkedDisposable = checked.onDidChange(() => update(checked.value));
		}
		if (item.stale || !item.row.domNode.parentElement) {
			const referenceNode = this.items.at(index + 1)?.row?.domNode ?? null;
			if (item.row.domNode.parentElement !== this.rowsContainer || item.row.domNode.nextElementSibling !== referenceNode) this.rowsContainer.insertBefore(item.row.domNode, referenceNode);
			item.stale = false;
		}
		this.updateItemInDOM(item, index);
		const renderer = this.renderers.get(item.templateId);
		if (!renderer) throw new Error(`No renderer found for template id ${item.templateId}`);
		if (!alreadyRendered) renderer.renderElement(item.element, index, item.row.templateData, { height: item.size });
		const uri = this.dnd.getDragURI(item.element);
		item.dragStartDisposable.dispose();
		item.row.domNode.draggable = !!uri;
		if (uri) item.dragStartDisposable = addDisposableListener(item.row.domNode, "dragstart", (event) => this.onDragStart(item.element, uri, event));
	}
	measureItemWidths(items) {
		const itemsWithRows = [];
		for (const item of items) if (item.row) itemsWithRows.push({
			item,
			domNode: item.row.domNode
		});
		for (const { domNode } of itemsWithRows) domNode.style.width = "fit-content";
		for (const { item, domNode } of itemsWithRows) {
			item.width = getContentWidth(domNode);
			const style = getWindow(domNode).getComputedStyle(domNode);
			if (style.paddingLeft) item.width += parseFloat(style.paddingLeft);
			if (style.paddingRight) item.width += parseFloat(style.paddingRight);
		}
		for (const { domNode } of itemsWithRows) domNode.style.width = "";
	}
	updateItemInDOM(item, index) {
		item.row.domNode.style.top = `${this.elementTop(index)}px`;
		if (this.setRowHeight) item.row.domNode.style.height = `${item.size}px`;
		if (this.setRowLineHeight) item.row.domNode.style.lineHeight = `${item.size}px`;
		item.row.domNode.setAttribute("data-index", `${index}`);
		item.row.domNode.setAttribute("data-last-element", index === this.length - 1 ? "true" : "false");
		item.row.domNode.setAttribute("data-parity", index % 2 === 0 ? "even" : "odd");
		item.row.domNode.setAttribute("aria-setsize", String(this.accessibilityProvider.getSetSize(item.element, index, this.length)));
		item.row.domNode.setAttribute("aria-posinset", String(this.accessibilityProvider.getPosInSet(item.element, index)));
		item.row.domNode.setAttribute("id", this.getElementDomId(index));
		item.row.domNode.classList.toggle("drop-target", item.dropTarget);
	}
	removeItemFromDOM(index, onScroll) {
		const item = this.items[index];
		item.dragStartDisposable.dispose();
		item.checkedDisposable.dispose();
		if (item.row) {
			const renderer = this.renderers.get(item.templateId);
			if (renderer && renderer.disposeElement) renderer.disposeElement(item.element, index, item.row.templateData, {
				height: item.size,
				onScroll
			});
			this.cache.release(item.row);
			item.row = null;
		}
		if (this.horizontalScrolling) this.eventuallyUpdateScrollWidth();
	}
	getScrollTop() {
		return this.scrollableElement.getScrollPosition().scrollTop;
	}
	setScrollTop(scrollTop, reuseAnimation) {
		if (this.scrollableElementUpdateDisposable) {
			this.scrollableElementUpdateDisposable.dispose();
			this.scrollableElementUpdateDisposable = null;
			this.scrollableElement.setScrollDimensions({ scrollHeight: this.scrollHeight });
		}
		this.scrollableElement.setScrollPosition({
			scrollTop,
			reuseAnimation
		});
	}
	get scrollTop() {
		return this.getScrollTop();
	}
	set scrollTop(scrollTop) {
		this.setScrollTop(scrollTop);
	}
	get scrollHeight() {
		return this._scrollHeight + (this.horizontalScrolling ? 10 : 0) + this.paddingBottom;
	}
	get onMouseClick() {
		return Event.map(this.disposables.add(new DomEmitter(this.domNode, "click")).event, (e) => this.toMouseEvent(e), this.disposables);
	}
	get onMouseDblClick() {
		return Event.map(this.disposables.add(new DomEmitter(this.domNode, "dblclick")).event, (e) => this.toMouseEvent(e), this.disposables);
	}
	get onMouseMiddleClick() {
		return Event.filter(Event.map(this.disposables.add(new DomEmitter(this.domNode, "auxclick")).event, (e) => this.toMouseEvent(e), this.disposables), (e) => e.browserEvent.button === 1, this.disposables);
	}
	get onMouseDown() {
		return Event.map(this.disposables.add(new DomEmitter(this.domNode, "mousedown")).event, (e) => this.toMouseEvent(e), this.disposables);
	}
	get onMouseOver() {
		return Event.map(this.disposables.add(new DomEmitter(this.domNode, "mouseover")).event, (e) => this.toMouseEvent(e), this.disposables);
	}
	get onMouseMove() {
		return Event.map(this.disposables.add(new DomEmitter(this.domNode, "mousemove")).event, (e) => this.toMouseEvent(e), this.disposables);
	}
	get onMouseOut() {
		return Event.map(this.disposables.add(new DomEmitter(this.domNode, "mouseout")).event, (e) => this.toMouseEvent(e), this.disposables);
	}
	get onContextMenu() {
		return Event.any(Event.map(this.disposables.add(new DomEmitter(this.domNode, "contextmenu")).event, (e) => this.toMouseEvent(e), this.disposables), Event.map(this.disposables.add(new DomEmitter(this.domNode, EventType.Contextmenu)).event, (e) => this.toGestureEvent(e), this.disposables));
	}
	get onTouchStart() {
		return Event.map(this.disposables.add(new DomEmitter(this.domNode, "touchstart")).event, (e) => this.toTouchEvent(e), this.disposables);
	}
	get onTap() {
		return Event.map(this.disposables.add(new DomEmitter(this.rowsContainer, EventType.Tap)).event, (e) => this.toGestureEvent(e), this.disposables);
	}
	toMouseEvent(browserEvent) {
		const index = this.getItemIndexFromEventTarget(browserEvent.target || null);
		const item = typeof index === "undefined" ? void 0 : this.items[index];
		return {
			browserEvent,
			index,
			element: item && item.element
		};
	}
	toTouchEvent(browserEvent) {
		const index = this.getItemIndexFromEventTarget(browserEvent.target || null);
		const item = typeof index === "undefined" ? void 0 : this.items[index];
		return {
			browserEvent,
			index,
			element: item && item.element
		};
	}
	toGestureEvent(browserEvent) {
		const index = this.getItemIndexFromEventTarget(browserEvent.initialTarget || null);
		const item = typeof index === "undefined" ? void 0 : this.items[index];
		return {
			browserEvent,
			index,
			element: item && item.element
		};
	}
	toDragEvent(browserEvent) {
		const index = this.getItemIndexFromEventTarget(browserEvent.target || null);
		const item = typeof index === "undefined" ? void 0 : this.items[index];
		return {
			browserEvent,
			index,
			element: item && item.element,
			sector: this.getTargetSector(browserEvent, index)
		};
	}
	onScroll(e) {
		try {
			const previousRenderRange = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight);
			this.render(previousRenderRange, e.scrollTop, e.height, e.scrollLeft, e.scrollWidth, void 0, true);
			if (this.supportDynamicHeights) this._rerender(e.scrollTop, e.height, e.inSmoothScrolling);
		} catch (err) {
			console.error("Got bad scroll event:", e);
			throw err;
		}
	}
	onTouchChange(event) {
		event.preventDefault();
		event.stopPropagation();
		this.scrollTop -= event.translationY;
	}
	onDragStart(element, uri, event) {
		if (!event.dataTransfer) return;
		const elements = this.dnd.getDragElements(element);
		event.dataTransfer.effectAllowed = "copyMove";
		event.dataTransfer.setData(DataTransfers.TEXT, uri);
		let label;
		if (this.dnd.getDragLabel) label = this.dnd.getDragLabel(elements, event);
		if (typeof label === "undefined") label = String(elements.length);
		applyDragImage(event, this.domNode, label, [this.domId]);
		this.domNode.classList.add("dragging");
		this.currentDragData = new ElementsDragAndDropData(elements);
		StaticDND.CurrentDragAndDropData = new ExternalElementsDragAndDropData(elements);
		this.dnd.onDragStart?.(this.currentDragData, event);
	}
	onPotentialSelectionStart(e) {
		const doc = getDocument(this.domNode);
		this.currentSelectionMovementDisposable.clear();
		if (e.shiftKey && this.currentSelectionBounds && doc.getSelection()?.isCollapsed === false) {
			this.currentSelectionMovementDisposable.value = this.createSelectionMovementStore(doc);
			return;
		}
		this.currentSelectionDisposable.clear();
		const selectionStore = new DisposableStore();
		this.currentSelectionDisposable.value = selectionStore;
		this.currentSelectionMovementDisposable.value = this.createSelectionMovementStore(doc);
		selectionStore.add(toDisposable(() => {
			this.currentSelectionMovementDisposable.clear();
			const previousRenderRange = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight);
			this.currentSelectionBounds = void 0;
			this.render(previousRenderRange, this.lastRenderTop, this.lastRenderHeight, void 0, void 0);
		}));
		selectionStore.add(addDisposableListener(doc, "selectionchange", () => {
			const selection = doc.getSelection();
			if (!selection || selection.isCollapsed) {
				if (!this.currentSelectionMovementDisposable.value) this.currentSelectionDisposable.clear();
				return;
			}
			let start = this.getIndexOfListElement(selection.anchorNode);
			let end = this.getIndexOfListElement(selection.focusNode);
			if (start !== void 0 && end !== void 0) {
				if (end < start) [start, end] = [end, start];
				this.currentSelectionBounds = {
					start,
					end
				};
			}
		}));
	}
	createSelectionMovementStore(doc) {
		const movementStore = new DisposableStore();
		movementStore.add(addDisposableListener(this.domNode, "selectstart", () => {
			movementStore.add(addDisposableListener(doc, "mousemove", (e) => {
				if (doc.getSelection()?.isCollapsed === false) this.setupDragAndDropScrollTopAnimation(e);
			}));
		}));
		movementStore.add(addDisposableListener(doc, "mouseup", () => {
			this.currentSelectionMovementDisposable.clear();
			this.teardownDragAndDropScrollTopAnimation();
			if (doc.getSelection()?.isCollapsed !== false) this.currentSelectionDisposable.clear();
		}));
		return movementStore;
	}
	getIndexOfListElement(element) {
		if (!element || !this.domNode.contains(element)) return;
		while (element && element !== this.domNode) {
			if (element.dataset?.index) return Number(element.dataset.index);
			element = element.parentElement;
		}
	}
	onDragOver(event) {
		event.browserEvent.preventDefault();
		this.onDragLeaveTimeout.dispose();
		if (StaticDND.CurrentDragAndDropData && StaticDND.CurrentDragAndDropData.getData() === "vscode-ui") return false;
		this.setupDragAndDropScrollTopAnimation(event.browserEvent);
		if (!event.browserEvent.dataTransfer) return false;
		if (!this.currentDragData) {
			if (StaticDND.CurrentDragAndDropData) this.currentDragData = StaticDND.CurrentDragAndDropData;
			else {
				if (!event.browserEvent.dataTransfer.types) return false;
				this.currentDragData = new NativeDragAndDropData();
			}
		}
		const result = this.dnd.onDragOver(this.currentDragData, event.element, event.index, event.sector, event.browserEvent);
		this.canDrop = typeof result === "boolean" ? result : result.accept;
		if (!this.canDrop) {
			this.currentDragFeedback = void 0;
			this.currentDragFeedbackDisposable.dispose();
			return false;
		}
		event.browserEvent.dataTransfer.dropEffect = typeof result !== "boolean" && result.effect?.type === 0 ? "copy" : "move";
		let feedback;
		if (typeof result !== "boolean" && result.feedback) feedback = result.feedback;
		else if (typeof event.index === "undefined") feedback = [-1];
		else feedback = [event.index];
		feedback = distinct(feedback).filter((i) => i >= -1 && i < this.length).sort((a, b) => a - b);
		feedback = feedback[0] === -1 ? [-1] : feedback;
		let dragOverEffectPosition = typeof result !== "boolean" && result.effect && result.effect.position ? result.effect.position : "drop-target";
		if (equalsDragFeedback(this.currentDragFeedback, feedback) && this.currentDragFeedbackPosition === dragOverEffectPosition) return true;
		this.currentDragFeedback = feedback;
		this.currentDragFeedbackPosition = dragOverEffectPosition;
		this.currentDragFeedbackDisposable.dispose();
		if (feedback[0] === -1) {
			this.domNode.classList.add(dragOverEffectPosition);
			this.rowsContainer.classList.add(dragOverEffectPosition);
			this.currentDragFeedbackDisposable = toDisposable(() => {
				this.domNode.classList.remove(dragOverEffectPosition);
				this.rowsContainer.classList.remove(dragOverEffectPosition);
			});
		} else {
			if (feedback.length > 1 && dragOverEffectPosition !== "drop-target") throw new Error("Can't use multiple feedbacks with position different than 'over'");
			if (dragOverEffectPosition === "drop-target-after") {
				if (feedback[0] < this.length - 1) {
					feedback[0] += 1;
					dragOverEffectPosition = "drop-target-before";
				}
			}
			for (const index of feedback) {
				const item = this.items[index];
				item.dropTarget = true;
				item.row?.domNode.classList.add(dragOverEffectPosition);
			}
			this.currentDragFeedbackDisposable = toDisposable(() => {
				for (const index of feedback) {
					const item = this.items[index];
					item.dropTarget = false;
					item.row?.domNode.classList.remove(dragOverEffectPosition);
				}
			});
		}
		return true;
	}
	onDragLeave(event) {
		this.onDragLeaveTimeout.dispose();
		this.onDragLeaveTimeout = disposableTimeout(() => this.clearDragOverFeedback(), 100, this.disposables);
		if (this.currentDragData) this.dnd.onDragLeave?.(this.currentDragData, event.element, event.index, event.browserEvent);
	}
	onDrop(event) {
		if (!this.canDrop) return;
		const dragData = this.currentDragData;
		this.teardownDragAndDropScrollTopAnimation();
		this.clearDragOverFeedback();
		this.domNode.classList.remove("dragging");
		this.currentDragData = void 0;
		StaticDND.CurrentDragAndDropData = void 0;
		if (!dragData || !event.browserEvent.dataTransfer) return;
		event.browserEvent.preventDefault();
		dragData.update(event.browserEvent.dataTransfer);
		this.dnd.drop(dragData, event.element, event.index, event.sector, event.browserEvent);
	}
	onDragEnd(event) {
		this.canDrop = false;
		this.teardownDragAndDropScrollTopAnimation();
		this.clearDragOverFeedback();
		this.domNode.classList.remove("dragging");
		this.currentDragData = void 0;
		StaticDND.CurrentDragAndDropData = void 0;
		this.dnd.onDragEnd?.(event);
	}
	clearDragOverFeedback() {
		this.currentDragFeedback = void 0;
		this.currentDragFeedbackPosition = void 0;
		this.currentDragFeedbackDisposable.dispose();
		this.currentDragFeedbackDisposable = Disposable.None;
	}
	setupDragAndDropScrollTopAnimation(event) {
		if (!this.dragOverAnimationDisposable) {
			const viewTop = getTopLeftOffset(this.domNode).top;
			this.dragOverAnimationDisposable = animate(getWindow(this.domNode), this.animateDragAndDropScrollTop.bind(this, viewTop));
		}
		this.dragOverAnimationStopDisposable.dispose();
		this.dragOverAnimationStopDisposable = disposableTimeout(() => {
			if (this.dragOverAnimationDisposable) {
				this.dragOverAnimationDisposable.dispose();
				this.dragOverAnimationDisposable = void 0;
			}
		}, 1e3, this.disposables);
		this.dragOverMouseY = event.pageY;
	}
	animateDragAndDropScrollTop(viewTop) {
		if (this.dragOverMouseY === void 0) return;
		const diff = this.dragOverMouseY - viewTop;
		const upperLimit = this.renderHeight - 35;
		if (diff < 35) this.scrollTop += Math.max(-14, Math.floor(.3 * (diff - 35)));
		else if (diff > upperLimit) this.scrollTop += Math.min(14, Math.floor(.3 * (diff - upperLimit)));
	}
	teardownDragAndDropScrollTopAnimation() {
		this.dragOverAnimationStopDisposable.dispose();
		if (this.dragOverAnimationDisposable) {
			this.dragOverAnimationDisposable.dispose();
			this.dragOverAnimationDisposable = void 0;
		}
	}
	getTargetSector(browserEvent, targetIndex) {
		if (targetIndex === void 0) return;
		const relativePosition = browserEvent.offsetY / this.items[targetIndex].size;
		return clamp(Math.floor(relativePosition / .25), 0, 3);
	}
	getItemIndexFromEventTarget(target) {
		const scrollableElement = this.scrollableElement.getDomNode();
		let element = target;
		while ((isHTMLElement(element) || isSVGElement(element)) && element !== this.rowsContainer && scrollableElement.contains(element)) {
			const rawIndex = element.getAttribute("data-index");
			if (rawIndex) {
				const index = Number(rawIndex);
				if (!isNaN(index)) return index;
			}
			element = element.parentElement;
		}
	}
	getVisibleRange(renderTop, renderHeight) {
		const start = this.rangeMap.indexAt(renderTop);
		return {
			start,
			end: Math.max(start, this.rangeMap.indexAfter(renderTop + renderHeight - 1))
		};
	}
	getRenderRange(renderTop, renderHeight) {
		const range = this.getVisibleRange(renderTop, renderHeight);
		if (this.currentSelectionBounds) {
			const max = this.rangeMap.count;
			range.start = Math.min(range.start, this.currentSelectionBounds.start, max);
			range.end = Math.min(Math.max(range.end, this.currentSelectionBounds.end + 1), max);
		}
		return range;
	}
	/**
	* Given a stable rendered state, checks every rendered element whether it needs
	* to be probed for dynamic height. Adjusts scroll height and top if necessary.
	*/
	_rerender(renderTop, renderHeight, inSmoothScrolling) {
		let previousRenderRange = this.getRenderRange(renderTop, renderHeight);
		const retainedMeasurements = /* @__PURE__ */ new Map();
		let anchorElementIndex;
		let anchorElementTopDelta;
		const updateAnchorElement = () => {
			anchorElementIndex = void 0;
			anchorElementTopDelta = void 0;
			if (renderTop === this.elementTop(previousRenderRange.start)) {
				anchorElementIndex = previousRenderRange.start;
				anchorElementTopDelta = 0;
			} else if (previousRenderRange.end - previousRenderRange.start > 1) {
				anchorElementIndex = previousRenderRange.start + 1;
				anchorElementTopDelta = this.elementTop(anchorElementIndex) - renderTop;
			}
		};
		updateAnchorElement();
		let heightDiff = 0;
		try {
			while (true) {
				const renderRange = this.getRenderRange(renderTop, renderHeight);
				let didChange = false;
				const probedItems = this.items.slice(renderRange.start, renderRange.end);
				const dynamicHeightDiffs = this.probeDynamicHeights(renderRange, retainedMeasurements);
				if (this.items.length < renderRange.end || probedItems.some((item, index) => item !== this.items[renderRange.start + index])) {
					for (let index = 0; index < probedItems.length; index++) {
						const diff = dynamicHeightDiffs[index];
						const currentIndex = this.items.indexOf(probedItems[index]);
						if (diff !== 0 && currentIndex !== -1) {
							this.rangeMap.splice(currentIndex, 1, [probedItems[index]]);
							heightDiff += diff;
						}
					}
					this.disposeDynamicHeightMeasurements(retainedMeasurements);
					previousRenderRange = this.getRenderRange(renderTop, renderHeight);
					updateAnchorElement();
					continue;
				}
				for (let i = renderRange.start; i < renderRange.end; i++) {
					const diff = dynamicHeightDiffs[i - renderRange.start];
					if (diff !== 0) this.rangeMap.splice(i, 1, [this.items[i]]);
					heightDiff += diff;
					didChange = didChange || diff !== 0;
				}
				if (!didChange) {
					if (heightDiff !== 0) this.eventuallyUpdateScrollDimensions();
					const unrenderRanges = Range$1.relativeComplement(previousRenderRange, renderRange);
					for (const range of unrenderRanges) for (let i = range.start; i < range.end; i++) if (this.items[i].row) this.removeItemFromDOM(i);
					const insertedItems = [];
					for (let i = renderRange.end - 1; i >= renderRange.start; i--) {
						const item = this.items[i];
						if (!item.row) {
							const measurement = retainedMeasurements.get(i);
							const canPromoteMeasurement = measurement?.item === item && measurement.item.templateId === item.templateId;
							if (canPromoteMeasurement) retainedMeasurements.delete(i);
							this.insertItemInDOM(i, canPromoteMeasurement ? measurement.row : void 0, canPromoteMeasurement);
							insertedItems.push(item);
						}
					}
					this.disposeDynamicHeightMeasurements(retainedMeasurements);
					if (this.horizontalScrolling && insertedItems.length > 0) {
						this.measureItemWidths(insertedItems);
						this.eventuallyUpdateScrollWidth();
					}
					for (let i = renderRange.start; i < renderRange.end; i++) if (this.items[i].row) this.updateItemInDOM(this.items[i], i);
					if (typeof anchorElementIndex === "number") {
						const deltaScrollTop = this.scrollable.getFutureScrollPosition().scrollTop - renderTop;
						const newScrollTop = this.elementTop(anchorElementIndex) - anchorElementTopDelta + deltaScrollTop;
						this.setScrollTop(newScrollTop, inSmoothScrolling);
					}
					this._onDidChangeContentHeight.fire(this.contentHeight);
					return;
				}
			}
		} finally {
			this.disposeDynamicHeightMeasurements(retainedMeasurements);
		}
	}
	probeDynamicHeight(index) {
		const item = this.items[index];
		return this.probeDynamicHeightForItem(item, index);
	}
	probeDynamicHeightForItem(item, index) {
		const delegateHeightDiff = this.probeDynamicHeightFromDelegate(item);
		if (delegateHeightDiff !== void 0) return delegateHeightDiff;
		if (!this.shouldProbeDynamicHeight(item)) return 0;
		const size = item.size;
		if (item.row) {
			item.row.domNode.style.height = "";
			item.size = item.row.domNode.offsetHeight;
			if (item.size === 0) {
				if (!isAncestor$1(item.row.domNode, getWindow(item.row.domNode).document.body)) console.warn("Measuring item node that is not in DOM! Add ListView to the DOM before measuring row height!", (/* @__PURE__ */ new Error()).stack);
				else console.warn("Measured item node at 0px- ensure that ListView is not display:none before measuring row height!", (/* @__PURE__ */ new Error()).stack);
			}
			item.lastDynamicHeightWidth = this.renderWidth;
			this.publishDynamicHeight(item);
			return item.size - size;
		}
		const { row } = this.cache.alloc(item.templateId);
		row.domNode.style.height = "";
		this.rowsContainer.appendChild(row.domNode);
		const renderer = this.renderers.get(item.templateId);
		if (!renderer) throw new BugIndicatingError("Missing renderer for templateId: " + item.templateId);
		renderer.renderElement(item.element, index, row.templateData);
		item.size = row.domNode.offsetHeight;
		renderer.disposeElement?.(item.element, index, row.templateData);
		item.lastDynamicHeightWidth = this.renderWidth;
		this.publishDynamicHeight(item);
		row.domNode.remove();
		this.cache.release(row);
		return item.size - size;
	}
	probeDynamicHeights(range, retainedMeasurements) {
		const diffs = new Array(range.end - range.start).fill(0);
		const measurements = [];
		for (let index = range.start; index < range.end; index++) {
			const item = this.items[index];
			const delegateHeightDiff = this.probeDynamicHeightFromDelegate(item);
			if (delegateHeightDiff !== void 0) {
				diffs[index - range.start] = delegateHeightDiff;
				continue;
			}
			if (!this.shouldProbeDynamicHeight(item) || retainedMeasurements.has(index)) continue;
			if (item.row) {
				item.row.domNode.style.height = "";
				measurements.push({
					item,
					index,
					previousSize: item.size,
					row: item.row,
					rendered: true
				});
				continue;
			}
			const { row } = this.cache.alloc(item.templateId);
			const measurement = {
				item,
				index,
				previousSize: item.size,
				row,
				rendered: false
			};
			retainedMeasurements.set(index, measurement);
			measurements.push(measurement);
			row.domNode.style.height = "";
			this.rowsContainer.appendChild(row.domNode);
			const renderer = this.renderers.get(item.templateId);
			if (!renderer) throw new BugIndicatingError("Missing renderer for templateId: " + item.templateId);
			measurement.rendered = true;
			renderer.renderElement(item.element, index, row.templateData, { height: item.size });
		}
		for (const measurement of measurements) measurement.item.size = measurement.row.domNode.offsetHeight;
		for (const measurement of measurements) {
			const { item, index, previousSize, row } = measurement;
			if (item.size === 0) {
				if (!isAncestor$1(row.domNode, getWindow(row.domNode).document.body)) console.warn("Measuring item node that is not in DOM! Add ListView to the DOM before measuring row height!", (/* @__PURE__ */ new Error()).stack);
				else console.warn("Measured item node at 0px- ensure that ListView is not display:none before measuring row height!", (/* @__PURE__ */ new Error()).stack);
			}
			item.lastDynamicHeightWidth = this.renderWidth;
			this.publishDynamicHeight(item);
			diffs[index - range.start] = item.size - previousSize;
		}
		return diffs;
	}
	disposeDynamicHeightMeasurements(measurements) {
		for (const [measurementIndex, { item, index, row, rendered }] of measurements) {
			measurements.delete(measurementIndex);
			try {
				if (rendered) this.renderers.get(item.templateId)?.disposeElement?.(item.element, index, row.templateData, { height: item.size });
			} finally {
				row.domNode.remove();
				this.cache.release(row);
			}
		}
	}
	probeDynamicHeightFromDelegate(item) {
		const newSize = this.virtualDelegate.getDynamicHeight?.(item.element);
		if (newSize === void 0 || newSize === null) return;
		const size = item.size;
		item.size = newSize;
		item.lastDynamicHeightWidth = this.renderWidth;
		this.publishDynamicHeight(item);
		return newSize - size;
	}
	shouldProbeDynamicHeight(item) {
		if (!item.hasDynamicHeight || item.lastDynamicHeightWidth === this.renderWidth) return false;
		return !this.virtualDelegate.hasDynamicHeight || this.virtualDelegate.hasDynamicHeight(item.element);
	}
	publishDynamicHeight(item) {
		if (item.size > 0) this.virtualDelegate.setDynamicHeight?.(item.element, item.size);
	}
	getElementDomId(index) {
		return `${this.domId}_${index}`;
	}
	dispose() {
		this.currentSelectionDisposable.clear();
		for (const item of this.items) {
			item.dragStartDisposable.dispose();
			item.checkedDisposable.dispose();
			if (item.row) {
				const renderer = this.renderers.get(item.row.templateId);
				if (renderer) {
					renderer.disposeElement?.(item.element, -1, item.row.templateData, void 0);
					renderer.disposeTemplate(item.row.templateData);
				}
			}
		}
		this.items = [];
		this.domNode?.remove();
		this.dragOverAnimationDisposable?.dispose();
		this.disposables.dispose();
	}
};
__decorate$37([memoize], ListView.prototype, "onMouseClick", null);
__decorate$37([memoize], ListView.prototype, "onMouseDblClick", null);
__decorate$37([memoize], ListView.prototype, "onMouseMiddleClick", null);
__decorate$37([memoize], ListView.prototype, "onMouseDown", null);
__decorate$37([memoize], ListView.prototype, "onMouseOver", null);
__decorate$37([memoize], ListView.prototype, "onMouseMove", null);
__decorate$37([memoize], ListView.prototype, "onMouseOut", null);
__decorate$37([memoize], ListView.prototype, "onContextMenu", null);
__decorate$37([memoize], ListView.prototype, "onTouchStart", null);
__decorate$37([memoize], ListView.prototype, "onTap", null);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/observableInternal/observables/constObservable.js
/**
* Represents an efficient observable whose value never changes.
*/
function constObservable(value) {
	return new ConstObservable(value);
}
var ConstObservable = class extends ConvenientObservable {
	constructor(value) {
		super();
		this.value = value;
	}
	get debugName() {
		return this.toString();
	}
	get() {
		return this.value;
	}
	addObserver(observer) {}
	removeObserver(observer) {}
	toString() {
		return `Const: ${this.value}`;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/list/listWidget.js
var __decorate$36 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TraitRenderer = class {
	constructor(trait) {
		this.trait = trait;
		this.renderedElements = [];
	}
	get templateId() {
		return `template:${this.trait.name}`;
	}
	renderTemplate(container) {
		return container;
	}
	renderElement(element, index, templateData) {
		const renderedElementIndex = this.renderedElements.findIndex((el) => el.templateData === templateData);
		if (renderedElementIndex >= 0) {
			const rendered = this.renderedElements[renderedElementIndex];
			this.trait.unrender(templateData);
			rendered.index = index;
		} else {
			const rendered = {
				index,
				templateData
			};
			this.renderedElements.push(rendered);
		}
		this.trait.renderIndex(index, templateData);
	}
	splice(start, deleteCount, insertCount) {
		const rendered = [];
		for (const renderedElement of this.renderedElements) if (renderedElement.index < start) rendered.push(renderedElement);
		else if (renderedElement.index >= start + deleteCount) rendered.push({
			index: renderedElement.index + insertCount - deleteCount,
			templateData: renderedElement.templateData
		});
		this.renderedElements = rendered;
	}
	renderIndexes(indexes) {
		for (const { index, templateData } of this.renderedElements) if (indexes.indexOf(index) > -1) this.trait.renderIndex(index, templateData);
	}
	disposeTemplate(templateData) {
		const index = this.renderedElements.findIndex((el) => el.templateData === templateData);
		if (index < 0) return;
		this.renderedElements.splice(index, 1);
	}
};
var Trait$1 = class {
	get onChange() {
		return this._onChange.event;
	}
	get name() {
		return this._trait;
	}
	get renderer() {
		return new TraitRenderer(this);
	}
	constructor(_trait) {
		this._trait = _trait;
		this.indexes = [];
		this.sortedIndexes = [];
		this._onChange = new Emitter$1();
	}
	splice(start, deleteCount, elements) {
		const diff = elements.length - deleteCount;
		const end = start + deleteCount;
		const sortedIndexes = [];
		let i = 0;
		while (i < this.sortedIndexes.length && this.sortedIndexes[i] < start) sortedIndexes.push(this.sortedIndexes[i++]);
		for (let j = 0; j < elements.length; j++) if (elements[j]) sortedIndexes.push(j + start);
		while (i < this.sortedIndexes.length && this.sortedIndexes[i] >= end) sortedIndexes.push(this.sortedIndexes[i++] + diff);
		this.renderer.splice(start, deleteCount, elements.length);
		this._set(sortedIndexes, sortedIndexes);
	}
	renderIndex(index, container) {
		container.classList.toggle(this._trait, this.contains(index));
	}
	unrender(container) {
		container.classList.remove(this._trait);
	}
	/**
	* Sets the indexes which should have this trait.
	*
	* @param indexes Indexes which should have this trait.
	* @return The old indexes which had this trait.
	*/
	set(indexes, browserEvent) {
		return this._set(indexes, [...indexes].sort(numericSort), browserEvent);
	}
	_set(indexes, sortedIndexes, browserEvent) {
		const result = this.indexes;
		const sortedResult = this.sortedIndexes;
		this.indexes = indexes;
		this.sortedIndexes = sortedIndexes;
		const toRender = disjunction(sortedResult, indexes);
		this.renderer.renderIndexes(toRender);
		this._onChange.fire({
			indexes,
			browserEvent
		});
		return result;
	}
	get() {
		return this.indexes;
	}
	contains(index) {
		return binarySearch(this.sortedIndexes, index, numericSort) >= 0;
	}
	dispose() {
		dispose(this._onChange);
	}
};
__decorate$36([memoize], Trait$1.prototype, "renderer", null);
var SelectionTrait = class extends Trait$1 {
	constructor(setAriaSelected) {
		super("selected");
		this.setAriaSelected = setAriaSelected;
	}
	renderIndex(index, container) {
		super.renderIndex(index, container);
		if (this.setAriaSelected) {
			if (this.contains(index)) container.setAttribute("aria-selected", "true");
			else container.setAttribute("aria-selected", "false");
		}
	}
};
/**
* The TraitSpliceable is used as a util class to be able
* to preserve traits across splice calls, given an identity
* provider.
*/
var TraitSpliceable = class {
	constructor(trait, view, identityProvider) {
		this.trait = trait;
		this.view = view;
		this.identityProvider = identityProvider;
	}
	splice(start, deleteCount, elements) {
		if (!this.identityProvider) return this.trait.splice(start, deleteCount, new Array(elements.length).fill(false));
		const pastElementsWithTrait = this.trait.get().map((i) => this.identityProvider.getId(this.view.element(i)).toString());
		if (pastElementsWithTrait.length === 0) return this.trait.splice(start, deleteCount, new Array(elements.length).fill(false));
		const pastElementsWithTraitSet = new Set(pastElementsWithTrait);
		const elementsWithTrait = elements.map((e) => pastElementsWithTraitSet.has(this.identityProvider.getId(e).toString()));
		this.trait.splice(start, deleteCount, elementsWithTrait);
	}
};
function isListElementDescendantOfClass(e, className) {
	if (e.classList.contains(className)) return true;
	if (e.classList.contains("monaco-list")) return false;
	if (!e.parentElement) return false;
	return isListElementDescendantOfClass(e.parentElement, className);
}
function isMonacoEditor(e) {
	return isListElementDescendantOfClass(e, "monaco-editor");
}
function isMonacoCustomToggle(e) {
	return isListElementDescendantOfClass(e, "monaco-custom-toggle");
}
function isActionItem(e) {
	return isListElementDescendantOfClass(e, "action-item");
}
function isStickyScrollElement(e) {
	return isListElementDescendantOfClass(e, "monaco-tree-sticky-row");
}
function isStickyScrollContainer(e) {
	return e.classList.contains("monaco-tree-sticky-container");
}
function isButton(e) {
	if (e.tagName === "A" && e.classList.contains("monaco-button") || e.tagName === "DIV" && e.classList.contains("monaco-button-dropdown")) return true;
	if (e.classList.contains("monaco-list")) return false;
	if (!e.parentElement) return false;
	return isButton(e.parentElement);
}
var KeyboardController = class {
	get onKeyDown() {
		return Event.chain(this.disposables.add(new DomEmitter(this.view.domNode, "keydown")).event, ($) => $.filter((e) => !isEditableElement(e.target)).map((e) => new StandardKeyboardEvent(e)));
	}
	constructor(list, view, options) {
		this.list = list;
		this.view = view;
		this.disposables = new DisposableStore();
		this.multipleSelectionDisposables = new DisposableStore();
		this.multipleSelectionSupport = options.multipleSelectionSupport;
		this.disposables.add(this.onKeyDown((e) => {
			switch (e.keyCode) {
				case 3: return this.onEnter(e);
				case 16: return this.onUpArrow(e);
				case 18: return this.onDownArrow(e);
				case 11: return this.onPageUpArrow(e);
				case 12: return this.onPageDownArrow(e);
				case 9: return this.onEscape(e);
				case 31: if (this.multipleSelectionSupport && (isMacintosh ? e.metaKey : e.ctrlKey)) this.onCtrlA(e);
			}
		}));
	}
	updateOptions(optionsUpdate) {
		if (optionsUpdate.multipleSelectionSupport !== void 0) this.multipleSelectionSupport = optionsUpdate.multipleSelectionSupport;
	}
	onEnter(e) {
		e.preventDefault();
		e.stopPropagation();
		this.list.setSelection(this.list.getFocus(), e.browserEvent);
	}
	onUpArrow(e) {
		e.preventDefault();
		e.stopPropagation();
		this.list.focusPrevious(1, false, e.browserEvent);
		const el = this.list.getFocus()[0];
		this.list.setAnchor(el);
		this.list.reveal(el);
		this.view.domNode.focus();
	}
	onDownArrow(e) {
		e.preventDefault();
		e.stopPropagation();
		this.list.focusNext(1, false, e.browserEvent);
		const el = this.list.getFocus()[0];
		this.list.setAnchor(el);
		this.list.reveal(el);
		this.view.domNode.focus();
	}
	onPageUpArrow(e) {
		e.preventDefault();
		e.stopPropagation();
		this.list.focusPreviousPage(e.browserEvent);
		const el = this.list.getFocus()[0];
		this.list.setAnchor(el);
		this.list.reveal(el);
		this.view.domNode.focus();
	}
	onPageDownArrow(e) {
		e.preventDefault();
		e.stopPropagation();
		this.list.focusNextPage(e.browserEvent);
		const el = this.list.getFocus()[0];
		this.list.setAnchor(el);
		this.list.reveal(el);
		this.view.domNode.focus();
	}
	onCtrlA(e) {
		e.preventDefault();
		e.stopPropagation();
		let selection = range(this.list.length);
		const focusedElements = this.list.getFocus();
		const referenceGroupId = focusedElements.length > 0 ? this.list.getElementGroupId(focusedElements[0]) : void 0;
		if (referenceGroupId !== void 0) selection = this.list.filterIndicesByGroup(selection, referenceGroupId);
		this.list.setSelection(selection, e.browserEvent);
		this.list.setAnchor(void 0);
		this.view.domNode.focus();
	}
	onEscape(e) {
		if (this.list.getSelection().length) {
			e.preventDefault();
			e.stopPropagation();
			this.list.setSelection([], e.browserEvent);
			this.list.setAnchor(void 0);
			this.view.domNode.focus();
		}
	}
	dispose() {
		this.disposables.dispose();
		this.multipleSelectionDisposables.dispose();
	}
};
__decorate$36([memoize], KeyboardController.prototype, "onKeyDown", null);
var TypeNavigationMode;
(function(TypeNavigationMode) {
	TypeNavigationMode[TypeNavigationMode["Automatic"] = 0] = "Automatic";
	TypeNavigationMode[TypeNavigationMode["Trigger"] = 1] = "Trigger";
})(TypeNavigationMode || (TypeNavigationMode = {}));
var TypeNavigationControllerState;
(function(TypeNavigationControllerState) {
	TypeNavigationControllerState[TypeNavigationControllerState["Idle"] = 0] = "Idle";
	TypeNavigationControllerState[TypeNavigationControllerState["Typing"] = 1] = "Typing";
})(TypeNavigationControllerState || (TypeNavigationControllerState = {}));
var DefaultKeyboardNavigationDelegate = new class {
	mightProducePrintableCharacter(event) {
		if (event.ctrlKey || event.metaKey || event.altKey) return false;
		return event.keyCode >= 31 && event.keyCode <= 56 || event.keyCode >= 21 && event.keyCode <= 30 || event.keyCode >= 98 && event.keyCode <= 107 || event.keyCode >= 85 && event.keyCode <= 95;
	}
}();
var TypeNavigationController = class {
	constructor(list, view, keyboardNavigationLabelProvider, keyboardNavigationEventFilter, delegate) {
		this.list = list;
		this.view = view;
		this.keyboardNavigationLabelProvider = keyboardNavigationLabelProvider;
		this.keyboardNavigationEventFilter = keyboardNavigationEventFilter;
		this.delegate = delegate;
		this.enabled = false;
		this.state = TypeNavigationControllerState.Idle;
		this.mode = TypeNavigationMode.Automatic;
		this.triggered = false;
		this.previouslyFocused = -1;
		this.enabledDisposables = new DisposableStore();
		this.disposables = new DisposableStore();
		this.updateOptions(list.options);
	}
	updateOptions(options) {
		if (options.typeNavigationEnabled ?? true) this.enable();
		else this.disable();
		this.mode = options.typeNavigationMode ?? TypeNavigationMode.Automatic;
	}
	enable() {
		if (this.enabled) return;
		let typing = false;
		const onChar = Event.chain(this.enabledDisposables.add(new DomEmitter(this.view.domNode, "keydown")).event, ($) => $.filter((e) => !isEditableElement(e.target)).filter(() => this.mode === TypeNavigationMode.Automatic || this.triggered).map((event) => new StandardKeyboardEvent(event)).filter((e) => typing || this.keyboardNavigationEventFilter(e)).filter((e) => this.delegate.mightProducePrintableCharacter(e)).forEach((e) => EventHelper.stop(e, true)).map((event) => event.browserEvent.key));
		const onClear = Event.debounce(onChar, () => null, 800, void 0, void 0, void 0, this.enabledDisposables);
		Event.reduce(Event.any(onChar, onClear), (r, i) => i === null ? null : (r || "") + i, void 0, this.enabledDisposables)(this.onInput, this, this.enabledDisposables);
		onClear(this.onClear, this, this.enabledDisposables);
		onChar(() => typing = true, void 0, this.enabledDisposables);
		onClear(() => typing = false, void 0, this.enabledDisposables);
		this.enabled = true;
		this.triggered = false;
	}
	disable() {
		if (!this.enabled) return;
		this.enabledDisposables.clear();
		this.enabled = false;
		this.triggered = false;
	}
	onClear() {
		const focus = this.list.getFocus();
		if (focus.length > 0 && focus[0] === this.previouslyFocused) {
			const ariaLabel = this.list.options.accessibilityProvider?.getAriaLabel(this.list.element(focus[0]));
			if (typeof ariaLabel === "string") alert(ariaLabel);
			else if (ariaLabel) alert(ariaLabel.get());
		}
		this.previouslyFocused = -1;
	}
	onInput(word) {
		if (!word) {
			this.state = TypeNavigationControllerState.Idle;
			this.triggered = false;
			return;
		}
		const focus = this.list.getFocus();
		const start = focus.length > 0 ? focus[0] : 0;
		const delta = this.state === TypeNavigationControllerState.Idle ? 1 : 0;
		this.state = TypeNavigationControllerState.Typing;
		for (let i = 0; i < this.list.length; i++) {
			const index = (start + i + delta) % this.list.length;
			const label = this.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(this.view.element(index));
			const labelStr = label && label.toString();
			if (this.list.options.typeNavigationEnabled) {
				if (typeof labelStr !== "undefined") {
					if (matchesPrefix(word, labelStr)) {
						this.previouslyFocused = start;
						this.list.setFocus([index]);
						this.list.reveal(index);
						return;
					}
					const fuzzy = matchesFuzzy2(word, labelStr);
					if (fuzzy) {
						if (fuzzy[0].end - fuzzy[0].start > 1 && fuzzy.length === 1) {
							this.previouslyFocused = start;
							this.list.setFocus([index]);
							this.list.reveal(index);
							return;
						}
					}
				}
			} else if (typeof labelStr === "undefined" || matchesPrefix(word, labelStr)) {
				this.previouslyFocused = start;
				this.list.setFocus([index]);
				this.list.reveal(index);
				return;
			}
		}
	}
	dispose() {
		this.disable();
		this.enabledDisposables.dispose();
		this.disposables.dispose();
	}
};
var DOMFocusController = class {
	constructor(list, view) {
		this.list = list;
		this.view = view;
		this.disposables = new DisposableStore();
		const onKeyDown = Event.chain(this.disposables.add(new DomEmitter(view.domNode, "keydown")).event, ($) => $.filter((e) => !isEditableElement(e.target)).map((e) => new StandardKeyboardEvent(e)));
		Event.chain(onKeyDown, ($) => $.filter((e) => e.keyCode === 2 && !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey))(this.onTab, this, this.disposables);
	}
	onTab(e) {
		if (e.target !== this.view.domNode) return;
		const focus = this.list.getFocus();
		if (focus.length === 0) return;
		const focusedDomElement = this.view.domElement(focus[0]);
		if (!focusedDomElement) return;
		const tabIndexElement = focusedDomElement.querySelector("[tabIndex]");
		if (!tabIndexElement || !isHTMLElement(tabIndexElement) || tabIndexElement.tabIndex === -1) return;
		const style = getWindow(tabIndexElement).getComputedStyle(tabIndexElement);
		if (style.visibility === "hidden" || style.display === "none") return;
		e.preventDefault();
		e.stopPropagation();
		tabIndexElement.focus();
	}
	dispose() {
		this.disposables.dispose();
	}
};
function isSelectionSingleChangeEvent(event) {
	return isMacintosh ? event.browserEvent.metaKey : event.browserEvent.ctrlKey;
}
function isSelectionRangeChangeEvent(event) {
	return event.browserEvent.shiftKey;
}
function isMouseRightClick(event) {
	return isMouseEvent(event) && event.button === 2;
}
var DefaultMultipleSelectionController = {
	isSelectionSingleChangeEvent,
	isSelectionRangeChangeEvent
};
var MouseController = class {
	get onPointer() {
		return this._onPointer.event;
	}
	constructor(list) {
		this.list = list;
		this.disposables = new DisposableStore();
		this._onPointer = this.disposables.add(new Emitter$1());
		if (list.options.multipleSelectionSupport !== false) this.multipleSelectionController = this.list.options.multipleSelectionController || DefaultMultipleSelectionController;
		this.mouseSupport = typeof list.options.mouseSupport === "undefined" || !!list.options.mouseSupport;
		if (this.mouseSupport) {
			list.onMouseDown(this.onMouseDown, this, this.disposables);
			list.onContextMenu(this.onContextMenu, this, this.disposables);
			list.onMouseDblClick(this.onDoubleClick, this, this.disposables);
			list.onTouchStart(this.onMouseDown, this, this.disposables);
			this.disposables.add(Gesture.addTarget(list.getHTMLElement()));
		}
		Event.any(list.onMouseClick, list.onMouseMiddleClick, list.onTap)(this.onViewPointer, this, this.disposables);
	}
	updateOptions(optionsUpdate) {
		if (optionsUpdate.multipleSelectionSupport !== void 0) {
			this.multipleSelectionController = void 0;
			if (optionsUpdate.multipleSelectionSupport) this.multipleSelectionController = this.list.options.multipleSelectionController || DefaultMultipleSelectionController;
		}
	}
	isSelectionSingleChangeEvent(event) {
		if (!this.multipleSelectionController) return false;
		return this.multipleSelectionController.isSelectionSingleChangeEvent(event);
	}
	isSelectionRangeChangeEvent(event) {
		if (!this.multipleSelectionController) return false;
		return this.multipleSelectionController.isSelectionRangeChangeEvent(event);
	}
	isSelectionChangeEvent(event) {
		return this.isSelectionSingleChangeEvent(event) || this.isSelectionRangeChangeEvent(event);
	}
	onMouseDown(e) {
		if (isMonacoEditor(e.browserEvent.target)) return;
		if (getActiveElement() !== e.browserEvent.target) this.list.domFocus();
	}
	onContextMenu(e) {
		if (isEditableElement(e.browserEvent.target) || isMonacoEditor(e.browserEvent.target)) return;
		const focus = typeof e.index === "undefined" ? [] : [e.index];
		this.list.setFocus(focus, e.browserEvent);
	}
	onViewPointer(e) {
		if (!this.mouseSupport) return;
		if (isEditableElement(e.browserEvent.target) || isMonacoEditor(e.browserEvent.target)) return;
		if (e.browserEvent.isHandledByList) return;
		e.browserEvent.isHandledByList = true;
		const focus = e.index;
		if (typeof focus === "undefined") {
			this.list.setFocus([], e.browserEvent);
			this.list.setSelection([], e.browserEvent);
			this.list.setAnchor(void 0);
			return;
		}
		if (this.isSelectionChangeEvent(e)) return this.changeSelection(e);
		this.list.setFocus([focus], e.browserEvent);
		this.list.setAnchor(focus);
		if (!isMouseRightClick(e.browserEvent)) {
			if (this.list.getElementGroupId(focus) !== "notSelectable") this.list.setSelection([focus], e.browserEvent);
		}
		this._onPointer.fire(e);
	}
	onDoubleClick(e) {
		if (isEditableElement(e.browserEvent.target) || isMonacoEditor(e.browserEvent.target)) return;
		if (this.isSelectionChangeEvent(e)) return;
		if (e.browserEvent.isHandledByList) return;
		e.browserEvent.isHandledByList = true;
		const focus = this.list.getFocus();
		this.list.setSelection(focus, e.browserEvent);
	}
	changeSelection(e) {
		const focus = e.index;
		let anchor = this.list.getAnchor();
		if (this.isSelectionRangeChangeEvent(e)) {
			if (typeof anchor === "undefined") {
				anchor = this.list.getFocus()[0] ?? focus;
				this.list.setAnchor(anchor);
			}
			let rangeSelection = range(Math.min(anchor, focus), Math.max(anchor, focus) + 1);
			const selectedElement = this.list.getSelection()[0];
			if (selectedElement !== void 0) {
				const referenceGroupId = this.list.getElementGroupId(selectedElement);
				if (referenceGroupId !== void 0) rangeSelection = this.list.filterIndicesByGroup(rangeSelection, referenceGroupId);
			}
			const selection = this.list.getSelection();
			const contiguousRange = getContiguousRangeContaining(disjunction(selection, [anchor]), anchor);
			if (contiguousRange.length === 0) return;
			const newSelection = disjunction(rangeSelection, relativeComplement(selection, contiguousRange));
			this.list.setSelection(newSelection, e.browserEvent);
			this.list.setFocus([focus], e.browserEvent);
		} else if (this.isSelectionSingleChangeEvent(e)) {
			const selection = this.list.getSelection();
			const newSelection = selection.filter((i) => i !== focus);
			this.list.setFocus([focus]);
			this.list.setAnchor(focus);
			const focusGroupId = this.list.getElementGroupId(focus);
			if (focusGroupId === "notSelectable") return;
			if (selection.length === newSelection.length) {
				const itemsToBeSelected = focusGroupId !== void 0 ? this.list.filterIndicesByGroup([...newSelection, focus], focusGroupId) : [...newSelection, focus];
				this.list.setSelection(itemsToBeSelected, e.browserEvent);
			} else this.list.setSelection(newSelection, e.browserEvent);
		}
	}
	dispose() {
		this.disposables.dispose();
	}
};
var DefaultStyleController = class {
	constructor(styleElement, selectorSuffix) {
		this.styleElement = styleElement;
		this.selectorSuffix = selectorSuffix;
	}
	style(styles) {
		const suffix = this.selectorSuffix && `.${this.selectorSuffix}`;
		const content = [];
		if (styles.listBackground) content.push(`.monaco-list${suffix} .monaco-list-rows { background: ${styles.listBackground}; }`);
		if (styles.listFocusBackground) {
			content.push(`.monaco-list${suffix}:focus .monaco-list-row.focused { background-color: ${styles.listFocusBackground}; }`);
			content.push(`.monaco-list${suffix}:focus .monaco-list-row.focused:hover { background-color: ${styles.listFocusBackground}; }`);
		}
		if (styles.listFocusForeground) content.push(`.monaco-list${suffix}:focus .monaco-list-row.focused { color: ${styles.listFocusForeground}; }`);
		if (styles.listActiveSelectionBackground) {
			content.push(`.monaco-list${suffix}:focus .monaco-list-row.selected { background-color: ${styles.listActiveSelectionBackground}; }`);
			content.push(`.monaco-list${suffix}:focus .monaco-list-row.selected:hover { background-color: ${styles.listActiveSelectionBackground}; }`);
		}
		if (styles.listActiveSelectionForeground) content.push(`.monaco-list${suffix}:focus .monaco-list-row.selected { color: ${styles.listActiveSelectionForeground}; }`);
		if (styles.listActiveSelectionIconForeground) content.push(`.monaco-list${suffix}:focus .monaco-list-row.selected .codicon { color: ${styles.listActiveSelectionIconForeground}; }`);
		if (styles.listFocusAndSelectionBackground) content.push(`
				.monaco-drag-image${suffix},
				.monaco-list${suffix}:focus .monaco-list-row.selected.focused { background-color: ${styles.listFocusAndSelectionBackground}; }
			`);
		if (styles.listFocusAndSelectionForeground) content.push(`
				.monaco-drag-image${suffix},
				.monaco-list${suffix}:focus .monaco-list-row.selected.focused { color: ${styles.listFocusAndSelectionForeground}; }
			`);
		if (styles.listInactiveFocusForeground) {
			content.push(`.monaco-list${suffix} .monaco-list-row.focused { color:  ${styles.listInactiveFocusForeground}; }`);
			content.push(`.monaco-list${suffix} .monaco-list-row.focused:hover { color:  ${styles.listInactiveFocusForeground}; }`);
		}
		if (styles.listInactiveSelectionIconForeground) content.push(`.monaco-list${suffix} .monaco-list-row.focused .codicon { color:  ${styles.listInactiveSelectionIconForeground}; }`);
		if (styles.listInactiveFocusBackground) {
			content.push(`.monaco-list${suffix} .monaco-list-row.focused { background-color:  ${styles.listInactiveFocusBackground}; }`);
			content.push(`.monaco-list${suffix} .monaco-list-row.focused:hover { background-color:  ${styles.listInactiveFocusBackground}; }`);
		}
		if (styles.listInactiveSelectionBackground) {
			content.push(`.monaco-list${suffix} .monaco-list-row.selected { background-color:  ${styles.listInactiveSelectionBackground}; }`);
			content.push(`.monaco-list${suffix} .monaco-list-row.selected:hover { background-color:  ${styles.listInactiveSelectionBackground}; }`);
		}
		if (styles.listInactiveSelectionForeground) content.push(`.monaco-list${suffix} .monaco-list-row.selected { color: ${styles.listInactiveSelectionForeground}; }`);
		if (styles.listHoverBackground) content.push(`.monaco-list${suffix}:not(.drop-target):not(.dragging) .monaco-list-row:hover:not(.selected):not(.focused) { background-color: ${styles.listHoverBackground}; }`);
		if (styles.listHoverForeground) content.push(`.monaco-list${suffix}:not(.drop-target):not(.dragging) .monaco-list-row:hover:not(.selected):not(.focused) { color:  ${styles.listHoverForeground}; }`);
		/**
		* Outlines
		*/
		const focusAndSelectionOutline = asCssValueWithDefault(styles.listFocusAndSelectionOutline, asCssValueWithDefault(styles.listSelectionOutline, styles.listFocusOutline ?? ""));
		if (focusAndSelectionOutline) content.push(`.monaco-list${suffix}:focus .monaco-list-row.focused.selected { outline: 1px solid ${focusAndSelectionOutline}; outline-offset: -1px;}`);
		if (styles.listFocusOutline) content.push(`
				.monaco-drag-image${suffix},
				.monaco-list${suffix}:focus .monaco-list-row.focused,
				.context-menu-visible .monaco-list${suffix}.last-focused .monaco-list-row.focused { outline: 1px solid ${styles.listFocusOutline}; outline-offset: -1px; }
			`);
		const inactiveFocusAndSelectionOutline = asCssValueWithDefault(styles.listSelectionOutline, styles.listInactiveFocusOutline ?? "");
		if (inactiveFocusAndSelectionOutline) content.push(`.monaco-list${suffix} .monaco-list-row.focused.selected { outline: 1px dotted ${inactiveFocusAndSelectionOutline}; outline-offset: -1px; }`);
		if (styles.listSelectionOutline) content.push(`.monaco-list${suffix} .monaco-list-row.selected { outline: 1px dotted ${styles.listSelectionOutline}; outline-offset: -1px; }`);
		if (styles.listInactiveFocusOutline) content.push(`.monaco-list${suffix} .monaco-list-row.focused { outline: 1px dotted ${styles.listInactiveFocusOutline}; outline-offset: -1px; }`);
		if (styles.listHoverOutline) content.push(`.monaco-list${suffix} .monaco-list-row:hover { outline: 1px dashed ${styles.listHoverOutline}; outline-offset: -1px; }`);
		if (styles.listDropOverBackground) content.push(`
				.monaco-list${suffix}.drop-target,
				.monaco-list${suffix} .monaco-list-rows.drop-target,
				.monaco-list${suffix} .monaco-list-row.drop-target { background-color: ${styles.listDropOverBackground} !important; color: inherit !important; }
			`);
		if (styles.listDropBetweenBackground) {
			content.push(`
			.monaco-list${suffix} .monaco-list-rows.drop-target-before .monaco-list-row:first-child::before,
			.monaco-list${suffix} .monaco-list-row.drop-target-before::before {
				content: ""; position: absolute; top: 0px; left: 0px; width: 100%; height: 1px;
				background-color: ${styles.listDropBetweenBackground};
			}`);
			content.push(`
			.monaco-list${suffix} .monaco-list-rows.drop-target-after .monaco-list-row:last-child::after,
			.monaco-list${suffix} .monaco-list-row.drop-target-after::after {
				content: ""; position: absolute; bottom: 0px; left: 0px; width: 100%; height: 1px;
				background-color: ${styles.listDropBetweenBackground};
			}`);
		}
		if (styles.tableColumnsBorder) content.push(`
				.monaco-table > .monaco-split-view2,
				.monaco-table > .monaco-split-view2 .monaco-sash.vertical::before,
				.monaco-enable-motion .monaco-table:hover > .monaco-split-view2,
				.monaco-enable-motion .monaco-table:hover > .monaco-split-view2 .monaco-sash.vertical::before {
					border-color: ${styles.tableColumnsBorder};
				}

				.monaco-enable-motion .monaco-table > .monaco-split-view2,
				.monaco-enable-motion .monaco-table > .monaco-split-view2 .monaco-sash.vertical::before {
					border-color: transparent;
				}
			`);
		if (styles.tableOddRowsBackgroundColor) content.push(`
				.monaco-table .monaco-list-row[data-parity=odd]:not(.focused):not(.selected):not(:hover) .monaco-table-tr,
				.monaco-table .monaco-list:not(:focus) .monaco-list-row[data-parity=odd].focused:not(.selected):not(:hover) .monaco-table-tr,
				.monaco-table .monaco-list:not(.focused) .monaco-list-row[data-parity=odd].focused:not(.selected):not(:hover) .monaco-table-tr {
					background-color: ${styles.tableOddRowsBackgroundColor};
				}
			`);
		this.styleElement.textContent = content.join("\n");
	}
};
var unthemedListStyles = {
	listFocusBackground: "#7FB0D0",
	listActiveSelectionBackground: "#0E639C",
	listActiveSelectionForeground: "#FFFFFF",
	listActiveSelectionIconForeground: "#FFFFFF",
	listFocusAndSelectionOutline: "#90C2F9",
	listFocusAndSelectionBackground: "#094771",
	listFocusAndSelectionForeground: "#FFFFFF",
	listInactiveSelectionBackground: "#3F3F46",
	listInactiveSelectionIconForeground: "#FFFFFF",
	listHoverBackground: "#2A2D2E",
	listDropOverBackground: "#383B3D",
	listDropBetweenBackground: "#EEEEEE",
	treeIndentGuidesStroke: "#a9a9a9",
	treeInactiveIndentGuidesStroke: Color.fromHex("#a9a9a9").transparent(.4).toString(),
	tableColumnsBorder: Color.fromHex("#cccccc").transparent(.2).toString(),
	tableOddRowsBackgroundColor: Color.fromHex("#cccccc").transparent(.04).toString(),
	listBackground: void 0,
	listFocusForeground: void 0,
	listInactiveSelectionForeground: void 0,
	listInactiveFocusForeground: void 0,
	listInactiveFocusBackground: void 0,
	listHoverForeground: void 0,
	listFocusOutline: void 0,
	listInactiveFocusOutline: void 0,
	listSelectionOutline: void 0,
	listHoverOutline: void 0,
	treeStickyScrollBackground: void 0,
	treeStickyScrollBorder: void 0,
	treeStickyScrollShadow: void 0
};
var DefaultOptions = {
	keyboardSupport: true,
	mouseSupport: true,
	multipleSelectionSupport: true,
	dnd: {
		getDragURI() {
			return null;
		},
		onDragStart() {},
		onDragOver() {
			return false;
		},
		drop() {},
		dispose() {}
	}
};
function getContiguousRangeContaining(range, value) {
	const index = range.indexOf(value);
	if (index === -1) return [];
	const result = [];
	let i = index - 1;
	while (i >= 0 && range[i] === value - (index - i)) result.push(range[i--]);
	result.reverse();
	i = index;
	while (i < range.length && range[i] === value + (i - index)) result.push(range[i++]);
	return result;
}
/**
* Given two sorted collections of numbers, returns the intersection
* between them (OR).
*/
function disjunction(one, other) {
	const result = [];
	let i = 0, j = 0;
	while (i < one.length || j < other.length) if (i >= one.length) result.push(other[j++]);
	else if (j >= other.length) result.push(one[i++]);
	else if (one[i] === other[j]) {
		result.push(one[i]);
		i++;
		j++;
		continue;
	} else if (one[i] < other[j]) result.push(one[i++]);
	else result.push(other[j++]);
	return result;
}
/**
* Given two sorted collections of numbers, returns the relative
* complement between them (XOR).
*/
function relativeComplement(one, other) {
	const result = [];
	let i = 0, j = 0;
	while (i < one.length || j < other.length) if (i >= one.length) result.push(other[j++]);
	else if (j >= other.length) result.push(one[i++]);
	else if (one[i] === other[j]) {
		i++;
		j++;
		continue;
	} else if (one[i] < other[j]) result.push(one[i++]);
	else j++;
	return result;
}
var numericSort = (a, b) => a - b;
var PipelineRenderer = class {
	constructor(_templateId, renderers) {
		this._templateId = _templateId;
		this.renderers = renderers;
	}
	get templateId() {
		return this._templateId;
	}
	renderTemplate(container) {
		return this.renderers.map((r) => r.renderTemplate(container));
	}
	renderElement(element, index, templateData, renderDetails) {
		let i = 0;
		for (const renderer of this.renderers) renderer.renderElement(element, index, templateData[i++], renderDetails);
	}
	disposeElement(element, index, templateData, renderDetails) {
		let i = 0;
		for (const renderer of this.renderers) {
			renderer.disposeElement?.(element, index, templateData[i], renderDetails);
			i += 1;
		}
	}
	disposeTemplate(templateData) {
		let i = 0;
		for (const renderer of this.renderers) renderer.disposeTemplate(templateData[i++]);
	}
};
var AccessibiltyRenderer = class {
	constructor(accessibilityProvider) {
		this.accessibilityProvider = accessibilityProvider;
		this.templateId = "a18n";
	}
	renderTemplate(container) {
		return {
			container,
			disposables: new DisposableStore()
		};
	}
	renderElement(element, index, data) {
		const ariaLabel = this.accessibilityProvider.getAriaLabel(element);
		const observable = ariaLabel && typeof ariaLabel !== "string" ? ariaLabel : constObservable(ariaLabel);
		data.disposables.add(autorun((reader) => {
			this.setAriaLabel(reader.readObservable(observable), data.container);
		}));
		const ariaLevel = this.accessibilityProvider.getAriaLevel && this.accessibilityProvider.getAriaLevel(element);
		if (typeof ariaLevel === "number") data.container.setAttribute("aria-level", `${ariaLevel}`);
		else data.container.removeAttribute("aria-level");
	}
	setAriaLabel(ariaLabel, element) {
		if (ariaLabel) element.setAttribute("aria-label", ariaLabel);
		else element.removeAttribute("aria-label");
	}
	disposeElement(element, index, templateData) {
		templateData.disposables.clear();
	}
	disposeTemplate(templateData) {
		templateData.disposables.dispose();
	}
};
var ListViewDragAndDrop = class {
	constructor(list, dnd) {
		this.list = list;
		this.dnd = dnd;
	}
	getDragElements(element) {
		const selection = this.list.getSelectedElements();
		return selection.indexOf(element) > -1 ? selection : [element];
	}
	getDragURI(element) {
		return this.dnd.getDragURI(element);
	}
	getDragLabel(elements, originalEvent) {
		if (this.dnd.getDragLabel) return this.dnd.getDragLabel(elements, originalEvent);
	}
	onDragStart(data, originalEvent) {
		this.dnd.onDragStart?.(data, originalEvent);
	}
	onDragOver(data, targetElement, targetIndex, targetSector, originalEvent) {
		return this.dnd.onDragOver(data, targetElement, targetIndex, targetSector, originalEvent);
	}
	onDragLeave(data, targetElement, targetIndex, originalEvent) {
		this.dnd.onDragLeave?.(data, targetElement, targetIndex, originalEvent);
	}
	onDragEnd(originalEvent) {
		this.dnd.onDragEnd?.(originalEvent);
	}
	drop(data, targetElement, targetIndex, targetSector, originalEvent) {
		this.dnd.drop(data, targetElement, targetIndex, targetSector, originalEvent);
	}
	dispose() {
		this.dnd.dispose();
	}
};
/**
* The {@link List} is a virtual scrolling widget, built on top of the {@link ListView}
* widget.
*
* Features:
* - Customizable keyboard and mouse support
* - Element traits: focus, selection, achor
* - Accessibility support
* - Touch support
* - Performant template-based rendering
* - Horizontal scrolling
* - Variable element height support
* - Dynamic element height support
* - Drag-and-drop support
*/
var List = class {
	get onDidChangeFocus() {
		return Event.map(this.eventBufferer.wrapEvent(this.focus.onChange), (e) => this.toListEvent(e), this.disposables);
	}
	get onDidChangeSelection() {
		return Event.map(this.eventBufferer.wrapEvent(this.selection.onChange), (e) => this.toListEvent(e), this.disposables);
	}
	get domId() {
		return this.view.domId;
	}
	get onDidScroll() {
		return this.view.onDidScroll;
	}
	get onMouseClick() {
		return this.view.onMouseClick;
	}
	get onMouseDblClick() {
		return this.view.onMouseDblClick;
	}
	get onMouseMiddleClick() {
		return this.view.onMouseMiddleClick;
	}
	get onPointer() {
		return this.mouseController.onPointer;
	}
	get onMouseDown() {
		return this.view.onMouseDown;
	}
	get onMouseOver() {
		return this.view.onMouseOver;
	}
	get onMouseMove() {
		return this.view.onMouseMove;
	}
	get onMouseOut() {
		return this.view.onMouseOut;
	}
	get onTouchStart() {
		return this.view.onTouchStart;
	}
	get onTap() {
		return this.view.onTap;
	}
	/**
	* Possible context menu trigger events:
	* - ContextMenu key
	* - Shift F10
	* - Ctrl Option Shift M (macOS with VoiceOver)
	* - Mouse right click
	*/
	get onContextMenu() {
		let didJustPressContextMenuKey = false;
		const fromKeyDown = Event.chain(this.disposables.add(new DomEmitter(this.view.domNode, "keydown")).event, ($) => $.map((e) => new StandardKeyboardEvent(e)).filter((e) => didJustPressContextMenuKey = e.keyCode === 58 || e.shiftKey && e.keyCode === 68).map((e) => EventHelper.stop(e, true)).filter(() => false));
		const fromKeyUp = Event.chain(this.disposables.add(new DomEmitter(this.view.domNode, "keyup")).event, ($) => $.forEach(() => didJustPressContextMenuKey = false).map((e) => new StandardKeyboardEvent(e)).filter((e) => e.keyCode === 58 || e.shiftKey && e.keyCode === 68).map((e) => EventHelper.stop(e, true)).map(({ browserEvent }) => {
			const focus = this.getFocus();
			const index = focus.length ? focus[0] : void 0;
			return {
				index,
				element: typeof index !== "undefined" ? this.view.element(index) : void 0,
				anchor: typeof index !== "undefined" ? this.view.domElement(index) : this.view.domNode,
				browserEvent
			};
		}));
		const fromMouse = Event.chain(this.view.onContextMenu, ($) => $.filter((_) => !didJustPressContextMenuKey).map(({ element, index, browserEvent }) => ({
			element,
			index,
			anchor: new StandardMouseEvent(getWindow(this.view.domNode), browserEvent),
			browserEvent
		})));
		return Event.any(fromKeyDown, fromKeyUp, fromMouse);
	}
	get onKeyDown() {
		return this.disposables.add(new DomEmitter(this.view.domNode, "keydown")).event;
	}
	get onDidFocus() {
		return Event.signal(this.disposables.add(new DomEmitter(this.view.domNode, "focus", true)).event);
	}
	get onDidBlur() {
		return Event.signal(this.disposables.add(new DomEmitter(this.view.domNode, "blur", true)).event);
	}
	constructor(user, container, virtualDelegate, renderers, _options = DefaultOptions) {
		this.user = user;
		this._options = _options;
		this.focus = new Trait$1("focused");
		this.anchor = new Trait$1("anchor");
		this.eventBufferer = new EventBufferer();
		this._ariaLabel = "";
		this.disposables = new DisposableStore();
		this._onDidDispose = new Emitter$1();
		this.onDidDispose = this._onDidDispose.event;
		const role = this._options.accessibilityProvider && this._options.accessibilityProvider.getWidgetRole ? this._options.accessibilityProvider?.getWidgetRole() : "list";
		this.selection = new SelectionTrait(role !== "listbox");
		const baseRenderers = [this.focus.renderer, this.selection.renderer];
		this.accessibilityProvider = _options.accessibilityProvider;
		if (this.accessibilityProvider) {
			baseRenderers.push(new AccessibiltyRenderer(this.accessibilityProvider));
			this.accessibilityProvider.onDidChangeActiveDescendant?.(this.onDidChangeActiveDescendant, this, this.disposables);
		}
		renderers = renderers.map((r) => new PipelineRenderer(r.templateId, [...baseRenderers, r]));
		const viewOptions = {
			..._options,
			dnd: _options.dnd && new ListViewDragAndDrop(this, _options.dnd)
		};
		this.view = this.createListView(container, virtualDelegate, renderers, viewOptions);
		this.view.domNode.setAttribute("role", role);
		if (_options.styleController) this.styleController = _options.styleController(this.view.domId);
		else {
			const styleElement = createStyleSheet(this.view.domNode);
			this.styleController = new DefaultStyleController(styleElement, this.view.domId);
		}
		this.spliceable = new CombinedSpliceable([
			new TraitSpliceable(this.focus, this.view, _options.identityProvider),
			new TraitSpliceable(this.selection, this.view, _options.identityProvider),
			new TraitSpliceable(this.anchor, this.view, _options.identityProvider),
			this.view
		]);
		this.disposables.add(this.focus);
		this.disposables.add(this.selection);
		this.disposables.add(this.anchor);
		this.disposables.add(this.view);
		this.disposables.add(this._onDidDispose);
		this.disposables.add(new DOMFocusController(this, this.view));
		if (typeof _options.keyboardSupport !== "boolean" || _options.keyboardSupport) {
			this.keyboardController = new KeyboardController(this, this.view, _options);
			this.disposables.add(this.keyboardController);
		}
		if (_options.keyboardNavigationLabelProvider) {
			const delegate = _options.keyboardNavigationDelegate || DefaultKeyboardNavigationDelegate;
			this.typeNavigationController = new TypeNavigationController(this, this.view, _options.keyboardNavigationLabelProvider, _options.keyboardNavigationEventFilter ?? (() => true), delegate);
			this.disposables.add(this.typeNavigationController);
		}
		this.mouseController = this.createMouseController(_options);
		this.disposables.add(this.mouseController);
		this.onDidChangeFocus(this._onFocusChange, this, this.disposables);
		this.onDidChangeSelection(this._onSelectionChange, this, this.disposables);
		this.view.onDidScroll(this.onDidChangeActiveDescendant, this, this.disposables);
		if (this.accessibilityProvider) {
			const ariaLabel = this.accessibilityProvider.getWidgetAriaLabel();
			const observable = ariaLabel && typeof ariaLabel !== "string" ? ariaLabel : constObservable(ariaLabel);
			this.disposables.add(autorun((reader) => {
				this.ariaLabel = reader.readObservable(observable);
			}));
		}
		if (this._options.multipleSelectionSupport !== false) this.view.domNode.setAttribute("aria-multiselectable", "true");
	}
	createListView(container, virtualDelegate, renderers, viewOptions) {
		return new ListView(container, virtualDelegate, renderers, viewOptions);
	}
	createMouseController(options) {
		return new MouseController(this);
	}
	updateOptions(optionsUpdate = {}) {
		this._options = {
			...this._options,
			...optionsUpdate
		};
		this.typeNavigationController?.updateOptions(this._options);
		if (this._options.multipleSelectionController !== void 0) {
			if (this._options.multipleSelectionSupport) this.view.domNode.setAttribute("aria-multiselectable", "true");
			else this.view.domNode.removeAttribute("aria-multiselectable");
		}
		this.mouseController.updateOptions(optionsUpdate);
		this.keyboardController?.updateOptions(optionsUpdate);
		this.view.updateOptions(optionsUpdate);
	}
	get options() {
		return this._options;
	}
	splice(start, deleteCount, elements = []) {
		if (start < 0 || start > this.view.length) throw new ListError(this.user, `Invalid start index: ${start}`);
		if (deleteCount < 0) throw new ListError(this.user, `Invalid delete count: ${deleteCount}`);
		if (deleteCount === 0 && elements.length === 0) return;
		this.eventBufferer.bufferEvents(() => this.spliceable.splice(start, deleteCount, elements));
	}
	updateElementHeight(index, size) {
		this.view.updateElementHeight(index, size, null);
	}
	rerender() {
		this.view.rerender();
	}
	element(index) {
		return this.view.element(index);
	}
	indexOf(element) {
		return this.view.indexOf(element);
	}
	indexAt(position) {
		return this.view.indexAt(position);
	}
	get length() {
		return this.view.length;
	}
	get contentHeight() {
		return this.view.contentHeight;
	}
	get onDidChangeContentHeight() {
		return this.view.onDidChangeContentHeight;
	}
	get scrollTop() {
		return this.view.getScrollTop();
	}
	set scrollTop(scrollTop) {
		this.view.setScrollTop(scrollTop);
	}
	get scrollHeight() {
		return this.view.scrollHeight;
	}
	get renderHeight() {
		return this.view.renderHeight;
	}
	get firstVisibleIndex() {
		return this.view.firstVisibleIndex;
	}
	get ariaLabel() {
		return this._ariaLabel;
	}
	set ariaLabel(value) {
		this._ariaLabel = value;
		this.view.domNode.setAttribute("aria-label", value);
	}
	domFocus() {
		this.view.domNode.focus({ preventScroll: true });
	}
	layout(height, width) {
		this.view.layout(height, width);
	}
	setSelection(indexes, browserEvent) {
		for (const index of indexes) if (index < 0 || index >= this.length) throw new ListError(this.user, `Invalid index ${index}`);
		indexes = indexes.filter((i) => this.getElementGroupId(i) !== NotSelectableGroupId);
		this.selection.set(indexes, browserEvent);
	}
	getSelection() {
		return this.selection.get();
	}
	getSelectedElements() {
		return this.getSelection().map((i) => this.view.element(i));
	}
	setAnchor(index) {
		if (typeof index === "undefined") {
			this.anchor.set([]);
			return;
		}
		if (index < 0 || index >= this.length) throw new ListError(this.user, `Invalid index ${index}`);
		this.anchor.set([index]);
	}
	getAnchor() {
		return this.anchor.get().at(0);
	}
	getAnchorElement() {
		const anchor = this.getAnchor();
		return typeof anchor === "undefined" ? void 0 : this.element(anchor);
	}
	/**
	* Gets the group ID for an element at the given index.
	* Returns undefined if no identity provider, no getGroupId method, or if the group ID is undefined.
	*/
	getElementGroupId(index) {
		const identityProvider = this.options.identityProvider;
		if (!identityProvider?.getGroupId) return;
		const element = this.element(index);
		return identityProvider.getGroupId(element);
	}
	/**
	* Filters the given indices to only include those with a matching group ID.
	* If no identity provider or getGroupId method exists, returns the original indices.
	* If referenceGroupId is undefined, returns an empty array (elements without group IDs are not selectable).
	*/
	filterIndicesByGroup(indices, referenceGroupId) {
		const identityProvider = this.options.identityProvider;
		if (!identityProvider?.getGroupId) return indices;
		if (referenceGroupId === "notSelectable") return [];
		return indices.filter((index) => {
			const element = this.element(index);
			return identityProvider.getGroupId(element) === referenceGroupId;
		});
	}
	setFocus(indexes, browserEvent) {
		for (const index of indexes) if (index < 0 || index >= this.length) throw new ListError(this.user, `Invalid index ${index}`);
		this.focus.set(indexes, browserEvent);
	}
	focusNext(n = 1, loop = false, browserEvent, filter) {
		if (this.length === 0) return;
		const focus = this.focus.get();
		const index = this.findNextIndex(focus.length > 0 ? focus[0] + n : 0, loop, filter);
		if (index > -1) this.setFocus([index], browserEvent);
	}
	focusPrevious(n = 1, loop = false, browserEvent, filter) {
		if (this.length === 0) return;
		const focus = this.focus.get();
		const index = this.findPreviousIndex(focus.length > 0 ? focus[0] - n : 0, loop, filter);
		if (index > -1) this.setFocus([index], browserEvent);
	}
	async focusNextPage(browserEvent, filter) {
		let lastPageIndex = this.view.indexAt(this.view.getScrollTop() + this.view.renderHeight);
		lastPageIndex = lastPageIndex === 0 ? 0 : lastPageIndex - 1;
		const currentlyFocusedElementIndex = this.getFocus()[0];
		if (currentlyFocusedElementIndex !== lastPageIndex && (currentlyFocusedElementIndex === void 0 || lastPageIndex > currentlyFocusedElementIndex)) {
			const lastGoodPageIndex = this.findPreviousIndex(lastPageIndex, false, filter);
			if (lastGoodPageIndex > -1 && currentlyFocusedElementIndex !== lastGoodPageIndex) this.setFocus([lastGoodPageIndex], browserEvent);
			else this.setFocus([lastPageIndex], browserEvent);
		} else {
			const previousScrollTop = this.view.getScrollTop();
			let nextpageScrollTop = previousScrollTop + this.view.renderHeight;
			if (lastPageIndex > currentlyFocusedElementIndex) nextpageScrollTop -= this.view.elementHeight(lastPageIndex);
			this.view.setScrollTop(nextpageScrollTop);
			if (this.view.getScrollTop() !== previousScrollTop) {
				this.setFocus([]);
				await timeout(0);
				await this.focusNextPage(browserEvent, filter);
			}
		}
	}
	async focusPreviousPage(browserEvent, filter, getPaddingTop = () => 0) {
		let firstPageIndex;
		const paddingTop = getPaddingTop();
		const scrollTop = this.view.getScrollTop() + paddingTop;
		if (scrollTop === 0) firstPageIndex = this.view.indexAt(scrollTop);
		else firstPageIndex = this.view.indexAfter(scrollTop - 1);
		const currentlyFocusedElementIndex = this.getFocus()[0];
		if (currentlyFocusedElementIndex !== firstPageIndex && (currentlyFocusedElementIndex === void 0 || currentlyFocusedElementIndex >= firstPageIndex)) {
			const firstGoodPageIndex = this.findNextIndex(firstPageIndex, false, filter);
			if (firstGoodPageIndex > -1 && currentlyFocusedElementIndex !== firstGoodPageIndex) this.setFocus([firstGoodPageIndex], browserEvent);
			else this.setFocus([firstPageIndex], browserEvent);
		} else {
			const previousScrollTop = scrollTop;
			this.view.setScrollTop(scrollTop - this.view.renderHeight - paddingTop);
			if (this.view.getScrollTop() + getPaddingTop() !== previousScrollTop) {
				this.setFocus([]);
				await timeout(0);
				await this.focusPreviousPage(browserEvent, filter, getPaddingTop);
			}
		}
	}
	focusLast(browserEvent, filter) {
		if (this.length === 0) return;
		const index = this.findPreviousIndex(this.length - 1, false, filter);
		if (index > -1) this.setFocus([index], browserEvent);
	}
	focusFirst(browserEvent, filter) {
		this.focusNth(0, browserEvent, filter);
	}
	focusNth(n, browserEvent, filter) {
		if (this.length === 0) return;
		const index = this.findNextIndex(n, false, filter);
		if (index > -1) this.setFocus([index], browserEvent);
	}
	findNextIndex(index, loop = false, filter) {
		for (let i = 0; i < this.length; i++) {
			if (index >= this.length && !loop) return -1;
			index = index % this.length;
			if (!filter || filter(this.element(index))) return index;
			index++;
		}
		return -1;
	}
	findPreviousIndex(index, loop = false, filter) {
		for (let i = 0; i < this.length; i++) {
			if (index < 0 && !loop) return -1;
			index = (this.length + index % this.length) % this.length;
			if (!filter || filter(this.element(index))) return index;
			index--;
		}
		return -1;
	}
	getFocus() {
		return this.focus.get();
	}
	getFocusedElements() {
		return this.getFocus().map((i) => this.view.element(i));
	}
	reveal(index, relativeTop, paddingTop = 0) {
		if (index < 0 || index >= this.length) throw new ListError(this.user, `Invalid index ${index}`);
		const scrollTop = this.view.getScrollTop();
		const elementTop = this.view.elementTop(index);
		const elementHeight = this.view.elementHeight(index);
		if (isNumber$1(relativeTop)) {
			const m = elementHeight - this.view.renderHeight + paddingTop;
			this.view.setScrollTop(m * clamp(relativeTop, 0, 1) + elementTop - paddingTop);
		} else {
			const viewItemBottom = elementTop + elementHeight;
			const scrollBottom = scrollTop + this.view.renderHeight;
			if (elementTop < scrollTop + paddingTop && viewItemBottom >= scrollBottom);
			else if (elementTop < scrollTop + paddingTop || viewItemBottom >= scrollBottom && elementHeight >= this.view.renderHeight) this.view.setScrollTop(elementTop - paddingTop);
			else if (viewItemBottom >= scrollBottom) this.view.setScrollTop(viewItemBottom - this.view.renderHeight);
		}
	}
	getHTMLElement() {
		return this.view.domNode;
	}
	getScrollableElement() {
		return this.view.scrollableElementDomNode;
	}
	getElementID(index) {
		return this.view.getElementDomId(index);
	}
	getElementTop(index) {
		return this.view.elementTop(index);
	}
	getElementHeight(index) {
		return this.view.elementHeight(index);
	}
	style(styles) {
		this.styleController.style(styles);
	}
	toListEvent({ indexes, browserEvent }) {
		return {
			indexes,
			elements: indexes.map((i) => this.view.element(i)),
			browserEvent
		};
	}
	_onFocusChange() {
		const focus = this.focus.get();
		this.view.domNode.classList.toggle("element-focused", focus.length > 0);
		this.onDidChangeActiveDescendant();
	}
	onDidChangeActiveDescendant() {
		const focus = this.focus.get();
		if (focus.length > 0) {
			const index = focus[0];
			let id;
			if (this.accessibilityProvider?.getActiveDescendantId) id = this.accessibilityProvider.getActiveDescendantId(this.view.element(index));
			if (!id && this.view.domElement(index)) id = this.view.getElementDomId(index);
			if (id) this.view.domNode.setAttribute("aria-activedescendant", id);
			else this.view.domNode.removeAttribute("aria-activedescendant");
		} else this.view.domNode.removeAttribute("aria-activedescendant");
	}
	_onSelectionChange() {
		const selection = this.selection.get();
		this.view.domNode.classList.toggle("selection-none", selection.length === 0);
		this.view.domNode.classList.toggle("selection-single", selection.length === 1);
		this.view.domNode.classList.toggle("selection-multiple", selection.length > 1);
	}
	dispose() {
		this._onDidDispose.fire();
		this.disposables.dispose();
		this._onDidDispose.dispose();
	}
};
__decorate$36([memoize], List.prototype, "onDidChangeFocus", null);
__decorate$36([memoize], List.prototype, "onDidChangeSelection", null);
__decorate$36([memoize], List.prototype, "onContextMenu", null);
__decorate$36([memoize], List.prototype, "onKeyDown", null);
__decorate$36([memoize], List.prototype, "onDidFocus", null);
__decorate$36([memoize], List.prototype, "onDidBlur", null);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/selectBox/selectBoxCustom.js
var $$7 = $$10;
var SELECT_OPTION_ENTRY_TEMPLATE_ID = "selectOption.entry.template";
var SELECT_OPTION_HEIGHT = 22;
var SelectListRenderer = class {
	constructor() {
		this.elements = /* @__PURE__ */ new Map();
	}
	get templateId() {
		return SELECT_OPTION_ENTRY_TEMPLATE_ID;
	}
	renderTemplate(container) {
		const data = Object.create(null);
		data.root = container;
		data.text = append$2(container, $$7(".option-text"));
		data.detail = append$2(container, $$7(".option-detail"));
		data.decoratorRight = append$2(container, $$7(".option-decorator-right"));
		return data;
	}
	renderElement(element, index, templateData) {
		const data = templateData;
		if (data.element) this.elements.delete(data.element);
		data.element = element;
		this.elements.set(element, data.root);
		const text = element.text;
		const detail = element.detail;
		const decoratorRight = element.decoratorRight;
		const isDisabled = element.isDisabled;
		data.text.textContent = text;
		data.detail.textContent = !!detail ? detail : "";
		data.decoratorRight.textContent = !!decoratorRight ? decoratorRight : "";
		if (isDisabled) data.root.classList.add("option-disabled");
		else data.root.classList.remove("option-disabled");
		if (element.isSeparator) {
			data.root.classList.add("option-separator");
			data.root.classList.add("option-disabled");
		} else data.root.classList.remove("option-separator");
	}
	disposeTemplate(templateData) {
		if (templateData.element) this.elements.delete(templateData.element);
	}
	getElement(element) {
		return this.elements.get(element);
	}
};
var SelectBoxList = class SelectBoxList extends Disposable {
	static {
		this.DEFAULT_DROPDOWN_MINIMUM_BOTTOM_MARGIN = 32;
	}
	static {
		this.DEFAULT_DROPDOWN_MINIMUM_TOP_MARGIN = 2;
	}
	static {
		this.DEFAULT_MINIMUM_VISIBLE_OPTIONS = 3;
	}
	constructor(options, selected, contextViewProvider, styles, selectBoxOptions) {
		super();
		this.options = [];
		this.listOptionIndexes = [];
		this._currentSelection = 0;
		this._hasDetails = false;
		this._selectionDetailsDisposables = this._register(new DisposableStore());
		this._optionDescriptionHover = this._register(new MutableDisposable());
		this._skipLayout = false;
		this._sticky = false;
		this._isVisible = false;
		this.styles = styles;
		this.selectBoxOptions = selectBoxOptions || Object.create(null);
		if (typeof this.selectBoxOptions.minBottomMargin !== "number") this.selectBoxOptions.minBottomMargin = SelectBoxList.DEFAULT_DROPDOWN_MINIMUM_BOTTOM_MARGIN;
		else if (this.selectBoxOptions.minBottomMargin < 0) this.selectBoxOptions.minBottomMargin = 0;
		this.selectElement = document.createElement("select");
		this.selectElement.className = "monaco-select-box";
		if (typeof this.selectBoxOptions.ariaLabel === "string") this.selectElement.setAttribute("aria-label", this.selectBoxOptions.ariaLabel);
		if (typeof this.selectBoxOptions.ariaDescription === "string") this.selectElement.setAttribute("aria-description", this.selectBoxOptions.ariaDescription);
		this._onDidSelect = new Emitter$1();
		this._register(this._onDidSelect);
		this.registerListeners();
		this.constructSelectDropDown(contextViewProvider);
		this.selected = selected || 0;
		if (options) this.setOptions(options, selected);
		this.initStyleSheet();
	}
	setTitle(title) {
		if (!this._hover && title) this._hover = this._register(getBaseLayerHoverDelegate().setupManagedHover(getDefaultHoverDelegate("mouse"), this.selectElement, title));
		else if (this._hover) this._hover.update(title);
	}
	getHeight(_element) {
		return SELECT_OPTION_HEIGHT;
	}
	getTemplateId() {
		return SELECT_OPTION_ENTRY_TEMPLATE_ID;
	}
	constructSelectDropDown(contextViewProvider) {
		this.contextViewProvider = contextViewProvider;
		this.selectDropDownContainer = $$10(".monaco-select-box-dropdown-container");
		this.selectionDetailsPane = append$2(this.selectDropDownContainer, $$7(".select-box-details-pane"));
		const widthControlInnerDiv = append$2(append$2(this.selectDropDownContainer, $$7(".select-box-dropdown-container-width-control")), $$7(".width-control-div"));
		this.widthControlElement = document.createElement("span");
		this.widthControlElement.className = "option-text-width-control";
		append$2(widthControlInnerDiv, this.widthControlElement);
		this._dropDownPosition = 0;
		this.styleElement = createStyleSheet(this.selectDropDownContainer);
		this.selectDropDownContainer.setAttribute("draggable", "true");
		this._register(addDisposableListener(this.selectDropDownContainer, EventType$1.DRAG_START, (e) => {
			EventHelper.stop(e, true);
		}));
	}
	registerListeners() {
		this._register(addStandardDisposableListener(this.selectElement, "change", (e) => {
			this.selected = e.target.selectedIndex;
			this._onDidSelect.fire({
				index: e.target.selectedIndex,
				selected: e.target.value
			});
			if (!!this.options[this.selected] && !!this.options[this.selected].text) this.setTitle(this.options[this.selected].text);
		}));
		this._register(addDisposableListener(this.selectElement, EventType$1.CLICK, (e) => {
			EventHelper.stop(e);
			if (this._isVisible) this.cancelSelectDropDown(true);
			else this.showSelectDropDown();
		}));
		this._register(addDisposableListener(this.selectElement, EventType$1.MOUSE_DOWN, (e) => {
			EventHelper.stop(e);
		}));
		let listIsVisibleOnTouchStart;
		this._register(addDisposableListener(this.selectElement, "touchstart", (e) => {
			listIsVisibleOnTouchStart = this._isVisible;
		}));
		this._register(addDisposableListener(this.selectElement, "touchend", (e) => {
			EventHelper.stop(e);
			if (listIsVisibleOnTouchStart) this.cancelSelectDropDown(true);
			else this.showSelectDropDown();
		}));
		this._register(addDisposableListener(this.selectElement, EventType$1.KEY_DOWN, (e) => {
			const event = new StandardKeyboardEvent(e);
			let showDropDown = false;
			if (isMacintosh) {
				if (event.keyCode === 18 || event.keyCode === 16 || event.keyCode === 10 || event.keyCode === 3) showDropDown = true;
			} else if (event.keyCode === 18 && event.altKey || event.keyCode === 16 && event.altKey || event.keyCode === 10 || event.keyCode === 3) showDropDown = true;
			if (showDropDown) {
				this.showSelectDropDown();
				EventHelper.stop(e, true);
			}
		}));
	}
	get onDidSelect() {
		return this._onDidSelect.event;
	}
	setOptions(options, selected) {
		if (!equals$1(this.options, options)) {
			this.options = options;
			this.selectElement.options.length = 0;
			this._hasDetails = false;
			this._cachedMaxDetailsHeight = void 0;
			this.options.forEach((option, index) => {
				this.selectElement.add(this.createOption(option.text, index, option.isDisabled));
				if (typeof option.description === "string" && !this.selectBoxOptions.showOptionDescriptionHovers) this._hasDetails = true;
			});
		}
		if (selected !== void 0) {
			this.select(selected);
			this._currentSelection = this.selected;
		}
	}
	setOptionsList() {
		this.listOptionIndexes = [];
		for (let index = 0; index < this.options.length; index++) if (!this.selectBoxOptions.hideDisabledOptions || !this.options[index].isDisabled) this.listOptionIndexes.push(index);
		this.selectList?.splice(0, this.selectList.length, this.listOptionIndexes.map((index) => this.options[index]));
	}
	getListIndex(optionIndex) {
		return this.listOptionIndexes.indexOf(optionIndex);
	}
	getOptionIndex(listIndex) {
		return this.listOptionIndexes[listIndex];
	}
	focusOption(optionIndex) {
		const listIndex = this.getListIndex(optionIndex);
		if (listIndex >= 0) {
			this.selectList.reveal(listIndex);
			this.selectList.setFocus([listIndex]);
		}
	}
	select(index) {
		if (index >= 0 && index < this.options.length) this.selected = index;
		else if (index > this.options.length - 1) this.select(this.options.length - 1);
		else if (this.selected < 0) this.selected = 0;
		this.selectElement.selectedIndex = this.selected;
		if (!!this.options[this.selected] && !!this.options[this.selected].text) this.setTitle(this.options[this.selected].text);
	}
	focus() {
		if (this.selectElement) {
			this.selectElement.tabIndex = 0;
			this.selectElement.focus();
		}
	}
	blur() {
		if (this.selectElement) {
			this.selectElement.tabIndex = -1;
			this.selectElement.blur();
		}
	}
	setFocusable(focusable) {
		this.selectElement.tabIndex = focusable ? 0 : -1;
	}
	render(container) {
		this.container = container;
		container.classList.add("select-container");
		container.appendChild(this.selectElement);
		this.styleSelectElement();
	}
	initStyleSheet() {
		const content = [];
		if (this.styles.listFocusBackground) content.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row.focused { background-color: ${this.styles.listFocusBackground} !important; }`);
		if (this.styles.listFocusForeground) content.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row.focused { color: ${this.styles.listFocusForeground} !important; }`);
		if (this.styles.decoratorRightForeground) content.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row:not(.focused) .option-decorator-right { color: ${this.styles.decoratorRightForeground}; }`);
		if (this.styles.selectBackground && this.styles.selectBorder && this.styles.selectBorder !== this.styles.selectBackground) {
			content.push(`.monaco-select-box-dropdown-container { border: 1px solid ${this.styles.selectBorder} } `);
			content.push(`.monaco-select-box-dropdown-container > .select-box-details-pane.border-top { border-top: 1px solid ${this.styles.selectBorder} } `);
			content.push(`.monaco-select-box-dropdown-container > .select-box-details-pane.border-bottom { border-bottom: 1px solid ${this.styles.selectBorder} } `);
		} else if (this.styles.selectListBorder) {
			content.push(`.monaco-select-box-dropdown-container > .select-box-details-pane.border-top { border-top: 1px solid ${this.styles.selectListBorder} } `);
			content.push(`.monaco-select-box-dropdown-container > .select-box-details-pane.border-bottom { border-bottom: 1px solid ${this.styles.selectListBorder} } `);
		}
		if (this.styles.listHoverForeground) content.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row:not(.option-disabled):not(.focused):hover { color: ${this.styles.listHoverForeground} !important; }`);
		if (this.styles.listHoverBackground) content.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row:not(.option-disabled):not(.focused):hover { background-color: ${this.styles.listHoverBackground} !important; }`);
		if (this.styles.listFocusOutline) content.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row.focused { outline: 1px solid ${this.styles.listFocusOutline} !important; outline-offset: -1px !important; }`);
		if (this.styles.listHoverOutline) content.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row:not(.option-disabled):not(.focused):hover { outline: 1px solid ${this.styles.listHoverOutline} !important; outline-offset: -1px !important; }`);
		content.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row.option-disabled.focused { background-color: transparent !important; color: inherit !important; outline: none !important; }`);
		content.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row.option-disabled:hover { background-color: transparent !important; color: inherit !important; outline: none !important; }`);
		this.styleElement.textContent = content.join("\n");
	}
	styleSelectElement() {
		const background = this.styles.selectBackground ?? "";
		const foreground = this.styles.selectForeground ?? "";
		const border = this.styles.selectBorder ?? "";
		this.selectElement.style.backgroundColor = background;
		this.selectElement.style.color = foreground;
		this.selectElement.style.borderColor = border;
	}
	styleList() {
		const background = this.styles.selectBackground ?? "";
		const listBackground = asCssValueWithDefault(this.styles.selectListBackground, background);
		this.selectDropDownContainer.style.backgroundColor = listBackground;
		this.selectDropDownListContainer.style.backgroundColor = listBackground;
		this.selectionDetailsPane.style.backgroundColor = listBackground;
		this.selectList.style(this.styles);
	}
	createOption(value, index, disabled) {
		const option = document.createElement("option");
		option.value = value;
		option.text = value;
		option.disabled = !!disabled;
		return option;
	}
	showSelectDropDown() {
		this.selectionDetailsPane.textContent = "";
		if (!this.contextViewProvider || this._isVisible) return;
		this.createSelectList(this.selectDropDownContainer);
		this.setOptionsList();
		this._currentSelection = this.selected;
		this.contextViewProvider.showContextView({
			getAnchor: () => this.selectElement,
			render: (container) => this.renderSelectDropDown(container, true),
			layout: () => {
				this.layoutSelectDropDown();
			},
			onHide: () => {
				this.selectDropDownContainer.classList.remove("visible");
			},
			anchorPosition: this._dropDownPosition
		}, this.selectBoxOptions.optionsAsChildren ? this.container : void 0);
		this._isVisible = true;
		this.hideSelectDropDown(false);
		this.contextViewProvider.showContextView({
			getAnchor: () => this.selectElement,
			render: (container) => this.renderSelectDropDown(container),
			layout: () => this.layoutSelectDropDown(),
			onHide: () => {
				this.selectDropDownContainer.classList.remove("visible");
			},
			anchorPosition: this._dropDownPosition
		}, this.selectBoxOptions.optionsAsChildren ? this.container : void 0);
		this._isVisible = true;
		this.selectElement.setAttribute("aria-expanded", "true");
		const focusedListIndex = this.selectList.getFocus()[0];
		if (focusedListIndex !== void 0) this.showOptionDescriptionHover(focusedListIndex);
	}
	hideSelectDropDown(focusSelect) {
		if (!this.contextViewProvider || !this._isVisible) return;
		this._isVisible = false;
		this._optionDescriptionHover.clear();
		this.selectElement.setAttribute("aria-expanded", "false");
		if (focusSelect) this.selectElement.focus();
		this.contextViewProvider.hideContextView();
	}
	cancelSelectDropDown(focusSelect) {
		this.select(this._currentSelection);
		this.hideSelectDropDown(focusSelect);
	}
	renderSelectDropDown(container, preLayoutPosition) {
		container.appendChild(this.selectDropDownContainer);
		const computedFontSize = getWindow(this.selectElement).getComputedStyle(this.selectElement).fontSize;
		if (computedFontSize) this.selectDropDownContainer.style.fontSize = computedFontSize;
		this.layoutSelectDropDown(preLayoutPosition);
		return { dispose: () => {
			this.selectDropDownContainer.remove();
		} };
	}
	measureMaxDetailsHeight() {
		let maxDetailsPaneHeight = 0;
		this.options.forEach((_option, index) => {
			this.updateDetail(index);
			if (this.selectionDetailsPane.offsetHeight > maxDetailsPaneHeight) maxDetailsPaneHeight = this.selectionDetailsPane.offsetHeight;
		});
		return maxDetailsPaneHeight;
	}
	layoutSelectDropDown(preLayoutPosition) {
		if (this._skipLayout) return false;
		if (this.selectList) {
			this.selectDropDownContainer.classList.add("visible");
			const window = getWindow(this.selectElement);
			const selectPosition = getDomNodePagePosition(this.selectElement);
			const maxSelectDropDownHeightBelow = window.innerHeight - selectPosition.top - selectPosition.height - (this.selectBoxOptions.minBottomMargin || 0);
			const maxSelectDropDownHeightAbove = selectPosition.top - SelectBoxList.DEFAULT_DROPDOWN_MINIMUM_TOP_MARGIN;
			const selectWidth = this.selectElement.offsetWidth;
			const selectMinWidth = this.setWidthControlElement(this.widthControlElement);
			const selectOptimalWidth = `${Math.max(selectMinWidth, Math.round(selectWidth))}px`;
			this.selectDropDownContainer.style.width = selectOptimalWidth;
			this.selectList.getHTMLElement().style.height = "";
			this.selectList.layout();
			let listHeight = this.selectList.contentHeight;
			if (this._hasDetails && this._cachedMaxDetailsHeight === void 0) this._cachedMaxDetailsHeight = this.measureMaxDetailsHeight();
			const maxDetailsPaneHeight = this._hasDetails ? this._cachedMaxDetailsHeight : 0;
			const minRequiredDropDownHeight = listHeight + maxDetailsPaneHeight;
			const maxVisibleOptionsBelow = Math.floor((maxSelectDropDownHeightBelow - maxDetailsPaneHeight) / SELECT_OPTION_HEIGHT);
			const maxVisibleOptionsAbove = Math.floor((maxSelectDropDownHeightAbove - maxDetailsPaneHeight) / SELECT_OPTION_HEIGHT);
			if (preLayoutPosition) {
				if (selectPosition.top + selectPosition.height > window.innerHeight - 22 || selectPosition.top < SelectBoxList.DEFAULT_DROPDOWN_MINIMUM_TOP_MARGIN || maxVisibleOptionsBelow < 1 && maxVisibleOptionsAbove < 1) return false;
				if (maxVisibleOptionsBelow < SelectBoxList.DEFAULT_MINIMUM_VISIBLE_OPTIONS && maxVisibleOptionsAbove > maxVisibleOptionsBelow && this.selectList.length > maxVisibleOptionsBelow) {
					this._dropDownPosition = 1;
					this.selectDropDownListContainer.remove();
					this.selectionDetailsPane.remove();
					this.selectDropDownContainer.appendChild(this.selectionDetailsPane);
					this.selectDropDownContainer.appendChild(this.selectDropDownListContainer);
					this.selectionDetailsPane.classList.remove("border-top");
					this.selectionDetailsPane.classList.add("border-bottom");
				} else {
					this._dropDownPosition = 0;
					this.selectDropDownListContainer.remove();
					this.selectionDetailsPane.remove();
					this.selectDropDownContainer.appendChild(this.selectDropDownListContainer);
					this.selectDropDownContainer.appendChild(this.selectionDetailsPane);
					this.selectionDetailsPane.classList.remove("border-bottom");
					this.selectionDetailsPane.classList.add("border-top");
				}
				return true;
			}
			if (selectPosition.top + selectPosition.height > window.innerHeight - 22 || selectPosition.top < SelectBoxList.DEFAULT_DROPDOWN_MINIMUM_TOP_MARGIN || this._dropDownPosition === 0 && maxVisibleOptionsBelow < 1 || this._dropDownPosition === 1 && maxVisibleOptionsAbove < 1) {
				this.hideSelectDropDown(true);
				return false;
			}
			if (this._dropDownPosition === 0) {
				if (this._isVisible && maxVisibleOptionsBelow + maxVisibleOptionsAbove < 1) {
					this.hideSelectDropDown(true);
					return false;
				}
				if (minRequiredDropDownHeight > maxSelectDropDownHeightBelow) listHeight = maxVisibleOptionsBelow * SELECT_OPTION_HEIGHT;
			} else if (minRequiredDropDownHeight > maxSelectDropDownHeightAbove) listHeight = maxVisibleOptionsAbove * SELECT_OPTION_HEIGHT;
			this.selectList.layout(listHeight);
			this.selectList.domFocus();
			if (this.selectList.length > 0) {
				let selectedListIndex = this.getListIndex(this.selected);
				if (selectedListIndex < 0) {
					selectedListIndex = 0;
					this.selected = this.getOptionIndex(selectedListIndex);
					this.select(this.selected);
				}
				this.selectList.reveal(selectedListIndex);
				this.selectList.setFocus([selectedListIndex]);
			}
			if (this._hasDetails) {
				this.selectList.getHTMLElement().style.height = `${listHeight}px`;
				this.selectDropDownContainer.style.height = "";
			} else this.selectDropDownContainer.style.height = `${listHeight}px`;
			if (this._hasDetails) this.updateDetail(this.selected);
			else this.selectionDetailsPane.style.display = "none";
			this.selectDropDownContainer.style.width = selectOptimalWidth;
			this.selectDropDownListContainer.setAttribute("tabindex", "0");
			return true;
		} else return false;
	}
	setWidthControlElement(container) {
		let elementWidth = 0;
		if (container) {
			let longest = 0;
			let longestLength = 0;
			this.options.forEach((option, index) => {
				const detailLength = !!option.detail ? option.detail.length : 0;
				const rightDecoratorLength = !!option.decoratorRight ? option.decoratorRight.length : 0;
				const len = option.text.length + detailLength + rightDecoratorLength;
				if (len > longestLength) {
					longest = index;
					longestLength = len;
				}
			});
			container.textContent = this.options[longest].text + (!!this.options[longest].decoratorRight ? `${this.options[longest].decoratorRight} ` : "");
			elementWidth = getTotalWidth(container);
		}
		return elementWidth;
	}
	createSelectList(parent) {
		if (this.selectList) return;
		this.selectDropDownListContainer = append$2(parent, $$7(".select-box-dropdown-list-container"));
		this.listRenderer = new SelectListRenderer();
		this.selectList = this._register(new List("SelectBoxCustom", this.selectDropDownListContainer, this, [this.listRenderer], {
			useShadows: false,
			verticalScrollMode: 3,
			keyboardSupport: false,
			mouseSupport: false,
			accessibilityProvider: {
				getAriaLabel: (element) => {
					if (element.isSeparator) return localize(17, "separator");
					let label = element.text;
					if (element.detail) label += `. ${element.detail}`;
					if (element.decoratorRight) label += `. ${element.decoratorRight}`;
					if (element.description) label += `. ${element.description}`;
					return label;
				},
				getWidgetAriaLabel: () => localize(18, "Select Box"),
				getRole: () => isMacintosh ? "" : "option",
				getWidgetRole: () => "listbox"
			}
		}));
		if (this.selectBoxOptions.ariaLabel) this.selectList.ariaLabel = this.selectBoxOptions.ariaLabel;
		const onKeyDown = this._register(new DomEmitter(this.selectDropDownListContainer, "keydown"));
		const onSelectDropDownKeyDown = Event.chain(onKeyDown.event, ($) => $.filter(() => this.selectList.length > 0).map((e) => new StandardKeyboardEvent(e)));
		this._register(Event.chain(onSelectDropDownKeyDown, ($) => $.filter((e) => e.keyCode === 3))(this.onEnter, this));
		this._register(Event.chain(onSelectDropDownKeyDown, ($) => $.filter((e) => e.keyCode === 2))(this.onEnter, this));
		this._register(Event.chain(onSelectDropDownKeyDown, ($) => $.filter((e) => e.keyCode === 9))(this.onEscape, this));
		this._register(Event.chain(onSelectDropDownKeyDown, ($) => $.filter((e) => e.keyCode === 16))(this.onUpArrow, this));
		this._register(Event.chain(onSelectDropDownKeyDown, ($) => $.filter((e) => e.keyCode === 18))(this.onDownArrow, this));
		this._register(Event.chain(onSelectDropDownKeyDown, ($) => $.filter((e) => e.keyCode === 12))(this.onPageDown, this));
		this._register(Event.chain(onSelectDropDownKeyDown, ($) => $.filter((e) => e.keyCode === 11))(this.onPageUp, this));
		this._register(Event.chain(onSelectDropDownKeyDown, ($) => $.filter((e) => e.keyCode === 14))(this.onHome, this));
		this._register(Event.chain(onSelectDropDownKeyDown, ($) => $.filter((e) => e.keyCode === 13))(this.onEnd, this));
		this._register(Event.chain(onSelectDropDownKeyDown, ($) => $.filter((e) => e.keyCode >= 21 && e.keyCode <= 56 || e.keyCode >= 85 && e.keyCode <= 113))(this.onCharacter, this));
		this._register(addDisposableListener(this.selectList.getHTMLElement(), EventType$1.POINTER_UP, (e) => this.onPointerUp(e)));
		this._register(this.selectList.onMouseOver((e) => typeof e.index !== "undefined" && !e.element?.isDisabled && this.selectList.setFocus([e.index])));
		this._register(this.selectList.onDidChangeFocus((e) => this.onListFocus(e)));
		this._register(addDisposableListener(this.selectDropDownContainer, EventType$1.FOCUS_OUT, (e) => {
			if (!this._isVisible || isAncestor$1(e.relatedTarget, this.selectDropDownContainer)) return;
			this.onListBlur();
		}));
		this.selectList.getHTMLElement().setAttribute("aria-label", this.selectBoxOptions.ariaLabel || "");
		this.selectList.getHTMLElement().setAttribute("aria-expanded", "true");
		this.styleList();
	}
	onPointerUp(e) {
		if (!this.selectList.length) return;
		EventHelper.stop(e);
		const target = e.target;
		if (!target) return;
		if (target.classList.contains("slider")) return;
		const listRowElement = target.closest(".monaco-list-row");
		if (!listRowElement) return;
		const index = this.getOptionIndex(Number(listRowElement.getAttribute("data-index")));
		const disabled = listRowElement.classList.contains("option-disabled");
		if (index >= 0 && index < this.options.length && !disabled) {
			this.selected = index;
			this.select(this.selected);
			this.focusOption(this.selected);
			if (this.selected !== this._currentSelection) {
				this._currentSelection = this.selected;
				this._onDidSelect.fire({
					index: this.selectElement.selectedIndex,
					selected: this.options[this.selected].text
				});
				if (!!this.options[this.selected] && !!this.options[this.selected].text) this.setTitle(this.options[this.selected].text);
			}
			this.hideSelectDropDown(true);
		}
	}
	onListBlur() {
		if (this._sticky) return;
		this.cancelSelectDropDown(false);
	}
	renderDescriptionMarkdown(text, actionHandler) {
		const cleanRenderedMarkdown = (element) => {
			for (let i = 0; i < element.childNodes.length; i++) {
				const child = element.childNodes.item(i);
				if ((child.tagName && child.tagName.toLowerCase()) === "img") child.remove();
				else cleanRenderedMarkdown(child);
			}
		};
		const rendered = renderMarkdown({
			value: text,
			supportThemeIcons: true
		}, { actionHandler });
		rendered.element.classList.add("select-box-description-markdown");
		cleanRenderedMarkdown(rendered.element);
		return rendered;
	}
	onListFocus(e) {
		if (!this._isVisible) return;
		const listIndex = e.indexes[0];
		const optionIndex = this.getOptionIndex(listIndex);
		if (this._hasDetails) this.updateDetail(optionIndex);
		this.showOptionDescriptionHover(listIndex);
	}
	showOptionDescriptionHover(listIndex) {
		if (!this.selectBoxOptions.showOptionDescriptionHovers) return;
		const option = this.options[this.getOptionIndex(listIndex)];
		const description = option?.description;
		const target = option ? this.listRenderer.getElement(option) : void 0;
		this._optionDescriptionHover.value = description && target ? getBaseLayerHoverDelegate().showDelayedHover({
			content: description,
			target,
			position: { hoverPosition: 1 }
		}, { groupId: "select-box-option-description" }) : void 0;
	}
	updateDetail(selectedIndex) {
		this._selectionDetailsDisposables.clear();
		this.selectionDetailsPane.textContent = "";
		const option = this.options[selectedIndex];
		const description = option?.description ?? "";
		const descriptionIsMarkdown = option?.descriptionIsMarkdown ?? false;
		if (description) {
			if (descriptionIsMarkdown) {
				const actionHandler = option.descriptionMarkdownActionHandler;
				const result = this._selectionDetailsDisposables.add(this.renderDescriptionMarkdown(description, actionHandler));
				this.selectionDetailsPane.appendChild(result.element);
			} else this.selectionDetailsPane.textContent = description;
			this.selectionDetailsPane.style.display = "block";
		} else this.selectionDetailsPane.style.display = "none";
		this._skipLayout = true;
		this.contextViewProvider.layout();
		this._skipLayout = false;
	}
	onEscape(e) {
		EventHelper.stop(e);
		this.cancelSelectDropDown(true);
	}
	onEnter(e) {
		EventHelper.stop(e);
		if (this.options[this.selected]?.isDisabled) {
			this.hideSelectDropDown(true);
			return;
		}
		if (this.selected !== this._currentSelection) {
			this._currentSelection = this.selected;
			this._onDidSelect.fire({
				index: this.selectElement.selectedIndex,
				selected: this.options[this.selected].text
			});
			if (!!this.options[this.selected] && !!this.options[this.selected].text) this.setTitle(this.options[this.selected].text);
		}
		this.hideSelectDropDown(true);
	}
	onDownArrow(e) {
		if (this.selected < this.options.length - 1) {
			EventHelper.stop(e, true);
			let next = this.selected + 1;
			while (next < this.options.length && this.options[next].isDisabled) next++;
			if (next >= this.options.length) return;
			this.selected = next;
			this.select(this.selected);
			this.focusOption(this.selected);
		}
	}
	onUpArrow(e) {
		if (this.selected > 0) {
			EventHelper.stop(e, true);
			let prev = this.selected - 1;
			while (prev >= 0 && this.options[prev].isDisabled) prev--;
			if (prev < 0) return;
			this.selected = prev;
			this.select(this.selected);
			this.focusOption(this.selected);
		}
	}
	onPageUp(e) {
		EventHelper.stop(e);
		this.selectList.focusPreviousPage();
		setTimeout(() => {
			let candidate = this.selectList.getFocus()[0];
			while (candidate > 0 && this.options[this.getOptionIndex(candidate)].isDisabled) candidate--;
			const optionIndex = this.getOptionIndex(candidate);
			if (this.options[optionIndex].isDisabled) return;
			this.selected = optionIndex;
			this.selectList.reveal(candidate);
			this.selectList.setFocus([candidate]);
			this.select(this.selected);
		}, 1);
	}
	onPageDown(e) {
		EventHelper.stop(e);
		this.selectList.focusNextPage();
		setTimeout(() => {
			let candidate = this.selectList.getFocus()[0];
			while (candidate < this.selectList.length - 1 && this.options[this.getOptionIndex(candidate)].isDisabled) candidate++;
			const optionIndex = this.getOptionIndex(candidate);
			if (this.options[optionIndex].isDisabled) return;
			this.selected = optionIndex;
			this.selectList.reveal(candidate);
			this.selectList.setFocus([candidate]);
			this.select(this.selected);
		}, 1);
	}
	onHome(e) {
		EventHelper.stop(e);
		if (this.options.length < 2) return;
		let candidate = 0;
		while (candidate < this.options.length - 1 && this.options[candidate].isDisabled) candidate++;
		if (this.options[candidate].isDisabled) return;
		this.selected = candidate;
		this.focusOption(this.selected);
		this.select(this.selected);
	}
	onEnd(e) {
		EventHelper.stop(e);
		if (this.options.length < 2) return;
		let candidate = this.options.length - 1;
		while (candidate > 0 && this.options[candidate].isDisabled) candidate--;
		if (this.options[candidate].isDisabled) return;
		this.selected = candidate;
		this.focusOption(this.selected);
		this.select(this.selected);
	}
	onCharacter(e) {
		const ch = KeyCodeUtils.toString(e.keyCode);
		let optionIndex = -1;
		for (let i = 0; i < this.options.length - 1; i++) {
			optionIndex = (i + this.selected + 1) % this.options.length;
			if (this.options[optionIndex].text.charAt(0).toUpperCase() === ch && !this.options[optionIndex].isDisabled) {
				this.select(optionIndex);
				this.focusOption(optionIndex);
				EventHelper.stop(e);
				break;
			}
		}
	}
	dispose() {
		this.hideSelectDropDown(false);
		super.dispose();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/selectBox/selectBoxNative.js
var SelectBoxNative = class extends Disposable {
	constructor(options, selected, styles, selectBoxOptions) {
		super();
		this.selected = 0;
		this.selectBoxOptions = selectBoxOptions || Object.create(null);
		this.options = [];
		this.selectElement = document.createElement("select");
		this.selectElement.className = "monaco-select-box";
		if (typeof this.selectBoxOptions.ariaLabel === "string") this.selectElement.setAttribute("aria-label", this.selectBoxOptions.ariaLabel);
		if (typeof this.selectBoxOptions.ariaDescription === "string") this.selectElement.setAttribute("aria-description", this.selectBoxOptions.ariaDescription);
		this._onDidSelect = this._register(new Emitter$1());
		this.styles = styles;
		this.registerListeners();
		this.setOptions(options, selected);
	}
	registerListeners() {
		this._register(Gesture.addTarget(this.selectElement));
		[EventType.Tap].forEach((eventType) => {
			this._register(addDisposableListener(this.selectElement, eventType, (e) => {
				this.selectElement.focus();
			}));
		});
		this._register(addStandardDisposableListener(this.selectElement, "click", (e) => {
			EventHelper.stop(e, true);
		}));
		this._register(addStandardDisposableListener(this.selectElement, "change", (e) => {
			this.selectElement.title = e.target.value;
			this._onDidSelect.fire({
				index: e.target.selectedIndex,
				selected: e.target.value
			});
		}));
		this._register(addStandardDisposableListener(this.selectElement, "keydown", (e) => {
			let showSelect = false;
			if (isMacintosh) {
				if (e.keyCode === 18 || e.keyCode === 16 || e.keyCode === 10) showSelect = true;
			} else if (e.keyCode === 18 && e.altKey || e.keyCode === 10 || e.keyCode === 3) showSelect = true;
			if (showSelect) e.stopPropagation();
		}));
	}
	get onDidSelect() {
		return this._onDidSelect.event;
	}
	setOptions(options, selected) {
		if (!this.options || !equals$1(this.options, options)) {
			this.options = options;
			this.selectElement.options.length = 0;
			this.options.forEach((option, index) => {
				this.selectElement.add(this.createOption(option.text, index, option.isDisabled, option.isSeparator));
			});
		}
		if (selected !== void 0) this.select(selected);
	}
	select(index) {
		if (this.options.length === 0) this.selected = 0;
		else if (index >= 0 && index < this.options.length) this.selected = index;
		else if (index > this.options.length - 1) this.select(this.options.length - 1);
		else if (this.selected < 0) this.selected = 0;
		this.selectElement.selectedIndex = this.selected;
		if (this.selected < this.options.length && typeof this.options[this.selected].text === "string") this.selectElement.title = this.options[this.selected].text;
		else this.selectElement.title = "";
	}
	focus() {
		if (this.selectElement) {
			this.selectElement.tabIndex = 0;
			this.selectElement.focus();
		}
	}
	blur() {
		if (this.selectElement) {
			this.selectElement.tabIndex = -1;
			this.selectElement.blur();
		}
	}
	setFocusable(focusable) {
		this.selectElement.tabIndex = focusable ? 0 : -1;
	}
	render(container) {
		container.classList.add("select-container");
		container.appendChild(this.selectElement);
		this.setOptions(this.options, this.selected);
		this.applyStyles();
	}
	applyStyles() {
		if (this.selectElement) {
			this.selectElement.style.backgroundColor = this.styles.selectBackground ?? "";
			this.selectElement.style.color = this.styles.selectForeground ?? "";
			this.selectElement.style.borderColor = this.styles.selectBorder ?? "";
		}
	}
	createOption(value, index, disabled, isSeparator) {
		const option = document.createElement("option");
		option.value = value;
		option.text = value;
		option.disabled = !!disabled || !!isSeparator;
		if (isSeparator) option.setAttribute("role", "separator");
		return option;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/selectBox/selectBox.js
var SeparatorSelectOption = Object.freeze({
	text: "─────────",
	isDisabled: true,
	isSeparator: true
});
var SelectBox = class extends Widget$1 {
	constructor(options, selected, contextViewProvider, styles, selectBoxOptions) {
		super();
		if (isMacintosh && !selectBoxOptions?.useCustomDrawn) this.selectBoxDelegate = new SelectBoxNative(options, selected, styles, selectBoxOptions);
		else this.selectBoxDelegate = new SelectBoxList(options, selected, contextViewProvider, styles, selectBoxOptions);
		this._register(this.selectBoxDelegate);
	}
	get onDidSelect() {
		return this.selectBoxDelegate.onDidSelect;
	}
	setOptions(options, selected) {
		this.selectBoxDelegate.setOptions(options, selected);
	}
	select(index) {
		this.selectBoxDelegate.select(index);
	}
	focus() {
		this.selectBoxDelegate.focus();
	}
	blur() {
		this.selectBoxDelegate.blur();
	}
	setFocusable(focusable) {
		this.selectBoxDelegate.setFocusable(focusable);
	}
	render(container) {
		this.selectBoxDelegate.render(container);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/actionbar/actionViewItems.js
var BaseActionViewItem = class extends Disposable {
	get action() {
		return this._action;
	}
	constructor(context, action, options = {}) {
		super();
		this.options = options;
		this._context = context || this;
		this._action = action;
		if (action instanceof Action) this._register(action.onDidChange((event) => {
			if (!this.element) return;
			this.handleActionChangeEvent(event);
		}));
	}
	handleActionChangeEvent(event) {
		if (event.enabled !== void 0) this.updateEnabled();
		if (event.checked !== void 0) this.updateChecked();
		if (event.class !== void 0) this.updateClass();
		if (event.label !== void 0) {
			this.updateLabel();
			this.updateTooltip();
		}
		if (event.tooltip !== void 0) this.updateTooltip();
	}
	get actionRunner() {
		if (!this._actionRunner) this._actionRunner = this._register(new ActionRunner());
		return this._actionRunner;
	}
	set actionRunner(actionRunner) {
		this._actionRunner = actionRunner;
	}
	isEnabled() {
		return this._action.enabled;
	}
	setActionContext(newContext) {
		this._context = newContext;
	}
	render(container) {
		const element = this.element = container;
		this._register(Gesture.addTarget(container));
		const enableDragging = this.options && this.options.draggable;
		if (enableDragging) {
			container.draggable = true;
			if (isFirefox) this._register(addDisposableListener(container, EventType$1.DRAG_START, (e) => e.dataTransfer?.setData(DataTransfers.TEXT, this._action.label)));
		}
		this._register(addDisposableListener(element, EventType.Tap, (e) => this.onClick(e, true)));
		this._register(addDisposableListener(element, EventType$1.MOUSE_DOWN, (e) => {
			if (!enableDragging) EventHelper.stop(e, true);
			if (this._action.enabled && e.button === 0) element.classList.add("active");
		}));
		if (isMacintosh) this._register(addDisposableListener(element, EventType$1.CONTEXT_MENU, (e) => {
			if (e.button === 0 && e.ctrlKey === true) this.onClick(e);
		}));
		this._register(addDisposableListener(element, EventType$1.CLICK, (e) => {
			EventHelper.stop(e, true);
			if (!(this.options && this.options.isMenu)) this.onClick(e);
		}));
		this._register(addDisposableListener(element, EventType$1.DBLCLICK, (e) => {
			EventHelper.stop(e, true);
		}));
		[EventType$1.MOUSE_UP, EventType$1.MOUSE_OUT].forEach((event) => {
			this._register(addDisposableListener(element, event, (e) => {
				EventHelper.stop(e);
				element.classList.remove("active");
			}));
		});
	}
	onClick(event, preserveFocus = false) {
		EventHelper.stop(event, true);
		const context = isUndefinedOrNull(this._context) ? this.options?.useEventAsContext ? event : { preserveFocus } : this._context;
		this.actionRunner.run(this._action, context);
	}
	focus() {
		if (this.element) {
			this.element.tabIndex = 0;
			this.element.focus();
			this.element.classList.add("focused");
		}
	}
	blur() {
		if (this.element) {
			this.element.blur();
			this.element.tabIndex = -1;
			this.element.classList.remove("focused");
		}
	}
	setFocusable(focusable) {
		if (this.element) this.element.tabIndex = focusable ? 0 : -1;
	}
	get trapsArrowNavigation() {
		return false;
	}
	updateEnabled() {}
	updateLabel() {}
	getClass() {
		return this.action.class;
	}
	getTooltip() {
		return this.action.tooltip;
	}
	getHoverContents() {
		return this.getTooltip();
	}
	getHoverOptions() {}
	updateTooltip() {
		if (!this.element) return;
		const title = this.getHoverContents() ?? "";
		this.updateAriaLabel();
		if (!this.customHover && title !== "") {
			const hoverDelegate = this.options.hoverDelegate ?? getDefaultHoverDelegate("element");
			this.customHover = this._store.add(getBaseLayerHoverDelegate().setupManagedHover(hoverDelegate, this.element, title, this.getHoverOptions()));
		} else if (this.customHover) this.customHover.update(title, this.getHoverOptions());
	}
	updateAriaLabel() {
		if (this.element) {
			const title = this.getTooltip() ?? "";
			this.element.setAttribute("aria-label", title);
		}
	}
	updateClass() {}
	updateChecked() {}
	dispose() {
		if (this.element) {
			this.element.remove();
			this.element = void 0;
		}
		this._context = void 0;
		super.dispose();
	}
};
var ActionViewItem = class extends BaseActionViewItem {
	constructor(context, action, options) {
		options = {
			...options,
			icon: options.icon !== void 0 ? options.icon : false,
			label: options.label !== void 0 ? options.label : true
		};
		super(context, action, options);
		this.options = options;
		this.cssClass = "";
	}
	render(container) {
		super.render(container);
		assertType(this.element);
		const label = document.createElement("a");
		label.classList.add("action-label");
		label.setAttribute("role", this.getDefaultAriaRole());
		this.label = label;
		this.element.appendChild(label);
		if (this.options.label && this.options.keybinding && !this.options.keybindingNotRenderedWithLabel) {
			const kbLabel = document.createElement("span");
			kbLabel.classList.add("keybinding");
			kbLabel.textContent = this.options.keybinding;
			this.element.appendChild(kbLabel);
		}
		this.updateClass();
		this.updateLabel();
		this.updateTooltip();
		this.updateEnabled();
		this.updateChecked();
	}
	getDefaultAriaRole() {
		if (this._action.id === Separator.ID) return "presentation";
		else if (this.options.isMenu) return "menuitem";
		else if (this.options.isTabList) return "tab";
		else return "button";
	}
	focus() {
		if (this.label) {
			this.label.tabIndex = 0;
			this.label.focus();
		}
	}
	blur() {
		if (this.label) this.label.tabIndex = -1;
	}
	setFocusable(focusable) {
		if (this.label) this.label.tabIndex = focusable ? 0 : -1;
	}
	updateLabel() {
		if (this.options.label && this.label) this.label.textContent = this.action.label;
	}
	getTooltip() {
		let title = null;
		if (this.action.tooltip) title = this.action.tooltip;
		else if (this.action.label) {
			title = this.action.label;
			if (this.options.keybinding) title = localize(0, "{0} ({1})", title, this.options.keybinding);
		}
		return title ?? void 0;
	}
	updateClass() {
		if (this.cssClass && this.label) this.label.classList.remove(...this.cssClass.split(" "));
		if (this.action.id === Separator.ID && this.action.class) this.label?.classList.add(this.action.class);
		else if (this.options.icon) {
			this.cssClass = this.getClass();
			if (this.label) {
				this.label.classList.add("codicon");
				if (this.cssClass) this.label.classList.add(...this.cssClass.split(" "));
			}
			this.updateEnabled();
		} else this.label?.classList.remove("codicon");
	}
	updateEnabled() {
		if (this.action.enabled) {
			if (this.label) {
				this.label.removeAttribute("aria-disabled");
				this.label.classList.remove("disabled");
			}
			this.element?.classList.remove("disabled");
		} else {
			if (this.label) {
				this.label.setAttribute("aria-disabled", "true");
				this.label.classList.add("disabled");
			}
			this.element?.classList.add("disabled");
		}
	}
	updateAriaLabel() {
		if (this.label) {
			const title = this.getTooltip() ?? "";
			this.label.setAttribute("aria-label", title);
		}
	}
	updateChecked() {
		if (this.label) {
			if (this.action.checked !== void 0) {
				this.label.classList.toggle("checked", this.action.checked);
				if (this.options.isTabList) this.label.setAttribute("aria-selected", this.action.checked ? "true" : "false");
				else {
					this.label.setAttribute("aria-pressed", this.action.checked ? "true" : "false");
					this.label.setAttribute("role", "button");
				}
			} else {
				this.label.classList.remove("checked");
				this.label.removeAttribute(this.options.isTabList ? "aria-selected" : "aria-pressed");
				this.label.setAttribute("role", this.getDefaultAriaRole());
			}
		}
	}
};
var SelectActionViewItem = class extends BaseActionViewItem {
	constructor(ctx, action, options, selected, contextViewProvider, styles, selectBoxOptions) {
		super(ctx, action);
		this.selectBox = new SelectBox(options, selected, contextViewProvider, styles, selectBoxOptions);
		this.selectBox.setFocusable(false);
		this._register(this.selectBox);
		this.registerListeners();
	}
	select(index) {
		this.selectBox.select(index);
	}
	registerListeners() {
		this._register(this.selectBox.onDidSelect((e) => this.runAction(e.selected, e.index)));
	}
	runAction(option, index) {
		this.actionRunner.run(this._action, this.getActionContext(option, index));
	}
	getActionContext(option, index) {
		return option;
	}
	setFocusable(focusable) {
		this.selectBox.setFocusable(focusable);
	}
	focus() {
		this.selectBox?.focus();
	}
	blur() {
		this.selectBox?.blur();
	}
	render(container) {
		this.selectBox.render(container);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/dropdown/dropdown.js
var BaseDropdown = class extends ActionRunner {
	constructor(container, baseOptions) {
		super();
		this.baseOptions = baseOptions;
		this._onDidChangeVisibility = this._register(new Emitter$1());
		this.onDidChangeVisibility = this._onDidChangeVisibility.event;
		this._element = append$2(container, $$10(".monaco-dropdown"));
		this._label = append$2(this._element, $$10(".dropdown-label"));
		let labelRenderer = baseOptions.labelRenderer;
		if (!labelRenderer) labelRenderer = (container) => {
			container.textContent = baseOptions.label || "";
			return null;
		};
		for (const event of [
			EventType$1.CLICK,
			EventType$1.MOUSE_DOWN,
			EventType.Tap
		]) this._register(addDisposableListener(this.element, event, (e) => EventHelper.stop(e, true)));
		for (const event of [EventType$1.MOUSE_DOWN, EventType.Tap]) this._register(addDisposableListener(this._label, event, (e) => {
			if (baseOptions.isEnabled?.() === false) return;
			if (isMouseEvent(e) && e.button !== 0) return;
			if (this.visible) this.hide();
			else this.show();
		}));
		this._register(addDisposableListener(this._label, EventType$1.KEY_DOWN, (e) => {
			const event = new StandardKeyboardEvent(e);
			if (event.equals(3) || event.equals(10)) {
				EventHelper.stop(e, true);
				if (baseOptions.isEnabled?.() === false) return;
				if (this.visible) this.hide();
				else this.show();
			}
		}));
		const cleanupFn = labelRenderer(this._label);
		if (cleanupFn) this._register(cleanupFn);
		this._register(Gesture.addTarget(this._label));
	}
	get element() {
		return this._element;
	}
	show() {
		if (!this.visible && this.baseOptions.isEnabled?.() !== false) {
			this.visible = true;
			this._onDidChangeVisibility.fire(true);
		}
	}
	hide() {
		if (this.visible) {
			this.visible = false;
			this._onDidChangeVisibility.fire(false);
		}
	}
	dispose() {
		super.dispose();
		this.hide();
		if (this.boxContainer) {
			this.boxContainer.remove();
			this.boxContainer = void 0;
		}
		if (this.contents) {
			this.contents.remove();
			this.contents = void 0;
		}
		if (this._label) {
			this._label.remove();
			this._label = void 0;
		}
	}
};
var DropdownMenu = class extends BaseDropdown {
	constructor(container, _options) {
		super(container, _options);
		this._options = _options;
		this._actions = [];
		this.actions = _options.actions || [];
	}
	set menuOptions(options) {
		this._menuOptions = options;
	}
	get menuOptions() {
		return this._menuOptions;
	}
	get actions() {
		if (this._options.actionProvider) return this._options.actionProvider.getActions();
		return this._actions;
	}
	set actions(actions) {
		this._actions = actions;
	}
	show() {
		if (this._options.isEnabled?.() === false) return;
		super.show();
		this.element.classList.add("active");
		this._options.contextMenuProvider.showContextMenu({
			getAnchor: () => this._options.getAnchor?.() ?? this.element,
			getActions: () => this.actions,
			getActionsContext: () => this.menuOptions ? this.menuOptions.context : null,
			getActionViewItem: (action, options) => this.menuOptions && this.menuOptions.actionViewItemProvider ? this.menuOptions.actionViewItemProvider(action, options) : void 0,
			getKeyBinding: (action) => this.menuOptions && this.menuOptions.getKeyBinding ? this.menuOptions.getKeyBinding(action) : void 0,
			getMenuClassName: () => this.getMenuClassName(),
			closeAnimation: this._options.closeAnimation ?? contextViewMenuCloseAnimation,
			onHide: () => this.onHide(),
			actionRunner: this.menuOptions ? this.menuOptions.actionRunner : void 0,
			anchorAlignment: this.menuOptions ? this.menuOptions.anchorAlignment : 0,
			domForShadowRoot: this._options.menuAsChild ? this.element : void 0,
			skipTelemetry: this._options.skipTelemetry
		});
	}
	getMenuClassName() {
		const classNames = this._options.menuClassName?.split(/\s+/).filter(Boolean) ?? [];
		if (!classNames.includes("context-view-menu-motion")) classNames.push(CONTEXT_VIEW_MENU_MOTION_CLASS);
		return classNames.join(" ");
	}
	hide() {
		super.hide();
	}
	onHide() {
		this.hide();
		this.element.classList.remove("active");
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/dropdown/dropdownActionViewItem.js
var DropdownMenuActionViewItem = class extends BaseActionViewItem {
	get onDidChangeVisibility() {
		return this._onDidChangeVisibility.event;
	}
	constructor(action, menuActionsOrProvider, contextMenuProvider, options = Object.create(null)) {
		super(null, action, options);
		this.actionItem = null;
		this._onDidChangeVisibility = this._register(new Emitter$1());
		this.menuActionsOrProvider = menuActionsOrProvider;
		this.contextMenuProvider = contextMenuProvider;
		this.options = options;
		if (this.options.actionRunner) this.actionRunner = this.options.actionRunner;
	}
	render(container) {
		this.actionItem = container;
		const labelRenderer = (el) => {
			this.element = append$2(el, $$10("a.action-label"));
			this.setAriaLabelAttributes(this.element);
			return this.renderLabel(this.element);
		};
		const isActionsArray = Array.isArray(this.menuActionsOrProvider);
		const options = {
			contextMenuProvider: this.contextMenuProvider,
			labelRenderer,
			isEnabled: () => this.action.enabled,
			menuAsChild: this.options.menuAsChild,
			actions: isActionsArray ? this.menuActionsOrProvider : void 0,
			actionProvider: isActionsArray ? void 0 : this.menuActionsOrProvider,
			menuClassName: this.options.menuClassName,
			closeAnimation: this.options.closeAnimation,
			getAnchor: this.options.getAnchor,
			skipTelemetry: this.options.skipTelemetry
		};
		this.dropdownMenu = this._register(new DropdownMenu(container, options));
		this._register(this.dropdownMenu.onDidChangeVisibility((visible) => {
			this.element?.setAttribute("aria-expanded", `${visible}`);
			this._onDidChangeVisibility.fire(visible);
		}));
		this.dropdownMenu.menuOptions = {
			actionViewItemProvider: this.options.actionViewItemProvider,
			actionRunner: this.actionRunner,
			getKeyBinding: this.options.keybindingProvider,
			context: this._context
		};
		if (this.options.anchorAlignmentProvider) {
			const that = this;
			this.dropdownMenu.menuOptions = {
				...this.dropdownMenu.menuOptions,
				get anchorAlignment() {
					return that.options.anchorAlignmentProvider();
				}
			};
		}
		this.updateTooltip();
		this.updateEnabled();
	}
	renderLabel(element) {
		let classNames = [];
		if (typeof this.options.classNames === "string") classNames = this.options.classNames.split(/\s+/g).filter((s) => !!s);
		else if (this.options.classNames) classNames = this.options.classNames;
		if (!classNames.find((c) => c === "icon")) classNames.push("codicon");
		element.classList.add(...classNames);
		if (this._action.label) this._register(getBaseLayerHoverDelegate().setupManagedHover(this.options.hoverDelegate ?? getDefaultHoverDelegate("mouse"), element, this._action.label));
		return null;
	}
	setAriaLabelAttributes(element) {
		element.setAttribute("role", "button");
		element.setAttribute("aria-haspopup", "true");
		element.setAttribute("aria-expanded", "false");
		element.ariaLabel = this._action.label || "";
	}
	getTooltip() {
		let title = null;
		if (this.action.tooltip) title = this.action.tooltip;
		else if (this.action.label) title = this.action.label;
		return title ?? void 0;
	}
	setActionContext(newContext) {
		super.setActionContext(newContext);
		if (this.dropdownMenu) {
			if (this.dropdownMenu.menuOptions) this.dropdownMenu.menuOptions.context = newContext;
			else this.dropdownMenu.menuOptions = { context: newContext };
		}
	}
	show() {
		this.dropdownMenu?.show();
	}
	updateEnabled() {
		const disabled = !this.action.enabled;
		this.actionItem?.classList.toggle("disabled", disabled);
		this.element?.classList.toggle("disabled", disabled);
		this.element?.setAttribute("aria-disabled", String(disabled));
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/keybindingLabels.js
var ModifierLabelProvider = class {
	constructor(mac, windows, linux = windows) {
		this.modifierLabels = [null];
		this.modifierLabels[2] = mac;
		this.modifierLabels[1] = windows;
		this.modifierLabels[3] = linux;
	}
	toLabel(OS, chords, keyLabelProvider) {
		if (chords.length === 0) return null;
		const result = [];
		for (let i = 0, len = chords.length; i < len; i++) {
			const chord = chords[i];
			const keyLabel = keyLabelProvider(chord);
			if (keyLabel === null) return null;
			result[i] = _simpleAsString(chord, keyLabel, this.modifierLabels[OS]);
		}
		return result.join(" ");
	}
};
/**
* A label provider that prints modifiers in a suitable format for displaying in the UI.
*/
var UILabelProvider = new ModifierLabelProvider({
	ctrlKey: "⌃",
	shiftKey: "⇧",
	altKey: "⌥",
	metaKey: "⌘",
	separator: ""
}, {
	ctrlKey: localize(39, "Ctrl"),
	shiftKey: localize(40, "Shift"),
	altKey: localize(41, "Alt"),
	metaKey: localize(42, "Windows"),
	separator: "+"
}, {
	ctrlKey: localize(43, "Ctrl"),
	shiftKey: localize(44, "Shift"),
	altKey: localize(45, "Alt"),
	metaKey: localize(46, "Super"),
	separator: "+"
});
/**
* A label provider that prints modifiers in a suitable format for ARIA.
*/
var AriaLabelProvider = new ModifierLabelProvider({
	ctrlKey: localize(47, "Control"),
	shiftKey: localize(48, "Shift"),
	altKey: localize(49, "Option"),
	metaKey: localize(50, "Command"),
	separator: "+"
}, {
	ctrlKey: localize(51, "Control"),
	shiftKey: localize(52, "Shift"),
	altKey: localize(53, "Alt"),
	metaKey: localize(54, "Windows"),
	separator: "+"
}, {
	ctrlKey: localize(55, "Control"),
	shiftKey: localize(56, "Shift"),
	altKey: localize(57, "Alt"),
	metaKey: localize(58, "Super"),
	separator: "+"
});
/**
* A label provider that prints modifiers in a suitable format for Electron Accelerators.
* See https://github.com/electron/electron/blob/master/docs/api/accelerator.md
*/
var ElectronAcceleratorLabelProvider = new ModifierLabelProvider({
	ctrlKey: "Ctrl",
	shiftKey: "Shift",
	altKey: "Alt",
	metaKey: "Cmd",
	separator: "+"
}, {
	ctrlKey: "Ctrl",
	shiftKey: "Shift",
	altKey: "Alt",
	metaKey: "Super",
	separator: "+"
});
/**
* A label provider that prints modifiers in a suitable format for user settings.
*/
var UserSettingsLabelProvider = new ModifierLabelProvider({
	ctrlKey: "ctrl",
	shiftKey: "shift",
	altKey: "alt",
	metaKey: "cmd",
	separator: "+"
}, {
	ctrlKey: "ctrl",
	shiftKey: "shift",
	altKey: "alt",
	metaKey: "win",
	separator: "+"
}, {
	ctrlKey: "ctrl",
	shiftKey: "shift",
	altKey: "alt",
	metaKey: "meta",
	separator: "+"
});
function _simpleAsString(modifiers, key, labels) {
	if (key === null) return "";
	const result = [];
	if (modifiers.ctrlKey) result.push(labels.ctrlKey);
	if (modifiers.shiftKey) result.push(labels.shiftKey);
	if (modifiers.altKey) result.push(labels.altKey);
	if (modifiers.metaKey) result.push(labels.metaKey);
	if (key !== "") result.push(key);
	return result.join(labels.separator);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/action/common/action.js
function isLocalizedString(thing) {
	return !!thing && typeof thing === "object" && typeof thing.original === "string" && typeof thing.value === "string";
}
function isICommandActionToggleInfo(thing) {
	return thing ? thing.condition !== void 0 : false;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/theme/browser/defaultStyles.js
function overrideStyles(override, styles) {
	const result = { ...styles };
	for (const key in override) {
		const val = override[key];
		result[key] = val !== void 0 ? asCssVariable(val) : void 0;
	}
	return result;
}
var defaultKeybindingLabelStyles = {
	keybindingLabelBackground: asCssVariable(keybindingLabelBackground),
	keybindingLabelForeground: asCssVariable(keybindingLabelForeground),
	keybindingLabelBorder: asCssVariable(keybindingLabelBorder),
	keybindingLabelBottomBorder: asCssVariable(keybindingLabelBottomBorder),
	keybindingLabelShadow: asCssVariable(widgetShadow)
};
var defaultButtonStyles = {
	buttonForeground: asCssVariable(buttonForeground),
	buttonSeparator: asCssVariable(buttonSeparator),
	buttonBackground: asCssVariable(buttonBackground),
	buttonHoverBackground: asCssVariable(buttonHoverBackground),
	buttonSecondaryForeground: asCssVariable(buttonSecondaryForeground),
	buttonSecondaryBackground: asCssVariable(buttonSecondaryBackground),
	buttonSecondaryHoverBackground: asCssVariable(buttonSecondaryHoverBackground),
	buttonSecondaryBorder: asCssVariable(buttonSecondaryBorder),
	buttonBorder: asCssVariable(buttonBorder)
};
var defaultProgressBarStyles = { progressBarBackground: asCssVariable(progressBarBackground) };
var defaultToggleStyles = {
	inputActiveOptionBorder: asCssVariable(inputActiveOptionBorder),
	inputActiveOptionForeground: asCssVariable(inputActiveOptionForeground),
	inputActiveOptionBackground: asCssVariable(inputActiveOptionBackground)
};
asCssVariable(radioActiveForeground), asCssVariable(radioActiveBackground), asCssVariable(radioActiveBorder), asCssVariable(radioInactiveForeground), asCssVariable(radioInactiveBackground), asCssVariable(radioInactiveBorder), asCssVariable(radioInactiveHoverBackground);
var defaultCheckboxStyles = {
	checkboxBackground: asCssVariable(checkboxBackground),
	checkboxBorder: asCssVariable(checkboxBorder),
	checkboxForeground: asCssVariable(checkboxForeground),
	checkboxDisabledBackground: asCssVariable(checkboxDisabledBackground),
	checkboxDisabledForeground: asCssVariable(checkboxDisabledForeground)
};
asCssVariable(editorWidgetBackground), asCssVariable(editorWidgetForeground), asCssVariable(widgetShadow), asCssVariable(widgetBorder), asCssVariable(problemsErrorIconForeground), asCssVariable(problemsWarningIconForeground), asCssVariable(problemsInfoIconForeground), asCssVariable(textLinkForeground);
var defaultInputBoxStyles = {
	inputBackground: asCssVariable(inputBackground),
	inputForeground: asCssVariable(inputForeground),
	inputBorder: asCssVariable(inputBorder),
	inputValidationInfoBorder: asCssVariable(inputValidationInfoBorder),
	inputValidationInfoBackground: asCssVariable(inputValidationInfoBackground),
	inputValidationInfoForeground: asCssVariable(inputValidationInfoForeground),
	inputValidationWarningBorder: asCssVariable(inputValidationWarningBorder),
	inputValidationWarningBackground: asCssVariable(inputValidationWarningBackground),
	inputValidationWarningForeground: asCssVariable(inputValidationWarningForeground),
	inputValidationErrorBorder: asCssVariable(inputValidationErrorBorder),
	inputValidationErrorBackground: asCssVariable(inputValidationErrorBackground),
	inputValidationErrorForeground: asCssVariable(inputValidationErrorForeground)
};
var defaultFindWidgetStyles = {
	listFilterWidgetBackground: asCssVariable(listFilterWidgetBackground),
	listFilterWidgetOutline: asCssVariable(listFilterWidgetOutline),
	listFilterWidgetNoMatchesOutline: asCssVariable(listFilterWidgetNoMatchesOutline),
	listFilterWidgetShadow: asCssVariable(listFilterWidgetShadow),
	inputBoxStyles: defaultInputBoxStyles,
	toggleStyles: defaultToggleStyles
};
var defaultCountBadgeStyles = {
	badgeBackground: asCssVariable(badgeBackground),
	badgeForeground: asCssVariable(badgeForeground),
	badgeBorder: asCssVariable(contrastBorder)
};
asCssVariable(breadcrumbsBackground), asCssVariable(breadcrumbsForeground), asCssVariable(breadcrumbsFocusForeground), asCssVariable(breadcrumbsFocusForeground), asCssVariable(breadcrumbsActiveSelectionForeground);
var defaultListStyles = {
	listBackground: void 0,
	listInactiveFocusForeground: void 0,
	listFocusBackground: asCssVariable(listFocusBackground),
	listFocusForeground: asCssVariable(listFocusForeground),
	listFocusOutline: asCssVariable(listFocusOutline),
	listActiveSelectionBackground: asCssVariable(listActiveSelectionBackground),
	listActiveSelectionForeground: asCssVariable(listActiveSelectionForeground),
	listActiveSelectionIconForeground: asCssVariable(listActiveSelectionIconForeground),
	listFocusAndSelectionOutline: asCssVariable(listFocusAndSelectionOutline),
	listFocusAndSelectionBackground: asCssVariable(listActiveSelectionBackground),
	listFocusAndSelectionForeground: asCssVariable(listActiveSelectionForeground),
	listInactiveSelectionBackground: asCssVariable(listInactiveSelectionBackground),
	listInactiveSelectionIconForeground: asCssVariable(listInactiveSelectionIconForeground),
	listInactiveSelectionForeground: asCssVariable(listInactiveSelectionForeground),
	listInactiveFocusBackground: asCssVariable(listInactiveFocusBackground),
	listInactiveFocusOutline: asCssVariable(listInactiveFocusOutline),
	listHoverBackground: asCssVariable(listHoverBackground),
	listHoverForeground: asCssVariable(listHoverForeground),
	listDropOverBackground: asCssVariable(listDropOverBackground),
	listDropBetweenBackground: asCssVariable(listDropBetweenBackground),
	listSelectionOutline: asCssVariable(activeContrastBorder),
	listHoverOutline: asCssVariable(activeContrastBorder),
	treeIndentGuidesStroke: asCssVariable(treeIndentGuidesStroke),
	treeInactiveIndentGuidesStroke: asCssVariable(treeInactiveIndentGuidesStroke),
	treeStickyScrollBackground: void 0,
	treeStickyScrollBorder: void 0,
	treeStickyScrollShadow: asCssVariable(scrollbarShadow),
	tableColumnsBorder: asCssVariable(tableColumnsBorder),
	tableOddRowsBackgroundColor: asCssVariable(tableOddRowsBackgroundColor)
};
function getListStyles(override) {
	return overrideStyles(override, defaultListStyles);
}
var defaultSelectBoxStyles = {
	selectBackground: asCssVariable(selectBackground),
	selectListBackground: asCssVariable(selectListBackground),
	selectForeground: asCssVariable(selectForeground),
	decoratorRightForeground: asCssVariable(pickerGroupForeground),
	selectBorder: asCssVariable(selectBorder),
	focusBorder: asCssVariable(focusBorder),
	listFocusBackground: asCssVariable(quickInputListFocusBackground),
	listInactiveSelectionIconForeground: asCssVariable(quickInputListFocusIconForeground),
	listFocusForeground: asCssVariable(quickInputListFocusForeground),
	listFocusOutline: asCssVariableWithDefault(activeContrastBorder, Color.transparent.toString()),
	listHoverBackground: asCssVariable(listHoverBackground),
	listHoverForeground: asCssVariable(listHoverForeground),
	listHoverOutline: asCssVariable(activeContrastBorder),
	selectListBorder: asCssVariable(editorWidgetBorder),
	listBackground: void 0,
	listActiveSelectionBackground: void 0,
	listActiveSelectionForeground: void 0,
	listActiveSelectionIconForeground: void 0,
	listFocusAndSelectionBackground: void 0,
	listDropOverBackground: void 0,
	listDropBetweenBackground: void 0,
	listInactiveSelectionBackground: void 0,
	listInactiveSelectionForeground: void 0,
	listInactiveFocusBackground: void 0,
	listInactiveFocusOutline: void 0,
	listSelectionOutline: void 0,
	listFocusAndSelectionForeground: void 0,
	listFocusAndSelectionOutline: void 0,
	listInactiveFocusForeground: void 0,
	tableColumnsBorder: void 0,
	tableOddRowsBackgroundColor: void 0,
	treeIndentGuidesStroke: void 0,
	treeInactiveIndentGuidesStroke: void 0,
	treeStickyScrollBackground: void 0,
	treeStickyScrollBorder: void 0,
	treeStickyScrollShadow: void 0
};
var defaultMenuStyles = {
	shadowColor: asCssVariable(widgetShadow),
	borderColor: asCssVariableWithDefault(menuBorder, editorWidgetBorder),
	foregroundColor: asCssVariable(menuForeground),
	backgroundColor: asCssVariable(menuBackground),
	selectionForegroundColor: asCssVariable(listHoverForeground),
	selectionBackgroundColor: asCssVariable(listHoverBackground),
	selectionBorderColor: asCssVariable(menuSelectionBorder),
	separatorColor: asCssVariable(menuSeparatorBackground),
	scrollbarShadow: asCssVariable(scrollbarShadow),
	scrollbarSliderBackground: asCssVariable(scrollbarSliderBackground),
	scrollbarSliderHoverBackground: asCssVariable(scrollbarSliderHoverBackground),
	scrollbarSliderActiveBackground: asCssVariable(scrollbarSliderActiveBackground)
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/animations/animations.js
/** Captures the animation's position and container before the element can move or be removed. */
function captureAnimationTarget(element) {
	return {
		element,
		rect: element.getBoundingClientRect(),
		container: element.closest(".monaco-workbench") ?? getWindow(element).document.body
	};
}
var confettiColors = [
	"var(--vscode-charts-red)",
	"var(--vscode-charts-orange)",
	"var(--vscode-charts-yellow)",
	"var(--vscode-charts-green)",
	"var(--vscode-charts-blue)",
	"var(--vscode-charts-purple)"
];
var defaultConfettiLaunchDuration = {
	min: 280,
	max: 380
};
var defaultConfettiFallDuration = {
	min: 1700,
	max: 2100
};
var defaultConfettiFallDistance = {
	min: 90,
	max: 130
};
function randomInRange(range) {
	return range.min + Math.random() * (range.max - range.min);
}
/**
* Creates a fixed-positioned overlay centered on the live or captured target.
*/
function createOverlay(target) {
	const { element, rect, container } = isHTMLElement(target) ? captureAnimationTarget(target) : target;
	const overlay = $$10(".animation-overlay");
	overlay.style.position = "fixed";
	overlay.style.left = `${rect.left}px`;
	overlay.style.top = `${rect.top}px`;
	overlay.style.width = `${rect.width}px`;
	overlay.style.height = `${rect.height}px`;
	overlay.style.pointerEvents = "none";
	overlay.style.overflow = "visible";
	overlay.style.zIndex = "10000";
	container.appendChild(overlay);
	return {
		overlay,
		cx: rect.width / 2,
		cy: rect.height / 2,
		element,
		rect
	};
}
/**
* Cleans up the overlay after specified period.
*/
function cleanupOverlay(overlay, duration) {
	getWindow(overlay).setTimeout(() => {
		overlay.remove();
	}, duration);
}
/**
* Bounce the element with a given scale and optional rotation.
*/
function bounceElement(element, opts) {
	const frames = [];
	const steps = Math.max(opts.scale?.length ?? 0, opts.rotate?.length ?? 0, opts.translateY?.length ?? 0);
	if (steps === 0) return;
	for (let i = 0; i < steps; i++) {
		const frame = { offset: steps === 1 ? 1 : i / (steps - 1) };
		let transformParts = "";
		const scale = opts.scale?.[i];
		if (scale !== void 0) transformParts += `scale(${scale})`;
		const rotate = opts.rotate?.[i];
		if (rotate !== void 0) transformParts += ` rotate(${rotate}deg)`;
		const translateY = opts.translateY?.[i];
		if (translateY !== void 0) transformParts += ` translateY(${translateY}px)`;
		if (transformParts) frame.transform = transformParts.trim();
		frames.push(frame);
	}
	element.animate(frames, {
		duration: opts.duration ?? 350,
		easing: "cubic-bezier(0.4, 0, 0.2, 1)",
		fill: "forwards"
	});
}
/**
* Confetti: colorful particles burst upward from the element center and fall.
*/
function triggerConfettiAnimation(target, options = {}) {
	const { overlay, cx, cy, element } = createOverlay(target);
	const launchDuration = options.launchDuration ?? defaultConfettiLaunchDuration;
	const fallDuration = options.fallDuration ?? defaultConfettiFallDuration;
	const fallDistance = options.fallDistance ?? defaultConfettiFallDistance;
	bounceElement(element, {
		scale: [
			1,
			1.3,
			1
		],
		rotate: [
			0,
			-10,
			10,
			0
		],
		duration: 350
	});
	const particleCount = 24;
	for (let i = 0; i < particleCount; i++) {
		const width = 4 + i % 3 * 1.5;
		const height = 3 + (i + 1) % 3;
		const angle = (-160 + Math.random() * 140) * Math.PI / 180;
		const distance = 30 + Math.random() * 30;
		const peakX = Math.cos(angle) * distance;
		const peakY = Math.sin(angle) * distance;
		const endX = peakX * 1.4 + (Math.random() - .5) * 20;
		const endY = peakY + randomInRange(fallDistance);
		const rotation = (Math.random() - .5) * 720;
		const particleLaunchDuration = randomInRange(launchDuration);
		const particleDuration = particleLaunchDuration + randomInRange(fallDuration);
		const launchMidpointOffset = particleLaunchDuration * .4 / particleDuration;
		const apexOffset = particleLaunchDuration / particleDuration;
		const part = $$10(".animation-particle.animation-confetti-particle");
		part.style.position = "absolute";
		part.style.width = `${width}px`;
		part.style.height = `${height}px`;
		part.style.borderRadius = i % 4 === 0 ? "50%" : "1px";
		part.style.backgroundColor = confettiColors[i % confettiColors.length];
		part.style.left = `${cx}px`;
		part.style.top = `${cy}px`;
		overlay.appendChild(part);
		const keyframes = [
			{
				opacity: 0,
				transform: "translate(-50%, -50%) scale(0) rotate(0deg)",
				easing: "cubic-bezier(0.15, 0.75, 0.25, 1)"
			},
			{
				opacity: 1,
				transform: `translate(calc(-50% + ${peakX * .35}px), calc(-50% + ${peakY * .55}px)) scale(1) rotate(${rotation * .2}deg)`,
				offset: launchMidpointOffset,
				easing: "cubic-bezier(0.2, 0.7, 0.3, 1)"
			},
			{
				opacity: 1,
				transform: `translate(calc(-50% + ${peakX}px), calc(-50% + ${peakY}px)) rotate(${rotation * .5}deg)`,
				offset: apexOffset,
				easing: "linear"
			},
			{
				opacity: 0,
				transform: `translate(calc(-50% + ${endX}px), calc(-50% + ${endY}px)) rotate(${rotation}deg)`
			}
		];
		part.animate(keyframes, {
			duration: particleDuration,
			delay: Math.random() * 100,
			fill: "both"
		});
	}
	cleanupOverlay(overlay, launchDuration.max + fallDuration.max + 200);
}
/**
* Floating Icons: small icons float upward from the element.
*/
function triggerFloatingIconsAnimation(target, icon) {
	const { overlay, cx, cy, element, rect } = createOverlay(target);
	bounceElement(element, {
		translateY: [
			0,
			-6,
			0
		],
		duration: 350
	});
	const iconCount = 6;
	for (let i = 0; i < iconCount; i++) {
		const size = 12 + i % 3 * 2;
		const iconEl = $$10(".animation-particle");
		iconEl.style.position = "absolute";
		iconEl.style.left = `${cx}px`;
		iconEl.style.top = `${cy}px`;
		iconEl.style.fontSize = `${size}px`;
		iconEl.style.lineHeight = "1";
		iconEl.style.color = "var(--vscode-focusBorder, #007acc)";
		iconEl.classList.add(...ThemeIcon.asClassNameArray(icon));
		overlay.appendChild(iconEl);
		const driftX = (Math.random() - .5) * 50;
		const floatY = -50 - i % 3 * 10;
		const rotate1 = (Math.random() - .5) * 20;
		const rotate2 = (Math.random() - .5) * 40;
		iconEl.animate([
			{
				opacity: 0,
				transform: `translate(-50%, -50%) scale(0) rotate(${rotate1}deg)`
			},
			{
				opacity: 1,
				transform: `translate(calc(-50% + ${driftX * .3}px), calc(-50% + ${floatY * .3}px)) scale(1) rotate(${(rotate1 + rotate2) * .3}deg)`,
				offset: .3
			},
			{
				opacity: 1,
				transform: `translate(calc(-50% + ${driftX * .7}px), calc(-50% + ${floatY * .7}px)) scale(1) rotate(${(rotate1 + rotate2) * .7}deg)`,
				offset: .7
			},
			{
				opacity: 0,
				transform: `translate(calc(-50% + ${driftX}px), calc(-50% + ${floatY}px)) scale(0.8) rotate(${rotate2}deg)`
			}
		], {
			duration: 800 + i % 3 * 200,
			delay: i * 80,
			easing: "cubic-bezier(0.4, 0, 0.2, 1)",
			fill: "forwards"
		});
	}
	const ring = $$10(".animation-particle");
	ring.style.position = "absolute";
	ring.style.left = "0";
	ring.style.top = "0";
	ring.style.width = `${rect.width}px`;
	ring.style.height = `${rect.height}px`;
	ring.style.borderRadius = "50%";
	ring.style.border = "2px solid var(--vscode-focusBorder, #007acc)";
	ring.style.boxSizing = "border-box";
	overlay.appendChild(ring);
	ring.animate([{
		transform: "scale(1)",
		opacity: 1
	}, {
		transform: "scale(2)",
		opacity: 0
	}], {
		duration: 500,
		easing: "cubic-bezier(0.4, 0, 0.2, 1)",
		fill: "forwards"
	});
	cleanupOverlay(overlay, 2e3);
}
/**
* Pulse Wave: expanding rings and sparkle dots radiate from the element center.
*/
function triggerPulseWaveAnimation(target) {
	const { overlay, cx, cy, element, rect } = createOverlay(target);
	bounceElement(element, {
		scale: [
			1,
			1.1,
			1
		],
		rotate: [
			0,
			-12,
			0
		],
		duration: 400
	});
	for (let i = 0; i < 2; i++) {
		const ring = $$10(".animation-particle");
		ring.style.position = "absolute";
		ring.style.left = "0";
		ring.style.top = "0";
		ring.style.width = `${rect.width}px`;
		ring.style.height = `${rect.height}px`;
		ring.style.borderRadius = "50%";
		ring.style.border = "2px solid var(--vscode-focusBorder, #007acc)";
		ring.style.boxSizing = "border-box";
		overlay.appendChild(ring);
		ring.animate([
			{
				transform: "scale(0.8)",
				opacity: 0
			},
			{
				transform: "scale(0.8)",
				opacity: .6,
				offset: .01
			},
			{
				transform: "scale(2.5)",
				opacity: 0
			}
		], {
			duration: 800,
			delay: i * 150,
			easing: "cubic-bezier(0.4, 0, 0.2, 1)",
			fill: "forwards"
		});
	}
	for (let i = 0; i < 6; i++) {
		const angle = i * 60 * Math.PI / 180;
		const distance = 30 + i % 2 * 10;
		const size = 3.5;
		const dot = $$10(".animation-particle");
		dot.style.position = "absolute";
		dot.style.width = `${size}px`;
		dot.style.height = `${size}px`;
		dot.style.borderRadius = "50%";
		dot.style.backgroundColor = "#0098ff";
		dot.style.left = `${cx - size / 2}px`;
		dot.style.top = `${cy - size / 2}px`;
		overlay.appendChild(dot);
		const tx = Math.cos(angle) * distance;
		const ty = Math.sin(angle) * distance;
		dot.animate([
			{
				opacity: 0,
				transform: "scale(0) translate(0, 0)"
			},
			{
				opacity: 1,
				transform: `scale(1) translate(${tx}px, ${ty}px)`,
				offset: .5
			},
			{
				opacity: 0,
				transform: `scale(0) translate(${tx}px, ${ty}px)`
			}
		], {
			duration: 600,
			delay: 100 + i * 50,
			easing: "cubic-bezier(0.4, 0, 0.2, 1)",
			fill: "forwards"
		});
	}
	const glow = $$10(".animation-particle");
	glow.style.position = "absolute";
	glow.style.left = "0";
	glow.style.top = "0";
	glow.style.width = `${rect.width}px`;
	glow.style.height = `${rect.height}px`;
	glow.style.borderRadius = "50%";
	glow.style.backgroundColor = "var(--vscode-focusBorder, #007acc)";
	overlay.appendChild(glow);
	glow.animate([
		{
			transform: "scale(0.9)",
			opacity: 0
		},
		{
			transform: "scale(0.9)",
			opacity: .5,
			offset: .01
		},
		{
			transform: "scale(1.5)",
			opacity: 0
		}
	], {
		duration: 500,
		easing: "cubic-bezier(0.4, 0, 0.2, 1)",
		fill: "forwards"
	});
	cleanupOverlay(overlay, 2e3);
}
/**
* Radiant Lines: lines and dots emanate outward from the element center.
*/
function triggerRadiantLinesAnimation(target) {
	const { overlay, cx, cy, element } = createOverlay(target);
	bounceElement(element, {
		scale: [
			1,
			1.15,
			1
		],
		duration: 350
	});
	for (let i = 0; i < 8; i++) {
		const size = 3;
		const dotOpacity = .7;
		const angle = (i * 45 + 22.5) * Math.PI / 180;
		const startDistance = 14;
		const endDistance = 30;
		const dot = $$10(".animation-particle");
		dot.style.position = "absolute";
		dot.style.width = `${size}px`;
		dot.style.height = `${size}px`;
		dot.style.borderRadius = "50%";
		dot.style.backgroundColor = "var(--vscode-editor-foreground, #ffffff)";
		dot.style.left = `${cx - size / 2}px`;
		dot.style.top = `${cy - size / 2}px`;
		overlay.appendChild(dot);
		const startX = Math.cos(angle) * startDistance;
		const startY = Math.sin(angle) * startDistance;
		const endX = Math.cos(angle) * endDistance;
		const endY = Math.sin(angle) * endDistance;
		dot.animate([
			{
				opacity: 0,
				transform: `scale(0) translate(${startX}px, ${startY}px)`
			},
			{
				opacity: dotOpacity,
				transform: `scale(1.2) translate(${(startX + endX) / 2}px, ${(startY + endY) / 2}px)`,
				offset: .25
			},
			{
				opacity: dotOpacity,
				transform: `scale(1) translate(${endX * .8}px, ${endY * .8}px)`,
				offset: .5
			},
			{
				opacity: dotOpacity * .5,
				transform: `scale(1) translate(${endX}px, ${endY}px)`,
				offset: .75
			},
			{
				opacity: 0,
				transform: `scale(0.5) translate(${endX}px, ${endY}px)`
			}
		], {
			duration: 1100,
			easing: "cubic-bezier(0.4, 0, 0.2, 1)",
			fill: "forwards"
		});
	}
	for (let i = 0; i < 8; i++) {
		const angleDeg = i * 45;
		const lineWrapper = $$10(".animation-particle");
		lineWrapper.style.position = "absolute";
		lineWrapper.style.left = `${cx}px`;
		lineWrapper.style.top = `${cy}px`;
		lineWrapper.style.width = "0";
		lineWrapper.style.height = "0";
		lineWrapper.style.transform = `rotate(${angleDeg}deg)`;
		overlay.appendChild(lineWrapper);
		const line = $$10(".animation-particle");
		line.style.position = "absolute";
		line.style.width = "2px";
		line.style.height = "10px";
		line.style.backgroundColor = "var(--vscode-focusBorder, #007acc)";
		line.style.left = "-1px";
		line.style.top = "-22px";
		line.style.transformOrigin = "bottom center";
		lineWrapper.appendChild(line);
		line.animate([
			{
				transform: "scale(1, 0)",
				opacity: .6
			},
			{
				transform: "scale(1, 1)",
				opacity: .6,
				offset: .2
			},
			{
				transform: "scale(1, 1)",
				opacity: .6,
				offset: .6
			},
			{
				transform: "scale(1, 1)",
				opacity: .6,
				offset: .8
			},
			{
				transform: "scale(0, 0.3)",
				opacity: 0
			}
		], {
			duration: 1200,
			delay: 150,
			easing: "cubic-bezier(0.4, 0, 0.2, 1)",
			fill: "forwards"
		});
	}
	cleanupOverlay(overlay, 2e3);
}
/**
* Triggers the specified click animation on a live element or a captured target.
*/
function triggerClickAnimation(target, animation, icon) {
	switch (animation) {
		case 1:
			triggerConfettiAnimation(target);
			break;
		case 2:
			if (icon) triggerFloatingIconsAnimation(target, icon);
			break;
		case 3:
			triggerPulseWaveAnimation(target);
			break;
		case 4: triggerRadiantLinesAnimation(target);
	}
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/window/common/window.js
function hasNativeContextMenu(configurationService, titleBarStyle) {
	if (isWeb) return false;
	const nativeTitle = hasNativeTitlebar(configurationService, titleBarStyle);
	const windowConfigurations = configurationService.getValue("window");
	if (windowConfigurations?.menuStyle === "native") {
		if (!isMacintosh && !nativeTitle) return false;
		return true;
	}
	if (windowConfigurations?.menuStyle === "custom") return false;
	return nativeTitle;
}
function hasNativeTitlebar(configurationService, titleBarStyle) {
	if (!titleBarStyle) titleBarStyle = getTitleBarStyle(configurationService);
	return titleBarStyle === "native";
}
function getTitleBarStyle(configurationService) {
	if (isWeb) return "custom";
	const configuration = configurationService.getValue("window");
	if (configuration) {
		if (isMacintosh && configuration.nativeTabs === true) return "native";
		if (isMacintosh && configuration.nativeFullScreen === false) return "native";
		const style = configuration.titleBarStyle;
		if (style === "native" || style === "custom") return style;
	}
	return "custom";
}
function getWindowControlsStyle(configurationService) {
	if (isWeb || isMacintosh || getTitleBarStyle(configurationService) === "native") return "native";
	const style = configurationService.getValue("window")?.controlsStyle;
	if (style === "custom" || style === "hidden") return style;
	return "native";
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/actions/browser/menuEntryActionViewItem.js
var __decorate$35 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$32 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
function getFlatContextMenuActions(groups, primaryGroup) {
	const target = [];
	getContextMenuActionsImpl(groups, target);
	return target;
}
function getContextMenuActionsImpl(groups, target, primaryGroup) {
	const modifierKeyEmitter = ModifierKeyEmitter.getInstance();
	fillInActions(groups, target, modifierKeyEmitter.keyStatus.altKey || (isWindows || isLinux) && modifierKeyEmitter.keyStatus.shiftKey, (actionGroup) => actionGroup === "navigation");
}
function getActionBarActions(groups, primaryGroup, shouldInlineSubmenu, useSeparatorsInPrimaryActions) {
	const target = {
		primary: [],
		secondary: []
	};
	fillInActionBarActions(groups, target, primaryGroup, shouldInlineSubmenu, useSeparatorsInPrimaryActions);
	return target;
}
function getFlatActionBarActions(groups, primaryGroup, shouldInlineSubmenu, useSeparatorsInPrimaryActions) {
	const target = [];
	fillInActionBarActions(groups, target, primaryGroup, shouldInlineSubmenu, useSeparatorsInPrimaryActions);
	return target;
}
function fillInActionBarActions(groups, target, primaryGroup, shouldInlineSubmenu, useSeparatorsInPrimaryActions) {
	fillInActions(groups, target, false, typeof primaryGroup === "string" ? (actionGroup) => actionGroup === primaryGroup : primaryGroup, shouldInlineSubmenu, useSeparatorsInPrimaryActions);
}
function fillInActions(groups, target, useAlternativeActions, isPrimaryAction = (actionGroup) => actionGroup === "navigation", shouldInlineSubmenu = () => false, useSeparatorsInPrimaryActions = false) {
	let primaryBucket;
	let secondaryBucket;
	if (Array.isArray(target)) {
		primaryBucket = target;
		secondaryBucket = target;
	} else {
		primaryBucket = target.primary;
		secondaryBucket = target.secondary;
	}
	const submenuInfo = /* @__PURE__ */ new Set();
	for (const [group, actions] of groups) {
		let target;
		if (isPrimaryAction(group)) {
			target = primaryBucket;
			if (target.length > 0 && useSeparatorsInPrimaryActions) target.push(new Separator());
		} else {
			target = secondaryBucket;
			if (target.length > 0) target.push(new Separator());
		}
		for (let action of actions) {
			if (useAlternativeActions) action = action instanceof MenuItemAction && action.alt ? action.alt : action;
			const newLen = target.push(action);
			if (action instanceof SubmenuAction) submenuInfo.add({
				group,
				action,
				index: newLen - 1
			});
		}
	}
	for (const { group, action, index } of submenuInfo) {
		const target = isPrimaryAction(group) ? primaryBucket : secondaryBucket;
		const submenuActions = action.actions;
		if (shouldInlineSubmenu(action, group, target.length)) target.splice(index, 1, ...submenuActions);
	}
}
var MenuEntryActionViewItem = class MenuEntryActionViewItem extends ActionViewItem {
	constructor(action, _options, _keybindingService, _notificationService, _contextKeyService, _themeService, _contextMenuService, _accessibilityService) {
		super(void 0, action, {
			icon: !!(action.class || action.item.icon),
			label: !action.class && !action.item.icon,
			draggable: _options?.draggable,
			keybinding: _options?.keybinding,
			hoverDelegate: _options?.hoverDelegate,
			keybindingNotRenderedWithLabel: _options?.keybindingNotRenderedWithLabel
		});
		this._options = _options;
		this._keybindingService = _keybindingService;
		this._notificationService = _notificationService;
		this._contextKeyService = _contextKeyService;
		this._themeService = _themeService;
		this._contextMenuService = _contextMenuService;
		this._accessibilityService = _accessibilityService;
		this._wantsAltCommand = false;
		this._itemClassDispose = this._register(new MutableDisposable());
		this._altKey = ModifierKeyEmitter.getInstance();
	}
	get _menuItemAction() {
		return this._action;
	}
	get _commandAction() {
		return this._wantsAltCommand && this._menuItemAction.alt || this._menuItemAction;
	}
	async onClick(event) {
		event.preventDefault();
		event.stopPropagation();
		const commandAction = this._commandAction;
		let actionError;
		const actionRunnerListener = this.actionRunner.onDidRun((event) => {
			if (event.action === commandAction) actionError = event.error;
		});
		try {
			const animationTarget = this._options?.onClickAnimation && this.element ? captureAnimationTarget(this.element) : void 0;
			await this.actionRunner.run(commandAction, this._context);
			if (!actionError && this._options?.onClickAnimation && animationTarget && !this._accessibilityService.isMotionReduced()) {
				const icon = this._menuItemAction.item.icon;
				triggerClickAnimation(animationTarget, this._options.onClickAnimation, ThemeIcon.isThemeIcon(icon) ? icon : void 0);
			}
		} catch (err) {
			this._notificationService.error(err);
		} finally {
			actionRunnerListener.dispose();
		}
	}
	render(container) {
		super.render(container);
		container.classList.add("menu-entry");
		if (this.options.icon) this._updateItemClass(this._menuItemAction.item);
		if (this._menuItemAction.alt) {
			let isMouseOver = false;
			const updateAltState = () => {
				const wantsAltCommand = !!this._menuItemAction.alt?.enabled && (!this._accessibilityService.isMotionReduced() || isMouseOver) && (this._altKey.keyStatus.altKey || this._altKey.keyStatus.shiftKey && isMouseOver);
				if (wantsAltCommand !== this._wantsAltCommand) {
					this._wantsAltCommand = wantsAltCommand;
					this.updateLabel();
					this.updateTooltip();
					this.updateClass();
				}
			};
			this._register(this._altKey.event(updateAltState));
			this._register(addDisposableListener(container, "mouseleave", (_) => {
				isMouseOver = false;
				updateAltState();
			}));
			this._register(addDisposableListener(container, "mouseenter", (_) => {
				isMouseOver = true;
				updateAltState();
			}));
			updateAltState();
		}
	}
	updateLabel() {
		if (this.options.label && this.label) this.label.textContent = this._commandAction.label;
	}
	getTooltip() {
		const tooltip = this._commandAction.tooltip || this._commandAction.label;
		let title = this._keybindingService.appendKeybinding(tooltip, this._commandAction.id, this._contextKeyService);
		if (!this._wantsAltCommand && this._menuItemAction.alt?.enabled) {
			const altTooltip = this._menuItemAction.alt.tooltip || this._menuItemAction.alt.label;
			const altTitleSection = this._keybindingService.appendKeybinding(altTooltip, this._menuItemAction.alt.id, this._contextKeyService);
			title = localize(1724, "{0}\n[{1}] {2}", title, UILabelProvider.modifierLabels[OS].altKey, altTitleSection);
		}
		return title;
	}
	updateClass() {
		if (this.options.icon) {
			if (this._commandAction !== this._menuItemAction) {
				if (this._menuItemAction.alt) this._updateItemClass(this._menuItemAction.alt.item);
			} else this._updateItemClass(this._menuItemAction.item);
		}
	}
	_updateItemClass(item) {
		this._itemClassDispose.value = void 0;
		const { element, label } = this;
		if (!element || !label) return;
		const icon = this._commandAction.checked && isICommandActionToggleInfo(item.toggled) && item.toggled.icon ? item.toggled.icon : item.icon;
		if (!icon) return;
		if (ThemeIcon.isThemeIcon(icon)) {
			const iconClasses = ThemeIcon.asClassNameArray(icon);
			label.classList.add(...iconClasses);
			this._itemClassDispose.value = toDisposable(() => {
				label.classList.remove(...iconClasses);
			});
		} else {
			label.style.backgroundImage = isDark(this._themeService.getColorTheme().type) ? asCSSUrl(icon.dark) : asCSSUrl(icon.light);
			label.classList.add("icon");
			this._itemClassDispose.value = combinedDisposable(toDisposable(() => {
				label.style.backgroundImage = "";
				label.classList.remove("icon");
			}), this._themeService.onDidColorThemeChange(() => {
				this.updateClass();
			}));
		}
	}
};
MenuEntryActionViewItem = __decorate$35([
	__param$32(2, IKeybindingService),
	__param$32(3, INotificationService),
	__param$32(4, IContextKeyService),
	__param$32(5, IThemeService),
	__param$32(6, IContextMenuService),
	__param$32(7, IAccessibilityService)
], MenuEntryActionViewItem);
var TextOnlyMenuEntryActionViewItem = class TextOnlyMenuEntryActionViewItem extends MenuEntryActionViewItem {
	render(container) {
		this.options.label = true;
		this.options.icon = false;
		super.render(container);
		container.classList.add("text-only");
		container.classList.toggle("use-comma", this._options?.useComma ?? false);
	}
	updateLabel() {
		const kb = this._keybindingService.lookupKeybinding(this._action.id, this._contextKeyService);
		if (!kb) return super.updateLabel();
		if (this.label) {
			const kb2 = TextOnlyMenuEntryActionViewItem._symbolPrintEnter(kb);
			if (this._options?.conversational) this.label.textContent = localize(1725, "{1} to {0}", this._action.label, kb2);
			else this.label.textContent = localize(1726, "{0} ({1})", this._action.label, kb2);
		}
	}
	static _symbolPrintEnter(kb) {
		return kb.getLabel()?.replace(/\benter\b/gi, "⏎").replace(/\bEscape\b/gi, "Esc");
	}
};
var SubmenuEntryActionViewItem = class SubmenuEntryActionViewItem extends DropdownMenuActionViewItem {
	constructor(action, options, _keybindingService, _contextMenuService, _themeService) {
		const dropdownOptions = {
			...options,
			menuAsChild: options?.menuAsChild ?? false,
			classNames: options?.classNames ?? (ThemeIcon.isThemeIcon(action.item.icon) ? ThemeIcon.asClassName(action.item.icon) : void 0),
			keybindingProvider: options?.keybindingProvider ?? ((action) => _keybindingService.lookupKeybinding(action.id))
		};
		super(action, { getActions: () => action.actions }, _contextMenuService, dropdownOptions);
		this._keybindingService = _keybindingService;
		this._contextMenuService = _contextMenuService;
		this._themeService = _themeService;
	}
	render(container) {
		super.render(container);
		assertType(this.element);
		container.classList.add("menu-entry");
		const { icon } = this._action.item;
		if (icon && !ThemeIcon.isThemeIcon(icon)) {
			this.element.classList.add("icon");
			const setBackgroundImage = () => {
				if (this.element) this.element.style.backgroundImage = isDark(this._themeService.getColorTheme().type) ? asCSSUrl(icon.dark) : asCSSUrl(icon.light);
			};
			setBackgroundImage();
			this._register(this._themeService.onDidColorThemeChange(() => {
				setBackgroundImage();
			}));
		}
	}
};
SubmenuEntryActionViewItem = __decorate$35([
	__param$32(2, IKeybindingService),
	__param$32(3, IContextMenuService),
	__param$32(4, IThemeService)
], SubmenuEntryActionViewItem);
var DropdownWithDefaultActionViewItem = class DropdownWithDefaultActionViewItem extends BaseActionViewItem {
	constructor(submenuAction, options, _keybindingService, _notificationService, _contextMenuService, _menuService, _instaService, _storageService, _commandService) {
		super(null, submenuAction);
		this._keybindingService = _keybindingService;
		this._notificationService = _notificationService;
		this._contextMenuService = _contextMenuService;
		this._menuService = _menuService;
		this._instaService = _instaService;
		this._storageService = _storageService;
		this._commandService = _commandService;
		this._defaultActionDisposables = this._register(new DisposableStore());
		this._container = null;
		this._primaryActionListener = this._register(new MutableDisposable());
		this._options = options;
		this._storageKey = `${submenuAction.item.submenu.id}_lastActionId`;
		let defaultAction;
		const defaultActionId = options?.togglePrimaryAction ? _storageService.get(this._storageKey, 1) : void 0;
		if (defaultActionId) defaultAction = submenuAction.actions.find((a) => defaultActionId === a.id && this._canBePrimaryAction(a));
		if (!defaultAction) defaultAction = submenuAction.actions.find((action) => this._canBePrimaryAction(action)) ?? submenuAction.actions[0];
		this._defaultAction = this._defaultActionDisposables.add(this._instaService.createInstance(MenuEntryActionViewItem, defaultAction, {
			keybinding: this._getDefaultActionKeybindingLabel(defaultAction),
			hoverDelegate: options?.hoverDelegate
		}));
		const dropdownOptions = {
			keybindingProvider: (action) => this._keybindingService.lookupKeybinding(action.id),
			...options,
			menuAsChild: options?.menuAsChild ?? true,
			classNames: options?.classNames ?? ["codicon", "codicon-chevron-down"],
			actionRunner: options?.actionRunner ?? this._register(new ActionRunner())
		};
		this._dropdown = this._register(new DropdownMenuActionViewItem(submenuAction, submenuAction.actions, this._contextMenuService, dropdownOptions));
		if (options?.togglePrimaryAction) this.registerTogglePrimaryActionListener();
	}
	registerTogglePrimaryActionListener() {
		this._primaryActionListener.value = this._options?.primaryActionIds?.length ? this._commandService.onDidExecuteCommand((event) => {
			const action = this._action.actions.find((action) => action.id === event.commandId);
			if (action instanceof MenuItemAction && this._canBePrimaryAction(action)) this.update(action);
		}) : this._dropdown.actionRunner.onDidRun((e) => {
			if (e.action instanceof MenuItemAction) this.update(e.action);
		});
	}
	update(lastAction) {
		if (!this._canBePrimaryAction(lastAction)) return;
		if (this._options?.togglePrimaryAction) {
			if (this._storageService.get(this._storageKey, 1) !== lastAction.id) this._storageService.store(this._storageKey, lastAction.id, 1, 1);
		}
		if (this._defaultAction.action.id === lastAction.id) return;
		this._defaultActionDisposables.clear();
		this._defaultAction = this._defaultActionDisposables.add(this._instaService.createInstance(MenuEntryActionViewItem, lastAction, {
			keybinding: this._getDefaultActionKeybindingLabel(lastAction),
			hoverDelegate: this._options?.hoverDelegate
		}));
		this._defaultAction.actionRunner = this._defaultActionDisposables.add(new class extends ActionRunner {
			async runAction(action, context) {
				await action.run(void 0);
			}
		}());
		if (this._container) this._defaultAction.render(prepend$2(this._container, $$10(".action-container")));
	}
	_canBePrimaryAction(action) {
		return !this._options?.primaryActionIds?.length || this._options.primaryActionIds.includes(action.id);
	}
	_getDefaultActionKeybindingLabel(defaultAction) {
		let defaultActionKeybinding;
		if (this._options?.renderKeybindingWithDefaultActionLabel) {
			const kb = this._keybindingService.lookupKeybinding(defaultAction.id);
			if (kb) defaultActionKeybinding = `(${kb.getLabel()})`;
		}
		return defaultActionKeybinding;
	}
	setActionContext(newContext) {
		super.setActionContext(newContext);
		this._defaultAction.setActionContext(newContext);
		this._dropdown.setActionContext(newContext);
	}
	set actionRunner(actionRunner) {
		super.actionRunner = actionRunner;
		this._defaultAction.actionRunner = actionRunner;
		if (!this._options?.togglePrimaryAction || this._options.primaryActionIds?.length) this._dropdown.actionRunner = actionRunner;
	}
	get actionRunner() {
		return super.actionRunner;
	}
	render(container) {
		this._container = container;
		super.render(this._container);
		this._container.classList.add("monaco-dropdown-with-default");
		const primaryContainer = $$10(".action-container");
		this._defaultAction.render(append$2(this._container, primaryContainer));
		this._register(addDisposableListener(primaryContainer, EventType$1.KEY_DOWN, (e) => {
			const event = new StandardKeyboardEvent(e);
			if (event.equals(17)) {
				this._defaultAction.element.tabIndex = -1;
				this._dropdown.focus();
				event.stopPropagation();
			}
		}));
		const dropdownContainer = $$10(".dropdown-action-container");
		this._dropdown.render(append$2(this._container, dropdownContainer));
		this._register(addDisposableListener(dropdownContainer, EventType$1.KEY_DOWN, (e) => {
			const event = new StandardKeyboardEvent(e);
			if (event.equals(15)) {
				this._defaultAction.element.tabIndex = 0;
				this._dropdown.setFocusable(false);
				this._defaultAction.element?.focus();
				event.stopPropagation();
			}
		}));
	}
	focus(fromRight) {
		if (fromRight) this._dropdown.focus();
		else {
			this._defaultAction.element.tabIndex = 0;
			this._defaultAction.element.focus();
		}
	}
	blur() {
		this._defaultAction.element.tabIndex = -1;
		this._dropdown.blur();
		this._container.blur();
	}
	setFocusable(focusable) {
		if (focusable) this._defaultAction.element.tabIndex = 0;
		else {
			this._defaultAction.element.tabIndex = -1;
			this._dropdown.setFocusable(false);
		}
	}
};
DropdownWithDefaultActionViewItem = __decorate$35([
	__param$32(2, IKeybindingService),
	__param$32(3, INotificationService),
	__param$32(4, IContextMenuService),
	__param$32(5, IMenuService),
	__param$32(6, IInstantiationService),
	__param$32(7, IStorageService),
	__param$32(8, ICommandService)
], DropdownWithDefaultActionViewItem);
var SubmenuEntrySelectActionViewItem = class SubmenuEntrySelectActionViewItem extends SelectActionViewItem {
	constructor(action, contextViewService, configurationService) {
		super(null, action, action.actions.map((a) => a.id === Separator.ID ? SeparatorSelectOption : {
			text: a.label,
			isDisabled: !a.enabled
		}), 0, contextViewService, defaultSelectBoxStyles, {
			ariaLabel: action.tooltip || action.label,
			optionsAsChildren: true,
			useCustomDrawn: !hasNativeContextMenu(configurationService)
		});
		this.select(Math.max(0, action.actions.findIndex((a) => a.checked)));
	}
	render(container) {
		super.render(container);
		container.style.borderColor = asCssVariable(selectBorder);
	}
	runAction(option, index) {
		const action = this.action.actions[index];
		if (action) this.actionRunner.run(action);
	}
};
SubmenuEntrySelectActionViewItem = __decorate$35([__param$32(1, IContextViewService), __param$32(2, IConfigurationService)], SubmenuEntrySelectActionViewItem);
/**
* Creates action view items for menu actions or submenu actions.
*/
function createActionViewItem(instaService, action, options) {
	if (action instanceof MenuItemAction) return instaService.createInstance(MenuEntryActionViewItem, action, options);
	else if (action instanceof SubmenuItemAction) {
		if (action.item.isSelection) return instaService.createInstance(SubmenuEntrySelectActionViewItem, action);
		else if (action.item.isSplitButton) return instaService.createInstance(DropdownWithDefaultActionViewItem, action, {
			...options,
			togglePrimaryAction: typeof action.item.isSplitButton !== "boolean" ? action.item.isSplitButton.togglePrimaryAction : false,
			primaryActionIds: typeof action.item.isSplitButton !== "boolean" ? action.item.isSplitButton.primaryActionIds : void 0
		});
		else return instaService.createInstance(SubmenuEntryActionViewItem, action, options);
	} else return;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/actionbar/actionbar.js
var ActionBar = class extends Disposable {
	get viewItems() {
		return this._viewItems;
	}
	get onDidBlur() {
		return this._onDidBlur.event;
	}
	get onDidCancel() {
		return this._onDidCancel.event;
	}
	get onDidRun() {
		return this._onDidRun.event;
	}
	get onWillRun() {
		return this._onWillRun.event;
	}
	constructor(container, options = {}) {
		super();
		this._actionRunnerDisposables = this._register(new DisposableStore());
		this.viewItemDisposables = this._register(new DisposableMap());
		this.triggerKeyDown = false;
		this.focusable = true;
		this._onDidBlur = this._register(new Emitter$1());
		this._onDidCancel = this._register(new Emitter$1({ onWillAddFirstListener: () => this.cancelHasListener = true }));
		this.cancelHasListener = false;
		this._onDidRun = this._register(new Emitter$1());
		this._onWillRun = this._register(new Emitter$1());
		this.options = options;
		this._context = options.context ?? null;
		this._orientation = this.options.orientation ?? 0;
		this._triggerKeys = {
			keyDown: this.options.triggerKeys?.keyDown ?? false,
			keys: this.options.triggerKeys?.keys ?? [3, 10]
		};
		this._hoverDelegate = options.hoverDelegate ?? this._register(createInstantHoverDelegate());
		if (this.options.actionRunner) this._actionRunner = this.options.actionRunner;
		else {
			this._actionRunner = new ActionRunner();
			this._actionRunnerDisposables.add(this._actionRunner);
		}
		this._actionRunnerDisposables.add(this._actionRunner.onDidRun((e) => this._onDidRun.fire(e)));
		this._actionRunnerDisposables.add(this._actionRunner.onWillRun((e) => this._onWillRun.fire(e)));
		this._viewItems = [];
		this.focusedItem = void 0;
		this.domNode = document.createElement("div");
		this.domNode.className = "monaco-action-bar";
		let previousKeys;
		let nextKeys;
		switch (this._orientation) {
			case 0:
				previousKeys = [15];
				nextKeys = [17];
				break;
			case 1:
				previousKeys = [16];
				nextKeys = [18];
				this.domNode.className += " vertical";
		}
		this._register(addDisposableListener(this.domNode, EventType$1.KEY_DOWN, (e) => {
			const event = new StandardKeyboardEvent(e);
			let eventHandled = true;
			const focusedItem = typeof this.focusedItem === "number" ? this.viewItems[this.focusedItem] : void 0;
			if (previousKeys && (event.equals(previousKeys[0]) || event.equals(previousKeys[1]))) eventHandled = this.focusPrevious();
			else if (nextKeys && (event.equals(nextKeys[0]) || event.equals(nextKeys[1]))) eventHandled = this.focusNext();
			else if (event.equals(9) && this.cancelHasListener) this._onDidCancel.fire();
			else if (event.equals(14)) eventHandled = this.focusFirst();
			else if (event.equals(13)) eventHandled = this.focusLast();
			else if (event.equals(2) && focusedItem instanceof BaseActionViewItem && focusedItem.trapsArrowNavigation) eventHandled = this.focusNext(void 0, true);
			else if (this.isTriggerKeyEvent(event)) {
				if (this._triggerKeys.keyDown) this.doTrigger(event);
				else this.triggerKeyDown = true;
			} else eventHandled = false;
			if (eventHandled) {
				event.preventDefault();
				event.stopPropagation();
			}
		}));
		this._register(addDisposableListener(this.domNode, EventType$1.KEY_UP, (e) => {
			const event = new StandardKeyboardEvent(e);
			if (this.isTriggerKeyEvent(event)) {
				if (!this._triggerKeys.keyDown && this.triggerKeyDown) {
					this.triggerKeyDown = false;
					this.doTrigger(event);
				}
				event.preventDefault();
				event.stopPropagation();
			} else if (event.equals(2) || event.equals(1026) || event.equals(16) || event.equals(18) || event.equals(15) || event.equals(17)) this.updateFocusedItem();
		}));
		this.focusTracker = this._register(trackFocus(this.domNode));
		this._register(this.focusTracker.onDidBlur(() => {
			if (getActiveElement() === this.domNode || !isAncestor$1(getActiveElement(), this.domNode)) {
				this._onDidBlur.fire();
				this.previouslyFocusedItem = this.focusedItem;
				this.focusedItem = void 0;
				this.triggerKeyDown = false;
			}
		}));
		this._register(this.focusTracker.onDidFocus(() => this.updateFocusedItem()));
		this.actionsList = document.createElement("ul");
		this.actionsList.className = "actions-container";
		if (this.options.highlightToggledItems) this.actionsList.classList.add("highlight-toggled");
		this.actionsList.setAttribute("role", this.options.ariaRole || "toolbar");
		if (this.options.ariaLabel) this.actionsList.setAttribute("aria-label", this.options.ariaLabel);
		this.domNode.appendChild(this.actionsList);
		container.appendChild(this.domNode);
	}
	refreshRole() {
		if (this.length() >= 1) this.actionsList.setAttribute("role", this.options.ariaRole || "toolbar");
		else this.actionsList.setAttribute("role", "presentation");
	}
	setFocusable(focusable) {
		this.focusable = focusable;
		if (this.focusable) {
			const firstEnabled = this.viewItems.find((vi) => vi instanceof BaseActionViewItem && vi.isEnabled());
			if (firstEnabled instanceof BaseActionViewItem) firstEnabled.setFocusable(true);
		} else this.viewItems.forEach((vi) => {
			if (vi instanceof BaseActionViewItem) vi.setFocusable(false);
		});
	}
	isTriggerKeyEvent(event) {
		let ret = false;
		this._triggerKeys.keys.forEach((keyCode) => {
			ret = ret || event.equals(keyCode);
		});
		return ret;
	}
	updateFocusedItem() {
		for (let i = 0; i < this.actionsList.children.length; i++) {
			const elem = this.actionsList.children[i];
			if (isAncestor$1(getActiveElement(), elem)) {
				this.focusedItem = i;
				this.viewItems[this.focusedItem]?.showHover?.();
				break;
			}
		}
	}
	get context() {
		return this._context;
	}
	set context(context) {
		this._context = context;
		this.viewItems.forEach((i) => i.setActionContext(context));
	}
	get actionRunner() {
		return this._actionRunner;
	}
	set actionRunner(actionRunner) {
		this._actionRunner = actionRunner;
		this._actionRunnerDisposables.clear();
		this._actionRunnerDisposables.add(this._actionRunner.onDidRun((e) => this._onDidRun.fire(e)));
		this._actionRunnerDisposables.add(this._actionRunner.onWillRun((e) => this._onWillRun.fire(e)));
		this.viewItems.forEach((item) => item.actionRunner = actionRunner);
	}
	getContainer() {
		return this.domNode;
	}
	hasAction(action) {
		return this.viewItems.findIndex((candidate) => candidate.action.id === action.id) !== -1;
	}
	getAction(indexOrElement) {
		if (typeof indexOrElement === "number") return this.viewItems[indexOrElement]?.action;
		if (isHTMLElement(indexOrElement)) {
			while (indexOrElement.parentElement !== this.actionsList) {
				if (!indexOrElement.parentElement) return;
				indexOrElement = indexOrElement.parentElement;
			}
			for (let i = 0; i < this.actionsList.childNodes.length; i++) if (this.actionsList.childNodes[i] === indexOrElement) return this.viewItems[i].action;
		}
	}
	push(arg, options = {}) {
		const actions = Array.isArray(arg) ? arg : [arg];
		let index = isNumber$1(options.index) ? options.index : null;
		actions.forEach((action) => {
			const actionViewItemElement = document.createElement("li");
			actionViewItemElement.className = "action-item";
			actionViewItemElement.setAttribute("role", "presentation");
			let item;
			const viewItemOptions = {
				hoverDelegate: this._hoverDelegate,
				...options,
				isTabList: this.options.ariaRole === "tablist"
			};
			if (this.options.actionViewItemProvider) item = this.options.actionViewItemProvider(action, viewItemOptions);
			if (!item) item = new ActionViewItem(this.context, action, viewItemOptions);
			if (!this.options.allowContextMenu) this.viewItemDisposables.set(item, addDisposableListener(actionViewItemElement, EventType$1.CONTEXT_MENU, (e) => {
				EventHelper.stop(e, true);
			}));
			item.actionRunner = this._actionRunner;
			item.setActionContext(this.context);
			item.render(actionViewItemElement);
			if (index === null || index < 0 || index >= this.actionsList.children.length) {
				this.actionsList.appendChild(actionViewItemElement);
				this._viewItems.push(item);
			} else {
				this.actionsList.insertBefore(actionViewItemElement, this.actionsList.children[index]);
				this._viewItems.splice(index, 0, item);
				index++;
			}
		});
		if (this.focusable) {
			let didFocus = false;
			for (const item of this.viewItems) {
				if (!(item instanceof BaseActionViewItem)) continue;
				let focus;
				if (didFocus) focus = false;
				else if (item.action.id === Separator.ID) focus = false;
				else if (!item.isEnabled() && this.options.focusOnlyEnabledItems) focus = false;
				else focus = true;
				if (focus) {
					item.setFocusable(true);
					didFocus = true;
				} else item.setFocusable(false);
			}
		}
		if (typeof this.focusedItem === "number") this.focus(this.focusedItem);
		this.refreshRole();
	}
	getWidth(index) {
		return this.actionsList.children.item(index)?.clientWidth ?? 0;
	}
	pull(index) {
		if (index >= 0 && index < this.viewItems.length) {
			this.actionsList.childNodes[index].remove();
			this.viewItemDisposables.deleteAndDispose(this.viewItems[index]);
			dispose(this._viewItems.splice(index, 1));
			this.refreshRole();
		}
	}
	clear() {
		if (this.isEmpty()) return;
		this._viewItems = dispose(this._viewItems);
		this.viewItemDisposables.clearAndDisposeAll();
		clearNode(this.actionsList);
		this.refreshRole();
	}
	length() {
		return this.viewItems.length;
	}
	isEmpty() {
		return this.viewItems.length === 0;
	}
	isFocused(index) {
		return index === void 0 ? isAncestor$1(getActiveElement(), this.domNode) : isAncestor$1(getActiveElement(), this.actionsList.children[index]);
	}
	focus(arg) {
		let selectFirst = false;
		let index = void 0;
		if (arg === void 0) selectFirst = true;
		else if (typeof arg === "number") index = arg;
		else if (typeof arg === "boolean") selectFirst = arg;
		if (selectFirst && typeof this.focusedItem === "undefined") {
			const firstEnabled = this.viewItems.findIndex((item) => item.isEnabled());
			this.focusedItem = firstEnabled === -1 ? void 0 : firstEnabled;
			this.updateFocus(void 0, void 0, true);
		} else {
			if (index !== void 0) this.focusedItem = index;
			this.updateFocus(void 0, void 0, true);
		}
	}
	focusFirst() {
		this.focusedItem = this.length() - 1;
		return this.focusNext(true);
	}
	focusLast() {
		this.focusedItem = 0;
		return this.focusPrevious(true);
	}
	focusNext(forceLoop, forceFocus) {
		if (typeof this.focusedItem === "undefined") this.focusedItem = this.viewItems.length - 1;
		else if (this.viewItems.length <= 1) return false;
		const startIndex = this.focusedItem;
		let item;
		do {
			if (!forceLoop && this.options.preventLoopNavigation && this.focusedItem + 1 >= this.viewItems.length) {
				this.focusedItem = startIndex;
				return false;
			}
			this.focusedItem = (this.focusedItem + 1) % this.viewItems.length;
			item = this.viewItems[this.focusedItem];
		} while (this.focusedItem !== startIndex && (this.options.focusOnlyEnabledItems && !item.isEnabled() || item.action.id === Separator.ID));
		this.updateFocus(void 0, void 0, forceFocus);
		return true;
	}
	focusPrevious(forceLoop) {
		if (typeof this.focusedItem === "undefined") this.focusedItem = 0;
		else if (this.viewItems.length <= 1) return false;
		const startIndex = this.focusedItem;
		let item;
		do {
			this.focusedItem = this.focusedItem - 1;
			if (this.focusedItem < 0) {
				if (!forceLoop && this.options.preventLoopNavigation) {
					this.focusedItem = startIndex;
					return false;
				}
				this.focusedItem = this.viewItems.length - 1;
			}
			item = this.viewItems[this.focusedItem];
		} while (this.focusedItem !== startIndex && (this.options.focusOnlyEnabledItems && !item.isEnabled() || item.action.id === Separator.ID));
		this.updateFocus(true);
		return true;
	}
	updateFocus(fromRight, preventScroll, forceFocus = false) {
		if (typeof this.focusedItem === "undefined") this.actionsList.focus({ preventScroll });
		if (this.previouslyFocusedItem !== void 0 && this.previouslyFocusedItem !== this.focusedItem) this.viewItems[this.previouslyFocusedItem]?.blur();
		const actionViewItem = this.focusedItem !== void 0 ? this.viewItems[this.focusedItem] : void 0;
		if (actionViewItem) {
			let focusItem = true;
			if (!isFunction(actionViewItem.focus)) focusItem = false;
			if (this.options.focusOnlyEnabledItems && isFunction(actionViewItem.isEnabled) && !actionViewItem.isEnabled()) focusItem = false;
			if (actionViewItem.action.id === Separator.ID) focusItem = false;
			if (!focusItem) {
				this.actionsList.focus({ preventScroll });
				this.previouslyFocusedItem = void 0;
			} else if (forceFocus || this.previouslyFocusedItem !== this.focusedItem) {
				actionViewItem.focus(fromRight);
				this.previouslyFocusedItem = this.focusedItem;
			}
			if (focusItem) actionViewItem.showHover?.();
		}
	}
	doTrigger(event) {
		if (typeof this.focusedItem === "undefined") return;
		const actionViewItem = this.viewItems[this.focusedItem];
		if (actionViewItem instanceof BaseActionViewItem) {
			const context = actionViewItem._context === null || actionViewItem._context === void 0 ? event : actionViewItem._context;
			this.run(actionViewItem._action, context);
		}
	}
	async run(action, context) {
		await this._actionRunner.run(action, context);
	}
	dispose() {
		this._context = void 0;
		this._viewItems = dispose(this._viewItems);
		this.getContainer().remove();
		super.dispose();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/menu/menu.js
var MENU_MNEMONIC_REGEX = /\(&([^\s&])\)|(^|[^&])&([^\s&])/;
var MENU_ESCAPED_MNEMONIC_REGEX = /(&amp;)?(&amp;)([^\s&])/g;
var HorizontalDirection;
(function(HorizontalDirection) {
	HorizontalDirection[HorizontalDirection["Right"] = 0] = "Right";
	HorizontalDirection[HorizontalDirection["Left"] = 1] = "Left";
})(HorizontalDirection || (HorizontalDirection = {}));
var VerticalDirection;
(function(VerticalDirection) {
	VerticalDirection[VerticalDirection["Above"] = 0] = "Above";
	VerticalDirection[VerticalDirection["Below"] = 1] = "Below";
})(VerticalDirection || (VerticalDirection = {}));
var Menu = class Menu extends ActionBar {
	constructor(container, actions, options, menuStyles) {
		container.classList.add("monaco-menu-container");
		container.setAttribute("role", "presentation");
		const menuElement = document.createElement("div");
		menuElement.classList.add("monaco-menu");
		menuElement.setAttribute("role", "presentation");
		super(menuElement, {
			orientation: 1,
			actionViewItemProvider: (action) => this.doGetActionViewItem(action, options, parentData),
			context: options.context,
			actionRunner: options.actionRunner,
			ariaLabel: options.ariaLabel,
			ariaRole: "menu",
			focusOnlyEnabledItems: true,
			triggerKeys: {
				keys: [3, ...isMacintosh || isLinux ? [10] : []],
				keyDown: true
			}
		});
		this.menuStyles = menuStyles;
		this.menuElement = menuElement;
		this.actionsList.tabIndex = 0;
		this.initializeOrUpdateStyleSheet(container, menuStyles);
		this._register(Gesture.addTarget(menuElement));
		this._register(addDisposableListener(menuElement, EventType$1.KEY_DOWN, (e) => {
			if (new StandardKeyboardEvent(e).equals(2)) e.preventDefault();
		}));
		if (options.enableMnemonics) this._register(addDisposableListener(menuElement, EventType$1.KEY_DOWN, (e) => {
			const key = e.key.toLocaleLowerCase();
			const actions = this.mnemonics.get(key);
			if (actions !== void 0) {
				EventHelper.stop(e, true);
				if (actions.length === 1) {
					if (actions[0] instanceof SubmenuMenuActionViewItem && actions[0].container) this.focusItemByElement(actions[0].container);
					actions[0].onClick(e);
				}
				if (actions.length > 1) {
					const action = actions.shift();
					if (action && action.container) {
						this.focusItemByElement(action.container);
						actions.push(action);
					}
					this.mnemonics.set(key, actions);
				}
			}
		}));
		if (isLinux) this._register(addDisposableListener(menuElement, EventType$1.KEY_DOWN, (e) => {
			const event = new StandardKeyboardEvent(e);
			if (event.equals(14) || event.equals(11)) {
				this.focusedItem = this.viewItems.length - 1;
				this.focusNext();
				EventHelper.stop(e, true);
			} else if (event.equals(13) || event.equals(12)) {
				this.focusedItem = 0;
				this.focusPrevious();
				EventHelper.stop(e, true);
			}
		}));
		this._register(addDisposableListener(this.domNode, EventType$1.MOUSE_OUT, (e) => {
			const relatedTarget = e.relatedTarget;
			if (!isAncestor$1(relatedTarget, this.domNode)) {
				this.focusedItem = void 0;
				this.updateFocus();
				e.stopPropagation();
			}
		}));
		this._register(addDisposableListener(this.actionsList, EventType$1.MOUSE_MOVE, (e) => {
			if (e.movementX === 0 && e.movementY === 0) return;
			let target = e.target;
			if (!target || !isAncestor$1(target, this.actionsList) || target === this.actionsList) return;
			while (target.parentElement !== this.actionsList && target.parentElement !== null) target = target.parentElement;
			if (target.classList.contains("action-item")) {
				const lastFocusedItem = this.focusedItem;
				if (lastFocusedItem !== void 0 && this.actionsList.children[lastFocusedItem] === target) return;
				this.setFocusedItem(target);
				if (lastFocusedItem !== this.focusedItem) this.updateFocus();
			}
		}));
		this._register(Gesture.addTarget(this.actionsList));
		this._register(addDisposableListener(this.actionsList, EventType.Tap, (e) => {
			let target = e.initialTarget;
			if (!target || !isAncestor$1(target, this.actionsList) || target === this.actionsList) return;
			while (target.parentElement !== this.actionsList && target.parentElement !== null) target = target.parentElement;
			if (target.classList.contains("action-item")) {
				const lastFocusedItem = this.focusedItem;
				this.setFocusedItem(target);
				if (lastFocusedItem !== this.focusedItem) this.updateFocus();
			}
		}));
		const parentData = { parent: this };
		this.mnemonics = /* @__PURE__ */ new Map();
		this.scrollableElement = this._register(new DomScrollableElement(menuElement, {
			alwaysConsumeMouseWheel: true,
			horizontal: 2,
			vertical: 3,
			verticalScrollbarSize: 7,
			handleMouseWheel: true,
			useShadows: true
		}));
		const scrollElement = this.scrollableElement.getDomNode();
		scrollElement.style.position = "";
		this.styleScrollElement(scrollElement, menuStyles);
		this._register(addDisposableListener(menuElement, EventType.Change, (e) => {
			EventHelper.stop(e, true);
			const scrollTop = this.scrollableElement.getScrollPosition().scrollTop;
			this.scrollableElement.setScrollPosition({ scrollTop: scrollTop - e.translationY });
		}));
		this._register(addDisposableListener(scrollElement, EventType$1.MOUSE_UP, (e) => {
			e.preventDefault();
		}));
		const window = getWindow(container);
		menuElement.style.maxHeight = `${Math.max(10, window.innerHeight - container.getBoundingClientRect().top - 35)}px`;
		actions = actions.filter((a, idx) => {
			if (options.submenuIds?.has(a.id)) {
				console.warn(`Found submenu cycle: ${a.id}`);
				return false;
			}
			if (a instanceof Separator) {
				if (idx === actions.length - 1 || idx === 0) return false;
				if (actions[idx - 1] instanceof Separator) return false;
			}
			return true;
		});
		this.push(actions, {
			icon: true,
			label: true,
			isMenu: true
		});
		container.appendChild(this.scrollableElement.getDomNode());
		this.scrollableElement.scanDomNode();
		this.viewItems.filter((item) => !(item instanceof MenuSeparatorActionViewItem)).forEach((item, index, array) => {
			item.updatePositionInSet(index + 1, array.length);
		});
	}
	initializeOrUpdateStyleSheet(container, style) {
		if (!this.styleSheet) {
			if (isInShadowDOM(container)) this.styleSheet = createStyleSheet(container);
			else {
				if (!Menu.globalStyleSheet) Menu.globalStyleSheet = createStyleSheet();
				this.styleSheet = Menu.globalStyleSheet;
			}
		}
		this.styleSheet.textContent = getMenuWidgetCSS(style, isInShadowDOM(container));
	}
	styleScrollElement(scrollElement, style) {
		const fgColor = style.foregroundColor ?? "";
		const bgColor = style.backgroundColor ?? "";
		const borderRadius = "var(--vscode-cornerRadius-large)";
		scrollElement.style.borderRadius = borderRadius;
		scrollElement.style.color = fgColor;
		scrollElement.style.backgroundColor = bgColor;
	}
	getContainer() {
		return this.scrollableElement.getDomNode();
	}
	get onScroll() {
		return this.scrollableElement.onScroll;
	}
	focusItemByElement(element) {
		const lastFocusedItem = this.focusedItem;
		this.setFocusedItem(element);
		if (lastFocusedItem !== this.focusedItem) this.updateFocus();
	}
	setFocusedItem(element) {
		for (let i = 0; i < this.actionsList.children.length; i++) if (element === this.actionsList.children[i]) {
			this.focusedItem = i;
			break;
		}
	}
	updateFocus(fromRight) {
		super.updateFocus(fromRight, true, true);
		if (typeof this.focusedItem !== "undefined") this.scrollableElement.setScrollPosition({ scrollTop: Math.round(this.menuElement.scrollTop) });
	}
	doGetActionViewItem(action, options, parentData) {
		if (action instanceof Separator) return new MenuSeparatorActionViewItem(options.context, action, { icon: true }, this.menuStyles);
		else if (action instanceof SubmenuAction) {
			const menuActionViewItem = new SubmenuMenuActionViewItem(action, action.actions, parentData, {
				...options,
				submenuIds: /* @__PURE__ */ new Set([...options.submenuIds || [], action.id])
			}, this.menuStyles);
			if (options.enableMnemonics) {
				const mnemonic = menuActionViewItem.getMnemonic();
				if (mnemonic && menuActionViewItem.isEnabled()) {
					const actionViewItems = this.mnemonics.get(mnemonic);
					if (actionViewItems !== void 0) actionViewItems.push(menuActionViewItem);
					else this.mnemonics.set(mnemonic, [menuActionViewItem]);
				}
			}
			return menuActionViewItem;
		} else {
			const keybindingLabel = options.getKeyBinding?.(action)?.getLabel();
			const menuItemOptions = {
				enableMnemonics: options.enableMnemonics,
				useEventAsContext: options.useEventAsContext,
				keybinding: keybindingLabel
			};
			const menuActionViewItem = new BaseMenuActionViewItem(options.context, action, menuItemOptions, this.menuStyles);
			if (options.enableMnemonics) {
				const mnemonic = menuActionViewItem.getMnemonic();
				if (mnemonic && menuActionViewItem.isEnabled()) {
					const actionViewItems = this.mnemonics.get(mnemonic);
					if (actionViewItems !== void 0) actionViewItems.push(menuActionViewItem);
					else this.mnemonics.set(mnemonic, [menuActionViewItem]);
				}
			}
			return menuActionViewItem;
		}
	}
};
var BaseMenuActionViewItem = class extends BaseActionViewItem {
	constructor(ctx, action, options, menuStyle) {
		options = {
			...options,
			isMenu: true,
			icon: options.icon !== void 0 ? options.icon : false,
			label: options.label !== void 0 ? options.label : true
		};
		super(action, action, options);
		this.menuStyle = menuStyle;
		this.options = options;
		this.cssClass = "";
		if (this.options.label && options.enableMnemonics) {
			const label = this.action.label;
			if (label) {
				const matches = MENU_MNEMONIC_REGEX.exec(label);
				if (matches) this.mnemonic = (!!matches[1] ? matches[1] : matches[3]).toLocaleLowerCase();
			}
		}
		this.runOnceToEnableMouseUp = new RunOnceScheduler(() => {
			if (!this.element) return;
			this._register(addDisposableListener(this.element, EventType$1.MOUSE_UP, (e) => {
				EventHelper.stop(e, true);
				if (isFirefox) {
					if (new StandardMouseEvent(getWindow(this.element), e).rightButton) return;
					this.onClick(e);
				} else setTimeout(() => {
					this.onClick(e);
				}, 0);
			}));
			this._register(addDisposableListener(this.element, EventType$1.CONTEXT_MENU, (e) => {
				EventHelper.stop(e, true);
			}));
		}, 100);
		this._register(this.runOnceToEnableMouseUp);
	}
	render(container) {
		super.render(container);
		if (!this.element) return;
		this.container = container;
		this.item = append$2(this.element, $$10("a.action-menu-item"));
		if (this._action.id === Separator.ID) this.item.setAttribute("role", "presentation");
		else {
			this.item.setAttribute("role", "menuitem");
			if (this.mnemonic) this.item.setAttribute("aria-keyshortcuts", `${this.mnemonic}`);
		}
		this.check = append$2(this.item, $$10("span.menu-item-check" + ThemeIcon.asCSSSelector(Codicon.menuSelection)));
		this.check.setAttribute("role", "none");
		this.label = append$2(this.item, $$10("span.action-label"));
		if (this.options.label && this.options.keybinding) append$2(this.item, $$10("span.keybinding")).textContent = this.options.keybinding;
		this.runOnceToEnableMouseUp.schedule();
		this.updateClass();
		this.updateLabel();
		this.updateTooltip();
		this.updateEnabled();
		this.updateChecked();
		this.applyStyle();
	}
	blur() {
		super.blur();
		this.applyStyle();
	}
	focus() {
		super.focus();
		this.item?.focus();
		this.applyStyle();
	}
	updatePositionInSet(pos, setSize) {
		if (this.item) {
			this.item.setAttribute("aria-posinset", `${pos}`);
			this.item.setAttribute("aria-setsize", `${setSize}`);
		}
	}
	updateLabel() {
		if (!this.label) return;
		if (this.options.label) {
			clearNode(this.label);
			let label = stripIcons(this.action.label);
			if (label) {
				const cleanLabel = cleanMnemonic(label);
				if (!this.options.enableMnemonics) label = cleanLabel;
				this.label.setAttribute("aria-label", cleanLabel.replace(/&&/g, "&"));
				const matches = MENU_MNEMONIC_REGEX.exec(label);
				if (matches) {
					label = escape$2(label);
					MENU_ESCAPED_MNEMONIC_REGEX.lastIndex = 0;
					let escMatch = MENU_ESCAPED_MNEMONIC_REGEX.exec(label);
					while (escMatch && escMatch[1]) escMatch = MENU_ESCAPED_MNEMONIC_REGEX.exec(label);
					const replaceDoubleEscapes = (str) => str.replace(/&amp;&amp;/g, "&amp;");
					if (escMatch) this.label.append(ltrim(replaceDoubleEscapes(label.substr(0, escMatch.index)), " "), $$10("u", { "aria-hidden": "true" }, escMatch[3]), rtrim$1(replaceDoubleEscapes(label.substr(escMatch.index + escMatch[0].length)), " "));
					else this.label.textContent = replaceDoubleEscapes(label).trim();
					this.item?.setAttribute("aria-keyshortcuts", (!!matches[1] ? matches[1] : matches[3]).toLocaleLowerCase());
				} else this.label.textContent = label.replace(/&&/g, "&").trim();
			}
		}
	}
	updateTooltip() {}
	updateClass() {
		if (this.cssClass && this.item) this.item.classList.remove(...this.cssClass.split(" "));
		if (this.options.icon && this.label) {
			this.cssClass = this.action.class || "";
			this.label.classList.add("icon");
			if (this.cssClass) this.label.classList.add(...this.cssClass.split(" "));
			this.updateEnabled();
		} else if (this.label) this.label.classList.remove("icon");
	}
	updateEnabled() {
		if (this.action.enabled) {
			if (this.element) {
				this.element.classList.remove("disabled");
				this.element.removeAttribute("aria-disabled");
			}
			if (this.item) {
				this.item.classList.remove("disabled");
				this.item.removeAttribute("aria-disabled");
				this.item.tabIndex = 0;
			}
		} else {
			if (this.element) {
				this.element.classList.add("disabled");
				this.element.setAttribute("aria-disabled", "true");
			}
			if (this.item) {
				this.item.classList.add("disabled");
				this.item.setAttribute("aria-disabled", "true");
			}
		}
	}
	updateChecked() {
		if (!this.item) return;
		const checked = this.action.checked;
		this.item.classList.toggle("checked", !!checked);
		if (checked !== void 0) {
			this.item.setAttribute("role", "menuitemcheckbox");
			this.item.setAttribute("aria-checked", checked ? "true" : "false");
		} else {
			this.item.setAttribute("role", "menuitem");
			this.item.setAttribute("aria-checked", "");
		}
	}
	getMnemonic() {
		return this.mnemonic;
	}
	applyStyle() {
		const isSelected = this.element && this.element.classList.contains("focused");
		const fgColor = isSelected && this.menuStyle.selectionForegroundColor ? this.menuStyle.selectionForegroundColor : this.menuStyle.foregroundColor;
		const bgColor = isSelected && this.menuStyle.selectionBackgroundColor ? this.menuStyle.selectionBackgroundColor : void 0;
		const outline = isSelected && this.menuStyle.selectionBorderColor ? `1px solid ${this.menuStyle.selectionBorderColor}` : "";
		const outlineOffset = isSelected && this.menuStyle.selectionBorderColor ? `-1px` : "";
		if (this.item) {
			this.item.style.color = fgColor ?? "";
			this.item.style.backgroundColor = bgColor ?? "";
			this.item.style.outline = outline;
			this.item.style.outlineOffset = outlineOffset;
		}
		if (this.check) this.check.style.color = fgColor ?? "";
	}
};
var SubmenuMenuActionViewItem = class extends BaseMenuActionViewItem {
	constructor(action, submenuActions, parentData, submenuOptions, menuStyles) {
		super(action, action, submenuOptions, menuStyles);
		this.submenuActions = submenuActions;
		this.parentData = parentData;
		this.submenuOptions = submenuOptions;
		this.mysubmenu = null;
		this.submenuDisposables = this._register(new DisposableStore());
		this.mouseOver = false;
		this.expandDirection = submenuOptions && submenuOptions.expandDirection !== void 0 ? submenuOptions.expandDirection : {
			horizontal: HorizontalDirection.Right,
			vertical: VerticalDirection.Below
		};
		this.showScheduler = new RunOnceScheduler(() => {
			if (this.mouseOver) {
				this.cleanupExistingSubmenu(false);
				this.createSubmenu(false);
			}
		}, 250);
		this.hideScheduler = new RunOnceScheduler(() => {
			if (this.element && !isAncestor$1(getActiveElement(), this.element) && this.parentData.submenu === this.mysubmenu) {
				this.parentData.parent.focus(false);
				this.cleanupExistingSubmenu(true);
			}
		}, 750);
	}
	render(container) {
		super.render(container);
		if (!this.element) return;
		if (this.item) {
			this.item.classList.add("monaco-submenu-item");
			this.item.tabIndex = 0;
			this.item.setAttribute("aria-haspopup", "true");
			this.updateAriaExpanded("false");
			this.submenuIndicator = append$2(this.item, $$10("span.submenu-indicator" + ThemeIcon.asCSSSelector(Codicon.menuSubmenu)));
			this.submenuIndicator.setAttribute("aria-hidden", "true");
		}
		this._register(addDisposableListener(this.element, EventType$1.KEY_UP, (e) => {
			const event = new StandardKeyboardEvent(e);
			if (event.equals(17) || event.equals(3)) {
				EventHelper.stop(e, true);
				this.createSubmenu(true);
			}
		}));
		this._register(addDisposableListener(this.element, EventType$1.KEY_DOWN, (e) => {
			const event = new StandardKeyboardEvent(e);
			if (getActiveElement() === this.item) {
				if (event.equals(17) || event.equals(3)) EventHelper.stop(e, true);
			}
		}));
		this._register(addDisposableListener(this.element, EventType$1.MOUSE_MOVE, (e) => {
			if (e.movementX === 0 && e.movementY === 0) return;
			if (!this.mouseOver) {
				this.mouseOver = true;
				this.showScheduler.schedule();
			}
		}));
		this._register(addDisposableListener(this.element, EventType$1.MOUSE_LEAVE, (e) => {
			this.mouseOver = false;
		}));
		this._register(addDisposableListener(this.element, EventType$1.FOCUS_OUT, (e) => {
			if (this.element && !isAncestor$1(getActiveElement(), this.element)) this.hideScheduler.schedule();
		}));
		this._register(this.parentData.parent.onScroll(() => {
			if (this.parentData.submenu === this.mysubmenu) {
				this.parentData.parent.focus(false);
				this.cleanupExistingSubmenu(true);
			}
		}));
	}
	updateEnabled() {}
	onClick(e) {
		EventHelper.stop(e, true);
		this.cleanupExistingSubmenu(false);
		this.createSubmenu(true);
	}
	cleanupExistingSubmenu(force) {
		if (this.parentData.submenu && (force || this.parentData.submenu !== this.mysubmenu)) {
			try {
				this.parentData.submenu.dispose();
			} catch {}
			this.parentData.submenu = void 0;
			this.updateAriaExpanded("false");
			if (this.submenuContainer) {
				this.submenuDisposables.clear();
				this.submenuContainer = void 0;
			}
		}
	}
	calculateSubmenuMenuLayout(windowDimensions, submenu, entry, expandDirection) {
		const ret = {
			top: 0,
			left: 0
		};
		ret.left = layout(windowDimensions.width, submenu.width, {
			position: expandDirection.horizontal === HorizontalDirection.Right ? 0 : 1,
			offset: entry.left,
			size: entry.width
		}).position;
		if (ret.left >= entry.left && ret.left < entry.left + entry.width) {
			if (entry.left + 10 + submenu.width <= windowDimensions.width) ret.left = entry.left + 10;
			entry.top += 10;
			entry.height = 0;
		}
		ret.top = layout(windowDimensions.height, submenu.height, {
			position: 0,
			offset: entry.top,
			size: 0
		}).position;
		if (ret.top + submenu.height === entry.top && ret.top + entry.height + submenu.height <= windowDimensions.height) ret.top += entry.height;
		return ret;
	}
	createSubmenu(selectFirstItem = true) {
		if (!this.element) return;
		if (!this.parentData.submenu) {
			this.updateAriaExpanded("true");
			this.submenuContainer = append$2(this.element, $$10("div.monaco-submenu"));
			this.submenuContainer.classList.add("menubar-menu-items-holder", "context-view");
			const computedStyles = getWindow(this.parentData.parent.domNode).getComputedStyle(this.parentData.parent.domNode);
			const paddingTop = parseFloat(computedStyles.paddingTop || "0") || 0;
			this.submenuContainer.style.position = "fixed";
			this.submenuContainer.style.top = "0";
			this.submenuContainer.style.left = "0";
			this.submenuContainer.style.zIndex = "1";
			this.parentData.submenu = new Menu(this.submenuContainer, this.submenuActions.length ? this.submenuActions : [new EmptySubmenuAction()], this.submenuOptions, this.menuStyle);
			const entryBox = this.element.getBoundingClientRect();
			const entryBoxUpdated = {
				top: entryBox.top - paddingTop,
				left: entryBox.left,
				height: entryBox.height + 2 * paddingTop,
				width: entryBox.width
			};
			const viewBox = this.submenuContainer.getBoundingClientRect();
			const window = getWindow(this.element);
			const { top, left } = this.calculateSubmenuMenuLayout(new Dimension(window.innerWidth, window.innerHeight), Dimension.lift(viewBox), entryBoxUpdated, this.expandDirection);
			this.submenuContainer.style.left = `${left - viewBox.left}px`;
			this.submenuContainer.style.top = `${top - viewBox.top}px`;
			this.submenuDisposables.add(addDisposableListener(this.submenuContainer, EventType$1.KEY_UP, (e) => {
				if (new StandardKeyboardEvent(e).equals(15)) {
					EventHelper.stop(e, true);
					this.parentData.parent.focus();
					this.cleanupExistingSubmenu(true);
				}
			}));
			this.submenuDisposables.add(addDisposableListener(this.submenuContainer, EventType$1.KEY_DOWN, (e) => {
				if (new StandardKeyboardEvent(e).equals(15)) EventHelper.stop(e, true);
			}));
			this.submenuDisposables.add(this.parentData.submenu.onDidCancel(() => {
				this.parentData.parent.focus();
				this.cleanupExistingSubmenu(true);
			}));
			this.parentData.submenu.focus(selectFirstItem);
			this.mysubmenu = this.parentData.submenu;
		} else this.parentData.submenu.focus(false);
	}
	updateAriaExpanded(value) {
		if (this.item) this.item?.setAttribute("aria-expanded", value);
	}
	applyStyle() {
		super.applyStyle();
		const fgColor = this.element && this.element.classList.contains("focused") && this.menuStyle.selectionForegroundColor ? this.menuStyle.selectionForegroundColor : this.menuStyle.foregroundColor;
		if (this.submenuIndicator) this.submenuIndicator.style.color = fgColor ?? "";
	}
	dispose() {
		super.dispose();
		this.hideScheduler.dispose();
		if (this.mysubmenu) {
			this.mysubmenu.dispose();
			this.mysubmenu = null;
		}
		if (this.submenuContainer) this.submenuContainer = void 0;
	}
};
var MenuSeparatorActionViewItem = class extends ActionViewItem {
	constructor(context, action, options, menuStyles) {
		super(context, action, options);
		this.menuStyles = menuStyles;
	}
	render(container) {
		super.render(container);
		if (this.label) this.label.style.borderBottomColor = this.menuStyles.separatorColor ? `${this.menuStyles.separatorColor}` : "";
	}
};
function cleanMnemonic(label) {
	const regex = MENU_MNEMONIC_REGEX;
	const matches = regex.exec(label);
	if (!matches) return label;
	const mnemonicInText = !matches[1];
	return label.replace(regex, mnemonicInText ? "$2$3" : "").trim();
}
function formatRule(c) {
	const fontCharacter = getCodiconFontCharacters()[c.id];
	return `.codicon-${c.id}:before { content: '\\${fontCharacter.toString(16)}'; }`;
}
function getMenuWidgetCSS(style, isForShadowDom) {
	const borderColor = style.borderColor ?? "var(--vscode-menu-border)";
	const menuShadow = `var(--vscode-shadow-lg${style.shadowColor ? `, 0 0 12px ${style.shadowColor}` : ""})`;
	let result = `
.monaco-menu {
	font-size: 13px;
	border-radius: var(--vscode-cornerRadius-large);
	border: var(--vscode-strokeThickness) solid ${borderColor};
	min-width: 160px;
}

${formatRule(Codicon.menuSelection)}
${formatRule(Codicon.menuSubmenu)}

.monaco-menu .monaco-action-bar {
	text-align: right;
	overflow: hidden;
	white-space: nowrap;
}

.monaco-menu .monaco-action-bar .actions-container {
	display: flex;
	margin: 0 auto;
	padding: 0;
	width: 100%;
	justify-content: flex-end;
}

.monaco-menu .monaco-action-bar.vertical .actions-container {
	display: inline-block;
}

.monaco-menu .monaco-action-bar.reverse .actions-container {
	flex-direction: row-reverse;
}

.monaco-menu .monaco-action-bar .action-item {
	cursor: pointer;
	display: inline-block;
	transition: transform 50ms ease;
	position: relative;  /* DO NOT REMOVE - this is the key to preventing the ghosting icon bug in Chrome 42 */
}

.monaco-menu .monaco-action-bar .action-item.disabled {
	cursor: default;
}

.monaco-menu .monaco-action-bar .action-item .icon,
.monaco-menu .monaco-action-bar .action-item .codicon {
	display: inline-block;
}

.monaco-menu .monaco-action-bar .action-item .codicon {
	display: flex;
	align-items: center;
}

.monaco-menu .monaco-action-bar .action-label {
	font-size: 11px;
	margin-right: 4px;
}

.monaco-menu .monaco-action-bar .action-item.disabled .action-label,
.monaco-menu .monaco-action-bar .action-item.disabled .action-label:hover {
	color: var(--vscode-disabledForeground);
}

/* Vertical actions */

.monaco-menu .monaco-action-bar.vertical {
	text-align: left;
}

.monaco-menu .monaco-action-bar.vertical .action-item {
	display: block;
}

.monaco-menu .monaco-action-bar.vertical .action-label.separator {
	display: block;
	border-bottom: 1px solid var(--vscode-menu-separatorBackground);
	padding-top: 1px;
	padding: 30px;
}

.monaco-menu .secondary-actions .monaco-action-bar .action-label {
	margin-left: 6px;
}

/* Action Items */
.monaco-menu .monaco-action-bar .action-item.select-container {
	overflow: hidden; /* somehow the dropdown overflows its container, we prevent it here to not push */
	flex: 1;
	max-width: 170px;
	min-width: 60px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 10px;
}

.monaco-menu .monaco-action-bar.vertical {
	margin-left: 0;
	overflow: visible;
}

.monaco-menu .monaco-action-bar.vertical .actions-container {
	display: block;
}

.monaco-menu .monaco-action-bar.vertical .action-item {
	padding: 0;
	transform: none;
	display: flex;
}

.monaco-menu .monaco-action-bar.vertical .action-item.active {
	transform: none;
}

.monaco-menu .monaco-action-bar.vertical .action-menu-item {
	flex: 1 1 auto;
	display: flex;
	height: 24px;
	align-items: center;
	position: relative;
	margin: 0 4px;
	border-radius: var(--vscode-cornerRadius-medium);
}

.monaco-menu .monaco-action-bar.vertical .action-menu-item:hover .keybinding,
.monaco-menu .monaco-action-bar.vertical .action-menu-item:focus .keybinding {
	opacity: unset;
}

.monaco-menu .monaco-action-bar.vertical .action-label {
	flex: 1 1 auto;
	text-decoration: none;
	padding: 0 1em;
	background: none;
	font-size: 12px;
	line-height: 1;
}

.monaco-menu .monaco-action-bar.vertical .keybinding,
.monaco-menu .monaco-action-bar.vertical .submenu-indicator {
	display: inline-block;
	flex: 2 1 auto;
	padding: 0 1em;
	text-align: right;
	font-size: 12px;
	line-height: 1;
	opacity: 0.7;
}

.monaco-menu .monaco-action-bar.vertical .submenu-indicator {
	height: 100%;
}

.monaco-menu .monaco-action-bar.vertical .submenu-indicator.codicon {
	font-size: 16px !important;
	display: flex;
	align-items: center;
}

.monaco-menu .monaco-action-bar.vertical .submenu-indicator.codicon::before {
	margin-left: auto;
	margin-right: -20px;
}

.monaco-menu .monaco-action-bar.vertical .action-item.disabled .keybinding,
.monaco-menu .monaco-action-bar.vertical .action-item.disabled .submenu-indicator {
	opacity: 0.4;
}

.monaco-menu .monaco-action-bar.vertical .action-label:not(.separator) {
	display: inline-block;
	box-sizing: border-box;
	margin: 0;
}

.monaco-menu .monaco-action-bar.vertical .action-item {
	position: static;
	overflow: visible;
}

.monaco-menu .monaco-action-bar.vertical .action-item .monaco-submenu {
	position: absolute;
}

.monaco-menu .monaco-action-bar.vertical .action-label.separator {
	width: 100%;
	height: 0px !important;
	opacity: 1;
}

.monaco-menu .monaco-action-bar.vertical .action-label.separator.text {
	padding: 0.7em 1em 0.1em 1em;
	font-weight: bold;
	opacity: 1;
}

.monaco-menu .monaco-action-bar.vertical .action-label:hover {
	color: inherit;
}

.monaco-menu .monaco-action-bar.vertical .menu-item-check {
	position: absolute;
	visibility: hidden;
	width: 1em;
	height: 100%;
}

.monaco-menu .monaco-action-bar.vertical .action-menu-item.checked .menu-item-check {
	visibility: visible;
	display: flex;
	align-items: center;
	justify-content: center;
}

/* Context Menu */

.context-view.monaco-menu-container {
	${CONTEXT_VIEW_MENU_MOTION_SHADOW_VARIABLE}: ${menuShadow};
	outline: 0;
	border: none;
	animation: fadeIn 0.083s linear;
	-webkit-app-region: no-drag;
	box-shadow: var(${CONTEXT_VIEW_MENU_MOTION_SHADOW_VARIABLE});
	border-radius: var(--vscode-cornerRadius-large);
	overflow: hidden;
}

.context-view.monaco-menu-container :focus,
.context-view.monaco-menu-container .monaco-action-bar.vertical:focus,
.context-view.monaco-menu-container .monaco-action-bar.vertical :focus {
	outline: 0;
}

.hc-black .context-view.monaco-menu-container,
.hc-light .context-view.monaco-menu-container,
:host-context(.hc-black) .context-view.monaco-menu-container,
:host-context(.hc-light) .context-view.monaco-menu-container {
	${CONTEXT_VIEW_MENU_MOTION_SHADOW_VARIABLE}: none;
	box-shadow: none;
}

.hc-black .monaco-menu .monaco-action-bar.vertical .action-item.focused,
.hc-light .monaco-menu .monaco-action-bar.vertical .action-item.focused,
:host-context(.hc-black) .monaco-menu .monaco-action-bar.vertical .action-item.focused,
:host-context(.hc-light) .monaco-menu .monaco-action-bar.vertical .action-item.focused {
	background: none;
}

/* Show the menu item selection border only for keyboard navigation. Pointer-driven focus typically does not set :focus-visible, so suppress the border in that case. */
.monaco-menu .monaco-action-bar.vertical .action-menu-item:focus:not(:focus-visible) {
	outline: none !important;
	outline-offset: 0 !important;
}

/* High contrast themes always show the selection border to indicate the focused item, regardless of input modality. The duplicated .monaco-menu raises specificity above the keyboard-only suppression rule above so this wins independent of declaration order. */
.hc-black .monaco-menu.monaco-menu .monaco-action-bar.vertical .action-item.focused > .action-menu-item,
.hc-light .monaco-menu.monaco-menu .monaco-action-bar.vertical .action-item.focused > .action-menu-item {
	outline: 1px solid var(--vscode-menu-selectionBorder) !important;
	outline-offset: -1px !important;
}

/* Keep :host-context separate because WebKit otherwise rejects the valid selectors above. */
:host-context(.hc-black) .monaco-menu.monaco-menu .monaco-action-bar.vertical .action-item.focused > .action-menu-item,
:host-context(.hc-light) .monaco-menu.monaco-menu .monaco-action-bar.vertical .action-item.focused > .action-menu-item {
	outline: 1px solid var(--vscode-menu-selectionBorder) !important;
	outline-offset: -1px !important;
}

/* Vertical Action Bar Styles */

.monaco-menu .monaco-action-bar.vertical {
	padding: 4px 0;
}

.monaco-menu .monaco-action-bar.vertical .action-menu-item {
	height: 24px;
}

.monaco-menu .monaco-action-bar.vertical .action-label:not(.separator),
.monaco-menu .monaco-action-bar.vertical .keybinding {
	font-size: inherit;
	padding: 0 2em;
	max-height: 100%;
}

.monaco-menu .monaco-action-bar.vertical .menu-item-check {
	font-size: inherit;
	width: 2em;
}

.monaco-menu .monaco-action-bar.vertical .action-label.separator {
	font-size: inherit;
	margin: 5px 0 !important;
	padding: 0;
	border-radius: 0;
}

.linux .monaco-menu .monaco-action-bar.vertical .action-label.separator,
:host-context(.linux) .monaco-menu .monaco-action-bar.vertical .action-label.separator {
	margin-left: 0;
	margin-right: 0;
}

.monaco-menu .monaco-action-bar.vertical .submenu-indicator {
	font-size: 60%;
	padding: 0 1.8em;
}

.linux .monaco-menu .monaco-action-bar.vertical .submenu-indicator,
:host-context(.linux) .monaco-menu .monaco-action-bar.vertical .submenu-indicator {
	height: 100%;
	mask-size: 10px 10px;
	-webkit-mask-size: 10px 10px;
}

.monaco-menu .action-item {
	cursor: default;
}`;
	if (isForShadowDom) {
		result += `
			/* Arrows */
			.monaco-scrollable-element > .scrollbar > .scra {
				cursor: pointer;
				font-size: 11px !important;
			}

			.monaco-scrollable-element > .visible {
				opacity: 1;

				/* Background rule added for IE9 - to allow clicks on dom node */
				background:rgba(0,0,0,0);

				transition: opacity 100ms linear;
			}
			.monaco-scrollable-element > .invisible {
				opacity: 0;
				pointer-events: none;
			}
			.monaco-scrollable-element > .invisible.fade {
				transition: opacity 800ms linear;
			}

			/* Scrollable Content Inset Shadow */
			.monaco-scrollable-element > .shadow {
				position: absolute;
				display: none;
			}
			.monaco-scrollable-element > .shadow.top {
				display: block;
				top: 0;
				left: 3px;
				height: 3px;
				width: 100%;
			}
			.monaco-scrollable-element > .shadow.left {
				display: block;
				top: 3px;
				left: 0;
				height: 100%;
				width: 3px;
			}
			.monaco-scrollable-element > .shadow.top-left-corner {
				display: block;
				top: 0;
				left: 0;
				height: 3px;
				width: 3px;
			}
			/* Fix for https://github.com/microsoft/vscode/issues/103170 */
			.monaco-menu .action-item .monaco-submenu {
				z-index: 1;
			}
		`;
		const scrollbarShadowColor = style.scrollbarShadow;
		if (scrollbarShadowColor) result += `
				.monaco-scrollable-element > .shadow.top {
					box-shadow: ${scrollbarShadowColor} 0 6px 6px -6px inset;
				}

				.monaco-scrollable-element > .shadow.left {
					box-shadow: ${scrollbarShadowColor} 6px 0 6px -6px inset;
				}

				.monaco-scrollable-element > .shadow.top.left {
					box-shadow: ${scrollbarShadowColor} 6px 6px 6px -6px inset;
				}
			`;
		const scrollbarSliderBackgroundColor = style.scrollbarSliderBackground;
		if (scrollbarSliderBackgroundColor) result += `
				.monaco-scrollable-element > .scrollbar > .slider {
					background: ${scrollbarSliderBackgroundColor};
				}
			`;
		const scrollbarSliderHoverBackgroundColor = style.scrollbarSliderHoverBackground;
		if (scrollbarSliderHoverBackgroundColor) result += `
				.monaco-scrollable-element > .scrollbar > .slider:hover {
					background: ${scrollbarSliderHoverBackgroundColor};
				}
			`;
		const scrollbarSliderActiveBackgroundColor = style.scrollbarSliderActiveBackground;
		if (scrollbarSliderActiveBackgroundColor) result += `
				.monaco-scrollable-element > .scrollbar > .slider.active {
					background: ${scrollbarSliderActiveBackgroundColor};
				}
			`;
	}
	return result;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/contextview/browser/contextMenuHandler.js
var ContextMenuHandler = class {
	constructor(contextViewService, telemetryService, notificationService, keybindingService) {
		this.contextViewService = contextViewService;
		this.telemetryService = telemetryService;
		this.notificationService = notificationService;
		this.keybindingService = keybindingService;
		this.focusToReturn = null;
		this.lastContainer = null;
		this.block = null;
		this.blockDisposable = null;
		this.options = { blockMouse: true };
	}
	configure(options) {
		this.options = options;
	}
	showContextMenu(delegate) {
		const actions = delegate.getActions();
		if (!actions.length) return;
		this.focusToReturn = getActiveElement();
		let menu;
		const shadowRootElement = isHTMLElement(delegate.domForShadowRoot) ? delegate.domForShadowRoot : void 0;
		this.contextViewService.showContextView({
			getAnchor: () => delegate.getAnchor(),
			canRelayout: false,
			anchorAlignment: delegate.anchorAlignment,
			anchorAxisAlignment: delegate.anchorAxisAlignment,
			closeAnimation: delegate.closeAnimation,
			layer: delegate.layer,
			render: (container) => {
				this.lastContainer = container;
				const className = delegate.getMenuClassName ? delegate.getMenuClassName() : "";
				if (className) container.className += " " + className;
				if (this.options.blockMouse) {
					this.block = container.appendChild($$10(".context-view-block"));
					this.block.style.position = "fixed";
					this.block.style.cursor = "initial";
					this.block.style.left = "0";
					this.block.style.top = "0";
					this.block.style.width = "100%";
					this.block.style.height = "100%";
					this.block.style.zIndex = "-1";
					this.blockDisposable?.dispose();
					this.blockDisposable = addDisposableListener(this.block, EventType$1.MOUSE_DOWN, (e) => e.stopPropagation());
				}
				const menuDisposables = new DisposableStore();
				const actionRunner = delegate.actionRunner || menuDisposables.add(new ActionRunner());
				actionRunner.onWillRun((evt) => this.onActionRun(evt, !delegate.skipTelemetry), this, menuDisposables);
				actionRunner.onDidRun(this.onDidActionRun, this, menuDisposables);
				menu = new Menu(container, actions, {
					actionViewItemProvider: delegate.getActionViewItem,
					context: delegate.getActionsContext ? delegate.getActionsContext() : null,
					actionRunner,
					getKeyBinding: delegate.getKeyBinding ? delegate.getKeyBinding : (action) => this.keybindingService.lookupKeybinding(action.id)
				}, defaultMenuStyles);
				menu.onDidCancel(() => this.contextViewService.hideContextView(true), null, menuDisposables);
				menu.onDidBlur(() => this.contextViewService.hideContextView(true), null, menuDisposables);
				const targetWindow = getWindow(container);
				menuDisposables.add(addDisposableListener(targetWindow, EventType$1.BLUR, () => this.contextViewService.hideContextView(true)));
				menuDisposables.add(addDisposableListener(targetWindow, EventType$1.MOUSE_DOWN, (e) => {
					if (e.defaultPrevented) return;
					const event = new StandardMouseEvent(targetWindow, e);
					let element = event.target;
					if (event.rightButton) return;
					while (element) {
						if (element === container) return;
						element = element.parentElement;
					}
					this.contextViewService.hideContextView(true);
				}));
				return combinedDisposable(menuDisposables, menu);
			},
			focus: () => {
				menu?.focus(!!delegate.autoSelectFirstItem);
			},
			onHide: (didCancel) => {
				delegate.onHide?.(!!didCancel);
				if (this.block) {
					this.block.remove();
					this.block = null;
				}
				this.blockDisposable?.dispose();
				this.blockDisposable = null;
				if (!!this.lastContainer && (getActiveElement() === this.lastContainer || isAncestor$1(getActiveElement(), this.lastContainer))) this.focusToReturn?.focus();
				this.lastContainer = null;
			}
		}, shadowRootElement, !!shadowRootElement, delegate.useWindowContainerForShadowRoot);
	}
	onActionRun(e, logTelemetry) {
		if (logTelemetry) this.telemetryService.publicLog2("workbenchActionExecuted", {
			id: e.action.id,
			from: "contextMenu"
		});
		this.contextViewService.hideContextView(false);
	}
	onDidActionRun(e) {
		if (e.error && !isCancellationError(e.error)) this.notificationService.error(e.error);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/contextview/browser/contextMenuService.js
var __decorate$34 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$31 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var ContextMenuService = class ContextMenuService extends Disposable {
	get contextMenuHandler() {
		if (!this._contextMenuHandler) this._contextMenuHandler = new ContextMenuHandler(this.contextViewService, this.telemetryService, this.notificationService, this.keybindingService);
		return this._contextMenuHandler;
	}
	constructor(telemetryService, notificationService, contextViewService, keybindingService, menuService, contextKeyService) {
		super();
		this.telemetryService = telemetryService;
		this.notificationService = notificationService;
		this.contextViewService = contextViewService;
		this.keybindingService = keybindingService;
		this.menuService = menuService;
		this.contextKeyService = contextKeyService;
		this._contextMenuHandler = void 0;
		this._onDidShowContextMenu = this._store.add(new Emitter$1());
		this.onDidShowContextMenu = this._onDidShowContextMenu.event;
		this._onDidHideContextMenu = this._store.add(new Emitter$1());
		this.onDidHideContextMenu = this._onDidHideContextMenu.event;
	}
	configure(options) {
		this.contextMenuHandler.configure(options);
	}
	showContextMenu(delegate) {
		delegate = ContextMenuMenuDelegate.transform(delegate, this.menuService, this.contextKeyService);
		this.contextMenuHandler.showContextMenu({
			...delegate,
			onHide: (didCancel) => {
				delegate.onHide?.(didCancel);
				this._onDidHideContextMenu.fire();
			}
		});
		ModifierKeyEmitter.getInstance().resetKeyStatus();
		this._onDidShowContextMenu.fire();
	}
};
ContextMenuService = __decorate$34([
	__param$31(0, ITelemetryService),
	__param$31(1, INotificationService),
	__param$31(2, IContextViewService),
	__param$31(3, IKeybindingService),
	__param$31(4, IMenuService),
	__param$31(5, IContextKeyService)
], ContextMenuService);
var ContextMenuMenuDelegate;
(function(ContextMenuMenuDelegate) {
	function is(thing) {
		return thing && thing.menuId instanceof MenuId;
	}
	function transform(delegate, menuService, globalContextKeyService) {
		if (!is(delegate)) return delegate;
		const { menuId, menuActionOptions, contextKeyService } = delegate;
		return {
			...delegate,
			getActions: () => {
				let target = [];
				if (menuId) target = getFlatContextMenuActions(menuService.getMenuActions(menuId, contextKeyService ?? globalContextKeyService, menuActionOptions));
				if (!delegate.getActions) return target;
				else return Separator.join(delegate.getActions(), target);
			}
		};
	}
	ContextMenuMenuDelegate.transform = transform;
})(ContextMenuMenuDelegate || (ContextMenuMenuDelegate = {}));
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/contextview/browser/contextViewService.js
var __decorate$33 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$30 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var ContextViewHandler = class ContextViewHandler extends Disposable {
	constructor(layoutService) {
		super();
		this.layoutService = layoutService;
		this.contextView = this._register(new ContextView(this.layoutService.mainContainer, 1));
		this.layout();
		this._register(layoutService.onDidLayoutContainer(() => this.layout()));
	}
	showContextView(delegate, container, shadowRoot, useWindowContainerForShadowRoot) {
		let domPosition;
		if (container) {
			if (container === this.layoutService.getContainer(getWindow(container))) domPosition = 1;
			else if (shadowRoot) domPosition = 3;
			else domPosition = 2;
		} else domPosition = 1;
		const contextViewContainer = useWindowContainerForShadowRoot && container ? this.layoutService.getContainer(getWindow(container)) : container ?? this.layoutService.activeContainer;
		this.contextView.setContainer(contextViewContainer, domPosition);
		this.contextView.show(delegate);
		const openContextView = { close: () => {
			if (this.openContextView === openContextView) this.hideContextView();
		} };
		this.openContextView = openContextView;
		return openContextView;
	}
	layout() {
		this.contextView.layout();
	}
	hideContextView(data) {
		this.contextView.hide(data);
		this.openContextView = void 0;
	}
};
ContextViewHandler = __decorate$33([__param$30(0, ILayoutService)], ContextViewHandler);
var ContextViewService = class extends ContextViewHandler {
	getContextViewElement() {
		return this.contextView.getViewElement();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/dataChannel/common/dataChannel.js
var IDataChannelService = createDecorator("dataChannelService");
var NullDataChannelService = class {
	getDataChannel(_channelId) {
		return { sendData: () => {} };
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/defaultAccount/common/defaultAccount.js
var IDefaultAccountService = createDecorator("defaultAccountService");
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/instantiation/common/graph.js
var Node$1 = class {
	constructor(key, data) {
		this.key = key;
		this.data = data;
		this.incoming = /* @__PURE__ */ new Map();
		this.outgoing = /* @__PURE__ */ new Map();
	}
};
var Graph = class {
	constructor(_hashFn) {
		this._hashFn = _hashFn;
		this._nodes = /* @__PURE__ */ new Map();
	}
	roots() {
		const ret = [];
		for (const node of this._nodes.values()) if (node.outgoing.size === 0) ret.push(node);
		return ret;
	}
	insertEdge(from, to) {
		const fromNode = this.lookupOrInsertNode(from);
		const toNode = this.lookupOrInsertNode(to);
		fromNode.outgoing.set(toNode.key, toNode);
		toNode.incoming.set(fromNode.key, fromNode);
	}
	removeNode(data) {
		const key = this._hashFn(data);
		this._nodes.delete(key);
		for (const node of this._nodes.values()) {
			node.outgoing.delete(key);
			node.incoming.delete(key);
		}
	}
	lookupOrInsertNode(data) {
		const key = this._hashFn(data);
		let node = this._nodes.get(key);
		if (!node) {
			node = new Node$1(key, data);
			this._nodes.set(key, node);
		}
		return node;
	}
	isEmpty() {
		return this._nodes.size === 0;
	}
	toString() {
		const data = [];
		for (const [key, value] of this._nodes) data.push(`${key}\n\t(-> incoming)[${[...value.incoming.keys()].join(", ")}]\n\t(outgoing ->)[${[...value.outgoing.keys()].join(",")}]\n`);
		return data.join("\n");
	}
	/**
	* This is brute force and slow and **only** be used
	* to trouble shoot.
	*/
	findCycleSlow() {
		for (const [id, node] of this._nodes) {
			const seen = /* @__PURE__ */ new Set([id]);
			const res = this._findCycle(node, seen);
			if (res) return res;
		}
	}
	_findCycle(node, seen) {
		for (const [id, outgoing] of node.outgoing) {
			if (seen.has(id)) return [...seen, id].join(" -> ");
			seen.add(id);
			const value = this._findCycle(outgoing, seen);
			if (value) return value;
			seen.delete(id);
		}
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/instantiation/common/instantiationService.js
var _enableAllTracing = false;
var CyclicDependencyError = class extends Error {
	constructor(graph) {
		super("cyclic dependency between services");
		this.message = graph.findCycleSlow() ?? `UNABLE to detect cycle, dumping graph: \n${graph.toString()}`;
	}
};
var InstantiationService = class InstantiationService {
	constructor(_services = new ServiceCollection(), _strict = false, _parent, _enableTracing = _enableAllTracing) {
		this._services = _services;
		this._strict = _strict;
		this._parent = _parent;
		this._enableTracing = _enableTracing;
		this._isDisposed = false;
		this._servicesToMaybeDispose = /* @__PURE__ */ new Set();
		this._children = /* @__PURE__ */ new Set();
		this._activeInstantiations = /* @__PURE__ */ new Set();
		this._services.set(IInstantiationService, this);
		this._globalGraph = _enableTracing ? _parent?._globalGraph ?? new Graph((e) => e) : void 0;
	}
	dispose() {
		if (!this._isDisposed) {
			this._isDisposed = true;
			dispose(this._children);
			this._children.clear();
			for (const candidate of this._servicesToMaybeDispose) if (isDisposable(candidate)) candidate.dispose();
			this._servicesToMaybeDispose.clear();
		}
	}
	_throwIfDisposed() {
		if (this._isDisposed) throw new Error("InstantiationService has been disposed");
	}
	createChild(services, store) {
		this._throwIfDisposed();
		const that = this;
		const result = new class extends InstantiationService {
			dispose() {
				that._children.delete(result);
				super.dispose();
			}
		}(services, this._strict, this, this._enableTracing);
		this._children.add(result);
		store?.add(result);
		return result;
	}
	invokeFunction(fn, ...args) {
		this._throwIfDisposed();
		const _trace = Trace.traceInvocation(this._enableTracing, fn);
		let _done = false;
		try {
			return fn({ get: (id) => {
				if (_done) throw illegalState("service accessor is only valid during the invocation of its target method");
				const result = this._getOrCreateServiceInstance(id, _trace);
				if (!result) this._throwIfStrict(`[invokeFunction] unknown service '${id}'`, false);
				return result;
			} }, ...args);
		} finally {
			_done = true;
			_trace.stop();
		}
	}
	createInstance(ctorOrDescriptor, ...rest) {
		this._throwIfDisposed();
		let _trace;
		let result;
		if (ctorOrDescriptor instanceof SyncDescriptor) {
			_trace = Trace.traceCreation(this._enableTracing, ctorOrDescriptor.ctor);
			result = this._createInstance(ctorOrDescriptor.ctor, ctorOrDescriptor.staticArguments.concat(rest), _trace);
		} else {
			_trace = Trace.traceCreation(this._enableTracing, ctorOrDescriptor);
			result = this._createInstance(ctorOrDescriptor, rest, _trace);
		}
		_trace.stop();
		return result;
	}
	_createInstance(ctor, args = [], _trace) {
		const serviceDependencies = _util.getServiceDependencies(ctor).sort((a, b) => a.index - b.index);
		const serviceArgs = [];
		for (const dependency of serviceDependencies) {
			const service = this._getOrCreateServiceInstance(dependency.id, _trace);
			if (!service) this._throwIfStrict(`[createInstance] ${ctor.name} depends on UNKNOWN service ${dependency.id}.`, false);
			serviceArgs.push(service);
		}
		const firstServiceArgPos = serviceDependencies.length > 0 ? serviceDependencies[0].index : args.length;
		if (args.length !== firstServiceArgPos) {
			console.trace(`[createInstance] First service dependency of ${ctor.name} at position ${firstServiceArgPos + 1} conflicts with ${args.length} static arguments`);
			const delta = firstServiceArgPos - args.length;
			if (delta > 0) args = args.concat(new Array(delta));
			else args = args.slice(0, firstServiceArgPos);
		}
		return Reflect.construct(ctor, args.concat(serviceArgs));
	}
	_setCreatedServiceInstance(id, instance) {
		if (this._services.get(id) instanceof SyncDescriptor) this._services.set(id, instance);
		else if (this._parent) this._parent._setCreatedServiceInstance(id, instance);
		else throw new Error("illegalState - setting UNKNOWN service instance");
	}
	_getServiceInstanceOrDescriptor(id) {
		const instanceOrDesc = this._services.get(id);
		if (!instanceOrDesc && this._parent) return this._parent._getServiceInstanceOrDescriptor(id);
		else return instanceOrDesc;
	}
	_getOrCreateServiceInstance(id, _trace) {
		if (this._globalGraph && this._globalGraphImplicitDependency) this._globalGraph.insertEdge(this._globalGraphImplicitDependency, String(id));
		const thing = this._getServiceInstanceOrDescriptor(id);
		if (thing instanceof SyncDescriptor) return this._safeCreateAndCacheServiceInstance(id, thing, _trace.branch(id, true));
		else {
			_trace.branch(id, false);
			return thing;
		}
	}
	_safeCreateAndCacheServiceInstance(id, desc, _trace) {
		if (this._activeInstantiations.has(id)) throw new Error(`illegal state - RECURSIVELY instantiating service '${id}'`);
		this._activeInstantiations.add(id);
		try {
			return this._createAndCacheServiceInstance(id, desc, _trace);
		} finally {
			this._activeInstantiations.delete(id);
		}
	}
	_createAndCacheServiceInstance(id, desc, _trace) {
		const graph = new Graph((data) => data.id.toString());
		let cycleCount = 0;
		const stack = [{
			id,
			desc,
			_trace
		}];
		const seen = /* @__PURE__ */ new Set();
		while (stack.length) {
			const item = stack.pop();
			if (seen.has(String(item.id))) continue;
			seen.add(String(item.id));
			graph.lookupOrInsertNode(item);
			if (cycleCount++ > 1e3) throw new CyclicDependencyError(graph);
			for (const dependency of _util.getServiceDependencies(item.desc.ctor)) {
				const instanceOrDesc = this._getServiceInstanceOrDescriptor(dependency.id);
				if (!instanceOrDesc) this._throwIfStrict(`[createInstance] ${id} depends on ${dependency.id} which is NOT registered.`, true);
				this._globalGraph?.insertEdge(String(item.id), String(dependency.id));
				if (instanceOrDesc instanceof SyncDescriptor) {
					const d = {
						id: dependency.id,
						desc: instanceOrDesc,
						_trace: item._trace.branch(dependency.id, true)
					};
					graph.insertEdge(item, d);
					stack.push(d);
				}
			}
		}
		while (true) {
			const roots = graph.roots();
			if (roots.length === 0) {
				if (!graph.isEmpty()) throw new CyclicDependencyError(graph);
				break;
			}
			for (const { data } of roots) {
				if (this._getServiceInstanceOrDescriptor(data.id) instanceof SyncDescriptor) {
					const instance = this._createServiceInstanceWithOwner(data.id, data.desc.ctor, data.desc.staticArguments, data.desc.supportsDelayedInstantiation, data._trace);
					this._setCreatedServiceInstance(data.id, instance);
				}
				graph.removeNode(data);
			}
		}
		return this._getServiceInstanceOrDescriptor(id);
	}
	_createServiceInstanceWithOwner(id, ctor, args = [], supportsDelayedInstantiation, _trace) {
		if (this._services.get(id) instanceof SyncDescriptor) return this._createServiceInstance(id, ctor, args, supportsDelayedInstantiation, _trace, this._servicesToMaybeDispose);
		else if (this._parent) return this._parent._createServiceInstanceWithOwner(id, ctor, args, supportsDelayedInstantiation, _trace);
		else throw new Error(`illegalState - creating UNKNOWN service instance ${ctor.name}`);
	}
	_createServiceInstance(id, ctor, args = [], supportsDelayedInstantiation, _trace, disposeBucket) {
		if (!supportsDelayedInstantiation) {
			const result = this._createInstance(ctor, args, _trace);
			disposeBucket.add(result);
			return result;
		} else {
			const child = new InstantiationService(void 0, this._strict, this, this._enableTracing);
			child._globalGraphImplicitDependency = String(id);
			const earlyListeners = /* @__PURE__ */ new Map();
			const idle = new GlobalIdleValue(() => {
				const result = child._createInstance(ctor, args, _trace);
				for (const [key, values] of earlyListeners) {
					const candidate = result[key];
					if (typeof candidate === "function") for (const value of values) value.disposable = candidate.apply(result, value.listener);
				}
				earlyListeners.clear();
				disposeBucket.add(result);
				return result;
			});
			return new Proxy(Object.create(null), {
				get(target, key) {
					if (!idle.isInitialized) {
						if (typeof key === "string" && (key.startsWith("onDid") || key.startsWith("onWill"))) {
							let list = earlyListeners.get(key);
							if (!list) {
								list = new LinkedList();
								earlyListeners.set(key, list);
							}
							const event = (callback, thisArg, disposables) => {
								if (idle.isInitialized) return idle.value[key](callback, thisArg, disposables);
								else {
									const entry = {
										listener: [
											callback,
											thisArg,
											disposables
										],
										disposable: void 0
									};
									const rm = list.push(entry);
									return toDisposable(() => {
										rm();
										entry.disposable?.dispose();
									});
								}
							};
							return event;
						}
					}
					if (key in target) return target[key];
					const obj = idle.value;
					let prop = obj[key];
					if (typeof prop !== "function") return prop;
					prop = prop.bind(obj);
					target[key] = prop;
					return prop;
				},
				set(_target, p, value) {
					idle.value[p] = value;
					return true;
				},
				getPrototypeOf(_target) {
					return ctor.prototype;
				}
			});
		}
	}
	_throwIfStrict(msg, printWarning) {
		if (printWarning) console.warn(msg);
		if (this._strict) throw new Error(msg);
	}
};
var Trace = class Trace {
	static {
		this.all = /* @__PURE__ */ new Set();
	}
	static {
		this._None = new class extends Trace {
			constructor() {
				super(0, null);
			}
			stop() {}
			branch() {
				return this;
			}
		}();
	}
	static traceInvocation(_enableTracing, ctor) {
		return !_enableTracing ? Trace._None : new Trace(2, ctor.name || (/* @__PURE__ */ new Error()).stack.split("\n").slice(3, 4).join("\n"));
	}
	static traceCreation(_enableTracing, ctor) {
		return !_enableTracing ? Trace._None : new Trace(1, ctor.name);
	}
	static {
		this._totals = 0;
	}
	constructor(type, name) {
		this.type = type;
		this.name = name;
		this._start = Date.now();
		this._dep = [];
	}
	branch(id, first) {
		const child = new Trace(3, id.toString());
		this._dep.push([
			id,
			first,
			child
		]);
		return child;
	}
	stop() {
		const dur = Date.now() - this._start;
		Trace._totals += dur;
		let causedCreation = false;
		function printChild(n, trace) {
			const res = [];
			const prefix = new Array(n + 1).join("	");
			for (const [id, first, child] of trace._dep) if (first && child) {
				causedCreation = true;
				res.push(`${prefix}CREATES -> ${id}`);
				const nested = printChild(n + 1, child);
				if (nested) res.push(nested);
			} else res.push(`${prefix}uses -> ${id}`);
			return res.join("\n");
		}
		const lines = [
			`${this.type === 1 ? "CREATE" : "CALL"} ${this.name}`,
			`${printChild(1, this)}`,
			`DONE, took ${dur.toFixed(2)}ms (grand total ${Trace._totals.toFixed(2)}ms)`
		];
		if (dur > 2 || causedCreation) Trace.all.add(lines.join("\n"));
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/keybinding/common/keybindingResolver.js
var NoMatchingKb = { kind: 0 };
var MoreChordsNeeded = { kind: 1 };
function KbFound(commandId, commandArgs, isBubble) {
	return {
		kind: 2,
		commandId,
		commandArgs,
		isBubble
	};
}
/**
* Stores mappings from keybindings to commands and from commands to keybindings.
* Given a sequence of chords, `resolve`s which keybinding it matches
*/
var KeybindingResolver = class KeybindingResolver {
	constructor(defaultKeybindings, overrides, log) {
		this._log = log;
		this._defaultKeybindings = defaultKeybindings;
		this._defaultBoundCommands = /* @__PURE__ */ new Map();
		for (const defaultKeybinding of defaultKeybindings) {
			const command = defaultKeybinding.command;
			if (command && command.charAt(0) !== "-") this._defaultBoundCommands.set(command, true);
		}
		this._map = /* @__PURE__ */ new Map();
		this._lookupMap = /* @__PURE__ */ new Map();
		this._keybindings = KeybindingResolver.handleRemovals([].concat(defaultKeybindings).concat(overrides));
		for (let i = 0, len = this._keybindings.length; i < len; i++) {
			const k = this._keybindings[i];
			if (k.chords.length === 0) continue;
			const when = k.when?.substituteConstants();
			if (when && when.type === 0) continue;
			this._addKeyPress(k.chords[0], k);
		}
	}
	static _isTargetedForRemoval(defaultKb, keypress, when) {
		if (keypress) {
			for (let i = 0; i < keypress.length; i++) if (keypress[i] !== defaultKb.chords[i]) return false;
		}
		if (when && when.type !== 1) {
			if (!defaultKb.when) return false;
			const defaultWhen = defaultKb.when.substituteConstants();
			const removalWhen = when.substituteConstants();
			if (!KeybindingResolver.whenIsEntirelyIncluded(defaultWhen, removalWhen)) return false;
		}
		return true;
	}
	/**
	* Looks for rules containing "-commandId" and removes them.
	*/
	static handleRemovals(rules) {
		const removals = /* @__PURE__ */ new Map();
		for (let i = 0, len = rules.length; i < len; i++) {
			const rule = rules[i];
			if (rule.command && rule.command.charAt(0) === "-") {
				const command = rule.command.substring(1);
				if (!removals.has(command)) removals.set(command, [rule]);
				else removals.get(command).push(rule);
			}
		}
		if (removals.size === 0) return rules;
		const result = [];
		for (let i = 0, len = rules.length; i < len; i++) {
			const rule = rules[i];
			if (!rule.command || rule.command.length === 0) {
				result.push(rule);
				continue;
			}
			if (rule.command.charAt(0) === "-") continue;
			const commandRemovals = removals.get(rule.command);
			if (!commandRemovals || !rule.isDefault) {
				result.push(rule);
				continue;
			}
			let isRemoved = false;
			for (const commandRemoval of commandRemovals) {
				const when = commandRemoval.when;
				if (this._isTargetedForRemoval(rule, commandRemoval.chords, when)) {
					isRemoved = true;
					break;
				}
			}
			if (!isRemoved) {
				result.push(rule);
				continue;
			}
		}
		return result;
	}
	_addKeyPress(keypress, item) {
		const conflicts = this._map.get(keypress);
		if (typeof conflicts === "undefined") {
			this._map.set(keypress, [item]);
			this._addToLookupMap(item);
			return;
		}
		for (let i = conflicts.length - 1; i >= 0; i--) {
			const conflict = conflicts[i];
			if (conflict.command === item.command) continue;
			let isShorterKbPrefix = true;
			for (let i = 1; i < conflict.chords.length && i < item.chords.length; i++) if (conflict.chords[i] !== item.chords[i]) {
				isShorterKbPrefix = false;
				break;
			}
			if (!isShorterKbPrefix) continue;
			if (KeybindingResolver.whenIsEntirelyIncluded(conflict.when, item.when)) this._removeFromLookupMap(conflict);
		}
		conflicts.push(item);
		this._addToLookupMap(item);
	}
	_addToLookupMap(item) {
		if (!item.command) return;
		let arr = this._lookupMap.get(item.command);
		if (typeof arr === "undefined") {
			arr = [item];
			this._lookupMap.set(item.command, arr);
		} else arr.push(item);
	}
	_removeFromLookupMap(item) {
		if (!item.command) return;
		const arr = this._lookupMap.get(item.command);
		if (typeof arr === "undefined") return;
		for (let i = 0, len = arr.length; i < len; i++) if (arr[i] === item) {
			arr.splice(i, 1);
			return;
		}
	}
	/**
	* Returns true if it is provable `a` implies `b`.
	*/
	static whenIsEntirelyIncluded(a, b) {
		if (!b || b.type === 1) return true;
		if (!a || a.type === 1) return false;
		return implies(a, b);
	}
	getKeybindings() {
		return this._keybindings;
	}
	lookupPrimaryKeybinding(commandId, context, enforceContextCheck = false) {
		const items = this._lookupMap.get(commandId);
		if (typeof items === "undefined" || items.length === 0) return null;
		if (items.length === 1 && !enforceContextCheck) return items[0];
		for (let i = items.length - 1; i >= 0; i--) {
			const item = items[i];
			if (context.contextMatchesRules(item.when)) return item;
		}
		if (enforceContextCheck) return null;
		return items[items.length - 1];
	}
	/**
	* Looks up a keybinding trigged as a result of pressing a sequence of chords - `[...currentChords, keypress]`
	*
	* Example: resolving 3 chords pressed sequentially - `cmd+k cmd+p cmd+i`:
	* 	`currentChords = [ 'cmd+k' , 'cmd+p' ]` and `keypress = `cmd+i` - last pressed chord
	*/
	resolve(context, currentChords, keypress) {
		const pressedChords = [...currentChords, keypress];
		this._log(`| Resolving ${pressedChords}`);
		const kbCandidates = this._map.get(pressedChords[0]);
		if (kbCandidates === void 0) {
			this._log(`\\ No keybinding entries.`);
			return NoMatchingKb;
		}
		let lookupMap = null;
		if (pressedChords.length < 2) lookupMap = kbCandidates;
		else {
			lookupMap = [];
			for (let i = 0, len = kbCandidates.length; i < len; i++) {
				const candidate = kbCandidates[i];
				if (pressedChords.length > candidate.chords.length) continue;
				let prefixMatches = true;
				for (let i = 1; i < pressedChords.length; i++) if (candidate.chords[i] !== pressedChords[i]) {
					prefixMatches = false;
					break;
				}
				if (prefixMatches) lookupMap.push(candidate);
			}
		}
		const result = this._findCommand(context, lookupMap);
		if (!result) {
			this._log(`\\ From ${lookupMap.length} keybinding entries, no when clauses matched the context.`);
			return NoMatchingKb;
		}
		if (pressedChords.length < result.chords.length) {
			this._log(`\\ From ${lookupMap.length} keybinding entries, awaiting ${result.chords.length - pressedChords.length} more chord(s), when: ${printWhenExplanation(result.when)}, source: ${printSourceExplanation(result)}.`);
			return MoreChordsNeeded;
		}
		this._log(`\\ From ${lookupMap.length} keybinding entries, matched ${result.command}, when: ${printWhenExplanation(result.when)}, source: ${printSourceExplanation(result)}.`);
		return KbFound(result.command, result.commandArgs, result.bubble);
	}
	_findCommand(context, matches) {
		for (let i = matches.length - 1; i >= 0; i--) {
			const k = matches[i];
			if (!KeybindingResolver._contextMatchesRules(context, k.when)) continue;
			return k;
		}
		return null;
	}
	static _contextMatchesRules(context, rules) {
		if (!rules) return true;
		return rules.evaluate(context);
	}
};
function printWhenExplanation(when) {
	if (!when) return `no when condition`;
	return `${when.serialize()}`;
}
function printSourceExplanation(kb) {
	return kb.extensionId ? kb.isBuiltinExtension ? `built-in extension ${kb.extensionId}` : `user extension ${kb.extensionId}` : kb.isDefault ? `built-in` : `user`;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/keybinding/common/abstractKeybindingService.js
var HIGH_FREQ_COMMANDS = /^(cursor|delete|undo|redo|tab|editor\.action\.clipboard)/;
/**
* Whether the keystroke belongs to an in-flight IME composition. `StandardKeyboardEvent` normalizes
* every composing keystroke to {@link KeyCode.KEY_IN_COMPOSITION}, including the platform/IME
* combinations that would otherwise report the real key code for keys the IME owns.
*/
function isKeyInComposition(e) {
	return e.keyCode === 114;
}
var AbstractKeybindingService = class extends Disposable {
	get onDidUpdateKeybindings() {
		return this._onDidUpdateKeybindings ? this._onDidUpdateKeybindings.event : Event.None;
	}
	get inChordMode() {
		return this._currentChords.length > 0;
	}
	constructor(_contextKeyService, _commandService, _telemetryService, _notificationService, _logService) {
		super();
		this._contextKeyService = _contextKeyService;
		this._commandService = _commandService;
		this._telemetryService = _telemetryService;
		this._notificationService = _notificationService;
		this._logService = _logService;
		this._onDidUpdateKeybindings = this._register(new Emitter$1());
		this._currentChords = [];
		this._currentChordChecker = new IntervalTimer();
		this._currentChordStatusMessage = null;
		this._ignoreSingleModifiers = KeybindingModifierSet.EMPTY;
		this._currentSingleModifier = null;
		this._currentSingleModifierClearTimeout = new TimeoutTimer();
		this._currentlyDispatchingCommandId = null;
		this._logging = false;
	}
	_log(str) {
		if (this._logging) this._logService.info(`[KeybindingService]: ${str}`);
	}
	getKeybindings() {
		return this._getResolver().getKeybindings();
	}
	lookupKeybinding(commandId, context, enforceContextCheck = false) {
		const result = this._getResolver().lookupPrimaryKeybinding(commandId, context || this._contextKeyService, enforceContextCheck);
		if (!result) return;
		return result.resolvedKeybinding;
	}
	dispatchEvent(e, target) {
		return this._dispatch(e, target);
	}
	softDispatch(e, target) {
		this._log(`/ Soft dispatching keyboard event`);
		if (isKeyInComposition(e)) {
			this._log(`\\ Keyboard event is part of an IME composition`);
			return NoMatchingKb;
		}
		const keybinding = this.resolveKeyboardEvent(e);
		if (keybinding.hasMultipleChords()) {
			console.warn("keyboard event should not be mapped to multiple chords");
			return NoMatchingKb;
		}
		const [firstChord] = keybinding.getDispatchChords();
		if (firstChord === null) {
			this._log(`\\ Keyboard event cannot be dispatched`);
			return NoMatchingKb;
		}
		const contextValue = this._contextKeyService.getContext(target);
		const currentChords = this._currentChords.map((({ keypress }) => keypress));
		return this._getResolver().resolve(contextValue, currentChords, firstChord);
	}
	_scheduleLeaveChordMode() {
		const chordLastInteractedTime = Date.now();
		this._currentChordChecker.cancelAndSet(() => {
			if (!this._documentHasFocus()) {
				this._leaveChordMode();
				return;
			}
			if (Date.now() - chordLastInteractedTime > 5e3) this._leaveChordMode();
		}, 500);
	}
	_expectAnotherChord(firstChord, keypressLabel) {
		this._currentChords.push({
			keypress: firstChord,
			label: keypressLabel
		});
		switch (this._currentChords.length) {
			case 0: throw illegalState("impossible");
			case 1:
				this._currentChordStatusMessage = this._notificationService.status(localize(1796, "({0}) was pressed. Waiting for second key of chord...", keypressLabel));
				break;
			default: {
				const fullKeypressLabel = this._currentChords.map(({ label }) => label).join(", ");
				this._currentChordStatusMessage = this._notificationService.status(localize(1797, "({0}) was pressed. Waiting for next key of chord...", fullKeypressLabel));
			}
		}
		this._scheduleLeaveChordMode();
		if (IME.enabled) IME.disable();
	}
	_leaveChordMode() {
		if (this._currentChordStatusMessage) {
			this._currentChordStatusMessage.close();
			this._currentChordStatusMessage = null;
		}
		this._currentChordChecker.cancel();
		this._currentChords = [];
		IME.enable();
	}
	_dispatch(e, target) {
		if (isKeyInComposition(e)) {
			this._log(`+ Ignoring keybinding dispatch because an IME composition is in progress.`);
			return false;
		}
		return this._doDispatch(this.resolveKeyboardEvent(e), target, false);
	}
	_singleModifierDispatch(e, target) {
		if (isKeyInComposition(e)) return false;
		const keybinding = this.resolveKeyboardEvent(e);
		const [singleModifier] = keybinding.getSingleModifierDispatchChords();
		if (singleModifier) {
			if (this._ignoreSingleModifiers.has(singleModifier)) {
				this._log(`+ Ignoring single modifier ${singleModifier} due to it being pressed together with other keys.`);
				this._ignoreSingleModifiers = KeybindingModifierSet.EMPTY;
				this._currentSingleModifierClearTimeout.cancel();
				this._currentSingleModifier = null;
				return false;
			}
			this._ignoreSingleModifiers = KeybindingModifierSet.EMPTY;
			if (this._currentSingleModifier === null) {
				this._log(`+ Storing single modifier for possible chord ${singleModifier}.`);
				this._currentSingleModifier = singleModifier;
				this._currentSingleModifierClearTimeout.cancelAndSet(() => {
					this._log(`+ Clearing single modifier due to 300ms elapsed.`);
					this._currentSingleModifier = null;
				}, 300);
				return false;
			}
			if (singleModifier === this._currentSingleModifier) {
				this._log(`/ Dispatching single modifier chord ${singleModifier} ${singleModifier}`);
				this._currentSingleModifierClearTimeout.cancel();
				this._currentSingleModifier = null;
				return this._doDispatch(keybinding, target, true);
			}
			this._log(`+ Clearing single modifier due to modifier mismatch: ${this._currentSingleModifier} ${singleModifier}`);
			this._currentSingleModifierClearTimeout.cancel();
			this._currentSingleModifier = null;
			return false;
		}
		const [firstChord] = keybinding.getChords();
		this._ignoreSingleModifiers = new KeybindingModifierSet(firstChord);
		if (this._currentSingleModifier !== null) this._log(`+ Clearing single modifier due to other key up.`);
		this._currentSingleModifierClearTimeout.cancel();
		this._currentSingleModifier = null;
		return false;
	}
	_doDispatch(userKeypress, target, isSingleModiferChord = false) {
		let shouldPreventDefault = false;
		if (userKeypress.hasMultipleChords()) {
			console.warn("Unexpected keyboard event mapped to multiple chords");
			return false;
		}
		let userPressedChord = null;
		let currentChords = null;
		if (isSingleModiferChord) {
			const [dispatchKeyname] = userKeypress.getSingleModifierDispatchChords();
			userPressedChord = dispatchKeyname;
			currentChords = dispatchKeyname ? [dispatchKeyname] : [];
		} else {
			[userPressedChord] = userKeypress.getDispatchChords();
			currentChords = this._currentChords.map(({ keypress }) => keypress);
		}
		if (userPressedChord === null) {
			this._log(`\\ Keyboard event cannot be dispatched in keydown phase.`);
			return shouldPreventDefault;
		}
		const contextValue = this._contextKeyService.getContext(target);
		const keypressLabel = userKeypress.getLabel();
		const resolveResult = this._getResolver().resolve(contextValue, currentChords, userPressedChord);
		switch (resolveResult.kind) {
			case 0:
				this._logService.trace("KeybindingService#dispatch", keypressLabel, `[ No matching keybinding ]`);
				if (this.inChordMode) {
					const currentChordsLabel = this._currentChords.map(({ label }) => label).join(", ");
					this._log(`+ Leaving multi-chord mode: Nothing bound to "${currentChordsLabel}, ${keypressLabel}".`);
					this._notificationService.status(localize(1798, "The key combination ({0}, {1}) is not a command.", currentChordsLabel, keypressLabel), { hideAfter: 1e4 });
					this._leaveChordMode();
					shouldPreventDefault = true;
				}
				return shouldPreventDefault;
			case 1:
				this._logService.trace("KeybindingService#dispatch", keypressLabel, `[ Several keybindings match - more chords needed ]`);
				shouldPreventDefault = true;
				this._expectAnotherChord(userPressedChord, keypressLabel);
				this._log(this._currentChords.length === 1 ? `+ Entering multi-chord mode...` : `+ Continuing multi-chord mode...`);
				return shouldPreventDefault;
			case 2:
				this._logService.trace("KeybindingService#dispatch", keypressLabel, `[ Will dispatch command ${resolveResult.commandId} ]`);
				if (resolveResult.commandId === null || resolveResult.commandId === "") {
					if (this.inChordMode) {
						const currentChordsLabel = this._currentChords.map(({ label }) => label).join(", ");
						this._log(`+ Leaving chord mode: Nothing bound to "${currentChordsLabel}, ${keypressLabel}".`);
						this._notificationService.status(localize(1799, "The key combination ({0}, {1}) is not a command.", currentChordsLabel, keypressLabel), { hideAfter: 1e4 });
						this._leaveChordMode();
						shouldPreventDefault = true;
					}
				} else {
					if (this.inChordMode) this._leaveChordMode();
					if (!resolveResult.isBubble) shouldPreventDefault = true;
					this._log(`+ Invoking command ${resolveResult.commandId}.`);
					this._currentlyDispatchingCommandId = resolveResult.commandId;
					try {
						if (typeof resolveResult.commandArgs === "undefined") this._commandService.executeCommand(resolveResult.commandId).then(void 0, (err) => this._notificationService.warn(err));
						else this._commandService.executeCommand(resolveResult.commandId, resolveResult.commandArgs).then(void 0, (err) => this._notificationService.warn(err));
					} finally {
						this._currentlyDispatchingCommandId = null;
					}
					if (!HIGH_FREQ_COMMANDS.test(resolveResult.commandId)) this._telemetryService.publicLog2("workbenchActionExecuted", {
						id: resolveResult.commandId,
						from: "keybinding",
						detail: userKeypress.getUserSettingsLabel() ?? void 0
					});
				}
				return shouldPreventDefault;
		}
	}
	mightProducePrintableCharacter(event) {
		if (event.ctrlKey || event.metaKey) return false;
		if (event.keyCode >= 31 && event.keyCode <= 56 || event.keyCode >= 21 && event.keyCode <= 30) return true;
		return false;
	}
	appendKeybinding(label, commandId, context, enforceContextCheck) {
		if (commandId) {
			const keybindingLabel = this.lookupKeybinding(commandId, context, enforceContextCheck)?.getLabel();
			if (keybindingLabel) return localize(1800, "{0} ({1})", label, keybindingLabel);
		}
		return label;
	}
};
var KeybindingModifierSet = class KeybindingModifierSet {
	static {
		this.EMPTY = new KeybindingModifierSet(null);
	}
	constructor(source) {
		this._ctrlKey = source ? source.ctrlKey : false;
		this._shiftKey = source ? source.shiftKey : false;
		this._altKey = source ? source.altKey : false;
		this._metaKey = source ? source.metaKey : false;
	}
	has(modifier) {
		switch (modifier) {
			case "ctrl": return this._ctrlKey;
			case "shift": return this._shiftKey;
			case "alt": return this._altKey;
			case "meta": return this._metaKey;
		}
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/keybinding/common/resolvedKeybindingItem.js
var ResolvedKeybindingItem = class {
	constructor(resolvedKeybinding, command, commandArgs, when, isDefault, extensionId, isBuiltinExtension, systemWide = false) {
		this._resolvedKeybindingItemBrand = void 0;
		this.resolvedKeybinding = resolvedKeybinding;
		this.chords = resolvedKeybinding ? toEmptyArrayIfContainsNull(resolvedKeybinding.getDispatchChords()) : [];
		if (resolvedKeybinding && this.chords.length === 0) this.chords = toEmptyArrayIfContainsNull(resolvedKeybinding.getSingleModifierDispatchChords());
		this.bubble = command ? command.charCodeAt(0) === 94 : false;
		this.command = this.bubble ? command.substr(1) : command;
		this.commandArgs = commandArgs;
		this.when = when;
		this.isDefault = isDefault;
		this.extensionId = extensionId;
		this.isBuiltinExtension = isBuiltinExtension;
		this.systemWide = systemWide;
	}
};
function toEmptyArrayIfContainsNull(arr) {
	const result = [];
	for (let i = 0, len = arr.length; i < len; i++) {
		const element = arr[i];
		if (!element) return [];
		result.push(element);
	}
	return result;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/keybinding/common/baseResolvedKeybinding.js
var BaseResolvedKeybinding = class extends ResolvedKeybinding {
	constructor(os, chords) {
		super();
		if (chords.length === 0) throw illegalArgument(`chords`);
		this._os = os;
		this._chords = chords;
	}
	getLabel() {
		return UILabelProvider.toLabel(this._os, this._chords, (keybinding) => this._getLabel(keybinding));
	}
	getAriaLabel() {
		return AriaLabelProvider.toLabel(this._os, this._chords, (keybinding) => this._getAriaLabel(keybinding));
	}
	getElectronAccelerator() {
		if (this._chords.length > 1) return null;
		if (this._chords[0].isDuplicateModifierCase()) return null;
		return ElectronAcceleratorLabelProvider.toLabel(this._os, this._chords, (keybinding) => this._getElectronAccelerator(keybinding));
	}
	getUserSettingsLabel() {
		return UserSettingsLabelProvider.toLabel(this._os, this._chords, (keybinding) => this._getUserSettingsLabel(keybinding));
	}
	hasMultipleChords() {
		return this._chords.length > 1;
	}
	getChords() {
		return this._chords.map((keybinding) => this._getChord(keybinding));
	}
	_getChord(keybinding) {
		return new ResolvedChord(keybinding.ctrlKey, keybinding.shiftKey, keybinding.altKey, keybinding.metaKey, this._getLabel(keybinding), this._getAriaLabel(keybinding));
	}
	getDispatchChords() {
		return this._chords.map((keybinding) => this._getChordDispatch(keybinding));
	}
	getSingleModifierDispatchChords() {
		return this._chords.map((keybinding) => this._getSingleModifierChordDispatch(keybinding));
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/keybinding/common/usLayoutResolvedKeybinding.js
/**
* Do not instantiate. Use KeybindingService to get a ResolvedKeybinding seeded with information about the current kb layout.
*/
var USLayoutResolvedKeybinding = class USLayoutResolvedKeybinding extends BaseResolvedKeybinding {
	constructor(chords, os) {
		super(os, chords);
	}
	_keyCodeToUILabel(keyCode) {
		if (this._os === 2) switch (keyCode) {
			case 15: return "←";
			case 16: return "↑";
			case 17: return "→";
			case 18: return "↓";
		}
		return KeyCodeUtils.toString(keyCode);
	}
	_getLabel(chord) {
		if (chord.isDuplicateModifierCase()) return "";
		return this._keyCodeToUILabel(chord.keyCode);
	}
	_getAriaLabel(chord) {
		if (chord.isDuplicateModifierCase()) return "";
		return KeyCodeUtils.toString(chord.keyCode);
	}
	_getElectronAccelerator(chord) {
		return KeyCodeUtils.toElectronAccelerator(chord.keyCode);
	}
	_getUserSettingsLabel(chord) {
		if (chord.isDuplicateModifierCase()) return "";
		const result = KeyCodeUtils.toUserSettingsUS(chord.keyCode);
		return result ? result.toLowerCase() : result;
	}
	_getChordDispatch(chord) {
		return USLayoutResolvedKeybinding.getDispatchStr(chord);
	}
	static getDispatchStr(chord) {
		if (chord.isModifierKey()) return null;
		let result = "";
		if (chord.ctrlKey) result += "ctrl+";
		if (chord.shiftKey) result += "shift+";
		if (chord.altKey) result += "alt+";
		if (chord.metaKey) result += "meta+";
		result += KeyCodeUtils.toString(chord.keyCode);
		return result;
	}
	_getSingleModifierChordDispatch(keybinding) {
		if (keybinding.keyCode === 5 && !keybinding.shiftKey && !keybinding.altKey && !keybinding.metaKey) return "ctrl";
		if (keybinding.keyCode === 4 && !keybinding.ctrlKey && !keybinding.altKey && !keybinding.metaKey) return "shift";
		if (keybinding.keyCode === 6 && !keybinding.ctrlKey && !keybinding.shiftKey && !keybinding.metaKey) return "alt";
		if (keybinding.keyCode === 57 && !keybinding.ctrlKey && !keybinding.shiftKey && !keybinding.altKey) return "meta";
		return null;
	}
	/**
	* *NOTE*: Check return value for `KeyCode.Unknown`.
	*/
	static _scanCodeToKeyCode(scanCode) {
		const immutableKeyCode = IMMUTABLE_CODE_TO_KEY_CODE[scanCode];
		if (immutableKeyCode !== -1) return immutableKeyCode;
		switch (scanCode) {
			case 10: return 31;
			case 11: return 32;
			case 12: return 33;
			case 13: return 34;
			case 14: return 35;
			case 15: return 36;
			case 16: return 37;
			case 17: return 38;
			case 18: return 39;
			case 19: return 40;
			case 20: return 41;
			case 21: return 42;
			case 22: return 43;
			case 23: return 44;
			case 24: return 45;
			case 25: return 46;
			case 26: return 47;
			case 27: return 48;
			case 28: return 49;
			case 29: return 50;
			case 30: return 51;
			case 31: return 52;
			case 32: return 53;
			case 33: return 54;
			case 34: return 55;
			case 35: return 56;
			case 36: return 22;
			case 37: return 23;
			case 38: return 24;
			case 39: return 25;
			case 40: return 26;
			case 41: return 27;
			case 42: return 28;
			case 43: return 29;
			case 44: return 30;
			case 45: return 21;
			case 51: return 88;
			case 52: return 86;
			case 53: return 92;
			case 54: return 94;
			case 55: return 93;
			case 56: return 0;
			case 57: return 85;
			case 58: return 95;
			case 59: return 91;
			case 60: return 87;
			case 61: return 89;
			case 62: return 90;
			case 106: return 97;
		}
		return 0;
	}
	static _toKeyCodeChord(chord) {
		if (!chord) return null;
		if (chord instanceof KeyCodeChord) return chord;
		const keyCode = this._scanCodeToKeyCode(chord.scanCode);
		if (keyCode === 0) return null;
		return new KeyCodeChord(chord.ctrlKey, chord.shiftKey, chord.altKey, chord.metaKey, keyCode);
	}
	static resolveKeybinding(keybinding, os) {
		const chords = toEmptyArrayIfContainsNull(keybinding.chords.map((chord) => this._toKeyCodeChord(chord)));
		if (chords.length > 0) return [new USLayoutResolvedKeybinding(chords, os)];
		return [];
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/label/common/label.js
var ILabelService = createDecorator("labelService");
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/list/listPaging.js
var PagedRenderer = class {
	get templateId() {
		return this.renderer.templateId;
	}
	constructor(renderer, modelProvider) {
		this.renderer = renderer;
		this.modelProvider = modelProvider;
	}
	renderTemplate(container) {
		return {
			data: this.renderer.renderTemplate(container),
			disposable: Disposable.None
		};
	}
	renderElement(index, _, data, details) {
		data.disposable?.dispose();
		if (!data.data) return;
		const model = this.modelProvider();
		if (model.isResolved(index)) return this.renderer.renderElement(model.get(index), index, data.data, details);
		const cts = new CancellationTokenSource$1();
		const promise = model.resolve(index, cts.token);
		data.disposable = { dispose: () => cts.cancel() };
		this.renderer.renderPlaceholder(index, data.data);
		promise.then((entry) => this.renderer.renderElement(entry, index, data.data, details));
	}
	disposeTemplate(data) {
		if (data.disposable) {
			data.disposable.dispose();
			data.disposable = void 0;
		}
		if (data.data) {
			this.renderer.disposeTemplate(data.data);
			data.data = void 0;
		}
	}
};
var PagedAccessibilityProvider = class {
	constructor(modelProvider, accessibilityProvider) {
		this.modelProvider = modelProvider;
		this.accessibilityProvider = accessibilityProvider;
	}
	getWidgetAriaLabel() {
		return this.accessibilityProvider.getWidgetAriaLabel();
	}
	getAriaLabel(index) {
		const model = this.modelProvider();
		if (!model.isResolved(index)) return null;
		return this.accessibilityProvider.getAriaLabel(model.get(index));
	}
};
function fromPagedListOptions(modelProvider, options) {
	return {
		...options,
		accessibilityProvider: options.accessibilityProvider && new PagedAccessibilityProvider(modelProvider, options.accessibilityProvider)
	};
}
var PagedList = class {
	constructor(user, container, virtualDelegate, renderers, options = {}) {
		this.modelDisposables = new DisposableStore();
		const modelProvider = () => this.model;
		const pagedRenderers = renderers.map((r) => new PagedRenderer(r, modelProvider));
		this.list = new List(user, container, virtualDelegate, pagedRenderers, fromPagedListOptions(modelProvider, options));
	}
	updateOptions(options) {
		this.list.updateOptions(options);
	}
	getHTMLElement() {
		return this.list.getHTMLElement();
	}
	get onDidFocus() {
		return this.list.onDidFocus;
	}
	get widget() {
		return this.list;
	}
	get onDidDispose() {
		return this.list.onDidDispose;
	}
	get onMouseDblClick() {
		return Event.map(this.list.onMouseDblClick, ({ element, index, browserEvent }) => ({
			element: element === void 0 ? void 0 : this._model.get(element),
			index,
			browserEvent
		}));
	}
	get onPointer() {
		return Event.map(this.list.onPointer, ({ element, index, browserEvent }) => ({
			element: element === void 0 ? void 0 : this._model.get(element),
			index,
			browserEvent
		}));
	}
	get onDidChangeSelection() {
		return Event.map(this.list.onDidChangeSelection, ({ elements, indexes, browserEvent }) => ({
			elements: elements.map((e) => this._model.get(e)),
			indexes,
			browserEvent
		}));
	}
	get model() {
		return this._model;
	}
	set model(model) {
		this.modelDisposables.clear();
		this._model = model;
		this.list.splice(0, this.list.length, range(model.length));
		this.modelDisposables.add(model.onDidIncrementLength((newLength) => this.list.splice(this.list.length, 0, range(this.list.length, newLength))));
	}
	getFocus() {
		return this.list.getFocus();
	}
	getSelection() {
		return this.list.getSelection();
	}
	getSelectedElements() {
		return this.getSelection().map((i) => this.model.get(i));
	}
	style(styles) {
		this.list.style(styles);
	}
	dispose() {
		this.list.dispose();
		this.modelDisposables.dispose();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/sash/sash.js
var __decorate$32 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
* Allow the sashes to be visible at runtime.
* @remark Use for development purposes only.
*/
var DEBUG = false;
var OrthogonalEdge;
(function(OrthogonalEdge) {
	OrthogonalEdge["North"] = "north";
	OrthogonalEdge["South"] = "south";
	OrthogonalEdge["East"] = "east";
	OrthogonalEdge["West"] = "west";
})(OrthogonalEdge || (OrthogonalEdge = {}));
var globalSize = 4;
var onDidChangeGlobalSize = new Emitter$1();
var globalHoverDelay = 300;
var onDidChangeHoverDelay = new Emitter$1();
var MouseEventFactory = class {
	constructor(el) {
		this.el = el;
		this.disposables = new DisposableStore();
	}
	get onPointerMove() {
		return this.disposables.add(new DomEmitter(getWindow(this.el), "mousemove")).event;
	}
	get onPointerUp() {
		return this.disposables.add(new DomEmitter(getWindow(this.el), "mouseup")).event;
	}
	dispose() {
		this.disposables.dispose();
	}
};
__decorate$32([memoize], MouseEventFactory.prototype, "onPointerMove", null);
__decorate$32([memoize], MouseEventFactory.prototype, "onPointerUp", null);
var GestureEventFactory = class {
	get onPointerMove() {
		return this.disposables.add(new DomEmitter(this.el, EventType.Change)).event;
	}
	get onPointerUp() {
		return this.disposables.add(new DomEmitter(this.el, EventType.End)).event;
	}
	constructor(el) {
		this.el = el;
		this.disposables = new DisposableStore();
	}
	dispose() {
		this.disposables.dispose();
	}
};
__decorate$32([memoize], GestureEventFactory.prototype, "onPointerMove", null);
__decorate$32([memoize], GestureEventFactory.prototype, "onPointerUp", null);
var OrthogonalPointerEventFactory = class {
	get onPointerMove() {
		return this.factory.onPointerMove;
	}
	get onPointerUp() {
		return this.factory.onPointerUp;
	}
	constructor(factory) {
		this.factory = factory;
	}
	dispose() {}
};
__decorate$32([memoize], OrthogonalPointerEventFactory.prototype, "onPointerMove", null);
__decorate$32([memoize], OrthogonalPointerEventFactory.prototype, "onPointerUp", null);
var PointerEventsDisabledCssClass = "pointer-events-disabled";
/**
* The {@link Sash} is the UI component which allows the user to resize other
* components. It's usually an invisible horizontal or vertical line which, when
* hovered, becomes highlighted and can be dragged along the perpendicular dimension
* to its direction.
*
* Features:
* - Touch event handling
* - Corner sash support
* - Hover with different mouse cursor support
* - Configurable hover size
* - Linked sash support, for 2x2 corner sashes
*/
var Sash = class Sash extends Disposable {
	get state() {
		return this._state;
	}
	get orthogonalStartSash() {
		return this._orthogonalStartSash;
	}
	get orthogonalEndSash() {
		return this._orthogonalEndSash;
	}
	/**
	* The state of a sash defines whether it can be interacted with by the user
	* as well as what mouse cursor to use, when hovered.
	*/
	set state(state) {
		if (this._state === state) return;
		this.el.classList.toggle("disabled", state === 0);
		this.el.classList.toggle("minimum", state === 1);
		this.el.classList.toggle("maximum", state === 2);
		this._state = state;
		this.onDidEnablementChange.fire(state);
	}
	/**
	* An event which fires whenever the user starts dragging this sash.
	*/
	get onDidStart() {
		return this._onDidStart.event;
	}
	/**
	* An event which fires whenever the user moves the mouse while
	* dragging this sash.
	*/
	get onDidChange() {
		return this._onDidChange.event;
	}
	/**
	* An event which fires whenever the user double clicks this sash.
	*/
	get onDidReset() {
		return this._onDidReset.event;
	}
	/**
	* An event which fires whenever the user stops dragging this sash.
	*/
	get onDidEnd() {
		return this._onDidEnd.event;
	}
	/**
	* A reference to another sash, perpendicular to this one, which
	* aligns at the start of this one. A corner sash will be created
	* automatically at that location.
	*
	* The start of a horizontal sash is its left-most position.
	* The start of a vertical sash is its top-most position.
	*/
	set orthogonalStartSash(sash) {
		if (this._orthogonalStartSash === sash) return;
		this.orthogonalStartDragHandleDisposables.clear();
		this.orthogonalStartSashDisposables.clear();
		if (sash) {
			const onChange = (state) => {
				this.orthogonalStartDragHandleDisposables.clear();
				if (state !== 0) {
					this._orthogonalStartDragHandle = append$2(this.el, $$10(".orthogonal-drag-handle.start"));
					this.orthogonalStartDragHandleDisposables.add(toDisposable(() => this._orthogonalStartDragHandle.remove()));
					this.orthogonalStartDragHandleDisposables.add(addDisposableListener(this._orthogonalStartDragHandle, "mouseenter", () => Sash.onMouseEnter(sash)));
					this.orthogonalStartDragHandleDisposables.add(addDisposableListener(this._orthogonalStartDragHandle, "mouseleave", () => Sash.onMouseLeave(sash)));
				}
			};
			this.orthogonalStartSashDisposables.add(sash.onDidEnablementChange.event(onChange, this));
			onChange(sash.state);
		}
		this._orthogonalStartSash = sash;
	}
	/**
	* A reference to another sash, perpendicular to this one, which
	* aligns at the end of this one. A corner sash will be created
	* automatically at that location.
	*
	* The end of a horizontal sash is its right-most position.
	* The end of a vertical sash is its bottom-most position.
	*/
	set orthogonalEndSash(sash) {
		if (this._orthogonalEndSash === sash) return;
		this.orthogonalEndDragHandleDisposables.clear();
		this.orthogonalEndSashDisposables.clear();
		if (sash) {
			const onChange = (state) => {
				this.orthogonalEndDragHandleDisposables.clear();
				if (state !== 0) {
					this._orthogonalEndDragHandle = append$2(this.el, $$10(".orthogonal-drag-handle.end"));
					this.orthogonalEndDragHandleDisposables.add(toDisposable(() => this._orthogonalEndDragHandle.remove()));
					this.orthogonalEndDragHandleDisposables.add(addDisposableListener(this._orthogonalEndDragHandle, "mouseenter", () => Sash.onMouseEnter(sash)));
					this.orthogonalEndDragHandleDisposables.add(addDisposableListener(this._orthogonalEndDragHandle, "mouseleave", () => Sash.onMouseLeave(sash)));
				}
			};
			this.orthogonalEndSashDisposables.add(sash.onDidEnablementChange.event(onChange, this));
			onChange(sash.state);
		}
		this._orthogonalEndSash = sash;
	}
	constructor(container, layoutProvider, options) {
		super();
		this.hoverDelay = globalHoverDelay;
		this.hoverDelayer = this._register(new Delayer(this.hoverDelay));
		this._state = 3;
		this.onDidEnablementChange = this._register(new Emitter$1());
		this._onDidStart = this._register(new Emitter$1());
		this._onDidChange = this._register(new Emitter$1());
		this._onDidReset = this._register(new Emitter$1());
		this._onDidEnd = this._register(new Emitter$1());
		this.orthogonalStartSashDisposables = this._register(new DisposableStore());
		this.orthogonalStartDragHandleDisposables = this._register(new DisposableStore());
		this.orthogonalEndSashDisposables = this._register(new DisposableStore());
		this.orthogonalEndDragHandleDisposables = this._register(new DisposableStore());
		/**
		* A linked sash will be forwarded the same user interactions and events
		* so it moves exactly the same way as this sash.
		*
		* Useful in 2x2 grids. Not meant for widespread usage.
		*/
		this.linkedSash = void 0;
		this.el = append$2(container, $$10(".monaco-sash"));
		if (options.orthogonalEdge) this.el.classList.add(`orthogonal-edge-${options.orthogonalEdge}`);
		if (isMacintosh) this.el.classList.add("mac");
		this._register(addDisposableListener(this.el, "mousedown", (e) => this.onPointerStart(e, new MouseEventFactory(container))));
		this._register(addDisposableListener(this.el, "dblclick", (e) => this.onPointerDoublePress(e)));
		this._register(addDisposableListener(this.el, "mouseenter", () => Sash.onMouseEnter(this)));
		this._register(addDisposableListener(this.el, "mouseleave", () => Sash.onMouseLeave(this)));
		this._register(Gesture.addTarget(this.el));
		this._register(addDisposableListener(this.el, EventType.Start, (e) => this.onPointerStart(e, new GestureEventFactory(this.el))));
		let doubleTapTimeout = void 0;
		this._register(addDisposableListener(this.el, EventType.Tap, (event) => {
			if (doubleTapTimeout) {
				clearTimeout(doubleTapTimeout);
				doubleTapTimeout = void 0;
				this.onPointerDoublePress(event);
				return;
			}
			clearTimeout(doubleTapTimeout);
			doubleTapTimeout = setTimeout(() => doubleTapTimeout = void 0, 250);
		}));
		if (typeof options.size === "number") {
			this.size = options.size;
			if (options.orientation === 0) this.el.style.width = `${this.size}px`;
			else this.el.style.height = `${this.size}px`;
		} else {
			this.size = globalSize;
			this._register(onDidChangeGlobalSize.event((size) => {
				this.size = size;
				this.layout();
			}));
		}
		this._register(onDidChangeHoverDelay.event((delay) => this.hoverDelay = delay));
		this.layoutProvider = layoutProvider;
		this.orthogonalStartSash = options.orthogonalStartSash;
		this.orthogonalEndSash = options.orthogonalEndSash;
		this.orientation = options.orientation || 0;
		if (this.orientation === 1) {
			this.el.classList.add("horizontal");
			this.el.classList.remove("vertical");
		} else {
			this.el.classList.remove("horizontal");
			this.el.classList.add("vertical");
		}
		this.el.classList.toggle("debug", DEBUG);
		this.layout();
	}
	onPointerStart(event, pointerEventFactory) {
		EventHelper.stop(event);
		let isMultisashResize = false;
		if (!event.__orthogonalSashEvent) {
			const orthogonalSash = this.getOrthogonalSash(event);
			if (orthogonalSash) {
				isMultisashResize = true;
				event.__orthogonalSashEvent = true;
				orthogonalSash.onPointerStart(event, new OrthogonalPointerEventFactory(pointerEventFactory));
			}
		}
		if (this.linkedSash && !event.__linkedSashEvent) {
			event.__linkedSashEvent = true;
			this.linkedSash.onPointerStart(event, new OrthogonalPointerEventFactory(pointerEventFactory));
		}
		if (!this.state) return;
		const iframes = this.el.ownerDocument.getElementsByTagName("iframe");
		for (const iframe of iframes) iframe.classList.add(PointerEventsDisabledCssClass);
		const startX = event.pageX;
		const startY = event.pageY;
		const altKey = event.altKey;
		const startEvent = {
			startX,
			currentX: startX,
			startY,
			currentY: startY,
			altKey
		};
		this.el.classList.add("active");
		this._onDidStart.fire(startEvent);
		const style = createStyleSheet(this.el);
		const updateStyle = () => {
			let cursor = "";
			if (isMultisashResize) cursor = "all-scroll";
			else if (this.orientation === 1) {
				if (this.state === 1) cursor = "s-resize";
				else if (this.state === 2) cursor = "n-resize";
				else cursor = isMacintosh ? "row-resize" : "ns-resize";
			} else if (this.state === 1) cursor = "e-resize";
			else if (this.state === 2) cursor = "w-resize";
			else cursor = isMacintosh ? "col-resize" : "ew-resize";
			style.textContent = `* { cursor: ${cursor} !important; }`;
		};
		const disposables = new DisposableStore();
		updateStyle();
		if (!isMultisashResize) this.onDidEnablementChange.event(updateStyle, null, disposables);
		const onPointerMove = (e) => {
			EventHelper.stop(e, false);
			const event = {
				startX,
				currentX: e.pageX,
				startY,
				currentY: e.pageY,
				altKey
			};
			this._onDidChange.fire(event);
		};
		const onPointerUp = (e) => {
			EventHelper.stop(e, false);
			style.remove();
			this.el.classList.remove("active");
			this._onDidEnd.fire();
			disposables.dispose();
			for (const iframe of iframes) iframe.classList.remove(PointerEventsDisabledCssClass);
		};
		pointerEventFactory.onPointerMove(onPointerMove, null, disposables);
		pointerEventFactory.onPointerUp(onPointerUp, null, disposables);
		disposables.add(pointerEventFactory);
	}
	onPointerDoublePress(e) {
		const orthogonalSash = this.getOrthogonalSash(e);
		if (orthogonalSash) orthogonalSash._onDidReset.fire();
		if (this.linkedSash) this.linkedSash._onDidReset.fire();
		this._onDidReset.fire();
	}
	static onMouseEnter(sash, fromLinkedSash = false) {
		if (sash.el.classList.contains("active")) {
			sash.hoverDelayer.cancel();
			sash.el.classList.add("hover");
		} else sash.hoverDelayer.trigger(() => sash.el.classList.add("hover"), sash.hoverDelay).then(void 0, () => {});
		if (!fromLinkedSash && sash.linkedSash) Sash.onMouseEnter(sash.linkedSash, true);
	}
	static onMouseLeave(sash, fromLinkedSash = false) {
		sash.hoverDelayer.cancel();
		sash.el.classList.remove("hover");
		if (!fromLinkedSash && sash.linkedSash) Sash.onMouseLeave(sash.linkedSash, true);
	}
	/**
	* Forcefully stop any user interactions with this sash.
	* Useful when hiding a parent component, while the user is still
	* interacting with the sash.
	*/
	clearSashHoverState() {
		Sash.onMouseLeave(this);
	}
	/**
	* Layout the sash. The sash will size and position itself
	* based on its provided {@link ISashLayoutProvider layout provider}.
	*/
	layout() {
		if (this.orientation === 0) {
			const verticalProvider = this.layoutProvider;
			this.el.style.left = verticalProvider.getVerticalSashLeft(this) - this.size / 2 + "px";
			if (verticalProvider.getVerticalSashTop) this.el.style.top = verticalProvider.getVerticalSashTop(this) + "px";
			if (verticalProvider.getVerticalSashHeight) this.el.style.height = verticalProvider.getVerticalSashHeight(this) + "px";
		} else {
			const horizontalProvider = this.layoutProvider;
			this.el.style.top = horizontalProvider.getHorizontalSashTop(this) - this.size / 2 + "px";
			if (horizontalProvider.getHorizontalSashLeft) this.el.style.left = horizontalProvider.getHorizontalSashLeft(this) + "px";
			if (horizontalProvider.getHorizontalSashWidth) this.el.style.width = horizontalProvider.getHorizontalSashWidth(this) + "px";
		}
	}
	getOrthogonalSash(e) {
		const target = e.initialTarget ?? e.target;
		if (!target || !isHTMLElement(target)) return;
		if (target.classList.contains("orthogonal-drag-handle")) return target.classList.contains("start") ? this.orthogonalStartSash : this.orthogonalEndSash;
	}
	dispose() {
		super.dispose();
		this.el.remove();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/splitview/splitview.js
var defaultStyles = { separatorBorder: Color.transparent };
var ViewItem = class {
	set size(size) {
		this._size = size;
	}
	get size() {
		return this._size;
	}
	get visible() {
		return typeof this._cachedVisibleSize === "undefined";
	}
	setVisible(visible, size) {
		if (visible === this.visible) return;
		if (visible) {
			this.size = clamp(this._cachedVisibleSize, this.viewMinimumSize, this.viewMaximumSize);
			this._cachedVisibleSize = void 0;
		} else {
			this._cachedVisibleSize = typeof size === "number" ? size : this.size;
			this.size = 0;
		}
		this.container.classList.toggle("visible", visible);
		try {
			this.view.setVisible?.(visible);
		} catch (e) {
			console.error("Splitview: Failed to set visible view");
			console.error(e);
		}
	}
	get minimumSize() {
		return this.visible ? this.view.minimumSize : 0;
	}
	get viewMinimumSize() {
		return this.view.minimumSize;
	}
	get maximumSize() {
		return this.visible ? this.view.maximumSize : 0;
	}
	get viewMaximumSize() {
		return this.view.maximumSize;
	}
	get priority() {
		return this.view.priority;
	}
	get proportionalLayout() {
		return this.view.proportionalLayout ?? true;
	}
	get snap() {
		return !!this.view.snap;
	}
	set enabled(enabled) {
		this.container.style.pointerEvents = enabled ? "" : "none";
	}
	constructor(container, view, size, disposable) {
		this.container = container;
		this.view = view;
		this.disposable = disposable;
		this._cachedVisibleSize = void 0;
		if (typeof size === "number") {
			this._size = size;
			this._cachedVisibleSize = void 0;
			container.classList.add("visible");
		} else {
			this._size = 0;
			this._cachedVisibleSize = size.cachedVisibleSize;
		}
	}
	layout(offset, layoutContext) {
		this.layoutContainer(offset);
		try {
			this.view.layout(this.size, offset, layoutContext);
		} catch (e) {
			console.error("Splitview: Failed to layout view");
			console.error(e);
		}
	}
	dispose() {
		this.disposable.dispose();
	}
};
var VerticalViewItem = class extends ViewItem {
	layoutContainer(offset) {
		this.container.style.top = `${offset}px`;
		this.container.style.height = `${this.size}px`;
	}
};
var HorizontalViewItem = class extends ViewItem {
	layoutContainer(offset) {
		this.container.style.left = `${offset}px`;
		this.container.style.width = `${this.size}px`;
	}
};
var State;
(function(State) {
	State[State["Idle"] = 0] = "Idle";
	State[State["Busy"] = 1] = "Busy";
})(State || (State = {}));
var Sizing;
(function(Sizing) {
	/**
	* When adding or removing views, distribute the delta space among
	* all other views.
	*/
	Sizing.Distribute = { type: "distribute" };
	/**
	* When adding or removing views, split the delta space with another
	* specific view, indexed by the provided `index`.
	*/
	function Split(index) {
		return {
			type: "split",
			index
		};
	}
	Sizing.Split = Split;
	/**
	* When adding a view, use DistributeSizing when all pre-existing views are
	* distributed evenly, otherwise use SplitSizing.
	*/
	function Auto(index) {
		return {
			type: "auto",
			index
		};
	}
	Sizing.Auto = Auto;
	/**
	* When adding or removing views, assume the view is invisible.
	*/
	function Invisible(cachedVisibleSize) {
		return {
			type: "invisible",
			cachedVisibleSize
		};
	}
	Sizing.Invisible = Invisible;
})(Sizing || (Sizing = {}));
/**
* The {@link SplitView} is the UI component which implements a one dimensional
* flex-like layout algorithm for a collection of {@link IView} instances, which
* are essentially HTMLElement instances with the following size constraints:
*
* - {@link IView.minimumSize}
* - {@link IView.maximumSize}
* - {@link IView.priority}
* - {@link IView.snap}
*
* In case the SplitView doesn't have enough size to fit all views, it will overflow
* its content with a scrollbar.
*
* In between each pair of views there will be a {@link Sash} allowing the user
* to resize the views, making sure the constraints are respected.
*
* An optional {@link TLayoutContext layout context type} may be used in order to
* pass along layout contextual data from the {@link SplitView.layout} method down
* to each view's {@link IView.layout} calls.
*
* Features:
* - Flex-like layout algorithm
* - Snap support
* - Orthogonal sash support, for corner sashes
* - View hide/show support
* - View swap/move support
* - Alt key modifier behavior, macOS style
*/
var SplitView = class extends Disposable {
	get orthogonalStartSash() {
		return this._orthogonalStartSash;
	}
	get orthogonalEndSash() {
		return this._orthogonalEndSash;
	}
	get startSnappingEnabled() {
		return this._startSnappingEnabled;
	}
	get endSnappingEnabled() {
		return this._endSnappingEnabled;
	}
	/**
	* A reference to a sash, perpendicular to all sashes in this {@link SplitView},
	* located at the left- or top-most side of the SplitView.
	* Corner sashes will be created automatically at the intersections.
	*/
	set orthogonalStartSash(sash) {
		for (const sashItem of this.sashItems) sashItem.sash.orthogonalStartSash = sash;
		this._orthogonalStartSash = sash;
	}
	/**
	* A reference to a sash, perpendicular to all sashes in this {@link SplitView},
	* located at the right- or bottom-most side of the SplitView.
	* Corner sashes will be created automatically at the intersections.
	*/
	set orthogonalEndSash(sash) {
		for (const sashItem of this.sashItems) sashItem.sash.orthogonalEndSash = sash;
		this._orthogonalEndSash = sash;
	}
	/**
	* Enable/disable snapping at the beginning of this {@link SplitView}.
	*/
	set startSnappingEnabled(startSnappingEnabled) {
		if (this._startSnappingEnabled === startSnappingEnabled) return;
		this._startSnappingEnabled = startSnappingEnabled;
		this.updateSashEnablement();
	}
	/**
	* Enable/disable snapping at the end of this {@link SplitView}.
	*/
	set endSnappingEnabled(endSnappingEnabled) {
		if (this._endSnappingEnabled === endSnappingEnabled) return;
		this._endSnappingEnabled = endSnappingEnabled;
		this.updateSashEnablement();
	}
	/**
	* Create a new {@link SplitView} instance.
	*/
	constructor(container, options = {}) {
		super();
		this.size = 0;
		this._contentSize = 0;
		this.proportions = void 0;
		this.viewItems = [];
		this.sashItems = [];
		this.state = State.Idle;
		this._onDidSashChange = this._register(new Emitter$1());
		this._onDidSashReset = this._register(new Emitter$1());
		this._startSnappingEnabled = true;
		this._endSnappingEnabled = true;
		/**
		* Fires whenever the user resizes a {@link Sash sash}.
		*/
		this.onDidSashChange = this._onDidSashChange.event;
		/**
		* Fires whenever the user double clicks a {@link Sash sash}.
		*/
		this.onDidSashReset = this._onDidSashReset.event;
		this.orientation = options.orientation ?? 0;
		this.inverseAltBehavior = options.inverseAltBehavior ?? false;
		this.proportionalLayout = options.proportionalLayout ?? true;
		this.getSashOrthogonalSize = options.getSashOrthogonalSize;
		this.el = document.createElement("div");
		this.el.classList.add("monaco-split-view2");
		this.el.classList.add(this.orientation === 0 ? "vertical" : "horizontal");
		container.appendChild(this.el);
		this.sashContainer = append$2(this.el, $$10(".sash-container"));
		this.viewContainer = $$10(".split-view-container");
		this.scrollable = this._register(new Scrollable({
			forceIntegerValues: true,
			smoothScrollDuration: 125,
			scheduleAtNextAnimationFrame: (callback) => scheduleAtNextAnimationFrame(getWindow(this.el), callback)
		}));
		this.scrollableElement = this._register(new SmoothScrollableElement(this.viewContainer, {
			vertical: this.orientation === 0 ? options.scrollbarVisibility ?? 1 : 2,
			horizontal: this.orientation === 1 ? options.scrollbarVisibility ?? 1 : 2
		}, this.scrollable));
		const onDidScrollViewContainer = this._register(new DomEmitter(this.viewContainer, "scroll")).event;
		this._register(onDidScrollViewContainer((_) => {
			const position = this.scrollableElement.getScrollPosition();
			const scrollLeft = Math.abs(this.viewContainer.scrollLeft - position.scrollLeft) <= 1 ? void 0 : this.viewContainer.scrollLeft;
			const scrollTop = Math.abs(this.viewContainer.scrollTop - position.scrollTop) <= 1 ? void 0 : this.viewContainer.scrollTop;
			if (scrollLeft !== void 0 || scrollTop !== void 0) this.scrollableElement.setScrollPosition({
				scrollLeft,
				scrollTop
			});
		}));
		this.onDidScroll = this.scrollableElement.onScroll;
		this._register(this.onDidScroll((e) => {
			if (e.scrollTopChanged) this.viewContainer.scrollTop = e.scrollTop;
			if (e.scrollLeftChanged) this.viewContainer.scrollLeft = e.scrollLeft;
		}));
		append$2(this.el, this.scrollableElement.getDomNode());
		this.style(options.styles || defaultStyles);
		if (options.descriptor) {
			this.size = options.descriptor.size;
			options.descriptor.views.forEach((viewDescriptor, index) => {
				const sizing = isUndefined(viewDescriptor.visible) || viewDescriptor.visible ? viewDescriptor.size : {
					type: "invisible",
					cachedVisibleSize: viewDescriptor.size
				};
				const view = viewDescriptor.view;
				this.doAddView(view, sizing, index, true);
			});
			this._contentSize = this.viewItems.reduce((r, i) => r + i.size, 0);
			this.saveProportions();
		}
	}
	style(styles) {
		if (styles.separatorBorder.isTransparent()) {
			this.el.classList.remove("separator-border");
			this.el.style.removeProperty("--separator-border");
		} else {
			this.el.classList.add("separator-border");
			this.el.style.setProperty("--separator-border", styles.separatorBorder.toString());
		}
	}
	/**
	* Add a {@link IView view} to this {@link SplitView}.
	*
	* @param view The view to add.
	* @param size Either a fixed size, or a dynamic {@link Sizing} strategy.
	* @param index The index to insert the view on.
	* @param skipLayout Whether layout should be skipped.
	*/
	addView(view, size, index = this.viewItems.length, skipLayout) {
		this.doAddView(view, size, index, skipLayout);
	}
	/**
	* Layout the {@link SplitView}.
	*
	* @param size The entire size of the {@link SplitView}.
	* @param layoutContext An optional layout context to pass along to {@link IView views}.
	*/
	layout(size, layoutContext) {
		const previousSize = Math.max(this.size, this._contentSize);
		this.size = size;
		this.layoutContext = layoutContext;
		if (!this.proportions) {
			const indexes = range(this.viewItems.length);
			const lowPriorityIndexes = indexes.filter((i) => this.viewItems[i].priority === 1);
			const highPriorityIndexes = indexes.filter((i) => this.viewItems[i].priority === 2);
			this.resize(this.viewItems.length - 1, size - previousSize, void 0, lowPriorityIndexes, highPriorityIndexes);
		} else {
			let total = 0;
			for (let i = 0; i < this.viewItems.length; i++) {
				const item = this.viewItems[i];
				const proportion = this.proportions[i];
				if (typeof proportion === "number") total += proportion;
				else size -= item.size;
			}
			for (let i = 0; i < this.viewItems.length; i++) {
				const item = this.viewItems[i];
				const proportion = this.proportions[i];
				if (typeof proportion === "number" && total > 0) item.size = clamp(Math.round(proportion * size / total), item.minimumSize, item.maximumSize);
			}
		}
		this.distributeEmptySpace();
		this.layoutViews();
	}
	saveProportions() {
		if (this.proportionalLayout && this._contentSize > 0) this.proportions = this.viewItems.map((v) => v.proportionalLayout && v.visible ? v.size / this._contentSize : void 0);
	}
	onSashStart({ sash, start, alt }) {
		for (const item of this.viewItems) item.enabled = false;
		const index = this.sashItems.findIndex((item) => item.sash === sash);
		const disposable = combinedDisposable(addDisposableListener(this.el.ownerDocument.body, "keydown", (e) => resetSashDragState(this.sashDragState.current, e.altKey)), addDisposableListener(this.el.ownerDocument.body, "keyup", () => resetSashDragState(this.sashDragState.current, false)));
		const resetSashDragState = (start, alt) => {
			const sizes = this.viewItems.map((i) => i.size);
			let minDelta = Number.NEGATIVE_INFINITY;
			let maxDelta = Number.POSITIVE_INFINITY;
			if (this.inverseAltBehavior) alt = !alt;
			if (alt) {
				if (index === this.sashItems.length - 1) {
					const viewItem = this.viewItems[index];
					minDelta = (viewItem.minimumSize - viewItem.size) / 2;
					maxDelta = (viewItem.maximumSize - viewItem.size) / 2;
				} else {
					const viewItem = this.viewItems[index + 1];
					minDelta = (viewItem.size - viewItem.maximumSize) / 2;
					maxDelta = (viewItem.size - viewItem.minimumSize) / 2;
				}
			}
			let snapBefore;
			let snapAfter;
			if (!alt) {
				const upIndexes = range(index, -1);
				const downIndexes = range(index + 1, this.viewItems.length);
				const minDeltaUp = upIndexes.reduce((r, i) => r + (this.viewItems[i].minimumSize - sizes[i]), 0);
				const maxDeltaUp = upIndexes.reduce((r, i) => r + (this.viewItems[i].viewMaximumSize - sizes[i]), 0);
				const maxDeltaDown = downIndexes.length === 0 ? Number.POSITIVE_INFINITY : downIndexes.reduce((r, i) => r + (sizes[i] - this.viewItems[i].minimumSize), 0);
				const minDeltaDown = downIndexes.length === 0 ? Number.NEGATIVE_INFINITY : downIndexes.reduce((r, i) => r + (sizes[i] - this.viewItems[i].viewMaximumSize), 0);
				const minDelta = Math.max(minDeltaUp, minDeltaDown);
				const maxDelta = Math.min(maxDeltaDown, maxDeltaUp);
				const snapBeforeIndex = this.findFirstSnapIndex(upIndexes);
				const snapAfterIndex = this.findFirstSnapIndex(downIndexes);
				if (typeof snapBeforeIndex === "number") {
					const viewItem = this.viewItems[snapBeforeIndex];
					const halfSize = Math.floor(viewItem.viewMinimumSize / 2);
					snapBefore = {
						index: snapBeforeIndex,
						limitDelta: viewItem.visible ? minDelta - halfSize : minDelta + halfSize,
						size: viewItem.size
					};
				}
				if (typeof snapAfterIndex === "number") {
					const viewItem = this.viewItems[snapAfterIndex];
					const halfSize = Math.floor(viewItem.viewMinimumSize / 2);
					snapAfter = {
						index: snapAfterIndex,
						limitDelta: viewItem.visible ? maxDelta + halfSize : maxDelta - halfSize,
						size: viewItem.size
					};
				}
			}
			this.sashDragState = {
				start,
				current: start,
				index,
				sizes,
				minDelta,
				maxDelta,
				alt,
				snapBefore,
				snapAfter,
				disposable
			};
		};
		resetSashDragState(start, alt);
	}
	onSashChange({ current }) {
		const { index, start, sizes, alt, minDelta, maxDelta, snapBefore, snapAfter } = this.sashDragState;
		this.sashDragState.current = current;
		const delta = current - start;
		const newDelta = this.resize(index, delta, sizes, void 0, void 0, minDelta, maxDelta, snapBefore, snapAfter);
		if (alt) {
			const isLastSash = index === this.sashItems.length - 1;
			const newSizes = this.viewItems.map((i) => i.size);
			const viewItemIndex = isLastSash ? index : index + 1;
			const viewItem = this.viewItems[viewItemIndex];
			const newMinDelta = viewItem.size - viewItem.maximumSize;
			const newMaxDelta = viewItem.size - viewItem.minimumSize;
			const resizeIndex = isLastSash ? index - 1 : index + 1;
			this.resize(resizeIndex, -newDelta, newSizes, void 0, void 0, newMinDelta, newMaxDelta);
		}
		this.distributeEmptySpace();
		this.layoutViews();
	}
	onSashEnd(index) {
		this._onDidSashChange.fire(index);
		this.sashDragState.disposable.dispose();
		this.saveProportions();
		for (const item of this.viewItems) item.enabled = true;
	}
	onViewChange(item, size) {
		const index = this.viewItems.indexOf(item);
		if (index < 0 || index >= this.viewItems.length) return;
		size = typeof size === "number" ? size : item.size;
		size = clamp(size, item.minimumSize, item.maximumSize);
		if (this.inverseAltBehavior && index > 0) {
			this.resize(index - 1, Math.floor((item.size - size) / 2));
			this.distributeEmptySpace();
			this.layoutViews();
		} else {
			item.size = size;
			const indexes = range(this.viewItems.length).filter((i) => i !== index);
			const lowPriorityIndexes = [...indexes.filter((i) => this.viewItems[i].priority === 1), index];
			const highPriorityIndexes = indexes.filter((i) => this.viewItems[i].priority === 2);
			this.relayout(lowPriorityIndexes, highPriorityIndexes);
		}
	}
	/**
	* Resize a {@link IView view} within the {@link SplitView}.
	*
	* @param index The {@link IView view} index.
	* @param size The {@link IView view} size.
	*/
	resizeView(index, size) {
		if (index < 0 || index >= this.viewItems.length) return;
		if (this.state !== State.Idle) throw new Error("Cant modify splitview");
		this.state = State.Busy;
		try {
			const indexes = range(this.viewItems.length).filter((i) => i !== index);
			const lowPriorityIndexes = [...indexes.filter((i) => this.viewItems[i].priority === 1), index];
			const highPriorityIndexes = indexes.filter((i) => this.viewItems[i].priority === 2);
			const item = this.viewItems[index];
			size = Math.round(size);
			size = clamp(size, item.minimumSize, Math.min(item.maximumSize, this.size));
			item.size = size;
			this.relayout(lowPriorityIndexes, highPriorityIndexes);
		} finally {
			this.state = State.Idle;
		}
	}
	/**
	* Distribute the entire {@link SplitView} size among all {@link IView views}.
	*/
	distributeViewSizes() {
		const flexibleViewItems = [];
		let flexibleSize = 0;
		for (const item of this.viewItems) if (item.maximumSize - item.minimumSize > 0) {
			flexibleViewItems.push(item);
			flexibleSize += item.size;
		}
		const size = Math.floor(flexibleSize / flexibleViewItems.length);
		for (const item of flexibleViewItems) item.size = clamp(size, item.minimumSize, item.maximumSize);
		const indexes = range(this.viewItems.length);
		const lowPriorityIndexes = indexes.filter((i) => this.viewItems[i].priority === 1);
		const highPriorityIndexes = indexes.filter((i) => this.viewItems[i].priority === 2);
		this.relayout(lowPriorityIndexes, highPriorityIndexes);
	}
	/**
	* Returns the size of a {@link IView view}.
	*/
	getViewSize(index) {
		if (index < 0 || index >= this.viewItems.length) return -1;
		return this.viewItems[index].size;
	}
	doAddView(view, size, index = this.viewItems.length, skipLayout) {
		if (this.state !== State.Idle) throw new Error("Cant modify splitview");
		this.state = State.Busy;
		try {
			const container = $$10(".split-view-view");
			if (index === this.viewItems.length) this.viewContainer.appendChild(container);
			else this.viewContainer.insertBefore(container, this.viewContainer.children.item(index));
			const onChangeDisposable = view.onDidChange((size) => this.onViewChange(item, size));
			const containerDisposable = toDisposable(() => container.remove());
			const disposable = combinedDisposable(onChangeDisposable, containerDisposable);
			let viewSize;
			if (typeof size === "number") viewSize = size;
			else {
				if (size.type === "auto") {
					if (this.areViewsDistributed()) size = { type: "distribute" };
					else size = {
						type: "split",
						index: size.index
					};
				}
				if (size.type === "split") viewSize = this.getViewSize(size.index) / 2;
				else if (size.type === "invisible") viewSize = { cachedVisibleSize: size.cachedVisibleSize };
				else viewSize = view.minimumSize;
			}
			const item = this.orientation === 0 ? new VerticalViewItem(container, view, viewSize, disposable) : new HorizontalViewItem(container, view, viewSize, disposable);
			this.viewItems.splice(index, 0, item);
			if (this.viewItems.length > 1) {
				const opts = {
					orthogonalStartSash: this.orthogonalStartSash,
					orthogonalEndSash: this.orthogonalEndSash
				};
				const sash = this.orientation === 0 ? new Sash(this.sashContainer, {
					getHorizontalSashTop: (s) => this.getSashPosition(s),
					getHorizontalSashWidth: this.getSashOrthogonalSize
				}, {
					...opts,
					orientation: 1
				}) : new Sash(this.sashContainer, {
					getVerticalSashLeft: (s) => this.getSashPosition(s),
					getVerticalSashHeight: this.getSashOrthogonalSize
				}, {
					...opts,
					orientation: 0
				});
				const sashEventMapper = this.orientation === 0 ? (e) => ({
					sash,
					start: e.startY,
					current: e.currentY,
					alt: e.altKey
				}) : (e) => ({
					sash,
					start: e.startX,
					current: e.currentX,
					alt: e.altKey
				});
				const onStartDisposable = Event.map(sash.onDidStart, sashEventMapper)(this.onSashStart, this);
				const onChangeDisposable = Event.map(sash.onDidChange, sashEventMapper)(this.onSashChange, this);
				const onEndDisposable = Event.map(sash.onDidEnd, () => this.sashItems.findIndex((item) => item.sash === sash))(this.onSashEnd, this);
				const onDidResetDisposable = sash.onDidReset(() => {
					const index = this.sashItems.findIndex((item) => item.sash === sash);
					const upIndexes = range(index, -1);
					const downIndexes = range(index + 1, this.viewItems.length);
					const snapBeforeIndex = this.findFirstSnapIndex(upIndexes);
					const snapAfterIndex = this.findFirstSnapIndex(downIndexes);
					if (typeof snapBeforeIndex === "number" && !this.viewItems[snapBeforeIndex].visible) return;
					if (typeof snapAfterIndex === "number" && !this.viewItems[snapAfterIndex].visible) return;
					this._onDidSashReset.fire(index);
				});
				const sashItem = {
					sash,
					disposable: combinedDisposable(onStartDisposable, onChangeDisposable, onEndDisposable, onDidResetDisposable, sash)
				};
				this.sashItems.splice(index - 1, 0, sashItem);
			}
			container.appendChild(view.element);
			let highPriorityIndexes;
			if (typeof size !== "number" && size.type === "split") highPriorityIndexes = [size.index];
			if (!skipLayout) this.relayout([index], highPriorityIndexes);
			if (!skipLayout && typeof size !== "number" && size.type === "distribute") this.distributeViewSizes();
		} finally {
			this.state = State.Idle;
		}
	}
	relayout(lowPriorityIndexes, highPriorityIndexes) {
		const contentSize = this.viewItems.reduce((r, i) => r + i.size, 0);
		this.resize(this.viewItems.length - 1, this.size - contentSize, void 0, lowPriorityIndexes, highPriorityIndexes);
		this.distributeEmptySpace();
		this.layoutViews();
		this.saveProportions();
	}
	resize(index, delta, sizes = this.viewItems.map((i) => i.size), lowPriorityIndexes, highPriorityIndexes, overloadMinDelta = Number.NEGATIVE_INFINITY, overloadMaxDelta = Number.POSITIVE_INFINITY, snapBefore, snapAfter) {
		if (index < 0 || index >= this.viewItems.length) return 0;
		const upIndexes = range(index, -1);
		const downIndexes = range(index + 1, this.viewItems.length);
		if (highPriorityIndexes) for (const index of highPriorityIndexes) {
			pushToStart(upIndexes, index);
			pushToStart(downIndexes, index);
		}
		if (lowPriorityIndexes) for (const index of lowPriorityIndexes) {
			pushToEnd(upIndexes, index);
			pushToEnd(downIndexes, index);
		}
		const upItems = upIndexes.map((i) => this.viewItems[i]);
		const upSizes = upIndexes.map((i) => sizes[i]);
		const downItems = downIndexes.map((i) => this.viewItems[i]);
		const downSizes = downIndexes.map((i) => sizes[i]);
		const minDeltaUp = upIndexes.reduce((r, i) => r + (this.viewItems[i].minimumSize - sizes[i]), 0);
		const maxDeltaUp = upIndexes.reduce((r, i) => r + (this.viewItems[i].maximumSize - sizes[i]), 0);
		const maxDeltaDown = downIndexes.length === 0 ? Number.POSITIVE_INFINITY : downIndexes.reduce((r, i) => r + (sizes[i] - this.viewItems[i].minimumSize), 0);
		const minDeltaDown = downIndexes.length === 0 ? Number.NEGATIVE_INFINITY : downIndexes.reduce((r, i) => r + (sizes[i] - this.viewItems[i].maximumSize), 0);
		const minDelta = Math.max(minDeltaUp, minDeltaDown, overloadMinDelta);
		const maxDelta = Math.min(maxDeltaDown, maxDeltaUp, overloadMaxDelta);
		let snapped = false;
		if (snapBefore) {
			const snapView = this.viewItems[snapBefore.index];
			const visible = delta >= snapBefore.limitDelta;
			snapped = visible !== snapView.visible;
			snapView.setVisible(visible, snapBefore.size);
		}
		if (!snapped && snapAfter) {
			const snapView = this.viewItems[snapAfter.index];
			const visible = delta < snapAfter.limitDelta;
			snapped = visible !== snapView.visible;
			snapView.setVisible(visible, snapAfter.size);
		}
		if (snapped) return this.resize(index, delta, sizes, lowPriorityIndexes, highPriorityIndexes, overloadMinDelta, overloadMaxDelta);
		delta = clamp(delta, minDelta, maxDelta);
		for (let i = 0, deltaUp = delta; i < upItems.length; i++) {
			const item = upItems[i];
			const size = clamp(upSizes[i] + deltaUp, item.minimumSize, item.maximumSize);
			const viewDelta = size - upSizes[i];
			deltaUp -= viewDelta;
			item.size = size;
		}
		for (let i = 0, deltaDown = delta; i < downItems.length; i++) {
			const item = downItems[i];
			const size = clamp(downSizes[i] - deltaDown, item.minimumSize, item.maximumSize);
			const viewDelta = size - downSizes[i];
			deltaDown += viewDelta;
			item.size = size;
		}
		return delta;
	}
	distributeEmptySpace(lowPriorityIndex) {
		const contentSize = this.viewItems.reduce((r, i) => r + i.size, 0);
		let emptyDelta = this.size - contentSize;
		const indexes = range(this.viewItems.length - 1, -1);
		const lowPriorityIndexes = indexes.filter((i) => this.viewItems[i].priority === 1);
		const highPriorityIndexes = indexes.filter((i) => this.viewItems[i].priority === 2);
		for (const index of highPriorityIndexes) pushToStart(indexes, index);
		for (const index of lowPriorityIndexes) pushToEnd(indexes, index);
		if (typeof lowPriorityIndex === "number") pushToEnd(indexes, lowPriorityIndex);
		for (let i = 0; emptyDelta !== 0 && i < indexes.length; i++) {
			const item = this.viewItems[indexes[i]];
			const size = clamp(item.size + emptyDelta, item.minimumSize, item.maximumSize);
			const viewDelta = size - item.size;
			emptyDelta -= viewDelta;
			item.size = size;
		}
	}
	layoutViews() {
		this._contentSize = this.viewItems.reduce((r, i) => r + i.size, 0);
		let offset = 0;
		for (const viewItem of this.viewItems) {
			viewItem.layout(offset, this.layoutContext);
			offset += viewItem.size;
		}
		this.sashItems.forEach((item) => item.sash.layout());
		this.updateSashEnablement();
		this.updateScrollableElement();
	}
	updateScrollableElement() {
		if (this.orientation === 0) this.scrollableElement.setScrollDimensions({
			height: this.size,
			scrollHeight: this._contentSize
		});
		else this.scrollableElement.setScrollDimensions({
			width: this.size,
			scrollWidth: this._contentSize
		});
	}
	updateSashEnablement() {
		let previous = false;
		const collapsesDown = this.viewItems.map((i) => previous = i.size - i.minimumSize > 0 || previous);
		previous = false;
		const expandsDown = this.viewItems.map((i) => previous = i.maximumSize - i.size > 0 || previous);
		const reverseViews = [...this.viewItems].reverse();
		previous = false;
		const collapsesUp = reverseViews.map((i) => previous = i.size - i.minimumSize > 0 || previous).reverse();
		previous = false;
		const expandsUp = reverseViews.map((i) => previous = i.maximumSize - i.size > 0 || previous).reverse();
		let position = 0;
		for (let index = 0; index < this.sashItems.length; index++) {
			const { sash } = this.sashItems[index];
			const viewItem = this.viewItems[index];
			position += viewItem.size;
			const min = !(collapsesDown[index] && expandsUp[index + 1]);
			const max = !(expandsDown[index] && collapsesUp[index + 1]);
			if (min && max) {
				const upIndexes = range(index, -1);
				const downIndexes = range(index + 1, this.viewItems.length);
				const snapBeforeIndex = this.findFirstSnapIndex(upIndexes);
				const snapAfterIndex = this.findFirstSnapIndex(downIndexes);
				const snappedBefore = typeof snapBeforeIndex === "number" && !this.viewItems[snapBeforeIndex].visible;
				const snappedAfter = typeof snapAfterIndex === "number" && !this.viewItems[snapAfterIndex].visible;
				if (snappedBefore && collapsesUp[index] && (position > 0 || this.startSnappingEnabled)) sash.state = 1;
				else if (snappedAfter && collapsesDown[index] && (position < this._contentSize || this.endSnappingEnabled)) sash.state = 2;
				else sash.state = 0;
			} else if (min && !max) sash.state = 1;
			else if (!min && max) sash.state = 2;
			else sash.state = 3;
		}
	}
	getSashPosition(sash) {
		let position = 0;
		for (let i = 0; i < this.sashItems.length; i++) {
			position += this.viewItems[i].size;
			if (this.sashItems[i].sash === sash) return position;
		}
		return 0;
	}
	findFirstSnapIndex(indexes) {
		for (const index of indexes) {
			const viewItem = this.viewItems[index];
			if (!viewItem.visible) continue;
			if (viewItem.snap) return index;
		}
		for (const index of indexes) {
			const viewItem = this.viewItems[index];
			if (viewItem.visible && viewItem.maximumSize - viewItem.minimumSize > 0) return;
			if (!viewItem.visible && viewItem.snap) return index;
		}
	}
	areViewsDistributed() {
		let min = void 0, max = void 0;
		for (const view of this.viewItems) {
			min = min === void 0 ? view.size : Math.min(min, view.size);
			max = max === void 0 ? view.size : Math.max(max, view.size);
			if (max - min > 2) return false;
		}
		return true;
	}
	dispose() {
		this.sashDragState?.disposable.dispose();
		dispose(this.viewItems);
		this.viewItems = [];
		this.sashItems.forEach((i) => i.disposable.dispose());
		this.sashItems = [];
		super.dispose();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/table/tableWidget.js
var TableListRenderer = class TableListRenderer {
	static {
		this.TemplateId = "row";
	}
	constructor(columns, renderers, getColumnSize) {
		this.columns = columns;
		this.getColumnSize = getColumnSize;
		this.templateId = TableListRenderer.TemplateId;
		this.renderedTemplates = /* @__PURE__ */ new Set();
		const rendererMap = new Map(renderers.map((r) => [r.templateId, r]));
		this.renderers = [];
		for (const column of columns) {
			const renderer = rendererMap.get(column.templateId);
			if (!renderer) throw new Error(`Table cell renderer for template id ${column.templateId} not found.`);
			this.renderers.push(renderer);
		}
	}
	renderTemplate(container) {
		const rowContainer = append$2(container, $$10(".monaco-table-tr"));
		const cellContainers = [];
		const cellTemplateData = [];
		for (let i = 0; i < this.columns.length; i++) {
			const renderer = this.renderers[i];
			const cellContainer = append$2(rowContainer, $$10(".monaco-table-td", { "data-col-index": i }));
			cellContainer.style.width = `${this.getColumnSize(i)}px`;
			cellContainers.push(cellContainer);
			cellTemplateData.push(renderer.renderTemplate(cellContainer));
		}
		const result = {
			container,
			cellContainers,
			cellTemplateData
		};
		this.renderedTemplates.add(result);
		return result;
	}
	renderElement(element, index, templateData, renderDetails) {
		for (let i = 0; i < this.columns.length; i++) {
			const cell = this.columns[i].project(element);
			this.renderers[i].renderElement(cell, index, templateData.cellTemplateData[i], renderDetails);
		}
	}
	disposeElement(element, index, templateData, renderDetails) {
		for (let i = 0; i < this.columns.length; i++) {
			const renderer = this.renderers[i];
			if (renderer.disposeElement) {
				const cell = this.columns[i].project(element);
				renderer.disposeElement(cell, index, templateData.cellTemplateData[i], renderDetails);
			}
		}
	}
	disposeTemplate(templateData) {
		for (let i = 0; i < this.columns.length; i++) this.renderers[i].disposeTemplate(templateData.cellTemplateData[i]);
		clearNode(templateData.container);
		this.renderedTemplates.delete(templateData);
	}
	layoutColumn(index, size) {
		for (const { cellContainers } of this.renderedTemplates) cellContainers[index].style.width = `${size}px`;
	}
};
function asListVirtualDelegate(delegate) {
	return {
		getHeight(row) {
			return delegate.getHeight(row);
		},
		getTemplateId() {
			return TableListRenderer.TemplateId;
		}
	};
}
var ColumnHeader = class extends Disposable {
	get minimumSize() {
		return this.column.minimumWidth ?? 120;
	}
	get maximumSize() {
		return this.column.maximumWidth ?? Number.POSITIVE_INFINITY;
	}
	get onDidChange() {
		return this.column.onDidChangeWidthConstraints ?? Event.None;
	}
	constructor(column, index) {
		super();
		this.column = column;
		this.index = index;
		this._onDidLayout = this._register(new Emitter$1());
		this.onDidLayout = this._onDidLayout.event;
		this.element = $$10(".monaco-table-th", { "data-col-index": index }, column.label);
		if (column.tooltip) this._register(getBaseLayerHoverDelegate().setupManagedHover(getDefaultHoverDelegate("mouse"), this.element, column.tooltip));
	}
	layout(size) {
		this._onDidLayout.fire([this.index, size]);
	}
};
var Table = class Table {
	static {
		this.InstanceCount = 0;
	}
	get onDidChangeFocus() {
		return this.list.onDidChangeFocus;
	}
	get onDidChangeSelection() {
		return this.list.onDidChangeSelection;
	}
	get onDidScroll() {
		return this.list.onDidScroll;
	}
	get onMouseDblClick() {
		return this.list.onMouseDblClick;
	}
	get onPointer() {
		return this.list.onPointer;
	}
	get onDidFocus() {
		return this.list.onDidFocus;
	}
	get scrollTop() {
		return this.list.scrollTop;
	}
	set scrollTop(scrollTop) {
		this.list.scrollTop = scrollTop;
	}
	get scrollHeight() {
		return this.list.scrollHeight;
	}
	get renderHeight() {
		return this.list.renderHeight;
	}
	get onDidDispose() {
		return this.list.onDidDispose;
	}
	constructor(user, container, virtualDelegate, columns, renderers, _options) {
		this.virtualDelegate = virtualDelegate;
		this.columns = columns;
		this.domId = `table_id_${++Table.InstanceCount}`;
		this.disposables = new DisposableStore();
		this.cachedWidth = 0;
		this.cachedHeight = 0;
		this.domNode = append$2(container, $$10(`.monaco-table.${this.domId}`));
		const headers = columns.map((c, i) => this.disposables.add(new ColumnHeader(c, i)));
		const descriptor = {
			size: headers.reduce((a, b) => a + b.column.weight, 0),
			views: headers.map((view) => ({
				size: view.column.weight,
				view
			}))
		};
		this.splitview = this.disposables.add(new SplitView(this.domNode, {
			orientation: 1,
			scrollbarVisibility: 2,
			getSashOrthogonalSize: () => this.cachedHeight,
			descriptor
		}));
		this.splitview.el.style.height = `${virtualDelegate.headerRowHeight}px`;
		this.splitview.el.style.lineHeight = `${virtualDelegate.headerRowHeight}px`;
		const renderer = new TableListRenderer(columns, renderers, (i) => this.splitview.getViewSize(i));
		this.list = this.disposables.add(new List(user, this.domNode, asListVirtualDelegate(virtualDelegate), [renderer], _options));
		Event.any(...headers.map((h) => h.onDidLayout))(([index, size]) => renderer.layoutColumn(index, size), null, this.disposables);
		this.splitview.onDidSashReset((index) => {
			const totalWeight = columns.reduce((r, c) => r + c.weight, 0);
			const size = columns[index].weight / totalWeight * this.cachedWidth;
			this.splitview.resizeView(index, size);
		}, null, this.disposables);
		this.styleElement = createStyleSheet(this.domNode);
		this.style(unthemedListStyles);
	}
	updateOptions(options) {
		this.list.updateOptions(options);
	}
	splice(start, deleteCount, elements = []) {
		this.list.splice(start, deleteCount, elements);
	}
	getHTMLElement() {
		return this.domNode;
	}
	style(styles) {
		const content = [];
		content.push(`.monaco-table.${this.domId} > .monaco-split-view2 .monaco-sash.vertical::before {
			top: ${this.virtualDelegate.headerRowHeight + 1}px;
			height: calc(100% - ${this.virtualDelegate.headerRowHeight}px);
		}`);
		this.styleElement.textContent = content.join("\n");
		this.list.style(styles);
	}
	getSelectedElements() {
		return this.list.getSelectedElements();
	}
	getSelection() {
		return this.list.getSelection();
	}
	getFocus() {
		return this.list.getFocus();
	}
	dispose() {
		this.disposables.dispose();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/toggle/toggle.js
var unthemedToggleStyles = {
	inputActiveOptionBorder: "#007ACC00",
	inputActiveOptionForeground: "#FFFFFF",
	inputActiveOptionBackground: "#0E639C50"
};
var ToggleActionViewItem = class extends BaseActionViewItem {
	constructor(context, action, options) {
		super(context, action, options);
		const title = this.options.keybinding ? `${this._action.label} (${this.options.keybinding})` : this._action.label;
		this.toggle = this._register(new Toggle({
			actionClassName: this._action.class,
			isChecked: !!this._action.checked,
			title,
			notFocusable: true,
			inputActiveOptionBackground: options.toggleStyles?.inputActiveOptionBackground,
			inputActiveOptionBorder: options.toggleStyles?.inputActiveOptionBorder,
			inputActiveOptionForeground: options.toggleStyles?.inputActiveOptionForeground
		}));
		this._register(this.toggle.onChange(() => {
			this._action.checked = !!this.toggle && this.toggle.checked;
		}));
	}
	render(container) {
		this.element = container;
		this.element.appendChild(this.toggle.domNode);
		this.updateChecked();
		this.updateEnabled();
	}
	updateEnabled() {
		if (this.toggle) {
			if (this.isEnabled()) {
				this.toggle.enable();
				this.element?.classList.remove("disabled");
			} else {
				this.toggle.disable();
				this.element?.classList.add("disabled");
			}
		}
	}
	updateChecked() {
		this.toggle.checked = !!this._action.checked;
	}
	updateLabel() {
		const title = this.options.keybinding ? `${this._action.label} (${this.options.keybinding})` : this._action.label;
		this.toggle.setTitle(title);
	}
	focus() {
		this.toggle.domNode.tabIndex = 0;
		this.toggle.focus();
	}
	blur() {
		this.toggle.domNode.tabIndex = -1;
		this.toggle.domNode.blur();
	}
	setFocusable(focusable) {
		this.toggle.domNode.tabIndex = focusable ? 0 : -1;
	}
};
var Toggle = class extends Widget$1 {
	get onChange() {
		return this._onChange.event;
	}
	get onKeyDown() {
		return this._onKeyDown.event;
	}
	constructor(opts) {
		super();
		this._onChange = this._register(new Emitter$1());
		this._onKeyDown = this._register(new Emitter$1());
		this._opts = opts;
		this._title = this._opts.title;
		this._checked = this._opts.isChecked;
		const classes = ["monaco-custom-toggle"];
		if (this._opts.icon) {
			this._icon = this._opts.icon;
			classes.push(...ThemeIcon.asClassNameArray(this._icon));
		}
		if (this._opts.actionClassName) classes.push(...this._opts.actionClassName.split(" "));
		if (this._checked) classes.push("checked");
		this.domNode = document.createElement("div");
		this._register(getBaseLayerHoverDelegate().setupDelayedHover(this.domNode, () => ({
			content: !isMarkdownString(this._title) && !isHTMLElement(this._title) ? stripIcons(this._title) : this._title,
			style: 1
		}), this._opts.hoverLifecycleOptions));
		this.domNode.classList.add(...classes);
		if (!this._opts.notFocusable) this.domNode.tabIndex = 0;
		this.domNode.setAttribute("role", "checkbox");
		this.domNode.setAttribute("aria-checked", String(this._checked));
		this.setTitle(this._opts.title);
		this.applyStyles();
		this.onclick(this.domNode, (ev) => {
			if (this.enabled) {
				this.checked = !this._checked;
				this._onChange.fire(false);
				ev.preventDefault();
				ev.stopPropagation();
			}
		});
		this._register(this.ignoreGesture(this.domNode));
		this.onkeydown(this.domNode, (keyboardEvent) => {
			if (!this.enabled) return;
			if (keyboardEvent.keyCode === 10 || keyboardEvent.keyCode === 3) {
				this.checked = !this._checked;
				this._onChange.fire(true);
				keyboardEvent.preventDefault();
				keyboardEvent.stopPropagation();
				return;
			}
			this._onKeyDown.fire(keyboardEvent);
		});
	}
	get enabled() {
		return this.domNode.getAttribute("aria-disabled") !== "true";
	}
	focus() {
		this.domNode.focus();
	}
	get checked() {
		return this._checked;
	}
	set checked(newIsChecked) {
		this._checked = newIsChecked;
		this.domNode.setAttribute("aria-checked", String(this._checked));
		this.domNode.classList.toggle("checked", this._checked);
		this.applyStyles();
	}
	setIcon(icon) {
		if (this._icon) this.domNode.classList.remove(...ThemeIcon.asClassNameArray(this._icon));
		this._icon = icon;
		if (this._icon) this.domNode.classList.add(...ThemeIcon.asClassNameArray(this._icon));
	}
	width() {
		return 22;
	}
	applyStyles() {
		if (this.domNode) {
			if (this._checked && this._opts.inputActiveOptionBorder) this.domNode.style.setProperty("--monaco-custom-toggle-border-color", this._opts.inputActiveOptionBorder);
			else this.domNode.style.removeProperty("--monaco-custom-toggle-border-color");
			this.domNode.style.color = this._checked && this._opts.inputActiveOptionForeground || "inherit";
			this.domNode.style.backgroundColor = this._checked && this._opts.inputActiveOptionBackground || "";
		}
	}
	enable() {
		this.domNode.setAttribute("aria-disabled", String(false));
		this.domNode.classList.remove("disabled");
		if (!this._opts.notFocusable) this.domNode.tabIndex = 0;
	}
	disable() {
		this.domNode.setAttribute("aria-disabled", String(true));
		this.domNode.classList.add("disabled");
		if (!this._opts.notFocusable) this.domNode.tabIndex = -1;
	}
	setTitle(newTitle) {
		this._title = newTitle;
		const ariaLabel = typeof newTitle === "string" ? newTitle : isMarkdownString(newTitle) ? newTitle.value : newTitle.textContent;
		this.domNode.setAttribute("aria-label", getCodiconAriaLabel(ariaLabel));
	}
};
var BaseCheckbox = class extends Widget$1 {
	static {
		this.CLASS_NAME = "monaco-checkbox";
	}
	constructor(checkbox, domNode, styles) {
		super();
		this.checkbox = checkbox;
		this.domNode = domNode;
		this.styles = styles;
		this._onChange = this._register(new Emitter$1());
		this.onChange = this._onChange.event;
		this.applyStyles();
	}
	get enabled() {
		return this.checkbox.enabled;
	}
	enable() {
		this.checkbox.enable();
		this.applyStyles(true);
	}
	disable() {
		this.checkbox.disable();
		this.applyStyles(false);
	}
	setTitle(newTitle) {
		this.checkbox.setTitle(newTitle);
	}
	applyStyles(enabled = this.enabled) {
		this.domNode.style.color = (enabled ? this.styles.checkboxForeground : this.styles.checkboxDisabledForeground) || "";
		this.domNode.style.backgroundColor = (enabled ? this.styles.checkboxBackground : this.styles.checkboxDisabledBackground) || "";
		this.domNode.style.borderColor = (enabled ? this.styles.checkboxBorder : this.styles.checkboxDisabledBackground) || "";
		const size = this.styles.size || 18;
		this.domNode.style.width = this.domNode.style.height = this.domNode.style.fontSize = `${size}px`;
		this.domNode.style.fontSize = `${size - 2}px`;
	}
};
var Checkbox = class extends BaseCheckbox {
	constructor(title, isChecked, styles) {
		const toggle = new Toggle({
			title,
			isChecked,
			icon: Codicon.check,
			actionClassName: BaseCheckbox.CLASS_NAME,
			hoverLifecycleOptions: styles.hoverLifecycleOptions,
			...unthemedToggleStyles
		});
		super(toggle, toggle.domNode, styles);
		this._register(toggle);
		this._register(this.checkbox.onChange((keyboard) => {
			this.applyStyles();
			this._onChange.fire(keyboard);
		}));
	}
	get checked() {
		return this.checkbox.checked;
	}
	set checked(newIsChecked) {
		this.checkbox.checked = newIsChecked;
		this.applyStyles();
	}
	applyStyles(enabled) {
		if (this.checkbox.checked) this.checkbox.setIcon(Codicon.check);
		else this.checkbox.setIcon(void 0);
		super.applyStyles(enabled);
	}
};
var TriStateCheckbox = class extends BaseCheckbox {
	constructor(title, _state, styles) {
		let icon;
		switch (_state) {
			case true:
				icon = Codicon.check;
				break;
			case "mixed":
				icon = Codicon.dash;
				break;
			case false: icon = void 0;
		}
		const checkbox = new Toggle({
			title,
			isChecked: _state === true,
			icon,
			actionClassName: Checkbox.CLASS_NAME,
			hoverLifecycleOptions: styles.hoverLifecycleOptions,
			...unthemedToggleStyles
		});
		super(checkbox, checkbox.domNode, styles);
		this._state = _state;
		this._register(checkbox);
		this._register(this.checkbox.onChange((keyboard) => {
			this._state = this.checkbox.checked;
			this.applyStyles();
			this._onChange.fire(keyboard);
		}));
	}
	get checked() {
		return this._state;
	}
	set checked(newState) {
		if (this._state !== newState) {
			this._state = newState;
			this.checkbox.checked = newState === true;
			this.applyStyles();
		}
	}
	applyStyles(enabled) {
		switch (this._state) {
			case true:
				this.checkbox.setIcon(Codicon.check);
				break;
			case "mixed":
				this.checkbox.setIcon(Codicon.dash);
				break;
			case false: this.checkbox.setIcon(void 0);
		}
		super.applyStyles(enabled);
	}
};
/**
* Creates an action view item provider that renders toggles for actions with a checked state
* and falls back to default button rendering for regular actions.
*
* @param toggleStyles - Optional styles to apply to toggle items
* @returns An IActionViewItemProvider that can be used with ActionBar
*/
function createToggleActionViewItemProvider(toggleStyles) {
	return (action, options) => {
		if (action.checked !== void 0) return new ToggleActionViewItem(null, action, {
			...options,
			toggleStyles
		});
	};
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/findinput/findInputToggles.js
/**
* Arrow-Key support to navigate between the toggles of a find input, with
* `Escape` moving focus back to the input box.
*
* The toggles are resolved through a callback because they are only needed
* once one of the handled keys is pressed.
*/
function navigateToggles(event, domNode, getToggleDomNodes, focusInput) {
	if (event.equals(15) || event.equals(17) || event.equals(9)) {
		const indexes = getToggleDomNodes();
		const index = indexes.indexOf(domNode.ownerDocument.activeElement);
		if (index >= 0) {
			let newIndex = -1;
			if (event.equals(17)) newIndex = (index + 1) % indexes.length;
			else if (event.equals(15)) {
				if (index === 0) newIndex = indexes.length - 1;
				else newIndex = index - 1;
			}
			if (event.equals(9)) {
				indexes[index].blur();
				focusInput();
			} else if (newIndex >= 0) indexes[newIndex].focus();
			EventHelper.stop(event, true);
		}
	}
}
var NLS_CASE_SENSITIVE_TOGGLE_LABEL = localize(2, "Match Case");
var NLS_WHOLE_WORD_TOGGLE_LABEL = localize(3, "Match Whole Word");
var NLS_REGEX_TOGGLE_LABEL = localize(4, "Use Regular Expression");
var CaseSensitiveToggle = class extends Toggle {
	constructor(opts) {
		super({
			icon: Codicon.caseSensitive,
			title: NLS_CASE_SENSITIVE_TOGGLE_LABEL + opts.appendTitle,
			isChecked: opts.isChecked,
			hoverLifecycleOptions: opts.hoverLifecycleOptions,
			inputActiveOptionBorder: opts.inputActiveOptionBorder,
			inputActiveOptionForeground: opts.inputActiveOptionForeground,
			inputActiveOptionBackground: opts.inputActiveOptionBackground
		});
	}
};
var WholeWordsToggle = class extends Toggle {
	constructor(opts) {
		super({
			icon: Codicon.wholeWord,
			title: NLS_WHOLE_WORD_TOGGLE_LABEL + opts.appendTitle,
			isChecked: opts.isChecked,
			hoverLifecycleOptions: opts.hoverLifecycleOptions,
			inputActiveOptionBorder: opts.inputActiveOptionBorder,
			inputActiveOptionForeground: opts.inputActiveOptionForeground,
			inputActiveOptionBackground: opts.inputActiveOptionBackground
		});
	}
};
var RegexToggle = class extends Toggle {
	constructor(opts) {
		super({
			icon: Codicon.regex,
			title: NLS_REGEX_TOGGLE_LABEL + opts.appendTitle,
			isChecked: opts.isChecked,
			hoverLifecycleOptions: opts.hoverLifecycleOptions,
			inputActiveOptionBorder: opts.inputActiveOptionBorder,
			inputActiveOptionForeground: opts.inputActiveOptionForeground,
			inputActiveOptionBackground: opts.inputActiveOptionBackground
		});
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/formattedTextRenderer.js
function renderText(text, _options, target) {
	const element = target ?? document.createElement("div");
	element.textContent = text;
	return element;
}
function renderFormattedText(formattedText, options, target) {
	const element = target ?? document.createElement("div");
	element.textContent = "";
	_renderFormattedText(element, parseFormattedText(formattedText), options?.actionHandler, options?.renderCodeSegments);
	return element;
}
var StringStream = class {
	constructor(source) {
		this.source = source;
		this.index = 0;
	}
	eos() {
		return this.index >= this.source.length;
	}
	next() {
		const next = this.peek();
		this.advance();
		return next;
	}
	peek() {
		return this.source[this.index];
	}
	advance() {
		this.index++;
	}
};
function _renderFormattedText(element, treeNode, actionHandler, renderCodeSegments) {
	let child;
	if (treeNode.type === 2) child = document.createTextNode(treeNode.content || "");
	else if (treeNode.type === 3) child = document.createElement("b");
	else if (treeNode.type === 4) child = document.createElement("i");
	else if (treeNode.type === 7 && renderCodeSegments) child = document.createElement("code");
	else if (treeNode.type === 5 && actionHandler) {
		const a = document.createElement("a");
		actionHandler.disposables.add(addStandardDisposableListener(a, "click", (event) => {
			actionHandler.callback(String(treeNode.index), event);
		}));
		child = a;
	} else if (treeNode.type === 8) child = document.createElement("br");
	else if (treeNode.type === 1) child = element;
	if (child && element !== child) element.appendChild(child);
	if (child && Array.isArray(treeNode.children)) treeNode.children.forEach((nodeChild) => {
		_renderFormattedText(child, nodeChild, actionHandler, renderCodeSegments);
	});
}
function parseFormattedText(content, parseCodeSegments) {
	const root = {
		type: 1,
		children: []
	};
	let actionViewItemIndex = 0;
	let current = root;
	const stack = [];
	const stream = new StringStream(content);
	while (!stream.eos()) {
		let next = stream.next();
		const isEscapedFormatType = next === "\\" && formatTagType(stream.peek()) !== 0;
		if (isEscapedFormatType) next = stream.next();
		if (!isEscapedFormatType && isFormatTag(next) && next === stream.peek()) {
			stream.advance();
			if (current.type === 2) current = stack.pop();
			const type = formatTagType(next);
			if (current.type === type || current.type === 5 && type === 6) current = stack.pop();
			else {
				const newCurrent = {
					type,
					children: []
				};
				if (type === 5) {
					newCurrent.index = actionViewItemIndex;
					actionViewItemIndex++;
				}
				current.children.push(newCurrent);
				stack.push(current);
				current = newCurrent;
			}
		} else if (next === "\n") {
			if (current.type === 2) current = stack.pop();
			current.children.push({ type: 8 });
		} else if (current.type !== 2) {
			const textCurrent = {
				type: 2,
				content: next
			};
			current.children.push(textCurrent);
			stack.push(current);
			current = textCurrent;
		} else current.content += next;
	}
	if (current.type === 2) current = stack.pop();
	return root;
}
function isFormatTag(char, supportCodeSegments) {
	return formatTagType(char) !== 0;
}
function formatTagType(char, supportCodeSegments) {
	switch (char) {
		case "*": return 3;
		case "_": return 4;
		case "[": return 5;
		case "]": return 6;
		case "`": return 0;
		default: return 0;
	}
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/navigator.js
var ArrayNavigator = class {
	constructor(items, start = 0, end = items.length, index = start - 1) {
		this.items = items;
		this.start = start;
		this.end = end;
		this.index = index;
	}
	current() {
		if (this.index === this.start - 1 || this.index === this.end) return null;
		return this.items[this.index];
	}
	next() {
		this.index = Math.min(this.index + 1, this.end);
		return this.current();
	}
	previous() {
		this.index = Math.max(this.index - 1, this.start - 1);
		return this.current();
	}
	first() {
		this.index = this.start;
		return this.current();
	}
	last() {
		this.index = this.end - 1;
		return this.current();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/history.js
var HistoryNavigator = class {
	constructor(_history = /* @__PURE__ */ new Set(), limit = 10) {
		this._history = _history;
		this._limit = limit;
		this._onChange();
		if (this._history.onDidChange) this._disposable = this._history.onDidChange(() => this._onChange());
	}
	getHistory() {
		return this._elements;
	}
	add(t) {
		this._history.delete(t);
		this._history.add(t);
		this._onChange();
	}
	next() {
		return this._navigator.next();
	}
	previous() {
		if (this._currentPosition() !== 0) return this._navigator.previous();
		return null;
	}
	current() {
		return this._navigator.current();
	}
	first() {
		return this._navigator.first();
	}
	last() {
		return this._navigator.last();
	}
	isLast() {
		return this._currentPosition() >= this._elements.length - 1;
	}
	isNowhere() {
		return this._navigator.current() === null;
	}
	has(t) {
		return this._history.has(t);
	}
	_onChange() {
		this._reduceToLimit();
		const elements = this._elements;
		this._navigator = new ArrayNavigator(elements, 0, elements.length, elements.length);
	}
	_reduceToLimit() {
		const data = this._elements;
		if (data.length > this._limit) {
			const replaceValue = data.slice(data.length - this._limit);
			if (this._history.replace) this._history.replace(replaceValue);
			else this._history = new Set(replaceValue);
		}
	}
	_currentPosition() {
		const currentElement = this._navigator.current();
		if (!currentElement) return -1;
		return this._elements.indexOf(currentElement);
	}
	get _elements() {
		const elements = [];
		this._history.forEach((e) => elements.push(e));
		return elements;
	}
	dispose() {
		if (this._disposable) {
			this._disposable.dispose();
			this._disposable = void 0;
		}
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/inputbox/inputBox.js
var $$6 = $$10;
var InputBox$1 = class extends Widget$1 {
	get onDidChange() {
		return this._onDidChange.event;
	}
	get onDidHeightChange() {
		return this._onDidHeightChange.event;
	}
	constructor(container, contextViewProvider, options) {
		super();
		this.state = "idle";
		this.maxHeight = Number.POSITIVE_INFINITY;
		this.hover = this._register(new MutableDisposable());
		this.messageResizeObserver = this._register(new MutableDisposable());
		this._onDidChange = this._register(new Emitter$1());
		this._onDidHeightChange = this._register(new Emitter$1());
		this.contextViewProvider = contextViewProvider;
		this.options = options;
		this.message = null;
		this.placeholder = this.options.placeholder || "";
		this.tooltip = this.options.tooltip ?? (this.placeholder || "");
		this.ariaLabel = this.options.ariaLabel || "";
		if (this.options.validationOptions) this.validation = this.options.validationOptions.validation;
		this.element = append$2(container, $$6(".monaco-inputbox.idle"));
		const tagName = this.options.flexibleHeight ? "textarea" : "input";
		const wrapper = append$2(this.element, $$6(".ibwrapper"));
		this.input = append$2(wrapper, $$6(tagName + ".input.empty"));
		this.input.setAttribute("autocorrect", "off");
		this.input.setAttribute("autocapitalize", "off");
		this.input.setAttribute("spellcheck", "false");
		this.onfocus(this.input, () => this.element.classList.add("synthetic-focus"));
		this.onblur(this.input, () => this.element.classList.remove("synthetic-focus"));
		if (this.options.flexibleHeight) {
			this.maxHeight = typeof this.options.flexibleMaxHeight === "number" ? this.options.flexibleMaxHeight : Number.POSITIVE_INFINITY;
			this.mirror = append$2(wrapper, $$6("div.mirror"));
			this.mirror.innerText = "\xA0";
			this.scrollableElement = new ScrollableElement(this.element, { vertical: 1 });
			if (this.options.flexibleWidth) {
				this.input.setAttribute("wrap", "off");
				this.mirror.style.whiteSpace = "pre";
				this.mirror.style.wordWrap = "initial";
			}
			append$2(container, this.scrollableElement.getDomNode());
			this._register(this.scrollableElement);
			this._register(this.scrollableElement.onScroll((e) => this.input.scrollTop = e.scrollTop));
			const onSelectionChange = this._register(new DomEmitter(container.ownerDocument, "selectionchange"));
			const onAnchoredSelectionChange = Event.filter(onSelectionChange.event, () => {
				return container.ownerDocument.getSelection()?.anchorNode === wrapper;
			});
			this._register(onAnchoredSelectionChange(this.updateScrollDimensions, this));
			this._register(this.onDidHeightChange(this.updateScrollDimensions, this));
		} else {
			this.input.type = this.options.type || "text";
			this.input.setAttribute("wrap", "off");
		}
		if (this.ariaLabel) this.input.setAttribute("aria-label", this.ariaLabel);
		if (this.placeholder && !this.options.showPlaceholderOnFocus) this.setPlaceHolder(this.placeholder);
		if (this.tooltip) this.setTooltip(this.tooltip);
		this.oninput(this.input, () => this.onValueChange());
		this.onblur(this.input, () => this.onBlur());
		this.onfocus(this.input, () => this.onFocus());
		this._register(this.ignoreGesture(this.input));
		setTimeout(() => this.updateMirror(), 0);
		if (this.options.actions) {
			this.actionbar = this._register(new ActionBar(this.element, { actionViewItemProvider: this.options.actionViewItemProvider }));
			this.actionbar.push(this.options.actions, {
				icon: true,
				label: false
			});
		}
		this.applyStyles();
	}
	setActions(actions, actionViewItemProvider) {
		if (this.actionbar) {
			this.actionbar.clear();
			if (actions) this.actionbar.push(actions, {
				icon: true,
				label: false
			});
		} else if (actions) {
			this.actionbar = this._register(new ActionBar(this.element, { actionViewItemProvider: actionViewItemProvider ?? this.options.actionViewItemProvider }));
			this.actionbar.push(actions, {
				icon: true,
				label: false
			});
		}
	}
	get actionsWidth() {
		return this.actionbar?.getContainer().offsetWidth ?? 0;
	}
	onBlur() {
		this._hideMessage();
		if (this.options.showPlaceholderOnFocus) this.input.setAttribute("placeholder", "");
	}
	onFocus() {
		this._showMessage();
		if (this.options.showPlaceholderOnFocus) this.input.setAttribute("placeholder", this.placeholder || "");
	}
	setPlaceHolder(placeHolder) {
		this.placeholder = placeHolder;
		this.input.setAttribute("placeholder", placeHolder);
	}
	setTooltip(tooltip) {
		this.tooltip = tooltip;
		if (!this.hover.value) this.hover.value = this._register(getBaseLayerHoverDelegate().setupDelayedHoverAtMouse(this.input, () => ({
			content: this.tooltip,
			appearance: { compact: true }
		})));
	}
	setAriaLabel(label) {
		this.ariaLabel = label;
		if (label) this.input.setAttribute("aria-label", this.ariaLabel);
		else this.input.removeAttribute("aria-label");
	}
	get inputElement() {
		return this.input;
	}
	get value() {
		return this.input.value;
	}
	set value(newValue) {
		if (this.input.value !== newValue) {
			this.input.value = newValue;
			this.onValueChange();
		}
	}
	get height() {
		return typeof this.cachedHeight === "number" ? this.cachedHeight : getTotalHeight(this.element);
	}
	focus() {
		this.input.focus();
	}
	blur() {
		this.input.blur();
	}
	hasFocus() {
		return isActiveElement(this.input);
	}
	select(range = null) {
		this.input.select();
		if (range) {
			this.input.setSelectionRange(range.start, range.end);
			if (range.end === this.input.value.length) this.input.scrollLeft = this.input.scrollWidth;
		}
	}
	isSelectionAtEnd() {
		return this.input.selectionEnd === this.input.value.length && this.input.selectionStart === this.input.selectionEnd;
	}
	getSelection() {
		const selectionStart = this.input.selectionStart;
		if (selectionStart === null) return null;
		return {
			start: selectionStart,
			end: this.input.selectionEnd ?? selectionStart
		};
	}
	enable() {
		this.input.removeAttribute("disabled");
	}
	disable() {
		this.blur();
		this.input.disabled = true;
		this._hideMessage();
	}
	set paddingRight(paddingRight) {
		this.input.style.width = `calc(100% - ${paddingRight}px)`;
		if (this.mirror) this.mirror.style.paddingRight = paddingRight + "px";
	}
	updateScrollDimensions() {
		if (typeof this.cachedContentHeight !== "number" || typeof this.cachedHeight !== "number" || !this.scrollableElement) return;
		const scrollHeight = this.cachedContentHeight;
		const height = this.cachedHeight;
		const scrollTop = this.input.scrollTop;
		this.scrollableElement.setScrollDimensions({
			scrollHeight,
			height
		});
		this.scrollableElement.setScrollPosition({ scrollTop });
	}
	showMessage(message, force) {
		if (this.state === "open" && equals$2(this.message, message)) return;
		this.message = message;
		this.element.classList.remove("idle");
		this.element.classList.remove("info");
		this.element.classList.remove("warning");
		this.element.classList.remove("error");
		this.element.classList.add(this.classForType(message.type));
		const styles = this.stylesForType(this.message.type);
		this.element.style.border = `1px solid ${asCssValueWithDefault(styles.border, "transparent")}`;
		if (this.message.content && (this.hasFocus() || force)) this._showMessage();
	}
	hideMessage() {
		this.message = null;
		this.element.classList.remove("info");
		this.element.classList.remove("warning");
		this.element.classList.remove("error");
		this.element.classList.add("idle");
		this._hideMessage();
		this.applyStyles();
	}
	validate() {
		let errorMsg = null;
		if (this.validation) {
			errorMsg = this.validation(this.value);
			if (errorMsg) {
				this.inputElement.setAttribute("aria-invalid", "true");
				this.showMessage(errorMsg);
			} else if (this.inputElement.hasAttribute("aria-invalid")) {
				this.inputElement.removeAttribute("aria-invalid");
				this.hideMessage();
			}
		}
		return errorMsg?.type;
	}
	stylesForType(type) {
		const styles = this.options.inputBoxStyles;
		switch (type) {
			case 1: return {
				border: styles.inputValidationInfoBorder,
				background: styles.inputValidationInfoBackground,
				foreground: styles.inputValidationInfoForeground
			};
			case 2: return {
				border: styles.inputValidationWarningBorder,
				background: styles.inputValidationWarningBackground,
				foreground: styles.inputValidationWarningForeground
			};
			default: return {
				border: styles.inputValidationErrorBorder,
				background: styles.inputValidationErrorBackground,
				foreground: styles.inputValidationErrorForeground
			};
		}
	}
	classForType(type) {
		switch (type) {
			case 1: return "info";
			case 2: return "warning";
			default: return "error";
		}
	}
	_showMessage() {
		if (!this.contextViewProvider || !this.message) return;
		let div;
		const layout = () => div.style.width = getTotalWidth(this.element) + "px";
		this.contextViewProvider.showContextView({
			getAnchor: () => this.element,
			anchorAlignment: 1,
			render: (container) => {
				if (!this.message) return null;
				div = append$2(container, $$6(".monaco-inputbox-container"));
				layout();
				const spanElement = $$6("span.monaco-inputbox-message");
				if (this.message.formatContent) renderFormattedText(this.message.content, void 0, spanElement);
				else renderText(this.message.content, void 0, spanElement);
				spanElement.classList.add(this.classForType(this.message.type));
				const styles = this.stylesForType(this.message.type);
				spanElement.style.backgroundColor = styles.background ?? "";
				spanElement.style.color = styles.foreground ?? "";
				spanElement.style.border = styles.border ? `1px solid ${styles.border}` : "";
				append$2(div, spanElement);
				return null;
			},
			onHide: () => {
				this.state = "closed";
				this.messageResizeObserver.clear();
			},
			layout
		});
		this.observeElementResize();
		let alertText;
		if (this.message.type === 3) alertText = localize(9, "Error: {0}", this.message.content);
		else if (this.message.type === 2) alertText = localize(10, "Warning: {0}", this.message.content);
		else alertText = localize(11, "Info: {0}", this.message.content);
		alert(alertText);
		this.state = "open";
	}
	_hideMessage() {
		if (!this.contextViewProvider) return;
		if (this.state === "open") this.contextViewProvider.hideContextView();
		this.messageResizeObserver.clear();
		this.state = "idle";
	}
	/**
	* Keeps the validation message sized and anchored to the input while the
	* message is showing and the input itself is resized, e.g. because the
	* containing view was resized.
	*/
	observeElementResize() {
		const disposables = new DisposableStore();
		const observer = disposables.add(new DisposableResizeObserver("InputBox.validationMessage", () => {
			if (this.element.isConnected && getTotalWidth(this.element) > 0) this.layoutMessage();
		}, getWindow(this.element)));
		disposables.add(observer.observe(this.element));
		this.messageResizeObserver.value = disposables;
	}
	layoutMessage() {
		if (this.state === "open" && this.contextViewProvider) this.contextViewProvider.layout();
	}
	onValueChange() {
		this._onDidChange.fire(this.value);
		this.validate();
		this.updateMirror();
		this.input.classList.toggle("empty", !this.value);
		if (this.state === "open" && this.contextViewProvider) this.contextViewProvider.layout();
		if (this.options.hideHoverOnValueChange) getBaseLayerHoverDelegate().hideHover();
	}
	updateMirror() {
		if (!this.mirror) return;
		const value = this.value;
		const suffix = value.charCodeAt(value.length - 1) === 10 ? " " : "";
		if ((value + suffix).replace(/\u000c/g, "")) this.mirror.textContent = value + suffix;
		else this.mirror.innerText = "\xA0";
		this.layout();
	}
	applyStyles() {
		const styles = this.options.inputBoxStyles;
		const background = styles.inputBackground ?? "";
		const foreground = styles.inputForeground ?? "";
		const border = styles.inputBorder ?? "";
		this.element.style.backgroundColor = background;
		this.element.style.color = foreground;
		this.input.style.backgroundColor = "inherit";
		this.input.style.color = foreground;
		this.element.style.border = `1px solid ${asCssValueWithDefault(border, "transparent")}`;
	}
	layout() {
		if (!this.mirror) {
			this.layoutMessage();
			return;
		}
		const previousHeight = this.cachedContentHeight;
		this.cachedContentHeight = getTotalHeight(this.mirror);
		if (previousHeight !== this.cachedContentHeight) {
			this.cachedHeight = Math.min(this.cachedContentHeight, this.maxHeight);
			this.input.style.height = this.cachedHeight + "px";
			this._onDidHeightChange.fire(this.cachedContentHeight);
		}
		this.layoutMessage();
	}
	insertAtCursor(text) {
		const inputElement = this.inputElement;
		const start = inputElement.selectionStart;
		const end = inputElement.selectionEnd;
		const content = inputElement.value;
		if (start !== null && end !== null) {
			this.value = content.substr(0, start) + text + content.substr(end);
			inputElement.setSelectionRange(start + 1, start + 1);
			this.layout();
		}
	}
	dispose() {
		this._hideMessage();
		this.message = null;
		this.actionbar?.dispose();
		super.dispose();
	}
};
var HistoryInputBox = class extends InputBox$1 {
	constructor(container, contextViewProvider, options) {
		const NLS_PLACEHOLDER_HISTORY_HINT_SUFFIX_NO_PARENS = localize(12, " or {0} for history", `\u21C5`);
		const NLS_PLACEHOLDER_HISTORY_HINT_SUFFIX_IN_PARENS = localize(13, " ({0} for history)", `\u21C5`);
		super(container, contextViewProvider, options);
		this._onDidFocus = this._register(new Emitter$1());
		this.onDidFocus = this._onDidFocus.event;
		this._onDidBlur = this._register(new Emitter$1());
		this.onDidBlur = this._onDidBlur.event;
		this.history = this._register(new HistoryNavigator(options.history, 100));
		const addSuffix = () => {
			if (options.showHistoryHint && options.showHistoryHint() && !this.placeholder.endsWith(NLS_PLACEHOLDER_HISTORY_HINT_SUFFIX_NO_PARENS) && !this.placeholder.endsWith(NLS_PLACEHOLDER_HISTORY_HINT_SUFFIX_IN_PARENS) && this.history.getHistory().length) {
				const suffix = this.placeholder.endsWith(")") ? NLS_PLACEHOLDER_HISTORY_HINT_SUFFIX_NO_PARENS : NLS_PLACEHOLDER_HISTORY_HINT_SUFFIX_IN_PARENS;
				const suffixedPlaceholder = this.placeholder + suffix;
				if (options.showPlaceholderOnFocus && !isActiveElement(this.input)) this.placeholder = suffixedPlaceholder;
				else this.setPlaceHolder(suffixedPlaceholder);
			}
		};
		this.observer = new MutationObserver((mutationList, observer) => {
			mutationList.forEach((mutation) => {
				if (!mutation.target.textContent) addSuffix();
			});
		});
		this.observer.observe(this.input, { attributeFilter: ["class"] });
		this.onfocus(this.input, () => addSuffix());
		this.onblur(this.input, () => {
			const resetPlaceholder = (historyHint) => {
				if (!this.placeholder.endsWith(historyHint)) return false;
				else {
					const revertedPlaceholder = this.placeholder.slice(0, this.placeholder.length - historyHint.length);
					if (options.showPlaceholderOnFocus) this.placeholder = revertedPlaceholder;
					else this.setPlaceHolder(revertedPlaceholder);
					return true;
				}
			};
			if (!resetPlaceholder(NLS_PLACEHOLDER_HISTORY_HINT_SUFFIX_IN_PARENS)) resetPlaceholder(NLS_PLACEHOLDER_HISTORY_HINT_SUFFIX_NO_PARENS);
		});
	}
	dispose() {
		super.dispose();
		if (this.observer) {
			this.observer.disconnect();
			this.observer = void 0;
		}
	}
	addToHistory(always) {
		if (this.value && (always || this.value !== this.getCurrentValue())) this.history.add(this.value);
	}
	isAtLastInHistory() {
		return this.history.isLast();
	}
	isNowhereInHistory() {
		return this.history.isNowhere();
	}
	showNextValue() {
		if (!this.history.has(this.value)) this.addToHistory();
		let next = this.getNextValue();
		if (next) next = next === this.value ? this.getNextValue() : next;
		this.value = next ?? "";
		status(this.value ? this.value : localize(14, "Cleared Input"));
	}
	showPreviousValue() {
		if (!this.history.has(this.value)) this.addToHistory();
		let previous = this.getPreviousValue();
		if (previous) previous = previous === this.value ? this.getPreviousValue() : previous;
		if (previous) {
			this.value = previous;
			status(this.value);
		}
	}
	setPlaceHolder(placeHolder) {
		super.setPlaceHolder(placeHolder);
		this.setTooltip(placeHolder);
	}
	onBlur() {
		super.onBlur();
		this._onDidBlur.fire();
	}
	onFocus() {
		super.onFocus();
		this._onDidFocus.fire();
	}
	getCurrentValue() {
		let currentValue = this.history.current();
		if (!currentValue) {
			currentValue = this.history.last();
			this.history.next();
		}
		return currentValue;
	}
	getPreviousValue() {
		return this.history.previous() || this.history.first();
	}
	getNextValue() {
		return this.history.next();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/findinput/findInput.js
var NLS_DEFAULT_LABEL = localize(1, "input");
var FindInput = class extends Widget$1 {
	get onDidOptionChange() {
		return this._onDidOptionChange.event;
	}
	get onKeyDown() {
		return this._onKeyDown.event;
	}
	get onMouseDown() {
		return this._onMouseDown.event;
	}
	get onCaseSensitiveKeyDown() {
		return this._onCaseSensitiveKeyDown.event;
	}
	get onRegexKeyDown() {
		return this._onRegexKeyDown.event;
	}
	constructor(parent, contextViewProvider, options) {
		super();
		this.fixFocusOnOptionClickEnabled = true;
		this.imeSessionInProgress = false;
		this.additionalTogglesDisposables = this._register(new MutableDisposable());
		this.additionalToggles = [];
		this._onDidOptionChange = this._register(new Emitter$1());
		this._onKeyDown = this._register(new Emitter$1());
		this._onMouseDown = this._register(new Emitter$1());
		this._onInput = this._register(new Emitter$1());
		this._onKeyUp = this._register(new Emitter$1());
		this._onCaseSensitiveKeyDown = this._register(new Emitter$1());
		this._onRegexKeyDown = this._register(new Emitter$1());
		this._lastHighlightFindOptions = 0;
		this.placeholder = options.placeholder || "";
		this.validation = options.validation;
		this.label = options.label || NLS_DEFAULT_LABEL;
		this.showCommonFindToggles = !!options.showCommonFindToggles;
		const appendCaseSensitiveLabel = options.appendCaseSensitiveLabel || "";
		const appendWholeWordsLabel = options.appendWholeWordsLabel || "";
		const appendRegexLabel = options.appendRegexLabel || "";
		const flexibleHeight = !!options.flexibleHeight;
		const flexibleWidth = !!options.flexibleWidth;
		const flexibleMaxHeight = options.flexibleMaxHeight;
		this.domNode = document.createElement("div");
		this.domNode.classList.add("monaco-findInput");
		this.inputBox = this._register(new HistoryInputBox(this.domNode, contextViewProvider, {
			placeholder: this.placeholder || "",
			ariaLabel: this.label || "",
			validationOptions: { validation: this.validation },
			showHistoryHint: options.showHistoryHint,
			flexibleHeight,
			flexibleWidth,
			flexibleMaxHeight,
			inputBoxStyles: options.inputBoxStyles,
			history: options.history,
			actions: options.actions,
			actionViewItemProvider: options.actionViewItemProvider,
			hideHoverOnValueChange: options.hideHoverOnValueChange
		}));
		if (this.showCommonFindToggles) {
			const hoverLifecycleOptions = options?.hoverLifecycleOptions || { groupId: "find-input" };
			this.regex = this._register(new RegexToggle({
				appendTitle: appendRegexLabel,
				isChecked: false,
				hoverLifecycleOptions,
				...options.toggleStyles
			}));
			this._register(this.regex.onChange((viaKeyboard) => {
				this._onDidOptionChange.fire(viaKeyboard);
				if (!viaKeyboard && this.fixFocusOnOptionClickEnabled) this.inputBox.focus();
				this.validate();
			}));
			this._register(this.regex.onKeyDown((e) => {
				this._onRegexKeyDown.fire(e);
			}));
			this.wholeWords = this._register(new WholeWordsToggle({
				appendTitle: appendWholeWordsLabel,
				isChecked: false,
				hoverLifecycleOptions,
				...options.toggleStyles
			}));
			this._register(this.wholeWords.onChange((viaKeyboard) => {
				this._onDidOptionChange.fire(viaKeyboard);
				if (!viaKeyboard && this.fixFocusOnOptionClickEnabled) this.inputBox.focus();
				this.validate();
			}));
			this.caseSensitive = this._register(new CaseSensitiveToggle({
				appendTitle: appendCaseSensitiveLabel,
				isChecked: false,
				hoverLifecycleOptions,
				...options.toggleStyles
			}));
			this._register(this.caseSensitive.onChange((viaKeyboard) => {
				this._onDidOptionChange.fire(viaKeyboard);
				if (!viaKeyboard && this.fixFocusOnOptionClickEnabled) this.inputBox.focus();
				this.validate();
			}));
			this._register(this.caseSensitive.onKeyDown((e) => {
				this._onCaseSensitiveKeyDown.fire(e);
			}));
			this.onkeydown(this.domNode, (event) => {
				navigateToggles(event, this.domNode, () => this.getToggleDomNodes(), () => this.inputBox.focus());
			});
		}
		this.controls = document.createElement("div");
		this.controls.className = "controls";
		this.controls.style.display = this.showCommonFindToggles ? "" : "none";
		if (this.caseSensitive) this.controls.append(this.caseSensitive.domNode);
		if (this.wholeWords) this.controls.appendChild(this.wholeWords.domNode);
		if (this.regex) this.controls.appendChild(this.regex.domNode);
		this.setAdditionalToggles(options?.additionalToggles);
		if (this.controls) this.domNode.appendChild(this.controls);
		parent?.appendChild(this.domNode);
		this._register(addDisposableListener(this.inputBox.inputElement, "compositionstart", (e) => {
			this.imeSessionInProgress = true;
		}));
		this._register(addDisposableListener(this.inputBox.inputElement, "compositionend", (e) => {
			this.imeSessionInProgress = false;
			this._onInput.fire({ fromCompositionEnd: true });
		}));
		this.onkeydown(this.inputBox.inputElement, (e) => this._onKeyDown.fire(e));
		this.onkeyup(this.inputBox.inputElement, (e) => this._onKeyUp.fire(e));
		this.oninput(this.inputBox.inputElement, (e) => this._onInput.fire({ fromCompositionEnd: false }));
		this.onmousedown(this.inputBox.inputElement, (e) => this._onMouseDown.fire(e));
	}
	get onDidChange() {
		return this.inputBox.onDidChange;
	}
	layout(style) {
		this.inputBox.layout();
		this.updateInputBoxPadding(style.collapsedFindWidget);
	}
	enable() {
		this.domNode.classList.remove("disabled");
		this.inputBox.enable();
		this.regex?.enable();
		this.wholeWords?.enable();
		this.caseSensitive?.enable();
		for (const toggle of this.additionalToggles) toggle.enable();
	}
	disable() {
		this.domNode.classList.add("disabled");
		this.inputBox.disable();
		this.regex?.disable();
		this.wholeWords?.disable();
		this.caseSensitive?.disable();
		for (const toggle of this.additionalToggles) toggle.disable();
	}
	setFocusInputOnOptionClick(value) {
		this.fixFocusOnOptionClickEnabled = value;
	}
	setEnabled(enabled) {
		if (enabled) this.enable();
		else this.disable();
	}
	setAdditionalToggles(toggles) {
		for (const currentToggle of this.additionalToggles) currentToggle.domNode.remove();
		this.additionalToggles = [];
		this.additionalTogglesDisposables.value = new DisposableStore();
		for (const toggle of toggles ?? []) {
			this.additionalTogglesDisposables.value.add(toggle);
			this.controls.appendChild(toggle.domNode);
			this.additionalTogglesDisposables.value.add(toggle.onChange((viaKeyboard) => {
				this._onDidOptionChange.fire(viaKeyboard);
				if (!viaKeyboard && this.fixFocusOnOptionClickEnabled) this.inputBox.focus();
			}));
			this.additionalToggles.push(toggle);
		}
		if (this.additionalToggles.length > 0) this.controls.style.display = "";
		this.updateInputBoxPadding();
	}
	getToggleDomNodes() {
		const nodes = [];
		if (this.caseSensitive) nodes.push(this.caseSensitive.domNode);
		if (this.wholeWords) nodes.push(this.wholeWords.domNode);
		if (this.regex) nodes.push(this.regex.domNode);
		for (const toggle of this.additionalToggles) nodes.push(toggle.domNode);
		return nodes;
	}
	setActions(actions, actionViewItemProvider) {
		this.inputBox.setActions(actions, actionViewItemProvider);
		this.updateInputBoxPadding();
	}
	updateInputBoxPadding(controlsHidden = false) {
		const togglesWidth = controlsHidden ? 0 : (this.caseSensitive?.width() ?? 0) + (this.wholeWords?.width() ?? 0) + (this.regex?.width() ?? 0) + this.additionalToggles.reduce((r, t) => r + t.width(), 0);
		this.inputBox.paddingRight = togglesWidth + this.inputBox.actionsWidth;
	}
	getValue() {
		return this.inputBox.value;
	}
	setValue(value) {
		if (this.inputBox.value !== value) this.inputBox.value = value;
	}
	select() {
		this.inputBox.select();
	}
	focus() {
		this.inputBox.focus();
	}
	getCaseSensitive() {
		return this.caseSensitive?.checked ?? false;
	}
	setCaseSensitive(value) {
		if (this.caseSensitive) this.caseSensitive.checked = value;
	}
	getWholeWords() {
		return this.wholeWords?.checked ?? false;
	}
	setWholeWords(value) {
		if (this.wholeWords) this.wholeWords.checked = value;
	}
	getRegex() {
		return this.regex?.checked ?? false;
	}
	setRegex(value) {
		if (this.regex) {
			this.regex.checked = value;
			this.validate();
		}
	}
	focusOnCaseSensitive() {
		this.caseSensitive?.focus();
	}
	highlightFindOptions() {
		this.domNode.classList.remove("highlight-" + this._lastHighlightFindOptions);
		this._lastHighlightFindOptions = 1 - this._lastHighlightFindOptions;
		this.domNode.classList.add("highlight-" + this._lastHighlightFindOptions);
	}
	validate() {
		this.inputBox.validate();
	}
	showMessage(message) {
		this.inputBox.showMessage(message);
	}
	clearMessage() {
		this.inputBox.hideMessage();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/tree/tree.js
var ObjectTreeElementCollapseState;
(function(ObjectTreeElementCollapseState) {
	ObjectTreeElementCollapseState[ObjectTreeElementCollapseState["Expanded"] = 0] = "Expanded";
	ObjectTreeElementCollapseState[ObjectTreeElementCollapseState["Collapsed"] = 1] = "Collapsed";
	/**
	* If the element is already in the tree, preserve its current state. Else, expand it.
	*/
	ObjectTreeElementCollapseState[ObjectTreeElementCollapseState["PreserveOrExpanded"] = 2] = "PreserveOrExpanded";
	/**
	* If the element is already in the tree, preserve its current state. Else, collapse it.
	*/
	ObjectTreeElementCollapseState[ObjectTreeElementCollapseState["PreserveOrCollapsed"] = 3] = "PreserveOrCollapsed";
})(ObjectTreeElementCollapseState || (ObjectTreeElementCollapseState = {}));
var TreeMouseEventTarget;
(function(TreeMouseEventTarget) {
	TreeMouseEventTarget[TreeMouseEventTarget["Unknown"] = 0] = "Unknown";
	TreeMouseEventTarget[TreeMouseEventTarget["Twistie"] = 1] = "Twistie";
	TreeMouseEventTarget[TreeMouseEventTarget["Element"] = 2] = "Element";
	TreeMouseEventTarget[TreeMouseEventTarget["Filter"] = 3] = "Filter";
})(TreeMouseEventTarget || (TreeMouseEventTarget = {}));
var TreeError = class extends Error {
	constructor(user, message) {
		super(`TreeError [${user}] ${message}`);
	}
};
var WeakMapper = class {
	constructor(fn) {
		this.fn = fn;
		this._map = /* @__PURE__ */ new WeakMap();
	}
	map(key) {
		let result = this._map.get(key);
		if (!result) {
			result = this.fn(key);
			this._map.set(key, result);
		}
		return result;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/tree/indexTreeModel.js
function isFilterResult(obj) {
	return !!obj && obj.visibility !== void 0;
}
function getVisibleState(visibility) {
	switch (visibility) {
		case true: return 1;
		case false: return 0;
		default: return visibility;
	}
}
function isCollapsibleStateUpdate(update) {
	return "collapsible" in update;
}
var IndexTreeModel = class {
	constructor(user, rootElement, options = {}) {
		this.user = user;
		this.rootRef = [];
		this.eventBufferer = new EventBufferer();
		this._onDidSpliceModel = new Emitter$1();
		this.onDidSpliceModel = this._onDidSpliceModel.event;
		this._onDidSpliceRenderedNodes = new Emitter$1();
		this.onDidSpliceRenderedNodes = this._onDidSpliceRenderedNodes.event;
		this._onDidChangeCollapseState = new Emitter$1();
		this.onDidChangeCollapseState = this.eventBufferer.wrapEvent(this._onDidChangeCollapseState.event);
		this._onDidChangeRenderNodeCount = new Emitter$1();
		this.onDidChangeRenderNodeCount = this.eventBufferer.wrapEvent(this._onDidChangeRenderNodeCount.event);
		this.refilterDelayer = new Delayer(MicrotaskDelay);
		this.collapseByDefault = typeof options.collapseByDefault === "undefined" ? false : options.collapseByDefault;
		this.allowNonCollapsibleParents = options.allowNonCollapsibleParents ?? false;
		this.filter = options.filter;
		this.autoExpandSingleChildren = typeof options.autoExpandSingleChildren === "undefined" ? false : options.autoExpandSingleChildren;
		this.root = {
			parent: void 0,
			element: rootElement,
			children: [],
			depth: 0,
			visibleChildrenCount: 0,
			visibleChildIndex: -1,
			collapsible: false,
			collapsed: false,
			renderNodeCount: 0,
			visibility: 1,
			visible: true,
			filterData: void 0
		};
	}
	splice(location, deleteCount, toInsert = Iterable.empty(), options = {}) {
		if (location.length === 0) throw new TreeError(this.user, "Invalid tree location");
		if (options.diffIdentityProvider) this.spliceSmart(options.diffIdentityProvider, location, deleteCount, toInsert, options);
		else this.spliceSimple(location, deleteCount, toInsert, options);
	}
	spliceSmart(identity, location, deleteCount, toInsertIterable = Iterable.empty(), options, recurseLevels = options.diffDepth ?? 0) {
		const { parentNode } = this.getParentNodeWithListIndex(location);
		if (!parentNode.lastDiffIds) return this.spliceSimple(location, deleteCount, toInsertIterable, options);
		const toInsert = [...toInsertIterable];
		const index = location[location.length - 1];
		const diff = new LcsDiff({ getElements: () => parentNode.lastDiffIds }, { getElements: () => [
			...parentNode.children.slice(0, index),
			...toInsert,
			...parentNode.children.slice(index + deleteCount)
		].map((e) => identity.getId(e.element).toString()) }).ComputeDiff(false);
		if (diff.quitEarly) {
			parentNode.lastDiffIds = void 0;
			return this.spliceSimple(location, deleteCount, toInsert, options);
		}
		const locationPrefix = location.slice(0, -1);
		const recurseSplice = (fromOriginal, fromModified, count) => {
			if (recurseLevels > 0) for (let i = 0; i < count; i++) {
				fromOriginal--;
				fromModified--;
				this.spliceSmart(identity, [
					...locationPrefix,
					fromOriginal,
					0
				], Number.MAX_SAFE_INTEGER, toInsert[fromModified].children, options, recurseLevels - 1);
			}
		};
		let lastStartO = Math.min(parentNode.children.length, index + deleteCount);
		let lastStartM = toInsert.length;
		for (const change of diff.changes.sort((a, b) => b.originalStart - a.originalStart)) {
			recurseSplice(lastStartO, lastStartM, lastStartO - (change.originalStart + change.originalLength));
			lastStartO = change.originalStart;
			lastStartM = change.modifiedStart - index;
			this.spliceSimple([...locationPrefix, lastStartO], change.originalLength, Iterable.slice(toInsert, lastStartM, lastStartM + change.modifiedLength), options);
		}
		recurseSplice(lastStartO, lastStartM, lastStartO);
	}
	spliceSimple(location, deleteCount, toInsert = Iterable.empty(), { onDidCreateNode, onDidDeleteNode, diffIdentityProvider }) {
		const { parentNode, listIndex, revealed, visible } = this.getParentNodeWithListIndex(location);
		const treeListElementsToInsert = [];
		const nodesToInsertIterator = Iterable.map(toInsert, (el) => this.createTreeNode(el, parentNode, parentNode.visible ? 1 : 0, revealed, treeListElementsToInsert, onDidCreateNode));
		const lastIndex = location[location.length - 1];
		let visibleChildStartIndex = 0;
		for (let i = lastIndex; i >= 0 && i < parentNode.children.length; i--) {
			const child = parentNode.children[i];
			if (child.visible) {
				visibleChildStartIndex = child.visibleChildIndex;
				break;
			}
		}
		const nodesToInsert = [];
		let insertedVisibleChildrenCount = 0;
		let renderNodeCount = 0;
		for (const child of nodesToInsertIterator) {
			nodesToInsert.push(child);
			renderNodeCount += child.renderNodeCount;
			if (child.visible) child.visibleChildIndex = visibleChildStartIndex + insertedVisibleChildrenCount++;
		}
		const deletedNodes = splice$1(parentNode.children, lastIndex, deleteCount, nodesToInsert);
		if (!diffIdentityProvider) parentNode.lastDiffIds = void 0;
		else if (parentNode.lastDiffIds) splice$1(parentNode.lastDiffIds, lastIndex, deleteCount, nodesToInsert.map((n) => diffIdentityProvider.getId(n.element).toString()));
		else parentNode.lastDiffIds = parentNode.children.map((n) => diffIdentityProvider.getId(n.element).toString());
		let deletedVisibleChildrenCount = 0;
		for (const child of deletedNodes) if (child.visible) deletedVisibleChildrenCount++;
		if (deletedVisibleChildrenCount !== 0) for (let i = lastIndex + nodesToInsert.length; i < parentNode.children.length; i++) {
			const child = parentNode.children[i];
			if (child.visible) child.visibleChildIndex -= deletedVisibleChildrenCount;
		}
		parentNode.visibleChildrenCount += insertedVisibleChildrenCount - deletedVisibleChildrenCount;
		if (deletedNodes.length > 0 && onDidDeleteNode) {
			const visit = (node) => {
				onDidDeleteNode(node);
				node.children.forEach(visit);
			};
			deletedNodes.forEach(visit);
		}
		if (revealed && visible) {
			const visibleDeleteCount = deletedNodes.reduce((r, node) => r + (node.visible ? node.renderNodeCount : 0), 0);
			this._updateAncestorsRenderNodeCount(parentNode, renderNodeCount - visibleDeleteCount);
			this._onDidSpliceRenderedNodes.fire({
				start: listIndex,
				deleteCount: visibleDeleteCount,
				elements: treeListElementsToInsert
			});
		}
		this._onDidSpliceModel.fire({
			insertedNodes: nodesToInsert,
			deletedNodes
		});
		let node = parentNode;
		while (node) {
			if (node.visibility === 2) {
				this.refilterDelayer.trigger(() => this.refilter());
				break;
			}
			node = node.parent;
		}
	}
	rerender(location) {
		if (location.length === 0) throw new TreeError(this.user, "Invalid tree location");
		const { node, listIndex, revealed } = this.getTreeNodeWithListIndex(location);
		if (node.visible && revealed) this._onDidSpliceRenderedNodes.fire({
			start: listIndex,
			deleteCount: 1,
			elements: [node]
		});
	}
	has(location) {
		return this.hasTreeNode(location);
	}
	getListIndex(location) {
		const { listIndex, visible, revealed } = this.getTreeNodeWithListIndex(location);
		return visible && revealed ? listIndex : -1;
	}
	getListRenderCount(location) {
		return this.getTreeNode(location).renderNodeCount;
	}
	isCollapsible(location) {
		return this.getTreeNode(location).collapsible;
	}
	setCollapsible(location, collapsible) {
		const node = this.getTreeNode(location);
		if (typeof collapsible === "undefined") collapsible = !node.collapsible;
		const update = { collapsible };
		return this.eventBufferer.bufferEvents(() => this._setCollapseState(location, update));
	}
	isCollapsed(location) {
		return this.getTreeNode(location).collapsed;
	}
	setCollapsed(location, collapsed, recursive) {
		const node = this.getTreeNode(location);
		if (typeof collapsed === "undefined") collapsed = !node.collapsed;
		const update = {
			collapsed,
			recursive: recursive || false
		};
		return this.eventBufferer.bufferEvents(() => this._setCollapseState(location, update));
	}
	_setCollapseState(location, update) {
		const { node, listIndex, revealed } = this.getTreeNodeWithListIndex(location);
		const result = this._setListNodeCollapseState(node, listIndex, revealed, update);
		if (node !== this.root && this.autoExpandSingleChildren && result && !isCollapsibleStateUpdate(update) && node.collapsible && !node.collapsed && !update.recursive) {
			let onlyVisibleChildIndex = -1;
			for (let i = 0; i < node.children.length; i++) if (node.children[i].visible) {
				if (onlyVisibleChildIndex > -1) {
					onlyVisibleChildIndex = -1;
					break;
				} else onlyVisibleChildIndex = i;
			}
			if (onlyVisibleChildIndex > -1) this._setCollapseState([...location, onlyVisibleChildIndex], update);
		}
		return result;
	}
	_setListNodeCollapseState(node, listIndex, revealed, update) {
		const result = this._setNodeCollapseState(node, update, false);
		if (!revealed || !node.visible || !result) return result;
		const previousRenderNodeCount = node.renderNodeCount;
		const toInsert = this.updateNodeAfterCollapseChange(node);
		const deleteCount = previousRenderNodeCount - (listIndex === -1 ? 0 : 1);
		this._onDidSpliceRenderedNodes.fire({
			start: listIndex + 1,
			deleteCount,
			elements: toInsert.slice(1)
		});
		return result;
	}
	_setNodeCollapseState(node, update, deep) {
		let result;
		if (node === this.root) result = false;
		else {
			if (isCollapsibleStateUpdate(update)) {
				result = node.collapsible !== update.collapsible;
				node.collapsible = update.collapsible;
			} else if (!node.collapsible) result = false;
			else {
				result = node.collapsed !== update.collapsed;
				node.collapsed = update.collapsed;
			}
			if (result) this._onDidChangeCollapseState.fire({
				node,
				deep
			});
		}
		if (!isCollapsibleStateUpdate(update) && update.recursive) for (const child of node.children) result = this._setNodeCollapseState(child, update, true) || result;
		return result;
	}
	expandTo(location) {
		this.eventBufferer.bufferEvents(() => {
			let node = this.getTreeNode(location);
			while (node.parent) {
				node = node.parent;
				location = location.slice(0, location.length - 1);
				if (node.collapsed) this._setCollapseState(location, {
					collapsed: false,
					recursive: false
				});
			}
		});
	}
	refilter() {
		const previousRenderNodeCount = this.root.renderNodeCount;
		const toInsert = this.updateNodeAfterFilterChange(this.root);
		this._onDidSpliceRenderedNodes.fire({
			start: 0,
			deleteCount: previousRenderNodeCount,
			elements: toInsert
		});
		this.refilterDelayer.cancel();
	}
	createTreeNode(treeElement, parent, parentVisibility, revealed, treeListElements, onDidCreateNode) {
		const node = {
			parent,
			element: treeElement.element,
			children: [],
			depth: parent.depth + 1,
			visibleChildrenCount: 0,
			visibleChildIndex: -1,
			collapsible: typeof treeElement.collapsible === "boolean" ? treeElement.collapsible : typeof treeElement.collapsed !== "undefined",
			collapsed: typeof treeElement.collapsed === "undefined" ? this.collapseByDefault : treeElement.collapsed,
			renderNodeCount: 1,
			visibility: 1,
			visible: true,
			filterData: void 0
		};
		const visibility = this._filterNode(node, parentVisibility);
		node.visibility = visibility;
		if (revealed) treeListElements.push(node);
		const childElements = treeElement.children || Iterable.empty();
		const childRevealed = revealed && visibility !== 0 && !node.collapsed;
		let visibleChildrenCount = 0;
		let renderNodeCount = 1;
		for (const el of childElements) {
			const child = this.createTreeNode(el, node, visibility, childRevealed, treeListElements, onDidCreateNode);
			node.children.push(child);
			renderNodeCount += child.renderNodeCount;
			if (child.visible) child.visibleChildIndex = visibleChildrenCount++;
		}
		if (!this.allowNonCollapsibleParents) node.collapsible = node.collapsible || node.children.length > 0;
		node.visibleChildrenCount = visibleChildrenCount;
		node.visible = visibility === 2 ? visibleChildrenCount > 0 : visibility === 1;
		if (!node.visible) {
			node.renderNodeCount = 0;
			if (revealed) treeListElements.pop();
		} else if (!node.collapsed) node.renderNodeCount = renderNodeCount;
		onDidCreateNode?.(node);
		return node;
	}
	updateNodeAfterCollapseChange(node) {
		const previousRenderNodeCount = node.renderNodeCount;
		const result = [];
		this._updateNodeAfterCollapseChange(node, result);
		this._updateAncestorsRenderNodeCount(node.parent, result.length - previousRenderNodeCount);
		return result;
	}
	_updateNodeAfterCollapseChange(node, result) {
		if (node.visible === false) return 0;
		result.push(node);
		node.renderNodeCount = 1;
		if (!node.collapsed) for (const child of node.children) node.renderNodeCount += this._updateNodeAfterCollapseChange(child, result);
		this._onDidChangeRenderNodeCount.fire(node);
		return node.renderNodeCount;
	}
	updateNodeAfterFilterChange(node) {
		const previousRenderNodeCount = node.renderNodeCount;
		const result = [];
		this._updateNodeAfterFilterChange(node, node.visible ? 1 : 0, result);
		this._updateAncestorsRenderNodeCount(node.parent, result.length - previousRenderNodeCount);
		return result;
	}
	_updateNodeAfterFilterChange(node, parentVisibility, result, revealed = true) {
		let visibility;
		if (node !== this.root) {
			visibility = this._filterNode(node, parentVisibility);
			if (visibility === 0) {
				node.visible = false;
				node.renderNodeCount = 0;
				return false;
			}
			if (revealed) result.push(node);
		}
		const resultStartLength = result.length;
		node.renderNodeCount = node === this.root ? 0 : 1;
		let hasVisibleDescendants = false;
		if (!node.collapsed || visibility !== 0) {
			let visibleChildIndex = 0;
			for (const child of node.children) {
				hasVisibleDescendants = this._updateNodeAfterFilterChange(child, visibility, result, revealed && !node.collapsed) || hasVisibleDescendants;
				if (child.visible) child.visibleChildIndex = visibleChildIndex++;
			}
			node.visibleChildrenCount = visibleChildIndex;
		} else node.visibleChildrenCount = 0;
		if (node !== this.root) {
			node.visible = visibility === 2 ? hasVisibleDescendants : visibility === 1;
			node.visibility = visibility;
		}
		if (!node.visible) {
			node.renderNodeCount = 0;
			if (revealed) result.pop();
		} else if (!node.collapsed) node.renderNodeCount += result.length - resultStartLength;
		this._onDidChangeRenderNodeCount.fire(node);
		return node.visible;
	}
	_updateAncestorsRenderNodeCount(node, diff) {
		if (diff === 0) return;
		while (node) {
			node.renderNodeCount += diff;
			this._onDidChangeRenderNodeCount.fire(node);
			node = node.parent;
		}
	}
	_filterNode(node, parentVisibility) {
		const result = this.filter ? this.filter.filter(node.element, parentVisibility) : 1;
		if (typeof result === "boolean") {
			node.filterData = void 0;
			return result ? 1 : 0;
		} else if (isFilterResult(result)) {
			node.filterData = result.data;
			return getVisibleState(result.visibility);
		} else {
			node.filterData = void 0;
			return getVisibleState(result);
		}
	}
	hasTreeNode(location, node = this.root) {
		if (!location || location.length === 0) return true;
		const [index, ...rest] = location;
		if (index < 0 || index > node.children.length) return false;
		return this.hasTreeNode(rest, node.children[index]);
	}
	getTreeNode(location, node = this.root) {
		if (!location || location.length === 0) return node;
		const [index, ...rest] = location;
		if (index < 0 || index > node.children.length) throw new TreeError(this.user, "Invalid tree location");
		return this.getTreeNode(rest, node.children[index]);
	}
	getTreeNodeWithListIndex(location) {
		if (location.length === 0) return {
			node: this.root,
			listIndex: -1,
			revealed: true,
			visible: false
		};
		const { parentNode, listIndex, revealed, visible } = this.getParentNodeWithListIndex(location);
		const index = location[location.length - 1];
		if (index < 0 || index > parentNode.children.length) throw new TreeError(this.user, "Invalid tree location");
		const node = parentNode.children[index];
		return {
			node,
			listIndex,
			revealed,
			visible: visible && node.visible
		};
	}
	getParentNodeWithListIndex(location, node = this.root, listIndex = 0, revealed = true, visible = true) {
		const [index, ...rest] = location;
		if (index < 0 || index > node.children.length) throw new TreeError(this.user, "Invalid tree location");
		for (let i = 0; i < index; i++) listIndex += node.children[i].renderNodeCount;
		revealed = revealed && !node.collapsed;
		visible = visible && node.visible;
		if (rest.length === 0) return {
			parentNode: node,
			listIndex,
			revealed,
			visible
		};
		return this.getParentNodeWithListIndex(rest, node.children[index], listIndex + 1, revealed, visible);
	}
	getNode(location = []) {
		return this.getTreeNode(location);
	}
	getNodeLocation(node) {
		const location = [];
		let indexTreeNode = node;
		while (indexTreeNode.parent) {
			location.push(indexTreeNode.parent.children.indexOf(indexTreeNode));
			indexTreeNode = indexTreeNode.parent;
		}
		return location.reverse();
	}
	getParentNodeLocation(location) {
		if (location.length === 0) return;
		else if (location.length === 1) return [];
		else return tail(location)[0];
	}
	getFirstElementChild(location) {
		const node = this.getTreeNode(location);
		if (node.children.length === 0) return;
		return node.children[0].element;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/tree/abstractTree.js
var TreeElementsDragAndDropData = class extends ElementsDragAndDropData {
	constructor(data) {
		super(data.elements.map((node) => node.element));
		this.data = data;
	}
};
function asTreeDragAndDropData(data) {
	if (data instanceof ElementsDragAndDropData) return new TreeElementsDragAndDropData(data);
	return data;
}
var TreeNodeListDragAndDrop = class {
	constructor(modelProvider, dnd) {
		this.modelProvider = modelProvider;
		this.dnd = dnd;
		this.autoExpandDisposable = Disposable.None;
		this.disposables = new DisposableStore();
	}
	getDragURI(node) {
		return this.dnd.getDragURI(node.element);
	}
	getDragLabel(nodes, originalEvent) {
		if (this.dnd.getDragLabel) return this.dnd.getDragLabel(nodes.map((node) => node.element), originalEvent);
	}
	onDragStart(data, originalEvent) {
		this.dnd.onDragStart?.(asTreeDragAndDropData(data), originalEvent);
	}
	onDragOver(data, targetNode, targetIndex, targetSector, originalEvent, raw = true) {
		const result = this.dnd.onDragOver(asTreeDragAndDropData(data), targetNode && targetNode.element, targetIndex, targetSector, originalEvent);
		const didChangeAutoExpandNode = this.autoExpandNode !== targetNode;
		if (didChangeAutoExpandNode) {
			this.autoExpandDisposable.dispose();
			this.autoExpandNode = targetNode;
		}
		if (typeof targetNode === "undefined") return result;
		if (didChangeAutoExpandNode && typeof result !== "boolean" && result.autoExpand) this.autoExpandDisposable = disposableTimeout(() => {
			const model = this.modelProvider();
			const ref = model.getNodeLocation(targetNode);
			if (model.isCollapsed(ref)) model.setCollapsed(ref, false);
			this.autoExpandNode = void 0;
		}, 500, this.disposables);
		if (typeof result === "boolean" || !result.accept || typeof result.bubble === "undefined" || result.feedback) {
			if (!raw) return {
				accept: typeof result === "boolean" ? result : result.accept,
				effect: typeof result === "boolean" ? void 0 : result.effect,
				feedback: [targetIndex]
			};
			return result;
		}
		if (result.bubble === 1) {
			const model = this.modelProvider();
			const ref = model.getNodeLocation(targetNode);
			const parentRef = model.getParentNodeLocation(ref);
			const parentNode = model.getNode(parentRef);
			const parentIndex = parentRef && model.getListIndex(parentRef);
			return this.onDragOver(data, parentNode, parentIndex, targetSector, originalEvent, false);
		}
		const model = this.modelProvider();
		const ref = model.getNodeLocation(targetNode);
		const start = model.getListIndex(ref);
		const length = model.getListRenderCount(ref);
		return {
			...result,
			feedback: range(start, start + length)
		};
	}
	drop(data, targetNode, targetIndex, targetSector, originalEvent) {
		this.autoExpandDisposable.dispose();
		this.autoExpandNode = void 0;
		this.dnd.drop(asTreeDragAndDropData(data), targetNode && targetNode.element, targetIndex, targetSector, originalEvent);
	}
	onDragEnd(originalEvent) {
		this.dnd.onDragEnd?.(originalEvent);
	}
	dispose() {
		this.disposables.dispose();
		this.dnd.dispose();
	}
};
function asListOptions(modelProvider, disposableStore, options) {
	return options && {
		...options,
		identityProvider: options.identityProvider && {
			getId(el) {
				return options.identityProvider.getId(el.element);
			},
			getGroupId: options.identityProvider.getGroupId ? (el) => {
				return options.identityProvider.getGroupId(el.element);
			} : void 0
		},
		dnd: options.dnd && disposableStore.add(new TreeNodeListDragAndDrop(modelProvider, options.dnd)),
		multipleSelectionController: options.multipleSelectionController && {
			isSelectionSingleChangeEvent(e) {
				return options.multipleSelectionController.isSelectionSingleChangeEvent({
					...e,
					element: e.element
				});
			},
			isSelectionRangeChangeEvent(e) {
				return options.multipleSelectionController.isSelectionRangeChangeEvent({
					...e,
					element: e.element
				});
			}
		},
		accessibilityProvider: options.accessibilityProvider && {
			...options.accessibilityProvider,
			getSetSize(node) {
				const model = modelProvider();
				const ref = model.getNodeLocation(node);
				const parentRef = model.getParentNodeLocation(ref);
				return model.getNode(parentRef).visibleChildrenCount;
			},
			getPosInSet(node) {
				return node.visibleChildIndex + 1;
			},
			isChecked: options.accessibilityProvider && options.accessibilityProvider.isChecked ? (node) => {
				return options.accessibilityProvider.isChecked(node.element);
			} : void 0,
			getRole: options.accessibilityProvider && options.accessibilityProvider.getRole ? (node) => {
				return options.accessibilityProvider.getRole(node.element);
			} : () => "treeitem",
			getAriaLabel(e) {
				return options.accessibilityProvider.getAriaLabel(e.element);
			},
			getWidgetAriaLabel() {
				return options.accessibilityProvider.getWidgetAriaLabel();
			},
			getWidgetRole: options.accessibilityProvider && options.accessibilityProvider.getWidgetRole ? () => options.accessibilityProvider.getWidgetRole() : () => "tree",
			getAriaLevel: options.accessibilityProvider && options.accessibilityProvider.getAriaLevel ? (node) => options.accessibilityProvider.getAriaLevel(node.element) : (node) => {
				return node.depth;
			},
			getActiveDescendantId: options.accessibilityProvider.getActiveDescendantId && ((node) => {
				return options.accessibilityProvider.getActiveDescendantId(node.element);
			})
		},
		keyboardNavigationLabelProvider: options.keyboardNavigationLabelProvider && {
			...options.keyboardNavigationLabelProvider,
			getKeyboardNavigationLabel(node) {
				return options.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(node.element);
			}
		}
	};
}
var ComposedTreeDelegate = class {
	constructor(delegate) {
		this.delegate = delegate;
	}
	getHeight(element) {
		return this.delegate.getHeight(element.element);
	}
	getTemplateId(element) {
		return this.delegate.getTemplateId(element.element);
	}
	hasDynamicHeight(element) {
		return !!this.delegate.hasDynamicHeight && this.delegate.hasDynamicHeight(element.element);
	}
	setDynamicHeight(element, height) {
		this.delegate.setDynamicHeight?.(element.element, height);
	}
};
var RenderIndentGuides;
(function(RenderIndentGuides) {
	RenderIndentGuides["None"] = "none";
	RenderIndentGuides["OnHover"] = "onHover";
	RenderIndentGuides["Always"] = "always";
})(RenderIndentGuides || (RenderIndentGuides = {}));
var EventCollection = class {
	get elements() {
		return this._elements;
	}
	constructor(onDidChange, _elements = []) {
		this._elements = _elements;
		this.disposables = new DisposableStore();
		this.onDidChange = Event.forEach(onDidChange, (elements) => this._elements = elements, this.disposables);
	}
	dispose() {
		this.disposables.dispose();
	}
};
var TreeRenderer = class TreeRenderer {
	static {
		this.DefaultIndent = 8;
	}
	constructor(renderer, model, onDidChangeCollapseState, activeNodes, renderedIndentGuides, options = {}) {
		this.renderer = renderer;
		this.model = model;
		this.activeNodes = activeNodes;
		this.renderedIndentGuides = renderedIndentGuides;
		this.renderedElements = /* @__PURE__ */ new Map();
		this.renderedNodes = /* @__PURE__ */ new Map();
		this.indent = TreeRenderer.DefaultIndent;
		this.defaultIndent = TreeRenderer.DefaultIndent;
		this.hideTwistiesOfChildlessElements = false;
		this.shouldRenderIndentGuides = false;
		this.activeIndentNodes = /* @__PURE__ */ new Set();
		this.indentGuidesDisposable = Disposable.None;
		this.disposables = new DisposableStore();
		this.templateId = renderer.templateId;
		this.updateOptions(options);
		Event.map(onDidChangeCollapseState, (e) => e.node)(this.onDidChangeNodeTwistieState, this, this.disposables);
		renderer.onDidChangeTwistieState?.(this.onDidChangeTwistieState, this, this.disposables);
	}
	updateOptions(options = {}) {
		if (typeof options.defaultIndent !== "undefined") this.defaultIndent = options.defaultIndent;
		if (typeof options.indent !== "undefined" || typeof options.defaultIndent !== "undefined") {
			const indent = typeof options.indent !== "undefined" ? clamp(options.indent, 0, 40) : this.indent;
			if (indent !== this.indent || typeof options.defaultIndent !== "undefined") {
				this.indent = indent;
				for (const [node, templateData] of this.renderedNodes) {
					templateData.indentSize = this.defaultIndent + (node.depth - 1) * this.indent;
					this.renderTreeElement(node, templateData);
				}
			}
		}
		if (typeof options.renderIndentGuides !== "undefined") {
			const shouldRenderIndentGuides = options.renderIndentGuides !== RenderIndentGuides.None;
			if (shouldRenderIndentGuides !== this.shouldRenderIndentGuides) {
				this.shouldRenderIndentGuides = shouldRenderIndentGuides;
				for (const [node, templateData] of this.renderedNodes) this._renderIndentGuides(node, templateData);
				this.indentGuidesDisposable.dispose();
				if (shouldRenderIndentGuides) {
					const disposables = new DisposableStore();
					this.activeNodes.onDidChange(this._onDidChangeActiveNodes, this, disposables);
					this.indentGuidesDisposable = disposables;
					this._onDidChangeActiveNodes(this.activeNodes.elements);
				}
			}
		}
		if (typeof options.hideTwistiesOfChildlessElements !== "undefined") this.hideTwistiesOfChildlessElements = options.hideTwistiesOfChildlessElements;
		if (typeof options.twistieAdditionalCssClass !== "undefined") this.twistieAdditionalCssClass = options.twistieAdditionalCssClass;
	}
	renderTemplate(container) {
		if (this.renderer.rowClassName) container.classList.add(this.renderer.rowClassName);
		const el = append$2(container, $$10(".monaco-tl-row"));
		const indent = append$2(el, $$10(".monaco-tl-indent"));
		const twistie = append$2(el, $$10(".monaco-tl-twistie"));
		const contents = append$2(el, $$10(".monaco-tl-contents"));
		const templateData = this.renderer.renderTemplate(contents);
		return {
			container,
			indent,
			twistie,
			indentGuidesDisposable: Disposable.None,
			indentSize: 0,
			templateData
		};
	}
	renderElement(node, index, templateData, details) {
		templateData.indentSize = this.defaultIndent + (node.depth - 1) * this.indent;
		this.renderedNodes.set(node, templateData);
		this.renderedElements.set(node.element, node);
		this.renderTreeElement(node, templateData);
		this.renderer.renderElement(node, index, templateData.templateData, {
			...details,
			indent: templateData.indentSize
		});
	}
	disposeElement(node, index, templateData, details) {
		templateData.indentGuidesDisposable.dispose();
		this.renderer.disposeElement?.(node, index, templateData.templateData, {
			...details,
			indent: templateData.indentSize
		});
		if (typeof details?.height === "number" && this.renderedNodes.get(node) === templateData) {
			this.renderedNodes.delete(node);
			if (this.renderedElements.get(node.element) === node) this.renderedElements.delete(node.element);
		}
	}
	disposeTemplate(templateData) {
		this.renderer.disposeTemplate(templateData.templateData);
	}
	onDidChangeTwistieState(element) {
		const node = this.renderedElements.get(element);
		if (!node) return;
		this.onDidChangeNodeTwistieState(node);
	}
	onDidChangeNodeTwistieState(node) {
		const templateData = this.renderedNodes.get(node);
		if (!templateData) return;
		this._onDidChangeActiveNodes(this.activeNodes.elements);
		this.renderTreeElement(node, templateData);
	}
	renderTreeElement(node, templateData) {
		templateData.twistie.className = templateData.twistie.classList.item(0);
		templateData.twistie.style.paddingLeft = `${templateData.indentSize}px`;
		templateData.indent.style.width = `${templateData.indentSize + this.indent - 16}px`;
		if (node.collapsible) templateData.container.setAttribute("aria-expanded", String(!node.collapsed));
		else templateData.container.removeAttribute("aria-expanded");
		templateData.twistie.classList.remove(...ThemeIcon.asClassNameArray(Codicon.treeItemExpanded));
		let twistieRendered = false;
		if (this.renderer.renderTwistie) twistieRendered = this.renderer.renderTwistie(node.element, templateData.twistie);
		if (node.collapsible && (!this.hideTwistiesOfChildlessElements || node.visibleChildrenCount > 0)) {
			if (!twistieRendered) templateData.twistie.classList.add(...ThemeIcon.asClassNameArray(Codicon.treeItemExpanded));
			templateData.twistie.classList.add("collapsible");
			templateData.twistie.classList.toggle("collapsed", node.collapsed);
		} else templateData.twistie.classList.remove("collapsible", "collapsed");
		if (this.twistieAdditionalCssClass) {
			const additionalClass = this.twistieAdditionalCssClass(node.element);
			if (additionalClass) templateData.twistie.classList.add(additionalClass);
		}
		this._renderIndentGuides(node, templateData);
	}
	_renderIndentGuides(node, templateData) {
		clearNode(templateData.indent);
		templateData.indentGuidesDisposable.dispose();
		if (!this.shouldRenderIndentGuides) return;
		const disposableStore = new DisposableStore();
		while (true) {
			const ref = this.model.getNodeLocation(node);
			const parentRef = this.model.getParentNodeLocation(ref);
			if (!parentRef) break;
			const parent = this.model.getNode(parentRef);
			const guide = $$10(".indent-guide", { style: `width: ${this.indent}px` });
			if (this.activeIndentNodes.has(parent)) guide.classList.add("active");
			if (templateData.indent.childElementCount === 0) templateData.indent.appendChild(guide);
			else templateData.indent.insertBefore(guide, templateData.indent.firstElementChild);
			this.renderedIndentGuides.add(parent, guide);
			disposableStore.add(toDisposable(() => this.renderedIndentGuides.delete(parent, guide)));
			node = parent;
		}
		templateData.indentGuidesDisposable = disposableStore;
	}
	_onDidChangeActiveNodes(nodes) {
		if (!this.shouldRenderIndentGuides) return;
		const set = /* @__PURE__ */ new Set();
		nodes.forEach((node) => {
			const ref = this.model.getNodeLocation(node);
			try {
				const parentRef = this.model.getParentNodeLocation(ref);
				if (node.collapsible && node.children.length > 0 && !node.collapsed) set.add(node);
				else if (parentRef) set.add(this.model.getNode(parentRef));
			} catch {}
		});
		this.activeIndentNodes.forEach((node) => {
			if (!set.has(node)) this.renderedIndentGuides.forEach(node, (line) => line.classList.remove("active"));
		});
		set.forEach((node) => {
			if (!this.activeIndentNodes.has(node)) this.renderedIndentGuides.forEach(node, (line) => line.classList.add("active"));
		});
		this.activeIndentNodes = set;
	}
	dispose() {
		this.renderedNodes.clear();
		this.renderedElements.clear();
		this.indentGuidesDisposable.dispose();
		dispose(this.disposables);
	}
};
function contiguousFuzzyScore(patternLower, wordLower) {
	const index = wordLower.toLowerCase().indexOf(patternLower);
	let score;
	if (index > -1) {
		score = [Number.MAX_SAFE_INTEGER, 0];
		for (let i = patternLower.length; i > 0; i--) score.push(index + i - 1);
	}
	return score;
}
var FindFilter = class {
	get totalCount() {
		return this._totalCount;
	}
	get matchCount() {
		return this._matchCount;
	}
	set findMatchType(type) {
		this._findMatchType = type;
	}
	get findMatchType() {
		return this._findMatchType;
	}
	set findMode(mode) {
		this._findMode = mode;
	}
	get findMode() {
		return this._findMode;
	}
	constructor(_keyboardNavigationLabelProvider, _filter, _defaultFindVisibility) {
		this._keyboardNavigationLabelProvider = _keyboardNavigationLabelProvider;
		this._filter = _filter;
		this._defaultFindVisibility = _defaultFindVisibility;
		this._totalCount = 0;
		this._matchCount = 0;
		this._findMatchType = TreeFindMatchType.Fuzzy;
		this._findMode = TreeFindMode.Highlight;
		this._pattern = "";
		this._lowercasePattern = "";
		this.disposables = new DisposableStore();
	}
	filter(element, parentVisibility) {
		let visibility = 1;
		if (this._filter) {
			const result = this._filter.filter(element, parentVisibility);
			if (typeof result === "boolean") visibility = result ? 1 : 0;
			else if (isFilterResult(result)) visibility = getVisibleState(result.visibility);
			else visibility = result;
			if (visibility === 0) return false;
		}
		this._totalCount++;
		if (!this._pattern) {
			this._matchCount++;
			return {
				data: FuzzyScore.Default,
				visibility
			};
		}
		const label = this._keyboardNavigationLabelProvider.getKeyboardNavigationLabel(element);
		const labels = Array.isArray(label) ? label : [label];
		for (const l of labels) {
			const labelStr = l && l.toString();
			if (typeof labelStr === "undefined") return {
				data: FuzzyScore.Default,
				visibility
			};
			let score;
			if (this._findMatchType === TreeFindMatchType.Contiguous) score = contiguousFuzzyScore(this._lowercasePattern, labelStr.toLowerCase());
			else score = fuzzyScore(this._pattern, this._lowercasePattern, 0, labelStr, labelStr.toLowerCase(), 0, {
				firstMatchCanBeWeak: true,
				boostFullMatch: true
			});
			if (score) {
				this._matchCount++;
				return labels.length === 1 ? {
					data: score,
					visibility
				} : {
					data: {
						label: labelStr,
						score
					},
					visibility
				};
			}
		}
		if (this._findMode === TreeFindMode.Filter) {
			if (typeof this._defaultFindVisibility === "number") return this._defaultFindVisibility;
			else if (this._defaultFindVisibility) return this._defaultFindVisibility(element);
			else return 2;
		} else return {
			data: FuzzyScore.Default,
			visibility
		};
	}
	reset() {
		this._totalCount = 0;
		this._matchCount = 0;
	}
	dispose() {
		dispose(this.disposables);
	}
};
var FindToggles = class {
	constructor(startStates) {
		this.stateMap = new Map(startStates.map((state) => [state.id, { ...state }]));
	}
	get(id) {
		const state = this.stateMap.get(id);
		if (state === void 0) throw new Error(`No state found for toggle id ${id}`);
		return state.isChecked;
	}
	set(id, value) {
		const state = this.stateMap.get(id);
		if (state === void 0) throw new Error(`No state found for toggle id ${id}`);
		if (state.isChecked === value) return false;
		state.isChecked = value;
		return true;
	}
};
var TreeFindMode;
(function(TreeFindMode) {
	TreeFindMode[TreeFindMode["Highlight"] = 0] = "Highlight";
	TreeFindMode[TreeFindMode["Filter"] = 1] = "Filter";
})(TreeFindMode || (TreeFindMode = {}));
var TreeFindMatchType;
(function(TreeFindMatchType) {
	TreeFindMatchType[TreeFindMatchType["Fuzzy"] = 0] = "Fuzzy";
	TreeFindMatchType[TreeFindMatchType["Contiguous"] = 1] = "Contiguous";
})(TreeFindMatchType || (TreeFindMatchType = {}));
var DefaultTreeToggles;
(function(DefaultTreeToggles) {
	DefaultTreeToggles["Mode"] = "mode";
	DefaultTreeToggles["MatchType"] = "matchType";
})(DefaultTreeToggles || (DefaultTreeToggles = {}));
var AbstractFindController = class {
	get pattern() {
		return this._pattern;
	}
	get placeholder() {
		return this._placeholder;
	}
	set placeholder(value) {
		this._placeholder = value;
		this.widget?.setPlaceHolder(value);
	}
	constructor(tree, filter, contextViewProvider, options = {}) {
		this.tree = tree;
		this.filter = filter;
		this.contextViewProvider = contextViewProvider;
		this.options = options;
		this._pattern = "";
		this._onDidChangePattern = new Emitter$1();
		this._onDidChangeOpenState = new Emitter$1();
		this.onDidChangeOpenState = this._onDidChangeOpenState.event;
		this.enabledDisposables = new DisposableStore();
		this.disposables = new DisposableStore();
		this.toggles = new FindToggles(options.toggles ?? []);
		this._placeholder = options.placeholder ?? localize(22, "Type to search");
	}
	isOpened() {
		return !!this.widget;
	}
	updateToggleState(id, checked) {
		this.toggles.set(id, checked);
		this.widget?.setToggleState(id, checked);
	}
	renderMessage(showNotFound, warningMessage) {
		if (showNotFound) {
			if (this.tree.options.showNotFoundMessage ?? true) this.widget?.showMessage({
				type: 2,
				content: warningMessage ?? localize(23, "No results found.")
			});
			else this.widget?.showMessage({ type: 2 });
		} else this.widget?.clearMessage();
	}
	alertResults(results) {
		if (!results) alert(localize(24, "No results"));
		else alert(localize(25, "{0} results", results));
	}
	dispose() {
		this._history = void 0;
		this._onDidChangePattern.dispose();
		this.enabledDisposables.dispose();
		this.disposables.dispose();
	}
};
var FindController = class extends AbstractFindController {
	get mode() {
		return this.toggles.get(DefaultTreeToggles.Mode) ? TreeFindMode.Filter : TreeFindMode.Highlight;
	}
	set mode(mode) {
		if (mode === this.mode) return;
		const isFilterMode = mode === TreeFindMode.Filter;
		this.updateToggleState(DefaultTreeToggles.Mode, isFilterMode);
		this.placeholder = isFilterMode ? localize(26, "Type to filter") : localize(27, "Type to search");
		this.filter.findMode = mode;
		this.tree.refilter();
		this.render();
		this._onDidChangeMode.fire(mode);
	}
	get matchType() {
		return this.toggles.get(DefaultTreeToggles.MatchType) ? TreeFindMatchType.Fuzzy : TreeFindMatchType.Contiguous;
	}
	set matchType(matchType) {
		if (matchType === this.matchType) return;
		this.updateToggleState(DefaultTreeToggles.MatchType, matchType === TreeFindMatchType.Fuzzy);
		this.filter.findMatchType = matchType;
		this.tree.refilter();
		this.render();
		this._onDidChangeMatchType.fire(matchType);
	}
	constructor(tree, filter, contextViewProvider, options = {}) {
		const defaultFindMode = options.defaultFindMode ?? TreeFindMode.Highlight;
		const defaultFindMatchType = options.defaultFindMatchType ?? TreeFindMatchType.Fuzzy;
		const toggleContributions = [{
			id: DefaultTreeToggles.Mode,
			icon: Codicon.listFilter,
			title: localize(28, "Filter"),
			isChecked: defaultFindMode === TreeFindMode.Filter
		}, {
			id: DefaultTreeToggles.MatchType,
			icon: Codicon.searchFuzzy,
			title: localize(29, "Fuzzy Match"),
			isChecked: defaultFindMatchType === TreeFindMatchType.Fuzzy
		}];
		filter.findMatchType = defaultFindMatchType;
		filter.findMode = defaultFindMode;
		super(tree, filter, contextViewProvider, {
			...options,
			toggles: toggleContributions
		});
		this.filter = filter;
		this._onDidChangeMode = new Emitter$1();
		this.onDidChangeMode = this._onDidChangeMode.event;
		this._onDidChangeMatchType = new Emitter$1();
		this.onDidChangeMatchType = this._onDidChangeMatchType.event;
		this.disposables.add(this.tree.onDidChangeModel(() => {
			if (!this.isOpened()) return;
			if (this.pattern.length !== 0) this.tree.refilter();
			this.render();
		}));
		this.disposables.add(this.tree.onWillRefilter(() => this.filter.reset()));
	}
	updateOptions(optionsUpdate = {}) {
		if (optionsUpdate.defaultFindMode !== void 0) this.mode = optionsUpdate.defaultFindMode;
		if (optionsUpdate.defaultFindMatchType !== void 0) this.matchType = optionsUpdate.defaultFindMatchType;
	}
	shouldAllowFocus(node) {
		if (!this.isOpened() || !this.pattern) return true;
		if (this.filter.totalCount > 0 && this.filter.matchCount <= 1) return true;
		return !FuzzyScore.isDefault(node.filterData);
	}
	render() {
		const showNotFound = this.filter.matchCount === 0 && this.filter.totalCount > 0 && this.pattern.length > 0;
		this.renderMessage(showNotFound);
		if (this.pattern.length) this.alertResults(this.filter.matchCount);
	}
};
function stickyScrollNodeStateEquals(node1, node2) {
	return node1.position === node2.position && stickyScrollNodeEquals(node1, node2);
}
function stickyScrollNodeEquals(node1, node2) {
	return node1.node.element === node2.node.element && node1.startIndex === node2.startIndex && node1.height === node2.height && node1.endIndex === node2.endIndex && node1.sourceNodeEnd === node2.sourceNodeEnd && node1.sourceNodePartiallyVisible === node2.sourceNodePartiallyVisible && node1.hasExplicitHeight === node2.hasExplicitHeight;
}
var StickyScrollState = class {
	constructor(stickyNodes = []) {
		this.stickyNodes = stickyNodes;
	}
	get count() {
		return this.stickyNodes.length;
	}
	equal(state) {
		return equals$1(this.stickyNodes, state.stickyNodes, stickyScrollNodeStateEquals);
	}
	contains(element) {
		return this.stickyNodes.some((node) => node.node.element === element.element);
	}
	lastNodePartiallyVisible() {
		if (this.count === 0) return false;
		const lastStickyNode = this.stickyNodes[this.count - 1];
		if (this.count === 1) return lastStickyNode.position !== 0;
		const secondLastStickyNode = this.stickyNodes[this.count - 2];
		return secondLastStickyNode.position + secondLastStickyNode.height !== lastStickyNode.position;
	}
	animationStateChanged(previousState) {
		if (!equals$1(this.stickyNodes, previousState.stickyNodes, stickyScrollNodeEquals)) return false;
		if (this.count === 0) return false;
		const lastStickyNode = this.stickyNodes[this.count - 1];
		const previousLastStickyNode = previousState.stickyNodes[previousState.count - 1];
		return lastStickyNode.position !== previousLastStickyNode.position;
	}
};
var DefaultStickyScrollDelegate = class {
	constrainStickyScrollNodes(stickyNodes, stickyScrollMaxItemCount, maxWidgetHeight) {
		for (let i = 0; i < stickyNodes.length; i++) {
			const stickyNode = stickyNodes[i];
			if (stickyNode.position + stickyNode.height > maxWidgetHeight || i >= stickyScrollMaxItemCount) return stickyNodes.slice(0, i);
		}
		return stickyNodes;
	}
};
var StickyScrollController = class extends Disposable {
	get domNode() {
		return this._widget.domNode;
	}
	constructor(tree, model, view, renderers, treeDelegate, options = {}) {
		super();
		this.tree = tree;
		this.model = model;
		this.view = view;
		this.treeDelegate = treeDelegate;
		this.maxWidgetViewRatio = .4;
		const stickyScrollOptions = this.validateStickySettings(options);
		this.stickyScrollMaxItemCount = stickyScrollOptions.stickyScrollMaxItemCount;
		this.stickyScrollDelegate = options.stickyScrollDelegate ?? new DefaultStickyScrollDelegate();
		this.paddingTop = options.paddingTop ?? 0;
		this._widget = this._register(new StickyScrollWidget(view.getScrollableElement(), view, tree, renderers, treeDelegate, options.accessibilityProvider));
		this.onDidChangeHasFocus = this._widget.onDidChangeHasFocus;
		this.onContextMenu = this._widget.onContextMenu;
		this._register(view.onDidScroll(() => this.update()));
		this._register(view.onDidChangeContentHeight(() => this.update()));
		this._register(tree.onDidChangeCollapseState(() => this.update()));
		this._register(this._widget.onDidChangeHeight((heightChanges) => {
			for (const { index, height } of heightChanges) this.view.updateElementHeight(index, height);
		}));
		this._register(model.onDidSpliceRenderedNodes((e) => {
			const state = this._widget.state;
			if (!state) return;
			if (e.deleteCount > 0 && state.stickyNodes.some((stickyNode) => !this.model.has(this.model.getNodeLocation(stickyNode.node)))) {
				this.update();
				return;
			}
			if (state.stickyNodes.some((stickyNode) => {
				const listIndex = this.model.getListIndex(this.model.getNodeLocation(stickyNode.node));
				return listIndex >= e.start && listIndex < e.start + e.deleteCount && state.contains(stickyNode.node);
			})) this._widget.rerender();
		}));
		this.update();
	}
	get height() {
		return this._widget.height;
	}
	getNodeAtHeight(height) {
		let index;
		if (height === 0) index = this.view.firstVisibleIndex;
		else index = this.view.indexAt(height + this.view.scrollTop);
		if (index < 0 || index >= this.view.length) return;
		return this.view.element(index);
	}
	update() {
		const firstVisibleNode = this.getNodeAtHeight(this.paddingTop);
		if (!firstVisibleNode || this.tree.scrollTop <= this.paddingTop || this.view.renderHeight === 0) {
			this._widget.setState(void 0);
			return;
		}
		const stickyState = this.findStickyState(firstVisibleNode);
		this._widget.setState(stickyState);
	}
	findStickyState(firstVisibleNode) {
		const stickyNodes = [];
		let firstVisibleNodeUnderWidget = firstVisibleNode;
		let stickyNodesHeight = 0;
		let nextStickyNode = this.getNextStickyNode(firstVisibleNodeUnderWidget, void 0, stickyNodesHeight);
		while (nextStickyNode) {
			stickyNodes.push(nextStickyNode);
			stickyNodesHeight += nextStickyNode.height;
			if (stickyNodes.length <= this.stickyScrollMaxItemCount) {
				firstVisibleNodeUnderWidget = this.getNextVisibleNode(nextStickyNode);
				if (!firstVisibleNodeUnderWidget) break;
			}
			nextStickyNode = this.getNextStickyNode(firstVisibleNodeUnderWidget, nextStickyNode.node, stickyNodesHeight);
		}
		const contrainedStickyNodes = this.constrainStickyNodes(stickyNodes);
		return contrainedStickyNodes.length ? new StickyScrollState(contrainedStickyNodes) : void 0;
	}
	getNextVisibleNode(previousStickyNode) {
		return this.getNodeAtHeight(previousStickyNode.position + previousStickyNode.height);
	}
	getNextStickyNode(firstVisibleNodeUnderWidget, previousStickyNode, stickyNodesHeight) {
		const nextStickyNode = this.getAncestorUnderPrevious(firstVisibleNodeUnderWidget, previousStickyNode);
		if (!nextStickyNode) return;
		if (nextStickyNode === firstVisibleNodeUnderWidget && !this.nodeIsUncollapsedParent(firstVisibleNodeUnderWidget)) return;
		const sourceRange = this.getStickyScrollNodeSourceRange(nextStickyNode);
		if (!sourceRange || !Number.isFinite(sourceRange.start) || !Number.isFinite(sourceRange.end) || sourceRange.end <= sourceRange.start) return;
		const sourceNodeTop = this.view.getElementTop(this.getNodeIndex(nextStickyNode));
		const stickyViewportBottom = this.view.scrollTop + stickyNodesHeight;
		if (stickyViewportBottom <= sourceNodeTop + sourceRange.start) return;
		const height = this.getStickyScrollNodeHeight(sourceRange, stickyNodesHeight);
		const sourceNodePartiallyVisible = stickyViewportBottom + height < sourceNodeTop + sourceRange.end;
		return this.createStickyScrollNode(nextStickyNode, stickyNodesHeight, height, sourceRange.end, sourceNodePartiallyVisible, sourceRange.stickyNodeHeight !== void 0);
	}
	getStickyScrollNodeSourceRange(node) {
		const defaultRange = {
			start: 0,
			end: this.getNodeHeight(node)
		};
		const sourceRangeProvider = this.tree.options.stickyScrollNodeSourceRangeProvider;
		if (sourceRangeProvider) return sourceRangeProvider(node.element, defaultRange);
		return defaultRange;
	}
	getStickyScrollNodeHeight(sourceRange, currentStickyNodesHeight) {
		const height = this.clampNodeHeight(sourceRange.stickyNodeHeight ?? sourceRange.end - sourceRange.start);
		if (!sourceRange.estimated) return height;
		const availableHeight = Math.max(1, this.view.renderHeight * this.maxWidgetViewRatio - currentStickyNodesHeight);
		return Math.min(height, availableHeight);
	}
	getNodeHeight(node) {
		const nodeLocation = this.model.getNodeLocation(node);
		const index = this.model.getListIndex(nodeLocation);
		if (index >= 0) return this.view.getElementHeight(index);
		return this.treeDelegate.getHeight(node);
	}
	clampNodeHeight(height) {
		const max = this.tree.options.stickyScrollMaxNodeHeight;
		return max !== void 0 ? Math.min(height, max) : height;
	}
	createStickyScrollNode(node, currentStickyNodesHeight, height, sourceNodeEnd, sourceNodePartiallyVisible, hasExplicitHeight) {
		const { startIndex, endIndex } = this.getNodeRange(node);
		return {
			node,
			position: this.calculateStickyNodePosition(endIndex, currentStickyNodesHeight, height),
			height,
			startIndex,
			endIndex,
			sourceNodeEnd,
			sourceNodePartiallyVisible,
			hasExplicitHeight
		};
	}
	getAncestorUnderPrevious(node, previousAncestor = void 0) {
		let currentAncestor = node;
		let parentOfcurrentAncestor = this.getParentNode(currentAncestor);
		while (parentOfcurrentAncestor) {
			if (parentOfcurrentAncestor === previousAncestor) return currentAncestor;
			currentAncestor = parentOfcurrentAncestor;
			parentOfcurrentAncestor = this.getParentNode(currentAncestor);
		}
		if (previousAncestor === void 0) return currentAncestor;
	}
	calculateStickyNodePosition(lastDescendantIndex, stickyRowPositionTop, stickyNodeHeight) {
		const lastChildHeight = this.view.getElementHeight(lastDescendantIndex);
		const bottomOfLastChild = this.view.getElementTop(lastDescendantIndex) + lastChildHeight - this.view.scrollTop;
		if (stickyRowPositionTop + stickyNodeHeight > bottomOfLastChild && stickyRowPositionTop <= bottomOfLastChild) return bottomOfLastChild - stickyNodeHeight;
		return stickyRowPositionTop;
	}
	constrainStickyNodes(stickyNodes) {
		if (stickyNodes.length === 0) return [];
		const maximumStickyWidgetHeight = this.view.renderHeight * this.maxWidgetViewRatio;
		const lastStickyNode = stickyNodes[stickyNodes.length - 1];
		if (stickyNodes.length <= this.stickyScrollMaxItemCount && lastStickyNode.position + lastStickyNode.height <= maximumStickyWidgetHeight) return stickyNodes;
		const constrainedStickyNodes = this.stickyScrollDelegate.constrainStickyScrollNodes(stickyNodes, this.stickyScrollMaxItemCount, maximumStickyWidgetHeight);
		if (!constrainedStickyNodes.length) return [];
		const lastConstrainedStickyNode = constrainedStickyNodes[constrainedStickyNodes.length - 1];
		if (constrainedStickyNodes.length > this.stickyScrollMaxItemCount || lastConstrainedStickyNode.position + lastConstrainedStickyNode.height > maximumStickyWidgetHeight) throw new Error("stickyScrollDelegate violates constraints");
		return constrainedStickyNodes;
	}
	getParentNode(node) {
		const nodeLocation = this.model.getNodeLocation(node);
		const parentLocation = this.model.getParentNodeLocation(nodeLocation);
		return parentLocation ? this.model.getNode(parentLocation) : void 0;
	}
	nodeIsUncollapsedParent(node) {
		const nodeLocation = this.model.getNodeLocation(node);
		return this.model.getListRenderCount(nodeLocation) > 1;
	}
	getNodeIndex(node) {
		const nodeLocation = this.model.getNodeLocation(node);
		return this.model.getListIndex(nodeLocation);
	}
	getNodeRange(node) {
		const nodeLocation = this.model.getNodeLocation(node);
		const startIndex = this.model.getListIndex(nodeLocation);
		if (startIndex < 0) throw new Error("Node not found in tree");
		return {
			startIndex,
			endIndex: startIndex + this.model.getListRenderCount(nodeLocation) - 1
		};
	}
	nodePositionTopBelowWidget(node) {
		const ancestors = [];
		let currentAncestor = this.getParentNode(node);
		while (currentAncestor) {
			ancestors.push(currentAncestor);
			currentAncestor = this.getParentNode(currentAncestor);
		}
		let widgetHeight = 0;
		for (let i = 0; i < ancestors.length && i < this.stickyScrollMaxItemCount; i++) {
			const sourceRange = this.getStickyScrollNodeSourceRange(ancestors[i]);
			if (sourceRange) widgetHeight += this.getStickyScrollNodeHeight(sourceRange, widgetHeight);
		}
		return widgetHeight;
	}
	domFocus() {
		this._widget.domFocus();
	}
	focusedLast() {
		return this._widget.focusedLast();
	}
	updateOptions(optionsUpdate = {}) {
		if (optionsUpdate.paddingTop !== void 0) this.paddingTop = optionsUpdate.paddingTop;
		if (optionsUpdate.stickyScrollMaxItemCount !== void 0) {
			const validatedOptions = this.validateStickySettings(optionsUpdate);
			if (this.stickyScrollMaxItemCount !== validatedOptions.stickyScrollMaxItemCount) {
				this.stickyScrollMaxItemCount = validatedOptions.stickyScrollMaxItemCount;
				this.update();
			}
		}
	}
	validateStickySettings(options) {
		let stickyScrollMaxItemCount = 7;
		if (typeof options.stickyScrollMaxItemCount === "number") stickyScrollMaxItemCount = Math.max(options.stickyScrollMaxItemCount, 1);
		return { stickyScrollMaxItemCount };
	}
};
var StickyScrollWidget = class {
	get state() {
		return this._previousState;
	}
	constructor(container, view, tree, treeRenderers, treeDelegate, accessibilityProvider) {
		this.view = view;
		this.tree = tree;
		this.treeRenderers = treeRenderers;
		this.treeDelegate = treeDelegate;
		this.accessibilityProvider = accessibilityProvider;
		this._previousElements = [];
		this._previousElementHeights = [];
		this._previousStateDisposables = new DisposableStore();
		this._onDidChangeHeight = new Emitter$1();
		this.onDidChangeHeight = this._onDidChangeHeight.event;
		this._rootDomNode = $$10(".monaco-tree-sticky-container.empty");
		container.appendChild(this._rootDomNode);
		const shadow = $$10(".monaco-tree-sticky-container-shadow");
		this._rootDomNode.appendChild(shadow);
		this.stickyScrollFocus = new StickyScrollFocus(this._rootDomNode, view);
		this.onDidChangeHasFocus = this.stickyScrollFocus.onDidChangeHasFocus;
		this.onContextMenu = this.stickyScrollFocus.onContextMenu;
	}
	get height() {
		if (!this._previousState) return 0;
		return this.getRootHeight(this._previousState);
	}
	get domNode() {
		return this._rootDomNode;
	}
	setState(state) {
		const wasVisible = !!this._previousState && this._previousState.count > 0;
		const isVisible = !!state && state.count > 0;
		if (!wasVisible && !isVisible || wasVisible && isVisible && this._previousState.equal(state)) {
			this.updateSourceNodeVisibility(state);
			return;
		}
		if (wasVisible !== isVisible) this.setVisible(isVisible);
		if (!isVisible) {
			this.updateSourceNodeVisibility(void 0);
			this._previousState = void 0;
			this._previousElements = [];
			this._previousElementHeights = [];
			this._previousStateDisposables.clear();
			return;
		}
		const lastStickyNode = state.stickyNodes[state.count - 1];
		if (this._previousState && state.animationStateChanged(this._previousState)) this._previousElements[this._previousState.count - 1].style.top = `${lastStickyNode.position}px`;
		else this.renderState(state);
		this._previousState = state;
		this.updateSourceNodeVisibility(state);
		this.updateRootHeight(state);
	}
	updateSourceNodeVisibility(state) {
		let sourceNodePartiallyVisible = false;
		for (let i = 0; state && i < state.count; i++) {
			const stickyNode = state.stickyNodes[i];
			const stickyElement = this._previousElements[i];
			let nodePartiallyVisible = stickyNode.sourceNodePartiallyVisible;
			if (stickyElement) {
				const sourceNodeBottom = this.view.getElementTop(stickyNode.startIndex) + stickyNode.sourceNodeEnd;
				const stickyElementHeight = this.getRenderedNodeHeight(stickyNode, i);
				nodePartiallyVisible = this.view.scrollTop + stickyNode.position + stickyElementHeight < sourceNodeBottom;
			}
			stickyElement?.classList.toggle("source-node-partially-visible", nodePartiallyVisible);
			sourceNodePartiallyVisible ||= nodePartiallyVisible;
		}
		this._rootDomNode.classList.toggle("source-node-partially-visible", sourceNodePartiallyVisible);
	}
	renderState(state) {
		this._previousStateDisposables.clear();
		const elements = Array(state.count);
		for (let stickyIndex = state.count - 1; stickyIndex >= 0; stickyIndex--) {
			const stickyNode = state.stickyNodes[stickyIndex];
			const { element, disposable } = this.createElement(stickyNode, stickyIndex, state.count);
			elements[stickyIndex] = element;
			this._rootDomNode.appendChild(element);
			this._previousStateDisposables.add(disposable);
		}
		this.stickyScrollFocus.updateElements(elements, state);
		this._previousElements = elements;
		this._previousElementHeights = this.probeDynamicHeights(state, elements);
	}
	rerender() {
		if (this._previousState) {
			this.renderState(this._previousState);
			this.updateSourceNodeVisibility(this._previousState);
			this.updateRootHeight(this._previousState);
		}
	}
	updateRootHeight(state) {
		this._rootDomNode.style.height = `${this.getRootHeight(state)}px`;
	}
	getRootHeight(state) {
		const lastStickyNode = state.stickyNodes[state.count - 1];
		const lastStickyElementHeight = this.getRenderedNodeHeight(lastStickyNode, state.count - 1);
		return Math.max(0, lastStickyNode.position + lastStickyElementHeight);
	}
	getRenderedNodeHeight(stickyNode, index) {
		return Math.min(this._previousElementHeights[index] ?? stickyNode.height, stickyNode.height);
	}
	probeDynamicHeights(state, elements) {
		const heightChanges = [];
		const elementHeights = state.stickyNodes.map((node) => node.height);
		for (let i = 0; i < state.count; i++) {
			const stickyNode = state.stickyNodes[i];
			if (!this.treeDelegate.hasDynamicHeight || !this.treeDelegate.hasDynamicHeight(stickyNode.node)) {
				const measuredHeight = elements[i].offsetHeight;
				if (measuredHeight > 0) elementHeights[i] = measuredHeight;
				continue;
			}
			const element = elements[i];
			const previousHeight = element.style.height;
			element.style.height = "";
			const measuredHeight = element.offsetHeight;
			if (measuredHeight <= 0) {
				element.style.height = previousHeight;
				continue;
			}
			const maxNodeHeight = this.tree.options.stickyScrollMaxNodeHeight;
			const clampedMeasuredHeight = maxNodeHeight !== void 0 ? Math.min(measuredHeight, maxNodeHeight) : measuredHeight;
			const renderedHeight = stickyNode.hasExplicitHeight ? stickyNode.height : clampedMeasuredHeight;
			elementHeights[i] = renderedHeight;
			if (this.tree.options.setRowHeight !== false) element.style.height = `${renderedHeight}px`;
			if (this.tree.options.setRowLineHeight !== false) element.style.lineHeight = `${renderedHeight}px`;
			if (!stickyNode.hasExplicitHeight && clampedMeasuredHeight > this.view.getElementHeight(stickyNode.startIndex)) heightChanges.push({
				index: stickyNode.startIndex,
				height: clampedMeasuredHeight
			});
		}
		if (heightChanges.length > 0) this._onDidChangeHeight.fire(heightChanges);
		return elementHeights;
	}
	createElement(stickyNode, stickyIndex, stickyNodesTotal) {
		const nodeIndex = stickyNode.startIndex;
		const stickyElement = document.createElement("div");
		stickyElement.style.top = `${stickyNode.position}px`;
		const maxNodeHeight = this.tree.options.stickyScrollMaxNodeHeight;
		const clampedHeight = maxNodeHeight !== void 0 ? Math.min(stickyNode.height, maxNodeHeight) : stickyNode.height;
		if (this.tree.options.setRowHeight !== false) stickyElement.style.height = `${clampedHeight}px`;
		if (this.tree.options.setRowLineHeight !== false) stickyElement.style.lineHeight = `${clampedHeight}px`;
		stickyElement.style.overflow = "hidden";
		stickyElement.classList.add("monaco-tree-sticky-row");
		stickyElement.classList.add("monaco-list-row");
		stickyElement.classList.toggle("source-node-partially-visible", stickyNode.sourceNodePartiallyVisible);
		stickyElement.setAttribute("data-index", `${nodeIndex}`);
		stickyElement.setAttribute("data-parity", nodeIndex % 2 === 0 ? "even" : "odd");
		stickyElement.setAttribute("id", this.view.getElementID(nodeIndex));
		const accessibilityDisposable = this.setAccessibilityAttributes(stickyElement, stickyNode.node.element, stickyIndex, stickyNodesTotal);
		const nodeTemplateId = this.treeDelegate.getTemplateId(stickyNode.node);
		const renderer = this.treeRenderers.find((renderer) => renderer.templateId === nodeTemplateId);
		if (!renderer) throw new Error(`No renderer found for template id ${nodeTemplateId}`);
		let nodeCopy = stickyNode.node;
		if (nodeCopy === this.tree.getNode(this.tree.getNodeLocation(stickyNode.node))) nodeCopy = new Proxy(stickyNode.node, {});
		const templateData = renderer.renderTemplate(stickyElement);
		renderer.renderElement(nodeCopy, stickyNode.startIndex, templateData, { height: stickyNode.height });
		return {
			element: stickyElement,
			disposable: toDisposable(() => {
				accessibilityDisposable.dispose();
				renderer.disposeElement(nodeCopy, stickyNode.startIndex, templateData, { height: stickyNode.height });
				renderer.disposeTemplate(templateData);
				stickyElement.remove();
			})
		};
	}
	setAccessibilityAttributes(container, element, stickyIndex, stickyNodesTotal) {
		if (!this.accessibilityProvider) return Disposable.None;
		if (this.accessibilityProvider.getSetSize) container.setAttribute("aria-setsize", String(this.accessibilityProvider.getSetSize(element, stickyIndex, stickyNodesTotal)));
		if (this.accessibilityProvider.getPosInSet) container.setAttribute("aria-posinset", String(this.accessibilityProvider.getPosInSet(element, stickyIndex)));
		if (this.accessibilityProvider.getRole) container.setAttribute("role", this.accessibilityProvider.getRole(element) ?? "treeitem");
		const ariaLabel = this.accessibilityProvider.getAriaLabel(element);
		const observable = ariaLabel && typeof ariaLabel !== "string" ? ariaLabel : constObservable(ariaLabel);
		const result = autorun((reader) => {
			const value = reader.readObservable(observable);
			if (value) container.setAttribute("aria-label", value);
			else container.removeAttribute("aria-label");
		});
		if (typeof ariaLabel === "string");
		else if (ariaLabel) container.setAttribute("aria-label", ariaLabel.get());
		const ariaLevel = this.accessibilityProvider.getAriaLevel && this.accessibilityProvider.getAriaLevel(element);
		if (typeof ariaLevel === "number") container.setAttribute("aria-level", `${ariaLevel}`);
		return result;
	}
	setVisible(visible) {
		this._rootDomNode.classList.toggle("empty", !visible);
		if (!visible) this.stickyScrollFocus.updateElements([], void 0);
	}
	domFocus() {
		this.stickyScrollFocus.domFocus();
	}
	focusedLast() {
		return this.stickyScrollFocus.focusedLast();
	}
	dispose() {
		this._onDidChangeHeight.dispose();
		this.stickyScrollFocus.dispose();
		this._previousStateDisposables.dispose();
		this._rootDomNode.remove();
	}
};
var StickyScrollFocus = class extends Disposable {
	get domHasFocus() {
		return this._domHasFocus;
	}
	set domHasFocus(hasFocus) {
		if (hasFocus !== this._domHasFocus) {
			this._onDidChangeHasFocus.fire(hasFocus);
			this._domHasFocus = hasFocus;
		}
	}
	constructor(container, view) {
		super();
		this.container = container;
		this.view = view;
		this.focusedIndex = -1;
		this.elements = [];
		this._onDidChangeHasFocus = this._register(new Emitter$1());
		this.onDidChangeHasFocus = this._onDidChangeHasFocus.event;
		this._onContextMenu = this._register(new Emitter$1());
		this.onContextMenu = this._onContextMenu.event;
		this._domHasFocus = false;
		this._register(addDisposableListener(this.container, "focus", () => this.onFocus()));
		this._register(addDisposableListener(this.container, "blur", () => this.onBlur()));
		this._register(this.view.onDidFocus(() => this.toggleStickyScrollFocused(false)));
		this._register(this.view.onKeyDown((e) => this.onKeyDown(e)));
		this._register(this.view.onMouseDown((e) => this.onMouseDown(e)));
		this._register(this.view.onContextMenu((e) => this.handleContextMenu(e)));
	}
	handleContextMenu(e) {
		const target = e.browserEvent.target;
		if (!isStickyScrollContainer(target) && !isStickyScrollElement(target)) {
			if (this.focusedLast()) this.view.domFocus();
			return;
		}
		if (!isKeyboardEvent(e.browserEvent)) {
			if (!this.state) throw new Error("Context menu should not be triggered when state is undefined");
			const stickyIndex = this.state.stickyNodes.findIndex((stickyNode) => stickyNode.node.element === e.element?.element);
			if (stickyIndex === -1) throw new Error("Context menu should not be triggered when element is not in sticky scroll widget");
			this.container.focus();
			this.setFocus(stickyIndex);
			return;
		}
		if (!this.state || this.focusedIndex < 0) throw new Error("Context menu key should not be triggered when focus is not in sticky scroll widget");
		const element = this.state.stickyNodes[this.focusedIndex].node.element;
		const anchor = this.elements[this.focusedIndex];
		this._onContextMenu.fire({
			element,
			anchor,
			browserEvent: e.browserEvent,
			isStickyScroll: true
		});
	}
	onKeyDown(e) {
		if (this.domHasFocus && this.state) {
			if (e.key === "ArrowUp") {
				this.setFocusedElement(Math.max(0, this.focusedIndex - 1));
				e.preventDefault();
				e.stopPropagation();
			} else if (e.key === "ArrowDown" || e.key === "ArrowRight") {
				if (this.focusedIndex >= this.state.count - 1) {
					const nodeIndexToFocus = this.state.stickyNodes[this.state.count - 1].startIndex + 1;
					this.view.domFocus();
					this.view.setFocus([nodeIndexToFocus]);
					this.scrollNodeUnderWidget(nodeIndexToFocus, this.state);
				} else this.setFocusedElement(this.focusedIndex + 1);
				e.preventDefault();
				e.stopPropagation();
			}
		}
	}
	onMouseDown(e) {
		const target = e.browserEvent.target;
		if (!isStickyScrollContainer(target) && !isStickyScrollElement(target)) return;
		e.browserEvent.preventDefault();
		e.browserEvent.stopPropagation();
	}
	updateElements(elements, state) {
		if (state && state.count === 0) throw new Error("Sticky scroll state must be undefined when there are no sticky nodes");
		if (state && state.count !== elements.length) throw new Error("Sticky scroll focus received illigel state");
		const previousIndex = this.focusedIndex;
		this.removeFocus();
		this.elements = elements;
		this.state = state;
		if (state) {
			const newFocusedIndex = clamp(previousIndex, 0, state.count - 1);
			this.setFocus(newFocusedIndex);
		} else if (this.domHasFocus) this.view.domFocus();
		this.container.tabIndex = state ? 0 : -1;
	}
	setFocusedElement(stickyIndex) {
		const state = this.state;
		if (!state) throw new Error("Cannot set focus when state is undefined");
		this.setFocus(stickyIndex);
		if (stickyIndex < state.count - 1) return;
		if (state.lastNodePartiallyVisible()) {
			const lastStickyNode = state.stickyNodes[stickyIndex];
			this.scrollNodeUnderWidget(lastStickyNode.endIndex + 1, state);
		}
	}
	scrollNodeUnderWidget(nodeIndex, state) {
		const lastStickyNode = state.stickyNodes[state.count - 1];
		const secondLastStickyNode = state.count > 1 ? state.stickyNodes[state.count - 2] : void 0;
		const elementScrollTop = this.view.getElementTop(nodeIndex);
		const elementTargetViewTop = secondLastStickyNode ? secondLastStickyNode.position + secondLastStickyNode.height + lastStickyNode.height : lastStickyNode.height;
		this.view.scrollTop = elementScrollTop - elementTargetViewTop;
	}
	domFocus() {
		if (!this.state) throw new Error("Cannot focus when state is undefined");
		this.container.focus();
	}
	focusedLast() {
		if (!this.state) return false;
		return this.view.getHTMLElement().classList.contains("sticky-scroll-focused");
	}
	removeFocus() {
		if (this.focusedIndex === -1) return;
		this.toggleElementFocus(this.elements[this.focusedIndex], false);
		this.focusedIndex = -1;
	}
	setFocus(newFocusIndex) {
		if (0 > newFocusIndex) throw new Error("addFocus() can not remove focus");
		if (!this.state && newFocusIndex >= 0) throw new Error("Cannot set focus index when state is undefined");
		if (this.state && newFocusIndex >= this.state.count) throw new Error("Cannot set focus index to an index that does not exist");
		const oldIndex = this.focusedIndex;
		if (oldIndex >= 0) this.toggleElementFocus(this.elements[oldIndex], false);
		if (newFocusIndex >= 0) this.toggleElementFocus(this.elements[newFocusIndex], true);
		this.focusedIndex = newFocusIndex;
	}
	toggleElementFocus(element, focused) {
		this.toggleElementActiveFocus(element, focused && this.domHasFocus);
		this.toggleElementPassiveFocus(element, focused);
	}
	toggleCurrentElementActiveFocus(focused) {
		if (this.focusedIndex === -1) return;
		this.toggleElementActiveFocus(this.elements[this.focusedIndex], focused);
	}
	toggleElementActiveFocus(element, focused) {
		element.classList.toggle("focused", focused);
	}
	toggleElementPassiveFocus(element, focused) {
		element.classList.toggle("passive-focused", focused);
	}
	toggleStickyScrollFocused(focused) {
		this.view.getHTMLElement().classList.toggle("sticky-scroll-focused", focused);
	}
	onFocus() {
		if (!this.state || this.elements.length === 0) throw new Error("Cannot focus when state is undefined or elements are empty");
		this.domHasFocus = true;
		this.toggleStickyScrollFocused(true);
		this.toggleCurrentElementActiveFocus(true);
		if (this.focusedIndex === -1) this.setFocus(0);
	}
	onBlur() {
		this.domHasFocus = false;
		this.toggleCurrentElementActiveFocus(false);
	}
	dispose() {
		this.toggleStickyScrollFocused(false);
		this._onDidChangeHasFocus.fire(false);
		super.dispose();
	}
};
function asTreeMouseEvent$1(event) {
	let target = TreeMouseEventTarget.Unknown;
	if (hasParentWithClass(event.browserEvent.target, "monaco-tl-twistie", "monaco-tl-row")) target = TreeMouseEventTarget.Twistie;
	else if (hasParentWithClass(event.browserEvent.target, "monaco-tl-contents", "monaco-tl-row")) target = TreeMouseEventTarget.Element;
	else if (hasParentWithClass(event.browserEvent.target, "monaco-tree-type-filter", "monaco-list")) target = TreeMouseEventTarget.Filter;
	return {
		browserEvent: event.browserEvent,
		element: event.element ? event.element.element : null,
		target
	};
}
function asTreeContextMenuEvent(event) {
	const isStickyScroll = isStickyScrollContainer(event.browserEvent.target);
	return {
		element: event.element ? event.element.element : null,
		browserEvent: event.browserEvent,
		anchor: event.anchor,
		isStickyScroll
	};
}
function dfs$1(node, fn) {
	fn(node);
	node.children.forEach((child) => dfs$1(child, fn));
}
/**
* The trait concept needs to exist at the tree level, because collapsed
* tree nodes will not be known by the list.
*/
var Trait = class {
	get nodeSet() {
		if (!this._nodeSet) this._nodeSet = this.createNodeSet();
		return this._nodeSet;
	}
	constructor(getFirstViewElementWithTrait, identityProvider) {
		this.getFirstViewElementWithTrait = getFirstViewElementWithTrait;
		this.identityProvider = identityProvider;
		this.nodes = [];
		this._onDidChange = new Emitter$1();
		this.onDidChange = this._onDidChange.event;
	}
	set(nodes, browserEvent) {
		if (!browserEvent?.__forceEvent && equals$1(this.nodes, nodes)) return;
		this._set(nodes, false, browserEvent);
	}
	_set(nodes, silent, browserEvent) {
		this.nodes = [...nodes];
		this.elements = void 0;
		this._nodeSet = void 0;
		if (!silent) {
			const that = this;
			this._onDidChange.fire({
				get elements() {
					return that.get();
				},
				browserEvent
			});
		}
	}
	get() {
		if (!this.elements) this.elements = this.nodes.map((node) => node.element);
		return [...this.elements];
	}
	getNodes() {
		return this.nodes;
	}
	has(node) {
		return this.nodeSet.has(node);
	}
	onDidModelSplice({ insertedNodes, deletedNodes }) {
		if (!this.identityProvider) {
			const set = this.createNodeSet();
			const visit = (node) => set.delete(node);
			deletedNodes.forEach((node) => dfs$1(node, visit));
			this.set([...set.values()]);
			return;
		}
		const deletedNodesIdSet = /* @__PURE__ */ new Set();
		const deletedNodesVisitor = (node) => deletedNodesIdSet.add(this.identityProvider.getId(node.element).toString());
		deletedNodes.forEach((node) => dfs$1(node, deletedNodesVisitor));
		const insertedNodesMap = /* @__PURE__ */ new Map();
		const insertedNodesVisitor = (node) => insertedNodesMap.set(this.identityProvider.getId(node.element).toString(), node);
		insertedNodes.forEach((node) => dfs$1(node, insertedNodesVisitor));
		const nodes = [];
		for (const node of this.nodes) {
			const id = this.identityProvider.getId(node.element).toString();
			if (!deletedNodesIdSet.has(id)) nodes.push(node);
			else {
				const insertedNode = insertedNodesMap.get(id);
				if (insertedNode && insertedNode.visible) nodes.push(insertedNode);
			}
		}
		if (this.nodes.length > 0 && nodes.length === 0) {
			const node = this.getFirstViewElementWithTrait();
			if (node) nodes.push(node);
		}
		this._set(nodes, true);
	}
	createNodeSet() {
		const set = /* @__PURE__ */ new Set();
		for (const node of this.nodes) set.add(node);
		return set;
	}
};
var TreeNodeListMouseController = class extends MouseController {
	constructor(list, tree, stickyScrollProvider) {
		super(list);
		this.tree = tree;
		this.stickyScrollProvider = stickyScrollProvider;
	}
	onViewPointer(e) {
		if (isButton(e.browserEvent.target) || isEditableElement(e.browserEvent.target) || isMonacoEditor(e.browserEvent.target)) return;
		if (e.browserEvent.isHandledByList) return;
		const node = e.element;
		if (!node) return super.onViewPointer(e);
		if (this.isSelectionRangeChangeEvent(e) || this.isSelectionSingleChangeEvent(e)) return super.onViewPointer(e);
		const target = e.browserEvent.target;
		const onTwistie = target.classList.contains("monaco-tl-twistie") || target.classList.contains("monaco-icon-label") && target.classList.contains("folder-icon") && e.browserEvent.offsetX < 16;
		const isStickyElement = isStickyScrollElement(e.browserEvent.target);
		let expandOnlyOnTwistieClick = false;
		if (isStickyElement) expandOnlyOnTwistieClick = true;
		else if (typeof this.tree.expandOnlyOnTwistieClick === "function") expandOnlyOnTwistieClick = this.tree.expandOnlyOnTwistieClick(node.element);
		else expandOnlyOnTwistieClick = !!this.tree.expandOnlyOnTwistieClick;
		if (!isStickyElement) {
			if (expandOnlyOnTwistieClick && !onTwistie && e.browserEvent.detail !== 2) return super.onViewPointer(e);
			if (!this.tree.expandOnDoubleClick && e.browserEvent.detail === 2) return super.onViewPointer(e);
		} else this.handleStickyScrollMouseEvent(e, node);
		if (node.collapsible && (!isStickyElement || onTwistie)) {
			const location = this.tree.getNodeLocation(node);
			const recursive = e.browserEvent.altKey;
			this.tree.setFocus([location]);
			this.tree.toggleCollapsed(location, recursive);
			if (onTwistie) {
				e.browserEvent.isHandledByList = true;
				return;
			}
		}
		if (!isStickyElement) super.onViewPointer(e);
	}
	handleStickyScrollMouseEvent(e, node) {
		if (isMonacoCustomToggle(e.browserEvent.target) || isActionItem(e.browserEvent.target)) return;
		const stickyScrollController = this.stickyScrollProvider();
		if (!stickyScrollController) throw new Error("Sticky scroll controller not found");
		const nodeIndex = this.list.indexOf(node);
		const elementScrollTop = this.list.getElementTop(nodeIndex);
		const elementTargetViewTop = stickyScrollController.nodePositionTopBelowWidget(node);
		this.tree.scrollTop = elementScrollTop - elementTargetViewTop;
		this.list.domFocus();
		this.list.setFocus([nodeIndex]);
		this.list.setSelection([nodeIndex]);
	}
	onDoubleClick(e) {
		if (e.browserEvent.target.classList.contains("monaco-tl-twistie") || !this.tree.expandOnDoubleClick) return;
		if (e.browserEvent.isHandledByList) return;
		super.onDoubleClick(e);
	}
	onMouseDown(e) {
		const target = e.browserEvent.target;
		if (!isStickyScrollContainer(target) && !isStickyScrollElement(target)) {
			super.onMouseDown(e);
			return;
		}
	}
	onContextMenu(e) {
		const target = e.browserEvent.target;
		if (!isStickyScrollContainer(target) && !isStickyScrollElement(target)) {
			super.onContextMenu(e);
			return;
		}
	}
};
/**
* We use this List subclass to restore selection and focus as nodes
* get rendered in the list, possibly due to a node expand() call.
*/
var TreeNodeList = class extends List {
	constructor(user, container, virtualDelegate, renderers, focusTrait, selectionTrait, anchorTrait, options) {
		super(user, container, virtualDelegate, renderers, options);
		this.focusTrait = focusTrait;
		this.selectionTrait = selectionTrait;
		this.anchorTrait = anchorTrait;
	}
	createMouseController(options) {
		return new TreeNodeListMouseController(this, options.tree, options.stickyScrollProvider);
	}
	splice(start, deleteCount, elements = []) {
		super.splice(start, deleteCount, elements);
		if (elements.length === 0) return;
		const additionalFocus = [];
		const additionalSelection = [];
		let anchor;
		elements.forEach((node, index) => {
			if (this.focusTrait.has(node)) additionalFocus.push(start + index);
			if (this.selectionTrait.has(node)) additionalSelection.push(start + index);
			if (this.anchorTrait.has(node)) anchor = start + index;
		});
		if (additionalFocus.length > 0) super.setFocus(distinct([...super.getFocus(), ...additionalFocus]));
		if (additionalSelection.length > 0) super.setSelection(distinct([...super.getSelection(), ...additionalSelection]));
		if (typeof anchor === "number") super.setAnchor(anchor);
	}
	setFocus(indexes, browserEvent, fromAPI = false) {
		super.setFocus(indexes, browserEvent);
		if (!fromAPI) this.focusTrait.set(indexes.map((i) => this.element(i)), browserEvent);
	}
	setSelection(indexes, browserEvent, fromAPI = false) {
		super.setSelection(indexes, browserEvent);
		if (!fromAPI) this.selectionTrait.set(indexes.map((i) => this.element(i)), browserEvent);
	}
	setAnchor(index, fromAPI = false) {
		super.setAnchor(index);
		if (!fromAPI) {
			if (typeof index === "undefined") this.anchorTrait.set([]);
			else this.anchorTrait.set([this.element(index)]);
		}
	}
};
var AbstractTree = class {
	get onDidScroll() {
		return this.view.onDidScroll;
	}
	get onDidChangeFocus() {
		return this.eventBufferer.wrapEvent(this.focus.onDidChange);
	}
	get onDidChangeSelection() {
		return this.eventBufferer.wrapEvent(this.selection.onDidChange);
	}
	get onMouseDblClick() {
		return Event.filter(Event.map(this.view.onMouseDblClick, asTreeMouseEvent$1), (e) => e.target !== TreeMouseEventTarget.Filter);
	}
	get onMouseOver() {
		return Event.map(this.view.onMouseOver, asTreeMouseEvent$1);
	}
	get onMouseOut() {
		return Event.map(this.view.onMouseOut, asTreeMouseEvent$1);
	}
	get onContextMenu() {
		return Event.any(Event.filter(Event.map(this.view.onContextMenu, asTreeContextMenuEvent), (e) => !e.isStickyScroll), this.stickyScrollController?.onContextMenu ?? Event.None);
	}
	get onPointer() {
		return Event.map(this.view.onPointer, asTreeMouseEvent$1);
	}
	get onDidFocus() {
		return this.view.onDidFocus;
	}
	get onDidChangeModel() {
		return Event.any(this.onDidChangeModelRelay.event, this.onDidSwapModel.event);
	}
	get onDidChangeCollapseState() {
		return this.onDidChangeCollapseStateRelay.event;
	}
	get expandOnDoubleClick() {
		return typeof this._options.expandOnDoubleClick === "undefined" ? true : this._options.expandOnDoubleClick;
	}
	get expandOnlyOnTwistieClick() {
		return typeof this._options.expandOnlyOnTwistieClick === "undefined" ? true : this._options.expandOnlyOnTwistieClick;
	}
	get onDidDispose() {
		return this.view.onDidDispose;
	}
	constructor(_user, container, delegate, renderers, _options = {}) {
		this._user = _user;
		this._options = _options;
		this.eventBufferer = new EventBufferer();
		this.onDidChangeFindOpenState = Event.None;
		this.onDidChangeStickyScrollFocused = Event.None;
		this.disposables = new DisposableStore();
		this._onDidChangeStickyScrollDomNode = this.disposables.add(new Emitter$1());
		this.onDidSwapModel = this.disposables.add(new Emitter$1());
		this.onDidChangeModelRelay = this.disposables.add(new Relay());
		this.onDidSpliceModelRelay = this.disposables.add(new Relay());
		this.onDidChangeCollapseStateRelay = this.disposables.add(new Relay());
		this.onDidChangeRenderNodeCountRelay = this.disposables.add(new Relay());
		this.onDidChangeActiveNodesRelay = this.disposables.add(new Relay());
		this._onWillRefilter = new Emitter$1();
		this.onWillRefilter = this._onWillRefilter.event;
		this._onDidUpdateOptions = new Emitter$1();
		this.modelDisposables = new DisposableStore();
		if (_options.keyboardNavigationLabelProvider && (_options.findWidgetEnabled ?? true)) {
			this.findFilter = new FindFilter(_options.keyboardNavigationLabelProvider, _options.filter, _options.defaultFindVisibility);
			_options = {
				..._options,
				filter: this.findFilter
			};
			this.disposables.add(this.findFilter);
		}
		this.model = this.createModel(_user, _options);
		this.treeDelegate = new ComposedTreeDelegate(delegate);
		const activeNodes = this.disposables.add(new EventCollection(this.onDidChangeActiveNodesRelay.event));
		const renderedIndentGuides = new SetMap();
		this.renderers = renderers.map((r) => new TreeRenderer(r, this.model, this.onDidChangeCollapseStateRelay.event, activeNodes, renderedIndentGuides, _options));
		for (const r of this.renderers) this.disposables.add(r);
		this.focus = new Trait(() => this.view.getFocusedElements()[0], _options.identityProvider);
		this.selection = new Trait(() => this.view.getSelectedElements()[0], _options.identityProvider);
		this.anchor = new Trait(() => this.view.getAnchorElement(), _options.identityProvider);
		this.view = new TreeNodeList(_user, container, this.treeDelegate, this.renderers, this.focus, this.selection, this.anchor, {
			...asListOptions(() => this.model, this.disposables, _options),
			tree: this,
			stickyScrollProvider: () => this.stickyScrollController
		});
		this.setupModel(this.model);
		if (_options.keyboardSupport !== false) {
			const onKeyDown = Event.chain(this.view.onKeyDown, ($) => $.filter((e) => !isEditableElement(e.target)).map((e) => new StandardKeyboardEvent(e)));
			Event.chain(onKeyDown, ($) => $.filter((e) => e.keyCode === 15))(this.onLeftArrow, this, this.disposables);
			Event.chain(onKeyDown, ($) => $.filter((e) => e.keyCode === 17))(this.onRightArrow, this, this.disposables);
			Event.chain(onKeyDown, ($) => $.filter((e) => e.keyCode === 10))(this.onSpace, this, this.disposables);
		}
		if ((_options.findWidgetEnabled ?? true) && _options.keyboardNavigationLabelProvider && _options.contextViewProvider) {
			const findOptions = {
				styles: _options.findWidgetStyles,
				defaultFindMode: _options.defaultFindMode,
				defaultFindMatchType: _options.defaultFindMatchType,
				showNotFoundMessage: _options.showNotFoundMessage,
				findWidgetContainer: _options.findWidgetContainer
			};
			this.findController = this.disposables.add(new FindController(this, this.findFilter, _options.contextViewProvider, findOptions));
			this.focusNavigationFilter = (node) => this.findController.shouldAllowFocus(node);
			this.onDidChangeFindOpenState = this.findController.onDidChangeOpenState;
			this.onDidChangeFindMode = this.findController.onDidChangeMode;
			this.onDidChangeFindMatchType = this.findController.onDidChangeMatchType;
		} else {
			this.onDidChangeFindMode = Event.None;
			this.onDidChangeFindMatchType = Event.None;
		}
		if (_options.enableStickyScroll) {
			this.stickyScrollController = new StickyScrollController(this, this.model, this.view, this.renderers, this.treeDelegate, _options);
			this.onDidChangeStickyScrollFocused = this.stickyScrollController.onDidChangeHasFocus;
		}
		this.styleElement = createStyleSheet(this.view.getHTMLElement());
		this.getHTMLElement().classList.toggle("always", this._options.renderIndentGuides === RenderIndentGuides.Always);
	}
	updateOptions(optionsUpdate = {}) {
		this._options = {
			...this._options,
			...optionsUpdate
		};
		for (const renderer of this.renderers) renderer.updateOptions(optionsUpdate);
		this.view.updateOptions(optionsUpdate);
		this.findController?.updateOptions(optionsUpdate);
		this.updateStickyScroll(optionsUpdate);
		this._onDidUpdateOptions.fire(this._options);
		this.getHTMLElement().classList.toggle("always", this._options.renderIndentGuides === RenderIndentGuides.Always);
	}
	get options() {
		return this._options;
	}
	updateStickyScroll(optionsUpdate) {
		if (!this.stickyScrollController && this._options.enableStickyScroll) {
			this.stickyScrollController = new StickyScrollController(this, this.model, this.view, this.renderers, this.treeDelegate, this._options);
			this.onDidChangeStickyScrollFocused = this.stickyScrollController.onDidChangeHasFocus;
			this._onDidChangeStickyScrollDomNode.fire(this.stickyScrollController.domNode);
		} else if (this.stickyScrollController && !this._options.enableStickyScroll) {
			this.onDidChangeStickyScrollFocused = Event.None;
			this.stickyScrollController.dispose();
			this.stickyScrollController = void 0;
			this._onDidChangeStickyScrollDomNode.fire(void 0);
		}
		this.stickyScrollController?.updateOptions(optionsUpdate);
	}
	getHTMLElement() {
		return this.view.getHTMLElement();
	}
	get onDidChangeContentHeight() {
		return this.view.onDidChangeContentHeight;
	}
	get scrollTop() {
		return this.view.scrollTop;
	}
	set scrollTop(scrollTop) {
		this.view.scrollTop = scrollTop;
	}
	get scrollHeight() {
		return this.view.scrollHeight;
	}
	get renderHeight() {
		return this.view.renderHeight;
	}
	get ariaLabel() {
		return this.view.ariaLabel;
	}
	set ariaLabel(value) {
		this.view.ariaLabel = value;
	}
	domFocus() {
		if (this.stickyScrollController?.focusedLast()) this.stickyScrollController.domFocus();
		else this.view.domFocus();
	}
	isDOMFocused() {
		return isActiveElement(this.getHTMLElement());
	}
	layout(height, width) {
		this.view.layout(height, width);
	}
	style(styles) {
		const suffix = `.${this.view.domId}`;
		const content = [];
		if (styles.treeIndentGuidesStroke) {
			content.push(`.monaco-list${suffix}:hover .monaco-tl-indent > .indent-guide, .monaco-list${suffix}.always .monaco-tl-indent > .indent-guide  { opacity: 1; border-color: ${styles.treeInactiveIndentGuidesStroke}; }`);
			content.push(`.monaco-list${suffix} .monaco-tl-indent > .indent-guide.active { opacity: 1; border-color: ${styles.treeIndentGuidesStroke}; }`);
		}
		const stickyScrollBackground = styles.treeStickyScrollBackground ?? styles.listBackground;
		if (stickyScrollBackground) {
			content.push(`.monaco-list${suffix} .monaco-scrollable-element .monaco-tree-sticky-container { background-color: ${stickyScrollBackground}; }`);
			content.push(`.monaco-list${suffix} .monaco-scrollable-element .monaco-tree-sticky-container .monaco-tree-sticky-row { background-color: ${stickyScrollBackground}; }`);
		}
		if (styles.treeStickyScrollBorder) content.push(`.monaco-list${suffix} .monaco-scrollable-element .monaco-tree-sticky-container { border-bottom: 1px solid ${styles.treeStickyScrollBorder}; }`);
		if (styles.treeStickyScrollShadow) content.push(`.monaco-list${suffix} .monaco-scrollable-element .monaco-tree-sticky-container .monaco-tree-sticky-container-shadow { box-shadow: ${styles.treeStickyScrollShadow} 0 6px 6px -6px inset; height: 3px; }`);
		if (styles.listFocusForeground) {
			content.push(`.monaco-list${suffix}.sticky-scroll-focused .monaco-scrollable-element .monaco-tree-sticky-container:focus .monaco-list-row.focused { color: ${styles.listFocusForeground}; }`);
			content.push(`.monaco-list${suffix}:not(.sticky-scroll-focused) .monaco-scrollable-element .monaco-tree-sticky-container .monaco-list-row.focused { color: inherit; }`);
		}
		const focusAndSelectionOutline = asCssValueWithDefault(styles.listFocusAndSelectionOutline, asCssValueWithDefault(styles.listSelectionOutline, styles.listFocusOutline ?? ""));
		if (focusAndSelectionOutline) {
			content.push(`.monaco-list${suffix}.sticky-scroll-focused .monaco-scrollable-element .monaco-tree-sticky-container:focus .monaco-list-row.focused.selected { outline: 1px solid ${focusAndSelectionOutline}; outline-offset: -1px;}`);
			content.push(`.monaco-list${suffix}:not(.sticky-scroll-focused) .monaco-scrollable-element .monaco-tree-sticky-container .monaco-list-row.focused.selected { outline: inherit;}`);
		}
		if (styles.listFocusOutline) {
			content.push(`.monaco-list${suffix}.sticky-scroll-focused .monaco-scrollable-element .monaco-tree-sticky-container:focus .monaco-list-row.focused { outline: 1px solid ${styles.listFocusOutline}; outline-offset: -1px; }`);
			content.push(`.monaco-list${suffix}:not(.sticky-scroll-focused) .monaco-scrollable-element .monaco-tree-sticky-container .monaco-list-row.focused { outline: inherit; }`);
			content.push(`.context-menu-visible .monaco-list${suffix}.last-focused.sticky-scroll-focused .monaco-scrollable-element .monaco-tree-sticky-container .monaco-list-row.passive-focused { outline: 1px solid ${styles.listFocusOutline}; outline-offset: -1px; }`);
			content.push(`.context-menu-visible .monaco-list${suffix}.last-focused.sticky-scroll-focused .monaco-list-rows .monaco-list-row.focused { outline: inherit; }`);
			content.push(`.context-menu-visible .monaco-list${suffix}.last-focused:not(.sticky-scroll-focused) .monaco-tree-sticky-container .monaco-list-rows .monaco-list-row.focused { outline: inherit; }`);
		}
		this.styleElement.textContent = content.join("\n");
		this.view.style(styles);
	}
	getParentElement(location) {
		const parentRef = this.model.getParentNodeLocation(location);
		return this.model.getNode(parentRef).element;
	}
	getFirstElementChild(location) {
		return this.model.getFirstElementChild(location);
	}
	getNode(location) {
		return this.model.getNode(location);
	}
	getNodeLocation(node) {
		return this.model.getNodeLocation(node);
	}
	collapse(location, recursive = false) {
		return this.model.setCollapsed(location, true, recursive);
	}
	expand(location, recursive = false) {
		return this.model.setCollapsed(location, false, recursive);
	}
	toggleCollapsed(location, recursive = false) {
		return this.model.setCollapsed(location, void 0, recursive);
	}
	isCollapsible(location) {
		return this.model.isCollapsible(location);
	}
	setCollapsible(location, collapsible) {
		return this.model.setCollapsible(location, collapsible);
	}
	isCollapsed(location) {
		return this.model.isCollapsed(location);
	}
	refilter() {
		this._onWillRefilter.fire(void 0);
		this.model.refilter();
	}
	setSelection(elements, browserEvent) {
		this.eventBufferer.bufferEvents(() => {
			const nodes = elements.map((e) => this.model.getNode(e));
			this.selection.set(nodes, browserEvent);
			const indexes = elements.map((e) => this.model.getListIndex(e)).filter((i) => i > -1);
			this.view.setSelection(indexes, browserEvent, true);
		});
	}
	getSelection() {
		return this.selection.get();
	}
	setFocus(elements, browserEvent) {
		this.eventBufferer.bufferEvents(() => {
			const nodes = elements.map((e) => this.model.getNode(e));
			this.focus.set(nodes, browserEvent);
			const indexes = elements.map((e) => this.model.getListIndex(e)).filter((i) => i > -1);
			this.view.setFocus(indexes, browserEvent, true);
		});
	}
	focusNext(n = 1, loop = false, browserEvent, filter = isKeyboardEvent(browserEvent) && browserEvent.altKey ? void 0 : this.focusNavigationFilter) {
		this.view.focusNext(n, loop, browserEvent, filter);
	}
	focusPrevious(n = 1, loop = false, browserEvent, filter = isKeyboardEvent(browserEvent) && browserEvent.altKey ? void 0 : this.focusNavigationFilter) {
		this.view.focusPrevious(n, loop, browserEvent, filter);
	}
	focusNextPage(browserEvent, filter = isKeyboardEvent(browserEvent) && browserEvent.altKey ? void 0 : this.focusNavigationFilter) {
		return this.view.focusNextPage(browserEvent, filter);
	}
	focusPreviousPage(browserEvent, filter = isKeyboardEvent(browserEvent) && browserEvent.altKey ? void 0 : this.focusNavigationFilter) {
		return this.view.focusPreviousPage(browserEvent, filter, () => this.stickyScrollController?.height ?? 0);
	}
	focusLast(browserEvent, filter = isKeyboardEvent(browserEvent) && browserEvent.altKey ? void 0 : this.focusNavigationFilter) {
		this.view.focusLast(browserEvent, filter);
	}
	focusFirst(browserEvent, filter = isKeyboardEvent(browserEvent) && browserEvent.altKey ? void 0 : this.focusNavigationFilter) {
		this.view.focusFirst(browserEvent, filter);
	}
	getFocus() {
		return this.focus.get();
	}
	reveal(location, relativeTop) {
		this.model.expandTo(location);
		const index = this.model.getListIndex(location);
		if (index === -1) return;
		if (!this.stickyScrollController) this.view.reveal(index, relativeTop);
		else {
			const paddingTop = this.stickyScrollController.nodePositionTopBelowWidget(this.getNode(location));
			this.view.reveal(index, relativeTop, paddingTop);
		}
	}
	onLeftArrow(e) {
		e.preventDefault();
		e.stopPropagation();
		const nodes = this.view.getFocusedElements();
		if (nodes.length === 0) return;
		const node = nodes[0];
		const location = this.model.getNodeLocation(node);
		if (!this.model.setCollapsed(location, true)) {
			const parentLocation = this.model.getParentNodeLocation(location);
			if (!parentLocation) return;
			const parentListIndex = this.model.getListIndex(parentLocation);
			this.view.reveal(parentListIndex);
			this.view.setFocus([parentListIndex]);
		}
	}
	onRightArrow(e) {
		e.preventDefault();
		e.stopPropagation();
		const nodes = this.view.getFocusedElements();
		if (nodes.length === 0) return;
		const node = nodes[0];
		const location = this.model.getNodeLocation(node);
		if (!this.model.setCollapsed(location, false)) {
			if (!node.children.some((child) => child.visible)) return;
			const [focusedIndex] = this.view.getFocus();
			const firstChildIndex = focusedIndex + 1;
			this.view.reveal(firstChildIndex);
			this.view.setFocus([firstChildIndex]);
		}
	}
	onSpace(e) {
		e.preventDefault();
		e.stopPropagation();
		const nodes = this.view.getFocusedElements();
		if (nodes.length === 0) return;
		const node = nodes[0];
		const location = this.model.getNodeLocation(node);
		const recursive = e.browserEvent.altKey;
		this.model.setCollapsed(location, void 0, recursive);
	}
	setupModel(model) {
		this.modelDisposables.clear();
		this.modelDisposables.add(model.onDidSpliceRenderedNodes(({ start, deleteCount, elements }) => this.view.splice(start, deleteCount, elements)));
		const onDidModelSplice = Event.forEach(model.onDidSpliceModel, (e) => {
			this.eventBufferer.bufferEvents(() => {
				this.focus.onDidModelSplice(e);
				this.selection.onDidModelSplice(e);
			});
		}, this.modelDisposables);
		onDidModelSplice(() => null, null, this.modelDisposables);
		const activeNodesEmitter = this.modelDisposables.add(new Emitter$1());
		const activeNodesDebounce = this.modelDisposables.add(new Delayer(0));
		this.modelDisposables.add(Event.any(onDidModelSplice, this.focus.onDidChange, this.selection.onDidChange)(() => {
			activeNodesDebounce.trigger(() => {
				const set = /* @__PURE__ */ new Set();
				for (const node of this.focus.getNodes()) set.add(node);
				for (const node of this.selection.getNodes()) set.add(node);
				activeNodesEmitter.fire([...set.values()]);
			});
		}));
		this.onDidChangeActiveNodesRelay.input = activeNodesEmitter.event;
		this.onDidChangeModelRelay.input = Event.signal(model.onDidSpliceModel);
		this.onDidChangeCollapseStateRelay.input = model.onDidChangeCollapseState;
		this.onDidChangeRenderNodeCountRelay.input = model.onDidChangeRenderNodeCount;
		this.onDidSpliceModelRelay.input = model.onDidSpliceModel;
		if (isMacintosh) this.modelDisposables.add(model.onDidChangeCollapseState((e) => {
			const { node, deep } = e;
			if (node.collapsible && !deep && this.isDOMFocused()) alert(node.collapsed ? localize(30, "collapsed") : localize(31, "expanded"));
		}));
	}
	dispose() {
		dispose(this.disposables);
		this.stickyScrollController?.dispose();
		this.view.dispose();
		this.modelDisposables.dispose();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/tree/objectTreeModel.js
var ObjectTreeModel = class {
	constructor(user, options = {}) {
		this.user = user;
		this.rootRef = null;
		this.nodes = /* @__PURE__ */ new Map();
		this.nodesByIdentity = /* @__PURE__ */ new Map();
		this.model = new IndexTreeModel(user, null, options);
		this.onDidSpliceModel = this.model.onDidSpliceModel;
		this.onDidSpliceRenderedNodes = this.model.onDidSpliceRenderedNodes;
		this.onDidChangeCollapseState = this.model.onDidChangeCollapseState;
		this.onDidChangeRenderNodeCount = this.model.onDidChangeRenderNodeCount;
		if (options.sorter) this.sorter = { compare(a, b) {
			return options.sorter.compare(a.element, b.element);
		} };
		this.identityProvider = options.identityProvider;
	}
	setChildren(element, children = Iterable.empty(), options = {}) {
		const location = this.getElementLocation(element);
		this._setChildren(location, this.preserveCollapseState(children), options);
	}
	_setChildren(location, children = Iterable.empty(), options) {
		const insertedElements = /* @__PURE__ */ new Set();
		const insertedElementIds = /* @__PURE__ */ new Set();
		const onDidCreateNode = (node) => {
			if (node.element === null) return;
			const tnode = node;
			insertedElements.add(tnode.element);
			this.nodes.set(tnode.element, tnode);
			if (this.identityProvider) {
				const id = this.identityProvider.getId(tnode.element).toString();
				insertedElementIds.add(id);
				this.nodesByIdentity.set(id, tnode);
			}
			options.onDidCreateNode?.(tnode);
		};
		const onDidDeleteNode = (node) => {
			if (node.element === null) return;
			const tnode = node;
			if (!insertedElements.has(tnode.element)) this.nodes.delete(tnode.element);
			if (this.identityProvider) {
				const id = this.identityProvider.getId(tnode.element).toString();
				if (!insertedElementIds.has(id)) this.nodesByIdentity.delete(id);
			}
			options.onDidDeleteNode?.(tnode);
		};
		this.model.splice([...location, 0], Number.MAX_VALUE, children, {
			...options,
			onDidCreateNode,
			onDidDeleteNode
		});
	}
	preserveCollapseState(elements = Iterable.empty()) {
		if (this.sorter) elements = [...elements].sort(this.sorter.compare.bind(this.sorter));
		return Iterable.map(elements, (treeElement) => {
			let node = this.nodes.get(treeElement.element);
			if (!node && this.identityProvider) {
				const id = this.identityProvider.getId(treeElement.element).toString();
				node = this.nodesByIdentity.get(id);
			}
			if (!node) {
				let collapsed;
				if (typeof treeElement.collapsed === "undefined") collapsed = void 0;
				else if (treeElement.collapsed === ObjectTreeElementCollapseState.Collapsed || treeElement.collapsed === ObjectTreeElementCollapseState.PreserveOrCollapsed) collapsed = true;
				else if (treeElement.collapsed === ObjectTreeElementCollapseState.Expanded || treeElement.collapsed === ObjectTreeElementCollapseState.PreserveOrExpanded) collapsed = false;
				else collapsed = Boolean(treeElement.collapsed);
				return {
					...treeElement,
					children: this.preserveCollapseState(treeElement.children),
					collapsed
				};
			}
			const collapsible = typeof treeElement.collapsible === "boolean" ? treeElement.collapsible : node.collapsible;
			let collapsed;
			if (typeof treeElement.collapsed === "undefined" || treeElement.collapsed === ObjectTreeElementCollapseState.PreserveOrCollapsed || treeElement.collapsed === ObjectTreeElementCollapseState.PreserveOrExpanded) collapsed = node.collapsed;
			else if (treeElement.collapsed === ObjectTreeElementCollapseState.Collapsed) collapsed = true;
			else if (treeElement.collapsed === ObjectTreeElementCollapseState.Expanded) collapsed = false;
			else collapsed = Boolean(treeElement.collapsed);
			return {
				...treeElement,
				collapsible,
				collapsed,
				children: this.preserveCollapseState(treeElement.children)
			};
		});
	}
	rerender(element) {
		const location = this.getElementLocation(element);
		this.model.rerender(location);
	}
	resort(element = null, recursive = true) {
		if (!this.sorter) return;
		const location = this.getElementLocation(element);
		const node = this.model.getNode(location);
		this._setChildren(location, this.resortChildren(node, recursive), {});
	}
	resortChildren(node, recursive, first = true) {
		let childrenNodes = [...node.children];
		if (recursive || first) childrenNodes = childrenNodes.sort(this.sorter.compare.bind(this.sorter));
		return Iterable.map(childrenNodes, (node) => ({
			element: node.element,
			collapsible: node.collapsible,
			collapsed: node.collapsed,
			children: this.resortChildren(node, recursive, false)
		}));
	}
	getFirstElementChild(ref = null) {
		const location = this.getElementLocation(ref);
		return this.model.getFirstElementChild(location);
	}
	has(element) {
		return this.nodes.has(element);
	}
	getListIndex(element) {
		const location = this.getElementLocation(element);
		return this.model.getListIndex(location);
	}
	getListRenderCount(element) {
		const location = this.getElementLocation(element);
		return this.model.getListRenderCount(location);
	}
	isCollapsible(element) {
		const location = this.getElementLocation(element);
		return this.model.isCollapsible(location);
	}
	setCollapsible(element, collapsible) {
		const location = this.getElementLocation(element);
		return this.model.setCollapsible(location, collapsible);
	}
	isCollapsed(element) {
		const location = this.getElementLocation(element);
		return this.model.isCollapsed(location);
	}
	setCollapsed(element, collapsed, recursive) {
		const location = this.getElementLocation(element);
		return this.model.setCollapsed(location, collapsed, recursive);
	}
	expandTo(element) {
		const location = this.getElementLocation(element);
		this.model.expandTo(location);
	}
	refilter() {
		this.model.refilter();
	}
	getNode(element = null) {
		if (element === null) return this.model.getNode(this.model.rootRef);
		const node = this.nodes.get(element);
		if (!node) throw new TreeError(this.user, `Tree element not found: ${element}`);
		return node;
	}
	getNodeLocation(node) {
		return node.element;
	}
	getParentNodeLocation(element) {
		if (element === null) throw new TreeError(this.user, `Invalid getParentNodeLocation call`);
		const node = this.nodes.get(element);
		if (!node) throw new TreeError(this.user, `Tree element not found: ${element}`);
		const location = this.model.getNodeLocation(node);
		const parentLocation = this.model.getParentNodeLocation(location);
		return this.model.getNode(parentLocation).element;
	}
	getElementLocation(element) {
		if (element === null) return [];
		const node = this.nodes.get(element);
		if (!node) throw new TreeError(this.user, `Tree element not found: ${element}`);
		return this.model.getNodeLocation(node);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/tree/compressedObjectTreeModel.js
function noCompress(element) {
	return {
		element: {
			elements: [element.element],
			incompressible: element.incompressible || false
		},
		children: Iterable.map(Iterable.from(element.children), noCompress),
		collapsible: element.collapsible,
		collapsed: element.collapsed
	};
}
function compress(element) {
	const elements = [element.element];
	const incompressible = element.incompressible || false;
	let childrenIterator;
	let children;
	while (true) {
		[children, childrenIterator] = Iterable.consume(Iterable.from(element.children), 2);
		if (children.length !== 1) break;
		if (children[0].incompressible) break;
		element = children[0];
		elements.push(element.element);
	}
	return {
		element: {
			elements,
			incompressible
		},
		children: Iterable.map(Iterable.concat(children, childrenIterator), compress),
		collapsible: element.collapsible,
		collapsed: element.collapsed
	};
}
function _decompress(element, index = 0) {
	let children;
	if (index < element.element.elements.length - 1) children = [_decompress(element, index + 1)];
	else children = Iterable.map(Iterable.from(element.children), (el) => _decompress(el, 0));
	if (index === 0 && element.element.incompressible) return {
		element: element.element.elements[index],
		children,
		incompressible: true,
		collapsible: element.collapsible,
		collapsed: element.collapsed
	};
	return {
		element: element.element.elements[index],
		children,
		collapsible: element.collapsible,
		collapsed: element.collapsed
	};
}
function decompress(element) {
	return _decompress(element, 0);
}
function splice(treeElement, element, children) {
	if (treeElement.element === element) return {
		...treeElement,
		children
	};
	return {
		...treeElement,
		children: Iterable.map(Iterable.from(treeElement.children), (e) => splice(e, element, children))
	};
}
var wrapIdentityProvider = (base) => ({
	getId(node) {
		return node.elements.map((e) => base.getId(e).toString()).join("\0");
	},
	getGroupId: base.getGroupId ? (node) => {
		return base.getGroupId(node.elements[node.elements.length - 1]);
	} : void 0
});
var CompressedObjectTreeModel = class {
	get onDidSpliceRenderedNodes() {
		return this.model.onDidSpliceRenderedNodes;
	}
	get onDidSpliceModel() {
		return this.model.onDidSpliceModel;
	}
	get onDidChangeCollapseState() {
		return this.model.onDidChangeCollapseState;
	}
	get onDidChangeRenderNodeCount() {
		return this.model.onDidChangeRenderNodeCount;
	}
	constructor(user, options = {}) {
		this.user = user;
		this.rootRef = null;
		this.nodes = /* @__PURE__ */ new Map();
		this.model = new ObjectTreeModel(user, options);
		this.enabled = typeof options.compressionEnabled === "undefined" ? true : options.compressionEnabled;
		this.identityProvider = options.identityProvider;
	}
	setChildren(element, children = Iterable.empty(), options) {
		const diffIdentityProvider = options.diffIdentityProvider && wrapIdentityProvider(options.diffIdentityProvider);
		if (element === null) {
			const compressedChildren = Iterable.map(children, this.enabled ? compress : noCompress);
			this._setChildren(null, compressedChildren, {
				diffIdentityProvider,
				diffDepth: Infinity
			});
			return;
		}
		const compressedNode = this.nodes.get(element);
		if (!compressedNode) throw new TreeError(this.user, "Unknown compressed tree node");
		const node = this.model.getNode(compressedNode);
		const compressedParentNode = this.model.getParentNodeLocation(compressedNode);
		const parent = this.model.getNode(compressedParentNode);
		const splicedElement = splice(decompress(node), element, children);
		const recompressedElement = (this.enabled ? compress : noCompress)(splicedElement);
		const elementComparator = options.diffIdentityProvider ? ((a, b) => options.diffIdentityProvider.getId(a) === options.diffIdentityProvider.getId(b)) : void 0;
		if (equals$1(recompressedElement.element.elements, node.element.elements, elementComparator)) {
			this._setChildren(compressedNode, recompressedElement.children || Iterable.empty(), {
				diffIdentityProvider,
				diffDepth: 1
			});
			return;
		}
		const parentChildren = parent.children.map((child) => child === node ? recompressedElement : child);
		this._setChildren(parent.element, parentChildren, {
			diffIdentityProvider,
			diffDepth: node.depth - parent.depth
		});
	}
	isCompressionEnabled() {
		return this.enabled;
	}
	setCompressionEnabled(enabled) {
		if (enabled === this.enabled) return;
		this.enabled = enabled;
		const rootChildren = this.model.getNode().children;
		const decompressedRootChildren = Iterable.map(rootChildren, decompress);
		const recompressedRootChildren = Iterable.map(decompressedRootChildren, enabled ? compress : noCompress);
		this._setChildren(null, recompressedRootChildren, {
			diffIdentityProvider: this.identityProvider,
			diffDepth: Infinity
		});
	}
	_setChildren(node, children, options) {
		const insertedElements = /* @__PURE__ */ new Set();
		const onDidCreateNode = (node) => {
			for (const element of node.element.elements) {
				insertedElements.add(element);
				this.nodes.set(element, node.element);
			}
		};
		const onDidDeleteNode = (node) => {
			for (const element of node.element.elements) if (!insertedElements.has(element)) this.nodes.delete(element);
		};
		this.model.setChildren(node, children, {
			...options,
			onDidCreateNode,
			onDidDeleteNode
		});
	}
	has(element) {
		return this.nodes.has(element);
	}
	getListIndex(location) {
		const node = this.getCompressedNode(location);
		return this.model.getListIndex(node);
	}
	getListRenderCount(location) {
		const node = this.getCompressedNode(location);
		return this.model.getListRenderCount(node);
	}
	getNode(location) {
		if (typeof location === "undefined") return this.model.getNode();
		const node = this.getCompressedNode(location);
		return this.model.getNode(node);
	}
	getNodeLocation(node) {
		const compressedNode = this.model.getNodeLocation(node);
		if (compressedNode === null) return null;
		return compressedNode.elements[compressedNode.elements.length - 1];
	}
	getParentNodeLocation(location) {
		const compressedNode = this.getCompressedNode(location);
		const parentNode = this.model.getParentNodeLocation(compressedNode);
		if (parentNode === null) return null;
		return parentNode.elements[parentNode.elements.length - 1];
	}
	getFirstElementChild(location) {
		const compressedNode = this.getCompressedNode(location);
		return this.model.getFirstElementChild(compressedNode);
	}
	isCollapsible(location) {
		const compressedNode = this.getCompressedNode(location);
		return this.model.isCollapsible(compressedNode);
	}
	setCollapsible(location, collapsible) {
		const compressedNode = this.getCompressedNode(location);
		return this.model.setCollapsible(compressedNode, collapsible);
	}
	isCollapsed(location) {
		const compressedNode = this.getCompressedNode(location);
		return this.model.isCollapsed(compressedNode);
	}
	setCollapsed(location, collapsed, recursive) {
		const compressedNode = this.getCompressedNode(location);
		return this.model.setCollapsed(compressedNode, collapsed, recursive);
	}
	expandTo(location) {
		const compressedNode = this.getCompressedNode(location);
		this.model.expandTo(compressedNode);
	}
	rerender(location) {
		const compressedNode = this.getCompressedNode(location);
		this.model.rerender(compressedNode);
	}
	refilter() {
		this.model.refilter();
	}
	resort(location = null, recursive = true) {
		const compressedNode = this.getCompressedNode(location);
		this.model.resort(compressedNode, recursive);
	}
	getCompressedNode(element) {
		if (element === null) return null;
		const node = this.nodes.get(element);
		if (!node) throw new TreeError(this.user, `Tree element not found: ${element}`);
		return node;
	}
};
var DefaultElementMapper = (elements) => elements[elements.length - 1];
var CompressedTreeNodeWrapper = class CompressedTreeNodeWrapper {
	get element() {
		return this.node.element === null ? null : this.unwrapper(this.node.element);
	}
	get children() {
		return this.node.children.map((node) => new CompressedTreeNodeWrapper(this.unwrapper, node));
	}
	get depth() {
		return this.node.depth;
	}
	get visibleChildrenCount() {
		return this.node.visibleChildrenCount;
	}
	get visibleChildIndex() {
		return this.node.visibleChildIndex;
	}
	get collapsible() {
		return this.node.collapsible;
	}
	get collapsed() {
		return this.node.collapsed;
	}
	get visible() {
		return this.node.visible;
	}
	get filterData() {
		return this.node.filterData;
	}
	constructor(unwrapper, node) {
		this.unwrapper = unwrapper;
		this.node = node;
	}
};
function mapOptions(compressedNodeUnwrapper, options) {
	return {
		...options,
		identityProvider: options.identityProvider && {
			getId(node) {
				return options.identityProvider.getId(compressedNodeUnwrapper(node));
			},
			getGroupId: options.identityProvider.getGroupId ? (node) => {
				return options.identityProvider.getGroupId(compressedNodeUnwrapper(node));
			} : void 0
		},
		sorter: options.sorter && { compare(node, otherNode) {
			return options.sorter.compare(node.elements[0], otherNode.elements[0]);
		} },
		filter: options.filter && { filter(node, parentVisibility) {
			const elements = node.elements;
			for (let i = 0; i < elements.length - 1; i++) {
				const result = options.filter.filter(elements[i], parentVisibility);
				parentVisibility = getVisibleState(isFilterResult(result) ? result.visibility : result);
			}
			return options.filter.filter(elements[elements.length - 1], parentVisibility);
		} }
	};
}
var CompressibleObjectTreeModel = class {
	get onDidSpliceModel() {
		return Event.map(this.model.onDidSpliceModel, ({ insertedNodes, deletedNodes }) => ({
			insertedNodes: insertedNodes.map((node) => this.nodeMapper.map(node)),
			deletedNodes: deletedNodes.map((node) => this.nodeMapper.map(node))
		}));
	}
	get onDidSpliceRenderedNodes() {
		return Event.map(this.model.onDidSpliceRenderedNodes, ({ start, deleteCount, elements }) => ({
			start,
			deleteCount,
			elements: elements.map((node) => this.nodeMapper.map(node))
		}));
	}
	get onDidChangeCollapseState() {
		return Event.map(this.model.onDidChangeCollapseState, ({ node, deep }) => ({
			node: this.nodeMapper.map(node),
			deep
		}));
	}
	get onDidChangeRenderNodeCount() {
		return Event.map(this.model.onDidChangeRenderNodeCount, (node) => this.nodeMapper.map(node));
	}
	constructor(user, options = {}) {
		this.rootRef = null;
		this.elementMapper = options.elementMapper || DefaultElementMapper;
		const compressedNodeUnwrapper = (node) => this.elementMapper(node.elements);
		this.nodeMapper = new WeakMapper((node) => new CompressedTreeNodeWrapper(compressedNodeUnwrapper, node));
		this.model = new CompressedObjectTreeModel(user, mapOptions(compressedNodeUnwrapper, options));
	}
	setChildren(element, children = Iterable.empty(), options = {}) {
		this.model.setChildren(element, children, options);
	}
	isCompressionEnabled() {
		return this.model.isCompressionEnabled();
	}
	setCompressionEnabled(enabled) {
		this.model.setCompressionEnabled(enabled);
	}
	has(location) {
		return this.model.has(location);
	}
	getListIndex(location) {
		return this.model.getListIndex(location);
	}
	getListRenderCount(location) {
		return this.model.getListRenderCount(location);
	}
	getNode(location) {
		return this.nodeMapper.map(this.model.getNode(location));
	}
	getNodeLocation(node) {
		return node.element;
	}
	getParentNodeLocation(location) {
		return this.model.getParentNodeLocation(location);
	}
	getFirstElementChild(location) {
		const result = this.model.getFirstElementChild(location);
		if (result === null || typeof result === "undefined") return result;
		return this.elementMapper(result.elements);
	}
	isCollapsible(location) {
		return this.model.isCollapsible(location);
	}
	setCollapsible(location, collapsed) {
		return this.model.setCollapsible(location, collapsed);
	}
	isCollapsed(location) {
		return this.model.isCollapsed(location);
	}
	setCollapsed(location, collapsed, recursive) {
		return this.model.setCollapsed(location, collapsed, recursive);
	}
	expandTo(location) {
		return this.model.expandTo(location);
	}
	rerender(location) {
		return this.model.rerender(location);
	}
	refilter() {
		return this.model.refilter();
	}
	resort(element = null, recursive = true) {
		return this.model.resort(element, recursive);
	}
	getCompressedTreeNode(location = null) {
		return this.model.getNode(location);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/tree/objectTree.js
var __decorate$31 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ObjectTree = class extends AbstractTree {
	get onDidChangeCollapseState() {
		return this.model.onDidChangeCollapseState;
	}
	constructor(user, container, delegate, renderers, options = {}) {
		super(user, container, delegate, renderers, options);
		this.user = user;
	}
	setChildren(element, children = Iterable.empty(), options) {
		this.model.setChildren(element, children, options);
	}
	rerender(element) {
		if (element === void 0) {
			this.view.rerender();
			return;
		}
		this.model.rerender(element);
	}
	resort(element, recursive = true) {
		this.model.resort(element, recursive);
	}
	hasElement(element) {
		return this.model.has(element);
	}
	createModel(user, options) {
		return new ObjectTreeModel(user, options);
	}
};
var CompressibleRenderer = class {
	get compressedTreeNodeProvider() {
		return this._compressedTreeNodeProvider();
	}
	constructor(_compressedTreeNodeProvider, stickyScrollDelegate, renderer) {
		this._compressedTreeNodeProvider = _compressedTreeNodeProvider;
		this.stickyScrollDelegate = stickyScrollDelegate;
		this.renderer = renderer;
		this.templateId = renderer.templateId;
		if (renderer.onDidChangeTwistieState) this.onDidChangeTwistieState = renderer.onDidChangeTwistieState;
	}
	renderTemplate(container) {
		return {
			compressedTreeNode: void 0,
			data: this.renderer.renderTemplate(container)
		};
	}
	renderElement(node, index, templateData, details) {
		let compressedTreeNode = this.stickyScrollDelegate.getCompressedNode(node);
		if (!compressedTreeNode) compressedTreeNode = this.compressedTreeNodeProvider.getCompressedTreeNode(node.element);
		if (compressedTreeNode.element.elements.length === 1) {
			templateData.compressedTreeNode = void 0;
			this.renderer.renderElement(node, index, templateData.data, details);
		} else {
			templateData.compressedTreeNode = compressedTreeNode;
			this.renderer.renderCompressedElements(compressedTreeNode, index, templateData.data, details);
		}
	}
	disposeElement(node, index, templateData, details) {
		if (templateData.compressedTreeNode) this.renderer.disposeCompressedElements?.(templateData.compressedTreeNode, index, templateData.data, details);
		else this.renderer.disposeElement?.(node, index, templateData.data, details);
	}
	disposeTemplate(templateData) {
		this.renderer.disposeTemplate(templateData.data);
	}
	renderTwistie(element, twistieElement) {
		return this.renderer.renderTwistie?.(element, twistieElement) ?? false;
	}
};
__decorate$31([memoize], CompressibleRenderer.prototype, "compressedTreeNodeProvider", null);
var CompressibleStickyScrollDelegate = class {
	constructor(modelProvider) {
		this.modelProvider = modelProvider;
		this.compressedStickyNodes = /* @__PURE__ */ new Map();
	}
	getCompressedNode(node) {
		return this.compressedStickyNodes.get(node);
	}
	constrainStickyScrollNodes(stickyNodes, stickyScrollMaxItemCount, maxWidgetHeight) {
		this.compressedStickyNodes.clear();
		if (stickyNodes.length === 0) return [];
		for (let i = 0; i < stickyNodes.length; i++) {
			const stickyNode = stickyNodes[i];
			const stickyNodeBottom = stickyNode.position + stickyNode.height;
			if (i + 1 < stickyNodes.length && stickyNodeBottom + stickyNodes[i + 1].height > maxWidgetHeight || i >= stickyScrollMaxItemCount - 1 && stickyScrollMaxItemCount < stickyNodes.length) {
				const uncompressedStickyNodes = stickyNodes.slice(0, i);
				const overflowingStickyNodes = stickyNodes.slice(i);
				const compressedStickyNode = this.compressStickyNodes(overflowingStickyNodes);
				return [...uncompressedStickyNodes, compressedStickyNode];
			}
		}
		return stickyNodes;
	}
	compressStickyNodes(stickyNodes) {
		if (stickyNodes.length === 0) throw new Error("Can't compress empty sticky nodes");
		const compressionModel = this.modelProvider();
		if (!compressionModel.isCompressionEnabled()) return stickyNodes[0];
		const elements = [];
		for (let i = 0; i < stickyNodes.length; i++) {
			const stickyNode = stickyNodes[i];
			const compressedNode = compressionModel.getCompressedTreeNode(stickyNode.node.element);
			if (compressedNode.element) {
				if (i !== 0 && compressedNode.element.incompressible) break;
				elements.push(...compressedNode.element.elements);
			}
		}
		if (elements.length < 2) return stickyNodes[0];
		const lastStickyNode = stickyNodes[stickyNodes.length - 1];
		const compressedElement = {
			elements,
			incompressible: false
		};
		const compressedNode = {
			...lastStickyNode.node,
			children: [],
			element: compressedElement
		};
		const stickyTreeNode = new Proxy(stickyNodes[0].node, {});
		const compressedStickyNode = {
			node: stickyTreeNode,
			startIndex: stickyNodes[0].startIndex,
			endIndex: lastStickyNode.endIndex,
			position: stickyNodes[0].position,
			height: stickyNodes[0].height,
			sourceNodeEnd: stickyNodes[0].sourceNodeEnd,
			sourceNodePartiallyVisible: stickyNodes.some((node) => node.sourceNodePartiallyVisible),
			hasExplicitHeight: stickyNodes[0].hasExplicitHeight
		};
		this.compressedStickyNodes.set(stickyTreeNode, compressedNode);
		return compressedStickyNode;
	}
};
function asObjectTreeOptions$1(compressedTreeNodeProvider, options) {
	return options && {
		...options,
		keyboardNavigationLabelProvider: options.keyboardNavigationLabelProvider && { getKeyboardNavigationLabel(e) {
			let compressedTreeNode;
			try {
				compressedTreeNode = compressedTreeNodeProvider().getCompressedTreeNode(e);
			} catch {
				return options.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(e);
			}
			if (compressedTreeNode.element.elements.length === 1) return options.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(e);
			else return options.keyboardNavigationLabelProvider.getCompressedNodeKeyboardNavigationLabel(compressedTreeNode.element.elements);
		} }
	};
}
var CompressibleObjectTree = class extends ObjectTree {
	constructor(user, container, delegate, renderers, options = {}) {
		const compressedTreeNodeProvider = () => this;
		const stickyScrollDelegate = new CompressibleStickyScrollDelegate(() => this.model);
		const compressibleRenderers = renderers.map((r) => new CompressibleRenderer(compressedTreeNodeProvider, stickyScrollDelegate, r));
		super(user, container, delegate, compressibleRenderers, {
			...asObjectTreeOptions$1(compressedTreeNodeProvider, options),
			stickyScrollDelegate
		});
	}
	setChildren(element, children = Iterable.empty(), options) {
		this.model.setChildren(element, children, options);
	}
	createModel(user, options) {
		return new CompressibleObjectTreeModel(user, options);
	}
	updateOptions(optionsUpdate = {}) {
		super.updateOptions(optionsUpdate);
		if (typeof optionsUpdate.compressionEnabled !== "undefined") this.model.setCompressionEnabled(optionsUpdate.compressionEnabled);
	}
	getCompressedTreeNode(element = null) {
		return this.model.getCompressedTreeNode(element);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/tree/asyncDataTree.js
function createAsyncDataTreeNode(props) {
	return {
		...props,
		children: [],
		refreshPromise: void 0,
		stale: true,
		slow: false,
		forceExpanded: false
	};
}
function isAncestor(ancestor, descendant) {
	if (!descendant.parent) return false;
	else if (descendant.parent === ancestor) return true;
	else return isAncestor(ancestor, descendant.parent);
}
function intersects(node, other) {
	return node === other || isAncestor(node, other) || isAncestor(other, node);
}
var AsyncDataTreeNodeWrapper = class AsyncDataTreeNodeWrapper {
	get element() {
		return this.node.element.element;
	}
	get children() {
		return this.node.children.map((node) => new AsyncDataTreeNodeWrapper(node));
	}
	get depth() {
		return this.node.depth;
	}
	get visibleChildrenCount() {
		return this.node.visibleChildrenCount;
	}
	get visibleChildIndex() {
		return this.node.visibleChildIndex;
	}
	get collapsible() {
		return this.node.collapsible;
	}
	get collapsed() {
		return this.node.collapsed;
	}
	get visible() {
		return this.node.visible;
	}
	get filterData() {
		return this.node.filterData;
	}
	constructor(node) {
		this.node = node;
	}
};
var AsyncDataTreeRenderer = class {
	constructor(renderer, nodeMapper, onDidChangeTwistieState) {
		this.renderer = renderer;
		this.nodeMapper = nodeMapper;
		this.onDidChangeTwistieState = onDidChangeTwistieState;
		this.renderedNodes = /* @__PURE__ */ new Map();
		this.templateId = renderer.templateId;
	}
	renderTemplate(container) {
		return { templateData: this.renderer.renderTemplate(container) };
	}
	renderElement(node, index, templateData, details) {
		this.renderer.renderElement(this.nodeMapper.map(node), index, templateData.templateData, details);
	}
	renderTwistie(element, twistieElement) {
		if (element.slow) {
			twistieElement.classList.add(...ThemeIcon.asClassNameArray(Codicon.treeItemLoading));
			return true;
		} else {
			twistieElement.classList.remove(...ThemeIcon.asClassNameArray(Codicon.treeItemLoading));
			return false;
		}
	}
	disposeElement(node, index, templateData, details) {
		this.renderer.disposeElement?.(this.nodeMapper.map(node), index, templateData.templateData, details);
	}
	disposeTemplate(templateData) {
		this.renderer.disposeTemplate(templateData.templateData);
	}
	dispose() {
		this.renderedNodes.clear();
	}
};
function asTreeEvent(e) {
	return {
		browserEvent: e.browserEvent,
		elements: e.elements.map((e) => e.element)
	};
}
function asTreeMouseEvent(e) {
	return {
		browserEvent: e.browserEvent,
		element: e.element && e.element.element,
		target: e.target
	};
}
var AsyncDataTreeElementsDragAndDropData = class extends ElementsDragAndDropData {
	constructor(data) {
		super(data.elements.map((node) => node.element));
		this.data = data;
	}
};
function asAsyncDataTreeDragAndDropData(data) {
	if (data instanceof ElementsDragAndDropData) return new AsyncDataTreeElementsDragAndDropData(data);
	return data;
}
var AsyncDataTreeNodeListDragAndDrop = class {
	constructor(dnd) {
		this.dnd = dnd;
	}
	getDragURI(node) {
		return this.dnd.getDragURI(node.element);
	}
	getDragLabel(nodes, originalEvent) {
		if (this.dnd.getDragLabel) return this.dnd.getDragLabel(nodes.map((node) => node.element), originalEvent);
	}
	onDragStart(data, originalEvent) {
		this.dnd.onDragStart?.(asAsyncDataTreeDragAndDropData(data), originalEvent);
	}
	onDragOver(data, targetNode, targetIndex, targetSector, originalEvent, raw = true) {
		return this.dnd.onDragOver(asAsyncDataTreeDragAndDropData(data), targetNode && targetNode.element, targetIndex, targetSector, originalEvent);
	}
	drop(data, targetNode, targetIndex, targetSector, originalEvent) {
		this.dnd.drop(asAsyncDataTreeDragAndDropData(data), targetNode && targetNode.element, targetIndex, targetSector, originalEvent);
	}
	onDragEnd(originalEvent) {
		this.dnd.onDragEnd?.(originalEvent);
	}
	dispose() {
		this.dnd.dispose();
	}
};
var AsyncFindFilter = class extends FindFilter {
	constructor(findProvider, keyboardNavigationLabelProvider, filter) {
		super(keyboardNavigationLabelProvider, filter);
		this.findProvider = findProvider;
		this.isFindSessionActive = false;
	}
	filter(element, parentVisibility) {
		const filterResult = super.filter(element, parentVisibility);
		if (!this.isFindSessionActive || this.findMode === TreeFindMode.Highlight || !this.findProvider.isVisible) return filterResult;
		if (getVisibleState(isFilterResult(filterResult) ? filterResult.visibility : filterResult) === 0) return 0;
		return this.findProvider.isVisible(element) ? filterResult : 0;
	}
};
var AsyncFindController = class extends FindController {
	constructor(tree, findProvider, filter, contextViewProvider, options) {
		super(tree, filter, contextViewProvider, options);
		this.findProvider = findProvider;
		this.filter = filter;
		this.activeSession = false;
		this.asyncWorkInProgress = false;
		this.disposables.add(toDisposable(async () => {
			if (this.activeSession) await this.findProvider.endSession?.();
		}));
	}
	render() {
		if (this.asyncWorkInProgress || !this.activeFindMetadata) return;
		const showNotFound = this.activeFindMetadata.matchCount === 0 && this.pattern.length > 0;
		this.renderMessage(showNotFound);
		if (this.pattern.length) this.alertResults(this.activeFindMetadata.matchCount);
	}
	shouldAllowFocus(node) {
		return this.shouldFocusWhenNavigating(node);
	}
	shouldFocusWhenNavigating(node) {
		if (!this.activeSession || !this.activeFindMetadata) return true;
		const element = node.element?.element;
		if (element && this.activeFindMetadata.isMatch(element)) return true;
		return !FuzzyScore.isDefault(node.filterData);
	}
};
function asObjectTreeOptions(options) {
	return options && {
		...options,
		collapseByDefault: true,
		identityProvider: options.identityProvider && {
			getId(el) {
				return options.identityProvider.getId(el.element);
			},
			getGroupId: options.identityProvider.getGroupId ? (el) => {
				return options.identityProvider.getGroupId(el.element);
			} : void 0
		},
		dnd: options.dnd && new AsyncDataTreeNodeListDragAndDrop(options.dnd),
		multipleSelectionController: options.multipleSelectionController && {
			isSelectionSingleChangeEvent(e) {
				return options.multipleSelectionController.isSelectionSingleChangeEvent({
					...e,
					element: e.element
				});
			},
			isSelectionRangeChangeEvent(e) {
				return options.multipleSelectionController.isSelectionRangeChangeEvent({
					...e,
					element: e.element
				});
			}
		},
		accessibilityProvider: options.accessibilityProvider && {
			...options.accessibilityProvider,
			getPosInSet: void 0,
			getSetSize: void 0,
			getRole: options.accessibilityProvider.getRole ? (el) => {
				return options.accessibilityProvider.getRole(el.element);
			} : () => "treeitem",
			isChecked: options.accessibilityProvider.isChecked ? (e) => {
				return !!options.accessibilityProvider?.isChecked(e.element);
			} : void 0,
			getAriaLabel(e) {
				return options.accessibilityProvider.getAriaLabel(e.element);
			},
			getWidgetAriaLabel() {
				return options.accessibilityProvider.getWidgetAriaLabel();
			},
			getWidgetRole: options.accessibilityProvider.getWidgetRole ? () => options.accessibilityProvider.getWidgetRole() : () => "tree",
			getAriaLevel: options.accessibilityProvider.getAriaLevel && ((node) => {
				return options.accessibilityProvider.getAriaLevel(node.element);
			}),
			getActiveDescendantId: options.accessibilityProvider.getActiveDescendantId && ((node) => {
				return options.accessibilityProvider.getActiveDescendantId(node.element);
			})
		},
		filter: options.filter && { filter(e, parentVisibility) {
			return options.filter.filter(e.element, parentVisibility);
		} },
		keyboardNavigationLabelProvider: options.keyboardNavigationLabelProvider && {
			...options.keyboardNavigationLabelProvider,
			getKeyboardNavigationLabel(e) {
				return options.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(e.element);
			}
		},
		stickyScrollNodeSourceRangeProvider: options.stickyScrollNodeSourceRangeProvider && ((e, defaultRange) => options.stickyScrollNodeSourceRangeProvider(e.element, defaultRange)),
		sorter: void 0,
		expandOnlyOnTwistieClick: typeof options.expandOnlyOnTwistieClick === "undefined" ? void 0 : typeof options.expandOnlyOnTwistieClick !== "function" ? options.expandOnlyOnTwistieClick : ((e) => options.expandOnlyOnTwistieClick(e.element)),
		twistieAdditionalCssClass: typeof options.twistieAdditionalCssClass === "undefined" ? void 0 : ((e) => options.twistieAdditionalCssClass(e.element)),
		defaultFindVisibility: (e) => {
			if (e.hasChildren && e.stale) return 1;
			else if (typeof options.defaultFindVisibility === "number") return options.defaultFindVisibility;
			else if (typeof options.defaultFindVisibility === "undefined") return 2;
			else return options.defaultFindVisibility(e.element);
		},
		stickyScrollDelegate: options.stickyScrollDelegate
	};
}
function dfs(node, fn) {
	fn(node);
	node.children.forEach((child) => dfs(child, fn));
}
var AsyncDataTree = class {
	get onDidScroll() {
		return this.tree.onDidScroll;
	}
	get onDidChangeFocus() {
		return Event.map(this.tree.onDidChangeFocus, asTreeEvent);
	}
	get onDidChangeSelection() {
		return Event.map(this.tree.onDidChangeSelection, asTreeEvent);
	}
	get onMouseDblClick() {
		return Event.map(this.tree.onMouseDblClick, asTreeMouseEvent);
	}
	get onPointer() {
		return Event.map(this.tree.onPointer, asTreeMouseEvent);
	}
	get onDidFocus() {
		return this.tree.onDidFocus;
	}
	/**
	* To be used internally only!
	* @deprecated
	*/
	get onDidChangeModel() {
		return this.tree.onDidChangeModel;
	}
	get onDidChangeCollapseState() {
		return this.tree.onDidChangeCollapseState;
	}
	get onDidChangeStickyScrollFocused() {
		return this.tree.onDidChangeStickyScrollFocused;
	}
	get onDidDispose() {
		return this.tree.onDidDispose;
	}
	constructor(user, container, delegate, renderers, dataSource, options = {}) {
		this.user = user;
		this.dataSource = dataSource;
		this.nodes = /* @__PURE__ */ new Map();
		this.subTreeRefreshPromises = /* @__PURE__ */ new Map();
		this.refreshPromises = /* @__PURE__ */ new Map();
		this._onDidRender = new Emitter$1();
		this._onDidChangeNodeSlowState = new Emitter$1();
		this.nodeMapper = new WeakMapper((node) => new AsyncDataTreeNodeWrapper(node));
		this.disposables = new DisposableStore();
		this.identityProvider = options.identityProvider;
		this.autoExpandSingleChildren = typeof options.autoExpandSingleChildren === "undefined" ? false : options.autoExpandSingleChildren;
		this.sorter = options.sorter;
		this.getDefaultCollapseState = (e) => options.collapseByDefault ? options.collapseByDefault(e) ? ObjectTreeElementCollapseState.PreserveOrCollapsed : ObjectTreeElementCollapseState.PreserveOrExpanded : void 0;
		let asyncFindEnabled = false;
		let findFilter;
		if (options.findProvider && (options.findWidgetEnabled ?? true) && options.keyboardNavigationLabelProvider && options.contextViewProvider) {
			asyncFindEnabled = true;
			findFilter = new AsyncFindFilter(options.findProvider, options.keyboardNavigationLabelProvider, options.filter);
		}
		this.tree = this.createTree(user, container, delegate, renderers, {
			...options,
			findWidgetEnabled: !asyncFindEnabled,
			filter: findFilter ?? options.filter
		});
		this.root = createAsyncDataTreeNode({
			element: void 0,
			parent: null,
			hasChildren: true,
			defaultCollapseState: void 0
		});
		if (this.identityProvider) this.root = {
			...this.root,
			id: null
		};
		this.nodes.set(null, this.root);
		this.tree.onDidChangeCollapseState(this._onDidChangeCollapseState, this, this.disposables);
		if (asyncFindEnabled) {
			const findOptions = {
				styles: options.findWidgetStyles,
				showNotFoundMessage: options.showNotFoundMessage,
				defaultFindMatchType: options.defaultFindMatchType,
				defaultFindMode: options.defaultFindMode
			};
			this.findController = this.disposables.add(new AsyncFindController(this.tree, options.findProvider, findFilter, this.tree.options.contextViewProvider, findOptions));
			this.focusNavigationFilter = (node) => this.findController.shouldFocusWhenNavigating(node);
			this.onDidChangeFindOpenState = this.findController.onDidChangeOpenState;
			this.onDidChangeFindMode = this.findController.onDidChangeMode;
			this.onDidChangeFindMatchType = this.findController.onDidChangeMatchType;
		} else {
			this.onDidChangeFindOpenState = this.tree.onDidChangeFindOpenState;
			this.onDidChangeFindMode = this.tree.onDidChangeFindMode;
			this.onDidChangeFindMatchType = this.tree.onDidChangeFindMatchType;
		}
	}
	createTree(user, container, delegate, renderers, options) {
		return new ObjectTree(user, container, new ComposedTreeDelegate(delegate), renderers.map((r) => new AsyncDataTreeRenderer(r, this.nodeMapper, this._onDidChangeNodeSlowState.event)), asObjectTreeOptions(options) || {});
	}
	updateOptions(optionsUpdate = {}) {
		if (this.findController) {
			if (optionsUpdate.defaultFindMode !== void 0) this.findController.mode = optionsUpdate.defaultFindMode;
			if (optionsUpdate.defaultFindMatchType !== void 0) this.findController.matchType = optionsUpdate.defaultFindMatchType;
		}
		this.tree.updateOptions(optionsUpdate);
	}
	getHTMLElement() {
		return this.tree.getHTMLElement();
	}
	get scrollTop() {
		return this.tree.scrollTop;
	}
	set scrollTop(scrollTop) {
		this.tree.scrollTop = scrollTop;
	}
	get scrollHeight() {
		return this.tree.scrollHeight;
	}
	get renderHeight() {
		return this.tree.renderHeight;
	}
	domFocus() {
		this.tree.domFocus();
	}
	layout(height, width) {
		this.tree.layout(height, width);
	}
	style(styles) {
		this.tree.style(styles);
	}
	getInput() {
		return this.root.element;
	}
	async setInput(input, viewState) {
		this.cancelAllRefreshPromises();
		this.root.element = input;
		const viewStateContext = viewState && {
			viewState,
			focus: [],
			selection: []
		};
		await this._updateChildren(input, true, false, viewStateContext);
		if (viewStateContext) {
			this.tree.setFocus(viewStateContext.focus);
			this.tree.setSelection(viewStateContext.selection);
		}
		if (viewState && typeof viewState.scrollTop === "number") this.scrollTop = viewState.scrollTop;
	}
	cancelAllRefreshPromises(includeSubTrees = false) {
		this.refreshPromises.forEach((promise) => promise.cancel());
		this.refreshPromises.clear();
		if (includeSubTrees) {
			this.subTreeRefreshPromises.forEach((promise) => promise.cancel());
			this.subTreeRefreshPromises.clear();
		}
	}
	async _updateChildren(element = this.root.element, recursive = true, rerender = false, viewStateContext, options) {
		if (typeof this.root.element === "undefined") throw new TreeError(this.user, "Tree input not set");
		if (this.root.refreshPromise) {
			await this.root.refreshPromise;
			await Event.toPromise(this._onDidRender.event);
		}
		const node = this.getDataNode(element);
		await this.refreshAndRenderNode(node, recursive, viewStateContext, options);
		if (rerender) try {
			this.tree.rerender(node);
		} catch {}
	}
	rerender(element) {
		if (element === void 0 || element === this.root.element) {
			this.tree.rerender();
			return;
		}
		const node = this.getDataNode(element);
		this.tree.rerender(node);
	}
	getNode(element = this.root.element) {
		const dataNode = this.getDataNode(element);
		const node = this.tree.getNode(dataNode === this.root ? null : dataNode);
		return this.nodeMapper.map(node);
	}
	collapse(element, recursive = false) {
		const node = this.getDataNode(element);
		return this.tree.collapse(node === this.root ? null : node, recursive);
	}
	async expand(element, recursive = false) {
		if (typeof this.root.element === "undefined") throw new TreeError(this.user, "Tree input not set");
		if (this.root.refreshPromise) {
			await this.root.refreshPromise;
			await Event.toPromise(this._onDidRender.event);
		}
		const node = this.getDataNode(element);
		if (this.tree.hasElement(node) && !this.tree.isCollapsible(node)) return false;
		if (node.refreshPromise) {
			await node.refreshPromise;
			await Event.toPromise(this._onDidRender.event);
		}
		if (node !== this.root && !node.refreshPromise && !this.tree.isCollapsed(node)) return false;
		const result = this.tree.expand(node === this.root ? null : node, recursive);
		if (node.refreshPromise) {
			await node.refreshPromise;
			await Event.toPromise(this._onDidRender.event);
		}
		return result;
	}
	setSelection(elements, browserEvent) {
		const nodes = elements.map((e) => this.getDataNode(e));
		this.tree.setSelection(nodes, browserEvent);
	}
	getSelection() {
		return this.tree.getSelection().map((n) => n.element);
	}
	setFocus(elements, browserEvent) {
		const nodes = elements.map((e) => this.getDataNode(e));
		this.tree.setFocus(nodes, browserEvent);
	}
	getFocus() {
		return this.tree.getFocus().map((n) => n.element);
	}
	reveal(element, relativeTop) {
		this.tree.reveal(this.getDataNode(element), relativeTop);
	}
	getParentElement(element) {
		const node = this.tree.getParentElement(this.getDataNode(element));
		return node && node.element;
	}
	getFirstElementChild(element = this.root.element) {
		const dataNode = this.getDataNode(element);
		const node = this.tree.getFirstElementChild(dataNode === this.root ? null : dataNode);
		return node && node.element;
	}
	getDataNode(element) {
		const node = this.nodes.get(element === this.root.element ? null : element);
		if (!node) {
			const nodeIdentity = this.identityProvider?.getId(element).toString();
			throw new TreeError(this.user, `Data tree node not found${nodeIdentity ? `: ${nodeIdentity}` : ""}`);
		}
		return node;
	}
	async refreshAndRenderNode(node, recursive, viewStateContext, options) {
		if (this.disposables.isDisposed) return;
		await this.refreshNode(node, recursive, viewStateContext);
		if (this.disposables.isDisposed) return;
		this.render(node, viewStateContext, options);
	}
	async refreshNode(node, recursive, viewStateContext) {
		let result;
		this.subTreeRefreshPromises.forEach((refreshPromise, refreshNode) => {
			if (!result && intersects(refreshNode, node)) result = refreshPromise.then(() => this.refreshNode(node, recursive, viewStateContext));
		});
		if (result) return result;
		if (node !== this.root) {
			if (this.tree.getNode(node).collapsed) {
				node.hasChildren = !!this.dataSource.hasChildren(node.element);
				node.stale = true;
				this.setChildren(node, [], recursive, viewStateContext);
				return;
			}
		}
		return this.doRefreshSubTree(node, recursive, viewStateContext);
	}
	async doRefreshSubTree(node, recursive, viewStateContext) {
		const cancelablePromise = createCancelablePromise(async () => {
			const childrenToRefresh = await this.doRefreshNode(node, recursive, viewStateContext);
			node.stale = false;
			await Promises.settled(childrenToRefresh.map((child) => this.doRefreshSubTree(child, recursive, viewStateContext)));
		});
		node.refreshPromise = cancelablePromise;
		this.subTreeRefreshPromises.set(node, cancelablePromise);
		cancelablePromise.finally(() => {
			node.refreshPromise = void 0;
			this.subTreeRefreshPromises.delete(node);
		});
		return cancelablePromise;
	}
	async doRefreshNode(node, recursive, viewStateContext) {
		node.hasChildren = !!this.dataSource.hasChildren(node.element);
		let childrenPromise;
		if (!node.hasChildren) childrenPromise = Promise.resolve(Iterable.empty());
		else {
			const children = this.doGetChildren(node);
			if (isIterable(children)) childrenPromise = Promise.resolve(children);
			else {
				const slowTimeout = timeout(800);
				slowTimeout.then(() => {
					node.slow = true;
					this._onDidChangeNodeSlowState.fire(node);
				}, (_) => null);
				childrenPromise = children.finally(() => slowTimeout.cancel());
			}
		}
		try {
			const children = await childrenPromise;
			return this.setChildren(node, children, recursive, viewStateContext);
		} catch (err) {
			if (node !== this.root && this.tree.hasElement(node)) this.tree.collapse(node);
			if (isCancellationError(err)) return [];
			throw err;
		} finally {
			if (node.slow) {
				node.slow = false;
				this._onDidChangeNodeSlowState.fire(node);
			}
		}
	}
	doGetChildren(node) {
		let result = this.refreshPromises.get(node);
		if (result) return result;
		const children = this.dataSource.getChildren(node.element);
		if (isIterable(children)) return this.processChildren(children);
		else {
			result = createCancelablePromise(async () => this.processChildren(await children));
			this.refreshPromises.set(node, result);
			return result.finally(() => {
				this.refreshPromises.delete(node);
			});
		}
	}
	_onDidChangeCollapseState({ node, deep }) {
		if (node.element === null) return;
		if (!node.collapsed && node.element.stale) {
			if (deep) this.collapse(node.element.element);
			else this.refreshAndRenderNode(node.element, false).catch(onUnexpectedError);
		}
	}
	setChildren(node, childrenElementsIterable, recursive, viewStateContext) {
		const childrenElements = [...childrenElementsIterable];
		if (node.children.length === 0 && childrenElements.length === 0) return [];
		const nodesToForget = /* @__PURE__ */ new Map();
		const childrenTreeNodesById = /* @__PURE__ */ new Map();
		for (const child of node.children) {
			nodesToForget.set(child.element, child);
			if (this.identityProvider) childrenTreeNodesById.set(child.id, {
				node: child,
				collapsed: this.tree.hasElement(child) && this.tree.isCollapsed(child)
			});
		}
		const childrenToRefresh = [];
		const children = childrenElements.map((element) => {
			const hasChildren = !!this.dataSource.hasChildren(element);
			if (!this.identityProvider) {
				const asyncDataTreeNode = createAsyncDataTreeNode({
					element,
					parent: node,
					hasChildren,
					defaultCollapseState: this.getDefaultCollapseState(element)
				});
				if (hasChildren && asyncDataTreeNode.defaultCollapseState === ObjectTreeElementCollapseState.PreserveOrExpanded) childrenToRefresh.push(asyncDataTreeNode);
				return asyncDataTreeNode;
			}
			const id = this.identityProvider.getId(element).toString();
			const result = childrenTreeNodesById.get(id);
			if (result) {
				const asyncDataTreeNode = result.node;
				nodesToForget.delete(asyncDataTreeNode.element);
				this.nodes.delete(asyncDataTreeNode.element);
				this.nodes.set(element, asyncDataTreeNode);
				asyncDataTreeNode.element = element;
				asyncDataTreeNode.hasChildren = hasChildren;
				if (recursive) {
					if (result.collapsed) {
						asyncDataTreeNode.children.forEach((node) => dfs(node, (node) => this.nodes.delete(node.element)));
						asyncDataTreeNode.children.splice(0, asyncDataTreeNode.children.length);
						asyncDataTreeNode.stale = true;
					} else childrenToRefresh.push(asyncDataTreeNode);
				} else if (hasChildren && !result.collapsed) childrenToRefresh.push(asyncDataTreeNode);
				return asyncDataTreeNode;
			}
			const childAsyncDataTreeNode = createAsyncDataTreeNode({
				element,
				parent: node,
				id,
				hasChildren,
				defaultCollapseState: this.getDefaultCollapseState(element)
			});
			if (viewStateContext && viewStateContext.viewState.focus && viewStateContext.viewState.focus.indexOf(id) > -1) viewStateContext.focus.push(childAsyncDataTreeNode);
			if (viewStateContext && viewStateContext.viewState.selection && viewStateContext.viewState.selection.indexOf(id) > -1) viewStateContext.selection.push(childAsyncDataTreeNode);
			if (viewStateContext && viewStateContext.viewState.expanded && viewStateContext.viewState.expanded.indexOf(id) > -1) childrenToRefresh.push(childAsyncDataTreeNode);
			else if (hasChildren && childAsyncDataTreeNode.defaultCollapseState === ObjectTreeElementCollapseState.PreserveOrExpanded) childrenToRefresh.push(childAsyncDataTreeNode);
			return childAsyncDataTreeNode;
		});
		for (const node of nodesToForget.values()) dfs(node, (node) => this.nodes.delete(node.element));
		for (const child of children) this.nodes.set(child.element, child);
		splice$1(node.children, 0, node.children.length, children);
		if (node !== this.root && this.autoExpandSingleChildren && children.length === 1 && childrenToRefresh.length === 0) {
			children[0].forceExpanded = true;
			childrenToRefresh.push(children[0]);
		}
		return childrenToRefresh;
	}
	render(node, viewStateContext, options) {
		const children = node.children.map((node) => this.asTreeElement(node, viewStateContext));
		const objectTreeOptions = options && {
			...options,
			diffIdentityProvider: options.diffIdentityProvider && {
				getId(node) {
					return options.diffIdentityProvider.getId(node.element);
				},
				getGroupId: options.diffIdentityProvider.getGroupId ? (node) => {
					return options.diffIdentityProvider.getGroupId(node.element);
				} : void 0
			}
		};
		this.tree.setChildren(node === this.root ? null : node, children, objectTreeOptions);
		if (node !== this.root) this.tree.setCollapsible(node, node.hasChildren);
		this._onDidRender.fire();
	}
	asTreeElement(node, viewStateContext) {
		if (node.stale) return {
			element: node,
			collapsible: node.hasChildren,
			collapsed: true
		};
		let collapsed;
		if (viewStateContext && viewStateContext.viewState.expanded && node.id && viewStateContext.viewState.expanded.indexOf(node.id) > -1) collapsed = false;
		else if (node.forceExpanded) {
			collapsed = false;
			node.forceExpanded = false;
		} else collapsed = node.defaultCollapseState;
		return {
			element: node,
			children: node.hasChildren ? Iterable.map(node.children, (child) => this.asTreeElement(child, viewStateContext)) : [],
			collapsible: node.hasChildren,
			collapsed
		};
	}
	processChildren(children) {
		if (this.sorter) children = [...children].sort(this.sorter.compare.bind(this.sorter));
		return children;
	}
	dispose() {
		this._onDidRender.dispose();
		this._onDidChangeNodeSlowState.dispose();
		this.disposables.dispose();
		this.tree.dispose();
	}
};
var CompressibleAsyncDataTreeNodeWrapper = class CompressibleAsyncDataTreeNodeWrapper {
	get element() {
		return {
			elements: this.node.element.elements.map((e) => e.element),
			incompressible: this.node.element.incompressible
		};
	}
	get children() {
		return this.node.children.map((node) => new CompressibleAsyncDataTreeNodeWrapper(node));
	}
	get depth() {
		return this.node.depth;
	}
	get visibleChildrenCount() {
		return this.node.visibleChildrenCount;
	}
	get visibleChildIndex() {
		return this.node.visibleChildIndex;
	}
	get collapsible() {
		return this.node.collapsible;
	}
	get collapsed() {
		return this.node.collapsed;
	}
	get visible() {
		return this.node.visible;
	}
	get filterData() {
		return this.node.filterData;
	}
	constructor(node) {
		this.node = node;
	}
};
var CompressibleAsyncDataTreeRenderer = class {
	constructor(renderer, nodeMapper, compressibleNodeMapperProvider, onDidChangeTwistieState) {
		this.renderer = renderer;
		this.nodeMapper = nodeMapper;
		this.compressibleNodeMapperProvider = compressibleNodeMapperProvider;
		this.onDidChangeTwistieState = onDidChangeTwistieState;
		this.renderedNodes = /* @__PURE__ */ new Map();
		this.disposables = [];
		this.templateId = renderer.templateId;
	}
	renderTemplate(container) {
		return { templateData: this.renderer.renderTemplate(container) };
	}
	renderElement(node, index, templateData, details) {
		this.renderer.renderElement(this.nodeMapper.map(node), index, templateData.templateData, details);
	}
	renderCompressedElements(node, index, templateData, details) {
		this.renderer.renderCompressedElements(this.compressibleNodeMapperProvider().map(node), index, templateData.templateData, details);
	}
	renderTwistie(element, twistieElement) {
		if (element.slow) {
			twistieElement.classList.add(...ThemeIcon.asClassNameArray(Codicon.treeItemLoading));
			return true;
		} else {
			twistieElement.classList.remove(...ThemeIcon.asClassNameArray(Codicon.treeItemLoading));
			return false;
		}
	}
	disposeElement(node, index, templateData, details) {
		this.renderer.disposeElement?.(this.nodeMapper.map(node), index, templateData.templateData, details);
	}
	disposeCompressedElements(node, index, templateData, details) {
		this.renderer.disposeCompressedElements?.(this.compressibleNodeMapperProvider().map(node), index, templateData.templateData, details);
	}
	disposeTemplate(templateData) {
		this.renderer.disposeTemplate(templateData.templateData);
	}
	dispose() {
		this.renderedNodes.clear();
		this.disposables = dispose(this.disposables);
	}
};
function asCompressibleObjectTreeOptions(options) {
	const objectTreeOptions = options && asObjectTreeOptions(options);
	return objectTreeOptions && {
		...objectTreeOptions,
		keyboardNavigationLabelProvider: objectTreeOptions.keyboardNavigationLabelProvider && {
			...objectTreeOptions.keyboardNavigationLabelProvider,
			getCompressedNodeKeyboardNavigationLabel(els) {
				return options.keyboardNavigationLabelProvider.getCompressedNodeKeyboardNavigationLabel(els.map((e) => e.element));
			}
		},
		stickyScrollDelegate: objectTreeOptions.stickyScrollDelegate
	};
}
var CompressibleAsyncDataTree = class extends AsyncDataTree {
	constructor(user, container, virtualDelegate, compressionDelegate, renderers, dataSource, options = {}) {
		super(user, container, virtualDelegate, renderers, dataSource, options);
		this.compressionDelegate = compressionDelegate;
		this.compressibleNodeMapper = new WeakMapper((node) => new CompressibleAsyncDataTreeNodeWrapper(node));
		this.filter = options.filter;
	}
	createTree(user, container, delegate, renderers, options) {
		return new CompressibleObjectTree(user, container, new ComposedTreeDelegate(delegate), renderers.map((r) => new CompressibleAsyncDataTreeRenderer(r, this.nodeMapper, () => this.compressibleNodeMapper, this._onDidChangeNodeSlowState.event)), asCompressibleObjectTreeOptions(options) || {});
	}
	asTreeElement(node, viewStateContext) {
		return {
			incompressible: this.compressionDelegate.isIncompressible(node.element),
			...super.asTreeElement(node, viewStateContext)
		};
	}
	render(node, viewStateContext, options) {
		if (!this.identityProvider) return super.render(node, viewStateContext);
		const getId = (element) => this.identityProvider.getId(element).toString();
		const getUncompressedIds = (nodes) => {
			const result = /* @__PURE__ */ new Set();
			for (const node of nodes) {
				const compressedNode = this.tree.getCompressedTreeNode(node === this.root ? null : node);
				if (!compressedNode.element) continue;
				for (const node of compressedNode.element.elements) result.add(getId(node.element));
			}
			return result;
		};
		const oldSelection = getUncompressedIds(this.tree.getSelection());
		const oldFocus = getUncompressedIds(this.tree.getFocus());
		super.render(node, viewStateContext, options);
		const selection = this.getSelection();
		let didChangeSelection = false;
		const focus = this.getFocus();
		let didChangeFocus = false;
		const visit = (node) => {
			const compressedNode = node.element;
			if (compressedNode) for (let i = 0; i < compressedNode.elements.length; i++) {
				const id = getId(compressedNode.elements[i].element);
				const element = compressedNode.elements[compressedNode.elements.length - 1].element;
				if (oldSelection.has(id) && selection.indexOf(element) === -1) {
					selection.push(element);
					didChangeSelection = true;
				}
				if (oldFocus.has(id) && focus.indexOf(element) === -1) {
					focus.push(element);
					didChangeFocus = true;
				}
			}
			node.children.forEach(visit);
		};
		visit(this.tree.getCompressedTreeNode(node === this.root ? null : node));
		if (didChangeSelection) this.setSelection(selection);
		if (didChangeFocus) this.setFocus(focus);
	}
	processChildren(children) {
		if (this.filter) children = Iterable.filter(children, (e) => {
			const visibility = getVisibility(this.filter.filter(e, 1));
			if (visibility === 2) throw new Error("Recursive tree visibility not supported in async data compressed trees");
			return visibility === 1;
		});
		return super.processChildren(children);
	}
};
function getVisibility(filterResult) {
	if (typeof filterResult === "boolean") return filterResult ? 1 : 0;
	else if (isFilterResult(filterResult)) return getVisibleState(filterResult.visibility);
	else return getVisibleState(filterResult);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/tree/dataTree.js
var DataTree = class extends AbstractTree {
	constructor(user, container, delegate, renderers, dataSource, options = {}) {
		super(user, container, delegate, renderers, options);
		this.user = user;
		this.dataSource = dataSource;
		this.identityProvider = options.identityProvider;
	}
	createModel(user, options) {
		return new ObjectTreeModel(user, options);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/list/browser/listService.js
var __decorate$30 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$29 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var IListService = createDecorator("listService");
var ListService = class {
	get lastFocusedList() {
		return this._lastFocusedWidget;
	}
	constructor() {
		this.disposables = new DisposableStore();
		this.lists = [];
		this._lastFocusedWidget = void 0;
	}
	setLastFocusedList(widget) {
		if (widget === this._lastFocusedWidget) return;
		this._lastFocusedWidget?.getHTMLElement().classList.remove("last-focused");
		this._lastFocusedWidget = widget;
		this._lastFocusedWidget?.getHTMLElement().classList.add("last-focused");
	}
	register(widget, extraContextKeys) {
		if (this.lists.some((l) => l.widget === widget)) throw new Error("Cannot register the same widget multiple times");
		const registeredList = {
			widget,
			extraContextKeys
		};
		this.lists.push(registeredList);
		if (isActiveElement(widget.getHTMLElement())) this.setLastFocusedList(widget);
		return combinedDisposable(widget.onDidFocus(() => this.setLastFocusedList(widget)), toDisposable(() => this.lists.splice(this.lists.indexOf(registeredList), 1)), widget.onDidDispose(() => {
			this.lists = this.lists.filter((l) => l !== registeredList);
			if (this._lastFocusedWidget === widget) this.setLastFocusedList(void 0);
		}));
	}
	dispose() {
		this.disposables.dispose();
	}
};
var RawWorkbenchListScrollAtBoundaryContextKey = new RawContextKey("listScrollAtBoundary", "none");
ContextKeyExpr.or(RawWorkbenchListScrollAtBoundaryContextKey.isEqualTo("top"), RawWorkbenchListScrollAtBoundaryContextKey.isEqualTo("both"));
ContextKeyExpr.or(RawWorkbenchListScrollAtBoundaryContextKey.isEqualTo("bottom"), RawWorkbenchListScrollAtBoundaryContextKey.isEqualTo("both"));
var RawWorkbenchListFocusContextKey = new RawContextKey("listFocus", true);
var WorkbenchTreeStickyScrollFocused = new RawContextKey("treestickyScrollFocused", false);
var WorkbenchListSupportsMultiSelectContextKey = new RawContextKey("listSupportsMultiselect", true);
var WorkbenchListFocusContextKey = ContextKeyExpr.and(RawWorkbenchListFocusContextKey, ContextKeyExpr.not(InputFocusedContextKey), WorkbenchTreeStickyScrollFocused.negate());
var WorkbenchListHasSelectionOrFocus = new RawContextKey("listHasSelectionOrFocus", false);
var WorkbenchListDoubleSelection = new RawContextKey("listDoubleSelection", false);
var WorkbenchListMultiSelection = new RawContextKey("listMultiSelection", false);
var WorkbenchListSelectionNavigation = new RawContextKey("listSelectionNavigation", false);
var WorkbenchListSupportsFind = new RawContextKey("listSupportsFind", true);
var WorkbenchTreeElementCanCollapse = new RawContextKey("treeElementCanCollapse", false);
var WorkbenchTreeElementHasParent = new RawContextKey("treeElementHasParent", false);
var WorkbenchTreeElementCanExpand = new RawContextKey("treeElementCanExpand", false);
var WorkbenchTreeElementHasChild = new RawContextKey("treeElementHasChild", false);
var WorkbenchTreeFindOpen = new RawContextKey("treeFindOpen", false);
var WorkbenchListTypeNavigationModeKey = "listTypeNavigationMode";
/**
* @deprecated in favor of WorkbenchListTypeNavigationModeKey
*/
var WorkbenchListAutomaticKeyboardNavigationLegacyKey = "listAutomaticKeyboardNavigation";
function createScopedContextKeyService(contextKeyService, widget) {
	const result = contextKeyService.createScoped(widget.getHTMLElement());
	RawWorkbenchListFocusContextKey.bindTo(result);
	return result;
}
function createScrollObserver(contextKeyService, widget) {
	const listScrollAt = RawWorkbenchListScrollAtBoundaryContextKey.bindTo(contextKeyService);
	const update = () => {
		const atTop = widget.scrollTop === 0;
		const atBottom = widget.scrollHeight - widget.renderHeight - widget.scrollTop < 1;
		if (atTop && atBottom) listScrollAt.set("both");
		else if (atTop) listScrollAt.set("top");
		else if (atBottom) listScrollAt.set("bottom");
		else listScrollAt.set("none");
	};
	update();
	return widget.onDidScroll(update);
}
var multiSelectModifierSettingKey = "workbench.list.multiSelectModifier";
var openModeSettingKey = "workbench.list.openMode";
var horizontalScrollingKey = "workbench.list.horizontalScrolling";
var defaultFindModeSettingKey = "workbench.list.defaultFindMode";
var typeNavigationModeSettingKey = "workbench.list.typeNavigationMode";
/** @deprecated in favor of `workbench.list.defaultFindMode` and `workbench.list.typeNavigationMode` */
var keyboardNavigationSettingKey = "workbench.list.keyboardNavigation";
var scrollByPageKey = "workbench.list.scrollByPage";
var defaultFindMatchTypeSettingKey = "workbench.list.defaultFindMatchType";
var treeIndentKey = "workbench.tree.indent";
var treeRenderIndentGuidesKey = "workbench.tree.renderIndentGuides";
var listSmoothScrolling = "workbench.list.smoothScrolling";
var mouseWheelScrollSensitivityKey = "workbench.list.mouseWheelScrollSensitivity";
var fastScrollSensitivityKey = "workbench.list.fastScrollSensitivity";
var treeExpandMode = "workbench.tree.expandMode";
var treeStickyScroll = "workbench.tree.enableStickyScroll";
var treeStickyScrollMaxElements = "workbench.tree.stickyScrollMaxItemCount";
function useAltAsMultipleSelectionModifier(configurationService) {
	return configurationService.getValue(multiSelectModifierSettingKey) === "alt";
}
var MultipleSelectionController = class extends Disposable {
	constructor(configurationService) {
		super();
		this.configurationService = configurationService;
		this.useAltAsMultipleSelectionModifier = useAltAsMultipleSelectionModifier(configurationService);
		this.registerListeners();
	}
	registerListeners() {
		this._register(this.configurationService.onDidChangeConfiguration((e) => {
			if (e.affectsConfiguration(multiSelectModifierSettingKey)) this.useAltAsMultipleSelectionModifier = useAltAsMultipleSelectionModifier(this.configurationService);
		}));
	}
	isSelectionSingleChangeEvent(event) {
		if (this.useAltAsMultipleSelectionModifier) return event.browserEvent.altKey;
		return isSelectionSingleChangeEvent(event);
	}
	isSelectionRangeChangeEvent(event) {
		return isSelectionRangeChangeEvent(event);
	}
};
function toWorkbenchListOptions(accessor, options) {
	const configurationService = accessor.get(IConfigurationService);
	const keybindingService = accessor.get(IKeybindingService);
	const disposables = new DisposableStore();
	return [{
		...options,
		keyboardNavigationDelegate: { mightProducePrintableCharacter(e) {
			return keybindingService.mightProducePrintableCharacter(e);
		} },
		smoothScrolling: Boolean(configurationService.getValue(listSmoothScrolling)),
		mouseWheelScrollSensitivity: configurationService.getValue(mouseWheelScrollSensitivityKey),
		fastScrollSensitivity: configurationService.getValue(fastScrollSensitivityKey),
		multipleSelectionController: options.multipleSelectionController ?? disposables.add(new MultipleSelectionController(configurationService)),
		keyboardNavigationEventFilter: createKeyboardNavigationEventFilter(keybindingService),
		scrollByPage: Boolean(configurationService.getValue(scrollByPageKey))
	}, disposables];
}
var WorkbenchList = class WorkbenchList extends List {
	constructor(user, container, delegate, renderers, options, contextKeyService, listService, configurationService, instantiationService) {
		const horizontalScrolling = typeof options.horizontalScrolling !== "undefined" ? options.horizontalScrolling : Boolean(configurationService.getValue(horizontalScrollingKey));
		const [workbenchListOptions, workbenchListOptionsDisposable] = instantiationService.invokeFunction(toWorkbenchListOptions, options);
		super(user, container, delegate, renderers, {
			keyboardSupport: false,
			...workbenchListOptions,
			horizontalScrolling
		});
		this.disposables.add(workbenchListOptionsDisposable);
		this.contextKeyService = createScopedContextKeyService(contextKeyService, this);
		this.disposables.add(createScrollObserver(this.contextKeyService, this));
		this.listSupportsMultiSelect = WorkbenchListSupportsMultiSelectContextKey.bindTo(this.contextKeyService);
		this.listSupportsMultiSelect.set(options.multipleSelectionSupport !== false);
		WorkbenchListSelectionNavigation.bindTo(this.contextKeyService).set(Boolean(options.selectionNavigation));
		this.listHasSelectionOrFocus = WorkbenchListHasSelectionOrFocus.bindTo(this.contextKeyService);
		this.listDoubleSelection = WorkbenchListDoubleSelection.bindTo(this.contextKeyService);
		this.listMultiSelection = WorkbenchListMultiSelection.bindTo(this.contextKeyService);
		this.horizontalScrolling = options.horizontalScrolling;
		this._useAltAsMultipleSelectionModifier = useAltAsMultipleSelectionModifier(configurationService);
		this.disposables.add(this.contextKeyService);
		this.disposables.add(listService.register(this));
		this.updateStyles(options.overrideStyles);
		this.disposables.add(this.onDidChangeSelection(() => {
			const selection = this.getSelection();
			const focus = this.getFocus();
			this.contextKeyService.bufferChangeEvents(() => {
				this.listHasSelectionOrFocus.set(selection.length > 0 || focus.length > 0);
				this.listMultiSelection.set(selection.length > 1);
				this.listDoubleSelection.set(selection.length === 2);
			});
		}));
		this.disposables.add(this.onDidChangeFocus(() => {
			const selection = this.getSelection();
			const focus = this.getFocus();
			this.listHasSelectionOrFocus.set(selection.length > 0 || focus.length > 0);
		}));
		this.disposables.add(configurationService.onDidChangeConfiguration((e) => {
			if (e.affectsConfiguration(multiSelectModifierSettingKey)) this._useAltAsMultipleSelectionModifier = useAltAsMultipleSelectionModifier(configurationService);
			let options = {};
			if (e.affectsConfiguration(horizontalScrollingKey) && this.horizontalScrolling === void 0) {
				const horizontalScrolling = Boolean(configurationService.getValue(horizontalScrollingKey));
				options = {
					...options,
					horizontalScrolling
				};
			}
			if (e.affectsConfiguration(scrollByPageKey)) {
				const scrollByPage = Boolean(configurationService.getValue(scrollByPageKey));
				options = {
					...options,
					scrollByPage
				};
			}
			if (e.affectsConfiguration(listSmoothScrolling)) {
				const smoothScrolling = Boolean(configurationService.getValue(listSmoothScrolling));
				options = {
					...options,
					smoothScrolling
				};
			}
			if (e.affectsConfiguration(mouseWheelScrollSensitivityKey)) {
				const mouseWheelScrollSensitivity = configurationService.getValue(mouseWheelScrollSensitivityKey);
				options = {
					...options,
					mouseWheelScrollSensitivity
				};
			}
			if (e.affectsConfiguration(fastScrollSensitivityKey)) {
				const fastScrollSensitivity = configurationService.getValue(fastScrollSensitivityKey);
				options = {
					...options,
					fastScrollSensitivity
				};
			}
			if (Object.keys(options).length > 0) this.updateOptions(options);
		}));
		this.navigator = new ListResourceNavigator(this, {
			configurationService,
			...options
		});
		this.disposables.add(this.navigator);
	}
	updateOptions(options) {
		super.updateOptions(options);
		if (options.overrideStyles !== void 0) this.updateStyles(options.overrideStyles);
		if (options.multipleSelectionSupport !== void 0) this.listSupportsMultiSelect.set(!!options.multipleSelectionSupport);
	}
	updateStyles(styles) {
		this.style(styles ? getListStyles(styles) : defaultListStyles);
	}
};
WorkbenchList = __decorate$30([
	__param$29(5, IContextKeyService),
	__param$29(6, IListService),
	__param$29(7, IConfigurationService),
	__param$29(8, IInstantiationService)
], WorkbenchList);
var WorkbenchPagedList = class WorkbenchPagedList extends PagedList {
	constructor(user, container, delegate, renderers, options, contextKeyService, listService, configurationService, instantiationService) {
		const horizontalScrolling = typeof options.horizontalScrolling !== "undefined" ? options.horizontalScrolling : Boolean(configurationService.getValue(horizontalScrollingKey));
		const [workbenchListOptions, workbenchListOptionsDisposable] = instantiationService.invokeFunction(toWorkbenchListOptions, options);
		super(user, container, delegate, renderers, {
			keyboardSupport: false,
			...workbenchListOptions,
			horizontalScrolling
		});
		this.disposables = new DisposableStore();
		this.disposables.add(workbenchListOptionsDisposable);
		this.contextKeyService = createScopedContextKeyService(contextKeyService, this);
		this.disposables.add(createScrollObserver(this.contextKeyService, this.widget));
		this.horizontalScrolling = options.horizontalScrolling;
		this.listSupportsMultiSelect = WorkbenchListSupportsMultiSelectContextKey.bindTo(this.contextKeyService);
		this.listSupportsMultiSelect.set(options.multipleSelectionSupport !== false);
		WorkbenchListSelectionNavigation.bindTo(this.contextKeyService).set(Boolean(options.selectionNavigation));
		this._useAltAsMultipleSelectionModifier = useAltAsMultipleSelectionModifier(configurationService);
		this.disposables.add(this.contextKeyService);
		this.disposables.add(listService.register(this));
		this.updateStyles(options.overrideStyles);
		this.disposables.add(configurationService.onDidChangeConfiguration((e) => {
			if (e.affectsConfiguration(multiSelectModifierSettingKey)) this._useAltAsMultipleSelectionModifier = useAltAsMultipleSelectionModifier(configurationService);
			let options = {};
			if (e.affectsConfiguration(horizontalScrollingKey) && this.horizontalScrolling === void 0) {
				const horizontalScrolling = Boolean(configurationService.getValue(horizontalScrollingKey));
				options = {
					...options,
					horizontalScrolling
				};
			}
			if (e.affectsConfiguration(scrollByPageKey)) {
				const scrollByPage = Boolean(configurationService.getValue(scrollByPageKey));
				options = {
					...options,
					scrollByPage
				};
			}
			if (e.affectsConfiguration(listSmoothScrolling)) {
				const smoothScrolling = Boolean(configurationService.getValue(listSmoothScrolling));
				options = {
					...options,
					smoothScrolling
				};
			}
			if (e.affectsConfiguration(mouseWheelScrollSensitivityKey)) {
				const mouseWheelScrollSensitivity = configurationService.getValue(mouseWheelScrollSensitivityKey);
				options = {
					...options,
					mouseWheelScrollSensitivity
				};
			}
			if (e.affectsConfiguration(fastScrollSensitivityKey)) {
				const fastScrollSensitivity = configurationService.getValue(fastScrollSensitivityKey);
				options = {
					...options,
					fastScrollSensitivity
				};
			}
			if (Object.keys(options).length > 0) this.updateOptions(options);
		}));
		this.navigator = new ListResourceNavigator(this, {
			configurationService,
			...options
		});
		this.disposables.add(this.navigator);
	}
	updateOptions(options) {
		super.updateOptions(options);
		if (options.overrideStyles !== void 0) this.updateStyles(options.overrideStyles);
		if (options.multipleSelectionSupport !== void 0) this.listSupportsMultiSelect.set(!!options.multipleSelectionSupport);
	}
	updateStyles(styles) {
		this.style(styles ? getListStyles(styles) : defaultListStyles);
	}
	dispose() {
		this.disposables.dispose();
		super.dispose();
	}
};
WorkbenchPagedList = __decorate$30([
	__param$29(5, IContextKeyService),
	__param$29(6, IListService),
	__param$29(7, IConfigurationService),
	__param$29(8, IInstantiationService)
], WorkbenchPagedList);
var WorkbenchTable = class WorkbenchTable extends Table {
	constructor(user, container, delegate, columns, renderers, options, contextKeyService, listService, configurationService, instantiationService) {
		const horizontalScrolling = typeof options.horizontalScrolling !== "undefined" ? options.horizontalScrolling : Boolean(configurationService.getValue(horizontalScrollingKey));
		const [workbenchListOptions, workbenchListOptionsDisposable] = instantiationService.invokeFunction(toWorkbenchListOptions, options);
		super(user, container, delegate, columns, renderers, {
			keyboardSupport: false,
			...workbenchListOptions,
			horizontalScrolling
		});
		this.disposables.add(workbenchListOptionsDisposable);
		this.contextKeyService = createScopedContextKeyService(contextKeyService, this);
		this.disposables.add(createScrollObserver(this.contextKeyService, this));
		this.listSupportsMultiSelect = WorkbenchListSupportsMultiSelectContextKey.bindTo(this.contextKeyService);
		this.listSupportsMultiSelect.set(options.multipleSelectionSupport !== false);
		WorkbenchListSelectionNavigation.bindTo(this.contextKeyService).set(Boolean(options.selectionNavigation));
		this.listHasSelectionOrFocus = WorkbenchListHasSelectionOrFocus.bindTo(this.contextKeyService);
		this.listDoubleSelection = WorkbenchListDoubleSelection.bindTo(this.contextKeyService);
		this.listMultiSelection = WorkbenchListMultiSelection.bindTo(this.contextKeyService);
		this.horizontalScrolling = options.horizontalScrolling;
		this._useAltAsMultipleSelectionModifier = useAltAsMultipleSelectionModifier(configurationService);
		this.disposables.add(this.contextKeyService);
		this.disposables.add(listService.register(this));
		this.updateStyles(options.overrideStyles);
		this.disposables.add(this.onDidChangeSelection(() => {
			const selection = this.getSelection();
			const focus = this.getFocus();
			this.contextKeyService.bufferChangeEvents(() => {
				this.listHasSelectionOrFocus.set(selection.length > 0 || focus.length > 0);
				this.listMultiSelection.set(selection.length > 1);
				this.listDoubleSelection.set(selection.length === 2);
			});
		}));
		this.disposables.add(this.onDidChangeFocus(() => {
			const selection = this.getSelection();
			const focus = this.getFocus();
			this.listHasSelectionOrFocus.set(selection.length > 0 || focus.length > 0);
		}));
		this.disposables.add(configurationService.onDidChangeConfiguration((e) => {
			if (e.affectsConfiguration(multiSelectModifierSettingKey)) this._useAltAsMultipleSelectionModifier = useAltAsMultipleSelectionModifier(configurationService);
			let options = {};
			if (e.affectsConfiguration(horizontalScrollingKey) && this.horizontalScrolling === void 0) {
				const horizontalScrolling = Boolean(configurationService.getValue(horizontalScrollingKey));
				options = {
					...options,
					horizontalScrolling
				};
			}
			if (e.affectsConfiguration(scrollByPageKey)) {
				const scrollByPage = Boolean(configurationService.getValue(scrollByPageKey));
				options = {
					...options,
					scrollByPage
				};
			}
			if (e.affectsConfiguration(listSmoothScrolling)) {
				const smoothScrolling = Boolean(configurationService.getValue(listSmoothScrolling));
				options = {
					...options,
					smoothScrolling
				};
			}
			if (e.affectsConfiguration(mouseWheelScrollSensitivityKey)) {
				const mouseWheelScrollSensitivity = configurationService.getValue(mouseWheelScrollSensitivityKey);
				options = {
					...options,
					mouseWheelScrollSensitivity
				};
			}
			if (e.affectsConfiguration(fastScrollSensitivityKey)) {
				const fastScrollSensitivity = configurationService.getValue(fastScrollSensitivityKey);
				options = {
					...options,
					fastScrollSensitivity
				};
			}
			if (Object.keys(options).length > 0) this.updateOptions(options);
		}));
		this.navigator = new TableResourceNavigator(this, {
			configurationService,
			...options
		});
		this.disposables.add(this.navigator);
	}
	updateOptions(options) {
		super.updateOptions(options);
		if (options.overrideStyles !== void 0) this.updateStyles(options.overrideStyles);
		if (options.multipleSelectionSupport !== void 0) this.listSupportsMultiSelect.set(!!options.multipleSelectionSupport);
	}
	updateStyles(styles) {
		this.style(styles ? getListStyles(styles) : defaultListStyles);
	}
	dispose() {
		this.disposables.dispose();
		super.dispose();
	}
};
WorkbenchTable = __decorate$30([
	__param$29(6, IContextKeyService),
	__param$29(7, IListService),
	__param$29(8, IConfigurationService),
	__param$29(9, IInstantiationService)
], WorkbenchTable);
var ResourceNavigator = class extends Disposable {
	constructor(widget, options) {
		super();
		this.widget = widget;
		this._onDidOpen = this._register(new Emitter$1());
		this.onDidOpen = this._onDidOpen.event;
		this._register(Event.filter(this.widget.onDidChangeSelection, (e) => isKeyboardEvent(e.browserEvent))((e) => this.onSelectionFromKeyboard(e)));
		this._register(this.widget.onPointer((e) => this.onPointer(e.element, e.browserEvent)));
		this._register(this.widget.onMouseDblClick((e) => this.onMouseDblClick(e.element, e.browserEvent)));
		if (typeof options?.openOnSingleClick !== "boolean" && options?.configurationService) {
			this.openOnSingleClick = options?.configurationService.getValue(openModeSettingKey) !== "doubleClick";
			this._register(options?.configurationService.onDidChangeConfiguration((e) => {
				if (e.affectsConfiguration(openModeSettingKey)) this.openOnSingleClick = options?.configurationService.getValue(openModeSettingKey) !== "doubleClick";
			}));
		} else this.openOnSingleClick = options?.openOnSingleClick ?? true;
	}
	onSelectionFromKeyboard(event) {
		if (event.elements.length !== 1) return;
		const selectionKeyboardEvent = event.browserEvent;
		const preserveFocus = typeof selectionKeyboardEvent.preserveFocus === "boolean" ? selectionKeyboardEvent.preserveFocus : true;
		const pinned = typeof selectionKeyboardEvent.pinned === "boolean" ? selectionKeyboardEvent.pinned : !preserveFocus;
		this._open(this.getSelectedElement(), preserveFocus, pinned, false, event.browserEvent);
	}
	onPointer(element, browserEvent) {
		if (!this.openOnSingleClick) return;
		if (browserEvent.detail === 2) return;
		const isMiddleClick = browserEvent.button === 1;
		const preserveFocus = true;
		const pinned = isMiddleClick;
		const sideBySide = browserEvent.ctrlKey || browserEvent.metaKey || browserEvent.altKey;
		this._open(element, preserveFocus, pinned, sideBySide, browserEvent);
	}
	onMouseDblClick(element, browserEvent) {
		if (!browserEvent) return;
		const target = browserEvent.target;
		if (target.classList.contains("monaco-tl-twistie") || target.classList.contains("monaco-icon-label") && target.classList.contains("folder-icon") && browserEvent.offsetX < 16) return;
		const preserveFocus = false;
		const pinned = true;
		const sideBySide = browserEvent.ctrlKey || browserEvent.metaKey || browserEvent.altKey;
		this._open(element, preserveFocus, pinned, sideBySide, browserEvent);
	}
	_open(element, preserveFocus, pinned, sideBySide, browserEvent) {
		if (!element) return;
		this._onDidOpen.fire({
			editorOptions: {
				preserveFocus,
				pinned,
				revealIfVisible: true
			},
			sideBySide,
			element,
			browserEvent
		});
	}
};
var ListResourceNavigator = class extends ResourceNavigator {
	constructor(widget, options) {
		super(widget, options);
		this.widget = widget;
	}
	getSelectedElement() {
		return this.widget.getSelectedElements()[0];
	}
};
var TableResourceNavigator = class extends ResourceNavigator {
	constructor(widget, options) {
		super(widget, options);
	}
	getSelectedElement() {
		return this.widget.getSelectedElements()[0];
	}
};
var TreeResourceNavigator = class extends ResourceNavigator {
	constructor(widget, options) {
		super(widget, options);
	}
	getSelectedElement() {
		return this.widget.getSelection()[0] ?? void 0;
	}
};
function createKeyboardNavigationEventFilter(keybindingService) {
	let inMultiChord = false;
	return (event) => {
		if (event.toKeyCodeChord().isModifierKey()) return false;
		if (inMultiChord) {
			inMultiChord = false;
			return false;
		}
		const result = keybindingService.softDispatch(event, event.target);
		if (result.kind === 1) {
			inMultiChord = true;
			return false;
		}
		inMultiChord = false;
		return result.kind === 0;
	};
}
var WorkbenchObjectTree = class WorkbenchObjectTree extends ObjectTree {
	get onDidOpen() {
		return this.internals.onDidOpen;
	}
	constructor(user, container, delegate, renderers, options, instantiationService, contextKeyService, listService, configurationService) {
		const { options: treeOptions, getTypeNavigationMode, disposable } = instantiationService.invokeFunction(workbenchTreeDataPreamble, options);
		super(user, container, delegate, renderers, treeOptions);
		this.disposables.add(disposable);
		this.internals = new WorkbenchTreeInternals(this, options, getTypeNavigationMode, options.overrideStyles, contextKeyService, listService, configurationService);
		this.disposables.add(this.internals);
	}
	updateOptions(options = {}) {
		super.updateOptions(options);
		if (options.overrideStyles) this.internals.updateStyleOverrides(options.overrideStyles);
		this.internals.updateOptions(options);
	}
};
WorkbenchObjectTree = __decorate$30([
	__param$29(5, IInstantiationService),
	__param$29(6, IContextKeyService),
	__param$29(7, IListService),
	__param$29(8, IConfigurationService)
], WorkbenchObjectTree);
var WorkbenchCompressibleObjectTree = class WorkbenchCompressibleObjectTree extends CompressibleObjectTree {
	constructor(user, container, delegate, renderers, options, instantiationService, contextKeyService, listService, configurationService) {
		const { options: treeOptions, getTypeNavigationMode, disposable } = instantiationService.invokeFunction(workbenchTreeDataPreamble, options);
		super(user, container, delegate, renderers, treeOptions);
		this.disposables.add(disposable);
		this.internals = new WorkbenchTreeInternals(this, options, getTypeNavigationMode, options.overrideStyles, contextKeyService, listService, configurationService);
		this.disposables.add(this.internals);
	}
	updateOptions(options = {}) {
		super.updateOptions(options);
		if (options.overrideStyles) this.internals.updateStyleOverrides(options.overrideStyles);
		this.internals.updateOptions(options);
	}
};
WorkbenchCompressibleObjectTree = __decorate$30([
	__param$29(5, IInstantiationService),
	__param$29(6, IContextKeyService),
	__param$29(7, IListService),
	__param$29(8, IConfigurationService)
], WorkbenchCompressibleObjectTree);
var WorkbenchDataTree = class WorkbenchDataTree extends DataTree {
	constructor(user, container, delegate, renderers, dataSource, options, instantiationService, contextKeyService, listService, configurationService) {
		const { options: treeOptions, getTypeNavigationMode, disposable } = instantiationService.invokeFunction(workbenchTreeDataPreamble, options);
		super(user, container, delegate, renderers, dataSource, treeOptions);
		this.disposables.add(disposable);
		this.internals = new WorkbenchTreeInternals(this, options, getTypeNavigationMode, options.overrideStyles, contextKeyService, listService, configurationService);
		this.disposables.add(this.internals);
	}
	updateOptions(options = {}) {
		super.updateOptions(options);
		if (options.overrideStyles !== void 0) this.internals.updateStyleOverrides(options.overrideStyles);
		this.internals.updateOptions(options);
	}
};
WorkbenchDataTree = __decorate$30([
	__param$29(6, IInstantiationService),
	__param$29(7, IContextKeyService),
	__param$29(8, IListService),
	__param$29(9, IConfigurationService)
], WorkbenchDataTree);
var WorkbenchAsyncDataTree = class WorkbenchAsyncDataTree extends AsyncDataTree {
	get onDidOpen() {
		return this.internals.onDidOpen;
	}
	constructor(user, container, delegate, renderers, dataSource, options, instantiationService, contextKeyService, listService, configurationService) {
		const { options: treeOptions, getTypeNavigationMode, disposable } = instantiationService.invokeFunction(workbenchTreeDataPreamble, options);
		super(user, container, delegate, renderers, dataSource, treeOptions);
		this.disposables.add(disposable);
		this.internals = new WorkbenchTreeInternals(this, options, getTypeNavigationMode, options.overrideStyles, contextKeyService, listService, configurationService);
		this.disposables.add(this.internals);
	}
	updateOptions(options = {}) {
		super.updateOptions(options);
		if (options.overrideStyles) this.internals.updateStyleOverrides(options.overrideStyles);
		this.internals.updateOptions(options);
	}
};
WorkbenchAsyncDataTree = __decorate$30([
	__param$29(6, IInstantiationService),
	__param$29(7, IContextKeyService),
	__param$29(8, IListService),
	__param$29(9, IConfigurationService)
], WorkbenchAsyncDataTree);
var WorkbenchCompressibleAsyncDataTree = class WorkbenchCompressibleAsyncDataTree extends CompressibleAsyncDataTree {
	constructor(user, container, virtualDelegate, compressionDelegate, renderers, dataSource, options, instantiationService, contextKeyService, listService, configurationService) {
		const { options: treeOptions, getTypeNavigationMode, disposable } = instantiationService.invokeFunction(workbenchTreeDataPreamble, options);
		super(user, container, virtualDelegate, compressionDelegate, renderers, dataSource, treeOptions);
		this.disposables.add(disposable);
		this.internals = new WorkbenchTreeInternals(this, options, getTypeNavigationMode, options.overrideStyles, contextKeyService, listService, configurationService);
		this.disposables.add(this.internals);
	}
	updateOptions(options) {
		super.updateOptions(options);
		this.internals.updateOptions(options);
	}
};
WorkbenchCompressibleAsyncDataTree = __decorate$30([
	__param$29(7, IInstantiationService),
	__param$29(8, IContextKeyService),
	__param$29(9, IListService),
	__param$29(10, IConfigurationService)
], WorkbenchCompressibleAsyncDataTree);
function getDefaultTreeFindMode(configurationService) {
	const value = configurationService.getValue(defaultFindModeSettingKey);
	if (value === "highlight") return TreeFindMode.Highlight;
	else if (value === "filter") return TreeFindMode.Filter;
	const deprecatedValue = configurationService.getValue(keyboardNavigationSettingKey);
	if (deprecatedValue === "simple" || deprecatedValue === "highlight") return TreeFindMode.Highlight;
	else if (deprecatedValue === "filter") return TreeFindMode.Filter;
}
function getDefaultTreeFindMatchType(configurationService) {
	const value = configurationService.getValue(defaultFindMatchTypeSettingKey);
	if (value === "fuzzy") return TreeFindMatchType.Fuzzy;
	else if (value === "contiguous") return TreeFindMatchType.Contiguous;
}
function workbenchTreeDataPreamble(accessor, options) {
	const configurationService = accessor.get(IConfigurationService);
	const contextViewService = accessor.get(IContextViewService);
	const contextKeyService = accessor.get(IContextKeyService);
	const instantiationService = accessor.get(IInstantiationService);
	const getTypeNavigationMode = () => {
		const modeString = contextKeyService.getContextKeyValue(WorkbenchListTypeNavigationModeKey);
		if (modeString === "automatic") return TypeNavigationMode.Automatic;
		else if (modeString === "trigger") return TypeNavigationMode.Trigger;
		if (contextKeyService.getContextKeyValue(WorkbenchListAutomaticKeyboardNavigationLegacyKey) === false) return TypeNavigationMode.Trigger;
		const configString = configurationService.getValue(typeNavigationModeSettingKey);
		if (configString === "automatic") return TypeNavigationMode.Automatic;
		else if (configString === "trigger") return TypeNavigationMode.Trigger;
	};
	const horizontalScrolling = options.horizontalScrolling !== void 0 ? options.horizontalScrolling : Boolean(configurationService.getValue(horizontalScrollingKey));
	const [workbenchListOptions, disposable] = instantiationService.invokeFunction(toWorkbenchListOptions, options);
	const paddingBottom = options.paddingBottom;
	const renderIndentGuides = options.renderIndentGuides !== void 0 ? options.renderIndentGuides : configurationService.getValue(treeRenderIndentGuidesKey);
	return {
		getTypeNavigationMode,
		disposable,
		options: {
			keyboardSupport: false,
			...workbenchListOptions,
			indent: typeof configurationService.getValue(treeIndentKey) === "number" ? configurationService.getValue(treeIndentKey) : void 0,
			renderIndentGuides,
			smoothScrolling: Boolean(configurationService.getValue(listSmoothScrolling)),
			defaultFindMode: options.defaultFindMode ?? getDefaultTreeFindMode(configurationService),
			defaultFindMatchType: options.defaultFindMatchType ?? getDefaultTreeFindMatchType(configurationService),
			horizontalScrolling,
			scrollByPage: Boolean(configurationService.getValue(scrollByPageKey)),
			paddingBottom,
			hideTwistiesOfChildlessElements: options.hideTwistiesOfChildlessElements,
			expandOnlyOnTwistieClick: options.expandOnlyOnTwistieClick ?? configurationService.getValue(treeExpandMode) === "doubleClick",
			contextViewProvider: contextViewService,
			findWidgetStyles: defaultFindWidgetStyles,
			enableStickyScroll: options.enableStickyScroll ?? Boolean(configurationService.getValue(treeStickyScroll)),
			stickyScrollMaxItemCount: options.stickyScrollMaxItemCount ?? Number(configurationService.getValue(treeStickyScrollMaxElements))
		}
	};
}
var WorkbenchTreeInternals = class WorkbenchTreeInternals {
	get onDidOpen() {
		return this.navigator.onDidOpen;
	}
	constructor(tree, options, getTypeNavigationMode, overrideStyles, contextKeyService, listService, configurationService) {
		this.tree = tree;
		this.disposables = [];
		this.contextKeyService = createScopedContextKeyService(contextKeyService, tree);
		this.disposables.push(createScrollObserver(this.contextKeyService, tree));
		this.listSupportsMultiSelect = WorkbenchListSupportsMultiSelectContextKey.bindTo(this.contextKeyService);
		this.listSupportsMultiSelect.set(options.multipleSelectionSupport !== false);
		WorkbenchListSelectionNavigation.bindTo(this.contextKeyService).set(Boolean(options.selectionNavigation));
		this.listSupportFindWidget = WorkbenchListSupportsFind.bindTo(this.contextKeyService);
		this.listSupportFindWidget.set(options.findWidgetEnabled ?? true);
		this.hasSelectionOrFocus = WorkbenchListHasSelectionOrFocus.bindTo(this.contextKeyService);
		this.hasDoubleSelection = WorkbenchListDoubleSelection.bindTo(this.contextKeyService);
		this.hasMultiSelection = WorkbenchListMultiSelection.bindTo(this.contextKeyService);
		this.treeElementCanCollapse = WorkbenchTreeElementCanCollapse.bindTo(this.contextKeyService);
		this.treeElementHasParent = WorkbenchTreeElementHasParent.bindTo(this.contextKeyService);
		this.treeElementCanExpand = WorkbenchTreeElementCanExpand.bindTo(this.contextKeyService);
		this.treeElementHasChild = WorkbenchTreeElementHasChild.bindTo(this.contextKeyService);
		this.treeFindOpen = WorkbenchTreeFindOpen.bindTo(this.contextKeyService);
		this.treeStickyScrollFocused = WorkbenchTreeStickyScrollFocused.bindTo(this.contextKeyService);
		this._useAltAsMultipleSelectionModifier = useAltAsMultipleSelectionModifier(configurationService);
		this.updateStyleOverrides(overrideStyles);
		const updateCollapseContextKeys = () => {
			const focus = tree.getFocus()[0];
			if (!focus) return;
			const node = tree.getNode(focus);
			this.treeElementCanCollapse.set(node.collapsible && !node.collapsed);
			this.treeElementHasParent.set(!!tree.getParentElement(focus));
			this.treeElementCanExpand.set(node.collapsible && node.collapsed);
			this.treeElementHasChild.set(!!tree.getFirstElementChild(focus));
		};
		const interestingContextKeys = /* @__PURE__ */ new Set();
		interestingContextKeys.add(WorkbenchListTypeNavigationModeKey);
		interestingContextKeys.add(WorkbenchListAutomaticKeyboardNavigationLegacyKey);
		this.disposables.push(this.contextKeyService, listService.register(tree), tree.onDidChangeSelection(() => {
			const selection = tree.getSelection();
			const focus = tree.getFocus();
			this.contextKeyService.bufferChangeEvents(() => {
				this.hasSelectionOrFocus.set(selection.length > 0 || focus.length > 0);
				this.hasMultiSelection.set(selection.length > 1);
				this.hasDoubleSelection.set(selection.length === 2);
			});
		}), tree.onDidChangeFocus(() => {
			const selection = tree.getSelection();
			const focus = tree.getFocus();
			this.hasSelectionOrFocus.set(selection.length > 0 || focus.length > 0);
			updateCollapseContextKeys();
		}), tree.onDidChangeCollapseState(updateCollapseContextKeys), tree.onDidChangeModel(updateCollapseContextKeys), tree.onDidChangeFindOpenState((enabled) => this.treeFindOpen.set(enabled)), tree.onDidChangeStickyScrollFocused((focused) => this.treeStickyScrollFocused.set(focused)), configurationService.onDidChangeConfiguration((e) => {
			let newOptions = {};
			if (e.affectsConfiguration(multiSelectModifierSettingKey)) this._useAltAsMultipleSelectionModifier = useAltAsMultipleSelectionModifier(configurationService);
			if (e.affectsConfiguration(treeIndentKey)) {
				const indent = configurationService.getValue(treeIndentKey);
				newOptions = {
					...newOptions,
					indent
				};
			}
			if (e.affectsConfiguration(treeRenderIndentGuidesKey) && options.renderIndentGuides === void 0) {
				const renderIndentGuides = configurationService.getValue(treeRenderIndentGuidesKey);
				newOptions = {
					...newOptions,
					renderIndentGuides
				};
			}
			if (e.affectsConfiguration(listSmoothScrolling)) {
				const smoothScrolling = Boolean(configurationService.getValue(listSmoothScrolling));
				newOptions = {
					...newOptions,
					smoothScrolling
				};
			}
			if (e.affectsConfiguration(defaultFindModeSettingKey) || e.affectsConfiguration(keyboardNavigationSettingKey)) {
				const defaultFindMode = getDefaultTreeFindMode(configurationService);
				newOptions = {
					...newOptions,
					defaultFindMode
				};
			}
			if (e.affectsConfiguration(typeNavigationModeSettingKey) || e.affectsConfiguration(keyboardNavigationSettingKey)) {
				const typeNavigationMode = getTypeNavigationMode();
				newOptions = {
					...newOptions,
					typeNavigationMode
				};
			}
			if (e.affectsConfiguration(defaultFindMatchTypeSettingKey)) {
				const defaultFindMatchType = getDefaultTreeFindMatchType(configurationService);
				newOptions = {
					...newOptions,
					defaultFindMatchType
				};
			}
			if (e.affectsConfiguration(horizontalScrollingKey) && options.horizontalScrolling === void 0) {
				const horizontalScrolling = Boolean(configurationService.getValue(horizontalScrollingKey));
				newOptions = {
					...newOptions,
					horizontalScrolling
				};
			}
			if (e.affectsConfiguration(scrollByPageKey)) {
				const scrollByPage = Boolean(configurationService.getValue(scrollByPageKey));
				newOptions = {
					...newOptions,
					scrollByPage
				};
			}
			if (e.affectsConfiguration(treeExpandMode) && options.expandOnlyOnTwistieClick === void 0) newOptions = {
				...newOptions,
				expandOnlyOnTwistieClick: configurationService.getValue(treeExpandMode) === "doubleClick"
			};
			if (e.affectsConfiguration(treeStickyScroll) && options.enableStickyScroll === void 0) {
				const enableStickyScroll = configurationService.getValue(treeStickyScroll);
				newOptions = {
					...newOptions,
					enableStickyScroll
				};
			}
			if (e.affectsConfiguration(treeStickyScrollMaxElements) && options.stickyScrollMaxItemCount === void 0) {
				const stickyScrollMaxItemCount = Math.max(1, configurationService.getValue(treeStickyScrollMaxElements));
				newOptions = {
					...newOptions,
					stickyScrollMaxItemCount
				};
			}
			if (e.affectsConfiguration(mouseWheelScrollSensitivityKey)) {
				const mouseWheelScrollSensitivity = configurationService.getValue(mouseWheelScrollSensitivityKey);
				newOptions = {
					...newOptions,
					mouseWheelScrollSensitivity
				};
			}
			if (e.affectsConfiguration(fastScrollSensitivityKey)) {
				const fastScrollSensitivity = configurationService.getValue(fastScrollSensitivityKey);
				newOptions = {
					...newOptions,
					fastScrollSensitivity
				};
			}
			if (Object.keys(newOptions).length > 0) tree.updateOptions(newOptions);
		}), this.contextKeyService.onDidChangeContext((e) => {
			if (e.affectsSome(interestingContextKeys)) tree.updateOptions({ typeNavigationMode: getTypeNavigationMode() });
		}));
		this.navigator = new TreeResourceNavigator(tree, {
			configurationService,
			...options
		});
		this.disposables.push(this.navigator);
	}
	updateOptions(options) {
		if (options.multipleSelectionSupport !== void 0) this.listSupportsMultiSelect.set(!!options.multipleSelectionSupport);
	}
	updateStyleOverrides(overrideStyles) {
		this.tree.style(overrideStyles ? getListStyles(overrideStyles) : defaultListStyles);
	}
	dispose() {
		this.disposables = dispose(this.disposables);
	}
};
WorkbenchTreeInternals = __decorate$30([
	__param$29(4, IContextKeyService),
	__param$29(5, IListService),
	__param$29(6, IConfigurationService)
], WorkbenchTreeInternals);
Registry.as(Extensions$6.Configuration).registerConfiguration({
	id: "workbench",
	order: 7,
	title: localize(1801, "Workbench"),
	type: "object",
	properties: {
		[multiSelectModifierSettingKey]: {
			type: "string",
			enum: ["ctrlCmd", "alt"],
			markdownEnumDescriptions: [localize(1802, "Maps to `Control` on Windows and Linux and to `Command` on macOS."), localize(1803, "Maps to `Alt` on Windows and Linux and to `Option` on macOS.")],
			default: "ctrlCmd",
			description: localize(1804, "The modifier to be used to add an item in trees and lists to a multi-selection with the mouse (for example in the explorer, open editors and scm view). The 'Open to Side' mouse gestures - if supported - will adapt such that they do not conflict with the multiselect modifier.")
		},
		[openModeSettingKey]: {
			type: "string",
			enum: ["singleClick", "doubleClick"],
			default: "singleClick",
			description: localize(1805, "Controls how to open items in trees and lists using the mouse (if supported). Note that some trees and lists might choose to ignore this setting if it is not applicable.")
		},
		[horizontalScrollingKey]: {
			type: "boolean",
			default: false,
			description: localize(1806, "Controls whether lists and trees support horizontal scrolling in the workbench. Warning: turning on this setting has a performance implication.")
		},
		[scrollByPageKey]: {
			type: "boolean",
			default: false,
			description: localize(1807, "Controls whether clicks in the scrollbar scroll page by page.")
		},
		[treeIndentKey]: {
			type: "number",
			default: 8,
			minimum: 4,
			maximum: 40,
			description: localize(1808, "Controls tree indentation in pixels.")
		},
		[treeRenderIndentGuidesKey]: {
			type: "string",
			enum: [
				"none",
				"onHover",
				"always"
			],
			default: "onHover",
			description: localize(1809, "Controls whether the tree should render indent guides.")
		},
		[listSmoothScrolling]: {
			type: "boolean",
			default: false,
			description: localize(1810, "Controls whether lists and trees have smooth scrolling.")
		},
		[mouseWheelScrollSensitivityKey]: {
			type: "number",
			default: 1,
			markdownDescription: localize(1811, "A multiplier to be used on the `deltaX` and `deltaY` of mouse wheel scroll events.")
		},
		[fastScrollSensitivityKey]: {
			type: "number",
			default: 5,
			markdownDescription: localize(1812, "Scrolling speed multiplier when pressing `Alt`.")
		},
		[defaultFindModeSettingKey]: {
			type: "string",
			enum: ["highlight", "filter"],
			enumDescriptions: [localize(1813, "Highlight elements when searching. Further up and down navigation will traverse only the highlighted elements."), localize(1814, "Filter elements when searching.")],
			default: "highlight",
			description: localize(1815, "Controls the default find mode for lists and trees in the workbench.")
		},
		[keyboardNavigationSettingKey]: {
			type: "string",
			enum: [
				"simple",
				"highlight",
				"filter"
			],
			enumDescriptions: [
				localize(1816, "Simple keyboard navigation focuses elements which match the keyboard input. Matching is done only on prefixes."),
				localize(1817, "Highlight keyboard navigation highlights elements which match the keyboard input. Further up and down navigation will traverse only the highlighted elements."),
				localize(1818, "Filter keyboard navigation will filter out and hide all the elements which do not match the keyboard input.")
			],
			default: "highlight",
			description: localize(1819, "Controls the keyboard navigation style for lists and trees in the workbench. Can be simple, highlight and filter."),
			deprecated: true,
			deprecationMessage: localize(1820, "Please use 'workbench.list.defaultFindMode' and	'workbench.list.typeNavigationMode' instead.")
		},
		[defaultFindMatchTypeSettingKey]: {
			type: "string",
			enum: ["fuzzy", "contiguous"],
			enumDescriptions: [localize(1821, "Use fuzzy matching when searching."), localize(1822, "Use contiguous matching when searching.")],
			default: "fuzzy",
			description: localize(1823, "Controls the type of matching used when searching lists and trees in the workbench.")
		},
		[treeExpandMode]: {
			type: "string",
			enum: ["singleClick", "doubleClick"],
			default: "singleClick",
			description: localize(1824, "Controls how tree folders are expanded when clicking the folder names. Note that some trees and lists might choose to ignore this setting if it is not applicable.")
		},
		[treeStickyScroll]: {
			type: "boolean",
			default: true,
			description: localize(1825, "Controls whether sticky scrolling is enabled in trees.")
		},
		[treeStickyScrollMaxElements]: {
			type: "number",
			minimum: 1,
			default: 7,
			markdownDescription: localize(1826, "Controls the number of sticky elements displayed in the tree when {0} is enabled.", "`#workbench.tree.enableStickyScroll#`")
		},
		[typeNavigationModeSettingKey]: {
			type: "string",
			enum: ["automatic", "trigger"],
			default: "automatic",
			markdownDescription: localize(1827, "Controls how type navigation works in lists and trees in the workbench. When set to `trigger`, type navigation begins once the `list.triggerTypeNavigation` command is run.")
		}
	}
});
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/log/common/logService.js
var LogService = class extends Disposable {
	constructor(primaryLogger, otherLoggers = []) {
		super();
		this.logger = new MultiplexLogger([primaryLogger, ...otherLoggers]);
		this._register(primaryLogger.onDidChangeLogLevel((level) => this.setLevel(level)));
	}
	get onDidChangeLogLevel() {
		return this.logger.onDidChangeLogLevel;
	}
	setLevel(level) {
		this.logger.setLevel(level);
	}
	getLevel() {
		return this.logger.getLevel();
	}
	trace(message, ...args) {
		this.logger.trace(message, ...args);
	}
	debug(message, ...args) {
		this.logger.debug(message, ...args);
	}
	info(message, ...args) {
		this.logger.info(message, ...args);
	}
	warn(message, ...args) {
		this.logger.warn(message, ...args);
	}
	error(message, ...args) {
		this.logger.error(message, ...args);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/markers/common/markers.js
var MarkerSeverity$1;
(function(MarkerSeverity) {
	MarkerSeverity[MarkerSeverity["Hint"] = 1] = "Hint";
	MarkerSeverity[MarkerSeverity["Info"] = 2] = "Info";
	MarkerSeverity[MarkerSeverity["Warning"] = 4] = "Warning";
	MarkerSeverity[MarkerSeverity["Error"] = 8] = "Error";
})(MarkerSeverity$1 || (MarkerSeverity$1 = {}));
(function(MarkerSeverity) {
	function compare(a, b) {
		return b - a;
	}
	MarkerSeverity.compare = compare;
	const _displayStrings = Object.create(null);
	_displayStrings[MarkerSeverity.Error] = localize(1828, "Error");
	_displayStrings[MarkerSeverity.Warning] = localize(1829, "Warning");
	_displayStrings[MarkerSeverity.Info] = localize(1830, "Info");
	function toString(a) {
		return _displayStrings[a] || "";
	}
	MarkerSeverity.toString = toString;
	const _displayStringsPlural = Object.create(null);
	_displayStringsPlural[MarkerSeverity.Error] = localize(1831, "Errors");
	_displayStringsPlural[MarkerSeverity.Warning] = localize(1832, "Warnings");
	_displayStringsPlural[MarkerSeverity.Info] = localize(1833, "Infos");
	function toStringPlural(a) {
		return _displayStringsPlural[a] || "";
	}
	MarkerSeverity.toStringPlural = toStringPlural;
	function fromSeverity(severity) {
		switch (severity) {
			case Severity$1$1.Error: return MarkerSeverity.Error;
			case Severity$1$1.Warning: return MarkerSeverity.Warning;
			case Severity$1$1.Info: return MarkerSeverity.Info;
			case Severity$1$1.Ignore: return MarkerSeverity.Hint;
		}
	}
	MarkerSeverity.fromSeverity = fromSeverity;
	function toSeverity(severity) {
		switch (severity) {
			case MarkerSeverity.Error: return Severity$1$1.Error;
			case MarkerSeverity.Warning: return Severity$1$1.Warning;
			case MarkerSeverity.Info: return Severity$1$1.Info;
			case MarkerSeverity.Hint: return Severity$1$1.Ignore;
		}
	}
	MarkerSeverity.toSeverity = toSeverity;
})(MarkerSeverity$1 || (MarkerSeverity$1 = {}));
var IMarkerData;
(function(IMarkerData) {
	const emptyString = "";
	function makeKey(markerData) {
		return makeKeyOptionalMessage(markerData, true);
	}
	IMarkerData.makeKey = makeKey;
	function makeKeyOptionalMessage(markerData, useMessage) {
		const result = [emptyString];
		if (markerData.source) result.push(markerData.source.replace("¦", "\\¦"));
		else result.push(emptyString);
		if (markerData.code) {
			if (typeof markerData.code === "string") result.push(markerData.code.replace("¦", "\\¦"));
			else result.push(markerData.code.value.replace("¦", "\\¦"));
		} else result.push(emptyString);
		if (markerData.severity !== void 0 && markerData.severity !== null) result.push(MarkerSeverity$1.toString(markerData.severity));
		else result.push(emptyString);
		if (markerData.message && useMessage) result.push(markerData.message.replace("¦", "\\¦"));
		else result.push(emptyString);
		if (markerData.startLineNumber !== void 0 && markerData.startLineNumber !== null) result.push(markerData.startLineNumber.toString());
		else result.push(emptyString);
		if (markerData.startColumn !== void 0 && markerData.startColumn !== null) result.push(markerData.startColumn.toString());
		else result.push(emptyString);
		if (markerData.endLineNumber !== void 0 && markerData.endLineNumber !== null) result.push(markerData.endLineNumber.toString());
		else result.push(emptyString);
		if (markerData.endColumn !== void 0 && markerData.endColumn !== null) result.push(markerData.endColumn.toString());
		else result.push(emptyString);
		result.push(emptyString);
		return result.join("¦");
	}
	IMarkerData.makeKeyOptionalMessage = makeKeyOptionalMessage;
})(IMarkerData || (IMarkerData = {}));
var IMarkerService = createDecorator("markerService");
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/markers/common/markerService.js
var unsupportedSchemas = /* @__PURE__ */ new Set([
	Schemas.inMemory,
	Schemas.vscodeSourceControl,
	Schemas.walkThrough,
	Schemas.walkThroughSnippet,
	Schemas.vscodeChatCodeBlock,
	Schemas.vscodeTerminal
]);
var DoubleResourceMap = class {
	constructor() {
		this._byResource = new ResourceMap();
		this._byOwner = /* @__PURE__ */ new Map();
	}
	set(resource, owner, value) {
		let ownerMap = this._byResource.get(resource);
		if (!ownerMap) {
			ownerMap = /* @__PURE__ */ new Map();
			this._byResource.set(resource, ownerMap);
		}
		ownerMap.set(owner, value);
		let resourceMap = this._byOwner.get(owner);
		if (!resourceMap) {
			resourceMap = new ResourceMap();
			this._byOwner.set(owner, resourceMap);
		}
		resourceMap.set(resource, value);
	}
	get(resource, owner) {
		return this._byResource.get(resource)?.get(owner);
	}
	delete(resource, owner) {
		let removedA = false;
		let removedB = false;
		const ownerMap = this._byResource.get(resource);
		if (ownerMap) removedA = ownerMap.delete(owner);
		const resourceMap = this._byOwner.get(owner);
		if (resourceMap) removedB = resourceMap.delete(resource);
		if (removedA !== removedB) throw new Error("illegal state");
		return removedA && removedB;
	}
	values(key) {
		if (typeof key === "string") return this._byOwner.get(key)?.values() ?? Iterable.empty();
		if (URI.isUri(key)) return this._byResource.get(key)?.values() ?? Iterable.empty();
		return Iterable.map(Iterable.concat(...this._byOwner.values()), (map) => map[1]);
	}
};
var MarkerStats = class {
	constructor(service) {
		this.errors = 0;
		this.infos = 0;
		this.warnings = 0;
		this.unknowns = 0;
		this._data = new ResourceMap();
		this._service = service;
		this._subscription = service.onMarkerChanged(this._update, this);
	}
	dispose() {
		this._subscription.dispose();
	}
	_update(resources) {
		for (const resource of resources) {
			const oldStats = this._data.get(resource);
			if (oldStats) this._substract(oldStats);
			const newStats = this._resourceStats(resource);
			this._add(newStats);
			this._data.set(resource, newStats);
		}
	}
	_resourceStats(resource) {
		const result = {
			errors: 0,
			warnings: 0,
			infos: 0,
			unknowns: 0
		};
		if (unsupportedSchemas.has(resource.scheme)) return result;
		for (const { severity } of this._service.read({ resource })) if (severity === MarkerSeverity$1.Error) result.errors += 1;
		else if (severity === MarkerSeverity$1.Warning) result.warnings += 1;
		else if (severity === MarkerSeverity$1.Info) result.infos += 1;
		else result.unknowns += 1;
		return result;
	}
	_substract(op) {
		this.errors -= op.errors;
		this.warnings -= op.warnings;
		this.infos -= op.infos;
		this.unknowns -= op.unknowns;
	}
	_add(op) {
		this.errors += op.errors;
		this.warnings += op.warnings;
		this.infos += op.infos;
		this.unknowns += op.unknowns;
	}
};
var MarkerService = class MarkerService {
	constructor() {
		this._onMarkerChanged = new MicrotaskEmitter({ merge: MarkerService._merge });
		this.onMarkerChanged = this._onMarkerChanged.event;
		this._data = new DoubleResourceMap();
		this._stats = new MarkerStats(this);
		this._filteredResources = new ResourceMap();
	}
	dispose() {
		this._stats.dispose();
		this._onMarkerChanged.dispose();
	}
	remove(owner, resources) {
		for (const resource of resources || []) this.changeOne(owner, resource, []);
	}
	changeOne(owner, resource, markerData) {
		if (isFalsyOrEmpty(markerData)) {
			if (this._data.delete(resource, owner)) this._onMarkerChanged.fire([resource]);
		} else {
			const markers = [];
			for (const data of markerData) {
				const marker = MarkerService._toMarker(owner, resource, data);
				if (marker) markers.push(marker);
			}
			this._data.set(resource, owner, markers);
			this._onMarkerChanged.fire([resource]);
		}
	}
	static _toMarker(owner, resource, data) {
		let { code, severity, message, source, startLineNumber, startColumn, endLineNumber, endColumn, relatedInformation, modelVersionId, tags, origin } = data;
		if (!message) return;
		startLineNumber = startLineNumber > 0 ? startLineNumber : 1;
		startColumn = startColumn > 0 ? startColumn : 1;
		endLineNumber = endLineNumber >= startLineNumber ? endLineNumber : startLineNumber;
		endColumn = endColumn > 0 ? endColumn : startColumn;
		return {
			resource,
			owner,
			code,
			severity,
			message,
			source,
			startLineNumber,
			startColumn,
			endLineNumber,
			endColumn,
			relatedInformation,
			modelVersionId,
			tags,
			origin
		};
	}
	changeAll(owner, data) {
		const changes = [];
		const existing = this._data.values(owner);
		if (existing) for (const data of existing) {
			const first = Iterable.first(data);
			if (first) {
				changes.push(first.resource);
				this._data.delete(first.resource, owner);
			}
		}
		if (isNonEmptyArray(data)) {
			const groups = new ResourceMap();
			for (const { resource, marker: markerData } of data) {
				const marker = MarkerService._toMarker(owner, resource, markerData);
				if (!marker) continue;
				const array = groups.get(resource);
				if (!array) {
					groups.set(resource, [marker]);
					changes.push(resource);
				} else array.push(marker);
			}
			for (const [resource, value] of groups) this._data.set(resource, owner, value);
		}
		if (changes.length > 0) this._onMarkerChanged.fire(changes);
	}
	/**
	* Creates an information marker for filtered resources
	*/
	_createFilteredMarker(resource, reasons) {
		const message = reasons.length === 1 ? localize(1834, "Problems are paused because: \"{0}\"", reasons[0]) : localize(1835, "Problems are paused because: \"{0}\" and {1} more", reasons[0], reasons.length - 1);
		return {
			owner: "markersFilter",
			resource,
			severity: MarkerSeverity$1.Info,
			message,
			startLineNumber: 1,
			startColumn: 1,
			endLineNumber: 1,
			endColumn: 1
		};
	}
	read(filter = Object.create(null)) {
		let { owner, resource, severities, take } = filter;
		if (!take || take < 0) take = -1;
		if (owner && resource) {
			const reasons = !filter.ignoreResourceFilters ? this._filteredResources.get(resource) : void 0;
			if (reasons?.length) return [this._createFilteredMarker(resource, reasons)];
			const data = this._data.get(resource, owner);
			if (!data) return [];
			const result = [];
			for (const marker of data) {
				if (take > 0 && result.length === take) break;
				const reasons = !filter.ignoreResourceFilters ? this._filteredResources.get(resource) : void 0;
				if (reasons?.length) result.push(this._createFilteredMarker(resource, reasons));
				else if (MarkerService._accept(marker, severities)) result.push(marker);
			}
			return result;
		} else {
			const iterable = !owner && !resource ? this._data.values() : this._data.values(resource ?? owner);
			const result = [];
			const filtered = new ResourceSet();
			for (const markers of iterable) for (const data of markers) {
				if (filtered.has(data.resource)) continue;
				if (take > 0 && result.length === take) break;
				const reasons = !filter.ignoreResourceFilters ? this._filteredResources.get(data.resource) : void 0;
				if (reasons?.length) {
					result.push(this._createFilteredMarker(data.resource, reasons));
					filtered.add(data.resource);
				} else if (MarkerService._accept(data, severities)) result.push(data);
			}
			return result;
		}
	}
	static _accept(marker, severities) {
		return severities === void 0 || (severities & marker.severity) === marker.severity;
	}
	static _merge(all) {
		const set = new ResourceMap();
		for (const array of all) for (const item of array) set.set(item, true);
		return Array.from(set.keys());
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/progress/common/progress.js
var IProgressService = createDecorator("progressService");
var Progress = class {
	static {
		this.None = Object.freeze({ report() {} });
	}
	constructor(callback) {
		this.callback = callback;
	}
	report(item) {
		this._value = item;
		this.callback(this._value);
	}
};
var IEditorProgressService = createDecorator("editorProgressService");
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/userInteraction/browser/userInteractionServiceImpl.js
var UserInteractionService = class {
	constructor() {
		this._modifierObservables = /* @__PURE__ */ new WeakMap();
	}
	readModifierKeyStatus(element, reader) {
		const win = element instanceof Window ? element : getWindow(element);
		let obs = this._modifierObservables.get(win);
		if (!obs) {
			const emitter = ModifierKeyEmitter.getInstance();
			obs = observableFromEvent(this, emitter.event, () => ({
				ctrlKey: emitter.keyStatus.ctrlKey,
				shiftKey: emitter.keyStatus.shiftKey,
				altKey: emitter.keyStatus.altKey,
				metaKey: emitter.keyStatus.metaKey
			}));
			this._modifierObservables.set(win, obs);
		}
		return obs.read(reader);
	}
	createFocusTracker(element, store) {
		const tracker = store.add(trackFocus(element));
		const hasFocusWithin = (el) => {
			if (el instanceof Window) return el.document.hasFocus();
			const shadowRoot = el.getRootNode() instanceof ShadowRoot ? el.getRootNode() : null;
			const activeElement = shadowRoot ? shadowRoot.activeElement : el.ownerDocument.activeElement;
			return el.contains(activeElement);
		};
		const value = observableValue("isFocused", hasFocusWithin(element));
		store.add(tracker.onDidFocus(() => value.set(true, void 0)));
		store.add(tracker.onDidBlur(() => value.set(false, void 0)));
		return value;
	}
	createHoverTracker(element, store) {
		const value = observableValue("isHovered", false);
		const onEnter = () => value.set(true, void 0);
		const onLeave = () => value.set(false, void 0);
		element.addEventListener("mouseenter", onEnter);
		element.addEventListener("mouseleave", onLeave);
		store.add({ dispose: () => {
			element.removeEventListener("mouseenter", onEnter);
			element.removeEventListener("mouseleave", onLeave);
		} });
		return value;
	}
	createDomFocusTracker(element) {
		return trackFocus(element);
	}
};
registerSingleton(IUserInteractionService, UserInteractionService, 1);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/workspace/common/workspace.js
var IWorkspaceContextService = createDecorator("contextService");
function isSingleFolderWorkspaceIdentifier(obj) {
	const singleFolderIdentifier = obj;
	return typeof singleFolderIdentifier?.id === "string" && URI.isUri(singleFolderIdentifier.uri);
}
function isEmptyWorkspaceIdentifier(obj) {
	return typeof obj?.id === "string" && !isSingleFolderWorkspaceIdentifier(obj) && !isWorkspaceIdentifier(obj);
}
var UNKNOWN_EMPTY_WINDOW_WORKSPACE = { id: "empty-window" };
function toWorkspaceIdentifier(arg0, isExtensionDevelopment) {
	if (typeof arg0 === "string" || typeof arg0 === "undefined") {
		if (typeof arg0 === "string") return { id: basename$1(arg0) };
		return UNKNOWN_EMPTY_WINDOW_WORKSPACE;
	}
	const workspace = arg0;
	if (workspace.configuration) return {
		id: workspace.id,
		configPath: workspace.configuration
	};
	if (workspace.folders.length === 1) return {
		id: workspace.id,
		uri: workspace.folders[0].uri
	};
	return { id: workspace.id };
}
function isWorkspaceIdentifier(obj) {
	const workspaceIdentifier = obj;
	return typeof workspaceIdentifier?.id === "string" && URI.isUri(workspaceIdentifier.configPath);
}
var WorkspaceFolder = class {
	constructor(data, raw) {
		this.raw = raw;
		this.uri = data.uri;
		this.index = data.index;
		this.name = data.name;
	}
	toJSON() {
		return {
			uri: this.uri,
			name: this.name,
			index: this.index
		};
	}
};
var WORKSPACE_EXTENSION = "code-workspace";
localize(2152, "Code Workspace");
var STANDALONE_EDITOR_WORKSPACE_ID = "4064f6ec-cb38-4ad0-af64-ee6467e63c82";
function isStandaloneEditorWorkspace(workspace) {
	return workspace.id === STANDALONE_EDITOR_WORKSPACE_ID;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/workspace/common/workspaceTrust.js
var IWorkspaceTrustManagementService = createDecorator("workspaceTrustManagementService");
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/services/bulkEditService.js
var IBulkEditService = createDecorator("IWorkspaceEditService");
var ResourceEdit = class {
	constructor(metadata) {
		this.metadata = metadata;
	}
	static convert(edit) {
		return edit.edits.map((edit) => {
			if (ResourceTextEdit.is(edit)) return ResourceTextEdit.lift(edit);
			if (ResourceFileEdit.is(edit)) return ResourceFileEdit.lift(edit);
			throw new Error("Unsupported edit");
		});
	}
};
var ResourceTextEdit = class ResourceTextEdit extends ResourceEdit {
	static is(candidate) {
		if (candidate instanceof ResourceTextEdit) return true;
		return isObject(candidate) && URI.isUri(candidate.resource) && isObject(candidate.textEdit);
	}
	static lift(edit) {
		if (edit instanceof ResourceTextEdit) return edit;
		else return new ResourceTextEdit(edit.resource, edit.textEdit, edit.versionId, edit.metadata);
	}
	constructor(resource, textEdit, versionId = void 0, metadata) {
		super(metadata);
		this.resource = resource;
		this.textEdit = textEdit;
		this.versionId = versionId;
	}
};
var ResourceFileEdit = class ResourceFileEdit extends ResourceEdit {
	static is(candidate) {
		if (candidate instanceof ResourceFileEdit) return true;
		else return isObject(candidate) && (Boolean(candidate.newResource) || Boolean(candidate.oldResource));
	}
	static lift(edit) {
		if (edit instanceof ResourceFileEdit) return edit;
		else return new ResourceFileEdit(edit.oldResource, edit.newResource, edit.options, edit.metadata);
	}
	constructor(oldResource, newResource, options = {}, metadata) {
		super(metadata);
		this.oldResource = oldResource;
		this.newResource = newResource;
		this.options = options;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/editor/common/editor.js
var EditorOpenSource;
(function(EditorOpenSource) {
	/**
	* Default: the editor is opening via a programmatic call
	* to the editor service API.
	*/
	EditorOpenSource[EditorOpenSource["API"] = 0] = "API";
	/**
	* Indicates that a user action triggered the opening, e.g.
	* via mouse or keyboard use.
	*/
	EditorOpenSource[EditorOpenSource["USER"] = 1] = "USER";
})(EditorOpenSource || (EditorOpenSource = {}));
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/services/openerService.js
var __decorate$29 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$28 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var CommandOpener = class CommandOpener {
	constructor(_commandService) {
		this._commandService = _commandService;
	}
	async open(target, options) {
		if (!matchesScheme(target, Schemas.command)) return false;
		if (!options?.allowCommands) return true;
		if (typeof target === "string") target = URI.parse(target);
		if (Array.isArray(options.allowCommands)) {
			if (!options.allowCommands.includes(target.path)) return true;
		}
		let args = [];
		try {
			args = parse$1(decodeURIComponent(target.query));
		} catch {
			try {
				args = parse$1(target.query);
			} catch {}
		}
		if (!Array.isArray(args)) args = [args];
		await this._commandService.executeCommand(target.path, ...args);
		return true;
	}
};
CommandOpener = __decorate$29([__param$28(0, ICommandService)], CommandOpener);
var EditorOpener = class EditorOpener {
	constructor(_editorService) {
		this._editorService = _editorService;
	}
	async open(target, options) {
		if (typeof target === "string") target = URI.parse(target);
		const { selection, uri } = extractSelection(target);
		target = uri;
		if (target.scheme === Schemas.file) target = normalizePath(target);
		await this._editorService.openCodeEditor({
			resource: target,
			options: {
				selection,
				source: options?.fromUserGesture ? EditorOpenSource.USER : EditorOpenSource.API,
				...options?.editorOptions
			}
		}, this._editorService.getFocusedCodeEditor(), options?.openToSide);
		return true;
	}
};
EditorOpener = __decorate$29([__param$28(0, ICodeEditorService)], EditorOpener);
function shouldOpenExternal(target, options) {
	return !!options?.openExternal || matchesSomeScheme(target, Schemas.mailto, Schemas.http, Schemas.https, Schemas.vsls);
}
function shouldUseContributedExternalOpeners(target, options) {
	return !!options?.allowContributedOpeners && options.allowContributedOpeners !== "default" && shouldOpenExternal(target, options);
}
var OpenerService = class OpenerService {
	constructor(editorService, commandService) {
		this._openers = new LinkedList();
		this._validators = new LinkedList();
		this._resolvers = new LinkedList();
		this._resolvedUriTargets = new ResourceMap((uri) => uri.with({
			path: null,
			fragment: null,
			query: null
		}).toString());
		this._externalOpeners = new LinkedList();
		this._defaultExternalOpener = { openExternal: async (href) => {
			if (matchesSomeScheme(href, Schemas.http, Schemas.https)) windowOpenNoOpener(href);
			else mainWindow.location.href = href;
			return true;
		} };
		this._externalResourceOpener = { open: async (target, options) => {
			if (shouldOpenExternal(target, options)) {
				await this._doOpenExternal(target, options);
				return true;
			}
			return false;
		} };
		this._openers.push(this._externalResourceOpener);
		this._openers.push(new CommandOpener(commandService));
		this._openers.push(new EditorOpener(editorService));
	}
	registerOpener(opener) {
		return { dispose: this._openers.unshift(opener) };
	}
	async open(target, options) {
		const targetURI = typeof target === "string" ? URI.parse(target) : target;
		if (targetURI.scheme === Schemas.internal) return false;
		let externalUriOpenTarget;
		if (shouldUseContributedExternalOpeners(target, options)) {
			externalUriOpenTarget = await this._resolveExternalUriOpenTarget(target, options);
			if (await this._openWithContributedExternalOpeners(externalUriOpenTarget, options)) return true;
		}
		if (!options?.skipValidation) {
			const validationTarget = externalUriOpenTarget?.validationTarget ?? this._resolvedUriTargets.get(targetURI) ?? target;
			if (!await this._validate(validationTarget, options)) return false;
		}
		for (const opener of this._openers) {
			if (externalUriOpenTarget && opener === this._externalResourceOpener) return this._openDefaultExternal(externalUriOpenTarget);
			if (await opener.open(target, options)) return true;
		}
		return false;
	}
	async resolveExternalUri(resource, options) {
		for (const resolver of this._resolvers) try {
			const result = await resolver.resolveExternalUri(resource, options);
			if (result) {
				if (!this._resolvedUriTargets.has(result.resolved)) this._resolvedUriTargets.set(result.resolved, resource);
				return result;
			}
		} catch {}
		throw new Error("Could not resolve external URI: " + resource.toString());
	}
	async _resolveExternalUriOpenTarget(resource, options) {
		const uri = typeof resource === "string" ? URI.parse(resource) : resource;
		let externalUri;
		try {
			externalUri = (await this.resolveExternalUri(uri, options)).resolved;
		} catch {
			externalUri = uri;
		}
		const preserveOriginalString = typeof resource === "string" && uri.toString() === externalUri.toString();
		let href;
		if (preserveOriginalString) href = resource;
		else href = encodeURI(externalUri.toString(true));
		return {
			sourceUri: uri,
			href,
			validationTarget: preserveOriginalString ? resource : externalUri
		};
	}
	async _openWithContributedExternalOpeners(target, options) {
		const preferredOpenerId = typeof options?.allowContributedOpeners === "string" ? options.allowContributedOpeners : void 0;
		for (const opener of this._externalOpeners) if (await opener.openExternal(target.href, {
			sourceUri: target.sourceUri,
			preferredOpenerId
		}, CancellationToken.None)) return true;
		return false;
	}
	_openDefaultExternal(target) {
		return this._defaultExternalOpener.openExternal(target.href, { sourceUri: target.sourceUri }, CancellationToken.None);
	}
	async _doOpenExternal(resource, options) {
		const target = await this._resolveExternalUriOpenTarget(resource, options);
		return this._openDefaultExternal(target);
	}
	async _validate(resource, options) {
		for (const validator of this._validators) if (!await validator.shouldOpen(resource, options)) return false;
		return true;
	}
	dispose() {
		this._validators.clear();
	}
};
OpenerService = __decorate$29([__param$28(0, ICodeEditorService), __param$28(1, ICommandService)], OpenerService);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/services/renameSymbolTrackerService.js
var IRenameSymbolTrackerService = createDecorator("renameSymbolTrackerService");
var NullRenameSymbolTrackerService = class {
	constructor() {
		this._trackedWord = observableValue(this, void 0);
		this.trackedWord = this._trackedWord;
		this._trackedWord.set(void 0, void 0);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/config/diffEditor.js
var diffEditorDefaultOptions = {
	enableSplitViewResizing: true,
	renderSideBySide: true,
	renderMarginRevertIcon: true,
	renderGutterMenu: true,
	maxComputationTime: 5e3,
	maxFileSize: 50,
	ignoreTrimWhitespace: true,
	renderIndicators: true,
	originalEditable: false,
	diffCodeLens: false,
	renderOverviewRuler: true,
	diffWordWrap: "inherit",
	diffAlgorithm: "advanced",
	accessibilityVerbose: false,
	experimental: {
		showMoves: false,
		showEmptyDecorations: true,
		useTrueInlineView: false
	},
	hideUnchangedRegions: {
		enabled: false,
		contextLineCount: 3,
		minimumLineCount: 3,
		revealLineCount: 20
	},
	isInEmbeddedEditor: false,
	onlyShowAccessibleDiffViewer: false,
	renderSideBySideInlineBreakpoint: 900,
	useInlineViewWhenSpaceIsLimited: true,
	compactMode: false,
	hideOriginalLineNumbers: false
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/config/editorConfigurationSchema.js
var editorConfigurationBaseNode = Object.freeze({
	id: "editor",
	order: 5,
	type: "object",
	title: localize(168, "Editor"),
	scope: 6
});
var editorConfiguration = {
	...editorConfigurationBaseNode,
	properties: {
		"editor.tabSize": {
			type: "number",
			default: EDITOR_MODEL_DEFAULTS.tabSize,
			minimum: 1,
			maximum: 100,
			markdownDescription: localize(169, "The number of spaces a tab is equal to. This setting is overridden based on the file contents when {0} is on.", "`#editor.detectIndentation#`")
		},
		"editor.indentSize": {
			"anyOf": [{
				type: "string",
				enum: ["tabSize"]
			}, {
				type: "number",
				minimum: 1
			}],
			default: "tabSize",
			markdownDescription: localize(170, "The number of spaces used for indentation or `\"tabSize\"` to use the value from `#editor.tabSize#`. This setting is overridden based on the file contents when `#editor.detectIndentation#` is on.")
		},
		"editor.insertSpaces": {
			type: "boolean",
			default: EDITOR_MODEL_DEFAULTS.insertSpaces,
			markdownDescription: localize(171, "Insert spaces when pressing `Tab`. This setting is overridden based on the file contents when {0} is on.", "`#editor.detectIndentation#`")
		},
		"editor.detectIndentation": {
			type: "boolean",
			default: EDITOR_MODEL_DEFAULTS.detectIndentation,
			markdownDescription: localize(172, "Controls whether {0} and {1} will be automatically detected when a file is opened based on the file contents.", "`#editor.tabSize#`", "`#editor.insertSpaces#`")
		},
		"editor.trimAutoWhitespace": {
			type: "boolean",
			default: EDITOR_MODEL_DEFAULTS.trimAutoWhitespace,
			description: localize(173, "Remove trailing auto inserted whitespace.")
		},
		"editor.largeFileOptimizations": {
			type: "boolean",
			default: EDITOR_MODEL_DEFAULTS.largeFileOptimizations,
			description: localize(174, "Special handling for large files to disable certain memory intensive features.")
		},
		"editor.wordBasedSuggestions": {
			enum: [
				"off",
				"offWithInlineSuggestions",
				"currentDocument",
				"matchingDocuments",
				"allDocuments"
			],
			default: "offWithInlineSuggestions",
			enumDescriptions: [
				localize(175, "Turn off Word Based Suggestions."),
				localize(176, "Turn off Word Based Suggestions when Inline Suggestions are present."),
				localize(177, "Only suggest words from the active document."),
				localize(178, "Suggest words from all open documents of the same language."),
				localize(179, "Suggest words from all open documents.")
			],
			description: localize(180, "Controls whether completions should be computed based on words in the document and from which documents they are computed."),
			experiment: { mode: "auto" }
		},
		"editor.semanticHighlighting.enabled": {
			enum: [
				true,
				false,
				"configuredByTheme"
			],
			enumDescriptions: [
				localize(181, "Semantic highlighting enabled for all color themes."),
				localize(182, "Semantic highlighting disabled for all color themes."),
				localize(183, "Semantic highlighting is configured by the current color theme's `semanticHighlighting` setting.")
			],
			default: "configuredByTheme",
			description: localize(184, "Controls whether the semanticHighlighting is shown for the languages that support it.")
		},
		"editor.stablePeek": {
			type: "boolean",
			default: false,
			markdownDescription: localize(185, "Keep peek editors open even when double-clicking their content or when hitting `Escape`.")
		},
		"editor.maxTokenizationLineLength": {
			type: "integer",
			default: 2e4,
			description: localize(186, "Lines above this length will not be tokenized for performance reasons")
		},
		"editor.experimental.asyncTokenization": {
			type: "boolean",
			default: true,
			description: localize(187, "Controls whether the tokenization should happen asynchronously on a web worker."),
			tags: ["experimental"]
		},
		"editor.experimental.asyncTokenizationLogging": {
			type: "boolean",
			default: false,
			description: localize(188, "Controls whether async tokenization should be logged. For debugging only.")
		},
		"editor.experimental.asyncTokenizationVerification": {
			type: "boolean",
			default: false,
			description: localize(189, "Controls whether async tokenization should be verified against legacy background tokenization. Might slow down tokenization. For debugging only."),
			tags: ["experimental"]
		},
		"editor.experimental.treeSitterTelemetry": {
			type: "boolean",
			default: false,
			markdownDescription: localize(190, "Controls whether tree sitter parsing should be turned on and telemetry collected. Setting `#editor.experimental.preferTreeSitter#` for specific languages will take precedence."),
			tags: ["experimental"],
			experiment: { mode: "auto" }
		},
		"editor.experimental.preferTreeSitter.css": {
			type: "boolean",
			default: false,
			markdownDescription: localize(191, "Controls whether tree sitter parsing should be turned on for css. This will take precedence over `#editor.experimental.treeSitterTelemetry#` for css."),
			tags: ["experimental"],
			experiment: { mode: "auto" }
		},
		"editor.experimental.preferTreeSitter.typescript": {
			type: "boolean",
			default: false,
			markdownDescription: localize(192, "Controls whether tree sitter parsing should be turned on for typescript. This will take precedence over `#editor.experimental.treeSitterTelemetry#` for typescript."),
			tags: ["experimental"],
			experiment: { mode: "auto" }
		},
		"editor.experimental.preferTreeSitter.ini": {
			type: "boolean",
			default: false,
			markdownDescription: localize(193, "Controls whether tree sitter parsing should be turned on for ini. This will take precedence over `#editor.experimental.treeSitterTelemetry#` for ini."),
			tags: ["experimental"],
			experiment: { mode: "auto" }
		},
		"editor.experimental.preferTreeSitter.regex": {
			type: "boolean",
			default: false,
			markdownDescription: localize(194, "Controls whether tree sitter parsing should be turned on for regex. This will take precedence over `#editor.experimental.treeSitterTelemetry#` for regex."),
			tags: ["experimental"],
			experiment: { mode: "auto" }
		},
		"editor.language.brackets": {
			type: ["array", "null"],
			default: null,
			description: localize(195, "Defines the bracket symbols that increase or decrease the indentation."),
			items: {
				type: "array",
				items: [{
					type: "string",
					description: localize(196, "The opening bracket character or string sequence.")
				}, {
					type: "string",
					description: localize(197, "The closing bracket character or string sequence.")
				}]
			}
		},
		"editor.language.colorizedBracketPairs": {
			type: ["array", "null"],
			default: null,
			description: localize(198, "Defines the bracket pairs that are colorized by their nesting level if bracket pair colorization is enabled."),
			items: {
				type: "array",
				items: [{
					type: "string",
					description: localize(199, "The opening bracket character or string sequence.")
				}, {
					type: "string",
					description: localize(200, "The closing bracket character or string sequence.")
				}]
			}
		},
		"diffEditor.maxComputationTime": {
			type: "number",
			default: diffEditorDefaultOptions.maxComputationTime,
			description: localize(201, "Timeout in milliseconds after which diff computation is cancelled. Use 0 for no timeout.")
		},
		"diffEditor.maxFileSize": {
			type: "number",
			default: diffEditorDefaultOptions.maxFileSize,
			description: localize(202, "Maximum file size in MB for which to compute diffs. Use 0 for no limit.")
		},
		"diffEditor.renderSideBySide": {
			type: "boolean",
			default: diffEditorDefaultOptions.renderSideBySide,
			description: localize(203, "Controls whether the diff editor shows the diff side by side or inline."),
			agentsWindow: { default: true }
		},
		"diffEditor.renderSideBySideInlineBreakpoint": {
			type: "number",
			default: diffEditorDefaultOptions.renderSideBySideInlineBreakpoint,
			description: localize(204, "If the diff editor width is smaller than this value, the inline view is used.")
		},
		"diffEditor.useInlineViewWhenSpaceIsLimited": {
			type: "boolean",
			default: diffEditorDefaultOptions.useInlineViewWhenSpaceIsLimited,
			description: localize(205, "If enabled and the editor width is too small, the inline view is used."),
			agentsWindow: { default: true }
		},
		"diffEditor.hideOriginalLineNumbers": {
			type: ["boolean", "null"],
			default: null,
			description: localize(206, "Controls whether original line numbers are hidden in inline diffs. When set to null, uses the editor's default: hidden in compact multi diff editors and visible in other diff editors.")
		},
		"diffEditor.renderMarginRevertIcon": {
			type: "boolean",
			default: diffEditorDefaultOptions.renderMarginRevertIcon,
			description: localize(207, "When enabled, the diff editor shows arrows in its glyph margin to revert changes."),
			agentsWindow: { default: false }
		},
		"diffEditor.renderGutterMenu": {
			type: "boolean",
			default: diffEditorDefaultOptions.renderGutterMenu,
			description: localize(208, "When enabled, the diff editor shows a special gutter for revert and stage actions."),
			agentsWindow: { default: false }
		},
		"diffEditor.ignoreTrimWhitespace": {
			type: "boolean",
			default: diffEditorDefaultOptions.ignoreTrimWhitespace,
			description: localize(209, "When enabled, the diff editor ignores changes in leading or trailing whitespace.")
		},
		"diffEditor.renderIndicators": {
			type: "boolean",
			default: diffEditorDefaultOptions.renderIndicators,
			description: localize(210, "Controls whether the diff editor shows +/- indicators for added/removed changes."),
			agentsWindow: { default: false }
		},
		"diffEditor.codeLens": {
			type: "boolean",
			default: diffEditorDefaultOptions.diffCodeLens,
			description: localize(211, "Controls whether the editor shows CodeLens.")
		},
		"diffEditor.wordWrap": {
			type: "string",
			enum: [
				"off",
				"on",
				"inherit"
			],
			default: diffEditorDefaultOptions.diffWordWrap,
			markdownEnumDescriptions: [
				localize(212, "Lines will never wrap."),
				localize(213, "Lines will wrap at the viewport width."),
				localize(214, "Lines will wrap according to the {0} setting.", "`#editor.wordWrap#`")
			]
		},
		"diffEditor.diffAlgorithm": {
			type: "string",
			enum: [
				"legacy",
				"advanced",
				"advanced-external",
				"advanced-wasm"
			],
			default: diffEditorDefaultOptions.diffAlgorithm,
			markdownEnumDescriptions: [
				localize(215, "Uses the legacy diffing algorithm."),
				localize(216, "Uses the advanced diffing algorithm."),
				localize(217, "Uses the advanced diffing algorithm from the external `@vscode/diff` package (pure JavaScript)."),
				localize(218, "Uses the advanced diffing algorithm from the external `@vscode/diff` package (WebAssembly).")
			]
		},
		"diffEditor.hideUnchangedRegions.enabled": {
			type: "boolean",
			default: diffEditorDefaultOptions.hideUnchangedRegions.enabled,
			markdownDescription: localize(219, "Controls whether the diff editor shows unchanged regions."),
			agentsWindow: { default: true }
		},
		"diffEditor.hideUnchangedRegions.revealLineCount": {
			type: "integer",
			default: diffEditorDefaultOptions.hideUnchangedRegions.revealLineCount,
			markdownDescription: localize(220, "Controls how many lines are used for unchanged regions."),
			minimum: 1
		},
		"diffEditor.hideUnchangedRegions.minimumLineCount": {
			type: "integer",
			default: diffEditorDefaultOptions.hideUnchangedRegions.minimumLineCount,
			markdownDescription: localize(221, "Controls how many lines are used as a minimum for unchanged regions."),
			minimum: 1
		},
		"diffEditor.hideUnchangedRegions.contextLineCount": {
			type: "integer",
			default: diffEditorDefaultOptions.hideUnchangedRegions.contextLineCount,
			markdownDescription: localize(222, "Controls how many lines are used as context when comparing unchanged regions."),
			minimum: 1
		},
		"diffEditor.experimental.showMoves": {
			type: "boolean",
			default: diffEditorDefaultOptions.experimental.showMoves,
			markdownDescription: localize(223, "Controls whether the diff editor should show detected code moves.")
		},
		"diffEditor.experimental.showEmptyDecorations": {
			type: "boolean",
			default: diffEditorDefaultOptions.experimental.showEmptyDecorations,
			description: localize(224, "Controls whether the diff editor shows empty decorations to see where characters got inserted or deleted.")
		},
		"diffEditor.experimental.useTrueInlineView": {
			type: "boolean",
			default: diffEditorDefaultOptions.experimental.useTrueInlineView,
			description: localize(225, "If enabled and the editor uses the inline view, word changes are rendered inline.")
		}
	}
};
function isConfigurationPropertySchema(x) {
	return typeof x.type !== "undefined" || typeof x.anyOf !== "undefined";
}
for (const editorOption of editorOptionsRegistry) {
	const schema = editorOption.schema;
	if (typeof schema !== "undefined") {
		if (isConfigurationPropertySchema(schema)) editorConfiguration.properties[`editor.${editorOption.name}`] = schema;
		else for (const key in schema) if (Object.hasOwnProperty.call(schema, key)) editorConfiguration.properties[key] = schema[key];
	}
}
var cachedEditorConfigurationKeys = null;
function getEditorConfigurationKeys() {
	if (cachedEditorConfigurationKeys === null) {
		cachedEditorConfigurationKeys = Object.create(null);
		Object.keys(editorConfiguration.properties).forEach((prop) => {
			cachedEditorConfigurationKeys[prop] = true;
		});
	}
	return cachedEditorConfigurationKeys;
}
function isEditorConfigurationKey(key) {
	return getEditorConfigurationKeys()[`editor.${key}`] || false;
}
function isDiffEditorConfigurationKey(key) {
	return getEditorConfigurationKeys()[`diffEditor.${key}`] || false;
}
Registry.as(Extensions$6.Configuration).registerConfiguration(editorConfiguration);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/core/editOperation.js
var EditOperation = class {
	static insert(position, text) {
		return {
			range: new Range$2(position.lineNumber, position.column, position.lineNumber, position.column),
			text,
			forceMoveMarkers: true
		};
	}
	static delete(range) {
		return {
			range,
			text: null
		};
	}
	static replace(range, text) {
		return {
			range,
			text
		};
	}
	static replaceMove(range, text) {
		return {
			range,
			text,
			forceMoveMarkers: true
		};
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/editorFeatures.js
var editorFeatures = [];
/**
* Registers an editor feature. Editor features will be instantiated only once, as soon as
* the first code editor is instantiated.
*/
function registerEditorFeature(ctor) {
	editorFeatures.push(ctor);
}
function getEditorFeatures() {
	return editorFeatures.slice(0);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/services/languagesAssociations.js
var registeredAssociations = [];
var nonUserRegisteredAssociations = [];
var userRegisteredAssociations = [];
/**
* Associate a language to the registry (platform).
* * **NOTE**: This association will lose over associations registered using `registerConfiguredLanguageAssociation`.
* * **NOTE**: Use `clearPlatformLanguageAssociations` to remove all associations registered using this function.
*/
function registerPlatformLanguageAssociation(association, warnOnOverwrite = false) {
	_registerLanguageAssociation(association, false, warnOnOverwrite);
}
function _registerLanguageAssociation(association, userConfigured, warnOnOverwrite) {
	const associationItem = toLanguageAssociationItem(association, userConfigured);
	registeredAssociations.push(associationItem);
	if (!associationItem.userConfigured) nonUserRegisteredAssociations.push(associationItem);
	else userRegisteredAssociations.push(associationItem);
	if (warnOnOverwrite && !associationItem.userConfigured) registeredAssociations.forEach((a) => {
		if (a.mime === associationItem.mime || a.userConfigured) return;
		if (associationItem.extension && a.extension === associationItem.extension) console.warn(`Overwriting extension <<${associationItem.extension}>> to now point to mime <<${associationItem.mime}>>`);
		if (associationItem.filename && a.filename === associationItem.filename) console.warn(`Overwriting filename <<${associationItem.filename}>> to now point to mime <<${associationItem.mime}>>`);
		if (associationItem.filepattern && a.filepattern === associationItem.filepattern) console.warn(`Overwriting filepattern <<${associationItem.filepattern}>> to now point to mime <<${associationItem.mime}>>`);
		if (associationItem.firstline && a.firstline === associationItem.firstline) console.warn(`Overwriting firstline <<${associationItem.firstline}>> to now point to mime <<${associationItem.mime}>>`);
	});
}
function toLanguageAssociationItem(association, userConfigured) {
	return {
		id: association.id,
		mime: association.mime,
		filename: association.filename,
		extension: association.extension,
		filepattern: association.filepattern,
		firstline: association.firstline,
		userConfigured,
		filepatternParsed: association.filepattern ? parse(association.filepattern, { ignoreCase: true }) : void 0,
		filepatternOnPath: association.filepattern ? association.filepattern.indexOf(posix.sep) >= 0 : false
	};
}
/**
* Clear language associations from the registry (platform).
*/
function clearPlatformLanguageAssociations() {
	registeredAssociations = registeredAssociations.filter((a) => a.userConfigured);
	nonUserRegisteredAssociations = [];
}
/**
* @see `getMimeTypes`
*/
function getLanguageIds(resource, firstLine) {
	return getAssociations(resource, firstLine).map((item) => item.id);
}
function getAssociations(resource, firstLine) {
	let path;
	if (resource) switch (resource.scheme) {
		case Schemas.file:
			path = resource.fsPath;
			break;
		case Schemas.data:
			path = DataUri.parseMetaData(resource).get(DataUri.META_DATA_LABEL);
			break;
		case Schemas.vscodeNotebookCell:
			path = void 0;
			break;
		default: path = resource.path;
	}
	if (!path) return [{
		id: "unknown",
		mime: Mimes.unknown
	}];
	path = path.toLowerCase();
	const filename = basename$1(path);
	const configuredLanguage = getAssociationByPath(path, filename, userRegisteredAssociations);
	if (configuredLanguage) return [configuredLanguage, {
		id: PLAINTEXT_LANGUAGE_ID,
		mime: Mimes.text
	}];
	const registeredLanguage = getAssociationByPath(path, filename, nonUserRegisteredAssociations);
	if (registeredLanguage) return [registeredLanguage, {
		id: PLAINTEXT_LANGUAGE_ID,
		mime: Mimes.text
	}];
	if (firstLine) {
		const firstlineLanguage = getAssociationByFirstline(firstLine);
		if (firstlineLanguage) return [firstlineLanguage, {
			id: PLAINTEXT_LANGUAGE_ID,
			mime: Mimes.text
		}];
	}
	return [{
		id: "unknown",
		mime: Mimes.unknown
	}];
}
function getAssociationByPath(path, filename, associations) {
	let filenameMatch = void 0;
	let patternMatch = void 0;
	let extensionMatch = void 0;
	for (let i = associations.length - 1; i >= 0; i--) {
		const association = associations[i];
		if (equals$3(filename, association.filename)) {
			filenameMatch = association;
			break;
		}
		if (association.filepattern) {
			if (!patternMatch || association.filepattern.length > patternMatch.filepattern.length) {
				const target = association.filepatternOnPath ? path : filename;
				if (association.filepatternParsed?.(target)) patternMatch = association;
			}
		}
		if (association.extension) {
			if (!extensionMatch || association.extension.length > extensionMatch.extension.length) {
				if (endsWithIgnoreCase(filename, association.extension)) extensionMatch = association;
			}
		}
	}
	if (filenameMatch) return filenameMatch;
	if (patternMatch) return patternMatch;
	if (extensionMatch) return extensionMatch;
}
function getAssociationByFirstline(firstLine) {
	if (startsWithUTF8BOM(firstLine)) firstLine = firstLine.substring(1);
	if (firstLine.length > 0) for (let i = registeredAssociations.length - 1; i >= 0; i--) {
		const association = registeredAssociations[i];
		if (!association.firstline) continue;
		const matches = firstLine.match(association.firstline);
		if (matches && matches.length > 0) return association;
	}
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/services/languagesRegistry.js
var hasOwnProperty = Object.prototype.hasOwnProperty;
var NULL_LANGUAGE_ID = "vs.editor.nullLanguage";
var LanguageIdCodec = class {
	constructor() {
		this._languageIdToLanguage = [];
		this._languageToLanguageId = /* @__PURE__ */ new Map();
		this._register(NULL_LANGUAGE_ID, 0);
		this._register(PLAINTEXT_LANGUAGE_ID, 1);
		this._nextLanguageId = 2;
	}
	_register(language, languageId) {
		this._languageIdToLanguage[languageId] = language;
		this._languageToLanguageId.set(language, languageId);
	}
	register(language) {
		if (this._languageToLanguageId.has(language)) return;
		const languageId = this._nextLanguageId++;
		this._register(language, languageId);
	}
	encodeLanguageId(languageId) {
		return this._languageToLanguageId.get(languageId) || 0;
	}
	decodeLanguageId(languageId) {
		return this._languageIdToLanguage[languageId] || NULL_LANGUAGE_ID;
	}
};
var LanguagesRegistry = class LanguagesRegistry extends Disposable {
	static {
		this.instanceCount = 0;
	}
	constructor(useModesRegistry = true, warnOnOverwrite = false) {
		super();
		this._onDidChange = this._register(new Emitter$1());
		this.onDidChange = this._onDidChange.event;
		LanguagesRegistry.instanceCount++;
		this._warnOnOverwrite = warnOnOverwrite;
		this.languageIdCodec = new LanguageIdCodec();
		this._dynamicLanguages = [];
		this._languages = {};
		this._mimeTypesMap = {};
		this._nameMap = {};
		this._lowercaseNameMap = {};
		if (useModesRegistry) {
			this._initializeFromRegistry();
			this._register(ModesRegistry.onDidChangeLanguages((m) => {
				this._initializeFromRegistry();
			}));
		}
	}
	dispose() {
		LanguagesRegistry.instanceCount--;
		super.dispose();
	}
	_initializeFromRegistry() {
		this._languages = {};
		this._mimeTypesMap = {};
		this._nameMap = {};
		this._lowercaseNameMap = {};
		clearPlatformLanguageAssociations();
		const desc = [].concat(ModesRegistry.getLanguages()).concat(this._dynamicLanguages);
		this._registerLanguages(desc);
	}
	_registerLanguages(desc) {
		for (const d of desc) this._registerLanguage(d);
		this._mimeTypesMap = {};
		this._nameMap = {};
		this._lowercaseNameMap = {};
		Object.keys(this._languages).forEach((langId) => {
			const language = this._languages[langId];
			if (language.name) this._nameMap[language.name] = language.identifier;
			language.aliases.forEach((alias) => {
				this._lowercaseNameMap[alias.toLowerCase()] = language.identifier;
			});
			language.mimetypes.forEach((mimetype) => {
				this._mimeTypesMap[mimetype] = language.identifier;
			});
		});
		Registry.as(Extensions$6.Configuration).registerOverrideIdentifiers(this.getRegisteredLanguageIds());
		this._onDidChange.fire();
	}
	_registerLanguage(lang) {
		const langId = lang.id;
		let resolvedLanguage;
		if (hasOwnProperty.call(this._languages, langId)) resolvedLanguage = this._languages[langId];
		else {
			this.languageIdCodec.register(langId);
			resolvedLanguage = {
				identifier: langId,
				name: null,
				mimetypes: [],
				aliases: [],
				extensions: [],
				filenames: [],
				configurationFiles: [],
				icons: []
			};
			this._languages[langId] = resolvedLanguage;
		}
		this._mergeLanguage(resolvedLanguage, lang);
	}
	_mergeLanguage(resolvedLanguage, lang) {
		const langId = lang.id;
		let primaryMime = null;
		if (Array.isArray(lang.mimetypes) && lang.mimetypes.length > 0) {
			resolvedLanguage.mimetypes.push(...lang.mimetypes);
			primaryMime = lang.mimetypes[0];
		}
		if (!primaryMime) {
			primaryMime = `text/x-${langId}`;
			resolvedLanguage.mimetypes.push(primaryMime);
		}
		if (Array.isArray(lang.extensions)) {
			if (lang.configuration) resolvedLanguage.extensions = lang.extensions.concat(resolvedLanguage.extensions);
			else resolvedLanguage.extensions = resolvedLanguage.extensions.concat(lang.extensions);
			for (const extension of lang.extensions) registerPlatformLanguageAssociation({
				id: langId,
				mime: primaryMime,
				extension
			}, this._warnOnOverwrite);
		}
		if (Array.isArray(lang.filenames)) for (const filename of lang.filenames) {
			registerPlatformLanguageAssociation({
				id: langId,
				mime: primaryMime,
				filename
			}, this._warnOnOverwrite);
			resolvedLanguage.filenames.push(filename);
		}
		if (Array.isArray(lang.filenamePatterns)) for (const filenamePattern of lang.filenamePatterns) registerPlatformLanguageAssociation({
			id: langId,
			mime: primaryMime,
			filepattern: filenamePattern
		}, this._warnOnOverwrite);
		if (typeof lang.firstLine === "string" && lang.firstLine.length > 0) {
			let firstLineRegexStr = lang.firstLine;
			if (firstLineRegexStr.charAt(0) !== "^") firstLineRegexStr = "^" + firstLineRegexStr;
			try {
				const firstLineRegex = new RegExp(firstLineRegexStr);
				if (!regExpLeadsToEndlessLoop(firstLineRegex)) registerPlatformLanguageAssociation({
					id: langId,
					mime: primaryMime,
					firstline: firstLineRegex
				}, this._warnOnOverwrite);
			} catch (err) {
				console.warn(`[${lang.id}]: Invalid regular expression \`${firstLineRegexStr}\`: `, err);
			}
		}
		resolvedLanguage.aliases.push(langId);
		let langAliases = null;
		if (typeof lang.aliases !== "undefined" && Array.isArray(lang.aliases)) {
			if (lang.aliases.length === 0) langAliases = [null];
			else langAliases = lang.aliases;
		}
		if (langAliases !== null) for (const langAlias of langAliases) {
			if (!langAlias || langAlias.length === 0) continue;
			resolvedLanguage.aliases.push(langAlias);
		}
		const containsAliases = langAliases !== null && langAliases.length > 0;
		if (containsAliases && langAliases[0] === null);
		else {
			const bestName = (containsAliases ? langAliases[0] : null) || langId;
			if (containsAliases || !resolvedLanguage.name) resolvedLanguage.name = bestName;
		}
		if (lang.configuration) resolvedLanguage.configurationFiles.push(lang.configuration);
		if (lang.icon) resolvedLanguage.icons.push(lang.icon);
	}
	isRegisteredLanguageId(languageId) {
		if (!languageId) return false;
		return hasOwnProperty.call(this._languages, languageId);
	}
	getRegisteredLanguageIds() {
		return Object.keys(this._languages);
	}
	getLanguageIdByLanguageName(languageName) {
		const languageNameLower = languageName.toLowerCase();
		if (!hasOwnProperty.call(this._lowercaseNameMap, languageNameLower)) return null;
		return this._lowercaseNameMap[languageNameLower];
	}
	getLanguageIdByMimeType(mimeType) {
		if (!mimeType) return null;
		if (hasOwnProperty.call(this._mimeTypesMap, mimeType)) return this._mimeTypesMap[mimeType];
		return null;
	}
	guessLanguageIdByFilepathOrFirstLine(resource, firstLine) {
		if (!resource && !firstLine) return [];
		return getLanguageIds(resource, firstLine);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/services/languageService.js
var LanguageService = class LanguageService extends Disposable {
	static {
		this.instanceCount = 0;
	}
	constructor(warnOnOverwrite = false) {
		super();
		this._onDidRequestBasicLanguageFeatures = this._register(new Emitter$1());
		this.onDidRequestBasicLanguageFeatures = this._onDidRequestBasicLanguageFeatures.event;
		this._onDidRequestRichLanguageFeatures = this._register(new Emitter$1());
		this.onDidRequestRichLanguageFeatures = this._onDidRequestRichLanguageFeatures.event;
		this._onDidChange = this._register(new Emitter$1({
			leakWarningThreshold: 200,
			leakWarningName: "LanguageService._onDidChange"
		}));
		this.onDidChange = this._onDidChange.event;
		this._requestedBasicLanguages = /* @__PURE__ */ new Set();
		this._requestedRichLanguages = /* @__PURE__ */ new Set();
		LanguageService.instanceCount++;
		this._registry = this._register(new LanguagesRegistry(true, warnOnOverwrite));
		this.languageIdCodec = this._registry.languageIdCodec;
		this._register(this._registry.onDidChange(() => this._onDidChange.fire()));
	}
	dispose() {
		LanguageService.instanceCount--;
		super.dispose();
	}
	isRegisteredLanguageId(languageId) {
		return this._registry.isRegisteredLanguageId(languageId);
	}
	getLanguageIdByLanguageName(languageName) {
		return this._registry.getLanguageIdByLanguageName(languageName);
	}
	getLanguageIdByMimeType(mimeType) {
		return this._registry.getLanguageIdByMimeType(mimeType);
	}
	guessLanguageIdByFilepathOrFirstLine(resource, firstLine) {
		return this._registry.guessLanguageIdByFilepathOrFirstLine(resource, firstLine).at(0) ?? null;
	}
	createById(languageId) {
		return new LanguageSelection(this.onDidChange, () => {
			return this._createAndGetLanguageIdentifier(languageId);
		});
	}
	createByFilepathOrFirstLine(resource, firstLine) {
		return new LanguageSelection(this.onDidChange, () => {
			const languageId = this.guessLanguageIdByFilepathOrFirstLine(resource, firstLine);
			return this._createAndGetLanguageIdentifier(languageId);
		});
	}
	_createAndGetLanguageIdentifier(languageId) {
		if (!languageId || !this.isRegisteredLanguageId(languageId)) languageId = PLAINTEXT_LANGUAGE_ID;
		return languageId;
	}
	requestBasicLanguageFeatures(languageId) {
		if (!this._requestedBasicLanguages.has(languageId)) {
			this._requestedBasicLanguages.add(languageId);
			this._onDidRequestBasicLanguageFeatures.fire(languageId);
		}
	}
	requestRichLanguageFeatures(languageId) {
		if (!this._requestedRichLanguages.has(languageId)) {
			this._requestedRichLanguages.add(languageId);
			this.requestBasicLanguageFeatures(languageId);
			TokenizationRegistry.getOrCreate(languageId);
			this._onDidRequestRichLanguageFeatures.fire(languageId);
		}
	}
};
var LanguageSelection = class {
	constructor(onDidChangeLanguages, selector) {
		this._value = observableFromEvent(this, onDidChangeLanguages, () => selector());
		this.onDidChange = Event.fromObservable(this._value);
	}
	get languageId() {
		return this._value.get();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/services/markerDecorationsService.js
var __decorate$28 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$27 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var MarkerDecorationsService = class MarkerDecorationsService extends Disposable {
	constructor(modelService, _markerService) {
		super();
		this._markerService = _markerService;
		this._onDidChangeMarker = this._register(new Emitter$1());
		this._suppressedRanges = new ResourceMap();
		this._markerDecorations = new ResourceMap();
		modelService.getModels().forEach((model) => this._onModelAdded(model));
		this._register(modelService.onModelAdded(this._onModelAdded, this));
		this._register(modelService.onModelRemoved(this._onModelRemoved, this));
		this._register(this._markerService.onMarkerChanged(this._handleMarkerChange, this));
	}
	dispose() {
		super.dispose();
		this._markerDecorations.forEach((value) => value.dispose());
		this._markerDecorations.clear();
	}
	getMarker(uri, decoration) {
		const markerDecorations = this._markerDecorations.get(uri);
		return markerDecorations ? markerDecorations.getMarker(decoration) || null : null;
	}
	_handleMarkerChange(changedResources) {
		changedResources.forEach((resource) => {
			const markerDecorations = this._markerDecorations.get(resource);
			if (markerDecorations) this._updateDecorations(markerDecorations);
		});
	}
	_onModelAdded(model) {
		const markerDecorations = new MarkerDecorations(model);
		this._markerDecorations.set(model.uri, markerDecorations);
		this._updateDecorations(markerDecorations);
	}
	_onModelRemoved(model) {
		const markerDecorations = this._markerDecorations.get(model.uri);
		if (markerDecorations) {
			markerDecorations.dispose();
			this._markerDecorations.delete(model.uri);
		}
		if (model.uri.scheme === Schemas.inMemory || model.uri.scheme === Schemas.internal || model.uri.scheme === Schemas.vscode) this._markerService?.read({ resource: model.uri }).map((marker) => marker.owner).forEach((owner) => this._markerService.remove(owner, [model.uri]));
	}
	_updateDecorations(markerDecorations) {
		let markers = this._markerService.read({
			resource: markerDecorations.model.uri,
			take: 500
		});
		const suppressedRanges = this._suppressedRanges.get(markerDecorations.model.uri);
		if (suppressedRanges) markers = markers.filter((marker) => {
			return !Iterable.some(suppressedRanges, (candidate) => Range$2.areIntersectingOrTouching(candidate, marker));
		});
		if (markerDecorations.update(markers)) this._onDidChangeMarker.fire(markerDecorations.model);
	}
};
MarkerDecorationsService = __decorate$28([__param$27(0, IModelService), __param$27(1, IMarkerService)], MarkerDecorationsService);
var MarkerDecorations = class extends Disposable {
	constructor(model) {
		super();
		this.model = model;
		this._map = new BidirectionalMap();
		this._register(toDisposable(() => {
			this.model.deltaDecorations([...this._map.values()], []);
			this._map.clear();
		}));
	}
	update(markers) {
		const { added, removed } = diffSets(new Set(this._map.keys()), new Set(markers));
		if (added.length === 0 && removed.length === 0) return false;
		const oldIds = removed.map((marker) => this._map.get(marker));
		const newDecorations = added.map((marker) => {
			return {
				range: this._createDecorationRange(this.model, marker),
				options: this._createDecorationOption(marker)
			};
		});
		const ids = this.model.deltaDecorations(oldIds, newDecorations);
		for (const removedMarker of removed) this._map.delete(removedMarker);
		for (let index = 0; index < ids.length; index++) this._map.set(added[index], ids[index]);
		return true;
	}
	getMarker(decoration) {
		return this._map.getKey(decoration.id);
	}
	_createDecorationRange(model, rawMarker) {
		let ret = Range$2.lift(rawMarker);
		if (rawMarker.severity === MarkerSeverity$1.Hint && !this._hasMarkerTag(rawMarker, 1) && !this._hasMarkerTag(rawMarker, 2)) ret = ret.setEndPosition(ret.startLineNumber, ret.startColumn + 2);
		ret = model.validateRange(ret);
		if (ret.isEmpty()) {
			const maxColumn = model.getLineLastNonWhitespaceColumn(ret.startLineNumber) || model.getLineMaxColumn(ret.startLineNumber);
			if (maxColumn === 1 || ret.endColumn >= maxColumn) return ret;
			const word = model.getWordAtPosition(ret.getStartPosition());
			if (word) ret = new Range$2(ret.startLineNumber, word.startColumn, ret.endLineNumber, word.endColumn);
		} else if (rawMarker.endColumn === Number.MAX_VALUE && rawMarker.startColumn === 1 && ret.startLineNumber === ret.endLineNumber) {
			const minColumn = model.getLineFirstNonWhitespaceColumn(rawMarker.startLineNumber);
			if (minColumn < ret.endColumn) {
				ret = new Range$2(ret.startLineNumber, minColumn, ret.endLineNumber, ret.endColumn);
				rawMarker.startColumn = minColumn;
			}
		}
		return ret;
	}
	_createDecorationOption(marker) {
		let className;
		let color = void 0;
		let zIndex;
		let inlineClassName = void 0;
		let minimap;
		switch (marker.severity) {
			case MarkerSeverity$1.Hint:
				if (this._hasMarkerTag(marker, 2)) className = void 0;
				else if (this._hasMarkerTag(marker, 1)) className = "squiggly-unnecessary";
				else className = "squiggly-hint";
				zIndex = 0;
				break;
			case MarkerSeverity$1.Info:
				className = "squiggly-info";
				color = themeColorFromId(overviewRulerInfo);
				zIndex = 10;
				minimap = {
					color: themeColorFromId(minimapInfo),
					position: 1
				};
				break;
			case MarkerSeverity$1.Warning:
				className = "squiggly-warning";
				color = themeColorFromId(overviewRulerWarning);
				zIndex = 20;
				minimap = {
					color: themeColorFromId(minimapWarning),
					position: 1
				};
				break;
			case MarkerSeverity$1.Error:
			default:
				className = "squiggly-error";
				color = themeColorFromId(overviewRulerError);
				zIndex = 30;
				minimap = {
					color: themeColorFromId(minimapError),
					position: 1
				};
		}
		if (marker.tags) {
			if (marker.tags.indexOf(1) !== -1) inlineClassName = "squiggly-inline-unnecessary";
			if (marker.tags.indexOf(2) !== -1) inlineClassName = "squiggly-inline-deprecated";
		}
		return {
			description: "marker-decoration",
			stickiness: 1,
			className,
			showIfCollapsed: true,
			overviewRuler: {
				color,
				position: OverviewRulerLane.Right
			},
			minimap,
			zIndex,
			inlineClassName
		};
	}
	_hasMarkerTag(marker, tag) {
		if (marker.tags) return marker.tags.indexOf(tag) >= 0;
		return false;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/services/modelService.js
var __decorate$27 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$26 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var ModelService_1;
function MODEL_ID(resource) {
	return resource.toString();
}
var ModelData = class {
	constructor(model, onWillDispose, onDidChangeLanguage) {
		this.model = model;
		this._modelEventListeners = new DisposableStore();
		this.model = model;
		this._modelEventListeners.add(model.onWillDispose(() => onWillDispose(model)));
		this._modelEventListeners.add(model.onDidChangeLanguage((e) => onDidChangeLanguage(model, e)));
	}
	dispose() {
		this._modelEventListeners.dispose();
	}
};
var DEFAULT_EOL = isLinux || isMacintosh ? 1 : 2;
var DisposedModelInfo = class {
	constructor(uri, initialUndoRedoSnapshot, time, sharesUndoRedoStack, heapSize, sha1, versionId, alternativeVersionId) {
		this.uri = uri;
		this.initialUndoRedoSnapshot = initialUndoRedoSnapshot;
		this.time = time;
		this.sharesUndoRedoStack = sharesUndoRedoStack;
		this.heapSize = heapSize;
		this.sha1 = sha1;
		this.versionId = versionId;
		this.alternativeVersionId = alternativeVersionId;
	}
};
var ModelService = class ModelService extends Disposable {
	static {
		ModelService_1 = this;
	}
	static {
		this.MAX_MEMORY_FOR_CLOSED_FILES_UNDO_STACK = 20971520;
	}
	constructor(_configurationService, _resourcePropertiesService, _undoRedoService, _instantiationService) {
		super();
		this._configurationService = _configurationService;
		this._resourcePropertiesService = _resourcePropertiesService;
		this._undoRedoService = _undoRedoService;
		this._instantiationService = _instantiationService;
		this._onModelAdded = this._register(new Emitter$1());
		this.onModelAdded = this._onModelAdded.event;
		this._onModelRemoved = this._register(new Emitter$1());
		this.onModelRemoved = this._onModelRemoved.event;
		this._onModelModeChanged = this._register(new Emitter$1());
		this.onModelLanguageChanged = this._onModelModeChanged.event;
		this._modelCreationOptionsByLanguageAndResource = Object.create(null);
		this._models = {};
		this._disposedModels = /* @__PURE__ */ new Map();
		this._disposedModelsHeapSize = 0;
		this._register(this._configurationService.onDidChangeConfiguration((e) => this._updateModelOptions(e)));
		this._updateModelOptions(void 0);
	}
	static _readModelOptions(config, isForSimpleWidget) {
		let tabSize = EDITOR_MODEL_DEFAULTS.tabSize;
		if (config.editor && typeof config.editor.tabSize !== "undefined") tabSize = clampedInt(config.editor.tabSize, EDITOR_MODEL_DEFAULTS.tabSize, 1, 100);
		let indentSize = "tabSize";
		if (config.editor && typeof config.editor.indentSize !== "undefined" && config.editor.indentSize !== "tabSize") indentSize = clampedInt(config.editor.indentSize, "tabSize", 1, 100);
		let insertSpaces = EDITOR_MODEL_DEFAULTS.insertSpaces;
		if (config.editor && typeof config.editor.insertSpaces !== "undefined") insertSpaces = config.editor.insertSpaces === "false" ? false : Boolean(config.editor.insertSpaces);
		let newDefaultEOL = DEFAULT_EOL;
		const eol = config.eol;
		if (eol === "\r\n") newDefaultEOL = 2;
		else if (eol === "\n") newDefaultEOL = 1;
		let trimAutoWhitespace = EDITOR_MODEL_DEFAULTS.trimAutoWhitespace;
		if (config.editor && typeof config.editor.trimAutoWhitespace !== "undefined") trimAutoWhitespace = config.editor.trimAutoWhitespace === "false" ? false : Boolean(config.editor.trimAutoWhitespace);
		let detectIndentation = EDITOR_MODEL_DEFAULTS.detectIndentation;
		if (config.editor && typeof config.editor.detectIndentation !== "undefined") detectIndentation = config.editor.detectIndentation === "false" ? false : Boolean(config.editor.detectIndentation);
		let largeFileOptimizations = EDITOR_MODEL_DEFAULTS.largeFileOptimizations;
		if (config.editor && typeof config.editor.largeFileOptimizations !== "undefined") largeFileOptimizations = config.editor.largeFileOptimizations === "false" ? false : Boolean(config.editor.largeFileOptimizations);
		let bracketPairColorizationOptions = EDITOR_MODEL_DEFAULTS.bracketPairColorizationOptions;
		if (config.editor?.bracketPairColorization && typeof config.editor.bracketPairColorization === "object") {
			const bpConfig = config.editor.bracketPairColorization;
			bracketPairColorizationOptions = {
				enabled: !!bpConfig.enabled,
				independentColorPoolPerBracketType: !!bpConfig.independentColorPoolPerBracketType
			};
		}
		return {
			isForSimpleWidget,
			tabSize,
			indentSize,
			insertSpaces,
			detectIndentation,
			defaultEOL: newDefaultEOL,
			trimAutoWhitespace,
			largeFileOptimizations,
			bracketPairColorizationOptions
		};
	}
	_getEOL(resource, language) {
		if (resource) return this._resourcePropertiesService.getEOL(resource, language);
		const eol = this._configurationService.getValue("files.eol", { overrideIdentifier: language });
		if (eol && typeof eol === "string" && eol !== "auto") return eol;
		return OS === 3 || OS === 2 ? "\n" : "\r\n";
	}
	_shouldRestoreUndoStack() {
		const result = this._configurationService.getValue("files.restoreUndoStack");
		if (typeof result === "boolean") return result;
		return true;
	}
	getCreationOptions(languageIdOrSelection, resource, isForSimpleWidget) {
		const language = typeof languageIdOrSelection === "string" ? languageIdOrSelection : languageIdOrSelection.languageId;
		let creationOptions = this._modelCreationOptionsByLanguageAndResource[language + resource];
		if (!creationOptions) {
			const editor = this._configurationService.getValue("editor", {
				overrideIdentifier: language,
				resource
			});
			const eol = this._getEOL(resource, language);
			creationOptions = ModelService_1._readModelOptions({
				editor,
				eol
			}, isForSimpleWidget);
			this._modelCreationOptionsByLanguageAndResource[language + resource] = creationOptions;
		}
		return creationOptions;
	}
	_updateModelOptions(e) {
		const oldOptionsByLanguageAndResource = this._modelCreationOptionsByLanguageAndResource;
		this._modelCreationOptionsByLanguageAndResource = Object.create(null);
		const keys = Object.keys(this._models);
		for (let i = 0, len = keys.length; i < len; i++) {
			const modelId = keys[i];
			const modelData = this._models[modelId];
			const language = modelData.model.getLanguageId();
			const uri = modelData.model.uri;
			if (e && !e.affectsConfiguration("editor", {
				overrideIdentifier: language,
				resource: uri
			}) && !e.affectsConfiguration("files.eol", {
				overrideIdentifier: language,
				resource: uri
			})) continue;
			const oldOptions = oldOptionsByLanguageAndResource[language + uri];
			const newOptions = this.getCreationOptions(language, uri, modelData.model.isForSimpleWidget);
			ModelService_1._setModelOptionsForModel(modelData.model, newOptions, oldOptions);
		}
	}
	static _setModelOptionsForModel(model, newOptions, currentOptions) {
		if (currentOptions && currentOptions.defaultEOL !== newOptions.defaultEOL && model.getLineCount() === 1) model.setEOL(newOptions.defaultEOL === 1 ? 0 : 1);
		if (currentOptions && currentOptions.detectIndentation === newOptions.detectIndentation && currentOptions.insertSpaces === newOptions.insertSpaces && currentOptions.tabSize === newOptions.tabSize && currentOptions.indentSize === newOptions.indentSize && currentOptions.trimAutoWhitespace === newOptions.trimAutoWhitespace && equals$2(currentOptions.bracketPairColorizationOptions, newOptions.bracketPairColorizationOptions)) return;
		if (newOptions.detectIndentation) {
			model.detectIndentation(newOptions.insertSpaces, newOptions.tabSize);
			model.updateOptions({
				trimAutoWhitespace: newOptions.trimAutoWhitespace,
				bracketColorizationOptions: newOptions.bracketPairColorizationOptions
			});
		} else model.updateOptions({
			insertSpaces: newOptions.insertSpaces,
			tabSize: newOptions.tabSize,
			indentSize: newOptions.indentSize,
			trimAutoWhitespace: newOptions.trimAutoWhitespace,
			bracketColorizationOptions: newOptions.bracketPairColorizationOptions
		});
	}
	_insertDisposedModel(disposedModelData) {
		this._disposedModels.set(MODEL_ID(disposedModelData.uri), disposedModelData);
		this._disposedModelsHeapSize += disposedModelData.heapSize;
	}
	_removeDisposedModel(resource) {
		const disposedModelData = this._disposedModels.get(MODEL_ID(resource));
		if (disposedModelData) this._disposedModelsHeapSize -= disposedModelData.heapSize;
		this._disposedModels.delete(MODEL_ID(resource));
		return disposedModelData;
	}
	_ensureDisposedModelsHeapSize(maxModelsHeapSize) {
		if (this._disposedModelsHeapSize > maxModelsHeapSize) {
			const disposedModels = [];
			this._disposedModels.forEach((entry) => {
				if (!entry.sharesUndoRedoStack) disposedModels.push(entry);
			});
			disposedModels.sort((a, b) => a.time - b.time);
			while (disposedModels.length > 0 && this._disposedModelsHeapSize > maxModelsHeapSize) {
				const disposedModel = disposedModels.shift();
				this._removeDisposedModel(disposedModel.uri);
				if (disposedModel.initialUndoRedoSnapshot !== null) this._undoRedoService.restoreSnapshot(disposedModel.initialUndoRedoSnapshot);
			}
		}
	}
	_createModelData(value, languageIdOrSelection, resource, isForSimpleWidget) {
		const options = this.getCreationOptions(languageIdOrSelection, resource, isForSimpleWidget);
		const model = this._instantiationService.createInstance(TextModel, value, languageIdOrSelection, options, resource);
		if (resource && this._disposedModels.has(MODEL_ID(resource))) {
			const disposedModelData = this._removeDisposedModel(resource);
			const elements = this._undoRedoService.getElements(resource);
			const sha1Computer = this._getSHA1Computer();
			const sha1IsEqual = sha1Computer.canComputeSHA1(model) ? sha1Computer.computeSHA1(model) === disposedModelData.sha1 : false;
			if (sha1IsEqual || disposedModelData.sharesUndoRedoStack) {
				for (const element of elements.past) if (isEditStackElement(element) && element.matchesResource(resource)) element.setModel(model);
				for (const element of elements.future) if (isEditStackElement(element) && element.matchesResource(resource)) element.setModel(model);
				this._undoRedoService.setElementsValidFlag(resource, true, (element) => isEditStackElement(element) && element.matchesResource(resource));
				if (sha1IsEqual) {
					model._overwriteVersionId(disposedModelData.versionId);
					model._overwriteAlternativeVersionId(disposedModelData.alternativeVersionId);
					model._overwriteInitialUndoRedoSnapshot(disposedModelData.initialUndoRedoSnapshot);
				}
			} else if (disposedModelData.initialUndoRedoSnapshot !== null) this._undoRedoService.restoreSnapshot(disposedModelData.initialUndoRedoSnapshot);
		}
		const modelId = MODEL_ID(model.uri);
		if (this._models[modelId]) throw new Error("ModelService: Cannot add model because it already exists!");
		const modelData = new ModelData(model, (model) => this._onWillDispose(model), (model, e) => this._onDidChangeLanguage(model, e));
		this._models[modelId] = modelData;
		return modelData;
	}
	createModel(value, languageSelection, resource, isForSimpleWidget = false) {
		let modelData;
		if (languageSelection) modelData = this._createModelData(value, languageSelection, resource, isForSimpleWidget);
		else modelData = this._createModelData(value, PLAINTEXT_LANGUAGE_ID, resource, isForSimpleWidget);
		this._onModelAdded.fire(modelData.model);
		return modelData.model;
	}
	getModels() {
		const ret = [];
		const keys = Object.keys(this._models);
		for (let i = 0, len = keys.length; i < len; i++) {
			const modelId = keys[i];
			ret.push(this._models[modelId].model);
		}
		return ret;
	}
	getModel(resource) {
		const modelId = MODEL_ID(resource);
		const modelData = this._models[modelId];
		if (!modelData) return null;
		return modelData.model;
	}
	_schemaShouldMaintainUndoRedoElements(resource) {
		return resource.scheme === Schemas.file || resource.scheme === Schemas.vscodeRemote || resource.scheme === Schemas.vscodeUserData || resource.scheme === Schemas.vscodeNotebookCell || resource.scheme === "fake-fs";
	}
	_onWillDispose(model) {
		const modelId = MODEL_ID(model.uri);
		const modelData = this._models[modelId];
		const sharesUndoRedoStack = this._undoRedoService.getUriComparisonKey(model.uri) !== model.uri.toString();
		let maintainUndoRedoStack = false;
		let heapSize = 0;
		if (sharesUndoRedoStack || this._shouldRestoreUndoStack() && this._schemaShouldMaintainUndoRedoElements(model.uri)) {
			const elements = this._undoRedoService.getElements(model.uri);
			if (elements.past.length > 0 || elements.future.length > 0) {
				for (const element of elements.past) if (isEditStackElement(element) && element.matchesResource(model.uri)) {
					maintainUndoRedoStack = true;
					heapSize += element.heapSize(model.uri);
					element.setModel(model.uri);
				}
				for (const element of elements.future) if (isEditStackElement(element) && element.matchesResource(model.uri)) {
					maintainUndoRedoStack = true;
					heapSize += element.heapSize(model.uri);
					element.setModel(model.uri);
				}
			}
		}
		const maxMemory = ModelService_1.MAX_MEMORY_FOR_CLOSED_FILES_UNDO_STACK;
		const sha1Computer = this._getSHA1Computer();
		if (!maintainUndoRedoStack) {
			if (!sharesUndoRedoStack) {
				const initialUndoRedoSnapshot = modelData.model.getInitialUndoRedoSnapshot();
				if (initialUndoRedoSnapshot !== null) this._undoRedoService.restoreSnapshot(initialUndoRedoSnapshot);
			}
		} else if (!sharesUndoRedoStack && (heapSize > maxMemory || !sha1Computer.canComputeSHA1(model))) {
			const initialUndoRedoSnapshot = modelData.model.getInitialUndoRedoSnapshot();
			if (initialUndoRedoSnapshot !== null) this._undoRedoService.restoreSnapshot(initialUndoRedoSnapshot);
		} else {
			this._ensureDisposedModelsHeapSize(maxMemory - heapSize);
			this._undoRedoService.setElementsValidFlag(model.uri, false, (element) => isEditStackElement(element) && element.matchesResource(model.uri));
			this._insertDisposedModel(new DisposedModelInfo(model.uri, modelData.model.getInitialUndoRedoSnapshot(), Date.now(), sharesUndoRedoStack, heapSize, sha1Computer.computeSHA1(model), model.getVersionId(), model.getAlternativeVersionId()));
		}
		delete this._models[modelId];
		modelData.dispose();
		delete this._modelCreationOptionsByLanguageAndResource[model.getLanguageId() + model.uri];
		this._onModelRemoved.fire(model);
	}
	_onDidChangeLanguage(model, e) {
		const oldLanguageId = e.oldLanguage;
		const newLanguageId = model.getLanguageId();
		const oldOptions = this.getCreationOptions(oldLanguageId, model.uri, model.isForSimpleWidget);
		const newOptions = this.getCreationOptions(newLanguageId, model.uri, model.isForSimpleWidget);
		ModelService_1._setModelOptionsForModel(model, newOptions, oldOptions);
		this._onModelModeChanged.fire({
			model,
			oldLanguageId
		});
	}
	_getSHA1Computer() {
		return new DefaultModelSHA1Computer();
	}
};
ModelService = ModelService_1 = __decorate$27([
	__param$26(0, IConfigurationService),
	__param$26(1, ITextResourcePropertiesService),
	__param$26(2, IUndoRedoService),
	__param$26(3, IInstantiationService)
], ModelService);
var DefaultModelSHA1Computer = class DefaultModelSHA1Computer {
	static {
		this.MAX_MODEL_SIZE = 10485760;
	}
	canComputeSHA1(model) {
		return model.getValueLength() <= DefaultModelSHA1Computer.MAX_MODEL_SIZE;
	}
	computeSHA1(model) {
		const shaComputer = new StringSHA1();
		const snapshot = model.createSnapshot();
		let text;
		while (text = snapshot.read()) shaComputer.update(text);
		return shaComputer.digest();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/standaloneStrings.js
var InspectTokensNLS;
(function(InspectTokensNLS) {
	InspectTokensNLS.inspectTokensAction = localize(836, "Developer: Inspect Tokens");
})(InspectTokensNLS || (InspectTokensNLS = {}));
var GoToLineNLS;
(function(GoToLineNLS) {
	GoToLineNLS.gotoLineActionLabel = localize(837, "Go to Line/Column...");
	GoToLineNLS.gotoOffsetActionLabel = localize(838, "Go to Offset...");
})(GoToLineNLS || (GoToLineNLS = {}));
var QuickHelpNLS;
(function(QuickHelpNLS) {
	QuickHelpNLS.helpQuickAccessActionLabel = localize(839, "Show all Quick Access Providers");
})(QuickHelpNLS || (QuickHelpNLS = {}));
var QuickCommandNLS;
(function(QuickCommandNLS) {
	QuickCommandNLS.quickCommandActionLabel = localize(840, "Command Palette");
	QuickCommandNLS.quickCommandHelp = localize(841, "Show And Run Commands");
})(QuickCommandNLS || (QuickCommandNLS = {}));
var QuickOutlineNLS;
(function(QuickOutlineNLS) {
	QuickOutlineNLS.quickOutlineActionLabel = localize(842, "Go to Symbol...");
	QuickOutlineNLS.quickOutlineByCategoryActionLabel = localize(843, "Go to Symbol by Category...");
})(QuickOutlineNLS || (QuickOutlineNLS = {}));
var StandaloneCodeEditorNLS;
(function(StandaloneCodeEditorNLS) {
	StandaloneCodeEditorNLS.editorViewAccessibleLabel = localize(844, "Editor content");
})(StandaloneCodeEditorNLS || (StandaloneCodeEditorNLS = {}));
var ToggleHighContrastNLS;
(function(ToggleHighContrastNLS) {
	ToggleHighContrastNLS.toggleHighContrast = localize(845, "Toggle High Contrast Theme");
})(ToggleHighContrastNLS || (ToggleHighContrastNLS = {}));
var StandaloneServicesNLS;
(function(StandaloneServicesNLS) {
	StandaloneServicesNLS.bulkEditServiceSummary = localize(846, "Made {0} edits in {1} files");
})(StandaloneServicesNLS || (StandaloneServicesNLS = {}));
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/standalone/common/standaloneTheme.js
var IStandaloneThemeService = createDecorator("themeService");
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/services/inMemoryTextModelService.js
var __decorate$26 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$25 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var InMemoryTextModelService = class InMemoryTextModelService {
	constructor(modelService) {
		this._models = new InMemoryModelCollection(modelService);
	}
	createModelReference(resource) {
		return this._acquire(resource);
	}
	createSyntheticDocument(value, languageSelection) {
		const resource = URI.from({
			scheme: Schemas.inMemory,
			path: `/synthetic/${generateUuid()}`
		});
		return this._acquire(resource, value, languageSelection);
	}
	async _acquire(resource, value, languageSelection = null) {
		const reference = this._models.acquire(resource.toString(), value, languageSelection);
		try {
			await Promise.resolve();
			return {
				object: reference.object.value,
				dispose: () => reference.dispose()
			};
		} catch (error) {
			reference.dispose();
			throw error;
		}
	}
};
InMemoryTextModelService = __decorate$26([__param$25(0, IModelService)], InMemoryTextModelService);
var InMemoryModelCollection = class extends ReferenceCollection {
	constructor(_modelService) {
		super();
		this._modelService = _modelService;
	}
	createReferencedObject(key, value, languageSelection = null) {
		return new Lazy(() => {
			const resource = URI.parse(key);
			const model = value === void 0 ? this._modelService.getModel(resource) : this._modelService.createModel(value, languageSelection, resource);
			if (!model) throw new Error("Model not found");
			return new SimpleModel(model, value !== void 0);
		});
	}
	destroyReferencedObject(_key, model) {
		model.rawValue?.dispose();
	}
};
var SimpleModel = class extends Disposable {
	constructor(textEditorModel, _ownsModel) {
		super();
		this.textEditorModel = textEditorModel;
		this._ownsModel = _ownsModel;
		this._onWillDispose = this._register(new Emitter$1());
	}
	dispose() {
		if (this.isDisposed()) return;
		this._onWillDispose.fire();
		super.dispose();
		if (this._ownsModel) this.textEditorModel.dispose();
	}
	isDisposed() {
		return this._store.isDisposed;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/quickinput/common/quickAccess.js
var DefaultQuickAccessFilterValue;
(function(DefaultQuickAccessFilterValue) {
	/**
	* Keep the value as it is given to quick access.
	*/
	DefaultQuickAccessFilterValue[DefaultQuickAccessFilterValue["PRESERVE"] = 0] = "PRESERVE";
	/**
	* Use the value that was used last time something was accepted from the picker.
	*/
	DefaultQuickAccessFilterValue[DefaultQuickAccessFilterValue["LAST"] = 1] = "LAST";
})(DefaultQuickAccessFilterValue || (DefaultQuickAccessFilterValue = {}));
var Extensions$1 = { Quickaccess: "workbench.contributions.quickaccess" };
var QuickAccessRegistry = class {
	constructor() {
		this.providers = [];
		this.defaultProvider = void 0;
	}
	registerQuickAccessProvider(provider) {
		if (provider.prefix.length === 0) this.defaultProvider = provider;
		else this.providers.push(provider);
		this.providers.sort((providerA, providerB) => providerB.prefix.length - providerA.prefix.length);
		return toDisposable(() => {
			this.providers.splice(this.providers.indexOf(provider), 1);
			if (this.defaultProvider === provider) this.defaultProvider = void 0;
		});
	}
	getQuickAccessProviders(contextKeyService) {
		return coalesce([this.defaultProvider, ...this.providers]).filter((provider) => !provider.when || contextKeyService.contextMatchesRules(provider.when));
	}
	getQuickAccessProvider(prefix, contextKeyService) {
		return (prefix ? this.providers.find((provider) => prefix.startsWith(provider.prefix) && (!provider.when || contextKeyService.contextMatchesRules(provider.when))) : void 0) || this.defaultProvider;
	}
};
Registry.add(Extensions$1.Quickaccess, new QuickAccessRegistry());
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/quickinput/browser/quickAccess.js
var __decorate$25 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$24 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var QuickAccessController = class QuickAccessController extends Disposable {
	constructor(quickInputService, instantiationService, contextKeyService) {
		super();
		this.quickInputService = quickInputService;
		this.instantiationService = instantiationService;
		this.contextKeyService = contextKeyService;
		this.registry = Registry.as(Extensions$1.Quickaccess);
		this.mapProviderToDescriptor = /* @__PURE__ */ new Map();
		this.lastAcceptedPickerValues = /* @__PURE__ */ new Map();
		this.visibleQuickAccess = void 0;
		this._register(toDisposable(() => {
			for (const provider of this.mapProviderToDescriptor.values()) if (isDisposable(provider)) provider.dispose();
			this.visibleQuickAccess?.picker.dispose();
		}));
	}
	show(value = "", options) {
		this.doShowOrPick(value, false, options);
	}
	doShowOrPick(value, pick, options) {
		const [provider, descriptor] = this.getOrInstantiateProvider(value, options?.enabledProviderPrefixes);
		const visibleQuickAccess = this.visibleQuickAccess;
		const visibleDescriptor = visibleQuickAccess?.descriptor;
		if (visibleQuickAccess && descriptor && visibleDescriptor === descriptor) {
			if (value !== descriptor.prefix && !options?.preserveValue) visibleQuickAccess.picker.value = value;
			this.adjustValueSelection(visibleQuickAccess.picker, descriptor, options);
			return;
		}
		if (descriptor && !options?.preserveValue) {
			let newValue = void 0;
			if (visibleQuickAccess && visibleDescriptor && visibleDescriptor !== descriptor) {
				const newValueCandidateWithoutPrefix = visibleQuickAccess.value.substr(visibleDescriptor.prefix.length);
				if (newValueCandidateWithoutPrefix) newValue = `${descriptor.prefix}${newValueCandidateWithoutPrefix}`;
			}
			if (!newValue) {
				const defaultFilterValue = provider?.defaultFilterValue;
				if (defaultFilterValue === DefaultQuickAccessFilterValue.LAST) newValue = this.lastAcceptedPickerValues.get(descriptor);
				else if (typeof defaultFilterValue === "string") newValue = `${descriptor.prefix}${defaultFilterValue}`;
			}
			if (typeof newValue === "string") value = newValue;
		}
		const visibleSelection = visibleQuickAccess?.picker?.valueSelection;
		const visibleValue = visibleQuickAccess?.picker?.value;
		const disposables = new DisposableStore();
		const picker = disposables.add(this.quickInputService.createQuickPick({ useSeparators: true }));
		picker.value = value;
		this.adjustValueSelection(picker, descriptor, options);
		picker.placeholder = options?.placeholder ?? descriptor?.placeholder;
		picker.quickNavigate = options?.quickNavigateConfiguration;
		picker.hideInput = !!picker.quickNavigate && !visibleQuickAccess;
		if (typeof options?.itemActivation === "number" || options?.quickNavigateConfiguration) picker.itemActivation = options?.itemActivation ?? ItemActivation.SECOND;
		picker.contextKey = descriptor?.contextKey;
		picker.filterValue = (value) => value.substring(descriptor ? descriptor.prefix.length : 0);
		let pickPromise = void 0;
		if (pick) {
			pickPromise = new DeferredPromise();
			disposables.add(Event.once(picker.onWillAccept)((e) => {
				e.veto();
				picker.hide();
			}));
		}
		disposables.add(this.registerPickerListeners(picker, provider, descriptor, value, options));
		const cts = disposables.add(new CancellationTokenSource$1());
		if (provider) disposables.add(provider.provide(picker, cts.token, options?.providerOptions));
		Event.once(picker.onDidHide)(() => {
			if (picker.selectedItems.length === 0) cts.cancel();
			disposables.dispose();
			pickPromise?.complete(picker.selectedItems.slice(0));
		});
		picker.show();
		if (visibleSelection && visibleValue === value) picker.valueSelection = visibleSelection;
		if (pick) return pickPromise?.p;
	}
	adjustValueSelection(picker, descriptor, options) {
		let valueSelection;
		if (options?.preserveValue) valueSelection = [picker.value.length, picker.value.length];
		else valueSelection = [descriptor?.prefix.length ?? 0, picker.value.length];
		picker.valueSelection = valueSelection;
	}
	registerPickerListeners(picker, provider, descriptor, value, options) {
		const disposables = new DisposableStore();
		const visibleQuickAccess = this.visibleQuickAccess = {
			picker,
			descriptor,
			value
		};
		disposables.add(toDisposable(() => {
			if (visibleQuickAccess === this.visibleQuickAccess) this.visibleQuickAccess = void 0;
		}));
		disposables.add(picker.onDidChangeValue((value) => {
			const [providerForValue] = this.getOrInstantiateProvider(value, options?.enabledProviderPrefixes);
			if (providerForValue !== provider) this.show(value, {
				enabledProviderPrefixes: options?.enabledProviderPrefixes,
				preserveValue: true,
				providerOptions: options?.providerOptions
			});
			else visibleQuickAccess.value = value;
		}));
		if (descriptor) disposables.add(picker.onDidAccept(() => {
			this.lastAcceptedPickerValues.set(descriptor, picker.value);
		}));
		return disposables;
	}
	getOrInstantiateProvider(value, enabledProviderPrefixes) {
		const providerDescriptor = this.registry.getQuickAccessProvider(value, this.contextKeyService);
		if (!providerDescriptor || enabledProviderPrefixes && !enabledProviderPrefixes?.includes(providerDescriptor.prefix)) return [void 0, void 0];
		let provider = this.mapProviderToDescriptor.get(providerDescriptor);
		if (!provider) {
			provider = this.instantiationService.createInstance(providerDescriptor.ctor);
			this.mapProviderToDescriptor.set(providerDescriptor, provider);
		}
		return [provider, providerDescriptor];
	}
};
QuickAccessController = __decorate$25([
	__param$24(0, IQuickInputService),
	__param$24(1, IInstantiationService),
	__param$24(2, IContextKeyService)
], QuickAccessController);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/linkedText.js
var __decorate$24 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var LinkedText = class {
	constructor(nodes) {
		this.nodes = nodes;
	}
	toString() {
		return this.nodes.map((node) => typeof node === "string" ? node : node.label).join("");
	}
};
__decorate$24([memoize], LinkedText.prototype, "toString", null);
var LINK_REGEX = /\[([^\]]+)\]\(((?:https?:\/\/|command:|file:)[^\)\s]+)(?: (["'])(.+?)(\3))?\)/gi;
function parseLinkedText(text) {
	const result = [];
	let index = 0;
	let match;
	while (match = LINK_REGEX.exec(text)) {
		if (match.index - index > 0) result.push(text.substring(index, match.index));
		const [, label, href, , title] = match;
		if (title) result.push({
			label,
			href,
			title
		});
		else result.push({
			label,
			href
		});
		index = match.index + match[0].length;
	}
	if (index < text.length) result.push(text.substring(index));
	return new LinkedText(result);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/quickinput/browser/quickInputUtils.js
var iconPathToClass = {};
var iconClassGenerator = new IdGenerator("quick-input-button-icon-");
function getIconClass(iconPath) {
	if (!iconPath) return;
	let iconClass;
	const key = iconPath.dark.toString();
	if (iconPathToClass[key]) iconClass = iconPathToClass[key];
	else {
		iconClass = iconClassGenerator.nextId();
		createCSSRule(`.${iconClass}, .hc-light .${iconClass}`, `background-image: ${asCSSUrl(iconPath.light || iconPath.dark)}`);
		createCSSRule(`.vs-dark .${iconClass}, .hc-black .${iconClass}`, `background-image: ${asCSSUrl(iconPath.dark)}`);
		iconPathToClass[key] = iconClass;
	}
	return iconClass;
}
var QuickInputToggleButtonAction = class {
	constructor(id, label, tooltip, className, enabled, _checked, _run) {
		this.id = id;
		this.label = label;
		this.tooltip = tooltip;
		this.enabled = enabled;
		this._checked = _checked;
		this._run = _run;
		this.class = className;
	}
	get checked() {
		return this._checked;
	}
	set checked(value) {
		this._checked = value;
		this._run();
	}
	run() {
		this._checked = !this._checked;
		return this._run();
	}
};
function quickInputButtonToAction(button, id, run) {
	let cssClasses = button.iconClass || getIconClass(button.iconPath);
	if (button.alwaysVisible) cssClasses = cssClasses ? `${cssClasses} always-visible` : "always-visible";
	const handler = () => {
		if (button.toggle) button.toggle.checked = !button.toggle.checked;
		return run();
	};
	return button.toggle ? new QuickInputToggleButtonAction(id, button.tooltip || "", "", cssClasses, true, button.toggle.checked, handler) : {
		id,
		label: "",
		tooltip: button.tooltip || "",
		class: cssClasses,
		enabled: true,
		run: handler
	};
}
function quickInputButtonsToActionArrays(buttons, idPrefix, onTrigger) {
	const primary = [];
	const secondary = [];
	buttons.forEach((button, index) => {
		const action = quickInputButtonToAction(button, `${idPrefix}-${index}`, async () => onTrigger(button));
		if (button.label) action.label = button.label;
		if (button.secondary) secondary.push(action);
		else primary.push(action);
	});
	return {
		primary,
		secondary
	};
}
function renderQuickInputDescription(description, container, actionHandler) {
	reset(container);
	const parsed = parseLinkedText(description);
	let tabIndex = 0;
	for (const node of parsed.nodes) if (typeof node === "string") container.append(...renderLabelWithIcons(node));
	else {
		let title = node.title;
		if (!title && node.href.startsWith("command:")) title = localize(1868, "Click to execute command '{0}'", node.href.substring(8));
		else if (!title) title = node.href;
		const anchor = $$10("a", {
			href: node.href,
			title,
			tabIndex: tabIndex++
		}, node.label);
		anchor.style.textDecoration = "underline";
		const handleOpen = (e) => {
			if (isEventLike(e)) EventHelper.stop(e, true);
			actionHandler.callback(node.href);
		};
		const onClick = actionHandler.disposables.add(new DomEmitter(anchor, EventType$1.CLICK)).event;
		const onKeydown = actionHandler.disposables.add(new DomEmitter(anchor, EventType$1.KEY_DOWN)).event;
		const onSpaceOrEnter = Event.chain(onKeydown, ($) => $.filter((e) => {
			const event = new StandardKeyboardEvent(e);
			return event.equals(10) || event.equals(3);
		}));
		actionHandler.disposables.add(Gesture.addTarget(anchor));
		const onTap = actionHandler.disposables.add(new DomEmitter(anchor, EventType.Tap)).event;
		Event.any(onClick, onTap, onSpaceOrEnter)(handleOpen, null, actionHandler.disposables);
		container.appendChild(anchor);
	}
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/quickinput/browser/quickInput.js
var __decorate$23 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$23 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var inQuickInputContextKeyValue = "inQuickInput";
var InQuickInputContextKey = new RawContextKey(inQuickInputContextKeyValue, false, localize(1845, "Whether keyboard focus is inside the quick input control"));
var inQuickInputContext = ContextKeyExpr.has(inQuickInputContextKeyValue);
var QuickInputAlignmentContextKey = new RawContextKey("quickInputAlignment", "top", localize(1846, "The alignment of the quick input"));
var quickInputTypeContextKeyValue = "quickInputType";
var QuickInputTypeContextKey = new RawContextKey(quickInputTypeContextKeyValue, void 0, localize(1847, "The type of the currently visible quick input"));
var endOfQuickInputBoxContextKeyValue = "cursorAtEndOfQuickInputBox";
var EndOfQuickInputBoxContextKey = new RawContextKey(endOfQuickInputBoxContextKeyValue, false, localize(1848, "Whether the cursor in the quick input is at the end of the input box"));
var endOfQuickInputBoxContext = ContextKeyExpr.has(endOfQuickInputBoxContextKeyValue);
var backButton = {
	iconClass: ThemeIcon.asClassName(Codicon.quickInputBack),
	tooltip: localize(1849, "Back")
};
var QuickInput = class QuickInput extends Disposable {
	static {
		this.noPromptMessage = localize(1850, "Press 'Enter' to confirm your input or 'Escape' to cancel");
	}
	constructor(ui) {
		super();
		this.ui = ui;
		this._visible = observableValue("visible", false);
		this._enabled = true;
		this._busy = false;
		this._ignoreFocusOut = false;
		this._leftButtons = [];
		this._rightButtons = [];
		this._inlineButtons = [];
		this._inputButtons = [];
		this.buttonsUpdated = false;
		this.noValidationMessage = QuickInput.noPromptMessage;
		this._severity = Severity$1$1.Ignore;
		this.onDidTriggerButtonEmitter = this._register(new Emitter$1());
		this.onDidHideEmitter = this._register(new Emitter$1());
		this.onWillHideEmitter = this._register(new Emitter$1());
		this.onDisposeEmitter = this._register(new Emitter$1());
		this.visibleDisposables = this._register(new DisposableStore());
		this.onDidTriggerButton = this.onDidTriggerButtonEmitter.event;
		this.onDidHide = this.onDidHideEmitter.event;
	}
	get visible() {
		return this._visible.get();
	}
	get title() {
		return this._title;
	}
	set title(title) {
		this._title = title;
		this.update();
	}
	get description() {
		return this._description;
	}
	set description(description) {
		this._description = description;
		this.update();
	}
	get step() {
		return this._steps;
	}
	set step(step) {
		this._steps = step;
		this.update();
	}
	get totalSteps() {
		return this._totalSteps;
	}
	set totalSteps(totalSteps) {
		this._totalSteps = totalSteps;
		this.update();
	}
	get enabled() {
		return this._enabled;
	}
	set enabled(enabled) {
		this._enabled = enabled;
		this.update();
	}
	get contextKey() {
		return this._contextKey;
	}
	set contextKey(contextKey) {
		this._contextKey = contextKey;
		this.update();
	}
	get busy() {
		return this._busy;
	}
	set busy(busy) {
		this._busy = busy;
		this.update();
	}
	get ignoreFocusOut() {
		return this._ignoreFocusOut;
	}
	set ignoreFocusOut(ignoreFocusOut) {
		const shouldUpdate = this._ignoreFocusOut !== ignoreFocusOut && !isIOS;
		this._ignoreFocusOut = ignoreFocusOut && !isIOS;
		if (shouldUpdate) this.update();
	}
	get titleButtons() {
		return this._leftButtons.length ? [...this._leftButtons, this._rightButtons] : this._rightButtons;
	}
	get buttons() {
		return [
			...this._leftButtons,
			...this._rightButtons,
			...this._inlineButtons,
			...this._inputButtons
		];
	}
	set buttons(buttons) {
		const leftButtons = [];
		const rightButtons = [];
		const inlineButtons = [];
		const inputButtons = [];
		for (const button of buttons) if (button === backButton) leftButtons.push(button);
		else switch (button.location) {
			case QuickInputButtonLocation.Inline:
				inlineButtons.push(button);
				break;
			case QuickInputButtonLocation.Input:
				inputButtons.push(button);
				break;
			default: rightButtons.push(button);
		}
		this._leftButtons = leftButtons;
		this._rightButtons = rightButtons;
		this._inlineButtons = inlineButtons;
		this._inputButtons = inputButtons;
		this.buttonsUpdated = true;
		this.update();
	}
	get validationMessage() {
		return this._validationMessage;
	}
	set validationMessage(validationMessage) {
		this._validationMessage = validationMessage;
		this.update();
	}
	get severity() {
		return this._severity;
	}
	set severity(severity) {
		this._severity = severity;
		this.update();
	}
	show() {
		if (this.visible) return;
		this.visibleDisposables.add(this.ui.onDidTriggerButton((button) => {
			if (this.buttons.indexOf(button) !== -1) this.onDidTriggerButtonEmitter.fire(button);
		}));
		this.ui.show(this);
		this._visible.set(true, void 0);
		this._lastValidationMessage = void 0;
		this._lastSeverity = void 0;
		if (this.buttons.length) this.buttonsUpdated = true;
		this.update();
	}
	hide() {
		if (!this.visible) return;
		this.ui.hide();
	}
	didHide(reason = QuickInputHideReason.Other) {
		this._visible.set(false, void 0);
		this.visibleDisposables.clear();
		this.onDidHideEmitter.fire({ reason });
	}
	willHide(reason = QuickInputHideReason.Other) {
		this.onWillHideEmitter.fire({ reason });
	}
	update() {
		if (!this.visible) return;
		const title = this.getTitle();
		if (title && this.ui.title.textContent !== title) this.ui.title.textContent = title;
		else if (!title && this.ui.title.innerHTML !== "&nbsp;") this.ui.title.innerText = "\xA0";
		const description = this.getDescription();
		if (this.ui.description1.textContent !== description) this.ui.description1.textContent = description;
		if (this.ui.description2.textContent !== description) this.ui.description2.textContent = description;
		if (this.busy && !this.busyDelay) {
			this.busyDelay = new TimeoutTimer();
			this.busyDelay.setIfNotSet(() => {
				if (this.visible) {
					this.ui.progressBar.infinite();
					this.ui.progressBar.getContainer().removeAttribute("aria-hidden");
				}
			}, 800);
		}
		if (!this.busy && this.busyDelay) {
			this.ui.progressBar.stop();
			this.ui.progressBar.getContainer().setAttribute("aria-hidden", "true");
			this.busyDelay.cancel();
			this.busyDelay = void 0;
		}
		if (this.buttonsUpdated) {
			this.buttonsUpdated = false;
			const leftActions = quickInputButtonsToActionArrays(this._leftButtons, "left-button", (button) => this.onDidTriggerButtonEmitter.fire(button));
			this.ui.leftActionBar.setActions(leftActions.primary, leftActions.secondary);
			const rightActions = quickInputButtonsToActionArrays(this._rightButtons, "right-button", (button) => this.onDidTriggerButtonEmitter.fire(button));
			this.ui.rightActionBar.setActions(rightActions.primary, rightActions.secondary);
			const inlineActions = quickInputButtonsToActionArrays(this._inlineButtons, "inline-button", (button) => this.onDidTriggerButtonEmitter.fire(button));
			this.ui.inlineActionBar.setActions(inlineActions.primary, inlineActions.secondary);
			const inputButtonOffset = this._inputButtons.length * 22;
			this.ui.countContainer.style.right = inputButtonOffset > 0 ? `${4 + inputButtonOffset}px` : "4px";
			this.ui.inputBox.actions = this._inputButtons.map((button, index) => quickInputButtonToAction(button, `id-${index}`, async () => this.onDidTriggerButtonEmitter.fire(button)));
		}
		this.ui.ignoreFocusOut = this.ignoreFocusOut;
		this.ui.setEnabled(this.enabled);
		this.ui.setContextKey(this.contextKey);
		const validationMessage = this.validationMessage || this.noValidationMessage;
		if (this._lastValidationMessage !== validationMessage) {
			this._lastValidationMessage = validationMessage;
			reset(this.ui.message);
			if (validationMessage) renderQuickInputDescription(validationMessage, this.ui.message, {
				callback: (content) => {
					this.ui.linkOpenerDelegate(content);
				},
				disposables: this.visibleDisposables
			});
		}
		if (this._lastSeverity !== this.severity) {
			this._lastSeverity = this.severity;
			this.showMessageDecoration(this.severity);
		}
	}
	getTitle() {
		if (this.title && this.step) return `${this.title} (${this.getSteps()})`;
		if (this.title) return this.title;
		if (this.step) return this.getSteps();
		return "";
	}
	getDescription() {
		return this.description || "";
	}
	getSteps() {
		if (this.step && this.totalSteps) return localize(1851, "{0}/{1}", this.step, this.totalSteps);
		if (this.step) return String(this.step);
		return "";
	}
	showMessageDecoration(severity) {
		this.ui.inputBox.showDecoration(severity);
		if (severity !== Severity$1$1.Ignore) {
			const styles = this.ui.inputBox.stylesForType(severity);
			this.ui.message.style.color = styles.foreground ? `${styles.foreground}` : "";
			this.ui.message.style.backgroundColor = styles.background ? `${styles.background}` : "";
			this.ui.message.style.border = styles.border ? `1px solid ${styles.border}` : "";
			this.ui.message.style.marginBottom = "-2px";
		} else {
			this.ui.message.style.color = "";
			this.ui.message.style.backgroundColor = "";
			this.ui.message.style.border = "";
			this.ui.message.style.marginBottom = "";
		}
	}
	dispose() {
		this.hide();
		this.onDisposeEmitter.fire();
		super.dispose();
	}
};
var QuickPick = class QuickPick extends QuickInput {
	static {
		this.DEFAULT_ARIA_LABEL = localize(1852, "Type to narrow down results.");
	}
	constructor(ui) {
		super(ui);
		this._value = "";
		this.onDidChangeValueEmitter = this._register(new Emitter$1());
		this.onWillAcceptEmitter = this._register(new Emitter$1());
		this.onDidAcceptEmitter = this._register(new Emitter$1());
		this.onDidCustomEmitter = this._register(new Emitter$1());
		this._items = [];
		this.itemsUpdated = false;
		this._canSelectMany = false;
		this._canAcceptInBackground = false;
		this._matchOnDescription = false;
		this._matchOnDetail = false;
		this._matchOnLabel = true;
		this._matchOnLabelMode = "fuzzy";
		this._sortByLabel = true;
		this._keepScrollPosition = false;
		this._itemActivation = ItemActivation.FIRST;
		this._activeItems = [];
		this.activeItemsUpdated = false;
		this.activeItemsToConfirm = [];
		this.onDidChangeActiveEmitter = this._register(new Emitter$1());
		this._selectedItems = [];
		this.selectedItemsUpdated = false;
		this.selectedItemsToConfirm = [];
		this.onDidChangeSelectionEmitter = this._register(new Emitter$1());
		this.onDidTriggerItemButtonEmitter = this._register(new Emitter$1());
		this.onDidTriggerSeparatorButtonEmitter = this._register(new Emitter$1());
		this.valueSelectionUpdated = true;
		this._ok = "default";
		this._customButton = false;
		this._customButtonSecondary = false;
		this._focusEventBufferer = new EventBufferer();
		this.type = "quickPick";
		this.filterValue = (value) => value;
		this.onDidChangeValue = this.onDidChangeValueEmitter.event;
		this.onWillAccept = this.onWillAcceptEmitter.event;
		this.onDidAccept = this.onDidAcceptEmitter.event;
		this.onDidChangeActive = this.onDidChangeActiveEmitter.event;
		this.onDidChangeSelection = this.onDidChangeSelectionEmitter.event;
		this.onDidTriggerItemButton = this.onDidTriggerItemButtonEmitter.event;
		this.onDidTriggerSeparatorButton = this.onDidTriggerSeparatorButtonEmitter.event;
		this.noValidationMessage = void 0;
	}
	get quickNavigate() {
		return this._quickNavigate;
	}
	set quickNavigate(quickNavigate) {
		this._quickNavigate = quickNavigate;
		this.update();
	}
	get value() {
		return this._value;
	}
	set value(value) {
		this.doSetValue(value);
	}
	doSetValue(value, skipUpdate) {
		if (this._value !== value) {
			this._value = value;
			if (!skipUpdate) this.update();
			if (this.visible) {
				if (this.ui.list.filter(this.filterValue(this._value))) this.trySelectFirst();
			}
			this.onDidChangeValueEmitter.fire(this._value);
		}
	}
	set ariaLabel(ariaLabel) {
		this._ariaLabel = ariaLabel;
		this.update();
	}
	get ariaLabel() {
		return this._ariaLabel;
	}
	get placeholder() {
		return this._placeholder;
	}
	set placeholder(placeholder) {
		this._placeholder = placeholder;
		this.update();
	}
	get prompt() {
		return this.noValidationMessage;
	}
	set prompt(prompt) {
		this.noValidationMessage = prompt;
		this.update();
	}
	get items() {
		return this._items;
	}
	get scrollTop() {
		return this.ui.list.scrollTop;
	}
	set scrollTop(scrollTop) {
		this.ui.list.scrollTop = scrollTop;
	}
	set items(items) {
		this._items = items;
		this.itemsUpdated = true;
		this.update();
	}
	get canSelectMany() {
		return this._canSelectMany;
	}
	set canSelectMany(canSelectMany) {
		this._canSelectMany = canSelectMany;
		this.update();
	}
	get canAcceptInBackground() {
		return this._canAcceptInBackground;
	}
	set canAcceptInBackground(canAcceptInBackground) {
		this._canAcceptInBackground = canAcceptInBackground;
	}
	get matchOnDescription() {
		return this._matchOnDescription;
	}
	set matchOnDescription(matchOnDescription) {
		this._matchOnDescription = matchOnDescription;
		this.update();
	}
	get matchOnDetail() {
		return this._matchOnDetail;
	}
	set matchOnDetail(matchOnDetail) {
		this._matchOnDetail = matchOnDetail;
		this.update();
	}
	get matchOnLabel() {
		return this._matchOnLabel;
	}
	set matchOnLabel(matchOnLabel) {
		this._matchOnLabel = matchOnLabel;
		this.update();
	}
	get matchOnLabelMode() {
		return this._matchOnLabelMode;
	}
	set matchOnLabelMode(matchOnLabelMode) {
		this._matchOnLabelMode = matchOnLabelMode;
		this.update();
	}
	get sortByLabel() {
		return this._sortByLabel;
	}
	set sortByLabel(sortByLabel) {
		this._sortByLabel = sortByLabel;
		this.update();
	}
	get keepScrollPosition() {
		return this._keepScrollPosition;
	}
	set keepScrollPosition(keepScrollPosition) {
		this._keepScrollPosition = keepScrollPosition;
	}
	get itemActivation() {
		return this._itemActivation;
	}
	set itemActivation(itemActivation) {
		this._itemActivation = itemActivation;
	}
	get activeItems() {
		return this._activeItems;
	}
	set activeItems(activeItems) {
		this._activeItems = activeItems;
		this.activeItemsUpdated = true;
		this.update();
	}
	get selectedItems() {
		return this._selectedItems;
	}
	set selectedItems(selectedItems) {
		this._selectedItems = selectedItems;
		this.selectedItemsUpdated = true;
		this.update();
	}
	get keyMods() {
		if (this._quickNavigate) return NO_KEY_MODS;
		return this.ui.keyMods;
	}
	get valueSelection() {
		const selection = this.ui.inputBox.getSelection();
		if (!selection) return;
		return [selection.start, selection.end];
	}
	set valueSelection(valueSelection) {
		this._valueSelection = valueSelection;
		this.valueSelectionUpdated = true;
		this.update();
	}
	get customButton() {
		return this._customButton;
	}
	set customButton(showCustomButton) {
		this._customButton = showCustomButton;
		this.update();
	}
	get customLabel() {
		return this._customButtonLabel;
	}
	set customLabel(label) {
		this._customButtonLabel = label;
		this.update();
	}
	get customHover() {
		return this._customButtonHover;
	}
	set customHover(hover) {
		this._customButtonHover = hover;
		this.update();
	}
	get customButtonSecondary() {
		return this._customButtonSecondary;
	}
	set customButtonSecondary(secondary) {
		this._customButtonSecondary = secondary ?? false;
		this.update();
	}
	get ok() {
		return this._ok;
	}
	set ok(showOkButton) {
		this._ok = showOkButton;
		this.update();
	}
	get okLabel() {
		return this._okLabel ?? localize(1853, "OK");
	}
	set okLabel(okLabel) {
		this._okLabel = okLabel;
		this.update();
	}
	get hideInput() {
		return !!this._hideInput;
	}
	set hideInput(hideInput) {
		this._hideInput = hideInput;
		this.update();
	}
	trySelectFirst() {
		if (!this.canSelectMany) this.ui.list.focus(QuickPickFocus.First);
	}
	show() {
		if (!this.visible) {
			this.visibleDisposables.add(this.ui.inputBox.onDidChange((value) => {
				this.doSetValue(value, true);
			}));
			this.visibleDisposables.add(this.ui.onDidAccept(() => {
				if (this.canSelectMany) {
					if (!this.ui.list.getCheckedElements().length) {
						this._selectedItems = [];
						this.onDidChangeSelectionEmitter.fire(this.selectedItems);
					}
				} else if (this.activeItems[0]) {
					this._selectedItems = [this.activeItems[0]];
					this.onDidChangeSelectionEmitter.fire(this.selectedItems);
				}
				this.handleAccept(false);
			}));
			this.visibleDisposables.add(this.ui.onDidCustom(() => {
				this.onDidCustomEmitter.fire();
			}));
			this.visibleDisposables.add(this._focusEventBufferer.wrapEvent(this.ui.list.onDidChangeFocus, (_, e) => e)((focusedItems) => {
				if (this.activeItemsUpdated) return;
				if (this.activeItemsToConfirm !== this._activeItems && equals$1(focusedItems, this._activeItems, (a, b) => a === b)) return;
				this._activeItems = focusedItems;
				this.onDidChangeActiveEmitter.fire(focusedItems);
			}));
			this.visibleDisposables.add(this.ui.list.onDidChangeSelection(({ items: selectedItems, event }) => {
				if (this.canSelectMany && !selectedItems.some((i) => i.pickable === false)) {
					if (selectedItems.length) this.ui.list.setSelectedElements([]);
					return;
				}
				if (this.selectedItemsToConfirm !== this._selectedItems && equals$1(selectedItems, this._selectedItems, (a, b) => a === b)) return;
				this._selectedItems = selectedItems;
				this.onDidChangeSelectionEmitter.fire(selectedItems);
				if (selectedItems.length) this.handleAccept(isMouseEvent(event) && event.button === 1);
			}));
			this.visibleDisposables.add(this.ui.list.onChangedCheckedElements((checkedItems) => {
				if (!this.canSelectMany || !this.visible) return;
				if (this.selectedItemsToConfirm !== this._selectedItems && equals$1(checkedItems, this._selectedItems, (a, b) => a === b)) return;
				this._selectedItems = checkedItems;
				this.onDidChangeSelectionEmitter.fire(checkedItems);
			}));
			this.visibleDisposables.add(this.ui.list.onButtonTriggered((event) => this.onDidTriggerItemButtonEmitter.fire(event)));
			this.visibleDisposables.add(this.ui.list.onSeparatorButtonTriggered((event) => this.onDidTriggerSeparatorButtonEmitter.fire(event)));
			this.visibleDisposables.add(this.registerQuickNavigation());
			this.valueSelectionUpdated = true;
		}
		super.show();
	}
	handleAccept(inBackground) {
		let veto = false;
		this.onWillAcceptEmitter.fire({ veto: () => veto = true });
		if (!veto) this.onDidAcceptEmitter.fire({ inBackground });
	}
	registerQuickNavigation() {
		return addDisposableListener(this.ui.container, EventType$1.KEY_UP, (e) => {
			if (this.canSelectMany || !this._quickNavigate) return;
			const keyboardEvent = new StandardKeyboardEvent(e);
			const keyCode = keyboardEvent.keyCode;
			if (this._quickNavigate.keybindings.some((k) => {
				const chords = k.getChords();
				if (chords.length > 1) return false;
				if (chords[0].shiftKey && keyCode === 4) {
					if (keyboardEvent.ctrlKey || keyboardEvent.altKey || keyboardEvent.metaKey) return false;
					return true;
				}
				if (chords[0].altKey && keyCode === 6) return true;
				if (chords[0].ctrlKey && keyCode === 5) return true;
				if (chords[0].metaKey && keyCode === 57) return true;
				return false;
			})) {
				if (this.activeItems[0]) {
					this._selectedItems = [this.activeItems[0]];
					this.onDidChangeSelectionEmitter.fire(this.selectedItems);
					this.handleAccept(false);
				}
				this._quickNavigate = void 0;
			}
		});
	}
	update() {
		if (!this.visible) return;
		const scrollTopBefore = this.keepScrollPosition ? this.scrollTop : 0;
		const hasDescription = !!this.description;
		const visibilities = {
			title: !!this.title || !!this.step || !!this.titleButtons.length,
			description: hasDescription,
			checkAll: this.canSelectMany && !this._hideCheckAll,
			checkBox: this.canSelectMany,
			inputBox: !this._hideInput,
			progressBar: !this._hideInput || hasDescription,
			visibleCount: true,
			count: this.canSelectMany && !this._hideCountBadge,
			ok: this.ok === "default" ? this.canSelectMany : this.ok,
			list: true,
			message: !!this.validationMessage || !!this.prompt,
			customButton: this.customButton
		};
		this.ui.setVisibilities(visibilities);
		super.update();
		if (this.ui.inputBox.value !== this.value) this.ui.inputBox.value = this.value;
		if (this.valueSelectionUpdated) {
			this.valueSelectionUpdated = false;
			this.ui.inputBox.select(this._valueSelection && {
				start: this._valueSelection[0],
				end: this._valueSelection[1]
			});
		}
		if (this.ui.inputBox.placeholder !== (this.placeholder || "")) this.ui.inputBox.placeholder = this.placeholder || "";
		let ariaLabel = this.ariaLabel;
		if (!ariaLabel && visibilities.inputBox) {
			ariaLabel = this.placeholder;
			if (this.title) ariaLabel = ariaLabel ? `${ariaLabel} - ${this.title}` : this.title;
			if (!ariaLabel) ariaLabel = QuickPick.DEFAULT_ARIA_LABEL;
		}
		if (this.ui.list.ariaLabel !== ariaLabel) this.ui.list.ariaLabel = ariaLabel ?? null;
		if (this.ui.inputBox.ariaLabel !== ariaLabel) this.ui.inputBox.ariaLabel = ariaLabel ?? "input";
		this.ui.list.matchOnDescription = this.matchOnDescription;
		this.ui.list.matchOnDetail = this.matchOnDetail;
		this.ui.list.matchOnLabel = this.matchOnLabel;
		this.ui.list.matchOnLabelMode = this.matchOnLabelMode;
		this.ui.list.sortByLabel = this.sortByLabel;
		if (this.itemsUpdated) {
			this.itemsUpdated = false;
			this._focusEventBufferer.bufferEvents(() => {
				this.ui.list.setElements(this.items);
				this.ui.list.shouldLoop = !this.canSelectMany;
				this.ui.list.filter(this.filterValue(this.ui.inputBox.value));
				switch (this._itemActivation) {
					case ItemActivation.NONE:
						this._itemActivation = ItemActivation.FIRST;
						break;
					case ItemActivation.SECOND:
						this.ui.list.focus(QuickPickFocus.Second);
						this._itemActivation = ItemActivation.FIRST;
						break;
					case ItemActivation.LAST:
						this.ui.list.focus(QuickPickFocus.Last);
						this._itemActivation = ItemActivation.FIRST;
						break;
					default: this.trySelectFirst();
				}
			});
		}
		if (this.ui.container.classList.contains("show-checkboxes") !== !!this.canSelectMany) {
			if (this.canSelectMany) this.ui.list.clearFocus();
			else this.trySelectFirst();
		}
		if (this.activeItemsUpdated) {
			this.activeItemsUpdated = false;
			this.activeItemsToConfirm = this._activeItems;
			this.ui.list.setFocusedElements(this.activeItems);
			if (this.activeItemsToConfirm === this._activeItems) this.activeItemsToConfirm = null;
		}
		if (this.selectedItemsUpdated) {
			this.selectedItemsUpdated = false;
			this.selectedItemsToConfirm = this._selectedItems;
			if (this.canSelectMany) this.ui.list.setCheckedElements(this.selectedItems);
			else this.ui.list.setSelectedElements(this.selectedItems);
			if (this.selectedItemsToConfirm === this._selectedItems) this.selectedItemsToConfirm = null;
		}
		this.ui.ok.label = this.okLabel || "";
		this.ui.customButton.label = this.customLabel || "";
		this.ui.customButton.element.title = this.customHover || "";
		this.ui.customButton.secondary = this.customButtonSecondary || false;
		if (!visibilities.inputBox) {
			this.ui.list.domFocus();
			if (this.canSelectMany) this.ui.list.focus(QuickPickFocus.First);
		}
		if (this.keepScrollPosition) this.scrollTop = scrollTopBefore;
	}
	focus(focus) {
		this.ui.list.focus(focus);
		if (this.canSelectMany) this.ui.list.domFocus();
	}
	accept(inBackground) {
		if (inBackground && !this._canAcceptInBackground) return;
		if (this.activeItems[0] && !this._canSelectMany) {
			this._selectedItems = [this.activeItems[0]];
			this.onDidChangeSelectionEmitter.fire(this.selectedItems);
		}
		this.handleAccept(inBackground ?? false);
	}
};
var InputBox = class extends QuickInput {
	constructor() {
		super(...arguments);
		this._value = "";
		this.valueSelectionUpdated = true;
		this._password = false;
		this.onDidValueChangeEmitter = this._register(new Emitter$1());
		this.onDidAcceptEmitter = this._register(new Emitter$1());
		this.type = "inputBox";
		this.onDidChangeValue = this.onDidValueChangeEmitter.event;
		this.onDidAccept = this.onDidAcceptEmitter.event;
	}
	get value() {
		return this._value;
	}
	set value(value) {
		this._value = value || "";
		this.update();
	}
	get valueSelection() {
		const selection = this.ui.inputBox.getSelection();
		if (!selection) return;
		return [selection.start, selection.end];
	}
	set valueSelection(valueSelection) {
		this._valueSelection = valueSelection;
		this.valueSelectionUpdated = true;
		this.update();
	}
	get placeholder() {
		return this._placeholder;
	}
	set placeholder(placeholder) {
		this._placeholder = placeholder;
		this.update();
	}
	get ariaLabel() {
		return this._ariaLabel;
	}
	set ariaLabel(ariaLabel) {
		this._ariaLabel = ariaLabel;
		this.update();
	}
	get password() {
		return this._password;
	}
	set password(password) {
		this._password = password;
		this.update();
	}
	get prompt() {
		return this._prompt;
	}
	set prompt(prompt) {
		this._prompt = prompt;
		this.noValidationMessage = prompt ? localize(1854, "{0} (Press 'Enter' to confirm or 'Escape' to cancel)", prompt) : QuickInput.noPromptMessage;
		this.update();
	}
	show() {
		if (!this.visible) {
			this.visibleDisposables.add(this.ui.inputBox.onDidChange((value) => {
				if (value === this.value) return;
				this._value = value;
				this.onDidValueChangeEmitter.fire(value);
			}));
			this.visibleDisposables.add(this.ui.onDidAccept(() => this.onDidAcceptEmitter.fire()));
			this.valueSelectionUpdated = true;
		}
		super.show();
	}
	accept() {
		this.onDidAcceptEmitter.fire();
	}
	update() {
		if (!this.visible) return;
		this.ui.container.classList.remove("hidden-input");
		const visibilities = {
			title: !!this.title || !!this.step || !!this.titleButtons.length,
			description: !!this.description || !!this.step,
			inputBox: true,
			message: true,
			progressBar: true
		};
		this.ui.setVisibilities(visibilities);
		super.update();
		if (this.ui.inputBox.value !== this.value) this.ui.inputBox.value = this.value;
		if (this.valueSelectionUpdated) {
			this.valueSelectionUpdated = false;
			this.ui.inputBox.select(this._valueSelection && {
				start: this._valueSelection[0],
				end: this._valueSelection[1]
			});
		}
		if (this.ui.inputBox.placeholder !== (this.placeholder || "")) this.ui.inputBox.placeholder = this.placeholder || "";
		if (this.ui.inputBox.password !== this.password) this.ui.inputBox.password = this.password;
		let ariaLabel = this.ariaLabel;
		if (!ariaLabel && visibilities.inputBox) ariaLabel = this.placeholder ? this.title ? `${this.placeholder} - ${this.title}` : this.placeholder : this.title ? this.title : "input";
		if (this.ui.inputBox.ariaLabel !== ariaLabel) this.ui.inputBox.ariaLabel = ariaLabel || "input";
	}
};
var QuickInputHoverDelegate = class QuickInputHoverDelegate extends WorkbenchHoverDelegate {
	constructor(configurationService, hoverService) {
		super("mouse", void 0, (options) => this.getOverrideOptions(options), configurationService, hoverService);
	}
	getOverrideOptions(options) {
		return {
			persistence: { hideOnKeyDown: false },
			appearance: {
				showHoverHint: (isHTMLElement(options.content) ? options.content.textContent ?? "" : typeof options.content === "string" ? options.content : options.content.value).includes("\n"),
				skipFadeInAnimation: true
			}
		};
	}
};
QuickInputHoverDelegate = __decorate$23([__param$23(0, IConfigurationService), __param$23(1, IHoverService)], QuickInputHoverDelegate);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/toolbar/toolbar.js
var ACTION_MIN_WIDTH = 20;
var ACTION_PADDING = 4;
var ACTION_MIN_WIDTH_VAR = "--vscode-toolbar-action-min-width";
/**
* A widget that combines an action bar for primary actions and a dropdown for secondary actions.
*/
var ToolBar = class extends Disposable {
	get onDidChangeDropdownVisibility() {
		return this._onDidChangeDropdownVisibility.event;
	}
	constructor(container, contextMenuProvider, options = { orientation: 0 }) {
		super();
		this.container = container;
		this.submenuActionViewItems = [];
		this.hasSecondaryActions = false;
		this._onDidChangeDropdownVisibility = this._register(new EventMultiplexer());
		this.originalPrimaryActions = [];
		this.originalSecondaryActions = [];
		this.hiddenActions = [];
		this.disposables = this._register(new DisposableStore());
		options.hoverDelegate = options.hoverDelegate ?? this._register(createInstantHoverDelegate());
		this.options = options;
		this.toggleMenuAction = this._register(new ToggleMenuAction(() => this.toggleMenuActionViewItem?.show(), options.toggleMenuTitle));
		this.element = document.createElement("div");
		this.element.className = "monaco-toolbar";
		container.appendChild(this.element);
		this.actionBar = this._register(new ActionBar(this.element, {
			orientation: options.orientation,
			ariaLabel: options.ariaLabel,
			actionRunner: options.actionRunner,
			allowContextMenu: options.allowContextMenu,
			highlightToggledItems: options.highlightToggledItems,
			hoverDelegate: options.hoverDelegate,
			actionViewItemProvider: (action, viewItemOptions) => {
				if (action.id === ToggleMenuAction.ID) {
					this.toggleMenuActionViewItem = new DropdownMenuActionViewItem(action, { getActions: () => this.toggleMenuAction.menuActions }, contextMenuProvider, {
						actionViewItemProvider: this.options.actionViewItemProvider,
						actionRunner: this.actionRunner,
						keybindingProvider: this.options.getKeyBinding,
						classNames: ThemeIcon.asClassNameArray(options.moreIcon ?? Codicon.toolBarMore),
						menuClassName: this.options.dropdownMenuClassName,
						closeAnimation: this.options.dropdownMenuCloseAnimation,
						anchorAlignmentProvider: this.options.anchorAlignmentProvider,
						menuAsChild: !!this.options.renderDropdownAsChildElement,
						skipTelemetry: this.options.skipTelemetry,
						isMenu: true,
						hoverDelegate: this.options.hoverDelegate
					});
					this.toggleMenuActionViewItem.setActionContext(this.actionBar.context);
					this.disposables.add(this._onDidChangeDropdownVisibility.add(this.toggleMenuActionViewItem.onDidChangeVisibility));
					return this.toggleMenuActionViewItem;
				}
				if (options.actionViewItemProvider) {
					const result = options.actionViewItemProvider(action, viewItemOptions);
					if (result) return result;
				}
				if (action instanceof SubmenuAction) {
					const result = new DropdownMenuActionViewItem(action, action.actions, contextMenuProvider, {
						actionViewItemProvider: this.options.actionViewItemProvider,
						actionRunner: this.actionRunner,
						keybindingProvider: this.options.getKeyBinding,
						classNames: action.class,
						menuClassName: this.options.dropdownMenuClassName,
						closeAnimation: this.options.dropdownMenuCloseAnimation,
						anchorAlignmentProvider: this.options.anchorAlignmentProvider,
						menuAsChild: !!this.options.renderDropdownAsChildElement,
						skipTelemetry: this.options.skipTelemetry,
						hoverDelegate: this.options.hoverDelegate
					});
					result.setActionContext(this.actionBar.context);
					this.submenuActionViewItems.push(result);
					this.disposables.add(this._onDidChangeDropdownVisibility.add(result.onDidChangeVisibility));
					return result;
				}
			}
		}));
		if (this.options.responsiveBehavior?.enabled) {
			this.element.classList.toggle("responsive", true);
			this.element.classList.toggle("responsive-all", this.options.responsiveBehavior.kind === "all");
			this.element.classList.toggle("responsive-last", this.options.responsiveBehavior.kind === "last");
			this.element.style.setProperty(ACTION_MIN_WIDTH_VAR, `${this.getConfiguredActionMinWidth()}px`);
			const observer = new ResizeObserver(() => {
				this.updateActions(this.getAvailableWidth());
			});
			observer.observe(this.options.responsiveBehavior?.observedElement ?? this.element);
			this._store.add(toDisposable(() => observer.disconnect()));
		}
	}
	set actionRunner(actionRunner) {
		this.actionBar.actionRunner = actionRunner;
	}
	get actionRunner() {
		return this.actionBar.actionRunner;
	}
	set context(context) {
		this.actionBar.context = context;
		this.toggleMenuActionViewItem?.setActionContext(context);
		for (const actionViewItem of this.submenuActionViewItems) actionViewItem.setActionContext(context);
	}
	getElement() {
		return this.element;
	}
	getItemAction(indexOrElement) {
		return this.actionBar.getAction(indexOrElement);
	}
	getItemElement(index) {
		const element = this.actionBar.getContainer().firstElementChild?.children.item(index);
		return isHTMLElement(element) ? element : void 0;
	}
	getItemViewItem(index) {
		return this.actionBar.viewItems[index];
	}
	getUnshrunkItemWidth(index) {
		const actionItem = this.actionBar.getContainer().firstElementChild?.children.item(index);
		if (!isHTMLElement(actionItem)) return this.actionBar.getWidth(index);
		const previousFlexShrink = actionItem.style.flexShrink;
		const previousMinWidth = actionItem.style.minWidth;
		try {
			actionItem.style.flexShrink = "0";
			if (!previousMinWidth) actionItem.style.minWidth = "0";
			return this.actionBar.getWidth(index);
		} finally {
			actionItem.style.flexShrink = previousFlexShrink;
			actionItem.style.minWidth = previousMinWidth;
		}
	}
	getItemsLength() {
		return this.actionBar.length();
	}
	setActions(primaryActions, secondaryActions) {
		this.clear();
		this.originalPrimaryActions = primaryActions ? primaryActions.slice(0) : [];
		this.originalSecondaryActions = secondaryActions ? secondaryActions.slice(0) : [];
		const primaryActionsToSet = primaryActions ? primaryActions.slice(0) : [];
		this.hasSecondaryActions = !!(secondaryActions && secondaryActions.length > 0);
		if (this.hasSecondaryActions && secondaryActions) {
			this.toggleMenuAction.menuActions = secondaryActions.slice(0);
			primaryActionsToSet.push(this.toggleMenuAction);
		}
		if (primaryActionsToSet.length > 0 && this.options.trailingSeparator) primaryActionsToSet.push(new Separator());
		primaryActionsToSet.forEach((action) => {
			this.actionBar.push(action, {
				icon: this.options.icon ?? true,
				label: this.options.label ?? false,
				keybinding: this.getKeybindingLabel(action)
			});
		});
		this.updateOverflowClassName();
		this.applyResponsiveActionMinWidths();
		if (this.options.responsiveBehavior?.enabled) {
			this.hiddenActions.length = 0;
			if (this.options.responsiveBehavior.minItems !== void 0) {
				const itemCount = this.options.responsiveBehavior.minItems;
				const primaryActionsMinWidth = (this.overflowFromStart ? this.originalPrimaryActions.slice(Math.max(0, this.originalPrimaryActions.length - itemCount)) : this.originalPrimaryActions.slice(0, itemCount)).reduce((total, action) => total + this.getActionMinWidth(action), 0);
				let overflowWidth = 0;
				if (this.originalSecondaryActions.length > 0 || itemCount < this.originalPrimaryActions.length) overflowWidth = 24;
				const separatorWidth = this.options.trailingSeparator && !this.actionBar.isEmpty() ? this.actionBar.getWidth(this.actionBar.length() - 1) + ACTION_PADDING : 0;
				this.container.style.minWidth = `${primaryActionsMinWidth + overflowWidth + separatorWidth}px`;
				this.element.style.minWidth = `${primaryActionsMinWidth + overflowWidth + separatorWidth}px`;
			} else {
				const minimumActionWidth = this.originalPrimaryActions.length > 0 ? this.getActionMinWidth(this.originalPrimaryActions[0]) : 24;
				this.container.style.minWidth = `${minimumActionWidth}px`;
				this.element.style.minWidth = `${minimumActionWidth}px`;
			}
			this.updateActions(this.getAvailableWidth());
		}
	}
	get overflowFromStart() {
		return this.options.responsiveBehavior?.kind === "all" && this.options.responsiveBehavior.overflowFrom === "start";
	}
	getKeybindingLabel(action) {
		return (this.options.getKeyBinding?.(action))?.getLabel() ?? void 0;
	}
	getConfiguredActionMinWidth(action) {
		if (action?.id === ToggleMenuAction.ID) return ACTION_MIN_WIDTH;
		return this.options.responsiveBehavior?.getActionMinWidth?.(action ?? this.toggleMenuAction) ?? this.options.responsiveBehavior?.actionMinWidth ?? ACTION_MIN_WIDTH;
	}
	getActionMinWidth(action) {
		return this.getConfiguredActionMinWidth(action) + ACTION_PADDING;
	}
	getAvailableWidth() {
		if (this.options.responsiveBehavior?.getAvailableWidth) return this.options.responsiveBehavior.getAvailableWidth();
		return this.element.getBoundingClientRect().width;
	}
	applyResponsiveActionMinWidths() {
		if (!this.options.responsiveBehavior?.enabled) return;
		if (this.options.responsiveBehavior.kind === "last") {
			const shrinkableIndex = this.actionBar.hasAction(this.toggleMenuAction) ? this.actionBar.length() - 2 : this.actionBar.length() - 1;
			const shrinkableAction = shrinkableIndex >= 0 ? this.actionBar.getAction(shrinkableIndex) : void 0;
			const minWidth = `${this.getConfiguredActionMinWidth(shrinkableAction)}px`;
			if (this.element.style.getPropertyValue(ACTION_MIN_WIDTH_VAR) !== minWidth) this.element.style.setProperty(ACTION_MIN_WIDTH_VAR, minWidth);
			return;
		}
		const actionsContainer = this.actionBar.getContainer().firstElementChild;
		if (!isHTMLElement(actionsContainer)) return;
		for (let i = 0; i < actionsContainer.children.length; i++) {
			const actionItem = actionsContainer.children.item(i);
			if (!isHTMLElement(actionItem)) continue;
			const action = this.actionBar.getAction(i);
			const minWidth = action instanceof Separator ? "0px" : `${this.getConfiguredActionMinWidth(action)}px`;
			if (action instanceof Separator) actionItem.style.flexShrink = "0";
			if (actionItem.style.minWidth !== minWidth) actionItem.style.minWidth = minWidth;
		}
	}
	updateActions(containerWidth) {
		if (this.actionBar.isEmpty()) return;
		this.applyResponsiveActionMinWidths();
		const parsedMinWidth = parseInt(this.element.style.minWidth);
		containerWidth = Math.max(containerWidth, Number.isNaN(parsedMinWidth) ? 0 : parsedMinWidth);
		const isActionItemVisible = (index) => {
			const element = this.getItemElement(index);
			return !element || getWindow(element).getComputedStyle(element).display !== "none";
		};
		const getVisiblePrimaryActionIndexes = () => {
			const indexes = [];
			for (let index = 0; index < this.actionBar.length(); index++) {
				const action = this.actionBar.getAction(index);
				if (action && this.originalPrimaryActions.includes(action) && isActionItemVisible(index)) indexes.push(index);
			}
			return indexes;
		};
		const getVisiblePrimaryActionCount = () => getVisiblePrimaryActionIndexes().reduce((count, index) => count + (this.actionBar.getAction(index) instanceof Separator ? 0 : 1), 0);
		const getActionsToHide = () => {
			const indexes = getVisiblePrimaryActionIndexes();
			const actionIndex = (this.overflowFromStart ? indexes : indexes.slice().reverse()).find((index) => !(this.actionBar.getAction(index) instanceof Separator));
			if (actionIndex === void 0) return [];
			let startIndex = actionIndex;
			let endIndex = actionIndex;
			const step = this.overflowFromStart ? 1 : -1;
			for (let index = actionIndex + step; index >= 0 && index < this.actionBar.length(); index += step) {
				const action = this.actionBar.getAction(index);
				if (!(action instanceof Separator) || !this.originalPrimaryActions.includes(action) || !isActionItemVisible(index)) break;
				startIndex = Math.min(startIndex, index);
				endIndex = Math.max(endIndex, index);
			}
			const actions = [];
			for (let index = startIndex; index <= endIndex; index++) {
				const action = this.actionBar.getAction(index);
				if (action) actions.push(action);
			}
			return actions;
		};
		const getActionsToRestore = () => {
			if (this.hiddenActions.length === 0) return [];
			if (this.overflowFromStart) {
				let startIndex = this.hiddenActions.length - 1;
				while (startIndex > 0 && this.hiddenActions[startIndex] instanceof Separator) startIndex--;
				return this.hiddenActions.slice(startIndex);
			}
			let endIndex = 0;
			while (endIndex < this.hiddenActions.length - 1 && this.hiddenActions[endIndex] instanceof Separator) endIndex++;
			return this.hiddenActions.slice(0, endIndex + 1);
		};
		const actionBarMinimumWidth = () => {
			if (this.options.responsiveBehavior?.kind === "last") {
				const hasToggleMenuAction = this.actionBar.hasAction(this.toggleMenuAction);
				const primaryActionIndexes = getVisiblePrimaryActionIndexes();
				if (primaryActionIndexes.length === 0) return hasToggleMenuAction ? 24 : 0;
				let itemsWidth = 0;
				for (const index of primaryActionIndexes.slice(0, -1)) itemsWidth += this.actionBar.getWidth(index) + ACTION_PADDING;
				const action = this.actionBar.getAction(primaryActionIndexes.at(-1));
				itemsWidth += this.getActionMinWidth(action);
				itemsWidth += hasToggleMenuAction ? 24 : 0;
				return itemsWidth;
			} else {
				let itemsWidth = 0;
				for (let i = 0; i < this.actionBar.length(); i++) if (isActionItemVisible(i)) {
					const action = this.actionBar.getAction(i);
					itemsWidth += action instanceof Separator ? this.actionBar.getWidth(i) + ACTION_PADDING : this.getActionMinWidth(action);
				}
				return itemsWidth;
			}
		};
		const projectedActionBarMinimumWidth = (actionsToAdd, keepToggleMenuAction) => {
			let itemsWidth = actionsToAdd.reduce((width, action) => width + this.getActionMinWidth(action), 0);
			if (this.options.responsiveBehavior?.kind === "last") {
				const primaryActionIndexes = getVisiblePrimaryActionIndexes();
				for (const [position, index] of primaryActionIndexes.entries()) {
					const itemWidth = position === primaryActionIndexes.length - 1 ? this.getUnshrunkItemWidth(index) : this.actionBar.getWidth(index);
					itemsWidth += itemWidth + ACTION_PADDING;
				}
			} else for (let i = 0; i < this.actionBar.length(); i++) {
				const action = this.actionBar.getAction(i);
				if (action && action !== this.toggleMenuAction && isActionItemVisible(i)) itemsWidth += action instanceof Separator ? this.actionBar.getWidth(i) + ACTION_PADDING : this.getActionMinWidth(action);
			}
			if (keepToggleMenuAction) itemsWidth += 24;
			return itemsWidth;
		};
		let minimumWidth = actionBarMinimumWidth();
		if (minimumWidth <= containerWidth && this.hiddenActions.length === 0) return;
		const focusedElement = getActiveElement();
		const focusedAction = isHTMLElement(focusedElement) ? this.actionBar.getAction(focusedElement) : void 0;
		const previousHiddenActionsCount = this.hiddenActions.length;
		if (minimumWidth > containerWidth) {
			const allowOverflow = this.options.responsiveBehavior?.allowOverflow;
			if (allowOverflow === false || typeof allowOverflow === "function" && !allowOverflow()) return;
			if (this.options.responsiveBehavior?.minItems !== void 0) {
				if (getVisiblePrimaryActionCount() <= this.options.responsiveBehavior.minItems) return;
			}
			while (minimumWidth > containerWidth && this.actionBar.length() > 0) {
				if (this.options.responsiveBehavior?.minItems !== void 0 && getVisiblePrimaryActionCount() <= this.options.responsiveBehavior.minItems) break;
				const actionsToHide = getActionsToHide();
				if (actionsToHide.length === 0) break;
				for (const action of actionsToHide) {
					this.hiddenActions.push(action);
					const index = this.actionBar.viewItems.findIndex((item) => item.action === action);
					if (index !== -1) this.actionBar.pull(index);
				}
				this.hiddenActions.sort((a, b) => this.originalPrimaryActions.indexOf(a) - this.originalPrimaryActions.indexOf(b));
				if (this.originalSecondaryActions.length === 0 && !this.actionBar.hasAction(this.toggleMenuAction)) {
					this.actionBar.push(this.toggleMenuAction, {
						icon: this.options.icon ?? true,
						label: this.options.label ?? false,
						keybinding: this.getKeybindingLabel(this.toggleMenuAction),
						index: this.options.trailingSeparator ? this.actionBar.length() - 1 : void 0
					});
					this.updateOverflowClassName();
				}
				this.applyResponsiveActionMinWidths();
				minimumWidth = actionBarMinimumWidth();
			}
		} else while (this.hiddenActions.length > 0) {
			const actionsToRestore = getActionsToRestore();
			if (projectedActionBarMinimumWidth(actionsToRestore, this.originalSecondaryActions.length > 0 || this.hiddenActions.length > actionsToRestore.length) > containerWidth) break;
			for (const action of actionsToRestore) {
				this.hiddenActions.splice(this.hiddenActions.indexOf(action), 1);
				const visibleActions = new Set(this.actionBar.viewItems.map((item) => item.action));
				this.actionBar.push(action, {
					icon: this.options.icon ?? true,
					label: this.options.label ?? false,
					keybinding: this.getKeybindingLabel(action),
					index: this.originalPrimaryActions.slice(0, this.originalPrimaryActions.indexOf(action)).reduce((index, precedingAction) => index + (visibleActions.has(precedingAction) ? 1 : 0), 0)
				});
			}
			if (this.originalSecondaryActions.length === 0 && this.hiddenActions.length === 0) {
				this.toggleMenuAction.menuActions = [];
				this.actionBar.pull(this.actionBar.viewItems.findIndex((item) => item.action === this.toggleMenuAction));
				this.updateOverflowClassName();
			}
			this.applyResponsiveActionMinWidths();
		}
		const hiddenActions = this.hiddenActions.map((action) => this.options.responsiveBehavior?.getOverflowAction?.(action, () => this.toggleMenuActionViewItem?.element) ?? action);
		if (this.originalSecondaryActions.length > 0 || hiddenActions.length > 0) {
			const secondaryActions = this.originalSecondaryActions.slice(0);
			this.toggleMenuAction.menuActions = Separator.clean(Separator.join(hiddenActions, secondaryActions));
		}
		this.updateOverflowClassName();
		this.applyResponsiveActionMinWidths();
		if (this.hiddenActions.length === previousHiddenActionsCount) return;
		for (let i = 0; i < this.actionBar.length(); i++) {
			const viewItem = this.getItemViewItem(i);
			if (viewItem instanceof BaseActionViewItem) viewItem.setFocusable(false);
		}
		if (focusedAction) {
			const index = Array.from({ length: this.actionBar.length() }, (_, index) => index).find((index) => this.actionBar.getAction(index) === focusedAction);
			const overflowIndex = Array.from({ length: this.actionBar.length() }, (_, index) => index).find((index) => this.actionBar.getAction(index) === this.toggleMenuAction);
			this.actionBar.focus(index ?? overflowIndex);
			if (index !== void 0 && isHTMLElement(focusedElement) && isAncestor$1(focusedElement, this.getItemElement(index) ?? null) && getActiveElement() !== focusedElement) {
				const viewItem = this.getItemViewItem(index);
				if (viewItem instanceof BaseActionViewItem) viewItem.setFocusable(false);
				focusedElement.tabIndex = 0;
				focusedElement.focus({ preventScroll: true });
			}
		} else this.actionBar.setFocusable(true);
	}
	updateOverflowClassName() {
		this.actionBar.domNode.classList.toggle("has-overflow", this.actionBar.hasAction(this.toggleMenuAction));
	}
	clear() {
		this.submenuActionViewItems = [];
		this.disposables.clear();
		this.actionBar.clear();
	}
	dispose() {
		this.clear();
		this.disposables.dispose();
		this.element.remove();
		super.dispose();
	}
};
var ToggleMenuAction = class ToggleMenuAction extends Action {
	static {
		this.ID = "toolbar.toggle.more";
	}
	constructor(toggleDropdownMenu, title) {
		title = title || localize(19, "More Actions...");
		super(ToggleMenuAction.ID, title, void 0, true);
		this._menuActions = [];
		this.toggleDropdownMenu = toggleDropdownMenu;
	}
	async run() {
		this.toggleDropdownMenu();
	}
	get menuActions() {
		return this._menuActions;
	}
	set menuActions(actions) {
		this._menuActions = actions;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/button/button.js
Color.white.toString(), Color.white.toString();
var buttonSanitizerConfig = Object.freeze({
	allowedTags: { override: [
		"b",
		"i",
		"u",
		"code",
		"span"
	] },
	allowedAttributes: { override: ["class"] }
});
var buttonMarkdownRenderOptions = Object.freeze({ sanitizerConfig: { allowedAttributes: { override: ["class"] } } });
var Button = class extends Disposable {
	get onDidClick() {
		return this._onDidClick.event;
	}
	constructor(container, options) {
		super();
		this._label = "";
		this._onDidClick = this._register(new Emitter$1());
		this._onDidEscape = this._register(new Emitter$1());
		this.options = options;
		this._element = document.createElement("a");
		this._element.classList.add("monaco-button");
		this._element.tabIndex = 0;
		this._element.setAttribute("role", "button");
		this._element.classList.toggle("secondary", !!options.secondary);
		this._element.classList.toggle("small", !!options.small);
		const background = options.secondary ? options.buttonSecondaryBackground : options.buttonBackground;
		const foreground = options.secondary ? options.buttonSecondaryForeground : options.buttonForeground;
		const border = options.secondary ? options.buttonSecondaryBorder : options.buttonBorder;
		this._element.style.color = foreground || "";
		this._element.style.backgroundColor = background || "";
		if (border) this._element.style.border = `1px solid ${border}`;
		if (options.supportShortLabel) {
			this._labelShortElement = document.createElement("div");
			this._labelShortElement.classList.add("monaco-button-label-short");
			this._element.appendChild(this._labelShortElement);
			this._labelElement = document.createElement("div");
			this._labelElement.classList.add("monaco-button-label");
			this._element.appendChild(this._labelElement);
			this._element.classList.add("monaco-text-button-with-short-label");
		}
		if (typeof options.title === "string") this.setTitle(options.title);
		if (typeof options.ariaLabel === "string") this._element.setAttribute("aria-label", options.ariaLabel);
		container.appendChild(this._element);
		this.enabled = !options.disabled;
		this._register(Gesture.addTarget(this._element));
		[EventType$1.CLICK, EventType.Tap].forEach((eventType) => {
			this._register(addDisposableListener(this._element, eventType, (e) => {
				if (!this.enabled) {
					EventHelper.stop(e);
					return;
				}
				this._onDidClick.fire(e);
			}));
		});
		this._register(addDisposableListener(this._element, EventType$1.KEY_DOWN, (e) => {
			const event = new StandardKeyboardEvent(e);
			let eventHandled = false;
			if (this.enabled && (event.equals(3) || event.equals(10))) {
				this._onDidClick.fire(e);
				eventHandled = true;
			} else if (event.equals(9)) {
				this._onDidEscape.fire(e);
				this._element.blur();
				eventHandled = true;
			}
			if (eventHandled) EventHelper.stop(event, true);
		}));
		this._register(addDisposableListener(this._element, EventType$1.MOUSE_OVER, (e) => {
			if (!this._element.classList.contains("disabled")) this.updateStyles(true);
		}));
		this._register(addDisposableListener(this._element, EventType$1.MOUSE_OUT, (e) => {
			this.updateStyles(false);
		}));
		this.focusTracker = this._register(trackFocus(this._element));
		this._register(this.focusTracker.onDidFocus(() => {
			if (this.enabled) this.updateStyles(true);
		}));
		this._register(this.focusTracker.onDidBlur(() => {
			if (this.enabled) this.updateStyles(false);
		}));
	}
	dispose() {
		super.dispose();
		this._element.remove();
	}
	getContentElements(content) {
		const elements = [];
		for (let segment of renderLabelWithIcons(content)) if (typeof segment === "string") {
			segment = segment.trim();
			if (segment === "") continue;
			const node = document.createElement("span");
			node.textContent = segment;
			elements.push(node);
		} else elements.push(segment);
		return elements;
	}
	updateStyles(hover) {
		let background;
		let foreground;
		let border;
		if (this.options.secondary) {
			background = hover ? this.options.buttonSecondaryHoverBackground : this.options.buttonSecondaryBackground;
			foreground = this.options.buttonSecondaryForeground;
			border = this.options.buttonSecondaryBorder;
		} else {
			background = hover ? this.options.buttonHoverBackground : this.options.buttonBackground;
			foreground = this.options.buttonForeground;
			border = this.options.buttonBorder;
		}
		this._element.style.backgroundColor = background || "";
		this._element.style.color = foreground || "";
		this._element.style.border = border ? `1px solid ${border}` : "";
	}
	get element() {
		return this._element;
	}
	set label(value) {
		if (this._label === value) return;
		if (isMarkdownString(this._label) && isMarkdownString(value) && markdownStringEqual(this._label, value)) return;
		this._element.classList.add("monaco-text-button");
		const labelElement = this.options.supportShortLabel ? this._labelElement : this._element;
		if (isMarkdownString(value)) {
			const rendered = renderMarkdown(value, buttonMarkdownRenderOptions, document.createElement("span"));
			rendered.dispose();
			const root = rendered.element.querySelector("p")?.innerHTML;
			if (root) safeSetInnerHtml(labelElement, root, buttonSanitizerConfig);
			else reset(labelElement);
		} else if (this.options.supportIcons) reset(labelElement, ...this.getContentElements(value));
		else labelElement.textContent = value;
		let title = "";
		if (typeof this.options.title === "string") title = this.options.title;
		else if (this.options.title) title = renderAsPlaintext(value);
		this.setTitle(title);
		this._setAriaLabel();
		this._label = value;
	}
	get label() {
		return this._label;
	}
	_setAriaLabel() {
		if (typeof this.options.ariaLabel === "string") this._element.setAttribute("aria-label", this.options.ariaLabel);
		else if (typeof this.options.title === "string") this._element.setAttribute("aria-label", this.options.title);
	}
	set icon(icon) {
		this._setAriaLabel();
		const oldIcons = Array.from(this._element.classList).filter((item) => item.startsWith("codicon-"));
		this._element.classList.remove(...oldIcons);
		this._element.classList.add(...ThemeIcon.asClassNameArray(icon));
	}
	set enabled(value) {
		if (value) {
			this._element.classList.remove("disabled");
			this._element.setAttribute("aria-disabled", String(false));
			this._element.tabIndex = 0;
		} else {
			this._element.classList.add("disabled");
			this._element.setAttribute("aria-disabled", String(true));
		}
	}
	get enabled() {
		return !this._element.classList.contains("disabled");
	}
	set secondary(value) {
		this._element.classList.toggle("secondary", value);
		this.options.secondary = value;
		this.updateStyles(false);
	}
	setTitle(title) {
		if (!this._hover && title !== "") this._hover = this._register(getBaseLayerHoverDelegate().setupManagedHover(this.options.hoverDelegate ?? getDefaultHoverDelegate("element"), this._element, title));
		else if (this._hover) this._hover.update(title);
	}
	focus() {
		this._element.focus();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/countBadge/countBadge.js
var CountBadge = class extends Disposable {
	constructor(container, options, styles) {
		super();
		this.options = options;
		this.styles = styles;
		this.count = 0;
		this.hover = this._register(new MutableDisposable());
		this.element = append$2(container, $$10(".monaco-count-badge"));
		this._register(toDisposable(() => container.removeChild(this.element)));
		this.countFormat = this.options.countFormat || "{0}";
		this.titleFormat = this.options.titleFormat || "";
		this.setCount(this.options.count || 0);
		this.updateHover();
	}
	setCount(count) {
		this.count = count;
		this.render();
	}
	setTitleFormat(titleFormat) {
		this.titleFormat = titleFormat;
		this.updateHover();
		this.render();
	}
	updateHover() {
		if (this.titleFormat !== "" && !this.hover.value) this.hover.value = getBaseLayerHoverDelegate().setupDelayedHoverAtMouse(this.element, () => ({
			content: format(this.titleFormat, this.count),
			appearance: { compact: true }
		}));
		else if (this.titleFormat === "" && this.hover.value) this.hover.value = void 0;
	}
	render() {
		this.element.textContent = format(this.countFormat, this.count);
		this.element.style.backgroundColor = this.styles.badgeBackground ?? "";
		this.element.style.color = this.styles.badgeForeground ?? "";
		if (this.styles.badgeBorder) this.element.style.border = `1px solid ${this.styles.badgeBorder}`;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/progressbar/progressbar.js
var CSS_DONE = "done";
var CSS_ACTIVE = "active";
var CSS_INFINITE = "infinite";
var CSS_INFINITE_LONG_RUNNING = "infinite-long-running";
var CSS_DISCRETE = "discrete";
var NLS_PROGRESS_LABEL = localize(16, "Progress");
/**
* A progress bar with support for infinite or discrete progress.
*/
var ProgressBar = class ProgressBar extends Disposable {
	/**
	* After a certain time of showing the progress bar, switch
	* to long-running mode and throttle animations to reduce
	* the pressure on the GPU process.
	*
	* https://github.com/microsoft/vscode/issues/97900
	* https://github.com/microsoft/vscode/issues/138396
	*/
	static {
		this.LONG_RUNNING_INFINITE_THRESHOLD = 1e4;
	}
	constructor(container, options) {
		super();
		this.progressSignal = this._register(new MutableDisposable());
		this.workedVal = 0;
		this.showDelayedScheduler = this._register(new RunOnceScheduler(() => show(this.element), 0));
		this.longRunningScheduler = this._register(new RunOnceScheduler(() => this.infiniteLongRunning(), ProgressBar.LONG_RUNNING_INFINITE_THRESHOLD));
		this.create(container, options);
	}
	create(container, options) {
		this.element = document.createElement("div");
		this.element.classList.add("monaco-progress-container");
		this.element.setAttribute("role", "progressbar");
		this.element.setAttribute("aria-valuemin", "0");
		this.element.setAttribute("aria-label", options?.ariaLabel && options.ariaLabel.trim() ? options.ariaLabel : NLS_PROGRESS_LABEL);
		container.appendChild(this.element);
		this.bit = document.createElement("div");
		this.bit.classList.add("progress-bit");
		this.bit.style.backgroundColor = options?.progressBarBackground || "#0E70C0";
		this.element.appendChild(this.bit);
	}
	off() {
		this.bit.style.width = "inherit";
		this.bit.style.opacity = "1";
		this.element.classList.remove(CSS_ACTIVE, CSS_INFINITE, CSS_INFINITE_LONG_RUNNING, CSS_DISCRETE);
		this.workedVal = 0;
		this.totalWork = void 0;
		this.longRunningScheduler.cancel();
		this.progressSignal.clear();
	}
	/**
	* Stops the progressbar from showing any progress instantly without fading out.
	*/
	stop() {
		return this.doDone(false);
	}
	doDone(delayed) {
		this.element.classList.add(CSS_DONE);
		if (!this.element.classList.contains(CSS_INFINITE)) {
			this.bit.style.width = "inherit";
			if (delayed) setTimeout(() => this.off(), 200);
			else this.off();
		} else {
			this.bit.style.opacity = "0";
			if (delayed) setTimeout(() => this.off(), 200);
			else this.off();
		}
		return this;
	}
	/**
	* Use this mode to indicate progress that has no total number of work units.
	*/
	infinite() {
		this.bit.style.width = "2%";
		this.bit.style.opacity = "1";
		this.element.classList.remove(CSS_DISCRETE, CSS_DONE, CSS_INFINITE_LONG_RUNNING);
		this.element.classList.add(CSS_ACTIVE, CSS_INFINITE);
		this.longRunningScheduler.schedule();
		return this;
	}
	infiniteLongRunning() {
		this.element.classList.add(CSS_INFINITE_LONG_RUNNING);
	}
	getContainer() {
		return this.element;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/quickinput/browser/quickInputBox.js
var $$5 = $$10;
var QuickInputBox = class extends Disposable {
	constructor(parent, inputBoxStyles, toggleStyles) {
		super();
		this.parent = parent;
		this._listFocusMode = false;
		this.onDidChange = (handler) => {
			return this.findInput.onDidChange(handler);
		};
		this.container = append$2(this.parent, $$5(".quick-input-box"));
		this.findInput = this._register(new FindInput(this.container, void 0, {
			label: "",
			inputBoxStyles,
			toggleStyles,
			actionViewItemProvider: createToggleActionViewItemProvider(toggleStyles),
			hideHoverOnValueChange: true
		}));
	}
	get onKeyDown() {
		return this.findInput.onKeyDown;
	}
	get value() {
		return this.findInput.getValue();
	}
	set value(value) {
		this.findInput.setValue(value);
	}
	select(range = null) {
		this.findInput.inputBox.select(range);
	}
	getSelection() {
		return this.findInput.inputBox.getSelection();
	}
	isSelectionAtEnd() {
		return this.findInput.inputBox.isSelectionAtEnd();
	}
	get placeholder() {
		return this.findInput.inputBox.inputElement.getAttribute("placeholder") || "";
	}
	set placeholder(placeholder) {
		this.findInput.inputBox.setPlaceHolder(placeholder);
	}
	get password() {
		return this.findInput.inputBox.inputElement.type === "password";
	}
	set password(password) {
		this.findInput.inputBox.inputElement.type = password ? "password" : "text";
	}
	set enabled(enabled) {
		this.findInput.inputBox.inputElement.toggleAttribute("readonly", !enabled);
	}
	set toggles(toggles) {
		this.findInput.setAdditionalToggles(toggles);
	}
	set actions(actions) {
		this.setActions(actions);
	}
	setActions(actions, actionViewItemProvider) {
		this.findInput.setActions(actions, actionViewItemProvider);
	}
	get ariaLabel() {
		return this.findInput.inputBox.inputElement.getAttribute("aria-label") || "";
	}
	set ariaLabel(ariaLabel) {
		this.findInput.inputBox.inputElement.setAttribute("aria-label", ariaLabel);
	}
	hasFocus() {
		return this.findInput.inputBox.hasFocus();
	}
	setAttribute(name, value) {
		this.findInput.inputBox.inputElement.setAttribute(name, value);
	}
	removeAttribute(name) {
		this.findInput.inputBox.inputElement.removeAttribute(name);
	}
	/**
	* Controls the ARIA popup mode for screen readers.
	* When enabled (hasActiveDescendant=true), indicates a list popup is active.
	* When disabled, removes ARIA attributes to allow normal text input behavior.
	* Only updates attributes when the state actually changes to avoid
	* unnecessary screen reader re-announcements.
	*/
	setListFocusMode(hasActiveDescendant) {
		if (this._listFocusMode === hasActiveDescendant) return;
		this._listFocusMode = hasActiveDescendant;
		const input = this.findInput.inputBox.inputElement;
		if (hasActiveDescendant) {
			input.setAttribute("aria-haspopup", "listbox");
			input.setAttribute("aria-autocomplete", "list");
		} else {
			input.removeAttribute("aria-haspopup");
			input.removeAttribute("aria-autocomplete");
		}
	}
	showDecoration(decoration) {
		if (decoration === Severity$1$1.Ignore) this.findInput.clearMessage();
		else this.findInput.showMessage({
			type: decoration === Severity$1$1.Info ? 1 : decoration === Severity$1$1.Warning ? 2 : 3,
			content: ""
		});
	}
	stylesForType(decoration) {
		return this.findInput.inputBox.stylesForType(decoration === Severity$1$1.Info ? 1 : decoration === Severity$1$1.Warning ? 2 : 3);
	}
	setFocus() {
		this.findInput.focus();
	}
	layout() {
		this.findInput.inputBox.layout();
	}
	setHeight(height) {
		this.findInput.inputBox.element.style.height = height === void 0 ? "" : `${height}px`;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/highlightedlabel/highlightedLabel.js
/**
* A widget which can render a label with substring highlights, often
* originating from a filter function like the fuzzy matcher.
*/
var HighlightedLabel = class HighlightedLabel extends Disposable {
	/**
	* Create a new {@link HighlightedLabel}.
	*
	* @param container The parent container to append to.
	*/
	constructor(container, options) {
		super();
		this.options = options;
		this.text = "";
		this.title = "";
		this.highlights = [];
		this.didEverRender = false;
		this.domNode = append$2(container, $$10("span.monaco-highlighted-label"));
	}
	/**
	* The label's DOM node.
	*/
	get element() {
		return this.domNode;
	}
	/**
	* Set the label and highlights.
	*
	* @param text The label to display.
	* @param highlights The ranges to highlight.
	* @param title An optional title for the hover tooltip.
	* @param escapeNewLines Whether to escape new lines.
	* @returns
	*/
	set(text, highlights = [], title = "", escapeNewLines, supportIcons) {
		if (!text) text = "";
		if (escapeNewLines) text = HighlightedLabel.escapeNewLines(text, highlights);
		if (this.didEverRender && this.text === text && this.title === title && equals$2(this.highlights, highlights)) return;
		this.text = text;
		this.title = title;
		this.highlights = highlights;
		this.render(supportIcons);
	}
	render(supportIcons) {
		const children = [];
		let pos = 0;
		for (const highlight of this.highlights) {
			if (highlight.end === highlight.start) continue;
			if (pos < highlight.start) {
				const substring = this.text.substring(pos, highlight.start);
				if (supportIcons) children.push(...renderLabelWithIcons(substring, true));
				else children.push(substring);
				pos = highlight.start;
			}
			const substring = this.text.substring(pos, highlight.end);
			const element = $$10("span.highlight", void 0, ...supportIcons ? renderLabelWithIcons(substring, true) : [substring]);
			if (highlight.extraClasses) element.classList.add(...highlight.extraClasses);
			children.push(element);
			pos = highlight.end;
		}
		if (pos < this.text.length) {
			const substring = this.text.substring(pos);
			if (supportIcons) children.push(...renderLabelWithIcons(substring, true));
			else children.push(substring);
		}
		reset(this.domNode, ...children);
		if (!this.customHover && this.title !== "") {
			const hoverDelegate = this.options?.hoverDelegate ?? getDefaultHoverDelegate("mouse");
			this.customHover = this._register(getBaseLayerHoverDelegate().setupManagedHover(hoverDelegate, this.domNode, this.title));
		} else if (this.customHover) this.customHover.update(this.title);
		this.didEverRender = true;
	}
	static escapeNewLines(text, highlights) {
		let total = 0;
		let extra = 0;
		return text.replace(/\r\n|\r|\n/g, (match, offset) => {
			extra = match === "\r\n" ? -1 : 0;
			offset += total;
			for (const highlight of highlights) {
				if (highlight.end <= offset) continue;
				if (highlight.start >= offset) highlight.start += extra;
				if (highlight.end >= offset) highlight.end += extra;
			}
			total += extra;
			return "⏎";
		});
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/iconLabel/iconLabel.js
var FastLabelNode = class {
	constructor(_element) {
		this._element = _element;
	}
	get element() {
		return this._element;
	}
	set textContent(content) {
		if (this.disposed || content === this._textContent) return;
		this._textContent = content;
		this._element.textContent = content;
	}
	set classNames(classNames) {
		if (this.disposed || equals$2(classNames, this._classNames)) return;
		this._classNames = classNames;
		this._element.classList.value = "";
		this._element.classList.add(...classNames);
	}
	set empty(empty) {
		if (this.disposed || empty === this._empty) return;
		this._empty = empty;
		this._element.style.marginLeft = empty ? "0" : "";
	}
	dispose() {
		this.disposed = true;
	}
};
var IconLabel = class extends Disposable {
	constructor(container, options) {
		super();
		this.customHovers = /* @__PURE__ */ new Map();
		this.creationOptions = options;
		this.domNode = this._register(new FastLabelNode(append$2(container, $$10(".monaco-icon-label"))));
		this.labelContainer = append$2(this.domNode.element, $$10(".monaco-icon-label-container"));
		this.nameContainer = append$2(this.labelContainer, $$10("span.monaco-icon-name-container"));
		if (options?.supportHighlights || options?.supportIcons) this.nameNode = this._register(new LabelWithHighlights(this.nameContainer, !!options.supportIcons));
		else this.nameNode = new Label(this.nameContainer);
		this.hoverDelegate = options?.hoverDelegate ?? getDefaultHoverDelegate("mouse");
	}
	get element() {
		return this.domNode.element;
	}
	setLabel(label, description, options) {
		const labelClasses = ["monaco-icon-label"];
		const containerClasses = ["monaco-icon-label-container"];
		let ariaLabel = "";
		if (options) {
			if (options.extraClasses) labelClasses.push(...options.extraClasses);
			if (options.bold) labelClasses.push("bold");
			if (options.italic) labelClasses.push("italic");
			if (options.strikethrough) labelClasses.push("strikethrough");
			if (options.disabledCommand) containerClasses.push("disabled");
			if (options.title) {
				if (typeof options.title === "string") ariaLabel += options.title;
				else ariaLabel += label;
			}
		}
		const existingIconNode = this.domNode.element.querySelector(".monaco-icon-label-iconpath");
		if (options?.iconPath) {
			let iconNode;
			if (!existingIconNode || !isHTMLElement(existingIconNode)) {
				iconNode = $$10(".monaco-icon-label-iconpath");
				this.domNode.element.prepend(iconNode);
			} else iconNode = existingIconNode;
			if (ThemeIcon.isThemeIcon(options.iconPath)) {
				const iconClass = ThemeIcon.asClassName(options.iconPath);
				iconNode.className = `monaco-icon-label-iconpath ${iconClass}`;
				iconNode.style.backgroundImage = "";
			} else iconNode.style.backgroundImage = asCSSUrl(options?.iconPath);
			iconNode.style.backgroundRepeat = "no-repeat";
			iconNode.style.backgroundPosition = "center";
			iconNode.style.backgroundSize = "contain";
		} else if (existingIconNode) existingIconNode.remove();
		this.domNode.classNames = labelClasses;
		this.domNode.element.setAttribute("aria-label", ariaLabel);
		this.labelContainer.classList.value = "";
		this.labelContainer.classList.add(...containerClasses);
		this.setupHover(options?.descriptionTitle ? this.labelContainer : this.element, options?.title);
		this.nameNode.setLabel(label, options);
		if (description || this.descriptionNode) {
			const descriptionNode = this.getOrCreateDescriptionNode();
			if (descriptionNode instanceof HighlightedLabel) {
				const supportIcons = options?.supportIcons ?? this.creationOptions?.supportIcons;
				descriptionNode.set(description || "", options ? options.descriptionMatches : void 0, void 0, options?.labelEscapeNewLines, supportIcons);
				this.setupHover(descriptionNode.element, options?.descriptionTitle);
			} else {
				descriptionNode.textContent = description && options?.labelEscapeNewLines ? HighlightedLabel.escapeNewLines(description, []) : description || "";
				this.setupHover(descriptionNode.element, options?.descriptionTitle || "");
				descriptionNode.empty = !description;
			}
		}
		if (options?.suffix || this.suffixNode) {
			const suffixNode = this.getOrCreateSuffixNode();
			suffixNode.textContent = options?.suffix ?? "";
		}
	}
	setupHover(htmlElement, tooltip) {
		const previousCustomHover = this.customHovers.get(htmlElement);
		if (previousCustomHover) {
			previousCustomHover.dispose();
			this.customHovers.delete(htmlElement);
		}
		if (!tooltip) {
			htmlElement.removeAttribute("title");
			return;
		}
		let hoverTarget = htmlElement;
		if (this.creationOptions?.hoverTargetOverride) {
			if (!isAncestor$1(htmlElement, this.creationOptions.hoverTargetOverride)) throw new Error("hoverTargetOverrride must be an ancestor of the htmlElement");
			hoverTarget = this.creationOptions.hoverTargetOverride;
		}
		const hoverDisposable = getBaseLayerHoverDelegate().setupManagedHover(this.hoverDelegate, hoverTarget, tooltip);
		if (hoverDisposable) this.customHovers.set(htmlElement, hoverDisposable);
	}
	dispose() {
		super.dispose();
		for (const disposable of this.customHovers.values()) disposable.dispose();
		this.customHovers.clear();
	}
	getOrCreateSuffixNode() {
		if (!this.suffixNode) {
			const suffixContainer = this._register(new FastLabelNode(after(this.nameContainer, $$10("span.monaco-icon-suffix-container"))));
			this.suffixNode = this._register(new FastLabelNode(append$2(suffixContainer.element, $$10("span.label-suffix"))));
		}
		return this.suffixNode;
	}
	getOrCreateDescriptionNode() {
		if (!this.descriptionNode) {
			const descriptionContainer = this._register(new FastLabelNode(append$2(this.labelContainer, $$10("span.monaco-icon-description-container"))));
			if (this.creationOptions?.supportDescriptionHighlights) this.descriptionNode = this._register(new HighlightedLabel(append$2(descriptionContainer.element, $$10("span.label-description"))));
			else this.descriptionNode = this._register(new FastLabelNode(append$2(descriptionContainer.element, $$10("span.label-description"))));
		}
		return this.descriptionNode;
	}
};
var Label = class {
	constructor(container) {
		this.container = container;
		this.label = void 0;
		this.singleLabel = void 0;
	}
	setLabel(label, options) {
		if (this.label === label && equals$2(this.options, options)) return;
		this.label = label;
		this.options = options;
		if (typeof label === "string") {
			if (!this.singleLabel) {
				this.container.textContent = "";
				this.container.classList.remove("multiple");
				this.singleLabel = append$2(this.container, $$10("a.label-name", { id: options?.domId }));
			}
			this.singleLabel.textContent = label;
		} else {
			this.container.textContent = "";
			this.container.classList.add("multiple");
			this.singleLabel = void 0;
			for (let i = 0; i < label.length; i++) {
				const l = label[i];
				const id = options?.domId && `${options?.domId}_${i}`;
				append$2(this.container, $$10("a.label-name", {
					id,
					"data-icon-label-count": label.length,
					"data-icon-label-index": i,
					"role": "treeitem"
				}, l));
				if (i < label.length - 1) append$2(this.container, $$10("span.label-separator", void 0, options?.separator || "/"));
			}
		}
	}
};
function splitMatches(labels, separator, matches) {
	if (!matches) return;
	let labelStart = 0;
	return labels.map((label) => {
		const labelRange = {
			start: labelStart,
			end: labelStart + label.length
		};
		const result = matches.map((match) => Range$1.intersect(labelRange, match)).filter((range) => !Range$1.isEmpty(range)).map(({ start, end }) => ({
			start: start - labelStart,
			end: end - labelStart
		}));
		labelStart = labelRange.end + separator.length;
		return result;
	});
}
var LabelWithHighlights = class extends Disposable {
	constructor(container, supportIcons) {
		super();
		this.container = container;
		this.supportIcons = supportIcons;
		this.label = void 0;
		this.singleLabel = void 0;
		this._labelDisposables = this._register(new DisposableStore());
	}
	setLabel(label, options) {
		if (this.label === label && equals$2(this.options, options)) return;
		this.label = label;
		this.options = options;
		const supportIcons = options?.supportIcons ?? this.supportIcons;
		if (typeof label === "string") {
			if (!this.singleLabel) {
				this._labelDisposables.clear();
				this.container.textContent = "";
				this.container.classList.remove("multiple");
				this.singleLabel = this._labelDisposables.add(new HighlightedLabel(append$2(this.container, $$10("a.label-name", { id: options?.domId }))));
			}
			this.singleLabel.set(label, options?.matches, void 0, options?.labelEscapeNewLines, supportIcons);
		} else {
			this._labelDisposables.clear();
			this.container.textContent = "";
			this.container.classList.add("multiple");
			this.singleLabel = void 0;
			const separator = options?.separator || "/";
			const matches = splitMatches(label, separator, options?.matches);
			for (let i = 0; i < label.length; i++) {
				const l = label[i];
				const m = matches ? matches[i] : void 0;
				const name = $$10("a.label-name", {
					id: options?.domId && `${options?.domId}_${i}`,
					"data-icon-label-count": label.length,
					"data-icon-label-index": i,
					"role": "treeitem"
				});
				this._labelDisposables.add(new HighlightedLabel(append$2(this.container, name))).set(l, m, void 0, options?.labelEscapeNewLines, supportIcons);
				if (i < label.length - 1) append$2(name, $$10("span.label-separator", void 0, separator));
			}
		}
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/browser/ui/keybindingLabel/keybindingLabel.js
var $$4 = $$10;
var unthemedKeybindingLabelOptions = {
	keybindingLabelBackground: void 0,
	keybindingLabelForeground: void 0,
	keybindingLabelBorder: void 0,
	keybindingLabelBottomBorder: void 0,
	keybindingLabelShadow: void 0
};
var KeybindingLabel = class KeybindingLabel extends Disposable {
	constructor(container, os, options) {
		super();
		this.os = os;
		this.keyElements = /* @__PURE__ */ new Set();
		this.options = options || Object.create(null);
		const labelForeground = this.options.keybindingLabelForeground;
		this.domNode = append$2(container, $$4(".monaco-keybinding"));
		if (labelForeground) this.domNode.style.color = labelForeground;
		this.hover = this._register(getBaseLayerHoverDelegate().setupManagedHover(getDefaultHoverDelegate("mouse"), this.domNode, ""));
		this.didEverRender = false;
		container.appendChild(this.domNode);
	}
	set(keybinding, matches) {
		if (this.didEverRender && this.keybinding === keybinding && KeybindingLabel.areSame(this.matches, matches)) return;
		this.keybinding = keybinding;
		this.matches = matches;
		this.render();
	}
	render() {
		this.clear();
		if (this.keybinding) {
			const chords = this.keybinding.getChords();
			if (chords[0]) this.renderChord(this.domNode, chords[0], this.matches ? this.matches.firstPart : null);
			for (let i = 1; i < chords.length; i++) {
				append$2(this.domNode, $$4("span.monaco-keybinding-key-chord-separator", void 0, " "));
				this.renderChord(this.domNode, chords[i], this.matches ? this.matches.chordPart : null);
			}
			const title = this.options.disableTitle ?? false ? void 0 : this.keybinding.getAriaLabel() || void 0;
			this.hover.update(title);
			this.domNode.setAttribute("aria-label", title || "");
		} else if (this.options && this.options.renderUnboundKeybindings) this.renderUnbound(this.domNode);
		this.didEverRender = true;
	}
	clear() {
		clearNode(this.domNode);
		this.keyElements.clear();
	}
	renderChord(parent, chord, match) {
		const modifierLabels = UILabelProvider.modifierLabels[this.os];
		if (chord.ctrlKey) this.renderKey(parent, modifierLabels.ctrlKey, Boolean(match?.ctrlKey), modifierLabels.separator);
		if (chord.shiftKey) this.renderKey(parent, modifierLabels.shiftKey, Boolean(match?.shiftKey), modifierLabels.separator);
		if (chord.altKey) this.renderKey(parent, modifierLabels.altKey, Boolean(match?.altKey), modifierLabels.separator);
		if (chord.metaKey) this.renderKey(parent, modifierLabels.metaKey, Boolean(match?.metaKey), modifierLabels.separator);
		const keyLabel = chord.keyLabel;
		if (keyLabel) this.renderKey(parent, keyLabel, Boolean(match?.keyCode), "");
	}
	renderKey(parent, label, highlight, separator) {
		append$2(parent, this.createKeyElement(label, highlight ? ".highlight" : ""));
		if (separator) append$2(parent, $$4("span.monaco-keybinding-key-separator", void 0, separator));
	}
	renderUnbound(parent) {
		append$2(parent, this.createKeyElement(localize(15, "Unbound")));
	}
	createKeyElement(label, extraClass = "") {
		const keyElement = $$4("span.monaco-keybinding-key" + extraClass, void 0, label);
		this.keyElements.add(keyElement);
		if (this.options.keybindingLabelBackground) keyElement.style.backgroundColor = this.options.keybindingLabelBackground;
		if (this.options.keybindingLabelBorder) keyElement.style.borderColor = this.options.keybindingLabelBorder;
		if (this.options.keybindingLabelBottomBorder) keyElement.style.borderBottomColor = this.options.keybindingLabelBottomBorder;
		if (this.options.keybindingLabelShadow) keyElement.style.boxShadow = `inset 0 -1px 0 ${this.options.keybindingLabelShadow}`;
		return keyElement;
	}
	static areSame(a, b) {
		if (a === b || !a && !b) return true;
		return !!a && !!b && equals$2(a.firstPart, b.firstPart) && equals$2(a.chordPart, b.chordPart);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/comparers.js
var intlFileNameCollatorBaseNumeric = new Lazy(() => {
	const collator = safeIntl.Collator(void 0, {
		numeric: true,
		sensitivity: "base"
	}).value;
	return {
		collator,
		collatorIsNumeric: collator.resolvedOptions().numeric
	};
});
new Lazy(() => {
	return { collator: safeIntl.Collator(void 0, { numeric: true }).value };
});
new Lazy(() => {
	return { collator: safeIntl.Collator(void 0, {
		numeric: true,
		sensitivity: "accent"
	}).value };
});
/** Compares filenames without distinguishing the name from the extension. Disambiguates by unicode comparison. */
function compareFileNames(one, other, caseSensitive = false) {
	const a = one || "";
	const b = other || "";
	const result = intlFileNameCollatorBaseNumeric.value.collator.compare(a, b);
	if (intlFileNameCollatorBaseNumeric.value.collatorIsNumeric && result === 0 && a !== b) return a < b ? -1 : 1;
	return result;
}
function compareAnything(one, other, lookFor) {
	const elementAName = one.toLowerCase();
	const elementBName = other.toLowerCase();
	const prefixCompare = compareByPrefix(one, other, lookFor);
	if (prefixCompare) return prefixCompare;
	const elementASuffixMatch = elementAName.endsWith(lookFor);
	if (elementASuffixMatch !== elementBName.endsWith(lookFor)) return elementASuffixMatch ? -1 : 1;
	const r = compareFileNames(elementAName, elementBName);
	if (r !== 0) return r;
	return elementAName.localeCompare(elementBName);
}
function compareByPrefix(one, other, lookFor) {
	const elementAName = one.toLowerCase();
	const elementBName = other.toLowerCase();
	const elementAPrefixMatch = elementAName.startsWith(lookFor);
	const elementBPrefixMatch = elementBName.startsWith(lookFor);
	if (elementAPrefixMatch !== elementBPrefixMatch) return elementAPrefixMatch ? -1 : 1;
	else if (elementAPrefixMatch && elementBPrefixMatch) {
		if (elementAName.length < elementBName.length) return -1;
		if (elementAName.length > elementBName.length) return 1;
	}
	return 0;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/quickinput/browser/quickInputList.js
var __decorate$22 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$22 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var QuickPickItemElementRenderer_1;
var QuickPickSeparatorElementRenderer_1;
var $$3 = $$10;
var BaseQuickPickItemElement = class {
	constructor(index, hasCheckbox, mainItem) {
		this.index = index;
		this.hasCheckbox = hasCheckbox;
		this._hidden = false;
		this._init = new Lazy(() => {
			const saneLabel = mainItem.label ?? "";
			return {
				saneLabel,
				saneSortLabel: parseLabelWithIcons(saneLabel).text.trim(),
				saneAriaLabel: mainItem.ariaLabel || [
					saneLabel,
					this.saneDescription,
					this.saneDetail
				].map((s) => getCodiconAriaLabel(s)).filter((s) => !!s).join(", ")
			};
		});
		this._saneDescription = mainItem.description;
		this._saneTooltip = mainItem.tooltip;
	}
	get saneLabel() {
		return this._init.value.saneLabel;
	}
	get saneSortLabel() {
		return this._init.value.saneSortLabel;
	}
	get saneAriaLabel() {
		return this._init.value.saneAriaLabel;
	}
	get element() {
		return this._element;
	}
	set element(value) {
		this._element = value;
	}
	get hidden() {
		return this._hidden;
	}
	set hidden(value) {
		this._hidden = value;
	}
	get saneDescription() {
		return this._saneDescription;
	}
	set saneDescription(value) {
		this._saneDescription = value;
	}
	get saneDetail() {
		return this._saneDetail;
	}
	set saneDetail(value) {
		this._saneDetail = value;
	}
	get saneTooltip() {
		return this._saneTooltip;
	}
	set saneTooltip(value) {
		this._saneTooltip = value;
	}
	get labelHighlights() {
		return this._labelHighlights;
	}
	set labelHighlights(value) {
		this._labelHighlights = value;
	}
	get descriptionHighlights() {
		return this._descriptionHighlights;
	}
	set descriptionHighlights(value) {
		this._descriptionHighlights = value;
	}
	get detailHighlights() {
		return this._detailHighlights;
	}
	set detailHighlights(value) {
		this._detailHighlights = value;
	}
};
var QuickPickItemElement = class extends BaseQuickPickItemElement {
	constructor(index, childIndex, hasCheckbox, fireButtonTriggered, _onChecked, item, _separator) {
		super(index, hasCheckbox, item);
		this.childIndex = childIndex;
		this.fireButtonTriggered = fireButtonTriggered;
		this._onChecked = _onChecked;
		this.item = item;
		this._separator = _separator;
		this._checked = false;
		this.onChecked = hasCheckbox ? Event.map(Event.filter(this._onChecked.event, (e) => e.element === this), (e) => e.checked) : Event.None;
		this._saneDetail = item.detail;
		this._labelHighlights = item.highlights?.label;
		this._descriptionHighlights = item.highlights?.description;
		this._detailHighlights = item.highlights?.detail;
	}
	get separator() {
		return this._separator;
	}
	set separator(value) {
		this._separator = value;
	}
	get checked() {
		return this._checked;
	}
	set checked(value) {
		if (value !== this._checked) {
			this._checked = value;
			this._onChecked.fire({
				element: this,
				checked: value
			});
		}
	}
	get checkboxDisabled() {
		return !!this.item.disabled;
	}
};
var QuickPickSeparatorFocusReason;
(function(QuickPickSeparatorFocusReason) {
	/**
	* No item is hovered or active
	*/
	QuickPickSeparatorFocusReason[QuickPickSeparatorFocusReason["NONE"] = 0] = "NONE";
	/**
	* Some item within this section is hovered
	*/
	QuickPickSeparatorFocusReason[QuickPickSeparatorFocusReason["MOUSE_HOVER"] = 1] = "MOUSE_HOVER";
	/**
	* Some item within this section is active
	*/
	QuickPickSeparatorFocusReason[QuickPickSeparatorFocusReason["ACTIVE_ITEM"] = 2] = "ACTIVE_ITEM";
})(QuickPickSeparatorFocusReason || (QuickPickSeparatorFocusReason = {}));
var QuickPickSeparatorElement = class extends BaseQuickPickItemElement {
	constructor(index, fireSeparatorButtonTriggered, separator) {
		super(index, false, separator);
		this.fireSeparatorButtonTriggered = fireSeparatorButtonTriggered;
		this.separator = separator;
		this.children = new Array();
		/**
		* If this item is >0, it means that there is some item in the list that is either:
		* * hovered over
		* * active
		*/
		this.focusInsideSeparator = QuickPickSeparatorFocusReason.NONE;
	}
};
var QuickInputItemDelegate = class {
	getHeight(element) {
		if (element instanceof QuickPickSeparatorElement) return 30;
		return element.saneDetail ? 44 : 22;
	}
	getTemplateId(element) {
		if (element instanceof QuickPickItemElement) return QuickPickItemElementRenderer.ID;
		else return QuickPickSeparatorElementRenderer.ID;
	}
};
var QuickInputAccessibilityProvider = class {
	getWidgetAriaLabel() {
		return localize(1867, "Quick Input");
	}
	getAriaLabel(element) {
		return element.separator?.label ? `${element.saneAriaLabel}, ${element.separator.label}` : element.saneAriaLabel;
	}
	getWidgetRole() {
		return "listbox";
	}
	getRole(element) {
		return element.hasCheckbox ? "checkbox" : "option";
	}
	isChecked(element) {
		if (!element.hasCheckbox || !(element instanceof QuickPickItemElement)) return;
		return {
			get value() {
				return element.checked;
			},
			onDidChange: (e) => element.onChecked(() => e())
		};
	}
};
var BaseQuickInputListRenderer = class extends Disposable {
	constructor(hoverDelegate, toggleStyles, contextMenuService) {
		super();
		this.hoverDelegate = hoverDelegate;
		this.toggleStyles = toggleStyles;
		this.contextMenuService = contextMenuService;
		this._onDidDisposeFocusedElement = this._register(new Emitter$1());
		/**
		* This event is emitted when the renderer disposes an element that has focus.
		* This allows the list to re-focus itself and prevent focus from being lost
		* (potentially causing quickinput to dismiss itself) when an element is
		* removed while focused.
		*/
		this.onDidDisposeFocusedElement = this._onDidDisposeFocusedElement.event;
	}
	renderTemplate(container) {
		const data = Object.create(null);
		data.toDisposeElement = new DisposableStore();
		data.toDisposeTemplate = new DisposableStore();
		data.entry = append$2(container, $$3(".quick-input-list-entry"));
		const label = append$2(data.entry, $$3("label.quick-input-list-label"));
		data.outerLabel = label;
		data.checkbox = data.toDisposeTemplate.add(new MutableDisposable());
		data.toDisposeTemplate.add(addStandardDisposableListener(label, EventType$1.CLICK, (e) => {
			if (data.checkbox.value && !e.defaultPrevented && data.checkbox.value.enabled) {
				const checked = !data.checkbox.value.checked;
				data.checkbox.value.checked = checked;
				data.element.checked = checked;
			}
		}));
		const rows = append$2(label, $$3(".quick-input-list-rows"));
		const row1 = append$2(rows, $$3(".quick-input-list-row"));
		const row2 = append$2(rows, $$3(".quick-input-list-row"));
		data.label = new IconLabel(row1, {
			supportHighlights: true,
			supportDescriptionHighlights: true,
			supportIcons: true,
			hoverDelegate: this.hoverDelegate
		});
		data.toDisposeTemplate.add(data.label);
		data.icon = prepend$2(data.label.element, $$3(".quick-input-list-icon"));
		data.keybinding = new KeybindingLabel(append$2(row1, $$3(".quick-input-list-entry-keybinding")), OS);
		data.toDisposeTemplate.add(data.keybinding);
		data.detail = new IconLabel(append$2(row2, $$3(".quick-input-list-label-meta")), {
			supportHighlights: true,
			supportIcons: true,
			hoverDelegate: this.hoverDelegate
		});
		data.toDisposeTemplate.add(data.detail);
		data.separator = append$2(data.entry, $$3(".quick-input-list-separator"));
		data.toolBar = new ToolBar(data.entry, this.contextMenuService, {
			...this.hoverDelegate ? { hoverDelegate: this.hoverDelegate } : void 0,
			actionViewItemProvider: createToggleActionViewItemProvider(this.toggleStyles),
			icon: true,
			label: false
		});
		data.toolBar.getElement().classList.add("quick-input-list-entry-action-bar");
		data.toDisposeTemplate.add(data.toolBar);
		return data;
	}
	disposeTemplate(data) {
		data.toDisposeElement.dispose();
		data.toDisposeTemplate.dispose();
	}
	disposeElement(_element, _index, data) {
		if (isAncestorOfActiveElement(data.entry)) this._onDidDisposeFocusedElement.fire();
		data.toDisposeElement.clear();
		data.toolBar.setActions([]);
	}
};
var QuickPickItemElementRenderer = class QuickPickItemElementRenderer extends BaseQuickInputListRenderer {
	static {
		QuickPickItemElementRenderer_1 = this;
	}
	static {
		this.ID = "quickpickitem";
	}
	constructor(hoverDelegate, toggleStyles, contextMenuService, themeService) {
		super(hoverDelegate, toggleStyles, contextMenuService);
		this.themeService = themeService;
		this._itemsWithSeparatorsFrequency = /* @__PURE__ */ new Map();
	}
	get templateId() {
		return QuickPickItemElementRenderer_1.ID;
	}
	ensureCheckbox(element, data) {
		if (!element.hasCheckbox) {
			data.checkbox.value?.domNode.remove();
			data.checkbox.clear();
			return;
		}
		let checkbox = data.checkbox.value;
		if (!checkbox) {
			checkbox = new Checkbox(element.saneLabel, element.checked, {
				...defaultCheckboxStyles,
				size: 15
			});
			data.checkbox.value = checkbox;
			data.outerLabel.prepend(checkbox.domNode);
			checkbox.domNode.tabIndex = -1;
		} else checkbox.setTitle(element.saneLabel);
		if (element.checkboxDisabled) checkbox.disable();
		else checkbox.enable();
		checkbox.checked = element.checked;
		data.toDisposeElement.add(element.onChecked((checked) => checkbox.checked = checked));
		data.toDisposeElement.add(checkbox.onChange(() => element.checked = checkbox.checked));
	}
	renderElement(node, index, data) {
		const element = node.element;
		data.element = element;
		element.element = data.entry ?? void 0;
		const mainItem = element.item;
		element.element.classList.toggle("not-pickable", element.item.pickable === false);
		if (typeof mainItem.id === "string") data.entry.setAttribute("data-quick-input-id", mainItem.id);
		else data.entry.removeAttribute("data-quick-input-id");
		this.ensureCheckbox(element, data);
		const { labelHighlights, descriptionHighlights, detailHighlights } = element;
		if (mainItem.iconPath) {
			const icon = isDark(this.themeService.getColorTheme().type) ? mainItem.iconPath.dark : mainItem.iconPath.light ?? mainItem.iconPath.dark;
			const iconUrl = URI.revive(icon);
			data.icon.className = "quick-input-list-icon";
			data.icon.style.backgroundImage = asCSSUrl(iconUrl);
		} else {
			data.icon.style.backgroundImage = "";
			data.icon.className = mainItem.iconClass ? `quick-input-list-icon ${mainItem.iconClass}` : "";
		}
		data.icon.style.color = mainItem.iconColor ? asCssVariable(mainItem.iconColor.id) : "";
		let descriptionTitle;
		if (!element.saneTooltip && element.saneDescription) descriptionTitle = {
			markdown: {
				value: escape$2(element.saneDescription),
				supportThemeIcons: true
			},
			markdownNotSupportedFallback: element.saneDescription
		};
		const options = {
			matches: labelHighlights || [],
			descriptionTitle,
			descriptionMatches: descriptionHighlights || [],
			labelEscapeNewLines: true
		};
		options.extraClasses = mainItem.iconClasses;
		options.italic = mainItem.italic;
		options.strikethrough = mainItem.strikethrough;
		data.entry.classList.remove("quick-input-list-separator-as-item");
		data.label.setLabel(element.saneLabel, element.saneDescription, options);
		data.keybinding.set(mainItem.keybinding);
		if (element.saneDetail) {
			let title;
			if (!element.saneTooltip) title = {
				markdown: {
					value: escape$2(element.saneDetail),
					supportThemeIcons: true
				},
				markdownNotSupportedFallback: element.saneDetail
			};
			data.detail.element.style.display = "";
			data.detail.setLabel(element.saneDetail, void 0, {
				matches: detailHighlights,
				title,
				labelEscapeNewLines: true
			});
		} else data.detail.element.style.display = "none";
		if (element.separator?.label) {
			data.separator.textContent = element.separator.label;
			data.separator.style.display = "";
			this.addItemWithSeparator(element);
		} else data.separator.style.display = "none";
		data.entry.classList.toggle("quick-input-list-separator-border", !!element.separator && element.childIndex !== 0);
		const buttons = mainItem.buttons;
		if (buttons && buttons.length) {
			const { primary, secondary } = quickInputButtonsToActionArrays(buttons, "quick-input-item", (button) => element.fireButtonTriggered({
				button,
				item: element.item
			}));
			data.toolBar.setActions(primary, secondary);
			data.entry.classList.add("has-actions");
		} else {
			data.toolBar.setActions([]);
			data.entry.classList.remove("has-actions");
		}
	}
	disposeElement(element, _index, data) {
		this.removeItemWithSeparator(element.element);
		super.disposeElement(element, _index, data);
	}
	isItemWithSeparatorVisible(item) {
		return this._itemsWithSeparatorsFrequency.has(item);
	}
	addItemWithSeparator(item) {
		this._itemsWithSeparatorsFrequency.set(item, (this._itemsWithSeparatorsFrequency.get(item) || 0) + 1);
	}
	removeItemWithSeparator(item) {
		const frequency = this._itemsWithSeparatorsFrequency.get(item) || 0;
		if (frequency > 1) this._itemsWithSeparatorsFrequency.set(item, frequency - 1);
		else this._itemsWithSeparatorsFrequency.delete(item);
	}
};
QuickPickItemElementRenderer = QuickPickItemElementRenderer_1 = __decorate$22([__param$22(2, IContextMenuService), __param$22(3, IThemeService)], QuickPickItemElementRenderer);
var QuickPickSeparatorElementRenderer = class QuickPickSeparatorElementRenderer extends BaseQuickInputListRenderer {
	static {
		QuickPickSeparatorElementRenderer_1 = this;
	}
	static {
		this.ID = "quickpickseparator";
	}
	constructor(hoverDelegate, toggleStyles, contextMenuService) {
		super(hoverDelegate, toggleStyles, contextMenuService);
		this._visibleSeparatorsFrequency = /* @__PURE__ */ new Map();
	}
	get templateId() {
		return QuickPickSeparatorElementRenderer_1.ID;
	}
	get visibleSeparators() {
		return [...this._visibleSeparatorsFrequency.keys()];
	}
	isSeparatorVisible(separator) {
		return this._visibleSeparatorsFrequency.has(separator);
	}
	renderElement(node, index, data) {
		const element = node.element;
		data.element = element;
		element.element = data.entry ?? void 0;
		element.element.classList.toggle("focus-inside", !!element.focusInsideSeparator);
		const mainItem = element.separator;
		const { labelHighlights, descriptionHighlights } = element;
		data.icon.style.backgroundImage = "";
		data.icon.className = "";
		let descriptionTitle;
		if (!element.saneTooltip && element.saneDescription) descriptionTitle = {
			markdown: {
				value: escape$2(element.saneDescription),
				supportThemeIcons: true
			},
			markdownNotSupportedFallback: element.saneDescription
		};
		const options = {
			matches: labelHighlights || [],
			descriptionTitle,
			descriptionMatches: descriptionHighlights || [],
			labelEscapeNewLines: true
		};
		data.entry.classList.add("quick-input-list-separator-as-item");
		data.label.setLabel(element.saneLabel, element.saneDescription, options);
		data.separator.style.display = "none";
		data.entry.classList.add("quick-input-list-separator-border");
		const buttons = mainItem.buttons;
		if (buttons && buttons.length) {
			const { primary, secondary } = quickInputButtonsToActionArrays(buttons, "quick-input-separator", (button) => element.fireSeparatorButtonTriggered({
				button,
				separator: element.separator
			}));
			data.toolBar.setActions(primary, secondary);
			data.entry.classList.add("has-actions");
		} else {
			data.toolBar.setActions([]);
			data.entry.classList.remove("has-actions");
		}
		this.addSeparator(element);
	}
	disposeElement(element, _index, data) {
		this.removeSeparator(element.element);
		if (!this.isSeparatorVisible(element.element)) element.element.element?.classList.remove("focus-inside");
		super.disposeElement(element, _index, data);
	}
	addSeparator(separator) {
		this._visibleSeparatorsFrequency.set(separator, (this._visibleSeparatorsFrequency.get(separator) || 0) + 1);
	}
	removeSeparator(separator) {
		const frequency = this._visibleSeparatorsFrequency.get(separator) || 0;
		if (frequency > 1) this._visibleSeparatorsFrequency.set(separator, frequency - 1);
		else this._visibleSeparatorsFrequency.delete(separator);
	}
};
QuickPickSeparatorElementRenderer = QuickPickSeparatorElementRenderer_1 = __decorate$22([__param$22(2, IContextMenuService)], QuickPickSeparatorElementRenderer);
var QuickInputList = class QuickInputList extends Disposable {
	constructor(parent, hoverDelegate, linkOpenerDelegate, id, styles, instantiationService, accessibilityService) {
		super();
		this.parent = parent;
		this.hoverDelegate = hoverDelegate;
		this.linkOpenerDelegate = linkOpenerDelegate;
		this.styles = styles;
		this.accessibilityService = accessibilityService;
		this._onLeave = this._register(new Emitter$1());
		/**
		* Event that is fired when the tree would no longer have focus.
		*/
		this.onLeave = this._onLeave.event;
		this._visibleCountObservable = observableValue("VisibleCount", 0);
		this.onChangedVisibleCount = Event.fromObservable(this._visibleCountObservable, this._store);
		this._allVisibleCheckedObservable = observableValue("AllVisibleChecked", false);
		this.onChangedAllVisibleChecked = Event.fromObservable(this._allVisibleCheckedObservable, this._store);
		this._checkedCountObservable = observableValue("CheckedCount", 0);
		this.onChangedCheckedCount = Event.fromObservable(this._checkedCountObservable, this._store);
		this._checkedElementsObservable = observableValueOpts({ equalsFn: equals$1 }, new Array());
		this.onChangedCheckedElements = Event.fromObservable(this._checkedElementsObservable, this._store);
		this._onButtonTriggered = this._register(new Emitter$1());
		this.onButtonTriggered = this._onButtonTriggered.event;
		this._onSeparatorButtonTriggered = this._register(new Emitter$1());
		this.onSeparatorButtonTriggered = this._onSeparatorButtonTriggered.event;
		this._elementChecked = this._register(new Emitter$1());
		this._elementCheckedEventBufferer = new EventBufferer();
		this._hasCheckboxes = false;
		this._inputElements = new Array();
		this._elementTree = new Array();
		this._itemElements = new Array();
		this._elementDisposable = this._register(new DisposableStore());
		this._matchOnDescription = false;
		this._matchOnDetail = false;
		this._matchOnLabel = true;
		this._matchOnLabelMode = "fuzzy";
		this._sortByLabel = true;
		this._shouldLoop = true;
		this._container = append$2(this.parent, $$3(".quick-input-list"));
		this._separatorRenderer = this._register(instantiationService.createInstance(QuickPickSeparatorElementRenderer, hoverDelegate, this.styles.toggle));
		this._itemRenderer = this._register(instantiationService.createInstance(QuickPickItemElementRenderer, hoverDelegate, this.styles.toggle));
		this._tree = this._register(instantiationService.createInstance(WorkbenchObjectTree, "QuickInput", this._container, new QuickInputItemDelegate(), [this._itemRenderer, this._separatorRenderer], {
			filter: { filter(element) {
				return element.hidden ? 0 : element instanceof QuickPickSeparatorElement ? 2 : 1;
			} },
			sorter: { compare: (element, otherElement) => {
				if (!this.sortByLabel || !this._lastQueryString) return 0;
				return compareEntries(element, otherElement, this._lastQueryString.toLowerCase());
			} },
			accessibilityProvider: new QuickInputAccessibilityProvider(),
			setRowLineHeight: false,
			multipleSelectionSupport: false,
			hideTwistiesOfChildlessElements: true,
			renderIndentGuides: RenderIndentGuides.None,
			findWidgetEnabled: false,
			indent: 0,
			horizontalScrolling: false,
			allowNonCollapsibleParents: true,
			alwaysConsumeMouseWheel: true
		}));
		this._tree.getHTMLElement().id = id;
		this._register(this._itemRenderer.onDidDisposeFocusedElement(() => this._tree.domFocus()));
		this._register(this._separatorRenderer.onDidDisposeFocusedElement(() => this._tree.domFocus()));
		this._registerListeners();
	}
	get onDidChangeFocus() {
		return Event.map(this._tree.onDidChangeFocus, (e) => e.elements.filter((e) => e instanceof QuickPickItemElement).map((e) => e.item), this._store);
	}
	get onDidChangeSelection() {
		return Event.map(this._tree.onDidChangeSelection, (e) => ({
			items: e.elements.filter((e) => e instanceof QuickPickItemElement).map((e) => e.item),
			event: e.browserEvent
		}), this._store);
	}
	get displayed() {
		return this._container.style.display !== "none";
	}
	set displayed(value) {
		this._container.style.display = value ? "" : "none";
	}
	get scrollTop() {
		return this._tree.scrollTop;
	}
	set scrollTop(scrollTop) {
		this._tree.scrollTop = scrollTop;
	}
	get ariaLabel() {
		return this._tree.ariaLabel;
	}
	set ariaLabel(label) {
		this._tree.ariaLabel = label ?? "";
	}
	set enabled(value) {
		this._tree.getHTMLElement().style.pointerEvents = value ? "" : "none";
	}
	get matchOnDescription() {
		return this._matchOnDescription;
	}
	set matchOnDescription(value) {
		this._matchOnDescription = value;
	}
	get matchOnDetail() {
		return this._matchOnDetail;
	}
	set matchOnDetail(value) {
		this._matchOnDetail = value;
	}
	get matchOnLabel() {
		return this._matchOnLabel;
	}
	set matchOnLabel(value) {
		this._matchOnLabel = value;
	}
	get matchOnLabelMode() {
		return this._matchOnLabelMode;
	}
	set matchOnLabelMode(value) {
		this._matchOnLabelMode = value;
	}
	get sortByLabel() {
		return this._sortByLabel;
	}
	set sortByLabel(value) {
		this._sortByLabel = value;
	}
	get shouldLoop() {
		return this._shouldLoop;
	}
	set shouldLoop(value) {
		this._shouldLoop = value;
	}
	_registerListeners() {
		this._registerOnContainerClick();
		this._registerOnMouseMiddleClick();
		this._registerOnTreeModelChanged();
		this._registerOnElementChecked();
		this._registerOnContextMenu();
		this._registerHoverListeners();
		this._registerSelectionChangeListener();
		this._registerSeparatorActionShowingListeners();
	}
	_registerOnContainerClick() {
		this._register(addDisposableListener(this._container, EventType$1.CLICK, (e) => {
			if (e.x || e.y) this._onLeave.fire();
		}));
	}
	_registerOnMouseMiddleClick() {
		this._register(addDisposableListener(this._container, EventType$1.AUXCLICK, (e) => {
			if (e.button === 1) this._onLeave.fire();
		}));
	}
	_registerOnTreeModelChanged() {
		this._register(this._tree.onDidChangeModel(() => {
			const visibleCount = this._itemElements.filter((e) => !e.hidden).length;
			this._visibleCountObservable.set(visibleCount, void 0);
			if (this._hasCheckboxes) this._updateCheckedObservables();
		}));
	}
	_registerOnElementChecked() {
		this._register(this._elementCheckedEventBufferer.wrapEvent(this._elementChecked.event, (_, e) => e)((_) => this._updateCheckedObservables()));
	}
	_registerOnContextMenu() {
		this._register(this._tree.onContextMenu((e) => {
			if (e.element) {
				e.browserEvent.preventDefault();
				this._tree.setSelection([e.element]);
			}
		}));
	}
	_registerHoverListeners() {
		const delayer = this._register(new ThrottledDelayer(typeof this.hoverDelegate.delay === "function" ? this.hoverDelegate.delay() : this.hoverDelegate.delay));
		this._register(this._tree.onMouseOver(async (e) => {
			if (isHTMLAnchorElement(e.browserEvent.target)) {
				delayer.cancel();
				return;
			}
			if (!isHTMLAnchorElement(e.browserEvent.relatedTarget) && isAncestor$1(e.browserEvent.relatedTarget, e.element?.element)) return;
			try {
				await delayer.trigger(async () => {
					if (e.element instanceof QuickPickItemElement) this.showHover(e.element);
				});
			} catch (e) {
				if (!isCancellationError(e)) throw e;
			}
		}));
		this._register(this._tree.onMouseOut((e) => {
			if (isAncestor$1(e.browserEvent.relatedTarget, e.element?.element)) return;
			delayer.cancel();
		}));
	}
	/**
	* Register's focus change and mouse events so that we can track when items inside of a
	* separator's section are focused or hovered so that we can display the separator's actions
	*/
	_registerSeparatorActionShowingListeners() {
		this._register(this._tree.onDidChangeFocus((e) => {
			const parent = e.elements[0] ? this._tree.getParentElement(e.elements[0]) : null;
			for (const separator of this._separatorRenderer.visibleSeparators) {
				const value = separator === parent;
				if (!!(separator.focusInsideSeparator & QuickPickSeparatorFocusReason.ACTIVE_ITEM) !== value) {
					if (value) separator.focusInsideSeparator |= QuickPickSeparatorFocusReason.ACTIVE_ITEM;
					else separator.focusInsideSeparator &= ~QuickPickSeparatorFocusReason.ACTIVE_ITEM;
					this._tree.rerender(separator);
				}
			}
		}));
		this._register(this._tree.onMouseOver((e) => {
			const parent = e.element ? this._tree.getParentElement(e.element) : null;
			for (const separator of this._separatorRenderer.visibleSeparators) {
				if (separator !== parent) continue;
				if (!!!(separator.focusInsideSeparator & QuickPickSeparatorFocusReason.MOUSE_HOVER)) {
					separator.focusInsideSeparator |= QuickPickSeparatorFocusReason.MOUSE_HOVER;
					this._tree.rerender(separator);
				}
			}
		}));
		this._register(this._tree.onMouseOut((e) => {
			const parent = e.element ? this._tree.getParentElement(e.element) : null;
			for (const separator of this._separatorRenderer.visibleSeparators) {
				if (separator !== parent) continue;
				if (!!(separator.focusInsideSeparator & QuickPickSeparatorFocusReason.MOUSE_HOVER)) {
					separator.focusInsideSeparator &= ~QuickPickSeparatorFocusReason.MOUSE_HOVER;
					this._tree.rerender(separator);
				}
			}
		}));
	}
	_registerSelectionChangeListener() {
		this._register(this._tree.onDidChangeSelection((e) => {
			const elementsWithoutSeparators = e.elements.filter((e) => e instanceof QuickPickItemElement);
			if (elementsWithoutSeparators.length !== e.elements.length) {
				if (e.elements.length === 1 && e.elements[0] instanceof QuickPickSeparatorElement) {
					this._tree.setFocus([e.elements[0].children[0]]);
					this._tree.reveal(e.elements[0], 0);
				}
				this._tree.setSelection(elementsWithoutSeparators);
			}
		}));
	}
	setAllVisibleChecked(checked) {
		this._elementCheckedEventBufferer.bufferEvents(() => {
			this._itemElements.forEach((element) => {
				if (!element.hidden && !element.checkboxDisabled && element.item.pickable !== false) element.checked = checked;
			});
		});
	}
	setElements(inputElements) {
		this._elementDisposable.clear();
		this._lastQueryString = void 0;
		this._inputElements = inputElements;
		this._hasCheckboxes = this.parent.classList.contains("show-checkboxes");
		let currentSeparatorElement;
		this._itemElements = new Array();
		this._elementTree = inputElements.reduce((result, item, index) => {
			let element;
			if (item.type === "separator") {
				if (!item.buttons) return result;
				currentSeparatorElement = new QuickPickSeparatorElement(index, (e) => this._onSeparatorButtonTriggered.fire(e), item);
				element = currentSeparatorElement;
			} else {
				const previous = index > 0 ? inputElements[index - 1] : void 0;
				let separator;
				if (previous && previous.type === "separator" && !previous.buttons) separator = previous;
				const qpi = new QuickPickItemElement(index, currentSeparatorElement?.children ? currentSeparatorElement.children.length : index, this._hasCheckboxes && item.pickable !== false, (e) => this._onButtonTriggered.fire(e), this._elementChecked, item, separator);
				this._itemElements.push(qpi);
				if (currentSeparatorElement) {
					currentSeparatorElement.children.push(qpi);
					return result;
				}
				element = qpi;
			}
			result.push(element);
			return result;
		}, new Array());
		this._setElementsToTree(this._elementTree);
		if (this.accessibilityService.isScreenReaderOptimized()) disposableTimeout(() => {
			const focusedElement = this._tree.getHTMLElement().querySelector(`.monaco-list-row.focused`);
			const parent = focusedElement?.parentNode;
			if (focusedElement && parent) {
				const nextSibling = focusedElement.nextSibling;
				focusedElement.remove();
				parent.insertBefore(focusedElement, nextSibling);
			}
		}, 0, this._elementDisposable);
	}
	setFocusedElements(items) {
		const elements = items.map((item) => this._itemElements.find((e) => e.item === item)).filter((e) => !!e).filter((e) => !e.hidden);
		this._tree.setFocus(elements);
		if (items.length > 0) {
			const focused = this._tree.getFocus()[0];
			if (focused) this._tree.reveal(focused);
		}
	}
	getActiveDescendant() {
		return this._tree.getHTMLElement().getAttribute("aria-activedescendant");
	}
	setSelectedElements(items) {
		const elements = items.map((item) => this._itemElements.find((e) => e.item === item)).filter((e) => !!e);
		this._tree.setSelection(elements);
	}
	getCheckedElements() {
		return this._itemElements.filter((e) => e.checked).map((e) => e.item);
	}
	setCheckedElements(items) {
		this._elementCheckedEventBufferer.bufferEvents(() => {
			const checked = /* @__PURE__ */ new Set();
			for (const item of items) checked.add(item);
			for (const element of this._itemElements) element.checked = checked.has(element.item);
		});
	}
	focus(what) {
		if (!this._itemElements.length) return;
		if (what === QuickPickFocus.Second && this._itemElements.length < 2) what = QuickPickFocus.First;
		switch (what) {
			case QuickPickFocus.First:
				this._tree.scrollTop = 0;
				this._tree.focusFirst(void 0, (e) => e.element instanceof QuickPickItemElement);
				break;
			case QuickPickFocus.Second: {
				this._tree.scrollTop = 0;
				let isSecondItem = false;
				this._tree.focusFirst(void 0, (e) => {
					if (!(e.element instanceof QuickPickItemElement)) return false;
					if (isSecondItem) return true;
					isSecondItem = !isSecondItem;
					return false;
				});
				break;
			}
			case QuickPickFocus.Last:
				this._tree.scrollTop = this._tree.scrollHeight;
				this._tree.focusLast(void 0, (e) => e.element instanceof QuickPickItemElement);
				break;
			case QuickPickFocus.Next: {
				const prevFocus = this._tree.getFocus();
				this._tree.focusNext(void 0, this._shouldLoop, void 0, (e) => {
					if (!(e.element instanceof QuickPickItemElement)) return false;
					this._tree.reveal(e.element);
					return true;
				});
				const currentFocus = this._tree.getFocus();
				if (prevFocus.length && prevFocus[0] === currentFocus[0]) this._onLeave.fire();
				break;
			}
			case QuickPickFocus.Previous: {
				const prevFocus = this._tree.getFocus();
				this._tree.focusPrevious(void 0, this._shouldLoop, void 0, (e) => {
					if (!(e.element instanceof QuickPickItemElement)) return false;
					const parent = this._tree.getParentElement(e.element);
					if (parent === null || parent.children[0] !== e.element) this._tree.reveal(e.element);
					else this._tree.reveal(parent);
					return true;
				});
				const currentFocus = this._tree.getFocus();
				if (prevFocus.length && prevFocus[0] === currentFocus[0]) this._onLeave.fire();
				break;
			}
			case QuickPickFocus.NextPage:
				this._tree.focusNextPage(void 0, (e) => {
					if (!(e.element instanceof QuickPickItemElement)) return false;
					this._tree.reveal(e.element);
					return true;
				});
				break;
			case QuickPickFocus.PreviousPage:
				this._tree.focusPreviousPage(void 0, (e) => {
					if (!(e.element instanceof QuickPickItemElement)) return false;
					const parent = this._tree.getParentElement(e.element);
					if (parent === null || parent.children[0] !== e.element) this._tree.reveal(e.element);
					else this._tree.reveal(parent);
					return true;
				});
				break;
			case QuickPickFocus.NextSeparator: {
				let foundSeparatorAsItem = false;
				const before = this._tree.getFocus()[0];
				this._tree.focusNext(void 0, true, void 0, (e) => {
					if (foundSeparatorAsItem) return true;
					if (e.element instanceof QuickPickSeparatorElement) {
						foundSeparatorAsItem = true;
						if (this._separatorRenderer.isSeparatorVisible(e.element)) this._tree.reveal(e.element.children[0]);
						else this._tree.reveal(e.element, 0);
					} else if (e.element instanceof QuickPickItemElement) {
						if (e.element.separator) {
							if (this._itemRenderer.isItemWithSeparatorVisible(e.element)) this._tree.reveal(e.element);
							else this._tree.reveal(e.element, 0);
							return true;
						} else if (e.element === this._elementTree[0]) {
							this._tree.reveal(e.element, 0);
							return true;
						}
					}
					return false;
				});
				if (before === this._tree.getFocus()[0]) {
					this._tree.scrollTop = this._tree.scrollHeight;
					this._tree.focusLast(void 0, (e) => e.element instanceof QuickPickItemElement);
				}
				break;
			}
			case QuickPickFocus.PreviousSeparator: {
				let focusElement;
				let foundSeparator = !!this._tree.getFocus()[0]?.separator;
				this._tree.focusPrevious(void 0, true, void 0, (e) => {
					if (e.element instanceof QuickPickSeparatorElement) {
						if (foundSeparator) {
							if (!focusElement) {
								if (this._separatorRenderer.isSeparatorVisible(e.element)) this._tree.reveal(e.element);
								else this._tree.reveal(e.element, 0);
								focusElement = e.element.children[0];
							}
						} else foundSeparator = true;
					} else if (e.element instanceof QuickPickItemElement) {
						if (!focusElement) {
							if (e.element.separator) {
								if (this._itemRenderer.isItemWithSeparatorVisible(e.element)) this._tree.reveal(e.element);
								else this._tree.reveal(e.element, 0);
								focusElement = e.element;
							} else if (e.element === this._elementTree[0]) {
								this._tree.reveal(e.element, 0);
								return true;
							}
						}
					}
					return false;
				});
				if (focusElement) this._tree.setFocus([focusElement]);
				break;
			}
		}
	}
	clearFocus() {
		this._tree.setFocus([]);
	}
	domFocus() {
		this._tree.domFocus();
	}
	layout(maxHeight) {
		this._tree.getHTMLElement().style.maxHeight = maxHeight ? `${Math.floor(maxHeight / 44) * 44 + 6}px` : "";
		this._tree.layout();
	}
	filter(query) {
		this._lastQueryString = query;
		if (!(this._sortByLabel || this._matchOnLabel || this._matchOnDescription || this._matchOnDetail)) {
			this._tree.layout();
			return false;
		}
		const queryWithWhitespace = query;
		query = query.trim();
		if (!query || !(this.matchOnLabel || this.matchOnDescription || this.matchOnDetail)) this._itemElements.forEach((element) => {
			element.labelHighlights = void 0;
			element.descriptionHighlights = void 0;
			element.detailHighlights = void 0;
			element.hidden = false;
			const previous = element.index && this._inputElements[element.index - 1];
			if (element.item) element.separator = previous && previous.type === "separator" && !previous.buttons ? previous : void 0;
		});
		else {
			let currentSeparator;
			this._itemElements.forEach((element) => {
				let labelHighlights;
				if (this.matchOnLabelMode === "fuzzy") labelHighlights = this.matchOnLabel ? matchesFuzzyIconAware(query, parseLabelWithIcons(element.saneLabel)) ?? void 0 : void 0;
				else labelHighlights = this.matchOnLabel ? matchesContiguousIconAware(queryWithWhitespace, parseLabelWithIcons(element.saneLabel)) ?? void 0 : void 0;
				const descriptionHighlights = this.matchOnDescription ? matchesFuzzyIconAware(query, parseLabelWithIcons(element.saneDescription || "")) ?? void 0 : void 0;
				const detailHighlights = this.matchOnDetail ? matchesFuzzyIconAware(query, parseLabelWithIcons(element.saneDetail || "")) ?? void 0 : void 0;
				if (labelHighlights || descriptionHighlights || detailHighlights) {
					element.labelHighlights = labelHighlights;
					element.descriptionHighlights = descriptionHighlights;
					element.detailHighlights = detailHighlights;
					element.hidden = false;
				} else {
					element.labelHighlights = void 0;
					element.descriptionHighlights = void 0;
					element.detailHighlights = void 0;
					element.hidden = element.item ? !element.item.alwaysShow : true;
				}
				if (element.item) element.separator = void 0;
				else if (element.separator) element.hidden = true;
				if (!this.sortByLabel) {
					const previous = element.index && this._inputElements[element.index - 1] || void 0;
					if (previous?.type === "separator" && !previous.buttons) currentSeparator = previous;
					if (currentSeparator && !element.hidden) {
						element.separator = currentSeparator;
						currentSeparator = void 0;
					}
				}
			});
		}
		this._setElementsToTree(this._sortByLabel && query ? this._itemElements : this._elementTree);
		this._tree.layout();
		return true;
	}
	toggleCheckbox() {
		this._elementCheckedEventBufferer.bufferEvents(() => {
			const elements = this._tree.getFocus().filter((e) => e instanceof QuickPickItemElement);
			const allChecked = this._allVisibleChecked(elements);
			for (const element of elements) if (!element.checkboxDisabled) element.checked = !allChecked;
		});
	}
	style(styles) {
		this._tree.style(styles);
	}
	toggleHover() {
		const focused = this._tree.getFocus()[0];
		if (!focused?.saneTooltip || !(focused instanceof QuickPickItemElement)) return;
		if (this._lastHover && !this._lastHover.isDisposed) {
			this._lastHover.dispose();
			return;
		}
		this.showHover(focused);
		const store = new DisposableStore();
		store.add(this._tree.onDidChangeFocus((e) => {
			if (e.elements[0] instanceof QuickPickItemElement) this.showHover(e.elements[0]);
		}));
		if (this._lastHover) store.add(this._lastHover);
		this._elementDisposable.add(store);
	}
	_setElementsToTree(elements) {
		const treeElements = new Array();
		for (const element of elements) if (element instanceof QuickPickSeparatorElement) treeElements.push({
			element,
			collapsible: false,
			collapsed: false,
			children: element.children.map((e) => ({
				element: e,
				collapsible: false,
				collapsed: false
			}))
		});
		else treeElements.push({
			element,
			collapsible: false,
			collapsed: false
		});
		this._tree.setChildren(null, treeElements);
	}
	_allVisibleChecked(elements, whenNoneVisible = true) {
		for (let i = 0, n = elements.length; i < n; i++) {
			const element = elements[i];
			if (!element.hidden && element.item.pickable !== false) {
				if (!element.checked) return false;
				else whenNoneVisible = true;
			}
		}
		return whenNoneVisible;
	}
	_updateCheckedObservables() {
		transaction((tx) => {
			this._allVisibleCheckedObservable.set(this._allVisibleChecked(this._itemElements, false), tx);
			const checkedCount = this._itemElements.filter((element) => element.checked).length;
			this._checkedCountObservable.set(checkedCount, tx);
			this._checkedElementsObservable.set(this.getCheckedElements(), tx);
		});
	}
	/**
	* Disposes of the hover and shows a new one for the given index if it has a tooltip.
	* @param element The element to show the hover for
	*/
	showHover(element) {
		if (this._lastHover && !this._lastHover.isDisposed) {
			this.hoverDelegate.onDidHideHover?.();
			this._lastHover?.dispose();
		}
		if (!element.element || !element.saneTooltip) return;
		this._lastHover = this.hoverDelegate.showHover({
			content: element.saneTooltip,
			target: element.element,
			linkHandler: (url) => {
				this.linkOpenerDelegate(url);
			},
			appearance: { showPointer: true },
			container: this._container,
			position: { hoverPosition: 1 }
		}, false);
	}
};
__decorate$22([memoize], QuickInputList.prototype, "onDidChangeFocus", null);
__decorate$22([memoize], QuickInputList.prototype, "onDidChangeSelection", null);
QuickInputList = __decorate$22([__param$22(5, IInstantiationService), __param$22(6, IAccessibilityService)], QuickInputList);
function matchesContiguousIconAware(query, target) {
	const { text, iconOffsets } = target;
	if (!iconOffsets || iconOffsets.length === 0) return matchesContiguous(query, text);
	const wordToMatchAgainstWithoutIconsTrimmed = ltrim(text, " ");
	const leadingWhitespaceOffset = text.length - wordToMatchAgainstWithoutIconsTrimmed.length;
	const matches = matchesContiguous(query, wordToMatchAgainstWithoutIconsTrimmed);
	if (matches) for (const match of matches) {
		const iconOffset = iconOffsets[match.start + leadingWhitespaceOffset] + leadingWhitespaceOffset;
		match.start += iconOffset;
		match.end += iconOffset;
	}
	return matches;
}
function matchesContiguous(word, wordToMatchAgainst) {
	const matchIndex = wordToMatchAgainst.toLowerCase().indexOf(word.toLowerCase());
	if (matchIndex !== -1) return [{
		start: matchIndex,
		end: matchIndex + word.length
	}];
	return null;
}
function compareEntries(elementA, elementB, lookFor) {
	const labelHighlightsA = elementA.labelHighlights || [];
	const labelHighlightsB = elementB.labelHighlights || [];
	if (labelHighlightsA.length && !labelHighlightsB.length) return -1;
	if (!labelHighlightsA.length && labelHighlightsB.length) return 1;
	if (labelHighlightsA.length === 0 && labelHighlightsB.length === 0) return 0;
	return compareAnything(elementA.saneSortLabel, elementB.saneSortLabel, lookFor);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/quickinput/browser/quickInputActions.js
function registerQuickInputCommandAndKeybindingRule(rule, options = {}) {
	KeybindingsRegistry.registerCommandAndKeybindingRule({
		weight: 200,
		when: inQuickInputContext,
		metadata: { description: localize(1855, "Used while in the context of any kind of quick input. If you change one keybinding for this command, you should change all of the other keybindings (modifier variants) of this command as well.") },
		...rule,
		secondary: getSecondary(rule.primary, rule.secondary ?? [], options)
	});
}
function registerQuickPickCommandAndKeybindingRule(rule, options = {}) {
	KeybindingsRegistry.registerCommandAndKeybindingRule({
		weight: 200,
		when: ContextKeyExpr.and(ContextKeyExpr.or(ContextKeyExpr.equals(quickInputTypeContextKeyValue, "quickPick"), ContextKeyExpr.equals(quickInputTypeContextKeyValue, "quickTree")), inQuickInputContext),
		metadata: { description: localize(1856, "Used while in the context of the quick pick. If you change one keybinding for this command, you should change all of the other keybindings (modifier variants) of this command as well.") },
		...rule,
		secondary: getSecondary(rule.primary, rule.secondary ?? [], options)
	});
}
var ctrlKeyMod = isMacintosh ? 256 : 2048;
function getSecondary(primary, secondary, options = {}) {
	if (options.withAltMod) secondary.push(512 + primary);
	if (options.withCtrlMod) {
		secondary.push(ctrlKeyMod + primary);
		if (options.withAltMod) secondary.push(512 + ctrlKeyMod + primary);
	}
	if (options.withShiftMod) {
		secondary.push(1024 + primary);
		if (options.withAltMod) secondary.push(1536 + primary);
		if (options.withCtrlMod) {
			secondary.push(ctrlKeyMod + 1024 + primary);
			if (options.withAltMod) secondary.push(512 + ctrlKeyMod + 1024 + primary);
		}
	}
	if (options.withCmdMod && isMacintosh) {
		secondary.push(2048 + primary);
		if (options.withCtrlMod) secondary.push(2304 + primary);
		if (options.withAltMod) {
			secondary.push(2560 + primary);
			if (options.withCtrlMod) secondary.push(2816 + primary);
		}
	}
	return secondary;
}
function focusHandler(focus, focusOnQuickNatigate) {
	return (accessor) => {
		const currentQuickPick = accessor.get(IQuickInputService).currentQuickInput;
		if (!currentQuickPick) return;
		if (focusOnQuickNatigate && currentQuickPick.quickNavigate) return currentQuickPick.focus(focusOnQuickNatigate);
		return currentQuickPick.focus(focus);
	};
}
registerQuickPickCommandAndKeybindingRule({
	id: "quickInput.pageNext",
	primary: 12,
	handler: focusHandler(QuickPickFocus.NextPage)
}, {
	withAltMod: true,
	withCtrlMod: true,
	withCmdMod: true
});
registerQuickPickCommandAndKeybindingRule({
	id: "quickInput.pagePrevious",
	primary: 11,
	handler: focusHandler(QuickPickFocus.PreviousPage)
}, {
	withAltMod: true,
	withCtrlMod: true,
	withCmdMod: true
});
registerQuickPickCommandAndKeybindingRule({
	id: "quickInput.first",
	primary: ctrlKeyMod + 14,
	handler: focusHandler(QuickPickFocus.First)
}, {
	withAltMod: true,
	withCmdMod: true
});
registerQuickPickCommandAndKeybindingRule({
	id: "quickInput.last",
	primary: ctrlKeyMod + 13,
	handler: focusHandler(QuickPickFocus.Last)
}, {
	withAltMod: true,
	withCmdMod: true
});
registerQuickPickCommandAndKeybindingRule({
	id: "quickInput.next",
	primary: 18,
	handler: focusHandler(QuickPickFocus.Next)
}, { withCtrlMod: true });
registerQuickPickCommandAndKeybindingRule({
	id: "quickInput.previous",
	primary: 16,
	handler: focusHandler(QuickPickFocus.Previous)
}, { withCtrlMod: true });
var nextSeparatorFallbackDesc = localize(1857, "If we're in quick access mode, this will navigate to the next item. If we are not in quick access mode, this will navigate to the next separator.");
var prevSeparatorFallbackDesc = localize(1858, "If we're in quick access mode, this will navigate to the previous item. If we are not in quick access mode, this will navigate to the previous separator.");
if (isMacintosh) {
	registerQuickPickCommandAndKeybindingRule({
		id: "quickInput.nextSeparatorWithQuickAccessFallback",
		primary: 2066,
		handler: focusHandler(QuickPickFocus.NextSeparator, QuickPickFocus.Next),
		metadata: { description: nextSeparatorFallbackDesc }
	});
	registerQuickPickCommandAndKeybindingRule({
		id: "quickInput.nextSeparator",
		primary: 2578,
		secondary: [2322],
		handler: focusHandler(QuickPickFocus.NextSeparator)
	}, { withCtrlMod: true });
	registerQuickPickCommandAndKeybindingRule({
		id: "quickInput.previousSeparatorWithQuickAccessFallback",
		primary: 2064,
		handler: focusHandler(QuickPickFocus.PreviousSeparator, QuickPickFocus.Previous),
		metadata: { description: prevSeparatorFallbackDesc }
	});
	registerQuickPickCommandAndKeybindingRule({
		id: "quickInput.previousSeparator",
		primary: 2576,
		secondary: [2320],
		handler: focusHandler(QuickPickFocus.PreviousSeparator)
	}, { withCtrlMod: true });
} else {
	registerQuickPickCommandAndKeybindingRule({
		id: "quickInput.nextSeparatorWithQuickAccessFallback",
		primary: 530,
		handler: focusHandler(QuickPickFocus.NextSeparator, QuickPickFocus.Next),
		metadata: { description: nextSeparatorFallbackDesc }
	});
	registerQuickPickCommandAndKeybindingRule({
		id: "quickInput.nextSeparator",
		primary: 2578,
		handler: focusHandler(QuickPickFocus.NextSeparator)
	});
	registerQuickPickCommandAndKeybindingRule({
		id: "quickInput.previousSeparatorWithQuickAccessFallback",
		primary: 528,
		handler: focusHandler(QuickPickFocus.PreviousSeparator, QuickPickFocus.Previous),
		metadata: { description: prevSeparatorFallbackDesc }
	});
	registerQuickPickCommandAndKeybindingRule({
		id: "quickInput.previousSeparator",
		primary: 2576,
		handler: focusHandler(QuickPickFocus.PreviousSeparator)
	});
}
KeybindingsRegistry.registerCommandAndKeybindingRule({
	id: "quickInput.accept",
	primary: 3,
	weight: 200,
	when: ContextKeyExpr.and(ContextKeyExpr.notEquals(quickInputTypeContextKeyValue, "quickWidget"), inQuickInputContext),
	metadata: { description: localize(1859, "Used while in the context of some quick input. If you change one keybinding for this command, you should change all of the other keybindings (modifier variants) of this command as well.") },
	handler: (accessor) => {
		accessor.get(IQuickInputService).currentQuickInput?.accept();
	},
	secondary: getSecondary(3, [], {
		withAltMod: true,
		withCtrlMod: true,
		withCmdMod: true,
		withShiftMod: true
	})
});
registerQuickPickCommandAndKeybindingRule({
	id: "quickInput.acceptInBackground",
	when: ContextKeyExpr.and(inQuickInputContext, ContextKeyExpr.equals(quickInputTypeContextKeyValue, "quickPick"), ContextKeyExpr.or(InputFocusedContext.negate(), endOfQuickInputBoxContext)),
	primary: 17,
	weight: 250,
	handler: (accessor) => {
		accessor.get(IQuickInputService).currentQuickInput?.accept(true);
	}
}, {
	withAltMod: true,
	withCtrlMod: true,
	withCmdMod: true
});
registerQuickInputCommandAndKeybindingRule({
	id: "quickInput.hide",
	primary: 9,
	handler: (accessor) => {
		accessor.get(IQuickInputService).currentQuickInput?.hide();
	}
}, {
	withAltMod: true,
	withCtrlMod: true,
	withCmdMod: true
});
registerQuickPickCommandAndKeybindingRule({
	id: "quickInput.toggleCheckbox",
	when: ContextKeyExpr.and(inQuickInputContext, ContextKeyExpr.or(ContextKeyExpr.equals(quickInputTypeContextKeyValue, "quickPick"), ContextKeyExpr.equals(quickInputTypeContextKeyValue, "quickTree")), InputFocusedContext.negate()),
	primary: 10,
	handler: (accessor) => {
		accessor.get(IQuickInputService).toggle();
	}
});
registerQuickPickCommandAndKeybindingRule({
	id: "quickInput.toggleHover",
	primary: ctrlKeyMod | 10,
	handler: (accessor) => {
		accessor.get(IQuickInputService).toggleHover();
	}
});
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/quickinput/browser/tree/quickInputTreeRenderer.js
var __decorate$21 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$21 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var QuickInputTreeRenderer_1;
var $$2 = $$10;
var QuickInputCheckboxStateHandler = class extends Disposable {
	constructor() {
		super(...arguments);
		this._onDidChangeCheckboxState = this._register(new Emitter$1());
		this.onDidChangeCheckboxState = this._onDidChangeCheckboxState.event;
	}
	setCheckboxState(node, checked) {
		this._onDidChangeCheckboxState.fire({
			item: node,
			checked
		});
	}
};
var QuickInputTreeRenderer = class QuickInputTreeRenderer extends Disposable {
	static {
		QuickInputTreeRenderer_1 = this;
	}
	static {
		this.ID = "quickInputTreeElement";
	}
	constructor(_hoverDelegate, _buttonTriggeredEmitter, onCheckedEvent, _checkboxStateHandler, _toggleStyles, _contextMenuService, _themeService) {
		super();
		this._hoverDelegate = _hoverDelegate;
		this._buttonTriggeredEmitter = _buttonTriggeredEmitter;
		this.onCheckedEvent = onCheckedEvent;
		this._checkboxStateHandler = _checkboxStateHandler;
		this._toggleStyles = _toggleStyles;
		this._contextMenuService = _contextMenuService;
		this._themeService = _themeService;
		this.templateId = QuickInputTreeRenderer_1.ID;
		this._onDidDisposeFocusedElement = this._register(new Emitter$1());
		/**
		* This event is emitted when the renderer disposes an element that has focus.
		* This allows the list to re-focus itself and prevent focus from being lost
		* (potentially causing quickinput to dismiss itself) when an element is
		* removed while focused.
		*/
		this.onDidDisposeFocusedElement = this._onDidDisposeFocusedElement.event;
	}
	renderTemplate(container) {
		const store = new DisposableStore();
		const entry = append$2(container, $$2(".quick-input-tree-entry"));
		const checkbox = store.add(new TriStateCheckbox("", false, {
			...defaultCheckboxStyles,
			size: 15
		}));
		entry.appendChild(checkbox.domNode);
		const row1 = append$2(append$2(append$2(entry, $$2("label.quick-input-tree-label")), $$2(".quick-input-tree-rows")), $$2(".quick-input-tree-row"));
		const icon = prepend$2(row1, $$2(".quick-input-tree-icon"));
		const label = store.add(new IconLabel(row1, {
			supportHighlights: true,
			supportDescriptionHighlights: true,
			supportIcons: true,
			hoverDelegate: this._hoverDelegate
		}));
		const actionBar = store.add(new ToolBar(entry, this._contextMenuService, {
			actionViewItemProvider: createToggleActionViewItemProvider(this._toggleStyles),
			hoverDelegate: this._hoverDelegate,
			icon: true,
			label: false
		}));
		actionBar.getElement().classList.add("quick-input-tree-entry-action-bar");
		return {
			toDisposeTemplate: store,
			entry,
			checkbox,
			icon,
			label,
			actionBar,
			toDisposeElement: new DisposableStore()
		};
	}
	renderElement(node, _index, templateData, _details) {
		const store = templateData.toDisposeElement;
		const quickTreeItem = node.element;
		if (quickTreeItem.pickable === false) templateData.checkbox.domNode.style.display = "none";
		else {
			const checkbox = templateData.checkbox;
			checkbox.domNode.style.display = "";
			checkbox.checked = quickTreeItem.checked ?? false;
			store.add(Event.filter(this.onCheckedEvent, (e) => e.item === quickTreeItem)((e) => checkbox.checked = e.checked));
			if (quickTreeItem.disabled) checkbox.disable();
			store.add(checkbox.onChange((e) => this._checkboxStateHandler.setCheckboxState(quickTreeItem, checkbox.checked)));
		}
		if (quickTreeItem.iconPath) {
			const icon = isDark(this._themeService.getColorTheme().type) ? quickTreeItem.iconPath.dark : quickTreeItem.iconPath.light ?? quickTreeItem.iconPath.dark;
			const iconUrl = URI.revive(icon);
			templateData.icon.className = "quick-input-tree-icon";
			templateData.icon.style.backgroundImage = asCSSUrl(iconUrl);
		} else {
			templateData.icon.style.backgroundImage = "";
			templateData.icon.className = quickTreeItem.iconClass ? `quick-input-tree-icon ${quickTreeItem.iconClass}` : "";
		}
		templateData.icon.style.color = quickTreeItem.iconColor ? asCssVariable(quickTreeItem.iconColor.id) : "";
		const { labelHighlights: matches, descriptionHighlights: descriptionMatches } = node.filterData || {};
		let descriptionTitle;
		if (quickTreeItem.description) descriptionTitle = {
			markdown: {
				value: escape$2(quickTreeItem.description),
				supportThemeIcons: true
			},
			markdownNotSupportedFallback: quickTreeItem.description
		};
		templateData.label.setLabel(quickTreeItem.label, quickTreeItem.description, {
			matches,
			descriptionMatches,
			extraClasses: quickTreeItem.iconClasses,
			italic: quickTreeItem.italic,
			strikethrough: quickTreeItem.strikethrough,
			labelEscapeNewLines: true,
			descriptionTitle
		});
		const buttons = quickTreeItem.buttons;
		if (buttons && buttons.length) {
			const { primary, secondary } = quickInputButtonsToActionArrays(buttons, "quick-input-tree", (button) => this._buttonTriggeredEmitter.fire({
				item: quickTreeItem,
				button
			}));
			templateData.actionBar.setActions(primary, secondary);
			templateData.entry.classList.add("has-actions");
		} else {
			templateData.actionBar.setActions([]);
			templateData.entry.classList.remove("has-actions");
		}
	}
	disposeElement(_element, _index, templateData, _details) {
		if (isAncestorOfActiveElement(templateData.entry)) this._onDidDisposeFocusedElement.fire();
		templateData.toDisposeElement.clear();
		templateData.actionBar.setActions([]);
	}
	disposeTemplate(templateData) {
		templateData.toDisposeElement.dispose();
		templateData.toDisposeTemplate.dispose();
	}
};
QuickInputTreeRenderer = QuickInputTreeRenderer_1 = __decorate$21([__param$21(5, IContextMenuService), __param$21(6, IThemeService)], QuickInputTreeRenderer);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/quickinput/browser/tree/quickInputDelegate.js
/**
* Delegate for QuickInputTree that provides height and template information.
*/
var QuickInputTreeDelegate = class {
	getHeight(_element) {
		return 22;
	}
	getTemplateId(_element) {
		return QuickInputTreeRenderer.ID;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/quickinput/browser/tree/quickInputTree.js
function getParentNodeState(parentChildren) {
	let containsChecks = false;
	let containsUnchecks = false;
	let containsMixed = false;
	for (const element of parentChildren) {
		switch (element.element?.checked) {
			case "mixed":
				containsMixed = true;
				break;
			case true:
				containsChecks = true;
				break;
			default: containsUnchecks = true;
		}
		if (containsChecks && containsUnchecks && containsMixed) break;
	}
	return containsUnchecks ? containsMixed ? "mixed" : containsChecks ? "mixed" : false : containsMixed ? "mixed" : containsChecks;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/quickinput/browser/tree/quickInputTreeAccessibilityProvider.js
/**
* Accessibility provider for QuickTree.
*/
var QuickTreeAccessibilityProvider = class {
	constructor(onCheckedEvent) {
		this.onCheckedEvent = onCheckedEvent;
	}
	getWidgetAriaLabel() {
		return localize(1869, "Quick Tree");
	}
	getAriaLabel(element) {
		return element.ariaLabel || [element.label, element.description].map((s) => getCodiconAriaLabel(s)).filter((s) => !!s).join(", ");
	}
	getWidgetRole() {
		return "tree";
	}
	getRole(_element) {
		return "checkbox";
	}
	isChecked(element) {
		return {
			get value() {
				return element.checked === "mixed" ? "mixed" : !!element.checked;
			},
			onDidChange: (e) => Event.filter(this.onCheckedEvent, (e) => e.item === element)((_) => e())
		};
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/quickinput/browser/tree/quickInputTreeFilter.js
var QuickInputTreeFilter = class {
	constructor() {
		this.filterValue = "";
		this.matchOnLabel = true;
		this.matchOnDescription = false;
	}
	filter(element, parentVisibility) {
		if (!this.filterValue || !(this.matchOnLabel || this.matchOnDescription)) return element.children ? {
			visibility: 2,
			data: {}
		} : {
			visibility: 1,
			data: {}
		};
		const labelHighlights = this.matchOnLabel ? matchesFuzzyIconAware(this.filterValue, parseLabelWithIcons(element.label)) ?? void 0 : void 0;
		const descriptionHighlights = this.matchOnDescription ? matchesFuzzyIconAware(this.filterValue, parseLabelWithIcons(element.description || "")) ?? void 0 : void 0;
		return {
			visibility: parentVisibility === 1 ? 1 : labelHighlights || descriptionHighlights ? 1 : element.children ? 2 : 0,
			data: {
				labelHighlights,
				descriptionHighlights
			}
		};
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/quickinput/browser/tree/quickInputTreeSorter.js
var QuickInputTreeSorter = class extends Disposable {
	constructor() {
		super(...arguments);
		this._sortByLabel = true;
	}
	get sortByLabel() {
		return this._sortByLabel;
	}
	set sortByLabel(value) {
		this._sortByLabel = value;
	}
	compare(a, b) {
		if (!this._sortByLabel) return 0;
		if (a.label < b.label) return -1;
		else if (a.label > b.label) return 1;
		if (a.description && b.description) {
			if (a.description < b.description) return -1;
			else if (a.description > b.description) return 1;
		} else if (a.description) return -1;
		else if (b.description) return 1;
		return 0;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/quickinput/browser/tree/quickInputTreeController.js
var __decorate$20 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$20 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var $$1 = $$10;
var flatHierarchyClass = "quick-input-tree-flat";
var QuickInputTreeIdentityProvider = class {
	constructor() {
		this._elementIds = /* @__PURE__ */ new WeakMap();
		this._counter = 0;
	}
	getId(element) {
		let id = element.id;
		if (id !== void 0) return id;
		id = this._elementIds.get(element);
		if (id !== void 0) return id;
		id = `__generated_${this._counter++}`;
		this._elementIds.set(element, id);
		return id;
	}
};
var QuickInputTreeController = class QuickInputTreeController extends Disposable {
	constructor(container, hoverDelegate, styles, instantiationService) {
		super();
		this.instantiationService = instantiationService;
		this._onDidTriggerButton = this._register(new Emitter$1());
		this._onDidChangeCheckboxState = this._register(new Emitter$1());
		this.onDidChangeCheckboxState = this._onDidChangeCheckboxState.event;
		this._onDidCheckedLeafItemsChange = this._register(new Emitter$1());
		this.onDidChangeCheckedLeafItems = this._onDidCheckedLeafItemsChange.event;
		this._onLeave = this._register(new Emitter$1());
		/**
		* Event that is fired when the tree would no longer have focus.
		*/
		this.onLeave = this._onLeave.event;
		this._onDidAccept = this._register(new Emitter$1());
		/**
		* Event that is fired when a non-pickable item is clicked, indicating acceptance.
		*/
		this.onDidAccept = this._onDidAccept.event;
		this._container = append$2(container, $$1(".quick-input-tree"));
		this._checkboxStateHandler = this._register(new QuickInputCheckboxStateHandler());
		this._renderer = this._register(this.instantiationService.createInstance(QuickInputTreeRenderer, hoverDelegate, this._onDidTriggerButton, this.onDidChangeCheckboxState, this._checkboxStateHandler, styles.toggle));
		this._filter = this.instantiationService.createInstance(QuickInputTreeFilter);
		this._sorter = this._register(new QuickInputTreeSorter());
		this._tree = this._register(this.instantiationService.createInstance(WorkbenchObjectTree, "QuickInputTree", this._container, new QuickInputTreeDelegate(), [this._renderer], {
			accessibilityProvider: new QuickTreeAccessibilityProvider(this.onDidChangeCheckboxState),
			horizontalScrolling: false,
			multipleSelectionSupport: false,
			findWidgetEnabled: false,
			alwaysConsumeMouseWheel: true,
			hideTwistiesOfChildlessElements: true,
			renderIndentGuides: RenderIndentGuides.None,
			expandOnDoubleClick: true,
			expandOnlyOnTwistieClick: true,
			disableExpandOnSpacebar: true,
			sorter: this._sorter,
			filter: this._filter,
			identityProvider: new QuickInputTreeIdentityProvider()
		}));
		this._register(this._renderer.onDidDisposeFocusedElement(() => {
			this._tree.domFocus();
		}));
		this.registerCheckboxStateListeners();
		this.registerOnDidChangeFocus();
	}
	get tree() {
		return this._tree;
	}
	get displayed() {
		return this._container.style.display !== "none";
	}
	set displayed(value) {
		this._container.style.display = value ? "" : "none";
	}
	get sortByLabel() {
		return this._sorter.sortByLabel;
	}
	set sortByLabel(value) {
		this._sorter.sortByLabel = value;
		this._tree.resort(null, true);
	}
	getActiveDescendant() {
		return this._tree.getHTMLElement().getAttribute("aria-activedescendant");
	}
	filter(input) {
		this._filter.filterValue = input;
		this._tree.refilter();
	}
	updateFilterOptions(options) {
		if (options.matchOnLabel !== void 0) this._filter.matchOnLabel = options.matchOnLabel;
		if (options.matchOnDescription !== void 0) this._filter.matchOnDescription = options.matchOnDescription;
		this._tree.refilter();
	}
	setTreeData(treeData) {
		let hasNestedItems = false;
		const createTreeElement = (item) => {
			let children;
			if (item.children && item.children.length > 0) {
				hasNestedItems = true;
				children = item.children.map((child) => createTreeElement(child));
				item.checked = getParentNodeState(children);
			}
			return {
				element: item,
				children,
				collapsible: !!children,
				collapsed: item.collapsed ? ObjectTreeElementCollapseState.PreserveOrCollapsed : ObjectTreeElementCollapseState.PreserveOrExpanded
			};
		};
		const treeElements = treeData.map((item) => createTreeElement(item));
		this._tree.setChildren(null, treeElements);
		this._container.classList.toggle(flatHierarchyClass, !hasNestedItems);
	}
	layout(maxHeight) {
		this._tree.getHTMLElement().style.maxHeight = maxHeight ? `${Math.floor(maxHeight / 44) * 44 + 6}px` : "";
		this._tree.layout();
	}
	focus(what) {
		switch (what) {
			case QuickPickFocus.First:
				this._tree.scrollTop = 0;
				this._tree.focusFirst();
				break;
			case QuickPickFocus.Second: {
				this._tree.scrollTop = 0;
				let isSecondItem = false;
				this._tree.focusFirst(void 0, (e) => {
					if (isSecondItem) return true;
					isSecondItem = !isSecondItem;
					return false;
				});
				break;
			}
			case QuickPickFocus.Last:
				this._tree.scrollTop = this._tree.scrollHeight;
				this._tree.focusLast();
				break;
			case QuickPickFocus.Next: {
				const prevFocus = this._tree.getFocus();
				this._tree.focusNext(void 0, false, void 0, (e) => {
					this._tree.reveal(e.element);
					return true;
				});
				const currentFocus = this._tree.getFocus();
				if (prevFocus.length && prevFocus[0] === currentFocus[0]) this._onLeave.fire();
				break;
			}
			case QuickPickFocus.Previous: {
				const prevFocus = this._tree.getFocus();
				this._tree.focusPrevious(void 0, false, void 0, (e) => {
					this._tree.reveal(e.element);
					return true;
				});
				const currentFocus = this._tree.getFocus();
				if (prevFocus.length && prevFocus[0] === currentFocus[0]) this._onLeave.fire();
				break;
			}
			case QuickPickFocus.NextPage:
				this._tree.focusNextPage(void 0, (e) => {
					this._tree.reveal(e.element);
					return true;
				});
				break;
			case QuickPickFocus.PreviousPage:
				this._tree.focusPreviousPage(void 0, (e) => {
					this._tree.reveal(e.element);
					return true;
				});
				break;
			case QuickPickFocus.NextSeparator:
			case QuickPickFocus.PreviousSeparator: return;
		}
	}
	registerCheckboxStateListeners() {
		this._register(this._tree.onDidOpen((e) => {
			const item = e.element;
			if (!item) return;
			if (item.disabled) return;
			if (item.pickable === false) {
				this._tree.setFocus([item]);
				this._onDidAccept.fire();
				return;
			}
			const target = e.browserEvent?.target;
			if (target && target.classList.contains(Checkbox.CLASS_NAME)) return;
			this.updateCheckboxState(item, item.checked === true);
		}));
		this._register(this._checkboxStateHandler.onDidChangeCheckboxState((e) => {
			this.updateCheckboxState(e.item, e.checked === true, true);
			this._tree.setFocus([e.item]);
			this._tree.setSelection([e.item]);
		}));
	}
	updateCheckboxState(item, newState, skipItemRerender = false) {
		if ((item.checked ?? false) === newState) return;
		item.checked = newState;
		if (!skipItemRerender) this._tree.rerender(item);
		const updateSet = /* @__PURE__ */ new Set();
		const toUpdate = [...this._tree.getNode(item).children];
		while (toUpdate.length) {
			const pop = toUpdate.shift();
			if (pop?.element && !updateSet.has(pop.element)) {
				updateSet.add(pop.element);
				if ((pop.element.checked ?? false) !== item.checked) {
					pop.element.checked = item.checked;
					this._tree.rerender(pop.element);
				}
				toUpdate.push(...pop.children);
			}
		}
		let parent = this._tree.getParentElement(item);
		while (parent) {
			const newState = getParentNodeState([...this._tree.getNode(parent).children]);
			if ((parent.checked ?? false) !== newState) {
				parent.checked = newState;
				this._tree.rerender(parent);
			}
			parent = this._tree.getParentElement(parent);
		}
		this._onDidChangeCheckboxState.fire({
			item,
			checked: item.checked ?? false
		});
		this._onDidCheckedLeafItemsChange.fire(this.getCheckedLeafItems());
	}
	registerOnDidChangeFocus() {
		this._register(this._tree.onDidChangeFocus((e) => {
			const item = this._tree.getFocus().findLast((item) => item !== null);
			this._tree.setSelection(item ? [item] : [], e.browserEvent);
		}));
	}
	getCheckedLeafItems() {
		const lookedAt = /* @__PURE__ */ new Set();
		const toLookAt = [...this._tree.getNode().children];
		const checkedItems = new Array();
		while (toLookAt.length) {
			const lookAt = toLookAt.shift();
			if (!lookAt?.element || lookedAt.has(lookAt.element)) continue;
			if (lookAt.element.checked) {
				lookedAt.add(lookAt.element);
				toLookAt.push(...lookAt.children);
				if (!lookAt.element.children) checkedItems.push(lookAt.element);
			}
		}
		return checkedItems;
	}
	getActiveItems() {
		return this._tree.getFocus().filter((item) => item !== null);
	}
	toggleCheckbox() {
		for (const element of this.getActiveItems()) if (element.pickable !== false && !element.disabled) this.updateCheckboxState(element, !(element.checked === true));
	}
	checkAll(checked) {
		const updated = /* @__PURE__ */ new Set();
		const toUpdate = [...this._tree.getNode().children];
		let fireCheckedChangeEvent = false;
		while (toUpdate.length) {
			const update = toUpdate.shift();
			if (!update?.element || updated.has(update.element)) continue;
			if (update.element.checked !== checked) {
				fireCheckedChangeEvent = true;
				update.element.checked = checked;
				toUpdate.push(...update.children);
				updated.add(update.element);
				this._tree.rerender(update.element);
				this._onDidChangeCheckboxState.fire({
					item: update.element,
					checked: update.element.checked
				});
			}
		}
		if (fireCheckedChangeEvent) this._onDidCheckedLeafItemsChange.fire(this.getCheckedLeafItems());
	}
};
QuickInputTreeController = __decorate$20([__param$20(3, IInstantiationService)], QuickInputTreeController);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/quickinput/browser/tree/quickTree.js
var QuickTree = class QuickTree extends QuickInput {
	static {
		this.DEFAULT_ARIA_LABEL = localize(1870, "Type to narrow down results.");
	}
	constructor(ui) {
		super(ui);
		this.type = "quickTree";
		this._value = observableValue("value", "");
		this._ariaLabel = observableValue("ariaLabel", void 0);
		this._placeholder = observableValue("placeholder", void 0);
		this._matchOnDescription = observableValue("matchOnDescription", false);
		this._matchOnLabel = observableValue("matchOnLabel", true);
		this._sortByLabel = observableValue("sortByLabel", true);
		this._activeItems = observableValue("activeItems", []);
		this._itemTree = observableValue("itemTree", []);
		this._onDidChangeCheckedLeafItems = this._register(new Emitter$1());
		this._onDidChangeCheckboxState = this._register(new Emitter$1());
		this._onDidAcceptEmitter = this._register(new Emitter$1());
		this.onDidAccept = Event.any(ui.onDidAccept, this._onDidAcceptEmitter.event);
		this._registerAutoruns();
		this._register(ui.tree.onDidChangeCheckedLeafItems((e) => this._onDidChangeCheckedLeafItems.fire(e)));
		this._register(ui.tree.onDidChangeCheckboxState((e) => this._onDidChangeCheckboxState.fire(e.item)));
		this._register(ui.tree.tree.onDidChangeFocus((e) => {
			this._activeItems.set(ui.tree.getActiveItems(), void 0);
		}));
	}
	get placeholder() {
		return this._placeholder.get();
	}
	set placeholder(placeholder) {
		this._placeholder.set(placeholder, void 0);
	}
	show() {
		if (!this.visible) {
			const visibilities = {
				title: !!this.title || !!this.step || !!this.titleButtons.length,
				description: !!this.description,
				checkAll: true,
				checkBox: true,
				inputBox: true,
				progressBar: true,
				visibleCount: true,
				count: true,
				ok: true,
				list: false,
				tree: true,
				message: !!this.validationMessage,
				customButton: false
			};
			this.ui.setVisibilities(visibilities);
			this.visibleDisposables.add(this.ui.inputBox.onDidChange((value) => {
				this._value.set(value, void 0);
			}));
			this.visibleDisposables.add(this.ui.tree.onDidChangeCheckboxState((e) => {
				const checkAllState = getParentNodeState([...this.ui.tree.tree.getNode().children]);
				if (this.ui.checkAll.checked !== checkAllState) this.ui.checkAll.checked = checkAllState;
			}));
			this.visibleDisposables.add(this.ui.checkAll.onChange((_e) => {
				const checked = this.ui.checkAll.checked;
				this.ui.tree.checkAll(checked);
			}));
			this.visibleDisposables.add(this.ui.tree.onDidChangeCheckedLeafItems((e) => {
				this.ui.count.setCount(e.length);
			}));
		}
		super.show();
		setTimeout0(() => this.ui.count.setCount(this.ui.tree.getCheckedLeafItems().length));
		const checkAllState = getParentNodeState([...this.ui.tree.tree.getNode().children]);
		if (this.ui.checkAll.checked !== checkAllState) this.ui.checkAll.checked = checkAllState;
	}
	update() {
		if (!this.visible) return;
		const visibilities = {
			title: !!this.title || !!this.step || !!this.titleButtons.length,
			description: !!this.description,
			checkAll: true,
			checkBox: true,
			inputBox: true,
			progressBar: true,
			visibleCount: true,
			count: true,
			ok: true,
			tree: true,
			message: !!this.validationMessage
		};
		this.ui.setVisibilities(visibilities);
		super.update();
	}
	_registerAutoruns() {
		this.registerVisibleAutorun((reader) => {
			const value = this._value.read(reader);
			this.ui.inputBox.value = value;
			this.ui.tree.filter(value);
		});
		this.registerVisibleAutorun((reader) => {
			let ariaLabel = this._ariaLabel.read(reader);
			if (!ariaLabel) {
				ariaLabel = this.placeholder || QuickTree.DEFAULT_ARIA_LABEL;
				if (this.title) ariaLabel += ` - ${this.title}`;
			}
			if (this.ui.list.ariaLabel !== ariaLabel) this.ui.list.ariaLabel = ariaLabel ?? null;
			if (this.ui.inputBox.ariaLabel !== ariaLabel) this.ui.inputBox.ariaLabel = ariaLabel ?? "input";
		});
		this.registerVisibleAutorun((reader) => {
			const placeholder = this._placeholder.read(reader);
			if (this.ui.inputBox.placeholder !== placeholder) this.ui.inputBox.placeholder = placeholder ?? "";
		});
		this.registerVisibleAutorun((reader) => {
			const matchOnLabel = this._matchOnLabel.read(reader);
			const matchOnDescription = this._matchOnDescription.read(reader);
			this.ui.tree.updateFilterOptions({
				matchOnLabel,
				matchOnDescription
			});
		});
		this.registerVisibleAutorun((reader) => {
			const sortByLabel = this._sortByLabel.read(reader);
			this.ui.tree.sortByLabel = sortByLabel;
		});
		this.registerVisibleAutorun((reader) => {
			const itemTree = this._itemTree.read(reader);
			this.ui.tree.setTreeData(itemTree);
		});
	}
	registerVisibleAutorun(fn) {
		this._register(autorun((reader) => {
			if (this._visible.read(reader)) fn(reader);
		}));
	}
	focus(focus) {
		this.ui.tree.focus(focus);
		this.ui.tree.tree.domFocus();
	}
	/**
	* Programmatically accepts an item. Used internally for keyboard navigation.
	* @param inBackground Whether you are accepting an item in the background and keeping the picker open.
	*/
	accept(_inBackground) {
		this._onDidAcceptEmitter.fire();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/quickinput/browser/quickInputController.js
var __decorate$19 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$19 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var QuickInputController_1;
var $ = $$10;
var VIEWSTATE_STORAGE_KEY = "workbench.quickInput.viewState";
var QUICK_INPUT_MOTION_CLOSING_CLASS = "quick-input-widget-closing";
var QUICK_INPUT_OVERLAY_CLASS = "quick-input-widget-overlay";
var QUICK_INPUT_CLOSE_ANIMATION_DURATION = 150;
var QUICK_INPUT_MOTION_ANCESTOR_CLASSES = ["modern-ui", "monaco-enable-motion"];
var QuickInputController = class QuickInputController extends Disposable {
	static {
		QuickInputController_1 = this;
	}
	static {
		this.MAX_WIDTH = 600;
	}
	get currentQuickInput() {
		return this.controller ?? void 0;
	}
	get container() {
		return this._container;
	}
	constructor(options, layoutService, instantiationService, contextKeyService, storageService, contextMenuService) {
		super();
		this.options = options;
		this.layoutService = layoutService;
		this.instantiationService = instantiationService;
		this.storageService = storageService;
		this.contextMenuService = contextMenuService;
		this.enabled = true;
		this.onDidAcceptEmitter = this._register(new Emitter$1());
		this.onDidCustomEmitter = this._register(new Emitter$1());
		this.onDidTriggerButtonEmitter = this._register(new Emitter$1());
		this.keyMods = {
			ctrlCmd: false,
			alt: false,
			shift: false
		};
		this.controller = null;
		this.onShowEmitter = this._register(new Emitter$1());
		this.onShow = this.onShowEmitter.event;
		this.onHideEmitter = this._register(new Emitter$1());
		this.onHide = this.onHideEmitter.event;
		this.closeAnimation = this._register(new MutableDisposable());
		this._alignment = observableValue(this, "top");
		this.alignment = this._alignment;
		this.inQuickInputContext = InQuickInputContextKey.bindTo(contextKeyService);
		this.quickInputTypeContext = QuickInputTypeContextKey.bindTo(contextKeyService);
		this.endOfQuickInputBoxContext = EndOfQuickInputBoxContextKey.bindTo(contextKeyService);
		this.idPrefix = options.idPrefix;
		this._container = options.container;
		this.styles = options.styles;
		this._register(Event.runAndSubscribe(onDidRegisterWindow, ({ window, disposables }) => this.registerKeyModsListeners(window, disposables), {
			window: mainWindow,
			disposables: this._store
		}));
		this._register(onWillUnregisterWindow((window) => {
			if (this.ui && getWindow(this.ui.container) === window) {
				this.reparentUI(this.layoutService.mainContainer);
				this.layout(this.layoutService.mainContainerDimension, this.layoutService.mainContainerOffset.quickPickTop);
			}
		}));
		this.viewState = this.loadViewState();
	}
	registerKeyModsListeners(window, disposables) {
		const listener = (e) => {
			this.keyMods.ctrlCmd = e.ctrlKey || e.metaKey;
			this.keyMods.alt = e.altKey;
			this.keyMods.shift = e.shiftKey;
		};
		for (const event of [
			EventType$1.KEY_DOWN,
			EventType$1.KEY_UP,
			EventType$1.MOUSE_DOWN
		]) disposables.add(addDisposableListener(window, event, listener, true));
	}
	getUI(showInActiveContainer) {
		if (this.ui) {
			if (showInActiveContainer) {
				if (getWindow(this._container) !== getWindow(this.layoutService.activeContainer)) {
					this.reparentUI(this.layoutService.activeContainer);
					this.layout(this.layoutService.activeContainerDimension, this.layoutService.activeContainerOffset.quickPickTop);
				}
			}
			return this.ui;
		}
		const container = append$2(this._container, $(".quick-input-widget.show-file-icons"));
		container.tabIndex = -1;
		container.style.display = "none";
		const styleSheet = createStyleSheet(container);
		const titleBar = append$2(container, $(".quick-input-titlebar"));
		const leftActionBar = this._register(new ToolBar(titleBar, this.contextMenuService, {
			hoverDelegate: this.options.hoverDelegate,
			actionViewItemProvider: createToggleActionViewItemProvider(this.styles.toggle),
			icon: true,
			label: false
		}));
		leftActionBar.getElement().classList.add("quick-input-left-action-bar");
		const title = append$2(titleBar, $(".quick-input-title"));
		const rightActionBar = this._register(new ToolBar(titleBar, this.contextMenuService, {
			hoverDelegate: this.options.hoverDelegate,
			actionViewItemProvider: createToggleActionViewItemProvider(this.styles.toggle),
			icon: true,
			label: false
		}));
		rightActionBar.getElement().classList.add("quick-input-right-action-bar");
		const headerContainer = append$2(container, $(".quick-input-header"));
		const checkAll = this._register(new TriStateCheckbox(localize(1860, "Toggle all checkboxes"), false, {
			...defaultCheckboxStyles,
			size: 15
		}));
		append$2(headerContainer, checkAll.domNode);
		this._register(checkAll.onChange(() => {
			const checked = checkAll.checked;
			list.setAllVisibleChecked(checked === true);
		}));
		this._register(addDisposableListener(checkAll.domNode, EventType$1.CLICK, (e) => {
			if (e.x || e.y) inputBox.setFocus();
		}));
		const description2 = append$2(headerContainer, $(".quick-input-description"));
		const inputContainer = append$2(headerContainer, $(".quick-input-and-message"));
		const filterContainer = append$2(inputContainer, $(".quick-input-filter"));
		const inputBox = this._register(new QuickInputBox(filterContainer, this.styles.inputBox, this.styles.toggle));
		inputBox.setAttribute("aria-describedby", `${this.idPrefix}message`);
		const visibleCountContainer = append$2(filterContainer, $(".quick-input-visible-count"));
		visibleCountContainer.setAttribute("aria-live", "polite");
		visibleCountContainer.setAttribute("aria-atomic", "true");
		const visibleCount = this._register(new CountBadge(visibleCountContainer, { countFormat: localize(1861, "{0} Results") }, this.styles.countBadge));
		const countContainer = append$2(filterContainer, $(".quick-input-count"));
		countContainer.setAttribute("aria-live", "polite");
		const count = this._register(new CountBadge(countContainer, { countFormat: localize(1862, "{0} Selected") }, this.styles.countBadge));
		const inlineActionBar = this._register(new ToolBar(headerContainer, this.contextMenuService, {
			hoverDelegate: this.options.hoverDelegate,
			actionViewItemProvider: createToggleActionViewItemProvider(this.styles.toggle),
			icon: true,
			label: false
		}));
		inlineActionBar.getElement().classList.add("quick-input-inline-action-bar");
		const okContainer = append$2(headerContainer, $(".quick-input-action"));
		const ok = this._register(new Button(okContainer, this.styles.button));
		ok.label = localize(1863, "OK");
		this._register(ok.onDidClick((e) => {
			this.onDidAcceptEmitter.fire();
		}));
		const customButtonContainer = append$2(headerContainer, $(".quick-input-action"));
		const customButton = this._register(new Button(customButtonContainer, {
			...this.styles.button,
			supportIcons: true
		}));
		customButton.label = localize(1864, "Custom");
		this._register(customButton.onDidClick((e) => {
			this.onDidCustomEmitter.fire();
		}));
		const message = append$2(inputContainer, $(`#${this.idPrefix}message.quick-input-message`));
		const progressBar = this._register(new ProgressBar(container, this.styles.progressBar));
		progressBar.getContainer().classList.add("quick-input-progress");
		const widget = append$2(container, $(".quick-input-html-widget"));
		widget.tabIndex = -1;
		const description1 = append$2(container, $(".quick-input-description"));
		const listId = this.idPrefix + "list";
		const list = this._register(this.instantiationService.createInstance(QuickInputList, container, this.options.hoverDelegate, this.options.linkOpenerDelegate, listId, this.styles));
		inputBox.setAttribute("aria-controls", listId);
		this._register(list.onDidChangeFocus(() => {
			if (inputBox.hasFocus()) {
				const activeDescendant = list.getActiveDescendant();
				if (activeDescendant) {
					inputBox.setAttribute("aria-activedescendant", activeDescendant);
					inputBox.setListFocusMode(true);
				} else {
					inputBox.removeAttribute("aria-activedescendant");
					inputBox.setListFocusMode(false);
				}
			}
		}));
		this._register(list.onChangedAllVisibleChecked((checked) => {
			checkAll.checked = checked;
		}));
		this._register(list.onChangedVisibleCount((c) => {
			visibleCount.setCount(c);
		}));
		this._register(list.onChangedCheckedCount((c) => {
			setTimeout0(() => count.setCount(c));
		}));
		this._register(list.onLeave(() => {
			setTimeout(() => {
				if (!this.controller) return;
				inputBox.setFocus();
				if (this.controller instanceof QuickPick && this.controller.canSelectMany) list.clearFocus();
			}, 0);
		}));
		const tree = this._register(this.instantiationService.createInstance(QuickInputTreeController, container, this.options.hoverDelegate, this.styles));
		this._register(tree.tree.onDidChangeFocus(() => {
			if (inputBox.hasFocus()) {
				const activeDescendant = tree.getActiveDescendant();
				if (activeDescendant) {
					inputBox.setAttribute("aria-activedescendant", activeDescendant);
					inputBox.setListFocusMode(true);
				} else {
					inputBox.removeAttribute("aria-activedescendant");
					inputBox.setListFocusMode(false);
				}
			}
		}));
		this._register(tree.onLeave(() => {
			setTimeout(() => {
				if (!this.controller) return;
				inputBox.setFocus();
				tree.tree.setFocus([]);
			}, 0);
		}));
		this._register(tree.onDidAccept(() => {
			this.onDidAcceptEmitter.fire();
		}));
		this._register(tree.tree.onDidChangeContentHeight(() => this.updateLayout()));
		const focusTracker = trackFocus(container);
		this._register(focusTracker);
		this._register(addDisposableListener(container, EventType$1.FOCUS, (e) => {
			const ui = this.getUI();
			if (isAncestor$1(e.relatedTarget, ui.inputContainer)) {
				const value = ui.inputBox.isSelectionAtEnd();
				if (this.endOfQuickInputBoxContext.get() !== value) this.endOfQuickInputBoxContext.set(value);
			}
			if (isAncestor$1(e.relatedTarget, ui.container)) return;
			this.inQuickInputContext.set(true);
			this.previousFocusElement = isHTMLElement(e.relatedTarget) ? e.relatedTarget : void 0;
		}, true));
		this._register(focusTracker.onDidBlur(() => {
			if (!this.getUI().ignoreFocusOut && !this.options.ignoreFocusOut()) this.hide(QuickInputHideReason.Blur);
			this.inQuickInputContext.set(false);
			this.endOfQuickInputBoxContext.set(false);
			this.previousFocusElement = void 0;
		}));
		this._register(inputBox.onKeyDown((e) => {
			const value = this.getUI().inputBox.isSelectionAtEnd();
			if (this.endOfQuickInputBoxContext.get() !== value) this.endOfQuickInputBoxContext.set(value);
			if (!isModifierKey(e.keyCode)) {
				inputBox.removeAttribute("aria-activedescendant");
				inputBox.setListFocusMode(false);
			}
		}));
		this._register(addDisposableListener(container, EventType$1.FOCUS, (e) => {
			inputBox.setFocus();
		}));
		this.dndController = this._register(this.instantiationService.createInstance(QuickInputDragAndDropController, this._container, container, [{
			node: titleBar,
			includeChildren: true,
			excludeNodes: [leftActionBar.getElement(), rightActionBar.getElement()]
		}, {
			node: headerContainer,
			includeChildren: false
		}], this.viewState));
		this._register(autorun((reader) => {
			const dndViewState = this.dndController?.dndViewState.read(reader);
			if (!dndViewState) return;
			if (dndViewState.top !== void 0 && dndViewState.left !== void 0) this.viewState = {
				...this.viewState,
				top: dndViewState.top,
				left: dndViewState.left
			};
			else this.viewState = void 0;
			this.updateLayout();
			if (dndViewState.done) this.saveViewState(this.viewState);
		}));
		this._register(autorun((reader) => {
			this._alignment.set(this.dndController.alignment.read(reader), void 0);
		}));
		this.ui = {
			container,
			styleSheet,
			leftActionBar,
			titleBar,
			title,
			description1,
			description2,
			widget,
			rightActionBar,
			inlineActionBar,
			checkAll,
			inputContainer,
			filterContainer,
			inputBox,
			visibleCountContainer,
			visibleCount,
			countContainer,
			count,
			okContainer,
			ok,
			message,
			customButtonContainer,
			customButton,
			list,
			tree,
			progressBar,
			onDidAccept: this.onDidAcceptEmitter.event,
			onDidCustom: this.onDidCustomEmitter.event,
			onDidTriggerButton: this.onDidTriggerButtonEmitter.event,
			ignoreFocusOut: false,
			keyMods: this.keyMods,
			show: (controller) => this.show(controller),
			hide: () => this.hide(),
			setVisibilities: (visibilities) => this.setVisibilities(visibilities),
			setEnabled: (enabled) => this.setEnabled(enabled),
			setContextKey: (contextKey) => this.options.setContextKey(contextKey),
			linkOpenerDelegate: (content) => this.options.linkOpenerDelegate(content)
		};
		this.updateStyles();
		return this.ui;
	}
	reparentUI(container) {
		if (this.ui) {
			this._container = container;
			append$2(this._container, this.ui.container);
			this.dndController?.reparentUI(this._container);
		}
	}
	pick(picks, options = {}, token = CancellationToken.None) {
		return new Promise((doResolve, reject) => {
			let resolve = (result) => {
				resolve = doResolve;
				options.onKeyMods?.(input.keyMods);
				doResolve(result);
			};
			if (token.isCancellationRequested) {
				resolve(void 0);
				return;
			}
			const input = this.createQuickPick({ useSeparators: true });
			let activeItem;
			const disposables = [
				input,
				input.onDidAccept(() => {
					if (input.canSelectMany) {
						resolve(input.selectedItems.slice());
						input.hide();
					} else {
						const result = input.activeItems[0];
						if (result) {
							resolve(result);
							input.hide();
						}
					}
				}),
				input.onDidChangeActive((items) => {
					const focused = items[0];
					if (focused && options.onDidFocus) options.onDidFocus(focused);
				}),
				input.onDidChangeSelection((items) => {
					if (!input.canSelectMany) {
						const result = items[0];
						if (result) {
							resolve(result);
							input.hide();
						}
					}
				}),
				input.onDidTriggerItemButton((event) => options.onDidTriggerItemButton && options.onDidTriggerItemButton({
					...event,
					removeItem: () => {
						const index = input.items.indexOf(event.item);
						if (index !== -1) {
							const items = input.items.slice();
							const removed = items.splice(index, 1);
							const activeItems = input.activeItems.filter((activeItem) => activeItem !== removed[0]);
							const keepScrollPositionBefore = input.keepScrollPosition;
							input.keepScrollPosition = true;
							input.items = items;
							if (activeItems) input.activeItems = activeItems;
							input.keepScrollPosition = keepScrollPositionBefore;
						}
					}
				})),
				input.onDidTriggerSeparatorButton((event) => options.onDidTriggerSeparatorButton?.(event)),
				input.onDidChangeValue((value) => {
					if (activeItem && !value && (input.activeItems.length !== 1 || input.activeItems[0] !== activeItem)) input.activeItems = [activeItem];
				}),
				token.onCancellationRequested(() => {
					input.hide();
				}),
				input.onDidHide(() => {
					dispose(disposables);
					resolve(void 0);
				})
			];
			input.title = options.title;
			if (options.value) input.value = options.value;
			input.canSelectMany = !!options.canPickMany;
			input.placeholder = options.placeHolder;
			input.prompt = options.prompt;
			input.ignoreFocusOut = !!options.ignoreFocusLost;
			input.matchOnDescription = !!options.matchOnDescription;
			input.matchOnDetail = !!options.matchOnDetail;
			if (options.sortByLabel !== void 0) input.sortByLabel = options.sortByLabel;
			input.matchOnLabel = options.matchOnLabel === void 0 || options.matchOnLabel;
			input.quickNavigate = options.quickNavigate;
			input.hideInput = !!options.hideInput;
			input.contextKey = options.contextKey;
			input.anchor = options.anchor;
			input.anchorPosition = options.anchorPosition;
			input.busy = true;
			Promise.all([picks, options.activeItem]).then(([items, _activeItem]) => {
				activeItem = _activeItem;
				input.busy = false;
				input.items = items;
				if (input.canSelectMany) input.selectedItems = items.filter((item) => item.type !== "separator" && item.picked);
				if (activeItem) input.activeItems = [activeItem];
			});
			input.show();
			Promise.resolve(picks).then(void 0, (err) => {
				reject(err);
				input.hide();
			});
		});
	}
	setValidationOnInput(input, validationResult) {
		if (validationResult && isString$1(validationResult)) {
			input.severity = Severity$1$1.Error;
			input.validationMessage = validationResult;
		} else if (validationResult && !isString$1(validationResult)) {
			input.severity = validationResult.severity;
			input.validationMessage = validationResult.content;
		} else {
			input.severity = Severity$1$1.Ignore;
			input.validationMessage = void 0;
		}
	}
	input(options = {}, token = CancellationToken.None) {
		return new Promise((resolve) => {
			if (token.isCancellationRequested) {
				resolve(void 0);
				return;
			}
			const input = this.createInputBox();
			const validateInput = options.validateInput || (() => Promise.resolve(void 0));
			const onDidValueChange = Event.debounce(input.onDidChangeValue, (last, cur) => cur, 100);
			let validationValue = options.value || "";
			let validation = Promise.resolve(validateInput(validationValue));
			const disposables = [
				input,
				onDidValueChange((value) => {
					if (value !== validationValue) {
						validation = Promise.resolve(validateInput(value));
						validationValue = value;
					}
					validation.then((result) => {
						if (value === validationValue) this.setValidationOnInput(input, result);
					});
				}),
				input.onDidAccept(() => {
					const value = input.value;
					if (value !== validationValue) {
						validation = Promise.resolve(validateInput(value));
						validationValue = value;
					}
					validation.then((result) => {
						if (!result || !isString$1(result) && result.severity !== Severity$1$1.Error) {
							resolve(value);
							input.hide();
						} else if (value === validationValue) this.setValidationOnInput(input, result);
					});
				}),
				token.onCancellationRequested(() => {
					input.hide();
				}),
				input.onDidHide(() => {
					dispose(disposables);
					resolve(void 0);
				})
			];
			input.title = options.title;
			input.value = options.value || "";
			input.valueSelection = options.valueSelection;
			input.prompt = options.prompt;
			input.placeholder = options.placeHolder;
			input.password = !!options.password;
			input.ignoreFocusOut = !!options.ignoreFocusLost;
			input.show();
		});
	}
	createQuickPick(options = { useSeparators: false }) {
		return new QuickPick(this.getUI(true));
	}
	createInputBox() {
		return new InputBox(this.getUI(true));
	}
	show(controller) {
		this.completeCloseAnimation();
		const ui = this.getUI(true);
		const oldController = this.controller;
		this.controller = controller;
		oldController?.didHide();
		if (isHTMLElement(controller.anchor)) {
			const anchorWindow = getWindow(controller.anchor);
			if (getWindow(this._container) !== anchorWindow) this.reparentUI(this.layoutService.getContainer(anchorWindow));
		}
		this.setEnabled(true);
		ui.leftActionBar.setActions([]);
		ui.title.textContent = "";
		ui.description1.textContent = "";
		ui.description2.textContent = "";
		reset(ui.widget);
		ui.rightActionBar.setActions([]);
		ui.inlineActionBar.setActions([]);
		ui.checkAll.checked = false;
		ui.inputBox.placeholder = "";
		ui.inputBox.password = false;
		ui.inputBox.showDecoration(Severity$1$1.Ignore);
		ui.visibleCount.setCount(0);
		ui.count.setCount(0);
		ui.countContainer.style.right = "4px";
		reset(ui.message);
		ui.progressBar.stop();
		ui.progressBar.getContainer().setAttribute("aria-hidden", "true");
		ui.list.setElements([]);
		ui.list.matchOnDescription = false;
		ui.list.matchOnDetail = false;
		ui.list.matchOnLabel = true;
		ui.list.sortByLabel = true;
		ui.tree.updateFilterOptions({
			matchOnDescription: false,
			matchOnLabel: true
		});
		ui.tree.sortByLabel = true;
		ui.ignoreFocusOut = false;
		ui.inputBox.toggles = void 0;
		ui.inputBox.actions = void 0;
		ui.inputBox.setHeight(void 0);
		const backKeybindingLabel = this.options.backKeybindingLabel();
		backButton.tooltip = backKeybindingLabel ? localize(1865, "Back ({0})", backKeybindingLabel) : localize(1866, "Back");
		this.overlayLayoutCorrection = void 0;
		ui.container.classList.toggle(QUICK_INPUT_OVERLAY_CLASS, controller.anchorPosition === "overlay");
		ui.container.style.display = "";
		this.updateLayout();
		this.dndController?.setEnabled(!controller.anchor);
		this.dndController?.layoutContainer();
		if (controller.anchor) this._alignment.set("custom", void 0);
		else this._alignment.set(this.dndController?.alignment.get() ?? "top", void 0);
		this.onShowEmitter.fire();
		ui.inputBox.setFocus();
		this.quickInputTypeContext.set(controller.type);
	}
	isVisible() {
		return !!this.controller;
	}
	setVisibilities(visibilities) {
		const ui = this.getUI();
		ui.titleBar.style.display = visibilities.title ? "" : "none";
		ui.title.style.display = visibilities.title ? "" : "none";
		ui.description1.style.display = visibilities.description && (visibilities.inputBox || visibilities.checkAll) ? "" : "none";
		ui.description2.style.display = visibilities.description && !(visibilities.inputBox || visibilities.checkAll) ? "" : "none";
		ui.checkAll.domNode.style.display = visibilities.checkAll ? "" : "none";
		ui.inputContainer.style.display = visibilities.inputBox ? "" : "none";
		ui.filterContainer.style.display = visibilities.inputBox ? "" : "none";
		ui.visibleCountContainer.style.display = visibilities.visibleCount ? "" : "none";
		ui.countContainer.style.display = visibilities.count ? "" : "none";
		ui.okContainer.style.display = visibilities.ok ? "" : "none";
		ui.customButtonContainer.style.display = visibilities.customButton ? "" : "none";
		ui.message.style.display = visibilities.message ? "" : "none";
		ui.progressBar.getContainer().style.display = visibilities.progressBar ? "" : "none";
		ui.list.displayed = !!visibilities.list;
		ui.tree.displayed = !!visibilities.tree;
		ui.container.classList.toggle("show-checkboxes", !!visibilities.checkBox);
		ui.container.classList.toggle("hidden-input", !visibilities.inputBox && !visibilities.description);
		this.overlayLayoutCorrection = void 0;
		this.updateLayout();
	}
	setEnabled(enabled) {
		if (enabled !== this.enabled) {
			this.enabled = enabled;
			const ui = this.getUI();
			for (let i = 0; i < ui.leftActionBar.getItemsLength(); i++) {
				const action = ui.leftActionBar.getItemAction(i);
				if (action) action.enabled = enabled;
			}
			for (let i = 0; i < ui.rightActionBar.getItemsLength(); i++) {
				const action = ui.rightActionBar.getItemAction(i);
				if (action) action.enabled = enabled;
			}
			if (enabled) ui.checkAll.enable();
			else ui.checkAll.disable();
			ui.inputBox.enabled = enabled;
			ui.ok.enabled = enabled;
			ui.list.enabled = enabled;
		}
	}
	hide(reason) {
		const controller = this.controller;
		if (!controller) return;
		controller.willHide(reason);
		const container = this.ui?.container;
		const focusChanged = container && !isAncestorOfActiveElement(container);
		this.controller = null;
		this.onHideEmitter.fire();
		if (container) {
			if (!container.classList.contains(QUICK_INPUT_OVERLAY_CLASS) && hasParentWithClass(container, QUICK_INPUT_MOTION_ANCESTOR_CLASSES)) {
				container.inert = true;
				container.classList.add(QUICK_INPUT_MOTION_CLOSING_CLASS);
				this.closeAnimation.value = disposableTimeout(() => this.completeCloseAnimation(), QUICK_INPUT_CLOSE_ANIMATION_DURATION);
			} else container.style.display = "none";
		}
		if (!focusChanged) {
			let currentElement = this.previousFocusElement;
			while (currentElement && !currentElement.offsetParent) currentElement = currentElement.parentElement ?? void 0;
			if (currentElement?.offsetParent) {
				currentElement.focus();
				this.previousFocusElement = void 0;
			} else this.options.returnFocus();
		}
		controller.didHide(reason);
	}
	completeCloseAnimation() {
		if (!this.closeAnimation.value) return;
		this.closeAnimation.clear();
		const container = this.ui?.container;
		if (container) {
			container.inert = false;
			container.classList.remove(QUICK_INPUT_MOTION_CLOSING_CLASS);
			container.style.display = "none";
		}
	}
	dispose() {
		this.completeCloseAnimation();
		super.dispose();
	}
	toggle() {
		if (!this.isVisible()) return;
		if (this.controller instanceof QuickPick && this.controller.canSelectMany) this.getUI().list.toggleCheckbox();
		else if (this.controller instanceof QuickTree) this.getUI().tree.toggleCheckbox();
	}
	toggleHover() {
		if (this.isVisible() && this.controller instanceof QuickPick) this.getUI().list.toggleHover();
	}
	layout(dimension, titleBarOffset) {
		this.dimension = dimension;
		this.titleBarOffset = titleBarOffset;
		this.overlayLayoutCorrection = void 0;
		this.updateLayout();
	}
	updateLayout() {
		if (this.ui && this.isVisible()) {
			const style = this.ui.container.style;
			let width = Math.min(this.dimension.width * .62, QuickInputController_1.MAX_WIDTH);
			style.width = width + "px";
			let listHeight = this.dimension && this.dimension.height * .4;
			let overlayAnchor;
			if (this.controller?.anchor) {
				const target = this.controller.anchor;
				const anchorWindow = isHTMLElement(target) ? getWindow(target) : getActiveWindow();
				const container = this.layoutService.getContainer(anchorWindow).getBoundingClientRect();
				const verticalPadding = 48;
				let anchor = getAnchorRect(target);
				let preferredAnchorPosition = 1;
				let listHeightRatio = .2;
				let maxListHeight = 200;
				if (this.controller.anchorPosition === "overlay") {
					overlayAnchor = anchor;
					this.ui.inputBox.setHeight(anchor.height);
					width = anchor.width;
					listHeightRatio = .4;
					anchor = {
						...anchor,
						height: 0
					};
					maxListHeight = Math.min(400, container.bottom - anchor.top - verticalPadding);
					preferredAnchorPosition = 0;
				} else width = 380;
				listHeight = this.dimension ? Math.min(this.dimension.height * listHeightRatio, maxListHeight) : maxListHeight;
				const containerHeight = Math.floor(listHeight) + verticalPadding;
				const { top, left, right, bottom, anchorAlignment, anchorPosition } = layout2d(container, {
					width,
					height: containerHeight
				}, anchor, { anchorPosition: preferredAnchorPosition });
				if (anchorAlignment === 1) {
					style.right = `${right}px`;
					style.left = "initial";
				} else {
					style.left = `${left}px`;
					style.right = "initial";
				}
				if (anchorPosition === 1) {
					style.bottom = `${bottom}px`;
					style.top = "initial";
				} else {
					style.top = `${top}px`;
					style.bottom = "initial";
				}
				style.width = `${width}px`;
				style.height = "";
			} else {
				style.top = `${this.viewState?.top !== void 0 ? Math.round(this.dimension.height * this.viewState.top) : this.titleBarOffset}px`;
				style.left = `${Math.round(this.dimension.width * (this.viewState?.left ?? .5) - width / 2)}px`;
				style.right = "";
				style.bottom = "";
				style.height = "";
			}
			if (overlayAnchor) this.alignOverlayInput(overlayAnchor);
			this.ui.inputBox.layout();
			this.ui.list.layout(listHeight);
			this.ui.tree.layout(listHeight);
		}
	}
	alignOverlayInput(anchor) {
		const style = this.ui.container.style;
		let correction = this.overlayLayoutCorrection;
		if (!correction || correction.anchor.left !== anchor.left || correction.anchor.top !== anchor.top || correction.anchor.width !== anchor.width || correction.anchor.height !== anchor.height) {
			this.ui.inputBox.layout();
			const input = this.ui.filterContainer.getBoundingClientRect();
			correction = this.overlayLayoutCorrection = {
				anchor,
				left: anchor.left - input.left,
				right: input.right - (anchor.left + anchor.width),
				top: anchor.top - input.top,
				bottom: input.bottom - (anchor.top + anchor.height),
				width: anchor.width - input.width
			};
		}
		style.width = `${parseFloat(style.width) + correction.width}px`;
		if (style.left !== "initial") style.left = `${parseFloat(style.left) + correction.left}px`;
		else style.right = `${parseFloat(style.right) + correction.right}px`;
		if (style.top !== "initial") style.top = `${parseFloat(style.top) + correction.top}px`;
		else style.bottom = `${parseFloat(style.bottom) + correction.bottom}px`;
	}
	applyStyles(styles) {
		this.styles = styles;
		this.updateStyles();
	}
	updateStyles() {
		if (this.ui) {
			const { quickInputTitleBackground, quickInputBackground, quickInputForeground, widgetBorder } = this.styles.widget;
			this.ui.titleBar.style.backgroundColor = quickInputTitleBackground ?? "";
			this.ui.container.style.backgroundColor = quickInputBackground ?? "";
			this.ui.container.style.color = quickInputForeground ?? "";
			this.ui.container.style.border = widgetBorder ? `1px solid ${widgetBorder}` : "";
			this.ui.list.style(this.styles.list);
			this.ui.tree.tree.style(this.styles.list);
			const content = [];
			if (this.styles.pickerGroup.pickerGroupBorder) content.push(`.quick-input-list .quick-input-list-entry { border-top-color:  ${this.styles.pickerGroup.pickerGroupBorder}; }`);
			if (this.styles.pickerGroup.pickerGroupForeground) content.push(`.quick-input-list .quick-input-list-separator { color:  ${this.styles.pickerGroup.pickerGroupForeground}; }`);
			if (this.styles.pickerGroup.pickerGroupForeground) content.push(`.quick-input-list .quick-input-list-separator-as-item { color: var(--vscode-descriptionForeground); }`);
			if (this.styles.keybindingLabel.keybindingLabelBackground || this.styles.keybindingLabel.keybindingLabelBorder || this.styles.keybindingLabel.keybindingLabelBottomBorder || this.styles.keybindingLabel.keybindingLabelShadow || this.styles.keybindingLabel.keybindingLabelForeground) {
				content.push(".quick-input-list .monaco-keybinding > .monaco-keybinding-key {");
				if (this.styles.keybindingLabel.keybindingLabelBackground) content.push(`background-color: ${this.styles.keybindingLabel.keybindingLabelBackground};`);
				if (this.styles.keybindingLabel.keybindingLabelBorder) content.push(`border-color: ${this.styles.keybindingLabel.keybindingLabelBorder};`);
				if (this.styles.keybindingLabel.keybindingLabelBottomBorder) content.push(`border-bottom-color: ${this.styles.keybindingLabel.keybindingLabelBottomBorder};`);
				if (this.styles.keybindingLabel.keybindingLabelShadow) content.push(`box-shadow: inset 0 -1px 0 ${this.styles.keybindingLabel.keybindingLabelShadow};`);
				if (this.styles.keybindingLabel.keybindingLabelForeground) content.push(`color: ${this.styles.keybindingLabel.keybindingLabelForeground};`);
				content.push("}");
			}
			const newStyles = content.join("\n");
			if (newStyles !== this.ui.styleSheet.textContent) this.ui.styleSheet.textContent = newStyles;
		}
	}
	loadViewState() {
		try {
			const data = JSON.parse(this.storageService.get(VIEWSTATE_STORAGE_KEY, -1, "{}"));
			if (data.top !== void 0 || data.left !== void 0) return data;
		} catch {}
	}
	saveViewState(viewState) {
		if (!(this.layoutService.activeContainer === this.layoutService.mainContainer)) return;
		if (viewState !== void 0) this.storageService.store(VIEWSTATE_STORAGE_KEY, JSON.stringify(viewState), -1, 1);
		else this.storageService.remove(VIEWSTATE_STORAGE_KEY, -1);
	}
};
QuickInputController = QuickInputController_1 = __decorate$19([
	__param$19(1, ILayoutService),
	__param$19(2, IInstantiationService),
	__param$19(3, IContextKeyService),
	__param$19(4, IStorageService),
	__param$19(5, IContextMenuService)
], QuickInputController);
var QuickInputDragAndDropController = class QuickInputDragAndDropController extends Disposable {
	constructor(_container, _quickInputContainer, _quickInputDragAreas, initialViewState, _layoutService, contextKeyService, configurationService) {
		super();
		this._container = _container;
		this._quickInputContainer = _quickInputContainer;
		this._quickInputDragAreas = _quickInputDragAreas;
		this._layoutService = _layoutService;
		this.configurationService = configurationService;
		this.dndViewState = observableValue(this, void 0);
		this._enabled = true;
		this._snapThreshold = 20;
		this._snapLineHorizontalRatio = .25;
		this._alignment = observableValue(this, "top");
		this.alignment = this._alignment;
		this._quickInputAlignmentContext = QuickInputAlignmentContextKey.bindTo(contextKeyService);
		const customWindowControls = getWindowControlsStyle(this.configurationService) === "custom";
		this._controlsOnLeft = customWindowControls && platform === 1;
		this._controlsOnRight = customWindowControls && (platform === 3 || platform === 2);
		this._registerLayoutListener();
		this.registerMouseListeners();
		this.dndViewState.set({
			...initialViewState,
			done: true
		}, void 0);
		if (initialViewState?.top !== void 0 && initialViewState?.left !== void 0) this._setAlignmentState(void 0);
	}
	reparentUI(container) {
		this._container = container;
	}
	layoutContainer(dimension = this._layoutService.activeContainerDimension) {
		if (!this._enabled) return;
		const state = this.dndViewState.get();
		const dragAreaRect = this._quickInputContainer.getBoundingClientRect();
		if (state?.top !== void 0 && state?.left !== void 0) {
			const a = Math.round(state.left * 100) / 100;
			const b = dimension.width;
			const c = dragAreaRect.width;
			const d = a * b - c / 2;
			this._layout(state.top * dimension.height, d);
		}
	}
	setEnabled(enabled) {
		this._enabled = enabled;
		this._quickInputContainer.classList.toggle("no-drag", !enabled);
	}
	_setAlignmentState(value) {
		this._quickInputAlignmentContext.set(value);
		this._alignment.set(value ?? "custom", void 0);
	}
	_registerLayoutListener() {
		this._register(Event.filter(this._layoutService.onDidLayoutContainer, (e) => e.container === this._container)((e) => this.layoutContainer(e.dimension)));
	}
	registerMouseListeners() {
		const dragArea = this._quickInputContainer;
		this._register(addDisposableGenericMouseUpListener(dragArea, (event) => {
			if (!this._enabled) return;
			const originEvent = new StandardMouseEvent(getWindow(dragArea), event);
			if (originEvent.detail !== 2) return;
			const area = this._quickInputDragAreas.find(({ node, includeChildren }) => includeChildren ? isAncestor$1(originEvent.target, node) : originEvent.target === node);
			if (!area || area.excludeNodes?.some((node) => isAncestor$1(originEvent.target, node))) return;
			this.dndViewState.set({
				top: void 0,
				left: void 0,
				done: true
			}, void 0);
			this._setAlignmentState("top");
		}));
		this._register(addDisposableGenericMouseDownListener(dragArea, (e) => {
			if (!this._enabled) return;
			const activeWindow = getWindow(this._layoutService.activeContainer);
			const originEvent = new StandardMouseEvent(activeWindow, e);
			const area = this._quickInputDragAreas.find(({ node, includeChildren }) => includeChildren ? isAncestor$1(originEvent.target, node) : originEvent.target === node);
			if (!area || area.excludeNodes?.some((node) => isAncestor$1(originEvent.target, node))) return;
			const dragAreaRect = this._quickInputContainer.getBoundingClientRect();
			const dragOffsetX = originEvent.browserEvent.clientX - dragAreaRect.left;
			const dragOffsetY = originEvent.browserEvent.clientY - dragAreaRect.top;
			let isMovingQuickInput = false;
			const mouseMoveListener = addDisposableGenericMouseMoveListener(activeWindow, (e) => {
				new StandardMouseEvent(activeWindow, e).preventDefault();
				if (!isMovingQuickInput) isMovingQuickInput = true;
				this._layout(e.clientY - dragOffsetY, e.clientX - dragOffsetX);
			});
			const mouseUpListener = addDisposableGenericMouseUpListener(activeWindow, (e) => {
				if (isMovingQuickInput) {
					const state = this.dndViewState.get();
					this.dndViewState.set({
						top: state?.top,
						left: state?.left,
						done: true
					}, void 0);
				}
				mouseMoveListener.dispose();
				mouseUpListener.dispose();
			});
		}));
	}
	_layout(topCoordinate, leftCoordinate) {
		const snapCoordinateYTop = this._getTopSnapValue();
		const snapCoordinateY = this._getCenterYSnapValue();
		const snapCoordinateX = this._getCenterXSnapValue();
		topCoordinate = Math.max(0, Math.min(topCoordinate, this._container.clientHeight - this._quickInputContainer.clientHeight));
		if (topCoordinate < this._layoutService.activeContainerOffset.top) {
			if (this._controlsOnLeft) leftCoordinate = Math.max(leftCoordinate, 80 / getZoomFactor(getActiveWindow()));
			else if (this._controlsOnRight) leftCoordinate = Math.min(leftCoordinate, this._container.clientWidth - this._quickInputContainer.clientWidth - 140 / getZoomFactor(getActiveWindow()));
		}
		const snappingToTop = Math.abs(topCoordinate - snapCoordinateYTop) < this._snapThreshold;
		topCoordinate = snappingToTop ? snapCoordinateYTop : topCoordinate;
		const snappingToCenter = Math.abs(topCoordinate - snapCoordinateY) < this._snapThreshold;
		topCoordinate = snappingToCenter ? snapCoordinateY : topCoordinate;
		const top = topCoordinate / this._container.clientHeight;
		leftCoordinate = Math.max(0, Math.min(leftCoordinate, this._container.clientWidth - this._quickInputContainer.clientWidth));
		const snappingToCenterX = Math.abs(leftCoordinate - snapCoordinateX) < this._snapThreshold;
		leftCoordinate = snappingToCenterX ? snapCoordinateX : leftCoordinate;
		const b = this._container.clientWidth;
		const c = this._quickInputContainer.clientWidth;
		const left = (leftCoordinate + c / 2) / b;
		this.dndViewState.set({
			top,
			left,
			done: false
		}, void 0);
		if (snappingToCenterX) {
			if (snappingToTop) {
				this._setAlignmentState("top");
				return;
			} else if (snappingToCenter) {
				this._setAlignmentState("center");
				return;
			}
		}
		this._setAlignmentState(void 0);
	}
	_getTopSnapValue() {
		return this._layoutService.activeContainerOffset.quickPickTop;
	}
	_getCenterYSnapValue() {
		return Math.round(this._container.clientHeight * this._snapLineHorizontalRatio);
	}
	_getCenterXSnapValue() {
		return Math.round(this._container.clientWidth / 2) - Math.round(this._quickInputContainer.clientWidth / 2);
	}
};
QuickInputDragAndDropController = __decorate$19([
	__param$19(4, ILayoutService),
	__param$19(5, IContextKeyService),
	__param$19(6, IConfigurationService)
], QuickInputDragAndDropController);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/quickinput/browser/quickInputService.js
var __decorate$18 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$18 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var QuickInputService = class QuickInputService extends Themable {
	get controller() {
		if (!this._controller) this._controller = this._register(this.createController());
		return this._controller;
	}
	get hasController() {
		return !!this._controller;
	}
	get currentQuickInput() {
		return this.controller.currentQuickInput;
	}
	get quickAccess() {
		if (!this._quickAccess) this._quickAccess = this._register(this.instantiationService.createInstance(QuickAccessController));
		return this._quickAccess;
	}
	constructor(instantiationService, contextKeyService, themeService, layoutService, configurationService) {
		super(themeService);
		this.instantiationService = instantiationService;
		this.contextKeyService = contextKeyService;
		this.layoutService = layoutService;
		this.configurationService = configurationService;
		this._alignment = observableValue(this, "top");
		this._onShow = this._register(new Emitter$1());
		this._onHide = this._register(new Emitter$1());
		this.contexts = /* @__PURE__ */ new Map();
	}
	createController(host = this.layoutService, options) {
		const defaultOptions = {
			idPrefix: "quickInput_",
			container: host.activeContainer,
			ignoreFocusOut: () => false,
			backKeybindingLabel: () => void 0,
			setContextKey: (id) => this.setContextKey(id),
			linkOpenerDelegate: (content) => {
				this.instantiationService.invokeFunction((accessor) => {
					accessor.get(IOpenerService).open(content, {
						allowCommands: true,
						fromUserGesture: true
					});
				});
			},
			returnFocus: () => host.focus(),
			styles: this.computeStyles(),
			hoverDelegate: this._register(this.instantiationService.createInstance(QuickInputHoverDelegate))
		};
		const controller = this._register(this.instantiationService.createInstance(QuickInputController, {
			...defaultOptions,
			...options
		}));
		controller.layout(host.activeContainerDimension, host.activeContainerOffset.quickPickTop);
		this._register(host.onDidLayoutActiveContainer((dimension) => {
			if (getWindow(host.activeContainer) === getWindow(controller.container)) controller.layout(dimension, host.activeContainerOffset.quickPickTop);
		}));
		this._register(host.onDidChangeActiveContainer(() => {
			if (controller.isVisible()) return;
			controller.layout(host.activeContainerDimension, host.activeContainerOffset.quickPickTop);
		}));
		this._register(controller.onShow(() => {
			this.resetContextKeys();
			this._onShow.fire();
		}));
		this._register(controller.onHide(() => {
			this.resetContextKeys();
			this._onHide.fire();
		}));
		this._register(autorun((reader) => {
			this._alignment.set(controller.alignment.read(reader), void 0);
		}));
		return controller;
	}
	setContextKey(id) {
		let key;
		if (id) {
			key = this.contexts.get(id);
			if (!key) {
				key = new RawContextKey(id, false).bindTo(this.contextKeyService);
				this.contexts.set(id, key);
			}
		}
		if (key && key.get()) return;
		this.resetContextKeys();
		key?.set(true);
	}
	resetContextKeys() {
		this.contexts.forEach((context) => {
			if (context.get()) context.reset();
		});
	}
	pick(picks, options, token = CancellationToken.None) {
		return this.controller.pick(picks, options, token);
	}
	input(options = {}, token = CancellationToken.None) {
		return this.controller.input(options, token);
	}
	createQuickPick(options = { useSeparators: false }) {
		return this.controller.createQuickPick(options);
	}
	createInputBox() {
		return this.controller.createInputBox();
	}
	toggle() {
		this.controller.toggle();
	}
	toggleHover() {
		if (this.hasController) this.controller.toggleHover();
	}
	updateStyles() {
		if (this.hasController) this.controller.applyStyles(this.computeStyles());
	}
	computeStyles() {
		return {
			widget: {
				quickInputBackground: asCssVariable(quickInputBackground),
				quickInputForeground: asCssVariable(quickInputForeground),
				quickInputTitleBackground: asCssVariable(quickInputTitleBackground),
				widgetBorder: asCssVariable(widgetBorder),
				widgetShadow: asCssVariable(widgetShadow)
			},
			inputBox: defaultInputBoxStyles,
			toggle: defaultToggleStyles,
			countBadge: defaultCountBadgeStyles,
			button: defaultButtonStyles,
			progressBar: defaultProgressBarStyles,
			keybindingLabel: defaultKeybindingLabelStyles,
			list: getListStyles({
				listBackground: quickInputBackground,
				listFocusBackground: quickInputListFocusBackground,
				listFocusForeground: quickInputListFocusForeground,
				listInactiveFocusForeground: quickInputListFocusForeground,
				listInactiveSelectionIconForeground: quickInputListFocusIconForeground,
				listInactiveFocusBackground: quickInputListFocusBackground,
				listInactiveSelectionBackground: quickInputListFocusBackground,
				listInactiveSelectionForeground: quickInputListFocusForeground,
				listFocusOutline: activeContrastBorder,
				listInactiveFocusOutline: activeContrastBorder,
				treeStickyScrollBackground: quickInputBackground
			}),
			pickerGroup: {
				pickerGroupBorder: asCssVariable(pickerGroupBorder),
				pickerGroupForeground: asCssVariable(pickerGroupForeground)
			}
		};
	}
};
QuickInputService = __decorate$18([
	__param$18(0, IInstantiationService),
	__param$18(1, IContextKeyService),
	__param$18(2, IThemeService),
	__param$18(3, ILayoutService),
	__param$18(4, IConfigurationService)
], QuickInputService);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/standalone/browser/quickInput/standaloneQuickInputService.js
var __decorate$17 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$17 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var EditorScopedQuickInputService = class EditorScopedQuickInputService extends QuickInputService {
	constructor(editor, instantiationService, contextKeyService, themeService, codeEditorService, configurationService) {
		super(instantiationService, contextKeyService, themeService, new EditorScopedLayoutService(editor.getContainerDomNode(), codeEditorService), configurationService);
		this.host = void 0;
		const contribution = QuickInputEditorContribution.get(editor);
		if (contribution) {
			const widget = contribution.widget;
			this.host = {
				_serviceBrand: void 0,
				get mainContainer() {
					return widget.getDomNode();
				},
				getContainer() {
					return widget.getDomNode();
				},
				whenContainerStylesLoaded() {},
				get containers() {
					return [widget.getDomNode()];
				},
				get activeContainer() {
					return widget.getDomNode();
				},
				get mainContainerDimension() {
					return editor.getLayoutInfo();
				},
				get activeContainerDimension() {
					return editor.getLayoutInfo();
				},
				get onDidLayoutMainContainer() {
					return editor.onDidLayoutChange;
				},
				get onDidLayoutActiveContainer() {
					return editor.onDidLayoutChange;
				},
				get onDidLayoutContainer() {
					return Event.map(editor.onDidLayoutChange, (dimension) => ({
						container: widget.getDomNode(),
						dimension
					}));
				},
				get onDidChangeActiveContainer() {
					return Event.None;
				},
				get onDidAddContainer() {
					return Event.None;
				},
				get mainContainerOffset() {
					return {
						top: 0,
						quickPickTop: 0
					};
				},
				get activeContainerOffset() {
					return {
						top: 0,
						quickPickTop: 0
					};
				},
				focus: () => editor.focus()
			};
		} else this.host = void 0;
	}
	createController() {
		return super.createController(this.host);
	}
};
EditorScopedQuickInputService = __decorate$17([
	__param$17(1, IInstantiationService),
	__param$17(2, IContextKeyService),
	__param$17(3, IThemeService),
	__param$17(4, ICodeEditorService),
	__param$17(5, IConfigurationService)
], EditorScopedQuickInputService);
var StandaloneQuickInputService = class StandaloneQuickInputService {
	get activeService() {
		const editor = this.codeEditorService.getFocusedCodeEditor();
		if (!editor) throw new Error("Quick input service needs a focused editor to work.");
		let quickInputService = this.mapEditorToService.get(editor);
		if (!quickInputService) {
			const newQuickInputService = quickInputService = this.instantiationService.createInstance(EditorScopedQuickInputService, editor);
			this.mapEditorToService.set(editor, quickInputService);
			createSingleCallFunction(editor.onDidDispose)(() => {
				newQuickInputService.dispose();
				this.mapEditorToService.delete(editor);
			});
		}
		return quickInputService;
	}
	get currentQuickInput() {
		return this.activeService.currentQuickInput;
	}
	get quickAccess() {
		return this.activeService.quickAccess;
	}
	constructor(instantiationService, codeEditorService) {
		this.instantiationService = instantiationService;
		this.codeEditorService = codeEditorService;
		this.mapEditorToService = /* @__PURE__ */ new Map();
	}
	pick(picks, options, token = CancellationToken.None) {
		return this.activeService.pick(picks, options, token);
	}
	input(options, token) {
		return this.activeService.input(options, token);
	}
	createQuickPick(options = { useSeparators: false }) {
		return this.activeService.createQuickPick(options);
	}
	createInputBox() {
		return this.activeService.createInputBox();
	}
	toggle() {
		return this.activeService.toggle();
	}
	toggleHover() {
		return this.activeService.toggleHover();
	}
};
StandaloneQuickInputService = __decorate$17([__param$17(0, IInstantiationService), __param$17(1, ICodeEditorService)], StandaloneQuickInputService);
var QuickInputEditorContribution = class QuickInputEditorContribution {
	static {
		this.ID = "editor.controller.quickInput";
	}
	static get(editor) {
		return editor.getContribution(QuickInputEditorContribution.ID);
	}
	constructor(editor) {
		this.editor = editor;
		this.widget = new QuickInputEditorWidget(this.editor);
	}
	dispose() {
		this.widget.dispose();
	}
};
var QuickInputEditorWidget = class QuickInputEditorWidget {
	static {
		this.ID = "editor.contrib.quickInputWidget";
	}
	constructor(codeEditor) {
		this.codeEditor = codeEditor;
		this.domNode = document.createElement("div");
		this.codeEditor.addOverlayWidget(this);
	}
	getId() {
		return QuickInputEditorWidget.ID;
	}
	getDomNode() {
		return this.domNode;
	}
	getPosition() {
		return { preference: {
			top: 0,
			left: 0
		} };
	}
	dispose() {
		this.codeEditor.removeOverlayWidget(this);
	}
};
registerEditorContribution(QuickInputEditorContribution.ID, QuickInputEditorContribution, 4);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/webWorker/browser/webWorkerServiceImpl.js
var WebWorkerService = class WebWorkerService {
	static {
		this._workerIdPool = 0;
	}
	createWorkerClient(workerDescriptor) {
		let worker;
		const id = ++WebWorkerService._workerIdPool;
		if (workerDescriptor instanceof Worker || isPromiseLike(workerDescriptor)) worker = Promise.resolve(workerDescriptor);
		else worker = this._createWorker(workerDescriptor);
		return new WebWorkerClient(new WebWorker(worker, id));
	}
	_createWorker(descriptor) {
		const workerRunnerUrl = this.getWorkerUrl(descriptor);
		const workerUrlWithNls = getWorkerBootstrapUrl(descriptor.label, workerRunnerUrl, this._getWorkerLoadingFailedErrorMessage(descriptor));
		try {
			return whenESMWorkerReady(createBlobWorker(workerUrlWithNls, {
				name: descriptor.label,
				type: "module"
			})).finally(() => URL.revokeObjectURL(workerUrlWithNls));
		} catch (error) {
			URL.revokeObjectURL(workerUrlWithNls);
			throw error;
		}
	}
	_getWorkerLoadingFailedErrorMessage(_descriptor) {}
	getWorkerUrl(descriptor) {
		if (!descriptor.esmModuleLocation) throw new Error("Missing esmModuleLocation in WebWorkerDescriptor");
		return (typeof descriptor.esmModuleLocation === "function" ? descriptor.esmModuleLocation() : descriptor.esmModuleLocation).toString(true);
	}
};
var ttPolicy$1 = (() => {
	const workerGlobalThis = globalThis;
	if (typeof self === "object" && self.constructor && self.constructor.name === "DedicatedWorkerGlobalScope" && workerGlobalThis.workerttPolicy !== void 0) return workerGlobalThis.workerttPolicy;
	else return createTrustedTypesPolicy("defaultWorkerFactory", { createScriptURL: (value) => value });
})();
function createBlobWorker(blobUrl, options) {
	if (!blobUrl.startsWith("blob:")) throw new URIError("Not a blob-url: " + blobUrl);
	return new Worker(ttPolicy$1 ? ttPolicy$1.createScriptURL(blobUrl) : blobUrl, {
		...options,
		type: "module"
	});
}
function getWorkerBootstrapUrl(label, workerScriptUrl, workerLoadingFailedErrorMessage) {
	if (/^((http:)|(https:)|(file:))/.test(workerScriptUrl) && workerScriptUrl.substring(0, globalThis.origin.length) !== globalThis.origin);
	else {
		const start = workerScriptUrl.lastIndexOf("?");
		const end = workerScriptUrl.lastIndexOf("#", start);
		const params = start > 0 ? new URLSearchParams(workerScriptUrl.substring(start + 1, ~end ? end : void 0)) : new URLSearchParams();
		COI.addSearchParam(params, true, true);
		if (!params.toString()) workerScriptUrl = `${workerScriptUrl}#${label}`;
		else workerScriptUrl = `${workerScriptUrl}?${params.toString()}#${label}`;
	}
	const blob = new Blob([coalesce([
		`/*${label}*/`,
		`globalThis._VSCODE_NLS_MESSAGES = ${JSON.stringify(getNLSMessages())};`,
		`globalThis._VSCODE_NLS_LANGUAGE = ${JSON.stringify(getNLSLanguage())};`,
		`globalThis._VSCODE_FILE_ROOT = ${JSON.stringify(globalThis._VSCODE_FILE_ROOT)};`,
		`globalThis._VSCODE_PRODUCT_JSON = ${JSON.stringify(globalThis._VSCODE_PRODUCT_JSON)};`,
		`const ttPolicy = globalThis.trustedTypes?.createPolicy('defaultWorkerFactory', { createScriptURL: value => value });`,
		`globalThis.workerttPolicy = ttPolicy;`,
		workerLoadingFailedErrorMessage ? "try {" : "",
		`await import(ttPolicy?.createScriptURL(${JSON.stringify(workerScriptUrl)}) ?? ${JSON.stringify(workerScriptUrl)});`,
		workerLoadingFailedErrorMessage ? `} catch (err) { console.error(${JSON.stringify(workerLoadingFailedErrorMessage)}, err); throw err; }` : "",
		`globalThis.postMessage({ type: 'vscode-worker-ready' });`,
		`/*${label}*/`
	]).join("")], { type: "application/javascript" });
	return URL.createObjectURL(blob);
}
function whenESMWorkerReady(worker) {
	return new Promise((resolve, reject) => {
		worker.onmessage = function(e) {
			if (e.data.type === "vscode-worker-ready") {
				worker.onmessage = null;
				resolve(worker);
			}
		};
		worker.onerror = reject;
	});
}
function isPromiseLike(obj) {
	return !!obj && typeof obj.then === "function";
}
var WebWorker = class extends Disposable {
	constructor(worker, id) {
		super();
		this._onMessage = this._register(new Emitter$1());
		this.onMessage = this._onMessage.event;
		this._onError = this._register(new Emitter$1());
		this.onError = this._onError.event;
		this.id = id;
		this.worker = worker;
		this.postMessage("-please-ignore-", []);
		const errorHandler = (ev) => {
			this._onError.fire(ev);
		};
		this.worker.then((w) => {
			w.onmessage = (ev) => {
				this._onMessage.fire(ev.data);
			};
			w.onmessageerror = (ev) => {
				this._onError.fire(ev);
			};
			if (typeof w.addEventListener === "function") w.addEventListener("error", errorHandler);
		});
		this._register(toDisposable(() => {
			this.worker?.then((w) => {
				w.onmessage = null;
				w.onmessageerror = null;
				w.removeEventListener("error", errorHandler);
				w.terminate();
			});
			this.worker = null;
		}));
	}
	getId() {
		return this.id;
	}
	postMessage(message, transfer) {
		this.worker?.then((w) => {
			try {
				w.postMessage(message, transfer);
			} catch (err) {
				onUnexpectedError(err);
				onUnexpectedError(new Error(`FAILED to post message to worker`, { cause: err }));
			}
		});
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/standalone/browser/services/standaloneWebWorkerService.js
var StandaloneWebWorkerService = class extends WebWorkerService {
	_createWorker(descriptor) {
		const monacoEnvironment = getMonacoEnvironment();
		if (monacoEnvironment) {
			if (typeof monacoEnvironment.getWorker === "function") {
				const worker = monacoEnvironment.getWorker("workerMain.js", descriptor.label);
				if (worker !== void 0) return Promise.resolve(worker);
			}
		}
		return super._createWorker(descriptor);
	}
	_getWorkerLoadingFailedErrorMessage(descriptor) {
		return `Failed to load worker script for label: ${descriptor.label}.
Ensure your bundler properly bundles modules referenced by "new URL('...?esm', import.meta.url)".`;
	}
	getWorkerUrl(descriptor) {
		const monacoEnvironment = getMonacoEnvironment();
		if (monacoEnvironment) {
			if (typeof monacoEnvironment.getWorkerUrl === "function") {
				const workerUrl = monacoEnvironment.getWorkerUrl("workerMain.js", descriptor.label);
				if (workerUrl !== void 0) return new URL(workerUrl, document.baseURI).toString();
			}
		}
		if (!descriptor.esmModuleLocationBundler) throw new Error(`You must define a function MonacoEnvironment.getWorkerUrl or MonacoEnvironment.getWorker for the worker label: ${descriptor.label}`);
		return (typeof descriptor.esmModuleLocationBundler === "function" ? descriptor.esmModuleLocationBundler() : descriptor.esmModuleLocationBundler).toString();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/standalone/common/themes.js
var vs = {
	base: "vs",
	inherit: false,
	rules: [
		{
			token: "",
			foreground: "000000",
			background: "fffffe"
		},
		{
			token: "invalid",
			foreground: "cd3131"
		},
		{
			token: "emphasis",
			fontStyle: "italic"
		},
		{
			token: "strong",
			fontStyle: "bold"
		},
		{
			token: "variable",
			foreground: "001188"
		},
		{
			token: "variable.predefined",
			foreground: "4864AA"
		},
		{
			token: "constant",
			foreground: "dd0000"
		},
		{
			token: "comment",
			foreground: "008000"
		},
		{
			token: "number",
			foreground: "098658"
		},
		{
			token: "number.hex",
			foreground: "3030c0"
		},
		{
			token: "regexp",
			foreground: "800000"
		},
		{
			token: "annotation",
			foreground: "808080"
		},
		{
			token: "type",
			foreground: "008080"
		},
		{
			token: "delimiter",
			foreground: "000000"
		},
		{
			token: "delimiter.html",
			foreground: "383838"
		},
		{
			token: "delimiter.xml",
			foreground: "0000FF"
		},
		{
			token: "tag",
			foreground: "800000"
		},
		{
			token: "tag.id.pug",
			foreground: "4F76AC"
		},
		{
			token: "tag.class.pug",
			foreground: "4F76AC"
		},
		{
			token: "meta.scss",
			foreground: "800000"
		},
		{
			token: "metatag",
			foreground: "e00000"
		},
		{
			token: "metatag.content.html",
			foreground: "FF0000"
		},
		{
			token: "metatag.html",
			foreground: "808080"
		},
		{
			token: "metatag.xml",
			foreground: "808080"
		},
		{
			token: "metatag.php",
			fontStyle: "bold"
		},
		{
			token: "key",
			foreground: "863B00"
		},
		{
			token: "string.key.json",
			foreground: "A31515"
		},
		{
			token: "string.value.json",
			foreground: "0451A5"
		},
		{
			token: "attribute.name",
			foreground: "FF0000"
		},
		{
			token: "attribute.value",
			foreground: "0451A5"
		},
		{
			token: "attribute.value.number",
			foreground: "098658"
		},
		{
			token: "attribute.value.unit",
			foreground: "098658"
		},
		{
			token: "attribute.value.html",
			foreground: "0000FF"
		},
		{
			token: "attribute.value.xml",
			foreground: "0000FF"
		},
		{
			token: "string",
			foreground: "A31515"
		},
		{
			token: "string.html",
			foreground: "0000FF"
		},
		{
			token: "string.sql",
			foreground: "FF0000"
		},
		{
			token: "string.yaml",
			foreground: "0451A5"
		},
		{
			token: "keyword",
			foreground: "0000FF"
		},
		{
			token: "keyword.json",
			foreground: "0451A5"
		},
		{
			token: "keyword.flow",
			foreground: "AF00DB"
		},
		{
			token: "keyword.flow.scss",
			foreground: "0000FF"
		},
		{
			token: "operator.scss",
			foreground: "666666"
		},
		{
			token: "operator.sql",
			foreground: "778899"
		},
		{
			token: "operator.swift",
			foreground: "666666"
		},
		{
			token: "predefined.sql",
			foreground: "C700C7"
		}
	],
	colors: {
		[editorBackground]: "#FFFFFE",
		[editorForeground]: "#000000",
		[editorInactiveSelection]: "#E5EBF1",
		[editorIndentGuide1]: "#D3D3D3",
		[editorActiveIndentGuide1]: "#939393",
		[editorSelectionHighlight]: "#ADD6FF4D"
	}
};
var vs_dark = {
	base: "vs-dark",
	inherit: false,
	rules: [
		{
			token: "",
			foreground: "D4D4D4",
			background: "1E1E1E"
		},
		{
			token: "invalid",
			foreground: "f44747"
		},
		{
			token: "emphasis",
			fontStyle: "italic"
		},
		{
			token: "strong",
			fontStyle: "bold"
		},
		{
			token: "variable",
			foreground: "74B0DF"
		},
		{
			token: "variable.predefined",
			foreground: "4864AA"
		},
		{
			token: "variable.parameter",
			foreground: "9CDCFE"
		},
		{
			token: "constant",
			foreground: "569CD6"
		},
		{
			token: "comment",
			foreground: "608B4E"
		},
		{
			token: "number",
			foreground: "B5CEA8"
		},
		{
			token: "number.hex",
			foreground: "5BB498"
		},
		{
			token: "regexp",
			foreground: "B46695"
		},
		{
			token: "annotation",
			foreground: "cc6666"
		},
		{
			token: "type",
			foreground: "3DC9B0"
		},
		{
			token: "delimiter",
			foreground: "DCDCDC"
		},
		{
			token: "delimiter.html",
			foreground: "808080"
		},
		{
			token: "delimiter.xml",
			foreground: "808080"
		},
		{
			token: "tag",
			foreground: "569CD6"
		},
		{
			token: "tag.id.pug",
			foreground: "4F76AC"
		},
		{
			token: "tag.class.pug",
			foreground: "4F76AC"
		},
		{
			token: "meta.scss",
			foreground: "A79873"
		},
		{
			token: "meta.tag",
			foreground: "CE9178"
		},
		{
			token: "metatag",
			foreground: "DD6A6F"
		},
		{
			token: "metatag.content.html",
			foreground: "9CDCFE"
		},
		{
			token: "metatag.html",
			foreground: "569CD6"
		},
		{
			token: "metatag.xml",
			foreground: "569CD6"
		},
		{
			token: "metatag.php",
			fontStyle: "bold"
		},
		{
			token: "key",
			foreground: "9CDCFE"
		},
		{
			token: "string.key.json",
			foreground: "9CDCFE"
		},
		{
			token: "string.value.json",
			foreground: "CE9178"
		},
		{
			token: "attribute.name",
			foreground: "9CDCFE"
		},
		{
			token: "attribute.value",
			foreground: "CE9178"
		},
		{
			token: "attribute.value.number.css",
			foreground: "B5CEA8"
		},
		{
			token: "attribute.value.unit.css",
			foreground: "B5CEA8"
		},
		{
			token: "attribute.value.hex.css",
			foreground: "D4D4D4"
		},
		{
			token: "string",
			foreground: "CE9178"
		},
		{
			token: "string.sql",
			foreground: "FF0000"
		},
		{
			token: "keyword",
			foreground: "569CD6"
		},
		{
			token: "keyword.flow",
			foreground: "C586C0"
		},
		{
			token: "keyword.json",
			foreground: "CE9178"
		},
		{
			token: "keyword.flow.scss",
			foreground: "569CD6"
		},
		{
			token: "operator.scss",
			foreground: "909090"
		},
		{
			token: "operator.sql",
			foreground: "778899"
		},
		{
			token: "operator.swift",
			foreground: "909090"
		},
		{
			token: "predefined.sql",
			foreground: "FF00FF"
		}
	],
	colors: {
		[editorBackground]: "#1E1E1E",
		[editorForeground]: "#D4D4D4",
		[editorInactiveSelection]: "#3A3D41",
		[editorIndentGuide1]: "#404040",
		[editorActiveIndentGuide1]: "#707070",
		[editorSelectionHighlight]: "#ADD6FF26"
	}
};
var hc_black = {
	base: "hc-black",
	inherit: false,
	rules: [
		{
			token: "",
			foreground: "FFFFFF",
			background: "000000"
		},
		{
			token: "invalid",
			foreground: "f44747"
		},
		{
			token: "emphasis",
			fontStyle: "italic"
		},
		{
			token: "strong",
			fontStyle: "bold"
		},
		{
			token: "variable",
			foreground: "1AEBFF"
		},
		{
			token: "variable.parameter",
			foreground: "9CDCFE"
		},
		{
			token: "constant",
			foreground: "569CD6"
		},
		{
			token: "comment",
			foreground: "608B4E"
		},
		{
			token: "number",
			foreground: "FFFFFF"
		},
		{
			token: "regexp",
			foreground: "C0C0C0"
		},
		{
			token: "annotation",
			foreground: "569CD6"
		},
		{
			token: "type",
			foreground: "3DC9B0"
		},
		{
			token: "delimiter",
			foreground: "FFFF00"
		},
		{
			token: "delimiter.html",
			foreground: "FFFF00"
		},
		{
			token: "tag",
			foreground: "569CD6"
		},
		{
			token: "tag.id.pug",
			foreground: "4F76AC"
		},
		{
			token: "tag.class.pug",
			foreground: "4F76AC"
		},
		{
			token: "meta",
			foreground: "D4D4D4"
		},
		{
			token: "meta.tag",
			foreground: "CE9178"
		},
		{
			token: "metatag",
			foreground: "569CD6"
		},
		{
			token: "metatag.content.html",
			foreground: "1AEBFF"
		},
		{
			token: "metatag.html",
			foreground: "569CD6"
		},
		{
			token: "metatag.xml",
			foreground: "569CD6"
		},
		{
			token: "metatag.php",
			fontStyle: "bold"
		},
		{
			token: "key",
			foreground: "9CDCFE"
		},
		{
			token: "string.key",
			foreground: "9CDCFE"
		},
		{
			token: "string.value",
			foreground: "CE9178"
		},
		{
			token: "attribute.name",
			foreground: "569CD6"
		},
		{
			token: "attribute.value",
			foreground: "3FF23F"
		},
		{
			token: "string",
			foreground: "CE9178"
		},
		{
			token: "string.sql",
			foreground: "FF0000"
		},
		{
			token: "keyword",
			foreground: "569CD6"
		},
		{
			token: "keyword.flow",
			foreground: "C586C0"
		},
		{
			token: "operator.sql",
			foreground: "778899"
		},
		{
			token: "operator.swift",
			foreground: "909090"
		},
		{
			token: "predefined.sql",
			foreground: "FF00FF"
		}
	],
	colors: {
		[editorBackground]: "#000000",
		[editorForeground]: "#FFFFFF",
		[editorIndentGuide1]: "#FFFFFF",
		[editorActiveIndentGuide1]: "#FFFFFF"
	}
};
var hc_light = {
	base: "hc-light",
	inherit: false,
	rules: [
		{
			token: "",
			foreground: "292929",
			background: "FFFFFF"
		},
		{
			token: "invalid",
			foreground: "B5200D"
		},
		{
			token: "emphasis",
			fontStyle: "italic"
		},
		{
			token: "strong",
			fontStyle: "bold"
		},
		{
			token: "variable",
			foreground: "264F70"
		},
		{
			token: "variable.predefined",
			foreground: "4864AA"
		},
		{
			token: "constant",
			foreground: "dd0000"
		},
		{
			token: "comment",
			foreground: "008000"
		},
		{
			token: "number",
			foreground: "098658"
		},
		{
			token: "number.hex",
			foreground: "3030c0"
		},
		{
			token: "regexp",
			foreground: "800000"
		},
		{
			token: "annotation",
			foreground: "808080"
		},
		{
			token: "type",
			foreground: "008080"
		},
		{
			token: "delimiter",
			foreground: "000000"
		},
		{
			token: "delimiter.html",
			foreground: "383838"
		},
		{
			token: "tag",
			foreground: "800000"
		},
		{
			token: "tag.id.pug",
			foreground: "4F76AC"
		},
		{
			token: "tag.class.pug",
			foreground: "4F76AC"
		},
		{
			token: "meta.scss",
			foreground: "800000"
		},
		{
			token: "metatag",
			foreground: "e00000"
		},
		{
			token: "metatag.content.html",
			foreground: "B5200D"
		},
		{
			token: "metatag.html",
			foreground: "808080"
		},
		{
			token: "metatag.xml",
			foreground: "808080"
		},
		{
			token: "metatag.php",
			fontStyle: "bold"
		},
		{
			token: "key",
			foreground: "863B00"
		},
		{
			token: "string.key.json",
			foreground: "A31515"
		},
		{
			token: "string.value.json",
			foreground: "0451A5"
		},
		{
			token: "attribute.name",
			foreground: "264F78"
		},
		{
			token: "attribute.value",
			foreground: "0451A5"
		},
		{
			token: "string",
			foreground: "A31515"
		},
		{
			token: "string.sql",
			foreground: "B5200D"
		},
		{
			token: "keyword",
			foreground: "0000FF"
		},
		{
			token: "keyword.flow",
			foreground: "AF00DB"
		},
		{
			token: "operator.sql",
			foreground: "778899"
		},
		{
			token: "operator.swift",
			foreground: "666666"
		},
		{
			token: "predefined.sql",
			foreground: "C700C7"
		}
	],
	colors: {
		[editorBackground]: "#FFFFFF",
		[editorForeground]: "#292929",
		[editorIndentGuide1]: "#292929",
		[editorActiveIndentGuide1]: "#292929"
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/theme/common/iconRegistry.js
var Extensions = { IconContribution: "base.contributions.icons" };
var IconContribution;
(function(IconContribution) {
	function getDefinition(contribution, registry) {
		let definition = contribution.defaults;
		while (ThemeIcon.isThemeIcon(definition)) {
			const c = iconRegistry.getIcon(definition.id);
			if (!c) return;
			definition = c.defaults;
		}
		return definition;
	}
	IconContribution.getDefinition = getDefinition;
})(IconContribution || (IconContribution = {}));
var IconFontDefinition;
(function(IconFontDefinition) {
	function toJSONObject(iconFont) {
		return {
			weight: iconFont.weight,
			style: iconFont.style,
			src: iconFont.src.map((s) => ({
				format: s.format,
				location: s.location.toString()
			}))
		};
	}
	IconFontDefinition.toJSONObject = toJSONObject;
	function fromJSONObject(json) {
		const stringOrUndef = (s) => isString$1(s) ? s : void 0;
		if (json && Array.isArray(json.src) && json.src.every((s) => isString$1(s.format) && isString$1(s.location))) return {
			weight: stringOrUndef(json.weight),
			style: stringOrUndef(json.style),
			src: json.src.map((s) => ({
				format: s.format,
				location: URI.parse(s.location)
			}))
		};
	}
	IconFontDefinition.fromJSONObject = fromJSONObject;
})(IconFontDefinition || (IconFontDefinition = {}));
var fontIdRegex = /^([\w_-]+)$/;
var fontIdErrorMessage = localize(2126, "The font ID must only contain letters, numbers, underscores and dashes.");
var IconRegistry = class extends Disposable {
	constructor() {
		super();
		this._onDidChange = this._register(new Emitter$1());
		this.onDidChange = this._onDidChange.event;
		this.iconSchema = {
			definitions: { icons: {
				type: "object",
				properties: {
					fontId: {
						type: "string",
						description: localize(2127, "The id of the font to use. If not set, the font that is defined first is used."),
						pattern: fontIdRegex.source,
						patternErrorMessage: fontIdErrorMessage
					},
					fontCharacter: {
						type: "string",
						description: localize(2128, "The font character associated with the icon definition.")
					}
				},
				additionalProperties: false,
				defaultSnippets: [{ body: { fontCharacter: "\\\\e030" } }]
			} },
			type: "object",
			properties: {}
		};
		this.iconReferenceSchema = {
			type: "string",
			pattern: `^${ThemeIcon.iconNameExpression}$`,
			enum: [],
			enumDescriptions: []
		};
		this.iconsById = {};
		this.iconFontsById = {};
	}
	registerIcon(id, defaults, description, deprecationMessage) {
		const existing = this.iconsById[id];
		if (existing) {
			if (description && !existing.description) {
				existing.description = description;
				this.iconSchema.properties[id].markdownDescription = `${description} $(${id})`;
				const enumIndex = this.iconReferenceSchema.enum.indexOf(id);
				if (enumIndex !== -1) this.iconReferenceSchema.enumDescriptions[enumIndex] = description;
				this._onDidChange.fire();
			}
			return existing;
		}
		const iconContribution = {
			id,
			description,
			defaults,
			deprecationMessage
		};
		this.iconsById[id] = iconContribution;
		const propertySchema = { $ref: "#/definitions/icons" };
		if (deprecationMessage) propertySchema.deprecationMessage = deprecationMessage;
		if (description) propertySchema.markdownDescription = `${description}: $(${id})`;
		this.iconSchema.properties[id] = propertySchema;
		this.iconReferenceSchema.enum.push(id);
		this.iconReferenceSchema.enumDescriptions.push(description || "");
		this._onDidChange.fire();
		return { id };
	}
	getIcons() {
		return Object.keys(this.iconsById).map((id) => this.iconsById[id]);
	}
	getIcon(id) {
		return this.iconsById[id];
	}
	getIconSchema() {
		return this.iconSchema;
	}
	toString() {
		const sorter = (i1, i2) => {
			return i1.id.localeCompare(i2.id);
		};
		const classNames = (i) => {
			while (ThemeIcon.isThemeIcon(i.defaults)) i = this.iconsById[i.defaults.id];
			return `codicon codicon-${i ? i.id : ""}`;
		};
		const reference = [];
		reference.push(`| preview     | identifier                        | default codicon ID                | description`);
		reference.push(`| ----------- | --------------------------------- | --------------------------------- | --------------------------------- |`);
		const contributions = Object.keys(this.iconsById).map((key) => this.iconsById[key]);
		for (const i of contributions.filter((i) => !!i.description).sort(sorter)) reference.push(`|<i class="${classNames(i)}"></i>|${i.id}|${ThemeIcon.isThemeIcon(i.defaults) ? i.defaults.id : i.id}|${i.description || ""}|`);
		reference.push(`| preview     | identifier                        `);
		reference.push(`| ----------- | --------------------------------- |`);
		for (const i of contributions.filter((i) => !ThemeIcon.isThemeIcon(i.defaults)).sort(sorter)) reference.push(`|<i class="${classNames(i)}"></i>|${i.id}|`);
		return reference.join("\n");
	}
};
var iconRegistry = new IconRegistry();
Registry.add(Extensions.IconContribution, iconRegistry);
function registerIcon(id, defaults, description, deprecationMessage) {
	return iconRegistry.registerIcon(id, defaults, description, deprecationMessage);
}
function getIconRegistry() {
	return iconRegistry;
}
function initialize() {
	const codiconFontCharacters = getCodiconFontCharacters();
	for (const icon in codiconFontCharacters) {
		const fontCharacter = "\\" + codiconFontCharacters[icon].toString(16);
		iconRegistry.registerIcon(icon, { fontCharacter });
	}
}
initialize();
var iconsSchemaId = "vscode://schemas/icons";
var schemaRegistry = Registry.as(Extensions$7.JSONContribution);
schemaRegistry.registerSchema(iconsSchemaId, iconRegistry.getIconSchema());
var delayer = new RunOnceScheduler(() => schemaRegistry.notifySchemaChanged(iconsSchemaId), 200);
iconRegistry.onDidChange(() => {
	if (!delayer.isScheduled()) delayer.schedule();
});
var widgetClose = registerIcon("widget-close", Codicon.close, localize(2129, "Icon for the close action in widgets."));
registerIcon("goto-previous-location", Codicon.arrowUp, localize(2130, "Icon for goto previous editor location."));
registerIcon("goto-next-location", Codicon.arrowDown, localize(2131, "Icon for goto next editor location."));
ThemeIcon.modify(Codicon.sync, "spin");
ThemeIcon.modify(Codicon.loading, "spin");
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/theme/browser/iconsStyleSheet.js
function getIconsStyleSheet(themeService) {
	const disposable = new DisposableStore();
	const onDidChangeEmmiter = disposable.add(new Emitter$1());
	const iconRegistry = getIconRegistry();
	disposable.add(iconRegistry.onDidChange(() => onDidChangeEmmiter.fire()));
	if (themeService) disposable.add(themeService.onDidProductIconThemeChange(() => onDidChangeEmmiter.fire()));
	return {
		dispose: () => disposable.dispose(),
		onDidChange: onDidChangeEmmiter.event,
		getCSS() {
			const productIconTheme = themeService ? themeService.getProductIconTheme() : new UnthemedProductIconTheme();
			const usedFontIds = {};
			const rules = new Builder();
			const rootAttribs = new Builder();
			for (const contribution of iconRegistry.getIcons()) {
				const definition = productIconTheme.getIcon(contribution);
				if (!definition) continue;
				const fontContribution = definition.font;
				const fontFamilyVar = inline`--vscode-icon-${className(contribution.id)}-font-family`;
				const contentVar = inline`--vscode-icon-${className(contribution.id)}-content`;
				if (fontContribution) {
					usedFontIds[fontContribution.id] = fontContribution.definition;
					rootAttribs.push(inline`${fontFamilyVar}: ${stringValue(fontContribution.id)};`, inline`${contentVar}: ${stringValue(definition.fontCharacter)};`);
					rules.push(inline`.codicon-${className(contribution.id)}:before { content: ${stringValue(definition.fontCharacter)}; font-family: ${stringValue(fontContribution.id)}; }`);
				} else {
					rootAttribs.push(inline`${contentVar}: ${stringValue(definition.fontCharacter)}; ${fontFamilyVar}: 'codicon';`);
					rules.push(inline`.codicon-${className(contribution.id)}:before { content: ${stringValue(definition.fontCharacter)}; }`);
				}
			}
			for (const id in usedFontIds) {
				const definition = usedFontIds[id];
				const fontWeight = definition.weight ? inline`font-weight: ${identValue(definition.weight)};` : inline``;
				const fontStyle = definition.style ? inline`font-style: ${identValue(definition.style)};` : inline``;
				const src = new Builder();
				for (const l of definition.src) src.push(inline`${asCSSUrl(l.location)} format(${stringValue(l.format)})`);
				rules.push(inline`@font-face { src: ${src.join(", ")}; font-family: ${stringValue(id)};${fontWeight}${fontStyle} font-display: block; }`);
			}
			rules.push(inline`:root { ${rootAttribs.join(" ")} }`);
			return rules.join("\n");
		}
	};
}
var UnthemedProductIconTheme = class {
	getIcon(contribution) {
		const iconRegistry = getIconRegistry();
		let definition = contribution.defaults;
		while (ThemeIcon.isThemeIcon(definition)) {
			const c = iconRegistry.getIcon(definition.id);
			if (!c) return;
			definition = c.defaults;
		}
		return definition;
	}
};
var VS_DARK_THEME_NAME = "vs-dark";
var HC_BLACK_THEME_NAME = "hc-black";
var HC_LIGHT_THEME_NAME = "hc-light";
var colorRegistry = Registry.as(Extensions$4.ColorContribution);
var themingRegistry = Registry.as(Extensions$2.ThemingContribution);
var StandaloneTheme = class {
	constructor(name, standaloneThemeData) {
		this.semanticHighlighting = false;
		this.themeData = standaloneThemeData;
		const base = standaloneThemeData.base;
		if (name.length > 0) {
			if (isBuiltinTheme(name)) this.id = name;
			else this.id = base + " " + name;
			this.themeName = name;
		} else {
			this.id = base;
			this.themeName = base;
		}
		this.colors = null;
		this.defaultColors = Object.create(null);
		this._tokenTheme = null;
	}
	get base() {
		return this.themeData.base;
	}
	notifyBaseUpdated() {
		if (this.themeData.inherit) {
			this.colors = null;
			this._tokenTheme = null;
		}
	}
	getColors() {
		if (!this.colors) {
			const colors = /* @__PURE__ */ new Map();
			for (const id in this.themeData.colors) colors.set(id, Color.fromHex(this.themeData.colors[id]));
			if (this.themeData.inherit) {
				const baseData = getBuiltinRules(this.themeData.base);
				for (const id in baseData.colors) if (!colors.has(id)) colors.set(id, Color.fromHex(baseData.colors[id]));
			}
			this.colors = colors;
		}
		return this.colors;
	}
	getColor(colorId, useDefault) {
		const color = this.getColors().get(colorId);
		if (color) return color;
		if (useDefault !== false) return this.getDefault(colorId);
	}
	getDefault(colorId) {
		let color = this.defaultColors[colorId];
		if (color) return color;
		color = colorRegistry.resolveDefaultColor(colorId, this);
		this.defaultColors[colorId] = color;
		return color;
	}
	defines(colorId) {
		return this.getColors().has(colorId);
	}
	get type() {
		switch (this.base) {
			case "vs": return ColorScheme.LIGHT;
			case HC_BLACK_THEME_NAME: return ColorScheme.HIGH_CONTRAST_DARK;
			case HC_LIGHT_THEME_NAME: return ColorScheme.HIGH_CONTRAST_LIGHT;
			default: return ColorScheme.DARK;
		}
	}
	get tokenTheme() {
		if (!this._tokenTheme) {
			let rules = [];
			let encodedTokensColors = [];
			if (this.themeData.inherit) {
				const baseData = getBuiltinRules(this.themeData.base);
				rules = baseData.rules;
				if (baseData.encodedTokensColors) encodedTokensColors = baseData.encodedTokensColors;
			}
			const editorForeground = this.themeData.colors["editor.foreground"];
			const editorBackground = this.themeData.colors["editor.background"];
			if (editorForeground || editorBackground) {
				const rule = { token: "" };
				if (editorForeground) rule.foreground = editorForeground;
				if (editorBackground) rule.background = editorBackground;
				rules.push(rule);
			}
			rules = rules.concat(this.themeData.rules);
			if (this.themeData.encodedTokensColors) encodedTokensColors = this.themeData.encodedTokensColors;
			this._tokenTheme = TokenTheme.createFromRawTokenTheme(rules, encodedTokensColors);
		}
		return this._tokenTheme;
	}
	getTokenStyleMetadata(type, modifiers, modelLanguage) {
		const metadata = this.tokenTheme._match([type].concat(modifiers).join(".")).metadata;
		const foreground = TokenMetadata.getForeground(metadata);
		const fontStyle = TokenMetadata.getFontStyle(metadata);
		return {
			foreground,
			italic: Boolean(fontStyle & 1),
			bold: Boolean(fontStyle & 2),
			underline: Boolean(fontStyle & 4),
			strikethrough: Boolean(fontStyle & 8)
		};
	}
	get tokenColorMap() {
		return [];
	}
};
function isBuiltinTheme(themeName) {
	return themeName === "vs" || themeName === "vs-dark" || themeName === "hc-black" || themeName === "hc-light";
}
function getBuiltinRules(builtinTheme) {
	switch (builtinTheme) {
		case "vs": return vs;
		case VS_DARK_THEME_NAME: return vs_dark;
		case HC_BLACK_THEME_NAME: return hc_black;
		case HC_LIGHT_THEME_NAME: return hc_light;
	}
}
function newBuiltInTheme(builtinTheme) {
	return new StandaloneTheme(builtinTheme, getBuiltinRules(builtinTheme));
}
var StandaloneThemeService = class extends Disposable {
	constructor() {
		super();
		this._onColorThemeChange = this._register(new Emitter$1());
		this.onDidColorThemeChange = this._onColorThemeChange.event;
		this._onProductIconThemeChange = this._register(new Emitter$1());
		this.onDidProductIconThemeChange = this._onProductIconThemeChange.event;
		this._environment = Object.create(null);
		this._builtInProductIconTheme = new UnthemedProductIconTheme();
		this._autoDetectHighContrast = true;
		this._knownThemes = /* @__PURE__ */ new Map();
		this._knownThemes.set("vs", newBuiltInTheme("vs"));
		this._knownThemes.set(VS_DARK_THEME_NAME, newBuiltInTheme(VS_DARK_THEME_NAME));
		this._knownThemes.set(HC_BLACK_THEME_NAME, newBuiltInTheme(HC_BLACK_THEME_NAME));
		this._knownThemes.set(HC_LIGHT_THEME_NAME, newBuiltInTheme(HC_LIGHT_THEME_NAME));
		const iconsStyleSheet = this._register(getIconsStyleSheet(this));
		this._codiconCSS = iconsStyleSheet.getCSS();
		this._themeCSS = "";
		this._allCSS = `${this._codiconCSS}\n${this._themeCSS}`;
		this._globalStyleElement = null;
		this._styleElements = [];
		this._colorMapOverride = null;
		this.setTheme("vs");
		this._onOSSchemeChanged();
		this._register(iconsStyleSheet.onDidChange(() => {
			this._codiconCSS = iconsStyleSheet.getCSS();
			this._updateCSS();
		}));
		addMatchMediaChangeListener(mainWindow, "(forced-colors: active)", () => {
			this._onOSSchemeChanged();
		});
	}
	registerEditorContainer(domNode) {
		if (isInShadowDOM(domNode)) return this._registerShadowDomContainer(domNode);
		return this._registerRegularEditorContainer();
	}
	_registerRegularEditorContainer() {
		if (!this._globalStyleElement) {
			this._globalStyleElement = createStyleSheet(void 0, (style) => {
				style.className = "monaco-colors";
				style.textContent = this._allCSS;
			});
			this._styleElements.push(this._globalStyleElement);
		}
		return Disposable.None;
	}
	_registerShadowDomContainer(domNode) {
		const styleElement = createStyleSheet(domNode, (style) => {
			style.className = "monaco-colors";
			style.textContent = this._allCSS;
		});
		this._styleElements.push(styleElement);
		return { dispose: () => {
			for (let i = 0; i < this._styleElements.length; i++) if (this._styleElements[i] === styleElement) {
				this._styleElements.splice(i, 1);
				return;
			}
		} };
	}
	defineTheme(themeName, themeData) {
		if (!/^[a-z0-9\-]+$/i.test(themeName)) throw new Error("Illegal theme name!");
		if (!isBuiltinTheme(themeData.base) && !isBuiltinTheme(themeName)) throw new Error("Illegal theme base!");
		this._knownThemes.set(themeName, new StandaloneTheme(themeName, themeData));
		if (isBuiltinTheme(themeName)) this._knownThemes.forEach((theme) => {
			if (theme.base === themeName) theme.notifyBaseUpdated();
		});
		if (this._theme.themeName === themeName) this.setTheme(themeName);
	}
	getColorTheme() {
		return this._theme;
	}
	setColorMapOverride(colorMapOverride) {
		this._colorMapOverride = colorMapOverride;
		this._updateThemeOrColorMap();
	}
	setTheme(themeName) {
		let theme;
		if (this._knownThemes.has(themeName)) theme = this._knownThemes.get(themeName);
		else theme = this._knownThemes.get("vs");
		this._updateActualTheme(theme);
	}
	_updateActualTheme(desiredTheme) {
		if (!desiredTheme || this._theme === desiredTheme) return;
		this._theme = desiredTheme;
		this._updateThemeOrColorMap();
	}
	_onOSSchemeChanged() {
		if (this._autoDetectHighContrast) {
			const wantsHighContrast = mainWindow.matchMedia(`(forced-colors: active)`).matches;
			if (wantsHighContrast !== isHighContrast(this._theme.type)) {
				let newThemeName;
				if (isDark(this._theme.type)) newThemeName = wantsHighContrast ? HC_BLACK_THEME_NAME : VS_DARK_THEME_NAME;
				else newThemeName = wantsHighContrast ? HC_LIGHT_THEME_NAME : "vs";
				this._updateActualTheme(this._knownThemes.get(newThemeName));
			}
		}
	}
	setAutoDetectHighContrast(autoDetectHighContrast) {
		this._autoDetectHighContrast = autoDetectHighContrast;
		this._onOSSchemeChanged();
	}
	_updateThemeOrColorMap() {
		const cssRules = [];
		const hasRule = {};
		const ruleCollector = { addRule: (rule) => {
			if (!hasRule[rule]) {
				cssRules.push(rule);
				hasRule[rule] = true;
			}
		} };
		themingRegistry.getThemingParticipants().forEach((p) => p(this._theme, ruleCollector, this._environment));
		const colorVariables = [];
		for (const item of colorRegistry.getColors()) {
			const color = this._theme.getColor(item.id, true);
			if (color) colorVariables.push(`${asCssVariableName(item.id)}: ${color.toString()};`);
		}
		ruleCollector.addRule(`.monaco-editor, .monaco-diff-editor, .monaco-component { ${colorVariables.join("\n")} }`);
		const colorMap = this._colorMapOverride || this._theme.tokenTheme.getColorMap();
		ruleCollector.addRule(generateTokensCSSForColorMap(colorMap));
		ruleCollector.addRule(`.monaco-editor, .monaco-diff-editor, .monaco-component { forced-color-adjust: none; }`);
		this._themeCSS = cssRules.join("\n");
		this._updateCSS();
		TokenizationRegistry.setColorMap(colorMap);
		this._onColorThemeChange.fire(this._theme);
	}
	_updateCSS() {
		this._allCSS = `${this._codiconCSS}\n${this._themeCSS}`;
		this._styleElements.forEach((styleElement) => styleElement.textContent = this._allCSS);
	}
	getFileIconTheme() {
		return {
			hasFileIcons: false,
			hasFolderIcons: false,
			hidesExplorerArrows: false
		};
	}
	getProductIconTheme() {
		return this._builtInProductIconTheme;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/standalone/browser/standaloneTreeSitterLibraryService.js
var StandaloneTreeSitterLibraryService = class {
	getParserClass() {
		throw new Error("not implemented in StandaloneTreeSitterLibraryService");
	}
	supportsLanguage(languageId, reader) {
		return false;
	}
	getLanguage(languageId, ignoreSupportsCheck, reader) {}
	getInjectionQueries(languageId, reader) {
		return null;
	}
	getHighlightingQueries(languageId, reader) {
		return null;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/standalone/browser/standaloneServices.js
var __decorate$16 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$16 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var StandaloneEditorProgressService = class StandaloneEditorProgressService {
	static {
		this.NULL_PROGRESS_RUNNER = {
			done: () => {},
			total: () => {},
			worked: () => {}
		};
	}
	show() {
		return StandaloneEditorProgressService.NULL_PROGRESS_RUNNER;
	}
	async showWhile(promise, delay) {
		await promise;
	}
};
var StandaloneProgressService = class {
	withProgress(_options, task, onDidCancel) {
		return task({ report: () => {} });
	}
};
var StandaloneEnvironmentService = class {
	constructor() {
		this.isExtensionDevelopment = false;
		this.isBuilt = false;
	}
};
var StandaloneDialogService = class {
	async confirm(confirmation) {
		return {
			confirmed: this.doConfirm(confirmation.message, confirmation.detail),
			checkboxChecked: false
		};
	}
	doConfirm(message, detail) {
		let messageText = message;
		if (detail) messageText = messageText + "\n\n" + (typeof detail === "object" ? renderAsPlaintext(detail) : detail);
		return mainWindow.confirm(messageText);
	}
	async prompt(prompt) {
		let result = void 0;
		if (this.doConfirm(prompt.message, prompt.detail)) {
			const promptButtons = [...prompt.buttons ?? []];
			if (prompt.cancelButton && typeof prompt.cancelButton !== "string" && typeof prompt.cancelButton !== "boolean") promptButtons.push(prompt.cancelButton);
			result = await promptButtons[0]?.run({ checkboxChecked: false });
		}
		return { result };
	}
	async error(message, detail) {
		await this.prompt({
			type: Severity$1$1.Error,
			message,
			detail
		});
	}
};
var StandaloneNotificationService = class StandaloneNotificationService {
	static {
		this.NO_OP = new NoOpNotification();
	}
	info(message) {
		return this.notify({
			severity: Severity$1$1.Info,
			message
		});
	}
	warn(message) {
		return this.notify({
			severity: Severity$1$1.Warning,
			message
		});
	}
	error(error) {
		return this.notify({
			severity: Severity$1$1.Error,
			message: error
		});
	}
	notify(notification) {
		switch (notification.severity) {
			case Severity$1$1.Error:
				console.error(notification.message);
				break;
			case Severity$1$1.Warning:
				console.warn(notification.message);
				break;
			default: console.log(notification.message);
		}
		return StandaloneNotificationService.NO_OP;
	}
	prompt(severity, message, choices, options) {
		return StandaloneNotificationService.NO_OP;
	}
	status(message, options) {
		return { close: () => {} };
	}
};
var StandaloneCommandService = class StandaloneCommandService {
	constructor(instantiationService) {
		this._onWillExecuteCommand = new Emitter$1();
		this._onDidExecuteCommand = new Emitter$1();
		this.onDidExecuteCommand = this._onDidExecuteCommand.event;
		this._instantiationService = instantiationService;
	}
	executeCommand(id, ...args) {
		const command = CommandsRegistry.getCommand(id);
		if (!command) return Promise.reject(/* @__PURE__ */ new Error(`command '${id}' not found`));
		try {
			this._onWillExecuteCommand.fire({
				commandId: id,
				args
			});
			const result = this._instantiationService.invokeFunction.apply(this._instantiationService, [command.handler, ...args]);
			this._onDidExecuteCommand.fire({
				commandId: id,
				args
			});
			return Promise.resolve(result);
		} catch (err) {
			return Promise.reject(err);
		}
	}
};
StandaloneCommandService = __decorate$16([__param$16(0, IInstantiationService)], StandaloneCommandService);
var StandaloneKeybindingService = class StandaloneKeybindingService extends AbstractKeybindingService {
	constructor(contextKeyService, commandService, telemetryService, notificationService, logService, codeEditorService) {
		super(contextKeyService, commandService, telemetryService, notificationService, logService);
		this._cachedResolver = null;
		this._dynamicKeybindings = [];
		this._domNodeListeners = [];
		const addContainer = (domNode) => {
			const disposables = new DisposableStore();
			disposables.add(addDisposableListener(domNode, EventType$1.KEY_DOWN, (e) => {
				const keyEvent = new StandardKeyboardEvent(e);
				if (this._dispatch(keyEvent, keyEvent.target)) {
					keyEvent.preventDefault();
					keyEvent.stopPropagation();
				}
			}));
			disposables.add(addDisposableListener(domNode, EventType$1.KEY_UP, (e) => {
				const keyEvent = new StandardKeyboardEvent(e);
				if (this._singleModifierDispatch(keyEvent, keyEvent.target)) keyEvent.preventDefault();
			}));
			this._domNodeListeners.push(new DomNodeListeners(domNode, disposables));
		};
		const removeContainer = (domNode) => {
			for (let i = 0; i < this._domNodeListeners.length; i++) {
				const domNodeListeners = this._domNodeListeners[i];
				if (domNodeListeners.domNode === domNode) {
					this._domNodeListeners.splice(i, 1);
					domNodeListeners.dispose();
				}
			}
		};
		const addCodeEditor = (codeEditor) => {
			if (codeEditor.getOption(70)) return;
			addContainer(codeEditor.getContainerDomNode());
		};
		const removeCodeEditor = (codeEditor) => {
			if (codeEditor.getOption(70)) return;
			removeContainer(codeEditor.getContainerDomNode());
		};
		this._register(codeEditorService.onCodeEditorAdd(addCodeEditor));
		this._register(codeEditorService.onCodeEditorRemove(removeCodeEditor));
		codeEditorService.listCodeEditors().forEach(addCodeEditor);
		const addDiffEditor = (diffEditor) => {
			addContainer(diffEditor.getContainerDomNode());
		};
		const removeDiffEditor = (diffEditor) => {
			removeContainer(diffEditor.getContainerDomNode());
		};
		this._register(codeEditorService.onDiffEditorAdd(addDiffEditor));
		this._register(codeEditorService.onDiffEditorRemove(removeDiffEditor));
		codeEditorService.listDiffEditors().forEach(addDiffEditor);
	}
	addDynamicKeybinding(command, keybinding, handler, when) {
		return combinedDisposable(CommandsRegistry.registerCommand(command, handler), this.addDynamicKeybindings([{
			keybinding,
			command,
			when
		}]));
	}
	addDynamicKeybindings(rules) {
		const entries = rules.map((rule) => {
			return {
				keybinding: decodeKeybinding(rule.keybinding, OS),
				command: rule.command ?? null,
				commandArgs: rule.commandArgs,
				when: rule.when,
				weight1: 1e3,
				weight2: 0,
				extensionId: null,
				isBuiltinExtension: false
			};
		});
		this._dynamicKeybindings = this._dynamicKeybindings.concat(entries);
		this.updateResolver();
		return toDisposable(() => {
			for (let i = 0; i < this._dynamicKeybindings.length; i++) if (this._dynamicKeybindings[i] === entries[0]) {
				this._dynamicKeybindings.splice(i, entries.length);
				this.updateResolver();
				return;
			}
		});
	}
	updateResolver() {
		this._cachedResolver = null;
		this._onDidUpdateKeybindings.fire();
	}
	_getResolver() {
		if (!this._cachedResolver) {
			const defaults = this._toNormalizedKeybindingItems(KeybindingsRegistry.getDefaultKeybindings(), true);
			const overrides = this._toNormalizedKeybindingItems(this._dynamicKeybindings, false);
			this._cachedResolver = new KeybindingResolver(defaults, overrides, (str) => this._log(str));
		}
		return this._cachedResolver;
	}
	_documentHasFocus() {
		return mainWindow.document.hasFocus();
	}
	_toNormalizedKeybindingItems(items, isDefault) {
		const result = [];
		let resultLen = 0;
		for (const item of items) {
			const when = item.when || void 0;
			const keybinding = item.keybinding;
			if (!keybinding) result[resultLen++] = new ResolvedKeybindingItem(void 0, item.command, item.commandArgs, when, isDefault, null, false);
			else {
				const resolvedKeybindings = USLayoutResolvedKeybinding.resolveKeybinding(keybinding, OS);
				for (const resolvedKeybinding of resolvedKeybindings) result[resultLen++] = new ResolvedKeybindingItem(resolvedKeybinding, item.command, item.commandArgs, when, isDefault, null, false);
			}
		}
		return result;
	}
	resolveKeyboardEvent(keyboardEvent) {
		return new USLayoutResolvedKeybinding([new KeyCodeChord(keyboardEvent.ctrlKey, keyboardEvent.shiftKey, keyboardEvent.altKey, keyboardEvent.metaKey, keyboardEvent.keyCode)], OS);
	}
};
StandaloneKeybindingService = __decorate$16([
	__param$16(0, IContextKeyService),
	__param$16(1, ICommandService),
	__param$16(2, ITelemetryService),
	__param$16(3, INotificationService),
	__param$16(4, ILogService),
	__param$16(5, ICodeEditorService)
], StandaloneKeybindingService);
var DomNodeListeners = class extends Disposable {
	constructor(domNode, disposables) {
		super();
		this.domNode = domNode;
		this._register(disposables);
	}
};
function isConfigurationOverrides(thing) {
	return !!thing && typeof thing === "object" && (!thing.overrideIdentifier || typeof thing.overrideIdentifier === "string") && (!thing.resource || thing.resource instanceof URI);
}
var StandaloneConfigurationService = class StandaloneConfigurationService {
	constructor(logService) {
		this.logService = logService;
		this._onDidChangeConfiguration = new Emitter$1();
		this.onDidChangeConfiguration = this._onDidChangeConfiguration.event;
		const defaultConfiguration = new DefaultConfiguration(logService);
		this._configuration = new Configuration(defaultConfiguration.reload(), ConfigurationModel.createEmptyModel(logService), ConfigurationModel.createEmptyModel(logService), ConfigurationModel.createEmptyModel(logService), ConfigurationModel.createEmptyModel(logService), ConfigurationModel.createEmptyModel(logService), new ResourceMap(), ConfigurationModel.createEmptyModel(logService), new ResourceMap(), logService);
		defaultConfiguration.dispose();
	}
	getValue(arg1, arg2) {
		const section = typeof arg1 === "string" ? arg1 : void 0;
		const overrides = isConfigurationOverrides(arg1) ? arg1 : isConfigurationOverrides(arg2) ? arg2 : {};
		return this._configuration.getValue(section, overrides, void 0);
	}
	updateValues(values) {
		const previous = { data: this._configuration.toData() };
		const changedKeys = [];
		for (const entry of values) {
			const [key, value] = entry;
			if (this.getValue(key) === value) continue;
			this._configuration.updateValue(key, value);
			changedKeys.push(key);
		}
		if (changedKeys.length > 0) {
			const configurationChangeEvent = new ConfigurationChangeEvent({
				keys: changedKeys,
				overrides: []
			}, previous, this._configuration, void 0, this.logService);
			configurationChangeEvent.source = 8;
			this._onDidChangeConfiguration.fire(configurationChangeEvent);
		}
		return Promise.resolve();
	}
	updateValue(key, value, arg3, arg4) {
		return this.updateValues([[key, value]]);
	}
	inspect(key, options = {}) {
		return this._configuration.inspect(key, options, void 0);
	}
};
StandaloneConfigurationService = __decorate$16([__param$16(0, ILogService)], StandaloneConfigurationService);
var StandaloneResourceConfigurationService = class StandaloneResourceConfigurationService extends Disposable {
	constructor(configurationService, modelService, languageService) {
		super();
		this.configurationService = configurationService;
		this.modelService = modelService;
		this.languageService = languageService;
		this._onDidChangeConfiguration = this._register(new Emitter$1());
		this._register(this.configurationService.onDidChangeConfiguration((e) => {
			this._onDidChangeConfiguration.fire({
				affectedKeys: e.affectedKeys,
				affectsConfiguration: (resource, configuration) => e.affectsConfiguration(configuration)
			});
		}));
	}
	getValue(resource, arg2, arg3) {
		const position = Position$1.isIPosition(arg2) ? arg2 : null;
		const section = position ? typeof arg3 === "string" ? arg3 : void 0 : typeof arg2 === "string" ? arg2 : void 0;
		const language = resource ? this.getLanguage(resource, position) : void 0;
		if (typeof section === "undefined") return this.configurationService.getValue({
			resource,
			overrideIdentifier: language
		});
		return this.configurationService.getValue(section, {
			resource,
			overrideIdentifier: language
		});
	}
	getLanguage(resource, position) {
		const model = this.modelService.getModel(resource);
		if (model) return position ? model.getLanguageIdAtPosition(position.lineNumber, position.column) : model.getLanguageId();
		return this.languageService.guessLanguageIdByFilepathOrFirstLine(resource);
	}
};
StandaloneResourceConfigurationService = __decorate$16([
	__param$16(0, IConfigurationService),
	__param$16(1, IModelService),
	__param$16(2, ILanguageService)
], StandaloneResourceConfigurationService);
var StandaloneResourcePropertiesService = class StandaloneResourcePropertiesService {
	constructor(configurationService) {
		this.configurationService = configurationService;
	}
	getEOL(resource, language) {
		const eol = this.configurationService.getValue("files.eol", {
			overrideIdentifier: language,
			resource
		});
		if (eol && typeof eol === "string" && eol !== "auto") return eol;
		return isLinux || isMacintosh ? "\n" : "\r\n";
	}
};
StandaloneResourcePropertiesService = __decorate$16([__param$16(0, IConfigurationService)], StandaloneResourcePropertiesService);
var StandaloneTelemetryService = class {
	publicLog2() {}
};
var StandaloneWorkspaceContextService = class StandaloneWorkspaceContextService {
	static {
		this.SCHEME = "inmemory";
	}
	constructor() {
		const resource = URI.from({
			scheme: StandaloneWorkspaceContextService.SCHEME,
			authority: "model",
			path: "/"
		});
		this.workspace = {
			id: STANDALONE_EDITOR_WORKSPACE_ID,
			folders: [new WorkspaceFolder({
				uri: resource,
				name: "",
				index: 0
			})]
		};
	}
	getWorkspace() {
		return this.workspace;
	}
	getWorkspaceFolder(resource) {
		return resource && resource.scheme === StandaloneWorkspaceContextService.SCHEME ? this.workspace.folders[0] : null;
	}
};
function updateConfigurationService(configurationService, source, isDiffEditor) {
	if (!source) return;
	if (!(configurationService instanceof StandaloneConfigurationService)) return;
	const toUpdate = [];
	Object.keys(source).forEach((key) => {
		if (isEditorConfigurationKey(key)) toUpdate.push([`editor.${key}`, source[key]]);
		if (isDiffEditor && isDiffEditorConfigurationKey(key)) toUpdate.push([`diffEditor.${key}`, source[key]]);
	});
	if (toUpdate.length > 0) configurationService.updateValues(toUpdate);
}
var StandaloneBulkEditService = class StandaloneBulkEditService {
	constructor(_modelService) {
		this._modelService = _modelService;
	}
	hasPreviewHandler() {
		return false;
	}
	async apply(editsIn, _options) {
		const edits = Array.isArray(editsIn) ? editsIn : ResourceEdit.convert(editsIn);
		const textEdits = /* @__PURE__ */ new Map();
		for (const edit of edits) {
			if (!(edit instanceof ResourceTextEdit)) throw new Error("bad edit - only text edits are supported");
			const model = this._modelService.getModel(edit.resource);
			if (!model) throw new Error("bad edit - model not found");
			if (typeof edit.versionId === "number" && model.getVersionId() !== edit.versionId) throw new Error("bad state - model changed in the meantime");
			let array = textEdits.get(model);
			if (!array) {
				array = [];
				textEdits.set(model, array);
			}
			array.push(EditOperation.replaceMove(Range$2.lift(edit.textEdit.range), edit.textEdit.text));
		}
		let totalEdits = 0;
		let totalFiles = 0;
		for (const [model, edits] of textEdits) {
			model.pushStackElement();
			model.pushEditOperations([], edits, () => []);
			model.pushStackElement();
			totalFiles += 1;
			totalEdits += edits.length;
		}
		return {
			ariaSummary: format(StandaloneServicesNLS.bulkEditServiceSummary, totalEdits, totalFiles),
			isApplied: totalEdits > 0
		};
	}
};
StandaloneBulkEditService = __decorate$16([__param$16(0, IModelService)], StandaloneBulkEditService);
var StandaloneUriLabelService = class {
	getUriLabel(resource, options) {
		if (resource.scheme === "file") return resource.fsPath;
		return resource.path;
	}
	getUriBasenameLabel(resource) {
		return basename(resource);
	}
};
var StandaloneContextViewService = class StandaloneContextViewService extends ContextViewService {
	constructor(layoutService, _codeEditorService) {
		super(layoutService);
		this._codeEditorService = _codeEditorService;
	}
	showContextView(delegate, container, shadowRoot, useWindowContainerForShadowRoot) {
		if (!container) {
			const codeEditor = this._codeEditorService.getFocusedCodeEditor() || this._codeEditorService.getActiveCodeEditor();
			if (codeEditor) container = codeEditor.getContainerDomNode();
		}
		return super.showContextView(delegate, container, shadowRoot, useWindowContainerForShadowRoot);
	}
};
StandaloneContextViewService = __decorate$16([__param$16(0, ILayoutService), __param$16(1, ICodeEditorService)], StandaloneContextViewService);
var StandaloneWorkspaceTrustManagementService = class {
	constructor() {
		this._neverEmitter = new Emitter$1();
		this.onDidChangeTrust = this._neverEmitter.event;
	}
	isWorkspaceTrusted() {
		return true;
	}
};
var StandaloneLanguageService = class extends LanguageService {
	constructor() {
		super();
	}
};
var StandaloneLogService = class extends LogService {
	constructor() {
		super(new ConsoleLogger());
	}
};
var StandaloneContextMenuService = class StandaloneContextMenuService extends ContextMenuService {
	constructor(telemetryService, notificationService, contextViewService, keybindingService, menuService, contextKeyService) {
		super(telemetryService, notificationService, contextViewService, keybindingService, menuService, contextKeyService);
		this.configure({ blockMouse: false });
	}
};
StandaloneContextMenuService = __decorate$16([
	__param$16(0, ITelemetryService),
	__param$16(1, INotificationService),
	__param$16(2, IContextViewService),
	__param$16(3, IKeybindingService),
	__param$16(4, IMenuService),
	__param$16(5, IContextKeyService)
], StandaloneContextMenuService);
var StandaloneAccessbilitySignalService = class {
	async playSignal(cue, options) {}
};
var StandaloneDefaultAccountService = class {
	constructor() {
		this.onDidChangeDefaultAccount = Event.None;
	}
	async getDefaultAccount() {
		return null;
	}
};
registerSingleton(IWebWorkerService, StandaloneWebWorkerService, 0);
registerSingleton(ILogService, StandaloneLogService, 0);
registerSingleton(IConfigurationService, StandaloneConfigurationService, 0);
registerSingleton(ITextResourceConfigurationService, StandaloneResourceConfigurationService, 0);
registerSingleton(ITextResourcePropertiesService, StandaloneResourcePropertiesService, 0);
registerSingleton(IWorkspaceContextService, StandaloneWorkspaceContextService, 0);
registerSingleton(ILabelService, StandaloneUriLabelService, 0);
registerSingleton(ITelemetryService, StandaloneTelemetryService, 0);
registerSingleton(IDialogService, StandaloneDialogService, 0);
registerSingleton(IEnvironmentService, StandaloneEnvironmentService, 0);
registerSingleton(INotificationService, StandaloneNotificationService, 0);
registerSingleton(IMarkerService, MarkerService, 0);
registerSingleton(ILanguageService, StandaloneLanguageService, 0);
registerSingleton(IStandaloneThemeService, StandaloneThemeService, 0);
registerSingleton(IModelService, ModelService, 0);
registerSingleton(IMarkerDecorationsService, MarkerDecorationsService, 0);
registerSingleton(IContextKeyService, ContextKeyService, 0);
registerSingleton(IProgressService, StandaloneProgressService, 0);
registerSingleton(IEditorProgressService, StandaloneEditorProgressService, 0);
registerSingleton(IStorageService, InMemoryStorageService, 0);
registerSingleton(IBulkEditService, StandaloneBulkEditService, 0);
registerSingleton(IWorkspaceTrustManagementService, StandaloneWorkspaceTrustManagementService, 0);
registerSingleton(ITextModelService, InMemoryTextModelService, 0);
registerSingleton(IAccessibilityService, AccessibilityService, 0);
registerSingleton(IListService, ListService, 0);
registerSingleton(ICommandService, StandaloneCommandService, 0);
registerSingleton(IKeybindingService, StandaloneKeybindingService, 0);
registerSingleton(IQuickInputService, StandaloneQuickInputService, 0);
registerSingleton(IContextViewService, StandaloneContextViewService, 0);
registerSingleton(IOpenerService, OpenerService, 0);
registerSingleton(IClipboardService, BrowserClipboardService, 0);
registerSingleton(IContextMenuService, StandaloneContextMenuService, 0);
registerSingleton(IMenuService, MenuService, 0);
registerSingleton(IAccessibilitySignalService, StandaloneAccessbilitySignalService, 0);
registerSingleton(ITreeSitterLibraryService, StandaloneTreeSitterLibraryService, 0);
registerSingleton(ILoggerService, NullLoggerService, 0);
registerSingleton(IDataChannelService, NullDataChannelService, 0);
registerSingleton(IDefaultAccountService, StandaloneDefaultAccountService, 0);
registerSingleton(IRenameSymbolTrackerService, NullRenameSymbolTrackerService, 0);
registerSingleton(IUserInteractionService, UserInteractionService, 0);
/**
* We don't want to eagerly instantiate services because embedders get a one time chance
* to override services when they create the first editor.
*/
var StandaloneServices;
(function(StandaloneServices) {
	const serviceCollection = new ServiceCollection();
	for (const [id, descriptor] of getSingletonServiceDescriptors()) serviceCollection.set(id, descriptor);
	const instantiationService = new InstantiationService(serviceCollection, true);
	serviceCollection.set(IInstantiationService, instantiationService);
	function get(serviceId) {
		if (!initialized) initialize({});
		const r = serviceCollection.get(serviceId);
		if (!r) throw new Error("Missing service " + serviceId);
		if (r instanceof SyncDescriptor) return instantiationService.invokeFunction((accessor) => accessor.get(serviceId));
		else return r;
	}
	StandaloneServices.get = get;
	let initialized = false;
	const onDidInitialize = new Emitter$1();
	function initialize(overrides) {
		if (initialized) return instantiationService;
		initialized = true;
		for (const [id, descriptor] of getSingletonServiceDescriptors()) if (!serviceCollection.get(id)) serviceCollection.set(id, descriptor);
		for (const serviceId in overrides) if (overrides.hasOwnProperty(serviceId)) {
			const serviceIdentifier = createDecorator(serviceId);
			if (serviceCollection.get(serviceIdentifier) instanceof SyncDescriptor) serviceCollection.set(serviceIdentifier, overrides[serviceId]);
		}
		const editorFeatures = getEditorFeatures();
		for (const feature of editorFeatures) try {
			instantiationService.createInstance(feature);
		} catch (err) {
			onUnexpectedError(err);
		}
		onDidInitialize.fire();
		return instantiationService;
	}
	StandaloneServices.initialize = initialize;
	/**
	* Executes callback once services are initialized.
	*/
	function withServices(callback) {
		if (initialized) return callback();
		const disposable = new DisposableStore();
		const listener = disposable.add(onDidInitialize.event(() => {
			listener.dispose();
			disposable.add(callback());
		}));
		return disposable;
	}
	StandaloneServices.withServices = withServices;
})(StandaloneServices || (StandaloneServices = {}));
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/hotReloadHelpers.js
function readHotReloadableExport(value, reader) {
	return value;
}
function createHotClass(clazz) {
	return constObservable(clazz);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/observable/common/platformObservableUtils.js
/** Creates an observable update when a configuration key updates. */
function observableConfigValue(key, defaultValue, configurationService, debugLocation = DebugLocation.ofCaller()) {
	return observableFromEventOpts({ debugName: () => `Configuration Key "${key}"` }, (handleChange) => configurationService.onDidChangeConfiguration((e) => {
		if (e.affectsConfiguration(key)) handleChange(e);
	}), () => configurationService.getValue(key) ?? defaultValue, debugLocation);
}
/** Update the configuration key with a value derived from observables. */
function bindContextKey(key, service, computeValue, debugLocation = DebugLocation.ofCaller()) {
	const boundKey = key.bindTo(service);
	const store = new DisposableStore();
	derivedOpts({ debugName: () => `Set Context Key "${key.key}"` }, (reader) => {
		const value = computeValue(reader);
		boundKey.set(value);
		return value;
	}, debugLocation).recomputeInitiallyAndOnChange(store);
	return store;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/stableEditorScroll.js
var StableEditorScrollState = class StableEditorScrollState {
	static capture(editor) {
		if (editor.getScrollTop() === 0 || editor.hasPendingScrollAnimation()) return new StableEditorScrollState(editor.getScrollTop(), editor.getContentHeight(), null, 0, null);
		let visiblePosition = null;
		let visiblePositionScrollDelta = 0;
		const visibleRanges = editor.getVisibleRanges();
		if (visibleRanges.length > 0) {
			visiblePosition = visibleRanges[0].getStartPosition();
			const visiblePositionScrollTop = editor.getTopForPosition(visiblePosition.lineNumber, visiblePosition.column);
			visiblePositionScrollDelta = editor.getScrollTop() - visiblePositionScrollTop;
		}
		return new StableEditorScrollState(editor.getScrollTop(), editor.getContentHeight(), visiblePosition, visiblePositionScrollDelta, editor.getPosition());
	}
	constructor(_initialScrollTop, _initialContentHeight, _visiblePosition, _visiblePositionScrollDelta, _cursorPosition) {
		this._initialScrollTop = _initialScrollTop;
		this._initialContentHeight = _initialContentHeight;
		this._visiblePosition = _visiblePosition;
		this._visiblePositionScrollDelta = _visiblePositionScrollDelta;
		this._cursorPosition = _cursorPosition;
	}
	restore(editor) {
		if (this._initialContentHeight === editor.getContentHeight() && this._initialScrollTop === editor.getScrollTop()) return;
		if (this._visiblePosition) {
			const visiblePositionScrollTop = editor.getTopForPosition(this._visiblePosition.lineNumber, this._visiblePosition.column);
			editor.setScrollTop(visiblePositionScrollTop + this._visiblePositionScrollDelta);
		}
	}
	restoreRelativeVerticalPositionOfCursor(editor) {
		if (this._initialContentHeight === editor.getContentHeight() && this._initialScrollTop === editor.getScrollTop()) return;
		const currentCursorPosition = editor.getPosition();
		if (!this._cursorPosition || !currentCursorPosition) return;
		const offset = editor.getTopForLineNumber(currentCursorPosition.lineNumber) - editor.getTopForLineNumber(this._cursorPosition.lineNumber);
		editor.setScrollTop(editor.getScrollTop() + offset, 1);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/diffEditor/utils.js
function joinCombine(arr1, arr2, keySelector, combine) {
	if (arr1.length === 0) return arr2;
	if (arr2.length === 0) return arr1;
	const result = [];
	let i = 0;
	let j = 0;
	while (i < arr1.length && j < arr2.length) {
		const val1 = arr1[i];
		const val2 = arr2[j];
		const key1 = keySelector(val1);
		const key2 = keySelector(val2);
		if (key1 < key2) {
			result.push(val1);
			i++;
		} else if (key1 > key2) {
			result.push(val2);
			j++;
		} else {
			result.push(combine(val1, val2));
			i++;
			j++;
		}
	}
	while (i < arr1.length) {
		result.push(arr1[i]);
		i++;
	}
	while (j < arr2.length) {
		result.push(arr2[j]);
		j++;
	}
	return result;
}
function applyObservableDecorations(editor, decorations) {
	const d = new DisposableStore();
	const decorationsCollection = editor.createDecorationsCollection();
	d.add(autorunOpts({ debugName: () => `Apply decorations from ${decorations.debugName}` }, (reader) => {
		const d = decorations.read(reader);
		decorationsCollection.set(d);
	}));
	d.add({ dispose: () => {
		decorationsCollection.clear();
	} });
	return d;
}
function appendRemoveOnDispose(parent, child) {
	parent.appendChild(child);
	return toDisposable(() => {
		child.remove();
	});
}
function prependRemoveOnDispose(parent, child) {
	parent.prepend(child);
	return toDisposable(() => {
		child.remove();
	});
}
var ObservableElementSizeObserver = class extends Disposable {
	get width() {
		return this._width;
	}
	get height() {
		return this._height;
	}
	get automaticLayout() {
		return this._automaticLayout;
	}
	constructor(element, dimension) {
		super();
		this._automaticLayout = false;
		this.elementSizeObserver = this._register(new ElementSizeObserver(element, dimension));
		this._width = observableValue(this, this.elementSizeObserver.getWidth());
		this._height = observableValue(this, this.elementSizeObserver.getHeight());
		this._register(this.elementSizeObserver.onDidChange((e) => transaction((tx) => {
			/** @description Set width/height from elementSizeObserver */
			this._width.set(this.elementSizeObserver.getWidth(), tx);
			this._height.set(this.elementSizeObserver.getHeight(), tx);
		})));
	}
	observe(dimension) {
		this.elementSizeObserver.observe(dimension);
	}
	setAutomaticLayout(automaticLayout) {
		this._automaticLayout = automaticLayout;
		if (automaticLayout) this.elementSizeObserver.startObserving();
		else this.elementSizeObserver.stopObserving();
	}
};
function animatedObservable(targetWindow, base, store) {
	let targetVal = base.get();
	let startVal = targetVal;
	let curVal = targetVal;
	const result = observableValue("animatedValue", targetVal);
	let animationStartMs = -1;
	const durationMs = 300;
	let animationFrame = void 0;
	store.add(autorunHandleChanges({ changeTracker: {
		createChangeSummary: () => ({ animate: false }),
		handleChange: (ctx, s) => {
			if (ctx.didChange(base)) s.animate = s.animate || ctx.change;
			return true;
		}
	} }, (reader, s) => {
		/** @description update value */
		if (animationFrame !== void 0) {
			targetWindow.cancelAnimationFrame(animationFrame);
			animationFrame = void 0;
		}
		startVal = curVal;
		targetVal = base.read(reader);
		if (startVal === targetVal) animationStartMs = Date.now() - durationMs;
		else animationStartMs = Date.now() - (s.animate ? 0 : durationMs);
		update();
	}));
	function update() {
		const passedMs = Date.now() - animationStartMs;
		curVal = Math.floor(easeOutExpo(passedMs, startVal, targetVal - startVal, durationMs));
		if (passedMs < durationMs) animationFrame = targetWindow.requestAnimationFrame(update);
		else curVal = targetVal;
		result.set(curVal, void 0);
	}
	return result;
}
function easeOutExpo(t, b, c, d) {
	return t === d ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
}
var ViewZoneOverlayWidget = class extends Disposable {
	constructor(editor, viewZone, htmlElement) {
		super();
		this._register(new ManagedOverlayWidget(editor, htmlElement));
		this._register(applyStyle(htmlElement, {
			height: viewZone.actualHeight,
			top: viewZone.actualTop
		}));
	}
};
var PlaceholderViewZone = class {
	get afterLineNumber() {
		return this._afterLineNumber.get();
	}
	constructor(_afterLineNumber, heightInPx) {
		this._afterLineNumber = _afterLineNumber;
		this.heightInPx = heightInPx;
		this.domNode = document.createElement("div");
		this._actualTop = observableValue(this, void 0);
		this._actualHeight = observableValue(this, void 0);
		this.actualTop = this._actualTop;
		this.actualHeight = this._actualHeight;
		this.showInHiddenAreas = true;
		this.onChange = this._afterLineNumber;
		this.onDomNodeTop = (top) => {
			this._actualTop.set(top, void 0);
		};
		this.onComputedHeight = (height) => {
			this._actualHeight.set(height, void 0);
		};
	}
};
var ManagedOverlayWidget = class ManagedOverlayWidget {
	static {
		this._counter = 0;
	}
	constructor(_editor, _domElement) {
		this._editor = _editor;
		this._domElement = _domElement;
		this._overlayWidgetId = `managedOverlayWidget-${ManagedOverlayWidget._counter++}`;
		this._overlayWidget = {
			getId: () => this._overlayWidgetId,
			getDomNode: () => this._domElement,
			getPosition: () => null
		};
		this._editor.addOverlayWidget(this._overlayWidget);
	}
	dispose() {
		this._editor.removeOverlayWidget(this._overlayWidget);
	}
};
function applyStyle(domNode, style) {
	return autorun((reader) => {
		/** @description applyStyle */
		for (let [key, val] of Object.entries(style)) {
			if (val && typeof val === "object" && "read" in val) val = val.read(reader);
			if (typeof val === "number") val = `${val}px`;
			key = key.replace(/[A-Z]/g, (m) => "-" + m.toLowerCase());
			domNode.style[key] = val;
		}
	});
}
function applyViewZones(editor, viewZones, setIsUpdating, zoneIds) {
	const store = new DisposableStore();
	const lastViewZoneIds = [];
	store.add(autorunWithStore((reader, store) => {
		/** @description applyViewZones */
		const curViewZones = viewZones.read(reader);
		const viewZonIdsPerViewZone = /* @__PURE__ */ new Map();
		const viewZoneIdPerOnChangeObservable = /* @__PURE__ */ new Map();
		if (setIsUpdating) setIsUpdating(true);
		editor.changeViewZones((a) => {
			for (const id of lastViewZoneIds) {
				a.removeZone(id);
				zoneIds?.delete(id);
			}
			lastViewZoneIds.length = 0;
			for (const z of curViewZones) {
				const id = a.addZone(z);
				if (z.setZoneId) z.setZoneId(id);
				lastViewZoneIds.push(id);
				zoneIds?.add(id);
				viewZonIdsPerViewZone.set(z, id);
			}
		});
		if (setIsUpdating) setIsUpdating(false);
		store.add(autorunHandleChanges({ changeTracker: {
			createChangeSummary() {
				return { zoneIds: [] };
			},
			handleChange(context, changeSummary) {
				const id = viewZoneIdPerOnChangeObservable.get(context.changedObservable);
				if (id !== void 0) changeSummary.zoneIds.push(id);
				return true;
			}
		} }, (reader, changeSummary) => {
			/** @description layoutZone on change */
			for (const vz of curViewZones) if (vz.onChange) {
				viewZoneIdPerOnChangeObservable.set(vz.onChange, viewZonIdsPerViewZone.get(vz));
				vz.onChange.read(reader);
			}
			if (setIsUpdating) setIsUpdating(true);
			editor.changeViewZones((a) => {
				for (const id of changeSummary.zoneIds) a.layoutZone(id);
			});
			if (setIsUpdating) setIsUpdating(false);
		}));
	}));
	store.add({ dispose() {
		if (setIsUpdating) setIsUpdating(true);
		editor.changeViewZones((a) => {
			for (const id of lastViewZoneIds) a.removeZone(id);
		});
		zoneIds?.clear();
		if (setIsUpdating) setIsUpdating(false);
	} });
	return store;
}
var DisposableCancellationTokenSource = class extends CancellationTokenSource$1 {
	dispose() {
		super.dispose(true);
	}
};
function translatePosition(posInOriginal, mappings) {
	const mapping = findLast(mappings, (m) => m.original.startLineNumber <= posInOriginal.lineNumber);
	if (!mapping) return Range$2.fromPositions(posInOriginal);
	if (mapping.original.endLineNumberExclusive <= posInOriginal.lineNumber) {
		const newLineNumber = posInOriginal.lineNumber - mapping.original.endLineNumberExclusive + mapping.modified.endLineNumberExclusive;
		return Range$2.fromPositions(new Position$1(newLineNumber, posInOriginal.column));
	}
	if (!mapping.innerChanges) return Range$2.fromPositions(new Position$1(mapping.modified.startLineNumber, 1));
	const innerMapping = findLast(mapping.innerChanges, (m) => m.originalRange.getStartPosition().isBeforeOrEqual(posInOriginal));
	if (!innerMapping) {
		const newLineNumber = posInOriginal.lineNumber - mapping.original.startLineNumber + mapping.modified.startLineNumber;
		return Range$2.fromPositions(new Position$1(newLineNumber, posInOriginal.column));
	}
	if (innerMapping.originalRange.containsPosition(posInOriginal)) return innerMapping.modifiedRange;
	else {
		const l = lengthBetweenPositions(innerMapping.originalRange.getEndPosition(), posInOriginal);
		return Range$2.fromPositions(l.addToPosition(innerMapping.modifiedRange.getEndPosition()));
	}
}
function lengthBetweenPositions(position1, position2) {
	if (position1.lineNumber === position2.lineNumber) return new TextLength(0, position2.column - position1.column);
	else return new TextLength(position2.lineNumber - position1.lineNumber, position2.column - 1);
}
function filterWithPrevious(arr, filter) {
	let prev;
	return arr.filter((cur) => {
		const result = filter(cur, prev);
		prev = cur;
		return result;
	});
}
var RefCounted = class {
	static create(value, debugOwner = void 0) {
		return new BaseRefCounted(value, value, debugOwner);
	}
	static createWithDisposable(value, disposable, debugOwner = void 0) {
		const store = new DisposableStore();
		store.add(disposable);
		store.add(value);
		return new BaseRefCounted(value, store, debugOwner);
	}
};
var BaseRefCounted = class extends RefCounted {
	constructor(object, _disposable, _debugOwner) {
		super();
		this.object = object;
		this._disposable = _disposable;
		this._debugOwner = _debugOwner;
		this._refCount = 1;
		this._isDisposed = false;
		this._owners = [];
		if (_debugOwner) this._addOwner(_debugOwner);
	}
	_addOwner(debugOwner) {
		if (debugOwner) this._owners.push(debugOwner);
	}
	createNewRef(debugOwner) {
		this._refCount++;
		if (debugOwner) this._addOwner(debugOwner);
		return new ClonedRefCounted(this, debugOwner);
	}
	dispose() {
		if (this._isDisposed) return;
		this._isDisposed = true;
		this._decreaseRefCount(this._debugOwner);
	}
	_decreaseRefCount(debugOwner) {
		this._refCount--;
		if (this._refCount === 0) this._disposable.dispose();
		if (debugOwner) {
			const idx = this._owners.indexOf(debugOwner);
			if (idx !== -1) this._owners.splice(idx, 1);
		}
	}
};
var ClonedRefCounted = class extends RefCounted {
	constructor(_base, _debugOwner) {
		super();
		this._base = _base;
		this._debugOwner = _debugOwner;
		this._isDisposed = false;
	}
	get object() {
		return this._base.object;
	}
	createNewRef(debugOwner) {
		return this._base.createNewRef(debugOwner);
	}
	dispose() {
		if (this._isDisposed) return;
		this._isDisposed = true;
		this._base._decreaseRefCount(this._debugOwner);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/diffEditor/components/accessibleDiffViewer.js
var __decorate$15 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$15 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var accessibleDiffViewerInsertIcon = registerIcon("diff-review-insert", Codicon.add, localize(113, "Icon for 'Insert' in accessible diff viewer."));
var accessibleDiffViewerRemoveIcon = registerIcon("diff-review-remove", Codicon.remove, localize(114, "Icon for 'Remove' in accessible diff viewer."));
var accessibleDiffViewerCloseIcon = registerIcon("diff-review-close", Codicon.close, localize(115, "Icon for 'Close' in accessible diff viewer."));
var AccessibleDiffViewer = class AccessibleDiffViewer extends Disposable {
	static {
		this._ttPolicy = createTrustedTypesPolicy("diffReview", { createHTML: (value) => value });
	}
	constructor(_parentNode, _visible, _setVisible, _canClose, _width, _height, _diffs, _models, _instantiationService) {
		super();
		this._parentNode = _parentNode;
		this._visible = _visible;
		this._setVisible = _setVisible;
		this._canClose = _canClose;
		this._width = _width;
		this._height = _height;
		this._diffs = _diffs;
		this._models = _models;
		this._instantiationService = _instantiationService;
		this._state = derived(this, (reader) => {
			const visible = this._visible.read(reader);
			this._parentNode.style.visibility = visible ? "visible" : "hidden";
			if (!visible) return null;
			const model = reader.store.add(this._instantiationService.createInstance(ViewModel, this._diffs, this._models, this._setVisible, this._canClose));
			return {
				model,
				view: reader.store.add(this._instantiationService.createInstance(View, this._parentNode, model, this._width, this._height, this._models))
			};
		}).recomputeInitiallyAndOnChange(this._store);
	}
	next() {
		transaction((tx) => {
			const isVisible = this._visible.get();
			this._setVisible(true, tx);
			if (isVisible) this._state.get().model.nextGroup(tx);
		});
	}
	prev() {
		transaction((tx) => {
			this._setVisible(true, tx);
			this._state.get().model.previousGroup(tx);
		});
	}
	close() {
		transaction((tx) => {
			this._setVisible(false, tx);
		});
	}
};
AccessibleDiffViewer = __decorate$15([__param$15(8, IInstantiationService)], AccessibleDiffViewer);
var ViewModel = class ViewModel extends Disposable {
	constructor(_diffs, _models, _setVisible, canClose, _accessibilitySignalService) {
		super();
		this._diffs = _diffs;
		this._models = _models;
		this._setVisible = _setVisible;
		this.canClose = canClose;
		this._accessibilitySignalService = _accessibilitySignalService;
		this._groups = observableValue(this, []);
		this._currentGroupIdx = observableValue(this, 0);
		this._currentElementIdx = observableValue(this, 0);
		this.groups = this._groups;
		this.currentGroup = this._currentGroupIdx.map((idx, r) => this._groups.read(r)[idx]);
		this.currentGroupIndex = this._currentGroupIdx;
		this.currentElement = this._currentElementIdx.map((idx, r) => this.currentGroup.read(r)?.lines[idx]);
		this._register(autorun((reader) => {
			/** @description update groups */
			const diffs = this._diffs.read(reader);
			if (!diffs) {
				this._groups.set([], void 0);
				return;
			}
			const groups = computeViewElementGroups(diffs, this._models.getOriginalModel().getLineCount(), this._models.getModifiedModel().getLineCount());
			transaction((tx) => {
				const p = this._models.getModifiedPosition();
				if (p) {
					const nextGroup = groups.findIndex((g) => p?.lineNumber < g.range.modified.endLineNumberExclusive);
					if (nextGroup !== -1) this._currentGroupIdx.set(nextGroup, tx);
				}
				this._groups.set(groups, tx);
			});
		}));
		this._register(autorun((reader) => {
			/** @description play audio-cue for diff */
			const currentViewItem = this.currentElement.read(reader);
			if (currentViewItem?.type === LineType.Deleted) this._accessibilitySignalService.playSignal(AccessibilitySignal.diffLineDeleted, { source: "accessibleDiffViewer.currentElementChanged" });
			else if (currentViewItem?.type === LineType.Added) this._accessibilitySignalService.playSignal(AccessibilitySignal.diffLineInserted, { source: "accessibleDiffViewer.currentElementChanged" });
		}));
		this._register(autorun((reader) => {
			/** @description select lines in editor */
			const currentViewItem = this.currentElement.read(reader);
			if (currentViewItem && currentViewItem.type !== LineType.Header) {
				const lineNumber = currentViewItem.modifiedLineNumber ?? currentViewItem.diff.modified.startLineNumber;
				this._models.modifiedSetSelection(Range$2.fromPositions(new Position$1(lineNumber, 1)));
			}
		}));
	}
	_goToGroupDelta(delta, tx) {
		const groups = this.groups.get();
		if (!groups || groups.length <= 1) return;
		subtransaction(tx, (tx) => {
			this._currentGroupIdx.set(OffsetRange.ofLength(groups.length).clipCyclic(this._currentGroupIdx.get() + delta), tx);
			this._currentElementIdx.set(0, tx);
		});
	}
	nextGroup(tx) {
		this._goToGroupDelta(1, tx);
	}
	previousGroup(tx) {
		this._goToGroupDelta(-1, tx);
	}
	_goToLineDelta(delta) {
		const group = this.currentGroup.get();
		if (!group || group.lines.length <= 1) return;
		transaction((tx) => {
			this._currentElementIdx.set(OffsetRange.ofLength(group.lines.length).clip(this._currentElementIdx.get() + delta), tx);
		});
	}
	goToNextLine() {
		this._goToLineDelta(1);
	}
	goToPreviousLine() {
		this._goToLineDelta(-1);
	}
	goToLine(line) {
		const group = this.currentGroup.get();
		if (!group) return;
		const idx = group.lines.indexOf(line);
		if (idx === -1) return;
		transaction((tx) => {
			this._currentElementIdx.set(idx, tx);
		});
	}
	revealCurrentElementInEditor() {
		if (!this.canClose.get()) return;
		this._setVisible(false, void 0);
		const curElem = this.currentElement.get();
		if (curElem) {
			if (curElem.type === LineType.Deleted) this._models.originalReveal(Range$2.fromPositions(new Position$1(curElem.originalLineNumber, 1)));
			else this._models.modifiedReveal(curElem.type !== LineType.Header ? Range$2.fromPositions(new Position$1(curElem.modifiedLineNumber, 1)) : void 0);
		}
	}
	close() {
		if (!this.canClose.get()) return;
		this._setVisible(false, void 0);
		this._models.modifiedFocus();
	}
};
ViewModel = __decorate$15([__param$15(4, IAccessibilitySignalService)], ViewModel);
var viewElementGroupLineMargin = 3;
function computeViewElementGroups(diffs, originalLineCount, modifiedLineCount) {
	const result = [];
	for (const g of groupAdjacentBy(diffs, (a, b) => b.modified.startLineNumber - a.modified.endLineNumberExclusive < 6)) {
		const viewElements = [];
		viewElements.push(new HeaderViewElement());
		const origFullRange = new LineRange(Math.max(1, g[0].original.startLineNumber - viewElementGroupLineMargin), Math.min(g[g.length - 1].original.endLineNumberExclusive + viewElementGroupLineMargin, originalLineCount + 1));
		const modifiedFullRange = new LineRange(Math.max(1, g[0].modified.startLineNumber - viewElementGroupLineMargin), Math.min(g[g.length - 1].modified.endLineNumberExclusive + viewElementGroupLineMargin, modifiedLineCount + 1));
		forEachAdjacent(g, (a, b) => {
			const origRange = new LineRange(a ? a.original.endLineNumberExclusive : origFullRange.startLineNumber, b ? b.original.startLineNumber : origFullRange.endLineNumberExclusive);
			const modifiedRange = new LineRange(a ? a.modified.endLineNumberExclusive : modifiedFullRange.startLineNumber, b ? b.modified.startLineNumber : modifiedFullRange.endLineNumberExclusive);
			origRange.forEach((origLineNumber) => {
				viewElements.push(new UnchangedLineViewElement(origLineNumber, modifiedRange.startLineNumber + (origLineNumber - origRange.startLineNumber)));
			});
			if (b) {
				b.original.forEach((origLineNumber) => {
					viewElements.push(new DeletedLineViewElement(b, origLineNumber));
				});
				b.modified.forEach((modifiedLineNumber) => {
					viewElements.push(new AddedLineViewElement(b, modifiedLineNumber));
				});
			}
		});
		const modifiedRange = g[0].modified.join(g[g.length - 1].modified);
		const originalRange = g[0].original.join(g[g.length - 1].original);
		result.push(new ViewElementGroup(new LineRangeMapping(modifiedRange, originalRange), viewElements));
	}
	return result;
}
var LineType;
(function(LineType) {
	LineType[LineType["Header"] = 0] = "Header";
	LineType[LineType["Unchanged"] = 1] = "Unchanged";
	LineType[LineType["Deleted"] = 2] = "Deleted";
	LineType[LineType["Added"] = 3] = "Added";
})(LineType || (LineType = {}));
var ViewElementGroup = class {
	constructor(range, lines) {
		this.range = range;
		this.lines = lines;
	}
};
var HeaderViewElement = class {
	constructor() {
		this.type = LineType.Header;
	}
};
var DeletedLineViewElement = class {
	constructor(diff, originalLineNumber) {
		this.diff = diff;
		this.originalLineNumber = originalLineNumber;
		this.type = LineType.Deleted;
		this.modifiedLineNumber = void 0;
	}
};
var AddedLineViewElement = class {
	constructor(diff, modifiedLineNumber) {
		this.diff = diff;
		this.modifiedLineNumber = modifiedLineNumber;
		this.type = LineType.Added;
		this.originalLineNumber = void 0;
	}
};
var UnchangedLineViewElement = class {
	constructor(originalLineNumber, modifiedLineNumber) {
		this.originalLineNumber = originalLineNumber;
		this.modifiedLineNumber = modifiedLineNumber;
		this.type = LineType.Unchanged;
	}
};
var View = class View extends Disposable {
	constructor(_element, _model, _width, _height, _models, _languageService) {
		super();
		this._element = _element;
		this._model = _model;
		this._width = _width;
		this._height = _height;
		this._models = _models;
		this._languageService = _languageService;
		this.domNode = this._element;
		this.domNode.className = "monaco-component diff-review monaco-editor-background";
		const actionBarContainer = document.createElement("div");
		actionBarContainer.className = "diff-review-actions";
		this._actionBar = this._register(new ActionBar(actionBarContainer));
		this._register(autorun((reader) => {
			/** @description update actions */
			this._actionBar.clear();
			if (this._model.canClose.read(reader)) this._actionBar.push(toAction({
				id: "diffreview.close",
				label: localize(116, "Close"),
				class: "close-diff-review " + ThemeIcon.asClassName(accessibleDiffViewerCloseIcon),
				enabled: true,
				run: async () => _model.close()
			}), {
				label: false,
				icon: true
			});
		}));
		this._content = document.createElement("div");
		this._content.className = "diff-review-content";
		this._content.setAttribute("role", "code");
		this._scrollbar = this._register(new DomScrollableElement(this._content, {}));
		reset(this.domNode, this._scrollbar.getDomNode(), actionBarContainer);
		this._register(autorun((r) => {
			this._height.read(r);
			this._width.read(r);
			this._scrollbar.scanDomNode();
		}));
		this._register(toDisposable(() => {
			reset(this.domNode);
		}));
		this._register(applyStyle(this.domNode, {
			width: this._width,
			height: this._height
		}));
		this._register(applyStyle(this._content, {
			width: this._width,
			height: this._height
		}));
		this._register(autorunWithStore((reader, store) => {
			/** @description render */
			this._model.currentGroup.read(reader);
			this._render(store);
		}));
		this._register(addStandardDisposableListener(this.domNode, "keydown", (e) => {
			if (e.equals(18) || e.equals(2066) || e.equals(530)) {
				e.preventDefault();
				this._model.goToNextLine();
			}
			if (e.equals(16) || e.equals(2064) || e.equals(528)) {
				e.preventDefault();
				this._model.goToPreviousLine();
			}
			if (e.equals(9) || e.equals(2057) || e.equals(521) || e.equals(1033)) {
				e.preventDefault();
				this._model.close();
			}
			if (e.equals(10) || e.equals(3)) {
				e.preventDefault();
				this._model.revealCurrentElementInEditor();
			}
		}));
	}
	_render(store) {
		const originalOptions = this._models.getOriginalOptions();
		const modifiedOptions = this._models.getModifiedOptions();
		const container = document.createElement("div");
		container.className = "diff-review-table";
		container.setAttribute("role", "list");
		container.setAttribute("aria-label", localize(117, "Accessible Diff Viewer. Use arrow up and down to navigate."));
		applyFontInfo(container, modifiedOptions.get(59));
		reset(this._content, container);
		const originalModel = this._models.getOriginalModel();
		const modifiedModel = this._models.getModifiedModel();
		if (!originalModel || !modifiedModel) return;
		const originalModelOpts = originalModel.getOptions();
		const modifiedModelOpts = modifiedModel.getOptions();
		const lineHeight = modifiedOptions.get(75);
		const group = this._model.currentGroup.get();
		for (const viewItem of group?.lines || []) {
			if (!group) break;
			let row;
			if (viewItem.type === LineType.Header) {
				const header = document.createElement("div");
				header.className = "diff-review-row";
				header.setAttribute("role", "listitem");
				const r = group.range;
				const diffIndex = this._model.currentGroupIndex.get();
				const diffsLength = this._model.groups.get().length;
				const getAriaLines = (lines) => lines === 0 ? localize(118, "no lines changed") : lines === 1 ? localize(119, "1 line changed") : localize(120, "{0} lines changed", lines);
				const originalChangedLinesCntAria = getAriaLines(r.original.length);
				const modifiedChangedLinesCntAria = getAriaLines(r.modified.length);
				header.setAttribute("aria-label", localize(121, "Difference {0} of {1}: original line {2}, {3}, modified line {4}, {5}", diffIndex + 1, diffsLength, r.original.startLineNumber, originalChangedLinesCntAria, r.modified.startLineNumber, modifiedChangedLinesCntAria));
				const cell = document.createElement("div");
				cell.className = "diff-review-cell diff-review-summary";
				cell.appendChild(document.createTextNode(`${diffIndex + 1}/${diffsLength}: @@ -${r.original.startLineNumber},${r.original.length} +${r.modified.startLineNumber},${r.modified.length} @@`));
				header.appendChild(cell);
				row = header;
			} else row = this._createRow(viewItem, lineHeight, this._width.get(), originalOptions, originalModel, originalModelOpts, modifiedOptions, modifiedModel, modifiedModelOpts);
			container.appendChild(row);
			const isSelectedObs = derived((reader) => this._model.currentElement.read(reader) === viewItem);
			store.add(autorun((reader) => {
				/** @description update tab index */
				const isSelected = isSelectedObs.read(reader);
				row.tabIndex = isSelected ? 0 : -1;
				if (isSelected) row.focus();
			}));
			store.add(addDisposableListener(row, "focus", () => {
				this._model.goToLine(viewItem);
			}));
		}
		this._scrollbar.scanDomNode();
	}
	_createRow(item, lineHeight, width, originalOptions, originalModel, originalModelOpts, modifiedOptions, modifiedModel, modifiedModelOpts) {
		const originalLayoutInfo = originalOptions.get(166);
		const originalLineNumbersWidth = originalLayoutInfo.glyphMarginWidth + originalLayoutInfo.lineNumbersWidth;
		const modifiedLayoutInfo = modifiedOptions.get(166);
		const modifiedLineNumbersWidth = 10 + modifiedLayoutInfo.glyphMarginWidth + modifiedLayoutInfo.lineNumbersWidth;
		let rowClassName = "diff-review-row";
		let lineNumbersExtraClassName = "";
		const spacerClassName = "diff-review-spacer";
		let spacerIcon = null;
		switch (item.type) {
			case LineType.Added:
				rowClassName = "diff-review-row line-insert";
				lineNumbersExtraClassName = " char-insert";
				spacerIcon = accessibleDiffViewerInsertIcon;
				break;
			case LineType.Deleted:
				rowClassName = "diff-review-row line-delete";
				lineNumbersExtraClassName = " char-delete";
				spacerIcon = accessibleDiffViewerRemoveIcon;
		}
		const row = document.createElement("div");
		row.style.minWidth = width + "px";
		row.className = rowClassName;
		row.setAttribute("role", "listitem");
		row.ariaLevel = "";
		const cell = document.createElement("div");
		cell.className = "diff-review-cell";
		cell.style.height = `${lineHeight}px`;
		row.appendChild(cell);
		const originalLineNumber = document.createElement("span");
		originalLineNumber.style.width = originalLineNumbersWidth + "px";
		originalLineNumber.style.minWidth = originalLineNumbersWidth + "px";
		originalLineNumber.className = "diff-review-line-number" + lineNumbersExtraClassName;
		if (item.originalLineNumber !== void 0) originalLineNumber.appendChild(document.createTextNode(String(item.originalLineNumber)));
		else originalLineNumber.innerText = "\xA0";
		cell.appendChild(originalLineNumber);
		const modifiedLineNumber = document.createElement("span");
		modifiedLineNumber.style.width = modifiedLineNumbersWidth + "px";
		modifiedLineNumber.style.minWidth = modifiedLineNumbersWidth + "px";
		modifiedLineNumber.style.paddingRight = "10px";
		modifiedLineNumber.className = "diff-review-line-number" + lineNumbersExtraClassName;
		if (item.modifiedLineNumber !== void 0) modifiedLineNumber.appendChild(document.createTextNode(String(item.modifiedLineNumber)));
		else modifiedLineNumber.innerText = "\xA0";
		cell.appendChild(modifiedLineNumber);
		const spacer = document.createElement("span");
		spacer.className = spacerClassName;
		if (spacerIcon) {
			const spacerCodicon = document.createElement("span");
			spacerCodicon.className = ThemeIcon.asClassName(spacerIcon);
			spacerCodicon.innerText = "\xA0\xA0";
			spacer.appendChild(spacerCodicon);
		} else spacer.innerText = "\xA0\xA0";
		cell.appendChild(spacer);
		let lineContent;
		if (item.modifiedLineNumber !== void 0) {
			let html = this._getLineHtml(modifiedModel, modifiedOptions, modifiedModelOpts.tabSize, item.modifiedLineNumber, this._languageService.languageIdCodec);
			if (AccessibleDiffViewer._ttPolicy) html = AccessibleDiffViewer._ttPolicy.createHTML(html);
			cell.insertAdjacentHTML("beforeend", html);
			lineContent = modifiedModel.getLineContent(item.modifiedLineNumber);
		} else {
			let html = this._getLineHtml(originalModel, originalOptions, originalModelOpts.tabSize, item.originalLineNumber, this._languageService.languageIdCodec);
			if (AccessibleDiffViewer._ttPolicy) html = AccessibleDiffViewer._ttPolicy.createHTML(html);
			cell.insertAdjacentHTML("beforeend", html);
			lineContent = originalModel.getLineContent(item.originalLineNumber);
		}
		if (lineContent.length === 0) lineContent = localize(122, "blank");
		let ariaLabel = "";
		switch (item.type) {
			case LineType.Unchanged:
				if (item.originalLineNumber === item.modifiedLineNumber) ariaLabel = localize(123, "{0} unchanged line {1}", lineContent, item.originalLineNumber);
				else ariaLabel = localize(124, "{0} original line {1} modified line {2}", lineContent, item.originalLineNumber, item.modifiedLineNumber);
				break;
			case LineType.Added:
				ariaLabel = localize(125, "+ {0} modified line {1}", lineContent, item.modifiedLineNumber);
				break;
			case LineType.Deleted: ariaLabel = localize(126, "- {0} original line {1}", lineContent, item.originalLineNumber);
		}
		row.setAttribute("aria-label", ariaLabel);
		return row;
	}
	_getLineHtml(model, options, tabSize, lineNumber, languageIdCodec) {
		const lineContent = model.getLineContent(lineNumber);
		const fontInfo = options.get(59);
		const verticalScrollbarSize = options.get(117).verticalScrollbarSize;
		const lineTokens = LineTokens.createEmpty(lineContent, languageIdCodec);
		const isBasicASCII = ViewLineRenderingData.isBasicASCII(lineContent, model.mightContainNonBasicASCII());
		const containsRTL = ViewLineRenderingData.containsRTL(lineContent, isBasicASCII, model.mightContainRTL());
		return renderViewLine2(new RenderLineInput(fontInfo.isMonospace && !options.get(40), fontInfo.canUseHalfwidthRightwardsArrow, lineContent, false, isBasicASCII, containsRTL, 0, lineTokens, [], tabSize, 0, fontInfo.spaceWidth, fontInfo.middotWidth, fontInfo.wsmiddotWidth, options.get(133), options.get(113), options.get(108), options.get(60) !== EditorFontLigatures.OFF, null, null, verticalScrollbarSize)).html;
	}
};
View = __decorate$15([__param$15(5, ILanguageService)], View);
var AccessibleDiffViewerModelFromEditors = class {
	constructor(editors) {
		this.editors = editors;
	}
	getOriginalModel() {
		return this.editors.original.getModel();
	}
	getOriginalOptions() {
		return this.editors.original.getOptions();
	}
	originalReveal(range) {
		this.editors.original.revealRange(range);
		this.editors.original.setSelection(range);
		this.editors.original.focus();
	}
	getModifiedModel() {
		return this.editors.modified.getModel();
	}
	getModifiedOptions() {
		return this.editors.modified.getOptions();
	}
	modifiedReveal(range) {
		if (range) {
			this.editors.modified.revealRange(range);
			this.editors.modified.setSelection(range);
		}
		this.editors.modified.focus();
	}
	modifiedSetSelection(range) {
		this.editors.modified.setSelection(range);
	}
	modifiedFocus() {
		this.editors.modified.focus();
	}
	getModifiedPosition() {
		return this.editors.modified.getPosition() ?? void 0;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/diffEditor/registrations.contribution.js
registerColor("diffEditor.move.border", "#8b8b8b9c", localize(156, "The border color for text that got moved in the diff editor."));
registerColor("diffEditor.moveActive.border", "#FFA500", localize(157, "The active border color for text that got moved in the diff editor."));
registerColor("diffEditor.unchangedRegionShadow", {
	dark: "#000000",
	light: "#737373BF",
	hcDark: "#000000",
	hcLight: "#737373BF"
}, localize(158, "The color of the shadow around unchanged region widgets."));
var diffInsertIcon = registerIcon("diff-insert", Codicon.add, localize(159, "Line decoration for inserts in the diff editor."));
var diffRemoveIcon = registerIcon("diff-remove", Codicon.remove, localize(160, "Line decoration for removals in the diff editor."));
var diffLineAddDecorationBackgroundWithIndicator = ModelDecorationOptions.register({
	className: "line-insert",
	description: "line-insert",
	isWholeLine: true,
	linesDecorationsClassName: "insert-sign " + ThemeIcon.asClassName(diffInsertIcon),
	marginClassName: "gutter-insert"
});
var diffLineDeleteDecorationBackgroundWithIndicator = ModelDecorationOptions.register({
	className: "line-delete",
	description: "line-delete",
	isWholeLine: true,
	linesDecorationsClassName: "delete-sign " + ThemeIcon.asClassName(diffRemoveIcon),
	marginClassName: "gutter-delete"
});
var diffLineAddDecorationBackground = ModelDecorationOptions.register({
	className: "line-insert",
	description: "line-insert",
	isWholeLine: true,
	marginClassName: "gutter-insert"
});
var diffLineDeleteDecorationBackground = ModelDecorationOptions.register({
	className: "line-delete",
	description: "line-delete",
	isWholeLine: true,
	marginClassName: "gutter-delete"
});
var diffAddDecoration = ModelDecorationOptions.register({
	className: "char-insert",
	description: "char-insert",
	shouldFillLineOnLineBreak: true
});
var diffWholeLineAddDecoration = ModelDecorationOptions.register({
	className: "char-insert",
	description: "char-insert",
	isWholeLine: true
});
var diffAddDecorationEmpty = ModelDecorationOptions.register({
	className: "char-insert diff-range-empty",
	description: "char-insert diff-range-empty"
});
var diffDeleteDecoration = ModelDecorationOptions.register({
	className: "char-delete",
	description: "char-delete",
	shouldFillLineOnLineBreak: true
});
var diffWholeLineDeleteDecoration = ModelDecorationOptions.register({
	className: "char-delete",
	description: "char-delete",
	isWholeLine: true
});
var diffDeleteDecorationEmpty = ModelDecorationOptions.register({
	className: "char-delete diff-range-empty",
	description: "char-delete diff-range-empty"
});
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/diffEditor/diffProviderFactoryService.js
var __decorate$14 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$14 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var WorkerBasedDocumentDiffProvider_1;
var IDiffProviderFactoryService = createDecorator("diffProviderFactoryService");
var WorkerBasedDiffProviderFactoryService = class WorkerBasedDiffProviderFactoryService {
	constructor(instantiationService) {
		this.instantiationService = instantiationService;
	}
	createDiffProvider(options) {
		return this.instantiationService.createInstance(WorkerBasedDocumentDiffProvider, options);
	}
};
WorkerBasedDiffProviderFactoryService = __decorate$14([__param$14(0, IInstantiationService)], WorkerBasedDiffProviderFactoryService);
registerSingleton(IDiffProviderFactoryService, WorkerBasedDiffProviderFactoryService, 1);
var WorkerBasedDocumentDiffProvider = class WorkerBasedDocumentDiffProvider {
	static {
		WorkerBasedDocumentDiffProvider_1 = this;
	}
	static {
		this.diffCache = /* @__PURE__ */ new Map();
	}
	constructor(options, editorWorkerService, telemetryService) {
		this.editorWorkerService = editorWorkerService;
		this.telemetryService = telemetryService;
		this.onDidChangeEventEmitter = new Emitter$1();
		this.onDidChange = this.onDidChangeEventEmitter.event;
		this.diffAlgorithm = "advanced";
		this.diffAlgorithmOnDidChangeSubscription = void 0;
		this.setOptions(options);
	}
	dispose() {
		this.diffAlgorithmOnDidChangeSubscription?.dispose();
		this.onDidChangeEventEmitter.dispose();
	}
	async computeDiff(original, modified, options, cancellationToken) {
		if (typeof this.diffAlgorithm !== "string") return this.diffAlgorithm.computeDiff(original, modified, options, cancellationToken);
		if (original.isDisposed() || modified.isDisposed()) return {
			changes: [],
			identical: true,
			quitEarly: false,
			moves: []
		};
		if (original.getLineCount() === 1 && original.getLineMaxColumn(1) === 1) {
			if (modified.getLineCount() === 1 && modified.getLineMaxColumn(1) === 1) return {
				changes: [],
				identical: true,
				quitEarly: false,
				moves: []
			};
			return {
				changes: [new DetailedLineRangeMapping(new LineRange(1, 2), new LineRange(1, modified.getLineCount() + 1), [new RangeMapping(original.getFullModelRange(), modified.getFullModelRange())])],
				identical: false,
				quitEarly: false,
				moves: []
			};
		}
		const uriKey = JSON.stringify([original.uri.toString(), modified.uri.toString()]);
		const context = JSON.stringify([
			original.id,
			modified.id,
			original.getAlternativeVersionId(),
			modified.getAlternativeVersionId(),
			JSON.stringify(options)
		]);
		const c = WorkerBasedDocumentDiffProvider_1.diffCache.get(uriKey);
		if (c && c.context === context) return c.result;
		const sw = StopWatch.create();
		const result = await this.editorWorkerService.computeDiff(original.uri, modified.uri, options, this.diffAlgorithm);
		const timeMs = sw.elapsed();
		this.telemetryService.publicLog2("diffEditor.computeDiff", {
			timeMs,
			timedOut: result?.quitEarly ?? true,
			detectedMoves: options.computeMoves ? result?.moves.length ?? 0 : -1
		});
		if (cancellationToken.isCancellationRequested) return {
			changes: [],
			identical: false,
			quitEarly: true,
			moves: []
		};
		if (!result) throw new Error("no diff result available");
		if (WorkerBasedDocumentDiffProvider_1.diffCache.size > 10) WorkerBasedDocumentDiffProvider_1.diffCache.delete(WorkerBasedDocumentDiffProvider_1.diffCache.keys().next().value);
		WorkerBasedDocumentDiffProvider_1.diffCache.set(uriKey, {
			result,
			context
		});
		return result;
	}
	setOptions(newOptions) {
		let didChange = false;
		if (newOptions.diffAlgorithm) {
			if (this.diffAlgorithm !== newOptions.diffAlgorithm) {
				this.diffAlgorithmOnDidChangeSubscription?.dispose();
				this.diffAlgorithmOnDidChangeSubscription = void 0;
				this.diffAlgorithm = newOptions.diffAlgorithm;
				if (typeof newOptions.diffAlgorithm !== "string") this.diffAlgorithmOnDidChangeSubscription = newOptions.diffAlgorithm.onDidChange(() => this.onDidChangeEventEmitter.fire());
				didChange = true;
			}
		}
		if (didChange) this.onDidChangeEventEmitter.fire();
	}
};
WorkerBasedDocumentDiffProvider = WorkerBasedDocumentDiffProvider_1 = __decorate$14([__param$14(1, IEditorWorkerService), __param$14(2, ITelemetryService)], WorkerBasedDocumentDiffProvider);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/observableInternal/utils/utilsCancellation.js
function waitForState(observable, predicate, isError, cancellationToken) {
	if (!predicate) predicate = (state) => state !== null && state !== void 0;
	return new Promise((resolve, reject) => {
		let isImmediateRun = true;
		let shouldDispose = false;
		const stateObs = observable.map((state) => {
			/** @description waitForState.state */
			return {
				isFinished: predicate(state),
				error: isError ? isError(state) : false,
				state
			};
		});
		const d = autorun((reader) => {
			/** @description waitForState */
			const { isFinished, error, state } = stateObs.read(reader);
			if (isFinished || error) {
				if (isImmediateRun) shouldDispose = true;
				else d.dispose();
				if (error) reject(error === true ? state : error);
				else resolve(state);
			}
		});
		if (cancellationToken) {
			const dc = cancellationToken.onCancellationRequested(() => {
				d.dispose();
				dc.dispose();
				reject(new CancellationError());
			});
			if (cancellationToken.isCancellationRequested) {
				d.dispose();
				dc.dispose();
				reject(new CancellationError());
				return;
			}
		}
		isImmediateRun = false;
		if (shouldDispose) d.dispose();
	});
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/observableInternal/observables/observableSignalFromEvent.js
function observableSignalFromEvent(owner, event, debugLocation = DebugLocation.ofCaller()) {
	return new FromEventObservableSignal(typeof owner === "string" ? owner : new DebugNameData(owner, void 0, void 0), event, debugLocation);
}
var FromEventObservableSignal = class extends BaseObservable {
	constructor(debugNameDataOrName, event, debugLocation) {
		super(debugLocation);
		this.event = event;
		this.handleEvent = () => {
			transaction((tx) => {
				for (const o of this._observers) {
					tx.updateObserver(o, this);
					o.handleChange(this, void 0);
				}
			}, () => this.debugName);
		};
		this.debugName = typeof debugNameDataOrName === "string" ? debugNameDataOrName : debugNameDataOrName.getDebugName(this) ?? "Observable Signal From Event";
	}
	onFirstObserverAdded() {
		this.subscription = this.event(this.handleEvent);
	}
	onLastObserverRemoved() {
		this.subscription.dispose();
		this.subscription = void 0;
	}
	get() {}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/diffEditor/diffEditorViewModel.js
var __decorate$13 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$13 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var DiffEditorViewModel = class DiffEditorViewModel extends Disposable {
	setActiveMovedText(movedText) {
		this._activeMovedText.set(movedText, void 0);
	}
	constructor(model, _options, _diffProviderFactoryService) {
		super();
		this.model = model;
		this._options = _options;
		this._diffProviderFactoryService = _diffProviderFactoryService;
		this._isDiffUpToDate = observableValue(this, false);
		this.isDiffUpToDate = this._isDiffUpToDate;
		this._diff = observableValue(this, void 0);
		this.diff = this._diff;
		this._unchangedRegions = observableValue(this, void 0);
		this.unchangedRegions = derived(this, (r) => {
			if (this._options.hideUnchangedRegions.read(r)) return this._unchangedRegions.read(r)?.regions ?? [];
			else {
				transaction((tx) => {
					for (const r of this._unchangedRegions.read(void 0)?.regions || []) r.collapseAll(tx);
				});
				return [];
			}
		});
		this.movedTextToCompare = observableValue(this, void 0);
		this._activeMovedText = observableValue(this, void 0);
		this._hoveredMovedText = observableValue(this, void 0);
		this.activeMovedText = derived(this, (r) => this.movedTextToCompare.read(r) ?? this._hoveredMovedText.read(r) ?? this._activeMovedText.read(r));
		this._cancellationTokenSource = new CancellationTokenSource$1();
		this._diffProvider = derived(this, (reader) => {
			const diffProvider = this._diffProviderFactoryService.createDiffProvider({ diffAlgorithm: this._options.diffAlgorithm.read(reader) });
			return {
				diffProvider,
				onChangeSignal: observableSignalFromEvent("onDidChange", diffProvider.onDidChange)
			};
		});
		this._register(toDisposable(() => this._cancellationTokenSource.cancel()));
		const contentChangedSignal = observableSignal("contentChangedSignal");
		const debouncer = this._register(new RunOnceScheduler(() => contentChangedSignal.trigger(void 0), 200));
		this._register(autorun((reader) => {
			/** @description collapse touching unchanged ranges */
			const lastUnchangedRegions = this._unchangedRegions.read(reader);
			if (!lastUnchangedRegions || lastUnchangedRegions.regions.some((r) => r.isDragged.read(reader))) return;
			const lastUnchangedRegionsOrigRanges = lastUnchangedRegions.originalDecorationIds.map((id) => model.original.getDecorationRange(id)).map((r) => r ? LineRange.fromRangeInclusive(r) : void 0);
			const lastUnchangedRegionsModRanges = lastUnchangedRegions.modifiedDecorationIds.map((id) => model.modified.getDecorationRange(id)).map((r) => r ? LineRange.fromRangeInclusive(r) : void 0);
			const updatedLastUnchangedRegions = lastUnchangedRegions.regions.map((r, idx) => !lastUnchangedRegionsOrigRanges[idx] || !lastUnchangedRegionsModRanges[idx] ? void 0 : new UnchangedRegion(lastUnchangedRegionsOrigRanges[idx].startLineNumber, lastUnchangedRegionsModRanges[idx].startLineNumber, lastUnchangedRegionsOrigRanges[idx].length, r.visibleLineCountTop.read(reader), r.visibleLineCountBottom.read(reader))).filter(isDefined);
			const newRanges = [];
			let didChange = false;
			for (const touching of groupAdjacentBy(updatedLastUnchangedRegions, (a, b) => a.getHiddenModifiedRange(reader).endLineNumberExclusive === b.getHiddenModifiedRange(reader).startLineNumber)) if (touching.length > 1) {
				didChange = true;
				const sumLineCount = touching.reduce((sum, r) => sum + r.lineCount, 0);
				const r = new UnchangedRegion(touching[0].originalLineNumber, touching[0].modifiedLineNumber, sumLineCount, touching[0].visibleLineCountTop.read(void 0), touching[touching.length - 1].visibleLineCountBottom.read(void 0));
				newRanges.push(r);
			} else newRanges.push(touching[0]);
			if (didChange) {
				const originalDecorationIds = model.original.deltaDecorations(lastUnchangedRegions.originalDecorationIds, newRanges.map((r) => ({
					range: r.originalUnchangedRange.toInclusiveRange(),
					options: { description: "unchanged" }
				})));
				const modifiedDecorationIds = model.modified.deltaDecorations(lastUnchangedRegions.modifiedDecorationIds, newRanges.map((r) => ({
					range: r.modifiedUnchangedRange.toInclusiveRange(),
					options: { description: "unchanged" }
				})));
				transaction((tx) => {
					this._unchangedRegions.set({
						regions: newRanges,
						originalDecorationIds,
						modifiedDecorationIds
					}, tx);
				});
			}
		}));
		const updateUnchangedRegions = (result, tx, reader) => {
			const newUnchangedRegions = UnchangedRegion.fromDiffs(result.changes, model.original.getLineCount(), model.modified.getLineCount(), this._options.hideUnchangedRegionsMinimumLineCount.read(reader), this._options.hideUnchangedRegionsContextLineCount.read(reader));
			let visibleRegions = void 0;
			const lastUnchangedRegions = this._unchangedRegions.get();
			if (lastUnchangedRegions) {
				const lastUnchangedRegionsOrigRanges = lastUnchangedRegions.originalDecorationIds.map((id) => model.original.getDecorationRange(id)).map((r) => r ? LineRange.fromRangeInclusive(r) : void 0);
				const lastUnchangedRegionsModRanges = lastUnchangedRegions.modifiedDecorationIds.map((id) => model.modified.getDecorationRange(id)).map((r) => r ? LineRange.fromRangeInclusive(r) : void 0);
				let hiddenRegions = filterWithPrevious(lastUnchangedRegions.regions.map((r, idx) => {
					if (!lastUnchangedRegionsOrigRanges[idx] || !lastUnchangedRegionsModRanges[idx]) return;
					const length = lastUnchangedRegionsOrigRanges[idx].length;
					return new UnchangedRegion(lastUnchangedRegionsOrigRanges[idx].startLineNumber, lastUnchangedRegionsModRanges[idx].startLineNumber, length, Math.min(r.visibleLineCountTop.get(), length), Math.min(r.visibleLineCountBottom.get(), length - r.visibleLineCountTop.get()));
				}).filter(isDefined), (cur, prev) => !prev || cur.modifiedLineNumber >= prev.modifiedLineNumber + prev.lineCount && cur.originalLineNumber >= prev.originalLineNumber + prev.lineCount).map((r) => new LineRangeMapping(r.getHiddenOriginalRange(reader), r.getHiddenModifiedRange(reader)));
				hiddenRegions = LineRangeMapping.clip(hiddenRegions, LineRange.ofLength(1, model.original.getLineCount()), LineRange.ofLength(1, model.modified.getLineCount()));
				visibleRegions = LineRangeMapping.inverse(hiddenRegions, model.original.getLineCount(), model.modified.getLineCount());
			}
			const newUnchangedRegions2 = [];
			if (visibleRegions) for (const r of newUnchangedRegions) {
				const intersecting = visibleRegions.filter((f) => f.original.intersectsStrict(r.originalUnchangedRange) && f.modified.intersectsStrict(r.modifiedUnchangedRange));
				newUnchangedRegions2.push(...r.setVisibleRanges(intersecting, tx));
			}
			else newUnchangedRegions2.push(...newUnchangedRegions);
			const originalDecorationIds = model.original.deltaDecorations(lastUnchangedRegions?.originalDecorationIds || [], newUnchangedRegions2.map((r) => ({
				range: r.originalUnchangedRange.toInclusiveRange(),
				options: { description: "unchanged" }
			})));
			const modifiedDecorationIds = model.modified.deltaDecorations(lastUnchangedRegions?.modifiedDecorationIds || [], newUnchangedRegions2.map((r) => ({
				range: r.modifiedUnchangedRange.toInclusiveRange(),
				options: { description: "unchanged" }
			})));
			this._unchangedRegions.set({
				regions: newUnchangedRegions2,
				originalDecorationIds,
				modifiedDecorationIds
			}, tx);
		};
		this._register(model.modified.onDidChangeContent((e) => {
			if (this._diff.get()) {
				TextEditInfo.fromModelContentChanges(e.changes);
				this._lastDiff, model.original, model.modified;
			}
			this._isDiffUpToDate.set(false, void 0);
			debouncer.schedule();
		}));
		this._register(model.original.onDidChangeContent((e) => {
			if (this._diff.get()) {
				TextEditInfo.fromModelContentChanges(e.changes);
				this._lastDiff, model.original, model.modified;
			}
			this._isDiffUpToDate.set(false, void 0);
			debouncer.schedule();
		}));
		this._register(autorun(async (reader) => {
			/** @description compute diff */
			const store = reader.store;
			this._options.hideUnchangedRegionsMinimumLineCount.read(reader);
			this._options.hideUnchangedRegionsContextLineCount.read(reader);
			debouncer.cancel();
			contentChangedSignal.read(reader);
			const documentDiffProvider = this._diffProvider.read(reader);
			documentDiffProvider.onChangeSignal.read(reader);
			this._isDiffUpToDate.set(false, void 0);
			let originalTextEditInfos = [];
			store.add(model.original.onDidChangeContent((e) => {
				const edits = TextEditInfo.fromModelContentChanges(e.changes);
				originalTextEditInfos = combineTextEditInfos(originalTextEditInfos, edits);
			}));
			let modifiedTextEditInfos = [];
			store.add(model.modified.onDidChangeContent((e) => {
				const edits = TextEditInfo.fromModelContentChanges(e.changes);
				modifiedTextEditInfos = combineTextEditInfos(modifiedTextEditInfos, edits);
			}));
			let result = await documentDiffProvider.diffProvider.computeDiff(model.original, model.modified, {
				ignoreTrimWhitespace: this._options.ignoreTrimWhitespace.read(reader),
				maxComputationTimeMs: this._options.maxComputationTimeMs.read(reader),
				computeMoves: this._options.showMoves.read(reader)
			}, this._cancellationTokenSource.token).catch(rejectIfNotCanceled);
			if (!result || this._cancellationTokenSource.token.isCancellationRequested) return;
			if (model.original.isDisposed() || model.modified.isDisposed()) return;
			result = normalizeDocumentDiff(result, model.original, model.modified);
			result = (model.original, model.modified, result);
			result = (model.original, model.modified, result);
			transaction((tx) => {
				/** @description write diff result */
				updateUnchangedRegions(result, tx);
				this._lastDiff = result;
				const state = DiffState.fromDiffResult(result);
				this._diff.set(state, tx);
				this._isDiffUpToDate.set(true, tx);
				const currentSyncedMovedText = this.movedTextToCompare.read(void 0);
				this.movedTextToCompare.set(currentSyncedMovedText ? this._lastDiff.moves.find((m) => m.lineRangeMapping.modified.intersect(currentSyncedMovedText.lineRangeMapping.modified)) : void 0, tx);
			});
		}));
	}
	ensureModifiedLineIsVisible(lineNumber, preference, tx) {
		if (this.diff.get()?.mappings.length === 0) return;
		const unchangedRegions = this._unchangedRegions.get()?.regions || [];
		for (const r of unchangedRegions) if (r.getHiddenModifiedRange(void 0).contains(lineNumber)) {
			r.showModifiedLine(lineNumber, preference, tx);
			return;
		}
	}
	ensureOriginalLineIsVisible(lineNumber, preference, tx) {
		if (this.diff.get()?.mappings.length === 0) return;
		const unchangedRegions = this._unchangedRegions.get()?.regions || [];
		for (const r of unchangedRegions) if (r.getHiddenOriginalRange(void 0).contains(lineNumber)) {
			r.showOriginalLine(lineNumber, preference, tx);
			return;
		}
	}
	async waitForDiff() {
		await waitForState(this.isDiffUpToDate, (s) => s, void 0, this._cancellationTokenSource.token).catch(rejectIfNotCanceled);
	}
	serializeState() {
		return { collapsedRegions: this._unchangedRegions.get()?.regions.map((r) => ({ range: r.getHiddenModifiedRange(void 0).serialize() })) };
	}
	restoreSerializedState(state) {
		const ranges = state.collapsedRegions?.map((r) => LineRange.deserialize(r.range));
		const regions = this._unchangedRegions.get();
		if (!regions || !ranges) return;
		transaction((tx) => {
			for (const r of regions.regions) for (const range of ranges) if (r.modifiedUnchangedRange.intersect(range)) {
				r.setHiddenModifiedRange(range, tx);
				break;
			}
		});
	}
};
DiffEditorViewModel = __decorate$13([__param$13(2, IDiffProviderFactoryService)], DiffEditorViewModel);
function normalizeDocumentDiff(diff, original, modified) {
	return {
		changes: diff.changes.map((c) => new DetailedLineRangeMapping(c.original, c.modified, c.innerChanges ? c.innerChanges.map((i) => normalizeRangeMapping(i, original, modified)) : void 0)),
		moves: diff.moves,
		identical: diff.identical,
		quitEarly: diff.quitEarly
	};
}
function normalizeRangeMapping(rangeMapping, original, modified) {
	let originalRange = rangeMapping.originalRange;
	let modifiedRange = rangeMapping.modifiedRange;
	if (originalRange.startColumn === 1 && modifiedRange.startColumn === 1 && (originalRange.endColumn !== 1 || modifiedRange.endColumn !== 1) && originalRange.endColumn === original.getLineMaxColumn(originalRange.endLineNumber) && modifiedRange.endColumn === modified.getLineMaxColumn(modifiedRange.endLineNumber) && originalRange.endLineNumber < original.getLineCount() && modifiedRange.endLineNumber < modified.getLineCount()) {
		originalRange = originalRange.setEndPosition(originalRange.endLineNumber + 1, 1);
		modifiedRange = modifiedRange.setEndPosition(modifiedRange.endLineNumber + 1, 1);
	}
	return new RangeMapping(originalRange, modifiedRange);
}
var DiffState = class DiffState {
	static fromDiffResult(result) {
		return new DiffState(result.changes.map((c) => new DiffMapping(c)), result.moves || [], result.identical, result.quitEarly);
	}
	constructor(mappings, movedTexts, identical, quitEarly) {
		this.mappings = mappings;
		this.movedTexts = movedTexts;
		this.identical = identical;
		this.quitEarly = quitEarly;
	}
};
var DiffMapping = class {
	constructor(lineRangeMapping) {
		this.lineRangeMapping = lineRangeMapping;
	}
};
var UnchangedRegion = class UnchangedRegion {
	static fromDiffs(changes, originalLineCount, modifiedLineCount, minHiddenLineCount, minContext) {
		const inversedMappings = DetailedLineRangeMapping.inverse(changes, originalLineCount, modifiedLineCount);
		const result = [];
		for (const mapping of inversedMappings) {
			let origStart = mapping.original.startLineNumber;
			let modStart = mapping.modified.startLineNumber;
			let length = mapping.original.length;
			const atStart = origStart === 1 && modStart === 1;
			const atEnd = origStart + length === originalLineCount + 1 && modStart + length === modifiedLineCount + 1;
			if ((atStart || atEnd) && length >= minContext + minHiddenLineCount) {
				if (atStart && !atEnd) length -= minContext;
				if (atEnd && !atStart) {
					origStart += minContext;
					modStart += minContext;
					length -= minContext;
				}
				result.push(new UnchangedRegion(origStart, modStart, length, 0, 0));
			} else if (length >= minContext * 2 + minHiddenLineCount) {
				origStart += minContext;
				modStart += minContext;
				length -= minContext * 2;
				result.push(new UnchangedRegion(origStart, modStart, length, 0, 0));
			}
		}
		return result;
	}
	get originalUnchangedRange() {
		return LineRange.ofLength(this.originalLineNumber, this.lineCount);
	}
	get modifiedUnchangedRange() {
		return LineRange.ofLength(this.modifiedLineNumber, this.lineCount);
	}
	constructor(originalLineNumber, modifiedLineNumber, lineCount, visibleLineCountTop, visibleLineCountBottom) {
		this.originalLineNumber = originalLineNumber;
		this.modifiedLineNumber = modifiedLineNumber;
		this.lineCount = lineCount;
		this._visibleLineCountTop = observableValue(this, 0);
		this.visibleLineCountTop = this._visibleLineCountTop;
		this._visibleLineCountBottom = observableValue(this, 0);
		this.visibleLineCountBottom = this._visibleLineCountBottom;
		this._shouldHideControls = derived(this, (reader) => this.visibleLineCountTop.read(reader) + this.visibleLineCountBottom.read(reader) === this.lineCount && !this.isDragged.read(reader));
		this.isDragged = observableValue(this, void 0);
		const visibleLineCountTop2 = Math.max(Math.min(visibleLineCountTop, this.lineCount), 0);
		const visibleLineCountBottom2 = Math.max(Math.min(visibleLineCountBottom, this.lineCount - visibleLineCountTop), 0);
		softAssert(visibleLineCountTop === visibleLineCountTop2);
		softAssert(visibleLineCountBottom === visibleLineCountBottom2);
		this._visibleLineCountTop.set(visibleLineCountTop2, void 0);
		this._visibleLineCountBottom.set(visibleLineCountBottom2, void 0);
	}
	setVisibleRanges(visibleRanges, tx) {
		const result = [];
		const hiddenModified = new LineRangeSet(visibleRanges.map((r) => r.modified)).subtractFrom(this.modifiedUnchangedRange);
		let originalStartLineNumber = this.originalLineNumber;
		let modifiedStartLineNumber = this.modifiedLineNumber;
		const modifiedEndLineNumberEx = this.modifiedLineNumber + this.lineCount;
		if (hiddenModified.ranges.length === 0) {
			this.showAll(tx);
			result.push(this);
		} else {
			let i = 0;
			for (const r of hiddenModified.ranges) {
				const isLast = i === hiddenModified.ranges.length - 1;
				i++;
				const length = (isLast ? modifiedEndLineNumberEx : r.endLineNumberExclusive) - modifiedStartLineNumber;
				const newR = new UnchangedRegion(originalStartLineNumber, modifiedStartLineNumber, length, 0, 0);
				newR.setHiddenModifiedRange(r, tx);
				result.push(newR);
				originalStartLineNumber = newR.originalUnchangedRange.endLineNumberExclusive;
				modifiedStartLineNumber = newR.modifiedUnchangedRange.endLineNumberExclusive;
			}
		}
		return result;
	}
	shouldHideControls(reader) {
		return this._shouldHideControls.read(reader);
	}
	getHiddenOriginalRange(reader) {
		return LineRange.ofLength(this.originalLineNumber + this._visibleLineCountTop.read(reader), this.lineCount - this._visibleLineCountTop.read(reader) - this._visibleLineCountBottom.read(reader));
	}
	getHiddenModifiedRange(reader) {
		return LineRange.ofLength(this.modifiedLineNumber + this._visibleLineCountTop.read(reader), this.lineCount - this._visibleLineCountTop.read(reader) - this._visibleLineCountBottom.read(reader));
	}
	setHiddenModifiedRange(range, tx) {
		const visibleLineCountTop = range.startLineNumber - this.modifiedLineNumber;
		const visibleLineCountBottom = this.modifiedLineNumber + this.lineCount - range.endLineNumberExclusive;
		this.setState(visibleLineCountTop, visibleLineCountBottom, tx);
	}
	getMaxVisibleLineCountTop() {
		return this.lineCount - this._visibleLineCountBottom.get();
	}
	getMaxVisibleLineCountBottom() {
		return this.lineCount - this._visibleLineCountTop.get();
	}
	showMoreAbove(count = 10, tx) {
		const maxVisibleLineCountTop = this.getMaxVisibleLineCountTop();
		this._visibleLineCountTop.set(Math.min(this._visibleLineCountTop.get() + count, maxVisibleLineCountTop), tx);
	}
	showMoreBelow(count = 10, tx) {
		const maxVisibleLineCountBottom = this.lineCount - this._visibleLineCountTop.get();
		this._visibleLineCountBottom.set(Math.min(this._visibleLineCountBottom.get() + count, maxVisibleLineCountBottom), tx);
	}
	showAll(tx) {
		this._visibleLineCountBottom.set(this.lineCount - this._visibleLineCountTop.get(), tx);
	}
	showModifiedLine(lineNumber, preference, tx) {
		const top = lineNumber + 1 - (this.modifiedLineNumber + this._visibleLineCountTop.get());
		const bottom = this.modifiedLineNumber - this._visibleLineCountBottom.get() + this.lineCount - lineNumber;
		if (preference === 0 && top < bottom || preference === 1) this._visibleLineCountTop.set(this._visibleLineCountTop.get() + top, tx);
		else this._visibleLineCountBottom.set(this._visibleLineCountBottom.get() + bottom, tx);
	}
	showOriginalLine(lineNumber, preference, tx) {
		const top = lineNumber - this.originalLineNumber;
		const bottom = this.originalLineNumber + this.lineCount - lineNumber;
		if (preference === 0 && top < bottom || preference === 1) this._visibleLineCountTop.set(Math.min(this._visibleLineCountTop.get() + bottom - top, this.getMaxVisibleLineCountTop()), tx);
		else this._visibleLineCountBottom.set(Math.min(this._visibleLineCountBottom.get() + top - bottom, this.getMaxVisibleLineCountBottom()), tx);
	}
	collapseAll(tx) {
		this._visibleLineCountTop.set(0, tx);
		this._visibleLineCountBottom.set(0, tx);
	}
	setState(visibleLineCountTop, visibleLineCountBottom, tx) {
		visibleLineCountTop = Math.max(Math.min(visibleLineCountTop, this.lineCount), 0);
		visibleLineCountBottom = Math.max(Math.min(visibleLineCountBottom, this.lineCount - visibleLineCountTop), 0);
		this._visibleLineCountTop.set(visibleLineCountTop, tx);
		this._visibleLineCountBottom.set(visibleLineCountBottom, tx);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/diffEditor/components/diffEditorViewZones/copySelection.js
function enableCopySelection(options) {
	const { domNode, renderLinesResult, diffEntry, originalModel, clipboardService } = options;
	const viewZoneDisposable = new DisposableStore();
	viewZoneDisposable.add(addDisposableListener(domNode, "copy", (e) => {
		e.preventDefault();
		const selection = domNode.ownerDocument.getSelection();
		if (!selection || selection.rangeCount === 0) return;
		const domRange = selection.getRangeAt(0);
		if (!domRange || domRange.collapsed) return;
		const startElement = domRange.startContainer.nodeType === Node.TEXT_NODE ? domRange.startContainer.parentElement : domRange.startContainer;
		const endElement = domRange.endContainer.nodeType === Node.TEXT_NODE ? domRange.endContainer.parentElement : domRange.endContainer;
		if (!startElement || !endElement) return;
		const startPosition = renderLinesResult.getModelPositionAt(startElement, domRange.startOffset);
		const endPosition = renderLinesResult.getModelPositionAt(endElement, domRange.endOffset);
		if (!startPosition || !endPosition) return;
		const adjustedStart = startPosition.delta(diffEntry.original.startLineNumber - 1);
		const adjustedEnd = endPosition.delta(diffEntry.original.startLineNumber - 1);
		const range = adjustedEnd.isBefore(adjustedStart) ? Range$2.fromPositions(adjustedEnd, adjustedStart) : Range$2.fromPositions(adjustedStart, adjustedEnd);
		const selectedText = originalModel.getValueInRange(range);
		clipboardService.writeText(selectedText);
	}));
	return viewZoneDisposable;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/diffEditor/components/diffEditorViewZones/inlineDiffDeletedCodeMargin.js
var InlineDiffDeletedCodeMargin = class extends Disposable {
	get visibility() {
		return this._visibility;
	}
	set visibility(_visibility) {
		if (this._visibility !== _visibility) {
			this._visibility = _visibility;
			this._diffActions.style.visibility = _visibility ? "visible" : "hidden";
		}
	}
	constructor(_getViewZoneId, _marginDomNode, _deletedCodeDomNode, _modifiedEditor, _diff, _editor, _renderLinesResult, _originalTextModel, _contextMenuService, _clipboardService) {
		super();
		this._getViewZoneId = _getViewZoneId;
		this._marginDomNode = _marginDomNode;
		this._deletedCodeDomNode = _deletedCodeDomNode;
		this._modifiedEditor = _modifiedEditor;
		this._diff = _diff;
		this._editor = _editor;
		this._renderLinesResult = _renderLinesResult;
		this._originalTextModel = _originalTextModel;
		this._contextMenuService = _contextMenuService;
		this._clipboardService = _clipboardService;
		this._visibility = false;
		this._marginDomNode.style.zIndex = "10";
		this._diffActions = document.createElement("div");
		this._diffActions.className = ThemeIcon.asClassName(Codicon.lightBulb) + " lightbulb-glyph";
		this._diffActions.style.position = "absolute";
		const lineHeight = this._modifiedEditor.getOption(75);
		this._diffActions.style.right = "0px";
		this._diffActions.style.visibility = "hidden";
		this._diffActions.style.height = `${lineHeight}px`;
		this._diffActions.style.lineHeight = `${lineHeight}px`;
		this._marginDomNode.appendChild(this._diffActions);
		let currentLineNumberOffset = 0;
		const useShadowDOM = _modifiedEditor.getOption(144) && !isIOS;
		const showContextMenu = (anchor, baseActions, onHide) => {
			this._contextMenuService.showContextMenu({
				domForShadowRoot: useShadowDOM ? _modifiedEditor.getDomNode() ?? void 0 : void 0,
				getAnchor: () => anchor,
				onHide,
				getActions: () => {
					const actions = [];
					const isDeletion = _diff.modified.isEmpty;
					actions.push(new Action("diff.clipboard.copyDeletedContent", isDeletion ? _diff.original.length > 1 ? localize(128, "Copy deleted lines") : localize(129, "Copy deleted line") : _diff.original.length > 1 ? localize(130, "Copy changed lines") : localize(131, "Copy changed line"), void 0, true, async () => {
						const originalText = this._originalTextModel.getValueInRange(_diff.original.toExclusiveRange());
						await this._clipboardService.writeText(originalText);
					}));
					if (_diff.original.length > 1) actions.push(new Action("diff.clipboard.copyDeletedLineContent", isDeletion ? localize(132, "Copy deleted line ({0})", _diff.original.startLineNumber + currentLineNumberOffset) : localize(133, "Copy changed line ({0})", _diff.original.startLineNumber + currentLineNumberOffset), void 0, true, async () => {
						let lineContent = this._originalTextModel.getLineContent(_diff.original.startLineNumber + currentLineNumberOffset);
						if (lineContent === "") lineContent = this._originalTextModel.getEndOfLineSequence() === 0 ? "\n" : "\r\n";
						await this._clipboardService.writeText(lineContent);
					}));
					if (!_modifiedEditor.getOption(104)) actions.push(new Action("diff.inline.revertChange", localize(134, "Revert this change"), void 0, true, async () => {
						this._editor.revert(this._diff);
					}));
					return actions;
				},
				autoSelectFirstItem: true
			});
		};
		this._register(addStandardDisposableListener(this._diffActions, "mousedown", (e) => {
			if (!e.leftButton) return;
			const { top, height } = getDomNodePagePosition(this._diffActions);
			const pad = Math.floor(lineHeight / 3);
			e.preventDefault();
			showContextMenu({
				x: e.posx,
				y: top + height + pad
			});
		}));
		this._register(_modifiedEditor.onMouseMove((e) => {
			if ((e.target.type === 8 || e.target.type === 5) && e.target.detail.viewZoneId === this._getViewZoneId()) {
				currentLineNumberOffset = this._updateLightBulbPosition(this._marginDomNode, e.event.browserEvent.y, lineHeight);
				this.visibility = true;
			} else this.visibility = false;
		}));
		this._register(enableCopySelection({
			domNode: this._deletedCodeDomNode,
			diffEntry: _diff,
			originalModel: this._originalTextModel,
			renderLinesResult: this._renderLinesResult,
			clipboardService: _clipboardService
		}));
	}
	_updateLightBulbPosition(marginDomNode, y, lineHeight) {
		const { top } = getDomNodePagePosition(marginDomNode);
		const offset = y - top;
		const lineNumberOffset = Math.floor(offset / lineHeight);
		const newTop = lineNumberOffset * lineHeight;
		this._diffActions.style.top = `${newTop}px`;
		if (this._renderLinesResult.viewLineCounts) {
			let acc = 0;
			for (let i = 0; i < this._renderLinesResult.viewLineCounts.length; i++) {
				acc += this._renderLinesResult.viewLineCounts[i];
				if (lineNumberOffset < acc) return i;
			}
		}
		return lineNumberOffset;
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/diffEditor/components/diffEditorViewZones/renderLines.js
var ttPolicy = createTrustedTypesPolicy("diffEditorWidget", { createHTML: (value) => value });
function renderLines(source, options, decorations, domNode, noExtra = false) {
	applyFontInfo(domNode, options.fontInfo);
	const hasCharChanges = decorations.length > 0;
	const sb = new StringBuilder(1e4);
	let maxCharsPerLine = 0;
	let renderedLineCount = 0;
	const viewLineCounts = [];
	const renderOutputs = [];
	for (let lineIndex = 0; lineIndex < source.lineTokens.length; lineIndex++) {
		const lineNumber = lineIndex + 1;
		const lineTokens = source.lineTokens[lineIndex];
		const lineBreakData = source.lineBreakData[lineIndex];
		const actualDecorations = LineDecoration.filter(decorations, lineNumber, 1, Number.MAX_SAFE_INTEGER);
		if (lineBreakData) {
			let lastBreakOffset = 0;
			for (const breakOffset of lineBreakData.breakOffsets) {
				const viewLineTokens = lineTokens.sliceAndInflate(lastBreakOffset, breakOffset, 0);
				const result = renderOriginalLine(renderedLineCount, viewLineTokens, LineDecoration.extractWrapped(actualDecorations, lastBreakOffset, breakOffset), hasCharChanges, source.mightContainNonBasicASCII, source.mightContainRTL, options, sb, noExtra);
				maxCharsPerLine = Math.max(maxCharsPerLine, result.maxCharWidth);
				renderOutputs.push(new RenderLineOutputWithOffset(result.output.characterMapping, result.output.containsForeignElements, lastBreakOffset));
				renderedLineCount++;
				lastBreakOffset = breakOffset;
			}
			viewLineCounts.push(lineBreakData.breakOffsets.length);
		} else {
			viewLineCounts.push(1);
			const result = renderOriginalLine(renderedLineCount, lineTokens, actualDecorations, hasCharChanges, source.mightContainNonBasicASCII, source.mightContainRTL, options, sb, noExtra);
			maxCharsPerLine = Math.max(maxCharsPerLine, result.maxCharWidth);
			renderOutputs.push(new RenderLineOutputWithOffset(result.output.characterMapping, result.output.containsForeignElements, 0));
			renderedLineCount++;
		}
	}
	maxCharsPerLine += options.scrollBeyondLastColumn;
	const html = sb.build();
	domNode.innerHTML = ttPolicy ? ttPolicy.createHTML(html) : html;
	const minWidthInPx = maxCharsPerLine * options.typicalHalfwidthCharacterWidth;
	return new RenderLinesResult(renderedLineCount, minWidthInPx, viewLineCounts, renderOutputs, source);
}
var LineSource = class {
	constructor(lineTokens, lineBreakData = lineTokens.map((t) => null), mightContainNonBasicASCII = true, mightContainRTL = true) {
		this.lineTokens = lineTokens;
		this.lineBreakData = lineBreakData;
		this.mightContainNonBasicASCII = mightContainNonBasicASCII;
		this.mightContainRTL = mightContainRTL;
	}
};
var RenderOptions = class RenderOptions {
	static fromEditor(editor) {
		const modifiedEditorOptions = editor.getOptions();
		const fontInfo = modifiedEditorOptions.get(59);
		const layoutInfo = modifiedEditorOptions.get(166);
		return new RenderOptions(editor.getModel()?.getOptions().tabSize || 0, fontInfo, modifiedEditorOptions.get(40), fontInfo.typicalHalfwidthCharacterWidth, modifiedEditorOptions.get(118), modifiedEditorOptions.get(75), layoutInfo.decorationsWidth, modifiedEditorOptions.get(133), modifiedEditorOptions.get(113), modifiedEditorOptions.get(108), modifiedEditorOptions.get(60), modifiedEditorOptions.get(117).verticalScrollbarSize, modifiedEditorOptions.get(176) === "twoCells");
	}
	constructor(tabSize, fontInfo, disableMonospaceOptimizations, typicalHalfwidthCharacterWidth, scrollBeyondLastColumn, lineHeight, lineDecorationsWidth, stopRenderingLineAfter, renderWhitespace, renderControlCharacters, fontLigatures, verticalScrollbarSize, useTwoCellFullwidthCharacters = false, setWidth = true) {
		this.tabSize = tabSize;
		this.fontInfo = fontInfo;
		this.disableMonospaceOptimizations = disableMonospaceOptimizations;
		this.typicalHalfwidthCharacterWidth = typicalHalfwidthCharacterWidth;
		this.scrollBeyondLastColumn = scrollBeyondLastColumn;
		this.lineHeight = lineHeight;
		this.lineDecorationsWidth = lineDecorationsWidth;
		this.stopRenderingLineAfter = stopRenderingLineAfter;
		this.renderWhitespace = renderWhitespace;
		this.renderControlCharacters = renderControlCharacters;
		this.fontLigatures = fontLigatures;
		this.verticalScrollbarSize = verticalScrollbarSize;
		this.useTwoCellFullwidthCharacters = useTwoCellFullwidthCharacters;
		this.setWidth = setWidth;
	}
	withSetWidth(setWidth) {
		return new RenderOptions(this.tabSize, this.fontInfo, this.disableMonospaceOptimizations, this.typicalHalfwidthCharacterWidth, this.scrollBeyondLastColumn, this.lineHeight, this.lineDecorationsWidth, this.stopRenderingLineAfter, this.renderWhitespace, this.renderControlCharacters, this.fontLigatures, this.verticalScrollbarSize, this.useTwoCellFullwidthCharacters, setWidth);
	}
	withScrollBeyondLastColumn(scrollBeyondLastColumn) {
		return new RenderOptions(this.tabSize, this.fontInfo, this.disableMonospaceOptimizations, this.typicalHalfwidthCharacterWidth, scrollBeyondLastColumn, this.lineHeight, this.lineDecorationsWidth, this.stopRenderingLineAfter, this.renderWhitespace, this.renderControlCharacters, this.fontLigatures, this.verticalScrollbarSize, this.useTwoCellFullwidthCharacters, this.setWidth);
	}
};
var RenderLinesResult = class {
	constructor(heightInLines, minWidthInPx, viewLineCounts, _renderOutputs, _source) {
		this.heightInLines = heightInLines;
		this.minWidthInPx = minWidthInPx;
		this.viewLineCounts = viewLineCounts;
		this._renderOutputs = _renderOutputs;
		this._source = _source;
	}
	/**
	* Returns the model position for a given DOM node and offset within that node.
	* @param domNode The span node within a view-line where the offset is located
	* @param offset The offset within the span node
	* @returns The Position in the model, or undefined if the position cannot be determined
	*/
	getModelPositionAt(domNode, offset) {
		let viewLineElement = domNode;
		while (viewLineElement && !viewLineElement.classList.contains("view-line")) viewLineElement = viewLineElement.parentElement;
		if (!viewLineElement) return;
		const container = viewLineElement.parentElement;
		if (!container) return;
		const viewLines = container.querySelectorAll(".view-line");
		let viewLineIndex = -1;
		for (let i = 0; i < viewLines.length; i++) if (viewLines[i] === viewLineElement) {
			viewLineIndex = i;
			break;
		}
		if (viewLineIndex === -1 || viewLineIndex >= this._renderOutputs.length) return;
		let modelLineNumber = 1;
		let remainingViewLines = viewLineIndex;
		for (let i = 0; i < this.viewLineCounts.length; i++) {
			if (remainingViewLines < this.viewLineCounts[i]) {
				modelLineNumber = i + 1;
				break;
			}
			remainingViewLines -= this.viewLineCounts[i];
		}
		if (modelLineNumber > this._source.lineTokens.length) return;
		const renderOutput = this._renderOutputs[viewLineIndex];
		if (!renderOutput) return;
		const column = getColumnOfNodeOffset(renderOutput.characterMapping, domNode, offset) + renderOutput.offset;
		return new Position$1(modelLineNumber, column);
	}
};
var RenderLineOutputWithOffset = class extends RenderLineOutput {
	constructor(characterMapping, containsForeignElements, offset) {
		super(characterMapping, containsForeignElements);
		this.offset = offset;
	}
};
function renderOriginalLine(viewLineIdx, lineTokens, decorations, hasCharChanges, mightContainNonBasicASCII, mightContainRTL, options, sb, noExtra) {
	sb.appendString("<div class=\"view-line");
	if (!noExtra && !hasCharChanges) sb.appendString(" char-delete");
	sb.appendString("\" style=\"top:");
	sb.appendString(String(viewLineIdx * options.lineHeight));
	if (options.setWidth) sb.appendString("px;width:1000000px;\">");
	else sb.appendString("px;\">");
	const lineContent = lineTokens.getLineContent();
	const isBasicASCII = ViewLineRenderingData.isBasicASCII(lineContent, mightContainNonBasicASCII);
	const containsRTL = ViewLineRenderingData.containsRTL(lineContent, isBasicASCII, mightContainRTL);
	const output = renderViewLine(new RenderLineInput(options.fontInfo.isMonospace && !options.disableMonospaceOptimizations, options.fontInfo.canUseHalfwidthRightwardsArrow, lineContent, false, isBasicASCII, containsRTL, 0, lineTokens, decorations, options.tabSize, 0, options.fontInfo.spaceWidth, options.fontInfo.middotWidth, options.fontInfo.wsmiddotWidth, options.stopRenderingLineAfter, options.renderWhitespace, options.renderControlCharacters, options.fontLigatures !== EditorFontLigatures.OFF, null, null, options.verticalScrollbarSize, false, options.useTwoCellFullwidthCharacters), sb);
	sb.appendString("</div>");
	return {
		output,
		maxCharWidth: output.characterMapping.getHorizontalOffset(output.characterMapping.length)
	};
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/diffEditor/components/diffEditorViewZones/diffEditorViewZones.js
var __decorate$12 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$12 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
/**
* Ensures both editors have the same height by aligning unchanged lines.
* In inline view mode, inserts viewzones to show deleted code from the original text model in the modified code editor.
* Synchronizes scrolling.
*
* Make sure to add the view zones!
*/
var DiffEditorViewZones = class DiffEditorViewZones extends Disposable {
	constructor(_targetWindow, _editors, _diffModel, _options, _diffEditorWidget, _canIgnoreViewZoneUpdateEvent, _origViewZonesToIgnore, _modViewZonesToIgnore, _clipboardService, _contextMenuService) {
		super();
		this._targetWindow = _targetWindow;
		this._editors = _editors;
		this._diffModel = _diffModel;
		this._options = _options;
		this._diffEditorWidget = _diffEditorWidget;
		this._canIgnoreViewZoneUpdateEvent = _canIgnoreViewZoneUpdateEvent;
		this._origViewZonesToIgnore = _origViewZonesToIgnore;
		this._modViewZonesToIgnore = _modViewZonesToIgnore;
		this._clipboardService = _clipboardService;
		this._contextMenuService = _contextMenuService;
		this._originalTopPadding = observableValue(this, 0);
		this._originalScrollOffset = observableValue(this, 0);
		this._originalScrollOffsetAnimated = animatedObservable(this._targetWindow, this._originalScrollOffset, this._store);
		this._modifiedTopPadding = observableValue(this, 0);
		this._modifiedScrollOffset = observableValue(this, 0);
		this._modifiedScrollOffsetAnimated = animatedObservable(this._targetWindow, this._modifiedScrollOffset, this._store);
		const state = observableValue("invalidateAlignmentsState", 0);
		const updateImmediately = this._register(new RunOnceScheduler(() => {
			state.set(state.get() + 1, void 0);
		}, 0));
		this._register(this._editors.original.onDidChangeViewZones((_args) => {
			if (!this._canIgnoreViewZoneUpdateEvent()) updateImmediately.schedule();
		}));
		this._register(this._editors.modified.onDidChangeViewZones((_args) => {
			if (!this._canIgnoreViewZoneUpdateEvent()) updateImmediately.schedule();
		}));
		this._register(this._editors.original.onDidChangeConfiguration((args) => {
			if (args.hasChanged(167) || args.hasChanged(75)) updateImmediately.schedule();
		}));
		this._register(this._editors.modified.onDidChangeConfiguration((args) => {
			if (args.hasChanged(167) || args.hasChanged(75)) updateImmediately.schedule();
		}));
		const originalModelTokenizationCompleted = this._diffModel.map((m) => m ? observableFromEvent(this, m.model.original.onDidChangeTokens, () => m.model.original.tokenization.backgroundTokenizationState === 2) : void 0).map((m, reader) => m?.read(reader));
		const alignments = derived((reader) => {
			/** @description alignments */
			const diffModel = this._diffModel.read(reader);
			const diff = diffModel?.diff.read(reader);
			if (!diffModel || !diff) return null;
			state.read(reader);
			const innerHunkAlignment = this._options.renderSideBySide.read(reader);
			return computeRangeAlignment(this._editors.original, this._editors.modified, diff.mappings, this._origViewZonesToIgnore, this._modViewZonesToIgnore, innerHunkAlignment);
		});
		const alignmentsSyncedMovedText = derived((reader) => {
			/** @description alignmentsSyncedMovedText */
			const syncedMovedText = this._diffModel.read(reader)?.movedTextToCompare.read(reader);
			if (!syncedMovedText) return null;
			state.read(reader);
			const mappings = syncedMovedText.changes.map((c) => new DiffMapping(c));
			return computeRangeAlignment(this._editors.original, this._editors.modified, mappings, this._origViewZonesToIgnore, this._modViewZonesToIgnore, true);
		});
		function createFakeLinesDiv() {
			const r = document.createElement("div");
			r.className = "diagonal-fill";
			return r;
		}
		const alignmentViewZonesDisposables = this._register(new DisposableStore());
		this.viewZones = derived(this, (reader) => {
			alignmentViewZonesDisposables.clear();
			const alignmentsVal = alignments.read(reader) || [];
			const origViewZones = [];
			const modViewZones = [];
			const modifiedTopPaddingVal = this._modifiedTopPadding.read(reader);
			if (modifiedTopPaddingVal > 0) modViewZones.push({
				afterLineNumber: 0,
				domNode: document.createElement("div"),
				heightInPx: modifiedTopPaddingVal,
				showInHiddenAreas: true,
				suppressMouseDown: true
			});
			const originalTopPaddingVal = this._originalTopPadding.read(reader);
			if (originalTopPaddingVal > 0) origViewZones.push({
				afterLineNumber: 0,
				domNode: document.createElement("div"),
				heightInPx: originalTopPaddingVal,
				showInHiddenAreas: true,
				suppressMouseDown: true
			});
			const renderSideBySide = this._options.renderSideBySide.read(reader);
			const deletedCodeLineBreaksComputer = !renderSideBySide ? this._editors.modified._getViewModel()?.createLineBreaksComputer({
				getLineContent: (lineNumber) => {
					return this._editors.original.getModel().getLineContent(lineNumber);
				},
				getLineInjectedText: (lineNumber) => {
					return null;
				}
			}) : void 0;
			if (deletedCodeLineBreaksComputer) {
				const originalModel = this._editors.original.getModel();
				for (const a of alignmentsVal) if (a.diff) for (let i = a.originalRange.startLineNumber; i < a.originalRange.endLineNumberExclusive; i++) {
					if (i > originalModel.getLineCount()) return {
						orig: origViewZones,
						mod: modViewZones
					};
					deletedCodeLineBreaksComputer?.addRequest(i, null);
				}
			}
			const lineBreakData = deletedCodeLineBreaksComputer?.finalize() ?? [];
			let lineBreakDataIdx = 0;
			const modLineHeight = this._editors.modified.getOption(75);
			const syncedMovedText = this._diffModel.read(reader)?.movedTextToCompare.read(reader);
			const mightContainNonBasicASCII = this._editors.original.getModel()?.mightContainNonBasicASCII() ?? false;
			const mightContainRTL = this._editors.original.getModel()?.mightContainRTL() ?? false;
			const renderOptions = RenderOptions.fromEditor(this._editors.modified);
			for (const a of alignmentsVal) if (a.diff && !renderSideBySide && (!this._options.useTrueInlineDiffRendering.read(reader) || !allowsTrueInlineDiffRendering(a.diff))) {
				if (!a.originalRange.isEmpty) {
					originalModelTokenizationCompleted.read(reader);
					const deletedCodeDomNode = document.createElement("div");
					deletedCodeDomNode.classList.add("view-lines", "line-delete", "line-delete-selectable", "monaco-mouse-cursor-text");
					const originalModel = this._editors.original.getModel();
					if (a.originalRange.endLineNumberExclusive - 1 > originalModel.getLineCount()) return {
						orig: origViewZones,
						mod: modViewZones
					};
					const source = new LineSource(a.originalRange.mapToLineArray((l) => originalModel.tokenization.getLineTokens(l)), a.originalRange.mapToLineArray((_) => lineBreakData[lineBreakDataIdx++]), mightContainNonBasicASCII, mightContainRTL);
					const decorations = [];
					for (const i of a.diff.innerChanges || []) decorations.push(new InlineDecoration(i.originalRange.delta(-(a.diff.original.startLineNumber - 1)), diffDeleteDecoration.className, 0));
					const result = renderLines(source, renderOptions, decorations, deletedCodeDomNode);
					const marginDomNode = document.createElement("div");
					marginDomNode.className = "inline-deleted-margin-view-zone";
					applyFontInfo(marginDomNode, renderOptions.fontInfo);
					if (this._options.renderIndicators.read(reader)) for (let i = 0; i < result.heightInLines; i++) {
						const marginElement = document.createElement("div");
						marginElement.className = `delete-sign ${ThemeIcon.asClassName(diffRemoveIcon)}`;
						marginElement.setAttribute("style", `position:absolute;top:${i * modLineHeight}px;width:${renderOptions.lineDecorationsWidth}px;height:${modLineHeight}px;right:0;`);
						marginDomNode.appendChild(marginElement);
					}
					let zoneId = void 0;
					alignmentViewZonesDisposables.add(new InlineDiffDeletedCodeMargin(() => assertReturnsDefined(zoneId), marginDomNode, deletedCodeDomNode, this._editors.modified, a.diff, this._diffEditorWidget, result, this._editors.original.getModel(), this._contextMenuService, this._clipboardService));
					for (let i = 0; i < result.viewLineCounts.length; i++) {
						const count = result.viewLineCounts[i];
						if (count > 1) origViewZones.push({
							afterLineNumber: a.originalRange.startLineNumber + i,
							domNode: createFakeLinesDiv(),
							heightInPx: (count - 1) * modLineHeight,
							showInHiddenAreas: true,
							suppressMouseDown: true
						});
					}
					modViewZones.push({
						afterLineNumber: a.modifiedRange.startLineNumber - 1,
						domNode: deletedCodeDomNode,
						heightInPx: result.heightInLines * modLineHeight,
						minWidthInPx: result.minWidthInPx,
						marginDomNode,
						setZoneId(id) {
							zoneId = id;
						},
						showInHiddenAreas: true,
						suppressMouseDown: false
					});
				}
				const marginDomNode = document.createElement("div");
				marginDomNode.className = "gutter-delete";
				origViewZones.push({
					afterLineNumber: a.originalRange.endLineNumberExclusive - 1,
					domNode: createFakeLinesDiv(),
					heightInPx: a.modifiedHeightInPx,
					marginDomNode,
					showInHiddenAreas: true,
					suppressMouseDown: true
				});
			} else {
				const delta = a.modifiedHeightInPx - a.originalHeightInPx;
				if (delta > 0) {
					if (syncedMovedText?.lineRangeMapping.original.delta(-1).deltaLength(2).contains(a.originalRange.endLineNumberExclusive - 1)) continue;
					origViewZones.push({
						afterLineNumber: a.originalRange.endLineNumberExclusive - 1,
						domNode: createFakeLinesDiv(),
						heightInPx: delta,
						showInHiddenAreas: true,
						suppressMouseDown: true
					});
				} else {
					if (syncedMovedText?.lineRangeMapping.modified.delta(-1).deltaLength(2).contains(a.modifiedRange.endLineNumberExclusive - 1)) continue;
					function createViewZoneMarginArrow() {
						const arrow = document.createElement("div");
						arrow.className = "arrow-revert-change " + ThemeIcon.asClassName(Codicon.arrowRight);
						reader.store.add(addDisposableListener(arrow, "mousedown", (e) => e.stopPropagation()));
						reader.store.add(addDisposableListener(arrow, "click", (e) => {
							e.stopPropagation();
							_diffEditorWidget.revert(a.diff);
						}));
						return $$10("div", {}, arrow);
					}
					let marginDomNode = void 0;
					if (a.diff && a.diff.modified.isEmpty && this._options.shouldRenderOldRevertArrows.read(reader)) marginDomNode = createViewZoneMarginArrow();
					modViewZones.push({
						afterLineNumber: a.modifiedRange.endLineNumberExclusive - 1,
						domNode: createFakeLinesDiv(),
						heightInPx: -delta,
						marginDomNode,
						showInHiddenAreas: true,
						suppressMouseDown: true
					});
				}
			}
			for (const a of alignmentsSyncedMovedText.read(reader) ?? []) {
				if (!syncedMovedText?.lineRangeMapping.original.intersect(a.originalRange) || !syncedMovedText?.lineRangeMapping.modified.intersect(a.modifiedRange)) continue;
				const delta = a.modifiedHeightInPx - a.originalHeightInPx;
				if (delta > 0) origViewZones.push({
					afterLineNumber: a.originalRange.endLineNumberExclusive - 1,
					domNode: createFakeLinesDiv(),
					heightInPx: delta,
					showInHiddenAreas: true,
					suppressMouseDown: true
				});
				else modViewZones.push({
					afterLineNumber: a.modifiedRange.endLineNumberExclusive - 1,
					domNode: createFakeLinesDiv(),
					heightInPx: -delta,
					showInHiddenAreas: true,
					suppressMouseDown: true
				});
			}
			return {
				orig: origViewZones,
				mod: modViewZones
			};
		});
		let ignoreChange = false;
		this._register(this._editors.original.onDidScrollChange((e) => {
			if (e.scrollLeftChanged && !ignoreChange) {
				ignoreChange = true;
				this._editors.modified.setScrollLeft(e.scrollLeft);
				ignoreChange = false;
			}
		}));
		this._register(this._editors.modified.onDidScrollChange((e) => {
			if (e.scrollLeftChanged && !ignoreChange) {
				ignoreChange = true;
				this._editors.original.setScrollLeft(e.scrollLeft);
				ignoreChange = false;
			}
		}));
		this._originalScrollTop = observableFromEvent(this._editors.original.onDidScrollChange, () => this._editors.original.getScrollTop());
		this._modifiedScrollTop = observableFromEvent(this._editors.modified.onDidScrollChange, () => this._editors.modified.getScrollTop());
		this._register(autorun((reader) => {
			/** @description update scroll modified */
			const newScrollTopModified = this._originalScrollTop.read(reader) - (this._originalScrollOffsetAnimated.read(void 0) - this._modifiedScrollOffsetAnimated.read(reader)) - (this._originalTopPadding.read(void 0) - this._modifiedTopPadding.read(reader));
			if (newScrollTopModified !== this._editors.modified.getScrollTop()) this._editors.modified.setScrollTop(newScrollTopModified, 1);
		}));
		this._register(autorun((reader) => {
			/** @description update scroll original */
			const newScrollTopOriginal = this._modifiedScrollTop.read(reader) - (this._modifiedScrollOffsetAnimated.read(void 0) - this._originalScrollOffsetAnimated.read(reader)) - (this._modifiedTopPadding.read(void 0) - this._originalTopPadding.read(reader));
			if (newScrollTopOriginal !== this._editors.original.getScrollTop()) this._editors.original.setScrollTop(newScrollTopOriginal, 1);
		}));
		this._register(autorun((reader) => {
			/** @description update editor top offsets */
			const m = this._diffModel.read(reader)?.movedTextToCompare.read(reader);
			let deltaOrigToMod = 0;
			if (m) {
				const trueTopOriginal = this._editors.original.getTopForLineNumber(m.lineRangeMapping.original.startLineNumber, true) - this._originalTopPadding.read(void 0);
				deltaOrigToMod = this._editors.modified.getTopForLineNumber(m.lineRangeMapping.modified.startLineNumber, true) - this._modifiedTopPadding.read(void 0) - trueTopOriginal;
			}
			if (deltaOrigToMod > 0) {
				this._modifiedTopPadding.set(0, void 0);
				this._originalTopPadding.set(deltaOrigToMod, void 0);
			} else if (deltaOrigToMod < 0) {
				this._modifiedTopPadding.set(-deltaOrigToMod, void 0);
				this._originalTopPadding.set(0, void 0);
			} else setTimeout(() => {
				this._modifiedTopPadding.set(0, void 0);
				this._originalTopPadding.set(0, void 0);
			}, 400);
			if (this._editors.modified.hasTextFocus()) this._originalScrollOffset.set(this._modifiedScrollOffset.read(void 0) - deltaOrigToMod, void 0, true);
			else this._modifiedScrollOffset.set(this._originalScrollOffset.read(void 0) + deltaOrigToMod, void 0, true);
		}));
	}
};
DiffEditorViewZones = __decorate$12([__param$12(8, IClipboardService), __param$12(9, IContextMenuService)], DiffEditorViewZones);
function computeRangeAlignment(originalEditor, modifiedEditor, diffs, originalEditorAlignmentViewZones, modifiedEditorAlignmentViewZones, innerHunkAlignment) {
	const originalLineHeightOverrides = new ArrayQueue(getAdditionalLineHeights(originalEditor, originalEditorAlignmentViewZones));
	const modifiedLineHeightOverrides = new ArrayQueue(getAdditionalLineHeights(modifiedEditor, modifiedEditorAlignmentViewZones));
	const origLineHeight = originalEditor.getOption(75);
	const modLineHeight = modifiedEditor.getOption(75);
	const result = [];
	let lastOriginalLineNumber = 0;
	let lastModifiedLineNumber = 0;
	function handleAlignmentsOutsideOfDiffs(untilOriginalLineNumberExclusive, untilModifiedLineNumberExclusive) {
		while (true) {
			let origNext = originalLineHeightOverrides.peek();
			let modNext = modifiedLineHeightOverrides.peek();
			if (origNext && origNext.lineNumber >= untilOriginalLineNumberExclusive) origNext = void 0;
			if (modNext && modNext.lineNumber >= untilModifiedLineNumberExclusive) modNext = void 0;
			if (!origNext && !modNext) break;
			const distOrig = origNext ? origNext.lineNumber - lastOriginalLineNumber : Number.MAX_VALUE;
			const distNext = modNext ? modNext.lineNumber - lastModifiedLineNumber : Number.MAX_VALUE;
			if (distOrig < distNext) {
				originalLineHeightOverrides.dequeue();
				modNext = {
					lineNumber: origNext.lineNumber - lastOriginalLineNumber + lastModifiedLineNumber,
					heightInPx: 0
				};
			} else if (distOrig > distNext) {
				modifiedLineHeightOverrides.dequeue();
				origNext = {
					lineNumber: modNext.lineNumber - lastModifiedLineNumber + lastOriginalLineNumber,
					heightInPx: 0
				};
			} else {
				originalLineHeightOverrides.dequeue();
				modifiedLineHeightOverrides.dequeue();
			}
			result.push({
				originalRange: LineRange.ofLength(origNext.lineNumber, 1),
				modifiedRange: LineRange.ofLength(modNext.lineNumber, 1),
				originalHeightInPx: origLineHeight + origNext.heightInPx,
				modifiedHeightInPx: modLineHeight + modNext.heightInPx,
				diff: void 0
			});
		}
	}
	for (const m of diffs) {
		const c = m.lineRangeMapping;
		handleAlignmentsOutsideOfDiffs(c.original.startLineNumber, c.modified.startLineNumber);
		let first = true;
		let lastModLineNumber = c.modified.startLineNumber;
		let lastOrigLineNumber = c.original.startLineNumber;
		function emitAlignment(origLineNumberExclusive, modLineNumberExclusive, forceAlignment = false) {
			if (origLineNumberExclusive < lastOrigLineNumber || modLineNumberExclusive < lastModLineNumber) return;
			if (first) first = false;
			else if (!forceAlignment && (origLineNumberExclusive === lastOrigLineNumber || modLineNumberExclusive === lastModLineNumber)) return;
			const originalRange = new LineRange(lastOrigLineNumber, origLineNumberExclusive);
			const modifiedRange = new LineRange(lastModLineNumber, modLineNumberExclusive);
			if (originalRange.isEmpty && modifiedRange.isEmpty) return;
			const originalAdditionalHeight = originalLineHeightOverrides.takeWhile((v) => v.lineNumber < origLineNumberExclusive)?.reduce((p, c) => p + c.heightInPx, 0) ?? 0;
			const modifiedAdditionalHeight = modifiedLineHeightOverrides.takeWhile((v) => v.lineNumber < modLineNumberExclusive)?.reduce((p, c) => p + c.heightInPx, 0) ?? 0;
			result.push({
				originalRange,
				modifiedRange,
				originalHeightInPx: originalRange.length * origLineHeight + originalAdditionalHeight,
				modifiedHeightInPx: modifiedRange.length * modLineHeight + modifiedAdditionalHeight,
				diff: m.lineRangeMapping
			});
			lastOrigLineNumber = origLineNumberExclusive;
			lastModLineNumber = modLineNumberExclusive;
		}
		if (innerHunkAlignment) for (const i of c.innerChanges || []) {
			if (i.originalRange.startColumn > 1 && i.modifiedRange.startColumn > 1) emitAlignment(i.originalRange.startLineNumber, i.modifiedRange.startLineNumber);
			const originalModel = originalEditor.getModel();
			const maxColumn = i.originalRange.endLineNumber <= originalModel.getLineCount() ? originalModel.getLineMaxColumn(i.originalRange.endLineNumber) : Number.MAX_SAFE_INTEGER;
			if (i.originalRange.endColumn < maxColumn) emitAlignment(i.originalRange.endLineNumber, i.modifiedRange.endLineNumber);
		}
		emitAlignment(c.original.endLineNumberExclusive, c.modified.endLineNumberExclusive, true);
		lastOriginalLineNumber = c.original.endLineNumberExclusive;
		lastModifiedLineNumber = c.modified.endLineNumberExclusive;
	}
	handleAlignmentsOutsideOfDiffs(Number.MAX_VALUE, Number.MAX_VALUE);
	return result;
}
function getAdditionalLineHeights(editor, viewZonesToIgnore) {
	const viewZoneHeights = [];
	const wrappingZoneHeights = [];
	const hasWrapping = editor.getOption(167).wrappingColumn !== -1;
	const coordinatesConverter = editor._getViewModel().coordinatesConverter;
	const editorLineHeight = editor.getOption(75);
	if (hasWrapping) for (let i = 1; i <= editor.getModel().getLineCount(); i++) {
		const lineCount = coordinatesConverter.getModelLineViewLineCount(i);
		if (lineCount > 1) wrappingZoneHeights.push({
			lineNumber: i,
			heightInPx: editorLineHeight * (lineCount - 1)
		});
	}
	for (const w of editor.getWhitespaces()) {
		if (viewZonesToIgnore.has(w.id)) continue;
		const modelLineNumber = w.afterLineNumber === 0 ? 0 : coordinatesConverter.convertViewPositionToModelPosition(new Position$1(w.afterLineNumber, 1)).lineNumber;
		viewZoneHeights.push({
			lineNumber: modelLineNumber,
			heightInPx: w.height
		});
	}
	return joinCombine(viewZoneHeights, wrappingZoneHeights, (v) => v.lineNumber, (v1, v2) => ({
		lineNumber: v1.lineNumber,
		heightInPx: v1.heightInPx + v2.heightInPx
	}));
}
function allowsTrueInlineDiffRendering(mapping) {
	if (!mapping.innerChanges) return false;
	return mapping.innerChanges.every((c) => rangeIsSingleLine(c.modifiedRange) && rangeIsSingleLine(c.originalRange) || c.originalRange.equalsRange(new Range$2(1, 1, 1, 1)));
}
function rangeIsSingleLine(range) {
	return range.startLineNumber === range.endLineNumber;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/diffEditor/features/movedBlocksLinesFeature.js
var MovedBlocksLinesFeature = class MovedBlocksLinesFeature extends Disposable {
	static {
		this.movedCodeBlockPadding = 4;
	}
	constructor(_rootElement, _diffModel, _originalEditorLayoutInfo, _modifiedEditorLayoutInfo, _editors) {
		super();
		this._rootElement = _rootElement;
		this._diffModel = _diffModel;
		this._originalEditorLayoutInfo = _originalEditorLayoutInfo;
		this._modifiedEditorLayoutInfo = _modifiedEditorLayoutInfo;
		this._editors = _editors;
		this._originalScrollTop = observableFromEvent(this, this._editors.original.onDidScrollChange, () => this._editors.original.getScrollTop());
		this._modifiedScrollTop = observableFromEvent(this, this._editors.modified.onDidScrollChange, () => this._editors.modified.getScrollTop());
		this._viewZonesChanged = observableSignalFromEvent("onDidChangeViewZones", this._editors.modified.onDidChangeViewZones);
		this.width = observableValue(this, 0);
		this._modifiedViewZonesChangedSignal = observableSignalFromEvent("modified.onDidChangeViewZones", this._editors.modified.onDidChangeViewZones);
		this._originalViewZonesChangedSignal = observableSignalFromEvent("original.onDidChangeViewZones", this._editors.original.onDidChangeViewZones);
		this._state = derived(this, (reader) => {
			/** @description state */
			this._element.replaceChildren();
			const model = this._diffModel.read(reader);
			const moves = model?.diff.read(reader)?.movedTexts;
			if (!moves || moves.length === 0) {
				this.width.set(0, void 0);
				return;
			}
			this._viewZonesChanged.read(reader);
			const infoOrig = this._originalEditorLayoutInfo.read(reader);
			const infoMod = this._modifiedEditorLayoutInfo.read(reader);
			if (!infoOrig || !infoMod) {
				this.width.set(0, void 0);
				return;
			}
			this._modifiedViewZonesChangedSignal.read(reader);
			this._originalViewZonesChangedSignal.read(reader);
			const lines = moves.map((move) => {
				function computeLineStart(range, editor) {
					return (editor.getTopForLineNumber(range.startLineNumber, true) + editor.getTopForLineNumber(range.endLineNumberExclusive, true)) / 2;
				}
				const start = computeLineStart(move.lineRangeMapping.original, this._editors.original);
				const startOffset = this._originalScrollTop.read(reader);
				const end = computeLineStart(move.lineRangeMapping.modified, this._editors.modified);
				const endOffset = this._modifiedScrollTop.read(reader);
				const from = start - startOffset;
				const to = end - endOffset;
				return {
					range: new OffsetRange(Math.min(start, end), Math.max(start, end)),
					from,
					to,
					fromWithoutScroll: start,
					toWithoutScroll: end,
					move
				};
			});
			lines.sort(tieBreakComparators(compareBy((l) => l.fromWithoutScroll > l.toWithoutScroll, booleanComparator), compareBy((l) => l.fromWithoutScroll > l.toWithoutScroll ? l.fromWithoutScroll : -l.toWithoutScroll, numberComparator)));
			const layout = LinesLayout.compute(lines.map((l) => l.range));
			const padding = 10;
			const lineAreaLeft = infoOrig.verticalScrollbarWidth;
			const lineAreaWidth = (layout.getTrackCount() - 1) * 10 + 20;
			const width = lineAreaLeft + lineAreaWidth + (infoMod.contentLeft - MovedBlocksLinesFeature.movedCodeBlockPadding);
			let idx = 0;
			for (const line of lines) {
				const track = layout.getTrack(idx);
				const verticalY = lineAreaLeft + padding + track * 10;
				const arrowHeight = 15;
				const arrowWidth = 15;
				const right = width;
				const rectWidth = infoMod.glyphMarginWidth + infoMod.lineNumbersWidth;
				const rectHeight = 18;
				const rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
				rect.classList.add("arrow-rectangle");
				rect.setAttribute("x", `${right - rectWidth}`);
				rect.setAttribute("y", `${line.to - rectHeight / 2}`);
				rect.setAttribute("width", `${rectWidth}`);
				rect.setAttribute("height", `${rectHeight}`);
				this._element.appendChild(rect);
				const g = document.createElementNS("http://www.w3.org/2000/svg", "g");
				const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
				path.setAttribute("d", `M 0 ${line.from} L ${verticalY} ${line.from} L ${verticalY} ${line.to} L ${right - arrowWidth} ${line.to}`);
				path.setAttribute("fill", "none");
				g.appendChild(path);
				const arrowRight = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
				arrowRight.classList.add("arrow");
				reader.store.add(autorun((reader) => {
					path.classList.toggle("currentMove", line.move === model.activeMovedText.read(reader));
					arrowRight.classList.toggle("currentMove", line.move === model.activeMovedText.read(reader));
				}));
				arrowRight.setAttribute("points", `${right - arrowWidth},${line.to - arrowHeight / 2} ${right},${line.to} ${right - arrowWidth},${line.to + arrowHeight / 2}`);
				g.appendChild(arrowRight);
				this._element.appendChild(g);
				idx++;
			}
			this.width.set(lineAreaWidth, void 0);
		});
		this._element = document.createElementNS("http://www.w3.org/2000/svg", "svg");
		this._element.setAttribute("class", "moved-blocks-lines");
		this._rootElement.appendChild(this._element);
		this._register(toDisposable(() => this._element.remove()));
		this._register(autorun((reader) => {
			/** @description update moved blocks lines positioning */
			const info = this._originalEditorLayoutInfo.read(reader);
			const info2 = this._modifiedEditorLayoutInfo.read(reader);
			if (!info || !info2) return;
			this._element.style.left = `${info.width - info.verticalScrollbarWidth}px`;
			this._element.style.height = `${info.height}px`;
			this._element.style.width = `${info.verticalScrollbarWidth + info.contentLeft - MovedBlocksLinesFeature.movedCodeBlockPadding + this.width.read(reader)}px`;
		}));
		this._register(recomputeInitiallyAndOnChange(this._state));
		const movedBlockViewZones = derived((reader) => {
			const d = this._diffModel.read(reader)?.diff.read(reader);
			if (!d) return [];
			return d.movedTexts.map((move) => ({
				move,
				original: new PlaceholderViewZone(constObservable(move.lineRangeMapping.original.startLineNumber - 1), 18),
				modified: new PlaceholderViewZone(constObservable(move.lineRangeMapping.modified.startLineNumber - 1), 18)
			}));
		});
		this._register(applyViewZones(this._editors.original, movedBlockViewZones.map((zones) => zones.map((z) => z.original))));
		this._register(applyViewZones(this._editors.modified, movedBlockViewZones.map((zones) => zones.map((z) => z.modified))));
		this._register(autorunWithStore((reader, store) => {
			const blocks = movedBlockViewZones.read(reader);
			for (const b of blocks) {
				store.add(new MovedBlockOverlayWidget(this._editors.original, b.original, b.move, "original", this._diffModel.get()));
				store.add(new MovedBlockOverlayWidget(this._editors.modified, b.modified, b.move, "modified", this._diffModel.get()));
			}
		}));
		const originalHasFocus = observableSignalFromEvent("original.onDidFocusEditorWidget", (e) => this._editors.original.onDidFocusEditorWidget(() => setTimeout(() => e(void 0), 0)));
		const modifiedHasFocus = observableSignalFromEvent("modified.onDidFocusEditorWidget", (e) => this._editors.modified.onDidFocusEditorWidget(() => setTimeout(() => e(void 0), 0)));
		let lastChangedEditor = "modified";
		this._register(autorunHandleChanges({ changeTracker: {
			createChangeSummary: () => void 0,
			handleChange: (ctx, summary) => {
				if (ctx.didChange(originalHasFocus)) lastChangedEditor = "original";
				if (ctx.didChange(modifiedHasFocus)) lastChangedEditor = "modified";
				return true;
			}
		} }, (reader) => {
			/** @description MovedBlocksLines.setActiveMovedTextFromCursor */
			originalHasFocus.read(reader);
			modifiedHasFocus.read(reader);
			const m = this._diffModel.read(reader);
			if (!m) return;
			const diff = m.diff.read(reader);
			let movedText = void 0;
			if (diff && lastChangedEditor === "original") {
				const originalPos = this._editors.originalCursor.read(reader);
				if (originalPos) movedText = diff.movedTexts.find((m) => m.lineRangeMapping.original.contains(originalPos.lineNumber));
			}
			if (diff && lastChangedEditor === "modified") {
				const modifiedPos = this._editors.modifiedCursor.read(reader);
				if (modifiedPos) movedText = diff.movedTexts.find((m) => m.lineRangeMapping.modified.contains(modifiedPos.lineNumber));
			}
			if (movedText !== m.movedTextToCompare.read(void 0)) m.movedTextToCompare.set(void 0, void 0);
			m.setActiveMovedText(movedText);
		}));
	}
};
var LinesLayout = class LinesLayout {
	static compute(lines) {
		const setsPerTrack = [];
		const trackPerLineIdx = [];
		for (const line of lines) {
			let trackIdx = setsPerTrack.findIndex((set) => !set.intersectsStrict(line));
			if (trackIdx === -1) {
				if (setsPerTrack.length >= 6) trackIdx = findMaxIdx(setsPerTrack, compareBy((set) => set.intersectWithRangeLength(line), numberComparator));
				else {
					trackIdx = setsPerTrack.length;
					setsPerTrack.push(new OffsetRangeSet());
				}
			}
			setsPerTrack[trackIdx].addRange(line);
			trackPerLineIdx.push(trackIdx);
		}
		return new LinesLayout(setsPerTrack.length, trackPerLineIdx);
	}
	constructor(_trackCount, trackPerLineIdx) {
		this._trackCount = _trackCount;
		this.trackPerLineIdx = trackPerLineIdx;
	}
	getTrack(lineIdx) {
		return this.trackPerLineIdx[lineIdx];
	}
	getTrackCount() {
		return this._trackCount;
	}
};
var MovedBlockOverlayWidget = class extends ViewZoneOverlayWidget {
	constructor(_editor, _viewZone, _move, _kind, _diffModel) {
		const root = h("div.diff-hidden-lines-widget");
		super(_editor, _viewZone, root.root);
		this._editor = _editor;
		this._move = _move;
		this._kind = _kind;
		this._diffModel = _diffModel;
		this._nodes = h("div.diff-moved-code-block", { style: { marginRight: "4px" } }, [h("div.text-content@textContent"), h("div.action-bar@actionBar")]);
		root.root.appendChild(this._nodes.root);
		const editorLayout = observableFromEvent(this._editor.onDidLayoutChange, () => this._editor.getLayoutInfo());
		this._register(applyStyle(this._nodes.root, { paddingRight: editorLayout.map((l) => l.verticalScrollbarWidth) }));
		let text;
		if (_move.changes.length > 0) text = this._kind === "original" ? localize(150, "Code moved with changes to line {0}-{1}", this._move.lineRangeMapping.modified.startLineNumber, this._move.lineRangeMapping.modified.endLineNumberExclusive - 1) : localize(151, "Code moved with changes from line {0}-{1}", this._move.lineRangeMapping.original.startLineNumber, this._move.lineRangeMapping.original.endLineNumberExclusive - 1);
		else text = this._kind === "original" ? localize(152, "Code moved to line {0}-{1}", this._move.lineRangeMapping.modified.startLineNumber, this._move.lineRangeMapping.modified.endLineNumberExclusive - 1) : localize(153, "Code moved from line {0}-{1}", this._move.lineRangeMapping.original.startLineNumber, this._move.lineRangeMapping.original.endLineNumberExclusive - 1);
		const actionBar = this._register(new ActionBar(this._nodes.actionBar, { highlightToggledItems: true }));
		const caption = this._register(new Action("", text, "", false));
		actionBar.push(caption, {
			icon: false,
			label: true
		});
		const actionCompare = this._register(new Action("", "Compare", ThemeIcon.asClassName(Codicon.compareChanges), true, () => {
			this._editor.focus();
			this._diffModel.movedTextToCompare.set(this._diffModel.movedTextToCompare.get() === _move ? void 0 : this._move, void 0);
		}));
		this._register(autorun((reader) => {
			const isActive = this._diffModel.movedTextToCompare.read(reader) === _move;
			actionCompare.checked = isActive;
		}));
		actionBar.push(actionCompare, {
			icon: false,
			label: true
		});
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/diffEditor/components/diffEditorDecorations.js
var DiffEditorDecorations = class extends Disposable {
	constructor(_editors, _diffModel, _options, widget) {
		super();
		this._editors = _editors;
		this._diffModel = _diffModel;
		this._options = _options;
		this._decorations = derived(this, (reader) => {
			const diffModel = this._diffModel.read(reader);
			const diff = diffModel?.diff.read(reader);
			if (!diff) return null;
			const movedTextToCompare = this._diffModel.read(reader).movedTextToCompare.read(reader);
			const renderIndicators = this._options.renderIndicators.read(reader);
			const showEmptyDecorations = this._options.showEmptyDecorations.read(reader);
			const originalDecorations = [];
			const modifiedDecorations = [];
			if (!movedTextToCompare) for (const m of diff.mappings) {
				if (!m.lineRangeMapping.original.isEmpty) originalDecorations.push({
					range: m.lineRangeMapping.original.toInclusiveRange(),
					options: renderIndicators ? diffLineDeleteDecorationBackgroundWithIndicator : diffLineDeleteDecorationBackground
				});
				if (!m.lineRangeMapping.modified.isEmpty) modifiedDecorations.push({
					range: m.lineRangeMapping.modified.toInclusiveRange(),
					options: renderIndicators ? diffLineAddDecorationBackgroundWithIndicator : diffLineAddDecorationBackground
				});
				if (m.lineRangeMapping.modified.isEmpty || m.lineRangeMapping.original.isEmpty) {
					if (!m.lineRangeMapping.original.isEmpty) originalDecorations.push({
						range: m.lineRangeMapping.original.toInclusiveRange(),
						options: diffWholeLineDeleteDecoration
					});
					if (!m.lineRangeMapping.modified.isEmpty) modifiedDecorations.push({
						range: m.lineRangeMapping.modified.toInclusiveRange(),
						options: diffWholeLineAddDecoration
					});
				} else {
					const useInlineDiff = this._options.useTrueInlineDiffRendering.read(reader) && allowsTrueInlineDiffRendering(m.lineRangeMapping);
					for (const i of m.lineRangeMapping.innerChanges || []) {
						if (m.lineRangeMapping.original.contains(i.originalRange.startLineNumber)) originalDecorations.push({
							range: i.originalRange,
							options: i.originalRange.isEmpty() && showEmptyDecorations ? diffDeleteDecorationEmpty : diffDeleteDecoration
						});
						if (m.lineRangeMapping.modified.contains(i.modifiedRange.startLineNumber)) modifiedDecorations.push({
							range: i.modifiedRange,
							options: i.modifiedRange.isEmpty() && showEmptyDecorations && !useInlineDiff ? diffAddDecorationEmpty : diffAddDecoration
						});
						if (useInlineDiff) {
							const deletedText = diffModel.model.original.getValueInRange(i.originalRange);
							modifiedDecorations.push({
								range: i.modifiedRange,
								options: {
									description: "deleted-text",
									before: {
										content: deletedText,
										inlineClassName: "inline-deleted-text"
									},
									zIndex: 1e5,
									showIfCollapsed: true
								}
							});
						}
					}
				}
			}
			if (movedTextToCompare) for (const m of movedTextToCompare.changes) {
				const fullRangeOriginal = m.original.toInclusiveRange();
				if (fullRangeOriginal) originalDecorations.push({
					range: fullRangeOriginal,
					options: renderIndicators ? diffLineDeleteDecorationBackgroundWithIndicator : diffLineDeleteDecorationBackground
				});
				const fullRangeModified = m.modified.toInclusiveRange();
				if (fullRangeModified) modifiedDecorations.push({
					range: fullRangeModified,
					options: renderIndicators ? diffLineAddDecorationBackgroundWithIndicator : diffLineAddDecorationBackground
				});
				for (const i of m.innerChanges || []) {
					originalDecorations.push({
						range: i.originalRange,
						options: diffDeleteDecoration
					});
					modifiedDecorations.push({
						range: i.modifiedRange,
						options: diffAddDecoration
					});
				}
			}
			const activeMovedText = this._diffModel.read(reader).activeMovedText.read(reader);
			for (const m of diff.movedTexts) {
				originalDecorations.push({
					range: m.lineRangeMapping.original.toInclusiveRange(),
					options: {
						description: "moved",
						blockClassName: "movedOriginal" + (m === activeMovedText ? " currentMove" : ""),
						blockPadding: [
							MovedBlocksLinesFeature.movedCodeBlockPadding,
							0,
							MovedBlocksLinesFeature.movedCodeBlockPadding,
							MovedBlocksLinesFeature.movedCodeBlockPadding
						]
					}
				});
				modifiedDecorations.push({
					range: m.lineRangeMapping.modified.toInclusiveRange(),
					options: {
						description: "moved",
						blockClassName: "movedModified" + (m === activeMovedText ? " currentMove" : ""),
						blockPadding: [
							4,
							0,
							4,
							4
						]
					}
				});
			}
			return {
				originalDecorations,
				modifiedDecorations
			};
		});
		this._register(applyObservableDecorations(this._editors.original, this._decorations.map((d) => d?.originalDecorations || [])));
		this._register(applyObservableDecorations(this._editors.modified, this._decorations.map((d) => d?.modifiedDecorations || [])));
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/core/2d/point.js
var Point = class Point {
	static equals(a, b) {
		return a.x === b.x && a.y === b.y;
	}
	constructor(x, y) {
		this.x = x;
		this.y = y;
	}
	add(other) {
		return new Point(this.x + other.x, this.y + other.y);
	}
	deltaX(delta) {
		return new Point(this.x + delta, this.y);
	}
	deltaY(delta) {
		return new Point(this.x, this.y + delta);
	}
	toString() {
		return `(${this.x},${this.y})`;
	}
	subtract(other) {
		return new Point(this.x - other.x, this.y - other.y);
	}
	scale(factor) {
		return new Point(this.x * factor, this.y * factor);
	}
	mapComponents(map) {
		return new Point(map(this.x), map(this.y));
	}
	isZero() {
		return this.x === 0 && this.y === 0;
	}
	withThreshold(threshold) {
		return this.mapComponents((axisVal) => {
			if (axisVal > threshold) return axisVal - threshold;
			else if (axisVal < -threshold) return axisVal + threshold;
			return 0;
		});
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/observableCodeEditor.js
/**
* Returns a facade for the code editor that provides observables for various states/events.
*/
function observableCodeEditor(editor) {
	return ObservableCodeEditor.get(editor);
}
var ObservableCodeEditor = class ObservableCodeEditor extends Disposable {
	static {
		this._map = /* @__PURE__ */ new Map();
	}
	/**
	* Make sure that editor is not disposed yet!
	*/
	static get(editor) {
		let result = ObservableCodeEditor._map.get(editor);
		if (!result) {
			result = new ObservableCodeEditor(editor);
			ObservableCodeEditor._map.set(editor, result);
			const d = editor.onDidDispose(() => {
				const item = ObservableCodeEditor._map.get(editor);
				if (item) {
					ObservableCodeEditor._map.delete(editor);
					item.dispose();
					d.dispose();
				}
			});
		}
		return result;
	}
	_beginUpdate() {
		this._updateCounter++;
		if (this._updateCounter === 1) this._currentTransaction = new TransactionImpl(() => {
			/** @description Update editor state */
		});
	}
	_endUpdate() {
		this._updateCounter--;
		if (this._updateCounter === 0) {
			const t = this._currentTransaction;
			this._currentTransaction = void 0;
			t.finish();
		}
	}
	constructor(editor) {
		super();
		this.editor = editor;
		/**
		* Tracks whether getWidthOfLine returned 0, indicating the editor may be hidden.
		* When resize happens and this flag is set, we reset cached line widths.
		*/
		this._sawZeroLineWidth = false;
		/**
		* Fires when the editor container resizes.
		* This is lazily created only when someone subscribes to it.
		* Useful for detecting when a parent element's display changes from 'none' to 'block'.
		*/
		this._onDidContainerResize = observableFromEventOpts({
			owner: this,
			getTransaction: () => this._currentTransaction
		}, (e) => {
			const container = this.editor.getContainerDomNode();
			const resizeObserver = new ResizeObserver(() => {
				if (this._sawZeroLineWidth) {
					this._sawZeroLineWidth = false;
					this.editor.resetLineWidthCaches();
				}
				e(void 0);
			});
			resizeObserver.observe(container);
			return { dispose: () => resizeObserver.disconnect() };
		}, () => ({}));
		this._updateCounter = 0;
		this._currentTransaction = void 0;
		this._model = observableValue(this, this.editor.getModel());
		this.model = this._model;
		this.isReadonly = observableFromEventOpts({
			owner: this,
			getTransaction: () => this._currentTransaction
		}, this.editor.onDidChangeConfiguration, () => this.editor.getOption(104));
		this._versionId = observableValueOpts({
			owner: this,
			lazy: true
		}, this.editor.getModel()?.getVersionId() ?? null);
		this.versionId = this._versionId;
		this._selections = observableValueOpts({
			owner: this,
			equalsFn: equalsIfDefinedC(arrayEqualsC(Selection$1.selectionsEqual)),
			lazy: true
		}, this.editor.getSelections() ?? null);
		this.selections = this._selections;
		this.positions = derivedOpts({
			owner: this,
			equalsFn: equalsIfDefinedC(arrayEqualsC(Position$1.equals))
		}, (reader) => this.selections.read(reader)?.map((s) => s.getStartPosition()) ?? null);
		this.isFocused = observableFromEventOpts({
			owner: this,
			getTransaction: () => this._currentTransaction
		}, (e) => {
			const d1 = this.editor.onDidFocusEditorWidget(e);
			const d2 = this.editor.onDidBlurEditorWidget(e);
			return { dispose() {
				d1.dispose();
				d2.dispose();
			} };
		}, () => this.editor.hasWidgetFocus());
		this.isTextFocused = observableFromEventOpts({
			owner: this,
			getTransaction: () => this._currentTransaction
		}, (e) => {
			const d1 = this.editor.onDidFocusEditorText(e);
			const d2 = this.editor.onDidBlurEditorText(e);
			return { dispose() {
				d1.dispose();
				d2.dispose();
			} };
		}, () => this.editor.hasTextFocus());
		this.inComposition = observableFromEventOpts({
			owner: this,
			getTransaction: () => this._currentTransaction
		}, (e) => {
			const d1 = this.editor.onDidCompositionStart(() => {
				e(void 0);
			});
			const d2 = this.editor.onDidCompositionEnd(() => {
				e(void 0);
			});
			return { dispose() {
				d1.dispose();
				d2.dispose();
			} };
		}, () => this.editor.inComposition);
		this.value = derivedWithSetter(this, (reader) => {
			this.versionId.read(reader);
			return this.model.read(reader)?.getValue() ?? "";
		}, (value, tx) => {
			const model = this.model.get();
			if (model !== null) {
				if (value !== model.getValue()) model.setValue(value);
			}
		});
		this.valueIsEmpty = derived(this, (reader) => {
			this.versionId.read(reader);
			return this.editor.getModel()?.getValueLength() === 0;
		});
		this.cursorSelection = derivedOpts({
			owner: this,
			equalsFn: equalsIfDefinedC(Selection$1.selectionsEqual)
		}, (reader) => this.selections.read(reader)?.[0] ?? null);
		this.cursorPosition = derivedOpts({
			owner: this,
			equalsFn: Position$1.equals
		}, (reader) => this.selections.read(reader)?.[0]?.getPosition() ?? null);
		this.cursorLineNumber = derived(this, (reader) => this.cursorPosition.read(reader)?.lineNumber ?? null);
		this.onDidType = observableSignal(this);
		this.onDidPaste = observableSignal(this);
		this.scrollTop = observableFromEventOpts({
			owner: this,
			getTransaction: () => this._currentTransaction
		}, this.editor.onDidScrollChange, () => this.editor.getScrollTop());
		this.scrollLeft = observableFromEventOpts({
			owner: this,
			getTransaction: () => this._currentTransaction
		}, this.editor.onDidScrollChange, () => this.editor.getScrollLeft());
		this.layoutInfo = observableFromEventOpts({
			owner: this,
			getTransaction: () => this._currentTransaction
		}, this.editor.onDidLayoutChange, () => this.editor.getLayoutInfo());
		this.layoutInfoContentLeft = this.layoutInfo.map((l) => l.contentLeft);
		this.layoutInfoDecorationsLeft = this.layoutInfo.map((l) => l.decorationsLeft);
		this.layoutInfoWidth = this.layoutInfo.map((l) => l.width);
		this.layoutInfoHeight = this.layoutInfo.map((l) => l.height);
		this.layoutInfoMinimap = this.layoutInfo.map((l) => l.minimap);
		this.layoutInfoVerticalScrollbarWidth = this.layoutInfo.map((l) => l.verticalScrollbarWidth);
		this.contentWidth = observableFromEventOpts({
			owner: this,
			getTransaction: () => this._currentTransaction
		}, this.editor.onDidContentSizeChange, () => this.editor.getContentWidth());
		this.contentHeight = observableFromEventOpts({
			owner: this,
			getTransaction: () => this._currentTransaction
		}, this.editor.onDidContentSizeChange, () => this.editor.getContentHeight());
		this._onDidChangeViewZones = observableSignalFromEvent(this, this.editor.onDidChangeViewZones);
		this._onDidHiddenAreasChanged = observableSignalFromEvent(this, this.editor.onDidChangeHiddenAreas);
		this._onDidLineHeightChanged = observableSignalFromEvent(this, this.editor.onDidChangeLineHeight);
		this._widgetCounter = 0;
		this.openedPeekWidgets = observableValue(this, 0);
		this._register(this.editor.onBeginUpdate(() => this._beginUpdate()));
		this._register(this.editor.onEndUpdate(() => this._endUpdate()));
		this._register(this.editor.onDidChangeModel(() => {
			this._beginUpdate();
			try {
				this._model.set(this.editor.getModel(), this._currentTransaction);
				this._forceUpdate();
			} finally {
				this._endUpdate();
			}
		}));
		this._register(this.editor.onDidType((e) => {
			this._beginUpdate();
			try {
				this._forceUpdate();
				this.onDidType.trigger(this._currentTransaction, e);
			} finally {
				this._endUpdate();
			}
		}));
		this._register(this.editor.onDidPaste((e) => {
			this._beginUpdate();
			try {
				this._forceUpdate();
				this.onDidPaste.trigger(this._currentTransaction, e);
			} finally {
				this._endUpdate();
			}
		}));
		this._register(this.editor.onDidChangeModelContent((e) => {
			this._beginUpdate();
			try {
				this._versionId.set(this.editor.getModel()?.getVersionId() ?? null, this._currentTransaction, e);
				this._forceUpdate();
			} finally {
				this._endUpdate();
			}
		}));
		this._register(this.editor.onDidChangeCursorSelection((e) => {
			this._beginUpdate();
			try {
				this._selections.set(this.editor.getSelections(), this._currentTransaction, e);
				this._forceUpdate();
			} finally {
				this._endUpdate();
			}
		}));
		this.domNode = derived((reader) => {
			this.model.read(reader);
			return this.editor.getDomNode();
		});
	}
	/**
	* Batches the transactions started by observableFromEvent.
	*
	* If the callback causes the editor to fire an event that updates
	* an observable value backed by observableFromEvent (such as scrollTop etc.),
	* then all such updates will be part of the same transaction.
	*/
	transaction(cb) {
		this._beginUpdate();
		try {
			return cb(this._currentTransaction);
		} finally {
			this._endUpdate();
		}
	}
	forceUpdate(cb) {
		this._beginUpdate();
		try {
			this._forceUpdate();
			if (!cb) return;
			return cb(this._currentTransaction);
		} finally {
			this._endUpdate();
		}
	}
	_forceUpdate() {
		this._beginUpdate();
		try {
			this._model.set(this.editor.getModel(), this._currentTransaction);
			this._versionId.set(this.editor.getModel()?.getVersionId() ?? null, this._currentTransaction, void 0);
			this._selections.set(this.editor.getSelections(), this._currentTransaction, void 0);
		} finally {
			this._endUpdate();
		}
	}
	getOption(id, debugLocation = DebugLocation.ofCaller()) {
		return observableFromEvent(this, (cb) => this.editor.onDidChangeConfiguration((e) => {
			if (e.hasChanged(id)) cb(void 0);
		}), () => this.editor.getOption(id), debugLocation);
	}
	setDecorations(decorations) {
		const d = new DisposableStore();
		const decorationsCollection = this.editor.createDecorationsCollection();
		d.add(autorunOpts({
			owner: this,
			debugName: () => `Apply decorations from ${decorations.debugName}`
		}, (reader) => {
			const d = decorations.read(reader);
			decorationsCollection.set(d);
		}));
		d.add({ dispose: () => {
			decorationsCollection.clear();
		} });
		return d;
	}
	createOverlayWidget(widget) {
		const overlayWidgetId = "observableOverlayWidget" + this._widgetCounter++;
		const w = {
			getDomNode: () => widget.domNode,
			getPosition: () => widget.position.get(),
			getId: () => overlayWidgetId,
			allowEditorOverflow: widget.allowEditorOverflow,
			getMinContentWidthInPx: () => widget.minContentWidthInPx.get()
		};
		this.editor.addOverlayWidget(w);
		const d = autorun((reader) => {
			widget.position.read(reader);
			widget.minContentWidthInPx.read(reader);
			this.editor.layoutOverlayWidget(w);
		});
		return toDisposable(() => {
			d.dispose();
			this.editor.removeOverlayWidget(w);
		});
	}
	createContentWidget(widget) {
		const contentWidgetId = "observableContentWidget" + this._widgetCounter++;
		const w = {
			getDomNode: () => widget.domNode,
			getPosition: () => widget.position.get(),
			getId: () => contentWidgetId,
			allowEditorOverflow: widget.allowEditorOverflow
		};
		this.editor.addContentWidget(w);
		const d = autorun((reader) => {
			widget.position.read(reader);
			this.editor.layoutContentWidget(w);
		});
		return toDisposable(() => {
			d.dispose();
			this.editor.removeContentWidget(w);
		});
	}
	observeLineOffsetRange(lineRange, store) {
		const start = this.observePosition(lineRange.map((r) => new Position$1(r.startLineNumber, 1)), store);
		const end = this.observePosition(lineRange.map((r) => new Position$1(r.endLineNumberExclusive + 1, 1)), store);
		return derived((reader) => {
			start.read(reader);
			end.read(reader);
			const range = lineRange.read(reader);
			const lineCount = this.model.read(reader)?.getLineCount();
			const s = (typeof lineCount !== "undefined" && range.startLineNumber > lineCount ? this.editor.getBottomForLineNumber(lineCount) : this.editor.getTopForLineNumber(range.startLineNumber)) - this.scrollTop.read(reader);
			const e = range.isEmpty ? s : this.editor.getBottomForLineNumber(range.endLineNumberExclusive - 1) - this.scrollTop.read(reader);
			return new OffsetRange(s, e);
		});
	}
	/**
	* Uses an approximation if the exact position cannot be determined.
	*/
	getLeftOfPosition(position, reader) {
		this.layoutInfo.read(reader);
		this.value.read(reader);
		let offset = this.editor.getOffsetForColumn(position.lineNumber, position.column);
		if (offset === -1) {
			const typicalHalfwidthCharacterWidth = this.editor.getOption(59).typicalHalfwidthCharacterWidth;
			offset = position.column * typicalHalfwidthCharacterWidth;
		}
		return offset;
	}
	observePosition(position, store) {
		let pos = position.get();
		const result = observableValueOpts({
			owner: this,
			debugName: () => `topLeftOfPosition${pos?.toString()}`,
			equalsFn: equalsIfDefinedC(Point.equals)
		}, new Point(0, 0));
		const contentWidgetId = `observablePositionWidget` + this._widgetCounter++;
		const domNode = document.createElement("div");
		const w = {
			getDomNode: () => domNode,
			getPosition: () => {
				return pos ? {
					preference: [0],
					position: position.get()
				} : null;
			},
			getId: () => contentWidgetId,
			allowEditorOverflow: false,
			useDisplayNone: true,
			afterRender: (position, coordinate) => {
				const model = this._model.get();
				if (model && pos && pos.lineNumber > model.getLineCount()) result.set(new Point(0, this.editor.getBottomForLineNumber(model.getLineCount()) - this.scrollTop.get()), void 0);
				else result.set(coordinate ? new Point(coordinate.left, coordinate.top) : null, void 0);
			}
		};
		this.editor.addContentWidget(w);
		store.add(autorun((reader) => {
			pos = position.read(reader);
			this.editor.layoutContentWidget(w);
		}));
		store.add(toDisposable(() => {
			this.editor.removeContentWidget(w);
		}));
		return result;
	}
	isTargetHovered(predicate, store) {
		const isHovered = observableValue("isInjectedTextHovered", false);
		store.add(this.editor.onMouseMove((e) => {
			const val = predicate(e);
			isHovered.set(val, void 0);
		}));
		store.add(this.editor.onMouseLeave((E) => {
			isHovered.set(false, void 0);
		}));
		return isHovered;
	}
	observeLineHeightForPosition(position) {
		return derived((reader) => {
			const pos = position instanceof Position$1 ? position : position.read(reader);
			if (pos === null) return null;
			this.getOption(75).read(reader);
			return this.editor.getLineHeightForPosition(pos);
		});
	}
	observeLineHeightForLine(lineNumber) {
		if (typeof lineNumber === "number") return this.observeLineHeightForPosition(new Position$1(lineNumber, 1));
		return derived((reader) => {
			const line = lineNumber.read(reader);
			if (line === null) return null;
			return this.observeLineHeightForPosition(new Position$1(line, 1)).read(reader);
		});
	}
	observeLineHeightsForLineRange(lineNumber) {
		return derived((reader) => {
			const range = lineNumber instanceof LineRange ? lineNumber : lineNumber.read(reader);
			const heights = [];
			for (let i = range.startLineNumber; i < range.endLineNumberExclusive; i++) heights.push(this.observeLineHeightForLine(i).read(reader));
			return heights;
		});
	}
	/**
	* Get the width of a line in pixels.
	* Reading the returned value depends on layoutInfo, value, scrollTop, and container resize events.
	* The container resize dependency ensures correct values when the editor becomes visible after being hidden.
	*/
	getWidthOfLine(lineNumber, reader) {
		this.layoutInfo.read(reader);
		this.value.read(reader);
		this.scrollTop.read(reader);
		const width = this.editor.getWidthOfLine(lineNumber);
		this._onDidContainerResize.read(reader);
		if (width === 0) this._sawZeroLineWidth = true;
		return width;
	}
	/**
	* Get the vertical position (top offset) for the line's bottom w.r.t. to the first line.
	*/
	observeTopForLineNumber(lineNumber) {
		return derived((reader) => {
			this.layoutInfo.read(reader);
			this._onDidChangeViewZones.read(reader);
			this._onDidHiddenAreasChanged.read(reader);
			this._onDidLineHeightChanged.read(reader);
			this._versionId.read(reader);
			return this.editor.getTopForLineNumber(lineNumber);
		});
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/diffEditor/features/overviewRulerFeature.js
var __decorate$11 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$11 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var OverviewRulerFeature_1;
var OverviewRulerFeature = class OverviewRulerFeature extends Disposable {
	static {
		OverviewRulerFeature_1 = this;
	}
	static {
		this.ONE_OVERVIEW_WIDTH = 15;
	}
	static {
		this.ENTIRE_DIFF_OVERVIEW_WIDTH = this.ONE_OVERVIEW_WIDTH * 2;
	}
	constructor(_editors, _rootElement, _diffModel, _rootWidth, _rootHeight, _modifiedEditorLayoutInfo, _themeService) {
		super();
		this._editors = _editors;
		this._rootElement = _rootElement;
		this._diffModel = _diffModel;
		this._rootWidth = _rootWidth;
		this._rootHeight = _rootHeight;
		this._modifiedEditorLayoutInfo = _modifiedEditorLayoutInfo;
		this._themeService = _themeService;
		this.width = OverviewRulerFeature_1.ENTIRE_DIFF_OVERVIEW_WIDTH;
		this._rootElement.classList.add("has-diff-overview");
		this._register(toDisposable(() => this._rootElement.classList.remove("has-diff-overview")));
		const currentColorTheme = observableFromEvent(this._themeService.onDidColorThemeChange, () => this._themeService.getColorTheme());
		const currentColors = derived((reader) => {
			/** @description colors */
			const theme = currentColorTheme.read(reader);
			return {
				insertColor: theme.getColor(diffOverviewRulerInserted) || (theme.getColor(diffInserted) || defaultInsertColor).transparent(2),
				removeColor: theme.getColor(diffOverviewRulerRemoved) || (theme.getColor(diffRemoved) || defaultRemoveColor).transparent(2)
			};
		});
		const viewportDomElement = createFastDomNode(document.createElement("div"));
		viewportDomElement.setClassName("diffViewport");
		viewportDomElement.setPosition("absolute");
		const diffOverviewRoot = h("div.diffOverview", { style: {
			position: "absolute",
			top: "0px",
			width: OverviewRulerFeature_1.ENTIRE_DIFF_OVERVIEW_WIDTH + "px"
		} }).root;
		this._register(appendRemoveOnDispose(diffOverviewRoot, viewportDomElement.domNode));
		this._register(addStandardDisposableListener(diffOverviewRoot, EventType$1.POINTER_DOWN, (e) => {
			this._editors.modified.delegateVerticalScrollbarPointerDown(e);
		}));
		this._register(addDisposableListener(diffOverviewRoot, EventType$1.MOUSE_WHEEL, (e) => {
			this._editors.modified.delegateScrollFromMouseWheelEvent(e);
		}, { passive: false }));
		this._register(appendRemoveOnDispose(this._rootElement, diffOverviewRoot));
		this._register(autorunWithStore((reader, store) => {
			/** @description recreate overview rules when model changes */
			const m = this._diffModel.read(reader);
			const originalOverviewRuler = this._editors.original.createOverviewRuler("original diffOverviewRuler");
			if (originalOverviewRuler) {
				store.add(originalOverviewRuler);
				store.add(appendRemoveOnDispose(diffOverviewRoot, originalOverviewRuler.getDomNode()));
			}
			const modifiedOverviewRuler = this._editors.modified.createOverviewRuler("modified diffOverviewRuler");
			if (modifiedOverviewRuler) {
				store.add(modifiedOverviewRuler);
				store.add(appendRemoveOnDispose(diffOverviewRoot, modifiedOverviewRuler.getDomNode()));
			}
			if (!originalOverviewRuler || !modifiedOverviewRuler) return;
			const origViewZonesChanged = observableSignalFromEvent("viewZoneChanged", this._editors.original.onDidChangeViewZones);
			const modViewZonesChanged = observableSignalFromEvent("viewZoneChanged", this._editors.modified.onDidChangeViewZones);
			const origHiddenRangesChanged = observableSignalFromEvent("hiddenRangesChanged", this._editors.original.onDidChangeHiddenAreas);
			const modHiddenRangesChanged = observableSignalFromEvent("hiddenRangesChanged", this._editors.modified.onDidChangeHiddenAreas);
			store.add(autorun((reader) => {
				/** @description set overview ruler zones */
				origViewZonesChanged.read(reader);
				modViewZonesChanged.read(reader);
				origHiddenRangesChanged.read(reader);
				modHiddenRangesChanged.read(reader);
				const colors = currentColors.read(reader);
				const diff = m?.diff.read(reader)?.mappings;
				function createZones(ranges, color, editor) {
					const vm = editor._getViewModel();
					if (!vm) return [];
					return ranges.filter((d) => d.length > 0).map((r) => {
						const start = vm.coordinatesConverter.convertModelPositionToViewPosition(new Position$1(r.startLineNumber, 1));
						const end = vm.coordinatesConverter.convertModelPositionToViewPosition(new Position$1(r.endLineNumberExclusive, 1));
						const lineCount = end.lineNumber - start.lineNumber;
						return new OverviewRulerZone(start.lineNumber, end.lineNumber, lineCount, color.toString());
					});
				}
				const originalZones = createZones((diff || []).map((d) => d.lineRangeMapping.original), colors.removeColor, this._editors.original);
				const modifiedZones = createZones((diff || []).map((d) => d.lineRangeMapping.modified), colors.insertColor, this._editors.modified);
				originalOverviewRuler?.setZones(originalZones);
				modifiedOverviewRuler?.setZones(modifiedZones);
			}));
			store.add(autorun((reader) => {
				/** @description layout overview ruler */
				const height = this._rootHeight.read(reader);
				const width = this._rootWidth.read(reader);
				const layoutInfo = this._modifiedEditorLayoutInfo.read(reader);
				if (layoutInfo) {
					const freeSpace = OverviewRulerFeature_1.ENTIRE_DIFF_OVERVIEW_WIDTH - 2 * OverviewRulerFeature_1.ONE_OVERVIEW_WIDTH;
					originalOverviewRuler.setLayout({
						top: 0,
						height,
						right: freeSpace + OverviewRulerFeature_1.ONE_OVERVIEW_WIDTH,
						width: OverviewRulerFeature_1.ONE_OVERVIEW_WIDTH
					});
					modifiedOverviewRuler.setLayout({
						top: 0,
						height,
						right: 0,
						width: OverviewRulerFeature_1.ONE_OVERVIEW_WIDTH
					});
					const scrollTop = this._editors.modifiedScrollTop.read(reader);
					const scrollHeight = this._editors.modifiedScrollHeight.read(reader);
					const scrollBarOptions = this._editors.modified.getOption(117);
					const state = new ScrollbarState(scrollBarOptions.verticalHasArrows ? scrollBarOptions.arrowSize : 0, scrollBarOptions.verticalScrollbarSize, 0, layoutInfo.height, scrollHeight, scrollTop);
					viewportDomElement.setTop(state.getSliderPosition());
					viewportDomElement.setHeight(state.getSliderSize());
				} else {
					viewportDomElement.setTop(0);
					viewportDomElement.setHeight(0);
				}
				diffOverviewRoot.style.height = height + "px";
				diffOverviewRoot.style.left = width - OverviewRulerFeature_1.ENTIRE_DIFF_OVERVIEW_WIDTH + "px";
				viewportDomElement.setWidth(OverviewRulerFeature_1.ENTIRE_DIFF_OVERVIEW_WIDTH);
			}));
		}));
	}
};
OverviewRulerFeature = OverviewRulerFeature_1 = __decorate$11([__param$11(6, IThemeService)], OverviewRulerFeature);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/diffEditor/components/diffEditorEditors.js
var __decorate$10 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$10 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var DiffEditorEditors = class DiffEditorEditors extends Disposable {
	get onDidContentSizeChange() {
		return this._onDidContentSizeChange.event;
	}
	getContentHeight() {
		return Math.max(this.modified.getContentHeight(), this.original.getContentHeight());
	}
	constructor(originalEditorElement, modifiedEditorElement, _options, _argCodeEditorWidgetOptions, _createInnerEditor, _contextKeyService, _instantiationService, _keybindingService) {
		super();
		this.originalEditorElement = originalEditorElement;
		this.modifiedEditorElement = modifiedEditorElement;
		this._options = _options;
		this._argCodeEditorWidgetOptions = _argCodeEditorWidgetOptions;
		this._createInnerEditor = _createInnerEditor;
		this._contextKeyService = _contextKeyService;
		this._instantiationService = _instantiationService;
		this._keybindingService = _keybindingService;
		this.original = this._register(this._createLeftHandSideEditor(this._options.editorOptions.get(), this._argCodeEditorWidgetOptions.originalEditor || {}));
		this.modified = this._register(this._createRightHandSideEditor(this._options.editorOptions.get(), this._argCodeEditorWidgetOptions.modifiedEditor || {}));
		this._onDidContentSizeChange = this._register(new Emitter$1());
		this.modifiedScrollTop = observableFromEvent(this, this.modified.onDidScrollChange, () => this.modified.getScrollTop());
		this.modifiedScrollHeight = observableFromEvent(this, this.modified.onDidScrollChange, () => this.modified.getScrollHeight());
		this.modifiedObs = observableCodeEditor(this.modified);
		this.originalObs = observableCodeEditor(this.original);
		this.modifiedModel = this.modifiedObs.model;
		this.modifiedSelections = observableFromEvent(this, this.modified.onDidChangeCursorSelection, () => this.modified.getSelections() ?? []);
		this.modifiedCursor = derivedOpts({
			owner: this,
			equalsFn: Position$1.equals
		}, (reader) => this.modifiedSelections.read(reader)[0]?.getPosition() ?? new Position$1(1, 1));
		this.originalCursor = observableFromEvent(this, this.original.onDidChangeCursorPosition, () => this.original.getPosition() ?? new Position$1(1, 1));
		this.isOriginalFocused = observableCodeEditor(this.original).isFocused;
		this.isModifiedFocused = observableCodeEditor(this.modified).isFocused;
		this.isFocused = derived(this, (reader) => this.isOriginalFocused.read(reader) || this.isModifiedFocused.read(reader));
		this._argCodeEditorWidgetOptions = null;
		this._register(autorunHandleChanges({ changeTracker: {
			createChangeSummary: () => ({}),
			handleChange: (ctx, changeSummary) => {
				if (ctx.didChange(_options.editorOptions)) Object.assign(changeSummary, ctx.change.changedOptions);
				return true;
			}
		} }, (reader, changeSummary) => {
			/** @description update editor options */
			_options.editorOptions.read(reader);
			this._options.renderSideBySide.read(reader);
			this.modified.updateOptions(this._adjustOptionsForRightHandSide(reader, changeSummary));
			this.original.updateOptions(this._adjustOptionsForLeftHandSide(reader, changeSummary));
		}));
	}
	_createLeftHandSideEditor(options, codeEditorWidgetOptions) {
		const leftHandSideOptions = this._adjustOptionsForLeftHandSide(void 0, options);
		const editor = this._constructInnerEditor(this._instantiationService, this.originalEditorElement, leftHandSideOptions, codeEditorWidgetOptions);
		const isInDiffLeftEditorKey = this._contextKeyService.createKey("isInDiffLeftEditor", editor.hasWidgetFocus());
		this._register(editor.onDidFocusEditorWidget(() => isInDiffLeftEditorKey.set(true)));
		this._register(editor.onDidBlurEditorWidget(() => isInDiffLeftEditorKey.set(false)));
		return editor;
	}
	_createRightHandSideEditor(options, codeEditorWidgetOptions) {
		const rightHandSideOptions = this._adjustOptionsForRightHandSide(void 0, options);
		const editor = this._constructInnerEditor(this._instantiationService, this.modifiedEditorElement, rightHandSideOptions, codeEditorWidgetOptions);
		const isInDiffRightEditorKey = this._contextKeyService.createKey("isInDiffRightEditor", editor.hasWidgetFocus());
		this._register(editor.onDidFocusEditorWidget(() => isInDiffRightEditorKey.set(true)));
		this._register(editor.onDidBlurEditorWidget(() => isInDiffRightEditorKey.set(false)));
		return editor;
	}
	_constructInnerEditor(instantiationService, container, options, editorWidgetOptions) {
		const editor = this._createInnerEditor(instantiationService, container, options, editorWidgetOptions);
		this._register(editor.onDidContentSizeChange((e) => {
			const width = this.original.getContentWidth() + this.modified.getContentWidth() + OverviewRulerFeature.ENTIRE_DIFF_OVERVIEW_WIDTH;
			this._onDidContentSizeChange.fire({
				contentHeight: this.getContentHeight(),
				contentWidth: width,
				contentHeightChanged: e.contentHeightChanged,
				contentWidthChanged: e.contentWidthChanged
			});
		}));
		return editor;
	}
	_adjustOptionsForLeftHandSide(_reader, changedOptions) {
		const result = this._adjustOptionsForSubEditor(changedOptions);
		if (!this._options.renderSideBySide.get()) {
			result.wordWrapOverride1 = "off";
			result.wordWrapOverride2 = "off";
			result.stickyScroll = { enabled: false };
			result.unicodeHighlight = {
				nonBasicASCII: false,
				ambiguousCharacters: false,
				invisibleCharacters: false
			};
		} else {
			result.unicodeHighlight = this._options.editorOptions.get().unicodeHighlight || {};
			result.wordWrapOverride1 = this._options.diffWordWrap.get();
		}
		result.glyphMargin = this._options.renderSideBySide.get();
		if (changedOptions.originalAriaLabel) result.ariaLabel = changedOptions.originalAriaLabel;
		result.ariaLabel = this._updateAriaLabel(result.ariaLabel);
		result.readOnly = !this._options.originalEditable.get();
		result.dropIntoEditor = { enabled: !result.readOnly };
		result.extraEditorClassName = "original-in-monaco-diff-editor";
		return result;
	}
	_adjustOptionsForRightHandSide(reader, changedOptions) {
		const result = this._adjustOptionsForSubEditor(changedOptions);
		if (changedOptions.modifiedAriaLabel) result.ariaLabel = changedOptions.modifiedAriaLabel;
		result.ariaLabel = this._updateAriaLabel(result.ariaLabel);
		result.wordWrapOverride1 = this._options.diffWordWrap.get();
		result.revealHorizontalRightPadding = EditorOptions.revealHorizontalRightPadding.defaultValue + OverviewRulerFeature.ENTIRE_DIFF_OVERVIEW_WIDTH;
		result.scrollbar.verticalHasArrows = false;
		result.extraEditorClassName = "modified-in-monaco-diff-editor";
		return result;
	}
	_adjustOptionsForSubEditor(options) {
		const clonedOptions = {
			...options,
			dimension: {
				height: 0,
				width: 0
			}
		};
		clonedOptions.inDiffEditor = true;
		clonedOptions.automaticLayout = false;
		clonedOptions.allowVariableLineHeights = false;
		clonedOptions.allowVariableFonts = false;
		clonedOptions.allowVariableFontsInAccessibilityMode = false;
		clonedOptions.scrollbar = { ...clonedOptions.scrollbar || {} };
		clonedOptions.folding = false;
		clonedOptions.codeLens = this._options.diffCodeLens.get();
		clonedOptions.fixedOverflowWidgets = true;
		clonedOptions.minimap = { ...clonedOptions.minimap || {} };
		clonedOptions.minimap.enabled = false;
		if (this._options.hideUnchangedRegions.get()) clonedOptions.stickyScroll = { enabled: false };
		else clonedOptions.stickyScroll = this._options.editorOptions.get().stickyScroll;
		return clonedOptions;
	}
	_updateAriaLabel(ariaLabel) {
		if (!ariaLabel) ariaLabel = "";
		const ariaNavigationTip = localize(127, " use {0} to open the accessibility help.", this._keybindingService.lookupKeybinding("editor.action.accessibilityHelp")?.getAriaLabel());
		if (this._options.accessibilityVerbose.get()) return ariaLabel + ariaNavigationTip;
		else if (ariaLabel) return ariaLabel.replaceAll(ariaNavigationTip, "");
		return "";
	}
};
DiffEditorEditors = __decorate$10([
	__param$10(5, IContextKeyService),
	__param$10(6, IInstantiationService),
	__param$10(7, IKeybindingService)
], DiffEditorEditors);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/diffEditor/components/diffEditorSash.js
var SashLayout = class {
	resetSash() {
		this._sashRatio.set(void 0, void 0);
	}
	constructor(_options, dimensions) {
		this._options = _options;
		this.dimensions = dimensions;
		this.sashLeft = derivedWithSetter(this, (reader) => {
			const ratio = this._sashRatio.read(reader) ?? this._options.splitViewDefaultRatio.read(reader);
			return this._computeSashLeft(ratio, reader);
		}, (value, tx) => {
			const contentWidth = this.dimensions.width.get();
			this._sashRatio.set(value / contentWidth, tx);
		});
		this._sashRatio = observableValue(this, void 0);
	}
	/** @pure */
	_computeSashLeft(desiredRatio, reader) {
		const contentWidth = this.dimensions.width.read(reader);
		const midPoint = Math.floor(this._options.splitViewDefaultRatio.read(reader) * contentWidth);
		const sashLeft = this._options.enableSplitViewResizing.read(reader) ? Math.floor(desiredRatio * contentWidth) : midPoint;
		const MINIMUM_EDITOR_WIDTH = 100;
		if (contentWidth <= 200) return midPoint;
		if (sashLeft < MINIMUM_EDITOR_WIDTH) return MINIMUM_EDITOR_WIDTH;
		if (sashLeft > contentWidth - MINIMUM_EDITOR_WIDTH) return contentWidth - MINIMUM_EDITOR_WIDTH;
		return sashLeft;
	}
};
var DiffEditorSash = class extends Disposable {
	constructor(_domNode, _dimensions, _enabled, _boundarySashes, sashLeft, _resetSash) {
		super();
		this._domNode = _domNode;
		this._dimensions = _dimensions;
		this._enabled = _enabled;
		this._boundarySashes = _boundarySashes;
		this.sashLeft = sashLeft;
		this._resetSash = _resetSash;
		this._sash = this._register(new Sash(this._domNode, {
			getVerticalSashTop: (_sash) => 0,
			getVerticalSashLeft: (_sash) => this.sashLeft.get(),
			getVerticalSashHeight: (_sash) => this._dimensions.height.get()
		}, { orientation: 0 }));
		this._startSashPosition = void 0;
		this._register(this._sash.onDidStart(() => {
			this._startSashPosition = this.sashLeft.get();
		}));
		this._register(this._sash.onDidChange((e) => {
			this.sashLeft.set(this._startSashPosition + (e.currentX - e.startX), void 0);
		}));
		this._register(this._sash.onDidEnd(() => this._sash.layout()));
		this._register(this._sash.onDidReset(() => this._resetSash()));
		this._register(autorun((reader) => {
			const sashes = this._boundarySashes.read(reader);
			if (sashes) this._sash.orthogonalEndSash = sashes.bottom;
		}));
		this._register(autorun((reader) => {
			/** @description DiffEditorSash.layoutSash */
			const enabled = this._enabled.read(reader);
			this._sash.state = enabled ? 3 : 0;
			this.sashLeft.read(reader);
			this._dimensions.height.read(reader);
			this._sash.layout();
		}));
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/diffEditor/delegatingEditorImpl.js
var DelegatingEditor = class DelegatingEditor extends Disposable {
	constructor() {
		super(...arguments);
		this._id = ++DelegatingEditor.idCounter;
		this._onDidDispose = this._register(new Emitter$1());
		this.onDidDispose = this._onDidDispose.event;
	}
	static {
		this.idCounter = 0;
	}
	getId() {
		return this.getEditorType() + ":v2:" + this._id;
	}
	getVisibleColumnFromPosition(position) {
		return this._targetEditor.getVisibleColumnFromPosition(position);
	}
	getPosition() {
		return this._targetEditor.getPosition();
	}
	setPosition(position, source = "api") {
		this._targetEditor.setPosition(position, source);
	}
	revealLine(lineNumber, scrollType = 0) {
		this._targetEditor.revealLine(lineNumber, scrollType);
	}
	revealLineInCenter(lineNumber, scrollType = 0) {
		this._targetEditor.revealLineInCenter(lineNumber, scrollType);
	}
	revealLineInCenterIfOutsideViewport(lineNumber, scrollType = 0) {
		this._targetEditor.revealLineInCenterIfOutsideViewport(lineNumber, scrollType);
	}
	revealLineNearTop(lineNumber, scrollType = 0) {
		this._targetEditor.revealLineNearTop(lineNumber, scrollType);
	}
	revealPosition(position, scrollType = 0) {
		this._targetEditor.revealPosition(position, scrollType);
	}
	revealPositionInCenter(position, scrollType = 0) {
		this._targetEditor.revealPositionInCenter(position, scrollType);
	}
	revealPositionInCenterIfOutsideViewport(position, scrollType = 0) {
		this._targetEditor.revealPositionInCenterIfOutsideViewport(position, scrollType);
	}
	revealPositionNearTop(position, scrollType = 0) {
		this._targetEditor.revealPositionNearTop(position, scrollType);
	}
	getSelection() {
		return this._targetEditor.getSelection();
	}
	getSelections() {
		return this._targetEditor.getSelections();
	}
	setSelection(something, source = "api") {
		this._targetEditor.setSelection(something, source);
	}
	setSelections(ranges, source = "api") {
		this._targetEditor.setSelections(ranges, source);
	}
	revealLines(startLineNumber, endLineNumber, scrollType = 0) {
		this._targetEditor.revealLines(startLineNumber, endLineNumber, scrollType);
	}
	revealLinesInCenter(startLineNumber, endLineNumber, scrollType = 0) {
		this._targetEditor.revealLinesInCenter(startLineNumber, endLineNumber, scrollType);
	}
	revealLinesInCenterIfOutsideViewport(startLineNumber, endLineNumber, scrollType = 0) {
		this._targetEditor.revealLinesInCenterIfOutsideViewport(startLineNumber, endLineNumber, scrollType);
	}
	revealLinesNearTop(startLineNumber, endLineNumber, scrollType = 0) {
		this._targetEditor.revealLinesNearTop(startLineNumber, endLineNumber, scrollType);
	}
	revealRange(range, scrollType = 0, revealVerticalInCenter = false, revealHorizontal = true) {
		this._targetEditor.revealRange(range, scrollType, revealVerticalInCenter, revealHorizontal);
	}
	revealRangeInCenter(range, scrollType = 0) {
		this._targetEditor.revealRangeInCenter(range, scrollType);
	}
	revealRangeInCenterIfOutsideViewport(range, scrollType = 0) {
		this._targetEditor.revealRangeInCenterIfOutsideViewport(range, scrollType);
	}
	revealRangeNearTop(range, scrollType = 0) {
		this._targetEditor.revealRangeNearTop(range, scrollType);
	}
	revealRangeNearTopIfOutsideViewport(range, scrollType = 0) {
		this._targetEditor.revealRangeNearTopIfOutsideViewport(range, scrollType);
	}
	revealRangeAtTop(range, scrollType = 0) {
		this._targetEditor.revealRangeAtTop(range, scrollType);
	}
	getSupportedActions() {
		return this._targetEditor.getSupportedActions();
	}
	focus() {
		this._targetEditor.focus();
	}
	trigger(source, handlerId, payload) {
		this._targetEditor.trigger(source, handlerId, payload);
	}
	createDecorationsCollection(decorations) {
		return this._targetEditor.createDecorationsCollection(decorations);
	}
	changeDecorations(callback) {
		return this._targetEditor.changeDecorations(callback);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/base/common/observableInternal/experimental/utils.js
/**
* Works like a derived.
* However, if the value is not undefined, it is cached and will not be recomputed anymore.
* In that case, the derived will unsubscribe from its dependencies.
*/
function derivedConstOnceDefined(owner, fn) {
	return derivedObservableWithCache(owner, (reader, lastValue) => lastValue ?? fn(reader));
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/diffEditor/diffEditorOptions.js
var __decorate$9 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$9 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var DiffEditorOptions = class DiffEditorOptions {
	get editorOptions() {
		return this._options;
	}
	constructor(options, _accessibilityService) {
		this._accessibilityService = _accessibilityService;
		this._widthBasedLayout = observableValue(this, "auto");
		this.temporaryInlineMode = this._widthBasedLayout.map(this, (layout) => layout === "inline");
		this._diffEditorWidth = observableValue(this, 0);
		this._screenReaderMode = observableFromEvent(this, this._accessibilityService.onDidChangeScreenReaderOptimized, () => this._accessibilityService.isScreenReaderOptimized());
		this.couldShowInlineViewBecauseOfSize = derived(this, (reader) => this._options.read(reader).renderSideBySide && this._diffEditorWidth.read(reader) <= this._options.read(reader).renderSideBySideInlineBreakpoint);
		this.renderOverviewRuler = derived(this, (reader) => this._options.read(reader).renderOverviewRuler);
		this.renderSideBySideInAutomaticMode = derived(this, (reader) => {
			if (this.compactMode.read(reader) && this.shouldRenderInlineViewInSmartMode.read(reader)) return false;
			return this._diffEditorWidth.read(reader) > this._options.read(reader).renderSideBySideInlineBreakpoint || this._screenReaderMode.read(reader);
		});
		this.renderSideBySide = derived(this, (reader) => {
			if (this.compactMode.read(reader)) {
				if (this.shouldRenderInlineViewInSmartMode.read(reader)) return false;
			}
			return this._options.read(reader).renderSideBySide && this._widthBasedLayout.read(reader) === "auto" && !(this._options.read(reader).useInlineViewWhenSpaceIsLimited && this.couldShowInlineViewBecauseOfSize.read(reader) && !this._screenReaderMode.read(reader));
		});
		this.readOnly = derived(this, (reader) => this._options.read(reader).readOnly);
		this.shouldRenderOldRevertArrows = derived(this, (reader) => {
			if (!this._options.read(reader).renderMarginRevertIcon) return false;
			if (!this.renderSideBySide.read(reader)) return false;
			if (this.readOnly.read(reader)) return false;
			if (this.shouldRenderGutterMenu.read(reader)) return false;
			return true;
		});
		this.shouldRenderGutterMenu = derived(this, (reader) => this._options.read(reader).renderGutterMenu);
		this.renderIndicators = derived(this, (reader) => this._options.read(reader).renderIndicators);
		this.enableSplitViewResizing = derived(this, (reader) => this._options.read(reader).enableSplitViewResizing);
		this.splitViewDefaultRatio = derived(this, (reader) => this._options.read(reader).splitViewDefaultRatio);
		this.ignoreTrimWhitespace = derived(this, (reader) => this._options.read(reader).ignoreTrimWhitespace);
		this.maxComputationTimeMs = derived(this, (reader) => this._options.read(reader).maxComputationTime);
		this.showMoves = derived(this, (reader) => this._options.read(reader).experimental.showMoves && this.renderSideBySide.read(reader));
		this.isInEmbeddedEditor = derived(this, (reader) => this._options.read(reader).isInEmbeddedEditor);
		this.diffWordWrap = derived(this, (reader) => this._options.read(reader).diffWordWrap);
		this.originalEditable = derived(this, (reader) => this._options.read(reader).originalEditable);
		this.diffCodeLens = derived(this, (reader) => this._options.read(reader).diffCodeLens);
		this.accessibilityVerbose = derived(this, (reader) => this._options.read(reader).accessibilityVerbose);
		this.diffAlgorithm = derived(this, (reader) => this._options.read(reader).diffAlgorithm);
		this.showEmptyDecorations = derived(this, (reader) => this._options.read(reader).experimental.showEmptyDecorations);
		this.onlyShowAccessibleDiffViewer = derived(this, (reader) => this._options.read(reader).onlyShowAccessibleDiffViewer);
		this.compactMode = derived(this, (reader) => this._options.read(reader).compactMode);
		this.trueInlineDiffRenderingEnabled = derived(this, (reader) => this._options.read(reader).experimental.useTrueInlineView);
		this.useTrueInlineDiffRendering = derived(this, (reader) => !this.renderSideBySide.read(reader) && this.trueInlineDiffRenderingEnabled.read(reader));
		this.hideUnchangedRegions = derived(this, (reader) => this._options.read(reader).hideUnchangedRegions.enabled);
		this.hideUnchangedRegionsRevealLineCount = derived(this, (reader) => this._options.read(reader).hideUnchangedRegions.revealLineCount);
		this.hideUnchangedRegionsContextLineCount = derived(this, (reader) => this._options.read(reader).hideUnchangedRegions.contextLineCount);
		this.hideUnchangedRegionsMinimumLineCount = derived(this, (reader) => this._options.read(reader).hideUnchangedRegions.minimumLineCount);
		this._model = observableValue(this, void 0);
		this.shouldRenderInlineViewInSmartMode = this._model.map(this, (model) => derivedConstOnceDefined(this, (reader) => {
			const diffs = model?.diff.read(reader);
			return diffs ? isSimpleDiff(diffs, this.trueInlineDiffRenderingEnabled.read(reader)) : void 0;
		})).flatten().map(this, (v) => !!v);
		this.inlineViewHideOriginalLineNumbers = derived(this, (reader) => this._options.read(reader).hideOriginalLineNumbers || this.compactMode.read(reader));
		const optionsCopy = {
			...options,
			...validateDiffEditorOptions(options, diffEditorDefaultOptions)
		};
		this._options = observableValue(this, optionsCopy);
	}
	updateOptions(changedOptions) {
		const currentOptions = this._options.get();
		const newDiffEditorOptions = validateDiffEditorOptions(changedOptions, this._options.get());
		const newOptions = {
			...currentOptions,
			...changedOptions,
			...newDiffEditorOptions
		};
		transaction((tx) => {
			if (currentOptions.renderSideBySide !== newOptions.renderSideBySide || currentOptions.useInlineViewWhenSpaceIsLimited !== newOptions.useInlineViewWhenSpaceIsLimited || currentOptions.renderSideBySideInlineBreakpoint !== newOptions.renderSideBySideInlineBreakpoint) this._widthBasedLayout.set("auto", tx);
			this._options.set(newOptions, tx, { changedOptions });
		});
	}
	setWidth(width, smoothResizeStartWidth) {
		const options = this._options.get();
		transaction((tx) => {
			this._diffEditorWidth.set(width, tx);
			if (width <= options.renderSideBySideInlineBreakpoint) this._widthBasedLayout.set("auto", tx);
			else if (smoothResizeStartWidth !== void 0 && this._widthBasedLayout.get() === "auto" && options.renderSideBySide && options.useInlineViewWhenSpaceIsLimited && smoothResizeStartWidth <= options.renderSideBySideInlineBreakpoint && width > options.renderSideBySideInlineBreakpoint && !this._screenReaderMode.get() && !(this.compactMode.get() && this.shouldRenderInlineViewInSmartMode.get())) this._widthBasedLayout.set("inline", tx);
		});
	}
	resetWidthBasedLayout(tx) {
		this._widthBasedLayout.set("auto", tx);
	}
	setModel(model) {
		this._model.set(model, void 0);
	}
};
DiffEditorOptions = __decorate$9([__param$9(1, IAccessibilityService)], DiffEditorOptions);
function isSimpleDiff(diff, supportsTrueDiffRendering) {
	return diff.mappings.every((m) => isInsertion(m.lineRangeMapping) || isDeletion(m.lineRangeMapping) || supportsTrueDiffRendering && allowsTrueInlineDiffRendering(m.lineRangeMapping));
}
function isInsertion(mapping) {
	return mapping.original.length === 0;
}
function isDeletion(mapping) {
	return mapping.modified.length === 0;
}
function validateDiffEditorOptions(options, defaults) {
	return {
		enableSplitViewResizing: boolean(options.enableSplitViewResizing, defaults.enableSplitViewResizing),
		splitViewDefaultRatio: clampedFloat(options.splitViewDefaultRatio, .5, .1, .9),
		renderSideBySide: boolean(options.renderSideBySide, defaults.renderSideBySide),
		renderMarginRevertIcon: boolean(options.renderMarginRevertIcon, defaults.renderMarginRevertIcon),
		maxComputationTime: clampedInt(options.maxComputationTime, defaults.maxComputationTime, 0, 1073741824),
		maxFileSize: clampedInt(options.maxFileSize, defaults.maxFileSize, 0, 1073741824),
		ignoreTrimWhitespace: boolean(options.ignoreTrimWhitespace, defaults.ignoreTrimWhitespace),
		renderIndicators: boolean(options.renderIndicators, defaults.renderIndicators),
		originalEditable: boolean(options.originalEditable, defaults.originalEditable),
		diffCodeLens: boolean(options.diffCodeLens, defaults.diffCodeLens),
		renderOverviewRuler: boolean(options.renderOverviewRuler, defaults.renderOverviewRuler),
		diffWordWrap: stringSet(options.diffWordWrap, defaults.diffWordWrap, [
			"off",
			"on",
			"inherit"
		]),
		diffAlgorithm: stringSet(options.diffAlgorithm, defaults.diffAlgorithm, [
			"legacy",
			"advanced",
			"advanced-external",
			"advanced-wasm"
		], {
			"smart": "legacy",
			"experimental": "advanced"
		}),
		accessibilityVerbose: boolean(options.accessibilityVerbose, defaults.accessibilityVerbose),
		experimental: {
			showMoves: boolean(options.experimental?.showMoves, defaults.experimental.showMoves),
			showEmptyDecorations: boolean(options.experimental?.showEmptyDecorations, defaults.experimental.showEmptyDecorations),
			useTrueInlineView: boolean(options.experimental?.useTrueInlineView, defaults.experimental.useTrueInlineView)
		},
		hideUnchangedRegions: {
			enabled: boolean(options.hideUnchangedRegions?.enabled ?? options.experimental?.collapseUnchangedRegions, defaults.hideUnchangedRegions.enabled),
			contextLineCount: clampedInt(options.hideUnchangedRegions?.contextLineCount, defaults.hideUnchangedRegions.contextLineCount, 0, 1073741824),
			minimumLineCount: clampedInt(options.hideUnchangedRegions?.minimumLineCount, defaults.hideUnchangedRegions.minimumLineCount, 0, 1073741824),
			revealLineCount: clampedInt(options.hideUnchangedRegions?.revealLineCount, defaults.hideUnchangedRegions.revealLineCount, 0, 1073741824)
		},
		isInEmbeddedEditor: boolean(options.isInEmbeddedEditor, defaults.isInEmbeddedEditor),
		onlyShowAccessibleDiffViewer: boolean(options.onlyShowAccessibleDiffViewer, defaults.onlyShowAccessibleDiffViewer),
		renderSideBySideInlineBreakpoint: clampedInt(options.renderSideBySideInlineBreakpoint, defaults.renderSideBySideInlineBreakpoint, 0, 1073741824),
		useInlineViewWhenSpaceIsLimited: boolean(options.useInlineViewWhenSpaceIsLimited, defaults.useInlineViewWhenSpaceIsLimited),
		renderGutterMenu: boolean(options.renderGutterMenu, defaults.renderGutterMenu),
		compactMode: boolean(options.compactMode, defaults.compactMode),
		hideOriginalLineNumbers: boolean(options.hideOriginalLineNumbers, defaults.hideOriginalLineNumbers)
	};
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/actions/browser/actionViewItemService.js
var IActionViewItemService = createDecorator("IActionViewItemService");
var ActionViewItemService = class {
	constructor() {
		this._providers = /* @__PURE__ */ new Map();
		this._onDidChange = new Emitter$1();
		this.onDidChange = this._onDidChange.event;
	}
	dispose() {
		this._onDidChange.dispose();
	}
	lookUp(menu, commandOrMenuId) {
		return this._providers.get(this._makeKey(menu, commandOrMenuId));
	}
	_makeKey(menu, commandOrMenuId) {
		return `${menu.id}/${commandOrMenuId instanceof MenuId ? commandOrMenuId.id : commandOrMenuId}`;
	}
};
registerSingleton(IActionViewItemService, ActionViewItemService, 1);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/actions/browser/toolbar.js
var __decorate$8 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$8 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
/**
* The `WorkbenchToolBar` does
* - support hiding of menu items
* - lookup keybindings for each actions automatically
* - send `workbenchActionExecuted`-events for each action
*
* See {@link MenuWorkbenchToolBar} for a toolbar that is backed by a menu.
*/
var WorkbenchToolBar = class WorkbenchToolBar extends ToolBar {
	constructor(container, _options, _menuService, _contextKeyService, _contextMenuService, _keybindingService, _commandService, telemetryService) {
		super(container, _contextMenuService, {
			getKeyBinding: (action) => _keybindingService.lookupKeybinding(action.id) ?? void 0,
			..._options,
			allowContextMenu: true,
			skipTelemetry: typeof _options?.telemetrySource === "string"
		});
		this._options = _options;
		this._menuService = _menuService;
		this._contextKeyService = _contextKeyService;
		this._contextMenuService = _contextMenuService;
		this._keybindingService = _keybindingService;
		this._commandService = _commandService;
		this._sessionDisposables = this._store.add(new DisposableStore());
		const telemetrySource = _options?.telemetrySource;
		if (telemetrySource) this._store.add(this.actionBar.onDidRun((e) => telemetryService.publicLog2("workbenchActionExecuted", {
			id: e.action.id,
			from: telemetrySource
		})));
	}
	setActions(_primary, _secondary = [], menuIds) {
		this._sessionDisposables.clear();
		const primary = _primary.slice();
		const secondary = _secondary.slice();
		const toggleActions = [];
		let toggleActionsCheckedCount = 0;
		const extraSecondary = [];
		let someAreHidden = false;
		if (this._options?.hiddenItemStrategy !== -1) for (let i = 0; i < primary.length; i++) {
			const action = primary[i];
			if (action instanceof Separator) {
				extraSecondary[i] = action;
				continue;
			}
			if (!(action instanceof MenuItemAction) && !(action instanceof SubmenuItemAction)) continue;
			if (!action.hideActions) continue;
			toggleActions.push(action.hideActions.toggle);
			if (action.hideActions.toggle.checked) toggleActionsCheckedCount++;
			if (action.hideActions.isHidden) {
				someAreHidden = true;
				primary[i] = void 0;
				if (this._options?.hiddenItemStrategy !== 0) extraSecondary[i] = action;
			}
		}
		if (this._options?.overflowBehavior !== void 0) {
			const exemptedIds = intersection(new Set(this._options.overflowBehavior.exempted), Iterable.map(primary, (a) => a?.id));
			const maxItems = this._options.overflowBehavior.maxItems - exemptedIds.size;
			let count = 0;
			for (let i = 0; i < primary.length; i++) {
				const action = primary[i];
				if (!action) continue;
				count++;
				if (exemptedIds.has(action.id)) continue;
				if (count >= maxItems) {
					primary[i] = void 0;
					extraSecondary[i] = action;
				}
			}
		}
		coalesceInPlace(primary);
		coalesceInPlace(extraSecondary);
		super.setActions(Separator.clean(primary), Separator.join(Separator.clean(extraSecondary), secondary));
		if (toggleActions.length > 0 || primary.length > 0) this._sessionDisposables.add(addDisposableListener(this.getElement(), "contextmenu", (e) => {
			const event = new StandardMouseEvent(getWindow(this.getElement()), e);
			const action = this.getItemAction(event.target);
			if (!action) return;
			event.preventDefault();
			event.stopPropagation();
			const primaryActions = [];
			if (action instanceof MenuItemAction && action.menuKeybinding) primaryActions.push(action.menuKeybinding);
			else if (!(action instanceof SubmenuItemAction || action instanceof ToggleMenuAction)) {
				const supportsKeybindings = !!this._keybindingService.lookupKeybinding(action.id);
				primaryActions.push(createConfigureKeybindingAction(this._commandService, this._keybindingService, action.id, void 0, supportsKeybindings));
			}
			if (toggleActions.length > 0) {
				let noHide = false;
				if (toggleActionsCheckedCount === 1 && this._options?.hiddenItemStrategy === 0) {
					noHide = true;
					for (let i = 0; i < toggleActions.length; i++) if (toggleActions[i].checked) {
						toggleActions[i] = toAction({
							id: action.id,
							label: action.label,
							checked: true,
							enabled: false,
							run() {}
						});
						break;
					}
				}
				if (!noHide && (action instanceof MenuItemAction || action instanceof SubmenuItemAction)) {
					if (!action.hideActions) return;
					primaryActions.push(action.hideActions.hide);
				} else primaryActions.push(toAction({
					id: "label",
					label: localize(1727, "Hide"),
					enabled: false,
					run() {}
				}));
			}
			const actions = Separator.join(primaryActions, toggleActions);
			if (this._options?.resetMenu && !menuIds) menuIds = [this._options.resetMenu];
			if (someAreHidden && menuIds) {
				actions.push(new Separator());
				actions.push(toAction({
					id: "resetThisMenu",
					label: localize(1728, "Reset Menu"),
					run: () => this._menuService.resetHiddenStates(menuIds)
				}));
			}
			if (actions.length === 0) return;
			this._contextMenuService.showContextMenu({
				getAnchor: () => event,
				getActions: () => actions,
				menuId: this._options?.contextMenu,
				menuActionOptions: {
					renderShortTitle: true,
					...this._options?.menuOptions
				},
				skipTelemetry: typeof this._options?.telemetrySource === "string",
				contextKeyService: this._contextKeyService
			});
		}));
	}
};
WorkbenchToolBar = __decorate$8([
	__param$8(2, IMenuService),
	__param$8(3, IContextKeyService),
	__param$8(4, IContextMenuService),
	__param$8(5, IKeybindingService),
	__param$8(6, ICommandService),
	__param$8(7, ITelemetryService)
], WorkbenchToolBar);
/**
* A {@link WorkbenchToolBar workbench toolbar} that is purely driven from a {@link MenuId menu}-identifier.
*
* *Note* that Manual updates via `setActions` are NOT supported.
*/
var MenuWorkbenchToolBar = class MenuWorkbenchToolBar extends WorkbenchToolBar {
	get onDidChangeMenuItems() {
		return this._onDidChangeMenuItems.event;
	}
	constructor(container, menuId, options, menuService, contextKeyService, contextMenuService, keybindingService, commandService, telemetryService, actionViewService, instantiationService) {
		super(container, {
			resetMenu: menuId,
			...options,
			actionViewItemProvider: (action, opts) => {
				let provider = actionViewService.lookUp(menuId, action instanceof SubmenuItemAction ? action.item.submenu.id : action.id);
				if (!provider) provider = options?.actionViewItemProvider;
				const viewItem = provider?.(action, opts, instantiationService, getWindow(container).vscodeWindowId);
				if (viewItem) return viewItem;
				return createActionViewItem(instantiationService, action, opts);
			}
		}, menuService, contextKeyService, contextMenuService, keybindingService, commandService, telemetryService);
		this._onDidChangeMenuItems = this._store.add(new Emitter$1());
		this._container = container;
		this._menuOptions = options?.menuOptions;
		this._toolbarOptions = options?.toolbarOptions;
		this._menu = this._store.add(menuService.createMenu(menuId, contextKeyService, {
			emitEventsForSubmenuChanges: true,
			eventDebounceDelay: options?.eventDebounceDelay
		}));
		this._store.add(this._menu.onDidChange(() => {
			this._updateToolbar();
			this._onDidChangeMenuItems.fire(this);
		}));
		this._store.add(actionViewService.onDidChange((e) => {
			if (e === menuId) this._updateToolbar();
		}));
		this._updateToolbar();
	}
	_updateToolbar() {
		const { primary, secondary } = getActionBarActions(this._menu.getActions(this._menuOptions), this._toolbarOptions?.primaryGroup, this._toolbarOptions?.shouldInlineSubmenu, this._toolbarOptions?.useSeparatorsInPrimaryActions);
		this._container.classList.toggle("has-no-actions", primary.length === 0 && secondary.length === 0);
		super.setActions(primary, secondary);
	}
	/**
	* @deprecated The WorkbenchToolBar does not support this method because it works with menus.
	*/
	setActions() {
		throw new BugIndicatingError("This toolbar is populated from a menu.");
	}
};
MenuWorkbenchToolBar = __decorate$8([
	__param$8(3, IMenuService),
	__param$8(4, IContextKeyService),
	__param$8(5, IContextMenuService),
	__param$8(6, IKeybindingService),
	__param$8(7, ICommandService),
	__param$8(8, ITelemetryService),
	__param$8(9, IActionViewItemService),
	__param$8(10, IInstantiationService)
], MenuWorkbenchToolBar);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/common/model/textModelText.js
var TextModelText = class extends AbstractText {
	constructor(_textModel) {
		super();
		this._textModel = _textModel;
	}
	getValueOfRange(range) {
		return this._textModel.getValueInRange(range);
	}
	getLineLength(lineNumber) {
		return this._textModel.getLineLength(lineNumber);
	}
	get length() {
		const lastLineNumber = this._textModel.getLineCount();
		const lastLineLen = this._textModel.getLineLength(lastLineNumber);
		return new TextLength(lastLineNumber - 1, lastLineLen);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/multiDiffEditor/utils.js
var ActionRunnerWithContext = class extends ActionRunner {
	constructor(_getContext) {
		super();
		this._getContext = _getContext;
	}
	runAction(action, _context) {
		const ctx = this._getContext();
		return super.runAction(action, ctx);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/diffEditor/utils/editorGutter.js
var EditorGutter = class extends Disposable {
	constructor(_editor, _domNode, itemProvider) {
		super();
		this._editor = _editor;
		this._domNode = _domNode;
		this.itemProvider = itemProvider;
		this.scrollTop = observableFromEvent(this, this._editor.onDidScrollChange, (e) => this._editor.getScrollTop());
		this.isScrollTopZero = this.scrollTop.map((scrollTop) => scrollTop === 0);
		this.modelAttached = observableFromEvent(this, this._editor.onDidChangeModel, (e) => this._editor.hasModel());
		this.editorOnDidChangeViewZones = observableSignalFromEvent("onDidChangeViewZones", this._editor.onDidChangeViewZones);
		this.editorOnDidContentSizeChange = observableSignalFromEvent("onDidContentSizeChange", this._editor.onDidContentSizeChange);
		this.domNodeSizeChanged = observableSignal("domNodeSizeChanged");
		this.views = this._register(new DisposableMap());
		this._domNode.className = "gutter monaco-editor";
		const scrollDecoration = this._domNode.appendChild(h("div.scroll-decoration", {
			role: "presentation",
			ariaHidden: "true",
			style: { width: "100%" }
		}).root);
		const o = new ResizeObserver(() => {
			transaction((tx) => {
				/** @description ResizeObserver: size changed */
				this.domNodeSizeChanged.trigger(tx);
			});
		});
		o.observe(this._domNode);
		this._register(toDisposable(() => o.disconnect()));
		this._register(autorun((reader) => {
			/** @description update scroll decoration */
			scrollDecoration.className = this.isScrollTopZero.read(reader) ? "" : "scroll-decoration";
		}));
		this._register(autorun((reader) => this.render(reader)));
	}
	dispose() {
		super.dispose();
		reset(this._domNode);
	}
	render(reader) {
		if (!this.modelAttached.read(reader)) return;
		this.domNodeSizeChanged.read(reader);
		this.editorOnDidChangeViewZones.read(reader);
		this.editorOnDidContentSizeChange.read(reader);
		const scrollTop = this.scrollTop.read(reader);
		const visibleRanges = this._editor.getVisibleRanges();
		const unusedIds = new Set(this.views.keys());
		const viewRange = OffsetRange.ofStartAndLength(0, this._domNode.clientHeight);
		if (!viewRange.isEmpty) for (const visibleRange of visibleRanges) {
			const visibleRange2 = new LineRange(visibleRange.startLineNumber, visibleRange.endLineNumber + 1);
			const gutterItems = this.itemProvider.getIntersectingGutterItems(visibleRange2, reader);
			transaction((tx) => {
				/** EditorGutter.render */
				for (const gutterItem of gutterItems) {
					if (!gutterItem.range.intersect(visibleRange2)) continue;
					unusedIds.delete(gutterItem.id);
					let view = this.views.get(gutterItem.id);
					if (!view) {
						const viewDomNode = document.createElement("div");
						this._domNode.appendChild(viewDomNode);
						const gutterItemObs = observableValue("item", gutterItem);
						view = new ManagedGutterItemView(gutterItemObs, this.itemProvider.createView(gutterItemObs, viewDomNode), viewDomNode);
						this.views.set(gutterItem.id, view);
					} else view.item.set(gutterItem, tx);
					const top = gutterItem.range.startLineNumber <= this._editor.getModel().getLineCount() ? this._editor.getTopForLineNumber(gutterItem.range.startLineNumber, true) - scrollTop : gutterItem.range.startLineNumber > 1 ? this._editor.getBottomForLineNumber(gutterItem.range.startLineNumber - 1, false) - scrollTop : 0;
					const height = (gutterItem.range.endLineNumberExclusive === 1 ? Math.max(top, this._editor.getTopForLineNumber(gutterItem.range.startLineNumber, false) - scrollTop) : Math.max(top, this._editor.getBottomForLineNumber(gutterItem.range.endLineNumberExclusive - 1, true) - scrollTop)) - top;
					view.domNode.style.top = `${top}px`;
					view.domNode.style.height = `${height}px`;
					view.gutterItemView.layout(OffsetRange.ofStartAndLength(top, height), viewRange);
				}
			});
		}
		for (const id of unusedIds) this.views.deleteAndDispose(id);
	}
};
var ManagedGutterItemView = class {
	constructor(item, gutterItemView, domNode) {
		this.item = item;
		this.gutterItemView = gutterItemView;
		this.domNode = domNode;
	}
	dispose() {
		this.gutterItemView.dispose();
		this.domNode.remove();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/diffEditor/features/gutterFeature.js
var __decorate$7 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$7 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var emptyArr$1 = [];
var width = 35;
var DiffEditorGutter = class DiffEditorGutter extends Disposable {
	constructor(diffEditorRoot, _diffModel, _editors, _options, _sashLayout, _boundarySashes, _instantiationService, _contextKeyService, _menuService) {
		super();
		this._diffModel = _diffModel;
		this._editors = _editors;
		this._options = _options;
		this._sashLayout = _sashLayout;
		this._boundarySashes = _boundarySashes;
		this._instantiationService = _instantiationService;
		this._contextKeyService = _contextKeyService;
		this._menuService = _menuService;
		this._menu = this._register(this._menuService.createMenu(MenuId.DiffEditorHunkToolbar, this._contextKeyService));
		this._actions = observableFromEvent(this, this._menu.onDidChange, () => this._menu.getActions());
		this._hasActions = this._actions.map((a) => a.length > 0);
		this._showSash = derived(this, (reader) => this._options.renderSideBySide.read(reader) && this._hasActions.read(reader));
		this.width = derived(this, (reader) => this._hasActions.read(reader) ? width : 0);
		this.elements = h("div.gutter@gutter", { style: {
			position: "absolute",
			height: "100%",
			width: "35px"
		} }, []);
		this._currentDiff = derived(this, (reader) => {
			const model = this._diffModel.read(reader);
			if (!model) return;
			const mappings = model.diff.read(reader)?.mappings;
			const cursorPosition = this._editors.modifiedCursor.read(reader);
			if (!cursorPosition) return;
			return mappings?.find((m) => m.lineRangeMapping.modified.contains(cursorPosition.lineNumber));
		});
		this._selectedDiffs = derived(this, (reader) => {
			const diff = this._diffModel.read(reader)?.diff.read(reader);
			if (!diff) return emptyArr$1;
			const selections = this._editors.modifiedSelections.read(reader);
			if (selections.every((s) => s.isEmpty())) return emptyArr$1;
			const selectedLineNumbers = new LineRangeSet(selections.map((s) => LineRange.fromRangeInclusive(s)));
			const result = diff.mappings.filter((m) => m.lineRangeMapping.innerChanges && selectedLineNumbers.intersects(m.lineRangeMapping.modified)).map((mapping) => ({
				mapping,
				rangeMappings: mapping.lineRangeMapping.innerChanges.filter((c) => selections.some((s) => Range$2.areIntersecting(c.modifiedRange, s)))
			}));
			if (result.length === 0 || result.every((r) => r.rangeMappings.length === 0)) return emptyArr$1;
			return result;
		});
		this._register(prependRemoveOnDispose(diffEditorRoot, this.elements.root));
		this._register(addDisposableListener(this.elements.root, "click", () => {
			this._editors.modified.focus();
		}));
		this._register(applyStyle(this.elements.root, { display: this._hasActions.map((a) => a ? "block" : "none") }));
		derivedDisposable(this, (reader) => {
			return !this._showSash.read(reader) ? void 0 : new DiffEditorSash(diffEditorRoot, this._sashLayout.dimensions, this._options.enableSplitViewResizing, this._boundarySashes, derivedWithSetter(this, (reader) => this._sashLayout.sashLeft.read(reader) - width, (v, tx) => this._sashLayout.sashLeft.set(v + width, tx)), () => this._sashLayout.resetSash());
		}).recomputeInitiallyAndOnChange(this._store);
		const gutterItems = derived(this, (reader) => {
			const model = this._diffModel.read(reader);
			if (!model) return [];
			const diffs = model.diff.read(reader);
			if (!diffs) return [];
			const selection = this._selectedDiffs.read(reader);
			if (selection.length > 0) return [new DiffGutterItem(DetailedLineRangeMapping.fromRangeMappings(selection.flatMap((s) => s.rangeMappings)), true, MenuId.DiffEditorSelectionToolbar, void 0, model.model.original.uri, model.model.modified.uri)];
			const currentDiff = this._currentDiff.read(reader);
			return diffs.mappings.map((m) => new DiffGutterItem(m.lineRangeMapping.withInnerChangesFromLineRanges(), m.lineRangeMapping === currentDiff?.lineRangeMapping, MenuId.DiffEditorHunkToolbar, void 0, model.model.original.uri, model.model.modified.uri));
		});
		this._register(new EditorGutter(this._editors.modified, this.elements.root, {
			getIntersectingGutterItems: (range, reader) => gutterItems.read(reader),
			createView: (item, target) => {
				return this._instantiationService.createInstance(DiffToolBar, item, target, this);
			}
		}));
		this._register(addDisposableListener(this.elements.gutter, EventType$1.MOUSE_WHEEL, (e) => {
			if (this._editors.modified.getOption(117).handleMouseWheel) this._editors.modified.delegateScrollFromMouseWheelEvent(e);
		}, { passive: false }));
	}
	computeStagedValue(mapping) {
		const c = mapping.innerChanges ?? [];
		const modified = new TextModelText(this._editors.modifiedModel.get());
		const original = new TextModelText(this._editors.original.getModel());
		return new TextEdit(c.map((c) => c.toTextEdit(modified))).apply(original);
	}
	layout(left) {
		this.elements.gutter.style.left = left + "px";
	}
};
DiffEditorGutter = __decorate$7([
	__param$7(6, IInstantiationService),
	__param$7(7, IContextKeyService),
	__param$7(8, IMenuService)
], DiffEditorGutter);
var DiffGutterItem = class {
	constructor(mapping, showAlways, menuId, rangeOverride, originalUri, modifiedUri) {
		this.mapping = mapping;
		this.showAlways = showAlways;
		this.menuId = menuId;
		this.rangeOverride = rangeOverride;
		this.originalUri = originalUri;
		this.modifiedUri = modifiedUri;
	}
	get id() {
		return this.mapping.modified.toString();
	}
	get range() {
		return this.rangeOverride ?? this.mapping.modified;
	}
};
var DiffToolBar = class DiffToolBar extends Disposable {
	constructor(_item, target, gutter, instantiationService) {
		super();
		this._item = _item;
		this._elements = h("div.gutterItem", { style: {
			height: "20px",
			width: "34px"
		} }, [h("div.background@background", {}, []), h("div.buttons@buttons", {}, [])]);
		this._showAlways = this._item.map(this, (item) => item.showAlways);
		this._menuId = this._item.map(this, (item) => item.menuId);
		this._isSmall = observableValue(this, false);
		this._lastItemRange = void 0;
		this._lastViewRange = void 0;
		const hoverDelegate = this._register(instantiationService.createInstance(WorkbenchHoverDelegate, "element", { instantHover: true }, { position: { hoverPosition: 1 } }));
		this._register(appendRemoveOnDispose(target, this._elements.root));
		this._register(autorun((reader) => {
			/** @description update showAlways */
			const showAlways = this._showAlways.read(reader);
			this._elements.root.classList.toggle("noTransition", true);
			this._elements.root.classList.toggle("showAlways", showAlways);
			setTimeout(() => {
				this._elements.root.classList.toggle("noTransition", false);
			}, 0);
		}));
		this._register(autorunWithStore((reader, store) => {
			this._elements.buttons.replaceChildren();
			const i = store.add(instantiationService.createInstance(MenuWorkbenchToolBar, this._elements.buttons, this._menuId.read(reader), {
				orientation: 1,
				hoverDelegate,
				toolbarOptions: { primaryGroup: (g) => g.startsWith("primary") },
				overflowBehavior: { maxItems: this._isSmall.read(reader) ? 1 : 3 },
				hiddenItemStrategy: 0,
				actionRunner: store.add(new ActionRunnerWithContext(() => {
					const item = this._item.read(void 0);
					const mapping = item.mapping;
					return {
						mapping,
						originalWithModifiedChanges: gutter.computeStagedValue(mapping),
						originalUri: item.originalUri,
						modifiedUri: item.modifiedUri
					};
				})),
				menuOptions: { shouldForwardArgs: true }
			}));
			store.add(i.onDidChangeMenuItems(() => {
				if (this._lastItemRange) this.layout(this._lastItemRange, this._lastViewRange);
			}));
		}));
	}
	layout(itemRange, viewRange) {
		this._lastItemRange = itemRange;
		this._lastViewRange = viewRange;
		let itemHeight = this._elements.buttons.clientHeight;
		this._isSmall.set(this._item.get().mapping.original.startLineNumber === 1 && itemRange.length < 30, void 0);
		itemHeight = this._elements.buttons.clientHeight;
		const middleHeight = itemRange.length / 2 - itemHeight / 2;
		const margin = itemHeight;
		let effectiveCheckboxTop = itemRange.start + middleHeight;
		const preferredViewPortRange = OffsetRange.tryCreate(margin, viewRange.endExclusive - margin - itemHeight);
		const preferredParentRange = OffsetRange.tryCreate(itemRange.start + margin, itemRange.endExclusive - itemHeight - margin);
		if (preferredParentRange && preferredViewPortRange && preferredParentRange.start < preferredParentRange.endExclusive) {
			effectiveCheckboxTop = preferredViewPortRange.clip(effectiveCheckboxTop);
			effectiveCheckboxTop = preferredParentRange.clip(effectiveCheckboxTop);
		}
		this._elements.buttons.style.top = `${effectiveCheckboxTop - itemRange.start}px`;
	}
};
DiffToolBar = __decorate$7([__param$7(3, IInstantiationService)], DiffToolBar);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/diffEditor/features/hideUnchangedRegionsFeature.js
var __decorate$6 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$6 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var HideUnchangedRegionsFeature_1;
/**
* Make sure to add the view zones to the editor!
*/
var HideUnchangedRegionsFeature = class HideUnchangedRegionsFeature extends Disposable {
	static {
		HideUnchangedRegionsFeature_1 = this;
	}
	static {
		this._breadcrumbsSourceFactory = observableValue(this, () => ({
			dispose() {},
			getBreadcrumbItems(startRange, reader) {
				return [];
			},
			getAt: () => []
		}));
	}
	static setBreadcrumbsSourceFactory(factory) {
		this._breadcrumbsSourceFactory.set(factory, void 0);
	}
	get isUpdatingHiddenAreas() {
		return this._isUpdatingHiddenAreas;
	}
	constructor(_editors, _diffModel, _options, _runWithOriginalEditorScrollAnchor, _runWithModifiedEditorScrollAnchor, _variant, _instantiationService) {
		super();
		this._editors = _editors;
		this._diffModel = _diffModel;
		this._options = _options;
		this._runWithOriginalEditorScrollAnchor = _runWithOriginalEditorScrollAnchor;
		this._runWithModifiedEditorScrollAnchor = _runWithModifiedEditorScrollAnchor;
		this._variant = _variant;
		this._instantiationService = _instantiationService;
		this._modifiedOutlineSource = derivedDisposable(this, (reader) => {
			const m = this._editors.modifiedModel.read(reader);
			const factory = HideUnchangedRegionsFeature_1._breadcrumbsSourceFactory.read(reader);
			return !m || !factory ? void 0 : factory(m, this._instantiationService);
		});
		this._isUpdatingHiddenAreas = false;
		this._register(this._editors.original.onDidChangeCursorPosition((e) => {
			if (e.reason === 1) return;
			const m = this._diffModel.get();
			transaction((tx) => {
				for (const s of this._editors.original.getSelections() || []) {
					m?.ensureOriginalLineIsVisible(s.getStartPosition().lineNumber, 0, tx);
					m?.ensureOriginalLineIsVisible(s.getEndPosition().lineNumber, 0, tx);
				}
			});
		}));
		this._register(this._editors.modified.onDidChangeCursorPosition((e) => {
			if (e.reason === 1) return;
			const m = this._diffModel.get();
			transaction((tx) => {
				for (const s of this._editors.modified.getSelections() || []) {
					m?.ensureModifiedLineIsVisible(s.getStartPosition().lineNumber, 0, tx);
					m?.ensureModifiedLineIsVisible(s.getEndPosition().lineNumber, 0, tx);
				}
			});
		}));
		const unchangedRegions = this._diffModel.map((m, reader) => {
			const regions = m?.unchangedRegions.read(reader) ?? [];
			if (regions.length === 1 && regions[0].modifiedLineNumber === 1 && regions[0].lineCount === this._editors.modifiedModel.read(reader)?.getLineCount()) return [];
			return regions;
		});
		this.viewZones = derived(this, (reader) => {
			/** @description view Zones */
			const modifiedOutlineSource = this._modifiedOutlineSource.read(reader);
			if (!modifiedOutlineSource) return {
				origViewZones: [],
				modViewZones: []
			};
			const origViewZones = [];
			const modViewZones = [];
			const sideBySide = this._options.renderSideBySide.read(reader);
			const compactControl = this._variant === "compact";
			const compactMode = !compactControl && this._options.compactMode.read(reader);
			const curUnchangedRegions = unchangedRegions.read(reader);
			for (let i = 0; i < curUnchangedRegions.length; i++) {
				const r = curUnchangedRegions[i];
				if (!compactControl && r.shouldHideControls(reader)) continue;
				if (compactMode && (i === 0 || i === curUnchangedRegions.length - 1)) continue;
				if (compactMode) {
					{
						const origVz = new PlaceholderViewZone(derived(this, (reader) => r.getHiddenOriginalRange(reader).startLineNumber - 1), 12);
						origViewZones.push(origVz);
						reader.store.add(new CompactCollapsedCodeOverlayWidget(this._editors.original, origVz, r, !sideBySide));
					}
					{
						const modViewZone = new PlaceholderViewZone(derived(this, (reader) => r.getHiddenModifiedRange(reader).startLineNumber - 1), 12);
						modViewZones.push(modViewZone);
						reader.store.add(new CompactCollapsedCodeOverlayWidget(this._editors.modified, modViewZone, r));
					}
				} else {
					{
						const origVz = new PlaceholderViewZone(derived(this, (reader) => r.getHiddenOriginalRange(reader).startLineNumber - 1), compactControl ? 40 : 24);
						origViewZones.push(origVz);
						reader.store.add(this._instantiationService.createInstance(CollapsedCodeOverlayWidget, this._editors.original, origVz, r, r.originalUnchangedRange, !sideBySide, modifiedOutlineSource, (l) => this._diffModel.get().ensureModifiedLineIsVisible(l, 2, void 0), this._options, this._runWithOriginalEditorScrollAnchor, compactControl));
					}
					{
						const modViewZone = new PlaceholderViewZone(derived(this, (reader) => r.getHiddenModifiedRange(reader).startLineNumber - 1), compactControl ? 40 : 24);
						modViewZones.push(modViewZone);
						reader.store.add(this._instantiationService.createInstance(CollapsedCodeOverlayWidget, this._editors.modified, modViewZone, r, r.modifiedUnchangedRange, false, modifiedOutlineSource, (l) => this._diffModel.get().ensureModifiedLineIsVisible(l, 2, void 0), this._options, this._runWithModifiedEditorScrollAnchor, compactControl));
					}
				}
			}
			return {
				origViewZones,
				modViewZones
			};
		});
		const unchangedLinesDecoration = {
			description: "unchanged lines",
			className: "diff-unchanged-lines",
			isWholeLine: true
		};
		const unchangedLinesDecorationShow = {
			description: "Fold Unchanged",
			glyphMarginHoverMessage: new MarkdownString(void 0, {
				isTrusted: true,
				supportThemeIcons: true
			}).appendMarkdown(localize(139, "Fold Unchanged Region")),
			glyphMarginClassName: "fold-unchanged " + ThemeIcon.asClassName(Codicon.fold),
			zIndex: 10001
		};
		this._register(applyObservableDecorations(this._editors.original, derived(this, (reader) => {
			/** @description decorations */
			const curUnchangedRegions = unchangedRegions.read(reader);
			const result = curUnchangedRegions.map((r) => ({
				range: r.originalUnchangedRange.toInclusiveRange(),
				options: unchangedLinesDecoration
			}));
			for (const r of curUnchangedRegions) if (this._variant !== "compact" && r.shouldHideControls(reader)) result.push({
				range: Range$2.fromPositions(new Position$1(r.originalLineNumber, 1)),
				options: unchangedLinesDecorationShow
			});
			return result;
		})));
		this._register(applyObservableDecorations(this._editors.modified, derived(this, (reader) => {
			/** @description decorations */
			const curUnchangedRegions = unchangedRegions.read(reader);
			const result = curUnchangedRegions.map((r) => ({
				range: r.modifiedUnchangedRange.toInclusiveRange(),
				options: unchangedLinesDecoration
			}));
			for (const r of curUnchangedRegions) if (this._variant !== "compact" && r.shouldHideControls(reader)) result.push({
				range: LineRange.ofLength(r.modifiedLineNumber, 1).toInclusiveRange(),
				options: unchangedLinesDecorationShow
			});
			return result;
		})));
		this._register(autorun((reader) => {
			/** @description update folded unchanged regions */
			const curUnchangedRegions = unchangedRegions.read(reader);
			this._isUpdatingHiddenAreas = true;
			try {
				this._editors.original.setHiddenAreas(curUnchangedRegions.map((r) => r.getHiddenOriginalRange(reader).toInclusiveRange()).filter(isDefined));
				this._editors.modified.setHiddenAreas(curUnchangedRegions.map((r) => r.getHiddenModifiedRange(reader).toInclusiveRange()).filter(isDefined));
			} finally {
				this._isUpdatingHiddenAreas = false;
			}
		}));
		this._register(this._editors.modified.onMouseUp((event) => {
			if (!event.event.rightButton && event.target.position && event.target.element?.className.includes("fold-unchanged")) {
				const lineNumber = event.target.position.lineNumber;
				const model = this._diffModel.get();
				if (!model) return;
				const region = model.unchangedRegions.get().find((r) => r.modifiedUnchangedRange.contains(lineNumber));
				if (!region) return;
				region.collapseAll(void 0);
				event.event.stopPropagation();
				event.event.preventDefault();
			}
		}));
		this._register(this._editors.original.onMouseUp((event) => {
			if (!event.event.rightButton && event.target.position && event.target.element?.className.includes("fold-unchanged")) {
				const lineNumber = event.target.position.lineNumber;
				const model = this._diffModel.get();
				if (!model) return;
				const region = model.unchangedRegions.get().find((r) => r.originalUnchangedRange.contains(lineNumber));
				if (!region) return;
				region.collapseAll(void 0);
				event.event.stopPropagation();
				event.event.preventDefault();
			}
		}));
	}
};
HideUnchangedRegionsFeature = HideUnchangedRegionsFeature_1 = __decorate$6([__param$6(6, IInstantiationService)], HideUnchangedRegionsFeature);
var CompactCollapsedCodeOverlayWidget = class extends ViewZoneOverlayWidget {
	constructor(editor, _viewZone, _unchangedRegion, _hide = false) {
		const root = h("div.diff-hidden-lines-widget");
		super(editor, _viewZone, root.root);
		this._unchangedRegion = _unchangedRegion;
		this._hide = _hide;
		this._nodes = h("div.diff-hidden-lines-compact", [
			h("div.line-left", []),
			h("div.text@text", []),
			h("div.line-right", [])
		]);
		root.root.appendChild(this._nodes.root);
		if (this._hide) this._nodes.root.replaceChildren();
		this._register(autorun((reader) => {
			/** @description update labels */
			if (!this._hide) {
				const lineCount = this._unchangedRegion.getHiddenModifiedRange(reader).length;
				const linesHiddenText = localize(140, "{0} hidden lines", lineCount);
				this._nodes.text.innerText = linesHiddenText;
			}
		}));
	}
};
var CollapsedCodeOverlayWidget = class CollapsedCodeOverlayWidget extends ViewZoneOverlayWidget {
	constructor(_editor, _viewZone, _unchangedRegion, _unchangedRegionRange, _hide, _modifiedOutlineSource, _revealModifiedHiddenLine, _options, _runWithScrollAnchor, _compactControl, _hoverService) {
		const root = h("div.diff-hidden-lines-widget");
		super(_editor, _viewZone, root.root);
		this._editor = _editor;
		this._unchangedRegion = _unchangedRegion;
		this._unchangedRegionRange = _unchangedRegionRange;
		this._hide = _hide;
		this._modifiedOutlineSource = _modifiedOutlineSource;
		this._revealModifiedHiddenLine = _revealModifiedHiddenLine;
		this._options = _options;
		this._runWithScrollAnchor = _runWithScrollAnchor;
		this._compactControl = _compactControl;
		this._hoverService = _hoverService;
		this._nodes = h("div.diff-hidden-lines", [
			h("div.top@top", { title: localize(141, "Click or drag to show more above") }),
			h("div.center@content", { style: { display: "flex" } }, [
				h("div.disclosure-toggle@toggle"),
				h("div.first@first", { style: {
					display: "flex",
					alignItems: "center",
					flexShrink: "0"
				} }, [h("span.line-number-control@lineNumberControl", { "aria-hidden": "true" }), $$10("a.default-control", {
					title: localize(142, "Show Unchanged Region"),
					role: "button",
					onclick: () => {
						this._unchangedRegion.showAll(void 0);
					}
				}, ...renderLabelWithIcons("$(unfold)"))]),
				h("div.content-row@others", { style: {
					display: "flex",
					justifyContent: "center",
					alignItems: "center"
				} })
			]),
			h("div.bottom@bottom", {
				title: localize(143, "Click or drag to show more below"),
				role: "button"
			})
		]);
		root.root.appendChild(this._nodes.root);
		this._nodes.root.classList.toggle("diff-hidden-lines-disclosure", this._compactControl);
		if (!this._hide) {
			const editorLayout = observableCodeEditor(this._editor);
			this._register(applyStyle(this._nodes.first, { width: editorLayout.layoutInfoContentLeft }));
			if (this._compactControl) this._register(autorun((reader) => {
				const layoutInfo = editorLayout.layoutInfo.read(reader);
				this._nodes.lineNumberControl.style.left = `${layoutInfo.lineNumbersLeft}px`;
				this._nodes.lineNumberControl.style.width = `${layoutInfo.lineNumbersWidth}px`;
			}));
		} else reset(this._nodes.first);
		if (this._compactControl && !this._hide) {
			this._nodes.toggle.tabIndex = 0;
			this._nodes.toggle.setAttribute("role", "button");
			this._register(this._hoverService.setupDelayedHover(this._nodes.toggle, () => ({ content: this._nodes.toggle.getAttribute("aria-label") })));
			this._register(addDisposableListener(this._nodes.toggle, EventType$1.CLICK, () => this._toggleAll()));
			this._register(addDisposableListener(this._nodes.toggle, EventType$1.KEY_DOWN, (e) => {
				if (e.key === "Enter" || e.key === " ") {
					e.preventDefault();
					e.stopPropagation();
					if (!e.repeat) this._toggleAll();
				}
			}));
		}
		this._register(autorun((reader) => {
			/** @description Update CollapsedCodeOverlayWidget canMove* css classes */
			const isFullyRevealed = this._unchangedRegion.visibleLineCountTop.read(reader) + this._unchangedRegion.visibleLineCountBottom.read(reader) === this._unchangedRegion.lineCount;
			if (this._compactControl && !this._hide) {
				const actionLabel = isFullyRevealed ? localize(144, "Collapse unchanged lines") : localize(145, "Show {0} hidden lines", this._unchangedRegion.getHiddenModifiedRange(reader).length);
				this._nodes.toggle.setAttribute("aria-expanded", String(isFullyRevealed));
				this._nodes.toggle.setAttribute("aria-label", actionLabel);
				reset(this._nodes.lineNumberControl, ...renderLabelWithIcons(isFullyRevealed ? "$(fold)" : "$(unfold)"));
			}
			this._nodes.bottom.classList.toggle("canMoveTop", !isFullyRevealed);
			this._nodes.bottom.classList.toggle("canMoveBottom", this._unchangedRegion.visibleLineCountBottom.read(reader) > 0);
			this._nodes.top.classList.toggle("canMoveTop", this._unchangedRegion.visibleLineCountTop.read(reader) > 0);
			this._nodes.top.classList.toggle("canMoveBottom", !isFullyRevealed);
			const isDragged = this._unchangedRegion.isDragged.read(reader);
			const domNode = this._editor.getDomNode();
			if (domNode) {
				domNode.classList.toggle("draggingUnchangedRegion", !!isDragged);
				if (isDragged === "top") {
					domNode.classList.toggle("canMoveTop", this._unchangedRegion.visibleLineCountTop.read(reader) > 0);
					domNode.classList.toggle("canMoveBottom", !isFullyRevealed);
				} else if (isDragged === "bottom") {
					domNode.classList.toggle("canMoveTop", !isFullyRevealed);
					domNode.classList.toggle("canMoveBottom", this._unchangedRegion.visibleLineCountBottom.read(reader) > 0);
				} else {
					domNode.classList.toggle("canMoveTop", false);
					domNode.classList.toggle("canMoveBottom", false);
				}
			}
		}));
		const editor = this._editor;
		this._register(addDisposableListener(this._nodes.top, "mousedown", (e) => {
			if (e.button !== 0) return;
			this._nodes.top.classList.toggle("dragging", true);
			this._nodes.root.classList.toggle("dragging", true);
			e.preventDefault();
			const startTop = e.clientY;
			let didMove = false;
			const cur = this._unchangedRegion.visibleLineCountTop.get();
			this._unchangedRegion.isDragged.set("top", void 0);
			const window = getWindow(this._nodes.top);
			const mouseMoveListener = addDisposableListener(window, "mousemove", (e) => {
				const delta = e.clientY - startTop;
				didMove = didMove || Math.abs(delta) > 2;
				const lineDelta = Math.round(delta / editor.getOption(75));
				const newVal = Math.max(0, Math.min(cur + lineDelta, this._unchangedRegion.getMaxVisibleLineCountTop()));
				this._unchangedRegion.visibleLineCountTop.set(newVal, void 0);
			});
			const mouseUpListener = addDisposableListener(window, "mouseup", (e) => {
				if (!didMove) {
					if (this._compactControl && this._isFullyRevealed()) this._unchangedRegion.collapseAll(void 0);
					else this._unchangedRegion.showMoreAbove(this._options.hideUnchangedRegionsRevealLineCount.get(), void 0);
				}
				this._nodes.top.classList.toggle("dragging", false);
				this._nodes.root.classList.toggle("dragging", false);
				this._unchangedRegion.isDragged.set(void 0, void 0);
				mouseMoveListener.dispose();
				mouseUpListener.dispose();
			});
		}));
		this._register(addDisposableListener(this._nodes.bottom, "mousedown", (e) => {
			if (e.button !== 0) return;
			this._nodes.bottom.classList.toggle("dragging", true);
			this._nodes.root.classList.toggle("dragging", true);
			e.preventDefault();
			const startTop = e.clientY;
			let didMove = false;
			const cur = this._unchangedRegion.visibleLineCountBottom.get();
			this._unchangedRegion.isDragged.set("bottom", void 0);
			const window = getWindow(this._nodes.bottom);
			const mouseMoveListener = addDisposableListener(window, "mousemove", (e) => {
				const delta = e.clientY - startTop;
				didMove = didMove || Math.abs(delta) > 2;
				const lineDelta = Math.round(delta / editor.getOption(75));
				const newVal = Math.max(0, Math.min(cur - lineDelta, this._unchangedRegion.getMaxVisibleLineCountBottom()));
				if (newVal === this._unchangedRegion.visibleLineCountBottom.get()) return;
				this._runWithLowerScrollAnchor(() => this._unchangedRegion.visibleLineCountBottom.set(newVal, void 0));
			});
			const mouseUpListener = addDisposableListener(window, "mouseup", (e) => {
				this._unchangedRegion.isDragged.set(void 0, void 0);
				if (!didMove) {
					if (this._compactControl && this._isFullyRevealed()) this._unchangedRegion.collapseAll(void 0);
					else this._runWithLowerScrollAnchor(() => this._unchangedRegion.showMoreBelow(this._options.hideUnchangedRegionsRevealLineCount.get(), void 0));
				}
				this._nodes.bottom.classList.toggle("dragging", false);
				this._nodes.root.classList.toggle("dragging", false);
				mouseMoveListener.dispose();
				mouseUpListener.dispose();
			});
		}));
		this._register(autorun((reader) => {
			/** @description update labels */
			const children = [];
			if (!this._hide) {
				const isFullyRevealed = this._isFullyRevealed(reader);
				const lineCount = _unchangedRegion.getHiddenModifiedRange(reader).length;
				const linesHiddenText = localize(146, "{0} hidden lines", lineCount);
				const span = $$10("span", this._compactControl ? void 0 : { title: localize(147, "Double click to unfold") }, this._compactControl && isFullyRevealed ? localize(148, "Collapse unchanged lines") : linesHiddenText);
				if (!this._compactControl) reader.store.add(addDisposableListener(span, EventType$1.DBLCLICK, (e) => {
					if (e.button !== 0) return;
					e.preventDefault();
					this._unchangedRegion.showAll(void 0);
				}));
				children.push(span);
				const range = this._unchangedRegion.getHiddenModifiedRange(reader);
				const items = isFullyRevealed ? [] : this._modifiedOutlineSource.getBreadcrumbItems(range, reader);
				if (items.length > 0) {
					children.push($$10("span", void 0, this._compactControl ? "\xA0·\xA0" : "\xA0\xA0|\xA0\xA0"));
					for (let i = 0; i < items.length; i++) {
						const item = items[i];
						const divItem = h("div.breadcrumb-item", { style: {
							display: "flex",
							alignItems: "center"
						} }, [
							renderIcon(SymbolKinds.toIcon(item.kind)),
							"\xA0",
							h("span.breadcrumb-label", [item.name]).root,
							...i === items.length - 1 ? [] : [renderIcon(Codicon.chevronRight)]
						]).root;
						children.push(divItem);
						const revealBreadcrumb = (event) => {
							event.stopPropagation();
							this._revealModifiedHiddenLine(item.startLineNumber);
						};
						reader.store.add(addDisposableListener(divItem, EventType$1.CLICK, revealBreadcrumb));
						if (this._compactControl) {
							const label = localize(149, "Go to {0}", item.name);
							divItem.tabIndex = 0;
							divItem.setAttribute("role", "button");
							divItem.setAttribute("aria-label", label);
							reader.store.add(this._hoverService.setupDelayedHover(divItem, { content: label }));
							reader.store.add(addDisposableListener(divItem, EventType$1.KEY_DOWN, (e) => {
								if (e.key === "Enter" || e.key === " ") {
									e.preventDefault();
									revealBreadcrumb(e);
								}
							}));
						}
					}
				}
			}
			if (this._compactControl && children.length > 0) {
				const content = h("div.disclosure-content", children).root;
				reader.store.add(this._hoverService.setupDelayedHover(content, { content: content.textContent ?? "" }));
				reset(this._nodes.others, h("div.line-left").root, content, h("div.line-right").root);
			} else reset(this._nodes.others, ...children);
		}));
	}
	_toggleAll() {
		if (this._isFullyRevealed()) this._unchangedRegion.collapseAll(void 0);
		else this._unchangedRegion.showAll(void 0);
	}
	_isFullyRevealed(reader) {
		return this._unchangedRegion.visibleLineCountTop.read(reader) + this._unchangedRegion.visibleLineCountBottom.read(reader) === this._unchangedRegion.lineCount;
	}
	_runWithLowerScrollAnchor(update) {
		const anchorLineNumber = this._unchangedRegionRange.endLineNumberExclusive;
		if (this._runWithScrollAnchor) {
			this._runWithScrollAnchor(anchorLineNumber, update);
			return;
		}
		const scrollTop = this._editor.getScrollTop();
		const top = this._getTopForLineNumber(anchorLineNumber);
		update();
		this._editor.setScrollTop(scrollTop + this._getTopForLineNumber(anchorLineNumber) - top);
	}
	_getTopForLineNumber(lineNumber) {
		return lineNumber > this._editor.getModel().getLineCount() ? this._editor.getContentHeight() : this._editor.getTopForLineNumber(lineNumber);
	}
};
CollapsedCodeOverlayWidget = __decorate$6([__param$6(10, IHoverService)], CollapsedCodeOverlayWidget);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/diffEditor/features/revertButtonsFeature.js
var emptyArr = [];
var RevertButtonsFeature = class extends Disposable {
	constructor(_editors, _diffModel, _options, _widget) {
		super();
		this._editors = _editors;
		this._diffModel = _diffModel;
		this._options = _options;
		this._widget = _widget;
		this._selectedDiffs = derived(this, (reader) => {
			const diff = this._diffModel.read(reader)?.diff.read(reader);
			if (!diff) return emptyArr;
			const selections = this._editors.modifiedSelections.read(reader);
			if (selections.every((s) => s.isEmpty())) return emptyArr;
			const selectedLineNumbers = new LineRangeSet(selections.map((s) => LineRange.fromRangeInclusive(s)));
			const result = diff.mappings.filter((m) => m.lineRangeMapping.innerChanges && selectedLineNumbers.intersects(m.lineRangeMapping.modified)).map((mapping) => ({
				mapping,
				rangeMappings: mapping.lineRangeMapping.innerChanges.filter((c) => selections.some((s) => Range$2.areIntersecting(c.modifiedRange, s)))
			}));
			if (result.length === 0 || result.every((r) => r.rangeMappings.length === 0)) return emptyArr;
			return result;
		});
		this._register(autorunWithStore((reader, store) => {
			if (!this._options.shouldRenderOldRevertArrows.read(reader)) return;
			const model = this._diffModel.read(reader);
			const diff = model?.diff.read(reader);
			if (!model || !diff) return;
			if (model.movedTextToCompare.read(reader)) return;
			const glyphWidgetsModified = [];
			const selectedDiffs = this._selectedDiffs.read(reader);
			const selectedDiffsSet = new Set(selectedDiffs.map((d) => d.mapping));
			if (selectedDiffs.length > 0) {
				const selections = this._editors.modifiedSelections.read(reader);
				const btn = store.add(new RevertButton(selections[selections.length - 1].positionLineNumber, this._widget, selectedDiffs.flatMap((d) => d.rangeMappings), true));
				this._editors.modified.addGlyphMarginWidget(btn);
				glyphWidgetsModified.push(btn);
			}
			for (const m of diff.mappings) {
				if (selectedDiffsSet.has(m)) continue;
				if (!m.lineRangeMapping.modified.isEmpty && m.lineRangeMapping.innerChanges) {
					const btn = store.add(new RevertButton(m.lineRangeMapping.modified.startLineNumber, this._widget, m.lineRangeMapping, false));
					this._editors.modified.addGlyphMarginWidget(btn);
					glyphWidgetsModified.push(btn);
				}
			}
			store.add(toDisposable(() => {
				for (const w of glyphWidgetsModified) this._editors.modified.removeGlyphMarginWidget(w);
			}));
		}));
	}
};
var RevertButton = class RevertButton extends Disposable {
	static {
		this.counter = 0;
	}
	getId() {
		return this._id;
	}
	constructor(_lineNumber, _widget, _diffs, _revertSelection) {
		super();
		this._lineNumber = _lineNumber;
		this._widget = _widget;
		this._diffs = _diffs;
		this._revertSelection = _revertSelection;
		this._id = `revertButton${RevertButton.counter++}`;
		this._domNode = h("div.revertButton", { title: this._revertSelection ? localize(154, "Revert Selected Changes") : localize(155, "Revert Change") }, [renderIcon(Codicon.arrowRight)]).root;
		this._register(addDisposableListener(this._domNode, EventType$1.MOUSE_DOWN, (e) => {
			if (e.button !== 2) {
				e.stopPropagation();
				e.preventDefault();
			}
		}));
		this._register(addDisposableListener(this._domNode, EventType$1.MOUSE_UP, (e) => {
			e.stopPropagation();
			e.preventDefault();
		}));
		this._register(addDisposableListener(this._domNode, EventType$1.CLICK, (e) => {
			if (this._diffs instanceof LineRangeMapping) this._widget.revert(this._diffs);
			else this._widget.revertRangeMappings(this._diffs);
			e.stopPropagation();
			e.preventDefault();
		}));
	}
	/**
	* Get the dom node of the glyph widget.
	*/
	getDomNode() {
		return this._domNode;
	}
	/**
	* Get the placement of the glyph widget.
	*/
	getPosition() {
		return {
			lane: GlyphMarginLane.Right,
			range: {
				startColumn: 1,
				startLineNumber: this._lineNumber,
				endColumn: 1,
				endLineNumber: this._lineNumber
			},
			zIndex: 10001
		};
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/diffEditor/diffEditorWidget.js
var __decorate$5 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$5 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var DiffEditorWidget = class DiffEditorWidget extends DelegatingEditor {
	get onDidContentSizeChange() {
		return this._editors.onDidContentSizeChange;
	}
	constructor(_domElement, options, codeEditorWidgetOptions, _parentContextKeyService, _parentInstantiationService, _codeEditorService, _accessibilitySignalService, _editorProgressService) {
		super();
		this._domElement = _domElement;
		this._parentContextKeyService = _parentContextKeyService;
		this._parentInstantiationService = _parentInstantiationService;
		this._codeEditorService = _codeEditorService;
		this._accessibilitySignalService = _accessibilitySignalService;
		this._editorProgressService = _editorProgressService;
		this._deferredDiffModelRefDisposals = this._register(new DisposableStore());
		this.elements = h("div.monaco-diff-editor.side-by-side", { style: {
			position: "relative",
			height: "100%"
		} }, [
			h("div.editor.original@original", { style: {
				position: "absolute",
				height: "100%"
			} }),
			h("div.editor.modified@modified", { style: {
				position: "absolute",
				height: "100%"
			} }),
			h("div.accessibleDiffViewer@accessibleDiffViewer", { style: {
				position: "absolute",
				height: "100%"
			} })
		]);
		this._diffModelSrc = this._register(disposableObservableValue(this, void 0));
		this._diffModel = derived(this, (reader) => this._diffModelSrc.read(reader)?.object);
		this.allUnchangedRegionsShown = derived(this, (reader) => {
			return (this._diffModel.read(reader)?.unchangedRegions.read(reader) ?? []).every((r) => r.visibleLineCountTop.read(reader) + r.visibleLineCountBottom.read(reader) >= r.lineCount);
		});
		this.onDidChangeModel = Event.fromObservableLight(this._diffModel);
		this._contextKeyService = this._register(this._parentContextKeyService.createScoped(this._domElement));
		this._instantiationService = this._register(this._parentInstantiationService.createChild(new ServiceCollection([IContextKeyService, this._contextKeyService])));
		this._boundarySashes = observableValue(this, void 0);
		this._accessibleDiffViewerShouldBeVisible = observableValue(this, false);
		this._accessibleDiffViewerVisible = derived(this, (reader) => this._options.onlyShowAccessibleDiffViewer.read(reader) ? true : this._accessibleDiffViewerShouldBeVisible.read(reader));
		this._movedBlocksLinesPart = observableValue(this, void 0);
		this._layoutInfo = derived(this, (reader) => {
			const fullWidth = this._rootSizeObserver.width.read(reader);
			const fullHeight = this._rootSizeObserver.height.read(reader);
			if (this._rootSizeObserver.automaticLayout) this.elements.root.style.height = "100%";
			else this.elements.root.style.height = fullHeight + "px";
			const sash = this._sash.read(reader);
			const gutter = this._gutter.read(reader);
			const gutterWidth = gutter?.width.read(reader) ?? 0;
			const overviewRulerPartWidth = this._overviewRulerPart.read(reader)?.width ?? 0;
			let originalLeft, originalWidth, modifiedLeft, modifiedWidth, gutterLeft;
			if (!!sash) {
				const sashLeft = sash.sashLeft.read(reader);
				const movedBlocksLinesWidth = this._movedBlocksLinesPart.read(reader)?.width.read(reader) ?? 0;
				originalLeft = 0;
				originalWidth = sashLeft - gutterWidth - movedBlocksLinesWidth;
				gutterLeft = sashLeft - gutterWidth;
				modifiedLeft = sashLeft;
				modifiedWidth = fullWidth - modifiedLeft - overviewRulerPartWidth;
			} else {
				gutterLeft = 0;
				const shouldHideOriginalLineNumbers = this._options.inlineViewHideOriginalLineNumbers.read(reader);
				originalLeft = gutterWidth;
				if (shouldHideOriginalLineNumbers) originalWidth = 0;
				else originalWidth = Math.max(5, this._editors.originalObs.layoutInfoDecorationsLeft.read(reader));
				modifiedLeft = gutterWidth + originalWidth;
				modifiedWidth = fullWidth - modifiedLeft - overviewRulerPartWidth;
			}
			this.elements.original.style.left = originalLeft + "px";
			this.elements.original.style.width = originalWidth + "px";
			this._editors.original.layout({
				width: originalWidth,
				height: fullHeight
			}, true);
			gutter?.layout(gutterLeft);
			this.elements.modified.style.left = modifiedLeft + "px";
			this.elements.modified.style.width = modifiedWidth + "px";
			this._editors.modified.layout({
				width: modifiedWidth,
				height: fullHeight
			}, true);
			return {
				modifiedEditor: this._editors.modified.getLayoutInfo(),
				originalEditor: this._editors.original.getLayoutInfo()
			};
		});
		this._diffValue = this._diffModel.map((m, r) => m?.diff.read(r));
		this.onDidUpdateDiff = Event.fromObservableLight(this._diffValue);
		this._codeEditorService.willCreateDiffEditor();
		this._contextKeyService.createKey("isInDiffEditor", true);
		this._domElement.appendChild(this.elements.root);
		this._register(toDisposable(() => this.elements.root.remove()));
		this._rootSizeObserver = this._register(new ObservableElementSizeObserver(this.elements.root, options.dimension));
		this._rootSizeObserver.setAutomaticLayout(options.automaticLayout ?? false);
		this._options = this._instantiationService.createInstance(DiffEditorOptions, options);
		let lastWidth;
		let resizeStartWidth;
		let windowResizeEventCount = 0;
		let resizeWasPointerDriven = false;
		let pointerDown = false;
		const finishSmoothResize = () => {
			if (pointerDown) {
				smoothResizeScheduler.schedule();
				return;
			}
			resizeStartWidth = void 0;
			windowResizeEventCount = 0;
			resizeWasPointerDriven = false;
		};
		const smoothResizeScheduler = this._register(new RunOnceScheduler(finishSmoothResize, 200));
		const targetWindow = getWindow(this._domElement);
		this._register(addDisposableListener(targetWindow, "resize", () => {
			windowResizeEventCount++;
			smoothResizeScheduler.schedule();
		}));
		const onPointerDown = () => pointerDown = true;
		const onPointerUp = () => {
			if (!pointerDown) return;
			pointerDown = false;
			smoothResizeScheduler.cancel();
			finishSmoothResize();
		};
		this._register(addDisposableListener(targetWindow, "mousedown", onPointerDown, true));
		this._register(addDisposableListener(targetWindow, "mouseup", onPointerUp, true));
		this._register(addDisposableListener(targetWindow, "touchstart", onPointerDown, true));
		this._register(addDisposableListener(targetWindow, "touchend", onPointerUp, true));
		this._register(addDisposableListener(targetWindow, "touchcancel", onPointerUp, true));
		this._register(autorun((reader) => {
			const width = this._rootSizeObserver.width.read(reader);
			let smoothResizeStartWidth;
			if (lastWidth !== void 0 && width !== lastWidth) {
				if (resizeStartWidth === void 0) resizeStartWidth = lastWidth;
				resizeWasPointerDriven ||= pointerDown;
				if (resizeStartWidth !== void 0 && (resizeWasPointerDriven || windowResizeEventCount > 1)) smoothResizeStartWidth = resizeStartWidth;
				smoothResizeScheduler.schedule();
			}
			this._options.setWidth(width, smoothResizeStartWidth);
			lastWidth = width;
		}));
		this._contextKeyService.createKey(EditorContextKeys.isEmbeddedDiffEditor.key, false);
		this._register(bindContextKey(EditorContextKeys.isEmbeddedDiffEditor, this._contextKeyService, (reader) => this._options.isInEmbeddedEditor.read(reader)));
		this._register(bindContextKey(EditorContextKeys.comparingMovedCode, this._contextKeyService, (reader) => !!this._diffModel.read(reader)?.movedTextToCompare.read(reader)));
		this._register(bindContextKey(EditorContextKeys.diffEditorRenderSideBySideInlineBreakpointReached, this._contextKeyService, (reader) => this._options.couldShowInlineViewBecauseOfSize.read(reader)));
		this._register(bindContextKey(EditorContextKeys.diffEditorInlineMode, this._contextKeyService, (reader) => !this._options.renderSideBySide.read(reader)));
		this._register(bindContextKey(EditorContextKeys.diffEditorTemporaryInlineMode, this._contextKeyService, (reader) => this._options.temporaryInlineMode.read(reader)));
		this._register(bindContextKey(EditorContextKeys.diffEditorAutomaticRenderSideBySide, this._contextKeyService, (reader) => this._options.renderSideBySideInAutomaticMode.read(reader)));
		this._register(bindContextKey(EditorContextKeys.hasChanges, this._contextKeyService, (reader) => (this._diffModel.read(reader)?.diff.read(reader)?.mappings.length ?? 0) > 0));
		this._editors = this._register(this._instantiationService.createInstance(DiffEditorEditors, this.elements.original, this.elements.modified, this._options, codeEditorWidgetOptions, (i, c, o, o2) => this._createInnerEditor(i, c, o, o2)));
		this._register(bindContextKey(EditorContextKeys.diffEditorOriginalWritable, this._contextKeyService, (reader) => this._options.originalEditable.read(reader)));
		this._register(bindContextKey(EditorContextKeys.diffEditorModifiedWritable, this._contextKeyService, (reader) => !this._options.readOnly.read(reader)));
		this._register(bindContextKey(EditorContextKeys.diffEditorOriginalUri, this._contextKeyService, (reader) => this._diffModel.read(reader)?.model.original.uri.toString() ?? ""));
		this._register(bindContextKey(EditorContextKeys.diffEditorModifiedUri, this._contextKeyService, (reader) => this._diffModel.read(reader)?.model.modified.uri.toString() ?? ""));
		this._overviewRulerPart = derivedDisposable(this, (reader) => !this._options.renderOverviewRuler.read(reader) ? void 0 : this._instantiationService.createInstance(readHotReloadableExport(OverviewRulerFeature), this._editors, this.elements.root, this._diffModel, this._rootSizeObserver.width, this._rootSizeObserver.height, this._layoutInfo.map((i) => i.modifiedEditor))).recomputeInitiallyAndOnChange(this._store);
		const dimensions = {
			height: this._rootSizeObserver.height,
			width: this._rootSizeObserver.width.map((w, reader) => w - (this._overviewRulerPart.read(reader)?.width ?? 0))
		};
		this._sashLayout = new SashLayout(this._options, dimensions);
		this._sash = derivedDisposable(this, (reader) => {
			const showSash = this._options.renderSideBySide.read(reader);
			this.elements.root.classList.toggle("side-by-side", showSash);
			return !showSash ? void 0 : new DiffEditorSash(this.elements.root, dimensions, this._options.enableSplitViewResizing, this._boundarySashes, this._sashLayout.sashLeft, () => this._sashLayout.resetSash());
		}).recomputeInitiallyAndOnChange(this._store);
		const unchangedRangesFeature = derivedDisposable(this, (reader) => this._instantiationService.createInstance(readHotReloadableExport(HideUnchangedRegionsFeature), this._editors, this._diffModel, this._options, codeEditorWidgetOptions.runWithOriginalEditorScrollAnchor, codeEditorWidgetOptions.runWithModifiedEditorScrollAnchor, codeEditorWidgetOptions.variant ?? "default")).recomputeInitiallyAndOnChange(this._store);
		derivedDisposable(this, (reader) => this._instantiationService.createInstance(readHotReloadableExport(DiffEditorDecorations), this._editors, this._diffModel, this._options, this)).recomputeInitiallyAndOnChange(this._store);
		const origViewZoneIdsToIgnore = /* @__PURE__ */ new Set();
		const modViewZoneIdsToIgnore = /* @__PURE__ */ new Set();
		let isUpdatingViewZones = false;
		const viewZoneManager = derivedDisposable(this, (reader) => this._instantiationService.createInstance(readHotReloadableExport(DiffEditorViewZones), getWindow(this._domElement), this._editors, this._diffModel, this._options, this, () => isUpdatingViewZones || unchangedRangesFeature.read(void 0).isUpdatingHiddenAreas, origViewZoneIdsToIgnore, modViewZoneIdsToIgnore)).recomputeInitiallyAndOnChange(this._store);
		const originalViewZones = derived(this, (reader) => {
			const orig = viewZoneManager.read(reader).viewZones.read(reader).orig;
			const orig2 = unchangedRangesFeature.read(reader).viewZones.read(reader).origViewZones;
			return orig.concat(orig2);
		});
		const modifiedViewZones = derived(this, (reader) => {
			const mod = viewZoneManager.read(reader).viewZones.read(reader).mod;
			const mod2 = unchangedRangesFeature.read(reader).viewZones.read(reader).modViewZones;
			return mod.concat(mod2);
		});
		this._register(applyViewZones(this._editors.original, originalViewZones, (isUpdatingOrigViewZones) => {
			isUpdatingViewZones = isUpdatingOrigViewZones;
		}, origViewZoneIdsToIgnore));
		let scrollState;
		this._register(applyViewZones(this._editors.modified, modifiedViewZones, (isUpdatingModViewZones) => {
			isUpdatingViewZones = isUpdatingModViewZones;
			if (isUpdatingViewZones) scrollState = StableEditorScrollState.capture(this._editors.modified);
			else {
				scrollState?.restore(this._editors.modified);
				scrollState = void 0;
			}
		}, modViewZoneIdsToIgnore));
		this._accessibleDiffViewer = derivedDisposable(this, (reader) => this._instantiationService.createInstance(readHotReloadableExport(AccessibleDiffViewer), this.elements.accessibleDiffViewer, this._accessibleDiffViewerVisible, (visible, tx) => this._accessibleDiffViewerShouldBeVisible.set(visible, tx), this._options.onlyShowAccessibleDiffViewer.map((v) => !v), this._rootSizeObserver.width, this._rootSizeObserver.height, this._diffModel.map((m, r) => m?.diff.read(r)?.mappings.map((m) => m.lineRangeMapping)), new AccessibleDiffViewerModelFromEditors(this._editors))).recomputeInitiallyAndOnChange(this._store);
		const visibility = this._accessibleDiffViewerVisible.map((v) => v ? "hidden" : "visible");
		this._register(applyStyle(this.elements.modified, { visibility }));
		this._register(applyStyle(this.elements.original, { visibility }));
		this._createDiffEditorContributions();
		this._codeEditorService.addDiffEditor(this);
		this._register(toDisposable(() => {
			this._codeEditorService.removeDiffEditor(this);
		}));
		this._gutter = derivedDisposable(this, (reader) => {
			return this._options.shouldRenderGutterMenu.read(reader) ? this._instantiationService.createInstance(readHotReloadableExport(DiffEditorGutter), this.elements.root, this._diffModel, this._editors, this._options, this._sashLayout, this._boundarySashes) : void 0;
		});
		this._register(recomputeInitiallyAndOnChange(this._layoutInfo));
		derivedDisposable(this, (reader) => new (readHotReloadableExport(MovedBlocksLinesFeature))(this.elements.root, this._diffModel, this._layoutInfo.map((i) => i.originalEditor), this._layoutInfo.map((i) => i.modifiedEditor), this._editors)).recomputeInitiallyAndOnChange(this._store, (value) => {
			this._movedBlocksLinesPart.set(value, void 0);
		});
		this._register(Event.runAndSubscribe(this._editors.modified.onDidChangeCursorPosition, (e) => this._handleCursorPositionChange(e, true)));
		this._register(Event.runAndSubscribe(this._editors.original.onDidChangeCursorPosition, (e) => this._handleCursorPositionChange(e, false)));
		const isInitializingDiff = this._diffModel.map(this, (m, reader) => {
			/** @isInitializingDiff isDiffUpToDate */
			if (!m) return;
			return m.diff.read(reader) === void 0 && !m.isDiffUpToDate.read(reader);
		});
		this._register(autorunWithStore((reader, store) => {
			/** @description DiffEditorWidgetHelper.ShowProgress */
			if (isInitializingDiff.read(reader) === true) {
				const r = this._editorProgressService.show(true, 1e3);
				store.add(toDisposable(() => r.done()));
			}
		}));
		this._register(autorunWithStore((reader, store) => {
			store.add(new (readHotReloadableExport(RevertButtonsFeature))(this._editors, this._diffModel, this._options, this));
		}));
		this._register(autorunWithStore((reader, store) => {
			const model = this._diffModel.read(reader);
			if (!model) return;
			for (const m of [model.model.original, model.model.modified]) store.add(m.onWillDispose((e) => {
				onUnexpectedError(new BugIndicatingError("TextModel got disposed before DiffEditorWidget model got reset"));
				this.setModel(null);
			}));
		}));
		this._register(autorun((reader) => {
			this._options.setModel(this._diffModel.read(reader));
		}));
	}
	getContentHeight() {
		return this._editors.getContentHeight();
	}
	_createInnerEditor(instantiationService, container, options, editorWidgetOptions) {
		return instantiationService.createInstance(CodeEditorWidget, container, options, editorWidgetOptions);
	}
	_createDiffEditorContributions() {
		const contributions = EditorExtensionsRegistry.getDiffEditorContributions();
		for (const desc of contributions) try {
			this._register(this._instantiationService.createInstance(desc.ctor, this));
		} catch (err) {
			onUnexpectedError(err);
		}
	}
	get _targetEditor() {
		return this._editors.modified;
	}
	getEditorType() {
		return EditorType.IDiffEditor;
	}
	layout(dimension) {
		this._rootSizeObserver.observe(dimension);
	}
	hasTextFocus() {
		return this._editors.original.hasTextFocus() || this._editors.modified.hasTextFocus();
	}
	saveViewState() {
		return {
			original: this._editors.original.saveViewState(),
			modified: this._editors.modified.saveViewState(),
			modelState: this._diffModel.get()?.serializeState()
		};
	}
	restoreViewState(s) {
		if (s && s.original && s.modified) {
			const diffEditorState = s;
			this._editors.original.restoreViewState(diffEditorState.original);
			this._editors.modified.restoreViewState(diffEditorState.modified);
			if (diffEditorState.modelState) this._diffModel.get()?.restoreSerializedState(diffEditorState.modelState);
		}
	}
	handleInitialized() {
		this._editors.original.handleInitialized();
		this._editors.modified.handleInitialized();
	}
	createViewModel(model) {
		return this._instantiationService.createInstance(DiffEditorViewModel, model, this._options);
	}
	getModel() {
		return this._diffModel.get()?.model ?? null;
	}
	setModel(model) {
		const vm = !model ? null : "model" in model ? RefCounted.create(model).createNewRef(this) : RefCounted.create(this.createViewModel(model), this);
		this.setDiffModel(vm);
	}
	setDiffModel(viewModel, tx) {
		const currentModel = this._diffModel.get();
		if (!viewModel && currentModel) this._accessibleDiffViewer.get().close();
		if (this._diffModel.get() !== viewModel?.object) subtransaction(tx, (tx) => {
			const vm = viewModel?.object;
			if (currentModel?.model.original !== vm?.model.original || currentModel?.model.modified !== vm?.model.modified) this._options.resetWidthBasedLayout(tx);
			/** @description DiffEditorWidget.setModel */
			observableFromEvent.batchEventsGlobally(tx, () => {
				this._editors.original.setModel(vm ? vm.model.original : null);
				this._editors.modified.setModel(vm ? vm.model.modified : null);
			});
			const prevValueRef = this._diffModelSrc.get()?.createNewRef(this);
			this._diffModelSrc.set(viewModel?.createNewRef(this), tx);
			if (prevValueRef) {
				this._deferredDiffModelRefDisposals.add(prevValueRef);
				setTimeout(() => {
					this._deferredDiffModelRefDisposals.delete(prevValueRef);
				}, 0);
			}
		});
	}
	/**
	* @param changedOptions Only has values for top-level options that have actually changed.
	*/
	updateOptions(changedOptions) {
		this._options.updateOptions(changedOptions);
	}
	getContainerDomNode() {
		return this._domElement;
	}
	getOriginalEditor() {
		return this._editors.original;
	}
	getModifiedEditor() {
		return this._editors.modified;
	}
	get renderSideBySideInAutomaticMode() {
		return this._options.renderSideBySideInAutomaticMode;
	}
	get temporaryInlineMode() {
		return this._options.temporaryInlineMode;
	}
	/**
	* @deprecated Use `this.getDiffComputationResult().changes2` instead.
	*/
	getLineChanges() {
		const diffState = this._diffModel.get()?.diff.get();
		if (!diffState) return null;
		return toLineChanges(diffState);
	}
	getDiffComputationResult() {
		const diffState = this._diffModel.get()?.diff.get();
		if (!diffState) return null;
		return {
			changes: this.getLineChanges(),
			changes2: diffState.mappings.map((m) => m.lineRangeMapping),
			identical: diffState.identical,
			quitEarly: diffState.quitEarly
		};
	}
	revert(diff) {
		const model = this._diffModel.get();
		if (!model || !model.isDiffUpToDate.get()) return;
		this._editors.modified.pushUndoStop();
		this._editors.modified.executeEdits("diffEditor", [{
			range: diff.modified.toExclusiveRange(),
			text: model.model.original.getValueInRange(diff.original.toExclusiveRange())
		}]);
		this._editors.modified.pushUndoStop();
	}
	revertRangeMappings(diffs) {
		const model = this._diffModel.get();
		if (!model || !model.isDiffUpToDate.get()) return;
		const changes = diffs.map((c) => ({
			range: c.modifiedRange,
			text: model.model.original.getValueInRange(c.originalRange)
		}));
		this._editors.modified.pushUndoStop();
		this._editors.modified.executeEdits("diffEditor", changes);
		this._editors.modified.pushUndoStop();
	}
	revertFocusedRangeMappings() {
		const model = this._diffModel.get();
		if (!model || !model.isDiffUpToDate.get()) return;
		const diffs = this._diffModel.get()?.diff.get()?.mappings;
		if (!diffs || diffs.length === 0) return;
		const modifiedEditor = this._editors.modified;
		if (!modifiedEditor.hasTextFocus()) return;
		const curLineNumber = modifiedEditor.getPosition().lineNumber;
		const selection = modifiedEditor.getSelection();
		const selectedRange = LineRange.fromRange(selection || new Range$2(curLineNumber, 0, curLineNumber, 0));
		const diffsToRevert = diffs.filter((d) => {
			return d.lineRangeMapping.modified.intersect(selectedRange);
		});
		modifiedEditor.pushUndoStop();
		modifiedEditor.executeEdits("diffEditor", diffsToRevert.map((d) => ({
			range: d.lineRangeMapping.modified.toExclusiveRange(),
			text: model.model.original.getValueInRange(d.lineRangeMapping.original.toExclusiveRange())
		})));
		modifiedEditor.pushUndoStop();
	}
	_goTo(diff) {
		this._editors.modified.setPosition(new Position$1(diff.lineRangeMapping.modified.startLineNumber, 1));
		this._editors.modified.revealRangeInCenter(diff.lineRangeMapping.modified.toExclusiveRange());
	}
	goToDiff(target) {
		const diffs = this._diffModel.get()?.diff.get()?.mappings;
		if (!diffs || diffs.length === 0) return;
		const curLineNumber = this._editors.modified.getPosition().lineNumber;
		let diff;
		if (target === "next") {
			if (this._editors.modified.getModel().getLineCount() === curLineNumber) diff = diffs[0];
			else diff = diffs.find((d) => d.lineRangeMapping.modified.startLineNumber > curLineNumber) ?? diffs[0];
		} else diff = findLast(diffs, (d) => d.lineRangeMapping.modified.startLineNumber < curLineNumber) ?? diffs[diffs.length - 1];
		this._goTo(diff);
		if (diff.lineRangeMapping.modified.isEmpty) this._accessibilitySignalService.playSignal(AccessibilitySignal.diffLineDeleted, { source: "diffEditor.goToDiff" });
		else if (diff.lineRangeMapping.original.isEmpty) this._accessibilitySignalService.playSignal(AccessibilitySignal.diffLineInserted, { source: "diffEditor.goToDiff" });
		else if (diff) this._accessibilitySignalService.playSignal(AccessibilitySignal.diffLineModified, { source: "diffEditor.goToDiff" });
	}
	revealFirstDiff() {
		const diffModel = this._diffModel.get();
		if (!diffModel) return;
		this.waitForDiff().then(() => {
			const diffs = diffModel.diff.get()?.mappings;
			if (!diffs || diffs.length === 0) return;
			this._goTo(diffs[0]);
		});
	}
	accessibleDiffViewerNext() {
		this._accessibleDiffViewer.get().next();
	}
	accessibleDiffViewerPrev() {
		this._accessibleDiffViewer.get().prev();
	}
	async waitForDiff() {
		const diffModel = this._diffModel.get();
		if (!diffModel) return;
		await diffModel.waitForDiff();
	}
	mapToOtherSide() {
		const isModifiedFocus = this._editors.modified.hasWidgetFocus();
		const source = isModifiedFocus ? this._editors.modified : this._editors.original;
		const destination = isModifiedFocus ? this._editors.original : this._editors.modified;
		let destinationSelection;
		const sourceSelection = source.getSelection();
		if (sourceSelection) {
			const mappings = this._diffModel.get()?.diff.get()?.mappings.map((m) => isModifiedFocus ? m.lineRangeMapping.flip() : m.lineRangeMapping);
			if (mappings) {
				const newRange1 = translatePosition(sourceSelection.getStartPosition(), mappings);
				const newRange2 = translatePosition(sourceSelection.getEndPosition(), mappings);
				destinationSelection = Range$2.plusRange(newRange1, newRange2);
			}
		}
		return {
			destination,
			destinationSelection
		};
	}
	switchSide() {
		const { destination, destinationSelection } = this.mapToOtherSide();
		destination.focus();
		if (destinationSelection) destination.setSelection(destinationSelection);
	}
	exitCompareMove() {
		const model = this._diffModel.get();
		if (!model) return;
		model.movedTextToCompare.set(void 0, void 0);
	}
	collapseAllUnchangedRegions() {
		const unchangedRegions = this._diffModel.get()?.unchangedRegions.get();
		if (!unchangedRegions) return;
		transaction((tx) => {
			for (const region of unchangedRegions) region.collapseAll(tx);
		});
	}
	showAllUnchangedRegions() {
		const unchangedRegions = this._diffModel.get()?.unchangedRegions.get();
		if (!unchangedRegions) return;
		transaction((tx) => {
			for (const region of unchangedRegions) region.showAll(tx);
		});
	}
	_handleCursorPositionChange(e, isModifiedEditor) {
		if (e?.reason === 3) {
			const diff = this._diffModel.get()?.diff.get()?.mappings.find((m) => isModifiedEditor ? m.lineRangeMapping.modified.contains(e.position.lineNumber) : m.lineRangeMapping.original.contains(e.position.lineNumber));
			if (diff?.lineRangeMapping.modified.isEmpty) this._accessibilitySignalService.playSignal(AccessibilitySignal.diffLineDeleted, { source: "diffEditor.cursorPositionChanged" });
			else if (diff?.lineRangeMapping.original.isEmpty) this._accessibilitySignalService.playSignal(AccessibilitySignal.diffLineInserted, { source: "diffEditor.cursorPositionChanged" });
			else if (diff) this._accessibilitySignalService.playSignal(AccessibilitySignal.diffLineModified, { source: "diffEditor.cursorPositionChanged" });
		}
	}
};
DiffEditorWidget = __decorate$5([
	__param$5(3, IContextKeyService),
	__param$5(4, IInstantiationService),
	__param$5(5, ICodeEditorService),
	__param$5(6, IAccessibilitySignalService),
	__param$5(7, IEditorProgressService)
], DiffEditorWidget);
function toLineChanges(state) {
	return state.mappings.map((x) => {
		const m = x.lineRangeMapping;
		let originalStartLineNumber;
		let originalEndLineNumber;
		let modifiedStartLineNumber;
		let modifiedEndLineNumber;
		let innerChanges = m.innerChanges;
		if (m.original.isEmpty) {
			originalStartLineNumber = m.original.startLineNumber - 1;
			originalEndLineNumber = 0;
			innerChanges = void 0;
		} else {
			originalStartLineNumber = m.original.startLineNumber;
			originalEndLineNumber = m.original.endLineNumberExclusive - 1;
		}
		if (m.modified.isEmpty) {
			modifiedStartLineNumber = m.modified.startLineNumber - 1;
			modifiedEndLineNumber = 0;
			innerChanges = void 0;
		} else {
			modifiedStartLineNumber = m.modified.startLineNumber;
			modifiedEndLineNumber = m.modified.endLineNumberExclusive - 1;
		}
		return {
			originalStartLineNumber,
			originalEndLineNumber,
			modifiedStartLineNumber,
			modifiedEndLineNumber,
			charChanges: innerChanges?.map((m) => ({
				originalStartLineNumber: m.originalRange.startLineNumber,
				originalStartColumn: m.originalRange.startColumn,
				originalEndLineNumber: m.originalRange.endLineNumber,
				originalEndColumn: m.originalRange.endColumn,
				modifiedStartLineNumber: m.modifiedRange.startLineNumber,
				modifiedStartColumn: m.modifiedRange.startColumn,
				modifiedEndLineNumber: m.modifiedRange.endLineNumber,
				modifiedEndColumn: m.modifiedRange.endColumn
			}))
		};
	});
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/editorBrowser.js
/**
*@internal
*/
function isCodeEditor(thing) {
	if (thing && typeof thing.getEditorType === "function") return thing.getEditorType() === EditorType.ICodeEditor;
	else return false;
}
/**
*@internal
*/
function isDiffEditor(thing) {
	if (thing && typeof thing.getEditorType === "function") return thing.getEditorType() === EditorType.IDiffEditor;
	else return false;
}
/**
*@internal
*/
function isCompositeEditor(thing) {
	return !!thing && typeof thing === "object" && typeof thing.onDidChangeActiveEditor === "function";
}
/**
*@internal
*/
function getCodeEditor(thing) {
	if (isCodeEditor(thing)) return thing;
	if (isDiffEditor(thing)) return thing.getModifiedEditor();
	if (isCompositeEditor(thing) && isCodeEditor(thing.activeCodeEditor)) return thing.activeCodeEditor;
	return null;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/markdownRenderer/browser/editorMarkdownCodeBlockRenderer.js
var __decorate$4 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$4 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var EditorMarkdownCodeBlockRenderer_1;
/**
* Renders markdown code blocks using the editor's tokenization and font settings.
*/
var EditorMarkdownCodeBlockRenderer = class EditorMarkdownCodeBlockRenderer {
	static {
		EditorMarkdownCodeBlockRenderer_1 = this;
	}
	static {
		this._ttpTokenizer = createTrustedTypesPolicy("tokenizeToString", { createHTML(html) {
			return html;
		} });
	}
	constructor(_configurationService, _languageService) {
		this._configurationService = _configurationService;
		this._languageService = _languageService;
	}
	async renderCodeBlock(languageAlias, value, options) {
		const editor = isCodeEditor(options.context) ? options.context : void 0;
		let languageId;
		if (languageAlias) languageId = this._languageService.getLanguageIdByLanguageName(languageAlias);
		else if (editor) languageId = editor.getModel()?.getLanguageId();
		if (!languageId) languageId = PLAINTEXT_LANGUAGE_ID;
		const html = await tokenizeToString(this._languageService, value, languageId);
		const content = EditorMarkdownCodeBlockRenderer_1._ttpTokenizer ? EditorMarkdownCodeBlockRenderer_1._ttpTokenizer.createHTML(html) ?? html : html;
		const root = document.createElement("span");
		root.innerHTML = content;
		const codeElement = root.querySelector(".monaco-tokenized-source");
		if (!isHTMLElement(codeElement)) return document.createElement("span");
		applyFontInfo(codeElement, this.getFontInfo(editor));
		return root;
	}
	getFontInfo(editor) {
		if (editor) return editor.getOption(59);
		else return createBareFontInfoFromRawSettings({ fontFamily: this._configurationService.getValue("editor").fontFamily }, 1);
	}
};
EditorMarkdownCodeBlockRenderer = EditorMarkdownCodeBlockRenderer_1 = __decorate$4([__param$4(0, IConfigurationService), __param$4(1, ILanguageService)], EditorMarkdownCodeBlockRenderer);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/standalone/browser/standaloneCodeEditor.js
var __decorate$3 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$3 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var LAST_GENERATED_COMMAND_ID = 0;
var ariaDomNodeCreated = false;
/**
* Create ARIA dom node inside parent,
* or only for the first editor instantiation inside document.body.
* @param parent container element for ARIA dom node
*/
function createAriaDomNode(parent) {
	if (!parent) {
		if (ariaDomNodeCreated) return;
		ariaDomNodeCreated = true;
	}
	setARIAContainer(parent || mainWindow.document.body);
}
/**
* A code editor to be used both by the standalone editor and the standalone diff editor.
*/
var StandaloneCodeEditor = class StandaloneCodeEditor extends CodeEditorWidget {
	constructor(domElement, _options, instantiationService, codeEditorService, commandService, contextKeyService, hoverService, keybindingService, themeService, notificationService, accessibilityService, languageConfigurationService, languageFeaturesService, markdownRendererService, userInteractionService) {
		const options = { ..._options };
		options.ariaLabel = options.ariaLabel || StandaloneCodeEditorNLS.editorViewAccessibleLabel;
		super(domElement, options, {}, instantiationService, codeEditorService, commandService, contextKeyService, themeService, notificationService, accessibilityService, languageConfigurationService, languageFeaturesService, userInteractionService);
		if (keybindingService instanceof StandaloneKeybindingService) this._standaloneKeybindingService = keybindingService;
		else this._standaloneKeybindingService = null;
		createAriaDomNode(options.ariaContainerElement);
		setHoverDelegateFactory((placement, enableInstantHover) => instantiationService.createInstance(WorkbenchHoverDelegate, placement, { instantHover: enableInstantHover }, {}));
		setBaseLayerHoverDelegate(hoverService);
		markdownRendererService.setDefaultCodeBlockRenderer(instantiationService.createInstance(EditorMarkdownCodeBlockRenderer));
	}
	addCommand(keybinding, handler, context) {
		if (!this._standaloneKeybindingService) {
			console.warn("Cannot add command because the editor is configured with an unrecognized KeybindingService");
			return null;
		}
		const commandId = "DYNAMIC_" + ++LAST_GENERATED_COMMAND_ID;
		const whenExpression = ContextKeyExpr.deserialize(context);
		this._standaloneKeybindingService.addDynamicKeybinding(commandId, keybinding, handler, whenExpression);
		return commandId;
	}
	createContextKey(key, defaultValue) {
		return this._contextKeyService.createKey(key, defaultValue);
	}
	addAction(_descriptor) {
		if (typeof _descriptor.id !== "string" || typeof _descriptor.label !== "string" || typeof _descriptor.run !== "function") throw new Error("Invalid action descriptor, `id`, `label` and `run` are required properties!");
		if (!this._standaloneKeybindingService) {
			console.warn("Cannot add keybinding because the editor is configured with an unrecognized KeybindingService");
			return Disposable.None;
		}
		const id = _descriptor.id;
		const label = _descriptor.label;
		const precondition = ContextKeyExpr.and(ContextKeyExpr.equals("editorId", this.getId()), ContextKeyExpr.deserialize(_descriptor.precondition));
		const keybindings = _descriptor.keybindings;
		const keybindingsWhen = ContextKeyExpr.and(precondition, ContextKeyExpr.deserialize(_descriptor.keybindingContext));
		const contextMenuGroupId = _descriptor.contextMenuGroupId || null;
		const contextMenuOrder = _descriptor.contextMenuOrder || 0;
		const run = (_accessor, ...args) => {
			return Promise.resolve(_descriptor.run(this, ...args));
		};
		const toDispose = new DisposableStore();
		const uniqueId = this.getId() + ":" + id;
		toDispose.add(CommandsRegistry.registerCommand(uniqueId, run));
		if (contextMenuGroupId) {
			const menuItem = {
				command: {
					id: uniqueId,
					title: label
				},
				when: precondition,
				group: contextMenuGroupId,
				order: contextMenuOrder
			};
			toDispose.add(MenuRegistry.appendMenuItem(MenuId.EditorContext, menuItem));
		}
		if (Array.isArray(keybindings)) for (const kb of keybindings) toDispose.add(this._standaloneKeybindingService.addDynamicKeybinding(uniqueId, kb, run, keybindingsWhen));
		const internalAction = new InternalEditorAction(uniqueId, label, label, void 0, precondition, (...args) => Promise.resolve(_descriptor.run(this, ...args)), this._contextKeyService);
		this._actions.set(id, internalAction);
		toDispose.add(toDisposable(() => {
			this._actions.delete(id);
		}));
		return toDispose;
	}
	_triggerCommand(handlerId, payload) {
		if (this._codeEditorService instanceof StandaloneCodeEditorService) try {
			this._codeEditorService.setActiveCodeEditor(this);
			super._triggerCommand(handlerId, payload);
		} finally {
			this._codeEditorService.setActiveCodeEditor(null);
		}
		else super._triggerCommand(handlerId, payload);
	}
};
StandaloneCodeEditor = __decorate$3([
	__param$3(2, IInstantiationService),
	__param$3(3, ICodeEditorService),
	__param$3(4, ICommandService),
	__param$3(5, IContextKeyService),
	__param$3(6, IHoverService),
	__param$3(7, IKeybindingService),
	__param$3(8, IThemeService),
	__param$3(9, INotificationService),
	__param$3(10, IAccessibilityService),
	__param$3(11, ILanguageConfigurationService),
	__param$3(12, ILanguageFeaturesService),
	__param$3(13, IMarkdownRendererService),
	__param$3(14, IUserInteractionService)
], StandaloneCodeEditor);
var StandaloneEditor = class StandaloneEditor extends StandaloneCodeEditor {
	constructor(domElement, _options, instantiationService, codeEditorService, commandService, contextKeyService, hoverService, keybindingService, themeService, notificationService, configurationService, accessibilityService, modelService, languageService, languageConfigurationService, languageFeaturesService, markdownRendererService, userInteractionService) {
		const options = { ..._options };
		updateConfigurationService(configurationService, options, false);
		const themeDomRegistration = themeService.registerEditorContainer(domElement);
		if (typeof options.theme === "string") themeService.setTheme(options.theme);
		if (typeof options.autoDetectHighContrast !== "undefined") themeService.setAutoDetectHighContrast(Boolean(options.autoDetectHighContrast));
		const _model = options.model;
		delete options.model;
		super(domElement, options, instantiationService, codeEditorService, commandService, contextKeyService, hoverService, keybindingService, themeService, notificationService, accessibilityService, languageConfigurationService, languageFeaturesService, markdownRendererService, userInteractionService);
		this._configurationService = configurationService;
		this._standaloneThemeService = themeService;
		this._register(themeDomRegistration);
		let model;
		if (typeof _model === "undefined") {
			const languageId = languageService.getLanguageIdByMimeType(options.language) || options.language || "plaintext";
			model = createTextModel(modelService, languageService, options.value || "", languageId, void 0);
			this._ownsModel = true;
		} else {
			model = _model;
			this._ownsModel = false;
		}
		this._attachModel(model);
		if (model) {
			const e = {
				oldModelUrl: null,
				newModelUrl: model.uri
			};
			this._onDidChangeModel.fire(e);
		}
	}
	updateOptions(newOptions) {
		updateConfigurationService(this._configurationService, newOptions, false);
		if (typeof newOptions.theme === "string") this._standaloneThemeService.setTheme(newOptions.theme);
		if (typeof newOptions.autoDetectHighContrast !== "undefined") this._standaloneThemeService.setAutoDetectHighContrast(Boolean(newOptions.autoDetectHighContrast));
		super.updateOptions(newOptions);
	}
	_postDetachModelCleanup(detachedModel) {
		super._postDetachModelCleanup(detachedModel);
		if (detachedModel && this._ownsModel) {
			detachedModel.dispose();
			this._ownsModel = false;
		}
	}
};
StandaloneEditor = __decorate$3([
	__param$3(2, IInstantiationService),
	__param$3(3, ICodeEditorService),
	__param$3(4, ICommandService),
	__param$3(5, IContextKeyService),
	__param$3(6, IHoverService),
	__param$3(7, IKeybindingService),
	__param$3(8, IStandaloneThemeService),
	__param$3(9, INotificationService),
	__param$3(10, IConfigurationService),
	__param$3(11, IAccessibilityService),
	__param$3(12, IModelService),
	__param$3(13, ILanguageService),
	__param$3(14, ILanguageConfigurationService),
	__param$3(15, ILanguageFeaturesService),
	__param$3(16, IMarkdownRendererService),
	__param$3(17, IUserInteractionService)
], StandaloneEditor);
var StandaloneDiffEditor2 = class StandaloneDiffEditor2 extends DiffEditorWidget {
	constructor(domElement, _options, instantiationService, contextKeyService, codeEditorService, themeService, notificationService, configurationService, contextMenuService, editorProgressService, clipboardService, accessibilitySignalService) {
		const options = { ..._options };
		updateConfigurationService(configurationService, options, true);
		const themeDomRegistration = themeService.registerEditorContainer(domElement);
		if (typeof options.theme === "string") themeService.setTheme(options.theme);
		if (typeof options.autoDetectHighContrast !== "undefined") themeService.setAutoDetectHighContrast(Boolean(options.autoDetectHighContrast));
		super(domElement, options, {}, contextKeyService, instantiationService, codeEditorService, accessibilitySignalService, editorProgressService);
		this._configurationService = configurationService;
		this._standaloneThemeService = themeService;
		this._register(themeDomRegistration);
	}
	updateOptions(newOptions) {
		updateConfigurationService(this._configurationService, newOptions, true);
		if (typeof newOptions.theme === "string") this._standaloneThemeService.setTheme(newOptions.theme);
		if (typeof newOptions.autoDetectHighContrast !== "undefined") this._standaloneThemeService.setAutoDetectHighContrast(Boolean(newOptions.autoDetectHighContrast));
		super.updateOptions(newOptions);
	}
	_createInnerEditor(instantiationService, container, options) {
		return instantiationService.createInstance(StandaloneCodeEditor, container, options);
	}
	getOriginalEditor() {
		return super.getOriginalEditor();
	}
	getModifiedEditor() {
		return super.getModifiedEditor();
	}
	addCommand(keybinding, handler, context) {
		return this.getModifiedEditor().addCommand(keybinding, handler, context);
	}
	createContextKey(key, defaultValue) {
		return this.getModifiedEditor().createContextKey(key, defaultValue);
	}
	addAction(descriptor) {
		return this.getModifiedEditor().addAction(descriptor);
	}
};
StandaloneDiffEditor2 = __decorate$3([
	__param$3(2, IInstantiationService),
	__param$3(3, IContextKeyService),
	__param$3(4, ICodeEditorService),
	__param$3(5, IStandaloneThemeService),
	__param$3(6, INotificationService),
	__param$3(7, IConfigurationService),
	__param$3(8, IContextMenuService),
	__param$3(9, IEditorProgressService),
	__param$3(10, IClipboardService),
	__param$3(11, IAccessibilitySignalService)
], StandaloneDiffEditor2);
/**
* @internal
*/
function createTextModel(modelService, languageService, value, languageId, uri) {
	value = value || "";
	if (!languageId) {
		const firstLF = value.indexOf("\n");
		let firstLine = value;
		if (firstLF !== -1) firstLine = value.substring(0, firstLF);
		return doCreateModel(modelService, value, languageService.createByFilepathOrFirstLine(uri || null, firstLine), uri);
	}
	return doCreateModel(modelService, value, languageService.createById(languageId), uri);
}
/**
* @internal
*/
function doCreateModel(modelService, value, languageSelection, uri) {
	return modelService.createModel(value, languageSelection, uri);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/multiDiffEditor/colors.js
registerColor("multiDiffEditor.headerBackground", {
	dark: "#262626",
	light: "tab.inactiveBackground",
	hcDark: "tab.inactiveBackground",
	hcLight: "tab.inactiveBackground"
}, localize(161, "The background color of the diff editor's header"));
registerColor("multiDiffEditor.background", editorBackground, localize(162, "The background color of the multi file diff editor"));
registerColor("multiDiffEditor.border", {
	dark: "sideBarSectionHeader.border",
	light: "#cccccc",
	hcDark: "sideBarSectionHeader.border",
	hcLight: "#cccccc"
}, localize(163, "The border color of the multi file diff editor"));
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/multiDiffEditor/virtualizedItemManager.js
var VirtualizedItemBinding = class extends Disposable {
	constructor(item) {
		super();
		this.item = item;
		this._onDidDispose = this._register(new Emitter$1());
		this.onDidDispose = this._onDidDispose.event;
	}
	dispose() {
		if (this._store.isDisposed) return;
		this._onDidDispose.fire();
		super.dispose();
	}
};
var VirtualizedItemTemplate = class extends Disposable {
	constructor() {
		super(...arguments);
		this._currentBinding = observableValue(this, void 0);
		this.currentBinding = this._currentBinding;
		this._bindingStore = this._register(new DisposableStore());
	}
	bind(item, context) {
		if (this._currentBinding.get()) throw new BugIndicatingError("Cannot rebind a virtualized template before disposing its current binding");
		const binding = this.createBinding(item, context);
		this._bindingStore.clear();
		this._bindingStore.add(Event.once(binding.onDidDispose)(() => {
			if (this._currentBinding.get() !== binding) throw new BugIndicatingError("Disposed binding does not own its virtualized template");
			this._currentBinding.set(void 0, void 0);
		}));
		this._currentBinding.set(binding, void 0);
		return binding;
	}
	dispose() {
		this._currentBinding.get()?.dispose();
		super.dispose();
	}
};
var VirtualizedItemManager = class extends Disposable {
	constructor(items, _context, _delegate) {
		super();
		this._context = _context;
		this._delegate = _delegate;
		this._pools = /* @__PURE__ */ new Map();
		this.virtualizedItems = mapObservableArrayCached(this, items, (item, store) => store.add(new ManagedVirtualizedItem(item, this, _delegate)), (item) => _delegate.getId(item)).recomputeInitiallyAndOnChange(this._store);
		this._register(toDisposable(() => {
			for (const pool of this._pools.values()) pool.dispose();
			this._pools.clear();
		}));
	}
	acquire(item) {
		const templateId = this._delegate.getTemplateId(item);
		let pool = this._pools.get(templateId);
		if (!pool) {
			pool = new VirtualizedTemplatePool(() => this._delegate.createTemplate(templateId, this._context));
			this._pools.set(templateId, pool);
		}
		return pool.acquire();
	}
};
var ManagedVirtualizedItem = class extends Disposable {
	constructor(item, _manager, _delegate) {
		super();
		this.item = item;
		this._manager = _manager;
		this._delegate = _delegate;
		this._templateReference = observableValue(this, void 0);
		this._isHidden = observableValue(this, false);
		this._didRenderFail = false;
		this.template = derived(this, (reader) => this._templateReference.read(reader)?.object);
		this.binding = derived(this, (reader) => this.template.read(reader)?.currentBinding.read(reader));
		const unboundSize = _delegate.getUnboundSize(item);
		this.size = derived(this, (reader) => this.binding.read(reader)?.size.read(reader) ?? unboundSize.read(reader));
		this.maxScroll = derived(this, (reader) => this.binding.read(reader)?.maxScroll.read(reader) ?? { maxScroll: 0 });
		this._register(autorun((reader) => {
			const binding = this.binding.read(reader);
			if (!binding || !this._isHidden.read(reader) || binding.shouldKeepAlive.read(reader)) return;
			this._clearBinding();
		}));
	}
	render(renderedRange, scrollOffset, width, renderedViewport, context) {
		this._lastRender = {
			renderedRange,
			scrollOffset,
			width,
			renderedViewport,
			context
		};
		this._isHidden.set(false, void 0);
		if (this._didRenderFail) return;
		try {
			this._render(renderedRange, scrollOffset, width, renderedViewport, context);
		} catch (error) {
			this._didRenderFail = true;
			onUnexpectedError(error);
		}
	}
	_render(renderedRange, scrollOffset, width, renderedViewport, context) {
		let binding = this.binding.get();
		if (!binding) {
			const templateReference = this._manager.acquire(this.item);
			const template = templateReference.object;
			if (template.currentBinding.get()) {
				templateReference.dispose();
				throw new BugIndicatingError("Virtualized template pool returned a bound template");
			}
			let newBinding;
			try {
				newBinding = template.bind(this.item, {
					initialSize: this.size.get(),
					runWithScrollAnchor: (getItemOffset, update) => {
						if (!context) throw new BugIndicatingError("Cannot preserve a virtualized item scroll anchor without a render context");
						context.runWithScrollAnchor(getItemOffset, update);
					}
				});
				if (newBinding.item !== this.item || template.currentBinding.get() !== newBinding) throw new BugIndicatingError("Virtualized template returned a binding for a different item");
				const validatedBinding = newBinding;
				transaction((tx) => {
					this._delegate.onDidBind?.(validatedBinding, tx);
					this._templateReference.set(templateReference, tx);
				});
			} catch (error) {
				(template.currentBinding.get() ?? newBinding)?.dispose();
				templateReference.dispose();
				throw error;
			}
			binding = newBinding;
		}
		binding.render(renderedRange, scrollOffset, width, renderedViewport);
	}
	hide() {
		this._isHidden.set(true, void 0);
		this.binding.get()?.hide();
	}
	_clearBinding() {
		const templateReference = this._templateReference.get();
		const binding = templateReference?.object.currentBinding.get();
		if (!templateReference || !binding) return;
		transaction((tx) => {
			this._delegate.onWillUnbind?.(binding, tx);
		});
		binding.hide();
		binding.dispose();
		if (templateReference.object.currentBinding.get()) throw new BugIndicatingError("Virtualized binding did not release its template when disposed");
		transaction((tx) => {
			this._templateReference.set(void 0, tx);
		});
		templateReference.dispose();
	}
	dispose() {
		this._clearBinding();
		super.dispose();
	}
};
var VirtualizedTemplatePool = class {
	constructor(_create) {
		this._create = _create;
		this._unused = /* @__PURE__ */ new Set();
		this._used = /* @__PURE__ */ new Set();
	}
	acquire() {
		const template = this._unused.values().next().value ?? this._create();
		this._unused.delete(template);
		if (template.currentBinding.get()) throw new BugIndicatingError("Cannot acquire a bound virtualized template");
		this._used.add(template);
		let disposed = false;
		return {
			object: template,
			dispose: () => {
				if (disposed) return;
				disposed = true;
				if (template.currentBinding.get()) throw new BugIndicatingError("Cannot pool a virtualized template with a current binding");
				this._used.delete(template);
				if (this._unused.size >= 5) template.dispose();
				else this._unused.add(template);
			}
		};
	}
	dispose() {
		for (const template of this._used) template.dispose();
		for (const template of this._unused) template.dispose();
		this._used.clear();
		this._unused.clear();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/multiDiffEditor/diffEditorItemTemplate.js
var __decorate$2 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$2 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var DiffEditorItemTemplate = class DiffEditorItemTemplate extends VirtualizedItemTemplate {
	constructor(_container, _overflowWidgetsDomNode, _workbenchUIElementFactory, _variantConfiguration, _optionsOverride, _instantiationService, _parentContextKeyService) {
		super();
		this._container = _container;
		this._overflowWidgetsDomNode = _overflowWidgetsDomNode;
		this._workbenchUIElementFactory = _workbenchUIElementFactory;
		this._variantConfiguration = _variantConfiguration;
		this._optionsOverride = _optionsOverride;
		this._instantiationService = _instantiationService;
		this._verticalStateUpdate = this._register(new MutableDisposable());
		this._observedEditorContentHeight = 500;
		this._isSettingData = false;
		this._viewModel = observableValue(this, void 0);
		this._collapsed = derived(this, (reader) => this._viewModel.read(reader)?.collapsed.read(reader));
		this._editorContentHeight = observableValue(this, 500);
		this._itemHorizontalInsets = this._variantConfiguration.horizontalInsets;
		this.size = derived(this, (reader) => {
			if (this._collapsed.read(reader)) return this._headerHeight;
			return this._editorContentHeight.read(reader) + this._outerEditorHeight;
		});
		this._modifiedContentWidth = observableValue(this, 0);
		this._modifiedWidth = observableValue(this, 0);
		this._originalContentWidth = observableValue(this, 0);
		this._originalWidth = observableValue(this, 0);
		this.maxScroll = derived(this, (reader) => {
			const scroll1 = this._modifiedContentWidth.read(reader) - this._modifiedWidth.read(reader);
			const scroll2 = this._originalContentWidth.read(reader) - this._originalWidth.read(reader);
			if (scroll1 > scroll2) return {
				maxScroll: scroll1,
				width: this._modifiedWidth.read(reader)
			};
			else return {
				maxScroll: scroll2,
				width: this._originalWidth.read(reader)
			};
		});
		const binaryFileChangedLabel = localize(164, "Binary file changed");
		this._elements = h("div.multiDiffEntry", [h("div.header@header", [h("div.header-content", [
			h("div.collapse-button@collapseButton"),
			h("div.file-path", [
				h("div.title.modified.show-file-icons@primaryPath", []),
				h("div.status.deleted@status", ["R"]),
				h("div.title.original.show-file-icons@secondaryPath", [])
			]),
			h("div.actions@actions")
		])]), h("div.editorParent", [h("div.editorContainer@editor"), h("div.binary-file-placeholder@binaryFilePlaceholder", {
			role: "group",
			"aria-label": binaryFileChangedLabel
		}, [h("div.binary-file-placeholder-content", [h("span", [binaryFileChangedLabel]), h("div.binary-file-placeholder-actions@binaryFilePlaceholderActions")])])])]);
		this.editor = this._register(this._instantiationService.createInstance(DiffEditorWidget, this._elements.editor, {
			overflowWidgetsDomNode: this._overflowWidgetsDomNode,
			fixedOverflowWidgets: true
		}, {
			variant: this._variantConfiguration.diffEditorVariant,
			runWithOriginalEditorScrollAnchor: (anchorLineNumber, update) => this._runWithEditorScrollAnchor(() => this._outerEditorHeight + this._getOriginalEditorLineTop(anchorLineNumber), update),
			runWithModifiedEditorScrollAnchor: (anchorLineNumber, update) => this._runWithEditorScrollAnchor(() => this._outerEditorHeight + this._getModifiedEditorLineTop(anchorLineNumber), update)
		}));
		this.isModifedFocused = observableCodeEditor(this.editor.getModifiedEditor()).isFocused;
		this.isOriginalFocused = observableCodeEditor(this.editor.getOriginalEditor()).isFocused;
		this.isBinaryFilePlaceholderFocused = observableValue(this, false);
		const binaryFilePlaceholderFocus = this._register(trackFocus(this._elements.binaryFilePlaceholder));
		this._register(binaryFilePlaceholderFocus.onDidFocus(() => this.isBinaryFilePlaceholderFocused.set(true, void 0)));
		this._register(binaryFilePlaceholderFocus.onDidBlur(() => this.isBinaryFilePlaceholderFocused.set(false, void 0)));
		this.isFocused = derived(this, (reader) => this.isModifedFocused.read(reader) || this.isOriginalFocused.read(reader) || this.isBinaryFilePlaceholderFocused.read(reader));
		this._elements.binaryFilePlaceholder.tabIndex = 0;
		if (this._workbenchUIElementFactory.openDiffEditor) {
			this._openBinaryDiffButton = this._register(new Button(this._elements.binaryFilePlaceholderActions, {
				...defaultButtonStyles,
				secondary: true
			}));
			this._openBinaryDiffButton.label = localize(165, "Open Diff");
			this._register(this._openBinaryDiffButton.onDidClick(() => {
				const item = this._viewModel.get();
				if (item?.originalUri && item.modifiedUri) this._workbenchUIElementFactory.openDiffEditor?.(item.originalUri, item.modifiedUri);
			}));
		} else this._openBinaryDiffButton = void 0;
		const primaryAccessory = h("div.multi-diff-resource-label-accessory").root;
		this._resourceLabel = this._workbenchUIElementFactory.createResourceLabel ? this._register(this._workbenchUIElementFactory.createResourceLabel(this._elements.primaryPath, "primary", primaryAccessory)) : void 0;
		this._elements.primaryPath.appendChild(primaryAccessory);
		const secondaryAccessory = h("div.multi-diff-resource-label-accessory").root;
		this._resourceLabel2 = this._workbenchUIElementFactory.createResourceLabel ? this._register(this._workbenchUIElementFactory.createResourceLabel(this._elements.secondaryPath, "secondary", secondaryAccessory)) : void 0;
		this._elements.secondaryPath.appendChild(secondaryAccessory);
		this._dataStore = this._register(new DisposableStore());
		this._headerHeight = this._variantConfiguration.headerHeight;
		const btn = this._register(new Button(this._elements.collapseButton, {}));
		const activateItem = () => this._viewModel.get()?.setActive(void 0);
		this._register(autorun((reader) => {
			btn.element.className = "";
			btn.icon = this._collapsed.read(reader) ? Codicon.chevronRight : Codicon.chevronDown;
		}));
		this._register(btn.onDidClick(() => {
			activateItem();
			this._viewModel.get()?.collapsed.set(!this._collapsed.get(), void 0);
		}));
		if (this._workbenchUIElementFactory.handleHeaderMiddleClick) this._register(addDisposableListener(this._elements.header, EventType$1.AUXCLICK, (e) => {
			if (e.button !== 1) return;
			const viewModel = this._viewModel.get();
			const resource = viewModel?.modifiedUri ?? viewModel?.originalUri;
			if (resource && this._workbenchUIElementFactory.handleHeaderMiddleClick?.(resource)) EventHelper.stop(e, true);
		}));
		if (this._variantConfiguration.headerClickToCollapse) {
			this._elements.header.tabIndex = 0;
			this._elements.header.setAttribute("role", "button");
			this._register(addDisposableListener(this._elements.header, EventType$1.MOUSE_ENTER, () => this._elements.root.classList.add("header-hovered")));
			this._register(addDisposableListener(this._elements.header, EventType$1.MOUSE_LEAVE, () => this._elements.root.classList.remove("header-hovered")));
			const headerFocus = this._register(trackFocus(this._elements.header));
			this._register(headerFocus.onDidFocus(() => {
				this._elements.root.classList.add("header-focused");
				activateItem();
			}));
			this._register(headerFocus.onDidBlur(() => this._elements.root.classList.remove("header-focused")));
			this._register(addDisposableListener(this._elements.header, EventType$1.CLICK, (e) => {
				activateItem();
				const target = e.target;
				if (!(target instanceof Element)) return;
				if (target.closest(".actions") || target.closest(".collapse-button")) return;
				this._viewModel.get()?.collapsed.set(!this._collapsed.get(), void 0);
			}));
			this._register(addDisposableListener(this._elements.header, EventType$1.KEY_DOWN, (e) => {
				if (e.key === "Enter" || e.key === " ") {
					activateItem();
					const target = e.target;
					if (target instanceof Element && (target.closest(".actions") || target.closest(".collapse-button"))) return;
					e.preventDefault();
					this._viewModel.get()?.collapsed.set(!this._collapsed.get(), void 0);
				}
			}));
		}
		this._register(autorun((reader) => {
			const collapsed = this._collapsed.read(reader);
			const item = this._viewModel.read(reader);
			const isBinary = item?.isBinary === true;
			const canOpenDiff = !!(item?.originalUri && item.modifiedUri && this._openBinaryDiffButton);
			this._elements.editor.style.display = collapsed || isBinary ? "none" : "block";
			this._elements.binaryFilePlaceholder.style.display = !collapsed && isBinary ? "grid" : "none";
			this._elements.binaryFilePlaceholder.tabIndex = canOpenDiff ? -1 : 0;
			this._elements.binaryFilePlaceholderActions.style.display = canOpenDiff ? "" : "none";
			if (this._variantConfiguration.headerClickToCollapse) this._elements.header.setAttribute("aria-expanded", String(!collapsed));
		}));
		this._register(this.editor.getModifiedEditor().onDidLayoutChange((e) => {
			const width = this.editor.getModifiedEditor().getLayoutInfo().contentWidth;
			this._modifiedWidth.set(width, void 0);
		}));
		this._register(this.editor.getOriginalEditor().onDidLayoutChange((e) => {
			const width = this.editor.getOriginalEditor().getLayoutInfo().contentWidth;
			this._originalWidth.set(width, void 0);
		}));
		this._register(this.editor.onDidContentSizeChange((e) => {
			globalTransaction((tx) => {
				this._modifiedContentWidth.set(this.editor.getModifiedEditor().getContentWidth(), tx);
				this._originalContentWidth.set(this.editor.getOriginalEditor().getContentWidth(), tx);
			});
			const viewModel = this._viewModel.get();
			if (this._isSettingData || viewModel?.isBinary || !viewModel?.diffEditorViewModel.isDiffUpToDate.get()) return;
			this._observedEditorContentHeight = e.contentHeight;
			this._scheduleVerticalStateUpdate();
		}));
		this._register(autorun((reader) => {
			const isActive = this._viewModel.read(reader)?.isActive.read(reader);
			this._elements.root.classList.toggle("active", isActive);
			const isFirst = this._viewModel.read(reader)?.isFirst.read(reader);
			this._elements.root.classList.toggle("first-diff-entry", isFirst);
		}));
		this._container.appendChild(this._elements.root);
		this._outerEditorHeight = this._headerHeight + this._variantConfiguration.contentBottomPadding;
		this._contextKeyService = this._register(_parentContextKeyService.createScoped(this._elements.actions));
		const ctxAllUnchangedRegionsShown = EditorContextKeys.multiDiffEditorItemAllUnchangedRegionsShown.bindTo(this._contextKeyService);
		this._register(autorun((reader) => {
			ctxAllUnchangedRegionsShown.set(this.editor.allUnchangedRegionsShown.read(reader));
		}));
		const instantiationService = this._register(this._instantiationService.createChild(new ServiceCollection([IContextKeyService, this._contextKeyService])));
		this._register(instantiationService.createInstance(MenuWorkbenchToolBar, this._elements.actions, MenuId.MultiDiffEditorFileToolbar, {
			actionRunner: this._register(new ActionRunnerWithContext(() => this._viewModel.get()?.modifiedUri ?? this._viewModel.get()?.originalUri)),
			highlightToggledItems: true,
			menuOptions: { shouldForwardArgs: true },
			toolbarOptions: { primaryGroup: (g) => g.startsWith("navigation") },
			actionViewItemProvider: (action, options) => this._workbenchUIElementFactory.createToolbarActionViewItem?.(action, options) ?? createActionViewItem(instantiationService, action, options)
		}));
	}
	setScrollLeft(left) {
		if (this._modifiedContentWidth.get() - this._modifiedWidth.get() > this._originalContentWidth.get() - this._originalWidth.get()) this.editor.getModifiedEditor().setScrollLeft(left);
		else this.editor.getOriginalEditor().setScrollLeft(left);
	}
	getExpandedContentHeight() {
		return this._observedEditorContentHeight + this._outerEditorHeight;
	}
	createBinding(item, context) {
		this._bindingContext = context;
		try {
			this.setItem(item, context.initialSize);
		} catch (error) {
			try {
				this.setItem(void 0);
			} finally {
				this._bindingContext = void 0;
			}
			throw error;
		}
		return new DiffEditorItemBinding(item, this);
	}
	_runWithEditorScrollAnchor(getItemOffset, update) {
		const context = this._bindingContext;
		if (!context) throw new BugIndicatingError("Cannot preserve a diff editor scroll anchor without an active item binding");
		context.runWithScrollAnchor(getItemOffset, (tx) => {
			update();
			this._verticalStateUpdate.clear();
			this._observedEditorContentHeight = this.editor.getContentHeight();
			this._editorContentHeight.set(this._observedEditorContentHeight, tx);
		});
	}
	_getOriginalEditorLineTop(lineNumber) {
		const originalEditor = this.editor.getOriginalEditor();
		return lineNumber > originalEditor.getModel().getLineCount() ? originalEditor.getContentHeight() : originalEditor.getTopForLineNumber(lineNumber);
	}
	_getModifiedEditorLineTop(lineNumber) {
		const modifiedEditor = this.editor.getModifiedEditor();
		return lineNumber > modifiedEditor.getModel().getLineCount() ? modifiedEditor.getContentHeight() : modifiedEditor.getTopForLineNumber(lineNumber);
	}
	setItem(item, initialSize = 0) {
		this._verticalStateUpdate.clear();
		const optionsOverride = this._optionsOverride;
		const variantOptions = this._variantConfiguration.diffEditorOptions;
		function updateOptions(options) {
			return {
				...variantOptions,
				...options,
				...optionsOverride?.get(),
				hideOriginalLineNumbers: optionsOverride?.get()?.hideOriginalLineNumbers ?? options.hideOriginalLineNumbers ?? variantOptions?.hideOriginalLineNumbers ?? false,
				scrollBeyondLastLine: false,
				hideUnchangedRegions: { enabled: true },
				scrollbar: {
					vertical: "hidden",
					horizontal: "hidden",
					handleMouseWheel: false,
					useShadows: false
				},
				renderOverviewRuler: false,
				fixedOverflowWidgets: true,
				overviewRulerBorder: false
			};
		}
		if (!item) {
			this._isSettingData = true;
			try {
				globalTransaction((tx) => {
					this._viewModel.set(void 0, tx);
					this.editor.setDiffModel(null, tx);
					this._dataStore.clear();
				});
			} finally {
				this._isSettingData = false;
			}
			return;
		}
		const value = item.documentDiffItem;
		const editorContentHeight = item.isBinary ? 100 : Math.max(0, Math.max(initialSize, item.lastTemplateData.get().expandedContentHeight) - this._outerEditorHeight);
		this._observedEditorContentHeight = editorContentHeight;
		this._isSettingData = true;
		try {
			globalTransaction((tx) => {
				this._editorContentHeight.set(editorContentHeight, tx);
				this._resourceLabel?.setUri(item.modifiedUri ?? item.originalUri, { strikethrough: item.modifiedUri === void 0 });
				let isRenamed = false;
				let isDeleted = false;
				let isAdded = false;
				let flag = "";
				if (item.modifiedUri && item.originalUri && item.modifiedUri.path !== item.originalUri.path) {
					flag = "R";
					isRenamed = true;
				} else if (!item.modifiedUri) {
					flag = "D";
					isDeleted = true;
				} else if (!item.originalUri) {
					flag = "A";
					isAdded = true;
				}
				this._elements.status.classList.toggle("renamed", isRenamed);
				this._elements.status.classList.toggle("deleted", isDeleted);
				this._elements.status.classList.toggle("added", isAdded);
				this._elements.status.innerText = flag;
				this._resourceLabel2?.setUri(isRenamed ? item.originalUri : void 0, { strikethrough: true });
				this._dataStore.clear();
				this._viewModel.set(item, tx);
				this.editor.updateOptions(updateOptions(value.options ?? {}));
				this.editor.setDiffModel(item.diffEditorViewModelRef, tx);
			});
		} finally {
			this._isSettingData = false;
		}
		this._dataStore.add(autorun((reader) => {
			if (item.isBinary) return;
			const viewModel = item.diffEditorViewModel;
			if (!viewModel.isDiffUpToDate.read(reader)) return;
			if ((viewModel.diff.read(reader)?.mappings.length ?? 0) > 0 && viewModel.unchangedRegions.read(reader).length > 0) return;
			this._observedEditorContentHeight = this.editor.getContentHeight();
			this._scheduleVerticalStateUpdate();
		}));
		if (value.onOptionsDidChange) this._dataStore.add(value.onOptionsDidChange(() => {
			this.editor.updateOptions(updateOptions(value.options ?? {}));
		}));
		if (optionsOverride) this._dataStore.add(autorun((reader) => {
			optionsOverride.read(reader);
			this.editor.updateOptions(updateOptions(value.options ?? {}));
		}));
		if (item.documentDiffItem.contextKeys) for (const [key, value] of Object.entries(item.documentDiffItem.contextKeys)) this._contextKeyService.createKey(key, value);
	}
	render(verticalRange, width, editorScroll, viewPort) {
		this._elements.root.style.visibility = "visible";
		this._elements.root.style.top = `${verticalRange.start}px`;
		this._elements.root.style.height = `${verticalRange.length}px`;
		this._elements.root.style.width = `${width}px`;
		this._elements.root.style.position = "absolute";
		const maxDelta = verticalRange.length - this._headerHeight;
		const delta = Math.max(0, Math.min(viewPort.start - verticalRange.start, maxDelta));
		this._elements.header.style.transform = `translateY(${delta}px)`;
		globalTransaction((tx) => {
			this.editor.layout({
				width: width - this._itemHorizontalInsets.left - this._itemHorizontalInsets.right,
				height: verticalRange.length - this._outerEditorHeight
			});
		});
		this.editor.getOriginalEditor().setScrollTop(editorScroll);
		this._flushVerticalState();
		this._elements.header.classList.toggle("shadow", delta > 0 || editorScroll > 0);
		this._elements.header.classList.toggle("collapsed", delta === maxDelta);
	}
	_scheduleVerticalStateUpdate() {
		if (this._verticalStateUpdate.value) return;
		this._verticalStateUpdate.value = scheduleAtNextAnimationFrame(getWindow(this._elements.root), () => this._flushVerticalState());
	}
	_flushVerticalState() {
		this._verticalStateUpdate.clear();
		globalTransaction((tx) => {
			this._editorContentHeight.set(this._observedEditorContentHeight, tx);
		});
	}
	hide() {
		this._elements.root.classList.remove("header-hovered");
		this._elements.root.style.top = `-100000px`;
		this._elements.root.style.visibility = "hidden";
	}
	focusBinaryFilePlaceholder() {
		const item = this._viewModel.get();
		if (item?.originalUri && item.modifiedUri && this._openBinaryDiffButton) this._openBinaryDiffButton.focus();
		else this._elements.binaryFilePlaceholder.focus();
	}
	unbind(item) {
		if (this._viewModel.get() !== item) throw new BugIndicatingError("Cannot unbind a diff editor template from a different item");
		this.setItem(void 0);
		this._bindingContext = void 0;
	}
};
DiffEditorItemTemplate = __decorate$2([__param$2(5, IInstantiationService), __param$2(6, IContextKeyService)], DiffEditorItemTemplate);
var DiffEditorItemBinding = class extends VirtualizedItemBinding {
	constructor(item, _template) {
		super(item);
		this._template = _template;
		this.size = _template.size;
		this.maxScroll = _template.maxScroll;
		this.shouldKeepAlive = _template.isFocused;
		this.editor = _template.editor;
	}
	render(renderedRange, scrollOffset, width, renderedViewport) {
		this._template.render(renderedRange, width, scrollOffset, renderedViewport);
	}
	hide() {
		this._template.hide();
	}
	setScrollLeft(scrollLeft) {
		this._template.setScrollLeft(scrollLeft);
	}
	getExpandedContentHeight() {
		return this._template.getExpandedContentHeight();
	}
	focus() {
		if (this.item.isBinary) this._template.focusBinaryFilePlaceholder();
		else this.editor.focus();
	}
	dispose() {
		if (this._store.isDisposed) return;
		this._template.unbind(this.item);
		super.dispose();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/multiDiffEditor/multiDiffEditorOptions.js
function getMultiDiffEditorVariantConfiguration(variant) {
	switch (variant) {
		case "noCardsNonCompact": return {
			classNames: ["multiDiffEditor-standard"],
			horizontalInsets: {
				left: 9,
				right: 9
			},
			headerHeight: 40,
			contentBottomPadding: 0,
			headerClickToCollapse: false
		};
		case "noCards": return {
			classNames: ["multiDiffEditor-compact"],
			horizontalInsets: {
				left: 0,
				right: 0
			},
			headerHeight: 32,
			contentBottomPadding: 8,
			headerClickToCollapse: true,
			diffEditorOptions: { hideOriginalLineNumbers: true }
		};
		case "cards": return {
			diffEditorVariant: "compact",
			classNames: ["multiDiffEditor-compact", "multiDiffEditor-card"],
			horizontalInsets: {
				left: 9,
				right: 9
			},
			headerHeight: 40,
			contentBottomPadding: 0,
			headerClickToCollapse: true,
			diffEditorOptions: { hideOriginalLineNumbers: true }
		};
	}
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/multiDiffEditor/compressedVirtualizedScrollLayout.js
function asLayoutRevision(value) {
	return value;
}
/**
* Computes the complete and compressed vertical layout of a virtualized list.
*/
function computeCompressedVirtualizedScrollLayout(input) {
	assertNonNegative("viewportHeight", input.viewportHeight);
	const leadingScrollSlack = input.leadingScrollSlack ?? 0;
	const trailingScrollSlack = input.trailingScrollSlack ?? 0;
	assertNonNegative("leadingScrollSlack", leadingScrollSlack);
	assertNonNegative("trailingScrollSlack", trailingScrollSlack);
	const logicalScrollHeight = computeCompressedVirtualizedScrollHeight(input.itemHeights, input.itemGap);
	const scrollHeight = leadingScrollSlack + logicalScrollHeight + trailingScrollSlack;
	const maxScrollTop = Math.max(0, scrollHeight - input.viewportHeight);
	const scrollTop = Math.max(0, Math.min(input.scrollTop, maxScrollTop));
	const contentViewport = OffsetRange.ofStartAndLength(scrollTop - leadingScrollSlack, input.viewportHeight);
	let contentTop = 0;
	let renderedTop = leadingScrollSlack;
	let hiddenContentHeightAboveViewport = 0;
	const items = [];
	for (let index = 0; index < input.itemHeights.length; index++) {
		const fullHeight = input.itemHeights[index];
		const renderedHeight = Math.min(fullHeight, input.viewportHeight);
		const maxScrollOffset = fullHeight - renderedHeight;
		const contentRange = OffsetRange.ofStartAndLength(contentTop, fullHeight);
		const renderedRange = OffsetRange.ofStartAndLength(renderedTop, renderedHeight);
		let visibility;
		let scrollOffset;
		if (contentRange.isBefore(contentViewport)) {
			visibility = "before";
			scrollOffset = maxScrollOffset;
		} else if (contentRange.isAfter(contentViewport)) {
			visibility = "after";
			scrollOffset = 0;
		} else {
			visibility = "visible";
			scrollOffset = Math.max(0, Math.min(contentViewport.start - contentRange.start, maxScrollOffset));
		}
		hiddenContentHeightAboveViewport += scrollOffset;
		items.push({
			contentRange,
			renderedRange,
			maxScrollOffset,
			scrollOffset,
			visibility
		});
		if (index < input.itemHeights.length - 1) {
			contentTop += fullHeight + input.itemGap;
			renderedTop += renderedHeight + input.itemGap;
		} else {
			contentTop += fullHeight;
			renderedTop += renderedHeight;
		}
	}
	const renderedScrollTop = scrollTop - hiddenContentHeightAboveViewport;
	return {
		revision: input.revision ?? asLayoutRevision(0),
		scrollTop,
		logicalScrollHeight,
		scrollHeight,
		leadingScrollSlack,
		trailingScrollSlack,
		renderedHeight: renderedTop + trailingScrollSlack,
		contentViewport,
		renderedViewport: OffsetRange.ofStartAndLength(renderedScrollTop, input.viewportHeight),
		hiddenContentHeightAboveViewport,
		items
	};
}
function computeItemRanges(itemHeights, itemGap) {
	assertNonNegative("itemGap", itemGap);
	const ranges = [];
	let offset = 0;
	for (let index = 0; index < itemHeights.length; index++) {
		const height = itemHeights[index];
		assertNonNegative(`itemHeights[${index}]`, height);
		ranges.push(OffsetRange.ofStartAndLength(offset, height));
		offset += height + (index < itemHeights.length - 1 ? itemGap : 0);
	}
	return ranges;
}
function createAnchoredSizeEditBatch(fromRevision, toRevision, oldItemHeights, newItemHeights, oldItemGap, newItemGap, anchorOffset) {
	if (oldItemHeights.length !== newItemHeights.length) throw new BugIndicatingError("Size edits require stable item identity and ordering");
	const oldRanges = computeItemRanges(oldItemHeights, oldItemGap);
	const newRanges = computeItemRanges(newItemHeights, newItemGap);
	const edits = [];
	for (let index = 0; index < oldRanges.length; index++) if (!oldRanges[index].equals(newRanges[index])) edits.push({
		oldRange: oldRanges[index],
		newRange: newRanges[index]
	});
	return {
		fromRevision,
		toRevision,
		edits,
		anchor: {
			revision: fromRevision,
			offset: anchorOffset
		}
	};
}
function mapLogicalPosition(position, edit) {
	if (position.revision !== edit.fromRevision) throw new BugIndicatingError(`Cannot map layout revision ${position.revision} through revision ${edit.fromRevision}`);
	let mappedOffset = position.offset;
	for (const sizeEdit of edit.edits) {
		if (position.offset < sizeEdit.oldRange.start) break;
		if (sizeEdit.oldRange.contains(position.offset)) {
			const relativeOffset = position.offset - sizeEdit.oldRange.start;
			mappedOffset = relativeOffset < sizeEdit.newRange.length ? sizeEdit.newRange.start + relativeOffset : sizeEdit.newRange.start;
			return {
				revision: edit.toRevision,
				offset: mappedOffset
			};
		}
		mappedOffset = position.offset + sizeEdit.newRange.endExclusive - sizeEdit.oldRange.endExclusive;
	}
	return {
		revision: edit.toRevision,
		offset: mappedOffset
	};
}
function computeCompressedVirtualizedScrollHeight(itemHeights, itemGap) {
	assertNonNegative("itemGap", itemGap);
	for (let i = 0; i < itemHeights.length; i++) assertNonNegative(`itemHeights[${i}]`, itemHeights[i]);
	if (itemHeights.length === 0) return 0;
	return itemHeights.reduce((result, height) => result + height, 0) + itemGap * (itemHeights.length - 1);
}
function assertNonNegative(name, value) {
	if (!Number.isFinite(value) || value < 0) throw new BugIndicatingError(`${name} must be a finite non-negative number, got ${value}`);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/multiDiffEditor/compressedVirtualizedScrollView.js
var scrollDirectionRetentionDurationMs = 100;
/**
* Virtualizes complete-height items into viewport-capped rows whose removed height is represented by item-local scrolling.
*/
var CompressedVirtualizedScrollView = class extends Disposable {
	constructor(elementToObserve, dimension, itemGap, createItems) {
		super();
		this._lastGeometryEdit = observableValue(this, void 0);
		this._itemAnchorEditSignal = observableSignal(this);
		this._revision = asLayoutRevision(0);
		this._leadingScrollSlack = 0;
		this._trailingScrollSlack = 0;
		this._previousItemGap = 0;
		this._lastScrollTop = 0;
		this._clearScrollDirection = this._register(new RunOnceScheduler(() => this._lastScrollDirection = void 0, scrollDirectionRetentionDurationMs));
		this._isUpdating = false;
		this.lastGeometryEdit = this._lastGeometryEdit;
		this._scrollableElements = h("div.scrollContent", [h("div@content", { style: {
			overflow: "hidden",
			position: "relative"
		} }), h("div.monaco-editor@overflowWidgetsDomNode")]);
		this._scrollable = this._register(new Scrollable({
			forceIntegerValues: false,
			scheduleAtNextAnimationFrame: (callback) => scheduleAtNextAnimationFrame(getWindow(elementToObserve), callback),
			smoothScrollDuration: 100
		}));
		this._scrollableElement = this._register(new SmoothScrollableElement(this._scrollableElements.root, {
			vertical: 1,
			horizontal: 1,
			useShadows: false
		}, this._scrollable));
		this.domNode = h("div", {}, [this._scrollableElement.getDomNode()]).root;
		this._sizeObserver = this._register(new ObservableElementSizeObserver(elementToObserve, void 0));
		this.scrollTop = observableFromEvent(this, this._scrollableElement.onScroll, () => this._scrollableElement.getScrollPosition().scrollTop);
		this.scrollLeft = observableFromEvent(this, this._scrollableElement.onScroll, () => this._scrollableElement.getScrollPosition().scrollLeft);
		this._items = createItems({
			contentDomNode: this._scrollableElements.content,
			overflowWidgetsDomNode: this._scrollableElements.overflowWidgetsDomNode,
			scrollLeft: this.scrollLeft
		});
		this._layout = observableValue(this, computeCompressedVirtualizedScrollLayout({
			revision: this._revision,
			scrollTop: 0,
			viewportHeight: 0,
			itemGap: 0,
			itemHeights: []
		}));
		this.layout = this._layout;
		this._scrollDimensions = observableValue(this, {
			width: 0,
			height: 0,
			scrollWidth: 0,
			scrollHeight: 0
		});
		this.scrollDimensions = this._scrollDimensions;
		this._register(autorun((reader) => {
			this._sizeObserver.observe(dimension.read(reader));
		}));
		this._register(autorun((reader) => {
			this._itemAnchorEditSignal.read(reader);
			const width = this._sizeObserver.width.read(reader);
			const height = this._sizeObserver.height.read(reader);
			const items = this._items.read(reader);
			const itemHeights = items.map((item) => item.size.read(reader));
			const maxScroll = findFirstMax(items, compareBy((item) => item.maxScroll.read(reader).maxScroll, numberComparator))?.maxScroll.read(reader).maxScroll ?? 0;
			const gap = itemGap.read(reader);
			const requestedScrollTop = this.scrollTop.read(reader);
			globalTransaction((tx) => this._update(items, itemHeights, gap, width, height, width + maxScroll, requestedScrollTop, tx));
		}));
	}
	setScrollPosition(position, smooth = false) {
		this._scrollableElement.setScrollPosition({
			...position,
			reuseAnimation: smooth
		});
	}
	setLogicalScrollPosition(scrollTop, smooth = false) {
		this.setScrollPosition({ scrollTop: this._leadingScrollSlack + scrollTop }, smooth);
	}
	getScrollPosition() {
		return this._scrollableElement.getScrollPosition();
	}
	_runWithItemScrollAnchor(item, getItemOffset, update) {
		const itemIndex = this._items.get().findIndex((candidate) => candidate === item);
		if (itemIndex === -1) throw new BugIndicatingError("Cannot anchor an item that is not in the compacted virtualized scroll view");
		const itemRange = this._layout.get().items[itemIndex].contentRange;
		const itemOffset = getItemOffset();
		if (!Number.isFinite(itemOffset) || itemOffset < 0 || itemOffset > itemRange.length) throw new BugIndicatingError(`Item anchor ${itemOffset} is outside item range ${itemRange}`);
		const position = {
			revision: this._revision,
			offset: itemRange.start + itemOffset
		};
		const logicalViewportTop = this.getScrollPosition().scrollTop - this._leadingScrollSlack;
		this._runWithPendingAnchor({
			position,
			viewportOffset: position.offset - logicalViewportTop,
			item,
			getItemOffset
		}, (tx) => {
			update(tx);
			if (getItemOffset() !== itemOffset) this._itemAnchorEditSignal.trigger(tx);
		});
	}
	_runWithPendingAnchor(pendingAnchor, update) {
		if (this._pendingAnchor) throw new BugIndicatingError("Cannot nest compacted virtualized scroll anchors");
		this._pendingAnchor = pendingAnchor;
		try {
			globalTransaction(update);
		} finally {
			if (this._pendingAnchor === pendingAnchor) this._pendingAnchor = void 0;
		}
	}
	_update(items, itemHeights, itemGap, width, height, scrollWidth, requestedScrollTop, tx) {
		if (this._isUpdating) return;
		this._isUpdating = true;
		try {
			let targetScrollTop = requestedScrollTop;
			const scrollDelta = requestedScrollTop - this._lastScrollTop;
			if (scrollDelta !== 0) {
				this._lastScrollDirection = scrollDelta < 0 ? "up" : "down";
				this._clearScrollDirection.schedule();
			}
			const previousItemHeights = this._previousItemHeights;
			const geometryChanged = previousItemHeights !== void 0 && (itemGap !== this._previousItemGap || !arrayEquals(previousItemHeights, itemHeights));
			const hasStableItems = this._previousItems !== void 0 && this._previousItems.length === items.length && this._previousItems.every((item, index) => item === items[index]);
			const itemsChanged = this._previousItems !== void 0 && !hasStableItems;
			let didApplyAnchor = false;
			const appliesPendingAnchor = !!this._pendingAnchor && hasStableItems;
			if (previousItemHeights && (geometryChanged || appliesPendingAnchor) && hasStableItems) {
				const oldLogicalScrollHeight = computeCompressedVirtualizedScrollHeight(previousItemHeights, this._previousItemGap);
				const oldLogicalViewportTop = requestedScrollTop - this._leadingScrollSlack;
				const pendingAnchor = this._pendingAnchor;
				const isScrollingUp = this._lastScrollDirection === "up";
				const defaultAnchorViewportOffset = isScrollingUp ? height : 0;
				const anchorKind = pendingAnchor?.item ? "item" : pendingAnchor ? "logical" : isScrollingUp ? "viewportBottom" : "viewportTop";
				const anchorOffset = pendingAnchor?.position.offset ?? Math.max(0, Math.min(oldLogicalViewportTop + defaultAnchorViewportOffset, oldLogicalScrollHeight));
				const anchorViewportOffset = pendingAnchor?.viewportOffset ?? anchorOffset - oldLogicalViewportTop;
				const fromRevision = this._revision;
				const toRevision = geometryChanged ? asLayoutRevision(fromRevision + 1) : fromRevision;
				const edit = createAnchoredSizeEditBatch(fromRevision, toRevision, previousItemHeights, itemHeights, this._previousItemGap, itemGap, anchorOffset);
				let mappedAnchor = mapLogicalPosition(edit.anchor, edit);
				if (pendingAnchor?.item && pendingAnchor.getItemOffset) {
					const itemIndex = items.findIndex((item) => item === pendingAnchor.item);
					if (itemIndex === -1) throw new BugIndicatingError("Compacted virtualized scroll anchor item was removed during its edit");
					const itemRange = computeItemRanges(itemHeights, itemGap)[itemIndex];
					const itemOffset = pendingAnchor.getItemOffset();
					if (!Number.isFinite(itemOffset) || itemOffset < 0 || itemOffset > itemRange.length) throw new BugIndicatingError(`Mapped item anchor ${itemOffset} is outside item range ${itemRange}`);
					mappedAnchor = {
						revision: toRevision,
						offset: itemRange.start + itemOffset
					};
				}
				const newLogicalScrollHeight = computeCompressedVirtualizedScrollHeight(itemHeights, itemGap);
				const desiredLogicalScrollTop = mappedAnchor.offset - anchorViewportOffset;
				const naturalMaxScrollTop = Math.max(0, newLogicalScrollHeight - height);
				this._leadingScrollSlack = Math.max(0, -desiredLogicalScrollTop);
				this._trailingScrollSlack = Math.max(0, desiredLogicalScrollTop - naturalMaxScrollTop);
				targetScrollTop = this._leadingScrollSlack + desiredLogicalScrollTop;
				this._revision = toRevision;
				this._pendingAnchor = void 0;
				didApplyAnchor = true;
				this._lastGeometryEdit.set({
					fromRevision,
					toRevision,
					edits: edit.edits,
					anchorKind,
					anchorOffset,
					mappedAnchorOffset: mappedAnchor.offset,
					anchorViewportOffset,
					desiredScrollTop: targetScrollTop,
					appliedScrollTop: targetScrollTop,
					leadingScrollSlack: this._leadingScrollSlack,
					trailingScrollSlack: this._trailingScrollSlack
				}, tx);
			} else if (geometryChanged || itemsChanged) {
				if (geometryChanged) this._revision = asLayoutRevision(this._revision + 1);
				this._leadingScrollSlack = 0;
				this._trailingScrollSlack = 0;
				this._lastGeometryEdit.set(void 0, tx);
			} else if (scrollDelta > 0 && this._leadingScrollSlack > 0) {
				const consumedSlack = Math.min(scrollDelta, this._leadingScrollSlack);
				this._leadingScrollSlack -= consumedSlack;
				targetScrollTop -= consumedSlack;
			} else if (scrollDelta < 0 && this._trailingScrollSlack > 0) {
				const logicalScrollHeight = computeCompressedVirtualizedScrollHeight(itemHeights, itemGap);
				const naturalMaxScrollTop = this._leadingScrollSlack + Math.max(0, logicalScrollHeight - height);
				this._trailingScrollSlack = Math.max(0, targetScrollTop - naturalMaxScrollTop);
			}
			let layout = computeCompressedVirtualizedScrollLayout({
				revision: this._revision,
				scrollTop: targetScrollTop,
				viewportHeight: height,
				itemGap,
				itemHeights,
				leadingScrollSlack: this._leadingScrollSlack,
				trailingScrollSlack: this._trailingScrollSlack
			});
			const dimensions = {
				width,
				height,
				scrollWidth,
				scrollHeight: layout.scrollHeight
			};
			this._scrollableElements.root.style.height = `${height}px`;
			this._scrollableElements.content.style.height = `${layout.scrollHeight}px`;
			this._scrollable.setScrollDimensions(dimensions, true);
			if (geometryChanged || targetScrollTop !== requestedScrollTop) this._scrollable.setScrollPositionNow({ scrollTop: layout.scrollTop });
			const appliedScrollTop = this._scrollableElement.getScrollPosition().scrollTop;
			if (appliedScrollTop !== layout.scrollTop) layout = computeCompressedVirtualizedScrollLayout({
				revision: this._revision,
				scrollTop: appliedScrollTop,
				viewportHeight: height,
				itemGap,
				itemHeights,
				leadingScrollSlack: this._leadingScrollSlack,
				trailingScrollSlack: this._trailingScrollSlack
			});
			const geometryEdit = this._lastGeometryEdit.get();
			if (didApplyAnchor && geometryEdit) this._lastGeometryEdit.set({
				...geometryEdit,
				appliedScrollTop
			}, tx);
			this._layout.set(layout, tx);
			this._scrollDimensions.set(dimensions, tx);
			this._render(items, layout, width);
			this._previousItems = items;
			this._previousItemHeights = itemHeights;
			this._previousItemGap = itemGap;
			this._lastScrollTop = layout.scrollTop;
		} finally {
			this._isUpdating = false;
		}
	}
	_render(items, layout, width) {
		for (let index = 0; index < items.length; index++) {
			const item = items[index];
			const itemLayout = layout.items[index];
			if (itemLayout.visibility !== "visible") item.hide();
			else item.render(itemLayout.renderedRange, itemLayout.scrollOffset, width, layout.renderedViewport, { runWithScrollAnchor: (getItemOffset, update) => this._runWithItemScrollAnchor(item, getItemOffset, update) });
		}
		this._scrollableElements.content.style.transform = `translateY(${-layout.renderedViewport.start}px)`;
	}
};
function arrayEquals(a, b) {
	return a.length === b.length && a.every((value, index) => value === b[index]);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/multiDiffEditor/multiDiffEditorLogging.js
/**
* Trace logger for the multi diff editor. Logs the state transitions that are
* hard to observe from the outside (scroll offsets that are set programmatically,
* content height changes, collapsed state changes and view state save/restore),
* so bugs like "the editor jumped while scrolling" or "this file was expanded
* even though it was collapsed" can be reconstructed from the log.
*
* Enable with `Developer: Set Log Level...` > `Window` > `Trace`.
*/
var MultiDiffEditorLogger = class extends Disposable {
	constructor(_logService) {
		super();
		this._logService = _logService;
		/** Last logged collapsed state per diff item, to only log actual changes. */
		this._lastLoggedCollapsed = /* @__PURE__ */ new Map();
		/** Last logged content height per diff item, to only log actual changes. */
		this._lastLoggedContentHeight = /* @__PURE__ */ new Map();
		this._isEnabled = observableFromEvent(this, this._logService.onDidChangeLogLevel, () => this._logService.getLevel() <= LogLevel.Trace);
	}
	/**
	* Whether trace logging is on. Check this before computing data that is only
	* needed for logging.
	*/
	get isEnabled() {
		return this._isEnabled.get();
	}
	log(message, data) {
		if (!this.isEnabled) return;
		const formattedData = data ? Object.entries(data).map(([key, value]) => `${key}: ${formatValue(value)}`).join(", ") : void 0;
		this._logService.trace(`[MultiDiffEditor] ${message}${formattedData ? ` (${formattedData})` : ""}`);
	}
	/**
	* Traces the state transitions that cannot be reconstructed after the fact:
	* view model/loading changes, collapsed state changes (no matter who caused
	* them) and content height changes, which are the usual cause of the view
	* jumping while scrolling. Per-frame rendering is deliberately not traced.
	*
	* The observers only exist while trace logging is on, so nothing is observed
	* (and no state is tracked) in the default case; they are recreated when the
	* log level is raised to trace again.
	*/
	logStateChanges(state) {
		this._register(autorunWithStore((reader, store) => {
			if (!this._isEnabled.read(reader)) return;
			store.add(toDisposable(() => {
				this._lastLoggedCollapsed.clear();
				this._lastLoggedContentHeight.clear();
			}));
			store.add(autorun((reader) => {
				const viewModel = state.viewModel.read(reader);
				this.log("view model changed", {
					hasViewModel: !!viewModel,
					isLoading: viewModel?.isLoading.read(reader),
					preserveFocusOnLoad: state.isPreserveFocusOnLoad()
				});
			}));
			store.add(autorun((reader) => {
				const changed = [];
				for (const item of state.items.read(reader)) {
					const collapsed = item.collapsed.read(reader);
					const key = item.getKey();
					if (this._lastLoggedCollapsed.get(key) !== collapsed) {
						this._lastLoggedCollapsed.set(key, collapsed);
						changed.push(`${item.getLabel()}=${collapsed}`);
					}
				}
				if (changed.length > 0) this.log("collapsed state changed", { changed });
			}));
			store.add(autorun((reader) => {
				const scrollTop = state.getScrollTop();
				const changed = [];
				let totalHeight = 0;
				for (const item of state.items.read(reader)) {
					const contentHeight = item.contentHeight.read(reader);
					const key = item.getKey();
					const lastContentHeight = this._lastLoggedContentHeight.get(key);
					if (lastContentHeight !== contentHeight) {
						const abovePosition = totalHeight < scrollTop ? " (above scroll offset)" : "";
						changed.push(`${item.getLabel()}: ${lastContentHeight ?? "?"} -> ${contentHeight}${abovePosition}`);
						this._lastLoggedContentHeight.set(key, contentHeight);
					}
					totalHeight += contentHeight + state.spaceBetweenPx;
				}
				if (changed.length > 0) this.log("content height changed", {
					changed,
					totalHeight,
					scrollTop
				});
			}));
		}));
	}
};
/** Short, log friendly name of a diff item resource. */
function formatUri(uri) {
	if (!uri) return "<none>";
	return basename(uri) || uri.authority || uri.scheme;
}
/** Turns a {@link DocumentDiffItemViewModel.getKey} value into a short log label. */
function formatDiffItemKey(key) {
	if (key === void 0) return "<none>";
	try {
		const [original, modified] = JSON.parse(key);
		const uri = modified ?? original;
		return uri ? formatUri(URI.parse(uri)) : "<none>";
	} catch {
		return key;
	}
}
function formatValue(value) {
	if (value === void 0) return "<undefined>";
	if (URI.isUri(value)) return formatUri(value);
	if (Array.isArray(value)) return `[${value.map(formatValue).join(", ")}]`;
	if (typeof value === "number") return String(Math.round(value * 100) / 100);
	if (typeof value === "object") return JSON.stringify(value);
	return String(value);
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/multiDiffEditor/multiDiffEditorWidgetImpl.js
var __decorate$1 = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param$1 = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var MultiDiffEditorWidgetImpl = class MultiDiffEditorWidgetImpl extends Disposable {
	constructor(_element, _dimension, _viewModel, _workbenchUIElementFactory, _variantConfiguration, _diffLayoutOptions, _diffEditorOptions, _paddingBottomPx, _parentContextKeyService, _parentInstantiationService, logService) {
		super();
		this._element = _element;
		this._dimension = _dimension;
		this._viewModel = _viewModel;
		this._workbenchUIElementFactory = _workbenchUIElementFactory;
		this._variantConfiguration = _variantConfiguration;
		this._diffLayoutOptions = _diffLayoutOptions;
		this._diffEditorOptions = _diffEditorOptions;
		this._paddingBottomPx = _paddingBottomPx;
		this._parentContextKeyService = _parentContextKeyService;
		this._parentInstantiationService = _parentInstantiationService;
		/**
		* When `true`, the automatic "select the first change" initialization that
		* runs once the view model finishes loading does not move keyboard focus
		* into the editor. Driven by {@link setPreserveFocusOnLoad} so a
		* `preserveFocus` open (e.g. restored in the background or on a session
		* switch) does not steal focus, while a normal user-initiated open does.
		*/
		this._preserveFocusOnLoad = false;
		this._hasAppliedPendingScrollState = false;
		this._logger = this._register(new MultiDiffEditorLogger(logService));
		this._optionsOverride = derived(this, (reader) => {
			return {
				...this._diffEditorOptions,
				...this._diffLayoutOptions.read(reader)
			};
		});
		this._spaceBetweenPx = observableValue(this, 0);
		const paddingBottomItem = this._paddingBottomPx.map(this, (size) => ({
			size: constObservable(size),
			maxScroll: constObservable({ maxScroll: 0 }),
			render() {},
			hide() {}
		}));
		let viewItemsInfo;
		let viewItems;
		this._scrollView = this._register(new CompressedVirtualizedScrollView(this._element, this._dimension, this._spaceBetweenPx, (context) => {
			const sourceItems = derived(this, (reader) => this._viewModel.read(reader)?.items.read(reader) ?? []);
			const manager = this._register(new VirtualizedItemManager(sourceItems, context, {
				getId: (item) => item,
				getTemplateId: () => "diffEditor",
				getUnboundSize: (item) => derived(item, (reader) => {
					const headerHeight = this._variantConfiguration.headerHeight;
					if (item.collapsed.read(reader)) return headerHeight;
					if (item.isBinary) return headerHeight + this._variantConfiguration.contentBottomPadding + 100;
					return item.lastTemplateData.read(reader).expandedContentHeight;
				}),
				createTemplate: () => this._instantiationService.createInstance(DiffEditorItemTemplate, context.contentDomNode, context.overflowWidgetsDomNode, this._workbenchUIElementFactory, this._variantConfiguration, this._optionsOverride),
				onDidBind: (binding) => {
					const selections = binding.item.lastTemplateData.get().selections;
					this._logger.log("acquired editor template", {
						file: formatUri(binding.item.modifiedUri ?? binding.item.originalUri),
						collapsed: binding.item.collapsed.get(),
						expectedExpandedContentHeight: binding.item.lastTemplateData.get().expandedContentHeight,
						selections: selections?.length ?? 0
					});
					if (selections) binding.editor.setSelections(selections);
				},
				onWillUnbind: (binding, tx) => {
					this._logger.log("releasing editor template", {
						file: formatUri(binding.item.modifiedUri ?? binding.item.originalUri),
						contentHeight: binding.size.get()
					});
					binding.item.lastTemplateData.set({
						expandedContentHeight: binding.getExpandedContentHeight(),
						selections: binding.editor.getSelections() ?? void 0
					}, tx);
				}
			}));
			const adaptedItems = mapObservableArrayCached(this, manager.virtualizedItems, (item, store) => {
				const adaptedItem = store.add(new VirtualizedViewItem(item, context.scrollLeft, this._logger));
				const data = this._lastDocStates?.[adaptedItem.getKey()];
				if (data) transaction((tx) => adaptedItem.setViewState(data, tx));
				return adaptedItem;
			}).recomputeInitiallyAndOnChange(this._store);
			viewItemsInfo = derived(this, (reader) => {
				const items = adaptedItems.read(reader);
				const map = new Map(items.map((item) => [item.viewModel, item]));
				const restoredDocStates = items.filter((item) => this._lastDocStates?.[item.getKey()] !== void 0).length;
				this._logger.log("view items updated", {
					items: items.length,
					restoredDocStates
				});
				return {
					items,
					getItem: (d) => map.get(d)
				};
			});
			viewItems = viewItemsInfo.map(this, (items) => items.items);
			return derived(this, (reader) => [...viewItems.read(reader), paddingBottomItem.read(reader)]);
		}));
		this._viewItemsInfo = viewItemsInfo;
		this._viewItems = viewItems;
		this.scrollTop = this._scrollView.scrollTop;
		this.scrollLeft = this._scrollView.scrollLeft;
		this.layoutDebugState = derived(this, (reader) => {
			const layout = this._scrollView.layout.read(reader);
			const items = this._viewItems.read(reader);
			const geometryEdit = this._scrollView.lastGeometryEdit.read(reader);
			return {
				scrollLeft: this.scrollLeft.read(reader),
				scrollDimensions: this._scrollView.scrollDimensions.read(reader),
				layout: {
					revision: layout.revision,
					scrollTop: layout.scrollTop,
					logicalScrollHeight: layout.logicalScrollHeight,
					scrollHeight: layout.scrollHeight,
					renderedHeight: layout.renderedHeight,
					leadingScrollSlack: layout.leadingScrollSlack,
					trailingScrollSlack: layout.trailingScrollSlack,
					contentViewport: serializeOffsetRange(layout.contentViewport),
					renderedViewport: serializeOffsetRange(layout.renderedViewport),
					hiddenContentHeightAboveViewport: layout.hiddenContentHeightAboveViewport
				},
				geometryEdit: geometryEdit ? {
					...geometryEdit,
					edits: geometryEdit.edits.map((edit) => ({
						oldRange: serializeOffsetRange(edit.oldRange),
						newRange: serializeOffsetRange(edit.newRange)
					}))
				} : void 0,
				items: items.map((item, index) => item.getLayoutDebugState(reader, layout.items[index]))
			};
		});
		const variantClassNames = this._variantConfiguration.classNames.map((className) => `.${className}`).join("");
		this._elements = h(`div.monaco-component.multiDiffEditor${variantClassNames}`, {}, [this._scrollView.domNode, h("div.placeholder@placeholder", {}, [h("div")])]);
		this.activeControl = derived(this, (reader) => {
			const activeDiffItem = this._viewModel.read(reader)?.activeDiffItem.read(reader);
			if (!activeDiffItem) return;
			return this._viewItemsInfo.read(reader).getItem(activeDiffItem).template.read(reader)?.editor;
		});
		this._contextKeyService = this._register(this._parentContextKeyService.createScoped(this._element));
		this._instantiationService = this._register(this._parentInstantiationService.createChild(new ServiceCollection([IContextKeyService, this._contextKeyService])));
		this._contextKeyService.createKey(EditorContextKeys.inMultiDiffEditor.key, true);
		this._register(bindContextKey(EditorContextKeys.diffEditorAutomaticRenderSideBySide, this._contextKeyService, (reader) => this.activeControl.read(reader)?.renderSideBySideInAutomaticMode.read(reader) ?? true));
		this._register(bindContextKey(EditorContextKeys.diffEditorTemporaryInlineMode, this._contextKeyService, (reader) => this.activeControl.read(reader)?.temporaryInlineMode.read(reader) ?? false));
		this._lastDocStates = {};
		this._register(autorunWithStore((reader, store) => {
			const viewModel = this._viewModel.read(reader);
			if (viewModel && viewModel.contextKeys) for (const [key, value] of Object.entries(viewModel.contextKeys)) {
				const contextKey = this._contextKeyService.createKey(key, void 0);
				contextKey.set(value);
				store.add(toDisposable(() => contextKey.reset()));
			}
		}));
		const ctxAllCollapsed = this._parentContextKeyService.createKey(EditorContextKeys.multiDiffEditorAllCollapsed.key, false);
		this._register(autorun((reader) => {
			const viewModel = this._viewModel.read(reader);
			if (viewModel) {
				const allCollapsed = viewModel.items.read(reader).every((item) => item.collapsed.read(reader));
				ctxAllCollapsed.set(allCollapsed);
			}
		}));
		const ctxRenderSideBySide = this._parentContextKeyService.createKey(EditorContextKeys.multiDiffEditorRenderSideBySide.key, true);
		this._register(autorun((reader) => {
			const renderSideBySide = this._diffLayoutOptions.read(reader)?.renderSideBySide;
			if (renderSideBySide !== void 0) ctxRenderSideBySide.set(renderSideBySide);
		}));
		this._logger.logStateChanges({
			viewModel: this._viewModel,
			items: this._viewItems,
			spaceBetweenPx: this._spaceBetweenPx.get(),
			getScrollTop: () => this._scrollView.getScrollPosition().scrollTop,
			isPreserveFocusOnLoad: () => this._preserveFocusOnLoad
		});
		const placeholderMessage = derived((reader) => {
			if (this._viewItems.read(reader).length > 0) return;
			const vm = this._viewModel.read(reader);
			return !vm || vm.isLoading.read(reader) ? localize(166, "Loading...") : localize(167, "No Changed Files");
		});
		this._register(autorun((reader) => {
			const message = placeholderMessage.read(reader);
			this._elements.placeholder.innerText = message ?? "";
			this._elements.placeholder.classList.toggle("visible", !!message);
		}));
		this._register(autorun((reader) => {
			this._scrollView.scrollDimensions.read(reader);
			this._applyPendingScrollState();
		}));
		_element.replaceChildren(this._elements.root);
		this._register(toDisposable(() => {
			_element.replaceChildren();
		}));
		this._register(autorun((reader) => {
			/** @description Initialize first change */
			const viewModel = this._viewModel.read(reader);
			if (!viewModel) return;
			if (!viewModel.isLoading.read(reader)) {
				const items = viewModel.items.read(reader);
				if (items.length === 0) return;
				if (viewModel.activeDiffItem.read(reader)) return;
				if (this._restorePendingActiveDiffItem(viewModel, items)) return;
				this._logger.log("no active diff item after loading, selecting first change", { items: items.length });
				this._navigateToChange("next", !this._preserveFocusOnLoad);
			}
		}));
	}
	setScrollState(scrollState) {
		this._pendingScrollState = scrollState;
		this._hasAppliedPendingScrollState = false;
		this._lastPendingScrollDimensions = void 0;
		this._applyPendingScrollState();
	}
	/**
	* Retries a restored scroll offset as dimensions change until it lands.
	* Navigation away from the clamped offset with unchanged dimensions cancels restoration.
	*/
	_applyPendingScrollState() {
		const pending = this._pendingScrollState;
		if (!pending) return;
		const dimensions = this._scrollView.scrollDimensions.get();
		const current = this._scrollView.getScrollPosition();
		const expectedTop = pending.top === void 0 ? current.scrollTop : Math.min(Math.max(0, pending.top), Math.max(0, dimensions.scrollHeight - dimensions.height));
		const expectedLeft = pending.left === void 0 ? current.scrollLeft : Math.min(Math.max(0, pending.left), Math.max(0, dimensions.scrollWidth - dimensions.width));
		const previousDimensions = this._lastPendingScrollDimensions;
		const dimensionsChanged = !previousDimensions || previousDimensions.width !== dimensions.width || previousDimensions.height !== dimensions.height || previousDimensions.scrollWidth !== dimensions.scrollWidth || previousDimensions.scrollHeight !== dimensions.scrollHeight;
		if (this._hasAppliedPendingScrollState && !dimensionsChanged && (current.scrollTop !== expectedTop || current.scrollLeft !== expectedLeft)) {
			this._pendingScrollState = void 0;
			this._hasAppliedPendingScrollState = false;
			this._lastPendingScrollDimensions = void 0;
			return;
		}
		this._scrollView.setScrollPosition({
			scrollLeft: pending.left,
			scrollTop: pending.top
		});
		const applied = this._scrollView.getScrollPosition();
		const topLanded = pending.top === void 0 || applied.scrollTop >= pending.top;
		const leftLanded = pending.left === void 0 || applied.scrollLeft >= pending.left;
		if (topLanded && leftLanded) {
			this._pendingScrollState = void 0;
			this._hasAppliedPendingScrollState = false;
			this._lastPendingScrollDimensions = void 0;
		} else {
			this._hasAppliedPendingScrollState = true;
			this._lastPendingScrollDimensions = dimensions;
		}
		this._logger.log("applied pending scroll state", {
			requested: pending,
			applied: {
				top: applied.scrollTop,
				left: applied.scrollLeft
			},
			landed: topLanded && leftLanded
		});
	}
	/**
	* Controls whether the automatic first-change selection that runs once the
	* view model finishes loading preserves focus instead of moving it into the
	* editor. Set to `true` for `preserveFocus` opens so focus is not stolen
	* from elsewhere.
	*/
	setPreserveFocusOnLoad(preserveFocus) {
		this._preserveFocusOnLoad = preserveFocus;
	}
	reveal(resource, options) {
		const viewItems = this._viewItems.get();
		const index = viewItems.findIndex((item) => item.viewModel.originalUri?.toString() === resource.original?.toString() && item.viewModel.modifiedUri?.toString() === resource.modified?.toString());
		if (index === -1) throw new BugIndicatingError("Resource not found in diff editor");
		const viewItem = viewItems[index];
		this._viewModel.get().activeDiffItem.setCache(viewItem.viewModel, void 0);
		let scrollTop = 0;
		for (let i = 0; i < index; i++) scrollTop += viewItems[i].contentHeight.get() + this._spaceBetweenPx.get();
		this._logger.log("reveal", {
			file: viewItem.getLabel(),
			index,
			scrollTop: `${this._scrollView.getScrollPosition().scrollTop} -> ${scrollTop}`,
			range: options?.range
		});
		this._scrollView.setLogicalScrollPosition(scrollTop);
		const diffEditor = viewItem.template.get()?.editor;
		const editor = "original" in resource ? diffEditor?.getOriginalEditor() : diffEditor?.getModifiedEditor();
		if (editor && options?.range) {
			editor.revealRangeInCenter(options.range);
			highlightRange(editor, options.range);
		}
	}
	getViewState() {
		const viewState = {
			scrollState: {
				top: this.scrollTop.get(),
				left: this.scrollLeft.get()
			},
			docStates: Object.fromEntries(this._viewItems.get().map((i) => [i.getKey(), i.getViewState()])),
			activeDiffItemKey: this._viewModel.get()?.activeDiffItem.get()?.getKey()
		};
		if (this._logger.isEnabled) {
			const docStates = Object.values(viewState.docStates ?? {});
			this._logger.log("get view state", {
				scrollTop: viewState.scrollState.top,
				scrollLeft: viewState.scrollState.left,
				docStates: docStates.length,
				collapsed: docStates.filter((s) => s.collapsed).length,
				activeDiffItem: formatDiffItemKey(viewState.activeDiffItemKey)
			});
		}
		return viewState;
	}
	setViewState(viewState, tx) {
		if (this._logger.isEnabled) {
			const docStates = Object.values(viewState.docStates ?? {});
			this._logger.log("set view state", {
				scrollTop: viewState.scrollState.top,
				scrollLeft: viewState.scrollState.left,
				docStates: docStates.length,
				collapsed: docStates.filter((s) => s.collapsed).length,
				activeDiffItem: formatDiffItemKey(viewState.activeDiffItemKey),
				viewItems: this._viewItems.get().length
			});
		}
		this.setScrollState(viewState.scrollState);
		this._lastDocStates = viewState.docStates;
		this._lastActiveDiffItemKey = viewState.activeDiffItemKey;
		const applyDocStates = (tx) => {
			if (viewState.docStates) for (const i of this._viewItems.get()) {
				const state = viewState.docStates[i.getKey()];
				if (state) i.setViewState(state, tx);
			}
		};
		if (tx) applyDocStates(tx);
		else transaction(applyDocStates);
		const viewModel = this._viewModel.get();
		if (viewModel) this._restorePendingActiveDiffItem(viewModel, viewModel.items.get());
	}
	/**
	* Restores the persisted active diff item (if any) onto the view model, so the
	* automatic first-change navigation is skipped. On an explicit (non-preserve-focus)
	* open it also moves focus into the restored item's editor, mirroring the
	* first-change navigation it replaces. Returns whether it was applied.
	*/
	_restorePendingActiveDiffItem(viewModel, items) {
		const key = this._lastActiveDiffItemKey;
		if (key === void 0 || items.length === 0) return false;
		this._lastActiveDiffItemKey = void 0;
		const target = items.find((i) => i.getKey() === key);
		if (!target) {
			if (this._logger.isEnabled) this._logger.log("persisted active diff item not found", {
				key: formatDiffItemKey(key),
				availableKeys: items.map((i) => formatDiffItemKey(i.getKey()))
			});
			return false;
		}
		this._logger.log("restored active diff item", {
			file: target.modifiedUri ?? target.originalUri,
			preserveFocus: this._preserveFocusOnLoad
		});
		viewModel.activeDiffItem.setCache(target, void 0);
		if (!this._preserveFocusOnLoad) this._viewItemsInfo.get().getItem(target).binding.get()?.focus();
		return true;
	}
	_navigateToChange(direction, focusEditor = true) {
		const viewItems = this._viewItems.get();
		if (viewItems.length === 0) return;
		const activeViewModel = this._viewModel.get()?.activeDiffItem.get();
		const currentIndex = activeViewModel ? viewItems.findIndex((v) => v.viewModel === activeViewModel) : -1;
		this._logger.log("navigate to change", {
			direction,
			focusEditor,
			currentIndex,
			items: viewItems.length
		});
		if (currentIndex === -1) {
			this._goToFile(0, "first", focusEditor);
			return;
		}
		const currentItem = viewItems[currentIndex];
		if (currentItem.viewModel.collapsed.get()) {
			this._logger.log("expanding collapsed item to navigate within it", { file: currentItem.getLabel() });
			currentItem.viewModel.collapsed.set(false, void 0);
		}
		const editor = currentItem.template.get()?.editor;
		if (editor?.getDiffComputationResult()?.changes2?.length) {
			const pos = editor.getModifiedEditor().getPosition()?.lineNumber || 1;
			const changes = editor.getDiffComputationResult().changes2;
			if (direction === "next" ? changes.some((c) => c.modified.startLineNumber > pos) : changes.some((c) => c.modified.endLineNumberExclusive <= pos)) {
				editor.goToDiff(direction);
				return;
			}
		}
		const nextIndex = (currentIndex + (direction === "next" ? 1 : -1) + viewItems.length) % viewItems.length;
		this._goToFile(nextIndex, direction === "next" ? "first" : "last", focusEditor);
	}
	_goToFile(index, position, focusEditor = true) {
		const item = this._viewItems.get()[index];
		const wasCollapsed = item.viewModel.collapsed.get();
		this._logger.log("go to file", {
			file: item.getLabel(),
			index,
			position,
			focusEditor,
			wasCollapsed
		});
		if (wasCollapsed) item.viewModel.collapsed.set(false, void 0);
		this.reveal({
			original: item.viewModel.originalUri,
			modified: item.viewModel.modifiedUri
		});
		const editor = item.template.get()?.editor;
		if (editor?.getDiffComputationResult()?.changes2?.length) {
			if (position === "first") editor.revealFirstDiff();
			else {
				const lastChange = editor.getDiffComputationResult().changes2.at(-1);
				const modifiedEditor = editor.getModifiedEditor();
				modifiedEditor.setPosition({
					lineNumber: lastChange.modified.startLineNumber,
					column: 1
				});
				modifiedEditor.revealLineInCenter(lastChange.modified.startLineNumber);
			}
		}
		if (focusEditor) item.binding.get()?.focus();
	}
};
MultiDiffEditorWidgetImpl = __decorate$1([
	__param$1(8, IContextKeyService),
	__param$1(9, IInstantiationService),
	__param$1(10, ILogService)
], MultiDiffEditorWidgetImpl);
function highlightRange(targetEditor, range) {
	const modelNow = targetEditor.getModel();
	const decorations = targetEditor.createDecorationsCollection([{
		range,
		options: {
			description: "symbol-navigate-action-highlight",
			className: "symbolHighlight"
		}
	}]);
	setTimeout(() => {
		if (targetEditor.getModel() === modelNow) decorations.clear();
	}, 350);
}
function serializeOffsetRange(range) {
	return {
		start: range.start,
		endExclusive: range.endExclusive
	};
}
var VirtualizedViewItem = class extends Disposable {
	get collapsed() {
		return this.viewModel.collapsed;
	}
	getLayoutDebugState(reader, layout) {
		const binding = this.binding.read(reader);
		return {
			key: this.getKey(),
			label: this.getLabel(),
			originalUri: this.viewModel.originalUri?.toString() ?? null,
			modifiedUri: this.viewModel.modifiedUri?.toString() ?? null,
			collapsed: this.collapsed.read(reader),
			hasTemplate: binding !== void 0,
			verticalState: {
				contentHeight: this.size.read(reader),
				itemViewportOffset: layout.scrollOffset
			},
			maxScroll: this.maxScroll.read(reader).maxScroll,
			layout: {
				contentRange: serializeOffsetRange(layout.contentRange),
				renderedRange: serializeOffsetRange(layout.renderedRange),
				maxScrollOffset: layout.maxScrollOffset,
				scrollOffset: layout.scrollOffset,
				visibility: layout.visibility
			}
		};
	}
	constructor(_managedItem, _scrollLeft, _logger) {
		super();
		this._managedItem = _managedItem;
		this._scrollLeft = _scrollLeft;
		this._logger = _logger;
		this.size = _managedItem.size;
		this.contentHeight = this.size;
		this.maxScroll = _managedItem.maxScroll;
		this.template = _managedItem.template;
		this.binding = _managedItem.binding;
		this.viewModel = _managedItem.item;
		this._isFocused = derived(this, (reader) => this.template.read(reader)?.isFocused.read(reader) ?? false);
		this.viewModel.setIsFocused(this._isFocused, void 0);
		this._register(autorun((reader) => {
			const scrollLeft = this._scrollLeft.read(reader);
			this.binding.read(reader)?.setScrollLeft(scrollLeft);
		}));
	}
	toString() {
		return `VirtualViewItem(${this.viewModel.modifiedUri?.toString() ?? this.viewModel.originalUri?.toString()})`;
	}
	getKey() {
		return this.viewModel.getKey();
	}
	/** Short, log friendly name of this item. */
	getLabel() {
		return formatUri(this.viewModel.modifiedUri ?? this.viewModel.originalUri);
	}
	getViewState() {
		transaction((tx) => {
			this._updateTemplateData(tx);
		});
		return {
			collapsed: this.viewModel.collapsed.get(),
			selections: this.viewModel.lastTemplateData.get().selections
		};
	}
	setViewState(viewState, tx) {
		this._logger.log("item view state restored", {
			file: this.getLabel(),
			collapsed: viewState.collapsed,
			selections: viewState.selections?.length ?? 0
		});
		this.viewModel.collapsed.set(viewState.collapsed, tx);
		this._updateTemplateData(tx);
		const data = this.viewModel.lastTemplateData.get();
		const selections = viewState.selections?.map(Selection$1.liftSelection);
		this.viewModel.lastTemplateData.set({
			...data,
			selections
		}, tx);
		const binding = this.binding.get();
		if (binding && selections) binding.editor.setSelections(selections);
	}
	_updateTemplateData(tx) {
		const binding = this.binding.get();
		if (!binding) return;
		this.viewModel.lastTemplateData.set({
			expandedContentHeight: binding.getExpandedContentHeight(),
			selections: binding.editor.getSelections() ?? void 0
		}, tx);
	}
	hide() {
		this._managedItem.hide();
	}
	render(verticalSpace, offset, width, viewPort, context) {
		this._managedItem.render(verticalSpace, offset, width, viewPort, context);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/browser/widget/multiDiffEditor/multiDiffEditorWidget.js
var __decorate = function(decorators, target, key, desc) {
	var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = function(paramIndex, decorator) {
	return function(target, key) {
		decorator(target, key, paramIndex);
	};
};
var MultiDiffEditorWidget = class MultiDiffEditorWidget extends Disposable {
	constructor(_element, _workbenchUIElementFactory, _options, _instantiationService) {
		super();
		this._element = _element;
		this._workbenchUIElementFactory = _workbenchUIElementFactory;
		this._options = _options;
		this._instantiationService = _instantiationService;
		this._dimension = observableValue(this, void 0);
		this._viewModel = observableValue(this, void 0);
		this._diffLayoutOptions = observableValue(this, void 0);
		this._paddingBottomPx = observableValue(this, 0);
		this._widgetImplDisposable = this._register(new MutableDisposable());
		this._variant = this._options.variant;
		const initialWidgetImpl = this._createWidgetImpl(MultiDiffEditorWidgetImpl);
		this._widgetImplDisposable.value = initialWidgetImpl;
		this._widgetImplValue = observableValue(this, initialWidgetImpl);
		this._widgetImpl = this._widgetImplValue;
		let isInitialHotReloadRun = true;
		this._register(autorun((reader) => {
			const widgetImpl = readHotReloadableExport(MultiDiffEditorWidgetImpl);
			if (isInitialHotReloadRun) {
				isInitialHotReloadRun = false;
				return;
			}
			this._replaceWidgetImpl(widgetImpl);
		}));
	}
	_createWidgetImpl(widgetImpl) {
		return this._instantiationService.createInstance(widgetImpl, this._element, this._dimension, this._viewModel, this._workbenchUIElementFactory, getMultiDiffEditorVariantConfiguration(this._variant), this._diffLayoutOptions, this._options.diffEditorOptions, this._paddingBottomPx);
	}
	_replaceWidgetImpl(widgetImpl) {
		const previousImpl = this._widgetImplValue.get();
		const viewState = previousImpl.getViewState();
		const viewModel = this._viewModel.get();
		const previousControl = previousImpl.activeControl.get();
		const focusedEditor = previousControl?.getOriginalEditor().hasTextFocus() ? "original" : previousControl?.getModifiedEditor().hasTextFocus() ? "modified" : void 0;
		this._viewModel.set(void 0, void 0);
		this._widgetImplDisposable.clear();
		const newImpl = this._createWidgetImpl(widgetImpl);
		this._widgetImplDisposable.value = newImpl;
		newImpl.setPreserveFocusOnLoad(true);
		transaction((tx) => {
			this._viewModel.set(viewModel, tx);
			newImpl.setViewState(viewState, tx);
		});
		if (focusedEditor === "original") newImpl.activeControl.get()?.getOriginalEditor().focus();
		else if (focusedEditor === "modified") newImpl.activeControl.get()?.getModifiedEditor().focus();
		newImpl.setPreserveFocusOnLoad(false);
		this._widgetImplValue.set(newImpl, void 0);
	}
};
MultiDiffEditorWidget = __decorate([__param(3, IInstantiationService)], MultiDiffEditorWidget);
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/standalone/browser/standaloneEditor.js
/**
* Create a new editor under `domElement`.
* `domElement` should be empty (not contain other dom nodes).
* The editor will read the size of `domElement`.
*/
function create(domElement, options, override) {
	return StandaloneServices.initialize(override || {}).createInstance(StandaloneEditor, domElement, options);
}
/**
* Emitted when an editor is created.
* Creating a diff editor might cause this listener to be invoked with the two editors.
* @event
*/
function onDidCreateEditor(listener) {
	return StandaloneServices.get(ICodeEditorService).onCodeEditorAdd((editor) => {
		listener(editor);
	});
}
/**
* Emitted when an diff editor is created.
* @event
*/
function onDidCreateDiffEditor(listener) {
	return StandaloneServices.get(ICodeEditorService).onDiffEditorAdd((editor) => {
		listener(editor);
	});
}
/**
* Get all the created editors.
*/
function getEditors() {
	return StandaloneServices.get(ICodeEditorService).listCodeEditors();
}
/**
* Get all the created diff editors.
*/
function getDiffEditors() {
	return StandaloneServices.get(ICodeEditorService).listDiffEditors();
}
/**
* Create a new diff editor under `domElement`.
* `domElement` should be empty (not contain other dom nodes).
* The editor will read the size of `domElement`.
*/
function createDiffEditor(domElement, options, override) {
	return StandaloneServices.initialize(override || {}).createInstance(StandaloneDiffEditor2, domElement, options);
}
function createMultiFileDiffEditor(domElement, override) {
	const instantiationService = StandaloneServices.initialize(override || {});
	return new MultiDiffEditorWidget(domElement, {}, { variant: "noCardsNonCompact" }, instantiationService);
}
/**
* Add a command.
*/
function addCommand(descriptor) {
	if (typeof descriptor.id !== "string" || typeof descriptor.run !== "function") throw new Error("Invalid command descriptor, `id` and `run` are required properties!");
	return CommandsRegistry.registerCommand(descriptor.id, descriptor.run);
}
/**
* Add an action to all editors.
*/
function addEditorAction(descriptor) {
	if (typeof descriptor.id !== "string" || typeof descriptor.label !== "string" || typeof descriptor.run !== "function") throw new Error("Invalid action descriptor, `id`, `label` and `run` are required properties!");
	const precondition = ContextKeyExpr.deserialize(descriptor.precondition);
	const run = (accessor, ...args) => {
		return EditorCommand.runEditorCommand(accessor, args, precondition, (accessor, editor, args) => Promise.resolve(descriptor.run(editor, ...args)));
	};
	const toDispose = new DisposableStore();
	toDispose.add(CommandsRegistry.registerCommand(descriptor.id, run));
	if (descriptor.contextMenuGroupId) {
		const menuItem = {
			command: {
				id: descriptor.id,
				title: descriptor.label
			},
			when: precondition,
			group: descriptor.contextMenuGroupId,
			order: descriptor.contextMenuOrder || 0
		};
		toDispose.add(MenuRegistry.appendMenuItem(MenuId.EditorContext, menuItem));
	}
	if (Array.isArray(descriptor.keybindings)) {
		const keybindingService = StandaloneServices.get(IKeybindingService);
		if (!(keybindingService instanceof StandaloneKeybindingService)) console.warn("Cannot add keybinding because the editor is configured with an unrecognized KeybindingService");
		else {
			const keybindingsWhen = ContextKeyExpr.and(precondition, ContextKeyExpr.deserialize(descriptor.keybindingContext));
			toDispose.add(keybindingService.addDynamicKeybindings(descriptor.keybindings.map((keybinding) => {
				return {
					keybinding,
					command: descriptor.id,
					when: keybindingsWhen
				};
			})));
		}
	}
	return toDispose;
}
/**
* Add a keybinding rule.
*/
function addKeybindingRule(rule) {
	return addKeybindingRules([rule]);
}
/**
* Add keybinding rules.
*/
function addKeybindingRules(rules) {
	const keybindingService = StandaloneServices.get(IKeybindingService);
	if (!(keybindingService instanceof StandaloneKeybindingService)) {
		console.warn("Cannot add keybinding because the editor is configured with an unrecognized KeybindingService");
		return Disposable.None;
	}
	return keybindingService.addDynamicKeybindings(rules.map((rule) => {
		return {
			keybinding: rule.keybinding,
			command: rule.command,
			commandArgs: rule.commandArgs,
			when: ContextKeyExpr.deserialize(rule.when)
		};
	}));
}
/**
* Create a new editor model.
* You can specify the language that should be set for this model or let the language be inferred from the `uri`.
*/
function createModel(value, language, uri) {
	const languageService = StandaloneServices.get(ILanguageService);
	const languageId = languageService.getLanguageIdByMimeType(language) || language;
	return createTextModel(StandaloneServices.get(IModelService), languageService, value, languageId, uri);
}
/**
* Change the language for a model.
*/
function setModelLanguage(model, mimeTypeOrLanguageId) {
	const languageService = StandaloneServices.get(ILanguageService);
	const languageId = languageService.getLanguageIdByMimeType(mimeTypeOrLanguageId) || mimeTypeOrLanguageId || "plaintext";
	model.setLanguage(languageService.createById(languageId));
}
/**
* Set the markers for a model.
*/
function setModelMarkers(model, owner, markers) {
	if (model) StandaloneServices.get(IMarkerService).changeOne(owner, model.uri, markers);
}
/**
* Remove all markers of an owner.
*/
function removeAllMarkers(owner) {
	StandaloneServices.get(IMarkerService).changeAll(owner, []);
}
/**
* Get markers for owner and/or resource
*
* @returns list of markers
*/
function getModelMarkers(filter) {
	return StandaloneServices.get(IMarkerService).read(filter);
}
/**
* Emitted when markers change for a model.
* @event
*/
function onDidChangeMarkers(listener) {
	return StandaloneServices.get(IMarkerService).onMarkerChanged(listener);
}
/**
* Get the model that has `uri` if it exists.
*/
function getModel(uri) {
	return StandaloneServices.get(IModelService).getModel(uri);
}
/**
* Get all the created models.
*/
function getModels() {
	return StandaloneServices.get(IModelService).getModels();
}
/**
* Emitted when a model is created.
* @event
*/
function onDidCreateModel(listener) {
	return StandaloneServices.get(IModelService).onModelAdded(listener);
}
/**
* Emitted right before a model is disposed.
* @event
*/
function onWillDisposeModel(listener) {
	return StandaloneServices.get(IModelService).onModelRemoved(listener);
}
/**
* Emitted when a different language is set to a model.
* @event
*/
function onDidChangeModelLanguage(listener) {
	return StandaloneServices.get(IModelService).onModelLanguageChanged((e) => {
		listener({
			model: e.model,
			oldLanguage: e.oldLanguageId
		});
	});
}
/**
* Create a new web worker that has model syncing capabilities built in.
* Specify an AMD module to load that will `create` an object that will be proxied.
*/
function createWebWorker(opts) {
	return createWebWorker$1(StandaloneServices.get(IModelService), StandaloneServices.get(IWebWorkerService), opts);
}
/**
* Colorize the contents of `domNode` using attribute `data-lang`.
*/
function colorizeElement(domNode, options) {
	const languageService = StandaloneServices.get(ILanguageService);
	const themeService = StandaloneServices.get(IStandaloneThemeService);
	return Colorizer.colorizeElement(themeService, languageService, domNode, options).then(() => {
		themeService.registerEditorContainer(domNode);
	});
}
/**
* Colorize `text` using language `languageId`.
*/
function colorize(text, languageId, options) {
	const languageService = StandaloneServices.get(ILanguageService);
	StandaloneServices.get(IStandaloneThemeService).registerEditorContainer(mainWindow.document.body);
	return Colorizer.colorize(languageService, text, languageId, options);
}
/**
* Colorize a line in a model.
*/
function colorizeModelLine(model, lineNumber, tabSize = 4) {
	StandaloneServices.get(IStandaloneThemeService).registerEditorContainer(mainWindow.document.body);
	return Colorizer.colorizeModelLine(model, lineNumber, tabSize);
}
/**
* @internal
*/
function getSafeTokenizationSupport(language) {
	const tokenizationSupport = TokenizationRegistry.get(language);
	if (tokenizationSupport) return tokenizationSupport;
	return {
		getInitialState: () => NullState,
		tokenize: (line, hasEOL, state) => nullTokenize(language, state)
	};
}
/**
* Tokenize `text` using language `languageId`
*/
function tokenize(text, languageId) {
	TokenizationRegistry.getOrCreate(languageId);
	const tokenizationSupport = getSafeTokenizationSupport(languageId);
	const lines = splitLines(text);
	const result = [];
	let state = tokenizationSupport.getInitialState();
	for (let i = 0, len = lines.length; i < len; i++) {
		const line = lines[i];
		const tokenizationResult = tokenizationSupport.tokenize(line, true, state);
		result[i] = tokenizationResult.tokens;
		state = tokenizationResult.endState;
	}
	return result;
}
/**
* Define a new theme or update an existing theme.
*/
function defineTheme(themeName, themeData) {
	StandaloneServices.get(IStandaloneThemeService).defineTheme(themeName, themeData);
}
/**
* Switches to a theme.
*/
function setTheme(themeName) {
	StandaloneServices.get(IStandaloneThemeService).setTheme(themeName);
}
/**
* Clears all cached font measurements and triggers re-measurement.
*/
function remeasureFonts() {
	FontMeasurements.clearAllFontInfos();
}
/**
* Register a command.
*/
function registerCommand(id, handler) {
	return CommandsRegistry.registerCommand({
		id,
		handler
	});
}
/**
* Registers a handler that is called when a link is opened in any editor. The handler callback should return `true` if the link was handled and `false` otherwise.
* The handler that was registered last will be called first when a link is opened.
*
* Returns a disposable that can unregister the opener again.
*/
function registerLinkOpener(opener) {
	return StandaloneServices.get(IOpenerService).registerOpener({ async open(resource) {
		if (typeof resource === "string") resource = URI.parse(resource);
		return opener.open(resource);
	} });
}
/**
* Registers a handler that is called when a resource other than the current model should be opened in the editor (e.g. "go to definition").
* The handler callback should return `true` if the request was handled and `false` otherwise.
*
* Returns a disposable that can unregister the opener again.
*
* If no handler is registered the default behavior is to do nothing for models other than the currently attached one.
*/
function registerEditorOpener(opener) {
	return StandaloneServices.get(ICodeEditorService).registerCodeEditorOpenHandler(async (input, source, sideBySide) => {
		if (!source) return null;
		const selection = input.options?.selection;
		let selectionOrPosition;
		if (selection && typeof selection.endLineNumber === "number" && typeof selection.endColumn === "number") selectionOrPosition = selection;
		else if (selection) selectionOrPosition = {
			lineNumber: selection.startLineNumber,
			column: selection.startColumn
		};
		if (await opener.openCodeEditor(source, input.resource, selectionOrPosition)) return source;
		return null;
	});
}
/**
* @internal
*/
function createMonacoEditorAPI() {
	return {
		create,
		getEditors,
		getDiffEditors,
		onDidCreateEditor,
		onDidCreateDiffEditor,
		createDiffEditor,
		addCommand,
		addEditorAction,
		addKeybindingRule,
		addKeybindingRules,
		createModel,
		setModelLanguage,
		setModelMarkers,
		getModelMarkers,
		removeAllMarkers,
		onDidChangeMarkers,
		getModels,
		getModel,
		onDidCreateModel,
		onWillDisposeModel,
		onDidChangeModelLanguage,
		createWebWorker,
		colorizeElement,
		colorize,
		colorizeModelLine,
		tokenize,
		defineTheme,
		setTheme,
		remeasureFonts,
		registerCommand,
		registerLinkOpener,
		registerEditorOpener,
		AccessibilitySupport,
		ContentWidgetPositionPreference,
		CursorChangeReason,
		DefaultEndOfLine,
		EditorAutoIndentStrategy,
		EditorOption,
		EndOfLinePreference,
		EndOfLineSequence,
		MinimapPosition,
		MinimapSectionHeaderStyle,
		MouseTargetType,
		OverlayWidgetPositionPreference,
		OverviewRulerLane: OverviewRulerLane$1,
		GlyphMarginLane: GlyphMarginLane$1,
		RenderLineNumbersType,
		RenderMinimap,
		ScrollbarVisibility,
		ScrollType,
		TextEditorCursorBlinkingStyle,
		TextEditorCursorStyle: TextEditorCursorStyle$1,
		TrackedRangeStickiness,
		WrappingIndent,
		InjectedTextCursorStops: InjectedTextCursorStops$1,
		PositionAffinity,
		ShowLightbulbIconMode: ShowLightbulbIconMode$1,
		TextDirection: TextDirection$1,
		ConfigurationChangedEvent,
		BareFontInfo,
		FontInfo,
		TextModelResolvedOptions,
		FindMatch,
		ApplyUpdateResult,
		EditorZoom,
		createMultiFileDiffEditor,
		EditorType,
		EditorOptions
	};
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/standalone/common/monarch/monarchCompile.js
function isArrayOf(elemType, obj) {
	if (!obj) return false;
	if (!Array.isArray(obj)) return false;
	for (const el of obj) if (!elemType(el)) return false;
	return true;
}
function bool(prop, defValue) {
	if (typeof prop === "boolean") return prop;
	return defValue;
}
function string(prop, defValue) {
	if (typeof prop === "string") return prop;
	return defValue;
}
function arrayToHash(array) {
	const result = {};
	for (const e of array) result[e] = true;
	return result;
}
function createKeywordMatcher(arr, caseInsensitive = false) {
	if (caseInsensitive) arr = arr.map(function(x) {
		return x.toLowerCase();
	});
	const hash = arrayToHash(arr);
	if (caseInsensitive) return function(word) {
		return hash[word.toLowerCase()] !== void 0 && hash.hasOwnProperty(word.toLowerCase());
	};
	else return function(word) {
		return hash[word] !== void 0 && hash.hasOwnProperty(word);
	};
}
function compileRegExp(lexer, str, handleSn) {
	str = str.replace(/@@/g, `\x01`);
	let n = 0;
	let hadExpansion;
	do {
		hadExpansion = false;
		str = str.replace(/@(\w+)/g, function(s, attr) {
			hadExpansion = true;
			let sub = "";
			if (typeof lexer[attr] === "string") sub = lexer[attr];
			else if (lexer[attr] && lexer[attr] instanceof RegExp) sub = lexer[attr].source;
			else if (lexer[attr] === void 0) throw createError(lexer, "language definition does not contain attribute '" + attr + "', used at: " + str);
			else throw createError(lexer, "attribute reference '" + attr + "' must be a string, used at: " + str);
			return empty(sub) ? "" : "(?:" + sub + ")";
		});
		n++;
	} while (hadExpansion && n < 5);
	str = str.replace(/\x01/g, "@");
	const flags = (lexer.ignoreCase ? "i" : "") + (lexer.unicode ? "u" : "");
	if (handleSn) {
		if (str.match(/\$[sS](\d\d?)/g)) {
			let lastState = null;
			let lastRegEx = null;
			return (state) => {
				if (lastRegEx && lastState === state) return lastRegEx;
				lastState = state;
				lastRegEx = new RegExp(substituteMatchesRe(lexer, str, state), flags);
				return lastRegEx;
			};
		}
	}
	return new RegExp(str, flags);
}
/**
* Compiles guard functions for case matches.
* This compiles 'cases' attributes into efficient match functions.
*
*/
function selectScrutinee(id, matches, state, num) {
	if (num < 0) return id;
	if (num < matches.length) return matches[num];
	if (num >= 100) {
		num = num - 100;
		const parts = state.split(".");
		parts.unshift(state);
		if (num < parts.length) return parts[num];
	}
	return null;
}
function createGuard(lexer, ruleName, tkey, val) {
	let scrut = -1;
	let oppat = tkey;
	let matches = tkey.match(/^\$(([sS]?)(\d\d?)|#)(.*)$/);
	if (matches) {
		if (matches[3]) {
			scrut = parseInt(matches[3]);
			if (matches[2]) scrut = scrut + 100;
		}
		oppat = matches[4];
	}
	let op = "~";
	let pat = oppat;
	if (!oppat || oppat.length === 0) {
		op = "!=";
		pat = "";
	} else if (/^\w*$/.test(pat)) op = "==";
	else {
		matches = oppat.match(/^(@|!@|~|!~|==|!=)(.*)$/);
		if (matches) {
			op = matches[1];
			pat = matches[2];
		}
	}
	let tester;
	if ((op === "~" || op === "!~") && /^(\w|\|)*$/.test(pat)) {
		const inWords = createKeywordMatcher(pat.split("|"), lexer.ignoreCase);
		tester = function(s) {
			return op === "~" ? inWords(s) : !inWords(s);
		};
	} else if (op === "@" || op === "!@") {
		const words = lexer[pat];
		if (!words) throw createError(lexer, "the @ match target '" + pat + "' is not defined, in rule: " + ruleName);
		if (!isArrayOf(function(elem) {
			return typeof elem === "string";
		}, words)) throw createError(lexer, "the @ match target '" + pat + "' must be an array of strings, in rule: " + ruleName);
		const inWords = createKeywordMatcher(words, lexer.ignoreCase);
		tester = function(s) {
			return op === "@" ? inWords(s) : !inWords(s);
		};
	} else if (op === "~" || op === "!~") {
		if (pat.indexOf("$") < 0) {
			const re = compileRegExp(lexer, "^" + pat + "$", false);
			tester = function(s) {
				return op === "~" ? re.test(s) : !re.test(s);
			};
		} else tester = function(s, id, matches, state) {
			return compileRegExp(lexer, "^" + substituteMatches(lexer, pat, id, matches, state) + "$", false).test(s);
		};
	} else if (pat.indexOf("$") < 0) {
		const patx = fixCase(lexer, pat);
		tester = function(s) {
			return op === "==" ? s === patx : s !== patx;
		};
	} else {
		const patx = fixCase(lexer, pat);
		tester = function(s, id, matches, state, eos) {
			const patexp = substituteMatches(lexer, patx, id, matches, state);
			return op === "==" ? s === patexp : s !== patexp;
		};
	}
	if (scrut === -1) return {
		name: tkey,
		value: val,
		test: function(id, matches, state, eos) {
			return tester(id, id, matches, state, eos);
		}
	};
	else return {
		name: tkey,
		value: val,
		test: function(id, matches, state, eos) {
			const scrutinee = selectScrutinee(id, matches, state, scrut);
			return tester(!scrutinee ? "" : scrutinee, id, matches, state, eos);
		}
	};
}
/**
* Compiles an action: i.e. optimize regular expressions and case matches
* and do many sanity checks.
*
* This is called only during compilation but if the lexer definition
* contains user functions as actions (which is usually not allowed), then this
* may be called during lexing. It is important therefore to compile common cases efficiently
*/
function compileAction(lexer, ruleName, action) {
	if (!action) return { token: "" };
	else if (typeof action === "string") return action;
	else if (action.token || action.token === "") {
		if (typeof action.token !== "string") throw createError(lexer, "a 'token' attribute must be of type string, in rule: " + ruleName);
		else {
			const newAction = { token: action.token };
			if (action.token.indexOf("$") >= 0) newAction.tokenSubst = true;
			if (typeof action.bracket === "string") {
				if (action.bracket === "@open") newAction.bracket = 1;
				else if (action.bracket === "@close") newAction.bracket = -1;
				else throw createError(lexer, "a 'bracket' attribute must be either '@open' or '@close', in rule: " + ruleName);
			}
			if (action.next) {
				if (typeof action.next !== "string") throw createError(lexer, "the next state must be a string value in rule: " + ruleName);
				else {
					let next = action.next;
					if (!/^(@pop|@push|@popall)$/.test(next)) {
						if (next[0] === "@") next = next.substr(1);
						if (next.indexOf("$") < 0) {
							if (!stateExists(lexer, substituteMatches(lexer, next, "", [], ""))) throw createError(lexer, "the next state '" + action.next + "' is not defined in rule: " + ruleName);
						}
					}
					newAction.next = next;
				}
			}
			if (typeof action.goBack === "number") newAction.goBack = action.goBack;
			if (typeof action.switchTo === "string") newAction.switchTo = action.switchTo;
			if (typeof action.log === "string") newAction.log = action.log;
			if (typeof action.nextEmbedded === "string") {
				newAction.nextEmbedded = action.nextEmbedded;
				lexer.usesEmbedded = true;
			}
			return newAction;
		}
	} else if (Array.isArray(action)) {
		const results = [];
		for (let i = 0, len = action.length; i < len; i++) results[i] = compileAction(lexer, ruleName, action[i]);
		return { group: results };
	} else if (action.cases) {
		const cases = [];
		let hasEmbeddedEndInCases = false;
		for (const tkey in action.cases) if (action.cases.hasOwnProperty(tkey)) {
			const val = compileAction(lexer, ruleName, action.cases[tkey]);
			if (tkey === "@default" || tkey === "@" || tkey === "") cases.push({
				test: void 0,
				value: val,
				name: tkey
			});
			else if (tkey === "@eos") cases.push({
				test: function(id, matches, state, eos) {
					return eos;
				},
				value: val,
				name: tkey
			});
			else cases.push(createGuard(lexer, ruleName, tkey, val));
			if (!hasEmbeddedEndInCases) hasEmbeddedEndInCases = !isString$1(val) && (val.hasEmbeddedEndInCases || ["@pop", "@popall"].includes(val.nextEmbedded || ""));
		}
		const def = lexer.defaultToken;
		return {
			hasEmbeddedEndInCases,
			test: function(id, matches, state, eos) {
				for (const _case of cases) if (!_case.test || _case.test(id, matches, state, eos)) return _case.value;
				return def;
			}
		};
	} else throw createError(lexer, "an action must be a string, an object with a 'token' or 'cases' attribute, or an array of actions; in rule: " + ruleName);
}
/**
* Helper class for creating matching rules
*/
var Rule = class {
	constructor(name) {
		this.regex = /* @__PURE__ */ new RegExp("");
		this.action = { token: "" };
		this.matchOnlyAtLineStart = false;
		this.name = "";
		this.name = name;
	}
	setRegex(lexer, re) {
		let sregex;
		if (typeof re === "string") sregex = re;
		else if (re instanceof RegExp) sregex = re.source;
		else throw createError(lexer, "rules must start with a match string or regular expression: " + this.name);
		this.matchOnlyAtLineStart = sregex.length > 0 && sregex[0] === "^";
		this.name = this.name + ": " + sregex;
		this.regex = compileRegExp(lexer, "^(?:" + (this.matchOnlyAtLineStart ? sregex.substr(1) : sregex) + ")", true);
	}
	setAction(lexer, act) {
		this.action = compileAction(lexer, this.name, act);
	}
	resolveRegex(state) {
		if (this.regex instanceof RegExp) return this.regex;
		else return this.regex(state);
	}
};
/**
* Compiles a json description function into json where all regular expressions,
* case matches etc, are compiled and all include rules are expanded.
* We also compile the bracket definitions, supply defaults, and do many sanity checks.
* If the 'jsonStrict' parameter is 'false', we allow at certain locations
* regular expression objects and functions that get called during lexing.
* (Currently we have no samples that need this so perhaps we should always have
* jsonStrict to true).
*/
function compile(languageId, json) {
	if (!json || typeof json !== "object") throw new Error("Monarch: expecting a language definition object");
	const lexer = {
		languageId,
		includeLF: bool(json.includeLF, false),
		noThrow: false,
		maxStack: 100,
		start: typeof json.start === "string" ? json.start : null,
		ignoreCase: bool(json.ignoreCase, false),
		unicode: bool(json.unicode, false),
		tokenPostfix: string(json.tokenPostfix, "." + languageId),
		defaultToken: string(json.defaultToken, "source"),
		usesEmbedded: false,
		stateNames: {},
		tokenizer: {},
		brackets: []
	};
	const lexerMin = json;
	lexerMin.languageId = languageId;
	lexerMin.includeLF = lexer.includeLF;
	lexerMin.ignoreCase = lexer.ignoreCase;
	lexerMin.unicode = lexer.unicode;
	lexerMin.noThrow = lexer.noThrow;
	lexerMin.usesEmbedded = lexer.usesEmbedded;
	lexerMin.stateNames = json.tokenizer;
	lexerMin.defaultToken = lexer.defaultToken;
	function addRules(state, newrules, rules) {
		for (const rule of rules) {
			let include = rule.include;
			if (include) {
				if (typeof include !== "string") throw createError(lexer, "an 'include' attribute must be a string at: " + state);
				if (include[0] === "@") include = include.substr(1);
				if (!json.tokenizer[include]) throw createError(lexer, "include target '" + include + "' is not defined at: " + state);
				addRules(state + "." + include, newrules, json.tokenizer[include]);
			} else {
				const newrule = new Rule(state);
				if (Array.isArray(rule) && rule.length >= 1 && rule.length <= 3) {
					newrule.setRegex(lexerMin, rule[0]);
					if (rule.length >= 3) {
						if (typeof rule[1] === "string") newrule.setAction(lexerMin, {
							token: rule[1],
							next: rule[2]
						});
						else if (typeof rule[1] === "object") {
							const rule1 = rule[1];
							rule1.next = rule[2];
							newrule.setAction(lexerMin, rule1);
						} else throw createError(lexer, "a next state as the last element of a rule can only be given if the action is either an object or a string, at: " + state);
					} else newrule.setAction(lexerMin, rule[1]);
				} else {
					if (!rule.regex) throw createError(lexer, "a rule must either be an array, or an object with a 'regex' or 'include' field at: " + state);
					if (rule.name) {
						if (typeof rule.name === "string") newrule.name = rule.name;
					}
					if (rule.matchOnlyAtStart) newrule.matchOnlyAtLineStart = bool(rule.matchOnlyAtLineStart, false);
					newrule.setRegex(lexerMin, rule.regex);
					newrule.setAction(lexerMin, rule.action);
				}
				newrules.push(newrule);
			}
		}
	}
	if (!json.tokenizer || typeof json.tokenizer !== "object") throw createError(lexer, "a language definition must define the 'tokenizer' attribute as an object");
	lexer.tokenizer = [];
	for (const key in json.tokenizer) if (json.tokenizer.hasOwnProperty(key)) {
		if (!lexer.start) lexer.start = key;
		const rules = json.tokenizer[key];
		lexer.tokenizer[key] = new Array();
		addRules("tokenizer." + key, lexer.tokenizer[key], rules);
	}
	lexer.usesEmbedded = lexerMin.usesEmbedded;
	if (json.brackets) {
		if (!Array.isArray(json.brackets)) throw createError(lexer, "the 'brackets' attribute must be defined as an array");
	} else json.brackets = [
		{
			open: "{",
			close: "}",
			token: "delimiter.curly"
		},
		{
			open: "[",
			close: "]",
			token: "delimiter.square"
		},
		{
			open: "(",
			close: ")",
			token: "delimiter.parenthesis"
		},
		{
			open: "<",
			close: ">",
			token: "delimiter.angle"
		}
	];
	const brackets = [];
	for (const el of json.brackets) {
		let desc = el;
		if (desc && Array.isArray(desc) && desc.length === 3) desc = {
			token: desc[2],
			open: desc[0],
			close: desc[1]
		};
		if (desc.open === desc.close) throw createError(lexer, "open and close brackets in a 'brackets' attribute must be different: " + desc.open + "\n hint: use the 'bracket' attribute if matching on equal brackets is required.");
		if (typeof desc.open === "string" && typeof desc.token === "string" && typeof desc.close === "string") brackets.push({
			token: desc.token + lexer.tokenPostfix,
			open: fixCase(lexer, desc.open),
			close: fixCase(lexer, desc.close)
		});
		else throw createError(lexer, "every element in the 'brackets' array must be a '{open,close,token}' object or array");
	}
	lexer.brackets = brackets;
	lexer.noThrow = true;
	return lexer;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/standalone/browser/standaloneLanguages.js
/**
* Register information about a new language.
*/
function register(language) {
	ModesRegistry.registerLanguage(language);
}
/**
* Get the information of all the registered languages.
*/
function getLanguages() {
	let result = [];
	result = result.concat(ModesRegistry.getLanguages());
	return result;
}
function getEncodedLanguageId(languageId) {
	return StandaloneServices.get(ILanguageService).languageIdCodec.encodeLanguageId(languageId);
}
/**
* Compute the score of a language selector against a candidate URI and language.
*/
function score(selector, candidateUri, candidateLanguage) {
	return score$1(selector, candidateUri, candidateLanguage, true, void 0, void 0);
}
/**
* An event emitted when a language is associated for the first time with a text model.
* @event
*/
function onLanguage(languageId, callback) {
	return StandaloneServices.withServices(() => {
		const disposable = StandaloneServices.get(ILanguageService).onDidRequestRichLanguageFeatures((encounteredLanguageId) => {
			if (encounteredLanguageId === languageId) {
				disposable.dispose();
				callback();
			}
		});
		return disposable;
	});
}
/**
* An event emitted when a language is associated for the first time with a text model or
* when a language is encountered during the tokenization of another language.
* @event
*/
function onLanguageEncountered(languageId, callback) {
	return StandaloneServices.withServices(() => {
		const disposable = StandaloneServices.get(ILanguageService).onDidRequestBasicLanguageFeatures((encounteredLanguageId) => {
			if (encounteredLanguageId === languageId) {
				disposable.dispose();
				callback();
			}
		});
		return disposable;
	});
}
/**
* Set the editing configuration for a language.
*/
function setLanguageConfiguration(languageId, configuration) {
	if (!StandaloneServices.get(ILanguageService).isRegisteredLanguageId(languageId)) throw new Error(`Cannot set configuration for unknown language ${languageId}`);
	return StandaloneServices.get(ILanguageConfigurationService).register(languageId, configuration, 100);
}
/**
* @internal
*/
var EncodedTokenizationSupportAdapter = class {
	constructor(languageId, actual) {
		this._languageId = languageId;
		this._actual = actual;
	}
	dispose() {}
	getInitialState() {
		return this._actual.getInitialState();
	}
	tokenize(line, hasEOL, state) {
		if (typeof this._actual.tokenize === "function") return TokenizationSupportAdapter.adaptTokenize(this._languageId, this._actual, line, state);
		throw new Error("Not supported!");
	}
	tokenizeEncoded(line, hasEOL, state) {
		const result = this._actual.tokenizeEncoded(line, state);
		return new EncodedTokenizationResult(result.tokens, [], result.endState);
	}
};
/**
* @internal
*/
var TokenizationSupportAdapter = class TokenizationSupportAdapter {
	constructor(_languageId, _actual, _languageService, _standaloneThemeService) {
		this._languageId = _languageId;
		this._actual = _actual;
		this._languageService = _languageService;
		this._standaloneThemeService = _standaloneThemeService;
	}
	dispose() {}
	getInitialState() {
		return this._actual.getInitialState();
	}
	static _toClassicTokens(tokens, language) {
		const result = [];
		let previousStartIndex = 0;
		for (let i = 0, len = tokens.length; i < len; i++) {
			const t = tokens[i];
			let startIndex = t.startIndex;
			if (i === 0) startIndex = 0;
			else if (startIndex < previousStartIndex) startIndex = previousStartIndex;
			result[i] = new Token$2(startIndex, t.scopes, language);
			previousStartIndex = startIndex;
		}
		return result;
	}
	static adaptTokenize(language, actual, line, state) {
		const actualResult = actual.tokenize(line, state);
		const tokens = TokenizationSupportAdapter._toClassicTokens(actualResult.tokens, language);
		let endState;
		if (actualResult.endState.equals(state)) endState = state;
		else endState = actualResult.endState;
		return new TokenizationResult(tokens, endState);
	}
	tokenize(line, hasEOL, state) {
		return TokenizationSupportAdapter.adaptTokenize(this._languageId, this._actual, line, state);
	}
	_toBinaryTokens(languageIdCodec, tokens) {
		const languageId = languageIdCodec.encodeLanguageId(this._languageId);
		const tokenTheme = this._standaloneThemeService.getColorTheme().tokenTheme;
		const result = [];
		let resultLen = 0;
		let previousStartIndex = 0;
		for (let i = 0, len = tokens.length; i < len; i++) {
			const t = tokens[i];
			const metadata = tokenTheme.match(languageId, t.scopes) | 1024;
			if (resultLen > 0 && result[resultLen - 1] === metadata) continue;
			let startIndex = t.startIndex;
			if (i === 0) startIndex = 0;
			else if (startIndex < previousStartIndex) startIndex = previousStartIndex;
			result[resultLen++] = startIndex;
			result[resultLen++] = metadata;
			previousStartIndex = startIndex;
		}
		const actualResult = new Uint32Array(resultLen);
		for (let i = 0; i < resultLen; i++) actualResult[i] = result[i];
		return actualResult;
	}
	tokenizeEncoded(line, hasEOL, state) {
		const actualResult = this._actual.tokenize(line, state);
		const tokens = this._toBinaryTokens(this._languageService.languageIdCodec, actualResult.tokens);
		let endState;
		if (actualResult.endState.equals(state)) endState = state;
		else endState = actualResult.endState;
		return new EncodedTokenizationResult(tokens, [], endState);
	}
};
function isATokensProvider(provider) {
	return typeof provider.getInitialState === "function";
}
function isEncodedTokensProvider(provider) {
	return "tokenizeEncoded" in provider;
}
function isThenable(obj) {
	return obj && typeof obj.then === "function";
}
/**
* Change the color map that is used for token colors.
* Supported formats (hex): #RRGGBB, $RRGGBBAA, #RGB, #RGBA
*/
function setColorMap(colorMap) {
	const standaloneThemeService = StandaloneServices.get(IStandaloneThemeService);
	if (colorMap) {
		const result = [null];
		for (let i = 1, len = colorMap.length; i < len; i++) result[i] = Color.fromHex(colorMap[i]);
		standaloneThemeService.setColorMapOverride(result);
	} else standaloneThemeService.setColorMapOverride(null);
}
/**
* @internal
*/
function createTokenizationSupportAdapter(languageId, provider) {
	if (isEncodedTokensProvider(provider)) return new EncodedTokenizationSupportAdapter(languageId, provider);
	else return new TokenizationSupportAdapter(languageId, provider, StandaloneServices.get(ILanguageService), StandaloneServices.get(IStandaloneThemeService));
}
/**
* Register a tokens provider factory for a language. This tokenizer will be exclusive with a tokenizer
* set using `setTokensProvider` or one created using `setMonarchTokensProvider`, but will work together
* with a tokens provider set using `registerDocumentSemanticTokensProvider` or `registerDocumentRangeSemanticTokensProvider`.
*/
function registerTokensProviderFactory(languageId, factory) {
	const adaptedFactory = new LazyTokenizationSupport(async () => {
		const result = await Promise.resolve(factory.create());
		if (!result) return null;
		if (isATokensProvider(result)) return createTokenizationSupportAdapter(languageId, result);
		return new MonarchTokenizer(StandaloneServices.get(ILanguageService), StandaloneServices.get(IStandaloneThemeService), languageId, compile(languageId, result), StandaloneServices.get(IConfigurationService));
	});
	return TokenizationRegistry.registerFactory(languageId, adaptedFactory);
}
/**
* Set the tokens provider for a language (manual implementation). This tokenizer will be exclusive
* with a tokenizer created using `setMonarchTokensProvider`, or with `registerTokensProviderFactory`,
* but will work together with a tokens provider set using `registerDocumentSemanticTokensProvider`
* or `registerDocumentRangeSemanticTokensProvider`.
*/
function setTokensProvider(languageId, provider) {
	if (!StandaloneServices.get(ILanguageService).isRegisteredLanguageId(languageId)) throw new Error(`Cannot set tokens provider for unknown language ${languageId}`);
	if (isThenable(provider)) return registerTokensProviderFactory(languageId, { create: () => provider });
	return TokenizationRegistry.register(languageId, createTokenizationSupportAdapter(languageId, provider));
}
/**
* Set the tokens provider for a language (monarch implementation). This tokenizer will be exclusive
* with a tokenizer set using `setTokensProvider`, or with `registerTokensProviderFactory`, but will
* work together with a tokens provider set using `registerDocumentSemanticTokensProvider` or
* `registerDocumentRangeSemanticTokensProvider`.
*/
function setMonarchTokensProvider(languageId, languageDef) {
	const create = (languageDef) => {
		return new MonarchTokenizer(StandaloneServices.get(ILanguageService), StandaloneServices.get(IStandaloneThemeService), languageId, compile(languageId, languageDef), StandaloneServices.get(IConfigurationService));
	};
	if (isThenable(languageDef)) return registerTokensProviderFactory(languageId, { create: () => languageDef });
	return TokenizationRegistry.register(languageId, create(languageDef));
}
/**
* Register a reference provider (used by e.g. reference search).
*/
function registerReferenceProvider(languageSelector, provider) {
	return StandaloneServices.get(ILanguageFeaturesService).referenceProvider.register(languageSelector, provider);
}
/**
* Register a rename provider (used by e.g. rename symbol).
*/
function registerRenameProvider(languageSelector, provider) {
	return StandaloneServices.get(ILanguageFeaturesService).renameProvider.register(languageSelector, provider);
}
/**
* Register a new symbol-name provider (e.g., when a symbol is being renamed, show new possible symbol-names)
*/
function registerNewSymbolNameProvider(languageSelector, provider) {
	return StandaloneServices.get(ILanguageFeaturesService).newSymbolNamesProvider.register(languageSelector, provider);
}
/**
* Register a signature help provider (used by e.g. parameter hints).
*/
function registerSignatureHelpProvider(languageSelector, provider) {
	return StandaloneServices.get(ILanguageFeaturesService).signatureHelpProvider.register(languageSelector, provider);
}
/**
* Register a hover provider (used by e.g. editor hover).
*/
function registerHoverProvider(languageSelector, provider) {
	return StandaloneServices.get(ILanguageFeaturesService).hoverProvider.register(languageSelector, { provideHover: async (model, position, token, context) => {
		const word = model.getWordAtPosition(position);
		return Promise.resolve(provider.provideHover(model, position, token, context)).then((value) => {
			if (!value) return;
			if (!value.range && word) value.range = new Range$2(position.lineNumber, word.startColumn, position.lineNumber, word.endColumn);
			if (!value.range) value.range = new Range$2(position.lineNumber, position.column, position.lineNumber, position.column);
			return value;
		});
	} });
}
/**
* Register a document symbol provider (used by e.g. outline).
*/
function registerDocumentSymbolProvider(languageSelector, provider) {
	return StandaloneServices.get(ILanguageFeaturesService).documentSymbolProvider.register(languageSelector, provider);
}
/**
* Register a document highlight provider (used by e.g. highlight occurrences).
*/
function registerDocumentHighlightProvider(languageSelector, provider) {
	return StandaloneServices.get(ILanguageFeaturesService).documentHighlightProvider.register(languageSelector, provider);
}
/**
* Register an linked editing range provider.
*/
function registerLinkedEditingRangeProvider(languageSelector, provider) {
	return StandaloneServices.get(ILanguageFeaturesService).linkedEditingRangeProvider.register(languageSelector, provider);
}
/**
* Register a definition provider (used by e.g. go to definition).
*/
function registerDefinitionProvider(languageSelector, provider) {
	return StandaloneServices.get(ILanguageFeaturesService).definitionProvider.register(languageSelector, provider);
}
/**
* Register a implementation provider (used by e.g. go to implementation).
*/
function registerImplementationProvider(languageSelector, provider) {
	return StandaloneServices.get(ILanguageFeaturesService).implementationProvider.register(languageSelector, provider);
}
/**
* Register a type definition provider (used by e.g. go to type definition).
*/
function registerTypeDefinitionProvider(languageSelector, provider) {
	return StandaloneServices.get(ILanguageFeaturesService).typeDefinitionProvider.register(languageSelector, provider);
}
/**
* Register a code lens provider (used by e.g. inline code lenses).
*/
function registerCodeLensProvider(languageSelector, provider) {
	return StandaloneServices.get(ILanguageFeaturesService).codeLensProvider.register(languageSelector, provider);
}
/**
* Register a code action provider (used by e.g. quick fix).
*/
function registerCodeActionProvider(languageSelector, provider, metadata) {
	return StandaloneServices.get(ILanguageFeaturesService).codeActionProvider.register(languageSelector, {
		providedCodeActionKinds: metadata?.providedCodeActionKinds,
		documentation: metadata?.documentation,
		provideCodeActions: (model, range, context, token) => {
			const markers = StandaloneServices.get(IMarkerService).read({ resource: model.uri }).filter((m) => {
				return Range$2.areIntersectingOrTouching(m, range);
			});
			return provider.provideCodeActions(model, range, {
				markers,
				only: context.only,
				trigger: context.trigger
			}, token);
		},
		resolveCodeAction: provider.resolveCodeAction
	});
}
/**
* Register a formatter that can handle only entire models.
*/
function registerDocumentFormattingEditProvider(languageSelector, provider) {
	return StandaloneServices.get(ILanguageFeaturesService).documentFormattingEditProvider.register(languageSelector, provider);
}
/**
* Register a formatter that can handle a range inside a model.
*/
function registerDocumentRangeFormattingEditProvider(languageSelector, provider) {
	return StandaloneServices.get(ILanguageFeaturesService).documentRangeFormattingEditProvider.register(languageSelector, provider);
}
/**
* Register a formatter than can do formatting as the user types.
*/
function registerOnTypeFormattingEditProvider(languageSelector, provider) {
	return StandaloneServices.get(ILanguageFeaturesService).onTypeFormattingEditProvider.register(languageSelector, provider);
}
/**
* Register a link provider that can find links in text.
*/
function registerLinkProvider(languageSelector, provider) {
	return StandaloneServices.get(ILanguageFeaturesService).linkProvider.register(languageSelector, provider);
}
/**
* Register a completion item provider (use by e.g. suggestions).
*/
function registerCompletionItemProvider(languageSelector, provider) {
	return StandaloneServices.get(ILanguageFeaturesService).completionProvider.register(languageSelector, provider);
}
/**
* Register a document color provider (used by Color Picker, Color Decorator).
*/
function registerColorProvider(languageSelector, provider) {
	return StandaloneServices.get(ILanguageFeaturesService).colorProvider.register(languageSelector, provider);
}
/**
* Register a folding range provider
*/
function registerFoldingRangeProvider(languageSelector, provider) {
	return StandaloneServices.get(ILanguageFeaturesService).foldingRangeProvider.register(languageSelector, provider);
}
/**
* Register a declaration provider
*/
function registerDeclarationProvider(languageSelector, provider) {
	return StandaloneServices.get(ILanguageFeaturesService).declarationProvider.register(languageSelector, provider);
}
/**
* Register a selection range provider
*/
function registerSelectionRangeProvider(languageSelector, provider) {
	return StandaloneServices.get(ILanguageFeaturesService).selectionRangeProvider.register(languageSelector, provider);
}
/**
* Register a document semantic tokens provider. A semantic tokens provider will complement and enhance a
* simple top-down tokenizer. Simple top-down tokenizers can be set either via `setMonarchTokensProvider`
* or `setTokensProvider`.
*
* For the best user experience, register both a semantic tokens provider and a top-down tokenizer.
*/
function registerDocumentSemanticTokensProvider(languageSelector, provider) {
	return StandaloneServices.get(ILanguageFeaturesService).documentSemanticTokensProvider.register(languageSelector, provider);
}
/**
* Register a document range semantic tokens provider. A semantic tokens provider will complement and enhance a
* simple top-down tokenizer. Simple top-down tokenizers can be set either via `setMonarchTokensProvider`
* or `setTokensProvider`.
*
* For the best user experience, register both a semantic tokens provider and a top-down tokenizer.
*/
function registerDocumentRangeSemanticTokensProvider(languageSelector, provider) {
	return StandaloneServices.get(ILanguageFeaturesService).documentRangeSemanticTokensProvider.register(languageSelector, provider);
}
/**
* Register an inline completions provider.
*/
function registerInlineCompletionsProvider(languageSelector, provider) {
	return StandaloneServices.get(ILanguageFeaturesService).inlineCompletionsProvider.register(languageSelector, provider);
}
/**
* Register an inlay hints provider.
*/
function registerInlayHintsProvider(languageSelector, provider) {
	return StandaloneServices.get(ILanguageFeaturesService).inlayHintsProvider.register(languageSelector, provider);
}
/**
* @internal
*/
function createMonacoLanguagesAPI() {
	return {
		register,
		getLanguages,
		onLanguage,
		onLanguageEncountered,
		getEncodedLanguageId,
		score,
		setLanguageConfiguration,
		setColorMap,
		registerTokensProviderFactory,
		setTokensProvider,
		setMonarchTokensProvider,
		registerReferenceProvider,
		registerRenameProvider,
		registerNewSymbolNameProvider,
		registerCompletionItemProvider,
		registerSignatureHelpProvider,
		registerHoverProvider,
		registerDocumentSymbolProvider,
		registerDocumentHighlightProvider,
		registerLinkedEditingRangeProvider,
		registerDefinitionProvider,
		registerImplementationProvider,
		registerTypeDefinitionProvider,
		registerCodeLensProvider,
		registerCodeActionProvider,
		registerDocumentFormattingEditProvider,
		registerDocumentRangeFormattingEditProvider,
		registerOnTypeFormattingEditProvider,
		registerLinkProvider,
		registerColorProvider,
		registerFoldingRangeProvider,
		registerDeclarationProvider,
		registerSelectionRangeProvider,
		registerDocumentSemanticTokensProvider,
		registerDocumentRangeSemanticTokensProvider,
		registerInlineCompletionsProvider,
		registerInlayHintsProvider,
		DocumentHighlightKind,
		CompletionItemKind,
		CompletionItemTag,
		CompletionItemInsertTextRule,
		SymbolKind,
		SymbolTag,
		IndentAction: IndentAction$1,
		CompletionTriggerKind,
		SignatureHelpTriggerKind,
		InlayHintKind,
		InlineCompletionTriggerKind,
		CodeActionTriggerType,
		NewSymbolNameTag,
		NewSymbolNameTriggerKind,
		PartialAcceptTriggerKind,
		HoverVerbosityAction,
		InlineCompletionEndOfLifeReasonKind,
		InlineCompletionHintStyle,
		FoldingRangeKind,
		SelectedSuggestionInfo,
		EditDeltaInfo
	};
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/contrib/editorState/browser/keybindingCancellation.js
var IEditorCancellationTokens = createDecorator("IEditorCancelService");
var ctxCancellableOperation = new RawContextKey("cancellableOperation", false, localize(993, "Whether the editor runs a cancellable operation, e.g. like 'Peek References'"));
registerSingleton(IEditorCancellationTokens, class {
	constructor() {
		this._tokens = /* @__PURE__ */ new WeakMap();
	}
	add(editor, cts) {
		let data = this._tokens.get(editor);
		if (!data) {
			data = editor.invokeWithinContext((accessor) => {
				return {
					key: ctxCancellableOperation.bindTo(accessor.get(IContextKeyService)),
					tokens: new LinkedList()
				};
			});
			this._tokens.set(editor, data);
		}
		let removeFn;
		data.key.set(true);
		removeFn = data.tokens.push(cts);
		return () => {
			if (removeFn) {
				removeFn();
				data.key.set(!data.tokens.isEmpty());
				removeFn = void 0;
			}
		};
	}
	cancel(editor) {
		const data = this._tokens.get(editor);
		if (!data) return;
		const cts = data.tokens.pop();
		if (cts) {
			cts.cancel();
			data.key.set(!data.tokens.isEmpty());
		}
	}
}, 1);
var EditorKeybindingCancellationTokenSource = class extends CancellationTokenSource$1 {
	constructor(editor, parent) {
		super(parent);
		this.editor = editor;
		this._unregister = editor.invokeWithinContext((accessor) => accessor.get(IEditorCancellationTokens).add(editor, this));
	}
	dispose() {
		this._unregister();
		super.dispose();
	}
};
registerEditorCommand(new class extends EditorCommand {
	constructor() {
		super({
			id: "editor.cancelOperation",
			kbOpts: {
				weight: 100,
				primary: 9
			},
			precondition: ctxCancellableOperation
		});
	}
	runEditorCommand(accessor, editor) {
		accessor.get(IEditorCancellationTokens).cancel(editor);
	}
}());
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/contrib/editorState/browser/editorState.js
var EditorState = class EditorState {
	constructor(editor, flags) {
		this.flags = flags;
		if ((this.flags & 1) !== 0) {
			const model = editor.getModel();
			this.modelVersionId = model ? format("{0}#{1}", model.uri.toString(), model.getVersionId()) : null;
		} else this.modelVersionId = null;
		if ((this.flags & 4) !== 0) this.position = editor.getPosition();
		else this.position = null;
		if ((this.flags & 2) !== 0) this.selection = editor.getSelection();
		else this.selection = null;
		if ((this.flags & 8) !== 0) {
			this.scrollLeft = editor.getScrollLeft();
			this.scrollTop = editor.getScrollTop();
		} else {
			this.scrollLeft = -1;
			this.scrollTop = -1;
		}
	}
	_equals(other) {
		if (!(other instanceof EditorState)) return false;
		const state = other;
		if (this.modelVersionId !== state.modelVersionId) return false;
		if (this.scrollLeft !== state.scrollLeft || this.scrollTop !== state.scrollTop) return false;
		if (!this.position && state.position || this.position && !state.position || this.position && state.position && !this.position.equals(state.position)) return false;
		if (!this.selection && state.selection || this.selection && !state.selection || this.selection && state.selection && !this.selection.equalsRange(state.selection)) return false;
		return true;
	}
	validate(editor) {
		return this._equals(new EditorState(editor, this.flags));
	}
};
/**
* A cancellation token source that cancels when the editor changes as expressed
* by the provided flags
* @param range If provided, changes in position and selection within this range will not trigger cancellation
*/
var EditorStateCancellationTokenSource = class extends EditorKeybindingCancellationTokenSource {
	constructor(editor, flags, range, parent) {
		super(editor, parent);
		this._listener = new DisposableStore();
		if (flags & 4) this._listener.add(editor.onDidChangeCursorPosition((e) => {
			if (!range || !Range$2.containsPosition(range, e.position)) this.cancel();
		}));
		if (flags & 2) this._listener.add(editor.onDidChangeCursorSelection((e) => {
			if (!range || !Range$2.containsRange(range, e.selection)) this.cancel();
		}));
		if (flags & 8) this._listener.add(editor.onDidScrollChange((_) => this.cancel()));
		if (flags & 1) {
			this._listener.add(editor.onDidChangeModel((_) => this.cancel()));
			this._listener.add(editor.onDidChangeModelContent((_) => this.cancel()));
		}
	}
	dispose() {
		this._listener.dispose();
		super.dispose();
	}
};
/**
* A cancellation token source that cancels when the provided model changes
*/
var TextModelCancellationTokenSource = class extends CancellationTokenSource$1 {
	constructor(model, parent) {
		super(parent);
		this._listener = model.onDidChangeContent(() => this.cancel());
	}
	dispose() {
		this._listener.dispose();
		super.dispose();
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/contrib/format/browser/formattingEdit.js
var FormattingEdit = class FormattingEdit {
	static _handleEolEdits(editor, edits) {
		let newEol = void 0;
		const singleEdits = [];
		for (const edit of edits) {
			if (typeof edit.eol === "number") newEol = edit.eol;
			if (edit.range && typeof edit.text === "string") singleEdits.push(edit);
		}
		if (typeof newEol === "number") {
			if (editor.hasModel()) editor.getModel().pushEOL(newEol);
		}
		return singleEdits;
	}
	static _isFullModelReplaceEdit(editor, edit) {
		if (!editor.hasModel()) return false;
		const model = editor.getModel();
		const editRange = model.validateRange(edit.range);
		return model.getFullModelRange().equalsRange(editRange);
	}
	static execute(editor, _edits, addUndoStops) {
		if (addUndoStops) editor.pushUndoStop();
		const scrollState = StableEditorScrollState.capture(editor);
		const edits = FormattingEdit._handleEolEdits(editor, _edits);
		if (edits.length === 1 && FormattingEdit._isFullModelReplaceEdit(editor, edits[0])) editor.executeEdits("formatEditsCommand", edits.map((edit) => EditOperation.replace(Range$2.lift(edit.range), edit.text)));
		else editor.executeEdits("formatEditsCommand", edits.map((edit) => EditOperation.replaceMove(Range$2.lift(edit.range), edit.text)));
		if (addUndoStops) editor.pushUndoStop();
		scrollState.restoreRelativeVerticalPositionOfCursor(editor);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/platform/extensions/common/extensions.js
/**
* **!Do not construct directly!**
*
* **!Only static methods because it gets serialized!**
*
* This represents the "canonical" version for an extension identifier. Extension ids
* have to be case-insensitive (due to the marketplace), but we must ensure case
* preservation because the extension API is already public at this time.
*
* For example, given an extension with the publisher `"Hello"` and the name `"World"`,
* its canonical extension identifier is `"Hello.World"`. This extension could be
* referenced in some other extension's dependencies using the string `"hello.world"`.
*
* To make matters more complicated, an extension can optionally have an UUID. When two
* extensions have the same UUID, they are considered equal even if their identifier is different.
*/
var ExtensionIdentifier = class {
	constructor(value) {
		this.value = value;
		this._lower = value.toLowerCase();
	}
	/**
	* Gives the value by which to index (for equality).
	*/
	static toKey(id) {
		if (typeof id === "string") return id.toLowerCase();
		return id._lower;
	}
};
var ExtensionIdentifierSet = class {
	constructor(iterable) {
		this._set = /* @__PURE__ */ new Set();
		if (iterable) for (const value of iterable) this.add(value);
	}
	add(id) {
		this._set.add(ExtensionIdentifier.toKey(id));
	}
	has(id) {
		return this._set.has(ExtensionIdentifier.toKey(id));
	}
};
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/contrib/format/browser/format.js
function getRealAndSyntheticDocumentFormattersOrdered(documentFormattingEditProvider, documentRangeFormattingEditProvider, model) {
	const result = [];
	const seen = new ExtensionIdentifierSet();
	const docFormatter = documentFormattingEditProvider.ordered(model);
	for (const formatter of docFormatter) {
		result.push(formatter);
		if (formatter.extensionId) seen.add(formatter.extensionId);
	}
	const rangeFormatter = documentRangeFormattingEditProvider.ordered(model);
	for (const formatter of rangeFormatter) {
		if (formatter.extensionId) {
			if (seen.has(formatter.extensionId)) continue;
			seen.add(formatter.extensionId);
		}
		result.push({
			displayName: formatter.displayName,
			extensionId: formatter.extensionId,
			provideDocumentFormattingEdits(model, options, token) {
				return formatter.provideDocumentRangeFormattingEdits(model, model.getFullModelRange(), options, token);
			}
		});
	}
	return result;
}
var FormattingConflicts = class FormattingConflicts {
	static {
		this._selectors = new LinkedList();
	}
	static setFormatterSelector(selector) {
		return { dispose: FormattingConflicts._selectors.unshift(selector) };
	}
	static async select(formatter, document, mode, kind) {
		if (formatter.length === 0) return;
		const selector = Iterable.first(FormattingConflicts._selectors);
		if (selector) return await selector(formatter, document, mode, kind);
	}
};
async function formatDocumentRangesWithSelectedProvider(accessor, editorOrModel, rangeOrRanges, mode, progress, token, userGesture) {
	const instaService = accessor.get(IInstantiationService);
	const { documentRangeFormattingEditProvider: documentRangeFormattingEditProviderRegistry } = accessor.get(ILanguageFeaturesService);
	const model = isCodeEditor(editorOrModel) ? editorOrModel.getModel() : editorOrModel;
	const provider = documentRangeFormattingEditProviderRegistry.ordered(model);
	const selected = await FormattingConflicts.select(provider, model, mode, 2);
	if (selected) {
		progress.report(selected);
		await instaService.invokeFunction(formatDocumentRangesWithProvider, selected, editorOrModel, rangeOrRanges, token, userGesture);
	}
}
async function formatDocumentRangesWithProvider(accessor, provider, editorOrModel, rangeOrRanges, token, userGesture) {
	const workerService = accessor.get(IEditorWorkerService);
	const logService = accessor.get(ILogService);
	const accessibilitySignalService = accessor.get(IAccessibilitySignalService);
	let model;
	let cts;
	if (isCodeEditor(editorOrModel)) {
		model = editorOrModel.getModel();
		cts = new EditorStateCancellationTokenSource(editorOrModel, 5, void 0, token);
	} else {
		model = editorOrModel;
		cts = new TextModelCancellationTokenSource(editorOrModel, token);
	}
	const ranges = [];
	let len = 0;
	for (const range of asArray(rangeOrRanges).sort(Range$2.compareRangesUsingStarts)) if (len > 0 && Range$2.areIntersectingOrTouching(ranges[len - 1], range)) ranges[len - 1] = Range$2.fromPositions(ranges[len - 1].getStartPosition(), range.getEndPosition());
	else len = ranges.push(range);
	const computeEdits = async (range) => {
		logService.trace(`[format][provideDocumentRangeFormattingEdits] (request)`, provider.extensionId?.value, range);
		const result = await provider.provideDocumentRangeFormattingEdits(model, range, model.getFormattingOptions(), cts.token) || [];
		logService.trace(`[format][provideDocumentRangeFormattingEdits] (response)`, provider.extensionId?.value, result);
		return result;
	};
	const hasIntersectingEdit = (a, b) => {
		if (!a.length || !b.length) return false;
		const mergedA = a.reduce((acc, val) => {
			return Range$2.plusRange(acc, val.range);
		}, a[0].range);
		if (!b.some((x) => {
			return Range$2.intersectRanges(mergedA, x.range);
		})) return false;
		for (const edit of a) for (const otherEdit of b) if (Range$2.intersectRanges(edit.range, otherEdit.range)) return true;
		return false;
	};
	const allEdits = [];
	const rawEditsList = [];
	try {
		if (typeof provider.provideDocumentRangesFormattingEdits === "function") {
			logService.trace(`[format][provideDocumentRangeFormattingEdits] (request)`, provider.extensionId?.value, ranges);
			const result = await provider.provideDocumentRangesFormattingEdits(model, ranges, model.getFormattingOptions(), cts.token) || [];
			logService.trace(`[format][provideDocumentRangeFormattingEdits] (response)`, provider.extensionId?.value, result);
			rawEditsList.push(result);
		} else {
			for (const range of ranges) {
				if (cts.token.isCancellationRequested) return true;
				rawEditsList.push(await computeEdits(range));
			}
			for (let i = 0; i < ranges.length; ++i) for (let j = i + 1; j < ranges.length; ++j) {
				if (cts.token.isCancellationRequested) return true;
				if (hasIntersectingEdit(rawEditsList[i], rawEditsList[j])) {
					const mergedRange = Range$2.plusRange(ranges[i], ranges[j]);
					const edits = await computeEdits(mergedRange);
					ranges.splice(j, 1);
					ranges.splice(i, 1);
					ranges.push(mergedRange);
					rawEditsList.splice(j, 1);
					rawEditsList.splice(i, 1);
					rawEditsList.push(edits);
					i = 0;
					j = 0;
				}
			}
		}
		for (const rawEdits of rawEditsList) {
			if (cts.token.isCancellationRequested) return true;
			const minimalEdits = await workerService.computeMoreMinimalEdits(model.uri, rawEdits);
			if (minimalEdits) allEdits.push(...minimalEdits);
		}
		if (cts.token.isCancellationRequested) return true;
	} finally {
		cts.dispose();
	}
	if (allEdits.length === 0) return false;
	if (isCodeEditor(editorOrModel)) {
		FormattingEdit.execute(editorOrModel, allEdits, true);
		editorOrModel.revealPositionInCenterIfOutsideViewport(editorOrModel.getPosition(), 1);
	} else {
		const [{ range }] = allEdits;
		const initialSelection = new Selection$1(range.startLineNumber, range.startColumn, range.endLineNumber, range.endColumn);
		model.pushEditOperations([initialSelection], allEdits.map((edit) => {
			return {
				text: edit.text,
				range: Range$2.lift(edit.range),
				forceMoveMarkers: true
			};
		}), (undoEdits) => {
			for (const { range } of undoEdits) if (Range$2.areIntersectingOrTouching(range, initialSelection)) return [new Selection$1(range.startLineNumber, range.startColumn, range.endLineNumber, range.endColumn)];
			return null;
		});
	}
	accessibilitySignalService.playSignal(AccessibilitySignal.format, { userGesture });
	return true;
}
async function formatDocumentWithSelectedProvider(accessor, editorOrModel, mode, progress, token, userGesture) {
	const instaService = accessor.get(IInstantiationService);
	const languageFeaturesService = accessor.get(ILanguageFeaturesService);
	const model = isCodeEditor(editorOrModel) ? editorOrModel.getModel() : editorOrModel;
	const provider = getRealAndSyntheticDocumentFormattersOrdered(languageFeaturesService.documentFormattingEditProvider, languageFeaturesService.documentRangeFormattingEditProvider, model);
	const selected = await FormattingConflicts.select(provider, model, mode, 1);
	if (selected) {
		progress.report(selected);
		await instaService.invokeFunction(formatDocumentWithProvider, selected, editorOrModel, mode, token, userGesture);
	}
}
async function formatDocumentWithProvider(accessor, provider, editorOrModel, mode, token, userGesture) {
	const workerService = accessor.get(IEditorWorkerService);
	const accessibilitySignalService = accessor.get(IAccessibilitySignalService);
	let model;
	let cts;
	if (isCodeEditor(editorOrModel)) {
		model = editorOrModel.getModel();
		cts = new EditorStateCancellationTokenSource(editorOrModel, 5, void 0, token);
	} else {
		model = editorOrModel;
		cts = new TextModelCancellationTokenSource(editorOrModel, token);
	}
	let edits;
	try {
		const rawEdits = await provider.provideDocumentFormattingEdits(model, model.getFormattingOptions(), cts.token);
		edits = await workerService.computeMoreMinimalEdits(model.uri, rawEdits);
		if (cts.token.isCancellationRequested) return true;
	} finally {
		cts.dispose();
	}
	if (!edits || edits.length === 0) return false;
	if (isCodeEditor(editorOrModel)) {
		FormattingEdit.execute(editorOrModel, edits, mode !== 2);
		if (mode !== 2) editorOrModel.revealPositionInCenterIfOutsideViewport(editorOrModel.getPosition(), 1);
	} else {
		const [{ range }] = edits;
		const initialSelection = new Selection$1(range.startLineNumber, range.startColumn, range.endLineNumber, range.endColumn);
		model.pushEditOperations([initialSelection], edits.map((edit) => {
			return {
				text: edit.text,
				range: Range$2.lift(edit.range),
				forceMoveMarkers: true
			};
		}), (undoEdits) => {
			for (const { range } of undoEdits) if (Range$2.areIntersectingOrTouching(range, initialSelection)) return [new Selection$1(range.startLineNumber, range.startColumn, range.endLineNumber, range.endColumn)];
			return null;
		});
	}
	accessibilitySignalService.playSignal(AccessibilitySignal.format, { userGesture });
	return true;
}
async function getDocumentRangeFormattingEditsUntilResult(workerService, languageFeaturesService, model, range, options, token) {
	const providers = languageFeaturesService.documentRangeFormattingEditProvider.ordered(model);
	for (const provider of providers) {
		const rawEdits = await Promise.resolve(provider.provideDocumentRangeFormattingEdits(model, range, options, token)).catch(onUnexpectedExternalError);
		if (isNonEmptyArray(rawEdits)) return await workerService.computeMoreMinimalEdits(model.uri, rawEdits);
	}
}
async function getDocumentFormattingEditsUntilResult(workerService, languageFeaturesService, model, options, token) {
	const providers = getRealAndSyntheticDocumentFormattersOrdered(languageFeaturesService.documentFormattingEditProvider, languageFeaturesService.documentRangeFormattingEditProvider, model);
	for (const provider of providers) {
		const rawEdits = await Promise.resolve(provider.provideDocumentFormattingEdits(model, options, token)).catch(onUnexpectedExternalError);
		if (isNonEmptyArray(rawEdits)) return await workerService.computeMoreMinimalEdits(model.uri, rawEdits);
	}
}
function getOnTypeFormattingEdits(workerService, languageFeaturesService, model, position, ch, options, token) {
	const providers = languageFeaturesService.onTypeFormattingEditProvider.ordered(model);
	if (providers.length === 0) return Promise.resolve(void 0);
	if (providers[0].autoFormatTriggerCharacters.indexOf(ch) < 0) return Promise.resolve(void 0);
	return Promise.resolve(providers[0].provideOnTypeFormattingEdits(model, position, ch, options, token)).catch(onUnexpectedExternalError).then((edits) => {
		return workerService.computeMoreMinimalEdits(model.uri, edits);
	});
}
function isFormattingOptions(obj) {
	const candidate = obj;
	return !!candidate && typeof candidate === "object" && typeof candidate.tabSize === "number" && typeof candidate.insertSpaces === "boolean";
}
CommandsRegistry.registerCommand("_executeFormatRangeProvider", async function(accessor, ...args) {
	const [resource, range, options] = args;
	assertType(URI.isUri(resource));
	assertType(Range$2.isIRange(range));
	const resolverService = accessor.get(ITextModelService);
	const workerService = accessor.get(IEditorWorkerService);
	const languageFeaturesService = accessor.get(ILanguageFeaturesService);
	const reference = await resolverService.createModelReference(resource);
	try {
		return getDocumentRangeFormattingEditsUntilResult(workerService, languageFeaturesService, reference.object.textEditorModel, Range$2.lift(range), ensureFormattingOptions(options, reference), CancellationToken.None);
	} finally {
		reference.dispose();
	}
});
CommandsRegistry.registerCommand("_executeFormatDocumentProvider", async function(accessor, ...args) {
	const [resource, options] = args;
	assertType(URI.isUri(resource));
	const resolverService = accessor.get(ITextModelService);
	const workerService = accessor.get(IEditorWorkerService);
	const languageFeaturesService = accessor.get(ILanguageFeaturesService);
	const reference = await resolverService.createModelReference(resource);
	try {
		return getDocumentFormattingEditsUntilResult(workerService, languageFeaturesService, reference.object.textEditorModel, ensureFormattingOptions(options, reference), CancellationToken.None);
	} finally {
		reference.dispose();
	}
});
CommandsRegistry.registerCommand("_executeFormatOnTypeProvider", async function(accessor, ...args) {
	const [resource, position, ch, options] = args;
	assertType(URI.isUri(resource));
	assertType(Position$1.isIPosition(position));
	assertType(typeof ch === "string");
	const resolverService = accessor.get(ITextModelService);
	const workerService = accessor.get(IEditorWorkerService);
	const languageFeaturesService = accessor.get(ILanguageFeaturesService);
	const reference = await resolverService.createModelReference(resource);
	try {
		return getOnTypeFormattingEdits(workerService, languageFeaturesService, reference.object.textEditorModel, Position$1.lift(position), ch, ensureFormattingOptions(options, reference), CancellationToken.None);
	} finally {
		reference.dispose();
	}
});
function ensureFormattingOptions(options, reference) {
	let validatedOptions;
	if (isFormattingOptions(options)) validatedOptions = options;
	else {
		const modelOptions = reference.object.textEditorModel.getOptions();
		validatedOptions = {
			tabSize: modelOptions.tabSize,
			insertSpaces: modelOptions.insertSpaces
		};
	}
	return validatedOptions;
}
//#endregion
//#region ../../node_modules/.pnpm/monaco-editor@0.57.0/node_modules/monaco-editor/esm/vs/editor/editor.api.js
EditorOptions.wrappingIndent.defaultValue = 0;
EditorOptions.glyphMargin.defaultValue = false;
EditorOptions.autoIndent.defaultValue = 3;
EditorOptions.overviewRulerLanes.defaultValue = 2;
FormattingConflicts.setFormatterSelector((formatter, document, mode) => Promise.resolve(formatter[0]));
var api = createMonacoBaseAPI();
api.editor = createMonacoEditorAPI();
api.languages = createMonacoLanguagesAPI();
api.CancellationTokenSource;
var Emitter = api.Emitter;
api.KeyCode;
api.KeyMod;
api.Position;
var Range = api.Range;
api.Selection;
api.SelectionDirection;
var MarkerSeverity = api.MarkerSeverity;
api.MarkerTag;
var Uri = api.Uri;
api.Token;
var editor = api.editor;
var languages = api.languages;
var monacoEnvironment = getMonacoEnvironment();
var globalWithAMD = globalThis;
if (monacoEnvironment?.globalAPI || typeof globalWithAMD.define === "function" && globalWithAMD.define.amd) globalWithAMD.monaco = api;
if (typeof globalWithAMD.require !== "undefined" && typeof globalWithAMD.require.config === "function") globalWithAMD.require.config({ ignoreDuplicateModules: [
	"vscode-languageserver-types",
	"vscode-languageserver-types/main",
	"vscode-languageserver-textdocument",
	"vscode-languageserver-textdocument/main",
	"vscode-nls",
	"vscode-nls/vscode-nls",
	"jsonc-parser",
	"jsonc-parser/main",
	"vscode-uri",
	"vscode-uri/index",
	"vs/basic-languages/typescript/typescript"
] });
//#endregion
export { QuickOutlineNLS as $, RenderLineInput as $a, EditorOptions as $c, diffRemoved as $i, HoverWidget$1 as $n, MenuId as $o, ShiftCommand as $r, hide as $s, List as $t, DisposableCancellationTokenSource as A, widgetShadow as Aa, autorunDelta as Ac, getColumnOfNodeOffset as Ai, withSelection as An, registerEditorContribution as Ao, runOnChangeWithCancellationToken as Ar, ModifierKeyEmitter as As, navigateToggles as At, widgetClose as B, registerColor as Ba, arrayEqualsC as Bc, inputActiveOptionBackground as Bi, stripIcons as Bn, basename as Bo, computeIndentLevel as Br, getActiveDocument as Bs, MenuEntryActionViewItem as Bt, Point as C, editorWarningBorder as Ca, observableFromEventOpts as Cc, DomEmitter as Ci, isKeyModified as Cn, EditorAction as Co, countEOL as Cr, applyFontInfo as Cs, WorkbenchTreeElementCanCollapse as Ct, renderLines as D, overviewRulerFindMatchForeground as Da, subtransaction as Dc, EventType as Di, IMarkdownRendererService as Dn, MultiEditorAction as Do, IKeybindingService as Dr, DisposableResizeObserver as Ds, CaseSensitiveToggle as Dt, RenderOptions as E, editorWidgetBorder as Ea, asyncTransaction as Ec, Widget$1 as Ei, getAnchorRect as En, MultiCommand as Eo, NativeEditContextRegistry as Er, Dimension as Es, HistoryInputBox as Et, createHotClass as F, foreground as Fa, derivedHandleChanges as Fc, quickInputListFocusBackground as Fi, defaultGenerator as Fn, ILogService as Fo, GlyphRasterizer as Fr, addDisposableListener as Fs, Sash as Ft, CountBadge as G, removeCSSRulesContainingSelector as Ga, structuralEquals as Gc, inputForeground as Gi, fuzzyScore as Gn, isEqual as Go, registerThemingParticipant as Gr, getDomNodePagePosition as Gs, defaultCountBadgeStyles as Gt, unthemedKeybindingLabelOptions as H, GlobalPointerMoveMonitor as Ha, equalsIfDefined as Hc, inputActiveOptionForeground as Hi, FuzzyScoreOptions as Hn, dirname as Ho, ghostTextForeground as Hr, getActiveWindow as Hs, createActionViewItem as Ht, HC_BLACK_THEME_NAME as I, iconForeground as Ia, derivedOpts as Ic, quickInputListFocusForeground as Ii, MarkdownString as In, ILoggerService as Io, ensureNonNullable as Ir, addStandardDisposableGenericMouseDownListener as Is, ILabelService as It, IStandaloneThemeService as J, TabFocus as Ja, StandardMouseEvent as Jc, listHighlightForeground as Ji, matchesSubString as Jn, relativePath as Jo, EditorContextKeys as Jr, getTopLeftOffset as Js, defaultListStyles as Jt, Button as K, CONTEXT_ACCESSIBILITY_MODE_ENABLED as Ka, thisEqualsC as Kc, editorActionListForeground as Ki, fuzzyScoreGracefulAggressive as Kn, joinPath as Ko, themeColorFromId as Kr, getDomNodeZoomLevel as Ks, defaultInputBoxStyles as Kt, HC_LIGHT_THEME_NAME as L, asCssVariable as La, DerivedWithSetter as Lc, quickInputListFocusIconForeground as Li, createCommandUri as Ln, LogLevel as Lo, isModelDecorationInComment as Lr, addStandardDisposableListener as Ls, IDefaultAccountService as Lt, StableEditorScrollState as M, activeContrastBorder as Ma, registerAutorunSelfDisposable as Mc, isHighContrast as Mi, renderIcon as Mn, registerModelAndPositionCommand as Mo, INotificationService as Mr, WindowIdleValue as Ms, Sizing as Mt, bindContextKey as N, contrastBorder as Na, derived as Nc, DynamicCssRules as Ni, renderLabelWithIcons as Nn, registerMultiEditorAction as No, Severity as Nr, addDisposableGenericMouseDownListener as Ns, SplitView as Nt, observableSignalFromEvent as O, overviewRulerSelectionHighlightForeground as Oa, transaction as Oc, Gesture as Oi, openLinkFromMarkdown as On, registerEditorAction as Oo, ViewGpuContext as Or, EventHelper as Os, RegexToggle as Ot, observableConfigValue as P, descriptionForeground as Pa, derivedDisposable as Pc, EditorMouseEvent as Pi, IdGenerator as Pn, TriggerInlineEditCommandsRegistry as Po, Severity$1$1 as Pr, addDisposableGenericMouseUpListener as Ps, OrthogonalEdge as Pt, QuickHelpNLS as Q, status as Qa, EditorFontLigatures as Qc, diffInsertedLine as Qi, HoverAction as Qn, IMenuService as Qo, getIndentMetadata as Qr, h as Qs, ActionViewItem as Qt, VS_DARK_THEME_NAME as R, darken as Ra, DebugNameData as Rc, buttonBackground as Ri, isEmptyMarkdownString as Rn, canLog as Ro, isModelDecorationInString as Rr, append$2 as Rs, IDataChannelService as Rt, observableCodeEditor as S, editorSelectionHighlight as Sa, observableFromEvent as Sc, prefixedUuid as Si, QuickInputButtonLocation as Sn, IndentAction as So, EditSources as Sr, createDecorator as Ss, WorkbenchListFocusContextKey as St, LineSource as T, editorWidgetBackground as Ta, observableValue as Tc, ScrollableElement as Ti, ILayoutService as Tn, EditorCommand as To, IUserInteractionService as Tr, $$10 as Ts, FindInput as Tt, IconLabel as U, createCSSRule as Ua, equalsIfDefinedC as Uc, inputBackground as Ui, anyScore as Un, extUri as Uo, overviewRulerRangeHighlight as Ur, getClientArea as Us, getActionBarActions as Ut, KeybindingLabel as V, transparent as Va, equals as Vc, inputActiveOptionBorder as Vi, FuzzyScore as Vn, basenameOrAuthority as Vo, editorBracketMatchForeground as Vr, getActiveElement as Vs, TextOnlyMenuEntryActionViewItem as Vt, HighlightedLabel as W, createStyleSheetFromObservable as Wa, strictEquals as Wc, inputBorder as Wi, createMatches as Wn, extname as Wo, IThemeService as Wr, getComputedStyle as Ws, getFlatActionBarActions as Wt, InspectTokensNLS as X, IEditorWorkerService as Xa, isFirefox as Xc, minimapSelectionOccurrenceHighlight as Xi, or as Xn, ITelemetryService as Xo, EnterOperation as Xr, getTotalWidth as Xs, getListStyles as Xt, GoToLineNLS as Y, IMarkerDecorationsService as Ya, StandardKeyboardEvent as Yc, minimapFindMatch as Yi, matchesWords as Yn, hasDriveLetter as Yo, TypeOperations as Yr, getTotalHeight as Ys, defaultToggleStyles as Yt, QuickCommandNLS as Z, alert as Za, mainWindow as Zc, diffInserted as Zi, ClickAction as Zn, Action2 as Zo, getGoodIndentForLine as Zr, getWindow as Zs, isLocalizedString as Zt, DiffEditorWidget as _, editorInlayHintParameterBackground as _a, derivedObservableWithCache as _c, VSDataTransfer as _i, SnoozeInlineCompletion as _n, Mimes as _o, TextBufferTokenizer as _r, toAction as _s, IMarkerData as _t, editor as a, editorFindMatchHighlight as aa, isMouseEvent as ac, MoveOperations as ai, IsWindowsContext as an, TokenMetadata as ao, WorkbenchHoverDelegate as ar, KeybindingsRegistry as as, IBulkEditService as at, MenuWorkbenchToolBar as b, editorInlayHintTypeForeground as ba, recomputeInitiallyAndOnChange as bc, DataTransfers as bi, IQuickInputService as bn, IConfigurationService as bo, lengthGetColumnCountIfZeroLineCount as br, ICodeEditorService as bs, IListService as bt, formatDocumentWithSelectedProvider as c, editorFindRangeHighlightBorder as ca, runAtThisOrScheduleAtNextAnimationFrame as cc, ReplaceCommandThatSelectsText as ci, AccessibilitySignal as cn, nullTokenize as co, InlineDecoration as cr, ContextKeyExpr as cs, IWorkspaceContextService as ct, EditorState as d, editorHoverBorder as da, setVisibility as dc, CopyOptions as di, toMultilineTokens2 as dn, ILanguageFeaturesService as do, TextModel as dr, CommandsRegistry as ds, isSingleFolderWorkspaceIdentifier as dt, editorActiveLinkForeground as ea, isActiveElement as ec, getEnterAction as ei, ShowLightbulbIconMode as el, constObservable as en, renderViewLine as eo, KeyDownAction as er, MenuItemAction as es, ToggleHighContrastNLS as et, EditorStateCancellationTokenSource as f, editorHoverForeground as fa, show as fc, InMemoryClipboardMetadataManager as fi, score$1 as fn, ITextResourceConfigurationService as fo, indentOfLine as fr, ICommandService as fs, isStandaloneEditorWorkspace as ft, isDiffEditor as g, editorInlayHintForeground as ga, debouncedObservable2 as gc, UriList as gi, IInlineCompletionsService as gn, product$1 as go, LanguageAgnosticBracketTokens as gr, SubmenuAction as gs, Progress as gt, isCodeEditor as h, editorInlayHintBackground as ha, debouncedObservable as hc, LocalSelectionTransfer as hi, CancelSnoozeInlineCompletion as hn, Extensions$6 as ho, parseDocument as hr, Separator as hs, IProgressService as ht, Uri as i, editorFindMatchForeground as ia, isHTMLElement as ic, WordPartOperations as ii, EditorZoom as il, IsWebContext as in, getStandardTokenTypeAtPosition as io, IHoverService as ir, registerAction2 as is, IRenameSymbolTrackerService as it, appendRemoveOnDispose as j, scrollbarShadow as ja, autorunWithStore as jc, isDark as ji, renderMarkdown as jn, registerInstantiatedEditorAction as jo, runOnChangeWithStore as jr, SafeTriangle as js, Toggle as jt, waitForState as k, widgetBorder as ka, autorun as kc, CursorColumns as ki, IOpenerService as kn, registerEditorCommand as ko, runOnChange as kr, EventType$1 as ks, WholeWordsToggle as kt, getOnTypeFormattingEdits as l, editorForeground as la, runWhenWindowIdle as lc, CursorState as li, IAccessibilitySignalService as ln, nullTokenizeEncoded as lo, ModelDecorationInjectedTextOptions as lr, IContextKeyService as ls, WORKSPACE_EXTENSION as lt, getCodeEditor as m, editorInfoForeground as ma, trackFocus as mc, toExternalVSDataTransfer as mi, IEnvironmentService as mn, PLAINTEXT_LANGUAGE_ID as mo, offsetEditFromContentChanges as mr, Action as ms, IEditorProgressService as mt, MarkerSeverity as n, editorErrorBorder as na, isAncestorOfActiveElement as nc, CursorMoveCommands as ni, unicodeHighlightConfigKeys as nl, getDefaultHoverDelegate as nn, LineTokens as no, IContextMenuService as nr, SubmenuItemAction as ns, EditOperation as nt, languages as o, editorFindMatchHighlightBorder as oa, n as oc, ReplaceCommand as oi, TernarySearchTree as on, createTrustedTypesPolicy as oo, nativeHoverDelegate as or, Registry as os, ResourceTextEdit as ot, TextModelCancellationTokenSource as p, editorInfoBorder as pa, size as pc, generateDataToCopyAndStoreInMemory as pi, ILanguageFeatureDebounceService as pn, ILanguageConfigurationService as po, recordChangesLazy as pr, ThemeIcon as ps, toWorkspaceIdentifier as pt, Extensions$1 as q, IAccessibilityService as qa, clamp as qc, listFocusHighlightForeground as qi, matchesBaseContiguousSubString as qn, originalFSPath as qo, CoreEditingCommands as qr, getShadowRoot as qs, defaultKeybindingLabelStyles as qt, Range as r, editorErrorForeground as ra, isEditableElement as rc, WordOperations as ri, EDITOR_FONT_DEFAULTS as rl, InputFocusedContext as rn, TokenArray as ro, IContextViewService as rr, isIMenuItem as rs, editorConfigurationBaseNode as rt, formatDocumentRangesWithSelectedProvider as s, editorFindMatchHighlightForeground as sa, reset as sc, ReplaceCommandThatPreservesSelection as si, IClipboardService as sn, NullState as so, CodeEditorWidget as sr, ContextKeyEqualsExpr as ss, IWorkspaceTrustManagementService as st, Emitter as t, editorBackground as ta, isAncestor$1 as tc, ProcessedIndentRulesSupport as ti, inUntrustedWorkspace as tl, getBaseLayerHoverDelegate as tn, LineDecoration as to, getHoverAccessibleViewHint as tr, MenuRegistry as ts, registerEditorFeature as tt, FormattingEdit as u, editorHoverBackground as ua, scheduleAtNextAnimationFrame as uc, normalizeIndentation as ui, ISemanticTokensStylingService as un, isCompletionsEnabledFromObject as uo, ModelDecorationOptions as ur, RawContextKey as us, isEmptyWorkspaceIdentifier as ut, HideUnchangedRegionsFeature as v, editorInlayHintParameterForeground as va, mapObservableArrayCached as vc, createStringDataTransferItem as vi, IStorageService as vn, registerSingleton as vo, DenseKeyProvider as vr, ITextModelService as vs, IMarkerService as vt, rangeIsSingleLine as w, editorWarningForeground as wa, disposableObservableValue as wc, DomScrollableElement as wi, IDialogService as wn, EditorAction2 as wo, groupByMap as wr, PixelRatio as ws, WorkbenchTreeElementCanExpand as wt, WorkbenchToolBar as x, editorSelectionBackground as xa, observableSignal as xc, generateUuid as xi, ItemActivation as xn, StringBuilder as xo, EditDeltaInfo as xr, IInstantiationService as xs, WorkbenchAsyncDataTree as xt, TextModelText as y, editorInlayHintTypeBackground as ya, observableFromPromise as yc, matchesMimeType as yi, WillSaveStateReason as yn, ILanguageService as yo, lengthAdd as yr, IModelService as ys, MarkerSeverity$1 as yt, registerIcon as z, oneOf as za, DebugLocation as zc, buttonForeground as zi, isMarkdownString as zn, DataUri as zo, isModelDecorationVisible as zr, clearNode as zs, ActionBar as zt };

//# sourceMappingURL=editor.api-BvHOuemv.js.map